(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[790],{

/***/ 2438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgArrowright = function SvgArrowright(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 0 9.885 2.115l8.37 8.385H0v3h18.255l-8.37 8.385L12 24l12-12L12 0Z",
    fill: "var(--default-text-color)"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowright);

/***/ }),

/***/ 4320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCalender = function SvgCalender(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.467 1.399h5.066V.732a.4.4 0 0 1 .8 0v.673a1.467 1.467 0 0 1 1.334 1.46V8.2c0 .81-.657 1.466-1.467 1.466H1.8C.99 9.665.333 9.01.333 8.2V2.865c0-.765.586-1.393 1.334-1.46V.732a.4.4 0 1 1 .8 0v.667Zm-.4.8H1.8a.667.667 0 0 0-.667.666V3.8h7.734v-.934A.667.667 0 0 0 8.2 2.2H2.067Zm-.934 2.4v3.6c0 .368.299.666.667.666h6.4a.667.667 0 0 0 .667-.666v-3.6H1.133Z",
    fill: "var(--default-text-color)"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgCalender);

/***/ }),

/***/ 67536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCall2 = function SvgCall2(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 22,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.157 3.14a7.305 7.305 0 0 1 6.453 6.446M13.157 6.388a4.057 4.057 0 0 1 3.208 3.208",
    stroke: "#203040",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    clipRule: "evenodd",
    d: "M10.112 12.282c3.657 3.655 4.486-.574 6.814 1.753 2.245 2.244 3.536 2.693.691 5.536-.356.287-2.62 3.73-10.573-4.22C-.911 7.396 2.531 5.13 2.818 4.775c2.85-2.851 3.293-1.554 5.538.69 2.327 2.328-1.9 3.16 1.756 6.816Z",
    stroke: "#203040",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgCall2);

/***/ }),

/***/ 11632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m5 12.5 5 4.5 9-10",
    stroke: "#868E96",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgCheck);

/***/ }),

/***/ 11676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgChevronRedLeft = function SvgChevronRedLeft(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#chevron-red-left_svg__a)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12.841 13.817 9.026 10l3.816-3.825L11.666 5l-5 5 5 5 1.175-1.183Z",
    fill: "var(--default-error-color)"
  }))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "chevron-red-left_svg__a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgChevronRedLeft);

/***/ }),

/***/ 99295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgChevronRedRight = function SvgChevronRedRight(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#chevron-red-right_svg__a)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.158 13.817 10.975 10 7.158 6.175 8.333 5l5 5-5 5-1.175-1.183Z",
    fill: "var(--default-error-color)"
  }))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "chevron-red-right_svg__a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgChevronRedRight);

/***/ }),

/***/ 11466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgClipboard = function SvgClipboard(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M53.98 9.143h-3.97c-.082 0-.155.028-.232.047V5.023C49.778 2.253 47.473 0 44.64 0H10.217C7.384 0 5.08 2.253 5.08 5.023v46.843c0 2.77 2.305 5.023 5.138 5.023h6.037v2.268c0 2.67 2.216 4.843 4.941 4.843H53.98c2.725 0 4.942-2.173 4.942-4.843v-45.17c0-2.671-2.217-4.844-4.942-4.844zM7.11 51.866V5.023c0-1.649 1.394-2.991 3.106-2.991H44.64c1.712 0 3.106 1.342 3.106 2.99v46.844c0 1.649-1.394 2.991-3.106 2.991H10.217c-1.712 0-3.106-1.342-3.106-2.99zm49.778 7.29c0 1.551-1.306 2.812-2.91 2.812H21.195c-1.604 0-2.91-1.26-2.91-2.811v-2.268H44.64c2.833 0 5.138-2.253 5.138-5.023V11.128c.077.018.15.047.233.047h3.968c1.604 0 2.91 1.26 2.91 2.811v45.17z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M38.603 13.206H16.254a1.015 1.015 0 1 0 0 2.032h22.35a1.015 1.015 0 1 0 0-2.032zM38.603 21.333H16.254a1.015 1.015 0 1 0 0 2.032h22.35a1.015 1.015 0 1 0 0-2.032zM38.603 29.46H16.254a1.015 1.015 0 1 0 0 2.032h22.35a1.015 1.015 0 1 0 0-2.032zM28.444 37.587h-12.19a1.015 1.015 0 1 0 0 2.032h12.19a1.015 1.015 0 1 0 0-2.032z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgClipboard);

/***/ }),

/***/ 11473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgClockYellow = function SvgClockYellow(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.5 3a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19Zm0 1a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17ZM11 7h1v5.42l4.7 2.71-.5.87-5.2-3V7Z",
    fill: "#FFC107"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgClockYellow);

/***/ }),

/***/ 70394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgClosewhite = function SvgClosewhite(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.844 1.45 12.456.063 6.953 5.564 1.45.062.063 1.45l5.502 5.503-5.503 5.503 1.388 1.388L6.953 8.34l5.503 5.503 1.388-1.388L8.34 6.953l5.503-5.503Z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgClosewhite);

/***/ }),

/***/ 93922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCscore = function SvgCscore(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 19,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M.334 6.1h4v13.067h-4V6.1ZM7.801.5h3.733v18.667H7.801V.5Zm7.466 10.667h3.734v8h-3.734v-8Z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgCscore);

/***/ }),

/***/ 54487:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgDaxtra = function SvgDaxtra(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.15 16.396-.05-.021-.025-.049c-.401-.805-.697-1.757-.878-2.83a21.491 21.491 0 0 1-.286-3.574c0-2.56.343-4.592 1.019-6.038l.022-.048.049-.022c1.19-.545 2.605-.821 4.203-.821 1.447 0 2.77.25 3.93.745l.056.024.022.055c.409 1.01.668 2.255.772 3.7l.01.133h3.1l-.026-.165c-.13-.844-.53-1.618-1.192-2.302-.63-.652-1.441-1.195-2.409-1.616l-.053-.023-.022-.052c-.796-1.838-2.155-2.77-4.038-2.77-2.09 0-3.638.961-4.598 2.855l-.022.043-.044.022a6.557 6.557 0 0 0-2.678 2.381C.341 7.078 0 8.39 0 9.922c0 1.728.345 3.16 1.024 4.256.664 1.07 1.611 1.877 2.816 2.4l.047.02.024.046c.951 1.816 2.438 2.737 4.418 2.737 1.855 0 3.24-.881 4.117-2.619l.025-.05.052-.02c1.922-.747 3.193-2.064 3.778-3.915l.06-.188h-3.24l-.012.132c-.134 1.469-.412 2.714-.826 3.7l-.026.061-.064.02c-1.209.388-2.56.584-4.014.584-1.547 0-2.903-.232-4.029-.69Z"
  })));
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SvgDaxtra)));

/***/ }),

/***/ 21384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgDeleteicon = function SvgDeleteicon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 14,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.417 1h-3.209l-.916-1H4.708l-.916 1H.583v2h12.834V1ZM1.5 16c0 .53.193 1.04.537 1.414.344.375.81.586 1.296.586h7.334c.486 0 .952-.21 1.296-.586.344-.375.537-.884.537-1.414V4h-11v12Z",
    fill: "var(--default-text-color)"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgDeleteicon);

/***/ }),

/***/ 86298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgDevice = function SvgDevice(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M21 19.002a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-7h18v7Zm-18-14a1 1 0 0 1 1-1h6.586a1 1 0 0 1 .707.293l1.414 1.414a1 1 0 0 0 .707.293H20a1 1 0 0 1 1 1v4H3v-6Z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgDevice);

/***/ }),

/***/ 86441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgDislike = function SvgDislike(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8.893 16.89a3.142 3.142 0 0 1-.224-.361l.758-3.835.236-1.194h-5.8a.672.672 0 0 1-.667-.666v-.9A.63.63 0 0 1 3.21 9.8l.043-.132.002-.005 2.182-5.042a.678.678 0 0 1 .55-.289h6.76c.524 0 .948.43.949.942v6.533c0 .132-.04.261-.114.372l-.085.105-4.604 4.605Zm8.47-5.39V4.334h.5v7.168h-.5Z",
    stroke: "#F44336",
    strokeWidth: 2
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgDislike);

/***/ }),

/***/ 99553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgDrive = function SvgDrive(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8.333 3h7.334L23 15h-7.333L8.333 3Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m4.601 21 3.7-6H23l-3.667 6H4.601Z",
    fill: "#1976D2"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M1 15.063 4.601 21 12 9 8.333 3 1 15.063Z",
    fill: "#4CAF50"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgDrive);

/***/ }),

/***/ 65684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgDropbox = function SvgDropbox(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "#0061FF",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m12.015 6.574-5.508 3.573 5.508 3.574-5.508 3.574L1 13.69l5.507-3.573L1 6.574 6.507 3l5.508 3.574ZM6.478 18.426l5.507-3.573 5.508 3.573L11.985 22l-5.507-3.574Zm5.537-4.735 5.507-3.573-5.507-3.544L17.493 3 23 6.574l-5.507 3.573L23 13.721l-5.507 3.574-5.478-3.604Z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgDropbox);

/***/ }),

/***/ 81737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M17.71 5.039c.39-.39.39-1.04 0-1.41l-2.34-2.34c-.37-.39-1.02-.39-1.41 0l-1.84 1.83 3.75 3.75 1.84-1.83ZM0 15.249v3.75h3.75l11.06-11.07-3.75-3.75L0 15.249Z",
    fill: "#203040"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgEdit);

/***/ }),

/***/ 97489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M4.881 2.705h10.237c.855 0 1.549.716 1.549 1.596v1.762c0 .647-.388 1.445-.775 1.844l-3.336 3.042c-.467.399-.774 1.197-.774 1.844v3.44c0 .482-.307 1.116-.694 1.363l-1.081.702c-1.015.647-2.403-.082-2.403-1.362v-4.24c0-.564-.307-1.28-.627-1.678L4.027 7.81c-.387-.386-.694-1.115-.694-1.597v-1.83c0-.964.694-1.68 1.548-1.68Z",
    fill: "#0D3A80"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgFilter);

/***/ }),

/***/ 61876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgGripicon = function SvgGripicon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 15
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "var(--default-text-color)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M3.333 1.667c0 .46-.162.853-.488 1.178a1.606 1.606 0 0 1-1.178.488c-.46 0-.853-.162-1.179-.488A1.606 1.606 0 0 1 0 1.667C0 1.207.163.814.488.488A1.606 1.606 0 0 1 1.667 0c.46 0 .853.163 1.178.488a1.606 1.606 0 0 1 .487 1.237M3.333 7.363c0 .46-.162.853-.488 1.179a1.606 1.606 0 0 1-1.178.488c-.46 0-.853-.163-1.179-.488A1.606 1.606 0 0 1 0 7.363c0-.46.163-.853.488-1.178a1.606 1.606 0 0 1 1.179-.488c.46 0 .853.162 1.178.488a1.606 1.606 0 0 1 .487 1.236M3.333 13.06c0 .46-.162.853-.488 1.178a1.606 1.606 0 0 1-1.178.489c-.46 0-.853-.163-1.179-.489A1.606 1.606 0 0 1 0 13.06c0-.46.163-.853.488-1.179a1.606 1.606 0 0 1 1.179-.488c.46 0 .853.163 1.178.488a1.606 1.606 0 0 1 .487 1.237M9.808 1.667c0 .46-.163.853-.488 1.178a1.606 1.606 0 0 1-1.179.488c-.46 0-.853-.162-1.178-.488a1.606 1.606 0 0 1-.488-1.178c0-.46.162-.853.488-1.179A1.606 1.606 0 0 1 8.14 0c.46 0 .853.163 1.179.488a1.606 1.606 0 0 1 .487 1.237M9.808 7.363c0 .46-.163.853-.488 1.179a1.606 1.606 0 0 1-1.179.488c-.46 0-.853-.163-1.178-.488a1.606 1.606 0 0 1-.488-1.179c0-.46.162-.853.488-1.178a1.606 1.606 0 0 1 1.178-.488c.46 0 .853.162 1.179.488a1.606 1.606 0 0 1 .487 1.236M9.808 13.06c0 .46-.163.853-.488 1.178a1.606 1.606 0 0 1-1.179.489c-.46 0-.853-.163-1.178-.489a1.606 1.606 0 0 1-.488-1.178c0-.46.162-.853.488-1.179a1.606 1.606 0 0 1 1.178-.488c.46 0 .853.163 1.179.488a1.606 1.606 0 0 1 .487 1.237"
  }))));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgGripicon);

/***/ }),

/***/ 79444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgImport = function SvgImport(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16.44 8.9c3.6.31 5.07 2.16 5.07 6.21v.13c0 4.47-1.79 6.26-6.26 6.26H8.74c-4.47 0-6.26-1.79-6.26-6.26v-.13c0-4.02 1.45-5.87 4.99-6.2M12 2v12.88",
    stroke: "#002359",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.35 12.65 12 16l-3.35-3.35",
    stroke: "#002359",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgImport);

/***/ }),

/***/ 35150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M9 6.849a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm0 4a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0v-4Zm1-10c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z",
    fill: "#868E96"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgInfo);

/***/ }),

/***/ 96894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12.166 3.11c.082.113.155.234.223.361l-.757 3.835-.237 1.194h5.801c.364 0 .667.302.667.666v.9a.627.627 0 0 1-.015.133l-.043.132-.002.005-2.181 5.042a.678.678 0 0 1-.551.288H8.312a.95.95 0 0 1-.949-.94V8.191c0-.176.069-.347.198-.477l4.605-4.605ZM3.696 8.5v7.166h-.5V8.5h.5Z",
    stroke: "#368434",
    strokeWidth: 2
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgLike);

/***/ }),

/***/ 21993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Svg1Green = function Svg1Green(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "var(--default-success-color)"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M51.139 23.797V35h-1.852v-8.625l-2.53 2.047v-2.25l3.1-2.375h1.282Z",
    fill: "#fff"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (Svg1Green);

/***/ }),

/***/ 33644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Svg1Red = function Svg1Red(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "var(--default-error-color)"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M51.139 23.797V35h-1.852v-8.625l-2.53 2.047v-2.25l3.1-2.375h1.282Z",
    fill: "#fff"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (Svg1Red);

/***/ }),

/***/ 95585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Svg1Yellow = function Svg1Yellow(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "var(--default-yellow-color)"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M51.139 23.797V35h-1.852v-8.625l-2.53 2.047v-2.25l3.1-2.375h1.282Z",
    fill: "#fff"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (Svg1Yellow);

/***/ }),

/***/ 32020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Svg2Green = function Svg2Green(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 0.2,
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "var(--default-success-color)"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M46.003 35v-1.36l3.906-3.859c.427-.422.75-.76.97-1.015.218-.256.395-.524.53-.805.141-.281.211-.565.211-.852 0-.479-.174-.872-.523-1.18-.35-.312-.784-.468-1.305-.468-.635 0-1.133.203-1.492.61-.36.4-.529.945-.508 1.632H45.91c-.036-1.208.316-2.187 1.055-2.937.74-.75 1.695-1.125 2.867-1.125 1.073 0 1.959.323 2.656.968.704.641 1.055 1.459 1.055 2.453 0 .657-.195 1.292-.586 1.907-.385.614-.958 1.281-1.719 2l-2.21 2.21h4.593V35h-7.617Z",
    fill: "#fff"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (Svg2Green);

/***/ }),

/***/ 69588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Svg2Red = function Svg2Red(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 0.2,
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "var(--default-error-color)"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M46.003 35v-1.36l3.906-3.859c.427-.422.75-.76.97-1.015.218-.256.395-.524.53-.805.141-.281.211-.565.211-.852 0-.479-.174-.872-.523-1.18-.35-.312-.784-.468-1.305-.468-.635 0-1.133.203-1.492.61-.36.4-.529.945-.508 1.632H45.91c-.036-1.208.316-2.187 1.055-2.937.74-.75 1.695-1.125 2.867-1.125 1.073 0 1.959.323 2.656.968.704.641 1.055 1.459 1.055 2.453 0 .657-.195 1.292-.586 1.907-.385.614-.958 1.281-1.719 2l-2.21 2.21h4.593V35h-7.617Z",
    fill: "#fff"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (Svg2Red);

/***/ }),

/***/ 94468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Svg2Yellow = function Svg2Yellow(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 0.2,
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "var(--default-yellow-color)"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M46.003 35v-1.36l3.906-3.859c.427-.422.75-.76.97-1.015.218-.256.395-.524.53-.805.141-.281.211-.565.211-.852 0-.479-.174-.872-.523-1.18-.35-.312-.784-.468-1.305-.468-.635 0-1.133.203-1.492.61-.36.4-.529.945-.508 1.632H45.91c-.036-1.208.316-2.187 1.055-2.937.74-.75 1.695-1.125 2.867-1.125 1.073 0 1.959.323 2.656.968.704.641 1.055 1.459 1.055 2.453 0 .657-.195 1.292-.586 1.907-.385.614-.958 1.281-1.719 2l-2.21 2.21h4.593V35h-7.617Z",
    fill: "#fff"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (Svg2Yellow);

/***/ }),

/***/ 86307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Svg3Green = function Svg3Green(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 0.4,
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "var(--default-success-color)"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m48.328 28.453 2.625-2.86h-4.86v-1.796h7.5v1.25l-2.991 3.187c.875-.01 1.609.29 2.203.899.593.604.89 1.36.89 2.265 0 1.094-.375 1.995-1.125 2.704-.75.703-1.703 1.054-2.859 1.054-1.063 0-1.961-.3-2.695-.898-.73-.604-1.138-1.386-1.227-2.344h1.867c.084.411.308.753.672 1.023.365.266.826.399 1.383.399.604 0 1.099-.185 1.484-.555.386-.37.578-.846.578-1.43 0-.374-.096-.7-.289-.976a1.635 1.635 0 0 0-.757-.617 3.468 3.468 0 0 0-1.102-.235 3.702 3.702 0 0 0-1.297.165v-1.235Z",
    fill: "#fff"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (Svg3Green);

/***/ }),

/***/ 83917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Svg3Yellow = function Svg3Yellow(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 0.4,
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "var(--default-yellow-color)"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m48.328 28.453 2.625-2.86h-4.86v-1.796h7.5v1.25l-2.991 3.187c.875-.01 1.609.29 2.203.899.593.604.89 1.36.89 2.265 0 1.094-.375 1.995-1.125 2.704-.75.703-1.703 1.054-2.859 1.054-1.063 0-1.961-.3-2.695-.898-.73-.604-1.138-1.386-1.227-2.344h1.867c.084.411.308.753.672 1.023.365.266.826.399 1.383.399.604 0 1.099-.185 1.484-.555.386-.37.578-.846.578-1.43 0-.374-.096-.7-.289-.976a1.635 1.635 0 0 0-.757-.617 3.468 3.468 0 0 0-1.102-.235 3.702 3.702 0 0 0-1.297.165v-1.235Z",
    fill: "#fff"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (Svg3Yellow);

/***/ }),

/***/ 43731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Svg4Green = function Svg4Green(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 0.6,
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "var(--default-success-color)"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M54.286 30.906v1.696h-1.328V35H51.09v-2.398h-5.57V31.32l3.984-7.523h2.125l-3.774 7.11h3.235V27.75h1.867v3.156h1.328Z",
    fill: "#fff"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (Svg4Green);

/***/ }),

/***/ 49364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Svg5Green = function Svg5Green(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 0.8,
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "var(--default-success-color)"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M50.095 35.156a4.676 4.676 0 0 1-1.89-.375 3.479 3.479 0 0 1-1.399-1.125c-.364-.5-.57-1.08-.617-1.742h1.867c.1.432.331.779.696 1.04.364.254.812.382 1.343.382.563 0 1.04-.193 1.43-.578.39-.386.586-.854.586-1.406 0-.589-.193-1.076-.578-1.461-.386-.391-.865-.586-1.438-.586-.37 0-.713.062-1.03.187-.319.12-.569.287-.75.5H46.68l.516-6.195h6.11v1.765H48.86l-.273 2.735c.208-.167.474-.302.796-.406.323-.104.644-.157.961-.157 1.068 0 1.948.334 2.64 1 .694.662 1.04 1.545 1.04 2.649 0 1.052-.38 1.945-1.14 2.68-.761.729-1.69 1.093-2.79 1.093Z",
    fill: "#fff"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (Svg5Green);

/***/ }),

/***/ 46132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgRefreshIcon = function SvgRefreshIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15 3a11.967 11.967 0 0 0-7.793 2.875 1 1 0 1 0 1.299 1.52A9.948 9.948 0 0 1 15 5a9.986 9.986 0 0 1 9.951 9H22l4 6 4-6h-3.05C26.437 7.852 21.277 3 15 3zM4 10l-4 6h3.05C3.563 22.148 8.723 27 15 27c2.969 0 5.697-1.083 7.793-2.875a1 1 0 1 0-1.299-1.52A9.948 9.948 0 0 1 15 25a9.986 9.986 0 0 1-9.951-9H8l-4-6z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgRefreshIcon);

/***/ }),

/***/ 1400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgRejected = function SvgRejected(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m5 5 14 14M5 19 19 5",
    stroke: "#F2360D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgRejected);

/***/ }),

/***/ 31343:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgRobot = function SvgRobot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "var(--default-error-color)",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.458 39.667H11.541a5.214 5.214 0 0 1-5.208-5.208V10.5a5.214 5.214 0 0 1 5.208-5.208h22.917a5.214 5.214 0 0 1 5.208 5.208V34.46a5.214 5.214 0 0 1-5.208 5.208ZM11.541 7.375A3.127 3.127 0 0 0 8.416 10.5V34.46a3.128 3.128 0 0 0 3.125 3.125h22.917a3.127 3.127 0 0 0 3.125-3.125V10.5a3.127 3.127 0 0 0-3.125-3.125H11.541Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.041.083h-2.083v6.25h2.083V.083ZM3.208 23H.083V12.584h3.125a5.214 5.214 0 0 1 5.208 5.208A5.214 5.214 0 0 1 3.208 23Zm-1.042-2.083h1.042a3.127 3.127 0 0 0 3.125-3.125 3.128 3.128 0 0 0-3.125-3.125H2.166v6.25ZM31.333 45.917H14.666v-8.334h16.667v8.334Zm-14.584-2.084h12.5v-4.166h-12.5v4.166ZM45.916 23h-3.125a5.214 5.214 0 0 1-5.208-5.208 5.214 5.214 0 0 1 5.208-5.209h3.125V23Zm-3.125-8.333a3.128 3.128 0 0 0-3.125 3.125 3.127 3.127 0 0 0 3.125 3.125h1.042v-6.25h-1.042ZM16.75 21.958a4.172 4.172 0 0 1-4.167-4.166 4.172 4.172 0 0 1 4.167-4.167 4.172 4.172 0 0 1 4.166 4.167 4.172 4.172 0 0 1-4.166 4.166Zm0-6.25a2.086 2.086 0 0 0-2.084 2.084c0 1.148.935 2.083 2.084 2.083a2.086 2.086 0 0 0 2.083-2.083 2.086 2.086 0 0 0-2.083-2.084ZM29.25 21.958a4.172 4.172 0 0 1-4.167-4.166 4.172 4.172 0 0 1 4.167-4.167 4.172 4.172 0 0 1 4.166 4.167 4.172 4.172 0 0 1-4.166 4.166Zm0-6.25a2.086 2.086 0 0 0-2.084 2.084c0 1.148.935 2.083 2.084 2.083a2.086 2.086 0 0 0 2.083-2.083 2.086 2.086 0 0 0-2.083-2.084ZM29.69 34.04H16.31c-.73 0-1.404-.365-1.805-.977l-1.675-2.565a2.152 2.152 0 0 1 1.802-3.33H31.36a2.152 2.152 0 0 1 1.802 3.33l-1.674 2.565a2.128 2.128 0 0 1-1.797.976Zm-15.052-4.79c-.019 0-.042 0-.063.037-.02.036-.005.057.003.073l1.674 2.565a.07.07 0 0 0 .06.031h13.38a.068.068 0 0 0 .058-.031l1.674-2.565c.01-.016.024-.037.003-.073-.021-.037-.045-.037-.063-.037H14.638Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.041 28.503h-2.083v4.214h2.083v-4.214ZM28.208 28.503h-2.083v4.214h2.083v-4.214ZM19.874 28.503h-2.083v4.214h2.083v-4.214Z"
  })));
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SvgRobot)));

/***/ }),

/***/ 71810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgStarfilled = function SvgStarfilled(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    clipRule: "evenodd",
    d: "m11.104 1.799 1.828 3.65c.179.359.524.607.925.665l4.088.588c1.01.146 1.412 1.37.681 2.072l-2.956 2.84c-.29.28-.423.68-.354 1.075l.698 4.01c.172.992-.884 1.75-1.787 1.28l-3.654-1.895a1.248 1.248 0 0 0-1.146 0L5.773 17.98c-.903.47-1.959-.288-1.786-1.28l.697-4.01a1.203 1.203 0 0 0-.354-1.075l-2.956-2.84c-.731-.702-.33-1.926.68-2.072l4.089-.588c.4-.058.747-.306.926-.665L8.896 1.8c.452-.903 1.756-.903 2.208 0Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgStarfilled);

/***/ }),

/***/ 36414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _mask, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgTechnical = function SvgTechnical(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 19,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 1.116,
    y: 0.761,
    width: 16.371,
    height: 1.806,
    rx: 0.848,
    stroke: "#203040",
    strokeWidth: 1.2
  })), _mask || (_mask = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("mask", {
    id: "technical_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.367 2.634v15.922c0 .8-.648 1.448-1.447 1.448h-.965c-.8 0-1.448-.648-1.448-1.448V2.634h3.86Z"
  }))), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12.567 2.634v15.922a2.648 2.648 0 0 1-2.647 2.648v-2.4c.136 0 .247-.11.247-.248V2.634h2.4Zm-3.612 18.57a2.647 2.647 0 0 1-2.648-2.648V2.634h2.4v15.922c0 .137.11.248.248.248v2.4ZM7.507 2.634h3.86-3.86Zm5.06 15.922a2.648 2.648 0 0 1-2.647 2.648h-.965a2.647 2.647 0 0 1-2.648-2.648h2.4c0 .137.11.248.248.248h.965c.136 0 .247-.11.247-.248h2.4Z",
    fill: "#203040",
    mask: "url(#technical_svg__a)"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgTechnical);

/***/ }),

/***/ 76075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _mask, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgTechnicalkanban = function SvgTechnicalkanban(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 19,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 1.116,
    y: 0.761,
    width: 16.371,
    height: 1.806,
    rx: 0.848,
    stroke: "#203040",
    strokeWidth: 1.2
  })), _mask || (_mask = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("mask", {
    id: "technicalkanban_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.367 2.634v15.922c0 .8-.648 1.448-1.447 1.448h-.965c-.8 0-1.448-.648-1.448-1.448V2.634h3.86Z"
  }))), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12.567 2.634v15.922a2.648 2.648 0 0 1-2.647 2.648v-2.4c.136 0 .247-.11.247-.248V2.634h2.4Zm-3.612 18.57a2.647 2.647 0 0 1-2.648-2.648V2.634h2.4v15.922c0 .137.11.248.248.248v2.4ZM7.507 2.634h3.86-3.86Zm5.06 15.922a2.648 2.648 0 0 1-2.647 2.648h-.965a2.647 2.647 0 0 1-2.648-2.648h2.4c0 .137.11.248.248.248h.965c.136 0 .247-.11.247-.248h2.4Z",
    fill: "#203040",
    mask: "url(#technicalkanban_svg__a)"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgTechnicalkanban);

/***/ }),

/***/ 83238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgThickPlus = function SvgThickPlus(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8 2.667v10.666M2.667 8h10.666",
    stroke: "#527CBE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgThickPlus);

/***/ }),

/***/ 41739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 15,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    clipRule: "evenodd",
    d: "M7.485 12.707c-3.706 0-6.871.56-6.871 2.804 0 2.245 3.145 2.825 6.871 2.825 3.707 0 6.871-.561 6.871-2.804 0-2.244-3.144-2.825-6.87-2.825ZM7.485 9.506A4.404 4.404 0 1 0 3.081 5.1a4.39 4.39 0 0 0 4.373 4.405h.031Z",
    stroke: "#0D3A80",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgUser);

/***/ }),

/***/ 49942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgVerified = function SvgVerified(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "m15.67 7.06-1.08-1.34c-.17-.22-.28-.48-.31-.77l-.19-1.7a1.51 1.51 0 0 0-1.33-1.33l-1.7-.19c-.3-.03-.56-.16-.78-.33L8.94.32c-.55-.44-1.33-.44-1.88 0L5.72 1.4c-.22.17-.48.28-.77.31l-1.7.19c-.7.08-1.25.63-1.33 1.33l-.19 1.7c-.03.3-.16.56-.33.78L.32 7.05c-.44.55-.44 1.33 0 1.88l1.08 1.34c.17.22.28.48.31.77l.19 1.7c.08.7.63 1.25 1.33 1.33l1.7.19c.3.03.56.16.78.33l1.34 1.08c.55.44 1.33.44 1.88 0l1.34-1.08c.22-.17.48-.28.77-.31l1.7-.19c.7-.08 1.25-.63 1.33-1.33l.19-1.7c.03-.3.16-.56.33-.78l1.08-1.34c.44-.55.44-1.33 0-1.88zM6.5 12 3 8.5 4.5 7l2 2 5-5L13 5.55 6.5 12z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgVerified);

/***/ }),

/***/ 15166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 22,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    clipRule: "evenodd",
    d: "M14.939 15.091c.074 1.68-1.281 3.1-3.027 3.171-.129.006-6.398-.007-6.398-.007-1.737.132-3.258-1.116-3.395-2.79-.01-.124-.007-6.85-.007-6.85-.077-1.682 1.276-3.106 3.023-3.18.13-.006 6.391.006 6.391.006 1.746-.13 3.271 1.127 3.406 2.808.01.121.007 6.842.007 6.842Z",
    stroke: "#203040",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m14.942 9.996 3.018-2.47c.748-.612 1.87-.079 1.87.886l-.011 6.737c-.001.965-1.124 1.494-1.87.882l-3.007-2.47",
    stroke: "#203040",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgVideo);

/***/ }),

/***/ 20226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgVideoqa = function SvgVideoqa(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#videoqa_svg__a)",
    stroke: "#203040"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M19.062 17.724H3.879a1.465 1.465 0 0 1-1.462-1.462V4.207c0-.806.656-1.463 1.462-1.463h16.242c.806 0 1.462.657 1.462 1.463v10.996a2.525 2.525 0 0 1-2.521 2.521ZM3.879 3.703a.505.505 0 0 0-.504.504v12.056c0 .278.226.504.504.504h15.183c.862 0 1.563-.702 1.563-1.563V4.207a.505.505 0 0 0-.504-.504H3.879Z",
    fill: "#203040",
    strokeWidth: 0.2
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m21.583 21.583-.607-.168a7.36 7.36 0 0 1-1.549-.661c-1.097-.634-1.677-1.439-1.677-2.327 0-.814.335-1.223.618-1.423.316-.224.633-.236.694-.236.877 0 1.547.244 1.993.723a2.02 2.02 0 0 1 .528 1.42v2.672Zm-2.512-3.859c-.09.009-.363.084-.363.701 0 .865 1.098 1.513 1.917 1.852l.001-1.416s.016-.417-.281-.728c-.257-.27-.685-.406-1.274-.409Z",
    fill: "#203040",
    strokeWidth: 0.1
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    clipRule: "evenodd",
    d: "M11.992 11.521c-1.933 0-3.585.293-3.585 1.464 0 1.17 1.641 1.474 3.585 1.474 1.934 0 3.585-.293 3.585-1.464 0-1.17-1.64-1.473-3.585-1.473ZM11.992 9.852a2.298 2.298 0 1 0-2.298-2.299 2.29 2.29 0 0 0 2.282 2.299h.016Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "videoqa_svg__a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 .349)",
    d: "M0 0h23v23H0z"
  })))));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgVideoqa);

/***/ }),

/***/ 62199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgRating1 = function SvgRating1(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 102,
    height: 56,
    viewBox: "0 0 100 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "#E7EBEE"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M51.139 23.797V35h-1.852v-8.625l-2.53 2.047v-2.25l3.1-2.375h1.282Z",
    fill: "#203040"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgRating1);

/***/ }),

/***/ 60498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgRating2 = function SvgRating2(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 102,
    height: 56,
    viewBox: "0 0 100 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 0.2,
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "#E7EBEE"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M46.003 35v-1.36l3.906-3.859c.427-.422.75-.76.97-1.015.218-.256.395-.524.53-.805.141-.281.211-.565.211-.852 0-.479-.174-.872-.523-1.18-.35-.312-.784-.468-1.305-.468-.635 0-1.133.203-1.492.61-.36.4-.529.945-.508 1.632H45.91c-.036-1.208.316-2.187 1.055-2.937.74-.75 1.695-1.125 2.867-1.125 1.073 0 1.959.323 2.656.968.704.641 1.055 1.459 1.055 2.453 0 .657-.195 1.292-.586 1.907-.385.614-.958 1.281-1.719 2l-2.21 2.21h4.593V35h-7.617Z",
    fill: "#203040"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgRating2);

/***/ }),

/***/ 70880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgRating3 = function SvgRating3(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 102,
    height: 56,
    viewBox: "0 0 100 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 0.4,
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "#E7EBEE"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m48.328 28.453 2.625-2.86h-4.86v-1.796h7.5v1.25l-2.991 3.187c.875-.01 1.609.29 2.203.899.593.604.89 1.36.89 2.265 0 1.094-.375 1.995-1.125 2.704-.75.703-1.703 1.054-2.859 1.054-1.063 0-1.961-.3-2.695-.898-.73-.604-1.138-1.386-1.227-2.344h1.867c.084.411.308.753.672 1.023.365.266.826.399 1.383.399.604 0 1.099-.185 1.484-.555.386-.37.578-.846.578-1.43 0-.374-.096-.7-.289-.976a1.635 1.635 0 0 0-.757-.617 3.468 3.468 0 0 0-1.102-.235 3.702 3.702 0 0 0-1.297.165v-1.235Z",
    fill: "#203040"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgRating3);

/***/ }),

/***/ 42876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgRating4 = function SvgRating4(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 102,
    height: 56,
    viewBox: "0 0 100 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 0.6,
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "#E7EBEE"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M54.286 30.906v1.696h-1.328V35H51.09v-2.398h-5.57V31.32l3.984-7.523h2.125l-3.774 7.11h3.235V27.75h1.867v3.156h1.328Z",
    fill: "#203040"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgRating4);

/***/ }),

/***/ 56795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgRating5 = function SvgRating5(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 102,
    height: 56,
    viewBox: "0 0 100 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 0.8,
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "#E7EBEE"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M50.095 35.156a4.676 4.676 0 0 1-1.89-.375 3.479 3.479 0 0 1-1.399-1.125c-.364-.5-.57-1.08-.617-1.742h1.867c.1.432.331.779.696 1.04.364.254.812.382 1.343.382.563 0 1.04-.193 1.43-.578.39-.386.586-.854.586-1.406 0-.589-.193-1.076-.578-1.461-.386-.391-.865-.586-1.438-.586-.37 0-.713.062-1.03.187-.319.12-.569.287-.75.5H46.68l.516-6.195h6.11v1.765H48.86l-.273 2.735c.208-.167.474-.302.796-.406.323-.104.644-.157.961-.157 1.068 0 1.948.334 2.64 1 .694.662 1.04 1.545 1.04 2.649 0 1.052-.38 1.945-1.14 2.68-.761.729-1.69 1.093-2.79 1.093Z",
    fill: "#203040"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgRating5);

/***/ }),

/***/ 30327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgSubRating1 = function SvgSubRating1(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "#E7EBEE"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M51.139 23.797V35h-1.852v-8.625l-2.53 2.047v-2.25l3.1-2.375h1.282Z",
    fill: "#203040"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgSubRating1);

/***/ }),

/***/ 75818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgSubRating2 = function SvgSubRating2(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 0.2,
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "#E7EBEE"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M46.003 35v-1.36l3.906-3.859c.427-.422.75-.76.97-1.015.218-.256.395-.524.53-.805.141-.281.211-.565.211-.852 0-.479-.174-.872-.523-1.18-.35-.312-.784-.468-1.305-.468-.635 0-1.133.203-1.492.61-.36.4-.529.945-.508 1.632H45.91c-.036-1.208.316-2.187 1.055-2.937.74-.75 1.695-1.125 2.867-1.125 1.073 0 1.959.323 2.656.968.704.641 1.055 1.459 1.055 2.453 0 .657-.195 1.292-.586 1.907-.385.614-.958 1.281-1.719 2l-2.21 2.21h4.593V35h-7.617Z",
    fill: "#203040"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgSubRating2);

/***/ }),

/***/ 42307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgSubRating3 = function SvgSubRating3(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 0.4,
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "#E7EBEE"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m48.328 28.453 2.625-2.86h-4.86v-1.796h7.5v1.25l-2.991 3.187c.875-.01 1.609.29 2.203.899.593.604.89 1.36.89 2.265 0 1.094-.375 1.995-1.125 2.704-.75.703-1.703 1.054-2.859 1.054-1.063 0-1.961-.3-2.695-.898-.73-.604-1.138-1.386-1.227-2.344h1.867c.084.411.308.753.672 1.023.365.266.826.399 1.383.399.604 0 1.099-.185 1.484-.555.386-.37.578-.846.578-1.43 0-.374-.096-.7-.289-.976a1.635 1.635 0 0 0-.757-.617 3.468 3.468 0 0 0-1.102-.235 3.702 3.702 0 0 0-1.297.165v-1.235Z",
    fill: "#203040"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgSubRating3);

/***/ }),

/***/ 73589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgSubRating4 = function SvgSubRating4(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 0.6,
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "#E7EBEE"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M54.286 30.906v1.696h-1.328V35H51.09v-2.398h-5.57V31.32l3.984-7.523h2.125l-3.774 7.11h3.235V27.75h1.867v3.156h1.328Z",
    fill: "#203040"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgSubRating4);

/***/ }),

/***/ 48542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgSubRating5 = function SvgSubRating5(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 0.8,
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "#E7EBEE"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M50.095 35.156a4.676 4.676 0 0 1-1.89-.375 3.479 3.479 0 0 1-1.399-1.125c-.364-.5-.57-1.08-.617-1.742h1.867c.1.432.331.779.696 1.04.364.254.812.382 1.343.382.563 0 1.04-.193 1.43-.578.39-.386.586-.854.586-1.406 0-.589-.193-1.076-.578-1.461-.386-.391-.865-.586-1.438-.586-.37 0-.713.062-1.03.187-.319.12-.569.287-.75.5H46.68l.516-6.195h6.11v1.765H48.86l-.273 2.735c.208-.167.474-.302.796-.406.323-.104.644-.157.961-.157 1.068 0 1.948.334 2.64 1 .694.662 1.04 1.545 1.04 2.649 0 1.052-.38 1.945-1.14 2.68-.761.729-1.69 1.093-2.79 1.093Z",
    fill: "#203040"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgSubRating5);

/***/ }),

/***/ 73554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgArrowleftActive = function SvgArrowleftActive(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.334 8H2.667M7.334 3.333 2.667 8l4.667 4.667",
    stroke: "#008ECC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowleftActive);

/***/ }),

/***/ 56991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgArrowleftDisabled = function SvgArrowleftDisabled(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.334 8H2.667M7.334 3.333 2.667 8l4.667 4.667",
    stroke: "#A4AAB0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowleftDisabled);

/***/ }),

/***/ 24797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgArrowrightActive = function SvgArrowrightActive(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M2.666 8h10.667M8.666 12.667 13.333 8 8.666 3.333",
    stroke: "#008ECC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowrightActive);

/***/ }),

/***/ 86337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgArrowrightDisabled = function SvgArrowrightDisabled(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M2.666 8h10.667M8.666 12.667 13.333 8 8.666 3.333",
    stroke: "#A4AAB0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowrightDisabled);

/***/ }),

/***/ 76434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m5 8 7 7 7-7",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgChevronDown);

/***/ }),

/***/ 4025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgFilterIcon = function SvgFilterIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M4.881 2.705h10.237c.855 0 1.549.716 1.549 1.596v1.762c0 .647-.388 1.445-.775 1.844l-3.336 3.042c-.467.399-.774 1.197-.774 1.844v3.44c0 .482-.307 1.116-.694 1.363l-1.081.702c-1.015.647-2.403-.082-2.403-1.362v-4.24c0-.564-.307-1.28-.627-1.678L4.027 7.81c-.387-.386-.694-1.115-.694-1.597v-1.83c0-.964.694-1.68 1.548-1.68Z",
    fill: "#0D3A80"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgFilterIcon);

/***/ }),

/***/ 86013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgInfoIcon = function SvgInfoIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M9 6.849a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm0 4a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0v-4Zm1-10c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z",
    fill: "#868E96"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgInfoIcon);

/***/ }),

/***/ 9906:
/***/ (function() {

"use strict";
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({"src":"/_next/static/media/chevron.0f5247ed.png","height":8,"width":13,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAACXBIWXMAAAsTAAALEwEAmpwYAAAASElEQVR4nD2LwQ2AQAzDCmvdCnxZgx0QT3aukSFHJKtRkhYwunsDClhDJRuag097RqLHbgZnRn6JMqs5kCuF0r/5LJfcO/zZA7Bbg8fjg9mWAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 22700:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/close.cff9adf2.png","height":42,"width":42,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAACE4AAAhOAFFljFgAAAAh0lEQVR4nFVPMQ7CQAzz0D4oeUQX6FaGmOmkPgBewta9n2SpBMiXIMQQybF9dg6w2OFscAIWI5xD4RssNoEGizecCzxQ4to5i6sWzaVMp04mnrsG51gmiS94HDBOlTTI8O3UywMWTzjPybEbfp3OCRaKrpsIife/zpyluKZlq/jsVGVi/e7xAXyaOU5e4KwsAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 98745:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/document.c141565b.png","height":10,"width":8,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAl0lEQVR4nB3NMQ7BQRTE4d8piEI0SrHvrVAphDgBiZ0XQYHij4ZWQ+kmbimrmeabzEDWixwHcuzJcSHHF9cUXDumDaRNGytdPJ64PhWODFctrIyxMiFterhuFa4kjTCtsFiTygDXqUKDaYnHHY8HpjmuM3g0pOiTNCPFgmHpkHWArC0eYAKLulDLuxofPI7/L9cFjxNZ7x/ioiiGn+QO3AAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});

/***/ }),

/***/ 72358:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/fbicon.ffba6df1.png","height":40,"width":37,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA8UlEQVR4nBWNPS8EURhGn0asAmHtbmaCQq/R6NZaouBvWIlosPO1Co1EgoxF7A9BtD4atYItbGgUChLz3ntJ3HtnXpny5OTkoBIQpnYTuJGoj3m0jrVkoXb8i+FtAko+FZxQXJV84omW4NkDyW4krvs2vgfghBRXAuKiR/rh1ZjHd6snd0TOcS6fix7xfFtZ9ZdlKx1lR5rETii6KAf05EaC716MZebsvmfseEtw2acunEgc5mU1VvpTpqbeVnq0Sfn3CIunsn9oiy6m9yR/UMoz+5IHN+ly+fynADQSnNxqVGM19/aVNpbOVO2mx8Bqgn9I1YddTJ7rRgAAAABJRU5ErkJggg==","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 51536:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/linkedicon.76d34b3e.png","height":34,"width":34,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAAsTAAALEwEAmpwYAAABE0lEQVR4nAEIAff+AABnqwAAZao2AGyuvwJ3tPgBdrTyAna0qAB0sx4AdbMAAABjqTkqjMD8VaTN/wBwsP4AcrH/AHOy/wF2tOAAdLMXAABusMs3k8T/eLbX+Qd5tv4kib7+F4K69wBzsv8BdrSXAABvsP9Kncn9jMHd/5/L4v7J4u/+y+Pv/RSBuv8AcrLLAABtr/1cp8/9rtPn/7zb6/4/mMb+yOHu/DmVxP8Aba/KAABsrsJHnMn/k8Xf+JvJ4f4ykcL9qNDl9yyOwf8AbK6PAABysi8FeLXyCHq2/wp7t/8DeLX/Cnu3/wN3tdUAcbARAABysgAAcbEqAHSyrAB0s+kAdbPjAHOylwBvsBQAcrIAgciNKrRxy9wAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 32938:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/reply.90c74682.png","height":13,"width":16,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAnUlEQVR4nDWNwQnCUBBEX1S0EPEasj8GK1AJeFX/bsjBQ5qyg5w8WoAd2I2oRPYHD8MszJtZCAZiNUFrRCHYDLEJZQNVCwTdEuyLWE+hKzYXLzg4/QMD4jL3F6J3JIa07BCiH0IKh+Sj3kjcpZcU8TCG+kDsithzXNSBIi59waEO0Tbd+XlBEStEb4j2UDZZ+pef5qybjH3nhX/x+APBczSZPTHZLAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 61515:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/twittericon.9805a439.png","height":43,"width":34,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA00lEQVR4nAHIADf/AB+i8gAAkO4AIKHyJDKp8yQAhO0AJqTyAAAfofIUFZ3xtB2h8vkPm/H5DpvxtSml8xMAHKDxsTSq8/8XnvH+dcX3/lC29P8UnfGyAA+b8fOe1vn/yun8/f////2V0vj/C5nw8wARnPHzY772//////3y+f79OKzz/xae8fMAF57xqzes8/99yff+Pq/z/hWe8f8fovKsACSj8Q4YnvGpDZrx9hWe8fYfofKoF57xDgAjo/IAA5bwAD6u8xktp/IZIKLyABug8QAec3Zy7deGzwAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});

/***/ }),

/***/ 98766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ ApplicationFilter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62286);

function ApplicationFilter(job_id) {
    var retainFilterData = JSON.parse(localStorage.getItem("filterData"));
    if (retainFilterData) {
        retainFilterData = Object.fromEntries(Object.entries(retainFilterData).filter(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
            return Array.isArray(value) ? value.length > 0 : value;
        }));
        if (retainFilterData && retainFilterData["job_id"] == parseInt(job_id)) {
            delete retainFilterData["job_id"];
            return retainFilterData;
        }
    } else {
        return null;
    }
}


/***/ }),

/***/ 90308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ PlaceAutocompleteAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27305);


var PlaceAutocompleteAction = /*#__PURE__*/ function() {
    "use strict";
    function PlaceAutocompleteAction() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, PlaceAutocompleteAction);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(PlaceAutocompleteAction, [
        {
            key: "shouldFetchSuggestions",
            value: function shouldFetchSuggestions(formik_field) {
                return formik_field.length >= 3;
            }
        }
    ]);
    return PlaceAutocompleteAction;
}();


/***/ }),

/***/ 67280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ closeModalUsingState; }
/* harmony export */ });
function closeModalUsingState(closeValue, stateFunction) {
    stateFunction(closeValue);
}


/***/ }),

/***/ 12448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ GetNameFromHash; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34817);



var GetNameFromHash = /*#__PURE__*/ function() {
    "use strict";
    function GetNameFromHash() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, GetNameFromHash);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(GetNameFromHash, [
        {
            key: "getCompetencyName",
            value: function getCompetencyName(competency_id, competency_hash) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = competency_hash[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var competency = _step.value;
                        if (competency.job_competency_id == competency_id) {
                            return competency.job_competency_name;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "getCompetencyNotes",
            value: function getCompetencyNotes(competency_id, competency_hash) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = competency_hash[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var competency = _step.value;
                        if (competency.job_competency_id == competency_id) {
                            return competency.job_competency_notes;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "getSubCompetencyName",
            value: function getSubCompetencyName(competency_id, competency_hash) {
                var new_sub_competency_hash = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = competency_hash[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var competency = _step.value;
                        new_sub_competency_hash = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(new_sub_competency_hash).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(competency.job_sub_competency_names));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = new_sub_competency_hash[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var sub_competency_name = _step1.value;
                        if (sub_competency_name.job_sub_competency_id == competency_id) {
                            return sub_competency_name.job_sub_competency_name;
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "getSubCompetencyNotes",
            value: function getSubCompetencyNotes(competency_id, competency_hash) {
                var new_sub_competency_hash = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = competency_hash[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var competency = _step.value;
                        new_sub_competency_hash = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(new_sub_competency_hash).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(competency.job_sub_competency_names));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = new_sub_competency_hash[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var sub_competency_name = _step1.value;
                        if (sub_competency_name.job_sub_competency_id == competency_id) {
                            return sub_competency_name.job_sub_competency_notes;
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        }
    ]);
    return GetNameFromHash;
}();


/***/ }),

/***/ 17728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ dataURItoBlob; }
/* harmony export */ });
/* unused harmony export base64toBlob */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27307);


function dataURItoBlob(bas64Image) {
    return _dataURItoBlob.apply(this, arguments);
}
function _dataURItoBlob() {
    _dataURItoBlob = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(bas64Image) {
        var url, res, blob;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = bas64Image;
                    return [
                        4,
                        fetch(url)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res === null || res === void 0 ? void 0 : res.blob()
                    ];
                case 2:
                    blob = _state.sent();
                    return [
                        2,
                        blob
                    ];
            }
        });
    });
    return _dataURItoBlob.apply(this, arguments);
}
function base64toBlob(base64String) {
    return _base64toBlob.apply(this, arguments);
}
function _base64toBlob() {
    _base64toBlob = _async_to_generator(function(base64String) {
        var url, res, blob;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = base64String;
                    return [
                        4,
                        fetch(url)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res === null || res === void 0 ? void 0 : res.blob()
                    ];
                case 2:
                    blob = _state.sent();
                    console.log(blob);
                    return [
                        2,
                        blob
                    ];
            }
        });
    });
    return _base64toBlob.apply(this, arguments);
}


/***/ }),

/***/ 69735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ OtherSourceAction; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(38641);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/jobs/job.js
var job = __webpack_require__(44791);
// EXTERNAL MODULE: ./src/services/components/candidate-listing-action.js
var candidate_listing_action = __webpack_require__(66693);
// EXTERNAL MODULE: ./src/services/pages/candidates/add-candidate.js
var add_candidate = __webpack_require__(40657);
// EXTERNAL MODULE: ./src/imports-files/pages/candidates/add-candidate.js
var candidates_add_candidate = __webpack_require__(43361);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ./src/services/common/send-request.js
var send_request = __webpack_require__(34964);
;// CONCATENATED MODULE: ./src/services/common/other-source.js








var OtherSourceService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(OtherSourceService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(OtherSourceService);
    function OtherSourceService() {
        (0,_class_call_check/* default */.Z)(this, OtherSourceService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(OtherSourceService, [
        {
            key: "getOtherSourceName",
            value: function getOtherSourceName() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.other_source_users */.bl.other_source_users;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(url, (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return OtherSourceService;
}(send_request/* SendRequest */.L);

;// CONCATENATED MODULE: ./src/actions/common/other-source-action.js












var OtherSourceAction = /*#__PURE__*/ function() {
    "use strict";
    function OtherSourceAction(setValue, setSuggestion) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, OtherSourceAction);
        var _this1 = this;
        (0,_define_property/* default */.Z)(this, "onSuggestionsFetchRequested", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
                var suggestion;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this1.getSuggestions(value)
                            ];
                        case 1:
                            suggestion = _state.sent();
                            _this1.setSuggestion(suggestion);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(value) {
                return _ref.apply(this, arguments);
            };
        }());
        (0,_define_property/* default */.Z)(this, "onSuggestionsClearRequested", function() {
            _this.setSuggestion([]);
        });
        this.setValue = setValue;
        this.setSuggestion = setSuggestion;
        this.customToastrAction = new common/* CustomToastrAction */.Y5();
        this.otherSourceService = new OtherSourceService();
    }
    (0,_create_class/* default */.Z)(OtherSourceAction, [
        {
            key: "escapeRegexCharacters",
            value: function escapeRegexCharacters(str) {
                return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            }
        },
        {
            key: "getSuggestions",
            value: function getSuggestions(param) {
                var value = param.value;
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var escapedValue, userList;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                escapedValue = _this.escapeRegexCharacters(value === null || value === void 0 ? void 0 : value.trim());
                                if (escapedValue === "") {
                                    return [
                                        2,
                                        []
                                    ];
                                }
                                return [
                                    4,
                                    _this.otherSourceService.getOtherSourceName()
                                ];
                            case 1:
                                userList = _state.sent();
                                return [
                                    2,
                                    userList.data.other_source_users
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSuggestionValue",
            value: function getSuggestionValue(suggestion) {
                return suggestion;
            }
        },
        {
            key: "renderSuggestion",
            value: function renderSuggestion(suggestion) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        " ",
                        suggestion
                    ]
                });
            }
        },
        {
            key: "shouldRenderSuggestions",
            value: function shouldRenderSuggestions(value) {
                return (value === null || value === void 0 ? void 0 : value.trim().length) >= 3;
            }
        }
    ]);
    return OtherSourceAction;
}();


/***/ }),

/***/ 7141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ AutosuggestionInputAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18186);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2443);
/* harmony import */ var _styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95662);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96047);










var AutosuggestionInputAction = /*#__PURE__*/ function() {
    "use strict";
    function AutosuggestionInputAction() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, AutosuggestionInputAction);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(AutosuggestionInputAction, [
        {
            key: "onSuggestionsFetchRequested",
            value: // This function is used to fetch the dsuggestion of the data fron the api
            // Here name is the name of the hash which should be reterieve from data to show suggestion
            function onSuggestionsFetchRequested(value, setSuggestion, getSuggestionDataService, name, onFocusShowList) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var suggestion;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(typeof value != "undefined")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.getSuggestions(value, getSuggestionDataService, onFocusShowList)
                                ];
                            case 1:
                                suggestion = _state.sent();
                                suggestion[name] ? setSuggestion(suggestion[name]) : setSuggestion([]);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                setSuggestion([]);
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSuggestions",
            value: // Get Suggestion bring the session from the api
            // The api function will be pass through getSuggestion
            function getSuggestions(value, getSuggestionDataService) {
                var onFocusShowList = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var escapedValue, ref, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                escapedValue = "";
                                if (value === null || value === void 0 ? void 0 : value.value) {
                                    ;
                                    escapedValue = _this.escapeRegexCharacters(value === null || value === void 0 ? void 0 : (ref = value.value) === null || ref === void 0 ? void 0 : ref.trim());
                                }
                                if (escapedValue === "" && !onFocusShowList) {
                                    return [
                                        2,
                                        []
                                    ];
                                }
                                return [
                                    4,
                                    getSuggestionDataService(escapedValue)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result.data
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "escapeRegexCharacters",
            value: function escapeRegexCharacters(str) {
                return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            }
        },
        {
            // Functionality of this function ??
            key: "getSuggestionValue",
            value: function getSuggestionValue(label) {
                return label;
            }
        },
        {
            // This function will show the data in the dropdown 
            key: "renderSuggestion",
            value: function renderSuggestion(label) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: label
                });
            }
        },
        {
            // ------------------------------------------------------------ Used ------------------------------------------------------------
            // Clear the suggestion
            key: "onSuggestionsClearRequested",
            value: function onSuggestionsClearRequested(setSuggestion) {
                setSuggestion([]);
            }
        },
        {
            // Show the suggestion after user type more than 3 words 
            key: "shouldRenderSuggestions",
            value: function shouldRenderSuggestions(value, charLength) {
                // if(typeof value != 'undefined')
                // {
                //   return value.trim().length >= charLength;
                // }
                // else
                // {
                //   return true;
                // }
                return true;
            }
        },
        {
            // Add the add component in input text box for entering the data 
            key: "renderInputComponent",
            value: function renderInputComponent(inputProps, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, add_selected_value, params) {
                // return(<div className="buttonIn ShareCV">
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "buttonIn",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                        className: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().Form__Input),
                        autoComplete: "password"
                    }, inputProps))
                });
            }
        },
        {
            // Add the functionality of the add component in input text box for entering the data 
            key: "onAddClick",
            value: function onAddClick(event, value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, add_selected_value, params) {
                var ref;
                event.preventDefault();
                if (((ref = value.value) === null || ref === void 0 ? void 0 : ref.trim()) != "") {
                    var new_value = {
                        label: value.value,
                        value: value.id || ""
                    };
                    add_selected_value(new_value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params);
                }
            }
        },
        {
            // This function is called when click on the cross of the chips selected
            key: "removeSelectedValues",
            value: function removeSelectedValues(event, selectedValues, setSelectedValues, setSelectedUserCount) {
                var selected_value_index = parseInt(event.currentTarget.getAttribute("data-index"));
                selectedValues.splice(selected_value_index, 1);
                setSelectedValues(selectedValues);
                setSelectedUserCount(selectedValues.length);
            }
        },
        {
            // When selecting the suggestion 
            key: "onSuggestionSelectionValue",
            value: function onSuggestionSelectionValue(value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, add_selected_value, params) {
                add_selected_value(value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params);
            }
        },
        {
            // Function called when pressing the enter key in the input
            key: "handleKeyDown",
            value: function handleKeyDown(evt, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, add_selected_value, params) {
                if (evt.key === "Enter" && evt.target.value.trim() != "") {
                    evt.preventDefault();
                    var value = {
                        label: evt.target.value,
                        value: evt.target.id
                    };
                    add_selected_value(value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params);
                }
            }
        }
    ]);
    return AutosuggestionInputAction;
}();


/***/ }),

/***/ 61665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FB": function() { return /* binding */ deselectAllCandidates; },
/* harmony export */   "Sp": function() { return /* binding */ bulkAddToJob; },
/* harmony export */   "UH": function() { return /* binding */ getSelectedCandidateId; },
/* harmony export */   "_0": function() { return /* binding */ bulkDeleteCandidate; },
/* harmony export */   "nt": function() { return /* binding */ bulkDownloadCV; }
/* harmony export */ });
/* unused harmony exports bulkSendGDPREmail, buldSendGDPREmail */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96047);
/* harmony import */ var _services_components_candidate_listing_action__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66693);




function bulkDownloadCV(setCandidateBulkActionModal, setApiError) {
    return _bulkDownloadCV.apply(this, arguments);
}
function _bulkDownloadCV() {
    _bulkDownloadCV = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(setCandidateBulkActionModal, setApiError) {
        var candidate_ids, body, _tmp, result, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    candidate_ids = getSelectedCandidateId();
                    _tmp = {};
                    body = (_tmp["candidate_ids"] = candidate_ids, _tmp);
                    return [
                        4,
                        new _services_components_candidate_listing_action__WEBPACK_IMPORTED_MODULE_1__/* .CandidateListAction */ .n().downloadCandidateResumes(body)
                    ];
                case 1:
                    result = _state.sent();
                    customToastrAction = new _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .CustomToastrAction */ .Y5();
                    setApiError(result.request);
                    if (!(result.status == 204)) return [
                        3,
                        2
                    ];
                    // toastr.success('No CVs available for download.');
                    customToastrAction.setNormalToastr("No CVs available for download", "success");
                    return [
                        3,
                        6
                    ];
                case 2:
                    if (!(result.data.type == "application/zip")) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        saveAs(result.data, "Resumes.zip")
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 4:
                    return [
                        4,
                        saveAs(result.data, "Resume.".concat(result.data.type.split("/")[1]))
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    setCandidateBulkActionModal(false);
                    deselectAllCandidates();
                    return [
                        2
                    ];
            }
        });
    });
    return _bulkDownloadCV.apply(this, arguments);
}
function bulkSendGDPREmail() {
    console.log("send gdpr email");
}
function bulkAddToJob(setCandidateAddToJobModal, setSelectedCandidateId) {
    return _bulkAddToJob.apply(this, arguments);
}
function _bulkAddToJob() {
    _bulkAddToJob = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(setCandidateAddToJobModal, setSelectedCandidateId) {
        var candidate_ids;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            candidate_ids = getSelectedCandidateId();
            setSelectedCandidateId(candidate_ids);
            setCandidateAddToJobModal(true);
            return [
                2
            ];
        });
    });
    return _bulkAddToJob.apply(this, arguments);
}
function bulkDeleteCandidate(setcandidateJobDeleteModal, setSelectedCandidateId, setCandidateBulkActionModal) {
    return _bulkDeleteCandidate.apply(this, arguments);
}
function _bulkDeleteCandidate() {
    _bulkDeleteCandidate = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(setcandidateJobDeleteModal, setSelectedCandidateId, setCandidateBulkActionModal) {
        var candidate_ids;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            candidate_ids = getSelectedCandidateId();
            setSelectedCandidateId(candidate_ids);
            setcandidateJobDeleteModal(true);
            setCandidateBulkActionModal(false);
            deselectAllCandidates();
            return [
                2
            ];
        });
    });
    return _bulkDeleteCandidate.apply(this, arguments);
}
function buldSendGDPREmail() {
    return _buldSendGDPREmail.apply(this, arguments);
}
function _buldSendGDPREmail() {
    _buldSendGDPREmail = _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            // TODO :- Need to send email
            console.log("Next sprint");
            return [
                2
            ];
        });
    });
    return _buldSendGDPREmail.apply(this, arguments);
}
function getSelectedCandidateId() {
    var all_body_checkbox = document.querySelectorAll('.rdt_TableRow input[type="checkbox"]');
    var selected_candidate = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = all_body_checkbox[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            if (element.checked) {
                selected_candidate.push(element.closest(".rdt_TableRow").querySelector(".DotsOptionsCandi").id);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return selected_candidate;
}
function deselectAllCandidates() {
    var all_checkbox = document.querySelector("[name = select-all-rows]");
    if (all_checkbox.checked) {
        all_checkbox.click();
    } else {
        all_checkbox.click();
        all_checkbox.click();
    }
}


/***/ }),

/***/ 20344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uF": function() { return /* binding */ agencyEmailTo; },
  "o5": function() { return /* binding */ getCandidateName; },
  "x9": function() { return /* binding */ getCustomTemplate; },
  "BF": function() { return /* binding */ getEmailTo; },
  "E7": function() { return /* binding */ getPurposeOptions; },
  "JZ": function() { return /* binding */ removeAttachment; },
  "nc": function() { return /* binding */ submitCandidateEmail; },
  "WF": function() { return /* binding */ submitKanbanEmail; }
});

// UNUSED EXPORTS: getEmails, onKeyDown

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ./src/imports-files/pages/admins/logout.js + 1 modules
var logout = __webpack_require__(63281);
;// CONCATENATED MODULE: ./src/services/components/candidate-email.js








var CandidateEmail = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(CandidateEmail, SendRequest);
    var _super = (0,_create_super/* default */.Z)(CandidateEmail);
    function CandidateEmail() {
        (0,_class_call_check/* default */.Z)(this, CandidateEmail);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CandidateEmail, [
        {
            key: "SendCandidateJobEmail",
            value: function SendCandidateJobEmail(params, router, entity_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var send_candidate_email, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                send_candidate_email = common/* API.client.applicant.SEND_EMAIL.replace */.bl.client.applicant.SEND_EMAIL.replace("$applicant_id", router.query.applicant_id || entity_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(send_candidate_email, params, _this.setMultipartHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "SendCandidateGeneralEmail",
            value: function SendCandidateGeneralEmail(params, router, entity_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var send_candidate_email, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                send_candidate_email = common/* API.client.applicant.GENERAL_SEND_EMAIL.replace */.bl.client.applicant.GENERAL_SEND_EMAIL.replace("$candidate_id", router.query.candidate_id || entity_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(send_candidate_email, params, _this.setMultipartHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "SendKanbanEmail",
            value: function SendKanbanEmail(params, router) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var send_candidate_email, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                send_candidate_email = common/* API.client.kanban.SEND_EMAIL.replace */.bl.client.kanban.SEND_EMAIL.replace("$job_id", router.query.job_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(send_candidate_email, params, _this.setMultipartHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CandidateEmail;
}(logout/* SendRequest */.Lt);

// EXTERNAL MODULE: ./src/imports-files/pages/clients/candidates/kanban.js + 10 modules
var kanban = __webpack_require__(47942);
// EXTERNAL MODULE: ./src/imports-files/components/review-email.js + 1 modules
var review_email = __webpack_require__(3623);
;// CONCATENATED MODULE: ./src/actions/components/candidate-email.js






function submitCandidateEmail(values, router, setEmailModal, setFlagForRerender, initialData, setInitialData, selectedValues, selectedToValues, setShowLoader, entity_id, entity_type, formRef) {
    return _submitCandidateEmail.apply(this, arguments);
}
function _submitCandidateEmail() {
    _submitCandidateEmail = (0,_async_to_generator/* default */.Z)(function(values, router, setEmailModal, setFlagForRerender, initialData, setInitialData, selectedValues, selectedToValues, setShowLoader, entity_id, entity_type, formRef) {
        var ref, _tmp, cc_emails, to_emails, formData, customToastrAction, result, link, params, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    //If user does not add any email besides default email in to then it should show the error to enter email
                    if (formRef && values.email.forward && selectedToValues.length == 1) {
                        formRef.current.setStatus((_tmp["email"] = {
                            "to": "Required"
                        }, _tmp));
                        formRef.current.setFieldTouched("email.to", true);
                        return [
                            2,
                            null
                        ];
                    }
                    setShowLoader(true);
                    cc_emails = getEmails(selectedValues);
                    to_emails = getEmails(selectedToValues);
                    formData = new FormData();
                    customToastrAction = new common/* CustomToastrAction */.Y5();
                    // {console.log('setShowLoader')}
                    // {console.log(values)}
                    formData.append("email[subject]", values.email.subject);
                    formData.append("email[body]", values.email.body);
                    formData.append("email[entity_type]", values.email.entity_type);
                    // formData.append(`email[reply_to]`, values.email.reply_to);
                    values.email.reply_to ? formData.append("email[reply_to]", values.email.reply_to) : "";
                    formData.append("email[references]", values.email.references);
                    formData.append("email[cc]", cc_emails);
                    formData.append("email[to]", to_emails);
                    formData.append("email[comm_detail_id]", values.email.comm_detail_id);
                    values.email.forward ? formData.append("email[forward]", values.email.forward) : "";
                    values.email.attachments = Array.from(values.email.attachments);
                    values.email.attachments.map(function(file, index) {
                        formData.append("email[attachments][]", file);
                    });
                    result = "";
                    if (!(router.asPath.includes("/clients/candidates/") || entity_type == "ClientCandidate")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        new CandidateEmail().SendCandidateGeneralEmail(formData, router, entity_id)
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        new CandidateEmail().SendCandidateJobEmail(formData, router, entity_id)
                    ];
                case 3:
                    result = _state.sent();
                    _state.label = 4;
                case 4:
                    _tmp1 = {};
                    if ((result === null || result === void 0 ? void 0 : (ref = result.response) === null || ref === void 0 ? void 0 : ref.status) == 200 || result.status == 200) {
                        initialData.comms = result.data.comms;
                        setInitialData(initialData);
                        setFlagForRerender(Math.random() * 10000);
                        setShowLoader(false);
                        setEmailModal(false);
                        customToastrAction.setNormalToastr((0,common/* TRANSLATION */.TA)("toastr:email_sent"), "success");
                        // toastr.success('The email has been sent successfully ');
                        // If email is forward then move it to the inbox page
                        if (values.email.forward) {
                            link = common/* REDIRECT.client.communication.index */.RQ.client.communication.index;
                            params = router.query;
                            delete params["comm_detail_id"];
                            router.push((_tmp1.pathname = link, _tmp1.query = params, _tmp1));
                        }
                    // Call the show api again to shoe data
                    // if(router.asPath.) 
                    // {
                    //     let link = REDIRECT.client.communication.index
                    //     let params = router.query.params
                    //     router.push({pathname: link, query: params})
                    // }
                    } else {
                        setShowLoader(false);
                        // setEmailModal(false);
                        customToastrAction.setNormalToastr(result.response.data.error, "warning");
                    // toastr.warning(result.response.data.error);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _submitCandidateEmail.apply(this, arguments);
}
function submitKanbanEmail(args) {
    return _submitKanbanEmail.apply(this, arguments);
}
function _submitKanbanEmail() {
    _submitKanbanEmail = (0,_async_to_generator/* default */.Z)(function(args) {
        var ref, ref1, cc_emails, formData, customToastrAction, result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    args.setShowLoader(true);
                    cc_emails = getEmails(args.selectedValues);
                    formData = new FormData();
                    customToastrAction = new common/* CustomToastrAction */.Y5();
                    formData.append("email[subject]", args.values.email.subject);
                    formData.append("email[body]", args.values.email.body);
                    formData.append("email[cc]", cc_emails);
                    formData.append("email[entity_type]", args.values.email.entity_type);
                    // formData.append('email[to]', receiver_ids);
                    formData.append("kanban[stage_id]", (ref = args.selectedCards) === null || ref === void 0 ? void 0 : ref.stage_id);
                    formData.append("kanban[job_application_ids]", args.selectedCards.job_application_ids);
                    formData.append("kanban[rejected_ids]", args.selectedCards.rejected_ids);
                    formData.append("kanban[status]", args.status);
                    formData.append("kanban[moving_status]", args.moving_status);
                    args.values.email.attachments = Array.from(args.values.email.attachments);
                    args.values.email.attachments.map(function(file, index) {
                        formData.append("email[attachments][]", file);
                    });
                    if (!args.isActiveEmail) return [
                        3,
                        2
                    ];
                    if (args.from == "kanban") {
                        formData.append("query", args.filterData.query);
                        formData.append("years_of_experience", args.filterData.years_of_experience);
                        formData.append("interview_score", args.filterData.interview_score);
                        formData.append("tech_score", args.filterData.tech_score);
                        formData.append("desired_salary", args.filterData.desired_salary);
                        formData.append("application_status", args.filterData.application_status);
                        formData.append("source", args.filterData.source);
                        formData.append("status", args.activeTab);
                    }
                    formData.append("from", args.from);
                    return [
                        4,
                        new kanban/* Kanban */.pt().markActiveUnsuccessful(args.job_id, formData)
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        new CandidateEmail().SendKanbanEmail(formData, args.router)
                    ];
                case 3:
                    result = _state.sent();
                    _state.label = 4;
                case 4:
                    if ((result === null || result === void 0 ? void 0 : (ref1 = result.response) === null || ref1 === void 0 ? void 0 : ref1.status) == 200 || result.status == 200) {
                        args.setShowLoader(false);
                        args.setEmailModal(false);
                        if (args.from == "kanban") (0,kanban/* clearRadioButtonSelection */.sZ)(args.setSelectedCards, args.activeTab, args.setActionBar);
                        if (args.isActiveEmail && args.from == "kanban") {
                            args.setJobData(result.data.kanban_data);
                        } else if (args.from == "application_view") {
                            args.setInitialData(result.data.application_data);
                        }
                        if (result.data.warning && result.data.warning.length > 0) {
                            customToastrAction.setNormalToastr(result.data.warning, "error");
                        // toastr.error(result.data.warning)
                        } else {
                            args.isActiveEmail ? customToastrAction.setNormalToastr(result.data.success, "success") : customToastrAction.setNormalToastr((0,common/* TRANSLATION */.TA)("toastr:email_sent"), "success");
                        }
                    } else {
                        args.setShowLoader(false);
                        customToastrAction.setNormalToastr(result.response.data.error, "warning");
                    // toastr.warning(result.response.data.error);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _submitKanbanEmail.apply(this, arguments);
}
function getEmails(values) {
    var emails = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            emails.push(element.email);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return emails;
}
function removeAttachment(event, attachmentList, setAttachmentList, setFlagForRerender) {
    var remove_file_index = event.currentTarget.closest(".AttachmentChip").getAttribute("data-index");
    attachmentList.splice(remove_file_index, 1);
    setAttachmentList(attachmentList);
    setFlagForRerender(Math.random() * 10000);
}
function getCandidateName(selectedCards) {
    var ref, ref1;
    var name = null;
    name = (ref1 = (ref = document.querySelector("[data-stage_id='" + selectedCards.stage_id + "']")) === null || ref === void 0 ? void 0 : ref.closest(".react-trello-lane")) === null || ref1 === void 0 ? void 0 : ref1.querySelectorAll("[data-application_id]");
    if (name && name.length > 0) {
        for(var i = 0; i < name.length; i++){
            if (name[i].checked) {
                name = name[i].closest("div").querySelector("h2").textContent;
                break;
            }
        }
    }
    return name;
}
function getEmailTo(props) {
    var send_email = props === null || props === void 0 ? void 0 : props.system_notification_email;
    var email_To = props.emailTo;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = props.emailTo[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            if (element.email != (props === null || props === void 0 ? void 0 : props.system_notification_email) && element.email == props.session.email) {
                email_To = props.emailFrom;
                break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (Array.isArray(email_To)) {
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = email_To[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var element1 = _step1.value;
                if ((element1.name || element1.email) && (element1.name || element1.email) != (props === null || props === void 0 ? void 0 : props.system_notification_email)) {
                    send_email = send_email + ", " + element1.name || element1.email;
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    } else {
        if (email_To.name || email_To.email) {
            send_email = send_email + ", " + email_To.name || email_To.email;
        }
    }
    if ([
        "send_email_candidate_button",
        "not_send_email_candidate_button"
    ].includes(props.openFrom)) {
        // if(props.data.application.email || props.data.application.name)
        // {
        //     send_email = send_email+', '+ props.data.application.name || props.data.application.email
        // }
        // else
        // {
        //     send_email = send_email+', '+ props.data.application.agency_detail.name || props.data.application.agency_detail.email
        // }
        if (props.data.application && props.data.application.email) {
            send_email = send_email + ", " + props.data.application.name || props.data.application.email;
        }
    // if( props.data.application.agency_detail)
    // {
    //     send_email = send_email+', '+ props.data.application.agency_detail
    // }
    }
    return send_email;
// `${props?.data?.application.name||props?.data?.application.email}${!props?.data?.application?.name.includes(props?.system_notification_email) ? `, ${props?.system_notification_email}` : ''}`
}
function getPurposeOptions(data) {
    var options = [];
    if (data) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                options.push({
                    value: element.id,
                    label: element.purpose,
                    type: element.type,
                    template_type: element.template_type,
                    template_id: element.template_id,
                    is_custom_master: element.is_custom_master || false
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return options;
    }
}
function getCustomTemplate(select_option, formik, setSubject, setDataVariables, setRefreshKey, t) {
    return _getCustomTemplate.apply(this, arguments);
}
function _getCustomTemplate() {
    _getCustomTemplate = (0,_async_to_generator/* default */.Z)(function(select_option, formik, setSubject, setDataVariables, setRefreshKey, t) {
        var reviewEmailService, reviewEmailActions, master_template_id, master_template_type, template_type, template_id, body, _tmp, result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    reviewEmailService = new review_email/* ReviewEmailServices */.fu();
                    reviewEmailActions = new review_email/* ReviewEmailActions */.fY();
                    master_template_id = select_option.value;
                    master_template_type = select_option.type;
                    template_type = select_option.template_type;
                    template_id = select_option.template_id;
                    _tmp = {};
                    body = (_tmp.type = template_type, _tmp.master = false, _tmp.is_custom_master = select_option.is_custom_master || false, _tmp);
                    return [
                        4,
                        reviewEmailService.getSystemEmailTemplate(body, template_id)
                    ];
                case 1:
                    result = _state.sent();
                    if (!(result.request.status == 200)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        formik.setFieldValue("email.subject", result.data.subject)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        formik.setFieldValue("email.body", result.data.email_body)
                    ];
                case 3:
                    _state.sent();
                    return [
                        4,
                        formik.setFieldValue("email.entity_type", result.data.entity_type)
                    ];
                case 4:
                    _state.sent();
                    return [
                        4,
                        setSubject(reviewEmailActions.subjectVars(t))
                    ];
                case 5:
                    _state.sent();
                    return [
                        4,
                        setDataVariables(reviewEmailActions.bodyVars(t))
                    ];
                case 6:
                    _state.sent();
                    return [
                        4,
                        setRefreshKey(Math.random() * 10000)
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return _getCustomTemplate.apply(this, arguments);
}
function onKeyDown(keyEvent) {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
        keyEvent.preventDefault();
    }
}
function agencyEmailTo(props, selectedToValues, setSelectedToValues) {
    if (selectedToValues.length == 0) {
        var send_email = [
            {
                name: props === null || props === void 0 ? void 0 : props.system_notification_email,
                email: props === null || props === void 0 ? void 0 : props.system_notification_email
            }
        ];
        props.data.application.email ? send_email.push({
            name: props.data.application.name,
            email: props.data.application.email
        }) : "";
        props.data.application.agency_user_email ? send_email.push({
            name: props.data.application.agency_detail,
            email: props.data.application.agency_user_email
        }) : "";
        setSelectedToValues(send_email);
    }
}


/***/ }),

/***/ 50668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ CustomCropperAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96916);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var cropperjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51934);
/* harmony import */ var cropperjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(cropperjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _actions_common_image_base64_to_blob__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17728);
/* harmony import */ var _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82352);






__webpack_require__.g.cropper = "";


var CustomCropperAction = /*#__PURE__*/ function() {
    "use strict";
    function CustomCropperAction() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, CustomCropperAction);
        this.blob_data = "";
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(CustomCropperAction, [
        {
            key: "initialize_cropping_area",
            value: function initialize_cropping_area(type) {
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var image, initalize_hash, _tmp, minCroppedWidth, minCroppedHeight, maxCroppedWidth, maxCroppedHeight, minCroppedWidth, minCroppedHeight, maxCroppedWidth, maxCroppedHeight, minCroppedWidth, minCroppedHeight, maxCroppedWidth, maxCroppedHeight, minCroppedWidth, minCroppedHeight, maxCroppedWidth, maxCroppedHeight, minCroppedWidth, minCroppedHeight, maxCroppedWidth, maxCroppedHeight, minCroppedWidth, minCroppedHeight, maxCroppedWidth, maxCroppedHeight, minCroppedWidth, minCroppedHeight, maxCroppedWidth, maxCroppedHeight, _tmp1;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                type = type || "profilepic";
                                image = document.querySelector(".Cropper__Image");
                                _tmp = {};
                                initalize_hash = (_tmp.dragMode = "move", _tmp.aspectRatio = 1, _tmp.viewMode = 1, _tmp.cropBoxResizable = false, _tmp.toggleDragModeOnDblclick = false, _tmp);
                                switch(type){
                                    case "logo_image":
                                        return [
                                            3,
                                            1
                                        ];
                                    case "hero_image":
                                        return [
                                            3,
                                            3
                                        ];
                                    case "mobile_image":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "about_image":
                                        return [
                                            3,
                                            7
                                        ];
                                    case "gallery_image":
                                        return [
                                            3,
                                            9
                                        ];
                                    case "benefit_image":
                                        return [
                                            3,
                                            11
                                        ];
                                    case "team_image":
                                        return [
                                            3,
                                            13
                                        ];
                                    case "profilepic":
                                        return [
                                            3,
                                            15
                                        ];
                                }
                                return [
                                    3,
                                    17
                                ];
                            case 1:
                                minCroppedWidth = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.logo.minWidth */ ._f.logo.minWidth;
                                minCroppedHeight = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.logo.minHeight */ ._f.logo.minHeight;
                                maxCroppedWidth = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.logo.maxWidth */ ._f.logo.maxWidth;
                                maxCroppedHeight = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.logo.maxHeight */ ._f.logo.maxHeight;
                                initalize_hash = {
                                    dragMode: "move",
                                    viewMode: 1,
                                    zoomable: true,
                                    cropBoxResizable: false,
                                    background: false,
                                    aspectRatio: _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.logo.ratio */ ._f.logo.ratio,
                                    toggleDragModeOnDblclick: false
                                };
                                return [
                                    4,
                                    new (cropperjs__WEBPACK_IMPORTED_MODULE_1___default())(image, initalize_hash)
                                ];
                            case 2:
                                cropper = _state.sent();
                                return [
                                    3,
                                    17
                                ];
                            case 3:
                                minCroppedWidth = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.hero.minWidth */ ._f.hero.minWidth;
                                minCroppedHeight = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.hero.minHeight */ ._f.hero.minHeight;
                                maxCroppedWidth = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.hero.maxWidth */ ._f.hero.maxWidth;
                                maxCroppedHeight = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.hero.maxHeight */ ._f.hero.maxHeight;
                                initalize_hash = {
                                    dragMode: "move",
                                    viewMode: 1,
                                    zoomable: true,
                                    cropBoxResizable: false,
                                    aspectRatio: _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.hero.ratio */ ._f.hero.ratio,
                                    toggleDragModeOnDblclick: false
                                };
                                return [
                                    4,
                                    new (cropperjs__WEBPACK_IMPORTED_MODULE_1___default())(image, initalize_hash)
                                ];
                            case 4:
                                cropper = _state.sent();
                                return [
                                    3,
                                    17
                                ];
                            case 5:
                                minCroppedWidth = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.mobile_hero.minWidth */ ._f.mobile_hero.minWidth;
                                minCroppedHeight = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.mobile_hero.minHeight */ ._f.mobile_hero.minHeight;
                                maxCroppedWidth = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.mobile_hero.maxWidth */ ._f.mobile_hero.maxWidth;
                                maxCroppedHeight = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.mobile_hero.maxHeight */ ._f.mobile_hero.maxHeight;
                                initalize_hash = {
                                    dragMode: "move",
                                    viewMode: 1,
                                    zoomable: true,
                                    cropBoxResizable: false,
                                    aspectRatio: _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.mobile_hero.ratio */ ._f.mobile_hero.ratio,
                                    toggleDragModeOnDblclick: false
                                };
                                return [
                                    4,
                                    new (cropperjs__WEBPACK_IMPORTED_MODULE_1___default())(image, initalize_hash)
                                ];
                            case 6:
                                cropper = _state.sent();
                                return [
                                    3,
                                    17
                                ];
                            case 7:
                                minCroppedWidth = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.about.minWidth */ ._f.about.minWidth;
                                minCroppedHeight = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.about.minHeight */ ._f.about.minHeight;
                                maxCroppedWidth = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.about.maxWidth */ ._f.about.maxWidth;
                                maxCroppedHeight = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.about.maxHeight */ ._f.about.maxHeight;
                                initalize_hash = {
                                    dragMode: "move",
                                    viewMode: 1,
                                    zoomable: true,
                                    cropBoxResizable: false,
                                    aspectRatio: _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.about.ratio */ ._f.about.ratio,
                                    toggleDragModeOnDblclick: false
                                };
                                return [
                                    4,
                                    new (cropperjs__WEBPACK_IMPORTED_MODULE_1___default())(image, initalize_hash)
                                ];
                            case 8:
                                cropper = _state.sent();
                                return [
                                    3,
                                    17
                                ];
                            case 9:
                                minCroppedWidth = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.gallery.minWidth */ ._f.gallery.minWidth;
                                minCroppedHeight = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.gallery.minHeight */ ._f.gallery.minHeight;
                                maxCroppedWidth = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.gallery.maxWidth */ ._f.gallery.maxWidth;
                                maxCroppedHeight = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.gallery.maxHeight */ ._f.gallery.maxHeight;
                                initalize_hash = {
                                    dragMode: "move",
                                    viewMode: 1,
                                    zoomable: true,
                                    cropBoxResizable: false,
                                    aspectRatio: _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.gallery.ratio */ ._f.gallery.ratio,
                                    toggleDragModeOnDblclick: false
                                };
                                return [
                                    4,
                                    new (cropperjs__WEBPACK_IMPORTED_MODULE_1___default())(image, initalize_hash)
                                ];
                            case 10:
                                cropper = _state.sent();
                                return [
                                    3,
                                    17
                                ];
                            case 11:
                                minCroppedWidth = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.benefit.minWidth */ ._f.benefit.minWidth;
                                minCroppedHeight = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.benefit.minHeight */ ._f.benefit.minHeight;
                                maxCroppedWidth = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.benefit.maxWidth */ ._f.benefit.maxWidth;
                                maxCroppedHeight = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.benefit.maxHeight */ ._f.benefit.maxHeight;
                                initalize_hash = {
                                    dragMode: "move",
                                    viewMode: 0,
                                    zoomable: true,
                                    cropBoxResizable: false,
                                    aspectRatio: _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.benefit.ratio */ ._f.benefit.ratio,
                                    toggleDragModeOnDblclick: false
                                };
                                return [
                                    4,
                                    new (cropperjs__WEBPACK_IMPORTED_MODULE_1___default())(image, initalize_hash)
                                ];
                            case 12:
                                cropper = _state.sent();
                                return [
                                    3,
                                    17
                                ];
                            case 13:
                                minCroppedWidth = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.team.minWidth */ ._f.team.minWidth;
                                minCroppedHeight = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.team.minHeight */ ._f.team.minHeight;
                                maxCroppedWidth = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.team.maxWidth */ ._f.team.maxWidth;
                                maxCroppedHeight = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.team.maxHeight */ ._f.team.maxHeight;
                                initalize_hash = {
                                    dragMode: "move",
                                    viewMode: 1,
                                    zoomable: true,
                                    cropBoxResizable: false,
                                    aspectRatio: _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_2__/* .FILE_SIZES.team.ratio */ ._f.team.ratio,
                                    toggleDragModeOnDblclick: false
                                };
                                return [
                                    4,
                                    new (cropperjs__WEBPACK_IMPORTED_MODULE_1___default())(image, initalize_hash)
                                ];
                            case 14:
                                cropper = _state.sent();
                                return [
                                    3,
                                    17
                                ];
                            case 15:
                                _tmp1 = {};
                                return [
                                    4,
                                    new (cropperjs__WEBPACK_IMPORTED_MODULE_1___default())(image, (_tmp1.dragMode = "move", _tmp1.aspectRatio = 1, _tmp1.viewMode = 1, _tmp1.cropBoxResizable = false, _tmp1.toggleDragModeOnDblclick = false, _tmp1))
                                ];
                            case 16:
                                cropper = _state.sent();
                                return [
                                    3,
                                    17
                                ];
                            case 17:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "crop_image",
            value: function crop_image(args) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var cropper_type, _tmp, type, croppedCanvas, data_url, blob_data, result, croppedCanvas, data_url, blob_data, croppedCanvas, data_url, blob_data, croppedCanvas, data_url, blob_data, croppedCanvas, data_url, blob_data, croppedCanvas, data_url, blob_data, croppedCanvas, data_url, blob_data, result, croppedCanvas, roundedCanvas;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = args || {};
                                _tmp = {};
                                cropper_type = args.cropper_type || _tmp;
                                if (!(Object.keys(cropper_type).length > 0)) return [
                                    3,
                                    24
                                ];
                                type = cropper_type.type;
                                switch(type){
                                    case "logo_image":
                                        return [
                                            3,
                                            1
                                        ];
                                    case "hero_image":
                                        return [
                                            3,
                                            4
                                        ];
                                    case "mobile_image":
                                        return [
                                            3,
                                            8
                                        ];
                                    case "about_image":
                                        return [
                                            3,
                                            11
                                        ];
                                    case "gallery_image":
                                        return [
                                            3,
                                            14
                                        ];
                                    case "benefit_image":
                                        return [
                                            3,
                                            17
                                        ];
                                    case "team_image":
                                        return [
                                            3,
                                            20
                                        ];
                                }
                                return [
                                    3,
                                    23
                                ];
                            case 1:
                                croppedCanvas = cropper.getCroppedCanvas();
                                data_url = croppedCanvas.toDataURL("image/png");
                                cropper_type.formik.setFieldValue("logo_url", data_url);
                                return [
                                    4,
                                    (0,_actions_common_image_base64_to_blob__WEBPACK_IMPORTED_MODULE_7__/* .dataURItoBlob */ .O)(data_url)
                                ];
                            case 2:
                                blob_data = _state.sent();
                                return [
                                    4,
                                    args.viewProfileAction.updateLogo(blob_data)
                                ];
                            case 3:
                                _state.sent();
                                _this.destroy_cropper();
                                return [
                                    3,
                                    23
                                ];
                            case 4:
                                result = document.querySelector("#Hero_Back_Image");
                                croppedCanvas = cropper.getCroppedCanvas();
                                data_url = croppedCanvas.toDataURL("image/jpeg");
                                result.style.backgroundImage = "url(".concat(data_url, ")");
                                return [
                                    4,
                                    (0,_actions_common_image_base64_to_blob__WEBPACK_IMPORTED_MODULE_7__/* .dataURItoBlob */ .O)(data_url)
                                ];
                            case 5:
                                blob_data = _state.sent();
                                return [
                                    4,
                                    args.viewProfileAction.updateBackground(blob_data)
                                ];
                            case 6:
                                _state.sent();
                                _this.destroy_cropper();
                                return [
                                    4,
                                    args.viewProfileAction.handleMobileBackground(args.viewProfileAction)
                                ];
                            case 7:
                                _state.sent();
                                return [
                                    3,
                                    23
                                ];
                            case 8:
                                croppedCanvas = cropper.getCroppedCanvas();
                                data_url = croppedCanvas.toDataURL("image/jpeg");
                                return [
                                    4,
                                    (0,_actions_common_image_base64_to_blob__WEBPACK_IMPORTED_MODULE_7__/* .dataURItoBlob */ .O)(data_url)
                                ];
                            case 9:
                                blob_data = _state.sent();
                                return [
                                    4,
                                    args.viewProfileAction.updateMobileBackground(blob_data)
                                ];
                            case 10:
                                _state.sent();
                                _this.destroy_cropper();
                                return [
                                    3,
                                    23
                                ];
                            case 11:
                                croppedCanvas = cropper.getCroppedCanvas();
                                data_url = croppedCanvas.toDataURL("image/jpeg");
                                cropper_type.formik.setFieldValue("page_sections_attributes.".concat(cropper_type.index, ".career_about_section_attributes.image_url"), data_url);
                                return [
                                    4,
                                    (0,_actions_common_image_base64_to_blob__WEBPACK_IMPORTED_MODULE_7__/* .dataURItoBlob */ .O)(data_url)
                                ];
                            case 12:
                                blob_data = _state.sent();
                                return [
                                    4,
                                    args.viewProfileAction.updateAboutImage(cropper_type.formik, cropper_type.index, blob_data)
                                ];
                            case 13:
                                _state.sent();
                                _this.destroy_cropper();
                                return [
                                    3,
                                    23
                                ];
                            case 14:
                                croppedCanvas = cropper.getCroppedCanvas();
                                data_url = croppedCanvas.toDataURL("image/jpeg");
                                cropper_type.formik.setFieldValue("page_sections_attributes.".concat(cropper_type.index, ".career_gallery_section_attributes.career_gallery_images_attributes.").concat(cropper_type.gallery_index, ".image_url"), data_url);
                                return [
                                    4,
                                    (0,_actions_common_image_base64_to_blob__WEBPACK_IMPORTED_MODULE_7__/* .dataURItoBlob */ .O)(data_url)
                                ];
                            case 15:
                                blob_data = _state.sent();
                                return [
                                    4,
                                    args.viewProfileAction.updateGalleryImage(cropper_type.formik, cropper_type.index, cropper_type.gallery_index, blob_data)
                                ];
                            case 16:
                                _state.sent();
                                _this.destroy_cropper();
                                return [
                                    3,
                                    23
                                ];
                            case 17:
                                croppedCanvas = cropper.getCroppedCanvas();
                                data_url = croppedCanvas.toDataURL("image/png");
                                cropper_type.formik.setFieldValue("page_sections_attributes.".concat(cropper_type.index, ".career_benefit_section_attributes.career_benefit_details_attributes.").concat(cropper_type.benefit_index, ".image_url"), data_url);
                                return [
                                    4,
                                    (0,_actions_common_image_base64_to_blob__WEBPACK_IMPORTED_MODULE_7__/* .dataURItoBlob */ .O)(data_url)
                                ];
                            case 18:
                                blob_data = _state.sent();
                                return [
                                    4,
                                    args.viewProfileAction.updateBenefitImage(cropper_type.formik, cropper_type.index, cropper_type.benefit_index, blob_data)
                                ];
                            case 19:
                                _state.sent();
                                _this.destroy_cropper();
                                return [
                                    3,
                                    23
                                ];
                            case 20:
                                croppedCanvas = cropper.getCroppedCanvas();
                                data_url = croppedCanvas.toDataURL("image/png");
                                cropper_type.formik.setFieldValue("page_sections_attributes.".concat(cropper_type.index, ".career_team_section_attributes.career_team_details_attributes.").concat(cropper_type.team_index, ".image_url"), data_url);
                                return [
                                    4,
                                    (0,_actions_common_image_base64_to_blob__WEBPACK_IMPORTED_MODULE_7__/* .dataURItoBlob */ .O)(data_url)
                                ];
                            case 21:
                                blob_data = _state.sent();
                                return [
                                    4,
                                    args.viewProfileAction.updateTeamImage(cropper_type.formik, cropper_type.index, cropper_type.team_index, blob_data)
                                ];
                            case 22:
                                _state.sent();
                                _this.destroy_cropper();
                                return [
                                    3,
                                    23
                                ];
                            case 23:
                                return [
                                    3,
                                    25
                                ];
                            case 24:
                                result = document.querySelector("#User_Profile");
                                croppedCanvas = cropper.getCroppedCanvas();
                                roundedCanvas = _this.getRoundedCanvas(croppedCanvas);
                                result.src = roundedCanvas.toDataURL("image/jpeg");
                                _this.destroy_cropper();
                                _state.label = 25;
                            case 25:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "destroy_cropper",
            value: function destroy_cropper() {
                cropper.destroy();
            }
        },
        {
            key: "getRoundedCanvas",
            value: function getRoundedCanvas(sourceCanvas) {
                var canvas = document.createElement("canvas");
                var context = canvas.getContext("2d");
                var width = sourceCanvas.width;
                var height = sourceCanvas.height;
                canvas.width = width;
                canvas.height = height;
                context.imageSmoothingEnabled = true;
                context.drawImage(sourceCanvas, 0, 0, width, height);
                context.globalCompositeOperation = "destination-in";
                context.beginPath();
                context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
                context.fill();
                return canvas;
            }
        },
        {
            key: "zoom_in",
            value: function zoom_in() {
                cropper.zoom(0.1);
            }
        },
        {
            key: "zoom_out",
            value: function zoom_out() {
                cropper.zoom(-0.1);
            }
        }
    ]);
    return CustomCropperAction;
}();


/***/ }),

/***/ 55384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ CommunicationCenterOptionsActions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34817);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_clients_communication_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25355);






var CommunicationCenterOptionsActions = /*#__PURE__*/ function() {
    "use strict";
    function CommunicationCenterOptionsActions(router) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, CommunicationCenterOptionsActions);
        this.communicationCenterOptionsService = new _imports_files_pages_clients_communication_index__WEBPACK_IMPORTED_MODULE_0__/* .CommunicationCenterOptionsService */ .hF();
        this.emailDetailsService = new _imports_files_pages_clients_communication_index__WEBPACK_IMPORTED_MODULE_0__/* .EmailDetailsService */ .V1();
        this.router = router;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(CommunicationCenterOptionsActions, [
        {
            key: "performJobAction",
            value: function performJobAction(ActionName, params) {
                var _this = this;
                switch(ActionName){
                    case "mark_as_read":
                        this.markAsRead(params);
                        break;
                    case "mark_as_unread":
                        this.markAsUnread(params);
                        break;
                    case "dismiss":
                        params.setConfirmationModal({
                            state: true,
                            message: params.t("modal:confirmation:delete:email"),
                            confirm_btn_action: function() {
                                _this.dismiss(params);
                            }
                        });
                        break;
                    default:
                        "";
                }
            }
        },
        {
            key: "markAsRead",
            value: function markAsRead(args) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                    var params, id_arr, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, result, _tmp, link, _tmp1;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                params = "";
                                if (typeof args.id == "object") {
                                    id_arr = [];
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(_iterator = args.id.selectedRows[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            element = _step.value;
                                            if (element.parent_id && element.child_ids) {
                                                id_arr.push(element.parent_id);
                                                id_arr = id_arr.concat(element.child_ids);
                                            } else if (element.parent_id) {
                                                id_arr.push(element.parent_id);
                                                id_arr.push(element.id);
                                            } else {
                                                id_arr.push(element.id);
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    params = {
                                        ids: id_arr,
                                        read: true
                                    };
                                    params.ids = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(new Set(params.ids));
                                } else {
                                    if (args.row.parent_id && args.row.child_ids) {
                                        params = {
                                            ids: [
                                                args.row.parent_id
                                            ].concat(args.row.child_ids),
                                            read: true
                                        };
                                    } else if (args.row.parent_id) {
                                        params = {
                                            ids: [
                                                args.row.parent_id
                                            ].push(args.row.id),
                                            read: true
                                        };
                                    } else {
                                        params = {
                                            ids: args.row.id,
                                            read: true
                                        };
                                    }
                                }
                                params.email_type = _this.router.query.email_type;
                                return [
                                    4,
                                    _this.communicationCenterOptionsService.markAsRead(params)
                                ];
                            case 1:
                                result = _state.sent();
                                args.setApiError(result.request);
                                args.setCommunicationBulkActionModal(false);
                                _tmp = {};
                                args.setConfirmationModal((_tmp.state = false, _tmp.message = "", _tmp.confirm_btn_action = null, _tmp));
                                args.closeAllJobsOptions;
                                _this.deselectAllCandidates();
                                _tmp1 = {};
                                if (args.redirect) {
                                    link = _imports_files_pages_clients_communication_index__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT.client.communication.emails.replace */ .RQ.client.communication.emails.replace("$comm_detail_id", args.row.id);
                                    _this.router.push((_tmp1.pathname = link, _tmp1.query = _this.router.query, _tmp1));
                                } else {
                                    args.setCommunicationList(result.data);
                                    args.setFlagForRerender(Math.random() * 10000);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "markAsUnread",
            value: function markAsUnread(args) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                    var params, id_arr, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, result, _tmp;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                params = "";
                                if (typeof args.id == "object") {
                                    id_arr = [];
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(_iterator = args.id.selectedRows[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            element = _step.value;
                                            if (element.parent_id && element.child_ids) {
                                                id_arr.push(element.parent_id);
                                                id_arr = id_arr.concat(element.child_ids);
                                            } else if (element.parent_id) {
                                                id_arr.push(element.parent_id);
                                                id_arr.push(element.id);
                                            } else {
                                                id_arr.push(element.id);
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    params = {
                                        ids: id_arr,
                                        read: false
                                    };
                                    params.ids = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(new Set(params.ids));
                                } else {
                                    // params = { ids: [args.id], read: false }
                                    if (args.row.parent_id && args.row.child_ids) {
                                        params = {
                                            ids: [
                                                args.row.parent_id
                                            ].concat(args.row.child_ids),
                                            read: false
                                        };
                                    } else if (args.row.parent_id) {
                                        params = {
                                            ids: [
                                                args.row.parent_id
                                            ].push(args.row.id),
                                            read: false
                                        };
                                    } else {
                                        params = {
                                            ids: args.row.id,
                                            read: false
                                        };
                                    }
                                }
                                params.email_type = _this.router.query.email_type;
                                return [
                                    4,
                                    _this.communicationCenterOptionsService.markAsRead(params)
                                ];
                            case 1:
                                result = _state.sent();
                                args.setApiError(result.request);
                                args.setCommunicationList(result.data);
                                args.setCommunicationBulkActionModal(false);
                                _tmp = {};
                                args.setConfirmationModal((_tmp.state = false, _tmp.message = "", _tmp.confirm_btn_action = null, _tmp));
                                args.closeAllJobsOptions;
                                args.setFlagForRerender(Math.random() * 10000);
                                _this.deselectAllCandidates();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "dismiss",
            value: function dismiss(args) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                    var params, id_arr, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, result, _tmp;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                params = "";
                                if (typeof args.id == "object") {
                                    id_arr = [];
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(_iterator = args.id.selectedRows[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            element = _step.value;
                                            if (element.parent_id && element.child_ids) {
                                                id_arr.push(element.parent_id);
                                                id_arr = id_arr.concat(element.child_ids);
                                            } else if (element.parent_id) {
                                                id_arr.push(element.parent_id);
                                                id_arr.push(element.id);
                                            } else {
                                                id_arr.push(element.id);
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    params = {
                                        ids: id_arr,
                                        read: true
                                    };
                                    params.ids = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(new Set(params.ids));
                                } else {
                                    // params = { ids: [args.id], read: true }
                                    if (args.row.parent_id && args.row.child_ids) {
                                        params = {
                                            ids: [
                                                args.row.parent_id
                                            ].concat(args.row.child_ids),
                                            read: true
                                        };
                                    } else if (args.row.parent_id) {
                                        params = {
                                            ids: [
                                                args.row.parent_id
                                            ].push(args.row.id),
                                            read: true
                                        };
                                    } else {
                                        params = {
                                            ids: args.row.id,
                                            read: true
                                        };
                                    }
                                }
                                params.email_type = _this.router.query.email_type;
                                return [
                                    4,
                                    _this.communicationCenterOptionsService.dismiss(params)
                                ];
                            case 1:
                                result = _state.sent();
                                args.setApiError(result.request);
                                args.setCommunicationList(result.data);
                                args.setCommunicationBulkActionModal(false);
                                _tmp = {};
                                args.setConfirmationModal((_tmp.state = false, _tmp.message = "", _tmp.confirm_btn_action = null, _tmp));
                                args.closeAllJobsOptions;
                                args.setFlagForRerender(Math.random() * 10000);
                                _this.deselectAllCandidates();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deselectAllCandidates",
            value: function deselectAllCandidates() {
                var all_checkbox = document.querySelector("[name = select-all-rows]");
                if (all_checkbox) {
                    if (all_checkbox === null || all_checkbox === void 0 ? void 0 : all_checkbox.checked) {
                        all_checkbox.click();
                    } else {
                        all_checkbox.click();
                        all_checkbox.click();
                    }
                }
            }
        },
        {
            key: "showCommunicationCenterOptions",
            value: function showCommunicationCenterOptions(data, key) {
                if (this.router.query.email_type == "inbox") {
                    if (data.read) {
                        return key == "mark_as_unread" || key == "dismiss";
                    } else {
                        return key == "mark_as_read" || key == "dismiss";
                    }
                } else {
                    if (key == "mark_as_unread" || key == "mark_as_read") {
                        return false;
                    } else {
                        return true;
                    }
                }
            }
        },
        {
            key: "toggle",
            value: function toggle(event, data, page_name) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                    var params, _tmp, result, element_classes;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                params = _tmp;
                                result = "";
                                event.stopPropagation();
                                params["id"] = [
                                    data.id
                                ];
                                element_classes = event.currentTarget;
                                if (!element_classes.classList.contains("ImportantEmail")) return [
                                    3,
                                    2
                                ];
                                params["important"] = false;
                                return [
                                    4,
                                    _this.emailDetailsService.markAsImportantAndUnimportant(params)
                                ];
                            case 1:
                                result = _state.sent();
                                if (result.status == 200) {
                                    element_classes.classList.remove("ImportantEmail");
                                    element_classes.classList.add("NotImportantEmail");
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                params["important"] = true;
                                return [
                                    4,
                                    _this.emailDetailsService.markAsImportantAndUnimportant(params)
                                ];
                            case 3:
                                result = _state.sent();
                                if (result.status == 200) {
                                    element_classes.classList.remove("NotImportantEmail");
                                    element_classes.classList.add("ImportantEmail");
                                }
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CommunicationCenterOptionsActions;
}();


/***/ }),

/***/ 41817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f2": function() { return /* binding */ performJobAction; },
/* harmony export */   "t7": function() { return /* binding */ closeJob; }
/* harmony export */ });
/* unused harmony exports editJob, copyJob, duplicateJob, promoteJob, copyJobUrl, publishJob, deleteJob, isPreviousUpdateBeforeTwoDays */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96047);
/* harmony import */ var _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83813);
/* harmony import */ var _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44791);
/* harmony import */ var copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62985);
/* harmony import */ var copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34357);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);







function editJob(params) {
    return _editJob.apply(this, arguments);
}
function _editJob() {
    _editJob = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(params) {
        var link, key, setPageName, queryClient, link, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params.closeAllJobsOptions();
                    link = params.link.replace("$job_id", params.job_id);
                    key = "jobs";
                    setPageName = params.setPageName;
                    queryClient = params.queryClient;
                    link = params.link.replace("$job_id", params.job_id);
                    return [
                        4,
                        new _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_1__/* .JobCommon */ .gW().editJob(params.job_id)
                    ];
                case 1:
                    result = _state.sent();
                    params.setApiError(result.response);
                    if (result.data.is_editable || result.data.is_editable == undefined || params.router.query.job_type == "draft") {
                        params.router.push(link);
                    } else {
                        params.setjobEditModal([
                            "Open",
                            link
                        ]);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _editJob.apply(this, arguments);
}
function copyJob(params) {
    return _copyJob.apply(this, arguments);
}
function _copyJob() {
    _copyJob = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(params) {
        var duplicateJob, link;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params.closeAllJobsOptions();
                    return [
                        4,
                        new _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_1__/* .JobCommon */ .gW().duplicateJob(params.job_id)
                    ];
                case 1:
                    duplicateJob = _state.sent();
                    link = params.link.replace("$job_id", duplicateJob.data.id);
                    // var key          =   'jobs';
                    // var setPageName  =   params.setPageName;
                    // var queryClient  =   params.queryClient;
                    // goToNextPage(key, setPageName, queryClient, link);
                    params.router.push(link);
                    return [
                        2
                    ];
            }
        });
    });
    return _copyJob.apply(this, arguments);
}
function duplicateJob(params) {
    return _duplicateJob.apply(this, arguments);
}
function _duplicateJob() {
    _duplicateJob = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(params) {
        var duplicateJob, link;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params.from == "kanban" ? "" : params === null || params === void 0 ? void 0 : params.closeAllJobsOptions();
                    return [
                        4,
                        new _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_1__/* .JobCommon */ .gW().duplicateJob(params.job_id)
                    ];
                case 1:
                    duplicateJob = _state.sent();
                    link = params.link.replace("$job_id", duplicateJob.data.id);
                    // var key          =   'jobs';
                    // var setPageName  =   params.setPageName;
                    // var queryClient  =   params.queryClient;
                    // goToNextPage(key, setPageName, queryClient, link);
                    params.router.push(link);
                    return [
                        2
                    ];
            }
        });
    });
    return _duplicateJob.apply(this, arguments);
}
function promoteJob(params) {
    params.closeAllJobsOptions();
    var link = params.link.replace("$job_id", params.job_id);
    // var key          =   'jobs';
    // var setPageName  =   params.setPageName;
    // var queryClient  =   params.queryClient;
    // goToNextPage(key, setPageName, queryClient, link);
    params.router.push(link);
}
function copyJobUrl(params) {
    params.closeAllJobsOptions();
    var link = params.link.replace("$slug", params.slug);
    link = link.replace("$client_slug", params.client_slug);
    var proptocol = window.location.protocol;
    var host_arr = window.location.host.split(".");
    host_arr[0] = "jobs";
    var new_host = host_arr.join(".");
    link = proptocol + "//" + new_host + link;
    copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3___default()(link);
}
function closeJob(params) {
    return _closeJob.apply(this, arguments);
}
function _closeJob() {
    _closeJob = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(params) {
        var param_list, body, _tmp, _tmp1, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    param_list = params.router.query;
                    params.closeAllJobsOptions();
                    _tmp = {};
                    body = (_tmp["job"] = {
                        "close_job": true
                    }, _tmp);
                    return [
                        4,
                        new _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_1__/* .JobCommon */ .gW().closeJob(body, params.job_id)
                    ];
                case 1:
                    _state.sent();
                    _tmp1 = {};
                    return [
                        4,
                        params.setJobCloseModal((_tmp1.state = false, _tmp1))
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .getJobListingData */ .az(param_list, params.setApiError)
                    ];
                case 3:
                    result = _state.sent();
                    params.setJobList(result.data);
                    return [
                        2
                    ];
            }
        });
    });
    return _closeJob.apply(this, arguments);
}
function publishJob(params) {
    return _publishJob.apply(this, arguments);
}
function _publishJob() {
    _publishJob = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(params) {
        var ref, param_list, customToastrAction, publish_result, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    param_list = params.router.query;
                    customToastrAction = new _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .CustomToastrAction */ .Y5();
                    params.closeAllJobsOptions();
                    return [
                        4,
                        new _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_1__/* .JobCommon */ .gW().publishJob(params.job_id)
                    ];
                case 1:
                    publish_result = _state.sent();
                    if ((ref = publish_result.data) === null || ref === void 0 ? void 0 : ref.success) customToastrAction.setNormalToastr(publish_result.data.success, "success");
                    return [
                        4,
                        (0,_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .getJobListingData */ .az)(param_list, params.setApiError)
                    ];
                case 2:
                    result = _state.sent();
                    params.setJobList(result.data);
                    return [
                        2
                    ];
            }
        });
    });
    return _publishJob.apply(this, arguments);
}
function deleteJob(params) {
    return _deleteJob.apply(this, arguments);
}
function _deleteJob() {
    _deleteJob = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(params) {
        var ref, param_list, customToastrAction, destroy_result, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    param_list = params.router.query;
                    customToastrAction = new _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .CustomToastrAction */ .Y5();
                    params.closeAllJobsOptions();
                    return [
                        4,
                        new _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_1__/* .JobCommon */ .gW().destroyJob(params.job_id)
                    ];
                case 1:
                    destroy_result = _state.sent();
                    if ((ref = destroy_result.data) === null || ref === void 0 ? void 0 : ref.success) customToastrAction.setNormalToastr(destroy_result.data.success, "success");
                    return [
                        4,
                        (0,_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .getJobListingData */ .az)(param_list, params.setApiError)
                    ];
                case 2:
                    result = _state.sent();
                    params.setJobList(result.data);
                    return [
                        2
                    ];
            }
        });
    });
    return _deleteJob.apply(this, arguments);
}
function performJobAction(ActionName, params) {
    switch(ActionName){
        case "edit_job":
            editJob(params);
            break;
        case "duplicate_job":
            duplicateJob(params);
            break;
        case "promote":
            promoteJob(params);
            break;
        case "copy_job_url":
            copyJobUrl(params);
            break;
        case "close_job":
            // closeJob(params);
            params.setJobCloseModal({
                state: true,
                params: params
            });
            break;
        case "publish_job":
            publishJob(params);
            break;
        case "delete_job":
            deleteJob(params);
            break;
        case "copy_job":
            copyJob(params);
            break;
        default:
            "";
    }
}
function isPreviousUpdateBeforeTwoDays(days_data) {
    var isConditionValid = false;
    if (days_data != "" && days_data != undefined && days_data != null) {
        if (days_data.includes("days ago")) {
            var days_data = days_data.split("");
            isConditionValid = parseInt(days_data[0]) >= 2;
        }
    }
    return isConditionValid;
}


/***/ }),

/***/ 8704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ flipLane; }
/* harmony export */ });
function flipLane(event) {
    var lane = event.target.closest(".react-trello-lane");
    var backPage = lane.querySelector(".NormalLaneBack");
    var frontPage = lane.querySelector(".NormalLaneFront");
    if (lane.classList.contains("FlipBack")) {
        lane.classList.remove("FlipBack");
        sleep(500).then(function() {
            lane.style.padding = "10px";
            backPage.classList.remove("Show");
            backPage.classList.add("Hide");
            frontPage.style.display = "block";
            frontPage.classList.remove("Hide");
        });
    } else {
        lane.classList.add("FlipBack");
        sleep(500).then(function() {
            lane.style.padding = "0px";
            backPage.classList.add("Show");
            backPage.classList.remove("Hide");
            frontPage.style.display = "none";
            frontPage.classList.add("Hide");
        });
    }
}
function sleep(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
}


/***/ }),

/***/ 17523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ AddScorecardAction; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
;// CONCATENATED MODULE: ./src/constants/components/modals/add-scorecard-constant.js
var CONSTANT = {
    scorecard: {
        overall_feedback: "",
        score: "",
        score_hash: [
            {
                link: "",
                score: "",
                job_competency_id: "",
                job_competency_name: "",
                job_sub_competencies: [
                    {
                        job_sub_competency_id: "",
                        score: "",
                        job_sub_competency_name: ""
                    }
                ]
            }
        ],
        current_job_id: ""
    }
};

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
;// CONCATENATED MODULE: ./src/services/components/modal/add-scorecard-service.js







var AddScorecardService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(AddScorecardService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(AddScorecardService);
    function AddScorecardService() {
        (0,_class_call_check/* default */.Z)(this, AddScorecardService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(AddScorecardService, [
        {
            key: "addScorecard",
            value: function addScorecard(params, applicant_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(common/* API.client.applicant.SAVE_SCORECARD.replace */.bl.client.applicant.SAVE_SCORECARD.replace("$applicant_id", applicant_id), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AddScorecardService;
}(common/* SendRequest */.Lt);

// EXTERNAL MODULE: ./src/actions/common/application-filter.js
var application_filter = __webpack_require__(98766);
// EXTERNAL MODULE: ./public/icons/rating/1red.svg
var _1red = __webpack_require__(33644);
// EXTERNAL MODULE: ./public/icons/rating/2red.svg
var _2red = __webpack_require__(69588);
// EXTERNAL MODULE: ./public/icons/rating/1yellow.svg
var _1yellow = __webpack_require__(95585);
// EXTERNAL MODULE: ./public/icons/rating/2yellow.svg
var _2yellow = __webpack_require__(94468);
// EXTERNAL MODULE: ./public/icons/rating/3yellow.svg
var _3yellow = __webpack_require__(83917);
// EXTERNAL MODULE: ./public/icons/rating/1green.svg
var _1green = __webpack_require__(21993);
// EXTERNAL MODULE: ./public/icons/rating/2green.svg
var _2green = __webpack_require__(32020);
// EXTERNAL MODULE: ./public/icons/rating/3green.svg
var _3green = __webpack_require__(86307);
// EXTERNAL MODULE: ./public/icons/rating/4green.svg
var _4green = __webpack_require__(43731);
// EXTERNAL MODULE: ./public/icons/rating/5green.svg
var _5green = __webpack_require__(49364);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/rating1.svg
var rating1 = __webpack_require__(62199);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/rating2.svg
var rating2 = __webpack_require__(60498);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/rating3.svg
var rating3 = __webpack_require__(70880);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/rating4.svg
var rating4 = __webpack_require__(42876);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/rating5.svg
var rating5 = __webpack_require__(56795);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/sub-rating1.svg
var sub_rating1 = __webpack_require__(30327);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/sub-rating2.svg
var sub_rating2 = __webpack_require__(75818);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/sub-rating3.svg
var sub_rating3 = __webpack_require__(42307);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/sub-rating4.svg
var sub_rating4 = __webpack_require__(73589);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/sub-rating5.svg
var sub_rating5 = __webpack_require__(48542);
;// CONCATENATED MODULE: ./src/actions/components/modal/add-scorecard-action.js










// ---- RED ----


// // ---- RED ----
// ---- YELLOW ----



// // ---- YELLOW ----
// ---- GREEN ----





// // ---- GREEN ----
//





// Sub Competency Icons





var AddScorecardAction = /*#__PURE__*/ function() {
    "use strict";
    function AddScorecardAction(router) {
        (0,_class_call_check/* default */.Z)(this, AddScorecardAction);
        this.router = router;
        this.addScorecardService = new AddScorecardService();
        this.customToastrAction = new common/* CustomToastrAction */.Y5();
    }
    (0,_create_class/* default */.Z)(AddScorecardAction, [
        {
            key: "submitForm",
            value: function submitForm(values, setShowScorecardPopup, setFlagForRerender, props, setSubmitButtonDisabled, hideAddScorecard, setShowLoader) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var applicant_id, filterData, result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setSubmitButtonDisabled(true);
                                setShowLoader(true);
                                applicant_id = _this.router.query.applicant_id;
                                if (props.from == "application_view") {
                                    values.kanban = {
                                        candidate_index: props.candidateIndex,
                                        base_stage_id: props.paramStageId
                                    };
                                    filterData = (0,application_filter/* ApplicationFilter */.i)(values.current_job_id);
                                    if (filterData) {
                                        values.application_filter_data = filterData;
                                    }
                                }
                                return [
                                    4,
                                    _this.addScorecardService.addScorecard(values, applicant_id)
                                ];
                            case 1:
                                result = _state.sent();
                                if (!((result === null || result === void 0 ? void 0 : result.status) == 200)) return [
                                    3,
                                    3
                                ];
                                _this.customToastrAction.setNormalToastr(result.data.success, "success");
                                props.initialData.application.scorecard_value = result.data.overall_score;
                                props.initialData.application.overall_score = result.data.overall_score;
                                props.initialData.scorecards = result.data.scorecards;
                                props.initialData.add_scorecard = result.data.add_scorecard;
                                setShowScorecardPopup(false);
                                hideAddScorecard();
                                return [
                                    4,
                                    props.setInitialData(result.data)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _this.customToastrAction.setNormalToastr(result.response.data.error, "warning");
                                _state.label = 4;
                            case 4:
                                /*setFlagForRerender(Math.random()*1000);*/ setShowLoader(false);
                                setSubmitButtonDisabled(false);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setFormInitialValues",
            value: function setFormInitialValues(formData, index) {
                var ref;
                var scorecard_score_hash = [];
                var type = typeof index != "undefined" ? "edit" : "create";
                if (type == "create") {
                    if (!formData.scorecard_link) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = formData.competencies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var element = _step.value;
                                var sub_hash = "";
                                var form_hash = {
                                    "job_competency_id": element.job_competency_id,
                                    "score": "",
                                    "info": "",
                                    "job_sub_competencies": [],
                                    "job_competency_name": element.job_competency_name,
                                    "job_competency_notes": element.job_competency_notes
                                };
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = element.job_sub_competency_names[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var sub_competency = _step1.value;
                                        sub_hash = {
                                            "job_sub_competency_id": sub_competency.job_sub_competency_id,
                                            "score": "",
                                            "info": "",
                                            "job_sub_competency_name": sub_competency.job_sub_competency_name,
                                            "job_sub_competency_notes": sub_competency.job_sub_competency_notes
                                        };
                                        form_hash.job_sub_competencies.push(sub_hash);
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                scorecard_score_hash.push(form_hash);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    } else {
                        var form_hash1 = {
                            "score": "",
                            "link": ""
                        };
                        scorecard_score_hash.push(form_hash1);
                    }
                } else {
                    if (formData.scorecards[index].score_hash.length > 0) {
                        scorecard_score_hash = formData.scorecards[index].score_hash;
                    } else {
                        if (!formData.scorecard_link) {
                            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            try {
                                for(var _iterator2 = formData.competencies[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    var element1 = _step2.value;
                                    var sub_hash1 = "";
                                    var form_hash2 = {
                                        "job_competency_id": element1.job_competency_id,
                                        "score": "",
                                        "info": "",
                                        "job_sub_competencies": [],
                                        "job_competency_name": element1.job_competency_name,
                                        "job_competency_notes": element1.job_competency_notes
                                    };
                                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                                    try {
                                        for(var _iterator3 = element1.job_sub_competency_names[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                            var sub_competency1 = _step3.value;
                                            sub_hash1 = {
                                                "job_sub_competency_id": sub_competency1.job_sub_competency_id,
                                                "score": "",
                                                "job_sub_competency_name": sub_competency1.job_sub_competency_name,
                                                "job_sub_competency_notes": sub_competency1.job_sub_competency_notes
                                            };
                                            form_hash2.job_sub_competencies.push(sub_hash1);
                                        }
                                    } catch (err) {
                                        _didIteratorError3 = true;
                                        _iteratorError3 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                                _iterator3.return();
                                            }
                                        } finally{
                                            if (_didIteratorError3) {
                                                throw _iteratorError3;
                                            }
                                        }
                                    }
                                    scorecard_score_hash.push(form_hash2);
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        } else {
                            var form_hash3 = {
                                "score": "",
                                "link": ""
                            };
                            scorecard_score_hash.push(form_hash3);
                        }
                    }
                }
                CONSTANT.scorecard.empty = ""; // TO Print empty text area in download pdf
                CONSTANT.scorecard.score_hash = scorecard_score_hash;
                CONSTANT.scorecard.overall_feedback = ((ref = formData.scorecards[index]) === null || ref === void 0 ? void 0 : ref.overall_feedback) || "";
                CONSTANT.current_job_id = this.router.query.job_id;
                return CONSTANT;
            }
        },
        {
            key: "addComment",
            value: function addComment(formik, setComment, index) {
                var ref, ref1;
                var heading = ((ref = formik.values.scorecard.score_hash[index]) === null || ref === void 0 ? void 0 : ref.info) && ((ref1 = formik.values.scorecard.score_hash[index]) === null || ref1 === void 0 ? void 0 : ref1.info) != "" ? "Edit Comment" : "Add Comment";
                setComment({
                    status: true,
                    index: index,
                    heading: heading,
                    submitButtonAction: this.submitCommentSection
                });
            }
        },
        {
            key: "submitCommentSection",
            value: function submitCommentSection(params) {
                if (params.formik) {
                    params.formik.setFieldValue(params.name, params.value);
                }
                params.setModal({
                    status: false,
                    heading: "",
                    index: params === null || params === void 0 ? void 0 : params.index,
                    submitButtonAction: ""
                });
            }
        },
        {
            key: "setColorClass",
            value: function setColorClass(value) {
                var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "competency";
                if (type == "competency") {
                    var scoreValue = parseFloat(value);
                    if (scoreValue == NaN) return "RedBg";
                    else if (scoreValue <= 2) return "RedBg";
                    else if (scoreValue > 2 && scoreValue < 4) return "YellowBg";
                    else if (scoreValue >= 4) return "GreenBg";
                    else return "RedBg";
                } else {
                    return "Default";
                }
            }
        },
        {
            key: "isNotesPresent",
            value: function isNotesPresent(competency_id, competencies) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = competencies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var competency = _step.value;
                        if (competency.job_competency_id == competency_id && competency.job_competency_notes && competency.job_competency_notes != "") {
                            return true;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            key: "getNotesData",
            value: function getNotesData(competency_id, competencies) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = competencies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var competency = _step.value;
                        if (competency.job_competency_id == competency_id && competency.job_competency_notes && competency.job_competency_notes != "") {
                            return competency.job_competency_notes;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            // --------------------------
            key: "colorHoverRatingSymbolArray",
            value: function colorHoverRatingSymbolArray(value, name) {
                var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "subcompetency_color", selected_score_value = arguments.length > 3 ? arguments[3] : void 0;
                var _this = this;
                var fill_ratings = document.querySelectorAll(".".concat(name, " .FillRating"));
                var empty_ratings = document.querySelectorAll(".".concat(name, " .EmptyRating"));
                value = typeof value == "undefined" ? selected_score_value : value;
                fill_ratings.forEach(function(rating, index) {
                    if (index < value) {
                        if (type == "competency_color") {
                            rating.classList.remove("RedBg");
                            rating.classList.remove("YellowBg");
                            rating.classList.remove("GreenBg");
                            rating.classList.remove("Default");
                            // rating.classList.add(this.setColorClass(value));
                            var empty_rating = empty_ratings[index];
                            empty_rating.classList.remove("RedBg");
                            empty_rating.classList.remove("YellowBg");
                            empty_rating.classList.remove("GreenBg");
                            empty_rating.classList.remove("Default");
                        // empty_rating.classList.add(this.setColorClass(value));
                        } else {
                            rating.classList.remove("RedBg");
                            rating.classList.remove("YellowBg");
                            rating.classList.remove("GreenBg");
                            rating.classList.remove("Default");
                            var empty_rating1 = empty_ratings[index];
                            empty_rating1.classList.remove("RedBg");
                            empty_rating1.classList.remove("YellowBg");
                            empty_rating1.classList.remove("GreenBg");
                            empty_rating1.classList.remove("Default");
                        }
                    } else {
                        rating.classList.remove("RedBg");
                        rating.classList.remove("YellowBg");
                        rating.classList.remove("GreenBg");
                        rating.classList.remove("Default");
                        // rating.classList.add('Default');
                        var empty_rating2 = empty_ratings[index];
                        empty_rating2.classList.remove("RedBg");
                        empty_rating2.classList.remove("YellowBg");
                        empty_rating2.classList.remove("GreenBg");
                        empty_rating2.classList.remove("Default");
                    // empty_rating.classList.add('Default');
                    }
                    var svg = rating.querySelector("svg");
                    if (index < value) {
                        if (type == "subcompetency_color") {
                            var empty_svg = empty_ratings[index].querySelector("svg");
                            // this.setDefultFilledColor(svg);
                            // this.setDefultFilledColor(empty_svg);
                            _this.setCompetencyColor(svg, value);
                            _this.setCompetencyColor(empty_svg, value);
                        } else {
                            var empty_svg1 = empty_ratings[index].querySelector("svg");
                            _this.setCompetencyColor(svg, value);
                            _this.setCompetencyColor(empty_svg1, value);
                        }
                    } else {
                        var empty_svg2 = empty_ratings[index].querySelector("svg");
                        _this.setDefultColor(empty_svg2, type);
                        _this.setDefultColor(svg, type);
                    }
                });
            }
        },
        {
            key: "setColor",
            value: function setColor(value) {
                var redColor = "var(--default-error-color)";
                var yellowColor = "var(--default-yellow-color)";
                var greenColor = "var(--default-success-color)";
                switch(value){
                    case 1:
                        return redColor;
                    case 2:
                        return redColor;
                    case 3:
                        return yellowColor;
                    case 4:
                        return greenColor;
                    case 5:
                        return greenColor;
                    default:
                        return redColor;
                }
            }
        },
        {
            key: "onChangeRating",
            value: function onChangeRating(name, formik, value, field_name, type) {
                var _this = this;
                formik.setFieldValue(name, value);
                var fill_ratings = document.querySelectorAll(".".concat(field_name, " .FillRating"));
                // let empty_ratings = document.querySelectorAll(`.${field_name} .EmptyRating`);
                fill_ratings.forEach(function(rating, index) {
                    rating.classList.remove("RedBg");
                    rating.classList.remove("YellowBg");
                    rating.classList.remove("GreenBg");
                    // rating.classList.add(this.setColorClass(value));
                    var svg = rating.querySelector("svg");
                    if (index < value) {
                        _this.setCompetencyColor(svg, value);
                    } else {
                        var fill_svg = fill_ratings[index].querySelector("svg");
                        _this.setDefultColor(fill_svg, type);
                    }
                });
            }
        },
        {
            key: "setCompetencyColor",
            value: function setCompetencyColor(svg, value) {
                var rect = svg.querySelector("rect");
                var path = svg.querySelector("path");
                var color = this.setColor(value);
                // svg.setAttribute('fill','none');
                // svg.style.backgroundColor = color;
                // rect.setAttribute('stroke',color);
                rect.setAttribute("fill", color);
                path.setAttribute("fill", "#E7EBEE");
            }
        },
        {
            key: "setDefultColor",
            value: function setDefultColor(svg, type) {
                var rect = svg.querySelector("rect");
                var path = svg.querySelector("path");
                // let color = "#99ADBD";
                var color = type == "subcompetency_color" ? "var(--default-primary-color)" : "#E7EBEE";
                // svg.setAttribute('fill','none');
                // svg.style.backgroundColor = type == 'subcompetency_color' ? 'var(--default-primary-color)' : '#E7EBEE';
                // rect.setAttribute('stroke',color);
                rect.setAttribute("fill", color);
                // rect.setAttribute('height', 56);
                // rect.setAttribute('width', 100);
                // rect.setAttribute('stroke-width', '2');
                // rect.setAttribute('x', 1);
                // rect.setAttribute('y', 1);
                path.setAttribute("fill", "var(--default-secondary-color)");
            }
        },
        {
            key: "setDefultFilledColor",
            value: function setDefultFilledColor(svg) {
                var rect = svg.querySelector("rect");
                var path = svg.querySelector("path");
                var color = "#99ADBD";
                svg.setAttribute("fill", "none");
                svg.style.backgroundColor = color;
                rect.setAttribute("stroke", color);
                rect.setAttribute("fill", "none");
                rect.setAttribute("height", 24);
                rect.setAttribute("width", 25);
                rect.setAttribute("stroke-width", "2");
                rect.setAttribute("x", 1);
                rect.setAttribute("y", 1);
                path.setAttribute("fill", "#E7EBEE");
            }
        },
        {
            key: "calculateOverallScore",
            value: function calculateOverallScore(sub_competencies) {
                var competency_score = 0;
                var total = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = sub_competencies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        competency_score = competency_score + parseFloat(element.score || 0);
                        if (element.score != 0 && element.score != "") {
                            total = total + 1;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (total == 0) return 0;
                competency_score = competency_score / total;
                return Number.isInteger(competency_score) ? competency_score : competency_score.toFixed(1);
            // return competency_score.slice(0, (competency_score.indexOf(".")) + 2);
            }
        },
        {
            key: "getOverallScoreColor",
            value: function getOverallScoreColor(sub_competencies) {
                var value = this.calculateOverallScore(sub_competencies);
                var scoreValue = parseFloat(value);
                if (scoreValue == NaN) return "RedBg";
                else if (scoreValue <= 2) return "RedBg";
                else if (scoreValue > 2 && scoreValue < 4) return "YellowBg";
                else if (scoreValue >= 4) return "GreenBg";
                else return "GreenBg";
            }
        },
        {
            key: "initalArray",
            value: function initalArray(value, type) {
                var scoreValue = parseFloat(value);
                if (scoreValue == NaN) return type == "subcompetency" ? [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating1/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating2/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating3/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating4/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating5/* default */.Z, {})
                ] : [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rating1/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rating2/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rating3/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rating4/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rating5/* default */.Z, {})
                ];
                else if (scoreValue <= 2) return type == "subcompetency" ? [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_1red/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_2red/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating3/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating4/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating5/* default */.Z, {})
                ] : [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_1red/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_2red/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rating3/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rating4/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rating5/* default */.Z, {})
                ];
                else if (scoreValue > 2 && scoreValue < 4) return type == "subcompetency" ? [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_1yellow/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_2yellow/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_3yellow/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating4/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating5/* default */.Z, {})
                ] : [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_1yellow/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_2yellow/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_3yellow/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rating4/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rating5/* default */.Z, {})
                ];
                else if (scoreValue >= 4) return type == "subcompetency" ? [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_1green/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_2green/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_3green/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_4green/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_5green/* default */.Z, {})
                ] : [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_1green/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_2green/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_3green/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_4green/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_5green/* default */.Z, {})
                ];
                else return type == "subcompetency" ? [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating1/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating2/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating3/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating4/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating5/* default */.Z, {})
                ] : [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rating1/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rating2/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rating3/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rating4/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rating5/* default */.Z, {})
                ];
            }
        }
    ]);
    return AddScorecardAction;
}();


/***/ }),

/***/ 75868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ ActionShareCv; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(38641);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(18186);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/styles/components/share-cv/_index.module.scss
var _index_module = __webpack_require__(2443);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/services/pages/clients/jobs/interview-stages.js
var interview_stages = __webpack_require__(42465);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/imports-files/pages/admins/logout.js + 1 modules
var logout = __webpack_require__(63281);
;// CONCATENATED MODULE: ./src/services/pages/clients/jobs/job-share-cv.js








var JobShareCV = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(JobShareCV, SendRequest);
    var _super = (0,_create_super/* default */.Z)(JobShareCV);
    function JobShareCV() {
        (0,_class_call_check/* default */.Z)(this, JobShareCV);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(JobShareCV, [
        {
            key: "sendCV",
            value: function sendCV(params, applicant_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(common/* API.client.applicant.SHARE_CV.replace */.bl.client.applicant.SHARE_CV.replace("$applicant_id", applicant_id), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return JobShareCV;
}(logout/* SendRequest */.Lt);

;// CONCATENATED MODULE: ./src/services/pages/clients/candidates/candidate-job-share-cv.js








var CandidateShareCV = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(CandidateShareCV, SendRequest);
    var _super = (0,_create_super/* default */.Z)(CandidateShareCV);
    function CandidateShareCV() {
        (0,_class_call_check/* default */.Z)(this, CandidateShareCV);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CandidateShareCV, [
        {
            key: "sendCV",
            value: function sendCV(params, candidate_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(common/* API.client.applicant.CANDIDATE_SHARE_CV.replace */.bl.client.applicant.CANDIDATE_SHARE_CV.replace("$candidate_id", candidate_id), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CandidateShareCV;
}(logout/* SendRequest */.Lt);

;// CONCATENATED MODULE: ./src/actions/components/share-cv.js














var ActionShareCv = /*#__PURE__*/ function() {
    "use strict";
    function ActionShareCv(setValue, setSuggestion) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, ActionShareCv);
        (0,_define_property/* default */.Z)(this, "getSuggestionValue", function(suggestion) {
            return suggestion.user_attributes.name || suggestion.user_attributes.email;
        });
        (0,_define_property/* default */.Z)(this, "renderSuggestion", function(suggestion) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    " ",
                    suggestion.user_attributes.name || suggestion.user_attributes.email
                ]
            });
        });
        var _this1 = this;
        (0,_define_property/* default */.Z)(this, "onSuggestionsFetchRequested", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
                var suggestion;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this1.getSuggestions(value)
                            ];
                        case 1:
                            suggestion = _state.sent();
                            _this1.setSuggestion(suggestion);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(value) {
                return _ref.apply(this, arguments);
            };
        }());
        (0,_define_property/* default */.Z)(this, "onSuggestionsClearRequested", function() {
            _this.setSuggestion([]);
        });
        this.setValue = setValue;
        this.setSuggestion = setSuggestion;
        this.customToastrAction = new common/* CustomToastrAction */.Y5();
    }
    (0,_create_class/* default */.Z)(ActionShareCv, [
        {
            key: "getSuggestions",
            value: function getSuggestions(param) {
                var value = param.value;
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var escapedValue, body, _tmp, finalUsers;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                escapedValue = _this.escapeRegexCharacters(value === null || value === void 0 ? void 0 : value.trim());
                                if (escapedValue === "") {
                                    return [
                                        2,
                                        []
                                    ];
                                }
                                _tmp = {};
                                body = (_tmp.name_or_email = escapedValue, _tmp);
                                return [
                                    4,
                                    new interview_stages/* InterviewStage */.P().getUserByNameOrEmail(body)
                                ];
                            case 1:
                                finalUsers = _state.sent();
                                return [
                                    2,
                                    finalUsers.data.users
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "escapeRegexCharacters",
            value: function escapeRegexCharacters(str) {
                return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            }
        },
        {
            key: "shouldRenderSuggestions",
            value: function shouldRenderSuggestions(value) {
                return value.trim().length >= 3;
            }
        },
        {
            key: "renderInputComponent",
            value: function renderInputComponent(inputProps) {
                var selectedToValues = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], setSelectedToValues = arguments.length > 2 ? arguments[2] : void 0, setSelectedToUserCount = arguments.length > 3 ? arguments[3] : void 0, setToValue = arguments.length > 4 ? arguments[4] : void 0;
                var ref;
                // return(<div className="buttonIn ShareCV">
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "buttonIn AutoSuggestInput__Tags",
                    style: inputProps.styleError,
                    children: [
                        (ref = inputProps.selectedValues) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (_index_module_default()).SetupPopup__Tags,
                                children: [
                                    item.name ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: item.name
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: item.email
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        className: (_index_module_default()).Tagrow__Cancel,
                                        onClick: function(event) {
                                            return inputProps.removeSelectedValues(event, inputProps.selectedValues, inputProps.setSelectedValues, inputProps.setSelectedUserCount);
                                        },
                                        "data-index": index,
                                        children: inputProps.closeIcon
                                    })
                                ]
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                            className: (_index_module_default()).Form__Input,
                            autoComplete: "password"
                        }, inputProps))
                    ]
                });
            }
        },
        {
            key: "onAddClick",
            value: function onAddClick(event, params, selectedToValues, setSelectedToValues, setSelectedToUserCount, setToValue) {
                event.preventDefault();
                var email = params.value;
                if (this.isEmail(email)) {
                    email = typeof email == "string" ? {
                        email: email,
                        name: email
                    } : email;
                    this.onSuggestionSelectionEmail(email, selectedToValues, setSelectedToValues, setToValue, setSelectedToUserCount, params.formik);
                } else {
                    email == "" ? params.formik.setStatus({
                        "email": {
                            "to": "Required"
                        }
                    }) : params.formik.setStatus({
                        "email": {
                            "to": "Please enter valid email"
                        }
                    });
                    params.formik.setFieldTouched("email.to", true);
                }
            }
        },
        {
            key: "removeSelectedValues",
            value: function removeSelectedValues(event, selectedValues, setSelectedValues, setSelectedUserCount) {
                var selected_value_index = parseInt(event.currentTarget.getAttribute("data-index"));
                selectedValues.splice(selected_value_index, 1);
                setSelectedValues(selectedValues);
                setSelectedUserCount(selectedValues.length);
            }
        },
        {
            key: "onSuggestionSelectionEmail",
            value: function onSuggestionSelectionEmail(value, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik) {
                this.add_selected_value_email(value, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik);
            }
        },
        {
            key: "onSuggestionSelectionValue",
            value: function onSuggestionSelectionValue(value, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik) {
                this.add_selected_value(value, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik);
            }
        },
        {
            key: "handleKeyDown",
            value: function handleKeyDown(evt, selectedValues, setSelectedValues, setSelectedUserCount, setValue, formik) {
                if ([
                    "Enter"
                ].includes(evt.key)) {
                    var k_this = this;
                    setTimeout(function() {
                        evt.preventDefault();
                        var email = evt.target.value;
                        if (k_this.isEmail(email)) {
                            k_this.add_selected_value({
                                email: email,
                                name: email
                            }, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik);
                        }
                    }, 0);
                }
                ;
            }
        },
        {
            key: "add_default_selected_value_email",
            value: function add_default_selected_value_email(values, selectedValues, setSelectedValues, setValue, setSelectedUserCount) {
                var emails = [];
                if (typeof selectedValues == "undefined") {
                    selectedValues = [];
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = selectedValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        emails.push(element.email);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var value = _step1.value;
                        if (!emails.includes(value.email)) {
                            selectedValues.push(value);
                            setValue("");
                            setSelectedValues(selectedValues);
                            setSelectedUserCount(selectedValues.length);
                        } else if (emails.includes(value.email)) {
                            setValue("");
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "add_selected_value_email",
            value: function add_selected_value_email(value, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik) {
                var emails = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = selectedValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        emails.push(element.email);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (!emails.includes(value.email)) {
                    selectedValues.push(value);
                    setValue("");
                    setSelectedValues(selectedValues);
                    setSelectedUserCount(selectedValues.length);
                } else if (emails.includes(value.email)) {
                    setValue("");
                }
            }
        },
        {
            key: "add_selected_value",
            value: function add_selected_value(value, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik) {
                var emails = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = selectedValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        emails.push(element.email);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (!emails.includes(value.email)) {
                    selectedValues.push(value);
                    setValue("");
                    setSelectedValues(selectedValues);
                    setSelectedUserCount(selectedValues.length);
                } else if (emails.includes(value.email)) {
                    setValue("");
                }
            }
        },
        {
            key: "isEmail",
            value: function isEmail(email) {
                return /^[^\s@]+@[^\s@]+\.[^\s@\.]+$/.test(email);
            }
        },
        {
            key: "submitCandidateShareForm",
            value: function submitCandidateShareForm(router, formik, selectedValues, setApiError, setButtonPopup, setSelectedValues, t) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var emails, is_candidate_general_profile, entity_id, entity_type, body, _tmp, result, _tmp1, _tmp2;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                emails = _this.getEmails(selectedValues);
                                if (!(selectedValues.length > 0)) return [
                                    3,
                                    4
                                ];
                                is_candidate_general_profile = router.asPath.includes("/clients/candidates/") && router.asPath.includes("/view-profile");
                                entity_id = is_candidate_general_profile ? router.query.candidate_id : router.query.applicant_id;
                                entity_type = is_candidate_general_profile ? "ClientCandidate" : "JobApplication";
                                _tmp = {};
                                body = (_tmp.candidate_share = {
                                    member_emails: emails,
                                    note: formik.values.title_note,
                                    entity_id: entity_id,
                                    entity_type: entity_type
                                }, _tmp);
                                if (!is_candidate_general_profile) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    new CandidateShareCV().sendCV(body, entity_id)
                                ];
                            case 1:
                                _tmp1 = _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                _tmp1 = new JobShareCV().sendCV(body, entity_id);
                                _state.label = 3;
                            case 3:
                                result = _tmp1;
                                result.request.status != 200 ? setApiError(result.request) : setButtonPopup(false);
                                setSelectedValues([]);
                                if (result.request.status == 200) {
                                    _this.customToastrAction.setNormalToastr(result.data.success, "success");
                                } else {
                                    _this.customToastrAction.setNormalToastr(result.response.data.error, "error");
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                formik.touched["share_with"] = true;
                                _tmp2 = {};
                                formik.setStatus((_tmp2.share_with = t("errors:existing_user_suggestions"), _tmp2));
                                _state.label = 5;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "submitJobShareForm",
            value: function submitJobShareForm(router, formik, selectedValues, setApiError, setButtonPopup, setSelectedValues, t) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var emails, is_candidate_general_profile, entity_id, entity_type, body, _tmp, result, _tmp1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                emails = _this.getEmails(selectedValues);
                                if (!(selectedValues.length > 0)) return [
                                    3,
                                    2
                                ];
                                is_candidate_general_profile = router.asPath.includes("/clients/candidates/") && router.asPath.includes("/view-profile");
                                entity_id = is_candidate_general_profile ? router.query.candidate_id : router.query.applicant_id;
                                entity_type = is_candidate_general_profile ? "ClientCandidate" : "JobApplication";
                                _tmp = {};
                                body = (_tmp.candidate_share = {
                                    member_emails: emails,
                                    note: formik.values.title_note,
                                    entity_id: entity_id,
                                    entity_type: entity_type
                                }, _tmp);
                                return [
                                    4,
                                    new JobShareCV().sendCV(body, entity_id)
                                ];
                            case 1:
                                result = _state.sent();
                                result.request.status != 200 ? setApiError(result.request) : setButtonPopup(false);
                                setSelectedValues([]);
                                if (result.request.status == 200) {
                                    _this.customToastrAction.setNormalToastr(result.data.success, "success");
                                } else {
                                    _this.customToastrAction.setNormalToastr(result.response.data.error, "error");
                                }
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                formik.touched["share_with"] = true;
                                _tmp1 = {};
                                formik.setStatus((_tmp1.share_with = t("errors:existing_user_suggestions"), _tmp1));
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getEmails",
            value: function getEmails(values) {
                var emails = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        emails.push(element.email);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return emails;
            }
        }
    ]);
    return ActionShareCv;
}();



/***/ }),

/***/ 88161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ej": function() { return /* binding */ onAdminUserRemove; },
/* harmony export */   "I6": function() { return /* binding */ handelFileChange; },
/* harmony export */   "Yk": function() { return /* binding */ onAdminUserAdd; },
/* harmony export */   "dl": function() { return /* binding */ getClientData; },
/* harmony export */   "uJ": function() { return /* binding */ roles; },
/* harmony export */   "x0": function() { return /* binding */ handleOnSubmit; }
/* harmony export */ });
/* unused harmony exports clientRoles, remove_blank_formik_fields */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32510);



function handleOnSubmit(values, router, queryClient, setApiError) {
    return _handleOnSubmit.apply(this, arguments);
}
function _handleOnSubmit() {
    _handleOnSubmit = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(values, router, queryClient, setApiError) {
        var path, result1, status_code, customToastrAction, response, link, ref, ref1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    path = new _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_0__/* .DataFromUrl */ .QJ().getClientId();
                    return [
                        4,
                        new _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_0__/* .AddUsers */ .FZ().createNewClientUser(values, path)
                    ];
                case 1:
                    result1 = _state.sent();
                    setApiError(result1.request);
                    status_code = result1.status || result1.response.status;
                    customToastrAction = new _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_0__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_0__/* .SUCCESS_REPONSE_CODE */ .Us:
                            return [
                                3,
                                2
                            ];
                        case _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_0__/* .UNAUTHORIZED_REPONSE_CODE */ .t9:
                            return [
                                3,
                                5
                            ];
                        case _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_0__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        7
                    ];
                case 2:
                    response = result1.data;
                    if (!response.success) return [
                        3,
                        4
                    ];
                    link = _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT.admins.dashboard.clients.integration.replace */ .RQ.admins.dashboard.clients.integration.replace("$client_id", response.slug);
                    router.push(link);
                    // goToNextPage('integrations', setPageName, queryClient, link);
                    return [
                        4,
                        queryClient.removeQueries("add-user-data")
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        8
                    ];
                case 5:
                    customToastrAction.setNormalToastr(result1.response.data.error, "warning");
                    // toastr.warning(result.response.data.error);
                    return [
                        3,
                        8
                    ];
                case 6:
                    if ((ref = result1.response.data.error.client) === null || ref === void 0 ? void 0 : ref.base) {
                        ;
                        customToastrAction.setNormalToastr((ref1 = result1.response.data.error.client) === null || ref1 === void 0 ? void 0 : ref1.base, "warning");
                    // toastr.warning(result.response.data.error.client?.base);
                    }
                    return [
                        2,
                        result1.response.data.error
                    ];
                case 7:
                    (0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_0__/* .handleOtherResponseCode */ .GB)(status_code, router);
                    _state.label = 8;
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return _handleOnSubmit.apply(this, arguments);
}
function onAdminUserAdd() {
    return _onAdminUserAdd.apply(this, arguments);
}
function _onAdminUserAdd() {
    _onAdminUserAdd = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var _len, args, _key, ref, formik, action, setAdminCount, queryClient, client_users_attributes, client, _tmp, _tmp1, records_length;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = _arguments[_key];
                    }
                    formik = (ref = args[0]) === null || ref === void 0 ? void 0 : ref.current;
                    action = args[1];
                    setAdminCount = args[2];
                    queryClient = args[3];
                    client_users_attributes = formik.values.client.client_users_attributes;
                    client = formik.values.client;
                    _tmp = {};
                    // ---------------------------- Initialization ------------------------------
                    client_users_attributes.push((_tmp.role_id = "", _tmp.status_id = "", _tmp._destroy = false, _tmp.deletable = true, _tmp.user_attributes = {
                        name: "",
                        email: ""
                    }, _tmp));
                    _tmp1 = {};
                    // formik.current.setValues({client, client_users_attributes});
                    formik.setValues((_tmp1.client = client, _tmp1.client_users_attributes = client_users_attributes, _tmp1));
                    records_length = client_users_attributes.map(function(element) {
                        return element._destroy == false;
                    }).filter(function(element) {
                        return element == true;
                    }).length;
                    return [
                        4,
                        queryClient.setQueryData("add-user-data", client_users_attributes)
                    ];
                case 1:
                    _state.sent();
                    setAdminCount(records_length);
                    return [
                        2
                    ];
            }
        });
    });
    return _onAdminUserAdd.apply(this, arguments);
}
function onAdminUserRemove() {
    return _onAdminUserRemove.apply(this, arguments);
}
function _onAdminUserRemove() {
    _onAdminUserRemove = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var _len, args, _key, formik, action, setAdminCount, index, queryClient, client_users_attributes, client, _tmp, records_length;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = _arguments[_key];
                    }
                    formik = args[0];
                    action = args[1];
                    setAdminCount = args[2];
                    index = args[3] != undefined ? args[3] : "";
                    queryClient = args[4];
                    client_users_attributes = formik.values.client.client_users_attributes;
                    client = formik.values.client;
                    // ---------------------------- Initialization ------------------------------
                    client_users_attributes[index]["_destroy"] = true;
                    _tmp = {};
                    // formik.current.setValues({client, client_users_attributes});
                    formik.setValues((_tmp.client = client, _tmp.client_users_attributes = client_users_attributes, _tmp));
                    records_length = client_users_attributes.map(function(element) {
                        return element._destroy == false;
                    }).filter(function(element) {
                        return element == true;
                    }).length;
                    return [
                        4,
                        queryClient.setQueryData("add-user-data", client_users_attributes)
                    ];
                case 1:
                    _state.sent();
                    setAdminCount(records_length);
                    return [
                        2
                    ];
            }
        });
    });
    return _onAdminUserRemove.apply(this, arguments);
}
function clientRoles(client_auth_cookies, setApiError) {
    return _clientRoles.apply(this, arguments);
}
function _clientRoles() {
    _clientRoles = _async_to_generator(function(client_auth_cookies, setApiError) {
        var ref, results, data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new AddUsers().getClientUserRoles(client_auth_cookies)
                    ];
                case 1:
                    results = _state.sent();
                    setApiError(result.request);
                    data = [];
                    results === null || results === void 0 ? void 0 : (ref = results.data) === null || ref === void 0 ? void 0 : ref.roles.map(function(values, index) {
                        data.push({
                            value: values.id,
                            label: values.display_name
                        });
                    });
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return _clientRoles.apply(this, arguments);
}
function roles(setApiError) {
    return _roles.apply(this, arguments);
}
function _roles() {
    _roles = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(setApiError) {
        var ref, results, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_0__/* .AddUsers */ .FZ().getUserRoles()
                    ];
                case 1:
                    results = _state.sent();
                    setApiError(results.request);
                    data = [];
                    results === null || results === void 0 ? void 0 : (ref = results.data) === null || ref === void 0 ? void 0 : ref.roles.map(function(values, index) {
                        data.push({
                            value: values.id,
                            label: values.display_name
                        });
                    });
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return _roles.apply(this, arguments);
}
function handelFileChange(data, formik, setAdminCount, userRoles, queryClient, fileInfo) {
    return _handelFileChange.apply(this, arguments);
}
function _handelFileChange() {
    _handelFileChange = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data, formik, setAdminCount, userRoles, queryClient, fileInfo) {
        var fileSize, csvValid, client_users_attributes, client, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, user, role_id, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    fileSize = fileSizeValid(fileInfo);
                    csvValid = isCSVFileValid(data, userRoles);
                    if (!!(fileSize && csvValid)) return [
                        3,
                        1
                    ];
                    return [
                        2,
                        false
                    ];
                case 1:
                    client_users_attributes = formik.current.values.client.client_users_attributes;
                    client = formik.current.values.client;
                    // ---------------------------- Initialization ------------------------------
                    data.length > 0 ? remove_blank_formik_fields(formik, client, client_users_attributes, setAdminCount) : "";
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _tmp = {};
                    try {
                        for(_iterator = data[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            user = _step.value;
                            role_id = userRoles.findIndex(function(obj) {
                                return obj.label === user.role;
                            });
                            client_users_attributes.push((_tmp.role_id = userRoles[role_id].value, _tmp._destroy = false, _tmp.deletable = true, _tmp.user_attributes = {
                                name: user.name,
                                email: user.email
                            }, _tmp));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    _tmp1 = {};
                    formik.current.setTouched((_tmp1.client = client, _tmp1.client_users_attributes = client_users_attributes, _tmp1));
                    setAdminCount(client_users_attributes.length);
                    return [
                        4,
                        queryClient.setQueryData("add-user-data", client_users_attributes)
                    ];
                case 2:
                    _state.sent();
                    document.getElementById("react-csv-reader-input").value = null;
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _handelFileChange.apply(this, arguments);
}
// INFO:- This function will removes the blank fields which are not filled yet
function remove_blank_formik_fields(formik, client, client_users_attributes, setAdminCount) {
    for(var index = client_users_attributes.length - 1; index >= 0; index--){
        if (client_users_attributes[index].role_id == "" && client_users_attributes[index].user_attributes.name == "" && client_users_attributes[index].user_attributes.email == "") {
            client_users_attributes.splice(index, 1);
        } else {
            break;
        }
    }
    // set the formik schema and re render it by changing the state
    formik.current.setValues({
        client: client,
        client_users_attributes: client_users_attributes
    });
    setAdminCount(client_users_attributes.length);
}
function getClientData(setApiError) {
    return _getClientData.apply(this, arguments);
}
function _getClientData() {
    _getClientData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(setApiError) {
        var client_id, result1, client, data, _tmp, _tmp1, role_ids;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client_id = new _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_0__/* .DataFromUrl */ .QJ().getClientId();
                    return [
                        4,
                        new _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_0__/* .EditClient */ .N4().getClientInfo(client_id)
                    ];
                case 1:
                    result1 = _state.sent();
                    setApiError(result1.request);
                    client = result1.data.client;
                    _tmp = {};
                    _tmp1 = {};
                    return [
                        4,
                        roles(setApiError)
                    ];
                case 2:
                    data = (_tmp.clientData = (_tmp1.userRoles = _state.sent(), _tmp1.client = client, _tmp1), _tmp);
                    role_ids = data.clientData.userRoles.map(function(x) {
                        return x.value;
                    });
                    data.clientData.client.client_users_attributes = data.clientData.client.client_users_attributes.filter(function(x) {
                        if (role_ids.includes(x.role_id)) return x;
                    });
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return _getClientData.apply(this, arguments);
}
function fileSizeValid(fileInfo) {
    if (fileInfo.size > _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_0__/* .CSV_FILE_SIZE_LIMIT */ .af) {
        new _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_0__/* .CustomToastrAction */ .Y5().setNormalToastr("The file size is greater than 1MB", "success");
        // toastr.success('The file size is greater than 1MB');
        document.getElementById("react-csv-reader-input").value = null;
        return false;
    } else {
        return true;
    }
}
function isCSVFileValid(data, userRoles) {
    try {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var user = _step.value;
                var role_id = userRoles.findIndex(function(obj) {
                    return obj.label === user.role;
                });
                userRoles[role_id].value;
                user.name;
                user.email;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return true;
    } catch (exception) {
        // toastr.success('Invalid File');
        new _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_0__/* .CustomToastrAction */ .Y5().setNormalToastr("Invalid File", "success");
        document.getElementById("react-csv-reader-input").value = null;
        return false;
    }
}


/***/ }),

/***/ 19803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EA": function() { return /* binding */ handleAssignValueOnChange; },
/* harmony export */   "I3": function() { return /* binding */ goToCandidateListingPage; },
/* harmony export */   "I8": function() { return /* binding */ getCandidateToken; },
/* harmony export */   "W3": function() { return /* binding */ getAssignOptionsData; },
/* harmony export */   "XE": function() { return /* binding */ onAddCandidateRemoveFile; },
/* harmony export */   "YF": function() { return /* binding */ selectedIntegrationOption; },
/* harmony export */   "Zm": function() { return /* binding */ AddCandidateActions; },
/* harmony export */   "ax": function() { return /* binding */ getJobListData; },
/* harmony export */   "xV": function() { return /* binding */ submitCandidate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38641);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(18186);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96047);
/* harmony import */ var _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44791);
/* harmony import */ var _services_components_candidate_listing_action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66693);
/* harmony import */ var _services_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40657);
/* harmony import */ var _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43361);
/* harmony import */ var _services_components_candidate_info_edit_form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40914);













var AddCandidateActions = /*#__PURE__*/ function() {
    "use strict";
    function AddCandidateActions(setValue, setSuggestion, setAgencyUserSuggestion, setAgencyUserEmail) {
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, AddCandidateActions);
        var _this1 = this;
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, "onSuggestionsFetchRequested", function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(value) {
                var suggestion;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this1.getSuggestions(value)
                            ];
                        case 1:
                            suggestion = _state.sent();
                            _this1.setSuggestion(suggestion);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(value) {
                return _ref.apply(this, arguments);
            };
        }());
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, "onSuggestionsClearRequested", function() {
            _this.setSuggestion([]);
        });
        var _this2 = this;
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, "onAgencyUserSuggestionsFetchRequested", function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(hash, agencyUsers, setAgencyUsers) {
                var suggestion;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this2.getAgencyUserSuggestions(hash.value, agencyUsers, setAgencyUsers)
                            ];
                        case 1:
                            suggestion = _state.sent();
                            _this2.setAgencyUserSuggestion(suggestion);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(hash, agencyUsers, setAgencyUsers) {
                return _ref.apply(this, arguments);
            };
        }());
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, "onAgencyUserSuggestionsClearRequested", function() {
            _this.setAgencyUserSuggestion([]);
        });
        this.setValue = setValue;
        this.setSuggestion = setSuggestion;
        this.setAgencyUserSuggestion = setAgencyUserSuggestion;
        this.setAgencyUserEmail = setAgencyUserEmail;
        this.customToastrAction = new _imports_files_common_common__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
        this.candidateInfoEditService = new _services_components_candidate_info_edit_form__WEBPACK_IMPORTED_MODULE_6__/* .CandidateInfoEditService */ .o();
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(AddCandidateActions, [
        {
            key: "escapeRegexCharacters",
            value: function escapeRegexCharacters(str) {
                return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            }
        },
        {
            key: "getSuggestions",
            value: function getSuggestions(param) {
                var value = param.value;
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
                    var escapedValue, userList;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                escapedValue = _this.escapeRegexCharacters(value === null || value === void 0 ? void 0 : value.trim());
                                if (escapedValue === "") {
                                    return [
                                        2,
                                        []
                                    ];
                                }
                                return [
                                    4,
                                    _this.candidateInfoEditService.getReferralUsers()
                                ];
                            case 1:
                                userList = _state.sent();
                                return [
                                    2,
                                    userList.data.referral_users
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSuggestionValue",
            value: function getSuggestionValue(suggestion) {
                return suggestion;
            }
        },
        {
            key: "renderSuggestion",
            value: function renderSuggestion(suggestion) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        " ",
                        suggestion
                    ]
                });
            }
        },
        {
            key: "shouldRenderSuggestions",
            value: function shouldRenderSuggestions(value) {
                return (value === null || value === void 0 ? void 0 : value.trim().length) >= 3;
            }
        },
        {
            key: "renderInputComponent",
            value: function renderInputComponent(inputProps, selectedValues, setSelectedValues, setSelectedUserCount, setValue, formik) {
                var _this = this;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "buttonIn ShareCV",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                            className: PageStyle.Form__Input,
                            autoComplete: "password"
                        }, inputProps)),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, {
                            buttonstyle: "".concat(ButtonStyle.nobgbutton, " addbtn"),
                            onClick: function() {
                                return _this.onAddClick(inputProps.value, selectedValues, setSelectedValues, setSelectedUserCount, setValue, formik);
                            },
                            children: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_5__/* .TRANSLATION */ .TA)("button:add:default")
                        })
                    ]
                });
            }
        },
        {
            key: "onSuggestionSelectionEmail",
            value: function onSuggestionSelectionEmail(value, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik) {
                this.add_selected_value_email(value, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik);
            }
        },
        {
            key: "add_selected_value_email",
            value: function add_selected_value_email(value, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik) {
                var emails = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = selectedValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        emails.push(element.email);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (!emails.includes(value.email)) {
                    selectedValues.push(value);
                    setValue("");
                    setSelectedValues(selectedValues);
                    setSelectedUserCount(selectedValues.length);
                } else if (emails.includes(value.email)) {
                    setValue("");
                }
            }
        },
        {
            key: "getAgencyUserSuggestionValue",
            value: function getAgencyUserSuggestionValue(suggestion) {
                return suggestion.email;
            }
        },
        {
            key: "renderAgencyUserSuggestion",
            value: function renderAgencyUserSuggestion(suggestion) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        " ",
                        suggestion.name ? "".concat(suggestion.name, " | ").concat(suggestion.email) : "".concat(suggestion.email)
                    ]
                });
            }
        },
        {
            key: "getAgencyUserSuggestions",
            value: function getAgencyUserSuggestions(value, agencyUsers, setAgencyUsers) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
                    var escapedValue, inputLength;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                        escapedValue = _this.escapeRegexCharacters(value === null || value === void 0 ? void 0 : value.trim());
                        if (escapedValue === "") {
                            return [
                                2,
                                []
                            ];
                        }
                        inputLength = escapedValue.length;
                        return [
                            2,
                            inputLength === 0 ? [] : agencyUsers.filter(function(user) {
                                var ref, ref1;
                                return ((ref1 = (ref = user.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.slice(0, inputLength)) === escapedValue || user.email.toLowerCase().slice(0, inputLength) === escapedValue;
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return AddCandidateActions;
}();
function submitCandidate(args) {
    return _submitCandidate.apply(this, arguments);
}
function _submitCandidate() {
    _submitCandidate = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(args) {
        var ref, formData, result, customToastrAction, _tmp, error_hash, formik_values, _tmp1, _tmp2, _tmp3;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    args.setLoader(true);
                    formData = setCandidateFormData(args);
                    return [
                        4,
                        new _services_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_4__/* .AddCandidate */ .d().createCandidate(formData)
                    ];
                case 1:
                    result = _state.sent();
                    customToastrAction = new _imports_files_common_common__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    _tmp = {};
                    _tmp1 = {};
                    _tmp2 = {};
                    _tmp3 = {};
                    if (result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.success) {
                        if (args.from == "kanban") {
                            // args.setShowCandidate(false)
                            if (result.data.automations_hsh) (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_5__/* .setAutomationHash */ .ks)(args, result.data.automations_hsh);
                            args.setJobData(result.data.kanban_data);
                            if (result.data.automations_hsh) (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_5__/* .manageAutomationTimer */ .jM)((_tmp.restart = args.restart, _tmp.setTimerStatus = args.setTimerStatus, _tmp));
                        }
                        goToCandidateListingPage(args.router, args.from, args.formik, args.setIsDisabled);
                        if (args.from == "kanban") {
                            args.setShowCandidate(false);
                        }
                        customToastrAction.setNormalToastr(result.data.success, "success");
                    // toastr.success(result.data.success);
                    } else {
                        error_hash = result.response.data.error;
                        formik_values = args.formik.current.values.client_candidate;
                        args.formik.current.setTouched((_tmp1.client_candidate = formik_values, _tmp1));
                        if (error_hash.client_candidate) args.formik.current.setStatus((_tmp2.client_candidate = error_hash === null || error_hash === void 0 ? void 0 : error_hash.client_candidate, _tmp2));
                        if (error_hash && typeof error_hash === "string") customToastrAction.setNormalToastr(error_hash, "error");
                        args.setApiError(result.response);
                        args.setLoader(false);
                        if (result.response.data.duplicate_candidate) args.setDuplicateEmail((_tmp3.state = true, _tmp3.client_candidate_id = result.response.data.client_candidate_id, _tmp3.job_application_id = result.response.data.job_application_id, _tmp3.job_id = result.response.data.job_id, _tmp3.job_stage_id = result.response.data.job_stage_id, _tmp3));
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _submitCandidate.apply(this, arguments);
}
function setCandidateFormData(args) {
    var formData = new FormData();
    var values = args.values;
    formData.append("client_candidate[name]", values.client_candidate.name);
    formData.append("client_candidate[first_name]", values.client_candidate.first_name);
    formData.append("client_candidate[last_name]", values.client_candidate.last_name);
    formData.append("client_candidate[email]", values.client_candidate.email);
    formData.append("client_candidate[contact_no]", values.client_candidate.contact_no);
    formData.append("client_candidate[social_media_detail_attributes][linkedin_url]", values.client_candidate.social_media_detail_attributes.linkedin_url);
    formData.append("client_candidate[social_media_detail_attributes][portfolio_url]", values.client_candidate.social_media_detail_attributes.portfolio_url);
    formData.append("client_candidate[location_attributes][full_address]", values.client_candidate.location);
    if (args.from && args.from.length > 0) {
        formData.append("from", args.from);
    }
    // values.client_candidate.resume_attributes.file_type != '' ? formData.append( "client_candidate[resume_attributes][file_type]", 'cv') : '';
    values.client_candidate.resume_attributes.file != "" ? formData.append("client_candidate[cvs_attributes][][file]", values.client_candidate.resume_attributes.file, values.client_candidate.resume_attributes.file.name) : "";
    values.client_candidate.assign != "" ? formData.append("sourced", true) : "";
    values.client_candidate.assign != "" ? formData.append("client_candidate[job_slug]", values.client_candidate.assign) : "";
    values.client_candidate.assign != "" ? formData.append("sourced_option", values.client_candidate.sourced_option) : "";
    values.client_candidate.other_files_attributes.map(function(file, index) {
        formData.append("client_candidate[other_files_attributes][".concat(index, "][file_type]"), file.file_type);
        formData.append("client_candidate[other_files_attributes][".concat(index, "][file]"), file.file, file.file_name);
        return file;
    });
    if (values.client_candidate.sourced_option == "Referral") {
        formData.append("referrer_name", values.referrer_name || "");
    }
    if (values.client_candidate.sourced_option == "Other") {
        formData.append("other_source", values.other_source || "");
    }
    if (values.client_candidate.sourced_option == "Social" || values.client_candidate.sourced_option == "Job Board") {
        formData.append("job_board_integration_attributes[integration_id]", values.client_candidate.job_board_integration_attributes.integration_id);
        formData.append("job_board_integration_attributes[integration_type]", values.client_candidate.job_board_integration_attributes.integration_type);
    }
    if (values.client_candidate.sourced_option == "Agency" && values.client_candidate.agency_id) {
        formData.append("agency_id", values.client_candidate.agency_id || "");
        formData.append("agency_user_email", values.client_candidate.agency_user_email || "");
    }
    return formData;
}
function getCandidateToken(args, duplicateEmail) {
    return _getCandidateToken.apply(this, arguments);
}
function _getCandidateToken() {
    _getCandidateToken = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(args, duplicateEmail) {
        var formData, result, selected_candidate_id, link, route_params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    args.setLoader(true);
                    formData = setCandidateFormData(args);
                    return [
                        4,
                        new _services_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_4__/* .AddCandidate */ .d().candidateToken(formData, duplicateEmail)
                    ];
                case 1:
                    result = _state.sent();
                    _tmp = {};
                    _tmp1 = {};
                    if ((result === null || result === void 0 ? void 0 : result.request.status) == 200) {
                        selected_candidate_id = "add_candidate_merge";
                        link = _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .REDIRECT.client.jobs.merge_duplicate_users.replace */ .RQ.client.jobs.merge_duplicate_users.replace("$candidate_id", result.data.client_candidate_id).replace("$duplicate_id", selected_candidate_id);
                        route_params = (_tmp.applicant_id = result.data.job_application_id, _tmp.job_id = result.data.job_id, _tmp.candidate_token = result.data.candidate_token, _tmp);
                        args.setLoader(false);
                        args.router.push((_tmp1.pathname = link, _tmp1.query = route_params, _tmp1));
                    } else {
                        args.setLoader(false);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getCandidateToken.apply(this, arguments);
}
function getJobListData(params, t) {
    return _getJobListData.apply(this, arguments);
}
function _getJobListData() {
    _getJobListData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(params, t) {
        var resultArray, _tmp, sourcedOption, _tmp1, agencies, _tmp2, integration_options, _tmp3, result, error, _tmp4;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    resultArray = [
                        (_tmp.label = t("placeholder:select:please"), _tmp.value = "", _tmp)
                    ];
                    _tmp1 = {};
                    sourcedOption = [
                        (_tmp1.label = t("placeholder:select:please"), _tmp1.value = "", _tmp1)
                    ];
                    _tmp2 = {};
                    agencies = [
                        (_tmp2.label = t("placeholder:select:please"), _tmp2.value = "", _tmp2.users = [], _tmp2)
                    ];
                    _tmp3 = {};
                    integration_options = (_tmp3.social = [
                        {
                            label: t("placeholder:select:please"),
                            value: "",
                            type: "Integration"
                        }
                    ], _tmp3.job_board = [
                        {
                            label: t("placeholder:select:please"),
                            value: "",
                            type: "Integration"
                        }
                    ], _tmp3);
                    return [
                        4,
                        new _services_components_candidate_listing_action__WEBPACK_IMPORTED_MODULE_3__/* .CandidateListAction */ .n().ActiveJobList(params)
                    ];
                case 1:
                    result = _state.sent();
                    _tmp4 = {};
                    if (result.status == undefined || result.status != 200) {
                        error = new Error("An error occurred while fetching the data.");
                        error.status = result.response.status;
                        throw error;
                    } else {
                        result.data.jobs.map(function(element) {
                            resultArray.push({
                                label: element.label,
                                value: element.slug
                            });
                            return element;
                        });
                        // for(var element of result.data.jobs)
                        // {
                        //   console.log(`${element.label}`)
                        //   var label = element.label
                        //   var slug  = element.slug
                        //   resultArray.push({label: label, value: slug})
                        // }
                        if (result.data.sourced_options && result.data.sourced_options.length > 0) {
                            // for( var element of result.data.sourced_options)
                            // {
                            //   var label = element
                            //   var value  = element
                            //   sourcedOption.push({label: label, value: value})
                            // } 
                            result.data.sourced_options.map(function(element) {
                                sourcedOption.push({
                                    label: element.label,
                                    value: element.value
                                });
                                return element;
                            });
                        }
                        if (result.data.agencies && result.data.agencies.length > 0) {
                            // for( var element of result.data.agencies)
                            // {
                            //   agencies.push({label: element.label, value: element.value, users: element.users, domain: element.domain})
                            // } 
                            result.data.agencies.map(function(element) {
                                agencies.push({
                                    label: element.label,
                                    value: element.value,
                                    users: element.users,
                                    domain: element.domain
                                });
                                return element;
                            });
                        }
                        if (result.data.integration_options && Object.keys(result.data.integration_options).length > 0) {
                            result.data.integration_options.social.map(function(element) {
                                integration_options.social.push({
                                    label: element.label,
                                    value: element.value,
                                    type: element.type
                                });
                                return element;
                            });
                            result.data.integration_options.job_board.map(function(element) {
                                integration_options.job_board.push({
                                    label: element.label,
                                    value: element.value,
                                    type: element.type
                                });
                                return element;
                            });
                        }
                        return [
                            2,
                            (_tmp4.resultArray = resultArray, _tmp4.sourcedOption = sourcedOption, _tmp4.agencies = agencies, _tmp4.integration_options = integration_options, _tmp4)
                        ];
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getJobListData.apply(this, arguments);
}
function selectedIntegrationOption(options, job_board_integration_attributes) {
    return options.filter(function(x) {
        return x.value == (job_board_integration_attributes === null || job_board_integration_attributes === void 0 ? void 0 : job_board_integration_attributes.integration_id) && x.type == (job_board_integration_attributes === null || job_board_integration_attributes === void 0 ? void 0 : job_board_integration_attributes.integration_type);
    });
}
function handleAssignValueOnChange(type, data, formik) {
    if (type == "sourced_options") {
        formik.setFieldValue("client_candidate.sourced_option", data.value);
    } else if (type == "agency_id") {
        formik.setFieldValue("client_candidate.agency_id", data.value);
    } else {
        formik.setFieldValue("client_candidate.assign", data.value);
    }
}
function goToCandidateListingPage(router, from, formik, setIsDisabled) {
    if (from && from == "kanban") {
        (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_5__/* .onCancelClick */ .bp)();
        formik.current.resetForm();
        var hash = {
            file_type: "",
            file: "",
            file_name: ""
        };
        formik.current.setFieldValue("client_candidate.resume_attributes", hash);
        formik.current.setFieldValue("client_candidate.other_files_attributes", []);
        document.getElementById("add_candidate_cv") ? document.getElementById("add_candidate_cv").value = "" : "";
        document.getElementById("additional_files_cv") ? document.getElementById("additional_files_cv").value = "" : "";
        setIsDisabled(false);
    } else {
        var link = _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .REDIRECT.client.candidates.candidate_listing */ .RQ.client.candidates.candidate_listing;
        router.push(link);
    }
}
function onAddCandidateRemoveFile(formik, type, index, setCvErrorMessage, setOtherErrorMessage, setFileCount, setIsDisabled, isAgency) {
    if (type == "cv") {
        var hash = {
            file_type: "",
            file: "",
            file_name: ""
        };
        setIsDisabled(false);
        formik.setFieldValue("client_candidate.resume_attributes", hash);
        document.getElementById("add_candidate_cv") ? document.getElementById("add_candidate_cv").value = "" : "";
        setCvErrorMessage("");
    } else {
        if (isAgency) {
            formik.values.client_candidate.other_files_attributes.map(function(x, agencyIndex) {
                if (index == agencyIndex) x["_destroy"] = true;
                else x["_destroy"] = false;
                return x;
            });
        } else {
            var ref;
            (ref = formik.values.client_candidate.other_files_attributes) === null || ref === void 0 ? void 0 : ref.splice(index, 1);
        }
        document.getElementById("additional_files_cv") ? document.getElementById("additional_files_cv").value = "" : "";
        setOtherErrorMessage("");
        setFileCount(Math.random() * 10000);
    }
}
function getAssignOptionsData(data, t) {
    var resultArray = [
        {
            label: t("placeholder:select:please"),
            value: ""
        }
    ];
    var sourcedOption = [
        {
            label: t("label:sourced"),
            value: "Sourced"
        }
    ];
    var agencies = [
        {
            label: t("placeholder:select:please"),
            value: "",
            users: []
        }
    ];
    var integrationOption = {
        social: [
            {
                label: t("placeholder:select:please"),
                value: "",
                type: "Integration"
            }
        ],
        job_board: [
            {
                label: t("placeholder:select:please"),
                value: "",
                type: "Integration"
            }
        ]
    };
    if (data.jobs) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = data.jobs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                var label = element.label;
                var slug = element.slug;
                resultArray.push({
                    label: label,
                    value: slug
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    if (data.sourced_options && data.sourced_options.length > 0) {
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = data.sourced_options[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var element = _step1.value;
                var label = element.label;
                var value = element.value;
                sourcedOption.push({
                    label: label,
                    value: value
                });
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    if (data.agencies && data.agencies.length > 0) {
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator2 = data.agencies[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var element = _step2.value;
                agencies.push({
                    label: element.label,
                    value: element.value,
                    users: element.users,
                    domain: element.domain
                });
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }
    if (data.integration_options && Object.keys(data.integration_options).length > 0) {
        data.integration_options.social.map(function(element) {
            integrationOption.social.push({
                label: element.label,
                value: element.value,
                type: element.type
            });
            return element;
        });
        data.integration_options.job_board.map(function(element) {
            integrationOption.job_board.push({
                label: element.label,
                value: element.value,
                type: element.type
            });
            return element;
        });
    }
    data.jobs = resultArray;
    data.sourced_options = sourcedOption;
    data.integration_options = integrationOption;
    data.agencies = agencies;
    return data;
}


/***/ }),

/***/ 52848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ CandidateMergeAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14683);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96047);






var CandidateMergeAction = /*#__PURE__*/ function() {
    "use strict";
    function CandidateMergeAction(args, t) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, CandidateMergeAction);
        this.setApiError = args.setApiError;
        this.setFlagForRerender = args.setFlagForRerender;
        this.router = args.router;
        this.setAgencyAcceptReject = args.setAgencyAcceptReject;
        this.mergeRecordsService = new _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .MergeRecordsService */ .GK();
        this.customToastrAction = new _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .CustomToastrAction */ .Y5();
        this.activitiesData = args.activitiesData;
        this.setActivitiesData = args.setActivitiesData;
        this.setJobData = args.setJobData;
        this.t = t;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(CandidateMergeAction, [
        {
            key: "showAcceptReject",
            value: function showAcceptReject(data) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var _tmp;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        _tmp = {};
                        _this.setAgencyAcceptReject((_tmp.status = true, _tmp.confirmBtnAction = function() {
                            _this.confirmAcceptApplication(data);
                        }, _tmp.declineBtnAction = function() {
                            _this.confirmRejectApplication(data);
                        }, _tmp.button1_text = _this.t("modal:duplicate:decline"), _tmp.button2_text = _this.t("modal:duplicate:accept"), _tmp.viewData = data.details, _tmp));
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "confirmAcceptApplication",
            value: function confirmAcceptApplication(data) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var body, _tmp, result, status_code, _tmp1, _tmp2;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                body = (_tmp.job_application_id = data.details.job_application_id, _tmp.duplicate_application_id = data.details.duplicate_application_id, _tmp.notification_id = data.id, _tmp);
                                if (data.from) body.from = "kanban";
                                return [
                                    4,
                                    _this.mergeRecordsService.acceptAgencyApplication(body)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                status_code = result.status || result.response.status;
                                _tmp1 = {};
                                _tmp2 = {};
                                switch(status_code){
                                    case _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .SUCCESS_REPONSE_CODE */ .Us:
                                        _this.setAgencyAcceptReject((_tmp1.status = false, _tmp1.message = "", _tmp1.confirmBtnAction = "", _tmp1.declineBtnAction = "", _tmp1.button1_text = _this.t("modal:duplicate:cancel"), _tmp1.button2_text = _this.t("modal:duplicate:dismiss"), _tmp1));
                                        _this.customToastrAction.setNormalToastr(result.data.success, "success");
                                        if (data.from == "kanban") {
                                            _this.setJobData(result.data.kanban_data);
                                        } else {
                                            _this.activitiesData.alerts = result.data.data.alerts;
                                            _this.setActivitiesData(_this.activitiesData);
                                        }
                                        _this.setFlagForRerender(Math.random() * 10000);
                                        break;
                                    default:
                                        _this.setAgencyAcceptReject((_tmp2.status = false, _tmp2.message = "", _tmp2.confirmBtnAction = "", _tmp2.declineBtnAction = "", _tmp2.button1_text = _this.t("modal:duplicate:cancel"), _tmp2.button2_text = _this.t("modal:duplicate:dismiss"), _tmp2));
                                        _this.customToastrAction.setNormalToastr(result.request.error, "success");
                                        _this.setFlagForRerender(Math.random() * 10000);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "confirmRejectApplication",
            value: function confirmRejectApplication(data) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var body, _tmp, result, status_code, _tmp1, _tmp2;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                body = (_tmp.duplicate_application_id = data.details.duplicate_application_id, _tmp.agency_user_id = data.details.agency_user_id, _tmp.notification_id = data.id, _tmp);
                                if (data.from) body.from = "kanban";
                                return [
                                    4,
                                    _this.mergeRecordsService.rejectAgencyApplication(body)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                status_code = result.status || result.response.status;
                                _tmp1 = {};
                                _tmp2 = {};
                                switch(status_code){
                                    case _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .SUCCESS_REPONSE_CODE */ .Us:
                                        _this.setAgencyAcceptReject((_tmp1.status = false, _tmp1.message = "", _tmp1.confirmBtnAction = "", _tmp1.declineBtnAction = "", _tmp1.button1_text = _this.t("modal:duplicate:cancel"), _tmp1.button2_text = _this.t("modal:duplicate:dismiss"), _tmp1));
                                        _this.customToastrAction.setNormalToastr(result.data.success, "success");
                                        if (data.from == "kanban") {
                                            _this.setJobData(result.data.kanban_data);
                                        } else {
                                            _this.activitiesData.alerts = result.data.data.alerts;
                                            _this.setActivitiesData(_this.activitiesData);
                                        }
                                        _this.setFlagForRerender(Math.random() * 10000);
                                        break;
                                    default:
                                        _this.setAgencyAcceptReject((_tmp2.status = false, _tmp2.message = "", _tmp2.confirmBtnAction = "", _tmp2.declineBtnAction = "", _tmp2.button1_text = _this.t("modal:duplicate:cancel"), _tmp2.button2_text = _this.t("modal:duplicate:dismiss"), _tmp2));
                                        _this.customToastrAction.setNormalToastr(result.request.error, "success");
                                        _this.setFlagForRerender(Math.random() * 10000);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CandidateMergeAction;
}();


/***/ }),

/***/ 79925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A6": function() { return /* binding */ handleCvLibrarySubmit; },
/* harmony export */   "BN": function() { return /* binding */ getClientIntegrationData; },
/* harmony export */   "CT": function() { return /* binding */ connectDisconnectIntegration; },
/* harmony export */   "Hx": function() { return /* binding */ getButtonClass; },
/* harmony export */   "YF": function() { return /* binding */ selectClientIntegrationTab; },
/* harmony export */   "_k": function() { return /* binding */ handleIntegrationSubmit; },
/* harmony export */   "jL": function() { return /* binding */ initialiseLiveAuthClient; },
/* harmony export */   "qL": function() { return /* binding */ createIntegrationData; },
/* harmony export */   "rF": function() { return /* binding */ cvLibraryValidations; },
/* harmony export */   "z9": function() { return /* binding */ turnOnOffAccessibility; },
/* harmony export */   "zH": function() { return /* binding */ getIntegrationsStatus; }
/* harmony export */ });
/* unused harmony exports getClientCustomIntegrationData, generateHash */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7485);
/* harmony import */ var _candidates_kanban__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21572);
/* harmony import */ var _constants_common_logo_sizes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80758);
/* provided dependency */ var process = __webpack_require__(56957);






var crypto = __webpack_require__(76747);
function createIntegrationData(index, client_integration_id, integration_id, slug, name, description, user_enabled, is_linkable, idibu_data_exists, idibu_data, logo, accessible, connected, redirect_url, limit) {
    return {
        index: index,
        client_integration_id: client_integration_id,
        integration_id: integration_id,
        slug: slug,
        name: name,
        description: description,
        user_enabled: user_enabled,
        is_linkable: is_linkable,
        idibu_data_exists: idibu_data_exists,
        idibu_data: idibu_data,
        logo: logo,
        accessible: accessible,
        connected: connected,
        redirect_url: redirect_url,
        limit: limit
    };
}
function getIntegrationsStatus(row, t) {
    if (row.is_linkable) {
        return row.connected ? t("button:disconnect") : t("button:connect");
    } else {
        return row.accessible ? t("button:turn_off") : t("button:turn_on");
    }
}
function getButtonClass(row, isEditable) {
    var baseClass = "";
    if (row.is_linkable) {
        if (!isEditable) baseClass = row.connected ? "disabledbuttonlight" : "disabledbuttondark";
        var mainClass = baseClass + (row.connected ? " secondarybtnoff" : " secondarybtnon");
        return mainClass;
    } else {
        if (!isEditable) baseClass = row.accessible ? "disabledbuttonlight" : "disabledbuttondark";
        var mainClass1 = baseClass + (row.accessible ? " secondarybtnoff" : " secondarybtnon");
        return mainClass1;
    }
}
function turnOnOffAccessibility(event, integration_id, t, setApiError) {
    return _turnOnOffAccessibility.apply(this, arguments);
}
function _turnOnOffAccessibility() {
    _turnOnOffAccessibility = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(event, integration_id, t, setApiError) {
        var text, params, _tmp, result, status_code, customToastrAction, response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    text = event.target.textContent;
                    _tmp = {};
                    params = _tmp;
                    if (text == t("button:turn_off")) {
                        params["accessibile"] = "0";
                    } else if (text == t("buttons:turn_on")) {
                        params["accessibile"] = "1";
                    }
                    return [
                        4,
                        new _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .ClientIntegration */ .qI().updateIntegrationAccessibility(params, integration_id)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    setApiError(result.request);
                    switch(status_code){
                        case _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            response = result.data;
                            if (response.success) {
                                event.target.textContent = text == t("button:turn_on") ? t("button:turn_off") : t("button:turn_on");
                                if (event.target.classList.contains("secondarybtnon")) {
                                    event.target.classList.remove("secondarybtnon");
                                    event.target.classList.add("secondarybtnoff");
                                } else if (event.target.classList.contains("secondarybtnoff")) {
                                    event.target.classList.remove("secondarybtnoff");
                                    event.target.classList.add("secondarybtnon");
                                }
                            }
                            break;
                        case _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            if (result.response.data.error) {
                                console.log(result.response.data.error);
                            }
                            break;
                        case _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .UNAUTHORIZED_REPONSE_CODE */ .t9:
                            if (result.response.data.erro) {
                                customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            // toastr.warning(result.response.data.error);
                            }
                            break;
                        default:
                            (0,_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _turnOnOffAccessibility.apply(this, arguments);
}
function connectDisconnectIntegration(event, router, row, setApiError, setFormData, setConnectModal) {
    return _connectDisconnectIntegration.apply(this, arguments);
}
function _connectDisconnectIntegration() {
    _connectDisconnectIntegration = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(event, router, row, setApiError, setFormData, setConnectModal) {
        var params, _tmp, customToastrAction, result, status_code, response, error, modalName;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    params = (_tmp.slug = row.slug, _tmp.connected = false, _tmp.integrate_level = "client", _tmp);
                    customToastrAction = new _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    if (!row.connected) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        new _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .ClientIntegration */ .qI().disconnectIntegration(params, row.slug)
                    ];
                case 1:
                    result = _state.sent();
                    setApiError(result.request);
                    status_code = result.status || result.response.status;
                    switch(status_code){
                        case _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            response = result.data;
                            if (response.success) {
                                row.connected = false;
                                customToastrAction.setNormalToastr(response.success, "success");
                            }
                            break;
                        case _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            error = result.response.data.error;
                            if (error) {
                                customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            }
                            break;
                        default:
                            (0,_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code);
                    }
                    return [
                        2,
                        row
                    ];
                case 2:
                    setFormData("");
                    modalName = _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .CONSTANTS.modalMap */ .tl.modalMap[row.name];
                    if (modalName) {
                        setConnectModal(modalName);
                    } else {
                        row.redirect_url.length > 0 ? router.push(row.redirect_url) : console.log("Integration is not done yet.");
                    }
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _connectDisconnectIntegration.apply(this, arguments);
}
function getClientIntegrationData(router, setApiError) {
    return _getClientIntegrationData.apply(this, arguments);
}
function _getClientIntegrationData() {
    _getClientIntegrationData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(router, setApiError) {
        var ref, ref1, body, integration_data, custom_integration_data, enabled_integrations, disabled_integrations, error, data, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    body = router.query;
                    return [
                        4,
                        new _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .ClientIntegration */ .qI().getIntegrationsList(body)
                    ];
                case 1:
                    integration_data = _state.sent();
                    return [
                        4,
                        getClientCustomIntegrationData(setApiError)
                    ];
                case 2:
                    custom_integration_data = _state.sent();
                    setApiError(integration_data.request);
                    enabled_integrations = (ref = integration_data.data) === null || ref === void 0 ? void 0 : ref.enabled;
                    disabled_integrations = (ref1 = integration_data.data) === null || ref1 === void 0 ? void 0 : ref1.disabled;
                    _tmp = {};
                    if (integration_data.status == undefined || integration_data.status != 200) {
                        error = new Error("An error occurred while fetching the data.");
                        error.status = integration_data.response.status;
                        throw error;
                    } else {
                        data = (_tmp.props = {
                            enabled_integrations: enabled_integrations,
                            disabled_integrations: disabled_integrations,
                            integration_data: integration_data,
                            custom_integration_data: custom_integration_data
                        }, _tmp);
                        return [
                            2,
                            data.props
                        ];
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getClientIntegrationData.apply(this, arguments);
}
function getClientCustomIntegrationData(setApiError) {
    return _getClientCustomIntegrationData.apply(this, arguments);
}
function _getClientCustomIntegrationData() {
    _getClientCustomIntegrationData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(setApiError) {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .ClientIntegration */ .qI().getCustomIntegrationsList()
                    ];
                case 1:
                    result = _state.sent();
                    setApiError(result.request);
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _getClientCustomIntegrationData.apply(this, arguments);
}
function handleCvLibrarySubmit(values, row, router, setCvLibraryModal, setApiError) {
    return _handleCvLibrarySubmit.apply(this, arguments);
}
function _handleCvLibrarySubmit() {
    _handleCvLibrarySubmit = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(values, row, router, setCvLibraryModal, setApiError) {
        var session, client_slug, params, _tmp, result, status_code, customToastrAction, response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .getSession */ .Gg)()
                    ];
                case 1:
                    session = _state.sent();
                    client_slug = session === null || session === void 0 ? void 0 : session.subdomain;
                    _tmp = {};
                    params = (_tmp.code = values.username, _tmp.password = values.password, _tmp.integrate_level = "client", _tmp);
                    return [
                        4,
                        new _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .IntegrationConnect */ .hJ().submitIntegrationCode(params, row.slug, client_slug)
                    ];
                case 2:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    setApiError(result.request);
                    switch(status_code){
                        case _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            response = result.data;
                            if (response.success) {
                                row.connected = true;
                                setTimeout(function() {
                                    return setCvLibraryModal(false);
                                }, 50);
                                customToastrAction.setNormalToastr(response.success, "success");
                            }
                            break;
                        case _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            setCvLibraryModal(false);
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            break;
                        default:
                            setCvLibraryModal(false);
                            (0,_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _handleCvLibrarySubmit.apply(this, arguments);
}
function handleIntegrationSubmit(values, row, router, setModalState, setApiError) {
    return _handleIntegrationSubmit.apply(this, arguments);
}
function _handleIntegrationSubmit() {
    _handleIntegrationSubmit = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(values, row, router, setModalState, setApiError) {
        var session, client_slug, params, _tmp, result, status_code, customToastrAction, response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .getSession */ .Gg)()
                    ];
                case 1:
                    session = _state.sent();
                    client_slug = session === null || session === void 0 ? void 0 : session.subdomain;
                    _tmp = {};
                    params = (_tmp.values = values, _tmp.integrate_level = "client", _tmp);
                    return [
                        4,
                        new _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .IntegrationConnect */ .hJ().submitIntegrationCode(params, row.slug, client_slug)
                    ];
                case 2:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    setApiError(result.request);
                    switch(status_code){
                        case _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            response = result.data;
                            if (response.success) {
                                row.connected = true;
                                setTimeout(function() {
                                    return setModalState(null);
                                }, 50);
                                customToastrAction.setNormalToastr(response.success, "success");
                            }
                            break;
                        case _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            setModalState(null);
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            break;
                        default:
                            setModalState(null);
                            (0,_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _handleIntegrationSubmit.apply(this, arguments);
}
function generateHash() {
    var client_id = process.env.NEXT_PUBLIC_IDIBU_CLIENT_ID;
    var current_time = Date.now();
    var future_time = current_time + 3600 * 1000;
    var message = "".concat(client_id, "-").concat(future_time);
    var secret_key = process.env.NEXT_PUBLIC_IDIBU_SECRET_KEY;
    var hmac = crypto.createHmac("sha256", secret_key).update(message).digest("hex");
    console.log("HMAC SHA256 Hash:", hmac);
    return hmac;
}
var initialiseLiveAuthClient = function(e, formik, selectedItem, setIsAccountConnected) {
    // const link = e.currentTarget.getAttribute("data-link");
    // const portal = e.currentTarget.getAttribute("data-portal");
    // const id = e.currentTarget.getAttribute("data-id");
    var client = new window.LiveAuthClient({
        auth: {
            client: selectedItem.idibu_client_id,
            expires: selectedItem.expires,
            hash: selectedItem.hash
        }
    });
    client.test(function(message) {
        console.log(message, "message");
    });
    // formik.setFieldValue("contract_id", "EAADHEaqnQw4BO8Y3diz9rStkFZAXZCAf6Bd6X1so85Fi8sCnE38I0UzsTX6HZA8rXKbf4u1ZCldI7tIPF9bRydloahcb9GZABjsb6uL6bUcueZCxcuyi5TbIXOrZBowxZCaSSXWfZC4HwjXLZA4RnzyV1OAfloBKgWG27QKkiYYK2xvqYKxS1mNOfLVpXm06ZCqs1wvFvGKWcKzglNhfbN37ybIZB1qc1ytLvppb2ZAmmSAtukKlIS3VBZC2uH");
    client.login({
        portal: selectedItem.job_board_id
    }, function(credentials) {
        // console.log("Login successful:", credentials);
        // formik.setFieldValue("contract_id", getContractID(credentials))
        var contractID = getContractID(credentials);
        formik.setFieldValue("contract_id", contractID);
        setIsAccountConnected(contractID);
    });
};
function getContractID(liveAuthHash) {
    if (liveAuthHash.hasOwnProperty("linjobs_cid")) {
        return liveAuthHash["linjobs_cid"];
    } else {
        // Get the first key's value
        var firstKey = Object.keys(liveAuthHash)[0];
        return liveAuthHash[firstKey];
    }
}
function cvLibraryValidations() {
    var schema = _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .Yup.object */ .sm.object({
        username: _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .TRANSLATION */ .TA)("errors:required")),
        password: _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .TRANSLATION */ .TA)("errors:required"))
    });
    return schema;
}
function selectClientIntegrationTab(tab_index, router, setEnableItems, setCustomEnableItems, setApiError, setCategoryList, setDatatableLoading) {
    return _selectClientIntegrationTab.apply(this, arguments);
}
function _selectClientIntegrationTab() {
    _selectClientIntegrationTab = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(tab_index, router, setEnableItems, setCustomEnableItems, setApiError, setCategoryList, setDatatableLoading) {
        var param_list, ref, result, enable_array, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setDatatableLoading(true);
                    param_list = router.query;
                    delete param_list.type;
                    if (!(tab_index == 0)) return [
                        3,
                        2
                    ];
                    param_list.type = "default";
                    (0,_candidates_kanban__WEBPACK_IMPORTED_MODULE_2__/* .addParamsToUrl */ .Sr)(param_list, router);
                    return [
                        4,
                        getClientIntegrationData(router, setApiError)
                    ];
                case 1:
                    result = _state.sent();
                    enable_array = [];
                    (ref = result.enabled_integrations) === null || ref === void 0 ? void 0 : ref.map(function(x, index) {
                        var logo_url = "/images/pages/integration/".concat(x.integration.display_name.toLowerCase().replace(/\s/g, "_"), ".png");
                        enable_array.push(createIntegrationData(index, x.id, x.integration.id, x.integration.slug, x.integration.display_name, x.integration.description, x.integration.user_enabled, x.integration.is_linkable, x.integration.idibu_data_exists, x.integration.idibu_data, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Ee, {
                            src: logo_url,
                            alt: "",
                            width: (0,_constants_common_logo_sizes__WEBPACK_IMPORTED_MODULE_3__/* .imageSize */ .g)(x.integration.display_name.toLowerCase().replace(/\s/g, "_")).width,
                            height: (0,_constants_common_logo_sizes__WEBPACK_IMPORTED_MODULE_3__/* .imageSize */ .g)(x.integration.display_name.toLowerCase().replace(/\s/g, "_")).height
                        }), x.accessible, x.connected, x.integration.redirect_url, x.integration_limit));
                    });
                    setApiError(result.request);
                    setCustomEnableItems("");
                    setEnableItems(enable_array);
                    setDatatableLoading(false);
                    return [
                        3,
                        4
                    ];
                case 2:
                    param_list.type = "custom";
                    (0,_candidates_kanban__WEBPACK_IMPORTED_MODULE_2__/* .addParamsToUrl */ .Sr)(param_list, router);
                    return [
                        4,
                        getClientCustomIntegrationData(setApiError)
                    ];
                case 3:
                    result = _state.sent();
                    setCustomEnableItems(result.custom_integrations);
                    setCategoryList(result.categories);
                    setDatatableLoading(false);
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _selectClientIntegrationTab.apply(this, arguments);
}


/***/ }),

/***/ 89339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RY": function() { return /* binding */ setIntegrationData; },
/* harmony export */   "Tk": function() { return /* binding */ CompanyIntegrationAction; },
/* harmony export */   "zJ": function() { return /* binding */ setDisabledIntegrationData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43190);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38641);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7485);










var CompanyIntegrationAction = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(CompanyIntegrationAction, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(CompanyIntegrationAction);
    function CompanyIntegrationAction() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, CompanyIntegrationAction);
        var _this;
        _this = _super.call(this);
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this), "companyIntegrationService", new _imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .CompanyIntegrationService */ .Cv());
        _this.applyFilter = _this.applyFilter.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this));
        _this.applyClientFilter = _this.applyClientFilter.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this));
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(CompanyIntegrationAction, [
        {
            key: "applyFilter",
            value: function applyFilter(values, setEnableItems, set_disable_integrations_array, router) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                    var ref, ref1, selectedArray, queryParams, _tmp, _tmp1, result, enableItems, disableItems, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    ,
                                    5
                                ]);
                                selectedArray = Object.keys(values).filter(function(key) {
                                    return values[key];
                                });
                                _tmp = {};
                                _tmp1 = {};
                                queryParams = selectedArray.length > 0 ? (_tmp.integration_category = selectedArray.length > 1 ? selectedArray : selectedArray[0], _tmp) : _tmp1;
                                (0,_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .addParamsToUrl */ .Sr)(queryParams, router);
                                return [
                                    4,
                                    _this.companyIntegrationService.applyFilter(values)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    4,
                                    setIntegrationData((ref = result.data) === null || ref === void 0 ? void 0 : ref.enabled)
                                ];
                            case 2:
                                enableItems = _state.sent();
                                return [
                                    4,
                                    setDisabledIntegrationData((ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.disabled)
                                ];
                            case 3:
                                disableItems = _state.sent();
                                setEnableItems(enableItems);
                                set_disable_integrations_array(disableItems);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                console.error("Error applying filter:", error);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "applyClientFilter",
            value: function applyClientFilter(values, updateIntegrationRows, client_id, addIntegrationData, router) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                    var ref, selectedArray, queryParams, _tmp, _tmp1, result, data, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                selectedArray = Object.keys(values).filter(function(key) {
                                    return values[key];
                                });
                                _tmp = {};
                                _tmp1 = {};
                                queryParams = selectedArray.length > 0 ? (_tmp.integration_category = selectedArray.length > 1 ? selectedArray : selectedArray[0], _tmp) : _tmp1;
                                (0,_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .addParamsToUrl */ .Sr)(queryParams, router);
                                return [
                                    4,
                                    _this.companyIntegrationService.applyClientFilter(values, client_id)
                                ];
                            case 1:
                                result = _state.sent();
                                data = addIntegrationData((ref = result.data) === null || ref === void 0 ? void 0 : ref.client_integrations, result.data.step);
                                updateIntegrationRows(data);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                console.error("Error applying filter:", error);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isFilterApplied",
            value: function isFilterApplied(router) {
                var integration_category = router.query.integration_category;
                if (Array.isArray(integration_category)) {
                    return integration_category.some(function(item) {
                        return /^\d+$/.test(item);
                    });
                }
                return /^\d+$/.test(integration_category);
            }
        }
    ]);
    return CompanyIntegrationAction;
}(_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .SendRequest */ .Lt);
function setIntegrationData(data) {
    return _setIntegrationData.apply(this, arguments);
}
function _setIntegrationData() {
    _setIntegrationData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            return [
                2,
                (data === null || data === void 0 ? void 0 : data.map(function(x, index) {
                    var logo_url = "/images/pages/integration/".concat(x.integration.display_name.toLowerCase().replace(/\s/g, "_"), ".png");
                    return (0,_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .createIntegrationData */ .qL)(index, x.id, x.integration.id, x.integration.slug, x.integration.display_name, x.integration.description, x.integration.user_enabled, x.integration.is_linkable, x.integration.idibu_data_exists, x.integration.idibu_data, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Ee, {
                        src: logo_url,
                        alt: "",
                        width: (0,_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .imageSize */ .gs)(x.integration.display_name.toLowerCase().replace(/\s/g, "_")).width,
                        height: (0,_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .imageSize */ .gs)(x.integration.display_name.toLowerCase().replace(/\s/g, "_")).height
                    }), x.accessible, x.connected, x.integration.redirect_url, x.integration_limit);
                })) || []
            ];
        });
    });
    return _setIntegrationData.apply(this, arguments);
}
function setDisabledIntegrationData(data) {
    return _setDisabledIntegrationData.apply(this, arguments);
}
function _setDisabledIntegrationData() {
    _setDisabledIntegrationData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            return [
                2,
                data === null || data === void 0 ? void 0 : data.map(function(x, index) {
                    var logo_url = "/images/pages/integration/".concat(x.display_name.toLowerCase().replace(/\s/g, "_"), ".png");
                    return (0,_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .createIntegrationData */ .qL)(index, null, x.id, x.slug, x.display_name, x.description, x.user_enabled, x.is_linkable, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Ee, {
                        src: logo_url,
                        alt: "",
                        width: (0,_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .imageSize */ .gs)(x.display_name.toLowerCase().replace(/\s/g, "_")).width,
                        height: (0,_imports_files_pages_clients_activities_client_integrations__WEBPACK_IMPORTED_MODULE_1__/* .imageSize */ .gs)(x.display_name.toLowerCase().replace(/\s/g, "_")).height
                    }), false, false, "", "NA") || [];
                })
            ];
        });
    });
    return _setDisabledIntegrationData.apply(this, arguments);
}


/***/ }),

/***/ 41767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ ActivitiesAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14683);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96047);






var calander_array;
var ActivitiesAction = /*#__PURE__*/ function() {
    "use strict";
    function ActivitiesAction(setApiError, calanderData, setCalanderData, setActivitiesData, activitiesData, setConfirmation, setFlagForRerender, setOfferRejectReasons, router, setCalendarDataArray, setAgencyAcceptReject, setInfoModal) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, ActivitiesAction);
        var t = (0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
        this.errorPage = new _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .ErrorPages */ .dC();
        this.setApiError = setApiError;
        this.dashboardService = new _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .DashboardService */ .sp();
        this.setCalanderData = setCalanderData;
        calander_array = calanderData;
        this.activitiesData = activitiesData;
        this.setActivitiesData = setActivitiesData;
        this.customToastrAction = new _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .CustomToastrAction */ .Y5();
        this.setConfirmation = setConfirmation;
        this.mergeRecordsService = new _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .MergeRecordsService */ .GK();
        this.setFlagForRerender = setFlagForRerender;
        this.setOfferRejectReasons = setOfferRejectReasons;
        this.setInfoModal = setInfoModal;
        this.router = router;
        this.setCalendarDataArray = setCalendarDataArray;
        this.setAgencyAcceptReject = setAgencyAcceptReject;
        this.commonAction = new _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .CommonAction */ .x4();
        this.candidateMergeAction = new _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .CandidateMergeAction */ .ai({
            setApiError: setApiError,
            setFlagForRerender: setFlagForRerender,
            router: router,
            setAgencyAcceptReject: setAgencyAcceptReject,
            activitiesData: activitiesData,
            setActivitiesData: setActivitiesData
        }, t);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ActivitiesAction, [
        {
            key: "getDashboardData",
            value: function getDashboardData(router) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var dashboard_result, activity_result, status, result, _tmp;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.dashboardService.getDashboardData()
                                ];
                            case 1:
                                dashboard_result = _state.sent();
                                return [
                                    4,
                                    _this.dashboardService.getActivityData()
                                ];
                            case 2:
                                activity_result = _state.sent();
                                status = _this.errorPage.handleMultipleApiErrorCodes([
                                    dashboard_result === null || dashboard_result === void 0 ? void 0 : dashboard_result.request,
                                    activity_result === null || activity_result === void 0 ? void 0 : activity_result.request
                                ]);
                                _tmp = {};
                                result = (_tmp.dashboard_result = dashboard_result.data, _tmp.activity_result = activity_result.data, _tmp);
                                _this.setApiError(status);
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getActivityScrollData",
            value: function getActivityScrollData(type, activitiesData, setActivitiesData, setFlagForRerender, pageNumber, setPageNumber) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var body, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                body = "";
                                if (type == "alerts") {
                                    body = {
                                        alerts_page: pageNumber + 1
                                    };
                                } else {
                                    body = {
                                        comms_page: pageNumber + 1
                                    };
                                }
                                return [
                                    4,
                                    _this.dashboardService.getScrollActivityData(body)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                setPageNumber(pageNumber + 1);
                                if (type == "alerts") {
                                    activitiesData.alerts = activitiesData.alerts.concat(result.data.data.alerts);
                                    setActivitiesData(activitiesData);
                                } else {
                                    activitiesData.comms = activitiesData.comms.concat(result.data.data.comms);
                                    setActivitiesData(activitiesData);
                                }
                                setFlagForRerender(Math.random() * 10000);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "nextOnboardingStep",
            value: function nextOnboardingStep(step, router) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var result, _tmp, status_code, next_step, url;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                return [
                                    4,
                                    _this.dashboardService.updateOnboardingStep((_tmp.current_step = step, _tmp))
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                status_code = result.status || result.response.status;
                                switch(status_code){
                                    case _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .SUCCESS_REPONSE_CODE */ .Us:
                                        next_step = result.data.next_step;
                                        url = "".concat(_imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT.client.quick_setup */ .RQ.client.quick_setup).concat(next_step);
                                        next_step == "complete" ? router.push(_imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT.client.activities */ .RQ.client.activities) : router.push(url);
                                        break;
                                    default:
                                        (0,_imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .handleOtherResponseCode */ .GB)(status_code, router);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "dismissOnboarding",
            value: function dismissOnboarding(router, dashboardData, setDashboardData, setFlagForRerender) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var result, status_code;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.dashboardService.dismiss()
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                status_code = result.status || result.response.status;
                                switch(status_code){
                                    case _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .SUCCESS_REPONSE_CODE */ .Us:
                                        return [
                                            3,
                                            2
                                        ];
                                    case _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                                        return [
                                            3,
                                            4
                                        ];
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 2:
                                dashboardData.onboarding_dismissed = true;
                                return [
                                    4,
                                    setDashboardData(dashboardData)
                                ];
                            case 3:
                                _state.sent();
                                setFlagForRerender(Math.random() * 10000);
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                _this.customToastrAction.setNormalToastr(result.response.data.error, "warning");
                                _state.label = 5;
                            case 5:
                                (0,_imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .handleOtherResponseCode */ .GB)(status_code, router);
                                _state.label = 6;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "previousWeek",
            value: function previousWeek(event) {
                var container = document.querySelector(".SchedulingContainer");
                var header_element = container.childNodes[0];
                var scroll_direction = "up";
                this.getCalanderData(scroll_direction, header_element);
            }
        },
        {
            key: "nextWeek",
            value: function nextWeek(event) {
                var container = document.querySelector(".SchedulingContainer");
                var header_element = container.childNodes[0];
                var scroll_direction = "down";
                this.getCalanderData(scroll_direction, header_element);
            }
        },
        {
            key: "setInitialArrowData",
            value: function setInitialArrowData(setCurrentWeek, currentWeek) {
                if (document.querySelector("#Current_Week") && !currentWeek) {
                    var current_week = document.querySelector("#Current_Week").closest(".Week");
                    setCurrentWeek(current_week);
                }
            }
        },
        {
            key: "pagination",
            value: function pagination(event) {
                var element1 = event.target;
                if (element1.scrollHeight - element1.scrollTop === element1.clientHeight) {
                    var container = document.querySelector(".SchedulingContainer");
                    var header_element = container.childNodes[container.childNodes.length - 1];
                    var scroll_element = container.childNodes[container.childNodes.length - 3];
                    var scroll_direction = "down";
                    this.getCalanderData(scroll_direction, header_element, container, scroll_element);
                } else if (element1.scrollTop == 0) {
                    var container = document.querySelector(".SchedulingContainer");
                    var header_element = container.childNodes[0];
                    var scroll_element = container.childNodes[2];
                    var scroll_direction = "up";
                    this.getCalanderData(scroll_direction, header_element, container, scroll_element);
                }
            }
        },
        {
            key: "getCalanderData",
            value: function getCalanderData(direction, element1) {
                var week_year = element1.getAttribute("id").split("_");
                var body = "";
                if (direction == "up") {
                    var week = parseInt(week_year[0]) - 1 == 0 ? 52 : parseInt(week_year[0]) - 1;
                    var year = parseInt(week_year[0]) - 1 == 0 ? parseInt(week_year[1]) - 1 : parseInt(week_year[1]);
                    body = {
                        week: week,
                        year: year,
                        scroll: direction
                    };
                } else {
                    var week = parseInt(week_year[0]) + 1 == 53 ? 1 : parseInt(week_year[0]) + 1;
                    var year = parseInt(week_year[0]) + 1 == 53 ? parseInt(week_year[1]) + 1 : parseInt(week_year[1]);
                    body = {
                        week: week,
                        year: year,
                        scroll: direction
                    };
                }
                var k_this = this;
                this.dashboardService.getEventData(body).then(function(result) {
                    calander_array = result.data.data.events.data;
                    k_this.setCalanderData(calander_array);
                    var calendar_data_array = result.data.data.events.date_range_array;
                    k_this.setCalendarDataArray(calendar_data_array);
                });
            }
        },
        {
            key: "getCalanderDateData",
            value: function getCalanderDateData(calanderHash) {
                var week_year = element.getAttribute("id").split("_");
                var body = calanderHash;
                var k_this = this;
                this.dashboardService.getEventData(body).then(function(result) {
                    calander_array = result.data.data.events.data;
                    k_this.setCalanderData(calander_array);
                    var calendar_data_array = result.data.data.events.date_range_array;
                    k_this.setCalendarDataArray(calendar_data_array);
                });
            }
        },
        {
            key: "dismissNotification",
            value: function dismissNotification(current_element, type, setFlagForRerender, setConfirmation) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var body, _tmp, result, status_code, element1, activitiesData;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                body = _tmp;
                                if (type == "comms" || type == "alerts") {
                                    body.all = type;
                                } else {
                                    if (type == "comm_id") {
                                        body.id = current_element.classList.contains("Cross") ? current_element.getAttribute("data-comm_id") : current_element.closest("svg").getAttribute("data-comm_id");
                                    } else {
                                        body.id = current_element.classList.contains("Cross") ? current_element.getAttribute("data-alert_id") : current_element.closest("svg").getAttribute("data-alert_id");
                                    }
                                }
                                return [
                                    4,
                                    _this.dashboardService.dismissNotification(body)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                status_code = result.status || result.response.status;
                                switch(status_code){
                                    case _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .SUCCESS_REPONSE_CODE */ .Us:
                                        if (type != "comms" && type != "alerts") {
                                            element1 = current_element.closest(".NotificationSection__List");
                                            element1.style.display = "none";
                                            setConfirmation(false);
                                        } else {
                                            activitiesData = _this.activitiesData;
                                            activitiesData[type] = [];
                                            _this.setActivitiesData(activitiesData);
                                            setConfirmation(false);
                                            setFlagForRerender(Math.random() * 10000);
                                        }
                                    default:
                                        "";
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "nextStep",
            value: function nextStep(data, params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var modal_name, result, result_data, _tmp, _tmp1, _tmp2;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (data.href && data.href != "") {
                                    window.open(data.href, "");
                                }
                                if (!data.details) return [
                                    3,
                                    9
                                ];
                                modal_name = data.details.modal_name;
                                switch(modal_name){
                                    case "reject_offer_reason":
                                        return [
                                            3,
                                            1
                                        ];
                                    case "reject_job_reason":
                                        return [
                                            3,
                                            3
                                        ];
                                    case "job_approval_user_rejected_response":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "job_approval_rejected_response":
                                        return [
                                            3,
                                            6
                                        ];
                                    case "job_approval_user_approved_response_received":
                                        return [
                                            3,
                                            7
                                        ];
                                }
                                return [
                                    3,
                                    8
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.dashboardService.getOfferRejectedReason(data.details)
                                ];
                            case 2:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                result_data = result.data;
                                result_data.state = true;
                                params.setOfferRejectReasons(result_data);
                                return [
                                    3,
                                    9
                                ];
                            case 3:
                                return [
                                    4,
                                    _this.dashboardService.getOfferRejectedReason(data.details)
                                ];
                            case 4:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                result_data = result.data;
                                result_data.state = true;
                                _this.setOfferRejectReasons(result_data);
                                return [
                                    3,
                                    9
                                ];
                            case 5:
                                result_data = data.details.reason;
                                _tmp = {};
                                _this.setOfferRejectReasons((_tmp.state = true, _tmp.heading = "Rejection Reason", _tmp.reasons = data.details.reason, _tmp.job_status = "Rejected", _tmp));
                                // this.setInfoModal({state: true, heading: 'Rejection Reason', message: data.details.reasons, job_status: 'Rejected'})
                                return [
                                    3,
                                    9
                                ];
                            case 6:
                                _tmp1 = {};
                                _this.setInfoModal((_tmp1.state = true, _tmp1.heading = "Rejection Reasons", _tmp1.message = data.details.reasons, _tmp1.job_status = "Rejected", _tmp1));
                                // this.setInfoModal({state: true, heading: 'Rejection Reason', message: data.details.reasons, job_status: 'Rejected'})
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                result_data = data.details;
                                _tmp2 = {};
                                _this.setInfoModal((_tmp2.state = true, _tmp2.heading = "Approver", _tmp2.message = result_data.message, _tmp2.job_status = "", _tmp2));
                                // this.setInfoModal({state: true, heading: 'Rejection Reason', message: data.details.reasons, job_status: 'Rejected'})
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                data.details.show_accept_reject ? _this.candidateMergeAction.showAcceptReject(data) : "";
                                _state.label = 9;
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMyInterviewData",
            value: function getMyInterviewData(event, calendarHash) {
                this.setTabActive(event);
                var body = {};
                body["current_date"] = this.commonAction.getParamsToUrlWithoutRouter("current_date") ? this.commonAction.getParamsToUrlWithoutRouter("current_date") : this.commonAction.getDateInDMYFormat(new Date());
                body["selected_tab"] = this.commonAction.getParamsToUrlWithoutRouter("selected_tab") ? this.commonAction.getParamsToUrlWithoutRouter("selected_tab") : "month";
                body["is_my_interviews"] = true;
                body = {
                    activities: body
                };
                var k_this = this;
                calendarHash["selected_tab"] = "month";
                calendarHash["current_date"] = this.commonAction.getParamsToUrlWithoutRouter("current_date") ? this.commonAction.getParamsToUrlWithoutRouter("current_date") : this.commonAction.getDateInDMYFormat(new Date());
                calendarHash["is_my_interviews"] = true;
                this.commonAction.paramsToUrlWithoutRouter(calendarHash, this.router);
                this.dashboardService.getEventData(body).then(function(result) {
                    calander_array = result.data.data.events.data;
                    k_this.setCalanderData(calander_array);
                    var calendar_data_array = result.data.data.events.date_range_array;
                    k_this.setCalendarDataArray(calendar_data_array);
                });
            }
        },
        {
            key: "getTeamInterviewData",
            value: function getTeamInterviewData(event, calendarHash) {
                this.setTabActive(event);
                var body = {};
                body["current_date"] = this.commonAction.getParamsToUrlWithoutRouter("current_date") ? this.commonAction.getParamsToUrlWithoutRouter("current_date") : this.commonAction.getDateInDMYFormat(new Date());
                body["selected_tab"] = this.commonAction.getParamsToUrlWithoutRouter("selected_tab") ? this.commonAction.getParamsToUrlWithoutRouter("selected_tab") : "month";
                body["is_my_interviews"] = false;
                body = {
                    activities: body
                };
                var k_this = this;
                calendarHash["selected_tab"] = "month";
                calendarHash["current_date"] = this.commonAction.getParamsToUrlWithoutRouter("current_date") ? this.commonAction.getParamsToUrlWithoutRouter("current_date") : this.commonAction.getDateInDMYFormat(new Date());
                calendarHash["is_my_interviews"] = false;
                this.commonAction.paramsToUrlWithoutRouter(calendarHash, this.router);
                this.dashboardService.getEventData(body).then(function(result) {
                    calander_array = result.data.data.events.data;
                    k_this.setCalanderData(calander_array);
                    var calendar_data_array = result.data.data.events.date_range_array;
                    k_this.setCalendarDataArray(calendar_data_array);
                });
            }
        },
        {
            key: "setTabActive",
            value: function setTabActive(event) {
                var all_tab = document.querySelectorAll(".ReactInterviewTypeTab");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = all_tab[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element1 = _step.value;
                        element1.classList.remove("TabActiveUnderline");
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                event.target.classList.add("TabActiveUnderline");
            }
        },
        {
            key: "onSelectTab",
            value: function onSelectTab(setTabIndex, tabIndex, calendarHash, setTodayClick) {
                setTabIndex(tabIndex);
                setTodayClick(false);
                calendarHash.current_date = this.commonAction.getDateInDMYFormat(calendarHash.current_date);
                switch(tabIndex){
                    case 0:
                        calendarHash.selected_tab = "day";
                        break;
                    case 1:
                        calendarHash.selected_tab = "week";
                        break;
                    case 2:
                        calendarHash.selected_tab = "month";
                        break;
                    default:
                        calendarHash.selected_tab = "month";
                }
                this.commonAction.paramsToUrlWithoutRouter(calendarHash, this.router);
            }
        }
    ]);
    return ActivitiesAction;
}();


/***/ }),

/***/ 74527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ DaxtraScoreAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38641);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62286);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);





var DaxtraScoreAction = /*#__PURE__*/ function() {
    "use strict";
    function DaxtraScoreAction(args) {
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, DaxtraScoreAction);
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "renderScoreBox", function(score) {
            var small_box = [];
            var convertedScore = _this.gradeScore(score);
            var index = 0;
            switch(convertedScore){
                case 1:
                    _this.loop(1, function(i) {
                        small_box.push(_this.smallBox("red"));
                    });
                    break;
                case 2:
                    _this.loop(2, function(i) {
                        small_box.push(_this.smallBox("yellow"));
                    });
                    break;
                case 3:
                    _this.loop(3, function(i) {
                        small_box.push(_this.smallBox("yellow"));
                    });
                    break;
                case 4:
                    _this.loop(4, function(i) {
                        small_box.push(_this.smallBox("green"));
                    });
                    break;
                case 5:
                    _this.loop(5, function(i) {
                        small_box.push(_this.smallBox("green"));
                    });
                    break;
            }
            index = convertedScore;
            for(var i = index; i < 5; i++){
                small_box.push(_this.smallBox("grey"));
            }
            return small_box;
        });
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "renderSkillScore", function(job_application_skills) {
            var layout = [];
            if (job_application_skills.matching_skills) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(job_application_skills.matching_skills)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_step.value, 2), key = _value[0], value = _value[1];
                        layout.push(_this.smallSkill(key, value));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            if (job_application_skills.not_matching_skills) {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = Object.entries(job_application_skills.not_matching_skills)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _value1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_step1.value, 2), key1 = _value1[0], value1 = _value1[1];
                        layout.push(_this.smallSkill(key1, 0));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
            return layout;
        });
        this.PageStyle = args.PageStyle;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(DaxtraScoreAction, [
        {
            key: "daxtraScore",
            value: function daxtraScore(score) {
                if (!isNaN(parseInt(score))) {
                    return this.renderScoreBox(score);
                } else return this.renderScoreBox(0);
            }
        },
        {
            key: "gradeScore",
            value: function gradeScore(score) {
                score = parseInt(score);
                switch(true){
                    case score >= 1 && score <= 20:
                        return 1;
                    case score >= 21 && score <= 40:
                        return 2;
                    case score >= 41 && score <= 60:
                        return 3;
                    case score >= 61 && score <= 80:
                        return 4;
                    case score >= 81 && score <= 100:
                        return 5;
                    default:
                        return 0;
                }
            }
        },
        {
            key: "loop",
            value: function loop(times, callback) {
                for(var i = 0; i < times; i++){
                    callback(i);
                }
            }
        },
        {
            key: "smallBox",
            value: function smallBox(color) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "".concat(this.PageStyle.SmallBox, " ").concat(color, "-box-bg")
                });
            }
        },
        {
            key: "smallSkill",
            value: function smallSkill(key, value) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "".concat(this.PageStyle.ScoreBox__SkillDetail),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "".concat(this.PageStyle.ScoreBox__Skills_Name, "  ").concat(this.PageStyle.ScoreBox__Skills_Width100),
                            children: key.replace(/_/g, " ")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "".concat(this.PageStyle.ScoreBox__Skills_Score),
                            children: this.renderScoreBox(value)
                        })
                    ]
                });
            }
        }
    ]);
    return DaxtraScoreAction;
}();


/***/ }),

/***/ 21572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C$": function() { return /* binding */ performAction; },
/* harmony export */   "CZ": function() { return /* binding */ showUnsuccessful; },
/* harmony export */   "DU": function() { return /* binding */ syncNowHiredData; },
/* harmony export */   "E6": function() { return /* binding */ hideCompareCandidate; },
/* harmony export */   "Gu": function() { return /* binding */ automationPopup; },
/* harmony export */   "HD": function() { return /* binding */ sendCustomTechTest; },
/* harmony export */   "Iw": function() { return /* binding */ handleLaneCheckbox; },
/* harmony export */   "JE": function() { return /* binding */ getScorecards; },
/* harmony export */   "Jb": function() { return /* binding */ addToAnotherJob; },
/* harmony export */   "KF": function() { return /* binding */ markActiveUnsuccessful; },
/* harmony export */   "Ki": function() { return /* binding */ NumberField; },
/* harmony export */   "LA": function() { return /* binding */ getFilterdData; },
/* harmony export */   "M": function() { return /* binding */ send_unsuccessful_email; },
/* harmony export */   "NY": function() { return /* binding */ showAddCandidate; },
/* harmony export */   "Oj": function() { return /* binding */ getOfferHash; },
/* harmony export */   "Ow": function() { return /* binding */ redirectContractPage; },
/* harmony export */   "Qz": function() { return /* binding */ isScheduledInterview; },
/* harmony export */   "Si": function() { return /* binding */ handleCardCheckbox; },
/* harmony export */   "Sr": function() { return /* binding */ addParamsToUrl; },
/* harmony export */   "VD": function() { return /* binding */ KanbanActions; },
/* harmony export */   "Wg": function() { return /* binding */ setAutomationHash; },
/* harmony export */   "Yn": function() { return /* binding */ sendOfferToCandidate; },
/* harmony export */   "b8": function() { return /* binding */ sendQuestions; },
/* harmony export */   "bp": function() { return /* binding */ onCancelClick; },
/* harmony export */   "dd": function() { return /* binding */ showErrors; },
/* harmony export */   "ds": function() { return /* binding */ reviewAutomationEmail; },
/* harmony export */   "gw": function() { return /* binding */ showCompareCandidate; },
/* harmony export */   "h9": function() { return /* binding */ getSingleScorecard; },
/* harmony export */   "hh": function() { return /* binding */ runAutomations; },
/* harmony export */   "jM": function() { return /* binding */ manageAutomationTimer; },
/* harmony export */   "jk": function() { return /* binding */ moveToNextStage; },
/* harmony export */   "kc": function() { return /* binding */ fetchMoreData; },
/* harmony export */   "pr": function() { return /* binding */ compareCandidateScorecards; },
/* harmony export */   "sZ": function() { return /* binding */ clearRadioButtonSelection; },
/* harmony export */   "t7": function() { return /* binding */ closeJob; },
/* harmony export */   "tk": function() { return /* binding */ getReasonsList; },
/* harmony export */   "uX": function() { return /* binding */ automationClick; },
/* harmony export */   "z6": function() { return /* binding */ showAddOffer; },
/* harmony export */   "zb": function() { return /* binding */ submitOffer; }
/* harmony export */ });
/* unused harmony exports getCandidatesFromDatabase, getEmails, isNotSent */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18186);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4012);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47942);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30711);
/* harmony import */ var _actions_components_candidate_email__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20344);
/* harmony import */ var lodash_clonedeep__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10552);
/* harmony import */ var lodash_clonedeep__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_clonedeep__WEBPACK_IMPORTED_MODULE_4__);











var TIMER_CONSTANT = 10;
function onCancelClick() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    (ref = document.getElementsByClassName("add-candidate-section")[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.add("displaynone");
    (ref2 = document.getElementsByClassName("add-offer-section")[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.classList) === null || ref3 === void 0 ? void 0 : ref3.add("displaynone");
    (ref4 = document.getElementsByClassName("kanban-job-section")[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.classList) === null || ref5 === void 0 ? void 0 : ref5.remove("displaynone");
    (ref6 = document.getElementsByClassName("job-application-view-section")[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.classList) === null || ref7 === void 0 ? void 0 : ref7.remove("displaynone");
}
function showAddCandidate(setShowCandidate) {
    setShowCandidate(true);
    document.getElementsByClassName("kanban-job-section")[0].classList.add("displaynone");
    document.getElementsByClassName("add-candidate-section")[0].classList.remove("displaynone");
}
function showAddOffer(setShowOffer, from) {
    var ref, ref1;
    setShowOffer(true);
    if (from == "application_view") (ref = document.getElementsByClassName("job-application-view-section")[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.add("displaynone");
    else document.getElementsByClassName("kanban-job-section")[0].classList.add("displaynone");
    document.getElementsByClassName("add-offer-section")[0].classList.remove("displaynone");
}
function showCompareCandidate() {
    document.getElementsByClassName("kanban-job-section")[0].classList.add("displaynone");
    document.getElementsByClassName("compare-candidate-section")[0].classList.remove("displaynone");
}
function hideCompareCandidate() {
    document.getElementsByClassName("kanban-job-section")[0].classList.remove("displaynone");
    document.getElementsByClassName("compare-candidate-section")[0].classList.add("displaynone");
}
function NumberField(param) {
    var field = param.field, className = param.className, disabled = param.disabled, format = param.format, placeholder = param.placeholder;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, field), {
        placeholder: placeholder,
        format: format,
        name: field.name,
        className: className,
        disabled: disabled
    }));
}
function submitOffer(args) {
    return _submitOffer.apply(this, arguments);
}
function _submitOffer() {
    _submitOffer = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(args) {
        var result, _tmp, customToastrAction, status_code, _tmp1, _tmp2, ref, ref1, message, offer_error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    result = _tmp;
                    args.values.from = args.from;
                    customToastrAction = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    args.setShowLoader(true);
                    if (!args.offer_id) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().updateOffer(args.values, args.offer_id)
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().createOffer(args.values)
                    ];
                case 3:
                    result = _state.sent();
                    _state.label = 4;
                case 4:
                    status_code = result.status || result.response.status;
                    args.setShowLoader(false);
                    _tmp1 = {};
                    _tmp2 = {};
                    switch(status_code){
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            if (args.from == "kanban") {
                                args.setJobData(result.data.kanban_data);
                            }
                            if (args.from == "application_view") {
                                args.setInitialData(result.data.application_data);
                            }
                            if (args.syncNowBtnClick) {
                                if (args.from == "application_view") {
                                    syncNowHiredData(args.router.query.job_id, (_tmp1.job_application_id = result.data.application_data.application.id, _tmp1.from = args.from, _tmp1));
                                } else {
                                    syncNowHiredData(args.router.query.job_id, (_tmp2.job_application_id = args.values.offer.job_application_id, _tmp2.from = args.from, _tmp2.setHiredSyncNowBtn = args.setHiredSyncNowBtn, _tmp2.setHiredSyncModal = args.setHiredSyncModal, _tmp2.setJobData = args.setJobData, _tmp2));
                                }
                            }
                            onCancelClick();
                            customToastrAction.setNormalToastr(result.data.success, "success");
                            break;
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            ;
                            message = "";
                            if ((ref = result.response.data.error.offer) === null || ref === void 0 ? void 0 : ref.offer_approver_emails) {
                                message += "".concat(result.response.data.error.offer.offer_approver_emails);
                            }
                            if ((ref1 = result.response.data.error.offer) === null || ref1 === void 0 ? void 0 : ref1.new_user_emails) {
                                message += "".concat(result.response.data.error.offer.new_user_emails);
                            }
                            if (message.length > 0) {
                                new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5().setNormalToastr(message, "error");
                            } else {
                                customToastrAction.setNormalToastr("Offer has already been created.", "error");
                            }
                            offer_error = result.response.data.error;
                            delete offer_error.offer["offer_approver_emails"];
                            return [
                                2,
                                result.response.data
                            ];
                            break;
                        default:
                            (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, args.router);
                    }
                    args.setShowLoader(false);
                    return [
                        2
                    ];
            }
        });
    });
    return _submitOffer.apply(this, arguments);
}
function fetchMoreData(job_slug, job_stage_id, page, status, per_page, router1, filterData) {
    return _fetchMoreData.apply(this, arguments);
}
function _fetchMoreData() {
    _fetchMoreData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(job_slug, job_stage_id, page, status, per_page, router1, filterData) {
        var params, _tmp, result, status_code, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    params = Object.assign(_tmp, filterData);
                    params.page = page;
                    params.per_page = per_page;
                    params.job_stage_id = job_stage_id;
                    params.status = status;
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().filterdKanbanData(job_slug, params)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            return [
                                2,
                                result.data.kanban_data.lanes[0].cards || []
                            ];
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "error");
                            break;
                        default:
                            (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router1);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchMoreData.apply(this, arguments);
}
function automationClick(job_id, job_stage_id, setCurrentStage, setBtnPopup, router1, isOpen) {
    (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .mangeInterviews */ .eF)(job_id, {
        id: job_stage_id
    }, setCurrentStage, setBtnPopup, router1, isOpen);
}
function getFilterdData(job_slug, filterData, setJobData, status, setSelectedCards, setActionBar) {
    return _getFilterdData.apply(this, arguments);
}
function _getFilterdData() {
    _getFilterdData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(job_slug, filterData, setJobData, status, setSelectedCards, setActionBar) {
        var result, status_code;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    filterData.status = status;
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().filterdKanbanData(job_slug, filterData)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    switch(status_code){
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            return [
                                3,
                                2
                            ];
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            return [
                                3,
                                4
                            ];
                    }
                    return [
                        3,
                        5
                    ];
                case 2:
                    return [
                        4,
                        setJobData(result.data.kanban_data)
                    ];
                case 3:
                    _state.sent();
                    clearRadioButtonSelection(setSelectedCards, status, setActionBar);
                    return [
                        3,
                        6
                    ];
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                    _state.label = 6;
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return _getFilterdData.apply(this, arguments);
}
function closeJob(job_id, router1) {
    return _closeJob.apply(this, arguments);
}
function _closeJob() {
    _closeJob = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(job_id, router1) {
        var result, status_code;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().closeJob(job_id)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    switch(status_code){
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            window.location.reload();
                            break;
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            break;
                        default:
                            (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router1);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _closeJob.apply(this, arguments);
}
function getCandidatesFromDatabase(args) {
    return _getCandidatesFromDatabase.apply(this, arguments);
}
function _getCandidatesFromDatabase() {
    _getCandidatesFromDatabase = _async_to_generator(function(args) {
        var result, status_code, customToastrAction;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new Kanban().importCandidates(args.job_id)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new CustomToastrAction();
                    switch(status_code){
                        case SUCCESS_REPONSE_CODE:
                            args.setJobData(result.data.kanban_data);
                            if (result.data.automations_hsh) setAutomationHash(args, result.data.automations_hsh);
                            manageAutomationTimer(args);
                            args.setLoading(false);
                            customToastrAction.setNormalToastr(result.data.success, "success");
                            break;
                        case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
                            args.setLoading(false);
                            customToastrAction.setNormalToastr(result.response.data.error, "error");
                            break;
                        default:
                            args.setLoading(false);
                            handleOtherResponseCode(status_code, args.router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getCandidatesFromDatabase.apply(this, arguments);
}
function addParamsToUrl(queryParams, router1) {
    router1.push({
        pathname: router1.asPath.split("?")[0],
        query: queryParams
    });
}
function handleCardCheckbox(event, selectedCards, setSelectedCards, actions, setActions, setActionBar, totalCardsCount, jobData, activeTab) {
    return _handleCardCheckbox.apply(this, arguments);
}
function _handleCardCheckbox() {
    _handleCardCheckbox = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(event, selectedCards, setSelectedCards, actions, setActions, setActionBar, totalCardsCount, jobData, activeTab) {
        var stage_id, application_id, page_all_checkbox, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, selected_lane, page_parent_checkbox;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    stage_id = event.target.getAttribute("data-stage_id");
                    application_id = event.target.getAttribute("data-application_id");
                    if (!event.target.checked) return [
                        3,
                        11
                    ];
                    if (!(stage_id == selectedCards.stage_id)) return [
                        3,
                        5
                    ];
                    if (selectedCards.job_application_ids.indexOf("all") != -1) {
                        selectedCards.rejected_ids.splice(selectedCards.rejected_ids.indexOf(application_id), 1);
                    } else {
                        selectedCards.job_application_ids.push(application_id);
                    }
                    return [
                        4,
                        setSelectedCards(selectedCards)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        modifyActions(jobData, selectedCards, actions)
                    ];
                case 2:
                    return [
                        4,
                        setActions.apply(void 0, [
                            _state.sent()
                        ])
                    ];
                case 3:
                    _state.sent();
                    return [
                        4,
                        setActionBar(true)
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        10
                    ];
                case 5:
                    page_all_checkbox = document.querySelectorAll('.react-trello-board input[type="checkbox"]');
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = page_all_checkbox[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            element = _step.value;
                            element.checked = false;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    event.target.checked = true;
                    selectedCards.stage_id = stage_id;
                    selectedCards.job_application_ids = [
                        application_id
                    ];
                    selectedCards.rejected_ids = [];
                    return [
                        4,
                        setSelectedCards(selectedCards)
                    ];
                case 6:
                    _state.sent();
                    return [
                        4,
                        modifyActions(jobData, selectedCards, actions)
                    ];
                case 7:
                    return [
                        4,
                        setActions.apply(void 0, [
                            _state.sent()
                        ])
                    ];
                case 8:
                    _state.sent();
                    return [
                        4,
                        setActionBar(true)
                    ];
                case 9:
                    _state.sent();
                    _state.label = 10;
                case 10:
                    return [
                        3,
                        21
                    ];
                case 11:
                    if (!(stage_id == selectedCards.stage_id)) return [
                        3,
                        21
                    ];
                    if (selectedCards.job_application_ids.indexOf(application_id) != -1) selectedCards.job_application_ids.splice(selectedCards.job_application_ids.indexOf(application_id), 1);
                    selected_lane = event.target.closest(".react-trello-lane");
                    page_parent_checkbox = selected_lane.querySelectorAll('input[type="checkbox"]')[0];
                    page_parent_checkbox.checked = false;
                    if (selectedCards.job_application_ids.indexOf("all") != -1) {
                        selectedCards.rejected_ids.push(application_id);
                    }
                    return [
                        4,
                        setSelectedCards(selectedCards)
                    ];
                case 12:
                    _state.sent();
                    if (!(selectedCards.rejected_ids.length == totalCardsCount)) return [
                        3,
                        15
                    ];
                    selectedCards.job_application_ids = [];
                    selectedCards.rejected_ids = [];
                    selectedCards.stage_id = "";
                    return [
                        4,
                        setSelectedCards(selectedCards)
                    ];
                case 13:
                    _state.sent();
                    return [
                        4,
                        setActionBar(false)
                    ];
                case 14:
                    _state.sent();
                    return [
                        3,
                        21
                    ];
                case 15:
                    if (!(selectedCards.job_application_ids.length > 0)) return [
                        3,
                        19
                    ];
                    return [
                        4,
                        modifyActions(jobData, selectedCards, actions)
                    ];
                case 16:
                    return [
                        4,
                        setActions.apply(void 0, [
                            _state.sent()
                        ])
                    ];
                case 17:
                    _state.sent();
                    return [
                        4,
                        setActionBar(true)
                    ];
                case 18:
                    _state.sent();
                    return [
                        3,
                        21
                    ];
                case 19:
                    return [
                        4,
                        setActionBar(false)
                    ];
                case 20:
                    _state.sent();
                    _state.label = 21;
                case 21:
                    return [
                        2
                    ];
            }
        });
    });
    return _handleCardCheckbox.apply(this, arguments);
}
function handleLaneCheckbox(event, selectedCards, setSelectedCards, actions, setActions, setActionBar, jobData, activeTab) {
    return _handleLaneCheckbox.apply(this, arguments);
}
function _handleLaneCheckbox() {
    _handleLaneCheckbox = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(event, selectedCards, setSelectedCards, actions, setActions, setActionBar, jobData, activeTab) {
        var stage_id, selected_lane, page_all_checkbox, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, page_all_checkbox1, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, element, selected_lane1, page_stage_checkbox, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, element, page_all_checkbox2, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, element;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    stage_id = event.target.getAttribute("data-stage_id");
                    if (!event.target.checked) return [
                        3,
                        11
                    ];
                    if (!(stage_id == selectedCards.stage_id)) return [
                        3,
                        5
                    ];
                    selectedCards.job_application_ids = [
                        "all"
                    ];
                    selectedCards.rejected_ids = [];
                    return [
                        4,
                        setSelectedCards(selectedCards)
                    ];
                case 1:
                    _state.sent();
                    selected_lane = event.target.closest(".react-trello-lane");
                    page_all_checkbox = selected_lane.querySelectorAll('input[type="checkbox"]:not(:disabled)');
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = page_all_checkbox[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            element = _step.value;
                            element.checked = true;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        4,
                        modifyActions(jobData, selectedCards, actions)
                    ];
                case 2:
                    return [
                        4,
                        setActions.apply(void 0, [
                            _state.sent()
                        ])
                    ];
                case 3:
                    _state.sent();
                    return [
                        4,
                        setActionBar(true)
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        10
                    ];
                case 5:
                    page_all_checkbox1 = document.querySelectorAll('.react-trello-board input[type="checkbox"]');
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(_iterator1 = page_all_checkbox1[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            element = _step1.value;
                            element.checked = false;
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    event.target.checked = true;
                    selectedCards.job_application_ids = [
                        "all"
                    ];
                    selectedCards.rejected_ids = [];
                    selectedCards.stage_id = stage_id;
                    selectedCards.status = activeTab;
                    selected_lane1 = event.target.closest(".react-trello-lane");
                    page_stage_checkbox = selected_lane1.querySelectorAll('input[type="checkbox"]:not(:disabled)');
                    _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(_iterator2 = page_stage_checkbox[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            element = _step2.value;
                            element.checked = true;
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                    return [
                        4,
                        modifyActions(jobData, selectedCards, actions)
                    ];
                case 6:
                    return [
                        4,
                        setActions.apply(void 0, [
                            _state.sent()
                        ])
                    ];
                case 7:
                    _state.sent();
                    return [
                        4,
                        setActions(actions)
                    ];
                case 8:
                    _state.sent();
                    return [
                        4,
                        setActionBar(true)
                    ];
                case 9:
                    _state.sent();
                    _state.label = 10;
                case 10:
                    return [
                        3,
                        14
                    ];
                case 11:
                    page_all_checkbox2 = document.querySelectorAll('.react-trello-board input[type="checkbox"]');
                    _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                    try {
                        for(_iterator3 = page_all_checkbox2[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                            element = _step3.value;
                            element.checked = false;
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                _iterator3.return();
                            }
                        } finally{
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                    selectedCards.job_application_ids = [];
                    selectedCards.rejected_ids = [];
                    selectedCards.stage_id = "";
                    selectedCards.status = activeTab;
                    return [
                        4,
                        setSelectedCards(selectedCards)
                    ];
                case 12:
                    _state.sent();
                    return [
                        4,
                        setActionBar(false)
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        2
                    ];
            }
        });
    });
    return _handleLaneCheckbox.apply(this, arguments);
}
function modifyActions(jobData, selectedCards, actions) {
    return _modifyActions.apply(this, arguments);
}
function _modifyActions() {
    _modifyActions = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(jobData, selectedCards, actions) {
        var lane, visibleAction, _tmp, actionsCopy, _tmp1, actionsCopy1, _tmp2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    lane = jobData.lanes.filter(function(x) {
                        return x.id.toString() == selectedCards.stage_id;
                    })[0];
                    if (!([
                        _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .JOB_STAGES.SCREENING */ .eP.SCREENING,
                        _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .JOB_STAGES.INTERVIEW */ .eP.INTERVIEW
                    ].includes(lane.stage) && !lane.automation)) return [
                        3,
                        2
                    ];
                    _tmp = {};
                    return [
                        4,
                        isNotSent((_tmp.selectedCards = selectedCards, _tmp.job_data = jobData, _tmp))
                    ];
                case 1:
                    visibleAction = _state.sent();
                    _tmp1 = {};
                    _tmp2 = {};
                    if (visibleAction) {
                        actionsCopy = Object.assign(_tmp1, actions);
                        actionsCopy.other = actions.other.filter(function(x) {
                            return x.name != "setup_new_interview";
                        });
                        return [
                            2,
                            actionsCopy
                        ];
                    } else {
                        actionsCopy1 = Object.assign(_tmp2, actions);
                        actionsCopy1.actions = actions.actions.filter(function(x) {
                            return x.name != "setup_interview";
                        });
                        return [
                            2,
                            actionsCopy1
                        ];
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    return [
                        2,
                        actions
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _modifyActions.apply(this, arguments);
}
function showUnsuccessful(job_data, stage_id, status) {
    var stage = job_data.lanes.filter(function(x) {
        return x.id == stage_id.toString();
    })[0];
    var stageCategory = stage === null || stage === void 0 ? void 0 : stage.stage_category;
    if (status == "unsuccessful") return false;
    if (stageCategory == "interview") {
        return true;
    }
    return false;
}
function performAction(args) {
    return _performAction.apply(this, arguments);
}
function _performAction() {
    _performAction = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(args) {
        var unsuccessfulPopup;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            unsuccessfulPopup = showUnsuccessful(args.job_data, args.selectedCards.stage_id, args.activeTab);
            if (args.moving_status == "active") {
                // args.setIsActiveEmail(true)
                // args.setCandidateEmailModal(true);
                args.setIsActiveConfirmation(true);
            } else if (isPendingInterview(args)) {
                args.setUnsuccessConfirmation(true);
            } else if (unsuccessfulPopup) {
                args.setUnsuccessfulModal(true);
            } else {
                markActiveUnsuccessful(args);
            }
            return [
                2
            ];
        });
    });
    return _performAction.apply(this, arguments);
}
function markActiveUnsuccessful(args) {
    return _markActiveUnsuccessful.apply(this, arguments);
}
function _markActiveUnsuccessful() {
    _markActiveUnsuccessful = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(args) {
        var result, status_code, customToastrAction, ref, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    args.selectedCards.status = args.activeTab;
                    args.selectedCards.moving_status = args.moving_status;
                    if (args.from == "kanban") args.filterData.status = args.activeTab;
                    args.filterData.kanban = args.selectedCards;
                    args.filterData.from = args.from;
                    args.setLoading(true);
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().markActiveUnsuccessful(args.job_id, args.filterData)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            return [
                                3,
                                2
                            ];
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            return [
                                3,
                                11
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    args.setLoading(false);
                    if (!(args.from == "kanban")) return [
                        3,
                        9
                    ];
                    if (!(args.moving_status == "unsuccessful")) return [
                        3,
                        7
                    ];
                    if (!args.setCandidateCount) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        args.setCandidateCount(getCandidateCount(args.job_data || args.jobData, args.selectedCards))
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    if (!args.setFirstCandidateName) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        args.setFirstCandidateName((0,_actions_components_candidate_email__WEBPACK_IMPORTED_MODULE_3__/* .getCandidateName */ .o5)(args.selectedCards))
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        3,
                        8
                    ];
                case 7:
                    clearRadioButtonSelection(args.setSelectedCards, args.activeTab, args.setActionBar);
                    _state.label = 8;
                case 8:
                    args.setJobData(result.data.kanban_data);
                    return [
                        3,
                        10
                    ];
                case 9:
                    args.setInitialData(result.data.application_data);
                    _state.label = 10;
                case 10:
                    if (((ref = args.selectedCards) === null || ref === void 0 ? void 0 : ref.reason_id) && args.setUnsuccessfulModal) {
                        args.setUnsuccessfulModal(false);
                    }
                    if (result.data.automations_hsh) {
                        setAutomationHash(args, result.data.automations_hsh);
                        manageAutomationTimer(args);
                    }
                    if (result.data.warning && result.data.warning.length > 0) {
                        customToastrAction.setNormalToastr(result.data.warning, "error");
                    } else {
                        customToastrAction.setNormalToastr(result.data.success, "success");
                    }
                    if (args.setIsActiveConfirmation) args.setIsActiveConfirmation(false);
                    if (args.setUnsuccessConfirmation) args.setUnsuccessConfirmation(false);
                    _tmp = {};
                    if (args.setUnsuccessfulEmailConfirmation && args.moving_status == "unsuccessful") args.setUnsuccessfulEmailConfirmation((_tmp.state = true, _tmp.unsuccessful_candidates_token = result.data.unsuccessful_candidates_token, _tmp));
                    return [
                        3,
                        13
                    ];
                case 11:
                    args.setLoading(false);
                    customToastrAction.setNormalToastr(result.response.data.error, "error");
                    // toastr.error(result.response.data.error)
                    return [
                        3,
                        13
                    ];
                case 12:
                    args.setLoading(false);
                    (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, args.router);
                    _state.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
    return _markActiveUnsuccessful.apply(this, arguments);
}
function addToAnotherJob(job_id, selectedJobId, params, router1, setCandidateAddToJobModal, setAutomationActions, setAutomationBar, restart, setTimerStatus, from, setSelectedCards, activeTab, setActionBar) {
    return _addToAnotherJob.apply(this, arguments);
}
function _addToAnotherJob() {
    _addToAnotherJob = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(job_id, selectedJobId, params, router1, setCandidateAddToJobModal, setAutomationActions, setAutomationBar, restart, setTimerStatus, from, setSelectedCards, activeTab, setActionBar) {
        var result, status_code, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params.job_id = selectedJobId;
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().addToJob(job_id, params)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            if (from == "kanban") clearRadioButtonSelection(setSelectedCards, activeTab, setActionBar);
                            // setAutomationHash({setAutomationActions: setAutomationActions, showAutomationPopup: false, setAutomationBar: setAutomationBar}, result.data.automations_hsh)
                            setCandidateAddToJobModal(false);
                            // manageAutomationTimer({restart: restart, setTimerStatus: setTimerStatus  })
                            customToastrAction.setNormalToastr(result.data.success, "success");
                            break;
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            setCandidateAddToJobModal(false);
                            customToastrAction.setNormalToastr(result.response.data.error, "error");
                            break;
                        default:
                            (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router1);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _addToAnotherJob.apply(this, arguments);
}
function sendCustomTechTest(args) {
    return _sendCustomTechTest.apply(this, arguments);
}
function _sendCustomTechTest() {
    _sendCustomTechTest = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(args) {
        var ref, ref1, ref2, ref3, sortByFilterData, result, status_code, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    args.params.days_to_expire = args.values.days_to_expire;
                    args.params.test_id = args.values.test_id;
                    args.params.test_type = args.values.test_type;
                    args.params.member_emails = args.values.member_emails;
                    args.params.assessment = args.values.assessment;
                    if (args.from == "application_view") {
                        ;
                        args.params.candidate_index = (ref = args.router) === null || ref === void 0 ? void 0 : (ref1 = ref.query) === null || ref1 === void 0 ? void 0 : ref1.candidate_index;
                        args.params.base_stage_id = (ref2 = args.router) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.query) === null || ref3 === void 0 ? void 0 : ref3.job_stage_id;
                        sortByFilterData = (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .ApplicationFilter */ .it)(args.job_id);
                        if (sortByFilterData) {
                            args.application_filter_data = sortByFilterData;
                        }
                    }
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().sendTechTest(args.job_id, args.params, args.from, args.application_filter_data)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            args.setBtnPopup(false);
                            if (args.from == "kanban") {
                                clearRadioButtonSelection(args.setSelectedCards, args.activeTab, args.setActionBar);
                                if (result.data.kanban_data) args.setJobData(result.data.kanban_data);
                            }
                            if (args.from == "application_view") {
                                args.setInitialData(result.data.application_data);
                            }
                            if (result.data.warning && result.data.warning.length > 0) {
                                customToastrAction.setNormalToastr(result.data.warning, "error");
                            } else {
                                customToastrAction.setNormalToastr(result.data.success, "success");
                            }
                            break;
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            args.setBtnPopup(false);
                            customToastrAction.setNormalToastr(result.response.data.error, "error");
                            break;
                        default:
                            (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, args.router);
                    }
                    args.setFlagForRerender(Math.random() * 10000);
                    return [
                        2
                    ];
            }
        });
    });
    return _sendCustomTechTest.apply(this, arguments);
}
function showErrors(errors) {
    var message = "";
    Object.keys(errors).map(function(x) {
        switch(x){
            case "calendars_connected":
                message = message += "".concat(errors.calendars_connected, " </br>");
                break;
            case "video_platforms_connected":
                message = message += "".concat(errors.video_platforms_connected, " </br>");
                break;
            case "available_slots":
                message = message += "".concat(errors.available_slots, " </br>");
                break;
        }
    });
    return message;
}
function automationPopup(jobData, stage_id) {
    var currentLane = jobData.lanes.filter(function(x) {
        return stage_id.toString() == x.id.toString();
    })[0];
    return !currentLane.automation;
}
function setAutomationHash(args, automationHash) {
    automationHash.rejected_ids = (automationHash === null || automationHash === void 0 ? void 0 : automationHash.rejected_ids) || [];
    args.setAutomationActions(automationHash);
    if (args.showAutomationPopup && args.from == "application_view") {
        args.setSendAutomation(true);
        automationClick(args.job_id, automationHash.stage_id, args.setCurrentStage, args.setBtnPopup, args.router, false);
    } else if (!args.showAutomationPopup) {
        args.setAutomationBar(true);
    }
}
function manageAutomationTimer(args) {
    var time = new Date();
    time.setSeconds(time.getSeconds() + TIMER_CONSTANT);
    args.restart(time);
    args.setTimerStatus(true);
}
function moveToNextStage(args) {
    return _moveToNextStage.apply(this, arguments);
}
function _moveToNextStage() {
    _moveToNextStage = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(args) {
        var selectedCards, heartpace, sortByFilterData, customToastrAction, result, status_code, candidate_name, _tmp, moved_success_message;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    selectedCards = args.selectedCards;
                    selectedCards.move_to = args.to_stage;
                    args.filterData.kanban = selectedCards;
                    args.filterData.from = args.from;
                    heartpace = "true";
                    if (args.from == "application_view") {
                        args.filterData.kanban.candidate_index = args.candidateIndex;
                        args.filterData.kanban.base_stage_id = args.filterData.kanban.stage_id;
                        if (args.candidateCurrentStageId) {
                            args.filterData.kanban.stage_id = args.candidateCurrentStageId;
                        }
                        sortByFilterData = (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .ApplicationFilter */ .it)(args.job_id);
                        if (sortByFilterData) {
                            args.filterData.application_filter_data = sortByFilterData;
                        }
                    }
                    customToastrAction = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().moveCandidates(args.job_id, args.filterData)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    _tmp = {};
                    switch(status_code){
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            if (args.from == "kanban") {
                                clearRadioButtonSelection(args.setSelectedCards, args.activeTab, args.setActionBar);
                                args.setJobData(result.data.kanban_data);
                                // if (result.data.kanban_data.candidate_hired){
                                //     args.setHiredModal(true)
                                //    }
                                if (heartpace == "true" && args.targetLaneName == "Hired" && args.hired_sync_data.hired_synced_data_empty) {
                                    candidate_name = args.hired_sync_data.candidate_name;
                                    args.setHiredSyncModal((_tmp.state = true, _tmp.action = {
                                        hiredSyncData: args.hired_sync_data,
                                        message: args.t("modal:confirmation:move_candidate:sync_data", {
                                            candidate_name: candidate_name
                                        }),
                                        data: result.data
                                    }, _tmp));
                                }
                            }
                            if (args.from == "application_view") {
                                args.setInitialData(result.data.application_data);
                                moved_success_message = (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .TRANSLATION */ .TA)("jobs:kanban:moved_successfully") + " " + result.data.application_data.application.current_stage_name.toLowerCase() + (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .TRANSLATION */ .TA)("jobs:kanban:stage");
                                customToastrAction.setNormalToastr(moved_success_message, "success");
                            }
                            if (result.data.automations_hsh) {
                                setAutomationHash(args, result.data.automations_hsh);
                                manageAutomationTimer(args);
                            } else if (result.data.offer_hsh && result.data.application_current_stage != "Hired") {
                                if (!args.isContract) {
                                    args.setOfferHash(result.data.offer_hsh);
                                    if (args.from == "application_view") {
                                        showAddOffer(args.setShowOffer, args.from);
                                    }
                                }
                            }
                            if (result.data.warning && result.data.warning.length > 0) {
                                customToastrAction.setNormalToastr(result.data.warning, "error");
                            }
                            break;
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            if (args.from == "kanban") {
                                clearRadioButtonSelection(args.setSelectedCards, args.activeTab, args.setActionBar);
                            }
                            customToastrAction.setNormalToastr(result.response.data.error, "error");
                            break;
                        default:
                            (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, args.router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _moveToNextStage.apply(this, arguments);
}
function setJobStageTestData(body, params, deleteQuestionList) {
    // if(values.hasOwnProperty("job_test_detail_attributes") && values.job_test_detail_attributes)
    // {
    //   if(values.job_test_detail_attributes.assessment.file == '') delete values.job_test_detail_attributes.assessment.file
    //   filterData.job_stage = { }
    //   filterData.job_stage.automation = values.automation
    //   filterData.assessment = values.job_test_detail_attributes.assessment
    //   delete values.job_test_detail_attributes.assessment
    //   filterData.job_stage.job_test_detail_attributes = values.job_test_detail_attributes
    //   filterData.save_and_continue = values.save_and_continue
    // }
    // else{
    //   filterData.job_stage = values
    // }
    body.job_stage = {
        automation: params.automation,
        interview_type_id: params.interview_type_id,
        job_meeting_details_attributes: params.job_meeting_details_attributes
    };
    if (params.interview_type == _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.TECHTEST */ .BH.TECHTEST) {
        var techTestBody = (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .setTechTestFormData */ .a)(params);
        body.job_stage.job_test_detail_attributes = techTestBody.job_stage.job_test_detail_attributes;
        if (techTestBody.assessment) body.assessment = techTestBody.assessment;
        if (techTestBody.save_and_continue) body.save_and_continue = techTestBody.save_and_continue;
    }
    if (params.interview_type == _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.VIDEOQA */ .BH.VIDEOQA) {
        var questions_attributes = Object.assign([], params.questions_attributes, deleteQuestionList);
        var video_question_details_attributes = {
            language: params.language,
            video_link: params.video_link,
            practise_screen: params.practise_screen,
            expires: params.expires,
            member_emails: params.videoqa.member_emails,
            questions_attributes: Object.assign([], params.questions_attributes, deleteQuestionList)
        };
        body.job_stage.video_question_details_attributes = video_question_details_attributes;
    }
    return body;
}
function runAutomations(args) {
    return _runAutomations.apply(this, arguments);
}
function _runAutomations() {
    _runAutomations = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(args) {
        var selectedCards, result, status_code, customToastrAction, ref, ref1, ref2, warning, ref3, ref4, errors, _tmp, error_message;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    selectedCards = args.selectedCards;
                    if (args.fromPopup) {
                        args.filterData = setJobStageTestData(args.filterData, JSON.parse(JSON.stringify(args.values)), args.deleteQuestionList);
                        if (args.setDisabled) args.setDisabled(true);
                    }
                    selectedCards.perform_action = true;
                    args.filterData.kanban = selectedCards;
                    args.filterData.from = args.from;
                    if (args.from == "application_view") {
                        args.filterData.kanban.candidate_index = args.candidateIndex;
                        args.filterData.kanban.base_stage_id = args.base_stage_id;
                        args.filterData.kanban.stage_id = args.candidateCurrentStageId;
                    }
                    if (!args.fromPopup && args.values) {
                        args.filterData.kanban.email = args.values;
                        args.filterData.kanban.email.cc = args.selectedValues ? getEmails(args.selectedValues) : [];
                        args.filterData.kanban.key = args.reviewKey;
                    }
                    if (args.reviewKey) args.filterData.kanban.key = args.reviewKey;
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().runAutomations(args.job_id, args.filterData)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    _tmp = {};
                    switch(status_code){
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            ;
                            if (args.reviewKey && args.setUnsuccessfulEmailModal) args.setUnsuccessfulEmailModal(false);
                            if (args.fromPopup && !args.fromPopup) {
                                clearRadioButtonSelection(args.setSelectedCards, args.activeTab, args.setActionBar);
                            }
                            if (args.fromPopup) {
                                args.setSendAutomation(false);
                                args.setBtnPopup(false);
                            }
                            if (args.from == "kanban") {
                                args.setJobData(result.data.kanban_data);
                            } else {
                                args.setInitialData(result.data.application_data);
                            }
                            warning = "";
                            if (result.data.warning && result.data.warning.length > 0) {
                                warning += result.data.warning;
                            }
                            if (result.data.contact_warning && result.data.contact_warning.length > 0) {
                                warning += result.data.contact_warning;
                            }
                            if (warning.length > 0) customToastrAction.setNormalToastr(warning, "error");
                            else if (result.data.success && ((ref = args.filterData) === null || ref === void 0 ? void 0 : (ref1 = ref.kanban) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.email) === null || ref2 === void 0 ? void 0 : ref2.email_body)) customToastrAction.setNormalToastr(result.data.success, "success");
                            else if (result.data.success) customToastrAction.setNormalToastr(result.data.success, "success");
                            break;
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            if (args.fromPopup && !args.fromPopup) clearRadioButtonSelection(args.setSelectedCards, args.activeTab, args.setActionBar);
                            if (args.fromPopup) {
                                ;
                                if ((ref3 = result.response.data.error.job_stage) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.job_test_detail_attributes) === null || ref4 === void 0 ? void 0 : ref4.test_attributes) {
                                    errors = (_tmp.job_test_detail_attributes = {
                                        assessment: result.response.data.error.job_stage.job_test_detail_attributes.test_attributes
                                    }, _tmp);
                                    return [
                                        2,
                                        errors
                                    ];
                                } else {
                                    args.setSendAutomation(false);
                                    args.setBtnPopup(false);
                                }
                                if (args.setDisabled) args.setDisabled(false);
                            }
                            error_message = showErrors(result.response.data.error);
                            error_message.length > 0 ? customToastrAction.setNormalToastr(error_message, "error") : customToastrAction.setNormalToastr(result.response.data.error, "error");
                            break;
                        default:
                            (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, args.router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _runAutomations.apply(this, arguments);
}
function clearRadioButtonSelection(setSelectedCards, activeTab, setActionBar) {
    return _clearRadioButtonSelection.apply(this, arguments);
}
function _clearRadioButtonSelection() {
    _clearRadioButtonSelection = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(setSelectedCards, activeTab, setActionBar) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            _tmp = {};
            setSelectedCards((_tmp.stage_id = "", _tmp.job_application_ids = [], _tmp.rejected_ids = [], _tmp.status = activeTab, _tmp));
            setActionBar(false);
            return [
                2
            ];
        });
    });
    return _clearRadioButtonSelection.apply(this, arguments);
}
function getOfferHash(args) {
    return _getOfferHash.apply(this, arguments);
}
function _getOfferHash() {
    _getOfferHash = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(args) {
        var params, _tmp, _tmp1, result, status_code, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    _tmp1 = {};
                    params = args.job_application_id ? (_tmp.job_application_id = args.job_application_id, _tmp) : (_tmp1.id = args.id, _tmp1);
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().getOfferDetail(params)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            if (result.data.offer_hsh) {
                                args.setOfferHash(result.data.offer_hsh);
                                showAddOffer(args.setShowOffer, args.from);
                            }
                            break;
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "error");
                            break;
                        default:
                            (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, args.router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getOfferHash.apply(this, arguments);
}
function redirectContractPage(job_id, job_application_id, isTemplate) {
    var send_contract_url = _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.jobs.send_contract.replace */ .RQ.client.jobs.send_contract.replace("$job_id", job_id).replace("$job_application_id", job_application_id);
    if (isTemplate) {
        send_contract_url = _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.jobs.send_template_contract.replace */ .RQ.client.jobs.send_template_contract.replace("$job_id", job_id).replace("$job_application_id", job_application_id);
    }
    var protocol = window.location.protocol;
    var host = window.location.host;
    var url = protocol + "//" + host + send_contract_url;
    window.open(url, "_self");
}
function getReasonsList(name, router1) {
    return _getReasonsList.apply(this, arguments);
}
function _getReasonsList() {
    _getReasonsList = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(name, router1) {
        var body, _tmp, result, status_code, customToastrAction, response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = (_tmp.search_text = name, _tmp);
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().unsuccessfulReasons(body)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            response = result.data;
                            return [
                                2,
                                response.unsuccessful_reasons || []
                            ];
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            // toastr.warning(result.response.data.error)
                            return [
                                2,
                                []
                            ];
                        default:
                            (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router1);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getReasonsList.apply(this, arguments);
}
function getScorecards(job_application_id, router1) {
    return _getScorecards.apply(this, arguments);
}
function _getScorecards() {
    _getScorecards = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(job_application_id, router1) {
        var result, status_code, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().scoreCards(job_application_id)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            return [
                                2,
                                result.data
                            ];
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            return [
                                2,
                                null
                            ];
                        default:
                            (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router1);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getScorecards.apply(this, arguments);
}
function getSingleScorecard(job_application_id, router1, scorecard_id) {
    return _getSingleScorecard.apply(this, arguments);
}
function _getSingleScorecard() {
    _getSingleScorecard = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(job_application_id, router1, scorecard_id) {
        var result, status_code, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().singleScoreCards(job_application_id, scorecard_id)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            return [
                                2,
                                result.data
                            ];
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            return [
                                2,
                                []
                            ];
                        default:
                            (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router1);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getSingleScorecard.apply(this, arguments);
}
function compareCandidateScorecards(job_id, params, router1) {
    return _compareCandidateScorecards.apply(this, arguments);
}
function _compareCandidateScorecards() {
    _compareCandidateScorecards = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(job_id, params, router1) {
        var body, _tmp, result, status_code, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = (_tmp.kanban = params, _tmp);
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().compareScoreCards(job_id, body)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            if (result.data.warning && result.data.warning.length > 0) customToastrAction.setNormalToastr(result.data.warning, "warning");
                            return [
                                2,
                                result.data
                            ];
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            return [
                                2,
                                []
                            ];
                        default:
                            (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router1);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _compareCandidateScorecards.apply(this, arguments);
}
function reviewAutomationEmail(job_id, router1, params) {
    return _reviewAutomationEmail.apply(this, arguments);
}
function _reviewAutomationEmail() {
    _reviewAutomationEmail = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(job_id, router1, params) {
        var result, status_code, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().reviewAutomationEmail(job_id, params)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            return [
                                2,
                                result.data
                            ];
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            // toastr.warning(result.response.data.error)
                            return [
                                2,
                                []
                            ];
                        default:
                            (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router1);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _reviewAutomationEmail.apply(this, arguments);
}
function getEmails(values) {
    var emails = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            emails.push(element.email);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return emails;
}
function send_unsuccessful_email(args) {
    return _send_unsuccessful_email.apply(this, arguments);
}
function _send_unsuccessful_email() {
    _send_unsuccessful_email = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(args) {
        var params, _tmp, result, status_code, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    params = (_tmp.kanban = args.selectedCards, _tmp);
                    params.kanban.email = args.values;
                    params.kanban.email.cc = getEmails(args.selectedValues);
                    params.kanban.email.language_iso_code = args.values.language_iso_code;
                    params.kanban.key = "active_or_unsuccessful";
                    params.kanban.unsuccessful_candidates_token = args.unsuccessful_candidates_token;
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().sendUnsuccessfulEmail(args.job_id, params)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            return [
                                3,
                                2
                            ];
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        7
                    ];
                case 2:
                    return [
                        4,
                        args.setUnsuccessfulEmailModal(false)
                    ];
                case 3:
                    _state.sent();
                    if (!(args.from == "kanban")) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        clearRadioButtonSelection(args.setSelectedCards, args.activeTab, args.setActionBar)
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    customToastrAction.setNormalToastr(result.data.success, "success");
                    return [
                        2,
                        result.data
                    ];
                case 6:
                    customToastrAction.setNormalToastr(result.response.data.error, "warning");
                    // toastr.warning(result.response.data.error)
                    return [
                        2,
                        []
                    ];
                case 7:
                    (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, args.router);
                    _state.label = 8;
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return _send_unsuccessful_email.apply(this, arguments);
}
function sendOfferToCandidate(params, setBtnPopup, setInitialData, setShowLoader) {
    return _sendOfferToCandidate.apply(this, arguments);
}
function _sendOfferToCandidate() {
    _sendOfferToCandidate = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(params, setBtnPopup, setInitialData, setShowLoader) {
        var body, result, customToastrAction, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    body = params;
                    setShowLoader(true);
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().sendOffer(body)
                    ];
                case 1:
                    result = _state.sent();
                    customToastrAction = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    _tmp = {};
                    if (setBtnPopup) setBtnPopup((_tmp.state = false, _tmp));
                    if (result.request.status == 200) {
                        setInitialData(result.data.application_data);
                        customToastrAction.setNormalToastr(result.data.success, "success");
                    } else {
                        customToastrAction.setNormalToastr(result.response.data.error, "error");
                    }
                    setShowLoader(false);
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _sendOfferToCandidate.apply(this, arguments);
}
function isPendingInterview(args) {
    var pending_interview = false;
    if (args.selectedCards.job_application_ids.indexOf("all") != -1) {
        args.job_data.lanes.filter(function(x) {
            return x.id.toString() == args.selectedCards.stage_id.toString();
        })[0].cards.map(function(y) {
            if (!args.selectedCards.rejected_ids.includes(y.id.toString())) {
                pending_interview = pending_interview || y.pending_interview;
            }
            return y;
        });
    } else {
        args.job_data.lanes.filter(function(x) {
            return x.id.toString() == args.selectedCards.stage_id.toString();
        })[0].cards.map(function(y) {
            if (args.selectedCards.job_application_ids.includes(y.id.toString())) {
                pending_interview = pending_interview || y.pending_interview;
            }
            return y;
        });
    }
    return pending_interview;
}
function isScheduledInterview(args) {
    var scheduled_interview = false;
    if (args.selectedCards.job_application_ids.indexOf("all") != -1) {
        args.job_data.lanes.filter(function(x) {
            return x.id.toString() == args.selectedCards.stage_id.toString();
        })[0].cards.map(function(y) {
            if (!args.selectedCards.rejected_ids.includes(y.id.toString())) {
                scheduled_interview = scheduled_interview || y.scheduled_interview;
            }
            return y;
        });
    } else {
        args.job_data.lanes.filter(function(x) {
            return x.id.toString() == args.selectedCards.stage_id.toString();
        })[0].cards.map(function(y) {
            if (args.selectedCards.job_application_ids.includes(y.id.toString())) {
                scheduled_interview = scheduled_interview || y.scheduled_interview;
            }
            return y;
        });
    }
    return scheduled_interview;
}
function getCandidateCount(job_data, selectedCards) {
    var count = 0;
    var stage = job_data.lanes.filter(function(x) {
        return x.id == selectedCards.stage_id.toString();
    })[0];
    if (selectedCards.job_application_ids.indexOf("all") != -1) {
        count = stage.count - selectedCards.rejected_ids.length;
    } else {
        count = selectedCards.job_application_ids.length;
    }
    return count;
}
function isNotSent(args) {
    return _isNotSent.apply(this, arguments);
}
function _isNotSent() {
    _isNotSent = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(args) {
        var not_sent_interviews, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    not_sent_interviews = false;
                    if (args.selectedCards.status == "unsuccessful") return [
                        2,
                        not_sent_interviews
                    ];
                    if (!(args.selectedCards.job_application_ids.indexOf("all") != -1)) return [
                        3,
                        2
                    ];
                    _tmp = {};
                    return [
                        4,
                        checkNotSent((_tmp.job_stage_id = args.selectedCards.stage_id, _tmp.job_application_ids = args.selectedCards.job_application_ids, _tmp.rejected_ids = args.selectedCards.rejected_ids, _tmp))
                    ];
                case 1:
                    not_sent_interviews = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    args.job_data.lanes.filter(function(x) {
                        return x.id.toString() == args.selectedCards.stage_id.toString();
                    })[0].cards.map(function(y) {
                        if (args.selectedCards.job_application_ids.includes(y.id.toString())) {
                            not_sent_interviews = not_sent_interviews || y.primary_status_key == "Not Sent";
                        }
                        return y;
                    });
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        not_sent_interviews
                    ];
            }
        });
    });
    return _isNotSent.apply(this, arguments);
}
function checkNotSent(args) {
    return _checkNotSent.apply(this, arguments);
}
function _checkNotSent() {
    _checkNotSent = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(args) {
        var result, _tmp, status_code, customToastrAction, response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().checkNotSent((_tmp.job_application_meeting = args, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            response = result.data;
                            return [
                                2,
                                response.not_sent_exists
                            ];
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            return [
                                2,
                                false
                            ];
                            break;
                        default:
                            return [
                                2,
                                false
                            ];
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _checkNotSent.apply(this, arguments);
}
function sendQuestions(args, setBtnPopup, from, setLoading, setData, kanban_args) {
    return _sendQuestions.apply(this, arguments);
}
function _sendQuestions() {
    _sendQuestions = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(args, setBtnPopup, from, setLoading, setData, kanban_args) {
        var result, status_code, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setLoading(true);
                    args.from = from;
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().sendQuestions(args.job_id, args)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            return [
                                3,
                                2
                            ];
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            return [
                                3,
                                5
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 2:
                    setBtnPopup(false);
                    customToastrAction.setNormalToastr(result.data.success, "success");
                    setLoading(false);
                    if (from == "application_view") {
                        setData(result.data.application_data);
                    } else {
                        setData(result.data.kanban_data);
                    }
                    if (!(from == "kanban")) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        clearRadioButtonSelection(kanban_args.setSelectedCards, kanban_args.activeTab, kanban_args.setActionBar)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        9
                    ];
                case 5:
                    setBtnPopup(false);
                    customToastrAction.setNormalToastr(result.response.data.error, "warning");
                    setLoading(false);
                    if (!(from == "kanban")) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        clearRadioButtonSelection(kanban_args.setSelectedCards, kanban_args.activeTab, kanban_args.setActionBar)
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        9
                    ];
                case 8:
                    setLoading(false);
                    (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                    _state.label = 9;
                case 9:
                    return [
                        2
                    ];
            }
        });
    });
    return _sendQuestions.apply(this, arguments);
}
// TODO put all the function in the class so that we should not write multiple imports 
// on the import files and the page 
var KanbanActions = /*#__PURE__*/ function() {
    "use strict";
    function KanbanActions() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(this, KanbanActions);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(KanbanActions, [
        {
            key: "setBackArrowTitle",
            value: function setBackArrowTitle(type, t) {
                switch(type){
                    case "reports":
                        return t("back:reports");
                    default:
                        return t("back:all_jobs");
                }
            }
        },
        {
            key: "setBackPageLink",
            value: function setBackPageLink(type) {
                switch(type){
                    case "reports":
                        return {
                            pathname: _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.reports.in_process */ .RQ.client.reports.in_process
                        };
                    default:
                        return {
                            pathname: _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.jobs.index */ .RQ.client.jobs.index,
                            query: {
                                job_type: "active"
                            }
                        };
                }
            }
        }
    ]);
    return KanbanActions;
}();
function syncNowHiredData(job_id, args) {
    return _syncNowHiredData.apply(this, arguments);
}
function _syncNowHiredData() {
    _syncNowHiredData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(job_id, args) {
        var result, customToastrAction, status_code, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .Kanban */ .pt().syncNowHiredDataService(job_id, args)
                    ];
                case 1:
                    result = _state.sent();
                    customToastrAction = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    status_code = result.status || result.response.status;
                    _tmp = {};
                    _tmp1 = {};
                    switch(status_code){
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            if (args.from == "kanban") {
                                args.setHiredSyncNowBtn((_tmp.state = false, _tmp.action = {}, _tmp));
                                args.setJobData(result.data.kanban_data);
                            } else {
                                args.setInitialData(result.data.application_data);
                            }
                            customToastrAction.setNormalToastr(result.data.success, "success");
                            if (result.data.kanban_data.candidate_hired) {
                                setTimeout(function() {
                                    args.setHiredModal(true);
                                }, 2000);
                            }
                            break;
                        case _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            if (args.from == "kanban") {
                                args.setHiredSyncModal((_tmp1.state = false, _tmp1.action = {}, _tmp1));
                            }
                            if (result.response.data.missing_data) {
                                args.setOfferHash(result.response.data.offer.offer_hsh);
                                args.setSyncNowBtnClick(true);
                                showAddOffer(args.setShowOffer, args.from);
                            }
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            break;
                        default:
                            (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, args.router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _syncNowHiredData.apply(this, arguments);
}


/***/ }),

/***/ 15302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gt": function() { return /* binding */ ViewProfileActions; }
/* harmony export */ });
/* unused harmony exports like_dislike, goToOtherCandidate, candidateDownloadCV, candidateOpenEmail, candidateShareCV, submitCandidateNote, getShareComponentMemberListArray, getCandidateGeneralProfile, addCv, updateCv */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27307);
/* harmony import */ var _actions_common_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1739);
/* harmony import */ var _actions_components_custom_toastr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66939);
/* harmony import */ var _constants_common_urls__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47694);
/* harmony import */ var _services_components_candidate_info_edit_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40914);
/* harmony import */ var _services_pages_clients_candidates_view_profile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57828);
/* harmony import */ var _services_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45533);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75763);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(file_saver__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96047);












var ViewProfileActions = /*#__PURE__*/ function() {
    "use strict";
    function ViewProfileActions(router) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, ViewProfileActions);
        this.candidateInfoEdit = new _services_components_candidate_info_edit_form__WEBPACK_IMPORTED_MODULE_3__/* .CandidateInfoEditService */ .o();
        this.commonAction = new _actions_common_common__WEBPACK_IMPORTED_MODULE_0__/* .CommonAction */ .x();
        this.customToastrAction = new _actions_components_custom_toastr__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y();
        this.router = router;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(ViewProfileActions, [
        {
            key: "like_dislike",
            value: function like_dislike(value, router, setLikeDislike, setApiError, initialData, setInitialData, setFlagForRerender) {
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
                    var candidate_id, body, _tmp, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                candidate_id = router.query.candidate_id;
                                _tmp = {};
                                body = (_tmp.liked = value, _tmp);
                                return [
                                    4,
                                    new _services_pages_clients_candidates_view_profile__WEBPACK_IMPORTED_MODULE_4__/* .CandidateGeneralProfileService */ .Z().like_dislike(body, candidate_id)
                                ];
                            case 1:
                                result = _state.sent();
                                setLikeDislike(value);
                                if (result.request.status == 200) {
                                    initialData.application.liked_unliked = value;
                                    initialData.notes = result.data.notes;
                                    setInitialData(initialData);
                                    setFlagForRerender(Math.random() * 10000);
                                } else {
                                    setApiError(result.request);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "goToOtherCandidate",
            value: function goToOtherCandidate(router, candidate_id) {
                if (candidate_id) {
                    var path = _constants_common_urls__WEBPACK_IMPORTED_MODULE_2__/* .REDIRECT.client.jobs.candidate_profile_view.replace */ .R.client.jobs.candidate_profile_view.replace("$candidate_id", candidate_id);
                    router.push({
                        pathname: path,
                        query: router.query
                    });
                }
            }
        },
        {
            key: "candidateDownloadCV",
            value: function candidateDownloadCV(url) {
                if (url) {
                    (0,file_saver__WEBPACK_IMPORTED_MODULE_6__.saveAs)(url, "Resume.pdf");
                } else {
                    this.customToastrAction.setNormalToastr((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_7__/* .TRANSLATION */ .TA)("toastr:cv_not_exists"), "error");
                }
            }
        },
        {
            key: "candidateOpenEmail",
            value: function candidateOpenEmail(setShowCandidateEmail, candidate_email, setReplyTo, setReplySubject, initialData, setOpenFrom, type, setReferences) {
                if (candidate_email) {
                    setReplyTo("");
                    if (setReferences) setReferences("");
                    setReplySubject("");
                    setOpenFrom(type);
                    setShowCandidateEmail(true);
                } else {
                    this.customToastrAction.setNormalToastr("Email does not exists", "error");
                }
            }
        },
        {
            key: "candidateShareCV",
            value: function candidateShareCV(setButtonPopup, cv_url) {
                if (cv_url) {
                    setButtonPopup(true);
                } else {
                    this.customToastrAction.setNormalToastr((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_7__/* .TRANSLATION */ .TA)("toastr:cv_not_exists"), "error");
                }
            }
        },
        {
            key: "submitCandidateNote",
            value: function submitCandidateNote(values, router, setMentionsInputValue, mentionsMember, initialData, setInitialData, setApiError, setFlagForRerender, formik) {
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
                    var message, body, _tmp, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                message = document.querySelector(".autocompleteInput textarea").value;
                                _tmp = {};
                                body = (_tmp.message = message, _tmp.member_tag_ids = mentionsMember, _tmp.private = values.private, _tmp);
                                return [
                                    4,
                                    new _services_pages_clients_candidates_view_profile__WEBPACK_IMPORTED_MODULE_4__/* .CandidateGeneralProfileService */ .Z().addNote(body, router.query.candidate_id)
                                ];
                            case 1:
                                result = _state.sent();
                                initialData.notes = result.data.notes;
                                setInitialData(initialData);
                                delete router.query["section"];
                                setFlagForRerender(Math.random() * 10000);
                                result.request.status != 200 ? setApiError(result.request) : null;
                                formik.current.resetForm();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getShareComponentMemberListArray",
            value: function getShareComponentMemberListArray(hash) {
                var names_hash = [];
                if (hash) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = hash[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            names_hash.push({
                                id: element.user_attributes.id,
                                display: "@".concat(element.user_attributes.name || element.user_attributes.email)
                            });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return names_hash;
            }
        },
        {
            key: "getCandidateGeneralProfile",
            value: function getCandidateGeneralProfile(router, setApiError) {
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
                    var result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    new _services_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_5__/* .CandidateProfileJobService */ .C().getCandidateGeneralViewData(router.query)
                                ];
                            case 1:
                                result = _state.sent();
                                if (setApiError) setApiError(result.request);
                                return [
                                    2,
                                    result.data
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addCv",
            value: function addCv(event, setLoading, router, setInitialData, initialData, setFlagForRerender, type, setShowLoader) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
                    var formData, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setShowLoader(true);
                                formData = new FormData();
                                result = "";
                                if (!_this.commonAction.check_file_size(event.target.files[0], 10485760)) return [
                                    3,
                                    5
                                ];
                                if (!(type == "candidate_profile")) return [
                                    3,
                                    2
                                ];
                                formData.append("job_application[candidate_cv]", event.target.files[0]);
                                return [
                                    4,
                                    _this.candidateInfoEdit.UpdateCanidateInfo(formData, router)
                                ];
                            case 1:
                                result = _state.sent();
                                initialData.application.cv = result.data.application.cv;
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                formData.append("client_candidate[cvs_attributes][default]", true);
                                formData.append("client_candidate[cvs_attributes][0][file_type]", "cv");
                                formData.append("client_candidate[cvs_attributes][0][file]", event.target.files[0]);
                                return [
                                    4,
                                    _this.candidateInfoEdit.UpdateGeneralCandidate(formData, router)
                                ];
                            case 3:
                                result = _state.sent();
                                initialData.application.cv = result.data.application.cv;
                                _state.label = 4;
                            case 4:
                                setFlagForRerender(Math.random() * 10000);
                                window.location.reload();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                _this.customToastrAction.setNormalToastr((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_7__/* .TRANSLATION */ .TA)("toastr:file_size_greater_than_10MB"), "warning");
                                _state.label = 6;
                            case 6:
                                setShowLoader(false);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateCv",
            value: function updateCv(event, router, initialData, setFlagForRerender, type, setShowLoader) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
                    var formData, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setShowLoader(true);
                                formData = new FormData();
                                result = "";
                                if (!_this.commonAction.check_file_size(event.target.files[0], 10485760)) return [
                                    3,
                                    5
                                ];
                                if (!(type == "candidate_profile")) return [
                                    3,
                                    2
                                ];
                                formData.append("job_application[update_cv]", true);
                                formData.append("job_application[candidate_cv]", event.target.files[0]);
                                return [
                                    4,
                                    _this.candidateInfoEdit.UpdateCanidateInfo(formData, router)
                                ];
                            case 1:
                                result = _state.sent();
                                initialData.application.cv = result.data.application.cv;
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                formData.append("client_candidate[cvs_attributes][default]", true);
                                formData.append("client_candidate[update_cv]", true);
                                formData.append("client_candidate[cvs_attributes][0][file_type]", "cv");
                                formData.append("client_candidate[cvs_attributes][0][file]", event.target.files[0]);
                                return [
                                    4,
                                    _this.candidateInfoEdit.UpdateGeneralCandidate(formData, router)
                                ];
                            case 3:
                                result = _state.sent();
                                initialData.application.cv = result.data.application.cv;
                                _state.label = 4;
                            case 4:
                                setFlagForRerender(Math.random() * 10000);
                                window.location.reload();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                _this.customToastrAction.setNormalToastr((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_7__/* .TRANSLATION */ .TA)("toastr:file_size_greater_than_10MB"), "warning");
                                _state.label = 6;
                            case 6:
                                setShowLoader(false);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "selectTabCandidateProfileView",
            value: function selectTabCandidateProfileView(technical_tests, video_q_a, candidate_answers, tab_name) {
                var tabs = [];
                if (candidate_answers) tabs.push("screening");
                tabs.push("notes", "comms", "scorecards");
                if (technical_tests) tabs.push("technical_tests");
                if ((video_q_a === null || video_q_a === void 0 ? void 0 : video_q_a.length) > 0) tabs.push("video_q_a");
                tabs.push("application", "info_and_docs", "timeline", "offer");
                var tabIndex = tabs.indexOf(String(tab_name));
                return tabIndex === -1 ? 0 : tabIndex;
            }
        },
        {
            key: "selectTabGeneralViewProfile",
            value: function selectTabGeneralViewProfile(tab_name) {
                switch(tab_name){
                    case "notes":
                        return 0;
                    case "comms":
                        return 1;
                    case "info_and_docs":
                        return 2;
                    case "previous_application":
                        return 3;
                    default:
                        return 0;
                }
            }
        },
        {
            key: "selectTabCandidateProfileViewOnClick",
            value: function selectTabCandidateProfileViewOnClick(index, initialData) {
                var tab_name = this.getTabFromIndexCandidateProfileView(index, initialData);
                this.router.query.tab = tab_name;
                this.commonAction.asyncAddParamsToUrl(this.router.query, this.router);
            }
        },
        {
            key: "getTabFromIndexCandidateProfileView",
            value: function getTabFromIndexCandidateProfileView(index, initialData) {
                var ref;
                var tabs = [
                    initialData.candidate_answers && "screening_answers",
                    "notes",
                    "comms",
                    "scorecards",
                    initialData.technical_tests && "assessment",
                    ((ref = initialData.video_q_a) === null || ref === void 0 ? void 0 : ref.length) > 0 && "video_qa",
                    "application",
                    "info&docs",
                    "timeline",
                    "offer", 
                ].filter(Boolean);
                return tabs[index] || "notes";
            }
        },
        {
            key: "selectTabGeneralProfileViewOnClick",
            value: function selectTabGeneralProfileViewOnClick(index) {
                var tab_name = this.getTabFromIndexGeneralProfileView(index);
                this.router.query.tab = tab_name;
                this.commonAction.asyncAddParamsToUrl(this.router.query, this.router);
            }
        },
        {
            key: "getTabFromIndexGeneralProfileView",
            value: function getTabFromIndexGeneralProfileView(index) {
                switch(index){
                    case 0:
                        return "notes";
                    case 1:
                        return "comms";
                    case 2:
                        return "info_and_docs";
                    case 3:
                        return "previous_application";
                    default:
                        return "notes";
                }
            }
        }
    ]);
    return ViewProfileActions;
}();
// TODO :- REMOVE THESE CODE AFTER REMOVING IT FROM THE OTHER FILES IN WHICH THEY ARE USED
function like_dislike(value, router, setLikeDislike, setApiError, initialData, setInitialData, setFlagForRerender) {
    return _like_dislike.apply(this, arguments);
}
function _like_dislike() {
    _like_dislike = _async_to_generator(function(value, router, setLikeDislike, setApiError, initialData, setInitialData, setFlagForRerender) {
        var candidate_id, body, _tmp, result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    candidate_id = router.query.candidate_id;
                    _tmp = {};
                    body = (_tmp.liked = value, _tmp);
                    return [
                        4,
                        new CandidateGeneralProfileService().like_dislike(body, candidate_id)
                    ];
                case 1:
                    result = _state.sent();
                    setLikeDislike(value);
                    if (result.request.status == 200) {
                        initialData.application.liked_unliked = value;
                        initialData.notes = result.data.notes;
                        setInitialData(initialData);
                        setFlagForRerender(Math.random() * 10000);
                    } else {
                        setApiError(result.request);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _like_dislike.apply(this, arguments);
}
function goToOtherCandidate(router, candidate_id) {
    if (candidate_id) {
        var path = REDIRECT.client.jobs.candidate_profile_view.replace("$candidate_id", candidate_id);
        router.push({
            pathname: path,
            query: router.query
        });
    }
}
function candidateDownloadCV(url) {
    var customToastrAction = new CustomToastrAction();
    if (url) {
        saveAs(url, "Resume.pdf");
    } else {
        customToastrAction.setNormalToastr(TRANSLATION("toastr:cv_not_exists"), "error");
    }
}
function candidateOpenEmail(setShowCandidateEmail, candidate_email, setReplyTo, setReplySubject, setOpenFrom, type, setReferences) {
    var customToastrAction = new CustomToastrAction();
    if (candidate_email) {
        setReplyTo("");
        if (setReferences) setReferences("");
        setReplySubject("");
        setOpenFrom(type);
        setShowCandidateEmail(true);
    } else {
        customToastrAction.setNormalToastr("Email does not exists", "error");
    // toastr.error('Email does not exists');
    }
}
function candidateShareCV(setButtonPopup, cv_url) {
    var customToastrAction = new CustomToastrAction();
    if (cv_url) {
        setButtonPopup(true);
    } else {
        customToastrAction.setNormalToastr(TRANSLATION("toastr:cv_not_exists"), "error");
    }
}
function submitCandidateNote(values, router, setMentionsInputValue, mentionsMember, initialData, setInitialData, setApiError, setFlagForRerender, formik) {
    return _submitCandidateNote.apply(this, arguments);
}
function _submitCandidateNote() {
    _submitCandidateNote = _async_to_generator(function(values, router, setMentionsInputValue, mentionsMember, initialData, setInitialData, setApiError, setFlagForRerender, formik) {
        var message, body, _tmp, result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    message = document.querySelector(".autocompleteInput textarea").value;
                    _tmp = {};
                    body = (_tmp.message = message, _tmp.member_tag_ids = mentionsMember, _tmp.private = values.private, _tmp);
                    return [
                        4,
                        new CandidateGeneralProfileService().addNote(body, router.query.candidate_id)
                    ];
                case 1:
                    result = _state.sent();
                    initialData.notes = result.data.notes;
                    setInitialData(initialData);
                    delete router.query["section"];
                    setFlagForRerender(Math.random() * 10000);
                    result.request.status != 200 ? setApiError(result.request) : null;
                    formik.current.resetForm();
                    return [
                        2
                    ];
            }
        });
    });
    return _submitCandidateNote.apply(this, arguments);
}
function getShareComponentMemberListArray(hash) {
    var names_hash = [];
    if (hash) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = hash[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                names_hash.push({
                    id: element.user_attributes.id,
                    display: "@".concat(element.user_attributes.name || element.user_attributes.email)
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return names_hash;
}
function getCandidateGeneralProfile(router, setApiError) {
    return _getCandidateGeneralProfile.apply(this, arguments);
}
function _getCandidateGeneralProfile() {
    _getCandidateGeneralProfile = _async_to_generator(function(router, setApiError) {
        var result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new CandidateProfileJobService().getCandidateGeneralViewData(router.query)
                    ];
                case 1:
                    result = _state.sent();
                    if (setApiError) setApiError(result.request);
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _getCandidateGeneralProfile.apply(this, arguments);
}
function addCv(event, setLoading, router, setInitialData, initialData, setFlagForRerender, type, setShowLoader) {
    return _addCv.apply(this, arguments);
}
function _addCv() {
    _addCv = _async_to_generator(function(event, setLoading, router, setInitialData, initialData, setFlagForRerender, type, setShowLoader) {
        var formData, result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    setShowLoader(true);
                    formData = new FormData();
                    result = "";
                    if (!(type == "candidate_profile")) return [
                        3,
                        2
                    ];
                    formData.append("job_application[candidate_cv]", event.target.files[0]);
                    return [
                        4,
                        new CandidateInfoEditService().UpdateCanidateInfo(formData, router)
                    ];
                case 1:
                    result = _state.sent();
                    initialData.application.cv = result.data.application.cv;
                    return [
                        3,
                        4
                    ];
                case 2:
                    formData.append("client_candidate[cvs_attributes][default]", true);
                    formData.append("client_candidate[cvs_attributes][0][file_type]", "cv");
                    formData.append("client_candidate[cvs_attributes][0][file]", event.target.files[0]);
                    return [
                        4,
                        new CandidateInfoEditService().UpdateGeneralCandidate(formData, router)
                    ];
                case 3:
                    result = _state.sent();
                    initialData.application.cv = result.data.application.cv;
                    _state.label = 4;
                case 4:
                    setFlagForRerender(Math.random() * 10000);
                    setShowLoader(false);
                    window.location.reload();
                    return [
                        2
                    ];
            }
        });
    });
    return _addCv.apply(this, arguments);
}
function updateCv(event, setLoading, router, setInitialData, initialData, setFlagForRerender, type, setShowLoader) {
    return _updateCv.apply(this, arguments);
} // TODO :- REMOVE THESE CODE AFTER REMOVING IT FROM THE OTHER FILES IN WHICH THEY ARE USED
function _updateCv() {
    _updateCv = _async_to_generator(function(event, setLoading, router, setInitialData, initialData, setFlagForRerender, type, setShowLoader) {
        var formData, result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    setShowLoader(true);
                    formData = new FormData();
                    result = "";
                    if (!(type == "candidate_profile")) return [
                        3,
                        2
                    ];
                    formData.append("job_application[candidate_cv]", event.target.files[0]);
                    return [
                        4,
                        new CandidateInfoEditService().UpdateCanidateInfo(formData, router)
                    ];
                case 1:
                    result = _state.sent();
                    initialData.application.cv = result.data.application.cv;
                    return [
                        3,
                        4
                    ];
                case 2:
                    formData.append("client_candidate[cvs_attributes][default]", true);
                    formData.append("client_candidate[cvs_attributes][0][file_type]", "cv");
                    formData.append("client_candidate[cvs_attributes][0][file]", event.target.files[0]);
                    return [
                        4,
                        new CandidateInfoEditService().UpdateGeneralCandidate(formData, router)
                    ];
                case 3:
                    result = _state.sent();
                    initialData.application.cv = result.data.application.cv;
                    _state.label = 4;
                case 4:
                    setFlagForRerender(Math.random() * 10000);
                    setShowLoader(false);
                    window.location.reload();
                    return [
                        2
                    ];
            }
        });
    });
    return _updateCv.apply(this, arguments);
}


/***/ }),

/***/ 73140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EH": function() { return /* binding */ updateHeader; },
/* harmony export */   "Qh": function() { return /* binding */ handleBackgroundOnChange; },
/* harmony export */   "iH": function() { return /* binding */ handleLogoOnChange; },
/* harmony export */   "oP": function() { return /* binding */ updateSubheader; },
/* harmony export */   "wy": function() { return /* binding */ getCustomizeCareerData; }
/* harmony export */ });
/* unused harmony exports openFile, set_background_image, updateLogo, updateBackground, removeCarrerPagePadding */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71198);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96047);




function openFile() {
    if (event.target.tagName == "IMG") {
        var element = document.getElementById("file-input");
        element.click();
    } else {
        var element = document.getElementById("background-input");
        element.click();
    }
}
function handleLogoOnChange(event1, setSelectedFile) {
    var customToastrAction = new _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_0__/* .CustomToastrAction */ .Y5();
    setSelectedFile(window.URL.createObjectURL(event1.target.files[0]));
    check_file_size(event1.target.files[0], _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_0__/* .LOGO_FILE_SIZE */ .h8) ? updateLogo(event1.target) : customToastrAction.setNormalToastr((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_1__/* .TRANSLATION */ .TA)("toastr:file_size_greater_than_10MB"), "warning");
    // toastr.warning('The file size is greater than 10MB');
    event1.target.value = "";
}
function handleBackgroundOnChange(event1, setBackgroundImage) {
    var customToastrAction = new _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_0__/* .CustomToastrAction */ .Y5();
    setBackgroundImage(window.URL.createObjectURL(event1.target.files[0]));
    var file_path = event1.target.files[0];
    check_file_size(event1.target.files[0], _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_0__/* .BACKGROUND_FILE_SIZE */ .ux) ? updateBackground(file_path, setBackgroundImage, event1.target) : customToastrAction.setNormalToastr((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_1__/* .TRANSLATION */ .TA)("toastr:file_size_greater_than_25MB"), "warning");
    // toastr.warning('The file size is greater than 25MB');
    event1.target.value = "";
}
function set_background_image(image_url) {
    var element = document.getElementsByClassName("Career_Background")[0];
    if (element != undefined && ((image_url === null || image_url === void 0 ? void 0 : image_url.length) || 0) > 0) {
        element.style.backgroundImage.includes(image_url) ? "" : element.style.backgroundImage = "url('" + image_url + "')";
    }
}
function updateLogo(element) {
    var formData = new FormData();
    formData.append("career_page[logo]", element.files[0]);
    new _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_0__/* .findJob */ .se().setJobsImages(formData);
}
function updateBackground(filePath, setBackgroundImage, element) {
    return _updateBackground.apply(this, arguments);
}
function _updateBackground() {
    _updateBackground = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(filePath, setBackgroundImage, element) {
        var formData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            formData = new FormData();
            formData.append("career_page[bg_image]", element.files[0]);
            new _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_0__/* .findJob */ .se().setJobsImages(formData);
            return [
                2
            ];
        });
    // document.getElementsByClassName('background-image')[0].src = window.URL.createObjectURL(filePath);
    });
    return _updateBackground.apply(this, arguments);
}
function updateHeader(val, setValueHeading, setHeadingEditing) {
    if (val.trim().length > 0) {
        setValueHeading(val);
        var data = {
            career_page: {
                heading: val
            }
        };
        new _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_0__/* .findJob */ .se().setJobsInfo(data);
        setHeadingEditing(false);
    }
}
function updateSubheader(val, setValueSubheading, setSubHeadingEditing) {
    if (val.trim().length > 0) {
        setValueSubheading(val);
        var data = {
            career_page: {
                sub_heading: val
            }
        };
        new _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_0__/* .findJob */ .se().setJobsInfo(data);
        setSubHeadingEditing(false);
    }
}
function check_file_size(file, file_size) {
    if (file.size > file_size) {
        return false;
    } else {
        return true;
    }
}
function getCustomizeCareerData(router, setApiError) {
    return _getCustomizeCareerData.apply(this, arguments);
}
function _getCustomizeCareerData() {
    _getCustomizeCareerData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(router, setApiError) {
        var body, _tmp, job_data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = (_tmp.host_name = window.location.hostname, _tmp.step = router.query.step, _tmp);
                    return [
                        4,
                        new _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_0__/* .findJob */ .se().getJobsDataForClientOwner(body)
                    ];
                case 1:
                    job_data = _state.sent();
                    setApiError(job_data.request);
                    // const data =  {
                    //           props: {
                    //                     job_data
                    //                  }
                    //        }
                    return [
                        2,
                        job_data.data
                    ];
            }
        });
    });
    return _getCustomizeCareerData.apply(this, arguments);
}
function removeCarrerPagePadding() {
    var element = document.getElementsByClassName("CustomizeCareer")[0];
    if (element != undefined) {
        element.closest(".DashboardPage").style.paddingLeft = 0;
    } else {
        element = document.getElementsByClassName("DashboardPage")[0];
        if (element != undefined) {
            element.style.paddingLeft = null;
        }
    }
    var loadingElement = document.querySelector(".CustomizeCareer__LoaderInPage");
    loadingElement != undefined ? loadingElement.classList.remove("Show") : "";
}


/***/ }),

/***/ 10691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ CustomizeCareerAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34817);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82352);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75462);
/* harmony import */ var _actions_common_image_base64_to_blob__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17728);
/* harmony import */ var lodash_clonedeep__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10552);
/* harmony import */ var lodash_clonedeep__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_clonedeep__WEBPACK_IMPORTED_MODULE_2__);









var CustomizeCareerAction = /*#__PURE__*/ function() {
    "use strict";
    function CustomizeCareerAction(args) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, CustomizeCareerAction);
        this.customToastrAction = new _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .CustomToastrAction */ .Y5();
        this.customizeCareerService = new _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .CustomizeCareerService */ .zn();
        this.cropperAction = new _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .CustomCropperAction */ .nu();
        this.commonAction = new _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .CommonAction */ .x4();
        this.sidebar_section = args.sidebar_section;
        this.setLoading = args.setLoading;
        this.formRef = args.formRef;
        this.setCropperType = args.setCropperType;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(CustomizeCareerAction, [
        {
            key: "showHideSidePanel",
            value: function showHideSidePanel(isOpen) {
                if (isOpen) {
                    if (document.getElementById("career_SidePanel")) document.getElementById("career_SidePanel").style.left = "50%";
                    if (document.getElementById("career_SidePanel")) document.getElementById("career_SidePanel").style.width = "580px";
                    document.body.classList.add("bodybg");
                } else {
                    if (document.getElementById("career_SidePanel")) document.getElementById("career_SidePanel").style.left = "0";
                    if (document.getElementById("career_SidePanel")) document.getElementById("career_SidePanel").style.width = "0";
                    document.body.classList.remove("bodybg");
                }
            }
        },
        {
            key: "toggleMenu",
            value: function toggleMenu() {
                var toggleBars = document.getElementById("careerHeaderDiv");
                if (toggleBars) {
                    if (toggleBars.classList.contains("responsive")) {
                        toggleBars.classList.remove("responsive");
                    } else {
                        toggleBars.classList.add("responsive");
                    }
                }
            }
        },
        {
            key: "bannerSize",
            value: function bannerSize() {
                var el = document.getElementById("Hero_Back_Image");
                if (true) {
                    if (window.innerWidth <= 600) {
                        var height = window.innerWidth / 0.592;
                        if (el) el.style.height = "".concat(height, "px");
                    } else if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
                        var height = window.innerWidth / 1.03;
                        if (el) el.style.height = "".concat(height, "px");
                    } else {
                        var height = window.innerWidth / 2;
                        if (el) el.style.height = "".concat(height, "px");
                    }
                }
            }
        },
        {
            key: "addAboutSection",
            value: function addAboutSection() {
                var page_sections_attributes = formRef.current.page_sections_attributes || [];
                if (page_sections_attributes) {
                    var about_section = {
                        title: "About",
                        description: "Description",
                        image: {}
                    };
                }
            }
        },
        {
            key: "addGallerySection",
            value: function addGallerySection() {
                var page_sections_attributes = formRef.current.page_sections_attributes || [];
                if (page_sections_attributes) {
                    var about_section = {
                        title: "About",
                        description: "Description",
                        image: {}
                    };
                }
            }
        },
        {
            key: "addBenefitSection",
            value: function addBenefitSection() {
                var page_sections_attributes = formRef.current.page_sections_attributes || [];
                if (page_sections_attributes) {
                    var about_section = {
                        title: "About",
                        description: "Description",
                        image: {}
                    };
                }
            }
        },
        {
            key: "addTeamSection",
            value: function addTeamSection() {
                var page_sections_attributes = formRef.current.page_sections_attributes || [];
                if (page_sections_attributes) {
                    var team_section = {
                        title: "My Team",
                        description: "Description",
                        image: {}
                    };
                }
            }
        },
        {
            key: "setInitialValues",
            value: function setInitialValues(cp_data) {
                return cp_data;
            }
        },
        {
            key: "updateAboutSection",
            value: function updateAboutSection(formik, index1) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var page_section;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                page_section = formik.values.page_sections_attributes[index1];
                                return [
                                    4,
                                    _this.updatePageSection(formik, page_section)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateAboutRef",
            value: function updateAboutRef(index1) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var page_section, params, _tmp;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        page_section = _this.formRef.current.values.page_sections_attributes[index1];
                        _tmp = {};
                        params = (_tmp.career_page = {
                            page_sections_attributes: [
                                page_section
                            ]
                        }, _tmp);
                        _this.customizeCareerService.updateCareerPage(params);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "updateHeroSection",
            value: function updateHeroSection(values, isImage) {
                var hero_section_attributes = this.formRef.current.values.hero_section_attributes;
                var params = {
                    career_page: {
                        hero_section_attributes: hero_section_attributes
                    }
                };
                this.customizeCareerService.updateCareerPage(params);
            }
        },
        {
            key: "updatePageSection",
            value: function updatePageSection(formik, page_section) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var ref, params, _tmp, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                params = (_tmp.career_page = {
                                    page_sections_attributes: [
                                        page_section
                                    ]
                                }, _tmp);
                                return [
                                    4,
                                    _this.customizeCareerService.updateCareerPage(params)
                                ];
                            case 1:
                                result = _state.sent();
                                if (!((ref = result.data) === null || ref === void 0 ? void 0 : ref.career_page)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    formik.setValues(result.data.career_page)
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateNavigationLinkSection",
            value: function updateNavigationLinkSection(formik, career_navigation_links_attributes) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var ref, params, _tmp, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                params = (_tmp.career_page = {
                                    career_navigation_links_attributes: career_navigation_links_attributes
                                }, _tmp);
                                return [
                                    4,
                                    _this.customizeCareerService.updateCareerPage(params)
                                ];
                            case 1:
                                result = _state.sent();
                                if (!((ref = result.data) === null || ref === void 0 ? void 0 : ref.career_page)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    formik.setFieldValue("career_navigation_links_attributes", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(result.data.career_page.career_navigation_links_attributes))
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleLogoOnChange",
            value: function handleLogoOnChange(event1, formik) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var file, data_url, blob_data;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                file = event1.target.files[0];
                                if (!(file.size > _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.logo.size */ ._f.logo.size)) return [
                                    3,
                                    1
                                ];
                                _this.customToastrAction.setNormalToastr((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:image_size_2"), "warning");
                                return [
                                    3,
                                    4
                                ];
                            case 1:
                                _this.logo_hash = {
                                    file_name: file.name,
                                    file: file,
                                    file_size: file.size
                                };
                                formik.setFieldValue("logo", _this.logo_hash);
                                data_url = window.URL.createObjectURL(file);
                                formik.setFieldValue("logo_url", data_url);
                                return [
                                    4,
                                    (0,_actions_common_image_base64_to_blob__WEBPACK_IMPORTED_MODULE_8__/* .dataURItoBlob */ .O)(data_url)
                                ];
                            case 2:
                                blob_data = _state.sent();
                                return [
                                    4,
                                    _this.updateLogo(blob_data)
                                ];
                            case 3:
                                _state.sent();
                                // document.querySelector('.CropperModal').style.visibility = 'visible';
                                // var img_tag = document.querySelector('.Cropper__Image');
                                // img_tag.src = this.image_url;
                                // this.setCropperType({type: 'logo_image', formik: formik})
                                // this.cropperAction.initialize_cropping_area('logo_image');
                                event1.target.value = "";
                                _state.label = 4;
                            case 4:
                                event1.target.value = "";
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateLogo",
            value: function updateLogo(blob_data) {
                var formData = new FormData();
                formData.append("career_page[logo]", blob_data, this.formRef.current.values.logo.file_name || this.logo_hash.file_name);
                this.customizeCareerService.updateCareerPageImages(formData);
            }
        },
        {
            key: "handleBackgroundOnChange",
            value: function handleBackgroundOnChange(event1, formik) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var file, img_tag, _tmp;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                file = event1.target.files[0];
                                if (!(file.size > _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.hero.size */ ._f.hero.size)) return [
                                    3,
                                    1
                                ];
                                _this.customToastrAction.setNormalToastr((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:image_size"), "warning");
                                return [
                                    3,
                                    5
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.commonAction.checkDimension(file, _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.hero.minWidth */ ._f.hero.minWidth, _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.hero.minHeight */ ._f.hero.minHeight, "hero_image")
                                ];
                            case 2:
                                if (!!_state.sent()) return [
                                    3,
                                    3
                                ];
                                _this.customToastrAction.setNormalToastr("".concat((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:min_image_size"), " ").concat(_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.hero.minWidth */ ._f.hero.minWidth, "px*").concat(_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.hero.minHeight */ ._f.hero.minHeight, "px."), "warning");
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                return [
                                    4,
                                    _this.commonAction.checkMinWidth(file, _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.hero.idealWidth */ ._f.hero.idealWidth, "hero_image")
                                ];
                            case 4:
                                if (!_state.sent()) {
                                    _this.customToastrAction.setNormalToastr((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:image_stretched"), "warning");
                                }
                                _this.hero_hash = {
                                    file_name: file.name,
                                    file: file,
                                    file_size: file.size
                                };
                                formik.setFieldValue("hero_section_attributes.hero_image", _this.hero_hash);
                                _this.image_url = window.URL.createObjectURL(file);
                                document.querySelector(".CropperModal").style.visibility = "visible";
                                img_tag = document.querySelector(".Cropper__Image");
                                img_tag.src = _this.image_url;
                                _tmp = {};
                                _this.setCropperType((_tmp.type = "hero_image", _tmp.formik = formik, _tmp));
                                _this.cropperAction.initialize_cropping_area("hero_image");
                                event1.target.value = "";
                                _this.mobile_hash = {
                                    file_name: file.name,
                                    file: file,
                                    file_size: file.size
                                };
                                formik.setFieldValue("hero_section_attributes.mobile_image", _this.mobile_hash);
                                _state.label = 5;
                            case 5:
                                event1.target.value = "";
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleMobileBackground",
            value: function handleMobileBackground(actionObject, formik) {
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var img_tag, _tmp;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        actionObject.image_url = window.URL.createObjectURL(actionObject.formRef.current.values.hero_section_attributes.mobile_image.file);
                        document.querySelector(".CropperModal").style.visibility = "visible";
                        img_tag = document.querySelector(".Cropper__Image");
                        img_tag.src = actionObject.image_url;
                        _tmp = {};
                        actionObject.setCropperType((_tmp.type = "mobile_image", _tmp.formik = {
                            values: actionObject.formRef.current.values
                        }, _tmp));
                        actionObject.cropperAction.initialize_cropping_area("mobile_image");
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "updateBackground",
            value: function updateBackground(blob_data) {
                var ref;
                var formData = new FormData();
                if (this.formRef.current.values.hero_section_attributes.id) formData.append("career_page[hero_section_attributes][id]", this.formRef.current.values.hero_section_attributes.id);
                formData.append("career_page[hero_section_attributes][bg_image]", blob_data, ((ref = this.formRef.current.values.hero_section_attributes.hero_image) === null || ref === void 0 ? void 0 : ref.file_name) || this.hero_hash.file_name);
                this.customizeCareerService.updateCareerPageImages(formData);
            }
        },
        {
            key: "updateMobileBackground",
            value: function updateMobileBackground(blob_data) {
                var ref;
                var formData = new FormData();
                if (this.formRef.current.values.hero_section_attributes.id) formData.append("career_page[hero_section_attributes][id]", this.formRef.current.values.hero_section_attributes.id);
                formData.append("career_page[hero_section_attributes][mobile_image]", blob_data, ((ref = this.formRef.current.values.hero_section_attributes.mobile_image) === null || ref === void 0 ? void 0 : ref.file_name) || this.mobile_hash.file_name);
                this.customizeCareerService.updateCareerPageImages(formData);
            }
        },
        {
            key: "handleAboutChange",
            value: function handleAboutChange(event1, formik, index1) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var file, img_tag, _tmp;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                file = event1.target.files[0];
                                if (!file) return [
                                    3,
                                    3
                                ];
                                if (!(file.size > _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.about.size */ ._f.about.size)) return [
                                    3,
                                    1
                                ];
                                _this.customToastrAction.setNormalToastr((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:image_size"), "warning");
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.commonAction.checkDimension(file, _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.about.minWidth */ ._f.about.minWidth, _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.about.minHeight */ ._f.about.minHeight, "about_image")
                                ];
                            case 2:
                                _tmp = {};
                                if (!_state.sent()) {
                                    _this.customToastrAction.setNormalToastr("".concat((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:min_image_size"), " ").concat(_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.about.minWidth */ ._f.about.minWidth, "px*").concat(_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.about.minHeight */ ._f.about.minHeight, "px."), "warning");
                                } else {
                                    _this.about_hash = {
                                        file_name: file.name,
                                        file: file,
                                        file_size: file.size
                                    };
                                    formik.setFieldValue("page_sections_attributes.".concat(index1, ".career_about_section_attributes.image"), _this.about_hash);
                                    _this.image_url = window.URL.createObjectURL(file);
                                    document.querySelector(".CropperModal").style.visibility = "visible";
                                    img_tag = document.querySelector(".Cropper__Image");
                                    img_tag.src = _this.image_url;
                                    _this.setCropperType((_tmp.type = "about_image", _tmp.formik = formik, _tmp.index = index1, _tmp));
                                    _this.cropperAction.initialize_cropping_area("about_image");
                                }
                                _state.label = 3;
                            case 3:
                                event1.target.value = "";
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateAboutImage",
            value: function updateAboutImage(formik, index1, blob_data) {
                var formData = new FormData();
                formData.append("career_page[page_sections_attributes][][id]", formik.values.page_sections_attributes[index1].id);
                formData.append("career_page[page_sections_attributes][][career_about_section_attributes][id]", formik.values.page_sections_attributes[index1].career_about_section_attributes.id);
                formData.append("career_page[page_sections_attributes][][career_about_section_attributes][image]", blob_data, this.formRef.current.values.page_sections_attributes[index1].career_about_section_attributes.image.file_name || this.about_hash.file_name);
                this.customizeCareerService.updateCareerPageImages(formData);
            }
        },
        {
            key: "handleGalleryImage",
            value: function handleGalleryImage(event1, formik, index1, gallery_index) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var file, img_tag, _tmp;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                file = event1.target.files[0];
                                if (!file) return [
                                    3,
                                    3
                                ];
                                if (!(file.size > _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.gallery.size */ ._f.gallery.size)) return [
                                    3,
                                    1
                                ];
                                _this.customToastrAction.setNormalToastr((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:image_size"), "warning");
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.commonAction.checkDimension(file, _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.gallery.minWidth */ ._f.gallery.minWidth, _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.gallery.minHeight */ ._f.gallery.minHeight, "gallery_image")
                                ];
                            case 2:
                                _tmp = {};
                                if (!_state.sent()) {
                                    _this.customToastrAction.setNormalToastr("".concat((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:min_image_size"), " ").concat(_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.gallery.minWidth */ ._f.gallery.minWidth, "px*").concat(_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.gallery.minHeight */ ._f.gallery.minHeight, "px."), "warning");
                                } else {
                                    _this.gallery_hash = {
                                        file_name: file.name,
                                        file: file,
                                        file_size: file.size
                                    };
                                    formik.setFieldValue("page_sections_attributes.".concat(index1, ".career_gallery_section_attributes.career_gallery_images_attributes.").concat(gallery_index, ".image"), _this.gallery_hash);
                                    _this.image_url = window.URL.createObjectURL(file);
                                    document.querySelector(".CropperModal").style.visibility = "visible";
                                    img_tag = document.querySelector(".Cropper__Image");
                                    img_tag.src = _this.image_url;
                                    _this.setCropperType((_tmp.type = "gallery_image", _tmp.formik = formik, _tmp.index = index1, _tmp.gallery_index = gallery_index, _tmp));
                                    _this.cropperAction.initialize_cropping_area("gallery_image");
                                }
                                _state.label = 3;
                            case 3:
                                event1.target.value = "";
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateGalleryImage",
            value: function updateGalleryImage(formik, index1, gallery_index, blob_data) {
                var formData = new FormData();
                formik.setFieldValue("page_sections_attributes.".concat(index1, ".career_gallery_section_attributes.career_gallery_images_attributes.").concat(gallery_index, ".display"), "show");
                formData.append("career_page[page_sections_attributes][][id]", formik.values.page_sections_attributes[index1].id);
                formData.append("career_page[page_sections_attributes][][career_gallery_section_attributes][id]", formik.values.page_sections_attributes[index1].career_gallery_section_attributes.id);
                formData.append("career_page[page_sections_attributes][][career_gallery_section_attributes][career_gallery_images_attributes][][id]", formik.values.page_sections_attributes[index1].career_gallery_section_attributes.career_gallery_images_attributes[gallery_index].id);
                formData.append("career_page[page_sections_attributes][][career_gallery_section_attributes][career_gallery_images_attributes][][image]", blob_data, this.formRef.current.values.page_sections_attributes[index1].career_gallery_section_attributes.career_gallery_images_attributes[gallery_index].image.file_name || this.gallery_hash.file_name);
                formData.append("career_page[page_sections_attributes][][career_gallery_section_attributes][career_gallery_images_attributes][][display]", "show");
                this.customizeCareerService.updateCareerPageImages(formData);
            }
        },
        {
            key: "handleTeamImage",
            value: function handleTeamImage(event1, formik, index1, team_index) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var file, img_tag, _tmp;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                file = event1.target.files[0];
                                if (!file) return [
                                    3,
                                    3
                                ];
                                if (!(file.size > _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.team.size */ ._f.team.size)) return [
                                    3,
                                    1
                                ];
                                _this.customToastrAction.setNormalToastr((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:image_size"), "warning");
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.commonAction.checkDimension(file, _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.team.minWidth */ ._f.team.minWidth, _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.team.minHeight */ ._f.team.minHeight, "team_image")
                                ];
                            case 2:
                                _tmp = {};
                                if (!_state.sent()) {
                                    _this.customToastrAction.setNormalToastr("".concat((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:min_image_size"), " ").concat(_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.team.minWidth */ ._f.team.minWidth, "px*").concat(_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.team.minHeight */ ._f.team.minHeight, "px."), "warning");
                                } else {
                                    _this.team_hash = {
                                        file_name: file.name,
                                        file: file,
                                        file_size: file.size
                                    };
                                    formik.setFieldValue("page_sections_attributes.".concat(index1, ".career_team_section_attributes.career_team_details_attributes.").concat(team_index, ".image"), _this.team_hash);
                                    _this.image_url = window.URL.createObjectURL(file);
                                    document.querySelector(".CropperModal").style.visibility = "visible";
                                    img_tag = document.querySelector(".Cropper__Image");
                                    img_tag.src = _this.image_url;
                                    _this.setCropperType((_tmp.type = "team_image", _tmp.formik = formik, _tmp.index = index1, _tmp.team_index = team_index, _tmp));
                                    _this.cropperAction.initialize_cropping_area("team_image");
                                }
                                _state.label = 3;
                            case 3:
                                event1.target.value = "";
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateTeamImage",
            value: function updateTeamImage(formik, index1, team_index, blob_data) {
                var formData = new FormData();
                formData.append("career_page[page_sections_attributes][][id]", formik.values.page_sections_attributes[index1].id);
                formData.append("career_page[page_sections_attributes][][career_team_section_attributes][id]", formik.values.page_sections_attributes[index1].career_team_section_attributes.id);
                formData.append("career_page[page_sections_attributes][][career_team_section_attributes][career_team_details_attributes][][id]", formik.values.page_sections_attributes[index1].career_team_section_attributes.career_team_details_attributes[team_index].id);
                formData.append("career_page[page_sections_attributes][][career_team_section_attributes][career_team_details_attributes][][image]", blob_data, this.formRef.current.values.page_sections_attributes[index1].career_team_section_attributes.career_team_details_attributes[team_index].image.file_name || this.team_hash.file_name);
                this.customizeCareerService.updateCareerPageImages(formData);
            }
        },
        {
            key: "handleBenefitImage",
            value: function handleBenefitImage(event1, formik, index1, benefit_index) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var file, img_tag, _tmp;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                file = event1.target.files[0];
                                if (!file) return [
                                    3,
                                    3
                                ];
                                if (!(file.size > _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.benefit.size */ ._f.benefit.size)) return [
                                    3,
                                    1
                                ];
                                _this.customToastrAction.setNormalToastr((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:image_size_1"), "warning");
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.commonAction.checkDimension(file, _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.benefit.minWidth */ ._f.benefit.minWidth, _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.benefit.minHeight */ ._f.benefit.minHeight, "benefit_image")
                                ];
                            case 2:
                                _tmp = {};
                                if (!_state.sent()) {
                                    _this.customToastrAction.setNormalToastr("".concat((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:min_image_size"), " ").concat(_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.benefit.minWidth */ ._f.benefit.minWidth, "px*").concat(_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.benefit.minHeight */ ._f.benefit.minHeight, "px."), "warning");
                                } else {
                                    _this.benefit_hash = {
                                        file_name: file.name,
                                        file: file,
                                        file_size: file.size
                                    };
                                    formik.setFieldValue("page_sections_attributes.".concat(index1, ".career_benefit_section_attributes.career_benefit_details_attributes.").concat(benefit_index, ".image"), _this.benefit_hash);
                                    _this.image_url = window.URL.createObjectURL(file);
                                    document.querySelector(".CropperModal").style.visibility = "visible";
                                    img_tag = document.querySelector(".Cropper__Image");
                                    img_tag.src = _this.image_url;
                                    _this.setCropperType((_tmp.type = "benefit_image", _tmp.formik = formik, _tmp.index = index1, _tmp.benefit_index = benefit_index, _tmp));
                                    _this.cropperAction.initialize_cropping_area("benefit_image");
                                }
                                _state.label = 3;
                            case 3:
                                event1.target.value = "";
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateBenefitImage",
            value: function updateBenefitImage(formik, index1, benefit_index, blob_data) {
                var formData = new FormData();
                formData.append("career_page[page_sections_attributes][][id]", formik.values.page_sections_attributes[index1].id);
                formData.append("career_page[page_sections_attributes][][career_benefit_section_attributes][id]", formik.values.page_sections_attributes[index1].career_benefit_section_attributes.id);
                formData.append("career_page[page_sections_attributes][][career_benefit_section_attributes][career_benefit_details_attributes][][id]", formik.values.page_sections_attributes[index1].career_benefit_section_attributes.career_benefit_details_attributes[benefit_index].id);
                formData.append("career_page[page_sections_attributes][][career_benefit_section_attributes][career_benefit_details_attributes][][image]", blob_data, this.formRef.current.values.page_sections_attributes[index1].career_benefit_section_attributes.career_benefit_details_attributes[benefit_index].image.file_name || this.benefit_hash.file_name);
                this.customizeCareerService.updateCareerPageImages(formData);
            }
        },
        {
            key: "closeCropperModal",
            value: function closeCropperModal() {
                this.cropperAction.destroy_cropper();
                document.querySelector(".CropperModal").style.visibility = "hidden";
            }
        },
        {
            key: "zoom_in",
            value: function zoom_in() {
                this.cropperAction.zoom_in();
            }
        },
        {
            key: "zoom_out",
            value: function zoom_out() {
                this.cropperAction.zoom_out();
            }
        },
        {
            key: "getCroppedImage",
            value: function getCroppedImage(props) {
                this.blob_data = this.cropperAction.crop_image(props);
            }
        },
        {
            key: "redirectToPreview",
            value: function redirectToPreview(slug, client_slug) {
                var preview_url = _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT.client.career_site.career_preview */ .RQ.client.career_site.career_preview;
                var protocol = window.location.protocol;
                var hostnamearray = window.location.host.split(".");
                var url = protocol + "//" + hostnamearray.join(".") + preview_url;
                window.open(url, "_blank");
            }
        },
        {
            key: "publishCareerPage",
            value: function publishCareerPage(formik, setLoading) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                return [
                                    4,
                                    _this.customizeCareerService.publishCareerPage(_tmp)
                                ];
                            case 1:
                                result = _state.sent();
                                if (result.data.success) {
                                    _this.customToastrAction.setNormalToastr((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("toastr:career_page_published"), "success");
                                    window.location.reload();
                                } else if (result.data.error) {
                                    _this.customToastrAction.setNormalToastr((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:something_wrong"), "error");
                                }
                                setLoading(false);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "resetCareerPage",
            value: function resetCareerPage(setResetCareerPage, formik, setLoading, setFlagForRender) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                return [
                                    4,
                                    _this.customizeCareerService.resetCareerPage(_tmp)
                                ];
                            case 1:
                                result = _state.sent();
                                if (!result.data.success) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    formik.setValues(result.data.career_page)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    setFlagForRender(Math.random() * 1000)
                                ];
                            case 3:
                                _state.sent();
                                _this.customToastrAction.setNormalToastr((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("toastr:career_page_reset"), "success");
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                if (result.data.error) {
                                    _this.customToastrAction.setNormalToastr((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:something_wrong"), "error");
                                }
                                _state.label = 5;
                            case 5:
                                setLoading(false);
                                setResetCareerPage(false);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addSection",
            value: function addSection(formik, section_type, layout, t) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var _Math, orders, next_order, page_sections_attributes, page_section, _tmp, new_section_title_prefix;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (formik.values.page_sections_attributes.length >= 8) {
                                    _this.customToastrAction.setNormalToastr((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:max_8_sections"), "warning");
                                    return [
                                        2
                                    ];
                                }
                                orders = formik.values.page_sections_attributes.map(function(page_section) {
                                    return page_section.order;
                                });
                                next_order = (_Math = Math).max.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(orders)) + 1;
                                page_sections_attributes = formik.values.page_sections_attributes;
                                _tmp = {};
                                page_section = _tmp;
                                new_section_title_prefix = _this.newSectionTitle(formik, section_type, t);
                                switch(section_type){
                                    case "about":
                                        page_section = {
                                            order: next_order,
                                            type: "about",
                                            career_about_section_attributes: {
                                                title: new_section_title_prefix + _this.sidebar_section.about.title,
                                                description: _this.sidebar_section.about.description,
                                                layout: layout
                                            }
                                        };
                                        break;
                                    case "benefit":
                                        page_section = {
                                            order: next_order,
                                            type: "benefit",
                                            career_benefit_section_attributes: {
                                                title: new_section_title_prefix + _this.sidebar_section.benefit.title,
                                                layout: layout,
                                                career_benefit_details_attributes: _this.benefit_details_data(layout, t)
                                            }
                                        };
                                        break;
                                    case "team":
                                        page_section = {
                                            order: next_order,
                                            type: "team",
                                            career_team_section_attributes: {
                                                title: new_section_title_prefix + _this.sidebar_section.team.title,
                                                layout: layout,
                                                career_team_details_attributes: _this.team_details_data(layout, t)
                                            }
                                        };
                                        break;
                                    case "gallery":
                                        page_section = {
                                            order: next_order,
                                            type: "gallery",
                                            career_gallery_section_attributes: {
                                                title: new_section_title_prefix + _this.sidebar_section.gallery.title,
                                                description: _this.sidebar_section.gallery.description,
                                                layout: layout,
                                                career_gallery_images_attributes: _this.gallery_details_data(layout)
                                            }
                                        };
                                        break;
                                }
                                page_sections_attributes.push(page_section);
                                return [
                                    4,
                                    _this.updatePageSection(formik, page_section)
                                ];
                            case 1:
                                _state.sent();
                                setTimeout(function() {
                                    var section_link = _this.formRef.current.values.page_sections_attributes[_this.formRef.current.values.page_sections_attributes.length - 1].uniq_reference;
                                    var section = document.querySelector("#" + section_link);
                                    if (section) section.scrollIntoView({
                                        behavior: "smooth",
                                        block: "start"
                                    });
                                }, 100);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "removeSection",
            value: function removeSection(formik, page_section) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                page_section._destroy = true;
                                return [
                                    4,
                                    _this.updatePageSection(formik, page_section)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "newSectionTitle",
            value: function newSectionTitle(formik, section_type, t) {
                var oldSection = formik.values.page_sections_attributes.filter(function(x) {
                    return x.type == section_type;
                })[0];
                return oldSection ? t("career:copy_of") : "";
            }
        },
        {
            key: "benefit_details_data",
            value: function benefit_details_data(layout, t) {
                switch(layout){
                    case "six_cards":
                        return Array(6).fill(0).map(function(_, i) {
                            return {
                                title: t("career:benefit_details_data:add_title"),
                                description: t("career:benefit_details_data:add_description"),
                                display: "hide"
                            };
                        });
                }
            }
        },
        {
            key: "team_details_data",
            value: function team_details_data(layout, t) {
                switch(layout){
                    case "with_description":
                        return Array(6).fill(0).map(function(_, i) {
                            return {
                                name: (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TEAM_NO_DATA */ .$t)(t).data.name,
                                designation: (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TEAM_NO_DATA */ .$t)(t).data.designation,
                                description: (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TEAM_NO_DATA */ .$t)(t).data.description,
                                display: "hide"
                            };
                        });
                    case "without_description":
                        return Array(6).fill(0).map(function(_, i) {
                            return {
                                name: (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TEAM_NO_DATA */ .$t)(t).data.name,
                                designation: (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TEAM_NO_DATA */ .$t)(t).data.designation,
                                description: "",
                                display: "hide"
                            };
                        });
                }
            }
        },
        {
            key: "gallery_details_data",
            value: function gallery_details_data(layout) {
                return Array(6).fill(0).map(function(_, i) {
                    return {
                        display: "show"
                    };
                });
            }
        },
        {
            key: "addHFLinks",
            value: function addHFLinks(formik, type) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var navigation_links, _tmp;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        navigation_links = formik.values.career_navigation_links_attributes;
                        _tmp = {};
                        navigation_links.push((_tmp.name = "", _tmp.url = "", _tmp.navigation_type = type, _tmp));
                        setTimeout(function() {
                            _this.updateNavigationLinkSection(formik, navigation_links);
                        }, 100);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "removeHFLinks",
            value: function removeHFLinks(formik, type, index1) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    formik.setFieldValue("career_navigation_links_attributes.".concat(index1, "._destroy"), true)
                                ];
                            case 1:
                                _state.sent();
                                setTimeout(function() {
                                    _this.updateNavigationLinkSection(formik, _this.formRef.current.values.career_navigation_links_attributes);
                                }, 100);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "showAddButton",
            value: function showAddButton(formik, type) {
                return formik.values.career_navigation_links_attributes.filter(function(navigation) {
                    return navigation.navigation_type == type;
                }).length < 3;
            }
        },
        {
            key: "updateNavigationLink",
            value: function updateNavigationLink(formik, link_index) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var navigation_link, params, _tmp, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                navigation_link = formik.values.career_navigation_links_attributes[link_index];
                                _tmp = {};
                                params = (_tmp.career_page = {
                                    career_navigation_links_attributes: navigation_link
                                }, _tmp);
                                if (!(_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .URL_FORMAT.test */ .QC.test(navigation_link.url) || navigation_link.url == "")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.customizeCareerService.updateCareerPage(params)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                formik.setFieldError(event.target.name, "Please enter valid url");
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateSocialLink",
            value: function updateSocialLink(event1, formik) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        setTimeout(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                            var params, _tmp, result;
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!(_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .URL_FORMAT.test */ .QC.test(event1.target.value) || event1.target.value == "")) return [
                                            3,
                                            2
                                        ];
                                        _tmp = {};
                                        params = (_tmp.career_page = {
                                            career_social_link_attributes: formik.values.career_social_link_attributes
                                        }, _tmp);
                                        return [
                                            4,
                                            _this.customizeCareerService.updateCareerPage(params)
                                        ];
                                    case 1:
                                        result = _state.sent();
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        formik.setFieldError(event1.target.name, "Please enter valid url");
                                        _state.label = 3;
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        }), 100);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "onDragEnd",
            value: function onDragEnd(result, formRef1) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var destination, source, add, active;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                destination = result.destination, source = result.source;
                                if (!destination) {
                                    return [
                                        2
                                    ];
                                }
                                if (destination.droppableId === source.droppableId && destination.index === source.index) {
                                    return [
                                        2
                                    ];
                                }
                                active = formRef1.current.values.page_sections_attributes;
                                // Source Logic
                                if (source.droppableId === "SectionsList") {
                                    add = active[source.index];
                                    active.splice(source.index, 1);
                                }
                                // Destination Logic
                                if (destination.droppableId === "SectionsList") {
                                    active.splice(destination.index, 0, add);
                                }
                                return [
                                    4,
                                    formRef1.current.setFieldValue("page_sections_attributes", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(active))
                                ];
                            case 1:
                                _state.sent();
                                _this.updateOrdering(formRef1);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateOrdering",
            value: function updateOrdering(formRef1) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var page_sections, params, _tmp, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                page_sections = formRef1.current.values.page_sections_attributes.map(function(x, order_index) {
                                    return {
                                        order: order_index + 1,
                                        id: x.id
                                    };
                                });
                                _tmp = {};
                                params = (_tmp.career_page = {
                                    page_sections_attributes: page_sections
                                }, _tmp);
                                return [
                                    4,
                                    _this.customizeCareerService.updateCareerPage(params)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fontStyleChange",
            value: function fontStyleChange(custom_event, formik, style, type, setFonts) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var new_value;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(type == "button")) return [
                                    3,
                                    40
                                ];
                                switch(style){
                                    case "hero_button_background_color":
                                        return [
                                            3,
                                            1
                                        ];
                                    case "hero_button_font_color":
                                        return [
                                            3,
                                            3
                                        ];
                                    case "view_more_job_button_background_color":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "view_more_job_button_font_color":
                                        return [
                                            3,
                                            7
                                        ];
                                    case "font_weight":
                                        return [
                                            3,
                                            9
                                        ];
                                    case "font_style":
                                        return [
                                            3,
                                            11
                                        ];
                                    case "text_decoration":
                                        return [
                                            3,
                                            13
                                        ];
                                    case "font_size":
                                        return [
                                            3,
                                            15
                                        ];
                                    case "font_family":
                                        return [
                                            3,
                                            17
                                        ];
                                    case "fill":
                                        return [
                                            3,
                                            19
                                        ];
                                    case "color":
                                        return [
                                            3,
                                            30
                                        ];
                                    case "background_color":
                                        return [
                                            3,
                                            34
                                        ];
                                    case "border_radius":
                                        return [
                                            3,
                                            37
                                        ];
                                }
                                return [
                                    3,
                                    39
                                ];
                            case 1:
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.hero_button.background_color", custom_event.rgb)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    39
                                ];
                            case 3:
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.hero_button.font_color", custom_event.rgb)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    39
                                ];
                            case 5:
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.view_more_job_button.background_color", custom_event.rgb)
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    3,
                                    39
                                ];
                            case 7:
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.view_more_job_button.font_color", custom_event.rgb)
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    3,
                                    39
                                ];
                            case 9:
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.style_hash.fontWeight", custom_event.target.checked ? "bold" : "normal")
                                ];
                            case 10:
                                _state.sent();
                                return [
                                    3,
                                    39
                                ];
                            case 11:
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.style_hash.fontStyle", custom_event.target.checked ? "italic" : "normal")
                                ];
                            case 12:
                                _state.sent();
                                return [
                                    3,
                                    39
                                ];
                            case 13:
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.style_hash.textDecoration", custom_event.target.checked ? "underline" : "none")
                                ];
                            case 14:
                                _state.sent();
                                return [
                                    3,
                                    39
                                ];
                            case 15:
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.style_hash.fontSize", custom_event.value)
                                ];
                            case 16:
                                _state.sent();
                                return [
                                    3,
                                    39
                                ];
                            case 17:
                                return [
                                    4,
                                    _this.formRef.current.setFieldValue("career_button_style_attributes.style_hash.fontFamily", custom_event.value).then(function() {
                                        setFonts(_this.listofAllFonts());
                                    })
                                ];
                            case 18:
                                _state.sent();
                                return [
                                    3,
                                    39
                                ];
                            case 19:
                                if (!(custom_event.value == "outline")) return [
                                    3,
                                    24
                                ];
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.style_hash.fill", custom_event.value)
                                ];
                            case 20:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.style_hash.fillColor", formik.values.career_button_style_attributes.style_hash.backgroundColor)
                                ];
                            case 21:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.style_hash.backgroundColor", "transparent")
                                ];
                            case 22:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.style_hash.borderColor", formik.values.career_button_style_attributes.style_hash.color)
                                ];
                            case 23:
                                _state.sent();
                                return [
                                    3,
                                    29
                                ];
                            case 24:
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.style_hash.fill", custom_event.value)
                                ];
                            case 25:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.style_hash.backgroundColor", formik.values.career_button_style_attributes.style_hash.fillColor)
                                ];
                            case 26:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.style_hash.borderColor", formik.values.career_button_style_attributes.style_hash.fillColor)
                                ];
                            case 27:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.style_hash.fillColor", "")
                                ];
                            case 28:
                                _state.sent();
                                _state.label = 29;
                            case 29:
                                return [
                                    3,
                                    39
                                ];
                            case 30:
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.style_hash.color", custom_event.rgb)
                                ];
                            case 31:
                                _state.sent();
                                if (!(formik.values.career_button_style_attributes.style_hash.fill == "outline")) return [
                                    3,
                                    33
                                ];
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.style_hash.borderColor", custom_event.rgb)
                                ];
                            case 32:
                                _state.sent();
                                _state.label = 33;
                            case 33:
                                return [
                                    3,
                                    39
                                ];
                            case 34:
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.style_hash.backgroundColor", custom_event.rgb)
                                ];
                            case 35:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.style_hash.borderColor", custom_event.rgb)
                                ];
                            case 36:
                                _state.sent();
                                return [
                                    3,
                                    39
                                ];
                            case 37:
                                new_value = isNaN(custom_event.target.value) ? formik.values.career_button_style_attributes.style_hash.borderRadius : parseInt(custom_event.target.value) == 0 ? "" : custom_event.target.value;
                                return [
                                    4,
                                    formik.setFieldValue("career_button_style_attributes.style_hash.borderRadius", new_value)
                                ];
                            case 38:
                                _state.sent();
                                return [
                                    3,
                                    39
                                ];
                            case 39:
                                setTimeout(_this.updateButtonStyle(formik), 1000);
                                return [
                                    3,
                                    76
                                ];
                            case 40:
                                if (!(type == "overlay")) return [
                                    3,
                                    44
                                ];
                                switch(style){
                                    case "hero_background_overlay":
                                        return [
                                            3,
                                            41
                                        ];
                                }
                                return [
                                    3,
                                    43
                                ];
                            case 41:
                                return [
                                    4,
                                    formik.setFieldValue("hero_section_attributes.overlay_hash", custom_event.rgb)
                                ];
                            case 42:
                                _state.sent();
                                return [
                                    3,
                                    43
                                ];
                            case 43:
                                setTimeout(_this.updateHeroSection(formik.values), 1000);
                                return [
                                    3,
                                    76
                                ];
                            case 44:
                                switch(style){
                                    case "font_family":
                                        return [
                                            3,
                                            45
                                        ];
                                    case "hero_font_size":
                                        return [
                                            3,
                                            47
                                        ];
                                    case "hero_font_color":
                                        return [
                                            3,
                                            49
                                        ];
                                    case "style_1_background_color":
                                        return [
                                            3,
                                            51
                                        ];
                                    case "style_1_font_color":
                                        return [
                                            3,
                                            53
                                        ];
                                    case "style_2_background_color":
                                        return [
                                            3,
                                            55
                                        ];
                                    case "style_2_font_color":
                                        return [
                                            3,
                                            57
                                        ];
                                    case "style_3_font_color":
                                        return [
                                            3,
                                            59
                                        ];
                                    case "font_weight":
                                        return [
                                            3,
                                            61
                                        ];
                                    case "font_style":
                                        return [
                                            3,
                                            63
                                        ];
                                    case "text_decoration":
                                        return [
                                            3,
                                            65
                                        ];
                                    case "font_size":
                                        return [
                                            3,
                                            67
                                        ];
                                    case "font_family":
                                        return [
                                            3,
                                            69
                                        ];
                                    case "fill":
                                        return [
                                            3,
                                            71
                                        ];
                                    case "border_radius":
                                        return [
                                            3,
                                            73
                                        ];
                                }
                                return [
                                    3,
                                    75
                                ];
                            case 45:
                                return [
                                    4,
                                    formik.setFieldValue("career_font_style_attributes.font_family", custom_event.value).then(function() {
                                        setFonts(_this.listofAllFonts(formik));
                                        setTimeout(_this.updateFontStyle(formik), 2000);
                                    })
                                ];
                            case 46:
                                _state.sent();
                                return [
                                    3,
                                    75
                                ];
                            case 47:
                                return [
                                    4,
                                    formik.setFieldValue("career_font_style_attributes.hero_font_size", custom_event.value)
                                ];
                            case 48:
                                _state.sent();
                                return [
                                    3,
                                    75
                                ];
                            case 49:
                                return [
                                    4,
                                    formik.setFieldValue("career_font_style_attributes.hero_font_color", custom_event.rgb)
                                ];
                            case 50:
                                _state.sent();
                                return [
                                    3,
                                    75
                                ];
                            case 51:
                                return [
                                    4,
                                    formik.setFieldValue("career_font_style_attributes.style_hash.style_1.background_color", custom_event.rgb)
                                ];
                            case 52:
                                _state.sent();
                                return [
                                    3,
                                    75
                                ];
                            case 53:
                                return [
                                    4,
                                    formik.setFieldValue("career_font_style_attributes.style_hash.style_1.font_color", custom_event.rgb)
                                ];
                            case 54:
                                _state.sent();
                                return [
                                    3,
                                    75
                                ];
                            case 55:
                                return [
                                    4,
                                    formik.setFieldValue("career_font_style_attributes.style_hash.style_2.background_color", custom_event.rgb)
                                ];
                            case 56:
                                _state.sent();
                                return [
                                    3,
                                    75
                                ];
                            case 57:
                                return [
                                    4,
                                    formik.setFieldValue("career_font_style_attributes.style_hash.style_2.font_color", custom_event.rgb)
                                ];
                            case 58:
                                _state.sent();
                                return [
                                    3,
                                    75
                                ];
                            case 59:
                                return [
                                    4,
                                    formik.setFieldValue("career_font_style_attributes.style_hash.style_3.font_color", custom_event.rgb)
                                ];
                            case 60:
                                _state.sent();
                                return [
                                    3,
                                    75
                                ];
                            case 61:
                                return [
                                    4,
                                    formik.setFieldValue("career_font_styles_attributes.".concat(index, ".style_hash.fontWeight"), custom_event.target.checked ? "bold" : "normal")
                                ];
                            case 62:
                                _state.sent();
                                return [
                                    3,
                                    75
                                ];
                            case 63:
                                return [
                                    4,
                                    formik.setFieldValue("career_font_styles_attributes.".concat(index, ".style_hash.fontStyle"), custom_event.target.checked ? "italic" : "normal")
                                ];
                            case 64:
                                _state.sent();
                                return [
                                    3,
                                    75
                                ];
                            case 65:
                                return [
                                    4,
                                    formik.setFieldValue("career_font_styles_attributes.".concat(index, ".style_hash.textDecoration"), custom_event.target.checked ? "underline" : "none")
                                ];
                            case 66:
                                _state.sent();
                                return [
                                    3,
                                    75
                                ];
                            case 67:
                                return [
                                    4,
                                    formik.setFieldValue("career_font_styles_attributes.".concat(index, ".style_hash.fontSize"), custom_event.value)
                                ];
                            case 68:
                                _state.sent();
                                return [
                                    3,
                                    75
                                ];
                            case 69:
                                return [
                                    4,
                                    formik.setFieldValue("career_font_styles_attributes.".concat(index, ".style_hash.fontFamily"), custom_event.value).then(function() {
                                        setFonts(_this.listofAllFonts(formik));
                                        setTimeout(_this.updateFontStyle(formik), 2000);
                                    })
                                ];
                            case 70:
                                _state.sent();
                                return [
                                    3,
                                    75
                                ];
                            case 71:
                                return [
                                    4,
                                    formik.setFieldValue("career_font_styles_attributes.".concat(index, ".style_hash.fill"), custom_event.value)
                                ];
                            case 72:
                                _state.sent();
                                return [
                                    3,
                                    75
                                ];
                            case 73:
                                return [
                                    4,
                                    formik.setFieldValue("career_font_styles_attributes.".concat(index, ".style_hash.borderRadius"), custom_event.target.value)
                                ];
                            case 74:
                                _state.sent();
                                return [
                                    3,
                                    75
                                ];
                            case 75:
                                setTimeout(_this.updateFontStyle(formik), 1000);
                                _state.label = 76;
                            case 76:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fontStyleChecked",
            value: function fontStyleChecked(formik, style, type) {
                var index1 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
                var career_button_style = type == "button" ? formik.values.career_button_style_attributes : formik.values.career_font_styles_attributes[index1];
                switch(style){
                    case "font_weight":
                        return career_button_style.style_hash.fontWeight == "bold";
                        break;
                    case "font_style":
                        return career_button_style.style_hash.fontStyle == "italic";
                        break;
                    case "text_decoration":
                        return career_button_style.style_hash.textDecoration == "underline";
                        break;
                }
            }
        },
        {
            key: "updateButtonStyle",
            value: function updateButtonStyle(formik) {
                var params = {
                    career_page: {
                        career_button_style_attributes: this.formRef.current.values.career_button_style_attributes
                    }
                };
                var result = this.customizeCareerService.updateCareerPage(params);
            }
        },
        {
            key: "updateFontStyle",
            value: function updateFontStyle(formik) {
                var params = {
                    career_page: {
                        career_font_style_attributes: this.formRef.current.values.career_font_style_attributes
                    }
                };
                var result = this.customizeCareerService.updateCareerPage(params);
            }
        },
        {
            key: "showHideGalleryImage",
            value: function showHideGalleryImage(formik, index1, gallery_index, new_value) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var hidden_image_count;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (new_value == "hide") {
                                    hidden_image_count = formik.values.page_sections_attributes[index1].career_gallery_section_attributes.career_gallery_images_attributes.filter(function(x) {
                                        return x.display == "hide";
                                    }).length;
                                    if (hidden_image_count >= 3) {
                                        _this.customToastrAction.setNormalToastr((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:min_3_images"), "warning");
                                        return [
                                            2
                                        ];
                                    }
                                }
                                return [
                                    4,
                                    formik.setFieldValue("page_sections_attributes.".concat(index1, ".career_gallery_section_attributes.career_gallery_images_attributes.").concat(gallery_index, ".display"), new_value)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.updateAboutRef(index1)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "heroTitleStyle",
            value: function heroTitleStyle(formik) {
                return {
                    fontSize: formik.values.career_font_style_attributes.hero_font_size,
                    fontFamily: formik.values.career_font_style_attributes.font_family,
                    color: this.rgbColorStyle(formik.values.career_font_style_attributes.hero_font_color || {
                        r: 255,
                        g: 255,
                        b: 255,
                        a: 1
                    })
                };
            }
        },
        {
            key: "titleStyle",
            value: function titleStyle(formik) {
                var ref, ref1;
                return ((ref1 = (ref = formik.values.career_font_styles_attributes) === null || ref === void 0 ? void 0 : ref.filter(function(x) {
                    return x.font_type == "title_text";
                })[0]) === null || ref1 === void 0 ? void 0 : ref1.style_hash) || {};
            }
        },
        {
            key: "bodyStyle",
            value: function bodyStyle(formik) {
                var ref, ref1;
                return ((ref1 = (ref = formik.values.career_font_styles_attributes) === null || ref === void 0 ? void 0 : ref.filter(function(x) {
                    return x.font_type == "body_text";
                })[0]) === null || ref1 === void 0 ? void 0 : ref1.style_hash) || {};
            }
        },
        {
            key: "labelStyle",
            value: function labelStyle(formik) {
                return {
                    fontFamily: formik.values.career_font_style_attributes.font_family,
                    color: this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_1.font_color)
                };
            }
        },
        {
            key: "headerStyle",
            value: function headerStyle(formik) {
                return {
                    fontFamily: formik.values.career_font_style_attributes.font_family
                };
            }
        },
        {
            key: "heroButtonStyle",
            value: function heroButtonStyle(formik) {
                var ref, ref1, ref2;
                var borderRadius = formik.values.career_button_style_attributes.style_hash.borderRadius ? "".concat(formik.values.career_button_style_attributes.style_hash.borderRadius, "px") : "0px";
                var button_style = {
                    borderRadius: borderRadius,
                    fontSize: formik.values.career_button_style_attributes.style_hash.fontSize,
                    color: this.rgbColorStyle((ref = formik.values.career_button_style_attributes.hero_button) === null || ref === void 0 ? void 0 : ref.font_color),
                    backgroundColor: this.rgbColorStyle((ref1 = formik.values.career_button_style_attributes.hero_button) === null || ref1 === void 0 ? void 0 : ref1.background_color),
                    borderColor: this.rgbColorStyle((ref2 = formik.values.career_button_style_attributes.hero_button) === null || ref2 === void 0 ? void 0 : ref2.background_color)
                };
                return button_style;
            }
        },
        {
            key: "viewMoreButtonStyle",
            value: function viewMoreButtonStyle(formik) {
                var ref, ref1, ref2;
                var borderRadius = formik.values.career_button_style_attributes.style_hash.borderRadius ? "".concat(formik.values.career_button_style_attributes.style_hash.borderRadius, "px") : "0px";
                var button_style = {
                    borderRadius: borderRadius,
                    fontSize: formik.values.career_button_style_attributes.style_hash.fontSize,
                    color: this.rgbColorStyle((ref = formik.values.career_button_style_attributes.view_more_job_button) === null || ref === void 0 ? void 0 : ref.font_color),
                    backgroundColor: this.rgbColorStyle((ref1 = formik.values.career_button_style_attributes.view_more_job_button) === null || ref1 === void 0 ? void 0 : ref1.background_color),
                    borderColor: this.rgbColorStyle((ref2 = formik.values.career_button_style_attributes.view_more_job_button) === null || ref2 === void 0 ? void 0 : ref2.background_color)
                };
                return button_style;
            }
        },
        {
            key: "fontSizeOptions",
            value: function fontSizeOptions(font_type, t) {
                var labelList = [
                    t("career:styles:font_small"),
                    t("career:styles:font_medium"),
                    t("career:styles:font_large"), 
                ];
                switch(font_type){
                    case "hero_font_size":
                        return [
                            3,
                            5,
                            7
                        ].map(function(_, i) {
                            return {
                                label: "".concat(labelList[i]),
                                value: "".concat(_, "em")
                            };
                        });
                    case "hero_text":
                        return [
                            2.375,
                            2.625,
                            2.875
                        ].map(function(_, i) {
                            return {
                                label: "".concat(labelList[i]),
                                value: "".concat(_, "em")
                            };
                        });
                    case "title_text":
                        return [
                            2,
                            2.25,
                            2.5
                        ].map(function(_, i) {
                            return {
                                label: "".concat(labelList[i]),
                                value: "".concat(_, "em")
                            };
                        });
                    case "body_text":
                        return [
                            1.375,
                            1.5,
                            1.625
                        ].map(function(_, i) {
                            return {
                                label: "".concat(labelList[i]),
                                value: "".concat(_, "em")
                            };
                        });
                    case "sub_text":
                        return [
                            0.875,
                            1,
                            1.125
                        ].map(function(_, i) {
                            return {
                                label: "".concat(labelList[i]),
                                value: "".concat(_, "em")
                            };
                        });
                    case "button_text":
                        return [
                            1,
                            1.25,
                            1.5
                        ].map(function(_, i) {
                            return {
                                label: "".concat(labelList[i]),
                                value: "".concat(_, "em")
                            };
                        });
                }
            }
        },
        {
            key: "listofAllFonts",
            value: function listofAllFonts(formik) {
                var fontFamilies = [
                    this.formRef.current.values.career_font_style_attributes.font_family
                ];
                var fontOptionsList = (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .fontOptions */ .yf)();
                return fontFamilies.map(function(font) {
                    var ref;
                    return {
                        font: font,
                        weights: ((ref = fontOptionsList.filter(function(x) {
                            return x.label == font;
                        })[0]) === null || ref === void 0 ? void 0 : ref.variants) || []
                    };
                });
            }
        },
        {
            key: "groupBy",
            value: function groupBy(xs, key, value) {
                return xs.reduce(function(rv, x) {
                    (rv[x[key]] = rv[x[key]] || []).push({
                        font: x[value],
                        variants: x["variants"]
                    });
                    return rv;
                }, {});
            }
        },
        {
            key: "fontFamilyByCategory",
            value: function fontFamilyByCategory() {
                var fontFamilyWithCategory = fontsList.items.map(function(fontItem) {
                    return {
                        family: fontItem.family,
                        category: fontItem.category,
                        variants: fontItem.variants
                    };
                });
                var fontFamilyByCategory1 = this.groupBy(fontFamilyWithCategory, "category", "family");
                return fontFamilyByCategory1;
            }
        },
        {
            key: "listOfSections",
            value: function listOfSections() {
                var _this = this;
                return this.formRef.current.values.page_sections_attributes.map(function(section) {
                    return {
                        label: _this.sectionTitle(section),
                        value: section.uniq_reference
                    };
                });
            }
        },
        {
            key: "sectionTitle",
            value: function sectionTitle(section) {
                switch(section.type){
                    case "about":
                        return section.career_about_section_attributes.title;
                        break;
                    case "gallery":
                        return section.career_gallery_section_attributes.title;
                        break;
                    case "benefit":
                        return section.career_benefit_section_attributes.title;
                        break;
                    case "team":
                        return section.career_team_section_attributes.title;
                        break;
                    case "job":
                        return "Our open jobs";
                }
            }
        },
        {
            key: "onHeroButtonClick",
            value: function onHeroButtonClick(formik, isPreview, button_index) {
                if (isPreview) {
                    var link_type = formik.values.hero_section_attributes.button_hash.buttons[button_index].is_link;
                    var link = formik.values.hero_section_attributes.button_hash.buttons[button_index].link;
                    if (link_type == "section") {
                        var section = document.querySelector("#" + link);
                        if (section) section.scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });
                    } else if (link_type == "link" && link) {
                        link = this.commonAction.addHttpOrHttps(link);
                        window.open(link, "_blank");
                    }
                }
            }
        },
        {
            key: "listOfSerifs",
            value: function listOfSerifs() {
                return _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .fonts["sans-serif"].map */ .Rq["sans-serif"].map(function(fs) {
                    return {
                        label: fs.font,
                        value: fs.font,
                        variants: fs.variants
                    };
                });
            }
        },
        {
            key: "addTeamCard",
            value: function addTeamCard(formik, index1, setFlagForReRender, t) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var career_team_section_attributes, layout, career_team_details_attributes, _tmp, _tmp1, page_section;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                career_team_section_attributes = formik.values.page_sections_attributes[index1].career_team_section_attributes;
                                layout = career_team_section_attributes.layout;
                                career_team_details_attributes = career_team_section_attributes.career_team_details_attributes;
                                _tmp = {};
                                _tmp1 = {};
                                if (layout == "with_description") {
                                    career_team_details_attributes.push((_tmp.name = (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TEAM_NO_DATA */ .$t)(t).data.name, _tmp.designation = (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TEAM_NO_DATA */ .$t)(t).data.designation, _tmp.description = (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TEAM_NO_DATA */ .$t)(t).data.description, _tmp.display = "hide", _tmp));
                                } else {
                                    career_team_details_attributes.push((_tmp1.name = (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TEAM_NO_DATA */ .$t)(t).data.name, _tmp1.designation = (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TEAM_NO_DATA */ .$t)(t).data.designation, _tmp1.description = "", _tmp1.display = "hide", _tmp1));
                                }
                                page_section = _this.formRef.current.values.page_sections_attributes[index1];
                                return [
                                    4,
                                    _this.updatePageSection(formik, page_section)
                                ];
                            case 1:
                                _state.sent();
                                setFlagForReRender(Math.random() * 1000);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "removeTeamCard",
            value: function removeTeamCard(formik, index1, team_index, setFlagForReRender) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var career_team_section_attributes, career_team_details_attributes, page_section;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                career_team_section_attributes = formik.values.page_sections_attributes[index1].career_team_section_attributes;
                                career_team_details_attributes = career_team_section_attributes.career_team_details_attributes;
                                career_team_details_attributes[team_index]._destroy = true;
                                page_section = _this.formRef.current.values.page_sections_attributes[index1];
                                return [
                                    4,
                                    _this.updatePageSection(formik, page_section)
                                ];
                            case 1:
                                _state.sent();
                                setFlagForReRender(Math.random() * 1000);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addBenefitCard",
            value: function addBenefitCard(formik, index1, setFlagForReRender, t) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var career_benefit_section_attributes, career_benefit_details_attributes, _tmp, page_section;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                career_benefit_section_attributes = formik.values.page_sections_attributes[index1].career_benefit_section_attributes;
                                career_benefit_details_attributes = career_benefit_section_attributes.career_benefit_details_attributes;
                                _tmp = {};
                                career_benefit_details_attributes.push((_tmp.title = t("career:benefit_details_data:add_title"), _tmp.description = t("career:benefit_details_data:add_description"), _tmp.display = "hide", _tmp));
                                page_section = _this.formRef.current.values.page_sections_attributes[index1];
                                return [
                                    4,
                                    _this.updatePageSection(formik, page_section)
                                ];
                            case 1:
                                _state.sent();
                                setFlagForReRender(Math.random() * 1000);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "removeBenefitCard",
            value: function removeBenefitCard(formik, index1, benefit_index, setFlagForReRender) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var career_benefit_section_attributes, career_benefit_details_attributes, page_section;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                career_benefit_section_attributes = formik.values.page_sections_attributes[index1].career_benefit_section_attributes;
                                career_benefit_details_attributes = career_benefit_section_attributes.career_benefit_details_attributes;
                                career_benefit_details_attributes[benefit_index]._destroy = true;
                                page_section = _this.formRef.current.values.page_sections_attributes[index1];
                                return [
                                    4,
                                    _this.updatePageSection(formik, page_section)
                                ];
                            case 1:
                                _state.sent();
                                setFlagForReRender(Math.random() * 1000);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addGalleryCard",
            value: function addGalleryCard(formik, index1) {
                var _this = this;
                var career_gallery_section_attributes = formik.values.page_sections_attributes[index1].career_gallery_section_attributes;
                var career_gallery_images_attributes = career_gallery_section_attributes.career_gallery_images_attributes;
                career_gallery_images_attributes.push({
                    display: "hide"
                });
                setTimeout(function() {
                    var page_section = _this.formRef.current.values.page_sections_attributes[index1];
                    _this.updatePageSection(formik, page_section);
                }, 100);
            }
        },
        {
            key: "removeGalleryCard",
            value: function removeGalleryCard(formik, index1, gallery_index) {
                var _this = this;
                var career_gallery_section_attributes = formik.values.page_sections_attributes[index1].career_gallery_section_attributes;
                var career_gallery_images_attributes = career_gallery_section_attributes.career_gallery_images_attributes;
                career_gallery_images_attributes[gallery_index]._destroy = true;
                setTimeout(function() {
                    var page_section = _this.formRef.current.values.page_sections_attributes[index1];
                    _this.updatePageSection(formik, page_section);
                }, 100);
            }
        },
        {
            key: "socialLinkClick",
            value: function socialLinkClick(formik, index1, team_index, isPreview, setSocialPopup, fieldName) {
                var url = "";
                if (isPreview) {
                    switch(fieldName){
                        case "facebook_url":
                            url = formik.values.page_sections_attributes[index1].career_team_section_attributes.career_team_details_attributes[team_index].facebook_url;
                            url = this.commonAction.addHttpOrHttps(url);
                            if (url) window.open(url, "_blank");
                            break;
                        case "twitter_url":
                            url = formik.values.page_sections_attributes[index1].career_team_section_attributes.career_team_details_attributes[team_index].twitter_url;
                            url = this.commonAction.addHttpOrHttps(url);
                            if (url) window.open(url, "_blank");
                            break;
                        case "linkedin_url":
                            url = formik.values.page_sections_attributes[index1].career_team_section_attributes.career_team_details_attributes[team_index].linkedin_url;
                            url = this.commonAction.addHttpOrHttps(url);
                            if (url) window.open(url, "_blank");
                            break;
                    }
                } else {
                    setSocialPopup({
                        state: true,
                        index: index1,
                        team_index: team_index,
                        formik: formik
                    });
                }
            }
        },
        {
            key: "imageInfoContent",
            value: function imageInfoContent(type) {
                switch(type){
                    case "logo_image":
                        return (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("tooltip:images:logo_image", {
                            minWidth: _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.logo.minWidth */ ._f.logo.minWidth,
                            minHeight: _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.logo.minHeight */ ._f.logo.minHeight
                        });
                    case "hero_image":
                        return (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("tooltip:images:logo_image", {
                            minWidth: _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.hero.minWidth */ ._f.hero.minWidth,
                            minHeight: _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.hero.minHeight */ ._f.hero.minHeight
                        });
                    case "about_image":
                        return (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("tooltip:images:logo_image", {
                            minWidth: _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.about.minWidth */ ._f.about.minWidth,
                            minHeight: _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.about.minHeight */ ._f.about.minHeight
                        });
                    case "gallery_image":
                        return (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("tooltip:images:logo_image", {
                            minWidth: _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.gallery.minWidth */ ._f.gallery.minWidth,
                            minHeight: _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.gallery.minHeight */ ._f.gallery.minHeight
                        });
                    case "benefit_image":
                        return (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("tooltip:images:benefit_image", {
                            minWidth: _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.benefit.minWidth */ ._f.benefit.minWidth,
                            minHeight: _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.benefit.minHeight */ ._f.benefit.minHeight
                        });
                    case "team_image":
                        return (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("tooltip:images:logo_image", {
                            minWidth: _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.team.minWidth */ ._f.team.minWidth,
                            minHeight: _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .FILE_SIZES.team.minHeight */ ._f.team.minHeight
                        });
                }
            }
        },
        {
            key: "titleLengthWarning",
            value: function titleLengthWarning(textContent) {
                if (textContent.length == 0) {
                    this.customToastrAction.setNormalToastr((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:section_title"), "warning");
                }
            }
        },
        {
            key: "descriptionLengthWarning",
            value: function descriptionLengthWarning(textContent) {
                if (textContent.length == 0) {
                    this.customToastrAction.setNormalToastr((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:section_description"), "warning");
                }
            }
        },
        {
            key: "setBackgroundColor",
            value: function setBackgroundColor(formik, section_type) {
                var stylehash = {};
                switch(section_type){
                    case "job":
                        stylehash.backgroundColor = this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_1.background_color);
                        break;
                    case "team":
                        stylehash.backgroundColor = this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_1.background_color);
                        break;
                    case "about":
                        stylehash.backgroundColor = this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_2.background_color);
                        break;
                    case "gallery":
                        stylehash.backgroundColor = this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_2.background_color);
                        break;
                }
                return stylehash;
            }
        },
        {
            key: "setBackgroundOverlay",
            value: function setBackgroundOverlay(formik, section_type) {
                var stylehash = {};
                var background_color = Object.assign({}, formik.values.career_font_style_attributes.style_hash.style_2.background_color);
                background_color.a = 0.8;
                stylehash.backgroundColor = this.rgbColorStyle(background_color);
                return stylehash;
            }
        },
        {
            key: "setFontColor",
            value: function setFontColor(formik, section_type) {
                var stylehash = {
                    fontFamily: formik.values.career_font_style_attributes.font_family
                };
                switch(section_type){
                    case "job":
                        stylehash.color = this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_1.font_color);
                        break;
                    case "team":
                        stylehash.color = this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_1.font_color);
                        break;
                    case "about":
                        stylehash.color = this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_2.font_color);
                        break;
                    case "gallery":
                        stylehash.color = this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_2.font_color);
                        break;
                }
                return stylehash;
            }
        },
        {
            key: "job_benefit_heading_color",
            value: function job_benefit_heading_color(formik) {
                return {
                    fontFamily: formik.values.career_font_style_attributes.font_family,
                    color: this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_3.font_color)
                };
            }
        },
        {
            key: "createLink",
            value: function createLink(fontFamilies) {
                var fontOptionsList = (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_0__/* .fontOptions */ .yf)();
                var fonts = fontFamilies.map(function(font) {
                    var ref;
                    return {
                        font: font,
                        weights: ((ref = fontOptionsList.filter(function(x) {
                            return x.label == font;
                        })[0]) === null || ref === void 0 ? void 0 : ref.variants) || []
                    };
                });
                var families = fonts.reduce(function(acc, font) {
                    var family = font.font.replace(/ +/g, "+");
                    var weights = (font.weights || []).join(",");
                    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(acc).concat([
                        family + (weights && ":".concat(weights)), 
                    ]);
                }, []).join("|");
                return "https://fonts.googleapis.com/css?family=".concat(families);
            }
        },
        {
            key: "loadSubTextFont",
            value: function loadSubTextFont(formik) {
                var fontFamily = formik.values.career_font_style_attributes.font_family;
                return fontFamily;
            }
        },
        {
            key: "hexToRGB",
            value: function hexToRGB(hexcode, alpha) {
                if (alpha) {
                    return "rgba(".concat(hexcode.r, ", ").concat(hexcode.g, ", ").concat(hexcode.b, ", ").concat(alpha, ")");
                }
                return "rgb(".concat(hexcode.r, ", ").concat(hexcode.g, ", ").concat(hexcode.b, ")");
            }
        },
        {
            key: "publishedDays",
            value: function publishedDays(publishedAt) {
                if (publishedAt) {
                    if ( true && window.innerWidth <= 1024) {
                        return publishedAt.replace("Posted ", "");
                    } else return publishedAt;
                }
            }
        },
        {
            key: "rgbColorStyle",
            value: function rgbColorStyle(rgbaHash) {
                return "rgba(".concat(rgbaHash.r, ", ").concat(rgbaHash.g, ", ").concat(rgbaHash.b, ", ").concat(rgbaHash.a, ")");
            }
        },
        {
            key: "onPastePreventStyling",
            value: function onPastePreventStyling(event1) {
                // Prevent the default paste behavior
                event1.preventDefault();
                // Get the plain text from the clipboard data
                var clipboardData = event1.clipboardData || window.clipboardData;
                var plainText = clipboardData.getData("text/plain");
                // Insert the plain text into the editable div
                document.execCommand("insertHTML", false, plainText);
            }
        },
        {
            key: "backgroundOverlayValue",
            value: function backgroundOverlayValue(formik) {
                return {
                    backgroundColor: this.rgbColorStyle(formik.values.hero_section_attributes.overlay_hash || {
                        r: 255,
                        g: 255,
                        b: 255,
                        a: 0.5
                    })
                };
            }
        },
        {
            key: "contractTypeTranslation",
            value: function contractTypeTranslation(t, contract_type) {
                switch(contract_type){
                    case "permanent":
                        return t("jobs:details:contract_type:permanent");
                        break;
                    case "contract":
                        return t("jobs:details:contract_type:contract");
                        break;
                    case "temporary":
                        return t("jobs:details:contract_type:temporary");
                        break;
                    case "internship":
                        return t("jobs:details:contract_type:internship");
                        break;
                }
            }
        }
    ]);
    return CustomizeCareerAction;
}();


/***/ }),

/***/ 70158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ ShowJobAction; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ./src/imports-files/pages/admins/dashboard/clients/integration.js + 3 modules
var integration = __webpack_require__(48847);
;// CONCATENATED MODULE: ./src/services/pages/clients/careers/showJob.js







var showJob = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(showJob, SendRequest);
    var _super = (0,_create_super/* default */.Z)(showJob);
    function showJob() {
        (0,_class_call_check/* default */.Z)(this, showJob);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(showJob, [
        {
            key: "getJobsData",
            value: function getJobsData(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = integration/* API.open.GET_CAREER_PAGE_DATA */.bl.open.GET_CAREER_PAGE_DATA;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    integration/* axios.post */.od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getfilteredJobsData",
            value: function getfilteredJobsData(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = params.isFrame ? integration/* API.open.SEND_IFRAME_SEARCH_DATA */.bl.open.SEND_IFRAME_SEARCH_DATA : integration/* API.open.SEND_CAREER_PAGE_SEARCH_DATA */.bl.open.SEND_CAREER_PAGE_SEARCH_DATA;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    integration/* axios.post */.od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCountries",
            value: function getCountries(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = "https://restcountries.eu/rest/v2/all?offset=".concat(params.length);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    integration/* axios.get */.od.get(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return showJob;
}(integration/* SendRequest */.Lt);

// EXTERNAL MODULE: ./src/imports-files/pages/clients/careers/showJob.js
var careers_showJob = __webpack_require__(51439);
;// CONCATENATED MODULE: ./src/actions/pages/clients/careers/showJob.js






var ShowJobAction = /*#__PURE__*/ function() {
    "use strict";
    function ShowJobAction() {
        (0,_class_call_check/* default */.Z)(this, ShowJobAction);
    }
    (0,_create_class/* default */.Z)(ShowJobAction, [
        {
            key: "getData",
            value: function getData(values, data, update_props, isFrame) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                values["page"] = data.next_page;
                                values["host_name"] = window.location.hostname;
                                values["isFrame"] = isFrame;
                                return [
                                    4,
                                    new showJob().getfilteredJobsData(values)
                                ];
                            case 1:
                                result = _state.sent();
                                result.data.jobs = data.jobs.concat(result.data.jobs);
                                update_props(result.data);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleValueOnChange",
            value: function handleValueOnChange() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var name, value, hash, update_value, update_props, data, isFrame, new_value;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        name = args[0];
                        value = args[1];
                        hash = args[2];
                        update_value = args[3];
                        update_props = args[4];
                        data = args[5];
                        isFrame = args[6];
                        new_value = typeof value == "object" ? value.value : value;
                        hash["".concat(name)] = value.value || value;
                        hash["host_name"] = window.location.hostname;
                        hash["isFrame"] = isFrame;
                        hash["page"] = null;
                        if (new_value.length == 0) delete hash["".concat(name)];
                        update_value(hash);
                        _this.getSearchData(hash, data, update_props);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "getSearchData",
            value: function getSearchData(values, data, update_props) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    new showJob().getfilteredJobsData(values)
                                ];
                            case 1:
                                result = _state.sent();
                                update_props(result.data);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "get_json_data_for_jobOption",
            value: function get_json_data_for_jobOption(result, t) {
                var data = [
                    {
                        label: t("placeholder:select:please"),
                        value: ""
                    }
                ];
                if (result) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = result[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            data.push({
                                value: element,
                                label: element
                            });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return {
                    options: data
                };
            }
        },
        {
            key: "get_json_data_for_location",
            value: function get_json_data_for_location(locations) {
                var data = [
                    {
                        label: (0,careers_showJob/* TRANSLATION */.TA)("placeholder:select:please"),
                        value: ""
                    }
                ];
                if (locations) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = locations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            data.push({
                                value: element,
                                label: element
                            });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return {
                    options: data
                };
            }
        },
        {
            key: "get_json_data_for_locationOption",
            value: function get_json_data_for_locationOption(job_location, job_countries) {
                var countries_data = [
                    {
                        label: (0,careers_showJob/* TRANSLATION */.TA)("placeholder:select:please"),
                        value: ""
                    }
                ];
                if ((job_location || false) && (job_countries || false) && (job_location.length > 0 || job_countries.length > 0)) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = job_location[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            countries_data.push({
                                value: element,
                                label: element
                            });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = job_countries[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var element1 = _step1.value;
                            countries_data.push({
                                value: element1,
                                label: element1
                            });
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    return {
                        options: countries_data
                    };
                } else {
                    return [];
                }
            }
        },
        {
            key: "set_background_image",
            value: function set_background_image(image_url) {
                var element = document.getElementsByClassName("Career_Background")[0];
                if (element) {
                    element.style.backgroundImage = "url('" + image_url + "')";
                }
            }
        },
        {
            key: "redirectToJob",
            value: function redirectToJob(slug, client_slug) {
                var isFrame = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                var job_url = careers_showJob/* REDIRECT.client.jobs.view_job */.RQ.client.jobs.view_job;
                var protocol = window.location.protocol;
                var hostnamearray = window.location.host.split(".");
                hostnamearray[0] = "jobs";
                job_url = job_url.replace("$slug", slug);
                job_url = job_url.replace("$client_slug", client_slug);
                var url = protocol + "//" + hostnamearray.join(".") + job_url + "?q=desc&isFrame=".concat(isFrame);
                window.open(url, "_blank");
            }
        }
    ]);
    return ShowJobAction;
} // export async function getData(values, data, update_props)
 // {
 //     values[`page`]        =    data.next_page;
 //     values['host_name']   =    window.location.hostname
 //     let result            =    await new showJob().getJobsData(values);
 //     result.data.jobs      =    result.data.jobs.concat(data.jobs)
 //     update_props(result.data);
 // }
 // export async function handleValueOnChange(...args) 
 // {
 //     const name          =    args[0];
 //     const value         =    args[1];
 //     const hash          =    args[2];
 //     const update_value  =    args[3];
 //     const update_props  =    args[4];
 //     const data          =    args[5];
 //     hash[`${name}`]     =    value.value || value;
 //     hash['host_name']   =    window.location.hostname
 //     update_value(hash);
 //     getSearchData(hash, data, update_props);
 // }
 // export async function getSearchData(values, data, update_props)
 // {
 //     values[`page`]        =    data.next_page;
 //     let result            =    await new showJob().getJobsData(values);
 //     update_props(result.data);
 // }
 // export function get_json_data_for_jobOption(result)
 // {
 //     let data = [];
 //     if(result)
 //     {
 //         for( let element of result)
 //         {
 //             data.push({
 //                         value: element, 
 //                         label: element,
 //                     })
 //         }
 //     }
 //     return {options: data};
 // }
 // export function get_json_data_for_location(locations)
 // {
 //   let data = [];
 //   if(locations)
 //   {
 //     for( let element of locations)
 //     {
 //       data.push({
 //         value: element, 
 //         label: element,
 //       })
 //     }
 //   }
 //   return {options: data}; 
 // }
 // export function get_json_data_for_locationOption(job_location, job_countries)
 // {
 //    let countries_data = [];
 //     if( (job_location || false) && ( job_countries || false) && (job_location.length > 0 || job_countries.length > 0))
 //     {
 //         for( let element of job_location)
 //         {
 //             countries_data.push({
 //                                     value: element, 
 //                                     label: element
 //                                 })
 //         }
 //         for( let element of job_countries)
 //         {
 //             countries_data.push({
 //                                     value: element, 
 //                                     label: element
 //                                 })
 //         }
 //         return {options: countries_data};
 //     }
 //     else
 //     {
 //         return [];
 //     }
 // }
 // export function set_background_image(image_url)
 // {
 //    let element                   =  document.getElementsByClassName('Career_Background')[0];
 //    if(element)
 //    {  element.style.backgroundImage =  "url('"+image_url+"')"; }
 // }
 // export function redirectToJob(slug, client_slug)
 // {
 //     let job_url        =  REDIRECT.client.jobs.view_job;
 //     let protocol       =  window.location.protocol;
 //     let hostnamearray  =  window.location.host.split('.');
 //     hostnamearray[0]   =  'jobs';
 //     job_url            =  job_url.replace('$slug', slug);
 //     job_url            =  job_url.replace('$client_slug', client_slug);
 //     let url            =  protocol + '//' + hostnamearray.join('.') + job_url;
 //     window.open(url, '_blank');
 // }
();


/***/ }),

/***/ 57223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ handleKeyDown; },
/* harmony export */   "Bb": function() { return /* binding */ interviewTypeIcon; },
/* harmony export */   "Bl": function() { return /* binding */ getAssessmentTestData; },
/* harmony export */   "D7": function() { return /* binding */ interviewStageName; },
/* harmony export */   "E$": function() { return /* binding */ addInitalInterview; },
/* harmony export */   "HW": function() { return /* binding */ showHideButtonValue; },
/* harmony export */   "Ib": function() { return /* binding */ getTechTestData; },
/* harmony export */   "K0": function() { return /* binding */ handleInterviewFormSubmit; },
/* harmony export */   "KH": function() { return /* binding */ shouldRenderSuggestions; },
/* harmony export */   "L5": function() { return /* binding */ setUpVideoQAMember; },
/* harmony export */   "Lj": function() { return /* binding */ getAutomationData; },
/* harmony export */   "Pq": function() { return /* binding */ isLocationDisabled; },
/* harmony export */   "Qx": function() { return /* binding */ renderInputComponent; },
/* harmony export */   "a": function() { return /* binding */ setTechTestFormData; },
/* harmony export */   "eF": function() { return /* binding */ mangeInterviews; },
/* harmony export */   "ev": function() { return /* binding */ interviewTypeHeader; },
/* harmony export */   "i9": function() { return /* binding */ defaultTestDetail; },
/* harmony export */   "jt": function() { return /* binding */ getManualJobStageData; },
/* harmony export */   "jv": function() { return /* binding */ initialStageValues; },
/* harmony export */   "mV": function() { return /* binding */ onAutomationChange; },
/* harmony export */   "oo": function() { return /* binding */ onSuggestionsFetchRequested; },
/* harmony export */   "ox": function() { return /* binding */ renderSuggestion; },
/* harmony export */   "rR": function() { return /* binding */ setUpTechTest; },
/* harmony export */   "rw": function() { return /* binding */ renderAutomationModalInputComponent; },
/* harmony export */   "uQ": function() { return /* binding */ setFormDirty; },
/* harmony export */   "wn": function() { return /* binding */ onSuggestionSelection; },
/* harmony export */   "y": function() { return /* binding */ handleAutomationFormSubmit; }
/* harmony export */ });
/* unused harmony exports handleDelete, showSuggestion, renderLabel, testDuration, automationText, userHash, getBgClass, updateThreshold, handleVideoQAFormSubmit, getJobStageData, manageModals */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18186);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34817);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64335);
/* harmony import */ var _imports_files_components_model_setup_video_qa__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37521);







var MAX_ALLOWED_RECORDS = 5;
function handleDelete(formik, index, itemIndex) {
    var member_emails = formik.values.job_meeting_details_attributes[index].member_emails;
    var member_initials = formik.values.job_meeting_details_attributes[index].member_initials;
    member_emails.splice(itemIndex, 1);
    member_initials.splice(itemIndex, 1);
    formik.setFieldValue("job_meeting_details_attributes[".concat(index, "].member_emails"), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(member_emails));
    formik.setFieldValue("job_meeting_details_attributes[".concat(index, "].member_initials"), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(member_initials));
}
;
function onSuggestionSelection(old_ids, id, old_initials, new_initial) {
    if (!(old_ids.includes(id) || old_ids.includes(id.toString()))) {
        old_ids.unshift(id);
        old_initials.unshift(new_initial);
    }
}
function initialStageValues(initialValues) {
    return initialValues.job_meeting_details_attributes.map(function(x) {
        return {
            value: ""
        };
    });
}
function showHideButtonValue(values) {
    var ref;
    var total_count = (ref = values.job_meeting_details_attributes.filter(function(x) {
        return !x._destroy;
    })) === null || ref === void 0 ? void 0 : ref.length;
    return total_count < MAX_ALLOWED_RECORDS ? true : false;
}
function onAutomationChange() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var ref;
    var formik = args[0];
    var action = args[1];
    var index = args[2] != undefined ? args[2] : 0;
    var currentStage = args[3];
    var setStageEmail = args[4];
    var setInterviewStageCount = args[5];
    var setTotalDuration = args[6];
    var setShowHideButton = args[7];
    var member_emails = args[8] || [];
    var member_initials = args[9] || [];
    var automations = formik.values.job_meeting_details_attributes;
    var correct_records = ((ref = formik.values.job_meeting_details_attributes) === null || ref === void 0 ? void 0 : ref.filter(function(record) {
        return !record._destroy;
    }).length) || 0;
    if (action == "add") {
        var interview = {
            member_ids: [],
            member_emails: member_emails,
            member_initials: member_initials,
            duration: "",
            interview_type: currentStage.interview_type,
            _destroy: false
        };
        if (currentStage.interview_type == _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.VIDEO */ .BH.VIDEO) {
            interview.meeting_platform_attributes = {
                integration_id: ""
            };
        } else if (currentStage.interview_type == _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.FACE2FACE */ .BH.FACE2FACE) {
            interview.location_attributes = {
                full_address: (currentStage === null || currentStage === void 0 ? void 0 : currentStage.default_location) || ""
            };
        }
        automations.push(interview);
    } else {
        automations[index]["_destroy"] = true;
    }
    setStageEmail(initialStageValues(formik.values));
    setInterviewStageCount(automations.filter(function(x) {
        return !x._destroy;
    }).length);
    var durations = [];
    var total_count = 0;
    formik.values.job_meeting_details_attributes.map(function(x, itemIndex) {
        if (!x._destroy) {
            var numer_duration = parseInt(x.duration) || 0;
            durations.push(numer_duration);
            total_count += 1;
        } else {
            durations.push(0);
        }
        return x;
    });
    setTotalDuration(durations.reduce(function(a, b) {
        return a + b;
    }, 0));
    total_count < MAX_ALLOWED_RECORDS ? setShowHideButton(true) : setShowHideButton(false);
}
// function getSuggestionValue(suggestion) {
//   return `${suggestion.email}`;
// }
function showSuggestion(suggestion) {
    if (suggestion.user_attributes.name && suggestion.user_attributes.email.length > 0) {
        return "".concat(suggestion.user_attributes.name, " | ").concat(suggestion.user_attributes.email);
    } else if (suggestion.user_attributes.name) {
        return "".concat(suggestion.user_attributes.name);
    } else {
        return "".concat(suggestion.user_attributes.email);
    }
}
function renderSuggestion(suggestion) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: showSuggestion(suggestion)
    });
}
function shouldRenderSuggestions(value) {
    return value.trim().length >= 3;
}
function isEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@\.]+$/.test(email);
}
var onAddClick = function(event, params) {
    var email = params.value;
    if (isEmail(email)) {
        onSuggestionSelection(params.formik.values.job_meeting_details_attributes[params.index].member_emails, email, params.formik.values.job_meeting_details_attributes[params.index].member_initials, {
            email: email,
            name_initials: null,
            name: null
        });
        params.stageEmail[params.index] = {
            value: "",
            error: ""
        };
        params.setStageEmail((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(params.stageEmail));
    } else {
        params.stageEmail[params.index] = {
            value: email,
            error: "Please enter valid email"
        };
        params.setStageEmail((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(params.stageEmail));
    }
};
function handleKeyDown(event, formik, index, stageEmail, setStageEmail) {
    if ([
        "Enter"
    ].includes(event.key)) {
        event.preventDefault();
        var email = event.target.value;
        if (isEmail(email)) {
            onSuggestionSelection(formik.values.job_meeting_details_attributes[index].member_emails, email, formik.values.job_meeting_details_attributes[index].member_initials, {
                email: email,
                name_initials: null,
                name: null
            });
            stageEmail[index] = {
                value: "",
                error: ""
            };
            setStageEmail((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(stageEmail));
        } else {
            stageEmail[index] = {
                value: email,
                error: "Please enter valid email"
            };
            setStageEmail((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(stageEmail));
        }
    }
}
var renderInputComponent = function(inputProps) {
    var ref;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "buttonIn AutoSuggestInput__Tags",
        style: inputProps.styleError,
        children: [
            (ref = inputProps.selectedValues) === null || ref === void 0 ? void 0 : ref.map(function(item, itemIndex) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.SetupPopup__Tags */ .k2.SetupPopup__Tags,
                    children: [
                        item.name ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: item.name
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: item.email
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            ButtonStyle: "".concat(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.nobgbutton */ .ZJ.nobgbutton),
                            type: "button",
                            onClick: function() {
                                handleDelete(inputProps.formik, inputProps.index, itemIndex);
                                setFormDirty(inputProps.parentData, inputProps.setParentData, inputProps.currentIndex, true);
                            },
                            children: [
                                " ",
                                inputProps.closeIcon
                            ]
                        })
                    ]
                }, "interview_email_".concat(inputProps.index, "_").concat(itemIndex));
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                className: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input */ .k2.Form__Input,
                autoComplete: "password"
            }, inputProps)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                buttonstyle: "".concat(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.nobgbutton */ .ZJ.nobgbutton, " addbtn ").concat((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .cursorNone */ .y$)(inputProps.editable)),
                disabled: inputProps.disabled,
                onClick: function(event) {
                    return onAddClick(event, inputProps);
                },
                children: (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .TRANSLATION */ .TA)("button:add:default")
            })
        ]
    });
};
var renderAutomationModalInputComponent = function(inputProps) {
    var ref;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "buttonIn AutoSuggestInput__Tags",
        style: inputProps.styleError,
        children: [
            (ref = inputProps.selectedValues) === null || ref === void 0 ? void 0 : ref.map(function(item, itemIndex) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.SetupPopup__Tags */ .k2.SetupPopup__Tags,
                    children: [
                        item.name ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: item.name
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: item.email
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            ButtonStyle: "".concat(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.nobgbutton */ .ZJ.nobgbutton),
                            type: "button",
                            onClick: function() {
                                handleDelete(inputProps.formik, inputProps.index, itemIndex);
                            },
                            children: [
                                " ",
                                inputProps.closeIcon
                            ]
                        })
                    ]
                }, "interview_email_".concat(inputProps.index, "_").concat(itemIndex));
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                className: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input */ .k2.Form__Input,
                autoComplete: "password"
            }, inputProps)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                buttonstyle: "".concat(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.nobgbutton */ .ZJ.nobgbutton, " addbtn ").concat((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .cursorNone */ .y$)(inputProps.editable)),
                disabled: inputProps.disabled,
                onClick: function(event) {
                    return onAddClick(event, inputProps);
                },
                children: (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .TRANSLATION */ .TA)("button:add:default")
            })
        ]
    });
};
function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function getSuggestions(value, currentStage, router) {
    return _getSuggestions.apply(this, arguments);
}
function _getSuggestions() {
    _getSuggestions = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(value, currentStage, router) {
        var escapedValue, regex, finalUsers;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    escapedValue = escapeRegexCharacters(value.trim());
                    if (escapedValue === "") {
                        return [
                            2,
                            []
                        ];
                    }
                    regex = new RegExp("^" + escapedValue, "i");
                    return [
                        4,
                        (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .getClientUsers */ .D6)(escapedValue, 3, router)
                    ];
                case 1:
                    finalUsers = _state.sent();
                    // return currentStage.members.filter((member) => regex.test(member.email) || regex.test(member.name));
                    return [
                        2,
                        finalUsers
                    ];
            }
        });
    });
    return _getSuggestions.apply(this, arguments);
}
function onSuggestionsFetchRequested(value, currentStage, setUsers, router, t) {
    return _onSuggestionsFetchRequested.apply(this, arguments);
}
function _onSuggestionsFetchRequested() {
    _onSuggestionsFetchRequested = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(value, currentStage, setUsers, router, t) {
        var users;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getSuggestions(value, currentStage, router)
                    ];
                case 1:
                    users = _state.sent();
                    setUsers(users);
                    return [
                        2
                    ];
            }
        });
    });
    return _onSuggestionsFetchRequested.apply(this, arguments);
}
;
function renderLabel(intervieType) {
    switch(intervieType){
        case INTERVIEW_TYPES.VIDEO:
            return /*#__PURE__*/ _jsx("label", {
                children: "Platform *"
            });
        case INTERVIEW_TYPES.PHONE:
            return "";
        default:
            return "";
    }
}
function interviewStageName(jobStage) {
    return jobStage.label;
// return (jobStage.stage === JOB_STAGES.INTERVIEW ? jobStage.label : jobStage.stage )
}
function testDuration() {
    var duration = [];
    for(var i = 1; i < 15; i++){
        duration.push({
            label: i,
            value: i
        });
    }
    return duration;
}
function automationText(jobStage) {
    var editSetup = jobStage.button_text;
    var text = "";
    if (jobStage.stage == JOB_STAGES.APPLIED) {
        text = "I’d like to automatically progress candidates who reach my set score.";
    } else if (jobStage.stage == JOB_STAGES.SCREENING) {
        var ref;
        var interview_type_text = jobStage.interview_type ? "a ".concat((ref = jobStage.interview_type) === null || ref === void 0 ? void 0 : ref.toLowerCase()) : "an";
        text = "Yes please. Automatically organise ".concat(interview_type_text, " interview for best match candidates.");
    } else if ([
        JOB_STAGES.INTERVIEW
    ].includes(jobStage.stage)) {
        var ref1;
        text = "I’m keen to arrange ".concat((ref1 = jobStage.interview_type) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), " interview at ").concat(jobStage.label);
    }
    return text;
}
function interviewTypeIcon(type) {
    switch(type){
        case _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.PHONE */ .BH.PHONE:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .Call */ .Ig, {
                className: "AutomationIcons"
            });
        case _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.TECHTEST */ .BH.TECHTEST:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .Tech */ .e6, {
                className: "AutomationIcons techIcon"
            });
        case _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.VIDEO */ .BH.VIDEO:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .Video */ .nk, {
                className: "AutomationIcons"
            });
        case _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.FACE2FACE */ .BH.FACE2FACE:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .User */ .n5, {
                className: "AutomationIcons faceIcon"
            });
        case _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.VIDEOQA */ .BH.VIDEOQA:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .VideoQA */ .jf, {
                className: "AutomationIcons videoQAIcon"
            });
    }
}
function userHash(user) {
    return {
        email: user.email,
        name_initial: user.name_initials,
        name: user.name
    };
}
function addInitalInterview(jobStage) {
    var interview = {
        member_ids: jobStage.members.map(function(x) {
            return x.id;
        }) || [],
        member_emails: jobStage.members.map(function(x) {
            return x.email;
        }) || [],
        member_initials: jobStage.members.map(function(x) {
            return userHash(x);
        }) || [],
        duration: "",
        _destroy: false
    };
    if (jobStage.interview_type == _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.VIDEO */ .BH.VIDEO) {
        interview.meeting_platform_attributes = {
            integration_id: ""
        };
    } else if (jobStage.interview_type == _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.FACE2FACE */ .BH.FACE2FACE) {
        interview.location_attributes = {
            full_address: (jobStage === null || jobStage === void 0 ? void 0 : jobStage.default_location) || ""
        };
    }
    jobStage.job_meeting_details_attributes.push(interview);
    return jobStage;
}
function addVideoInterviewQA(jobStage) {
    var interview = {
        language: "English",
        video_link: "",
        questions_attributes: [
            {
                question: "",
                description: "",
                attempts: 2,
                answer_time: 30,
                _destroy: false
            }
        ],
        job_stage_attributes: {
            automation: false
        },
        practise_screen: false,
        expires: ""
    };
    jobStage.job_meeting_details_attributes.push(interview);
    return jobStage;
}
function mangeInterviews(jobId, jobStage, setCurrentStage, setBtnPopup, router, isOpen) {
    return _mangeInterviews.apply(this, arguments);
}
function _mangeInterviews() {
    _mangeInterviews = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(jobId, jobStage, setCurrentStage, setBtnPopup, router, isOpen) {
        var jobStageData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getJobStageData(jobId, jobStage.id, router)
                    ];
                case 1:
                    jobStageData = _state.sent();
                    if (jobStageData.job_meeting_details_attributes.length == 0 && [
                        _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.PHONE */ .BH.PHONE,
                        _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.VIDEO */ .BH.VIDEO,
                        _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.FACE2FACE */ .BH.FACE2FACE
                    ].includes(jobStageData.interview_type)) {
                        jobStageData = addInitalInterview(jobStageData);
                    }
                    setCurrentStage(jobStageData);
                    setBtnPopup(isOpen);
                    return [
                        2
                    ];
            }
        });
    });
    return _mangeInterviews.apply(this, arguments);
}
function getBgClass(jobStage) {
    if ([
        JOB_STAGES.OFFERED,
        JOB_STAGES.HIRED,
        JOB_STAGES.APPLIED
    ].includes(jobStage.stage)) {
        return "".concat(PageStyle.Automation__FormRowHeading, " ").concat(PageStyle.rowbglight);
    } else {
        return "".concat(PageStyle.Automation__FormRowHeading);
    }
}
function updateThreshold(args) {
    return _updateThreshold.apply(this, arguments);
}
function _updateThreshold() {
    _updateThreshold = _async_to_generator(function(args) {
        var jobId, result, status_code, customToastrAction, response, _tmp;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    jobId = new DataFromUrl().getJobId();
                    return [
                        4,
                        new Automation().setThreshold(args.values, jobId, args.jobStageId)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new CustomToastrAction();
                    _tmp = {};
                    switch(status_code){
                        case SUCCESS_REPONSE_CODE:
                            response = result.data;
                            if (args.from == "job-form") {
                                args.setOnLoadValues((_tmp.job = {
                                    job_stages_attributes: result.data.job_stages_attributes,
                                    threshold: result.data.daxtra_threshold
                                }, _tmp));
                            } else if (args.from == "kanban") {
                                args.jobData.daxtra_threshold = response.daxtra_threshold;
                                args.setJobData(args.jobData);
                            }
                            args.setBtnPopup(false);
                            return [
                                2,
                                response
                            ];
                        case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                        // toastr.warning(result.response.data.error)
                        default:
                            handleOtherResponseCode(status_code, args.router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _updateThreshold.apply(this, arguments);
}
function handleInterviewFormSubmit(params, router, jobStageId, setBtnPopup, setOnLoadValues, from, jobData, setJobData, setDisabled, deleteQuestionList, formRef, t) {
    return _handleInterviewFormSubmit.apply(this, arguments);
}
function _handleInterviewFormSubmit() {
    _handleInterviewFormSubmit = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(params, router, jobStageId, setBtnPopup, setOnLoadValues, from, jobData, setJobData, setDisabled, deleteQuestionList, formRef, t) {
        var customToastrAction, job_id, body, _tmp, techTestBody, questions_attributes, video_question_details_attributes, _tmp1, result, status_code, current_updated_stage, _tmp2, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, message, ref10, ref11, ref12, ref13, ref14, ref15, _tmp3;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setDisabled(true);
                    customToastrAction = new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    if (params.interview_type == _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.FACE2FACE */ .BH.FACE2FACE) {
                        params.job_meeting_details_attributes = params.job_meeting_details_attributes.map(function(x) {
                            x.location_attributes = {
                                full_address: params.default_location || "",
                                place_id: params.place_id || ""
                            };
                            return x;
                        });
                    }
                    job_id = new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .DataFromUrl */ .QJ().getJobId();
                    _tmp = {};
                    body = (_tmp.job_stage = {
                        automation: params.automation,
                        interview_type_id: params.interview_type_id,
                        job_meeting_details_attributes: params.job_meeting_details_attributes
                    }, _tmp);
                    if (params.interview_type == _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.TECHTEST */ .BH.TECHTEST) {
                        techTestBody = setTechTestFormData(params);
                        body.job_stage.job_test_detail_attributes = techTestBody.job_stage.job_test_detail_attributes;
                        if (techTestBody.assessment) body.assessment = techTestBody.assessment;
                        if (techTestBody.save_and_continue) body.save_and_continue = techTestBody.save_and_continue;
                    }
                    _tmp1 = {};
                    if (params.interview_type == _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.VIDEOQA */ .BH.VIDEOQA) {
                        questions_attributes = Object.assign([], params.questions_attributes, deleteQuestionList);
                        video_question_details_attributes = (_tmp1.language = params.language, _tmp1.video_link = params.video_link, _tmp1.practise_screen = params.practise_screen, _tmp1.expires = params.expires, _tmp1.member_emails = params.videoqa.member_emails, _tmp1.questions_attributes = Object.assign([], params.questions_attributes, deleteQuestionList), _tmp1);
                        body.job_stage.video_question_details_attributes = video_question_details_attributes;
                    }
                    body.from = from;
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .Automation */ .qn().addAutomations(body, job_id, jobStageId)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    _tmp2 = {};
                    _tmp3 = {};
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            if (from == "kanban") {
                                setJobData(result.data.kanban_data);
                                if (result.data.success && from == "kanban") customToastrAction.setNormalToastr(result.data.success, "success");
                            } else if (from == "job-form") {
                                current_updated_stage = result.data;
                                setDisabled(false);
                                return [
                                    2,
                                    (_tmp2.success = true, _tmp2.updated_stage = current_updated_stage, _tmp2)
                                ];
                            // setOnLoadValues({job: {job_stages_attributes: result.data.job_stages_attributes}})
                            }
                            setBtnPopup(false);
                            break;
                        case _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            ;
                            setDisabled(false);
                            message = "";
                            if ((ref = result.response.data.error.job_stage) === null || ref === void 0 ? void 0 : ref.new_user_emails) {
                                if (message.length > 0) {
                                    message += "</br>";
                                }
                                message += "".concat(result.response.data.error.job_stage.new_user_emails);
                            }
                            if (((ref1 = result.response.data.error.job_stage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.job_test_detail_attributes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.test_attributes) === null || ref3 === void 0 ? void 0 : ref3.link) === "Link can't be blank") {
                                if (message.length > 0) message += "</br>";
                                message += (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .TRANSLATION */ .TA)("errors:assessment_link_error");
                            } else if ((ref4 = result.response.data.error.job_stage) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.job_test_detail_attributes) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.test_attributes) === null || ref6 === void 0 ? void 0 : ref6.link) {
                                ;
                                if (message.length > 0) message += "</br>";
                                message += (ref10 = result.response.data.error.job_stage) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.job_test_detail_attributes) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.test_attributes) === null || ref12 === void 0 ? void 0 : ref12.link;
                            } else if ((ref7 = result.response.data.error.job_stage) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.job_test_detail_attributes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.test_attributes) === null || ref9 === void 0 ? void 0 : ref9.name) {
                                ;
                                if (message.length > 0) message += "</br>";
                                message += (ref13 = result.response.data.error.job_stage) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.job_test_detail_attributes) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.test_attributes) === null || ref15 === void 0 ? void 0 : ref15.name;
                            }
                            if (message.length > 0) {
                                new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5().setNormalToastr(message, "warning");
                            }
                            if (from == "job-form") {
                                return [
                                    2,
                                    (_tmp3.success = false, _tmp3.errors = result.response.data.error.job_stage, _tmp3)
                                ];
                            } else {
                                return [
                                    2,
                                    result.response.data.error.job_stage
                                ];
                            }
                        default:
                            (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _handleInterviewFormSubmit.apply(this, arguments);
}
function handleAutomationFormSubmit(params, router, setPageName, queryClient, fromKanban, gotoKanban, setDisabledSaveButton, submitState, setSubmitState) {
    return _handleAutomationFormSubmit.apply(this, arguments);
}
function _handleAutomationFormSubmit() {
    _handleAutomationFormSubmit = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(params, router, setPageName, queryClient, fromKanban, gotoKanban, setDisabledSaveButton, submitState, setSubmitState) {
        var job_id, result, status_code, customToastrAction, response, queryPath, _tmp, _tmp1, ref, message, ref1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setDisabledSaveButton(true);
                    job_id = new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .DataFromUrl */ .QJ().getJobId();
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .Automation */ .qn().updateAutomations(params, job_id)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    _tmp = {};
                    _tmp1 = {};
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            response = result.data;
                            if ([
                                "draft",
                                "preview"
                            ].includes(submitState)) {
                                setSubmitState("");
                                if (submitState == "preview") (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .previewJob */ .ao)(router, job_id);
                                if (submitState == "draft") customToastrAction.setNormalToastr(response.success.replace("updated successfully.", "saved as draft"), "success");
                                setDisabledSaveButton(false);
                                return [
                                    2
                                ];
                            }
                            queryPath = fromKanban ? "?from_kanban=true" : "";
                            if (gotoKanban) {
                                if (fromKanban) {
                                    router.push((_tmp.pathname = _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.kanban_board.replace */ .RQ.client.kanban_board.replace("$job_id", job_id), _tmp));
                                } else {
                                    router.push((_tmp1.pathname = _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.jobs.index */ .RQ.client.jobs.index, _tmp1.query = {
                                        job_type: "active"
                                    }, _tmp1));
                                }
                            } else {
                                router.push(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.jobs.scorecards.replace */ .RQ.client.jobs.scorecards.replace("$job_id", job_id) + queryPath);
                            }
                            break;
                        case _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            ;
                            setSubmitState("");
                            message = "";
                            if ((ref = result.response.data.error.job) === null || ref === void 0 ? void 0 : ref.base) {
                                ;
                                message = (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .startDateMessage */ .d3)(message, (ref1 = result.response.data.error.job) === null || ref1 === void 0 ? void 0 : ref1.base);
                            }
                            if (message.length > 0) {
                                customToastrAction.setNormalToastr(message, "warning");
                            // toastr.warning(message)
                            }
                            setDisabledSaveButton(false);
                            break;
                        default:
                            setSubmitState("");
                            (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                            setDisabledSaveButton(false);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _handleAutomationFormSubmit.apply(this, arguments);
}
function handleVideoQAFormSubmit(params, router, jobStageId, setBtnPopup, setOnLoadValues, from, jobData, setJobData, setDisabled, deleteQuestionList) {
    return _handleVideoQAFormSubmit.apply(this, arguments);
}
function _handleVideoQAFormSubmit() {
    _handleVideoQAFormSubmit = _async_to_generator(function(params, router, jobStageId, setBtnPopup, setOnLoadValues, from, jobData, setJobData, setDisabled, deleteQuestionList) {
        var videoQAModalService, result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    videoQAModalService = new VideoQAModalService();
                    params = setQuestionsValues(params);
                    params.job_stage_id = params.id;
                    return [
                        4,
                        videoQAModalService.updateQuestions(params)
                    ];
                case 1:
                    result = _state.sent();
                    if (result.request.status == 200) {
                        setBtnPopup(false);
                    } else {
                        result.response.data.error;
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _handleVideoQAFormSubmit.apply(this, arguments);
}
function setQuestionsValues(values, deleteQuestionList) {
    values.questions_attributes = Object.assign([], values.questions_attributes, deleteQuestionList);
    return values;
}
function getJobStageData(jobId, jobStageId, router) {
    return _getJobStageData.apply(this, arguments);
}
function _getJobStageData() {
    _getJobStageData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(jobId, jobStageId, router) {
        var result, status_code, customToastrAction, response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .Automation */ .qn().jobStageData(jobId, jobStageId)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            response = result.data;
                            return [
                                2,
                                response
                            ];
                        case _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            break;
                        default:
                            (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getJobStageData.apply(this, arguments);
}
function getManualJobStageData(jobId, jobStageId, router) {
    return _getManualJobStageData.apply(this, arguments);
}
function _getManualJobStageData() {
    _getManualJobStageData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(jobId, jobStageId, router) {
        var result, status_code, customToastrAction, response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .Automation */ .qn().manualJobStageData(jobId, jobStageId)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            response = result.data;
                            return [
                                2,
                                response
                            ];
                        case _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            break;
                        default:
                            (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getManualJobStageData.apply(this, arguments);
}
function getTechTestData(value) {
    return _getTechTestData.apply(this, arguments);
}
function _getTechTestData() {
    _getTechTestData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(value) {
        var result, status_code, customToastrAction, response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .Automation */ .qn().getTechTests(value)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            response = result.data;
                            return [
                                2,
                                response.test_libraries
                            ];
                        case _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            break;
                        default:
                            (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getTechTestData.apply(this, arguments);
}
function getAssessmentTestData(value, isCustom, t) {
    return _getAssessmentTestData.apply(this, arguments);
}
function _getAssessmentTestData() {
    _getAssessmentTestData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(value, isCustom, t) {
        var result, status_code, customToastrAction, response, tests, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .Automation */ .qn().getAssessmentTests(value)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    _tmp = {};
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            response = result.data;
                            tests = response.test_libraries;
                            if (!isCustom) tests.unshift((_tmp.id = "upload_new_test", _tmp.name = t("modal:automation:upload_new_test"), _tmp));
                            return [
                                2,
                                tests
                            ];
                        case _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            break;
                        default:
                            (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getAssessmentTestData.apply(this, arguments);
}
function getAutomationData(setApiError) {
    return _getAutomationData.apply(this, arguments);
}
function _getAutomationData() {
    _getAutomationData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(setApiError) {
        var job_id, result, stages, threshold, step_name, status, editable, display_automation, system_reference, data, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    job_id = new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .DataFromUrl */ .QJ().getJobId();
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .Automation */ .qn().getJobStagesList(job_id)
                    ];
                case 1:
                    result = _state.sent();
                    _tmp = {};
                    if (result.request.status == 200) {
                        stages = result.data.stages;
                        threshold = result.data.threshold;
                        step_name = result.data.step;
                        status = result.data.status;
                        editable = result.data.editable;
                        display_automation = result.data.display_automation;
                        system_reference = result.data.system_reference;
                        data = (_tmp.props = {
                            status: status,
                            step_name: step_name,
                            stages: stages,
                            threshold: threshold,
                            editable: editable,
                            display_automation: display_automation,
                            system_reference: system_reference
                        }, _tmp);
                        return [
                            2,
                            data
                        ];
                    } else {
                        setApiError(result.request);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getAutomationData.apply(this, arguments);
}
function manageModals(setOldModal, setNewModal) {
    return _manageModals.apply(this, arguments);
}
function _manageModals() {
    _manageModals = _async_to_generator(function(setOldModal, setNewModal) {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        setOldModal(false)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        setNewModal(true)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _manageModals.apply(this, arguments);
}
function setTechTestFormData(params) {
    var data = {
        job_stage: {
            automation: params.automation,
            job_test_detail_attributes: {
                id: params.job_test_detail_attributes.id,
                test_type: params.job_test_detail_attributes.test_type,
                test_id: params.job_test_detail_attributes.test_id,
                days_to_expire: params.job_test_detail_attributes.days_to_expire,
                member_emails: params.job_test_detail_attributes.member_emails
            }
        }
    };
    if (params.job_test_detail_attributes.test_id == "upload_new_test") {
        var assessment = {
            name: params.job_test_detail_attributes.assessment.name,
            file_type: params.job_test_detail_attributes.assessment.file_type,
            link: params.job_test_detail_attributes.assessment.link
        };
        if (params.job_test_detail_attributes.assessment.id) assessment.id = params.job_test_detail_attributes.assessment.id;
        if (params.job_test_detail_attributes.assessment.file) assessment.file = params.job_test_detail_attributes.assessment.file;
        if (params.job_test_detail_attributes.assessment.filename) assessment.filename = params.job_test_detail_attributes.assessment.filename;
        data.assessment = assessment;
        data.save_and_continue = params.save_and_continue;
    }
    return data;
}
function interviewTypeHeader(intervieType, t) {
    var interviewTypes = _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES */ .BH;
    var interviewTypeHeaders = (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPE_HEADERS */ .Al)(t);
    switch(intervieType){
        case interviewTypes.PHONE:
            return interviewTypeHeaders.PHONE;
        case interviewTypes.VIDEO:
            return interviewTypeHeaders.VIDEO;
        case interviewTypes.FACE2FACE:
            return interviewTypeHeaders.FACE2FACE;
        case interviewTypes.TECHTEST:
            return interviewTypeHeaders.TECHTEST;
        case interviewTypes.VIDEOQA:
            return interviewTypeHeaders.VIDEOQA;
        default:
            return interviewTypeHeaders.DEFAULT;
    }
}
function defaultTestDetail(member_emails, member_initials) {
    return {
        "test_id": "",
        "test_type": "Assessment",
        "days_to_expire": "",
        "member_emails": member_emails || [],
        "member_initials": member_initials || [],
        "assessment": {
            name: "",
            file_type: "link",
            link: "",
            file: "",
            filename: "",
            filesize: ""
        }
    };
}
function setUpTechTest(initialValues, techTestAction, currentStage, t) {
    if (initialValues.job_test_detail_attributes) {
        initialValues.job_test_detail_attributes = techTestAction.setJobTestDetail(currentStage.job_test_detail_attributes, t);
    } else {
        initialValues.job_test_detail_attributes = defaultTestDetail([], []);
    }
    return initialValues;
}
function setUpVideoQAMember(initialValues, currentStage) {
    var ref, ref1;
    var videoqa = {
        member_emails: (currentStage === null || currentStage === void 0 ? void 0 : (ref = currentStage.members) === null || ref === void 0 ? void 0 : ref.map(function(x) {
            return x.email;
        })) || [],
        member_initials: (currentStage === null || currentStage === void 0 ? void 0 : (ref1 = currentStage.members) === null || ref1 === void 0 ? void 0 : ref1.map(function(x) {
            return userHash(x);
        })) || []
    };
    initialValues.videoqa = videoqa;
    return initialValues;
}
function isLocationDisabled(formik, current_index) {
    var active_index = 0;
    formik.values.job_meeting_details_attributes.map(function(item, index) {
        if (index > current_index) {
            return;
        }
        if (!item._destroy) active_index += 1;
    });
    return active_index > 1;
}
function setFormDirty(parentData, setParentData, index, is_dirty) {
    return _setFormDirty.apply(this, arguments);
}
function _setFormDirty() {
    _setFormDirty = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(parentData, setParentData, index, is_dirty) {
        var currentRecord;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    currentRecord = parentData[index];
                    if (is_dirty && !currentRecord.is_dirty) {
                        currentRecord.is_dirty = true;
                    } else if (!is_dirty) {
                        currentRecord.is_dirty = false;
                    }
                    parentData[index] = currentRecord;
                    return [
                        4,
                        setParentData((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(parentData))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _setFormDirty.apply(this, arguments);
}


/***/ }),

/***/ 57470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$l": function() { return /* binding */ hideAddScorecard; },
/* harmony export */   "BE": function() { return /* binding */ getCandidateProfileJobData; },
/* harmony export */   "Hi": function() { return /* binding */ addManualInterview; },
/* harmony export */   "Hk": function() { return /* binding */ submitCandidateNote; },
/* harmony export */   "K9": function() { return /* binding */ submitRestrictedCandidateNote; },
/* harmony export */   "Lg": function() { return /* binding */ like_dislike; },
/* harmony export */   "QB": function() { return /* binding */ getCandidateGeneralProfile; },
/* harmony export */   "QV": function() { return /* binding */ rescheduleInerview; },
/* harmony export */   "W5": function() { return /* binding */ addManualKanbanInterview; },
/* harmony export */   "WR": function() { return /* binding */ getMeetingDetails; },
/* harmony export */   "Zz": function() { return /* binding */ showAddScorecard; },
/* harmony export */   "ay": function() { return /* binding */ candidateOpenEmail; },
/* harmony export */   "cG": function() { return /* binding */ downloadContract; },
/* harmony export */   "c_": function() { return /* binding */ resendInvite; },
/* harmony export */   "cd": function() { return /* binding */ restricted_like_dislike; },
/* harmony export */   "fT": function() { return /* binding */ getShareComponentMemberListArray; },
/* harmony export */   "gR": function() { return /* binding */ checkAvailability; },
/* harmony export */   "hw": function() { return /* binding */ cancelInterviewByClient; },
/* harmony export */   "iA": function() { return /* binding */ candidateDownloadCV; },
/* harmony export */   "iM": function() { return /* binding */ goToOtherCandidate; },
/* harmony export */   "je": function() { return /* binding */ viewDetails; },
/* harmony export */   "kF": function() { return /* binding */ AddInterviewManualAction; },
/* harmony export */   "lm": function() { return /* binding */ getCandidateRestrictedProfileJobData; },
/* harmony export */   "te": function() { return /* binding */ markAsReadEmail; },
/* harmony export */   "ul": function() { return /* binding */ mergeCandidate; },
/* harmony export */   "uz": function() { return /* binding */ acceptSlot; },
/* harmony export */   "x8": function() { return /* binding */ candidateShareCV; }
/* harmony export */ });
/* unused harmony exports validateForm, viewRequest, setTabValue, previewContract */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18186);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4012);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51895);
/* harmony import */ var _imports_files_pages_clients_communication_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25355);
/* harmony import */ var _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47942);










function like_dislike(value, router, setLikeDislike, setApiError, initialData, setInitialData, setFlagForRerender) {
    return _like_dislike.apply(this, arguments);
}
function _like_dislike() {
    _like_dislike = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(value, router, setLikeDislike, setApiError, initialData, setInitialData, setFlagForRerender) {
        var job_applicant_id, body, _tmp, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    job_applicant_id = router.query.applicant_id;
                    _tmp = {};
                    body = (_tmp.liked = value, _tmp);
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CandidateProfileJobService */ .C2().like_dislike(body, job_applicant_id)
                    ];
                case 1:
                    result = _state.sent();
                    setLikeDislike(value);
                    if (result.request.status == 200) {
                        initialData.application.liked_unliked = value;
                        initialData.notes = result.data.notes;
                        setInitialData(initialData);
                        setFlagForRerender(Math.random() * 10000);
                    } else {
                        setApiError(result.request);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _like_dislike.apply(this, arguments);
}
function restricted_like_dislike(value, router, setLikeDislike, setApiError, initialData, setInitialData, setFlagForRerender) {
    return _restricted_like_dislike.apply(this, arguments);
}
function _restricted_like_dislike() {
    _restricted_like_dislike = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(value, router, setLikeDislike, setApiError, initialData, setInitialData, setFlagForRerender) {
        var token, body, _tmp, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    token = router.query.token;
                    _tmp = {};
                    body = (_tmp["liked"] = value, _tmp["token"] = token, _tmp);
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CandidateProfileJobService */ .C2().restrictedLikeDislike(body)
                    ];
                case 1:
                    result = _state.sent();
                    setLikeDislike(value);
                    if (result.request.status == 200) {
                        initialData.application.liked_unliked = value;
                        initialData.notes = result.data.notes;
                        setInitialData(initialData);
                        setFlagForRerender(Math.random() * 10000);
                    } else {
                        setApiError(result.request);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _restricted_like_dislike.apply(this, arguments);
}
function goToOtherCandidate(router, applicant_id, query, type, candidateCurrentStageId) {
    if (type == "next") {
        if (query.candidate_index && candidateCurrentStageId == parseInt(query.job_stage_id)) {
            var index = parseInt(query.candidate_index);
            index = index + 1;
            query.candidate_index = index.toString();
        }
    } else {
        if (query.candidate_index && candidateCurrentStageId == parseInt(query.job_stage_id)) {
            var index1 = parseInt(query.candidate_index);
            index1 = index1 - 1;
            query.candidate_index = index1.toString();
        }
    }
    if (applicant_id) {
        var path = _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.jobs.candidate_profile_job.replace */ .RQ.client.jobs.candidate_profile_job.replace("$job_id", query.job_id).replace("$applicant_id", applicant_id);
        router.push({
            pathname: path,
            query: query
        });
    }
}
function candidateDownloadCV(url) {
    if (url) {
        (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .saveAs */ .po)(url, "Resume.pdf");
    } else {
        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5().setNormalToastr((0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_3__/* .TRANSLATION */ .TA)("toastr:cv_not_exists"), "error");
    }
}
function candidateOpenEmail(setShowCandidateEmail, candidate_email, setReplyTo, setReplySubject, setEmailType, setIsActiveEmail, initialData, setOpenFrom, type, setReferences) {
    if (candidate_email || initialData.application.agency_detail) {
        setReplyTo("");
        if (setReferences) setReferences("");
        setReplySubject("");
        setOpenFrom(type);
        setEmailType("job_application");
        setIsActiveEmail(false);
        setShowCandidateEmail(true);
    } else {
        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5().setNormalToastr("Email does not exists", "error");
    // toastr.error('Email does not exists');
    }
}
function candidateShareCV(setButtonPopup, cv_url) {
    if (cv_url) {
        setButtonPopup(true);
    } else {
        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5().setNormalToastr((0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_3__/* .TRANSLATION */ .TA)("toastr:cv_not_exists"), "error");
    }
}
function submitCandidateNote(values, router, setMentionsInputValue, mentionsMember, initialData, setInitialData, setApiError, setFlagForRerender, formik) {
    return _submitCandidateNote.apply(this, arguments);
}
function _submitCandidateNote() {
    _submitCandidateNote = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(values, router, setMentionsInputValue, mentionsMember, initialData, setInitialData, setApiError, setFlagForRerender, formik) {
        var message, body, _tmp, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    message = document.querySelector(".autocompleteInput textarea").value;
                    _tmp = {};
                    body = (_tmp.message = message, _tmp.member_tag_ids = mentionsMember, _tmp.private = values.private, _tmp);
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CandidateProfileJobService */ .C2().addNote(body, router.query.applicant_id)
                    ];
                case 1:
                    result = _state.sent();
                    router.query["section"] = "notes";
                    initialData.notes = result.data.notes;
                    setInitialData(initialData);
                    delete router.query["section"];
                    setFlagForRerender(Math.random() * 10000);
                    result.request.status != 200 ? setApiError(result.request) : null;
                    formik.current.resetForm();
                    return [
                        2
                    ];
            }
        });
    });
    return _submitCandidateNote.apply(this, arguments);
}
function submitRestrictedCandidateNote(values, router, mentionsMember, initialData, setInitialData, setApiError, setFlagForRerender, formik) {
    return _submitRestrictedCandidateNote.apply(this, arguments);
}
function _submitRestrictedCandidateNote() {
    _submitRestrictedCandidateNote = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(values, router, mentionsMember, initialData, setInitialData, setApiError, setFlagForRerender, formik) {
        var message, token, body, _tmp, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    message = document.querySelector(".autocompleteInput textarea").value;
                    token = router.query.token;
                    _tmp = {};
                    body = (_tmp.message = message, _tmp.member_tag_ids = mentionsMember, _tmp.private = values.private, _tmp.token = token, _tmp);
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CandidateProfileJobService */ .C2().restrictedAddNote(body)
                    ];
                case 1:
                    result = _state.sent();
                    initialData.notes = result.data.notes;
                    setInitialData(initialData);
                    delete router.query["section"];
                    setFlagForRerender(Math.random() * 10000);
                    result.request.status != 200 ? setApiError(result.request) : null;
                    formik.current.resetForm();
                    return [
                        2
                    ];
            }
        });
    });
    return _submitRestrictedCandidateNote.apply(this, arguments);
}
function getShareComponentMemberListArray(hash) {
    var names_hash = [];
    if (hash) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = hash[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                names_hash.push({
                    id: element.user_attributes.id,
                    display: "@".concat(element.user_attributes.name)
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return names_hash;
}
function getCandidateProfileJobData(router, setApiError) {
    return _getCandidateProfileJobData.apply(this, arguments);
}
function _getCandidateProfileJobData() {
    _getCandidateProfileJobData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(router, setApiError) {
        var filterData, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    filterData = (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .ApplicationFilter */ .it)(router.query.job_id);
                    if (filterData) {
                        router.query = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, router.query, filterData);
                    }
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CandidateProfileJobService */ .C2().getApplicationsData(router.query)
                    ];
                case 1:
                    result = _state.sent();
                    if (setApiError) setApiError(result.request);
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _getCandidateProfileJobData.apply(this, arguments);
}
function getCandidateRestrictedProfileJobData(router) {
    return _getCandidateRestrictedProfileJobData.apply(this, arguments);
}
function _getCandidateRestrictedProfileJobData() {
    _getCandidateRestrictedProfileJobData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(router) {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CandidateProfileJobService */ .C2().getApplicationsDataWhenRestricted(router.query)
                    ];
                case 1:
                    result = _state.sent();
                    if (result.request.status != 200) {
                        router.push(_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.login */ .RQ.client.login);
                    }
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _getCandidateRestrictedProfileJobData.apply(this, arguments);
}
function getCandidateGeneralProfile(router, setApiError) {
    return _getCandidateGeneralProfile.apply(this, arguments);
}
function _getCandidateGeneralProfile() {
    _getCandidateGeneralProfile = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(router, setApiError) {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    router.query["general_view"] = true;
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CandidateProfileJobService */ .C2().getCandidateGeneralViewData(router.query)
                    ];
                case 1:
                    result = _state.sent();
                    if (setApiError) setApiError(result.request);
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _getCandidateGeneralProfile.apply(this, arguments);
}
function resendInvite(meetingId, interview_type, router, setInitialData, initialData) {
    return _resendInvite.apply(this, arguments);
}
function _resendInvite() {
    _resendInvite = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(meetingId, interview_type, router, setInitialData, initialData) {
        var result, status_code, customToastrAction, response_data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CandidateProfileJobService */ .C2().resendInvite(meetingId, interview_type)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            return [
                                3,
                                2
                            ];
                        case _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            return [
                                3,
                                5
                            ];
                    }
                    return [
                        3,
                        6
                    ];
                case 2:
                    response_data = result.data;
                    if (initialData) response_data.previous_record_id = initialData === null || initialData === void 0 ? void 0 : initialData.previous_record_id;
                    if (initialData) response_data.next_record_id = initialData === null || initialData === void 0 ? void 0 : initialData.next_record_id;
                    if (!setInitialData) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        setInitialData(response_data)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    customToastrAction.setNormalToastr(result.data.success, "success");
                    return [
                        3,
                        7
                    ];
                case 5:
                    customToastrAction.setNormalToastr(result.response.data.error, "error");
                    return [
                        3,
                        7
                    ];
                case 6:
                    (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                    _state.label = 7;
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return _resendInvite.apply(this, arguments);
}
function rescheduleInerview(values, meetingId, setBtnPopup, router, setInitialData) {
    return _rescheduleInerview.apply(this, arguments);
}
function _rescheduleInerview() {
    _rescheduleInerview = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(values, meetingId, setBtnPopup, router, setInitialData) {
        var params, _tmp, result, status_code, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    params = (_tmp.custom_meeting_period = values, _tmp);
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CandidateProfileJobService */ .C2().rescheduleInerview(params, meetingId)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            setBtnPopup(false);
                            setInitialData(result.data);
                            customToastrAction.setNormalToastr(result.data.success, "success");
                            return [
                                2,
                                result.data
                            ];
                        case _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "error");
                            break;
                        default:
                            (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _rescheduleInerview.apply(this, arguments);
}
function getMeetingDetails(params, router, action) {
    return _getMeetingDetails.apply(this, arguments);
}
function _getMeetingDetails() {
    _getMeetingDetails = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(params, router, action) {
        var result, status_code, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CandidateProfileJobService */ .C2().getDetails(params, action)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            return [
                                2,
                                result.data
                            ];
                        case _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "error");
                            break;
                        default:
                            (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getMeetingDetails.apply(this, arguments);
}
function validateForm(formik, index, start_time) {
    var values = formik.values.children_attributes;
    if (index == 0) return true;
    var prevIndex;
    values.map(function(x, itemIndex) {
        if (!x._destroy && itemIndex < index) {
            prevIndex = itemIndex;
        }
        return x;
    });
    if (typeof prevIndex === "undefined") return true;
    var end_time = values[prevIndex].end_time;
    if (end_time.length == 0) return true;
    var isValid = moment(start_time, "DD/MM/YYYY HH:mm").isAfter(moment(end_time, "DD/MM/YYYY HH:mm")) && moment(start_time, "DD/MM/YYYY").isSame(moment(end_time, "DD/MM/YYYY"));
    if (isValid) {
        formik.setStatus({}, true);
        formik.setTouched({}, true);
    } else {
        var children_attributes = [];
        children_attributes[index] = {
            start_time: "start time should greater than last round's end time and with same date"
        };
        formik.setStatus({
            children_attributes: children_attributes
        }, true);
        formik.setTouched({
            children_attributes: children_attributes
        }, true);
    }
}
function addManualInterview(params, router, setBtnPopup, setInitialData, setLoading, current_interview_type, setFlagForRender, setDisabledSaveButton) {
    return _addManualInterview.apply(this, arguments);
}
function _addManualInterview() {
    _addManualInterview = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(params, router, setBtnPopup, setInitialData, setLoading, current_interview_type, setFlagForRender, setDisabledSaveButton) {
        var from, setAddInterviewBar, addInterviewBar, emailContent, setUnsuccessfulEmailModal, kanban_params, _tmp, data, _tmp1, ref, ref1, filterData, result, status_code, customToastrAction, _tmp2, _tmp3, _tmp4, error_message, _tmp5;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    from = _arguments.length > 8 && _arguments[8] !== void 0 ? _arguments[8] : null, setAddInterviewBar = _arguments.length > 9 && _arguments[9] !== void 0 ? _arguments[9] : null, addInterviewBar = _arguments.length > 10 && _arguments[10] !== void 0 ? _arguments[10] : null, emailContent = _arguments.length > 11 && _arguments[11] !== void 0 ? _arguments[11] : null, setUnsuccessfulEmailModal = _arguments.length > 12 && _arguments[12] !== void 0 ? _arguments[12] : null;
                    _tmp = {};
                    kanban_params = _tmp;
                    setLoading(true);
                    setDisabledSaveButton(true);
                    if (current_interview_type == _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.FACE2FACE */ .BH.FACE2FACE) {
                        params.children_attributes = params.children_attributes.map(function(x) {
                            x.location_attributes = {
                                full_address: params.default_location || "",
                                place_id: params.place_id || ""
                            };
                            return x;
                        });
                    }
                    if (current_interview_type != _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.FACE2FACE */ .BH.FACE2FACE) params.children_attributes.map(function(x) {
                        x.location = "";
                        x.place_id = "";
                        x.start_time = x.date + " " + x.starttime;
                        x.end_time = x.date + " " + x.endtime;
                    });
                    if (current_interview_type != _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.VIDEOQA */ .BH.VIDEOQA) params.children_attributes.map(function(x) {
                        x.start_time = x.date + " " + x.starttime;
                        x.end_time = x.date + " " + x.endtime;
                    });
                    if (current_interview_type == _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.VIDEOQA */ .BH.VIDEOQA) {
                        params["job_stage_id"] = router.query.job_stage_id;
                        params["job_stage_attributes"]["id"] = router.query.job_stage_id;
                        params["job_stage_attributes"]["job_id"] = router.query.job_id;
                        params["member_emails"] = params.videoqa.member_emails;
                    // params['job_stage_attributes']['stage_id'] = 3;  //TODO
                    }
                    if (emailContent) {
                        params["email"] = emailContent;
                    }
                    _tmp1 = {};
                    data = (_tmp1.job_application_meeting = params, _tmp1);
                    if (from == "application_view") {
                        ;
                        data.kanban = {
                            candidate_index: router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.candidate_index,
                            base_stage_id: router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.job_stage_id
                        };
                        filterData = (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .ApplicationFilter */ .it)(router.query.job_id);
                        if (filterData) {
                            data.application_filter_data = filterData;
                        }
                    }
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CandidateProfileJobService */ .C2().addInterview(data)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    setLoading(false);
                    _tmp2 = {};
                    _tmp3 = {};
                    _tmp4 = {};
                    _tmp5 = {};
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            setBtnPopup((_tmp2.active = false, _tmp2.action = "", _tmp2));
                            setInitialData(result.data);
                            setFlagForRender(Math.random() * 10000);
                            setDisabledSaveButton(false);
                            setAddInterviewBar((_tmp3.active = false, _tmp3.action = {}, _tmp3));
                            if (setUnsuccessfulEmailModal) setUnsuccessfulEmailModal((_tmp4.state = false, _tmp4));
                            if (result.data.success) customToastrAction.setNormalToastr(result.data.success, "success");
                            return [
                                2,
                                result.data
                            ];
                        case _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            error_message = (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .showErrors */ .dd)(result.response.data.error);
                            error_message.length > 0 ? customToastrAction.setNormalToastr(error_message, "error") : customToastrAction.setNormalToastr(result.response.data.error, "error");
                            setDisabledSaveButton(false);
                            if (setUnsuccessfulEmailModal) setUnsuccessfulEmailModal((_tmp5.state = false, _tmp5));
                            break;
                        default:
                            (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                            setDisabledSaveButton(false);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _addManualInterview.apply(this, arguments);
}
function addManualKanbanInterview(params, router, setBtnPopup, setInitialData, setLoading, current_interview_type, setFlagForRender, setDisabledSaveButton, args) {
    return _addManualKanbanInterview.apply(this, arguments);
}
function _addManualKanbanInterview() {
    _addManualKanbanInterview = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(params, router, setBtnPopup, setInitialData, setLoading, current_interview_type, setFlagForRender, setDisabledSaveButton, args) {
        var setAddInterviewBar, addInterviewBar, emailContent, setUnsuccessfulEmailModal, t, customToastrAction, assessment, hasLink, hasFile, data, _tmp, result, status_code, customToastrAction1, _tmp1, _tmp2, error_message;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setAddInterviewBar = _arguments.length > 9 && _arguments[9] !== void 0 ? _arguments[9] : null, addInterviewBar = _arguments.length > 10 && _arguments[10] !== void 0 ? _arguments[10] : null, emailContent = _arguments.length > 11 && _arguments[11] !== void 0 ? _arguments[11] : null, setUnsuccessfulEmailModal = _arguments.length > 12 && _arguments[12] !== void 0 ? _arguments[12] : null, t = _arguments.length > 13 ? _arguments[13] : void 0;
                    setDisabledSaveButton(true);
                    setLoading(true);
                    if (current_interview_type != _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.FACE2FACE */ .BH.FACE2FACE) params.children_attributes.map(function(x) {
                        x.location = "";
                        x.place_id = "";
                        x.start_time = x.date + " " + x.starttime;
                        x.end_time = x.date + " " + x.endtime;
                    });
                    if (current_interview_type != _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.VIDEOQA */ .BH.VIDEOQA) params.children_attributes.map(function(x) {
                        x.start_time = x.date + " " + x.starttime;
                        x.end_time = x.date + " " + x.endtime;
                    });
                    if (current_interview_type == _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.VIDEOQA */ .BH.VIDEOQA) {
                        params["job_stage_id"] = args.selectedCards.stage_id;
                        params["job_stage_attributes"] = {
                            id: args.selectedCards.stage_id
                        };
                        params["job_stage_attributes"]["job_id"] = router.query.job_id;
                        params["member_emails"] = params.videoqa.member_emails;
                    }
                    if (current_interview_type == _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .INTERVIEW_TYPES.TECHTEST */ .BH.TECHTEST) {
                        customToastrAction = new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                        assessment = params.job_test_detail_attributes.assessment;
                        if (params.job_test_detail_attributes.test_id == "upload_new_test") {
                            hasLink = typeof assessment.link === "string" && assessment.link.trim().length > 0;
                            hasFile = assessment.file;
                            if (!hasLink && !hasFile) {
                                customToastrAction.setNormalToastr((0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_3__/* .TRANSLATION */ .TA)("errors:assessment_link_error"), "warning");
                                setLoading(false);
                                return [
                                    2
                                ];
                            }
                        }
                        params.assessment = params.job_test_detail_attributes.assessment;
                        params["job_stage"] = {
                            job_test_detail_attributes: params.job_test_detail_attributes
                        };
                        params.assessment = params.job_test_detail_attributes.assessment;
                    }
                    if (emailContent) {
                        params["email"] = emailContent;
                    }
                    _tmp = {};
                    data = (_tmp.job_application_meeting = params, _tmp.from = args.from, _tmp);
                    data.job_application_meeting.job_application_ids = args.selectedCards.job_application_ids;
                    data.job_application_meeting.rejected_ids = args.selectedCards.rejected_ids;
                    data.job_application_meeting.job_stage_id = args.selectedCards.stage_id;
                    if (args.from == "application_view") {
                        data.kanban = {
                            candidate_index: args.candidateIndex,
                            base_stage_id: args.paramStageId
                        };
                    }
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CandidateProfileJobService */ .C2().setupInterview(data)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction1 = new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    setLoading(false);
                    _tmp1 = {};
                    _tmp2 = {};
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            setBtnPopup(false);
                            if (args.from == "kanban") {
                                (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_3__/* .clearRadioButtonSelection */ .sZ)(args.setSelectedCards, args.activeTab, args.setActionBar);
                                setInitialData(result.data.kanban_data);
                            } else {
                                setInitialData(result.data.application_data);
                            }
                            // setFlagForRender(Math.random() * 10000);
                            setDisabledSaveButton(false);
                            setAddInterviewBar((_tmp1.active = false, _tmp1.action = {}, _tmp1));
                            if (setUnsuccessfulEmailModal) setUnsuccessfulEmailModal((_tmp2.state = false, _tmp2));
                            // if(result.data.success) customToastrAction.setNormalToastr(result.data.success, 'success')
                            return [
                                2,
                                result.data
                            ];
                        case _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            error_message = (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .showErrors */ .dd)(result.response.data.error);
                            error_message.length > 0 ? customToastrAction1.setNormalToastr(error_message, "error") : customToastrAction1.setNormalToastr(result.response.data.error, "error");
                            setDisabledSaveButton(false);
                            break;
                        default:
                            (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                            setDisabledSaveButton(false);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _addManualKanbanInterview.apply(this, arguments);
}
function viewDetails(meetingId, router) {
    return _viewDetails.apply(this, arguments);
}
function _viewDetails() {
    _viewDetails = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(meetingId, router) {
        var result, status_code, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CandidateProfileJobService */ .C2().viewDetails(meetingId)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            return [
                                2,
                                result.data
                            ];
                        case _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "error");
                            break;
                        default:
                            (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _viewDetails.apply(this, arguments);
}
function viewRequest(meetingId, router) {
    return _viewRequest.apply(this, arguments);
}
function _viewRequest() {
    _viewRequest = _async_to_generator(function(meetingId, router) {
        var result, status_code, customToastrAction;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new CandidateProfileJobService().viewRequest(meetingId)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new CustomToastrAction();
                    switch(status_code){
                        case SUCCESS_REPONSE_CODE:
                            return [
                                2,
                                result.data
                            ];
                        case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
                            customToastrAction.setNormalToastr(result.response.data.error, "error");
                            break;
                        default:
                            handleOtherResponseCode(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _viewRequest.apply(this, arguments);
}
function cancelInterviewByClient(values, meetingId, setBtnPopup, router, setInitialData, setFlagForRender) {
    return _cancelInterviewByClient.apply(this, arguments);
}
function _cancelInterviewByClient() {
    _cancelInterviewByClient = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(values, meetingId, setBtnPopup, router, setInitialData, setFlagForRender) {
        var data, _tmp, result, status_code, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    data = (_tmp.cancel_detail = values, _tmp);
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CandidateProfileJobService */ .C2().cancelInterview(data, meetingId)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            setBtnPopup(false);
                            setInitialData(result.data);
                            customToastrAction.setNormalToastr(result.data.success, "success");
                        // toastr.success(result.data.success)
                        case _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "error");
                            break;
                        default:
                            (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _cancelInterviewByClient.apply(this, arguments);
}
function checkAvailability(values, meetingId, router, setNoOfSlots) {
    return _checkAvailability.apply(this, arguments);
}
function _checkAvailability() {
    _checkAvailability = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(values, meetingId, router, setNoOfSlots) {
        var data, _tmp, result, status_code, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    data = (_tmp.start_date = values.start_date.replaceAll("/", "-"), _tmp.end_date = values.end_date.replaceAll("/", "-"), _tmp);
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CandidateProfileJobService */ .C2().getNoOfSlots(data, meetingId)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            setNoOfSlots(result.data.available_slots);
                            break;
                        case _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "error");
                            break;
                        default:
                            (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _checkAvailability.apply(this, arguments);
}
function acceptSlot(meetingId, preferenceId, setBtnPopup, router, setInitialData, setShowLoader) {
    return _acceptSlot.apply(this, arguments);
}
function _acceptSlot() {
    _acceptSlot = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(meetingId, preferenceId, setBtnPopup, router, setInitialData, setShowLoader) {
        var data, _tmp, result, status_code, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setShowLoader(true);
                    _tmp = {};
                    data = (_tmp.preference_id = preferenceId, _tmp);
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CandidateProfileJobService */ .C2().acceptSlotRequest(data, meetingId)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    setShowLoader(false);
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            setInitialData(result.data);
                            setBtnPopup(false);
                            customToastrAction.setNormalToastr(result.data.success, "success");
                            break;
                        case _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "error");
                            break;
                        default:
                            (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _acceptSlot.apply(this, arguments);
}
function setTabValue(router, initialData) {
    var ref, ref1, ref2, ref3, ref4;
    if (((ref = router.query) === null || ref === void 0 ? void 0 : ref.tab) && ((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.tab) == "scorecard") {
        return 2;
    } else if (((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.comm_section) == "comms") return 1;
    else if (((ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.selected_section) == "offer" || (initialData === null || initialData === void 0 ? void 0 : initialData.offer_stage_id) == (initialData === null || initialData === void 0 ? void 0 : (ref4 = initialData.application) === null || ref4 === void 0 ? void 0 : ref4.stage_id)) return initialData.technical_tests ? "7" : "6";
    else return 0;
}
function mergeCandidate(candidate_id, candidate_name, router) {
    var params = router.query;
    params["query"] = candidate_name.split(" ")[0];
    var link = _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.jobs.merge_listing.replace */ .RQ.client.jobs.merge_listing.replace("$candidate_id", candidate_id);
    router.push({
        pathname: link,
        query: params
    });
}
function markAsReadEmail(record) {
    return _markAsReadEmail.apply(this, arguments);
}
function _markAsReadEmail() {
    _markAsReadEmail = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(record) {
        var communicationCenterOptionsService, params, _tmp, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    communicationCenterOptionsService = new _imports_files_pages_clients_communication_index__WEBPACK_IMPORTED_MODULE_2__/* .CommunicationCenterOptionsService */ .hF();
                    _tmp = {};
                    params = (_tmp.ids = [
                        record.user_comm_detail_id
                    ].concat(record.child_ids), _tmp.read = true, _tmp);
                    params.comms_tab = true;
                    return [
                        4,
                        communicationCenterOptionsService.markAsRead(params)
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _markAsReadEmail.apply(this, arguments);
}
function downloadContract(contract_id, contract_title) {
    return _downloadContract.apply(this, arguments);
}
function _downloadContract() {
    _downloadContract = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(contract_id, contract_title) {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .CandidateProfileJobService */ .C2().downloadContract(contract_id)
                    ];
                case 1:
                    result = _state.sent();
                    (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .saveAs */ .po)(result.data, "".concat(contract_title, ".").concat(result.data.type.split("/")[1]));
                    return [
                        2
                    ];
            }
        });
    });
    return _downloadContract.apply(this, arguments);
}
function previewContract(contract_id) {
    return _previewContract.apply(this, arguments);
}
function _previewContract() {
    _previewContract = _async_to_generator(function(contract_id) {
        var result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new CandidateProfileJobService().previewContract(contract_id)
                    ];
                case 1:
                    result = _state.sent();
                    if (result.request.status == 200) {
                        window.open(result.data.file_url, "_blank");
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _previewContract.apply(this, arguments);
}
function showAddScorecard() {
    document.getElementsByClassName("job-application-view-section")[0].classList.add("displaynone");
    document.getElementsByClassName("add-scorecard-section")[0].classList.remove("displaynone");
}
function hideAddScorecard() {
    document.getElementsByClassName("job-application-view-section")[0].classList.remove("displaynone");
    document.getElementsByClassName("add-scorecard-section")[0].classList.add("displaynone");
}
var AddInterviewManualAction = /*#__PURE__*/ function() {
    "use strict";
    function AddInterviewManualAction(setFlagForRerender, deleteQuestionList, setDeleteQuestionList, setDisabledAddMoreQuestion) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, AddInterviewManualAction);
        this.setFlagForRerender = setFlagForRerender;
        this.deleteQuestionList = deleteQuestionList;
        this.setDeleteQuestionList = setDeleteQuestionList;
        this.setDisabledAddMoreQuestion = setDisabledAddMoreQuestion;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(AddInterviewManualAction, [
        {
            key: "NumberField",
            value: function NumberField(param) {
                var field = param.field, className = param.className, disabled = param.disabled, format = param.format, placeholder = param.placeholder, style = param.style, formik = param.formik, isAllowed = param.isAllowed, onValueChange = param.onValueChange, defaultValue = param.defaultValue;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .NumberFormat */ .y4, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, field), {
                    defaultValue: defaultValue,
                    thousandsGroupStyle: "thousand",
                    name: field.name,
                    format: format,
                    displayType: "input",
                    type: "text",
                    className: className,
                    style: style,
                    formik: formik,
                    disabled: disabled,
                    placeholder: placeholder,
                    thousandSeparator: true,
                    allowNegative: false,
                    isAllowed: isAllowed,
                    onValueChange: onValueChange
                }));
            }
        },
        {
            key: "setLanguageList",
            value: function setLanguageList(data) {
                var list_data = [];
                if (data) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.keys(data)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var key = _step.value;
                            list_data.push({
                                value: data[key].title,
                                label: data[key].title
                            });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return list_data;
            }
        },
        {
            key: "handleDurationChange",
            value: function handleDurationChange(evt, formik, index, setTotalDuration) {
                var new_value = isNaN(evt.target.value) ? "" : parseInt(evt.target.value) == 0 ? "" : evt.target.value;
                formik.setFieldValue("children_attributes.".concat(index, ".duration"), new_value);
                var durations = [];
                formik.values.children_attributes.map(function(x, itemIndex) {
                    if (!x._destroy) {
                        if (itemIndex == index) {
                            durations.push(new_value);
                        } else {
                            durations.push(parseInt(x.duration) || 0);
                        }
                    } else {
                        durations.push(0);
                    }
                    return x;
                });
                formik.setFieldValue("children_attributes.".concat(index, ".endtime"), (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_1__/* .addMinutes */ .mH)(formik.values.children_attributes[index].starttime, new_value));
                durations[index] = new_value;
                setTotalDuration(durations.reduce(function(a, b) {
                    return (parseInt(a) || 0) + (parseInt(b) || 0);
                }, 0));
            }
        },
        {
            key: "onAddClick",
            value: function onAddClick(formik) {
                formik.values.questions_attributes.push({
                    question: "",
                    description: "",
                    attempts: 2,
                    answer_time: 30,
                    _destroy: false
                });
                this.setFlagForRerender(Math.random() * 10000);
                if (formik.values.questions_attributes.length == 5) {
                    this.setDisabledAddMoreQuestion(true);
                }
            }
        },
        {
            key: "onDeleteClick",
            value: function onDeleteClick(formik, index) {
                this.deleteQuestionList.push(formik.values.questions_attributes[index]);
                this.deleteQuestionList[this.deleteQuestionList.length - 1]["_destroy"] = true;
                this.setDeleteQuestionList(this.deleteQuestionList);
                this.setDisabledAddMoreQuestion(false);
                formik.values.questions_attributes.splice(index, 1);
                this.setFlagForRerender(Math.random() * 10000);
            }
        },
        {
            key: "setQuestionsValues",
            value: function setQuestionsValues(values) {
                values.questions_attributes = Object.assign([], values.questions_attributes, this.deleteQuestionList);
                return values;
            }
        }
    ]);
    return AddInterviewManualAction;
}();


/***/ }),

/***/ 90432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$h": function() { return /* binding */ toggleDisabled; },
/* harmony export */   "M1": function() { return /* binding */ draftJob; },
/* harmony export */   "OP": function() { return /* binding */ jobStatusBadge; },
/* harmony export */   "UU": function() { return /* binding */ cancelJob; },
/* harmony export */   "WX": function() { return /* binding */ textDisabled; },
/* harmony export */   "XD": function() { return /* binding */ isCorrectTime; },
/* harmony export */   "_g": function() { return /* binding */ arrayEquals; },
/* harmony export */   "ao": function() { return /* binding */ previewJob; },
/* harmony export */   "d3": function() { return /* binding */ startDateMessage; },
/* harmony export */   "qb": function() { return /* binding */ isValidDate; },
/* harmony export */   "sT": function() { return /* binding */ humanDateFormat; },
/* harmony export */   "vH": function() { return /* binding */ setFilledDate; },
/* harmony export */   "y$": function() { return /* binding */ cursorNone; }
/* harmony export */ });
/* unused harmony exports todayDate, disableFutureDate, tomorrowDate, setDateTimeFilledDate, hideDraft, isFloat */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46780);



function cancelJob(router, setCancelPopup, setPageName, queryClient) {
    return _cancelJob.apply(this, arguments);
}
function _cancelJob() {
    _cancelJob = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(router, setCancelPopup, setPageName, queryClient) {
        var jobId, idRegex, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            jobId = new _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .DataFromUrl */ .QJ().getJobId();
            idRegex = new RegExp("[0-9]");
            setCancelPopup(false);
            _tmp = {};
            router.push((_tmp.pathname = _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT.client.jobs.index */ .RQ.client.jobs.index, _tmp.query = {
                job_type: "active"
            }, _tmp));
            return [
                2
            ];
        });
    });
    return _cancelJob.apply(this, arguments);
}
function redirectTopage(values, newValues, step) {
    switch(step){
        case 1:
            values = {
                job: newValues
            };
            break;
        case 2:
            values = (0,_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .getEditInitalOptionValues */ .Il)(newValues, step);
            break;
        case 3:
            values = (0,_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .getEditInitalValues */ .Ek)(newValues, step);
            break;
        case 4:
            values = {
                job: {
                    job_stages_attributes: newValues.job_stages_attributes
                }
            };
            break;
        case 5:
            values = {
                scorecard_config_attributes: newValues.scorecard_config_attributes,
                job_competencies_attributes: newValues.job_competencies_attributes
            };
            break;
        case 6:
            values = {
                job: {
                    integration_ids: newValues.integration_ids
                }
            };
            break;
    }
    return values;
}
function getJobObject(values, step) {
    var body = {};
    switch(step){
        case 1:
            body = Object.assign({}, values);
            break;
        case 2:
            var screening_questions_attributes = values.job.screening_questions_attributes;
            screening_questions_attributes = screening_questions_attributes.map(function(x) {
                var order = 1;
                x.question_options_attributes = x.question_options_attributes.map(function(option) {
                    if (!option._destroy) option.order = order;
                    return option;
                });
                return x;
            });
            values.job.screening_questions_attributes = screening_questions_attributes;
            body = Object.assign({}, values);
            break;
        case 3:
            var job_stages_attributes = values.job.job_stages_attributes;
            var order = 1;
            job_stages_attributes = job_stages_attributes.map(function(x, index) {
                delete x["stage_emails"];
                if (!x._destroy) {
                    x["order"] = order;
                    order = order + 1;
                    if (x.placeholder && x.placeholder.length > 0) {
                        if (x.job_stage_label_attributes.label.length > 0) {
                            x.job_stage_label_attributes.label = x.job_stage_label_attributes.label;
                        } else {
                            x.job_stage_label_attributes.label = x.placeholder;
                        }
                    }
                }
                return x;
            });
            values.job.job_stages_attributes = job_stages_attributes;
            body = Object.assign({}, values);
            break;
        case 4:
            body = Object.assign({}, values);
            break;
        case 5:
            body = {
                job: Object.assign({}, values)
            };
            break;
        case 6:
            body = Object.assign({}, values);
            break;
    }
    return body;
}
function showErrors(job, step) {
    var message = "";
    var customToastrAction = new _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .CustomToastrAction */ .Y5();
    switch(step){
        case 1:
            if (job === null || job === void 0 ? void 0 : job.hiring_manager_emails) {
                message += "".concat(job.hiring_manager_emails);
            }
            if (job === null || job === void 0 ? void 0 : job.job_owner_emails) {
                if (message.length > 0) {
                    message += "</br>";
                }
                message += "".concat(job.job_owner_emails);
            }
            if (job === null || job === void 0 ? void 0 : job.start_date) {
                message = startDateMessage(message, job === null || job === void 0 ? void 0 : job.start_date);
            }
            break;
        case 2:
            if (job === null || job === void 0 ? void 0 : job.start_date) {
                message = startDateMessage(message, job === null || job === void 0 ? void 0 : job.start_date);
            }
            break;
        case 3:
            var jobStages = job.job_stages_attributes;
            jobStages === null || jobStages === void 0 ? void 0 : jobStages.map(function(stage, index) {
                if (jobStages[index].member_emails) {
                    if (message.length > 0) {
                        message += " </br> ";
                    }
                    message += "".concat(jobStages[index].member_emails);
                }
            });
            if (job === null || job === void 0 ? void 0 : job.start_date) {
                message = startDateMessage(message, job === null || job === void 0 ? void 0 : job.start_date);
            }
            break;
        case 4:
            if (job === null || job === void 0 ? void 0 : job.start_date) {
                message = startDateMessage(message, job === null || job === void 0 ? void 0 : job.start_date);
            }
            break;
        case 5:
            if (job === null || job === void 0 ? void 0 : job.start_date) {
                message = startDateMessage(message, job === null || job === void 0 ? void 0 : job.start_date);
            }
            break;
        case 6:
            if (job === null || job === void 0 ? void 0 : job.start_date) {
                message = startDateMessage(message, job === null || job === void 0 ? void 0 : job.start_date);
            }
            break;
    }
    if (message.length > 0) {
        customToastrAction.setNormalToastr(message, "warning");
    }
}
function startDateMessage(message, error) {
    if (message.length > 0) {
        return message = message + "</br> ".concat(error);
    } else {
        return error;
    }
}
function draftJob(values, router, step, setPageName, queryClient, setJobStatus, setDisabledSaveButton, formRef, submitState) {
    return _draftJob.apply(this, arguments);
}
function _draftJob() {
    _draftJob = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(values, router, step, setPageName, queryClient, setJobStatus, setDisabledSaveButton, formRef, submitState) {
        var body, result, _tmp, jobId, idRegex, createJobAction, status_code, customToastrAction, response, link;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setDisabledSaveButton(true);
                    body = getJobObject(values, step);
                    body.job.draft = true;
                    _tmp = {};
                    result = _tmp;
                    jobId = new _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .DataFromUrl */ .QJ().getJobId();
                    idRegex = new RegExp("[0-9]");
                    createJobAction = false;
                    if (!idRegex.test(jobId)) return [
                        3,
                        2
                    ];
                    body.job.really_draft = true;
                    body.job.id = jobId;
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .JobCommon */ .gW().saveAsDraft(body, jobId)
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    values.job.really_draft = true;
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .Job */ .oI().createJob(values)
                    ];
                case 3:
                    result = _state.sent();
                    createJobAction = true;
                    _state.label = 4;
                case 4:
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .SUCCESS_REPONSE_CODE */ .Us:
                            response = result.data;
                            setJobStatus("draft");
                            values = redirectTopage(values, response, step);
                            if (step == 2 || step == 3 || step == 5) {
                                setDisabledSaveButton(false);
                                if (submitState == "draft") {
                                    customToastrAction.setNormalToastr(response.success, "success");
                                } else {
                                    previewJob(router, response.id);
                                }
                                return [
                                    2,
                                    values
                                ];
                            }
                            if (createJobAction) {
                                link = _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT.client.jobs.edit.replace */ .RQ.client.jobs.edit.replace("$job_id", response.id);
                                router.push(link);
                            }
                            if (submitState == "draft") {
                                customToastrAction.setNormalToastr(response.success, "success");
                            } else {
                                previewJob(router, response.id);
                            }
                            break;
                        case _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            showErrors(result.response.data.error.job, step);
                            formRef.current.setStatus(result.response.data.error);
                            break;
                        default:
                            (0,_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .handleOtherResponseCode */ .GB)(status_code, router);
                    }
                    setDisabledSaveButton(false);
                    return [
                        2
                    ];
            }
        });
    });
    return _draftJob.apply(this, arguments);
}
function previewJob(router, jobId) {
    return _previewJob.apply(this, arguments);
}
function _previewJob() {
    _previewJob = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(router, jobId) {
        var preview_url, protocol, hostnamearray, url;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            jobId = jobId || new _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .DataFromUrl */ .QJ().getJobId();
            preview_url = _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT.client.jobs.preview_job.replace */ .RQ.client.jobs.preview_job.replace("$job_id", jobId);
            protocol = window.location.protocol;
            hostnamearray = window.location.host.split(".");
            url = protocol + "//" + hostnamearray.join(".") + preview_url;
            window.open(url, "_blank");
            return [
                2
            ];
        });
    });
    return _previewJob.apply(this, arguments);
}
function todayDate(current) {
    var yesterday = moment().subtract(1, "day");
    return current.isAfter(yesterday);
}
function disableFutureDate(current) {
    var today = moment();
    return current.isBefore(today);
}
function tomorrowDate(current) {
    var yesterday = moment();
    return current.isAfter(yesterday);
}
function setFilledDate(filledDate) {
    if (filledDate != null && filledDate.includes("/")) {
        filledDate = filledDate.split("/");
        var year = parseInt(filledDate[2]);
        var month = parseInt(filledDate[1]) - 1;
        var date = parseInt(filledDate[0]);
        return new Date(year, month, date);
    } else {
        return null;
    }
}
function setDateTimeFilledDate(filledDate) {
    if (filledDate != null && filledDate.includes("/") && filledDate.includes(":")) {
        filledDate = filledDate.split(" ");
        var new_date = filledDate[0].split("/");
        var year = parseInt(new_date[2]);
        var month = parseInt(new_date[1]) - 1;
        var date = parseInt(new_date[0]);
        var new_time = filledDate[1].split(":");
        var hour = parseInt(new_time[0]);
        var min = parseInt(new_time[1]);
        return new Date(year, month, date, hour, min);
    } else {
        return null;
    }
}
function humanDateFormat(select_date) {
    var select_date = new Date(select_date);
    var month = select_date.getMonth() + 1; //months from 1-12
    var day = select_date.getDate();
    var year = select_date.getFullYear();
    var newdate = day + "/" + month + "/" + year;
    return newdate;
}
function hideDraft(editable) {
    return editable ? "" : "dnone";
}
function cursorNone(editable) {
    return editable ? "" : "cursornone";
}
function toggleDisabled(editable) {
    return editable ? "" : "toggle_disable";
}
function textDisabled(editable) {
    return editable ? "" : "text_disable";
}
function jobStatusBadge(status) {
    if (status.toLowerCase() == "active") {
        return "".concat(_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .PageStyle.ClientCompany__ActiveDot */ .k2.ClientCompany__ActiveDot);
    } else if (status.toLowerCase() == "archived") {
        return "".concat(_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .PageStyle.ClientCompany__CloseDot */ .k2.ClientCompany__CloseDot);
    }
}
function arrayEquals(a, b) {
    return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every(function(val, index) {
        return val === b[index];
    });
}
function isCorrectTime(value) {
    var time = value.replace(":", "");
    return !time.includes("-");
}
function isValidDate(value) {
    return !(value == "Invalid date");
}
function isFloat(value) {
    if (isNaN(value)) return false;
    if (value) {
        var number = Math.floor(value);
        if (value - number > 0) {
            return true;
        } else return false;
    }
}


/***/ }),

/***/ 68109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$q": function() { return /* binding */ onDragEnd; },
/* harmony export */   "D6": function() { return /* binding */ getClientUsers; },
/* harmony export */   "N$": function() { return /* binding */ getInterviewStagesData; },
/* harmony export */   "xz": function() { return /* binding */ handleFormSubmit; }
/* harmony export */ });
/* unused harmony export setToastrMessage */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34817);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77393);




function setToastrMessage(jobStages) {
    var message = "";
    jobStages === null || jobStages === void 0 ? void 0 : jobStages.map(function(stage, index) {
        if (jobStages[index].member_emails) {
            if (message.length > 0) {
                message += " </br> ";
            }
            message += "".concat(jobStages[index].member_emails);
        }
    });
    return message;
}
function handleFormSubmit(values, router, setPageName, queryClient, fromKanban, gotoKanban, setDisabledSaveButton) {
    return _handleFormSubmit.apply(this, arguments);
}
function _handleFormSubmit() {
    _handleFormSubmit = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(values, router, setPageName, queryClient, fromKanban, gotoKanban, setDisabledSaveButton) {
        var job_stages_attributes, order, result, status_code, customToastrAction, response, queryPath, _tmp, _tmp1, ref, ref1, message, ref2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setDisabledSaveButton(true);
                    job_stages_attributes = values.job.job_stages_attributes;
                    order = 2;
                    job_stages_attributes = job_stages_attributes.map(function(x, index) {
                        delete x["stage_emails"];
                        if (!x._destroy) {
                            x["order"] = order;
                            order = order + 1;
                            if (x.placeholder && x.placeholder.length > 0) {
                                if (x.job_stage_label_attributes.label.length > 0) {
                                    x.job_stage_label_attributes.label = x.job_stage_label_attributes.label;
                                } else {
                                    x.job_stage_label_attributes.label = x.placeholder;
                                }
                            }
                        }
                        return x;
                    });
                    values.job.job_stages_attributes = job_stages_attributes;
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__/* .InterviewStage */ .PU().addJobStages(values)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__/* .CustomToastrAction */ .Y5();
                    _tmp = {};
                    _tmp1 = {};
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__/* .SUCCESS_REPONSE_CODE */ .Us:
                            response = result.data;
                            queryPath = fromKanban ? "?from_kanban=true" : "";
                            if (gotoKanban) {
                                if (fromKanban) {
                                    router.push((_tmp.pathname = _imports_files_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT.client.kanban_board.replace */ .RQ.client.kanban_board.replace("$job_id", response.id), _tmp));
                                } else {
                                    router.push((_tmp1.pathname = _imports_files_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT.client.jobs.index */ .RQ.client.jobs.index, _tmp1.query = {
                                        job_type: "active"
                                    }, _tmp1));
                                }
                            } else router.push(_imports_files_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT.client.jobs.interview_details.replace */ .RQ.client.jobs.interview_details.replace("$job_id", response.id) + queryPath);
                            break;
                        case _imports_files_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            ;
                            message = setToastrMessage((ref = result.response.data.error.job) === null || ref === void 0 ? void 0 : ref.job_stages_attributes);
                            if ((ref1 = result.response.data.error.job) === null || ref1 === void 0 ? void 0 : ref1.base) {
                                ;
                                message = (0,_imports_files_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__/* .startDateMessage */ .d3)(message, (ref2 = result.response.data.error.job) === null || ref2 === void 0 ? void 0 : ref2.base);
                            }
                            if (message.length > 0) {
                                customToastrAction.setNormalToastr(message, "warning");
                            }
                            setDisabledSaveButton(false);
                            return [
                                2,
                                result.response.data.error
                            ];
                        default:
                            (0,_imports_files_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__/* .handleOtherResponseCode */ .GB)(status_code, router);
                            setDisabledSaveButton(false);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _handleFormSubmit.apply(this, arguments);
}
function getClientUsers(name_or_email, step, router) {
    return _getClientUsers.apply(this, arguments);
}
function _getClientUsers() {
    _getClientUsers = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(name_or_email, step, router) {
        var body, _tmp, result, status_code, customToastrAction, response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = (_tmp.name_or_email = name_or_email, _tmp.step = step, _tmp);
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__/* .InterviewStage */ .PU().getUserByNameOrEmail(body)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__/* .SUCCESS_REPONSE_CODE */ .Us:
                            response = result.data;
                            return [
                                2,
                                response.users
                            ];
                        case _imports_files_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            // toastr.warning(result.response.data.error)
                            return [
                                2,
                                []
                            ];
                        default:
                            (0,_imports_files_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__/* .handleOtherResponseCode */ .GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getClientUsers.apply(this, arguments);
}
function getInterviewStagesData(setApiError) {
    return _getInterviewStagesData.apply(this, arguments);
}
function _getInterviewStagesData() {
    _getInterviewStagesData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(setApiError) {
        var job_id, result, job_result, job, data, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    job_id = new _imports_files_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__/* .DataFromUrl */ .QJ().getJobId();
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__/* .InterviewStage */ .PU().getInteviewStageData(job_id)
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__/* .EditJob */ .gw().getJobInfo(job_id)
                    ];
                case 2:
                    job_result = _state.sent();
                    _tmp = {};
                    if (result.request.status == 200) {
                        job = job_result.data.job;
                        data = (_tmp.props = {
                            result: result.data,
                            job: job
                        }, _tmp);
                        return [
                            2,
                            data
                        ];
                    } else {
                        setApiError(result.request);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getInterviewStagesData.apply(this, arguments);
}
function onDragEnd(result, formRef, setDirtyArray) {
    var destination = result.destination, source = result.source;
    if (!destination) {
        return;
    }
    if (destination.droppableId === source.droppableId && destination.index === source.index) {
        return;
    }
    setDirtyArray(true);
    var add;
    var active = formRef.current.values.job.job_stages_attributes;
    // Source Logic
    if (destination.droppableId === "InterviewsList" || destination.droppableId === "ScreeningList") {
        add = active[source.index];
        active.splice(source.index, 1);
    }
    // Destination Logic
    if (destination.droppableId === "InterviewsList" || destination.droppableId === "ScreeningList") {
        active.splice(destination.index, 0, add);
    }
    formRef.current.setFieldValue("job.job_stages_attributes", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(active));
}


/***/ }),

/***/ 11007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ handleKeyDown; },
/* harmony export */   "I7": function() { return /* binding */ isJobForApproval; },
/* harmony export */   "KH": function() { return /* binding */ shouldRenderSuggestions; },
/* harmony export */   "KI": function() { return /* binding */ getActiveIds; },
/* harmony export */   "LB": function() { return /* binding */ renderUserSuggestion; },
/* harmony export */   "PR": function() { return /* binding */ getAgencyOrClientUsers; },
/* harmony export */   "Qx": function() { return /* binding */ renderInputComponent; },
/* harmony export */   "R": function() { return /* binding */ socialIcons; },
/* harmony export */   "UA": function() { return /* binding */ onUserSuggestionsFetchRequested; },
/* harmony export */   "W_": function() { return /* binding */ updateJobBoardState; },
/* harmony export */   "_v": function() { return /* binding */ onUserSuggestionsClearRequested; },
/* harmony export */   "aI": function() { return /* binding */ submitAgencyResponse; },
/* harmony export */   "d1": function() { return /* binding */ handleEmailDelete; },
/* harmony export */   "kF": function() { return /* binding */ handleJobSharingFormSubmit; },
/* harmony export */   "lU": function() { return /* binding */ getUserSuggestionValue; },
/* harmony export */   "oM": function() { return /* binding */ handleActiveJobBoard; },
/* harmony export */   "ro": function() { return /* binding */ onUserSuggestionSelection; },
/* harmony export */   "u3": function() { return /* binding */ getJobSharingData; }
/* harmony export */ });
/* unused harmony exports getAgencyUsers, isEmail, checkAgencyUserExisting */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18186);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34817);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20477);






function getActiveIds(freeJobBoards, paidJobBoards, socialSharings) {
    var active_ids = [];
    freeJobBoards.enabled.map(function(x) {
        if (x.active) active_ids.push(x.id.toString());
        return x;
    });
    paidJobBoards.enabled.map(function(x) {
        if (x.active) active_ids.push(x.id.toString());
        return x;
    });
    socialSharings.enabled.map(function(x) {
        if (x.active) active_ids.push(x.id.toString());
        return x;
    });
    return active_ids;
}
function handleActiveJobBoard(e, formik, setConfirmationModal, t) {
    var data_id = e.target.getAttribute("data-id");
    var integration_ids = formik.values.job.integration_ids;
    var data_post_type = e.target.getAttribute("data-board-type");
    if (e.target.checked && integration_ids.includes(data_id)) {
        setConfirmationModal({
            state: true,
            message: "".concat(t("modal:confirmation:activeJobBoard:active_linkedIn_jobs"), " ").concat(data_post_type == "free" ? t("modal:confirmation:activeJobBoard:premium") : t("modal:confirmation:activeJobBoard:basic"), " ").concat(t("modal:confirmation:activeJobBoard:proceed")),
            integration_id: data_id,
            data_post_type: data_post_type
        });
    }
    if (e.target.checked) {
        integration_ids.push(data_id);
        formik.setFieldValue("job.linkedin_post_type", data_post_type);
    } else {
        var index = integration_ids.indexOf(data_id);
        integration_ids.splice(index, 1);
    }
}
var updateJobBoardState = function(formRef, checkboxRefs, valueToUncheck, currentPostType, indexToSplice) {
    var integration_ids = formRef.current.values.job.integration_ids;
    var index = integration_ids.indexOf(indexToSplice);
    if (index !== -1) {
        integration_ids.splice(index, 1);
    }
    formRef.current.setFieldValue("job.integration_ids", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(integration_ids));
    formRef.current.setFieldValue("job.linkedin_post_type", currentPostType);
    if (checkboxRefs.current["".concat(valueToUncheck, "_").concat(indexToSplice)]) {
        checkboxRefs.current["".concat(valueToUncheck, "_").concat(indexToSplice)].checked = false;
    }
};
function socialIcons(integration_name) {
    var image = "";
    switch(integration_name){
        case "facebook":
            image = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Ee, {
                src: _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__.Fb,
                alt: ""
            });
            break;
        case "linkedin_feed_post":
            image = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Ee, {
                src: _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__.Li,
                alt: ""
            });
            break;
        case "twitter":
            image = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Ee, {
                src: _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .Twi */ .sQ,
                alt: ""
            });
            break;
    }
    return image;
}
function handleJobSharingFormSubmit(params, router1, setPageNamem, queryClient, setJobLivePopup, setJobSlug, setClientSlug, setJobTitle, showLivePopup, fromKanban, setDisabledSaveButton, jobForApprove, t) {
    return _handleJobSharingFormSubmit.apply(this, arguments);
}
function _handleJobSharingFormSubmit() {
    _handleJobSharingFormSubmit = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(params, router1, setPageNamem, queryClient, setJobLivePopup, setJobSlug, setClientSlug, setJobTitle, showLivePopup, fromKanban, setDisabledSaveButton, jobForApprove, t) {
        var job_id, result, status_code, customToastrAction, response, _tmp, ref, message, ref1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setDisabledSaveButton(true);
                    job_id = new _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .DataFromUrl */ .QJ().getJobId();
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .JobSharing */ .ww().addJobBoards(params, job_id)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    _tmp = {};
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            response = result.data;
                            // TODO:- Remove the jobdata cache when the redirection is set
                            // toastr.success(response.success)
                            setJobSlug(response.slug);
                            setClientSlug(response.client_slug);
                            setJobTitle(response.job_title);
                            if (showLivePopup && !jobForApprove) {
                                setJobLivePopup(true);
                                setDisabledSaveButton(false);
                            } else {
                                if (jobForApprove) {
                                    customToastrAction.setNormalToastr(response.success);
                                    router1.push(router1.push((_tmp.pathname = _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.jobs.index */ .RQ.client.jobs.index, _tmp.query = {
                                        job_type: "active"
                                    }, _tmp)));
                                } else {
                                    customToastrAction.setNormalToastr("".concat(response.job_title, " ").concat(t("jobs:update_message")), "success");
                                }
                                //  toastr.success(`${response.job_title}  is updated successfully.`)
                                if (fromKanban) {
                                    setTimeout(function() {
                                        return router1.push({
                                            pathname: _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.kanban_board.replace */ .RQ.client.kanban_board.replace("$job_id", job_id)
                                        });
                                    }, 50);
                                } else {
                                    setTimeout(function() {
                                        return router1.push({
                                            pathname: _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.jobs.index */ .RQ.client.jobs.index,
                                            query: {
                                                job_type: "active"
                                            }
                                        });
                                    }, 50);
                                }
                            }
                            break;
                        case _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            ;
                            message = "";
                            if ((ref = result.response.data.error.job) === null || ref === void 0 ? void 0 : ref.base) {
                                ;
                                message = (0,_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .startDateMessage */ .d3)(message, (ref1 = result.response.data.error.job) === null || ref1 === void 0 ? void 0 : ref1.base);
                            }
                            if (message.length > 0) {
                                customToastrAction.setNormalToastr(message, "warning");
                            }
                            setDisabledSaveButton(false);
                            break;
                        default:
                            (0,_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router1);
                            setDisabledSaveButton(false);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _handleJobSharingFormSubmit.apply(this, arguments);
}
function getJobSharingData(router1, setApiError) {
    return _getJobSharingData.apply(this, arguments);
}
function _getJobSharingData() {
    _getJobSharingData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(router1, setApiError) {
        var job_id, result, status_code, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    job_id = new _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .DataFromUrl */ .QJ().getJobId();
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .JobSharing */ .ww().getJobBoards(job_id)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    if (result.request.status == 200) {
                        return [
                            2,
                            result.data
                        ];
                    } else {
                        setApiError(result.request);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getJobSharingData.apply(this, arguments);
}
function getAgencyUsers(name_or_email, router1, domain) {
    return _getAgencyUsers.apply(this, arguments);
}
function _getAgencyUsers() {
    _getAgencyUsers = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(name_or_email, router1, domain) {
        var body, _tmp, result, status_code, customToastrAction, response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = (_tmp.name_or_email = name_or_email, _tmp.domain = domain, _tmp);
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .JobSharing */ .ww().getUserByNameOrEmail(body)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            response = result.data;
                            return [
                                2,
                                response.users
                            ];
                        case _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            return [
                                2,
                                []
                            ];
                        default:
                            (0,_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router1);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getAgencyUsers.apply(this, arguments);
}
function getAgencyOrClientUsers(name_or_email, router1, domain) {
    return _getAgencyOrClientUsers.apply(this, arguments);
}
function _getAgencyOrClientUsers() {
    _getAgencyOrClientUsers = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(name_or_email, router1, domain) {
        var body, _tmp, result, status_code, customToastrAction, response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = (_tmp.name_or_email = name_or_email, _tmp.domain = domain, _tmp);
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .JobSharing */ .ww().getAgencyOrClientUserByNameOrEmail(body)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            response = result.data;
                            return [
                                2,
                                response.users
                            ];
                        case _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            return [
                                2,
                                []
                            ];
                        default:
                            (0,_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router1);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getAgencyOrClientUsers.apply(this, arguments);
}
function shouldRenderSuggestions(value) {
    return value.trim().length >= 3;
}
var renderInputComponent = function(inputProps) {
    var ref;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "buttonIn AutoSuggestInput__Tags",
        children: [
            (ref = inputProps.selectedValues) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Tagrow__Tags */ .k2.Tagrow__Tags,
                    children: [
                        item.name ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: item.name
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: item.email
                        }),
                        inputProps.editable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "button",
                            className: _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Tagrow__Cancel */ .k2.Tagrow__Cancel,
                            onClick: function() {
                                if (inputProps.initialAgencyUserEmails.includes(item.email)) {
                                    inputProps.setConfirmation({
                                        state: true,
                                        formik: inputProps.formik,
                                        index: inputProps.index
                                    });
                                } else {
                                    inputProps.handleEmailDelete(inputProps.formik, inputProps.index);
                                }
                            },
                            children: inputProps.closeIcon
                        })
                    ]
                }, "agency_user_".concat(index));
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                className: _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input */ .k2.Form__Input,
                autoComplete: "password"
            }, inputProps)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                buttonstyle: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.nobgbutton */ .ZJ.nobgbutton, " addbtn ").concat((0,_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .cursorNone */ .y$)(inputProps.editable)),
                disabled: inputProps.disabled,
                onClick: function() {
                    return onAddClick(event, inputProps);
                },
                children: inputProps.t("button:add:default")
            })
        ]
    });
};
function getUserSuggestionValue(suggestion) {
    return "".concat(suggestion.user_attributes.email);
}
function showSuggestion(suggestion) {
    if (suggestion.user_attributes.name && suggestion.user_attributes.email.length > 0) {
        return "".concat(suggestion.user_attributes.name, " | ").concat(suggestion.user_attributes.email);
    } else if (suggestion.user_attributes.name) {
        return "".concat(suggestion.user_attributes.name);
    } else {
        return "".concat(suggestion.user_attributes.email);
    }
}
function renderUserSuggestion(suggestion) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: showSuggestion(suggestion)
    });
}
function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function getUserSuggestions(value, router1) {
    return _getUserSuggestions.apply(this, arguments);
}
function _getUserSuggestions() {
    _getUserSuggestions = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(value, router1) {
        var escapedValue, finalUsers;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    escapedValue = escapeRegexCharacters(value === null || value === void 0 ? void 0 : value.trim());
                    if (escapedValue === "") {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        4,
                        getAgencyUsers(escapedValue, router1)
                    ];
                case 1:
                    finalUsers = _state.sent();
                    return [
                        2,
                        finalUsers
                    ];
            }
        });
    });
    return _getUserSuggestions.apply(this, arguments);
}
function onUserSuggestionsFetchRequested(hash, setUsers) {
    return _onUserSuggestionsFetchRequested.apply(this, arguments);
}
function _onUserSuggestionsFetchRequested() {
    _onUserSuggestionsFetchRequested = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(hash, setUsers) {
        var users;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getUserSuggestions(hash.value)
                    ];
                case 1:
                    users = _state.sent();
                    setUsers(users);
                    return [
                        2
                    ];
            }
        });
    });
    return _onUserSuggestionsFetchRequested.apply(this, arguments);
}
;
var onUserSuggestionsClearRequested = function(setUsers) {
    setUsers([]);
};
function isEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@\.]+$/.test(email);
}
function onUserSuggestionSelection(formik, old_emails, email, old_initials, new_initial) {
    if (isEmail(email) && !old_emails.includes(email)) {
        old_emails.unshift(email);
        old_initials.unshift(new_initial);
    }
}
function handleKeyDown(evt, formik, setAgencyUserEmail, setAgencyUserError, t, params) {
    return _handleKeyDown.apply(this, arguments);
}
function _handleKeyDown() {
    _handleKeyDown = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(evt, formik, setAgencyUserEmail, setAgencyUserError, t, params) {
        var email, data, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (![
                        "Enter"
                    ].includes(evt.key)) return [
                        3,
                        3
                    ];
                    evt.preventDefault();
                    email = evt.target.value;
                    if (!isEmail(email)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        checkAgencyUserExisting(email)
                    ];
                case 1:
                    data = _state.sent();
                    _tmp = {};
                    _tmp1 = {};
                    if (data.new_user) {
                        params.setAddAgencyModal((_tmp.state = true, _tmp.data = {
                            onUserSuggestionSelection: onUserSuggestionSelection,
                            params: params
                        }, _tmp));
                    } else {
                        {
                            if (!data.deactivated_agency) onUserSuggestionSelection(params.formik, params.formik.values.job.agency_user_emails, email, params.formik.values.job.agency_user_initials, (_tmp1.email = email, _tmp1.name_initials = null, _tmp1.name = null, _tmp1));
                            params.setAgencyUserEmail("");
                        }
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    setAgencyUserError(t("errors:autocomplete_invalid_email"));
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _handleKeyDown.apply(this, arguments);
}
var onAddClick = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(event1, params) {
        var email, data, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    email = params.value;
                    if (!isEmail(email)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        checkAgencyUserExisting(email)
                    ];
                case 1:
                    data = _state.sent();
                    _tmp = {};
                    _tmp1 = {};
                    if (data.new_user) {
                        params.setAddAgencyModal((_tmp.state = true, _tmp.data = {
                            onUserSuggestionSelection: onUserSuggestionSelection,
                            params: params
                        }, _tmp));
                    } else {
                        {
                            if (!data.deactivated_agency) onUserSuggestionSelection(params.formik, params.formik.values.job.agency_user_emails, email, params.formik.values.job.agency_user_initials, (_tmp1.email = email, _tmp1.name_initials = null, _tmp1.name = null, _tmp1));
                            params.setAgencyUserEmail("");
                        }
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    params.setAgencyUserError(params.t("errors:autocomplete_invalid_email"));
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function onAddClick(event1, params) {
        return _ref.apply(this, arguments);
    };
}();
function checkAgencyUserExisting(email) {
    return _checkAgencyUserExisting.apply(this, arguments);
}
function _checkAgencyUserExisting() {
    _checkAgencyUserExisting = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(email) {
        var body, _tmp, result, status_code, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = (_tmp.email = email, _tmp);
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .JobSharing */ .ww().checkAgencyUserExist(body)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            return [
                                2,
                                result.data
                            ];
                        case _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            return [
                                2,
                                result.response.data
                            ];
                        default:
                            (0,_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _checkAgencyUserExisting.apply(this, arguments);
}
function submitAgencyResponse(params, addAgencyModal, setAddAgencyModal, job_id) {
    return _submitAgencyResponse.apply(this, arguments);
}
function _submitAgencyResponse() {
    _submitAgencyResponse = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(params, addAgencyModal, setAddAgencyModal, job_id) {
        var body, result, status_code, customToastrAction, _tmp, _tmp1, _tmp2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params.user_email = addAgencyModal.data.params.value;
                    params.job_id = job_id;
                    body = params;
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .JobSharing */ .ww().addAgencyUserResponse(body, job_id)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    _tmp = {};
                    _tmp1 = {};
                    _tmp2 = {};
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            addAgencyModal.data.onUserSuggestionSelection(addAgencyModal.data.params.formik, addAgencyModal.data.params.formik.values.job.agency_user_emails, body.user_email, addAgencyModal.data.params.formik.values.job.agency_user_initials, (_tmp.email = body.user_email, _tmp.name_initials = null, _tmp.name = null, _tmp));
                            addAgencyModal.data.params.setAgencyUserEmail("");
                            setAddAgencyModal((_tmp1.state = false, _tmp1.data = {}, _tmp1));
                            customToastrAction.setNormalToastr(result.data.success, "success");
                        case _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            setAddAgencyModal((_tmp2.state = false, _tmp2.data = {}, _tmp2));
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                        default:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            (0,_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _submitAgencyResponse.apply(this, arguments);
}
function handleEmailDelete(formik, itemIndex) {
    var emails = formik.values.job.agency_user_emails;
    var name_initials = formik.values.job.agency_user_initials;
    emails.splice(itemIndex, 1);
    name_initials.splice(itemIndex, 1);
    formik.setFieldValue("job.agency_user_emails", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(emails));
    formik.setFieldValue("job.agency_user_initials", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(name_initials));
}
function isJobForApproval(data) {
    return data.job_status != "Published" && data.required_approvers != 0;
}


/***/ }),

/***/ 98303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ getColumnsName; },
/* harmony export */   "DO": function() { return /* binding */ handleFilterClick; },
/* harmony export */   "Dg": function() { return /* binding */ handlePageChange; },
/* harmony export */   "LQ": function() { return /* binding */ openJobOptions; },
/* harmony export */   "Ni": function() { return /* binding */ isJobFilterApplied; },
/* harmony export */   "Rb": function() { return /* binding */ applyFilter; },
/* harmony export */   "Sv": function() { return /* binding */ closeAllJobsOptions; },
/* harmony export */   "Vm": function() { return /* binding */ closeEditJobModal; },
/* harmony export */   "XG": function() { return /* binding */ setDataTableClass; },
/* harmony export */   "YR": function() { return /* binding */ emailVerifiedOrNot; },
/* harmony export */   "_V": function() { return /* binding */ handlePerRowsSorting; },
/* harmony export */   "az": function() { return /* binding */ getJobListingData; },
/* harmony export */   "fC": function() { return /* binding */ changeJobTypeFilterData; },
/* harmony export */   "k3": function() { return /* binding */ retryJobOnJobBoard; },
/* harmony export */   "op": function() { return /* binding */ dismissJobOnJobBoard; },
/* harmony export */   "rU": function() { return /* binding */ changeSearchFilterData; },
/* harmony export */   "vW": function() { return /* binding */ handlePerRowsChange; }
/* harmony export */ });
/* unused harmony exports allJobFilterData, adminDatTableColumns, clientDatTableColumns, adminActiveColumns, adminDraftColumns, adminArcheivedColumns, clientUserActiveColumns, clientUserDraftColumns, clientUserArcheivedColumns, goToEditJob, warningPopUp, onSelectJob, selectAllBoard, changeDelay, goToApprovalRequest, setJobApplicationStatus, openInfoModal */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_components_job_filters__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29774);
/* harmony import */ var _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44791);
/* harmony import */ var _admins_dashboard_clients_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33399);
/* harmony import */ var react_simple_tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54392);
/* harmony import */ var _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51895);
/* harmony import */ var _constants_common_internationalisation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44052);










function getJobListingData(params, setApiError) {
    return _getJobListingData.apply(this, arguments);
}
function _getJobListingData() {
    _getJobListingData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(params, setApiError) {
        var body, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    body = params;
                    if (body.job_type == "draft") {
                        body.all_jobs = false;
                    }
                    body.job_type = body.job_type.toLowerCase();
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .JobListing */ .DT().getJobListingData(body)
                    ];
                case 1:
                    result = _state.sent();
                    setApiError(result.request);
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _getJobListingData.apply(this, arguments);
}
function handlePerRowsSorting(router, column, sortDirection, setJobList, setFiltersValue, setApiError) {
    return _handlePerRowsSorting.apply(this, arguments);
}
function _handlePerRowsSorting() {
    _handlePerRowsSorting = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(router, column, sortDirection, setJobList, setFiltersValue, setApiError) {
        var param_list, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    param_list = router.query;
                    param_list.col_name = column.sortField;
                    param_list.order = sortDirection;
                    (0,_admins_dashboard_clients_common__WEBPACK_IMPORTED_MODULE_3__/* .addParamsToUrl */ .Sr)(param_list, router);
                    return [
                        4,
                        getJobListingData(param_list, setApiError)
                    ];
                case 1:
                    result = _state.sent();
                    setApiError(result.request);
                    setJobList(result.data);
                    setFiltersValue(param_list);
                    return [
                        2
                    ];
            }
        });
    });
    return _handlePerRowsSorting.apply(this, arguments);
}
function handlePerRowsChange(router, per_page, setJobList, setFiltersValue, setApiError) {
    return _handlePerRowsChange.apply(this, arguments);
}
function _handlePerRowsChange() {
    _handlePerRowsChange = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(router, per_page, setJobList, setFiltersValue, setApiError) {
        var param_list, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    param_list = router.query;
                    param_list.per_page = per_page;
                    (0,_admins_dashboard_clients_common__WEBPACK_IMPORTED_MODULE_3__/* .addParamsToUrl */ .Sr)(param_list, router);
                    return [
                        4,
                        getJobListingData(param_list, setApiError)
                    ];
                case 1:
                    result = _state.sent();
                    setApiError(result.request);
                    setJobList(result.data);
                    setFiltersValue(param_list);
                    return [
                        2
                    ];
            }
        });
    });
    return _handlePerRowsChange.apply(this, arguments);
}
function handlePageChange(router, page_number, setJobList, setFiltersValue, setApiError) {
    return _handlePageChange.apply(this, arguments);
}
function _handlePageChange() {
    _handlePageChange = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(router, page_number, setJobList, setFiltersValue, setApiError) {
        var param_list, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    param_list = router.query;
                    param_list.page = page_number;
                    (0,_admins_dashboard_clients_common__WEBPACK_IMPORTED_MODULE_3__/* .addParamsToUrl */ .Sr)(param_list, router);
                    return [
                        4,
                        getJobListingData(param_list, setApiError)
                    ];
                case 1:
                    result = _state.sent();
                    setApiError(result.request);
                    setJobList(result.data);
                    setFiltersValue(param_list);
                    return [
                        2
                    ];
            }
        });
    });
    return _handlePageChange.apply(this, arguments);
}
function changeJobTypeFilterData(event, setJobList, setFiltersValue, router, setApiError, setDatatableLoading) {
    return _changeJobTypeFilterData.apply(this, arguments);
}
function _changeJobTypeFilterData() {
    _changeJobTypeFilterData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(event, setJobList, setFiltersValue, router, setApiError, setDatatableLoading) {
        var param_list, _tmp, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setDatatableLoading(true);
                    _tmp = {};
                    param_list = (_tmp.job_type = event.target.value.toLowerCase(), _tmp);
                    setFiltersValue(param_list);
                    document.querySelector("#jobSearch").value = "";
                    (0,_admins_dashboard_clients_common__WEBPACK_IMPORTED_MODULE_3__/* .addParamsToUrl */ .Sr)(param_list, router);
                    return [
                        4,
                        getJobListingData(param_list, setApiError)
                    ];
                case 1:
                    result = _state.sent();
                    setApiError(result.request);
                    setJobList(result.data);
                    setDatatableLoading(false);
                    return [
                        2
                    ];
            }
        });
    });
    return _changeJobTypeFilterData.apply(this, arguments);
}
function allJobFilterData(event, setJobList, setFiltersValue, router, setApiError) {
    return _allJobFilterData.apply(this, arguments);
}
function _allJobFilterData() {
    _allJobFilterData = _async_to_generator(function(event, setJobList, setFiltersValue, router, setApiError) {
        var previous_job_filter, result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    previous_job_filter = router.query;
                    previous_job_filter.all_jobs = event.target.checked;
                    localStorage.setItem("jobs_toggle", event.target.checked);
                    setJobFilter(previous_job_filter);
                    setFiltersValue(previous_job_filter);
                    return [
                        4,
                        getJobListingData(previous_job_filter, setApiError)
                    ];
                case 1:
                    result = _state.sent();
                    setApiError(result.request);
                    setJobList(result.data);
                    return [
                        2
                    ];
            }
        });
    });
    return _allJobFilterData.apply(this, arguments);
}
function changeSearchFilterData(event, setJobList, setFiltersValue, router, setApiError) {
    return _changeSearchFilterData.apply(this, arguments);
}
function _changeSearchFilterData() {
    _changeSearchFilterData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(event, setJobList, setFiltersValue, router, setApiError) {
        var param_list, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    param_list = router.query;
                    param_list.search_text = event.target.value;
                    param_list.search_text == "" ? delete param_list.search_text : "";
                    (0,_admins_dashboard_clients_common__WEBPACK_IMPORTED_MODULE_3__/* .addParamsToUrl */ .Sr)(param_list, router);
                    return [
                        4,
                        getJobListingData(param_list, setApiError)
                    ];
                case 1:
                    result = _state.sent();
                    setApiError(result.request);
                    setJobList(result.data);
                    setFiltersValue(param_list);
                    return [
                        2
                    ];
            }
        });
    });
    return _changeSearchFilterData.apply(this, arguments);
}
function handleFilterClick(event, job_filter, setJobFilter) {
    return _handleFilterClick.apply(this, arguments);
}
function _handleFilterClick() {
    _handleFilterClick = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(event, job_filter, setJobFilter) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            if (event.target.classList.contains("") || !event.target.closest(".JobFilter")) {
                job_filter == "Close" ? setJobFilter("Open") : setJobFilter("Close");
            }
            return [
                2
            ];
        });
    });
    return _handleFilterClick.apply(this, arguments);
}
function applyFilter(setFiltersValue, setModal, setJobList, startDate, endDate, location, router, setApiError, agency_user_emails, agency_user_initials) {
    return _applyFilter.apply(this, arguments);
}
function _applyFilter() {
    _applyFilter = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(setFiltersValue, setModal, setJobList, startDate, endDate, location, router, setApiError, agency_user_emails, agency_user_initials) {
        var commonAction, new_startDate, new_endDate, param_list, result, customToastrAction;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    commonAction = new _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .CommonAction */ .x4();
                    new_startDate = typeof startDate == "string" ? commonAction.changeDateFormatToYearMonthDay(startDate) : startDate;
                    new_endDate = typeof endDate == "string" ? commonAction.changeDateFormatToYearMonthDay(endDate) : endDate;
                    if (startDate && endDate && (0,_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .moment */ ._7)(new_startDate).startOf("day").isAfter(new_endDate)) {
                        document.querySelector(".filterStartDate").innerHTML = "Date from should be lesser than date to";
                        document.querySelector(".FilterCustomStartDate input").style.border = "1px solid red";
                        return [
                            2
                        ]; // Return because date field has error
                    }
                    if (!(startDate && endDate && (0,_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .moment */ ._7)(new_startDate).isSameOrBefore(new_endDate) || startDate || endDate || (location === null || location === void 0 ? void 0 : location.length) > 0 || agency_user_emails.length > 0)) return [
                        3,
                        2
                    ];
                    param_list = router.query;
                    param_list.start_date = typeof startDate == "object" && startDate != null ? (0,_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .moment */ ._7)(startDate).format("DD/MM/YYYY") : startDate || "";
                    param_list.end_date = typeof endDate == "object" && endDate != null ? (0,_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .moment */ ._7)(endDate).format("DD/MM/YYYY") : endDate || "";
                    param_list.location = location != "" ? location : "";
                    param_list.agency_user_emails = agency_user_emails.length > 0 ? agency_user_emails : "";
                    param_list.agency_user_names = agency_user_initials.length > 0 ? agency_user_initials.map(function(x) {
                        return x.name;
                    }) : "";
                    param_list.agency_user_photo_urls = agency_user_initials.length > 0 ? agency_user_initials.map(function(x) {
                        return x.photo_url;
                    }) : "";
                    param_list.agency_user_name_initials = agency_user_initials.length > 0 ? agency_user_initials.map(function(x) {
                        return x.name_initials;
                    }) : "";
                    (0,_admins_dashboard_clients_common__WEBPACK_IMPORTED_MODULE_3__/* .addParamsToUrl */ .Sr)(param_list, router);
                    return [
                        4,
                        getJobListingData(param_list, setApiError)
                    ];
                case 1:
                    result = _state.sent();
                    setApiError(result.request);
                    setJobList(result.data);
                    setFiltersValue(param_list);
                    setModal("Close");
                    return [
                        3,
                        3
                    ];
                case 2:
                    customToastrAction = new _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .CustomToastrAction */ .Y5();
                    customToastrAction.setNormalToastr((0,_constants_common_internationalisation__WEBPACK_IMPORTED_MODULE_6__/* .TRANSLATION */ .T)("modal:filter:select_some"), "warning");
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _applyFilter.apply(this, arguments);
}
function openJobOptions(event) {
    event.stopPropagation();
    var dots_element = event.currentTarget.querySelector(".Dots");
    var element = event.currentTarget.querySelector(".JobActionOptions");
    if (dots_element.classList.contains("Close")) {
        closeAllJobsOptions();
        element.classList.remove("Close");
        element.classList.add("Open");
        dots_element.classList.remove("Close");
        dots_element.classList.add("Open");
    } else {
        closeAllJobsOptions();
        element.classList.remove("Open");
        element.classList.add("Close");
        dots_element.classList.remove("Open");
        dots_element.classList.add("Close");
    }
}
function closeAllJobsOptions() {
    var element = document.querySelector(".JobActionOptions.Open");
    var dots_element = document.querySelector(".Dots.Open");
    if (element) {
        element.classList.remove("Open");
        element.classList.add("Close");
        dots_element.classList.remove("Open");
        dots_element.classList.add("Close");
    }
}
function getColumnsName(userRole, setPageName, setJobList, setjobEditModal, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, router, setApiError, setJobCloseModal, session, setInfoModal, t, setPendingDashboardList, setJobApprovalData) {
    var jobType = router.query.job_type;
    if (userRole == "client_admin" || userRole == "account_owner" || userRole == "Administrator") {
        return adminDatTableColumns(jobType, setPageName, setJobList, setjobEditModal, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, router, setApiError, setJobCloseModal, session, setInfoModal, t, setPendingDashboardList, setJobApprovalData);
    } else {
        return clientDatTableColumns(jobType, setPageName, setJobList, setjobEditModal, router, setApiError, setJobCloseModal, session, setInfoModal, t);
    }
}
function adminDatTableColumns(jobType, setPageName, setJobList, setjobEditModal, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, router, setApiError, setJobCloseModal, session, setInfoModal, t, setPendingDashboardList, setJobApprovalData) {
    switch(jobType){
        case "active":
            return adminActiveColumns(setPageName, setJobList, setjobEditModal, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, router, setApiError, setJobCloseModal, session, setInfoModal, t, setPendingDashboardList, setJobApprovalData);
        case "draft":
            return adminDraftColumns(setPageName, setJobList, setjobEditModal, router, setApiError, session, t);
        case "archived":
            return adminArcheivedColumns(setPageName, setJobList, setjobEditModal, router, setApiError, session, t);
        default:
            "";
    }
}
function clientDatTableColumns(jobType, setPageName, setJobList, setjobEditModal, router, setApiError, setJobCloseModal, session, setInfoModal, t) {
    switch(jobType){
        case "active":
            return clientUserActiveColumns(setPageName, setJobList, setjobEditModal, router, setApiError, setJobCloseModal, session, t);
        case "draft":
            return clientUserDraftColumns(setPageName, setJobList, setjobEditModal, router, setApiError, session, t);
        case "archived":
            return clientUserArcheivedColumns(setPageName, setJobList, setjobEditModal, router, setApiError, session, t);
        default:
            "";
    }
}
function adminActiveColumns(setPageName, setJobList, setjobEditModal, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, router, setApiError, setJobCloseModal, session, setInfoModal, t, setPendingDashboardList, setJobApprovalData) {
    var activeColumns = [
        {
            name: t("datatable:job"),
            selector: function(row) {
                var link = "";
                if (row.job_type == "active" || row.job_type == "archived") {
                    link = _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .REDIRECT.client.kanban_board.replace */ .RQ.client.kanban_board.replace("$job_id", row.id);
                } else {
                    link = _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .REDIRECT.client.jobs.edit.replace */ .RQ.client.jobs.edit.replace("$job_id", row.id);
                }
                return linkWithTitle(row.title, link, router);
            },
            sortable: true,
            sortField: "title"
        },
        {
            name: t("datatable:applicants"),
            selector: function(row) {
                return row.applicants || 0;
            },
            sortable: true,
            sortField: "applicants",
            className: "Datatable_Applicants"
        },
        {
            name: t("datatable:agency"),
            selector: function(row) {
                return row.agency;
            }
        },
        {
            name: t("datatable:created"),
            selector: function(row) {
                return row.created_at;
            },
            sortable: true,
            sortField: "created_at"
        },
        {
            name: t("datatable:last_updated"),
            selector: function(row) {
                return row.updated_at;
            },
            sortable: true,
            sortField: "updated_at"
        },
        {
            name: t("datatable:hiring_manager(s)"),
            selector: function(row) {
                return row.hiring_managers.map(function(element, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "JobSection",
                        children: [
                            (element === null || element === void 0 ? void 0 : element.photo_url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: element === null || element === void 0 ? void 0 : element.photo_url,
                                className: "JobImage"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "JobInitial",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: element.initials ? element.initials : "?"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "JobName",
                                children: [
                                    "  ",
                                    element.name,
                                    " "
                                ]
                            })
                        ]
                    }, "hiring_manager_initials_".concat(index));
                });
            },
            sortable: true,
            sortField: "job_creator"
        },
        {
            name: t("datatable:job_owner(s)"),
            selector: function(row) {
                return row.job_owners.map(function(element, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "JobSection",
                        children: [
                            (element === null || element === void 0 ? void 0 : element.photo_url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: element === null || element === void 0 ? void 0 : element.photo_url,
                                className: "JobImage"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "JobInitial",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: element.initials ? element.initials : "?"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "JobName",
                                children: [
                                    "  ",
                                    element.name,
                                    " "
                                ]
                            })
                        ]
                    }, "job_owner_initials_".concat(index));
                });
            },
            sortable: true,
            sortField: "job_creator"
        },
        {
            name: t("datatable:status"),
            selector: function(row) {
                return setJobApplicationStatus(row, setInfoModal, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, t, setPendingDashboardList, setJobApprovalData);
            },
            sortable: false,
            sortField: ""
        },
        {
            name: "",
            selector: function(row) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "DotsOptions",
                    onClick: function(event) {
                        return openJobOptions(event);
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .Dots */ .bb, {
                            className: "Dots Close"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .JobActionOptions */ .Fb, {
                            options: (0,_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .ACTION_OPTIONS */ .Z9)(),
                            job_id: row.id,
                            setPageName: setPageName,
                            slug: row.slug,
                            setJobList: setJobList,
                            setjobEditModal: setjobEditModal,
                            rowData: row,
                            closeAllJobsOptions: closeAllJobsOptions,
                            setApiError: setApiError,
                            setJobCloseModal: setJobCloseModal,
                            title: row.title,
                            session: session
                        })
                    ]
                });
            }
        }
    ];
    if (router.query.attention_token) {
        activeColumns.splice(5, 0, {
            name: t("datatable:comment"),
            selector: function(row) {
                return t("jobs:jobs_comment:".concat(row.attention_comment)) || "-";
            }
        });
    }
    return activeColumns;
}
function adminDraftColumns(setPageName, setJobList, setjobEditModal, router, setApiError, session, t) {
    return [
        {
            name: t("datatable:job"),
            selector: function(row) {
                var ref;
                var link = (ref = (0,_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .ACTION_OPTIONS */ .Z9)().edit_job) === null || ref === void 0 ? void 0 : ref.link.replace("$job_id", row.id);
                return linkWithTitle(row.title, link, router);
            },
            sortable: true,
            sortField: "title"
        },
        {
            name: t("datatable:agency"),
            selector: function(row) {
                return row.agency;
            }
        },
        {
            name: t("datatable:created"),
            selector: function(row) {
                return row.created_at;
            },
            sortable: true,
            sortField: "created_at"
        },
        {
            name: t("datatable:last_updated"),
            selector: function(row) {
                return row.updated_at;
            },
            sortable: true,
            sortField: "updated_at"
        },
        {
            name: t("datatable:job_owner(s)"),
            selector: function(row) {
                return row.job_owners.map(function(element, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "JobSection",
                        children: [
                            (element === null || element === void 0 ? void 0 : element.photo_url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: element === null || element === void 0 ? void 0 : element.photo_url,
                                className: "JobImage"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "JobInitial",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: element.initials ? element.initials : "?"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "JobName",
                                children: [
                                    "  ",
                                    element.name,
                                    " "
                                ]
                            })
                        ]
                    }, "job_owner_initials_".concat(index));
                });
            },
            sortable: true,
            sortField: "job_creator"
        },
        {
            name: "",
            selector: function(row) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "DotsOptions",
                    onClick: function(event) {
                        return openJobOptions(event);
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .Dots */ .bb, {
                            className: "Dots Close"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .JobActionOptions */ .Fb, {
                            options: (0,_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .ACTION_OPTIONS */ .Z9)(),
                            job_id: row.id,
                            setPageName: setPageName,
                            slug: row.slug,
                            setJobList: setJobList,
                            publishable: row.publishable,
                            setjobEditModal: setjobEditModal,
                            closeAllJobsOptions: closeAllJobsOptions,
                            setApiError: setApiError,
                            session: session
                        })
                    ]
                });
            }
        }
    ];
}
function adminArcheivedColumns(setPageName, setJobList, setjobEditModal, router, setApiError, session, t) {
    return [
        {
            name: t("datatable:job"),
            selector: function(row) {
                var link = _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .REDIRECT.client.kanban_board.replace */ .RQ.client.kanban_board.replace("$job_id", row.id);
                return linkWithTitle(row.title, link, router);
            },
            sortable: true,
            sortField: "title"
        },
        {
            name: t("datatable:applicants"),
            selector: function(row) {
                return row.applicants || 0;
            },
            sortable: true,
            sortField: "applicants"
        },
        {
            name: t("datatable:agency"),
            selector: function(row) {
                return row.agency;
            }
        },
        {
            name: t("datatable:hired"),
            selector: function(row) {
                return row.hired || 0;
            },
            sortable: true,
            sortField: ""
        },
        {
            name: t("datatable:created"),
            selector: function(row) {
                return row.created_at;
            },
            sortable: true,
            sortField: "created_at"
        },
        {
            name: t("datatable:archived"),
            selector: function(row) {
                return row.archived_at;
            },
            sortable: true,
            sortField: "archived_at"
        },
        {
            name: t("datatable:job_owner(s)"),
            selector: function(row) {
                return row.job_owners.map(function(element, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "JobSection",
                        children: [
                            (element === null || element === void 0 ? void 0 : element.photo_url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: element === null || element === void 0 ? void 0 : element.photo_url,
                                className: "JobImage"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "JobInitial",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: element.initials ? element.initials : "?"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "JobName",
                                children: [
                                    "  ",
                                    element.name,
                                    " "
                                ]
                            })
                        ]
                    }, "job_owner_initials_".concat(index));
                });
            },
            sortable: true,
            sortField: "job_creator"
        },
        {
            name: "",
            selector: function(row) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "DotsOptions",
                    onClick: function(event) {
                        return openJobOptions(event);
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .Dots */ .bb, {
                            className: "Dots Close"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .JobActionOptions */ .Fb, {
                            options: (0,_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .ACTION_OPTIONS */ .Z9)(),
                            job_id: row.id,
                            setPageName: setPageName,
                            slug: row.slug,
                            setJobList: setJobList,
                            setjobEditModal: setjobEditModal,
                            closeAllJobsOptions: closeAllJobsOptions,
                            setApiError: setApiError,
                            session: session
                        })
                    ]
                });
            }
        }
    ];
}
function clientUserActiveColumns(setPageName, setJobList, setjobEditModal, router, setApiError, setJobCloseModal, session, t) {
    var activeColumns = [
        {
            name: t("datatable:job"),
            selector: function(row) {
                var link = "";
                // var link = REDIRECT.client.kanban_board.replace('$job_id', row.id);
                if (row.job_type == "active" || row.job_type == "archived") {
                    link = _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .REDIRECT.client.kanban_board.replace */ .RQ.client.kanban_board.replace("$job_id", row.id);
                } else {
                    link = _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .REDIRECT.client.jobs.edit.replace */ .RQ.client.jobs.edit.replace("$job_id", row.id);
                }
                return linkWithTitle(row.title, link, router);
            },
            sortable: true,
            sortField: "title"
        },
        {
            name: t("datatable:sourced"),
            selector: function(row) {
                return row.sourced;
            },
            sortable: true,
            sortField: "sourced"
        },
        {
            name: t("datatable:applied"),
            selector: function(row) {
                return row.applied;
            },
            sortable: true,
            sortField: "applied"
        },
        {
            name: t("datatable:screening"),
            selector: function(row) {
                return row.screening;
            },
            sortable: true,
            sortField: "screening"
        },
        {
            name: t("datatable:interview"),
            selector: function(row) {
                return row.interview;
            },
            sortable: true,
            sortField: "interview"
        },
        {
            name: t("datatable:offered"),
            selector: function(row) {
                return row.offered;
            },
            sortable: true,
            sortField: "offered"
        },
        {
            name: t("datatable:hired"),
            selector: function(row) {
                return row.hired;
            },
            sortable: true,
            sortField: "hired"
        },
        {
            name: t("datatable:agency"),
            selector: function(row) {
                return row.agency;
            }
        },
        {
            name: t("datatable:date"),
            selector: function(row) {
                return row.updated_at;
            },
            sortable: true,
            sortField: "updated_at"
        },
        {
            name: t("datatable:location"),
            selector: function(row) {
                return row.location;
            },
            sortable: true,
            sortField: "country"
        },
        {
            name: "",
            selector: function(row) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "DotsOptions",
                    onClick: function(event) {
                        return openJobOptions(event);
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .Dots */ .bb, {
                            className: "Dots Close"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .JobActionOptions */ .Fb, {
                            options: (0,_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .ACTION_OPTIONS */ .Z9)(),
                            job_id: row.id,
                            setPageName: setPageName,
                            slug: row.slug,
                            setJobList: setJobList,
                            editable: row.editable,
                            setjobEditModal: setjobEditModal,
                            closeAllJobsOptions: closeAllJobsOptions,
                            setApiError: setApiError,
                            setJobCloseModal: setJobCloseModal,
                            title: row.title,
                            session: session
                        })
                    ]
                });
            }
        }
    ];
    if (router.query.attention_token) {
        //After Date
        activeColumns.splice(7, 0, {
            name: t("datatable:comment"),
            selector: function(row) {
                return t("jobs:jobs_comment:".concat(row.attention_comment)) || "-";
            }
        });
    }
    return activeColumns;
}
function clientUserDraftColumns(setPageName, setJobList, setjobEditModal, router, setApiError, session, t) {
    return [
        {
            name: t("datatable:job"),
            selector: function(row) {
                var link = (0,_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .ACTION_OPTIONS */ .Z9)().edit_job.link.replace("$job_id", row.id);
                return linkWithTitle(row.title, link, router);
            },
            sortable: true,
            sortField: "title"
        },
        {
            name: t("datatable:agency"),
            selector: function(row) {
                return row.agency;
            }
        },
        {
            name: t("datatable:created"),
            selector: function(row) {
                return row.created_at;
            },
            sortable: true,
            sortField: "created_at"
        },
        {
            name: t("datatable:last_updated"),
            selector: function(row) {
                return row.updated_at;
            },
            sortable: true,
            sortField: "updated_at"
        },
        {
            name: t("datatable:job_owner(s)"),
            selector: function(row) {
                return row.job_owners.map(function(element, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "JobSection",
                        children: [
                            (element === null || element === void 0 ? void 0 : element.photo_url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: element === null || element === void 0 ? void 0 : element.photo_url,
                                className: "JobImage"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "JobInitial",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: element.initials ? element.initials : "?"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "JobName",
                                children: [
                                    "  ",
                                    element.name,
                                    " "
                                ]
                            })
                        ]
                    }, "job_owner_initials_".concat(index));
                });
            },
            sortable: true,
            sortField: "job_creator"
        },
        {
            name: "",
            selector: function(row) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "DotsOptions",
                    onClick: function(event) {
                        return openJobOptions(event);
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .Dots */ .bb, {
                            className: "Dots Close"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .JobActionOptions */ .Fb, {
                            options: (0,_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .ACTION_OPTIONS */ .Z9)(),
                            setPageName: setPageName,
                            job_id: row.id,
                            slug: row.slug,
                            setJobList: setJobList,
                            publishable: row.publishable,
                            editable: row.editable,
                            setjobEditModal: setjobEditModal,
                            closeAllJobsOptions: closeAllJobsOptions,
                            setApiError: setApiError,
                            session: session
                        })
                    ]
                });
            }
        }
    ];
}
function clientUserArcheivedColumns(setPageName, setJobList, setjobEditModal, router, setApiError, session, t) {
    return [
        {
            name: t("datatable:job"),
            selector: function(row) {
                var link = _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .REDIRECT.client.kanban_board.replace */ .RQ.client.kanban_board.replace("$job_id", row.id);
                return linkWithTitle(row.title, link, router);
            },
            sortable: true,
            sortField: "title"
        },
        {
            name: t("datatable:applicants"),
            selector: function(row) {
                return row.applicants;
            },
            sortable: true,
            sortField: "applicants"
        },
        {
            name: t("datatable:agency"),
            selector: function(row) {
                return row.agency;
            }
        },
        {
            name: t("datatable:hired"),
            selector: function(row) {
                return row.hired || 0;
            },
            sortable: true,
            sortField: ""
        },
        {
            name: t("datatable:created"),
            selector: function(row) {
                return row.created_at;
            },
            sortable: true,
            sortField: "created_at"
        },
        {
            name: t("datatable:archived"),
            selector: function(row) {
                return row.archived_at;
            },
            sortable: true,
            sortField: "archived_at"
        },
        {
            name: t("datatable:job_owner(s)"),
            selector: function(row) {
                return row.job_owners.map(function(element, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "JobSection",
                        children: [
                            (element === null || element === void 0 ? void 0 : element.photo_url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: element === null || element === void 0 ? void 0 : element.photo_url,
                                className: "JobImage"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "JobInitial",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: element.initials ? element.initials : "?"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "JobName",
                                children: [
                                    "  ",
                                    element.name,
                                    " "
                                ]
                            })
                        ]
                    }, "job_owner_initials_".concat(index));
                });
            },
            sortable: true,
            sortField: "job_creator"
        },
        {
            name: "",
            selector: function(row) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "DotsOptions",
                    onClick: function(event) {
                        return openJobOptions(event);
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .Dots */ .bb, {
                            className: "Dots Close"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .JobActionOptions */ .Fb, {
                            options: (0,_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .ACTION_OPTIONS */ .Z9)(),
                            job_id: row.id,
                            setPageName: setPageName,
                            slug: row.slug,
                            setJobList: setJobList,
                            setjobEditModal: setjobEditModal,
                            closeAllJobsOptions: closeAllJobsOptions,
                            setApiError: setApiError,
                            session: session
                        })
                    ]
                });
            }
        }
    ];
}
function closeEditJobModal(setjobEditModal) {
    setjobEditModal([
        "Close",
        ""
    ]);
}
function goToEditJob(job_edit_modal_link, router) {
    router.push(job_edit_modal_link);
}
function warningPopUp(job_id, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, row, setPendingDashboardList, setJobApprovalData, setInfoModal, t) {
    return _warningPopUp.apply(this, arguments);
}
function _warningPopUp() {
    _warningPopUp = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(job_id, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, row, setPendingDashboardList, setJobApprovalData, setInfoModal, t) {
        var customToastrAction, _tmp, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!row.all_discard) return [
                        3,
                        1
                    ];
                    customToastrAction = new _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .CustomToastrAction */ .Y5();
                    _tmp = {};
                    if (row.approvers.length > 0) {
                        setInfoModal((_tmp.state = true, _tmp.heading = row.job_status == "Rejected" ? t("modal:info:rejection_reasons") : t("modal:info:approvers_list"), _tmp.message = row.job_status == "Rejected" ? row.reject_reason : row.approvers, _tmp.job_status = row.job_status, _tmp));
                    } else {
                        customToastrAction.setNormalToastr(row.message, "warning");
                    }
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .JobListing */ .DT().failedJobBoardList(job_id)
                    ];
                case 2:
                    result = _state.sent();
                    setFailedDashboardList(result.data.not_published);
                    setPublishedDashboardList(result.data.published);
                    setPendingDashboardList(result.data.pending);
                    setStatusJobId(job_id);
                    setJobApprovalData(row.approvers);
                    setJobStatusModal("Open");
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _warningPopUp.apply(this, arguments);
}
function retryJobOnJobBoard(job_id, setJobStatusModal, setDisableButton, setShowLoader, integration_id) {
    return _retryJobOnJobBoard.apply(this, arguments);
}
function _retryJobOnJobBoard() {
    _retryJobOnJobBoard = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(job_id, setJobStatusModal, setDisableButton, setShowLoader, integration_id) {
        var ref, ref1, ref2, all_checkbox, integration_ids, customToastrAction, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    all_checkbox = document.querySelectorAll('.JobStatusErrorSection input[type="checkbox"]');
                    integration_ids = [
                        integration_id
                    ];
                    customToastrAction = new _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .CustomToastrAction */ .Y5();
                    // for(var element of all_checkbox)
                    // {
                    //     if(element.checked)
                    //     {
                    //         integration_ids.push(element.value);
                    //     }
                    // }
                    setShowLoader(true);
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .JobListing */ .DT().retryJobsOnJobBoardService(integration_ids, job_id)
                    ];
                case 1:
                    result = _state.sent();
                    setShowLoader(false);
                    setDisableButton(true);
                    setJobStatusModal("Close");
                    if ((ref = result.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.error) {
                        customToastrAction.setNormalToastr(result.response.data.error, "error");
                    } else if (result === null || result === void 0 ? void 0 : (ref2 = result.data) === null || ref2 === void 0 ? void 0 : ref2.success) {
                        customToastrAction.setNormalToastr(result.data.success, "success");
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _retryJobOnJobBoard.apply(this, arguments);
}
function dismissJobOnJobBoard(job_id, setJobStatusModal, setDisableButton, setShowLoader, integration_id, failedCount) {
    return _dismissJobOnJobBoard.apply(this, arguments);
}
function _dismissJobOnJobBoard() {
    _dismissJobOnJobBoard = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(job_id, setJobStatusModal, setDisableButton, setShowLoader, integration_id, failedCount) {
        var all_checkbox, integration_ids, discard_all, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    all_checkbox = document.querySelectorAll('.JobStatusErrorSection input[type="checkbox"]');
                    integration_ids = [
                        integration_id
                    ];
                    discard_all = failedCount == 1 ? true : false;
                    setShowLoader(true);
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .JobListing */ .DT().dismissJobsOnJobBoardService(integration_ids, job_id, discard_all)
                    ];
                case 1:
                    result = _state.sent();
                    setShowLoader(false);
                    setDisableButton(true);
                    setJobStatusModal("Close");
                    return [
                        2
                    ];
            }
        });
    });
    return _dismissJobOnJobBoard.apply(this, arguments);
}
function isJobFilterApplied(router) {
    var previous_job_filter = router.query;
    return (previous_job_filter === null || previous_job_filter === void 0 ? void 0 : previous_job_filter.start_date) || (previous_job_filter === null || previous_job_filter === void 0 ? void 0 : previous_job_filter.end_date) || (previous_job_filter === null || previous_job_filter === void 0 ? void 0 : previous_job_filter.location) || previous_job_filter.agency_user_emails;
}
function linkWithTitle(title_name, redirect_link, router) {
    var previous_job_filter = router.query;
    switch(previous_job_filter === null || previous_job_filter === void 0 ? void 0 : previous_job_filter.job_type){
        case "active":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "EditableTitle",
                onClick: function() {
                    goToKanbanBoard(router, redirect_link);
                },
                children: title_name
            });
        case "draft":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "EditableTitle",
                onClick: function() {
                    goToEditJob(redirect_link, router);
                },
                children: title_name
            });
        case "archived":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "EditableTitle",
                onClick: function() {
                    goToKanbanBoard(router, redirect_link);
                },
                children: title_name
            });
        default:
            "";
    }
}
function goToKanbanBoard(router, redirect_link) {
    router.push(redirect_link);
}
function setDataTableClass(job_type, role) {
    switch(job_type){
        case "active":
            if (role == "client_admin" || role == "account_owner") {
                return "ClientAdminActiveTable";
            } else if (role == "client_user") {
                return "ClientUserActiveTable";
            } else {
                return "ClientReviewerActiveTable";
            }
        case "draft":
            if (role == "client_admin" || role == "account_owner") {
                return "ClientAdminDraftTable";
            } else if (role == "client_user") {
                return "ClientUserDraftTable";
            } else {
                return "ClientReviewerDraftTable";
            }
        case "archived":
            if (role == "client_admin" || role == "account_owner") {
                return "ClientAdminArchivedTable";
            } else if (role == "client_user") {
                return "ClientUserArchivedTable";
            } else {
                return "ClientReviewerArchivedTable";
            }
        default:
            "";
    }
}
function onSelectJob(event, setDisableButton, setHeaderChecked) {
    var all_checkbox = document.querySelectorAll('.JobStatusErrorSection input[type="checkbox"]');
    var no_job_selected = true;
    var discard_jobs_button = document.querySelector(".DiscardJobs");
    var retry_jobs_button = document.querySelector(".RetryJobs");
    var checked_count = 0;
    var header_checkbox = document.querySelector(".HeadingCheckboxSection input");
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = all_checkbox[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            if (element.checked) {
                checked_count = checked_count + 1;
                discard_jobs_button.disabled = false;
                retry_jobs_button.disabled = false;
                no_job_selected = false;
                setDisableButton(false);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    checked_count == all_checkbox.length ? setHeaderChecked(true) : setHeaderChecked(false);
    if (no_job_selected) {
        discard_jobs_button.disabled = true;
        retry_jobs_button.disabled = true;
        setDisableButton(true);
    }
}
function selectAllBoard(event, setDisableButton, setHeaderChecked) {
    var all_checkbox = document.querySelectorAll('.JobStatusErrorSection input[type="checkbox"]');
    if (event.currentTarget.checked) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = all_checkbox[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                if (!element.checked) {
                    element.click();
                }
            // element.checked = true;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = all_checkbox[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var element = _step1.value;
                if (element.checked) {
                    element.click();
                }
            // element.checked = true;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    setHeaderChecked(event.target.checked);
    setDisableButton(!event.target.checked);
}
function emailVerifiedOrNot(email, email_verified, t) {
    if (email && email.length > 0) {
        return email_verified ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_simple_tooltip__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: "SimpleTooltip",
                    content: t("label:verified"),
                    background: "#00325A",
                    radius: 20,
                    padding: 8,
                    placement: "top",
                    fontSize: "12px",
                    children: [
                        "   ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "tooltipwidth",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_5__/* .Verified */ .zI, {})
                        })
                    ]
                }),
                " ",
                " "
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    //                        <> <Tooltip className='SimpleTooltip' content="Not Verified" background= {'#00325A'} radius={20} padding = {8} placement	= "top" fontSize= "12px">
    // <p className={`tooltipwidth`}><Warning /></p> {" "}</Tooltip></>
    }
}
function changeDelay(timer, setTimer, event, setJobList, setFiltersValue, router, setApiError) {
    if (timer) {
        clearTimeout(timer);
        setTimer(null);
    }
    setTimer(setTimeout(function() {
        changeSearchFilterData(event, setJobList, setFiltersValue, router, setApiError);
    }, 500));
}
function goToApprovalRequest(router) {
    var link = REDIRECT.client.jobs.approvals_listing;
    router.push({
        pathname: link,
        query: {
            tab: "jobs"
        }
    });
}
function setJobApplicationStatus(row, setInfoModal, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, t, setPendingDashboardList, setJobApprovalData) {
    switch(row.job_status){
        case "Published":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                onClick: function() {
                    warningPopUp(row.id, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, row, setPendingDashboardList, setJobApprovalData, setInfoModal, t);
                },
                children: [
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_simple_tooltip__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        className: "SimpleTooltip",
                        content: t("tooltip:published"),
                        background: "#00325A",
                        radius: 20,
                        padding: 8,
                        placement: "top",
                        fontSize: "12px",
                        children: [
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .Check */ .Jr, {}),
                            " "
                        ]
                    })
                ]
            });
        case "Failed To Publish":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "Warning",
                onClick: function() {
                    warningPopUp(row.id, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, row, setPendingDashboardList, setJobApprovalData, setInfoModal, t);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_simple_tooltip__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: "SimpleTooltip",
                    content: t("tooltip:failed_to_publish"),
                    background: "#00325A",
                    radius: 20,
                    padding: 8,
                    placement: "top",
                    fontSize: "12px",
                    children: [
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .Warning */ .nL, {}),
                        " "
                    ]
                })
            });
        case "Queued":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                onClick: function() {
                    warningPopUp(row.id, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, row, setPendingDashboardList, setJobApprovalData, setInfoModal, t);
                },
                children: [
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_simple_tooltip__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        className: "SimpleTooltip",
                        content: t("tooltip:queued"),
                        background: "#00325A",
                        radius: 20,
                        padding: 8,
                        placement: "top",
                        fontSize: "12px",
                        children: [
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .Clock */ .SU, {}),
                            " "
                        ]
                    })
                ]
            });
        case "Pending":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                onClick: function() {
                    openInfoModal(row, setInfoModal, t);
                },
                children: [
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_simple_tooltip__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        className: "SimpleTooltip",
                        content: t("tooltip:approvers", {
                            pending_approval_text: "".concat(row.pending_approval_text)
                        }),
                        background: "#00325A",
                        radius: 20,
                        padding: 8,
                        placement: "top",
                        fontSize: "12px",
                        children: [
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .Clock */ .SU, {}),
                            " "
                        ]
                    })
                ]
            });
        case "Rejected":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "Rejected",
                onClick: function() {
                    openInfoModal(row, setInfoModal, t);
                },
                children: [
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_simple_tooltip__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        className: "SimpleTooltip",
                        content: t("tooltip:rejected"),
                        background: "#00325A",
                        radius: 20,
                        padding: 8,
                        placement: "top",
                        fontSize: "12px",
                        children: [
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .Rejected */ .WR, {}),
                            " "
                        ]
                    })
                ]
            });
        case "Approved":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_simple_tooltip__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        className: "SimpleTooltip",
                        content: t("tooltip:approved"),
                        background: "#00325A",
                        radius: 20,
                        padding: 8,
                        placement: "top",
                        fontSize: "12px",
                        children: [
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__/* .Check */ .Jr, {}),
                            " "
                        ]
                    })
                ]
            });
        default:
            "";
    }
}
function openInfoModal(row, setInfoModal, t) {
    setInfoModal({
        state: true,
        heading: row.job_status == "Rejected" ? t("modal:info:rejection_reasons") : t("modal:info:approvers_list"),
        message: row.job_status == "Rejected" ? row.reject_reason : row.approvers,
        job_status: row.job_status
    });
}


/***/ }),

/***/ 44059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B4": function() { return /* binding */ handleCompentencyFormSubmit; },
/* harmony export */   "h9": function() { return /* binding */ getScorecardData; },
/* harmony export */   "qz": function() { return /* binding */ ScorecardAction; }
/* harmony export */ });
/* unused harmony exports getSuggestionValue, renderSuggestion, onSuggestionsFetchRequested, onSuggestionsClearRequested, escapeRegexCharacters, getSuggestions, shouldRenderSuggestions, onAddClick, getCompetenciesList, setParamsValues */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96726);






function getSuggestionValue(suggestion) {
    return suggestion.label;
}
function renderSuggestion(suggestion) {
    return /*#__PURE__*/ _jsx("span", {
        children: suggestion.label
    });
}
function onSuggestionsFetchRequested(value, setCompetencies, router) {
    return _onSuggestionsFetchRequested.apply(this, arguments);
}
function _onSuggestionsFetchRequested() {
    _onSuggestionsFetchRequested = _async_to_generator(function(value, setCompetencies, router) {
        var competencies;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getSuggestions(value, router)
                    ];
                case 1:
                    competencies = _state.sent();
                    return [
                        2,
                        setCompetencies(competencies)
                    ];
            }
        });
    });
    return _onSuggestionsFetchRequested.apply(this, arguments);
}
;
var onSuggestionsClearRequested = function(setCompetencies) {
    setCompetencies([]);
};
function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function getSuggestions(value, router) {
    return _getSuggestions.apply(this, arguments);
}
function _getSuggestions() {
    _getSuggestions = _async_to_generator(function(value, router) {
        var escapedValue, competencies_list;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    escapedValue = escapeRegexCharacters(value.trim());
                    return [
                        4,
                        getCompetenciesList(escapedValue, router)
                    ];
                case 1:
                    competencies_list = _state.sent();
                    return [
                        2,
                        competencies_list
                    ];
            }
        });
    });
    return _getSuggestions.apply(this, arguments);
}
function shouldRenderSuggestions(value) {
    // return value.trim().length >= 3
    return true;
}
function onAddClick() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var formik = args[0];
    var action = args[1];
    var setCompetencyCount = args[2];
    var index = args[3];
    var competencies_names = formik.values.job_competency_names;
    if (action == "add") {
        competencies_names.push("");
    } else {
        competencies_names.splice(index, 1);
    }
    setCompetencyCount(competencies_names.length);
}
function getCompetenciesList(name, router) {
    return _getCompetenciesList.apply(this, arguments);
}
function _getCompetenciesList() {
    _getCompetenciesList = _async_to_generator(function(name, router) {
        var body, _tmp, result, status_code, customToastrAction, response;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = (_tmp.name = name, _tmp);
                    return [
                        4,
                        new ScoreCard().getCompetencyByName(body)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new CustomToastrAction();
                    switch(status_code){
                        case SUCCESS_REPONSE_CODE:
                            response = result.data;
                            return [
                                2,
                                response.competencies || []
                            ];
                        case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            // toastr.warning(result.response.data.error)
                            return [
                                2,
                                []
                            ];
                        default:
                            handleOtherResponseCode(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getCompetenciesList.apply(this, arguments);
}
function handleCompentencyFormSubmit(params, router, setPageName, queryClient, current_step, fromKanban, gotoKanban, setDisabledSaveButton, formRef) {
    return _handleCompentencyFormSubmit.apply(this, arguments);
}
function _handleCompentencyFormSubmit() {
    _handleCompentencyFormSubmit = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(params, router, setPageName, queryClient, current_step, fromKanban, gotoKanban, setDisabledSaveButton, formRef) {
        var body, _tmp, _tmp1, job_id, job_id, result, status_code, customToastrAction, response, queryPath, _tmp2, _tmp3, ref, message, ref1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // TODO
                    setDisabledSaveButton(true);
                    _tmp = {};
                    body = (_tmp.step = current_step, _tmp.job = {}, _tmp);
                    body["job"]["step"] = current_step;
                    _tmp1 = {};
                    setParamsValues((_tmp1.formRef = formRef, _tmp1));
                    params.scorecard_config_attributes ? body["job"]["scorecard_config_attributes"] = params.scorecard_config_attributes : "";
                    params.job_competencies_attributes ? body["job"]["job_competencies_attributes"] = params.job_competencies_attributes : "";
                    job_id = window.location.pathname.split("/").slice(-2)[0];
                    job_id = new _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_1__/* .DataFromUrl */ .QJ().getJobId();
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_1__/* .ScoreCard */ .kZ().addCompetencies(body, job_id)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
                    _tmp2 = {};
                    _tmp3 = {};
                    switch(status_code){
                        case _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us:
                            response = result.data;
                            queryPath = fromKanban ? "?from_kanban=true" : "";
                            if (gotoKanban) {
                                if (fromKanban) {
                                    router.push((_tmp2.pathname = _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.kanban_board.replace */ .RQ.client.kanban_board.replace("$job_id", job_id), _tmp2));
                                } else {
                                    router.push((_tmp3.pathname = _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.jobs.index */ .RQ.client.jobs.index, _tmp3.query = {
                                        job_type: "active"
                                    }, _tmp3));
                                }
                            } else {
                                router.push(_imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.jobs.job_sharing.replace */ .RQ.client.jobs.job_sharing.replace("$job_id", job_id) + queryPath);
                            }
                            break;
                        case _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_1__/* .UNPROCESSABLE_ENTITY_RESPONSE_CODE */ .Mn:
                            ;
                            message = "";
                            if ((ref = result.response.data.error.job) === null || ref === void 0 ? void 0 : ref.start_date) {
                                ;
                                message = (0,_imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_1__/* .startDateMessage */ .d3)(message, (ref1 = result.response.data.error.job) === null || ref1 === void 0 ? void 0 : ref1.start_date);
                            }
                            if (message.length > 0) {
                                customToastrAction.setNormalToastr(message, "warning");
                            // toastr.warning(message)
                            }
                            setDisabledSaveButton(false);
                            break;
                        default:
                            (0,_imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_1__/* .handleOtherResponseCode */ .GB)(status_code, router);
                            setDisabledSaveButton(false);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _handleCompentencyFormSubmit.apply(this, arguments);
}
function getScorecardData(setApiError) {
    return _getScorecardData.apply(this, arguments);
}
function _getScorecardData() {
    _getScorecardData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(setApiError) {
        var job_id, scorecard_data, result, data, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    job_id = new _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_1__/* .DataFromUrl */ .QJ().getJobId();
                    return [
                        4,
                        new _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_1__/* .ScoreCard */ .kZ().getCompetencies(job_id)
                    ];
                case 1:
                    scorecard_data = _state.sent();
                    _tmp = {};
                    if (scorecard_data.request.status == 200) {
                        result = scorecard_data.data.job;
                        data = (_tmp.props = {
                            result: result
                        }, _tmp);
                        return [
                            2,
                            data
                        ];
                    } else {
                        setApiError(scorecard_data.request);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getScorecardData.apply(this, arguments);
}
// This funtion set the values of the params which are not filled by the fields 
// /constants/pages/clients/jobs/scorecards.js
//pass job_id
function setParamsValues(params) {
    var ref, ref1, ref2, ref3;
    // params.formRef.current.values.scorecard_config_attributes.job_id = params.job_id;
    // If the add a scorecard link is selected then just sent the scorecard_config_attributes
    // and delete others 
    if (((ref = params.formRef.current) === null || ref === void 0 ? void 0 : ref.values.scorecard_config_attributes.link) && params.formRef.current.values.job_competencies_attributes) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = params.formRef.current.values.job_competencies_attributes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var job_competencies_attributes = _step.value;
                job_competencies_attributes._destroy = true;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else if (((ref1 = params.formRef.current) === null || ref1 === void 0 ? void 0 : ref1.values.scorecard_config_attributes.link) && !params.formRef.current.values.job_competencies_attributes) {
        delete params.formRef.current.values.job_competencies_attributes;
    } else if (!((ref2 = params.formRef.current) === null || ref2 === void 0 ? void 0 : ref2.values.scorecard_config_attributes.link) && params.formRef.current.values.scorecard_config_attributes) {
        params.formRef.current.values.scorecard_config_attributes.link = false;
        params.formRef.current.values.scorecard_config_attributes.scorecard_link = "";
    } else if (!((ref3 = params.formRef.current) === null || ref3 === void 0 ? void 0 : ref3.values.scorecard_config_attributes.link) && !params.formRef.current.values.scorecard_config_attributes) {
        delete params.formRef.current.values.scorecard_config_attributes;
    }
/*----------------------------------job_sub_competencies_attributes ---------------------------------- */ }
var ScorecardAction = /*#__PURE__*/ function() {
    "use strict";
    function ScorecardAction(formRef, initialValues, setFlagForRender) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, ScorecardAction);
        this.commonAction = new _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_1__/* .CommonAction */ .x4();
        this.formRef = formRef;
        this.initialValues = initialValues;
        this.setFlagForRender = setFlagForRender;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ScorecardAction, [
        {
            key: "getInitialValue",
            value: function getInitialValue(values) {
                _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_1__/* .INITIAL_VALUES.scorecard_config_attributes */ .N7.scorecard_config_attributes = (values === null || values === void 0 ? void 0 : values.scorecard_config_attributes) || (0,_imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_1__/* .scorecard_config_initials */ .nb)();
                _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_1__/* .INITIAL_VALUES.job_competencies_attributes */ .N7.job_competencies_attributes = (values === null || values === void 0 ? void 0 : values.job_competencies_attributes) || [
                    (0,_imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_1__/* .job_competency_initials */ .ZX)()
                ];
                // if(INITIAL_VALUES.job_competencies_attributes.length == 0) INITIAL_VALUES.job_competencies_attributes =  [job_competency_initials()];
                return _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_1__/* .INITIAL_VALUES */ .N7;
            }
        },
        {
            //TODO change it to the single select for radio and checkbox
            key: "selectScorecardType",
            value: function selectScorecardType(select_scorecard_name, event, value, initial_values) {
                if (select_scorecard_name) {
                    // this.formRef.current.setFieldValue('job_competencies_attributes',[]);
                    // this.formRef.current.setFieldValue('scorecard_config_attributes.instructions','');
                    // this.formRef.current.setFieldValue('scorecard_config_attributes.private', false);
                    // this.formRef.current.setFieldValue('scorecard_config_attributes.scorecard_link','');
                    this.formRef.current.setValues(this.getInitialValue(initial_values));
                    this.formRef.current.setFieldValue(select_scorecard_name, value);
                    this.formRef.current.setFieldTouched("job_competencies_attributes", false);
                    this.formRef.current.setFieldTouched("scorecard_config_attributes.scorecard_link", false);
                }
            }
        },
        {
            key: "selectPrivateScorecard",
            value: function selectPrivateScorecard(select_name, event) {
                this.formRef.current.setFieldValue(select_name, event.target.checked);
            }
        },
        {
            //-------------------------------------------
            key: "showScorecardTypeComponent",
            value: function showScorecardTypeComponent(type, formik) {
                var value = false;
                switch(type){
                    case "select_create_scorecard":
                        var create_scorecard_value = !(formik === null || formik === void 0 ? void 0 : formik.values.scorecard_config_attributes.link);
                        if (create_scorecard_value) {
                            value = create_scorecard_value;
                        }
                        if (typeof create_scorecard_value == "undefined") {
                            value = true;
                        }
                        break;
                    case "select_add_scorecard_link":
                        var add_scorecard_link_value = formik.values.scorecard_config_attributes.link;
                        if (add_scorecard_link_value) {
                            value = add_scorecard_link_value;
                        }
                        if (typeof add_scorecard_link_value == "undefined") {
                            value = false;
                        }
                        break;
                    default:
                        "";
                }
                return value;
            }
        }
    ]);
    return ScorecardAction;
}();


/***/ }),

/***/ 47084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ VideoQaAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38641);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18186);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34817);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64335);







var VideoQaAction = /*#__PURE__*/ function() {
    "use strict";
    function VideoQaAction() {
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, VideoQaAction);
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "renderInputComponent", function(inputProps) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                className: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input */ .k2.Form__Input,
                autoComplete: "password"
            }, inputProps));
        });
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "renderMemberInputComponent", function(inputProps) {
            var ref;
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "buttonIn AutoSuggestInput__Tags",
                style: inputProps.styleError,
                children: [
                    (ref = inputProps.selectedValues) === null || ref === void 0 ? void 0 : ref.map(function(item, itemIndex) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.SetupPopup__Tags */ .k2.SetupPopup__Tags,
                            children: [
                                item.name ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: item.name
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: item.email
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    ButtonStyle: "".concat(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.nobgbutton */ .ZJ.nobgbutton),
                                    type: "button",
                                    onClick: function() {
                                        inputProps.videoQaAction.handleDelete(inputProps.formik, itemIndex);
                                    },
                                    children: [
                                        " ",
                                        inputProps.closeIcon
                                    ]
                                })
                            ]
                        }, "interview_email_".concat(inputProps.index, "_").concat(itemIndex));
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                        className: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input */ .k2.Form__Input,
                        autoComplete: "password"
                    }, inputProps)),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                        buttonstyle: "".concat(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.nobgbutton */ .ZJ.nobgbutton, " addbtn ").concat((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .cursorNone */ .y$)(inputProps.editable)),
                        disabled: inputProps.disabled,
                        onClick: function(event) {
                            return inputProps.videoQaAction.onAddClick(event, inputProps);
                        },
                        children: (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .TRANSLATION */ .TA)("button:add:default")
                    })
                ]
            });
        });
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, "onAddClick", function(event, params) {
            var email = params.value;
            if (_this.isEmail(email)) {
                params.videoQaAction.onSuggestionSelection(params.formik, params.formik.values.videoqa.member_emails, email, params.formik.values.videoqa.member_initials, {
                    email: email,
                    name_initials: null,
                    name: null
                });
                params.setStageEmail({
                    value: "",
                    error: ""
                });
            } else {
                params.setStageEmail({
                    value: email,
                    error: "Please enter valid email"
                });
            }
        });
        this.customToastrAction = new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
        this.commonAction = new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_1__/* .CommonAction */ .x4();
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(VideoQaAction, [
        {
            key: "shouldRenderSuggestions",
            value: function shouldRenderSuggestions(value) {
                return value.trim().length >= 3;
            }
        },
        {
            key: "isEmail",
            value: function isEmail(email) {
                return /^[^\s@]+@[^\s@]+\.[^\s@\.]+$/.test(email);
            }
        },
        {
            key: "onSuggestionSelection",
            value: function onSuggestionSelection(formik, old_ids, id, old_initials, new_initial) {
                if (!(old_ids.includes(id) || old_ids.includes(id.toString()))) {
                    old_ids.unshift(id);
                    old_initials.unshift(new_initial);
                    formik.setFieldValue("videoqa.member_emails", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(old_ids));
                    formik.setFieldValue("videoqa.member_initials", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(old_initials));
                }
            }
        },
        {
            key: "handleKeyDown",
            value: function handleKeyDown(event, formik, setStageEmail) {
                if ([
                    "Enter"
                ].includes(event.key)) {
                    event.preventDefault();
                    var email = event.target.value;
                    if (this.isEmail(email)) {
                        this.onSuggestionSelection(formik, formik.values.videoqa.member_emails, email, formik.values.videoqa.member_initials, {
                            email: email,
                            name_initials: null,
                            name: null
                        });
                        setStageEmail({
                            value: "",
                            error: ""
                        });
                    } else {
                        setStageEmail({
                            value: email,
                            error: "Please enter valid email"
                        });
                    }
                }
            }
        },
        {
            key: "handleDelete",
            value: function handleDelete(formik, itemIndex) {
                var member_emails = formik.values.videoqa.member_emails;
                var member_initials = formik.values.videoqa.member_initials;
                member_emails.splice(itemIndex, 1);
                member_initials.splice(itemIndex, 1);
                formik.setFieldValue("videoqa.member_emails", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(member_emails));
                formik.setFieldValue("videoqa.member_initials", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(member_initials));
            }
        }
    ]);
    return VideoQaAction;
}();


/***/ }),

/***/ 2228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ UnsuccessfulReasonAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79995);






var UnsuccessfulReasonAction = /*#__PURE__*/ function() {
    "use strict";
    function UnsuccessfulReasonAction(args, router) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, UnsuccessfulReasonAction);
        var keys = Object.keys(args);
        this.unsuccessfulReasonService = new _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_1__/* .UnsuccessfulReasonService */ .S0();
        this.router = router;
        this.customToastrAction = new _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5();
        // Creating class variables
        for(var i = 0; i < keys.length; i++){
            if (typeof this["".concat(keys[i])] == "undefined") {
                this["".concat(keys[i])] = args[keys[i]];
            // console.log(this[`${keys[i]}`]);
            }
        }
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(UnsuccessfulReasonAction, [
        {
            key: "getUnsuccessfullReasonsData",
            value: function getUnsuccessfullReasonsData(router) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var param_list, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                param_list = new _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_1__/* .CommonAction */ .x4().getQueryInObject();
                                return [
                                    4,
                                    _this.unsuccessfulReasonService.getReasonsListData(param_list)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                result.data.reasons.forEach(function(element, index) {
                                    element["key"] = index + 1;
                                });
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getUnsuccessfullReasonseColumns",
            value: function getUnsuccessfullReasonseColumns(router, unsuccessfulReasonAction, t) {
                var _this = this;
                return [
                    {
                        name: t("datatable:unsuccessful_reasons"),
                        selector: function(row) {
                            return row.reason_text;
                        },
                        sortable: true,
                        sortField: "reason"
                    },
                    {
                        name: t("datatable:last_edited_by"),
                        selector: function(row) {
                            return row.edited_by_name || "-";
                        },
                        sortable: true,
                        sortField: "edited_by_name"
                    },
                    {
                        name: t("datatable:action(s)"),
                        selector: function(row) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "DotsOptions",
                                onClick: function(event) {
                                    _this.openJobOptions(event);
                                },
                                children: row.can_edit ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_1__/* .Dots */ .bb, {
                                            className: "Dots Close"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_1__/* .UnsuccessfulReasonOptions */ .fY, {
                                            options: _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_1__/* .UNSUCCESSFUL_REASONS.unsuccessfulReasonsOptions */ .JW.unsuccessfulReasonsOptions(t),
                                            unsuccessfulReasonAction: unsuccessfulReasonAction,
                                            id: row.id,
                                            reason_id: row.reason_id
                                        })
                                    ]
                                }) : "-"
                            });
                        }
                    }
                ];
            }
        },
        {
            key: "openJobOptions",
            value: function openJobOptions(event) {
                event.stopPropagation();
                var dots_element = event.currentTarget.querySelector(".Dots");
                var element = event.currentTarget.querySelector(".JobActionOptions");
                if (dots_element.classList.contains("Close")) {
                    this.closeAllJobsOptions();
                    element.classList.remove("Close");
                    element.classList.add("Open");
                    dots_element.classList.remove("Close");
                    dots_element.classList.add("Open");
                } else {
                    this.closeAllJobsOptions();
                    element.classList.remove("Open");
                    element.classList.add("Close");
                    dots_element.classList.remove("Open");
                    dots_element.classList.add("Close");
                }
            }
        },
        {
            key: "closeAllJobsOptions",
            value: function closeAllJobsOptions() {
                var element = document.querySelector(".JobActionOptions.Open");
                var dots_element = document.querySelector(".Dots.Open");
                if (element) {
                    element.classList.remove("Open");
                    element.classList.add("Close");
                    dots_element.classList.remove("Open");
                    dots_element.classList.add("Close");
                }
            }
        },
        {
            key: "changeSearchFilterData",
            value: function changeSearchFilterData(event) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var param_list, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.router.query.page = _this.router.query.page || 1;
                                param_list = _this.router.query;
                                param_list.search_text = event.target.value;
                                param_list.search_text == "" ? delete param_list.search_text : param_list.search_text;
                                (0,_imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_1__/* .addParamsToUrl */ .Sr)(param_list, _this.router);
                                return [
                                    4,
                                    _this.unsuccessfulReasonService.getReasonsListData(param_list)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                _this.setUnsuccessfulReasonData(result.data);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handlePerRowsSorting",
            value: function handlePerRowsSorting(router, column, sortDirection, setUnsuccessfulReasonData) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var param_list, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                param_list = router.query;
                                param_list.col_name = column.sortField;
                                param_list.order = sortDirection;
                                (0,_imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_1__/* .addParamsToUrl */ .Sr)(param_list, router);
                                return [
                                    4,
                                    _this.unsuccessfulReasonService.getReasonsListData(param_list)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                setUnsuccessfulReasonData(result.data);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handlePerRowsChange",
            value: function handlePerRowsChange(router, per_page, setUnsuccessfulReasonData) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var param_list, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                param_list = router.query;
                                param_list.per_page = per_page;
                                (0,_imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_1__/* .addParamsToUrl */ .Sr)(param_list, router);
                                return [
                                    4,
                                    _this.unsuccessfulReasonService.getReasonsListData(param_list)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                setUnsuccessfulReasonData(result.data);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handlePageChange",
            value: function handlePageChange(router, page_number, setUnsuccessfulReasonData) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var param_list, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                param_list = router.query;
                                param_list.page = page_number;
                                (0,_imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_1__/* .addParamsToUrl */ .Sr)(param_list, router);
                                return [
                                    4,
                                    _this.unsuccessfulReasonService.getReasonsListData(param_list)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                setUnsuccessfulReasonData(result.data);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "performJobAction",
            value: function performJobAction(ActionName, params) {
                switch(ActionName){
                    case "edit":
                        this.editEmailTemplate(params);
                        break;
                    case "delete":
                        this.deleteEmailTemplate(params);
                        break;
                    default:
                        "";
                }
            }
        },
        {
            key: "editEmailTemplate",
            value: function editEmailTemplate(args) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var result, _tmp;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_1__/* .UNSUCCESSFUL_REASONS.unsuccessfulReasonsForm */ .JW.unsuccessfulReasonsForm(args.t).texts.heading = _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_1__/* .UNSUCCESSFUL_REASONS.unsuccessfulReasonsForm */ .JW.unsuccessfulReasonsForm(args.t).texts.edit_heading;
                                return [
                                    4,
                                    _this.unsuccessfulReasonService.showReasonListData(args.id)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                _this.selectedReasonId = args.id;
                                _tmp = {};
                                _this.setFormInitialValues((_tmp.id = args.reason_id, _tmp.reason = result.data.reason.reason_text, _tmp));
                                _this.setFormValidations(_imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_1__/* .UNSUCCESSFUL_REASONS.unsuccessfulReasonsForm */ .JW.unsuccessfulReasonsForm(args.t).formValidation);
                                _this.setSubmitFormAction(function() {
                                    return function(values) {
                                        return _this.submitEditUnsuccessfulForm(values);
                                    };
                                });
                                _this.setShowUnsuccessfulReason(true);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deleteEmailTemplate",
            value: function deleteEmailTemplate(args) {
                this.setSelectedReasonId(args.id);
                this.setDeleteConfirmation(true);
            }
        },
        {
            key: "deleteTemplate",
            value: function deleteTemplate(selectedReasonId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var ref, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.unsuccessfulReasonService.deleteReasonsListData(selectedReasonId)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                _this.customToastrAction.setNormalToastr(result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.success, "success");
                                //   toastr.success(result?.data?.success);
                                _this.setDeleteConfirmation(false);
                                _this.setUnsuccessfulReasonData(result === null || result === void 0 ? void 0 : result.data);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "submitCreateUnsuccessfulForm",
            value: function submitCreateUnsuccessfulForm(values) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var body, _tmp, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.setDisabledSubmitButton(true);
                                _tmp = {};
                                body = (_tmp.client_user_unsuccessful_reason = {
                                    reason_attributes: values
                                }, _tmp);
                                body = Object.assign(_this.router.query, body);
                                body.page = new _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_1__/* .CommonAction */ .x4().getPageFromUrl();
                                return [
                                    4,
                                    _this.unsuccessfulReasonService.createReasonsListData(body)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                if (result.request.status == _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us) {
                                    _this.customToastrAction.setNormalToastr(result.data.success, "success");
                                // toastr.success( result.data.success );
                                }
                                _this.setUnsuccessfulReasonData(result.data);
                                _this.setShowUnsuccessfulReason(false);
                                _this.setDisabledSubmitButton(false);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "submitEditUnsuccessfulForm",
            value: function submitEditUnsuccessfulForm(values) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var body, _tmp, result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                body = (_tmp.client_user_unsuccessful_reason = {
                                    reason_attributes: values
                                }, _tmp);
                                body = Object.assign(_this.router.query, body);
                                body.page = new _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_1__/* .CommonAction */ .x4().getPageFromUrl();
                                return [
                                    4,
                                    _this.unsuccessfulReasonService.updateReasonsListData(body, _this.selectedReasonId)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                if (result.request.status == _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REPONSE_CODE */ .Us) {
                                    _this.customToastrAction.setNormalToastr(result.data.success, "success");
                                // toastr.success( result.data.success );
                                }
                                _this.setUnsuccessfulReasonData(result.data);
                                _this.setShowUnsuccessfulReason(false);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "changeDelay",
            value: function changeDelay(event, timer, setTimer) {
                var _this = this;
                if (timer) {
                    clearTimeout(timer);
                    setTimer(null);
                }
                setTimer(setTimeout(function() {
                    _this.changeSearchFilterData(event);
                }, 500));
            }
        }
    ]);
    return UnsuccessfulReasonAction;
}();


/***/ }),

/***/ 29929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ AddToJobModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62286);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60838);
/* harmony import */ var _imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3623);
/* harmony import */ var _common_modal_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99005);





function AddToJobModal(props) {
    var t = (0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    var ref = (0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .useSWR */ .dH)("candidate_active_jobs", function() {
        return (0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .getCandidateActiveJobList */ .A2)({
            current_job_id: props.job_id || ""
        });
    }), data = ref.data, error = ref.error;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(""), 2), selectJobId = ref1[0], setSelectJobId = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(true), 2), isLoading = ref2[0], setLoading = ref2[1];
    var ADD_TO_JOB_MODAL_SCHEMA = (0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .addToJobModalSchema */ .gJ)(t);
    (0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .useEffect */ .d4)(function() {
        if (data) {
            setLoading(false);
        }
    }, [
        data
    ]);
    if (isLoading) {
        return "";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_modal_modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        type: "form",
        heading: t("modal:form:add_job:heading"),
        closeModal: function() {
            (0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .closeModalUsingState */ .jL)(false, props.setCandidateAddToJobModal);
        },
        content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .Formik */ .J9, {
            initialValues: _imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .ADD_TO_JOB_INITIAL_VALUES */ .i5,
            validationSchema: ADD_TO_JOB_MODAL_SCHEMA,
            onSubmit: function() {
                if (props.from && (props.from == "kanban" || props.from == "application_view")) {
                    (0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .addToAnotherJob */ .Jb)(props.job_id, selectJobId, props.params, props.router, props.setCandidateAddToJobModal, props.setAutomationActions, props.setAutomationBar, props.restart, props.setTimerStatus, props.from, props.setSelectedCards, props.activeTab, props.setActionBar);
                } else {
                    (0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .addCandidateToJob */ .E1)(selectJobId, props.selectedCandidateId, props.setCandidateAddToJobModal, props.setCandidateBulkActionModal, props.from);
                }
            },
            children: function(formik) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_2__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat(_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .FormStyle.Form__TableCol */ .x.Form__TableCol, " mt30"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                    className: "".concat(_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                    style: (0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oH)(formik, "select_job"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "red-color",
                                            children: "*"
                                        }),
                                        "\xa0",
                                        t("label:select:job")
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                    control: "select",
                                    formik: formik,
                                    name: "select_job",
                                    onChange: function(value) {
                                        return (0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .handleSelectJobValueOnChange */ .F6)(value, setSelectJobId, formik);
                                    },
                                    options: data,
                                    className: _imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_2__/* .FormModalStyle.CustomSelect */ .w2.CustomSelect,
                                    style: (0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "select_job"),
                                    default: data.job_type
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "height113"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: _imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_2__/* .FormModalStyle.Modal__Container__ButtonSection */ .w2.Modal__Container__ButtonSection,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                    buttonstyle: _imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_2__/* .FormModalStyle.secondarybtn */ .w2.secondarybtn,
                                    onClick: function() {
                                        (0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .closeModalUsingState */ .jL)(false, props.setCandidateAddToJobModal);
                                    },
                                    children: t("button:cancel")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                    buttonstyle: _imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_2__/* .FormModalStyle.primarybtn */ .w2.primarybtn,
                                    type: "submit",
                                    children: t("button:save")
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
}


/***/ }),

/***/ 84529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ AgencyAcceptRejectModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_components_confirmation_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46464);
/* harmony import */ var _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66172);
/* harmony import */ var _common_modal_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99005);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96047);







function AgencyAcceptRejectModal(props) {
    var ref, ref1;
    var heightClass = props.heightClass ? props.heightClass : "";
    var widthClass = props.widthClass ? props.widthClass : "";
    var buttonwidth = props.buttonwidth ? props.buttonwidth : "";
    var t = (0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_modal_modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        type: "form",
        heading: t("modal:duplicate:heading"),
        filterWidth: true,
        closeModal: function(event) {
            props.setAgencyAcceptReject({
                status: false
            });
        },
        content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_2__/* .FormModalStyle.Modal__Container__ContentSection */ .w2.Modal__Container__ContentSection, " mt30"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: _imports_files_components_confirmation_modal__WEBPACK_IMPORTED_MODULE_1__/* .AgencyModalStyle.ConfirmationModal__SubText */ .cs.ConfirmationModal__SubText,
                            children: [
                                t("modal:duplicate:user"),
                                ": ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: props.viewData.agency_user_name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: _imports_files_components_confirmation_modal__WEBPACK_IMPORTED_MODULE_1__/* .AgencyModalStyle.ConfirmationModal__SubText */ .cs.ConfirmationModal__SubText,
                            children: [
                                t("modal:duplicate:agency"),
                                ": ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: props.viewData.agency_name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: _imports_files_components_confirmation_modal__WEBPACK_IMPORTED_MODULE_1__/* .AgencyModalStyle.ConfirmationModal__SubText */ .cs.ConfirmationModal__SubText,
                            children: [
                                t("modal:duplicate:job"),
                                ": ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: props.viewData.job_title
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: _imports_files_components_confirmation_modal__WEBPACK_IMPORTED_MODULE_1__/* .AgencyModalStyle.ConfirmationModal__SubText */ .cs.ConfirmationModal__SubText,
                            children: [
                                t("modal:duplicate:candidate_name"),
                                ": ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: props.viewData.candidate_name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: _imports_files_components_confirmation_modal__WEBPACK_IMPORTED_MODULE_1__/* .AgencyModalStyle.ConfirmationModal__SubText */ .cs.ConfirmationModal__SubText,
                            children: [
                                t("modal:duplicate:date_submitted"),
                                ": ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: props.viewData.date_submitted
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: _imports_files_components_confirmation_modal__WEBPACK_IMPORTED_MODULE_1__/* .AgencyModalStyle.ConfirmationModal__NewText */ .cs.ConfirmationModal__NewText,
                            children: t("modal:duplicate:confirmation_heading")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_2__/* .FormModalStyle.Modal__Container__ButtonSection */ .w2.Modal__Container__ButtonSection,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_imports_files_components_confirmation_modal__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                            buttonstyle: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_2__/* .FormModalStyle.secondarybtn */ .w2.secondarybtn),
                            onClick: function() {
                                props.closeModal();
                            },
                            children: [
                                " ",
                                (props === null || props === void 0 ? void 0 : (ref = props.texts) === null || ref === void 0 ? void 0 : ref.button1_text) || t("modal:duplicate:decline"),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_imports_files_components_confirmation_modal__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                            buttonstyle: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_2__/* .FormModalStyle.primarybtn */ .w2.primarybtn),
                            onClick: function() {
                                props.btnAction();
                            },
                            children: [
                                " ",
                                (props === null || props === void 0 ? void 0 : (ref1 = props.texts) === null || ref1 === void 0 ? void 0 : ref1.button2_text) || t("modal:duplicate:accept")
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 42927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ CommunicationBulkActionModal; }
});

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ./src/actions/components/datatableActionOptions/communication-center-options-actions.js
var communication_center_options_actions = __webpack_require__(55384);
;// CONCATENATED MODULE: ./src/actions/components/bulk-action-modal/communication-bulk-action.js



var CommunicationBulkAction = /*#__PURE__*/ function() {
    "use strict";
    function CommunicationBulkAction(router, t) {
        (0,_class_call_check/* default */.Z)(this, CommunicationBulkAction);
        this.router = router;
        this.communicationCenterOptionsActions = new communication_center_options_actions/* CommunicationCenterOptionsActions */.e(router);
        this.t = t;
    }
    (0,_create_class/* default */.Z)(CommunicationBulkAction, [
        {
            key: "bulk_mark_as_read",
            value: function bulk_mark_as_read(props) {
                var _this = this;
                props.confirmationModal.state = true;
                props.confirmationModal.message = this.t("modal:confirmation:mark_as_read");
                props.confirmationModal.confirm_btn_action = function() {
                    _this.communicationCenterOptionsActions.markAsRead(props);
                };
                props.setConfirmationModal(props.confirmationModal);
                props.setFlagForRerender(Math.random() * 10000);
            }
        },
        {
            key: "bulk_mark_as_unread",
            value: function bulk_mark_as_unread(props) {
                var _this = this;
                props.confirmationModal.state = true;
                props.confirmationModal.message = this.t("modal:confirmation:mark_as_unread");
                props.confirmationModal.confirm_btn_action = function() {
                    _this.communicationCenterOptionsActions.markAsUnread(props);
                };
                props.setConfirmationModal(props.confirmationModal);
                props.setFlagForRerender(Math.random() * 10000);
            }
        },
        {
            key: "bulk_dismiss",
            value: function bulk_dismiss(props) {
                var _this = this;
                props.confirmationModal.state = true;
                props.confirmationModal.message = this.t("modal:confirmation:bulk_delete_email");
                props.confirmationModal.confirm_btn_action = function() {
                    _this.communicationCenterOptionsActions.dismiss(props);
                };
                props.setConfirmationModal(props.confirmationModal);
                props.setFlagForRerender(Math.random() * 10000);
            }
        }
    ]);
    return CommunicationBulkAction;
}();

// EXTERNAL MODULE: ./src/imports-files/components/candidate-bulk-action-modal.js
var candidate_bulk_action_modal = __webpack_require__(16700);
// EXTERNAL MODULE: ../../shared/node_modules/next/router.js
var next_router = __webpack_require__(34357);
// EXTERNAL MODULE: ../../shared/node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(73732);
;// CONCATENATED MODULE: ./src/components/bulk-action-modal/communication-bulk-action.js





function CommunicationBulkActionModal(props) {
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "CommunicationBulkAction ".concat(candidate_bulk_action_modal/* ComponentStyle.CandidateBulkActionSection */.c2.CandidateBulkActionSection),
        children: [
            router.query.email_type == "inbox" && /*#__PURE__*/ (0,jsx_runtime.jsx)(candidate_bulk_action_modal/* Button */.zx, {
                buttonstyle: candidate_bulk_action_modal/* ComponentStyle.primarybtn */.c2.primarybtn,
                onClick: function() {
                    new CommunicationBulkAction(router, t).bulk_mark_as_read(props);
                },
                children: t("button:mark_as_read")
            }),
            router.query.email_type == "inbox" && /*#__PURE__*/ (0,jsx_runtime.jsx)(candidate_bulk_action_modal/* Button */.zx, {
                buttonstyle: candidate_bulk_action_modal/* ComponentStyle.primarybtn */.c2.primarybtn,
                onClick: function() {
                    new CommunicationBulkAction(router, t).bulk_mark_as_unread(props);
                },
                children: t("button:mark_as_unread")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(candidate_bulk_action_modal/* Button */.zx, {
                buttonstyle: candidate_bulk_action_modal/* ComponentStyle.primarybtn */.c2.primarybtn,
                onClick: function() {
                    new CommunicationBulkAction(router, t).bulk_dismiss(props);
                },
                children: t("button:delete")
            })
        ]
    });
}


/***/ }),

/***/ 4725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ CancelInterview; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2443);
/* harmony import */ var _styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_datetime_css_react_datetime_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18202);
/* harmony import */ var react_datetime_css_react_datetime_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_datetime_css_react_datetime_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96047);
/* harmony import */ var _imports_files_components_confirmation_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46464);
/* harmony import */ var _imports_files_pages_interviews_cronofy__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57378);
/* harmony import */ var _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66172);









function CancelInterview(param) {
    var setBtnPopup = param.setBtnPopup, token = param.token, router = param.router, cancelledBy = param.cancelledBy, setInitialData = param.setInitialData, setFlagForRender = param.setFlagForRender;
    var showReasonSection = function showReasonSection() {
        document.querySelector(".confirmationSection").classList.add("dnone");
        document.querySelector(".reasonSection").classList.remove("dnone");
    };
    var t = (0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var initialValues = {
        reason: ""
    };
    var validationSchema = _imports_files_pages_interviews_cronofy__WEBPACK_IMPORTED_MODULE_4__/* .Yup.object */ .sm.object({
        reason: _imports_files_pages_interviews_cronofy__WEBPACK_IMPORTED_MODULE_4__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_interviews_cronofy__WEBPACK_IMPORTED_MODULE_4__/* .TRANSLATION */ .TA)("errors:required"))
    });
    var confirmHint = cancelledBy == "client" ? t("modal:confirmation:interview:client_cancel") : t("modal:confirmation:interview:cancel");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__/* .FormModalStyle.ModalOverlay */ .w2.ModalOverlay),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__/* .FormModalStyle.Modal */ .w2.Modal),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__/* .FormModalStyle.Modal__Container */ .w2.Modal__Container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__/* .FormModalStyle.Modal__Container__Heading__Close */ .w2.Modal__Container__Heading__Close),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: " ".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__/* .FormModalStyle.Modal__Container__ContentSection__Heading */ .w2.Modal__Container__ContentSection__Heading),
                                children: t("button:cancel_interview")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__/* .FormModalStyle.Modal__Container__CloseSection */ .w2.Modal__Container__CloseSection),
                                onClick: function() {
                                    return setBtnPopup(false);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__/* .Close */ .x8, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__/* .FormModalStyle.Modal__Container__ContentSection */ .w2.Modal__Container__ContentSection),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__/* .FormModalStyle.Modal__Container__ContentSection__Description */ .w2.Modal__Container__ContentSection__Description),
                                children: confirmHint
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat(_imports_files_components_confirmation_modal__WEBPACK_IMPORTED_MODULE_3__/* .ComponentStyle.CancelInterview__Content */ .c2.CancelInterview__Content, " mt30"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .Formik */ .J9, {
                                    initialValues: initialValues,
                                    validationSchema: validationSchema,
                                    onSubmit: function() {
                                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(values) {
                                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (!(cancelledBy == "client")) return [
                                                            3,
                                                            2
                                                        ];
                                                        return [
                                                            4,
                                                            (0,_imports_files_pages_interviews_cronofy__WEBPACK_IMPORTED_MODULE_4__/* .cancelInterviewByClient */ .hw)(values, token, setBtnPopup, router, setInitialData, setFlagForRender)
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 2:
                                                        return [
                                                            4,
                                                            (0,_imports_files_pages_interviews_cronofy__WEBPACK_IMPORTED_MODULE_4__/* .cancelInterviewByCandidate */ .Dq)(values, token, router, setBtnPopup, setInitialData)
                                                        ];
                                                    case 3:
                                                        _state.sent();
                                                        _state.label = 4;
                                                    case 4:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(values) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }(),
                                    children: function(formik) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .Form */ .l0, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().Form__TableCol)),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                            className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().Form__FloatingLabel)),
                                                            style: (0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "reason"),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "red-color",
                                                                    children: "*"
                                                                }),
                                                                "\xa0",
                                                                t("label:reason_to_cancel_interview")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                            control: "customtextarea",
                                                            type: "text",
                                                            formik: formik,
                                                            className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().Form__Textarea), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().Form__TextareaPlaceholder)),
                                                            placeholder: t("placeholder:write_here"),
                                                            name: "reason",
                                                            style: (0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "reason")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__/* .FormModalStyle.Modal__Container__ButtonSection */ .w2.Modal__Container__ButtonSection),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_confirmation_modal__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                                                            buttonstyle: _imports_files_components_confirmation_modal__WEBPACK_IMPORTED_MODULE_3__/* .ComponentStyle.secondarybtnborder */ .c2.secondarybtnborder,
                                                            type: "button",
                                                            onClick: function() {
                                                                return setBtnPopup(false);
                                                            },
                                                            children: t("button:no_changed_my_mind")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_confirmation_modal__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                                                            buttonstyle: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().primarybtn),
                                                            type: "submit",
                                                            children: t("button:cancel_interview")
                                                        })
                                                    ]
                                                })
                                            ]
                                        });
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 63583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CandidateEmail": function() { return /* binding */ CandidateEmail; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/styles/components/candidate-email/_index.module.scss
var _index_module = __webpack_require__(22842);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ../../shared/node_modules/react-simple-tooltip/es/index.js + 11 modules
var es = __webpack_require__(54392);
// EXTERNAL MODULE: ./src/imports-files/components/add-to-job-modal.js + 2 modules
var add_to_job_modal = __webpack_require__(60838);
;// CONCATENATED MODULE: ./src/constants/components/candidate-email.js

var CANDIDATE_EMAIL_VALUES = {
    email: {
        purpose: "",
        to: "",
        cc: [],
        subject: "",
        body: "",
        reply_to: "",
        references: "",
        forward: "",
        attachments: [],
        comm_detail_id: "",
        entity_type: ""
    }
};
var CANDIDATE_EMAIL_VALIDATION = add_to_job_modal/* Yup.object */.sm.object({
    email: add_to_job_modal/* Yup.object */.sm.object({
        subject: add_to_job_modal/* Yup.string */.sm.string().required((0,add_to_job_modal/* TRANSLATION */.TA)("errors:required")),
        body: add_to_job_modal/* Yup.string */.sm.string().required((0,add_to_job_modal/* TRANSLATION */.TA)("errors:required")),
        reply_to: add_to_job_modal/* Yup.string */.sm.string()
    })
});
var TEXTS = function(t) {
    return {
        send_email: {
            heading: t("modal:email_modal:send_email_heading")
        },
        job_application: {
            heading: t("modal:email_modal:send_email_heading")
        },
        reply_email: {
            heading: t("modal:email_modal:reply_email_heading")
        },
        To: t("modal:email_modal:to"),
        reply_to: t("modal:email_modal:reply_to"),
        Email_Body: t("modal:email_modal:email_body"),
        Subject: t("modal:email_modal:subject"),
        CC: t("modal:email_modal:cc"),
        Attachment: t("modal:email_modal:attachment"),
        ADD_DOCUMENT: t("modal:email_modal:add_document"),
        Save: t("modal:email_modal:save"),
        purpose: t("modal:email_modal:purpose"),
        tag_heading: t("modal:email_modal:tag_heading"),
        insert_token: "insert_token"
    };
};

// EXTERNAL MODULE: ./src/actions/components/candidate-email.js + 1 modules
var candidate_email = __webpack_require__(20344);
// EXTERNAL MODULE: ../../shared/node_modules/next/image.js
var next_image = __webpack_require__(53429);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/actions/components/share-cv.js + 2 modules
var share_cv = __webpack_require__(75868);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/candidates/kanban.js + 10 modules
var kanban = __webpack_require__(47942);
// EXTERNAL MODULE: ./src/imports-files/components/review-email.js + 1 modules
var review_email = __webpack_require__(3623);
// EXTERNAL MODULE: ./src/imports-files/components/common-modal/common-modal.js + 2 modules
var common_modal = __webpack_require__(66172);
// EXTERNAL MODULE: ../../shared/node_modules/lodash.clonedeep/index.js
var lodash_clonedeep = __webpack_require__(10552);
var lodash_clonedeep_default = /*#__PURE__*/__webpack_require__.n(lodash_clonedeep);
;// CONCATENATED MODULE: ./src/components/candidate-email.js

















function CandidateEmail(props) {
    var editSubjectHtml = function editSubjectHtml(subject) {
        var new_subject = subject.replace(/(<([^>]+)>)/gi, "");
        new_subject = new_subject.replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&gt;/g, ">").replace(/&lt;/g, "<").replace(/&rsquo;/g, "’").replace(/&ouml;/g, "\xf6").replace(/&oslash;/g, "\xf8").replace(/&auml;/g, "\xe4").replace(/&aring;/g, "\xe5");
        new_subject = new_subject.replace(/\n/g, " ");
        return new_subject.trim();
    };
    var t = (0,common/* useTranslation */.$G)().t;
    var editorRef = (0,common/* useRef */.sO)(null);
    var router = (0,common/* useRouter */.tv)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), attachmentList = ref[0], setAttachmentList = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(CANDIDATE_EMAIL_VALUES), 2), initialCandidateEmailValues = ref1[0], setCandidateEmailInitalValues = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(0), 2), flagForRerender = ref2[0], setFlagForRerender = ref2[1];
    var ccValues = null;
    if (props.replySubject) {
        var ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        ccValues = lodash_clonedeep_default()((props === null || props === void 0 ? void 0 : (ref3 = props.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.comm_detail) === null || ref4 === void 0 ? void 0 : ref4.cc) || (props === null || props === void 0 ? void 0 : (ref5 = props.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.all_data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.comm_detail) === null || ref7 === void 0 ? void 0 : ref7.cc) || (props === null || props === void 0 ? void 0 : (ref8 = props.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.all_data) === null || ref9 === void 0 ? void 0 : ref9.cc) || (props === null || props === void 0 ? void 0 : props.ccEmails) || []);
    } else {
        var ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
        ccValues = lodash_clonedeep_default()((props === null || props === void 0 ? void 0 : (ref10 = props.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.comm_detail) === null || ref11 === void 0 ? void 0 : ref11.cc) || (props === null || props === void 0 ? void 0 : (ref12 = props.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.all_data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.comm_detail) === null || ref14 === void 0 ? void 0 : ref14.cc) || (props === null || props === void 0 ? void 0 : (ref15 = props.data) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.all_data) === null || ref16 === void 0 ? void 0 : ref16.cc) || (props === null || props === void 0 ? void 0 : (ref17 = props.data) === null || ref17 === void 0 ? void 0 : ref17.cc) || (props === null || props === void 0 ? void 0 : props.candidateCc) || []);
    }
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(ccValues), 2), selectedValues = ref18[0], setSelectedValues = ref18[1];
    var ref19 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), selectedToValues = ref19[0], setSelectedToValues = ref19[1];
    var ref20 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(""), 2), toValue = ref20[0], setToValue = ref20[1];
    var ref21 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(""), 2), value = ref21[0], setValue = ref21[1];
    var ref22 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), suggestion = ref22[0], setSuggestion = ref22[1];
    var formRef = (0,common/* useRef */.sO)(null);
    var autosuggest_action = new share_cv/* ActionShareCv */.o(setValue, setSuggestion);
    var ref23 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(null), 2), selectedUserCount = ref23[0], setSelectedUserCount = ref23[1];
    var ref24 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(0), 2), selectedToUserCount = ref24[0], setSelectedToUserCount = ref24[1];
    var ref25 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), showLoader = ref25[0], setShowLoader = ref25[1];
    var reviewEmailActions = new review_email/* ReviewEmailActions */.fY();
    var ref26 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), purposeList = ref26[0], setPurposeList = ref26[1];
    var ref27 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(reviewEmailActions.subjectVars(t)), 2), subject = ref27[0], setSubject = ref27[1];
    var ref28 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(reviewEmailActions.bodyVars(t)), 2), dataVariables = ref28[0], setDataVariables = ref28[1];
    var editorBodyRef = (0,common/* useRef */.sO)(null);
    var editorSubjectRef = (0,common/* useRef */.sO)(null);
    var ref29 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(true), 2), isLoading = ref29[0], setIsLoading = ref29[1];
    (0,common/* useEffect */.d4)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    initialCandidateEmailValues.email.reply_to = props.messageId || props.replyTo;
                    initialCandidateEmailValues.email.subject = props.replySubject;
                    initialCandidateEmailValues.email.comm_detail_id = props.comm_detail_id;
                    initialCandidateEmailValues.email.references = props.references;
                    initialCandidateEmailValues.email.body = props.forward ? props.email_body || "" : "";
                    initialCandidateEmailValues.email.forward = props.forward;
                    setCandidateEmailInitalValues(initialCandidateEmailValues);
                    _tmp = {};
                    return [
                        4,
                        reviewEmailActions.getSystemPurposeList((_tmp.only_custom = true, _tmp))
                    ];
                case 1:
                    setPurposeList.apply(void 0, [
                        candidate_email/* getPurposeOptions.apply */.E7.apply(void 0, [
                            _state.sent()
                        ])
                    ]);
                    _tmp1 = {};
                    props.forward ? setSelectedToValues([
                        (_tmp1.name = props === null || props === void 0 ? void 0 : props.system_notification_email, _tmp1.email = props === null || props === void 0 ? void 0 : props.system_notification_email, _tmp1)
                    ]) : ((ref = props.data) === null || ref === void 0 ? void 0 : (ref1 = ref.application) === null || ref1 === void 0 ? void 0 : ref1.view_source_name) == "Agency" ? (0,candidate_email/* agencyEmailTo */.uF)(props, selectedToValues, setSelectedToValues) : "";
                    setIsLoading(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        props,
        flagForRerender
    ]);
    if (isLoading) {
        return "";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(review_email/* FormModalStyle.ModalOverlay */.w2.ModalOverlay),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(review_email/* FormModalStyle.Modal */.w2.Modal),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat(review_email/* FormModalStyle.Modal__Container */.w2.Modal__Container),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat(review_email/* FormModalStyle.Modal__Container__Heading__Close */.w2.Modal__Container__Heading__Close),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: review_email/* FormModalStyle.Modal__Container__ContentSection__Heading */.w2.Modal__Container__ContentSection__Heading,
                                    children: props.replyTo || props.messageId ? TEXTS(t)["reply_email"]["heading"] : TEXTS(t)[props.email_type]["heading"]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(review_email/* FormModalStyle.Modal__Container__CloseSection */.w2.Modal__Container__CloseSection),
                                    onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!props.isActiveEmail) return [
                                                        3,
                                                        2
                                                    ];
                                                    props.setEmailModal(false);
                                                    return [
                                                        4,
                                                        (0,kanban/* markActiveUnsuccessful */.KF)(props)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        3,
                                                        3
                                                    ];
                                                case 2:
                                                    props.setEmailModal(false);
                                                    _state.label = 3;
                                                case 3:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal/* Close */.x8, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: review_email/* FormModalStyle.Modal__Container__ContentSection */.w2.Modal__Container__ContentSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Formik */.J9, {
                                initialValues: initialCandidateEmailValues,
                                validationSchema: CANDIDATE_EMAIL_VALIDATION,
                                innerRef: formRef,
                                onSubmit: function(values, event) {
                                    values.email.subject = editSubjectHtml(values.email.subject);
                                    if (props.email_type == "send_email") {
                                        (0,candidate_email/* submitKanbanEmail */.WF)({
                                            values: values,
                                            router: router,
                                            setEmailModal: props.setEmailModal,
                                            selectedValues: selectedValues,
                                            selectedCards: props.selectedCards,
                                            setSelectedCards: props.setSelectedCards,
                                            setActionBar: props.setActionBar,
                                            status: props.status,
                                            moving_status: props.moving_status,
                                            isActiveEmail: props.isActiveEmail,
                                            setJobData: props.setJobData,
                                            activeTab: props.activeTab,
                                            filterData: props.filterData,
                                            job_id: props.job_id,
                                            from: props.from,
                                            setInitialData: props.setInitialData,
                                            setShowLoader: setShowLoader
                                        });
                                    } else {
                                        (0,candidate_email/* submitCandidateEmail */.nc)(values, router, props.setEmailModal, props.setFlagForRerender, props.initialData, props.setInitialData, selectedValues, selectedToValues, setShowLoader, props.entity_id, props.entity_type, formRef);
                                    }
                                },
                                children: function(formik) {
                                    var ref, ref1, ref2, ref3, ref4;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(common/* Form */.l0, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block__TextContainer */.w2.Modal__Container__ContentSection__Block__TextContainer, " ").concat((_index_module_default()).Form__TableCol),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: "".concat((_index_module_default()).Form__FloatingLabel),
                                                            children: [
                                                                TEXTS(t).purpose,
                                                                "\xa0",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
                                                                    className: "SimpleTooltip",
                                                                    content: t("placeholder:select_from_your_templates"),
                                                                    background: "#00325A",
                                                                    radius: 20,
                                                                    padding: 8,
                                                                    placement: "top",
                                                                    fontSize: "12px",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                        className: "tooltipwidthinterview200 d-flex align-items-center",
                                                                        children: [
                                                                            "\xa0",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Exclamation */.P5, {})
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                            control: "select",
                                                            type: "text",
                                                            formik: formik,
                                                            placeholder: t("placeholder:select:default"),
                                                            errorClass: (_index_module_default()).Form__Error,
                                                            className: "".concat((_index_module_default()).Form__Input, " thresholdmodl"),
                                                            name: "email.purpose",
                                                            options: purposeList,
                                                            style: (0,common/* InputError */.pd)(formik, "email.purpose"),
                                                            onChange: function() {
                                                                var _ref = (0,_async_to_generator/* default */.Z)(function(option) {
                                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    (0,candidate_email/* getCustomTemplate */.x9)(option, formik, setSubject, setDataVariables, setFlagForRerender, t)
                                                                                ];
                                                                            case 1:
                                                                                _state.sent();
                                                                                return [
                                                                                    2
                                                                                ];
                                                                        }
                                                                    });
                                                                });
                                                                return function(option) {
                                                                    return _ref.apply(this, arguments);
                                                                };
                                                            }()
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        className: review_email/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading,
                                                        children: props.replyTo || props.messageId ? TEXTS(t).reply_to : TEXTS(t).To
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block,
                                                        children: [
                                                            !props.forward && !(((ref = props.data) === null || ref === void 0 ? void 0 : (ref1 = ref.application) === null || ref1 === void 0 ? void 0 : ref1.view_source_name) == "Agency") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (_index_module_default()).SetupPopup__ToChips,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "".concat((_index_module_default()).SetupPopup__ToName, " fw600"),
                                                                        children: [
                                                                            props.from == "kanban" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                children: [
                                                                                    props === null || props === void 0 ? void 0 : props.system_notification_email,
                                                                                    ",",
                                                                                    " ",
                                                                                    (0,candidate_email/* getCandidateName */.o5)(props.selectedCards),
                                                                                    " "
                                                                                ]
                                                                            }) : (0,candidate_email/* getEmailTo */.BF)(props),
                                                                            props.selectedCards && props.candidate_count > 1 ? " + ".concat(props.candidate_count - 1, " More") : ""
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            (props.forward || ((ref2 = props.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.application) === null || ref3 === void 0 ? void 0 : ref3.view_source_name) == "Agency") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                        control: "autosuggestInput",
                                                                        errorClass: (_index_module_default()).Form__Error,
                                                                        formik: formik,
                                                                        getSuggestionValue: autosuggest_action.getSuggestionValue,
                                                                        inputProps: {
                                                                            className: "AutosuggestOpenUp ".concat((_index_module_default()).Form__Input),
                                                                            formik: formik,
                                                                            name: "email.to",
                                                                            onChange: function(value, param) {
                                                                                var newValue = param.newValue;
                                                                                formik.touched["email.to"] = true;
                                                                                formik.setStatus("email.to", "");
                                                                                setToValue(newValue);
                                                                            },
                                                                            onKeyDown: function(event) {
                                                                                autosuggest_action.handleKeyDown(event, selectedToValues, setSelectedToValues, setSelectedToUserCount, setToValue, formik);
                                                                            },
                                                                            placeholder: t("placeholder:search:type_name_search"),
                                                                            style: (0,common/* InputError */.pd)(formik, "email.to"),
                                                                            value: toValue
                                                                        },
                                                                        onSuggestionsClearRequested: autosuggest_action.onSuggestionsClearRequested,
                                                                        onSuggestionsFetchRequested: autosuggest_action.onSuggestionsFetchRequested,
                                                                        onSuggestionSelected: function(event, param) {
                                                                            var suggestion = param.suggestion;
                                                                            if (suggestion.user_attributes.email.length > 0) {
                                                                                setToValue("");
                                                                                autosuggest_action.onSuggestionSelectionEmail({
                                                                                    email: suggestion.user_attributes.email,
                                                                                    name_initials: suggestion.user_attributes.name_initials,
                                                                                    name: suggestion.user_attributes.name,
                                                                                    photo_url: suggestion.user_attributes.photo_url
                                                                                }, selectedToValues, setSelectedToValues, setToValue, setSelectedToUserCount, formik);
                                                                            }
                                                                        },
                                                                        renderSuggestion: autosuggest_action.renderSuggestion,
                                                                        renderInputComponent: function(props) {
                                                                            return autosuggest_action.renderInputComponent(props, selectedToValues, setSelectedToValues, setSelectedToUserCount, setToValue);
                                                                        },
                                                                        shouldRenderSuggestions: autosuggest_action.shouldRenderSuggestions,
                                                                        suggestions: suggestion,
                                                                        type: "email"
                                                                    }),
                                                                    selectedToValues.map(function(element, index) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "Sharecv emailchipsspace ".concat((_index_module_default()).Tagrow),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: (_index_module_default()).Tagrow__Tags,
                                                                                children: [
                                                                                    (element === null || element === void 0 ? void 0 : element.photo_url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        src: element === null || element === void 0 ? void 0 : element.photo_url,
                                                                                        className: "JobImageSmall"
                                                                                    }) : element.name_initials && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: (_index_module_default()).Tagrow__Prefix,
                                                                                        children: element.name_initials
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                        className: "ml6 mb0",
                                                                                        children: element.name || element.email
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                        type: "button",
                                                                                        className: (_index_module_default()).Tagrow__Cancel,
                                                                                        onClick: function(event) {
                                                                                            return autosuggest_action.removeSelectedValues(event, selectedToValues, setSelectedToValues, setSelectedToUserCount);
                                                                                        },
                                                                                        "data-index": index,
                                                                                        children: element.email != (props === null || props === void 0 ? void 0 : props.system_notification_email) && /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal/* Close */.x8, {})
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }, index);
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((_index_module_default()).Form__TableCol),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        className: (_index_module_default()).Form__FloatingLabel,
                                                        children: TEXTS(t).CC
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                        control: "autosuggestInput",
                                                        errorClass: (_index_module_default()).Form__Error,
                                                        formik: formik,
                                                        getSuggestionValue: autosuggest_action.getSuggestionValue,
                                                        inputProps: {
                                                            className: "AutosuggestOpenUp ".concat((_index_module_default()).Form__Input),
                                                            formik: formik,
                                                            name: "email.cc",
                                                            onChange: function(value, param) {
                                                                var newValue = param.newValue;
                                                                formik.touched["email.cc"] = true;
                                                                formik.setStatus("email.cc", "");
                                                                setValue(newValue);
                                                            },
                                                            placeholder: t("placeholder:search:type_name_search"),
                                                            style: (0,common/* InputError */.pd)(formik, "email.cc"),
                                                            value: value,
                                                            onKeyDown: function(event) {
                                                                if ([
                                                                    "Enter"
                                                                ].includes(event.key)) event.preventDefault();
                                                            }
                                                        },
                                                        onSuggestionsClearRequested: autosuggest_action.onSuggestionsClearRequested,
                                                        onSuggestionsFetchRequested: autosuggest_action.onSuggestionsFetchRequested,
                                                        onSuggestionSelected: function(event, param) {
                                                            var suggestion = param.suggestion;
                                                            if (suggestion.user_attributes.email.length > 0) {
                                                                setValue("");
                                                                autosuggest_action.onSuggestionSelectionEmail({
                                                                    email: suggestion.user_attributes.email,
                                                                    name_initials: suggestion.user_attributes.name_initials,
                                                                    name: suggestion.user_attributes.name,
                                                                    photo_url: suggestion.user_attributes.photo_url
                                                                }, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik);
                                                            }
                                                        },
                                                        renderSuggestion: autosuggest_action.renderSuggestion,
                                                        shouldRenderSuggestions: autosuggest_action.shouldRenderSuggestions,
                                                        suggestions: suggestion,
                                                        type: "email"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "Dpflexonly Flexflow",
                                                        children: selectedValues.map(function(element, index) {
                                                            return element.email && element.email != (props === null || props === void 0 ? void 0 : props.system_notification_email) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "Sharecv emailchipsspace ".concat((_index_module_default()).Tagrow),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (_index_module_default()).Tagrow__Tags,
                                                                    children: [
                                                                        (element === null || element === void 0 ? void 0 : element.photo_url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: element === null || element === void 0 ? void 0 : element.photo_url,
                                                                            className: "JobImageSmall"
                                                                        }) : element.name_initials && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (_index_module_default()).Tagrow__Prefix,
                                                                            children: element.name_initials
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "ml6",
                                                                            children: element.name || element.email
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                            type: "button",
                                                                            className: (_index_module_default()).Tagrow__Cancel,
                                                                            onClick: function(event) {
                                                                                return autosuggest_action.removeSelectedValues(event, selectedValues, setSelectedValues, setSelectedUserCount);
                                                                            },
                                                                            "data-index": index,
                                                                            children: element.email != (props === null || props === void 0 ? void 0 : props.system_notification_email) && /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal/* Close */.x8, {})
                                                                        })
                                                                    ]
                                                                })
                                                            }, index);
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((_index_module_default()).Form__TableCol, " mt30"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "".concat((_index_module_default()).Form__FloatingLabel),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "red-color",
                                                                children: "*"
                                                            }),
                                                            "\xa0",
                                                            TEXTS(t).Subject
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                        id: "email_template_subject",
                                                        apiKey: "dxe0l6rdhdta2rzyfq2io208ncq1ay4l9wc2vyre3a53sdna",
                                                        control: "customEditor",
                                                        formik: formik,
                                                        onInit: function(evt, editor) {
                                                            return editorSubjectRef.current = editor;
                                                        },
                                                        textareaName: "email.subject",
                                                        identifierClass: "emailTemplateSubject",
                                                        style: (0,common/* InputError */.pd)(formik, "email.subject"),
                                                        value: formik.values.email.subject,
                                                        onEditorChange: function(value, editor) {
                                                            formik.setFieldValue("email.subject", value);
                                                        },
                                                        init: {
                                                            height: 50,
                                                            resize: false,
                                                            menubar: false,
                                                            plugins: [
                                                                "advlist autolink lists link image charmap print preview anchor",
                                                                "searchreplace visualblocks code fullscreen",
                                                                "insertdatetime media table paste help wordcount autoresize  noneditable", 
                                                            ],
                                                            readOnly: (props === null || props === void 0 ? void 0 : (ref4 = props.replyTo) === null || ref4 === void 0 ? void 0 : ref4.length) > 0,
                                                            toolbar: "tokens",
                                                            content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                                            newline_behavior: "block",
                                                            noneditable_regexp: /\{\{[^\}]+\}\}/g,
                                                            setup: function(editor) {
                                                                editor.ui.registry.addMenuButton("tokens", {
                                                                    text: TEXTS(t).tag_heading,
                                                                    tooltip: TEXTS(t).insert_token,
                                                                    fetch: function(callback) {
                                                                        var items = subject.map(function(subject) {
                                                                            return {
                                                                                type: "menuitem",
                                                                                text: subject.text,
                                                                                onAction: function() {
                                                                                    editor.insertContent(subject.value);
                                                                                }
                                                                            };
                                                                        });
                                                                        callback(items);
                                                                    }
                                                                });
                                                                editor.on("keydown", function(e) {
                                                                    if (e.keyCode == 13) {
                                                                        e.preventDefault();
                                                                    }
                                                                });
                                                            },
                                                            paste_preprocess: function paste_preprocess(plugin, args) {
                                                                args.content = args.content.replace(/(<([^>]+)>)/gi, "");
                                                            }
                                                        }
                                                    }, flagForRerender)
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((_index_module_default()).Form__TableCol, " mt10"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "".concat((_index_module_default()).Form__FloatingLabel),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "red-color",
                                                                children: "*"
                                                            }),
                                                            "\xa0",
                                                            TEXTS(t).Email_Body
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                        id: "email_template_body",
                                                        control: "customEditor",
                                                        formik: formik,
                                                        onInit: function(evt, editor) {
                                                            return editorBodyRef.current = editor;
                                                        },
                                                        textareaName: "email.body",
                                                        identifierClass: "emailTemplateBody",
                                                        style: (0,common/* InputError */.pd)(formik, "email.body"),
                                                        value: formik.values.email.body,
                                                        onEditorChange: function(value) {
                                                            formik.setFieldValue("email.body", value);
                                                        },
                                                        init: {
                                                            height: 500,
                                                            menubar: false,
                                                            resize: false,
                                                            plugins: [
                                                                "advlist",
                                                                "autolink",
                                                                "lists",
                                                                "link",
                                                                "image",
                                                                "charmap",
                                                                "preview",
                                                                "anchor",
                                                                "searchreplace",
                                                                "visualblocks",
                                                                "code",
                                                                "fullscreen",
                                                                "insertdatetime",
                                                                "media",
                                                                "table",
                                                                "help",
                                                                "wordcount",
                                                                "noneditable", 
                                                            ],
                                                            toolbar: "undo redo | blocks | " + "bold italic backcolor | link | alignleft aligncenter " + "alignright alignjustify | tokens",
                                                            content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                                            noneditable_regexp: /\{\{[^\}]+\}\}/g,
                                                            allow_html_in_named_anchor: true,
                                                            setup: function(editor) {
                                                                editor.ui.registry.addMenuButton("tokens", {
                                                                    text: TEXTS(t).tag_heading,
                                                                    tooltip: TEXTS(t).insert_token,
                                                                    fetch: function(callback) {
                                                                        var items = dataVariables.map(function(dataVariable) {
                                                                            return {
                                                                                type: "menuitem",
                                                                                text: dataVariable.text,
                                                                                onAction: function() {
                                                                                    editor.insertContent(dataVariable.value);
                                                                                }
                                                                            };
                                                                        });
                                                                        callback(items);
                                                                    }
                                                                });
                                                            }
                                                        }
                                                    }, flagForRerender),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "hidden",
                                                        value: props.messageId,
                                                        name: "email.reply_to",
                                                        id: "reply_to"
                                                    }),
                                                    props.forward && /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "hidden",
                                                        value: props.forward,
                                                        name: "email.forward",
                                                        id: "forward"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "hidden",
                                                        value: props.references,
                                                        name: "email.references",
                                                        id: "references"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "hidden",
                                                        value: props.forward,
                                                        name: "email.forward",
                                                        id: "forward"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "hidden",
                                                        value: props.references,
                                                        name: "email.references",
                                                        id: "references"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "hidden",
                                                        name: "email.entity_type"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        htmlFor: "attachments",
                                                        className: review_email/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading,
                                                        children: TEXTS(t).Attachment
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "Dpflex addDoc",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                                onClick: function() {
                                                                    document.getElementById("attachments").click();
                                                                },
                                                                buttonstyle: (_index_module_default()).primarybtn,
                                                                children: TEXTS(t).ADD_DOCUMENT
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                id: "attachments",
                                                                className: "".concat((_index_module_default()).SetupPopup__AddFile),
                                                                name: "email.attachments",
                                                                type: "file",
                                                                multiple: true,
                                                                onChange: function(event) {
                                                                    var new_files = Array.from(event.currentTarget.files);
                                                                    var attachment_list = attachmentList.concat(new_files);
                                                                    setAttachmentList(attachment_list);
                                                                    formik.setFieldValue("email.attachments", attachment_list);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (_index_module_default()).SetupPopup__AttachmentContainer,
                                                                children: attachmentList.map(function(file, index) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "AttachmentChip ".concat((_index_module_default()).SetupPopup__Status),
                                                                        "data-index": index,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: (_index_module_default()).SetupPopup__Name,
                                                                                children: file.name
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (_index_module_default()).FileDisplayContainer__Close,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                    src: "/icons/close.png",
                                                                                    height: 13,
                                                                                    width: 13,
                                                                                    alt: "",
                                                                                    onClick: function(event) {
                                                                                        (0,candidate_email/* removeAttachment */.JZ)(event, attachmentList, setAttachmentList, setFlagForRerender);
                                                                                    }
                                                                                })
                                                                            })
                                                                        ]
                                                                    }, "attachments_".concat(index));
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: review_email/* FormModalStyle.Modal__Container__ButtonSection */.w2.Modal__Container__ButtonSection,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                    buttonstyle: (_index_module_default()).primarybtn,
                                                    type: "submit",
                                                    children: TEXTS(t).Save
                                                })
                                            })
                                        ]
                                    });
                                }
                            })
                        })
                    ]
                })
            }),
            showLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Loading */.gb, {})
        ]
    });
}


/***/ }),

/***/ 96719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/styles/components/careers/footer/_index.module.scss
var _index_module = __webpack_require__(83971);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
;// CONCATENATED MODULE: ./public/icons/career_icons/social_icons/twitter.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 25,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.124 2.942c-.86.377-1.78.634-2.747.752A4.813 4.813 0 0 0 23.48 1.05c-.925.539-1.95.931-3.04 1.15A4.768 4.768 0 0 0 16.949.686a4.778 4.778 0 0 0-4.66 5.863A13.556 13.556 0 0 1 2.43 1.575a4.672 4.672 0 0 0-.647 2.402c0 1.66.846 3.118 2.127 3.975a4.775 4.775 0 0 1-2.166-.598v.06a4.78 4.78 0 0 0 3.836 4.683 4.866 4.866 0 0 1-2.15.083 4.798 4.798 0 0 0 4.476 3.315 9.605 9.605 0 0 1-5.933 2.043c-.379 0-.757-.022-1.137-.065a13.624 13.624 0 0 0 7.347 2.143c8.802 0 13.61-7.273 13.61-13.571 0-.203 0-.408-.015-.611a9.65 9.65 0 0 0 2.391-2.473l-.045-.02Z",
    fill: "#4F4F4F"
  })));
};

/* harmony default export */ var twitter = (SvgTwitter);
;// CONCATENATED MODULE: ./public/icons/career_icons/social_icons/facebook.svg
var facebook_path;

function facebook_extends() { facebook_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return facebook_extends.apply(this, arguments); }



var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/react.createElement("svg", facebook_extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), facebook_path || (facebook_path = /*#__PURE__*/react.createElement("path", {
    d: "M28.337 0H1.663A1.675 1.675 0 0 0 0 1.663v26.674A1.675 1.675 0 0 0 1.663 30h14.362V18.4h-3.9v-4.537h3.9v-3.338c0-3.875 2.363-5.988 5.838-5.988 1.162 0 2.325 0 3.487.176V8.75h-2.388c-1.887 0-2.25.9-2.25 2.213v2.887h4.5l-.587 4.537h-3.913V30h7.625A1.675 1.675 0 0 0 30 28.337V1.663A1.675 1.675 0 0 0 28.337 0Z",
    fill: "var(--default-text-color)"
  })));
};

/* harmony default export */ var facebook = (SvgFacebook);
;// CONCATENATED MODULE: ./public/icons/career_icons/social_icons/linkedin.svg
var linkedin_path;

function linkedin_extends() { linkedin_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return linkedin_extends.apply(this, arguments); }



var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/react.createElement("svg", linkedin_extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), linkedin_path || (linkedin_path = /*#__PURE__*/react.createElement("path", {
    d: "M27.75 0H2.25C1 0 0 1 0 2.125V27.75c0 1.125 1 2.125 2.25 2.125h25.5c1.25 0 2.25-1 2.25-2.125V2.125C30 1 29 0 27.75 0ZM8.875 25.5H4.5V11.25h4.375V25.5ZM6.75 9.25c-1.375 0-2.625-1.125-2.625-2.625S5.25 4 6.75 4c1.375 0 2.625 1.125 2.625 2.625S8.125 9.25 6.75 9.25Zm18.875 16.125H21.25v-7c0-1.625 0-3.875-2.375-3.875s-2.625 1.875-2.625 3.625v7.125h-4.375v-14H16v1.875h.125c.625-1.125 2.125-2.375 4.25-2.375 4.5 0 5.375 3 5.375 6.875v7.75h-.125Z",
    fill: "var(--default-text-color)"
  })));
};

/* harmony default export */ var linkedin = (SvgLinkedin);
;// CONCATENATED MODULE: ./public/icons/career_icons/social_icons/instagram.svg
var instagram_path;

function instagram_extends() { instagram_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return instagram_extends.apply(this, arguments); }



var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/react.createElement("svg", instagram_extends({
    width: 31,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), instagram_path || (instagram_path = /*#__PURE__*/react.createElement("path", {
    d: "M9.374.867h12.25c4.667 0 8.459 3.785 8.459 8.443v12.227c0 2.239-.891 4.386-2.478 5.97a8.466 8.466 0 0 1-5.98 2.473H9.374c-4.667 0-8.459-3.785-8.459-8.443V9.31c0-2.24.891-4.387 2.477-5.97A8.466 8.466 0 0 1 9.374.867Zm-.291 2.911A5.255 5.255 0 0 0 5.37 5.313 5.235 5.235 0 0 0 3.833 9.02v12.81a5.242 5.242 0 0 0 5.25 5.24h12.833a5.255 5.255 0 0 0 3.712-1.535 5.235 5.235 0 0 0 1.538-3.706V9.018a5.242 5.242 0 0 0-5.25-5.24H9.083Zm14.073 2.184a1.825 1.825 0 0 1 1.823 1.82A1.818 1.818 0 0 1 23.155 9.6a1.825 1.825 0 0 1-1.823-1.82 1.818 1.818 0 0 1 1.823-1.82Zm-7.657 2.183c1.934 0 3.789.767 5.156 2.132a7.271 7.271 0 0 1 0 10.293 7.298 7.298 0 0 1-10.312 0 7.271 7.271 0 0 1 0-10.293A7.298 7.298 0 0 1 15.5 8.145Zm0 2.912c-1.16 0-2.273.46-3.093 1.278a4.363 4.363 0 0 0 0 6.176 4.379 4.379 0 0 0 6.187 0 4.363 4.363 0 0 0 0-6.175 4.38 4.38 0 0 0-3.094-1.28Z",
    fill: "#4F4F4F"
  })));
};

/* harmony default export */ var instagram = (SvgInstagram);
;// CONCATENATED MODULE: ./public/icons/career_icons/social_icons/youtube.svg
var youtube_path;

function youtube_extends() { youtube_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return youtube_extends.apply(this, arguments); }



var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/react.createElement("svg", youtube_extends({
    width: 34,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), youtube_path || (youtube_path = /*#__PURE__*/react.createElement("path", {
    d: "M33.94 7.447A7.447 7.447 0 0 0 26.493 0H7.447A7.447 7.447 0 0 0 0 7.447v8.86a7.447 7.447 0 0 0 7.447 7.447h19.046a7.447 7.447 0 0 0 7.447-7.447v-8.86Zm-11.2 5.095-8.54 4.223c-.333.183-1.471-.062-1.471-.44V7.651c0-.386 1.147-.626 1.48-.435l8.176 4.446c.342.195.702.689.356.88Z",
    fill: "#4F4F4F"
  })));
};

/* harmony default export */ var youtube = (SvgYoutube);
// EXTERNAL MODULE: ./src/imports-files/pages/career/customize-career-page.js + 40 modules
var customize_career_page = __webpack_require__(82352);
;// CONCATENATED MODULE: ./src/components/careers/footer.js








function Footer(param) {
    var formik = param.formik, customizeCareerAction = param.customizeCareerAction, isPreview = param.isPreview, footerClass = param.footerClass;
    var t = (0,customize_career_page/* useTranslation */.$G)().t;
    var footerLinks = formik.values.career_navigation_links_attributes.filter(function(navigation) {
        return !navigation._destroy && navigation.navigation_type == customize_career_page/* LINK_TYPES.footer */.RZ.footer;
    });
    var socialLink = formik.values.career_social_link_attributes;
    var commonAction = new customize_career_page/* CommonAction */.x4();
    var footer_link_with_name = footerLinks.filter(function(x) {
        return x.name;
    }).length;
    var social_with_name = (socialLink === null || socialLink === void 0 ? void 0 : socialLink.twitter_url) || (socialLink === null || socialLink === void 0 ? void 0 : socialLink.facebook_url) || (socialLink === null || socialLink === void 0 ? void 0 : socialLink.linkedin_url) || (socialLink === null || socialLink === void 0 ? void 0 : socialLink.instagram_url) || (socialLink === null || socialLink === void 0 ? void 0 : socialLink.youtube_url) || "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (social_with_name.length > 0 || footer_link_with_name > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((_index_module_default()).Footer, " ").concat(footerClass),
                children: [
                    footer_link_with_name > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((_index_module_default()).Footer__SocialIcons, " ").concat(social_with_name.length == 0 ? (_index_module_default()).Footer__LinksCenter : (_index_module_default()).Footer__Links),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: footerLinks.map(function(footerLink, index) {
                                return footerLink.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: footerLink.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        style: customizeCareerAction.headerStyle(formik),
                                        href: commonAction.addHttpOrHttps(footerLink.url),
                                        target: "_blank",
                                        children: footerLink.name
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        style: customizeCareerAction.headerStyle(formik),
                                        children: footerLink.name
                                    })
                                }, "f_link_".concat(index));
                            })
                        })
                    }),
                    social_with_name.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((_index_module_default()).Footer__Right, " ").concat(footer_link_with_name > 0 ? (_index_module_default()).Footer__SocialIconsRight : (_index_module_default()).Footer__SocialIconsCenter),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            children: [
                                (socialLink === null || socialLink === void 0 ? void 0 : socialLink.twitter_url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "".concat((_index_module_default()).Footer__Links__Li),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: commonAction.addHttpOrHttps(socialLink.twitter_url),
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(twitter, {})
                                    })
                                }, "twitter_url_f"),
                                (socialLink === null || socialLink === void 0 ? void 0 : socialLink.facebook_url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "".concat((_index_module_default()).Footer__Links__Li),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: commonAction.addHttpOrHttps(socialLink.facebook_url),
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(facebook, {})
                                    })
                                }, "facebook_url_f"),
                                (socialLink === null || socialLink === void 0 ? void 0 : socialLink.linkedin_url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "".concat((_index_module_default()).Footer__Links__Li),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: commonAction.addHttpOrHttps(socialLink.linkedin_url),
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(linkedin, {})
                                    })
                                }, "linkedin_url_f"),
                                (socialLink === null || socialLink === void 0 ? void 0 : socialLink.instagram_url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "".concat((_index_module_default()).Footer__Links__Li),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: commonAction.addHttpOrHttps(socialLink.instagram_url),
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(instagram, {})
                                    })
                                }, "instagram_url_f"),
                                (socialLink === null || socialLink === void 0 ? void 0 : socialLink.youtube_url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "".concat((_index_module_default()).Footer__Links__Li),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: commonAction.addHttpOrHttps(socialLink.youtube_url),
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube, {})
                                    })
                                }, "youtube_url_f")
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((_index_module_default()).Footer__Disclaimer),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("jobs:hiring_with")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/logo/Full-logo-default.svg"
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 31061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/styles/components/careers/header/_index.module.scss
var _index_module = __webpack_require__(54484);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
;// CONCATENATED MODULE: ./public/icons/career_icons/edit.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 23,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M15.853 13.977c-.078.078-.078.117-.078.195v4.453H2.025V4.875h9.453c.078 0 .117 0 .195-.078l1.25-1.25c.079-.078.118-.195.079-.352-.079-.117-.157-.195-.274-.195H2.025c-.547 0-.977.195-1.328.547-.39.39-.547.82-.547 1.328v13.75c0 .547.156.977.547 1.328.351.39.781.547 1.328.547h13.75a1.77 1.77 0 0 0 1.328-.547c.352-.351.547-.781.547-1.328v-5.664c0-.156-.078-.234-.195-.313-.157-.039-.274 0-.352.079l-1.25 1.25Zm6.133-7.891c.43-.43.664-.977.664-1.602 0-.625-.234-1.171-.664-1.64l-1.68-1.68C19.837.734 19.291.5 18.666.5s-1.172.234-1.602.664L6.791 11.438 6.4 14.953c-.078.547.078.977.469 1.328.351.39.781.547 1.328.469l3.516-.39L21.986 6.085Zm-3.867 1.21-7.266 7.266-2.539.274.274-2.54 7.265-7.265 2.266 2.266Zm2.539-3.124a.444.444 0 0 1 .117.312c0 .118-.04.196-.117.274l-1.211 1.21-2.266-2.265 1.211-1.21a.354.354 0 0 1 .274-.118c.117 0 .234.04.312.117l1.68 1.68Z",
    fill: "var(--default-text-color)"
  })));
};

/* harmony default export */ var edit = (SvgEdit);
;// CONCATENATED MODULE: ./public/icons/career_icons/bars.svg
var bars_path;

function bars_extends() { bars_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bars_extends.apply(this, arguments); }



var SvgBars = function SvgBars(props) {
  return /*#__PURE__*/React.createElement("svg", bars_extends({
    width: 21,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), bars_path || (bars_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.059 3.392c.135 0 .27-.046.36-.136.09-.09.18-.225.18-.406V1.408c0-.136-.09-.27-.18-.361-.09-.09-.225-.18-.36-.18H.94c-.18 0-.315.09-.405.18a.512.512 0 0 0-.136.36V2.85c0 .18.045.316.136.406.09.09.225.136.405.136H20.06Zm0 7.214c.135 0 .27-.046.36-.136.09-.09.18-.225.18-.405V8.622c0-.136-.09-.27-.18-.361-.09-.09-.225-.18-.36-.18H.94c-.18 0-.315.09-.405.18a.512.512 0 0 0-.136.36v1.444c0 .18.045.315.136.405.09.09.225.136.405.136H20.06Zm0 7.214c.135 0 .27-.045.36-.136.09-.09.18-.225.18-.405v-1.443c0-.136-.09-.27-.18-.36-.09-.091-.225-.181-.36-.181H.94c-.18 0-.315.09-.405.18a.512.512 0 0 0-.136.36v1.444c0 .18.045.315.136.405.09.09.225.136.405.136H20.06Z",
    fill: "#000"
  })));
};

/* harmony default export */ var bars = ((/* unused pure expression or super */ null && (SvgBars)));
// EXTERNAL MODULE: ./src/imports-files/pages/career/customize-career-page.js + 40 modules
var customize_career_page = __webpack_require__(82352);
;// CONCATENATED MODULE: ./src/components/careers/header.js






function Header(param) {
    var formik = param.formik, customizeCareerAction = param.customizeCareerAction, isPreview = param.isPreview, isPublic = param.isPublic, headerClass = param.headerClass, logoClass = param.logoClass;
    var headerStyle = function headerStyle(isPreview, isPublic, formik) {
        var style = {};
        return isPreview && !isPublic && formik.values.unpublish_change ? {
            top: window.innerWidth <= 600 ? "50px" : "20px"
        } : {};
    };
    var t = (0,customize_career_page/* useTranslation */.$G)().t;
    var commonAction = new customize_career_page/* CommonAction */.x4();
    var headerLinks = formik.values.career_navigation_links_attributes.filter(function(navigation) {
        return !navigation._destroy && navigation.navigation_type == customize_career_page/* LINK_TYPES.header */.RZ.header;
    });
    var headerLinks_with_name = headerLinks.filter(function(x) {
        return x.name;
    }).length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((_index_module_default()).CareerMainHeader, " ").concat(headerClass),
        children: [
            isPreview && !isPublic && formik.values.unpublish_change && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((_index_module_default()).NarrowBanner),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/icons/error.png"
                        }),
                        " ",
                        t("career:changes_not_published")
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "careerHeaderDiv",
                className: "".concat((_index_module_default()).CareerHeader, " ").concat((_index_module_default()).CareerHeaderPreview),
                style: headerStyle(isPreview, isPublic, formik),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((_index_module_default()).CareerHeader__DFlex),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((_index_module_default()).CareerHeader__Logo, " ").concat(logoClass),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: formik.values.logo_url ? formik.values.logo_url : "/images/logo/Career_Default_Logo.png",
                                        alt: "Career Logo"
                                    }),
                                    !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "".concat((_index_module_default()).CareerHeader__Logo__EditIcon),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                id: "",
                                                accept: ".png, .jpg, .jpeg",
                                                type: "file",
                                                onChange: function(event) {
                                                    return customizeCareerAction.handleLogoOnChange(event, formik);
                                                },
                                                title: customizeCareerAction.imageInfoContent("logo_image")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(edit, {})
                                        ]
                                    })
                                ]
                            }),
                            isPreview && headerLinks_with_name > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((_index_module_default()).CareerHeader__BarsIcon),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    onClick: function(event) {
                                        return customizeCareerAction.toggleMenu();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "Hamburger",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "Hamburger__Line"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "Hamburger__Line"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "Hamburger__Line"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((_index_module_default()).CareerHeader__Links, " careerHeaderBlock"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: headerLinks.map(function(headerLink, index) {
                                return headerLink.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "".concat((_index_module_default()).CareerHeader__Links__Li),
                                    children: headerLink.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        style: customizeCareerAction.headerStyle(formik),
                                        href: commonAction.addHttpOrHttps(headerLink.url),
                                        target: "_blank",
                                        children: headerLink.name
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        style: customizeCareerAction.headerStyle(formik),
                                        children: headerLink.name
                                    })
                                }, "h_link_".concat(index));
                            })
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 52075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ CheckboxFilterModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34817);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_components_model_communication_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18020);
/* harmony import */ var _components_common_modal_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99005);
/* harmony import */ var _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66172);







function CheckboxFilterModal(param) {
    var filters = param.filters, closeState = param.closeState, onSubmit = param.onSubmit, onSubmitParams = param.onSubmitParams;
    var router = (0,_imports_files_components_model_communication_filter__WEBPACK_IMPORTED_MODULE_1__/* .useRouter */ .tv)();
    var initialValues = function(filters) {
        var selectedCategories = Array.isArray(router.query.integration_category) ? router.query.integration_category : [
            router.query.integration_category
        ];
        return {
            options: filters.map(function(x) {
                return {
                    id: x.id,
                    value: selectedCategories.includes(String(x.id)),
                    label: x.label
                };
            })
        };
    };
    var t = (0,_imports_files_components_model_communication_filter__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_modal_modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        type: "form",
        heading: t("modal:filter:heading"),
        closeModal: function(event) {
            closeState(false);
        },
        filterWidth: true,
        content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat(_imports_files_components_model_communication_filter__WEBPACK_IMPORTED_MODULE_1__/* .ComponentStyle.ModalFilter__Inner */ .c2.ModalFilter__Inner),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_model_communication_filter__WEBPACK_IMPORTED_MODULE_1__/* .Formik */ .J9, {
                initialValues: initialValues(filters),
                onSubmit: function(values) {
                    var filteredOptions = values.options.filter(function(option) {
                        return option.value === true;
                    }).reduce(function(acc, option) {
                        acc[option.id] = option.value;
                        return acc;
                    }, {});
                    onSubmit.apply(void 0, [
                        filteredOptions
                    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(onSubmitParams)));
                    closeState(false);
                },
                children: function(formik) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_imports_files_components_model_communication_filter__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
                        className: _imports_files_components_model_communication_filter__WEBPACK_IMPORTED_MODULE_1__/* .ComponentStyle.ModalFilter__Form */ .c2.ModalFilter__Form,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: _imports_files_components_model_communication_filter__WEBPACK_IMPORTED_MODULE_1__/* .ComponentStyle.ModalFilter__Form__Table */ .c2.ModalFilter__Form__Table,
                                children: formik.values.options.map(function(filter, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: _imports_files_components_model_communication_filter__WEBPACK_IMPORTED_MODULE_1__/* .ComponentStyle.ModalFilter__Form__TableRowBlock */ .c2.ModalFilter__Form__TableRowBlock,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: _imports_files_components_model_communication_filter__WEBPACK_IMPORTED_MODULE_1__/* .ComponentStyle.ModalFilter__Form__TableCol */ .c2.ModalFilter__Form__TableCol,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "\n                            ".concat(_imports_files_components_model_communication_filter__WEBPACK_IMPORTED_MODULE_1__/* .ComponentStyle.ModalFilter__Form__LabelCheck */ .c2.ModalFilter__Form__LabelCheck, "  Mui__CustomCheckbox\n                          "),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_model_communication_filter__WEBPACK_IMPORTED_MODULE_1__/* .Checkbox */ .XZ, {
                                                        defaultChecked: filter.value,
                                                        name: filter.label,
                                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_model_communication_filter__WEBPACK_IMPORTED_MODULE_1__/* .DefaultCheckbox */ .v0, {}),
                                                        checkedIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_model_communication_filter__WEBPACK_IMPORTED_MODULE_1__/* .CheckedCheckbox */ .bN, {}),
                                                        onChange: function(event) {
                                                            formik.setFieldValue("options.".concat(index, ".value"), event.target.checked);
                                                        },
                                                        checked: filter.value
                                                    }),
                                                    " ",
                                                    filter.label
                                                ]
                                            })
                                        })
                                    }, filter.id);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_3__/* .FormModalStyle.Modal__Container__ButtonSection */ .w2.Modal__Container__ButtonSection),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_model_communication_filter__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                        buttonstyle: _imports_files_components_model_communication_filter__WEBPACK_IMPORTED_MODULE_1__/* .ComponentStyle.secondarybtn */ .c2.secondarybtn,
                                        onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                                                formik.resetForm();
                                                onSubmit.apply(void 0, [
                                                    formik.values
                                                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(onSubmitParams)));
                                                closeState(false);
                                                return [
                                                    2
                                                ];
                                            });
                                        }),
                                        children: t("button:reset")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_model_communication_filter__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                        buttonstyle: _imports_files_components_model_communication_filter__WEBPACK_IMPORTED_MODULE_1__/* .ComponentStyle.primarybtn */ .c2.primarybtn,
                                        type: "submit",
                                        children: t("button:apply")
                                    })
                                ]
                            })
                        ]
                    });
                }
            })
        })
    });
}


/***/ }),

/***/ 75646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ CloseJobModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_components_delete_candidate_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15738);
/* harmony import */ var _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47942);
/* harmony import */ var _components_common_modal_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99005);




function CloseJobModal(param) {
    var setCloseJobModal = param.setCloseJobModal, job_id = param.job_id, router = param.router, title = param.title;
    var t = (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_modal_modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        type: "confirmation",
        message: t("modal:confirmation:close_job", {
            name: title
        }),
        texts: {
            button1_text: t("button:cancel"),
            button2_text: t("button:confirm")
        },
        closeModal: function() {
            return setCloseJobModal(false);
        },
        btnAction: function() {
            (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_2__/* .closeJob */ .t7)(job_id, router);
        }
    });
}


/***/ }),

/***/ 93425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ CustomCropper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var cropperjs_dist_cropper_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13446);
/* harmony import */ var cropperjs_dist_cropper_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(cropperjs_dist_cropper_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_components_job_live_index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95150);
/* harmony import */ var _styles_components_job_live_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_components_job_live_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _styles_components_cropper_filter_index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28033);
/* harmony import */ var _styles_components_cropper_filter_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_components_cropper_filter_index_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var public_icons_closewhite_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70394);
/* harmony import */ var _components_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95662);






function CustomCropper(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "JobFilterModal CropperModal ".concat((_styles_components_job_live_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().Modalpopup), " profilepic"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_components_cropper_filter_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().CropImage),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "".concat((_styles_components_cropper_filter_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().CropImage__Head)),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            children: "Crop Image"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "".concat((_styles_components_cropper_filter_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().ModalClose)),
                            onClick: function(event) {
                                props.viewProfileAction.closeCropperModal();
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(public_icons_closewhite_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_components_cropper_filter_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().CropImage__Inner),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "CustomCropperContainer",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/images/pages/profilepic/profilepic.png",
                                className: "Cropper__Image"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "CustomCropper",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "CustomCropper__Acion mt20",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_styles_components_cropper_filter_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().CropImage__Actions),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    children: "Zoom "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                    onClick: function() {
                                                        props.viewProfileAction.zoom_in();
                                                    },
                                                    children: [
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            children: "+"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                    onClick: function() {
                                                        props.viewProfileAction.zoom_out();
                                                    },
                                                    children: [
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            style: {
                                                                marginBottom: "3px"
                                                            },
                                                            children: "-"
                                                        }),
                                                        " "
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            buttonstyle: "m0 ".concat((_styles_components_cropper_filter_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().primarybtn)),
                                            onClick: function() {
                                                props.viewProfileAction.getCroppedImage();
                                                document.querySelector(".CropperModal").style.visibility = "hidden";
                                            },
                                            children: "Crop Image"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 60765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ CommunicationCenterOptions; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _actions_components_datatableActionOptions_communication_center_options_actions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55384);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34357);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73732);




function CommunicationCenterOptions(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var communicationCenterOptionsActions = new _actions_components_datatableActionOptions_communication_center_options_actions__WEBPACK_IMPORTED_MODULE_1__/* .CommunicationCenterOptionsActions */ .e(router);
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "CommunicationsOptions Close",
        children: Object.keys(props.options).map(function(key, index) {
            return communicationCenterOptionsActions.showCommunicationCenterOptions(props.row, key) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "CommunicationsOptionKeys",
                onClick: function(event) {
                    event.stopPropagation();
                    communicationCenterOptionsActions.performJobAction(key, {
                        id: props.id,
                        setCommunicationList: props.setCommunicationList,
                        setFlagForRerender: props.setFlagForRerender,
                        setCommunicationBulkActionModal: props.setCommunicationBulkActionModal,
                        setConfirmationModal: props.setConfirmationModal,
                        setApiError: props.setApiError,
                        row: props.row,
                        t: t
                    });
                },
                children: props.options[key]["title"]
            }, "Communications_".concat(key));
        })
    });
}


/***/ }),

/***/ 99363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ UnsuccessfulReasonOptions; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _actions_pages_clients_recruitment_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2228);


function UnsuccessfulReasonOptions(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "JobActionOptions Close",
        children: Object.keys(props.options).map(function(key, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "JobsOptionKeys",
                onClick: function(event) {
                    event.stopPropagation();
                    props.unsuccessfulReasonAction.performJobAction(key, {
                        id: props.id,
                        reason_id: props.reason_id,
                        unsuccessfulReasonAction: props.unsuccessfulReasonAction
                    });
                },
                children: props.options[key]["title"]
            }, "EmailTemplate_".concat(key));
        })
    });
}


/***/ }),

/***/ 93714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53429);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37307);
/* harmony import */ var _styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _components_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95662);
/* harmony import */ var public_icons_device_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86298);
/* harmony import */ var public_icons_dropbox_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65684);
/* harmony import */ var public_icons_drive_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99553);
/* harmony import */ var _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83813);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96047);
/* provided dependency */ var process = __webpack_require__(56957);












var DropZone = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var t = (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)().t;
    var dropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isActive = ref13[0], setIsActive = ref13[1];
    var onClick = function() {
        return setIsActive(!isActive);
    };
    var isAgency = props.isAgency || false;
    var router = (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_7__/* .useRouter */ .tv)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        var hash = {
            file_type: "",
            file: "",
            file_name: ""
        };
        // NOTE:- The dropbox is used in the agency client, client and job application 
        //        actionType is used for the edit agency client
        if ((props === null || props === void 0 ? void 0 : props.formik) && (props === null || props === void 0 ? void 0 : (ref = props.formik) === null || ref === void 0 ? void 0 : ref.values.client_candidate) && props.actionType && props.actionType != "edit") {
            var ref1, ref2;
            props === null || props === void 0 ? void 0 : (ref1 = props.formik) === null || ref1 === void 0 ? void 0 : ref1.setFieldValue("client_candidate.resume_attributes", hash);
            props === null || props === void 0 ? void 0 : (ref2 = props.formik) === null || ref2 === void 0 ? void 0 : ref2.setFieldValue("client_candidate.other_files_attributes", []);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var pageClickEvent = function(e) {
            // If the active element exists and is clicked outside of
            if (dropdownRef.current !== null && !dropdownRef.current.contains(e.target)) {
                setIsActive(!isActive);
            }
        };
        // If the item is active (ie open) then listen for clicks
        if (isActive) {
            window.addEventListener("click", pageClickEvent);
        }
        return function() {
            window.removeEventListener("click", pageClickEvent);
        };
    }, [
        isActive
    ]);
    var dragOver = function(e) {
        e.preventDefault();
    };
    var dragEnter = function(e) {
        e.preventDefault();
    };
    var dragLeave = function(e) {
        e.preventDefault();
    };
    var fileDrop = function(e) {
        e.preventDefault();
        var files = e.dataTransfer.files;
        if (files.length) {
            handleFiles(files);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().DropContainer),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().DropContainer__Inner),
                    onDragOver: dragOver,
                    onDragEnter: dragEnter,
                    onDragLeave: dragLeave,
                    onDrop: function(event) {
                        event.preventDefault();
                        if (props.isDisabled) return false;
                        else (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_7__/* .onFileChange */ .Os)(event.dataTransfer.files, props.formik, props.type, props.autofill, "system", props.setCvErrorMessage, props.setOtherErrorMessage, props.setFileCount, props.setShowLoader, props.setIsDisabled);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().DropContainer__Message),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().DropContainer__UploadIcon)
                            }),
                            t("upload:drag_and_drop"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: " BrowseFile ".concat((_styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().Browse)),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        buttonstyle: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__/* .ButtonStyle.primarybtn */ .ZJ.primarybtn,
                                        onClick: onClick,
                                        disabled: props.isDisabled,
                                        children: t("button:browse_to_upload")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                                        ref: dropdownRef,
                                        className: "dropboxmenu ".concat(isActive ? "active" : "inactive"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    onClick: function() {
                                                        return (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_7__/* .closeDropDown */ .mU)(setIsActive);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                            htmlFor: props.id,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(public_icons_device_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
                                                                "  ",
                                                                t("upload:from_device")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                            type: "file",
                                                            multiple: props.multiple,
                                                            onChange: function() {
                                                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(event) {
                                                                    var ref, ref1;
                                                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_7__/* .onFileChange */ .Os)(event.target.files, props.formik, props.type, props.autofill, "system", props.setCvErrorMessage, props.setOtherErrorMessage, props.setFileCount, props.setShowLoader, props.setIsDisabled)
                                                                                ];
                                                                            case 1:
                                                                                _state.sent();
                                                                                // If agency candidates we are auto enable my interview button
                                                                                if (props.setWidgetReady && props.action) {
                                                                                    ;
                                                                                    props.setWidgetReady(props.action.setCandidateDetails((ref = props.formRef.current) === null || ref === void 0 ? void 0 : ref.values.client_candidate.first_name, (ref1 = props.formRef.current) === null || ref1 === void 0 ? void 0 : ref1.values.client_candidate.email));
                                                                                }
                                                                                return [
                                                                                    2
                                                                                ];
                                                                        }
                                                                    });
                                                                });
                                                                return function(event) {
                                                                    return _ref.apply(this, arguments);
                                                                };
                                                            }(),
                                                            name: "user_cv",
                                                            accept: props.accept,
                                                            id: props.id
                                                        })
                                                    ]
                                                }),
                                                router.asPath.includes("/view-job") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    onClick: function() {
                                                        return (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_7__/* .closeDropDown */ .mU)(setIsActive);
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_7__/* .DropboxChooser */ .Yp, {
                                                        appKey: "l4w49vtd268647t",
                                                        success: function(files) {
                                                            return (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_7__/* .onFileChange */ .Os)(files, props.formik, props.type, props.autofill, "dropbox", props.setCvErrorMessage, props.setOtherErrorMessage, props.setFileCount, props.setShowLoader, props.setIsDisabled);
                                                        },
                                                        cancel: function() {
                                                            return (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_7__/* .onCancel */ .K3)();
                                                        },
                                                        multiselect: true,
                                                        extensions: props.extensions,
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(public_icons_dropbox_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                children: [
                                                                    " ",
                                                                    t("upload:from_dropbox")
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                router.asPath.includes("/view-job") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    onClick: function() {
                                                        return (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_7__/* .closeDropDown */ .mU)(setIsActive);
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_7__/* .GoogleChooser */ .Zm, {
                                                        clientId: process.env.NEXT_PUBLIC_GOOGLE_DRIVE_CLIENT_ID,
                                                        developerKey: process.env.NEXT_PUBLIC_GOOGLE_DRIVE_KEY,
                                                        success: function(files) {
                                                            return (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_7__/* .onFileChange */ .Os)(files, props.formik, props.type, props.autofill, "drive", props.setCvErrorMessage, props.setOtherErrorMessage, props.setFileCount, props.setShowLoader, props.setIsDisabled);
                                                        },
                                                        multiselect: true,
                                                        navHidden: true,
                                                        authImmediate: false,
                                                        extensions: props.extensions,
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(public_icons_drive_svg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                children: [
                                                                    "  ",
                                                                    t("upload:from_drive")
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().FileDisplayContainer),
                    children: ((ref = props.formik.values) === null || ref === void 0 ? void 0 : ref.job_application) ? props.type == "cv" ? ((ref1 = props.formik.values) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.job_application) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.resume_attributes) === null || ref3 === void 0 ? void 0 : ref3.file_name) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().FileDisplayContainer__Status),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().FileDisplayContainer__Name),
                                children: props.formik.values.job_application.resume_attributes.file_name
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().FileDisplayContainer__Close),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: "/icons/close.png",
                                    height: 13,
                                    width: 13,
                                    alt: "",
                                    onClick: function() {
                                        return (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_7__/* .onRemoveFile */ .Tp)(props.formik, "cv", 0, props.setCvErrorMessage, props.setOtherErrorMessage, props.setFileCount, props.setIsDisabled);
                                    }
                                })
                            })
                        ]
                    }) : "" : (ref4 = props.formik.values) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.job_application) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.job_application_files_attributes) === null || ref6 === void 0 ? void 0 : ref6.map(function(file, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().FileDisplayContainer__Status),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().FileDisplayContainer__Name),
                                    children: file.file_name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().FileDisplayContainer__Close),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: "/icons/close.png",
                                        height: 13,
                                        width: 13,
                                        alt: "",
                                        onClick: function() {
                                            return (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_7__/* .onRemoveFile */ .Tp)(props.formik, "other", index, props.setCvErrorMessage, props.setOtherErrorMessage, props.setFileCount, props.setIsDisabled);
                                        }
                                    })
                                })
                            ]
                        }, index);
                    }) : props.type == "cv" ? ((ref7 = props.formik.values) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.client_candidate) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.resume_attributes) === null || ref9 === void 0 ? void 0 : ref9.file_name) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().FileDisplayContainer__Status),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().FileDisplayContainer__Name),
                                children: props.formik.values.client_candidate.resume_attributes.file_name
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().FileDisplayContainer__Close),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: "/icons/close.png",
                                    height: 13,
                                    width: 13,
                                    alt: "",
                                    onClick: function() {
                                        return (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_7__/* .onAddCandidateRemoveFile */ .XE)(props.formik, "cv", 0, props.setCvErrorMessage, props.setOtherErrorMessage, props.setFileCount, props.setIsDisabled, isAgency);
                                    }
                                })
                            })
                        ]
                    }) : "" : (ref10 = props.formik.values) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.client_candidate) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.other_files_attributes) === null || ref12 === void 0 ? void 0 : ref12.map(function(file, index) {
                        return !file._destroy && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().FileDisplayContainer__Status),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().FileDisplayContainer__Name),
                                    children: file.file_name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_components_dropzone_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().FileDisplayContainer__Close),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: "/icons/close.png",
                                        height: 13,
                                        width: 13,
                                        alt: "",
                                        onClick: function() {
                                            return (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_7__/* .onAddCandidateRemoveFile */ .XE)(props.formik, "other", index, props.setCvErrorMessage, props.setOtherErrorMessage, props.setFileCount, props.setIsDisabled, isAgency);
                                        }
                                    })
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DropZone);


/***/ }),

/***/ 18332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ IframeGoogleDoc; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var _styles_components_custom_cv_load_index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72396);
/* harmony import */ var _styles_components_custom_cv_load_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_components_custom_cv_load_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73732);




function IframeGoogleDoc(param) {
    var url = param.url, isPublic = param.isPublic;
    var iframeLoaded = function iframeLoaded() {
        setShowLoading(false);
        clearInterval(iframeTimeoutId);
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), iframeTimeoutId = ref[0], setIframeTimeoutId = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), showLoading = ref1[0], setShowLoading = ref1[1];
    var iframeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$)().t;
    var getIframeLink = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return "https://docs.google.com/gview?url=".concat(encodeURIComponent(url), "&embedded=true");
    }, [
        url
    ]);
    var updateIframeSrc = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (iframeRef.current) {
            iframeRef.current.src = getIframeLink();
            setShowLoading(true);
        }
    }, [
        getIframeLink
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var intervalId = setInterval(updateIframeSrc, 1000 * 3);
        setIframeTimeoutId(intervalId);
        return function() {
            clearInterval(intervalId);
        };
    }, [
        updateIframeSrc
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            showLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_styles_components_custom_cv_load_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().CvLoader)),
                children: t("loading")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                title: "Candidate Document",
                onLoad: iframeLoaded,
                onError: updateIframeSrc,
                ref: iframeRef,
                style: showLoading ? {
                    display: "none"
                } : {
                    display: "block",
                    width: "100%",
                    height: "".concat(isPublic ? "100vh" : "100%")
                },
                src: getIframeLink()
            })
        ]
    });
} // export default IframeGoogleDoc;


/***/ }),

/***/ 69991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ JobActionOptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62286);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _actions_components_job_action_options__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41817);
/* harmony import */ var _hooks_job_filters__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57773);
/* harmony import */ var _imports_files_components_input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23434);
/* harmony import */ var _imports_files_components_sidebar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86064);
/* harmony import */ var _imports_files_hooks_use_navbar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49539);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34357);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);










function JobActionOptions(props) {
    var queryClient = (0,_imports_files_hooks_use_navbar__WEBPACK_IMPORTED_MODULE_5__/* .useQueryClient */ .NL)();
    //  const session                              =  getSession();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_imports_files_hooks_use_navbar__WEBPACK_IMPORTED_MODULE_5__/* .useState */ .eJ)(""), 2), userRole = ref[0], setuserRole = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_imports_files_hooks_use_navbar__WEBPACK_IMPORTED_MODULE_5__/* .useState */ .eJ)(""), 2), subdomainValue = ref1[0], setSubdomainValue = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_imports_files_hooks_use_navbar__WEBPACK_IMPORTED_MODULE_5__/* .useState */ .eJ)(""), 2), filters = ref2[0], setFilters = ref2[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var session = props.session;
    (0,_imports_files_components_sidebar__WEBPACK_IMPORTED_MODULE_4__/* .useEffect */ .d4)(function() {
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var ref;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                // const session =  await getSession();
                setFilters(router.query);
                setuserRole(session.role);
                setSubdomainValue(((ref = props.rowData) === null || ref === void 0 ? void 0 : ref.client_slug) || session.subdomain);
                return [
                    2
                ];
            });
        })();
    }, [
        userRole
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "JobActionOptions Close",
        children: Object.keys(props.options).map(function(key, index) {
            if (props.options[key]["allowed_user"].includes(userRole) && (props.options[key]["tab_name"].includes(filters.job_type) || props.options[key]["tab_name"].includes(props.job_type)) && (key == "publish_job" ? (userRole == "Administrator" || userRole == "client_owner" || userRole == "client_admin" || userRole == "account_owner") && props.publishable ? true : props.publishable : true) && (props.editable ? props.editable : userRole == "Administrator" || userRole == "client_owner" || userRole == "client_admin" || userRole == "account_owner" ? true : props.options[key]["visble_in_all_jobs"])) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "JobsOptionKeys",
                    onClick: function(event) {
                        event.stopPropagation();
                        (0,_actions_components_job_action_options__WEBPACK_IMPORTED_MODULE_1__/* .performJobAction */ .f2)(key, {
                            "link": props.options[key]["link"],
                            "job_id": props.job_id,
                            "queryClient": queryClient,
                            "setPageName": props.setPageName,
                            "slug": props.slug,
                            "client_slug": subdomainValue,
                            "setJobList": props.setJobList,
                            "setjobEditModal": props.setjobEditModal,
                            "rowData": props.rowData,
                            "closeAllJobsOptions": props.closeAllJobsOptions,
                            "router": router,
                            "setApiError": props.setApiError,
                            "setJobCloseModal": props.setJobCloseModal,
                            "title": props.title
                        });
                    },
                    children: props.options[key]["title"]
                }, "JobsOption_".concat(key));
            }
        })
    });
}


/***/ }),

/***/ 60353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ JobFilters; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/imports-files/components/job-filters.js + 1 modules
var job_filters = __webpack_require__(29774);
// EXTERNAL MODULE: ./src/components/common-modal/modal.js + 2 modules
var modal = __webpack_require__(99005);
// EXTERNAL MODULE: ./src/imports-files/components/review-email.js + 1 modules
var review_email = __webpack_require__(3623);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
;// CONCATENATED MODULE: ./public/new-icons/calendar.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2h-1V.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V2H5V.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V2H2a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Zm0 15H2V6h14v11Zm-7.5-7h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5Zm4 0h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5Zm-8 0h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5Zm4 4h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5Zm-4 0h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5Z",
    fill: "#A4AAB0"
  })));
};

/* harmony default export */ var calendar = ((/* unused pure expression or super */ null && (SvgCalendar)));
// EXTERNAL MODULE: ./src/imports-files/components/common-modal/common-modal.js + 2 modules
var common_modal = __webpack_require__(66172);
;// CONCATENATED MODULE: ./src/components/job-filters.js







function JobFilters(props) {
    var t = (0,job_filters/* useTranslation */.$G)().t;
    var router = (0,job_filters/* useRouter */.tv)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,job_filters/* useState */.eJ)(router.query.start_date || null), 2), startDate = ref[0], setStartDate = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,job_filters/* useState */.eJ)(router.query.end_date || null), 2), endDate = ref1[0], setEndDate = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,job_filters/* useState */.eJ)(router.query.location || null), 2), location = ref2[0], setLocation = ref2[1];
    var selectDropdownRef = (0,job_filters/* useRef */.sO)(null);
    var startDateRef = (0,job_filters/* useRef */.sO)(null);
    var endDateRef = (0,job_filters/* useRef */.sO)(null);
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,job_filters/* useState */.eJ)(router.query.agency_user_emails ? Array.isArray(router.query.agency_user_emails) ? router.query.agency_user_emails : [
        router.query.agency_user_emails
    ] : []), 2), agency_user_emails = ref3[0], setAgencyUserEmails = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,job_filters/* useState */.eJ)((0,job_filters/* setQueryParams */.BT)(router)), 2), agency_user_initials = ref4[0], setAgencyUserInitials = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,job_filters/* useState */.eJ)(""), 2), agencyUserEmail = ref5[0], setAgencyUserEmail = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,job_filters/* useState */.eJ)(""), 2), agencyUserError = ref6[0], setAgencyUserError = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,job_filters/* useState */.eJ)([]), 2), users = ref7[0], setUsers = ref7[1];
    var formRef = (0,job_filters/* useRef */.sO)(null);
    var showJobAction = new job_filters/* ShowJobAction */.Ws();
    var initialValues = {
        agency_user_emails: agency_user_emails,
        agency_user_initials: agency_user_initials
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        type: "form",
        heading: t("modal:filter:heading"),
        jobFilterModal: true,
        closeModal: function(event) {
            (0,job_filters/* closeJobModal */.eR)(event, props.setModal);
        },
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(job_filters/* Formik */.J9, {
                    initialValues: initialValues,
                    innerRef: formRef,
                    children: function(formik) {
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(job_filters/* Form */.l0, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: review_email/* FormModalStyle.Modal__Container__ContentSection__BlockContainer */.w2.Modal__Container__ContentSection__BlockContainer,
                                    style: {
                                        gridTemplateColumns: "auto auto",
                                        gap: "20px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat(job_filters/* PageStyle.Form__TableCol */.k2.Form__TableCol, " mb10"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    className: " ".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading, " ").concat(job_filters/* PageStyle.Form__FloatingLabel */.k2.Form__FloatingLabel),
                                                    children: t("label:date_from")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(job_filters/* FormikControl */.gt, {
                                                    control: "customDatePicker",
                                                    className: "FilterCustomDateTime FilterCustomStartDate ".concat(job_filters/* PageStyle.Form__Input */.k2.Form__Input),
                                                    format: "DD/MM/yyyy",
                                                    inputProps: {
                                                        disabled: false,
                                                        placeholder: t("placeholder:select:date"),
                                                        readOnly: true
                                                    },
                                                    onChange: function(value) {
                                                        setStartDate(value);
                                                        document.querySelector(".filterEndDate").innerHTML = "";
                                                        document.querySelector(".FilterCustomEndDate input").style.border = "1px solid #99ADBD";
                                                        if ((0,job_filters/* moment */._7)(value).startOf("day").isAfter((0,job_filters/* setFilledDate */.vH)(document.querySelector(".FilterCustomEndDate input").value))) {
                                                            document.querySelector(".filterStartDate").innerHTML = "Date from should be lesser than date to";
                                                            document.querySelector(".FilterCustomStartDate input").style.border = "1px solid red";
                                                        } else {
                                                            document.querySelector(".filterStartDate").innerHTML = "";
                                                            document.querySelector(".FilterCustomStartDate input").style.border = "1px solid #99ADBD";
                                                        }
                                                    },
                                                    reference: startDateRef,
                                                    value: typeof startDate == "string" ? (0,job_filters/* setFilledDate */.vH)(startDate) : startDate
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    className: "ErrorLabel filterStartDate"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat(job_filters/* PageStyle.Form__TableCol */.k2.Form__TableCol),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    className: " ".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading, " ").concat(job_filters/* PageStyle.Form__FloatingLabel */.k2.Form__FloatingLabel),
                                                    children: t("label:date_to")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(job_filters/* FormikControl */.gt, {
                                                    control: "customDatePicker",
                                                    className: "FilterCustomDateTime FilterCustomEndDate ".concat(job_filters/* PageStyle.Form__Input */.k2.Form__Input),
                                                    format: "DD/MM/yyyy",
                                                    inputProps: {
                                                        disabled: false,
                                                        placeholder: t("placeholder:select:date"),
                                                        readOnly: true
                                                    },
                                                    onChange: function(value) {
                                                        setEndDate(value);
                                                        document.querySelector(".filterStartDate").innerHTML = "";
                                                        document.querySelector(".FilterCustomStartDate input").style.border = "1px solid #99ADBD";
                                                        if ((0,job_filters/* moment */._7)(value).startOf("day").isBefore((0,job_filters/* setFilledDate */.vH)(document.querySelector(".FilterCustomStartDate input").value))) {
                                                            document.querySelector(".filterEndDate").innerHTML = "Date to should be greater than date from";
                                                            document.querySelector(".FilterCustomEndDate input").style.border = "1px solid red";
                                                        } else {
                                                            document.querySelector(".filterEndDate").innerHTML = "";
                                                            document.querySelector(".FilterCustomEndDate input").style.border = "1px solid #99ADBD";
                                                        }
                                                    },
                                                    reference: endDateRef,
                                                    value: typeof endDate == "string" ? (0,job_filters/* setFilledDate */.vH)(endDate) : endDate
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    className: "ErrorLabel filterEndDate"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat(job_filters/* PageStyle.Form__TableCol */.k2.Form__TableCol),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading, " ").concat(job_filters/* PageStyle.Form__FloatingLabel */.k2.Form__FloatingLabel),
                                            children: t("label:location")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(job_filters/* FormikControl */.gt, {
                                            className: "".concat(review_email/* FormModalStyle.Form__Input */.w2.Form__Input, " ").concat(job_filters/* PageStyle.Form__CustomSelect */.k2.Form__CustomSelect, " JobCustomSelect"),
                                            control: "select",
                                            default: location,
                                            disabled: ((props === null || props === void 0 ? void 0 : (ref = props.job_locations) === null || ref === void 0 ? void 0 : ref.length) || 0) < 2,
                                            onChange: function(option) {
                                                option != null ? setLocation(option.value) : "";
                                            },
                                            options: (ref1 = showJobAction.get_json_data_for_location(props.job_locations)) === null || ref1 === void 0 ? void 0 : ref1.options,
                                            reference: selectDropdownRef
                                        })
                                    ]
                                }),
                                props.session.role != "reviewer" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat(job_filters/* PageStyle.Form__TableCol */.k2.Form__TableCol, " mt30"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading, " ").concat(job_filters/* PageStyle.Form__FloatingLabel */.k2.Form__FloatingLabel),
                                            style: (0,job_filters/* InputText */.oH)(formik, "agency_user_emails"),
                                            children: t("label:agency_users")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(job_filters/* FormikControl */.gt, {
                                            control: "autosuggestInput",
                                            errorClass: job_filters/* PageStyle.Form__Error */.k2.Form__Error,
                                            formik: formik,
                                            getSuggestionValue: job_filters/* getUserSuggestionValue */.lU,
                                            inputProps: {
                                                className: "AutosuggestOpenUp ".concat(job_filters/* PageStyle.Form__Input */.k2.Form__Input, " ").concat(job_filters/* PageStyle.Form__textleft */.k2.Form__textleft, " ").concat(job_filters/* PageStyle.Form__InputFullWidth */.k2.Form__InputFullWidth),
                                                formik: formik,
                                                index: "ageny_user_email",
                                                name: "agency_user_emails",
                                                onChange: function(value, param) {
                                                    var newValue = param.newValue, method = param.method;
                                                    setAgencyUserEmail(newValue);
                                                    setAgencyUserError("");
                                                },
                                                placeholder: t("placeholder:search:type_name"),
                                                style: (0,job_filters/* InputError */.pd)(formik, "agency_user_emails"),
                                                value: agencyUserEmail,
                                                onKeyDown: function(event) {
                                                    return (0,job_filters/* handleKeyDown */.$y)(event, formik, setAgencyUserEmail, setAgencyUserError, setAgencyUserEmails, setAgencyUserInitials, t);
                                                },
                                                disabled: false
                                            },
                                            onChange: function(value, param) {
                                                var newValue = param.newValue, method = param.method;
                                                setAgencyUserEmail(newValue);
                                            },
                                            onSuggestionsClearRequested: function() {
                                                return (0,job_filters/* onUserSuggestionsClearRequested */._v)(setUsers);
                                            },
                                            onSuggestionsFetchRequested: function(hash) {
                                                (0,job_filters/* onUserSuggestionsFetchRequested */.UA)(hash, setUsers);
                                            },
                                            onSuggestionSelected: function(event, param) {
                                                var suggestion = param.suggestion;
                                                if (suggestion.user_attributes.email.length > 0) {
                                                    setAgencyUserEmail("");
                                                    (0,job_filters/* onUserSuggestionSelection */.ro)(formik, agency_user_emails, suggestion.user_attributes.email, agency_user_initials, {
                                                        email: suggestion.user_attributes.email,
                                                        name_initials: suggestion.user_attributes.name_initials,
                                                        name: suggestion.user_attributes.name,
                                                        photo_url: suggestion.user_attributes.photo_url
                                                    }, setAgencyUserEmails, setAgencyUserInitials);
                                                }
                                            },
                                            renderInputComponent: job_filters/* renderInputComponent */.Qx,
                                            renderSuggestion: job_filters/* renderUserSuggestion */.LB,
                                            shouldRenderSuggestions: job_filters/* shouldRenderSuggestions */.KH,
                                            suggestions: users,
                                            type: "text"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat(job_filters/* PageStyle.Tagrow */.k2.Tagrow, " height110"),
                                            children: agency_user_initials.map(function(item, index) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                    className: "mt5 ".concat(job_filters/* PageStyle.Tagrow__Tags */.k2.Tagrow__Tags),
                                                    children: [
                                                        (item === null || item === void 0 ? void 0 : item.photo_url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: item === null || item === void 0 ? void 0 : item.photo_url,
                                                            className: "JobImageSmall"
                                                        }) : item.name_initials && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: job_filters/* PageStyle.Tagrow__Prefix */.k2.Tagrow__Prefix,
                                                            children: item.name_initials
                                                        }),
                                                        item.name ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: item.name
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: item.email
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            type: "button",
                                                            className: job_filters/* PageStyle.Tagrow__Cancel */.k2.Tagrow__Cancel,
                                                            onClick: function() {
                                                                return (0,job_filters/* handleEmailDelete */.d1)(formik, index, setAgencyUserEmails, setAgencyUserInitials);
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal/* Close */.x8, {})
                                                        })
                                                    ]
                                                }, "agency_user_".concat(index));
                                            })
                                        })
                                    ]
                                })
                            ]
                        });
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: review_email/* FormModalStyle.Modal__Container__ButtonSection */.w2.Modal__Container__ButtonSection,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(job_filters/* Button */.zx, {
                            buttonstyle: review_email/* FormModalStyle.secondarybtn */.w2.secondarybtn,
                            onClick: function() {
                                return (0,job_filters/* resetJobModal */.wk)(props.setFiltersValue, props.setModal, props.setJobList, selectDropdownRef, startDateRef, endDateRef, setStartDate, setEndDate, setLocation, router, props.setApiError);
                            },
                            children: t("button:reset")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(job_filters/* Button */.zx, {
                            buttonstyle: review_email/* FormModalStyle.primarybtn */.w2.primarybtn,
                            onClick: function() {
                                return (0,job_filters/* applyFilter */.Rb)(props.setFiltersValue, props.setModal, props.setJobList, startDate, endDate, location, router, props.setApiError, agency_user_emails, agency_user_initials);
                            },
                            children: t("button:apply")
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 39006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ JobLivePopup; }
});

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/styles/components/job-live/_index.module.scss
var _index_module = __webpack_require__(95150);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./public/icons/fbicon.png
var fbicon = __webpack_require__(72358);
// EXTERNAL MODULE: ./public/icons/twittericon.png
var twittericon = __webpack_require__(61515);
// EXTERNAL MODULE: ./public/icons/linkedicon.png
var linkedicon = __webpack_require__(51536);
// EXTERNAL MODULE: ./public/icons/arrowleft.svg
var arrowleft = __webpack_require__(65661);
// EXTERNAL MODULE: ../../shared/node_modules/next/image.js
var next_image = __webpack_require__(53429);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../shared/node_modules/react-share/es/FacebookShareButton.js
var FacebookShareButton = __webpack_require__(91278);
// EXTERNAL MODULE: ../../shared/node_modules/react-share/es/TwitterShareButton.js
var TwitterShareButton = __webpack_require__(90495);
// EXTERNAL MODULE: ../../shared/node_modules/react-share/es/LinkedinShareButton.js
var LinkedinShareButton = __webpack_require__(88829);
// EXTERNAL MODULE: ../../shared/node_modules/react-confetti/dist/react-confetti.min.js
var react_confetti_min = __webpack_require__(61543);
;// CONCATENATED MODULE: ./public/images/confetti/confetti.gif
/* harmony default export */ var confetti = ({"src":"/_next/static/media/confetti.b5e6aade.gif","height":1240,"width":1700});
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ./src/imports-files/pages/admins/logout.js + 1 modules
var logout = __webpack_require__(63281);
;// CONCATENATED MODULE: ./src/services/components/job-live-popup.js








var JobLivePopupService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(JobLivePopupService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(JobLivePopupService);
    function JobLivePopupService() {
        (0,_class_call_check/* default */.Z)(this, JobLivePopupService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(JobLivePopupService, [
        {
            key: "updateLiveJobPopupStatus",
            value: // set the api for the data
            function updateLiveJobPopupStatus(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.jobs.UPDATE_JOB_LIVE_MODAL_SHOW_STATUS_FALSE */.bl.client.jobs.UPDATE_JOB_LIVE_MODAL_SHOW_STATUS_FALSE;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return JobLivePopupService;
}(logout/* SendRequest */.Lt);

;// CONCATENATED MODULE: ./src/actions/components/job-live-popup.js




var JobLivePopupAction = /*#__PURE__*/ function() {
    "use strict";
    function JobLivePopupAction(setApiError, router) {
        (0,_class_call_check/* default */.Z)(this, JobLivePopupAction);
        this.setApiError = setApiError;
        this.router = router;
        this.jobLivePopupService = new JobLivePopupService();
    }
    (0,_create_class/* default */.Z)(JobLivePopupAction, [
        {
            key: "updateJobLivePopupStatus",
            value: function updateJobLivePopupStatus() {
                var params = {
                    id: parseInt(this.router.query.job_id)
                };
                this.jobLivePopupService.updateLiveJobPopupStatus(params);
                params.setApiError(result.response);
            }
        },
        {
            key: "copyToClipboard",
            value: function copyToClipboard(link, setClipBoardMessage) {
                var textField = document.createElement("textarea");
                textField.innerText = link;
                document.body.appendChild(textField);
                textField.select();
                document.execCommand("copy");
                textField.remove();
                setClipBoardMessage((0,common/* TRANSLATION */.TA)("modal:congratulations:job_live:copied"));
            // document.querySelector('.ClipboardTooltip')?.lastChild?.textContent = 'Copied';
            }
        },
        {
            key: "jobViewUrl",
            value: function jobViewUrl(client_slug, job_slug) {
                var job_url = common/* REDIRECT.client.jobs.view_job */.RQ.client.jobs.view_job;
                var protocol = window.location.protocol;
                var hostnamearray = window.location.host.split(".");
                hostnamearray[0] = "jobs";
                job_url = job_url.replace("$slug", job_slug);
                job_url = job_url.replace("$client_slug", client_slug);
                var url = protocol + "//" + hostnamearray.join(".") + job_url + "?q=desc";
                return url;
            }
        }
    ]);
    return JobLivePopupAction;
}();

// EXTERNAL MODULE: ./public/icons/clipboard.svg
var clipboard = __webpack_require__(11466);
// EXTERNAL MODULE: ./src/imports-files/components/common-modal/common-modal.js + 2 modules
var common_modal = __webpack_require__(66172);
;// CONCATENATED MODULE: ./src/components/job-live.js

















function JobLivePopup(props) {
    var t = (0,common/* useTranslation */.$G)().t;
    var router = props.router;
    var ref = (0,common/* useNavbarStatus */.en)(), navbarStatus = ref.navbarStatus, updateNavbarStatus = ref.updateNavbarStatus;
    (0,common/* clearSWRCache */.A$)("JobLivePopup");
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(null), apiError = ref2[0], setApiError = ref2[1];
    var ref3 = (0,react.useState)(t("modal:congratulations:job_live:copy")), clipboardMessage = ref3[0], setClipBoardMessage = ref3[1];
    var jobLivePopup = new JobLivePopupAction(setApiError, router);
    var url = jobLivePopup.jobViewUrl(props.client_slug, props.job_slug);
    var ref4 = (0,common/* useSWR */.dH)("JobLivePopup", function() {
        return jobLivePopup.updateJobLivePopupStatus();
    }), data = ref4.data, error = ref4.error;
    (0,common/* useEffect */.d4)(function() {
        if (data) {
            setLoading(false);
        }
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(common_modal/* FormModalStyle.ModalOverlay */.w2.ModalOverlay),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(common_modal/* FormModalStyle.Modal */.w2.Modal),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(common_modal/* FormModalStyle.Modal__Container */.w2.Modal__Container),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(common_modal/* FormModalStyle.Modal__Container__BackSection */.w2.Modal__Container__BackSection),
                        onClick: function() {
                            router.push({
                                pathname: common/* REDIRECT.client.activities */.RQ.client.activities
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(arrowleft/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("back:dashboard")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection */.w2.Modal__Container__ContentSection, " ").concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__FlexCenter */.w2.Modal__Container__ContentSection__FlexCenter),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Heading */.w2.Modal__Container__ContentSection__Heading),
                                children: [
                                    t("modal:congratulations:job_live:heading"),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (_index_module_default()).JobLive__Url,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: url,
                                        target: "_blank",
                                        children: t("modal:congratulations:job_live:subheading")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Tooltip */.u, {
                                        className: "SimpleTooltip",
                                        content: clipboardMessage,
                                        background: "#00325A",
                                        radius: 20,
                                        padding: 8,
                                        placement: "top",
                                        fontSize: "12px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "CareerPageTooltip ".concat((_index_module_default()).JobLive__copyBtn),
                                            onClick: function() {
                                                return jobLivePopup.copyToClipboard(url, setClipBoardMessage);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(clipboard/* default */.Z, {
                                                className: "clipboardsvg"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(common_modal/* FormModalStyle.Modal__Container__ButtonSection */.w2.Modal__Container__ButtonSection, " ").concat(common_modal/* FormModalStyle.Modal__Container__ButtonSection__FlexCenter */.w2.Modal__Container__ButtonSection__FlexCenter, " ").concat(common_modal/* FormModalStyle.Modal__Container__ButtonSection__PositionRelative */.w2.Modal__Container__ButtonSection__PositionRelative, " mt10"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                            buttonstyle: "".concat(common/* ButtonStyle.primarybtn */.ZJ.primarybtn, " ").concat((_index_module_default()).mar, " "),
                            onClick: function() {
                                props.setJobLivePopup(false);
                                router.push({
                                    pathname: common/* REDIRECT.client.jobs.index */.RQ.client.jobs.index,
                                    query: {
                                        job_type: "active"
                                    }
                                });
                            },
                            children: t("button:view:all_jobs")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection */.w2.Modal__Container__ContentSection, " ").concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__FlexCenter */.w2.Modal__Container__ContentSection__FlexCenter),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: common_modal/* FormModalStyle.Modal__Container__ContentSection__SubHeading */.w2.Modal__Container__ContentSection__SubHeading,
                                children: t("modal:congratulations:job_live:description")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (_index_module_default()).JobLive__socialmedia,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (_index_module_default()).JobLive__SocialMedia,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookShareButton/* default */.Z, {
                                                url: url,
                                                quote: props.job_title,
                                                hashtag: "#candidly",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: fbicon/* default */.Z,
                                                    alt: "Facebook"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterShareButton/* default */.Z, {
                                                url: url,
                                                title: props.job_title,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: twittericon/* default */.Z,
                                                    alt: "Twitter"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedinShareButton/* default */.Z, {
                                                url: url,
                                                title: props.job_title,
                                                summary: "",
                                                source: "Candidly",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: linkedicon/* default */.Z,
                                                    alt: "Linkedin"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 95538:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: CreateJobAddScorecardLinkComponent

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/jobs/scorecards.js
var scorecards = __webpack_require__(96726);
;// CONCATENATED MODULE: ./src/components/jobScorecardComponent/addScorecardLink.js



function addScorecardLink_AddScoreCardLinkComponent(props) {
    return /*#__PURE__*/ _jsx("div", {
        className: "".concat(CreateScoreStyle.LightBox),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "".concat(CreateScoreStyle.LightBox__Competency, " ").concat(CreateScoreStyle.LightBox__CompetencyLink, " "),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "".concat(CreateScoreStyle.Dpflex),
                    children: /*#__PURE__*/ _jsx("label", {
                        children: "Link "
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "".concat(CreateScoreStyle.Dpflex),
                    children: /*#__PURE__*/ _jsx(FormikControl, {
                        control: "ScoreCardInput",
                        type: "text",
                        placeholder: "Add link here",
                        name: props.name,
                        formik: props.formik,
                        disabled: !props.editable,
                        className: "".concat(CreateScoreStyle.addLink, " ").concat(CreateScoreStyle.Form__Input),
                        style: InputError(props.formik, props.name),
                        custom_class: "".concat(CreateScoreStyle.ScorecardInputError)
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/jobScorecardComponent/createJobAddScorecardLinkComponent.js



function CreateJobAddScorecardLinkComponent(props) {
    return /*#__PURE__*/ _jsx("div", {
        className: "".concat(CreateScoreStyle.AddScoreLink),
        children: /*#__PURE__*/ _jsx(AddScoreCardLinkComponent, {
            formik: props.formik,
            name: props.name,
            editable: props.editable
        })
    });
}


/***/ }),

/***/ 70336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R6": function() { return /* binding */ CreateJobScorecardComponent; }
});

// UNUSED EXPORTS: closeCompetency, competenciesAction, removeCompetencyIfCreated, setComptencyDetroyTrue

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/imports-files/components/jobScorecardComponent/competency.js + 2 modules
var competency = __webpack_require__(94847);
// EXTERNAL MODULE: ./src/components/modals/add-note-modal.js
var add_note_modal = __webpack_require__(6816);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
;// CONCATENATED MODULE: ./public/images/pages/scorecard/search.svg
var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 9.767,
    cy: 9.767,
    r: 8.989,
    stroke: "#A4AAB0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M16.018 16.485 19.542 20",
    stroke: "#A4AAB0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ var search = (SvgSearch);
// EXTERNAL MODULE: ./public/icons/thick-plus.svg
var thick_plus = __webpack_require__(83238);
;// CONCATENATED MODULE: ./src/components/jobScorecardComponent/competency.js







function CompetencyComponent(props) {
    var subCompetencyShow = function subCompetencyShow(subCompetency) {
        return subCompetency ? "" : "";
    };
    var ref, ref1, ref2;
    var t = (0,competency/* useTranslation */.$G)().t;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,competency/* useState */.eJ)(((ref = props.formik.values.job_competencies_attributes[props.index].job_sub_competencies_attributes) === null || ref === void 0 ? void 0 : ref.length) > 0 ? true : false), 2), subCompetency = ref3[0], setSubCompetency = ref3[1];
    // competency autosuggestion variables --------
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,competency/* useState */.eJ)(((ref1 = props.formik.values.job_competencies_attributes[props.index]) === null || ref1 === void 0 ? void 0 : ref1.name) || ""), 2), competencyValue = ref4[0], setCompetencyValue = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,competency/* useState */.eJ)(""), 2), competencySelectedValue = ref5[0], setCompetencySelectedValue = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,competency/* useState */.eJ)([]), 2), competencySuggestion = ref6[0], setCompetencySuggestion = ref6[1];
    // competenct autosuggestion variables --------
    // sub competency autosuggestion variables --------
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,competency/* useState */.eJ)(""), 2), subCompetencyValue = ref7[0], setSubCompetencyValue = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,competency/* useState */.eJ)(props.formik.values.job_competencies_attributes[props.index].job_sub_competencies_attributes || []), 2), subcompetencySelectedValue = ref8[0], setSubcompetencySelectedValue = ref8[1];
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,competency/* useState */.eJ)([]), 2), subcompetencySuggestion = ref9[0], setSubcompetencySuggestion = ref9[1];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,competency/* useState */.eJ)(((ref2 = props.formik.values.job_competencies_attributes[props.index].job_sub_competencies_attributes) === null || ref2 === void 0 ? void 0 : ref2.map(function(x) {
        return x.name;
    })) || []), 2), subCompetencyIValue = ref10[0], setSubcompetencyIValue = ref10[1];
    // sub competency autosuggestion variables --------
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,competency/* useState */.eJ)(0), 2), flagForRerender = ref11[0], setFlagForRerender = ref11[1];
    var competencyComponentAction = new competency/* CompetencyComponentAction */.uM(setSubCompetency, subcompetencySelectedValue, setSubcompetencySelectedValue, setFlagForRerender);
    var competencyComponentService = new competency/* CompetencyComponentService */.$c();
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,competency/* useState */.eJ)({
        status: false,
        heading: "Add Note",
        submitButtonAction: ""
    }), 2), addNote = ref12[0], setAddNote = ref12[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(props.createscore.LightBox),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(competency/* CreateScoreStyle.LightBox__Competency */.GS.LightBox__Competency, " ").concat(subCompetencyShow(subCompetency), " "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(competency/* CreateScoreStyle.LeftSide */.GS.LeftSide),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(competency/* CreateScoreStyle.CloseIcon_Width */.GS.CloseIcon_Width),
                            children: props.formik.values.job_competencies_attributes.filter(function(x) {
                                return !x._destroy;
                            }).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    if (props.editable) {
                                        props.setDirtyArray(true);
                                        props.closeCompetency(props.index, props.formik, props.setFlagForRender, props.setConfirmationModal, props.job_status);
                                    }
                                },
                                className: "".concat(competency/* CreateScoreStyle.Anchor__Add */.GS.Anchor__Add, " ").concat(!props.editable ? "buttonTextDisabled" : "", " pb0"),
                                children: t("remove")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(competency/* CreateScoreStyle.CompetencyContainer */.GS.CompetencyContainer),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat(competency/* FormStyle.Form__TableCol */.x.Form__TableCol),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: "".concat(competency/* FormStyle.Form__FloatingLabel */.x.Form__FloatingLabel),
                                        style: (0,competency/* InputText */.oH)(props.formik, "job_competencies_attributes.".concat(props.index, ".name")),
                                        children: [
                                            t("label:competency"),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat(competency/* CreateScoreStyle.AutoSuggestInputContainer */.GS.AutoSuggestInputContainer, " ScoreCard__Competency"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(competency/* FormikControl */.gt, {
                                                control: "autosuggestInput",
                                                errorClass: competency/* CreateScoreStyle.Form__Error */.GS.Form__Error,
                                                custom_class: "form_custom_error",
                                                formik: props.formik,
                                                getSuggestionValue: function(suggestion) {
                                                    return competencyComponentAction.getSuggestionValue(suggestion.label);
                                                },
                                                inputProps: {
                                                    className: "AutosuggestOpenUp ".concat(competency/* CreateScoreStyle.Form__Input */.GS.Form__Input),
                                                    formik: props.formik,
                                                    name: "job_competencies_attributes.".concat(props.index, ".name"),
                                                    onChange: function(value, param) {
                                                        var newValue = param.newValue;
                                                        props.setDirtyArray(true);
                                                        // props.formik.touched[props.names.competency] = true;
                                                        props.formik.setFieldValue("job_competencies_attributes.".concat(props.index, ".name"), newValue);
                                                    // props.formik.setFieldValue(props.names.competency, newValue);
                                                    // props.formik.setStatus(props.names.competency, '');
                                                    // setCompetencyValue(newValue);
                                                    },
                                                    placeholder: t("placeholder:competency"),
                                                    style: (0,competency/* InputError */.pd)(props.formik, "job_competencies_attributes.".concat(props.index, ".name")),
                                                    value: props.formik.values.job_competencies_attributes[props.index].name || "",
                                                    disabled: !props.editable,
                                                    onKeyUp: function(event) {
                                                        competencyComponentAction.competencyHandleKeyUp(event, setCompetencyValue, competencySelectedValue, setCompetencySelectedValue, props.formik, competencyComponentAction.add_selected_value, {
                                                            index: props.index,
                                                            type: "client_competency",
                                                            jobId: props.jobId,
                                                            clientId: props.clientId,
                                                            setFlagForRerender: setFlagForRerender
                                                        });
                                                    }
                                                },
                                                onSuggestionsClearRequested: function() {
                                                    competencyComponentAction.onSuggestionsClearRequested(setCompetencySuggestion);
                                                },
                                                onSuggestionsFetchRequested: function(value) {
                                                    competencyComponentAction.onSuggestionsFetchRequested(value, setCompetencySuggestion, competencyComponentService.getCompetencySubCompetencySuggestionData, "competencies", true);
                                                },
                                                onSuggestionSelected: function(event, param) {
                                                    var suggestion = param.suggestion;
                                                    if (suggestion.label.length > 0) {
                                                        props.formik.setFieldValue("job_competencies_attributes.".concat(props.index, ".name"), suggestion.label);
                                                        setCompetencyValue("");
                                                        competencyComponentAction.onSuggestionSelectionValue(suggestion, setCompetencyValue, competencySelectedValue, setCompetencySelectedValue, props.formik, competencyComponentAction.add_selected_value, {
                                                            index: props.index,
                                                            type: "client_competency",
                                                            jobId: props.jobId,
                                                            clientId: props.clientId,
                                                            setFlagForRerender: setFlagForRerender
                                                        });
                                                    }
                                                },
                                                renderSuggestion: function(suggestion) {
                                                    return competencyComponentAction.renderSuggestion(suggestion.label);
                                                },
                                                shouldRenderSuggestions: function(value) {
                                                    return competencyComponentAction.shouldRenderSuggestions(value, 0);
                                                },
                                                suggestions: competencySuggestion
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(competency/* CreateScoreStyle.SearchIcon */.GS.SearchIcon),
                                                children: !props.editable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(search, {
                                                    className: "buttonTextDisabled"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/pages/scorecard/search.svg"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(competency/* CreateScoreStyle.AddNotes */.GS.AddNotes, " ScoreCard__Competency"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(competency/* FormikControl */.gt, {
                                    control: "customtextarea",
                                    type: "text",
                                    formik: props.formik.values,
                                    className: "".concat(competency/* CreateScoreStyle.Form__Textarea */.GS.Form__Textarea, " width100"),
                                    rows: "3",
                                    placeholder: t("placeholder:competency_description"),
                                    name: "job_competencies_attributes.".concat(props.index, ".notes"),
                                    defaultValue: props.formik.values.job_competencies_attributes[props.index].notes,
                                    onChange: function(event) {
                                        props.formik.setFieldValue("job_competencies_attributes.".concat(props.index, ".notes"), event.target.value);
                                    },
                                    maxLength: 1000
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(competency/* CreateScoreStyle.CreateScoreCard__SubCompetency */.GS.CreateScoreCard__SubCompetency),
                children: [
                    props.formik.values.job_competencies_attributes[props.index].job_sub_competencies_attributes.map(function(subcompetency, index) {
                        return !subcompetency._destroy && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat(competency/* CreateScoreStyle.LightBox__SubCompetency */.GS.LightBox__SubCompetency),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(competency/* CreateScoreStyle.LeftSide */.GS.LeftSide),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(competency/* CreateScoreStyle.CloseIcon_Width */.GS.CloseIcon_Width),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            onClick: function() {
                                                if (props.editable) {
                                                    props.setDirtyArray(true);
                                                    competencyComponentAction.removeSubcompetency(props.formik, props.index, index);
                                                }
                                            },
                                            className: "".concat(competency/* CreateScoreStyle.Anchor__Add */.GS.Anchor__Add, " ").concat(!props.editable ? "buttonTextDisabled" : "", " pb0"),
                                            children: t("remove")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(competency/* CreateScoreStyle.LeftSide */.GS.LeftSide),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat(competency/* FormStyle.Form__TableCol */.x.Form__TableCol, " w100"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: "".concat(competency/* FormStyle.Form__FloatingLabel */.x.Form__FloatingLabel),
                                                style: (0,competency/* InputText */.oH)(props.formik, "job_competencies_attributes.".concat(props.index, ".job_sub_competencies_attributes.").concat(index, ".name")),
                                                children: [
                                                    " ",
                                                    t("jobs:scorecards:sub_competency"),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat(competency/* CreateScoreStyle.AutoSuggestInputContainer */.GS.AutoSuggestInputContainer, " ScoreCard__Competency"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(competency/* FormikControl */.gt, {
                                                        control: "autosuggestInput",
                                                        errorClass: competency/* CreateScoreStyle.Form__Error */.GS.Form__Error,
                                                        custom_class: "form_custom_error",
                                                        formik: props.formik,
                                                        getSuggestionValue: function(suggestion) {
                                                            return competencyComponentAction.getSuggestionValue(suggestion.label);
                                                        },
                                                        inputProps: {
                                                            className: "AutosuggestOpenUp ".concat(competency/* CreateScoreStyle.Form__Input */.GS.Form__Input),
                                                            formik: props.formik,
                                                            name: "job_competencies_attributes.".concat(props.index, ".job_sub_competencies_attributes.").concat(index, ".name"),
                                                            onChange: function(value, param) {
                                                                var newValue = param.newValue;
                                                                props.setDirtyArray(true);
                                                                props.formik.setFieldValue("job_competencies_attributes.".concat(props.index, ".job_sub_competencies_attributes.").concat(index, ".name"), newValue);
                                                            },
                                                            placeholder: t("placeholder:competency"),
                                                            style: (0,competency/* InputError */.pd)(props.formik, "job_competencies_attributes.".concat(props.index, ".job_sub_competencies_attributes.").concat(index, ".name")),
                                                            value: props.formik.values.job_competencies_attributes[props.index].job_sub_competencies_attributes[index].name || "",
                                                            disabled: !props.editable,
                                                            onKeyUp: function(event) {
                                                                competencyComponentAction.handleKeyUp(event, setSubCompetencyValue, subcompetencySelectedValue, setSubcompetencySelectedValue, props.formik, {
                                                                    index: props.index,
                                                                    type: "job_competency",
                                                                    jobId: props.jobId,
                                                                    clientId: props.clientId,
                                                                    setFlagForRerender: setFlagForRerender,
                                                                    subcompetency_index: index
                                                                });
                                                            }
                                                        },
                                                        onSuggestionsClearRequested: function() {
                                                            competencyComponentAction.onSuggestionsClearRequested(setSubcompetencySuggestion);
                                                        },
                                                        onSuggestionsFetchRequested: function(value) {
                                                            competencyComponentAction.onSuggestionsFetchRequested(value, setSubcompetencySuggestion, competencyComponentService.getCompetencySubCompetencySuggestionData, "sub_competencies", true);
                                                        },
                                                        onSuggestionSelected: function(event, param) {
                                                            var suggestion = param.suggestion;
                                                            if (suggestion.label.length > 0) {
                                                                setSubcompetencySelectedValue("");
                                                                props.formik.setFieldValue("job_competencies_attributes.".concat(props.index, ".job_sub_competencies_attributes.").concat(index, ".name"), suggestion.label);
                                                                competencyComponentAction.onSuggestionSelectionValue(suggestion, setSubCompetencyValue, subcompetencySelectedValue, setSubcompetencySelectedValue, props.formik, competencyComponentAction.add_selected_value, {
                                                                    index: props.index,
                                                                    type: "job_competency",
                                                                    jobId: props.jobId,
                                                                    clientId: props.clientId,
                                                                    setFlagForRerender: setFlagForRerender,
                                                                    subcompetency_index: index
                                                                });
                                                            }
                                                        },
                                                        renderInputComponent: function(inputProps) {
                                                            return competencyComponentAction.renderInputComponent(inputProps, setSubCompetencyValue, subcompetencySelectedValue, setSubcompetencySelectedValue, props.formik, competencyComponentAction.add_selected_value, {
                                                                index: props.index,
                                                                type: "job_competency",
                                                                jobId: props.jobId,
                                                                clientId: props.clientId,
                                                                setFlagForRerender: setFlagForRerender
                                                            });
                                                        },
                                                        renderSuggestion: function(suggestion) {
                                                            return competencyComponentAction.renderSuggestion(suggestion.label);
                                                        },
                                                        shouldRenderSuggestions: function(value) {
                                                            return competencyComponentAction.shouldRenderSuggestions(value, 0);
                                                        },
                                                        suggestions: subcompetencySuggestion
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat(competency/* CreateScoreStyle.SearchIcon */.GS.SearchIcon),
                                                        children: !props.editable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(search, {
                                                            className: "buttonTextDisabled"
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/images/pages/scorecard/search.svg"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(competency/* CreateScoreStyle.AddNotes */.GS.AddNotes, " ScoreCard__Competency"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(competency/* FormikControl */.gt, {
                                        control: "customtextarea",
                                        type: "text",
                                        formik: props.formik.values,
                                        className: "".concat(competency/* CreateScoreStyle.Form__Textarea */.GS.Form__Textarea, " width100"),
                                        rows: "3",
                                        placeholder: t("placeholder:competency_description"),
                                        name: "job_competencies_attributes.".concat(props.index, ".job_sub_competencies_attributes.").concat(index, ".notes"),
                                        defaultValue: props.formik.values.job_competencies_attributes[props.index].job_sub_competencies_attributes[index].notes,
                                        onChange: function(event) {
                                            props.formik.setFieldValue("job_competencies_attributes.".concat(props.index, ".job_sub_competencies_attributes.").concat(index, ".notes"), event.target.value);
                                        },
                                        maxLength: 1000
                                    })
                                })
                            ]
                        }, "subcompetency_div_".concat(index));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(competency/* CreateScoreStyle.LeftSide */.GS.LeftSide),
                        children: props.editable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(competency/* Button */.zx, {
                            onClick: function() {
                                if (props.editable) competencyComponentAction.addSubcompetency(props.formik, props.index);
                            },
                            className: "".concat(competency/* ButtonStyle.iconTextButton */.ZJ.iconTextButton, " pb32"),
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(thick_plus/* default */.Z, {}),
                                t("jobs:scorecards:add_sub_competency")
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(competency/* Button */.zx, {
                            className: "".concat(competency/* CreateScoreStyle.iconTextButton */.GS.iconTextButton, " pb32"),
                            disabled: !props.editable,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(thick_plus/* default */.Z, {}),
                                " ",
                                t("jobs:scorecards:add_sub_competency")
                            ]
                        })
                    })
                ]
            }),
            addNote.status && /*#__PURE__*/ (0,jsx_runtime.jsx)(add_note_modal/* AddNoteModal */.s, {
                formik: props.formik,
                name: "job_competencies_attributes.".concat(props.index, ".notes"),
                setModal: setAddNote,
                modal: addNote,
                editable: props.editable,
                existing_value: props.formik.values.job_competencies_attributes[props.index].notes
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/constants/pages/clients/jobs/scorecards.js
var scorecards = __webpack_require__(40682);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/jobs/scorecards.js
var jobs_scorecards = __webpack_require__(96726);
// EXTERNAL MODULE: ./src/components/common-modal/modal.js + 2 modules
var modal = __webpack_require__(99005);
// EXTERNAL MODULE: ../../shared/node_modules/lodash.clonedeep/index.js
var lodash_clonedeep = __webpack_require__(10552);
// EXTERNAL MODULE: ./src/components/confirmation-modal.js
var confirmation_modal = __webpack_require__(72055);
;// CONCATENATED MODULE: ./public/images/pages/scorecard/default-primary-disabled-add-btn.svg
var _rect, default_primary_disabled_add_btn_path;

function default_primary_disabled_add_btn_extends() { default_primary_disabled_add_btn_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return default_primary_disabled_add_btn_extends.apply(this, arguments); }



var SvgDefaultPrimaryDisabledAddBtn = function SvgDefaultPrimaryDisabledAddBtn(props) {
  return /*#__PURE__*/React.createElement("svg", default_primary_disabled_add_btn_extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#E7EBEE"
  })), default_primary_disabled_add_btn_path || (default_primary_disabled_add_btn_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12v16M12 20h16",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ var default_primary_disabled_add_btn = ((/* unused pure expression or super */ null && (SvgDefaultPrimaryDisabledAddBtn)));
;// CONCATENATED MODULE: ./src/components/jobScorecardComponent/createJobScorecardComponent.js











function CreateJobScorecardComponent(props) {
    var ref = (0,common/* useTranslation */.$G)(), t = ref.t, i18n = ref.i18n;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(), 2), flagForRender = ref1[0], setFlagForRender = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)({
        index: null,
        show: false
    }), 2), confirmationModal = ref2[0], setConfirmationModal = ref2[1];
    var formDisabled = !props.editable;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(jobs_scorecards/* CreateScoreStyle.CreateScoreCard */.GS.CreateScoreCard),
        children: [
            props.formik.values.job_competencies_attributes.map(function(competency, index) {
                return (competency === null || competency === void 0 ? void 0 : competency._destroy) ? "" : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(jobs_scorecards/* CreateScoreStyle.CreateScoreCard__Card */.GS.CreateScoreCard__Card, " ").concat(!props.editable ? "competency-disabled" : jobs_scorecards/* CreateScoreStyle.CreateScoreCard__Card */.GS.CreateScoreCard__Card),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompetencyComponent, {
                        formik: props.formik,
                        names: {
                            subcompetency: "job_competencies_attributes.".concat(index, ".job_sub_competencies_attributes.name"),
                            competency: "job_competencies_attributes.".concat(index, ".client_competency_attributes.name")
                        },
                        index: index,
                        createscore: jobs_scorecards/* CreateScoreStyle */.GS,
                        jobId: props.jobId,
                        editable: props.editable,
                        clientId: props.clientId,
                        setDirtyArray: props.setDirtyArray,
                        closeCompetency: closeCompetency,
                        setConfirmationModal: setConfirmationModal,
                        job_status: props.job_status,
                        setFlagForRender: setFlagForRender
                    })
                }, "CreateJobScorecardComponent__".concat(index));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(jobs_scorecards/* CreateScoreStyle.Button */.GS.Button, " ").concat(!props.editable ? "competency-disabled" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Button */.zx, {
                    onClick: function() {
                        if (props.editable) {
                            props.setDirtyArray(true);
                            competenciesAction(props.formik, "add", null, setFlagForRender);
                        }
                    },
                    disabled: !props.editable || formDisabled,
                    className: "".concat(common/* ButtonStyle.iconTextButton */.ZJ.iconTextButton, " pb32"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(thick_plus/* default */.Z, {}),
                        t("jobs:scorecards:add_competency")
                    ]
                })
            }),
            confirmationModal.show && /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                type: "confirmation",
                message: t("modal:confirmation:remove_last_competency"),
                texts: {
                    button2_text: "Confirm"
                },
                closeModal: function() {
                    setConfirmationModal({
                        index: confirmationModal.index,
                        show: false
                    });
                },
                btnAction: function() {
                    setComptencyDetroyTrue(props.formik, confirmationModal.index);
                    setConfirmationModal({
                        index: confirmationModal.index,
                        show: false
                    });
                }
            })
        ]
    });
}
function closeCompetency(index, formik, setFlagForRender, setConfirmationModal, job_status) {
    var competency_list = formik.values.job_competencies_attributes;
    var competency_count = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = competency_list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var competency = _step.value;
            if (!(competency === null || competency === void 0 ? void 0 : competency._destroy)) {
                competency_count = competency_count + 1;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (competency_count == 1 && job_status == "Published") {
        setConfirmationModal({
            index: index,
            show: true
        });
    } else {
        setComptencyDetroyTrue(formik, index);
        removeCompetencyIfCreated(formik, index);
        setFlagForRender(Math.random() * 1000);
    }
}
function competenciesAction(formik, type) {
    var index = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, setFlagForRender = arguments.length > 3 ? arguments[3] : void 0;
    // let job_competency_hash = cloneDeep(JOB_COMPETENCY_ATTRIBUTES_HASH);
    var job_competency_hash = (0,scorecards/* job_competency_attr_hash */.mO)();
    switch(type){
        case "add":
            formik.values.job_competencies_attributes.push(job_competency_hash);
            setFlagForRender(Math.random() * 1000);
            break;
        default:
            "";
    }
}
function setComptencyDetroyTrue(formik, index) {
    formik.values.job_competencies_attributes[index]["_destroy"] = true;
}
function removeCompetencyIfCreated(formik, index) {
    var job_competencies_attributes = formik.values.job_competencies_attributes;
    if (!formik.values.job_competencies_attributes[index]["id"] || formik.values.job_competencies_attributes[index]["id"] == "") {
        job_competencies_attributes.splice(index, 1);
        formik.setFieldValue("job_competencies_attributes", job_competencies_attributes);
    }
}


/***/ }),

/***/ 6816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ AddNoteModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62286);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68946);



function AddNoteModal(props) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(props.existing_value), 2), prevalue = ref[0], setPreValue = ref[1];
    var editorRef = (0,_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .useRef */ .sO)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.SetupPopup */ .k2.SetupPopup),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "".concat(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.SetupPopup__inner */ .k2.SetupPopup__inner, " ").concat(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .RejectModalStyle.RejectModal__inner */ .nm.RejectModal__inner),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "".concat(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.OtpBacksection2 */ .k2.OtpBacksection2, " ").concat(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .RejectModalStyle.OtpBacksection2 */ .nm.OtpBacksection2),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Otpback */ .k2.Otpback, " ").concat(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .RejectModalStyle.Otpback */ .nm.Otpback),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                            buttonstyle: _imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.nobgbutton */ .k2.nobgbutton,
                            type: "button",
                            onClick: function() {
                                return props.setModal({
                                    status: false,
                                    index: props.modal.index,
                                    heading: "",
                                    submitButtonAction: ""
                                });
                            },
                            children: "Close"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "".concat(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.SetupPopup__Content */ .k2.SetupPopup__Content, " ").concat(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .RejectModalStyle.RejectModal__Content */ .nm.RejectModal__Content),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "".concat(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Sharecv__Heading */ .k2.Sharecv__Heading),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                children: props.modal.heading
                            })
                        }),
                        props.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "".concat(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.SetupPopup__ContentBlock */ .k2.SetupPopup__ContentBlock, " ").concat(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.mt15 */ .k2.mt15, " ").concat(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .RejectModalStyle.RejectModal__ContentBlock */ .nm.RejectModal__ContentBlock),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                children: props.label
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "".concat(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.SetupPopup__ContentBlock */ .k2.SetupPopup__ContentBlock, " mt25"),
                            children: props.text_area_type == "custom_editor" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                control: "customtextarea",
                                type: "text",
                                formik: props.formik,
                                className: "".concat(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Textarea */ .k2.Form__Textarea, " width100"),
                                rows: "7",
                                placeholder: t("placeholder:write_here"),
                                style: (0,_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(props.formik, props.name),
                                disabled: !props.editable,
                                name: "notes",
                                defaultValue: prevalue,
                                onChange: function(event) {
                                    setPreValue(event.target.value);
                                }
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                control: "customtextarea",
                                type: "text",
                                formik: props.formik,
                                className: "".concat(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Textarea */ .k2.Form__Textarea, " width100"),
                                rows: "7",
                                placeholder: t("placeholder:write_here"),
                                style: (0,_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(props.formik, props.name),
                                disabled: !props.editable,
                                name: "notes",
                                defaultValue: prevalue,
                                onChange: function(event) {
                                    setPreValue(event.target.value);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "".concat(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.SetupPopup__SubmitSectionSave */ .k2.SetupPopup__SubmitSectionSave, " ").concat(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .RejectModalStyle.RejectModal__SubmitSectionSave */ .nm.RejectModal__SubmitSectionSave),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                    buttonstyle: _imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.secondarybtnborder */ .k2.secondarybtnborder,
                                    type: "button",
                                    onClick: function() {
                                        props.setModal({
                                            status: false,
                                            index: props.modal.index,
                                            heading: "",
                                            submitButtonAction: ""
                                        });
                                    },
                                    children: " Cancel "
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                    disabled: !props.editable,
                                    buttonstyle: _imports_files_components_model_rejection_modal__WEBPACK_IMPORTED_MODULE_1__/* .ComponentStyle.primarybtn */ .c2.primarybtn,
                                    onClick: function() {
                                        props.modal.submitButtonAction({
                                            setModal: props.setModal,
                                            index: props.modal.index,
                                            value: prevalue,
                                            formik: props.formik,
                                            name: props.name
                                        });
                                    },
                                    children: " Submit"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 3038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ InformationModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _styles_components_request_for_more_index_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92626);
/* harmony import */ var _styles_components_request_for_more_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_components_request_for_more_index_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95662);
/* harmony import */ var _actions_common_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1739);
/* harmony import */ var _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66172);
/* harmony import */ var _common_modal_modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99005);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96047);







function InformationModal(props) {
    var ref, ref1, ref2, ref3;
    var commonAction = new _actions_common_common__WEBPACK_IMPORTED_MODULE_2__/* .CommonAction */ .x();
    var t = (0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_modal_modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        type: "info",
        className: "RequestMore mt0",
        heading: props === null || props === void 0 ? void 0 : props.infoModal.heading,
        closeModal: function() {
            return props.setInfoModal({
                state: false,
                heading: "",
                message: ""
            });
        },
        innerContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_styles_components_request_for_more_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().Contentdata1)),
            children: (props === null || props === void 0 ? void 0 : (ref = props.infoModal) === null || ref === void 0 ? void 0 : ref.job_status) == "Rejected" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                children: props === null || props === void 0 ? void 0 : (ref1 = props.infoModal) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.message) === null || ref2 === void 0 ? void 0 : ref2.map(function(message, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: "".concat((_styles_components_request_for_more_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().ListItem), " mt20"),
                        children: message
                    }, "rejected_message_".concat(index));
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
                className: "ApproverList",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                children: t("modal:info:job:approver")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                children: t("modal:info:job:status")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                children: t("modal:info:job:date_and_time")
                            })
                        ]
                    }),
                    props === null || props === void 0 ? void 0 : (ref3 = props.infoModal) === null || ref3 === void 0 ? void 0 : ref3.message.map(function(element, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "d-flex align-items-center w100",
                                        children: [
                                            (element === null || element === void 0 ? void 0 : element.photo_url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "JobInitial mr5",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: element === null || element === void 0 ? void 0 : element.photo_url,
                                                    className: "JobImage"
                                                })
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "JobInitial mr5",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    children: element.name_initials ? element.name_initials : "?"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "ApproverEmail",
                                                children: element.name || element.email
                                            })
                                        ]
                                    }, "job_owner_initials_".concat(index))
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "ApproverStatus",
                                        children: element.status
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "ApproverStatus",
                                        children: element.date_and_time
                                    })
                                })
                            ]
                        });
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 37111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ ScorecardImportModal; }
});

// UNUSED EXPORTS: GroupHeading

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/imports-files/components/model/select-job-modal.js + 3 modules
var select_job_modal = __webpack_require__(28801);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/candidates/kanban.js + 10 modules
var kanban = __webpack_require__(47942);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ./src/imports-files/pages/admins/logout.js + 1 modules
var logout = __webpack_require__(63281);
;// CONCATENATED MODULE: ./src/services/components/scorecard-import.js








var ScorecardImportService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(ScorecardImportService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(ScorecardImportService);
    function ScorecardImportService() {
        (0,_class_call_check/* default */.Z)(this, ScorecardImportService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ScorecardImportService, [
        {
            key: "templatelist",
            value: function templatelist(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.scorecard_templates.TEMPLATE_LIST */.bl.client.scorecard_templates.TEMPLATE_LIST;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "importScorecard",
            value: function importScorecard(job_id, template_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.jobs.IMPORT_SCORECARD.replace */.bl.client.jobs.IMPORT_SCORECARD.replace("$job_id", job_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(url, (_tmp.params = {
                                        template_id: template_id
                                    }, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ScorecardImportService;
}(logout/* SendRequest */.Lt);

;// CONCATENATED MODULE: ./src/actions/components/scorecard-import.js







var ScorecardImportAction = /*#__PURE__*/ function() {
    "use strict";
    function ScorecardImportAction(args) {
        (0,_class_call_check/* default */.Z)(this, ScorecardImportAction);
        this.scorecardImportService = new ScorecardImportService();
        this.customToastrAction = new common/* CustomToastrAction */.Y5();
        this.setApiError = args.setApiError;
        this.router = args.router;
        this.setTemplateList = args.setTemplateList;
    }
    (0,_create_class/* default */.Z)(ScorecardImportAction, [
        {
            key: "loadTemplateList",
            value: function loadTemplateList(string) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                return [
                                    4,
                                    _this.scorecardImportService.templatelist((_tmp.per_page = 30, _tmp.search_text = string, _tmp))
                                ];
                            case 1:
                                result = _state.sent();
                                if (result.request.status == 200) {
                                    return [
                                        2,
                                        result.data.list.map(function(template) {
                                            return {
                                                label: template.title,
                                                value: template.id
                                            };
                                        })
                                    ];
                                } else {
                                    return [
                                        2,
                                        []
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "submitForm",
            value: function submitForm(job_id, template_id, setScoreCardImport) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.scorecardImportService.importScorecard(job_id, template_id)
                                ];
                            case 1:
                                result = _state.sent();
                                _tmp = {};
                                if (result.request.status == 200) {
                                    _this.customToastrAction.setNormalToastr(result.data.success, "success");
                                    return [
                                        2,
                                        (_tmp.scorecard_config_attributes = result.data.scorecard_config_attributes, _tmp.job_competencies_attributes = result.data.job_competencies_attributes, _tmp)
                                    ];
                                } else {
                                    _this.customToastrAction.setNormalToastr(result.response.data.error, "error");
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "redirectToCreateTemplate",
            value: function redirectToCreateTemplate(jobId, router) {
                this.router.push(common/* REDIRECT.client.recruitment.scorecard_templates */.RQ.client.recruitment.scorecard_templates + "?redirect_id=".concat(jobId));
            }
        }
    ]);
    return ScorecardImportAction;
}();

// EXTERNAL MODULE: ./src/components/common-modal/modal.js + 2 modules
var modal = __webpack_require__(99005);
// EXTERNAL MODULE: ./src/imports-files/components/review-email.js + 1 modules
var review_email = __webpack_require__(3623);
;// CONCATENATED MODULE: ./src/components/modals/scorecard-import-modal.js











function ScorecardImportModal(props) {
    var getTemplateValidationSchema = function getTemplateValidationSchema() {
        return select_job_modal/* Yup.object */.sm.object().shape({
            template_id: select_job_modal/* Yup.string */.sm.string().required((0,select_job_modal/* TRANSLATION */.TA)("errors:required"))
        });
    };
    var t = (0,select_job_modal/* useTranslation */.$G)().t;
    var zeroTemplate = props.zeroTemplate, isImported = props.isImported, job_id = props.job_id;
    var ref = (0,_sliced_to_array/* default */.Z)((0,select_job_modal/* useState */.eJ)(null), 2), apiError = ref[0], setApiError = ref[1];
    var router = (0,select_job_modal/* useRouter */.tv)();
    var errorPages = new select_job_modal/* ErrorPages */.dC();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,select_job_modal/* useState */.eJ)({
        template_id: ""
    }), 2), initialValues = ref1[0], setInitialValues = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,select_job_modal/* useState */.eJ)(true), 2), isLoading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,select_job_modal/* useState */.eJ)(0), 2), flagForRerender = ref3[0], setFlagForRerender = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,select_job_modal/* useState */.eJ)({}), 2), options = ref4[0], setOptions = ref4[1];
    var scorecardImportAction = new ScorecardImportAction({
        setApiError: setApiError,
        router: router
    });
    return props.scoreCardImport ? /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        type: "form",
        heading: t("jobs:scorecards:import"),
        closeModal: function() {
            return props.setScoreCardImport(false);
        },
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* Formik */.J9, {
            initialValues: initialValues,
            validationSchema: getTemplateValidationSchema(),
            onSubmit: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
                    var _tmp, new_values;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isImported) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    props.setScoreCardImport(false)
                                ];
                            case 1:
                                _state.sent();
                                _tmp = {};
                                return [
                                    4,
                                    props.setIsConfirmation((_tmp.state = true, _tmp.scorecardImportAction = scorecardImportAction, _tmp.job_id = props.job_id, _tmp.template_id = values.template_id, _tmp))
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    9
                                ];
                            case 3:
                                return [
                                    4,
                                    scorecardImportAction.submitForm(props.job_id, values.template_id)
                                ];
                            case 4:
                                new_values = _state.sent();
                                if (!new_values) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    props.formRef.current.setValues(props.scorecardAction.getInitialValue(new_values))
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                if (!new_values) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    props.formRef.current.resetForm()
                                ];
                            case 7:
                                _state.sent();
                                _state.label = 8;
                            case 8:
                                props.setScoreCardImport(false);
                                _state.label = 9;
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(values) {
                    return _ref.apply(this, arguments);
                };
            }(),
            children: function(formik) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_job_modal/* Form */.l0, {
                    children: [
                        zeroTemplate ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block__Description */.w2.Modal__Container__ContentSection__Block__Description),
                                children: t("jobs:scorecards:zero")
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat(select_job_modal/* FormStyle.Form__TableCol */.x.Form__TableCol),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: "".concat(select_job_modal/* FormStyle.Form__FloatingLabel */.x.Form__FloatingLabel),
                                    style: (0,select_job_modal/* InputText */.oH)(formik, "template_id"),
                                    children: t("jobs:scorecards:templates")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* FormikControl */.gt, {
                                    className: "".concat(select_job_modal/* PageStyle.Form__CustomSelect */.k2.Form__CustomSelect),
                                    control: "asyncSelect",
                                    formik: formik,
                                    // placeholder={"Select Template"}
                                    loadOptions: function() {
                                        var _ref = (0,_async_to_generator/* default */.Z)(function(string) {
                                            var optionsList;
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            scorecardImportAction.loadTemplateList(string)
                                                        ];
                                                    case 1:
                                                        optionsList = _state.sent();
                                                        return [
                                                            2,
                                                            optionsList
                                                        ];
                                                }
                                            });
                                        });
                                        return function(string) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }(),
                                    default: formik.values.template_id,
                                    name: "template_id",
                                    custom_class: "form_custom_error",
                                    onChange: function(option) {
                                        formik.setFieldValue("template_id", option.value);
                                    },
                                    style: (0,select_job_modal/* InputError */.pd)(formik, "template_id")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: review_email/* FormModalStyle.Modal__Container__ButtonSection */.w2.Modal__Container__ButtonSection,
                            children: zeroTemplate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* Button */.zx, {
                                buttonstyle: select_job_modal/* PageStyle.primarybtn */.k2.primarybtn,
                                type: "button",
                                onClick: function() {
                                    return scorecardImportAction.redirectToCreateTemplate(job_id);
                                },
                                children: t("button:create:template")
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* Button */.zx, {
                                buttonstyle: select_job_modal/* PageStyle.primarybtn */.k2.primarybtn,
                                type: "submit",
                                children: t("button:import:default")
                            })
                        })
                    ]
                });
            }
        })
    }) : "";
}
function GroupHeading(props) {
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx(components.GroupHeading, _object_spread({}, props))
    });
}


/***/ }),

/***/ 48151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ SingleCandidateModal; }
});

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/styles/components/modal/single-candidate-modal/_index.module.scss
var _index_module = __webpack_require__(61790);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
;// CONCATENATED MODULE: ./src/imports-files/components/model/single-candidate-modal.js
// --------------------- COMMON ---------------------

// --------------------- COMMON ---------------------
// export { CONSTANTS } from '@/constants/components/modals/select-job-modal';



// EXTERNAL MODULE: ../../shared/node_modules/react-accessible-accordion/dist/es/index.js
var es = __webpack_require__(51101);
// EXTERNAL MODULE: ./src/imports-files/components/common-modal/common-modal.js + 2 modules
var common_modal = __webpack_require__(66172);
// EXTERNAL MODULE: ./src/components/common-modal/modal.js + 2 modules
var modal = __webpack_require__(99005);
;// CONCATENATED MODULE: ./src/components/modals/single-candidate-modal.js





function SingleCandidateModal(props) {
    var collapsibleButtonClick = function collapsibleButtonClick(event) {
        var currentElement = event.currentTarget;
        currentElement.classList.toggle("active");
        var content = currentElement.nextElementSibling;
        if (content.style.maxHeight && content.style.maxHeight != "0px") {
            content.style.maxHeight = "0px";
        } else {
            content.style.maxHeight = content.scrollHeight + "px";
        }
    };
    var getScoreColor = function getScoreColor(score, isLight) {
        var scoreValue = parseFloat(score);
        if (scoreValue == NaN || scoreValue == 0) return isLight ? "LightNaBg" : "NaBg";
        else if (scoreValue <= 2) return isLight ? "LightRedBg" : "RedBg";
        else if (scoreValue > 2 && scoreValue < 4) return isLight ? "LightYellowBg" : "YellowBg";
        else if (scoreValue >= 4) return isLight ? "LightGreenBg" : "GreenBg";
        else return isLight ? "LightNaBg" : "NaBg";
    };
    var t = (0,common/* useTranslation */.$G)().t;
    var data = props.data, buttonPopup = props.buttonPopup, setButtonPopup = props.setButtonPopup, viewScorecard = props.viewScorecard, setShowViewScorecards = props.setShowViewScorecards;
    (0,common/* useEffect */.d4)(function() {
        setTimeout(function() {
            var subcompetencies = Array.from(document.getElementsByClassName("collapsible"));
            if (subcompetencies && subcompetencies.length > 0) {
                subcompetencies === null || subcompetencies === void 0 ? void 0 : subcompetencies.forEach(function(element, index) {
                    element.classList.toggle("active");
                    var content = element.nextElementSibling;
                    if (content.style.maxHeight && content.style.maxHeight != "0px") {
                        content.style.maxHeight = "0px";
                    } else {
                        content.style.maxHeight = content.scrollHeight + "px";
                    }
                });
            }
        }, 100);
    }, [
        viewScorecard,
        buttonPopup
    ]);
    return buttonPopup || viewScorecard ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
            type: "form",
            heading: t("modal:form:scorecard:heading"),
            NoOuterPadding: true,
            ScoreCardModal: true,
            largeWidth: true,
            closeModal: function(event) {
                setButtonPopup ? setButtonPopup(false) : setShowViewScorecards(false);
            },
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((_index_module_default()).Modal__Body),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((_index_module_default()).Modal__Body__HeadingPlusScore),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "".concat((_index_module_default()).Modal__Body__MainHeading),
                                        children: data === null || data === void 0 ? void 0 : data.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((_index_module_default()).Modal__Body__OverallScore),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: t("modal:form:scorecard:overall_score")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((_index_module_default()).Modal__Body__OverallScoreValue, " ").concat(getScoreColor(data === null || data === void 0 ? void 0 : data.scorecard_overall_score, false)),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "Average__Score",
                                                    children: data === null || data === void 0 ? void 0 : data.scorecard_overall_score
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "Modal__Accordian",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Accordion */.UQ, {
                                        preExpanded: [
                                            "overall_feedback"
                                        ],
                                        allowZeroExpanded: true,
                                        className: "accordion",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItem */.Qd, {
                                            uuid: "overall_feedback",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemHeading */.Ol, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemButton */.on, {
                                                        className: "accordion__button ".concat(getScoreColor(data === null || data === void 0 ? void 0 : data.scorecard_overall_score, false)),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "NoRightBorder",
                                                            children: t("modal:form:scorecard:overall_feedback")
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemPanel */.Mt, {
                                                    className: "accordion__panel",
                                                    children: data === null || data === void 0 ? void 0 : data.overall_feedback.map(function(feedback, index) {
                                                        var ref, ref1, ref2;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "Accordian__Body",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "Accordian__Body__Candidate__Details",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "Accordian__Body__CandidateImg",
                                                                            children: ((ref = feedback.reviewer) === null || ref === void 0 ? void 0 : ref.photo_url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                src: feedback.reviewer.photo_url
                                                                            }) : ((ref1 = feedback.reviewer) === null || ref1 === void 0 ? void 0 : ref1.name_initials) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (_index_module_default()).Tagrow__Prefix,
                                                                                children: (ref2 = feedback.reviewer) === null || ref2 === void 0 ? void 0 : ref2.name_initials
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "Accordian__Body__CandidateDescription",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "Accordian__Body__CandidateName",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: feedback.reviewer.name
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            className: "Accordian__Body__Flex",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                className: "Accordian__Body__Date",
                                                                                                children: feedback.updated_at
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "Accordian__Body__CandidateFeedback",
                                                                                    children: feedback.feedback ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                        className: "BlueText",
                                                                                        children: feedback.feedback
                                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                        className: "GreyText",
                                                                                        children: [
                                                                                            t("modal:form:scorecard:no_notes"),
                                                                                            " "
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "Accordian__Body__Candidate__Score ".concat(getScoreColor(feedback.overall_score, true)),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: feedback.overall_score || "N/A"
                                                                    })
                                                                })
                                                            ]
                                                        });
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    !data.only_feedback && (data === null || data === void 0 ? void 0 : data.scorecard.competencies.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "Accordian__Title",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: t("modal:form:scorecard:competencies")
                                        })
                                    }),
                                    !data.only_feedback && (data === null || data === void 0 ? void 0 : data.scorecard.competencies.map(function(competency, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Accordion */.UQ, {
                                            preExpanded: [
                                                "competency_".concat(competency.id)
                                            ],
                                            allowZeroExpanded: true,
                                            className: "accordion WhiteBg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItem */.Qd, {
                                                uuid: "competency_".concat(competency.id),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemHeading */.Ol, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItemButton */.on, {
                                                            className: "accordion__button ".concat(getScoreColor(competency.competency_score, false)),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "".concat(competency.reviewers.length == 1 ? "noborder" : ""),
                                                                    children: competency.competency_name
                                                                }),
                                                                competency.reviewers.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "Average__Score",
                                                                    children: competency.competency_score || "N/A"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    (competency.reviewers.length > 0 || competency.sub_competencies.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItemPanel */.Mt, {
                                                        children: [
                                                            competency.reviewers.map(function(reviewer, review_ndex) {
                                                                var ref, ref1, ref2, ref3;
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "Accordian__Body",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "Accordian__Body__Candidate__Details",
                                                                            children: [
                                                                                competency.reviewers.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "Accordian__Body__CandidateImg",
                                                                                    children: ((ref = reviewer.reviewer_detail) === null || ref === void 0 ? void 0 : ref.photo_url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        src: (ref1 = reviewer.reviewer_detail) === null || ref1 === void 0 ? void 0 : ref1.photo_url
                                                                                    }) : ((ref2 = reviewer.reviewer_detail) === null || ref2 === void 0 ? void 0 : ref2.name_initials) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: (_index_module_default()).Tagrow__Prefix,
                                                                                        children: (ref3 = reviewer.reviewer_detail) === null || ref3 === void 0 ? void 0 : ref3.name_initials
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "Accordian__Body__CandidateDescription",
                                                                                    children: [
                                                                                        competency.reviewers.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "Accordian__Body__CandidateName",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    children: reviewer.reviewer_detail.name
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "Accordian__Body__Flex",
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                        className: "Accordian__Body__Date",
                                                                                                        children: reviewer.date
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        competency.reviewers.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "Accordian__Body__CandidateFeedback",
                                                                                            children: reviewer.info ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                className: "BlueText",
                                                                                                children: reviewer.info
                                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                                className: "GreyText",
                                                                                                children: [
                                                                                                    t("modal:form:scorecard:no_notes"),
                                                                                                    " "
                                                                                                ]
                                                                                            })
                                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "Accordian__Body__CandidateFeedback ".concat(reviewer.info ? "" : "h-100"),
                                                                                            children: reviewer.info ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                className: "BlueText mw100 pr10",
                                                                                                children: reviewer.info
                                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                                className: "GreyText d-flex align-items-center h-100",
                                                                                                children: [
                                                                                                    t("modal:form:scorecard:no_notes"),
                                                                                                    "  "
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "Accordian__Body__Candidate__Score ".concat(getScoreColor(reviewer.score, true)),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: reviewer.score || "N/A"
                                                                            })
                                                                        })
                                                                    ]
                                                                });
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "Accordian__SubCompetancy",
                                                                children: competency.sub_competencies.map(function(subcompetency, subcompetency_index) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                                class: "collapsible",
                                                                                onClick: function(event) {
                                                                                    if (subcompetency.reviewers.length > 0) collapsibleButtonClick(event);
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "w100 mr15",
                                                                                        children: subcompetency.sub_competency_name
                                                                                    }),
                                                                                    subcompetency.reviewers.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "SubCompetancy__Score ".concat(getScoreColor(subcompetency.sub_competency_score, false)),
                                                                                        children: subcompetency.sub_competency_score || "N/A"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                class: "content",
                                                                                children: subcompetency.reviewers.map(function(reviewer, review_index) {
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "Accordian__Body ".concat(subcompetency.reviewers.length > 1 ? "" : "pl0"),
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                className: "Accordian__Body__Candidate__Details",
                                                                                                children: [
                                                                                                    subcompetency.reviewers.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                        className: "Accordian__Body__CandidateImg",
                                                                                                        children: reviewer.reviewer_detail.photo_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                            src: reviewer.reviewer_detail.photo_url
                                                                                                        }) : reviewer.reviewer_detail.name_initials && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                            className: (_index_module_default()).Tagrow__Prefix,
                                                                                                            children: reviewer.reviewer_detail.name_initials
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                        className: "Accordian__Body__CandidateDescription",
                                                                                                        children: [
                                                                                                            subcompetency.reviewers.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                                className: "Accordian__Body__CandidateName",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                                        children: reviewer.reviewer_detail.name
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                                        className: "Accordian__Body__Flex",
                                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                            className: "Accordian__Body__Date",
                                                                                                                            children: reviewer.date
                                                                                                                        })
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            subcompetency.reviewers.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                className: "Accordian__Body__CandidateFeedback pr10",
                                                                                                                children: reviewer.info ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                                    className: "BlueText",
                                                                                                                    children: reviewer.info
                                                                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                                                    className: "GreyText",
                                                                                                                    children: [
                                                                                                                        t("modal:form:scorecard:no_notes"),
                                                                                                                        "  "
                                                                                                                    ]
                                                                                                                })
                                                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                className: "Accordian__Body__CandidateFeedback ".concat(reviewer.info ? "" : "h-100"),
                                                                                                                children: reviewer.info ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                                    className: "BlueText mw100 pr10",
                                                                                                                    children: reviewer.info
                                                                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                                                    className: "GreyText d-flex align-items-center h-100",
                                                                                                                    children: [
                                                                                                                        t("modal:form:scorecard:no_notes"),
                                                                                                                        " "
                                                                                                                    ]
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: "Accordian__Body__Candidate__Score ".concat(getScoreColor(reviewer.score, true)),
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    children: reviewer.score
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    });
                                                                                })
                                                                            })
                                                                        ]
                                                                    });
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        });
                                    }))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((_index_module_default()).Modal__Footer)
                    })
                ]
            })
        })
    }) : "";
}


/***/ }),

/***/ 62837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);


function ProgressBar() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "progress automationprog",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "progress-value automationprog-value"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ProgressBar);


/***/ }),

/***/ 57807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ ReviewEmail; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62286);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3623);
/* harmony import */ var _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66172);




function ReviewEmail(props) {
    var editSubjectHtml = function editSubjectHtml(subject) {
        var new_subject = subject.replace(/(<([^>]+)>)/gi, "");
        new_subject = new_subject.replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&gt;/g, ">").replace(/&lt;/g, "<").replace(/&rsquo;/g, "’").replace(/&ouml;/g, "\xf6").replace(/&oslash;/g, "\xf8").replace(/&auml;/g, "\xe4").replace(/&aring;/g, "\xe5");
        new_subject = new_subject.replace(/\n/g, " ");
        return new_subject.trim();
    };
    // --- INFO:- Clearing the SWR cache ----
    (0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .clearSWRCache */ .A$)("review_email_data");
    // --------------------------------------
    var t = (0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    var router = (0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .useRouter */ .tv)();
    var reviewEmailActions = new _imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .ReviewEmailActions */ .fY();
    var ref = (0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .useSWR */ .dH)("review_email_data", function() {
        return reviewEmailActions.getEmailTemplateData(router, props.emailTemplateInfo, props.emailTemplateInfo.template_id, props.emailTemplateData, props.type);
    }), data = ref.data, error = ref.error;
    var editorBodyRef = (0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .useRef */ .sO)(null);
    var editorSubjectRef = (0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .useRef */ .sO)(null);
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(""), 2), subject = ref1[0], setSubject = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(""), 2), dataVariables = ref2[0], setDataVariables = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(true), 2), isLoading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .REVIEW_EMAIL.email_template.formInitialValue */ .OT.email_template.formInitialValue), 2), formInitialValues = ref4[0], setFormInitialValues = ref4[1];
    // const formValidation                                    =     REVIEW_EMAIL.email_template.formValidation;
    var formFieldNames = reviewEmailActions.getFormFieldsName();
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(0), 2), refreshKey = ref5[0], setRefreshKey = ref5[1];
    var formRef = (0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .useRef */ .sO)(null);
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(false), 2), disableSubmitButton = ref6[0], setDisabledSubmitButton = ref6[1];
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(""), 2), currentPurposeValue = ref7[0], setCurrentPurposeValue = ref7[1];
    (0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .useEffect */ .d4)(function() {
        if (data) {
            var ref, ref1, ref2, ref3;
            if (props.emailTemplateInfo.operation_type == "edit") {
                var ref4;
                if (props.emailTemplateInfo.type == "custom" && props.emailTemplateInfo.operation_type == "edit") {
                    setCurrentPurposeValue("custom_template");
                }
                setFormInitialValues(reviewEmailActions.setFormInitialValues((data === null || data === void 0 ? void 0 : (ref4 = data.template_data) === null || ref4 === void 0 ? void 0 : ref4.data) || data, props.type));
            } else {
                var emptyInitialValue = {
                    template: {
                        master_template_id: "",
                        master_template_type: "",
                        master_template_attributes: {
                            purpose: ""
                        },
                        subject: "",
                        email_body: "",
                        default: false
                    }
                };
                setFormInitialValues(emptyInitialValue);
            }
            setSubject((data === null || data === void 0 ? void 0 : (ref = data.template_data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.subject_variables) || (data === null || data === void 0 ? void 0 : data.subject_variables));
            setDataVariables((data === null || data === void 0 ? void 0 : (ref2 = data.template_data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.data_variables) || (data === null || data === void 0 ? void 0 : data.data_variables));
            setLoading(false);
        }
    }, [
        JSON.stringify(data)
    ]);
    if (isLoading) {
        return "";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.ModalOverlay */ .w2.ModalOverlay),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal */ .w2.Modal, " "),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container */ .w2.Modal__Container, " "),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container__Heading__Close */ .w2.Modal__Container__Heading__Close),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container__ContentSection__Heading */ .w2.Modal__Container__ContentSection__Heading),
                                children: props.emailTemplateInfo.operation_type == "create" ? t("recruitment:templates:email:create") : t("recruitment:templates:email:edit")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container__CloseSection */ .w2.Modal__Container__CloseSection),
                                onClick: function() {
                                    props.type == "kanban" ? props.setHideModalClass(false) : "";
                                    props.setReviewEmail(false);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_2__/* .Close */ .x8, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: _imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container__ContentSection */ .w2.Modal__Container__ContentSection,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .Formik */ .J9, {
                            initialValues: formInitialValues,
                            validationSchema: reviewEmailActions.formValidation(currentPurposeValue),
                            innerRef: formRef,
                            onSubmit: function(values) {
                                if (props.type == "kanban") {
                                    values.job_stage_id = props.emailTemplateInfo.job_stage_id;
                                    values.template.subject = editSubjectHtml(values.template.subject);
                                    reviewEmailActions.saveEmailTemplate(values, props.job_id, router, props.setHideModalClass, props.setReviewEmail, formRef, setDisabledSubmitButton);
                                } else {
                                    values.template.subject = editSubjectHtml(values.template.subject);
                                    reviewEmailActions.submitReviewEmail(values, props.setReviewEmail, props.emailTemplateInfo, props.emailTemplateData, props.setEmailTemplateData, props.setFlagForRender, formRef, router, setDisabledSubmitButton);
                                }
                            },
                            children: function(formik) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                style: (0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oH)(formik, "".concat(formFieldNames.type, ".").concat(formFieldNames.master_template_id)),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "red-color",
                                                        children: "*"
                                                    }),
                                                    "\xa0",
                                                    t("label:purpose")
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block),
                                            children: props.emailTemplateInfo.type == "custom" && props.emailTemplateInfo.operation_type == "edit" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                control: "input",
                                                type: "text",
                                                formik: formik,
                                                errorClass: _imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Form__Error */ .w2.Form__Error,
                                                placeholder: t("label:purpose"),
                                                className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Form__Input */ .w2.Form__Input, " width100 thresholdmodl"),
                                                name: formFieldNames["type"] + "." + formFieldNames["purpose"],
                                                style: (0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "".concat(formFieldNames.type, ".").concat(formFieldNames.purpose))
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                control: "select",
                                                type: "text",
                                                formik: formik,
                                                errorClass: _imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Form__Error */ .w2.Form__Error,
                                                default: props.type == "kanban" ? "0" : formInitialValues.template.master_template_id,
                                                disabled: props.emailTemplateInfo.operation_type != "create" && props.type != "kanban" ? true : false,
                                                s: true,
                                                className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Form__Input */ .w2.Form__Input, " ").concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormStyle.Form__Input */ .x.Form__Input, " thresholdmodl"),
                                                name: formFieldNames["type"] + "." + formFieldNames["master_template_id"],
                                                options: props.type == "kanban" ? reviewEmailActions.kanbanPurposeList(props.emailTemplateData) : reviewEmailActions.getPurposeOptions(props.emailTemplateInfo.operation_type == "create" ? data === null || data === void 0 ? void 0 : data.purpose_list : props.emailTemplateData, props.type, t).options,
                                                style: (0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "".concat(formFieldNames.type, ".").concat(formFieldNames.master_template_id)),
                                                onChange: function(option) {
                                                    if (props.type == "kanban") {
                                                        setCurrentPurposeValue(option.value);
                                                        reviewEmailActions.setSystemTemplate(option, formik, formFieldNames, setSubject, setDataVariables, setRefreshKey, props.emailTemplateData.templates);
                                                    } else {
                                                        setCurrentPurposeValue(option.value);
                                                        reviewEmailActions.getSystemEmailTemplate(option, formik, formFieldNames, setSubject, setDataVariables, setRefreshKey, t);
                                                    }
                                                }
                                            })
                                        }),
                                        formik.values[formFieldNames["type"]][formFieldNames["master_template_id"]] == "add_custom" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                        className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                        style: (0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oH)(formik, "".concat(formFieldNames.type, ".").concat(formFieldNames.master_template_attributes, ".").concat(formFieldNames.purpose)),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "red-color",
                                                                children: "*"
                                                            }),
                                                            "\xa0",
                                                            t("label:new_purpose")
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                        control: "input",
                                                        type: "text",
                                                        formik: formik,
                                                        errorClass: _imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Form__Error */ .w2.Form__Error,
                                                        placeholder: t("label:purpose"),
                                                        className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Form__Input */ .w2.Form__Input, " ").concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormStyle.Form__Input */ .x.Form__Input, " width100 thresholdmodl"),
                                                        name: formFieldNames["type"] + "." + formFieldNames["master_template_attributes"] + "." + formFieldNames["purpose"],
                                                        style: (0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "".concat(formFieldNames.type, ".").concat(formFieldNames.master_template_attributes, ".").concat(formFieldNames.purpose))
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                style: (0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oH)(formik, "".concat(formFieldNames.type, ".").concat(formFieldNames.subject)),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "red-color",
                                                        children: "*"
                                                    }),
                                                    "\xa0",
                                                    t("label:subject")
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                id: "email_template_subject",
                                                apiKey: "dxe0l6rdhdta2rzyfq2io208ncq1ay4l9wc2vyre3a53sdna",
                                                control: "customEditor",
                                                formik: formik,
                                                name: "".concat(formFieldNames.type, ".").concat(formFieldNames.subject),
                                                onInit: function(evt, editor) {
                                                    return editorSubjectRef.current = editor;
                                                },
                                                textareaName: "".concat(formFieldNames.type, ".").concat(formFieldNames.subject),
                                                identifierClass: "emailTemplateSubject",
                                                style: (0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "".concat(formFieldNames.type, ".").concat(formFieldNames.subject)),
                                                value: formik.values["".concat(formFieldNames.type)]["".concat(formFieldNames.subject)],
                                                onEditorChange: function(value, editor) {
                                                    formik.status ? formik.status["".concat(formFieldNames.type)]["".concat(formFieldNames.subject)] = "" : "";
                                                    // let subject_value = editor.getContent({format: 'text'});
                                                    formik.setFieldValue("".concat(formFieldNames.type, ".").concat(formFieldNames.subject), value);
                                                },
                                                init: {
                                                    height: 50,
                                                    resize: false,
                                                    menubar: false,
                                                    plugins: [
                                                        "advlist",
                                                        "autolink",
                                                        "lists",
                                                        "link",
                                                        "image",
                                                        "charmap",
                                                        "print",
                                                        "preview anchor",
                                                        "searchreplace",
                                                        "visualblocks",
                                                        "code",
                                                        "fullscreen",
                                                        "insertdatetime",
                                                        "media",
                                                        "table",
                                                        "paste",
                                                        "help",
                                                        "wordcount",
                                                        "autoresize",
                                                        "noneditable", 
                                                    ],
                                                    toolbar: "tokens",
                                                    content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                                    newline_behavior: "block",
                                                    noneditable_regexp: /\{\{[^\}]+\}\}/g,
                                                    setup: function(editor) {
                                                        // Register a custom toolbar menu button to insert tokens
                                                        // https://www.tiny.cloud/docs/ui-components/typesoftoolbarbuttons/#menubutton
                                                        editor.ui.registry.addMenuButton("tokens", {
                                                            text: t("label:data_tags"),
                                                            tooltip: t("label:insert_token"),
                                                            fetch: function(callback) {
                                                                var items = subject.map(function(subject) {
                                                                    return {
                                                                        type: "menuitem",
                                                                        text: subject.text,
                                                                        onAction: function() {
                                                                            // Insert content at the location of the cursor.
                                                                            // https://www.tiny.cloud/docs/api/tinymce/tinymce.editor/#insertcontent
                                                                            editor.insertContent(subject.value);
                                                                        }
                                                                    };
                                                                });
                                                                callback(items);
                                                            }
                                                        });
                                                        editor.on("keydown", function(e) {
                                                            if (e.keyCode == 13) {
                                                                e.preventDefault();
                                                            }
                                                        });
                                                    },
                                                    paste_preprocess: function paste_preprocess(plugin, args) {
                                                        args.content = args.content.replace(/(<([^>]+)>)/gi, "");
                                                    }
                                                }
                                            }, refreshKey)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                style: (0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oH)(formik, "".concat(formFieldNames.type, ".").concat(formFieldNames.body)),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "red-color",
                                                        children: "*"
                                                    }),
                                                    "\xa0",
                                                    t("label:email_body")
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                id: "email_template_body",
                                                control: "customEditor",
                                                formik: formik,
                                                onInit: function(evt, editor) {
                                                    return editorBodyRef.current = editor;
                                                },
                                                textareaName: "".concat(formFieldNames.type, ".").concat(formFieldNames.body),
                                                identifierClass: "emailTemplateBody",
                                                style: (0,_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "".concat(formFieldNames.type, ".").concat(formFieldNames.body)),
                                                value: formik.values["".concat(formFieldNames.type)]["".concat(formFieldNames.body)],
                                                onEditorChange: function(value) {
                                                    formik.status ? formik.status["".concat(formFieldNames.type)]["".concat(formFieldNames.body)] = "" : "";
                                                    formik.setFieldValue("".concat(formFieldNames.type, ".").concat(formFieldNames.body), value);
                                                },
                                                init: {
                                                    height: 500,
                                                    menubar: false,
                                                    resize: false,
                                                    plugins: [
                                                        "advlist",
                                                        "autolink",
                                                        "lists",
                                                        "link",
                                                        "image",
                                                        "charmap",
                                                        "preview",
                                                        "anchor",
                                                        "searchreplace",
                                                        "visualblocks",
                                                        "code",
                                                        "fullscreen",
                                                        "insertdatetime",
                                                        "media",
                                                        "table",
                                                        "help",
                                                        "wordcount",
                                                        "noneditable", 
                                                    ],
                                                    toolbar: "undo redo | blocks | " + "bold italic backcolor | link |  alignleft aligncenter " + "alignright alignjustify | tokens",
                                                    content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                                    noneditable_regexp: /\{\{[^\}]+\}\}/g,
                                                    allow_html_in_named_anchor: true,
                                                    setup: function(editor) {
                                                        // Register a custom toolbar menu button to insert tokens
                                                        // https://www.tiny.cloud/docs/ui-components/typesoftoolbarbuttons/#menubutton
                                                        editor.ui.registry.addMenuButton("tokens", {
                                                            text: t("label:data_tags"),
                                                            tooltip: t("label:insert_token"),
                                                            fetch: function(callback) {
                                                                var items = dataVariables.map(function(dataVariable) {
                                                                    return {
                                                                        type: "menuitem",
                                                                        text: dataVariable.text,
                                                                        onAction: function() {
                                                                            // Insert content at the location of the cursor.
                                                                            // https://www.tiny.cloud/docs/api/tinymce/tinymce.editor/#insertcontent
                                                                            editor.insertContent(dataVariable.value);
                                                                        }
                                                                    };
                                                                });
                                                                callback(items);
                                                            }
                                                        });
                                                    }
                                                }
                                            }, refreshKey)
                                        }),
                                        router.query.email_type == "custom" && formik.values["".concat(formFieldNames["type"])]["master_template_type"] == "MasterTemplate" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormStyle.Form__LabelCheck */ .x.Form__LabelCheck, " Dpflex16 Mui__CustomCheckbox"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .Checkbox */ .XZ, {
                                                        name: formFieldNames["type"] + "." + formFieldNames["default"],
                                                        onChange: function(event) {
                                                            formik.setFieldValue("".concat(formFieldNames.type, ".").concat(formFieldNames.default), event.target.checked);
                                                        },
                                                        defaultChecked: formInitialValues.template.default == "Yes",
                                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .DefaultCheckbox */ .v0, {}),
                                                        checkedIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .CheckedCheckbox */ .bN, {})
                                                    }),
                                                    " ",
                                                    t("checkbox:set_as_default")
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: _imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container__ButtonSection */ .w2.Modal__Container__ButtonSection,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                    buttonstyle: _imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.secondarybtnborder */ .w2.secondarybtnborder,
                                                    onClick: function() {
                                                        props.type == "kanban" ? props.setHideModalClass(false) : "";
                                                        props.setReviewEmail(false);
                                                    },
                                                    children: t("button:cancel")
                                                }),
                                                props.type != "kanban" && router.query.email_type != "custom" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                    buttonstyle: _imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.secondarybtnborder */ .w2.secondarybtnborder,
                                                    onClick: function() {
                                                        reviewEmailActions.resetTemplate(props.emailTemplateInfo.template_id, props.setReviewEmail);
                                                    },
                                                    children: t("button:reset")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                    buttonstyle: _imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.primarybtn */ .w2.primarybtn,
                                                    type: "submit",
                                                    disabled: disableSubmitButton,
                                                    children: t("button:save")
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 78941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ setup_interview_modal; }
});

// UNUSED EXPORTS: SetupInterviewModal

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(38641);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(18186);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4012);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(34817);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/styles/components/share-cv/_index.module.scss
var _index_module = __webpack_require__(2443);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/styles/components/automation-popup/_index.module.scss
var automation_popup_index_module = __webpack_require__(72123);
var automation_popup_index_module_default = /*#__PURE__*/__webpack_require__.n(automation_popup_index_module);
// EXTERNAL MODULE: ./src/styles/components/modal/add-assessment/_index.module.scss
var add_assessment_index_module = __webpack_require__(55264);
var add_assessment_index_module_default = /*#__PURE__*/__webpack_require__.n(add_assessment_index_module);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
// EXTERNAL MODULE: ../../shared/node_modules/react-simple-tooltip/es/index.js + 11 modules
var es = __webpack_require__(54392);
// EXTERNAL MODULE: ./public/icons/call2.svg
var call2 = __webpack_require__(67536);
// EXTERNAL MODULE: ./public/icons/technical.svg
var technical = __webpack_require__(36414);
// EXTERNAL MODULE: ./public/icons/video.svg
var video = __webpack_require__(15166);
// EXTERNAL MODULE: ./public/icons/user.svg
var user = __webpack_require__(41739);
// EXTERNAL MODULE: ./public/icons/videoqa.svg
var videoqa = __webpack_require__(20226);
// EXTERNAL MODULE: ../../shared/node_modules/react-select/dist/index-4bd03571.esm.js + 1 modules
var index_4bd03571_esm = __webpack_require__(28805);
// EXTERNAL MODULE: ./src/styles/components/button/_index.module.scss
var button_index_module = __webpack_require__(84215);
var button_index_module_default = /*#__PURE__*/__webpack_require__.n(button_index_module);
// EXTERNAL MODULE: ../../shared/node_modules/react-autosuggest/dist/index.js
var dist = __webpack_require__(46921);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ../../shared/node_modules/react-places-autocomplete/dist/index.js
var react_places_autocomplete_dist = __webpack_require__(25538);
// EXTERNAL MODULE: ./src/components/loading.js + 1 modules
var loading = __webpack_require__(85462);
// EXTERNAL MODULE: ./public/icons/exclamation.svg
var exclamation = __webpack_require__(22461);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/recruitments/manage-assessment.js + 6 modules
var manage_assessment = __webpack_require__(78245);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/jobs/candidate-profile-job.js + 9 modules
var candidate_profile_job = __webpack_require__(51895);
// EXTERNAL MODULE: ./src/imports-files/components/job-filters.js + 1 modules
var job_filters = __webpack_require__(29774);
// EXTERNAL MODULE: ./src/imports-files/components/model/setup-video-qa.js + 3 modules
var setup_video_qa = __webpack_require__(37521);
// EXTERNAL MODULE: ./src/layouts/ClientDashboard.js
var ClientDashboard = __webpack_require__(71234);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/candidates/kanban.js + 10 modules
var kanban = __webpack_require__(47942);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/jobs/automations.js + 3 modules
var automations = __webpack_require__(64335);
// EXTERNAL MODULE: ../../shared/node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(73732);
;// CONCATENATED MODULE: ./src/constants/components/setup-interview.js

function setupInterviewInitialValues(values) {
    var isPrimary = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var setJobTestDetail = function setJobTestDetail(job_test_detail_attributes) {
        var value = job_test_detail_attributes;
        if (job_test_detail_attributes.test_type == "Assessment" && job_test_detail_attributes.entity_type == "JobStage") {
            value.test_id = "upload_new_test";
            value.test_name = t("modal:automation:upload_new_test");
        }
        if (!value.assessment) value.assessment = {
            name: "",
            file_type: "link",
            link: "",
            file: "",
            filename: "",
            filesize: ""
        };
        delete value["id"];
        return value;
    };
    var defaultTestDetail = function defaultTestDetail(member_emails, member_initials) {
        return {
            "test_id": "",
            "test_type": "TestLibrary",
            "days_to_expire": "",
            "member_emails": member_emails || [],
            "member_initials": member_initials || [],
            "assessment": {
                name: "",
                file_type: "link",
                link: "",
                file: "",
                filename: "",
                filesize: ""
            }
        };
    };
    var videoQuestions = function videoQuestions(questions_attributes) {
        var questions = [];
        questions_attributes.map(function(question, index) {
            questions.push({
                "question": question.question || "",
                "description": question.description || "",
                "attempts": question.attempts || "",
                "answer_time": question.answer_time || "",
                "_destroy": false
            });
            return question;
        });
        return questions;
    };
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var children_attributes = [];
    values.job_meeting_details_attributes.map(function(x, index) {
        var ref;
        var hash = {
            duration: x.duration,
            member_emails: x.member_emails || [],
            member_initials: x.member_initials || [],
            member_ids: x.member_ids || [],
            members: x.members || [],
            order: x.order,
            date: "",
            starttime: "",
            endtime: "",
            start_time: x.start_time || "",
            end_time: x.end_time || "",
            integration_id: ((ref = x.meeting_platform_attributes) === null || ref === void 0 ? void 0 : ref.integration_id) || "",
            location: x.location || "",
            place_id: x.place_id || "",
            meeting_link: "",
            _destroy: x._destroy
        };
        children_attributes.push(hash);
        return x;
    });
    var job_test_detail_attributes = {};
    if (values.job_test_detail_attributes) {
        job_test_detail_attributes = setJobTestDetail(values.job_test_detail_attributes, t);
    } else {
        job_test_detail_attributes = defaultTestDetail([], []);
    }
    return {
        primary: isPrimary,
        interview_type_id: isPrimary ? values.interview_type_id : "",
        interview_type: isPrimary ? values.interview_type : "",
        default_location: isPrimary ? values.default_location : "",
        place_id: isPrimary ? values.place_id : "",
        date_range: true,
        children_attributes: isPrimary ? children_attributes : [],
        language: "English",
        video_link: isPrimary ? values.video_link || "" : "",
        questions_attributes: isPrimary ? videoQuestions(values.questions_attributes) : [
            {
                question: "",
                description: "",
                attempts: 2,
                answer_time: 30,
                _destroy: false
            }
        ],
        practise_screen: isPrimary ? values.practise_screen || false : false,
        expires: isPrimary ? values.expires || "" : "",
        job_test_detail_attributes: isPrimary ? job_test_detail_attributes : defaultTestDetail([], []),
        videoqa: {
            member_emails: values.members.map(function(x) {
                return x.email;
            }) || [],
            member_initials: values.members || []
        }
    };
}

// EXTERNAL MODULE: ./src/components/common-modal/modal.js + 2 modules
var modal = __webpack_require__(99005);
// EXTERNAL MODULE: ./src/imports-files/components/common-modal/common-modal.js + 2 modules
var common_modal = __webpack_require__(66172);
// EXTERNAL MODULE: ./public/new-icons/info-icon.svg
var info_icon = __webpack_require__(86013);
// EXTERNAL MODULE: ./public/icons/thick-plus.svg
var thick_plus = __webpack_require__(83238);
;// CONCATENATED MODULE: ./src/components/setup-interview-modal.js






































function SetupInterviewModal(props) {
    var interviewSwitchButton = function interviewSwitchButton(type) {
        switch(type){
            case common/* INTERVIEW_TYPES.PHONE */.BH.PHONE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(call2/* default */.Z, {});
            case common/* INTERVIEW_TYPES.TECHTEST */.BH.TECHTEST:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(technical/* default */.Z, {
                    className: "techIcon"
                });
            case common/* INTERVIEW_TYPES.VIDEO */.BH.VIDEO:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(video/* default */.Z, {});
            case common/* INTERVIEW_TYPES.FACE2FACE */.BH.FACE2FACE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(user/* default */.Z, {
                    className: "faceIcon"
                });
            case common/* INTERVIEW_TYPES.VIDEOQA */.BH.VIDEOQA:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(videoqa/* default */.Z, {
                    className: "videoQAIcon"
                });
            default:
                return "";
        }
    };
    var gridClass = function gridClass(current_interview_type) {
        return current_interview_type == common/* INTERVIEW_TYPES.VIDEO */.BH.VIDEO ? (_index_module_default()).SetupPopup__ContentGrid : (automation_popup_index_module_default()).AutomationPopup__ContentGridPhone;
    };
    var ref, ref1, ref2, ref3;
    var initialValues = setupInterviewInitialValues(props.currentStage, props.isPrimaryinterview);
    var currentStage = props.currentStage;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(props.isPrimaryinterview ? currentStage === null || currentStage === void 0 ? void 0 : currentStage.interview_type : ""), 2), current_interview_type = ref4[0], setCurrentInterviewType = ref4[1];
    // initialValues.children_attributes.map((x) => x.interview_type    =     initialValues.interview_type)
    // initialValues.default_location                                              =     initialValues.job_meeting_details_attributes[0]?.location_attributes?.full_address || currentStage?.default_location
    // initialValues.place_id                                                      =     initialValues.job_meeting_details_attributes[0]?.location_attributes?.place_id || currentStage?.place_id
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), tests = ref5[0], setTests = ref5[1];
    var techTestAction = new automations/* TechTestAction */.Uy(setTests);
    var videoQaAction = new automations/* VideoQaAction */.CS(setTests);
    // if(currentStage.interview_type == INTERVIEW_TYPES.TECHTEST) (initialValues = setUpTechTest(initialValues, techTestAction, currentStage))
    // if(currentStage.interview_type == INTERVIEW_TYPES.VIDEOQA) (initialValues = setUpVideoQAMember(initialValues, currentStage))
    var Option = index_4bd03571_esm.c.Option;
    var setBtnPopup = props.setBtnPopup;
    var setOnLoadValues = props.setOnLoadValues;
    var platforms = props.currentStage.platforms;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(initialValues.children_attributes.length), 2), interviewStageCount = ref6[0], setInterviewStageCount = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), users = ref7[0], setUsers = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(initialValues.children_attributes.map(function(x) {
        return x.duration;
    }).reduce(function(a, b) {
        a = parseInt(a) || 0;
        b = parseInt(b) || 0;
        return a + b;
    }, 0)), 2), totalDuration = ref8[0], setTotalDuration = ref8[1];
    var router = (0,candidate_profile_job/* useRouter */.tv)();
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)((0,candidate_profile_job/* initialStageValues */.jv)(initialValues)), 2), stageEmail = ref9[0], setStageEmail = ref9[1];
    var duration = props.duration;
    var editable = props.editable;
    var ref10 = (0,candidate_profile_job/* useTranslation */.$G)(), t = ref10.t, i18n = ref10.i18n;
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(true), 2), isLoading = ref11[0], setLoading = ref11[1];
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), isDisabled = ref12[0], setDisabled = ref12[1];
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)((0,candidate_profile_job/* showHideButtonValue */.HW)(initialValues)), 2), showHideButton = ref13[0], setShowHideButton = ref13[1];
    var interviewTypes = props.currentStage.interview_types;
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), disabledAddMoreQuestion = ref14[0], setDisabledAddMoreQuestion = ref14[1];
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), deleteQuestionList = ref15[0], setDeleteQuestionList = ref15[1];
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(0), 2), flagForRender = ref16[0], setFlagForRender = ref16[1];
    var addInterviewManualAction = new candidate_profile_job/* AddInterviewManualAction */.kF(setFlagForRender, deleteQuestionList, setDeleteQuestionList, setDisabledAddMoreQuestion);
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(addInterviewManualAction.setLanguageList(props.currentStage.language_list)), 2), languageListing = ref17[0], setLanguageListing = ref17[1];
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(((ref = initialValues.job_test_detail_attributes) === null || ref === void 0 ? void 0 : ref.test_name) ? initialValues.job_test_detail_attributes.test_name : ""), 2), techTest = ref18[0], setTechTest = ref18[1];
    var ref19 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)({
        value: "",
        error: ""
    }), 2), techStageEmail = ref19[0], setTechStageEmail = ref19[1];
    var ref20 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)({
        type: ((ref1 = initialValues.job_test_detail_attributes) === null || ref1 === void 0 ? void 0 : ref1.test_type) || "TestLibrary",
        test_id: ((ref2 = initialValues.job_test_detail_attributes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.test_id) === null || ref3 === void 0 ? void 0 : ref3.toString()) || ""
    }), 2), validationData = ref20[0], setValidationData = ref20[1];
    var ref21 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(""), 2), buttonState = ref21[0], setButtonState = ref21[1];
    var ref22 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), disabledSaveButton = ref22[0], setDisabledSaveButton = ref22[1];
    var ref23 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)("Upload a file"), 2), uploadFileText = ref23[0], setUploadFileText = ref23[1];
    var customToastrAction = new automations/* CustomToastrAction */.Y5();
    var ref24 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)("range"), 2), addType = ref24[0], setAddType = ref24[1];
    var ref25 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), sendInterview = ref25[0], setSendInterview = ref25[1];
    var ref26 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(props.selectedCards.job_application_ids.indexOf("all") == -1 && props.selectedCards.job_application_ids.length == 1), 2), isSingleCandidate = ref26[0], setIsSingleCandidate = ref26[1];
    var formRef = (0,common/* useRef */.sO)(null);
    (0,candidate_profile_job/* useEffect */.d4)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setLoading(false);
                return [
                    2
                ];
            });
        })();
    }, []);
    if (isLoading) {
        return "";
    }
    var IconOption = function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (_index_module_default()).Selectimg,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        // src={`/images/pages/automation/${props.data.label.replace(' ', '_').toLowerCase()}.png`}
                        src: "".concat(props.data.logo_url),
                        style: {
                            marginRight: 12,
                            width: 20,
                            height: 20,
                            verticalAlign: "middle"
                        },
                        alt: props.data.label
                    }),
                    props.data.label
                ]
            })
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        type: "form",
        closeModal: function() {
            return setBtnPopup(false);
        },
        heading: "".concat((0,automations/* interviewTypeHeader */.ev)(current_interview_type, t).header),
        description: "".concat((0,automations/* interviewTypeHeader */.ev)(current_interview_type, t).subheader),
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Formik */.J9, {
            initialValues: initialValues,
            validationSchema: (0,candidate_profile_job/* validationManualform */.yT)(addType, current_interview_type, sendInterview, platforms, validationData),
            onSubmit: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(values, actions) {
                    var email_data, _tmp, _tmp1, _tmp2;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (validationData.type == "Assessment" && validationData.test_id == "upload_new_test") {
                                    values.save_and_continue = buttonState == "save_and_continue" ? true : false;
                                }
                                if (props.from == "kanban") props.setActionBar(false);
                                _tmp = {};
                                return [
                                    4,
                                    (0,kanban/* reviewAutomationEmail */.ds)(router.query.job_id, router, (_tmp.key = "add_interview", _tmp.list = true, _tmp))
                                ];
                            case 1:
                                email_data = _state.sent();
                                if (!(addType == "time" && [
                                    common/* INTERVIEW_TYPES.PHONE */.BH.PHONE,
                                    common/* INTERVIEW_TYPES.VIDEO */.BH.VIDEO,
                                    common/* INTERVIEW_TYPES.FACE2FACE */.BH.FACE2FACE
                                ].includes(current_interview_type))) return [
                                    3,
                                    2
                                ];
                                _tmp1 = {};
                                props.setAddInterviewBar((_tmp1.active = true, _tmp1.action = {
                                    values: values,
                                    router: router,
                                    setBtnPopup: setBtnPopup,
                                    setInitialData: props.setJobData || props.setInitialData,
                                    setLoading: props.setLoading,
                                    current_interview_type: current_interview_type,
                                    setFlagForRender: setFlagForRender,
                                    setDisabledSaveButton: setDisabledSaveButton,
                                    from: "manual_kanban_interview",
                                    props: props
                                }, _tmp1));
                                props.setReviewKey("add_interview");
                                props.setEmailData(email_data);
                                _tmp2 = {};
                                props.setUnsuccessfulEmailModal((_tmp2.state = true, _tmp2));
                                setBtnPopup(false);
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    (0,candidate_profile_job/* addManualKanbanInterview */.W5)(values, router, setBtnPopup, props.setJobData || props.setInitialData, props.setLoading, current_interview_type, setFlagForRender, setDisabledSaveButton, props, t)
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(values, actions) {
                    return _ref.apply(this, arguments);
                };
            }(),
            children: function(formik) {
                var ref, ref1, ref2, ref3, ref4, ref5;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(common/* Form */.l0, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "AddInterview AutomationPopup",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading, " mt30"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "red-color",
                                            children: "*"
                                        }),
                                        "\xa0",
                                        t("modal:automation:interview:type")
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "Dpflex mb0",
                                        children: interviewTypes.map(function(x, interviewIndex) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (_index_module_default()).Interview__Icons,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
                                                    background: "#00325A",
                                                    radius: 50,
                                                    placement: "top",
                                                    fontSize: "12px",
                                                    content: x.name,
                                                    padding: 12,
                                                    className: "SimpleTooltip",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "".concat((_index_module_default()).Interview__IconsType, " tooltipwidthinterview100"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "radio",
                                                                name: "interview_type_id",
                                                                id: "icon".concat(interviewIndex),
                                                                checked: formik.values.interview_type_id == x.id,
                                                                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                                    var old_interview_type, uniq_member_emails, uniq_member_initials, children_attributes, _obj, durations, _tmp, videoqa, _tmp1;
                                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                old_interview_type = formik.values.interview_type;
                                                                                formik.setFieldValue("interview_type_id", x.id);
                                                                                formik.setFieldValue("interview_type", x.name);
                                                                                currentStage.interview_type = x.name;
                                                                                return [
                                                                                    4,
                                                                                    setCurrentInterviewType(x.name)
                                                                                ];
                                                                            case 1:
                                                                                _state.sent();
                                                                                uniq_member_emails = [];
                                                                                uniq_member_initials = [];
                                                                                children_attributes = formik.values.children_attributes;
                                                                                children_attributes.map(function(x) {
                                                                                    var ref;
                                                                                    if (!x._destroy && ((ref = x.member_emails) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                                                                                        x.member_emails.map(function(member_email, member_email_index) {
                                                                                            if (!uniq_member_emails.includes(member_email)) {
                                                                                                uniq_member_emails.push(member_email);
                                                                                                uniq_member_initials.push(x.member_initials[member_email_index]);
                                                                                            }
                                                                                            return member_email;
                                                                                        });
                                                                                    }
                                                                                    x._destroy = true;
                                                                                    return x;
                                                                                });
                                                                                if (old_interview_type && old_interview_type == common/* INTERVIEW_TYPES.TECHTEST */.BH.TECHTEST) {
                                                                                    uniq_member_emails = formik.values.job_test_detail_attributes.member_emails;
                                                                                    uniq_member_initials = formik.values.job_test_detail_attributes.member_initials;
                                                                                }
                                                                                if (old_interview_type && old_interview_type == common/* INTERVIEW_TYPES.VIDEOQA */.BH.VIDEOQA) {
                                                                                    uniq_member_emails = formik.values.videoqa.member_emails;
                                                                                    uniq_member_initials = formik.values.videoqa.member_initials;
                                                                                }
                                                                                if ([
                                                                                    common/* INTERVIEW_TYPES.PHONE */.BH.PHONE,
                                                                                    common/* INTERVIEW_TYPES.VIDEO */.BH.VIDEO,
                                                                                    common/* INTERVIEW_TYPES.FACE2FACE */.BH.FACE2FACE
                                                                                ].includes(x.name)) {
                                                                                    ;
                                                                                    children_attributes.push((_obj = {
                                                                                        date: "",
                                                                                        starttime: "",
                                                                                        endtime: "",
                                                                                        location: formik.values.default_location || "",
                                                                                        place_id: formik.values.place_id || "",
                                                                                        integration_id: "",
                                                                                        members: [],
                                                                                        member_ids: []
                                                                                    }, (0,_define_property/* default */.Z)(_obj, "members", []), (0,_define_property/* default */.Z)(_obj, "duration", ""), (0,_define_property/* default */.Z)(_obj, "_destroy", false), _obj));
                                                                                    setStageEmail((0,candidate_profile_job/* initialStageValues */.jv)(formik.values));
                                                                                    durations = [];
                                                                                    setTotalDuration(durations.reduce(function(a, b) {
                                                                                        return (parseInt(a) || 0) + (parseInt(b) || 0);
                                                                                    }, 0));
                                                                                    setInterviewStageCount(1);
                                                                                }
                                                                                if (!(x.name == common/* INTERVIEW_TYPES.TECHTEST */.BH.TECHTEST)) return [
                                                                                    3,
                                                                                    4
                                                                                ];
                                                                                _tmp = {};
                                                                                return [
                                                                                    4,
                                                                                    setValidationData((_tmp.type = "TestLibrary", _tmp.test_id = "", _tmp))
                                                                                ];
                                                                            case 2:
                                                                                _state.sent();
                                                                                return [
                                                                                    4,
                                                                                    formik.setFieldValue("job_test_detail_attributes", (0,automations/* defaultTestDetail */.i9)(uniq_member_emails, uniq_member_initials))
                                                                                ];
                                                                            case 3:
                                                                                _state.sent();
                                                                                _state.label = 4;
                                                                            case 4:
                                                                                _tmp1 = {};
                                                                                if (x.name == common/* INTERVIEW_TYPES.VIDEOQA */.BH.VIDEOQA) {
                                                                                    videoqa = (_tmp1.member_emails = uniq_member_emails, _tmp1.member_initials = uniq_member_initials, _tmp1);
                                                                                    formik.setFieldValue("videoqa", videoqa);
                                                                                }
                                                                                return [
                                                                                    2
                                                                                ];
                                                                        }
                                                                    });
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "icon".concat(interviewIndex),
                                                                className: "labelcolor",
                                                                children: interviewSwitchButton(x.name)
                                                            })
                                                        ]
                                                    })
                                                }, x.name)
                                            }, "interview_type_".concat(interviewIndex));
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                        name: "interview_type_id",
                                        errorClass: (_index_module_default()).Form__Error,
                                        custom_class: "FieldError",
                                        formik: formik,
                                        style: (0,candidate_profile_job/* InputError */.pd)(formik, "interview_type_id")
                                    })
                                ]
                            }),
                            current_interview_type == common/* INTERVIEW_TYPES.VIDEOQA */.BH.VIDEOQA ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((_index_module_default()).SetupPopup__SetupVideoQa2, " ").concat((automation_popup_index_module_default()).AutomationPopup__SetupVideoQa2, " mb0"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((automation_popup_index_module_default()).AutomationPopup__Row),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((automation_popup_index_module_default()).AutomationPopup__Members, " ").concat((_index_module_default()).Form__TableCol, " mt30 mb10"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        className: "".concat((_index_module_default()).Form__FloatingLabel),
                                                        style: (0,common/* InputText */.oH)(formik, "videoqa.member_emails"),
                                                        children: t("modal:input:members")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat((automation_popup_index_module_default()).AutomationPopup__Field),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                                                                suggestions: users,
                                                                onSuggestionsFetchRequested: function(param) {
                                                                    var value = param.value;
                                                                    return (0,automations/* onSuggestionsFetchRequested */.oo)(value, currentStage, setUsers, router);
                                                                },
                                                                onSuggestionsClearRequested: function() {
                                                                    return setUsers([]);
                                                                },
                                                                getSuggestionValue: function(suggestion) {
                                                                    return "".concat(suggestion.user_attributes.email);
                                                                },
                                                                renderSuggestion: automations/* renderSuggestion */.ox,
                                                                renderInputComponent: videoQaAction.renderMemberInputComponent,
                                                                shouldRenderSuggestions: videoQaAction.shouldRenderSuggestions,
                                                                onSuggestionSelected: function(event, param) {
                                                                    var suggestion = param.suggestion;
                                                                    if (suggestion.user_attributes.email.length > 0) {
                                                                        setTechStageEmail({
                                                                            value: ""
                                                                        });
                                                                        videoQaAction.onSuggestionSelection(formik, formik.values.videoqa.member_emails, suggestion.user_attributes.email, formik.values.videoqa.member_initials, {
                                                                            email: suggestion.user_attributes.email,
                                                                            name_initials: suggestion.user_attributes.name_initials,
                                                                            name: suggestion.user_attributes.name
                                                                        });
                                                                        formik.validateForm();
                                                                    }
                                                                },
                                                                inputProps: {
                                                                    className: "".concat((_index_module_default()).Form__Input, " ").concat((_index_module_default()).Form__textleft, " ").concat((_index_module_default()).Form__InputFullWidth),
                                                                    placeholder: t("placeholder:search:type_name"),
                                                                    value: techStageEmail.value,
                                                                    disabled: !editable,
                                                                    editable: editable,
                                                                    selectedValues: (ref = formik.values.videoqa) === null || ref === void 0 ? void 0 : ref.member_initials,
                                                                    closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal/* Close */.x8, {}),
                                                                    formik: formik,
                                                                    videoQaAction: videoQaAction,
                                                                    add_button: false,
                                                                    name: "videoqa.member_emails",
                                                                    onChange: function(value, param) {
                                                                        var newValue = param.newValue, method = param.method;
                                                                        setTechStageEmail({
                                                                            value: newValue,
                                                                            error: ""
                                                                        });
                                                                    },
                                                                    setStageEmail: setTechStageEmail
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                                                name: "videoqa.member_emails",
                                                                errorClass: (_index_module_default()).Form__Error,
                                                                formik: formik,
                                                                style: (0,candidate_profile_job/* InputError */.pd)(formik, "videoqa.member_emails")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((automation_popup_index_module_default()).AutomationPopup__Row),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((automation_popup_index_module_default()).AutomationPopup__w50),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((automation_popup_index_module_default()).InterviewType__SetupVideoQa2, " ").concat((_index_module_default()).Form__TableCol, " mt20 mb10"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: "".concat(gridClass(current_interview_type), " ").concat((_index_module_default()).Form__FloatingLabel),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "red-color",
                                                                    children: "*"
                                                                }),
                                                                "\xa0",
                                                                t("modal:input:language")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((automation_popup_index_module_default()).AutomationPopup__Field),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                className: "".concat((_index_module_default()).Form__CustomSelect, " ").concat((automation_popup_index_module_default()).Form__CustomSelect),
                                                                control: "select",
                                                                formik: formik,
                                                                name: "language",
                                                                options: languageListing,
                                                                placeholder: t("placeholder:search:language"),
                                                                style: (0,candidate_profile_job/* InputError */.pd)(formik, "language"),
                                                                default: "English",
                                                                onChange: function(data) {
                                                                    formik.setFieldValue("language", data.value);
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((automation_popup_index_module_default()).AutomationPopup__w50),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((automation_popup_index_module_default()).InterviewType__SetupVideoQa2, " ").concat((_index_module_default()).Form__TableCol, " mt20 mb10"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            className: "".concat(gridClass(current_interview_type), " ").concat((_index_module_default()).Form__FloatingLabel),
                                                            style: (0,common/* InputText */.oH)(formik, "video_link"),
                                                            children: t("modal:input:intro_video")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((automation_popup_index_module_default()).AutomationPopup__Field),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                className: "".concat((_index_module_default()).Form__Input, " thresholdmodl"),
                                                                control: "input",
                                                                type: "text",
                                                                formik: formik,
                                                                name: "video_link",
                                                                placeholder: setup_video_qa/* CONSTANTS.texts.placeholder_intro_video */.tl.texts.placeholder_intro_video,
                                                                style: (0,candidate_profile_job/* InputError */.pd)(formik, "video_link"),
                                                                custom_error_90: "custom_error_90",
                                                                custom_class: "FieldError"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((automation_popup_index_module_default()).AutomationPopup__Row),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((automation_popup_index_module_default()).AutomationPopup__InterviewQuestion, " mt30"),
                                            children: formik === null || formik === void 0 ? void 0 : (ref1 = formik.values) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.questions_attributes) === null || ref2 === void 0 ? void 0 : ref2.map(function(question, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((_index_module_default()).SetupPopup__QuestionSection, " ").concat((automation_popup_index_module_default()).AutomationPopup__QuestionSection),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                            className: "Dpflex JustifySpace",
                                                            children: [
                                                                t("modal:input:interview_question"),
                                                                " ",
                                                                index + 1,
                                                                formik.values.questions_attributes.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(candidate_profile_job/* Deleteicon */.F_, {
                                                                    className: "".concat(common_modal/* FormModalStyle.Modal__Container__IconSvg */.w2.Modal__Container__IconSvg),
                                                                    onClick: function() {
                                                                        addInterviewManualAction.onDeleteClick(formik, index);
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((automation_popup_index_module_default()).AutomationPopup__Question, " ").concat((_index_module_default()).Form__TableCol, " mt30 mb10"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                    className: "".concat(gridClass(current_interview_type), " ").concat((_index_module_default()).Form__FloatingLabel),
                                                                    style: (0,common/* InputText */.oH)(formik, "questions_attributes.".concat(index, ".question")),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "red-color",
                                                                            children: "*"
                                                                        }),
                                                                        "\xa0",
                                                                        t("modal:input:question")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__Field),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                        className: "".concat((_index_module_default()).Form__Input, " ").concat((automation_popup_index_module_default()).Form__Input, " input600"),
                                                                        control: "input",
                                                                        type: "text",
                                                                        formik: formik,
                                                                        placeholder: t("placeholder:question"),
                                                                        name: "questions_attributes.".concat(index, ".question"),
                                                                        custom_class: "FieldError",
                                                                        style: (0,candidate_profile_job/* InputError */.pd)(formik, "questions_attributes.".concat(index, ".question")),
                                                                        onChange: function(data) {
                                                                            formik.setFieldValue("questions_attributes.".concat(index, ".question"), data.target.value);
                                                                            formik.status && formik.status["questions_attributes"] && formik.status["questions_attributes"][index] && formik.status["questions_attributes"][index]["question"] ? delete formik.status["questions_attributes"][index]["question"] : "";
                                                                            formik.setStatus(formik.status);
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((automation_popup_index_module_default()).AutomationPopup__Description, " ").concat((_index_module_default()).Form__TableCol, " mt30"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat(gridClass(current_interview_type), "  ").concat((_index_module_default()).Form__FloatingLabel, " mb10"),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                        style: (0,common/* InputText */.oH)(formik, "questions_attributes.".concat(index, ".description")),
                                                                        children: t("modal:input:description")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__Field),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                        control: "customtextarea",
                                                                        type: "text",
                                                                        formik: formik,
                                                                        className: "".concat((_index_module_default()).Form__Textarea, " ").concat((automation_popup_index_module_default()).Form__Textarea, " input600"),
                                                                        name: "questions_attributes.".concat(index, ".description"),
                                                                        rows: "4",
                                                                        style: (0,candidate_profile_job/* InputError */.pd)(formik, "questions_attributes.".concat(index, ".description"))
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "Dpflexonly AlignBaseline ".concat((automation_popup_index_module_default()).AutomationPopup__TwoFields),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__Time, " ").concat((_index_module_default()).Form__TableCol, " Dpflexonly AlignBaseline w100 mt20"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "".concat(gridClass(current_interview_type), " ").concat((_index_module_default()).Form__FloatingLabel, " wauto mb10"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                style: (0,common/* InputText */.oH)(formik, "questions_attributes.".concat(index, ".answer_time")),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "red-color",
                                                                                        children: "*"
                                                                                    }),
                                                                                    t("modal:input:time_to_answer")
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "".concat((automation_popup_index_module_default()).AutomationPopup__FieldAuto, " ").concat((automation_popup_index_module_default()).AutomationPopup__NoRightBorderRadius, "  w50"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "Dpflexonly",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Field */.gN, {
                                                                                            component: addInterviewManualAction.NumberField,
                                                                                            defaultValue: 30,
                                                                                            type: "text",
                                                                                            name: "questions_attributes.".concat(index, ".answer_time"),
                                                                                            className: "".concat((_index_module_default()).Form__Input, " ").concat((automation_popup_index_module_default()).Form__InputFocus, " width60 inputerrorheight"),
                                                                                            formik: formik,
                                                                                            format: "###",
                                                                                            style: (0,candidate_profile_job/* InputError */.pd)(formik, "questions_attributes.".concat(index, ".answer_time")),
                                                                                            onValueChange: function(value) {
                                                                                                formik.setFieldValue("questions_attributes.".concat(index, ".answer_time"), value.floatValue);
                                                                                                formik.status && formik.status["questions_attributes"] && formik.status["questions_attributes"][index] && formik.status["questions_attributes"][index]["answer_time"] ? delete formik.status["questions_attributes"][index]["answer_time"] : "";
                                                                                                formik.setStatus(formik.status);
                                                                                            }
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "".concat((automation_popup_index_module_default()).AutomationPopup__Seconds, " ").concat((_index_module_default()).Form__currency_symbol, " ").concat((_index_module_default()).Form__currency_symbol__right),
                                                                                            style: (0,candidate_profile_job/* InputError */.pd)(formik, "questions_attributes.".concat(index, ".answer_time")),
                                                                                            children: t("modal:input:sec")
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                                                                    name: "questions_attributes.".concat(index, ".answer_time"),
                                                                                    errorClass: (_index_module_default()).Form__Error,
                                                                                    formik: formik,
                                                                                    custom_class: "FieldError",
                                                                                    style: (0,candidate_profile_job/* InputError */.pd)(formik, "questions_attributes.".concat(index, ".answer_time"))
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__Time, " ").concat((_index_module_default()).Form__TableCol, " Dpflexonly AlignBaseline JustifyEnd w100 mt30 mb10"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "".concat(gridClass(current_interview_type), " ").concat((_index_module_default()).Form__FloatingLabel, " wauto mb10"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                className: "text-center",
                                                                                style: (0,common/* InputText */.oH)(formik, "questions_attributes.".concat(index, ".attempts")),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "red-color",
                                                                                        children: "*"
                                                                                    }),
                                                                                    " ",
                                                                                    t("modal:input:attempts:number"),
                                                                                    " \xa0",
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
                                                                                        content: t("modal:input:attempts:max"),
                                                                                        background: "#203040",
                                                                                        radius: 4,
                                                                                        padding: 8,
                                                                                        placement: "right",
                                                                                        fontSize: "12px",
                                                                                        className: "SimpleTooltip",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            className: "tooltipwidthinterview140",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(exclamation/* default */.Z, {})
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "".concat((automation_popup_index_module_default()).AutomationPopup__FieldAuto, " Dpflexonly AlignBaseline w50"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Field */.gN, {
                                                                                        component: addInterviewManualAction.NumberField,
                                                                                        defaultValue: 2,
                                                                                        type: "text",
                                                                                        name: "questions_attributes.".concat(index, ".attempts"),
                                                                                        className: "".concat((_index_module_default()).Form__Input, " ").concat((automation_popup_index_module_default()).Form__InputFocus, " width100 inputerrorheight text-center"),
                                                                                        formik: formik,
                                                                                        format: "#",
                                                                                        onValueChange: function(value) {
                                                                                            formik.setFieldValue("questions_attributes.".concat(index, ".attempts"), value.floatValue);
                                                                                            formik.status && formik.status["questions_attributes"] && formik.status["questions_attributes"][index] && formik.status["questions_attributes"][index]["attempts"] ? delete formik.status["questions_attributes"][index]["attempts"] : "";
                                                                                            formik.setStatus(formik.status);
                                                                                        },
                                                                                        style: (0,candidate_profile_job/* InputError */.pd)(formik, "questions_attributes.".concat(index, ".attempts"))
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                                                                        name: "questions_attributes.".concat(index, ".attempts"),
                                                                                        errorClass: (_index_module_default()).Form__Error,
                                                                                        formik: formik,
                                                                                        style: (0,candidate_profile_job/* InputError */.pd)(formik, "questions_attributes.".concat(index, ".attempts"))
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, "question_key_".concat(index));
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((_index_module_default()).SetupPopup__AddQuestion, " ").concat((automation_popup_index_module_default()).AutomationPopup__AddQuestionButton, " ").concat((_index_module_default()).mt15),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_button/* default */.Z, {
                                            buttonstyle: "".concat((button_index_module_default()).iconTextButton),
                                            type: "button",
                                            disabled: disabledAddMoreQuestion,
                                            onClick: function() {
                                                return addInterviewManualAction.onAddClick(formik);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(thick_plus/* default */.Z, {}),
                                                t("button:add:question")
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb30 mt40",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                className: " ".concat((_index_module_default()).SetupPopup__ContentBlock, " ").concat((automation_popup_index_module_default()).AutomationPopup__Customisation, " mt0"),
                                                children: t("modal:automation:customisations")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "Dpflex",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((_index_module_default()).SetupPopup__ContentCustomisation, " ").concat((automation_popup_index_module_default()).AutomationPopup__PracticeScreen, " ").concat((_index_module_default()).SetupPopup__AddInterviewCustomisation),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "thresholdmodl ".concat((automation_popup_index_module_default()).AutomationPopup__SetupVideoQa3),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                                    className: "Dpflexonly",
                                                                    children: [
                                                                        t("modal:input:practice_screen"),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "".concat((_index_module_default()).Interview__BestMatchExclamation, " ").concat((automation_popup_index_module_default()).AutomationPopup__PracticeExclamation),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
                                                                                content: t("agency:video:practice_question"),
                                                                                background: "#203040",
                                                                                radius: 20,
                                                                                padding: 8,
                                                                                placement: "right",
                                                                                fontSize: "12px",
                                                                                className: "SimpleTooltip",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: "tooltipwidthinterview200",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(info_icon/* default */.Z, {})
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                    className: (_index_module_default()).IntegrationTable__switch,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                            type: "checkbox",
                                                                            defaultChecked: formik.values.practise_screen,
                                                                            onChange: function(event) {
                                                                                formik.setFieldValue("practise_screen", event.target.checked);
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "".concat((_index_module_default()).IntegrationTable__slider, " ").concat((_index_module_default()).IntegrationTable__round, " width44")
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat((_index_module_default()).SetupPopup__ContentCustomisation, " ").concat((_index_module_default()).SetupPopup__PushTop, " ").concat((_index_module_default()).SetupPopup__SetupVideoQa4, " ").concat((automation_popup_index_module_default()).AutomationPopup__SetupVideoQa4, " ").concat((_index_module_default()).Form__TableCol),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                className: "Dpflexonly AlignBaseline ".concat((_index_module_default()).mb15, " ").concat((_index_module_default()).Form__FloatingLabel, " mr10"),
                                                                style: (0,common/* InputText */.oH)(formik, "expires"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "red-color",
                                                                        children: "*"
                                                                    }),
                                                                    " ",
                                                                    t("modal:input:expires")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "".concat((automation_popup_index_module_default()).AutomationPopup__FieldAuto, " ").concat((automation_popup_index_module_default()).AutomationPopup__NoRightBorderRadius, " w50"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "".concat((automation_popup_index_module_default()).AutomationPopup__NoRightBorderRadius, " Dpflexonly"),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Field */.gN, {
                                                                                component: addInterviewManualAction.NumberField,
                                                                                type: "text",
                                                                                name: "expires",
                                                                                className: "".concat((_index_module_default()).Form__Input, " ").concat((automation_popup_index_module_default()).Form__InputFocus, " thresholdmodl width70"),
                                                                                formik: formik,
                                                                                format: "###",
                                                                                style: (0,candidate_profile_job/* InputError */.pd)(formik, "expires"),
                                                                                defaultValue: 2,
                                                                                onValueChange: function(value) {
                                                                                    formik.setFieldValue("expires", value.floatValue);
                                                                                    formik.setStatus["expires"] = "";
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "".concat((automation_popup_index_module_default()).AutomationPopup__Seconds, " ").concat((_index_module_default()).Form__currency_symbol, " ").concat((_index_module_default()).Form__currency_symbol__right, " ml0"),
                                                                                style: (0,candidate_profile_job/* InputError */.pd)(formik, "expires"),
                                                                                children: t("modal:input:days")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                                                        name: "expires",
                                                                        errorClass: (_index_module_default()).Form__Error,
                                                                        formik: formik,
                                                                        custom_class: "FieldError",
                                                                        style: (0,candidate_profile_job/* InputError */.pd)(formik, "expires")
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FieldArray */.F2, {
                                        className: "",
                                        name: "children_attributes",
                                        render: function(arrayHelpers) {
                                            return formik.values.children_attributes.map(function(item, index) {
                                                return !item._destroy && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        current_interview_type == common/* INTERVIEW_TYPES.PHONE */.BH.PHONE && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((automation_popup_index_module_default()).InterviewType__Phone),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__Row),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "".concat((automation_popup_index_module_default()).AutomationPopup__Members, " ").concat((_index_module_default()).Form__TableCol, " mt30 mb20"),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                className: "".concat(gridClass(current_interview_type), " ").concat((_index_module_default()).Form__FloatingLabel),
                                                                                style: (0,common/* InputText */.oH)(formik, "children_attributes.".concat(index, ".member_ids")),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "red-color",
                                                                                        children: "*"
                                                                                    }),
                                                                                    "\xa0",
                                                                                    t("modal:input:members")
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "".concat((automation_popup_index_module_default()).AutomationPopup__Field),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                                                                                        suggestions: users,
                                                                                        onSuggestionsFetchRequested: function(param) {
                                                                                            var value = param.value;
                                                                                            return (0,automations/* onSuggestionsFetchRequested */.oo)(value, currentStage, setUsers, router);
                                                                                        },
                                                                                        onSuggestionsClearRequested: function() {
                                                                                            return setUsers([]);
                                                                                        },
                                                                                        getSuggestionValue: function(suggestion) {
                                                                                            return "".concat(suggestion.user_attributes.email);
                                                                                        },
                                                                                        renderSuggestion: automations/* renderSuggestion */.ox,
                                                                                        renderInputComponent: candidate_profile_job/* renderInputComponent */.Qx,
                                                                                        shouldRenderSuggestions: automations/* shouldRenderSuggestions */.KH,
                                                                                        onSuggestionSelected: function(event, param) {
                                                                                            var suggestion = param.suggestion;
                                                                                            if (suggestion.user_attributes.email.length > 0) {
                                                                                                stageEmail[index] = {
                                                                                                    value: ""
                                                                                                };
                                                                                                setStageEmail((0,_to_consumable_array/* default */.Z)(stageEmail));
                                                                                                (0,candidate_profile_job/* onSuggestionSelection */.wn)(formik.values.children_attributes[index].member_ids, suggestion.user_attributes.id, formik.values.children_attributes[index].members, {
                                                                                                    email: suggestion.user_attributes.email,
                                                                                                    name_initials: suggestion.user_attributes.name_initials,
                                                                                                    name: suggestion.user_attributes.name
                                                                                                });
                                                                                                formik.validateForm();
                                                                                            }
                                                                                        },
                                                                                        inputProps: {
                                                                                            className: "".concat((_index_module_default()).Form__Input, " ").concat((_index_module_default()).Form__textleft, " ").concat((_index_module_default()).Form__InputFullWidth),
                                                                                            placeholder: t("placeholder:search:type_name"),
                                                                                            value: stageEmail[index].value,
                                                                                            index: index,
                                                                                            formik: formik,
                                                                                            disabled: !editable,
                                                                                            editable: editable,
                                                                                            selectedValues: formik.values.children_attributes[index].members,
                                                                                            closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal/* Close */.x8, {}),
                                                                                            styleError: (0,candidate_profile_job/* InputError */.pd)(formik, "children_attributes.".concat(index, ".member_ids")),
                                                                                            name: "children_attributes.".concat(index, ".member_ids"),
                                                                                            onChange: function(value, param) {
                                                                                                var newValue = param.newValue, method = param.method;
                                                                                                stageEmail[index] = {
                                                                                                    value: newValue
                                                                                                };
                                                                                                setStageEmail((0,_to_consumable_array/* default */.Z)(stageEmail));
                                                                                            },
                                                                                            stageEmail: stageEmail,
                                                                                            setStageEmail: setStageEmail
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                                                                        name: "children_attributes.".concat(index, ".member_ids"),
                                                                                        errorClass: (_index_module_default()).Form__Error,
                                                                                        formik: formik,
                                                                                        style: (0,candidate_profile_job/* InputError */.pd)(formik, "children_attributes.".concat(index, ".member_ids"))
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__Row),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "".concat((automation_popup_index_module_default()).AutomationPopup__Duration, "  ").concat((_index_module_default()).Form__TableCol, " mt20 mb10"),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                className: "Dpflex ".concat((_index_module_default()).Form__FloatingLabel, " ").concat(gridClass(current_interview_type)),
                                                                                style: (0,common/* InputText */.oH)(formik, "children_attributes.".concat(index, ".duration")),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "red-color",
                                                                                        children: "*"
                                                                                    }),
                                                                                    "\xa0",
                                                                                    t("modal:input:duration"),
                                                                                    " (",
                                                                                    t("modal:input:mins"),
                                                                                    ")"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "".concat((automation_popup_index_module_default()).AutomationPopup__Field),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                                    className: "".concat((_index_module_default()).Form__Input, " ").concat((automation_popup_index_module_default()).AutomationPopup__Input),
                                                                                    control: "input",
                                                                                    type: "text",
                                                                                    autocomplete: "off",
                                                                                    placeholder: t("placeholder:eg:15"),
                                                                                    formik: formik,
                                                                                    maxLength: 3,
                                                                                    custom_class: "FieldError",
                                                                                    name: "children_attributes.".concat(index, ".duration"),
                                                                                    value: formik.values.children_attributes[index].duration,
                                                                                    onChange: function(evt) {
                                                                                        addInterviewManualAction.handleDurationChange(evt, formik, index, setTotalDuration);
                                                                                    },
                                                                                    style: (0,candidate_profile_job/* InputError */.pd)(formik, "children_attributes.".concat(index, ".duration"))
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        current_interview_type == common/* INTERVIEW_TYPES.VIDEO */.BH.VIDEO && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((automation_popup_index_module_default()).InterviewType__Video),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__Row),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "".concat((automation_popup_index_module_default()).AutomationPopup__w33, " ").concat((_index_module_default()).Form__TableCol, " mt30 mb10 pr0"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                    className: "Dpflex ".concat((_index_module_default()).Form__FloatingLabel),
                                                                                    style: (0,common/* InputText */.oH)(formik, "children_attributes.".concat(index, ".integration_id")),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "red-color",
                                                                                            children: "*"
                                                                                        }),
                                                                                        "\xa0",
                                                                                        t("modal:input:platform")
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__Field),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                                        className: "".concat((_index_module_default()).Form__CustomSelect, " ").concat((_index_module_default()).width100),
                                                                                        control: "select",
                                                                                        formik: formik,
                                                                                        placeholder: t("placeholder:select:default"),
                                                                                        options: platforms,
                                                                                        components: {
                                                                                            Option: IconOption
                                                                                        },
                                                                                        onChange: function(option) {
                                                                                            formik.setFieldValue("children_attributes.".concat(index, ".integration_id"), option.value);
                                                                                            if (option.label.toString() != "Custom Link") formik.setFieldValue("children_attributes.".concat(index, ".meeting_link"), "");
                                                                                        },
                                                                                        default: formik.values.children_attributes[index].integration_id,
                                                                                        name: "children_attributes.".concat(index, ".integration_id"),
                                                                                        style: (0,candidate_profile_job/* InputError */.pd)(formik, "children_attributes.".concat(index, ".integration_id")),
                                                                                        custom_class: "FieldError"
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "".concat((automation_popup_index_module_default()).AutomationPopup__Duration, " ").concat((automation_popup_index_module_default()).AutomationPopup__w33, " ").concat(gridClass(current_interview_type), " ").concat((_index_module_default()).Form__TableCol, " mt30 mb10 mt0"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                    className: "Dpflex ".concat((_index_module_default()).Form__FloatingLabel),
                                                                                    style: (0,common/* InputText */.oH)(formik, "children_attributes.".concat(index, ".duration")),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "red-color",
                                                                                            children: "*"
                                                                                        }),
                                                                                        "\xa0",
                                                                                        t("modal:input:duration"),
                                                                                        " (",
                                                                                        t("modal:input:mins"),
                                                                                        ")"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__Field),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                                        className: "".concat((_index_module_default()).Form__Input, " ").concat((automation_popup_index_module_default()).AutomationPopup__Input),
                                                                                        control: "input",
                                                                                        type: "text",
                                                                                        autocomplete: "off",
                                                                                        placeholder: t("placeholder:eg:15"),
                                                                                        formik: formik,
                                                                                        maxLength: 3,
                                                                                        custom_class: "FieldError",
                                                                                        name: "children_attributes.".concat(index, ".duration"),
                                                                                        value: formik.values.children_attributes[index].duration,
                                                                                        onChange: function(evt) {
                                                                                            addInterviewManualAction.handleDurationChange(evt, formik, index, setTotalDuration);
                                                                                        },
                                                                                        style: (0,candidate_profile_job/* InputError */.pd)(formik, "children_attributes.".concat(index, ".duration"))
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "".concat((automation_popup_index_module_default()).AutomationPopup__Duration, " ").concat((automation_popup_index_module_default()).AutomationPopup__w33, " ").concat(gridClass(current_interview_type), " ").concat((_index_module_default()).Form__TableCol, " mt30 mb10"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                    className: "Dpflex ".concat((_index_module_default()).Form__FloatingLabel),
                                                                                    style: (0,common/* InputText */.oH)(formik, "children_attributes.".concat(index, ".meeting_link")),
                                                                                    children: [
                                                                                        t("modal:input:meeting_link"),
                                                                                        " ",
                                                                                        (0,candidate_profile_job/* isCustomLink */.$x)(platforms, formik.values.children_attributes[index].integration_id) ? "" : "*"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__Field),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                                        className: "".concat((_index_module_default()).Form__Input, " ").concat((automation_popup_index_module_default()).AutomationPopup__Input),
                                                                                        control: "input",
                                                                                        type: "text",
                                                                                        autocomplete: "off",
                                                                                        placeholder: "",
                                                                                        formik: formik,
                                                                                        custom_class: "FieldError",
                                                                                        name: "children_attributes.".concat(index, ".meeting_link"),
                                                                                        value: formik.values.children_attributes[index].meeting_link,
                                                                                        disabled: (0,candidate_profile_job/* isCustomLink */.$x)(platforms, formik.values.children_attributes[index].integration_id),
                                                                                        style: (0,candidate_profile_job/* InputError */.pd)(formik, "children_attributes.".concat(index, ".meeting_link"))
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__Row),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "".concat((automation_popup_index_module_default()).AutomationPopup__Members, " mt30 mb10 ").concat((_index_module_default()).Form__TableCol),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                className: "".concat((_index_module_default()).Form__FloatingLabel),
                                                                                style: (0,common/* InputText */.oH)(formik, "children_attributes.".concat(index, ".member_ids")),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "red-color",
                                                                                        children: "*"
                                                                                    }),
                                                                                    "\xa0",
                                                                                    t("modal:input:members")
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "".concat((automation_popup_index_module_default()).AutomationPopup__Field),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                                                                                        suggestions: users,
                                                                                        onSuggestionsFetchRequested: function(param) {
                                                                                            var value = param.value;
                                                                                            return (0,automations/* onSuggestionsFetchRequested */.oo)(value, currentStage, setUsers, router);
                                                                                        },
                                                                                        onSuggestionsClearRequested: function() {
                                                                                            return setUsers([]);
                                                                                        },
                                                                                        getSuggestionValue: function(suggestion) {
                                                                                            return "".concat(suggestion.user_attributes.email);
                                                                                        },
                                                                                        renderSuggestion: automations/* renderSuggestion */.ox,
                                                                                        renderInputComponent: candidate_profile_job/* renderInputComponent */.Qx,
                                                                                        shouldRenderSuggestions: automations/* shouldRenderSuggestions */.KH,
                                                                                        onSuggestionSelected: function(event, param) {
                                                                                            var suggestion = param.suggestion;
                                                                                            if (suggestion.user_attributes.email.length > 0) {
                                                                                                stageEmail[index] = {
                                                                                                    value: ""
                                                                                                };
                                                                                                setStageEmail((0,_to_consumable_array/* default */.Z)(stageEmail));
                                                                                                (0,candidate_profile_job/* onSuggestionSelection */.wn)(formik.values.children_attributes[index].member_ids, suggestion.user_attributes.id, formik.values.children_attributes[index].members, {
                                                                                                    email: suggestion.user_attributes.email,
                                                                                                    name_initials: suggestion.user_attributes.name_initials,
                                                                                                    name: suggestion.user_attributes.name
                                                                                                });
                                                                                                formik.validateForm();
                                                                                            }
                                                                                        },
                                                                                        inputProps: {
                                                                                            className: "".concat((_index_module_default()).Form__Input, " ").concat((_index_module_default()).Form__textleft),
                                                                                            placeholder: t("placeholder:search:type_name"),
                                                                                            value: stageEmail[index].value,
                                                                                            index: index,
                                                                                            formik: formik,
                                                                                            selectedValues: formik.values.children_attributes[index].members,
                                                                                            closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal/* Close */.x8, {}),
                                                                                            disabled: !editable,
                                                                                            editable: editable,
                                                                                            name: "children_attributes.".concat(index, ".member_ids"),
                                                                                            onChange: function(value, param) {
                                                                                                var newValue = param.newValue, method = param.method;
                                                                                                stageEmail[index] = {
                                                                                                    value: newValue
                                                                                                };
                                                                                                setStageEmail((0,_to_consumable_array/* default */.Z)(stageEmail));
                                                                                            },
                                                                                            styleError: (0,candidate_profile_job/* InputError */.pd)(formik, "children_attributes.".concat(index, ".member_ids")),
                                                                                            stageEmail: stageEmail,
                                                                                            setStageEmail: setStageEmail
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                                                                        name: "children_attributes.".concat(index, ".member_ids"),
                                                                                        errorClass: (_index_module_default()).Form__Error,
                                                                                        formik: formik,
                                                                                        style: (0,candidate_profile_job/* InputError */.pd)(formik, "children_attributes.".concat(index, ".member_ids"))
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__CloseIcon),
                                                                    children: interviewStageCount != 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: "/icons/close.png",
                                                                        alt: "",
                                                                        className: "mt0",
                                                                        onClick: function() {
                                                                            return (0,candidate_profile_job/* onAutomationChange */.mV)(formik, "remove", index, setStageEmail, setInterviewStageCount, setTotalDuration, current_interview_type, setShowHideButton);
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        current_interview_type == common/* INTERVIEW_TYPES.FACE2FACE */.BH.FACE2FACE && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((automation_popup_index_module_default()).InterviewType__Face2Face),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__Row),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "".concat((automation_popup_index_module_default()).AutomationPopup__Location, " ").concat((automation_popup_index_module_default()).AutomationPopup__w50, " ").concat((_index_module_default()).Form__TableCol, " mt30 mb10"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                    className: "Dpflex ".concat(gridClass(current_interview_type), " ").concat((_index_module_default()).Form__FloatingLabel),
                                                                                    style: (0,common/* InputText */.oH)(formik, "default_location"),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "red-color",
                                                                                            children: "*"
                                                                                        }),
                                                                                        "\xa0",
                                                                                        t("modal:input:location")
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__Field),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_places_autocomplete_dist/* default */.ZP, {
                                                                                            value: formik.values.default_location,
                                                                                            onChange: function(value) {
                                                                                                formik.setFieldValue("default_location", value);
                                                                                                formik.setFieldValue("place_id", "");
                                                                                            },
                                                                                            onSelect: function(address, placeId, suggestion) {
                                                                                                formik.setFieldValue("default_location", address);
                                                                                                formik.setFieldValue("place_id", placeId);
                                                                                            },
                                                                                            shouldFetchSuggestions: formik.values.default_location.length >= 3,
                                                                                            children: function(param) {
                                                                                                var getInputProps = param.getInputProps, getSuggestionItemProps = param.getSuggestionItemProps, suggestions = param.suggestions, loading = param.loading;
                                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                    className: "autocomplete-root",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                                            className: (_index_module_default()).Form__Input,
                                                                                                            name: "default_location",
                                                                                                            placeholder: t("placeholder:eg:london"),
                                                                                                            style: (0,candidate_profile_job/* InputError */.pd)(formik, "default_location")
                                                                                                        }, getInputProps({
                                                                                                            disabled: !editable || (0,candidate_profile_job/* isLocationDisabled */.Pq)(formik, index)
                                                                                                        }))),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                            className: "autocomplete-dropdown-container",
                                                                                                            children: [
                                                                                                                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                    children: t("loading")
                                                                                                                }),
                                                                                                                suggestions.map(function(suggestion) {
                                                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getSuggestionItemProps(suggestion)), {
                                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                            children: suggestion.description
                                                                                                                        }, suggestion.id)
                                                                                                                    }), suggestion.placeId);
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    ]
                                                                                                });
                                                                                            }
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                                                                            name: "default_location",
                                                                                            errorClass: (_index_module_default()).Form__Error,
                                                                                            custom_class: "FieldError",
                                                                                            formik: formik,
                                                                                            style: (0,candidate_profile_job/* InputError */.pd)(formik, "default_location"),
                                                                                            custom_error_90: "custom_error_90"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "".concat((automation_popup_index_module_default()).AutomationPopup__Duration, " ").concat((automation_popup_index_module_default()).AutomationPopup__w50, " mt0 ").concat((_index_module_default()).Form__TableCol, " mt30 mb10"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                    className: "Dpflex ".concat(gridClass(current_interview_type), " ").concat((_index_module_default()).Form__FloatingLabel),
                                                                                    style: (0,common/* InputText */.oH)(formik, "children_attributes.".concat(index, ".duration")),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "red-color",
                                                                                            children: "*"
                                                                                        }),
                                                                                        "\xa0",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                            children: [
                                                                                                t("modal:input:duration"),
                                                                                                " (",
                                                                                                t("modal:input:mins"),
                                                                                                ")"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__Field),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                                        className: "".concat((_index_module_default()).Form__Input, " ").concat((automation_popup_index_module_default()).AutomationPopup__Input),
                                                                                        control: "input",
                                                                                        type: "text",
                                                                                        autocomplete: "off",
                                                                                        placeholder: t("placeholder:eg:15"),
                                                                                        formik: formik,
                                                                                        maxLength: 3,
                                                                                        custom_class: "FieldError",
                                                                                        name: "children_attributes.".concat(index, ".duration"),
                                                                                        value: formik.values.children_attributes[index].duration,
                                                                                        onChange: function(evt) {
                                                                                            addInterviewManualAction.handleDurationChange(evt, formik, index, setTotalDuration);
                                                                                        },
                                                                                        style: (0,candidate_profile_job/* InputError */.pd)(formik, "children_attributes.".concat(index, ".duration"))
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__Row),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "".concat((automation_popup_index_module_default()).AutomationPopup__Members, " ").concat((_index_module_default()).Form__TableCol, " mt30 mb10"),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                className: "".concat(gridClass(current_interview_type), " ").concat((_index_module_default()).Form__FloatingLabel),
                                                                                style: (0,common/* InputText */.oH)(formik, "children_attributes.".concat(index, ".member_ids")),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "red-color"
                                                                                    }),
                                                                                    "\xa0",
                                                                                    t("modal:input:members")
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "".concat((automation_popup_index_module_default()).AutomationPopup__Field),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                                                                                        suggestions: users,
                                                                                        onSuggestionsFetchRequested: function(param) {
                                                                                            var value = param.value;
                                                                                            return (0,automations/* onSuggestionsFetchRequested */.oo)(value, currentStage, setUsers, router);
                                                                                        },
                                                                                        onSuggestionsClearRequested: function() {
                                                                                            return setUsers([]);
                                                                                        },
                                                                                        getSuggestionValue: function(suggestion) {
                                                                                            return "".concat(suggestion.user_attributes.email);
                                                                                        },
                                                                                        renderSuggestion: automations/* renderSuggestion */.ox,
                                                                                        renderInputComponent: candidate_profile_job/* renderInputComponent */.Qx,
                                                                                        shouldRenderSuggestions: automations/* shouldRenderSuggestions */.KH,
                                                                                        onSuggestionSelected: function(event, param) {
                                                                                            var suggestion = param.suggestion;
                                                                                            if (suggestion.user_attributes.email.length > 0) {
                                                                                                stageEmail[index] = {
                                                                                                    value: ""
                                                                                                };
                                                                                                setStageEmail((0,_to_consumable_array/* default */.Z)(stageEmail));
                                                                                                (0,candidate_profile_job/* onSuggestionSelection */.wn)(formik.values.children_attributes[index].member_ids, suggestion.user_attributes.id, formik.values.children_attributes[index].members, {
                                                                                                    email: suggestion.user_attributes.email,
                                                                                                    name_initials: suggestion.user_attributes.name_initials,
                                                                                                    name: suggestion.user_attributes.name
                                                                                                });
                                                                                                formik.validateForm();
                                                                                            }
                                                                                        },
                                                                                        inputProps: {
                                                                                            className: "".concat((_index_module_default()).Form__Input, " ").concat((_index_module_default()).Form__textleft, " ").concat((_index_module_default()).Form__InputFullWidth),
                                                                                            placeholder: t("placeholder:search:type_name"),
                                                                                            value: stageEmail[index].value,
                                                                                            index: index,
                                                                                            formik: formik,
                                                                                            disabled: !editable,
                                                                                            editable: editable,
                                                                                            selectedValues: formik.values.children_attributes[index].members,
                                                                                            closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal/* Close */.x8, {}),
                                                                                            name: "children_attributes.".concat(index, ".member_ids"),
                                                                                            onChange: function(value, param) {
                                                                                                var newValue = param.newValue, method = param.method;
                                                                                                stageEmail[index] = {
                                                                                                    value: newValue
                                                                                                };
                                                                                                setStageEmail((0,_to_consumable_array/* default */.Z)(stageEmail));
                                                                                            },
                                                                                            styleError: (0,candidate_profile_job/* InputError */.pd)(formik, "children_attributes.".concat(index, ".member_ids")),
                                                                                            stageEmail: stageEmail,
                                                                                            setStageEmail: setStageEmail
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                                                                        name: "children_attributes.".concat(index, ".member_ids"),
                                                                                        errorClass: (_index_module_default()).Form__Error,
                                                                                        formik: formik,
                                                                                        style: (0,candidate_profile_job/* InputError */.pd)(formik, "children_attributes.".concat(index, ".member_ids"))
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__CloseIcon),
                                                                    children: interviewStageCount != 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: "/icons/close.png",
                                                                        alt: "",
                                                                        className: "mt0",
                                                                        onClick: function() {
                                                                            return (0,candidate_profile_job/* onAutomationChange */.mV)(formik, "remove", index, setStageEmail, setInterviewStageCount, setTotalDuration, current_interview_type, setShowHideButton);
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                });
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "dnone ".concat((_index_module_default()).addbtnposition),
                                        children: formik.values.interview_type_id && [
                                            common/* INTERVIEW_TYPES.VIDEO */.BH.VIDEO,
                                            common/* INTERVIEW_TYPES.FACE2FACE */.BH.FACE2FACE
                                        ].includes(current_interview_type) && showHideButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt20",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_button/* default */.Z, {
                                                buttonstyle: "".concat((button_index_module_default()).iconTextButton, " mt0"),
                                                type: "button",
                                                onClick: function() {
                                                    (0,candidate_profile_job/* onAutomationChange */.mV)(formik, "add", undefined, setStageEmail, setInterviewStageCount, setTotalDuration, current_interview_type, setShowHideButton);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(thick_plus/* default */.Z, {}),
                                                    t("button:add:interview")
                                                ]
                                            })
                                        })
                                    }),
                                    [
                                        common/* INTERVIEW_TYPES.PHONE */.BH.PHONE,
                                        common/* INTERVIEW_TYPES.VIDEO */.BH.VIDEO,
                                        common/* INTERVIEW_TYPES.FACE2FACE */.BH.FACE2FACE
                                    ].includes(current_interview_type) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt30",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "d-flex justify-content-between align-items-center mt20",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "WrapperRadio w100",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: "Dpflex WrapperRadioContainer WrapperRadiocheckmarkfont mb0",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Field */.gN, {
                                                                    type: "radio",
                                                                    name: "date_range",
                                                                    id: "option-1",
                                                                    value: true,
                                                                    onChange: function(event) {
                                                                        formik.setFieldValue("date_range", true);
                                                                        var children_attributes = formik.values.children_attributes;
                                                                        children_attributes.map(function(x) {
                                                                            x.start_time = "";
                                                                            x.end_time = "";
                                                                            return x;
                                                                        });
                                                                        setAddType("range");
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "WrapperRadiocheckmark m0"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "ml5",
                                                                    children: t("modal:automation:candidate_availability")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: "Dpflex WrapperRadioContainer WrapperRadiocheckmarkfont mb0 ".concat(!isSingleCandidate ? "disabledClass" : "notdisabled"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Field */.gN, {
                                                                    type: "radio",
                                                                    name: "date_range",
                                                                    id: "option-2",
                                                                    value: false,
                                                                    disabled: !isSingleCandidate,
                                                                    onChange: function(event) {
                                                                        formik.setFieldValue("date_range", false);
                                                                        var children_attributes = formik.values.children_attributes;
                                                                        children_attributes.map(function(x) {
                                                                            x.start_time = "";
                                                                            x.end_time = "";
                                                                            return x;
                                                                        });
                                                                        setAddType("time");
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "WrapperRadiocheckmark m0"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "ml5",
                                                                    children: t("modal:input:select_date_time")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            current_interview_type == "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "heightauto"
                                            }),
                                            addType == "range" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "heightauto"
                                            }),
                                            !formik.values.date_range && /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FieldArray */.F2, {
                                                name: "children_attributes",
                                                render: function(arrayHelpers) {
                                                    return formik.values.children_attributes.map(function(item, index) {
                                                        return !item._destroy && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((_index_module_default()).SetupPopup__ContentAddInterview, " ").concat((add_assessment_index_module_default()).AddInterview__ContentAddInterview, " ").concat((_index_module_default()).mtb25),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((_index_module_default()).SetupPopup__ContentFlex, " ").concat((_index_module_default()).Form__TableCol, " width145"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                            className: "".concat((_index_module_default()).Form__FloatingLabel),
                                                                            style: (0,common/* InputText */.oH)(formik, "children_attributes.".concat(index, ".date")),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "red-color",
                                                                                    children: "*"
                                                                                }),
                                                                                "\xa0",
                                                                                t("modal:input:interview_date")
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                            control: "customKeyboardPicker",
                                                                            className: "JobCustomDateTime",
                                                                            format: "DD/MM/YYYY",
                                                                            inputProps: {
                                                                                readOnly: false,
                                                                                style: (0,candidate_profile_job/* InputError */.pd)(formik, "children_attributes.".concat(index, ".date"))
                                                                            },
                                                                            minDate: new Date(new Date().setDate(new Date().getDate())),
                                                                            minDateMessage: "Interview date must be present or future date",
                                                                            disablePast: true,
                                                                            placeholder: "dd/mm/yyyy",
                                                                            name: "children_attributes.".concat(index, ".date"),
                                                                            onChange: function() {
                                                                                var _ref = (0,_async_to_generator/* default */.Z)(function(date) {
                                                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                                                        switch(_state.label){
                                                                                            case 0:
                                                                                                return [
                                                                                                    4,
                                                                                                    formik.setFieldValue("children_attributes.".concat(index, ".date"), date.format("DD/MM/YYYY"))
                                                                                                ];
                                                                                            case 1:
                                                                                                _state.sent();
                                                                                                return [
                                                                                                    2
                                                                                                ];
                                                                                        }
                                                                                    });
                                                                                });
                                                                                return function(date) {
                                                                                    return _ref.apply(this, arguments);
                                                                                };
                                                                            }(),
                                                                            formik: formik,
                                                                            custom_class: "form_custom_error",
                                                                            value: typeof formik.values.children_attributes[index].date == "string" ? (0,job_filters/* setFilledDate */.vH)(formik.values.children_attributes[index].date) : formik.values.children_attributes[index].date
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((_index_module_default()).SetupPopup__ContentFlex, " ").concat((_index_module_default()).Form__TableCol, " Timebg"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                            className: "".concat((_index_module_default()).Form__FloatingLabel),
                                                                            style: (0,common/* InputText */.oH)(formik, "children_attributes.".concat(index, ".starttime")),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "red-color",
                                                                                    children: "*"
                                                                                }),
                                                                                "\xa0",
                                                                                t("time:start")
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                            control: "timeinput",
                                                                            disabled: false,
                                                                            value: formik.values.children_attributes[index].starttime,
                                                                            fullTimeDropdown: true,
                                                                            allowDelete: true,
                                                                            hour12Format: false,
                                                                            onChange: function(dateString) {
                                                                                formik.setFieldValue("children_attributes.".concat(index, ".starttime"), dateString);
                                                                                formik.setFieldValue("children_attributes.".concat(index, ".endtime"), (0,candidate_profile_job/* addMinutes */.mH)(dateString, formik.values.children_attributes[index].duration));
                                                                            },
                                                                            inputProps: {
                                                                                style: (0,candidate_profile_job/* InputError */.pd)(formik, "children_attributes.".concat(index, ".starttime"))
                                                                            },
                                                                            errorClass: (_index_module_default()).Form__Error,
                                                                            name: "children_attributes.".concat(index, ".starttime"),
                                                                            formik: formik,
                                                                            custom_class: "form_custom_error",
                                                                            manuallyDisplayDropdown: true
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((_index_module_default()).SetupPopup__ContentFlex, " ").concat((_index_module_default()).Form__TableCol, " Timebg"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                            className: "".concat((_index_module_default()).Form__FloatingLabel),
                                                                            style: (0,common/* InputText */.oH)(formik, "children_attributes.".concat(index, ".endtime")),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "red-color",
                                                                                    children: "*"
                                                                                }),
                                                                                "\xa0",
                                                                                t("time:end")
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                            control: "timeinput",
                                                                            disabled: true,
                                                                            value: formik.values.children_attributes[index].endtime,
                                                                            fullTimeDropdown: false,
                                                                            allowDelete: true,
                                                                            hour12Format: false,
                                                                            onChange: function(dateString) {
                                                                                formik.setFieldValue("children_attributes.".concat(index, ".endtime"), dateString);
                                                                            },
                                                                            inputProps: {
                                                                                style: (0,candidate_profile_job/* InputError */.pd)(formik, "children_attributes.".concat(index, ".endtime"))
                                                                            },
                                                                            errorClass: (_index_module_default()).Form__Error,
                                                                            name: "children_attributes.".concat(index, ".endtime"),
                                                                            formik: formik,
                                                                            custom_class: "form_custom_error",
                                                                            manuallyDisplayDropdown: true
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }, "interview_round_".concat(index));
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    formik.values.interview_type_id && [
                                        common/* INTERVIEW_TYPES.PHONE */.BH.PHONE,
                                        common/* INTERVIEW_TYPES.VIDEO */.BH.VIDEO,
                                        common/* INTERVIEW_TYPES.FACE2FACE */.BH.FACE2FACE
                                    ].includes(current_interview_type) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((_index_module_default()).SetupPopup__Duration, " ").concat((automation_popup_index_module_default()).AutomationPopup__TotalDuration),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: t("time:total_duration")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    totalDuration,
                                                    " ",
                                                    t("time:mins")
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            current_interview_type == common/* INTERVIEW_TYPES.TECHTEST */.BH.TECHTEST && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((_index_module_default()).SetupPopup__ContentBlock),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__Row),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((automation_popup_index_module_default()).AutomationPopup__Members, " ").concat((_index_module_default()).Form__TableCol, " mt30 mb10"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: "".concat((_index_module_default()).Form__FloatingLabel),
                                                style: (0,common/* InputText */.oH)(formik, "job_test_detail_attributes.member_emails"),
                                                children: t("modal:input:members")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((automation_popup_index_module_default()).AutomationPopup__Field),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                                                        suggestions: users,
                                                        onSuggestionsFetchRequested: function(param) {
                                                            var value = param.value;
                                                            return (0,automations/* onSuggestionsFetchRequested */.oo)(value, currentStage, setUsers, router);
                                                        },
                                                        onSuggestionsClearRequested: function() {
                                                            return setUsers([]);
                                                        },
                                                        getSuggestionValue: function(suggestion) {
                                                            return "".concat(suggestion.user_attributes.email);
                                                        },
                                                        renderSuggestion: automations/* renderSuggestion */.ox,
                                                        renderInputComponent: techTestAction.renderMemberInputComponent,
                                                        shouldRenderSuggestions: techTestAction.shouldRenderSuggestions,
                                                        onSuggestionSelected: function(event, param) {
                                                            var suggestion = param.suggestion;
                                                            if (suggestion.user_attributes.email.length > 0) {
                                                                setTechStageEmail({
                                                                    value: ""
                                                                });
                                                                techTestAction.onSuggestionSelection(formik.values.job_test_detail_attributes.member_emails, suggestion.user_attributes.email, formik.values.job_test_detail_attributes.member_initials, {
                                                                    email: suggestion.user_attributes.email,
                                                                    name_initials: suggestion.user_attributes.name_initials,
                                                                    name: suggestion.user_attributes.name
                                                                });
                                                                formik.validateForm();
                                                            }
                                                        },
                                                        inputProps: {
                                                            className: "".concat((_index_module_default()).Form__Input, " ").concat((_index_module_default()).Form__textleft),
                                                            placeholder: t("placeholder:search:type_name"),
                                                            value: techStageEmail.value,
                                                            disabled: !editable,
                                                            editable: editable,
                                                            formik: formik,
                                                            selectedValues: (ref3 = formik.values.job_test_detail_attributes) === null || ref3 === void 0 ? void 0 : ref3.member_initials,
                                                            closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal/* Close */.x8, {}),
                                                            techTestAction: techTestAction,
                                                            add_button: false,
                                                            name: "job_test_detail_attributes.member_emails",
                                                            onChange: function(value, param) {
                                                                var newValue = param.newValue, method = param.method;
                                                                setTechStageEmail({
                                                                    value: newValue,
                                                                    error: ""
                                                                });
                                                            },
                                                            setStageEmail: setTechStageEmail
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                                        name: "job_test_detail_attributes.member_emails",
                                                        errorClass: (_index_module_default()).Form__Error,
                                                        formik: formik,
                                                        style: (0,candidate_profile_job/* InputError */.pd)(formik, "job_test_detail_attributes.member_emails")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            current_interview_type == common/* INTERVIEW_TYPES.TECHTEST */.BH.TECHTEST && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((_index_module_default()).SetupPopup__ContentGridTech, " UploadTest cpblock mb25"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((automation_popup_index_module_default()).AutomationPopup__Field, " ").concat((_index_module_default()).Form__TableCol, " mt30 mb10"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "".concat((_index_module_default()).Form__FloatingLabel),
                                                        style: (0,common/* InputText */.oH)(formik, "job_test_detail_attributes.test_id"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "red-color",
                                                                children: "*"
                                                            }),
                                                            "\xa0",
                                                            t("modal:input:test_name")
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                                                        suggestions: tests,
                                                        onSuggestionsFetchRequested: function(value) {
                                                            return techTestAction.onSuggestionsFetchRequested(value, techTestAction, formik.values.job_test_detail_attributes.test_type, false, t);
                                                        },
                                                        onSuggestionsClearRequested: function() {
                                                            return setTests([]);
                                                        },
                                                        getSuggestionValue: techTestAction.getSuggestionValue,
                                                        renderSuggestion: techTestAction.renderSuggestion,
                                                        renderInputComponent: techTestAction.renderInputComponent,
                                                        shouldRenderSuggestions: function() {
                                                            return formik.values.job_test_detail_attributes.test_type == "Assessment" ? true : techTestAction.shouldRenderSuggestions;
                                                        },
                                                        onSuggestionSelected: function(event, param) {
                                                            var suggestion = param.suggestion;
                                                            setTechTest(suggestion.name);
                                                            formik.setFieldValue("job_test_detail_attributes.test_id", suggestion.id);
                                                            techTestAction.setCustomTestOptions(formik, suggestion.id.toString(), validationData, setValidationData);
                                                        },
                                                        inputProps: {
                                                            className: "".concat((_index_module_default()).Form__Input, " input350"),
                                                            placeholder: t("placeholder:eg:java_test"),
                                                            value: techTest,
                                                            disabled: !props.editable,
                                                            onChange: function(value, param) {
                                                                var newValue = param.newValue, method = param.method;
                                                                setTechTest(newValue);
                                                                formik.setFieldValue("job_test_detail_attributes.test_id", "");
                                                            },
                                                            name: "job_test_detail_attributes.test_id",
                                                            styleError: (0,candidate_profile_job/* InputError */.pd)(formik, "job_test_detail_attributes.test_id")
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                                        name: "job_test_detail_attributes.test_id",
                                                        errorClass: (_index_module_default()).Form__Error,
                                                        formik: formik,
                                                        custom_class: "FieldError",
                                                        style: (0,candidate_profile_job/* InputError */.pd)(formik, "job_test_detail_attributes.test_id")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((automation_popup_index_module_default()).AutomationPopup__FieldAuto),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((_index_module_default()).Form__TableCol, " mt30 mb10"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: "".concat((_index_module_default()).Form__FloatingLabel),
                                                            style: (0,common/* InputText */.oH)(formik, "job_test_detail_attributes.days_to_expire"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "red-color",
                                                                    children: "*"
                                                                }),
                                                                "\xa0",
                                                                t("modal:input:expires")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((automation_popup_index_module_default()).AutomationPopup__FieldAuto, " ").concat((automation_popup_index_module_default()).AutomationPopup__NoRightBorderRadius, " w50"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__NoRightBorderRadius, " Dpflexonly"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Field */.gN, {
                                                                            component: addInterviewManualAction.NumberField,
                                                                            type: "text",
                                                                            autocomplete: "off",
                                                                            placeholder: t("placeholder:eg:5"),
                                                                            className: "".concat((_index_module_default()).Form__Input, " ").concat((automation_popup_index_module_default()).Form__InputFocus, " thresholdmodl width70"),
                                                                            formik: formik,
                                                                            maxLength: 2,
                                                                            name: "job_test_detail_attributes.days_to_expire",
                                                                            format: "###",
                                                                            style: (0,candidate_profile_job/* InputError */.pd)(formik, "job_test_detail_attributes.days_to_expire"),
                                                                            onChange: function(evt) {
                                                                                var new_value = isNaN(evt.target.value) ? 1 : parseInt(evt.target.value) == 0 ? "" : evt.target.value;
                                                                                formik.setFieldValue("job_test_detail_attributes.days_to_expire", new_value);
                                                                                return new_value;
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "".concat((automation_popup_index_module_default()).AutomationPopup__Seconds, " ").concat((_index_module_default()).Form__currency_symbol, " ").concat((_index_module_default()).Form__currency_symbol__right, " ml0"),
                                                                            style: (0,candidate_profile_job/* InputError */.pd)(formik, "job_test_detail_attributes.days_to_expire"),
                                                                            children: t("modal:input:days")
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                                                    name: "job_test_detail_attributes.days_to_expire",
                                                                    errorClass: (_index_module_default()).Form__Error,
                                                                    formik: formik,
                                                                    custom_class: "FieldError",
                                                                    style: (0,candidate_profile_job/* InputError */.pd)(formik, "job_test_detail_attributes.days_to_expire")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    ((ref4 = formik.values.job_test_detail_attributes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.test_id) === null || ref5 === void 0 ? void 0 : ref5.toString()) == "upload_new_test" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((_index_module_default()).SetupPopup__AssesmentsectionNew, " asessment-form-section"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((_index_module_default()).SetupPopup__ContentBlock, " ").concat((_index_module_default()).mt25),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((_index_module_default()).SetupPopup__ContentBlock, " ").concat((_index_module_default()).Form__TableCol),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            className: "".concat((_index_module_default()).Form__FloatingLabel),
                                                            style: (0,common/* InputText */.oH)(formik, "job_test_detail_attributes.assessment.name"),
                                                            children: t("modal:input:enter:assessment:name")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                            className: "assesmentlbl ".concat((_index_module_default()).Form__Input, " ").concat((add_assessment_index_module_default()).Form__Input),
                                                            control: "input",
                                                            type: "text",
                                                            errorClass: (_index_module_default()).Form__Error,
                                                            custom_class: "form_custom_error",
                                                            formik: formik,
                                                            name: "job_test_detail_attributes.assessment.name",
                                                            style: (0,candidate_profile_job/* InputError */.pd)(formik, "job_test_detail_attributes.assessment.name")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((_index_module_default()).SetupPopup__ContentBlock, " ").concat((_index_module_default()).Form__TableCol, " mt40"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            className: "".concat((_index_module_default()).Form__FloatingLabel),
                                                            style: (0,common/* InputText */.oH)(formik, "job_test_detail_attributes.assessment.link"),
                                                            children: t("modal:input:enter:assessment:link")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                            className: "".concat((_index_module_default()).Form__Input, " ").concat((add_assessment_index_module_default()).Form__Input),
                                                            control: "input",
                                                            placeholder: t("placeholder:eg:5"),
                                                            type: "text",
                                                            formik: formik,
                                                            name: "job_test_detail_attributes.assessment.link",
                                                            errorClass: (_index_module_default()).Form__Error,
                                                            custom_class: "form_custom_error",
                                                            disabled: false,
                                                            style: (0,candidate_profile_job/* InputError */.pd)(formik, "job_test_detail_attributes.assessment.link"),
                                                            onChange: function(event) {
                                                                if (event.target.value.length == 0 && formik.values.file) {
                                                                    formik.setFieldValue("job_test_detail_attributes.assessment.file_type", "file");
                                                                } else {
                                                                    formik.setFieldValue("job_test_detail_attributes.assessment.file_type", "link");
                                                                }
                                                                formik.setFieldValue("job_test_detail_attributes.assessment.link", event.target.value);
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((add_assessment_index_module_default()).DividerOr, " ").concat((add_assessment_index_module_default()).AutomationDividerOr),
                                                    children: t("upload:or")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "UploadAssessment ".concat((add_assessment_index_module_default()).UploadAssessment, " ").concat((_index_module_default()).SetupPopup__ContentBlock, " ").concat((_index_module_default()).mt0),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "".concat((add_assessment_index_module_default()).LabelNote),
                                                            children: t("upload:supported_files")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((add_assessment_index_module_default()).DropBox, " ").concat((_index_module_default()).Form__TableCol, " mt10"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    className: "mb10 ".concat((_index_module_default()).Form__FloatingLabel),
                                                                    children: t("upload:assessment")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((_index_module_default()).Form__DropBoxcontainer, " ").concat((add_assessment_index_module_default()).Assessment__Form__DropBoxcontainer),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(manage_assessment/* AssessmentDropZone */.Qq, {
                                                                        id: "upload_assessment",
                                                                        type: "automation",
                                                                        name: "job_test_detail_attributes.assessment.file",
                                                                        multiple: false,
                                                                        formRef: formRef,
                                                                        formik: formik,
                                                                        autofill: false,
                                                                        accept: ".pdf, .docx, .doc",
                                                                        dropAction: techTestAction,
                                                                        drop_type: "template"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((_index_module_default()).SetupPopup__FooterNew, " "),
                                children: current_interview_type == common/* INTERVIEW_TYPES.TECHTEST */.BH.TECHTEST && validationData.type == "Assessment" && validationData.test_id == "upload_new_test" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (_index_module_default()).SetupPopup__SubmitSectionSave,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
                                                content: t("tooltip:test_template"),
                                                background: "#00325A",
                                                radius: 20,
                                                padding: 12,
                                                placement: "top",
                                                fontSize: "12px",
                                                className: "SimpleTooltip",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "SaveTooltip",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                        buttonstyle: "".concat((button_index_module_default()).primarybtn, " ").concat((0,automations/* cursorNone */.y$)(props.editable)),
                                                        type: "button",
                                                        disabled: !props.editable,
                                                        onClick: function() {
                                                            setButtonState("save_and_continue");
                                                            // if((formik.values.job_test_detail_attributes.assessment.link.length > 0 && formik.values.job_test_detail_attributes.assessment.file) || (formik.values.job_test_detail_attributes.assessment.link.length == 0 && !formik.values.job_test_detail_attributes.assessment.file)){
                                                            //   customToastrAction.setNormalToastr(t('errors:assessment_link_error'), 'warning');
                                                            // }
                                                            // else{
                                                            formik.submitForm();
                                                        // }
                                                        },
                                                        children: t("button:save_and_continue")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                buttonstyle: "".concat((button_index_module_default()).secondarybtnborder, " ").concat((0,automations/* cursorNone */.y$)(props.editable)),
                                                type: "button",
                                                disabled: !props.editable,
                                                onClick: function() {
                                                    setButtonState("continue_without_saving");
                                                    formik.submitForm();
                                                },
                                                children: [
                                                    common/* INTERVIEW_TYPES.PHONE */.BH.PHONE,
                                                    common/* INTERVIEW_TYPES.VIDEO */.BH.VIDEO,
                                                    common/* INTERVIEW_TYPES.FACE2FACE */.BH.FACE2FACE
                                                ].includes(current_interview_type) && addType == "time" ? t("button:review_send") : t("button:continue_without_saving")
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((_index_module_default()).SetupPopup__SubmitSectionSave, " ").concat((automation_popup_index_module_default()).AutomationPopup__SubmitSectionSave),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        buttonstyle: "".concat((button_index_module_default()).primarybtn, " ").concat((0,automations/* cursorNone */.y$)(editable)),
                                        disabled: isDisabled || !editable,
                                        type: "button",
                                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            setSendInterview(true)
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        formik.submitForm();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        }),
                                        children: t("button:review_send")
                                    })
                                })
                            })
                        ]
                    })
                });
            }
        })
    });
}
SetupInterviewModal.layout = ClientDashboard/* default */.Z;
/* harmony default export */ var setup_interview_modal = (SetupInterviewModal);


/***/ }),

/***/ 60737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85374);
/* harmony import */ var _styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function SetupPopup(props) {
    var hide_class = props.hide_class ? "hide_modal" : "";
    return props.trigger ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_1___default().SetupPopup), " SetupPopup ").concat(hide_class),
        children: props.children
    }) : "";
}
/* harmony default export */ __webpack_exports__["Z"] = (SetupPopup);


/***/ }),

/***/ 4873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ShareCv": function() { return /* binding */ ShareCv; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/styles/components/share-cv/_index.module.scss
var _index_module = __webpack_require__(2443);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ../../shared/node_modules/yup/es/index.js + 26 modules
var es = __webpack_require__(76221);
;// CONCATENATED MODULE: ./src/constants/components/share-cv.js
 // Assuming t is correctly imported
var SHARE_CV = {
    share_with: "",
    title_note: ""
};
var getShareCvValidationSchema = function(t) {
    return common/* Yup.object */.sm.object({
        share_with: common/* Yup.string */.sm.string().email(t("errors:invalid_email")),
        title_note: common/* Yup.string */.sm.string().required(t("errors:required"))
    });
};

// EXTERNAL MODULE: ./src/actions/components/share-cv.js + 2 modules
var share_cv = __webpack_require__(75868);
// EXTERNAL MODULE: ./src/imports-files/components/review-email.js + 1 modules
var review_email = __webpack_require__(3623);
// EXTERNAL MODULE: ./src/imports-files/components/common-modal/common-modal.js + 2 modules
var common_modal = __webpack_require__(66172);
;// CONCATENATED MODULE: ./src/components/share-cv.js










function ShareCv(props) {
    var t = (0,common/* useTranslation */.$G)().t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(""), 2), jobTitleOptions = ref[0], setJobTitleOptions = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(""), 2), value = ref1[0], setValue = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), suggestion = ref2[0], setSuggestion = ref2[1];
    var share_cv_action = new share_cv/* ActionShareCv */.o(setValue, setSuggestion);
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), selectedValues = ref3[0], setSelectedValues = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(0), 2), selectedUserCount = ref4[0], setSelectedUserCount = ref4[1];
    var formRef = (0,common/* useRef */.sO)(null);
    var router = (0,common/* useRouter */.tv)();
    var SHARE_CV_VALIDATION_SCHEMA = getShareCvValidationSchema(t);
    return props.trigger ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(review_email/* FormModalStyle.ModalOverlay */.w2.ModalOverlay),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(review_email/* FormModalStyle.Modal */.w2.Modal),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(review_email/* FormModalStyle.Modal__Container */.w2.Modal__Container),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(review_email/* FormModalStyle.Modal__Container__Heading__Close */.w2.Modal__Container__Heading__Close),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Heading */.w2.Modal__Container__ContentSection__Heading),
                                children: t("modal:share_cv:heading")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(review_email/* FormModalStyle.Modal__Container__CloseSection */.w2.Modal__Container__CloseSection),
                                onClick: function() {
                                    setValue("");
                                    setSelectedValues([]);
                                    props.setButtonPopup(false);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal/* Close */.x8, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection */.w2.Modal__Container__ContentSection),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Formik */.J9, {
                            initialValues: SHARE_CV,
                            validationSchema: SHARE_CV_VALIDATION_SCHEMA,
                            innerRef: formRef,
                            onSubmit: function() {
                                router.asPath.includes("/clients/candidates") ? share_cv_action.submitCandidateShareForm(router, formRef.current, selectedValues, props.setApiError, props.setButtonPopup, setSelectedValues, t) : share_cv_action.submitJobShareForm(router, formRef.current, selectedValues, props.setApiError, props.setButtonPopup, setSelectedValues, t);
                            },
                            children: function(formik) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Form */.l0, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((_index_module_default()).Form__TableCol, " mt30"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: "".concat((_index_module_default()).Form__FloatingLabel),
                                                    style: (0,common/* InputText */.oH)(formik, "share_with"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "red-color",
                                                            children: "*"
                                                        }),
                                                        "\xa0",
                                                        t("modal:share_cv:with")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                    control: "autosuggestInput",
                                                    errorClass: (_index_module_default()).Form__Error,
                                                    formik: formik,
                                                    style: {
                                                        width: "60%"
                                                    },
                                                    getSuggestionValue: share_cv_action.getSuggestionValue,
                                                    inputProps: {
                                                        className: "AutosuggestOpenUp ".concat((_index_module_default()).Form__Input),
                                                        formik: formik,
                                                        name: "share_with",
                                                        onChange: function(value, param) {
                                                            var newValue = param.newValue;
                                                            formik.touched["share_with"] = true;
                                                            formik.setStatus({
                                                                share_with: ""
                                                            });
                                                            setValue(newValue);
                                                        },
                                                        selectedValues: selectedValues,
                                                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal/* Close */.x8, {}),
                                                        setSelectedValues: setSelectedValues,
                                                        setSelectedUserCount: setSelectedUserCount,
                                                        removeSelectedValues: share_cv_action.removeSelectedValues,
                                                        placeholder: t("placeholder:type_name"),
                                                        style: (0,common/* InputError */.pd)(formik, "share_with"),
                                                        value: value
                                                    },
                                                    onSuggestionsClearRequested: share_cv_action.onSuggestionsClearRequested,
                                                    onSuggestionsFetchRequested: share_cv_action.onSuggestionsFetchRequested,
                                                    onSuggestionSelected: function(event, param) {
                                                        var suggestion = param.suggestion;
                                                        if (suggestion.user_attributes.email.length > 0) {
                                                            setValue("");
                                                            share_cv_action.onSuggestionSelectionValue({
                                                                email: suggestion.user_attributes.email,
                                                                name_initials: suggestion.user_attributes.name_initials,
                                                                name: suggestion.user_attributes.name,
                                                                photo_url: suggestion.user_attributes.photo_url
                                                            }, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik);
                                                        }
                                                    },
                                                    renderSuggestion: share_cv_action.renderSuggestion,
                                                    shouldRenderSuggestions: share_cv_action.shouldRenderSuggestions,
                                                    suggestions: suggestion,
                                                    renderInputComponent: share_cv_action.renderInputComponent,
                                                    type: "email"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((_index_module_default()).Form__TableCol, " mt30"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: "".concat((_index_module_default()).Form__FloatingLabel),
                                                    style: (0,common/* InputText */.oH)(formik, "title_note"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "red-color",
                                                            children: "*"
                                                        }),
                                                        "\xa0",
                                                        t("modal:share_cv:add_note")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                    control: "customtextarea",
                                                    type: "text",
                                                    formik: formik,
                                                    className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block__Textarea */.w2.Modal__Container__ContentSection__Block__Textarea, " ").concat(common/* FormStyle.Form__Textarea */.x.Form__Textarea),
                                                    name: "title_note",
                                                    rows: "4",
                                                    style: (0,common/* InputError */.pd)(formik, "title_note")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: review_email/* FormModalStyle.Modal__Container__ButtonSection */.w2.Modal__Container__ButtonSection,
                                            style: {
                                                gap: "0"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                buttonstyle: (_index_module_default()).primarybtn,
                                                type: "submit",
                                                children: t("button:share")
                                            })
                                        })
                                    ]
                                });
                            }
                        })
                    })
                ]
            })
        })
    }) : "";
}


/***/ }),

/***/ 53594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ SkipModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47942);
/* harmony import */ var _components_common_modal_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99005);



function SkipModal(param) {
    var setBtnPopup = param.setBtnPopup, router = param.router;
    var t = (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_modal_modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        type: "confirmation",
        className: "CandidateFilterModal",
        noCloseIcon: true,
        message: t("modal:confirmation:skip_step"),
        texts: {
            button1_text: t("button:cancel"),
            button2_text: t("button:continue_skip")
        },
        closeModal: function() {
            return setBtnPopup(false);
        },
        btnAction: function() {
            router.push(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.activities */ .RQ.client.activities);
        }
    });
}


/***/ }),

/***/ 50261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ third_party_logo; }
});

// UNUSED EXPORTS: ThirdPartyLogo

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/styles/components/third-party-logo/_index.module.scss
var _index_module = __webpack_require__(56143);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
;// CONCATENATED MODULE: ./src/imports-files/components/third-party-logo.js



// EXTERNAL MODULE: ./src/actions/common/common.js
var common_common = __webpack_require__(1739);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
;// CONCATENATED MODULE: ./public/images/logo/logo.svg
var _path, _path2, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 38,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m1.72 6.606-.022-.009-.01-.02a4.336 4.336 0 0 1-.363-1.193 9.213 9.213 0 0 1-.119-1.507c0-1.079.142-1.935.422-2.544l.01-.02.02-.01c.493-.23 1.079-.346 1.741-.346.6 0 1.147.106 1.628.314l.023.01.01.023c.169.426.276.95.32 1.56l.003.056h1.285l-.011-.07a1.78 1.78 0 0 0-.494-.97 3.084 3.084 0 0 0-.998-.681l-.022-.01-.01-.022C4.805.393 4.242 0 3.462 0c-.866 0-1.507.405-1.905 1.203l-.01.018-.017.01c-.465.232-.838.57-1.11 1.003C.141 2.68 0 3.232 0 3.877c0 .73.143 1.333.424 1.794.275.451.668.792 1.167 1.012l.02.009.01.019c.393.765 1.01 1.154 1.83 1.154.768 0 1.342-.372 1.705-1.104l.01-.021.022-.009c.796-.315 1.323-.87 1.566-1.65L6.778 5H5.436l-.005.056c-.056.62-.17 1.144-.342 1.56l-.011.026-.026.008c-.501.163-1.06.246-1.663.246-.641 0-1.203-.098-1.67-.29ZM10.571 6.296l-.01.015c-.175.276-.41.456-.718.55-.323.098-.723.148-1.19.148-.074 0-.168-.004-.278-.013l-.046-.003-.009-.046a1.992 1.992 0 0 1-.032-.357c0-.298.058-.552.172-.756.114-.206.254-.373.415-.496.161-.124.388-.275.672-.449l.01-.006 1.014-.16v1.573Zm.157-3.202-.032-.012-.006-.033a1.198 1.198 0 0 0-.335-.638c-.19-.185-.448-.278-.767-.278-.588 0-.977.296-1.156.88l-.01.03-.03.01c-.324.102-.586.245-.777.425a.935.935 0 0 0-.31.716l.001.06h1.142l-.004-.064a4.493 4.493 0 0 1-.005-.247c0-.288.025-.546.074-.765l.008-.037.037-.008c.294-.07.623-.106.978-.106.394 0 .735.045 1.012.133l.04.013.002.042.002.101v.035c-.007.237-.058.44-.153.606-.096.168-.217.31-.359.424-.142.112-.329.24-.555.38l-.01.006-.444.076c-.647.1-1.105.257-1.401.479-.3.225-.453.518-.453.871 0 .499.328.803.975.905l.038.006.01.038a.938.938 0 0 0 .339.523c.178.13.405.197.677.197.35 0 .655-.124.906-.367.12-.115.222-.259.306-.427l.11-.22.015.883h1.013V4.454c0-.682-.296-1.14-.878-1.36ZM16.04 3.107l-.03-.013-.006-.032c-.082-.424-.327-.93-1.034-.93-.386 0-.717.145-.984.43-.147.157-.277.34-.384.546l-.114.218V2.263h-1.024v5.468h1.024v-3.95l.008-.015c.066-.11.17-.22.308-.323.151-.114.34-.207.558-.278a2.621 2.621 0 0 1 1.501.007l.039.012.004.04c.014.122.02.26.02.405v4.102h1.061V4.486c0-.361-.093-.66-.278-.89a1.667 1.667 0 0 0-.669-.49ZM21.763 3.758l.01.015v2.453l-.01.015a1.233 1.233 0 0 1-.333.33 2.129 2.129 0 0 1-.621.287c-.25.074-.532.112-.84.112-.346 0-.66-.053-.934-.158l-.026-.01-.01-.027c-.153-.436-.231-1.04-.231-1.796 0-.739.078-1.33.231-1.755l.01-.026.026-.01c.273-.105.588-.159.934-.159.308 0 .59.038.84.113.248.074.457.17.62.286.15.106.262.217.334.33Zm-1.54-1.623c-.614 0-1.05.318-1.298.944l-.01.025-.025.01c-.37.143-.675.366-.908.663-.244.312-.368.713-.368 1.191 0 .496.123.91.365 1.23.231.306.538.537.912.687l.024.01.01.024c.247.627.684.945 1.299.945.433 0 .792-.144 1.066-.428.142-.148.267-.321.369-.514l.114-.215v1.027h1.003V.125h-1.003v3.166l-.114-.212a2.306 2.306 0 0 0-.375-.518c-.273-.283-.63-.426-1.06-.426Z",
    fill: "#E55454"
  })), /*#__PURE__*/react.createElement("mask", {
    id: "logo_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10h38V0H0v10Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/react.createElement("g", {
    mask: "url(#logo_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E55454"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M23.706 7.734h1.034V2.266h-1.034v5.468ZM23.654 1.327h1.138V.125h-1.138v1.202ZM29.642 3.758l.01.015v2.453l-.01.015a1.233 1.233 0 0 1-.334.33 2.129 2.129 0 0 1-.62.287c-.25.074-.532.112-.84.112-.346 0-.66-.053-.934-.158l-.026-.01-.01-.027c-.153-.436-.231-1.04-.231-1.796 0-.739.078-1.33.231-1.755l.01-.026.025-.01c.274-.105.589-.159.935-.159.308 0 .59.038.84.113.248.074.457.17.62.286.15.106.262.217.334.33Zm-1.54-1.623c-.614 0-1.05.318-1.298.944l-.01.025-.025.01c-.37.143-.675.366-.908.663-.244.312-.368.713-.368 1.191 0 .496.123.91.365 1.23.23.306.538.537.912.687l.024.01.01.024c.247.627.684.945 1.298.945.434 0 .793-.144 1.067-.428.142-.148.266-.321.369-.514l.113-.215v1.027h1.004V.125h-1.004v3.166l-.113-.212a2.31 2.31 0 0 0-.375-.518c-.273-.283-.63-.426-1.06-.426ZM31.585 7.734h1.024V.125h-1.024v7.609ZM36.627 6.412c-.153.11-.344.202-.567.27-.223.07-.471.105-.737.105-.295 0-.568-.04-.812-.118l-.037-.012-.005-.039a3.273 3.273 0 0 1-.02-.376V2.266h-1.056v3.11c0 .353.093.649.276.878.168.211.392.373.666.48l.03.013.007.033c.061.312.176.548.341.702.179.167.424.252.73.252.395 0 .733-.146 1.001-.432.148-.158.278-.344.387-.55l.113-.22V7.97c0 .333-.03.636-.092.901l-.007.032-.03.011c-.33.13-.703.197-1.108.197a3.89 3.89 0 0 1-1.14-.16l-.032-.01-.009-.033a3.522 3.522 0 0 1-.098-.999l.001-.062h-1.162l.007.067c.026.247.147.474.362.673.197.183.457.331.773.44l.029.01.009.029c.195.62.612.934 1.24.934.637 0 1.058-.332 1.252-.985l.008-.025.023-.012c.309-.157.557-.382.74-.67.192-.302.29-.695.29-1.168V2.266h-1.056v3.81l-.008.014c-.066.113-.17.222-.309.322Z"
  }))));
};

/* harmony default export */ var logo = (SvgLogo);
;// CONCATENATED MODULE: ./src/components/third-party-logo.js







function ThirdPartyLogo(props) {
    var commonAction = new common_common/* CommonAction */.x();
    var ref = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)("".concat((_index_module_default()).ThirdPartyLogo__RectangularLogo)), 2), imageClass = ref[0], setImageClass = ref[1];
    (0,common/* useEffect */.d4)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            setTimeout(function() {
                var image = document.getElementById("third-party-header-logo"); // Replace 'yourImageId' with the actual ID of your image
                if (image) {
                    // Get the width and height of the image
                    var width = image.width;
                    var height = image.height;
                    // Calculate the aspect ratio
                    var aspectRatio = width / height;
                    console.log(width);
                    console.log(height);
                    console.log(aspectRatio);
                    // debugger;
                    // Check if it's a square or a rectangle
                    if (aspectRatio === 1) {
                        setImageClass("".concat((_index_module_default()).ThirdPartyLogo__SquareLogo));
                    // console.log('The image is a square.');
                    } else {
                        setImageClass("".concat((_index_module_default()).ThirdPartyLogo__RectangularLogo));
                    // console.log('The image is a rectangle.');
                    }
                }
            }, 100);
            return [
                2
            ];
        });
    }), []);
    return commonAction.headerLogoUrl() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((_index_module_default()).ThirdPartyLogo, " ").concat(imageClass),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: commonAction.headerLogoUrl(),
                alt: "Third Party Logo",
                id: "third-party-header-logo",
                onClick: function() {
                    return console.log("clicked");
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "".concat((_index_module_default()).ThirdPartyLogo__PoweredByCandidly),
                children: [
                    "powered by ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                ]
            })
        ]
    }) : "";
}
/* harmony default export */ var third_party_logo = (ThirdPartyLogo);


/***/ }),

/***/ 38678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ UnsuccessfulEmailModal; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/styles/components/candidate-email/_index.module.scss
var _index_module = __webpack_require__(22842);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/actions/components/candidate-email.js + 1 modules
var candidate_email = __webpack_require__(20344);
// EXTERNAL MODULE: ../../shared/node_modules/next/image.js
var next_image = __webpack_require__(53429);
// EXTERNAL MODULE: ./src/actions/components/share-cv.js + 2 modules
var share_cv = __webpack_require__(75868);
;// CONCATENATED MODULE: ./src/constants/components/unsuccessful-email-modal.js

var UNSUCCESSFUL_EMAIL_VALUES = {
    email: {
        cc: [],
        subject: "",
        email_body: ""
    }
};
var UNSUCCESSFUL_EMAIL_VALIDATION = common/* Yup.object */.sm.object({
    email: common/* Yup.object */.sm.object({})
});
var TEXTS = function(t) {
    return {
        active_or_unsuccessful: {
            heading: t("modal:unsuccessful_email")
        },
        move_candidates: {
            heading: (0,common/* TRANSLATION */.TA)("candidates:move_candidates:heading")
        },
        send_sourced_invitation: {
            heading: (0,common/* TRANSLATION */.TA)("candidates:send_sourced_invitation:heading")
        },
        add_interview: {
            heading: t("modal:email_modal:interview_email_scheduled")
        },
        setup_kanban_interview: {
            heading: t("modal:email_modal:interview_email_scheduled")
        },
        To: (0,common/* TRANSLATION */.TA)("modal:email_modal:to"),
        Email_Body: (0,common/* TRANSLATION */.TA)("modal:email_modal:email_body"),
        Subject: (0,common/* TRANSLATION */.TA)("modal:email_modal:subject"),
        CC: (0,common/* TRANSLATION */.TA)("modal:email_modal:cc"),
        Save: (0,common/* TRANSLATION */.TA)("modal:email_modal:save")
    };
};

// EXTERNAL MODULE: ./src/constants/components/review-email.js
var review_email = __webpack_require__(79300);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/candidates/kanban.js + 10 modules
var kanban = __webpack_require__(47942);
// EXTERNAL MODULE: ./src/imports-files/components/review-email.js + 1 modules
var components_review_email = __webpack_require__(3623);
// EXTERNAL MODULE: ./src/components/common-modal/modal.js + 2 modules
var modal = __webpack_require__(99005);
// EXTERNAL MODULE: ./src/imports-files/components/common-modal/common-modal.js + 2 modules
var common_modal = __webpack_require__(66172);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/candidate-profile-job.js
var candidate_profile_job = __webpack_require__(57470);
;// CONCATENATED MODULE: ./src/components/unsuccessful-email-modal.js


















function UnsuccessfulEmailModal(props) {
    var getFormFieldsName = function getFormFieldsName() {
        return {
            type: "template",
            master_template_id: "master_template_id",
            cc: "cc",
            subject: "subject",
            body: "email_body",
            default: "default",
            master_template_type: "master_template_type"
        };
    };
    var editSubjectHtml = function editSubjectHtml(subject) {
        var new_subject = subject.replace(/(<([^>]+)>)/gi, "");
        new_subject = new_subject.replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&gt;/g, ">").replace(/&lt;/g, "<").replace(/&rsquo;/g, "’").replace(/&ouml;/g, "\xf6").replace(/&oslash;/g, "\xf8").replace(/&auml;/g, "\xe4").replace(/&aring;/g, "\xe5").replace(/&aelig;/g, "\xe6");
        new_subject = new_subject.replace(/\n/g, " ");
        return new_subject.trim();
    };
    var t = (0,common/* useTranslation */.$G)().t;
    // --- INFO:- Clearing the SWR cache ----
    (0,components_review_email/* clearSWRCache */.A$)("review_email_data");
    // --------------------------------------
    var ref = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(0), 2), flagForRerender = ref[0], setFlagForRerender = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), selectedValues = ref1[0], setSelectedValues = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), showLoader = ref2[0], setShowLoader = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(""), 2), value = ref3[0], setValue = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), suggestion = ref4[0], setSuggestion = ref4[1];
    var autosuggest_action = new share_cv/* ActionShareCv */.o(setValue, setSuggestion);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(props.emailData.templates[0].subject_variables), 2), subject = ref5[0], setSubject = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(props.emailData.templates[0].data_variables), 2), dataVariables = ref6[0], setDataVariables = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(0), 2), refreshKey = ref7[0], setRefreshKey = ref7[1];
    var editorBodyRef = (0,common/* useRef */.sO)(null);
    var editorSubjectRef = (0,common/* useRef */.sO)(null);
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(0), 2), selectedUserCount = ref8[0], setSelectedUserCount = ref8[1];
    var router = (0,common/* useRouter */.tv)();
    var reviewEmailActions = new components_review_email/* ReviewEmailActions */.fY();
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(""), 2), currentPurposeValue = ref9[0], setCurrentPurposeValue = ref9[1];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)({
        cc: "",
        subject: props.emailData.templates[0].subject,
        email_body: props.emailData.templates[0].email_body,
        language_iso_code: props.emailData.templates[0].language_iso_code
    }), 2), unsuccessfulEmailValues = ref10[0], setUnsuccessfulEmailValues = ref10[1];
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), disabledSaveButton = ref11[0], setDisabledSaveButton = ref11[1];
    var formFieldNames = getFormFieldsName();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        type: "form",
        heading: TEXTS(t)["".concat(props.reviewKey)]["heading"],
        closeModal: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(props.from == "kanban")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,kanban/* clearRadioButtonSelection */.sZ)(props.setSelectedCards, props.activeTab, props.setActionBar)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        props.setUnsuccessfulEmailModal(false);
                        return [
                            2
                        ];
                }
            });
        }),
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Formik */.J9, {
                    initialValues: unsuccessfulEmailValues,
                    validationSchema: UNSUCCESSFUL_EMAIL_VALIDATION,
                    enableReinitialize: true,
                    onSubmit: function(values) {
                        values.subject = editSubjectHtml(values.subject);
                        if (props.reviewKey == "active_or_unsuccessful") (0,kanban/* send_unsuccessful_email */.M)({
                            job_id: props.job_id,
                            router: router,
                            selectedCards: props.selectedCards,
                            setActionBar: props.setActionBar,
                            setSelectedCards: props.setSelectedCards,
                            activeTab: props.activeTab,
                            values: values,
                            from: props.from,
                            selectedValues: selectedValues,
                            setUnsuccessfulEmailModal: props.setUnsuccessfulEmailModal,
                            unsuccessful_candidates_token: props.unsuccessful_candidates_token
                        });
                        else if (props.reviewKey == "add_interview") {
                            var action = props.addInterviewBar.action;
                            if (action.from == "manual_kanban_interview") {
                                (0,candidate_profile_job/* addManualKanbanInterview */.W5)(action.values, action.router, action.setBtnPopup, action.setJobData || action.setInitialData, setShowLoader, action.current_interview_type, action.setFlagForRender, setDisabledSaveButton, action.props, props.setAddInterviewBar, props.addInterviewBar, values, props.setUnsuccessfulEmailModal);
                            } else {
                                (0,candidate_profile_job/* addManualInterview */.Hi)(action.values, action.router, action.setBtnPopup, action.setInitialData, setShowLoader, action.current_interview_type, action.setFlagForRender, setDisabledSaveButton, action.from, props.setAddInterviewBar, props.addInterviewBar, values, props.setUnsuccessfulEmailModal);
                            }
                        } else {
                            (0,kanban/* runAutomations */.hh)({
                                activeTab: props.activeTab,
                                setJobData: props.setJobData,
                                selectedCards: props.automationActions,
                                setActionBar: props.setActionBar,
                                router: router,
                                job_id: props.job_id,
                                setSelectedCards: props.setSelectedCards,
                                filterData: props.filterData,
                                from: props.from,
                                values: values,
                                reviewKey: props.reviewKey,
                                setUnsuccessfulEmailModal: props.setUnsuccessfulEmailModal,
                                selectedValues: selectedValues,
                                setInitialData: props.setInitialData
                            });
                        }
                    },
                    children: function(formik) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(common/* Form */.l0, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat(components_review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((_index_module_default()).Form__TableCol, " removeplaceholder mt30"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: "".concat((_index_module_default()).Form__FloatingLabel),
                                            style: (0,common/* InputText */.oH)(formik, "".concat(formFieldNames.type, ".").concat(formFieldNames.master_template_id)),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "red-color",
                                                    children: "*"
                                                }),
                                                "\xa0 ",
                                                t("label:purpose")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                            control: "select",
                                            type: "text",
                                            formik: formik,
                                            errorClass: (_index_module_default()).Form__Error,
                                            default: "0",
                                            disabled: false,
                                            /* placeholder   =   {REVIEW_EMAIL.texts.purpose} */ className: "".concat((_index_module_default()).Form__Input, " thresholdmodl"),
                                            name: formFieldNames["type"] + "." + formFieldNames["master_template_id"],
                                            options: reviewEmailActions.kanbanPurposeList(props.emailData),
                                            style: (0,common/* InputError */.pd)(formik, "".concat(formFieldNames.type, ".").concat(formFieldNames.master_template_id)),
                                            onChange: function(option) {
                                                setCurrentPurposeValue(option.value);
                                                reviewEmailActions.setUnsuccssfulModalData(option, formik, formFieldNames, setSubject, setDataVariables, setRefreshKey, props.emailData.templates, setUnsuccessfulEmailValues);
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat(components_review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((_index_module_default()).Form__TableCol),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: "".concat((_index_module_default()).Form__Label),
                                            children: t("label:to")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (_index_module_default()).SetupPopup__ToChips,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "".concat((_index_module_default()).SetupPopup__ToName, " fw600"),
                                                    children: [
                                                        props.from == "kanban" ? props.firstCandidateName || (0,candidate_email/* getCandidateName */.o5)(props.selectedCards) : props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : ref.application.name,
                                                        props.candidate_count > 1 ? " + ".concat(props.candidate_count - 1, " More") : ""
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat(components_review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((_index_module_default()).Form__TableCol),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: "".concat((_index_module_default()).Form__FloatingLabel),
                                            style: (0,common/* InputText */.oH)(formik, "".concat(formFieldNames.cc)),
                                            children: t("label:cc")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                            control: "autosuggestInput",
                                            errorClass: (_index_module_default()).Form__Error,
                                            formik: formik,
                                            getSuggestionValue: autosuggest_action.getSuggestionValue,
                                            inputProps: {
                                                className: "AutosuggestOpenUp ".concat((_index_module_default()).Form__Input),
                                                formik: formik,
                                                name: "".concat(formFieldNames.cc),
                                                onChange: function(value, param) {
                                                    var newValue = param.newValue;
                                                    formik.touched["".concat(formFieldNames.cc)] = true;
                                                    formik.status ? formik.status["".concat(formFieldNames.cc)] = "" : "";
                                                    setValue(newValue);
                                                },
                                                placeholder: t("placeholder:search:type_name_search"),
                                                style: (0,common/* InputError */.pd)(formik, "".concat(formFieldNames.cc)),
                                                value: value
                                            },
                                            onSuggestionsClearRequested: autosuggest_action.onSuggestionsClearRequested,
                                            onSuggestionsFetchRequested: autosuggest_action.onSuggestionsFetchRequested,
                                            onSuggestionSelected: function(event, param) {
                                                var suggestion = param.suggestion;
                                                if (suggestion.user_attributes.email.length > 0) {
                                                    setValue("");
                                                    setSelectedValues;
                                                    autosuggest_action.onSuggestionSelectionEmail({
                                                        email: suggestion.user_attributes.email,
                                                        name_initials: suggestion.user_attributes.name_initials,
                                                        name: suggestion.user_attributes.name,
                                                        photo_url: suggestion.user_attributes.photo_url
                                                    }, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik);
                                                }
                                            },
                                            renderSuggestion: autosuggest_action.renderSuggestion,
                                            shouldRenderSuggestions: autosuggest_action.shouldRenderSuggestions,
                                            suggestions: suggestion,
                                            type: "email"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "Dpflexonly Flexflow",
                                            children: selectedValues.map(function(element, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "Sharecv emailchipsspace ".concat((_index_module_default()).Tagrow),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (_index_module_default()).Tagrow__Tags,
                                                        children: [
                                                            (element === null || element === void 0 ? void 0 : element.photo_url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: element === null || element === void 0 ? void 0 : element.photo_url,
                                                                className: "JobImageSmall"
                                                            }) : element.name_initials && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (_index_module_default()).Tagrow__Prefix,
                                                                children: element.name_initials
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "ml6",
                                                                children: element.name || element.email
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                type: "button",
                                                                className: (_index_module_default()).Tagrow__Cancel,
                                                                onClick: function(event) {
                                                                    return autosuggest_action.removeSelectedValues(event, selectedValues, setSelectedValues, setSelectedUserCount);
                                                                },
                                                                "data-index": index,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal/* Close */.x8, {})
                                                            })
                                                        ]
                                                    })
                                                }, index);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat(components_review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((_index_module_default()).Form__TableCol, " mt30"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: "".concat(components_review_email/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading, " ").concat((_index_module_default()).Form__FloatingLabel),
                                            style: (0,common/* InputText */.oH)(formik, "".concat(formFieldNames.subject)),
                                            children: t("label:subject")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                            id: "email_template_subject",
                                            apiKey: "dxe0l6rdhdta2rzyfq2io208ncq1ay4l9wc2vyre3a53sdna",
                                            control: "customEditor",
                                            formik: formik,
                                            onInit: function(evt, editor) {
                                                return editorSubjectRef.current = editor;
                                            },
                                            textareaName: "".concat(formFieldNames.subject),
                                            identifierClass: "emailTemplateSubject",
                                            style: (0,common/* InputError */.pd)(formik, "".concat(formFieldNames.subject)),
                                            value: formik.values["".concat(formFieldNames.subject)],
                                            onEditorChange: function(value, editor) {
                                                formik.status ? formik.status["".concat(formFieldNames.subject)] = "" : "";
                                                formik.setFieldValue("".concat(formFieldNames.subject), value);
                                            },
                                            init: {
                                                height: 50,
                                                resize: false,
                                                menubar: false,
                                                plugins: [
                                                    "advlist autolink lists link image charmap print preview anchor",
                                                    "searchreplace visualblocks code fullscreen",
                                                    "insertdatetime media table paste help wordcount autoresize  noneditable", 
                                                ],
                                                toolbar: "tokens",
                                                content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                                newline_behavior: "block",
                                                noneditable_regexp: /\{\{[^\}]+\}\}/g,
                                                setup: function(editor) {
                                                    editor.ui.registry.addMenuButton("tokens", {
                                                        text: t("label:data_tags"),
                                                        tooltip: t("label:insert_token"),
                                                        fetch: function(callback) {
                                                            var items = subject.map(function(subject) {
                                                                return {
                                                                    type: "menuitem",
                                                                    text: subject.text,
                                                                    onAction: function() {
                                                                        editor.insertContent(subject.value);
                                                                    }
                                                                };
                                                            });
                                                            callback(items);
                                                        }
                                                    });
                                                    editor.on("keydown", function(e) {
                                                        if (e.keyCode == 13) {
                                                            e.preventDefault();
                                                        }
                                                    });
                                                },
                                                paste_preprocess: function paste_preprocess(plugin, args) {
                                                    args.content = args.content.replace(/(<([^>]+)>)/gi, "");
                                                }
                                            }
                                        }, refreshKey)
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat(components_review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((_index_module_default()).Form__TableCol),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: "".concat((_index_module_default()).Form__FloatingLabel),
                                            style: (0,common/* InputText */.oH)(formik, "".concat(formFieldNames.body)),
                                            children: [
                                                " ",
                                                t("label:email_body")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                            id: "email_template_body",
                                            control: "customEditor",
                                            formik: formik,
                                            onInit: function(evt, editor) {
                                                return editorBodyRef.current = editor;
                                            },
                                            textareaName: "".concat(formFieldNames.body),
                                            identifierClass: "emailTemplateBody",
                                            style: (0,common/* InputError */.pd)(formik, "".concat(formFieldNames.body)),
                                            value: formik.values["".concat(formFieldNames.body)],
                                            onEditorChange: function(value) {
                                                formik.status ? formik.status["".concat(formFieldNames.body)] = "" : "";
                                                formik.setFieldValue("".concat(formFieldNames.body), value);
                                            },
                                            init: {
                                                height: 500,
                                                menubar: false,
                                                resize: false,
                                                plugins: [
                                                    "advlist",
                                                    "autolink",
                                                    "lists",
                                                    "link",
                                                    "image",
                                                    "charmap",
                                                    "preview",
                                                    "anchor",
                                                    "searchreplace",
                                                    "visualblocks",
                                                    "code",
                                                    "fullscreen",
                                                    "insertdatetime",
                                                    "media",
                                                    "table",
                                                    "help",
                                                    "wordcount",
                                                    "noneditable", 
                                                ],
                                                toolbar: "undo redo | blocks | " + "bold italic backcolor | link | alignleft aligncenter " + "alignright alignjustify | tokens",
                                                content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                                noneditable_regexp: /\{\{[^\}]+\}\}/g,
                                                allow_html_in_named_anchor: true,
                                                setup: function(editor) {
                                                    editor.ui.registry.addMenuButton("tokens", {
                                                        text: t("label:data_tags"),
                                                        tooltip: t("label:insert_token"),
                                                        fetch: function(callback) {
                                                            var items = dataVariables.map(function(dataVariable) {
                                                                return {
                                                                    type: "menuitem",
                                                                    text: dataVariable.text,
                                                                    onAction: function() {
                                                                        editor.insertContent(dataVariable.value);
                                                                    }
                                                                };
                                                            });
                                                            callback(items);
                                                        }
                                                    });
                                                }
                                            }
                                        }, refreshKey)
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat(components_review_email/* FormModalStyle.Modal__Container__ButtonSection */.w2.Modal__Container__ButtonSection),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                            buttonstyle: (_index_module_default()).secondarybtnborder,
                                            type: "button",
                                            onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            if (!(props.from == "kanban")) return [
                                                                3,
                                                                2
                                                            ];
                                                            return [
                                                                4,
                                                                (0,kanban/* clearRadioButtonSelection */.sZ)(props.setSelectedCards, props.activeTab, props.setActionBar)
                                                            ];
                                                        case 1:
                                                            _state.sent();
                                                            _state.label = 2;
                                                        case 2:
                                                            props.setUnsuccessfulEmailModal(false);
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            }),
                                            children: t("button:cancel")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                            buttonstyle: (_index_module_default()).primarybtn,
                                            disabled: disabledSaveButton,
                                            type: "submit",
                                            children: t("button:send")
                                        })
                                    ]
                                })
                            ]
                        });
                    }
                }),
                showLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Loading */.gb, {})
            ]
        })
    });
}


/***/ }),

/***/ 59678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ UnsuccessfulModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18186);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62286);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2443);
/* harmony import */ var _styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _components_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95662);
/* harmony import */ var react_datetime_css_react_datetime_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18202);
/* harmony import */ var react_datetime_css_react_datetime_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_datetime_css_react_datetime_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96047);
/* harmony import */ var _imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60838);
/* harmony import */ var _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47942);
/* harmony import */ var react_simple_tooltip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54392);
/* harmony import */ var _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66172);













function UnsuccessfulModal(props) {
    var ref;
    var t = (0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_5__/* .clearSWRCache */ .A$)("unsuccessful-reasons-list");
    var router = (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_5__/* .useRouter */ .tv)();
    var Placeholder = function(props) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_5__/* .components.Placeholder */ .wx.Placeholder, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props));
    };
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_5__/* .useState */ .eJ)([]), 2), reasons = ref1[0], setReasons = ref1[1];
    var ref2 = (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_5__/* .useSWR */ .dH)("unsuccessful-reasons-list", function() {
        return (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_5__/* .getReasonsList */ .tk)("", router);
    }), data = ref2.data, error = ref2.error;
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_5__/* .useState */ .eJ)(true), 2), isLoading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_5__/* .useState */ .eJ)(false), 2), showOther = ref4[0], setShowOther = ref4[1];
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_5__/* .useState */ .eJ)(false), 2), otherValidationCheck = ref5[0], setOtherValidationCheck = ref5[1];
    (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_5__/* .useEffect */ .d4)(function() {
        if (data) {
            setLoading(false);
            setReasons(data);
        }
    }, [
        data
    ]);
    if (isLoading) {
        return "";
    }
    function getSuggestions(router) {
        return _getSuggestions.apply(this, arguments);
    }
    function _getSuggestions() {
        _getSuggestions = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(router) {
            var reasons_list;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_5__/* .getReasonsList */ .tk)("", router)
                        ];
                    case 1:
                        reasons_list = _state.sent();
                        return [
                            2,
                            reasons_list
                        ];
                }
            });
        });
        return _getSuggestions.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .FormModalStyle.ModalOverlay */ .w2.ModalOverlay),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .FormModalStyle.Modal */ .w2.Modal),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .FormModalStyle.Modal__Container */ .w2.Modal__Container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .FormModalStyle.Modal__Container__Heading__Close */ .w2.Modal__Container__Heading__Close),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .FormModalStyle.Modal__Container__ContentSection__Heading */ .w2.Modal__Container__ContentSection__Heading),
                                children: (props === null || props === void 0 ? void 0 : (ref = props.texts) === null || ref === void 0 ? void 0 : ref.heading) || t("modal:unsuccessful_reasons:heading")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .FormModalStyle.Modal__Container__CloseSection */ .w2.Modal__Container__CloseSection),
                                onClick: function() {
                                    props.setUnsuccessfulModal(false);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .Close */ .x8, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .FormModalStyle.Modal__Container__ContentSection */ .w2.Modal__Container__ContentSection,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_3__/* .Formik */ .J9, {
                            initialValues: props.formInitialValues || _imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_4__/* .UNSUCCESSFUL_REASON_INITIAL_VALUES */ .h,
                            validationSchema: props.formValidations || (0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_4__/* .UnsuccessfulModalValidation */ .ae)(otherValidationCheck),
                            onSubmit: function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(values) {
                                    var _tmp;
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (props.selectedCards) {
                                                    props.selectedCards.reason_text = values.reason_text;
                                                    props.selectedCards.reason_id = values.reason_id;
                                                    props.selectedCards.reason = values.reason_text;
                                                }
                                                if (!(props === null || props === void 0 ? void 0 : props.page_name)) return [
                                                    3,
                                                    1
                                                ];
                                                _tmp = "";
                                                return [
                                                    3,
                                                    3
                                                ];
                                            case 1:
                                                return [
                                                    4,
                                                    (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_5__/* .markActiveUnsuccessful */ .KF)(props)
                                                ];
                                            case 2:
                                                _tmp = _state.sent();
                                                _state.label = 3;
                                            case 3:
                                                _tmp;
                                                if (props.submitFormAction) props.submitFormAction(values);
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(values) {
                                    return _ref.apply(this, arguments);
                                };
                            }(),
                            children: function(formik) {
                                var ref, ref1, ref2, ref3;
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_3__/* .Form */ .l0, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol), " mt30"),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                    className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabel), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabelWithIcon)),
                                                    style: (0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_4__/* .InputText */ .oH)(formik, "reason"),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "red-color",
                                                            children: "*"
                                                        }),
                                                        "\xa0",
                                                        (props === null || props === void 0 ? void 0 : (ref = props.texts) === null || ref === void 0 ? void 0 : ref.label) || t("modal:unsuccessful_reasons:reason"),
                                                        "\xa0\xa0",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_simple_tooltip__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                            className: "SimpleTooltip",
                                                            content: t("placeholder:max_50_char"),
                                                            background: "#00325A",
                                                            radius: 20,
                                                            padding: 8,
                                                            placement: "right",
                                                            fontSize: "12px",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "tooltipwidthinterview200 m0",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_3__/* .Exclamation */ .P5, {})
                                                            })
                                                        })
                                                    ]
                                                }),
                                                props.page_name == "unsuccessfulReasons" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_3__/* .FormikControl */ .gt, {
                                                    control: "input",
                                                    className: " ".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .FormModalStyle.Form__InputFullWidth */ .w2.Form__InputFullWidth, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Input)),
                                                    errorClass: _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .FormModalStyle.Form__Error */ .w2.Form__Error,
                                                    formik: formik,
                                                    name: "reason",
                                                    maxLength: "50",
                                                    placeholder: props === null || props === void 0 ? void 0 : (ref1 = props.texts) === null || ref1 === void 0 ? void 0 : ref1.placeholder,
                                                    style: (0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_4__/* .InputError */ .pd)(formik, "reason"),
                                                    type: "text"
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol)),
                                                    style: (0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_4__/* .InputText */ .oH)(formik, "reason_id"),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_3__/* .FormikControl */ .gt, {
                                                        className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .FormModalStyle.Form__CustomSelect */ .w2.Form__CustomSelect, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__CustomSelect)),
                                                        components: {
                                                            Placeholder: Placeholder
                                                        },
                                                        control: "select",
                                                        default: formik.values.reason_id,
                                                        formik: formik,
                                                        name: "reason_id",
                                                        onChange: function(option) {
                                                            formik.setFieldValue("reason_id", option.value);
                                                            formik.setFieldValue("reason", option.label);
                                                            if (option.reason == "Other") {
                                                                setOtherValidationCheck(true);
                                                                setShowOther(true);
                                                            } else {
                                                                setOtherValidationCheck(false);
                                                                setShowOther(false);
                                                                formik.setFieldValue("reason_text", "");
                                                            }
                                                        },
                                                        options: reasons,
                                                        placeholder: t("placeholder:select:please"),
                                                        style: (0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_4__/* .InputError */ .pd)(formik, "reason_id"),
                                                        value: reasons === null || reasons === void 0 ? void 0 : reasons.filter(function(option) {
                                                            return option.value === formik.values.reason_id;
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "height113",
                                            children: showOther && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol)),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                        className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabel), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabelWithIcon)),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "red-color",
                                                                children: "*"
                                                            }),
                                                            "\xa0",
                                                            t("modal:unsuccessful_reasons:other_reason"),
                                                            "\xa0",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_simple_tooltip__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                                className: "SimpleTooltip",
                                                                content: t("placeholder:max_50_char"),
                                                                background: "#00325A",
                                                                radius: 20,
                                                                padding: 8,
                                                                placement: "right",
                                                                fontSize: "12px",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: "tooltipwidthinterview200 m0",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_3__/* .Exclamation */ .P5, {})
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_3__/* .FormikControl */ .gt, {
                                                        control: "input",
                                                        className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .FormModalStyle.Form__Input */ .w2.Form__Input),
                                                        errorClass: _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .FormModalStyle.Form__Error */ .w2.Form__Error,
                                                        formik: formik,
                                                        name: "reason_text",
                                                        maxLength: "50",
                                                        placeholder: "",
                                                        infoPlaceholder: t("placeholder:max_50_char"),
                                                        style: (0,_imports_files_components_add_to_job_modal_js__WEBPACK_IMPORTED_MODULE_4__/* .InputError */ .pd)(formik, "reason_text"),
                                                        type: "text"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .FormModalStyle.Modal__Container__ButtonSection */ .w2.Modal__Container__ButtonSection,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                    buttonstyle: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .FormModalStyle.secondarybtn */ .w2.secondarybtn),
                                                    type: "button",
                                                    onClick: function() {
                                                        props.setUnsuccessfulModal(false);
                                                    },
                                                    children: (props === null || props === void 0 ? void 0 : (ref2 = props.texts) === null || ref2 === void 0 ? void 0 : ref2.button_1) || t("button:cancel")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                    buttonstyle: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .FormModalStyle.primarybtn */ .w2.primarybtn),
                                                    type: "submit",
                                                    disabled: props.disableSubmitButton,
                                                    children: (props === null || props === void 0 ? void 0 : (ref3 = props.texts) === null || ref3 === void 0 ? void 0 : ref3.button_2) || t("button:submit")
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 40168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IR": function() { return /* binding */ customCompnayIntegrationValidation; },
/* harmony export */   "KX": function() { return /* binding */ getTotalJobsModal; },
/* harmony export */   "Mm": function() { return /* binding */ getLinkedInJobsModal; },
/* harmony export */   "oq": function() { return /* binding */ getindeedModal; },
/* harmony export */   "tl": function() { return /* binding */ CONSTANTS; },
/* harmony export */   "vb": function() { return /* binding */ integrationValidationSchema; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38641);
/* harmony import */ var _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62641);


var DomainMatch = /^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/gm;
function getLinkedInJobsModal(t) {
    return {
        heading: "Authentication",
        description: t("modal:input_modal:description"),
        radios: [
            {
                text: t("modal:input_modal:text:linkedin_basic"),
                defaultvalue: "true",
                id: "obtainCompanyId",
                checked: "true"
            },
            {
                text: t("modal:input_modal:text:linkedin_premium"),
                defaultvalue: "false",
                id: "obtainCompanyId",
                checked: "false"
            }, 
        ],
        inputs: [
            {
                label: t("modal:input_modal:input:lable:company_id"),
                name: "company_id",
                placeholder: t("modal:input_modal:placeholder:company_id"),
                description: "obtainCompanyId"
            },
            {
                label: t("modal:input_modal:input:lable:contract_id"),
                name: "contract_id",
                placeholder: t("modal:input_modal:placeholder:contract_id"),
                description: "obtainContractId"
            }, 
        ]
    };
}
function getindeedModal(t) {
    return {
        heading: "Authentication",
        description: t("modal:input_modal:description"),
        inputs: [
            {
                label: t("modal:input_modal:input:lable:company_name"),
                tooltip: t("modal:input_modal:tooltip:company_name"),
                name: "company_name",
                placeholder: t("modal:input_modal:placeholder:company_name")
            },
            {
                label: t("modal:input_modal:input:lable:campaign_tag"),
                tooltip: t("modal:input_modal:tooltip:campaign_tag"),
                name: "campaign_tag",
                placeholder: t("modal:input_modal:placeholder:campaign_tag")
            }, 
        ]
    };
}
function getTotalJobsModal(t) {
    return {
        heading: "Authentication",
        description: t("modal:input_modal:descriptionTotalJob"),
        inputs: [
            {
                label: t("modal:input_modal:input:lable:total_job_username"),
                name: "user_name",
                type: "text",
                placeholder: t("modal:input_modal:placeholder:total_job_username"),
                tooltip: t("modal:input_modal:tooltip:totaljob_username")
            },
            {
                label: t("modal:input_modal:input:lable:password"),
                name: "password",
                type: "password",
                placeholder: t("modal:input_modal:placeholder:password"),
                tooltip: t("modal:input_modal:tooltip:totaljob_password")
            }, 
        ]
    };
}
var CONSTANTS = {
    formInitialValues: {
        custom_integration: {
            name: "",
            domain: "",
            category: ""
        }
    },
    formValidations: _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
        custom_integration: _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
            name: _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("common:errors:required")).nullable(true),
            domain: _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("common:errors:required")).matches(DomainMatch, "Please enter correct domain"),
            category: _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("common:errors:required"))
        })
    }),
    indeedModal: {
        heading: "Authentication",
        description: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:description"),
        inputs: [
            {
                label: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:input:lable:company_name"),
                tooltip: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:tooltip:company_name"),
                name: "company_name",
                type: "text",
                placeholder: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:placeholder:company_name")
            },
            {
                label: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:input:lable:campaign_tag"),
                tooltip: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:tooltip:campaign_tag"),
                name: "campaign_tag",
                type: "text",
                placeholder: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:placeholder:campaign_tag")
            }, 
        ]
    },
    linkedInJobsModal: {
        heading: "Authentication",
        description: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:description"),
        radios: [
            {
                text: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:text:linkedin_basic"),
                defaultvalue: "true",
                id: "obtainCompanyId",
                checked: "true"
            },
            {
                text: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:text:linkedin_premium"),
                defaultvalue: "false",
                id: "obtainCompanyId",
                checked: "false"
            }, 
        ],
        inputs: [
            (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                label: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:input:lable:company_id"),
                name: "company_id",
                placeholder: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:placeholder:company_id"),
                type: "text",
                description: "To obtain your Company ID, please refer to the guide here for step-by-step instructions on how to access and view it."
            }, "description", "obtainCompanyId"),
            {
                label: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:input:lable:contract_id"),
                name: "contract_id",
                placeholder: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:placeholder:contract_id"),
                type: "text",
                description: "obtainContractId"
            }, 
        ]
    },
    totalJobsModal: {
        heading: "Authentication",
        description: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:descriptionTotalJob"),
        inputs: [
            {
                label: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:input:lable:total_job_username"),
                name: "user_name",
                type: "text",
                placeholder: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:placeholder:total_job_username"),
                tooltip: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:tooltip:totaljob_username")
            },
            {
                label: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:input:lable:password"),
                name: "password",
                type: "password",
                placeholder: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:placeholder:password"),
                tooltip: (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("modal:input_modal:tooltip:totaljob_password")
            }, 
        ]
    },
    modalMap: {
        "CV-Library Paid": "cvLibraryPaid",
        "Indeed": "indeed",
        "LinkedIn Jobs": "linkedInJobs",
        "Total Jobs": "totalJobs"
    }
};
function integrationValidationSchema(isAccountConnected, connectModal, selectedRadio) {
    if (connectModal === "indeed") {
        return _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
            company_name: _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:company_name_is_required")).nullable(true)
        });
    }
    if (selectedRadio === "false") {
        return _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
            company_id: _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:company_id_is_required")).nullable(),
            contract_id: _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:contract_id_is_required")).when([], {
                is: function() {
                    return isAccountConnected;
                },
                then: _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:contract_id_is_required")).nullable(),
                otherwise: _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().nullable()
            })
        });
    }
    if (connectModal === "totalJobs") {
        return _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
            user_name: _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:totaljob_username_required")).nullable(true),
            password: _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:password_is_required")).nullable(true)
        });
    }
    return _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
        company_id: _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:company_id_is_required")).nullable()
    });
}
function customCompnayIntegrationValidation() {
    var a = {
        custom_integration: _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
            name: _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")).nullable(true),
            domain: _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")).matches(DomainMatch, (0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:invalid_domain")),
            category: _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required"))
        })
    };
    var CUSTOM_COMPANY_INTEGRATION_VALIDATION = _imports_files_components_model_custom_company_integration_modal_js__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object(a);
    return CUSTOM_COMPANY_INTEGRATION_VALIDATION;
}


/***/ }),

/***/ 79300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ REVIEW_EMAIL; }
/* harmony export */ });
/* unused harmony export CANDIDATE_DATE_INITIAL_VALUES */
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96047);

var REVIEW_EMAIL = {
    dummyTokens: [
        {
            text: "name.first",
            value: "{{name.first}}"
        },
        {
            text: "name.last",
            value: "{{name.last}}"
        },
        {
            text: "name.full",
            value: "{{name.full}}"
        },
        {
            text: "email.home",
            value: "{{email.home}}"
        },
        {
            text: "email.work",
            value: "{{email.work}}"
        }
    ],
    texts: {
        close: "Close",
        email_body: "Email Body",
        edit_heading: "Edit Template",
        create_heading: "Create New Template",
        insert_token: "Insert token",
        save: "Save",
        cancel: "Cancel",
        reset: "Reset",
        subject: "Subject",
        tag_heading: "Data Tags",
        purpose: "Purpose",
        custom_purpose: "New Purpose"
    },
    email_template: {
        formInitialValue: {
            template: {
                master_template_id: "",
                master_template_type: "",
                subject: "",
                email_body: "",
                default: false
            }
        },
        formValidation: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
            template: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
                master_template_id: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")),
                subject: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")),
                email_body: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required"))
            })
        })
    }
};
var CANDIDATE_DATE_INITIAL_VALUES = {
    radioTabTest: "",
    start_date: "",
    end_date: ""
};


/***/ }),

/***/ 67212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cj": function() { return /* binding */ QUESTIONS; },
/* harmony export */   "Hh": function() { return /* binding */ add_candidate_initial_values; },
/* harmony export */   "T1": function() { return /* binding */ VALIDATION_SCHEMA; },
/* harmony export */   "p9": function() { return /* binding */ validationSchema; }
/* harmony export */ });
/* unused harmony exports APPLICATION_FILE_SIZE_LIMIT, CV_FILE_EXTENSIONS, OTHER_FILE_EXTENSIONS, INITIAL_VALUES */
/* harmony import */ var _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83813);

var phoneRegex = /^\+?[\d\s]+$/;
var APPLICATION_FILE_SIZE_LIMIT = 25000000;
var CV_FILE_EXTENSIONS = (/* unused pure expression or super */ null && ([
    "pdf",
    "doc",
    "docx",
    "rtf",
    "ppt"
]));
var OTHER_FILE_EXTENSIONS = (/* unused pure expression or super */ null && ([
    "pdf",
    "doc",
    "docx",
    "rtf",
    "ppt",
    "jpeg",
    "jpg",
    "png"
]));
var INITIAL_VALUES = {
    client_candidate: {
        name: "",
        email: "",
        contact_no: "",
        location: "",
        assign: "",
        sourced_option: "",
        agency_id: "",
        agency_user_email: "",
        social_media_detail_attributes: {
            linkedin_url: "",
            portfolio_url: ""
        },
        resume_attributes: {
            file_id: "",
            file_type: "",
            file: "",
            file_name: "",
            _destroy: false
        },
        other_files_attributes: [],
        agency_domain: "",
        introduction: ""
    }
};
function validationSchema(agencyUsers) {
    return _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
        client_candidate: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
            // name: Yup.string().required(TRANSLATION('errors:required')),
            first_name: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")),
            last_name: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")),
            contact_no: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().matches(phoneRegex, (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:no_special_char")).min(8, (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:contact_short")).max(20, (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:contact_long")),
            email: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")).email((0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:invalid_email")),
            social_media_detail_attributes: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
                linkedin_url: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:invalid_url")),
                portfolio_url: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:invalid_url"))
            }),
            resume_attributes: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
                file_name: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string()
            }),
            sourced_option: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string(),
            // agency_domain: Yup.string()
            agency_id: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when("sourced_option", {
                is: function(sourced_option) {
                    return sourced_option == "Agency";
                },
                then: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")).nullable(),
                otherwise: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().notRequired()
            }),
            agency_user_email: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when([
                "sourced_option"
            ], {
                is: function(sourced_option) {
                    return sourced_option == "Agency";
                },
                then: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")).email((0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:invalid_email")).nullable().test("user_email_issue", "errors:email_select_from_dropdown", function(value) {
                    if (value) {
                        return agencyUsers.find(function(x) {
                            return x.email == value;
                        });
                    } else {
                        return true;
                    }
                }),
                otherwise: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().notRequired()
            }),
            job_board_integration_attributes: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().when("sourced_option", {
                is: function(sourced_option) {
                    return [
                        "Job Board",
                        "Social"
                    ].includes(sourced_option);
                },
                then: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
                    _destroy: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.boolean */ .sm.boolean(),
                    integration_id: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().nullable(true).required((0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required"))
                })
            })
        })
    });
}
var add_candidate_initial_values = function() {
    return {
        client_candidate: {
            name: "",
            first_name: "",
            last_name: "",
            email: "",
            contact_no: "",
            location: "",
            assign: "",
            sourced_option: "",
            agency_id: "",
            agency_user_email: "",
            social_media_detail_attributes: {
                linkedin_url: "",
                portfolio_url: ""
            },
            resume_attributes: {
                file_id: "",
                file_type: "",
                file: "",
                file_name: "",
                _destroy: false
            },
            other_files_attributes: [],
            agency_domain: "",
            job_board_integration_attributes: {
                integration_id: "",
                integration_type: "Integration"
            },
            introduction: ""
        }
    };
};
var QUESTIONS = [
    {
        question: "Tell us more about the candidate?",
        duration: 120,
        description: "",
        attempts: 3
    }
];
var VALIDATION_SCHEMA = function(t) {
    return _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
        client_candidate: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
            // name: Yup.string().required(TRANSLATION('errors:required')),
            first_name: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required(t("errors:required")),
            last_name: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required(t("errors:required")),
            contact_no: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().matches(phoneRegex, t("errors:no_special_char")).min(8, t("errors:contact_short")).max(20, t("errors:contact_long")),
            email: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required(t("errors:required")).email(t("errors:invalid_email")),
            social_media_detail_attributes: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
                linkedin_url: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, "Please enter correct url"),
                portfolio_url: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, "Please enter correct url")
            }),
            resume_attributes: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
                file_name: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string()
            }),
            sourced_option: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string(),
            agency_domain: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string(),
            agency_id: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when("sourced_option", {
                is: function(sourced_option) {
                    return sourced_option == "Agency";
                },
                then: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required(t("errors:required")).nullable(),
                otherwise: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().notRequired()
            }),
            agency_user_email: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when([
                "sourced_option",
                "agency_domain"
            ], {
                is: function(sourced_option, agency_domain) {
                    return sourced_option == "Agency";
                },
                then: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required(t("errors:required")).email(t("errors:invalid_email")).nullable().test("user_domain_issue", "User domain should match with agency domain", function(value) {
                    if (value) {
                        var agency_domain = this.parent.agency_domain;
                        var user_email_domain = value === null || value === void 0 ? void 0 : value.split("@")[1];
                        var user_domain = user_email_domain === null || user_email_domain === void 0 ? void 0 : user_email_domain.split(".")[0];
                        return user_domain == agency_domain;
                    } else {
                        return true;
                    }
                }),
                otherwise: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().notRequired()
            })
        })
    });
};


/***/ }),

/***/ 88755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N7": function() { return /* binding */ INITIAL_VALUES; }
/* harmony export */ });
/* unused harmony exports DEFAULT_HEADING, DEFAULT_SUBHEADING */
var DEFAULT_HEADING = "Lorem ipsum dolor sit amet";
var DEFAULT_SUBHEADING = "We’re looking for great people to join our growing team.";
var INITIAL_VALUES = {
    search_text: "",
    location_text: "",
    job_type: "",
    remote: false
};


/***/ }),

/***/ 63421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ COMMUNICATIONS; }
/* harmony export */ });
/* harmony import */ var _imports_files_pages_clients_company_add_members__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43862);

var COMMUNICATIONS = function(t) {
    return {
        action_options: {
            mark_as_read: {
                title: t("datatable:actions:mark_as_read")
            },
            mark_as_unread: {
                title: t("datatable:actions:mark_as_unread")
            },
            dismiss: {
                title: t("datatable:actions:delete")
            }
        },
        email_action_options: {
            reply_all: {
                title: t("datatable:actions:reply_all")
            },
            forward: {
                title: t("datatable:actions:forward")
            },
            delete: {
                title: t("datatable:actions:delete")
            }
        }
    };
};


/***/ }),

/***/ 78421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kz": function() { return /* binding */ CANDIDATE_GENERAL_PROFILE_INITIAL_VALUES; },
/* harmony export */   "RF": function() { return /* binding */ CANDIDATE_THOUGHTS_INITIAL_VALUES; },
/* harmony export */   "TD": function() { return /* binding */ candidateProfileValidationSchema; },
/* harmony export */   "cK": function() { return /* binding */ CANDIDATE_THOUGHTS_VALIDATION_SCHEMA; },
/* harmony export */   "dC": function() { return /* binding */ CANDIDATE_PROFILE_INITIAL_VALUES; },
/* harmony export */   "xB": function() { return /* binding */ candidateGeneralProfileValidationSchema; }
/* harmony export */ });
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96047);

var phoneRegex = /^\+?[\d\s]+$/;
var CANDIDATE_PROFILE_INITIAL_VALUES = {
    job_application: {
        client_candidate_attributes: {
            email: "",
            location_attributes: {
                full_address: ""
            },
            social_media_detail_attributes: {
                linkedin_url: ""
            }
        }
    },
    applied_date: "",
    current_job_title: "",
    contact_no: "",
    location: "",
    salary: "",
    sourced_option: "",
    availability: "",
    referral: "",
    agency_email: ""
};
var CANDIDATE_GENERAL_PROFILE_INITIAL_VALUES = {
    client_candidate: {
        email: "",
        location_attributes: {
            full_address: ""
        },
        social_media_detail_attributes: {
            linkedin_url: ""
        },
        applied_date: "",
        current_job_title: "",
        contact_no: "",
        location: "",
        salary: "",
        sourced_option: "",
        availability: "",
        referral: "",
        agency_email: ""
    }
};
function candidateProfileValidationSchema(agencyUsers, disabledArray) {
    return _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
        job_application: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
            client_candidate_attributes: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
                first_name: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when([], {
                    is: function() {
                        return !(disabledArray === null || disabledArray === void 0 ? void 0 : disabledArray.includes("first_name"));
                    },
                    then: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")),
                    otherwise: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().notRequired()
                }),
                last_name: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when([], {
                    is: function() {
                        return !(disabledArray === null || disabledArray === void 0 ? void 0 : disabledArray.includes("last_name"));
                    },
                    then: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")),
                    otherwise: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().notRequired()
                }),
                email: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when([], {
                    is: function() {
                        return !(disabledArray === null || disabledArray === void 0 ? void 0 : disabledArray.includes("email"));
                    },
                    then: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")).email((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:invalid_email")),
                    otherwise: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().notRequired()
                }),
                location_attributes: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
                    full_address: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string()
                }),
                social_media_detail_attributes: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
                    linkedin_url: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, (0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:invalid_url"))
                })
            }),
            contact_no: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().matches(phoneRegex, (0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:no_special_char")).min(8, "errors:contact_short").max(20, "errors:contact_long").nullable(true),
            // This error message should be change
            salary: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().matches(phoneRegex, (0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:no_special_char")),
            availability: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string(),
            agency_email: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().email((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:invalid_email")),
            sourced_option: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string(),
            agency_id: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when("sourced_option", {
                is: function(sourced_option) {
                    return sourced_option == "Agency";
                },
                then: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")).nullable(),
                otherwise: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().notRequired()
            }),
            agency_user_email: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when([
                "sourced_option"
            ], {
                is: function(sourced_option) {
                    return sourced_option == "Agency";
                },
                then: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")).email((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:invalid_email")).nullable().test("user_email_issue", "errors:email_select_from_dropdown", function(value) {
                    if (value) {
                        return agencyUsers.find(function(x) {
                            return x.email == value;
                        });
                    } else {
                        return true;
                    }
                }),
                otherwise: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().notRequired()
            }),
            job_board_integration_attributes: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().when("sourced_option", {
                is: function(sourced_option) {
                    return [
                        "Job Board",
                        "Social"
                    ].includes(sourced_option);
                },
                then: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
                    _destroy: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.boolean */ .sm.boolean(),
                    integration_id: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().nullable(true).required((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required"))
                })
            })
        })
    });
}
function candidateGeneralProfileValidationSchema(agencyUsers) {
    return _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
        client_candidate: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
            email: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")).email((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:invalid_email")),
            location_attributes: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
                full_address: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string()
            }),
            social_media_detail_attributes: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
                linkedin_url: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, (0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:invalid_url"))
            }),
            contact_no: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().matches(phoneRegex, (0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:no_special_char")).min(8, "errors:contact_short").max(20, "errors:contact_long").nullable(true),
            // This error message should be change
            salary: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().matches(phoneRegex, (0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:no_special_char")),
            availability: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string(),
            agency_email: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().email((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:invalid_email")),
            sourced_option: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string(),
            agency_id: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when("sourced_option", {
                is: function(sourced_option) {
                    return sourced_option == "Agency";
                },
                then: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")).nullable(),
                otherwise: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().notRequired()
            }),
            agency_user_email: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when([
                "sourced_option"
            ], {
                is: function(sourced_option) {
                    return sourced_option == "Agency";
                },
                then: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")).email((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:invalid_email")).nullable().test("user_email_issue", "errors:email_select_from_dropdown", function(value) {
                    if (value) {
                        return agencyUsers.find(function(x) {
                            return x.email == value;
                        });
                    } else {
                        return true;
                    }
                }),
                otherwise: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().notRequired()
            }),
            job_board_integration_attributes: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().when("sourced_option", {
                is: function(sourced_option) {
                    return [
                        "Job Board",
                        "Social"
                    ].includes(sourced_option);
                },
                then: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
                    _destroy: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.boolean */ .sm.boolean(),
                    integration_id: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().nullable(true).required((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required"))
                })
            })
        })
    });
}
var CANDIDATE_THOUGHTS_INITIAL_VALUES = {
    message: "",
    private: false
};
var CANDIDATE_THOUGHTS_VALIDATION_SCHEMA = function() {
    return _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
        message: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required"))
    });
};


/***/ }),

/***/ 32042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$J": function() { return /* binding */ getInitalValues; },
/* harmony export */   "Ek": function() { return /* binding */ getEditInitalValues; },
/* harmony export */   "iI": function() { return /* binding */ getValidationSchema; }
/* harmony export */ });
/* harmony import */ var _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13245);


function getInitalValues(interviewTypes, stageTypes, jobOwner, router, current_step, t) {
    // const jobId = router.query.job_id
    // const jobId  = window.location.pathname.split('/').slice(-2)[0];
    var jobId = new _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .DataFromUrl */ .QJ().getJobId();
    var intialValue = {
        job: {
            id: jobId,
            step: current_step,
            job_stages_attributes: [
                {
                    stage_id: stageTypes.filter(function(e) {
                        return e.name == _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .JOB_STAGES.APPLIED */ .eP.APPLIED;
                    })[0].id,
                    interview_type_id: "",
                    _destroy: false,
                    member_emails: [],
                    member_initials: [],
                    editable_deletable: false
                },
                {
                    stage_id: stageTypes.filter(function(e) {
                        return e.name == _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .JOB_STAGES.SCREENING */ .eP.SCREENING;
                    })[0].id,
                    interview_type_id: "",
                    _destroy: false,
                    stage_emails: "",
                    job_stage_label_attributes: {
                        label: ""
                    },
                    placeholder: t("placeholder:shortlist"),
                    member_emails: [],
                    member_initials: [],
                    editable_deletable: true,
                    date_id: Date.now(),
                    automation: false
                },
                {
                    stage_id: stageTypes.filter(function(e) {
                        return e.name == _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .JOB_STAGES.INTERVIEW */ .eP.INTERVIEW;
                    })[0].id,
                    interview_type_id: "",
                    _destroy: false,
                    stage_emails: "",
                    job_stage_label_attributes: {
                        label: ""
                    },
                    placeholder: t("placeholder:interview"),
                    member_emails: [],
                    member_initials: [],
                    editable_deletable: true,
                    date_id: Date.now(),
                    automation: false
                },
                {
                    stage_id: stageTypes.filter(function(e) {
                        return e.name == _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .JOB_STAGES.OFFERED */ .eP.OFFERED;
                    })[0].id,
                    interview_type_id: "",
                    _destroy: false,
                    member_emails: [],
                    member_initials: [],
                    editable_deletable: false
                },
                {
                    stage_id: stageTypes.filter(function(e) {
                        return e.name == _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .JOB_STAGES.HIRED */ .eP.HIRED;
                    })[0].id,
                    interview_type_id: "",
                    _destroy: false,
                    member_emails: [],
                    member_initials: [],
                    editable_deletable: false
                }
            ]
        }
    };
    return intialValue;
}
function getEditInitalValues(job, current_step) {
    var job_stages_attributes = job.job_stages_attributes.map(function(x) {
        if ([
            _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .JOB_STAGES.SCREENING */ .eP.SCREENING,
            _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .JOB_STAGES.INTERVIEW */ .eP.INTERVIEW
        ].includes(x.stage)) {
            var interview_stage = {
                id: x.id,
                stage_id: x.stage_id,
                job_id: x.job_id,
                interview_type_id: x.interview_type_id,
                _destroy: false,
                member_emails: x.members.map(function(x) {
                    return x.email;
                }),
                member_initials: x.members.map(function(x) {
                    return {
                        email: x.email,
                        name_initials: x.name_initials,
                        name: x.name,
                        photo_url: x.photo_url
                    };
                }),
                job_stage_label_attributes: x.job_stage_label_attributes,
                editable_deletable: x.editable_deletable || false,
                automation: x.automation
            };
            if (!interview_stage.job_stage_label_attributes) {
                interview_stage.job_stage_label_attributes = {
                    label: "Interview"
                };
            }
            return interview_stage;
        } else {
            return {
                id: x.id,
                stage_id: x.stage_id,
                job_id: x.job_id,
                interview_type_id: x.interview_type_id,
                _destroy: false,
                member_emails: x.members.map(function(x) {
                    return x.email;
                }),
                member_initials: x.members.map(function(x) {
                    return {
                        email: x.email,
                        name_initials: x.name_initials,
                        name: x.name,
                        photo_url: x.photo_url
                    };
                }),
                editable_deletable: x.editable_deletable || false,
                automation: x.automation
            };
        }
    });
    return {
        job: {
            step: current_step,
            job_stages_attributes: job_stages_attributes
        }
    };
}
function getValidationSchema(interviewTypes, stageTypes, submitState, job_status) {
    var ref, ref1;
    var validationRequired = !(submitState == "draft" || submitState == "preview" && job_status != "active");
    var screeningTypeId = (ref = stageTypes.filter(function(e) {
        return e.name == _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .JOB_STAGES.SCREENING */ .eP.SCREENING;
    })[0]) === null || ref === void 0 ? void 0 : ref.id;
    var interviewTypeId = (ref1 = stageTypes.filter(function(e) {
        return e.name == _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .JOB_STAGES.INTERVIEW */ .eP.INTERVIEW;
    })[0]) === null || ref1 === void 0 ? void 0 : ref1.id;
    var validationSchema = _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
        job: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
            job_stages_attributes: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.array */ .sm.array().of(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
                stage_id: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")),
                _destroy: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.boolean */ .sm.boolean(),
                placeholder: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string(),
                job_stage_label_attributes: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().when([
                    "stage_id",
                    "_destroy",
                    "placeholder"
                ], {
                    is: function(stage_id, _destroy, placeholder) {
                        return !_destroy && validationRequired && [
                            interviewTypeId === null || interviewTypeId === void 0 ? void 0 : interviewTypeId.toString(),
                            screeningTypeId === null || screeningTypeId === void 0 ? void 0 : screeningTypeId.toString()
                        ].includes(stage_id) && !((placeholder === null || placeholder === void 0 ? void 0 : placeholder.length) > 0);
                    },
                    then: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
                        label: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")).nullable(true)
                    })
                })
            }))
        })
    });
    return validationSchema;
}


/***/ }),

/***/ 42588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Il": function() { return /* binding */ getEditInitalOptionValues; },
/* harmony export */   "iI": function() { return /* binding */ getValidationSchema; }
/* harmony export */ });
/* unused harmony export getInitalValues */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38641);
/* harmony import */ var _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64547);


function getInitalValues(jobOwner, router, current_step) {
    var jobId = new DataFromUrl().getJobId();
    var intialValue = {
        job: {
            id: jobId,
            step: current_step
        }
    };
    return intialValue;
}
function getEditInitalOptionValues(job, current_step) {
    var approvers = [];
    var job_approvers = {};
    if (job.approvers.emails) {
        approvers = job.approvers;
        job_approvers.emails = approvers.emails;
        job_approvers.initials = approvers.initials;
        job_approvers.required_approvers = job.required_approvers;
    } else if (job.approvers) {
        approvers = job.approvers;
        job_approvers.emails = approvers.map(function(x) {
            return x.email;
        });
        job_approvers.initials = approvers;
        job_approvers.required_approvers = job.required_approvers;
    } else {
        job_approvers = {
            emails: new Array(),
            initials: new Array(),
            required_approvers: ""
        };
    }
    var _obj;
    return {
        job: (_obj = {
            id: job.id,
            step: current_step,
            hide_hiring: job.hide_hiring,
            hide_hiring_editable: job.hide_hiring_editable,
            daxtra_threshold: job.daxtra_threshold,
            hiring_manager_initials: job.hiring_manager_initials,
            job_owner_emails: job.job_owner_initials.map(function(x) {
                return x.email;
            }),
            job_owner_initials: job.job_owner_initials
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "job_owner_emails", job.job_owner_initials.map(function(x) {
            return x.email;
        })), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "hiring_manager_emails", job.hiring_manager_initials.map(function(x) {
            return x.email;
        })), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "screening_questions_attributes", job.screening_questions_attributes), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "approvers", job_approvers), _obj)
    };
}
function getValidationSchema(submitState, job_status) {
    var validationRequired = !(submitState == "draft" || submitState == "preview" && job_status != "active");
    if (validationRequired) {
        return _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
            job: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
                //daxtra_threshold: Yup.number().required(TRANSLATION('errors:value_greater_or_equal_one')).min(1, TRANSLATION('errors:value_greater_or_equal_one')).max(100, TRANSLATION('errors:value_less_or_equal_hundred')),
                job_owner_emails: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.array */ .sm.array().min(1, (0,_imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:owner_required")),
                approvers: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
                    emails: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.array */ .sm.array(),
                    required_approvers: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when("emails", {
                        is: function(emails) {
                            return emails.length > 0;
                        },
                        then: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required"))
                    })
                }),
                screening_questions_attributes: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.array */ .sm.array().of(_imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
                    _destroy: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.boolean */ .sm.boolean(),
                    mandatory: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.boolean */ .sm.boolean(),
                    option_mandatory: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.boolean */ .sm.boolean(),
                    question: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when("_destroy", {
                        is: function(_destroy) {
                            return !_destroy;
                        },
                        then: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().nullable(true).required((0,_imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:enter_queston"))
                    }),
                    question_type_id: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when("_destroy", {
                        is: function(_destroy) {
                            return !_destroy;
                        },
                        then: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().nullable(true).required((0,_imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:select_answer_type"))
                    }),
                    question_type_name: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string(),
                    question_options_attributes: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.array */ .sm.array().when([
                        "_destroy",
                        "option_mandatory"
                    ], {
                        is: function(_destroy, option_mandatory) {
                            return !_destroy && option_mandatory;
                        },
                        then: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.array */ .sm.array().of(_imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
                            _destroy: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.boolean */ .sm.boolean(),
                            option: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when("_destroy", {
                                is: function(_destroy) {
                                    return !_destroy;
                                },
                                then: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().nullable(true).required((0,_imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:add_anwser_option")),
                                otherwise: _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().notRequired()
                            })
                        }))
                    })
                }))
            })
        });
    } else {
        return _imports_files_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({});
    }
}


/***/ }),

/***/ 51560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z9": function() { return /* binding */ ACTION_OPTIONS; },
/* harmony export */   "sm": function() { return /* binding */ JOB_FILTER_LOCALSTORAGE_KEY; },
/* harmony export */   "wY": function() { return /* binding */ INITIAL_FILTER_VALUE; }
/* harmony export */ });
/* unused harmony exports DATA_TABLE_INITIAL_FILTER_VALUE, DATA_TABLE_FILTER_LOCALSTORAGE_KEY */
/* harmony import */ var _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44791);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73732);


var ACTION_OPTIONS = function() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$)().t;
    return {
        "edit_job": {
            allowed_user: [
                "Administrator",
                "client_admin",
                "account_owner",
                "client_user"
            ],
            link: _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT.client.jobs.edit */ .RQ.client.jobs.edit,
            tab_name: [
                "active",
                "draft"
            ],
            title: t("datatable:actions:edit"),
            visble_in_all_jobs: false
        },
        "duplicate_job": {
            allowed_user: [
                "Administrator",
                "client_admin",
                "account_owner",
                "client_user"
            ],
            link: _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT.client.jobs.edit */ .RQ.client.jobs.edit,
            tab_name: [
                "active",
                "archived"
            ],
            title: t("datatable:actions:duplicate"),
            visble_in_all_jobs: true
        },
        "promote": {
            allowed_user: [
                "Administrator",
                "client_admin",
                "account_owner",
                "client_user"
            ],
            link: _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT.client.jobs.job_sharing */ .RQ.client.jobs.job_sharing,
            tab_name: [
                "active"
            ],
            title: t("datatable:actions:promote"),
            visble_in_all_jobs: false
        },
        "copy_job_url": {
            allowed_user: [
                "Administrator",
                "client_admin",
                "account_owner",
                "client_user",
                "reviewer"
            ],
            title: t("datatable:actions:copy_job"),
            link: "".concat(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT.client.jobs.view_job */ .RQ.client.jobs.view_job, "?q=desc"),
            tab_name: [
                "active"
            ],
            visble_in_all_jobs: true
        },
        "close_job": {
            allowed_user: [
                "Administrator",
                "client_admin",
                "account_owner",
                "client_user"
            ],
            title: t("datatable:actions:close_job"),
            tab_name: [
                "active"
            ],
            visble_in_all_jobs: false
        },
        "publish_job": {
            allowed_user: [
                "Administrator",
                "client_admin",
                "account_owner",
                "client_user"
            ],
            title: t("datatable:actions:publish"),
            tab_name: [
                "draft"
            ],
            visble_in_all_jobs: false
        },
        "delete_job": {
            allowed_user: [
                "Administrator",
                "client_admin",
                "account_owner",
                "client_user"
            ],
            title: t("datatable:actions:delete"),
            tab_name: [
                "draft"
            ],
            visble_in_all_jobs: false
        }
    };
};
// ------------------------------- This will be removed -----------------------------
var INITIAL_FILTER_VALUE = {
    "page": 1,
    "per_page": 10,
    "start_date": "",
    "end_date": "",
    "job_type": "active",
    "search_text": "",
    "col_name": "",
    "order": "",
    "all_jobs": false
};
var JOB_FILTER_LOCALSTORAGE_KEY = "jobFiltersData";
// ------------------------------- This will be removed -----------------------------
// -------------------------------
var DATA_TABLE_INITIAL_FILTER_VALUE = {
    "job_listing": {
        "start_date": "",
        "end_date": "",
        "location": "",
        "job_type": "active",
        "search_text": "",
        "col_name": "",
        "order": "",
        "all_jobs": false,
        "active": {
            "page": 1,
            "per_page": 10
        },
        "draft": {
            "page": 1,
            "per_page": 10
        },
        "archived": {
            "page": 1,
            "per_page": 10
        }
    },
    "candidate_listing": {
        "date_choice": "",
        "location": "",
        "col_name": "",
        "order": "",
        "skill": "",
        "page": 1,
        "per_page": 10,
        "start_date": "",
        "end_date": ""
    }
};
var DATA_TABLE_FILTER_LOCALSTORAGE_KEY = "dataTableFiltersData";


/***/ }),

/***/ 40682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N7": function() { return /* binding */ INITIAL_VALUES; },
/* harmony export */   "ZX": function() { return /* binding */ job_competency_initials; },
/* harmony export */   "iI": function() { return /* binding */ getValidationSchema; },
/* harmony export */   "mO": function() { return /* binding */ job_competency_attr_hash; },
/* harmony export */   "nb": function() { return /* binding */ scorecard_config_initials; },
/* harmony export */   "sn": function() { return /* binding */ JOB_SUB_COMPETENCIES_COMPETENCY_ATTRIBUTES_HASH; }
/* harmony export */ });
/* unused harmony exports SCORECARD_CONFIG_ATTRIBUTES_HASH, JOB_COMPETENCY_ATTRIBUTES_HASH */
/* harmony import */ var _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96726);

function scorecard_config_initials() {
    return SCORECARD_CONFIG_ATTRIBUTES_HASH;
}
function job_competency_initials() {
    return JOB_COMPETENCY_ATTRIBUTES_HASH;
}
var SCORECARD_CONFIG_ATTRIBUTES_HASH = {
    job_id: "",
    link: false,
    private: false,
    scorecard_link: "",
    instructions: "",
    is_imported: false
};
var JOB_SUB_COMPETENCIES_COMPETENCY_ATTRIBUTES_HASH = {
    name: ""
};
var JOB_COMPETENCY_ATTRIBUTES_HASH = {
    _destroy: false,
    notes: "",
    name: "",
    job_sub_competencies_attributes: []
};
var INITIAL_VALUES = {
    scorecard_config_attributes: SCORECARD_CONFIG_ATTRIBUTES_HASH,
    job_competencies_attributes: [
        JOB_COMPETENCY_ATTRIBUTES_HASH
    ]
};
function job_competency_attr_hash() {
    return {
        _destroy: false,
        notes: "",
        name: "",
        job_sub_competencies_attributes: []
    };
}
function getValidationSchema(submitState, job_status) {
    var validationRequired = !(submitState == "draft" || submitState == "preview" && job_status != "active");
    return _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
        is_job_competency_visible: _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .Yup.boolean */ .sm.boolean(),
        job_competencies_attributes: _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .Yup.array */ .sm.array().of(_imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
            _destroy: _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .Yup.boolean */ .sm.boolean(),
            name: _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when("_destroy", {
                is: function(_destroy) {
                    return !_destroy && validationRequired;
                },
                then: _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")).nullable(true),
                otherwise: _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().notRequired().nullable(true)
            }),
            job_sub_competencies_attributes: _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .Yup.array */ .sm.array().of(_imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
                _destroy: _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .Yup.boolean */ .sm.boolean(),
                name: _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when("_destroy", {
                    is: function(_destroy) {
                        return !_destroy && validationRequired;
                    },
                    then: _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")).nullable(true),
                    otherwise: _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().notRequired().nullable(true)
                })
            }))
        }))
    });
}


/***/ }),

/***/ 30003:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: ROWS

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/manage-integration.js
// -------------------- Material Ui Table Components --------------

// -------------------- Material Ui Table Components --------------
// ----------------------------- COMMON ---------------------------------------

// ----------------------------- COMMON ---------------------------------------
// ----------------- Constants ---------------------

// ----------------- Constants ---------------------
// -----------------------------  CUSTOM COMPONENTS -----------------------------

// -----------------------------  CUSTOM COMPONENTS -----------------------------
// ---------------------------- Stylesheet -------------------------------------


 // ----------------------------- Stylesheet ------------------------------------

;// CONCATENATED MODULE: ./public/images/pages/integration/gmail.png
/* harmony default export */ var gmail = ({"src":"/_next/static/media/gmail.9a96987f.png","height":83,"width":329,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAACXBIWXMAAAsTAAALEwEAmpwYAAAASElEQVR4nGPYaBe3+Emy1oz1qzXyzJ17lLOyU/WT07I0QTglPceGIaPkWsuGdNMsk6VhyQWBRQaJGZmBKenZhsnp2fEpGTlBAGbgGZCBHCopAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/images/pages/integration/cronofy.png
/* harmony default export */ var cronofy = ({"src":"/_next/static/media/cronofy.a36e4959.png","height":63,"width":243,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAACXBIWXMAABuvAAAbrwFeGpEcAAAATUlEQVR4nAFCAL3/AIWamHx/nJtxc622MkDA3idVoKwndJ6iM2OrtylGw+AgAISbmXJ9nZ1pdKy1LUPB3yNsq7Ulb56jMUypuyZLxeEWMjogDyaj94AAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/images/pages/integration/slack.png
/* harmony default export */ var slack = ({"src":"/_next/static/media/slack.b9a0bbf2.png","height":58,"width":225,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAACXBIWXMAABuvAAAbrwFeGpEcAAAASUlEQVR4nAXBIQ5AAAAAwPMBSfMTgSLYdNNsNoqoCYLNFM0zJB/wAMk7vMKd/HqP4l7WiJhgRIUSDWpP1u3fmU5CCTYMmNGi/wH6VA0omq27cAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/images/pages/integration/zoom.png
/* harmony default export */ var zoom = ({"src":"/_next/static/media/zoom.5f64caf0.png","height":78,"width":276,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAACXBIWXMAACE4AAAhOAFFljFgAAAAQklEQVR4nCXGoQqAMABAwf1/thqMokmLVbCI4FgYWAyCGP2FE1l4xwvXS70yZobMdNBspfQQfqqFPtFGulR+PtlvPkOYOJGEIcWtAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/constants/pages/clients/manage-integration.js


// ---------------------------- IMAGES -----------------------------------------




// ---------------------------- IMAGES -----------------------------------------
var ROWS = [
    (0,common/* createData */.nG)("Email Account", /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Image */.Ee, {
        src: gmail,
        alt: "",
        height: 19,
        width: 26
    }), "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore  et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco", "Connect"),
    (0,common/* createData */.nG)("Calendar (Via Cronofy)", /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Image */.Ee, {
        src: cronofy,
        alt: "",
        height: 25,
        width: 97
    }), "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore  et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco", "Connect"),
    (0,common/* createData */.nG)("Slack", /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Image */.Ee, {
        src: slack,
        alt: "",
        height: 23,
        width: 90
    }), "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore  et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco", "Connect"),
    (0,common/* createData */.nG)("Zoom or Teams", /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Image */.Ee, {
        src: zoom,
        alt: "",
        height: 26,
        width: 92
    }), "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore  et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco", "Connect"), 
];


/***/ }),

/***/ 67734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ MY_ACCOUNT; }
/* harmony export */ });
/* unused harmony export QUESTIONS */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38641);
/* harmony import */ var _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80952);


var PASSWORD_FORMAT = /^(?=.*[A-Z])(?=.*\d).+$/;
var MY_ACCOUNT = {
    texts: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        heading: "My Account",
        add_btn: "Add",
        upload_button: "Upload new picture",
        label_1: "Role",
        placeholder_1: "Select Role",
        label_2: "Name",
        placeholder_2: "Name",
        label_3: "Biography",
        label_4: "Email address",
        placeholder_4: "Email address",
        label_5: "New password",
        placeholder_5: "New password",
        label_6: "Email Signature",
        optional: "Optional",
        sign_out: "Sign Out",
        save_changes: "Save Changes",
        next: "Next",
        skip: "Skip",
        label_7: "Video Biography",
        label_8: "Current password"
    }, "placeholder_5", "Current password"),
    PHOTO_SIZE: 5000000,
    VALIDATION_SCHEMA: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
        name: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")),
        email: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().email((0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:invalid_email")).required((0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")),
        password: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().nullable().min(8, (0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:short_password")).matches(PASSWORD_FORMAT, (0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:password_format"))
    })
};
var QUESTIONS = [
    {
        question: "Introduce yourself to candidates and explain why they should work for your company?",
        duration: 120,
        description: "",
        attempts: 3
    }
];


/***/ }),

/***/ 24229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ms": function() { return /* binding */ addAssessmentValidation; },
/* harmony export */   "QC": function() { return /* binding */ URL_FORMAT; },
/* harmony export */   "Sg": function() { return /* binding */ setAssessmentInitial; },
/* harmony export */   "WY": function() { return /* binding */ MANAGE_ASSESSMENT; }
/* harmony export */ });
/* harmony import */ var _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79995);

var URL_FORMAT = /^((http|https):\/\/)?[a-zA-Z0-9]+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-z]{2,}(:[0-9]{1,})?(\/.*)?$/i;
var MANAGE_ASSESSMENT = {
    file_size: 10000000,
    texts: {
        heading_1: "Manage Assessments",
        subheading: "Here you can manage the customised test templates which are to be sent to the candidates.",
        placeholder: "Search for reasons",
        button: "ADD new assessment",
        datatable: {
            column_1: "Unsuccessful Reasons",
            column_2: "Last Edited By",
            column_3: "Action"
        }
    },
    manageAssessmentOptions: {
        "edit": {
            title: "Edit"
        },
        "delete": {
            title: "Delete"
        }
    },
    assessmentForm: {
        formInitials: {
            reason: ""
        },
        formDefault: {
            reason: ""
        },
        formValidation: _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
            reason: _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("HGH")).max(50, (0,_imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:max_50_char_error"))
        }),
        texts: {
            heading: "Add New Reason",
            add_heading: "Add Assessment",
            edit_heading: "Edit Assessment",
            label: "Reason",
            placeholder: "Write here",
            close_button: "Close",
            button_1: "Cancel",
            button_2: "Submit"
        }
    },
    delete_reason_modal: {
        message: "Deleting this assessment template will also remove it from all the associated jobs. Do you wish to proceed?",
        action_button: "Delete"
    },
    assessment_initials: {
        name: "",
        file_type: "link",
        link: "",
        file: "",
        filename: ""
    }
};
function addAssessmentValidation() {
    var assessment_validation = {
        name: _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")),
        file_type: _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")),
        link: _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when("file_type", {
            is: function(file_type) {
                return file_type == "link";
            },
            then: _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().matches(URL_FORMAT, (0,_imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:assessment_link_invalid")),
            otherwise: _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().notRequired()
        }),
        filename: _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when("file_type", {
            is: function(file_type) {
                return file_type == "file";
            },
            then: _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string(),
            otherwise: _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().notRequired()
        }),
        filesize: _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when("file_type", {
            is: function(file_type) {
                return file_type == "file";
            },
            then: _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().test("is-greater", (0,_imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:max_file_size"), function(value) {
                var currentFileSize = parseInt(value) || 0;
                return currentFileSize < MANAGE_ASSESSMENT.file_size;
            }),
            otherwise: _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().notRequired()
        })
    };
    var ASSESSMENT_VALIDATION = _imports_files_pages_clients_recruitments_unsuccessful_reasons__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object(assessment_validation);
    return ASSESSMENT_VALIDATION;
}
var setAssessmentInitial = function(action, currentRow) {
    if (action == "create") {
        return {
            name: "",
            file_type: "link",
            link: "",
            file: "",
            filename: "",
            filesize: ""
        };
    } else {
        return {
            id: currentRow.id,
            name: currentRow.name,
            file_type: currentRow.file_type,
            link: currentRow.file_type == "link" ? currentRow.file_or_link : "",
            file: "",
            filename: currentRow.file_name || "",
            filesize: ""
        };
    }
};


/***/ }),

/***/ 47582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A6": function() { return /* binding */ submitAnswerInitialValues; },
/* harmony export */   "Yv": function() { return /* binding */ OTHER_FILE_EXTENSIONS; },
/* harmony export */   "fL": function() { return /* binding */ CV_FILE_EXTENSIONS; },
/* harmony export */   "lH": function() { return /* binding */ submitAnswerSchema; },
/* harmony export */   "lg": function() { return /* binding */ applyJobInitialValues; },
/* harmony export */   "tN": function() { return /* binding */ APPLICATION_FILE_SIZE_LIMIT; },
/* harmony export */   "uS": function() { return /* binding */ viewJobValidation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38641);
/* harmony import */ var _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83813);


var phoneRegex = /^\+?[\d\s]+$/;
var APPLICATION_FILE_SIZE_LIMIT = 25000000;
var CV_FILE_EXTENSIONS = [
    "pdf",
    "doc",
    "docx",
    "rtf",
    "ppt"
];
var OTHER_FILE_EXTENSIONS = [
    "pdf",
    "doc",
    "docx",
    "rtf",
    "ppt",
    "jpeg",
    "jpg",
    "png"
];
function applyJobInitialValues(job) {
    var _obj;
    return {
        job_application: (_obj = {
            candidate_linkedin_url: "",
            portfolio_url: "",
            first_name: "",
            last_name: "",
            email: "",
            contact_no: "",
            terms_accepted: false,
            social_media_detail: "",
            without_cv: false,
            resume_attributes: {
                file_type: "",
                file: "",
                file_name: ""
            },
            job_application_files_attributes: []
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "without_cv", job.without_cv), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "screening_answers_attributes", job.screening_questions_attributes.map(function(question, question_index) {
            return {
                text: "",
                screening_question_id: question.id,
                options: [],
                question_type_name: question.question_type_name,
                mandatory: question.mandatory
            };
        })), _obj)
    };
}
function viewJobValidation() {
    var viewJobValidation = {
        job_application: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
            without_cv: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.boolean */ .sm.boolean(),
            candidate_linkedin_url: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:invalid_url")),
            portfolio_url: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:invalid_url")),
            first_name: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")),
            last_name: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")),
            contact_no: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().matches(phoneRegex, (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:no_special_char")).min(8, (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:contact_short")).max(20, (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:contact_long")).required((0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")),
            email: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().email((0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:invalid_email")).required((0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")),
            social_media_detail: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:invalid_url")),
            terms_accepted: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.boolean */ .sm.boolean().required((0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:t&c_accept")).oneOf([
                true
            ], (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:t&c_accept")),
            resume_attributes: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().when("without_cv", {
                is: false,
                then: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
                    file_name: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required"))
                })
            }),
            screening_answers_attributes: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.array */ .sm.array().of(_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
                mandatory: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.boolean */ .sm.boolean(),
                question_type_name: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string(),
                text: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when([
                    "mandatory",
                    "question_type_name"
                ], {
                    is: function(mandatory, question_type_name) {
                        return mandatory && [
                            _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.SINGLE_LINE */ .j$.SINGLE_LINE,
                            _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.MULTIPLE_LINE */ .j$.MULTIPLE_LINE
                        ].includes(question_type_name);
                    },
                    then: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")).nullable(true)
                }),
                options: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.array */ .sm.array().when([
                    "mandatory",
                    "question_type_name"
                ], {
                    is: function(mandatory, question_type_name) {
                        return mandatory && [
                            _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.SINGLE_CHOICE */ .j$.SINGLE_CHOICE,
                            _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.YES_NO */ .j$.YES_NO,
                            _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.MULTIPLE_CHOICE */ .j$.MULTIPLE_CHOICE
                        ].includes(question_type_name);
                    },
                    then: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.array */ .sm.array().min(1, (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")),
                    otherwise: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.array */ .sm.array().notRequired()
                })
            }))
        })
    };
    var VALIDATION_SCHEMA = _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape(viewJobValidation);
    return VALIDATION_SCHEMA;
}
function submitAnswerInitialValues(job, candidate_detail) {
    return {
        job_application: {
            id: candidate_detail.job_application_id,
            screening_answers_attributes: job.screening_questions_attributes.map(function(question, question_index) {
                return {
                    text: "",
                    screening_question_id: question.id,
                    options: [],
                    question_type_name: question.question_type_name,
                    mandatory: question.mandatory
                };
            })
        }
    };
}
function submitAnswerSchema() {
    return _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
        job_application: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object().shape({
            screening_answers_attributes: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.array */ .sm.array().of(_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.object */ .sm.object({
                mandatory: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.boolean */ .sm.boolean(),
                question_type_name: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string(),
                text: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().when([
                    "mandatory",
                    "question_type_name"
                ], {
                    is: function(mandatory, question_type_name) {
                        return mandatory && [
                            _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.SINGLE_LINE */ .j$.SINGLE_LINE,
                            _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.MULTIPLE_LINE */ .j$.MULTIPLE_LINE
                        ].includes(question_type_name);
                    },
                    then: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")).nullable(true)
                }),
                options: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.array */ .sm.array().when([
                    "mandatory",
                    "question_type_name"
                ], {
                    is: function(mandatory, question_type_name) {
                        return mandatory && [
                            _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.SINGLE_CHOICE */ .j$.SINGLE_CHOICE,
                            _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.YES_NO */ .j$.YES_NO,
                            _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .QUESTION_TYPES.MULTIPLE_CHOICE */ .j$.MULTIPLE_CHOICE
                        ].includes(question_type_name);
                    },
                    then: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.array */ .sm.array().min(1, (0,_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .TRANSLATION */ .TA)("errors:required")),
                    otherwise: _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .Yup.array */ .sm.array().notRequired()
                })
            }))
        })
    });
}


/***/ }),

/***/ 57773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E6": function() { return /* binding */ setJobFilter; },
/* harmony export */   "oX": function() { return /* binding */ getJobFilter; }
/* harmony export */ });
/* unused harmony export clearJobFilter */
/* harmony import */ var _constants_pages_clients_jobs_jobs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51560);

// helper to get user from localstorage
function getJobFilter() {
    if (true) {
        var storedUser = localStorage.getItem(_constants_pages_clients_jobs_jobs__WEBPACK_IMPORTED_MODULE_0__/* .JOB_FILTER_LOCALSTORAGE_KEY */ .sm);
        if (storedUser == "undefined" || storedUser == null) {
            setJobFilter(_constants_pages_clients_jobs_jobs__WEBPACK_IMPORTED_MODULE_0__/* .INITIAL_FILTER_VALUE */ .wY);
            storedUser = localStorage.getItem(_constants_pages_clients_jobs_jobs__WEBPACK_IMPORTED_MODULE_0__/* .JOB_FILTER_LOCALSTORAGE_KEY */ .sm);
        }
        return storedUser ? JSON.parse(storedUser) : null;
    }
}
function setJobFilter(filters) {
    if (true) {
        localStorage.setItem(_constants_pages_clients_jobs_jobs__WEBPACK_IMPORTED_MODULE_0__/* .JOB_FILTER_LOCALSTORAGE_KEY */ .sm, JSON.stringify(filters));
    }
}
function clearJobFilter() {
    if (true) {
        localStorage.removeItem(JOB_FILTER_LOCALSTORAGE_KEY);
    }
}


/***/ }),

/***/ 60838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i5": function() { return /* reexport */ ADD_TO_JOB_INITIAL_VALUES; },
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "c2": function() { return /* reexport */ (_index_module_default()); },
  "l0": function() { return /* reexport */ common/* Form */.l0; },
  "x": function() { return /* reexport */ common/* FormStyle */.x; },
  "J9": function() { return /* reexport */ common/* Formik */.J9; },
  "gt": function() { return /* reexport */ common/* FormikControl */.gt; },
  "pd": function() { return /* reexport */ common/* InputError */.pd; },
  "oH": function() { return /* reexport */ common/* InputText */.oH; },
  "TA": function() { return /* reexport */ common/* TRANSLATION */.TA; },
  "h": function() { return /* reexport */ UNSUCCESSFUL_REASON_INITIAL_VALUES; },
  "ae": function() { return /* reexport */ UnsuccessfulModalValidation; },
  "sm": function() { return /* reexport */ common/* Yup */.sm; },
  "E1": function() { return /* reexport */ addCandidateToJob; },
  "Jb": function() { return /* reexport */ kanban/* addToAnotherJob */.Jb; },
  "gJ": function() { return /* reexport */ addToJobModalSchema; },
  "jL": function() { return /* reexport */ close_modal/* closeModalUsingState */.j; },
  "A2": function() { return /* reexport */ getCandidateActiveJobList; },
  "F6": function() { return /* reexport */ handleSelectJobValueOnChange; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: Image

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
;// CONCATENATED MODULE: ./src/constants/components/add-to-job-modal.js

var ADD_TO_JOB_INITIAL_VALUES = {
    select_job: ""
};
var addToJobModalSchema = function(t) {
    return common/* Yup.object */.sm.object({
        select_job: common/* Yup.string */.sm.string().required(t("errors:required"))
    });
};
var UNSUCCESSFUL_REASON_INITIAL_VALUES = {
    reason_id: "",
    reason_text: "",
    reason: ""
};
function UnsuccessfulModalValidation(reasonTextValidation) {
    var checkReasonTextValidation = reasonTextValidation;
    var a = {
        reason: common/* Yup.string */.sm.string(),
        reason_id: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")),
        reason_text: common/* Yup.string */.sm.string().when("reason", {
            is: function(reason) {
                return checkReasonTextValidation;
            },
            then: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).max(50, (0,common/* TRANSLATION */.TA)("errors:reason_long"))
        }).test("other", "Invalid reason", function(value) {
            var ref;
            return ((ref = value === null || value === void 0 ? void 0 : value.trim()) === null || ref === void 0 ? void 0 : ref.toLowerCase()) != "other";
        })
    };
    var UNSUCCESSFUL_REASON_MODAL_SCHEMA = common/* Yup.object */.sm.object(a);
    return UNSUCCESSFUL_REASON_MODAL_SCHEMA;
}

// EXTERNAL MODULE: ./src/actions/common/close-modal.js
var close_modal = __webpack_require__(67280);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ./src/services/components/candidate-listing-action.js
var candidate_listing_action = __webpack_require__(66693);
// EXTERNAL MODULE: ./src/actions/components/candidate-bulk-action.js
var candidate_bulk_action = __webpack_require__(61665);
;// CONCATENATED MODULE: ./src/actions/components/add-to-job-modal.js





function getCandidateActiveJobList(params) {
    return _getCandidateActiveJobList.apply(this, arguments);
}
function _getCandidateActiveJobList() {
    _getCandidateActiveJobList = (0,_async_to_generator/* default */.Z)(function(params) {
        var result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new candidate_listing_action/* CandidateListAction */.n().ActiveJobList(params)
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data.jobs
                    ];
            }
        });
    });
    return _getCandidateActiveJobList.apply(this, arguments);
}
function addCandidateToJob(setSelectJobId, selectedCandidateId, setCandidateAddToJobModal, setCandidateBulkActionModal, from) {
    return _addCandidateToJob.apply(this, arguments);
}
function _addCandidateToJob() {
    _addCandidateToJob = (0,_async_to_generator/* default */.Z)(function(setSelectJobId, selectedCandidateId, setCandidateAddToJobModal, setCandidateBulkActionModal, from) {
        var ref, ref1, ref2, job_id, candidate_ids, body, customToastrAction, result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    job_id = setSelectJobId;
                    candidate_ids = (0,candidate_bulk_action/* getSelectedCandidateId */.UH)();
                    body = "";
                    customToastrAction = new common/* CustomToastrAction */.Y5();
                    if (candidate_ids.length == 0) {
                        candidate_ids = [
                            selectedCandidateId
                        ];
                    }
                    body = {
                        "candidate_ids": candidate_ids,
                        "job_id": job_id
                    };
                    setCandidateAddToJobModal(false);
                    if (!(from && from == "candidate_view")) {
                        setCandidateBulkActionModal(false);
                        (0,candidate_bulk_action/* deselectAllCandidates */.FB)();
                    }
                    return [
                        4,
                        new candidate_listing_action/* CandidateListAction */.n().addToJobs(body)
                    ];
                case 1:
                    result = _state.sent();
                    if (result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.success) {
                        customToastrAction.setNormalToastr(result.data.success, "success");
                    // toastr.success(result.data.success);
                    } else if (result === null || result === void 0 ? void 0 : (ref1 = result.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.error) {
                        customToastrAction.setNormalToastr(result.response.data.error, "error");
                    } else {
                        customToastrAction.setNormalToastr(result.response.statusText, "error");
                    // toastr.error(result.response.statusText);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _addCandidateToJob.apply(this, arguments);
}
function handleSelectJobValueOnChange(data, setSelectJobId, formik) {
    formik.setFieldValue("select_job", data.value);
    setSelectJobId(data.value);
}

// EXTERNAL MODULE: ./src/styles/components/add-to-job-modal/_index.module.scss
var _index_module = __webpack_require__(27633);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/candidates/kanban.js + 10 modules
var kanban = __webpack_require__(47942);
;// CONCATENATED MODULE: ./src/imports-files/components/add-to-job-modal.js








/***/ }),

/***/ 16700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.$G; },
/* harmony export */   "Sp": function() { return /* reexport safe */ _actions_components_candidate_bulk_action__WEBPACK_IMPORTED_MODULE_1__.Sp; },
/* harmony export */   "_0": function() { return /* reexport safe */ _actions_components_candidate_bulk_action__WEBPACK_IMPORTED_MODULE_1__._0; },
/* harmony export */   "c2": function() { return /* reexport default from dynamic */ _styles_components_candidate_bulk_action_modal_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default.a; },
/* harmony export */   "nt": function() { return /* reexport safe */ _actions_components_candidate_bulk_action__WEBPACK_IMPORTED_MODULE_1__.nt; },
/* harmony export */   "zx": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.zx; }
/* harmony export */ });
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96047);
/* harmony import */ var _actions_components_candidate_bulk_action__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61665);
/* harmony import */ var _styles_components_candidate_bulk_action_modal_index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42037);
/* harmony import */ var _styles_components_candidate_bulk_action_modal_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_components_candidate_bulk_action_modal_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);





/***/ }),

/***/ 15738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c2": function() { return /* reexport default from dynamic */ _styles_components_delete_candidate_modal_index_module_scss__WEBPACK_IMPORTED_MODULE_0___default.a; },
/* harmony export */   "zx": function() { return /* reexport safe */ _components_button__WEBPACK_IMPORTED_MODULE_1__.Z; }
/* harmony export */ });
/* harmony import */ var _styles_components_delete_candidate_modal_index_module_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19955);
/* harmony import */ var _styles_components_delete_candidate_modal_index_module_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_styles_components_delete_candidate_modal_index_module_scss__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95662);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53429);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);






/***/ }),

/***/ 29774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ components_button/* default */.Z; },
  "XZ": function() { return /* reexport */ jobs_new/* Checkbox */.XZ; },
  "bN": function() { return /* reexport */ jobs_new/* CheckedCheckbox */.bN; },
  "c2": function() { return /* reexport */ (job_filter_index_module_default()); },
  "v0": function() { return /* reexport */ jobs_new/* DefaultCheckbox */.v0; },
  "gN": function() { return /* reexport */ jobs_new/* Field */.gN; },
  "l0": function() { return /* reexport */ jobs_new/* Form */.l0; },
  "x": function() { return /* reexport */ jobs_new/* FormStyle */.x; },
  "J9": function() { return /* reexport */ jobs_new/* Formik */.J9; },
  "gt": function() { return /* reexport */ jobs_new/* FormikControl */.gt; },
  "pd": function() { return /* reexport */ jobs_new/* InputError */.pd; },
  "oH": function() { return /* reexport */ jobs_new/* InputText */.oH; },
  "k2": function() { return /* reexport */ (_index_module_default()); },
  "j$": function() { return /* reexport */ jobs_new/* QUESTION_TYPES */.j$; },
  "Ws": function() { return /* reexport */ showJob/* ShowJobAction */.Ws; },
  "Rb": function() { return /* reexport */ job/* applyFilter */.Rb; },
  "eR": function() { return /* reexport */ closeJobModal; },
  "lU": function() { return /* reexport */ getUserSuggestionValue; },
  "d1": function() { return /* reexport */ handleEmailDelete; },
  "$y": function() { return /* reexport */ handleKeyDown; },
  "_7": function() { return /* reexport */ (moment_default()); },
  "ro": function() { return /* reexport */ onUserSuggestionSelection; },
  "_v": function() { return /* reexport */ onUserSuggestionsClearRequested; },
  "UA": function() { return /* reexport */ onUserSuggestionsFetchRequested; },
  "Qx": function() { return /* reexport */ renderInputComponent; },
  "LB": function() { return /* reexport */ renderUserSuggestion; },
  "wk": function() { return /* reexport */ resetJobModal; },
  "vH": function() { return /* reexport */ common/* setFilledDate */.vH; },
  "BT": function() { return /* reexport */ setQueryParams; },
  "KH": function() { return /* reexport */ shouldRenderSuggestions; },
  "d4": function() { return /* reexport */ jobs_new/* useEffect */.d4; },
  "sO": function() { return /* reexport */ jobs_new/* useRef */.sO; },
  "tv": function() { return /* reexport */ jobs_new/* useRouter */.tv; },
  "eJ": function() { return /* reexport */ jobs_new/* useState */.eJ; },
  "$G": function() { return /* reexport */ jobs_new/* useTranslation */.$G; }
});

// UNUSED EXPORTS: CloseWhite, Datetime, HoverCheckbox, Image, getJobFilter, isEmail, todayDate

// EXTERNAL MODULE: ./src/imports-files/pages/clients/jobs/new.js + 3 modules
var jobs_new = __webpack_require__(13245);
// EXTERNAL MODULE: ../../shared/node_modules/next/image.js
var next_image = __webpack_require__(53429);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
// EXTERNAL MODULE: ../../shared/node_modules/moment/moment.js
var moment = __webpack_require__(62290);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./public/icons/closewhite.svg
var closewhite = __webpack_require__(70394);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/careers/showJob.js
var showJob = __webpack_require__(51439);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/job.js
var job = __webpack_require__(98303);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/common.js
var common = __webpack_require__(90432);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(18186);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(34817);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/hooks/job-filters.js
var job_filters = __webpack_require__(57773);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/jobs/job.js
var jobs_job = __webpack_require__(44791);
// EXTERNAL MODULE: ./src/actions/pages/admins/dashboard/clients/common.js
var clients_common = __webpack_require__(33399);
// EXTERNAL MODULE: ./src/styles/pages/clients/job-sharing/_index.module.scss
var _index_module = __webpack_require__(25385);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
;// CONCATENATED MODULE: ./src/actions/components/job-filters.js









function closeJobModal(event, setJobFilter) {
    setJobFilter("Close");
}
function resetJobModal(setFiltersValue, setModal, setJobList, selectDropdownRef, startDateRef, endDateRef, setStartDate, setEndDate, setLocation, router, setApiError) {
    return _resetJobModal.apply(this, arguments);
}
function _resetJobModal() {
    _resetJobModal = (0,_async_to_generator/* default */.Z)(function(setFiltersValue, setModal, setJobList, selectDropdownRef, startDateRef, endDateRef, setStartDate, setEndDate, setLocation, router, setApiError) {
        var previous_job_filter, result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    previous_job_filter = router.query;
                    delete previous_job_filter.start_date;
                    delete previous_job_filter.end_date;
                    delete previous_job_filter.location;
                    delete previous_job_filter.agency_user_emails;
                    delete previous_job_filter.agency_user_name_initials;
                    delete previous_job_filter.agency_user_photo_urls;
                    delete previous_job_filter.agency_user_names;
                    (0,clients_common/* addParamsToUrl */.Sr)(previous_job_filter, router);
                    (0,job_filters/* setJobFilter */.E6)(previous_job_filter);
                    setFiltersValue(previous_job_filter);
                    return [
                        4,
                        (0,jobs_job/* getJobListingData */.az)(previous_job_filter, setApiError)
                    ];
                case 1:
                    result = _state.sent();
                    setJobList(result.data);
                    document.querySelector(".FilterCustomStartDate input").value = "";
                    document.querySelector(".FilterCustomEndDate input").value = "";
                    selectDropdownRef.current.select.clearValue();
                    // startDateRef.current?.state?.inputValue = ''
                    // endDateRef.current?.state?.inputValue = ''
                    setStartDate("");
                    setEndDate("");
                    setLocation("");
                    setModal(false);
                    return [
                        2
                    ];
            }
        });
    });
    return _resetJobModal.apply(this, arguments);
}
function getAgencyUsers(name_or_email, router) {
    return _getAgencyUsers.apply(this, arguments);
}
function _getAgencyUsers() {
    _getAgencyUsers = (0,_async_to_generator/* default */.Z)(function(name_or_email, router) {
        var body, _tmp, result, status_code, customToastrAction, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = (_tmp.name_or_email = name_or_email, _tmp);
                    return [
                        4,
                        new jobs_job/* JobListing */.DT().getUserByNameOrEmail(body)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new jobs_job/* CustomToastrAction */.Y5();
                    switch(status_code){
                        case jobs_job/* SUCCESS_REPONSE_CODE */.Us:
                            response = result.data;
                            return [
                                2,
                                response.users
                            ];
                        case jobs_job/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            return [
                                2,
                                []
                            ];
                        default:
                            (0,jobs_job/* handleOtherResponseCode */.GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getAgencyUsers.apply(this, arguments);
}
function shouldRenderSuggestions(value) {
    return value.trim().length >= 3;
}
var renderInputComponent = function(inputProps) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
        className: (_index_module_default()).Form__Input,
        autoComplete: "password"
    }, inputProps));
};
function getUserSuggestionValue(suggestion) {
    return "".concat(suggestion.user_attributes.email);
}
function showSuggestion(suggestion) {
    if (suggestion.user_attributes.name && suggestion.user_attributes.email.length > 0) {
        return "".concat(suggestion.user_attributes.name, " | ").concat(suggestion.user_attributes.email);
    } else if (suggestion.user_attributes.name) {
        return "".concat(suggestion.user_attributes.name);
    } else {
        return "".concat(suggestion.user_attributes.email);
    }
}
function renderUserSuggestion(suggestion) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: showSuggestion(suggestion)
    });
}
function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function getUserSuggestions(value, router) {
    return _getUserSuggestions.apply(this, arguments);
}
function _getUserSuggestions() {
    _getUserSuggestions = (0,_async_to_generator/* default */.Z)(function(value, router) {
        var escapedValue, finalUsers;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    escapedValue = escapeRegexCharacters(value === null || value === void 0 ? void 0 : value.trim());
                    if (escapedValue === "") {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        4,
                        getAgencyUsers(escapedValue, router)
                    ];
                case 1:
                    finalUsers = _state.sent();
                    return [
                        2,
                        finalUsers
                    ];
            }
        });
    });
    return _getUserSuggestions.apply(this, arguments);
}
function onUserSuggestionsFetchRequested(hash, setUsers) {
    return _onUserSuggestionsFetchRequested.apply(this, arguments);
}
function _onUserSuggestionsFetchRequested() {
    _onUserSuggestionsFetchRequested = (0,_async_to_generator/* default */.Z)(function(hash, setUsers) {
        var users;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getUserSuggestions(hash.value)
                    ];
                case 1:
                    users = _state.sent();
                    setUsers(users);
                    return [
                        2
                    ];
            }
        });
    });
    return _onUserSuggestionsFetchRequested.apply(this, arguments);
}
;
var onUserSuggestionsClearRequested = function(setUsers) {
    setUsers([]);
};
function isEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@\.]+$/.test(email);
}
function onUserSuggestionSelection(formik, old_emails, email, old_initials, new_initial, setAgencyUserEmails, setAgencyUserInitials) {
    if (isEmail(email) && !old_emails.includes(email)) {
        old_emails.unshift(email);
        old_initials.unshift(new_initial);
        setAgencyUserEmails((0,_to_consumable_array/* default */.Z)(old_emails));
        setAgencyUserInitials((0,_to_consumable_array/* default */.Z)(old_initials));
    }
}
function handleKeyDown(evt, formik, setAgencyUserEmail, setAgencyUserError, setAgencyUserEmails, setAgencyUserInitials, t) {
    if ([
        "Enter"
    ].includes(evt.key)) {
        evt.preventDefault();
        var email = evt.target.value;
        if (isEmail(email)) {
            {
                onUserSuggestionSelection(formik, formik.values.agency_user_emails, email, formik.values.agency_user_initials, {
                    email: email,
                    name_initials: null,
                    name: null
                }, setAgencyUserEmails, setAgencyUserInitials);
                setAgencyUserEmail("");
            }
        } else {
            setAgencyUserError(t("errors:autocomplete_invalid_email"));
        }
    }
    ;
}
function handleEmailDelete(formik, itemIndex, setAgencyUserEmails, setAgencyUserInitials) {
    var emails = formik.values.agency_user_emails;
    var name_initials = formik.values.agency_user_initials;
    emails.splice(itemIndex, 1);
    name_initials.splice(itemIndex, 1);
    formik.setFieldValue("agency_user_emails", (0,_to_consumable_array/* default */.Z)(emails));
    formik.setFieldValue("agency_user_initials", (0,_to_consumable_array/* default */.Z)(name_initials));
    setAgencyUserEmails((0,_to_consumable_array/* default */.Z)(emails));
    setAgencyUserInitials((0,_to_consumable_array/* default */.Z)(name_initials));
}
function setQueryParams(router) {
    var agency_user_emails = router.query.agency_user_emails;
    var agency_user_names = router.query.agency_user_names;
    var agency_user_photo_urls = router.query.agency_user_photo_urls;
    var agency_user_name_initials = router.query.agency_user_name_initials;
    var agency_user_initials = [];
    if (agency_user_emails) {
        if (Array.isArray(agency_user_emails)) {
            agency_user_initials = agency_user_emails.map(function(x, index) {
                return {
                    name: agency_user_names[index] || agency_user_emails[index],
                    photo_url: agency_user_photo_urls[index],
                    name_initials: agency_user_name_initials[index]
                };
            });
        } else {
            agency_user_initials = [
                {
                    name: agency_user_names || agency_user_emails,
                    photo_url: agency_user_photo_urls,
                    name_initials: agency_user_name_initials
                }
            ];
        }
        return agency_user_initials;
    } else {
        return [];
    }
}

// EXTERNAL MODULE: ./src/styles/components/job-filter/_index.module.scss
var job_filter_index_module = __webpack_require__(90538);
var job_filter_index_module_default = /*#__PURE__*/__webpack_require__.n(job_filter_index_module);
;// CONCATENATED MODULE: ./src/imports-files/components/job-filters.js

//----------------  COMPONENT ----------------





//----------------  COMPONENT ----------------
//----------------  ACTIONS ----------------



//----------------  ACTIONS ----------------
//----------------  HOOKS ----------------

//----------------  HOOKS ----------------
//----------------  STYLESHEET ----------------

 //----------------  STYLESHEET ----------------


/***/ }),

/***/ 94847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "ZJ": function() { return /* reexport */ common/* ButtonStyle */.ZJ; },
  "uM": function() { return /* reexport */ CompetencyComponentAction; },
  "$c": function() { return /* reexport */ CompetencyComponentService; },
  "GS": function() { return /* reexport */ jobs_scorecards/* CreateScoreStyle */.GS; },
  "x": function() { return /* reexport */ common/* FormStyle */.x; },
  "gt": function() { return /* reexport */ common/* FormikControl */.gt; },
  "pd": function() { return /* reexport */ common/* InputError */.pd; },
  "oH": function() { return /* reexport */ common/* InputText */.oH; },
  "Lt": function() { return /* reexport */ common/* SendRequest */.Lt; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: CloseSvg, Image

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ./src/actions/components/autosuggestion-input.js
var autosuggestion_input = __webpack_require__(7141);
// EXTERNAL MODULE: ./src/constants/pages/clients/jobs/scorecards.js
var scorecards = __webpack_require__(40682);
// EXTERNAL MODULE: ../../shared/node_modules/lodash.clonedeep/index.js
var lodash_clonedeep = __webpack_require__(10552);
var lodash_clonedeep_default = /*#__PURE__*/__webpack_require__.n(lodash_clonedeep);
;// CONCATENATED MODULE: ./src/actions/components/jobScorecardComponent/competency.js










var CompetencyComponentAction = /*#__PURE__*/ function(AutosuggestionInputAction) {
    "use strict";
    (0,_inherits/* default */.Z)(CompetencyComponentAction, AutosuggestionInputAction);
    var _super = (0,_create_super/* default */.Z)(CompetencyComponentAction);
    function CompetencyComponentAction(setSubCompetency, subcompetencySelectedValue, setSubcompetencySelectedValue, setFlagForRerender) {
        (0,_class_call_check/* default */.Z)(this, CompetencyComponentAction);
        var _this;
        _this = _super.call(this);
        _this.setSubCompetency = setSubCompetency;
        _this.subcompetencySelectedValue = subcompetencySelectedValue;
        _this.setSubcompetencySelectedValue = setSubcompetencySelectedValue;
        _this.competencyComponentService = new CompetencyComponentService();
        _this.setFlagForRerender = setFlagForRerender;
        return _this;
    }
    (0,_create_class/* default */.Z)(CompetencyComponentAction, [
        {
            key: "showCompetency",
            value: function showCompetency(formik, index) {
                var jobSubCompetencyHash = lodash_clonedeep_default()(scorecards/* JOB_SUB_COMPETENCIES_COMPETENCY_ATTRIBUTES_HASH */.sn);
                formik.setFieldValue("job_competencies_attributes.".concat(index, ".job_sub_competencies_attributes"), []);
                this.setSubCompetency(true);
            }
        },
        {
            key: "addSubcompetency",
            value: function addSubcompetency(formik, index) {
                var jobSubCompetencyHash = lodash_clonedeep_default()(scorecards/* JOB_SUB_COMPETENCIES_COMPETENCY_ATTRIBUTES_HASH */.sn);
                var job_sub_competencies_attributes = formik.values.job_competencies_attributes[index].job_sub_competencies_attributes;
                job_sub_competencies_attributes.push(jobSubCompetencyHash);
                this.setFlagForRerender(Math.random() * 1000);
            }
        },
        {
            key: "removeSubcompetency",
            value: function removeSubcompetency(formik, index, subcompetency_index) {
                var formik_value_array = formik.values.job_competencies_attributes[index].job_sub_competencies_attributes;
                formik_value_array[subcompetency_index]._destroy = true;
                // formik_value_array[subcompetency_index]?.id ? formik_value_array[subcompetency_index]._destroy = true : formik_value_array.splice(subcompetency_index,1);
                formik.setFieldValue("job_competencies_attributes.".concat(index, ".job_sub_competencies_attributes"), formik_value_array);
                this.setFlagForRerender(Math.random() * 1000);
                this.setSubcompetencySelectedValue(formik_value_array);
            }
        },
        {
            key: "hideCompetency",
            value: function hideCompetency(formik, index) {
                var jobSubCompetencyHash = lodash_clonedeep_default()(scorecards/* JOB_SUB_COMPETENCIES_COMPETENCY_ATTRIBUTES_HASH */.sn);
                var formik_value_array = formik.values.job_competencies_attributes[index].job_sub_competencies_attributes;
                for(var arr_index in formik_value_array){
                    formik_value_array[arr_index].id ? formik_value_array[arr_index]._destroy = true : "";
                }
                formik.setFieldValue("job_competencies_attributes.".concat(index, ".job_sub_competencies_attributes"), formik_value_array);
                this.setSubCompetency(false);
                this.setSubcompetencySelectedValue([]);
            }
        },
        {
            key: "removeSelectedValues",
            value: function removeSelectedValues(event, index, formik, job_competencies_attributes_index, setSubcompetencySelectedValue) {
                var ref;
                var formik_value_array = formik.values.job_competencies_attributes[job_competencies_attributes_index].job_sub_competencies_attributes;
                ((ref = formik_value_array[index]) === null || ref === void 0 ? void 0 : ref.id) ? formik_value_array[index]._destroy = true : formik_value_array.splice(index, 1);
                formik.setFieldValue("job_competencies_attributes.".concat(job_competencies_attributes_index, ".job_sub_competencies_attributes"), formik_value_array);
                this.setFlagForRerender(Math.random() * 1000);
                setSubcompetencySelectedValue(formik_value_array);
            }
        },
        {
            key: "competencyHandleKeyDown",
            value: function competencyHandleKeyDown(evt, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, add_selected_value, params) {
                if (evt.key === "Enter") {
                    evt.preventDefault();
                } else if (evt.target.value.trim() != "") {
                    var value = {
                        label: evt.target.value,
                        value: evt.target.id
                    };
                    this.add_selected_value(value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params);
                }
            }
        },
        {
            key: "competencyHandleKeyUp",
            value: function competencyHandleKeyUp(evt, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, add_selected_value, params) {
                // if (evt.key === 'Enter')
                //  {
                //     evt.preventDefault();
                //  }
                //  else if(evt.target.value.trim() !='')
                //  {
                evt.preventDefault();
                var value = {
                    label: evt.target.value,
                    value: evt.target.id
                };
                this.add_selected_value(value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params);
            // }
            }
        },
        {
            // Function called when pressing the enter key in the input
            key: "handleKeyDown",
            value: function handleKeyDown(evt, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params) {
                if (evt.key === "Enter" && evt.target.value.trim() != "") {
                    evt.preventDefault();
                    var value = {
                        label: evt.target.value,
                        value: evt.target.id
                    };
                    this.add_selected_value(value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params);
                }
            }
        },
        {
            key: "handleKeyUp",
            value: function handleKeyUp(evt, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params) {
                // if (evt.key === 'Enter' && evt.target.value.trim() !='')
                //  {
                //  	  evt.preventDefault();
                var value = {
                    label: evt.target.value,
                    value: evt.target.id
                };
                this.add_selected_value(value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params);
            // }
            }
        },
        {
            key: "add_selected_value",
            value: function add_selected_value(value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params) {
                var competencyComponentAction = new CompetencyComponentAction();
                if (params.type == "client_competency") {
                    if (value.value == "") {
                        competencyComponentAction.addCustomClientCompetencyAttribute(formik, params.index, selectedValues, setAutosuggestionFieldValue, value, params);
                    } else {
                        competencyComponentAction.addSystemClientCompetencyAttribute(formik, params.index, selectedValues, setAutosuggestionFieldValue, value, params);
                    }
                } else {
                    if (value.value == "") {
                        competencyComponentAction.addCustomJobSubCompetencyAttribute(formik, params.index, selectedValues, setAutosuggestionFieldValue, value, params);
                    } else {
                        competencyComponentAction.addSystemJobSubCompetencyAttribute(formik, params.index, selectedValues, setAutosuggestionFieldValue, value, params);
                    }
                }
                setSelectedValues(selectedValues);
            }
        },
        {
            key: "addCustomJobSubCompetencyAttribute",
            value: // This function will add the values of the Custom Job sub competencies
            function addCustomJobSubCompetencyAttribute(formik, index, selectedValues, setAutosuggestionFieldValue, value, params) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var ref, job_competencies_attributes_array, job_sub_competency_attributes_hash;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        job_competencies_attributes_array = ((ref = formik.values.job_competencies_attributes[index]) === null || ref === void 0 ? void 0 : ref.job_sub_competencies_attributes) || [];
                        job_sub_competency_attributes_hash = job_competencies_attributes_array[params.subcompetency_index];
                        job_sub_competency_attributes_hash.name = value.label;
                        job_sub_competency_attributes_hash.sub_competency_id = null;
                        formik.setFieldValue("job_competencies_attributes.".concat(index, ".job_sub_competencies_attributes"), job_competencies_attributes_array);
                        params.setFlagForRerender(Math.random() * 1000);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "addSystemJobSubCompetencyAttribute",
            value: // Add the value in the hash for the system job competency selected from the dropdown
            function addSystemJobSubCompetencyAttribute(formik, index, selectedValues, setAutosuggestionFieldValue, value, params) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var ref, job_competencies_attributes_array, job_sub_competency_attributes_hash;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        job_competencies_attributes_array = ((ref = formik.values.job_competencies_attributes[index]) === null || ref === void 0 ? void 0 : ref.job_sub_competencies_attributes) || [];
                        job_sub_competency_attributes_hash = job_competencies_attributes_array[params.subcompetency_index];
                        job_sub_competency_attributes_hash.name = value.label;
                        job_sub_competency_attributes_hash.sub_competency_id = value.id;
                        formik.setFieldValue("job_competencies_attributes.".concat(index, ".job_sub_competencies_attributes"), job_competencies_attributes_array);
                        params.setFlagForRerender(Math.random() * 1000);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "addCustomClientCompetencyAttribute",
            value: // This function will add the values of the Custom Job sub competencies
            function addCustomClientCompetencyAttribute(formik, index, selectedValues, setAutosuggestionFieldValue, value, params) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                formik.setFieldValue("job_competencies_attributes.".concat(index, ".name"), value.label);
                                formik.setFieldValue("job_competencies_attributes.".concat(index, ".competency_id"), null);
                                return [
                                    4,
                                    setAutosuggestionFieldValue(value.label)
                                ];
                            case 1:
                                _state.sent();
                                selectedValues = value;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addSystemClientCompetencyAttribute",
            value: // Add the value in the hash for the system job competency selected from the dropdown
            function addSystemClientCompetencyAttribute(formik, index, selectedValues, setAutosuggestionFieldValue, value, params) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        formik.setFieldValue("job_competencies_attributes.".concat(index, ".name"), value.label);
                        formik.setFieldValue("job_competencies_attributes.".concat(index, ".competency_id"), value.id);
                        setAutosuggestionFieldValue(value.label);
                        selectedValues = value;
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "submitNotes",
            value: function submitNotes(params) {
                if (params.formik) {
                    params.formik.setFieldValue(params.name, params.value);
                }
                params.setModal({
                    status: false,
                    heading: "",
                    index: params === null || params === void 0 ? void 0 : params.index,
                    submitButtonAction: ""
                });
            }
        }
    ]);
    return CompetencyComponentAction;
}(autosuggestion_input/* AutosuggestionInputAction */.T);

;// CONCATENATED MODULE: ./src/services/components/jobScorecardComponent/competency.js







var CompetencyComponentService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(CompetencyComponentService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(CompetencyComponentService);
    function CompetencyComponentService() {
        (0,_class_call_check/* default */.Z)(this, CompetencyComponentService);
        return _super.call(this);
    }
    (0,_create_class/* default */.Z)(CompetencyComponentService, [
        {
            key: "getCompetencySubCompetencySuggestionData",
            value: function getCompetencySubCompetencySuggestionData(params) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var k_this, body, _tmp, url, result, _tmp1, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                k_this = new CompetencyComponentService();
                                _tmp = {};
                                body = (_tmp.name = params, _tmp);
                                url = common/* API.scorecards.COMPETENCY_SUBCOMPETENCY_DATA */.bl.scorecards.COMPETENCY_SUBCOMPETENCY_DATA;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp1 = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(url, (_tmp1.params = body, _tmp1.headers = k_this.customHeaderJSON(), _tmp1), k_this.setHeaderJSON(), k_this.setCrossDomainTrue(), k_this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CompetencyComponentService;
}(common/* SendRequest */.Lt);

// EXTERNAL MODULE: ./src/imports-files/pages/clients/jobs/scorecards.js
var jobs_scorecards = __webpack_require__(96726);
;// CONCATENATED MODULE: ./src/imports-files/components/jobScorecardComponent/competency.js






/***/ }),

/***/ 18020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "s": function() { return /* reexport */ CONSTANT; },
  "XZ": function() { return /* reexport */ common/* Checkbox */.XZ; },
  "bN": function() { return /* reexport */ common/* CheckedCheckbox */.bN; },
  "HR": function() { return /* reexport */ CommunicationFilterAction; },
  "XL": function() { return /* reexport */ CommunicationFilterService; },
  "OX": function() { return /* reexport */ communication/* CommunicationService */.O; },
  "c2": function() { return /* reexport */ (_index_module_default()); },
  "v0": function() { return /* reexport */ common/* DefaultCheckbox */.v0; },
  "l0": function() { return /* reexport */ common/* Form */.l0; },
  "J9": function() { return /* reexport */ common/* Formik */.J9; },
  "gt": function() { return /* reexport */ common/* FormikControl */.gt; },
  "k2": function() { return /* reexport */ (job_sharing_index_module_default()); },
  "Lt": function() { return /* reexport */ common/* SendRequest */.Lt; },
  "Sr": function() { return /* reexport */ common/* addParamsToUrl */.Sr; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "A$": function() { return /* reexport */ common/* clearSWRCache */.A$; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "sO": function() { return /* reexport */ common/* useRef */.sO; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: CloseWhite, HoverCheckbox, Image, InputModalStyle, Yup

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
;// CONCATENATED MODULE: ./src/constants/components/modals/communication-filter.js
var CONSTANT = {
    initialValue: {
        job_title: "",
        candidate_name: "",
        important: "",
        non_interview: ""
    }
};

// EXTERNAL MODULE: ./public/icons/closewhite.svg
var closewhite = __webpack_require__(70394);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(18186);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
;// CONCATENATED MODULE: ./src/actions/components/modal/communication-filter.js






var CommunicationFilterAction = /*#__PURE__*/ function() {
    "use strict";
    function CommunicationFilterAction(router, setCommunicationFilter, communicationFilter, setFlagForRerender, setCommunicationList, formRef) {
        (0,_class_call_check/* default */.Z)(this, CommunicationFilterAction);
        this.router = router;
        this.setCommunicationFilter = setCommunicationFilter;
        this.communicationFilter = communicationFilter;
        this.setFlagForRerender = setFlagForRerender;
        this.setCommunicationList = setCommunicationList;
        this.communicationService = new communication/* CommunicationService */.O();
        this.communicationFilterService = new CommunicationFilterService();
        this.formRef = formRef;
    }
    (0,_create_class/* default */.Z)(CommunicationFilterAction, [
        {
            key: "closeModal",
            value: function closeModal() {
                this.communicationFilter.state = false;
                this.setCommunicationFilter(this.communicationFilter);
                this.setFlagForRerender(Math.random() * 1000);
            }
        },
        {
            key: "resetForm",
            value: function resetForm() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var params_list, result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                params_list = _this.router.query;
                                delete params_list.job_title;
                                delete params_list.candidate_name;
                                delete params_list.non_interview;
                                delete params_list.important;
                                (0,common/* addParamsToUrl */.Sr)(params_list, _this.router);
                                _this.formRef.current.resetForm();
                                return [
                                    4,
                                    _this.communicationService.getCommunicationData(params_list)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setCommunicationList(result.data);
                                _this.setFlagForRerender(Math.random() * 1000);
                                _this.closeModal();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "submitForm",
            value: function submitForm(values) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var params_list, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                params_list = _this.router.query;
                                if (!values.job_title) {
                                    delete params_list.job_title;
                                }
                                if (!values.candidate_name) {
                                    delete params_list.candidate_name;
                                }
                                if (!values.non_interview) {
                                    delete params_list.non_interview;
                                }
                                if (!values.important) {
                                    delete params_list.important;
                                }
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = Object.keys(values)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        key = _step.value;
                                        if (values[key] == "") {
                                            delete values[key];
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                params_list = (0,_object_spread/* default */.Z)({}, params_list, values);
                                (0,common/* addParamsToUrl */.Sr)(params_list, _this.router);
                                return [
                                    4,
                                    _this.communicationService.getCommunicationData(params_list)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setCommunicationList(result.data);
                                _this.setFlagForRerender(Math.random() * 1000);
                                _this.closeModal();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getDropdownOptions",
            value: function getDropdownOptions() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var job_and_candidate_listing, _tmp;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getCandidateAndJobNameOptions()
                                ];
                            case 1:
                                job_and_candidate_listing = _state.sent();
                                _tmp = {};
                                return [
                                    2,
                                    (_tmp.job_options = job_and_candidate_listing.job_options, _tmp.candidate_options = job_and_candidate_listing.candidate_list, _tmp)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getJobOptions",
            value: function getJobOptions() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var job_options;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.communicationFilterService.get_job_options()
                                ];
                            case 1:
                                job_options = _state.sent();
                                return [
                                    2,
                                    job_options
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCandidateAndJobNameOptions",
            value: function getCandidateAndJobNameOptions() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var params, _tmp, options, _tmp1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                params = (_tmp.email_type = _this.router.query.email_type, _tmp);
                                return [
                                    4,
                                    _this.communicationFilterService.get_candidate_job_options(params)
                                ];
                            case 1:
                                options = _state.sent();
                                _tmp1 = {};
                                return [
                                    2,
                                    (_tmp1.job_options = _this.finalArrayOf(options.data.job_titles), _tmp1.candidate_list = _this.finalArrayOf(options.data.candidate_names), _tmp1)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "finalArrayOf",
            value: function finalArrayOf(values) {
                var emptyArray = [];
                values.map(function(x) {
                    return emptyArray.push({
                        label: x,
                        value: x
                    });
                });
                return emptyArray;
            }
        },
        {
            key: "getCandidateNameptions",
            value: function getCandidateNameptions() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var candidate_options;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.communicationFilterService.get_candidate_options()
                                ];
                            case 1:
                                candidate_options = _state.sent();
                                return [
                                    2,
                                    candidate_options
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleCheckboxChange",
            value: function handleCheckboxChange(name, event) {
                this.formRef.current.setFieldValue(name, event.target.checked);
            }
        },
        {
            key: "handleDropdownChange",
            value: function handleDropdownChange(name, value) {
                this.formRef.current.setFieldValue(name, value.value);
            }
        },
        {
            key: "isFilterApplied",
            value: function isFilterApplied() {
                var previous_filter = this.router.query;
                return (previous_filter === null || previous_filter === void 0 ? void 0 : previous_filter.job_title) || (previous_filter === null || previous_filter === void 0 ? void 0 : previous_filter.candidate_name) || (previous_filter === null || previous_filter === void 0 ? void 0 : previous_filter.non_interview) || previous_filter.important;
            }
        },
        {
            key: "setDefaultValueDropdown",
            value: function setDefaultValueDropdown(options, value) {
                var hash = "";
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        if (element.value == value) {
                            hash = element;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return hash.value;
            }
        }
    ]);
    return CommunicationFilterAction;
}();

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
;// CONCATENATED MODULE: ./public/JSON_DATA/communication_center/communication_filter.js
function setJobOptions() {
    var job_options = [
        {
            label: "",
            value: ""
        }
    ];
    for(var index = 0; index < 10; index++){
        job_options.push({
            label: "Job_".concat(index + 1),
            value: "Job_".concat(index + 1)
        });
    }
    return job_options;
}
function setCandidateOptions() {
    var candidate_options = [
        {
            label: "",
            value: ""
        }
    ];
    for(var index = 0; index < 10; index++){
        candidate_options.push({
            label: "Candidate_".concat(index + 1),
            value: "Candidate_".concat(index + 1)
        });
    }
    return candidate_options;
}
var CommunicationFilterJobOptionsDummyData = setJobOptions();
var CommunicationFilterCandidateOptionsDummyData = setCandidateOptions();
var CommunicationFilterGetCommunicationData = {
    data: []
};

;// CONCATENATED MODULE: ./src/services/components/modal/communication-filter.js








var CommunicationFilterService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(CommunicationFilterService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(CommunicationFilterService);
    function CommunicationFilterService() {
        (0,_class_call_check/* default */.Z)(this, CommunicationFilterService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CommunicationFilterService, [
        {
            key: "get_communication_tab_data",
            value: function get_communication_tab_data(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.activities.CUSTOM_INTEGRATIONS */.bl.client.activities.CUSTOM_INTEGRATIONS;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(common/* API.client.communication.COMMUNICATION_DATA */.bl.client.communication.COMMUNICATION_DATA, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "get_job_options",
            value: function get_job_options() {
                return (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        // const url = API.client.communication.GET_JOB_OPTIONS;
                        // try
                        // {
                        //     const result = await axios.get(url,
                        //     {
                        //       params: params,
                        //       headers: this.customHeaderJSON()
                        //     },
                        //     this.setHeaderJSON(),
                        //     this.setCrossDomainTrue(),
                        //     this.setCredentialsJSON());
                        // return result;
                        // } 
                        // catch (error) 
                        // {
                        // return error;
                        // }
                        return [
                            2,
                            CommunicationFilterJobOptionsDummyData
                        ];
                    });
                })();
            }
        },
        {
            key: "get_candidate_job_options",
            value: function get_candidate_job_options(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.communication.COMMUNICATION_DATA */.bl.client.communication.COMMUNICATION_DATA;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CommunicationFilterService;
}(common/* SendRequest */.Lt);

// EXTERNAL MODULE: ./src/services/pages/clients/communication/index.js + 1 modules
var communication = __webpack_require__(51348);
// EXTERNAL MODULE: ./src/styles/components/checkbox-filter-modal/_index.module.scss
var _index_module = __webpack_require__(9648);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/styles/pages/clients/job-sharing/_index.module.scss
var job_sharing_index_module = __webpack_require__(25385);
var job_sharing_index_module_default = /*#__PURE__*/__webpack_require__.n(job_sharing_index_module);
;// CONCATENATED MODULE: ./src/imports-files/components/model/communication-filter.js
// --------------------- COMMON ---------------------

// --------------------- COMMON ---------------------
//----------------  CONSTANT ----------------

//----------------  CONSTANT ----------------
//----------------  COMPONENT ----------------

//----------------  COMPONENT ----------------
//----------------  ACTIONS ----------------


//----------------  ACTIONS ----------------
//----------------  SERVICE ----------------


//----------------  SERVICE ----------------
//----------------  STYLESHEET ----------------


 //----------------  STYLESHEET ----------------


/***/ }),

/***/ 62641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "tl": function() { return /* reexport */ custom_company_integration_modal/* CONSTANTS */.tl; },
  "c2": function() { return /* reexport */ (_index_module_default()); },
  "j5": function() { return /* reexport */ CustomCompanyIntegrationModalAction; },
  "rz": function() { return /* reexport */ CustomCompanyIntegrationModalService; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "gN": function() { return /* reexport */ common/* Field */.gN; },
  "l0": function() { return /* reexport */ common/* Form */.l0; },
  "x": function() { return /* reexport */ common/* FormStyle */.x; },
  "J9": function() { return /* reexport */ common/* Formik */.J9; },
  "gt": function() { return /* reexport */ common/* FormikControl */.gt; },
  "sz": function() { return /* reexport */ info/* default */.Z; },
  "pd": function() { return /* reexport */ common/* InputError */.pd; },
  "TJ": function() { return /* reexport */ InputModalConstants; },
  "Yh": function() { return /* reexport */ (input_modal_index_module_default()); },
  "oH": function() { return /* reexport */ common/* InputText */.oH; },
  "rU": function() { return /* reexport */ common/* Link */.rU; },
  "Lt": function() { return /* reexport */ common/* SendRequest */.Lt; },
  "TA": function() { return /* reexport */ common/* TRANSLATION */.TA; },
  "u": function() { return /* reexport */ common/* Tooltip */.u; },
  "sm": function() { return /* reexport */ common/* Yup */.sm; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "IR": function() { return /* reexport */ custom_company_integration_modal/* customCompnayIntegrationValidation */.IR; },
  "jL": function() { return /* reexport */ client_integrations/* initialiseLiveAuthClient */.jL; },
  "vb": function() { return /* reexport */ custom_company_integration_modal/* integrationValidationSchema */.vb; },
  "_7": function() { return /* reexport */ common/* moment */._7; },
  "sO": function() { return /* reexport */ common/* useRef */.sO; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: Close, CloseWhite, FormModalStyle, Image, useEffect

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/constants/components/modals/custom-company-integration-modal.js
var custom_company_integration_modal = __webpack_require__(40168);
;// CONCATENATED MODULE: ./src/constants/components/modals/input-modal.js
var InputModalConstants = {
    tooltip: {
        background: "#00325A",
        radius: 20,
        padding: 10,
        placement: "right",
        fontSize: "12px"
    }
};

// EXTERNAL MODULE: ./public/icons/closewhite.svg
var closewhite = __webpack_require__(70394);
// EXTERNAL MODULE: ./public/icons/info.svg
var info = __webpack_require__(35150);
// EXTERNAL MODULE: ./public/new-icons/close.svg
var new_icons_close = __webpack_require__(14270);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
;// CONCATENATED MODULE: ./src/actions/components/modal/custom-company-integration-modal.js





var CustomCompanyIntegrationModalAction = /*#__PURE__*/ function() {
    "use strict";
    function CustomCompanyIntegrationModalAction(setModal, setCustomEnableItems, setFlagForRerender, setApiError, formRef) {
        (0,_class_call_check/* default */.Z)(this, CustomCompanyIntegrationModalAction);
        this.customCompanyIntegrationModalService = new CustomCompanyIntegrationModalService();
        this.customToastrAction = new common/* CustomToastrAction */.Y5();
        this.setModal = setModal;
        this.setCustomEnableItems = setCustomEnableItems;
        this.setFlagForRerender = setFlagForRerender;
        this.setApiError = setApiError;
        this.formRef = formRef;
    }
    (0,_create_class/* default */.Z)(CustomCompanyIntegrationModalAction, [
        {
            key: "getSelectValue",
            value: function getSelectValue(values) {
                var select_values = [];
                Object.keys(values).map(function(key, index) {
                    select_values.push({
                        value: key,
                        label: values[key]
                    });
                });
                return select_values;
            }
        },
        {
            key: "submitForm",
            value: function submitForm(values, type) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                result = "";
                                if (!(type == "Edit")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.customCompanyIntegrationModalService.updateCustomIntegrationsList(values)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                if (!(type == "Create")) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.customCompanyIntegrationModalService.addCustomIntegrationsList(values)
                                ];
                            case 3:
                                result = _state.sent();
                                _state.label = 4;
                            case 4:
                                if (result.request.status == 200) {
                                    _this.customToastrAction.setNormalToastr(result.data.success, "success");
                                    _this.setApiError(result.request);
                                    _this.setCustomEnableItems(result.data.custom_integrations);
                                    _this.setModal(false);
                                    _this.setFlagForRerender(Math.random() * 10000);
                                } else {
                                    _this.formRef.current.setStatus(result.response.data.error);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setInitialValues",
            value: function setInitialValues(data, type) {
                if (type == "Edit") {
                    Object.keys(data).map(function(key) {
                        custom_company_integration_modal/* CONSTANTS.formInitialValues.custom_integration */.tl.formInitialValues.custom_integration[key] = data[key];
                    });
                } else {
                    Object.keys(custom_company_integration_modal/* CONSTANTS.formInitialValues.custom_integration */.tl.formInitialValues.custom_integration).map(function(key) {
                        custom_company_integration_modal/* CONSTANTS.formInitialValues.custom_integration */.tl.formInitialValues.custom_integration[key] = "";
                    });
                }
                return custom_company_integration_modal/* CONSTANTS.formInitialValues */.tl.formInitialValues;
            }
        },
        {
            key: "resetForm",
            value: function resetForm(formRef) {
                this.setFlagForRerender(Math.random() * 10000);
            }
        }
    ]);
    return CustomCompanyIntegrationModalAction;
}();

// EXTERNAL MODULE: ./src/actions/pages/clients/activities/client-integrations.js
var client_integrations = __webpack_require__(79925);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
;// CONCATENATED MODULE: ./src/services/components/modal/custom-company-integration-modal.js







var CustomCompanyIntegrationModalService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(CustomCompanyIntegrationModalService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(CustomCompanyIntegrationModalService);
    function CustomCompanyIntegrationModalService() {
        (0,_class_call_check/* default */.Z)(this, CustomCompanyIntegrationModalService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CustomCompanyIntegrationModalService, [
        {
            key: "addCustomIntegrationsList",
            value: function addCustomIntegrationsList(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.activities.CUSTOM_INTEGRATIONS */.bl.client.activities.CUSTOM_INTEGRATIONS;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateCustomIntegrationsList",
            value: function updateCustomIntegrationsList(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.activities.UPDATE_CUSTOM_INTEGRATIONS.replace */.bl.client.activities.UPDATE_CUSTOM_INTEGRATIONS.replace("$integration_id", params.custom_integration.id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.put */.od.put(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CustomCompanyIntegrationModalService;
}(common/* SendRequest */.Lt);

// EXTERNAL MODULE: ./src/styles/components/job-filter/_index.module.scss
var _index_module = __webpack_require__(90538);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/styles/components/input-modal/_index.module.scss
var input_modal_index_module = __webpack_require__(2983);
var input_modal_index_module_default = /*#__PURE__*/__webpack_require__.n(input_modal_index_module);
;// CONCATENATED MODULE: ./src/imports-files/components/model/custom-company-integration-modal.js
// --------------------- COMMON ---------------------

// --------------------- COMMON ---------------------
// ----------------- CONSTANT ----------------------


// ----------------- CONSTANT ----------------------
// ----------------- IMAGES ----------------------



// ----------------- IMAGES ----------------------
//------------------ ACTIONS ------------------


//------------------ ACTIONS ------------------
//------------------ SERVICES ------------------

//------------------ SERVICES ------------------
//----------------  STYLESHEET ----------------


 //----------------  STYLESHEET ----------------


/***/ }),

/***/ 68946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "tl": function() { return /* reexport */ CONSTANTS; },
  "c2": function() { return /* reexport */ (_index_module_default()); },
  "l0": function() { return /* reexport */ common/* Form */.l0; },
  "J9": function() { return /* reexport */ common/* Formik */.J9; },
  "gt": function() { return /* reexport */ common/* FormikControl */.gt; },
  "pd": function() { return /* reexport */ common/* InputError */.pd; },
  "oH": function() { return /* reexport */ common/* InputText */.oH; },
  "k2": function() { return /* reexport */ (share_cv_index_module_default()); },
  "h8": function() { return /* reexport */ REJECTION_MODAL_SCHEMA; },
  "nm": function() { return /* reexport */ (reject_modal_index_module_default()); },
  "sm": function() { return /* reexport */ common/* Yup */.sm; },
  "sO": function() { return /* reexport */ common/* useRef */.sO; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: API, CloseWhite, CustomToastrAction, Image, SendRequest, TRANSLATION, axios, useEffect, useRouter

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
;// CONCATENATED MODULE: ./src/constants/components/modals/rejection-modal.js

var CONSTANTS = {
    texts: {},
    initialValue: {
        job_approval_users: {
            rejected_reason: ""
        }
    }
};
var REJECTION_MODAL_SCHEMA = function(t) {
    return common/* Yup.object */.sm.object({
        job_approval_users: common/* Yup.object */.sm.object({
            rejected_reason: common/* Yup.string */.sm.string().required(t("errors:required"))
        })
    });
};

// EXTERNAL MODULE: ./public/icons/closewhite.svg
var closewhite = __webpack_require__(70394);
// EXTERNAL MODULE: ./src/styles/components/confirmation-modal/_index.module.scss
var _index_module = __webpack_require__(25798);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/styles/components/share-cv/_index.module.scss
var share_cv_index_module = __webpack_require__(2443);
var share_cv_index_module_default = /*#__PURE__*/__webpack_require__.n(share_cv_index_module);
// EXTERNAL MODULE: ./src/styles/components/reject-modal/_index.module.scss
var reject_modal_index_module = __webpack_require__(93210);
var reject_modal_index_module_default = /*#__PURE__*/__webpack_require__.n(reject_modal_index_module);
;// CONCATENATED MODULE: ./src/imports-files/components/model/rejection-modal.js
// --------------------- COMMON ---------------------

// --------------------- COMMON ---------------------
// ----------------- CONSTANT ----------------------

// ----------------- CONSTANT ----------------------
// ----------------- COMPONENTS ----------------------

// ----------------- COMPONENTS ----------------------
//----------------  STYLESHEET ----------------


 //----------------  STYLESHEET ----------------


/***/ }),

/***/ 28801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "ZJ": function() { return /* reexport */ common/* ButtonStyle */.ZJ; },
  "tl": function() { return /* reexport */ CONSTANTS; },
  "XZ": function() { return /* reexport */ common/* Checkbox */.XZ; },
  "bN": function() { return /* reexport */ common/* CheckedCheckbox */.bN; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "v0": function() { return /* reexport */ common/* DefaultCheckbox */.v0; },
  "g2": function() { return /* reexport */ common/* DisabledCheckbox */.g2; },
  "dC": function() { return /* reexport */ common/* ErrorPages */.dC; },
  "l0": function() { return /* reexport */ common/* Form */.l0; },
  "x": function() { return /* reexport */ common/* FormStyle */.x; },
  "J9": function() { return /* reexport */ common/* Formik */.J9; },
  "gt": function() { return /* reexport */ common/* FormikControl */.gt; },
  "pd": function() { return /* reexport */ common/* InputError */.pd; },
  "oH": function() { return /* reexport */ common/* InputText */.oH; },
  "Wy": function() { return /* reexport */ (modal_index_module_default()); },
  "k2": function() { return /* reexport */ (_index_module_default()); },
  "RQ": function() { return /* reexport */ common/* REDIRECT */.RQ; },
  "A0": function() { return /* reexport */ SELECT_JOB_VALIDATION; },
  "Us": function() { return /* reexport */ common/* SUCCESS_REPONSE_CODE */.Us; },
  "Fr": function() { return /* reexport */ SelectJobModalAction; },
  "fD": function() { return /* reexport */ SelectJobModalService; },
  "TA": function() { return /* reexport */ common/* TRANSLATION */.TA; },
  "u": function() { return /* reexport */ common/* Tooltip */.u; },
  "sm": function() { return /* reexport */ common/* Yup */.sm; },
  "A$": function() { return /* reexport */ common/* clearSWRCache */.A$; },
  "wx": function() { return /* reexport */ common/* components */.wx; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "sO": function() { return /* reexport */ common/* useRef */.sO; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: API, Field, HoverCheckbox, Image, Loading, SendRequest, axios

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
;// CONCATENATED MODULE: ./src/constants/components/modals/select-job-modal.js

var CONSTANTS = {
    formInitialValues: {
        select_job: "",
        details: "",
        stages: "",
        automations: "",
        scorecards: "",
        sharing: ""
    }
};
var SELECT_JOB_VALIDATION = function(t) {
    return common/* Yup.object */.sm.object().shape({
        select_job: common/* Yup.string */.sm.string().required(t("errors:required")).nullable()
    });
};

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
;// CONCATENATED MODULE: ./src/actions/components/modal/select-job-modal.js





var SelectJobModalAction = /*#__PURE__*/ function() {
    "use strict";
    function SelectJobModalAction(setShowLoader, setApiError, setOptions, checkboxStep, setCheckboxStep, setFlagForRerender, router, setButtonPopup, formRef, selectJobRef) {
        (0,_class_call_check/* default */.Z)(this, SelectJobModalAction);
        this.selectJobModalService = new SelectJobModalService();
        this.setApiError = setApiError;
        this.setOptions = setOptions;
        this.setShowLoader = setShowLoader;
        this.checkboxStep = checkboxStep;
        this.setCheckboxStep = setCheckboxStep;
        this.setFlagForRerender = setFlagForRerender;
        this.router = router;
        this.customToastrAction = new common/* CustomToastrAction */.Y5();
        this.setButtonPopup = setButtonPopup;
        this.formRef = formRef;
        this.selectJobRef = selectJobRef;
    }
    (0,_create_class/* default */.Z)(SelectJobModalAction, [
        {
            key: "getPreviousJobData",
            value: function getPreviousJobData(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.selectJobModalService.getPreviousImportData(params)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                return [
                                    2,
                                    result.data
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "dropdownJobOptions",
            value: function dropdownJobOptions(data, t) {
                var listOptions = [
                    {
                        label: t("label:active"),
                        options: []
                    },
                    {
                        label: t("label:archived"),
                        options: []
                    }
                ];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = data.active.options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        listOptions[0].options.push({
                            label: "".concat(element.job_title_name, " (").concat(element.system_reference, ")"),
                            value: element.id
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = data.archived.options[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var element1 = _step1.value;
                        listOptions[1].options.push({
                            label: "".concat(element1.job_title_name, " (").concat(element1.system_reference, ")"),
                            value: element1.id
                        });
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return listOptions;
            }
        },
        {
            key: "getArchiveJob",
            value: function getArchiveJob(event, t) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var params, _tmp, _tmp1, data, options;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                _tmp1 = {};
                                params = event.target.checked ? (_tmp.include_archived = true, _tmp) : _tmp1;
                                return [
                                    4,
                                    _this.getPreviousJobData(params)
                                ];
                            case 1:
                                data = _state.sent();
                                options = _this.dropdownJobOptions(data.data, t);
                                _this.selectJobRef.current.select ? _this.selectJobRef.current.select.clearValue() : "";
                                _this.setOptions(options);
                                _this.setFlagForRerender(Math.random() * 10000);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "checkboxChange",
            value: function checkboxChange(event, formik) {
                var key = event.target.value;
                this.checkboxStep[key] = event.target.checked;
                this.setCheckboxStep(this.checkboxStep);
                if (key == "stages" && !event.target.checked) {
                    this.checkboxStep["automations"] = event.target.checked;
                    this.setCheckboxStep(this.checkboxStep);
                    formik.setFieldValue("automations", event.target.checked);
                }
                this.setFlagForRerender(Math.random() * 10000);
                formik.setFieldValue(key, event.target.checked);
            }
        },
        {
            key: "submitForm",
            value: function submitForm(values) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var steps, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, params, _tmp, result, link;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                steps = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = Object.keys(_this.checkboxStep)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        key = _step.value;
                                        if (_this.checkboxStep[key]) {
                                            steps.push(key);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if (!(steps.length > 0)) return [
                                    3,
                                    2
                                ];
                                _this.setButtonPopup(false);
                                _this.setShowLoader(true);
                                _tmp = {};
                                params = (_tmp.job_id = values.select_job, _tmp.steps = steps, _tmp);
                                _this.router.query.job_id ? params["current_job_id"] = _this.router.query.job_id : "";
                                return [
                                    4,
                                    _this.selectJobModalService.importJob(params)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                if (result.request.status == common/* SUCCESS_REPONSE_CODE */.Us) {
                                    _this.customToastrAction.setNormalToastr(result.data.success, "success");
                                    link = common/* REDIRECT.client.jobs.edit.replace */.RQ.client.jobs.edit.replace("$job_id", result.data.id);
                                    _this.router.push(link);
                                } else {
                                    _this.customToastrAction.setNormalToastr(_this.getErrorFromHash(result.response.data.error), "warning");
                                }
                                _this.setShowLoader(false);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                _this.customToastrAction.setNormalToastr((0,common/* TRANSLATION */.TA)("errors:select_one_step"), "warning");
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getErrorFromHash",
            value: function getErrorFromHash(hash) {
                if (typeof hash == "string") {
                    return hash;
                } else {
                    return this.getErrorFromHash(hash[Object.keys(hash)[0]]);
                }
            }
        }
    ]);
    return SelectJobModalAction;
}();

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ./src/imports-files/components/model/custom-company-integration-modal.js + 3 modules
var custom_company_integration_modal = __webpack_require__(62641);
;// CONCATENATED MODULE: ./src/services/components/modal/select-job-modal.js







var SelectJobModalService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(SelectJobModalService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(SelectJobModalService);
    function SelectJobModalService() {
        (0,_class_call_check/* default */.Z)(this, SelectJobModalService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SelectJobModalService, [
        {
            key: "getPreviousImportData",
            value: function getPreviousImportData(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = custom_company_integration_modal/* API.client.jobs.GET_IMPORT_JOB_TEMPLATE_DATA */.bl.client.jobs.GET_IMPORT_JOB_TEMPLATE_DATA;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    custom_company_integration_modal/* axios.get */.od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "importJob",
            value: function importJob(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = custom_company_integration_modal/* API.client.jobs.IMPORT_JOB_TEMPLATE */.bl.client.jobs.IMPORT_JOB_TEMPLATE;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    custom_company_integration_modal/* axios.post */.od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return SelectJobModalService;
}(custom_company_integration_modal/* SendRequest */.Lt);

// EXTERNAL MODULE: ./src/styles/components/select-job-modal/_index.module.scss
var _index_module = __webpack_require__(2365);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/styles/components/careers/modal/_index.module.scss
var modal_index_module = __webpack_require__(98901);
var modal_index_module_default = /*#__PURE__*/__webpack_require__.n(modal_index_module);
;// CONCATENATED MODULE: ./src/imports-files/components/model/select-job-modal.js
// --------------------- COMMON ---------------------

// --------------------- COMMON ---------------------







/***/ }),

/***/ 37521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tl": function() { return /* reexport */ CONSTANTS; }
});

// UNUSED EXPORTS: API, AutocompleteError, Button, ButtonStyle, Deleteicon, ErrorPages, Exclamation, Field, Form, Formik, FormikControl, Image, InputError, MyInterviewWidget, PageStyle, SETUP_VIDEO_QA_INITIAL_VALUES, SETUP_VIDEO_QA_SCHEMA, SendRequest, Tooltip, VideoQAModalAction, VideoQAModalService, axios, cursorNone, toggleDisabled, useRouter, useSWR, useState

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/imports-files/components/model/custom-company-integration-modal.js + 3 modules
var custom_company_integration_modal = __webpack_require__(62641);
;// CONCATENATED MODULE: ./src/constants/components/modals/setup-video-qa.js

var CONSTANTS = {
    texts: {
        heading: "Setup Video Q & A",
        subheading1: "Select a language, add an introduction video, setup questions among other things to send a Video Q&A to your candidate",
        subheading2: "Interview Question",
        label1: "Language",
        label2: "Intro Video",
        label3: "Question",
        label4: "Description",
        label5: "Time to Answer",
        label6: "Sec",
        label7: "No. of attempts",
        label8: "Max. 3 attempts",
        placeholder_intro_video: "https://www.heartpace.com",
        placeholder_question: "Why do you want to work for our business?",
        placeholder_descripton: "Description for the question",
        add_question: "Add Question",
        customisations: "Customisations",
        practice_screen: "Practice Screen",
        optional: "Optional",
        automation: "Automation",
        expires: "Expires",
        review_email: "Review Email",
        save: "Save"
    },
    errors: {
        minimum: "Minimum $number",
        maximum: "Maximum $number"
    }
};
var setup_video_qa_SETUP_VIDEO_QA_INITIAL_VALUES = {
    language: "English",
    video_link: "",
    questions_attributes: [
        {
            question: "",
            description: "",
            attempts: 2,
            answer_time: 30,
            _destroy: false
        }
    ],
    job_stage_attributes: {
        automation: false
    },
    practise_screen: false,
    expires: ""
};
var SETUP_VIDEO_QA_SCHEMA = custom_company_integration_modal/* Yup.object */.sm.object({
    language: custom_company_integration_modal/* Yup.string */.sm.string().required((0,custom_company_integration_modal/* TRANSLATION */.TA)("errors:required")),
    video_link: custom_company_integration_modal/* Yup.string */.sm.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, (0,custom_company_integration_modal/* TRANSLATION */.TA)("errors:invalid_url")).nullable(true),
    questions_attributes: custom_company_integration_modal/* Yup.array */.sm.array(custom_company_integration_modal/* Yup.object */.sm.object().shape({
        question: custom_company_integration_modal/* Yup.string */.sm.string().required((0,custom_company_integration_modal/* TRANSLATION */.TA)("errors:required")),
        answer_time: custom_company_integration_modal/* Yup.number */.sm.number().required((0,custom_company_integration_modal/* TRANSLATION */.TA)("errors:required")).min(30, CONSTANTS.errors.minimum.replace("$number", 30)).max(120, CONSTANTS.errors.maximum.replace("$number", 120)).nullable(true),
        attempts: custom_company_integration_modal/* Yup.number */.sm.number().required((0,custom_company_integration_modal/* TRANSLATION */.TA)("errors:required")).min(1, CONSTANTS.errors.minimum.replace("$number", 1)).max(3, CONSTANTS.errors.maximum.replace("$number", 3)).nullable(true)
    })),
    expires: custom_company_integration_modal/* Yup.number */.sm.number().required((0,custom_company_integration_modal/* TRANSLATION */.TA)("errors:required"))
});

// EXTERNAL MODULE: ./src/pages/clients/dashboard/recruitments/my-interview-widget.js + 2 modules
var my_interview_widget = __webpack_require__(63523);
// EXTERNAL MODULE: ./public/icons/exclamation.svg
var exclamation = __webpack_require__(22461);
// EXTERNAL MODULE: ./public/icons/deleteicon.svg
var deleteicon = __webpack_require__(21384);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(30711);
// EXTERNAL MODULE: ./src/actions/components/custom-toastr.js
var custom_toastr = __webpack_require__(66939);
// EXTERNAL MODULE: ./src/services/pages/clients/candidates/kanban.js
var kanban = __webpack_require__(56075);
;// CONCATENATED MODULE: ./src/actions/components/modal/setup-video-qa.js









var VideoQAModalAction = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function VideoQAModalAction(router, setApiError, setFlagForRerender, deleteQuestionList, setDeleteQuestionList, setBtnPopup, formRef, setDisabledAddMoreQuestion) {
        _class_call_check(this, VideoQAModalAction);
        this.router = router;
        this.setApiError = setApiError;
        this.setFlagForRerender = setFlagForRerender;
        this.deleteQuestionList = deleteQuestionList;
        this.setDeleteQuestionList = setDeleteQuestionList;
        this.videoQAModalService = new VideoQAModalService();
        this.kanban = new Kanban();
        this.setBtnPopup = setBtnPopup;
        this.customToastrAction = new CustomToastrAction();
        this.formRef = formRef;
        this.setDisabledAddMoreQuestion = setDisabledAddMoreQuestion;
    }
    _create_class(VideoQAModalAction, [
        {
            key: "submitForm",
            value: function submitForm(data, values, fetchedInitialValues) {
                var _this = this;
                return _async_to_generator(function() {
                    var operation_type, result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                operation_type = _this.setOperationType(fetchedInitialValues, values);
                                values["job_id"] = data.job_id;
                                values["job_stage_id"] = data.id;
                                values["job_stage_attributes"]["id"] = data.id;
                                values["job_stage_attributes"]["job_id"] = data.job_id;
                                values["job_stage_attributes"]["stage_id"] = data.stage_id;
                                values["job_stage_attributes"]["order"] = data.order;
                                values = _this.setQuestionsValues(values);
                                result = "";
                                if (!(operation_type == "create")) return [
                                    3,
                                    2
                                ];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    // remove id's from the question attributes for creating
                                    for(_iterator = values.questions_attributes[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        element = _step.value;
                                        delete element.id;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return [
                                    4,
                                    _this.videoQAModalService.createQuestions(values)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.response);
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.videoQAModalService.updateQuestions(values)
                                ];
                            case 3:
                                result = _state.sent();
                                _this.setApiError(result.response);
                                _state.label = 4;
                            case 4:
                                if (result.request.status == 200) {
                                    _this.setBtnPopup(false);
                                    _this.setFlagForRerender(Math.random() * 10000);
                                } else {
                                    _this.formRef.current.setStatus(result.response.data.error);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setOperationType",
            value: function setOperationType(fetchedInitialValues, values) {
                // if the form value changes 
                // or the questions are added or deleted
                //  if(this.formRef.current.dirty || values.questions_attributes.length > fetchedInitialValues.questions_attributes.length)
                //  {
                //     return 'create';
                //  }
                //  else
                //  {
                return "update";
            //  }
            }
        },
        {
            key: "getVideoModalData",
            value: function getVideoModalData(data) {
                var _this = this;
                return _async_to_generator(function() {
                    var job_id, job_stage_id, params, _tmp, result, email_data, _tmp1, _tmp2;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                job_id = data.job_id;
                                job_stage_id = data.id;
                                _tmp = {};
                                params = (_tmp.job_id = job_id, _tmp.job_stage_id = job_stage_id, _tmp);
                                return [
                                    4,
                                    _this.videoQAModalService.getJobList(params)
                                ];
                            case 1:
                                result = _state.sent();
                                _tmp1 = {};
                                return [
                                    4,
                                    _this.kanban.reviewAutomationEmail(job_id, (_tmp1.key = "move_candidates", _tmp1.stage_id = job_stage_id, _tmp1.list = true, _tmp1))
                                ];
                            case 2:
                                email_data = _state.sent();
                                _this.setApiError(result.request && email_data.request);
                                _tmp2 = {};
                                return [
                                    2,
                                    (_tmp2.component_data = result.data, _tmp2.email_data = email_data, _tmp2)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "NumberField",
            value: function NumberField(param) {
                var field = param.field, className = param.className, disabled = param.disabled, format = param.format, placeholder = param.placeholder, style = param.style, formik = param.formik, isAllowed = param.isAllowed, onValueChange = param.onValueChange, defaultValue = param.defaultValue;
                return /*#__PURE__*/ _jsx(NumberFormat, {
                    defaultValue: defaultValue,
                    thousandsGroupStyle: "thousand",
                    name: field.name,
                    format: format,
                    displayType: "input",
                    type: "text",
                    className: className,
                    style: style,
                    formik: formik,
                    disabled: disabled,
                    placeholder: placeholder,
                    thousandSeparator: true,
                    allowNegative: false,
                    isAllowed: isAllowed,
                    onValueChange: onValueChange
                });
            }
        },
        {
            key: "setLanguageList",
            value: function setLanguageList(data) {
                var list_data = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(data)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        list_data.push({
                            value: data[key].title,
                            label: data[key].title
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return list_data;
            }
        },
        {
            key: "setInitialValues",
            value: function setInitialValues(data) {
                var initialData = "";
                if (data.component_data.questions_attributes) {
                    initialData = data.component_data;
                } else {
                    initialData = SETUP_VIDEO_QA_INITIAL_VALUES;
                    var job_stage_attributes = {
                        automation: data.component_data.automation,
                        disabled_automation: data.component_data.disabled_automation
                    };
                    initialData.job_stage_attributes = job_stage_attributes;
                }
                return initialData;
            }
        },
        {
            key: "onAddClick",
            value: function onAddClick(formik) {
                formik.values.questions_attributes.push({
                    question: "",
                    description: "",
                    attempts: 2,
                    answer_time: 30,
                    _destroy: false
                });
                this.setFlagForRerender(Math.random() * 10000);
                if (formik.values.questions_attributes.length == 5) {
                    this.setDisabledAddMoreQuestion(true);
                }
            }
        },
        {
            key: "onDeleteClick",
            value: function onDeleteClick(formik, index) {
                this.deleteQuestionList.push(formik.values.questions_attributes[index]);
                this.deleteQuestionList[this.deleteQuestionList.length - 1]["_destroy"] = true;
                this.setDeleteQuestionList(this.deleteQuestionList);
                this.setDisabledAddMoreQuestion(false);
                formik.values.questions_attributes.splice(index, 1);
                this.setFlagForRerender(Math.random() * 10000);
            }
        },
        {
            key: "setQuestionsValues",
            value: function setQuestionsValues(values) {
                values.questions_attributes = Object.assign([], values.questions_attributes, this.deleteQuestionList);
                return values;
            }
        }
    ]);
    return VideoQAModalAction;
}()));

;// CONCATENATED MODULE: ./src/services/components/modal/setup-video-qa.js







var setup_video_qa_VideoQAModalService = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(SendRequest) {
    "use strict";
    _inherits(VideoQAModalService, SendRequest);
    var _super = _create_super(VideoQAModalService);
    function VideoQAModalService() {
        _class_call_check(this, VideoQAModalService);
        return _super.apply(this, arguments);
    }
    _create_class(VideoQAModalService, [
        {
            key: "getJobList",
            value: function getJobList(params) {
                var _this = this;
                return _async_to_generator(function() {
                    var url, result, _tmp, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                url = API.VIDEO_QA_INTERVIEW.SHOW.replace("$job_stage_id", params.job_stage_id).replace("$job_id", params.job_id);
                                _tmp = {};
                                return [
                                    4,
                                    axios.get(url, (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createQuestions",
            value: function createQuestions(params) {
                var _this = this;
                return _async_to_generator(function() {
                    var url, result, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                url = API.VIDEO_QA_INTERVIEW.CREATE.replace("$job_stage_id", params.job_stage_id).replace("$job_id", params.job_id);
                                return [
                                    4,
                                    axios.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateQuestions",
            value: function updateQuestions(params) {
                var _this = this;
                return _async_to_generator(function() {
                    var url, result, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                url = API.VIDEO_QA_INTERVIEW.UPDATE.replace("$job_stage_id", params.job_stage_id).replace("$job_id", params.job_id);
                                return [
                                    4,
                                    axios.patch(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return VideoQAModalService;
}(SendRequest)));

// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/common.js
var jobs_common = __webpack_require__(90432);
;// CONCATENATED MODULE: ./src/imports-files/components/model/setup-video-qa.js
// --------------------- COMMON ---------------------

// --------------------- COMMON ---------------------












/***/ }),

/***/ 3623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ components_button/* default */.Z; },
  "XZ": function() { return /* reexport */ common/* Checkbox */.XZ; },
  "bN": function() { return /* reexport */ common/* CheckedCheckbox */.bN; },
  "v0": function() { return /* reexport */ common/* DefaultCheckbox */.v0; },
  "l0": function() { return /* reexport */ common/* Form */.l0; },
  "w2": function() { return /* reexport */ (_index_module_default()); },
  "x": function() { return /* reexport */ common/* FormStyle */.x; },
  "J9": function() { return /* reexport */ common/* Formik */.J9; },
  "gt": function() { return /* reexport */ common/* FormikControl */.gt; },
  "pd": function() { return /* reexport */ common/* InputError */.pd; },
  "oH": function() { return /* reexport */ common/* InputText */.oH; },
  "k2": function() { return /* reexport */ (share_cv_index_module_default()); },
  "OT": function() { return /* reexport */ review_email/* REVIEW_EMAIL */.O; },
  "fY": function() { return /* reexport */ ReviewEmailActions; },
  "fu": function() { return /* reexport */ components_review_email/* ReviewEmailServices */.f; },
  "A$": function() { return /* reexport */ common/* clearSWRCache */.A$; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "sO": function() { return /* reexport */ common/* useRef */.sO; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: Close, HoverCheckbox

// EXTERNAL MODULE: ./src/constants/components/review-email.js
var review_email = __webpack_require__(79300);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/candidates/kanban.js + 10 modules
var kanban = __webpack_require__(47942);
// EXTERNAL MODULE: ./src/services/components/review-email.js
var components_review_email = __webpack_require__(47896);
// EXTERNAL MODULE: ./src/services/pages/clients/recruitment/email-templates.js
var email_templates = __webpack_require__(32784);
;// CONCATENATED MODULE: ./src/actions/components/review-email.js









var ReviewEmailActions = /*#__PURE__*/ function() {
    "use strict";
    function ReviewEmailActions() {
        (0,_class_call_check/* default */.Z)(this, ReviewEmailActions);
        this.reviewEmailService = new components_review_email/* ReviewEmailServices */.f();
        this.customToastrAction = new common/* CustomToastrAction */.Y5();
    }
    (0,_create_class/* default */.Z)(ReviewEmailActions, [
        {
            key: "submitReviewEmail",
            value: function submitReviewEmail(values, setReviewEmail, emailTemplateInfo, emailTemplateData, setEmailTemplateData, setFlagForRender, formRef, router, setDisabledSubmitButton) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, body, _tmp, _tmp1, ref, newTemplateData, _tmp2;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                result = "";
                                _tmp = {};
                                body = _tmp;
                                setDisabledSubmitButton(true);
                                if (!(emailTemplateInfo.operation_type == "create")) return [
                                    3,
                                    5
                                ];
                                body = {
                                    values: values
                                };
                                body.values["type"] = router.query.email_type;
                                body.values["master_template_id"] = values.master_template_id;
                                return [
                                    4,
                                    _this.reviewEmailService.createCustomEmail(values)
                                ];
                            case 1:
                                result = _state.sent();
                                _tmp1 = {};
                                if (result.request.status == 200) {
                                    _this.customToastrAction.setNormalToastr(result.success, "success");
                                    // toastr.success(result.success);
                                    setEmailTemplateData((_tmp1.count = result.data.total_count, _tmp1.data = result.data.templates, _tmp1));
                                    setReviewEmail(false);
                                } else {
                                    formRef.current.setStatus(result.response.data.error);
                                }
                                return [
                                    4,
                                    delete router.query.purpose
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    delete router.query.created_at
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    delete router.query.created_by
                                ];
                            case 4:
                                _state.sent();
                                (0,kanban/* addParamsToUrl */.Sr)(router.query, router);
                                setFlagForRender(Math.random() * 10000);
                                return [
                                    3,
                                    7
                                ];
                            case 5:
                                if (!(emailTemplateInfo.operation_type == "edit")) return [
                                    3,
                                    7
                                ];
                                body = {
                                    email_body: values.template.email_body,
                                    subject: values.template.subject,
                                    type: router.query.email_type,
                                    default: (ref = values.template) === null || ref === void 0 ? void 0 : ref.default,
                                    purpose: values.template.purpose
                                };
                                if (router.query.created_by) body.created_by = router.query.created_by;
                                return [
                                    4,
                                    _this.reviewEmailService.updateEmailTemplate(body, values.template.master_template_id)
                                ];
                            case 6:
                                result = _state.sent();
                                _tmp2 = {};
                                if (result.request.status == 200) {
                                    newTemplateData = emailTemplateData.map(function(emailTemplate) {
                                        if (emailTemplate.id == emailTemplateInfo.template_id) {
                                            return result.data;
                                        } else {
                                            return emailTemplate;
                                        }
                                    });
                                    _this.customToastrAction.setNormalToastr(result.data.success, "success");
                                    // toastr.success(result.data.success);
                                    setEmailTemplateData((_tmp2.count = emailTemplateData.length, _tmp2.data = newTemplateData, _tmp2));
                                    setReviewEmail(false);
                                } else {
                                    formRef.current.setStatus(result.response.data.error);
                                }
                                _state.label = 7;
                            case 7:
                                setDisabledSubmitButton(false);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getEmailTemplateData",
            value: function getEmailTemplateData(router, info, template_id, emailTemplateData, type) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var template_data, body, purposelist, _tmp, purpose_list, _tmp1, _tmp2, _tmp3;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                template_data = "";
                                body = "";
                                if (!(type == "kanban")) return [
                                    3,
                                    1
                                ];
                                purposelist = [];
                                _tmp = {};
                                return [
                                    2,
                                    (_tmp.template_data = {
                                        data: emailTemplateData.templates[0]
                                    }, _tmp.purpose_list = purposelist, _tmp)
                                ];
                            case 1:
                                if (!(router.query.email_type == "custom")) return [
                                    3,
                                    3
                                ];
                                body = {
                                    type: "custom",
                                    master: false
                                };
                                if (router.query.created_by) body.created_by = router.query.created_by;
                                return [
                                    4,
                                    _this.reviewEmailService.getCustomEmailTemplate(body, template_id)
                                ];
                            case 2:
                                template_data = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                if (!(router.query.email_type == "system")) return [
                                    3,
                                    5
                                ];
                                body = {
                                    type: "system",
                                    master: false
                                };
                                return [
                                    4,
                                    _this.reviewEmailService.getSystemEmailTemplate(body, template_id)
                                ];
                            case 4:
                                template_data = _state.sent();
                                _state.label = 5;
                            case 5:
                                if (!(info.operation_type == "create")) return [
                                    3,
                                    7
                                ];
                                _tmp1 = {};
                                return [
                                    4,
                                    _this.getSystemPurposeList(_tmp1)
                                ];
                            case 6:
                                purpose_list = _state.sent();
                                _tmp2 = {};
                                return [
                                    2,
                                    (_tmp2.template_data = template_data, _tmp2.purpose_list = purpose_list, _tmp2)
                                ];
                            case 7:
                                _tmp3 = {};
                                return [
                                    2,
                                    (_tmp3.template_data = template_data, _tmp3.purpose_list = [], _tmp3)
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setFormInitialValues",
            value: function setFormInitialValues(initalData, type) {
                if (type == "kanban") {
                    review_email/* REVIEW_EMAIL.email_template.formInitialValue.template.master_template_id */.O.email_template.formInitialValue.template.master_template_id = initalData.master_template_id || "";
                    review_email/* REVIEW_EMAIL.email_template.formInitialValue.template.master_template_type */.O.email_template.formInitialValue.template.master_template_type = initalData.master_template_type || "";
                } else review_email/* REVIEW_EMAIL.email_template.formInitialValue.template.master_template_id */.O.email_template.formInitialValue.template.master_template_id = initalData.id || "";
                review_email/* REVIEW_EMAIL.email_template.formInitialValue.template.master_template_type */.O.email_template.formInitialValue.template.master_template_type = initalData.master_template_type || "";
                review_email/* REVIEW_EMAIL.email_template.formInitialValue.template.subject */.O.email_template.formInitialValue.template.subject = initalData.subject || "";
                review_email/* REVIEW_EMAIL.email_template.formInitialValue.template.email_body */.O.email_template.formInitialValue.template.email_body = initalData.email_body || "";
                review_email/* REVIEW_EMAIL.email_template.formInitialValue.template.default */.O.email_template.formInitialValue.template["default"] = initalData.default || false;
                review_email/* REVIEW_EMAIL.email_template.formInitialValue.template.purpose */.O.email_template.formInitialValue.template.purpose = initalData.purpose || "";
                return review_email/* REVIEW_EMAIL.email_template.formInitialValue */.O.email_template.formInitialValue;
            }
        },
        {
            key: "getFormFieldsName",
            value: function getFormFieldsName() {
                return {
                    type: "template",
                    master_template_id: "master_template_id",
                    subject: "subject",
                    body: "email_body",
                    default: "default",
                    master_template_type: "master_template_type",
                    master_template_attributes: "master_template_attributes",
                    purpose: "purpose"
                };
            }
        },
        {
            key: "resetTemplate",
            value: function resetTemplate(template_id, setReviewEmail) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var body, _tmp, result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                body = (_tmp.type = "system", _tmp);
                                return [
                                    4,
                                    _this.reviewEmailService.resetEmailTemplate(body, template_id)
                                ];
                            case 1:
                                result = _state.sent();
                                if (result.request.status == 200) {
                                    setReviewEmail(false);
                                    _this.customToastrAction.setNormalToastr(result.data.success, "success");
                                // toastr.success(result.data.success);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPurposeOptions",
            value: function getPurposeOptions(emailTemplateData, type, t) {
                var options = [
                    {
                        value: "add_custom",
                        "label": t("label:add:new_purpose"),
                        type: "CustomTemplate",
                        template_type: "custom",
                        template_id: ""
                    }
                ];
                var data = Array.isArray(emailTemplateData) ? emailTemplateData : [
                    emailTemplateData
                ];
                if (data) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            options.push({
                                value: type == "kanban" ? element.master_template_id : element.id,
                                label: element.purpose,
                                type: element.type,
                                template_type: element.template_type,
                                template_id: element.template_id
                            });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return {
                        options: options
                    };
                } else {
                    return [];
                }
            }
        },
        {
            key: "getSystemEmailTemplate",
            value: function getSystemEmailTemplate(select_option, formik, formFieldNames, setSubject, setDataVariables, setRefreshKey, t) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var master_template_id, master_template_type, template_type, template_id, body, _tmp, result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                master_template_id = select_option.value;
                                master_template_type = select_option.type;
                                template_type = select_option.template_type;
                                template_id = select_option.template_id;
                                if (!(master_template_id == "add_custom")) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    formik.setFieldValue("".concat(formFieldNames.type, ".").concat(formFieldNames.subject), "")
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("".concat(formFieldNames.type, ".").concat(formFieldNames.body), "")
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("".concat(formFieldNames.type, ".").concat(formFieldNames.master_template_id), master_template_id)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("".concat(formFieldNames.type, ".").concat(formFieldNames.master_template_type), master_template_type)
                                ];
                            case 4:
                                _state.sent();
                                setSubject(_this.subjectVars(t));
                                setDataVariables(_this.bodyVars(t));
                                setRefreshKey(Math.random() * 10000);
                                return [
                                    3,
                                    11
                                ];
                            case 5:
                                _tmp = {};
                                body = (_tmp.type = template_type, _tmp.master = template_type == "system" ? true : false, _tmp);
                                return [
                                    4,
                                    _this.reviewEmailService.getSystemEmailTemplate(body, template_id)
                                ];
                            case 6:
                                result = _state.sent();
                                if (!(result.request.status == 200)) return [
                                    3,
                                    11
                                ];
                                return [
                                    4,
                                    formik.setFieldValue("".concat(formFieldNames.type, ".").concat(formFieldNames.subject), result.data.subject)
                                ];
                            case 7:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("".concat(formFieldNames.type, ".").concat(formFieldNames.body), result.data.email_body)
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("".concat(formFieldNames.type, ".").concat(formFieldNames.master_template_id), master_template_id)
                                ];
                            case 9:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("".concat(formFieldNames.type, ".").concat(formFieldNames.master_template_type), master_template_type)
                                ];
                            case 10:
                                _state.sent();
                                setSubject(result.data.subject_variables);
                                setDataVariables(result.data.data_variables);
                                setRefreshKey(Math.random() * 10000);
                                _state.label = 11;
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSystemPurposeList",
            value: function getSystemPurposeList(params) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var system_result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    new email_templates/* EmailTemplatesService */.I().getSystemPurposeList()
                                ];
                            case 1:
                                system_result = _state.sent();
                                if (system_result.request.status == 200) {
                                    if (params.only_custom) {
                                        system_result.data.purposes_list.map(function(x) {
                                            if (x.template_type == "system") {
                                                x.is_custom_master = true;
                                            } else {
                                                x.is_custom_master = false;
                                            }
                                            return x;
                                        });
                                    }
                                    return [
                                        2,
                                        system_result.data.purposes_list
                                    ];
                                } else {
                                    return [
                                        2,
                                        []
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "saveEmailTemplate",
            value: function saveEmailTemplate(values, job_id, router, setHideModalClass, setReviewEmail, formRef, setDisabledSubmitButton) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var params, system_result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setDisabledSubmitButton(true);
                                params = values;
                                return [
                                    4,
                                    new email_templates/* EmailTemplatesService */.I().saveEmailTemplate(params, job_id)
                                ];
                            case 1:
                                system_result = _state.sent();
                                if (system_result.request.status == 200) {
                                    setReviewEmail(false);
                                    setHideModalClass(false);
                                    return [
                                        2,
                                        system_result.data
                                    ];
                                } else {
                                    formRef.current.setStatus(system_result.response.data.error);
                                }
                                setDisabledSubmitButton(false);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "bodyVars",
            value: function bodyVars(t) {
                var values = [
                    t("modal:data_variables:company_name"),
                    t("modal:data_variables:candidate_first_name"),
                    t("modal:data_variables:job_title"),
                    t("modal:data_variables:client_user_name"),
                    t("modal:data_variables:client_user_email_signature"),
                    t("modal:data_variables:user_email"),
                    t("modal:data_variables:website_url"),
                    t("modal:data_variables:job_url"),
                    t("modal:data_variables:company_facebook_url"),
                    t("modal:data_variables:company_twitter_url"),
                    t("modal:data_variables:company_linkedin_url"),
                    t("modal:data_variables:company_career_page"),
                    t("modal:data_variables:company_address")
                ];
                var body = [];
                values.map(function(val) {
                    body.push({
                        text: val,
                        value: "{{".concat(val, "}}")
                    });
                });
                return body;
            }
        },
        {
            key: "subjectVars",
            value: function subjectVars(t) {
                var values = [
                    t("modal:data_variables:company_name"),
                    t("modal:data_variables:candidate_first_name"),
                    t("modal:data_variables:job_title"),
                    t("modal:data_variables:client_user_name"),
                    t("modal:data_variables:user_email"),
                    t("modal:data_variables:company_address")
                ];
                var subject = [];
                values.map(function(val) {
                    subject.push({
                        text: val,
                        value: "{{".concat(val, "}}")
                    });
                });
                return subject;
            }
        },
        {
            key: "kanbanPurposeList",
            value: function kanbanPurposeList(emailTemplateData) {
                var options = [];
                emailTemplateData.templates.forEach(function(value, index) {
                    options.push({
                        value: index,
                        label: value.purpose
                    });
                });
                return options;
            }
        },
        {
            key: "setSystemTemplate",
            value: function setSystemTemplate(option, formik, formFieldNames, setSubject, setDataVariables, setRefreshKey, emailTemplateData) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var data;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                data = emailTemplateData["".concat(option.value)];
                                return [
                                    4,
                                    formik.setFieldValue("".concat(formFieldNames.type, ".").concat(formFieldNames.subject), data.subject)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("".concat(formFieldNames.type, ".").concat(formFieldNames.body), data.email_body)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("".concat(formFieldNames.type, ".").concat(formFieldNames.master_template_id), data.master_template_id)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("".concat(formFieldNames.type, ".").concat(formFieldNames.master_template_type), data.master_template_type)
                                ];
                            case 4:
                                _state.sent();
                                setSubject(data.subject_variables);
                                setDataVariables(data.data_variables);
                                setRefreshKey(Math.random() * 10000);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setUnsuccssfulModalData",
            value: function setUnsuccssfulModalData(option, formik, formFieldNames, setSubject, setDataVariables, setRefreshKey, emailTemplateData, setUnsuccessfulEmailValues) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var data, _tmp;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                data = emailTemplateData["".concat(option.value)];
                                return [
                                    4,
                                    formik.setFieldValue("".concat(formFieldNames.type, ".").concat(formFieldNames.master_template_id), data.master_template_id)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("".concat(formFieldNames.type, ".").concat(formFieldNames.master_template_type), data.master_template_type)
                                ];
                            case 2:
                                _state.sent();
                                _tmp = {};
                                if (setUnsuccessfulEmailValues) {
                                    setUnsuccessfulEmailValues((_tmp.cc = "", _tmp.subject = data.subject, _tmp.email_body = data.email_body, _tmp.entity_type = data.entity_type, _tmp));
                                }
                                setSubject(data.subject_variables);
                                setDataVariables(data.data_variables);
                                setRefreshKey(Math.random() * 10000);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "formValidation",
            value: function formValidation(current_purpose_type) {
                return common/* Yup.object */.sm.object().shape({
                    template: common/* Yup.object */.sm.object({
                        master_template_id: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")),
                        purpose: common/* Yup.string */.sm.string().when([], {
                            is: function() {
                                return current_purpose_type == "custom_template";
                            },
                            then: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")),
                            otherwise: common/* Yup.string */.sm.string().notRequired().nullable(true)
                        }),
                        master_template_attributes: common/* Yup.object */.sm.object().shape({
                            purpose: common/* Yup.string */.sm.string().when([], {
                                is: function() {
                                    return current_purpose_type == "add_custom";
                                },
                                then: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")),
                                otherwise: common/* Yup.string */.sm.string().notRequired().nullable(true)
                            })
                        }),
                        subject: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")),
                        email_body: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required"))
                    })
                });
            }
        }
    ]);
    return ReviewEmailActions;
}();

// EXTERNAL MODULE: ./src/styles/components/common-modal/form-modal/_index.module.scss
var _index_module = __webpack_require__(57860);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
// EXTERNAL MODULE: ./src/styles/components/share-cv/_index.module.scss
var share_cv_index_module = __webpack_require__(2443);
var share_cv_index_module_default = /*#__PURE__*/__webpack_require__.n(share_cv_index_module);
// EXTERNAL MODULE: ./public/new-icons/close.svg
var new_icons_close = __webpack_require__(14270);
;// CONCATENATED MODULE: ./src/imports-files/components/review-email.js










/***/ }),

/***/ 32510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ju": function() { return /* reexport */ components_sidebar/* ADMIN_SIDEBAR_OPTIONS */.ju; },
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "FZ": function() { return /* reexport */ AddUsers; },
  "Xd": function() { return /* reexport */ arrowleft/* default */.Z; },
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "ZJ": function() { return /* reexport */ common/* ButtonStyle */.ZJ; },
  "Bz": function() { return /* reexport */ onboarding_steps/* CLIENT_ONBOARDING_STEPS */.B; },
  "QM": function() { return /* reexport */ common/* CSVReader */.QM; },
  "af": function() { return /* reexport */ CSV_FILE_SIZE_LIMIT; },
  "LD": function() { return /* reexport */ common/* ClientDashboard */.LD; },
  "Tw": function() { return /* reexport */ icons_close/* default */.Z; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "QJ": function() { return /* reexport */ common/* DataFromUrl */.QJ; },
  "N4": function() { return /* reexport */ edit/* EditClient */.N; },
  "dC": function() { return /* reexport */ common/* ErrorPages */.dC; },
  "F2": function() { return /* reexport */ common/* FieldArray */.F2; },
  "l0": function() { return /* reexport */ common/* Form */.l0; },
  "x": function() { return /* reexport */ common/* FormStyle */.x; },
  "J9": function() { return /* reexport */ common/* Formik */.J9; },
  "gt": function() { return /* reexport */ common/* FormikControl */.gt; },
  "pd": function() { return /* reexport */ input_error/* InputError */.p; },
  "Mf": function() { return /* reexport */ common/* PAGE_ANIMATION_OPTIONS */.Mf; },
  "k2": function() { return /* reexport */ (_index_module_default()); },
  "RQ": function() { return /* reexport */ common/* REDIRECT */.RQ; },
  "Us": function() { return /* reexport */ common/* SUCCESS_REPONSE_CODE */.Us; },
  "Lt": function() { return /* reexport */ send_request/* SendRequest */.L; },
  "Dv": function() { return /* reexport */ sidebar/* SidebarAction */.D; },
  "if": function() { return /* reexport */ skip_modal/* SkipModal */.i; },
  "TA": function() { return /* reexport */ common/* TRANSLATION */.TA; },
  "t9": function() { return /* reexport */ common/* UNAUTHORIZED_REPONSE_CODE */.t9; },
  "Mn": function() { return /* reexport */ common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn; },
  "T1": function() { return /* reexport */ VALIDATION_SCHEMA; },
  "sm": function() { return /* reexport */ common/* Yup */.sm; },
  "yG": function() { return /* reexport */ addTeamMembers; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "A$": function() { return /* reexport */ common/* clearSWRCache */.A$; },
  "dl": function() { return /* reexport */ add_users/* getClientData */.dl; },
  "Rf": function() { return /* reexport */ getMyTeam; },
  "I6": function() { return /* reexport */ add_users/* handelFileChange */.I6; },
  "x0": function() { return /* reexport */ add_users/* handleOnSubmit */.x0; },
  "GB": function() { return /* reexport */ common/* handleOtherResponseCode */.GB; },
  "EA": function() { return /* reexport */ common/* motion */.EA; },
  "Yk": function() { return /* reexport */ add_users/* onAdminUserAdd */.Yk; },
  "Ej": function() { return /* reexport */ add_users/* onAdminUserRemove */.Ej; },
  "MZ": function() { return /* reexport */ clients_common/* sendToCurrentOnboardingSteps */.MZ; },
  "Qy": function() { return /* reexport */ setAddUserInitialValues; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "NL": function() { return /* reexport */ common/* useQueryClient */.NL; },
  "sO": function() { return /* reexport */ common/* useRef */.sO; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: Component, ErrorMessage, Field, FontAwesomeIcon, Image, Link, NextServerCookies, React, Sidebar, faExclamationCircle, faTimes, getIn, getSession, goToNextPage, roles, signIn, toastr

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/actions/pages/admins/dashboard/clients/add-users.js
var add_users = __webpack_require__(88161);
// EXTERNAL MODULE: ./src/actions/common/input-error.js
var input_error = __webpack_require__(54911);
// EXTERNAL MODULE: ./src/actions/components/sidebar.js + 1 modules
var sidebar = __webpack_require__(39826);
// EXTERNAL MODULE: ./src/actions/pages/admins/dashboard/clients/common.js
var clients_common = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/constants/pages/admins/dashboard/clients/users.js

var CSV_FILE_SIZE_LIMIT = 1000000;
function setAddUserInitialValues() {
    return {
        client: {
            client_users_attributes: []
        }
    };
}
var VALIDATION_SCHEMA = common/* Yup.object */.sm.object().shape({
    client: common/* Yup.object */.sm.object().shape({
        client_users_attributes: common/* Yup.array */.sm.array().of(common/* Yup.object */.sm.object({
            _destroy: common/* Yup.boolean */.sm.boolean(),
            role_id: common/* Yup.string */.sm.string().when("_destroy", {
                is: function(_destroy) {
                    return !_destroy;
                },
                then: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required"))
            }),
            user_attributes: common/* Yup.object */.sm.object().when("_destroy", {
                is: function(_destroy) {
                    return !_destroy;
                },
                then: common/* Yup.object */.sm.object({
                    email: common/* Yup.string */.sm.string().email((0,common/* TRANSLATION */.TA)("errors:invalid_email")).required((0,common/* TRANSLATION */.TA)("errors:required")),
                    name: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable()
                })
            })
        }))
    })
});

// EXTERNAL MODULE: ./src/constants/common/onboarding-steps.js
var onboarding_steps = __webpack_require__(2528);
// EXTERNAL MODULE: ./src/constants/components/sidebar.js
var components_sidebar = __webpack_require__(73257);
// EXTERNAL MODULE: ./src/components/skip-modal.js
var skip_modal = __webpack_require__(53594);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ./src/actions/components/custom-toastr.js
var custom_toastr = __webpack_require__(66939);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/activities/index.js + 26 modules
var activities = __webpack_require__(14683);
;// CONCATENATED MODULE: ./src/actions/pages/clients/add-team.js




function getMyTeam(router, setApiError) {
    return _getMyTeam.apply(this, arguments);
}
function _getMyTeam() {
    _getMyTeam = (0,_async_to_generator/* default */.Z)(function(router, setApiError) {
        var body, _tmp, result, error, role_ids;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = (_tmp.step = router.query.step, _tmp);
                    return [
                        4,
                        new activities/* MyTeamService */.Qx().getTeamDetails(body)
                    ];
                case 1:
                    result = _state.sent();
                    setApiError(result.request);
                    if (result.status == undefined || result.status != 200) {
                        error = new Error("An error occurred while fetching the data.");
                        error.status = result.response.status;
                        throw error;
                    } else {
                        role_ids = result.data.user_roles.map(function(x) {
                            return x.value;
                        });
                        result.data.client.client_users_attributes = result.data.client.client_users_attributes.filter(function(x) {
                            if (role_ids.includes(x.role_id)) return x;
                        });
                        return [
                            2,
                            result.data
                        ];
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getMyTeam.apply(this, arguments);
}
function addTeamMembers(params, router, quick_setup) {
    return _addTeamMembers.apply(this, arguments);
}
function _addTeamMembers() {
    _addTeamMembers = (0,_async_to_generator/* default */.Z)(function(params, router, quick_setup) {
        var body, _tmp, result, status_code, customToastrAction, next_step, url;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = (_tmp.client = {
                        id: params.client.id,
                        client_users_attributes: params.client.client_users_attributes
                    }, _tmp);
                    if (quick_setup) body.quick_setup = quick_setup;
                    return [
                        4,
                        new activities/* MyTeamService */.Qx().addTeamMembers(body)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new custom_toastr/* CustomToastrAction */.Y();
                    switch(status_code){
                        case activities/* SUCCESS_REPONSE_CODE */.Us:
                            customToastrAction.setNormalToastr(result.data.success, "success");
                            // toastr.success(result.data.success)
                            if (result.data.next_step) {
                                next_step = result.data.next_step;
                                url = "".concat(activities/* REDIRECT.client.quick_setup */.RQ.client.quick_setup).concat(next_step);
                                next_step == "complete" ? router.push(activities/* REDIRECT.client.activities */.RQ.client.activities) : router.push(url);
                            }
                            break;
                        case activities/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            return [
                                2,
                                result.response.data.error
                            ];
                            break;
                        default:
                            (0,activities/* handleOtherResponseCode */.GB)(status_code, args.router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _addTeamMembers.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/imports-files/pages/clients/add-team.js


// EXTERNAL MODULE: ./src/services/common/send-request.js
var send_request = __webpack_require__(34964);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
;// CONCATENATED MODULE: ./src/services/pages/admins/dashboard/clients/add-users.js







var AddUsers = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(AddUsers, SendRequest);
    var _super = (0,_create_super/* default */.Z)(AddUsers);
    function AddUsers() {
        (0,_class_call_check/* default */.Z)(this, AddUsers);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(AddUsers, [
        {
            key: "createNewClientUser",
            value: function createNewClientUser(params, client_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(common/* API.admins.dashboard.clients.users.CREATE_NEW_CLIENTS_URL.replace */.bl.admins.dashboard.clients.users.CREATE_NEW_CLIENTS_URL.replace("$client_id", client_id), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getClientUserRoles",
            value: function getClientUserRoles(client_auth_cookies) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    (0,common/* axios */.od)((_tmp.method = "get", _tmp.url = common/* API.client.welcome.invite_admin */.bl.client.welcome.invite_admin, _tmp.headers = {
                                        cookie: "Authorization=".concat(client_auth_cookies)
                                    }, _tmp))
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getUserRoles",
            value: function getUserRoles() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(common/* API.admins.dashboard.clients.users.GET_NEW_CLIENT_ROLE_URL */.bl.admins.dashboard.clients.users.GET_NEW_CLIENT_ROLE_URL, _tmp, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AddUsers;
}(send_request/* SendRequest */.L);

// EXTERNAL MODULE: ./src/services/pages/admins/dashboard/clients/edit.js
var edit = __webpack_require__(26013);
// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(85155);
// EXTERNAL MODULE: ./public/icons/arrowleft.svg
var arrowleft = __webpack_require__(65661);
// EXTERNAL MODULE: ./src/styles/components/progressline/_index.module.scss
var _index_module = __webpack_require__(39923);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
;// CONCATENATED MODULE: ./src/imports-files/pages/admins/dashboard/clients/add-users.js
//* This file contains the export files statement which will be export again in the pages
// ----------------- Common Library -----------------

// ----------------- Common Library -----------------
// ----------------- Actions ---------------------




// ----------------- Action ---------------------
// -----------------------------  CONSTANTS -----------------------------



// -----------------------------  CONSTANTS -----------------------------
// -----------------------------  COMPONENTS -----------------------------


// -----------------------------  COMPONENTS -----------------------------
// ------------------SERVICES -------------------



// ------------------SERVICES ------------------
// ------------------ICONS -------------------


// ------------------ICONS -------------------
// ----------------- Stylesheet ---------------------
 // ----------------- Stylesheet ---------------------


/***/ }),

/***/ 20504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ju": function() { return /* reexport */ components_sidebar/* ADMIN_SIDEBAR_OPTIONS */.ju; },
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "Bz": function() { return /* reexport */ onboarding_steps/* CLIENT_ONBOARDING_STEPS */.B; },
  "LD": function() { return /* reexport */ common/* ClientDashboard */.LD; },
  "Od": function() { return /* reexport */ client_form["default"]; },
  "QJ": function() { return /* reexport */ common/* DataFromUrl */.QJ; },
  "N4": function() { return /* reexport */ edit/* EditClient */.N; },
  "dC": function() { return /* reexport */ common/* ErrorPages */.dC; },
  "Lt": function() { return /* reexport */ send_request/* SendRequest */.L; },
  "Dv": function() { return /* reexport */ sidebar/* SidebarAction */.D; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "A$": function() { return /* reexport */ common/* clearSWRCache */.A$; },
  "Iw": function() { return /* reexport */ getClientNewData; },
  "MZ": function() { return /* reexport */ clients_common/* sendToCurrentOnboardingSteps */.MZ; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "NL": function() { return /* reexport */ common/* useQueryClient */.NL; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; }
});

// UNUSED EXPORTS: Button, ButtonStyle, Checkbox, Component, Congrats, ErrorMessage, Field, FieldArray, FontAwesomeIcon, Form, FormStyle, Formik, FormikControl, INITIAL_VALUES, Image, InputError, Link, NextServerCookies, PageStyle, PopupStyle, REDIRECT, React, SUCCESS_REPONSE_CODE, Sidebar, TRANSLATION, UNPROCESSABLE_ENTITY_RESPONSE_CODE, VALIDATION_SCHEMA, Yup, faExclamationCircle, faTimes, getIn, getSession, handleOtherResponseCode, signIn, toastr, useTranslation

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/pages/admins/dashboard/clients/client-form.js
var client_form = __webpack_require__(56397);
// EXTERNAL MODULE: ./src/actions/common/input-error.js
var input_error = __webpack_require__(54911);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
;// CONCATENATED MODULE: ./src/actions/pages/admins/dashboard/clients/edit.js



function getClientNewData(setApiError) {
    return _getClientNewData.apply(this, arguments);
}
function _getClientNewData() {
    _getClientNewData = (0,_async_to_generator/* default */.Z)(function(setApiError) {
        var client_id, result, client, data, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client_id = new common/* DataFromUrl */.QJ().getClientId();
                    return [
                        4,
                        new edit/* EditClient */.N().getClientInfo(client_id)
                    ];
                case 1:
                    result = _state.sent();
                    setApiError(result.request);
                    client = result.data.client || null;
                    _tmp = {};
                    data = (_tmp.props = {
                        client: client
                    }, _tmp);
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return _getClientNewData.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/actions/common/response-handler.js
var response_handler = __webpack_require__(24906);
// EXTERNAL MODULE: ./src/actions/components/sidebar.js + 1 modules
var sidebar = __webpack_require__(39826);
// EXTERNAL MODULE: ./src/actions/pages/admins/dashboard/clients/common.js
var clients_common = __webpack_require__(33399);
// EXTERNAL MODULE: ./src/services/common/send-request.js
var send_request = __webpack_require__(34964);
// EXTERNAL MODULE: ./src/services/pages/admins/dashboard/clients/edit.js
var edit = __webpack_require__(26013);
// EXTERNAL MODULE: ./src/constants/pages/admins/dashboard/clients/new.js
var clients_new = __webpack_require__(25068);
// EXTERNAL MODULE: ./src/constants/common/onboarding-steps.js
var onboarding_steps = __webpack_require__(2528);
// EXTERNAL MODULE: ./src/constants/components/sidebar.js
var components_sidebar = __webpack_require__(73257);
;// CONCATENATED MODULE: ./src/imports-files/pages/admins/dashboard/clients/edit.js
//* This file contains the export files statement which will be export again in the pages
// ----------------- Common Library -----------------

// ----------------- Common Library -----------------
// ----------------- Page  -----------------------

// ----------------- Page  -----------------------
// ----------------- Actions ---------------------





// ----------------- Action ---------------------
// --------------------Services----------


// ------------------Services-----------
// -----------------------------  CONSTANTS -----------------------------



// -----------------------------  CONSTANTS -----------------------------
// ----------------- Stylesheet ---------------------

 // ----------------- Stylesheet ---------------------


/***/ }),

/***/ 48847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ju": function() { return /* reexport */ components_sidebar/* ADMIN_SIDEBAR_OPTIONS */.ju; },
  "bl": function() { return /* reexport */ common_common/* API */.bl; },
  "Xd": function() { return /* reexport */ arrowleft/* default */.Z; },
  "zx": function() { return /* reexport */ components_button/* default */.Z; },
  "ZJ": function() { return /* reexport */ (button_index_module_default()); },
  "Bz": function() { return /* reexport */ onboarding_steps/* CLIENT_ONBOARDING_STEPS */.B; },
  "LD": function() { return /* reexport */ common_common/* ClientDashboard */.LD; },
  "qI": function() { return /* reexport */ ClientIntegration; },
  "CJ": function() { return /* reexport */ congrats/* default */.Z; },
  "Y5": function() { return /* reexport */ common_common/* CustomToastrAction */.Y5; },
  "QJ": function() { return /* reexport */ common_common/* DataFromUrl */.QJ; },
  "dC": function() { return /* reexport */ common_common/* ErrorPages */.dC; },
  "gN": function() { return /* reexport */ common_common/* Field */.gN; },
  "F2": function() { return /* reexport */ common_common/* FieldArray */.F2; },
  "wn": function() { return /* reexport */ filter/* default */.Z; },
  "l0": function() { return /* reexport */ common_common/* Form */.l0; },
  "J9": function() { return /* reexport */ common_common/* Formik */.J9; },
  "Ee": function() { return /* reexport */ common_common/* Image */.Ee; },
  "y4": function() { return /* reexport */ react_number_format_es/* default */.Z; },
  "Mf": function() { return /* reexport */ common_common/* PAGE_ANIMATION_OPTIONS */.Mf; },
  "k2": function() { return /* reexport */ (_index_module_default()); },
  "Qd": function() { return /* reexport */ (congrats_index_module_default()); },
  "RQ": function() { return /* reexport */ common_common/* REDIRECT */.RQ; },
  "Us": function() { return /* reexport */ common_common/* SUCCESS_REPONSE_CODE */.Us; },
  "Lt": function() { return /* reexport */ send_request/* SendRequest */.L; },
  "Dv": function() { return /* reexport */ sidebar/* SidebarAction */.D; },
  "z0": function() { return /* reexport */ (integration_index_module_default()); },
  "iA": function() { return /* reexport */ Table/* default */.Z; },
  "RM": function() { return /* reexport */ TableBody/* default */.Z; },
  "pj": function() { return /* reexport */ TableCell/* default */.Z; },
  "xJ": function() { return /* reexport */ TableContainer/* default */.Z; },
  "ss": function() { return /* reexport */ TableHead/* default */.Z; },
  "SC": function() { return /* reexport */ TableRow/* default */.Z; },
  "t9": function() { return /* reexport */ common_common/* UNAUTHORIZED_REPONSE_CODE */.t9; },
  "sm": function() { return /* reexport */ common_common/* Yup */.sm; },
  "od": function() { return /* reexport */ common_common/* axios */.od; },
  "A$": function() { return /* reexport */ common_common/* clearSWRCache */.A$; },
  "qL": function() { return /* reexport */ createIntegrationData; },
  "rH": function() { return /* reexport */ getIntegrationData; },
  "GB": function() { return /* reexport */ common_common/* handleOtherResponseCode */.GB; },
  "gs": function() { return /* reexport */ common_common/* imageSize */.gs; },
  "EA": function() { return /* reexport */ common_common/* motion */.EA; },
  "MZ": function() { return /* reexport */ common/* sendToCurrentOnboardingSteps */.MZ; },
  "Zs": function() { return /* reexport */ submitIntegrationsForm; },
  "d4": function() { return /* reexport */ common_common/* useEffect */.d4; },
  "NL": function() { return /* reexport */ common_common/* useQueryClient */.NL; },
  "tv": function() { return /* reexport */ common_common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common_common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common_common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common_common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: Checkbox, Datetime, INITIAL_VALUES, Link, NextServerCookies, Sidebar, TablePagination, TextField, UNPROCESSABLE_ENTITY_RESPONSE_CODE, VALIDATION_SCHEMA, goToNextPage, toastr

// EXTERNAL MODULE: ../../shared/node_modules/@material-ui/core/esm/Table/Table.js
var Table = __webpack_require__(89628);
// EXTERNAL MODULE: ../../shared/node_modules/@material-ui/core/esm/TableBody/TableBody.js
var TableBody = __webpack_require__(76748);
// EXTERNAL MODULE: ../../shared/node_modules/@material-ui/core/esm/TableCell/TableCell.js
var TableCell = __webpack_require__(17864);
// EXTERNAL MODULE: ../../shared/node_modules/@material-ui/core/esm/TableContainer/TableContainer.js
var TableContainer = __webpack_require__(83728);
// EXTERNAL MODULE: ../../shared/node_modules/@material-ui/core/esm/TableHead/TableHead.js
var TableHead = __webpack_require__(90222);
// EXTERNAL MODULE: ../../shared/node_modules/@material-ui/core/esm/TableRow/TableRow.js
var TableRow = __webpack_require__(14898);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(18186);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
;// CONCATENATED MODULE: ./src/actions/pages/admins/dashboard/clients/integration.js




function createIntegrationData(index, integrations, logo, type, limit, status, client_integration_id, integration_id, isDisabled, isChecked) {
    return {
        index: index,
        integrations: integrations,
        logo: logo,
        type: type,
        limit: limit,
        status: status,
        client_integration_id: client_integration_id,
        integration_id: integration_id,
        isDisabled: isDisabled,
        isChecked: isChecked
    };
}
// export async function requestIntegrations(user_type, router) {
//   const body = {user_type: user_type};
//   const result = await new ClientIntegration().getIntegrations(body);
//   const status_code = result.status || result.response.status;
//   switch (status_code) {
//     case SUCCESS_REPONSE_CODE:
//       const response = result.data;
//       if (response.success) {
//         return response.data;
//       }
//       break;
//     case UNAUTHORIZED_REPONSE_CODE:
//       toastr.warning(result.response.data.error);
//       break;
//     default:
//       handleOtherResponseCode(status_code, router);
//   }
// }
function submitIntegrationsForm(values, router, setButtonPopup, current_step) {
    return _submitIntegrationsForm.apply(this, arguments);
}
function _submitIntegrationsForm() {
    _submitIntegrationsForm = (0,_async_to_generator/* default */.Z)(function(values, router, setButtonPopup, current_step) {
        var client_integrations_attributes, client_id, result, status_code, customToastrAction, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client_integrations_attributes = values.client.client_integrations_attributes;
                    // client_integrations_attributes                  =   client_integrations_attributes.filter(function(x) {
                    //                                                       return x.is_enabled;
                    //                                                     });
                    values.client.client_integrations_attributes = client_integrations_attributes.map(function(x) {
                        delete x["is_enabled"];
                        return x;
                    });
                    client_id = new common_common/* DataFromUrl */.QJ().getClientId();
                    return [
                        4,
                        new ClientIntegration().addIntegrations(values, client_id)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new common_common/* CustomToastrAction */.Y5();
                    switch(status_code){
                        case common_common/* SUCCESS_REPONSE_CODE */.Us:
                            response = result.data;
                            if (response.success) {
                                if (response.step == current_step) {
                                    // toastr.success('Integrations updated successfully.')
                                    customToastrAction.setNormalToastr("Integrations updated successfully.", "success");
                                    setTimeout(function() {
                                        return router.push(common_common/* REDIRECT.admins.dashboard.clients.client */.RQ.admins.dashboard.clients.client);
                                    }, 50);
                                } else {
                                    setButtonPopup(true);
                                }
                                return [
                                    2,
                                    response
                                ];
                            }
                            break;
                        case common_common/* UNAUTHORIZED_REPONSE_CODE */.t9:
                            // toastr.warning(result.response.data.error);
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            break;
                        default:
                            (0,common_common/* handleOtherResponseCode */.GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _submitIntegrationsForm.apply(this, arguments);
}
function getIntegrationData(setApiError, router) {
    return _getIntegrationData.apply(this, arguments);
}
function _getIntegrationData() {
    _getIntegrationData = (0,_async_to_generator/* default */.Z)(function(setApiError, router) {
        var ref, ref1, ref2, client_id, body, _tmp, integration_data, integrations, step, filterOptions, data, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client_id = new common_common/* DataFromUrl */.QJ().getClientId();
                    _tmp = {};
                    body = (0,_object_spread/* default */.Z)((_tmp.user_type = "client", _tmp.id = client_id, _tmp), router.query);
                    return [
                        4,
                        new ClientIntegration().getIntegrations(body, client_id)
                    ];
                case 1:
                    integration_data = _state.sent();
                    setApiError(integration_data.request);
                    integrations = (integration_data === null || integration_data === void 0 ? void 0 : (ref = integration_data.data) === null || ref === void 0 ? void 0 : ref.client_integrations) || [];
                    step = integration_data === null || integration_data === void 0 ? void 0 : (ref1 = integration_data.data) === null || ref1 === void 0 ? void 0 : ref1.step;
                    filterOptions = integration_data === null || integration_data === void 0 ? void 0 : (ref2 = integration_data.data) === null || ref2 === void 0 ? void 0 : ref2.job_boards_listing;
                    _tmp1 = {};
                    data = (_tmp1.props = {
                        integrations: integrations,
                        step: step,
                        filterOptions: filterOptions
                    }, _tmp1);
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return _getIntegrationData.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/actions/components/sidebar.js + 1 modules
var sidebar = __webpack_require__(39826);
// EXTERNAL MODULE: ./src/actions/pages/admins/dashboard/clients/common.js
var common = __webpack_require__(33399);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common_common = __webpack_require__(96047);
;// CONCATENATED MODULE: ./src/constants/pages/admins/dashboard/clients/integration.js

var INITIAL_VALUES = {
    client: {
        client_integrations_attributes: []
    }
};
var VALIDATION_SCHEMA = common_common/* Yup.object */.sm.object({});

// EXTERNAL MODULE: ./src/constants/common/onboarding-steps.js
var onboarding_steps = __webpack_require__(2528);
// EXTERNAL MODULE: ./src/constants/components/sidebar.js
var components_sidebar = __webpack_require__(73257);
// EXTERNAL MODULE: ./public/icons/arrowleft.svg
var arrowleft = __webpack_require__(65661);
// EXTERNAL MODULE: ./public/icons/filter.svg
var filter = __webpack_require__(97489);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
// EXTERNAL MODULE: ./src/components/congrats.js + 1 modules
var congrats = __webpack_require__(1402);
// EXTERNAL MODULE: ../../shared/node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(30711);
// EXTERNAL MODULE: ./src/services/common/send-request.js
var send_request = __webpack_require__(34964);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
;// CONCATENATED MODULE: ./src/services/pages/admins/dashboard/clients/integration.js







var ClientIntegration = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(ClientIntegration, SendRequest);
    var _super = (0,_create_super/* default */.Z)(ClientIntegration);
    function ClientIntegration() {
        (0,_class_call_check/* default */.Z)(this, ClientIntegration);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ClientIntegration, [
        {
            key: "getIntegrations",
            value: // async getIntegrations(params, client_auth_cookies) {
            //   try {
            //     const result = await axios({
            //       method: 'get',
            //       url: API.admins.dashboard.clients.integration.CLIENT_INTEGRATIONS_URL,
            //       headers: {cookie: `Authorization=${client_auth_cookies}`},
            //       params: params,
            //     });
            //     return result.data;
            //   } catch (error) {
            //     return error;
            //   }
            // }
            function getIntegrations(params, client_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common_common/* API.admins.dashboard.clients.integration.CLIENT_INTEGRATIONS_URL.replace */.bl.admins.dashboard.clients.integration.CLIENT_INTEGRATIONS_URL.replace("$client_id", client_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common_common/* axios.get */.od.get(url, (_tmp.params = params, _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addIntegrations",
            value: function addIntegrations(params, client_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common_common/* API.admins.dashboard.clients.integration.ADD_INTEGRATIONS_URL.replace */.bl.admins.dashboard.clients.integration.ADD_INTEGRATIONS_URL.replace("$client_id", client_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common_common/* axios.post */.od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ClientIntegration;
}(send_request/* SendRequest */.L);

// EXTERNAL MODULE: ./src/styles/pages/admins/dashboard/clients/new/_index.module.scss
var _index_module = __webpack_require__(10994);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/styles/pages/admins/dashboard/clients/integration/_index.module.scss
var integration_index_module = __webpack_require__(84370);
var integration_index_module_default = /*#__PURE__*/__webpack_require__.n(integration_index_module);
// EXTERNAL MODULE: ./src/styles/components/button/_index.module.scss
var button_index_module = __webpack_require__(84215);
var button_index_module_default = /*#__PURE__*/__webpack_require__.n(button_index_module);
// EXTERNAL MODULE: ./src/styles/components/congrats/_index.module.scss
var congrats_index_module = __webpack_require__(66772);
var congrats_index_module_default = /*#__PURE__*/__webpack_require__.n(congrats_index_module);
;// CONCATENATED MODULE: ./src/imports-files/pages/admins/dashboard/clients/integration.js
// -------------------- Material Ui Table Components --------------

// -------------------- Material Ui Table Components --------------
// -------------------------------  ACTIONS -------------------------------------



// -------------------------------  ACTIONS -------------------------------------
//* This file contains the export files statement which will be export again in the pages

// ----------------------------- COMMON ---------------------------------------
// ----------------------------- CONSTANT ---------------------------------------



// ----------------------------- CONSTANT ---------------------------------------
// ----------------------------- ICONS ---------------------------------------


// ----------------------------- ICONS ---------------------------------------
// -----------------------------  CUSTOM COMPONENTS -----------------------------





// -----------------------------  CUSTOM COMPONENTS -----------------------------
// ----------------------------- SERVICES ---------------------------------------


// ----------------------------- SERVICES ---------------------------------------
// ---------------------------- Stylesheet -------------------------------------



 // ----------------------------- Stylesheet ------------------------------------


/***/ }),

/***/ 43361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.$G; },
/* harmony export */   "A$": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.A$; },
/* harmony export */   "EA": function() { return /* reexport safe */ _actions_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_9__.EA; },
/* harmony export */   "Ee": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.Ee; },
/* harmony export */   "GN": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.GN; },
/* harmony export */   "Hh": function() { return /* reexport safe */ _constants_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_1__.Hh; },
/* harmony export */   "I3": function() { return /* reexport safe */ _actions_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_9__.I3; },
/* harmony export */   "I8": function() { return /* reexport safe */ _actions_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_9__.I8; },
/* harmony export */   "J9": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.J9; },
/* harmony export */   "LD": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.LD; },
/* harmony export */   "Lt": function() { return /* reexport safe */ _services_common_send_request__WEBPACK_IMPORTED_MODULE_0__.L; },
/* harmony export */   "Mf": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.Mf; },
/* harmony export */   "NU": function() { return /* reexport safe */ react_places_autocomplete__WEBPACK_IMPORTED_MODULE_5__.NU; },
/* harmony export */   "RL": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.RL; },
/* harmony export */   "TA": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.TA; },
/* harmony export */   "TN": function() { return /* reexport safe */ _actions_common_auto_complete__WEBPACK_IMPORTED_MODULE_8__.T; },
/* harmony export */   "Wg": function() { return /* reexport safe */ react_file_picker_providers__WEBPACK_IMPORTED_MODULE_7__.Wg; },
/* harmony export */   "YB": function() { return /* reexport safe */ _actions_common_other_source_action__WEBPACK_IMPORTED_MODULE_10__.Y; },
/* harmony export */   "YF": function() { return /* reexport safe */ _actions_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_9__.YF; },
/* harmony export */   "Zm": function() { return /* reexport safe */ _actions_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_9__.Zm; },
/* harmony export */   "ax": function() { return /* reexport safe */ _actions_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_9__.ax; },
/* harmony export */   "bl": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.bl; },
/* harmony export */   "bp": function() { return /* reexport safe */ _actions_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_12__.bp; },
/* harmony export */   "d4": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.d4; },
/* harmony export */   "dC": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.dC; },
/* harmony export */   "dH": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.dH; },
/* harmony export */   "eJ": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.eJ; },
/* harmony export */   "gN": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.gN; },
/* harmony export */   "gb": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.gb; },
/* harmony export */   "gt": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.gt; },
/* harmony export */   "jM": function() { return /* reexport safe */ _actions_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_12__.jM; },
/* harmony export */   "k2": function() { return /* reexport default from dynamic */ _styles_pages_jobs_candidates_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default.a; },
/* harmony export */   "ks": function() { return /* reexport safe */ _actions_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_12__.Wg; },
/* harmony export */   "l0": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.l0; },
/* harmony export */   "mb": function() { return /* reexport safe */ react_places_autocomplete__WEBPACK_IMPORTED_MODULE_5__.ZP; },
/* harmony export */   "oH": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.oH; },
/* harmony export */   "od": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.od; },
/* harmony export */   "p9": function() { return /* reexport safe */ _constants_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_1__.p9; },
/* harmony export */   "pd": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.pd; },
/* harmony export */   "rE": function() { return /* reexport safe */ _components_dropzone__WEBPACK_IMPORTED_MODULE_3__.Z; },
/* harmony export */   "sO": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.sO; },
/* harmony export */   "tv": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.tv; },
/* harmony export */   "ww": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.EA; },
/* harmony export */   "x": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__.x; },
/* harmony export */   "xV": function() { return /* reexport safe */ _actions_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_9__.xV; },
/* harmony export */   "zx": function() { return /* reexport safe */ _components_button__WEBPACK_IMPORTED_MODULE_4__.Z; }
/* harmony export */ });
/* harmony import */ var _services_common_send_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34964);
/* harmony import */ var _constants_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67212);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96047);
/* harmony import */ var _components_dropzone__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93714);
/* harmony import */ var _components_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95662);
/* harmony import */ var react_places_autocomplete__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25538);
/* harmony import */ var _components_confirmation_modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72055);
/* harmony import */ var react_file_picker_providers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70853);
/* harmony import */ var _actions_common_auto_complete__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90308);
/* harmony import */ var _actions_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19803);
/* harmony import */ var _actions_common_other_source_action__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69735);
/* harmony import */ var _styles_pages_jobs_candidates_index_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87079);
/* harmony import */ var _styles_pages_jobs_candidates_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_jobs_candidates_index_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _actions_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(21572);















/***/ }),

/***/ 82352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "CL": function() { return /* reexport */ About; },
  "ez": function() { return /* reexport */ AboutSection; },
  "gU": function() { return /* reexport */ AddSection; },
  "V8": function() { return /* reexport */ Benefit; },
  "Om": function() { return /* reexport */ BenfitSection; },
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "Pq": function() { return /* reexport */ ButtonCustomizationModal; },
  "oL": function() { return /* reexport */ CareerCropper; },
  "x4": function() { return /* reexport */ common/* CommonAction */.x4; },
  "iq": function() { return /* reexport */ CustomButtons; },
  "nu": function() { return /* reexport */ components_custom_cropper/* CustomCropperAction */.n; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "jh": function() { return /* reexport */ customize_career_page/* CustomizeCareerAction */.j; },
  "zn": function() { return /* reexport */ CustomizeCareerService; },
  "Z5": function() { return /* reexport */ react_beautiful_dnd_esm/* DragDropContext */.Z5; },
  "_l": function() { return /* reexport */ react_beautiful_dnd_esm/* Draggable */._l; },
  "bK": function() { return /* reexport */ react_beautiful_dnd_esm/* Droppable */.bK; },
  "wN": function() { return /* reexport */ edit_banner; },
  "dC": function() { return /* reexport */ common/* ErrorPages */.dC; },
  "_f": function() { return /* reexport */ FILE_SIZES; },
  "$_": function() { return /* reexport */ footer/* Footer */.$; },
  "qo": function() { return /* reexport */ FooterLinks; },
  "l0": function() { return /* reexport */ common/* Form */.l0; },
  "J9": function() { return /* reexport */ common/* Formik */.J9; },
  "gt": function() { return /* reexport */ common/* FormikControl */.gt; },
  "ri": function() { return /* reexport */ Gallery; },
  "o0": function() { return /* reexport */ GallerySection; },
  "HZ": function() { return /* reexport */ build/* default */.Z; },
  "TM": function() { return /* reexport */ grey_gripicon; },
  "h4": function() { return /* reexport */ header/* Header */.h; },
  "f4": function() { return /* reexport */ HeaderLinks; },
  "DH": function() { return /* reexport */ HeroSection; },
  "LR": function() { return /* reexport */ HeroTitle; },
  "N7": function() { return /* reexport */ careers_showJob/* INITIAL_VALUES */.N7; },
  "RZ": function() { return /* reexport */ LINK_TYPES; },
  "gb": function() { return /* reexport */ common/* Loading */.gb; },
  "xG": function() { return /* reexport */ MeetTeam; },
  "gs": function() { return /* reexport */ MeetTeamSection; },
  "ry": function() { return /* reexport */ OpenJobs; },
  "k2": function() { return /* reexport */ (customize_career_page_index_module_default()); },
  "RQ": function() { return /* reexport */ common/* REDIRECT */.RQ; },
  "cG": function() { return /* reexport */ ReOrderSection; },
  "Lt": function() { return /* reexport */ common/* SendRequest */.Lt; },
  "Ws": function() { return /* reexport */ showJob/* ShowJobAction */.W; },
  "hs": function() { return /* reexport */ SidePanel; },
  "f9": function() { return /* reexport */ SocialLinkModal; },
  "WG": function() { return /* reexport */ SocialLinks; },
  "$t": function() { return /* reexport */ TEAM_NO_DATA; },
  "l$": function() { return /* reexport */ TEXT_STYLES_OPTIONS; },
  "TA": function() { return /* reexport */ common/* TRANSLATION */.TA; },
  "QC": function() { return /* reexport */ URL_FORMAT; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "yf": function() { return /* reexport */ fontOptions; },
  "Rq": function() { return /* reexport */ fonts; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "sO": function() { return /* reexport */ common/* useRef */.sO; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: BENEFIT_DATA, BUTTON_STYLES_OPTIONS, ButtonStyle, Checkbox, ConfirmationModal, CustomCropper, DEFAULT_JOBS, EdiText, EditImage, ErrorMessage, Field, FieldArray, FontAwesomeIcon, FormStyle, IMAGE_VISIBILITIES, Image, InputError, InputStyle, Link, NextServerCookies, React, SUCCESS_REPONSE_CODE, Select, Sidebar, TEAM_DATA, TestSection, Tooltip, UNPROCESSABLE_ENTITY_RESPONSE_CODE, Yup, faExclamationCircle, faTimes, getIn, getSession, signIn, toastr, useSWR

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/components/careers/header.js + 2 modules
var header = __webpack_require__(31061);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/styles/components/careers/hero-section/_index.module.scss
var _index_module = __webpack_require__(43747);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
;// CONCATENATED MODULE: ./public/icons/career_icons/setting.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgSetting = function SvgSetting(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 25,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M22.504 12.531v1.93l1.574.914c.203.152.406.355.508.61.102.304.152.558.102.761a12.684 12.684 0 0 1-3.301 5.637c-.203.203-.407.355-.66.355-.305.051-.559 0-.813-.152l-1.574-.914a9.459 9.459 0 0 1-1.676.965v1.828c0 .305-.102.61-.254.812-.203.203-.406.356-.66.407-2.184.609-4.367.609-6.5 0a.993.993 0 0 1-.66-.407c-.203-.203-.254-.508-.254-.812v-1.828a6.857 6.857 0 0 1-1.676-.965l-1.574.914c-.305.152-.559.203-.813.152-.304 0-.507-.152-.66-.355-1.625-1.574-2.691-3.453-3.3-5.637-.102-.203-.051-.457.05-.762.102-.254.305-.457.559-.609l1.574-.914c-.05-.61-.05-1.27 0-1.93l-1.574-.914a.958.958 0 0 1-.559-.61c-.101-.253-.152-.507-.05-.76.609-2.134 1.675-4.013 3.3-5.638.153-.203.356-.304.66-.355.254 0 .508.05.813.152l1.574.914c.508-.355 1.067-.66 1.676-.965V2.527c0-.304.05-.558.254-.761a1.29 1.29 0 0 1 .66-.457c2.133-.559 4.316-.559 6.5 0 .254.101.457.254.66.457.152.203.254.457.254.761v1.828c.559.305 1.117.61 1.676.965l1.574-.914c.254-.101.508-.152.813-.152.253.05.457.152.66.355 1.574 1.625 2.691 3.504 3.3 5.637.051.254 0 .508-.101.762a1.04 1.04 0 0 1-.508.61l-1.574.913Zm-2.692 3.2c.204-1.016.305-1.778.305-2.235 0-.406-.101-1.168-.305-2.234l2.235-1.27C21.64 8.926 21.03 7.91 20.32 6.996l-2.234 1.27c-.813-.66-1.422-1.118-1.828-1.32a36.1 36.1 0 0 0-2.031-.915V3.492a9.859 9.859 0 0 0-3.454 0v2.54c-1.015.405-1.675.71-2.082.913-.406.203-.964.66-1.777 1.32L4.68 6.997a10.45 10.45 0 0 0-1.727 2.996l2.235 1.27c-.204 1.066-.305 1.828-.305 2.234 0 .457.101 1.219.304 2.234L2.954 17a9.813 9.813 0 0 0 1.727 2.996l2.234-1.27c.813.712 1.371 1.169 1.777 1.372.407.203 1.067.508 2.082.863V23.5a9.86 9.86 0 0 0 3.454 0v-2.54c.964-.355 1.625-.66 2.03-.862.407-.203 1.016-.66 1.829-1.371l2.234 1.27c.711-.915 1.32-1.88 1.727-2.997l-2.235-1.27ZM12.5 8.62c1.32 0 2.488.508 3.453 1.422.914.965 1.422 2.133 1.422 3.453 0 1.371-.508 2.54-1.422 3.453-.965.965-2.133 1.422-3.453 1.422-1.371 0-2.54-.457-3.453-1.422-.965-.914-1.422-2.082-1.422-3.453 0-1.32.457-2.488 1.422-3.453.914-.914 2.082-1.422 3.453-1.422Zm0 7.313c.66 0 1.219-.204 1.727-.711.457-.457.71-1.016.71-1.727 0-.66-.253-1.219-.71-1.726-.508-.457-1.067-.711-1.727-.711-.71 0-1.27.254-1.727.71-.507.508-.71 1.067-.71 1.727 0 .711.203 1.27.71 1.727.457.507 1.016.71 1.727.71Z",
    fill: "#fff"
  })));
};

/* harmony default export */ var setting = (SvgSetting);
;// CONCATENATED MODULE: ./public/icons/career_icons/eye-close.svg
var eye_close_path;

function eye_close_extends() { eye_close_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return eye_close_extends.apply(this, arguments); }



var SvgEyeClose = function SvgEyeClose(props) {
  return /*#__PURE__*/react.createElement("svg", eye_close_extends({
    width: 18,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), eye_close_path || (eye_close_path = /*#__PURE__*/react.createElement("path", {
    d: "M9.567 12.012c-.322.058-.645.058-.967.058-1.553 0-2.988-.351-4.307-1.113A8.185 8.185 0 0 1 1.16 7.852c-.118-.147-.118-.293 0-.47A8.67 8.67 0 0 1 4 4.483l-.556-.761A9.428 9.428 0 0 0 .368 6.914a1.296 1.296 0 0 0-.205.703c0 .264.058.498.205.703a8.887 8.887 0 0 0 3.427 3.399c1.465.879 3.047 1.289 4.805 1.289.527 0 1.084-.03 1.611-.147l-.644-.85Zm-5.244-7.09.673.908a2.772 2.772 0 0 0-.146.967c0 .644.146 1.26.469 1.787.293.527.732.967 1.289 1.289.527.352 1.142.527 1.787.557l.674.908c-.176.03-.323.03-.469.03-.879 0-1.67-.206-2.373-.616a4.645 4.645 0 0 1-1.7-1.67 4.457 4.457 0 0 1-.615-2.285c0-.645.118-1.26.41-1.875Zm12.51 3.398a1.41 1.41 0 0 0 .205-.703c0-.234-.088-.469-.206-.703a9.765 9.765 0 0 0-3.427-3.398A9.446 9.446 0 0 0 8.6 2.226c-1.055 0-2.08.176-3.047.499L3.737.264a.638.638 0 0 0-.235-.147c-.117 0-.205 0-.263.059l-.205.146c-.088.059-.147.147-.147.235 0 .117.03.205.088.263l10.488 14.15c.059.089.118.147.235.147.088.03.175 0 .263-.058l.205-.147c.059-.059.118-.117.118-.234 0-.088 0-.176-.059-.264l-1.67-2.256c.879-.41 1.7-.937 2.432-1.582a9.156 9.156 0 0 0 1.845-2.256ZM12.35 6.797c0 .615-.146 1.172-.44 1.7a3.647 3.647 0 0 1-1.142 1.259L9.655 8.232c.38-.263.644-.644.761-1.113a1.722 1.722 0 0 0-.175-1.318.75.75 0 0 1-.235.556.706.706 0 0 1-.527.205c-.234 0-.41-.058-.557-.205-.146-.146-.205-.322-.205-.556 0-.205.059-.381.205-.528a.75.75 0 0 1 .557-.234 1.948 1.948 0 0 0-1.055-.205c-.38.03-.703.146-.996.38L6.403 3.868A3.642 3.642 0 0 1 8.6 3.164c.674 0 1.29.176 1.875.498a3.718 3.718 0 0 1 1.377 1.318c.322.557.498 1.172.498 1.817Zm3.691.586c.088.176.088.322 0 .469a7.674 7.674 0 0 1-1.757 2.109c-.704.586-1.465 1.084-2.286 1.435l-.673-.878a4.737 4.737 0 0 0 1.582-1.905 4.5 4.5 0 0 0 .322-2.402 4.555 4.555 0 0 0-.938-2.227c.762.381 1.495.85 2.14 1.436a9.274 9.274 0 0 1 1.61 1.963Z",
    fill: "#333"
  })));
};

/* harmony default export */ var eye_close = (SvgEyeClose);
;// CONCATENATED MODULE: ./public/icons/career_icons/eye-open.svg
var eye_open_path;

function eye_open_extends() { eye_open_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return eye_open_extends.apply(this, arguments); }



var SvgEyeOpen = function SvgEyeOpen(props) {
  return /*#__PURE__*/react.createElement("svg", eye_open_extends({
    width: 18,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), eye_open_path || (eye_open_path = /*#__PURE__*/react.createElement("path", {
    d: "M16.832 4.926c.118.234.206.469.206.703 0 .264-.088.498-.206.703a9.302 9.302 0 0 1-3.427 3.398c-1.465.88-3.076 1.29-4.805 1.29-1.758 0-3.34-.41-4.805-1.29A8.886 8.886 0 0 1 .368 6.332a1.168 1.168 0 0 1-.205-.703c0-.234.058-.469.205-.703a9.305 9.305 0 0 1 3.427-3.399A9.369 9.369 0 0 1 8.6.238c1.729 0 3.34.44 4.805 1.29a9.765 9.765 0 0 1 3.427 3.398Zm-4.482-.117c0-.645-.176-1.26-.498-1.817a3.718 3.718 0 0 0-1.377-1.318A3.818 3.818 0 0 0 8.6 1.176c-.703 0-1.318.176-1.904.498a3.432 3.432 0 0 0-1.348 1.318c-.352.557-.498 1.172-.498 1.817 0 .673.146 1.289.498 1.845.322.557.762.996 1.348 1.319.586.322 1.2.468 1.904.468.674 0 1.29-.146 1.875-.468a3.718 3.718 0 0 0 1.377-1.319 3.63 3.63 0 0 0 .498-1.845Zm3.691 1.054c.088-.146.088-.293 0-.468a8.596 8.596 0 0 0-1.61-1.963 9.433 9.433 0 0 0-2.14-1.436c.645.82.996 1.758.996 2.813 0 .82-.234 1.582-.644 2.285a4.645 4.645 0 0 1-1.7 1.67 4.592 4.592 0 0 1-2.343.615c-.879 0-1.67-.205-2.373-.615a4.644 4.644 0 0 1-1.7-1.67 4.457 4.457 0 0 1-.615-2.285c0-1.055.323-1.993.997-2.813-.791.38-1.495.85-2.14 1.436a8.46 8.46 0 0 0-1.61 1.963c-.118.175-.118.322 0 .468A8.32 8.32 0 0 0 4.293 8.94 8.459 8.459 0 0 0 8.6 10.082c1.523 0 2.959-.352 4.307-1.113 1.318-.762 2.373-1.787 3.134-3.106ZM6.725 4.691c0 .528.176.997.527 1.348.352.352.82.527 1.348.527.527 0 .967-.175 1.318-.527a1.88 1.88 0 0 0 .557-1.348c0-.527-.205-.966-.557-1.318a1.814 1.814 0 0 0-2.197-.322c.205 0 .381.088.527.234a.734.734 0 0 1 .235.527.75.75 0 0 1-.235.557.706.706 0 0 1-.527.205c-.234 0-.41-.058-.557-.205-.146-.146-.205-.322-.205-.556a1.653 1.653 0 0 0-.234.878Z",
    fill: "#333"
  })));
};

/* harmony default export */ var eye_open = (SvgEyeOpen);
;// CONCATENATED MODULE: ./public/icons/career_icons/link.svg
var link_path;

function link_extends() { link_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return link_extends.apply(this, arguments); }



var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/react.createElement("svg", link_extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), link_path || (link_path = /*#__PURE__*/react.createElement("path", {
    d: "M9.868 11.69a3.85 3.85 0 0 0 .996-1.7 3.72 3.72 0 0 0 0-1.963A4.119 4.119 0 0 0 9.868 6.3a4.167 4.167 0 0 0-1.2-.82.497.497 0 0 0-.294 0c-.117.058-.176.117-.176.205-.058.175-.117.322-.117.468 0 .176.059.264.235.323.293.146.586.322.82.556.527.557.791 1.201.791 1.963s-.264 1.406-.791 1.934l-2.344 2.314c-.527.557-1.172.82-1.933.82-.762 0-1.436-.263-1.963-.79-.528-.528-.791-1.202-.791-1.963 0-.762.263-1.407.82-1.934l2.197-2.227c.059-.058.088-.175.088-.293-.03-.117-.03-.263-.03-.41 0-.146-.087-.263-.234-.322-.146-.059-.263-.03-.351.059L2.163 8.613a3.83 3.83 0 0 0-.996 1.729 3.72 3.72 0 0 0 0 1.963c.176.644.498 1.23.996 1.699.469.498 1.055.82 1.7.996a3.719 3.719 0 0 0 1.962 0 3.83 3.83 0 0 0 1.729-.996l2.314-2.314ZM7.232 8.936a3.593 3.593 0 0 1-.996-1.7 3.72 3.72 0 0 1 0-1.963 3.83 3.83 0 0 1 .996-1.728L9.546 1.23a3.794 3.794 0 0 1 1.7-.966 3.72 3.72 0 0 1 1.962 0c.645.175 1.23.498 1.729.966.469.499.79 1.084.966 1.729a3.719 3.719 0 0 1 0 1.963 3.794 3.794 0 0 1-.966 1.7l-2.432 2.43c-.117.118-.234.118-.38.06-.147-.06-.206-.147-.206-.294 0-.146-.03-.293-.03-.41a.33.33 0 0 1 .089-.322l2.197-2.227c.527-.527.82-1.171.82-1.933s-.293-1.406-.82-1.934c-.527-.527-1.172-.82-1.934-.82-.761 0-1.406.293-1.933.82L7.964 4.307c-.527.556-.791 1.2-.791 1.963 0 .761.264 1.406.791 1.933.234.235.498.44.82.557.147.058.205.176.205.322 0 .176-.029.322-.087.469-.03.117-.088.176-.176.205-.117.058-.205.058-.293 0-.469-.176-.85-.469-1.201-.82Z",
    fill: "#333"
  })));
};

/* harmony default export */ var career_icons_link = (SvgLink);
;// CONCATENATED MODULE: ./src/components/careers/hero-section.js











function HeroSection(param) {
    var formik = param.formik, customizeCareerAction = param.customizeCareerAction, isPreview = param.isPreview, setButtonPopup = param.setButtonPopup, resetCareerPage = param.resetCareerPage;
    var buttonIconClass = function buttonIconClass(buttonIcons, index) {
        return !isPreview ? (_index_module_default()).Hero__EditButton__ShowIcons : "";
    };
    var buttonIconParentClass = function buttonIconParentClass(buttonIcons, index) {
        return !isPreview && buttonIcons[index] ? (_index_module_default()).Hero__EditButton : "";
    };
    var eyeIcons = function eyeIcons(formik, index) {
        return formik.values.hero_section_attributes.button_hash.buttons[index].is_visible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(eye_open, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(eye_close, {});
    };
    var imageUrl = function imageUrl(formik) {
        var image_url =  true && window.innerWidth <= 600 ? formik.values.hero_section_attributes.mobile_image_url : formik.values.hero_section_attributes.hero_image_url;
        return image_url || ( true && window.innerWidth <= 600 ? "/images/components/customise_career/mobile-banner.png" : "/images/components/customise_career/hero-banner.png");
    };
    var headerTitle = (0,common/* useRef */.sO)(formik.values.hero_section_attributes.title);
    var button1 = (0,common/* useRef */.sO)(formik.values.hero_section_attributes.button_hash.buttons[0].text);
    var ref = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([
        false,
        false
    ]), 2), buttonIcons = ref[0], setButtonIcons = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(0), 2), flagForRender = ref1[0], setFlagForRender = ref1[1];
    (0,common/* useEffect */.d4)(function() {
        headerTitle.current = formik.values.hero_section_attributes.title;
        button1.current = formik.values.hero_section_attributes.button_hash.buttons[0].text;
        setFlagForRender(Math.random() * 10000);
    }, [
        resetCareerPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "Hero_Back_Image",
        className: "".concat((_index_module_default()).Hero, " ").concat((_index_module_default()).Hero__BackgroundImage),
        style: {
            backgroundImage: "url(".concat(imageUrl(formik), ")")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: customizeCareerAction.backgroundOverlayValue(formik),
                className: "".concat((_index_module_default()).Overlayhero)
            }),
            !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((_index_module_default()).Hero__SettingsIcon),
                onClick: function() {
                    customizeCareerAction.showHideSidePanel(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(setting, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(isPreview ? (_index_module_default()).Hero__PreviewHeroTitle : (_index_module_default()).Hero__EditHeroTitle),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((_index_module_default()).Hero__EditHeroTitle__Contenteditable),
                        children: isPreview ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            suppressContentEditableWarning: true,
                            dangerouslySetInnerHTML: {
                                __html: headerTitle.current
                            },
                            style: customizeCareerAction.heroTitleStyle(formik)
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            contentEditable: true,
                            onInput: function(e) {
                                formik.setFieldValue("hero_section_attributes.title", e.currentTarget.innerHTML || "");
                            },
                            onPaste: function(event) {
                                customizeCareerAction.onPastePreventStyling(event);
                            },
                            onBlur: function(e) {
                                customizeCareerAction.updateHeroSection(formik.values);
                            },
                            suppressContentEditableWarning: true,
                            dangerouslySetInnerHTML: {
                                __html: headerTitle.current
                            },
                            style: customizeCareerAction.heroTitleStyle(formik)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((_index_module_default()).Hero__TwoButtons),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((_index_module_default()).Hero__LeftButton, " ").concat(buttonIconParentClass(buttonIcons, 0)),
                            children: [
                                !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((_index_module_default()).Hero__LeftButton__ButtonIconsHide, " ").concat(buttonIconClass(buttonIcons, 0)),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            onClick: function() {
                                                var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                return [
                                                                    4,
                                                                    formik.setFieldValue("hero_section_attributes.button_hash.buttons.0.is_visible", !formik.values.hero_section_attributes.button_hash.buttons[0].is_visible)
                                                                ];
                                                            case 1:
                                                                _state.sent();
                                                                setTimeout(customizeCareerAction.updateHeroSection(formik.values), 1000);
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                });
                                                return function(event) {
                                                    return _ref.apply(this, arguments);
                                                };
                                            }(),
                                            children: eyeIcons(formik, 0)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            onClick: function(event) {
                                                setButtonPopup({
                                                    state: true,
                                                    button_index: 0,
                                                    sections_list: customizeCareerAction.listOfSections(),
                                                    formik: formik
                                                });
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(career_icons_link, {})
                                        })
                                    ]
                                }),
                                (!isPreview || formik.values.hero_section_attributes.button_hash.buttons[0].is_visible) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    contentEditable: !isPreview,
                                    onInput: function(e) {
                                        var button1_hash = formik.values.hero_section_attributes.button_hash.buttons[0];
                                        button1_hash.text = e.currentTarget.textContent;
                                    },
                                    onPaste: function(event) {
                                        customizeCareerAction.onPastePreventStyling(event);
                                    },
                                    onClick: function() {
                                        setButtonIcons([
                                            true,
                                            false
                                        ]);
                                        customizeCareerAction.onHeroButtonClick(formik, isPreview, 0);
                                    },
                                    onBlur: function(e) {
                                        setButtonIcons([
                                            false,
                                            false
                                        ]);
                                        customizeCareerAction.updateHeroSection(formik.values);
                                    },
                                    suppressContentEditableWarning: true,
                                    dangerouslySetInnerHTML: {
                                        __html: button1.current
                                    },
                                    className: "".concat((_index_module_default()).Hero__ButtonStyle, " ").concat(isPreview ? "CursorPointer" : ""),
                                    style: customizeCareerAction.heroButtonStyle(formik)
                                })
                            ]
                        })
                    })
                ]
            }),
            !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((_index_module_default()).Hero__EditBannerIcon),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: "",
                        accept: ".png, .jpg, .jpeg",
                        type: "file",
                        onChange: function(event) {
                            return customizeCareerAction.handleBackgroundOnChange(event, formik);
                        },
                        title: customizeCareerAction.imageInfoContent("hero_image")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(edit_banner, {})
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../shared/node_modules/react-accessible-accordion/dist/es/index.js
var es = __webpack_require__(51101);
// EXTERNAL MODULE: ./src/styles/components/careers/open-jobs/_index.module.scss
var open_jobs_index_module = __webpack_require__(2093);
var open_jobs_index_module_default = /*#__PURE__*/__webpack_require__.n(open_jobs_index_module);
;// CONCATENATED MODULE: ./public/icons/career_icons/search.svg
var search_path;

function search_extends() { search_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return search_extends.apply(this, arguments); }



var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/react.createElement("svg", search_extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0 0h20v20H0z"
  }), search_path || (search_path = /*#__PURE__*/react.createElement("path", {
    d: "m18.125 17.24-4.72-4.72a6.886 6.886 0 1 0-.884.885l4.72 4.72.884-.884ZM2.5 8.126a5.625 5.625 0 1 1 5.625 5.625A5.632 5.632 0 0 1 2.5 8.125Z",
    fill: "var(--default-text-color)"
  })));
};

/* harmony default export */ var search = (SvgSearch);
;// CONCATENATED MODULE: ./public/icons/career_icons/search-close.svg
var search_close_path;

function search_close_extends() { search_close_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return search_close_extends.apply(this, arguments); }



var SvgSearchClose = function SvgSearchClose(props) {
  return /*#__PURE__*/react.createElement("svg", search_close_extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), search_close_path || (search_close_path = /*#__PURE__*/react.createElement("path", {
    d: "M10 .875 9.125 0 5 4.125.875 0 0 .875 4.125 5 0 9.125.875 10 5 5.875 9.125 10 10 9.125 5.875 5 10 .875Z",
    fill: "var(--default-text-color)"
  })));
};

/* harmony default export */ var search_close = (SvgSearchClose);
;// CONCATENATED MODULE: ./src/components/careers/open-jobs.js








function OpenJobs(param) {
    var job_data = param.job_data, page_section = param.page_section, customizeCareerAction = param.customizeCareerAction, formik = param.formik, isPreview = param.isPreview, isPublic = param.isPublic, isFrame = param.isFrame;
    var ref = (0,common/* useTranslation */.$G)(), t = ref.t, i18n = ref.i18n;
    var showJobAction = new showJob/* ShowJobAction */.W();
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(job_data), 2), data = ref1[0], setPropsData = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(careers_showJob/* INITIAL_VALUES */.N7), 2), searching = ref2[0], searchValues = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(isPreview ? {
        options: [
            {
                label: t("placeholder:select:please"),
                value: ""
            },
            {
                label: t("jobs:details:employment_type:full_time"),
                value: "full_time"
            },
            {
                label: t("jobs:details:employment_type:part_time"),
                value: "part_time"
            },
            {
                label: t("jobs:details:employment_type:either"),
                value: "either"
            }
        ]
    } : {
        options: []
    }), 2), jobOptions = ref3[0], setJobOptions = ref3[1];
    var ref4 = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(showJobAction.get_json_data_for_locationOption(data.job_locations || [], data.job_countries || [])), 2), locationOptions = ref4[0], setLocationOptions = ref4[1];
    var ref5 = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(isPreview ? {
        options: [
            {
                label: t("placeholder:select:please"),
                value: ""
            },
            {
                label: t("jobs:details:locations:all"),
                value: "all"
            },
            {
                label: t("jobs:details:locations:on_site"),
                value: "on_site"
            },
            {
                label: t("jobs:details:locations:is_remote"),
                value: "is_remote"
            },
            {
                label: t("jobs:details:locations:is_hybrid"),
                value: "is_hybrid"
            }
        ]
    } : {
        options: []
    }), 2), remoteOnlyOptions = ref5[0], setRemoteOnlyOptions = ref5[1];
    var ref6 = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)({
        job_type: "",
        job_location: ""
    }), 2), filterOptions = ref6[0], setFilterOptions = ref6[1];
    var labelStyle = customizeCareerAction.labelStyle(formik);
    var bodyStyle = customizeCareerAction.bodyStyle(formik);
    var headingFontColor = customizeCareerAction.job_benefit_heading_color(formik);
    var ref7 = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)("Show filters"), 2), mFilterText = ref7[0], setMFilterText = ref7[1];
    var ref8 = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(""), 2), searchText = ref8[0], setSearchText = ref8[1];
    (0,common/* useEffect */.d4)(function() {
        setRemoteOnlyOptions(isPreview ? {
            options: [
                {
                    label: t("placeholder:select:please"),
                    value: ""
                },
                {
                    label: t("career:jobs:all"),
                    value: "all"
                },
                {
                    label: t("career:jobs:on_site"),
                    value: "on_site"
                },
                {
                    label: t("career:jobs:remote"),
                    value: "is_remote"
                },
                {
                    label: t("career:jobs:hybrid"),
                    value: "is_hybrid"
                }, 
            ]
        } : {
            options: []
        });
        setJobOptions(isPreview ? {
            options: [
                {
                    label: t("placeholder:select:please"),
                    value: ""
                },
                {
                    label: t("jobs:details:employment_type:full_time"),
                    value: "full_time"
                },
                {
                    label: t("jobs:details:employment_type:part_time"),
                    value: "part_time"
                },
                {
                    label: t("jobs:details:employment_type:either"),
                    value: "either"
                }
            ]
        } : {
            options: []
        });
    }, [
        isPreview,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((open_jobs_index_module_default()).Jobs),
        id: page_section.uniq_reference,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((open_jobs_index_module_default()).Jobs__Title),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    style: headingFontColor,
                    children: t("career:jobs:title")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "OpenJobs ".concat((open_jobs_index_module_default()).Jobs__Container),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((open_jobs_index_module_default()).Jobs__JobFilter),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (open_jobs_index_module_default()).Jobs__SearchInputWidth,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (open_jobs_index_module_default()).Jobs__SearchInput,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((open_jobs_index_module_default()).Jobs__SearchInput__InputField),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "text",
                                                placeholder: t("placeholder:search:role_ui_designer"),
                                                className: (open_jobs_index_module_default()).Jobs__SearchInput__Input,
                                                name: "search",
                                                value: searchText,
                                                disabled: !isPreview,
                                                onChange: function(event) {
                                                    setSearchText(event.target.value);
                                                    showJobAction.handleValueOnChange("search_text", event.target.value, searching, searchValues, setPropsData, data, isFrame);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((open_jobs_index_module_default()).Jobs__Searchbtn),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                                    type: "button",
                                                    onClick: function() {
                                                        setSearchText("");
                                                        showJobAction.handleValueOnChange("search_text", "", searching, searchValues, setPropsData, data, isFrame);
                                                    },
                                                    style: isPreview ? {} : {
                                                        background: "rgb(242 242 242)",
                                                        cursor: "no-drop"
                                                    },
                                                    children: searchText.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(search_close, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(search, {})
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((open_jobs_index_module_default()).Jobs__AccordionInMobile, " Accordian__Filter"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Accordion */.UQ, {
                                    onChange: function() {
                                        mFilterText == "Show filters" ? setMFilterText("Hide filters") : setMFilterText("Show filters");
                                    },
                                    allowZeroExpanded: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItem */.Qd, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemPanel */.Mt, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Formik */.J9, {
                                                    children: function(formik) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (open_jobs_index_module_default()).Jobs__Width100,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (open_jobs_index_module_default()).Jobs__Select,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "".concat((open_jobs_index_module_default()).Jobs__Location),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                            className: "".concat((open_jobs_index_module_default()).Jobs__Location),
                                                                            placeholder: "Location",
                                                                            control: "select",
                                                                            default: searching.location_text || "",
                                                                            formik: formik,
                                                                            disabled: !isPreview,
                                                                            isClearable: true,
                                                                            onChange: function(value) {
                                                                                return showJobAction.handleValueOnChange("location_text", value, searching, searchValues, setPropsData, data, isFrame);
                                                                            },
                                                                            options: locationOptions.options
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (open_jobs_index_module_default()).Jobs__JobType,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                            className: "".concat((open_jobs_index_module_default()).Jobs__CustomSelect),
                                                                            control: "select",
                                                                            placeholder: t("placeholder:job_type"),
                                                                            //default         =     {searching.job_type || ''}
                                                                            default: jobOptions.options[1],
                                                                            formik: formik,
                                                                            disabled: !isPreview,
                                                                            isClearable: true,
                                                                            onChange: function(value) {
                                                                                return showJobAction.handleValueOnChange("job_type", value, searching, searchValues, setPropsData, data, isFrame);
                                                                            },
                                                                            options: jobOptions.options
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "".concat((open_jobs_index_module_default()).Jobs__Remote),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                            className: "".concat((open_jobs_index_module_default()).Jobs__CustomSelect),
                                                                            control: "select",
                                                                            placeholder: "Remote",
                                                                            default: remoteOnlyOptions.options[1],
                                                                            formik: formik,
                                                                            disabled: !isPreview,
                                                                            isClearable: true,
                                                                            onChange: function(option) {
                                                                                return showJobAction.handleValueOnChange("remote", option.value, searching, searchValues, setPropsData, data, isFrame);
                                                                            },
                                                                            options: remoteOnlyOptions.options
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemHeading */.Ol, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemButton */.on, {
                                                    children: mFilterText
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((open_jobs_index_module_default()).Jobs__HideInMobile, " w100"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Formik */.J9, {
                                    children: function(formik) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (open_jobs_index_module_default()).Jobs__Width100,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (open_jobs_index_module_default()).Jobs__Select,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((open_jobs_index_module_default()).Jobs__Location),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                            className: "".concat((open_jobs_index_module_default()).Jobs__Location),
                                                            placeholder: t("label:location"),
                                                            control: "select",
                                                            default: searching.location_text,
                                                            formik: formik,
                                                            disabled: !isPreview,
                                                            onChange: function(value) {
                                                                return showJobAction.handleValueOnChange("location_text", value, searching, searchValues, setPropsData, data, isFrame);
                                                            },
                                                            options: locationOptions.options
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (open_jobs_index_module_default()).Jobs__JobType,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                            className: "".concat((open_jobs_index_module_default()).Jobs__CustomSelect),
                                                            control: "select",
                                                            placeholder: t("label:job_type"),
                                                            default: searching.job_type,
                                                            formik: formik,
                                                            disabled: !isPreview,
                                                            onChange: function(value) {
                                                                return showJobAction.handleValueOnChange("job_type", value, searching, searchValues, setPropsData, data, isFrame);
                                                            },
                                                            options: jobOptions.options
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((open_jobs_index_module_default()).Jobs__Remote),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                            className: "".concat((open_jobs_index_module_default()).Jobs__CustomSelect),
                                                            control: "select",
                                                            // placeholder     =     "Location type"
                                                            default: remoteOnlyOptions.options[1],
                                                            formik: formik,
                                                            disabled: !isPreview,
                                                            onChange: function(option) {
                                                                return showJobAction.handleValueOnChange("job_location_type", option.value, searching, searchValues, setPropsData, data, isFrame);
                                                            },
                                                            options: remoteOnlyOptions.options
                                                        })
                                                    })
                                                ]
                                            })
                                        });
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((open_jobs_index_module_default()).Jobs__Listing, " ").concat(data.jobs.length > 0 ? "JustifySpace" : "JustifyCenter"),
                        children: data.jobs.length > 0 ? data.jobs.map(function(job, job_index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((open_jobs_index_module_default()).Jobs__ListingBox, " ").concat(isPublic ? "CursorPointer" : ""),
                                onClick: function() {
                                    if (isPublic) showJobAction.redirectToJob(job.slug, data.client_slug, isFrame);
                                },
                                style: customizeCareerAction.setBackgroundColor(formik, page_section.type),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: (open_jobs_index_module_default()).Jobs__SubTitle,
                                        style: labelStyle,
                                        children: job.job_title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (open_jobs_index_module_default()).Jobs__ContractType,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "tt-captialize",
                                            style: labelStyle,
                                            children: [
                                                " ",
                                                customizeCareerAction.contractTypeTranslation(t, job.contract_type),
                                                " ",
                                                job.is_remote && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    style: labelStyle,
                                                    children: [
                                                        ", ",
                                                        t("career:jobs:remote"),
                                                        " "
                                                    ]
                                                }),
                                                " ",
                                                job.is_hybrid && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    style: labelStyle,
                                                    children: [
                                                        ", ",
                                                        t("career:jobs:hybrid"),
                                                        " "
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (open_jobs_index_module_default()).Jobs__PostedLocation,
                                        children: job.city_country && job.city_country != ", " ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            style: labelStyle,
                                            children: [
                                                " ",
                                                job.city_country.split(",")[0] == "" ? job.city_country.split(",")[1].trim() : job.city_country,
                                                " "
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    })
                                ]
                            }, "jobs_list_".concat(job_index));
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (open_jobs_index_module_default()).Jobs__NoOpenJobs,
                            style: customizeCareerAction.headerStyle(formik),
                            children: t("career:jobs:no_jobs")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((open_jobs_index_module_default()).Jobs__ViewAllJobs),
                        children: [
                            !isPreview && data.jobs.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                type: "button",
                                style: customizeCareerAction.viewMoreButtonStyle(formik),
                                children: t("career:jobs:view_more")
                            }),
                            isPreview && data.next_page && /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Button */.zx, {
                                type: "button",
                                style: customizeCareerAction.viewMoreButtonStyle(formik),
                                onClick: function(event) {
                                    showJobAction.getData(searching, data, setPropsData, isFrame);
                                },
                                children: [
                                    " ",
                                    t("career:jobs:view_more")
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/careers/footer.js + 5 modules
var footer = __webpack_require__(96719);
;// CONCATENATED MODULE: ./src/components/careers/test-section.js




function TestSection(props) {
    var updateLabelText = function updateLabelText(val, setTextValue, setIsEditing) {
        if (val.trim().length > 0) {
            setTextValue(val);
            setIsEditing(false);
        }
    };
    var styleHash = function styleHash() {
        return {
            color: "#abcabc",
            fontFamily: "Parabole",
            fontSize: "1rem",
            fontWeight: "bold",
            fontStyle: "italic",
            textDecoration: "underline"
        };
    };
    var buttonStyleHash = function buttonStyleHash() {
        return {
            backgroundColor: "#abcabc",
            color: "#000000",
            borderRadius: 2,
            fontSize: 15,
            fontFamily: "Gellix",
            fontWeight: "bold",
            fontStyle: "italic",
            textDecoration: "underline"
        };
    };
    var ref = _sliced_to_array(useState(false), 2), editText = ref[0], setEdittext = ref[1];
    var ref1 = _sliced_to_array(useState("hello"), 2), value = ref1[0], setTextValue = ref1[1];
    var ref2 = _sliced_to_array(useState(false), 2), isEditing = ref2[0], setIsEditing = ref2[1];
    return /*#__PURE__*/ _jsxs("div", {
        className: "test-div",
        children: [
            /*#__PURE__*/ _jsx("h3", {
                children: "FooterText"
            }),
            /*#__PURE__*/ _jsx("button", {
                className: "test-button",
                type: "button",
                style: buttonStyleHash(),
                children: "Button 1"
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/styles/components/careers/side-panel/_index.module.scss
var side_panel_index_module = __webpack_require__(14117);
var side_panel_index_module_default = /*#__PURE__*/__webpack_require__.n(side_panel_index_module);
;// CONCATENATED MODULE: ./public/icons/career_icons/closebtn.svg
var closebtn_path;

function closebtn_extends() { closebtn_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return closebtn_extends.apply(this, arguments); }



var SvgClosebtn = function SvgClosebtn(props) {
  return /*#__PURE__*/react.createElement("svg", closebtn_extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), closebtn_path || (closebtn_path = /*#__PURE__*/react.createElement("path", {
    d: "M15.585 1.945 14.057.418 8.001 6.474 1.945.418.418 1.945l6.056 6.056-6.056 6.056 1.527 1.528 6.056-6.056 6.056 6.056 1.528-1.528-6.056-6.056 6.056-6.056Z",
    fill: "var(--default-text-color)"
  })));
};

/* harmony default export */ var closebtn = (SvgClosebtn);
// EXTERNAL MODULE: ../../shared/node_modules/react-simple-tooltip/es/index.js + 11 modules
var react_simple_tooltip_es = __webpack_require__(54392);
// EXTERNAL MODULE: ../../shared/node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(73732);
;// CONCATENATED MODULE: ./src/components/careers/side-panel.js







function SidePanel(param) {
    var formik = param.formik, router = param.router, customizeCareerAction = param.customizeCareerAction, setResetCareerPage = param.setResetCareerPage, setLoading = param.setLoading, sidebar_section = param.sidebar_section, setFonts = param.setFonts, formRef = param.formRef;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "career_SidePanel",
        className: "".concat((side_panel_index_module_default()).SidePanel),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((side_panel_index_module_default()).SidePanel__Padding18),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((side_panel_index_module_default()).SidePanel__DFlex),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "".concat((side_panel_index_module_default()).SidePanel__CloseBtn),
                            onClick: function() {
                                return customizeCareerAction.showHideSidePanel(false);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(closebtn, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((side_panel_index_module_default()).SidePanel__PreviewPublishBtns),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                    type: "button",
                                    buttonstyle: "".concat((side_panel_index_module_default()).SidePanel__PreviewPublishBtns__Reset),
                                    disabled: !formik.values.can_reset,
                                    onClick: function() {
                                        setResetCareerPage(true);
                                    },
                                    children: t("button:reset")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "".concat((side_panel_index_module_default()).SidePanel__PreviewPublishBtns__Preview),
                                    onClick: function() {
                                        customizeCareerAction.redirectToPreview();
                                    // customizeCareerAction.showHideSidePanel(false)
                                    },
                                    children: t("button:preview")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((side_panel_index_module_default()).SidePanel__PublishBtn),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_simple_tooltip_es/* default */.Z, {
                                        className: "SimpleTooltip",
                                        content: t("career:changes_not_published"),
                                        background: "#00325A",
                                        radius: 20,
                                        padding: 10,
                                        placement: "bottom",
                                        fixed: false,
                                        fontSize: "11px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tooltipwidth145",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "button",
                                                className: "".concat((side_panel_index_module_default()).SidePanel__PreviewPublishBtns__Publish),
                                                onClick: function() {
                                                    setLoading(true);
                                                    customizeCareerAction.publishCareerPage(formik, setLoading);
                                                // customizeCareerAction.showHideSidePanel(false)
                                                },
                                                children: t("button:publish")
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AddSection, {
                    formik: formik,
                    sidebar_section: sidebar_section,
                    customizeCareerAction: customizeCareerAction,
                    setFonts: setFonts,
                    formRef: formRef
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/styles/components/careers/add-section/_index.module.scss
var add_section_index_module = __webpack_require__(17664);
var add_section_index_module_default = /*#__PURE__*/__webpack_require__.n(add_section_index_module);
;// CONCATENATED MODULE: ./src/components/careers/add-section/add-section.js




function AddSection(param) {
    var formik = param.formik, sidebar_section = param.sidebar_section, customizeCareerAction = param.customizeCareerAction, setFonts = param.setFonts, formRef = param.formRef;
    var t = (0,common/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((add_section_index_module_default()).SidePanel__AddSection),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Accordion */.UQ, {
            allowZeroExpanded: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItem */.Qd, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemHeading */.Ol, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemButton */.on, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("career:add_section")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItemPanel */.Mt, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutSection, {
                                    formik: formik,
                                    sidebar_section: sidebar_section,
                                    customizeCareerAction: customizeCareerAction
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GallerySection, {
                                    formik: formik,
                                    sidebar_section: sidebar_section,
                                    customizeCareerAction: customizeCareerAction
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BenfitSection, {
                                    formik: formik,
                                    sidebar_section: sidebar_section,
                                    customizeCareerAction: customizeCareerAction
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MeetTeamSection, {
                                    formik: formik,
                                    sidebar_section: sidebar_section,
                                    customizeCareerAction: customizeCareerAction
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItem */.Qd, {
                    className: "accordion__item re-ordertab",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemHeading */.Ol, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemButton */.on, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("career:reorder_page")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemPanel */.Mt, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReOrderSection, {
                                formik: formik,
                                customizeCareerAction: customizeCareerAction,
                                formRef: formRef
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItem */.Qd, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemHeading */.Ol, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemButton */.on, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("career:styles:heading")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItemPanel */.Mt, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroTitle, {
                                    formik: formik,
                                    sidebar_section: sidebar_section,
                                    customizeCareerAction: customizeCareerAction,
                                    setFonts: setFonts
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButtons, {
                                    formik: formik,
                                    sidebar_section: sidebar_section,
                                    customizeCareerAction: customizeCareerAction,
                                    setFonts: setFonts
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItem */.Qd, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemHeading */.Ol, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemButton */.on, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("career:nav_links:heading")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItemPanel */.Mt, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLinks, {
                                    formik: formik,
                                    sidebar_section: sidebar_section,
                                    customizeCareerAction: customizeCareerAction
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLinks, {
                                    formik: formik,
                                    sidebar_section: sidebar_section,
                                    customizeCareerAction: customizeCareerAction
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLinks, {
                                    formik: formik,
                                    sidebar_section: sidebar_section,
                                    customizeCareerAction: customizeCareerAction
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/careers/add-section/about.js



function AboutSection(param) {
    var formik = param.formik, sidebar_section = param.sidebar_section, customizeCareerAction = param.customizeCareerAction;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((add_section_index_module_default()).About),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "".concat((add_section_index_module_default()).About__Title),
                children: t("career:about")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((add_section_index_module_default()).About__FirstOption),
                onClick: function(event) {
                    customizeCareerAction.addSection(formik, "about", "with_image", t);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((add_section_index_module_default()).About__LeftContent),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((add_section_index_module_default()).About__Image),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/pages/career/about.png"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((add_section_index_module_default()).About__RightContent),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((add_section_index_module_default()).About__SubTitle),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: sidebar_section.about.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((add_section_index_module_default()).About__Para),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: sidebar_section.about.description
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((add_section_index_module_default()).About__AddBtn, " noAddbtn__Inreorder"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("button:add_section")
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/careers/add-section/gallery.js




function GallerySection(param) {
    var formik = param.formik, sidebar_section = param.sidebar_section, customizeCareerAction = param.customizeCareerAction;
    var disableClass = function disableClass(formik) {
        return formik.values.page_sections_attributes.filter(function(section) {
            return section.type == "gallery";
        }).length >= 2 ? "cursornone disabled" : "";
    };
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((add_section_index_module_default()).Gallery),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "".concat((add_section_index_module_default()).Gallery__Title),
                children: t("career:gallery")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((add_section_index_module_default()).Gallery__FirstOption),
                onClick: function(event) {
                    customizeCareerAction.addSection(formik, "gallery", "without_text", t);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((add_section_index_module_default()).Gallery__Content),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((add_section_index_module_default()).Gallery__Preview),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((add_section_index_module_default()).Gallery__Image),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/pages/career/gallery/page-gallery1.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/pages/career/gallery/page-gallery2.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/pages/career/gallery/page-gallery3.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/pages/career/gallery/page-gallery4.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/pages/career/gallery/page-gallery5.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/pages/career/gallery/page-gallery6.png"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((add_section_index_module_default()).Gallery__AddBtn, " noAddbtn__Inreorder"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "".concat(disableClass(formik)),
                            children: t("button:add_section")
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/careers/add-section/benefit.js



function BenfitSection(param) {
    var formik = param.formik, sidebar_section = param.sidebar_section, customizeCareerAction = param.customizeCareerAction;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((add_section_index_module_default()).Benefit),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "".concat((add_section_index_module_default()).Benefit__Title),
                children: t("career:benefit:title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((add_section_index_module_default()).Benefit__FirstOption),
                onClick: function(event) {
                    customizeCareerAction.addSection(formik, "benefit", "six_cards", t);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((add_section_index_module_default()).Benefit__Content),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((add_section_index_module_default()).Benefit__SubTitle),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: sidebar_section.benefit.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((add_section_index_module_default()).Benefit__Cards),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((add_section_index_module_default()).Benefit__Card),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).Benefit__Card__Icon),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/pages/career/benefit/icons/briefcase.png"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).Benefit__Card__Title),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: t("career:benefit:card1:title")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).Benefit__Card__Text),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    children: t("career:benefit:card1:text")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((add_section_index_module_default()).Benefit__Card),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).Benefit__Card__Icon),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/pages/career/benefit/icons/calendar.png"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).Benefit__Card__Title),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: t("career:benefit:card2:title")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).Benefit__Card__Text),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    children: t("career:benefit:card2:text")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((add_section_index_module_default()).Benefit__Card),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).Benefit__Card__Icon),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/pages/career/benefit/icons/pet_friendly.png"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).Benefit__Card__Title),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: t("career:benefit:card3:title")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).Benefit__Card__Text),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    children: t("career:benefit:card3:text")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((add_section_index_module_default()).Benefit__Card),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).Benefit__Card__Icon),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/pages/career/benefit/icons/add.png"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).Benefit__Card__Title),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: t("career:benefit:card4:title")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).Benefit__Card__Text),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    children: t("career:benefit:card4:text")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((add_section_index_module_default()).Benefit__Card),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).Benefit__Card__Icon),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/pages/career/benefit/icons/dummy-icon.svg"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).Benefit__Card__Title),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "".concat((add_section_index_module_default()).Benefit__AddTitleText),
                                                    children: t("career:benefit:card5:title")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).Benefit__Card__Text),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    className: "".concat((add_section_index_module_default()).Benefit__AddDescriptionText),
                                                    children: t("career:benefit:card5:text")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((add_section_index_module_default()).Benefit__Card),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).Benefit__Card__Icon),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/pages/career/benefit/icons/dummy-icon.svg"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).Benefit__Card__Title),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "".concat((add_section_index_module_default()).Benefit__AddTitleText),
                                                    children: t("career:benefit:card6:title")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).Benefit__Card__Text),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    className: "".concat((add_section_index_module_default()).Benefit__AddDescriptionText),
                                                    children: t("career:benefit:card6:text")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((add_section_index_module_default()).Benefit__AddBtn, " noAddbtn__Inreorder"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("button:add_section")
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/careers/add-section/meet_our_team.js



function MeetTeamSection(param) {
    var formik = param.formik, sidebar_section = param.sidebar_section, customizeCareerAction = param.customizeCareerAction;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((add_section_index_module_default()).MeetTeam),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "".concat((add_section_index_module_default()).MeetTeam__Title),
                children: t("career:meet_our_team:heading")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((add_section_index_module_default()).MeetTeam__FirstOption),
                onClick: function(event) {
                    customizeCareerAction.addSection(formik, "team", "with_description", t);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((add_section_index_module_default()).MeetTeam__Content),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((add_section_index_module_default()).MeetTeam__SubTitle),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: t("career:meet_our_team:heading")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((add_section_index_module_default()).MeetTeam__Cards),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Top),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((add_section_index_module_default()).MeetTeam__Card__UserDetails),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Icon),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/images/pages/career/meet_our_team/member1.png"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((add_section_index_module_default()).MeetTeam__RightContent),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Name),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                children: t("career:meet_our_team:member_1:name")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Designation),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                children: t("career:meet_our_team:member_1:designation_1")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Text),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: t("career:meet_our_team:member_1:quote")
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Top),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((add_section_index_module_default()).MeetTeam__Card__UserDetails),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Icon),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/images/pages/career/meet_our_team/member2.png"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((add_section_index_module_default()).MeetTeam__RightContent),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Name),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                children: t("career:meet_our_team:member_2:name")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Designation),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                children: t("career:meet_our_team:member_2:designation_1")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Text),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: t("career:meet_our_team:member_2:quote")
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Top),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((add_section_index_module_default()).MeetTeam__Card__UserDetails),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Icon),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/images/pages/career/meet_our_team/member3.png"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((add_section_index_module_default()).MeetTeam__RightContent),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Name),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                children: t("career:meet_our_team:member_3:name")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Designation),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                children: t("career:meet_our_team:member_3:designation_1")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Text),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: t("career:meet_our_team:member_3:quote")
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Top),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((add_section_index_module_default()).MeetTeam__Card__UserDetails),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Icon),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/images/pages/career/meet_our_team/member4.png"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((add_section_index_module_default()).MeetTeam__RightContent),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Name),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                children: t("career:meet_our_team:member_4:name")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Designation),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                children: t("career:meet_our_team:member_4:designation_1")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Text),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: t("career:meet_our_team:member_4:quote")
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Top),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((add_section_index_module_default()).MeetTeam__Card__UserDetails),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Icon),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/images/pages/career/meet_our_team/member5.png"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((add_section_index_module_default()).MeetTeam__RightContent),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Name),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                children: t("career:meet_our_team:member_5:name")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Designation),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                children: t("career:meet_our_team:member_5:designation_1")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Text),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: t("career:meet_our_team:member_5:quote")
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Top),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((add_section_index_module_default()).MeetTeam__Card__UserDetails),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Icon),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/images/pages/career/meet_our_team/member6.png"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((add_section_index_module_default()).MeetTeam__RightContent),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Name),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                children: t("career:meet_our_team:member_6:name")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Designation),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                children: t("career:meet_our_team:member_6:designation_1")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((add_section_index_module_default()).MeetTeam__Card__Text),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: t("career:meet_our_team:member_6:quote")
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((add_section_index_module_default()).MeetTeam__AddBtn, " noAddbtn__Inreorder"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("button:add_section")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((add_section_index_module_default()).MeetTeam__SecondOption),
                onClick: function(event) {
                    customizeCareerAction.addSection(formik, "team", "without_description", t);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((add_section_index_module_default()).MeetTeam__Content),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((add_section_index_module_default()).MeetTeam__SubTitle),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: t("career:meet_our_team:heading")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((add_section_index_module_default()).MeetTeam__Cards),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card, " ").concat((add_section_index_module_default()).MeetTeam__SecondOption__Card),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).MeetTeam__Card__Top),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((add_section_index_module_default()).MeetTeam__Card__UserDetails, " ").concat((add_section_index_module_default()).MeetTeam__MarginAuto),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Icon),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/images/pages/career/meet_our_team/member1.png"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom, " ").concat((add_section_index_module_default()).MeetTeam__Card__TextCenter),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Name),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            children: t("career:meet_our_team:member_1:name")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Designation),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            children: t("career:meet_our_team:member_6:designation_2")
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card, " ").concat((add_section_index_module_default()).MeetTeam__SecondOption__Card),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).MeetTeam__Card__Top),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((add_section_index_module_default()).MeetTeam__Card__UserDetails, " ").concat((add_section_index_module_default()).MeetTeam__MarginAuto),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Icon),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/images/pages/career/meet_our_team/member2.png"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom, " ").concat((add_section_index_module_default()).MeetTeam__Card__TextCenter),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Name),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            children: t("career:meet_our_team:member_2:name")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Designation),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            children: t("career:meet_our_team:member_6:designation_2")
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card, " ").concat((add_section_index_module_default()).MeetTeam__SecondOption__Card),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).MeetTeam__Card__Top),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((add_section_index_module_default()).MeetTeam__Card__UserDetails, " ").concat((add_section_index_module_default()).MeetTeam__MarginAuto),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Icon),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/images/pages/career/meet_our_team/member3.png"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom, " ").concat((add_section_index_module_default()).MeetTeam__Card__TextCenter),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Name),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            children: t("career:meet_our_team:member_3:name")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Designation),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            children: t("career:meet_our_team:member_6:designation_2")
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card, " ").concat((add_section_index_module_default()).MeetTeam__SecondOption__Card),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).MeetTeam__Card__Top),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((add_section_index_module_default()).MeetTeam__Card__UserDetails, " ").concat((add_section_index_module_default()).MeetTeam__MarginAuto),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Icon),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/images/pages/career/meet_our_team/member4.png"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom, " ").concat((add_section_index_module_default()).MeetTeam__Card__TextCenter),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Name),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            children: t("career:meet_our_team:member_4:name")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Designation),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            children: t("career:meet_our_team:member_6:designation_2")
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card, " ").concat((add_section_index_module_default()).MeetTeam__SecondOption__Card),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).MeetTeam__Card__Top),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((add_section_index_module_default()).MeetTeam__Card__UserDetails, " ").concat((add_section_index_module_default()).MeetTeam__MarginAuto),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Icon),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/images/pages/career/meet_our_team/member5.png"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom, " ").concat((add_section_index_module_default()).MeetTeam__Card__TextCenter),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Name),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            children: t("career:meet_our_team:member_5:name")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Designation),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            children: t("career:meet_our_team:member_6:designation_2")
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card, " ").concat((add_section_index_module_default()).MeetTeam__SecondOption__Card),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((add_section_index_module_default()).MeetTeam__Card__Top),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((add_section_index_module_default()).MeetTeam__Card__UserDetails, " ").concat((add_section_index_module_default()).MeetTeam__MarginAuto),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Icon),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/images/pages/career/meet_our_team/member6.png"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom, " ").concat((add_section_index_module_default()).MeetTeam__Card__TextCenter),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Name),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            children: t("career:meet_our_team:member_6:name")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((add_section_index_module_default()).MeetTeam__Card__Bottom__Designation),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            children: t("career:meet_our_team:member_6:designation_2")
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((add_section_index_module_default()).MeetTeam__AddBtn, " noAddbtn__Inreorder"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("button:add_section")
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(18186);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4012);
// EXTERNAL MODULE: ../../shared/node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(56621);
;// CONCATENATED MODULE: ./src/components/careers/add-section/reorder.js









function ReOrderSection(param) {
    var formik = param.formik, customizeCareerAction = param.customizeCareerAction, formRef = param.formRef;
    var render_page_section = function render_page_section(page_section, index, formik, customizeCareerAction, isPreview) {
        var section_type = page_section.type;
        switch(section_type){
            case "about":
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((add_section_index_module_default()).ReOrder__AboutOptionCard),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((add_section_index_module_default()).ReOrder__SubTitle),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: (0,html_react_parser/* default */.ZP)(page_section.career_about_section_attributes.title)
                            })
                        }),
                        !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((add_section_index_module_default()).ReOrder__RemoveSection),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                onClick: function(event) {
                                    customizeCareerAction.removeSection(formik, page_section);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/icons/career_icons/grey_delete.svg"
                                })
                            })
                        })
                    ]
                });
                break;
            case "benefit":
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((add_section_index_module_default()).ReOrder__BenefitOptionCard),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((add_section_index_module_default()).ReOrder__SubTitle),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: (0,html_react_parser/* default */.ZP)(page_section.career_benefit_section_attributes.title)
                            })
                        }),
                        !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((add_section_index_module_default()).ReOrder__RemoveSection),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                onClick: function(event) {
                                    customizeCareerAction.removeSection(formik, page_section);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/icons/career_icons/grey_delete.svg"
                                })
                            })
                        })
                    ]
                });
                break;
            case "team":
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((add_section_index_module_default()).ReOrder__MeetOurTeamOptionCard),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((add_section_index_module_default()).ReOrder__SubTitle),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: (0,html_react_parser/* default */.ZP)(page_section.career_team_section_attributes.title)
                            })
                        }),
                        !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((add_section_index_module_default()).ReOrder__RemoveSection),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                onClick: function(event) {
                                    customizeCareerAction.removeSection(formik, page_section);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/icons/career_icons/grey_delete.svg"
                                })
                            })
                        })
                    ]
                });
                break;
            case "gallery":
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((add_section_index_module_default()).ReOrder__GalleryOptionCard),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((add_section_index_module_default()).ReOrder__SubTitle),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: (0,html_react_parser/* default */.ZP)(page_section.career_gallery_section_attributes.title)
                            })
                        }),
                        !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((add_section_index_module_default()).ReOrder__RemoveSection),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                onClick: function(event) {
                                    customizeCareerAction.removeSection(formik, page_section);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/icons/career_icons/grey_delete.svg"
                                })
                            })
                        })
                    ]
                });
                break;
        }
    };
    var render_static_section = function render_static_section(label) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((add_section_index_module_default()).ReOrder__DefaultOptionCard),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((add_section_index_module_default()).ReOrder__SubTitle, " ml0"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    children: label
                })
            })
        });
    };
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((add_section_index_module_default()).ReOrder),
        children: [
            render_static_section(t("career:hero_section")),
            render_static_section(t("career:job_openings")),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "DragandDropArea",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* DragDropContext */.Z5, {
                    onDragEnd: function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(result) {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            customizeCareerAction.onDragEnd(result, formRef, formik)
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            _state.sent()
                                        ];
                                }
                            });
                        });
                        return function(result) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Droppable */.bK, {
                        droppableId: "SectionsList",
                        children: function(provided, snapshot) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                className: "".concat(snapshot.isDraggingOver ? "dragactive" : ""),
                                ref: provided.innerRef
                            }, provided.droppableProps), {
                                children: [
                                    formik.values.page_sections_attributes.map(function(page_section, index) {
                                        {
                                            return page_section.type != "job" && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Draggable */._l, {
                                                draggableId: page_section.id.toString(),
                                                index: index,
                                                children: function(provided, snapshot) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        className: "".concat((customize_career_page_index_module_default()).Interview__FormRowHeading, " ").concat((customize_career_page_index_module_default()).DragAndDrop, " ").concat(snapshot.isDragging ? "drag" : "")
                                                    }, provided.draggableProps, provided.dragHandleProps), {
                                                        ref: provided.innerRef,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat((customize_career_page_index_module_default()).DragAndDrop__CursorHandle),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grey_gripicon, {})
                                                            }),
                                                            render_page_section(page_section, index, formik, customizeCareerAction)
                                                        ]
                                                    }));
                                                }
                                            }, page_section.id.toString());
                                        }
                                    }),
                                    provided.placeholder
                                ]
                            }));
                        }
                    })
                })
            }),
            render_static_section(t("career:footer"))
        ]
    });
}

// EXTERNAL MODULE: ./src/styles/pages/career/customize-career-page/_index.module.scss
var customize_career_page_index_module = __webpack_require__(70525);
var customize_career_page_index_module_default = /*#__PURE__*/__webpack_require__.n(customize_career_page_index_module);
;// CONCATENATED MODULE: ./src/components/careers/about.js





function About(param) {
    var formik = param.formik, index = param.index, page_section = param.page_section, customizeCareerAction = param.customizeCareerAction, isPreview = param.isPreview, resetCareerPage = param.resetCareerPage;
    var setOverlay = function setOverlay(formik) {
        var backgroundColor = formik.values.career_font_style_attributes.style_hash.style_2.background_color;
        var image_url = formik.values.page_sections_attributes[index].career_about_section_attributes.image_url || "/images/pages/career/about.png";
        var property = "linear-gradient(0deg, ".concat(customizeCareerAction.hexToRGB(backgroundColor, 0.5), ", ").concat(customizeCareerAction.hexToRGB(backgroundColor, 0.5), "), url(").concat(image_url, ")");
        return {
            background: property
        };
    };
    var aboutTitle = (0,common/* useRef */.sO)(formik.values.page_sections_attributes[index].career_about_section_attributes.title || page_section.title || "");
    var aboutDescription = (0,common/* useRef */.sO)(formik.values.page_sections_attributes[index].career_about_section_attributes.description || page_section.description || "");
    var ref = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(0), 2), flagForRender = ref[0], setFlagForRender = ref[1];
    (0,common/* useEffect */.d4)(function() {
        aboutTitle.current = formik.values.page_sections_attributes[index].career_about_section_attributes.title || page_section.title || "";
        aboutDescription.current = formik.values.page_sections_attributes[index].career_about_section_attributes.description || page_section.description || "";
        setFlagForRender(Math.random() * 10000);
    }, [
        resetCareerPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((customize_career_page_index_module_default()).About),
        id: page_section.uniq_reference,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((customize_career_page_index_module_default()).About__Container),
            children: page_section.career_about_section_attributes.layout == "with_image" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((customize_career_page_index_module_default()).About__FirstOption),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((customize_career_page_index_module_default()).About__LeftContent),
                        style: customizeCareerAction.setBackgroundOverlay(formik, page_section.type),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((customize_career_page_index_module_default()).About__Image),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: formik.values.page_sections_attributes[index].career_about_section_attributes.image_url || "/images/pages/career/about.png"
                                }),
                                !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((customize_career_page_index_module_default()).About__Image__EditIcon),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            id: "",
                                            accept: ".png, .jpg, .jpeg",
                                            type: "file",
                                            // name      =   {`page_sections_attributes.${index}.career_about_section_attributes.image`}
                                            title: customizeCareerAction.imageInfoContent("about_image"),
                                            onChange: function(event) {
                                                return customizeCareerAction.handleAboutChange(event, formik, index);
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(edit_banner, {})
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((customize_career_page_index_module_default()).About__RightContent),
                        style: customizeCareerAction.setBackgroundColor(formik, page_section.type),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(isPreview ? (customize_career_page_index_module_default()).About__ContentPreview : (customize_career_page_index_module_default()).About__ContentEditable),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((customize_career_page_index_module_default()).About__SubTitle),
                                    children: isPreview ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        suppressContentEditableWarning: true,
                                        style: customizeCareerAction.setFontColor(formik, page_section.type),
                                        children: (0,html_react_parser/* default */.ZP)(aboutTitle.current)
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        contentEditable: true,
                                        onInput: function(e) {
                                            customizeCareerAction.titleLengthWarning(e.currentTarget.textContent);
                                            formik.setFieldValue("page_sections_attributes.".concat(index, ".career_about_section_attributes.title"), e.currentTarget.innerHTML);
                                        },
                                        onPaste: function(event) {
                                            customizeCareerAction.onPastePreventStyling(event);
                                        },
                                        onBlur: function(e) {
                                            customizeCareerAction.updateAboutSection(formik, index);
                                        },
                                        suppressContentEditableWarning: true,
                                        dangerouslySetInnerHTML: {
                                            __html: aboutTitle.current
                                        },
                                        style: customizeCareerAction.setFontColor(formik, page_section.type)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(isPreview ? (customize_career_page_index_module_default()).About__ContentPreview : (customize_career_page_index_module_default()).About__ContentEditable),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((customize_career_page_index_module_default()).About__Para),
                                    children: isPreview ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        suppressContentEditableWarning: true,
                                        dangerouslySetInnerHTML: {
                                            __html: aboutDescription.current
                                        },
                                        style: customizeCareerAction.setFontColor(formik, page_section.type)
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        contentEditable: true,
                                        onInput: function(e) {
                                            customizeCareerAction.descriptionLengthWarning(e.currentTarget.innerHTML);
                                            formik.setFieldValue("page_sections_attributes.".concat(index, ".career_about_section_attributes.description"), e.currentTarget.innerHTML);
                                        },
                                        onPaste: function(event) {
                                            customizeCareerAction.onPastePreventStyling(event);
                                        },
                                        onBlur: function(e) {
                                            customizeCareerAction.updateAboutSection(formik, index);
                                        },
                                        suppressContentEditableWarning: true,
                                        dangerouslySetInnerHTML: {
                                            __html: aboutDescription.current
                                        },
                                        style: customizeCareerAction.setFontColor(formik, page_section.type),
                                        max: 1000
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./public/icons/career_icons/bigplus.svg
var bigplus_path;

function bigplus_extends() { bigplus_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bigplus_extends.apply(this, arguments); }



var SvgBigplus = function SvgBigplus(props) {
  return /*#__PURE__*/React.createElement("svg", bigplus_extends({
    width: 54,
    height: 55,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), bigplus_path || (bigplus_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.494 23.527h22.487v8.023H31.494v23.278h-8.136V31.55H.871v-8.023h22.487V.137h8.136v23.39Z",
    fill: "#99ADBD"
  })));
};

/* harmony default export */ var bigplus = ((/* unused pure expression or super */ null && (SvgBigplus)));
;// CONCATENATED MODULE: ./public/images/pages/career/benefit/icons/black_close.svg
var black_close_path;

function black_close_extends() { black_close_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return black_close_extends.apply(this, arguments); }



var SvgBlackClose = function SvgBlackClose(props) {
  return /*#__PURE__*/react.createElement("svg", black_close_extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), black_close_path || (black_close_path = /*#__PURE__*/react.createElement("path", {
    d: "m8.744 7.543 5.45 5.45c.043.087.087.175.087.263a.336.336 0 0 1-.088.22l-1.01 1.01c-.088.088-.176.088-.264.088-.088 0-.176 0-.22-.088L7.25 9.037l-5.45 5.45c-.087.087-.175.087-.263.087-.088 0-.176 0-.22-.088l-1.01-1.01c-.088-.044-.088-.132-.088-.22s0-.176.088-.264l5.449-5.449-5.45-5.45C.22 2.05.22 1.963.22 1.875s0-.176.088-.264L1.317.6a.336.336 0 0 1 .22-.088c.088 0 .176.044.264.088L7.25 6.049 12.7.599a.336.336 0 0 1 .219-.087c.088 0 .176.044.264.088l1.01 1.01c.044.088.088.176.088.264a.336.336 0 0 1-.088.22l-.922.923-4.527 4.526Z",
    fill: "#000"
  })));
};

/* harmony default export */ var black_close = (SvgBlackClose);
;// CONCATENATED MODULE: ./public/icons/career_icons/eyeGalleryClose.svg
var eyeGalleryClose_path;

function eyeGalleryClose_extends() { eyeGalleryClose_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return eyeGalleryClose_extends.apply(this, arguments); }



var SvgEyeGalleryClose = function SvgEyeGalleryClose(props) {
  return /*#__PURE__*/react.createElement("svg", eyeGalleryClose_extends({
    width: 30,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), eyeGalleryClose_path || (eyeGalleryClose_path = /*#__PURE__*/react.createElement("path", {
    d: "m14.238 18.852-5.941-8.48c-.356 1.32-.305 2.64.152 3.858a6.571 6.571 0 0 0 2.184 3.149 6.18 6.18 0 0 0 3.605 1.473ZM15 20.527h.406l1.625 2.336c-.71.102-1.37.102-2.031.102-3.047 0-5.79-.711-8.328-2.235A15.403 15.403 0 0 1 .73 14.84c-.253-.356-.355-.762-.355-1.219 0-.406.102-.812.355-1.219A16.045 16.045 0 0 1 5.91 6.97l1.371 1.98c-1.879 1.219-3.351 2.793-4.468 4.672 1.218 2.133 2.945 3.809 5.078 5.027 2.132 1.27 4.52 1.88 7.109 1.88Zm14.27-5.687c.203-.356.355-.762.355-1.219 0-.406-.152-.812-.355-1.219a16.926 16.926 0 0 0-5.942-5.89A16.373 16.373 0 0 0 15 4.277c-1.574 0-3.098.203-4.57.61L7.586.875C7.484.773 7.383.672 7.23.621c-.203 0-.355 0-.457.102l-1.066.761c-.152.102-.254.254-.254.407-.05.152 0 .304.102.406l16.86 24.07c.05.152.151.254.355.254.152.05.304 0 .457-.101l1.066-.762c.102-.102.203-.203.254-.356 0-.152 0-.304-.102-.457l-2.437-3.504A16.162 16.162 0 0 0 26.12 18.7a16.628 16.628 0 0 0 3.149-3.86Zm-2.082-1.219c-.762 1.32-1.727 2.438-2.844 3.402-1.117 1.016-2.387 1.778-3.758 2.387l-1.371-1.93c1.32-1.015 2.183-2.386 2.539-4.062.305-1.625.101-3.2-.66-4.672 0 .813-.305 1.473-.864 2.031-.558.559-1.218.813-1.98.813-.813 0-1.473-.254-2.031-.813-.559-.558-.813-1.218-.813-2.03 0-.763.254-1.423.813-1.981 2.285.203 4.418.914 6.347 2.132a14.166 14.166 0 0 1 4.622 4.723Z",
    fill: "#fff"
  })));
};

/* harmony default export */ var eyeGalleryClose = (SvgEyeGalleryClose);
;// CONCATENATED MODULE: ./public/icons/career_icons/eyeGalleryOpen.svg
var _g, _defs;

function eyeGalleryOpen_extends() { eyeGalleryOpen_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return eyeGalleryOpen_extends.apply(this, arguments); }



var SvgEyeGalleryOpen = function SvgEyeGalleryOpen(props) {
  return /*#__PURE__*/react.createElement("svg", eyeGalleryOpen_extends({
    width: 30,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#eyeGalleryOpen_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M29.27 12.031c.203.406.355.813.355 1.219 0 .457-.152.863-.355 1.219-1.473 2.488-3.454 4.469-5.942 5.89-2.539 1.524-5.332 2.235-8.328 2.235-3.047 0-5.79-.711-8.328-2.235A15.403 15.403 0 0 1 .73 14.47c-.253-.356-.355-.762-.355-1.219 0-.406.102-.813.355-1.219 1.422-2.437 3.403-4.418 5.942-5.89C9.21 4.668 11.953 3.906 15 3.906c2.996 0 5.79.762 8.328 2.235a16.926 16.926 0 0 1 5.942 5.89ZM15 20.156c2.54 0 4.926-.61 7.059-1.879a13.912 13.912 0 0 0 5.128-5.027 16.846 16.846 0 0 0-2.894-3.402 13.554 13.554 0 0 0-3.809-2.438c.914 1.27 1.422 2.692 1.422 4.215a6.66 6.66 0 0 1-.965 3.453 7.02 7.02 0 0 1-2.488 2.54A6.889 6.889 0 0 1 15 18.53c-1.27 0-2.438-.304-3.453-.914a6.771 6.771 0 0 1-2.54-2.539c-.609-1.015-.913-2.183-.913-3.453 0-1.117.254-2.234.812-3.25 0 .813.254 1.473.813 2.031.558.559 1.219.813 2.031.813.762 0 1.422-.254 1.98-.813.56-.558.864-1.219.864-2.031 0-.762-.305-1.422-.813-1.98a13.89 13.89 0 0 0-6.347 2.132c-1.93 1.22-3.504 2.793-4.622 4.723 1.22 2.133 2.946 3.809 5.079 5.027 2.132 1.27 4.52 1.88 7.109 1.88Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "eyeGalleryOpen_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v27H0z"
  })))));
};

/* harmony default export */ var eyeGalleryOpen = (SvgEyeGalleryOpen);
// EXTERNAL MODULE: ../../shared/node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(75462);
;// CONCATENATED MODULE: ./public/icons/career_icons/add-plus.svg
var add_plus_path;

function add_plus_extends() { add_plus_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return add_plus_extends.apply(this, arguments); }



var SvgAddPlus = function SvgAddPlus(props) {
  return /*#__PURE__*/react.createElement("svg", add_plus_extends({
    width: 17,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), add_plus_path || (add_plus_path = /*#__PURE__*/react.createElement("path", {
    d: "M9.909 7.44h6.898v2.461H9.91v7.142H7.413V9.9H.514V7.44h6.899V.264h2.496V7.44Z",
    fill: "#002644"
  })));
};

/* harmony default export */ var add_plus = (SvgAddPlus);
// EXTERNAL MODULE: ../../shared/node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(41410);
// EXTERNAL MODULE: ../../shared/node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(31602);
// EXTERNAL MODULE: ../../shared/node_modules/swiper/modules/free-mode/free-mode.min.css
var free_mode_min = __webpack_require__(5359);
// EXTERNAL MODULE: ../../shared/node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(69038);
// EXTERNAL MODULE: ../../shared/node_modules/swiper/swiper.esm.js + 89 modules
var swiper_esm = __webpack_require__(9784);
;// CONCATENATED MODULE: ./src/components/careers/gallery.js












// Import Swiper React components

// Import Swiper styles



// import required modules

function Gallery(param) {
    var formik = param.formik, index = param.index, page_section = param.page_section, customizeCareerAction = param.customizeCareerAction, isPreview = param.isPreview, resetCareerPage = param.resetCareerPage;
    var galleryEyeIcons = function galleryEyeIcons(formik, index, gallery_index) {
        return formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes[gallery_index].display == "show" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(eyeGalleryOpen, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(eyeGalleryClose, {});
    };
    var showHideValue = function showHideValue(formik, index, gallery_index) {
        return formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes[gallery_index].display == "show" ? "hide" : "show";
    };
    var galleryCount = function galleryCount(formik, index) {
        var count = formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes.length;
        if (lib/* TabletView */.Du && !lib/* isMobile */.tq) {
            return count <= 2 ? "swiper-center tablet" : "";
        } else if (lib/* isMobile */.tq) {
            return count <= 1 ? "swiper-center mobile" : "";
        } else {
            return count <= 2 ? "swiper-center" : "";
        }
    };
    var cardLayout = function cardLayout(formik, index) {
        var item_length = formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes.filter(function(x) {
            return isPreview ? x.display == "show" : true;
        }).length;
        if ( true && window.innerWidth >= 768 && window.innerWidth <= 1024) {
            return (customize_career_page_index_module_default()).Gallery__FourCardLayout;
        }
        switch(true){
            case item_length < 3:
                return (customize_career_page_index_module_default()).Gallery__FourCardLayout;
            case item_length == 3:
                return (customize_career_page_index_module_default()).Gallery__ThreeCardLayout;
            case item_length == 4:
                return (customize_career_page_index_module_default()).Gallery__FourCardLayout;
            case item_length <= 6:
                return (customize_career_page_index_module_default()).Gallery__SixCardLayout;
            default:
                return (customize_career_page_index_module_default()).Gallery__SixCardLayout;
        }
    };
    var dummy_image_url = function dummy_image_url(validItemLength) {
        if ( true && window.innerWidth >= 768 && window.innerWidth <= 1024) return "/images/pages/career/gallery/dummy@512.png";
        return [
            1,
            2,
            4
        ].includes(validItemLength) ? "/images/pages/career/gallery/dummy@768.png" : "/images/pages/career/gallery/dummy@512.png";
    };
    var validItemLength = formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes.filter(function(x) {
        return isPreview ? x.display == "show" : true;
    }).length;
    var galleryTitle = (0,common/* useRef */.sO)(formik.values.page_sections_attributes[index].career_gallery_section_attributes.title || page_section.title || "");
    var galleryDescription = (0,common/* useRef */.sO)(formik.values.page_sections_attributes[index].career_gallery_section_attributes.description || page_section.description || "");
    var ref = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), addDisabled = ref[0], setAddDisabled = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(0), 2), flagForRender = ref1[0], setFlagForRender = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(0), 2), flagForReRender = ref2[0], setFlagForReRender = ref2[1];
    (0,common/* useEffect */.d4)(function() {
        setFlagForReRender(Math.random() * 10000);
    }, [
        resetCareerPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((customize_career_page_index_module_default()).Gallery),
            id: page_section.uniq_reference,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: isPreview ? "".concat((customize_career_page_index_module_default()).Gallery__PreviewContainer) : "".concat((customize_career_page_index_module_default()).Gallery__Container),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((customize_career_page_index_module_default()).Gallery__FirstOption),
                    style: customizeCareerAction.setBackgroundColor(formik, page_section.type),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((customize_career_page_index_module_default()).Gallery__Content),
                            children: [
                                !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((customize_career_page_index_module_default()).Gallery__EditView),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((customize_career_page_index_module_default()).Gallery__Image, " ").concat(cardLayout(formik, index)),
                                        children: formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes.map(function(gallery_detail, gallery_index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((customize_career_page_index_module_default()).Gallery__EditImage),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: gallery_detail.display == "show" ? gallery_detail.image_url || "/images/pages/career/gallery/page-gallery".concat(gallery_index % 6 + 1, ".png") : dummy_image_url(validItemLength)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((customize_career_page_index_module_default()).Gallery__EditImage__UploadIcon),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "file",
                                                            id: "img",
                                                            name: "img",
                                                            accept: ".png, .jpg, .jpeg",
                                                            onChange: function(event) {
                                                                customizeCareerAction.handleGalleryImage(event, formik, index, gallery_index);
                                                            },
                                                            title: customizeCareerAction.imageInfoContent("gallery_image")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((customize_career_page_index_module_default()).Gallery__EditImage__EditIcon),
                                                        children: formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes.length > 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((customize_career_page_index_module_default()).Gallery__EditImage__UploadIcon),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(black_close, {
                                                                onClick: function() {
                                                                    customizeCareerAction.removeGalleryCard(formik, index, gallery_index);
                                                                }
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, "gallery_op1_".concat(gallery_index));
                                        })
                                    })
                                }),
                                isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((customize_career_page_index_module_default()).Gallery__Preview),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((customize_career_page_index_module_default()).Gallery__Image, " ").concat(cardLayout(formik, index), " ").concat(galleryCount(formik, index)),
                                        children: formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes.map(function(gallery_detail, gallery_index) {
                                            return gallery_detail.display == "show" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((customize_career_page_index_module_default()).Gallery__EditImage),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: gallery_detail.image_url || "/images/pages/career/gallery/page-gallery".concat(gallery_index % 6 + 1, ".png")
                                                })
                                            }, "gallery_op1_".concat(gallery_index));
                                        })
                                    })
                                })
                            ]
                        }),
                        !isPreview && formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes.length < 6 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((customize_career_page_index_module_default()).MeetTeam__AddNewMember, " ").concat((customize_career_page_index_module_default()).Gallery__AddNewMember),
                            onClick: function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!!addDisabled) return [
                                                    3,
                                                    2
                                                ];
                                                setAddDisabled(true);
                                                return [
                                                    4,
                                                    customizeCareerAction.addGalleryCard(formik, index)
                                                ];
                                            case 1:
                                                _state.sent();
                                                setAddDisabled(false);
                                                _state.label = 2;
                                            case 2:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(event) {
                                    return _ref.apply(this, arguments);
                                };
                            }(),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "".concat((customize_career_page_index_module_default()).MeetTeam__AddNewMember__Icon, " ").concat((customize_career_page_index_module_default()).Gallery__AddNewMember__Icon),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(add_plus, {})
                                    }),
                                    " Add Image "
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./public/images/pages/career/benefit/icons/benefit_editIcon.svg
var benefit_editIcon_g, benefit_editIcon_defs;

function benefit_editIcon_extends() { benefit_editIcon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return benefit_editIcon_extends.apply(this, arguments); }



var SvgBenefitEditIcon = function SvgBenefitEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", benefit_editIcon_extends({
    width: 37,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), benefit_editIcon_g || (benefit_editIcon_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#benefit_editIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.501,
    y: 0.742,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.14 18.979c-.058.058-.058.087-.058.146v3.34H11.77V12.152h7.09c.058 0 .088 0 .146-.058l.938-.938c.058-.058.087-.146.058-.263-.058-.088-.117-.147-.205-.147H11.77c-.41 0-.733.147-.996.41-.293.293-.41.615-.41.996v10.313c0 .41.117.732.41.996.263.293.586.41.996.41h10.312c.381 0 .703-.117.996-.41.264-.264.41-.586.41-.996v-4.248c0-.117-.058-.176-.146-.235-.117-.029-.205 0-.264.059l-.937.938Zm4.6-5.918a1.66 1.66 0 0 0 .498-1.202c0-.468-.175-.879-.498-1.23l-1.26-1.26c-.35-.322-.761-.498-1.23-.498a1.66 1.66 0 0 0-1.201.498l-7.705 7.705-.293 2.637c-.059.41.059.732.351.996.264.293.587.41.997.352l2.636-.293 7.705-7.705Zm-2.9.908-5.45 5.449-1.904.205.206-1.904 5.449-5.45 1.699 1.7Zm1.904-2.344a.333.333 0 0 1 .088.234c0 .088-.03.147-.088.206l-.908.908-1.7-1.7.91-.908a.266.266 0 0 1 .204-.088c.088 0 .176.03.235.088l1.26 1.26Z",
    fill: "#333"
  }))), benefit_editIcon_defs || (benefit_editIcon_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "benefit_editIcon_svg__a",
    x: 0.501,
    y: 0.742,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20011_86070"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_20011_86070",
    result: "shape"
  })))));
};

/* harmony default export */ var benefit_editIcon = ((/* unused pure expression or super */ null && (SvgBenefitEditIcon)));
;// CONCATENATED MODULE: ./src/components/careers/benefit.js












// Import Swiper React components

// Import Swiper styles



// import required modules

function Benefit(param) {
    var formik = param.formik, index = param.index, page_section = param.page_section, customizeCareerAction = param.customizeCareerAction, isPreview = param.isPreview, resetCareerPage = param.resetCareerPage, t = param.t;
    var benefitCount = function benefitCount(formik, index) {
        var count = formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes.length;
        if (lib/* TabletView */.Du && !lib/* isMobile */.tq) {
            return count <= 3 ? "swiper-center tablet" : "";
        } else if (lib/* isMobile */.tq) {
            return count <= 2 ? "swiper-center mobile" : "";
        } else {
            return count <= 3 ? "swiper-center" : "";
        }
    };
    var cardLayout = function cardLayout(formik, index) {
        var item_length = formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes.filter(function(x) {
            return isPreview ? x.display == "show" : true;
        }).length;
        if ( true && window.innerWidth >= 768 && window.innerWidth <= 1024) {
            return (customize_career_page_index_module_default()).Benefit__FourCardLayout;
        }
        switch(true){
            case item_length < 3:
                return (customize_career_page_index_module_default()).Benefit__FourCardLayout;
            case item_length == 3:
                return (customize_career_page_index_module_default()).Benefit__ThreeCardLayout;
            case item_length == 4:
                return (customize_career_page_index_module_default()).Benefit__FourCardLayout;
            case item_length <= 6:
                return (customize_career_page_index_module_default()).Benefit__SixCardLayout;
            default:
                return (customize_career_page_index_module_default()).Benefit__SixCardLayout;
        }
    };
    var benefitDefaultImage = function benefitDefaultImage(record, benefit_index) {
        if (record.image_url) {
            return record.image_url;
        } else {
            return "/images/pages/career/benefit/dummy-icon.svg";
        // if(benefit_index > 2 || (record.display == 'hide'))
        // switch(benefit_index){
        // case 0:
        //   return '/images/pages/career/benefit/icons/fire--alarm.png'
        // case 1:
        //   return '/images/pages/career/benefit/icons/apple.png'
        // case 2:
        //   return '/images/pages/career/benefit/icons/rock-on.png'
        // }
        }
    };
    var getTitleDescription = function getTitleDescription(benefitSection, benefit_index, type) {
        switch(type){
            case "title":
                return benefitSection.current.career_benefit_details_attributes.filter(function(x) {
                    return !x.destroy;
                })[benefit_index].title || "";
            case "description":
                return benefitSection.current.career_benefit_details_attributes.filter(function(x) {
                    return !x.destroy;
                })[benefit_index].description || "";
        }
    };
    var benefitSection = (0,common/* useRef */.sO)(formik.values.page_sections_attributes[index].career_benefit_section_attributes);
    var validItemLength = formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes.filter(function(x) {
        return isPreview ? x.display == "show" : true;
    }).length;
    var ref = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(0), 2), flagForRender = ref[0], setFlagForRender = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(0), 2), flagForReRender = ref1[0], setFlagForReRender = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), addDisabled = ref2[0], setAddDisabled = ref2[1];
    var headingFontColor = customizeCareerAction.job_benefit_heading_color(formik);
    (0,common/* useEffect */.d4)(function() {
        benefitSection.current.career_benefit_details_attributes = formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes.filter(function(x) {
            return !x.destroy;
        });
        benefitSection.current.title = formik.values.page_sections_attributes[index].career_benefit_section_attributes.title;
        setFlagForReRender(Math.random() * 10000);
    }, [
        flagForRender,
        resetCareerPage
    ]);
    if (validItemLength == 0 && isPreview) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((customize_career_page_index_module_default()).Benefit),
        id: page_section.uniq_reference,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: isPreview ? "".concat((customize_career_page_index_module_default()).Benefit__PreviewContainer) : "".concat((customize_career_page_index_module_default()).Benefit__Container),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((customize_career_page_index_module_default()).Benefit__FirstOption),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((customize_career_page_index_module_default()).Benefit__Content),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(isPreview ? (customize_career_page_index_module_default()).Benefit__ContentPreview : (customize_career_page_index_module_default()).Benefit__ContentEditable),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((customize_career_page_index_module_default()).Benefit__SubTitle),
                                    children: isPreview ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        suppressContentEditableWarning: true,
                                        style: headingFontColor,
                                        children: (0,html_react_parser/* default */.ZP)(benefitSection.current.title)
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        contentEditable: true,
                                        onInput: function(e) {
                                            customizeCareerAction.titleLengthWarning(e.currentTarget.textContent);
                                            formik.setFieldValue("page_sections_attributes.".concat(index, ".career_benefit_section_attributes.title"), e.currentTarget.innerHTML);
                                        },
                                        onPaste: function(event) {
                                            customizeCareerAction.onPastePreventStyling(event);
                                        },
                                        onBlur: function(e) {
                                            customizeCareerAction.updateAboutSection(formik, index);
                                        },
                                        suppressContentEditableWarning: true,
                                        dangerouslySetInnerHTML: {
                                            __html: benefitSection.current.title
                                        },
                                        style: headingFontColor
                                    })
                                })
                            }),
                            !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((customize_career_page_index_module_default()).Benefit__Cards, " ").concat(cardLayout(formik, index)),
                                children: formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes.map(function(benefit_detail, benefit_index) {
                                    var ref, ref1, ref2, ref3;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((customize_career_page_index_module_default()).Benefit__Card, " ").concat((customize_career_page_index_module_default()).Benefit__Card__Hover),
                                        children: [
                                            !isPreview && formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes.length > 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((customize_career_page_index_module_default()).Benefit__Card__Delete),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(black_close, {
                                                    onClick: function() {
                                                        customizeCareerAction.removeBenefitCard(formik, index, benefit_index, setFlagForRender);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((customize_career_page_index_module_default()).Benefit__Card__Icon),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: benefitDefaultImage(benefit_detail, benefit_index)
                                                    }),
                                                    !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((customize_career_page_index_module_default()).Benefit__Card__EditIcon),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "file",
                                                            id: "img",
                                                            name: "img",
                                                            accept: ".png, .jpg, .jpeg",
                                                            onChange: function(event) {
                                                                return customizeCareerAction.handleBenefitImage(event, formik, index, benefit_index);
                                                            },
                                                            title: customizeCareerAction.imageInfoContent("benefit_image")
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(isPreview ? (customize_career_page_index_module_default()).Benefit__ContentPreview : (customize_career_page_index_module_default()).Benefit__ContentEditable),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((customize_career_page_index_module_default()).Benefit__Card__Title),
                                                    children: isPreview ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        suppressContentEditableWarning: true,
                                                        dangerouslySetInnerHTML: {
                                                            __html: benefitSection.current.career_benefit_details_attributes[benefit_index].title
                                                        },
                                                        style: headingFontColor
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat(((ref = formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes[benefit_index]) === null || ref === void 0 ? void 0 : ref.display) == "show" ? "" : (customize_career_page_index_module_default()).Benefit__AddDescriptionText),
                                                        contentEditable: true,
                                                        onInput: function(e) {
                                                            formik.setFieldValue("page_sections_attributes.".concat(index, ".career_benefit_section_attributes.career_benefit_details_attributes.").concat(benefit_index, ".display"), "show");
                                                            formik.setFieldValue("page_sections_attributes.".concat(index, ".career_benefit_section_attributes.career_benefit_details_attributes.").concat(benefit_index, ".title"), e.currentTarget.innerHTML);
                                                        },
                                                        onPaste: function(event) {
                                                            customizeCareerAction.onPastePreventStyling(event);
                                                        },
                                                        onFocus: function(e) {
                                                            var placeholder = e.currentTarget.getAttribute("data-placeholder");
                                                            var value = e.currentTarget.innerHTML;
                                                            value === placeholder && (e.currentTarget.innerHTML = "");
                                                        },
                                                        onBlur: function(e) {
                                                            var placeholder = e.currentTarget.getAttribute("data-placeholder");
                                                            var value = e.currentTarget.innerHTML;
                                                            value === "" && (e.currentTarget.innerHTML = placeholder);
                                                            customizeCareerAction.updateAboutSection(formik, index);
                                                        },
                                                        "data-placeholder": t("career:benefit:placeholder:add_title"),
                                                        suppressContentEditableWarning: true,
                                                        dangerouslySetInnerHTML: {
                                                            __html: ((ref1 = benefitSection.current.career_benefit_details_attributes[benefit_index]) === null || ref1 === void 0 ? void 0 : ref1.title) || ""
                                                        },
                                                        style: headingFontColor
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(isPreview ? (customize_career_page_index_module_default()).Benefit__ContentPreview : (customize_career_page_index_module_default()).Benefit__ContentEditable),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((customize_career_page_index_module_default()).Benefit__Card__Text),
                                                    children: isPreview ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        suppressContentEditableWarning: true,
                                                        dangerouslySetInnerHTML: {
                                                            __html: benefitSection.current.career_benefit_details_attributes[benefit_index].description
                                                        },
                                                        style: headingFontColor
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat(((ref2 = formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes[benefit_index]) === null || ref2 === void 0 ? void 0 : ref2.display) == "show" ? "" : (customize_career_page_index_module_default()).Benefit__AddDescriptionText),
                                                        contentEditable: true,
                                                        onInput: function(e) {
                                                            formik.setFieldValue("page_sections_attributes.".concat(index, ".career_benefit_section_attributes.career_benefit_details_attributes.").concat(benefit_index, ".display"), "show");
                                                            formik.setFieldValue("page_sections_attributes.".concat(index, ".career_benefit_section_attributes.career_benefit_details_attributes.").concat(benefit_index, ".description"), e.currentTarget.innerHTML);
                                                        },
                                                        onPaste: function(event) {
                                                            customizeCareerAction.onPastePreventStyling(event);
                                                        },
                                                        onFocus: function(e) {
                                                            var placeholder = e.currentTarget.getAttribute("data-placeholder");
                                                            var value = e.currentTarget.innerHTML;
                                                            value === placeholder && (e.currentTarget.innerHTML = "");
                                                        },
                                                        onBlur: function(e) {
                                                            var placeholder = e.currentTarget.getAttribute("data-placeholder");
                                                            var value = e.currentTarget.innerHTML;
                                                            value === "" && (e.currentTarget.innerHTML = placeholder);
                                                            customizeCareerAction.updateAboutSection(formik, index);
                                                        },
                                                        "data-placeholder": t("career:benefit:placeholder:add_description"),
                                                        suppressContentEditableWarning: true,
                                                        dangerouslySetInnerHTML: {
                                                            __html: (ref3 = benefitSection.current.career_benefit_details_attributes[benefit_index]) === null || ref3 === void 0 ? void 0 : ref3.description
                                                        },
                                                        style: headingFontColor,
                                                        max: 500
                                                    })
                                                })
                                            })
                                        ]
                                    }, "benefit_section_f_".concat(benefit_detail.id || benefit_index));
                                })
                            }),
                            isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((customize_career_page_index_module_default()).Benefit__Preview),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((customize_career_page_index_module_default()).Benefit__Cards, " ").concat(cardLayout(formik, index), " ").concat(benefitCount(formik, index)),
                                    children: formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes.map(function(benefit_detail, benefit_index) {
                                        return benefit_detail.display == "show" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((customize_career_page_index_module_default()).Benefit__Card),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((customize_career_page_index_module_default()).Benefit__Card__Icon),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: benefitDefaultImage(benefit_detail, benefit_index)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((customize_career_page_index_module_default()).Benefit__ContentPreview),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((customize_career_page_index_module_default()).Benefit__Card__Title),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                style: headingFontColor,
                                                                children: (0,html_react_parser/* default */.ZP)(benefit_detail.title)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((customize_career_page_index_module_default()).Benefit__Card__Text),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                style: headingFontColor,
                                                                children: (0,html_react_parser/* default */.ZP)(benefit_detail.description)
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        });
                                    })
                                })
                            })
                        ]
                    }),
                    !isPreview && formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes.length < 6 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((customize_career_page_index_module_default()).MeetTeam__AddNewMember),
                        onClick: function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!!addDisabled) return [
                                                3,
                                                2
                                            ];
                                            setAddDisabled(true);
                                            return [
                                                4,
                                                customizeCareerAction.addBenefitCard(formik, index, setFlagForRender, t)
                                            ];
                                        case 1:
                                            _state.sent();
                                            setAddDisabled(false);
                                            _state.label = 2;
                                        case 2:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(event) {
                                return _ref.apply(this, arguments);
                            };
                        }(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat((customize_career_page_index_module_default()).MeetTeam__AddNewMember__Icon),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(add_plus, {})
                                }),
                                " ",
                                t("career:benefit_details_data:add_value_btn"),
                                " "
                            ]
                        })
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/careers/meet-our-team.js










// Import Swiper React components

// Import Swiper styles



// import required modules

function MeetTeam(param) {
    var formik = param.formik, index = param.index, page_section = param.page_section, customizeCareerAction = param.customizeCareerAction, isPreview = param.isPreview, setSocialPopup = param.setSocialPopup, resetCareerPage = param.resetCareerPage, t = param.t;
    var MeetCountFirstOption = function MeetCountFirstOption(formik, index) {
        var count = formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes.length;
        if (lib/* TabletView */.Du && !lib/* isMobile */.tq) {
            return count <= 2 ? "swiper-center tablet" : "";
        } else if (lib/* isMobile */.tq) {
            return count <= 1 ? "swiper-center mobile" : "";
        } else {
            return count <= 2 ? "swiper-center" : "";
        }
    };
    var MeetCountSecondOption = function MeetCountSecondOption(formik, index) {
        var count = formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes.length;
        if (lib/* TabletView */.Du && !lib/* isMobile */.tq) {
            return count <= 3 ? "swiper-center tablet" : "";
        } else if (lib/* isMobile */.tq) {
            return count <= 1 ? "swiper-center mobile" : "";
        } else {
            return count <= 3 ? "swiper-center" : "";
        }
    };
    var cardLayout = function cardLayout(formik, index) {
        var item_length = formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes.filter(function(x) {
            return isPreview ? x.display == "show" : true;
        }).length;
        if ( true && window.innerWidth >= 768 && window.innerWidth <= 1024) {
            return (customize_career_page_index_module_default()).MeetTeam__FourCardLayout;
        }
        switch(true){
            case item_length < 3:
                return (customize_career_page_index_module_default()).MeetTeam__FourCardLayout;
            case item_length == 3:
                return (customize_career_page_index_module_default()).MeetTeam__ThreeCardLayout;
            case item_length == 4:
                return (customize_career_page_index_module_default()).MeetTeam__FourCardLayout;
            case item_length <= 6:
                return (customize_career_page_index_module_default()).MeetTeam__SixCardLayout;
            default:
                return (customize_career_page_index_module_default()).MeetTeam__SixCardLayout;
        }
    };
    var teamDefaultImage = function teamDefaultImage(record, team_index) {
        if (record.image_url) {
            return record.image_url;
        } else {
            return "/images/pages/career/benefit/dummy-icon.svg";
        // if(team_index > 2 || (record.display == 'hide')) return '/images/pages/career/benefit/dummy-icon.svg'
        // switch(team_index){
        // case 0:
        //   return '/images/pages/career/meet_our_team/member1.jpeg'
        // case 1:
        //   return '/images/pages/career/meet_our_team/member2.jpeg'
        // case 2:
        //   return '/images/pages/career/meet_our_team/member3.jpeg'
        // }
        }
    };
    var teamSection = (0,common/* useRef */.sO)(formik.values.page_sections_attributes[index].career_team_section_attributes);
    var validItemLength = formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes.filter(function(x) {
        return isPreview ? x.display == "show" : true;
    }).length;
    var ref = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(0), 2), flagForRender = ref[0], setFlagForRender = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(0), 2), flagForReRender = ref1[0], setFlagForReRender = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), addDisabled = ref2[0], setAddDisabled = ref2[1];
    (0,common/* useEffect */.d4)(function() {
        teamSection.current.career_team_details_attributes = formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes.filter(function(x) {
            return !x.destroy;
        });
        teamSection.current.title = formik.values.page_sections_attributes[index].career_team_section_attributes.title;
        setFlagForReRender(Math.random() * 10000);
    }, [
        flagForRender,
        resetCareerPage
    ]);
    if (validItemLength == 0 && isPreview) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((customize_career_page_index_module_default()).MeetTeam),
        id: page_section.uniq_reference,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: isPreview ? "".concat((customize_career_page_index_module_default()).MeetTeam__PreviewContainer) : "".concat((customize_career_page_index_module_default()).MeetTeam__Container),
            style: customizeCareerAction.setBackgroundColor(formik, page_section.type),
            children: [
                formik.values.page_sections_attributes[index].career_team_section_attributes.layout == "with_description" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((customize_career_page_index_module_default()).MeetTeam__FirstOption),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((customize_career_page_index_module_default()).MeetTeam__Content),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(isPreview ? (customize_career_page_index_module_default()).MeetTeam__ContentPreview : (customize_career_page_index_module_default()).MeetTeam__ContentEditable),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((customize_career_page_index_module_default()).MeetTeam__SubTitle),
                                    children: isPreview ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        suppressContentEditableWarning: true,
                                        style: customizeCareerAction.setFontColor(formik, page_section.type),
                                        children: (0,html_react_parser/* default */.ZP)(teamSection.current.title)
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        contentEditable: true,
                                        onInput: function(e) {
                                            customizeCareerAction.titleLengthWarning(e.currentTarget.textContent);
                                            formik.setFieldValue("page_sections_attributes.".concat(index, ".career_team_section_attributes.title"), e.currentTarget.innerHTML);
                                        },
                                        onPaste: function(event) {
                                            customizeCareerAction.onPastePreventStyling(event);
                                        },
                                        onBlur: function(e) {
                                            customizeCareerAction.updateAboutSection(formik, index);
                                        },
                                        suppressContentEditableWarning: true,
                                        dangerouslySetInnerHTML: {
                                            __html: teamSection.current.title
                                        },
                                        style: customizeCareerAction.setFontColor(formik, page_section.type)
                                    })
                                })
                            }),
                            !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((customize_career_page_index_module_default()).MeetTeam__Cards, " ").concat(cardLayout(formik, index)),
                                children: formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes.map(function(team_detail, team_index) {
                                    var ref, ref1, ref2, ref3, ref4, ref5;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card, " ").concat((customize_career_page_index_module_default()).MeetTeam__Card__Hover),
                                        children: [
                                            !isPreview && formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes.length > 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Delete),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(black_close, {
                                                    onClick: function() {
                                                        customizeCareerAction.removeTeamCard(formik, index, team_index, setFlagForRender);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Left),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__UserDetails),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Icon),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: teamDefaultImage(team_detail, team_index)
                                                            }),
                                                            !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "".concat((customize_career_page_index_module_default()).MeetTeam__Image__EditIcon),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                        id: "",
                                                                        accept: ".png, .jpg, .jpeg",
                                                                        type: "file",
                                                                        onChange: function(event) {
                                                                            return customizeCareerAction.handleTeamImage(event, formik, index, team_index);
                                                                        },
                                                                        title: customizeCareerAction.imageInfoContent("team_image")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(edit_banner, {})
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Right),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Name),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat(isPreview ? (customize_career_page_index_module_default()).MeetTeam__ContentPreview : (customize_career_page_index_module_default()).MeetTeam__ContentEditable, " ").concat((customize_career_page_index_module_default()).MeetTeam__NoMarginBottom),
                                                            children: isPreview ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                suppressContentEditableWarning: true,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: teamSection.current.career_team_details_attributes[team_index].name
                                                                },
                                                                style: customizeCareerAction.setFontColor(formik, page_section.type)
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat(((ref = formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes[team_index]) === null || ref === void 0 ? void 0 : ref.display) == "show" ? "" : (customize_career_page_index_module_default()).MeetTeam__AddNameText),
                                                                contentEditable: true,
                                                                onInput: function(e) {
                                                                    formik.setFieldValue("page_sections_attributes.".concat(index, ".career_team_section_attributes.career_team_details_attributes.").concat(team_index, ".display"), "show");
                                                                    formik.setFieldValue("page_sections_attributes.".concat(index, ".career_team_section_attributes.career_team_details_attributes.").concat(team_index, ".name"), e.currentTarget.innerHTML);
                                                                },
                                                                onPaste: function(event) {
                                                                    customizeCareerAction.onPastePreventStyling(event);
                                                                },
                                                                onFocus: function(e) {
                                                                    var placeholder = e.currentTarget.getAttribute("data-placeholder");
                                                                    var value = e.currentTarget.innerHTML;
                                                                    value === placeholder && (e.currentTarget.innerHTML = "");
                                                                },
                                                                onBlur: function(e) {
                                                                    var placeholder = e.currentTarget.getAttribute("data-placeholder");
                                                                    var value = e.currentTarget.innerHTML;
                                                                    value === "" && (e.currentTarget.innerHTML = placeholder);
                                                                    customizeCareerAction.updateAboutSection(formik, index);
                                                                },
                                                                "data-placeholder": t("career:meet_our_team:placeholder:add_name"),
                                                                suppressContentEditableWarning: true,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: ((ref1 = teamSection.current.career_team_details_attributes[team_index]) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
                                                                },
                                                                style: customizeCareerAction.setFontColor(formik, page_section.type)
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Designation),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat(isPreview ? (customize_career_page_index_module_default()).MeetTeam__ContentPreview : (customize_career_page_index_module_default()).MeetTeam__ContentEditable, " ").concat((customize_career_page_index_module_default()).MeetTeam__NoMarginBottom),
                                                            children: isPreview ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                suppressContentEditableWarning: true,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: teamSection.current.career_team_details_attributes[team_index].designation
                                                                },
                                                                style: customizeCareerAction.setFontColor(formik, page_section.type)
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat(((ref2 = formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes[team_index]) === null || ref2 === void 0 ? void 0 : ref2.display) == "show" ? "" : (customize_career_page_index_module_default()).MeetTeam__AddDesignationText),
                                                                contentEditable: true,
                                                                onInput: function(e) {
                                                                    formik.setFieldValue("page_sections_attributes.".concat(index, ".career_team_section_attributes.career_team_details_attributes.").concat(team_index, ".display"), "show");
                                                                    formik.setFieldValue("page_sections_attributes.".concat(index, ".career_team_section_attributes.career_team_details_attributes.").concat(team_index, ".designation"), e.currentTarget.innerHTML);
                                                                },
                                                                onPaste: function(event) {
                                                                    customizeCareerAction.onPastePreventStyling(event);
                                                                },
                                                                onFocus: function(e) {
                                                                    var placeholder = e.currentTarget.getAttribute("data-placeholder");
                                                                    var value = e.currentTarget.innerHTML;
                                                                    value === placeholder && (e.currentTarget.innerHTML = "");
                                                                },
                                                                onBlur: function(e) {
                                                                    var placeholder = e.currentTarget.getAttribute("data-placeholder");
                                                                    var value = e.currentTarget.innerHTML;
                                                                    value === "" && (e.currentTarget.innerHTML = placeholder);
                                                                    customizeCareerAction.updateAboutSection(formik, index);
                                                                },
                                                                "data-placeholder": t("career:meet_our_team:placeholder:add_designation"),
                                                                suppressContentEditableWarning: true,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: ((ref3 = teamSection.current.career_team_details_attributes[team_index]) === null || ref3 === void 0 ? void 0 : ref3.designation) || ""
                                                                },
                                                                style: customizeCareerAction.setFontColor(formik, page_section.type)
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Text),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat(isPreview ? (customize_career_page_index_module_default()).MeetTeam__ContentPreview : (customize_career_page_index_module_default()).MeetTeam__ContentEditable, " ").concat((customize_career_page_index_module_default()).MeetTeam__NoMarginBottom),
                                                            children: isPreview ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                suppressContentEditableWarning: true,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: teamSection.current.career_team_details_attributes[team_index].description || ""
                                                                },
                                                                style: customizeCareerAction.setFontColor(formik, page_section.type)
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat(((ref4 = formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes[team_index]) === null || ref4 === void 0 ? void 0 : ref4.display) == "show" ? "" : (customize_career_page_index_module_default()).MeetTeam__AddDescriptionText),
                                                                contentEditable: true,
                                                                onInput: function(e) {
                                                                    formik.setFieldValue("page_sections_attributes.".concat(index, ".career_team_section_attributes.career_team_details_attributes.").concat(team_index, ".display"), "show");
                                                                    formik.setFieldValue("page_sections_attributes.".concat(index, ".career_team_section_attributes.career_team_details_attributes.").concat(team_index, ".description"), e.currentTarget.innerHTML);
                                                                },
                                                                onFocus: function(e) {
                                                                    var placeholder = e.currentTarget.getAttribute("data-placeholder");
                                                                    var value = e.currentTarget.innerHTML;
                                                                    value === placeholder && (e.currentTarget.innerHTML = "");
                                                                },
                                                                onPaste: function(event) {
                                                                    customizeCareerAction.onPastePreventStyling(event);
                                                                },
                                                                onBlur: function(e) {
                                                                    var placeholder = e.currentTarget.getAttribute("data-placeholder");
                                                                    var value = e.currentTarget.innerHTML;
                                                                    value === "" && (e.currentTarget.innerHTML = placeholder);
                                                                    customizeCareerAction.updateAboutSection(formik, index);
                                                                },
                                                                "data-placeholder": t("career:meet_our_team:placeholder:add_description"),
                                                                suppressContentEditableWarning: true,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: ((ref5 = teamSection.current.career_team_details_attributes[team_index]) === null || ref5 === void 0 ? void 0 : ref5.description) || ""
                                                                },
                                                                style: customizeCareerAction.setFontColor(formik, page_section.type),
                                                                max: 500
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, "team_section_f_".concat(team_detail.id || team_index));
                                })
                            }),
                            isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((customize_career_page_index_module_default()).MeetTeam__Preview),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((customize_career_page_index_module_default()).MeetTeam__Cards, " ").concat(cardLayout(formik, index), " ").concat(MeetCountFirstOption(formik, index)),
                                    children: formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes.map(function(team_detail, team_index) {
                                        return team_detail.display == "show" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Left),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__UserDetails),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Icon),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: teamDefaultImage(team_detail, team_index)
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Right),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat((customize_career_page_index_module_default()).MeetTeam__ContentPreview),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Name),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    style: customizeCareerAction.setFontColor(formik, page_section.type),
                                                                    children: (0,html_react_parser/* default */.ZP)(team_detail.name)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Designation),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    style: customizeCareerAction.setFontColor(formik, page_section.type),
                                                                    children: (0,html_react_parser/* default */.ZP)(team_detail.designation)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Text),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    style: customizeCareerAction.setFontColor(formik, page_section.type),
                                                                    children: (0,html_react_parser/* default */.ZP)(team_detail.description)
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        });
                                    })
                                })
                            }),
                            !isPreview && formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes.length < 6 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((customize_career_page_index_module_default()).MeetTeam__AddNewMember),
                                onClick: function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!!addDisabled) return [
                                                        3,
                                                        2
                                                    ];
                                                    setAddDisabled(true);
                                                    return [
                                                        4,
                                                        customizeCareerAction.addTeamCard(formik, index, setFlagForRender, t)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    setAddDisabled(false);
                                                    _state.label = 2;
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(event) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "".concat((customize_career_page_index_module_default()).MeetTeam__AddNewMember__Icon),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(add_plus, {})
                                        }),
                                        " ",
                                        t("career:meet_our_team:add_new_team_member"),
                                        " "
                                    ]
                                })
                            })
                        ]
                    })
                }),
                formik.values.page_sections_attributes[index].career_team_section_attributes.layout == "without_description" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((customize_career_page_index_module_default()).MeetTeam__SecondOption),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((customize_career_page_index_module_default()).MeetTeam__Content),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(isPreview ? (customize_career_page_index_module_default()).MeetTeam__ContentPreview : (customize_career_page_index_module_default()).MeetTeam__ContentEditable),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((customize_career_page_index_module_default()).MeetTeam__SubTitle),
                                    children: isPreview ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        suppressContentEditableWarning: true,
                                        dangerouslySetInnerHTML: {
                                            __html: teamSection.current.title
                                        },
                                        style: customizeCareerAction.setFontColor(formik, page_section.type)
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        contentEditable: true,
                                        onInput: function(e) {
                                            customizeCareerAction.titleLengthWarning(e.currentTarget.textContent);
                                            formik.setFieldValue("page_sections_attributes.".concat(index, ".career_team_section_attributes.title"), e.currentTarget.innerHTML);
                                        },
                                        onPaste: function(event) {
                                            customizeCareerAction.onPastePreventStyling(event);
                                        },
                                        onBlur: function(e) {
                                            customizeCareerAction.updateAboutSection(formik, index);
                                        },
                                        suppressContentEditableWarning: true,
                                        dangerouslySetInnerHTML: {
                                            __html: teamSection.current.title
                                        },
                                        style: customizeCareerAction.setFontColor(formik, page_section.type)
                                    })
                                })
                            })
                        }),
                        !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((customize_career_page_index_module_default()).MeetTeam__Cards, " ").concat(cardLayout(formik, index)),
                            children: formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes.map(function(team_detail, team_index) {
                                var ref, ref1, ref2, ref3;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card, " ").concat((customize_career_page_index_module_default()).MeetTeam__Card__Hover, " ").concat((customize_career_page_index_module_default()).MeetTeam__SecondOption__Card),
                                    children: [
                                        !isPreview && formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes.length > 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Delete),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(black_close, {
                                                onClick: function() {
                                                    customizeCareerAction.removeTeamCard(formik, index, team_index, setFlagForRender);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Center),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__UserDetails),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Icon, " ").concat((customize_career_page_index_module_default()).MeetTeam__Card__Icon240),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: teamDefaultImage(team_detail, team_index)
                                                            }),
                                                            !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "".concat((customize_career_page_index_module_default()).MeetTeam__Image__EditIcon),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                        id: "",
                                                                        accept: ".png, .jpg, .jpeg",
                                                                        type: "file",
                                                                        onChange: function(event) {
                                                                            return customizeCareerAction.handleTeamImage(event, formik, index, team_index);
                                                                        },
                                                                        title: customizeCareerAction.imageInfoContent("team_image")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(edit_banner, {})
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__NameCenter, " ").concat(isPreview ? (customize_career_page_index_module_default()).MeetTeam__ContentPreview : (customize_career_page_index_module_default()).MeetTeam__ContentEditable, " ").concat((customize_career_page_index_module_default()).MeetTeam__MarginBottom4),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Name, " ").concat((customize_career_page_index_module_default()).MeetTeam__TextCenter, " "),
                                                            children: isPreview ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                suppressContentEditableWarning: true,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: teamSection.current.career_team_details_attributes[team_index].name
                                                                },
                                                                style: customizeCareerAction.setFontColor(formik, page_section.type)
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat(((ref = formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes[team_index]) === null || ref === void 0 ? void 0 : ref.display) == "show" ? "" : (customize_career_page_index_module_default()).MeetTeam__AddNameText),
                                                                contentEditable: true,
                                                                onInput: function(e) {
                                                                    formik.setFieldValue("page_sections_attributes.".concat(index, ".career_team_section_attributes.career_team_details_attributes.").concat(team_index, ".display"), "show");
                                                                    formik.setFieldValue("page_sections_attributes.".concat(index, ".career_team_section_attributes.career_team_details_attributes.").concat(team_index, ".name"), e.currentTarget.innerHTML);
                                                                },
                                                                onPaste: function(event) {
                                                                    customizeCareerAction.onPastePreventStyling(event);
                                                                },
                                                                onFocus: function(e) {
                                                                    var placeholder = e.currentTarget.getAttribute("data-placeholder");
                                                                    var value = e.currentTarget.innerHTML;
                                                                    value === placeholder && (e.currentTarget.innerHTML = "");
                                                                },
                                                                onBlur: function(e) {
                                                                    var placeholder = e.currentTarget.getAttribute("data-placeholder");
                                                                    var value = e.currentTarget.innerHTML;
                                                                    value === "" && (e.currentTarget.innerHTML = placeholder);
                                                                    customizeCareerAction.updateAboutSection(formik, index);
                                                                },
                                                                "data-placeholder": "Add name",
                                                                suppressContentEditableWarning: true,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: ((ref1 = teamSection.current.career_team_details_attributes[team_index]) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
                                                                },
                                                                style: customizeCareerAction.setFontColor(formik, page_section.type)
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat(isPreview ? (customize_career_page_index_module_default()).MeetTeam__ContentPreview : (customize_career_page_index_module_default()).MeetTeam__ContentEditable, " ").concat((customize_career_page_index_module_default()).MeetTeam__NoMarginBottom),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Designation),
                                                            children: isPreview ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                suppressContentEditableWarning: true,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: teamSection.current.career_team_details_attributes[team_index].designation
                                                                },
                                                                style: customizeCareerAction.setFontColor(formik, page_section.type)
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat(((ref2 = formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes[team_index]) === null || ref2 === void 0 ? void 0 : ref2.display) == "show" ? "" : (customize_career_page_index_module_default()).MeetTeam__AddDesignationText),
                                                                contentEditable: true,
                                                                onInput: function(e) {
                                                                    formik.setFieldValue("page_sections_attributes.".concat(index, ".career_team_section_attributes.career_team_details_attributes.").concat(team_index, ".display"), "show");
                                                                    formik.setFieldValue("page_sections_attributes.".concat(index, ".career_team_section_attributes.career_team_details_attributes.").concat(team_index, ".designation"), e.currentTarget.innerHTML);
                                                                },
                                                                onPaste: function(event) {
                                                                    customizeCareerAction.onPastePreventStyling(event);
                                                                },
                                                                onFocus: function(e) {
                                                                    var placeholder = e.currentTarget.getAttribute("data-placeholder");
                                                                    var value = e.currentTarget.innerHTML;
                                                                    value === placeholder && (e.currentTarget.innerHTML = "");
                                                                },
                                                                onBlur: function(e) {
                                                                    var placeholder = e.currentTarget.getAttribute("data-placeholder");
                                                                    var value = e.currentTarget.innerHTML;
                                                                    value === "" && (e.currentTarget.innerHTML = placeholder);
                                                                    customizeCareerAction.updateAboutSection(formik, index);
                                                                },
                                                                "data-placeholder": "Add designation",
                                                                suppressContentEditableWarning: true,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: ((ref3 = teamSection.current.career_team_details_attributes[team_index]) === null || ref3 === void 0 ? void 0 : ref3.designation) || ""
                                                                },
                                                                style: customizeCareerAction.setFontColor(formik, page_section.type)
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, "team_section_s_".concat(team_detail.id || team_index));
                            })
                        }),
                        isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((customize_career_page_index_module_default()).MeetTeam__Preview),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((customize_career_page_index_module_default()).MeetTeam__Cards, " ").concat(cardLayout(formik, index), " ").concat(MeetCountSecondOption(formik, index)),
                                children: formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes.map(function(team_detail, team_index) {
                                    return team_detail.display == "show" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card, " ").concat((customize_career_page_index_module_default()).MeetTeam__SecondOption__Card),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Center),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__UserDetails),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Icon, " ").concat((customize_career_page_index_module_default()).MeetTeam__Card__Icon240),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: teamDefaultImage(team_detail, team_index)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat(isPreview ? (customize_career_page_index_module_default()).MeetTeam__ContentPreview : (customize_career_page_index_module_default()).MeetTeam__ContentEditable, " ").concat((customize_career_page_index_module_default()).MeetTeam__NoMarginBottom),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Name, " ").concat((customize_career_page_index_module_default()).MeetTeam__Card__NameCenter),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    style: customizeCareerAction.setFontColor(formik, page_section.type),
                                                                    children: (0,html_react_parser/* default */.ZP)(team_detail.name)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat((customize_career_page_index_module_default()).MeetTeam__Card__Designation, " ").concat((customize_career_page_index_module_default()).MeetTeam__Card__Designation__NoMargin, " ").concat((customize_career_page_index_module_default()).MeetTeam__Card__Designation__Center),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    style: customizeCareerAction.setFontColor(formik, page_section.type),
                                                                    children: (0,html_react_parser/* default */.ZP)(team_detail.designation)
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    });
                                })
                            })
                        }),
                        !isPreview && formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes.length < 6 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((customize_career_page_index_module_default()).MeetTeam__AddNewMember),
                            onClick: function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!!addDisabled) return [
                                                    3,
                                                    2
                                                ];
                                                setAddDisabled(true);
                                                return [
                                                    4,
                                                    customizeCareerAction.addTeamCard(formik, index, setFlagForRender, t)
                                                ];
                                            case 1:
                                                _state.sent();
                                                setAddDisabled(false);
                                                _state.label = 2;
                                            case 2:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(event) {
                                    return _ref.apply(this, arguments);
                                };
                            }(),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "".concat((customize_career_page_index_module_default()).MeetTeam__AddNewMember__Icon),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(add_plus, {})
                                    }),
                                    " ",
                                    t("career:meet_our_team:add_new_team_member"),
                                    " "
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/imports-files/components/model/select-job-modal.js + 3 modules
var select_job_modal = __webpack_require__(28801);
// EXTERNAL MODULE: ./src/components/common-modal/modal.js + 2 modules
var modal = __webpack_require__(99005);
// EXTERNAL MODULE: ./src/imports-files/components/common-modal/common-modal.js + 2 modules
var common_modal = __webpack_require__(66172);
;// CONCATENATED MODULE: ./src/components/careers/button-customization-modal.js







function ButtonCustomizationModal(param) {
    var formRef = param.formRef, buttonPopup = param.buttonPopup, setButtonPopup = param.setButtonPopup, customizeCareerAction = param.customizeCareerAction;
    var t = (0,select_job_modal/* useTranslation */.$G)().t;
    var formik = buttonPopup.formik;
    var ref = (0,src_sliced_to_array/* default */.Z)((0,select_job_modal/* useState */.eJ)(formRef.current.values.hero_section_attributes.button_hash.buttons[buttonPopup.button_index].link), 2), link = ref[0], setLink = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,select_job_modal/* useState */.eJ)(formRef.current.values.hero_section_attributes.button_hash.buttons[buttonPopup.button_index].is_link), 2), isLink = ref1[0], setIsLink = ref1[1];
    return buttonPopup.state ? /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        type: "form",
        heading: t("modal:form:add_link:heading"),
        closeModal: function() {
            setButtonPopup({
                state: false
            });
        },
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(select_job_modal/* ModalStyle.SetupPopup__ModalContent */.Wy.SetupPopup__ModalContent),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(select_job_modal/* PageStyle.SelectJob__DisplayFlex */.k2.SelectJob__DisplayFlex, " ").concat(select_job_modal/* ModalStyle.ButtonCustomization__RadioButtons */.Wy.ButtonCustomization__RadioButtons, " p0 mt30"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                className: "Dpflex WrapperRadioContainer mb0 mr15",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "radio",
                                        name: "hero_section_attributes.button_hash.buttons.".concat(buttonPopup.button_index, ".is_link"),
                                        value: "link",
                                        defaultChecked: isLink == "link",
                                        onChange: function() {
                                            var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                    setIsLink(event.target.value);
                                                    setLink("");
                                                    return [
                                                        2
                                                    ];
                                                });
                                            });
                                            return function(event) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }()
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "WrapperRadiocheckmark ml0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "ml0 WrapperRadioSpan pl10",
                                        children: [
                                            " ",
                                            t("modal:form:add_link:website_link")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                className: "Dpflex WrapperRadioContainer mb0 ml15",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "radio",
                                        name: "hero_section_attributes.button_hash.buttons.".concat(buttonPopup.button_index, ".is_link"),
                                        value: "section",
                                        defaultChecked: isLink == "section",
                                        onChange: function(event) {
                                            setIsLink(event.target.value);
                                            setLink("");
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "WrapperRadiocheckmark ml0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "ml0 WrapperRadioSpan pl10",
                                        children: [
                                            " ",
                                            t("modal:form:add_link:section")
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(select_job_modal/* PageStyle.SelectJob__Content */.k2.SelectJob__Content, " mt20 p0"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            children: isLink == "link" ? t("modal:form:add_link:website_link") : t("modal:form:add_link:section")
                        })
                    }),
                    isLink == "link" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt15",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(select_job_modal/* PageStyle.SelectJob__CustomSelectWidth */.k2.SelectJob__CustomSelectWidth, " ").concat(select_job_modal/* ModalStyle.ButtonCustomization__CustomSelectWidth */.Wy.ButtonCustomization__CustomSelectWidth),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "".concat(select_job_modal/* PageStyle.Form__Input */.k2.Form__Input, " thresholdmodl"),
                                type: "text",
                                value: link,
                                defaultValue: "",
                                onChange: function(event) {
                                    setLink(event.target.value);
                                }
                            })
                        })
                    }),
                    isLink == "section" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt15",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: select_job_modal/* PageStyle.SelectJob__CustomSelectWidth */.k2.SelectJob__CustomSelectWidth,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* FormikControl */.gt, {
                                control: "select",
                                name: "hero_section_attributes.button_hash.buttons.".concat(buttonPopup.button_index, ".link"),
                                className: "".concat(select_job_modal/* PageStyle.CustomSelect */.k2.CustomSelect),
                                options: buttonPopup.sections_list,
                                onChange: function(option) {
                                    setLink(option.value);
                                },
                                default: link
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(select_job_modal/* PageStyle.SelectJob__Footer */.k2.SelectJob__Footer, " ").concat(select_job_modal/* ModalStyle.ButtonCustomization__Footer */.Wy.ButtonCustomization__Footer, " ").concat(common_modal/* FormModalStyle.Modal__Container__ButtonSection */.w2.Modal__Container__ButtonSection),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(select_job_modal/* PageStyle.SelectJob__ButtonAction */.k2.SelectJob__ButtonAction, " ").concat(select_job_modal/* ModalStyle.ButtonCustomization__Footer__ButtonAction */.Wy.ButtonCustomization__Footer__ButtonAction, " mt0 mb0"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* Button */.zx, {
                                buttonstyle: "".concat(select_job_modal/* PageStyle.primarybtn */.k2.primarybtn, " ").concat(select_job_modal/* ModalStyle.primarybtn */.Wy.primarybtn),
                                type: "button",
                                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                    var _tmp;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    buttonPopup.formik.setFieldValue("hero_section_attributes.button_hash.buttons.".concat(buttonPopup.button_index, ".link"), link)
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    4,
                                                    buttonPopup.formik.setFieldValue("hero_section_attributes.button_hash.buttons.".concat(buttonPopup.button_index, ".is_link"), isLink)
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    4,
                                                    customizeCareerAction.updateHeroSection()
                                                ];
                                            case 3:
                                                setTimeout.apply(void 0, [
                                                    _state.sent(),
                                                    100
                                                ]);
                                                _tmp = {};
                                                setButtonPopup((_tmp.state = false, _tmp));
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                children: t("button:save")
                            })
                        })
                    })
                ]
            })
        })
    }) : "";
}

;// CONCATENATED MODULE: ./src/components/careers/social-link-modal.js





function SocialLinkModal(param) {
    var formRef = param.formRef, socialPopup = param.socialPopup, setSocialPopup = param.setSocialPopup, customizeCareerAction = param.customizeCareerAction;
    var formik = socialPopup.formik;
    var ref = (0,src_sliced_to_array/* default */.Z)((0,select_job_modal/* useState */.eJ)(formRef.current.values.page_sections_attributes[socialPopup.index].career_team_section_attributes.career_team_details_attributes[socialPopup.team_index].facebook_url), 2), facebookLink = ref[0], setFacebookLink = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,select_job_modal/* useState */.eJ)(formRef.current.values.page_sections_attributes[socialPopup.index].career_team_section_attributes.career_team_details_attributes[socialPopup.team_index].twitter_url), 2), twitterLink = ref1[0], setTwitterLink = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)((0,select_job_modal/* useState */.eJ)(formRef.current.values.page_sections_attributes[socialPopup.index].career_team_section_attributes.career_team_details_attributes[socialPopup.team_index].linkedin_url), 2), linkedinLink = ref2[0], setLinkedinLink = ref2[1];
    return socialPopup.state ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(select_job_modal/* PageStyle.SetupPopup */.k2.SetupPopup, " ").concat(select_job_modal/* PageStyle.SelectJob */.k2.SelectJob, " ").concat(select_job_modal/* ModalStyle.SelectJob */.Wy.SelectJob),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(select_job_modal/* PageStyle.SetupPopup__inner */.k2.SetupPopup__inner, " ").concat(select_job_modal/* ModalStyle.SetupPopup__ModalCenter */.Wy.SetupPopup__ModalCenter),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat(select_job_modal/* ModalStyle.SetupPopup__ModalContent */.Wy.SetupPopup__ModalContent),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(select_job_modal/* PageStyle.OtpBacksection */.k2.OtpBacksection, " ").concat(select_job_modal/* ModalStyle.OtpBacksection */.Wy.OtpBacksection),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(select_job_modal/* PageStyle.Otpback */.k2.Otpback, " ").concat(select_job_modal/* ModalStyle.Otpback */.Wy.Otpback),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* Button */.zx, {
                                    buttonstyle: select_job_modal/* ButtonStyle.nobgbutton */.ZJ.nobgbutton,
                                    type: "button",
                                    onClick: function() {
                                        return setSocialPopup({
                                            state: false
                                        });
                                    },
                                    children: "Close"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "PhoneSetupPage SetupPage ".concat(select_job_modal/* PageStyle.SetupPopup__Content */.k2.SetupPopup__Content, " ").concat(select_job_modal/* ModalStyle.SetupPopup__Content */.Wy.SetupPopup__Content, " DisplayInline ").concat(select_job_modal/* PageStyle.mt15 */.k2.mt15),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: "Add social link"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(select_job_modal/* PageStyle.SelectJob__Content */.k2.SelectJob__Content, " ").concat(select_job_modal/* ModalStyle.SelectJob__Content */.Wy.SelectJob__Content),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                children: "Facebook Link"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(select_job_modal/* PageStyle.SelectJob__Content */.k2.SelectJob__Content, " ").concat(select_job_modal/* ModalStyle.SelectJob__Content */.Wy.SelectJob__Content),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: select_job_modal/* PageStyle.SelectJob__CustomSelectWidth */.k2.SelectJob__CustomSelectWidth,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    className: "".concat(select_job_modal/* PageStyle.Form__Input */.k2.Form__Input, " thresholdmodl"),
                                    type: "text",
                                    value: facebookLink,
                                    defaultValue: "",
                                    onChange: function(event) {
                                        setFacebookLink(event.target.value);
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(select_job_modal/* PageStyle.SelectJob__Content */.k2.SelectJob__Content, " ").concat(select_job_modal/* ModalStyle.SelectJob__Content */.Wy.SelectJob__Content),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                children: "Twitter Link"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(select_job_modal/* PageStyle.SelectJob__Content */.k2.SelectJob__Content, " ").concat(select_job_modal/* ModalStyle.SelectJob__Content */.Wy.SelectJob__Content),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: select_job_modal/* PageStyle.SelectJob__CustomSelectWidth */.k2.SelectJob__CustomSelectWidth,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    className: "".concat(select_job_modal/* PageStyle.Form__Input */.k2.Form__Input, " thresholdmodl"),
                                    type: "text",
                                    value: twitterLink,
                                    defaultValue: "",
                                    onChange: function(event) {
                                        setTwitterLink(event.target.value);
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(select_job_modal/* PageStyle.SelectJob__Content */.k2.SelectJob__Content, " ").concat(select_job_modal/* ModalStyle.SelectJob__Content */.Wy.SelectJob__Content),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                children: "Linkedin Link"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(select_job_modal/* PageStyle.SelectJob__Content */.k2.SelectJob__Content, " ").concat(select_job_modal/* ModalStyle.SelectJob__Content */.Wy.SelectJob__Content),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: select_job_modal/* PageStyle.SelectJob__CustomSelectWidth */.k2.SelectJob__CustomSelectWidth,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    className: "".concat(select_job_modal/* PageStyle.Form__Input */.k2.Form__Input, " thresholdmodl"),
                                    type: "text",
                                    value: linkedinLink,
                                    defaultValue: "",
                                    onChange: function(event) {
                                        setLinkedinLink(event.target.value);
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(select_job_modal/* PageStyle.SelectJob__Footer */.k2.SelectJob__Footer, " ").concat(select_job_modal/* ModalStyle.SelectJob__Footer */.Wy.SelectJob__Footer),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(select_job_modal/* PageStyle.SelectJob__ButtonAction */.k2.SelectJob__ButtonAction, " ").concat(select_job_modal/* ModalStyle.SelectJob__ButtonAction */.Wy.SelectJob__ButtonAction),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* Button */.zx, {
                                    buttonstyle: select_job_modal/* PageStyle.primarybtn */.k2.primarybtn,
                                    type: "button",
                                    onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                        var _tmp;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        formRef.current.setFieldValue("page_sections_attributes.".concat(socialPopup.index, ".career_team_section_attributes.career_team_details_attributes.").concat(socialPopup.team_index, ".facebook_url"), facebookLink)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        4,
                                                        formRef.current.setFieldValue("page_sections_attributes.".concat(socialPopup.index, ".career_team_section_attributes.career_team_details_attributes.").concat(socialPopup.team_index, ".twitter_url"), twitterLink)
                                                    ];
                                                case 2:
                                                    _state.sent();
                                                    return [
                                                        4,
                                                        formRef.current.setFieldValue("page_sections_attributes.".concat(socialPopup.index, ".career_team_section_attributes.career_team_details_attributes.").concat(socialPopup.team_index, ".linkedin_url"), linkedinLink)
                                                    ];
                                                case 3:
                                                    _state.sent();
                                                    return [
                                                        4,
                                                        customizeCareerAction.updateAboutRef(socialPopup.index)
                                                    ];
                                                case 4:
                                                    setTimeout.apply(void 0, [
                                                        _state.sent(),
                                                        100
                                                    ]);
                                                    _tmp = {};
                                                    setSocialPopup((_tmp.state = false, _tmp));
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }),
                                    children: "Save"
                                })
                            })
                        })
                    ]
                })
            })
        })
    }) : "";
}

// EXTERNAL MODULE: ./src/styles/components/careers/navigation-section/_index.module.scss
var navigation_section_index_module = __webpack_require__(63417);
var navigation_section_index_module_default = /*#__PURE__*/__webpack_require__.n(navigation_section_index_module);
;// CONCATENATED MODULE: ./src/components/careers/navigation-section/header-links.js







function HeaderLinks(param) {
    var formik = param.formik, sidebar_section = param.sidebar_section, customizeCareerAction = param.customizeCareerAction;
    var ref = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), headerDisabled = ref[0], setHeaderDisabled = ref[1];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((navigation_section_index_module_default()).HeaderLinks),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "".concat((navigation_section_index_module_default()).HeaderLinks__Title),
                children: t("career:nav_links:header")
            }),
            formik.values.career_navigation_links_attributes.map(function(navigation, link_index) {
                return navigation.navigation_type == LINK_TYPES.header && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((navigation_section_index_module_default()).HeaderLinks__Fields),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((navigation_section_index_module_default()).HeaderLinks__Fields__LeftContent),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((navigation_section_index_module_default()).HeaderLinks__Fields__Label),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: t("career:nav_links:link_name")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((navigation_section_index_module_default()).HeaderLinks__Fields__Input),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                        control: "input",
                                        type: "text",
                                        placeholder: t("career:nav_links:link_name"),
                                        name: "career_navigation_links_attributes.".concat(link_index, ".name"),
                                        className: (navigation_section_index_module_default()).HeaderLinks__Input,
                                        formik: formik,
                                        onBlur: function() {
                                            customizeCareerAction.updateNavigationLink(formik, link_index);
                                        }
                                    })
                                })
                            ]
                        }, "header_link_".concat(link_index)),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((navigation_section_index_module_default()).HeaderLinks__Fields__RightContent),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((navigation_section_index_module_default()).HeaderLinks__Fields__Label),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: t("career:nav_links:link_url")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((navigation_section_index_module_default()).HeaderLinks__Fields__Input),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                        control: "input",
                                        type: "text",
                                        placeholder: t("career:nav_links:enter_url"),
                                        name: "career_navigation_links_attributes.".concat(link_index, ".url"),
                                        className: (navigation_section_index_module_default()).HeaderLinks__Input,
                                        formik: formik,
                                        onBlur: function() {
                                            customizeCareerAction.updateNavigationLink(formik, link_index);
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((navigation_section_index_module_default()).HeaderLinks__Fields__Remove_Fields),
                            children: formik.values.career_navigation_links_attributes.filter(function(x) {
                                return x.navigation_type == LINK_TYPES.header;
                            }).length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                onClick: function() {
                                    customizeCareerAction.removeHFLinks(formik, LINK_TYPES.header, link_index);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/icons/career_icons/closebtn.svg"
                                })
                            })
                        })
                    ]
                }, "header_links_".concat(link_index));
            }),
            customizeCareerAction.showAddButton(formik, LINK_TYPES.header) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((navigation_section_index_module_default()).HeaderLinks__Add_More_Link),
                onClick: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!!headerDisabled) return [
                                        3,
                                        2
                                    ];
                                    setHeaderDisabled(true);
                                    return [
                                        4,
                                        customizeCareerAction.addHFLinks(formik, LINK_TYPES.header)
                                    ];
                                case 1:
                                    _state.sent();
                                    setHeaderDisabled(false);
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(event) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "".concat((navigation_section_index_module_default()).HeaderLinks__Add_More_Link__Icon),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/icons/career_icons/plus.svg"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "".concat((navigation_section_index_module_default()).HeaderLinks__Add_More_Link__Text),
                        children: t("career:nav_links:add_more_links")
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/careers/navigation-section/footer-links.js






function FooterLinks(param) {
    var formik = param.formik, sidebar_section = param.sidebar_section, customizeCareerAction = param.customizeCareerAction;
    var t = (0,common/* useTranslation */.$G)().t;
    var ref = (0,src_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), footerDisabled = ref[0], setFooterDisabled = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((navigation_section_index_module_default()).FooterLinks),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "".concat((navigation_section_index_module_default()).FooterLinks__Title),
                children: t("career:nav_links:footer")
            }),
            formik.values.career_navigation_links_attributes.map(function(navigation, link_index) {
                return navigation.navigation_type == LINK_TYPES.footer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((navigation_section_index_module_default()).FooterLinks__Fields),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((navigation_section_index_module_default()).FooterLinks__Fields__LeftContent),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((navigation_section_index_module_default()).FooterLinks__Fields__Label),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: t("career:nav_links:link_name")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((navigation_section_index_module_default()).FooterLinks__Fields__Input),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                        control: "input",
                                        type: "text",
                                        placeholder: t("career:nav_links:link_name"),
                                        name: "career_navigation_links_attributes.".concat(link_index, ".name"),
                                        className: (navigation_section_index_module_default()).FooterLinks__Input,
                                        formik: formik,
                                        onBlur: function() {
                                            customizeCareerAction.updateNavigationLink(formik, link_index);
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((navigation_section_index_module_default()).FooterLinks__Fields__RightContent),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((navigation_section_index_module_default()).FooterLinks__Fields__Label),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: t("career:nav_links:link_url")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((navigation_section_index_module_default()).FooterLinks__Fields__Input),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                        control: "input",
                                        type: "text",
                                        placeholder: t("career:nav_links:enter_url"),
                                        name: "career_navigation_links_attributes.".concat(link_index, ".url"),
                                        className: (navigation_section_index_module_default()).FooterLinks__Input,
                                        formik: formik,
                                        onBlur: function() {
                                            customizeCareerAction.updateNavigationLink(formik, link_index);
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((navigation_section_index_module_default()).FooterLinks__Fields__Remove_Fields),
                            children: formik.values.career_navigation_links_attributes.filter(function(x) {
                                return x.navigation_type == LINK_TYPES.footer;
                            }).length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                onClick: function() {
                                    customizeCareerAction.removeHFLinks(formik, LINK_TYPES.footer, link_index);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/icons/career_icons/closebtn.svg"
                                })
                            })
                        })
                    ]
                }, "footer_link_".concat(link_index));
            }),
            customizeCareerAction.showAddButton(formik, LINK_TYPES.footer) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((navigation_section_index_module_default()).FooterLinks__Add_More_Link),
                onClick: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!!footerDisabled) return [
                                        3,
                                        2
                                    ];
                                    setFooterDisabled(true);
                                    return [
                                        4,
                                        customizeCareerAction.addHFLinks(formik, LINK_TYPES.footer)
                                    ];
                                case 1:
                                    _state.sent();
                                    setFooterDisabled(false);
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(event) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "".concat((navigation_section_index_module_default()).FooterLinks__Add_More_Link__Icon),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/icons/career_icons/plus.svg"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "".concat((navigation_section_index_module_default()).FooterLinks__Add_More_Link__Text),
                        children: t("career:nav_links:add_more_links")
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/careers/navigation-section/social-links.js



function SocialLinks(param) {
    var formik = param.formik, sidebar_section = param.sidebar_section, customizeCareerAction = param.customizeCareerAction;
    var t = (0,common/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((navigation_section_index_module_default()).SocialLinks),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "".concat((navigation_section_index_module_default()).SocialLinks__Title),
                children: t("career:nav_links:social")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((navigation_section_index_module_default()).SocialLinks__Fields),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((navigation_section_index_module_default()).SocialLinks__Fields__LeftContent),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((navigation_section_index_module_default()).SocialLinks__Fields__Label),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    children: t("career:nav_links:x")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((navigation_section_index_module_default()).SocialLinks__Fields__Input),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                    control: "input",
                                    type: "text",
                                    placeholder: t("career:nav_links:enter_url"),
                                    name: "career_social_link_attributes.twitter_url",
                                    className: (navigation_section_index_module_default()).SocialLinks__Input,
                                    formik: formik,
                                    onBlur: function(event) {
                                        return customizeCareerAction.updateSocialLink(event, formik);
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((navigation_section_index_module_default()).SocialLinks__Fields__RightContent),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((navigation_section_index_module_default()).SocialLinks__Fields__Label),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    children: t("career:nav_links:facebook")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((navigation_section_index_module_default()).SocialLinks__Fields__Input),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                    control: "input",
                                    type: "text",
                                    placeholder: t("career:nav_links:enter_url"),
                                    name: "career_social_link_attributes.facebook_url",
                                    className: (navigation_section_index_module_default()).SocialLinks__Input,
                                    formik: formik,
                                    onBlur: function(event) {
                                        return customizeCareerAction.updateSocialLink(event, formik);
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((navigation_section_index_module_default()).SocialLinks__Fields),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((navigation_section_index_module_default()).SocialLinks__Fields__LeftContent),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((navigation_section_index_module_default()).SocialLinks__Fields__Label),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    children: t("career:nav_links:linkedIn")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((navigation_section_index_module_default()).SocialLinks__Fields__Input),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                    control: "input",
                                    type: "text",
                                    placeholder: t("career:nav_links:enter_url"),
                                    name: "career_social_link_attributes.linkedin_url",
                                    className: (navigation_section_index_module_default()).SocialLinks__Input,
                                    formik: formik,
                                    onBlur: function(event) {
                                        return customizeCareerAction.updateSocialLink(event, formik);
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((navigation_section_index_module_default()).SocialLinks__Fields__RightContent),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((navigation_section_index_module_default()).SocialLinks__Fields__Label),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    children: t("career:nav_links:instagram")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((navigation_section_index_module_default()).SocialLinks__Fields__Input),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                    control: "input",
                                    type: "text",
                                    placeholder: t("career:nav_links:enter_url"),
                                    name: "career_social_link_attributes.instagram_url",
                                    className: (navigation_section_index_module_default()).SocialLinks__Input,
                                    formik: formik,
                                    onBlur: function(event) {
                                        return customizeCareerAction.updateSocialLink(event, formik);
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((navigation_section_index_module_default()).SocialLinks__Fields),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((navigation_section_index_module_default()).SocialLinks__Fields__LeftContent),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((navigation_section_index_module_default()).SocialLinks__Fields__Label),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    children: t("career:nav_links:youtube")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((navigation_section_index_module_default()).SocialLinks__Fields__Input),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                    control: "input",
                                    type: "text",
                                    placeholder: t("career:nav_links:enter_url"),
                                    name: "career_social_link_attributes.youtube_url",
                                    className: (navigation_section_index_module_default()).SocialLinks__Input,
                                    formik: formik,
                                    onBlur: function(event) {
                                        return customizeCareerAction.updateSocialLink(event, formik);
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((navigation_section_index_module_default()).SocialLinks__Fields__RightContent),
                        children: "\xa0"
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/styles/components/careers/button-style/_index.module.scss
var button_style_index_module = __webpack_require__(37648);
var button_style_index_module_default = /*#__PURE__*/__webpack_require__.n(button_style_index_module);
// EXTERNAL MODULE: ../../shared/node_modules/reactcss/lib/index.js
var reactcss_lib = __webpack_require__(40940);
// EXTERNAL MODULE: ../../shared/node_modules/react-color/es/index.js + 117 modules
var react_color_es = __webpack_require__(43691);
;// CONCATENATED MODULE: ./src/components/color-pickerf.js




function ColorPickerf(props) {
    var rgbaToHex = function rgbaToHex(rgba) {
        try {
            var str = "#";
            str = str + rgba.r.toString(16).padStart(2, "0");
            str = str + rgba.g.toString(16).padStart(2, "0");
            str = str + rgba.b.toString(16).padStart(2, "0");
            return str.toUpperCase() + " | " + parseInt(rgba.a * 100) + "%";
        } catch (error) {
            console.log(rgba);
            return "";
        }
    };
    var ref = (0,react.useState)(false), displayColorPicker = ref[0], setDisplayColorPicker = ref[1];
    var ref1 = (0,react.useState)(props.color || {
        r: 255,
        g: 255,
        b: 255,
        a: 1
    }), color = ref1[0], setColor = ref1[1];
    var handleClick = function() {
        if (props.isDisabled) {
            setDisplayColorPicker(false);
        } else {
            setDisplayColorPicker(!displayColorPicker);
        }
    };
    var handleClose = function() {
        setDisplayColorPicker(false);
    };
    var handleChange = function(color) {
        setColor(color.rgb);
        props.handleChange(color);
    };
    var styles = (0,reactcss_lib/* default */.ZP)({
        "default": {
            color: {
                width: "21px",
                height: "21px",
                border: "1px solid rgba(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ", ").concat(color.a, ")"),
                borderRadius: "3px",
                background: "rgba(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ", ").concat(color.a, ")")
            },
            popover: {
                position: "absolute",
                zIndex: "2",
                top: "auto"
            },
            cover: {
                position: "fixed",
                top: "0px",
                right: "0px",
                bottom: "0px",
                left: "0px"
            }
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: styles.swatch,
                onClick: handleClick,
                className: "Dpflex colorpickerpostion",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: styles.color
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ml15",
                        children: rgbaToHex(color)
                    })
                ]
            }),
            displayColorPicker ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: styles.popover,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: styles.cover,
                        onClick: handleClose
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_color_es/* SketchPicker */.xS, {
                        color: color,
                        onChange: handleChange
                    })
                ]
            }) : null
        ]
    });
}
/* harmony default export */ var color_pickerf = (ColorPickerf);

;// CONCATENATED MODULE: ./src/components/careers/button-section/buttons-style.js






function CustomButtons(param) {
    var formik = param.formik, sidebar_section = param.sidebar_section, customizeCareerAction = param.customizeCareerAction, setFonts = param.setFonts;
    var ref, ref1, ref2, ref3;
    var t = (0,common/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((button_style_index_module_default()).CustomButtons),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "".concat((button_style_index_module_default()).CustomButtons__Title),
                children: t("career:styles:button")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((button_style_index_module_default()).CustomButtons__Fields),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((button_style_index_module_default()).CustomButtons__Fields__LeftContent),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((button_style_index_module_default()).CustomButtons__Fields__Label),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    children: t("career:styles:border_radius")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((button_style_index_module_default()).CustomButtons__Fields__Input),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                    control: "input",
                                    type: "text",
                                    placeholder: "22",
                                    name: "career_button_style_attributes.style_hash.borderRadius",
                                    className: (button_style_index_module_default()).CustomButtons__Input,
                                    formik: formik,
                                    onChange: function(evt) {
                                        customizeCareerAction.fontStyleChange(evt, formik, "border_radius", "button");
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((button_style_index_module_default()).CustomButtons__Fields__RightContent),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((button_style_index_module_default()).CustomButtons__Fields__Label),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    children: t("career:styles:font_size")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((button_style_index_module_default()).CustomButtons__Fields__Input),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                    control: "select",
                                    options: customizeCareerAction.fontSizeOptions("button_text", t),
                                    name: "career_button_style_attributes.style_hash.fontSize",
                                    career: "".concat((button_style_index_module_default()).CustomButtons__Select, " CareerSelect"),
                                    formik: formik,
                                    placeholder: "24px",
                                    default: formik.values.career_button_style_attributes.style_hash.fontSize,
                                    onChange: function(option) {
                                        return customizeCareerAction.fontStyleChange(option, formik, "font_size", "button");
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((button_style_index_module_default()).CustomButtons__DFlex),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: "".concat((button_style_index_module_default()).CustomButtons__Title, " pt0"),
                        children: t("career:styles:hero_button")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((button_style_index_module_default()).CustomButtons__Fields),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((button_style_index_module_default()).CustomButtons__RightButtonContent),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                type: "button",
                                style: customizeCareerAction.heroButtonStyle(formik),
                                buttonstyle: "".concat((button_style_index_module_default()).CustomButtons__ButtonPreview),
                                children: t("career:styles:button")
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((button_style_index_module_default()).CustomButtons__Fields),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((button_style_index_module_default()).CustomButtons__Fields__LeftContent),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((button_style_index_module_default()).CustomButtons__Fields__Label),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    children: t("career:styles:bg_color")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((button_style_index_module_default()).CustomButtons__Fields__ColorInput),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(color_pickerf, {
                                    formik: formik,
                                    color: (ref = formik.values.career_button_style_attributes.hero_button) === null || ref === void 0 ? void 0 : ref.background_color,
                                    handleChange: function(color) {
                                        return customizeCareerAction.fontStyleChange(color, formik, "hero_button_background_color", "button");
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((button_style_index_module_default()).CustomButtons__Fields__RightContent),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((button_style_index_module_default()).CustomButtons__Fields__Label),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    children: t("career:styles:font_color")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((button_style_index_module_default()).CustomButtons__Fields__ColorInput),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(color_pickerf, {
                                    formik: formik,
                                    color: (ref1 = formik.values.career_button_style_attributes.hero_button) === null || ref1 === void 0 ? void 0 : ref1.font_color,
                                    handleChange: function(color) {
                                        return customizeCareerAction.fontStyleChange(color, formik, "hero_button_font_color", "button");
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((button_style_index_module_default()).CustomButtons__DFlex),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: "".concat((button_style_index_module_default()).CustomButtons__Title, " pt0"),
                        children: t("career:styles:view_more_jobs")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((button_style_index_module_default()).CustomButtons__Fields),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((button_style_index_module_default()).CustomButtons__RightButtonContent),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                type: "button",
                                style: customizeCareerAction.viewMoreButtonStyle(formik),
                                buttonstyle: "".concat((button_style_index_module_default()).CustomButtons__ButtonPreview),
                                children: t("career:styles:button")
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((button_style_index_module_default()).CustomButtons__Fields, " pb20"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((button_style_index_module_default()).CustomButtons__Fields__LeftContent),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((button_style_index_module_default()).CustomButtons__Fields__Label),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    children: t("career:styles:bg_color")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((button_style_index_module_default()).CustomButtons__Fields__ColorInput),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(color_pickerf, {
                                    formik: formik,
                                    color: (ref2 = formik.values.career_button_style_attributes.view_more_job_button) === null || ref2 === void 0 ? void 0 : ref2.background_color,
                                    handleChange: function(color) {
                                        return customizeCareerAction.fontStyleChange(color, formik, "view_more_job_button_background_color", "button");
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((button_style_index_module_default()).CustomButtons__Fields__RightContent),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((button_style_index_module_default()).CustomButtons__Fields__Label),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    children: t("career:styles:font_color")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((button_style_index_module_default()).CustomButtons__Fields__ColorInput),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(color_pickerf, {
                                    formik: formik,
                                    color: (ref3 = formik.values.career_button_style_attributes.view_more_job_button) === null || ref3 === void 0 ? void 0 : ref3.font_color,
                                    handleChange: function(color) {
                                        return customizeCareerAction.fontStyleChange(color, formik, "view_more_job_button_font_color", "button");
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/careers/font-section/hero-title.js






function HeroTitle(param) {
    var formik = param.formik, sidebar_section = param.sidebar_section, customizeCareerAction = param.customizeCareerAction, setFonts = param.setFonts;
    var t = (0,common/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((button_style_index_module_default()).CustomButtons),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    className: "".concat((button_style_index_module_default()).CustomButtons__Title),
                    children: t("career:styles:fonts")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((button_style_index_module_default()).CustomButtons__Fields__Label),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        children: t("career:styles:font_family")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((button_style_index_module_default()).CustomButtons__Fields__Input),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                        control: "select",
                        options: TEXT_STYLES_OPTIONS.fontFamilies,
                        name: "career_font_style_attributes.font_family",
                        career: "".concat((button_style_index_module_default()).CustomButtons__Select, " CareerSelect"),
                        formik: formik,
                        placeholder: "Arial",
                        default: formik.values.career_font_style_attributes.font_family,
                        onChange: function(option) {
                            return customizeCareerAction.fontStyleChange(option, formik, "font_family", "font_style", setFonts);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    className: "".concat((button_style_index_module_default()).CustomButtons__Title),
                    children: t("career:styles:hero_text")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((button_style_index_module_default()).CustomButtons__Fields100),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((button_style_index_module_default()).CustomButtons__Fields),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((button_style_index_module_default()).CustomButtons__Fields__LeftContent),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((button_style_index_module_default()).CustomButtons__Fields__Label),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            children: t("career:styles:font_size")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((button_style_index_module_default()).CustomButtons__Fields__Input),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                            control: "select",
                                            options: customizeCareerAction.fontSizeOptions("hero_font_size", t),
                                            name: "career_font_style_attributes.hero_font_size",
                                            career: "".concat((button_style_index_module_default()).CustomButtons__Select, " CareerSelect"),
                                            formik: formik,
                                            placeholder: "24px",
                                            default: formik.values.career_font_style_attributes.hero_font_size,
                                            onChange: function(option) {
                                                return customizeCareerAction.fontStyleChange(option, formik, "hero_font_size", "font_style");
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((button_style_index_module_default()).CustomButtons__Fields__RightContent),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((button_style_index_module_default()).CustomButtons__Fields__Label),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            children: t("career:styles:font_color")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((button_style_index_module_default()).CustomButtons__Fields__ColorInput),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(color_pickerf, {
                                            formik: formik,
                                            color: formik.values.career_font_style_attributes.hero_font_color,
                                            handleChange: function(color) {
                                                return customizeCareerAction.fontStyleChange(color, formik, "hero_font_color", "font_style");
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((button_style_index_module_default()).CustomButtons__Fields100, " mt20"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((button_style_index_module_default()).CustomButtons__Fields),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((button_style_index_module_default()).CustomButtons__Fields__OverlayBaseContainer),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((button_style_index_module_default()).CustomButtons__Fields__OverlayLabelContainer),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: t("career:styles:overlay")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((button_style_index_module_default()).OverlayGuideDesign),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: t("career:styles:overlay_description")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((button_style_index_module_default()).CustomButtons__Fields__ColorInput),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(color_pickerf, {
                                        formik: formik,
                                        color: formik.values.hero_section_attributes.overlay_hash,
                                        handleChange: function(color) {
                                            return customizeCareerAction.fontStyleChange(color, formik, "hero_background_overlay", "overlay");
                                        }
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    className: "".concat((button_style_index_module_default()).CustomButtons__Title),
                    children: t("career:styles:colours")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((button_style_index_module_default()).CustomColourStyle),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            children: [
                                t("career:styles:1:heading"),
                                " : ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("career:styles:1:description")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((button_style_index_module_default()).CustomButtons__Fields),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((button_style_index_module_default()).CustomButtons__Fields__LeftContent),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((button_style_index_module_default()).CustomButtons__Fields__Label),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                children: t("career:styles:bg_color")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((button_style_index_module_default()).CustomButtons__Fields__ColorInput),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(color_pickerf, {
                                                formik: formik,
                                                color: formik.values.career_font_style_attributes.style_hash.style_1.background_color,
                                                handleChange: function(color) {
                                                    return customizeCareerAction.fontStyleChange(color, formik, "style_1_background_color", "font_style");
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((button_style_index_module_default()).CustomButtons__Fields__RightContent),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((button_style_index_module_default()).CustomButtons__Fields__Label),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                children: t("career:styles:font_color")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((button_style_index_module_default()).CustomButtons__Fields__ColorInput),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(color_pickerf, {
                                                formik: formik,
                                                color: formik.values.career_font_style_attributes.style_hash.style_1.font_color,
                                                handleChange: function(color) {
                                                    return customizeCareerAction.fontStyleChange(color, formik, "style_1_font_color", "font_style");
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: "".concat((button_style_index_module_default()).CustomButtons__Title),
                            children: [
                                t("career:styles:2:heading"),
                                ": ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("career:styles:2:description")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((button_style_index_module_default()).CustomButtons__Fields),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((button_style_index_module_default()).CustomButtons__Fields__LeftContent),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((button_style_index_module_default()).CustomButtons__Fields__Label),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                children: t("career:styles:bg_color")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((button_style_index_module_default()).CustomButtons__Fields__ColorInput),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(color_pickerf, {
                                                formik: formik,
                                                color: formik.values.career_font_style_attributes.style_hash.style_2.background_color,
                                                handleChange: function(color) {
                                                    return customizeCareerAction.fontStyleChange(color, formik, "style_2_background_color", "font_style");
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((button_style_index_module_default()).CustomButtons__Fields__RightContent),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((button_style_index_module_default()).CustomButtons__Fields__Label),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                children: t("career:styles:font_color")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((button_style_index_module_default()).CustomButtons__Fields__ColorInput),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(color_pickerf, {
                                                formik: formik,
                                                color: formik.values.career_font_style_attributes.style_hash.style_2.font_color,
                                                handleChange: function(color) {
                                                    return customizeCareerAction.fontStyleChange(color, formik, "style_2_font_color", "font_style");
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: "".concat((button_style_index_module_default()).CustomButtons__Title),
                            children: [
                                t("career:styles:3:heading"),
                                ": ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("career:styles:3:description")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((button_style_index_module_default()).CustomButtons__Fields),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((button_style_index_module_default()).CustomButtons__Fields__leftContent),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((button_style_index_module_default()).CustomButtons__Fields__Label),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            children: t("career:styles:font_color")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((button_style_index_module_default()).CustomButtons__Fields__ColorInput),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(color_pickerf, {
                                            formik: formik,
                                            color: formik.values.career_font_style_attributes.style_hash.style_3.font_color,
                                            handleChange: function(color) {
                                                return customizeCareerAction.fontStyleChange(color, formik, "style_3_font_color", "font_style");
                                            }
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/components/custom-cropper.js
var custom_cropper = __webpack_require__(93425);
// EXTERNAL MODULE: ../../shared/node_modules/cropperjs/dist/cropper.css
var cropper = __webpack_require__(13446);
// EXTERNAL MODULE: ./src/styles/components/job-live/_index.module.scss
var job_live_index_module = __webpack_require__(95150);
var job_live_index_module_default = /*#__PURE__*/__webpack_require__.n(job_live_index_module);
// EXTERNAL MODULE: ./src/styles/components/cropper-filter/_index.module.scss
var cropper_filter_index_module = __webpack_require__(28033);
var cropper_filter_index_module_default = /*#__PURE__*/__webpack_require__.n(cropper_filter_index_module);
// EXTERNAL MODULE: ./public/icons/closewhite.svg
var closewhite = __webpack_require__(70394);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
;// CONCATENATED MODULE: ./src/components/career-cropper.js







function CareerCropper(props) {
    var cropperClass = function cropperClass() {
        var type = props.cropper_type.type;
        switch(type){
            case "logo_image":
                return (cropper_filter_index_module_default()).CareerLogoImage;
            case "hero_image":
                return (cropper_filter_index_module_default()).CareerHeroImage;
            case "about_image":
                return (cropper_filter_index_module_default()).CareerAboutImage;
            case "gallery_image":
                return (cropper_filter_index_module_default()).CareerGalleryImage;
            case "benefit_image":
                return (cropper_filter_index_module_default()).CareerBenefitImage;
            case "team_image":
                return (cropper_filter_index_module_default()).CareerTeamImage;
        }
    };
    var modal_title = function modal_title(type) {
        if (type === "mobile_image") {
            return t("career:cropper:mobile");
        } else if (type === "hero_image") {
            return t("career:cropper:desktop");
        } else {
            return t("career:cropper:default");
        }
    };
    var ref;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "CropperModal ".concat((job_live_index_module_default()).Modalpopup, " ").concat((ref = props.cropper_type) === null || ref === void 0 ? void 0 : ref.type),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((cropper_filter_index_module_default()).CropImage, " ").concat(cropperClass()),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((cropper_filter_index_module_default()).CropImage__Head),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: modal_title(props.cropper_type.type)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((cropper_filter_index_module_default()).ModalClose),
                            onClick: function(event) {
                                props.viewProfileAction.closeCropperModal();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(closewhite/* default */.Z, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (cropper_filter_index_module_default()).CropImage__Inner,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "CustomCropperContainer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/pages/profilepic/profilepic.png",
                                className: "Cropper__Image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "CustomCropper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "CustomCropper__Acion mt20",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (cropper_filter_index_module_default()).CropImage__Actions,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                    children: [
                                                        t("career:cropper:zoom"),
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_button/* default */.Z, {
                                                    onClick: function() {
                                                        props.viewProfileAction.zoom_in();
                                                    },
                                                    children: [
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "+"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_button/* default */.Z, {
                                                    onClick: function() {
                                                        props.viewProfileAction.zoom_out();
                                                    },
                                                    children: [
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            style: {
                                                                marginBottom: "3px"
                                                            },
                                                            children: "-"
                                                        }),
                                                        " "
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                            buttonstyle: "m0 ".concat((cropper_filter_index_module_default()).primarybtn),
                                            onClick: function() {
                                                props.viewProfileAction.getCroppedImage(props);
                                                document.querySelector(".CropperModal").style.visibility = "hidden";
                                            },
                                            children: t("career:cropper:button")
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/components/confirmation-modal.js
var confirmation_modal = __webpack_require__(72055);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
;// CONCATENATED MODULE: ./src/services/pages/clients/careers/customize-career-page.js







var CustomizeCareerService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(CustomizeCareerService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(CustomizeCareerService);
    function CustomizeCareerService() {
        (0,_class_call_check/* default */.Z)(this, CustomizeCareerService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CustomizeCareerService, [
        {
            key: "getCareerData",
            value: function getCareerData(client_auth_cookies, params, hostName) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.career.CAREER_PAGE_PREVIEW */.bl.client.career.CAREER_PAGE_PREVIEW;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    (0,common/* axios */.od)((_tmp.method = "get", _tmp.url = url, _tmp.headers = {
                                        cookie: "Authorization=".concat(client_auth_cookies),
                                        SLUG: hostName
                                    }, _tmp.params = params, _tmp))
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCareerPreviewData",
            value: function getCareerPreviewData(client_auth_cookies, params, hostName) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.career.CUSTOMIZE_CAREER */.bl.client.career.CUSTOMIZE_CAREER;
                                params.is_preview = true;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    (0,common/* axios */.od)((_tmp.method = "get", _tmp.url = url, _tmp.headers = {
                                        cookie: "Authorization=".concat(client_auth_cookies),
                                        SLUG: hostName
                                    }, _tmp.params = params, _tmp))
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateCareerPage",
            value: function updateCareerPage(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.admins.dashboard.clients.jobs.UPDATE_CAREER_PAGE */.bl.admins.dashboard.clients.jobs.UPDATE_CAREER_PAGE;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateCareerPageImages",
            value: function updateCareerPageImages(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.admins.dashboard.clients.jobs.UPDATE_CAREER_PAGE */.bl.admins.dashboard.clients.jobs.UPDATE_CAREER_PAGE;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(url, params, _this.setMultipartHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "publishCareerPage",
            value: function publishCareerPage(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.career.PUBLISH_CAREER_PAGE */.bl.client.career.PUBLISH_CAREER_PAGE;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "resetCareerPage",
            value: function resetCareerPage(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.career.RESET_CAREER_PAGE */.bl.client.career.RESET_CAREER_PAGE;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                console.log(error);
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CustomizeCareerService;
}(common/* SendRequest */.Lt);

// EXTERNAL MODULE: ./src/actions/pages/clients/careers/customize-career-page.js
var customize_career_page = __webpack_require__(10691);
// EXTERNAL MODULE: ./src/actions/components/custom-cropper.js
var components_custom_cropper = __webpack_require__(50668);
// EXTERNAL MODULE: ./src/actions/pages/clients/careers/showJob.js + 1 modules
var showJob = __webpack_require__(70158);
// EXTERNAL MODULE: ../../shared/node_modules/react-editext/dist/index.es.js
var index_es = __webpack_require__(73399);
// EXTERNAL MODULE: ./src/pages/careers/editimage.js
var editimage = __webpack_require__(52557);
;// CONCATENATED MODULE: ./src/constants/pages/clients/careers/customize-career-page.js

var URL_FORMAT = /^((http|https):\/\/)?[a-zA-Z0-9]+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-z]{2,}(:[0-9]{1,})?(\/.*)?$/i;
var LINK_TYPES = {
    header: "header",
    footer: "footer"
};
var IMAGE_VISIBILITIES = {
    show: "show",
    hide: "hide"
};
var BENEFIT_DATA = [
    {
        title: "Value1",
        description: "It's important to highlight how your company's values guide your decision-making, shapes your culture, and inform your interactions with your employees, customers, and other stakeholders."
    },
    {
        title: "Value2",
        description: "Values help potential employees understand what the company stands for and whether it aligns with their personal values and career aspiration."
    },
    {
        title: "Value3",
        description: "A company values section should include a clear and concise list of the company's core values and explanations of how each value is demonstrated within the company culture."
    }
];
var TEAM_NO_DATA = function(t) {
    return {
        data: {
            name: t("career:team_no_data:name"),
            designation: t("career:team_no_data:designation"),
            description: t("career:team_no_data:description")
        }
    };
};
var TEAM_DATA = [
    {
        name: "John Clark",
        designation: "CEO",
        description: "<div>Skills and expertise of each team member</div><div>Interests or hobbies outside of work</div><div>Awards or recognition received by the team or individual members</div><div>Quotes from the team on why they love working at your company.</div>"
    }
];
var DEFAULT_JOBS = Array(6).fill(0).map(function(_, i) {
    return {
        job_title: jobTitle(i),
        published_date: (0,common/* TRANSLATION */.TA)("page:clients:customize-career:texts:posted_today"),
        city_country: (0,common/* TRANSLATION */.TA)("page:clients:customize-career-page:texts:country"),
        is_remote: true,
        contract_type: (0,common/* TRANSLATION */.TA)("page:clients:customize-career-page:texts:permanent")
    };
});
var FILE_SIZES = {
    logo: {
        size: 2000000,
        minWidth: 100,
        minHeight: 50,
        maxWidth: 400,
        maxHeight: 200,
        ratio: 2 / 1
    },
    hero: {
        size: 5000000,
        minWidth: 900,
        minHeight: 450,
        maxWidth: 3600,
        maxHeight: 1800,
        ratio: 2 / 1,
        idealWidth: 1400
    },
    mobile_hero: {
        size: 5000000,
        minWidth: 375,
        minHeight: 640,
        maxWidth: 750,
        maxHeight: 1280,
        ratio: 75 / 128
    },
    about: {
        size: 5000000,
        minWidth: 720,
        minHeight: 800,
        maxWidth: 1440,
        maxHeight: 1600,
        ratio: 9 / 10
    },
    gallery: {
        size: 5000000,
        minWidth: 567,
        minHeight: 378,
        maxWidth: 1134,
        maxHeight: 756,
        ratio: 48 / 45
    },
    benefit: {
        size: 1000000,
        minWidth: 64,
        minHeight: 64,
        maxWidth: 128,
        maxHeight: 128,
        ratio: 1
    },
    team: {
        size: 5000000,
        minWidth: 203,
        minHeight: 203,
        maxWidth: 406,
        maxHeight: 406,
        ratio: 1
    }
};
var BUTTON_STYLES_OPTIONS = {
    fill: [
        {
            label: "Solid",
            value: "solid"
        },
        {
            label: "Outline",
            value: "outline"
        }
    ],
    font_sizes: [
        8,
        10,
        12,
        14,
        16,
        18,
        20,
        22,
        24,
        26,
        28,
        30
    ].map(function(_, i) {
        return {
            label: "".concat(_, "px"),
            value: "".concat(_, "px")
        };
    }),
    fontFamilies: fontOptions(),
    radiusOptions: Array(100).fill(0).map(function(_, i) {
        return {
            label: i + 1,
            value: "".concat(i + 1, "px")
        };
    })
};
var TEXT_STYLES_OPTIONS = {
    font_sizes: [
        8,
        10,
        12,
        14,
        16,
        18,
        20,
        22,
        24,
        26,
        28,
        30
    ].map(function(_, i) {
        return {
            label: "".concat(_, "px"),
            value: "".concat(_, "px")
        };
    }),
    fontFamilies: fontOptions()
};
function jobTitle(index) {
    if (index == 0) return (0,common/* TRANSLATION */.TA)("page:clients:customize-career-page:texts:post_first");
    else return index % 2 == 0 ? (0,common/* TRANSLATION */.TA)("page:clients:customize-career-page:texts:post_second") : (0,common/* TRANSLATION */.TA)("page:clients:customize-career-page:texts:post_third");
}
function fontOptions() {
    return [
        {
            "label": "ABeeZee",
            "value": "ABeeZee",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "label": "Abel",
            "value": "Abel",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Aclonica",
            "value": "Aclonica",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Acme",
            "value": "Acme",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Actor",
            "value": "Actor",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Advent Pro",
            "value": "Advent Pro",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Akshar",
            "value": "Akshar",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Alata",
            "value": "Alata",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Alatsi",
            "value": "Alatsi",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Albert Sans",
            "value": "Albert Sans",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Aldrich",
            "value": "Aldrich",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Alef",
            "value": "Alef",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "Alegreya Sans",
            "value": "Alegreya Sans",
            "variants": [
                "100",
                "100italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Alegreya Sans SC",
            "value": "Alegreya Sans SC",
            "variants": [
                "100",
                "100italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Alexandria",
            "value": "Alexandria",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Allerta",
            "value": "Allerta",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Allerta Stencil",
            "value": "Allerta Stencil",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Almarai",
            "value": "Almarai",
            "variants": [
                "300",
                "regular",
                "700",
                "800"
            ]
        },
        {
            "label": "Alumni Sans",
            "value": "Alumni Sans",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Alumni Sans Collegiate One",
            "value": "Alumni Sans Collegiate One",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "label": "Alumni Sans Pinstripe",
            "value": "Alumni Sans Pinstripe",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "label": "Amaranth",
            "value": "Amaranth",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Amiko",
            "value": "Amiko",
            "variants": [
                "regular",
                "600",
                "700"
            ]
        },
        {
            "label": "Anaheim",
            "value": "Anaheim",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Andika",
            "value": "Andika",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Anek Bangla",
            "value": "Anek Bangla",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Anek Devanagari",
            "value": "Anek Devanagari",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Anek Gujarati",
            "value": "Anek Gujarati",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Anek Gurmukhi",
            "value": "Anek Gurmukhi",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Anek Kannada",
            "value": "Anek Kannada",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Anek Latin",
            "value": "Anek Latin",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Anek Malayalam",
            "value": "Anek Malayalam",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Anek Odia",
            "value": "Anek Odia",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Anek Tamil",
            "value": "Anek Tamil",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Anek Telugu",
            "value": "Anek Telugu",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Antic",
            "value": "Antic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Anton",
            "value": "Anton",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Antonio",
            "value": "Antonio",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Archivo",
            "value": "Archivo",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Archivo Black",
            "value": "Archivo Black",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Archivo Narrow",
            "value": "Archivo Narrow",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "label": "Arimo",
            "value": "Arimo",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "label": "Armata",
            "value": "Armata",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Arsenal",
            "value": "Arsenal",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Arya",
            "value": "Arya",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "Asap",
            "value": "Asap",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Asap Condensed",
            "value": "Asap Condensed",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Assistant",
            "value": "Assistant",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Asul",
            "value": "Asul",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "Athiti",
            "value": "Athiti",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Atkinson Hyperlegible",
            "value": "Atkinson Hyperlegible",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Average Sans",
            "value": "Average Sans",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "B612",
            "value": "B612",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "BIZ UDGothic",
            "value": "BIZ UDGothic",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "BIZ UDPGothic",
            "value": "BIZ UDPGothic",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "Bai Jamjuree",
            "value": "Bai Jamjuree",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Barlow",
            "value": "Barlow",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Barlow Condensed",
            "value": "Barlow Condensed",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Barlow Semi Condensed",
            "value": "Barlow Semi Condensed",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Basic",
            "value": "Basic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Bayon",
            "value": "Bayon",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Be Vietnam Pro",
            "value": "Be Vietnam Pro",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Belleza",
            "value": "Belleza",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "BenchNine",
            "value": "BenchNine",
            "variants": [
                "300",
                "regular",
                "700"
            ]
        },
        {
            "label": "Biryani",
            "value": "Biryani",
            "variants": [
                "200",
                "300",
                "regular",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Black And White Picture",
            "value": "Black And White Picture",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Black Han Sans",
            "value": "Black Han Sans",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Blinker",
            "value": "Blinker",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Bubbler One",
            "value": "Bubbler One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Cabin",
            "value": "Cabin",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "label": "Cabin Condensed",
            "value": "Cabin Condensed",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Cagliostro",
            "value": "Cagliostro",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Cairo",
            "value": "Cairo",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Cambay",
            "value": "Cambay",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Candal",
            "value": "Candal",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Cantarell",
            "value": "Cantarell",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Cantora One",
            "value": "Cantora One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Capriola",
            "value": "Capriola",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Carme",
            "value": "Carme",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Carrois Gothic",
            "value": "Carrois Gothic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Carrois Gothic SC",
            "value": "Carrois Gothic SC",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Catamaran",
            "value": "Catamaran",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Chakra Petch",
            "value": "Chakra Petch",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Changa",
            "value": "Changa",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Chathura",
            "value": "Chathura",
            "variants": [
                "100",
                "300",
                "regular",
                "700",
                "800"
            ]
        },
        {
            "label": "Chau Philomene One",
            "value": "Chau Philomene One",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "label": "Chivo",
            "value": "Chivo",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Coda Caption",
            "value": "Coda Caption",
            "variants": [
                "800"
            ]
        },
        {
            "label": "Commissioner",
            "value": "Commissioner",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Convergence",
            "value": "Convergence",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Cuprum",
            "value": "Cuprum",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "label": "DM Sans",
            "value": "DM Sans",
            "variants": [
                "regular",
                "italic",
                "500",
                "500italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Darker Grotesque",
            "value": "Darker Grotesque",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Days One",
            "value": "Days One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Denk One",
            "value": "Denk One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Dhurjati",
            "value": "Dhurjati",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Didact Gothic",
            "value": "Didact Gothic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Do Hyeon",
            "value": "Do Hyeon",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Dongle",
            "value": "Dongle",
            "variants": [
                "300",
                "regular",
                "700"
            ]
        },
        {
            "label": "Doppio One",
            "value": "Doppio One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Dorsa",
            "value": "Dorsa",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Dosis",
            "value": "Dosis",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "DotGothic16",
            "value": "DotGothic16",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Duru Sans",
            "value": "Duru Sans",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Economica",
            "value": "Economica",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "El Messiri",
            "value": "El Messiri",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Electrolize",
            "value": "Electrolize",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Encode Sans",
            "value": "Encode Sans",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Encode Sans Condensed",
            "value": "Encode Sans Condensed",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Encode Sans Expanded",
            "value": "Encode Sans Expanded",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Encode Sans SC",
            "value": "Encode Sans SC",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Encode Sans Semi Condensed",
            "value": "Encode Sans Semi Condensed",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Encode Sans Semi Expanded",
            "value": "Encode Sans Semi Expanded",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Englebert",
            "value": "Englebert",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Epilogue",
            "value": "Epilogue",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Exo",
            "value": "Exo",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Exo 2",
            "value": "Exo 2",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Fahkwang",
            "value": "Fahkwang",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Familjen Grotesk",
            "value": "Familjen Grotesk",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "label": "Farro",
            "value": "Farro",
            "variants": [
                "300",
                "regular",
                "500",
                "700"
            ]
        },
        {
            "label": "Federo",
            "value": "Federo",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Figtree",
            "value": "Figtree",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Finlandica",
            "value": "Finlandica",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "label": "Fira Sans",
            "value": "Fira Sans",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Fira Sans Condensed",
            "value": "Fira Sans Condensed",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Fira Sans Extra Condensed",
            "value": "Fira Sans Extra Condensed",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Fjalla One",
            "value": "Fjalla One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Francois One",
            "value": "Francois One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Fredoka",
            "value": "Fredoka",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Fresca",
            "value": "Fresca",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "GFS Neohellenic",
            "value": "GFS Neohellenic",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Gafata",
            "value": "Gafata",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Galdeano",
            "value": "Galdeano",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Gantari",
            "value": "Gantari",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Gayathri",
            "value": "Gayathri",
            "variants": [
                "100",
                "regular",
                "700"
            ]
        },
        {
            "label": "Gemunu Libre",
            "value": "Gemunu Libre",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Genos",
            "value": "Genos",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Geo",
            "value": "Geo",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "label": "Gellix",
            "value": "Gellix",
            "variants": [
                "regular",
                "italic",
                "300",
                "500",
                "700"
            ]
        },
        {
            "label": "Georama",
            "value": "Georama",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Gidugu",
            "value": "Gidugu",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Glory",
            "value": "Glory",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic"
            ]
        },
        {
            "label": "Gothic A1",
            "value": "Gothic A1",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Gotu",
            "value": "Gotu",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Gowun Dodum",
            "value": "Gowun Dodum",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Gudea",
            "value": "Gudea",
            "variants": [
                "regular",
                "italic",
                "700"
            ]
        },
        {
            "label": "Hammersmith One",
            "value": "Hammersmith One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Hanken Grotesk",
            "value": "Hanken Grotesk",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Harmattan",
            "value": "Harmattan",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "Heebo",
            "value": "Heebo",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Hind",
            "value": "Hind",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Hind Guntur",
            "value": "Hind Guntur",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Hind Madurai",
            "value": "Hind Madurai",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Hind Siliguri",
            "value": "Hind Siliguri",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Hind Vadodara",
            "value": "Hind Vadodara",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Homenaje",
            "value": "Homenaje",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "IBM Plex Sans",
            "value": "IBM Plex Sans",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "IBM Plex Sans Arabic",
            "value": "IBM Plex Sans Arabic",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "IBM Plex Sans Condensed",
            "value": "IBM Plex Sans Condensed",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "IBM Plex Sans Devanagari",
            "value": "IBM Plex Sans Devanagari",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "IBM Plex Sans Hebrew",
            "value": "IBM Plex Sans Hebrew",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "IBM Plex Sans JP",
            "value": "IBM Plex Sans JP",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "IBM Plex Sans KR",
            "value": "IBM Plex Sans KR",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "IBM Plex Sans Thai",
            "value": "IBM Plex Sans Thai",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "IBM Plex Sans Thai Looped",
            "value": "IBM Plex Sans Thai Looped",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Imprima",
            "value": "Imprima",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Inder",
            "value": "Inder",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Inria Sans",
            "value": "Inria Sans",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Inter",
            "value": "Inter",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Inter Tight",
            "value": "Inter Tight",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Istok Web",
            "value": "Istok Web",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Jaldi",
            "value": "Jaldi",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "Jockey One",
            "value": "Jockey One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Josefin Sans",
            "value": "Josefin Sans",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "label": "Jost",
            "value": "Jost",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Jua",
            "value": "Jua",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Julius Sans One",
            "value": "Julius Sans One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Jura",
            "value": "Jura",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "K2D",
            "value": "K2D",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic"
            ]
        },
        {
            "label": "Kanit",
            "value": "Kanit",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Kantumruy",
            "value": "Kantumruy",
            "variants": [
                "300",
                "regular",
                "700"
            ]
        },
        {
            "label": "Kantumruy Pro",
            "value": "Kantumruy Pro",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "label": "Karla",
            "value": "Karla",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic"
            ]
        },
        {
            "label": "Kdam Thmor Pro",
            "value": "Kdam Thmor Pro",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Khand",
            "value": "Khand",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Khula",
            "value": "Khula",
            "variants": [
                "300",
                "regular",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Kite One",
            "value": "Kite One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "KoHo",
            "value": "KoHo",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Kodchasan",
            "value": "Kodchasan",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Kosugi",
            "value": "Kosugi",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Kosugi Maru",
            "value": "Kosugi Maru",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Krona One",
            "value": "Krona One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Krub",
            "value": "Krub",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Kufam",
            "value": "Kufam",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Kulim Park",
            "value": "Kulim Park",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Kumbh Sans",
            "value": "Kumbh Sans",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Laila",
            "value": "Laila",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Lato",
            "value": "Lato",
            "variants": [
                "100",
                "100italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "700",
                "700italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "League Gothic",
            "value": "League Gothic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "League Spartan",
            "value": "League Spartan",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Lekton",
            "value": "Lekton",
            "variants": [
                "regular",
                "italic",
                "700"
            ]
        },
        {
            "label": "Lexend",
            "value": "Lexend",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Lexend Deca",
            "value": "Lexend Deca",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Lexend Exa",
            "value": "Lexend Exa",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Lexend Giga",
            "value": "Lexend Giga",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Lexend Mega",
            "value": "Lexend Mega",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Lexend Peta",
            "value": "Lexend Peta",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Lexend Tera",
            "value": "Lexend Tera",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Lexend Zetta",
            "value": "Lexend Zetta",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Libre Franklin",
            "value": "Libre Franklin",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Livvic",
            "value": "Livvic",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "M PLUS 1",
            "value": "M PLUS 1",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "M PLUS 1 Code",
            "value": "M PLUS 1 Code",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "M PLUS 1p",
            "value": "M PLUS 1p",
            "variants": [
                "100",
                "300",
                "regular",
                "500",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "M PLUS 2",
            "value": "M PLUS 2",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "M PLUS Code Latin",
            "value": "M PLUS Code Latin",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "M PLUS Rounded 1c",
            "value": "M PLUS Rounded 1c",
            "variants": [
                "100",
                "300",
                "regular",
                "500",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Mada",
            "value": "Mada",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "900"
            ]
        },
        {
            "label": "Magra",
            "value": "Magra",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "Mako",
            "value": "Mako",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Mallanna",
            "value": "Mallanna",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Mandali",
            "value": "Mandali",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Manjari",
            "value": "Manjari",
            "variants": [
                "100",
                "regular",
                "700"
            ]
        },
        {
            "label": "Manrope",
            "value": "Manrope",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Marmelad",
            "value": "Marmelad",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Martel Sans",
            "value": "Martel Sans",
            "variants": [
                "200",
                "300",
                "regular",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Marvel",
            "value": "Marvel",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Maven Pro",
            "value": "Maven Pro",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Meera Inimai",
            "value": "Meera Inimai",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Merriweather Sans",
            "value": "Merriweather Sans",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic"
            ]
        },
        {
            "label": "Metrophobic",
            "value": "Metrophobic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Michroma",
            "value": "Michroma",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Mina",
            "value": "Mina",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "Mingzat",
            "value": "Mingzat",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Miriam Libre",
            "value": "Miriam Libre",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "Mitr",
            "value": "Mitr",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Mochiy Pop One",
            "value": "Mochiy Pop One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Mochiy Pop P One",
            "value": "Mochiy Pop P One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Mohave",
            "value": "Mohave",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "label": "Molengo",
            "value": "Molengo",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Monda",
            "value": "Monda",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "Montserrat",
            "value": "Montserrat",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Montserrat Alternates",
            "value": "Montserrat Alternates",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Montserrat Subrayada",
            "value": "Montserrat Subrayada",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "Mouse Memoirs",
            "value": "Mouse Memoirs",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Mukta",
            "value": "Mukta",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Mukta Mahee",
            "value": "Mukta Mahee",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Mukta Malar",
            "value": "Mukta Malar",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Mukta Vaani",
            "value": "Mukta Vaani",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Mulish",
            "value": "Mulish",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Murecho",
            "value": "Murecho",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "NTR",
            "value": "NTR",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Nanum Gothic",
            "value": "Nanum Gothic",
            "variants": [
                "regular",
                "700",
                "800"
            ]
        },
        {
            "label": "News Cycle",
            "value": "News Cycle",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "Niramit",
            "value": "Niramit",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Nobile",
            "value": "Nobile",
            "variants": [
                "regular",
                "italic",
                "500",
                "500italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Nokora",
            "value": "Nokora",
            "variants": [
                "100",
                "300",
                "regular",
                "700",
                "900"
            ]
        },
        {
            "label": "Notable",
            "value": "Notable",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Color Emoji",
            "value": "Noto Color Emoji",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Emoji",
            "value": "Noto Emoji",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Noto Kufi Arabic",
            "value": "Noto Kufi Arabic",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Music",
            "value": "Noto Music",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans",
            "value": "Noto Sans",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Noto Sans Adlam",
            "value": "Noto Sans Adlam",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Noto Sans Adlam Unjoined",
            "value": "Noto Sans Adlam Unjoined",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Noto Sans Anatolian Hieroglyphs",
            "value": "Noto Sans Anatolian Hieroglyphs",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Arabic",
            "value": "Noto Sans Arabic",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Armenian",
            "value": "Noto Sans Armenian",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Avestan",
            "value": "Noto Sans Avestan",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Balinese",
            "value": "Noto Sans Balinese",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Noto Sans Bamum",
            "value": "Noto Sans Bamum",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Noto Sans Bassa Vah",
            "value": "Noto Sans Bassa Vah",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Noto Sans Batak",
            "value": "Noto Sans Batak",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Bengali",
            "value": "Noto Sans Bengali",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Bhaiksuki",
            "value": "Noto Sans Bhaiksuki",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Brahmi",
            "value": "Noto Sans Brahmi",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Buginese",
            "value": "Noto Sans Buginese",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Buhid",
            "value": "Noto Sans Buhid",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Canadian Aboriginal",
            "value": "Noto Sans Canadian Aboriginal",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Carian",
            "value": "Noto Sans Carian",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Caucasian Albanian",
            "value": "Noto Sans Caucasian Albanian",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Chakma",
            "value": "Noto Sans Chakma",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Cham",
            "value": "Noto Sans Cham",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Cherokee",
            "value": "Noto Sans Cherokee",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Coptic",
            "value": "Noto Sans Coptic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Cuneiform",
            "value": "Noto Sans Cuneiform",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Cypriot",
            "value": "Noto Sans Cypriot",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Deseret",
            "value": "Noto Sans Deseret",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Devanagari",
            "value": "Noto Sans Devanagari",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Display",
            "value": "Noto Sans Display",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Noto Sans Duployan",
            "value": "Noto Sans Duployan",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Egyptian Hieroglyphs",
            "value": "Noto Sans Egyptian Hieroglyphs",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Elbasan",
            "value": "Noto Sans Elbasan",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Elymaic",
            "value": "Noto Sans Elymaic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Ethiopic",
            "value": "Noto Sans Ethiopic",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Georgian",
            "value": "Noto Sans Georgian",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Glagolitic",
            "value": "Noto Sans Glagolitic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Gothic",
            "value": "Noto Sans Gothic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Grantha",
            "value": "Noto Sans Grantha",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Gujarati",
            "value": "Noto Sans Gujarati",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Gunjala Gondi",
            "value": "Noto Sans Gunjala Gondi",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Gurmukhi",
            "value": "Noto Sans Gurmukhi",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans HK",
            "value": "Noto Sans HK",
            "variants": [
                "100",
                "300",
                "regular",
                "500",
                "700",
                "900"
            ]
        },
        {
            "label": "Noto Sans Hanifi Rohingya",
            "value": "Noto Sans Hanifi Rohingya",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Noto Sans Hanunoo",
            "value": "Noto Sans Hanunoo",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Hatran",
            "value": "Noto Sans Hatran",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Hebrew",
            "value": "Noto Sans Hebrew",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Imperial Aramaic",
            "value": "Noto Sans Imperial Aramaic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Indic Siyaq Numbers",
            "value": "Noto Sans Indic Siyaq Numbers",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Inscriptional Pahlavi",
            "value": "Noto Sans Inscriptional Pahlavi",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Inscriptional Parthian",
            "value": "Noto Sans Inscriptional Parthian",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans JP",
            "value": "Noto Sans JP",
            "variants": [
                "100",
                "300",
                "regular",
                "500",
                "700",
                "900"
            ]
        },
        {
            "label": "Noto Sans Javanese",
            "value": "Noto Sans Javanese",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Noto Sans KR",
            "value": "Noto Sans KR",
            "variants": [
                "100",
                "300",
                "regular",
                "500",
                "700",
                "900"
            ]
        },
        {
            "label": "Noto Sans Kaithi",
            "value": "Noto Sans Kaithi",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Kannada",
            "value": "Noto Sans Kannada",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Kayah Li",
            "value": "Noto Sans Kayah Li",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Noto Sans Kharoshthi",
            "value": "Noto Sans Kharoshthi",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Khmer",
            "value": "Noto Sans Khmer",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Khojki",
            "value": "Noto Sans Khojki",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Khudawadi",
            "value": "Noto Sans Khudawadi",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Lao",
            "value": "Noto Sans Lao",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Lao Looped",
            "value": "Noto Sans Lao Looped",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Lepcha",
            "value": "Noto Sans Lepcha",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Limbu",
            "value": "Noto Sans Limbu",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Linear A",
            "value": "Noto Sans Linear A",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Linear B",
            "value": "Noto Sans Linear B",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Lisu",
            "value": "Noto Sans Lisu",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Noto Sans Lycian",
            "value": "Noto Sans Lycian",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Lydian",
            "value": "Noto Sans Lydian",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Mahajani",
            "value": "Noto Sans Mahajani",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Malayalam",
            "value": "Noto Sans Malayalam",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Mandaic",
            "value": "Noto Sans Mandaic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Manichaean",
            "value": "Noto Sans Manichaean",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Marchen",
            "value": "Noto Sans Marchen",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Masaram Gondi",
            "value": "Noto Sans Masaram Gondi",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Math",
            "value": "Noto Sans Math",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Mayan Numerals",
            "value": "Noto Sans Mayan Numerals",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Medefaidrin",
            "value": "Noto Sans Medefaidrin",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Noto Sans Meetei Mayek",
            "value": "Noto Sans Meetei Mayek",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Mende Kikakui",
            "value": "Noto Sans Mende Kikakui",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Meroitic",
            "value": "Noto Sans Meroitic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Miao",
            "value": "Noto Sans Miao",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Modi",
            "value": "Noto Sans Modi",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Mongolian",
            "value": "Noto Sans Mongolian",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Mro",
            "value": "Noto Sans Mro",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Multani",
            "value": "Noto Sans Multani",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Myanmar",
            "value": "Noto Sans Myanmar",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans N Ko",
            "value": "Noto Sans N Ko",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Nabataean",
            "value": "Noto Sans Nabataean",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans New Tai Lue",
            "value": "Noto Sans New Tai Lue",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Noto Sans Newa",
            "value": "Noto Sans Newa",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Nushu",
            "value": "Noto Sans Nushu",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Ogham",
            "value": "Noto Sans Ogham",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Ol Chiki",
            "value": "Noto Sans Ol Chiki",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Noto Sans Old Hungarian",
            "value": "Noto Sans Old Hungarian",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Old Italic",
            "value": "Noto Sans Old Italic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Old North Arabian",
            "value": "Noto Sans Old North Arabian",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Old Permic",
            "value": "Noto Sans Old Permic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Old Persian",
            "value": "Noto Sans Old Persian",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Old Sogdian",
            "value": "Noto Sans Old Sogdian",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Old South Arabian",
            "value": "Noto Sans Old South Arabian",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Old Turkic",
            "value": "Noto Sans Old Turkic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Oriya",
            "value": "Noto Sans Oriya",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Osage",
            "value": "Noto Sans Osage",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Osmanya",
            "value": "Noto Sans Osmanya",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Pahawh Hmong",
            "value": "Noto Sans Pahawh Hmong",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Palmyrene",
            "value": "Noto Sans Palmyrene",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Pau Cin Hau",
            "value": "Noto Sans Pau Cin Hau",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Phags Pa",
            "value": "Noto Sans Phags Pa",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Phoenician",
            "value": "Noto Sans Phoenician",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Psalter Pahlavi",
            "value": "Noto Sans Psalter Pahlavi",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Rejang",
            "value": "Noto Sans Rejang",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Runic",
            "value": "Noto Sans Runic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans SC",
            "value": "Noto Sans SC",
            "variants": [
                "100",
                "300",
                "regular",
                "500",
                "700",
                "900"
            ]
        },
        {
            "label": "Noto Sans Samaritan",
            "value": "Noto Sans Samaritan",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Saurashtra",
            "value": "Noto Sans Saurashtra",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Sharada",
            "value": "Noto Sans Sharada",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Shavian",
            "value": "Noto Sans Shavian",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Siddham",
            "value": "Noto Sans Siddham",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans SignWriting",
            "value": "Noto Sans SignWriting",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Sinhala",
            "value": "Noto Sans Sinhala",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Sogdian",
            "value": "Noto Sans Sogdian",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Sora Sompeng",
            "value": "Noto Sans Sora Sompeng",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Noto Sans Soyombo",
            "value": "Noto Sans Soyombo",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Sundanese",
            "value": "Noto Sans Sundanese",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Noto Sans Syloti Nagri",
            "value": "Noto Sans Syloti Nagri",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Symbols",
            "value": "Noto Sans Symbols",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Symbols 2",
            "value": "Noto Sans Symbols 2",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Syriac",
            "value": "Noto Sans Syriac",
            "variants": [
                "100",
                "regular",
                "900"
            ]
        },
        {
            "label": "Noto Sans TC",
            "value": "Noto Sans TC",
            "variants": [
                "100",
                "300",
                "regular",
                "500",
                "700",
                "900"
            ]
        },
        {
            "label": "Noto Sans Tagalog",
            "value": "Noto Sans Tagalog",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Tagbanwa",
            "value": "Noto Sans Tagbanwa",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Tai Le",
            "value": "Noto Sans Tai Le",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Tai Tham",
            "value": "Noto Sans Tai Tham",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Noto Sans Tai Viet",
            "value": "Noto Sans Tai Viet",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Takri",
            "value": "Noto Sans Takri",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Tamil",
            "value": "Noto Sans Tamil",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Tamil Supplement",
            "value": "Noto Sans Tamil Supplement",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Tangsa",
            "value": "Noto Sans Tangsa",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Noto Sans Telugu",
            "value": "Noto Sans Telugu",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Thaana",
            "value": "Noto Sans Thaana",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Thai",
            "value": "Noto Sans Thai",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Thai Looped",
            "value": "Noto Sans Thai Looped",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Noto Sans Tifinagh",
            "value": "Noto Sans Tifinagh",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Tirhuta",
            "value": "Noto Sans Tirhuta",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Ugaritic",
            "value": "Noto Sans Ugaritic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Vai",
            "value": "Noto Sans Vai",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Wancho",
            "value": "Noto Sans Wancho",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Warang Citi",
            "value": "Noto Sans Warang Citi",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Yi",
            "value": "Noto Sans Yi",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Sans Zanabazar Square",
            "value": "Noto Sans Zanabazar Square",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Noto Traditional Nushu",
            "value": "Noto Traditional Nushu",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Numans",
            "value": "Numans",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Nunito",
            "value": "Nunito",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Nunito Sans",
            "value": "Nunito Sans",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Open Sans",
            "value": "Open Sans",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic"
            ]
        },
        {
            "label": "Orbitron",
            "value": "Orbitron",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Orienta",
            "value": "Orienta",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Oswald",
            "value": "Oswald",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Outfit",
            "value": "Outfit",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Overpass",
            "value": "Overpass",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Oxygen",
            "value": "Oxygen",
            "variants": [
                "300",
                "regular",
                "700"
            ]
        },
        {
            "label": "PT Sans",
            "value": "PT Sans",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "PT Sans Caption",
            "value": "PT Sans Caption",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "PT Sans Narrow",
            "value": "PT Sans Narrow",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "Padauk",
            "value": "Padauk",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "Palanquin",
            "value": "Palanquin",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Palanquin Dark",
            "value": "Palanquin Dark",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Pathway Gothic One",
            "value": "Pathway Gothic One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Pattaya",
            "value": "Pattaya",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Pavanam",
            "value": "Pavanam",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Paytone One",
            "value": "Paytone One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Philosopher",
            "value": "Philosopher",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Play",
            "value": "Play",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "Plus Jakarta Sans",
            "value": "Plus Jakarta Sans",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic"
            ]
        },
        {
            "label": "Pontano Sans",
            "value": "Pontano Sans",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Poppins",
            "value": "Poppins",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Port Lligat Sans",
            "value": "Port Lligat Sans",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Pragati Narrow",
            "value": "Pragati Narrow",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "Preahvihear",
            "value": "Preahvihear",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Prompt",
            "value": "Prompt",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Proza Libre",
            "value": "Proza Libre",
            "variants": [
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic"
            ]
        },
        {
            "label": "Public Sans",
            "value": "Public Sans",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Puritan",
            "value": "Puritan",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Qahiri",
            "value": "Qahiri",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Quantico",
            "value": "Quantico",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Quattrocento Sans",
            "value": "Quattrocento Sans",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Questrial",
            "value": "Questrial",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Quicksand",
            "value": "Quicksand",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Radio Canada",
            "value": "Radio Canada",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "label": "Rajdhani",
            "value": "Rajdhani",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Raleway",
            "value": "Raleway",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Ramabhadra",
            "value": "Ramabhadra",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Rambla",
            "value": "Rambla",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Rationale",
            "value": "Rationale",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Readex Pro",
            "value": "Readex Pro",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Recursive",
            "value": "Recursive",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Red Hat Display",
            "value": "Red Hat Display",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Red Hat Text",
            "value": "Red Hat Text",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "label": "Reem Kufi",
            "value": "Reem Kufi",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Reem Kufi Fun",
            "value": "Reem Kufi Fun",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Reem Kufi Ink",
            "value": "Reem Kufi Ink",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Roboto",
            "value": "Roboto",
            "variants": [
                "100",
                "100italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "700",
                "700italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Roboto Condensed",
            "value": "Roboto Condensed",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Roboto Flex",
            "value": "Roboto Flex",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "RocknRoll One",
            "value": "RocknRoll One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Ropa Sans",
            "value": "Ropa Sans",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "label": "Rosario",
            "value": "Rosario",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "label": "Rubik",
            "value": "Rubik",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Rubik Mono One",
            "value": "Rubik Mono One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Ruda",
            "value": "Ruda",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Ruluko",
            "value": "Ruluko",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Rum Raisin",
            "value": "Rum Raisin",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Russo One",
            "value": "Russo One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Saira",
            "value": "Saira",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Saira Condensed",
            "value": "Saira Condensed",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Saira Extra Condensed",
            "value": "Saira Extra Condensed",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Saira Semi Condensed",
            "value": "Saira Semi Condensed",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Sansita",
            "value": "Sansita",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Sarabun",
            "value": "Sarabun",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic"
            ]
        },
        {
            "label": "Sarala",
            "value": "Sarala",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "Sarpanch",
            "value": "Sarpanch",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Sawarabi Gothic",
            "value": "Sawarabi Gothic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Scada",
            "value": "Scada",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Secular One",
            "value": "Secular One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Sen",
            "value": "Sen",
            "variants": [
                "regular",
                "700",
                "800"
            ]
        },
        {
            "label": "Seymour One",
            "value": "Seymour One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Shanti",
            "value": "Shanti",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Share Tech",
            "value": "Share Tech",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Shippori Antique",
            "value": "Shippori Antique",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Shippori Antique B1",
            "value": "Shippori Antique B1",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Signika",
            "value": "Signika",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Signika Negative",
            "value": "Signika Negative",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Sintony",
            "value": "Sintony",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "Six Caps",
            "value": "Six Caps",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Smooch Sans",
            "value": "Smooch Sans",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Snippet",
            "value": "Snippet",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Sofia Sans",
            "value": "Sofia Sans",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Sofia Sans Condensed",
            "value": "Sofia Sans Condensed",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Sofia Sans Extra Condensed",
            "value": "Sofia Sans Extra Condensed",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Sofia Sans Semi Condensed",
            "value": "Sofia Sans Semi Condensed",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Sono",
            "value": "Sono",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Sora",
            "value": "Sora",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Source Sans 3",
            "value": "Source Sans 3",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Source Sans Pro",
            "value": "Source Sans Pro",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Space Grotesk",
            "value": "Space Grotesk",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Spinnaker",
            "value": "Spinnaker",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Spline Sans",
            "value": "Spline Sans",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Stick",
            "value": "Stick",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Stick No Bills",
            "value": "Stick No Bills",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Strait",
            "value": "Strait",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Stylish",
            "value": "Stylish",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Sulphur Point",
            "value": "Sulphur Point",
            "variants": [
                "300",
                "regular",
                "700"
            ]
        },
        {
            "label": "Sunflower",
            "value": "Sunflower",
            "variants": [
                "300",
                "500",
                "700"
            ]
        },
        {
            "label": "Syncopate",
            "value": "Syncopate",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "label": "Syne",
            "value": "Syne",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Tajawal",
            "value": "Tajawal",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Tauri",
            "value": "Tauri",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Teko",
            "value": "Teko",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Telex",
            "value": "Telex",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Tenali Ramakrishna",
            "value": "Tenali Ramakrishna",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Tenor Sans",
            "value": "Tenor Sans",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Text Me One",
            "value": "Text Me One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Thasadith",
            "value": "Thasadith",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Timmana",
            "value": "Timmana",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Titillium Web",
            "value": "Titillium Web",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "900"
            ]
        },
        {
            "label": "Tomorrow",
            "value": "Tomorrow",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "label": "Trispace",
            "value": "Trispace",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "label": "Truculenta",
            "value": "Truculenta",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Ubuntu",
            "value": "Ubuntu",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "700",
                "700italic"
            ]
        },
        {
            "label": "Ubuntu Condensed",
            "value": "Ubuntu Condensed",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Urbanist",
            "value": "Urbanist",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Varela",
            "value": "Varela",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Varela Round",
            "value": "Varela Round",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Varta",
            "value": "Varta",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Vazirmatn",
            "value": "Vazirmatn",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "label": "Viga",
            "value": "Viga",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Voltaire",
            "value": "Voltaire",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Wendy One",
            "value": "Wendy One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Wire One",
            "value": "Wire One",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Work Sans",
            "value": "Work Sans",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "label": "Yaldevi",
            "value": "Yaldevi",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Yanone Kaffeesatz",
            "value": "Yanone Kaffeesatz",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "label": "Yantramanav",
            "value": "Yantramanav",
            "variants": [
                "100",
                "300",
                "regular",
                "500",
                "700",
                "900"
            ]
        },
        {
            "label": "Yusei Magic",
            "value": "Yusei Magic",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "ZCOOL KuaiLe",
            "value": "ZCOOL KuaiLe",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "ZCOOL QingKe HuangYou",
            "value": "ZCOOL QingKe HuangYou",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "ZCOOL XiaoWei",
            "value": "ZCOOL XiaoWei",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Zen Kaku Gothic Antique",
            "value": "Zen Kaku Gothic Antique",
            "variants": [
                "300",
                "regular",
                "500",
                "700",
                "900"
            ]
        },
        {
            "label": "Zen Kaku Gothic New",
            "value": "Zen Kaku Gothic New",
            "variants": [
                "300",
                "regular",
                "500",
                "700",
                "900"
            ]
        },
        {
            "label": "Zen Kurenaido",
            "value": "Zen Kurenaido",
            "variants": [
                "regular"
            ]
        },
        {
            "label": "Zen Maru Gothic",
            "value": "Zen Maru Gothic",
            "variants": [
                "300",
                "regular",
                "500",
                "700",
                "900"
            ]
        }
    ];
}
var fonts = {
    "sans-serif": [
        {
            "font": "ABeeZee",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Abel",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Aclonica",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Acme",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Actor",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Advent Pro",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Akshar",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Alata",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Alatsi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Albert Sans",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Aldrich",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Alef",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Alegreya Sans",
            "variants": [
                "100",
                "100italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Alegreya Sans SC",
            "variants": [
                "100",
                "100italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Alexandria",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Allerta",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Allerta Stencil",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Almarai",
            "variants": [
                "300",
                "regular",
                "700",
                "800"
            ]
        },
        {
            "font": "Alumni Sans",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Alumni Sans Collegiate One",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Alumni Sans Pinstripe",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Amaranth",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Amiko",
            "variants": [
                "regular",
                "600",
                "700"
            ]
        },
        {
            "font": "Anaheim",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Andika",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Anek Bangla",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Anek Devanagari",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Anek Gujarati",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Anek Gurmukhi",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Anek Kannada",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Anek Latin",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Anek Malayalam",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Anek Odia",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Anek Tamil",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Anek Telugu",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Antic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Anton",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Antonio",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Archivo",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Archivo Black",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Archivo Narrow",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Arimo",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Armata",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Arsenal",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Arya",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Asap",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Asap Condensed",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Assistant",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Asul",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Athiti",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Atkinson Hyperlegible",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Average Sans",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "B612",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "BIZ UDGothic",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "BIZ UDPGothic",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Bai Jamjuree",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Barlow",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Barlow Condensed",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Barlow Semi Condensed",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Basic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bayon",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Be Vietnam Pro",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Belleza",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "BenchNine",
            "variants": [
                "300",
                "regular",
                "700"
            ]
        },
        {
            "font": "Biryani",
            "variants": [
                "200",
                "300",
                "regular",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Black And White Picture",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Black Han Sans",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Blinker",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Bubbler One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Cabin",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Cabin Condensed",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Cagliostro",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Cairo",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Cambay",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Candal",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Cantarell",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Cantora One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Capriola",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Carme",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Carrois Gothic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Carrois Gothic SC",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Catamaran",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Chakra Petch",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Changa",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Chathura",
            "variants": [
                "100",
                "300",
                "regular",
                "700",
                "800"
            ]
        },
        {
            "font": "Chau Philomene One",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Chivo",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Coda Caption",
            "variants": [
                "800"
            ]
        },
        {
            "font": "Commissioner",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Convergence",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Cuprum",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "DM Sans",
            "variants": [
                "regular",
                "italic",
                "500",
                "500italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Darker Grotesque",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Days One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Denk One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Dhurjati",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Didact Gothic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Do Hyeon",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Dongle",
            "variants": [
                "300",
                "regular",
                "700"
            ]
        },
        {
            "font": "Doppio One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Dorsa",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Dosis",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "DotGothic16",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Duru Sans",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Economica",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "El Messiri",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Electrolize",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Encode Sans",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Encode Sans Condensed",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Encode Sans Expanded",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Encode Sans SC",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Encode Sans Semi Condensed",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Encode Sans Semi Expanded",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Englebert",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Epilogue",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Exo",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Exo 2",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Fahkwang",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Familjen Grotesk",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Farro",
            "variants": [
                "300",
                "regular",
                "500",
                "700"
            ]
        },
        {
            "font": "Federo",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Figtree",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Finlandica",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Fira Sans",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Fira Sans Condensed",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Fira Sans Extra Condensed",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Fjalla One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Francois One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Fredoka",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Fresca",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "GFS Neohellenic",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Gafata",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Galdeano",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Gantari",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Gayathri",
            "variants": [
                "100",
                "regular",
                "700"
            ]
        },
        {
            "font": "Gemunu Libre",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Genos",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Geo",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Georama",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Gidugu",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Glory",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic"
            ]
        },
        {
            "font": "Gothic A1",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Gotu",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Gowun Dodum",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Gudea",
            "variants": [
                "regular",
                "italic",
                "700"
            ]
        },
        {
            "font": "Hammersmith One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Hanken Grotesk",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Harmattan",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Heebo",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Hind",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Hind Guntur",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Hind Madurai",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Hind Siliguri",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Hind Vadodara",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Homenaje",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "IBM Plex Sans",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "IBM Plex Sans Arabic",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "IBM Plex Sans Condensed",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "IBM Plex Sans Devanagari",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "IBM Plex Sans Hebrew",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "IBM Plex Sans JP",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "IBM Plex Sans KR",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "IBM Plex Sans Thai",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "IBM Plex Sans Thai Looped",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Imprima",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Inder",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Inria Sans",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Inter",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Inter Tight",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Istok Web",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Jaldi",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Jockey One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Josefin Sans",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Jost",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Jua",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Julius Sans One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Jura",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "K2D",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic"
            ]
        },
        {
            "font": "Kanit",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Kantumruy",
            "variants": [
                "300",
                "regular",
                "700"
            ]
        },
        {
            "font": "Kantumruy Pro",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Karla",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic"
            ]
        },
        {
            "font": "Kdam Thmor Pro",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Khand",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Khula",
            "variants": [
                "300",
                "regular",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Kite One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "KoHo",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Kodchasan",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Kosugi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Kosugi Maru",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Krona One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Krub",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Kufam",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Kulim Park",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Kumbh Sans",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Laila",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Lato",
            "variants": [
                "100",
                "100italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "700",
                "700italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "League Gothic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "League Spartan",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Lekton",
            "variants": [
                "regular",
                "italic",
                "700"
            ]
        },
        {
            "font": "Lexend",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Lexend Deca",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Lexend Exa",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Lexend Giga",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Lexend Mega",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Lexend Peta",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Lexend Tera",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Lexend Zetta",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Libre Franklin",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Livvic",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "M PLUS 1",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "M PLUS 1 Code",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "M PLUS 1p",
            "variants": [
                "100",
                "300",
                "regular",
                "500",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "M PLUS 2",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "M PLUS Code Latin",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "M PLUS Rounded 1c",
            "variants": [
                "100",
                "300",
                "regular",
                "500",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Mada",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "900"
            ]
        },
        {
            "font": "Magra",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Mako",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Mallanna",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Mandali",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Manjari",
            "variants": [
                "100",
                "regular",
                "700"
            ]
        },
        {
            "font": "Manrope",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Marmelad",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Martel Sans",
            "variants": [
                "200",
                "300",
                "regular",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Marvel",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Maven Pro",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Meera Inimai",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Merriweather Sans",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic"
            ]
        },
        {
            "font": "Metrophobic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Michroma",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Mina",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Mingzat",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Miriam Libre",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Mitr",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Mochiy Pop One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Mochiy Pop P One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Mohave",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Molengo",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Monda",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Montserrat",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Montserrat Alternates",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Montserrat Subrayada",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Mouse Memoirs",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Mukta",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Mukta Mahee",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Mukta Malar",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Mukta Vaani",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Mulish",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Murecho",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "NTR",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Nanum Gothic",
            "variants": [
                "regular",
                "700",
                "800"
            ]
        },
        {
            "font": "News Cycle",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Niramit",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Nobile",
            "variants": [
                "regular",
                "italic",
                "500",
                "500italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Nokora",
            "variants": [
                "100",
                "300",
                "regular",
                "700",
                "900"
            ]
        },
        {
            "font": "Notable",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Color Emoji",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Emoji",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Kufi Arabic",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Music",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Noto Sans Adlam",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Sans Adlam Unjoined",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Sans Anatolian Hieroglyphs",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Arabic",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Armenian",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Avestan",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Balinese",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Sans Bamum",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Sans Bassa Vah",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Sans Batak",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Bengali",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Bhaiksuki",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Brahmi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Buginese",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Buhid",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Canadian Aboriginal",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Carian",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Caucasian Albanian",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Chakma",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Cham",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Cherokee",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Coptic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Cuneiform",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Cypriot",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Deseret",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Devanagari",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Display",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Noto Sans Duployan",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Egyptian Hieroglyphs",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Elbasan",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Elymaic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Ethiopic",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Georgian",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Glagolitic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Gothic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Grantha",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Gujarati",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Gunjala Gondi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Gurmukhi",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans HK",
            "variants": [
                "100",
                "300",
                "regular",
                "500",
                "700",
                "900"
            ]
        },
        {
            "font": "Noto Sans Hanifi Rohingya",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Sans Hanunoo",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Hatran",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Hebrew",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Imperial Aramaic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Indic Siyaq Numbers",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Inscriptional Pahlavi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Inscriptional Parthian",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans JP",
            "variants": [
                "100",
                "300",
                "regular",
                "500",
                "700",
                "900"
            ]
        },
        {
            "font": "Noto Sans Javanese",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Sans KR",
            "variants": [
                "100",
                "300",
                "regular",
                "500",
                "700",
                "900"
            ]
        },
        {
            "font": "Noto Sans Kaithi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Kannada",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Kayah Li",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Sans Kharoshthi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Khmer",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Khojki",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Khudawadi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Lao",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Lao Looped",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Lepcha",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Limbu",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Linear A",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Linear B",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Lisu",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Sans Lycian",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Lydian",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Mahajani",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Malayalam",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Mandaic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Manichaean",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Marchen",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Masaram Gondi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Math",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Mayan Numerals",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Medefaidrin",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Sans Meetei Mayek",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Mende Kikakui",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Meroitic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Miao",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Modi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Mongolian",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Mro",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Multani",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Myanmar",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans N Ko",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Nabataean",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans New Tai Lue",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Sans Newa",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Nushu",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Ogham",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Ol Chiki",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Sans Old Hungarian",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Old Italic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Old North Arabian",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Old Permic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Old Persian",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Old Sogdian",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Old South Arabian",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Old Turkic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Oriya",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Osage",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Osmanya",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Pahawh Hmong",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Palmyrene",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Pau Cin Hau",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Phags Pa",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Phoenician",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Psalter Pahlavi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Rejang",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Runic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans SC",
            "variants": [
                "100",
                "300",
                "regular",
                "500",
                "700",
                "900"
            ]
        },
        {
            "font": "Noto Sans Samaritan",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Saurashtra",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Sharada",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Shavian",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Siddham",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans SignWriting",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Sinhala",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Sogdian",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Sora Sompeng",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Sans Soyombo",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Sundanese",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Sans Syloti Nagri",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Symbols",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Symbols 2",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Syriac",
            "variants": [
                "100",
                "regular",
                "900"
            ]
        },
        {
            "font": "Noto Sans TC",
            "variants": [
                "100",
                "300",
                "regular",
                "500",
                "700",
                "900"
            ]
        },
        {
            "font": "Noto Sans Tagalog",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Tagbanwa",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Tai Le",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Tai Tham",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Sans Tai Viet",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Takri",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Tamil",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Tamil Supplement",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Tangsa",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Sans Telugu",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Thaana",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Thai",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Thai Looped",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Sans Tifinagh",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Tirhuta",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Ugaritic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Vai",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Wancho",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Warang Citi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Yi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Sans Zanabazar Square",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Traditional Nushu",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Numans",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Nunito",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Nunito Sans",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Open Sans",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic"
            ]
        },
        {
            "font": "Orbitron",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Orienta",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Oswald",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Outfit",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Overpass",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Oxygen",
            "variants": [
                "300",
                "regular",
                "700"
            ]
        },
        {
            "font": "PT Sans",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "PT Sans Caption",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "PT Sans Narrow",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Padauk",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Palanquin",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Palanquin Dark",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Pathway Gothic One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Pattaya",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Pavanam",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Paytone One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Philosopher",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Play",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Plus Jakarta Sans",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic"
            ]
        },
        {
            "font": "Pontano Sans",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Poppins",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Port Lligat Sans",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Pragati Narrow",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Preahvihear",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Prompt",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Proza Libre",
            "variants": [
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic"
            ]
        },
        {
            "font": "Public Sans",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Puritan",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Qahiri",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Quantico",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Quattrocento Sans",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Questrial",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Quicksand",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Radio Canada",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Rajdhani",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Raleway",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Ramabhadra",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rambla",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Rationale",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Readex Pro",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Recursive",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Red Hat Display",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Red Hat Text",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Reem Kufi",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Reem Kufi Fun",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Reem Kufi Ink",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Roboto",
            "variants": [
                "100",
                "100italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "700",
                "700italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Roboto Condensed",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Roboto Flex",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "RocknRoll One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ropa Sans",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Rosario",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Rubik",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Rubik Mono One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ruda",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Ruluko",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rum Raisin",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Russo One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Saira",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Saira Condensed",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Saira Extra Condensed",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Saira Semi Condensed",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Sansita",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Sarabun",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic"
            ]
        },
        {
            "font": "Sarala",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Sarpanch",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Sawarabi Gothic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Scada",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Secular One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sen",
            "variants": [
                "regular",
                "700",
                "800"
            ]
        },
        {
            "font": "Seymour One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Shanti",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Share Tech",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Shippori Antique",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Shippori Antique B1",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Signika",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Signika Negative",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Sintony",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Six Caps",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Smooch Sans",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Snippet",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sofia Sans",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Sofia Sans Condensed",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Sofia Sans Extra Condensed",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Sofia Sans Semi Condensed",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Sono",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Sora",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Source Sans 3",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Source Sans Pro",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Space Grotesk",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Spinnaker",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Spline Sans",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Stick",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Stick No Bills",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Strait",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Stylish",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sulphur Point",
            "variants": [
                "300",
                "regular",
                "700"
            ]
        },
        {
            "font": "Sunflower",
            "variants": [
                "300",
                "500",
                "700"
            ]
        },
        {
            "font": "Syncopate",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Syne",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Tajawal",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Tauri",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Teko",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Telex",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Tenali Ramakrishna",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Tenor Sans",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Text Me One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Thasadith",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Timmana",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Titillium Web",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "900"
            ]
        },
        {
            "font": "Tomorrow",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Trispace",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Truculenta",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Ubuntu",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Ubuntu Condensed",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Urbanist",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Varela",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Varela Round",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Varta",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Vazirmatn",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Viga",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Voltaire",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Wendy One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Wire One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Work Sans",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Yaldevi",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Yanone Kaffeesatz",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Yantramanav",
            "variants": [
                "100",
                "300",
                "regular",
                "500",
                "700",
                "900"
            ]
        },
        {
            "font": "Yusei Magic",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "ZCOOL KuaiLe",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "ZCOOL QingKe HuangYou",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "ZCOOL XiaoWei",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Zen Kaku Gothic Antique",
            "variants": [
                "300",
                "regular",
                "500",
                "700",
                "900"
            ]
        },
        {
            "font": "Zen Kaku Gothic New",
            "variants": [
                "300",
                "regular",
                "500",
                "700",
                "900"
            ]
        },
        {
            "font": "Zen Kurenaido",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Zen Maru Gothic",
            "variants": [
                "300",
                "regular",
                "500",
                "700",
                "900"
            ]
        }
    ],
    "serif": [
        {
            "font": "Abhaya Libre",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Abyssinica SIL",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Adamina",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Alegreya",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Alegreya SC",
            "variants": [
                "regular",
                "italic",
                "500",
                "500italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Aleo",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Alice",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Alike",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Alike Angular",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Alkalami",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Almendra",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Almendra SC",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Amethysta",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Amiri",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Amiri Quran",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Andada Pro",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic"
            ]
        },
        {
            "font": "Antic Didone",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Antic Slab",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Arapey",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Arbutus Slab",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Aref Ruqaa",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Aref Ruqaa Ink",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Artifika",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Arvo",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Asar",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Average",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "BIZ UDMincho",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "BIZ UDPMincho",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Balthazar",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Baskervville",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Belgrano",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bellefair",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Benne",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bentham",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Besley",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "BioRhyme",
            "variants": [
                "200",
                "300",
                "regular",
                "700",
                "800"
            ]
        },
        {
            "font": "BioRhyme Expanded",
            "variants": [
                "200",
                "300",
                "regular",
                "700",
                "800"
            ]
        },
        {
            "font": "Bitter",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Bodoni Moda",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Bona Nova",
            "variants": [
                "regular",
                "italic",
                "700"
            ]
        },
        {
            "font": "Brawler",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Bree Serif",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Brygada 1918",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Buenard",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Caladea",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Cambo",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Cantata One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Cardo",
            "variants": [
                "regular",
                "italic",
                "700"
            ]
        },
        {
            "font": "Castoro",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Caudex",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Charis SIL",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Cinzel",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Copse",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Cormorant",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Cormorant Garamond",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Cormorant Infant",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Cormorant SC",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Cormorant Unicase",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Cormorant Upright",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Coustard",
            "variants": [
                "regular",
                "900"
            ]
        },
        {
            "font": "Crete Round",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Crimson Pro",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Crimson Text",
            "variants": [
                "regular",
                "italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Cutive",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "DM Serif Display",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "DM Serif Text",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "David Libre",
            "variants": [
                "regular",
                "500",
                "700"
            ]
        },
        {
            "font": "Della Respira",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Domine",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Donegal One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "EB Garamond",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic"
            ]
        },
        {
            "font": "Eczar",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Enriqueta",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Esteban",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Fanwood Text",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Fauna One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Faustina",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic"
            ]
        },
        {
            "font": "Fenix",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Fjord One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Frank Ruhl Libre",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Fraunces",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "GFS Didot",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Gabriela",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Gelasio",
            "variants": [
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Gentium Book Basic",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Gentium Book Plus",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Gentium Plus",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Gilda Display",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Glegoo",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Goudy Bookletter 1911",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Gowun Batang",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Grenze",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Gulzar",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Gupter",
            "variants": [
                "regular",
                "500",
                "700"
            ]
        },
        {
            "font": "Gurajada",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Habibi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Hahmlet",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Halant",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Hanuman",
            "variants": [
                "100",
                "300",
                "regular",
                "700",
                "900"
            ]
        },
        {
            "font": "Headland One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Hepta Slab",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Hina Mincho",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Holtwood One SC",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "IBM Plex Serif",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "IM Fell DW Pica",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "IM Fell DW Pica SC",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "IM Fell Double Pica",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "IM Fell Double Pica SC",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "IM Fell English",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "IM Fell English SC",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "IM Fell French Canon",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "IM Fell French Canon SC",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "IM Fell Great Primer",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "IM Fell Great Primer SC",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ibarra Real Nova",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Imbue",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Inika",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Inknut Antiqua",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Inria Serif",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Italiana",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Jacques Francois",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Joan",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Jomolhari",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Josefin Slab",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Judson",
            "variants": [
                "regular",
                "italic",
                "700"
            ]
        },
        {
            "font": "Junge",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Kadwa",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Kaisei Decol",
            "variants": [
                "regular",
                "500",
                "700"
            ]
        },
        {
            "font": "Kaisei HarunoUmi",
            "variants": [
                "regular",
                "500",
                "700"
            ]
        },
        {
            "font": "Kaisei Opti",
            "variants": [
                "regular",
                "500",
                "700"
            ]
        },
        {
            "font": "Kaisei Tokumin",
            "variants": [
                "regular",
                "500",
                "700",
                "800"
            ]
        },
        {
            "font": "Kameron",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Karma",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Kiwi Maru",
            "variants": [
                "300",
                "regular",
                "500"
            ]
        },
        {
            "font": "Kotta One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Kreon",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Kurale",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Lateef",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Ledger",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Libre Baskerville",
            "variants": [
                "regular",
                "italic",
                "700"
            ]
        },
        {
            "font": "Libre Bodoni",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Libre Caslon Display",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Libre Caslon Text",
            "variants": [
                "regular",
                "italic",
                "700"
            ]
        },
        {
            "font": "Linden Hill",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Literata",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Lora",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Lusitana",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Lustria",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Maitree",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Manuale",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic"
            ]
        },
        {
            "font": "Marcellus",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Marcellus SC",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Markazi Text",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Marko One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Martel",
            "variants": [
                "200",
                "300",
                "regular",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Mate",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Mate SC",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Merriweather",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "700",
                "700italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Montaga",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Montagu Slab",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Nanum Myeongjo",
            "variants": [
                "regular",
                "700",
                "800"
            ]
        },
        {
            "font": "Neuton",
            "variants": [
                "200",
                "300",
                "regular",
                "italic",
                "700",
                "800"
            ]
        },
        {
            "font": "New Tegomin",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Newsreader",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic"
            ]
        },
        {
            "font": "Noticia Text",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Noto Naskh Arabic",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Nastaliq Urdu",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Rashi Hebrew",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Serif",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Noto Serif Ahom",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Serif Armenian",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Serif Balinese",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Serif Bengali",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Serif Devanagari",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Serif Display",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Noto Serif Dogra",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Serif Ethiopic",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Serif Georgian",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Serif Grantha",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Serif Gujarati",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Serif Gurmukhi",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Serif HK",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Serif Hebrew",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Serif JP",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "900"
            ]
        },
        {
            "font": "Noto Serif KR",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "900"
            ]
        },
        {
            "font": "Noto Serif Kannada",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Serif Khmer",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Serif Khojki",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Serif Lao",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Serif Malayalam",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Serif Myanmar",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Serif NP Hmong",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Serif Nyiakeng Puachue Hmong",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Serif Oriya",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Serif SC",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "900"
            ]
        },
        {
            "font": "Noto Serif Sinhala",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Serif TC",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "900"
            ]
        },
        {
            "font": "Noto Serif Tamil",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Noto Serif Tangut",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Noto Serif Telugu",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Serif Thai",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Serif Tibetan",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Noto Serif Toto",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Noto Serif Yezidi",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Nuosu SIL",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Odor Mean Chey",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Old Standard TT",
            "variants": [
                "regular",
                "italic",
                "700"
            ]
        },
        {
            "font": "Oranienbaum",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ovo",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "PT Serif",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "PT Serif Caption",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Peddana",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Petrona",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Piazzolla",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Playfair Display",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Playfair Display SC",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Podkova",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Poly",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Port Lligat Slab",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Prata",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Pridi",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Prociono",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Quando",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Quattrocento",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Radley",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Ramaraja",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rasa",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Rhodium Libre",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Roboto Serif",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Roboto Slab",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Rokkitt",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Rosarivo",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Rozha One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rufina",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "STIX Two Text",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Sahitya",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Sanchez",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Sawarabi Mincho",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Scheherazade New",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Scope One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Shippori Mincho",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Shippori Mincho B1",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Slabo 13px",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Slabo 27px",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Solway",
            "variants": [
                "300",
                "regular",
                "500",
                "700",
                "800"
            ]
        },
        {
            "font": "Song Myung",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sorts Mill Goudy",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Source Serif 4",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Source Serif Pro",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Spectral",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic"
            ]
        },
        {
            "font": "Spectral SC",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic"
            ]
        },
        {
            "font": "Sree Krushnadevaraya",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Stoke",
            "variants": [
                "300",
                "regular"
            ]
        },
        {
            "font": "Suez One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sumana",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Sura",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Suranna",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Suravaram",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Suwannaphum",
            "variants": [
                "100",
                "300",
                "regular",
                "700",
                "900"
            ]
        },
        {
            "font": "Tai Heritage Pro",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Taviraj",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Texturina",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Tienne",
            "variants": [
                "regular",
                "700",
                "900"
            ]
        },
        {
            "font": "Tinos",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Tiro Bangla",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Tiro Devanagari Hindi",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Tiro Devanagari Marathi",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Tiro Devanagari Sanskrit",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Tiro Gurmukhi",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Tiro Kannada",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Tiro Tamil",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Tiro Telugu",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Trirong",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic",
                "800",
                "800italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Trocchi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Trykker",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Uchen",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ultra",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Unna",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Vesper Libre",
            "variants": [
                "regular",
                "500",
                "700",
                "900"
            ]
        },
        {
            "font": "Vidaloka",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Volkhov",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Vollkorn",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Vollkorn SC",
            "variants": [
                "regular",
                "600",
                "700",
                "900"
            ]
        },
        {
            "font": "Yrsa",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Yuji Boku",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Yuji Mai",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Yuji Syuku",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Zen Antique",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Zen Antique Soft",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Zen Old Mincho",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "900"
            ]
        },
        {
            "font": "Zilla Slab",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        }
    ],
    "display": [
        {
            "font": "Aboreto",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Abril Fatface",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Akaya Kanadaka",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Akaya Telivigala",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Akronim",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Alfa Slab One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Allan",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Almendra Display",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Alumni Sans Inline One",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Amarante",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Angkor",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Anybody",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Arbutus",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Arima",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Arima Madurai",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Asset",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Astloch",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Atma",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Atomic Age",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Aubrey",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Audiowide",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Autour One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Averia Gruesa Libre",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Averia Libre",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Averia Sans Libre",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Averia Serif Libre",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Bahiana",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bahianita",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bakbak One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Baloo 2",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Baloo Bhai 2",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Baloo Bhaijaan 2",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Baloo Bhaina 2",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Baloo Chettan 2",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Baloo Da 2",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Baloo Paaji 2",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Baloo Tamma 2",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Baloo Tammudu 2",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Baloo Thambi 2",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Balsamiq Sans",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Bangers",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Barriecito",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Barrio",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Battambang",
            "variants": [
                "100",
                "300",
                "regular",
                "700",
                "900"
            ]
        },
        {
            "font": "Baumans",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bebas Neue",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bellota",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Bellota Text",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Bevan",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "BhuTuka Expanded One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Big Shoulders Display",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Big Shoulders Inline Display",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Big Shoulders Inline Text",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Big Shoulders Stencil Display",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Big Shoulders Stencil Text",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Big Shoulders Text",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Bigelow Rules",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bigshot One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Black Ops One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Blaka",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Blaka Hollow",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Blaka Ink",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bokor",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Boogaloo",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bowlby One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bowlby One SC",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bubblegum Sans",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Buda",
            "variants": [
                "300"
            ]
        },
        {
            "font": "Bungee",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bungee Hairline",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bungee Inline",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bungee Outline",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bungee Shade",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bungee Spice",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Butcherman",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Cabin Sketch",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Caesar Dressing",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Cairo Play",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Calistoga",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Carter One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ceviche One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Changa One",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Chango",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Chela One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Chelsea Market",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Chenla",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Cherry Cream Soda",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Cherry Swash",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Chewy",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Chicle",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Chonburi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Cinzel Decorative",
            "variants": [
                "regular",
                "700",
                "900"
            ]
        },
        {
            "font": "Coda",
            "variants": [
                "regular",
                "800"
            ]
        },
        {
            "font": "Codystar",
            "variants": [
                "300",
                "regular"
            ]
        },
        {
            "font": "Coiny",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Combo",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Comfortaa",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Concert One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Content",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Contrail One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Corben",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Creepster",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Croissant One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Crushed",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Cute Font",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Dangrek",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Dela Gothic One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Diplomata",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Diplomata SC",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "DynaPuff",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Dynalight",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Eater",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Elsie",
            "variants": [
                "regular",
                "900"
            ]
        },
        {
            "font": "Elsie Swash Caps",
            "variants": [
                "regular",
                "900"
            ]
        },
        {
            "font": "Emblema One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Emilys Candy",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Erica One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ewert",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Expletus Sans",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Farsan",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Fascinate",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Fascinate Inline",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Faster One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Fasthand",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Federant",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Finger Paint",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Flamenco",
            "variants": [
                "300",
                "regular"
            ]
        },
        {
            "font": "Flavors",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Flow Block",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Flow Circular",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Flow Rounded",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Fontdiner Swanky",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Forum",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Freckle Face",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Fredericka the Great",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Fredoka One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Freehand",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Frijole",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Fruktur",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Fugaz One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Galada",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Galindo",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Geostar",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Geostar Fill",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Germania One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Gideon Roman",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Girassol",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Glass Antiqua",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Gluten",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Goblin One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Goldman",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Gorditas",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Graduate",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Grandstander",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Gravitas One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Grenze Gotisch",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Griffy",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Gruppo",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Gugi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Hanalei",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Hanalei Fill",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Happy Monkey",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Henny Penny",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Hubballi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Iceberg",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Iceland",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Irish Grover",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Jacques Francois Shadow",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Jolly Lodger",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Jomhuria",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Joti One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Karantina",
            "variants": [
                "300",
                "regular",
                "700"
            ]
        },
        {
            "font": "Katibeh",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Kavoon",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Keania One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Kelly Slab",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Kenia",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Khmer",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Kirang Haerang",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Knewave",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Koh Santepheap",
            "variants": [
                "100",
                "300",
                "regular",
                "700",
                "900"
            ]
        },
        {
            "font": "Koulen",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Kranky",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Kumar One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Kumar One Outline",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Lacquer",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Lalezar",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Lancelot",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Langar",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Lemon",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Lemonada",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Libre Barcode 128",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Libre Barcode 128 Text",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Libre Barcode 39",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Libre Barcode 39 Extended",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Libre Barcode 39 Extended Text",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Libre Barcode 39 Text",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Libre Barcode EAN13 Text",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Life Savers",
            "variants": [
                "regular",
                "700",
                "800"
            ]
        },
        {
            "font": "Lilita One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Lily Script One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Limelight",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Lobster",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Lobster Two",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Londrina Outline",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Londrina Shadow",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Londrina Sketch",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Londrina Solid",
            "variants": [
                "100",
                "300",
                "regular",
                "900"
            ]
        },
        {
            "font": "Love Ya Like A Sister",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Luckiest Guy",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Luxurious Roman",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Macondo",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Macondo Swash Caps",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Maiden Orange",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Margarine",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Marhey",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "McLaren",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "MedievalSharp",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Medula One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Megrim",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Metal",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Metal Mania",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Metamorphous",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Milonga",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Miltonian",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Miltonian Tattoo",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Miniver",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Mirza",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Modak",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Modern Antiqua",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Mogra",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Monofett",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Monoton",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Moo Lah Lah",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Moul",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Moulpali",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Mountains of Christmas",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "MuseoModerno",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Mystery Quest",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Nabla",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "New Rocker",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Nixie One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Nosifer",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Nova Cut",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Nova Flat",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Nova Oval",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Nova Round",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Nova Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Nova Slim",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Nova Square",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Odibee Sans",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Offside",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Oi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Oldenburg",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Oleo Script",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Oleo Script Swash Caps",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Oregano",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Orelega One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Original Surfer",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Overlock",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Overlock SC",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Oxanium",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Padyakke Expanded One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Paprika",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Passero One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Passion One",
            "variants": [
                "regular",
                "700",
                "900"
            ]
        },
        {
            "font": "Patua One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Peralta",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Piedra",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Pirata One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Plaster",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Playball",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Poiret One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Poller One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Pompiere",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Poor Story",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Potta One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Press Start 2P",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Prosto One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Purple Purse",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Racing Sans One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rakkas",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Raleway Dots",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rammetto One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rampart One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ranchers",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ranga",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Ravi Prakash",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Red Rose",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Redacted",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Redacted Script",
            "variants": [
                "300",
                "regular",
                "700"
            ]
        },
        {
            "font": "Reggae One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Revalia",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ribeye",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ribeye Marrow",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Righteous",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Risque",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Road Rage",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rowdies",
            "variants": [
                "300",
                "regular",
                "700"
            ]
        },
        {
            "font": "Rubik 80s Fade",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rubik Beastly",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rubik Bubbles",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rubik Burned",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rubik Dirt",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rubik Distressed",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rubik Gemstones",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rubik Glitch",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rubik Iso",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rubik Marker Hatch",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rubik Maze",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rubik Microbe",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rubik Moonrocks",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rubik Puddles",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rubik Spray Paint",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rubik Storm",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rubik Vinyl",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rubik Wet Paint",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ruslan Display",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rye",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sail",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Saira Stencil One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Salsa",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sancreek",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sansita Swashed",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Sarina",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Seaweed Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sevillana",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Share",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Shojumaru",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Shrikhand",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Siemreap",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sigmar One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Silkscreen",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Simonetta",
            "variants": [
                "regular",
                "italic",
                "900",
                "900italic"
            ]
        },
        {
            "font": "Single Day",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sirin Stencil",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Skranji",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Slackey",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Smokum",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Smythe",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sniglet",
            "variants": [
                "regular",
                "800"
            ]
        },
        {
            "font": "Snowburst One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sofadi One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sonsie One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Special Elite",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Spicy Rice",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Spirax",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Squada One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Srisakdi",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Staatliches",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Stalinist One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Stardos Stencil",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Stint Ultra Condensed",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Stint Ultra Expanded",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Supermercado One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Syne Tactile",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Taprom",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Titan One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Tourney",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Trade Winds",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Train One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Trochut",
            "variants": [
                "regular",
                "italic",
                "700"
            ]
        },
        {
            "font": "Tulpen One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Turret Road",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "700",
                "800"
            ]
        },
        {
            "font": "Unbounded",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Uncial Antiqua",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Underdog",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Unica One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "UnifrakturCook",
            "variants": [
                "700"
            ]
        },
        {
            "font": "UnifrakturMaguntia",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Unkempt",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Unlock",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Vampiro One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Vast Shadow",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Viaoda Libre",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Vibes",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Voces",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Wallpoet",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Warnes",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Wellfleet",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Yatra One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Yeon Sung",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Yeseva One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Zen Dots",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Zen Loop",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Zen Tokyo Zoo",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Zilla Slab Highlight",
            "variants": [
                "regular",
                "700"
            ]
        }
    ],
    "handwriting": [
        {
            "font": "Aguafina Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Aladin",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Alex Brush",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Allison",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Allura",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Amatic SC",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Amita",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Annie Use Your Telescope",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Architects Daughter",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Are You Serious",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Arizonia",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Babylonica",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bad Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ballet",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Beau Rivage",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Berkshire Swash",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Beth Ellen",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bilbo",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bilbo Swash Caps",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Birthstone",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Birthstone Bounce",
            "variants": [
                "regular",
                "500"
            ]
        },
        {
            "font": "Bonbon",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Bonheur Royale",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Butterfly Kids",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Calligraffitti",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Caramel",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Carattere",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Caveat",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Caveat Brush",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Cedarville Cursive",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Charm",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Charmonman",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Cherish",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Chilanka",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Clicker Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Comforter",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Comforter Brush",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Comic Neue",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Coming Soon",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Condiment",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Cookie",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Corinthia",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Courgette",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Covered By Your Grace",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Crafty Girls",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Damion",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Dancing Script",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Dawning of a New Day",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Dekko",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Delius",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Delius Swash Caps",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Delius Unicase",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Devonshire",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Dokdo",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Dr Sugiyama",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Eagle Lake",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "East Sea Dokdo",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Edu NSW ACT Foundation",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Edu QLD Beginner",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Edu SA Beginner",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Edu TAS Beginner",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Edu VIC WA NT Beginner",
            "variants": [
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Engagement",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ephesis",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Estonia",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Euphoria Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Explora",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Felipa",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Festive",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Fleur De Leah",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Fondamento",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "Fuggles",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Fuzzy Bubbles",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Gaegu",
            "variants": [
                "300",
                "regular",
                "700"
            ]
        },
        {
            "font": "Gamja Flower",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Give You Glory",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Gloria Hallelujah",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Gochi Hand",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Grand Hotel",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Grape Nuts",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Great Vibes",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Grechen Fuemen",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Grey Qo",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Gwendolyn",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Hachi Maru Pop",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Handlee",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Herr Von Muellerhoff",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Hi Melody",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Homemade Apple",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Hurricane",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Imperial Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Indie Flower",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ingrid Darling",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Inspiration",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Island Moments",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Italianno",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Itim",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Jim Nightshade",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Julee",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Just Another Hand",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Just Me Again Down Here",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Kalam",
            "variants": [
                "300",
                "regular",
                "700"
            ]
        },
        {
            "font": "Kaushan Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Kavivanar",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Kings",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Klee One",
            "variants": [
                "regular",
                "600"
            ]
        },
        {
            "font": "Kolker Brush",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Kristi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "La Belle Aurore",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Lakki Reddy",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Lavishly Yours",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "League Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Leckerli One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Licorice",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Liu Jian Mao Cao",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Long Cang",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Love Light",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Loved by the King",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Lovers Quarrel",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Luxurious Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ma Shan Zheng",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Mali",
            "variants": [
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Mansalva",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Marck Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Mea Culpa",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Meddon",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Meie Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Meow Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Merienda",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Merienda One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Miss Fajardose",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Molle",
            "variants": [
                "italic"
            ]
        },
        {
            "font": "Monsieur La Doulaise",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "MonteCarlo",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Montez",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Moon Dance",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Mr Bedfort",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Mr Dafoe",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Mr De Haviland",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Mrs Saint Delafield",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Mrs Sheppards",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ms Madi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "My Soul",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Nanum Brush Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Nanum Pen Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Neonderthaw",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Nerko One",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Neucha",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Niconne",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Norican",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Nothing You Could Do",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ole",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Oooh Baby",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Over the Rainbow",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Pacifico",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Pangolin",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Parisienne",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Passions Conflict",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Patrick Hand",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Patrick Hand SC",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Permanent Marker",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Petemoss",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Petit Formal Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Pinyon Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Praise",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Princess Sofia",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Puppies Play",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Quintessential",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Qwigley",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Qwitcher Grypen",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Rancho",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Redressed",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Reenie Beanie",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rochester",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rock Salt",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Romanesco",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Rouge Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ruge Boogie",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ruthie",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sacramento",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sassy Frass",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Satisfy",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Schoolbell",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sedgwick Ave",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sedgwick Ave Display",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Send Flowers",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Shadows Into Light",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Shadows Into Light Two",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Shalimar",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Short Stack",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Smooch",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sofia",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Splash",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Square Peg",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sriracha",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Stalemate",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Style Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sue Ellen Francisco",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Sunshiney",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Swanky and Moo Moo",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Tangerine",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Tapestry",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "The Girl Next Door",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "The Nautigal",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Tillana",
            "variants": [
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Twinkle Star",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Updock",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Vibur",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Vujahday Script",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Waiting for the Sunrise",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Walter Turncoat",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Water Brush",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Waterfall",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Whisper",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "WindSong",
            "variants": [
                "regular",
                "500"
            ]
        },
        {
            "font": "Yellowtail",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Yesteryear",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Yomogi",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Zeyada",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Zhi Mang Xing",
            "variants": [
                "regular"
            ]
        }
    ],
    "monospace": [
        {
            "font": "Anonymous Pro",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Azeret Mono",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "B612 Mono",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Chivo Mono",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Courier Prime",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Cousine",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Cutive Mono",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "DM Mono",
            "variants": [
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic"
            ]
        },
        {
            "font": "Fira Code",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Fira Mono",
            "variants": [
                "regular",
                "500",
                "700"
            ]
        },
        {
            "font": "Fragment Mono",
            "variants": [
                "regular",
                "italic"
            ]
        },
        {
            "font": "IBM Plex Mono",
            "variants": [
                "100",
                "100italic",
                "200",
                "200italic",
                "300",
                "300italic",
                "regular",
                "italic",
                "500",
                "500italic",
                "600",
                "600italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Inconsolata",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "JetBrains Mono",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic"
            ]
        },
        {
            "font": "Major Mono Display",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Martian Mono",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800"
            ]
        },
        {
            "font": "Nanum Gothic Coding",
            "variants": [
                "regular",
                "700"
            ]
        },
        {
            "font": "Noto Sans Mono",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900"
            ]
        },
        {
            "font": "Nova Mono",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Overpass Mono",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700"
            ]
        },
        {
            "font": "Oxygen Mono",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "PT Mono",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Red Hat Mono",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Roboto Mono",
            "variants": [
                "100",
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "100italic",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Share Tech Mono",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Source Code Pro",
            "variants": [
                "200",
                "300",
                "regular",
                "500",
                "600",
                "700",
                "800",
                "900",
                "200italic",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic",
                "800italic",
                "900italic"
            ]
        },
        {
            "font": "Space Mono",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "Spline Sans Mono",
            "variants": [
                "300",
                "regular",
                "500",
                "600",
                "700",
                "300italic",
                "italic",
                "500italic",
                "600italic",
                "700italic"
            ]
        },
        {
            "font": "Syne Mono",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Ubuntu Mono",
            "variants": [
                "regular",
                "italic",
                "700",
                "700italic"
            ]
        },
        {
            "font": "VT323",
            "variants": [
                "regular"
            ]
        },
        {
            "font": "Xanh Mono",
            "variants": [
                "regular",
                "italic"
            ]
        }
    ]
};

// EXTERNAL MODULE: ./src/constants/pages/clients/careers/showJob.js
var careers_showJob = __webpack_require__(88755);
;// CONCATENATED MODULE: ./public/icons/career_icons/edit-banner.svg
var edit_banner_path;

function edit_banner_extends() { edit_banner_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return edit_banner_extends.apply(this, arguments); }



var SvgEditBanner = function SvgEditBanner(props) {
  return /*#__PURE__*/react.createElement("svg", edit_banner_extends({
    width: 31,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), edit_banner_path || (edit_banner_path = /*#__PURE__*/react.createElement("path", {
    d: "M21.285 18.266c-.101.101-.101.203-.101.304v5.739H3.309V6.434h12.238c.101 0 .203 0 .305-.102l1.625-1.625c.253-.254.05-.71-.305-.71H3.309A2.438 2.438 0 0 0 .87 6.433v17.875a2.406 2.406 0 0 0 2.438 2.437h17.875a2.438 2.438 0 0 0 2.437-2.437v-7.364c0-.355-.457-.558-.71-.304l-1.626 1.625Zm7.922-10.207a2.973 2.973 0 0 0 0-4.215L27.023 1.66a2.973 2.973 0 0 0-4.214 0L9.504 14.965l-.508 4.62a2.062 2.062 0 0 0 2.285 2.286l4.621-.508L29.207 8.06ZM24.23 9.582l-9.445 9.445-3.351.407.406-3.352 9.445-9.445 2.945 2.945Zm3.25-4.012c.254.203.254.508.051.762l-1.574 1.574-2.945-2.996 1.523-1.523a.476.476 0 0 1 .762 0L27.48 5.57Z",
    fill: "#fff"
  })));
};

/* harmony default export */ var edit_banner = (SvgEditBanner);
;// CONCATENATED MODULE: ./public/icons/grey_gripicon.svg
var grey_gripicon_g;

function grey_gripicon_extends() { grey_gripicon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return grey_gripicon_extends.apply(this, arguments); }



var SvgGreyGripicon = function SvgGreyGripicon(props) {
  return /*#__PURE__*/react.createElement("svg", grey_gripicon_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 15
  }, props), grey_gripicon_g || (grey_gripicon_g = /*#__PURE__*/react.createElement("g", {
    fill: "#4F4F4F"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M3.333 1.667c0 .46-.162.853-.488 1.178a1.606 1.606 0 0 1-1.178.488c-.46 0-.853-.162-1.179-.488A1.606 1.606 0 0 1 0 1.667C0 1.207.163.814.488.488A1.606 1.606 0 0 1 1.667 0c.46 0 .853.163 1.178.488a1.606 1.606 0 0 1 .487 1.237M3.333 7.363c0 .46-.162.853-.488 1.179a1.606 1.606 0 0 1-1.178.488c-.46 0-.853-.163-1.179-.488A1.606 1.606 0 0 1 0 7.363c0-.46.163-.853.488-1.178a1.606 1.606 0 0 1 1.179-.488c.46 0 .853.162 1.178.488a1.606 1.606 0 0 1 .487 1.236M3.333 13.06c0 .46-.162.853-.488 1.178a1.606 1.606 0 0 1-1.178.489c-.46 0-.853-.163-1.179-.489A1.606 1.606 0 0 1 0 13.06c0-.46.163-.853.488-1.179a1.606 1.606 0 0 1 1.179-.488c.46 0 .853.163 1.178.488a1.606 1.606 0 0 1 .487 1.237M9.808 1.667c0 .46-.163.853-.488 1.178a1.606 1.606 0 0 1-1.179.488c-.46 0-.853-.162-1.178-.488a1.606 1.606 0 0 1-.488-1.178c0-.46.162-.853.488-1.179A1.606 1.606 0 0 1 8.14 0c.46 0 .853.163 1.179.488a1.606 1.606 0 0 1 .487 1.237M9.808 7.363c0 .46-.163.853-.488 1.179a1.606 1.606 0 0 1-1.179.488c-.46 0-.853-.163-1.178-.488a1.606 1.606 0 0 1-.488-1.179c0-.46.162-.853.488-1.178a1.606 1.606 0 0 1 1.178-.488c.46 0 .853.162 1.179.488a1.606 1.606 0 0 1 .487 1.236M9.808 13.06c0 .46-.163.853-.488 1.178a1.606 1.606 0 0 1-1.179.489c-.46 0-.853-.163-1.178-.489a1.606 1.606 0 0 1-.488-1.178c0-.46.162-.853.488-1.179a1.606 1.606 0 0 1 1.178-.488c.46 0 .853.163 1.179.488a1.606 1.606 0 0 1 .487 1.237"
  }))));
};

/* harmony default export */ var grey_gripicon = (SvgGreyGripicon);
// EXTERNAL MODULE: ../../shared/node_modules/react-beautiful-dnd/dist/react-beautiful-dnd.esm.js
var react_beautiful_dnd_esm = __webpack_require__(8979);
// EXTERNAL MODULE: ../../shared/node_modules/react-google-font-loader/build/index.js
var build = __webpack_require__(84501);
;// CONCATENATED MODULE: ./src/imports-files/pages/career/customize-career-page.js
// ----------------- Common Library -----------------

// ----------------- Common Library -----------------
// ----------------- Components ---------------    


























// ----------------- CSS ----------------


//------------------Service------------

//------------------Actions------------



//------------------Helper Components--------


//------------------Constants----------


//-------------- Image Components ------



//---------------Drag and Drop Components




/***/ }),

/***/ 83813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "tN": function() { return /* reexport */ view_job/* APPLICATION_FILE_SIZE_LIMIT */.tN; },
  "PG": function() { return /* reexport */ common/* AutocompleteError */.PG; },
  "zx": function() { return /* reexport */ components_button/* default */.Z; },
  "ZJ": function() { return /* reexport */ (button_index_module_default()); },
  "fL": function() { return /* reexport */ view_job/* CV_FILE_EXTENSIONS */.fL; },
  "bN": function() { return /* reexport */ common/* CheckedCheckbox */.bN; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "jh": function() { return /* reexport */ customize_career_page/* CustomizeCareerAction */.j; },
  "v0": function() { return /* reexport */ common/* DefaultCheckbox */.v0; },
  "Yp": function() { return /* reexport */ react_file_picker_providers/* DropboxChooser */.Yp; },
  "cb": function() { return /* reexport */ DuplicateEmailModal; },
  "Wg": function() { return /* reexport */ react_file_picker_providers/* EXTENSION_COMMON */.Wg; },
  "dC": function() { return /* reexport */ render_error_loading/* ErrorPages */.d; },
  "$_": function() { return /* reexport */ footer/* Footer */.$; },
  "Zm": function() { return /* reexport */ react_file_picker_providers/* GoogleChooser */.Zm; },
  "HZ": function() { return /* reexport */ build/* default */.Z; },
  "h4": function() { return /* reexport */ header/* Header */.h; },
  "HM": function() { return /* reexport */ jobs_view_job/* JobApplication */.H; },
  "gW": function() { return /* reexport */ jobs_common/* JobCommon */.g; },
  "gb": function() { return /* reexport */ common/* Loading */.gb; },
  "jP": function() { return /* reexport */ (new_view_job_index_module_default()); },
  "Yv": function() { return /* reexport */ view_job/* OTHER_FILE_EXTENSIONS */.Yv; },
  "k2": function() { return /* reexport */ (_index_module_default()); },
  "j$": function() { return /* reexport */ common/* QUESTION_TYPES */.j$; },
  "RQ": function() { return /* reexport */ common/* REDIRECT */.RQ; },
  "Us": function() { return /* reexport */ common/* SUCCESS_REPONSE_CODE */.Us; },
  "Lt": function() { return /* reexport */ send_request/* SendRequest */.L; },
  "TA": function() { return /* reexport */ common/* TRANSLATION */.TA; },
  "Mn": function() { return /* reexport */ common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn; },
  "sm": function() { return /* reexport */ common/* Yup */.sm; },
  "lg": function() { return /* reexport */ view_job/* applyJobInitialValues */.lg; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "mU": function() { return /* reexport */ closeDropDown; },
  "MQ": function() { return /* reexport */ cvErrors; },
  "xz": function() { return /* reexport */ handleFormSubmit; },
  "GB": function() { return /* reexport */ common/* handleOtherResponseCode */.GB; },
  "P5": function() { return /* reexport */ jobApplicationTokenSubmit; },
  "XE": function() { return /* reexport */ add_candidate/* onAddCandidateRemoveFile */.XE; },
  "K3": function() { return /* reexport */ onCancel; },
  "Os": function() { return /* reexport */ onFileChange; },
  "Tp": function() { return /* reexport */ onRemoveFile; },
  "G1": function() { return /* reexport */ otherErrors; },
  "gT": function() { return /* reexport */ redirectToCarrerPage; },
  "A6": function() { return /* reexport */ view_job/* submitAnswerInitialValues */.A6; },
  "lH": function() { return /* reexport */ view_job/* submitAnswerSchema */.lH; },
  "n3": function() { return /* reexport */ submitScreeningQuestions; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "sO": function() { return /* reexport */ common/* useRef */.sO; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; },
  "uS": function() { return /* reexport */ view_job/* viewJobValidation */.uS; }
});

// UNUSED EXPORTS: BlueLogo, Checkbox, CommonAction, DataFromUrl, HelmetMeta, HoverCheckbox, Image, Link, NextServerCookies, Tooltip, activeViewClass, copyToClipboard, fb, linkedin, onApplyClick, toastr, twitter, updateApplicationData, updatePage, validAnswers, viewDescription, without_cv_condition_passes

// EXTERNAL MODULE: ./src/styles/pages/career/view-job/_index.module.scss
var _index_module = __webpack_require__(25436);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/styles/pages/career/new-view-job/_index.module.scss
var new_view_job_index_module = __webpack_require__(94968);
var new_view_job_index_module_default = /*#__PURE__*/__webpack_require__.n(new_view_job_index_module);
// EXTERNAL MODULE: ./src/styles/components/button/_index.module.scss
var button_index_module = __webpack_require__(84215);
var button_index_module_default = /*#__PURE__*/__webpack_require__.n(button_index_module);
// EXTERNAL MODULE: ../../shared/node_modules/next/image.js
var next_image = __webpack_require__(53429);
// EXTERNAL MODULE: ../../shared/node_modules/next/link.js
var next_link = __webpack_require__(75547);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
// EXTERNAL MODULE: ./public/images/logo/Bluelogo.png
var Bluelogo = __webpack_require__(14278);
;// CONCATENATED MODULE: ./public/icons/fb.png
/* harmony default export */ var fb = ({"src":"/_next/static/media/fb.5db99b2d.png","height":81,"width":80,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAABuvAAAbrwFeGpEcAAAAlElEQVR4nF2Ouw3CYAyEv5FypgVRUsAC54KlWCkD0NDADEhUCKE8kP+kojjJPvseoHygnAkPRM7IC5b5zt/xjnxCPiC/G4c8EjmsyjOdi7sgf4mcymEiPKL8oNw1dSkjR+T2UMuEvCWSBnmDciDcIiq/Iq7IQu6Qb6vzUIoqubbOI3Jh2deSPcon8gvlHrnwIhrX/wDVAVO9ds6z6wAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/icons/twitter.png
/* harmony default export */ var twitter = ({"src":"/_next/static/media/twitter.ff71bb5e.png","height":81,"width":80,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAABuvAAAbrwFeGpEcAAAAn0lEQVR4nDWOMQoCUQxEH55BsPIGWswewjvMP42FpaVH2V4bK7FZLGwEsRG0ElRkEZWf/RYhyUwyMyBvkO/IF+Qr8gP5hfwMjip9UXpHj9kN8hL5FjtyBmfIC+Qz8oAqZXweHIqvaQH7VO6VedUpdLIH5CFyJnKNkNtikT4o5YNJ+Ryj1FCFdftXyInXyNuw/AcuIWvkI/Kp1B55V2zrH3ENUKauYxVkAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/icons/linkedin.png
/* harmony default export */ var linkedin = ({"src":"/_next/static/media/linkedin.0a9d1f27.png","height":81,"width":80,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAABuvAAAbrwFeGpEcAAAAq0lEQVR4nDWOrU6DYRSDH7dbQMxOktAjuAvEBKL1EzO7hAkMnpCQoAkeT4LjGuamtywDTdgg7/cjmp70tE1B+UL+61A5IZ+Rf6k07QjVPW+Qnzqxch64x5B+RPlAbg3fyNvubuG+IXOUB+Q58gx5grxCraE3XKHcUb6mco/8jDxFOY2GS5Q1ZVF5RX5DvqDyMxoWKC/IS5R35E/k23HkBuWAvEPeozTeDdrmH9HdURweXaziAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/constants/pages/jobs/view-job.js
var view_job = __webpack_require__(47582);
// EXTERNAL MODULE: ./src/actions/pages/candidates/add-candidate.js
var add_candidate = __webpack_require__(19803);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(34817);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
;// CONCATENATED MODULE: ./src/actions/pages/jobs/view-job.js




function onApplyClick(event, router) {
    document.getElementsByClassName("job-description-section")[0].classList.add("dnone");
    document.getElementsByClassName("job-apply-section")[0].classList.remove("dnone");
    document.getElementsByClassName("job-apply-button")[0].classList.add("dnone");
    document.getElementsByClassName("job-description-button")[0].classList.remove("dnone");
    //This considiton is to prevent the page looping 
    if (event != "useEffect") {
        // let queryParams =  router.query;
        // delete queryParams.q
        // delete queryParams.client_slug
        // delete queryParams.slug
        // queryParams['q'] = 'apply';
        // router.push({
        //                         pathname :  router.asPath.split('?')[0],
        //                         query    :  queryParams
        //                     })      
        // Construct URLSearchParams object instance from current URL querystring.
        var queryParams = new URLSearchParams(window.location.search);
        // Set new or modify existing parameter value. 
        queryParams.set("q", "apply");
        // Replace current querystring with the new one.
        history.replaceState(null, null, "?" + queryParams.toString());
    }
}
function viewDescription(event, formik, router) {
    document.getElementsByClassName("job-description-section")[0].classList.remove("dnone");
    document.getElementsByClassName("job-apply-section")[0].classList.add("dnone");
    document.getElementsByClassName("job-apply-button")[0].classList.remove("dnone");
    document.getElementsByClassName("job-description-button")[0].classList.add("dnone");
    formik.current.setErrors({});
    // let queryParams =  router.query;
    //  delete queryParams.q
    // delete queryParams.client_slug
    // delete queryParams.slug
    // queryParams['q'] = 'desc';
    // router.push({
    //                           pathname :  router.asPath.split('?')[0],
    //                           query    :  queryParams
    //                       }) 
    // Construct URLSearchParams object instance from current URL querystring.
    var queryParams = new URLSearchParams(window.location.search);
    // Set new or modify existing parameter value. 
    queryParams.set("q", "desc");
    // Replace current querystring with the new one.
    history.replaceState(null, null, "?" + queryParams.toString());
}
function updateApplicationData(mutationRecords, router, title, setApplied) {
    var mutationRecord = mutationRecords[0];
    var oldValue = mutationRecord.oldValue;
    var newValue = mutationRecord.target.getAttribute("class");
    if (oldValue.includes("indeed-apply-status-not-applied") && newValue.includes("indeed-apply-status-applied")) {
        setApplied(true);
    }
}
function updatePage(mutationRecords, router, title) {
    var mutationRecord = mutationRecords[0];
    var oldValue = mutationRecord.oldValue;
    var newValue = mutationRecord.target.getAttribute("style");
    if (!oldValue.includes("display: none;") && newValue.includes("display: none;")) {
        router.push(REDIRECT.client.jobs.application_sent + "?with_indeed=true&title=".concat(title));
    }
}
function parseResume(file, file_name, formik) {
    return _parseResume.apply(this, arguments);
}
function _parseResume() {
    _parseResume = (0,_async_to_generator/* default */.Z)(function(file, file_name, formik) {
        var formData, result, status_code, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    formData = new FormData();
                    formData.append("file", file, file_name);
                    return [
                        4,
                        new jobs_view_job/* JobApplication */.H().parseCV(formData)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    switch(status_code){
                        case common/* SUCCESS_REPONSE_CODE */.Us:
                            response = result.data;
                            if (formik.values.job_application) {
                                if (response.name) formik.setFieldValue("job_application.name", response.name || "");
                                if (response.first_name) formik.setFieldValue("job_application.first_name", response.first_name || "");
                                if (response.last_name) formik.setFieldValue("job_application.last_name", response.last_name || "");
                                if (response.email) formik.setFieldValue("job_application.email", response.email || "");
                                if (response.contact_no) formik.setFieldValue("job_application.contact_no", response.contact_no || "");
                            } else if (formik.values.client_candidate) {
                                if (response.name) formik.setFieldValue("client_candidate.name", response.name || "");
                                if (response.first_name) formik.setFieldValue("client_candidate.first_name", response.first_name || "");
                                if (response.last_name) formik.setFieldValue("client_candidate.last_name", response.last_name || "");
                                if (response.email) formik.setFieldValue("client_candidate.email", response.email || "");
                                if (response.contact_no) formik.setFieldValue("client_candidate.contact_no", response.contact_no || "");
                            }
                            break;
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            new common/* CustomToastrAction */.Y5().setNormalToastr(result.response.data.error, "warning");
                            // toastr.warning(result.response.data.error)
                            return [
                                2,
                                result.response.data.error
                            ];
                        default:
                            (0,common/* handleOtherResponseCode */.GB)(status_code);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _parseResume.apply(this, arguments);
}
function handleFormSubmit(values, router, job_slug, setConfirmModal, setShowLoader, source, setDuplicateEmail) {
    return _handleFormSubmit.apply(this, arguments);
}
function _handleFormSubmit() {
    _handleFormSubmit = (0,_async_to_generator/* default */.Z)(function(values, router, job_slug, setConfirmModal, setShowLoader, source, setDuplicateEmail) {
        var formData, result, status_code, response, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setConfirmModal(false);
                    setShowLoader(true);
                    formData = new FormData();
                    formData.append("job_application[name]", values.job_application.name);
                    formData.append("job_application[first_name]", values.job_application.first_name);
                    formData.append("job_application[last_name]", values.job_application.last_name);
                    formData.append("job_application[candidate_linkedin_url]", values.job_application.candidate_linkedin_url);
                    formData.append("job_application[portfolio_url]", values.job_application.portfolio_url);
                    formData.append("job_application[email]", values.job_application.email);
                    formData.append("job_application[contact_no]", values.job_application.contact_no);
                    formData.append("job_application[source]", "Direct");
                    formData.append("job_application[terms_accepted]", values.job_application.terms_accepted);
                    if (values.job_application.cv_library_token && values.job_application.cv_library_filename) {
                        formData.append("job_application[cv_library_token]", values.job_application.cv_library_token);
                        formData.append("job_application[cv_library_file_name]", values.job_application.cv_library_filename);
                    } else if (values.job_application.resume_attributes.file && values.job_application.resume_attributes.file_name) {
                        formData.append("job_application[candidate_cv]", values.job_application.resume_attributes.file, values.job_application.resume_attributes.file.name);
                    }
                    values.job_application.job_application_files_attributes.map(function(file, index) {
                        formData.append("job_application[other_files_attributes][".concat(index, "][file_type]"), file.file_type);
                        formData.append("job_application[other_files_attributes][".concat(index, "][file]"), file.file, file.file_name);
                        return file;
                    });
                    if (source.length > 0) formData.append("job_application[job_board_slug]", source);
                    if (document.referrer != "" && !document.referrer.includes(getSource()) && (source != "" || source != null || typeof source != "undefined")) {
                        formData.append("job_application[job_board_domain]", document.referrer);
                    }
                    values.job_application.screening_answers_attributes.map(function(screening_answer, index) {
                        formData.append("job_application[screening_answers_attributes][".concat(index, "][text]"), screening_answer.text);
                        formData.append("job_application[screening_answers_attributes][".concat(index, "][screening_question_id]"), screening_answer.screening_question_id);
                        screening_answer.options.forEach(function(item) {
                            formData.append("job_application[screening_answers_attributes][".concat(index, "][options][]"), item);
                        });
                        return screening_answer;
                    });
                    return [
                        4,
                        new jobs_view_job/* JobApplication */.H().applyJob(formData, job_slug)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    _tmp = {};
                    switch(status_code){
                        case common/* SUCCESS_REPONSE_CODE */.Us:
                            response = result.data;
                            if (response.success) {
                                setConfirmModal(false);
                                setShowLoader(true);
                                window.location.replace(common/* REDIRECT.client.jobs.application_sent */.RQ.client.jobs.application_sent + "?token=".concat(response.token));
                                // router.push(REDIRECT.client.jobs.application_sent + `?application_id=${response.id}`)
                                new common/* CustomToastrAction */.Y5().setNormalToastr(response.success, "success");
                            // toastr.success(response.success)
                            }
                            break;
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            setConfirmModal(false);
                            setShowLoader(false);
                            if (result.response.data.message) setDuplicateEmail((_tmp.state = true, _tmp.message = result.response.data.message, _tmp));
                            return [
                                2,
                                result.response.data.error
                            ];
                        default:
                            (0,common/* handleOtherResponseCode */.GB)(status_code);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _handleFormSubmit.apply(this, arguments);
}
function onFileChange(files, formik, type, isAutofill, from, setCvErrorMessage, setOtherErrorMessage, setFileCount, setShowLoader, setIsDisabled) {
    return _onFileChange.apply(this, arguments);
}
function _onFileChange() {
    _onFileChange = (0,_async_to_generator/* default */.Z)(function(files, formik, type, isAutofill, from, setCvErrorMessage, setOtherErrorMessage, setFileCount, setShowLoader, setIsDisabled) {
        var start_index, ref, ref1, ref2, _tmp, ref3, reject_files, i;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    start_index = "";
                    _tmp = {};
                    if (formik.values.job_application) {
                        ;
                        start_index = ((ref = formik.values.job_application.job_application_files_attributes) === null || ref === void 0 ? void 0 : ref.length) > 0 ? formik.values.job_application.job_application_files_attributes.length : 0;
                        (formik === null || formik === void 0 ? void 0 : (ref1 = formik.errors) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.job_application) === null || ref2 === void 0 ? void 0 : ref2.resume_attributes) ? formik.errors.job_application.resume_attributes = "" : "";
                        formik.setErrors((_tmp["job_application"] = formik.errors.job_application, _tmp));
                        setCvErrorMessage("");
                        setFileCount(Math.random() * 10000);
                    } else {
                        ;
                        start_index = ((ref3 = formik.values.client_candidate.other_files_attributes) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 ? formik.values.client_candidate.other_files_attributes.length : 0;
                    }
                    reject_files = [];
                    if ([
                        "drive",
                        "dropbox"
                    ].includes(from)) {
                        reject_files = (0,_to_consumable_array/* default */.Z)(files).filter(function(x) {
                            return x.fileBlob.size > view_job/* APPLICATION_FILE_SIZE_LIMIT */.tN;
                        });
                    } else {
                        reject_files = (0,_to_consumable_array/* default */.Z)(files).filter(function(x) {
                            return x.size > view_job/* APPLICATION_FILE_SIZE_LIMIT */.tN;
                        });
                    }
                    if (reject_files.length > 0) {
                        if (type == "other") setOtherErrorMessage("One or more files size is more than 25 MB.");
                        else if (type == "cv") setCvErrorMessage("File size is more than 25 MB.");
                        return [
                            2,
                            false
                        ];
                    }
                    if ([
                        "drive",
                        "dropbox"
                    ].includes(from)) {
                        reject_files = (0,_to_consumable_array/* default */.Z)(files).filter(function(x) {
                            var file_extension = x.fileName.split(".").pop().toLowerCase();
                            var extension = type == "cv" ? view_job/* CV_FILE_EXTENSIONS.includes */.fL.includes(file_extension) : view_job/* OTHER_FILE_EXTENSIONS.includes */.Yv.includes(file_extension);
                            return !extension;
                        });
                    } else {
                        reject_files = (0,_to_consumable_array/* default */.Z)(files).filter(function(x) {
                            var file_extension = x.name.split(".").pop().toLowerCase();
                            var extension = type == "cv" ? view_job/* CV_FILE_EXTENSIONS.includes */.fL.includes(file_extension) : view_job/* OTHER_FILE_EXTENSIONS.includes */.Yv.includes(file_extension);
                            return !extension;
                        });
                    }
                    if (reject_files.length > 0) {
                        if (type == "other") setOtherErrorMessage("One or more files types are not allowed.");
                        else if (type == "cv") setCvErrorMessage("File type is not allowed.");
                        return [
                            2,
                            false
                        ];
                    }
                    if (type == "cv" && files.length > 0) {
                        setIsDisabled(true);
                        if ([
                            "drive",
                            "dropbox"
                        ].includes(from)) {
                            addCV(formik, files[0].fileBlob, files[0].fileName, setCvErrorMessage, setFileCount);
                        } else {
                            addCV(formik, files[0], files[0].name, setCvErrorMessage, setFileCount);
                        }
                    } else if (type == "other" && files.length > 0) {
                        if (start_index >= 5 || start_index + files.length > 5) {
                            setOtherErrorMessage("Maximum no of files allowed is 5.");
                            return [
                                2,
                                false
                            ];
                        }
                        for(i = 0; i < files.length; i++){
                            if (start_index < 5) {
                                if ([
                                    "drive",
                                    "dropbox"
                                ].includes(from)) {
                                    addFile(formik, files[i].fileBlob, files[i].fileName, setOtherErrorMessage, setFileCount);
                                } else {
                                    addFile(formik, files[i], files[i].name, setOtherErrorMessage, setFileCount);
                                }
                                start_index += 1;
                            }
                        }
                    }
                    if (!isAutofill) return [
                        3,
                        4
                    ];
                    if (!(files.length > 0)) return [
                        3,
                        4
                    ];
                    setShowLoader(true);
                    if (![
                        "drive",
                        "dropbox"
                    ].includes(from)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        parseResume(files[0].fileBlob, files[0].fileName, formik)
                    ];
                case 1:
                    _state.sent();
                    setShowLoader(false);
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        parseResume(files[0], files[0].name, formik)
                    ];
                case 3:
                    _state.sent();
                    setShowLoader(false);
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _onFileChange.apply(this, arguments);
}
function addFile(formik, file, file_name, setOtherErrorMessage, setFileCount) {
    var hash = {
        file_type: "other",
        file: file,
        file_name: file_name,
        file_size: file.size
    };
    if (formik.values.job_application) {
        formik.values.job_application.job_application_files_attributes.push(hash);
    } else {
        formik.values.client_candidate.other_files_attributes.push(hash);
    }
    setOtherErrorMessage("");
    setFileCount(Math.random() * 10000);
}
function addCV(formik, file, file_name, setCvErrorMessage, setFileCount) {
    var hash = {
        file_type: "cv",
        file: file,
        file_name: file_name,
        file_size: file.size
    };
    if (formik.values.job_application) {
        formik.values.job_application.resume_attributes = hash;
    } else {
        formik.values.client_candidate.resume_attributes = hash;
    }
    setCvErrorMessage("");
    setFileCount(Math.random() * 10000);
}
function jobApplicationTokenSubmit(router, setConfirmState) {
    return _jobApplicationTokenSubmit.apply(this, arguments);
}
function _jobApplicationTokenSubmit() {
    _jobApplicationTokenSubmit = (0,_async_to_generator/* default */.Z)(function(router, setConfirmState) {
        var params, _tmp, result, status_code, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    params = (_tmp.token = router.query.token, _tmp);
                    setConfirmState(true);
                    return [
                        4,
                        new jobs_view_job/* JobApplication */.H().confirmEmail(params)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    switch(status_code){
                        case common/* SUCCESS_REPONSE_CODE */.Us:
                            response = result.data;
                            return [
                                2,
                                response
                            ];
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            return [
                                2,
                                result.response.data
                            ];
                        default:
                            (0,common/* handleOtherResponseCode */.GB)(status_code);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _jobApplicationTokenSubmit.apply(this, arguments);
}
function copyToClipboard(link, setClipBoardMessage) {
    var textField = document.createElement("textarea");
    textField.innerText = link;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
    setClipBoardMessage("Copied");
    document.querySelector(".ClipboardTooltip").lastChild.textContent = "Copied";
// toastr.success('Copied')
}
function onRemoveFile(formik, type, index, setCvErrorMessage, setOtherErrorMessage, setFileCount, setIsDisabled) {
    if (type == "cv") {
        var hash = {
            file_type: "",
            file: "",
            file_name: ""
        };
        setIsDisabled(false);
        formik.setFieldValue("job_application.resume_attributes", hash);
        setCvErrorMessage("");
    } else {
        var ref, ref1;
        (ref = formik.values.job_application) === null || ref === void 0 ? void 0 : (ref1 = ref.job_application_files_attributes) === null || ref1 === void 0 ? void 0 : ref1.splice(index, 1);
        setOtherErrorMessage("");
        setFileCount(Math.random() * 10000);
    }
}
function closeDropDown(setIsActive) {
    setTimeout(function() {
        return setIsActive(false);
    }, 50);
}
function onCancel() {
    return false;
}
function otherErrors(otherErrorMessage, errors) {
    var ref;
    return otherErrorMessage || (errors === null || errors === void 0 ? void 0 : (ref = errors.job_application) === null || ref === void 0 ? void 0 : ref.job_application_files_attributes) || "";
}
function cvErrors(cvErrorMessage, errors) {
    var ref, ref1, ref2, ref3;
    return cvErrorMessage || (errors === null || errors === void 0 ? void 0 : (ref = errors.job_application) === null || ref === void 0 ? void 0 : (ref1 = ref.resume_attributes) === null || ref1 === void 0 ? void 0 : ref1.file_name) || (errors === null || errors === void 0 ? void 0 : (ref2 = errors.job_application) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.resume_attributes) === null || ref3 === void 0 ? void 0 : ref3.base) || "";
}
function activeViewClass(activeView, section) {
    return activeView == section ? "" : "dnone";
}
function without_cv_condition_passes(formik) {
    if (formik.current.values.job_application.without_cv) {
        var profile_url_present = formik.current.values.job_application.portfolio_url == "" ? false : true;
        var resume_present = formik.current.values.job_application.resume_attributes.file_name == "" ? false : true;
        return profile_url_present || resume_present;
    } else {
        return true;
    }
}
function getSource() {
    var parent_domain = "";
    var hostname = window.location.hostname.split(".");
    parent_domain = parent_domain + hostname[hostname.length - 1] + hostname[hostname.length - 2];
    return parent_domain;
}
function getReffereParentDomain(refferName) {
    var parent_domain = "";
    var hostname = refferName.split(".");
    parent_domain = parent_domain + hostname[hostname.length - 1] + hostname[hostname.length - 2];
    return parent_domain;
}
function redirectToCarrerPage(client_slug, isFrame) {
    var carrer_url = common/* REDIRECT.client.jobs.view_career_page */.RQ.client.jobs.view_career_page;
    var protocol = window.location.protocol;
    var hostnamearray = window.location.host.split(".");
    hostnamearray[0] = client_slug;
    var url = protocol + "//" + hostnamearray.join(".") + carrer_url;
    window.open(url, "_self");
}
function submitScreeningQuestions(args, router, job_id, setShowLoader, setSuccessFailure) {
    return _submitScreeningQuestions.apply(this, arguments);
}
function _submitScreeningQuestions() {
    _submitScreeningQuestions = (0,_async_to_generator/* default */.Z)(function(args, router, job_id, setShowLoader, setSuccessFailure) {
        var result, status_code, response, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setShowLoader(true);
                    return [
                        4,
                        new jobs_view_job/* JobApplication */.H().submitAnswers(args, job_id)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    _tmp = {};
                    switch(status_code){
                        case common/* SUCCESS_REPONSE_CODE */.Us:
                            response = result.data;
                            if (response.success) {
                                setShowLoader(false);
                                setSuccessFailure((_tmp.status_code = 201, _tmp.error = "This tab can now be closed safely.", _tmp));
                                new common/* CustomToastrAction */.Y5().setNormalToastr(response.success, "success");
                            }
                            break;
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            setShowLoader(false);
                            new common/* CustomToastrAction */.Y5().setNormalToastr(result.response.data.error, "error");
                        default:
                            (0,common/* handleOtherResponseCode */.GB)(status_code);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _submitScreeningQuestions.apply(this, arguments);
}
function validAnswers(formik) {
    var isValid = true;
    for(var i = 0; i < formik.values.job_application.screening_answers_attributes.length; i++){
        var question = formik.values.job_application.screening_answers_attributes[i];
        if (question.mandatory) {
            switch(question.question_type_name){
                case QUESTION_TYPES.SINGLE_LINE:
                case QUESTION_TYPES.MULTIPLE_LINE:
                    isValid = question.text.length > 0 ? true : false;
                    break;
                default:
                    isValid = question.options.length > 0 ? true : false;
                    break;
            }
        } else {
            continue;
        }
        if (!isValid) break;
    }
    return isValid;
}

// EXTERNAL MODULE: ./src/services/pages/clients/jobs/common.js
var jobs_common = __webpack_require__(60515);
// EXTERNAL MODULE: ./src/services/common/send-request.js
var send_request = __webpack_require__(34964);
// EXTERNAL MODULE: ./src/services/pages/jobs/view-job.js
var jobs_view_job = __webpack_require__(83422);
// EXTERNAL MODULE: ./src/actions/common/render_error_loading.js
var render_error_loading = __webpack_require__(10758);
// EXTERNAL MODULE: ../../shared/node_modules/react-file-picker-providers/index.js
var react_file_picker_providers = __webpack_require__(70853);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/imports-files/components/delete-candidate-modal.js
var delete_candidate_modal = __webpack_require__(15738);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/candidates/kanban.js + 10 modules
var kanban = __webpack_require__(47942);
// EXTERNAL MODULE: ./src/components/common-modal/modal.js + 2 modules
var modal = __webpack_require__(99005);
// EXTERNAL MODULE: ../../shared/node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(73732);
;// CONCATENATED MODULE: ./src/components/duplicate-email-modal.js





function DuplicateEmailModal(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        type: "info",
        className: "CandidateFilterModal",
        noCloseIcon: true,
        innerContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "confirmcontainer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "normalweight ".concat(delete_candidate_modal/* ComponentStyle.DeleteCandidateModal__Message */.c2.DeleteCandidateModal__Message),
                        children: props.duplicateEmail.message
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "textcenter",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(delete_candidate_modal/* Button */.zx, {
                            buttonstyle: delete_candidate_modal/* ComponentStyle.secondarybtn */.c2.secondarybtn,
                            onClick: function() {
                                return props.setDuplicateEmail({
                                    state: false
                                });
                            },
                            style: {
                                maxWidth: "200px"
                            },
                            children: " "
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/careers/header.js + 2 modules
var header = __webpack_require__(31061);
// EXTERNAL MODULE: ./src/components/careers/footer.js + 5 modules
var footer = __webpack_require__(96719);
// EXTERNAL MODULE: ./src/actions/pages/clients/careers/customize-career-page.js
var customize_career_page = __webpack_require__(10691);
// EXTERNAL MODULE: ../../shared/node_modules/react-google-font-loader/build/index.js
var build = __webpack_require__(84501);
;// CONCATENATED MODULE: ./src/imports-files/pages/career/view-job.js
//-----------------StyleSheet-----------------



//-----------------StyleSheet-----------------
//-----------------Components-----------------


//-----------------Components-----------------
//-----------------Custom Components--------------

//-----------------Custom Components--------------
//----------------- Images --------------------




//----------------- Images --------------------

















/***/ }),

/***/ 7485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "W$": function() { return /* reexport */ activities/* ActivitiesAction */.W; },
  "zx": function() { return /* reexport */ components_button/* default */.Z; },
  "ZJ": function() { return /* reexport */ (button_index_module_default()); },
  "tl": function() { return /* reexport */ custom_company_integration_modal/* CONSTANTS */.tl; },
  "LD": function() { return /* reexport */ common/* ClientDashboard */.LD; },
  "qI": function() { return /* reexport */ ClientIntegration; },
  "Tk": function() { return /* reexport */ company_integrations/* CompanyIntegrationAction */.Tk; },
  "Cv": function() { return /* reexport */ CompanyIntegrationService; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "Vk": function() { return /* reexport */ CvLibrary; },
  "I8": function() { return /* reexport */ edit/* default */.Z; },
  "dC": function() { return /* reexport */ common/* ErrorPages */.dC; },
  "wn": function() { return /* reexport */ filter/* default */.Z; },
  "l0": function() { return /* reexport */ common/* Form */.l0; },
  "J9": function() { return /* reexport */ common/* Formik */.J9; },
  "gt": function() { return /* reexport */ common/* FormikControl */.gt; },
  "Ee": function() { return /* reexport */ common/* Image */.Ee; },
  "pd": function() { return /* reexport */ input_error/* InputError */.p; },
  "hJ": function() { return /* reexport */ integration_connected/* IntegrationConnect */.h; },
  "Mf": function() { return /* reexport */ common/* PAGE_ANIMATION_OPTIONS */.Mf; },
  "k2": function() { return /* reexport */ (new_index_module_default()); },
  "v3": function() { return /* reexport */ plus/* default */.Z; },
  "RQ": function() { return /* reexport */ common/* REDIRECT */.RQ; },
  "Us": function() { return /* reexport */ common/* SUCCESS_REPONSE_CODE */.Us; },
  "Lt": function() { return /* reexport */ common/* SendRequest */.Lt; },
  "Dv": function() { return /* reexport */ common/* SidebarAction */.Dv; },
  "if": function() { return /* reexport */ skip_modal/* SkipModal */.i; },
  "z0": function() { return /* reexport */ (integration_index_module_default()); },
  "TA": function() { return /* reexport */ common/* TRANSLATION */.TA; },
  "iA": function() { return /* reexport */ Table/* default */.Z; },
  "RM": function() { return /* reexport */ TableBody/* default */.Z; },
  "pj": function() { return /* reexport */ TableCell/* default */.Z; },
  "xJ": function() { return /* reexport */ TableContainer/* default */.Z; },
  "ss": function() { return /* reexport */ TableHead/* default */.Z; },
  "SC": function() { return /* reexport */ TableRow/* default */.Z; },
  "t9": function() { return /* reexport */ common/* UNAUTHORIZED_REPONSE_CODE */.t9; },
  "Mn": function() { return /* reexport */ common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn; },
  "sm": function() { return /* reexport */ common/* Yup */.sm; },
  "Sr": function() { return /* reexport */ common/* addParamsToUrl */.Sr; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "CT": function() { return /* reexport */ client_integrations/* connectDisconnectIntegration */.CT; },
  "qL": function() { return /* reexport */ client_integrations/* createIntegrationData */.qL; },
  "rF": function() { return /* reexport */ client_integrations/* cvLibraryValidations */.rF; },
  "Hx": function() { return /* reexport */ client_integrations/* getButtonClass */.Hx; },
  "BN": function() { return /* reexport */ client_integrations/* getClientIntegrationData */.BN; },
  "zH": function() { return /* reexport */ client_integrations/* getIntegrationsStatus */.zH; },
  "Mm": function() { return /* reexport */ custom_company_integration_modal/* getLinkedInJobsModal */.Mm; },
  "Gg": function() { return /* reexport */ common/* getSession */.Gg; },
  "KX": function() { return /* reexport */ custom_company_integration_modal/* getTotalJobsModal */.KX; },
  "oq": function() { return /* reexport */ custom_company_integration_modal/* getindeedModal */.oq; },
  "A6": function() { return /* reexport */ client_integrations/* handleCvLibrarySubmit */.A6; },
  "GB": function() { return /* reexport */ common/* handleOtherResponseCode */.GB; },
  "gs": function() { return /* reexport */ common/* imageSize */.gs; },
  "EA": function() { return /* reexport */ common/* motion */.EA; },
  "zJ": function() { return /* reexport */ company_integrations/* setDisabledIntegrationData */.zJ; },
  "RY": function() { return /* reexport */ company_integrations/* setIntegrationData */.RY; },
  "z9": function() { return /* reexport */ client_integrations/* turnOnOffAccessibility */.z9; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: ConfirmationModal, Field, FieldArray, Link, NextServerCookies, ROWS, Sidebar, TablePagination, createData, toastr

// EXTERNAL MODULE: ../../shared/node_modules/@material-ui/core/esm/Table/Table.js
var Table = __webpack_require__(89628);
// EXTERNAL MODULE: ../../shared/node_modules/@material-ui/core/esm/TableBody/TableBody.js
var TableBody = __webpack_require__(76748);
// EXTERNAL MODULE: ../../shared/node_modules/@material-ui/core/esm/TableCell/TableCell.js
var TableCell = __webpack_require__(17864);
// EXTERNAL MODULE: ../../shared/node_modules/@material-ui/core/esm/TableContainer/TableContainer.js
var TableContainer = __webpack_require__(83728);
// EXTERNAL MODULE: ../../shared/node_modules/@material-ui/core/esm/TableHead/TableHead.js
var TableHead = __webpack_require__(90222);
// EXTERNAL MODULE: ../../shared/node_modules/@material-ui/core/esm/TableRow/TableRow.js
var TableRow = __webpack_require__(14898);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/constants/pages/clients/manage-integration.js + 5 modules
var manage_integration = __webpack_require__(30003);
// EXTERNAL MODULE: ./src/constants/components/modals/custom-company-integration-modal.js
var custom_company_integration_modal = __webpack_require__(40168);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/styles/components/cv-library/_index.module.scss
var _index_module = __webpack_require__(44479);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
;// CONCATENATED MODULE: ./src/components/cv-library.js




function CvLibrary(props) {
    var router = (0,common/* useRouter */.tv)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(null), 2), apiError = ref[0], setApiError = ref[1];
    var errorPages = new common/* ErrorPages */.dC();
    var initialValues = {
        username: "",
        password: ""
    };
    if (errorPages.handleErrorCodes(apiError === null || apiError === void 0 ? void 0 : apiError.status)) {
        var renderPage = apiError ? errorPages.renderPage(apiError === null || apiError === void 0 ? void 0 : apiError.status, router) : null;
        return renderPage;
    }
    return props.trigger ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((_index_module_default()).Modalpopup),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((_index_module_default()).CvModal),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (_index_module_default()).OtpBacksection2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (_index_module_default()).Otpback,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                            buttonstyle: (_index_module_default()).nobgbutton,
                            type: "button",
                            onClick: function() {
                                return props.setCvLibraryModal(false);
                            },
                            children: "Close"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (_index_module_default()).Logincontent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (_index_module_default()).Logincontent__title,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: "CV Library"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (_index_module_default()).Form,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Formik */.J9, {
                                initialValues: initialValues,
                                validationSchema: client_integrations/* cvLibraryValidations */.rF,
                                onSubmit: function(values) {
                                    return (0,client_integrations/* handleCvLibrarySubmit */.A6)(values, props.row, router, props.setCvLibraryModal, setApiError);
                                },
                                children: function(formik) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Form */.l0, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (_index_module_default()).Form__container,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (_index_module_default()).Form__Container,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                        control: "input",
                                                        formik: formik,
                                                        type: "text",
                                                        name: "username",
                                                        placeholder: "Username",
                                                        className: "width100 ".concat((_index_module_default()).Form__Input),
                                                        errorClass: (_index_module_default()).Form__error,
                                                        style: (0,input_error/* InputError */.p)(formik, "username")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (_index_module_default()).Form__Container,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                        control: "input",
                                                        formik: formik,
                                                        type: "password",
                                                        name: "password",
                                                        placeholder: "Password",
                                                        className: "width100 ".concat((_index_module_default()).Form__Input),
                                                        errorClass: (_index_module_default()).Form__error,
                                                        style: (0,input_error/* InputError */.p)(formik, "password")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                    buttonstyle: (_index_module_default()).primarybtn,
                                                    type: "submit",
                                                    children: "Submit"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                    buttonstyle: (_index_module_default()).secondarybtnborder,
                                                    type: "button",
                                                    onClick: function() {
                                                        return props.setCvLibraryModal(false);
                                                    },
                                                    children: "Cancel"
                                                })
                                            ]
                                        })
                                    });
                                }
                            })
                        })
                    ]
                })
            ]
        })
    }) : "";
}

// EXTERNAL MODULE: ./src/components/skip-modal.js
var skip_modal = __webpack_require__(53594);
// EXTERNAL MODULE: ./src/components/confirmation-modal.js
var confirmation_modal = __webpack_require__(72055);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
;// CONCATENATED MODULE: ./src/services/pages/clients/activities/client-integrations.js







var ClientIntegration = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(ClientIntegration, SendRequest);
    var _super = (0,_create_super/* default */.Z)(ClientIntegration);
    function ClientIntegration() {
        (0,_class_call_check/* default */.Z)(this, ClientIntegration);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ClientIntegration, [
        {
            key: "getIntegrationsList",
            value: function getIntegrationsList(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.activities.CLIENT_INTEGRATIONS_URL */.bl.client.activities.CLIENT_INTEGRATIONS_URL;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateIntegrationAccessibility",
            value: function updateIntegrationAccessibility(params, integration_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.activities.INTEGRATION_ACCESSIBILITY_URL.replace */.bl.client.activities.INTEGRATION_ACCESSIBILITY_URL.replace("$integration_id", integration_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disconnectIntegration",
            value: function disconnectIntegration(params, integration_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.activities.DISCONNECT_INTEGRATION.replace */.bl.client.activities.DISCONNECT_INTEGRATION.replace("$integration_id", integration_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.delete */.od["delete"](url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCustomIntegrationsList",
            value: function getCustomIntegrationsList() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.activities.CUSTOM_INTEGRATIONS */.bl.client.activities.CUSTOM_INTEGRATIONS;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(url, (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ClientIntegration;
}(common/* SendRequest */.Lt);

// EXTERNAL MODULE: ./src/services/pages/clients/activities/integration-connected.js
var integration_connected = __webpack_require__(90317);
// EXTERNAL MODULE: ./src/actions/pages/clients/activities/client-integrations.js
var client_integrations = __webpack_require__(79925);
// EXTERNAL MODULE: ./src/actions/common/input-error.js
var input_error = __webpack_require__(54911);
// EXTERNAL MODULE: ./src/actions/pages/clients/activities/index.js
var activities = __webpack_require__(41767);
// EXTERNAL MODULE: ./public/icons/edit.svg
var edit = __webpack_require__(81737);
// EXTERNAL MODULE: ./public/icons/plus.svg
var plus = __webpack_require__(65099);
// EXTERNAL MODULE: ./public/icons/filter.svg
var filter = __webpack_require__(97489);
// EXTERNAL MODULE: ./src/styles/pages/admins/dashboard/clients/new/_index.module.scss
var new_index_module = __webpack_require__(10994);
var new_index_module_default = /*#__PURE__*/__webpack_require__.n(new_index_module);
// EXTERNAL MODULE: ./src/styles/pages/admins/dashboard/clients/integration/_index.module.scss
var integration_index_module = __webpack_require__(84370);
var integration_index_module_default = /*#__PURE__*/__webpack_require__.n(integration_index_module);
// EXTERNAL MODULE: ./src/styles/components/button/_index.module.scss
var button_index_module = __webpack_require__(84215);
var button_index_module_default = /*#__PURE__*/__webpack_require__.n(button_index_module);
// EXTERNAL MODULE: ./src/actions/pages/clients/activities/company-integrations.js
var company_integrations = __webpack_require__(89339);
;// CONCATENATED MODULE: ./src/services/pages/clients/activities/company-integrations.js







var CompanyIntegrationService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(CompanyIntegrationService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(CompanyIntegrationService);
    function CompanyIntegrationService() {
        (0,_class_call_check/* default */.Z)(this, CompanyIntegrationService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CompanyIntegrationService, [
        {
            key: "applyFilter",
            value: function applyFilter(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, transformedParams, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.activities.CLIENT_INTEGRATIONS_URL */.bl.client.activities.CLIENT_INTEGRATIONS_URL;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                transformedParams = Object.keys(params).filter(function(key) {
                                    return params[key] === true && key;
                                });
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(url, (_tmp.params = {
                                        integration_category: transformedParams
                                    }, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "applyClientFilter",
            value: function applyClientFilter(params, client_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, transformedParams, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.admins.dashboard.clients.integration.CLIENT_INTEGRATIONS_URL.replace */.bl.admins.dashboard.clients.integration.CLIENT_INTEGRATIONS_URL.replace("$client_id", client_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                transformedParams = Object.keys(params).filter(function(key) {
                                    return params[key] === true && key;
                                });
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(url, (_tmp.params = {
                                        integration_category: transformedParams
                                    }, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CompanyIntegrationService;
}(common/* SendRequest */.Lt);

;// CONCATENATED MODULE: ./src/imports-files/pages/clients/activities/client-integrations.js
// -------------------- Material Ui Table Components --------------

// -------------------- Material Ui Table Components --------------
// ----------------------------- COMMON ---------------------------------------

// ----------------------------- COMMON ---------------------------------------
// ----------------- Constants ---------------------


// ----------------- Constants ---------------------
// -----------------------------  CUSTOM COMPONENTS -----------------------------




// -----------------------------  CUSTOM COMPONENTS -----------------------------





// ---------------------------- ICONS -------------------------------------



// ---------------------------- ICONS -------------------------------------
// ---------------------------- Stylesheet -------------------------------------



// ----------------------------- Stylesheet ------------------------------------
// ---------------------------- Actions -------------------------------------

// ---------------------------- Actions -------------------------------------
// ---------------------------- Services -------------------------------------
 // ---------------------------- Services -------------------------------------


/***/ }),

/***/ 14683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "W$": function() { return /* reexport */ activities/* ActivitiesAction */.W; },
  "T5": function() { return /* reexport */ add_team["default"]; },
  "jd": function() { return /* reexport */ agency_accept_reject/* AgencyAcceptRejectModal */.j; },
  "ov": function() { return /* reexport */ common/* BrowserDetect */.ov; },
  "ij": function() { return /* reexport */ BrowserNotification; },
  "f": function() { return /* reexport */ calender/* default */.Z; },
  "TU": function() { return /* reexport */ CalendarAction; },
  "aw": function() { return /* reexport */ calendar_date; },
  "CH": function() { return /* reexport */ calendar_month; },
  "u$": function() { return /* reexport */ calendar_week; },
  "ai": function() { return /* reexport */ candidate_merge_action/* CandidateMergeAction */.a; },
  "$p": function() { return /* reexport */ career_setting["default"]; },
  "LD": function() { return /* reexport */ common/* ClientDashboard */.LD; },
  "SU": function() { return /* reexport */ clocktime; },
  "x8": function() { return /* reexport */ icons_close/* default */.Z; },
  "x4": function() { return /* reexport */ common/* CommonAction */.x4; },
  "gy": function() { return /* reexport */ message; },
  "bU": function() { return /* reexport */ company_integrations["default"]; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "sp": function() { return /* reexport */ DashboardService; },
  "dC": function() { return /* reexport */ common/* ErrorPages */.dC; },
  "Ee": function() { return /* reexport */ common/* Image */.Ee; },
  "v_": function() { return /* reexport */ index_es/* default */.Z; },
  "UI": function() { return /* reexport */ information_modal/* InformationModal */.U; },
  "ZU": function() { return /* reexport */ InterviewListDetails; },
  "GK": function() { return /* reexport */ merge_records/* MergeRecordsService */.G; },
  "Qb": function() { return /* reexport */ dashboard_my_account["default"]; },
  "kQ": function() { return /* reexport */ my_integration["default"]; },
  "Ng": function() { return /* reexport */ my_preferences["default"]; },
  "Qx": function() { return /* reexport */ my_team_service/* MyTeamService */.Q; },
  "xR": function() { return /* reexport */ NextSteps; },
  "vk": function() { return /* reexport */ OfferRejectedReasons; },
  "Mf": function() { return /* reexport */ common/* PAGE_ANIMATION_OPTIONS */.Mf; },
  "k2": function() { return /* reexport */ (progressline_index_module_default()); },
  "pu": function() { return /* reexport */ privacy_policy["default"]; },
  "CS": function() { return /* reexport */ progressline; },
  "YU": function() { return /* reexport */ quick_add/* default */.Z; },
  "RQ": function() { return /* reexport */ common/* REDIRECT */.RQ; },
  "Us": function() { return /* reexport */ common/* SUCCESS_REPONSE_CODE */.Us; },
  "Lt": function() { return /* reexport */ common/* SendRequest */.Lt; },
  "ck": function() { return /* reexport */ SetIcons; },
  "Tw": function() { return /* reexport */ SmallWarning/* default */.Z; },
  "OK": function() { return /* reexport */ esm/* Tab */.OK; },
  "td": function() { return /* reexport */ esm/* TabList */.td; },
  "AY": function() { return /* reexport */ esm/* TabPanel */.x4; },
  "mQ": function() { return /* reexport */ esm/* Tabs */.mQ; },
  "MT": function() { return /* reexport */ third_party_logo/* default */.Z; },
  "u": function() { return /* reexport */ common/* Tooltip */.u; },
  "Mn": function() { return /* reexport */ common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn; },
  "OE": function() { return /* reexport */ user_switch/* UserSwitch */.O; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "A$": function() { return /* reexport */ common/* clearSWRCache */.A$; },
  "jL": function() { return /* reexport */ close_modal/* closeModalUsingState */.j; },
  "GB": function() { return /* reexport */ common/* handleOtherResponseCode */.GB; },
  "EA": function() { return /* reexport */ common/* motion */.EA; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "Oz": function() { return /* reexport */ usePushNotifications; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; },
  "aF": function() { return /* reexport */ common/* useUser */.aF; }
});

// UNUSED EXPORTS: ACTIVITIES, ArrowDown, ArrowDown2, ArrowUp, ArrowUp2, Button, ButtonStyle, ConfirmationModal, CustomizeCareer, Face, Link, Loading, MY_ACCOUNT, MyAccountService, Phone, SkipModal, TRANSLATION, Tech, UNAUTHORIZED_REPONSE_CODE, Video, Warning, Yup, getSession, logoutUser, toastr, useRef

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/qs/lib/index.js
var lib = __webpack_require__(69800);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./src/services/pages/clients/activities/index.js








var DashboardService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(DashboardService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(DashboardService);
    function DashboardService() {
        (0,_class_call_check/* default */.Z)(this, DashboardService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(DashboardService, [
        {
            key: "getDashboardData",
            value: function getDashboardData() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, host_name, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.activities.DASHBOARD */.bl.client.activities.DASHBOARD;
                                host_name = _this.customHeaderJSON();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(url, (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateOnboardingStep",
            value: function updateOnboardingStep(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.activities.UPDATE_ONBOARDING_STEP */.bl.client.activities.UPDATE_ONBOARDING_STEP;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "dismiss",
            value: function dismiss(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(common/* API.client.activities.DISMISS_ONBOARDING */.bl.client.activities.DISMISS_ONBOARDING, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getActivityData",
            value: function getActivityData() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(common/* API.client.activities.SHOW_ACTIVITIES_DATA */.bl.client.activities.SHOW_ACTIVITIES_DATA, (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getScrollActivityData",
            value: function getScrollActivityData(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(common/* API.client.activities.SHOW_ACTIVITIES_DATA */.bl.client.activities.SHOW_ACTIVITIES_DATA, (_tmp.headers = _this.customHeaderJSON(), _tmp.params = params, _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getEventData",
            value: function getEventData(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(common/* API.client.activities.SHOW_ACTIVITIES_DATA */.bl.client.activities.SHOW_ACTIVITIES_DATA, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp.paramsSerializer = function paramsSerializer(params) {
                                        return lib_default().stringify(params, {
                                            arrayFormat: "brackets"
                                        });
                                    }, _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "dismissNotification",
            value: function dismissNotification(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(common/* API.client.activities.DISMISS_ALERT_COMM */.bl.client.activities.DISMISS_ALERT_COMM, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getOfferRejectedReason",
            value: function getOfferRejectedReason(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(common/* API.client.activities.OFFER_REJECTED_REASONS.replace */.bl.client.activities.OFFER_REJECTED_REASONS.replace("$offer_id", params.offer_id), (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getJobRejectedReason",
            value: function getJobRejectedReason(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(common/* API.client.activities.OFFER_REJECTED_REASONS.replace */.bl.client.activities.OFFER_REJECTED_REASONS.replace("$offer_id", params.offer_id), (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return DashboardService;
}(common/* SendRequest */.Lt);

// EXTERNAL MODULE: ./src/services/pages/clients/my-account-service.js
var my_account_service = __webpack_require__(68711);
// EXTERNAL MODULE: ./src/services/pages/clients/my-team-service.js
var my_team_service = __webpack_require__(16424);
// EXTERNAL MODULE: ./src/services/pages/clients/jobs/merge-records.js
var merge_records = __webpack_require__(4185);
// EXTERNAL MODULE: ./src/actions/pages/clients/activities/index.js
var activities = __webpack_require__(41767);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ../../shared/node_modules/next/router.js
var next_router = __webpack_require__(34357);
// EXTERNAL MODULE: ../../shared/node_modules/date-fns/esm/format/index.js + 20 modules
var format = __webpack_require__(6202);
// EXTERNAL MODULE: ../../shared/node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(25367);
// EXTERNAL MODULE: ../../shared/node_modules/date-fns/esm/subDays/index.js
var subDays = __webpack_require__(86418);
// EXTERNAL MODULE: ../../shared/node_modules/date-fns/esm/isSameDay/index.js + 1 modules
var isSameDay = __webpack_require__(49385);
// EXTERNAL MODULE: ../../shared/node_modules/date-fns/esm/startOfWeek/index.js
var startOfWeek = __webpack_require__(90140);
// EXTERNAL MODULE: ../../shared/node_modules/date-fns/esm/lastDayOfWeek/index.js
var lastDayOfWeek = __webpack_require__(71329);
// EXTERNAL MODULE: ../../shared/node_modules/date-fns/esm/addWeeks/index.js
var addWeeks = __webpack_require__(17918);
// EXTERNAL MODULE: ../../shared/node_modules/date-fns/esm/subWeeks/index.js
var subWeeks = __webpack_require__(72130);
// EXTERNAL MODULE: ../../shared/node_modules/date-fns/esm/isSameMonth/index.js
var isSameMonth = __webpack_require__(96057);
// EXTERNAL MODULE: ../../shared/node_modules/date-fns/esm/addMonths/index.js
var addMonths = __webpack_require__(3579);
// EXTERNAL MODULE: ../../shared/node_modules/date-fns/esm/subMonths/index.js
var subMonths = __webpack_require__(62569);
// EXTERNAL MODULE: ../../shared/node_modules/date-fns/esm/startOfMonth/index.js
var startOfMonth = __webpack_require__(84689);
// EXTERNAL MODULE: ../../shared/node_modules/date-fns/esm/endOfMonth/index.js
var endOfMonth = __webpack_require__(82186);
// EXTERNAL MODULE: ../../shared/node_modules/date-fns/esm/locale/nb/index.js + 5 modules
var nb = __webpack_require__(71546);
// EXTERNAL MODULE: ../../shared/node_modules/date-fns/esm/locale/en-US/index.js + 5 modules
var en_US = __webpack_require__(20131);
// EXTERNAL MODULE: ../../shared/node_modules/date-fns/esm/locale/sv/index.js + 5 modules
var sv = __webpack_require__(14144);
// EXTERNAL MODULE: ../../shared/node_modules/date-fns/esm/locale/da/index.js + 5 modules
var da = __webpack_require__(57014);
// EXTERNAL MODULE: ./public/icons/chevron-red-left.svg
var chevron_red_left = __webpack_require__(11676);
// EXTERNAL MODULE: ./public/icons/chevron-red-right.svg
var chevron_red_right = __webpack_require__(99295);
// EXTERNAL MODULE: ./src/actions/common/common.js
var common_common = __webpack_require__(1739);
// EXTERNAL MODULE: ./src/imports-files/pages/admins/logout.js + 1 modules
var logout = __webpack_require__(63281);
;// CONCATENATED MODULE: ./src/services/components/calendar/calendar.js









var CalandarService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(CalandarService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(CalandarService);
    function CalandarService() {
        (0,_class_call_check/* default */.Z)(this, CalandarService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CalandarService, [
        {
            key: "getEventData",
            value: function getEventData(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(common/* API.client.activities.SHOW_ACTIVITIES_DATA */.bl.client.activities.SHOW_ACTIVITIES_DATA, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp.paramsSerializer = function paramsSerializer(params) {
                                        return lib_default().stringify(params, {
                                            arrayFormat: "brackets"
                                        });
                                    }, _tmp))
                                ];
                            case 1:
                                result = _state.sent();
                                // var end = new Date().getTime();
                                // var time = end - start;
                                // alert(time);
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CalandarService;
}(logout/* SendRequest */.Lt);

// EXTERNAL MODULE: ./src/styles/components/calendar/_index.module.scss
var _index_module = __webpack_require__(35714);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
;// CONCATENATED MODULE: ./src/imports-files/components/calendar/calendar.js




// ------------------- ICONS -------------------


// ------------------- ICONS -------------------
// ------------------- STYLESHEET -------------------




 // ------------------- STYLESHEET -------------------

;// CONCATENATED MODULE: ./src/actions/components/calendar/calendar.js



var CalendarAction = /*#__PURE__*/ function() {
    "use strict";
    function CalendarAction(setCalendarData, calendarHash, router, setCalendarDataArray) {
        (0,_class_call_check/* default */.Z)(this, CalendarAction);
        this.calandatService = new CalandarService();
        this.setCalendarData = setCalendarData;
        this.calendarHash = calendarHash;
        this.commonAction = new common_common/* CommonAction */.x();
        this.router = router;
        this.setCalendarDataArray = setCalendarDataArray;
    }
    (0,_create_class/* default */.Z)(CalendarAction, [
        {
            key: "getCalanderData",
            value: function getCalanderData(calendarHash) {
                var body = {
                    activities: calendarHash
                };
                body.activities.current_date = this.commonAction.getDateInString(body.activities.current_date);
                var k_this = this;
                this.calandatService.getEventData(body).then(function(result) {
                    var calendar_array = result.data.data.events.data;
                    var calendar_data_array = result.data.data.events.date_range_array;
                    k_this.setCalendarData(calendar_array);
                    k_this.setCalendarDataArray(calendar_data_array);
                });
            }
        },
        {
            key: "setTodayDate",
            value: function setTodayDate(setTodayClick) {
                // We are just changing the state of the page which rerender the component
                // and set the selected date
                this.calendarHash.current_date = this.commonAction.getDateInDMYFormat(new Date());
                this.calendarHash.selected_tab = this.commonAction.getParamsToUrlWithoutRouter("selected_tab");
                this.calendarHash.is_my_interviews = this.commonAction.getParamsToUrlWithoutRouter("is_my_interviews");
                this.commonAction.paramsToUrlWithoutRouter(this.calendarHash, this.router);
                setTodayClick(true);
                document.querySelector(".react-tabs__today").classList.add("react-tabs__tab--selected");
                return Math.random() * 1000;
            }
        },
        {
            key: "setTabIndex",
            value: function setTabIndex() {
                var selected_tab = this.router.query.selected_tab;
                switch(selected_tab){
                    case "day":
                        return 0;
                    case "week":
                        return 1;
                    case "month":
                        return 2;
                    default:
                        return 2;
                }
            }
        },
        {
            key: "changeDateHandle",
            value: function changeDateHandle(btnType, currentDate, setCurrentDate, setTodayClick) {
                if (btnType === "prev") {
                    setCurrentDate((0,subDays/* default */.Z)(currentDate, 1));
                    this.calendarHash.current_date = (0,subDays/* default */.Z)(currentDate, 1).toLocaleDateString();
                    ;
                    this.getCalanderData(this.calendarHash);
                    setTodayClick(false);
                    this.commonAction.paramsToUrlWithoutRouter(this.calendarHash, this.router);
                }
                if (btnType === "next") {
                    setCurrentDate((0,addDays/* default */.Z)(currentDate, 1));
                    this.calendarHash.current_date = (0,addDays/* default */.Z)(currentDate, 1).toLocaleDateString();
                    ;
                    this.getCalanderData(this.calendarHash);
                    setTodayClick(false);
                    this.commonAction.paramsToUrlWithoutRouter(this.calendarHash, this.router);
                }
            }
        },
        {
            //------------------- MONTH ----------------
            key: "changeMonthHandle",
            value: function changeMonthHandle(btnType, currentMonth, setCurrentMonth) {
                if (btnType === "prev") {
                    setCurrentMonth((0,subMonths/* default */.Z)(currentMonth, 1));
                }
                if (btnType === "next") {
                    setCurrentMonth((0,addMonths/* default */.Z)(currentMonth, 1));
                }
            }
        },
        {
            key: "onMonthDateClickHandle",
            value: function onMonthDateClickHandle(day, dayStr, setSelectedDate, setTodayClick) {
                setSelectedDate(day);
                this.calendarHash.current_date = this.commonAction.getDateInDMYFormat(day);
                this.getCalanderData(this.calendarHash);
                setTodayClick(false);
                this.commonAction.paramsToUrlWithoutRouter(this.calendarHash, this.router);
            // showDetailsHandle(dayStr);
            }
        },
        {
            //------------------- MONTH ----------------
            //------------------- WEEK ----------------
            key: "changeWeekHandle",
            value: function changeWeekHandle(btnType, currentWeek, setCurrentWeek) {
                if (btnType === "prev") {
                    setCurrentWeek((0,subWeeks/* default */.Z)(currentWeek, 1));
                }
                if (btnType === "next") {
                    setCurrentWeek((0,addWeeks/* default */.Z)(currentWeek, 1));
                }
            }
        },
        {
            key: "onWeekDateClickHandle",
            value: function onWeekDateClickHandle(day, dayStr, setSelectedDate, setTodayClick) {
                setSelectedDate(day);
                this.calendarHash.current_date = this.commonAction.getDateInDMYFormat(day);
                this.getCalanderData(this.calendarHash);
                setTodayClick(false);
                this.commonAction.paramsToUrlWithoutRouter(this.calendarHash, this.router);
            // showDetailsHandle1(dayStr);
            }
        },
        {
            //------------------- WEEK ----------------
            key: "onArrowClickHandle",
            value: function onArrowClickHandle(day, dayStr, setTodayClick) {
                this.calendarHash.calendar_date = this.commonAction.getDateInDMYFormat(day);
                this.getCalanderData(this.calendarHash);
                setTodayClick(false);
                this.commonAction.paramsToUrlWithoutRouter(this.calendarHash, this.router);
            }
        },
        {
            key: "greenDotClass",
            value: function greenDotClass(date, dateArray, klass) {
                date = this.appendZero(date);
                return dateArray.indexOf(date) != -1 ? klass : "";
            }
        },
        {
            key: "appendZero",
            value: function appendZero(str) {
                var date = str.split("/")[0];
                return date.length >= 2 ? str : "0" + str;
            }
        }
    ]);
    return CalendarAction;
}();

// EXTERNAL MODULE: ./src/actions/pages/clients/activities/candidate-merge-action.js
var candidate_merge_action = __webpack_require__(52848);
// EXTERNAL MODULE: ./src/constants/pages/clients/my-account.js
var my_account = __webpack_require__(67734);
;// CONCATENATED MODULE: ./src/constants/pages/clients/activities/index.js
var ACTIVITIES = {
    texts: {},
    calander_view_Dummy_data: [
        {
            week_name: "15 Dec -  22Dec",
            current_week: false,
            scheduled_data: [
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview",
                    interviewee_name: "Rahul",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=1",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=5",
                            initials: "VI"
                        }
                    ],
                    date: "03/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "04/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "05/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "06/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "07/01/2022",
                    time: "16:88"
                }
            ],
            week_number: 51,
            year: 2021
        },
        {
            week_name: "23 Dec - 31 Dec",
            current_week: false,
            scheduled_data: [
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview",
                    interviewee_name: "Rahul",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=1",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=5",
                            initials: "VI"
                        }
                    ],
                    date: "03/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "04/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "05/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "06/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "07/01/2022",
                    time: "16:88"
                }
            ],
            week_number: 52,
            year: 2021
        },
        {
            week_name: "01 Jan - 07 Jan",
            current_week: true,
            scheduled_data: [
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview",
                    interviewee_name: "Rahul",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=1",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=5",
                            initials: "VI"
                        }
                    ],
                    date: "03/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "04/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "05/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "06/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "07/01/2022",
                    time: "16:88"
                }
            ],
            week_number: 1,
            year: 2022
        },
        {
            id: "2",
            week_name: "08 Jan - 14 Jan",
            current_week: false,
            scheduled_data: [
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview",
                    interviewee_name: "Rahul",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=1",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=5",
                            initials: "VI"
                        }
                    ],
                    date: "12/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "13/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "14/01/2022",
                    time: "16:88"
                }
            ],
            week_number: 2,
            year: 2022
        },
        {
            id: "3",
            week_name: "09 Jan - 21 Jan",
            current_week: false,
            scheduled_data: [
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview",
                    interviewee_name: "Rahul",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=1",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=5",
                            initials: "VI"
                        }
                    ],
                    date: "12/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "13/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "14/01/2022",
                    time: "16:88"
                }
            ],
            week_number: 3,
            year: 2022
        },
        {
            id: "4",
            week_name: "22 Jan - 28 Jan",
            current_week: false,
            scheduled_data: [
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview",
                    interviewee_name: "Rahul",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=1",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=5",
                            initials: "VI"
                        }
                    ],
                    date: "12/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "13/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "14/01/2022",
                    time: "16:88"
                }
            ],
            week_number: 4,
            year: 2022
        },
        {
            id: "5",
            week_name: "29 Jan - 4 Feb",
            current_week: false,
            scheduled_data: [
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview",
                    interviewee_name: "Rahul",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=1",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=5",
                            initials: "VI"
                        }
                    ],
                    date: "12/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "13/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "14/01/2022",
                    time: "16:88"
                }
            ],
            week_number: 5,
            year: 2022
        },
        {
            id: "6",
            week_name: "5 Feb - 11 Feb",
            current_week: false,
            scheduled_data: [
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview",
                    interviewee_name: "Rahul",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=1",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=5",
                            initials: "VI"
                        }
                    ],
                    date: "12/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "13/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "14/01/2022",
                    time: "16:88"
                }
            ],
            week_number: 6,
            year: 2022
        },
        {
            id: "4",
            week_name: "12 Feb - 18 Feb",
            current_week: false,
            scheduled_data: [
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview",
                    interviewee_name: "Rahul",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=1",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=5",
                            initials: "VI"
                        }
                    ],
                    date: "12/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "13/01/2022",
                    time: "16:88"
                },
                {
                    interview_link: "www.googl.com",
                    interview_type: "Video Interview 1",
                    interviewee_name: "Rahul 1",
                    interviewers_info: [
                        {
                            image_url: "https://picsum.photos/200/300?random=11",
                            initials: "VI"
                        },
                        {
                            image_url: "https://picsum.photos/200/300?random=12",
                            initials: "VI"
                        }
                    ],
                    date: "14/01/2022",
                    time: "16:88"
                }
            ],
            week_number: 7,
            year: 2022
        }, 
    ]
};

// EXTERNAL MODULE: ./src/components/third-party-logo.js + 2 modules
var third_party_logo = __webpack_require__(50261);
// EXTERNAL MODULE: ./src/components/quick-add.js
var quick_add = __webpack_require__(35294);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/styles/components/progressline/_index.module.scss
var progressline_index_module = __webpack_require__(39923);
var progressline_index_module_default = /*#__PURE__*/__webpack_require__.n(progressline_index_module);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
// EXTERNAL MODULE: ./src/constants/common/urls.js
var urls = __webpack_require__(47694);
// EXTERNAL MODULE: ../../shared/node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(73732);
;// CONCATENATED MODULE: ./src/components/dashboardComponents/next-steps.js





function NextSteps(param) {
    var pending_steps = param.pending_steps, router = param.router;
    var redirectStep = function redirectStep(router, step) {
        var url = "".concat(urls/* REDIRECT.client.quick_setup */.R.client.quick_setup).concat(step);
        router.push(url);
    };
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (pending_steps === null || pending_steps === void 0 ? void 0 : pending_steps.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (progressline_index_module_default()).ProgressLineSection__AcionSection,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    children: t("actions")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: (progressline_index_module_default()).ProgressLineSection__ActionButtons,
                    children: pending_steps.map(function(step, index) {
                        switch(step){
                            case "add_teams":
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        buttonstyle: (progressline_index_module_default()).secondarybtnborder,
                                        type: "button",
                                        onClick: function() {
                                            return redirectStep(router, step);
                                        },
                                        children: t("quick_add:add_team")
                                    })
                                }, "onboarding-step-".concat(index));
                                break;
                            case "company_integrations":
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        buttonstyle: (progressline_index_module_default()).secondarybtnborder,
                                        type: "button",
                                        onClick: function() {
                                            return redirectStep(router, step);
                                        },
                                        children: t("quick_add:company_integrations")
                                    })
                                }, "onboarding-step-".concat(index));
                                break;
                            case "careers_page":
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        buttonstyle: (progressline_index_module_default()).secondarybtnborder,
                                        type: "button",
                                        onClick: function() {
                                            return redirectStep(router, step);
                                        },
                                        children: t("quick_add:careers_page")
                                    })
                                }, "onboarding-step-".concat(index));
                                break;
                            case "privacy_policy":
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        buttonstyle: (progressline_index_module_default()).secondarybtnborder,
                                        type: "button",
                                        onClick: function() {
                                            return redirectStep(router, step);
                                        },
                                        children: t("quick_add:privacy_policy")
                                    })
                                }, "onboarding-step-".concat(index));
                                break;
                            case "my_account":
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        buttonstyle: (progressline_index_module_default()).secondarybtnborder,
                                        type: "button",
                                        onClick: function() {
                                            return redirectStep(router, step);
                                        },
                                        children: t("quick_add:my_account")
                                    })
                                }, "onboarding-step-".concat(index));
                                break;
                            case "my_integrations":
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        buttonstyle: (progressline_index_module_default()).secondarybtnborder,
                                        type: "button",
                                        onClick: function() {
                                            return redirectStep(router, step);
                                        },
                                        children: t("quick_add:my_integrations")
                                    })
                                }, "onboarding-step-".concat(index));
                                break;
                            case "my_preferences":
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        buttonstyle: (progressline_index_module_default()).secondarybtnborder,
                                        type: "button",
                                        onClick: function() {
                                            return redirectStep(router, step);
                                        },
                                        children: t("quick_add:my_preferences")
                                    })
                                }, "onboarding-step-".concat(index));
                                break;
                        }
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/constants/components/browser-notification.js
var BROWSER_NOTIFICATION = {
    texts: {
        button_1: "Allow",
        button_2: "Cancel",
        message: "Message"
    }
};

;// CONCATENATED MODULE: ./src/actions/components/browser-notification.js


var BrowserNotificationAction = /*#__PURE__*/ function() {
    "use strict";
    function BrowserNotificationAction() {
        (0,_class_call_check/* default */.Z)(this, BrowserNotificationAction);
    }
    (0,_create_class/* default */.Z)(BrowserNotificationAction, [
        {
            key: "cancel",
            value: function cancel(setNotificationModal, onClickCancelUserPermission) {
                setNotificationModal(false);
                onClickCancelUserPermission();
            }
        }
    ]);
    return BrowserNotificationAction;
}();

// EXTERNAL MODULE: ../../shared/node_modules/axios/index.js
var axios = __webpack_require__(41690);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/actions/common/push-notification.js


var pushServerPublicKey = "BE09zaH66fEAyFFwbVxCaaNiUETYObOtGgFClyFn64CfgWbJBqSFadjq3soynT08lvYPbFaPGoZTzIQYmMKLAT4=";
/**
 * checks if Push notification and service workers are supported by your browser
 */ function isPushNotificationSupported() {
    if (typeof navigator != "undefined") {
        return "Notification" in window && "serviceWorker" in navigator && "PushManager" in window;
    } else {
        return false;
    }
}
function askUserPermission() {
    return _askUserPermission.apply(this, arguments);
}
function _askUserPermission() {
    _askUserPermission = /**
 * asks user consent to receive push notifications and returns the response of the user, one of granted, default, denied
 */ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (isIOS()) return [
                        2,
                        false
                    ];
                    if (!(typeof Notification != "undefined")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        Notification.requestPermission()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _askUserPermission.apply(this, arguments);
}
function registerServiceWorker() {
    if (typeof navigator != "undefined" && (navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) {
        return navigator.serviceWorker.register("/sw.js");
    } else {
        return null;
    }
}
function createNotificationSubscription() {
    return _createNotificationSubscription.apply(this, arguments);
}
function _createNotificationSubscription() {
    _createNotificationSubscription = /**
 *
 * using the registered service worker creates a push notification subscription and returns it
 *
 */ (0,_async_to_generator/* default */.Z)(function() {
        var serviceWorker, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        navigator.serviceWorker.ready
                    ];
                case 1:
                    serviceWorker = _state.sent();
                    _tmp = {};
                    return [
                        4,
                        serviceWorker.pushManager.subscribe((_tmp.userVisibleOnly = true, _tmp.applicationServerKey = urlBase64ToUint8Array(pushServerPublicKey), _tmp))
                    ];
                case 2:
                    // subscribe and return the subscription
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return _createNotificationSubscription.apply(this, arguments);
}
function urlBase64ToUint8Array(base64String) {
    var padding = "=".repeat((4 - base64String.length % 4) % 4);
    var base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);
    for(var i = 0; i < rawData.length; ++i){
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}
/**
 * returns the subscription if present or nothing
 */ function getUserSubscription() {
    //wait for service worker installation to be ready, and then
    if (typeof navigator != "undefined" && (navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) {
        return navigator.serviceWorker.ready.then(function(serviceWorker) {
            return serviceWorker.pushManager.getSubscription();
        }).then(function(pushSubscription) {
            return pushSubscription;
        });
    }
}
function isIOS() {
    var browserInfo = navigator.userAgent.toLowerCase();
    if (browserInfo.match("iphone") || browserInfo.match("ipad")) {
        return true;
    }
    return false;
}


// EXTERNAL MODULE: ./src/services/common/send-request.js
var send_request = __webpack_require__(34964);
;// CONCATENATED MODULE: ./src/actions/common/useNotification.js




//the function to call the push server: https://github.com/Spyna/push-notification-demo/blob/master/front-end-react/src/utils/http.js



//import all the function created to manage the push notifications
var pushNotificationSupported = isPushNotificationSupported();
//first thing to do: check if the push notifications are supported by the browser
function usePushNotifications() {
    var ref = (0,react.useState)(typeof Notification != "undefined" ? Notification.permission : false), userConsent = ref[0], setUserConsent = ref[1];
    //to manage the user consent: Notification.permission is a JavaScript native function that return the current state of the permission
    //We initialize the userConsent with that value
    var ref1 = (0,react.useState)(null), userSubscription = ref1[0], setUserSubscription = ref1[1];
    //to manage the use push notification subscription
    var ref2 = (0,react.useState)(), pushServerSubscriptionId = ref2[0], setPushServerSubscriptionId = ref2[1];
    //to manage the push server subscription
    var ref3 = (0,react.useState)(null), notificationError = ref3[0], setNotificationError = ref3[1];
    //to manage errors
    var ref4 = (0,react.useState)(true), notificationLoading = ref4[0], setNotificationLoading = ref4[1];
    //to manage async actions
    (0,react.useEffect)(function() {
        if (pushNotificationSupported) {
            setNotificationLoading(true);
            setNotificationError(false);
            registerServiceWorker().then(function() {
                setNotificationLoading(false);
            });
        }
    }, []);
    //if the push notifications are supported, registers the service worker
    //this effect runs only the first render
    (0,react.useEffect)(function() {
        setNotificationLoading(true);
        setNotificationError(false);
        var getExixtingSubscription = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var existingSubscription;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getUserSubscription()
                            ];
                        case 1:
                            existingSubscription = _state.sent();
                            setUserSubscription(existingSubscription);
                            setNotificationLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getExixtingSubscription() {
                return _ref.apply(this, arguments);
            };
        }();
        getExixtingSubscription();
    }, []);
    //Retrieve if there is any push notification subscription for the registered service worker
    // this use effect runs only in the first render
    /**
   * define a click handler that asks the user permission,
   * it uses the setUserConsent state, to set the consent of the user
   * If the user denies the consent, an error is created with the setNotificationError hook
   */ var onClickAskUserPermission = function() {
        setNotificationLoading(true);
        setNotificationError(false);
        askUserPermission().then(function(consent) {
            setUserConsent(consent);
            if (consent !== "granted") {
                setNotificationError({
                    name: "Consent denied",
                    message: "You denied the consent to receive notifications",
                    code: 0
                });
            }
            setNotificationLoading(false);
            onClickSusbribeToPushNotification();
        });
    };
    //
    var onClickCancelUserPermission = function() {
        setNotificationLoading(true);
        setNotificationError(false);
        setNotificationError({
            name: "Consent denied",
            message: "You denied the consent to receive notifications",
            code: 0
        });
        setNotificationLoading(false);
        onClickSusbribeToPushNotification();
    };
    /**
   * define a click handler that creates a push notification subscription.
   * Once the subscription is created, it uses the setUserSubscription hook
   */ var onClickSusbribeToPushNotification = function() {
        setNotificationLoading(true);
        setNotificationError(false);
        createNotificationSubscription().then(function(subscrition) {
            setUserSubscription(subscrition);
            setNotificationLoading(false);
            onClickSendSubscriptionToPushServer(subscrition);
        }).catch(function(err) {
            console.error("Couldn't create the notification subscription", err, "name:", err.name, "message:", err.message, "code:", err.code);
            setNotificationError(err);
            setNotificationLoading(false);
        });
    };
    /**
   * define a click handler that sends the push susbcribtion to the push server.
   * Once the subscription ics created on the server, it saves the id using the hook setPushServerSubscriptionId
   */ var onClickSendSubscriptionToPushServer = function(subscrition) {
        setNotificationLoading(true);
        setNotificationError(false);
        var body = {
            subscription: subscrition.toJSON()
        };
        axios_default().post(urls/* API.subscribe_notification */.b.subscribe_notification, body, new send_request/* SendRequest */.L().setHeaderJSON()).then(function(response) {
            setPushServerSubscriptionId(response.id);
            setNotificationLoading(false);
        }).catch(function(err) {
            setNotificationLoading(false);
            setNotificationError(err);
        });
    };
    return {
        onClickAskUserPermission: onClickAskUserPermission,
        onClickCancelUserPermission: onClickCancelUserPermission,
        onClickSusbribeToPushNotification: onClickSusbribeToPushNotification,
        onClickSendSubscriptionToPushServer: onClickSendSubscriptionToPushServer,
        pushServerSubscriptionId: pushServerSubscriptionId,
        userConsent: userConsent,
        setUserConsent: setUserConsent,
        pushNotificationSupported: pushNotificationSupported,
        userSubscription: userSubscription,
        notificationError: notificationError,
        notificationLoading: notificationLoading
    };
};

// EXTERNAL MODULE: ./src/styles/components/browser-notification/_index.module.scss
var browser_notification_index_module = __webpack_require__(58079);
var browser_notification_index_module_default = /*#__PURE__*/__webpack_require__.n(browser_notification_index_module);
;// CONCATENATED MODULE: ./src/imports-files/components/browser-notification.js





// EXTERNAL MODULE: ./src/imports-files/pages/career/view-job.js + 5 modules
var view_job = __webpack_require__(83813);
;// CONCATENATED MODULE: ./src/components/browser-notification.js




function BrowserNotification(props) {
    var actions = new BrowserNotificationAction();
    var ref = usePushNotifications(), userConsent = ref.userConsent, setUserConsent = ref.setUserConsent, onClickAskUserPermission = ref.onClickAskUserPermission, onClickCancelUserPermission = ref.onClickCancelUserPermission;
    var t = (0,common/* useTranslation */.$G)().t;
    var companyName = "Heartpace";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (browser_notification_index_module_default()).BrowserNotification,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (browser_notification_index_module_default()).BrowserNotification__content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (browser_notification_index_module_default()).BrowserNotification__LogoImage,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "logo-image",
                            src: "/images/logo/Bluelogo.png"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (browser_notification_index_module_default()).BrowserNotification__Message,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: t("browser_notification:heading", {
                                        companyName: companyName
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("browser_notification:subheading")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (browser_notification_index_module_default()).BtnSection,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (browser_notification_index_module_default()).ClearBtn,
                        onClick: function() {
                            setUserConsent("denied");
                            actions.cancel(props.setNotificationModal, onClickCancelUserPermission);
                        },
                        children: t("button:cancel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (browser_notification_index_module_default()).AllowBtn,
                        onClick: function() {
                            props.setNotificationModal(false);
                            onClickAskUserPermission();
                        },
                        children: t("button:allow")
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../shared/node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(57709);
// EXTERNAL MODULE: ./public/icons/call2.svg
var call2 = __webpack_require__(67536);
// EXTERNAL MODULE: ./public/icons/technical.svg
var technical = __webpack_require__(36414);
// EXTERNAL MODULE: ./public/icons/video.svg
var video = __webpack_require__(15166);
// EXTERNAL MODULE: ./public/icons/user.svg
var user = __webpack_require__(41739);
;// CONCATENATED MODULE: ./src/actions/common/setIcons.js
//-----------------Images ----------------------------







//-----------------Images ----------------------------
var ICONS = {
    PHONE: "Phone",
    VIDEO: "Video",
    VIDEOQA: "Video Q&A",
    TECHTEST: "Assessment",
    FACE2FACE: "In-Person"
};
var SetIcons = /*#__PURE__*/ function() {
    "use strict";
    function SetIcons() {
        (0,_class_call_check/* default */.Z)(this, SetIcons);
    }
    (0,_create_class/* default */.Z)(SetIcons, [
        {
            key: "icons",
            value: function icons(type) {
                type = type.charAt(0).toUpperCase() + type.slice(1);
                switch(type){
                    case ICONS.PHONE:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(call2/* default */.Z, {});
                    case ICONS.TECHTEST:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(technical/* default */.Z, {});
                    case ICONS.VIDEO:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(video/* default */.Z, {});
                    case ICONS.FACE2FACE:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(user/* default */.Z, {
                            className: "faceIcon"
                        });
                    default:
                        return "";
                }
            }
        }
    ]);
    return SetIcons;
}();

// EXTERNAL MODULE: ./src/actions/common/authentication/logout.js
var authentication_logout = __webpack_require__(37339);
// EXTERNAL MODULE: ./src/actions/common/close-modal.js
var close_modal = __webpack_require__(67280);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/my-integration.js + 4 modules
var my_integration = __webpack_require__(15639);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/company-integrations.js + 2 modules
var company_integrations = __webpack_require__(71944);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/my-preferences.js + 4 modules
var my_preferences = __webpack_require__(49712);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/career/customize-career.js
var customize_career = __webpack_require__(78403);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/career/career-setting.js + 4 modules
var career_setting = __webpack_require__(65981);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/my-account.js
var dashboard_my_account = __webpack_require__(59546);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/add-team.js
var add_team = __webpack_require__(91752);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/data-privacy/privacy-policy.js + 4 modules
var privacy_policy = __webpack_require__(27690);
// EXTERNAL MODULE: ./src/components/skip-modal.js
var skip_modal = __webpack_require__(53594);
;// CONCATENATED MODULE: ./src/components/progressline.js


var ProgressLine = function(param) {
    var label = param.label, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "#99ADBD" : _backgroundColor, _visualParts = param.visualParts, visualParts = _visualParts === void 0 ? [
        {
            percentage: "0%",
            color: "white"
        }
    ] : _visualParts;
    var ref = (0,react.useState)(visualParts.map(function() {
        return 0;
    })), widths = ref[0], setWidths = ref[1];
    (0,react.useEffect)(function() {
        requestAnimationFrame(function() {
            setWidths(visualParts.map(function(item) {
                return item.percentage;
            }));
        });
    }, [
        visualParts
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "progressLabel"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "progressVisualFull",
                style: {
                    backgroundColor: backgroundColor
                },
                children: visualParts.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            width: widths[index],
                            backgroundColor: item.color
                        },
                        className: "progressVisualPart"
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var progressline = (ProgressLine);

// EXTERNAL MODULE: ./src/styles/components/request-for-more/_index.module.scss
var request_for_more_index_module = __webpack_require__(92626);
var request_for_more_index_module_default = /*#__PURE__*/__webpack_require__.n(request_for_more_index_module);
// EXTERNAL MODULE: ../../shared/node_modules/react-datetime/css/react-datetime.css
var react_datetime = __webpack_require__(18202);
// EXTERNAL MODULE: ./src/components/common-modal/modal.js + 2 modules
var modal = __webpack_require__(99005);
;// CONCATENATED MODULE: ./src/components/interview-list-details.js







function InterviewListDetails(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var data = props.data;
    var candidate_names = data.attendant_list.filter(function(element) {
        return element.candidate;
    });
    var interview_names = data.attendant_list.filter(function(element) {
        return !element.candidate;
    });
    var commonAction = new common_common/* CommonAction */.x();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        type: "info",
        closeModal: function() {
            return props.setSingleEventDetails(false);
        },
        heading: t("modal:info:interview_list:heading"),
        className: "mt0",
        innerContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (request_for_more_index_module_default()).RequestDetails,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                    children: [
                        t("modal:info:interview_list:stage_type"),
                        ": ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: data.interview_type_name
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                    children: [
                        t("modal:info:interview_list:stage_name"),
                        ": ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: data.stage_name
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                    children: [
                        t("modal:info:interview_list:date_time"),
                        ": ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                data.date,
                                " \xa0 ",
                                data.time
                            ]
                        })
                    ]
                }),
                data.interview_link ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                    children: [
                        t("modal:info:interview_list:interview_link"),
                        ": ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: commonAction.embedHttps(data.interview_link),
                                target: "_blank",
                                children: data.interview_link || "-"
                            })
                        })
                    ]
                }) : "",
                data.location ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                    children: [
                        t("modal:info:interview_list:location_info"),
                        ": ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: data.location || "-"
                        })
                    ]
                }) : "",
                data.job_title ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                    children: [
                        t("modal:info:interview_list:job_title"),
                        ": ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: data.job_title || "-"
                        })
                    ]
                }) : "",
                candidate_names ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                    children: [
                        t("modal:info:interview_list:candidate_name"),
                        ": ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: candidate_names.map(function(element, index) {
                                return candidate_names.length - 1 == index ? element.name : element.name + ", ";
                            })
                        })
                    ]
                }) : "",
                data.interview_type_name == common/* INTERVIEW_TYPES.PHONE */.BH.PHONE && data.contact_no && /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                    children: [
                        t("modal:info:interview_list:contact_no"),
                        ": ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: data.contact_no || "-"
                        })
                    ]
                }),
                interview_names ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                    children: [
                        t("modal:info:interview_list:interviewer(s)_name"),
                        ": ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: interview_names.map(function(element, index) {
                                return interview_names.length - 1 == index ? element.name : element.name + ", ";
                            })
                        })
                    ]
                }) : ""
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/components/confirmation-modal.js
var confirmation_modal = __webpack_require__(72055);
// EXTERNAL MODULE: ./src/components/agency-accept-reject.js
var agency_accept_reject = __webpack_require__(84529);
;// CONCATENATED MODULE: ./src/components/offer-rejected-reasons.js





function OfferRejectedReasons(param) {
    var offerRejectedReasons = param.offerRejectedReasons, setOfferRejectReasons = param.setOfferRejectReasons;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        type: "info",
        closeModal: function() {
            return setOfferRejectReasons({
                state: false
            });
        },
        heading: (offerRejectedReasons === null || offerRejectedReasons === void 0 ? void 0 : offerRejectedReasons.heading) == "Rejection Reason" ? t("modal:info:offer:rejection:reason") : t("modal:info:offer:rejection:rejected"),
        description: (offerRejectedReasons === null || offerRejectedReasons === void 0 ? void 0 : offerRejectedReasons.heading) == "Rejection Reason" ? "" : t("modal:info:offer:rejection:description"),
        innerContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: offerRejectedReasons.reasons.map(function(reason) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "".concat((request_for_more_index_module_default()).SetupPopup__PopDetails, " mt15"),
                    children: reason
                });
            })
        })
    });
}

// EXTERNAL MODULE: ../../shared/node_modules/react-tabs/esm/index.js + 10 modules
var esm = __webpack_require__(42419);
// EXTERNAL MODULE: ./src/components/user-switch.js + 5 modules
var user_switch = __webpack_require__(28418);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
;// CONCATENATED MODULE: ./src/components/calendar/calendar-date.js



function CalendarDate(props) {
    var router = (0,next_router.useRouter)();
    var i18n = (0,common/* useTranslation */.$G)().i18n;
    var commonAction = new common_common/* CommonAction */.x();
    var ref = (0,_sliced_to_array/* default */.Z)((0,react.useState)(commonAction.getParamsToUrlWithoutRouter("current_date") ? new Date(commonAction.getParamsToUrlWithoutRouter("current_date").split("/").reverse().join("/")) : new Date()), 2), currentDate = ref[0], setCurrentDate = ref[1];
    var calendarHash = {
        "current_date": commonAction.getParamsToUrlWithoutRouter("current_date") ? new Date(commonAction.getParamsToUrlWithoutRouter("current_date").split("/").reverse().join("/")) : new Date(),
        "is_my_interviews": commonAction.getParamsToUrlWithoutRouter("is_my_interviews") || true,
        "selected_tab": "day"
    };
    var calendarAction = new CalendarAction(props.setCalendarData, calendarHash, router, props.setCalendarDataArray);
    (0,react.useEffect)(function() {
        setCurrentDate(commonAction.getParamsToUrlWithoutRouter("current_date") ? new Date(commonAction.getParamsToUrlWithoutRouter("current_date").split("/").reverse().join("/")) : new Date());
        calendarAction.getCalanderData(calendarHash);
    }, [
        props.calandarFlagForRerender
    ]);
    var localeMap = {
        en: en_US/* default */.Z,
        sv: sv/* default */.Z,
        da: da/* default */.Z,
        no: nb/* default */.Z
    };
    var getLocale = function() {
        return localeMap[i18n.language] || en_US/* default */.Z;
    };
    var renderCurrentDate = function() {
        var dateFormat = "dd MMMM yyyy, EEEE";
        var ddmmYYDate = commonAction.getDateInDMYFormat(currentDate);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((_index_module_default()).CalendarDate),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((_index_module_default()).CalendarDate__LeftIcon),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "icon",
                        onClick: function() {
                            return calendarAction.changeDateHandle("prev", currentDate, setCurrentDate, props.setTodayClick);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "chevron-left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_red_left/* default */.Z, {})
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((_index_module_default()).CalendarDate__Content, " ").concat((_index_module_default()).CalendarDate__CenterFlex),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "".concat((_index_module_default()).CalendarDate__Content__CurrentDate),
                            children: (0,format/* default */.Z)(currentDate, dateFormat, {
                                locale: getLocale()
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "p-relative ".concat(calendarAction.greenDotClass(ddmmYYDate, props.calendarDataArray, (_index_module_default()).CalendarDate__Content__InterviewAvailable))
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((_index_module_default()).CalendarDate__RightIcon),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "icon",
                        onClick: function() {
                            return calendarAction.changeDateHandle("next", currentDate, setCurrentDate, props.setTodayClick);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "chevron-right",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_red_right/* default */.Z, {})
                        })
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((_index_module_default()).DateFNS__Calendar),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((_index_module_default()).DateFNS__Calendar__Date),
            children: renderCurrentDate()
        })
    });
}
/* harmony default export */ var calendar_date = (react.memo(CalendarDate));

;// CONCATENATED MODULE: ./src/components/calendar/calendar-week.js



function CalendarWeek(props) {
    var router = (0,next_router.useRouter)();
    var i18n = (0,common/* useTranslation */.$G)().i18n;
    var commonAction = new common_common/* CommonAction */.x();
    var ref = (0,_sliced_to_array/* default */.Z)((0,react.useState)(commonAction.getParamsToUrlWithoutRouter("current_date") ? new Date(commonAction.getParamsToUrlWithoutRouter("current_date").split("/").reverse().join("/")) : new Date()), 2), currentWeek = ref[0], setCurrentWeek = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(commonAction.getParamsToUrlWithoutRouter("current_date") ? new Date(commonAction.getParamsToUrlWithoutRouter("current_date").split("/").reverse().join("/")) : new Date()), 2), selectedDate = ref1[0], setSelectedDate = ref1[1];
    var calendarHash = {
        "current_date": commonAction.getParamsToUrlWithoutRouter("current_date") ? new Date(commonAction.getParamsToUrlWithoutRouter("current_date").split("/").reverse().join("/")) : new Date(),
        "is_my_interviews": commonAction.getParamsToUrlWithoutRouter("is_my_interviews") || true,
        "selected_tab": "week"
    };
    var calendarAction = new CalendarAction(props.setCalendarData, calendarHash, router, props.setCalendarDataArray);
    (0,react.useEffect)(function() {
        setCurrentWeek(commonAction.getParamsToUrlWithoutRouter("current_date") ? new Date(commonAction.getParamsToUrlWithoutRouter("current_date").split("/").reverse().join("/")) : new Date());
        setSelectedDate(commonAction.getParamsToUrlWithoutRouter("current_date") ? new Date(commonAction.getParamsToUrlWithoutRouter("current_date").split("/").reverse().join("/")) : new Date());
        calendarAction.getCalanderData(calendarHash);
    }, [
        props.calandarFlagForRerender
    ]);
    var localeMap = {
        en: en_US/* default */.Z,
        sv: sv/* default */.Z,
        da: da/* default */.Z,
        no: nb/* default */.Z
    };
    var getLocale = function() {
        return localeMap[i18n.language] || en_US/* default */.Z;
    };
    var renderCurrentWeek = function() {
        var daysFormat = "iii";
        var startDate = (0,startOfWeek/* default */.Z)(currentWeek, {
            weekStartsOn: 1
        });
        var endDate = (0,lastDayOfWeek/* default */.Z)(currentWeek, {
            weekStartsOn: 1
        });
        var dateFormat = "d";
        var rows = [];
        var days = [];
        var day = startDate;
        var formattedDate = "";
        var ddmmYYDate = "";
        while(day <= endDate){
            var _loop = function(i) {
                formattedDate = (0,format/* default */.Z)(day, dateFormat, {
                    locale: getLocale()
                });
                ddmmYYDate = commonAction.getDateInDMYFormat(day);
                var cloneDay = day;
                days.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((_index_module_default()).CalendarWeek__Cell, "\n                ").concat((0,isSameDay/* default */.Z)(day, selectedDate) ? "".concat((_index_module_default()).CalendarWeek__Cell__CurrentDay) : (0,isSameDay/* default */.Z)(day, selectedDate) ? "".concat((_index_module_default()).CalendarWeek__Cell__Selected) : "", " ").concat(calendarAction.greenDotClass(ddmmYYDate, props.calendarDataArray, (_index_module_default()).CalendarMonth__Content__InterviewAvailable)),
                    onClick: function() {
                        var dayStr = (0,format/* default */.Z)(cloneDay, "ccc dd MMM yy", {
                            locale: getLocale()
                        });
                        calendarAction.onWeekDateClickHandle(cloneDay, dayStr, setSelectedDate, props.setTodayClick);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "".concat((_index_module_default()).CalendarWeek__Cell__DayName),
                            children: (0,format/* default */.Z)((0,addDays/* default */.Z)(startDate, i), daysFormat, {
                                locale: getLocale()
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "".concat((_index_module_default()).CalendarWeek__Cell__Date),
                            children: formattedDate
                        })
                    ]
                }, day));
                day = (0,addDays/* default */.Z)(day, 1);
            };
            for(var i = 0; i < 7; i++)_loop(i);
            rows.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((_index_module_default()).CalendarWeek__Row),
                children: days
            }, day));
            days = [];
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((_index_module_default()).CalendarWeek),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((_index_module_default()).CalendarWeek__LeftIcon),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((_index_module_default()).CalendarWeek__Icon),
                            onClick: function() {
                                calendarAction.changeWeekHandle("prev", currentWeek, setCurrentWeek);
                                var weekStartDay = (0,startOfWeek/* default */.Z)((0,subWeeks/* default */.Z)(currentWeek, 1), {
                                    weekStartsOn: 1
                                });
                                var dayStr = (0,format/* default */.Z)(weekStartDay, "ccc dd MMM yy", {
                                    locale: getLocale()
                                });
                                calendarAction.onArrowClickHandle(weekStartDay, dayStr, props.setTodayClick);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "chevron-left",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_red_left/* default */.Z, {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((_index_module_default()).CalendarWeek__Content),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((_index_module_default()).CalendarWeek__Content__Body),
                            children: [
                                rows,
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((_index_module_default()).CalendarWeek__RightIcon),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((_index_module_default()).CalendarWeek__Icon),
                            onClick: function() {
                                calendarAction.changeWeekHandle("next", currentWeek, setCurrentWeek);
                                var weekStartDay = (0,startOfWeek/* default */.Z)((0,addWeeks/* default */.Z)(currentWeek, 1), {
                                    weekStartsOn: 1
                                });
                                var dayStr = (0,format/* default */.Z)(weekStartDay, "ccc dd MMM yy", {
                                    locale: getLocale()
                                });
                                calendarAction.onArrowClickHandle(weekStartDay, dayStr, props.setTodayClick);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "chevron-right",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_red_right/* default */.Z, {})
                            })
                        })
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((_index_module_default()).DateFNS__Calendar),
            children: renderCurrentWeek()
        })
    });
}
/* harmony default export */ var calendar_week = (react.memo(CalendarWeek));

;// CONCATENATED MODULE: ./src/components/calendar/calendar-month.js





function CalendarMonth(props) {
    // States
    var router = (0,next_router.useRouter)();
    var i18n = (0,common/* useTranslation */.$G)().i18n;
    var commonAction = new common_common/* CommonAction */.x();
    var ref = (0,_sliced_to_array/* default */.Z)((0,react.useState)(commonAction.getParamsToUrlWithoutRouter("current_date") ? new Date(commonAction.getParamsToUrlWithoutRouter("current_date").split("/").reverse().join("/")) : new Date()), 2), currentMonth = ref[0], setCurrentMonth = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(commonAction.getParamsToUrlWithoutRouter("current_date") ? new Date(commonAction.getParamsToUrlWithoutRouter("current_date").split("/").reverse().join("/")) : new Date()), 2), selectedDate = ref1[0], setSelectedDate = ref1[1];
    var calendarHash = {
        "current_date": commonAction.getParamsToUrlWithoutRouter("current_date") ? new Date(commonAction.getParamsToUrlWithoutRouter("current_date").split("/").reverse().join("/")) : new Date(),
        "is_my_interviews": commonAction.getParamsToUrlWithoutRouter("is_my_interviews") || true,
        "selected_tab": "month"
    };
    var calendarAction = new CalendarAction(props.setCalendarData, calendarHash, router, props.setCalendarDataArray);
    (0,react.useEffect)(function() {
        setCurrentMonth(commonAction.getParamsToUrlWithoutRouter("current_date") ? new Date(commonAction.getParamsToUrlWithoutRouter("current_date").split("/").reverse().join("/")) : new Date());
        setSelectedDate(commonAction.getParamsToUrlWithoutRouter("current_date") ? new Date(commonAction.getParamsToUrlWithoutRouter("current_date").split("/").reverse().join("/")) : new Date());
        calendarAction.getCalanderData(calendarHash);
    }, [
        props.calandarFlagForRerender
    ]);
    var localeMap = {
        en: en_US/* default */.Z,
        sv: sv/* default */.Z,
        da: da/* default */.Z,
        no: nb/* default */.Z
    };
    var getLocale = function() {
        return localeMap[i18n.language] || en_US/* default */.Z;
    };
    // Render name of month along with year
    var renderMonthYear = function() {
        var dateFormat = "MMMM yyyy";
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((_index_module_default()).CalendarMonth),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((_index_module_default()).CalendarMonth__LeftIcon),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((_index_module_default()).CalendarMonth__Icon),
                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            var monthStartDay, dayStr, _tmp;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            calendarAction.changeMonthHandle("prev", currentMonth, setCurrentMonth, props.setTodayClick)
                                        ];
                                    case 1:
                                        _state.sent();
                                        monthStartDay = (0,startOfMonth/* default */.Z)((0,subMonths/* default */.Z)(currentMonth, 1));
                                        _tmp = {};
                                        dayStr = (0,format/* default */.Z)(monthStartDay, "ccc dd MMM yy", (_tmp.locale = getLocale(), _tmp));
                                        calendarAction.onArrowClickHandle(monthStartDay, dayStr, props.setTodayClick);
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "chevron-left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_red_left/* default */.Z, {})
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((_index_module_default()).CalendarMonth__Content),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "".concat((_index_module_default()).CalendarMonth__CurrentMonth),
                        children: (0,format/* default */.Z)(currentMonth, dateFormat, {
                            locale: getLocale()
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((_index_module_default()).CalendarMonth__RightIcon),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((_index_module_default()).CalendarMonth__Icon),
                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            var monthStartDay, dayStr, _tmp;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            calendarAction.changeMonthHandle("next", currentMonth, setCurrentMonth, props.setTodayClick)
                                        ];
                                    case 1:
                                        _state.sent();
                                        monthStartDay = (0,startOfMonth/* default */.Z)((0,addMonths/* default */.Z)(currentMonth, 1));
                                        _tmp = {};
                                        dayStr = (0,format/* default */.Z)(monthStartDay, "ccc dd MMM yy", (_tmp.locale = getLocale(), _tmp));
                                        calendarAction.onArrowClickHandle(monthStartDay, dayStr, props.setTodayClick);
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "chevron-right",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_red_right/* default */.Z, {})
                        })
                    })
                })
            ]
        });
    };
    // Render name of week
    var renderMonthWeekdaysName = function() {
        var dateFormat = "iii";
        var days = [];
        var startDate = (0,startOfWeek/* default */.Z)(currentMonth, {
            weekStartsOn: 1
        });
        for(var i = 0; i < 7; i++){
            days.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((_index_module_default()).CalendarMonth__Content),
                children: (0,format/* default */.Z)((0,addDays/* default */.Z)(startDate, i), dateFormat, {
                    locale: getLocale()
                })
            }, i));
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((_index_module_default()).DateFNS__Calendar__WeekNames),
            children: days
        });
    };
    //------------------------------------------
    // Render days in month
    var renderMonthDaysCells = function() {
        var monthStart = (0,startOfMonth/* default */.Z)(currentMonth);
        var monthEnd = (0,endOfMonth/* default */.Z)(monthStart);
        var startDate = (0,startOfWeek/* default */.Z)(monthStart, {
            weekStartsOn: 1
        });
        var endDate = (0,startOfWeek/* default */.Z)(monthEnd, {
            weekStartsOn: 1
        });
        var dateFormat = "d";
        var rows = [];
        var days = [];
        var day = startDate;
        var formattedDate = "";
        var ddmmYYDate = "";
        while(day <= endDate){
            var _loop = function(i) {
                formattedDate = (0,format/* default */.Z)(day, dateFormat, {
                    locale: getLocale()
                });
                ddmmYYDate = commonAction.getDateInDMYFormat(day);
                var cloneDay = day;
                days.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((_index_module_default()).DateFNS__Calendar__Cell, " ").concat(!(0,isSameMonth/* default */.Z)(day, monthStart) ? "".concat((_index_module_default()).DateFNS__Calendar__Cell__Disabled) : (0,isSameDay/* default */.Z)(day, selectedDate) ? "".concat((_index_module_default()).DateFNS__Calendar__Cell__Selected) : ""),
                    onClick: function() {
                        var dayStr = (0,format/* default */.Z)(cloneDay, "ccc dd MMM yy", {
                            locale: getLocale()
                        });
                        calendarAction.onMonthDateClickHandle(cloneDay, dayStr, setSelectedDate, props.setTodayClick);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "".concat((_index_module_default()).CalendarMonth__Content__CurrentDate, " ").concat(calendarAction.greenDotClass(ddmmYYDate, props.calendarDataArray, (_index_module_default()).CalendarMonth__Content__InterviewAvailable)),
                        children: formattedDate
                    })
                }, day));
                day = (0,addDays/* default */.Z)(day, 1);
            };
            for(var i = 0; i < 7; i++)_loop(i);
            rows.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((_index_module_default()).DateFNS__Calendar__Row),
                children: days
            }, day));
            days = [];
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((_index_module_default()).DateFNS__Calendar__Body),
            children: rows
        });
    };
    //------------------------------------------
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((_index_module_default()).DateFNS__Calendar),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((_index_module_default()).DateFNS__Calendar__Month),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((_index_module_default()).DateFNS__Calendar__MonthYear),
                    children: renderMonthYear()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((_index_module_default()).DateFNS__Calendar__WeekDays),
                    children: renderMonthWeekdaysName()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((_index_module_default()).DateFNS__Calendar__DaysCells),
                    children: renderMonthDaysCells()
                })
            ]
        })
    });
}
/* harmony default export */ var calendar_month = (react.memo(CalendarMonth));

// EXTERNAL MODULE: ./src/components/modals/information-modal.js
var information_modal = __webpack_require__(3038);
// EXTERNAL MODULE: ./public/icons/warning.svg
var warning = __webpack_require__(51750);
// EXTERNAL MODULE: ./public/new-icons/SmallWarning.svg
var SmallWarning = __webpack_require__(14850);
;// CONCATENATED MODULE: ./public/icons/arrowup.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgArrowup = function SvgArrowup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.414 1.707 6.707A1 1 0 0 1 .293 5.293l5-5a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L6 2.414Z",
    fill: "#92929D"
  })));
};

/* harmony default export */ var arrowup = ((/* unused pure expression or super */ null && (SvgArrowup)));
;// CONCATENATED MODULE: ./public/icons/arrowdown.svg
var arrowdown_path;

function arrowdown_extends() { arrowdown_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrowdown_extends.apply(this, arguments); }



var SvgArrowdown = function SvgArrowdown(props) {
  return /*#__PURE__*/React.createElement("svg", arrowdown_extends({
    width: 12,
    height: 7,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), arrowdown_path || (arrowdown_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.586 10.293.293a1 1 0 1 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5A1 1 0 0 1 1.707.293L6 4.586Z",
    fill: "#92929D"
  })));
};

/* harmony default export */ var arrowdown = ((/* unused pure expression or super */ null && (SvgArrowdown)));
;// CONCATENATED MODULE: ./public/icons/arrow-up-2.svg
var arrow_up_2_path;

function arrow_up_2_extends() { arrow_up_2_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_up_2_extends.apply(this, arguments); }



var SvgArrowUp2 = function SvgArrowUp2(props) {
  return /*#__PURE__*/React.createElement("svg", arrow_up_2_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 330 330",
    style: {
      enableBackground: "new 0 0 330 330"
    },
    xmlSpace: "preserve"
  }, props), arrow_up_2_path || (arrow_up_2_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.606 100.606 150 51.212V315c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15V51.212l49.394 49.394A14.95 14.95 0 0 0 240 105a14.95 14.95 0 0 0 10.606-4.394c5.858-5.857 5.858-15.355 0-21.213l-75-75c-5.857-5.858-15.355-5.858-21.213 0l-75 75c-5.858 5.857-5.858 15.355 0 21.213 5.858 5.857 15.356 5.857 21.213 0z",
    fill: "#111128"
  })));
};

/* harmony default export */ var arrow_up_2 = ((/* unused pure expression or super */ null && (SvgArrowUp2)));
;// CONCATENATED MODULE: ./public/icons/arrow-down-2.svg
var arrow_down_2_path;

function arrow_down_2_extends() { arrow_down_2_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_down_2_extends.apply(this, arguments); }



var SvgArrowDown2 = function SvgArrowDown2(props) {
  return /*#__PURE__*/React.createElement("svg", arrow_down_2_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 330 330",
    style: {
      enableBackground: "new 0 0 330 330"
    },
    xmlSpace: "preserve"
  }, props), arrow_down_2_path || (arrow_down_2_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.394 325.606C157.322 328.535 161.161 330 165 330s7.678-1.465 10.607-4.394l75-75c5.858-5.857 5.858-15.355 0-21.213-5.858-5.857-15.356-5.857-21.213 0L180 278.787V15c0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15v263.787l-49.394-49.394c-5.858-5.857-15.355-5.857-21.213 0-5.858 5.857-5.858 15.355 0 21.213l75.001 75z",
    fill: "#111128"
  })));
};

/* harmony default export */ var arrow_down_2 = ((/* unused pure expression or super */ null && (SvgArrowDown2)));
;// CONCATENATED MODULE: ./public/icons/call.svg
var call_path;

function call_extends() { call_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return call_extends.apply(this, arguments); }



var SvgCall = function SvgCall(props) {
  return /*#__PURE__*/React.createElement("svg", call_extends({
    width: 19,
    height: 19,
    viewBox: "0 0 167 163",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), call_path || (call_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.58 162.91c-8.5 0-31.18-1.22-58.05-12.6-1.77 1.91-4.03 3.5-6.71 4.68-12.62 5.56-36.18 2.24-58.14-18.18l-2.48-2.03C9.68 113.26 5.47 89.5 10.65 76.53c1.1-2.76 2.64-5.1 4.52-6.96C-.21 36.51.28 9.35.32 7.7L.4 4.89l2.68-.85c16.99-5.36 18.64-5.11 35.12-.21l2.96.88 12.81 42.91-.04.69c-.55 9.8-10.82 23.69-26.26 24.07-.72.02-1.4.09-2.05.22 6.86 13.27 16.43 27.27 29.77 40.6l-.01.01C68.6 125.29 82.24 133.88 95.13 140c.1-.63.15-1.29.14-1.98-.15-15.28 13.22-25.91 22.88-26.81l.69-.06 42.82 11.17.98 2.91c5.41 16.11 5.71 17.73 1.01 34.7l-.75 2.71-2.81.18c-.31.02-1.53.09-3.51.09Zm-54.1-19.64c25.5 10.57 46.93 11.69 54.34 11.72 3.27-11.93 3.06-13.15-1.29-26.1l-37.27-9.72c-5.53.95-15.2 7.94-15.09 18.78.01 1.86-.22 3.64-.69 5.32Zm-65.84-14.21 2.32 1.88c18.51 17.26 39 21.53 49.67 16.83.72-.32 1.38-.67 1.98-1.05-13.58-6.61-27.94-15.88-41.89-28.89l.05-.06C35.61 104.4 26.02 90.54 19.03 77.35c-.39.65-.74 1.36-1.05 2.13-4.37 10.94.64 31.47 18.66 49.58ZM8.27 10.69c.3 7.48 2.22 29.2 13.83 54.68 1.68-.54 3.47-.84 5.37-.88 11.01-.27 17.76-10.35 18.53-16L34.83 11.07c-13.32-3.96-14.55-4.13-26.56-.38Z"
  })));
};

/* harmony default export */ var call = ((/* unused pure expression or super */ null && (SvgCall)));
;// CONCATENATED MODULE: ./public/new-icons/message.svg
var message_path, _path2;

function message_extends() { message_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return message_extends.apply(this, arguments); }



var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/react.createElement("svg", message_extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), message_path || (message_path = /*#__PURE__*/react.createElement("path", {
    clipRule: "evenodd",
    d: "M13.38 13.686a6.67 6.67 0 0 1-7.522 1.336c-.365-.147-.664-.265-.948-.265-.791.004-1.776.771-2.288.26-.512-.512.256-1.497.256-2.293 0-.284-.114-.578-.26-.943A6.67 6.67 0 0 1 13.38 4.257a6.668 6.668 0 0 1 0 9.429Z",
    stroke: "#A4AAB0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M11.293 9.248h.006M8.62 9.248h.006M5.948 9.248h.006",
    stroke: "#A4AAB0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ var message = (SvgMessage);
;// CONCATENATED MODULE: ./public/icons/clocktime.svg
var clocktime_path;

function clocktime_extends() { clocktime_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return clocktime_extends.apply(this, arguments); }



var SvgClocktime = function SvgClocktime(props) {
  return /*#__PURE__*/react.createElement("svg", clocktime_extends({
    width: 13,
    height: 13,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), clocktime_path || (clocktime_path = /*#__PURE__*/react.createElement("path", {
    d: "M6 10.668a4.68 4.68 0 0 0 4.667-4.667A4.68 4.68 0 0 0 6 1.335 4.68 4.68 0 0 0 1.333 6 4.68 4.68 0 0 0 6 10.668Zm0-10.5c3.208 0 5.833 2.625 5.833 5.833 0 3.209-2.625 5.834-5.833 5.834S.167 9.21.167 6C.167 2.793 2.792.168 6 .168ZM8.917 7.11l-.409.758-3.091-1.692V3.085h.875V5.65L8.917 7.11Z",
    fill: "var(--default-text-color)"
  })));
};

/* harmony default export */ var clocktime = (SvgClocktime);
// EXTERNAL MODULE: ./public/icons/calender.svg
var calender = __webpack_require__(4320);
// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(85155);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/activities/index.js








// TODO NEED TO BE CHANGE
















































/***/ }),

/***/ 5837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "hJ": function() { return /* reexport */ integration_connected/* IntegrationConnect */.h; },
  "gb": function() { return /* reexport */ common/* Loading */.gb; },
  "Us": function() { return /* reexport */ common/* SUCCESS_REPONSE_CODE */.Us; },
  "Lt": function() { return /* reexport */ send_request/* SendRequest */.L; },
  "Mn": function() { return /* reexport */ common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn; },
  "mQ": function() { return /* reexport */ authorizeUser; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "Gg": function() { return /* reexport */ common/* getSession */.Gg; },
  "GB": function() { return /* reexport */ common/* handleOtherResponseCode */.GB; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; }
});

// UNUSED EXPORTS: MainArea, Modal, TRANSLATION, UNAUTHORIZED_REPONSE_CODE, Yup, toastr, useTranslation

// EXTERNAL MODULE: ./src/components/main-area.js + 1 modules
var main_area = __webpack_require__(89675);
// EXTERNAL MODULE: ./src/components/modal.js
var modal = __webpack_require__(75695);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/services/common/send-request.js
var send_request = __webpack_require__(34964);
// EXTERNAL MODULE: ./src/services/pages/clients/activities/integration-connected.js
var integration_connected = __webpack_require__(90317);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ./src/constants/common/urls.js
var urls = __webpack_require__(47694);
// EXTERNAL MODULE: ./src/actions/pages/app/protected-routes.js + 1 modules
var protected_routes = __webpack_require__(28325);
// EXTERNAL MODULE: ../../shared/node_modules/aes-encryption/index.js
var aes_encryption = __webpack_require__(32972);
var aes_encryption_default = /*#__PURE__*/__webpack_require__.n(aes_encryption);
;// CONCATENATED MODULE: ./src/actions/pages/clients/activities/integration-connected.js






function authorizeUser(setPageName, queryClient, router) {
    return _authorizeUser.apply(this, arguments);
}
function _authorizeUser() {
    _authorizeUser = (0,_async_to_generator/* default */.Z)(function(setPageName, queryClient, router) {
        var session, client_slug, slug, integrate_level, params, _tmp, send_integrate_level, ref, hash, ref1, hash1, code, verifier, code1, result, status_code, response, message;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,common/* getSession */.Gg)()
                    ];
                case 1:
                    session = _state.sent();
                    client_slug = session === null || session === void 0 ? void 0 : session.subdomain;
                    slug = window.location.pathname.split("/")[3];
                    integrate_level = router.query.state;
                    _tmp = {};
                    params = _tmp;
                    send_integrate_level = "";
                    if (slug == "slack") {
                        ;
                        send_integrate_level = integrate_level;
                        hash = decrypt(integrate_level);
                        integrate_level = ((ref = JSON.parse(hash)) === null || ref === void 0 ? void 0 : ref.integration_redirect_state) || "user";
                    } else if (slug == "linked-in") {
                        ;
                        send_integrate_level = integrate_level;
                        hash1 = decrypt(integrate_level);
                        integrate_level = ((ref1 = JSON.parse(hash1)) === null || ref1 === void 0 ? void 0 : ref1.integration_redirect_state) || "user";
                    } else {
                        send_integrate_level = integrate_level.replace("_quick_setup", "");
                    }
                    if (router.query.error || router.query.denied) {
                        redirectToIntegration(integrate_level, false, router, null);
                        return [
                            2,
                            null
                        ];
                    } else if (slug == "twitter") {
                        code = new URLSearchParams(window.location.search).get("oauth_token");
                        verifier = new URLSearchParams(window.location.search).get("oauth_verifier");
                        params = {
                            code: code,
                            integrate_level: send_integrate_level,
                            verifier: verifier
                        };
                    } else {
                        code1 = new URLSearchParams(window.location.search).get("code");
                        params = {
                            code: code1,
                            integrate_level: send_integrate_level
                        };
                    }
                    if (slug == "gmail") {
                        params.scope = router.query.scope;
                    }
                    return [
                        4,
                        new integration_connected/* IntegrationConnect */.h().submitIntegrationCode(params, slug, client_slug)
                    ];
                case 2:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    switch(status_code){
                        case common/* SUCCESS_REPONSE_CODE */.Us:
                            response = result.data;
                            if (response.success) {
                                redirectToIntegration(integrate_level, true, router, null);
                            }
                            break;
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            message = result.response.data.error;
                            redirectToIntegration(integrate_level, false, router, message);
                            break;
                        default:
                            (0,common/* handleOtherResponseCode */.GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _authorizeUser.apply(this, arguments);
}
function redirectToIntegration(state, success, router, message) {
    if (state == "client") {
        var url = (0,protected_routes/* get_new_host */.Ro)() + urls/* REDIRECT.client.client_integrations */.R.client.client_integrations;
        router.replace({
            pathname: url,
            query: {
                success: success,
                message: message
            }
        });
    } else if (state == "client_quick_setup") {
        var url1 = (0,protected_routes/* get_new_host */.Ro)() + urls/* REDIRECT.client.quick_setup_page */.R.client.quick_setup_page;
        router.replace({
            pathname: url1,
            query: {
                success: success,
                message: message,
                step: "company_integrations"
            }
        });
    } else if (state == "user_quick_setup") {
        var url2 = (0,protected_routes/* get_new_host */.Ro)() + urls/* REDIRECT.client.quick_setup_page */.R.client.quick_setup_page;
        router.replace({
            pathname: url2,
            query: {
                success: success,
                message: message,
                step: "my_integrations"
            }
        });
    } else {
        var url3 = (0,protected_routes/* get_new_host */.Ro)() + urls/* REDIRECT.client.my_integrations */.R.client.my_integrations;
        router.replace({
            pathname: url3,
            query: {
                success: success,
                message: message
            }
        });
    }
}
function decrypt(encrypted) {
    var secretPass = "c52f6a7af1eab682bcc64b76600cda6354c6b8c8387d4e7bb38b296b85d87d6a";
    var aes = new (aes_encryption_default())();
    aes.setSecretKey(secretPass);
    var data = aes.decrypt(encrypted);
    return data;
}
function encrypt(encrypted) {
    var secretPass = "c52f6a7af1eab682bcc64b76600cda6354c6b8c8387d4e7bb38b296b85d87d6a";
    var aes = new AesEncryption();
    aes.setSecretKey(secretPass);
    var data = aes.decrypt(encrypted);
    return data;
}

;// CONCATENATED MODULE: ./src/imports-files/pages/clients/activities/integration-connected.js
// -------------Custom Components ---------------//



// -------------Custom Components ---------------//
// -------------SERVICES ---------------//


// -------------SERVICES ---------------//
// -------------PAGES ---------------//
 // -------------PAGES ---------------//


/***/ }),

/***/ 47942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "_W": function() { return /* reexport */ add_candidate["default"]; },
  "s$": function() { return /* reexport */ AddNewStage; },
  "sK": function() { return /* reexport */ add_offer["default"]; },
  "YD": function() { return /* reexport */ add_to_job_modal/* AddToJobModal */.Y; },
  "jd": function() { return /* reexport */ agency_accept_reject/* AgencyAcceptRejectModal */.j; },
  "it": function() { return /* reexport */ application_filter/* ApplicationFilter */.i; },
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "ai": function() { return /* reexport */ candidate_merge_action/* CandidateMergeAction */.a; },
  "Gv": function() { return /* reexport */ close_job_modal/* CloseJobModal */.G; },
  "J0": function() { return /* reexport */ compare_candidates["default"]; },
  "ij": function() { return /* reexport */ custom_tech_test_modal["default"]; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "t9": function() { return /* reexport */ daxtra_score_action/* DaxtraScoreAction */.t; },
  "dC": function() { return /* reexport */ render_error_loading/* ErrorPages */.d; },
  "R": function() { return /* reexport */ FlipPageAction; },
  "lR": function() { return /* reexport */ FlipPageService; },
  "a3": function() { return /* reexport */ HiredModal; },
  "BH": function() { return /* reexport */ common/* INTERVIEW_TYPES */.BH; },
  "eP": function() { return /* reexport */ common/* JOB_STAGES */.eP; },
  "v6": function() { return /* reexport */ common/* JOB_STATUSES */.v6; },
  "l": function() { return /* reexport */ common/* JOB_STEPS */.l; },
  "pt": function() { return /* reexport */ candidates_kanban/* Kanban */.p; },
  "Ki": function() { return /* reexport */ kanban/* NumberField */.Ki; },
  "_Q": function() { return /* reexport */ OfferActions; },
  "j$": function() { return /* reexport */ common/* QUESTION_TYPES */.j$; },
  "RQ": function() { return /* reexport */ common/* REDIRECT */.RQ; },
  "Us": function() { return /* reexport */ common/* SUCCESS_REPONSE_CODE */.Us; },
  "bw": function() { return /* reexport */ send_questions_modal["default"]; },
  "Lt": function() { return /* reexport */ common/* SendRequest */.Lt; },
  "x2": function() { return /* reexport */ setup_interview_modal/* default */.Z; },
  "Rl": function() { return /* reexport */ single_candidate_modal/* SingleCandidateModal */.R; },
  "TA": function() { return /* reexport */ common/* TRANSLATION */.TA; },
  "Mn": function() { return /* reexport */ common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn; },
  "hF": function() { return /* reexport */ unsuccessful_email_modal/* UnsuccessfulEmailModal */.h; },
  "OE": function() { return /* reexport */ unsuccessfull/* UnsuccessfulModal */.O; },
  "v3": function() { return /* reexport */ warning/* default */.Z; },
  "Sr": function() { return /* reexport */ kanban/* addParamsToUrl */.Sr; },
  "Jb": function() { return /* reexport */ kanban/* addToAnotherJob */.Jb; },
  "uX": function() { return /* reexport */ kanban/* automationClick */.uX; },
  "Gu": function() { return /* reexport */ kanban/* automationPopup */.Gu; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "sZ": function() { return /* reexport */ kanban/* clearRadioButtonSelection */.sZ; },
  "A$": function() { return /* reexport */ common/* clearSWRCache */.A$; },
  "t7": function() { return /* reexport */ kanban/* closeJob */.t7; },
  "pr": function() { return /* reexport */ kanban/* compareCandidateScorecards */.pr; },
  "wx": function() { return /* reexport */ index_4bd03571_esm.c; },
  "y$": function() { return /* reexport */ jobs_common/* cursorNone */.y$; },
  "kc": function() { return /* reexport */ kanban/* fetchMoreData */.kc; },
  "D6": function() { return /* reexport */ interview_stages/* getClientUsers */.D6; },
  "LA": function() { return /* reexport */ kanban/* getFilterdData */.LA; },
  "tk": function() { return /* reexport */ kanban/* getReasonsList */.tk; },
  "JE": function() { return /* reexport */ kanban/* getScorecards */.JE; },
  "h9": function() { return /* reexport */ kanban/* getSingleScorecard */.h9; },
  "cd": function() { return /* reexport */ otp/* get_seconds_for_timer */.cd; },
  "Si": function() { return /* reexport */ kanban/* handleCardCheckbox */.Si; },
  "Iw": function() { return /* reexport */ kanban/* handleLaneCheckbox */.Iw; },
  "GB": function() { return /* reexport */ common/* handleOtherResponseCode */.GB; },
  "E6": function() { return /* reexport */ kanban/* hideCompareCandidate */.E6; },
  "Qz": function() { return /* reexport */ kanban/* isScheduledInterview */.Qz; },
  "jM": function() { return /* reexport */ kanban/* manageAutomationTimer */.jM; },
  "eF": function() { return /* reexport */ jobs_automation/* mangeInterviews */.eF; },
  "KF": function() { return /* reexport */ kanban/* markActiveUnsuccessful */.KF; },
  "jk": function() { return /* reexport */ kanban/* moveToNextStage */.jk; },
  "Ff": function() { return /* reexport */ offerInitialValues; },
  "mU": function() { return /* reexport */ offerValidationSchema; },
  "bp": function() { return /* reexport */ kanban/* onCancelClick */.bp; },
  "C$": function() { return /* reexport */ kanban/* performAction */.C$; },
  "Ow": function() { return /* reexport */ kanban/* redirectContractPage */.Ow; },
  "ds": function() { return /* reexport */ kanban/* reviewAutomationEmail */.ds; },
  "hh": function() { return /* reexport */ kanban/* runAutomations */.hh; },
  "HD": function() { return /* reexport */ kanban/* sendCustomTechTest */.HD; },
  "Yn": function() { return /* reexport */ kanban/* sendOfferToCandidate */.Yn; },
  "b8": function() { return /* reexport */ kanban/* sendQuestions */.b8; },
  "M": function() { return /* reexport */ kanban/* send_unsuccessful_email */.M; },
  "Wg": function() { return /* reexport */ kanban/* setAutomationHash */.Wg; },
  "a": function() { return /* reexport */ jobs_automation/* setTechTestFormData */.a; },
  "z6": function() { return /* reexport */ kanban/* showAddOffer */.z6; },
  "gw": function() { return /* reexport */ kanban/* showCompareCandidate */.gw; },
  "CZ": function() { return /* reexport */ kanban/* showUnsuccessful */.CZ; },
  "zb": function() { return /* reexport */ kanban/* submitOffer */.zb; },
  "DU": function() { return /* reexport */ kanban/* syncNowHiredData */.DU; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "sO": function() { return /* reexport */ common/* useRef */.sO; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "J7": function() { return /* reexport */ react_timer_hook_dist.useTimer; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: APPLICATION_FILE_SIZE_LIMIT, AutocompleteError, Automation, CV_FILE_EXTENSIONS, ConfirmationModal, CountdownTimer, DataFromUrl, HelmetMeta, KanbanActions, Loading, NextServerCookies, OTHER_FILE_EXTENSIONS, Yup, applyJobInitialValues, duplicateJob, getCandidatesFromDatabase, getOfferHash, jobStatusBadge, toastr, todayDate, useSession

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/actions/pages/clients/candidates/kanban.js
var kanban = __webpack_require__(21572);
// EXTERNAL MODULE: ../../shared/node_modules/react-select/dist/index-4bd03571.esm.js + 1 modules
var index_4bd03571_esm = __webpack_require__(28805);
// EXTERNAL MODULE: ./src/constants/pages/jobs/view-job.js
var view_job = __webpack_require__(47582);
// EXTERNAL MODULE: ./src/services/pages/clients/candidates/kanban.js
var candidates_kanban = __webpack_require__(56075);
// EXTERNAL MODULE: ./src/services/pages/clients/jobs/automation.js
var automation = __webpack_require__(49639);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/candidates/add-candidate.js
var add_candidate = __webpack_require__(48234);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/candidates/add-offer.js
var add_offer = __webpack_require__(23746);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/jobs/compare-candidates.js
var compare_candidates = __webpack_require__(2145);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/automation.js
var jobs_automation = __webpack_require__(57223);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/common.js
var jobs_common = __webpack_require__(90432);
// EXTERNAL MODULE: ./src/actions/components/job-action-options.js
var job_action_options = __webpack_require__(41817);
// EXTERNAL MODULE: ./src/actions/pages/clients/candidates/daxtra-score-action.js
var daxtra_score_action = __webpack_require__(74527);
// EXTERNAL MODULE: ./src/components/add-to-job-modal.js
var add_to_job_modal = __webpack_require__(29929);
// EXTERNAL MODULE: ./src/components/close-job-modal.js
var close_job_modal = __webpack_require__(75646);
// EXTERNAL MODULE: ./src/components/modals/single-candidate-modal.js + 1 modules
var single_candidate_modal = __webpack_require__(48151);
// EXTERNAL MODULE: ./src/components/unsuccessful-email-modal.js + 1 modules
var unsuccessful_email_modal = __webpack_require__(38678);
// EXTERNAL MODULE: ./src/components/unsuccessfull.js
var unsuccessfull = __webpack_require__(59678);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/imports-files/components/confirmation-modal.js
var confirmation_modal = __webpack_require__(46464);
// EXTERNAL MODULE: ./src/styles/components/delete-candidate-modal/_index.module.scss
var _index_module = __webpack_require__(19955);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
;// CONCATENATED MODULE: ./src/components/hired-modal.js




function HiredModal(param) {
    var setHiredModal = param.setHiredModal, router = param.router, job_id = param.job_id, t = param.t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "CandidateFilterModal ".concat((_index_module_default()).DeleteCandidateModal),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (_index_module_default()).DeleteCandidateModal__Inner,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (_index_module_default()).DeleteCandidateModal__Container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "normalweight ".concat((_index_module_default()).DeleteCandidateModal__Message),
                        children: t("modal:close_job_modal_text")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (_index_module_default()).DeleteCandidateModal__ButtonSection,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(confirmation_modal/* Button */.zx, {
                                buttonstyle: (_index_module_default()).primarybtn,
                                onClick: function() {
                                    (0,kanban/* closeJob */.t7)(job_id, router);
                                },
                                children: t("modal:close_job_button")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(confirmation_modal/* Button */.zx, {
                                buttonstyle: (_index_module_default()).secondarybtn,
                                onClick: function() {
                                    return setHiredModal(false);
                                },
                                children: t("modal:continue_hiring")
                            })
                        ]
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/confirmation-modal.js
var components_confirmation_modal = __webpack_require__(72055);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(34817);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ./src/styles/components/share-cv/_index.module.scss
var share_cv_index_module = __webpack_require__(2443);
var share_cv_index_module_default = /*#__PURE__*/__webpack_require__.n(share_cv_index_module);
// EXTERNAL MODULE: ./src/styles/components/add-new-stage/_index.module.scss
var add_new_stage_index_module = __webpack_require__(81769);
var add_new_stage_index_module_default = /*#__PURE__*/__webpack_require__.n(add_new_stage_index_module);
// EXTERNAL MODULE: ../../shared/node_modules/react-simple-tooltip/es/index.js + 11 modules
var es = __webpack_require__(54392);
// EXTERNAL MODULE: ./public/icons/call2.svg
var call2 = __webpack_require__(67536);
// EXTERNAL MODULE: ./public/icons/technical.svg
var technical = __webpack_require__(36414);
// EXTERNAL MODULE: ./public/icons/video.svg
var video = __webpack_require__(15166);
// EXTERNAL MODULE: ./public/icons/user.svg
var user = __webpack_require__(41739);
// EXTERNAL MODULE: ./public/icons/videoqa.svg
var videoqa = __webpack_require__(20226);
// EXTERNAL MODULE: ./src/styles/components/button/_index.module.scss
var button_index_module = __webpack_require__(84215);
var button_index_module_default = /*#__PURE__*/__webpack_require__.n(button_index_module);
// EXTERNAL MODULE: ../../shared/node_modules/react-autosuggest/dist/index.js
var dist = __webpack_require__(46921);
// EXTERNAL MODULE: ./src/components/loading.js + 1 modules
var loading = __webpack_require__(85462);
;// CONCATENATED MODULE: ./src/constants/components/add-new-stage.js

var ADD_NEW_STAGE = {
    job_stage_label_attributes: {
        label: ""
    },
    interview_type_id: "",
    member_emails: [],
    member_initials: [],
    after_stage_id: "",
    stage_id: ""
};
function addNewStageValidation(isScreening) {
    return common/* Yup.object */.sm.object({
        job_stage_label_attributes: common/* Yup.object */.sm.object().shape({
            label: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable(true)
        }),
        interview_type_id: common/* Yup.string */.sm.string().when([], {
            is: function() {
                return !isScreening;
            },
            then: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable(true),
            otherwise: common/* Yup.string */.sm.string().notRequired()
        }),
        member_emails: common/* Yup.array */.sm.array(),
        after_stage_id: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable(true),
        stage_id: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable(true)
    });
}

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(38641);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(18186);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/jobs/automations.js + 3 modules
var automations = __webpack_require__(64335);
;// CONCATENATED MODULE: ./src/actions/components/add-new-stage.js










var AddNewStageAction = /*#__PURE__*/ function() {
    "use strict";
    function AddNewStageAction() {
        (0,_class_call_check/* default */.Z)(this, AddNewStageAction);
        (0,_define_property/* default */.Z)(this, "renderInputComponent", function(inputProps) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "buttonIn",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        className: automations/* PageStyle.Form__Input */.k2.Form__Input,
                        autoComplete: "password"
                    }, inputProps)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(automations/* Button */.zx, {
                        buttonstyle: "".concat(automations/* ButtonStyle.nobgbutton */.ZJ.nobgbutton, " addbtn"),
                        disabled: inputProps.disabled,
                        onClick: function() {
                            return inputProps.addNewStageAction.onAddClick(event, inputProps);
                        },
                        children: (0,automations/* TRANSLATION */.TA)("button:add:default")
                    })
                ]
            });
        });
        this.customToastrAction = new common/* CustomToastrAction */.Y5();
        this.addNewStageService = new AddNewStageService();
    }
    (0,_create_class/* default */.Z)(AddNewStageAction, [
        {
            key: "submitForm",
            value: function submitForm(values, setBtnPopup, jobData, setJobData, setIsLoading) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var params, _tmp, result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                params = (_tmp.job_stage = values, _tmp);
                                return [
                                    4,
                                    _this.addNewStageService.addStage(params, jobData.id)
                                ];
                            case 1:
                                result = _state.sent();
                                if (result.request.status == 200) {
                                    setIsLoading(false);
                                    setJobData(result.data.kanban_data);
                                    setBtnPopup(false);
                                    _this.customToastrAction.setNormalToastr(result.data.success, "success");
                                } else {
                                    if (typeof result.response.data.error === "string") {
                                        _this.customToastrAction.setNormalToastr(result.response.data.error, "error");
                                    } else {
                                        return [
                                            2,
                                            result.response.data.error.job_stage
                                        ];
                                    }
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getJobInfo",
            value: function getJobInfo(jobId) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.addNewStageService.addStageInfo(jobId)
                                ];
                            case 1:
                                result = _state.sent();
                                if (result.request.status == 200) {
                                    return [
                                        2,
                                        result.data
                                    ];
                                } else {
                                    return [
                                        2,
                                        result.response.data.error
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onSuggestionSelection",
            value: function onSuggestionSelection(emails, email, emailInitials, emailInitial) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        if (!emails.includes(email)) {
                            emails.unshift(email);
                            emailInitials.unshift(emailInitial);
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "handleDelete",
            value: function handleDelete(formik, itemIndex) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var member_emails, member_initials;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        member_emails = formik.values.member_emails;
                        member_initials = formik.values.member_initials;
                        member_emails.splice(itemIndex, 1);
                        member_initials.splice(itemIndex, 1);
                        formik.setFieldValue("member_emails", (0,_to_consumable_array/* default */.Z)(member_emails));
                        formik.setFieldValue("member_initials", (0,_to_consumable_array/* default */.Z)(member_initials));
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "onAddClick",
            value: function onAddClick(event1, params) {
                var email = params.value;
                if (params.addNewStageAction.isEmail(email)) {
                    params.addNewStageAction.onSuggestionSelection(params.formik.values.member_emails, email, params.formik.values.member_initials, {
                        email: email,
                        name_initials: null,
                        name: null
                    });
                    params.setStageEmail("");
                    params.formik.setStatus({});
                } else {
                    params.formik.touched["member_emails"] = true;
                    params.formik.setStatus({
                        "member_emails": "Please enter valid email"
                    });
                }
            }
        },
        {
            key: "isEmail",
            value: function isEmail(email) {
                return /^[^\s@]+@[^\s@]+\.[^\s@\.]+$/.test(email);
            }
        },
        {
            key: "handleKeyDown",
            value: function handleKeyDown(event1, formik, setStageEmail, addNewStageAction) {
                if ([
                    "Enter"
                ].includes(event1.key)) {
                    event1.preventDefault();
                    var email = event1.target.value;
                    if (addNewStageAction.isEmail(email)) {
                        addNewStageAction.onSuggestionSelection(formik.values.member_emails, email, formik.values.member_initials, {
                            email: email,
                            name_initials: null,
                            name: null
                        });
                        formik.setStatus({});
                        setStageEmail("");
                    } else {
                        formik.touched["member_emails"] = true;
                        formik.setStatus({
                            "member_emails": "Please enter valid email"
                        });
                    }
                }
            }
        }
    ]);
    return AddNewStageAction;
}();

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ./src/imports-files/pages/admins/logout.js + 1 modules
var logout = __webpack_require__(63281);
;// CONCATENATED MODULE: ./src/services/components/add-new-stage.js








var AddNewStageService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(AddNewStageService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(AddNewStageService);
    function AddNewStageService() {
        (0,_class_call_check/* default */.Z)(this, AddNewStageService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(AddNewStageService, [
        {
            key: "addStage",
            value: function addStage(params, job_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(common/* API.client.kanban.ADD_NEW_STAGE.replace */.bl.client.kanban.ADD_NEW_STAGE.replace("$job_id", job_id), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addStageInfo",
            value: function addStageInfo(job_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(common/* API.client.kanban.NEW_STAGE_INFO.replace */.bl.client.kanban.NEW_STAGE_INFO.replace("$job_id", job_id), (_tmp.params = {}, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AddNewStageService;
}(logout/* SendRequest */.Lt);

;// CONCATENATED MODULE: ./src/imports-files/components/add-new-stage.js





// EXTERNAL MODULE: ./src/imports-files/components/review-email.js + 1 modules
var review_email = __webpack_require__(3623);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/jobs/candidate-profile-job.js + 9 modules
var candidate_profile_job = __webpack_require__(51895);
// EXTERNAL MODULE: ./src/components/common-modal/modal.js + 2 modules
var modal = __webpack_require__(99005);
;// CONCATENATED MODULE: ./src/components/add-new-stage.js





















function AddNewStage(param) {
    var router = param.router, setBtnPopup = param.setBtnPopup, jobData = param.jobData, setJobData = param.setJobData;
    var interviewSwitchButton = function interviewSwitchButton(type) {
        switch(type){
            case common/* INTERVIEW_TYPES.PHONE */.BH.PHONE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(call2/* default */.Z, {});
            case common/* INTERVIEW_TYPES.TECHTEST */.BH.TECHTEST:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(technical/* default */.Z, {
                    className: "techIcon"
                });
            case common/* INTERVIEW_TYPES.VIDEO */.BH.VIDEO:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(video/* default */.Z, {});
            case common/* INTERVIEW_TYPES.FACE2FACE */.BH.FACE2FACE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(user/* default */.Z, {
                    className: "faceIcon"
                });
            case common/* INTERVIEW_TYPES.VIDEOQA */.BH.VIDEOQA:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(videoqa/* default */.Z, {
                    className: "videoQAIcon"
                });
            default:
                return "";
        }
    };
    var t = (0,candidate_profile_job/* useTranslation */.$G)().t;
    (0,candidate_profile_job/* clearSWRCache */.A$)("job_stage_info");
    var ref = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), users = ref[0], setUsers = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(""), 2), stageEmail = ref1[0], setStageEmail = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), disabledSaveButton = ref3[0], setDisabledSaveButton = ref3[1];
    var addNewStageAction = new AddNewStageAction();
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), interviewTypes = ref4[0], setinterviewTypes = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), stages = ref5[0], setStages = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), stagePositions = ref6[0], setStagePositions = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), stageType = ref7[0], setstageType = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(ADD_NEW_STAGE), 2), initialValues = ref8[0], setInitialValues = ref8[1];
    var ref9 = (0,candidate_profile_job/* useSWR */.dH)("job_stage_info", function() {
        return addNewStageAction.getJobInfo(jobData.id);
    }), data = ref9.data, error = ref9.error;
    var selectDropdownRef = (0,candidate_profile_job/* useRef */.sO)(null);
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), isScreening = ref10[0], setIsScreeing = ref10[1];
    (0,candidate_profile_job/* useEffect */.d4)(function() {
        if (data) {
            setStagePositions(data.stage_positions);
            setstageType(data.stage_type);
            setinterviewTypes(data.interview_types);
            initialValues.member_emails = [];
            initialValues.member_initials = [];
            setInitialValues(initialValues);
        }
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                type: "form",
                heading: t("modal:add_new_stage"),
                closeModal: function() {
                    return setBtnPopup(false);
                },
                largeWidth: true,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Formik */.J9, {
                    initialValues: initialValues,
                    validationSchema: addNewStageValidation(isScreening),
                    onSubmit: function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(values, actions) {
                            var errors;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        setDisabledSaveButton(true);
                                        return [
                                            4,
                                            addNewStageAction.submitForm(values, setBtnPopup, jobData, setJobData, setIsLoading)
                                        ];
                                    case 1:
                                        errors = _state.sent();
                                        actions.setErrors(errors);
                                        setDisabledSaveButton(false);
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(values, actions) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    children: function(formik) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(common/* Form */.l0, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((add_new_stage_index_module_default()).AddNewStage, " AutomationPopup AddInterview"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((share_cv_index_module_default()).Form__TableCol),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "".concat((share_cv_index_module_default()).Form__FloatingLabel),
                                                        style: (0,common/* InputText */.oH)(formik, "job_stage_label_attributes.label"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "red-color",
                                                                children: "*"
                                                            }),
                                                            "\xa0",
                                                            t("modal:input:stage_name")
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                        className: "".concat((share_cv_index_module_default()).Form__Input, " ").concat((add_new_stage_index_module_default()).AddNewStage__w100),
                                                        control: "input",
                                                        type: "text",
                                                        autocomplete: "off",
                                                        placeholder: t("placeholder:add_stage"),
                                                        formik: formik,
                                                        maxLength: 255,
                                                        name: "job_stage_label_attributes.label",
                                                        value: formik.values.job_stage_label_attributes.label,
                                                        style: (0,common/* InputError */.pd)(formik, "job_stage_label_attributes.label"),
                                                        custom_class: "FieldError"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((share_cv_index_module_default()).Form__TableCol),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "red-color",
                                                                children: isScreening ? "" : "*"
                                                            }),
                                                            "\xa0",
                                                            t("modal:automation:interview:type")
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: review_email/* FormModalStyle.Modal__Container__ContentSection__Block__IconContainer */.w2.Modal__Container__ContentSection__Block__IconContainer,
                                                        children: interviewTypes.map(function(x, interviewIndex) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: review_email/* FormModalStyle.Modal__Container__ContentSection__Block__IconContainer__Icons */.w2.Modal__Container__ContentSection__Block__IconContainer__Icons,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
                                                                    className: "SimpleTooltip",
                                                                    background: "#00325A",
                                                                    radius: 50,
                                                                    padding: 11,
                                                                    placement: "top",
                                                                    fontSize: "12px",
                                                                    content: x.display_name,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                        className: "".concat((share_cv_index_module_default()).Interview__IconsType, " ").concat((add_new_stage_index_module_default()).Interview__IconsType),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                type: "radio",
                                                                                name: "interview_type_id",
                                                                                id: "icon".concat(interviewIndex),
                                                                                defaultChecked: formik.values.interview_type_id == x.id,
                                                                                checked: formik.values.interview_type_id == x.id,
                                                                                onClick: function() {
                                                                                    if (formik.values.interview_type_id != "" && isScreening && formik.values.interview_type_id == x.id) {
                                                                                        formik.setFieldValue("interview_type_id", "");
                                                                                    } else {
                                                                                        formik.setFieldValue("interview_type_id", x.id);
                                                                                    }
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "icon".concat(interviewIndex),
                                                                                className: "labelcolor",
                                                                                children: interviewSwitchButton(x.name)
                                                                            })
                                                                        ]
                                                                    })
                                                                }, x.name)
                                                            }, "interview_type_".concat(interviewIndex));
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                                        name: "interview_type_id",
                                                        errorClass: (share_cv_index_module_default()).Form__Error,
                                                        formik: formik,
                                                        style: (0,common/* InputError */.pd)(formik, "interview_type_id"),
                                                        custom_class: "FieldError"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: review_email/* FormModalStyle.Modal__Container__ContentSection__BlockContainer */.w2.Modal__Container__ContentSection__BlockContainer,
                                        style: {
                                            gridTemplateColumns: "auto auto"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((share_cv_index_module_default()).Form__TableCol, " mt0"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "".concat((share_cv_index_module_default()).Form__FloatingLabel),
                                                        style: (0,common/* InputText */.oH)(formik, "stage_id"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "red-color",
                                                                children: "*"
                                                            }),
                                                            "\xa0",
                                                            t("modal:input:stage_type")
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w100",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                            className: "".concat((share_cv_index_module_default()).Form__CustomSelect),
                                                            control: "select",
                                                            formik: formik,
                                                            placeholder: t("placeholder:select:stage_type"),
                                                            options: stageType,
                                                            onChange: function(option) {
                                                                var ref, ref1;
                                                                formik.setFieldValue("stage_id", option.value);
                                                                var options = stagePositions[option.key.toLowerCase()];
                                                                setStages((0,_to_consumable_array/* default */.Z)(options));
                                                                selectDropdownRef.current.select.clearValue();
                                                                setIsScreeing(option.value.toString() == ((ref = stageType.find(function(x) {
                                                                    return x.label == common/* JOB_STAGES.SCREENING */.eP.SCREENING;
                                                                })) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.toString()));
                                                                formik.setFieldValue("after_stage_id", "");
                                                            },
                                                            default: formik.values.select_stage_type,
                                                            name: "stage_id",
                                                            style: (0,common/* InputError */.pd)(formik, "stage_id"),
                                                            custom_class: "FieldError"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((share_cv_index_module_default()).Form__TableCol, " mt0"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "".concat((share_cv_index_module_default()).Form__FloatingLabel),
                                                        style: (0,common/* InputText */.oH)(formik, "after_stage_id"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "red-color",
                                                                children: "*"
                                                            }),
                                                            "\xa0",
                                                            t("modal:input:position")
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                        className: "".concat((share_cv_index_module_default()).Form__CustomSelect),
                                                        control: "select",
                                                        formik: formik,
                                                        placeholder: t("placeholder:select:position"),
                                                        options: stages,
                                                        onChange: function(option) {
                                                            formik.setFieldValue("after_stage_id", option === null || option === void 0 ? void 0 : option.value);
                                                        },
                                                        default: formik.values.after_stage_id,
                                                        name: "after_stage_id",
                                                        style: (0,common/* InputError */.pd)(formik, "after_stage_id"),
                                                        custom_class: "FieldError",
                                                        reference: selectDropdownRef
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((share_cv_index_module_default()).SetupPopup__SubmitSectionAutomation, " ").concat((add_new_stage_index_module_default()).SetupPopup__Content__Submit),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                                buttonstyle: "".concat((button_index_module_default()).primarybtn),
                                                type: "submit",
                                                disabled: disabledSaveButton,
                                                children: t("button:save")
                                            })
                                        })
                                    })
                                ]
                            })
                        });
                    }
                })
            }),
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(loading/* Loading */.g, {})
        ]
    });
}

// EXTERNAL MODULE: ./src/components/setup-interview-modal.js + 1 modules
var setup_interview_modal = __webpack_require__(78941);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/jobs/custom-tech-test-modal.js
var custom_tech_test_modal = __webpack_require__(23908);
// EXTERNAL MODULE: ../../shared/node_modules/react-timer-hook/dist/index.js
var react_timer_hook_dist = __webpack_require__(69107);
// EXTERNAL MODULE: ./src/components/countdown-timer.js
var countdown_timer = __webpack_require__(39919);
// EXTERNAL MODULE: ./src/actions/pages/admins/otp.js
var otp = __webpack_require__(6999);
// EXTERNAL MODULE: ./src/imports-files/components/add-to-job-modal.js + 2 modules
var components_add_to_job_modal = __webpack_require__(60838);
;// CONCATENATED MODULE: ./src/constants/components/add-offer.js

var phoneRegex = /^\+?[\d\s]+$/;
function offerInitialValues(offerHash) {
    var ref, ref1, ref2, ref3;
    var salary = offerHash.offer ? offerHash.offer.salary : "";
    var benefits = offerHash.offer ? offerHash.offer.benefits : "";
    var salary_period = offerHash.offer ? offerHash.offer.salary_period : "";
    var start_date = offerHash.offer ? offerHash.offer.start_date : "";
    var employer = offerHash.offer ? offerHash.offer.employer || "" : "";
    var personal_id_number = offerHash.offer ? offerHash.offer.personal_id_number || "" : "";
    var data = {
        offer: {
            job_application_id: offerHash.job_application_id,
            job_application_attributes: {
                contact_no: offerHash.contact_no,
                id: offerHash.job_application_id,
                client_candidate_attributes: {
                    id: offerHash.client_candidate_id,
                    name: offerHash.name,
                    email: offerHash.email
                }
            },
            title: offerHash.title,
            job_title: offerHash.job_title,
            location: offerHash.location,
            employment_type: offerHash.employment_type,
            contract_type: offerHash.contract_type,
            remote: offerHash.remote,
            salary: salary,
            salary_period: salary_period,
            currency_id: offerHash.currency_id,
            benefits: benefits,
            start_date: start_date,
            email: offerHash.email,
            contact_no: offerHash.contact_no,
            name: offerHash.name,
            employer: employer,
            personal_id_number: personal_id_number,
            location_attributes: {
                full_address: offerHash.full_address
            },
            offer_approvals_attributes: [
                {
                    minimum_approval_required: ((ref = offerHash.offer) === null || ref === void 0 ? void 0 : ref.minimum_approval_required) || "",
                    approver_emails: ((ref1 = offerHash.offer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.approvers) === null || ref2 === void 0 ? void 0 : ref2.map(function(x) {
                        return x.email;
                    })) || [],
                    approver_initials: ((ref3 = offerHash.offer) === null || ref3 === void 0 ? void 0 : ref3.approvers) || [],
                    is_default: true,
                    client_id: offerHash.client_id
                }
            ]
        }
    };
    return data;
}
function offerValidationSchema(validation, locationValidation, syncFormValidation) {
    var showValidation = validation;
    var locationValidationCheck = locationValidation;
    var a = {
        offer: components_add_to_job_modal/* Yup.object */.sm.object().shape({
            salary: components_add_to_job_modal/* Yup.string */.sm.string().required((0,components_add_to_job_modal/* TRANSLATION */.TA)("errors:required")).nullable(true),
            salary_period: components_add_to_job_modal/* Yup.string */.sm.string().required((0,components_add_to_job_modal/* TRANSLATION */.TA)("errors:required")),
            currency_id: components_add_to_job_modal/* Yup.string */.sm.string().required((0,components_add_to_job_modal/* TRANSLATION */.TA)("errors:required")),
            // benefits: Yup.string().required(TRANSLATION('errors:required')),
            start_date: components_add_to_job_modal/* Yup.string */.sm.string().required((0,components_add_to_job_modal/* TRANSLATION */.TA)("errors:required")).nullable(true),
            job_title: components_add_to_job_modal/* Yup.string */.sm.string().required((0,components_add_to_job_modal/* TRANSLATION */.TA)("errors:required")),
            employment_type: components_add_to_job_modal/* Yup.string */.sm.string().required((0,components_add_to_job_modal/* TRANSLATION */.TA)("errors:required")),
            contract_type: components_add_to_job_modal/* Yup.string */.sm.string().required((0,components_add_to_job_modal/* TRANSLATION */.TA)("errors:required")),
            name: components_add_to_job_modal/* Yup.string */.sm.string().required((0,components_add_to_job_modal/* TRANSLATION */.TA)("errors:required")),
            business_unit: components_add_to_job_modal/* Yup.string */.sm.string().nullable(),
            team: components_add_to_job_modal/* Yup.string */.sm.string().nullable(),
            syncValidation: components_add_to_job_modal/* Yup.boolean */.sm.boolean(),
            employer: components_add_to_job_modal/* Yup.string */.sm.string().when("syncValidation", {
                is: function(syncValidation) {
                    return syncFormValidation;
                },
                then: components_add_to_job_modal/* Yup.string */.sm.string().required((0,components_add_to_job_modal/* TRANSLATION */.TA)("errors:required")).nullable(true),
                otherwise: components_add_to_job_modal/* Yup.string */.sm.string().nullable()
            }),
            personal_id_number: components_add_to_job_modal/* Yup.string */.sm.string().when("syncValidation", {
                is: function(syncValidation) {
                    return syncFormValidation;
                },
                then: components_add_to_job_modal/* Yup.string */.sm.string().required((0,components_add_to_job_modal/* TRANSLATION */.TA)("errors:required")).nullable(true),
                otherwise: components_add_to_job_modal/* Yup.string */.sm.string().nullable()
            }),
            checkValidation: components_add_to_job_modal/* Yup.boolean */.sm.boolean(),
            contact_no: components_add_to_job_modal/* Yup.string */.sm.string().when("checkValidation", {
                is: function(checkValidation) {
                    return showValidation;
                },
                then: components_add_to_job_modal/* Yup.string */.sm.string().required((0,components_add_to_job_modal/* TRANSLATION */.TA)("errors:required")).matches(phoneRegex, (0,components_add_to_job_modal/* TRANSLATION */.TA)("errors:no_special_char"))
            }),
            email: components_add_to_job_modal/* Yup.string */.sm.string().when("checkValidation", {
                is: function(checkValidation) {
                    return showValidation;
                },
                then: components_add_to_job_modal/* Yup.string */.sm.string().required((0,components_add_to_job_modal/* TRANSLATION */.TA)("errors:required"))
            }),
            location_attributes: components_add_to_job_modal/* Yup.object */.sm.object().shape({
                full_address: components_add_to_job_modal/* Yup.string */.sm.string().when("checkValidation", {
                    is: function(checkValidation) {
                        return locationValidationCheck;
                    },
                    then: components_add_to_job_modal/* Yup.string */.sm.string().required((0,components_add_to_job_modal/* TRANSLATION */.TA)("errors:required")),
                    otherwise: components_add_to_job_modal/* Yup.string */.sm.string().nullable()
                })
            }),
            offer_approvals_attributes: components_add_to_job_modal/* Yup.array */.sm.array().of(components_add_to_job_modal/* Yup.object */.sm.object({
                approver_emails: components_add_to_job_modal/* Yup.array */.sm.array(),
                minimum_approval_required: components_add_to_job_modal/* Yup.string */.sm.string().when("approver_emails", {
                    is: function(approver_emails) {
                        return approver_emails.length > 0;
                    },
                    then: components_add_to_job_modal/* Yup.string */.sm.string().required((0,components_add_to_job_modal/* TRANSLATION */.TA)("errors:required")).nullable(),
                    otherwise: components_add_to_job_modal/* Yup.string */.sm.string().notRequired()
                })
            }))
        })
    };
    var ADD_TO_OFFER_SCHEMA = components_add_to_job_modal/* Yup.object */.sm.object(a);
    return ADD_TO_OFFER_SCHEMA;
}

// EXTERNAL MODULE: ./src/actions/common/render_error_loading.js
var render_error_loading = __webpack_require__(10758);
// EXTERNAL MODULE: ./src/styles/pages/clients/job-sharing/_index.module.scss
var job_sharing_index_module = __webpack_require__(25385);
var job_sharing_index_module_default = /*#__PURE__*/__webpack_require__.n(job_sharing_index_module);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/interview_stages.js
var interview_stages = __webpack_require__(68109);
// EXTERNAL MODULE: ./src/constants/common/internationalisation.js
var internationalisation = __webpack_require__(44052);
;// CONCATENATED MODULE: ./src/actions/pages/clients/candidates/add-offer.js












var OfferActions = /*#__PURE__*/ function() {
    "use strict";
    function OfferActions(setApprovalOptions, approvalDropdownRef, t) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, OfferActions);
        (0,_define_property/* default */.Z)(this, "renderInputComponent", function(inputProps) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                className: "buttonIn AutoSuggestInput__Tags",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (job_sharing_index_module_default()).Tagrow,
                        children: (ref = inputProps.selectedValues) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (job_sharing_index_module_default()).Tagrow__Tags,
                                children: [
                                    item.name ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: item.name
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: item.email
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        className: (job_sharing_index_module_default()).Tagrow__Cancel,
                                        onClick: function() {
                                            return inputProps.offerActions.handleEmailDelete(inputProps.formik, index);
                                        },
                                        children: inputProps.closeIcon
                                    })
                                ]
                            }, "job_approvers_".concat(inputProps.index));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        className: (job_sharing_index_module_default()).Form__Input,
                        autoComplete: "password"
                    }, inputProps)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                        buttonstyle: "".concat((job_sharing_index_module_default()).nobgbutton, " addbtn"),
                        disabled: inputProps.disabled,
                        onClick: function() {
                            return _this.onAddClick(event, inputProps);
                        },
                        children: (0,internationalisation/* TRANSLATION */.T)("button:add:default")
                    })
                ]
            });
        });
        (0,_define_property/* default */.Z)(this, "onUserSuggestionsClearRequested", function(setUsers) {
            setUsers([]);
        });
        (0,_define_property/* default */.Z)(this, "onAddClick", function(event1, params) {
            var email = params.value;
            if (_this.isEmail(email)) {
                {
                    _this.onUserSuggestionSelection(params.formik, params.formik.values.offer.offer_approvals_attributes[0].approver_emails, email, params.formik.values.offer.offer_approvals_attributes[0].approver_initials, {
                        email: email,
                        name_initials: null,
                        name: null
                    });
                    params.setApproverEmail("");
                }
            } else {
                params.setApproverEmailError(params.t("errors:autocomplete_invalid_email"));
            }
        });
        this.setApprovalOptions = setApprovalOptions;
        this.approvalDropdownRef = approvalDropdownRef;
        this.t = t;
    }
    (0,_create_class/* default */.Z)(OfferActions, [
        {
            key: "shouldRenderSuggestions",
            value: function shouldRenderSuggestions(value) {
                return value.trim().length >= 3;
            }
        },
        {
            key: "getUserSuggestionValue",
            value: function getUserSuggestionValue(suggestion) {
                return "".concat(suggestion.user_attributes.email);
            }
        },
        {
            key: "showSuggestion",
            value: function showSuggestion(suggestion) {}
        },
        {
            key: "renderUserSuggestion",
            value: function renderUserSuggestion(suggestion) {
                var response = "";
                if (suggestion.user_attributes.name && suggestion.user_attributes.email.length > 0) {
                    response = "".concat(suggestion.user_attributes.name, " | ").concat(suggestion.user_attributes.email);
                } else if (suggestion.user_attributes.name) {
                    response = "".concat(suggestion.user_attributes.name);
                } else {
                    response = "".concat(suggestion.user_attributes.email);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: response
                });
            }
        },
        {
            key: "escapeRegexCharacters",
            value: function escapeRegexCharacters(str) {
                return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            }
        },
        {
            key: "getUserSuggestions",
            value: function getUserSuggestions(value, router) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var escapedValue, finalUsers;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                escapedValue = _this.escapeRegexCharacters(value === null || value === void 0 ? void 0 : value.trim());
                                if (escapedValue === "") {
                                    return [
                                        2,
                                        []
                                    ];
                                }
                                return [
                                    4,
                                    (0,interview_stages/* getClientUsers */.D6)(escapedValue, "3", router)
                                ];
                            case 1:
                                finalUsers = _state.sent();
                                return [
                                    2,
                                    finalUsers
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onUserSuggestionsFetchRequested",
            value: function onUserSuggestionsFetchRequested(hash, setUsers) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var users;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getUserSuggestions(hash.value)
                                ];
                            case 1:
                                users = _state.sent();
                                setUsers(users);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isEmail",
            value: function isEmail(email) {
                return /^[^\s@]+@[^\s@]+\.[^\s@\.]+$/.test(email);
            }
        },
        {
            key: "onUserSuggestionSelection",
            value: function onUserSuggestionSelection(formik, old_emails, email, old_initials, new_initial) {
                if (this.isEmail(email) && !old_emails.includes(email)) {
                    var ref, ref1;
                    old_emails.unshift(email);
                    old_initials.unshift(new_initial);
                    this.setOptions(old_emails.length);
                    formik.setFieldValue("offer.offer_approvals_attributes.0.minimum_approval_required", "");
                    (ref = this.approvalDropdownRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.select) === null || ref1 === void 0 ? void 0 : ref1.clearValue();
                }
            }
        },
        {
            key: "handleKeyDown",
            value: function handleKeyDown(evt, formik, setApproverEmail, setApproverEmailError, t) {
                if ([
                    "Enter"
                ].includes(evt.key)) {
                    evt.preventDefault();
                    var email = evt.target.value;
                    if (this.isEmail(email)) {
                        {
                            this.onUserSuggestionSelection(formik, formik.values.offer.offer_approvals_attributes[0].approver_emails, email, formik.values.offer.offer_approvals_attributes[0].approver_initials, {
                                email: email,
                                name_initials: null,
                                name: null
                            });
                            setApproverEmail("");
                        }
                    } else {
                        setApproverEmailError(t("errors:autocomplete_invalid_email"));
                    }
                }
                ;
            }
        },
        {
            key: "handleEmailDelete",
            value: function handleEmailDelete(formik, itemIndex) {
                var ref, ref1;
                var emails = formik.values.offer.offer_approvals_attributes[0].approver_emails;
                var name_initials = formik.values.offer.offer_approvals_attributes[0].approver_initials;
                emails.splice(itemIndex, 1);
                name_initials.splice(itemIndex, 1);
                this.setOptions(emails.length);
                formik.setFieldValue("offer.offer_approvals_attributes.0.minimum_approval_required", "");
                (ref = this.approvalDropdownRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.select) === null || ref1 === void 0 ? void 0 : ref1.clearValue();
            }
        },
        {
            key: "setOptions",
            value: function setOptions(len) {
                var options = [
                    {
                        value: len,
                        label: this.t("career:jobs:all")
                    }
                ];
                for(var i = 1; i < len; i++){
                    options.push({
                        value: i,
                        label: this.t("career:jobs:any", {
                            i: i
                        })
                    });
                }
                return len == 0 ? this.setApprovalOptions([]) : this.setApprovalOptions(options);
            }
        }
    ]);
    return OfferActions;
}();

// EXTERNAL MODULE: ./src/styles/pages/kanban/_index.module.scss
var kanban_index_module = __webpack_require__(31144);
var kanban_index_module_default = /*#__PURE__*/__webpack_require__.n(kanban_index_module);
// EXTERNAL MODULE: ./src/actions/components/kanbanComponents/flip-back-page.js
var flip_back_page = __webpack_require__(8704);
;// CONCATENATED MODULE: ./src/actions/pages/clients/candidates/flip-page.js











var FlipPageAction = /*#__PURE__*/ function() {
    "use strict";
    function FlipPageAction(router, setUsers) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, FlipPageAction);
        (0,_define_property/* default */.Z)(this, "renderMemberInputComponent", function(inputProps) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "savebuttonin ".concat(inputProps.flipPageAction.isDisabled(inputProps.editable)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        className: (kanban_index_module_default()).Form__Input,
                        autoComplete: "password"
                    }, inputProps)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                        buttonstyle: "".concat((kanban_index_module_default()).nobgbutton, " addbtn ").concat((0,jobs_common/* cursorNone */.y$)(inputProps.editable)),
                        disabled: inputProps.disabled,
                        onClick: function(event) {
                            return inputProps.flipPageAction.onAddClick(event, inputProps);
                        },
                        children: (0,common/* TRANSLATION */.TA)("button:add:default")
                    })
                ]
            });
        });
        (0,_define_property/* default */.Z)(this, "onAddClick", function(event, params) {
            var email = params.value;
            if (_this.isEmail(email)) {
                params.flipPageAction.onSuggestionSelection(params.members, params.setMembers, {
                    email: email,
                    name_initials: null,
                    name: null
                });
                params.setUserEmail("");
                params.setUserEmailError("");
            } else {
                params.setUserEmailError("Please enter valid email");
            }
        });
        this.router = router;
        this.setUsers = setUsers;
        this.customToastrAction = new common/* CustomToastrAction */.Y5();
    }
    (0,_create_class/* default */.Z)(FlipPageAction, [
        {
            key: "addRemoveMember",
            value: function addRemoveMember(event, members, job_id, job_stage_id, jobData, setJobData, setFlagForRerender) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var params, _tmp, result, status_code, ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                params = (_tmp.member_emails = members.map(function(member) {
                                    return member.email;
                                }), _tmp);
                                return [
                                    4,
                                    new FlipPageService().addRemoveMember(params, job_id, job_stage_id)
                                ];
                            case 1:
                                result = _state.sent();
                                status_code = result.status || result.response.status;
                                if (!(status_code == 200)) return [
                                    3,
                                    5
                                ];
                                jobData.lanes.map(function(lane) {
                                    if (lane.id.toString() == job_stage_id.toString()) {
                                        lane.members = result.data.members;
                                    }
                                    return lane;
                                });
                                return [
                                    4,
                                    setJobData(jobData)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    (0,flip_back_page/* flipLane */.u)(event)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    setFlagForRerender(Math.random * 10000)
                                ];
                            case 4:
                                _state.sent();
                                _this.customToastrAction.setNormalToastr("Member(s) updated successfully", "success");
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if ((ref = result.response.data.error) === null || ref === void 0 ? void 0 : (ref1 = ref.job_stage) === null || ref1 === void 0 ? void 0 : ref1.member_emails) _this.customToastrAction.setNormalToastr(result.response.data.error.job_stage.member_emails, "error");
                                _state.label = 6;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSuggestionValue",
            value: function getSuggestionValue(suggestion) {
                return "".concat(suggestion.user_attributes.email);
            }
        },
        {
            key: "showSuggestion",
            value: function showSuggestion(suggestion) {
                if (suggestion.user_attributes.name && suggestion.user_attributes.email.length > 0) {
                    return "".concat(suggestion.user_attributes.name, " | ").concat(suggestion.user_attributes.email);
                } else if (suggestion.user_attributes.name) {
                    return "".concat(suggestion.user_attributes.name);
                } else {
                    return "".concat(suggestion.user_attributes.email);
                }
            }
        },
        {
            key: "renderSuggestion",
            value: function renderSuggestion(suggestion, flipPageAction) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: flipPageAction.showSuggestion(suggestion)
                });
            }
        },
        {
            key: "escapeRegexCharacters",
            value: function escapeRegexCharacters(str) {
                return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            }
        },
        {
            key: "getSuggestions",
            value: function getSuggestions(value, current_step) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var escapedValue, regex, finalUsers;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                escapedValue = _this.escapeRegexCharacters(value.trim());
                                if (escapedValue === "") {
                                    return [
                                        2,
                                        []
                                    ];
                                }
                                regex = new RegExp("^" + escapedValue, "i");
                                return [
                                    4,
                                    (0,interview_stages/* getClientUsers */.D6)(escapedValue, current_step, _this.router)
                                ];
                            case 1:
                                finalUsers = _state.sent();
                                return [
                                    2,
                                    finalUsers
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onSuggestionsFetchRequested",
            value: function onSuggestionsFetchRequested(value, flipPageAction, current_step) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var users;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    flipPageAction.getSuggestions(value)
                                ];
                            case 1:
                                users = _state.sent();
                                _this.setUsers(users);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "shouldRenderSuggestions",
            value: function shouldRenderSuggestions(value) {
                return value.trim().length >= 3;
            }
        },
        {
            key: "isEmail",
            value: function isEmail(email) {
                return /^[^\s@]+@[^\s@]+\.[^\s@\.]+$/.test(email);
            }
        },
        {
            key: "isDisabled",
            value: function isDisabled(editable) {
                return editable ? "" : "disabled";
            }
        },
        {
            key: "onSuggestionSelection",
            value: function onSuggestionSelection(members, setMembers, member_initial) {
                var member_emails = members.map(function(x) {
                    return x.email;
                });
                if (!member_emails.includes(member_initial.email)) {
                    members.unshift(member_initial);
                    setMembers((0,_to_consumable_array/* default */.Z)(members));
                }
            }
        },
        {
            key: "handleKeyDown",
            value: function handleKeyDown(event, members, setMembers, setUserEmailError) {
                if ([
                    "Enter"
                ].includes(event.key)) {
                    event.preventDefault();
                    var email = event.target.value;
                    if (this.isEmail(email)) {
                        this.onSuggestionSelection(members, setMembers, {
                            email: email,
                            name_initials: null,
                            name: null
                        });
                        setUserEmailError("");
                    } else {
                        setUserEmailError("Please enter valid email");
                    }
                }
            }
        },
        {
            key: "handleDelete",
            value: function handleDelete(members, setMembers, itemIndex) {
                members.splice(itemIndex, 1);
                setMembers((0,_to_consumable_array/* default */.Z)(members));
            }
        }
    ]);
    return FlipPageAction;
}();

// EXTERNAL MODULE: ./src/imports-files/pages/clients/activities/index.js + 26 modules
var activities = __webpack_require__(14683);
;// CONCATENATED MODULE: ./src/services/pages/clients/candidates/flip-page-service.js







var FlipPageService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(FlipPageService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(FlipPageService);
    function FlipPageService() {
        (0,_class_call_check/* default */.Z)(this, FlipPageService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(FlipPageService, [
        {
            key: "addRemoveMember",
            value: function addRemoveMember(params, job_id, job_stage_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    activities/* axios.put */.od.put(activities/* API.client.kanban.ADD_MEMBER_KANBAN.replace */.bl.client.kanban.ADD_MEMBER_KANBAN.replace("$job_id", job_id).replace("$job_stage_id", job_stage_id), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return FlipPageService;
}(activities/* SendRequest */.Lt);

// EXTERNAL MODULE: ./public/icons/warning.svg
var warning = __webpack_require__(51750);
// EXTERNAL MODULE: ./src/components/agency-accept-reject.js
var agency_accept_reject = __webpack_require__(84529);
// EXTERNAL MODULE: ./src/actions/pages/clients/activities/candidate-merge-action.js
var candidate_merge_action = __webpack_require__(52848);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/jobs/send-questions-modal.js
var send_questions_modal = __webpack_require__(11281);
// EXTERNAL MODULE: ./src/actions/common/application-filter.js
var application_filter = __webpack_require__(98766);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/candidates/kanban.js















// COMPONENTS









// COMPONENTS


















/***/ }),

/***/ 71198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W$": function() { return /* reexport */ activities/* ActivitiesAction */.W; },
  "ux": function() { return /* reexport */ BACKGROUND_FILE_SIZE; },
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "ZJ": function() { return /* reexport */ (button_index_module_default()); },
  "XZ": function() { return /* reexport */ common/* Checkbox */.XZ; },
  "LD": function() { return /* reexport */ common/* ClientDashboard */.LD; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "Oi": function() { return /* reexport */ DEFAULT_HEADING; },
  "uw": function() { return /* reexport */ DEFAULT_SUBHEADING; },
  "AE": function() { return /* reexport */ index_es/* default */.Z; },
  "TW": function() { return /* reexport */ editimage["default"]; },
  "dC": function() { return /* reexport */ common/* ErrorPages */.dC; },
  "l0": function() { return /* reexport */ common/* Form */.l0; },
  "J9": function() { return /* reexport */ common/* Formik */.J9; },
  "h8": function() { return /* reexport */ LOGO_FILE_SIZE; },
  "k2": function() { return /* reexport */ (_index_module_default()); },
  "Ph": function() { return /* reexport */ common/* Select */.Ph; },
  "Dv": function() { return /* reexport */ common/* SidebarAction */.Dv; },
  "if": function() { return /* reexport */ skip_modal/* SkipModal */.i; },
  "se": function() { return /* reexport */ careers_createJob/* findJob */.s; },
  "wy": function() { return /* reexport */ createJob/* getCustomizeCareerData */.wy; },
  "Qh": function() { return /* reexport */ createJob/* handleBackgroundOnChange */.Qh; },
  "EH": function() { return /* reexport */ createJob/* updateHeader */.EH; },
  "oP": function() { return /* reexport */ createJob/* updateSubheader */.oP; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: API, Component, ErrorMessage, Field, FieldArray, FormikControl, Image, Link, Loading, NextServerCookies, PAGE_ANIMATION_OPTIONS, REDIRECT, React, SUCCESS_REPONSE_CODE, ShowJobAction, TRANSLATION, UNAUTHORIZED_REPONSE_CODE, Yup, afterSigninPath, axios, faExclamationCircle, faTimes, getIn, getSession, handleLogoOnChange, motion, openFile, removeCarrerPagePadding, set_background_image, signIn, toastr, updateBackground, updateLogo

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ../../shared/node_modules/react-editext/dist/index.es.js
var index_es = __webpack_require__(73399);
// EXTERNAL MODULE: ./src/pages/careers/editimage.js
var editimage = __webpack_require__(52557);
// EXTERNAL MODULE: ./src/actions/pages/clients/activities/index.js
var activities = __webpack_require__(41767);
// EXTERNAL MODULE: ./src/components/skip-modal.js
var skip_modal = __webpack_require__(53594);
;// CONCATENATED MODULE: ./src/constants/pages/clients/careers/createJob.js
var BACKGROUND_FILE_SIZE = 26214400; // 25 MB
var LOGO_FILE_SIZE = 10485760; // 10 MB
var DEFAULT_HEADING = "Lorem ipsum dolor sit amet";
var DEFAULT_SUBHEADING = "We’re looking for great people to join our growing team.";
var LOGO_FILE = "/images/pages/career/LOGO.png";

// EXTERNAL MODULE: ./src/styles/pages/clients/career/customize-career/_index.module.scss
var _index_module = __webpack_require__(91122);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/styles/components/button/_index.module.scss
var button_index_module = __webpack_require__(84215);
var button_index_module_default = /*#__PURE__*/__webpack_require__.n(button_index_module);
// EXTERNAL MODULE: ./src/actions/pages/clients/careers/createJob.js
var createJob = __webpack_require__(73140);
// EXTERNAL MODULE: ./src/actions/pages/clients/careers/showJob.js + 1 modules
var showJob = __webpack_require__(70158);
// EXTERNAL MODULE: ./src/services/pages/clients/careers/createJob.js
var careers_createJob = __webpack_require__(43185);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/careers/createJob.js
// ----------------- Common Library -----------------

// ----------------- Common Library -----------------
// ------------------ COMPONENTS -------------------




// ------------------ COMPONENTS -------------------
// ----------------- Constant -----------------

// ----------------- Constant -----------------
// ----------------- Style -----------------


// ----------------- Style -----------------
// ----------------- Actions -----------------

// ----------------- Actions -----------------

// export { get_json_data_for_jobOption, get_json_data_for_locationOption, get_json_data_for_location } from '@/actions/pages/clients/careers/showJob';
// ----------------- Actions ------------------
// ----------------- Actions -----------------
// ----------------- Services -----------------
 // ----------------- Services -----------------


/***/ }),

/***/ 51439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RQ": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.RQ; },
/* harmony export */   "TA": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.TA; },
/* harmony export */   "Ws": function() { return /* reexport safe */ _actions_pages_clients_careers_showJob__WEBPACK_IMPORTED_MODULE_2__.W; }
/* harmony export */ });
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96047);
/* harmony import */ var _constants_pages_clients_careers_showJob_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88755);
/* harmony import */ var _actions_pages_clients_careers_showJob__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70158);
/* harmony import */ var _services_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43185);
/* harmony import */ var _actions_common_render_error_loading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10758);
// ----------------- Common Library -----------------

// ----------------- Common Library -----------------
// ----------------- Constant -----------------

// ----------------- Constant -----------------
// ----------------- Style -----------------



// ----------------- Style -----------------
// ----------------- Actions -----------------

// ----------------- Actions ------------------
// ----------------- Services -----------------

// ----------------- Services -----------------



/***/ }),

/***/ 92518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "UQ": function() { return /* reexport */ es/* Accordion */.UQ; },
  "Qd": function() { return /* reexport */ es/* AccordionItem */.Qd; },
  "on": function() { return /* reexport */ es/* AccordionItemButton */.on; },
  "Ol": function() { return /* reexport */ es/* AccordionItemHeading */.Ol; },
  "Mt": function() { return /* reexport */ es/* AccordionItemPanel */.Mt; },
  "Xd": function() { return /* reexport */ arrowleft/* default */.Z; },
  "Q9": function() { return /* reexport */ communication/* COMMUNICATIONS */.Q; },
  "IP": function() { return /* reexport */ candidate_email.CandidateEmail; },
  "LD": function() { return /* reexport */ common/* ClientDashboard */.LD; },
  "QW": function() { return /* reexport */ icons_document/* default */.Z; },
  "Dd": function() { return /* reexport */ react_ellipsis_text["default"]; },
  "B8": function() { return /* reexport */ EmailDetailsAction; },
  "V1": function() { return /* reexport */ email_details/* EmailDetailsService */.V; },
  "Y8": function() { return /* reexport */ EmailsDetailsOptions; },
  "dC": function() { return /* reexport */ common/* ErrorPages */.dC; },
  "Ee": function() { return /* reexport */ common/* Image */.Ee; },
  "Mf": function() { return /* reexport */ common/* PAGE_ANIMATION_OPTIONS */.Mf; },
  "k2": function() { return /* reexport */ (_index_module_default()); },
  "RQ": function() { return /* reexport */ common/* REDIRECT */.RQ; },
  "Lt": function() { return /* reexport */ common/* SendRequest */.Lt; },
  "Rh": function() { return /* reexport */ starfilled/* default */.Z; },
  "pI": function() { return /* reexport */ tripledots; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "A$": function() { return /* reexport */ common/* clearSWRCache */.A$; },
  "EA": function() { return /* reexport */ common/* motion */.EA; },
  "Qc": function() { return /* reexport */ html_react_parser/* default */.ZP; },
  "Z6": function() { return /* reexport */ (sanitize_html_default()); },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: BrowserDetect, Button, ButtonStyle, Checkbox, CommunicationBulkActionModal, CommunicationCenterOptions, ConfirmationModal, CustomToastrAction, DataTable, Dots, DownloadFileFromEmail, Filter, Link, Loading, SUCCESS_REPONSE_CODE, Star, TRANSLATION, Tooltip, UNAUTHORIZED_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE, Yup, getColumnsName, getSession, handleOtherResponseCode, setDataTableClass, toastr, useUser

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/constants/pages/clients/communication/index.js
var communication = __webpack_require__(63421);
// EXTERNAL MODULE: ../../shared/node_modules/react-data-table-component/dist/index.cjs.js
var index_cjs = __webpack_require__(61977);
// EXTERNAL MODULE: ./src/components/datatableActionOptions/commuication-center.js
var commuication_center = __webpack_require__(60765);
// EXTERNAL MODULE: ./src/components/bulk-action-modal/communication-bulk-action.js + 1 modules
var communication_bulk_action = __webpack_require__(42927);
// EXTERNAL MODULE: ./src/components/confirmation-modal.js
var confirmation_modal = __webpack_require__(72055);
// EXTERNAL MODULE: ../../shared/node_modules/react-accessible-accordion/dist/es/index.js
var es = __webpack_require__(51101);
// EXTERNAL MODULE: ../../shared/node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(78719);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ../../shared/node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(56621);
// EXTERNAL MODULE: ../../shared/node_modules/react-ellipsis-text/index.js
var react_ellipsis_text = __webpack_require__(80272);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ./src/services/pages/clients/communication/email-details.js
var email_details = __webpack_require__(72389);
// EXTERNAL MODULE: ./src/actions/components/custom-toastr.js
var custom_toastr = __webpack_require__(66939);
// EXTERNAL MODULE: ./src/constants/common/urls.js
var urls = __webpack_require__(47694);
;// CONCATENATED MODULE: ./src/actions/pages/clients/communication/email-detail.js





var EmailDetailsAction = /*#__PURE__*/ function() {
    "use strict";
    function EmailDetailsAction(setApiError, setShowCandidateEmail, router) {
        (0,_class_call_check/* default */.Z)(this, EmailDetailsAction);
        this.setApiError = setApiError;
        this.setShowCandidateEmail = setShowCandidateEmail;
        this.emailDetailsService = new email_details/* EmailDetailsService */.V();
        this.router = router;
    }
    (0,_create_class/* default */.Z)(EmailDetailsAction, [
        {
            key: "getEmailData",
            value: function getEmailData() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var params, _tmp, comms_id, result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                params = _tmp;
                                comms_id = _this.router.query.comm_detail_id;
                                return [
                                    4,
                                    _this.emailDetailsService.getEmailDetailData(params, comms_id)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                return [
                                    2,
                                    result.data
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "openJobOptions",
            value: function openJobOptions(event) {
                event.stopPropagation();
                var dots_element = event.currentTarget.querySelector(".Dots");
                var element = event.currentTarget.querySelector(".EmailsDetailsOptions");
                if (dots_element.classList.contains("Close")) {
                    this.closeAllJobsOptions();
                    element.classList.remove("Close");
                    element.classList.add("Open");
                    dots_element.classList.remove("Close");
                    dots_element.classList.add("Open");
                } else {
                    this.closeAllJobsOptions();
                    element.classList.remove("Open");
                    element.classList.add("Close");
                    dots_element.classList.remove("Open");
                    dots_element.classList.add("Close");
                }
            }
        },
        {
            key: "closeAllJobsOptions",
            value: function closeAllJobsOptions() {
                var element = document.querySelector(".EmailsDetailsOptions.Open");
                var dots_element = document.querySelector(".Dots.Open");
                if (element) {
                    element.classList.remove("Open");
                    element.classList.add("Close");
                    dots_element.classList.remove("Open");
                    dots_element.classList.add("Close");
                }
            }
        },
        {
            key: "html_txt_parsing",
            value: function html_txt_parsing(message_body) {
                try {
                    message_body = sanitize_html_default()(message_body, {
                        allowedTags: false,
                        allowedAttributes: false
                    });
                    return (0,html_react_parser/* default */.ZP)("".concat(message_body));
                } catch (err) {
                    return message_body;
                }
            }
        },
        {
            key: "html_txt_parsing_text_only",
            value: function html_txt_parsing_text_only(message_body) {
                try {
                    message_body = sanitize_html_default()(message_body, {
                        allowedTags: [],
                        allowedAttributes: {}
                    });
                    return (0,html_react_parser/* default */.ZP)("".concat(message_body));
                } catch (err) {
                    return message_body;
                }
            }
        },
        {
            key: "toggle",
            value: function toggle(event, data, page_name) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var params, _tmp, result, element_classes;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                params = _tmp;
                                result = "";
                                event.stopPropagation();
                                params["id"] = [
                                    _this.router.query.comm_detail_id
                                ];
                                params["comm_detail_id"] = [
                                    data.id
                                ];
                                element_classes = event.currentTarget;
                                if (!element_classes.classList.contains("ImportantEmail")) return [
                                    3,
                                    2
                                ];
                                params["important"] = false;
                                return [
                                    4,
                                    _this.emailDetailsService.markAsImportantAndUnimportant(params)
                                ];
                            case 1:
                                result = _state.sent();
                                if (result.status == 200) {
                                    element_classes.classList.remove("ImportantEmail");
                                    element_classes.classList.add("NotImportantEmail");
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                params["important"] = true;
                                return [
                                    4,
                                    _this.emailDetailsService.markAsImportantAndUnimportant(params)
                                ];
                            case 3:
                                result = _state.sent();
                                if (result.status == 200) {
                                    element_classes.classList.remove("NotImportantEmail");
                                    element_classes.classList.add("ImportantEmail");
                                }
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getToData",
            value: function getToData(data) {
                var return_data = "";
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        if (return_data == "") {
                            return_data = element.name || element.email;
                        } else {
                            return_data = return_data + ", " + (element.name || element.email);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return return_data;
            }
        },
        {
            key: "onChangeAccordion",
            value: function onChangeAccordion(uuid) {
                var all_element = document.querySelectorAll(".EmailTo");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = all_element[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        element.style.display = "none";
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var all_show_element_text = document.querySelectorAll(".Texts");
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = all_show_element_text[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var element1 = _step1.value;
                        element1.style.display = "block";
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if (uuid.length != 0) {
                    var current_element = document.querySelectorAll(".".concat(uuid, " .EmailTo"));
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = current_element[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var element2 = _step2.value;
                            element2.style.display = "block";
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                    var show_element_text = document.querySelectorAll(".".concat(uuid, " .Texts"));
                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                    try {
                        for(var _iterator3 = show_element_text[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                            var element3 = _step3.value;
                            element3.style.display = "none";
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                _iterator3.return();
                            }
                        } finally{
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }
            }
        },
        {
            key: "preExpand",
            value: function preExpand() {
                var element = document.querySelector(".AccordionItem.Item_1 .Texts");
                if (element) element.style.display = "none";
            }
        },
        {
            key: "actionDownloadFileFromEmail",
            value: function actionDownloadFileFromEmail(event, attachment) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var downloadLink;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        downloadLink = document.createElement("a");
                        downloadLink.setAttribute("target", "_blank");
                        downloadLink.setAttribute("download", "");
                        downloadLink.href = attachment.attachment_url;
                        downloadLink.download = attachment.fileName;
                        downloadLink.click();
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    ]);
    return EmailDetailsAction;
}();

;// CONCATENATED MODULE: ./src/actions/components/datatableActionOptions/email-details-options-actions.js









var EmailsDetailsOptionsActions = /*#__PURE__*/ function() {
    "use strict";
    function EmailsDetailsOptionsActions(router, setApiError, setShowCandidateEmail) {
        (0,_class_call_check/* default */.Z)(this, EmailsDetailsOptionsActions);
        this.emailDetailsService = new email_details/* EmailDetailsService */.V();
        this.customToastrAction = new custom_toastr/* CustomToastrAction */.Y();
        this.router = router;
        this.setApiError = setApiError;
        this.emailDetailsAction = new EmailDetailsAction(setApiError, setShowCandidateEmail, router);
    }
    (0,_create_class/* default */.Z)(EmailsDetailsOptionsActions, [
        {
            key: "performJobAction",
            value: function performJobAction(ActionName, params) {
                var _this = this;
                switch(ActionName){
                    case "reply_all":
                        this.reply_all(params);
                        break;
                    case "forward":
                        this.forward(params);
                        break;
                    case "delete":
                        params.setConfirmationModal({
                            state: true,
                            message: params.t("modal:confirmation:delete:email"),
                            confirm_btn_action: function() {
                                _this.delete(params);
                            }
                        });
                        break;
                    default:
                        "";
                }
            }
        },
        {
            key: "reply_all",
            value: function reply_all(args) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        args.setEmailData(args.data || args.data);
                        args.setMessageId(((ref = args.data) === null || ref === void 0 ? void 0 : (ref1 = ref.comm_detail) === null || ref1 === void 0 ? void 0 : ref1.message_id) || args.data.message_id);
                        args.setReferences(((ref2 = args.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.comm_detail) === null || ref3 === void 0 ? void 0 : ref3.references) || args.data.references);
                        args.setReplyTo(((ref4 = args.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.comm_detail) === null || ref5 === void 0 ? void 0 : ref5.in_reply_to) || ((ref6 = args.data) === null || ref6 === void 0 ? void 0 : ref6.in_reply_to));
                        args.setEmailFrom(((ref7 = args.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.comm_detail) === null || ref8 === void 0 ? void 0 : ref8.from) || ((ref9 = args.data) === null || ref9 === void 0 ? void 0 : ref9.from));
                        args.setEmailTo(((ref10 = args.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.comm_detail) === null || ref11 === void 0 ? void 0 : ref11.to) || ((ref12 = args.data) === null || ref12 === void 0 ? void 0 : ref12.to));
                        args.setForward(false);
                        args.setShowCandidateEmail(true);
                        args.setFlagForRerender(Math.random() * 10000);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "forward",
            value: function forward(args) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        args.setEmailData(args.data || args.data);
                        args.setForward(true);
                        args.setShowCandidateEmail(true);
                        args.setFlagForRerender(Math.random() * 10000);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "delete",
            value: function _delete(args) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3, params, _tmp, result, params1, comms_id, list_result, _tmp1, link, _tmp2, link1, _tmp3;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                params = (_tmp.id = ((ref = args.data) === null || ref === void 0 ? void 0 : (ref1 = ref.comm_detail) === null || ref1 === void 0 ? void 0 : ref1.id) || args.data.id, _tmp.comm_detail_id = ((ref2 = args.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.comm_detail) === null || ref3 === void 0 ? void 0 : ref3.id) || args.data.id, _tmp);
                                return [
                                    4,
                                    _this.emailDetailsService.deleteEmail(params)
                                ];
                            case 1:
                                result = _state.sent();
                                if (!(result.request.status == 200)) return [
                                    3,
                                    3
                                ];
                                _this.customToastrAction.setNormalToastr((0,common/* TRANSLATION */.TA)("toastr:email_deleted"), "success");
                                params1 = _this.router.query;
                                comms_id = args.parentId ? args.parentId : _this.router.query.comm_detail_id;
                                return [
                                    4,
                                    _this.emailDetailsService.getEmailDetailData(params1, comms_id)
                                ];
                            case 2:
                                list_result = _state.sent();
                                _this.setApiError(list_result.request);
                                _tmp1 = {};
                                _tmp2 = {};
                                _tmp3 = {};
                                if (list_result.request.status == 200) {
                                    args.setConfirmationModal((_tmp1.state = false, _tmp1.message = "", _tmp1.confirm_btn_action = "", _tmp1));
                                    args.setFlagForRerender(Math.random() * 10000);
                                    args.setEmailListingData(list_result.data);
                                    if (args.parentId) {
                                        link = urls/* REDIRECT.client.communication.emails.replace */.R.client.communication.emails.replace("$comm_detail_id", args.parentId);
                                        params1.email_type = "sent";
                                        delete params1["comm_detail_id"];
                                        _this.router.push((_tmp2.pathname = link, _tmp2.query = params1, _tmp2));
                                    }
                                } else {
                                    link1 = urls/* REDIRECT.client.communication.index */.R.client.communication.index;
                                    delete params1["comm_detail_id"];
                                    _this.router.push((_tmp3.pathname = link1, _tmp3.query = params1, _tmp3));
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _this.showError(args, result);
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "showError",
            value: function showError(args, result) {
                args.setConfirmationModal({
                    state: false,
                    message: "",
                    confirm_btn_action: ""
                });
                args.setFlagForRerender(Math.random() * 10000);
                this.customToastrAction.setNormalToastr(result.response.data.error, "warning");
            }
        }
    ]);
    return EmailsDetailsOptionsActions;
}();

// EXTERNAL MODULE: ../../shared/node_modules/next/router.js
var next_router = __webpack_require__(34357);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ../../shared/node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(73732);
;// CONCATENATED MODULE: ./src/components/datatableActionOptions/email-details.js





function EmailsDetailsOptions(props) {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), apiError = ref[0], setApiError = ref[1];
    var emailsDetailsOptionsActions = new EmailsDetailsOptionsActions(router, setApiError, props.setShowCandidateEmail);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "EmailsDetailsOptions Close",
        children: Object.keys(props.options).map(function(key, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "EmailsDetailsOptionsKeys",
                onClick: function(event) {
                    event.stopPropagation();
                    emailsDetailsOptionsActions.performJobAction(key, {
                        setShowCandidateEmail: props.setShowCandidateEmail,
                        setReplyTo: props.setReplyTo,
                        // id :  props.id,
                        // setCommunicationList: props.setCommunicationList,
                        setFlagForRerender: props.setFlagForRerender,
                        // setCommunicationBulkActionModal: props.setCommunicationBulkActionModal,
                        setConfirmationModal: props.setConfirmationModal,
                        setApiError: props.setApiError,
                        setForward: props.setForward,
                        data: props.data,
                        setMessageId: props.setMessageId,
                        setReferences: props.setReferences,
                        setEmailListingData: props.setEmailListingData,
                        setEmailData: props.setEmailData,
                        setEmailTo: props.setEmailTo,
                        emailTo: props.emailTo,
                        setEmailFrom: props.setEmailFrom,
                        emailFrom: props.emailFrom,
                        parentId: props.parentId,
                        t: t
                    });
                },
                children: props.options[key]["title"]
            }, "EmailsDetails_".concat(key));
        })
    });
}

// EXTERNAL MODULE: ./src/components/candidate-email.js + 1 modules
var candidate_email = __webpack_require__(63583);
// EXTERNAL MODULE: ./public/icons/document.png
var icons_document = __webpack_require__(98745);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/job.js
var job = __webpack_require__(98303);
// EXTERNAL MODULE: ./src/services/common/download-file-from-email.js
var download_file_from_email = __webpack_require__(13142);
// EXTERNAL MODULE: ./public/icons/filter.svg
var filter = __webpack_require__(97489);
// EXTERNAL MODULE: ./public/icons/arrowleft.svg
var arrowleft = __webpack_require__(65661);
;// CONCATENATED MODULE: ./public/icons/star.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 13.39-3.76 2.27.99-4.28L3.91 8.5l4.38-.37L10 4.09l1.71 4.04 4.38.37-3.32 2.88.99 4.28L10 13.39Zm10-6.15-7.19-.61L10 0 7.19 6.63 0 7.24l5.45 4.73L3.82 19 10 15.27 16.18 19l-1.64-7.03L20 7.24Z",
    fill: "var(--default-text-color)"
  })));
};

/* harmony default export */ var star = ((/* unused pure expression or super */ null && (SvgStar)));
// EXTERNAL MODULE: ./public/icons/starfilled.svg
var starfilled = __webpack_require__(71810);
;// CONCATENATED MODULE: ./public/icons/tripledots.svg
var tripledots_path;

function tripledots_extends() { tripledots_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tripledots_extends.apply(this, arguments); }



var SvgTripledots = function SvgTripledots(props) {
  return /*#__PURE__*/react.createElement("svg", tripledots_extends({
    width: 5,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), tripledots_path || (tripledots_path = /*#__PURE__*/react.createElement("path", {
    d: "M2.5 11.25a1.875 1.875 0 1 1 0 3.75 1.875 1.875 0 0 1 0-3.75Zm0-5.625a1.875 1.875 0 1 1 0 3.75 1.875 1.875 0 0 1 0-3.75ZM2.5 0a1.875 1.875 0 1 1 0 3.75A1.875 1.875 0 0 1 2.5 0Z",
    fill: "var(--default-text-color)"
  })));
};

/* harmony default export */ var tripledots = (SvgTripledots);
// EXTERNAL MODULE: ./public/icons/dots.svg
var dots = __webpack_require__(30054);
// EXTERNAL MODULE: ./src/styles/pages/clients/email-chain/_index.module.scss
var _index_module = __webpack_require__(2273);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/communication/email-details.js


// ------------------- COMPONENTS -------------------












// ------------------- COMPONENTS -------------------
// ------------------- ACTIONS -------------------


// ------------------- ACTIONS -------------------
// ------------------- SERVICE -------------------


// ------------------- SERVICE -------------------
// ------------------- IMAGES -------------------






// ------------------- IMAGES -------------------





/***/ }),

/***/ 25355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "zx": function() { return /* reexport */ components_button/* default */.Z; },
  "ZJ": function() { return /* reexport */ (button_index_module_default()); },
  "Q9": function() { return /* reexport */ communication/* COMMUNICATIONS */.Q; },
  "LD": function() { return /* reexport */ common/* ClientDashboard */.LD; },
  "x4": function() { return /* reexport */ common/* CommonAction */.x4; },
  "oq": function() { return /* reexport */ CommunicationAction; },
  "mw": function() { return /* reexport */ communication_bulk_action/* CommunicationBulkActionModal */.m; },
  "BA": function() { return /* reexport */ commuication_center/* CommunicationCenterOptions */.B; },
  "ed": function() { return /* reexport */ communication_center_options_actions/* CommunicationCenterOptionsActions */.e; },
  "hF": function() { return /* reexport */ CommunicationCenterOptionsService; },
  "Gv": function() { return /* reexport */ CommunicationFilter; },
  "OX": function() { return /* reexport */ clients_communication/* CommunicationService */.O; },
  "Xl": function() { return /* reexport */ common/* CustomCheckbox */.Xl; },
  "hh": function() { return /* reexport */ datatable/* CustomDataTable */.h; },
  "bb": function() { return /* reexport */ dots/* default */.Z; },
  "V1": function() { return /* reexport */ email_details/* EmailDetailsService */.V; },
  "dC": function() { return /* reexport */ common/* ErrorPages */.dC; },
  "wn": function() { return /* reexport */ filter_icon/* default */.Z; },
  "gb": function() { return /* reexport */ common/* Loading */.gb; },
  "Mf": function() { return /* reexport */ common/* PAGE_ANIMATION_OPTIONS */.Mf; },
  "k2": function() { return /* reexport */ (_index_module_default()); },
  "YU": function() { return /* reexport */ quick_add/* default */.Z; },
  "RQ": function() { return /* reexport */ common/* REDIRECT */.RQ; },
  "Lt": function() { return /* reexport */ common/* SendRequest */.Lt; },
  "Rh": function() { return /* reexport */ starfilled/* default */.Z; },
  "MT": function() { return /* reexport */ third_party_logo/* default */.Z; },
  "Sr": function() { return /* reexport */ common/* addParamsToUrl */.Sr; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "A$": function() { return /* reexport */ common/* clearSWRCache */.A$; },
  "EA": function() { return /* reexport */ common/* motion */.EA; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: CustomToastrAction, Image, Link, SUCCESS_REPONSE_CODE, TRANSLATION, UNAUTHORIZED_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE, UserSwitch, Yup, getSession, handleOtherResponseCode, mutate, toastr

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/constants/pages/clients/communication/index.js
var communication = __webpack_require__(63421);
// EXTERNAL MODULE: ./src/components/customDatatable/datatable.js + 1 modules
var datatable = __webpack_require__(54489);
// EXTERNAL MODULE: ./src/components/quick-add.js
var quick_add = __webpack_require__(35294);
// EXTERNAL MODULE: ./src/components/third-party-logo.js + 2 modules
var third_party_logo = __webpack_require__(50261);
// EXTERNAL MODULE: ./public/icons/dots.svg
var dots = __webpack_require__(30054);
// EXTERNAL MODULE: ./src/components/datatableActionOptions/commuication-center.js
var commuication_center = __webpack_require__(60765);
// EXTERNAL MODULE: ./src/components/bulk-action-modal/communication-bulk-action.js + 1 modules
var communication_bulk_action = __webpack_require__(42927);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/imports-files/components/model/communication-filter.js + 4 modules
var communication_filter = __webpack_require__(18020);
// EXTERNAL MODULE: ./src/components/common-modal/modal.js + 2 modules
var modal = __webpack_require__(99005);
// EXTERNAL MODULE: ./src/imports-files/components/review-email.js + 1 modules
var review_email = __webpack_require__(3623);
;// CONCATENATED MODULE: ./src/components/modals/communication-filter.js





function CommunicationFilter(props) {
    var t = (0,communication_filter/* useTranslation */.$G)().t;
    (0,communication_filter/* clearSWRCache */.A$)("communication_filter_data");
    var router = (0,communication_filter/* useRouter */.tv)();
    var formRef = (0,communication_filter/* useRef */.sO)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,communication_filter/* useState */.eJ)(true), 2), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,communication_filter/* useState */.eJ)(), 2), initialValues = ref1[0], setInitialValues = ref1[1];
    var communicationAction = new communication_filter/* CommunicationFilterAction */.HR(router, props.setCommunicationFilter, props.communicationFilter, props.setFlagForRerender, props.setCommunicationList, formRef);
    var ref2 = (0,communication_filter/* useSWR */.dH)("communication_filter_data", function() {
        return communicationAction.getDropdownOptions();
    }), data = ref2.data, error = ref2.error;
    (0,communication_filter/* useEffect */.d4)(function() {
        if (data) {
            setInitialValues(communicationAction.isFilterApplied() ? router.query : communication_filter/* CONSTANT.initialValue */.s.initialValue);
            setIsLoading(false);
        }
    }, [
        data
    ]);
    if (isLoading) {
        return "";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        type: "form",
        heading: t("modal:filter:heading"),
        closeModal: function(event) {
            communicationAction.closeModal();
        },
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(communication_filter/* Formik */.J9, {
            initialValues: initialValues,
            innerRef: formRef,
            onSubmit: function(values) {
                communicationAction.submitForm(values);
            },
            children: function(formik) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(communication_filter/* Form */.l0, {
                    className: communication_filter/* ComponentStyle.Form */.c2.Form,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat(communication_filter/* PageStyle.Form__TableCol */.k2.Form__TableCol),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading, " ").concat(communication_filter/* PageStyle.Form__FloatingLabel */.k2.Form__FloatingLabel),
                                    children: t("modal:filter:comms:job_titles")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(communication_filter/* FormikControl */.gt, {
                                    className: "".concat(communication_filter/* ComponentStyle.Form__CustomSelect */.c2.Form__CustomSelect, " ").concat(communication_filter/* PageStyle.Form__CustomSelect */.k2.Form__CustomSelect, " mmt0"),
                                    control: "select",
                                    type: "text",
                                    placeholder: t("placeholder:select:job_title"),
                                    name: "job_title",
                                    default: formik.values.job_title,
                                    onChange: function(value) {
                                        communicationAction.handleDropdownChange("job_title", value);
                                    },
                                    options: data.job_options
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat(communication_filter/* PageStyle.Form__TableCol */.k2.Form__TableCol),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading, " ").concat(communication_filter/* PageStyle.Form__FloatingLabel */.k2.Form__FloatingLabel),
                                    children: t("modal:filter:comms:candidate_name")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(communication_filter/* FormikControl */.gt, {
                                    className: "".concat(communication_filter/* ComponentStyle.Form__CustomSelect */.c2.Form__CustomSelect, " ").concat(communication_filter/* PageStyle.Form__CustomSelect */.k2.Form__CustomSelect, " mmt0"),
                                    control: "select",
                                    type: "text",
                                    placeholder: t("placeholder:select:job_candidate"),
                                    name: "candidate_name",
                                    default: communicationAction.setDefaultValueDropdown(data.candidate_options, formik.values.candidate_name),
                                    options: data.candidate_options,
                                    onChange: function(value) {
                                        communicationAction.handleDropdownChange("candidate_name", value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " ".concat(communication_filter/* ComponentStyle.Form__TableRowBlock */.c2.Form__TableRowBlock, " mb16"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: communication_filter/* ComponentStyle.Form__TableCol2 */.c2.Form__TableCol2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat(communication_filter/* ComponentStyle.Form__LabelCheck */.c2.Form__LabelCheck, " Dpflex16 Mui__CustomCheckbox"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(communication_filter/* Checkbox */.XZ, {
                                            defaultChecked: formik.values.non_interview,
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(communication_filter/* DefaultCheckbox */.v0, {}),
                                            checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(communication_filter/* CheckedCheckbox */.bN, {}),
                                            name: "non_interview",
                                            onChange: function(event) {
                                                communicationAction.handleCheckboxChange("non_interview", event);
                                            }
                                        }),
                                        " ",
                                        t("modal:filter:comms:non_interview_emails")
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " ".concat(communication_filter/* ComponentStyle.Form__TableRowBlock */.c2.Form__TableRowBlock, " mt0"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: communication_filter/* ComponentStyle.Form__TableCol2 */.c2.Form__TableCol2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat(communication_filter/* ComponentStyle.Form__LabelCheck */.c2.Form__LabelCheck, " Dpflex16 Mui__CustomCheckbox"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(communication_filter/* Checkbox */.XZ, {
                                            defaultChecked: formik.values.important,
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(communication_filter/* DefaultCheckbox */.v0, {}),
                                            checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(communication_filter/* CheckedCheckbox */.bN, {}),
                                            name: "important",
                                            onChange: function(event) {
                                                communicationAction.handleCheckboxChange("important", event);
                                            }
                                        }),
                                        " ",
                                        t("modal:filter:comms:important_emails")
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "height113"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: review_email/* FormModalStyle.Modal__Container__ButtonSection */.w2.Modal__Container__ButtonSection,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(communication_filter/* Button */.zx, {
                                    buttonstyle: communication_filter/* ComponentStyle.secondarybtn */.c2.secondarybtn,
                                    onClick: function() {
                                        communicationAction.resetForm();
                                    },
                                    children: t("button:reset")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(communication_filter/* Button */.zx, {
                                    buttonstyle: communication_filter/* ComponentStyle.primarybtn */.c2.primarybtn,
                                    type: "submit",
                                    children: t("button:apply")
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
}

// EXTERNAL MODULE: ./src/components/user-switch.js + 5 modules
var user_switch = __webpack_require__(28418);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
;// CONCATENATED MODULE: ./src/actions/pages/clients/communication/index.js






var CommunicationAction = /*#__PURE__*/ function() {
    "use strict";
    function CommunicationAction(setCommunicationList, setFlagForRerender, setCommunicationBulkActionModal, setConfirmationModal, setApiError, setFiltersValue, router, setCommunicationFilter, setShowLoader) {
        (0,_class_call_check/* default */.Z)(this, CommunicationAction);
        this.communicationService = new clients_communication/* CommunicationService */.O();
        this.setCommunicationList = setCommunicationList;
        this.setFlagForRerender = setFlagForRerender;
        this.setCommunicationBulkActionModal = setCommunicationBulkActionModal;
        this.setConfirmationModal = setConfirmationModal;
        this.setApiError = setApiError;
        this.CommunicationCenterOptionsActions = new communication_center_options_actions/* CommunicationCenterOptionsActions */.e(router);
        this.setFiltersValue = setFiltersValue;
        this.router = router;
        this.setCommunicationFilter = setCommunicationFilter;
        this.setShowLoader = setShowLoader;
    }
    (0,_create_class/* default */.Z)(CommunicationAction, [
        {
            key: "getColumnsName",
            value: function getColumnsName(t, router) {
                var _this = this;
                return [
                    {
                        name: "",
                        selector: function(row) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(starfilled/* default */.Z, {
                                    className: row.important ? "ImportantEmail" : "NotImportantEmail",
                                    onClick: function(event) {
                                        _this.CommunicationCenterOptionsActions.toggle(event, row, "index_page");
                                    }
                                })
                            });
                        },
                        sortable: false
                    },
                    {
                        name: this.router.query.email_type == "sent" ? t("datatable:to") : t("datatable:from"),
                        selector: function(row) {
                            var _this1 = _this;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: _this.router.query.email_type == "sent" ? "Read DPBlock" : row.read ? "Read DPBlock" : "Unread DPBlock",
                                onClick: function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                                        var _tmp;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _tmp = {};
                                                    return [
                                                        4,
                                                        _this1.CommunicationCenterOptionsActions.markAsRead((_tmp.options = (0,communication/* COMMUNICATIONS */.Q)(t).action_options, _tmp.performAction = _this1.performAction, _tmp.id = row.id, _tmp.setCommunicationList = _this1.setCommunicationList, _tmp.setFlagForRerender = _this1.setFlagForRerender, _tmp.setCommunicationBulkActionModal = _this1.setCommunicationBulkActionModal, _tmp.setConfirmationModal = _this1.setConfirmationModal, _tmp.setApiError = _this1.setApiError, _tmp.closeAllJobsOptions = _this1.closeAllJobsOptions(), _tmp.row = row, _tmp.redirect = true, _tmp))
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(event) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(),
                                children: row.sender
                            });
                        },
                        sortable: false
                    },
                    {
                        name: t("datatable:description"),
                        selector: function(row) {
                            var _this1 = _this;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: _this.router.query.email_type == "sent" ? "Read DPBlock" : row.read ? "Read DPBlock" : "Unread DPBlock",
                                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                    var _tmp;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _tmp = {};
                                                return [
                                                    4,
                                                    _this1.CommunicationCenterOptionsActions.markAsRead((_tmp.options = (0,communication/* COMMUNICATIONS */.Q)(t).action_options, _tmp.performAction = _this1.performAction, _tmp.id = row.id, _tmp.setCommunicationList = _this1.setCommunicationList, _tmp.setFlagForRerender = _this1.setFlagForRerender, _tmp.setCommunicationBulkActionModal = _this1.setCommunicationBulkActionModal, _tmp.setConfirmationModal = _this1.setConfirmationModal, _tmp.setApiError = _this1.setApiError, _tmp.closeAllJobsOptions = _this1.closeAllJobsOptions(), _tmp.row = row, _tmp.redirect = true, _tmp))
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                children: row.description
                            });
                        },
                        sortable: false
                    },
                    {
                        name: t("datatable:when"),
                        selector: function(row) {
                            var _this1 = _this;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: _this.router.query.email_type == "sent" ? "Read DPBlock" : row.read ? "Read" : "Unread DPBlock",
                                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                    var _tmp;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _tmp = {};
                                                return [
                                                    4,
                                                    _this1.CommunicationCenterOptionsActions.markAsRead((_tmp.options = (0,communication/* COMMUNICATIONS */.Q)(t).action_options, _tmp.performAction = _this1.performAction, _tmp.id = row.id, _tmp.setCommunicationList = _this1.setCommunicationList, _tmp.setFlagForRerender = _this1.setFlagForRerender, _tmp.setCommunicationBulkActionModal = _this1.setCommunicationBulkActionModal, _tmp.setConfirmationModal = _this1.setConfirmationModal, _tmp.setApiError = _this1.setApiError, _tmp.closeAllJobsOptions = _this1.closeAllJobsOptions(), _tmp.row = row, _tmp.redirect = true, _tmp))
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                children: row.when
                            });
                        },
                        sortable: false
                    },
                    {
                        name: "",
                        selector: function(row) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "DotsOptions",
                                onClick: function(event) {
                                    return _this.openJobOptions(event);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dots/* default */.Z, {
                                        className: "Dots Close"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(commuication_center/* CommunicationCenterOptions */.B, {
                                        options: (0,communication/* COMMUNICATIONS */.Q)(t).action_options,
                                        performAction: _this.performAction,
                                        id: row.id,
                                        setCommunicationList: _this.setCommunicationList,
                                        setFlagForRerender: _this.setFlagForRerender,
                                        setCommunicationBulkActionModal: _this.setCommunicationBulkActionModal,
                                        setConfirmationModal: _this.setConfirmationModal,
                                        setApiError: _this.setApiError,
                                        closeAllJobsOptions: _this.closeAllJobsOptions(),
                                        row: row
                                    })
                                ]
                            });
                        }
                    }
                ];
            }
        },
        {
            key: "getCommunicationData",
            value: function getCommunicationData(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, urlParams, type;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.setShowLoader(true);
                                result = "";
                                urlParams = new URLSearchParams(window.location.search);
                                type = urlParams.get("email_type");
                                params.email_type = type;
                                return [
                                    4,
                                    _this.communicationService.getCommunicationData(params)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.response);
                                _this.setShowLoader(false);
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "openJobOptions",
            value: function openJobOptions(event) {
                event.stopPropagation();
                var dots_element = event.currentTarget.querySelector(".Dots");
                var element = event.currentTarget.querySelector(".CommunicationsOptions");
                if (dots_element.classList.contains("Close")) {
                    this.closeAllJobsOptions();
                    element.classList.remove("Close");
                    element.classList.add("Open");
                    dots_element.classList.remove("Close");
                    dots_element.classList.add("Open");
                } else {
                    this.closeAllJobsOptions();
                    element.classList.remove("Open");
                    element.classList.add("Close");
                    dots_element.classList.remove("Open");
                    dots_element.classList.add("Close");
                }
            }
        },
        {
            key: "closeAllJobsOptions",
            value: function closeAllJobsOptions() {
                var element = document.querySelector(".CommunicationsOptions.Open");
                var dots_element = document.querySelector(".Dots.Open");
                if (element) {
                    element.classList.remove("Open");
                    element.classList.add("Close");
                    dots_element.classList.remove("Open");
                    dots_element.classList.add("Close");
                }
            }
        },
        {
            key: "handlePerRowsSorting",
            value: function handlePerRowsSorting(router, column, sortDirection, setCommunicationList, setFiltersValue, setApiError) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var previous_job_filter, result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                previous_job_filter = router.query;
                                previous_job_filter.col_name = column.sortField;
                                previous_job_filter.order = sortDirection;
                                (0,common/* addParamsToUrl */.Sr)(previous_job_filter, router);
                                setFiltersValue(previous_job_filter);
                                return [
                                    4,
                                    _this.getCommunicationData(previous_job_filter)
                                ];
                            case 1:
                                result = _state.sent();
                                setCommunicationList(result.data);
                                _this.setFlagForRerender(Math.random() * 10000);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handlePerRowsChange",
            value: function handlePerRowsChange(router, per_page, setCommunicationList, setFiltersValue, setApiError) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var previous_job_filter, result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                previous_job_filter = router.query;
                                previous_job_filter.per_page = per_page;
                                (0,common/* addParamsToUrl */.Sr)(previous_job_filter, router);
                                setFiltersValue(previous_job_filter);
                                return [
                                    4,
                                    _this.getCommunicationData(previous_job_filter)
                                ];
                            case 1:
                                result = _state.sent();
                                setCommunicationList(result.data);
                                _this.setFlagForRerender(Math.random() * 10000);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handlePageChange",
            value: function handlePageChange(router, page, setCommunicationList, setFiltersValue, setApiError) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var previous_job_filter, result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                previous_job_filter = router.query;
                                previous_job_filter.page = page;
                                (0,common/* addParamsToUrl */.Sr)(previous_job_filter, router);
                                setFiltersValue(previous_job_filter);
                                return [
                                    4,
                                    _this.getCommunicationData(previous_job_filter)
                                ];
                            case 1:
                                result = _state.sent();
                                setApiError(result.request);
                                setCommunicationList(result.data);
                                _this.setFlagForRerender(Math.random() * 10000);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onSelectingRows",
            value: function onSelectingRows(selected_rows, setCommunicationBulkActionModal, setSelectedComms) {
                if (selected_rows.selectedCount > 0) {
                    setCommunicationBulkActionModal(true);
                    setSelectedComms(selected_rows);
                } else {
                    setCommunicationBulkActionModal(false);
                    setSelectedComms(selected_rows);
                }
            }
        },
        {
            key: "changeSearchFilterData",
            value: function changeSearchFilterData(event) {
                var _this = this;
                setTimeout(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    var param_list, result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                param_list = _this.router.query;
                                param_list.search_text = event.target.value;
                                param_list.search_text == "" ? delete param_list.search_text : "";
                                (0,common/* addParamsToUrl */.Sr)(param_list, _this.router);
                                return [
                                    4,
                                    _this.getCommunicationData(param_list)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                _this.setCommunicationList(result.data);
                                _this.setFiltersValue(param_list);
                                return [
                                    2
                                ];
                        }
                    });
                }), 500);
            }
        },
        {
            key: "handleCommunicationFilterClick",
            value: function handleCommunicationFilterClick(event) {
                this.setCommunicationFilter({
                    state: true,
                    message: "",
                    confirm_btn_action: null
                });
                this.setFlagForRerender(Math.random() * 10000);
            }
        },
        {
            key: "isFilterApplied",
            value: function isFilterApplied() {
                var previous_job_filter = this.router.query;
                return (previous_job_filter === null || previous_job_filter === void 0 ? void 0 : previous_job_filter.job_title) || (previous_job_filter === null || previous_job_filter === void 0 ? void 0 : previous_job_filter.candidate_name) || (previous_job_filter === null || previous_job_filter === void 0 ? void 0 : previous_job_filter.important) || previous_job_filter.non_interview;
            }
        },
        {
            key: "deselectAllCandidates",
            value: function deselectAllCandidates() {
                var all_checkbox = document.querySelector("[name = select-all-rows]");
                if (all_checkbox) {
                    if (all_checkbox === null || all_checkbox === void 0 ? void 0 : all_checkbox.checked) {
                        all_checkbox.click();
                    } else {
                        all_checkbox.click();
                        all_checkbox.click();
                    }
                }
            }
        }
    ]);
    return CommunicationAction;
}();

// EXTERNAL MODULE: ./src/actions/components/datatableActionOptions/communication-center-options-actions.js
var communication_center_options_actions = __webpack_require__(55384);
// EXTERNAL MODULE: ./src/services/pages/clients/communication/index.js + 1 modules
var clients_communication = __webpack_require__(51348);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ./src/imports-files/pages/admins/logout.js + 1 modules
var logout = __webpack_require__(63281);
;// CONCATENATED MODULE: ./src/services/components/dataActionOptions/communication-center-options-service.js








var CommunicationCenterOptionsService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(CommunicationCenterOptionsService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(CommunicationCenterOptionsService);
    function CommunicationCenterOptionsService() {
        (0,_class_call_check/* default */.Z)(this, CommunicationCenterOptionsService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CommunicationCenterOptionsService, [
        {
            key: "markAsRead",
            value: function markAsRead(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.communication.MARK_READ */.bl.client.communication.MARK_READ;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.put */.od.put(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "dismiss",
            value: function dismiss(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.communication.DISMISS */.bl.client.communication.DISMISS;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.put */.od.put(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CommunicationCenterOptionsService;
}(logout/* SendRequest */.Lt);

// EXTERNAL MODULE: ./src/services/pages/clients/communication/email-details.js
var email_details = __webpack_require__(72389);
// EXTERNAL MODULE: ./public/icons/starfilled.svg
var starfilled = __webpack_require__(71810);
// EXTERNAL MODULE: ./src/styles/pages/clients/templates/_index.module.scss
var _index_module = __webpack_require__(54552);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
// EXTERNAL MODULE: ./src/styles/components/button/_index.module.scss
var button_index_module = __webpack_require__(84215);
var button_index_module_default = /*#__PURE__*/__webpack_require__.n(button_index_module);
// EXTERNAL MODULE: ./public/new-icons/filter-icon.svg
var filter_icon = __webpack_require__(4025);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/communication/index.js


// ------------------- COMPONENTS -------------------








// ------------------- COMPONENTS -------------------
// ------------------- ACTIONS -------------------


// ------------------- ACTIONS -------------------
// ------------------- SERVICE -------------------



// ------------------- SERVICE -------------------







/***/ }),

/***/ 43862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G9": function() { return /* reexport */ ADD_MEMBERS; },
  "bI": function() { return /* reexport */ AddMembersAction; },
  "uS": function() { return /* reexport */ AddMembersService; },
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "ZJ": function() { return /* reexport */ common/* ButtonStyle */.ZJ; },
  "QM": function() { return /* reexport */ common/* CSVReader */.QM; },
  "LD": function() { return /* reexport */ common/* ClientDashboard */.LD; },
  "Tw": function() { return /* reexport */ icons_close/* default */.Z; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "dC": function() { return /* reexport */ render_error_loading/* ErrorPages */.d; },
  "F2": function() { return /* reexport */ common/* FieldArray */.F2; },
  "l0": function() { return /* reexport */ common/* Form */.l0; },
  "x": function() { return /* reexport */ common/* FormStyle */.x; },
  "J9": function() { return /* reexport */ common/* Formik */.J9; },
  "gt": function() { return /* reexport */ common/* FormikControl */.gt; },
  "pd": function() { return /* reexport */ common/* InputError */.pd; },
  "oH": function() { return /* reexport */ common/* InputText */.oH; },
  "gb": function() { return /* reexport */ common/* Loading */.gb; },
  "Mf": function() { return /* reexport */ common/* PAGE_ANIMATION_OPTIONS */.Mf; },
  "k2": function() { return /* reexport */ (_index_module_default()); },
  "RQ": function() { return /* reexport */ common/* REDIRECT */.RQ; },
  "Us": function() { return /* reexport */ common/* SUCCESS_REPONSE_CODE */.Us; },
  "TA": function() { return /* reexport */ common/* TRANSLATION */.TA; },
  "Mn": function() { return /* reexport */ common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn; },
  "sm": function() { return /* reexport */ common/* Yup */.sm; },
  "GB": function() { return /* reexport */ common/* handleOtherResponseCode */.GB; },
  "EA": function() { return /* reexport */ common/* motion */.EA; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "NL": function() { return /* reexport */ common/* useQueryClient */.NL; },
  "sO": function() { return /* reexport */ common/* useRef */.sO; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: Checkbox, clearSWRCache, getSession, toastr, useSWR

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ./src/services/pages/clients/my-team-service.js
var my_team_service = __webpack_require__(16424);
;// CONCATENATED MODULE: ./src/actions/pages/clients/company/add-members.js






var AddMembersAction = /*#__PURE__*/ function() {
    "use strict";
    function AddMembersAction(setLoader) {
        (0,_class_call_check/* default */.Z)(this, AddMembersAction);
        this.AddMembersService = new AddMembersService();
        this.MyTeamService = new my_team_service/* MyTeamService */.Q();
        this.setLoader = setLoader;
        this.customToastrAction = new common/* CustomToastrAction */.Y5();
    }
    (0,_create_class/* default */.Z)(AddMembersAction, [
        {
            key: "addTeamMembers",
            value: function addTeamMembers(params, router) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var body, _tmp, result, status_code, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.setLoader(true);
                                _tmp = {};
                                body = (_tmp.client = {
                                    id: params.client.id,
                                    client_users_attributes: params.client.client_users_attributes
                                }, _tmp);
                                return [
                                    4,
                                    _this.AddMembersService.addMembers(body)
                                ];
                            case 1:
                                result = _state.sent();
                                status_code = result.status || result.response.status;
                                switch(status_code){
                                    case common/* SUCCESS_REPONSE_CODE */.Us:
                                        _this.setLoader(false);
                                        _this.customToastrAction.setNormalToastr(result.data.success, "success");
                                        // toastr.success(result.data.success)
                                        router.push(common/* REDIRECT.client.company.add_team */.RQ.client.company.add_team);
                                        break;
                                    case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                                        _this.setLoader(false);
                                        error = result.response.data.error.client.base;
                                        //this.customToastrAction.setNormalToastr(error, 'warning');
                                        // toastr.warning(error);
                                        return [
                                            2,
                                            result.response.data.error
                                        ];
                                        break;
                                    default:
                                        _this.setLoader(false);
                                        (0,common/* handleOtherResponseCode */.GB)(status_code, args.router);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onAdminUserRemove",
            value: function onAdminUserRemove() {
                for(var _len = arguments.length, args1 = new Array(_len), _key = 0; _key < _len; _key++){
                    args1[_key] = arguments[_key];
                }
                return (0,_async_to_generator/* default */.Z)(function() {
                    var formik, action, setAdminCount, index, queryClient, client_users_attributes, client, _tmp, records_length;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                formik = args1[0];
                                action = args1[1];
                                setAdminCount = args1[2];
                                index = args1[3] != undefined ? args1[3] : "";
                                queryClient = args1[4];
                                client_users_attributes = formik.values.client.client_users_attributes;
                                client = formik.values.client;
                                // ---------------------------- Initialization ------------------------------
                                client_users_attributes[index]["_destroy"] = true;
                                _tmp = {};
                                // formik.current.setValues({client, client_users_attributes});
                                formik.setValues((_tmp.client = client, _tmp.client_users_attributes = client_users_attributes, _tmp));
                                records_length = client_users_attributes.map(function(element) {
                                    return element._destroy == false;
                                }).filter(function(element) {
                                    return element == true;
                                }).length;
                                return [
                                    4,
                                    queryClient.setQueryData("add-user-data", client_users_attributes)
                                ];
                            case 1:
                                _state.sent();
                                setAdminCount(records_length);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onAdminUserAdd",
            value: function onAdminUserAdd() {
                for(var _len = arguments.length, args1 = new Array(_len), _key = 0; _key < _len; _key++){
                    args1[_key] = arguments[_key];
                }
                return (0,_async_to_generator/* default */.Z)(function() {
                    var ref, formik, action, setAdminCount, queryClient, client_users_attributes, client, _tmp, _tmp1, records_length;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                formik = (ref = args1[0]) === null || ref === void 0 ? void 0 : ref.current;
                                action = args1[1];
                                setAdminCount = args1[2];
                                queryClient = args1[3];
                                client_users_attributes = formik.values.client.client_users_attributes;
                                client = formik.values.client;
                                _tmp = {};
                                // ---------------------------- Initialization ------------------------------
                                client_users_attributes.push((_tmp.role_id = "", _tmp.status_id = "", _tmp._destroy = false, _tmp.user_attributes = {
                                    name: "",
                                    email: ""
                                }, _tmp));
                                _tmp1 = {};
                                // formik.current.setValues({client, client_users_attributes});
                                formik.setValues((_tmp1.client = client, _tmp1.client_users_attributes = client_users_attributes, _tmp1));
                                records_length = client_users_attributes.map(function(element) {
                                    return element._destroy == false;
                                }).filter(function(element) {
                                    return element == true;
                                }).length;
                                return [
                                    4,
                                    queryClient.setQueryData("add-user-data", client_users_attributes)
                                ];
                            case 1:
                                _state.sent();
                                setAdminCount(records_length);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handelFileChange",
            value: function handelFileChange(data, formik, userRoles, fileInfo) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var fileSize, csvValid, client_users_attributes, client, _tmp, _tmp1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        _this.setLoader(true);
                        fileSize = _this.fileSizeValid(fileInfo);
                        csvValid = _this.isCSVFileValid(data, userRoles);
                        _tmp = {};
                        _tmp1 = {};
                        if (!(fileSize && csvValid)) {
                            _this.setLoader(false);
                            return [
                                2,
                                false
                            ];
                        } else {
                            client_users_attributes = formik.current.values.client.client_users_attributes;
                            client = formik.current.values.client;
                            // ---------------------------- Initialization ------------------------------
                            data.length > 0 ? _this.remove_blank_formik_fields(formik, client, client_users_attributes) : "";
                            data.map(function(user) {
                                var role_id = userRoles.findIndex(function(obj) {
                                    return obj.label === user.role;
                                });
                                client_users_attributes.push({
                                    role_id: userRoles[role_id].value,
                                    _destroy: false,
                                    user_attributes: {
                                        name: user.name,
                                        email: user.email
                                    }
                                });
                                return user;
                            });
                            document.getElementById("react-csv-reader-input").value = null;
                            formik.current.setValues((_tmp.client = {
                                client_users_attributes: client_users_attributes
                            }, _tmp));
                            formik.current.setTouched((_tmp1.client = {
                                client_users_attributes: client_users_attributes
                            }, _tmp1));
                            _this.setLoader(false);
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "fileSizeValid",
            value: function fileSizeValid(fileInfo) {
                if (fileInfo.size > ADD_MEMBERS.CSV_FILE_SIZE_LIMIT) {
                    this.customToastrAction.setNormalToastr("The file size is greater than 1MB", "success");
                    // toastr.success('The file size is greater than 1MB');
                    document.getElementById("react-csv-reader-input").value = null;
                    return false;
                } else {
                    return true;
                }
            }
        },
        {
            key: "isCSVFileValid",
            value: function isCSVFileValid(data, userRoles) {
                try {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var user = _step.value;
                            var role_id = userRoles.findIndex(function(obj) {
                                return obj.label === user.role;
                            });
                            userRoles[role_id].value;
                            user.name;
                            user.email;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return true;
                } catch (exception) {
                    this.customToastrAction.setNormalToastr("Invalid File", "success");
                    // toastr.success('Invalid File');
                    document.getElementById("react-csv-reader-input").value = null;
                    return false;
                }
            }
        },
        {
            key: "remove_blank_formik_fields",
            value: function remove_blank_formik_fields(formik, client, client_users_attributes) {
                for(var index = client_users_attributes.length - 1; index >= 0; index--){
                    if (client_users_attributes[index].role_id == "" && client_users_attributes[index].user_attributes.name == "" && client_users_attributes[index].user_attributes.email == "") {
                        client_users_attributes.splice(index, 1);
                    } else {
                        break;
                    }
                }
                formik.current.setValues({
                    client: client,
                    client_users_attributes: client_users_attributes
                });
            }
        }
    ]);
    return AddMembersAction;
}();

// EXTERNAL MODULE: ./src/actions/common/render_error_loading.js
var render_error_loading = __webpack_require__(10758);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ./src/services/common/send-request.js
var send_request = __webpack_require__(34964);
// EXTERNAL MODULE: ./src/services/pages/clients/company/add-team.js
var add_team = __webpack_require__(28936);
;// CONCATENATED MODULE: ./src/services/pages/clients/company/add-members.js









var AddMembersService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(AddMembersService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(AddMembersService);
    function AddMembersService() {
        (0,_class_call_check/* default */.Z)(this, AddMembersService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(AddMembersService, [
        {
            key: "userListData",
            value: function userListData(slug, params) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    new add_team/* AddTeamService */.g().getUserListData(slug, params)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTeamDetails",
            value: function getTeamDetails(params, hostName) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, header, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.company.GET_MY_TEAM */.bl.client.company.GET_MY_TEAM;
                                header = _this.serverSideHeaderJSON(hostName);
                                header["cookie"] = "Authorization=".concat(params.token);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(url, (_tmp.params = params, _tmp.headers = header, _tmp), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addMembers",
            value: function addMembers(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.company.ADD_CLIENTS */.bl.client.company.ADD_CLIENTS;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AddMembersService;
}(send_request/* SendRequest */.L);

;// CONCATENATED MODULE: ./src/constants/pages/clients/company/add-members.js

var ADD_MEMBERS = {
    CSV_FILE_SIZE_LIMIT: 1000000,
    texts: {
        heading: "Add Team Member",
        subheading_1: "Individuals that’ll be using Heartpace. For speed, you can",
        subheading_2: "download CSV template",
        subheading_3: "and import a list of users. You can also add more later.",
        add_user_button: "Add User",
        import_user: "Bulk Import User",
        submit_button: "Submit",
        cancel_button: "Cancel"
    },
    INITIAL_VALUES: {
        client: {
            client_users_attributes: [
                {
                    role_id: "",
                    user_attributes: {
                        email: "",
                        name: ""
                    }
                }
            ]
        }
    },
    DEFAULT_VALUE: {
        client: {
            client_users_attributes: [
                {
                    role_id: "",
                    user_attributes: {
                        email: "",
                        name: ""
                    }
                }
            ]
        }
    },
    VALIDATION_SCHEMA: common/* Yup.object */.sm.object().shape({
        client: common/* Yup.object */.sm.object().shape({
            client_users_attributes: common/* Yup.array */.sm.array().of(common/* Yup.object */.sm.object({
                _destroy: common/* Yup.boolean */.sm.boolean(),
                role_id: common/* Yup.string */.sm.string().when("_destroy", {
                    is: function(_destroy) {
                        return !_destroy;
                    },
                    then: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required"))
                }),
                user_attributes: common/* Yup.object */.sm.object().when("_destroy", {
                    is: function(_destroy) {
                        return !_destroy;
                    },
                    then: common/* Yup.object */.sm.object({
                        email: common/* Yup.string */.sm.string().email((0,common/* TRANSLATION */.TA)("errors:invalid_email")).required((0,common/* TRANSLATION */.TA)("errors:required")),
                        name: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable()
                    })
                })
            }))
        })
    })
};

// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(85155);
// EXTERNAL MODULE: ./src/styles/components/progressline/_index.module.scss
var _index_module = __webpack_require__(39923);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/company/add-members.js
// --------------- COMMON --------------

// --------------- COMMON --------------
// --------------- ACTIONS --------------

// --------------- ACTIONS --------------
// --------------- COMPONENTS --------------

// --------------- COMPONENTS --------------
// --------------- SERVICE --------------

// --------------- SERVICE --------------
// --------------- CONSTANT --------------

// --------------- CONSTANT --------------
// --------------- ICONS --------------

// --------------- ICONS --------------
// --------------- STYLESHEET --------------
 // --------------- STYLESHEET --------------


/***/ }),

/***/ 33908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G9": function() { return /* reexport */ ADD_MEMBERS; },
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "ZJ": function() { return /* reexport */ common/* ButtonStyle */.ZJ; },
  "LD": function() { return /* reexport */ common/* ClientDashboard */.LD; },
  "Tw": function() { return /* reexport */ icons_close/* default */.Z; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "dC": function() { return /* reexport */ render_error_loading/* ErrorPages */.d; },
  "F2": function() { return /* reexport */ common/* FieldArray */.F2; },
  "l0": function() { return /* reexport */ common/* Form */.l0; },
  "x": function() { return /* reexport */ common/* FormStyle */.x; },
  "J9": function() { return /* reexport */ common/* Formik */.J9; },
  "gt": function() { return /* reexport */ common/* FormikControl */.gt; },
  "L2": function() { return /* reexport */ INVITE_AGENCY_USER_VALIDATION_SCHEMA; },
  "pd": function() { return /* reexport */ common/* InputError */.pd; },
  "Gw": function() { return /* reexport */ InviteAgencyUserService; },
  "E4": function() { return /* reexport */ InviteAgencyUsersAction; },
  "gb": function() { return /* reexport */ common/* Loading */.gb; },
  "Mf": function() { return /* reexport */ common/* PAGE_ANIMATION_OPTIONS */.Mf; },
  "k2": function() { return /* reexport */ (_index_module_default()); },
  "RQ": function() { return /* reexport */ common/* REDIRECT */.RQ; },
  "Us": function() { return /* reexport */ common/* SUCCESS_REPONSE_CODE */.Us; },
  "TA": function() { return /* reexport */ common/* TRANSLATION */.TA; },
  "Mn": function() { return /* reexport */ common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn; },
  "sm": function() { return /* reexport */ common/* Yup */.sm; },
  "y$": function() { return /* reexport */ jobs_common/* cursorNone */.y$; },
  "PR": function() { return /* reexport */ job_sharing/* getAgencyOrClientUsers */.PR; },
  "lU": function() { return /* reexport */ getUserSuggestionValue; },
  "d1": function() { return /* reexport */ handleEmailDelete; },
  "$y": function() { return /* reexport */ handleKeyDown; },
  "GB": function() { return /* reexport */ common/* handleOtherResponseCode */.GB; },
  "pS": function() { return /* reexport */ inviteUsers; },
  "EA": function() { return /* reexport */ common/* motion */.EA; },
  "ro": function() { return /* reexport */ onUserSuggestionSelection; },
  "_v": function() { return /* reexport */ onUserSuggestionsClearRequested; },
  "UA": function() { return /* reexport */ onUserSuggestionsFetchRequested; },
  "Qx": function() { return /* reexport */ renderInputComponent; },
  "LB": function() { return /* reexport */ renderUserSuggestion; },
  "KH": function() { return /* reexport */ shouldRenderSuggestions; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "NL": function() { return /* reexport */ common/* useQueryClient */.NL; },
  "sO": function() { return /* reexport */ common/* useRef */.sO; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: CSVReader, Checkbox, INVITE_AGENCY_USER_INITIAL_VALUES, checkEmailDomain, clearSWRCache, getSession, isEmail, toastr, useSWR

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(18186);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(34817);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
;// CONCATENATED MODULE: ./src/actions/pages/clients/company/invite-agency-users.js








var InviteAgencyUsersAction = /*#__PURE__*/ function() {
    "use strict";
    function InviteAgencyUsersAction(setLoader) {
        (0,_class_call_check/* default */.Z)(this, InviteAgencyUsersAction);
        this.InviteAgencyUserService = new InviteAgencyUserService();
        this.setLoader = setLoader;
        this.customToastrAction = new common/* CustomToastrAction */.Y5();
    }
    (0,_create_class/* default */.Z)(InviteAgencyUsersAction, [
        {
            key: "addTeamMembers",
            value: function addTeamMembers(params, router) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                // this.setLoader(true);
                // const body        = { agency: {id: params.agency.id, agency_users_attributes: params.agency.agency_users_attributes}} 
                // const result      = await this.InviteAgencyUserService.addMembers(body);
                // const status_code = result.status || result.response.status;
                // switch (status_code)
                // {  
                //     case SUCCESS_REPONSE_CODE:
                //     this.setLoader(false);
                //     this.customToastrAction.setNormalToastr(result.data.success, 'success');
                //     router.push(REDIRECT.agency.company.add_team);
                //     break;
                //     case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
                //     this.setLoader(false);
                //     let error = result.response.data.error.agency.base
                //     this.customToastrAction.setNormalToastr(error, 'warning');
                //     return result.response.data.error
                //     break;
                //     default: 
                //     this.setLoader(false);
                //     handleOtherResponseCode(status_code, args.router);
                // }
                })();
            }
        },
        {
            key: "onAdminUserRemove",
            value: function onAdminUserRemove() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (0,_async_to_generator/* default */.Z)(function() {
                    var formik, action, setAdminCount, index, queryClient, agency_users_attributes, agency, _tmp, records_length;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                formik = args[0];
                                action = args[1];
                                setAdminCount = args[2];
                                index = args[3] != undefined ? args[3] : "";
                                queryClient = args[4];
                                agency_users_attributes = formik.values.agency.agency_users_attributes;
                                agency = formik.values.agency;
                                // ---------------------------- Initialization ------------------------------
                                agency_users_attributes[index]["_destroy"] = true;
                                _tmp = {};
                                // formik.current.setValues({agency, agency_users_attributes});
                                formik.setValues((_tmp.agency = agency, _tmp.agency_users_attributes = agency_users_attributes, _tmp));
                                records_length = agency_users_attributes.map(function(element) {
                                    return element._destroy == false;
                                }).filter(function(element) {
                                    return element == true;
                                }).length;
                                return [
                                    4,
                                    queryClient.setQueryData("add-user-data", agency_users_attributes)
                                ];
                            case 1:
                                _state.sent();
                                setAdminCount(records_length);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onAdminUserAdd",
            value: function onAdminUserAdd() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (0,_async_to_generator/* default */.Z)(function() {
                    var ref, formik, action, setAdminCount, queryClient, agency_users_attributes, agency, _tmp, _tmp1, records_length;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                formik = (ref = args[0]) === null || ref === void 0 ? void 0 : ref.current;
                                action = args[1];
                                setAdminCount = args[2];
                                queryClient = args[3];
                                agency_users_attributes = formik.values.agency.agency_users_attributes;
                                agency = formik.values.agency;
                                _tmp = {};
                                // ---------------------------- Initialization ------------------------------
                                agency_users_attributes.push((_tmp.role_id = "", _tmp.status_id = "", _tmp._destroy = false, _tmp.user_attributes = {
                                    name: "",
                                    email: ""
                                }, _tmp));
                                _tmp1 = {};
                                // formik.current.setValues({agency, agency_users_attributes});
                                formik.setValues((_tmp1.agency = agency, _tmp1.agency_users_attributes = agency_users_attributes, _tmp1));
                                records_length = agency_users_attributes.map(function(element) {
                                    return element._destroy == false;
                                }).filter(function(element) {
                                    return element == true;
                                }).length;
                                return [
                                    4,
                                    queryClient.setQueryData("add-user-data", agency_users_attributes)
                                ];
                            case 1:
                                _state.sent();
                                setAdminCount(records_length);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handelFileChange",
            value: function handelFileChange(data, formik, userRoles, fileInfo) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var fileSize, csvValid, agency_users_attributes, agency, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, user, role_id, _tmp, _tmp1, _tmp2;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        _this.setLoader(true);
                        fileSize = _this.fileSizeValid(fileInfo);
                        csvValid = _this.isCSVFileValid(data, userRoles);
                        _tmp = {};
                        _tmp1 = {};
                        _tmp2 = {};
                        if (!(fileSize && csvValid)) {
                            _this.setLoader(false);
                            return [
                                2,
                                false
                            ];
                        } else {
                            agency_users_attributes = formik.current.values.agency.agency_users_attributes;
                            agency = formik.current.values.agency;
                            // ---------------------------- Initialization ------------------------------
                            data.length > 0 ? _this.remove_blank_formik_fields(formik, agency, agency_users_attributes) : "";
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = data[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    user = _step.value;
                                    role_id = userRoles.findIndex(function(obj) {
                                        return obj.label === user.role;
                                    });
                                    agency_users_attributes.push((_tmp.role_id = userRoles[role_id].value, _tmp._destroy = false, _tmp.user_attributes = {
                                        name: user.name,
                                        email: user.email
                                    }, _tmp));
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            document.getElementById("react-csv-reader-input").value = null;
                            formik.current.setValues((_tmp1.agency = {
                                agency_users_attributes: agency_users_attributes
                            }, _tmp1));
                            formik.current.setTouched((_tmp2.agency = {
                                agency_users_attributes: agency_users_attributes
                            }, _tmp2));
                            _this.setLoader(false);
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "fileSizeValid",
            value: function fileSizeValid(fileInfo) {
                if (fileInfo.size > ADD_MEMBERS.CSV_FILE_SIZE_LIMIT) {
                    this.customToastrAction.setNormalToastr("The file size is greater than 1MB", "success");
                    // toastr.success('The file size is greater than 1MB');
                    document.getElementById("react-csv-reader-input").value = null;
                    return false;
                } else {
                    return true;
                }
            }
        },
        {
            key: "isCSVFileValid",
            value: function isCSVFileValid(data, userRoles) {
                try {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var user = _step.value;
                            var role_id = userRoles.findIndex(function(obj) {
                                return obj.label === user.role;
                            });
                            userRoles[role_id].value;
                            user.name;
                            user.email;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return true;
                } catch (exception) {
                    this.customToastrAction.setNormalToastr("Invalid File", "success");
                    // toastr.success('Invalid File');
                    document.getElementById("react-csv-reader-input").value = null;
                    return false;
                }
            }
        },
        {
            key: "remove_blank_formik_fields",
            value: function remove_blank_formik_fields(formik, agency, agency_users_attributes) {
                for(var index = agency_users_attributes.length - 1; index >= 0; index--){
                    if (agency_users_attributes[index].role_id == "" && agency_users_attributes[index].user_attributes.name == "" && agency_users_attributes[index].user_attributes.email == "") {
                        agency_users_attributes.splice(index, 1);
                    } else {
                        break;
                    }
                }
                formik.current.setValues({
                    agency: agency,
                    agency_users_attributes: agency_users_attributes
                });
            }
        }
    ]);
    return InviteAgencyUsersAction;
}();
function shouldRenderSuggestions(value) {
    return value.trim().length >= 3;
}
var renderInputComponent = function(inputProps) {
    var ref;
    // <input className = {PageStyle.Form__Input} autoComplete="password"
    // {...inputProps} />
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "buttonIn AutoSuggestInput__Tags",
        style: inputProps.styleError,
        children: [
            (ref = inputProps.selectedValues) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt5 ".concat((_index_module_default()).Tagrow__Tags),
                    children: [
                        item.name ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: item.name
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: item.email
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: (_index_module_default()).Tagrow__Cancel,
                            onClick: function() {
                                return inputProps.handleEmailDelete(inputProps.formik, index);
                            },
                            children: inputProps.closeIcon
                        })
                    ]
                }, "agency_user_".concat(index));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                className: (_index_module_default()).Form__Input,
                autoComplete: "password"
            }, inputProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                buttonstyle: "".concat(common/* ButtonStyle.nobgbutton */.ZJ.nobgbutton, " addbtn ").concat((0,jobs_common/* cursorNone */.y$)(inputProps.editable)),
                disabled: inputProps.disabled,
                onClick: function() {
                    return onAddClick(event, inputProps);
                },
                children: (0,common/* TRANSLATION */.TA)("button:add:default")
            })
        ]
    });
};
function getUserSuggestionValue(suggestion) {
    return "".concat(suggestion.user_attributes.email);
}
function showSuggestion(suggestion) {
    if (suggestion.user_attributes.name && suggestion.user_attributes.email.length > 0) {
        return "".concat(suggestion.user_attributes.name, " | ").concat(suggestion.user_attributes.email);
    } else if (suggestion.user_attributes.name) {
        return "".concat(suggestion.user_attributes.name);
    } else {
        return "".concat(suggestion.user_attributes.email);
    }
}
function renderUserSuggestion(suggestion) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: showSuggestion(suggestion)
    });
}
function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function getUserSuggestions(value, router, domain) {
    return _getUserSuggestions.apply(this, arguments);
}
function _getUserSuggestions() {
    _getUserSuggestions = (0,_async_to_generator/* default */.Z)(function(value, router, domain) {
        var escapedValue, finalUsers;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    escapedValue = escapeRegexCharacters(value === null || value === void 0 ? void 0 : value.trim());
                    if (escapedValue === "") {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        4,
                        (0,job_sharing/* getAgencyOrClientUsers */.PR)(escapedValue, router, domain)
                    ];
                case 1:
                    finalUsers = _state.sent();
                    return [
                        2,
                        finalUsers
                    ];
            }
        });
    });
    return _getUserSuggestions.apply(this, arguments);
}
function onUserSuggestionsFetchRequested(hash, setUsers, router, domain) {
    return _onUserSuggestionsFetchRequested.apply(this, arguments);
}
function _onUserSuggestionsFetchRequested() {
    _onUserSuggestionsFetchRequested = (0,_async_to_generator/* default */.Z)(function(hash, setUsers, router, domain) {
        var users;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getUserSuggestions(hash.value, router, domain)
                    ];
                case 1:
                    users = _state.sent();
                    setUsers(users);
                    return [
                        2
                    ];
            }
        });
    });
    return _onUserSuggestionsFetchRequested.apply(this, arguments);
}
;
var onUserSuggestionsClearRequested = function(setUsers) {
    setUsers([]);
};
function isEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@\.]+$/.test(email);
}
function onUserSuggestionSelection(formik, old_emails, email, old_initials, new_initial) {
    if (isEmail(email) && !old_emails.includes(email)) {
        var ref;
        if ((ref = formik.status) === null || ref === void 0 ? void 0 : ref.agency_user_emails) {
            formik.setStatus({
                agency_user_emails: ""
            });
        }
        old_emails.unshift(email);
        old_initials.unshift(new_initial);
        formik.validateForm();
    }
}
function handleKeyDown(evt, formik, setAgencyUserEmail, setAgencyUserError, agency_domain, t) {
    if ([
        "Enter"
    ].includes(evt.key)) {
        evt.preventDefault();
        var email = evt.target.value;
        if (isEmail(email)) {
            // if(checkEmailDomain(email, agency_domain)){
            onUserSuggestionSelection(formik, formik.values.agency_user_emails, email, formik.values.agency_user_initials, {
                email: email,
                name_initials: null,
                name: null
            });
            setAgencyUserEmail("");
        // }
        // else
        // {
        //   formik.setStatus({agency_user_emails: 'User domain should match with agency domain'})
        //   formik.touched['agency_user_emails'] = true;
        // }
        } else {
            formik.setStatus({
                agency_user_emails: ""
            });
            setAgencyUserError(t("errors:autocomplete_invalid_email"));
        }
    }
    ;
}
var onAddClick = function(event1, params) {
    var email = params.value.trim();
    if (isEmail(email)) {
        // if(checkEmailDomain(email, params.agency_domain)){
        onUserSuggestionSelection(params.formik, params.formik.values.agency_user_emails, email, params.formik.values.agency_user_initials, {
            email: email,
            name_initials: null,
            name: null
        });
        params.setAgencyUserEmail("");
    // }
    // else{
    //   params.formik.setStatus({agency_user_emails: 'User domain should match with agency domain'})
    //   params.formik.touched['agency_user_emails'] = true;
    // }
    } else {
        params.formik.setStatus({
            agency_user_emails: ""
        });
        params.setAgencyUserError(params.t("errors:autocomplete_invalid_email"));
    }
};
function checkEmailDomain(email, agency_domain) {
    var user_email_domain = email === null || email === void 0 ? void 0 : email.split("@")[1];
    var user_domain = user_email_domain === null || user_email_domain === void 0 ? void 0 : user_email_domain.split(".")[0];
    return user_domain == agency_domain;
}
function handleEmailDelete(formik, itemIndex) {
    var emails = formik.values.agency_user_emails;
    var name_initials = formik.values.agency_user_initials;
    emails.splice(itemIndex, 1);
    name_initials.splice(itemIndex, 1);
    formik.setFieldValue("agency_user_emails", (0,_to_consumable_array/* default */.Z)(emails));
    formik.setFieldValue("agency_user_initials", (0,_to_consumable_array/* default */.Z)(name_initials));
}
function inviteUsers(values, inviteUserModal, setInviteUserModal, router, setAgencyUserList) {
    return _inviteUsers.apply(this, arguments);
}
function _inviteUsers() {
    _inviteUsers = (0,_async_to_generator/* default */.Z)(function(values, inviteUserModal, setInviteUserModal, router, setAgencyUserList) {
        var result, status_code, customToastrAction, _tmp, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new InviteAgencyUserService().inviteUsers(values, inviteUserModal.agency_id)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new common/* CustomToastrAction */.Y5();
                    _tmp = {};
                    switch(status_code){
                        case common/* SUCCESS_REPONSE_CODE */.Us:
                            // this.setLoader(false);
                            if (result.data.msg) {
                                customToastrAction.setNormalToastr(result.data.msg, "warning");
                            } else {
                                customToastrAction.setNormalToastr(result.data.success, "success");
                            }
                            if (setAgencyUserList) setAgencyUserList(result.data);
                            setInviteUserModal((_tmp.state = false, _tmp));
                            break;
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            error = result.response.data.error;
                            customToastrAction.setNormalToastr(error, "warning");
                            break;
                        default:
                            // this.setLoader(false);
                            (0,common/* handleOtherResponseCode */.GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _inviteUsers.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/actions/common/render_error_loading.js
var render_error_loading = __webpack_require__(10758);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ./src/services/common/send-request.js
var send_request = __webpack_require__(34964);
// EXTERNAL MODULE: ./src/services/pages/clients/company/add-team.js
var add_team = __webpack_require__(28936);
;// CONCATENATED MODULE: ./src/services/pages/clients/company/invite-agency-users.js









var InviteAgencyUserService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(InviteAgencyUserService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(InviteAgencyUserService);
    function InviteAgencyUserService() {
        (0,_class_call_check/* default */.Z)(this, InviteAgencyUserService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(InviteAgencyUserService, [
        {
            key: "userListData",
            value: function userListData(slug, params) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    new add_team/* AddTeamService */.g().getUserListData(slug, params)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAgencyUserRoles",
            value: function getAgencyUserRoles(params, hostName) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, header, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.company.GET_AGENCY_USER_ROLES */.bl.client.company.GET_AGENCY_USER_ROLES;
                                header = _this.serverSideHeaderJSON(hostName);
                                header["cookie"] = "Authorization=".concat(params.token);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(url, (_tmp.params = params, _tmp.headers = header, _tmp), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addMembers",
            value: function addMembers(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.company.ADD_CLIENTS */.bl.client.company.ADD_CLIENTS;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "inviteUsers",
            value: function inviteUsers(params, agency_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.company.INVITE_AGENCY_USER.replace */.bl.client.company.INVITE_AGENCY_USER.replace("$agency_id", agency_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return InviteAgencyUserService;
}(send_request/* SendRequest */.L);

;// CONCATENATED MODULE: ./src/constants/pages/clients/company/invite-agency-users.js

var INVITE_AGENCY_USER_INITIAL_VALUES = {
    job: "",
    agency_user_emails: [],
    agency_user_initials: []
};
var INVITE_AGENCY_USER_VALIDATION_SCHEMA = common/* Yup.object */.sm.object({
    // job: Yup.string().required(TRANSLATION('errors:required')),
    allow_unshare: common/* Yup.boolean */.sm.boolean(),
    agency_user_emails: common/* Yup.array */.sm.array().when("allow_unshare", {
        is: function(allow_unshare) {
            return !allow_unshare;
        },
        then: common/* Yup.array */.sm.array().min(1, (0,common/* TRANSLATION */.TA)("errors:member_required")),
        otherwise: common/* Yup.array */.sm.array().notRequired()
    })
});
var ADD_MEMBERS = {
    CSV_FILE_SIZE_LIMIT: 1000000,
    texts: {
        heading: "Invite Agency User",
        subheading_1: "Individuals that’ll be using Heartpace. For speed, you can",
        subheading_2: "download CSV template",
        subheading_3: "and import a list of users. You can also add more later.",
        add_user_button: "Add User",
        import_user: "Bulk Import User",
        submit_button: "Submit",
        cancel_button: "Cancel"
    },
    INITIAL_VALUES: {
        agency: {
            agency_users_attributes: [
                {
                    role_id: "",
                    user_attributes: {
                        email: "",
                        name: ""
                    }
                }
            ]
        }
    },
    DEFAULT_VALUE: {
        agency: {
            agency_users_attributes: [
                {
                    role_id: "",
                    user_attributes: {
                        email: "",
                        name: ""
                    }
                }
            ]
        }
    },
    VALIDATION_SCHEMA: common/* Yup.object */.sm.object().shape({
        agency: common/* Yup.object */.sm.object().shape({
            agency_users_attributes: common/* Yup.array */.sm.array().of(common/* Yup.object */.sm.object({
                _destroy: common/* Yup.boolean */.sm.boolean(),
                role_id: common/* Yup.string */.sm.string().when("_destroy", {
                    is: function(_destroy) {
                        return !_destroy;
                    },
                    then: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required"))
                }),
                user_attributes: common/* Yup.object */.sm.object().when("_destroy", {
                    is: function(_destroy) {
                        return !_destroy;
                    },
                    then: common/* Yup.object */.sm.object({
                        email: common/* Yup.string */.sm.string().email((0,common/* TRANSLATION */.TA)("errors:invalid_email")).required((0,common/* TRANSLATION */.TA)("errors:required")),
                        name: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable()
                    })
                })
            }))
        })
    })
};

// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(85155);
// EXTERNAL MODULE: ./src/styles/components/progressline/_index.module.scss
var _index_module = __webpack_require__(39923);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/common.js
var jobs_common = __webpack_require__(90432);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/job-sharing.js
var job_sharing = __webpack_require__(11007);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/company/invite-agency-users.js
// --------------- COMMON --------------

// --------------- COMMON --------------
// --------------- ACTIONS --------------

// --------------- ACTIONS --------------
// --------------- COMPONENTS --------------

// --------------- COMPONENTS --------------
// --------------- SERVICE --------------

// --------------- SERVICE --------------
// --------------- CONSTANT --------------

// --------------- CONSTANT --------------
// --------------- ICONS --------------

// --------------- ICONS --------------
// --------------- STYLESHEET --------------

// --------------- STYLESHEET --------------

 // import PageStyle from "@/styles/pages/clients/job-sharing/_index.module.scss";


/***/ }),

/***/ 66090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "PJ": function() { return /* reexport */ (login_index_module_default()); },
  "zx": function() { return /* reexport */ components_button/* default */.Z; },
  "ZJ": function() { return /* reexport */ (_index_module_default()); },
  "PZ": function() { return /* reexport */ (success_index_module_default()); },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "dC": function() { return /* reexport */ common/* ErrorPages */.dC; },
  "u_": function() { return /* reexport */ (input_field_index_module_default()); },
  "KN": function() { return /* reexport */ InviteClientAdmin; },
  "rU": function() { return /* reexport */ (link_default()); },
  "TR": function() { return /* reexport */ logo/* default */.Z; },
  "CO": function() { return /* reexport */ modal/* default */.Z; },
  "Mf": function() { return /* reexport */ common/* PAGE_ANIMATION_OPTIONS */.Mf; },
  "RQ": function() { return /* reexport */ common/* REDIRECT */.RQ; },
  "Us": function() { return /* reexport */ common/* SUCCESS_REPONSE_CODE */.Us; },
  "Lt": function() { return /* reexport */ send_request/* SendRequest */.L; },
  "Ye": function() { return /* reexport */ (invite_admin_index_module_default()); },
  "TA": function() { return /* reexport */ common/* TRANSLATION */.TA; },
  "t9": function() { return /* reexport */ common/* UNAUTHORIZED_REPONSE_CODE */.t9; },
  "Mn": function() { return /* reexport */ common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "A$": function() { return /* reexport */ common/* clearSWRCache */.A$; },
  "Gg": function() { return /* reexport */ common/* getSession */.Gg; },
  "GB": function() { return /* reexport */ common/* handleOtherResponseCode */.GB; },
  "MI": function() { return /* reexport */ inviteAdminFormSubmit; },
  "EA": function() { return /* reexport */ common/* motion */.EA; },
  "uJ": function() { return /* reexport */ add_users/* roles */.uJ; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: CLIENT_NAME, Component, FontAwesomeIcon, Image, InputError, Loading, NextServerCookies, React, Yup, clientRoles, faArrowLeft, faTimes, signIn, toastr

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ./src/components/logo.js + 1 modules
var logo = __webpack_require__(8498);
// EXTERNAL MODULE: ./src/components/modal.js
var modal = __webpack_require__(75695);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
// EXTERNAL MODULE: ./src/services/common/send-request.js
var send_request = __webpack_require__(34964);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
;// CONCATENATED MODULE: ./src/services/pages/clients/invite-admin.js







var InviteClientAdmin = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(InviteClientAdmin, SendRequest);
    var _super = (0,_create_super/* default */.Z)(InviteClientAdmin);
    function InviteClientAdmin() {
        (0,_class_call_check/* default */.Z)(this, InviteClientAdmin);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(InviteClientAdmin, [
        {
            key: "inviteAdmins",
            value: function inviteAdmins(params, client_id) {
                var _this = this;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(common/* API.client.invite_admin.replace */.bl.client.invite_admin.replace("$client_id", client_id), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return InviteClientAdmin;
}(send_request/* SendRequest */.L);

// EXTERNAL MODULE: ./src/styles/components/button/_index.module.scss
var _index_module = __webpack_require__(84215);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/styles/pages/clients/success/_index.module.scss
var success_index_module = __webpack_require__(47327);
var success_index_module_default = /*#__PURE__*/__webpack_require__.n(success_index_module);
// EXTERNAL MODULE: ./src/styles/pages/clients/invite-admin/_index.module.scss
var invite_admin_index_module = __webpack_require__(98071);
var invite_admin_index_module_default = /*#__PURE__*/__webpack_require__.n(invite_admin_index_module);
// EXTERNAL MODULE: ./src/styles/components/input-field/_index.module.scss
var input_field_index_module = __webpack_require__(58427);
var input_field_index_module_default = /*#__PURE__*/__webpack_require__.n(input_field_index_module);
// EXTERNAL MODULE: ./src/styles/pages/admins/login/_index.module.scss
var login_index_module = __webpack_require__(39457);
var login_index_module_default = /*#__PURE__*/__webpack_require__.n(login_index_module);
;// CONCATENATED MODULE: ./src/actions/pages/clients/invite-admin.js



function createUserData(values, client_id, role_id) {
    return _createUserData.apply(this, arguments);
}
function _createUserData() {
    _createUserData = _async_to_generator(function(values, client_id, role_id) {
        var hash, _tmp, client_users_attributes;
        return _ts_generator(this, function(_state) {
            _tmp = {};
            hash = (_tmp.client = {
                id: client_id
            }, _tmp);
            client_users_attributes = [];
            values.map(function(value) {
                var client_user = {
                    user_attributes: {
                        email: value
                    },
                    role_id: role_id
                };
                client_users_attributes.push(client_user);
            });
            return [
                2,
                hash.push(client_users_attributes)
            ];
        });
    });
    return _createUserData.apply(this, arguments);
}
function inviteAdminFormSubmit(values, client_id, role_id, router) {
    return _inviteAdminFormSubmit.apply(this, arguments);
}
function _inviteAdminFormSubmit() {
    _inviteAdminFormSubmit = (0,src_async_to_generator/* default */.Z)(function(values, client_id, role_id, router) {
        var body, _tmp, client_users_attributes, result, status_code, response, customToastrAction;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = (_tmp.client = {}, _tmp);
                    client_users_attributes = [];
                    values.map(function(value) {
                        var client_user = {
                            user_attributes: {
                                email: value
                            },
                            role_id: role_id
                        };
                        client_users_attributes.push(client_user);
                    });
                    body["client"]["client_users_attributes"] = client_users_attributes;
                    body.invite_admin = true;
                    return [
                        4,
                        new InviteClientAdmin().inviteAdmins(body, client_id)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    response = result.data || result.response.data;
                    customToastrAction = new common/* CustomToastrAction */.Y5();
                    // ---------------------------- Initialization ------------------------------
                    switch(status_code){
                        case common/* SUCCESS_REPONSE_CODE */.Us:
                            if (response.success) {
                                customToastrAction.setNormalToastr(response.success, "success");
                                // toastr.success(response.success)
                                router.push(common/* REDIRECT.client.activities */.RQ.client.activities);
                            }
                            break;
                        case common/* UNAUTHORIZED_REPONSE_CODE */.t9:
                            customToastrAction.setNormalToastr(response.error, "warning");
                            break;
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            customToastrAction.setNormalToastr(result.response.data.error.client.base, "warning");
                            break;
                        default:
                            (0,common/* handleOtherResponseCode */.GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _inviteAdminFormSubmit.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/actions/pages/admins/dashboard/clients/add-users.js
var add_users = __webpack_require__(88161);
// EXTERNAL MODULE: ./src/actions/common/input-error.js
var input_error = __webpack_require__(54911);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(82994);
// EXTERNAL MODULE: ../../shared/node_modules/next/link.js
var next_link = __webpack_require__(75547);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/invite-admin.js


//-----------Custom Component----------------



//-----------Custom Component----------------
// ----------------------------- SERVICES ---------------------------------------


// ----------------------------- SERVICES ---------------------------------------
// ----------------------------- CONSTANTS ---------------------------------------

// ----------------------------- CONSTANTS ---------------------------------------
//-----------Stylesheet----------------





//-----------Stylesheet----------------



// ----------------Fontawesome icons -----------------


// ----------------Fontawesome icons -----------------



/***/ }),

/***/ 64335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "PG": function() { return /* reexport */ common/* AutocompleteError */.PG; },
  "qn": function() { return /* reexport */ automation/* Automation */.q; },
  "rA": function() { return /* reexport */ automation_modal["default"]; },
  "tc": function() { return /* reexport */ back_all_jobs_modal["default"]; },
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "ZJ": function() { return /* reexport */ (_index_module_default()); },
  "Ig": function() { return /* reexport */ call2/* default */.Z; },
  "x4": function() { return /* reexport */ common/* CommonAction */.x4; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "QJ": function() { return /* reexport */ common/* DataFromUrl */.QJ; },
  "dC": function() { return /* reexport */ common/* ErrorPages */.dC; },
  "l0": function() { return /* reexport */ common/* Form */.l0; },
  "J9": function() { return /* reexport */ common/* Formik */.J9; },
  "gt": function() { return /* reexport */ common/* FormikControl */.gt; },
  "BH": function() { return /* reexport */ common/* INTERVIEW_TYPES */.BH; },
  "Al": function() { return /* reexport */ common/* INTERVIEW_TYPE_HEADERS */.Al; },
  "pd": function() { return /* reexport */ input_error/* InputError */.p; },
  "oH": function() { return /* reexport */ common/* InputText */.oH; },
  "eP": function() { return /* reexport */ common/* JOB_STAGES */.eP; },
  "l": function() { return /* reexport */ common/* JOB_STEPS */.l; },
  "WY": function() { return /* reexport */ manage_assessment/* MANAGE_ASSESSMENT */.WY; },
  "Mf": function() { return /* reexport */ common/* PAGE_ANIMATION_OPTIONS */.Mf; },
  "k2": function() { return /* reexport */ (automation_index_module_default()); },
  "RQ": function() { return /* reexport */ common/* REDIRECT */.RQ; },
  "Us": function() { return /* reexport */ common/* SUCCESS_REPONSE_CODE */.Us; },
  "Lt": function() { return /* reexport */ send_request/* SendRequest */.L; },
  "TA": function() { return /* reexport */ common/* TRANSLATION */.TA; },
  "e6": function() { return /* reexport */ technical/* default */.Z; },
  "Uy": function() { return /* reexport */ TechTestAction; },
  "Mn": function() { return /* reexport */ common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn; },
  "QC": function() { return /* reexport */ manage_assessment/* URL_FORMAT */.QC; },
  "rG": function() { return /* reexport */ uploadIcon; },
  "bN": function() { return /* reexport */ (tech_test_index_module_default()); },
  "n5": function() { return /* reexport */ user/* default */.Z; },
  "nk": function() { return /* reexport */ video/* default */.Z; },
  "jf": function() { return /* reexport */ videoqa/* default */.Z; },
  "CS": function() { return /* reexport */ video_qa_action/* VideoQaAction */.C; },
  "sm": function() { return /* reexport */ common/* Yup */.sm; },
  "E$": function() { return /* reexport */ jobs_automation/* addInitalInterview */.E$; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "A$": function() { return /* reexport */ common/* clearSWRCache */.A$; },
  "y$": function() { return /* reexport */ jobs_common/* cursorNone */.y$; },
  "i9": function() { return /* reexport */ jobs_automation/* defaultTestDetail */.i9; },
  "x9": function() { return /* reexport */ duration; },
  "Bl": function() { return /* reexport */ jobs_automation/* getAssessmentTestData */.Bl; },
  "Lj": function() { return /* reexport */ jobs_automation/* getAutomationData */.Lj; },
  "D6": function() { return /* reexport */ interview_stages/* getClientUsers */.D6; },
  "jt": function() { return /* reexport */ jobs_automation/* getManualJobStageData */.jt; },
  "Ib": function() { return /* reexport */ jobs_automation/* getTechTestData */.Ib; },
  "y": function() { return /* reexport */ jobs_automation/* handleAutomationFormSubmit */.y; },
  "K0": function() { return /* reexport */ jobs_automation/* handleInterviewFormSubmit */.K0; },
  "$y": function() { return /* reexport */ jobs_automation/* handleKeyDown */.$y; },
  "GB": function() { return /* reexport */ common/* handleOtherResponseCode */.GB; },
  "jv": function() { return /* reexport */ jobs_automation/* initialStageValues */.jv; },
  "D7": function() { return /* reexport */ jobs_automation/* interviewStageName */.D7; },
  "ev": function() { return /* reexport */ jobs_automation/* interviewTypeHeader */.ev; },
  "Bb": function() { return /* reexport */ jobs_automation/* interviewTypeIcon */.Bb; },
  "Pq": function() { return /* reexport */ jobs_automation/* isLocationDisabled */.Pq; },
  "EA": function() { return /* reexport */ common/* motion */.EA; },
  "mV": function() { return /* reexport */ jobs_automation/* onAutomationChange */.mV; },
  "wn": function() { return /* reexport */ jobs_automation/* onSuggestionSelection */.wn; },
  "oo": function() { return /* reexport */ jobs_automation/* onSuggestionsFetchRequested */.oo; },
  "ao": function() { return /* reexport */ jobs_common/* previewJob */.ao; },
  "rw": function() { return /* reexport */ jobs_automation/* renderAutomationModalInputComponent */.rw; },
  "Qx": function() { return /* reexport */ jobs_automation/* renderInputComponent */.Qx; },
  "ox": function() { return /* reexport */ jobs_automation/* renderSuggestion */.ox; },
  "hh": function() { return /* reexport */ kanban/* runAutomations */.hh; },
  "uQ": function() { return /* reexport */ jobs_automation/* setFormDirty */.uQ; },
  "rR": function() { return /* reexport */ jobs_automation/* setUpTechTest */.rR; },
  "L5": function() { return /* reexport */ jobs_automation/* setUpVideoQAMember */.L5; },
  "KH": function() { return /* reexport */ jobs_automation/* shouldRenderSuggestions */.KH; },
  "HW": function() { return /* reexport */ jobs_automation/* showHideButtonValue */.HW; },
  "d3": function() { return /* reexport */ jobs_common/* startDateMessage */.d3; },
  "$h": function() { return /* reexport */ jobs_common/* toggleDisabled */.$h; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "NL": function() { return /* reexport */ common/* useQueryClient */.NL; },
  "sO": function() { return /* reexport */ common/* useRef */.sO; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; },
  "tV": function() { return /* reexport */ validations; }
});

// UNUSED EXPORTS: Checkbox, Field, FieldArray, INITIAL_VALUES, Image, Link, MyInterviewWidget, NextServerCookies, RESOURCE_NOT_FOUND_REPONSE_CODE, React, Robot, Select, SetupPopup, Sidebar, Tooltip, automationText, draftJob, getBgClass, getJobStageData, goToNextPage, handleDelete, handleVideoQAFormSubmit, hideDraft, jobStatusBadge, manageModals, mangeInterviews, renderLabel, showSuggestion, testDuration, toastr, updateThreshold, userHash

// EXTERNAL MODULE: ./src/styles/components/button/_index.module.scss
var _index_module = __webpack_require__(84215);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/styles/pages/clients/automation/_index.module.scss
var automation_index_module = __webpack_require__(68685);
var automation_index_module_default = /*#__PURE__*/__webpack_require__.n(automation_index_module);
// EXTERNAL MODULE: ./src/styles/components/tech-test/_index.module.scss
var tech_test_index_module = __webpack_require__(6966);
var tech_test_index_module_default = /*#__PURE__*/__webpack_require__.n(tech_test_index_module);
// EXTERNAL MODULE: ./public/icons/call2.svg
var call2 = __webpack_require__(67536);
// EXTERNAL MODULE: ./public/icons/video.svg
var video = __webpack_require__(15166);
// EXTERNAL MODULE: ./public/icons/user.svg
var user = __webpack_require__(41739);
// EXTERNAL MODULE: ./public/icons/robot.svg
var robot = __webpack_require__(31343);
// EXTERNAL MODULE: ./public/icons/technical.svg
var technical = __webpack_require__(36414);
// EXTERNAL MODULE: ./public/icons/videoqa.svg
var videoqa = __webpack_require__(20226);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
;// CONCATENATED MODULE: ./public/icons/uploadIcon.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgUploadIcon = function SvgUploadIcon(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 14,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M8.094 11.25a.64.64 0 0 0 .465-.191.66.66 0 0 0 .191-.465V6h2.406c.219 0 .383-.11.492-.328.082-.219.055-.438-.109-.602L7.383.914A.54.54 0 0 0 7 .75a.496.496 0 0 0-.383.164L2.461 5.07c-.164.164-.219.383-.11.602.083.219.247.328.493.328H5.25v4.594c0 .191.055.355.191.465.11.136.274.191.465.191h2.188ZM14 11.031c0-.164-.082-.328-.191-.465-.137-.109-.301-.191-.465-.191H9.625v.219c0 .437-.164.793-.465 1.094-.3.3-.656.437-1.066.437H5.906c-.437 0-.793-.137-1.093-.438-.301-.3-.438-.656-.438-1.093v-.219H.656a.66.66 0 0 0-.465.191.64.64 0 0 0-.191.465v3.063c0 .191.055.355.191.465.11.136.274.191.465.191h12.688a.64.64 0 0 0 .465-.191.66.66 0 0 0 .191-.465V11.03Zm-3.39 2.406a.496.496 0 0 1-.165.383.54.54 0 0 1-.383.164.496.496 0 0 1-.382-.164.496.496 0 0 1-.164-.383.54.54 0 0 1 .164-.382.496.496 0 0 1 .383-.164.54.54 0 0 1 .382.164.54.54 0 0 1 .164.383Zm1.75 0a.496.496 0 0 1-.165.383.54.54 0 0 1-.383.164.496.496 0 0 1-.382-.164.496.496 0 0 1-.164-.383.54.54 0 0 1 .164-.382.496.496 0 0 1 .383-.164.54.54 0 0 1 .382.164.54.54 0 0 1 .164.383Z",
    fill: "var(--default-text-color)"
  })));
};

/* harmony default export */ var uploadIcon = (SvgUploadIcon);
// EXTERNAL MODULE: ./src/components/setupmodel.js
var setupmodel = __webpack_require__(60737);
// EXTERNAL MODULE: ./src/actions/common/input-error.js
var input_error = __webpack_require__(54911);
// EXTERNAL MODULE: ./src/services/common/send-request.js
var send_request = __webpack_require__(34964);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/services/pages/clients/jobs/automation.js
var automation = __webpack_require__(49639);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/automation.js
var jobs_automation = __webpack_require__(57223);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/common.js
var jobs_common = __webpack_require__(90432);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/interview_stages.js
var interview_stages = __webpack_require__(68109);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(38641);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(18186);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4012);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(34817);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
;// CONCATENATED MODULE: ./src/actions/pages/clients/jobs/tech-test.js










var TechTestAction = /*#__PURE__*/ function() {
    "use strict";
    function TechTestAction(setTests) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, TechTestAction);
        (0,_define_property/* default */.Z)(this, "renderInputComponent", function(inputProps) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: (automation_index_module_default()).Form__Input,
                autoComplete: "password"
            }, inputProps), {
                style: inputProps.styleError
            }));
        });
        (0,_define_property/* default */.Z)(this, "renderMemberInputComponent", function(inputProps) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                className: "buttonIn AutoSuggestInput__Tags",
                children: [
                    (ref = inputProps.selectedValues) === null || ref === void 0 ? void 0 : ref.map(function(item, itemIndex) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (automation_index_module_default()).SetupPopup__Tags,
                            children: [
                                item.name ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: item.name
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: item.email
                                }),
                                inputProps.editable && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    ButtonStyle: "".concat((_index_module_default()).nobgbutton),
                                    type: "button",
                                    onClick: function() {
                                        return inputProps.techTestAction.handleDelete(inputProps.formik, inputProps.itemIndex);
                                    },
                                    children: [
                                        " ",
                                        inputProps.closeIcon
                                    ]
                                })
                            ]
                        }, "interview_email_".concat(itemIndex));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        className: (automation_index_module_default()).Form__Input,
                        autoComplete: "password"
                    }, inputProps)),
                    inputProps.add_button && /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                        buttonstyle: "".concat((_index_module_default()).nobgbutton, " addbtn ").concat((0,jobs_common/* cursorNone */.y$)(inputProps.editable)),
                        disabled: inputProps.disabled,
                        onClick: function(event) {
                            return inputProps.techTestAction.onAddClick(event, inputProps);
                        },
                        children: (0,common/* TRANSLATION */.TA)("button:add:default")
                    })
                ]
            });
        });
        (0,_define_property/* default */.Z)(this, "onAddClick", function(event, params) {
            var email = params.value;
            if (_this.isEmail(email)) {
                params.techTestAction.onSuggestionSelection(params.formik.values.job_test_detail_attributes.member_emails, email, params.formik.values.job_test_detail_attributes.member_initials, {
                    email: email,
                    name_initials: null,
                    name: null
                });
                params.setStageEmail({
                    value: "",
                    error: ""
                });
            } else {
                params.setStageEmail({
                    value: email,
                    error: "Please enter valid email"
                });
            }
        });
        this.setTests = setTests;
        this.customToastrAction = new common/* CustomToastrAction */.Y5();
        this.commonAction = new common/* CommonAction */.x4();
    }
    (0,_create_class/* default */.Z)(TechTestAction, [
        {
            key: "getSuggestionValue",
            value: function getSuggestionValue(suggestion) {
                return suggestion.code;
            }
        },
        {
            key: "renderSuggestion",
            value: function renderSuggestion(suggestion) {
                return suggestion.id == "upload_new_test" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "".concat((tech_test_index_module_default()).uploadNewTest),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(uploadIcon, {}),
                        " ",
                        suggestion.name
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: suggestion.name
                });
            }
        },
        {
            key: "escapeRegexCharacters",
            value: function escapeRegexCharacters(str) {
                return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            }
        },
        {
            key: "getIkmTests",
            value: function getIkmTests(value) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var escapedValue, techTests;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                escapedValue = _this.escapeRegexCharacters(value.value.trim());
                                if (escapedValue === "") {
                                    return [
                                        2,
                                        []
                                    ];
                                }
                                return [
                                    4,
                                    (0,jobs_automation/* getTechTestData */.Ib)(escapedValue)
                                ];
                            case 1:
                                techTests = _state.sent();
                                return [
                                    2,
                                    techTests
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAssessments",
            value: function getAssessments(value, isCustom, t) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var escapedValue, techTests;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                escapedValue = _this.escapeRegexCharacters(value.value.trim());
                                return [
                                    4,
                                    (0,jobs_automation/* getAssessmentTestData */.Bl)(escapedValue, isCustom, t)
                                ];
                            case 1:
                                techTests = _state.sent();
                                return [
                                    2,
                                    techTests
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onSuggestionsFetchRequested",
            value: function onSuggestionsFetchRequested(value, techTestAction, test_type, isCustom, t) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var techTests, techTests1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                test_type = test_type || "TestLibrary";
                                if (!(test_type == "TestLibrary")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    techTestAction.getIkmTests(value)
                                ];
                            case 1:
                                techTests = _state.sent();
                                _this.setTests(techTests);
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                if (!(test_type == "Assessment")) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    techTestAction.getAssessments(value, isCustom, t)
                                ];
                            case 3:
                                techTests1 = _state.sent();
                                _this.setTests(techTests1);
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "shouldRenderSuggestions",
            value: function shouldRenderSuggestions(value) {
                return value.trim().length >= 3;
            }
        },
        {
            key: "isEmail",
            value: function isEmail(email) {
                return /^[^\s@]+@[^\s@]+\.[^\s@\.]+$/.test(email);
            }
        },
        {
            key: "onSuggestionSelection",
            value: function onSuggestionSelection(old_ids, id, old_initials, new_initial) {
                if (!(old_ids.includes(id) || old_ids.includes(id.toString()))) {
                    old_ids.unshift(id);
                    old_initials.unshift(new_initial);
                }
            }
        },
        {
            key: "handleKeyDown",
            value: function handleKeyDown(event, formik, setStageEmail) {
                if ([
                    "Enter"
                ].includes(event.key)) {
                    event.preventDefault();
                    var email = event.target.value;
                    if (this.isEmail(email)) {
                        this.onSuggestionSelection(formik.values.job_test_detail_attributes.member_emails, email, formik.values.job_test_detail_attributes.member_initials, {
                            email: email,
                            name_initials: null,
                            name: null
                        });
                        setStageEmail({
                            value: "",
                            error: ""
                        });
                    } else {
                        setStageEmail({
                            value: email,
                            error: "Please enter valid email"
                        });
                    }
                }
            }
        },
        {
            key: "handleDelete",
            value: function handleDelete(formik, itemIndex) {
                var member_emails = formik.values.job_test_detail_attributes.member_emails;
                var member_initials = formik.values.job_test_detail_attributes.member_initials;
                member_emails.splice(itemIndex, 1);
                member_initials.splice(itemIndex, 1);
                formik.setFieldValue("job_test_detail_attributes.member_emails", (0,_to_consumable_array/* default */.Z)(member_emails));
                formik.setFieldValue("job_test_detail_attributes.member_initials", (0,_to_consumable_array/* default */.Z)(member_initials));
            }
        },
        {
            key: "onOptionChange",
            value: function onOptionChange(formik, event, setTechTest, validationData, setvalidationData, test_origin) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(test_origin == "custom")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    formik.setFieldValue("test_type", event.target.value)
                                ];
                            case 1:
                                _state.sent();
                                formik.setFieldValue("test_id", "");
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    formik.setFieldValue("job_test_detail_attributes.test_type", event.target.value)
                                ];
                            case 3:
                                _state.sent();
                                formik.setFieldValue("job_test_detail_attributes.test_id", "");
                                _state.label = 4;
                            case 4:
                                validationData.type = event.target.value;
                                validationData.test_id = "";
                                setvalidationData(validationData);
                                setTechTest("");
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onTestoptionChange",
            value: function onTestoptionChange(formik, event) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var val;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                val = event.target.value;
                                if (!(val == "file")) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    formik.setFieldValue(event.target.name, val)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue(event.target.name.replace("file_type", "link"), "")
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                return [
                                    4,
                                    formik.setFieldValue(event.target.name, val)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue(event.target.name.replace("file_type", "file"), "")
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue(event.target.name.replace("file_type", "filename"), "")
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "uploadFile",
            value: function uploadFile(formik, files, event) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var ref, file, name_atr, base64;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                file = files[0];
                                name_atr = ((ref = event.target) === null || ref === void 0 ? void 0 : ref.name) || event.currentTarget.getAttribute("name");
                                if (!file) return [
                                    3,
                                    9
                                ];
                                formik.setFieldValue(name_atr.replace("file", "file_type"), "file");
                                if (!(file.size > manage_assessment/* MANAGE_ASSESSMENT.file_size */.WY.file_size)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    formik.setFieldValue(name_atr.replace("file", "filename"), file.name)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue(name_atr.replace("file", "file"), "")
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue(name_atr.replace("file", "filesize"), file.size)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    9
                                ];
                            case 4:
                                return [
                                    4,
                                    _this.commonAction.convertToBase64(file)
                                ];
                            case 5:
                                base64 = _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue(name_atr.replace("file", "filename"), file.name)
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue(name_atr.replace("file", "file"), base64)
                                ];
                            case 7:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue(name_atr.replace("file", "filesize"), file.size)
                                ];
                            case 8:
                                _state.sent();
                                _state.label = 9;
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onRemoveFile",
            value: function onRemoveFile(formik, name) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    formik.setFieldValue(name.replace("file", "file_type"), "link")
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue(name.replace("file", "file"), "")
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue(name.replace("file", "filename"), "")
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setCustomTestOptions",
            value: function setCustomTestOptions(formik, suggestionId, validationData, setvalidationData) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        if (suggestionId == "upload_new_test") {
                            ;
                            validationData.test_id = suggestionId;
                            (ref = document.getElementsByClassName("asessment-form-section")[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.remove("displaynone");
                        } else {
                            ;
                            validationData.test_id = suggestionId;
                            (ref2 = document.getElementsByClassName("asessment-form-section")[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.classList) === null || ref3 === void 0 ? void 0 : ref3.add("displaynone");
                        }
                        setvalidationData(validationData);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "setJobTestDetail",
            value: function setJobTestDetail(job_test_detail_attributes, t) {
                var value = job_test_detail_attributes;
                if (job_test_detail_attributes.test_type == "Assessment" && job_test_detail_attributes.entity_type == "JobStage") {
                    value.test_id = "upload_new_test";
                    value.test_name = t("modal:automation:upload_new_test");
                }
                if (!value.assessment) value.assessment = {
                    name: "",
                    file_type: "link",
                    link: "",
                    file: "",
                    filename: "",
                    filesize: ""
                };
                return value;
            }
        }
    ]);
    return TechTestAction;
}();

// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/video-qa-action.js
var video_qa_action = __webpack_require__(47084);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/jobs/automation-modal.js
var automation_modal = __webpack_require__(23028);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/recruitments/my-interview-widget.js + 2 modules
var my_interview_widget = __webpack_require__(63523);
;// CONCATENATED MODULE: ./src/constants/pages/clients/jobs/automation.js


var INITIAL_VALUES = {
    test: {
        test_code: "",
        expires_in: ""
    }
};
var duration = [
    {
        label: "15",
        value: 15
    },
    {
        label: "30",
        value: 30
    },
    {
        label: "45",
        value: 45
    },
    {
        label: "60",
        value: 60
    }
];
var CONSTANTS = {
    errors: {
        minimum: "Minimum $number",
        maximum: "Maximum $number"
    }
};
function validations(current_interview_type, validationData) {
    if ([
        common/* INTERVIEW_TYPES.PHONE */.BH.PHONE,
        common/* INTERVIEW_TYPES.VIDEO */.BH.VIDEO,
        common/* INTERVIEW_TYPES.FACE2FACE */.BH.FACE2FACE
    ].includes(current_interview_type)) {
        var phoneVideoFaceSchema = common/* Yup.object */.sm.object().shape({
            place_id: common/* Yup.string */.sm.string().nullable(true),
            default_location: common/* Yup.string */.sm.string().when([], {
                is: function() {
                    return current_interview_type == common/* INTERVIEW_TYPES.FACE2FACE */.BH.FACE2FACE;
                },
                then: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).test("validLocation", (0,common/* TRANSLATION */.TA)("errors:invalid_address"), function(value) {
                    return this.parent.place_id && this.parent.place_id.length > 0;
                })
            }),
            job_meeting_details_attributes: common/* Yup.array */.sm.array().of(common/* Yup.object */.sm.object().shape({
                interview_type: common/* Yup.string */.sm.string(),
                _destroy: common/* Yup.boolean */.sm.boolean(),
                duration: common/* Yup.string */.sm.string().when("_destroy", {
                    is: function(_destroy) {
                        return !_destroy;
                    },
                    then: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required"))
                }),
                // location_attributes: Yup.object().when(["interview_type", "_destroy"],{
                //   is: (interview_type, _destroy) => {
                //     return (!_destroy && (interview_type == INTERVIEW_TYPES.FACE2FACE))
                //   },
                //   then: Yup.object().shape({
                //     full_address: Yup.string().required(TRANSLATION('errors:required'))
                //   })
                // }),
                meeting_platform_attributes: common/* Yup.object */.sm.object().when([
                    "interview_type",
                    "_destroy"
                ], {
                    is: function(interview_type, _destroy) {
                        return !_destroy && interview_type == common/* INTERVIEW_TYPES.VIDEO */.BH.VIDEO;
                    },
                    then: common/* Yup.object */.sm.object().shape({
                        integration_id: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required"))
                    })
                }),
                member_emails: common/* Yup.array */.sm.array().when("_destroy", {
                    is: function(_destroy) {
                        return !_destroy;
                    },
                    then: common/* Yup.array */.sm.array().min(1, (0,common/* TRANSLATION */.TA)("errors:member_required"))
                })
            }))
        });
        return phoneVideoFaceSchema;
    } else if (current_interview_type == common/* INTERVIEW_TYPES.TECHTEST */.BH.TECHTEST) {
        var techTestSchema = common/* Yup.object */.sm.object({
            job_test_detail_attributes: common/* Yup.object */.sm.object({
                test_id: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:invalid_test")),
                days_to_expire: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")),
                test_type: common/* Yup.string */.sm.string(),
                assessment: common/* Yup.object */.sm.object().shape((0,_object_spread/* default */.Z)({}, validationData.type == "Assessment" && validationData.test_id.toString() == "upload_new_test" ? {
                    name: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")),
                    file_type: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")),
                    link: common/* Yup.string */.sm.string().when("file_type", {
                        is: function(file_type) {
                            return file_type == "link";
                        },
                        then: common/* Yup.string */.sm.string().matches(manage_assessment/* URL_FORMAT */.QC, (0,common/* TRANSLATION */.TA)("errors:assessment_link_invalid")),
                        otherwise: common/* Yup.string */.sm.string().notRequired()
                    }),
                    filename: common/* Yup.string */.sm.string().when("file_type", {
                        is: function(file_type) {
                            return file_type == "file";
                        },
                        then: common/* Yup.string */.sm.string(),
                        otherwise: common/* Yup.string */.sm.string().notRequired()
                    }),
                    filesize: common/* Yup.string */.sm.string().when("file_type", {
                        is: function(file_type) {
                            return file_type == "file";
                        },
                        then: common/* Yup.string */.sm.string().test("is-greater", (0,common/* TRANSLATION */.TA)("errors:max_file_size"), function(value) {
                            var currentFileSize = parseInt(value) || 0;
                            return currentFileSize < manage_assessment/* MANAGE_ASSESSMENT.file_size */.WY.file_size;
                        }),
                        otherwise: common/* Yup.string */.sm.string().notRequired()
                    })
                } : {}))
            })
        });
        return techTestSchema;
    } else if (current_interview_type == common/* INTERVIEW_TYPES.VIDEOQA */.BH.VIDEOQA) {
        var videQASchema = common/* Yup.object */.sm.object({
            language: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")),
            video_link: common/* Yup.string */.sm.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, (0,common/* TRANSLATION */.TA)("errors:invalid_url")).nullable(true),
            questions_attributes: common/* Yup.array */.sm.array(common/* Yup.object */.sm.object().shape({
                question: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")),
                answer_time: common/* Yup.number */.sm.number().required((0,common/* TRANSLATION */.TA)("errors:required")).min(30, CONSTANTS.errors.minimum.replace("$number", 30)).max(120, CONSTANTS.errors.maximum.replace("$number", 120)).nullable(true),
                attempts: common/* Yup.number */.sm.number().required((0,common/* TRANSLATION */.TA)("errors:required")).min(1, CONSTANTS.errors.minimum.replace("$number", 1)).max(3, CONSTANTS.errors.maximum.replace("$number", 3)).nullable(true)
            })),
            expires: common/* Yup.number */.sm.number().required((0,common/* TRANSLATION */.TA)("errors:required"))
        });
        return videQASchema;
    } else {
        var interviewTypeSchema = common/* Yup.object */.sm.object({
            interview_type_id: common/* Yup.string */.sm.string().when("automation", {
                is: function(automation) {
                    return automation;
                },
                then: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable(true),
                otherwise: common/* Yup.string */.sm.string().notRequired().nullable(true)
            })
        });
        return interviewTypeSchema;
    }
}

// EXTERNAL MODULE: ./src/pages/clients/jobs/back-all-jobs-modal.js
var back_all_jobs_modal = __webpack_require__(92867);
// EXTERNAL MODULE: ./src/actions/pages/clients/candidates/kanban.js
var kanban = __webpack_require__(21572);
// EXTERNAL MODULE: ./src/constants/pages/clients/recruitment/manage-assessment.js
var manage_assessment = __webpack_require__(24229);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/jobs/automations.js
//-----------------StyleSheet--------------------



//-----------------StyleSheet--------------------
//------------------Images ---------------------







//------------------Images ---------------------
//------------------- Custom Components --------------

//------------------- Custom Components --------------













// export { default as JobPreviewPage} from '@/pages/clients/dashboard/jobs/job-preview'




/***/ }),

/***/ 51895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_B": function() { return /* reexport */ AddInterviewManual; },
  "kF": function() { return /* reexport */ jobs_candidate_profile_job/* AddInterviewManualAction */.kF; },
  "sK": function() { return /* reexport */ add_offer["default"]; },
  "YD": function() { return /* reexport */ add_to_job_modal/* AddToJobModal */.Y; },
  "it": function() { return /* reexport */ application_filter/* ApplicationFilter */.i; },
  "Xd": function() { return /* reexport */ arrowleft/* default */.Z; },
  "o": function() { return /* reexport */ arrowleft_active/* default */.Z; },
  "MI": function() { return /* reexport */ arrowleft_disabled/* default */.Z; },
  "CM": function() { return /* reexport */ arrowright_active/* default */.Z; },
  "RA": function() { return /* reexport */ arrowright_disabled/* default */.Z; },
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "RF": function() { return /* reexport */ candidate_profile_job/* CANDIDATE_THOUGHTS_INITIAL_VALUES */.RF; },
  "cK": function() { return /* reexport */ candidate_profile_job/* CANDIDATE_THOUGHTS_VALIDATION_SCHEMA */.cK; },
  "mq": function() { return /* reexport */ cancel_interview/* CancelInterview */.m; },
  "$c": function() { return /* reexport */ CancelReasonPopup; },
  "C2": function() { return /* reexport */ clients_jobs_candidate_profile_job/* CandidateProfileJobService */.C; },
  "XZ": function() { return /* reexport */ common/* Checkbox */.XZ; },
  "bN": function() { return /* reexport */ common/* CheckedCheckbox */.bN; },
  "_M": function() { return /* reexport */ chevron_down/* default */.Z; },
  "t1": function() { return /* reexport */ chevron_red_left/* default */.Z; },
  "Bm": function() { return /* reexport */ chevron_red_right/* default */.Z; },
  "LD": function() { return /* reexport */ common/* ClientDashboard */.LD; },
  "vR": function() { return /* reexport */ cscore/* default */.Z; },
  "ij": function() { return /* reexport */ custom_tech_test_modal["default"]; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "t9": function() { return /* reexport */ daxtra_score_action/* DaxtraScoreAction */.t; },
  "v0": function() { return /* reexport */ common/* DefaultCheckbox */.v0; },
  "F_": function() { return /* reexport */ deleteicon/* default */.Z; },
  "AS": function() { return /* reexport */ dislike/* default */.Z; },
  "uq": function() { return /* reexport */ common/* ErrorPages */.dC; },
  "P5": function() { return /* reexport */ info_icon/* default */.Z; },
  "l0": function() { return /* reexport */ common/* Form */.l0; },
  "J9": function() { return /* reexport */ common/* Formik */.J9; },
  "gt": function() { return /* reexport */ common/* FormikControl */.gt; },
  "BH": function() { return /* reexport */ common/* INTERVIEW_TYPES */.BH; },
  "SE": function() { return /* reexport */ iframe_google_doc/* IframeGoogleDoc */.c; },
  "Ee": function() { return /* reexport */ common/* Image */.Ee; },
  "pd": function() { return /* reexport */ common/* InputError */.pd; },
  "oH": function() { return /* reexport */ common/* InputText */.oH; },
  "mN": function() { return /* reexport */ like/* default */.Z; },
  "ls": function() { return /* reexport */ new_edit_scorecard["default"]; },
  "y4": function() { return /* reexport */ react_number_format_es/* default */.Z; },
  "Mf": function() { return /* reexport */ common/* PAGE_ANIMATION_OPTIONS */.Mf; },
  "k2": function() { return /* reexport */ (_index_module_default()); },
  "ko": function() { return /* reexport */ progressbar/* default */.Z; },
  "RQ": function() { return /* reexport */ common/* REDIRECT */.RQ; },
  "_K": function() { return /* reexport */ RescheduleDetails; },
  "xz": function() { return /* reexport */ RescheduleRequest; },
  "QY": function() { return /* reexport */ review_email/* ReviewEmail */.Q; },
  "Us": function() { return /* reexport */ common/* SUCCESS_REPONSE_CODE */.Us; },
  "$F": function() { return /* reexport */ ScheduleDetails; },
  "Gg": function() { return /* reexport */ SendOfferModal; },
  "bw": function() { return /* reexport */ send_questions_modal["default"]; },
  "x2": function() { return /* reexport */ setup_interview_modal/* default */.Z; },
  "oC": function() { return /* reexport */ setupmodel/* default */.Z; },
  "Rl": function() { return /* reexport */ single_candidate_modal/* SingleCandidateModal */.R; },
  "OK": function() { return /* reexport */ esm/* Tab */.OK; },
  "td": function() { return /* reexport */ esm/* TabList */.td; },
  "AY": function() { return /* reexport */ esm/* TabPanel */.x4; },
  "mQ": function() { return /* reexport */ esm/* Tabs */.mQ; },
  "e6": function() { return /* reexport */ technicalkanban/* default */.Z; },
  "u": function() { return /* reexport */ es/* default */.Z; },
  "Mn": function() { return /* reexport */ common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn; },
  "hF": function() { return /* reexport */ unsuccessful_email_modal/* UnsuccessfulEmailModal */.h; },
  "OE": function() { return /* reexport */ unsuccessfull/* UnsuccessfulModal */.O; },
  "zI": function() { return /* reexport */ verified/* default */.Z; },
  "jf": function() { return /* reexport */ videoqa/* default */.Z; },
  "Uq": function() { return /* reexport */ view_profile/* ViewProfileActions */.gt; },
  "uz": function() { return /* reexport */ jobs_candidate_profile_job/* acceptSlot */.uz; },
  "Hi": function() { return /* reexport */ jobs_candidate_profile_job/* addManualInterview */.Hi; },
  "W5": function() { return /* reexport */ jobs_candidate_profile_job/* addManualKanbanInterview */.W5; },
  "mH": function() { return /* reexport */ addMinutes; },
  "iA": function() { return /* reexport */ jobs_candidate_profile_job/* candidateDownloadCV */.iA; },
  "ay": function() { return /* reexport */ jobs_candidate_profile_job/* candidateOpenEmail */.ay; },
  "EU": function() { return /* reexport */ jobs_candidate_profile_job/* candidateShareCV */.x8; },
  "gR": function() { return /* reexport */ jobs_candidate_profile_job/* checkAvailability */.gR; },
  "A$": function() { return /* reexport */ common/* clearSWRCache */.A$; },
  "cG": function() { return /* reexport */ jobs_candidate_profile_job/* downloadContract */.cG; },
  "D8": function() { return /* reexport */ common/* dynamic */.D8; },
  "WR": function() { return /* reexport */ jobs_candidate_profile_job/* getMeetingDetails */.WR; },
  "Oj": function() { return /* reexport */ candidates_kanban/* getOfferHash */.Oj; },
  "JE": function() { return /* reexport */ candidates_kanban/* getScorecards */.JE; },
  "fT": function() { return /* reexport */ jobs_candidate_profile_job/* getShareComponentMemberListArray */.fT; },
  "cd": function() { return /* reexport */ otp/* get_seconds_for_timer */.cd; },
  "iM": function() { return /* reexport */ jobs_candidate_profile_job/* goToOtherCandidate */.iM; },
  "GB": function() { return /* reexport */ common/* handleOtherResponseCode */.GB; },
  "$l": function() { return /* reexport */ jobs_candidate_profile_job/* hideAddScorecard */.$l; },
  "jv": function() { return /* reexport */ initialStageValues; },
  "$x": function() { return /* reexport */ isCustomLink; },
  "Pq": function() { return /* reexport */ isLocationDisabled; },
  "Lg": function() { return /* reexport */ jobs_candidate_profile_job/* like_dislike */.Lg; },
  "jM": function() { return /* reexport */ candidates_kanban/* manageAutomationTimer */.jM; },
  "Sb": function() { return /* reexport */ manualInitialValues; },
  "KF": function() { return /* reexport */ candidates_kanban/* markActiveUnsuccessful */.KF; },
  "te": function() { return /* reexport */ jobs_candidate_profile_job/* markAsReadEmail */.te; },
  "ul": function() { return /* reexport */ jobs_candidate_profile_job/* mergeCandidate */.ul; },
  "EA": function() { return /* reexport */ common/* motion */.EA; },
  "jk": function() { return /* reexport */ candidates_kanban/* moveToNextStage */.jk; },
  "mV": function() { return /* reexport */ onAutomationChange; },
  "wn": function() { return /* reexport */ onSuggestionSelection; },
  "oo": function() { return /* reexport */ onSuggestionsFetchRequested; },
  "iv": function() { return /* reexport */ entry/* pdfjs */.v0; },
  "Qx": function() { return /* reexport */ renderInputComponent; },
  "ox": function() { return /* reexport */ renderSuggestion; },
  "QV": function() { return /* reexport */ jobs_candidate_profile_job/* rescheduleInerview */.QV; },
  "c_": function() { return /* reexport */ jobs_candidate_profile_job/* resendInvite */.c_; },
  "ds": function() { return /* reexport */ candidates_kanban/* reviewAutomationEmail */.ds; },
  "hh": function() { return /* reexport */ candidates_kanban/* runAutomations */.hh; },
  "po": function() { return /* reexport */ FileSaver_min.saveAs; },
  "Wg": function() { return /* reexport */ candidates_kanban/* setAutomationHash */.Wg; },
  "KH": function() { return /* reexport */ shouldRenderSuggestions; },
  "z6": function() { return /* reexport */ candidates_kanban/* showAddOffer */.z6; },
  "Zz": function() { return /* reexport */ jobs_candidate_profile_job/* showAddScorecard */.Zz; },
  "dd": function() { return /* reexport */ candidates_kanban/* showErrors */.dd; },
  "HW": function() { return /* reexport */ showHideButtonValue; },
  "Hk": function() { return /* reexport */ jobs_candidate_profile_job/* submitCandidateNote */.Hk; },
  "DU": function() { return /* reexport */ candidates_kanban/* syncNowHiredData */.DU; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "sO": function() { return /* reexport */ common/* useRef */.sO; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "J7": function() { return /* reexport */ dist.useTimer; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; },
  "yT": function() { return /* reexport */ validationManualform; },
  "je": function() { return /* reexport */ jobs_candidate_profile_job/* viewDetails */.je; }
});

// UNUSED EXPORTS: ArrowRight, CANDIDATE_PROFILE_INITIAL_VALUES, ChevronDownWhite, Close, CommonAction, ConfirmationModal, Daxtra, Doc, Document, EllipsisText, FontAwesomeIcon, HoverCheckbox, Link, Loading, NextServerCookies, Page, RefreshIcon, Reply, ShareCv, VideoIcon, Warning, candidateProfileValidationSchema, chevron, getSession, handleDelete, handleKeyDown, moment, performAction, previewContract, todayDate, tomorrowDate, validateForm, viewRequest

// EXTERNAL MODULE: ./src/constants/pages/clients/jobs/candidate-profile-job.js
var candidate_profile_job = __webpack_require__(78421);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./public/icons/cscore.svg
var cscore = __webpack_require__(93922);
// EXTERNAL MODULE: ./public/icons/daxtra.svg
var daxtra = __webpack_require__(54487);
// EXTERNAL MODULE: ./public/icons/like.svg
var like = __webpack_require__(96894);
// EXTERNAL MODULE: ./public/icons/dislike.svg
var dislike = __webpack_require__(86441);
// EXTERNAL MODULE: ./public/icons/verified.svg
var verified = __webpack_require__(49942);
// EXTERNAL MODULE: ./public/icons/warning.svg
var warning = __webpack_require__(51750);
// EXTERNAL MODULE: ./public/icons/chevron.png
var chevron = __webpack_require__(9906);
// EXTERNAL MODULE: ./public/new-icons/chevron-down.svg
var chevron_down = __webpack_require__(76434);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
;// CONCATENATED MODULE: ./public/new-icons/chevron-down-white.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgChevronDownWhite = function SvgChevronDownWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "scale(.8)"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m.723.829 5.88 6.74a.5.5 0 0 0 .752.002L13.272.83a.5.5 0 0 0-.376-.83H1.1a.5.5 0 0 0-.377.829Z",
    fill: "#fff"
  })));
};

/* harmony default export */ var chevron_down_white = ((/* unused pure expression or super */ null && (SvgChevronDownWhite)));
// EXTERNAL MODULE: ./public/icons/document.png
var icons_document = __webpack_require__(98745);
// EXTERNAL MODULE: ./public/icons/reply.png
var reply = __webpack_require__(32938);
// EXTERNAL MODULE: ./public/icons/arrowleft.svg
var arrowleft = __webpack_require__(65661);
// EXTERNAL MODULE: ./public/icons/arrowright.svg
var arrowright = __webpack_require__(2438);
// EXTERNAL MODULE: ./public/new-icons/arrowleft-active.svg
var arrowleft_active = __webpack_require__(73554);
// EXTERNAL MODULE: ./public/new-icons/arrowright-active.svg
var arrowright_active = __webpack_require__(24797);
// EXTERNAL MODULE: ./public/new-icons/arrowleft-disabled.svg
var arrowleft_disabled = __webpack_require__(56991);
// EXTERNAL MODULE: ./public/new-icons/arrowright-disabled.svg
var arrowright_disabled = __webpack_require__(86337);
// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(85155);
// EXTERNAL MODULE: ./public/icons/technicalkanban.svg
var technicalkanban = __webpack_require__(76075);
// EXTERNAL MODULE: ./public/icons/refresh-icon.svg
var refresh_icon = __webpack_require__(46132);
// EXTERNAL MODULE: ./public/new-icons/info-icon.svg
var info_icon = __webpack_require__(86013);
// EXTERNAL MODULE: ./public/icons/video.svg
var video = __webpack_require__(15166);
// EXTERNAL MODULE: ./public/icons/deleteicon.svg
var deleteicon = __webpack_require__(21384);
// EXTERNAL MODULE: ./public/icons/videoqa.svg
var videoqa = __webpack_require__(20226);
// EXTERNAL MODULE: ./public/icons/chevron-red-left.svg
var chevron_red_left = __webpack_require__(11676);
// EXTERNAL MODULE: ./public/icons/chevron-red-right.svg
var chevron_red_right = __webpack_require__(99295);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/candidate-profile-job.js
var jobs_candidate_profile_job = __webpack_require__(57470);
// EXTERNAL MODULE: ./src/actions/pages/clients/candidates/view-profile.js
var view_profile = __webpack_require__(15302);
// EXTERNAL MODULE: ./src/services/pages/clients/jobs/candidate-profile-job.js
var clients_jobs_candidate_profile_job = __webpack_require__(45533);
// EXTERNAL MODULE: ../../shared/node_modules/react-tabs/esm/index.js + 10 modules
var esm = __webpack_require__(42419);
// EXTERNAL MODULE: ./src/components/share-cv.js + 1 modules
var share_cv = __webpack_require__(4873);
// EXTERNAL MODULE: ../../shared/node_modules/react-pdf/dist/esm/entry.js + 22 modules
var entry = __webpack_require__(45340);
// EXTERNAL MODULE: ./src/components/progressbar.js
var progressbar = __webpack_require__(62837);
// EXTERNAL MODULE: ./src/components/setupmodel.js
var setupmodel = __webpack_require__(60737);
// EXTERNAL MODULE: ../../shared/node_modules/react-simple-tooltip/es/index.js + 11 modules
var es = __webpack_require__(54392);
// EXTERNAL MODULE: ../../shared/node_modules/react-ellipsis-text/index.js
var react_ellipsis_text = __webpack_require__(80272);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/jobs/new-edit-scorecard.js + 2 modules
var new_edit_scorecard = __webpack_require__(6967);
// EXTERNAL MODULE: ./src/components/review-email.js
var review_email = __webpack_require__(57807);
// EXTERNAL MODULE: ../../shared/node_modules/moment/moment.js
var moment = __webpack_require__(62290);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ../../shared/node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(75763);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/imports-files/components/confirmation-modal.js
var confirmation_modal = __webpack_require__(46464);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/candidates/kanban.js + 10 modules
var kanban = __webpack_require__(47942);
// EXTERNAL MODULE: ./src/components/common-modal/modal.js + 2 modules
var modal = __webpack_require__(99005);
;// CONCATENATED MODULE: ./src/components/send-offer-modal.js






function SendOfferModal(param) {
    var setBtnPopup = param.setBtnPopup, sendOfferPopup = param.sendOfferPopup, heightClass = param.heightClass, setInitialData = param.setInitialData;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        type: "confirmation",
        className: "CandidateFilterModal",
        noCloseIcon: true,
        message: "Congratulations!! You have received all the required approvals for this offer. Its time to send it to the candidate.",
        texts: {
            button1_text: "Cancel",
            button2_text: "Send Offer"
        },
        closeModal: function() {
            return setBtnPopup(false);
        },
        btnAction: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            (0,kanban/* sendOfferToCandidate */.Yn)((_tmp.id = sendOfferPopup.offer_id, _tmp.from = "application_view", _tmp.kanban = {
                                candidate_index: props.candidateIndex,
                                base_stage_id: props.paramStageId
                            }, _tmp), setBtnPopup, setInitialData)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })
    });
}

// EXTERNAL MODULE: ./src/components/iframe-google-doc.js
var iframe_google_doc = __webpack_require__(18332);
// EXTERNAL MODULE: ../../shared/node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(30711);
// EXTERNAL MODULE: ./src/components/confirmation-modal.js
var components_confirmation_modal = __webpack_require__(72055);
// EXTERNAL MODULE: ./src/styles/pages/jobs/candidate-profile-job/_index.module.scss
var _index_module = __webpack_require__(63393);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ../../shared/node_modules/react-timer-hook/dist/index.js
var dist = __webpack_require__(69107);
// EXTERNAL MODULE: ./src/actions/pages/admins/otp.js
var otp = __webpack_require__(6999);
// EXTERNAL MODULE: ./src/components/add-to-job-modal.js
var add_to_job_modal = __webpack_require__(29929);
// EXTERNAL MODULE: ./src/components/modals/single-candidate-modal.js + 1 modules
var single_candidate_modal = __webpack_require__(48151);
// EXTERNAL MODULE: ./src/components/cancel-interview.js
var cancel_interview = __webpack_require__(4725);
// EXTERNAL MODULE: ./src/styles/components/share-cv/_index.module.scss
var share_cv_index_module = __webpack_require__(2443);
var share_cv_index_module_default = /*#__PURE__*/__webpack_require__.n(share_cv_index_module);
// EXTERNAL MODULE: ./src/imports-files/components/common-modal/common-modal.js + 2 modules
var common_modal = __webpack_require__(66172);
// EXTERNAL MODULE: ../../shared/node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(73732);
;// CONCATENATED MODULE: ./src/components/cancel-reason-popup.js




function CancelReasonPopup(param) {
    var setBtnPopup = param.setBtnPopup, meetingDetails = param.meetingDetails;
    var ref;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(common_modal/* InfoModalStyle.ModalOverlay */.KD.ModalOverlay),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(common_modal/* InfoModalStyle.Modal */.KD.Modal, " ").concat((share_cv_index_module_default()).CancelReason__inner, " mw-90-xs"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(common_modal/* InfoModalStyle.Modal__Container */.KD.Modal__Container),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(common_modal/* InfoModalStyle.Modal__Container__Heading__Close */.KD.Modal__Container__Heading__Close),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "".concat(common_modal/* InfoModalStyle.Modal__Container__ContentSection__Heading */.KD.Modal__Container__ContentSection__Heading, " mt0"),
                                children: t("modal:cancelled_interview:heading")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(common_modal/* InfoModalStyle.Modal__Container__CloseSection */.KD.Modal__Container__CloseSection),
                                onClick: function() {
                                    return setBtnPopup(false);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal/* Close */.x8, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "CancelInterview ".concat(common_modal/* InfoModalStyle.Modal__Container__ContentSection */.KD.Modal__Container__ContentSection, " ").concat((share_cv_index_module_default()).CancelReason__Content, " DisplayInline"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(common_modal/* InfoModalStyle.Modal__Container__ContentSection__Block */.KD.Modal__Container__ContentSection__Block, " ").concat((share_cv_index_module_default()).CancelReason__ContentBlock, " mt30"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: "".concat(common_modal/* InfoModalStyle.Modal__Container__ContentSection__Block__Heading */.KD.Modal__Container__ContentSection__Block__Heading),
                                    children: t("modal:cancelled_interview:reason")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((share_cv_index_module_default()).SetupPopup__ContentBlock, " ").concat((share_cv_index_module_default()).CancelReason__ContentBlock),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "".concat(common_modal/* InfoModalStyle.Modal__Container__ContentSection__Point */.KD.Modal__Container__ContentSection__Point),
                                    children: (ref = meetingDetails.details) === null || ref === void 0 ? void 0 : ref.reason
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ./src/styles/components/request-for-more/_index.module.scss
var request_for_more_index_module = __webpack_require__(92626);
var request_for_more_index_module_default = /*#__PURE__*/__webpack_require__.n(request_for_more_index_module);
// EXTERNAL MODULE: ./src/styles/components/reschedule-request-modal/_index.module.scss
var reschedule_request_modal_index_module = __webpack_require__(24207);
var reschedule_request_modal_index_module_default = /*#__PURE__*/__webpack_require__.n(reschedule_request_modal_index_module);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
// EXTERNAL MODULE: ../../shared/node_modules/react-datetime/css/react-datetime.css
var react_datetime = __webpack_require__(18202);
// EXTERNAL MODULE: ./src/imports-files/pages/interviews/cronofy.js + 3 modules
var cronofy = __webpack_require__(57378);
// EXTERNAL MODULE: ./src/imports-files/components/job-filters.js + 1 modules
var job_filters = __webpack_require__(29774);
;// CONCATENATED MODULE: ./src/components/reschedule-request.js
















function RescheduleRequest(param) {
    var setBtnPopup = param.setBtnPopup, router = param.router, request = param.request, meetingDetails = param.meetingDetails, meetingId = param.meetingId, setInitialData = param.setInitialData, setShowLoader = param.setShowLoader, setFlagForRender = param.setFlagForRender;
    var validationSchema = function validationSchema(t) {
        var a = {
            start_date: cronofy/* Yup.string */.sm.string().required((0,cronofy/* TRANSLATION */.TA)("errors:required")),
            end_date: cronofy/* Yup.string */.sm.string().when("start_date", {
                is: function() {
                    return true;
                },
                then: cronofy/* Yup.string */.sm.string().required((0,cronofy/* TRANSLATION */.TA)("errors:required")).test("is-greater", (0,cronofy/* TRANSLATION */.TA)("errors:end_date_invalid"), function(value) {
                    var start_date = this.parent.start_date;
                    return moment_default()(value, "DD:MM:YYYY").isSameOrAfter(moment_default()(start_date, "DD:MM:YYYY"));
                })
            })
        };
        var RECHEDULE_REQUEST = cronofy/* Yup.object */.sm.object().shape(a);
        return RECHEDULE_REQUEST;
    };
    var requestNewSlots = function requestNewSlots() {
        document.querySelector(".new-dates-section").classList.remove("dnone");
    };
    var noOfSlotsClass = function noOfSlotsClass(no_of_slots) {
        return no_of_slots > 0 ? (request_for_more_index_module_default()).RequestDetails__AvailableSlotsBg : (request_for_more_index_module_default()).RequestDetails__NoAvailableSlotsBg;
    };
    var t = (0,common/* useTranslation */.$G)().t;
    var meeting_preference = meetingDetails.details;
    var heading = meetingDetails.status == "pending" ? t("modal:form:reschedule:request_more_slots") : t("modal:form:reschedule:reschedule_interview");
    var ref = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(0), 2), no_of_slots = ref[0], setNoOfSlots = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)("check_availability"), 2), submitState = ref1[0], setSubmitState = ref1[1];
    var showNewDates = request == "reschedule" ? "" : "dnone";
    var moreSlotsSection = request == "reschedule" ? "dnone" : "";
    var initialValues = {
        start_date: "",
        end_date: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        type: "form",
        heading: heading,
        closeModal: function(event) {
            setBtnPopup(false);
        },
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "RequestMore",
            children: [
                meeting_preference && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((request_for_more_index_module_default()).RequestDetails, " ").concat(moreSlotsSection),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                            children: [
                                t("modal:form:reschedule:heading"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                            children: [
                                t("modal:form:reschedule:subheading"),
                                ": ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: meeting_preference.preferred_date_time
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                            children: [
                                t("modal:form:reschedule:message"),
                                ": ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: meeting_preference.reason
                                })
                            ]
                        }),
                        meeting_preference.can_accept ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(info_icon/* default */.Z, {}),
                                " ",
                                t("modal:form:reschedule:slot_available")
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(info_icon/* default */.Z, {}),
                                " ",
                                t("modal:form:reschedule:slot_not_available"),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "textcenter mt20",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (request_for_more_index_module_default()).SetupPopup__RequestAccessBtn,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        buttonstyle: "".concat((request_for_more_index_module_default()).primarybtn),
                                        type: "button",
                                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            (0,jobs_candidate_profile_job/* acceptSlot */.uz)(meetingId, meeting_preference.id, setBtnPopup, router, setInitialData, setShowLoader)
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        }),
                                        children: t("modal:form:reschedule:accept_request")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        buttonstyle: "".concat((request_for_more_index_module_default()).secondarybtn),
                                        type: "button",
                                        onClick: function() {
                                            return requestNewSlots();
                                        },
                                        children: t("modal:form:reschedule:suggest_new_slots")
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "RequestDetails ".concat((request_for_more_index_module_default()).RequestDetails, " ").concat(showNewDates, " new-dates-section"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                            children: [
                                t("modal:form:reschedule:suggest"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Formik */.J9, {
                            initialValues: initialValues,
                            validationSchema: validationSchema(t),
                            onSubmit: function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(submitState == "submit")) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    (0,jobs_candidate_profile_job/* rescheduleInerview */.QV)(values, meetingId, setBtnPopup, router, setInitialData)
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 2:
                                                return [
                                                    4,
                                                    (0,jobs_candidate_profile_job/* checkAvailability */.gR)(values, meetingId, router, setNoOfSlots)
                                                ];
                                            case 3:
                                                _state.sent();
                                                _state.label = 4;
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(values) {
                                    return _ref.apply(this, arguments);
                                };
                            }(),
                            children: function(formik) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Form */.l0, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: "".concat((request_for_more_index_module_default()).ClientCompany__BodyText, " mb0"),
                                            children: [
                                                t("modal:form:reschedule:preferred_dates"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((request_for_more_index_module_default()).RequestDetails__ContentBlock, " ").concat((reschedule_request_modal_index_module_default()).RescheduleRequest__ContentBlock, " mt10"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                    control: "customDatePicker",
                                                    className: "".concat((reschedule_request_modal_index_module_default()).RescheduleRequest__JobCustomDateTime),
                                                    format: "DD/MM/YYYY",
                                                    inputProps: {
                                                        placeholder: t("placeholder:start_date"),
                                                        readOnly: true,
                                                        style: (0,common/* InputError */.pd)(formik, "start_date")
                                                    },
                                                    formik: formik,
                                                    name: "start_date",
                                                    disablePast: true,
                                                    minDate: new Date(new Date().setDate(new Date().getDate() + 1)),
                                                    onChange: function(moment) {
                                                        formik.setFieldValue("start_date", moment.format("DD/MM/YYYY"));
                                                    },
                                                    style: (0,common/* InputError */.pd)(formik, "start_date"),
                                                    value: typeof formik.values.start_date == "string" ? (0,job_filters/* setFilledDate */.vH)(formik.values.start_date) : formik.values.start_date
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                    control: "customDatePicker",
                                                    className: "".concat((reschedule_request_modal_index_module_default()).RescheduleRequest__JobCustomDateTime),
                                                    format: "DD/MM/YYYY",
                                                    inputProps: {
                                                        placeholder: t("placeholder:end_date"),
                                                        readOnly: true,
                                                        style: (0,common/* InputError */.pd)(formik, "end_date")
                                                    },
                                                    formik: formik,
                                                    name: "end_date",
                                                    onChange: function(moment) {
                                                        formik.setFieldValue("end_date", moment.format("DD/MM/YYYY"));
                                                    },
                                                    style: (0,common/* InputError */.pd)(formik, "end_date"),
                                                    disablePast: true,
                                                    minDate: new Date(new Date().setDate(new Date().getDate() + 1)),
                                                    value: typeof formik.values.end_date == "string" ? (0,job_filters/* setFilledDate */.vH)(formik.values.end_date) : formik.values.end_date
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                    buttonstyle: "".concat((request_for_more_index_module_default()).primarybtn, " ").concat((reschedule_request_modal_index_module_default()).RescheduleRequest__primarybtn),
                                                    type: "button",
                                                    onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    return [
                                                                        4,
                                                                        setSubmitState("check_availability")
                                                                    ];
                                                                case 1:
                                                                    _state.sent();
                                                                    formik.submitForm();
                                                                    return [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    }),
                                                    children: t("modal:form:reschedule:check_availability")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb20 ".concat((request_for_more_index_module_default()).RequestDetails__SlotsAvailablity, " ").concat((reschedule_request_modal_index_module_default()).RescheduleRequest__SlotsAvailablity, " "),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "".concat(noOfSlotsClass(no_of_slots)),
                                                children: [
                                                    no_of_slots,
                                                    "\xa0",
                                                    t("modal:form:reschedule:slots_available")
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((request_for_more_index_module_default()).SetupPopup__Footer, " ").concat((reschedule_request_modal_index_module_default()).RescheduleRequest__Footer),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "textcenter",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                    buttonstyle: "".concat((request_for_more_index_module_default()).secondarybtnborder),
                                                    type: "button",
                                                    onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    return [
                                                                        4,
                                                                        setSubmitState("submit")
                                                                    ];
                                                                case 1:
                                                                    _state.sent();
                                                                    formik.submitForm();
                                                                    return [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    }),
                                                    disabled: !(no_of_slots > 0),
                                                    children: t("modal:form:reschedule:send_invite")
                                                })
                                            })
                                        })
                                    ]
                                });
                            }
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/components/unsuccessfull.js
var unsuccessfull = __webpack_require__(59678);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(38641);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(18186);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4012);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var src_to_consumable_array = __webpack_require__(34817);
// EXTERNAL MODULE: ./src/styles/components/add-interview-modal/_index.module.scss
var add_interview_modal_index_module = __webpack_require__(42000);
var add_interview_modal_index_module_default = /*#__PURE__*/__webpack_require__.n(add_interview_modal_index_module);
// EXTERNAL MODULE: ./src/styles/components/automation-popup/_index.module.scss
var automation_popup_index_module = __webpack_require__(72123);
var automation_popup_index_module_default = /*#__PURE__*/__webpack_require__.n(automation_popup_index_module);
// EXTERNAL MODULE: ./public/icons/call2.svg
var call2 = __webpack_require__(67536);
// EXTERNAL MODULE: ./public/icons/technical.svg
var technical = __webpack_require__(36414);
// EXTERNAL MODULE: ./public/icons/user.svg
var user = __webpack_require__(41739);
// EXTERNAL MODULE: ../../shared/node_modules/react-select/dist/index-4bd03571.esm.js + 1 modules
var index_4bd03571_esm = __webpack_require__(28805);
// EXTERNAL MODULE: ./src/styles/components/button/_index.module.scss
var button_index_module = __webpack_require__(84215);
var button_index_module_default = /*#__PURE__*/__webpack_require__.n(button_index_module);
// EXTERNAL MODULE: ../../shared/node_modules/react-autosuggest/dist/index.js
var react_autosuggest_dist = __webpack_require__(46921);
var react_autosuggest_dist_default = /*#__PURE__*/__webpack_require__.n(react_autosuggest_dist);
// EXTERNAL MODULE: ../../shared/node_modules/react-places-autocomplete/dist/index.js
var react_places_autocomplete_dist = __webpack_require__(25538);
// EXTERNAL MODULE: ./src/components/loading.js + 1 modules
var loading = __webpack_require__(85462);
// EXTERNAL MODULE: ./public/icons/exclamation.svg
var exclamation = __webpack_require__(22461);
// EXTERNAL MODULE: ./src/imports-files/components/model/setup-video-qa.js + 3 modules
var setup_video_qa = __webpack_require__(37521);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/video-qa-action.js
var video_qa_action = __webpack_require__(47084);
// EXTERNAL MODULE: ./src/actions/pages/clients/candidates/kanban.js
var candidates_kanban = __webpack_require__(21572);
// EXTERNAL MODULE: ./public/icons/thick-plus.svg
var thick_plus = __webpack_require__(83238);
;// CONCATENATED MODULE: ./src/components/add-interview.js


































function AddInterviewManual(param) {
    var setBtnPopup = param.setBtnPopup, router = param.router, meetingData = param.meetingData, setInitialData = param.setInitialData, action = param.action, job_application_id = param.job_application_id, setFlagForRender = param.setFlagForRender, initialData = param.initialData, _from = param.from, from = _from === void 0 ? null : _from, _setAddInterviewBar = param.setAddInterviewBar, setAddInterviewBar = _setAddInterviewBar === void 0 ? null : _setAddInterviewBar, _restart = param.restart, restart = _restart === void 0 ? null : _restart, _setTimerStatus = param.setTimerStatus, setTimerStatus = _setTimerStatus === void 0 ? null : _setTimerStatus, _setUnsuccessfulEmailModal = param.setUnsuccessfulEmailModal, setUnsuccessfulEmailModal = _setUnsuccessfulEmailModal === void 0 ? null : _setUnsuccessfulEmailModal, _setEmailData = param.setEmailData, setEmailData = _setEmailData === void 0 ? null : _setEmailData, _setReviewKey = param.setReviewKey, setReviewKey = _setReviewKey === void 0 ? null : _setReviewKey;
    var interviewSwitchButton = function interviewSwitchButton(type) {
        switch(type){
            case common/* INTERVIEW_TYPES.PHONE */.BH.PHONE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(call2/* default */.Z, {});
            case common/* INTERVIEW_TYPES.TECHTEST */.BH.TECHTEST:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(technical/* default */.Z, {
                    className: "techIcon"
                });
            case common/* INTERVIEW_TYPES.VIDEO */.BH.VIDEO:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(video/* default */.Z, {});
            case common/* INTERVIEW_TYPES.FACE2FACE */.BH.FACE2FACE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(user/* default */.Z, {
                    className: "faceIcon"
                });
            case common/* INTERVIEW_TYPES.VIDEOQA */.BH.VIDEOQA:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(videoqa/* default */.Z, {
                    className: "videoQAIcon"
                });
            default:
                return "";
        }
    };
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)("range"), 2), addType = ref5[0], setAddType = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), tests = ref6[0], setTests = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)({
        value: "",
        error: ""
    }), 2), techStageEmail = ref7[0], setTechStageEmail = ref7[1];
    var videoQaAction = new video_qa_action/* VideoQaAction */.C(setTests);
    var interview_type = ((ref = meetingData.meetingDetails) === null || ref === void 0 ? void 0 : ref.interview_type_id) ? (ref1 = meetingData.interview_types.filter(function(x) {
        return x.id == meetingData.meetingDetails.interview_type_id;
    })[0]) === null || ref1 === void 0 ? void 0 : ref1.name : "";
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(interview_type), 2), current_interview_type = ref8[0], setCurrentInterviewType = ref8[1];
    var INITIAL_VALUES = manualInitialValues(meetingData === null || meetingData === void 0 ? void 0 : meetingData.meetingDetails, action || "new", job_application_id);
    INITIAL_VALUES.default_location = ((ref2 = INITIAL_VALUES.children_attributes[0]) === null || ref2 === void 0 ? void 0 : ref2.location) || meetingData.default_location;
    INITIAL_VALUES.place_id = ((ref3 = INITIAL_VALUES.children_attributes[0]) === null || ref3 === void 0 ? void 0 : ref3.place_id) || meetingData.place_id;
    var Option = index_4bd03571_esm.c.Option;
    var interviewTypes = meetingData.interview_types.filter(function(x) {
        return x.name != common/* INTERVIEW_TYPES.TECHTEST */.BH.TECHTEST;
    });
    var platforms = meetingData.platforms;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(initialStageValues(INITIAL_VALUES)), 2), stageEmail = ref9[0], setStageEmail = ref9[1];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(INITIAL_VALUES.children_attributes.length), 2), interviewStageCount = ref10[0], setInterviewStageCount = ref10[1];
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(""), 2), submitState = ref11[0], setSubmitState = ref11[1];
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), isLoading = ref12[0], setLoading = ref12[1];
    var ref13 = (0,common/* useTranslation */.$G)(), t = ref13.t, i18n = ref13.i18n;
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(INITIAL_VALUES.children_attributes.map(function(x) {
        return x.duration;
    }).reduce(function(a, b) {
        a = parseInt(a) || 0;
        b = parseInt(b) || 0;
        return a + b;
    }, 0)), 2), totalDuration = ref14[0], setTotalDuration = ref14[1];
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), users = ref15[0], setUsers = ref15[1];
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), sendInterview = ref16[0], setSendInterview = ref16[1];
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(showHideButtonValue(INITIAL_VALUES)), 2), showHideButton = ref17[0], setShowHideButton = ref17[1];
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), disabledSaveButton = ref18[0], setDisabledSaveButton = ref18[1];
    var ref19 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), deleteQuestionList = ref19[0], setDeleteQuestionList = ref19[1];
    var ref20 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), disabledAddMoreQuestion = ref20[0], setDisabledAddMoreQuestion = ref20[1];
    var addInterviewManualAction = new jobs_candidate_profile_job/* AddInterviewManualAction */.kF(setFlagForRender, deleteQuestionList, setDeleteQuestionList, setDisabledAddMoreQuestion);
    var ref21 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(addInterviewManualAction.setLanguageList((meetingData === null || meetingData === void 0 ? void 0 : (ref4 = meetingData.meetingDetails) === null || ref4 === void 0 ? void 0 : ref4.language_list) || (meetingData === null || meetingData === void 0 ? void 0 : meetingData.language_list))), 2), languageListing = ref21[0], setLanguageListing = ref21[1];
    var IconOption = function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (share_cv_index_module_default()).Selectimg,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "".concat(props.data.logo_url),
                        style: {
                            marginRight: 12,
                            width: 20,
                            height: 20,
                            verticalAlign: "middle"
                        },
                        alt: props.data.label
                    }),
                    props.data.label
                ]
            })
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(common_modal/* FormModalStyle.ModalOverlay */.w2.ModalOverlay),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(common_modal/* FormModalStyle.Modal */.w2.Modal, " AutomationPopup AddInterview"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat(common_modal/* FormModalStyle.Modal__Container */.w2.Modal__Container),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat(common_modal/* FormModalStyle.Modal__Container__Heading__Close */.w2.Modal__Container__Heading__Close),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: " ".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Heading */.w2.Modal__Container__ContentSection__Heading),
                                    children: action == "new" ? t("modal:add_interview") : t("modal:edit_interview")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(common_modal/* FormModalStyle.Modal__Container__CloseSection */.w2.Modal__Container__CloseSection),
                                    onClick: function() {
                                        return setBtnPopup({
                                            active: false,
                                            action: ""
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal/* Close */.x8, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Formik */.J9, {
                            initialValues: INITIAL_VALUES,
                            validationSchema: validationManualform(addType, current_interview_type, sendInterview, platforms),
                            onSubmit: function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(values, actions) {
                                    var _tmp, _tmp1, _tmp2, _tmp3;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(submitState == "submit")) return [
                                                    3,
                                                    9
                                                ];
                                                if (!(addType == "range")) return [
                                                    3,
                                                    2
                                                ];
                                                setLoading(true);
                                                return [
                                                    4,
                                                    (0,jobs_candidate_profile_job/* addManualInterview */.Hi)(values, router, setBtnPopup, setInitialData, setLoading, current_interview_type, setFlagForRender, setDisabledSaveButton, from)
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    3,
                                                    9
                                                ];
                                            case 2:
                                                _tmp = {};
                                                return [
                                                    4,
                                                    setAddInterviewBar((_tmp.active = true, _tmp.action = {
                                                        values: values,
                                                        router: router,
                                                        setBtnPopup: setBtnPopup,
                                                        setInitialData: setInitialData,
                                                        setLoading: setLoading,
                                                        current_interview_type: current_interview_type,
                                                        setFlagForRender: setFlagForRender,
                                                        setDisabledSaveButton: setDisabledSaveButton,
                                                        from: from
                                                    }, _tmp))
                                                ];
                                            case 3:
                                                _state.sent();
                                                return [
                                                    4,
                                                    setReviewKey("add_interview")
                                                ];
                                            case 4:
                                                _state.sent();
                                                _tmp1 = {};
                                                return [
                                                    4,
                                                    (0,candidates_kanban/* reviewAutomationEmail */.ds)(router.query.job_id, router, (_tmp1.key = "add_interview", _tmp1.list = true, _tmp1))
                                                ];
                                            case 5:
                                                return [
                                                    4,
                                                    setEmailData.apply(void 0, [
                                                        _state.sent()
                                                    ])
                                                ];
                                            case 6:
                                                _state.sent();
                                                _tmp2 = {};
                                                return [
                                                    4,
                                                    setUnsuccessfulEmailModal((_tmp2.state = true, _tmp2))
                                                ];
                                            case 7:
                                                _state.sent();
                                                _tmp3 = {};
                                                return [
                                                    4,
                                                    setBtnPopup((_tmp3.active = false, _tmp3.action = "", _tmp3))
                                                ];
                                            case 8:
                                                _state.sent();
                                                _state.label = 9;
                                            case 9:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(values, actions) {
                                    return _ref.apply(this, arguments);
                                };
                            }(),
                            children: function(formik) {
                                var ref, ref1, ref2;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(common/* Form */.l0, {
                                    style: {
                                        width: "100%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__FormContainer */.w2.Modal__Container__ContentSection__FormContainer),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "red-color",
                                                                children: "*"
                                                            }),
                                                            "\xa0",
                                                            t("modal:automation:interview:type")
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__IconContainer */.w2.Modal__Container__ContentSection__Block__IconContainer,
                                                        children: interviewTypes.map(function(x, interviewIndex) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__IconContainer__Icons */.w2.Modal__Container__ContentSection__Block__IconContainer__Icons,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
                                                                    background: "#00325A",
                                                                    radius: 50,
                                                                    padding: 11,
                                                                    placement: "top",
                                                                    fontSize: "12px",
                                                                    content: x.display_name,
                                                                    className: "SimpleTooltip",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                        className: (share_cv_index_module_default()).Interview__IconsType,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                type: "radio",
                                                                                name: "interview_type_id",
                                                                                id: "icon".concat(interviewIndex),
                                                                                defaultChecked: formik.values.interview_type_id == x.id,
                                                                                onChange: function() {
                                                                                    formik.setFieldValue("interview_type_id", x.id);
                                                                                    setCurrentInterviewType(x.name);
                                                                                    var children_attributes = formik.values.children_attributes;
                                                                                    children_attributes.map(function(x) {
                                                                                        x._destroy = true;
                                                                                        return x;
                                                                                    });
                                                                                    var _obj;
                                                                                    children_attributes.push((_obj = {
                                                                                        date: "",
                                                                                        starttime: "",
                                                                                        endtime: "",
                                                                                        location: formik.values.default_location || "",
                                                                                        place_id: formik.values.place_id || "",
                                                                                        integration_id: "",
                                                                                        members: [],
                                                                                        member_ids: []
                                                                                    }, (0,_define_property/* default */.Z)(_obj, "members", []), (0,_define_property/* default */.Z)(_obj, "duration", ""), (0,_define_property/* default */.Z)(_obj, "_destroy", false), _obj));
                                                                                    setStageEmail(initialStageValues(formik.values));
                                                                                    var durations = [];
                                                                                    setTotalDuration(durations.reduce(function(a, b) {
                                                                                        return (parseInt(a) || 0) + (parseInt(b) || 0);
                                                                                    }, 0));
                                                                                    setInterviewStageCount(1);
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "icon".concat(interviewIndex),
                                                                                className: "labelcolor",
                                                                                children: interviewSwitchButton(x.name)
                                                                            })
                                                                        ]
                                                                    })
                                                                }, x.name)
                                                            }, "interview_type_".concat(interviewIndex));
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                                        name: "interview_type_id",
                                                        errorClass: (share_cv_index_module_default()).Form__Error,
                                                        formik: formik,
                                                        style: (0,common/* InputError */.pd)(formik, "interview_type_id")
                                                    })
                                                ]
                                            }),
                                            current_interview_type == common/* INTERVIEW_TYPES.VIDEOQA */.BH.VIDEOQA ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__BlockRow */.w2.Modal__Container__ContentSection__BlockRow, " ").concat((share_cv_index_module_default()).Form__TableCol, " mt30 mb30"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading, " ").concat((share_cv_index_module_default()).Form__FloatingLabel),
                                                                style: (0,common/* InputText */.oH)(formik, "videoqa.member_emails"),
                                                                children: t("label:members")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__InputHalf */.w2.Modal__Container__ContentSection__Block__InputHalf, " "),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((react_autosuggest_dist_default()), {
                                                                        suggestions: users,
                                                                        onSuggestionsFetchRequested: function(param) {
                                                                            var value = param.value;
                                                                            return onSuggestionsFetchRequested(value, setUsers, router);
                                                                        },
                                                                        onSuggestionsClearRequested: function() {
                                                                            return setUsers([]);
                                                                        },
                                                                        getSuggestionValue: function(suggestion) {
                                                                            return "".concat(suggestion.user_attributes.email);
                                                                        },
                                                                        renderSuggestion: renderSuggestion,
                                                                        renderInputComponent: videoQaAction.renderMemberInputComponent,
                                                                        shouldRenderSuggestions: videoQaAction.shouldRenderSuggestions,
                                                                        onSuggestionSelected: function(event, param) {
                                                                            var suggestion = param.suggestion;
                                                                            if (suggestion.user_attributes.email.length > 0) {
                                                                                setTechStageEmail({
                                                                                    value: ""
                                                                                });
                                                                                videoQaAction.onSuggestionSelection(formik, formik.values.videoqa.member_emails, suggestion.user_attributes.email, formik.values.videoqa.member_initials, {
                                                                                    email: suggestion.user_attributes.email,
                                                                                    name_initials: suggestion.user_attributes.name_initials,
                                                                                    name: suggestion.user_attributes.name
                                                                                });
                                                                                formik.validateForm();
                                                                            }
                                                                        },
                                                                        inputProps: {
                                                                            className: "".concat((share_cv_index_module_default()).Form__Input, " ").concat((share_cv_index_module_default()).Form__textleft, " ").concat((share_cv_index_module_default()).Form__InputFullWidth),
                                                                            placeholder: t("placeholder:search:type_name"),
                                                                            value: techStageEmail.value,
                                                                            disabled: false,
                                                                            editable: true,
                                                                            formik: formik,
                                                                            selectedValues: (ref = formik.values.videoqa) === null || ref === void 0 ? void 0 : ref.member_initials,
                                                                            closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal/* Close */.x8, {}),
                                                                            videoQaAction: videoQaAction,
                                                                            add_button: false,
                                                                            name: "videoqa.member_emails",
                                                                            onChange: function(value, param) {
                                                                                var newValue = param.newValue, method = param.method;
                                                                                setTechStageEmail({
                                                                                    value: newValue,
                                                                                    error: ""
                                                                                });
                                                                            },
                                                                            setStageEmail: setTechStageEmail
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                                                        name: "videoqa.member_emails",
                                                                        errorClass: (share_cv_index_module_default()).Form__Error,
                                                                        formik: formik,
                                                                        style: (0,common/* InputError */.pd)(formik, "videoqa.member_emails")
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__BlockRow */.w2.Modal__Container__ContentSection__BlockRow, " ").concat((share_cv_index_module_default()).Form__TableCol, " mt15"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading, " ").concat((share_cv_index_module_default()).Form__FloatingLabel),
                                                                style: (0,common/* InputText */.oH)(formik, "language"),
                                                                children: [
                                                                    " ",
                                                                    t("modal:input:language")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                className: "".concat((share_cv_index_module_default()).Form__CustomSelect),
                                                                control: "select",
                                                                formik: formik,
                                                                name: "language",
                                                                options: languageListing,
                                                                placeholder: t("placeholder:select:language"),
                                                                style: (0,common/* InputError */.pd)(formik, "language"),
                                                                default: INITIAL_VALUES.language || "English",
                                                                onChange: function(data) {
                                                                    formik.setFieldValue("language", data.value);
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__BlockRow */.w2.Modal__Container__ContentSection__BlockRow, " ").concat((share_cv_index_module_default()).Form__TableCol, " mt30"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__TextContainer__Heading */.w2.Modal__Container__ContentSection__Block__TextContainer__Heading, " ").concat((share_cv_index_module_default()).Form__FloatingLabel),
                                                                children: [
                                                                    t("modal:input:intro_video"),
                                                                    "\xa0",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
                                                                        content: t("modal:input:optional"),
                                                                        background: "#00325A",
                                                                        radius: 20,
                                                                        padding: 8,
                                                                        placement: "right",
                                                                        fontSize: "12px",
                                                                        className: "SimpleTooltip",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "tooltipwidthinterview140",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(exclamation/* default */.Z, {})
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                className: "".concat((share_cv_index_module_default()).Form__Input, " thresholdmodl"),
                                                                control: "input",
                                                                type: "text",
                                                                formik: formik,
                                                                name: "video_link",
                                                                placeholder: setup_video_qa/* CONSTANTS.texts.placeholder_intro_video */.tl.texts.placeholder_intro_video,
                                                                style: (0,common/* InputError */.pd)(formik, "video_link")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " mt30"),
                                                        children: formik === null || formik === void 0 ? void 0 : (ref1 = formik.values) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.questions_attributes) === null || ref2 === void 0 ? void 0 : ref2.map(function(question, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: " ".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__InterviewContainer */.w2.Modal__Container__ContentSection__Block__InterviewContainer),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                                                        className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__SubHeading */.w2.Modal__Container__ContentSection__SubHeading, " ").concat((automation_popup_index_module_default()).AutomationPopup__JustifyContentBetween),
                                                                        children: [
                                                                            t("modal:input:interview_question"),
                                                                            " ",
                                                                            index + 1,
                                                                            formik.values.questions_attributes.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(deleteicon/* default */.Z, {
                                                                                className: "".concat(common_modal/* FormModalStyle.Modal__Container__IconSvg */.w2.Modal__Container__IconSvg),
                                                                                onClick: function() {
                                                                                    addInterviewManualAction.onDeleteClick(formik, index);
                                                                                }
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((share_cv_index_module_default()).Form__TableCol),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading, " ").concat((share_cv_index_module_default()).Form__FloatingLabel),
                                                                                style: (0,common/* InputText */.oH)(formik, "questions_attributes.".concat(index, ".question")),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "red-color",
                                                                                        children: "*"
                                                                                    }),
                                                                                    "\xa0",
                                                                                    t("modal:input:question")
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                                className: "".concat((share_cv_index_module_default()).Form__Input, " input600"),
                                                                                control: "input",
                                                                                type: "text",
                                                                                formik: formik,
                                                                                placeholder: t("placeholder:question"),
                                                                                name: "questions_attributes.".concat(index, ".question"),
                                                                                style: (0,common/* InputError */.pd)(formik, "questions_attributes.".concat(index, ".question")),
                                                                                onChange: function(data) {
                                                                                    formik.setFieldValue("questions_attributes.".concat(index, ".question"), data.target.value);
                                                                                    formik.status && formik.status["questions_attributes"] && formik.status["questions_attributes"][index] && formik.status["questions_attributes"][index]["question"] ? delete formik.status["questions_attributes"][index]["question"] : "";
                                                                                    formik.setStatus(formik.status);
                                                                                }
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((share_cv_index_module_default()).Form__TableCol, " mt30"),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading, " ").concat((share_cv_index_module_default()).Form__FloatingLabel),
                                                                                style: (0,common/* InputText */.oH)(formik, "questions_attributes.".concat(index, ".description")),
                                                                                children: t("modal:input:description")
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                                control: "customtextarea",
                                                                                type: "text",
                                                                                formik: formik,
                                                                                className: "".concat((share_cv_index_module_default()).Form__Textarea, " ").concat((share_cv_index_module_default()).Form__Input, " input600"),
                                                                                name: "questions_attributes.".concat(index, ".description"),
                                                                                rows: "4",
                                                                                style: (0,common/* InputError */.pd)(formik, "questions_attributes.".concat(index, ".description")),
                                                                                placeholder: t("placeholder:question")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__BlockContainer */.w2.Modal__Container__ContentSection__BlockContainer),
                                                                        style: {
                                                                            gridTemplateColumns: "auto auto"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "".concat((automation_popup_index_module_default()).AutomationPopup__FieldAuto, " ").concat((automation_popup_index_module_default()).AutomationPopup__NoRightBorderRadius, "  w50"),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__BlockContainer__BlockFlex */.w2.Modal__Container__ContentSection__BlockContainer__BlockFlex, " ").concat((share_cv_index_module_default()).Form__TableCol),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                            className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading, " ").concat((share_cv_index_module_default()).Form__FloatingLabel),
                                                                                            style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,common/* InputText */.oH)(formik, "questions_attributes.".concat(index, ".answer_time"))), {
                                                                                                whiteSpace: "nowrap"
                                                                                            }),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    className: "red-color",
                                                                                                    children: "*"
                                                                                                }),
                                                                                                "\xa0",
                                                                                                t("modal:input:time_to_answer")
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "Dpflexonly",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Field */.gN, {
                                                                                                    component: addInterviewManualAction.NumberField,
                                                                                                    defaultValue: 30,
                                                                                                    type: "text",
                                                                                                    name: "questions_attributes.".concat(index, ".answer_time"),
                                                                                                    className: "".concat((share_cv_index_module_default()).Form__Input, " ").concat((automation_popup_index_module_default()).Form__InputFocus, " width60 inputerrorheight"),
                                                                                                    formik: formik,
                                                                                                    format: "###",
                                                                                                    style: (0,common/* InputError */.pd)(formik, "questions_attributes.".concat(index, ".answer_time")),
                                                                                                    onValueChange: function(value) {
                                                                                                        formik.setFieldValue("questions_attributes.".concat(index, ".answer_time"), value.floatValue);
                                                                                                        formik.status && formik.status["questions_attributes"] && formik.status["questions_attributes"][index] && formik.status["questions_attributes"][index]["answer_time"] ? delete formik.status["questions_attributes"][index]["answer_time"] : "";
                                                                                                        formik.setStatus(formik.status);
                                                                                                    }
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__Seconds, " ").concat((share_cv_index_module_default()).Form__currency_symbol, " ").concat((share_cv_index_module_default()).Form__currency_symbol__right),
                                                                                                    style: (0,common/* InputError */.pd)(formik, "questions_attributes.".concat(index, ".answer_time")),
                                                                                                    children: t("modal:input:sec")
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                                                                                    name: "questions_attributes.".concat(index, ".answer_time"),
                                                                                                    errorClass: (share_cv_index_module_default()).Form__Error,
                                                                                                    formik: formik,
                                                                                                    style: (0,common/* InputError */.pd)(formik, "questions_attributes.".concat(index, ".answer_time"))
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "".concat((automation_popup_index_module_default()).AutomationPopup__Time, " ").concat((share_cv_index_module_default()).Form__TableCol, " Dpflexonly AlignBaseline JustifyEnd wauto"),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "".concat((automation_popup_index_module_default()).AutomationPopup__Time, " ").concat((share_cv_index_module_default()).Form__TableCol, " Dpflexonly AlignBaseline JustifyEnd wauto"),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                            className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading, " ").concat((share_cv_index_module_default()).Form__FloatingLabel),
                                                                                            style: (0,common/* InputText */.oH)(formik, "questions_attributes.".concat(index, ".attempts")),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    className: "red-color",
                                                                                                    children: "*"
                                                                                                }),
                                                                                                "\xa0 ",
                                                                                                t("modal:input:attempts:number"),
                                                                                                "\xa0",
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
                                                                                                    content: t("modal:input:attempts:max"),
                                                                                                    background: "#203040",
                                                                                                    radius: 4,
                                                                                                    padding: 8,
                                                                                                    placement: "right",
                                                                                                    fontSize: "12px",
                                                                                                    className: "SimpleTooltip",
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                        className: "tooltipwidthinterview140",
                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(exclamation/* default */.Z, {})
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "".concat((automation_popup_index_module_default()).AutomationPopup__Attempts__Number),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Field */.gN, {
                                                                                                    component: addInterviewManualAction.NumberField,
                                                                                                    defaultValue: 2,
                                                                                                    type: "text",
                                                                                                    name: "questions_attributes.".concat(index, ".attempts"),
                                                                                                    className: "".concat((share_cv_index_module_default()).Form__Input, " ").concat((automation_popup_index_module_default()).Form__InputFocus, " width100 inputerrorheight text-center"),
                                                                                                    formik: formik,
                                                                                                    format: "#",
                                                                                                    onValueChange: function(value) {
                                                                                                        formik.setFieldValue("questions_attributes.".concat(index, ".attempts"), value.floatValue);
                                                                                                        formik.status && formik.status["questions_attributes"] && formik.status["questions_attributes"][index] && formik.status["questions_attributes"][index]["attempts"] ? delete formik.status["questions_attributes"][index]["attempts"] : "";
                                                                                                        formik.setStatus(formik.status);
                                                                                                    },
                                                                                                    style: (0,common/* InputError */.pd)(formik, "questions_attributes.".concat(index, ".attempts"))
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                                                                                    name: "questions_attributes.".concat(index, ".attempts"),
                                                                                                    errorClass: (share_cv_index_module_default()).Form__Error,
                                                                                                    formik: formik,
                                                                                                    style: (0,common/* InputError */.pd)(formik, "questions_attributes.".concat(index, ".attempts"))
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }, "question_key_".concat(index));
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((share_cv_index_module_default()).SetupPopup__AddQuestion, " ").concat((share_cv_index_module_default()).mt15),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_button/* default */.Z, {
                                                            buttonstyle: "".concat((button_index_module_default()).iconTextButton),
                                                            type: "button",
                                                            disabled: disabledAddMoreQuestion,
                                                            onClick: function() {
                                                                return addInterviewManualAction.onAddClick(formik);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(thick_plus/* default */.Z, {}),
                                                                t("button:add:question")
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: " ".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " mt30"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                className: " ".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__InterviewContainer__Label */.w2.Modal__Container__ContentSection__Block__InterviewContainer__Label, " ").concat((automation_popup_index_module_default()).AutomationPopup__Customisation),
                                                                children: t("modal:automation:customisations")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "Dpflex",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "".concat((share_cv_index_module_default()).SetupPopup__ContentCustomisation, " ").concat((automation_popup_index_module_default()).AutomationPopup__PracticeScreen, " ").concat((share_cv_index_module_default()).SetupPopup__AddInterviewCustomisation),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "thresholdmodl ".concat((automation_popup_index_module_default()).AutomationPopup__SetupVideoQa3),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                                                    className: "Dpflexonly",
                                                                                    style: {
                                                                                        margin: "0"
                                                                                    },
                                                                                    children: [
                                                                                        t("modal:input:practice_screen"),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "".concat((share_cv_index_module_default()).Interview__BestMatchExclamation, " ").concat((automation_popup_index_module_default()).AutomationPopup__PracticeExclamation),
                                                                                            style: {
                                                                                                marginLeft: "10px"
                                                                                            },
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
                                                                                                content: "Practice Screen",
                                                                                                background: "#00325A",
                                                                                                radius: 20,
                                                                                                padding: 8,
                                                                                                placement: "right",
                                                                                                fontSize: "12px",
                                                                                                className: "SimpleTooltip",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "tooltipwidthinterview140",
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(info_icon/* default */.Z, {})
                                                                                                })
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                    className: (share_cv_index_module_default()).IntegrationTable__switch,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                            type: "checkbox",
                                                                                            defaultChecked: INITIAL_VALUES.practise_screen,
                                                                                            onChange: function(event) {
                                                                                                formik.setFieldValue("practise_screen", event.target.checked);
                                                                                            }
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "".concat((share_cv_index_module_default()).IntegrationTable__slider, " ").concat((share_cv_index_module_default()).IntegrationTable__round, " width44 automationslider automationround")
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "".concat((share_cv_index_module_default()).SetupPopup__ContentCustomisation, " ").concat((share_cv_index_module_default()).SetupPopup__PushTop, " ").concat((share_cv_index_module_default()).SetupPopup__SetupVideoQa4, " ").concat((automation_popup_index_module_default()).AutomationPopup__SetupVideoQa4, " ").concat((share_cv_index_module_default()).Form__TableCol),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                className: "Dpflexonly AlignBaseline ".concat((share_cv_index_module_default()).mb15, " ").concat((share_cv_index_module_default()).Form__FloatingLabel, " mr10"),
                                                                                style: (0,common/* InputText */.oH)(formik, "expires"),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "red-color",
                                                                                        children: "*"
                                                                                    }),
                                                                                    t("modal:input:expires")
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "".concat((automation_popup_index_module_default()).AutomationPopup__FieldAuto, " ").concat((automation_popup_index_module_default()).AutomationPopup__NoRightBorderRadius, " w50"),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "".concat((automation_popup_index_module_default()).AutomationPopup__NoRightBorderRadius, " Dpflexonly"),
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Field */.gN, {
                                                                                                component: addInterviewManualAction.NumberField,
                                                                                                placeholder: "2",
                                                                                                type: "text",
                                                                                                name: "expires",
                                                                                                className: "".concat((share_cv_index_module_default()).Form__Input, " ").concat((automation_popup_index_module_default()).Form__InputFocus, " thresholdmodl width70"),
                                                                                                formik: formik,
                                                                                                format: "###",
                                                                                                style: (0,common/* InputError */.pd)(formik, "expires"),
                                                                                                onValueChange: function(value) {
                                                                                                    formik.setFieldValue("expires", value.floatValue);
                                                                                                    formik.setStatus["expires"] = "";
                                                                                                }
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                className: "".concat((automation_popup_index_module_default()).AutomationPopup__Seconds, " ").concat((share_cv_index_module_default()).Form__currency_symbol, " ").concat((share_cv_index_module_default()).Form__currency_symbol__right, " ml0"),
                                                                                                style: (0,common/* InputError */.pd)(formik, "expires"),
                                                                                                children: t("modal:input:days")
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                                                                        name: "expires",
                                                                                        errorClass: (share_cv_index_module_default()).Form__Error,
                                                                                        formik: formik,
                                                                                        style: (0,common/* InputError */.pd)(formik, "expires")
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    current_interview_type == common/* INTERVIEW_TYPES.FACE2FACE */.BH.FACE2FACE && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: " ".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((share_cv_index_module_default()).Form__TableCol, " mt30"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                className: " ".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading, " ").concat((share_cv_index_module_default()).Form__FloatingLabel),
                                                                style: (0,common/* InputText */.oH)(formik, "default_location"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "red-color",
                                                                        children: "*"
                                                                    }),
                                                                    "\xa0",
                                                                    t("modal:input:location")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_places_autocomplete_dist/* default */.ZP, {
                                                                value: formik.values.default_location,
                                                                onChange: function(value) {
                                                                    formik.setFieldValue("default_location", value);
                                                                    formik.setFieldValue("place_id", "");
                                                                    formik.values.children_attributes.map(function(x) {
                                                                        x.location = value;
                                                                        x.place_id = "";
                                                                        return x;
                                                                    });
                                                                },
                                                                onSelect: function(address, placeId, suggestion) {
                                                                    formik.setFieldValue("default_location", address);
                                                                    formik.setFieldValue("place_id", placeId);
                                                                    formik.values.children_attributes.map(function(x) {
                                                                        x.location = address;
                                                                        x.place_id = placeId;
                                                                        return x;
                                                                    });
                                                                },
                                                                shouldFetchSuggestions: formik.values.default_location.length >= 3,
                                                                children: function(param) {
                                                                    var getInputProps = param.getInputProps, getSuggestionItemProps = param.getSuggestionItemProps, suggestions = param.suggestions, loading = param.loading;
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "autocomplete-root",
                                                                        style: {
                                                                            maxWidth: "50%"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                className: (share_cv_index_module_default()).Form__Input,
                                                                                name: "default_location",
                                                                                placeholder: t("placeholder:eg:london"),
                                                                                style: (0,common/* InputError */.pd)(formik, "default_location")
                                                                            }, getInputProps({}))),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "autocomplete-dropdown-container",
                                                                                children: [
                                                                                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        children: t("loading")
                                                                                    }),
                                                                                    suggestions.map(function(suggestion) {
                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getSuggestionItemProps(suggestion)), {
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                children: suggestion.description
                                                                                            }, suggestion.id)
                                                                                        }), suggestion.placeId);
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    });
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                                                name: "default_location",
                                                                errorClass: (share_cv_index_module_default()).Form__Error,
                                                                formik: formik,
                                                                style: (0,common/* InputError */.pd)(formik, "default_location"),
                                                                custom_error_90: "custom_error_90"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FieldArray */.F2, {
                                                        className: "w-auto",
                                                        name: "children_attributes",
                                                        render: function(arrayHelpers) {
                                                            return formik.values.children_attributes.map(function(item, index) {
                                                                return !item._destroy && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((share_cv_index_module_default()).SetupPopup__ContentAddInterview, " dnone ").concat((automation_popup_index_module_default()).AutomationPopup__FlexFlow, " mt30"),
                                                                    children: [
                                                                        current_interview_type == common/* INTERVIEW_TYPES.VIDEO */.BH.VIDEO && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((share_cv_index_module_default()).Form__TableCol, " ").concat(common_modal/* FormModalStyle.Modal__Container__TableCol__Wauto */.w2.Modal__Container__TableCol__Wauto, " wauto mt0 mb30"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                    className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading, " ").concat((share_cv_index_module_default()).Form__FloatingLabel),
                                                                                    style: (0,common/* InputText */.oH)(formik, "children_attributes.".concat(index, ".integration_id")),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "red-color",
                                                                                            children: "*"
                                                                                        }),
                                                                                        "\xa0",
                                                                                        t("modal:input:video_platform")
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    style: {
                                                                                        width: "120px"
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                                        className: "".concat((share_cv_index_module_default()).Form__CustomSelect),
                                                                                        control: "select",
                                                                                        formik: formik,
                                                                                        placeholder: t("placeholder:select:default"),
                                                                                        options: platforms,
                                                                                        components: {
                                                                                            Option: IconOption
                                                                                        },
                                                                                        onChange: function(option) {
                                                                                            formik.setFieldValue("children_attributes.".concat(index, ".integration_id"), option.value);
                                                                                            if (option.label.toString() != "Custom Link") formik.setFieldValue("children_attributes.".concat(index, ".meeting_link"), "");
                                                                                        },
                                                                                        default: formik.values.children_attributes[index].integration_id,
                                                                                        name: "children_attributes.".concat(index, ".integration_id"),
                                                                                        custom_class: "form_custom_error",
                                                                                        style: (0,common/* InputError */.pd)(formik, "children_attributes.".concat(index, ".integration_id"))
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__GridColumn */.w2.Modal__Container__ContentSection__GridColumn, " ").concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__CustomWidth */.w2.Modal__Container__ContentSection__CustomWidth),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((share_cv_index_module_default()).Form__TableCol, " mt0"),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                            className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading, " ").concat((share_cv_index_module_default()).Form__FloatingLabel),
                                                                                            style: (0,common/* InputText */.oH)(formik, "children_attributes.".concat(index, ".member_ids")),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    className: "red-color",
                                                                                                    children: "*"
                                                                                                }),
                                                                                                "\xa0",
                                                                                                t("label:members")
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((react_autosuggest_dist_default()), {
                                                                                            suggestions: users,
                                                                                            onSuggestionsFetchRequested: function(param) {
                                                                                                var value = param.value;
                                                                                                return onSuggestionsFetchRequested(value, setUsers, router);
                                                                                            },
                                                                                            onSuggestionsClearRequested: function() {
                                                                                                return setUsers([]);
                                                                                            },
                                                                                            getSuggestionValue: function(suggestion) {
                                                                                                return "".concat(suggestion.user_attributes.email);
                                                                                            },
                                                                                            renderSuggestion: renderSuggestion,
                                                                                            renderInputComponent: renderInputComponent,
                                                                                            shouldRenderSuggestions: shouldRenderSuggestions,
                                                                                            onSuggestionSelected: function(event, param) {
                                                                                                var suggestion = param.suggestion;
                                                                                                if (suggestion.user_attributes.email.length > 0) {
                                                                                                    stageEmail[index] = {
                                                                                                        value: ""
                                                                                                    };
                                                                                                    setStageEmail((0,src_to_consumable_array/* default */.Z)(stageEmail));
                                                                                                    onSuggestionSelection(formik.values.children_attributes[index].member_ids, suggestion.user_attributes.id, formik.values.children_attributes[index].members, {
                                                                                                        email: suggestion.user_attributes.email,
                                                                                                        name_initials: suggestion.user_attributes.name_initials,
                                                                                                        name: suggestion.user_attributes.name,
                                                                                                        photo_url: suggestion.user_attributes.photo_url
                                                                                                    });
                                                                                                    formik.validateForm();
                                                                                                }
                                                                                            },
                                                                                            inputProps: {
                                                                                                className: "".concat((share_cv_index_module_default()).Form__Input, " width300"),
                                                                                                placeholder: t("placeholder:search:type_name"),
                                                                                                value: stageEmail[index].value,
                                                                                                index: index,
                                                                                                formik: formik,
                                                                                                styleError: (0,common/* InputError */.pd)(formik, "children_attributes.".concat(index, ".member_ids")),
                                                                                                selectedValues: formik.values.children_attributes[index].members,
                                                                                                closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal/* Close */.x8, {}),
                                                                                                disabled: false,
                                                                                                editable: true,
                                                                                                name: "children_attributes.".concat(index, ".member_ids"),
                                                                                                onChange: function(value, param) {
                                                                                                    var newValue = param.newValue, method = param.method;
                                                                                                    stageEmail[index] = {
                                                                                                        value: newValue
                                                                                                    };
                                                                                                    setStageEmail((0,src_to_consumable_array/* default */.Z)(stageEmail));
                                                                                                },
                                                                                                stageEmail: stageEmail,
                                                                                                setStageEmail: setStageEmail
                                                                                            },
                                                                                            custom_class: "form_custom_error"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* AutocompleteError */.PG, {
                                                                                            name: "children_attributes.".concat(index, ".member_ids"),
                                                                                            errorClass: (share_cv_index_module_default()).Form__Error,
                                                                                            formik: formik,
                                                                                            style: (0,common/* InputError */.pd)(formik, "children_attributes.".concat(index, ".member_ids")),
                                                                                            custom_class: "form_custom_error"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((share_cv_index_module_default()).Form__TableCol, " width48 mt0"),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                            className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading, " ").concat((share_cv_index_module_default()).Form__FloatingLabel),
                                                                                            style: (0,common/* InputText */.oH)(formik, "children_attributes.".concat(index, ".duration")),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    className: "red-color",
                                                                                                    children: "*"
                                                                                                }),
                                                                                                "\xa0",
                                                                                                t("modal:input:duration"),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                                    children: [
                                                                                                        "(",
                                                                                                        t("modal:input:mins"),
                                                                                                        ")"
                                                                                                    ]
                                                                                                }),
                                                                                                " "
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                                            className: "".concat((share_cv_index_module_default()).Form__Input, "  width100"),
                                                                                            control: "input",
                                                                                            type: "text",
                                                                                            autocomplete: "off",
                                                                                            placeholder: t("placeholder:eg:15"),
                                                                                            formik: formik,
                                                                                            maxLength: 3,
                                                                                            custom_class: "form_custom_error",
                                                                                            name: "children_attributes.".concat(index, ".duration"),
                                                                                            value: formik.values.children_attributes[index].duration,
                                                                                            onChange: function(evt) {
                                                                                                var new_value = isNaN(evt.target.value) ? "" : parseInt(evt.target.value) == 0 ? "" : evt.target.value;
                                                                                                formik.setFieldValue("children_attributes.".concat(index, ".duration"), new_value);
                                                                                                var durations = [];
                                                                                                formik.values.children_attributes.map(function(x, itemIndex) {
                                                                                                    if (!x._destroy) {
                                                                                                        if (itemIndex == index) {
                                                                                                            durations.push(new_value);
                                                                                                        } else {
                                                                                                            durations.push(parseInt(x.duration) || 0);
                                                                                                        }
                                                                                                    } else {
                                                                                                        durations.push(0);
                                                                                                    }
                                                                                                    return x;
                                                                                                });
                                                                                                formik.setFieldValue("children_attributes.".concat(index, ".endtime"), addMinutes(formik.values.children_attributes[index].starttime, new_value));
                                                                                                durations[index] = new_value;
                                                                                                setTotalDuration(durations.reduce(function(a, b) {
                                                                                                    return (parseInt(a) || 0) + (parseInt(b) || 0);
                                                                                                }, 0));
                                                                                                var children_attributes = formik.values.children_attributes;
                                                                                            },
                                                                                            style: (0,common/* InputError */.pd)(formik, "children_attributes.".concat(index, ".duration"))
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        current_interview_type == common/* INTERVIEW_TYPES.VIDEO */.BH.VIDEO && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((share_cv_index_module_default()).Form__TableCol, " width250 mt15 ").concat(isCustomLink(platforms, formik.values.children_attributes[index].integration_id) ? "".concat((share_cv_index_module_default()).Form__TableCol__Disabled) : ""),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                    className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__Heading */.w2.Modal__Container__ContentSection__Block__Heading, " ").concat((share_cv_index_module_default()).Form__FloatingLabel),
                                                                                    children: [
                                                                                        t("modal:input:meeting_link"),
                                                                                        isCustomLink(platforms, formik.values.children_attributes[index].integration_id) ? "" : "*"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                                    className: "".concat((share_cv_index_module_default()).Form__Input, "  width250"),
                                                                                    control: "input",
                                                                                    type: "text",
                                                                                    autocomplete: "off",
                                                                                    placeholder: "",
                                                                                    formik: formik,
                                                                                    name: "children_attributes.".concat(index, ".meeting_link"),
                                                                                    value: formik.values.children_attributes[index].meeting_link,
                                                                                    style: (0,common/* InputError */.pd)(formik, "children_attributes.".concat(index, ".meeting_link")),
                                                                                    disabled: isCustomLink(platforms, formik.values.children_attributes[index].integration_id),
                                                                                    custom_class: "form_custom_error"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: " ".concat((share_cv_index_module_default()).crossimgheight, " ").concat((automation_popup_index_module_default()).AutomationPopup__DeleteIcon),
                                                                            children: interviewStageCount != 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                src: "/icons/close.png",
                                                                                alt: "",
                                                                                className: "mt50",
                                                                                onClick: function() {
                                                                                    return onAutomationChange(formik, "remove", index, setStageEmail, setInterviewStageCount, setTotalDuration, current_interview_type, setShowHideButton);
                                                                                }
                                                                            })
                                                                        })
                                                                    ]
                                                                }, "interview_round_".concat(index));
                                                            });
                                                        }
                                                    }),
                                                    formik.values.interview_type_id && current_interview_type != common/* INTERVIEW_TYPES.PHONE */.BH.PHONE && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "dnone ".concat((share_cv_index_module_default()).addbtnposition, " mt25 mb45"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: formik.values.interview_type_id && current_interview_type != common/* INTERVIEW_TYPES.PHONE */.BH.PHONE && showHideButton && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_button/* default */.Z, {
                                                                buttonstyle: "".concat((button_index_module_default()).iconTextButton),
                                                                type: "button",
                                                                onClick: function() {
                                                                    onAutomationChange(formik, "add", undefined, setStageEmail, setInterviewStageCount, setTotalDuration, current_interview_type, setShowHideButton);
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(thick_plus/* default */.Z, {}),
                                                                    t("button:add:interview")
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    current_interview_type != "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "mt30",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "d-flex justify-content-between align-items-center mt20",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "WrapperRadio w100",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                            className: "Dpflex WrapperRadioContainer WrapperRadiocheckmarkfont mb0",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Field */.gN, {
                                                                                    type: "radio",
                                                                                    name: "date_range",
                                                                                    id: "option-1",
                                                                                    value: true,
                                                                                    onChange: function(event) {
                                                                                        formik.setFieldValue("date_range", true);
                                                                                        var children_attributes = formik.values.children_attributes;
                                                                                        children_attributes.map(function(x) {
                                                                                            x.start_time = "";
                                                                                            x.end_time = "";
                                                                                            return x;
                                                                                        });
                                                                                        setAddType("range");
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "WrapperRadiocheckmark"
                                                                                }),
                                                                                " ",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "ml10 mt-0",
                                                                                    children: t("modal:automation:candidate_availability")
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                            className: "Dpflex WrapperRadioContainer WrapperRadiocheckmarkfont mb0",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Field */.gN, {
                                                                                    type: "radio",
                                                                                    name: "date_range",
                                                                                    id: "option-2",
                                                                                    value: false,
                                                                                    onChange: function(event) {
                                                                                        formik.setFieldValue("date_range", false);
                                                                                        var children_attributes = formik.values.children_attributes;
                                                                                        children_attributes.map(function(x) {
                                                                                            x.start_time = "";
                                                                                            x.end_time = "";
                                                                                            return x;
                                                                                        });
                                                                                        setAddType("time");
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "WrapperRadiocheckmark"
                                                                                }),
                                                                                " ",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "ml10",
                                                                                    children: t("modal:input:select_date_time")
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            addType == "range" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "heightauto"
                                                            }),
                                                            !formik.values.date_range && /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FieldArray */.F2, {
                                                                name: "children_attributes",
                                                                render: function(arrayHelpers) {
                                                                    return formik.values.children_attributes.map(function(item, index) {
                                                                        return !item._destroy && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "".concat((share_cv_index_module_default()).SetupPopup__ContentAddInterview, " ").concat((add_interview_modal_index_module_default()).AddInterview__ContentAddInterview),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "".concat((share_cv_index_module_default()).SetupPopup__ContentFlex, " ").concat((share_cv_index_module_default()).Form__TableCol, " width145"),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                            className: "".concat((share_cv_index_module_default()).Form__FloatingLabel, " mb0"),
                                                                                            style: (0,common/* InputText */.oH)(formik, "children_attributes.".concat(index, ".date")),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    className: "red-color",
                                                                                                    children: "*"
                                                                                                }),
                                                                                                "\xa0",
                                                                                                t("modal:input:interview_date"),
                                                                                                " "
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                                            control: "customKeyboardPicker",
                                                                                            className: "JobCustomDateTime",
                                                                                            format: "DD/MM/YYYY",
                                                                                            inputProps: {
                                                                                                readOnly: false,
                                                                                                style: (0,common/* InputError */.pd)(formik, "children_attributes.".concat(index, ".date"))
                                                                                            },
                                                                                            minDate: new Date(new Date().setDate(new Date().getDate())),
                                                                                            minDateMessage: "Interview date must be present or future date",
                                                                                            disablePast: true,
                                                                                            placeholder: "dd/mm/yyyy",
                                                                                            name: "children_attributes.".concat(index, ".date"),
                                                                                            onChange: function() {
                                                                                                var _ref = (0,_async_to_generator/* default */.Z)(function(date) {
                                                                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                                                                        switch(_state.label){
                                                                                                            case 0:
                                                                                                                return [
                                                                                                                    4,
                                                                                                                    formik.setFieldValue("children_attributes.".concat(index, ".date"), date.format("DD/MM/YYYY"))
                                                                                                                ];
                                                                                                            case 1:
                                                                                                                _state.sent();
                                                                                                                return [
                                                                                                                    2
                                                                                                                ];
                                                                                                        }
                                                                                                    });
                                                                                                });
                                                                                                return function(date) {
                                                                                                    return _ref.apply(this, arguments);
                                                                                                };
                                                                                            }(),
                                                                                            formik: formik,
                                                                                            custom_class: "form_custom_error",
                                                                                            value: typeof formik.values.children_attributes[index].date == "string" ? (0,job_filters/* setFilledDate */.vH)(formik.values.children_attributes[index].date) : formik.values.children_attributes[index].date
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "".concat((share_cv_index_module_default()).SetupPopup__ContentFlex, " ").concat((share_cv_index_module_default()).Form__TableCol, " mt0 Timebg"),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                            className: "".concat((share_cv_index_module_default()).Form__FloatingLabel, " mb0"),
                                                                                            style: (0,common/* InputText */.oH)(formik, "children_attributes.".concat(index, ".starttime")),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    className: "red-color",
                                                                                                    children: "*"
                                                                                                }),
                                                                                                "\xa0",
                                                                                                t("time:start")
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                                            control: "timeinput",
                                                                                            disabled: false,
                                                                                            value: formik.values.children_attributes[index].starttime,
                                                                                            fullTimeDropdown: true,
                                                                                            allowDelete: true,
                                                                                            hour12Format: false,
                                                                                            onChange: function(dateString) {
                                                                                                formik.setFieldValue("children_attributes.".concat(index, ".starttime"), dateString);
                                                                                                formik.setFieldValue("children_attributes.".concat(index, ".endtime"), addMinutes(dateString, formik.values.children_attributes[index].duration));
                                                                                            },
                                                                                            inputProps: {
                                                                                                style: (0,common/* InputError */.pd)(formik, "children_attributes.".concat(index, ".starttime"))
                                                                                            },
                                                                                            errorClass: (share_cv_index_module_default()).Form__Error,
                                                                                            name: "children_attributes.".concat(index, ".starttime"),
                                                                                            formik: formik,
                                                                                            custom_class: "form_custom_error",
                                                                                            manuallyDisplayDropdown: true
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                " ",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "".concat((share_cv_index_module_default()).SetupPopup__ContentFlex, " ").concat((share_cv_index_module_default()).Form__TableCol, " ").concat((share_cv_index_module_default()).Form__TableCol__Disabled, " DisabledInput mt0 Timebg"),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                            className: "".concat((share_cv_index_module_default()).Form__FloatingLabel),
                                                                                            style: (0,common/* InputText */.oH)(formik, "children_attributes.".concat(index, ".endtime")),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    className: "red-color",
                                                                                                    children: "*"
                                                                                                }),
                                                                                                "\xa0",
                                                                                                t("time:end")
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                                            control: "timeinput",
                                                                                            disabled: true,
                                                                                            value: formik.values.children_attributes[index].endtime,
                                                                                            fullTimeDropdown: false,
                                                                                            allowDelete: true,
                                                                                            hour12Format: false,
                                                                                            onChange: function(dateString) {
                                                                                                formik.setFieldValue("children_attributes.".concat(index, ".endtime"), dateString);
                                                                                            },
                                                                                            inputProps: {
                                                                                                style: (0,common/* InputError */.pd)(formik, "children_attributes.".concat(index, ".endtime"))
                                                                                            },
                                                                                            errorClass: (share_cv_index_module_default()).Form__Error,
                                                                                            name: "children_attributes.".concat(index, ".endtime"),
                                                                                            formik: formik,
                                                                                            custom_class: "form_custom_error",
                                                                                            manuallyDisplayDropdown: true
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }, "interview_round_".concat(index));
                                                                    });
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            addType == "time" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "heightauto"
                                            }),
                                            formik.values.interview_type_id && current_interview_type != common/* INTERVIEW_TYPES.VIDEOQA */.BH.VIDEOQA && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w100",
                                                children: formik.values.interview_type_id && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((share_cv_index_module_default()).SetupPopup__Duration, " ").concat((automation_popup_index_module_default()).AutomationPopup__TotalDuration, " m0 mt30"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            children: t("time:total_duration")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                totalDuration,
                                                                " ",
                                                                t("time:mins")
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: common_modal/* FormModalStyle.Modal__Container__ButtonSection */.w2.Modal__Container__ButtonSection,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                    buttonstyle: "".concat((button_index_module_default()).primarybtn),
                                                    type: "button",
                                                    disabled: disabledSaveButton,
                                                    onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    setSendInterview(true);
                                                                    return [
                                                                        4,
                                                                        setSubmitState("submit")
                                                                    ];
                                                                case 1:
                                                                    _state.sent();
                                                                    formik.submitForm();
                                                                    return [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    }),
                                                    children: addType == "time" ? t("button:review_send") : t("button:send")
                                                })
                                            })
                                        ]
                                    })
                                });
                            }
                        })
                    ]
                })
            }),
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(loading/* Loading */.g, {})
        ]
    });
}

// EXTERNAL MODULE: ./src/actions/common/common.js
var common_common = __webpack_require__(1739);
;// CONCATENATED MODULE: ./src/components/schedule-details.js





function ScheduleDetails(param) {
    var setBtnPopup = param.setBtnPopup, meetingDetails = param.meetingDetails;
    var commonAction = new common_common/* CommonAction */.x();
    var t = (0,common/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(common_modal/* InfoModalStyle.ModalOverlay */.KD.ModalOverlay),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(common_modal/* InfoModalStyle.Modal */.KD.Modal),
            style: {
                minHeight: "auto"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(common_modal/* InfoModalStyle.Modal__Container */.KD.Modal__Container),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(common_modal/* InfoModalStyle.Modal__Container__Heading__Close */.KD.Modal__Container__Heading__Close),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "".concat(common_modal/* InfoModalStyle.Modal__Container__ContentSection__Heading */.KD.Modal__Container__ContentSection__Heading),
                                children: t("modal:form:import:previous_job:interview_details")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(common_modal/* InfoModalStyle.Modal__Container__CloseSection */.KD.Modal__Container__CloseSection),
                                onClick: function() {
                                    return setBtnPopup(false);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal/* Close */.x8, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(common_modal/* InfoModalStyle.Modal__Container__ContentSection */.KD.Modal__Container__ContentSection, " mt20"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                className: "".concat(common_modal/* InfoModalStyle.Modal__Container__ContentSection__Description */.KD.Modal__Container__ContentSection__Description),
                                style: {
                                    height: "auto"
                                },
                                children: meetingDetails.details.message
                            }),
                            meetingDetails.details.round_details.map(function(round, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                    className: "".concat(common_modal/* InfoModalStyle.Modal__Container__ContentSection__Description */.KD.Modal__Container__ContentSection__Description),
                                    style: {
                                        height: "auto"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                            children: [
                                                t("label:round"),
                                                " ",
                                                index + 1,
                                                " "
                                            ]
                                        }),
                                        " ",
                                        round.time,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: t("label:with")
                                        }),
                                        " ",
                                        round.member_names,
                                        ".",
                                        " ",
                                        round.meeting_link && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: commonAction.embedHttps(round.meeting_link),
                                            target: "_blank",
                                            style: {
                                                textDecoration: "underline"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: "Meeting Link"
                                            })
                                        })
                                    ]
                                });
                            })
                        ]
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/reschedule-details.js




function RescheduleDetails(param) {
    var meetingId = param.meetingId, setBtnPopup = param.setBtnPopup, meetingDetails = param.meetingDetails;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        type: "info",
        closeModal: function() {
            return setBtnPopup(false);
        },
        heading: t("modal:reschedule_details"),
        className: "RequestMore mt20",
        innerContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (request_for_more_index_module_default()).RequestDetails,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: t("modal:info:reschedule:request")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                        className: (request_for_more_index_module_default()).RequestDetails__gridauto,
                        children: [
                            t("label:duration"),
                            ": ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    meetingDetails.details.duration,
                                    " "
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/unsuccessful-email-modal.js + 1 modules
var unsuccessful_email_modal = __webpack_require__(38678);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/candidates/add-offer.js
var add_offer = __webpack_require__(23746);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/jobs/custom-tech-test-modal.js
var custom_tech_test_modal = __webpack_require__(23908);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/common.js
var jobs_common = __webpack_require__(90432);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/jobs/automations.js + 3 modules
var jobs_automations = __webpack_require__(64335);
;// CONCATENATED MODULE: ./src/actions/components/add-interview.js








var MAX_ALLOWED_RECORDS = 5;
var renderInputComponent = function(inputProps) {
    var ref;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "buttonIn AutoSuggestInput__Tags",
        style: inputProps.styleError,
        children: [
            (ref = inputProps.selectedValues) === null || ref === void 0 ? void 0 : ref.map(function(item, itemIndex) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: jobs_automations/* PageStyle.SetupPopup__Tags */.k2.SetupPopup__Tags,
                    children: [
                        item.name ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: item.name
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: item.email
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            ButtonStyle: "".concat(jobs_automations/* ButtonStyle.nobgbutton */.ZJ.nobgbutton),
                            type: "button",
                            onClick: function() {
                                return handleDelete(inputProps.formik, inputProps.index, itemIndex);
                            },
                            children: [
                                " ",
                                inputProps.closeIcon
                            ]
                        })
                    ]
                }, "interview_email_".concat(inputProps.index, "_").concat(itemIndex));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                className: jobs_automations/* PageStyle.Form__Input */.k2.Form__Input,
                autoComplete: "password"
            }, inputProps))
        ]
    });
};
function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function getSuggestions(value, router) {
    return _getSuggestions.apply(this, arguments);
}
function _getSuggestions() {
    _getSuggestions = (0,_async_to_generator/* default */.Z)(function(value, router) {
        var escapedValue, regex, finalUsers;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    escapedValue = escapeRegexCharacters(value.trim());
                    if (escapedValue === "") {
                        return [
                            2,
                            []
                        ];
                    }
                    regex = new RegExp("^" + escapedValue, "i");
                    return [
                        4,
                        getClientUsers(escapedValue, router)
                    ];
                case 1:
                    finalUsers = _state.sent();
                    return [
                        2,
                        finalUsers
                    ];
            }
        });
    });
    return _getSuggestions.apply(this, arguments);
}
function onSuggestionsFetchRequested(value, setUsers, router) {
    return _onSuggestionsFetchRequested.apply(this, arguments);
}
function _onSuggestionsFetchRequested() {
    _onSuggestionsFetchRequested = (0,_async_to_generator/* default */.Z)(function(value, setUsers, router) {
        var users;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getSuggestions(value, router)
                    ];
                case 1:
                    users = _state.sent();
                    setUsers(users);
                    return [
                        2
                    ];
            }
        });
    });
    return _onSuggestionsFetchRequested.apply(this, arguments);
}
;
function shouldRenderSuggestions(value) {
    return value.trim().length >= 3;
}
function showSuggestion(suggestion) {
    if (suggestion.user_attributes.name && suggestion.user_attributes.email.length > 0) {
        return "".concat(suggestion.user_attributes.name, " | ").concat(suggestion.user_attributes.email);
    } else if (suggestion.user_attributes.name) {
        return "".concat(suggestion.user_attributes.name);
    } else {
        return "".concat(suggestion.user_attributes.email);
    }
}
function renderSuggestion(suggestion) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: showSuggestion(suggestion)
    });
}
function getClientUsers(name_or_email, router) {
    return _getClientUsers.apply(this, arguments);
}
function _getClientUsers() {
    _getClientUsers = (0,_async_to_generator/* default */.Z)(function(name_or_email, router) {
        var body, _tmp, result, status_code, customToastrAction, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = (_tmp.name_or_email = name_or_email, _tmp);
                    return [
                        4,
                        new clients_jobs_candidate_profile_job/* CandidateProfileJobService */.C().getUserByNameOrEmail(body)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new common/* CustomToastrAction */.Y5();
                    switch(status_code){
                        case common/* SUCCESS_REPONSE_CODE */.Us:
                            response = result.data;
                            return [
                                2,
                                response.users
                            ];
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            return [
                                2,
                                []
                            ];
                        default:
                            (0,common/* handleOtherResponseCode */.GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getClientUsers.apply(this, arguments);
}
function onSuggestionSelection(old_ids, id, old_initials, new_initial) {
    if (!(old_ids.includes(id) || old_ids.includes(id.toString()))) {
        old_ids.unshift(id);
        old_initials.unshift(new_initial);
    }
}
function showHideButtonValue(values) {
    var ref;
    var total_count = (ref = values.children_attributes.filter(function(x) {
        return !x._destroy;
    })) === null || ref === void 0 ? void 0 : ref.length;
    return total_count < MAX_ALLOWED_RECORDS ? true : false;
}
function onAutomationChange() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var formik = args[0];
    var action = args[1];
    var index = args[2] != undefined ? args[2] : 0;
    var setStageEmail = args[3];
    var setInterviewStageCount = args[4];
    var setTotalDuration = args[5];
    var current_interview_type = args[6];
    var setShowHideButton = args[7];
    var automations = formik.values.children_attributes;
    if (action == "add") {
        var _obj;
        var interview = (_obj = {
            date: "",
            starttime: "",
            endtime: "",
            integration_id: "",
            members: [],
            member_ids: []
        }, (0,_define_property/* default */.Z)(_obj, "members", []), (0,_define_property/* default */.Z)(_obj, "duration", ""), (0,_define_property/* default */.Z)(_obj, "meeting_link", ""), (0,_define_property/* default */.Z)(_obj, "_destroy", false), _obj);
        if (current_interview_type == jobs_automations/* INTERVIEW_TYPES.FACE2FACE */.BH.FACE2FACE) {
            interview.location = formik.values.default_location || "";
        }
        automations.push(interview);
    } else {
        automations[index]["_destroy"] = true;
    }
    setStageEmail(initialStageValues(formik.values));
    setInterviewStageCount(automations.filter(function(x) {
        return !x._destroy;
    }).length);
    var durations = [];
    var total_count = 0;
    formik.values.children_attributes.map(function(x, itemIndex) {
        if (!x._destroy) {
            var numer_duration = parseInt(x.duration) || 0;
            durations.push(numer_duration);
            total_count += 1;
        } else {
            durations.push(0);
        }
        return x;
    });
    setTotalDuration(durations.reduce(function(a, b) {
        return a + b;
    }, 0));
    total_count < MAX_ALLOWED_RECORDS ? setShowHideButton(true) : setShowHideButton(false);
}
function initialStageValues(initialValues) {
    return initialValues.children_attributes.map(function(x) {
        return {
            value: ""
        };
    });
}
function handleDelete(formik, index, itemIndex) {
    var member_ids = formik.values.children_attributes[index].member_ids;
    var members = formik.values.children_attributes[index].members;
    member_ids.splice(itemIndex, 1);
    members.splice(itemIndex, 1);
    formik.setFieldValue("children_attributes[".concat(index, "].member_ids"), (0,src_to_consumable_array/* default */.Z)(member_ids));
    formik.setFieldValue("children_attributes[".concat(index, "].members"), (0,src_to_consumable_array/* default */.Z)(members));
}
;
function handleKeyDown(event, formik, index, stageEmail, setStageEmail) {
    if ([
        "Enter"
    ].includes(event.key)) {
        event.preventDefault();
        var email = event.target.value;
        if (isEmail(email)) {
            onSuggestionSelection(formik.values.children_attributes[index].member_emails, email, formik.values.children_attributes[index].members, {
                email: email,
                name_initials: null,
                name: null
            });
            stageEmail[index] = {
                value: "",
                error: ""
            };
            setStageEmail(_to_consumable_array(stageEmail));
        } else {
            stageEmail[index] = {
                value: email,
                error: "Please enter valid email"
            };
            setStageEmail(_to_consumable_array(stageEmail));
        }
    }
}
function isCustomLink(platforms, integration_id) {
    var customPlatform = true;
    platforms.map(function(platform) {
        if (platform.default_name == "Custom Link" && integration_id && integration_id.toString() == platform.value.toString()) {
            customPlatform = false;
        }
        return platform;
    });
    return customPlatform;
}
function addMinutes(starttime, otherMinutes) {
    var totalInMinutes = parseInt(starttime.split(":")[0]) * 60 + parseInt(starttime.split(":")[1]);
    var grandTotal = (parseInt(otherMinutes) || 0) + totalInMinutes;
    var bookH = Math.floor(grandTotal / 60);
    var bookM = grandTotal % 60;
    var final = appendZero(bookH % 24) + ":" + appendZero(bookM);
    return final;
}
function appendZero(x) {
    if (x.toString().length < 2) return "0" + x.toString();
    return x;
}
function isLocationDisabled(formik, current_index) {
    var active_index = 0;
    formik.values.children_attributes.map(function(item, index) {
        if (index > current_index) {
            return;
        }
        if (!item._destroy) active_index += 1;
    });
    return active_index > 1;
}

;// CONCATENATED MODULE: ./src/constants/pages/clients/jobs/manual-interview.js




var URL_FORMAT = /^((http|https):\/\/)?[a-zA-Z0-9]+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-z]{2,}(:[0-9]{1,})?(\/.*)?$/i;
function manualInitialValues(values, action, job_application_id) {
    if (action == "new") {
        return {
            interview_type_id: "",
            default_location: "",
            place_id: "",
            job_application_id: job_application_id,
            date_range: true,
            children_attributes: [],
            primary: false,
            // Video QA Interview
            language: "English",
            video_link: "",
            questions_attributes: [
                {
                    question: "",
                    description: "",
                    attempts: 2,
                    answer_time: 30,
                    _destroy: false
                }
            ],
            job_stage_attributes: {
                automation: false
            },
            practise_screen: false,
            expires: null,
            videoqa: {
                member_emails: [],
                member_initials: []
            }
        };
    } else if (action == "edit") {
        values.default_location = "";
        values.place_id = "";
        values.date_range = true;
        values.children_attributes.map(function(x) {
            x.date = "", x.starttime = "", x.endtime = "", x.start_time = x.start_time || "";
            x.end_time = x.end_time || "", x.integration_id = x.integration_id || "", x.location = x.location || "", x.place_id = x.place_id, x.meeting_link = x.meeting_link || "";
            return x;
        });
        values.language = values.language || "English";
        values.video_link = values.video_link || "";
        values.questions_attributes = values.questions_attributes || [
            {
                question: "",
                description: "",
                attempts: 2,
                answer_time: 30,
                _destroy: false
            }
        ];
        values.job_stage_attributes = values.job_stage_attributes || {
            automation: false
        };
        values.practise_screen = values.practise_screen || false;
        values.expires = values.expires || null;
        values.videoqa = {
            member_emails: [],
            member_initials: []
        };
        return values;
    }
}
;
function validationManualform(addType, current_interview_type, sendInterview, platforms, validationData) {
    var CONSTANTS = {
        errors: {
            minimum: "Minimum $number",
            maximum: "Maximum $number"
        }
    };
    return jobs_automations/* Yup.object */.sm.object().shape({
        interview_type_id: jobs_automations/* Yup.string */.sm.string().required((0,jobs_automations/* TRANSLATION */.TA)("errors:required")),
        place_id: jobs_automations/* Yup.string */.sm.string().nullable(true),
        default_location: jobs_automations/* Yup.string */.sm.string().when([], {
            is: function() {
                return current_interview_type == jobs_automations/* INTERVIEW_TYPES.FACE2FACE */.BH.FACE2FACE;
            },
            then: jobs_automations/* Yup.string */.sm.string().required((0,jobs_automations/* TRANSLATION */.TA)("errors:required")).test("validLocation", (0,jobs_automations/* TRANSLATION */.TA)("errors:invalid_address"), function(value) {
                return this.parent.place_id && this.parent.place_id.length > 0;
            })
        })
    }).when(function(values, schema) {
        if ([
            jobs_automations/* INTERVIEW_TYPES.PHONE */.BH.PHONE,
            jobs_automations/* INTERVIEW_TYPES.VIDEO */.BH.VIDEO,
            jobs_automations/* INTERVIEW_TYPES.FACE2FACE */.BH.FACE2FACE
        ].includes(current_interview_type)) {
            return schema.shape({
                children_attributes: jobs_automations/* Yup.array */.sm.array().of(jobs_automations/* Yup.object */.sm.object().shape({
                    _destroy: jobs_automations/* Yup.boolean */.sm.boolean(),
                    date: jobs_automations/* Yup.string */.sm.string().when("_destroy", {
                        is: function(_destroy) {
                            return addType == "time" && !_destroy && sendInterview;
                        },
                        then: jobs_automations/* Yup.string */.sm.string().nullable().required((0,jobs_automations/* TRANSLATION */.TA)("errors:required"))
                    }),
                    starttime: jobs_automations/* Yup.string */.sm.string().when("_destroy", {
                        is: function(_destroy) {
                            return addType == "time" && !_destroy && sendInterview;
                        },
                        then: jobs_automations/* Yup.string */.sm.string().required((0,jobs_automations/* TRANSLATION */.TA)("errors:required")).test("is-correct", "Please select valid start time.", function(value) {
                            return isCorrectTime(value);
                        })
                    }),
                    endtime: jobs_automations/* Yup.string */.sm.string().when("_destroy", {
                        is: function(_destroy) {
                            return addType == "time" && !_destroy && sendInterview;
                        },
                        then: jobs_automations/* Yup.string */.sm.string().required((0,jobs_automations/* TRANSLATION */.TA)("errors:required")).test("is-greater", (0,jobs_automations/* TRANSLATION */.TA)("errors:end_time_greater_then_start_time"), function(value) {
                            var starttime = this.parent.starttime;
                            return isValidTime(starttime, value);
                        }).test("is-equal", (0,jobs_automations/* TRANSLATION */.TA)("errors:start_end_not_same"), function(value) {
                            var starttime = this.parent.starttime;
                            return isEqualTime(starttime, value);
                        })
                    }),
                    member_ids: jobs_automations/* Yup.array */.sm.array().when("_destroy", {
                        is: function(_destroy) {
                            return !_destroy;
                        },
                        then: jobs_automations/* Yup.array */.sm.array().min(1, (0,jobs_automations/* TRANSLATION */.TA)("errors:member_required"))
                    }),
                    // location: Yup.string().when("_destroy",{
                    // is: (_destroy) => {
                    //   return current_interview_type == INTERVIEW_TYPES.FACE2FACE && !_destroy
                    // },
                    // then: Yup.string().required(TRANSLATION('errors:required')).nullable(true)
                    // }),
                    duration: jobs_automations/* Yup.string */.sm.string().when("_destroy", {
                        is: function(_destroy) {
                            return !_destroy;
                        },
                        then: jobs_automations/* Yup.string */.sm.string().required((0,jobs_automations/* TRANSLATION */.TA)("errors:required"))
                    }),
                    integration_id: jobs_automations/* Yup.string */.sm.string().when("_destroy", {
                        is: function(_destroy) {
                            return current_interview_type == jobs_automations/* INTERVIEW_TYPES.VIDEO */.BH.VIDEO && !_destroy;
                        },
                        then: jobs_automations/* Yup.string */.sm.string().required((0,jobs_automations/* TRANSLATION */.TA)("errors:required")).nullable(true)
                    }),
                    meeting_link: jobs_automations/* Yup.string */.sm.string().when([
                        "_destroy",
                        "integration_id"
                    ], {
                        is: function(_destroy, integration_id) {
                            return current_interview_type == jobs_automations/* INTERVIEW_TYPES.VIDEO */.BH.VIDEO && !_destroy && !isCustomLink(platforms, integration_id);
                        },
                        then: jobs_automations/* Yup.string */.sm.string().required((0,jobs_automations/* TRANSLATION */.TA)("errors:required")).nullable(true).matches(URL_FORMAT, "Meeting link is invalid.")
                    })
                }))
            });
        } else if ([
            jobs_automations/* INTERVIEW_TYPES.VIDEOQA */.BH.VIDEOQA
        ].includes(current_interview_type)) {
            return schema.shape({
                language: jobs_automations/* Yup.string */.sm.string().required((0,jobs_automations/* TRANSLATION */.TA)("errors:required")),
                intro_video: jobs_automations/* Yup.string */.sm.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, (0,jobs_automations/* TRANSLATION */.TA)("errors:invalid_url")),
                video_link: jobs_automations/* Yup.string */.sm.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, (0,jobs_automations/* TRANSLATION */.TA)("errors:invalid_url")),
                questions_attributes: jobs_automations/* Yup.array */.sm.array(jobs_automations/* Yup.object */.sm.object().shape({
                    question: jobs_automations/* Yup.string */.sm.string().required((0,jobs_automations/* TRANSLATION */.TA)("errors:required")),
                    answer_time: jobs_automations/* Yup.number */.sm.number().required((0,jobs_automations/* TRANSLATION */.TA)("errors:required")).min(30, CONSTANTS.errors.minimum.replace("$number", 30)).max(120, CONSTANTS.errors.maximum.replace("$number", 120)).nullable(true),
                    attempts: jobs_automations/* Yup.number */.sm.number().required((0,jobs_automations/* TRANSLATION */.TA)("errors:required")).min(1, CONSTANTS.errors.minimum.replace("$number", 1)).max(3, CONSTANTS.errors.maximum.replace("$number", 3)).nullable(true)
                })),
                expires: jobs_automations/* Yup.number */.sm.number().required((0,jobs_automations/* TRANSLATION */.TA)("errors:required")).nullable(true)
            });
        } else if ([
            jobs_automations/* INTERVIEW_TYPES.TECHTEST */.BH.TECHTEST
        ].includes(current_interview_type)) {
            return schema.shape({
                job_test_detail_attributes: jobs_automations/* Yup.object */.sm.object({
                    test_id: jobs_automations/* Yup.string */.sm.string().required((0,jobs_automations/* TRANSLATION */.TA)("errors:invalid_test")),
                    days_to_expire: jobs_automations/* Yup.string */.sm.string().required((0,jobs_automations/* TRANSLATION */.TA)("errors:required")),
                    test_type: jobs_automations/* Yup.string */.sm.string(),
                    assessment: jobs_automations/* Yup.object */.sm.object().shape((0,_object_spread/* default */.Z)({}, validationData.type == "Assessment" && validationData.test_id.toString() == "upload_new_test" ? {
                        name: jobs_automations/* Yup.string */.sm.string().required((0,jobs_automations/* TRANSLATION */.TA)("errors:required")),
                        file_type: jobs_automations/* Yup.string */.sm.string().required((0,jobs_automations/* TRANSLATION */.TA)("errors:required")),
                        link: jobs_automations/* Yup.string */.sm.string().when("file_type", {
                            is: function(file_type) {
                                return file_type == "link";
                            },
                            then: jobs_automations/* Yup.string */.sm.string().matches(URL_FORMAT, (0,jobs_automations/* TRANSLATION */.TA)("errors:assessment_link_invalid")),
                            otherwise: jobs_automations/* Yup.string */.sm.string().notRequired()
                        }),
                        filename: jobs_automations/* Yup.string */.sm.string().when("file_type", {
                            is: function(file_type) {
                                return file_type == "file";
                            },
                            then: jobs_automations/* Yup.string */.sm.string(),
                            otherwise: jobs_automations/* Yup.string */.sm.string().notRequired()
                        }),
                        filesize: jobs_automations/* Yup.string */.sm.string().when("file_type", {
                            is: function(file_type) {
                                return file_type == "file";
                            },
                            then: jobs_automations/* Yup.string */.sm.string().test("is-greater", (0,jobs_automations/* TRANSLATION */.TA)("errors:max_file_size"), function(value) {
                                var currentFileSize = parseInt(value) || 0;
                                return currentFileSize < jobs_automations/* MANAGE_ASSESSMENT.file_size */.WY.file_size;
                            }),
                            otherwise: jobs_automations/* Yup.string */.sm.string().notRequired()
                        })
                    } : {}))
                })
            });
        }
    });
}
// children_attributes: Yup.array().of(
//   Yup.object().shape({
//   _destroy: Yup.boolean(),
//   start_time: Yup.string().when("_destroy", {
//     is: (_destroy) => {
//      return addType == "time" && !_destroy && sendInterview
//    },
//     then: Yup.string().required(TRANSLATION('errors:required'))
//   }),
//   end_time:   Yup.string().when("_destroy", {
//     is: (_destroy) => { return addType == "time" && !_destroy && sendInterview },
//     then: Yup.string().required(TRANSLATION('errors:required')).test("is-greater", "end time should be greater with same date", function(value) {
//       let start_time = this.parent.start_time
//       return moment(moment(value).format("YYYY/MM/DD h:mm a")).isAfter( moment(start_time).format("YYYY/MM/DD h:mm a")) && moment( moment(value).format("YYYY/MM/DD")).isSame(moment(start_time).format("YYYY/MM/DD"))
//     })
//   }),
//   member_ids: Yup.array().when("_destroy",{
//       is: (_destroy) => { return !_destroy },
//       then: Yup.array().min(1, TRANSLATION('errors:member_required'))
//     }),
//   location: Yup.string().when("_destroy",{
//   is: (_destroy) => {
//     return current_interview_type == INTERVIEW_TYPES.FACE2FACE && !_destroy
//   },
//   then: Yup.string().required(TRANSLATION('errors:required')).nullable(true)
//   }),
//   duration: Yup.string().when("_destroy",{
//       is: (_destroy) => { return !_destroy},
//       then: Yup.string().required(TRANSLATION('errors:required'))
//     }),
//   integration_id: Yup.string().when("_destroy",{
//   is: (_destroy) => {
//     return current_interview_type == INTERVIEW_TYPES.VIDEO && !_destroy
//   },
//   then: Yup.string().required(TRANSLATION('errors:required')).nullable(true)
// }),
// })
// )
function isValidTime(start_time, end_time) {
    var start_int = parseInt(start_time.replace(":", ""));
    var end_int = parseInt(end_time.replace(":", ""));
    if (start_time.includes("-") || end_time.includes("-")) return true;
    return start_int <= end_int;
}
function isEqualTime(start_time, end_time) {
    var start_int = parseInt(start_time.replace(":", ""));
    var end_int = parseInt(end_time.replace(":", ""));
    if (start_time.includes("-") || end_time.includes("-")) return true;
    return start_time != end_time;
}
function isCorrectTime(value) {
    var time = value.replace(":", "");
    return !time.includes("-");
}

// EXTERNAL MODULE: ./src/actions/pages/clients/candidates/daxtra-score-action.js
var daxtra_score_action = __webpack_require__(74527);
// EXTERNAL MODULE: ./src/components/setup-interview-modal.js + 1 modules
var setup_interview_modal = __webpack_require__(78941);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/jobs/send-questions-modal.js
var send_questions_modal = __webpack_require__(11281);
// EXTERNAL MODULE: ./src/actions/common/application-filter.js
var application_filter = __webpack_require__(98766);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/jobs/candidate-profile-job.js
//-----------------Constants----------------------------

//-----------------Constants ----------------------------
//-----------------Common ----------------------------

//-----------------Common ----------------------------
//----------------- Images ----------------------------
























// ---------------------------------------------------------
// ------------------- ICONS -------------------


// ------------------- ICONS -------------------
//----------------- Actions ----------------------------


//------------------------------------------------------
//--------------- Services -------------------

//--------------- Services -------------------
//----------------- Components ----------------------------















// ---------------------------------------------------------
//--------------- Stylesheets -------------------

//--------------- Stylesheets -------------------
























/***/ }),

/***/ 46780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ek": function() { return /* reexport safe */ _constants_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_5__.Ek; },
/* harmony export */   "GB": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.GB; },
/* harmony export */   "Il": function() { return /* reexport safe */ _constants_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_6__.Il; },
/* harmony export */   "Lt": function() { return /* reexport safe */ _services_common_send_request__WEBPACK_IMPORTED_MODULE_1__.L; },
/* harmony export */   "Mn": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.Mn; },
/* harmony export */   "QJ": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.QJ; },
/* harmony export */   "RQ": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.RQ; },
/* harmony export */   "UU": function() { return /* reexport safe */ _actions_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_4__.UU; },
/* harmony export */   "Us": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.Us; },
/* harmony export */   "Y5": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.Y5; },
/* harmony export */   "bl": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.bl; },
/* harmony export */   "gW": function() { return /* reexport safe */ _services_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_2__.g; },
/* harmony export */   "k2": function() { return /* reexport default from dynamic */ _styles_pages_clients_interview_stages_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default.a; },
/* harmony export */   "oI": function() { return /* reexport safe */ _services_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_3__.o; },
/* harmony export */   "od": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.od; },
/* harmony export */   "tv": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.tv; }
/* harmony export */ });
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96047);
/* harmony import */ var _services_common_send_request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34964);
/* harmony import */ var _services_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60515);
/* harmony import */ var _services_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47441);
/* harmony import */ var _actions_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90432);
/* harmony import */ var _constants_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32042);
/* harmony import */ var _constants_pages_clients_jobs_job_options__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42588);
/* harmony import */ var _styles_pages_clients_interview_stages_index_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89817);
/* harmony import */ var _styles_pages_clients_interview_stages_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_clients_interview_stages_index_module_scss__WEBPACK_IMPORTED_MODULE_7__);










/***/ }),

/***/ 77393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.$G; },
/* harmony export */   "$J": function() { return /* reexport safe */ _constants_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__.$J; },
/* harmony export */   "$q": function() { return /* reexport safe */ _actions_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_12__.$q; },
/* harmony export */   "A$": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.A$; },
/* harmony export */   "BH": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.BH; },
/* harmony export */   "D6": function() { return /* reexport safe */ _actions_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_12__.D6; },
/* harmony export */   "EA": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.EA; },
/* harmony export */   "Ee": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.Ee; },
/* harmony export */   "Ek": function() { return /* reexport safe */ _constants_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__.Ek; },
/* harmony export */   "F2": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.F2; },
/* harmony export */   "GB": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.GB; },
/* harmony export */   "J9": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.J9; },
/* harmony export */   "LP": function() { return /* reexport safe */ public_icons_call2_svg__WEBPACK_IMPORTED_MODULE_2__.Z; },
/* harmony export */   "LR": function() { return /* reexport safe */ public_icons_user_svg__WEBPACK_IMPORTED_MODULE_5__.Z; },
/* harmony export */   "M1": function() { return /* reexport safe */ _actions_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_11__.M1; },
/* harmony export */   "Mf": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.Mf; },
/* harmony export */   "Mn": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.Mn; },
/* harmony export */   "N$": function() { return /* reexport safe */ _actions_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_12__.N$; },
/* harmony export */   "NL": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.NL; },
/* harmony export */   "PG": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.PG; },
/* harmony export */   "PU": function() { return /* reexport safe */ _services_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_14__.P; },
/* harmony export */   "QJ": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.QJ; },
/* harmony export */   "RQ": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.RQ; },
/* harmony export */   "TA": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.TA; },
/* harmony export */   "Us": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.Us; },
/* harmony export */   "Y5": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.Y5; },
/* harmony export */   "Z5": function() { return /* reexport safe */ react_beautiful_dnd__WEBPACK_IMPORTED_MODULE_20__.Z5; },
/* harmony export */   "ZJ": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.ZJ; },
/* harmony export */   "_l": function() { return /* reexport safe */ react_beautiful_dnd__WEBPACK_IMPORTED_MODULE_20__._l; },
/* harmony export */   "ao": function() { return /* reexport safe */ _actions_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_11__.ao; },
/* harmony export */   "bK": function() { return /* reexport safe */ react_beautiful_dnd__WEBPACK_IMPORTED_MODULE_20__.bK; },
/* harmony export */   "d3": function() { return /* reexport safe */ _actions_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_11__.d3; },
/* harmony export */   "d4": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.d4; },
/* harmony export */   "dC": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.dC; },
/* harmony export */   "dH": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.dH; },
/* harmony export */   "e6": function() { return /* reexport safe */ public_icons_technical_svg__WEBPACK_IMPORTED_MODULE_3__.Z; },
/* harmony export */   "eJ": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.eJ; },
/* harmony export */   "eP": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.eP; },
/* harmony export */   "gt": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.gt; },
/* harmony export */   "gw": function() { return /* reexport safe */ _services_pages_clients_jobs_edit_job__WEBPACK_IMPORTED_MODULE_13__.g; },
/* harmony export */   "iI": function() { return /* reexport safe */ _constants_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__.iI; },
/* harmony export */   "jL": function() { return /* reexport safe */ _actions_common_close_modal__WEBPACK_IMPORTED_MODULE_19__.j; },
/* harmony export */   "jf": function() { return /* reexport safe */ public_icons_videoqa_svg__WEBPACK_IMPORTED_MODULE_7__.Z; },
/* harmony export */   "k2": function() { return /* reexport default from dynamic */ _styles_pages_clients_interview_stages_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default.a; },
/* harmony export */   "l": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.l; },
/* harmony export */   "l0": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.l0; },
/* harmony export */   "nk": function() { return /* reexport safe */ public_icons_video_svg__WEBPACK_IMPORTED_MODULE_4__.Z; },
/* harmony export */   "pd": function() { return /* reexport safe */ _actions_common_input_error__WEBPACK_IMPORTED_MODULE_10__.p; },
/* harmony export */   "sO": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.sO; },
/* harmony export */   "tc": function() { return /* reexport safe */ _pages_clients_jobs_back_all_jobs_modal__WEBPACK_IMPORTED_MODULE_15__["default"]; },
/* harmony export */   "tv": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.tv; },
/* harmony export */   "u2": function() { return /* reexport safe */ _constants_components_sidebar__WEBPACK_IMPORTED_MODULE_1__.u2; },
/* harmony export */   "w1": function() { return /* reexport safe */ react_simple_tooltip__WEBPACK_IMPORTED_MODULE_9__.Z; },
/* harmony export */   "xz": function() { return /* reexport safe */ _actions_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_12__.xz; },
/* harmony export */   "y$": function() { return /* reexport safe */ _actions_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_11__.y$; },
/* harmony export */   "zx": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__.zx; }
/* harmony export */ });
/* harmony import */ var _constants_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32042);
/* harmony import */ var _constants_components_sidebar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73257);
/* harmony import */ var public_icons_call2_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67536);
/* harmony import */ var public_icons_technical_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36414);
/* harmony import */ var public_icons_video_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15166);
/* harmony import */ var public_icons_user_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41739);
/* harmony import */ var public_icons_exclamation_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22461);
/* harmony import */ var public_icons_videoqa_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20226);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96047);
/* harmony import */ var react_simple_tooltip__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54392);
/* harmony import */ var _actions_common_input_error__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(54911);
/* harmony import */ var _actions_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(90432);
/* harmony import */ var _actions_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68109);
/* harmony import */ var _services_pages_clients_jobs_edit_job__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85985);
/* harmony import */ var _services_pages_clients_jobs_interview_stages__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(42465);
/* harmony import */ var _pages_clients_jobs_back_all_jobs_modal__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(92867);
/* harmony import */ var _styles_pages_clients_interview_stages_index_module_scss__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(89817);
/* harmony import */ var _styles_pages_clients_interview_stages_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_clients_interview_stages_index_module_scss__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _imports_files_pages_clients_invite_admin__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(66090);
/* harmony import */ var _components_confirmation_modal__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(72055);
/* harmony import */ var _actions_common_close_modal__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(67280);
/* harmony import */ var react_beautiful_dnd__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(8979);
//-----------------Constant ----------------------------


//-----------------Constant ----------------------------
//-----------------Images ----------------------------






//-----------------Images ----------------------------
//-----------------Common ----------------------------


//-----------------Common ----------------------------
//----------------- Actions -----------------------------



//----------------- Actions -----------------------------
//----------------- Services -----------------------------



//----------------- Services -----------------------------
//----------------- Pages -----------------------------

//----------------- Pages -----------------------------
//----------------- Stylesheet -----------------------------


//----------------- Stylesheet -----------------------------
//----------------- Chips ---------------------

//----------------- Chips ---------------------





/***/ }),

/***/ 64547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xd": function() { return /* reexport */ arrowleft/* default */.Z; },
  "tc": function() { return /* reexport */ back_all_jobs_modal["default"]; },
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "ZJ": function() { return /* reexport */ common/* ButtonStyle */.ZJ; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "QJ": function() { return /* reexport */ common/* DataFromUrl */.QJ; },
  "gw": function() { return /* reexport */ edit_job/* EditJob */.g; },
  "dC": function() { return /* reexport */ common/* ErrorPages */.dC; },
  "gN": function() { return /* reexport */ common/* Field */.gN; },
  "l0": function() { return /* reexport */ common/* Form */.l0; },
  "x": function() { return /* reexport */ (_form_module_default()); },
  "J9": function() { return /* reexport */ common/* Formik */.J9; },
  "gt": function() { return /* reexport */ common/* FormikControl */.gt; },
  "Ee": function() { return /* reexport */ common/* Image */.Ee; },
  "pd": function() { return /* reexport */ input_error/* InputError */.p; },
  "oH": function() { return /* reexport */ common/* InputText */.oH; },
  "l": function() { return /* reexport */ common/* JOB_STEPS */.l; },
  "q9": function() { return /* reexport */ JobOptionsAction; },
  "hf": function() { return /* reexport */ JobOptionsService; },
  "gb": function() { return /* reexport */ common/* Loading */.gb; },
  "Mf": function() { return /* reexport */ common/* PAGE_ANIMATION_OPTIONS */.Mf; },
  "k2": function() { return /* reexport */ (_index_module_default()); },
  "j$": function() { return /* reexport */ common/* QUESTION_TYPES */.j$; },
  "RQ": function() { return /* reexport */ common/* REDIRECT */.RQ; },
  "u2": function() { return /* reexport */ sidebar/* SIDEBAR_OPTIONS */.u2; },
  "Us": function() { return /* reexport */ common/* SUCCESS_REPONSE_CODE */.Us; },
  "nj": function() { return /* reexport */ ScreeningQuestions; },
  "mR": function() { return /* reexport */ (job_options_index_module_default()); },
  "TA": function() { return /* reexport */ common/* TRANSLATION */.TA; },
  "Mn": function() { return /* reexport */ common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn; },
  "sm": function() { return /* reexport */ common/* Yup */.sm; },
  "_g": function() { return /* reexport */ jobs_common/* arrayEquals */._g; },
  "A$": function() { return /* reexport */ common/* clearSWRCache */.A$; },
  "wx": function() { return /* reexport */ index_4bd03571_esm.c; },
  "y$": function() { return /* reexport */ jobs_common/* cursorNone */.y$; },
  "M1": function() { return /* reexport */ jobs_common/* draftJob */.M1; },
  "D6": function() { return /* reexport */ interview_stages/* getClientUsers */.D6; },
  "Il": function() { return /* reexport */ job_options/* getEditInitalOptionValues */.Il; },
  "iI": function() { return /* reexport */ job_options/* getValidationSchema */.iI; },
  "GB": function() { return /* reexport */ common/* handleOtherResponseCode */.GB; },
  "EA": function() { return /* reexport */ common/* motion */.EA; },
  "ao": function() { return /* reexport */ jobs_common/* previewJob */.ao; },
  "$h": function() { return /* reexport */ jobs_common/* toggleDisabled */.$h; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "NL": function() { return /* reexport */ common/* useQueryClient */.NL; },
  "sO": function() { return /* reexport */ common/* useRef */.sO; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: API, AutocompleteError, FieldArray, HelmetMeta, INTERVIEW_TYPES, JOB_STAGES, Link, NextServerCookies, RESOURCE_NOT_FOUND_REPONSE_CODE, React, SendRequest, Sidebar, Tooltip, axios, getInitalValues, getSession, goToNextPage, hideDraft, jobStatusBadge, startDateMessage, toastr, useNavbarStatus

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ../../shared/node_modules/react-select/dist/index-4bd03571.esm.js + 1 modules
var index_4bd03571_esm = __webpack_require__(28805);
// EXTERNAL MODULE: ./src/services/pages/clients/jobs/edit-job.js
var edit_job = __webpack_require__(85985);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ./src/imports-files/pages/admins/dashboard/clients/new.js + 2 modules
var clients_new = __webpack_require__(97336);
;// CONCATENATED MODULE: ./src/services/pages/clients/jobs/job-options.js







var JobOptionsService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(JobOptionsService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(JobOptionsService);
    function JobOptionsService() {
        (0,_class_call_check/* default */.Z)(this, JobOptionsService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(JobOptionsService, [
        {
            key: "getJobOptionsData",
            value: function getJobOptionsData(jobId) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    clients_new/* axios.get */.od.get(clients_new/* API.client.jobs.GET_JOB_OPTIONS_DATA.replace */.bl.client.jobs.GET_JOB_OPTIONS_DATA.replace("$job_id", jobId), (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addJobOptions",
            value: function addJobOptions(params, jobId) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    clients_new/* axios.post */.od.post(clients_new/* API.client.jobs.ADD_JOB_OPTIONS_DATA.replace */.bl.client.jobs.ADD_JOB_OPTIONS_DATA.replace("$job_id", jobId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return JobOptionsService;
}(clients_new/* SendRequest */.Lt);

// EXTERNAL MODULE: ./src/constants/pages/clients/jobs/job-options.js
var job_options = __webpack_require__(42588);
// EXTERNAL MODULE: ./src/constants/components/sidebar.js
var sidebar = __webpack_require__(73257);
// EXTERNAL MODULE: ./src/actions/common/input-error.js
var input_error = __webpack_require__(54911);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/common.js
var jobs_common = __webpack_require__(90432);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/interview_stages.js
var interview_stages = __webpack_require__(68109);
;// CONCATENATED MODULE: ./src/actions/pages/clients/jobs/job-options.js





var JobOptionsAction = /*#__PURE__*/ function() {
    "use strict";
    function JobOptionsAction(args) {
        (0,_class_call_check/* default */.Z)(this, JobOptionsAction);
        this.jobOptionsService = new JobOptionsService();
    }
    (0,_create_class/* default */.Z)(JobOptionsAction, [
        {
            key: "getJobOptionsData",
            value: function getJobOptionsData(setApiError) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var job_id, result, job_result, job, data, _tmp;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                job_id = new common/* DataFromUrl */.QJ().getJobId();
                                return [
                                    4,
                                    _this.jobOptionsService.getJobOptionsData(job_id)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    4,
                                    new edit_job/* EditJob */.g().getJobInfo(job_id)
                                ];
                            case 2:
                                job_result = _state.sent();
                                _tmp = {};
                                if (result.request.status == 200) {
                                    job = job_result.data.job;
                                    data = (_tmp.props = {
                                        result: result.data,
                                        job: job
                                    }, _tmp);
                                    return [
                                        2,
                                        data
                                    ];
                                } else {
                                    setApiError(job_result.request);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleFormSubmit",
            value: function handleFormSubmit(values, router, t, setPageName, queryClient, formik, fromKanban, gotoKanban, setDisabledSaveButton, setShowLoader) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, jobId, idRegex, screening_questions_attributes, body, _tmp1, status_code, response, queryPath, _tmp2, _tmp3, ref, ref1, ref2, message, job_error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setDisabledSaveButton(true);
                                _tmp = {};
                                result = _tmp;
                                jobId = new common/* DataFromUrl */.QJ().getJobId() || values.job.id;
                                idRegex = new RegExp("[0-9]");
                                screening_questions_attributes = values.job.screening_questions_attributes;
                                screening_questions_attributes = screening_questions_attributes.map(function(x) {
                                    var order = 1;
                                    x.question_options_attributes = x.question_options_attributes.map(function(option) {
                                        if (!option.option) option._destroy = true;
                                        if (!option._destroy) option.order = order;
                                        return option;
                                    });
                                    return x;
                                });
                                values.job.screening_questions_attributes = screening_questions_attributes;
                                _tmp1 = {};
                                body = Object.assign(_tmp1, values);
                                return [
                                    4,
                                    _this.jobOptionsService.addJobOptions(body, values.job.id)
                                ];
                            case 1:
                                result = _state.sent();
                                status_code = result.status || result.response.status;
                                _tmp2 = {};
                                _tmp3 = {};
                                switch(status_code){
                                    case common/* SUCCESS_REPONSE_CODE */.Us:
                                        response = result.data;
                                        queryPath = fromKanban ? "?from_kanban=true" : "";
                                        setShowLoader(false);
                                        if (gotoKanban) {
                                            if (fromKanban) {
                                                router.push((_tmp2.pathname = common/* REDIRECT.client.kanban_board.replace */.RQ.client.kanban_board.replace("$job_id", response.id), _tmp2));
                                            } else {
                                                router.push((_tmp3.pathname = common/* REDIRECT.client.jobs.index */.RQ.client.jobs.index, _tmp3.query = {
                                                    job_type: "active"
                                                }, _tmp3));
                                            }
                                        } else router.push(common/* REDIRECT.client.jobs.interview_stages.replace */.RQ.client.jobs.interview_stages.replace("$job_id", response.id) + queryPath);
                                        break;
                                    case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                                        ;
                                        message = "";
                                        if ((ref = result.response.data.error.job) === null || ref === void 0 ? void 0 : ref.hiring_manager_emails) {
                                            message += "".concat(result.response.data.error.job.hiring_manager_emails);
                                        }
                                        if ((ref1 = result.response.data.error.job) === null || ref1 === void 0 ? void 0 : ref1.job_owner_emails) {
                                            if (message.length > 0) {
                                                message += "</br>";
                                            }
                                            message += "".concat(result.response.data.error.job.job_owner_emails);
                                        }
                                        if ((ref2 = result.response.data.error.job) === null || ref2 === void 0 ? void 0 : ref2.new_user_emails) {
                                            if (message.length > 0) {
                                                message += "</br>";
                                            }
                                            message += "".concat(result.response.data.error.job.new_user_emails);
                                        }
                                        if (message.length > 0) {
                                            new common/* CustomToastrAction */.Y5().setNormalToastr(message, "warning");
                                        }
                                        job_error = result.response.data.error;
                                        delete job_error.job["hiring_manager_emails"];
                                        delete job_error.job["job_owner_emails"];
                                        formik.current.setStatus(job_error);
                                        formik.current.setErrors(job_error);
                                        setDisabledSaveButton(false);
                                        setShowLoader(false);
                                        break;
                                    default:
                                        (0,common/* handleOtherResponseCode */.GB)(status_code, router);
                                        setDisabledSaveButton(false);
                                        setShowLoader(false);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return JobOptionsAction;
}();

// EXTERNAL MODULE: ./src/pages/clients/jobs/back-all-jobs-modal.js
var back_all_jobs_modal = __webpack_require__(92867);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/invite-admin.js + 2 modules
var invite_admin = __webpack_require__(66090);
// EXTERNAL MODULE: ./src/styles/pages/clients/new-job/_index.module.scss
var _index_module = __webpack_require__(35057);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/styles/pages/clients/job-options/_index.module.scss
var job_options_index_module = __webpack_require__(67019);
var job_options_index_module_default = /*#__PURE__*/__webpack_require__.n(job_options_index_module);
// EXTERNAL MODULE: ./src/styles/layout/_form.module.scss
var _form_module = __webpack_require__(73779);
var _form_module_default = /*#__PURE__*/__webpack_require__.n(_form_module);
// EXTERNAL MODULE: ./public/icons/arrowleft.svg
var arrowleft = __webpack_require__(65661);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(34817);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./public/icons/thick-plus.svg
var thick_plus = __webpack_require__(83238);
;// CONCATENATED MODULE: ./src/components/jobOptionsComponents/screening-questions.js







function ScreeningQuestions(props) {
    var canQuestionAdd = function canQuestionAdd(formik, editable) {
        var screening_questions_attributes = formik.values.job.screening_questions_attributes.filter(function(x) {
            return !x._destroy;
        });
        if (screening_questions_attributes.length < 10) {
            return true;
        }
        return false;
    };
    var onAddQuestion = function onAddQuestion(formik, job_id) {
        setAddQuestonDisabled(true);
        var question = {
            question: "",
            question_type_id: "",
            question_type_name: "",
            mandatory: false,
            option_mandatory: false,
            _destroy: false,
            job_id: job_id,
            question_options_attributes: []
        };
        var screening_questions = formik.values.job.screening_questions_attributes;
        screening_questions.push(question);
        formik.setFieldValue("job.screening_questions_attributes", (0,_to_consumable_array/* default */.Z)(screening_questions));
        setAddQuestonDisabled(false);
    };
    var onRemoveQuestion = function onRemoveQuestion(formik, index) {
        var screening_questions_attributes = formik.values.job.screening_questions_attributes;
        formik.setFieldValue("job.screening_questions_attributes.".concat(index, "._destroy"), true);
    };
    var canOptionAdd = function canOptionAdd(question, editable) {
        var question_options_attributes = question.question_options_attributes.filter(function(x) {
            return !x._destroy;
        });
        if ([
            common/* QUESTION_TYPES.SINGLE_CHOICE */.j$.SINGLE_CHOICE,
            common/* QUESTION_TYPES.MULTIPLE_CHOICE */.j$.MULTIPLE_CHOICE
        ].includes(question.question_type_name) && question_options_attributes.length < 7) {
            return  true && editable;
        }
        return false;
    };
    var canOptionRemove = function canOptionRemove(question, editable) {
        var question_options_attributes = question.question_options_attributes.filter(function(x) {
            return !x._destroy;
        });
        if ([
            common/* QUESTION_TYPES.SINGLE_CHOICE */.j$.SINGLE_CHOICE,
            common/* QUESTION_TYPES.MULTIPLE_CHOICE */.j$.MULTIPLE_CHOICE
        ].includes(question.question_type_name) && question_options_attributes.length > 2) {
            return  true && editable;
        }
        return false;
    };
    var optionPlaceholder = function optionPlaceholder(question, option_index, t) {
        if (question.question_type_name == common/* QUESTION_TYPES.YES_NO */.j$.YES_NO) {
            var validIndexes = [];
            question.question_options_attributes.map(function(x, op_index) {
                if (!x._destroy) validIndexes.push(op_index);
            });
            return option_index == validIndexes[0] ? t("button:yes") : t("button:no");
        } else {
            return t("jobs:options:screening:add_ans_choice");
        }
    };
    var ref;
    var formik = props.formik, questionTypes = props.questionTypes, editable = props.editable, formRef = props.formRef, job_id = props.job_id;
    var ref1 = (0,common/* useTranslation */.$G)(), t = ref1.t, i18n = ref1.i18n;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(null), 2), selectedOption = ref2[0], setSelectedOption = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(null), 2), flagForRender = ref3[0], setFlagForRender = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), addQuestionDisabled = ref4[0], setAddQuestonDisabled = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), addChoiceDisabled = ref5[0], setAddChoiceDisabled = ref5[1];
    var options = [
        {
            value: "Text (single line)",
            label: "Text (single line)"
        },
        {
            value: "Text (multiple lines) ",
            label: "Text (multiple lines) "
        },
        {
            value: "Yes/No",
            label: "Yes/No"
        }, 
    ];
    function onAddChoice(formik, index) {
        return _onAddChoice.apply(this, arguments);
    }
    function _onAddChoice() {
        _onAddChoice = (0,_async_to_generator/* default */.Z)(function(formik, index) {
            var question_options_attributes, next_order, question_option, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            setAddQuestonDisabled(true)
                        ];
                    case 1:
                        _state.sent();
                        question_options_attributes = formik.values.job.screening_questions_attributes[index].question_options_attributes;
                        next_order = question_options_attributes.length > 0 ? question_options_attributes[question_options_attributes.length - 1].order + 1 : 1;
                        _tmp = {};
                        question_option = (_tmp.option = "", _tmp._destroy = false, _tmp);
                        question_options_attributes.push(question_option);
                        return [
                            4,
                            formik.setFieldValue("job.screening_questions_attributes.".concat(index, ".question_options_attributes"), question_options_attributes)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            setAddQuestonDisabled(false)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _onAddChoice.apply(this, arguments);
    }
    function onRemoveChoice(formik, index, option_index) {
        return _onRemoveChoice.apply(this, arguments);
    }
    function _onRemoveChoice() {
        _onRemoveChoice = (0,_async_to_generator/* default */.Z)(function(formik, index, option_index) {
            var question_options_attributes;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        question_options_attributes = formik.values.job.screening_questions_attributes[index].question_options_attributes;
                        return [
                            4,
                            formik.setFieldValue("job.screening_questions_attributes.".concat(index, ".question_options_attributes.").concat(option_index, "._destroy"), true)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _onRemoveChoice.apply(this, arguments);
    }
    function onQuestionTypeChanged(formik, index, question_type, t) {
        return _onQuestionTypeChanged.apply(this, arguments);
    }
    function _onQuestionTypeChanged() {
        _onQuestionTypeChanged = (0,_async_to_generator/* default */.Z)(function(formik, index, question_type, t) {
            var question_options_attributes, question_option_1, _tmp, question_option_2, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        question_options_attributes = formik.values.job.screening_questions_attributes[index].question_options_attributes;
                        question_options_attributes = question_options_attributes.map(function(x) {
                            x._destroy = true;
                            return x;
                        });
                        switch(question_type){
                            case common/* QUESTION_TYPES.SINGLE_LINE */.j$.SINGLE_LINE:
                                return [
                                    3,
                                    1
                                ];
                            case common/* QUESTION_TYPES.MULTIPLE_LINE */.j$.MULTIPLE_LINE:
                                return [
                                    3,
                                    1
                                ];
                            case common/* QUESTION_TYPES.YES_NO */.j$.YES_NO:
                                return [
                                    3,
                                    4
                                ];
                            case common/* QUESTION_TYPES.SINGLE_CHOICE */.j$.SINGLE_CHOICE:
                                return [
                                    3,
                                    4
                                ];
                            case common/* QUESTION_TYPES.MULTIPLE_CHOICE */.j$.MULTIPLE_CHOICE:
                                return [
                                    3,
                                    4
                                ];
                        }
                        return [
                            3,
                            7
                        ];
                    case 1:
                        return [
                            4,
                            formik.setFieldValue("job.screening_questions_attributes.".concat(index, ".question_options_attributes"), question_options_attributes)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            formik.setFieldValue("job.screening_questions_attributes.".concat(index, ".option_mandatory"), false)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 4:
                        _tmp = {};
                        question_option_1 = (_tmp.option = question_type == "yes_no" ? t("button:yes") : "", _tmp._destroy = false, _tmp);
                        _tmp1 = {};
                        question_option_2 = (_tmp1.option = question_type == "yes_no" ? t("button:no") : "", _tmp1._destroy = false, _tmp1);
                        question_options_attributes.push(question_option_1);
                        question_options_attributes.push(question_option_2); // for adding 2 options
                        return [
                            4,
                            formik.setFieldValue("job.screening_questions_attributes.".concat(index, ".question_options_attributes"), question_options_attributes)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            4,
                            formik.setFieldValue("job.screening_questions_attributes.".concat(index, ".option_mandatory"), true)
                        ];
                    case 6:
                        _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return _onQuestionTypeChanged.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(props.ScreeningStyle.ScreeningQuestions, " ScreeningQuestions"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "".concat((_index_module_default()).ClientCompany__Subheading, " mb0"),
                        children: t("jobs:options:screening:heading")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(props.ScreeningStyle.ScreeningQuestions__Description),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            children: t("jobs:options:screening:subheading")
                        })
                    }),
                    (ref = formik.values.job.screening_questions_attributes) === null || ref === void 0 ? void 0 : ref.map(function(question, index) {
                        return !question._destroy && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(props.ScreeningStyle.ScreeningQuestions__Box),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat(props.ScreeningStyle.ScreeningQuestions__BoxForm),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w100 ".concat((_form_module_default()).Form__TableCol),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(props.ScreeningStyle.ScreeningQuestions__BoxLabel, " wauto"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: "".concat((_form_module_default()).Form__FloatingLabel),
                                                    style: (0,common/* InputText */.oH)(formik, "job.screening_questions_attributes.".concat(index, ".question")),
                                                    children: [
                                                        " ",
                                                        t("jobs:options:screening:input:question")
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(props.PageStyle.Form__InputSection, " ").concat(props.ScreeningStyle.ScreeningQuestions__BoxInput, " removeplaceholder"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                    control: "input",
                                                    className: "".concat(props.PageStyle.Form__Input),
                                                    errorClass: "".concat(props.PageStyle.Form__Error),
                                                    formik: formik,
                                                    placeholder: t("placeholder:add_question"),
                                                    name: "job.screening_questions_attributes.".concat(index, ".question"),
                                                    style: (0,input_error/* InputError */.p)(formik, "job.screening_questions_attributes.".concat(index, ".question")),
                                                    custom_class: "FieldError",
                                                    disabled: !editable
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(props.ScreeningStyle.ScreeningQuestions__BoxLabels, " ").concat(props.ScreeningStyle.ScreeningQuestions__Remove),
                                                children: editable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat(props.ScreeningStyle.ScreeningQuestions__BoxLabel, " CursorPointer"),
                                                    onClick: function() {
                                                        onRemoveQuestion(formik, index);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "w100 JustifyEnd",
                                                        children: [
                                                            " ",
                                                            t("jobs:options:screening:remove")
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w100 ".concat((_form_module_default()).Form__TableCol),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(props.ScreeningStyle.ScreeningQuestions__BoxLabels),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat(props.ScreeningStyle.ScreeningQuestions__BoxLabel, " wauto"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "".concat((_form_module_default()).Form__FloatingLabel),
                                                        style: (0,common/* InputText */.oH)(formik, "job.screening_questions_attributes.".concat(index, ".question_type_id")),
                                                        children: [
                                                            " ",
                                                            t("jobs:options:screening:input:answer_type")
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(props.PageStyle.Form__InputSection, " ").concat(props.ScreeningStyle.ScreeningQuestions__BoxSelect, " removeplaceholder"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                    control: "select",
                                                    errorClass: "".concat(props.PageStyle.Form__Error),
                                                    formik: formik,
                                                    options: questionTypes,
                                                    default: formik.values.job.screening_questions_attributes[index].question_type_id,
                                                    onChange: function() {
                                                        var _ref = (0,_async_to_generator/* default */.Z)(function(option) {
                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            formik.setFieldValue("job.screening_questions_attributes.".concat(index, ".question_type_id"), option.value)
                                                                        ];
                                                                    case 1:
                                                                        _state.sent();
                                                                        return [
                                                                            4,
                                                                            formik.setFieldValue("job.screening_questions_attributes.".concat(index, ".question_type_name"), option.name)
                                                                        ];
                                                                    case 2:
                                                                        _state.sent();
                                                                        return [
                                                                            4,
                                                                            onQuestionTypeChanged(formik, index, option.name, t)
                                                                        ];
                                                                    case 3:
                                                                        _state.sent();
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                        return function(option) {
                                                            return _ref.apply(this, arguments);
                                                        };
                                                    }(),
                                                    name: "job.screening_questions_attributes.".concat(index, ".question_type_id"),
                                                    value: questionTypes.filter(function(option) {
                                                        return option.value === formik.values.job.screening_questions_attributes[index].question_type_id;
                                                    }),
                                                    style: (0,input_error/* InputError */.p)(formik, "job.screening_questions_attributes.".concat(index, ".question_type_id")),
                                                    custom_class: "FieldError",
                                                    custom_error_90: "custom_error_90",
                                                    disabled: !editable
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w100 d-flex justify-content-start align-items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(props.ScreeningStyle.ScreeningQuestions__BoxLabels, " wauto"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat(props.ScreeningStyle.ScreeningQuestions__BoxLabel),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "w100 mb0",
                                                        children: [
                                                            " ",
                                                            t("jobs:options:screening:input:required")
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(props.ScreeningStyle.ScreeningQuestions__ToggleSwitch),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: "".concat(props.ScreeningStyle.ScreeningQuestions__Switch, " automationswitch"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "checkbox",
                                                            name: "job.screening_questions_attributes.".concat(index, ".mandatory"),
                                                            defaultChecked: formik.values.job.screening_questions_attributes[index].mandatory,
                                                            onChange: function(event) {
                                                                formik.setFieldValue("job.screening_questions_attributes.".concat(index, ".mandatory"), event.target.checked);
                                                            },
                                                            disabled: !editable
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat(props.ScreeningStyle.ScreeningQuestions__Slider, " automationslider automationround ").concat((0,jobs_common/* toggleDisabled */.$h)(editable))
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    [
                                        common/* QUESTION_TYPES.YES_NO */.j$.YES_NO,
                                        common/* QUESTION_TYPES.SINGLE_CHOICE */.j$.SINGLE_CHOICE,
                                        common/* QUESTION_TYPES.MULTIPLE_CHOICE */.j$.MULTIPLE_CHOICE
                                    ].includes(question.question_type_name) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(props.ScreeningStyle.ScreeningQuestions__BoxLabels),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "".concat((_index_module_default()).Form__Label),
                                                    children: t("jobs:options:screening:input:answer_choice")
                                                })
                                            }),
                                            question.question_options_attributes.map(function(question_option, option_index) {
                                                return !question_option._destroy && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "d-flex ".concat(props.ScreeningStyle.ScreeningQuestions__BoxInput, " removeplaceholder mb20"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                            control: "input",
                                                            errorClass: "".concat(props.PageStyle.Form__Error),
                                                            formik: formik,
                                                            placeholder: optionPlaceholder(question, option_index, t),
                                                            name: "job.screening_questions_attributes.".concat(index, ".question_options_attributes.").concat(option_index, ".option"),
                                                            style: (0,input_error/* InputError */.p)(formik, "job.screening_questions_attributes.".concat(index, ".question_options_attributes.").concat(option_index, ".option")),
                                                            custom_class: "FieldError",
                                                            maxLength: 160,
                                                            disabled: !editable,
                                                            onChange: function() {
                                                                var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    formik.setFieldValue("job.screening_questions_attributes.".concat(index, ".question_options_attributes.").concat(option_index, ".option"), event.target.value || "")
                                                                                ];
                                                                            case 1:
                                                                                _state.sent();
                                                                                if (!(formRef.current.values.job.screening_questions_attributes[index].question_options_attributes.filter(function(x) {
                                                                                    return !x._destroy && x.option && x.option.length > 0;
                                                                                }).length < 2)) return [
                                                                                    3,
                                                                                    3
                                                                                ];
                                                                                return [
                                                                                    4,
                                                                                    formik.setFieldValue("job.screening_questions_attributes.".concat(index, ".option_mandatory"), true)
                                                                                ];
                                                                            case 2:
                                                                                _state.sent();
                                                                                return [
                                                                                    3,
                                                                                    5
                                                                                ];
                                                                            case 3:
                                                                                return [
                                                                                    4,
                                                                                    formik.setFieldValue("job.screening_questions_attributes.".concat(index, ".option_mandatory"), false)
                                                                                ];
                                                                            case 4:
                                                                                _state.sent();
                                                                                _state.label = 5;
                                                                            case 5:
                                                                                return [
                                                                                    2
                                                                                ];
                                                                        }
                                                                    });
                                                                });
                                                                return function(event) {
                                                                    return _ref.apply(this, arguments);
                                                                };
                                                            }()
                                                        }),
                                                        canOptionRemove(question, editable) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "wauto d-flex JustifyEnd AlignCenter ml25 CursorPointer h-48",
                                                            onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                                    switch(_state.label){
                                                                        case 0:
                                                                            return [
                                                                                4,
                                                                                onRemoveChoice(formik, index, option_index)
                                                                            ];
                                                                        case 1:
                                                                            _state.sent();
                                                                            if (!(formRef.current.values.job.screening_questions_attributes[index].question_options_attributes.filter(function(x) {
                                                                                return !x._destroy && x.option && x.option.length > 0;
                                                                            }).length < 2)) return [
                                                                                3,
                                                                                3
                                                                            ];
                                                                            return [
                                                                                4,
                                                                                formik.setFieldValue("job.screening_questions_attributes.".concat(index, ".option_mandatory"), true)
                                                                            ];
                                                                        case 2:
                                                                            _state.sent();
                                                                            return [
                                                                                3,
                                                                                5
                                                                            ];
                                                                        case 3:
                                                                            return [
                                                                                4,
                                                                                formik.setFieldValue("job.screening_questions_attributes.".concat(index, ".option_mandatory"), false)
                                                                            ];
                                                                        case 4:
                                                                            _state.sent();
                                                                            _state.label = 5;
                                                                        case 5:
                                                                            return [
                                                                                2
                                                                            ];
                                                                    }
                                                                });
                                                            }),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Image */.Ee, {
                                                                src: "/icons/close.png",
                                                                height: 14,
                                                                width: 14,
                                                                alt: ""
                                                            })
                                                        })
                                                    ]
                                                }, "question-option-".concat(index, "-").concat(option_index));
                                            })
                                        ]
                                    }),
                                    canOptionAdd(question, editable) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w100 ".concat(props.ScreeningStyle.ScreeningQuestions__BoxChoiceButton, " mt0 mb0"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Button */.zx, {
                                            buttonstyle: "".concat(common/* ButtonStyle.iconTextButton */.ZJ.iconTextButton, " tt-captialize-imp"),
                                            disabled: addChoiceDisabled,
                                            type: "button",
                                            onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                onAddChoice(formik, index)
                                                            ];
                                                        case 1:
                                                            _state.sent();
                                                            if (!(formRef.current.values.job.screening_questions_attributes[index].question_options_attributes.filter(function(x) {
                                                                return !x._destroy && x.option && x.option.length > 0;
                                                            }).length < 2)) return [
                                                                3,
                                                                3
                                                            ];
                                                            return [
                                                                4,
                                                                formik.setFieldValue("job.screening_questions_attributes.".concat(index, ".option_mandatory"), true)
                                                            ];
                                                        case 2:
                                                            _state.sent();
                                                            return [
                                                                3,
                                                                5
                                                            ];
                                                        case 3:
                                                            return [
                                                                4,
                                                                formik.setFieldValue("job.screening_questions_attributes.".concat(index, ".option_mandatory"), false)
                                                            ];
                                                        case 4:
                                                            _state.sent();
                                                            _state.label = 5;
                                                        case 5:
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            }),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(thick_plus/* default */.Z, {}),
                                                t("jobs:options:screening:add:choice")
                                            ]
                                        })
                                    })
                                ]
                            })
                        }, "screening_".concat(index));
                    })
                ]
            }),
            canQuestionAdd(formik, editable) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w100 ".concat(props.ScreeningStyle.ScreeningQuestions__BoxChoiceButton, " "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Button */.zx, {
                    buttonstyle: "".concat(common/* ButtonStyle.iconTextButton */.ZJ.iconTextButton),
                    type: "button",
                    disabled: addQuestionDisabled || !editable,
                    onClick: function() {
                        return onAddQuestion(formik, job_id);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(thick_plus/* default */.Z, {}),
                        t("jobs:options:screening:add:question")
                    ]
                })
            })
        ]
    });
}
;

;// CONCATENATED MODULE: ./src/imports-files/pages/clients/jobs/job-options.js

//-----------------Common ----------------------------

//----------------- Services -----------------------------



//----------------- Services -----------------------------
//-----------------Constant ----------------------------


//-----------------Constant ----------------------------
//----------------- Actions -----------------------------




//----------------- Actions -----------------------------
//----------------- Pages -----------------------------

//----------------- Pages -----------------------------
//----------------- Chips ---------------------

//----------------- Chips ---------------------
//----------------StyleSheet-------------------

// export {default as style} from '@/styles/pages/clients/my-preferences/_index.module.scss';


//----------------StyleSheet-------------------

//----------------- Components -----------------------------
 //----------------- Components -----------------------------


/***/ }),

/***/ 20477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "bJ": function() { return /* reexport */ AddNewAgencyUser; },
  "Xd": function() { return /* reexport */ arrowleft/* default */.Z; },
  "tc": function() { return /* reexport */ back_all_jobs_modal["default"]; },
  "zx": function() { return /* reexport */ components_button/* default */.Z; },
  "ZJ": function() { return /* reexport */ (_index_module_default()); },
  "bO": function() { return /* reexport */ (compare_candidates_index_module_default()); },
  "XZ": function() { return /* reexport */ common/* Checkbox */.XZ; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "QJ": function() { return /* reexport */ common/* DataFromUrl */.QJ; },
  "dC": function() { return /* reexport */ common/* ErrorPages */.dC; },
  "Fb": function() { return /* reexport */ fbicon/* default */.Z; },
  "l0": function() { return /* reexport */ common/* Form */.l0; },
  "J9": function() { return /* reexport */ common/* Formik */.J9; },
  "gt": function() { return /* reexport */ common/* FormikControl */.gt; },
  "Ee": function() { return /* reexport */ (image_default()); },
  "pd": function() { return /* reexport */ common/* InputError */.pd; },
  "oH": function() { return /* reexport */ common/* InputText */.oH; },
  "l": function() { return /* reexport */ common/* JOB_STEPS */.l; },
  "AN": function() { return /* reexport */ job_live/* default */.Z; },
  "ww": function() { return /* reexport */ JobSharing; },
  "Li": function() { return /* reexport */ linkedicon/* default */.Z; },
  "Mf": function() { return /* reexport */ common/* PAGE_ANIMATION_OPTIONS */.Mf; },
  "k2": function() { return /* reexport */ (job_sharing_index_module_default()); },
  "RQ": function() { return /* reexport */ common/* REDIRECT */.RQ; },
  "Us": function() { return /* reexport */ common/* SUCCESS_REPONSE_CODE */.Us; },
  "Lt": function() { return /* reexport */ send_request/* SendRequest */.L; },
  "Rl": function() { return /* reexport */ single_candidate_modal/* SingleCandidateModal */.R; },
  "u": function() { return /* reexport */ common/* Tooltip */.u; },
  "sQ": function() { return /* reexport */ twittericon/* default */.Z; },
  "Mn": function() { return /* reexport */ common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn; },
  "Rs": function() { return /* reexport */ arrowupward; },
  "_g": function() { return /* reexport */ jobs_common/* arrayEquals */._g; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "A$": function() { return /* reexport */ common/* clearSWRCache */.A$; },
  "y$": function() { return /* reexport */ jobs_common/* cursorNone */.y$; },
  "M1": function() { return /* reexport */ jobs_common/* draftJob */.M1; },
  "KI": function() { return /* reexport */ job_sharing/* getActiveIds */.KI; },
  "u3": function() { return /* reexport */ job_sharing/* getJobSharingData */.u3; },
  "lU": function() { return /* reexport */ job_sharing/* getUserSuggestionValue */.lU; },
  "oM": function() { return /* reexport */ job_sharing/* handleActiveJobBoard */.oM; },
  "d1": function() { return /* reexport */ job_sharing/* handleEmailDelete */.d1; },
  "kF": function() { return /* reexport */ job_sharing/* handleJobSharingFormSubmit */.kF; },
  "$y": function() { return /* reexport */ job_sharing/* handleKeyDown */.$y; },
  "GB": function() { return /* reexport */ common/* handleOtherResponseCode */.GB; },
  "gs": function() { return /* reexport */ common/* imageSize */.gs; },
  "I7": function() { return /* reexport */ job_sharing/* isJobForApproval */.I7; },
  "EA": function() { return /* reexport */ common/* motion */.EA; },
  "ro": function() { return /* reexport */ job_sharing/* onUserSuggestionSelection */.ro; },
  "_v": function() { return /* reexport */ job_sharing/* onUserSuggestionsClearRequested */._v; },
  "UA": function() { return /* reexport */ job_sharing/* onUserSuggestionsFetchRequested */.UA; },
  "ao": function() { return /* reexport */ jobs_common/* previewJob */.ao; },
  "Qx": function() { return /* reexport */ job_sharing/* renderInputComponent */.Qx; },
  "LB": function() { return /* reexport */ job_sharing/* renderUserSuggestion */.LB; },
  "KH": function() { return /* reexport */ job_sharing/* shouldRenderSuggestions */.KH; },
  "R": function() { return /* reexport */ job_sharing/* socialIcons */.R; },
  "d3": function() { return /* reexport */ jobs_common/* startDateMessage */.d3; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "NL": function() { return /* reexport */ common/* useQueryClient */.NL; },
  "sO": function() { return /* reexport */ common/* useRef */.sO; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: AutocompleteError, BackArrow, ConfirmationModal, Field, FieldArray, Link, NextServerCookies, RESOURCE_NOT_FOUND_REPONSE_CODE, React, Select, Sidebar, TRANSLATION, Yup, closeModalUsingState, goToNextPage, hideDraft, isEmail, jobStatusBadge, toastr

// EXTERNAL MODULE: ./src/imports-files/pages/clients/jobs/automations.js + 3 modules
var automations = __webpack_require__(64335);
// EXTERNAL MODULE: ./src/styles/components/button/_index.module.scss
var _index_module = __webpack_require__(84215);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/styles/pages/clients/job-sharing/_index.module.scss
var job_sharing_index_module = __webpack_require__(25385);
var job_sharing_index_module_default = /*#__PURE__*/__webpack_require__.n(job_sharing_index_module);
// EXTERNAL MODULE: ./src/styles/pages/clients/compare_candidates/_index.module.scss
var compare_candidates_index_module = __webpack_require__(3002);
var compare_candidates_index_module_default = /*#__PURE__*/__webpack_require__.n(compare_candidates_index_module);
// EXTERNAL MODULE: ../../shared/node_modules/next/image.js
var next_image = __webpack_require__(53429);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../shared/node_modules/next/link.js
var next_link = __webpack_require__(75547);
// EXTERNAL MODULE: ./src/components/modals/single-candidate-modal.js + 1 modules
var single_candidate_modal = __webpack_require__(48151);
// EXTERNAL MODULE: ./public/icons/fbicon.png
var fbicon = __webpack_require__(72358);
// EXTERNAL MODULE: ./public/icons/twittericon.png
var twittericon = __webpack_require__(61515);
// EXTERNAL MODULE: ./public/icons/linkedicon.png
var linkedicon = __webpack_require__(51536);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
;// CONCATENATED MODULE: ./public/icons/compare_candidates/arrowback.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgArrowback = function SvgArrowback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 20 1.41-1.41L3.83 11H24V9H3.83l7.58-7.59L10 0 0 10l10 10Z",
    fill: "var(--default-text-color)"
  })));
};

/* harmony default export */ var arrowback = ((/* unused pure expression or super */ null && (SvgArrowback)));
// EXTERNAL MODULE: ./public/icons/arrowleft.svg
var arrowleft = __webpack_require__(65661);
;// CONCATENATED MODULE: ./public/icons/compare_candidates/arrowupward.svg
var arrowupward_path;

function arrowupward_extends() { arrowupward_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrowupward_extends.apply(this, arguments); }



var SvgArrowupward = function SvgArrowupward(props) {
  return /*#__PURE__*/react.createElement("svg", arrowupward_extends({
    width: 9,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), arrowupward_path || (arrowupward_path = /*#__PURE__*/react.createElement("path", {
    d: "M2.45.25V1H7.17L.95 7.221l.529.529L7.7 1.529V6.25h.75v-6h-6Z",
    fill: "#fff"
  })));
};

/* harmony default export */ var arrowupward = (SvgArrowupward);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
// EXTERNAL MODULE: ./src/services/common/send-request.js
var send_request = __webpack_require__(34964);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
;// CONCATENATED MODULE: ./src/services/pages/clients/jobs/job-sharing.js







var JobSharing = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(JobSharing, SendRequest);
    var _super = (0,_create_super/* default */.Z)(JobSharing);
    function JobSharing() {
        (0,_class_call_check/* default */.Z)(this, JobSharing);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(JobSharing, [
        {
            key: "getJobBoards",
            value: // async getJobBoards(client_auth_cookies, jobId) {
            //   try {
            //     const result = await axios({
            //       method: 'get',
            //       url: API.client.jobs.GET_JOB_BOARDS.replace('$job_id', jobId),
            //       headers: {cookie: `Authorization=${client_auth_cookies}`},
            //       params: {},
            //     });
            //     return result.data;
            //   } catch (error) {
            //     return error;
            //   }
            // }
            function getJobBoards(jobId) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(common/* API.client.jobs.GET_JOB_BOARDS.replace */.bl.client.jobs.GET_JOB_BOARDS.replace("$job_id", jobId), (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addJobBoards",
            value: function addJobBoards(params, jobId) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(common/* API.client.jobs.ADD_JOB_BOARDS.replace */.bl.client.jobs.ADD_JOB_BOARDS.replace("$job_id", jobId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getUserByNameOrEmail",
            value: function getUserByNameOrEmail(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(common/* API.client.jobs.GET_AGENCY_USERS */.bl.client.jobs.GET_AGENCY_USERS, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAgencyOrClientUserByNameOrEmail",
            value: function getAgencyOrClientUserByNameOrEmail(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(common/* API.client.jobs.GET_SHARE_USERS */.bl.client.jobs.GET_SHARE_USERS, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "checkAgencyUserExist",
            value: function checkAgencyUserExist(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(common/* API.client.jobs.CHECK_AGENCY_USER_EXIST */.bl.client.jobs.CHECK_AGENCY_USER_EXIST, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addAgencyUserResponse",
            value: function addAgencyUserResponse(params, jobId) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(common/* API.client.jobs.ADD_AGENCY_USER_RESPONSE.replace */.bl.client.jobs.ADD_AGENCY_USER_RESPONSE.replace("$job_id", jobId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return JobSharing;
}(send_request/* SendRequest */.L);

// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/job-sharing.js
var job_sharing = __webpack_require__(11007);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/pages/clients/jobs/back-all-jobs-modal.js
var back_all_jobs_modal = __webpack_require__(92867);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/common.js
var jobs_common = __webpack_require__(90432);
// EXTERNAL MODULE: ./src/components/job-live.js + 3 modules
var job_live = __webpack_require__(39006);
// EXTERNAL MODULE: ./src/components/confirmation-modal.js
var confirmation_modal = __webpack_require__(72055);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/imports-files/components/add-to-job-modal.js + 2 modules
var add_to_job_modal = __webpack_require__(60838);
// EXTERNAL MODULE: ./src/imports-files/components/review-email.js + 1 modules
var review_email = __webpack_require__(3623);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/company/invite-agency-users.js + 3 modules
var invite_agency_users = __webpack_require__(33908);
// EXTERNAL MODULE: ./public/icons/closewhite.svg
var closewhite = __webpack_require__(70394);
// EXTERNAL MODULE: ./public/icons/error_exclamation.svg
var error_exclamation = __webpack_require__(71843);
// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(85155);
// EXTERNAL MODULE: ./src/imports-files/components/common-modal/common-modal.js + 2 modules
var common_modal = __webpack_require__(66172);
// EXTERNAL MODULE: ./src/components/common-modal/modal.js + 2 modules
var modal = __webpack_require__(99005);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/candidates/kanban.js + 10 modules
var kanban = __webpack_require__(47942);
;// CONCATENATED MODULE: ./src/components/add-new-agency-user-modal.js















function AddNewAgencyUser(props) {
    var ref = (0,common/* useTranslation */.$G)(), t = ref.t, i18n = ref.i18n;
    var formRef = (0,invite_agency_users/* useRef */.sO)();
    var ref1 = (0,add_to_job_modal/* useState */.eJ)(), data = ref1.data, error = ref1.error;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,add_to_job_modal/* useState */.eJ)({
        existing_agency: true,
        agency_id: "",
        agency_name: ""
    }), 2), initialValues = ref2[0], setInitialValues = ref2[1];
    var schema = common/* Yup.object */.sm.object({
        existing_agency: common/* Yup.boolean */.sm.boolean().nullable(),
        agency_id: common/* Yup.string */.sm.string().when("existing_agency", {
            is: function(existing_agency) {
                return existing_agency;
            },
            then: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable(),
            otherwise: common/* Yup.string */.sm.string().notRequired()
        }),
        agency_name: common/* Yup.string */.sm.string().when("existing_agency", {
            is: function(existing_agency) {
                return !existing_agency;
            },
            then: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable(),
            otherwise: common/* Yup.string */.sm.string().notRequired()
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(add_to_job_modal/* Formik */.J9, {
        initialValues: initialValues,
        validationSchema: schema,
        innerRef: formRef,
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!values.existing_agency) values.agency_id = "";
                            return [
                                4,
                                (0,job_sharing/* submitAgencyResponse */.aI)(values, props.addAgencyModal, props.setAddAgencyModal, props.job_id)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }(),
        children: function(formik) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                    type: "form",
                    heading: t("modal:form:new_agency:add"),
                    closeModal: function() {
                        props.setAddAgencyModal({
                            state: false
                        });
                    },
                    content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(add_to_job_modal/* Form */.l0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "WrapperRadio w100 mt40 mb20",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: "Dpflex WrapperRadioContainer WrapperRadiocheckmarkfont mb0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Field */.gN, {
                                                type: "radio",
                                                name: "existing_agency",
                                                id: "option-1",
                                                value: true,
                                                onChange: function(event) {
                                                    formik.setFieldValue("existing_agency", true);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "WrapperRadiocheckmark m0"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "ml5",
                                                children: t("modal:form:new_agency:existing")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: "Dpflex WrapperRadioContainer WrapperRadiocheckmarkfont mb0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Field */.gN, {
                                                type: "radio",
                                                name: "existing_agency",
                                                id: "option-2",
                                                value: false,
                                                onChange: function(event) {
                                                    formik.setFieldValue("existing_agency", false);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "WrapperRadiocheckmark m0"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "ml5",
                                                children: t("modal:form:new_agency:add_new")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            formik.values.existing_agency && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block__Description */.w2.Modal__Container__ContentSection__Block__Description, " mb30"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: t("modal:form:new_agency:choose")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: invite_agency_users/* PageStyle.Form__TableCol */.k2.Form__TableCol,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: "".concat(invite_agency_users/* PageStyle.Form__Label */.k2.Form__Label, " ").concat(invite_agency_users/* PageStyle.Form__FloatingLabel */.k2.Form__FloatingLabel),
                                                style: (0,add_to_job_modal/* InputText */.oH)(formik, "agency_id"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "red-color",
                                                        children: "*"
                                                    }),
                                                    "\xa0",
                                                    t("label:select_agency")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(add_to_job_modal/* FormikControl */.gt, {
                                                className: "".concat(invite_agency_users/* PageStyle.Form__CustomSelect */.k2.Form__CustomSelect, " ").concat(invite_agency_users/* PageStyle.widthauto */.k2.widthauto, " pb20"),
                                                control: "select",
                                                default: "",
                                                formik: formik,
                                                name: "agency_id",
                                                onChange: function(option) {
                                                    return formik.setFieldValue("agency_id", option.value);
                                                },
                                                options: props.agency_list,
                                                style: (0,add_to_job_modal/* InputError */.pd)(formik, "agency_id"),
                                                value: props.agency_list.filter(function(option) {
                                                    return option.value === formik.values.agency_id;
                                                }),
                                                disabled: false
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "height113 mt9"
                                    })
                                ]
                            }),
                            !formik.values.existing_agency && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block__Description */.w2.Modal__Container__ContentSection__Block__Description, " mb30"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: t("modal:form:new_agency:enter_name")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: invite_agency_users/* PageStyle.Form__TableCol */.k2.Form__TableCol,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: "".concat(invite_agency_users/* PageStyle.Form__Label */.k2.Form__Label, " ").concat(invite_agency_users/* PageStyle.Form__FloatingLabel */.k2.Form__FloatingLabel),
                                                style: (0,add_to_job_modal/* InputText */.oH)(formik, "agency_name"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "red-color",
                                                        children: "*"
                                                    }),
                                                    "\xa0",
                                                    t("label:add_new_agency")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(add_to_job_modal/* FormikControl */.gt, {
                                                control: "input",
                                                type: "text",
                                                formik: formik,
                                                name: "agency_name",
                                                className: invite_agency_users/* PageStyle.Form__Input */.k2.Form__Input,
                                                errorClass: invite_agency_users/* PageStyle.Form__Error */.k2.Form__Error,
                                                style: (0,add_to_job_modal/* InputError */.pd)(formik, "agency_name"),
                                                disabled: false
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "height113"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: review_email/* FormModalStyle.Modal__Container__ButtonSection */.w2.Modal__Container__ButtonSection,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(add_to_job_modal/* Button */.zx, {
                                        buttonstyle: review_email/* FormModalStyle.secondarybtn */.w2.secondarybtn,
                                        onClick: function() {
                                            props.setAddAgencyModal({
                                                state: false
                                            });
                                        },
                                        children: t("button:cancel")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(add_to_job_modal/* Button */.zx, {
                                        buttonstyle: review_email/* FormModalStyle.primarybtn */.w2.primarybtn,
                                        type: "submit",
                                        children: t("button:save")
                                    })
                                ]
                            })
                        ]
                    })
                })
            });
        }
    });
}

;// CONCATENATED MODULE: ./src/imports-files/pages/clients/jobs/job-sharing.js

//--------------------StyleSheet -------------------



//--------------------StyleSheet -------------------
//-------------------- Components --------------




//-------------------- Components --------------
//-------------------Image --------------------






//-------------------Image --------------------
//------------------Custom Components -------------

//------------------Custom Components -------------







// export {default as JobPreviewPage} from '@/pages/clients/dashboard/jobs/job-preview'






/***/ }),

/***/ 44791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* reexport safe */ _actions_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__.$0; },
/* harmony export */   "DO": function() { return /* reexport safe */ _actions_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__.DO; },
/* harmony export */   "DT": function() { return /* reexport safe */ _services_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_13__.D; },
/* harmony export */   "Dg": function() { return /* reexport safe */ _actions_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__.Dg; },
/* harmony export */   "EA": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.EA; },
/* harmony export */   "Fb": function() { return /* reexport safe */ _components_job_action_options__WEBPACK_IMPORTED_MODULE_8__.F; },
/* harmony export */   "GB": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.GB; },
/* harmony export */   "Jr": function() { return /* reexport safe */ public_icons_check_svg__WEBPACK_IMPORTED_MODULE_18__.Z; },
/* harmony export */   "KU": function() { return /* reexport safe */ _actions_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__.rU; },
/* harmony export */   "Lt": function() { return /* reexport safe */ _services_common_send_request__WEBPACK_IMPORTED_MODULE_12__.L; },
/* harmony export */   "MT": function() { return /* reexport safe */ _components_third_party_logo__WEBPACK_IMPORTED_MODULE_4__.Z; },
/* harmony export */   "Mf": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.Mf; },
/* harmony export */   "Mn": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.Mn; },
/* harmony export */   "NL": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.NL; },
/* harmony export */   "Ni": function() { return /* reexport safe */ _actions_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__.Ni; },
/* harmony export */   "Ot": function() { return /* reexport default from dynamic */ _styles_pages_clients_templates_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default.a; },
/* harmony export */   "RQ": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.RQ; },
/* harmony export */   "SU": function() { return /* reexport safe */ public_icons_clock_yellow_svg__WEBPACK_IMPORTED_MODULE_20__.Z; },
/* harmony export */   "UI": function() { return /* reexport safe */ _components_modals_information_modal__WEBPACK_IMPORTED_MODULE_11__.U; },
/* harmony export */   "Us": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.Us; },
/* harmony export */   "Vm": function() { return /* reexport safe */ _actions_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__.Vm; },
/* harmony export */   "WR": function() { return /* reexport safe */ public_icons_rejected_svg__WEBPACK_IMPORTED_MODULE_21__.Z; },
/* harmony export */   "XG": function() { return /* reexport safe */ _actions_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__.XG; },
/* harmony export */   "Y5": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.Y5; },
/* harmony export */   "Z9": function() { return /* reexport safe */ _constants_pages_clients_jobs_jobs__WEBPACK_IMPORTED_MODULE_1__.Z9; },
/* harmony export */   "ZJ": function() { return /* reexport default from dynamic */ _styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_23___default.a; },
/* harmony export */   "_7": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__._7; },
/* harmony export */   "_V": function() { return /* reexport safe */ _actions_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__._V; },
/* harmony export */   "az": function() { return /* reexport safe */ _actions_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__.az; },
/* harmony export */   "bb": function() { return /* reexport safe */ public_icons_dots_svg__WEBPACK_IMPORTED_MODULE_16__.Z; },
/* harmony export */   "bl": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.bl; },
/* harmony export */   "d4": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.d4; },
/* harmony export */   "dH": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.dH; },
/* harmony export */   "eJ": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.eJ; },
/* harmony export */   "fC": function() { return /* reexport safe */ _actions_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__.fC; },
/* harmony export */   "hh": function() { return /* reexport safe */ _components_customDatatable_datatable__WEBPACK_IMPORTED_MODULE_5__.h; },
/* harmony export */   "k2": function() { return /* reexport default from dynamic */ _styles_pages_jobs_job_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default.a; },
/* harmony export */   "k3": function() { return /* reexport safe */ _actions_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__.k3; },
/* harmony export */   "kI": function() { return /* reexport safe */ _components_job_filters__WEBPACK_IMPORTED_MODULE_6__.k; },
/* harmony export */   "nL": function() { return /* reexport safe */ public_icons_warning_svg__WEBPACK_IMPORTED_MODULE_19__.Z; },
/* harmony export */   "od": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.od; },
/* harmony export */   "op": function() { return /* reexport safe */ _actions_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__.op; },
/* harmony export */   "tv": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.tv; },
/* harmony export */   "v3": function() { return /* reexport safe */ public_icons_plus_svg__WEBPACK_IMPORTED_MODULE_15__.Z; },
/* harmony export */   "vW": function() { return /* reexport safe */ _actions_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__.vW; },
/* harmony export */   "wn": function() { return /* reexport safe */ public_new_icons_filter_icon_svg__WEBPACK_IMPORTED_MODULE_14__.Z; },
/* harmony export */   "x4": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__.x4; },
/* harmony export */   "zx": function() { return /* reexport safe */ _components_button__WEBPACK_IMPORTED_MODULE_22__.Z; }
/* harmony export */ });
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96047);
/* harmony import */ var _constants_pages_clients_jobs_jobs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51560);
/* harmony import */ var _actions_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98303);
/* harmony import */ var _hooks_job_filters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57773);
/* harmony import */ var _components_third_party_logo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50261);
/* harmony import */ var _components_customDatatable_datatable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54489);
/* harmony import */ var _components_job_filters__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60353);
/* harmony import */ var _imports_files_components_sidebar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86064);
/* harmony import */ var _components_job_action_options__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69991);
/* harmony import */ var _components_close_job_modal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75646);
/* harmony import */ var _components_confirmation_modal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(72055);
/* harmony import */ var _components_modals_information_modal__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3038);
/* harmony import */ var _services_common_send_request__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34964);
/* harmony import */ var _services_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(23152);
/* harmony import */ var public_new_icons_filter_icon_svg__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(4025);
/* harmony import */ var public_icons_plus_svg__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(65099);
/* harmony import */ var public_icons_dots_svg__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(30054);
/* harmony import */ var public_icons_close_svg__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(85155);
/* harmony import */ var public_icons_check_svg__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(11632);
/* harmony import */ var public_icons_warning_svg__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(51750);
/* harmony import */ var public_icons_clock_yellow_svg__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(11473);
/* harmony import */ var public_icons_rejected_svg__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(1400);
/* harmony import */ var _components_button__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(95662);
/* harmony import */ var _styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(84215);
/* harmony import */ var _styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _styles_pages_jobs_job_index_module_scss__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(36647);
/* harmony import */ var _styles_pages_jobs_job_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_jobs_job_index_module_scss__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _styles_pages_clients_templates_index_module_scss__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(54552);
/* harmony import */ var _styles_pages_clients_templates_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_clients_templates_index_module_scss__WEBPACK_IMPORTED_MODULE_25__);

// ------------------- CONSTANTS -------------------

// ------------------- CONSTANTS -------------------
// ------------------- ACTIONS -------------------

// ------------------- ACTIONS -------------------
// -------------------  HOOKS ------------------- 

// -------------------  HOOKS ------------------- 
// ------------------- COMPONENTS -------------------








// ------------------- COMPONENTS -------------------
// ------------------- SERVICES -------------------


// ------------------- SERVICES -------------------
// ------------------- ICONS -------------------









// ------------------- ICONS -------------------
// ------------------- STYLESHEET -------------------



 // ------------------- STYLESHEET -------------------


/***/ }),

/***/ 13245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "Xd": function() { return /* reexport */ arrowleft/* default */.Z; },
  "PG": function() { return /* reexport */ common/* AutocompleteError */.PG; },
  "tc": function() { return /* reexport */ back_all_jobs_modal["default"]; },
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "ZJ": function() { return /* reexport */ common/* ButtonStyle */.ZJ; },
  "XZ": function() { return /* reexport */ common/* Checkbox */.XZ; },
  "bN": function() { return /* reexport */ common/* CheckedCheckbox */.bN; },
  "LD": function() { return /* reexport */ common/* ClientDashboard */.LD; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "QJ": function() { return /* reexport */ common/* DataFromUrl */.QJ; },
  "v0": function() { return /* reexport */ common/* DefaultCheckbox */.v0; },
  "g2": function() { return /* reexport */ common/* DisabledCheckbox */.g2; },
  "gw": function() { return /* reexport */ edit_job/* EditJob */.g; },
  "dC": function() { return /* reexport */ common/* ErrorPages */.dC; },
  "P5": function() { return /* reexport */ common/* Exclamation */.P5; },
  "gN": function() { return /* reexport */ common/* Field */.gN; },
  "$_": function() { return /* reexport */ footer/* Footer */.$; },
  "l0": function() { return /* reexport */ common/* Form */.l0; },
  "x": function() { return /* reexport */ common/* FormStyle */.x; },
  "J9": function() { return /* reexport */ common/* Formik */.J9; },
  "gt": function() { return /* reexport */ common/* FormikControl */.gt; },
  "h4": function() { return /* reexport */ header/* Header */.h; },
  "N7": function() { return /* reexport */ INITIAL_VALUES; },
  "pd": function() { return /* reexport */ common/* InputError */.pd; },
  "oH": function() { return /* reexport */ common/* InputText */.oH; },
  "eP": function() { return /* reexport */ common/* JOB_STAGES */.eP; },
  "l": function() { return /* reexport */ common/* JOB_STEPS */.l; },
  "oI": function() { return /* reexport */ jobs_new/* Job */.o; },
  "E8": function() { return /* reexport */ job_form["default"]; },
  "gb": function() { return /* reexport */ common/* Loading */.gb; },
  "jP": function() { return /* reexport */ (new_view_job_index_module_default()); },
  "Ki": function() { return /* reexport */ NumberField; },
  "Mf": function() { return /* reexport */ common/* PAGE_ANIMATION_OPTIONS */.Mf; },
  "k2": function() { return /* reexport */ (_index_module_default()); },
  "j$": function() { return /* reexport */ common/* QUESTION_TYPES */.j$; },
  "RQ": function() { return /* reexport */ common/* REDIRECT */.RQ; },
  "u2": function() { return /* reexport */ sidebar/* SIDEBAR_OPTIONS */.u2; },
  "Us": function() { return /* reexport */ common/* SUCCESS_REPONSE_CODE */.Us; },
  "A9": function() { return /* reexport */ SelectJobModal; },
  "t": function() { return /* reexport */ common/* SelectedDisabledCheckbox */.t; },
  "Lt": function() { return /* reexport */ common/* SendRequest */.Lt; },
  "TA": function() { return /* reexport */ common/* TRANSLATION */.TA; },
  "Mn": function() { return /* reexport */ common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn; },
  "sm": function() { return /* reexport */ common/* Yup */.sm; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "q$": function() { return /* reexport */ canGenerateDescription; },
  "A$": function() { return /* reexport */ common/* clearSWRCache */.A$; },
  "wx": function() { return /* reexport */ index_4bd03571_esm.c; },
  "y$": function() { return /* reexport */ jobs_common/* cursorNone */.y$; },
  "M1": function() { return /* reexport */ jobs_common/* draftJob */.M1; },
  "By": function() { return /* reexport */ getDepartmentsList; },
  "cm": function() { return /* reexport */ getJobEditInitials; },
  "WU": function() { return /* reexport */ getJobInitials; },
  "o$": function() { return /* reexport */ getJobTitles; },
  "r5": function() { return /* reexport */ getRequiredApprovedHash; },
  "Gg": function() { return /* reexport */ common/* getSession */.Gg; },
  "yf": function() { return /* reexport */ getValueHash; },
  "xz": function() { return /* reexport */ handleFormSubmit; },
  "GB": function() { return /* reexport */ common/* handleOtherResponseCode */.GB; },
  "GM": function() { return /* reexport */ handleRequiredApproved; },
  "OP": function() { return /* reexport */ jobs_common/* jobStatusBadge */.OP; },
  "aD": function() { return /* reexport */ job_validation; },
  "EA": function() { return /* reexport */ common/* motion */.EA; },
  "ao": function() { return /* reexport */ jobs_common/* previewJob */.ao; },
  "bT": function() { return /* reexport */ common/* sendToCurrentSteps */.bT; },
  "xi": function() { return /* reexport */ showImportPreviousJob; },
  "xQ": function() { return /* reexport */ toneOfVoiceList; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "NL": function() { return /* reexport */ common/* useQueryClient */.NL; },
  "sO": function() { return /* reexport */ common/* useRef */.sO; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: Datetime, HoverCheckbox, Image, Link, NextServerCookies, RESOURCE_NOT_FOUND_REPONSE_CODE, React, Select, Sidebar, arrayEquals, generateDescription, getClientUsers, getJobWithTitleId, goToNextPage, hideDraft, isFloat, languageList, moment, style, toastr, useNavbarStatus

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ../../shared/node_modules/react-select/dist/index-4bd03571.esm.js + 1 modules
var index_4bd03571_esm = __webpack_require__(28805);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(18186);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/imports-files/components/model/select-job-modal.js + 3 modules
var select_job_modal = __webpack_require__(28801);
// EXTERNAL MODULE: ./src/imports-files/components/common-modal/common-modal.js + 2 modules
var common_modal = __webpack_require__(66172);
// EXTERNAL MODULE: ./src/components/common-modal/modal.js + 2 modules
var modal = __webpack_require__(99005);
;// CONCATENATED MODULE: ./src/components/modals/select-job-modal.js






function SelectJobModal(props) {
    var t = (0,select_job_modal/* useTranslation */.$G)().t;
    (0,select_job_modal/* clearSWRCache */.A$)("import-previous-application");
    var ref = (0,_sliced_to_array/* default */.Z)((0,select_job_modal/* useState */.eJ)(null), 2), apiError = ref[0], setApiError = ref[1];
    var router = (0,select_job_modal/* useRouter */.tv)();
    var errorPages = new select_job_modal/* ErrorPages */.dC();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,select_job_modal/* useState */.eJ)({}), 2), initialValues = ref1[0], setInitialValues = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,select_job_modal/* useState */.eJ)(true), 2), isLoading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,select_job_modal/* useState */.eJ)(0), 2), flagForRerender = ref3[0], setFlagForRerender = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,select_job_modal/* useState */.eJ)({}), 2), options = ref4[0], setOptions = ref4[1];
    var formRef = (0,select_job_modal/* useRef */.sO)(null);
    var selectJobRef = (0,select_job_modal/* useRef */.sO)(null);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,select_job_modal/* useState */.eJ)(null), 2), checkboxStep = ref5[0], setCheckboxStep = ref5[1];
    var selectJobModalAction = new select_job_modal/* SelectJobModalAction */.Fr(props.setShowLoader, setApiError, setOptions, checkboxStep, setCheckboxStep, setFlagForRerender, router, props.setButtonPopup, formRef, selectJobRef);
    var ref6 = (0,select_job_modal/* useSWR */.dH)("import-previous-application", function() {
        return selectJobModalAction.getPreviousJobData({});
    }), data = ref6.data, error = ref6.error;
    (0,select_job_modal/* useEffect */.d4)(function() {
        if (data) {
            setInitialValues(data.data);
            setLoading(false);
            setOptions(selectJobModalAction.dropdownJobOptions(data.data, t));
            setCheckboxStep({
                details: false,
                stages: false,
                automations: false,
                scorecards: false,
                sharing: false
            });
        }
    }, [
        data
    ]);
    if (isLoading || error || errorPages.handleErrorCodes(apiError === null || apiError === void 0 ? void 0 : apiError.status)) {
        var renderPage = error || apiError ? errorPages.renderPage((error === null || error === void 0 ? void 0 : error.status) || (apiError === null || apiError === void 0 ? void 0 : apiError.status), router) : null;
        return renderPage;
    }
    return props.buttonPopup ? /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        type: "form",
        heading: t("modal:form:import:previous_job:heading"),
        closeModal: function(event) {
            props.setButtonPopup(false);
        },
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection */.w2.Modal__Container__ContentSection),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Description */.w2.Modal__Container__ContentSection__Description),
                        children: t("modal:form:import:previous_job:description")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* Formik */.J9, {
                        initialValues: select_job_modal/* CONSTANTS.formInitialValues */.tl.formInitialValues,
                        validationSchema: (0,select_job_modal/* SELECT_JOB_VALIDATION */.A0)(t),
                        innerRef: formRef,
                        onSubmit: function(values) {
                            selectJobModalAction.submitForm(values);
                        },
                        children: function(formik) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                className: common_modal/* FormModalStyle.Modal__Container__ContentSection__FormContainer */.w2.Modal__Container__ContentSection__FormContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_job_modal/* Form */.l0, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-100 ".concat(select_job_modal/* FormStyle.Form__LabelCheck */.x.Form__LabelCheck, " ").concat(select_job_modal/* PageStyle.SelectJob__DisplayFlex */.k2.SelectJob__DisplayFlex, " Mui__CustomCheckbox"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* Checkbox */.XZ, {
                                                    onChange: function(event) {
                                                        selectJobModalAction.getArchiveJob(event, t);
                                                    },
                                                    className: "height23",
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* DefaultCheckbox */.v0, {}),
                                                    checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* CheckedCheckbox */.bN, {})
                                                }),
                                                t("modal:form:import:previous_job:include")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat(select_job_modal/* FormStyle.Form__TableCol */.x.Form__TableCol, " mt30"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: "".concat(select_job_modal/* FormStyle.Form__FloatingLabel */.x.Form__FloatingLabel, " mb0"),
                                                    style: (0,select_job_modal/* InputText */.oH)(formik, "select_job"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "red-color",
                                                            children: "*"
                                                        }),
                                                        " ",
                                                        t("modal:form:import:previous_job:job_title")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-100",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: select_job_modal/* PageStyle.SelectJob__CustomSelectWidth */.k2.SelectJob__CustomSelectWidth,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* FormikControl */.gt, {
                                                            control: "select",
                                                            reference: selectJobRef,
                                                            formik: formik,
                                                            name: "select_job",
                                                            className: "".concat(select_job_modal/* PageStyle.CustomSelect */.k2.CustomSelect, " ").concat(select_job_modal/* FormStyle.CustomSelect */.x.CustomSelect),
                                                            options: options,
                                                            onChange: function(value) {
                                                                formik.setFieldValue("select_job", value === null || value === void 0 ? void 0 : value.value);
                                                            },
                                                            style: (0,select_job_modal/* InputError */.pd)(formik, "select_job"),
                                                            components: {
                                                                GroupHeading: GroupHeading
                                                            },
                                                            default: {
                                                                label: "",
                                                                values: ""
                                                            }
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-100 ".concat(select_job_modal/* PageStyle.SelectJob__Checkoptions */.k2.SelectJob__Checkoptions, " mt0"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat(select_job_modal/* PageStyle.SelectJob__DisplayFlex */.k2.SelectJob__DisplayFlex, " ").concat(select_job_modal/* FormStyle.Form__LabelCheck */.x.Form__LabelCheck, " Mui__CustomCheckbox mb10 ImportSteps"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* Checkbox */.XZ, {
                                                            name: "details",
                                                            onChange: function(event) {
                                                                selectJobModalAction.checkboxChange(event, formik);
                                                            },
                                                            value: "details",
                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* DefaultCheckbox */.v0, {}),
                                                            checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* CheckedCheckbox */.bN, {})
                                                        }),
                                                        " ",
                                                        t("modal:form:import:previous_job:job_details")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat(select_job_modal/* PageStyle.SelectJob__DisplayFlex */.k2.SelectJob__DisplayFlex, " ").concat(select_job_modal/* FormStyle.Form__LabelCheck */.x.Form__LabelCheck, " Mui__CustomCheckbox mb10 ImportSteps"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* Checkbox */.XZ, {
                                                            name: "details",
                                                            onChange: function(event) {
                                                                selectJobModalAction.checkboxChange(event, formik);
                                                            },
                                                            value: "options",
                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* DefaultCheckbox */.v0, {}),
                                                            checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* CheckedCheckbox */.bN, {})
                                                        }),
                                                        " ",
                                                        t("modal:form:import:previous_job:job_options")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat(select_job_modal/* PageStyle.SelectJob__DisplayFlex */.k2.SelectJob__DisplayFlex, " ").concat(select_job_modal/* FormStyle.Form__LabelCheck */.x.Form__LabelCheck, " Mui__CustomCheckbox mb10"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* Checkbox */.XZ, {
                                                            name: "stages",
                                                            onChange: function(event) {
                                                                selectJobModalAction.checkboxChange(event, formik);
                                                            },
                                                            value: "stages",
                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* DefaultCheckbox */.v0, {}),
                                                            checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* CheckedCheckbox */.bN, {})
                                                        }),
                                                        " ",
                                                        t("modal:form:import:previous_job:interview_stages")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat(select_job_modal/* PageStyle.SelectJob__DisplayFlex */.k2.SelectJob__DisplayFlex, " ").concat(select_job_modal/* FormStyle.Form__LabelCheck */.x.Form__LabelCheck, " Mui__CustomCheckbox mb10 ").concat(!checkboxStep.stages ? "disabledautomation" : ""),
                                                    children: !checkboxStep.stages ? /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* Tooltip */.u, {
                                                        className: "SimpleTooltip",
                                                        content: t("modal:form:import:previous_job:tooltip"),
                                                        background: "#00325A",
                                                        radius: 20,
                                                        padding: 8,
                                                        placement: "right",
                                                        fontSize: "12px",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "tooltipwidthautomation d-flex Dpflex16 align-items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* Checkbox */.XZ, {
                                                                    checked: checkboxStep.automations,
                                                                    name: "automations",
                                                                    onChange: function(event) {
                                                                        selectJobModalAction.checkboxChange(event, formik);
                                                                    },
                                                                    value: "automations",
                                                                    disabled: !checkboxStep.stages,
                                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* DisabledCheckbox */.g2, {}),
                                                                    checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* DisabledCheckbox */.g2, {})
                                                                }),
                                                                " ",
                                                                t("modal:form:import:previous_job:interview_details")
                                                            ]
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* Checkbox */.XZ, {
                                                                checked: checkboxStep.automations,
                                                                name: "automations",
                                                                onChange: function(event) {
                                                                    selectJobModalAction.checkboxChange(event, formik);
                                                                },
                                                                value: "automations",
                                                                disabled: !checkboxStep.stages,
                                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* DefaultCheckbox */.v0, {}),
                                                                checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* CheckedCheckbox */.bN, {})
                                                            }),
                                                            " ",
                                                            t("modal:form:import:previous_job:interview_details")
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat(select_job_modal/* PageStyle.SelectJob__DisplayFlex */.k2.SelectJob__DisplayFlex, " ").concat(select_job_modal/* FormStyle.Form__LabelCheck */.x.Form__LabelCheck, " Mui__CustomCheckbox mb10"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* Checkbox */.XZ, {
                                                            name: "scorecards",
                                                            onChange: function(event) {
                                                                selectJobModalAction.checkboxChange(event, formik);
                                                            },
                                                            value: "scorecards",
                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* DefaultCheckbox */.v0, {}),
                                                            checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* CheckedCheckbox */.bN, {})
                                                        }),
                                                        " ",
                                                        t("modal:form:import:previous_job:scorecards")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat(select_job_modal/* PageStyle.SelectJob__DisplayFlex */.k2.SelectJob__DisplayFlex, " ").concat(select_job_modal/* FormStyle.Form__LabelCheck */.x.Form__LabelCheck, " Mui__CustomCheckbox"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* Checkbox */.XZ, {
                                                            name: "sharing",
                                                            onChange: function(event) {
                                                                selectJobModalAction.checkboxChange(event, formik);
                                                            },
                                                            value: "sharing",
                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* DefaultCheckbox */.v0, {}),
                                                            checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* CheckedCheckbox */.bN, {})
                                                        }),
                                                        " ",
                                                        t("modal:form:import:previous_job:sharing")
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: select_job_modal/* PageStyle.SelectJob__Footer */.k2.SelectJob__Footer,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: select_job_modal/* PageStyle.SelectJob__ButtonAction */.k2.SelectJob__ButtonAction,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* Button */.zx, {
                                                    buttonstyle: select_job_modal/* PageStyle.primarybtn */.k2.primarybtn,
                                                    type: "submit",
                                                    children: t("button:import:default")
                                                })
                                            })
                                        })
                                    ]
                                })
                            });
                        }
                    })
                ]
            })
        })
    }) : "";
}
function GroupHeading(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_job_modal/* components.GroupHeading */.wx.GroupHeading, (0,_object_spread/* default */.Z)({}, props))
    });
}

// EXTERNAL MODULE: ./public/icons/arrowleft.svg
var arrowleft = __webpack_require__(65661);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(38641);
;// CONCATENATED MODULE: ./src/constants/pages/clients/jobs/new.js


var INITIAL_VALUES = {
    job: {
        job_title_name: "",
        internal_reference: "",
        industry_id: "",
        department: "",
        is_remote: false,
        is_hybrid: false,
        location_attributes: {
            full_address: ""
        },
        employment_type: "",
        contract_type: "",
        job_salary_detail_attributes: {
            salary_choice: "range",
            currency_id: "",
            salary_duration: "",
            min_salary: "",
            max_salary: "",
            salary_hidden: false,
            salary_displayed: ""
        },
        description: "",
        seniority_level_id: "",
        education: "",
        job_owner_emails: new Array(),
        job_owner_initials: new Array(),
        editable: true,
        without_cv: false
    }
};
function job_validation(submitState, job_status) {
    var validationRequired = !(submitState == "draft" || submitState == "preview" && job_status != "active");
    if (validationRequired) {
        return validationJobform();
    } else {
        return validateOnlyTitle();
    }
}
function validateOnlyTitle() {
    return common/* Yup.object */.sm.object().shape({
        job: common/* Yup.object */.sm.object().shape({
            job_title_name: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required"))
        })
    });
}
function validationJobform() {
    var _obj;
    return common/* Yup.object */.sm.object().shape({
        job: common/* Yup.object */.sm.object().shape({
            job_title_name: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).trim().min(4, (0,common/* TRANSLATION */.TA)("errors:characters_long")),
            industry_id: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable(),
            employment_type: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable(),
            contract_type: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable(),
            seniority_level_id: common/* Yup.string */.sm.string().nullable(true).nullable(),
            education: common/* Yup.string */.sm.string().nullable(true).nullable(),
            job_salary_detail_attributes: common/* Yup.object */.sm.object().shape((_obj = {
                salary_hidden: common/* Yup.boolean */.sm.boolean().nullable(),
                salary_choice: common/* Yup.string */.sm.string().nullable(),
                salary_duration: common/* Yup.string */.sm.string().when("salary_hidden", {
                    is: function(salary_hidden) {
                        return !salary_hidden;
                    },
                    then: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable(),
                    otherwise: common/* Yup.string */.sm.string().notRequired().nullable()
                })
            }, (0,_define_property/* default */.Z)(_obj, "salary_choice", common/* Yup.string */.sm.string().when("salary_hidden", {
                is: function(salary_hidden) {
                    return !salary_hidden;
                },
                then: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable(),
                otherwise: common/* Yup.string */.sm.string().notRequired()
            })), (0,_define_property/* default */.Z)(_obj, "currency_id", common/* Yup.string */.sm.string().when("salary_hidden", {
                is: function(salary_hidden) {
                    return !salary_hidden;
                },
                then: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable(),
                otherwise: common/* Yup.string */.sm.string().notRequired()
            })), (0,_define_property/* default */.Z)(_obj, "salary_displayed", common/* Yup.string */.sm.string().when("salary_hidden", {
                is: function(salary_hidden) {
                    return salary_hidden;
                },
                then: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable(),
                otherwise: common/* Yup.string */.sm.string().nullable().notRequired()
            })), (0,_define_property/* default */.Z)(_obj, "min_salary", common/* Yup.string */.sm.string().when([
                "salary_hidden",
                "salary_choice"
            ], {
                is: function(salary_hidden, salary_choice) {
                    return !salary_hidden && (salary_choice == "range" || salary_choice == "starting");
                },
                then: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable(),
                otherwise: common/* Yup.string */.sm.string().notRequired().nullable(true)
            })), (0,_define_property/* default */.Z)(_obj, "max_salary", common/* Yup.string */.sm.string().when([
                "salary_hidden",
                "salary_choice"
            ], {
                is: function(salary_hidden, salary_choice) {
                    return !salary_hidden && (salary_choice == "upto" || salary_choice == "exact");
                },
                then: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable(true),
                otherwise: common/* Yup.string */.sm.string().notRequired().nullable(true)
            }).when([
                "salary_hidden",
                "salary_choice"
            ], {
                is: function(salary_hidden, salary_choice) {
                    return !salary_hidden && salary_choice == "range";
                },
                then: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable().test("is-greater", (0,common/* TRANSLATION */.TA)("errors:invalid_salary_range"), function(value) {
                    var ref;
                    var min_salary = ((ref = this.parent.min_salary) === null || ref === void 0 ? void 0 : ref.replaceAll(",", "")) || 0;
                    var max_salary = (value === null || value === void 0 ? void 0 : value.replaceAll(",", "")) || 0;
                    return parseInt(min_salary) < parseInt(max_salary);
                }),
                otherwise: common/* Yup.string */.sm.string().notRequired().nullable(true)
            })), _obj)),
            is_remote: common/* Yup.boolean */.sm.boolean(),
            is_hybrid: common/* Yup.boolean */.sm.boolean(),
            location_attributes: common/* Yup.object */.sm.object().when([
                "is_remote",
                "is_hybrid"
            ], {
                is: function(is_hybrid, is_remote) {
                    return is_remote || !is_hybrid || !is_remote && !is_hybrid;
                },
                then: common/* Yup.object */.sm.object().shape({
                    place_id: common/* Yup.string */.sm.string().nullable(true),
                    full_address: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable(true).test("validLocation", (0,common/* TRANSLATION */.TA)("errors:invalid_address"), function(value) {
                        return this.parent.place_id && this.parent.place_id.length > 0;
                    })
                }),
                otherwise: common/* Yup.object */.sm.object().shape({
                    place_id: common/* Yup.string */.sm.string().nullable(true),
                    full_address: common/* Yup.string */.sm.string().notRequired().nullable(true).test("validLocation", (0,common/* TRANSLATION */.TA)("errors:invalid_address"), function(value) {
                        return (value === null || value === void 0 ? void 0 : value.length) > 0 ? this.parent.place_id && this.parent.place_id.length > 0 : true;
                    })
                })
            }),
            description: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).min(100, (0,common/* TRANSLATION */.TA)("errors:least_characters_long"))
        })
    });
}
function languageList() {
    return [
        {
            label: "English US",
            value: "English US"
        },
        {
            label: "English UK",
            value: "English UK"
        },
        {
            label: "Spanish",
            value: "Spanish"
        },
        {
            label: "German",
            value: "German"
        },
        {
            label: "French",
            value: "French"
        }
    ];
}
function toneOfVoiceList(t) {
    return [
        {
            label: t("tov:friendly"),
            value: "Friendly"
        },
        {
            label: t("tov:fun"),
            value: "Fun"
        },
        {
            label: t("tov:professional"),
            value: "Professional"
        }
    ];
}

// EXTERNAL MODULE: ./src/constants/components/sidebar.js
var sidebar = __webpack_require__(73257);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/common.js
var jobs_common = __webpack_require__(90432);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4012);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(30711);
;// CONCATENATED MODULE: ./src/actions/pages/clients/jobs/new.js







function getJobInitials(router1, setApiError) {
    return _getJobInitials.apply(this, arguments);
}
function _getJobInitials() {
    _getJobInitials = (0,src_async_to_generator/* default */.Z)(function(router1, setApiError) {
        var result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new jobs_new/* Job */.o().getJobData()
                    ];
                case 1:
                    result = _state.sent();
                    if (result.request.status == 200) {
                        return [
                            2,
                            result.data
                        ];
                    } else {
                        setApiError(result.request);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getJobInitials.apply(this, arguments);
}
function getJobWithTitleId(job_title_id) {
    return _getJobWithTitleId.apply(this, arguments);
}
function _getJobWithTitleId() {
    _getJobWithTitleId = _async_to_generator(function(job_title_id) {
        var result, status_code;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new Job().getJobDataByJobTitle(job_title_id)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    switch(status_code){
                        case SUCCESS_REPONSE_CODE:
                            return [
                                2,
                                result.data
                            ];
                        case RESOURCE_NOT_FOUND_REPONSE_CODE:
                            console.log("Job Not found by title.");
                            break;
                        default:
                            handleOtherResponseCode(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getJobWithTitleId.apply(this, arguments);
}
function handleFormSubmit(values, router1, t, setPageName, queryClient, formik, fromKanban, gotoKanban, setDisabledSaveButton) {
    return _handleFormSubmit.apply(this, arguments);
}
function _handleFormSubmit() {
    _handleFormSubmit = (0,src_async_to_generator/* default */.Z)(function(values, router1, t, setPageName, queryClient, formik, fromKanban, gotoKanban, setDisabledSaveButton) {
        var result, _tmp, jobId, idRegex, status_code, response, queryPath, _tmp1, _tmp2, ref, ref1, message, job_error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setDisabledSaveButton(true);
                    _tmp = {};
                    result = _tmp;
                    jobId = new common/* DataFromUrl */.QJ().getJobId() || values.job.id;
                    idRegex = new RegExp("[0-9]");
                    values.job.draft = true;
                    values.job.really_draft = false;
                    if (!idRegex.test(jobId)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        new jobs_new/* Job */.o().updateJob(values, values.job.id)
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        new jobs_new/* Job */.o().createJob(values)
                    ];
                case 3:
                    result = _state.sent();
                    _state.label = 4;
                case 4:
                    status_code = result.status || result.response.status;
                    _tmp1 = {};
                    _tmp2 = {};
                    switch(status_code){
                        case common/* SUCCESS_REPONSE_CODE */.Us:
                            response = result.data;
                            queryPath = fromKanban ? "?from_kanban=true" : "";
                            if (gotoKanban) {
                                if (fromKanban) {
                                    router1.push((_tmp1.pathname = common/* REDIRECT.client.kanban_board.replace */.RQ.client.kanban_board.replace("$job_id", response.id), _tmp1));
                                } else {
                                    router1.push((_tmp2.pathname = common/* REDIRECT.client.jobs.index */.RQ.client.jobs.index, _tmp2.query = {
                                        job_type: "active"
                                    }, _tmp2));
                                }
                            } else router1.push(common/* REDIRECT.client.jobs.job_options.replace */.RQ.client.jobs.job_options.replace("$job_id", response.id) + queryPath);
                            break;
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            ;
                            message = "";
                            if ((ref = result.response.data.error.job) === null || ref === void 0 ? void 0 : ref.hiring_manager_emails) {
                                message += "".concat(result.response.data.error.job.hiring_manager_emails);
                            }
                            if ((ref1 = result.response.data.error.job) === null || ref1 === void 0 ? void 0 : ref1.job_owner_emails) {
                                if (message.length > 0) {
                                    message += "</br>";
                                }
                                message += "".concat(result.response.data.error.job.job_owner_emails);
                            }
                            if (message.length > 0) {
                                new common/* CustomToastrAction */.Y5().setNormalToastr(message, "warning");
                            // toastr.warning(message);  }
                            }
                            job_error = result.response.data.error;
                            if (job_error.job.full_address) {
                                job_error.job["location_attributes"] = {};
                                job_error.job.location_attributes["full_address"] = job_error.job.full_address;
                                delete job_error.job["full_address"];
                            }
                            delete job_error.job["hiring_manager_emails"];
                            delete job_error.job["job_owner_emails"];
                            formik.current.setStatus(job_error);
                            formik.current.setErrors(job_error);
                            setDisabledSaveButton(false);
                            break;
                        default:
                            (0,common/* handleOtherResponseCode */.GB)(status_code, router1);
                            setDisabledSaveButton(false);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _handleFormSubmit.apply(this, arguments);
}
function getJobTitles(name, router1) {
    return _getJobTitles.apply(this, arguments);
}
function _getJobTitles() {
    _getJobTitles = (0,src_async_to_generator/* default */.Z)(function(name, router1) {
        var body, _tmp, result, status_code, customToastrAction, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = (_tmp.name = name, _tmp);
                    return [
                        4,
                        new jobs_new/* Job */.o().getJobTitlesByName(body)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new common/* CustomToastrAction */.Y5();
                    switch(status_code){
                        case common/* SUCCESS_REPONSE_CODE */.Us:
                            response = result.data;
                            if (response.job_titles.length > 0) {
                                return [
                                    2,
                                    response.job_titles
                                ];
                            } else {
                                return [
                                    2,
                                    []
                                ];
                            }
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            // toastr.warning(result.response.data.error)
                            return [
                                2,
                                []
                            ];
                        default:
                            (0,common/* handleOtherResponseCode */.GB)(status_code, router1);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getJobTitles.apply(this, arguments);
}
function getJobEditInitials(router1, setApiError) {
    return _getJobEditInitials.apply(this, arguments);
}
function _getJobEditInitials() {
    _getJobEditInitials = (0,src_async_to_generator/* default */.Z)(function(router1, setApiError) {
        var jobId, job_result, result, job, data, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    jobId = new common/* DataFromUrl */.QJ().getJobId();
                    return [
                        4,
                        new edit_job/* EditJob */.g().getJobInfo(jobId)
                    ];
                case 1:
                    job_result = _state.sent();
                    return [
                        4,
                        new jobs_new/* Job */.o().getJobData()
                    ];
                case 2:
                    result = _state.sent();
                    _tmp = {};
                    if (job_result.request.status == 200 && result.request.status == 200) {
                        job = job_result.data.job || null;
                        result = result.data;
                        data = (_tmp.props = {
                            job: job,
                            result: result
                        }, _tmp);
                        return [
                            2,
                            data
                        ];
                    } else {
                        setApiError(job_result.request);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getJobEditInitials.apply(this, arguments);
}
function NumberField(param) {
    var field = param.field, className = param.className, disabled = param.disabled, format = param.format, placeholder = param.placeholder, style = param.style, formik = param.formik;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
        thousandsGroupStyle: "thousand",
        name: field.name,
        format: format,
        decimalSeparator: ".",
        displayType: "input",
        type: "text",
        className: className,
        style: style,
        formik: formik,
        disabled: disabled,
        placeholder: placeholder,
        thousandSeparator: true,
        allowNegative: false
    }));
}
function getRequiredApprovedHash(total_count) {
    var select_hash = [
        {
            label: "All",
            values: total_count
        }
    ];
    for(var i = 1; i < total_count; i++){
        select_hash.push({
            label: "Any ".concat(i),
            values: i
        });
    }
    return total_count == 0 ? [] : select_hash;
}
function getValueHash(total_count, email_count, formRef) {
    var hash;
    if (total_count == email_count) {
        hash = {
            label: "All",
            values: total_count
        };
    } else if (typeof total_count != "undefined" && total_count != "") {
        hash = {
            label: "Any ".concat(total_count),
            values: total_count
        };
    } else {
        hash = "";
    }
    if (formRef.current && hash && hash != "") {
        formRef.current.setFieldValue("job.approvers.required_approvers", hash.values);
        formRef.current.setFieldValue("job.required_approvers", hash.values);
    }
    return hash;
}
function handleRequiredApproved(option, formik, event, setRequiredApprovers, setFlagForRender) {
    formik.setFieldValue("job.approvers.required_approvers", option.values);
    formik.setFieldValue("job.required_approvers", option.values);
    formik.validateField("job.approvers.required_approvers");
    formik.values.job.approvers.required_approvers = option.values;
    formik.values.job.required_approvers = option.values;
    setRequiredApprovers(option);
    setFlagForRender(Math.random() * 10000);
}
function showImportPreviousJob(router1, values) {
    var result = false;
    if (router1.query.job_id && router1.pathname.includes("/edit") && values.job.can_import) {
        result = true;
    }
    if (router1.pathname.includes("/jobs/new")) {
        result = true;
    }
    return result;
}
function getDepartmentsList(name, router1) {
    return _getDepartmentsList.apply(this, arguments);
}
function _getDepartmentsList() {
    _getDepartmentsList = (0,src_async_to_generator/* default */.Z)(function(name, router1) {
        var body, _tmp, result, status_code, customToastrAction, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = (_tmp.name = name, _tmp);
                    return [
                        4,
                        new jobs_new/* Job */.o().getDepartmentsByName(body)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new common/* CustomToastrAction */.Y5();
                    switch(status_code){
                        case common/* SUCCESS_REPONSE_CODE */.Us:
                            response = result.data;
                            if (response.departments.length > 0) {
                                return [
                                    2,
                                    response.departments
                                ];
                            } else {
                                return [
                                    2,
                                    []
                                ];
                            }
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            return [
                                2,
                                []
                            ];
                        default:
                            (0,common/* handleOtherResponseCode */.GB)(status_code, router1);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getDepartmentsList.apply(this, arguments);
}
function canGenerateDescription(formik, descriptionModal, setDescriptionModal, router1, setShowLoader, setIsOpen) {
    var customToastrAction = new common/* CustomToastrAction */.Y5();
    var jobData = formik.values.job;
    if (jobData.job_title_name && jobData.job_title_name.trim().length > 0) {
        setShowLoader(true);
        var values = {
            job_title: jobData.job_title_name
        };
        if (descriptionModal.data.tone_of_voice) values.tone_of_voice = descriptionModal.data.tone_of_voice || "";
        if (descriptionModal.data.language) values.language = descriptionModal.data.language;
        if (jobData.employment_type.length > 0) values.employment_type = jobData.employment_type;
        if (jobData.contract_type.length > 0) values.contract_type = jobData.contract_type;
        if (jobData.industry_id) values.industry_id = jobData.industry_id;
        if (jobData.seniority_level_id) values.seniority_level_id = jobData.seniority_level_id;
        generateDescription(values, formik, router1, setShowLoader, setIsOpen);
    } else {
        customToastrAction.setNormalToastr((0,common/* TRANSLATION */.TA)("errors:job_title_for_description"), "warning");
    }
}
function generateDescription(values, formik, router1, setShowLoader, setIsOpen) {
    return _generateDescription.apply(this, arguments);
}
function _generateDescription() {
    _generateDescription = (0,src_async_to_generator/* default */.Z)(function(values, formik, router1, setShowLoader, setIsOpen) {
        var body, _tmp, result, status_code, customToastrAction;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = (_tmp.generate_description = values, _tmp);
                    return [
                        4,
                        new jobs_new/* Job */.o().generateJobDescription(body)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new common/* CustomToastrAction */.Y5();
                    setShowLoader(false);
                    setIsOpen(false);
                    switch(status_code){
                        case common/* SUCCESS_REPONSE_CODE */.Us:
                            formik.setFieldValue("job.description", result.data.description);
                            customToastrAction.setNormalToastr(result.data.success, "success");
                            break;
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            break;
                        default:
                            (0,common/* handleOtherResponseCode */.GB)(status_code, router1);
                            break;
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _generateDescription.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/interview_stages.js
var interview_stages = __webpack_require__(68109);
// EXTERNAL MODULE: ./src/services/pages/clients/jobs/new.js
var jobs_new = __webpack_require__(47441);
// EXTERNAL MODULE: ./src/services/pages/clients/jobs/edit-job.js
var edit_job = __webpack_require__(85985);
// EXTERNAL MODULE: ./src/pages/clients/jobs/back-all-jobs-modal.js
var back_all_jobs_modal = __webpack_require__(92867);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/jobs/job-form.js
var job_form = __webpack_require__(91831);
// EXTERNAL MODULE: ./src/styles/pages/clients/new-job/_index.module.scss
var _index_module = __webpack_require__(35057);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/styles/pages/career/new-view-job/_index.module.scss
var new_view_job_index_module = __webpack_require__(94968);
var new_view_job_index_module_default = /*#__PURE__*/__webpack_require__.n(new_view_job_index_module);
// EXTERNAL MODULE: ./src/components/careers/header.js + 2 modules
var header = __webpack_require__(31061);
// EXTERNAL MODULE: ./src/components/careers/footer.js + 5 modules
var footer = __webpack_require__(96719);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/jobs/new.js

//----------------Components----------------



//----------------Components----------------








// export {default as JobPreviewPage} from '@/pages/clients/dashboard/jobs/job-preview';

//----------------StyleSheet-------------------


//----------------StyleSheet-------------------
//
//






/***/ }),

/***/ 96726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.$G; },
/* harmony export */   "A$": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.A$; },
/* harmony export */   "B4": function() { return /* reexport safe */ _actions_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_8__.B4; },
/* harmony export */   "Dv": function() { return /* reexport safe */ _actions_components_sidebar__WEBPACK_IMPORTED_MODULE_7__.D; },
/* harmony export */   "EA": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.EA; },
/* harmony export */   "GB": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.GB; },
/* harmony export */   "GS": function() { return /* reexport default from dynamic */ _styles_pages_clients_scorecards_component_index_module_scss__WEBPACK_IMPORTED_MODULE_1___default.a; },
/* harmony export */   "J9": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.J9; },
/* harmony export */   "LD": function() { return /* reexport safe */ src_layouts_ClientDashboard__WEBPACK_IMPORTED_MODULE_17__.Z; },
/* harmony export */   "Lt": function() { return /* reexport safe */ _services_common_send_request__WEBPACK_IMPORTED_MODULE_9__.L; },
/* harmony export */   "M1": function() { return /* reexport safe */ _actions_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_22__.M1; },
/* harmony export */   "Mf": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.Mf; },
/* harmony export */   "Mn": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.Mn; },
/* harmony export */   "N7": function() { return /* reexport safe */ _constants_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_12__.N7; },
/* harmony export */   "NL": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.NL; },
/* harmony export */   "QJ": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.QJ; },
/* harmony export */   "R6": function() { return /* reexport safe */ _components_jobScorecardComponent_createJobScorecardComponent__WEBPACK_IMPORTED_MODULE_19__.R6; },
/* harmony export */   "RQ": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.RQ; },
/* harmony export */   "TA": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.TA; },
/* harmony export */   "Us": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.Us; },
/* harmony export */   "XZ": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.XZ; },
/* harmony export */   "Xd": function() { return /* reexport safe */ public_icons_arrowleft_svg__WEBPACK_IMPORTED_MODULE_4__.Z; },
/* harmony export */   "Y5": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.Y5; },
/* harmony export */   "ZJ": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.ZJ; },
/* harmony export */   "ZX": function() { return /* reexport safe */ _constants_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_12__.ZX; },
/* harmony export */   "ao": function() { return /* reexport safe */ _actions_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_22__.ao; },
/* harmony export */   "bN": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.bN; },
/* harmony export */   "bT": function() { return /* reexport safe */ _actions_common_go_to_next_page__WEBPACK_IMPORTED_MODULE_6__.b; },
/* harmony export */   "bl": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.bl; },
/* harmony export */   "d3": function() { return /* reexport safe */ _actions_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_22__.d3; },
/* harmony export */   "d4": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.d4; },
/* harmony export */   "dC": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.dC; },
/* harmony export */   "dH": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.dH; },
/* harmony export */   "eJ": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.eJ; },
/* harmony export */   "f2": function() { return /* reexport safe */ _constants_common_jobs_steps__WEBPACK_IMPORTED_MODULE_13__.f; },
/* harmony export */   "g2": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.g2; },
/* harmony export */   "h9": function() { return /* reexport safe */ _actions_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_8__.h9; },
/* harmony export */   "iI": function() { return /* reexport safe */ _constants_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_12__.iI; },
/* harmony export */   "k2": function() { return /* reexport default from dynamic */ _styles_pages_clients_scorecards_index_module_scss__WEBPACK_IMPORTED_MODULE_0___default.a; },
/* harmony export */   "kZ": function() { return /* reexport safe */ _services_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_10__.k; },
/* harmony export */   "l": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.l; },
/* harmony export */   "l0": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.l0; },
/* harmony export */   "nb": function() { return /* reexport safe */ _constants_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_12__.nb; },
/* harmony export */   "od": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.od; },
/* harmony export */   "qz": function() { return /* reexport safe */ _actions_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_8__.qz; },
/* harmony export */   "sO": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.sO; },
/* harmony export */   "sm": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.sm; },
/* harmony export */   "t": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.t; },
/* harmony export */   "tc": function() { return /* reexport safe */ _pages_clients_jobs_back_all_jobs_modal__WEBPACK_IMPORTED_MODULE_15__["default"]; },
/* harmony export */   "tv": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.tv; },
/* harmony export */   "u": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.u; },
/* harmony export */   "u2": function() { return /* reexport safe */ _constants_components_sidebar__WEBPACK_IMPORTED_MODULE_14__.u2; },
/* harmony export */   "v0": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.v0; },
/* harmony export */   "wl": function() { return /* reexport safe */ _components_modals_scorecard_import_modal__WEBPACK_IMPORTED_MODULE_20__.w; },
/* harmony export */   "x4": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.x4; },
/* harmony export */   "zx": function() { return /* reexport safe */ _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__.zx; }
/* harmony export */ });
/* harmony import */ var _styles_pages_clients_scorecards_index_module_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90837);
/* harmony import */ var _styles_pages_clients_scorecards_index_module_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_clients_scorecards_index_module_scss__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _styles_pages_clients_scorecards_component_index_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9765);
/* harmony import */ var _styles_pages_clients_scorecards_component_index_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_clients_scorecards_component_index_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var public_icons_close_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22700);
/* harmony import */ var public_icons_close_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85155);
/* harmony import */ var public_icons_arrowleft_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65661);
/* harmony import */ var _actions_common_input_error__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54911);
/* harmony import */ var _actions_common_go_to_next_page__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81067);
/* harmony import */ var _actions_components_sidebar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39826);
/* harmony import */ var _actions_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44059);
/* harmony import */ var _services_common_send_request__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34964);
/* harmony import */ var _services_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(76275);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96047);
/* harmony import */ var _constants_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40682);
/* harmony import */ var _constants_common_jobs_steps__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46680);
/* harmony import */ var _constants_components_sidebar__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(73257);
/* harmony import */ var _pages_clients_jobs_back_all_jobs_modal__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(92867);
/* harmony import */ var react_autosuggest__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(46921);
/* harmony import */ var react_autosuggest__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(react_autosuggest__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var src_layouts_ClientDashboard__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(71234);
/* harmony import */ var _components_jobScorecardComponent_createJobAddScorecardLinkComponent__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(95538);
/* harmony import */ var _components_jobScorecardComponent_createJobScorecardComponent__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(70336);
/* harmony import */ var _components_modals_scorecard_import_modal__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(37111);
/* harmony import */ var _components_confirmation_modal__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(72055);
/* harmony import */ var _actions_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(90432);
//--------------------StyleSheet -------------------


//--------------------StyleSheet -------------------
//-------------------Image --------------------



//-------------------Image --------------------
//-------------------Actions --------------------




//-------------------Actions --------------------



//-------------------Constant --------------------



//-------------------Constant --------------------
//-------------------Components --------------------







//-------------------Components --------------------
 // export { default as JobPreviewPage } from '@/pages/clients/dashboard/jobs/job-preview'


/***/ }),

/***/ 80952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "CW": function() { return /* reexport */ common/* COMMON */.CW; },
  "LD": function() { return /* reexport */ common/* ClientDashboard */.LD; },
  "x4": function() { return /* reexport */ common/* CommonAction */.x4; },
  "tS": function() { return /* reexport */ custom_cropper/* CustomCropper */.t; },
  "nu": function() { return /* reexport */ components_custom_cropper/* CustomCropperAction */.n; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "dC": function() { return /* reexport */ common/* ErrorPages */.dC; },
  "l0": function() { return /* reexport */ common/* Form */.l0; },
  "J9": function() { return /* reexport */ common/* Formik */.J9; },
  "gt": function() { return /* reexport */ common/* FormikControl */.gt; },
  "pd": function() { return /* reexport */ common/* InputError */.pd; },
  "oH": function() { return /* reexport */ common/* InputText */.oH; },
  "gb": function() { return /* reexport */ common/* Loading */.gb; },
  "RX": function() { return /* reexport */ my_account/* MY_ACCOUNT */.R; },
  "Pf": function() { return /* reexport */ MyAccountAction; },
  "$E": function() { return /* reexport */ my_account_service/* MyAccountService */.$; },
  "Mf": function() { return /* reexport */ common/* PAGE_ANIMATION_OPTIONS */.Mf; },
  "k2": function() { return /* reexport */ (_index_module_default()); },
  "YU": function() { return /* reexport */ quick_add/* default */.Z; },
  "RQ": function() { return /* reexport */ common/* REDIRECT */.RQ; },
  "if": function() { return /* reexport */ skip_modal/* SkipModal */.i; },
  "TA": function() { return /* reexport */ common/* TRANSLATION */.TA; },
  "sm": function() { return /* reexport */ common/* Yup */.sm; },
  "A$": function() { return /* reexport */ common/* clearSWRCache */.A$; },
  "OP": function() { return /* reexport */ image_base64_to_blob/* dataURItoBlob */.O; },
  "TX": function() { return /* reexport */ logout/* logoutUser */.T; },
  "EA": function() { return /* reexport */ common/* motion */.EA; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "sO": function() { return /* reexport */ common/* useRef */.sO; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; },
  "aF": function() { return /* reexport */ use_user/* useUser */.a; }
});

// UNUSED EXPORTS: Checkbox, CheckedCheckbox, DefaultCheckbox, Error, Link, MY_INTERVIEW_JOBS, MyInterviewWidget, Plus, QUESTIONS, SidebarAction, axios, getSession, toastr

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/components/skip-modal.js
var skip_modal = __webpack_require__(53594);
// EXTERNAL MODULE: ./src/components/custom-cropper.js
var custom_cropper = __webpack_require__(93425);
// EXTERNAL MODULE: ./src/components/quick-add.js
var quick_add = __webpack_require__(35294);
// EXTERNAL MODULE: ./src/pages/clients/dashboard/recruitments/my-interview-widget.js + 2 modules
var my_interview_widget = __webpack_require__(63523);
// EXTERNAL MODULE: ./src/constants/pages/clients/my-account.js
var my_account = __webpack_require__(67734);
// EXTERNAL MODULE: ./src/actions/components/sidebar.js + 1 modules
var sidebar = __webpack_require__(39826);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
;// CONCATENATED MODULE: ./src/actions/pages/clients/my-account.js





var MyAccountAction = /*#__PURE__*/ function() {
    "use strict";
    function MyAccountAction(setApiError, setShowLoader, t) {
        (0,_class_call_check/* default */.Z)(this, MyAccountAction);
        this.t = t;
        this.setApiError = setApiError;
        this.errorPage = new common/* ErrorPages */.dC();
        this.cropperAction = new components_custom_cropper/* CustomCropperAction */.n();
        this.setShowLoader = setShowLoader;
        this.customToastrAction = new common/* CustomToastrAction */.Y5();
        this.commonAction = new common/* CommonAction */.x4();
    }
    (0,_create_class/* default */.Z)(MyAccountAction, [
        {
            key: "getUserDetails",
            value: function getUserDetails(router) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var body, _tmp, result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                body = (_tmp.step = router.query.step, _tmp);
                                return [
                                    4,
                                    new my_account_service/* MyAccountService */.$().getDetails(body)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                return [
                                    2,
                                    result.data
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateUserDetails",
            value: function updateUserDetails(params, router, quick_setup, updateUser, client_slug, setInitialValues, deleteImageUrls) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, formData, blob_data, result, base64Data, _tmp, next_step, url;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.setShowLoader(true);
                                formData = new FormData();
                                formData.append("user[video_]", params.name);
                                formData.append("user[name]", params.name);
                                formData.append("user[email]", params.email);
                                formData.append("user[biography]", params.biography || "");
                                formData.append("user[email_signature]", params.email_signature || "");
                                formData.append("user[newsletter]", params.newsletter);
                                // videoToken ? formData.append("user[introduction_video_key]", videoToken) : '';
                                formData.append("user[introduction_video_from]", "client user");
                                deleteImageUrls === null || deleteImageUrls === void 0 ? void 0 : deleteImageUrls.map(function(image_url, index) {
                                    formData.append("delete_image_urls[".concat(index, "]"), image_url);
                                    return image_url;
                                });
                                if (params.password) formData.append("user[password]", params.password);
                                if (!((params === null || params === void 0 ? void 0 : (ref = params.photo) === null || ref === void 0 ? void 0 : ref.file) && (params === null || params === void 0 ? void 0 : (ref1 = params.photo) === null || ref1 === void 0 ? void 0 : ref1.file_name))) return [
                                    3,
                                    2
                                ];
                                blob_data = document.querySelector("#User_Profile").getAttribute("src");
                                return [
                                    4,
                                    (0,image_base64_to_blob/* dataURItoBlob */.O)(blob_data)
                                ];
                            case 1:
                                blob_data = _state.sent();
                                formData.append("user[photo]", blob_data, params.photo.file_name);
                                _state.label = 2;
                            case 2:
                                if (quick_setup) formData.append("quick_setup", quick_setup);
                                return [
                                    4,
                                    new my_account_service/* MyAccountService */.$().updateUserDetails(formData, client_slug)
                                ];
                            case 3:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                if (!(result.request.status == 200)) return [
                                    3,
                                    6
                                ];
                                _this.setShowLoader(false);
                                _this.customToastrAction.setNormalToastr(result.data.success, "success");
                                return [
                                    4,
                                    _this.commonAction.convertUrlToBase64(result.data.user.photo_url)
                                ];
                            case 4:
                                base64Data = _state.sent();
                                _tmp = {};
                                return [
                                    4,
                                    updateUser((_tmp.user_image = base64Data || result.data.user.photo_url, _tmp.user_name = result.data.user.name, _tmp.name_initials = result.data.user.name_initials, _tmp))
                                ];
                            case 5:
                                _state.sent();
                                if (result.data.user.photo_url) {
                                    document.querySelector(".AvatarImage").src = result.data.user.photo_url || common/* COMMON.DUMMY_IMAGE */.CW.DUMMY_IMAGE;
                                    _this.showImageOrInitials(true);
                                } else {
                                    document.querySelector(".AvatarInitials").innerText = result.data.user.name_initials;
                                    _this.showImageOrInitials(false);
                                }
                                document.querySelector(".AvatarName").textContent = result.data.user.name;
                                if (result.data.next_step) {
                                    next_step = result.data.next_step;
                                    url = "".concat(common/* REDIRECT.client.quick_setup */.RQ.client.quick_setup).concat(next_step);
                                    next_step == "complete" ? router.push(common/* REDIRECT.client.activities */.RQ.client.activities) : router.push(url);
                                }
                                setInitialValues(result.data.user);
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                _this.setShowLoader(false);
                                return [
                                    2,
                                    result.response.data.error.user
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleSelectJobValueOnChange",
            value: function handleSelectJobValueOnChange(data, formik) {
                formik.setFieldValue("role_id", data.value);
            }
        },
        {
            key: "closeCropperModal",
            value: function closeCropperModal() {
                this.cropperAction.destroy_cropper();
                document.querySelector(".CropperModal").style.visibility = "hidden";
            }
        },
        {
            key: "zoom_in",
            value: function zoom_in() {
                this.cropperAction.zoom_in();
            }
        },
        {
            key: "zoom_out",
            value: function zoom_out() {
                this.cropperAction.zoom_out();
            }
        },
        {
            key: "onFileChange",
            value: function onFileChange(event, formik, setImageError) {
                var file = event.target.files[0];
                if (file.size > my_account/* MY_ACCOUNT.PHOTO_SIZE */.R.PHOTO_SIZE) {
                    setImageError(this.t("errors:image_size"));
                } else {
                    this.hash = {
                        file_name: file.name,
                        file: file,
                        file_size: file.size
                    };
                    formik.setFieldValue("photo", this.hash);
                    this.image_url = window.URL.createObjectURL(file);
                    setImageError("");
                    document.querySelector(".CropperModal").style.visibility = "visible";
                    var img_tag = document.querySelector(".Cropper__Image");
                    img_tag.src = this.image_url;
                    this.cropperAction.initialize_cropping_area();
                    event.target.value = "";
                }
            }
        },
        {
            key: "getCroppedImage",
            value: function getCroppedImage() {
                this.blob_data = this.cropperAction.crop_image();
            }
        },
        {
            key: "handleLogout",
            value: function handleLogout(router) {
                (0,logout/* logoutUser */.T)(router, "ClientUser");
            }
        },
        {
            key: "showImageOrInitials",
            value: function showImageOrInitials(isImage) {
                if (isImage) {
                    var imageElement = document.querySelector(".AvatarImage");
                    if (imageElement) imageElement.classList.remove("dnone");
                    var initialElement = document.querySelector(".AvatarInitials");
                    if (initialElement) initialElement.style.display = "none";
                } else {
                    var imageElement1 = document.querySelector(".AvatarImage");
                    if (imageElement1) imageElement1.classList.add("dnone");
                    var initialElement1 = document.querySelector(".AvatarInitials");
                    if (initialElement1) initialElement1.style.display = "flex";
                }
            }
        },
        {
            key: "imageToBase64",
            value: function imageToBase64(element) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, promise;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        url = element.src;
                        promise = new Promise(function(resolve, reject) {
                            fetch(url).then(function(response) {
                                return response.blob();
                            }).then(function(blob) {
                                var reader = new FileReader();
                                reader.readAsDataURL(blob);
                                reader.onloadend = function() {
                                    var base64String = reader.result;
                                    resolve(base64String);
                                };
                            });
                        });
                        return [
                            2,
                            promise
                        ];
                    });
                })();
            }
        }
    ]);
    return MyAccountAction;
}();

// EXTERNAL MODULE: ./src/actions/common/authentication/logout.js
var logout = __webpack_require__(37339);
// EXTERNAL MODULE: ./src/actions/common/image-base64-to-blob.js
var image_base64_to_blob = __webpack_require__(17728);
// EXTERNAL MODULE: ./src/actions/components/custom-cropper.js
var components_custom_cropper = __webpack_require__(50668);
// EXTERNAL MODULE: ./src/hooks/use-user.js + 1 modules
var use_user = __webpack_require__(3343);
// EXTERNAL MODULE: ./src/services/pages/clients/my-account-service.js
var my_account_service = __webpack_require__(68711);
// EXTERNAL MODULE: ./public/icons/error_exclamation.svg
var error_exclamation = __webpack_require__(71843);
// EXTERNAL MODULE: ./public/icons/plus.svg
var plus = __webpack_require__(65099);
// EXTERNAL MODULE: ./src/styles/pages/jobs/profile/_index.module.scss
var _index_module = __webpack_require__(54858);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/my-account.js
// ----------------------------- COMMON ---------------------------------------

// ----------------------------- COMMON ---------------------------------------
// ----------------- COMPONENTS ---------------------




// ----------------- COMPONENTS ---------------------
// ----------------- Constants ---------------------

// ----------------- Constants ---------------------
// -----------------------------  ACTIONS -----------------------------






// -----------------------------  ACTIONS -----------------------------
// -----------------------------  SERVICE -----------------------------

// -----------------------------  SERVICE -----------------------------
// -----------------------------  ICONS -----------------------------


// -----------------------------  ICONS -----------------------------
// ---------------------------- Stylesheet -------------------------------------
 // ----------------------------- Stylesheet ------------------------------------


/***/ }),

/***/ 78245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sw": function() { return /* reexport */ AddAssessment; },
  "w0": function() { return /* reexport */ AssessmentActionOptions; },
  "Qq": function() { return /* reexport */ AssessmentDropZone; },
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "ZJ": function() { return /* reexport */ common/* ButtonStyle */.ZJ; },
  "LD": function() { return /* reexport */ common/* ClientDashboard */.LD; },
  "x4": function() { return /* reexport */ common/* CommonAction */.x4; },
  "hh": function() { return /* reexport */ datatable/* CustomDataTable */.h; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "bb": function() { return /* reexport */ dots/* default */.Z; },
  "dC": function() { return /* reexport */ common/* ErrorPages */.dC; },
  "pd": function() { return /* reexport */ common/* InputError */.pd; },
  "WY": function() { return /* reexport */ manage_assessment/* MANAGE_ASSESSMENT */.WY; },
  "F8": function() { return /* reexport */ ManageAssessmentAction; },
  "ze": function() { return /* reexport */ ManageAssessmentService; },
  "Mf": function() { return /* reexport */ common/* PAGE_ANIMATION_OPTIONS */.Mf; },
  "k2": function() { return /* reexport */ (privacy_policy_index_module_default()); },
  "v3": function() { return /* reexport */ plus/* default */.Z; },
  "YU": function() { return /* reexport */ quick_add/* default */.Z; },
  "Ms": function() { return /* reexport */ manage_assessment/* addAssessmentValidation */.Ms; },
  "A$": function() { return /* reexport */ common/* clearSWRCache */.A$; },
  "Sv": function() { return /* reexport */ job/* closeAllJobsOptions */.Sv; },
  "EA": function() { return /* reexport */ common/* motion */.EA; },
  "Sg": function() { return /* reexport */ manage_assessment/* setAssessmentInitial */.Sg; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: API, ConfirmationModal, DragDropContext, Draggable, DropboxChooser, Droppable, EXTENSION_COMMON, GoogleChooser, GripIcon, Link, Loading, REDIRECT, SUCCESS_REPONSE_CODE, Search, SendRequest, TRANSLATION, UnsuccessfulModal, UnsuccessfulReasonOptions, Yup, addParamsToUrl, axios, closeModalUsingState, toastr

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/constants/pages/clients/recruitment/manage-assessment.js
var manage_assessment = __webpack_require__(24229);
// EXTERNAL MODULE: ./src/components/datatableActionOptions/unsuccessful-reason-options.js
var unsuccessful_reason_options = __webpack_require__(99363);
// EXTERNAL MODULE: ./src/components/confirmation-modal.js
var confirmation_modal = __webpack_require__(72055);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/styles/components/share-cv/_index.module.scss
var _index_module = __webpack_require__(2443);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/imports-files/components/common-modal/common-modal.js + 2 modules
var common_modal = __webpack_require__(66172);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
;// CONCATENATED MODULE: ./src/components/add-assessment.js










function AddAssessment(props) {
    var t = (0,common/* useTranslation */.$G)().t;
    var formRef = (0,common/* useRef */.sO)(null);
    var customToastrAction = new common/* CustomToastrAction */.Y5();
    var ref = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(props.assessmentAction == "edit" && props.currentRow.file_type == "file" ? "Change file" : "Upload a file"), 2), uploadFileText = ref[0], setUploadFileText = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(common_modal/* FormModalStyle.ModalOverlay */.w2.ModalOverlay, " AddAssessment"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(common_modal/* FormModalStyle.Modal */.w2.Modal),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(common_modal/* FormModalStyle.Modal__Container */.w2.Modal__Container, " removeplaceholder"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(common_modal/* FormModalStyle.Modal__Container__Heading__Close */.w2.Modal__Container__Heading__Close),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Heading */.w2.Modal__Container__ContentSection__Heading),
                                children: props.assessmentAction == "create" ? t("modal:form:assessment:heading") : t("modal:form:assessment:edit_heading")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(common_modal/* FormModalStyle.Modal__Container__CloseSection */.w2.Modal__Container__CloseSection),
                                onClick: function() {
                                    return props.setAssessmentCreateModal({
                                        state: false
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal/* Close */.x8, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: common_modal/* FormModalStyle.Modal__Container__ContentSection */.w2.Modal__Container__ContentSection,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: common_modal/* FormModalStyle.Modal__Container__ContentSection__Description */.w2.Modal__Container__ContentSection__Description,
                                children: t("modal:form:assessment:subheading")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Formik */.J9, {
                                initialValues: (0,manage_assessment/* setAssessmentInitial */.Sg)(props.assessmentAction, props.currentRow),
                                innerRef: formRef,
                                validationSchema: (0,manage_assessment/* addAssessmentValidation */.Ms)(),
                                onSubmit: function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(values, actions) {
                                        var errors, errors1;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!(props.assessmentAction == "create")) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        props.manageAssessmentAction.createAssessment(values, props.setAssessmentCreateModal, props.setAssessmentList)
                                                    ];
                                                case 1:
                                                    errors = _state.sent();
                                                    actions.setErrors(errors);
                                                    return [
                                                        3,
                                                        4
                                                    ];
                                                case 2:
                                                    return [
                                                        4,
                                                        props.manageAssessmentAction.updateAssessment(values, props.setAssessmentCreateModal, props.setAssessmentList)
                                                    ];
                                                case 3:
                                                    errors1 = _state.sent();
                                                    actions.setErrors(errors1);
                                                    _state.label = 4;
                                                case 4:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(values, actions) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(),
                                children: function(formik) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Form */.l0, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((_index_module_default()).Form__TableCol, " mt32"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        className: "".concat((_index_module_default()).Form__FloatingLabel),
                                                        children: t("label:assessment:name")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                        className: " ".concat(common_modal/* FormModalStyle.Form__Input */.w2.Form__Input, " ").concat((_index_module_default()).Form__Input, " "),
                                                        errorClass: common_modal/* FormModalStyle.Form__Error */.w2.Form__Error,
                                                        control: "input",
                                                        placeholder: "",
                                                        type: "text",
                                                        formik: formik,
                                                        name: "name",
                                                        style: (0,common/* InputError */.pd)(formik, "name"),
                                                        // errorClass={`customError`}
                                                        custom_class: "form_custom_error"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat((_index_module_default()).Form__TableCol, " mt32"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        className: "".concat((_index_module_default()).Form__FloatingLabel),
                                                        children: t("label:assessment:link")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                        className: " ".concat(common_modal/* FormModalStyle.Form__Input */.w2.Form__Input, " ").concat((_index_module_default()).Form__Input),
                                                        errorClass: common_modal/* FormModalStyle.Form__Error */.w2.Form__Error,
                                                        control: "input",
                                                        placeholder: "",
                                                        type: "text",
                                                        formik: formik,
                                                        name: "link",
                                                        disabled: false,
                                                        style: (0,common/* InputError */.pd)(formik, "link"),
                                                        // errorClass={`customError`}
                                                        custom_class: "form_custom_error",
                                                        onChange: function(event) {
                                                            if (event.target.value.length == 0 && formik.values.file) {
                                                                formik.setFieldValue("file_type", "file");
                                                            } else {
                                                                formik.setFieldValue("file_type", "link");
                                                            }
                                                            formik.setFieldValue("link", event.target.value);
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Divider */.w2.Modal__Container__ContentSection__Divider),
                                                children: t("upload:or")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "UploadAssessment ".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__Label */.w2.Modal__Container__ContentSection__Block__Label, " text-left"),
                                                        children: t("upload:supported_files")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection__Block__DropboxContainer */.w2.Modal__Container__ContentSection__Block__DropboxContainer, " ").concat((_index_module_default()).Form__TableCol),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                className: "".concat((_index_module_default()).Form__FloatingLabel),
                                                                children: t("label:assessment:upload")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AssessmentDropZone, {
                                                                id: "upload_assessment",
                                                                type: "settings",
                                                                name: "file",
                                                                multiple: false,
                                                                formRef: formRef,
                                                                formik: formik,
                                                                autofill: false,
                                                                accept: ".pdf, .docx, .doc",
                                                                dropAction: props.manageAssessmentAction,
                                                                drop_type: "template",
                                                                t: t
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: common_modal/* FormModalStyle.Modal__Container__ButtonSection */.w2.Modal__Container__ButtonSection,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                    buttonstyle: "".concat(common_modal/* FormModalStyle.primarybtn */.w2.primarybtn),
                                                    type: "button",
                                                    onClick: function() {
                                                        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                if (Object.keys(formik.touched).length == 0 && !formik.values.id) {
                                                                    formik.submitForm();
                                                                } else {
                                                                    if (formik.values.link.length > 0 && (formik.values.file || formik.values.filename.length > 0) || formik.values.link.length == 0 && !formik.values.file && !(formik.values.filename.length > 0)) {
                                                                        customToastrAction.setNormalToastr(t("errors:assessment_link_error"), "warning");
                                                                    } else {
                                                                        formik.submitForm();
                                                                    }
                                                                }
                                                                return [
                                                                    2
                                                                ];
                                                            });
                                                        });
                                                        return function(event) {
                                                            return _ref.apply(this, arguments);
                                                        };
                                                    }(),
                                                    children: t("button:save")
                                                })
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/unsuccessfull.js
var unsuccessfull = __webpack_require__(59678);
// EXTERNAL MODULE: ./src/components/quick-add.js
var quick_add = __webpack_require__(35294);
// EXTERNAL MODULE: ./src/imports-files/components/input.js
var input = __webpack_require__(23434);
;// CONCATENATED MODULE: ./src/components/assessment-action-options.js


function AssessmentActionOptions(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "JobActionOptions Close",
        children: Object.keys(props.options).map(function(key, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "JobsOptionKeys ".concat(props.row.can_modify ? "" : "disabled"),
                onClick: function(event) {
                    event.stopPropagation();
                    if (props.row.can_modify) {
                        props.performAssessmentAction(props.options[key]["action"], {
                            "row": props.row,
                            "setAssessmentList": props.setAssessmentList,
                            "router": props.router,
                            "key": props.options[key]["key"],
                            "setDatatableLoading": props.setDatatableLoading,
                            "setApiError": props.setApiError,
                            "setAssessmentDeleteModal": props.setAssessmentDeleteModal,
                            "setCurrentRow": props.setCurrentRow,
                            "customToastrAction": props.customToastrAction,
                            "setAssessmentAction": props.setAssessmentAction,
                            "setAssessmentCreateModal": props.setAssessmentCreateModal
                        });
                    }
                },
                children: props.options[key]["title"]
            }, "JobsOption_".concat(key));
        })
    });
}

// EXTERNAL MODULE: ../../shared/node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(75763);
// EXTERNAL MODULE: ./public/icons/gripicon.svg
var gripicon = __webpack_require__(61876);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/jobs/assessment-dropzone.js





// EXTERNAL MODULE: ./src/styles/components/dropzone/_index.module.scss
var dropzone_index_module = __webpack_require__(37307);
var dropzone_index_module_default = /*#__PURE__*/__webpack_require__.n(dropzone_index_module);
// EXTERNAL MODULE: ./public/icons/device.svg
var device = __webpack_require__(86298);
// EXTERNAL MODULE: ./src/imports-files/pages/career/view-job.js + 5 modules
var view_job = __webpack_require__(83813);
;// CONCATENATED MODULE: ./src/components/assessment-dropzone.js







function AssessmentDropZone(props) {
    var documentList = function documentList(drop_type, formik) {
        if (drop_type == "contract") {
            return formik.values.contract.documents;
        } else if (drop_type == "template") {
            return formik.values.signature_template.documents;
        }
    };
    var ref, ref1, ref2, ref3;
    var formik = props.formik;
    var t = (0,view_job/* useTranslation */.$G)().t;
    var dropdownRef = (0,common/* useRef */.sO)(null);
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), isActive = ref4[0], setIsActive = ref4[1];
    var onClick = function() {
        return setIsActive(!isActive);
    };
    var router = (0,common/* useRouter */.tv)();
    var dropAction = props.dropAction;
    (0,common/* useEffect */.d4)(function() {
        var hash = {
            file_type: "",
            file: "",
            file_name: ""
        };
    }, []);
    (0,common/* useEffect */.d4)(function() {
        var pageClickEvent = function(e) {
            // If the active element exists and is clicked outside of
            if (dropdownRef.current !== null && !dropdownRef.current.contains(e.target)) {
                setIsActive(!isActive);
            }
        };
        // If the item is active (ie open) then listen for clicks
        if (isActive) {
            window.addEventListener("click", pageClickEvent);
        }
        return function() {
            window.removeEventListener("click", pageClickEvent);
        };
    }, [
        isActive
    ]);
    var dragOver = function(e) {
        e.preventDefault();
    };
    var dragEnter = function(e) {
        e.preventDefault();
    };
    var dragLeave = function(e) {
        e.preventDefault();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (dropzone_index_module_default()).DropContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((dropzone_index_module_default()).DropContainer__Inner, " DropContainerInner"),
                    onDragOver: dragOver,
                    onDragEnter: dragEnter,
                    onDragLeave: dragLeave,
                    name: props.name,
                    onDrop: function(event) {
                        event.preventDefault();
                        if (props.isDisabled) return false;
                        else dropAction.uploadFile(props.formik, event.dataTransfer.files, event);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (dropzone_index_module_default()).DropContainer__Message,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (dropzone_index_module_default()).DropContainer__UploadIcon
                            }),
                            t("upload:drag_and_drop"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " BrowseFile ".concat((dropzone_index_module_default()).Browse),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                        buttonstyle: common/* ButtonStyle.primarybtn */.ZJ.primarybtn,
                                        onClick: onClick,
                                        disabled: props.isDisabled,
                                        children: t("button:browse_to_upload")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                        ref: dropdownRef,
                                        className: "dropboxmenu ".concat(isActive ? "active" : "inactive"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                onClick: function() {
                                                    return (0,view_job/* closeDropDown */.mU)(setIsActive);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        htmlFor: props.id,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(device/* default */.Z, {}),
                                                            "  ",
                                                            t("button:from_device")
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "file",
                                                        multiple: props.multiple,
                                                        onChange: function(event) {
                                                            dropAction.uploadFile(props.formik, event.target.files, event);
                                                        },
                                                        name: props.name,
                                                        accept: props.accept,
                                                        id: props.id
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                (formik.values.filename || ((ref = formik.values.job_test_detail_attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.assessment) === null || ref1 === void 0 ? void 0 : ref1.filename)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((dropzone_index_module_default()).FileDisplayContainer, " FileDisplayContainerW100"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((dropzone_index_module_default()).FileDisplayContainer__Status, " FileDisplayWidth"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "".concat((dropzone_index_module_default()).FileDisplayContainer__Name, " FileDisplayName"),
                                children: formik.values.filename || ((ref2 = formik.values.job_test_detail_attributes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.assessment) === null || ref3 === void 0 ? void 0 : ref3.filename)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((dropzone_index_module_default()).FileDisplayContainer__Close, " FileDisplayClose"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Image */.Ee, {
                                    src: "/icons/close.png",
                                    height: 13,
                                    width: 13,
                                    alt: "",
                                    onClick: function() {
                                        return dropAction.onRemoveFile(formik, props.name);
                                    }
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
;

// EXTERNAL MODULE: ../../shared/node_modules/react-file-picker-providers/index.js
var react_file_picker_providers = __webpack_require__(70853);
// EXTERNAL MODULE: ./src/components/customDatatable/datatable.js + 1 modules
var datatable = __webpack_require__(54489);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ./src/actions/pages/admins/dashboard/clients/common.js
var clients_common = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/actions/pages/clients/recruitment/manage-assessment.js







var ManageAssessmentAction = /*#__PURE__*/ function() {
    "use strict";
    function ManageAssessmentAction(router, setApiError) {
        (0,_class_call_check/* default */.Z)(this, ManageAssessmentAction);
        this.manageAssessmentService = new ManageAssessmentService();
        this.customToastrAction = new common/* CustomToastrAction */.Y5();
        this.setApiError = setApiError;
        this.router = router;
        this.commonAction = new common/* CommonAction */.x4();
    }
    (0,_create_class/* default */.Z)(ManageAssessmentAction, [
        {
            key: "listAssessments",
            value: function listAssessments(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.manageAssessmentService.listAssessments(params)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                return [
                                    2,
                                    result.data
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleAssessmentPerRowsSorting",
            value: function handleAssessmentPerRowsSorting(column, sortDirection, setAssessmentList) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var param_list, data;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                param_list = _this.router.query;
                                param_list.col_name = column.sortField;
                                param_list.order = sortDirection;
                                (0,clients_common/* addParamsToUrl */.Sr)(param_list, _this.router);
                                return [
                                    4,
                                    _this.listAssessments(param_list)
                                ];
                            case 1:
                                data = _state.sent();
                                setAssessmentList(data);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleAssessmentPerRowsChange",
            value: function handleAssessmentPerRowsChange(per_page, setAssessmentList) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var param_list, data;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                param_list = _this.router.query;
                                param_list.per_page = per_page;
                                (0,clients_common/* addParamsToUrl */.Sr)(param_list, _this.router);
                                return [
                                    4,
                                    _this.listAssessments(param_list)
                                ];
                            case 1:
                                data = _state.sent();
                                setAssessmentList(data);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleAssessmentPageChange",
            value: function handleAssessmentPageChange(page_number, setAssessmentList) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var param_list, data;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                param_list = _this.router.query;
                                param_list.page = page_number;
                                (0,clients_common/* addParamsToUrl */.Sr)(param_list, _this.router);
                                return [
                                    4,
                                    _this.listAssessments(param_list)
                                ];
                            case 1:
                                data = _state.sent();
                                setAssessmentList(data);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deleteAssessment",
            value: function deleteAssessment(currentRow, setAssessmentDeleteModal, setAssessmentList) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.manageAssessmentService.deleteAssessment(currentRow.id)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                _tmp = {};
                                if (result.request.status == 200) {
                                    setAssessmentDeleteModal((_tmp.state = false, _tmp));
                                    _this.customToastrAction.setNormalToastr(result.data.success, "success");
                                    setAssessmentList(result.data);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createAssessment",
            value: function createAssessment(values, setAssessmentCreateModal, setAssessmentList) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var params, result, _tmp;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                params = _this.setFormData(values);
                                return [
                                    4,
                                    _this.manageAssessmentService.createAssessment(params)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                _tmp = {};
                                if (result.request.status == 200) {
                                    setAssessmentCreateModal((_tmp.state = false, _tmp));
                                    _this.customToastrAction.setNormalToastr(result.data.success, "success");
                                    setAssessmentList(result.data);
                                } else {
                                    return [
                                        2,
                                        result.response.data.error.assessment
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateAssessment",
            value: function updateAssessment(values, setAssessmentCreateModal, setAssessmentList) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var params, result, _tmp;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                params = _this.setFormData(values);
                                return [
                                    4,
                                    _this.manageAssessmentService.updateAssessment(params, values.id)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                _tmp = {};
                                if (result.request.status == 200) {
                                    setAssessmentCreateModal((_tmp.state = false, _tmp));
                                    _this.customToastrAction.setNormalToastr(result.data.success, "success");
                                    setAssessmentList(result.data);
                                } else {
                                    return [
                                        2,
                                        result.response.data.error.assessment
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setFormData",
            value: function setFormData(params) {
                var data = {
                    assessment: {
                        name: params.name,
                        file_type: params.file_type,
                        link: params.link
                    }
                };
                if (params.file) {
                    data.assessment.file = params.file;
                    data.assessment.filename = params.filename;
                }
                return data;
            }
        },
        {
            key: "uploadFile",
            value: function uploadFile(formik, files, event) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var file, base64;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                file = files[0];
                                if (!file) return [
                                    3,
                                    9
                                ];
                                formik.setFieldValue("file_type", "file");
                                if (!(file.size > manage_assessment/* MANAGE_ASSESSMENT.file_size */.WY.file_size)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    formik.setFieldValue("file", "")
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("filename", file.name)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("filesize", file.size)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    9
                                ];
                            case 4:
                                return [
                                    4,
                                    _this.commonAction.convertToBase64(file)
                                ];
                            case 5:
                                base64 = _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("filename", file.name)
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("file", base64)
                                ];
                            case 7:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("filesize", file.size)
                                ];
                            case 8:
                                _state.sent();
                                _state.label = 9;
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onRemoveFile",
            value: function onRemoveFile(formik) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    formik.setFieldValue("file_type", "link")
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("file", "")
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("filename", "")
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onOptionChange",
            value: function onOptionChange(formik, event) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var val;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                val = event.target.value;
                                if (!(val == "file")) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    formik.setFieldValue(event.target.name, val)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("link", "")
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                return [
                                    4,
                                    formik.setFieldValue(event.target.name, val)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("file", "")
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("filename", "")
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addHttpOrHttps",
            value: function addHttpOrHttps(link) {
                var downcaseUrl = link.toLowerCase();
                if (downcaseUrl.indexOf("http://") == 0 || downcaseUrl.indexOf("https://") == 0) {
                    return downcaseUrl;
                } else {
                    return "https://" + downcaseUrl;
                }
            }
        },
        {
            key: "assessmentActionOptions",
            value: function assessmentActionOptions(row, t) {
                var options = [
                    {
                        "key": "edit",
                        "title": t("datatable:actions:edit"),
                        "action": "edit"
                    },
                    {
                        "key": "delete",
                        "title": t("datatable:actions:delete"),
                        "action": "delete"
                    }
                ];
                return options;
            }
        },
        {
            key: "openJobOptions",
            value: function openJobOptions(event) {
                event.stopPropagation();
                var dots_element = event.currentTarget.querySelector(".Dots");
                var element = event.currentTarget.querySelector(".JobActionOptions");
                if (dots_element.classList.contains("Close")) {
                    this.closeAllJobsOptions();
                    element.classList.remove("Close");
                    element.classList.add("Open");
                    dots_element.classList.remove("Close");
                    dots_element.classList.add("Open");
                } else {
                    this.closeAllJobsOptions();
                    element.classList.remove("Open");
                    element.classList.add("Close");
                    dots_element.classList.remove("Open");
                    dots_element.classList.add("Close");
                }
            }
        },
        {
            key: "closeAllJobsOptions",
            value: function closeAllJobsOptions() {
                var element = document.querySelector(".JobActionOptions.Open");
                var dots_element = document.querySelector(".Dots.Open");
                if (element) {
                    element.classList.remove("Open");
                    element.classList.add("Close");
                    dots_element.classList.remove("Open");
                    dots_element.classList.add("Close");
                }
            }
        },
        {
            key: "performAssessmentAction",
            value: function performAssessmentAction(ActionName, params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var _tmp, _tmp1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.closeAllJobsOptions();
                                switch(ActionName){
                                    case "edit":
                                        return [
                                            3,
                                            1
                                        ];
                                    case "delete":
                                        return [
                                            3,
                                            2
                                        ];
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 1:
                                params.setAssessmentAction("edit");
                                params.setCurrentRow(params.row);
                                _tmp = {};
                                params.setAssessmentCreateModal((_tmp.state = true, _tmp));
                                return [
                                    3,
                                    5
                                ];
                            case 2:
                                return [
                                    4,
                                    params.setCurrentRow(params.row)
                                ];
                            case 3:
                                _state.sent();
                                _tmp1 = {};
                                return [
                                    4,
                                    params.setAssessmentDeleteModal((_tmp1.state = true, _tmp1))
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAssessmentColumnsName",
            value: function getAssessmentColumnsName(setAssessmentDeleteModal, setCurrentRow, setAssessmentAction, setAssessmentCreateModal, t) {
                var _this = this;
                var columns = [
                    {
                        name: t("datatable:assessment_name"),
                        selector: function(row) {
                            return row.name;
                        },
                        sortable: true,
                        sortField: "name"
                    },
                    {
                        name: t("datatable:file/link"),
                        selector: function(row) {
                            if (row.file_type == "file") {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: row.file_or_link,
                                    target: "_blank",
                                    className: "termslink",
                                    children: row.file_name
                                });
                            } else {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: _this.addHttpOrHttps(row.file_or_link),
                                    target: "_blank",
                                    className: "termslink",
                                    children: row.file_or_link
                                });
                            }
                        }
                    },
                    {
                        name: t("datatable:updated_on"),
                        selector: function(row) {
                            return row.added_on;
                        },
                        sortable: true,
                        sortField: "created_at"
                    },
                    {
                        name: t("datatable:updated_by"),
                        selector: function(row) {
                            var ref, ref1;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "CandidateSection",
                                children: [
                                    ((ref = row.added_by) === null || ref === void 0 ? void 0 : ref.photo_url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (ref1 = row.added_by) === null || ref1 === void 0 ? void 0 : ref1.photo_url,
                                        className: "JobImage"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "JobInitial",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: row.added_by.name_initials ? row.added_by.name_initials : "?"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "JobName",
                                        children: [
                                            "  ",
                                            row.added_by.name || row.added_by.email
                                        ]
                                    })
                                ]
                            });
                        },
                        sortable: true,
                        sortField: "added_by"
                    },
                    {
                        name: "",
                        selector: function(row) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "DotsOptions",
                                onClick: function(event) {
                                    return _this.openJobOptions(event);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dots/* default */.Z, {
                                        className: "Dots Close"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AssessmentActionOptions, {
                                        options: _this.assessmentActionOptions(row, t),
                                        row: row,
                                        setApiError: _this.setApiError,
                                        router: _this.router,
                                        setAssessmentList: _this.setAssessmentList,
                                        performAssessmentAction: _this.performAssessmentAction,
                                        closeAllJobsOptions: _this.closeAllJobsOptions,
                                        setAssessmentDeleteModal: setAssessmentDeleteModal,
                                        setCurrentRow: setCurrentRow,
                                        customToastrAction: _this.customToastrAction,
                                        setAssessmentAction: setAssessmentAction,
                                        setAssessmentCreateModal: setAssessmentCreateModal
                                    })
                                ]
                            });
                        }
                    }, 
                ];
                return columns;
            }
        }
    ]);
    return ManageAssessmentAction;
}();

// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/job.js
var job = __webpack_require__(98303);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ./src/services/common/send-request.js
var send_request = __webpack_require__(34964);
;// CONCATENATED MODULE: ./src/services/pages/clients/recruitment/manage-assessment.js








var ManageAssessmentService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(ManageAssessmentService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(ManageAssessmentService);
    function ManageAssessmentService() {
        (0,_class_call_check/* default */.Z)(this, ManageAssessmentService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ManageAssessmentService, [
        {
            key: "listAssessments",
            value: function listAssessments(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.manage_assessment.ASSESSMENT_LIST */.bl.client.manage_assessment.ASSESSMENT_LIST;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createAssessment",
            value: function createAssessment(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.manage_assessment.CREATE_ASSESSMENT */.bl.client.manage_assessment.CREATE_ASSESSMENT;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateAssessment",
            value: function updateAssessment(params, assessmentId) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.manage_assessment.UPDATE_ASSESSMENT.replace */.bl.client.manage_assessment.UPDATE_ASSESSMENT.replace("$assessment_id", assessmentId);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.put */.od.put(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deleteAssessment",
            value: function deleteAssessment(assesmentId) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.manage_assessment.DELETE_ASSESSMENT.replace */.bl.client.manage_assessment.DELETE_ASSESSMENT.replace("$assessment_id", assesmentId);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.delete */.od["delete"](url, (_tmp.params = {}, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ManageAssessmentService;
}(send_request/* SendRequest */.L);

// EXTERNAL MODULE: ./public/icons/plus.svg
var plus = __webpack_require__(65099);
// EXTERNAL MODULE: ./public/icons/search.svg
var search = __webpack_require__(26173);
// EXTERNAL MODULE: ./public/icons/dots.svg
var dots = __webpack_require__(30054);
// EXTERNAL MODULE: ./src/styles/pages/clients/privacy-policy/_index.module.scss
var privacy_policy_index_module = __webpack_require__(8001);
var privacy_policy_index_module_default = /*#__PURE__*/__webpack_require__.n(privacy_policy_index_module);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/recruitments/manage-assessment.js


// ----------------- COMPONENTS ----------------------











// ----------------- COMPONENTS ----------------------
// ----------------- ACTIONS ----------------------



// ----------------- ACTION ----------------------
// ----------------- SERVICE ----------------------

// ----------------- SERVICE ----------------------
// ----------------- STYLESHEET ----------------------



// ----------------- STYLESHEET ----------------------
// ----------------- STYLESHEET ----------------------
 // ----------------- STYLESHEET ----------------------


/***/ }),

/***/ 79995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "zx": function() { return /* reexport */ common/* Button */.zx; },
  "ZJ": function() { return /* reexport */ common/* ButtonStyle */.ZJ; },
  "LD": function() { return /* reexport */ common/* ClientDashboard */.LD; },
  "x4": function() { return /* reexport */ common/* CommonAction */.x4; },
  "hh": function() { return /* reexport */ datatable/* CustomDataTable */.h; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "bb": function() { return /* reexport */ dots/* default */.Z; },
  "dC": function() { return /* reexport */ common/* ErrorPages */.dC; },
  "Mf": function() { return /* reexport */ common/* PAGE_ANIMATION_OPTIONS */.Mf; },
  "k2": function() { return /* reexport */ (_index_module_default()); },
  "v3": function() { return /* reexport */ plus/* default */.Z; },
  "YU": function() { return /* reexport */ quick_add/* default */.Z; },
  "Us": function() { return /* reexport */ common/* SUCCESS_REPONSE_CODE */.Us; },
  "ol": function() { return /* reexport */ search/* default */.Z; },
  "Lt": function() { return /* reexport */ common/* SendRequest */.Lt; },
  "TA": function() { return /* reexport */ common/* TRANSLATION */.TA; },
  "JW": function() { return /* reexport */ UNSUCCESSFUL_REASONS; },
  "OE": function() { return /* reexport */ unsuccessfull/* UnsuccessfulModal */.O; },
  "OD": function() { return /* reexport */ unsuccessful_reasons/* UnsuccessfulReasonAction */.O; },
  "fY": function() { return /* reexport */ unsuccessful_reason_options/* UnsuccessfulReasonOptions */.f; },
  "S0": function() { return /* reexport */ UnsuccessfulReasonService; },
  "sm": function() { return /* reexport */ common/* Yup */.sm; },
  "Sr": function() { return /* reexport */ common/* addParamsToUrl */.Sr; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "A$": function() { return /* reexport */ common/* clearSWRCache */.A$; },
  "jL": function() { return /* reexport */ close_modal/* closeModalUsingState */.j; },
  "EA": function() { return /* reexport */ common/* motion */.EA; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "dH": function() { return /* reexport */ common/* useSWR */.dH; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: ConfirmationModal, FormStyle, InputText, Link, Loading, REDIRECT, toastr

// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
;// CONCATENATED MODULE: ./src/constants/pages/clients/recruitment/unsuccessful-reasons.js

var UNSUCCESSFUL_REASONS = {
    texts: {
        heading_1: "Recruitment",
        heading_2: "Unsuccessful Reasons",
        subheading: "Here you can manage the reasons why your candidates\n                                                                     weren’t successful. We have provided a default list, but you can click “ADD NEW\n                                                                     REASON” to create your own.",
        placeholder: "Search for reasons",
        button: "Add new Reason",
        datatable: {
            column_1: "Unsuccessful Reasons",
            column_2: "Last Edited By",
            column_3: "Action"
        }
    },
    unsuccessfulReasonsOptions: function(t) {
        return {
            edit: {
                title: t("datatable:actions:edit")
            },
            delete: {
                title: t("datatable:actions:delete")
            }
        };
    },
    unsuccessfulReasonsForm: function(t) {
        return {
            formInitials: {
                reason: ""
            },
            formDefault: {
                reason: ""
            },
            formValidation: common/* Yup.object */.sm.object({
                reason: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).max(50, (0,common/* TRANSLATION */.TA)("errors:max_50_char_error"))
            }),
            texts: {
                heading: "Add New Reason",
                add_heading: "Add New Reason",
                edit_heading: "Edit Reason",
                label: "Reason",
                placeholder: "Write here",
                close_button: "Close",
                button_1: "Cancel",
                button_2: "Submit"
            }
        };
    },
    delete_reason_modal: {
        message: "Are you sure you want to delete this template ?"
    }
};

// EXTERNAL MODULE: ./src/components/datatableActionOptions/unsuccessful-reason-options.js
var unsuccessful_reason_options = __webpack_require__(99363);
// EXTERNAL MODULE: ./src/components/confirmation-modal.js
var confirmation_modal = __webpack_require__(72055);
// EXTERNAL MODULE: ./src/components/unsuccessfull.js
var unsuccessfull = __webpack_require__(59678);
// EXTERNAL MODULE: ./src/components/quick-add.js
var quick_add = __webpack_require__(35294);
// EXTERNAL MODULE: ./src/components/customDatatable/datatable.js + 1 modules
var datatable = __webpack_require__(54489);
// EXTERNAL MODULE: ./src/actions/pages/clients/recruitment/unsuccessful-reasons.js
var unsuccessful_reasons = __webpack_require__(2228);
// EXTERNAL MODULE: ./src/actions/common/close-modal.js
var close_modal = __webpack_require__(67280);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
;// CONCATENATED MODULE: ./src/services/pages/clients/recruitment/unsuccessful-reasons.js







var UnsuccessfulReasonService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(UnsuccessfulReasonService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(UnsuccessfulReasonService);
    function UnsuccessfulReasonService() {
        (0,_class_call_check/* default */.Z)(this, UnsuccessfulReasonService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(UnsuccessfulReasonService, [
        {
            key: "getReasonsListData",
            value: function getReasonsListData(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.unsuccessful_reasons.REASON_LIST */.bl.client.unsuccessful_reasons.REASON_LIST;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createReasonsListData",
            value: function createReasonsListData(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.unsuccessful_reasons.CREATE_REASON */.bl.client.unsuccessful_reasons.CREATE_REASON;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deleteReasonsListData",
            value: function deleteReasonsListData(reason_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.unsuccessful_reasons.RUD_REASON.replace */.bl.client.unsuccessful_reasons.RUD_REASON.replace("$reason_id", reason_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.delete */.od["delete"](url, (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateReasonsListData",
            value: function updateReasonsListData(params, reason_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.unsuccessful_reasons.RUD_REASON.replace */.bl.client.unsuccessful_reasons.RUD_REASON.replace("$reason_id", reason_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.put */.od.put(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "showReasonListData",
            value: function showReasonListData(reason_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.unsuccessful_reasons.RUD_REASON.replace */.bl.client.unsuccessful_reasons.RUD_REASON.replace("$reason_id", reason_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(url, (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return UnsuccessfulReasonService;
}(common/* SendRequest */.Lt);

// EXTERNAL MODULE: ./public/icons/plus.svg
var plus = __webpack_require__(65099);
// EXTERNAL MODULE: ./public/icons/search.svg
var search = __webpack_require__(26173);
// EXTERNAL MODULE: ./public/icons/dots.svg
var dots = __webpack_require__(30054);
// EXTERNAL MODULE: ./src/styles/pages/clients/privacy-policy/_index.module.scss
var _index_module = __webpack_require__(8001);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/recruitments/unsuccessful-reasons.js


// ----------------- COMPONENTS ----------------------





// ----------------- COMPONENTS ----------------------
// ----------------- ACTIONS ----------------------


// ----------------- ACTION ----------------------
// ----------------- SERVICE ----------------------

// ----------------- SERVICE ----------------------
// ----------------- STYLESHEET ----------------------



// ----------------- STYLESHEET ----------------------
// ----------------- STYLESHEET ----------------------
 // ----------------- STYLESHEET ----------------------


/***/ }),

/***/ 57378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bl": function() { return /* reexport */ common/* API */.bl; },
  "LU": function() { return /* reexport */ Cronofy; },
  "Y5": function() { return /* reexport */ common/* CustomToastrAction */.Y5; },
  "q5": function() { return /* reexport */ RequestForMoreSlot; },
  "Us": function() { return /* reexport */ common/* SUCCESS_REPONSE_CODE */.Us; },
  "Lt": function() { return /* reexport */ send_request/* SendRequest */.L; },
  "TA": function() { return /* reexport */ common/* TRANSLATION */.TA; },
  "Mn": function() { return /* reexport */ common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn; },
  "sm": function() { return /* reexport */ common/* Yup */.sm; },
  "Sr": function() { return /* reexport */ kanban/* addParamsToUrl */.Sr; },
  "od": function() { return /* reexport */ common/* axios */.od; },
  "Dq": function() { return /* reexport */ cancelInterviewByCandidate; },
  "hw": function() { return /* reexport */ jobs_candidate_profile_job/* cancelInterviewByClient */.hw; },
  "os": function() { return /* reexport */ cronofyCallback; },
  "GB": function() { return /* reexport */ common/* handleOtherResponseCode */.GB; },
  "mQ": function() { return /* reexport */ isValidContactNo; },
  "go": function() { return /* reexport */ requestForMoreSlots; },
  "Pb": function() { return /* reexport */ requestToReschedule; },
  "d1": function() { return /* reexport */ reuqestMoreDaysData; },
  "$b": function() { return /* reexport */ updateContactNo; },
  "d4": function() { return /* reexport */ common/* useEffect */.d4; },
  "tv": function() { return /* reexport */ common/* useRouter */.tv; },
  "eJ": function() { return /* reexport */ common/* useState */.eJ; },
  "$G": function() { return /* reexport */ common/* useTranslation */.$G; }
});

// UNUSED EXPORTS: ErrorPages, REDIRECT, toastr, todayDate, tomorrowDate, useCallback, useRef

// EXTERNAL MODULE: ./src/services/common/send-request.js
var send_request = __webpack_require__(34964);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
;// CONCATENATED MODULE: ./src/services/pages/interviews/cronofy.js







var Cronofy = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(Cronofy, SendRequest);
    var _super = (0,_create_super/* default */.Z)(Cronofy);
    function Cronofy() {
        (0,_class_call_check/* default */.Z)(this, Cronofy);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(Cronofy, [
        {
            key: "getCronofyHash",
            value: function getCronofyHash(token, hostName) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(common/* API.client.cronofy.GET_CRONOFY_HASH */.bl.client.cronofy.GET_CRONOFY_HASH, (_tmp.params = {
                                        token: token
                                    }, _tmp.headers = _this.serverSideHeaderJSON(hostName), _tmp), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMoreDaysSlots",
            value: function getMoreDaysSlots(data) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(common/* API.client.cronofy.GET_MORE_DAYS_SLOTS */.bl.client.cronofy.GET_MORE_DAYS_SLOTS, (_tmp.params = data, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "interviewBooked",
            value: function interviewBooked(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(common/* API.client.cronofy.BOOK_INTERVIEW */.bl.client.cronofy.BOOK_INTERVIEW, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "requestForSlots",
            value: function requestForSlots(params, type) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(common/* API.client.cronofy.REQUEST_FOR_SLOTS */.bl.client.cronofy.REQUEST_FOR_SLOTS, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "rescheduleRequest",
            value: function rescheduleRequest(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(common/* API.client.cronofy.RESCHEDULE_REQUEST */.bl.client.cronofy.RESCHEDULE_REQUEST, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "cancelInterview",
            value: function cancelInterview(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(common/* API.client.cronofy.CANCEL_INTERVIEW */.bl.client.cronofy.CANCEL_INTERVIEW, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateContactNo",
            value: function updateContactNo(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(common/* API.client.cronofy.UPDATE_CONTACT_NO */.bl.client.cronofy.UPDATE_CONTACT_NO, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Cronofy;
}(send_request/* SendRequest */.L);

;// CONCATENATED MODULE: ./src/actions/pages/interviews/cronofy.js




function cronofyCallback(cronofyData, token, router1, setInitialData, setLoading) {
    var notification = cronofyData.notification;
    if (notification.type == "slot_selected") {
        setLoading(true);
        confirmSlot(notification, token, router1, setInitialData, setLoading);
    }
}
function reuqestMoreDaysData(router1, token, setInitialData, setShowPreferedTime, timezone) {
    return _reuqestMoreDaysData.apply(this, arguments);
}
function _reuqestMoreDaysData() {
    _reuqestMoreDaysData = (0,_async_to_generator/* default */.Z)(function(router1, token, setInitialData, setShowPreferedTime, timezone) {
        var data, _tmp, result, status_code, customToastrAction;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    data = (_tmp.request_more_slots = true, _tmp.token = token, _tmp.tzid = timezone, _tmp);
                    return [
                        4,
                        new Cronofy().getMoreDaysSlots(data)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new common/* CustomToastrAction */.Y5();
                    switch(status_code){
                        case common/* SUCCESS_REPONSE_CODE */.Us:
                            return [
                                3,
                                2
                            ];
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            return [
                                3,
                                4
                            ];
                    }
                    return [
                        3,
                        5
                    ];
                case 2:
                    return [
                        4,
                        setInitialData(result.data.data)
                    ];
                case 3:
                    _state.sent();
                    setShowPreferedTime(true);
                    // customToastrAction.setNormalToastr(result.data.success, 'success');
                    return [
                        3,
                        6
                    ];
                case 4:
                    customToastrAction.setNormalToastr(result.response.data.error, "error");
                    return [
                        3,
                        6
                    ];
                case 5:
                    (0,common/* handleOtherResponseCode */.GB)(status_code, router1);
                    _state.label = 6;
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return _reuqestMoreDaysData.apply(this, arguments);
}
function confirmSlot(notification, token, router1, setInitialData, setLoading) {
    return _confirmSlot.apply(this, arguments);
}
function _confirmSlot() {
    _confirmSlot = (0,_async_to_generator/* default */.Z)(function(notification, token, router1, setInitialData, setLoading) {
        var data, _tmp, result, status_code, customToastrAction;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    data = (_tmp.notification = notification, _tmp.token = token, _tmp);
                    return [
                        4,
                        new Cronofy().interviewBooked(data)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new common/* CustomToastrAction */.Y5();
                    setLoading(false);
                    switch(status_code){
                        case common/* SUCCESS_REPONSE_CODE */.Us:
                            setInitialData(result.data.data);
                            break;
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "error");
                            break;
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "error");
                            break;
                        default:
                            (0,common/* handleOtherResponseCode */.GB)(status_code, router1);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _confirmSlot.apply(this, arguments);
}
function requestForMoreSlots(args) {
    return _requestForMoreSlots.apply(this, arguments);
}
function _requestForMoreSlots() {
    _requestForMoreSlots = (0,_async_to_generator/* default */.Z)(function(args) {
        var data, _tmp, result, status_code, customToastrAction;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    data = (_tmp.token = args.token, _tmp.candidate_meeting_preference = {
                        preferred_date_time: "".concat(args.values.preferred_date, " ").concat(args.values.preferred_time),
                        reason: args.values.reason
                    }, _tmp.tzid = args.tzid, _tmp);
                    return [
                        4,
                        new Cronofy().requestForSlots(data, args.type)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new common/* CustomToastrAction */.Y5();
                    switch(status_code){
                        case common/* SUCCESS_REPONSE_CODE */.Us:
                            args.setBtnPopup(false);
                            args.setInitialData(result.data.data);
                            customToastrAction.setNormalToastr(result.data.success, "success");
                            break;
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "error");
                            break;
                        default:
                            (0,common/* handleOtherResponseCode */.GB)(status_code, args.router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _requestForMoreSlots.apply(this, arguments);
}
function cancelInterviewByCandidate(values, token, router1, setBtnPopup, setInitialData) {
    return _cancelInterviewByCandidate.apply(this, arguments);
}
function _cancelInterviewByCandidate() {
    _cancelInterviewByCandidate = (0,_async_to_generator/* default */.Z)(function(values, token, router1, setBtnPopup, setInitialData) {
        var data, _tmp, result, status_code, customToastrAction;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    data = (_tmp.token = token, _tmp.cancel_detail = values, _tmp);
                    return [
                        4,
                        new Cronofy().cancelInterview(data)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new common/* CustomToastrAction */.Y5();
                    switch(status_code){
                        case common/* SUCCESS_REPONSE_CODE */.Us:
                            setBtnPopup(false);
                            setInitialData(result.data.data);
                            customToastrAction.setNormalToastr(result.data.success, "success");
                            break;
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            customToastrAction.setNormalToastr(result.response.data.error, "error");
                            break;
                        default:
                            (0,common/* handleOtherResponseCode */.GB)(status_code, router1);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _cancelInterviewByCandidate.apply(this, arguments);
}
function requestToReschedule(router1, token, setInitialData) {
    return _requestToReschedule.apply(this, arguments);
}
function _requestToReschedule() {
    _requestToReschedule = (0,_async_to_generator/* default */.Z)(function(router1, token, setInitialData) {
        var data, _tmp, result, status_code, customToastrAction;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    data = (_tmp.token = token, _tmp);
                    return [
                        4,
                        new Cronofy().rescheduleRequest(data)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new common/* CustomToastrAction */.Y5();
                    switch(status_code){
                        case common/* SUCCESS_REPONSE_CODE */.Us:
                            return [
                                3,
                                2
                            ];
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            return [
                                3,
                                4
                            ];
                    }
                    return [
                        3,
                        5
                    ];
                case 2:
                    return [
                        4,
                        setInitialData(result.data.data)
                    ];
                case 3:
                    _state.sent();
                    if (result.data.success) {
                        customToastrAction.setNormalToastr(result.data.success, "success");
                    }
                    return [
                        3,
                        6
                    ];
                case 4:
                    customToastrAction.setNormalToastr(result.response.data.error, "error");
                    return [
                        3,
                        6
                    ];
                case 5:
                    (0,common/* handleOtherResponseCode */.GB)(status_code, router1);
                    _state.label = 6;
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return _requestToReschedule.apply(this, arguments);
}
function updateContactNo(args) {
    return _updateContactNo.apply(this, arguments);
}
function _updateContactNo() {
    _updateContactNo = (0,_async_to_generator/* default */.Z)(function(args) {
        var result, status_code, customToastrAction;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new Cronofy().updateContactNo(args)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new common/* CustomToastrAction */.Y5();
                    switch(status_code){
                        case common/* SUCCESS_REPONSE_CODE */.Us:
                            break;
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            break;
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            break;
                        default:
                            (0,common/* handleOtherResponseCode */.GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _updateContactNo.apply(this, arguments);
}
function isValidContactNo(contactNo, setContactError) {
    var phoneRegex = /^\+?[\d\s]+$/;
    if (contactNo) {
        if (phoneRegex.test(contactNo)) {
            if (contactNo.length < 8) {
                setContactError((0,common/* TRANSLATION */.TA)("errors:contact_short"));
                return false;
            }
            if (contactNo.length > 20) {
                setContactError((0,common/* TRANSLATION */.TA)("errors:contact_long"));
                return false;
            }
            setContactError("");
            return true;
        } else {
            setContactError((0,common/* TRANSLATION */.TA)("errors:no_special_char"));
            return false;
        }
    } else {
        setContactError((0,common/* TRANSLATION */.TA)("errors:required"));
    }
}

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/styles/components/request-for-more/_index.module.scss
var _index_module = __webpack_require__(92626);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
// EXTERNAL MODULE: ../../shared/node_modules/react-datetime/css/react-datetime.css
var react_datetime = __webpack_require__(18202);
// EXTERNAL MODULE: ../../shared/node_modules/moment/moment.js
var moment = __webpack_require__(62290);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/jobs/candidate-profile-job.js + 9 modules
var candidate_profile_job = __webpack_require__(51895);
// EXTERNAL MODULE: ./src/imports-files/components/job-filters.js + 1 modules
var job_filters = __webpack_require__(29774);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/common.js
var jobs_common = __webpack_require__(90432);
// EXTERNAL MODULE: ./src/imports-files/components/common-modal/common-modal.js + 2 modules
var common_modal = __webpack_require__(66172);
// EXTERNAL MODULE: ./src/components/common-modal/modal.js + 2 modules
var modal = __webpack_require__(99005);
;// CONCATENATED MODULE: ./src/components/request-for-more-slot.js














function RequestForMoreSlot(param) {
    var setBtnPopup = param.setBtnPopup, token = param.token, status = param.status, router = param.router, setInitialData = param.setInitialData, tzid = param.tzid;
    var validationSchema = function validationSchema(t) {
        var a = {
            preferred_date: common/* Yup.string */.sm.string().nullable().required(t("errors:required")).test("is-valid-date", t("errors:invalid_preferred_date"), function(value) {
                return (0,jobs_common/* isValidDate */.qb)(value);
            }),
            preferred_time: common/* Yup.string */.sm.string().required(t("errors:required")).test("is-correct", t("errors:invalid_preferred_time"), function(value) {
                return (0,jobs_common/* isCorrectTime */.XD)(value);
            }),
            reason: common/* Yup.string */.sm.string().required(t("errors:required"))
        };
        var REQUEST_MORE_SLOT = common/* Yup.object */.sm.object(a);
        return REQUEST_MORE_SLOT;
    };
    var t = (0,common/* useTranslation */.$G)().t;
    var type = status == "Scheduled" ? "reschedule_request" : "more_slot_request";
    var date = new Date();
    date.setDate(date.getDate() + 22);
    var initialValues = {
        preferred_date: status == "Scheduled" ? "" : date,
        preferred_time: "09:00",
        reason: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        type: "form",
        heading: status == "Scheduled" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: t("modal:form:reschedule:reschedule_request")
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: t("modal:form:reschedule:request_more_slots")
        }),
        closeModal: function(event) {
            setBtnPopup(false);
        },
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "RequestMore ".concat(common_modal/* FormModalStyle.Modal__Container__ContentSection */.w2.Modal__Container__ContentSection, " mt30"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Formik */.J9, {
                initialValues: initialValues,
                validationSchema: validationSchema(t),
                onSubmit: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
                        var _tmp;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _tmp = {};
                                    return [
                                        4,
                                        requestForMoreSlots((_tmp.values = values, _tmp.router = router, _tmp.setBtnPopup = setBtnPopup, _tmp.token = token, _tmp.type = type, _tmp.setInitialData = setInitialData, _tmp.tzid = tzid, _tmp))
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(values) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: function(formik) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Form */.l0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((_index_module_default()).Preferred_Date_Time),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((_index_module_default()).Preferred_Date_Time__LeftColumn, " ").concat((_index_module_default()).Form__TableCol),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: "".concat((_index_module_default()).Form__FloatingLabel),
                                                style: (0,common/* InputText */.oH)(formik, "preferred_date"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "red-color",
                                                        children: "*"
                                                    }),
                                                    "\xa0",
                                                    t("modal:form:reschedule:preferred_date")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                control: "customKeyboardPicker",
                                                className: "".concat((_index_module_default()).Preferred__Date),
                                                format: "DD/MM/YYYY",
                                                inputProps: {
                                                    readOnly: false,
                                                    style: (0,common/* InputError */.pd)(formik, "preferred_date")
                                                },
                                                minDate: new Date(new Date().setDate(new Date().getDate() + 1)),
                                                minDateMessage: "Preferred date must be present or future date",
                                                disablePast: true,
                                                placeholder: "dd/mm/yyyy",
                                                name: "preferred_date",
                                                onChange: function() {
                                                    var _ref = (0,_async_to_generator/* default */.Z)(function(date) {
                                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    return [
                                                                        4,
                                                                        formik.setFieldValue("preferred_date", date ? date.format("DD/MM/YYYY") : "")
                                                                    ];
                                                                case 1:
                                                                    _state.sent();
                                                                    return [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                    return function(date) {
                                                        return _ref.apply(this, arguments);
                                                    };
                                                }(),
                                                formik: formik,
                                                custom_error_90: "custom_error_90",
                                                custom_class: "form_custom_error mt0",
                                                value: typeof formik.values.preferred_date == "string" ? (0,job_filters/* setFilledDate */.vH)(formik.values.preferred_date) : formik.values.preferred_date
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((_index_module_default()).Preferred_Date_Time__RightColumn, " ").concat((_index_module_default()).Form__TableCol, " Timebg Timebg-arrow-down"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: "".concat((_index_module_default()).Form__FloatingLabel, " ").concat((0,common/* InputText */.oH)(formik, "preferred_time") ? "errorClass" : ""),
                                                style: (0,common/* InputText */.oH)(formik, "preferred_time"),
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "red-color",
                                                        children: "*"
                                                    }),
                                                    "\xa0",
                                                    t("modal:form:reschedule:preferred_time")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                control: "timeinput",
                                                disabled: false,
                                                value: formik.values.preferred_time,
                                                fullTimeDropdown: true,
                                                allowDelete: true,
                                                hour12Format: false,
                                                onChange: function(dateString) {
                                                    formik.setFieldValue("preferred_time", dateString);
                                                },
                                                inputProps: {
                                                    style: (0,common/* InputError */.pd)(formik, "preferred_time")
                                                },
                                                errorClass: (_index_module_default()).Form__Error,
                                                name: "preferred_time",
                                                formik: formik,
                                                manuallyDisplayDropdown: true,
                                                custom_class: "form_custom_error"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((_index_module_default()).SetupPopup__ContentBlock, " ").concat((_index_module_default()).Form__TableCol, " mt30"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "Dpflex ".concat((_index_module_default()).Form__FloatingLabel),
                                        style: (0,common/* InputText */.oH)(formik, "reason"),
                                        children: t("modal:form:reschedule:reason")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                        control: "customtextarea",
                                        type: "text",
                                        formik: formik,
                                        name: "reason",
                                        className: "".concat((_index_module_default()).Form__Textarea),
                                        style: (0,common/* InputError */.pd)(formik, "reason"),
                                        placeholder: t("placeholder:write_here"),
                                        custom_class: "form_custom_error"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat(common_modal/* FormModalStyle.Modal__Container__ButtonSection */.w2.Modal__Container__ButtonSection),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        buttonstyle: "".concat((_index_module_default()).secondarybtn),
                                        type: "button",
                                        onClick: function() {
                                            return setBtnPopup(false);
                                        },
                                        children: t("button:cancel")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        buttonstyle: "".concat((_index_module_default()).primarybtn),
                                        type: "submit",
                                        children: t("modal:form:reschedule:send_request")
                                    })
                                ]
                            })
                        ]
                    });
                }
            })
        })
    });
}

// EXTERNAL MODULE: ./src/actions/common/render_error_loading.js
var render_error_loading = __webpack_require__(10758);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/candidate-profile-job.js
var jobs_candidate_profile_job = __webpack_require__(57470);
// EXTERNAL MODULE: ./src/actions/pages/clients/candidates/kanban.js
var kanban = __webpack_require__(21572);
;// CONCATENATED MODULE: ./src/imports-files/pages/interviews/cronofy.js











/***/ }),

/***/ 52557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var _actions_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73140);



function EditImage(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.logo_url || "/images/pages/career/LOGO.png"), selectedFile = ref[0], setSelectedFile = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "image-upload",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        alt: "logo-image",
                        src: selectedFile,
                        className: "logo-image"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                    htmlFor: "file-input",
                    className: "img-edit-icon",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        alt: "icon-image",
                        src: "/icons/edit.png"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    id: "file-input",
                    type: "file",
                    onChange: function(event) {
                        return (0,_actions_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_2__/* .handleLogoOnChange */ .iH)(event, setSelectedFile);
                    },
                    accept: ".png, .jpg, .jpeg"
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (EditImage);


/***/ }),

/***/ 91752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62286);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32510);





function AddTeamMember(props) {
    var ref;
    (0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .clearSWRCache */ .A$)("client_add_team");
    var router = (0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .useRouter */ .tv)();
    var errorPages = new _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .ErrorPages */ .dC();
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(), 2), apiError = ref1[0], setApiError = ref1[1];
    var ref2 = (0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)(), t = ref2.t, i18n = ref2.i18n;
    var formRef = (0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .useRef */ .sO)(null);
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(0), 2), total_admin = ref3[0], setAdminCount = ref3[1];
    var step = router.query.step;
    var isQuickSetup = router.query.step && router.query.step == "add_teams" ? true : false;
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(false), 2), skipModal = ref4[0], setSkipModal = ref4[1];
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(Object.assign({}, (0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .setAddUserInitialValues */ .Qy)())), 2), initialValues = ref5[0], setInitialValues = ref5[1];
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)({}), 2), userRoles = ref6[0], setUserRoles = ref6[1];
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(true), 2), isLoading = ref7[0], setLoading = ref7[1];
    var queryClient = (0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .useQueryClient */ .NL)();
    var CSV_OPTIONS = {
        header: true,
        dynamicTyping: true,
        skipEmptyLines: true,
        transformHeader: function(header) {
            return header.toLowerCase().replace(/\W/g, "_");
        }
    };
    var ref8 = (0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .useSWR */ .dH)("client_add_team", function() {
        return (0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .getMyTeam */ .Rf)(router, setApiError);
    }, {
        revalidateOnFocus: false
    }), data = ref8.data, error = ref8.error;
    (0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .useEffect */ .d4)(function() {
        if (data) {
            var store_data = queryClient.getQueryData("add-user-data");
            if (store_data != undefined && data.client != undefined) {
                data.client.client_users_attributes = store_data;
            }
            data.client.client_users_attributes.length ? setInitialValues({
                client: data.client
            }) : "";
            setAdminCount((store_data === null || store_data === void 0 ? void 0 : store_data.filter(function(element) {
                return element._destroy == false;
            }).length) || data.client.client_users_attributes.length);
            setUserRoles(data.user_roles);
            setLoading(false);
            if (isQuickSetup) setTimeout(function() {
                new _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .SidebarAction */ .Dv().subsidebarQuickSetupChangeIcon(data.sidebar_options.complete_steps, "add_teams");
            }, 750);
        }
    }, [
        data
    ]);
    if (isLoading || error || errorPages.handleErrorCodes(apiError === null || apiError === void 0 ? void 0 : apiError.status)) {
        var renderPage = error || apiError ? errorPages.renderPage((error === null || error === void 0 ? void 0 : error.status) || (apiError === null || apiError === void 0 ? void 0 : apiError.status), router) : null;
        return renderPage;
    }
    if (true) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "Page DashboardPageContent",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .motion.div */ .EA.div, {
            initial: "pageInitial",
            animate: "pageAnimate",
            exit: "pageExit",
            variants: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PAGE_ANIMATION_OPTIONS */ .Mf,
            transition: {
                delay: 0.2
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.AddUsers__Container */ .k2.AddUsers__Container,
                    children: [
                        !isQuickSetup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.AddUsers__Heading */ .k2.AddUsers__Heading,
                            children: "Add Team Member"
                        }),
                        isQuickSetup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                            className: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.AddUsers__Heading */ .k2.AddUsers__Heading,
                            children: [
                                "Welcome  ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.ClientCompany__Company */ .k2.ClientCompany__Company,
                                    children: data === null || data === void 0 ? void 0 : (ref = data.client) === null || ref === void 0 ? void 0 : ref.name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                "Let’s get started."
                            ]
                        }),
                        isQuickSetup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.AddUsers__QuickStepHeading */ .k2.AddUsers__QuickStepHeading,
                            children: "Team"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h4", {
                            className: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.AddUsers__Subheading */ .k2.AddUsers__Subheading,
                            children: [
                                "Individuals that’ll be using Heartpace. For speed, you can ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "/sample_users.csv",
                                    download: "sample_users.csv",
                                    children: "download CSV template"
                                }),
                                " and import a list of users. You can also add more later."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.AddUsers__ButtonsActionSection */ .k2.AddUsers__ButtonsActionSection,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                        buttonstyle: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.primarybtn */ .ZJ.primarybtn,
                                        type: "button",
                                        onClick: function() {
                                            return (0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .onAdminUserAdd */ .Yk)(formRef, "add", setAdminCount, queryClient);
                                        },
                                        children: "Add User"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.AddUsers__ImportUsers */ .k2.AddUsers__ImportUsers,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .CSVReader */ .QM, {
                                            cssClass: "react-csv-input",
                                            parserOptions: CSV_OPTIONS,
                                            onFileLoaded: function(user_data, fileInfo) {
                                                return (0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .handelFileChange */ .I6)(user_data, formRef, setAdminCount, userRoles, queryClient, fileInfo);
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                            buttonstyle: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.tertiarybtn */ .ZJ.tertiarybtn,
                                            children: "Bulk Import User"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.FormSection */ .k2.FormSection,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .Formik */ .J9, {
                                enableReinitialize: true,
                                initialValues: initialValues,
                                validationSchema: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_SCHEMA */ .T1,
                                onSubmit: function() {
                                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(values, actions) {
                                        var errors;
                                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        (0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .addTeamMembers */ .yG)(values, router, isQuickSetup)
                                                    ];
                                                case 1:
                                                    errors = _state.sent();
                                                    actions.setErrors(errors);
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(values, actions) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(),
                                innerRef: formRef,
                                children: function(formik) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .FieldArray */ .F2, {
                                                name: "client_users_attributes",
                                                children: function() {
                                                    return formik.values.client.client_users_attributes.map(function(client, index) {
                                                        return !client["_destroy"] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "mt15 ".concat(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.AddUsers__FormSection */ .k2.AddUsers__FormSection),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                            className: "mb20 ".concat(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .FormStyle.Form__Label */ .x.Form__Label),
                                                                            children: [
                                                                                t("label:role"),
                                                                                " *"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                            className: "".concat(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input */ .k2.Form__Input, " ").concat(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.AddUsers__RoleInput */ .k2.AddUsers__RoleInput),
                                                                            control: "select",
                                                                            errorClass: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            formik: formik,
                                                                            name: "client.client_users_attributes.".concat(index, ".role_id"),
                                                                            onChange: function(option) {
                                                                                return formik.setFieldValue("client.client_users_attributes.".concat(index, ".role_id"), option.value);
                                                                            },
                                                                            options: userRoles,
                                                                            style: (0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "client.client_users_attributes.".concat(index, ".role_id")),
                                                                            default: client.role_id != "" ? client.role_id : ""
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                            className: "mb20 ".concat(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .FormStyle.Form__Label */ .x.Form__Label),
                                                                            children: [
                                                                                t("label:name"),
                                                                                " *"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                            control: "input",
                                                                            type: "text",
                                                                            formik: formik,
                                                                            name: "client.client_users_attributes.".concat(index, ".user_attributes.name"),
                                                                            placeholder: t("common:texts:example_name"),
                                                                            className: " ".concat(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input */ .k2.Form__Input, " ").concat(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.AddUsers__NameInput */ .k2.AddUsers__NameInput),
                                                                            errorClass: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            style: (0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "client.client_users_attributes.".concat(index, ".user_attributes.name"))
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                            className: "mb20 ".concat(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .FormStyle.Form__Label */ .x.Form__Label),
                                                                            children: [
                                                                                t("label:email"),
                                                                                " *"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                            control: "input",
                                                                            type: "text",
                                                                            formik: formik,
                                                                            name: "client.client_users_attributes.".concat(index, ".user_attributes.email"),
                                                                            placeholder: t("common:texts:example_email"),
                                                                            autoComplete: "password",
                                                                            className: "".concat(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input */ .k2.Form__Input, " ").concat(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.AddUsers__EmailInput */ .k2.AddUsers__EmailInput),
                                                                            errorClass: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            style: (0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "client.client_users_attributes.".concat(index, ".user_attributes.email"))
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.AddUsers__DeleteCrossHeight */ .k2.AddUsers__DeleteCrossHeight,
                                                                    children: client.deletable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                                        color: "primary",
                                                                        buttonstyle: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.nobgbutton */ .ZJ.nobgbutton,
                                                                        onClick: function() {
                                                                            return (0,_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .onAdminUserRemove */ .Ej)(formik, "remove", setAdminCount, index, queryClient);
                                                                        },
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .CloseIcon */ .Tw, {})
                                                                    })
                                                                })
                                                            ]
                                                        }, index);
                                                    });
                                                }
                                            }),
                                            skipModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .SkipModal */ ["if"], {
                                                setBtnPopup: setSkipModal,
                                                router: router
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "space"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.AddUsers__SubmitSection */ .k2.AddUsers__SubmitSection,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                        buttonstyle: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.secondarybtnborder */ .k2.secondarybtnborder,
                                                        type: "button",
                                                        onClick: function() {
                                                            setSkipModal(true);
                                                        },
                                                        children: [
                                                            " ",
                                                            t("button:skip"),
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                        type: "submit",
                                                        buttonstyle: _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.primarybtn */ .ZJ.primarybtn,
                                                        children: t("button:next_step")
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                }
                            })
                        })
                    ]
                })
            })
        })
    });
}
AddTeamMember.layout = _imports_files_pages_admins_dashboard_clients_add_users__WEBPACK_IMPORTED_MODULE_1__/* .ClientDashboard */ .LD;
/* harmony default export */ __webpack_exports__["default"] = (AddTeamMember);


/***/ }),

/***/ 48234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38641);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18186);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4012);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62286);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _components_common_modal_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99005);
/* harmony import */ var _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43361);









function AddCandidates(props) {
    var t = (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    // --- INFO:- Clearing the SWR cache ----
    (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .clearSWRCache */ .A$)("add_candidate_job_list");
    // --------------------------------------
    var router = (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useRouter */ .tv)();
    var formRef = (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useRef */ .sO)(null);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useState */ .eJ)(""), 2), cvErrorMessage = ref[0], setCvErrorMessage = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useState */ .eJ)(""), 2), otherErrorMessage = ref1[0], setOtherErrorMessage = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useState */ .eJ)(0), 2), fileCount = ref2[0], setFileCount = ref2[1];
    var ref3 = (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useSWR */ .dH)("add_candidate_job_list", function() {
        return (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .getJobListData */ .ax)({}, t);
    }), data = ref3.data, error = ref3.error;
    var errorPages = new _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .ErrorPages */ .dC();
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useState */ .eJ)(true), 2), isLoading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useState */ .eJ)(null), 2), apiError = ref5[0], setApiError = ref5[1];
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useState */ .eJ)(false), 2), loader = ref6[0], setLoader = ref6[1];
    var initialValues = (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .add_candidate_initial_values */ .Hh)();
    var dashbaordPageContent = props.no_page_content ? "" : "DashboardPageContent";
    var placeAutocompleteAction = new _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PlaceAutocompleteAction */ .TN();
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useState */ .eJ)(false), 2), isDisabled = ref7[0], setIsDisabled = ref7[1];
    var ref8 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useState */ .eJ)(false), 2), showLoader = ref8[0], setShowLoader = ref8[1];
    var ref9 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useState */ .eJ)(""), 2), referrerNameValue = ref9[0], setReferrerNameValue = ref9[1];
    var ref10 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useState */ .eJ)(""), 2), agencyUserEmail = ref10[0], setAgencyUserEmail = ref10[1];
    var ref11 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useState */ .eJ)([]), 2), suggestion = ref11[0], setSuggestion = ref11[1];
    var ref12 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useState */ .eJ)([]), 2), agencyUserSuggestion = ref12[0], setAgencyUserSuggestion = ref12[1];
    var ref13 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useState */ .eJ)([]), 2), agencyUsers = ref13[0], setAgencyUsers = ref13[1];
    var ref14 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useState */ .eJ)({
        state: false,
        message: ""
    }), 2), duplicateEmail = ref14[0], setDuplicateEmail = ref14[1];
    var ref15 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useState */ .eJ)(""), 2), otherSourceName = ref15[0], setOtherSourceName = ref15[1];
    var addCandidateActions = new _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .AddCandidateActions */ .Zm(setReferrerNameValue, setSuggestion, setAgencyUserSuggestion, setAgencyUserEmail);
    var otherSourceActions = new _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .OtherSourceAction */ .YB(setOtherSourceName, setSuggestion);
    var integrationRef = (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useRef */ .sO)(null);
    (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .useEffect */ .d4)(function() {
        console.log(data);
        if (data) {
            setLoading(false);
        }
    }, [
        data
    ]);
    if (isLoading || error || errorPages.handleErrorCodes(apiError === null || apiError === void 0 ? void 0 : apiError.status)) {
        var renderPage = error || apiError ? errorPages.renderPage((error === null || error === void 0 ? void 0 : error.status) || (apiError === null || apiError === void 0 ? void 0 : apiError.status), router) : null;
        return renderPage;
    }
    if (props.slug) {
        initialValues.client_candidate.assign = props.slug;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            loader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "LoaderStyle",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .Loading */ .gb, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "CandidatesListpage ".concat(dashbaordPageContent, " ").concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.JobList */ .k2.JobList, " ").concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.NewJob */ .k2.NewJob),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .ww.div, {
                        initial: "pageInitial",
                        animate: "pageAnimate",
                        exit: "pageExit",
                        variants: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PAGE_ANIMATION_OPTIONS */ .Mf,
                        transition: {
                            delay: 0.2
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.NewJob__Container */ .k2.NewJob__Container,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.NewJob__TopSection */ .k2.NewJob__TopSection,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.ClientCompany__BackSection */ .k2.ClientCompany__BackSection
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.ClientCompany__FormSection */ .k2.ClientCompany__FormSection,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.ClientCompany__Heading */ .k2.ClientCompany__Heading,
                                        children: t("button:add:candidate")
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.AddCandidatesForm */ .k2.AddCandidatesForm,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .Formik */ .J9, {
                                        initialValues: initialValues,
                                        validationSchema: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .validationSchema */ .p9)(agencyUsers),
                                        innerRef: formRef,
                                        onSubmit: function(values) {
                                            var _obj;
                                            (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .submitCandidate */ .xV)((_obj = {
                                                values: values,
                                                router: router,
                                                formik: formRef,
                                                from: props.from,
                                                setShowCandidate: props.setShowCandidate,
                                                setJobData: props.setJobData,
                                                setApiError: setApiError,
                                                setLoader: setLoader,
                                                setAutomationBar: props.setAutomationBar,
                                                setAutomationActions: props.setAutomationActions,
                                                showAutomationPopup: false,
                                                restart: props.restart,
                                                setTimerStatus: props.setTimerStatus
                                            }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "formik", formRef), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "setIsDisabled", setIsDisabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "setDuplicateEmail", setDuplicateEmail), _obj));
                                        },
                                        children: function(formik) {
                                            var ref, ref1, ref2, ref3, ref4, ref5;
                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .Form */ .l0, {
                                                className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form */ .k2.Form, " width100 AddCandidateForm"),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Table */ .k2.Form__Table,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "tablerowflex",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "tablecolflex ".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol, " mb30"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                                            children: t("label:upload_cv")
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__DropBox */ .k2.Form__DropBox,
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__DropBoxcontainer */ .k2.Form__DropBoxcontainer,
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .DropZone */ .rE, {
                                                                                    type: "cv",
                                                                                    multiple: "",
                                                                                    formik: formik,
                                                                                    setCvErrorMessage: setCvErrorMessage,
                                                                                    setOtherErrorMessage: setOtherErrorMessage,
                                                                                    autofill: true,
                                                                                    setFileCount: setFileCount,
                                                                                    accept: ".pdf, .rtf, .doc, .docx, .ppt, .pptx",
                                                                                    id: "add_candidate_cv",
                                                                                    isDisabled: isDisabled,
                                                                                    setIsDisabled: setIsDisabled,
                                                                                    setShowLoader: setShowLoader,
                                                                                    extensions: [
                                                                                        _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .EXTENSION_COMMON.PDF */ .Wg.PDF,
                                                                                        _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .EXTENSION_COMMON.DOC */ .Wg.DOC,
                                                                                        _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .EXTENSION_COMMON.DOCX */ .Wg.DOCX,
                                                                                        _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .EXTENSION_COMMON.RTF */ .Wg.RTF,
                                                                                        _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .EXTENSION_COMMON.PPT */ .Wg.PPT, 
                                                                                    ]
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            className: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__DropBoxError */ .k2.Form__DropBoxError,
                                                                            children: cvErrorMessage.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .GN, {
                                                                                        icon: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .faExclamationCircle */ .RL,
                                                                                        size: "sm"
                                                                                    }),
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        children: cvErrorMessage
                                                                                    })
                                                                                ]
                                                                            }) : ((ref = formik.errors) === null || ref === void 0 ? void 0 : (ref1 = ref.job_application) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.resume_attributes) === null || ref2 === void 0 ? void 0 : ref2.file_name) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                                                                                        src: "/icons/errorred.png",
                                                                                        alt: "",
                                                                                        height: 10,
                                                                                        width: 10
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                        children: [
                                                                                            (ref3 = formik.errors) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.job_application) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.resume_attributes) === null || ref5 === void 0 ? void 0 : ref5.file_name,
                                                                                            " "
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }) : ""
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "tablecolflex ".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                                            children: t("label:additional_files")
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__DropBox */ .k2.Form__DropBox,
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__DropBoxcontainer */ .k2.Form__DropBoxcontainer,
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .DropZone */ .rE, {
                                                                                    type: "other",
                                                                                    multiple: "multiple",
                                                                                    formik: formik,
                                                                                    setCvErrorMessage: setCvErrorMessage,
                                                                                    setOtherErrorMessage: setOtherErrorMessage,
                                                                                    autofill: false,
                                                                                    setFileCount: setFileCount,
                                                                                    accept: ".pdf, .rtf, .jpeg, .png, .doc, .docx, .jpg, .ppt, .pptx",
                                                                                    id: "additional_files_cv",
                                                                                    isDisabled: false,
                                                                                    setIsDisabled: setIsDisabled,
                                                                                    setShowLoader: setShowLoader,
                                                                                    extensions: [
                                                                                        _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .EXTENSION_COMMON.PDF */ .Wg.PDF,
                                                                                        _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .EXTENSION_COMMON.DOC */ .Wg.DOC,
                                                                                        _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .EXTENSION_COMMON.DOCX */ .Wg.DOCX,
                                                                                        _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .EXTENSION_COMMON.RTF */ .Wg.RTF,
                                                                                        _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .EXTENSION_COMMON.PPT */ .Wg.PPT,
                                                                                        _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .EXTENSION_COMMON.JPG */ .Wg.JPG,
                                                                                        _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .EXTENSION_COMMON.JPEG */ .Wg.JPEG,
                                                                                        _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .EXTENSION_COMMON.PNG */ .Wg.PNG
                                                                                    ]
                                                                                })
                                                                            })
                                                                        }),
                                                                        otherErrorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                            className: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__DropBoxError */ .k2.Form__DropBoxError,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .GN, {
                                                                                    icon: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .faExclamationCircle */ .RL,
                                                                                    size: "sm"
                                                                                }),
                                                                                " ",
                                                                                otherErrorMessage
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "tablecolflex ".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "client_candidate.first_name"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: "red-color",
                                                                                    children: "*"
                                                                                }),
                                                                                "\xa0",
                                                                                t("label:first_name")
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                            control: "input",
                                                                            type: "text",
                                                                            name: "client_candidate.first_name",
                                                                            className: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Input */ .k2.Form__Input,
                                                                            formik: formik,
                                                                            errorClass: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "client_candidate.first_name"),
                                                                            onKeyDown: function() {
                                                                                var ref, ref1;
                                                                                (formik === null || formik === void 0 ? void 0 : (ref = formik.status) === null || ref === void 0 ? void 0 : (ref1 = ref.client_candidate) === null || ref1 === void 0 ? void 0 : ref1.first_name) ? formik.current.status.client_candidate.first_name = "" : "";
                                                                            }
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "tablecolflex ".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "client_candidate.last_name"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: "red-color",
                                                                                    children: "*"
                                                                                }),
                                                                                "\xa0",
                                                                                t("label:last_name")
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                            control: "input",
                                                                            type: "text",
                                                                            name: "client_candidate.last_name",
                                                                            className: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Input */ .k2.Form__Input,
                                                                            formik: formik,
                                                                            errorClass: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "client_candidate.last_name"),
                                                                            onKeyDown: function() {
                                                                                var ref, ref1;
                                                                                (formik === null || formik === void 0 ? void 0 : (ref = formik.status) === null || ref === void 0 ? void 0 : (ref1 = ref.client_candidate) === null || ref1 === void 0 ? void 0 : ref1.last_name) ? formik.current.status.client_candidate.last_name = "" : "";
                                                                            }
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "tablecolflex ".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "client_candidate.email"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: "red-color",
                                                                                    children: "*"
                                                                                }),
                                                                                "\xa0",
                                                                                t("label:email")
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                            control: "input",
                                                                            type: "text",
                                                                            name: "client_candidate.email",
                                                                            formik: formik,
                                                                            className: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Input */ .k2.Form__Input,
                                                                            errorClass: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "client_candidate.email"),
                                                                            onKeyDown: function() {
                                                                                var ref, ref1;
                                                                                (formik === null || formik === void 0 ? void 0 : (ref = formik.status) === null || ref === void 0 ? void 0 : (ref1 = ref.client_candidate) === null || ref1 === void 0 ? void 0 : ref1.email) ? formik.status.client_candidate.email = "" : "";
                                                                            }
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "tablecolflex ".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "client_candidate.contact_no"),
                                                                            children: t("label:phone_number")
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                            control: "input",
                                                                            type: "text",
                                                                            name: "client_candidate.contact_no",
                                                                            formik: formik,
                                                                            className: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Input */ .k2.Form__Input,
                                                                            errorClass: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "client_candidate.contact_no")
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "tablecolflex ".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "client_candidate.location"),
                                                                            children: t("label:location")
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PlacesAutocomplete */ .mb, {
                                                                            value: formik.values.client_candidate.location,
                                                                            onChange: function() {
                                                                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(value) {
                                                                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                                                                                        switch(_state.label){
                                                                                            case 0:
                                                                                                return [
                                                                                                    4,
                                                                                                    formik.setFieldValue("client_candidate.location", value)
                                                                                                ];
                                                                                            case 1:
                                                                                                _state.sent();
                                                                                                return [
                                                                                                    2
                                                                                                ];
                                                                                        }
                                                                                    });
                                                                                });
                                                                                return function(value) {
                                                                                    return _ref.apply(this, arguments);
                                                                                };
                                                                            }(),
                                                                            onSelect: function(value) {
                                                                                (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .geocodeByAddress */ .NU)(value).then(function(results) {
                                                                                    return getLatLng(results[0]);
                                                                                }).then(function(latLng) {
                                                                                    return console.log("Success", latLng);
                                                                                }).catch(function(error) {
                                                                                    return console.error("Error", error);
                                                                                });
                                                                                formik.setFieldValue("client_candidate.location", value);
                                                                            },
                                                                            children: function(param) {
                                                                                var getInputProps = param.getInputProps, getSuggestionItemProps = param.getSuggestionItemProps, suggestions = param.suggestions, loading = param.loading;
                                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                    className: "autocomplete-root",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                                                                            name: "client_candidate.location",
                                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "client_candidate.location")
                                                                                        }, getInputProps({
                                                                                            className: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Input */ .k2.Form__Input
                                                                                        }))),
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                            className: "autocomplete-dropdown-container",
                                                                                            children: [
                                                                                                loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                                    children: t("loading")
                                                                                                }),
                                                                                                suggestions.map(function(suggestion) {
                                                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, getSuggestionItemProps(suggestion)), {
                                                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                            children: suggestion.description
                                                                                                        }, suggestion.id)
                                                                                                    }), suggestion.placeId);
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                });
                                                                            }
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "tablecolflex ".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "client_candidate.assign"),
                                                                            children: t("label:assign_to_job")
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                            control: "select",
                                                                            type: "text",
                                                                            placeholder: t("placeholder:select:please"),
                                                                            name: "client_candidate.assign",
                                                                            formik: formik,
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Input */ .k2.Form__Input, " mt0"),
                                                                            errorClass: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            options: data.resultArray,
                                                                            onChange: function(value) {
                                                                                return (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .handleAssignValueOnChange */ .EA)("assign", value, formik);
                                                                            },
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "client_candidate.assign"),
                                                                            default: formik.values.assign,
                                                                            disabled: props.slug && props.slug.length > 0,
                                                                            value: data.resultArray.filter(function(option) {
                                                                                return option.value === formik.values.client_candidate.assign;
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                formik.values.client_candidate.assign != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "tablecolflex ".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "client_candidate.sourced_option"),
                                                                            children: t("label:source")
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                            control: "select",
                                                                            type: "text",
                                                                            placeholder: t("placeholder:select:source"),
                                                                            name: "client_candidate.sourced_option",
                                                                            formik: formik,
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Input */ .k2.Form__Input, " mt0"),
                                                                            errorClass: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            options: data.sourcedOption,
                                                                            onChange: function(data) {
                                                                                var ref, ref1;
                                                                                formik.setFieldValue("client_candidate.sourced_option", data.value);
                                                                                (ref = integrationRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.select) === null || ref1 === void 0 ? void 0 : ref1.clearValue();
                                                                            },
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "client_candidate.sourced_option"),
                                                                            default: formik.values.sourced_option,
                                                                            value: data.sourcedOption.filter(function(option) {
                                                                                return option.value === formik.values.client_candidate.sourced_option;
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                [
                                                                    "Social",
                                                                    "Job Board"
                                                                ].includes(formik.values.client_candidate.sourced_option) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "tablecolflex ".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                                            children: [
                                                                                t("label:social_platform"),
                                                                                " / ",
                                                                                t("label:job_board"),
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                            control: "select",
                                                                            type: "text",
                                                                            placeholder: t("placeholder:select:platform_job_board"),
                                                                            name: "client_candidate.job_board_integration_attributes.integration_id",
                                                                            formik: formik,
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Input */ .k2.Form__Input, " mt0"),
                                                                            errorClass: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            options: formik.values.client_candidate.sourced_option == "Job Board" ? data.integration_options.job_board : data.integration_options.social,
                                                                            onChange: function(data) {
                                                                                if (data) {
                                                                                    formik.setFieldValue("client_candidate.job_board_integration_attributes", {
                                                                                        integration_id: data.value,
                                                                                        integration_type: data.type,
                                                                                        _destroy: false
                                                                                    });
                                                                                } else {
                                                                                    formik.setFieldValue("client_candidate.job_board_integration_attributes", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, formik.values.client_candidate.job_board_integration_attributes), {
                                                                                        integration_id: "",
                                                                                        _destroy: true,
                                                                                        integration_type: "Integration"
                                                                                    }));
                                                                                }
                                                                            },
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "client_candidate.job_board_integration_attributes.integration_id"),
                                                                            default: formik.values.client_candidate.job_board_integration_attributes,
                                                                            value: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .selectedIntegrationOption */ .YF)(formik.values.client_candidate.sourced_option == "Job Board" ? data.integration_options.job_board : data.integration_options.social, formik.values.client_candidate.job_board_integration_attributes),
                                                                            reference: integrationRef
                                                                        })
                                                                    ]
                                                                }),
                                                                formik.values.client_candidate.sourced_option == "Other" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "tablecolflex ".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                                            children: t("label:other")
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                            control: "autosuggestInput",
                                                                            errorClass: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            formik: formik,
                                                                            getSuggestionValue: otherSourceActions.getSuggestionValue,
                                                                            inputProps: {
                                                                                className: "AutosuggestOpenUp ".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Input */ .k2.Form__Input),
                                                                                formik: formik,
                                                                                name: "other_source",
                                                                                onChange: function(value, param) {
                                                                                    var newValue = param.newValue;
                                                                                    formik.setFieldValue("other_source", newValue);
                                                                                    setOtherSourceName(newValue);
                                                                                },
                                                                                style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "other_source"),
                                                                                value: otherSourceName
                                                                            },
                                                                            onSuggestionsClearRequested: otherSourceActions.onSuggestionsClearRequested,
                                                                            onSuggestionsFetchRequested: otherSourceActions.onSuggestionsFetchRequested,
                                                                            renderSuggestion: otherSourceActions.renderSuggestion,
                                                                            shouldRenderSuggestions: otherSourceActions.shouldRenderSuggestions,
                                                                            suggestions: suggestion
                                                                        })
                                                                    ]
                                                                }),
                                                                formik.values.client_candidate.sourced_option == "Referral" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "tablecolflex ".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, props.type == "referrer_name"),
                                                                            children: t("label:referral_name")
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                            control: "autosuggestInput",
                                                                            errorClass: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            formik: formik,
                                                                            getSuggestionValue: addCandidateActions.getSuggestionValue,
                                                                            inputProps: {
                                                                                className: "AutosuggestOpenUp ".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Input */ .k2.Form__Input),
                                                                                formik: formik,
                                                                                name: "referrer_name",
                                                                                onChange: function(value, param) {
                                                                                    var newValue = param.newValue;
                                                                                    formik.setFieldValue("referrer_name", newValue);
                                                                                    setReferrerNameValue(newValue);
                                                                                },
                                                                                style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, props.type == "referrer_name"),
                                                                                value: referrerNameValue
                                                                            },
                                                                            onSuggestionsClearRequested: addCandidateActions.onSuggestionsClearRequested,
                                                                            onSuggestionsFetchRequested: addCandidateActions.onSuggestionsFetchRequested,
                                                                            renderSuggestion: addCandidateActions.renderSuggestion,
                                                                            shouldRenderSuggestions: addCandidateActions.shouldRenderSuggestions,
                                                                            suggestions: suggestion
                                                                        })
                                                                    ]
                                                                }),
                                                                formik.values.client_candidate.assign != "" && formik.values.client_candidate.sourced_option == "Agency" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "tablecolflex ".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "client_candidate.agency_id"),
                                                                            children: t("label:agency")
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                            control: "select",
                                                                            type: "text",
                                                                            placeholder: t("placeholder:select:agency"),
                                                                            name: "client_candidate.agency_id",
                                                                            formik: formik,
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Input */ .k2.Form__Input, " mt0"),
                                                                            errorClass: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            options: data.agencies,
                                                                            onChange: function(option) {
                                                                                (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .handleAssignValueOnChange */ .EA)("agency_id", option, formik);
                                                                                setAgencyUsers(option.users);
                                                                                formik.setFieldValue("client_candidate.agency_domain", option.domain);
                                                                            },
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "client_candidate.agency_id"),
                                                                            default: formik.values.client_candidate.agency_id,
                                                                            value: data.agencies.filter(function(option) {
                                                                                return option.value === formik.values.client_candidate.agency_id;
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                formik.values.client_candidate.sourced_option == "Agency" && formik.values.client_candidate.agency_id && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "tablecolflex ".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "client_candidate.agency_user_email"),
                                                                            children: t("label:agency_user_email")
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                            control: "autosuggestInput",
                                                                            errorClass: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            formik: formik,
                                                                            getSuggestionValue: addCandidateActions.getAgencyUserSuggestionValue,
                                                                            inputProps: {
                                                                                className: "AutosuggestOpenUp ".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Input */ .k2.Form__Input),
                                                                                formik: formik,
                                                                                name: "client_candidate.agency_user_email",
                                                                                onChange: function(value, param) {
                                                                                    var newValue = param.newValue;
                                                                                    formik.setFieldValue("client_candidate.agency_user_email", newValue);
                                                                                    setAgencyUserEmail(newValue);
                                                                                },
                                                                                style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "client_candidate.agency_user_email"),
                                                                                value: agencyUserEmail
                                                                            },
                                                                            onSuggestionsClearRequested: addCandidateActions.onAgencyUserSuggestionsClearRequested,
                                                                            onSuggestionsFetchRequested: function(hash) {
                                                                                return addCandidateActions.onAgencyUserSuggestionsFetchRequested(hash, agencyUsers, setAgencyUsers);
                                                                            },
                                                                            renderSuggestion: addCandidateActions.renderAgencyUserSuggestion,
                                                                            shouldRenderSuggestions: addCandidateActions.shouldRenderSuggestions,
                                                                            suggestions: agencyUserSuggestion,
                                                                            custom_error_90: "custom_error_90"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "tablecolflex ".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "client_candidate.social_media_detail_attributes.linkedin_url"),
                                                                            children: t("label:linkedin_url")
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                            control: "input",
                                                                            type: "text",
                                                                            name: "client_candidate.social_media_detail_attributes.linkedin_url",
                                                                            formik: formik,
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Input */ .k2.Form__Input, " mt0"),
                                                                            errorClass: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "client_candidate.social_media_detail_attributes.linkedin_url")
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "tablecolflex ".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "client_candidate.social_media_detail_attributes.portfolio_url"),
                                                                            children: t("label:portfolio_link")
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                            control: "input",
                                                                            type: "text",
                                                                            name: "client_candidate.social_media_detail_attributes.portfolio_url",
                                                                            formik: formik,
                                                                            className: "".concat(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Input */ .k2.Form__Input, " mt0"),
                                                                            errorClass: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            style: (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "client_candidate.social_media_detail_attributes.portfolio_url")
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "space"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.NewJob__SubmitSection */ .k2.NewJob__SubmitSection,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                                                    buttonstyle: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.secondarybtnborder */ .k2.secondarybtnborder,
                                                                    type: "button",
                                                                    onClick: function() {
                                                                        (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .goToCandidateListingPage */ .I3)(router, props.from, formRef, setIsDisabled);
                                                                    },
                                                                    children: [
                                                                        " ",
                                                                        t("button:cancel"),
                                                                        " "
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                                                    buttonstyle: _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .PageStyle.primarybtn */ .k2.primarybtn,
                                                                    type: "submit",
                                                                    children: [
                                                                        " ",
                                                                        t("button:save"),
                                                                        " "
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    href: "#",
                                                                    className: "preview-job-link dnone",
                                                                    target: "_blank"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            });
                                        }
                                    })
                                })
                            ]
                        })
                    }),
                    showLoader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .Loading */ .gb, {}),
                    duplicateEmail.state && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_modal_modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "confirmation",
                        message: t("modal:confirmation:email_already_used"),
                        closeModal: function() {
                            return setDuplicateEmail({
                                state: false
                            });
                        },
                        btnAction: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                            var _obj;
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                                (0,_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .getCandidateToken */ .I8)((_obj = {
                                    values: formRef.current.values,
                                    router: router,
                                    formik: formRef,
                                    from: props.from,
                                    setShowCandidate: props.setShowCandidate,
                                    setJobData: props.setJobData,
                                    setApiError: setApiError,
                                    setLoader: setLoader,
                                    setAutomationBar: props.setAutomationBar,
                                    setAutomationActions: props.setAutomationActions,
                                    showAutomationPopup: false,
                                    restart: props.restart,
                                    setTimerStatus: props.setTimerStatus
                                }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "formik", formRef), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "setIsDisabled", setIsDisabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "setDuplicateEmail", setDuplicateEmail), _obj), duplicateEmail);
                                return [
                                    2
                                ];
                            });
                        }),
                        texts: {
                            button1_text: t("button:no"),
                            button2_text: t("button:yes")
                        }
                    })
                ]
            })
        ]
    });
}
AddCandidates.layout = _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_2__/* .ClientDashboard */ .LD;
/* harmony default export */ __webpack_exports__["default"] = (AddCandidates);


/***/ }),

/***/ 23746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ AddOffer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(38641);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(18186);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(4012);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62286);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47942);
/* harmony import */ var _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13245);
/* harmony import */ var _imports_files_components_job_filters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29774);
/* harmony import */ var _styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(51841);
/* harmony import */ var _styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _components_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95662);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53429);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(62607);
/* harmony import */ var react_places_autocomplete__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25538);
/* harmony import */ var _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66172);

















function AddOffer(param) {
    var offerHash = param.offerHash, setOfferHash = param.setOfferHash, setShowOffer = param.setShowOffer, router = param.router, from = param.from, setJobData = param.setJobData, setInitialData = param.setInitialData, setShowLoader = param.setShowLoader, _candidateIndex = param.candidateIndex, candidateIndex = _candidateIndex === void 0 ? null : _candidateIndex, _paramStageId = param.paramStageId, paramStageId = _paramStageId === void 0 ? null : _paramStageId, _syncNowBtnClick = param.syncNowBtnClick, syncNowBtnClick = _syncNowBtnClick === void 0 ? false : _syncNowBtnClick, _setHiredSyncNowBtn = param.setHiredSyncNowBtn, setHiredSyncNowBtn = _setHiredSyncNowBtn === void 0 ? null : _setHiredSyncNowBtn, _setHiredSyncModal = param.setHiredSyncModal, setHiredSyncModal = _setHiredSyncModal === void 0 ? null : _setHiredSyncModal;
    var handleIsRemote = function handleIsRemote(event, formik) {
        var isChecked = event.target.checked;
        var inputName = event.target.getAttribute("name");
        formik.setFieldValue("offer.location_attributes.full_address", "");
        formik.setFieldValue(inputName, isChecked);
    };
    var handleSubmitButtonState = function handleSubmitButtonState(formik, btnType) {
        if (formik.values.offer.remote) {
            setCheckLocationValidation(false);
        } else {
            setCheckLocationValidation(true);
        }
        if (btnType == "save") {
            formik.values.offer.is_save = true;
            setSaveValue(false);
            formik.validateForm().then(function() {
                formik.submitForm();
            });
        } else {
            delete formik.values.offer.is_save;
            setSaveValue(true);
            formik.validateForm().then(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                    formik.submitForm();
                    return [
                        2
                    ];
                });
            }));
        }
    };
    var shouldFetchSuggestions = function shouldFetchSuggestions(formik) {
        var ref, ref1;
        return ((ref = formik.values.offer.location_attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.full_address) === null || ref1 === void 0 ? void 0 : ref1.length) >= 3;
    };
    var ref;
    var formRef = (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .useRef */ .sO)();
    var selectDropdownRef = (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .useRef */ .sO)();
    var approvalDropdownRef = (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .useRef */ .sO)(null);
    var salary_duration = offerHash.salary_duration;
    var currency = offerHash.currency;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)({}), 2), initialValues = ref1[0], setInitialValues = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(), 2), offerId = ref2[0], setOfferId = ref2[1];
    var offer_id = (ref = offerHash.offer) === null || ref === void 0 ? void 0 : ref.id;
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(currency[0].symbol), 2), currencySymbol = ref3[0], setCurrencySymbol = ref3[1];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(offerHash.offer && offerHash.offer.offer_status == "draft" ? offerHash.offer.start_date : ""), 2), selectedDate = ref4[0], setSelectedDate = ref4[1];
    var Placeholder = function(props) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .components.Placeholder */ .wx.Placeholder, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, props));
    };
    var ref5 = (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)(), t = ref5.t, i18n = ref5.i18n;
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)([]), 2), approvalOptions = ref6[0], setApprovalOptions = ref6[1];
    var offerActions = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .OfferActions */ ._Q(setApprovalOptions, approvalDropdownRef, t);
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(""), 2), approverEmail = ref7[0], setApproverEmail = ref7[1];
    var ref8 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(""), 2), approverEmailError = ref8[0], setApproverEmailError = ref8[1];
    var ref9 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)([]), 2), users = ref9[0], setUsers = ref9[1];
    var ref10 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)([]), 2), requiredApproverOption = ref10[0], setRequiredApproverOption = ref10[1];
    var editorRef = (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .useRef */ .sO)(null);
    var ref11 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(), 2), saveValue = ref11[0], setSaveValue = ref11[1];
    var ref12 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(true), 2), checkLocationValidaton = ref12[0], setCheckLocationValidation = ref12[1];
    var ref13 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(false), 2), syncFormValidation = ref13[0], setSyncFormValidation = ref13[1];
    (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .useEffect */ .d4)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
        var ref, ref1, ref2, ref3, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!offerHash) return [
                        3,
                        8
                    ];
                    data = (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .offerInitialValues */ .Ff)(offerHash);
                    return [
                        4,
                        setInitialValues(data)
                    ];
                case 1:
                    _state.sent();
                    console.log(offerHash);
                    if (!(offerHash.offer && offerHash.offer.offer_status == "draft")) return [
                        3,
                        2
                    ];
                    formRef.current.setFieldValue("offer.salary_period", offerHash.offer.salary_period);
                    formRef.current.setFieldValue("offer.start_date", offerHash.offer.start_date);
                    formRef.current.setFieldTouched("offer.start_date", true);
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        selectDropdownRef.current.select.clearValue()
                    ];
                case 3:
                    _state.sent();
                    formRef.current.setFieldValue("offer.salary_period", "");
                    formRef.current.setFieldValue("offer.start_date", "");
                    formRef.current.setFieldTouched("offer.start_date", false);
                    _state.label = 4;
                case 4:
                    formRef.current.setFieldValue("offer.checkValidation", false);
                    formRef.current.setFieldValue("offer.syncValidation", false);
                    offerHash.stage_name == "Hired" ? setSyncFormValidation(true) : setSyncFormValidation(false);
                    return [
                        4,
                        setOfferId((ref = offerHash.offer) === null || ref === void 0 ? void 0 : ref.id)
                    ];
                case 5:
                    _state.sent();
                    return [
                        4,
                        setCurrencySymbol(((ref1 = currency.filter(function(x) {
                            return x.value == offerHash.currency_id;
                        })[0]) === null || ref1 === void 0 ? void 0 : ref1.symbol) || currency[0].symbol)
                    ];
                case 6:
                    _state.sent();
                    return [
                        4,
                        offerActions.setOptions(((ref2 = offerHash.offer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.approvers) === null || ref3 === void 0 ? void 0 : ref3.length) || 0)
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        2
                    ];
            }
        });
    }), [
        offerHash
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: initialValues.offer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().AddOffer), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().JobList), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().NewJob)),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().NewJob__Container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().NewJob__TopSection),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().ClientCompany__BackSection), " pb16"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    setShowOffer(false)
                                                ];
                                            case 1:
                                                _state.sent();
                                                (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .onCancelClick */ .bp)();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .Close */ .x8, {
                                        className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().ClientCompany__BackSection__CloseIcon))
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: t("close")
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().ClientCompany__FormSection),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().ClientCompany__Heading),
                            children: syncNowBtnClick && offerHash.stage_name == "Hired" ? t("candidates:data_sync") : t("candidates:create_offer")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().AddCandidatesForm),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .Formik */ .J9, {
                            initialValues: initialValues,
                            validationSchema: (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .offerValidationSchema */ .mU)(saveValue, checkLocationValidaton, syncFormValidation),
                            innerRef: formRef,
                            onSubmit: function(values, actions) {
                                values.offer.salary = values.offer.salary.toString().replaceAll(",", "");
                                values.kanban = {
                                    candidate_index: candidateIndex,
                                    base_stage_id: paramStageId
                                };
                                var sortByFilterData = (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .ApplicationFilter */ .it)(router.query.job_id);
                                if (sortByFilterData) {
                                    values.application_filter_data = sortByFilterData;
                                }
                                var _obj;
                                var errors = (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .submitOffer */ .zb)((_obj = {
                                    values: values,
                                    router: router,
                                    formik: formRef,
                                    from: from,
                                    setJobData: setJobData,
                                    setShowOffer: setShowOffer
                                }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, "router", router), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, "offer_id", offer_id), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, "setInitialData", setInitialData), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, "setShowLoader", setShowLoader), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, "syncNowBtnClick", syncNowBtnClick), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, "setHiredSyncNowBtn", setHiredSyncNowBtn), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, "setHiredSyncModal", setHiredSyncModal), _obj));
                                actions.setErrors(errors);
                            },
                            children: function(formik) {
                                var ref;
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .Form */ .l0, {
                                    className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Table),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().ClientCompany__Subheading),
                                                children: t("candidates:heading")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableRowTwoGrid),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol), " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Label), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabel), " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "offer.name"),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "red-color",
                                                                    children: "*"
                                                                }),
                                                                "\xa0",
                                                                t("label:name")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                            control: "input",
                                                            type: "text",
                                                            // placeholder="Name"
                                                            name: "offer.name",
                                                            className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Input), " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__Input */ .x.Form__Input),
                                                            formik: formik,
                                                            // disabled= {true}
                                                            errorclass: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Error),
                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.name")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol), " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Label), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabel), " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "offer.email"),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "red-color",
                                                                    children: "*"
                                                                }),
                                                                "\xa0",
                                                                t("label:email")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                            control: "input",
                                                            type: "text",
                                                            // placeholder="Email address"
                                                            name: "offer.email",
                                                            formik: formik,
                                                            className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Input), " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__Input */ .x.Form__Input),
                                                            errorclass: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Error),
                                                            // disabled={offerHash.email && offerHash.email.length > 0 }
                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.email")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableRowTwoGrid),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol), " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Label), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabel), " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "offer.contact_no"),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "red-color",
                                                                    children: "*"
                                                                }),
                                                                "\xa0",
                                                                t("label:phone")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                            control: "input",
                                                            type: "text",
                                                            // placeholder="Phone Number"
                                                            name: "offer.contact_no",
                                                            formik: formik,
                                                            className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Input), " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__Input */ .x.Form__Input),
                                                            errorclass: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Error),
                                                            // disabled={offerHash.contact_no && offerHash.contact_no.length > 0 }
                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.contact_no")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Label), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabel)),
                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "offer.start_date"),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "red-color",
                                                                    children: "*"
                                                                }),
                                                                "\xa0",
                                                                t("jobs:details:input:offer_start_date")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                            control: "customDatePicker",
                                                            className: "FilterCustomDateTime FilterCustomEndDate",
                                                            format: "DD/MM/yyyy",
                                                            formik: formik,
                                                            inputProps: {
                                                                disabled: false,
                                                                placeholder: t("placeholder:select:date"),
                                                                readOnly: true,
                                                                style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.start_date")
                                                            },
                                                            disablePast: new Date(),
                                                            name: "offer.start_date",
                                                            onChange: function(moment) {
                                                                formik.setFieldValue("offer.start_date", moment.format("DD/MM/YYYY"));
                                                                setSelectedDate(moment);
                                                            },
                                                            value: typeof selectedDate == "string" ? (0,_imports_files_components_job_filters__WEBPACK_IMPORTED_MODULE_3__/* .setFilledDate */ .vH)(selectedDate) : selectedDate
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        syncNowBtnClick && offerHash.stage_name == "Hired" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableRowTwoGrid),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                    className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Label), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabel)),
                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "offer.team"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "red-color"
                                                                        }),
                                                                        "\xa0",
                                                                        t("label:team")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                    control: "input",
                                                                    type: "text",
                                                                    name: "offer.team",
                                                                    formik: formik,
                                                                    className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Input),
                                                                    errorclass: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Error),
                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.team")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                    className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Label), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabel)),
                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "offer.business_unit"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "red-color"
                                                                        }),
                                                                        "\xa0",
                                                                        t("label:business_unit")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                    control: "input",
                                                                    type: "text",
                                                                    name: "offer.business_unit",
                                                                    formik: formik,
                                                                    className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Input),
                                                                    errorclass: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Error),
                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.business_unit")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableRowTwoGrid),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                    className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Label), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabel)),
                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "offer.employer"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "red-color",
                                                                            children: "*"
                                                                        }),
                                                                        "\xa0",
                                                                        t("label:employer")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                    control: "input",
                                                                    type: "text",
                                                                    name: "offer.employer",
                                                                    formik: formik,
                                                                    className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Input),
                                                                    errorclass: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Error),
                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.employer")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                    className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Label), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabel)),
                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "offer.personal_id_number"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "red-color",
                                                                            children: "*"
                                                                        }),
                                                                        "\xa0",
                                                                        t("label:personal_id_number")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                    control: "input",
                                                                    type: "text",
                                                                    name: "offer.personal_id_number",
                                                                    formik: formik,
                                                                    className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Input),
                                                                    errorclass: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Error),
                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.personal_id_number")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().AddOffer__Addbg),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                    className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().ClientCompany__Subheading), " mt32"),
                                                    children: t("candidates:job")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableRowTwoGrid),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                    className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Label), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabel)),
                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "offer.job_title"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "red-color",
                                                                            children: "*"
                                                                        }),
                                                                        "\xa0",
                                                                        t("label:job_title")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                    control: "input",
                                                                    type: "text",
                                                                    // placeholder="Phone Number"
                                                                    name: "offer.job_title",
                                                                    formik: formik,
                                                                    className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Input),
                                                                    errorclass: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Error),
                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.job_title")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Remotegrid),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                        className: "Dpflex ".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__CheckLabel), " Dpflex16 Mui__CustomCheckbox mb0"),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                                                inputProps: {
                                                                                    "aria-label": "Checkbox A"
                                                                                },
                                                                                onChange: function(event) {
                                                                                    return handleIsRemote(event, formik);
                                                                                },
                                                                                checked: formik.values.offer.remote,
                                                                                name: "offer.remote",
                                                                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .DefaultCheckbox */ .v0, {}),
                                                                                checkedIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .CheckedCheckbox */ .bN, {})
                                                                            }),
                                                                            " ",
                                                                            t("jobs:details:input:remote")
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_places_autocomplete__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                                                                    value: formik.values.offer.location_attributes.full_address,
                                                                    onChange: function() {
                                                                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(value) {
                                                                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                                                                                switch(_state.label){
                                                                                    case 0:
                                                                                        return [
                                                                                            4,
                                                                                            formik.setFieldValue("offer.location_attributes.full_address", value)
                                                                                        ];
                                                                                    case 1:
                                                                                        _state.sent();
                                                                                        return [
                                                                                            2
                                                                                        ];
                                                                                }
                                                                            });
                                                                        });
                                                                        return function(value) {
                                                                            return _ref.apply(this, arguments);
                                                                        };
                                                                    }(),
                                                                    onSelect: function(address, suggestion) {
                                                                        formik.setFieldValue("offer.location_attributes.full_address", address);
                                                                    },
                                                                    shouldFetchSuggestions: shouldFetchSuggestions(formik),
                                                                    children: function(param) {
                                                                        var getInputProps = param.getInputProps, getSuggestionItemProps = param.getSuggestionItemProps, suggestions = param.suggestions, loading = param.loading;
                                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "autocomplete-root",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                                    className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Label), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabel)),
                                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "offer.location_attributes.full_address"),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            className: "red-color",
                                                                                            children: "*"
                                                                                        }),
                                                                                        "\xa0 ",
                                                                                        t("jobs:details:input:location")
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                                                                                    className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Input),
                                                                                    disabled: formik.values.offer.remote,
                                                                                    name: "offer.location_attributes.full_address",
                                                                                    placeholder: t("placeholder:eg:postcode"),
                                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.location_attributes.full_address")
                                                                                }, getInputProps({
                                                                                    disabled: formik.values.offer.remote
                                                                                }))),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                    className: "autocomplete-dropdown-container",
                                                                                    children: [
                                                                                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                            children: [
                                                                                                " ",
                                                                                                t("loading"),
                                                                                                " "
                                                                                            ]
                                                                                        }),
                                                                                        suggestions.map(function(suggestion) {
                                                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, getSuggestionItemProps(suggestion)), {
                                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                    children: suggestion.description
                                                                                                }, suggestion.id)
                                                                                            }), suggestion.placeId);
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        });
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .AutocompleteError */ .PG, {
                                                                    name: "offer.location_attributes.full_address",
                                                                    errorClass: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Error),
                                                                    formik: formik,
                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.location_attributes.full_address"),
                                                                    custom_error_90: "custom_error_90"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableRowTwoGrid),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Label),
                                                                style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "offer.employment_type"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "red-color",
                                                                        children: "*"
                                                                    }),
                                                                    "\xa0 ",
                                                                    t("jobs:details:employment_type:heading")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "wrapper",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
                                                                        type: "radio",
                                                                        name: "offer.employment_type",
                                                                        id: "option-1",
                                                                        value: "full_time"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
                                                                        type: "radio",
                                                                        name: "offer.employment_type",
                                                                        id: "option-2",
                                                                        value: "part_time"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
                                                                        type: "radio",
                                                                        name: "offer.employment_type",
                                                                        id: "option-3",
                                                                        value: "either"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                        htmlFor: "option-1",
                                                                        className: "option option-1 }",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            children: t("jobs:details:employment_type:full_time")
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                        htmlFor: "option-2",
                                                                        className: "option option-2 ",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            children: t("jobs:details:employment_type:part_time")
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                        htmlFor: "option-3",
                                                                        className: "option option-3",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            children: t("jobs:details:employment_type:either")
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .AutocompleteError */ .PG, {
                                                                name: "offer.employment_type",
                                                                errorClass: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Error),
                                                                formik: formik,
                                                                style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.employment_type")
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableRowTwoGrid),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Label),
                                                                style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "offer.contract_type"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "red-color",
                                                                        children: "*"
                                                                    }),
                                                                    "\xa0",
                                                                    t("jobs:details:contract_type:heading")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "wrapper2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
                                                                        type: "radio",
                                                                        name: "offer.contract_type",
                                                                        id: "option-4",
                                                                        value: "permanent"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
                                                                        type: "radio",
                                                                        name: "offer.contract_type",
                                                                        id: "option-5",
                                                                        value: "contract"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
                                                                        type: "radio",
                                                                        name: "offer.contract_type",
                                                                        id: "option-6",
                                                                        value: "temporary"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
                                                                        type: "radio",
                                                                        name: "offer.contract_type",
                                                                        id: "option-7",
                                                                        value: "internship"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                        htmlFor: "option-4",
                                                                        className: "option option-4",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            children: t("jobs:details:contract_type:permanent")
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                        htmlFor: "option-5",
                                                                        className: "option option-5",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            children: t("jobs:details:contract_type:contract")
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                        htmlFor: "option-6",
                                                                        className: "option option-6",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            children: t("jobs:details:contract_type:temporary")
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                        htmlFor: "option-7",
                                                                        className: "option option-7",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            children: t("jobs:details:contract_type:internship")
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .AutocompleteError */ .PG, {
                                                                name: "offer.contract_type",
                                                                errorClass: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Error),
                                                                formik: formik,
                                                                style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.contract_type")
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableRowThreeGrid),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol), " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                    className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Label), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabel), " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "offer.salary"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "red-color",
                                                                            children: "*"
                                                                        }),
                                                                        "\xa0",
                                                                        t("jobs:details:input:salary")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Input_currency), " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__Input_currency */ .x.Form__Input_currency),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__currency_symbol), " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__currency_symbol */ .x.Form__currency_symbol),
                                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.salary"),
                                                                            children: currencySymbol
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
                                                                            component: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .NumberField */ .Ki,
                                                                            type: "text",
                                                                            placeholder: "e.g. 30,000",
                                                                            name: "offer.salary",
                                                                            className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Input), " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__Input */ .x.Form__Input),
                                                                            disabled: false,
                                                                            formik: formik,
                                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.salary")
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .AutocompleteError */ .PG, {
                                                                    name: "offer.salary",
                                                                    errorclass: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Error),
                                                                    formik: formik,
                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.salary")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                    className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Label), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabel)),
                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "offer.salary_period"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "red-color",
                                                                            children: "*"
                                                                        }),
                                                                        "\xa0",
                                                                        t("jobs:details:input:salary_period")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                    control: "select",
                                                                    type: "select",
                                                                    name: "offer.salary_period",
                                                                    formik: formik,
                                                                    className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__CustomSelect),
                                                                    errorclass: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Error),
                                                                    options: salary_duration,
                                                                    default: formik.values.offer.salary_period,
                                                                    onChange: function(option) {
                                                                        return formik.setFieldValue("offer.salary_period", option === null || option === void 0 ? void 0 : option.value);
                                                                    },
                                                                    reference: selectDropdownRef,
                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.salary_period")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "CurrencyDropdown ".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                    className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Label), " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "offer.currency_id"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "red-color",
                                                                            children: "*"
                                                                        }),
                                                                        "\xa0",
                                                                        t("jobs:details:input:currency")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                    control: "select",
                                                                    type: "select",
                                                                    placeholder: "Select Currency",
                                                                    // infoPlaceholder   =   "Currency"
                                                                    isCurrency: true,
                                                                    currencySymbol: currencySymbol,
                                                                    name: "offer.currency_id",
                                                                    formik: formik,
                                                                    className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__CustomSelect */ .x.Form__CustomSelect, " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__CustomSelect)),
                                                                    errorclass: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__Error */ .x.Form__Error,
                                                                    options: currency,
                                                                    default: formik.values.offer.currency_id || currency[0].value,
                                                                    onChange: function(option) {
                                                                        setCurrencySymbol(option.symbol);
                                                                        formik.setFieldValue("offer.currency_id", option === null || option === void 0 ? void 0 : option.value);
                                                                    },
                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.currency_id")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "benefitstext",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: " ".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Label), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabel)),
                                                                children: t("jobs:details:input:benefits")
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                apiKey: "dxe0l6rdhdta2rzyfq2io208ncq1ay4l9wc2vyre3a53sdna",
                                                                control: "customEditor",
                                                                formik: formik,
                                                                textareaName: "offer.benefits",
                                                                onInit: function(evt, editor) {
                                                                    return editorRef.current = editor;
                                                                },
                                                                style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.benefits"),
                                                                value: formik.values.offer.benefits,
                                                                onEditorChange: function(value) {
                                                                    formik.setFieldValue("offer.benefits", value);
                                                                },
                                                                init: {
                                                                    height: 250,
                                                                    menubar: false,
                                                                    resize: false,
                                                                    // readOnly: !editable,
                                                                    plugins: [
                                                                        "advlist",
                                                                        "autolink",
                                                                        "lists",
                                                                        "link",
                                                                        "image",
                                                                        "charmap",
                                                                        "preview",
                                                                        "anchor",
                                                                        "searchreplace",
                                                                        "visualblocks",
                                                                        "code",
                                                                        "fullscreen",
                                                                        "insertdatetime",
                                                                        "media",
                                                                        "table",
                                                                        "help",
                                                                        "wordcount"
                                                                    ],
                                                                    toolbar: "undo redo | blocks | " + "bold italic backcolor | link | alignleft aligncenter " + "alignright alignjustify | bullist numlist outdent indent | " + "removeformat | help",
                                                                    content_style: "body { font-family:Gellix; font-size:14px }"
                                                                }
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableRowTwoGrid),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol)),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                    className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Label), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabel), " mb0"),
                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "offer.offer_approvals_attributes_0_approver_emails"),
                                                                    children: [
                                                                        t("jobs:details:input:approvers"),
                                                                        " "
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__InputSection), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__width), " noplaceholderspace  AutosuggestOpenUp"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                            control: "autosuggestInput",
                                                                            errorClass: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Error),
                                                                            formik: formik,
                                                                            getSuggestionValue: offerActions.getUserSuggestionValue,
                                                                            inputProps: {
                                                                                className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Input), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__textleft), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__InputFullWidth)),
                                                                                formik: formik,
                                                                                index: "approver_user_email",
                                                                                name: "offer.offer_approvals_attributes_0_approver_emails",
                                                                                onChange: function(value, param) {
                                                                                    var newValue = param.newValue, method = param.method;
                                                                                    setApproverEmail(newValue);
                                                                                    setApproverEmailError("");
                                                                                },
                                                                                selectedValues: (ref = formik.values.offer.offer_approvals_attributes[0]) === null || ref === void 0 ? void 0 : ref.approver_initials,
                                                                                closeIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_7__/* .Close */ .x8, {}),
                                                                                placeholder: t("placeholder:search:type_name"),
                                                                                style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.offer_approvals_attributes_0_approver_emails"),
                                                                                value: approverEmail,
                                                                                onKeyDown: function(event) {
                                                                                    return offerActions.handleKeyDown(event, formik, setApproverEmail, setApproverEmailError, t);
                                                                                },
                                                                                setApproverEmail: setApproverEmail,
                                                                                setApproverEmailError: setApproverEmailError,
                                                                                offerActions: offerActions,
                                                                                t: t
                                                                            },
                                                                            onSuggestionsClearRequested: function() {
                                                                                return offerActions.onUserSuggestionsClearRequested(setUsers);
                                                                            },
                                                                            onSuggestionsFetchRequested: function(hash) {
                                                                                offerActions.onUserSuggestionsFetchRequested(hash, setUsers);
                                                                            },
                                                                            onSuggestionSelected: function(event, param) {
                                                                                var suggestion = param.suggestion;
                                                                                if (suggestion.user_attributes.email.length > 0) {
                                                                                    setApproverEmail("");
                                                                                    offerActions.onUserSuggestionSelection(formik, formik.values.offer.offer_approvals_attributes[0].approver_emails, suggestion.user_attributes.email, formik.values.offer.offer_approvals_attributes[0].approver_initials, {
                                                                                        email: suggestion.user_attributes.email,
                                                                                        name_initials: suggestion.user_attributes.name_initials,
                                                                                        name: suggestion.user_attributes.name,
                                                                                        photo_url: suggestion.user_attributes.photo_url
                                                                                    });
                                                                                }
                                                                            },
                                                                            renderInputComponent: offerActions.renderInputComponent,
                                                                            renderSuggestion: offerActions.renderUserSuggestion,
                                                                            shouldRenderSuggestions: offerActions.shouldRenderSuggestions,
                                                                            suggestions: users,
                                                                            type: "text",
                                                                            autoComplete: "password"
                                                                        }),
                                                                        approverEmailError && approverEmailError.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__Error */ .x.Form__Error),
                                                                            children: approverEmailError
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        approvalOptions.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                    className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Label), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabel)),
                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "offer.offer_approvals_attributes.".concat(0, ".minimum_approval_required")),
                                                                    children: t("jobs:details:input:required_approval")
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__InputSection), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__width), " noplaceholderspace AutosuggestOpenUp"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                                        className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__CustomSelect), " ").concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().widthauto)),
                                                                        components: {
                                                                            Placeholder: Placeholder
                                                                        },
                                                                        control: "select",
                                                                        default: formik.values.offer.offer_approvals_attributes[0].minimum_approval_required,
                                                                        formik: formik,
                                                                        name: "offer.offer_approvals_attributes.".concat(0, ".minimum_approval_required"),
                                                                        onChange: function(option) {
                                                                            return option != null ? formik.setFieldValue("offer.offer_approvals_attributes.".concat(0, ".minimum_approval_required"), option.value) : "";
                                                                        },
                                                                        options: approvalOptions,
                                                                        style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "offer.offer_approvals_attributes.".concat(0, ".minimum_approval_required")),
                                                                        reference: approvalDropdownRef
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "space"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "".concat((_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().NewJob__SubmitSection), " ").concat(syncNowBtnClick && offerHash.stage_name == "Hired" ? (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().TwoButtonAlign) : (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().ButtonAlign)),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    buttonstyle: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().nobgbutton),
                                                    type: "button",
                                                    onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                                                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    return [
                                                                        4,
                                                                        setShowOffer(false)
                                                                    ];
                                                                case 1:
                                                                    _state.sent();
                                                                    (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_1__/* .onCancelClick */ .bp)();
                                                                    return [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    }),
                                                    children: [
                                                        " ",
                                                        t("button:cancel"),
                                                        "  "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    buttonstyle: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().secondarybtn),
                                                    type: "button",
                                                    onClick: function() {
                                                        return handleSubmitButtonState(formik, "save");
                                                    },
                                                    children: syncNowBtnClick && offerHash.stage_name == "Hired" ? "".concat(t("button:sync_with"), " HRM") : t("button:save")
                                                }),
                                                offerHash.stage_name != "Hired" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    buttonstyle: (_styles_pages_jobs_add_offer_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().primarybtn),
                                                    type: "button",
                                                    onClick: function() {
                                                        return handleSubmitButtonState(formik, "save&continue");
                                                    },
                                                    children: [
                                                        " ",
                                                        t("button:save_and_send"),
                                                        "  "
                                                    ]
                                                }) : ""
                                            ]
                                        })
                                    ]
                                });
                            }
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 65981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ career_setting; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/components/common-modal/modal.js + 2 modules
var modal = __webpack_require__(99005);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
;// CONCATENATED MODULE: ./src/actions/pages/clients/careers/career-setting.js





var CareerSettingAction = /*#__PURE__*/ function() {
    "use strict";
    function CareerSettingAction(setApiError) {
        (0,_class_call_check/* default */.Z)(this, CareerSettingAction);
        this.CareerSettingService = new CareerSettingService();
        this.setApiError = setApiError;
        this.customToastrAction = new common/* CustomToastrAction */.Y5();
    }
    (0,_create_class/* default */.Z)(CareerSettingAction, [
        {
            key: "resetCarrerPage",
            value: function resetCarrerPage(setFlagForRerender, setConfirmation) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.CareerSettingService.resetCareer()
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                if (result.request.status == common/* SUCCESS_REPONSE_CODE */.Us) {
                                    _this.customToastrAction.setNormalToastr("Carrer Page Reset Successfully.", "success");
                                // toastr.success('Carrer Page Reset Successfully.')
                                }
                                setConfirmation(false);
                                setFlagForRerender(Math.random() * 10000);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "copyToClipboard",
            value: function copyToClipboard(link, setClipBoardMessage) {
                var textField = document.createElement("textarea");
                textField.innerText = link;
                document.body.appendChild(textField);
                textField.select();
                document.execCommand("copy");
                textField.remove();
                setClipBoardMessage((0,common/* TRANSLATION */.TA)("career_site:settings:copied"));
            // document.querySelector('.ClipboardTooltip').lastChild.textContent = 'Copied';
            }
        },
        {
            key: "getIframeValue",
            value: function getIframeValue(link) {
                return "<iframe src='".concat(link, '?type=iframe\'  style="width:100%" height="500px" title="Heartpace job listing"></iframe>');
            }
        }
    ]);
    return CareerSettingAction;
}();

// EXTERNAL MODULE: ./src/actions/pages/clients/activities/index.js
var activities = __webpack_require__(41767);
// EXTERNAL MODULE: ./src/actions/common/close-modal.js
var close_modal = __webpack_require__(67280);
// EXTERNAL MODULE: ./src/components/skip-modal.js
var skip_modal = __webpack_require__(53594);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
;// CONCATENATED MODULE: ./src/services/pages/career/career-setting.js







var CareerSettingService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(CareerSettingService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(CareerSettingService);
    function CareerSettingService() {
        (0,_class_call_check/* default */.Z)(this, CareerSettingService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CareerSettingService, [
        {
            key: "resetCareer",
            value: function resetCareer() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.put */.od.put(common/* API.client.career_site.RESET_CAREER */.bl.client.career_site.RESET_CAREER, _tmp, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CareerSettingService;
}(common/* SendRequest */.Lt);

;// CONCATENATED MODULE: ./src/constants/pages/clients/careers/career-setting.js
var CAREER_SETTING = {
    texts: {
        modal: {
            message: "If you reset the career page all the changes will be lost and reset to default careers page. Are you sure to proceed?",
            button_1: "Cancel",
            button_2: "Reset"
        }
    }
};

// EXTERNAL MODULE: ./src/components/confirmation-modal.js
var confirmation_modal = __webpack_require__(72055);
// EXTERNAL MODULE: ./src/components/quick-add.js
var quick_add = __webpack_require__(35294);
// EXTERNAL MODULE: ./public/icons/clipboard.svg
var clipboard = __webpack_require__(11466);
// EXTERNAL MODULE: ./src/styles/pages/clients/privacy-policy/_index.module.scss
var _index_module = __webpack_require__(8001);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/actions/components/subSidebarListItemWithSubMenu.js
var subSidebarListItemWithSubMenu = __webpack_require__(97849);
// EXTERNAL MODULE: ./src/actions/pages/clients/careers/createJob.js
var createJob = __webpack_require__(73140);
;// CONCATENATED MODULE: ./src/imports-files/pages/career/career-setting.js
// ----------------- Common Library -----------------

// ----------------- Common Library -----------------
// ----------------- ACTIONS -----------------




// ----------------- ACTIONS -----------------
// ----------------- SERVICE -----------------

// ----------------- SERVICE -----------------










;// CONCATENATED MODULE: ./src/pages/clients/dashboard/career/career-setting.js




function CareerSetting(props) {
    (0,common/* clearSWRCache */.A$)("career_setting_data");
    var router = (0,common/* useRouter */.tv)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(null), 2), apiError = ref[0], setApiError = ref[1];
    var errorPages = new common/* ErrorPages */.dC();
    var ref1 = (0,common/* useTranslation */.$G)(), t = ref1.t, i18n = ref1.i18n;
    var careerSettingAction = new CareerSettingAction(setApiError);
    var activitiesAction = new activities/* ActivitiesAction */.W(setApiError);
    var ref2 = (0,common/* useSWR */.dH)("career_setting_data", function() {
        return (0,createJob/* getCustomizeCareerData */.wy)(router, setApiError);
    }), data = ref2.data, error = ref2.error;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(0), 2), flagForRerender = ref3[0], setFlagForRerender = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(t("career_site:settings:copy")), 2), clipboardMessage = ref4[0], setClipBoardMessage = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(t("career_site:settings:copy")), 2), careerClipboardMessage = ref5[0], setCareerClipBoardMessage = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(window.location.protocol + "//" + window.location.host + "/careers"), 2), link = ref6[0], setLink = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(window.location.protocol + "//" + window.location.host + "/job-openings"), 2), iFrameLink = ref7[0], setIframeLink = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), confirmation = ref8[0], setConfirmation = ref8[1];
    var step = router.query.step;
    var isQuickSetup = router.query.step && router.query.step == "careers_page" ? true : false;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), skipModal = ref9[0], setSkipModal = ref9[1];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), isPublished = ref10[0], setIsPublished = ref10[1];
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(true), 2), isLoading = ref11[0], setIsLoading = ref11[1];
    (0,common/* useEffect */.d4)(function() {
        if (data) {
            setIsPublished(data.career_page_published);
            setIsLoading(false);
            if (isQuickSetup) setTimeout(function() {
                new common/* SidebarAction */.Dv().subsidebarQuickSetupChangeIcon(data.sidebar_options.complete_steps, "careers_page");
            }, 750);
        }
    }, [
        data
    ]);
    if (errorPages.handleErrorCodes(apiError === null || apiError === void 0 ? void 0 : apiError.status)) {
        var renderPage = apiError ? errorPages.renderPage(apiError === null || apiError === void 0 ? void 0 : apiError.status, router) : null;
        return renderPage;
    }
    if (isLoading) return "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* motion.div */.EA.div, {
        initial: "pageInitial",
        animate: "pageAnimate",
        variants: common/* PAGE_ANIMATION_OPTIONS */.Mf,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "JobListPage TeamList DashboardPageContent ".concat((_index_module_default()).JobList, " ").concat((_index_module_default()).NewJob),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (_index_module_default()).NewJob__Container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (_index_module_default()).ClientCompany__TopSection2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (_index_module_default()).JobsApi__QuickAdd,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(quick_add/* default */.Z, {
                                    session: props.session
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (_index_module_default()).ClientCompany__FormSection,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                    className: " mb0 ".concat((_index_module_default()).ClientCompany__Heading),
                                    children: [
                                        t("career_site:settings:heading"),
                                        ": ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "".concat((_index_module_default()).ClientCompany__Company, " ").concat((_index_module_default()).LightBlueColor),
                                            children: [
                                                t("career_site:settings:heading_span"),
                                                " "
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat((_index_module_default()).PrivacyPolicy__PrivacySubhead),
                                    children: t("career_site:settings:subheading")
                                })
                            ]
                        }),
                        isPublished ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((_index_module_default()).CareerSetting, " ").concat((_index_module_default()).Form__TableCol),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    className: "".concat((_index_module_default()).Form__Label, " ").concat((_index_module_default()).Form__FloatingLabel),
                                    children: [
                                        " ",
                                        t("career_site:settings:link")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((_index_module_default()).CareerSetting__Inputbox, " ").concat((_index_module_default()).Form__Input),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            value: link,
                                            disabled: false
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Tooltip */.u, {
                                                className: "SimpleTooltip CareerSettingTooltip",
                                                content: careerClipboardMessage,
                                                background: "#00325A",
                                                radius: 20,
                                                padding: 8,
                                                placement: "top",
                                                fontSize: "12px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "CareerPageTooltip",
                                                    onClick: function() {
                                                        return careerSettingAction.copyToClipboard(link, setCareerClipBoardMessage);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(clipboard/* default */.Z, {
                                                        className: "clipboardsvg"
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Tooltip */.u, {
                            className: "CareerSettingsTooltip SimpleTooltip ml0",
                            content: t("career_site:settings:not_published"),
                            background: "#00325A",
                            radius: 20,
                            padding: 8,
                            placement: "top",
                            fontSize: "12px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((_index_module_default()).CareerSetting, " ").concat((_index_module_default()).Form__TableCol),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "".concat((_index_module_default()).Form__FloatingLabel),
                                        children: [
                                            " ",
                                            t("career_site:settings:link")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((_index_module_default()).CareerSetting__Inputbox, " ").concat((_index_module_default()).Form__Input, " ").concat(isPublished ? "" : (_index_module_default()).CareerSetting__Inputbox__disabled),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            value: "",
                                            disabled: true
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt30 ".concat((_index_module_default()).CareerSetting, " ").concat((_index_module_default()).Form__TableCol),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    className: "".concat((_index_module_default()).Form__Label, " ").concat((_index_module_default()).Form__FloatingLabel),
                                    children: [
                                        " ",
                                        t("career_site:settings:jobs_iframe")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((_index_module_default()).CareerSetting__Inputbox, " ").concat((_index_module_default()).Form__Input),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            value: careerSettingAction.getIframeValue(iFrameLink)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Tooltip */.u, {
                                                className: "SimpleTooltip",
                                                content: clipboardMessage,
                                                background: "#00325A",
                                                radius: 20,
                                                padding: 8,
                                                placement: "top",
                                                fontSize: "12px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "CareerPageTooltip",
                                                    onClick: function() {
                                                        return careerSettingAction.copyToClipboard(careerSettingAction.getIframeValue(iFrameLink), setClipBoardMessage);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(clipboard/* default */.Z, {
                                                        className: "clipboardsvg"
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (_index_module_default()).CareerSettingButton,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                buttonstyle: (_index_module_default()).primarybtn,
                                onClick: function() {
                                    return (0,subSidebarListItemWithSubMenu/* redirectToCareerPage */.GE)();
                                },
                                children: t("button:customise_careers_page")
                            })
                        }),
                        isQuickSetup && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (_index_module_default()).NewJob__SubmitSection,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                    buttonstyle: (_index_module_default()).secondarybtnborder,
                                    type: "button",
                                    onClick: function() {
                                        setSkipModal(true);
                                    },
                                    children: t("button:skip")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                    buttonstyle: (_index_module_default()).primarybtn,
                                    type: "button",
                                    onClick: function() {
                                        activitiesAction.nextOnboardingStep(step, router);
                                    },
                                    children: t("button:next")
                                })
                            ]
                        })
                    ]
                })
            }),
            skipModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(skip_modal/* SkipModal */.i, {
                setBtnPopup: setSkipModal,
                router: router
            }),
            confirmation && /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                type: "confirmation",
                message: t("modal:confirmation:delete:reset_career_page"),
                closeModal: function() {
                    (0,close_modal/* closeModalUsingState */.j)(false, setConfirmation);
                },
                btnAction: function() {
                    careerSettingAction.resetCarrerPage(setFlagForRerender, setConfirmation);
                },
                texts: {
                    button2_text: t("button:reset")
                }
            })
        ]
    }, router.route);
}
CareerSetting.layout = common/* ClientDashboard */.LD;
/* harmony default export */ var career_setting = (CareerSetting);


/***/ }),

/***/ 78403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62286);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71198);



function CustomizeCareer(props) {
    var ref;
    var router = (0,_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .useRouter */ .tv)();
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(null), 2), apiError = ref1[0], setApiError = ref1[1];
    var errorPages = new _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .ErrorPages */ .dC();
    var activitiesAction = new _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .ActivitiesAction */ .W$(setApiError);
    var ref2 = (0,_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .useSWR */ .dH)("customize_career_data", function() {
        return (0,_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .getCustomizeCareerData */ .wy)(router, setApiError);
    }), data = ref2.data, error = ref2.error;
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_HEADING */ .Oi), 2), valueHeading = ref3[0], setValueHeading = ref3[1];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_SUBHEADING */ .uw), 2), valueSubheading = ref4[0], setValueSubheading = ref4[1];
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(true), 2), isLoading = ref5[0], setLoadingStatus = ref5[1];
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(""), 2), jobOptions = ref6[0], setJobOptions = ref6[1];
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(""), 2), locationOptions = ref7[0], setLocationOptions = ref7[1];
    var ref8 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(false), 2), editingHeading = ref8[0], setHeadingEditing = ref8[1];
    var ref9 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(false), 2), editingSubHeading = ref9[0], setSubHeadingEditing = ref9[1];
    var ref10 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)("/images/pages/career/careerbg.png"), 2), newbackgroundImage = ref10[0], setBackgroundImage = ref10[1];
    var ref11 = (0,_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)(), t = ref11.t, i18n = ref11.i18n;
    var step = router.query.step;
    var isQuickSetup = router.query.step && router.query.step == "careers_page" ? true : false;
    var ref12 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(false), 2), skipModal = ref12[0], setSkipModal = ref12[1];
    (0,_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .useEffect */ .d4)(function() {
        if (data) {
            var ref, ref1, ref2;
            (data === null || data === void 0 ? void 0 : (ref = data.career_page) === null || ref === void 0 ? void 0 : ref.heading) ? setValueHeading(data.career_page.heading) : "";
            (data === null || data === void 0 ? void 0 : (ref1 = data.career_page) === null || ref1 === void 0 ? void 0 : ref1.sub_heading) ? setValueSubheading(data.career_page.sub_heading) : "";
            newbackgroundImage.includes("blob:") ? "" : (data === null || data === void 0 ? void 0 : (ref2 = data.career_page) === null || ref2 === void 0 ? void 0 : ref2.bg_image_url) ? setBackgroundImage(data.career_page.bg_image_url) : "";
            setLoadingStatus(false);
            if (isQuickSetup) setTimeout(function() {
                new _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .SidebarAction */ .Dv().subsidebarQuickSetupChangeIcon(data.sidebar_options.complete_steps, "careers_page");
            }, 750);
        }
    }, [
        data
    ]);
    if (isLoading || error || errorPages.handleErrorCodes(apiError === null || apiError === void 0 ? void 0 : apiError.status)) {
        var renderPage = error || apiError ? errorPages.renderPage((error === null || error === void 0 ? void 0 : error.status) || (apiError === null || apiError === void 0 ? void 0 : apiError.status), router) : null;
        return renderPage;
    }
    if (isLoading) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "CustomizeCareer ".concat(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.CustomizeCareer__Container */ .k2.CustomizeCareer__Container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "Career_Background  ".concat(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.CustomizeCareer */ .k2.CustomizeCareer),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: newbackgroundImage,
                        alt: "back-image",
                        className: "background-image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.CustomizeCareer__Inner */ .k2.CustomizeCareer__Inner),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "".concat(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.CustomizeCareer__Background_Edit */ .k2.CustomizeCareer__Background_Edit),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                        htmlFor: "background-file-input",
                                        className: "background-edit-icon",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            alt: "edit-image",
                                            src: "/icons/edit.png",
                                            className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.CustomizeCareer__Background_Edit_Image */ .k2.CustomizeCareer__Background_Edit_Image
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        id: "background-file-input",
                                        accept: ".png, .jpg, .jpeg",
                                        type: "file",
                                        onChange: function(event) {
                                            return (0,_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .handleBackgroundOnChange */ .Qh)(event, setBackgroundImage);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.CustomizeCareer__logo */ .k2.CustomizeCareer__logo,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .EditImage */ .TW, {
                                    logo_url: (ref = data.career_page) === null || ref === void 0 ? void 0 : ref.logo_url
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.CustomizeCareer__Content */ .k2.CustomizeCareer__Content,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                        onClick: function() {
                                            return setHeadingEditing(function() {
                                                return !editingHeading;
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .EdiText */ .AE, {
                                                showButtonsOnHover: true,
                                                className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.CustomizeCareer__Heading */ .k2.CustomizeCareer__Heading,
                                                editing: editingHeading,
                                                editButtonClassName: "removeEdit",
                                                inputProps: {
                                                    maxLength: "40"
                                                },
                                                onSave: function(val) {
                                                    return (0,_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .updateHeader */ .EH)(val, setValueHeading, setHeadingEditing);
                                                },
                                                type: "text",
                                                value: valueHeading,
                                                submitOnEnter: true
                                            }),
                                            !editingHeading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                alt: "edit-image",
                                                src: "/icons/edit.png",
                                                className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.CustomizeCareer__Background_Edit_Image */ .k2.CustomizeCareer__Background_Edit_Image
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        onClick: function() {
                                            return setSubHeadingEditing(function() {
                                                return !editingSubHeading;
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .EdiText */ .AE, {
                                                showButtonsOnHover: true,
                                                className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.CustomizeCareer__Subheading */ .k2.CustomizeCareer__Subheading,
                                                editing: editingSubHeading,
                                                editButtonClassName: "removeEdit",
                                                inputProps: {
                                                    maxLength: "70"
                                                },
                                                onSave: function(val) {
                                                    return (0,_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .updateSubheader */ .oP)(val, setValueSubheading, setSubHeadingEditing);
                                                },
                                                type: "text",
                                                value: valueSubheading,
                                                submitOnEnter: true
                                            }),
                                            !editingSubHeading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                alt: "edit-image",
                                                src: "/icons/edit.png",
                                                className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.CustomizeCareer__Background_Edit_Image */ .k2.CustomizeCareer__Background_Edit_Image
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job */ .k2.Job,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__Inner */ .k2.Job__Inner,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                            className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__Heading */ .k2.Job__Heading,
                            children: [
                                t("page:clients:customize-career:texts:title"),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__Company */ .k2.Job__Company,
                                    children: " 88"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__SearchContainer */ .k2.Job__SearchContainer,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.DT */ .k2.DT,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "".concat(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__SearchInput */ .k2.Job__SearchInput),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "text",
                                                placeholder: "e.g. UI Designer",
                                                className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__Input */ .k2.Job__Input,
                                                name: "search"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "".concat(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__Searchbtn */ .k2.Job__Searchbtn),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                buttonstyle: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.jobsrchbtn */ .ZJ.jobsrchbtn,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: "/icons/search.png",
                                                    alt: "",
                                                    className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.pd11 */ .k2.pd11
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__SelectJob */ .k2.Job__SelectJob,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .Formik */ .J9, {
                                children: function(formik) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
                                        className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form */ .k2.Form,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Table */ .k2.Form__Table,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableRowflex */ .k2.Form__TableRowflex,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "".concat(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableColm */ .k2.Form__TableColm, " tablecol80"),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label,
                                                                children: [
                                                                    "  ",
                                                                    t("page:clients:customize-career:texts:locations"),
                                                                    " "
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .Select */ .Ph, {
                                                                className: "".concat(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__CustomSelect */ .k2.Form__CustomSelect, " ").concat(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.widthauto */ .k2.widthauto),
                                                                options: locationOptions.options
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "".concat(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableColm */ .k2.Form__TableColm, " tablecol80"),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label,
                                                                children: [
                                                                    "  ",
                                                                    t("page:clients:customize-career:texts:job_type"),
                                                                    " "
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .Select */ .Ph, {
                                                                className: "".concat(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__CustomSelect */ .k2.Form__CustomSelect, " ").concat(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.widthauto */ .k2.widthauto, " "),
                                                                options: jobOptions.options
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "".concat(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableColm */ .k2.Form__TableColm, " ").concat(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.padt40 */ .k2.padt40, " tablecol47 alignright mr0"),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .Checkbox */ .XZ, {
                                                                value: "checkedA",
                                                                inputProps: {
                                                                    "aria-label": "Checkbox A"
                                                                }
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__RemoteLabel */ .k2.Job__RemoteLabel,
                                                                children: t("page:clients:customize-career:texts:remote_only")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    });
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__Display */ .k2.Job__Display,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__PostDay */ .k2.Job__PostDay,
                                    children: t("page:clients:customize-career:texts:posted_today")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__Title */ .k2.Job__Title,
                                    children: t("page:clients:customize-career:texts:post_first")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__Location */ .k2.Job__Location,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            children: [
                                                " ",
                                                t("page:clients:customize-career:texts:country")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            children: [
                                                " ",
                                                t("page:clients:customize-career:texts:remote")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            children: [
                                                " ",
                                                t("page:clients:customize-career:texts:permanent")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__Display */ .k2.Job__Display,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__PostDay */ .k2.Job__PostDay,
                                    children: t("page:clients:customize-career:texts:posted_today")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__Title */ .k2.Job__Title,
                                    children: t("page:clients:customize-career:texts:post_second")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__Location */ .k2.Job__Location,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            children: [
                                                " ",
                                                t("page:clients:customize-career:texts:country")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            children: [
                                                " ",
                                                t("page:clients:customize-career:texts:remote")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            children: [
                                                " ",
                                                t("page:clients:customize-career:texts:permanent")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__Display */ .k2.Job__Display,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__PostDay */ .k2.Job__PostDay,
                                    children: t("page:clients:customize-career:texts:posted_today")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__Title */ .k2.Job__Title,
                                    children: t("page:clients:customize-career:texts:post_third")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Job__Location */ .k2.Job__Location,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            children: [
                                                " ",
                                                t("page:clients:customize-career:texts:country")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            children: [
                                                " ",
                                                t("page:clients:customize-career:texts:remote")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            children: [
                                                " ",
                                                t("page:clients:customize-career:texts:permanent")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            skipModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .SkipModal */ ["if"], {
                setBtnPopup: setSkipModal,
                router: router
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.CareerFooterWithButton */ .k2.CareerFooterWithButton,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: t("page:clients:customize-career:texts:footer_text")
                    }),
                    isQuickSetup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "buttonolumngap",
                        style: {
                            display: "grid",
                            gridTemplateColumns: "175px 175px"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                buttonstyle: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.secondarybtnborder */ .ZJ.secondarybtnborder,
                                type: "button",
                                onClick: function() {
                                    setSkipModal(true);
                                },
                                children: "Skip"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                buttonstyle: _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.primarybtn */ .ZJ.primarybtn,
                                type: "button",
                                onClick: function() {
                                    activitiesAction.nextOnboardingStep(step, router);
                                },
                                children: "Next"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
CustomizeCareer.layout = _imports_files_pages_clients_careers_createJob__WEBPACK_IMPORTED_MODULE_1__/* .ClientDashboard */ .LD;
/* harmony default export */ __webpack_exports__["default"] = (CustomizeCareer);


/***/ }),

/***/ 71944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CompanyIntegrations": function() { return /* binding */ CompanyIntegrations; },
  "default": function() { return /* binding */ company_integrations; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(18186);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4012);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(34817);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/activities/client-integrations.js + 3 modules
var client_integrations = __webpack_require__(7485);
// EXTERNAL MODULE: ./src/components/quick-add.js
var quick_add = __webpack_require__(35294);
// EXTERNAL MODULE: ./src/imports-files/components/model/custom-company-integration-modal.js + 3 modules
var custom_company_integration_modal = __webpack_require__(62641);
// EXTERNAL MODULE: ./src/imports-files/components/review-email.js + 1 modules
var review_email = __webpack_require__(3623);
// EXTERNAL MODULE: ./src/components/common-modal/modal.js + 2 modules
var modal = __webpack_require__(99005);
;// CONCATENATED MODULE: ./src/components/modals/custom-company-integration-modal.js






function CustomCompanyIntegrationModal(props) {
    var t = (0,custom_company_integration_modal/* useTranslation */.$G)().t;
    var router = (0,custom_company_integration_modal/* useRouter */.tv)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,custom_company_integration_modal/* useState */.eJ)([
        props.categories
    ]), 2), categoryList = ref[0], setCategoryList = ref[1];
    var formRef = (0,custom_company_integration_modal/* useRef */.sO)(null);
    var custom_company_integration_modal_action = new custom_company_integration_modal/* CustomCompanyIntegrationModalAction */.j5(props.setModal, props.setCustomEnableItems, props.setFlagForRerender, props.setApiError, formRef);
    var operation_type = props.data ? "Edit" : "Create";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        type: "form",
        heading: t("modal:form:add_integration"),
        closeModal: function() {
            custom_company_integration_modal_action.resetForm(formRef);
            props.setModal(false);
        },
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_company_integration_modal/* Formik */.J9, {
            enableReinitialize: true,
            initialValues: custom_company_integration_modal_action.setInitialValues(props.data, operation_type),
            validationSchema: (0,custom_company_integration_modal/* customCompnayIntegrationValidation */.IR)(),
            innerRef: formRef,
            onSubmit: function(values) {
                custom_company_integration_modal_action.submitForm(values, operation_type);
            },
            children: function(formik) {
                var ref, ref1;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(custom_company_integration_modal/* Form */.l0, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat(custom_company_integration_modal/* FormStyle.Form__TableCol */.x.Form__TableCol),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    className: "".concat(custom_company_integration_modal/* FormStyle.Form__FloatingLabel */.x.Form__FloatingLabel),
                                    style: (0,custom_company_integration_modal/* InputText */.oH)(formik, "custom_integration.domain"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "red-color",
                                            children: "*"
                                        }),
                                        "\xa0",
                                        t("label:domain")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_company_integration_modal/* FormikControl */.gt, {
                                    control: "input",
                                    name: "custom_integration.domain",
                                    className: "".concat(custom_company_integration_modal/* ComponentStyle.Form__Input */.c2.Form__Input, " ").concat(custom_company_integration_modal/* FormStyle.Form__Input */.x.Form__Input),
                                    style: (0,custom_company_integration_modal/* InputError */.pd)(formik, "custom_integration.domain"),
                                    formik: formik,
                                    onKeyDown: function(event) {
                                        formik.setStatus("custom_integration.domain", "");
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat(custom_company_integration_modal/* FormStyle.Form__TableCol */.x.Form__TableCol),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    className: "".concat(custom_company_integration_modal/* FormStyle.Form__FloatingLabel */.x.Form__FloatingLabel),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "red-color",
                                            children: "*"
                                        }),
                                        "\xa0",
                                        t("label:name")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_company_integration_modal/* FormikControl */.gt, {
                                    control: "input",
                                    name: "custom_integration.name",
                                    className: "".concat(custom_company_integration_modal/* ComponentStyle.Form__Input */.c2.Form__Input, " ").concat(custom_company_integration_modal/* FormStyle.Form__Input */.x.Form__Input),
                                    style: (0,custom_company_integration_modal/* InputError */.pd)(formik, "custom_integration.name"),
                                    formik: formik
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat(review_email/* FormModalStyle.Modal__Container__ContentSection__Block */.w2.Modal__Container__ContentSection__Block, " ").concat(custom_company_integration_modal/* FormStyle.Form__TableCol */.x.Form__TableCol),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: "".concat(custom_company_integration_modal/* FormStyle.Form__FloatingLabel */.x.Form__FloatingLabel),
                                    children: t("label:category")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_company_integration_modal/* FormikControl */.gt, {
                                    className: "".concat(custom_company_integration_modal/* ComponentStyle.Form__Input */.c2.Form__Input, " ").concat(custom_company_integration_modal/* FormStyle.Form__Input */.x.Form__Input, " JobCustomSelect"),
                                    control: "select",
                                    name: "custom_integration.category",
                                    default: (formik === null || formik === void 0 ? void 0 : (ref = formik.values) === null || ref === void 0 ? void 0 : (ref1 = ref.custom_integration) === null || ref1 === void 0 ? void 0 : ref1.category) || "",
                                    onChange: function(option) {
                                        formik.setFieldValue("custom_integration.category", option.value);
                                    },
                                    options: custom_company_integration_modal_action.getSelectValue(categoryList[0])
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: review_email/* FormModalStyle.Modal__Container__ButtonSection */.w2.Modal__Container__ButtonSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_company_integration_modal/* Button */.zx, {
                                buttonstyle: custom_company_integration_modal/* ComponentStyle.primarybtn */.c2.primarybtn,
                                type: "submit",
                                children: t("button:save")
                            })
                        })
                    ]
                });
            }
        })
    });
}

// EXTERNAL MODULE: ../../shared/node_modules/react-tabs/esm/index.js + 10 modules
var esm = __webpack_require__(42419);
// EXTERNAL MODULE: ./src/actions/pages/clients/activities/client-integrations.js
var activities_client_integrations = __webpack_require__(79925);
// EXTERNAL MODULE: ./src/components/loading.js + 1 modules
var loading = __webpack_require__(85462);
// EXTERNAL MODULE: ./src/components/checkbox-filter-modal.js
var checkbox_filter_modal = __webpack_require__(52075);
// EXTERNAL MODULE: ./src/imports-files/components/common-modal/common-modal.js + 2 modules
var common_modal = __webpack_require__(66172);
;// CONCATENATED MODULE: ./src/components/input-modal.js









function InputModal(param) {
    var closeState = param.closeState, description = param.description, inputs = param.inputs, radios = param.radios, onSubmit = param.onSubmit, initialValues = param.initialValues, setFormData = param.setFormData, links = param.links, selectedItem = param.selectedItem, connectModal = param.connectModal, selectedRadio = param.selectedRadio, setSelectedRadio = param.setSelectedRadio;
    var ref = (0,_sliced_to_array/* default */.Z)((0,custom_company_integration_modal/* useState */.eJ)(false), 2), isAccountConnected = ref[0], setIsAccountConnected = ref[1];
    var handleRadioChange = function(value, formik) {
        setSelectedRadio(value);
        if (value === "false") {
            formik.setFieldValue("contract_id", "");
            formik.setFieldValue("company_id", "");
        } else {
            formik.setFieldValue("contract_id", "");
            formik.setFieldValue("company_id", "");
        }
    };
    var formRef = (0,custom_company_integration_modal/* useRef */.sO)(null);
    var ref1 = (0,custom_company_integration_modal/* useTranslation */.$G)(), t = ref1.t, i18n = ref1.i18n;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(custom_company_integration_modal/* InputModalStyle.Modalpopup */.Yh.Modalpopup),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(custom_company_integration_modal/* InputModalStyle.ModalInput */.Yh.ModalInput),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                type: "form",
                heading: t("modal:filter:authentication"),
                closeModal: function(event) {
                    closeState(false);
                },
                filterWidth: true,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(custom_company_integration_modal/* InputModalStyle.ModalInput__Inner */.Yh.ModalInput__Inner),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_company_integration_modal/* Formik */.J9, {
                        initialValues: initialValues,
                        validationSchema: (0,custom_company_integration_modal/* integrationValidationSchema */.vb)(isAccountConnected, connectModal, selectedRadio, t),
                        innerRef: formRef,
                        onSubmit: function(values) {
                            var jobdata = {};
                            if (connectModal === "indeed") {
                                jobdata.company_name = values.company_name;
                                if (values.campaign_tag) {
                                    jobdata.campaign_tag = values.campaign_tag;
                                }
                            } else if (connectModal === "linkedInJobs") {
                                jobdata.company_id = values.company_id;
                                if (selectedRadio === "false" && values.contract_id) {
                                    jobdata.contract_id = values.contract_id;
                                }
                            }
                            if (connectModal === "linkedInJobs") {
                                jobdata.company_id = values.company_id;
                                if (selectedRadio === "false" && values.contract_id) {
                                    jobdata.contract_id = values.contract_id;
                                }
                            }
                            if (connectModal === "totalJobs") {
                                jobdata.user_name = values.user_name;
                                if (values.password) {
                                    jobdata.password = values.password;
                                }
                            }
                            setFormData(jobdata);
                            onSubmit();
                        },
                        children: function(formik) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(custom_company_integration_modal/* Form */.l0, {
                                className: custom_company_integration_modal/* InputModalStyle.ModalInput__Form */.Yh.ModalInput__Form,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: custom_company_integration_modal/* InputModalStyle.ModalInput__Description */.Yh.ModalInput__Description,
                                        children: description
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: custom_company_integration_modal/* InputModalStyle.ModalInput__Form__Radio */.Yh.ModalInput__Form__Radio,
                                        children: radios === null || radios === void 0 ? void 0 : radios.map(function(radio, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "Dpflex WrapperRadioContainer WrapperRadiocheckmarkfont mb0",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_company_integration_modal/* Field */.gN, {
                                                                type: "radio",
                                                                name: "radio",
                                                                id: radio.id,
                                                                value: radio.defaultvalue,
                                                                checked: selectedRadio === radio.defaultvalue,
                                                                onChange: function() {
                                                                    return handleRadioChange(radio.defaultvalue, formik);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "WrapperRadiocheckmark"
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "ml5 mt-0",
                                                                children: radio.text
                                                            })
                                                        ]
                                                    })
                                                }, index)
                                            });
                                        })
                                    }),
                                    inputs === null || inputs === void 0 ? void 0 : inputs.map(function(input, index) {
                                        if (input.name === "contract_id" && selectedRadio !== "false") {
                                            return null;
                                        }
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat(custom_company_integration_modal/* InputModalStyle.ModalInput__ContentBlock */.Yh.ModalInput__ContentBlock),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat(custom_company_integration_modal/* InputModalStyle.ModalInput__ContentBlock__flexAlign */.Yh.ModalInput__ContentBlock__flexAlign),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                    children: [
                                                                        input.label,
                                                                        " ",
                                                                        ![
                                                                            "campaign_tag"
                                                                        ].includes(input.name) && " *",
                                                                        input.tooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: custom_company_integration_modal/* InputModalStyle.ModalInput__ContentBlock__Tooltip */.Yh.ModalInput__ContentBlock__Tooltip,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_company_integration_modal/* Tooltip */.u, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                                className: "SimpleTooltip",
                                                                                content: input.tooltip
                                                                            }, custom_company_integration_modal/* InputModalConstants.tooltip */.TJ.tooltip), {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: "tooltipwidthinterview270",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_company_integration_modal/* InfoIcon */.sz, {})
                                                                                })
                                                                            }))
                                                                        })
                                                                    ]
                                                                }),
                                                                [
                                                                    "contract_id"
                                                                ].includes(input.name) && selectedRadio === "false" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                        className: "\n                              ".concat(custom_company_integration_modal/* InputModalStyle.Modal__Container__ContentSection__Block__flexAlign__btn */.Yh.Modal__Container__ContentSection__Block__flexAlign__btn, " "),
                                                                        onClick: function() {
                                                                            var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                                                                                var errors;
                                                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                                                    switch(_state.label){
                                                                                        case 0:
                                                                                            e.preventDefault();
                                                                                            return [
                                                                                                4,
                                                                                                formik.validateForm()
                                                                                            ];
                                                                                        case 1:
                                                                                            errors = _state.sent();
                                                                                            (0,custom_company_integration_modal/* initialiseLiveAuthClient */.jL)(e, formik, selectedItem.idibu_data, setIsAccountConnected);
                                                                                            return [
                                                                                                2
                                                                                            ];
                                                                                    }
                                                                                });
                                                                            });
                                                                            return function(e) {
                                                                                return _ref.apply(this, arguments);
                                                                            };
                                                                        }(),
                                                                        children: [
                                                                            " ",
                                                                            t("modal:filter:connect_an_account")
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        input.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: custom_company_integration_modal/* InputModalStyle.ModalInput__ContentBlock__Description */.Yh.ModalInput__ContentBlock__Description,
                                                            children: {
                                                                obtainContractId: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: t("modal:input_modal:contract_id:description")
                                                                    })
                                                                }),
                                                                obtainCompanyId: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        t("modal:input_modal:CompanyId:description:company"),
                                                                        " ",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: custom_company_integration_modal/* InputModalStyle.ModalInput__Link */.Yh.ModalInput__Link,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                href: "https://www.linkedin.com/help/linkedin/answer/a415420",
                                                                                target: "_blank",
                                                                                rel: "noopener noreferrer",
                                                                                children: t("modal:input_modal:CompanyId:description:guide_here")
                                                                            })
                                                                        }),
                                                                        " ",
                                                                        t("modal:input_modal:CompanyId:description:instructions")
                                                                    ]
                                                                })
                                                            }[input.description] || input.description
                                                        })
                                                    ]
                                                }, index),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: custom_company_integration_modal/* InputModalStyle.ModalInput__Form__Table */.Yh.ModalInput__Form__Table,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_company_integration_modal/* FormikControl */.gt, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        control: "input",
                                                        formik: formik
                                                    }, input), {
                                                        disabled: input.name === "contract_id" && !isAccountConnected,
                                                        className: "width80 ".concat(custom_company_integration_modal/* InputModalStyle.Form__Input */.Yh.Form__Input),
                                                        errorClass: custom_company_integration_modal/* InputModalStyle.Form__error */.Yh.Form__error,
                                                        style: (0,custom_company_integration_modal/* InputError */.pd)(formik, input.name),
                                                        onBlur: function() {
                                                            return formik.setFieldTouched(input.name, true);
                                                        }
                                                    }))
                                                })
                                            ]
                                        });
                                    }),
                                    links === null || links === void 0 ? void 0 : links.map(function(link, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: custom_company_integration_modal/* InputModalStyle.ModalInput__Link */.Yh.ModalInput__Link,
                                            onClick: function(e) {
                                                if (link.onClick) {
                                                    link.onClick(e);
                                                } else if (link.initialiseLiveAuthClient) {
                                                    (0,custom_company_integration_modal/* initialiseLiveAuthClient */.jL)(e, formik);
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_company_integration_modal/* Link */.rU, {
                                                href: link.url,
                                                children: link.label
                                            })
                                        }, index);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat(common_modal/* FormModalStyle.Modal__Container__ButtonSection */.w2.Modal__Container__ButtonSection),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_company_integration_modal/* Button */.zx, {
                                                buttonstyle: custom_company_integration_modal/* InputModalStyle.secondarybtn */.Yh.secondarybtn,
                                                onClick: function() {
                                                    closeState(false);
                                                },
                                                children: t("button:cancel")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_company_integration_modal/* Button */.zx, {
                                                buttonstyle: custom_company_integration_modal/* InputModalStyle.primarybtn */.Yh.primarybtn,
                                                type: "submit",
                                                children: t("button:submit")
                                            })
                                        ]
                                    })
                                ]
                            });
                        }
                    })
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/clients/dashboard/company-integrations.js
















function CompanyIntegrations(props) {
    var router = (0,client_integrations/* useRouter */.tv)("");
    var ref = (0,_sliced_to_array/* default */.Z)((0,client_integrations/* useState */.eJ)(null), 2), apiError = ref[0], setApiError = ref[1];
    var activitiesAction = new client_integrations/* ActivitiesAction */.W$(setApiError);
    var errorPages = new client_integrations/* ErrorPages */.dC();
    var ref1 = (0,client_integrations/* useSWR */.dH)("client_integration_data", function() {
        return (0,client_integrations/* getClientIntegrationData */.BN)(router, setApiError);
    }, {
        revalidateOnFocus: false
    }), data = ref1.data, error = ref1.error;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,client_integrations/* useState */.eJ)([]), 2), enable_integrations_array = ref2[0], set_enable_integrations_array = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,client_integrations/* useState */.eJ)([]), 2), disable_integrations_array = ref3[0], set_disable_integrations_array = ref3[1];
    var ref4 = (0,client_integrations/* useTranslation */.$G)(), t = ref4.t, i18n = ref4.i18n;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,client_integrations/* useState */.eJ)(""), 2), enable_items = ref5[0], setEnableItems = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,client_integrations/* useState */.eJ)(""), 2), custom_enable_items = ref6[0], setCustomEnableItems = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,client_integrations/* useState */.eJ)(true), 2), isLoading = ref7[0], setLoadingStatus = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,client_integrations/* useState */.eJ)(""), 2), formData = ref8[0], setFormData = ref8[1];
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,client_integrations/* useState */.eJ)(true), 2), isEditable = ref9[0], setEditable = ref9[1];
    var step = router.query.step;
    var isQuickSetup = router.query.step && router.query.step == "company_integrations" ? true : false;
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,client_integrations/* useState */.eJ)(false), 2), skipModal = ref10[0], setSkipModal = ref10[1];
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,client_integrations/* useState */.eJ)(false), 2), customTabModal = ref11[0], setCustomTabModal = ref11[1];
    var customToastrAction = new client_integrations/* CustomToastrAction */.Y5();
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,client_integrations/* useState */.eJ)(props.session), 2), session = ref12[0], setSession = ref12[1];
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,client_integrations/* useState */.eJ)(""), 2), categoryList = ref13[0], setCategoryList = ref13[1];
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,client_integrations/* useState */.eJ)(0), 2), flagForRerender = ref14[0], setFlagForRerender = ref14[1];
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,client_integrations/* useState */.eJ)(null), 2), editIntegrationData = ref15[0], setEditIntegrationData = ref15[1];
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,client_integrations/* useState */.eJ)(false), 2), integrationFilterModal = ref16[0], setIntegrationFilterModal = ref16[1];
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,client_integrations/* useState */.eJ)(null), 2), connectModal = ref17[0], setConnectModal = ref17[1];
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,client_integrations/* useState */.eJ)(client_integrations/* CONSTANTS.linkedInJobsModal.radios.0.defaultvalue */.tl.linkedInJobsModal.radios[0].defaultvalue || ""), 2), selectedRadio = ref18[0], setSelectedRadio = ref18[1];
    var companyIntegrationAction = new client_integrations/* CompanyIntegrationAction */.Tk(router);
    var selectedItem = [];
    if (Array.isArray(enable_items) && enable_items.length > 0) {
        selectedItem = enable_items.find(function(item) {
            return item.slug === "linkedin-jobs";
        });
    }
    var linkedInJobsModal = (0,client_integrations/* getLinkedInJobsModal */.Mm)(t);
    var indeedModal = (0,client_integrations/* getindeedModal */.oq)(t);
    var totalJobsModal = (0,client_integrations/* getTotalJobsModal */.KX)(t);
    (0,client_integrations/* useEffect */.d4)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, enableData, disableData, ref2, _tmp, ref3, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!data) return [
                        3,
                        3
                    ];
                    if ((session === null || session === void 0 ? void 0 : session.role) == "Administrator") setEditable(false);
                    return [
                        4,
                        (0,client_integrations/* setIntegrationData */.RY)(data.enabled_integrations)
                    ];
                case 1:
                    enableData = _state.sent();
                    return [
                        4,
                        (0,client_integrations/* setDisabledIntegrationData */.zJ)(data.disabled_integrations)
                    ];
                case 2:
                    disableData = _state.sent();
                    set_disable_integrations_array(disableData);
                    setEnableItems(enableData);
                    setCategoryList(data.custom_integration_data.categories);
                    setCustomEnableItems(data.custom_integration_data.custom_integrations);
                    _tmp = {};
                    _tmp1 = {};
                    if (((ref = router.query) === null || ref === void 0 ? void 0 : ref.success) == "true") {
                        ;
                        customToastrAction.setNormalToastr(t("integrations:errors:connect_success"), "success");
                        if ((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.step) {
                            router.push((_tmp.pathname = client_integrations/* REDIRECT.client.quick_setup_page */.RQ.client.quick_setup_page, _tmp.query = {
                                step: "company_integrations"
                            }, _tmp));
                        } else {
                            window.history.replaceState(null, null, client_integrations/* REDIRECT.client.client_integrations */.RQ.client.client_integrations);
                        }
                        router.query = {};
                    } else if (((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.success) == "false") {
                        ;
                        customToastrAction.setNormalToastr(router.query.message != null ? router.query.message : t("integrations:errors:connect_error"), "warning");
                        // toastr.warning(t('page:clients:integrations:errors:connect_error')) 
                        if ((ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.step) {
                            router.push((_tmp1.pathname = client_integrations/* REDIRECT.client.quick_setup_page */.RQ.client.quick_setup_page, _tmp1.query = {
                                step: "company_integrations"
                            }, _tmp1));
                        } else {
                            window.history.replaceState(null, null, client_integrations/* REDIRECT.client.client_integrations */.RQ.client.client_integrations);
                        }
                        router.query = {};
                    }
                    if (isQuickSetup) setTimeout(function() {
                        new client_integrations/* SidebarAction */.Dv().subsidebarQuickSetupChangeIcon(data.integration_data.data.sidebar_options.complete_steps, "company_integrations");
                    }, 750);
                    setLoadingStatus(false);
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        data
    ]);
    if (isLoading || error || errorPages.handleErrorCodes(apiError === null || apiError === void 0 ? void 0 : apiError.status)) {
        var renderPage = error || apiError ? errorPages.renderPage((error === null || error === void 0 ? void 0 : error.status) || (apiError === null || apiError === void 0 ? void 0 : apiError.status), router) : /*#__PURE__*/ (0,jsx_runtime.jsx)(loading/* Loading */.g, {});
        return renderPage;
    }
    var initialValues = function(values) {
        return {
            company_name: (values === null || values === void 0 ? void 0 : values.company_name) || "",
            campaign_tag: (values === null || values === void 0 ? void 0 : values.campaign_tag) || ""
        };
    };
    var linkedInJobsInitialValues = function(values) {
        return {
            company_id: (values === null || values === void 0 ? void 0 : values.company_id) || "",
            contract_id: (values === null || values === void 0 ? void 0 : values.contract_id) || ""
        };
    };
    var totalJobsInitialValues = function(values) {
        return {
            user_name: (values === null || values === void 0 ? void 0 : values.user_name) || "",
            password: (values === null || values === void 0 ? void 0 : values.password) || ""
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "DashboardPageContent CompanyIntegration ".concat(client_integrations/* PageStyle.ClientCompany */.k2.ClientCompany),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* motion.div */.EA.div, {
                    initial: "pageInitial",
                    animate: "pageAnimate",
                    exit: "pageExit",
                    variants: client_integrations/* PAGE_ANIMATION_OPTIONS */.Mf,
                    transition: {
                        delay: 0.2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: client_integrations/* PageStyle.ClientCompany__Container */.k2.ClientCompany__Container,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: client_integrations/* PageStyle.ClientCompany__TopSection2 */.k2.ClientCompany__TopSection2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: client_integrations/* PageStyle.JobList__QuickAdd */.k2.JobList__QuickAdd,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(quick_add/* default */.Z, {
                                        session: session
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: client_integrations/* PageStyle.ClientCompany__FormSection */.k2.ClientCompany__FormSection,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "".concat(client_integrations/* PageStyle.ClientCompany__Heading */.k2.ClientCompany__Heading, " mb0"),
                                        children: router.query.type == "default" ? t("integrations:company:heading") : t("integrations:company:custom_heading")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: client_integrations/* PageStyle.ClientCompany__Subheading2 */.k2.ClientCompany__Subheading2,
                                            children: t("integrations:company:subheading")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Tabs */.mQ, {
                                defaultIndex: router.query.type == "custom" ? 1 : 0,
                                onSelect: function(index) {
                                    (0,activities_client_integrations/* selectClientIntegrationTab */.YF)(index, router, setEnableItems, setCustomEnableItems, setApiError, setCategoryList, setLoadingStatus);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat(client_integrations/* PageStyle.SearchFlex */.k2.SearchFlex),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "Tabsdesign",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* TabList */.td, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Tab */.OK, {
                                                            children: t("tabs:default")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Tab */.OK, {
                                                            children: t("tabs:custom")
                                                        })
                                                    ]
                                                })
                                            }),
                                            router.query.type !== "custom" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(client_integrations/* PageStyle.ClientCompany__Filter */.k2.ClientCompany__Filter),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* Button */.zx, {
                                                    buttonstyle: "".concat(client_integrations/* ButtonStyle.iconFilled */.ZJ.iconFilled, " ").concat(companyIntegrationAction.isFilterApplied(router) ? client_integrations/* ButtonStyle.iconFilledSolid */.ZJ.iconFilledSolid : client_integrations/* ButtonStyle.iconFilled */.ZJ.iconFilled),
                                                    onClick: function() {
                                                        setIntegrationFilterModal(!integrationFilterModal);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* Filter */.wn, {})
                                                })
                                            }),
                                            router.query.type == "custom" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "AddIntegrationSection2 mb20",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(client_integrations/* Button */.zx, {
                                                    buttonstyle: "".concat(client_integrations/* ButtonStyle.secondarybtn */.ZJ.secondarybtn, " buttonWithIcon"),
                                                    onClick: function() {
                                                        setEditIntegrationData("");
                                                        setCustomTabModal(true);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* Plus */.v3, {}),
                                                        t("button:add:integration")
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TabPanel */.x4, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: client_integrations/* Styles.IntegrationTable */.z0.IntegrationTable,
                                                    children: enable_items.length + disable_integrations_array.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableContainer */.xJ, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(client_integrations/* Table */.iA, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableHead */.ss, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(client_integrations/* TableRow */.SC, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                style: {
                                                                                    width: "13%"
                                                                                },
                                                                                children: t("datatable:integrations")
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                style: {
                                                                                    width: "14%"
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                style: {
                                                                                    width: "60%"
                                                                                },
                                                                                children: t("datatable:description")
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                style: {
                                                                                    width: "20%"
                                                                                },
                                                                                children: t("datatable:connect")
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(client_integrations/* TableBody */.RM, {
                                                                    children: [
                                                                        enable_items.map(function(row, index) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(client_integrations/* TableRow */.SC, {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                        children: row.name
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                        align: "right",
                                                                                        children: row.logo
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                        align: "right",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            className: client_integrations/* Styles.IntegrationTable__des */.z0.IntegrationTable__des,
                                                                                            children: row.description
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                        align: "right",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* Button */.zx, {
                                                                                            buttonstyle: (0,client_integrations/* getButtonClass */.Hx)(row, isEditable),
                                                                                            disabled: !isEditable,
                                                                                            onClick: function() {
                                                                                                var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                                                                                                    var result;
                                                                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                                                                        switch(_state.label){
                                                                                                            case 0:
                                                                                                                if (!row.is_linkable) return [
                                                                                                                    3,
                                                                                                                    2
                                                                                                                ];
                                                                                                                return [
                                                                                                                    4,
                                                                                                                    (0,client_integrations/* connectDisconnectIntegration */.CT)(e, router, row, setApiError, setFormData, setConnectModal)
                                                                                                                ];
                                                                                                            case 1:
                                                                                                                result = _state.sent();
                                                                                                                if (result && !result.connected) {
                                                                                                                    enable_items[row.index] = result;
                                                                                                                    setEnableItems((0,_to_consumable_array/* default */.Z)(enable_items));
                                                                                                                }
                                                                                                                return [
                                                                                                                    3,
                                                                                                                    3
                                                                                                                ];
                                                                                                            case 2:
                                                                                                                (0,client_integrations/* turnOnOffAccessibility */.z9)(e, row.slug, t, setApiError);
                                                                                                                _state.label = 3;
                                                                                                            case 3:
                                                                                                                return [
                                                                                                                    2
                                                                                                                ];
                                                                                                        }
                                                                                                    });
                                                                                                });
                                                                                                return function(e) {
                                                                                                    return _ref.apply(this, arguments);
                                                                                                };
                                                                                            }(),
                                                                                            children: (0,client_integrations/* getIntegrationsStatus */.zH)(row, t)
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }, "enable_items_".concat(index));
                                                                        }),
                                                                        disable_integrations_array.map(function(row, index) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(client_integrations/* TableRow */.SC, {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                        children: row.name
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                        align: "right",
                                                                                        children: row.logo
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                        align: "right",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            className: client_integrations/* Styles.IntegrationTable__des */.z0.IntegrationTable__des,
                                                                                            children: row.description
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                        align: "right",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* Button */.zx, {
                                                                                            buttonstyle: "".concat(client_integrations/* ButtonStyle.secondarybtn */.ZJ.secondarybtn, " ").concat(client_integrations/* ButtonStyle.GrayBgBtn */.ZJ.GrayBgBtn),
                                                                                            children: t("button:disabled")
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }, "disable_integration_".concat(index));
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "NoDataFound",
                                                        children: t("page:clients:my-integrations:texts:no_integrations")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TabPanel */.x4, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "CustomIntegrationTable",
                                                    children: (custom_enable_items === null || custom_enable_items === void 0 ? void 0 : custom_enable_items.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableContainer */.xJ, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(client_integrations/* Table */.iA, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableHead */.ss, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(client_integrations/* TableRow */.SC, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                style: {
                                                                                    width: "30%"
                                                                                },
                                                                                children: t("datatable:domain")
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                style: {
                                                                                    width: "30%"
                                                                                },
                                                                                children: t("datatable:name")
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                style: {
                                                                                    width: "30%"
                                                                                },
                                                                                children: t("datatable:category")
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                style: {
                                                                                    width: "10%"
                                                                                }
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableBody */.RM, {
                                                                    children: custom_enable_items.map(function(row, index) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(client_integrations/* TableRow */.SC, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                    style: {
                                                                                        width: "30%"
                                                                                    },
                                                                                    children: row.domain
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                    style: {
                                                                                        width: "30%"
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                        children: row.name
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                    style: {
                                                                                        width: "30%"
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                        children: row.category_label
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* TableCell */.pj, {
                                                                                    style: {
                                                                                        width: "10%"
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                        className: client_integrations/* Styles.IntegrationTable__Action */.z0.IntegrationTable__Action,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* Edit */.I8, {
                                                                                            onClick: function() {
                                                                                                setEditIntegrationData(row);
                                                                                                setCustomTabModal(true);
                                                                                            }
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }, "CustomIntegration_".concat(index));
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "NoDataFound",
                                                        children: t("integrations:company:no_integrations")
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            skipModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* SkipModal */["if"], {
                                setBtnPopup: setSkipModal,
                                router: router
                            }),
                            isQuickSetup && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(client_integrations/* Styles.SkipFinishButton */.z0.SkipFinishButton, " space"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "buttonolumngap ".concat(client_integrations/* Styles.Integration__SubmitSection */.z0.Integration__SubmitSection),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(client_integrations/* Button */.zx, {
                                            buttonstyle: client_integrations/* ButtonStyle.secondarybtnborder */.ZJ.secondarybtnborder,
                                            type: "button",
                                            onClick: function() {
                                                setSkipModal(true);
                                            },
                                            children: [
                                                " ",
                                                t("button:skip"),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(client_integrations/* Button */.zx, {
                                            buttonstyle: client_integrations/* ButtonStyle.primarybtn */.ZJ.primarybtn,
                                            type: "button",
                                            onClick: function() {
                                                activitiesAction.nextOnboardingStep(step, router);
                                            },
                                            children: [
                                                " ",
                                                t("button:next"),
                                                "  "
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(client_integrations/* CvLibrary */.Vk, {
                trigger: connectModal == "cvLibraryPaid",
                editIntegrationData: true,
                row: enable_items.filter(function(x) {
                    return x.name == "CV-Library Paid";
                })[0],
                setCvLibraryModal: setConnectModal,
                setApiError: setApiError
            }),
            customTabModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCompanyIntegrationModal, {
                setModal: setCustomTabModal,
                categories: categoryList,
                setCustomEnableItems: setCustomEnableItems,
                setFlagForRerender: setFlagForRerender,
                data: editIntegrationData,
                setApiError: setApiError
            }),
            integrationFilterModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_filter_modal/* CheckboxFilterModal */.o, {
                closeState: setIntegrationFilterModal,
                modalHeight: "height450",
                filters: data.integration_data.data.job_boards_listing,
                onSubmit: companyIntegrationAction.applyFilter,
                onSubmitParams: [
                    setEnableItems,
                    set_disable_integrations_array,
                    router, 
                ]
            }),
            connectModal == "indeed" && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                initialValues: initialValues(formData)
            }, indeedModal), {
                closeState: setConnectModal,
                setFormData: setFormData,
                connectModal: connectModal,
                onSubmit: function() {
                    setConnectModal("indeedConfirmation");
                }
            })),
            connectModal == "totalJobs" && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                initialValues: totalJobsInitialValues(formData)
            }, totalJobsModal), {
                closeState: setConnectModal,
                setFormData: setFormData,
                connectModal: connectModal,
                onSubmit: function() {
                    setConnectModal("totalJobsConfirmation");
                }
            })),
            connectModal == "linkedInJobs" && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                initialValues: linkedInJobsInitialValues(formData)
            }, linkedInJobsModal), {
                closeState: setConnectModal,
                setFormData: setFormData,
                selectedItem: selectedItem,
                connectModal: connectModal,
                selectedRadio: selectedRadio,
                setSelectedRadio: setSelectedRadio,
                onSubmit: function() {
                    setConnectModal("linkedInJobsconfirmation");
                }
            })),
            connectModal == "linkedInJobsconfirmation" && /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                type: "confirmation",
                message: t("modal:input_modal:confirm_modal:description"),
                closeModal: function() {
                    setConnectModal("linkedInJobs");
                },
                btnAction: function() {
                    (0,activities_client_integrations/* handleIntegrationSubmit */._k)(formData, enable_items.filter(function(x) {
                        return x.name === "LinkedIn Jobs";
                    })[0], router, setConnectModal, setApiError);
                },
                texts: {
                    button1_text: t("button:edit"),
                    button2_text: t("button:confirm")
                },
                heightClass: "height400 width600"
            }),
            connectModal == "indeedConfirmation" && /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                type: "confirmation",
                message: t("modal:input_modal:confirm_modal:description"),
                closeModal: function() {
                    setConnectModal("indeed");
                },
                btnAction: function() {
                    (0,activities_client_integrations/* handleIntegrationSubmit */._k)(formData, enable_items.filter(function(x) {
                        return x.name === "Indeed";
                    })[0], router, setConnectModal, setApiError);
                },
                texts: {
                    button1_text: t("button:edit"),
                    button2_text: t("button:confirm")
                },
                heightClass: "height400 width600"
            }),
            connectModal == "totalJobsConfirmation" && /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                type: "confirmation",
                message: t("modal:input_modal:confirm_modal:description"),
                closeModal: function() {
                    setConnectModal("totalJobs");
                },
                btnAction: function() {
                    (0,activities_client_integrations/* handleIntegrationSubmit */._k)(formData, enable_items.filter(function(x) {
                        return x.name === "Total Jobs";
                    })[0], router, setConnectModal, setApiError);
                },
                texts: {
                    button1_text: t("button:edit"),
                    button2_text: t("button:confirm")
                }
            })
        ]
    });
}
CompanyIntegrations.layout = client_integrations/* ClientDashboard */.LD;
/* harmony default export */ var company_integrations = (CompanyIntegrations);


/***/ }),

/***/ 27690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ privacy_policy; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/components/common-modal/modal.js + 2 modules
var modal = __webpack_require__(99005);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
;// CONCATENATED MODULE: ./src/constants/pages/clients/data-privacy/privacy-policy.js

var phoneRegex = /^\+?[\d\s]+$/;
var PRIVACY_POLICY = {
    texts: {
        heading: "Data & Privacy",
        label_1: "Last Edited",
        button_1: "Quick Add",
        button_2: "save",
        selector_label: "Please setup your Privacy Policy below in order to post jobs and receive candidate applications. You can choose to use your own privacy policy or get started with a template.",
        create_your_own: "Please be sure to review the following being added to your Privacy Policy as the terms of use of Candidly platform and nothing in your policy contradicts with the below.",
        own_confirmation: "By saving the privacy policy you acknowledge that you agree to add the mandatory privacy policy given by Candidly and your usage is in compliance with it.",
        template_confirmation: "Please make sure you have entered the following details correctly in the privacy policy: Company Name, Contact Details - Email Address, Postal Address, Telephone Number",
        privacy_policy: {
            para1: " We use Candidly, an online application provider and \n                                                                       applicant tracking system (ATS) for assisting with our \n                                                                       recruitment processes.  Candidly collect, use, store, and \n                                                                       share Aggregated Data such as statistical or demographic \n                                                                       data.  Aggregated Data could be derived from your personal \n                                                                       data but is not considered personal data in law as this data is \n                                                                       anonymised/ pseudonymised and will not directly or indirectly reveal \n                                                                       your identity.  For example, we may aggregate your Professional Data \n                                                                       to develop analytics with respect to a specific platform feature or \n                                                                       component. However, if we combine or connect Aggregated Data with your \n                                                                       personal data so that it can directly or indirectly identify you, we treat\n                                                                       the combined data as personal data which will be used in accordance with \n                                                                       this privacy policy.",
            para2: "Your data will be stored on Candidly’s AWS Servers \n                                                                       which are located in the UK. We have put in place appropriate security measures \n                                                                       to prevent your personal data from being accidentally lost, used, or accessed in \n                                                                       an unauthorized way, altered, or disclosed.  In addition, we limit access to your \n                                                                       personal data to those employees, agents, contractors, and other third parties who \n                                                                       have a business need to know.  They will only process your personal data in accordance \n                                                                       with our instructions and they are subject to a duty of confidentiality.",
            para3: "Candidly have also put in place procedures to deal with any suspected personal data breach and will \n                                                                       notify you and any applicable regulator of a breach where we are legally required to \n                                                                       do so"
        },
        terms: {
            para1: "Please note that you should review the template to ensure it is in compliance with your own company data protection policies and how you work with any potential candidates.",
            para2: "This template is provided in good faith; however we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability or completeness for use on your site.",
            para3: "Under no circumstance shall we have any liability to you for any loss or damage of any kind incurred because of the use of this template or reliance on any information provided.  Your use of this template or your reliance on any information on the site is solely at your own risk. \n                                             "
        },
        next: "Next",
        skip: "Skip"
    }
};
var set_privacy_initial_form_data = function() {
    return {
        company_name: "",
        account_owner: "",
        contact_number: "",
        email: "",
        address: ""
    };
};
function privacyPolicyValidation() {
    var privacyPolicyFormDataValidation = {
        company_name: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")),
        account_owner: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")),
        contact_number: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).nullable().matches(phoneRegex, (0,common/* TRANSLATION */.TA)("errors:contact_no")).min(8, (0,common/* TRANSLATION */.TA)("errors:contact_short")).max(20, (0,common/* TRANSLATION */.TA)("errors:contact_long")),
        email: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")).email((0,common/* TRANSLATION */.TA)("errors:invalid_email")).nullable(),
        address: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required"))
    };
    var PRIVACY_POLICY_VALIDATION = common/* Yup.object */.sm.object(privacyPolicyFormDataValidation);
    return PRIVACY_POLICY_VALIDATION;
}
function validationSchema() {
    var validation = {
        description: common/* Yup.string */.sm.string().required((0,common/* TRANSLATION */.TA)("errors:required")),
        candidly_template: common/* Yup.boolean */.sm.boolean()
    };
    var VALIDATION_SCHEMA = common/* Yup.object */.sm.object(validation);
    return VALIDATION_SCHEMA;
}

// EXTERNAL MODULE: ./src/components/skip-modal.js
var skip_modal = __webpack_require__(53594);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
;// CONCATENATED MODULE: ./src/actions/pages/clients/data-privacy/privacy-policy.js





var PrivacyPolicyAction = /*#__PURE__*/ function() {
    "use strict";
    function PrivacyPolicyAction(setApiError) {
        (0,_class_call_check/* default */.Z)(this, PrivacyPolicyAction);
        this.privacyPolicyService = new PrivacyPolicyService();
        this.setApiError = setApiError;
        this.customToastrAction = new common/* CustomToastrAction */.Y5();
    }
    (0,_create_class/* default */.Z)(PrivacyPolicyAction, [
        {
            key: "getPrivacyPolicy",
            value: function getPrivacyPolicy(router) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var body, _tmp, result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                body = (_tmp.step = router.query.step, _tmp);
                                return [
                                    4,
                                    _this.privacyPolicyService.getPrivacyPolicy(body)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                return [
                                    2,
                                    result.data
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "submitData",
            value: function submitData(values, setIntitalData, router, quick_setup) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var body, result, next_step, url;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                body = values;
                                if (quick_setup) {
                                    body.quick_setup = quick_setup;
                                }
                                return [
                                    4,
                                    _this.privacyPolicyService.submitPolicy(body)
                                ];
                            case 1:
                                result = _state.sent();
                                _this.setApiError(result.request);
                                _this.customToastrAction.setNormalToastr(result.data.success || (0,common/* TRANSLATION */.TA)("toastr:policy_update"), "success");
                                if (result.data.next_step) {
                                    next_step = result.data.next_step;
                                    url = "".concat(common/* REDIRECT.client.quick_setup */.RQ.client.quick_setup).concat(next_step);
                                    next_step == "complete" ? router.push(common/* REDIRECT.client.activities */.RQ.client.activities) : router.push(url);
                                }
                                setIntitalData(result.data.policy);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "generatePolicyData",
            value: function generatePolicyData(values, setIntitalData, router, quick_setup, setPolicyDataForm, setPrivacyPolicyForm, formik) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var body, result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                body = values;
                                if (quick_setup) {
                                    body.quick_setup = quick_setup;
                                }
                                return [
                                    4,
                                    _this.privacyPolicyService.generatePolicy(body)
                                ];
                            case 1:
                                result = _state.sent();
                                // result.data.policy.terms_accepted = result.data.policy.terms_accepted_at ? true : false
                                return [
                                    4,
                                    setIntitalData(result.data.policy)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    setPolicyDataForm(false)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    setPrivacyPolicyForm(true)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onPrivacyPolicyChange",
            value: function onPrivacyPolicyChange(event, formik) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var value;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                value = event.target.value;
                                if (!(value == "true")) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    formik.setFieldValue("candidly_template", true)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("description", formik.values.policy_template)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                return [
                                    4,
                                    formik.setFieldValue("candidly_template", false)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("terms_accepted", false)
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    4,
                                    formik.setFieldValue("description", "")
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return PrivacyPolicyAction;
}();

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
;// CONCATENATED MODULE: ./src/services/pages/clients/data-privacy/privacy-policy.js







var PrivacyPolicyService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(PrivacyPolicyService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(PrivacyPolicyService);
    function PrivacyPolicyService() {
        (0,_class_call_check/* default */.Z)(this, PrivacyPolicyService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(PrivacyPolicyService, [
        {
            key: "getPrivacyPolicy",
            value: function getPrivacyPolicy(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.privacy_policy.SHOW */.bl.client.privacy_policy.SHOW;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "submitPolicy",
            value: function submitPolicy(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.privacy_policy.UPDATE */.bl.client.privacy_policy.UPDATE;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "generatePolicy",
            value: function generatePolicy(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.privacy_policy.GENERATE */.bl.client.privacy_policy.GENERATE;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return PrivacyPolicyService;
}(common/* SendRequest */.Lt);

// EXTERNAL MODULE: ../../shared/node_modules/@tinymce/tinymce-react/lib/es2015/main/ts/index.js + 5 modules
var ts = __webpack_require__(53160);
// EXTERNAL MODULE: ./src/components/confirmation-modal.js
var confirmation_modal = __webpack_require__(72055);
// EXTERNAL MODULE: ./src/actions/common/close-modal.js
var close_modal = __webpack_require__(67280);
// EXTERNAL MODULE: ./src/components/quick-add.js
var quick_add = __webpack_require__(35294);
// EXTERNAL MODULE: ./public/icons/plus.svg
var plus = __webpack_require__(65099);
// EXTERNAL MODULE: ./src/styles/pages/clients/privacy-policy/_index.module.scss
var _index_module = __webpack_require__(8001);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/actions/components/sidebar.js + 1 modules
var sidebar = __webpack_require__(39826);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/data-privacy/privacy-policy.js














;// CONCATENATED MODULE: ./src/pages/clients/dashboard/data-privacy/privacy-policy.js






function PrivacyPolicy(props) {
    var t = (0,common/* useTranslation */.$G)().t;
    var router = (0,common/* useRouter */.tv)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(null), 2), apiError = ref[0], setApiError = ref[1];
    var step = router.query.step;
    var isQuickSetup = router.query.step && router.query.step == "privacy_policy" ? true : false;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), skipModal = ref1[0], setSkipModal = ref1[1];
    var privacyPolicyAction = new PrivacyPolicyAction(setApiError);
    var errorPages = new common/* ErrorPages */.dC();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(true), 2), isLoading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,common/* useSWR */.dH)("privacy-policy", function() {
        return privacyPolicyAction.getPrivacyPolicy(router);
    }, {
        revalidateOnFocus: false
    }), data = ref3.data, error = ref3.error;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(), 2), intitalData = ref4[0], setIntitalData = ref4[1];
    var editorRef = (0,common/* useRef */.sO)(null);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), mandatoryOption = ref5[0], setMandatoryOption = ref5[1];
    var formRef = (0,common/* useRef */.sO)(null);
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(true), 2), policyDataForm = ref6[0], setPolicyDataForm = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), privacyPolicyForm = ref7[0], setPrivacyPolicyForm = ref7[1];
    var policyData = set_privacy_initial_form_data();
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), privacyPolicyPresent = ref8[0], setPrivacyPolicyPresent = ref8[1];
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), regenerateModal = ref9[0], setRegenerateModal = ref9[1];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), regeneratePolicy = ref10[0], setRegeneratepolicy = ref10[1];
    (0,common/* useEffect */.d4)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!data) return [
                        3,
                        2
                    ];
                    setPrivacyPolicyPresent(data.privacy_record_present);
                    if (data.privacy_record_present && !regeneratePolicy) {
                        setPrivacyPolicyForm(true);
                    }
                    // data.policy.terms_accepted = data.policy.terms_accepted_at ? true : false
                    data.policy.description = data.policy.description || "";
                    return [
                        4,
                        setIntitalData(data.policy)
                    ];
                case 1:
                    _state.sent();
                    setLoading(false);
                    if (isQuickSetup) setTimeout(function() {
                        var ref;
                        new sidebar/* SidebarAction */.D().subsidebarQuickSetupChangeIcon((ref = data.sidebar_options) === null || ref === void 0 ? void 0 : ref.complete_steps, "privacy_policy");
                    }, 750);
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        data
    ]);
    if (isLoading || error || errorPages.handleErrorCodes(apiError === null || apiError === void 0 ? void 0 : apiError.status)) {
        var renderPage = error || apiError ? errorPages.renderPage((error === null || error === void 0 ? void 0 : error.status) || (apiError === null || apiError === void 0 ? void 0 : apiError.status), router) : null;
        return renderPage;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* motion.div */.EA.div, {
        initial: "pageInitial",
        animate: "pageAnimate",
        variants: common/* PAGE_ANIMATION_OPTIONS */.Mf,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "Privcy DashboardPageContent DashboardPageContentRight ".concat((_index_module_default()).PrivacyPolicy, " ").concat((_index_module_default()).NewJob),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (_index_module_default()).NewJob__Container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(quick_add/* default */.Z, {
                            session: props.session
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (_index_module_default()).ClientCompany__FormSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: "mb0 ".concat((_index_module_default()).ClientCompany__Heading),
                                children: [
                                    t("data_and_privacy:heading"),
                                    ": ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "".concat((_index_module_default()).ClientCompany__Company, " ").concat((_index_module_default()).LightBlueColor),
                                        children: t("data_and_privacy:heading_span")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: "".concat((_index_module_default()).PrivacyPolicy__PrivacySubhead),
                            children: t("data_and_privacy:subheading")
                        }),
                        policyDataForm && !privacyPolicyPresent && /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Formik */.J9, {
                            initialValues: policyData,
                            innerRef: formRef,
                            validationSchema: privacyPolicyValidation(),
                            onSubmit: function(values, formik) {
                                privacyPolicyAction.generatePolicyData(values, setIntitalData, router, isQuickSetup, setPolicyDataForm, setPrivacyPolicyForm, formik);
                            },
                            children: function(formik) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Form */.l0, {
                                    className: "".concat((_index_module_default()).Form),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (_index_module_default()).Form__Table,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (_index_module_default()).Form__TableRow,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (_index_module_default()).Form__TableCol,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: "".concat((_index_module_default()).Form__Label, " ").concat((_index_module_default()).Form__FloatingLabel),
                                                            style: (0,common/* InputText */.oH)(formik, "company_name"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "red-color",
                                                                    children: "*"
                                                                }),
                                                                " ",
                                                                t("privacy_policy:company_name")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                            control: "input",
                                                            type: "text",
                                                            name: "company_name",
                                                            className: (_index_module_default()).Form__Input,
                                                            formik: formik,
                                                            errorClass: (_index_module_default()).Form__Error,
                                                            style: (0,common/* InputError */.pd)(formik, "company_name")
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (_index_module_default()).Form__TableRow,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (_index_module_default()).Form__TableCol,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                className: "".concat((_index_module_default()).Form__Label, " ").concat((_index_module_default()).Form__FloatingLabel),
                                                                style: (0,common/* InputText */.oH)(formik, "account_owner"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "red-color",
                                                                        children: "*"
                                                                    }),
                                                                    " ",
                                                                    t("privacy_policy:account_owner")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                control: "input",
                                                                type: "text",
                                                                name: "account_owner",
                                                                className: (_index_module_default()).Form__Input,
                                                                formik: formik,
                                                                errorClass: (_index_module_default()).Form__Error,
                                                                style: (0,common/* InputError */.pd)(formik, "account_owner")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (_index_module_default()).Form__TableCol,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                className: "".concat((_index_module_default()).Form__Label, " ").concat((_index_module_default()).Form__FloatingLabel),
                                                                style: (0,common/* InputText */.oH)(formik, "contact_number"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "red-color",
                                                                        children: "*"
                                                                    }),
                                                                    " ",
                                                                    t("privacy_policy:contact_number")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                control: "input",
                                                                type: "text",
                                                                name: "contact_number",
                                                                className: (_index_module_default()).Form__Input,
                                                                formik: formik,
                                                                errorClass: (_index_module_default()).Form__Error,
                                                                style: (0,common/* InputError */.pd)(formik, "contact_number")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (_index_module_default()).Form__TableRow,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (_index_module_default()).Form__TableCol,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                className: "".concat((_index_module_default()).Form__Label, " ").concat((_index_module_default()).Form__FloatingLabel),
                                                                style: (0,common/* InputText */.oH)(formik, "email"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "red-color",
                                                                        children: "*"
                                                                    }),
                                                                    " ",
                                                                    t("privacy_policy:email")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                control: "input",
                                                                type: "text",
                                                                name: "email",
                                                                className: (_index_module_default()).Form__Input,
                                                                formik: formik,
                                                                errorClass: (_index_module_default()).Form__Error,
                                                                style: (0,common/* InputError */.pd)(formik, "email")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (_index_module_default()).Form__TableCol,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                className: "".concat((_index_module_default()).Form__Label, " ").concat((_index_module_default()).Form__FloatingLabel),
                                                                style: (0,common/* InputText */.oH)(formik, "address"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "red-color",
                                                                        children: "*"
                                                                    }),
                                                                    " ",
                                                                    t("privacy_policy:address")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                control: "input",
                                                                type: "text",
                                                                name: "address",
                                                                className: (_index_module_default()).Form__Input,
                                                                formik: formik,
                                                                errorClass: (_index_module_default()).Form__Error,
                                                                style: (0,common/* InputError */.pd)(formik, "address")
                                                            })
                                                        ]
                                                    }),
                                                    skipModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(skip_modal/* SkipModal */.i, {
                                                        setBtnPopup: setSkipModal,
                                                        router: router
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "space"
                                                    }),
                                                    !isQuickSetup && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (_index_module_default()).NewJob__SubmitSection,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "space"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                                                buttonstyle: common/* ButtonStyle.primarybtn */.ZJ.primarybtn,
                                                                type: "button",
                                                                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    formik.validateForm()
                                                                                ];
                                                                            case 1:
                                                                                _state.sent();
                                                                                formRef.current.submitForm();
                                                                                return [
                                                                                    2
                                                                                ];
                                                                        }
                                                                    });
                                                                }),
                                                                children: t("privacy_policy:generate_policy")
                                                            })
                                                        ]
                                                    }),
                                                    isQuickSetup && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (_index_module_default()).NewJob__SubmitSection,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                                                buttonstyle: (_index_module_default()).secondarybtnborder,
                                                                type: "button",
                                                                onClick: function() {
                                                                    setSkipModal(true);
                                                                },
                                                                children: PRIVACY_POLICY.texts.skip
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                                                buttonstyle: (_index_module_default()).primarybtn,
                                                                type: "button",
                                                                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    formik.validateForm()
                                                                                ];
                                                                            case 1:
                                                                                _state.sent();
                                                                                formRef.current.submitForm();
                                                                                return [
                                                                                    2
                                                                                ];
                                                                        }
                                                                    });
                                                                }),
                                                                children: PRIVACY_POLICY.texts.next
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                });
                            }
                        }),
                        privacyPolicyForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Formik */.J9, {
                            initialValues: intitalData,
                            validationSchema: validationSchema(),
                            innerRef: formRef,
                            onSubmit: function(values) {
                                privacyPolicyAction.submitData(values, setIntitalData, router, isQuickSetup);
                            },
                            children: function(formik) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Form */.l0, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt30 ".concat((_index_module_default()).PrivacyPolicy),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (_index_module_default()).Form__TableRow,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                    apiKey: "dxe0l6rdhdta2rzyfq2io208ncq1ay4l9wc2vyre3a53sdna",
                                                    control: "customEditor",
                                                    formik: formik,
                                                    onInit: function(evt, editor) {
                                                        return editorRef.current = editor;
                                                    },
                                                    textareaName: "description",
                                                    identifierClass: "description",
                                                    style: (0,common/* InputError */.pd)(formik, "description"),
                                                    value: formik.values.description,
                                                    onEditorChange: function(value) {
                                                        formik.setFieldValue("description", value);
                                                    },
                                                    init: {
                                                        height: 400,
                                                        resize: false,
                                                        menubar: false,
                                                        plugins: [
                                                            "advlist",
                                                            "autolink",
                                                            "lists",
                                                            "link",
                                                            "image",
                                                            "charmap",
                                                            "preview",
                                                            "anchor",
                                                            "searchreplace",
                                                            "visualblocks",
                                                            "code",
                                                            "fullscreen",
                                                            "insertdatetime",
                                                            "media",
                                                            "table",
                                                            "help",
                                                            "wordcount"
                                                        ],
                                                        toolbar: "undo redo | blocks | " + "bold italic backcolor | link | alignleft aligncenter " + "alignright alignjustify | bullist numlist outdent indent | " + "removeformat | help",
                                                        content_style: "body { font-family:Gellix,Arial,sans-serif; font-size:14px; color: #00325A; }"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (_index_module_default()).ClientCompany__LastEdited,
                                                    children: [
                                                        t("data_and_privacy:edited_by"),
                                                        ": ",
                                                        intitalData.edited_by_name && intitalData.updated_at ? "".concat(intitalData.edited_by_name, ",  ").concat(intitalData.updated_at) : "-",
                                                        " "
                                                    ]
                                                })
                                            }),
                                            skipModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(skip_modal/* SkipModal */.i, {
                                                setBtnPopup: setSkipModal,
                                                router: router
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "space"
                                            }),
                                            !isQuickSetup && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (_index_module_default()).NewJob__SubmitSection,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                                        buttonstyle: common/* ButtonStyle.secondarybtnborder */.ZJ.secondarybtnborder,
                                                        type: "button",
                                                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                setRegenerateModal(true);
                                                                return [
                                                                    2
                                                                ];
                                                            });
                                                        }),
                                                        children: t("privacy_policy:regenerate_policy")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                                        buttonstyle: common/* ButtonStyle.primarybtn */.ZJ.primarybtn,
                                                        type: "button",
                                                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            formik.validateForm()
                                                                        ];
                                                                    case 1:
                                                                        _state.sent();
                                                                        formRef.current.submitForm();
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        // formRef.current.isValid ? setMandatoryOption(true) : formRef.current.submitForm()
                                                        }),
                                                        children: t("button:save")
                                                    })
                                                ]
                                            }),
                                            isQuickSetup && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((_index_module_default()).NewJob__SubmitSectionThreeBtn),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                                        buttonstyle: (_index_module_default()).secondarybtnborder,
                                                        type: "button",
                                                        onClick: function() {
                                                            setSkipModal(true);
                                                        },
                                                        children: t("button:skip")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                                        buttonstyle: common/* ButtonStyle.secondarybtnborder */.ZJ.secondarybtnborder,
                                                        type: "button",
                                                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                setRegenerateModal(true);
                                                                return [
                                                                    2
                                                                ];
                                                            });
                                                        }),
                                                        children: t("privacy_policy:regenerate_policy")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                                        buttonstyle: (_index_module_default()).primarybtn,
                                                        type: "button",
                                                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            formik.validateForm()
                                                                        ];
                                                                    case 1:
                                                                        _state.sent();
                                                                        formRef.current.submitForm();
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        // formRef.current.isValid ? setMandatoryOption(true) : formRef.current.submitForm()
                                                        }),
                                                        children: t("button:next")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                });
                            }
                        })
                    ]
                }),
                mandatoryOption && /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                    type: "confirmation",
                    message: formRef.current.values.candidly_template ? t("data_and_privacy:template_confirmation") : t("data_and_privacy:own_confirmation"),
                    closeModal: function() {
                        (0,close_modal/* closeModalUsingState */.j)(false, setMandatoryOption);
                    },
                    btnAction: function() {
                        setMandatoryOption(false);
                        formRef.current.submitForm();
                    },
                    texts: {
                        button1_text: t("button:cancel"),
                        button2_text: t("button:confirm")
                    }
                }),
                regenerateModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                    type: "confirmation",
                    ButtonWidth: true,
                    message: t("modal:privacy_policy_modal_message:regenerate_policy_message"),
                    closeModal: function() {
                        setRegenerateModal(false);
                    },
                    btnAction: function() {
                        setPrivacyPolicyPresent(false);
                        setRegeneratepolicy(true);
                        setPrivacyPolicyForm(false);
                        setPolicyDataForm(true);
                        setRegenerateModal(false);
                    },
                    texts: {
                        button1_text: t("modal:privacy_policy_modal_message:cancel_button_text"),
                        button2_text: t("modal:privacy_policy_modal_message:admin_button_text")
                    }
                })
            ]
        })
    }, router.route);
}
PrivacyPolicy.layout = common/* ClientDashboard */.LD;
/* harmony default export */ var privacy_policy = (PrivacyPolicy);


/***/ }),

/***/ 23028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AutomationModal": function() { return /* binding */ AutomationModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(38641);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(18186);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(4012);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(62286);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(34817);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(2443);
/* harmony import */ var _styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(72123);
/* harmony import */ var _styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _styles_components_modal_add_assessment_index_module_scss__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(55264);
/* harmony import */ var _styles_components_modal_add_assessment_index_module_scss__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_styles_components_modal_add_assessment_index_module_scss__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _components_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95662);
/* harmony import */ var react_datetime_css_react_datetime_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18202);
/* harmony import */ var react_datetime_css_react_datetime_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_datetime_css_react_datetime_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_simple_tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54392);
/* harmony import */ var public_icons_call2_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67536);
/* harmony import */ var public_icons_technical_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36414);
/* harmony import */ var public_icons_video_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15166);
/* harmony import */ var public_icons_user_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41739);
/* harmony import */ var public_icons_videoqa_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20226);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(28805);
/* harmony import */ var _styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(84215);
/* harmony import */ var _styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var react_autosuggest__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46921);
/* harmony import */ var react_autosuggest__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_autosuggest__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_places_autocomplete__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25538);
/* harmony import */ var _components_loading__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85462);
/* harmony import */ var public_icons_exclamation_svg__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(22461);
/* harmony import */ var public_new_icons_info_icon_svg__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86013);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(96047);
/* harmony import */ var _imports_files_pages_clients_recruitments_manage_assessment__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(78245);
/* harmony import */ var _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(51895);
/* harmony import */ var _imports_files_components_job_filters__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(29774);
/* harmony import */ var _imports_files_components_model_setup_video_qa__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(37521);
/* harmony import */ var src_layouts_ClientDashboard__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(71234);
/* harmony import */ var _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(47942);
/* harmony import */ var _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(64335);
/* harmony import */ var _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(66172);
/* harmony import */ var public_icons_thick_plus_svg__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(83238);




































function AutomationModal(props) {
    var interviewSwitchButton = function interviewSwitchButton(type) {
        switch(type){
            case _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.PHONE */ .BH.PHONE:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(public_icons_call2_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
            case _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.TECHTEST */ .BH.TECHTEST:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(public_icons_technical_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    className: "techIcon"
                });
            case _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.VIDEO */ .BH.VIDEO:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(public_icons_video_svg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {});
            case _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.FACE2FACE */ .BH.FACE2FACE:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(public_icons_user_svg__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: "faceIcon"
                });
            case _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.VIDEOQA */ .BH.VIDEOQA:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(public_icons_videoqa_svg__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    className: "videoQAIcon"
                });
            default:
                return "";
        }
    };
    var gridClass = function gridClass(current_interview_type) {
        return current_interview_type == _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.VIDEO */ .BH.VIDEO ? (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().SetupPopup__ContentGrid) : (_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__ContentGridPhone);
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .useTranslation */ .$G)(), t = ref9.t, i18n = ref9.i18n;
    var initialValues = props.currentStage;
    var currentStage = props.currentStage;
    var ref10 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .useState */ .eJ)(currentStage === null || currentStage === void 0 ? void 0 : currentStage.interview_type), 2), current_interview_type = ref10[0], setCurrentInterviewType = ref10[1];
    (ref = initialValues.job_meeting_details_attributes) === null || ref === void 0 ? void 0 : ref.map(function(x) {
        return x.interview_type = initialValues.interview_type;
    });
    initialValues.default_location = ((ref1 = initialValues.job_meeting_details_attributes[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.location_attributes) === null || ref2 === void 0 ? void 0 : ref2.full_address) || (currentStage === null || currentStage === void 0 ? void 0 : currentStage.default_location);
    initialValues.place_id = ((ref3 = initialValues.job_meeting_details_attributes[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.location_attributes) === null || ref4 === void 0 ? void 0 : ref4.place_id) || (currentStage === null || currentStage === void 0 ? void 0 : currentStage.place_id);
    var ref11 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .useState */ .eJ)([]), 2), tests = ref11[0], setTests = ref11[1];
    var techTestAction = new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .TechTestAction */ .Uy(setTests);
    var videoQaAction = new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .VideoQaAction */ .CS(setTests);
    if (currentStage.interview_type == _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.TECHTEST */ .BH.TECHTEST) initialValues = (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .setUpTechTest */ .rR)(initialValues, techTestAction, currentStage, t);
    if (currentStage.interview_type == _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.VIDEOQA */ .BH.VIDEOQA) initialValues = (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .setUpVideoQAMember */ .L5)(initialValues, currentStage);
    var Option = react_select__WEBPACK_IMPORTED_MODULE_27__.c.Option;
    var setBtnPopup = props.setBtnPopup;
    var setOnLoadValues = props.setOnLoadValues;
    var platforms = props.currentStage.platforms;
    var ref12 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .useState */ .eJ)(currentStage.job_meeting_details_attributes.length), 2), interviewStageCount = ref12[0], setInterviewStageCount = ref12[1];
    var ref13 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .useState */ .eJ)([]), 2), users = ref13[0], setUsers = ref13[1];
    var ref14 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .useState */ .eJ)(currentStage.job_meeting_details_attributes.map(function(x) {
        return x.duration;
    }).reduce(function(a, b) {
        a = parseInt(a) || 0;
        b = parseInt(b) || 0;
        return a + b;
    }, 0)), 2), totalDuration = ref14[0], setTotalDuration = ref14[1];
    var router = (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .useRouter */ .tv)();
    var ref15 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .useState */ .eJ)((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .initialStageValues */ .jv)(initialValues)), 2), stageEmail = ref15[0], setStageEmail = ref15[1];
    var editable = props.editable;
    var ref16 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .useState */ .eJ)(true), 2), isLoading = ref16[0], setLoading = ref16[1];
    var ref17 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .useState */ .eJ)(false), 2), isDisabled = ref17[0], setDisabled = ref17[1];
    var ref18 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .useState */ .eJ)((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .showHideButtonValue */ .HW)(initialValues)), 2), showHideButton = ref18[0], setShowHideButton = ref18[1];
    var interviewTypes = props.currentStage.interview_types;
    var ref19 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .useState */ .eJ)(false), 2), disabledAddMoreQuestion = ref19[0], setDisabledAddMoreQuestion = ref19[1];
    var ref20 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .useState */ .eJ)([]), 2), deleteQuestionList = ref20[0], setDeleteQuestionList = ref20[1];
    var ref21 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .useState */ .eJ)(0), 2), flagForRender = ref21[0], setFlagForRender = ref21[1];
    var addInterviewManualAction = new _imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .AddInterviewManualAction */ .kF(setFlagForRender, deleteQuestionList, setDeleteQuestionList, setDisabledAddMoreQuestion);
    var ref22 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .useState */ .eJ)(addInterviewManualAction.setLanguageList(props.currentStage.language_list)), 2), languageListing = ref22[0], setLanguageListing = ref22[1];
    var ref23 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .useState */ .eJ)(((ref5 = initialValues.job_test_detail_attributes) === null || ref5 === void 0 ? void 0 : ref5.test_name) ? initialValues.job_test_detail_attributes.test_name : ""), 2), techTest = ref23[0], setTechTest = ref23[1];
    var ref24 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .useState */ .eJ)({
        value: "",
        error: ""
    }), 2), techStageEmail = ref24[0], setTechStageEmail = ref24[1];
    var ref25 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .useState */ .eJ)({
        type: ((ref6 = initialValues.job_test_detail_attributes) === null || ref6 === void 0 ? void 0 : ref6.test_type) || "TestLibrary",
        test_id: ((ref7 = initialValues.job_test_detail_attributes) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.test_id) === null || ref8 === void 0 ? void 0 : ref8.toString()) || ""
    }), 2), validationData = ref25[0], setValidationData = ref25[1];
    var parentData = props.parentData, setParentData = props.setParentData, currentIndex = props.currentIndex;
    var ref26 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .useState */ .eJ)(""), 2), buttonState = ref26[0], setButtonState = ref26[1];
    var ref27 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .useState */ .eJ)("Upload a file"), 2), uploadFileText = ref27[0], setUploadFileText = ref27[1];
    var customToastrAction = new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .CustomToastrAction */ .Y5();
    var formRef = (0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .useRef */ .sO)(null);
    (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .useEffect */ .d4)(function() {
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_29__.__generator)(this, function(_state) {
                setLoading(false);
                return [
                    2
                ];
            });
        })();
    }, []);
    if (isLoading) {
        return "";
    }
    var IconOption = function(props) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Option, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)({}, props), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Selectimg),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/images/pages/automation/".concat(props.data.label.replace(" ", "_").toLowerCase(), ".png"),
                        style: {
                            marginRight: 12,
                            width: 20,
                            height: 20,
                            verticalAlign: "middle"
                        },
                        alt: props.data.label
                    }),
                    props.data.label
                ]
            })
        }));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.ModalOverlay */ .w2.ModalOverlay),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal */ .w2.Modal, " AutomationPopup AddInterview"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container */ .w2.Modal__Container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__Heading__Close */ .w2.Modal__Container__Heading__Close),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Heading */ .w2.Modal__Container__ContentSection__Heading, " mb0"),
                                children: "".concat((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .interviewTypeHeader */ .ev)(current_interview_type, t).header)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__CloseSection */ .w2.Modal__Container__CloseSection),
                                onClick: function() {
                                    return setBtnPopup(false);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .Close */ .x8, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection */ .w2.Modal__Container__ContentSection,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Description */ .w2.Modal__Container__ContentSection__Description,
                            children: "".concat((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .interviewTypeHeader */ .ev)(current_interview_type, t).subheader)
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .Formik */ .J9, {
                        initialValues: initialValues,
                        validationSchema: (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .validations */ .tV)(current_interview_type, validationData),
                        onSubmit: function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)(function(values, actions) {
                                var _tmp, errors;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_29__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (validationData.type == "Assessment" && validationData.test_id == "upload_new_test") {
                                                values.save_and_continue = buttonState == "save_and_continue" ? true : false;
                                            }
                                            if (!props.sendAutomation) return [
                                                3,
                                                1
                                            ];
                                            _tmp = {};
                                            (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .runAutomations */ .hh)((_tmp.setJobData = props.setJobData, _tmp.selectedCards = props.automationActions, _tmp.router = router, _tmp.job_id = props.jobData.id, _tmp.fromPopup = true, _tmp.values = values, _tmp.setBtnPopup = setBtnPopup, _tmp.setSendAutomation = props.setSendAutomation, _tmp.filterData = props.filterData, _tmp.reviewKey = props.reviewKey, _tmp.setDisabled = setDisabled, _tmp.deleteQuestionList = deleteQuestionList, _tmp.from = props.from, _tmp.setInitialData = props.setInitialData, _tmp));
                                            return [
                                                3,
                                                3
                                            ];
                                        case 1:
                                            return [
                                                4,
                                                (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .handleInterviewFormSubmit */ .K0)(values, router, currentStage.id, setBtnPopup, setOnLoadValues, props.from, props.jobData, props.setJobData, setDisabled, deleteQuestionList, t)
                                            ];
                                        case 2:
                                            errors = _state.sent();
                                            actions.setErrors(errors);
                                            _state.label = 3;
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(values, actions) {
                                return _ref.apply(this, arguments);
                            };
                        }(),
                        children: function(formik) {
                            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .Form */ .l0, {
                                style: {
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__FormContainer */ .w2.Modal__Container__ContentSection__FormContainer,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block__ToggleContainer */ .w2.Modal__Container__ContentSection__Block__ToggleContainer),
                                            children: [
                                                t("modal:input:automation"),
                                                ":",
                                                ((ref = formik.values.disabled_automation) === null || ref === void 0 ? void 0 : ref.is_disabled) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_simple_tooltip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                    content: (ref1 = formik.values.disabled_automation) === null || ref1 === void 0 ? void 0 : ref1.hover_text,
                                                    background: "#203040",
                                                    radius: 20,
                                                    padding: 8,
                                                    placement: "bottom",
                                                    fontSize: "12px",
                                                    className: "SimpleTooltip",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "tooltipwidthinterview140",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                            className: "automationswitch",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                    type: "checkbox",
                                                                    name: "automation",
                                                                    defaultChecked: formik.values.automation,
                                                                    disabled: (ref2 = formik.values.disabled_automation) === null || ref2 === void 0 ? void 0 : ref2.is_disabled,
                                                                    onChange: function(event) {
                                                                        formik.setFieldValue("automation", event.target.checked);
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "automationslider automationround ".concat((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .toggleDisabled */ .$h)(!((ref3 = formik.values.disabled_automation) === null || ref3 === void 0 ? void 0 : ref3.is_disabled)))
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                    className: "automationswitch",
                                                    style: {
                                                        marginBottom: 0
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                            type: "checkbox",
                                                            name: "automation",
                                                            defaultChecked: formik.values.automation,
                                                            onChange: function(event) {
                                                                formik.setFieldValue("automation", event.target.checked);
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "automationslider automationround"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                    className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block__Heading */ .w2.Modal__Container__ContentSection__Block__Heading),
                                                    children: [
                                                        t("jobs:stages:interview:type"),
                                                        currentStage.stage == _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .JOB_STAGES.INTERVIEW */ .eP.INTERVIEW ? "*" : ""
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block__IconContainer */ .w2.Modal__Container__ContentSection__Block__IconContainer),
                                                    children: interviewTypes.map(function(x, interviewIndex) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block__IconContainer__Icons */ .w2.Modal__Container__ContentSection__Block__IconContainer__Icons,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_simple_tooltip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                background: "#203040",
                                                                radius: 50,
                                                                placement: "bottom",
                                                                fontSize: "12px",
                                                                content: x.display_name,
                                                                padding: 12,
                                                                className: "SimpleTooltip",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                    className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Interview__IconsType), " tooltipwidthinterview100"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                            type: "radio",
                                                                            name: "interview_type_id",
                                                                            id: "icon".concat(interviewIndex),
                                                                            checked: formik.values.interview_type_id == x.id,
                                                                            onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)(function() {
                                                                                var old_interview_type, uniq_member_emails, uniq_member_initials, _tmp, videoqa, _tmp1;
                                                                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_29__.__generator)(this, function(_state) {
                                                                                    switch(_state.label){
                                                                                        case 0:
                                                                                            old_interview_type = formik.values.interview_type;
                                                                                            if (!(old_interview_type && currentStage.stage == _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .JOB_STAGES.SCREENING */ .eP.SCREENING && old_interview_type == x.name)) return [
                                                                                                3,
                                                                                                4
                                                                                            ];
                                                                                            if (!formik.values.automation) return [
                                                                                                3,
                                                                                                1
                                                                                            ];
                                                                                            customToastrAction.setNormalToastr("Please turn the automation off to deselect interview type.", "warning");
                                                                                            return [
                                                                                                3,
                                                                                                3
                                                                                            ];
                                                                                        case 1:
                                                                                            formik.setFieldValue("interview_type_id", null);
                                                                                            formik.setFieldValue("interview_type", null);
                                                                                            currentStage.interview_type = null;
                                                                                            return [
                                                                                                4,
                                                                                                setCurrentInterviewType(null)
                                                                                            ];
                                                                                        case 2:
                                                                                            _state.sent();
                                                                                            formik.values.job_meeting_details_attributes.map(function(x) {
                                                                                                x._destroy = true;
                                                                                                return x;
                                                                                            });
                                                                                            _state.label = 3;
                                                                                        case 3:
                                                                                            return [
                                                                                                3,
                                                                                                9
                                                                                            ];
                                                                                        case 4:
                                                                                            if (old_interview_type && old_interview_type == x.name) {
                                                                                                return [
                                                                                                    2
                                                                                                ];
                                                                                            }
                                                                                            formik.setFieldValue("interview_type_id", x.id);
                                                                                            formik.setFieldValue("interview_type", x.name);
                                                                                            currentStage.interview_type = x.name;
                                                                                            return [
                                                                                                4,
                                                                                                setCurrentInterviewType(x.name)
                                                                                            ];
                                                                                        case 5:
                                                                                            _state.sent();
                                                                                            uniq_member_emails = [];
                                                                                            uniq_member_initials = [];
                                                                                            formik.values.job_meeting_details_attributes.map(function(x) {
                                                                                                if (!x._destroy && x.member_emails.length > 0) {
                                                                                                    x.member_emails.map(function(member_email, member_email_index) {
                                                                                                        if (!uniq_member_emails.includes(member_email)) {
                                                                                                            uniq_member_emails.push(member_email);
                                                                                                            uniq_member_initials.push(x.member_initials[member_email_index]);
                                                                                                        }
                                                                                                        return member_email;
                                                                                                    });
                                                                                                }
                                                                                                x._destroy = true;
                                                                                                return x;
                                                                                            });
                                                                                            if (old_interview_type && old_interview_type == _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.TECHTEST */ .BH.TECHTEST) {
                                                                                                uniq_member_emails = formik.values.job_test_detail_attributes.member_emails;
                                                                                                uniq_member_initials = formik.values.job_test_detail_attributes.member_initials;
                                                                                            }
                                                                                            if (old_interview_type && old_interview_type == _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.VIDEOQA */ .BH.VIDEOQA) {
                                                                                                uniq_member_emails = formik.values.videoqa.member_emails;
                                                                                                uniq_member_initials = formik.values.videoqa.member_initials;
                                                                                            }
                                                                                            if ([
                                                                                                _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.PHONE */ .BH.PHONE,
                                                                                                _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.VIDEO */ .BH.VIDEO,
                                                                                                _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.FACE2FACE */ .BH.FACE2FACE
                                                                                            ].includes(x.name)) (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .onAutomationChange */ .mV)(formik, "add", undefined, currentStage, setStageEmail, setInterviewStageCount, setTotalDuration, setShowHideButton, uniq_member_emails, uniq_member_initials);
                                                                                            if (!(x.name == _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.TECHTEST */ .BH.TECHTEST)) return [
                                                                                                3,
                                                                                                8
                                                                                            ];
                                                                                            _tmp = {};
                                                                                            return [
                                                                                                4,
                                                                                                setValidationData((_tmp.type = "TestLibrary", _tmp.test_id = "", _tmp))
                                                                                            ];
                                                                                        case 6:
                                                                                            _state.sent();
                                                                                            return [
                                                                                                4,
                                                                                                formik.setFieldValue("job_test_detail_attributes", (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .defaultTestDetail */ .i9)(uniq_member_emails, uniq_member_initials))
                                                                                            ];
                                                                                        case 7:
                                                                                            _state.sent();
                                                                                            _state.label = 8;
                                                                                        case 8:
                                                                                            _tmp1 = {};
                                                                                            if (x.name == _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.VIDEOQA */ .BH.VIDEOQA) {
                                                                                                videoqa = (_tmp1.member_emails = uniq_member_emails, _tmp1.member_initials = uniq_member_initials, _tmp1);
                                                                                                formik.setFieldValue("videoqa", videoqa);
                                                                                            }
                                                                                            _state.label = 9;
                                                                                        case 9:
                                                                                            return [
                                                                                                2
                                                                                            ];
                                                                                    }
                                                                                });
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                            htmlFor: "icon".concat(interviewIndex),
                                                                            className: "labelcolor",
                                                                            children: interviewSwitchButton(x.name)
                                                                        })
                                                                    ]
                                                                })
                                                            }, x.name)
                                                        }, "interview_type_".concat(interviewIndex));
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .CustomAutocompleteError */ .Jz, {
                                                        name: "interview_type_id",
                                                        errorClass: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Error),
                                                        custom_class: "FieldError",
                                                        formik: formik,
                                                        style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "interview_type_id")
                                                    })
                                                })
                                            ]
                                        }),
                                        current_interview_type == _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.VIDEOQA */ .BH.VIDEOQA ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol), " mt30"),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                            className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block__Heading */ .w2.Modal__Container__ContentSection__Block__Heading, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel)),
                                                            style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputText */ .oH)(formik, "videoqa.member_emails"),
                                                            children: t("modal:input:members")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_autosuggest__WEBPACK_IMPORTED_MODULE_9___default()), {
                                                            suggestions: users,
                                                            onSuggestionsFetchRequested: function(param) {
                                                                var value = param.value;
                                                                return (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .onSuggestionsFetchRequested */ .oo)(value, currentStage, setUsers, router);
                                                            },
                                                            onSuggestionsClearRequested: function() {
                                                                return setUsers([]);
                                                            },
                                                            getSuggestionValue: function(suggestion) {
                                                                return "".concat(suggestion.user_attributes.email);
                                                            },
                                                            renderSuggestion: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .renderSuggestion */ .ox,
                                                            renderInputComponent: videoQaAction.renderMemberInputComponent,
                                                            shouldRenderSuggestions: videoQaAction.shouldRenderSuggestions,
                                                            onSuggestionSelected: function(event, param) {
                                                                var suggestion = param.suggestion;
                                                                if (suggestion.user_attributes.email.length > 0) {
                                                                    setTechStageEmail({
                                                                        value: ""
                                                                    });
                                                                    videoQaAction.onSuggestionSelection(formik, formik.values.videoqa.member_emails, suggestion.user_attributes.email, formik.values.videoqa.member_initials, {
                                                                        email: suggestion.user_attributes.email,
                                                                        name_initials: suggestion.user_attributes.name_initials,
                                                                        name: suggestion.user_attributes.name
                                                                    });
                                                                    formik.validateForm();
                                                                }
                                                            },
                                                            inputProps: {
                                                                className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Input), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__textleft), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__InputFullWidth)),
                                                                placeholder: t("placeholder:search:type_name"),
                                                                style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "videoqa.member_emails"),
                                                                value: techStageEmail.value,
                                                                disabled: !editable,
                                                                editable: editable,
                                                                formik: formik,
                                                                selectedValues: (ref4 = formik.values.videoqa) === null || ref4 === void 0 ? void 0 : ref4.member_initials,
                                                                closeIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .Close */ .x8, {}),
                                                                videoQaAction: videoQaAction,
                                                                add_button: true,
                                                                name: "videoqa.member_emails",
                                                                onChange: function(value, param) {
                                                                    var newValue = param.newValue, method = param.method;
                                                                    setTechStageEmail({
                                                                        value: newValue,
                                                                        error: ""
                                                                    });
                                                                },
                                                                setStageEmail: setTechStageEmail,
                                                                onKeyDown: function(event) {
                                                                    return videoQaAction.handleKeyDown(event, formik, setTechStageEmail);
                                                                }
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .CustomAutocompleteError */ .Jz, {
                                                            name: "videoqa.member_emails",
                                                            errorClass: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Error),
                                                            formik: formik,
                                                            style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "videoqa.member_emails")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Row), " mt30"),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__w50), " mb10"),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().InterviewType__SetupVideoQa2), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol)),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "".concat(gridClass(current_interview_type), " mb0"),
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                            className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel)),
                                                                            style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputText */ .oH)(formik, "language"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: "red-color",
                                                                                    children: "*"
                                                                                }),
                                                                                "\xa0",
                                                                                t("modal:input:language")
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Field)),
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .FormikControl */ .gt, {
                                                                            className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__CustomSelect), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().Form__CustomSelect)),
                                                                            control: "select",
                                                                            formik: formik,
                                                                            name: "language",
                                                                            options: languageListing,
                                                                            placeholder: t("placeholder:select:langugae"),
                                                                            style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "language"),
                                                                            default: "English",
                                                                            onChange: function(data) {
                                                                                formik.setFieldValue("language", data.value);
                                                                            }
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__w50)),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().InterviewType__SetupVideoQa2)),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "".concat(gridClass(current_interview_type), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel), " mb10"),
                                                                        style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "video_link"),
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                            children: t("label:intro_video")
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Field)),
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .FormikControl */ .gt, {
                                                                            className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Input), " thresholdmodl"),
                                                                            control: "input",
                                                                            type: "text",
                                                                            formik: formik,
                                                                            name: "video_link",
                                                                            placeholder: _imports_files_components_model_setup_video_qa__WEBPACK_IMPORTED_MODULE_18__/* .CONSTANTS.texts.placeholder_intro_video */ .tl.texts.placeholder_intro_video,
                                                                            style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "video_link")
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Row)),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__InterviewQuestion), " mt30"),
                                                        children: formik === null || formik === void 0 ? void 0 : (ref5 = formik.values) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.questions_attributes) === null || ref6 === void 0 ? void 0 : ref6.map(function(question, index) {
                                                            var _obj;
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().SetupPopup__QuestionSection), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__QuestionSection)),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                                                        className: "Dpflex JustifySpace",
                                                                        children: [
                                                                            " ",
                                                                            t("modal:input:interview_question"),
                                                                            " ",
                                                                            index + 1,
                                                                            formik.values.questions_attributes.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .Deleteicon */ .F_, {
                                                                                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__IconSvg */ .w2.Modal__Container__IconSvg),
                                                                                onClick: function() {
                                                                                    addInterviewManualAction.onDeleteClick(formik, index);
                                                                                }
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Question), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol), " mt30"),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "".concat(gridClass(current_interview_type), " mb0"),
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", (_obj = {
                                                                                    className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel)),
                                                                                    style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputText */ .oH)(formik, "questions_attributes.".concat(index, ".question"))
                                                                                }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(_obj, "style", (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputText */ .oH)(formik, "questions_attributes.".concat(index, ".question"))), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(_obj, "children", [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        className: "red-color",
                                                                                        children: "*"
                                                                                    }),
                                                                                    "\xa0",
                                                                                    t("modal:input:question")
                                                                                ]), _obj))
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Field)),
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .FormikControl */ .gt, {
                                                                                    className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Input), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().Form__Input), " input600"),
                                                                                    control: "input",
                                                                                    type: "text",
                                                                                    formik: formik,
                                                                                    placeholder: t("placeholder:question"),
                                                                                    name: "questions_attributes.".concat(index, ".question"),
                                                                                    custom_class: "FieldError",
                                                                                    style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "questions_attributes.".concat(index, ".question")),
                                                                                    onChange: function(data) {
                                                                                        formik.setFieldValue("questions_attributes.".concat(index, ".question"), data.target.value);
                                                                                        formik.status && formik.status["questions_attributes"] && formik.status["questions_attributes"][index] && formik.status["questions_attributes"][index]["question"] ? delete formik.status["questions_attributes"][index]["question"] : "";
                                                                                        formik.setStatus(formik.status);
                                                                                    }
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Description), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol), " mt30"),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "".concat(gridClass(current_interview_type), "  ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel), " mb10"),
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                                    children: t("modal:input:description")
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Field)),
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .FormikControl */ .gt, {
                                                                                    control: "customtextarea",
                                                                                    type: "text",
                                                                                    formik: formik,
                                                                                    className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Textarea), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().Form__Textarea), " input600"),
                                                                                    name: "questions_attributes.".concat(index, ".description"),
                                                                                    rows: "4",
                                                                                    style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "questions_attributes.".concat(index, ".description"))
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "Dpflexonly AlignBaseline mt20 ".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__TwoFields)),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Time), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol), " Dpflexonly AlignBaseline w100 mt20"),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                        className: "".concat(gridClass(current_interview_type), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel), " wauto mb10 mr0"),
                                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                                            style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)({}, (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputText */ .oH)(formik, "questions_attributes.".concat(index, ".answer_time"))), {
                                                                                                whiteSpace: "nowrap"
                                                                                            }),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                    className: "red-color",
                                                                                                    children: "*"
                                                                                                }),
                                                                                                " ",
                                                                                                t("modal:input:time_to_answer")
                                                                                            ]
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                        className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__FieldAuto), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__NoRightBorderRadius), "  w50"),
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                                className: "Dpflexonly",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .Field */ .gN, {
                                                                                                        component: addInterviewManualAction.NumberField,
                                                                                                        defaultValue: 30,
                                                                                                        type: "text",
                                                                                                        name: "questions_attributes.".concat(index, ".answer_time"),
                                                                                                        className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Input), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().Form__InputFocus), " width60 inputerrorheight"),
                                                                                                        formik: formik,
                                                                                                        format: "###",
                                                                                                        style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "questions_attributes.".concat(index, ".answer_time")),
                                                                                                        onValueChange: function(value) {
                                                                                                            formik.setFieldValue("questions_attributes.".concat(index, ".answer_time"), value.floatValue);
                                                                                                            formik.status && formik.status["questions_attributes"] && formik.status["questions_attributes"][index] && formik.status["questions_attributes"][index]["answer_time"] ? delete formik.status["questions_attributes"][index]["answer_time"] : "";
                                                                                                            formik.setStatus(formik.status);
                                                                                                        }
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                        className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Seconds), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__currency_symbol), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__currency_symbol__right)),
                                                                                                        style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "questions_attributes.".concat(index, ".answer_time")),
                                                                                                        children: t("modal:input:sec")
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .CustomAutocompleteError */ .Jz, {
                                                                                                name: "questions_attributes.".concat(index, ".answer_time"),
                                                                                                errorClass: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Error),
                                                                                                formik: formik,
                                                                                                custom_class: "FieldError",
                                                                                                style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "questions_attributes.".concat(index, ".answer_time"))
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Time), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol), " Dpflexonly AlignBaseline JustifyEnd wauto"),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                        className: "".concat(gridClass(current_interview_type), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel), " wauto mb10"),
                                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                                            className: "text-center",
                                                                                            style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputText */ .oH)(formik, "questions_attributes.".concat(index, ".attempts")),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                    className: "red-color",
                                                                                                    children: "*"
                                                                                                }),
                                                                                                " ",
                                                                                                t("modal:input:attempts:number"),
                                                                                                " \xa0",
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_simple_tooltip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                                                    content: t("modal:input:attempts:max"),
                                                                                                    background: "#203040",
                                                                                                    radius: 4,
                                                                                                    padding: 8,
                                                                                                    placement: "right",
                                                                                                    fontSize: "12px",
                                                                                                    className: "SimpleTooltip",
                                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                                        className: "tooltipwidthinterview140",
                                                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(public_icons_exclamation_svg__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                        className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__FieldAuto), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Attempts__Number), " Dpflexonly AlignBaseline w50"),
                                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .Field */ .gN, {
                                                                                                    component: addInterviewManualAction.NumberField,
                                                                                                    defaultValue: 2,
                                                                                                    type: "text",
                                                                                                    name: "questions_attributes.".concat(index, ".attempts"),
                                                                                                    className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Input), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().Form__InputFocus), " width100 inputerrorheight text-center"),
                                                                                                    formik: formik,
                                                                                                    format: "#",
                                                                                                    onValueChange: function(value) {
                                                                                                        formik.setFieldValue("questions_attributes.".concat(index, ".attempts"), value.floatValue);
                                                                                                        formik.status && formik.status["questions_attributes"] && formik.status["questions_attributes"][index] && formik.status["questions_attributes"][index]["attempts"] ? delete formik.status["questions_attributes"][index]["attempts"] : "";
                                                                                                        formik.setStatus(formik.status);
                                                                                                    },
                                                                                                    style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "questions_attributes.".concat(index, ".attempts"))
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .CustomAutocompleteError */ .Jz, {
                                                                                                    name: "questions_attributes.".concat(index, ".attempts"),
                                                                                                    errorClass: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Error),
                                                                                                    formik: formik,
                                                                                                    style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "questions_attributes.".concat(index, ".attempts"))
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }, "question_key_".concat(index));
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().SetupPopup__AddQuestion), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__AddQuestionButton), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().mt15)),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                        buttonstyle: "".concat((_styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_33___default().iconTextButton)),
                                                        type: "button",
                                                        disabled: disabledAddMoreQuestion,
                                                        onClick: function() {
                                                            return addInterviewManualAction.onAddClick(formik);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(public_icons_thick_plus_svg__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {}),
                                                            t("button:add:question")
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "mb30 mt40",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                            className: " ".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().SetupPopup__ContentBlock), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Customisation), " mt0"),
                                                            children: t("modal:automation:customisations")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "Dpflex",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().SetupPopup__ContentCustomisation), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__PracticeScreen), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().SetupPopup__AddInterviewCustomisation)),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "thresholdmodl ".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__SetupVideoQa3)),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                                                                className: "Dpflexonly",
                                                                                children: [
                                                                                    t("modal:input:practice_screen"),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Interview__BestMatchExclamation), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__PracticeExclamation)),
                                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_simple_tooltip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                                            content: t("agency:video:practice_question"),
                                                                                            background: "#203040",
                                                                                            radius: 20,
                                                                                            padding: 8,
                                                                                            placement: "right",
                                                                                            fontSize: "12px",
                                                                                            className: "SimpleTooltip",
                                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                                className: "tooltipwidthinterview200",
                                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(public_new_icons_info_icon_svg__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {})
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                                className: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().IntegrationTable__switch),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                                        type: "checkbox",
                                                                                        defaultChecked: formik.values.practise_screen,
                                                                                        onChange: function(event) {
                                                                                            formik.setFieldValue("practise_screen", event.target.checked);
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().IntegrationTable__slider), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().IntegrationTable__round), " automationslider automationround width44")
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().SetupPopup__ContentCustomisation), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().SetupPopup__PushTop), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().SetupPopup__SetupVideoQa4), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__SetupVideoQa4), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol)),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                            className: "Dpflexonly AlignBaseline ".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().mb15), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel), " mr10"),
                                                                            style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputText */ .oH)(formik, "expires"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: "red-color",
                                                                                    children: "*"
                                                                                }),
                                                                                "  ",
                                                                                t("modal:input:expires")
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__FieldAuto), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__NoRightBorderRadius), " w50"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                    className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__NoRightBorderRadius), " Dpflexonly"),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .Field */ .gN, {
                                                                                            component: addInterviewManualAction.NumberField,
                                                                                            type: "text",
                                                                                            name: "expires",
                                                                                            className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Input), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().Form__InputFocus), " thresholdmodl width70"),
                                                                                            formik: formik,
                                                                                            format: "###",
                                                                                            style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "expires"),
                                                                                            defaultValue: 2,
                                                                                            onValueChange: function(value) {
                                                                                                formik.setFieldValue("expires", value.floatValue);
                                                                                                formik.setStatus["expires"] = "";
                                                                                            }
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Seconds), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__currency_symbol), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__currency_symbol__right), " ml0"),
                                                                                            style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "expires"),
                                                                                            children: "days"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .CustomAutocompleteError */ .Jz, {
                                                                                    name: "expires",
                                                                                    errorClass: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Error),
                                                                                    formik: formik,
                                                                                    custom_class: "FieldError",
                                                                                    style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "expires")
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .FieldArray */ .F2, {
                                                    className: "",
                                                    name: "job_meeting_details_attributes",
                                                    render: function(arrayHelpers) {
                                                        return formik.values.job_meeting_details_attributes.map(function(item, index) {
                                                            var ref;
                                                            return !item._destroy && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                children: [
                                                                    current_interview_type == _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.PHONE */ .BH.PHONE && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol), " mt30"),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                                        className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block__Heading */ .w2.Modal__Container__ContentSection__Block__Heading, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel)),
                                                                                        style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputText */ .oH)(formik, "job_meeting_details_attributes.".concat(index, ".member_emails")),
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                className: "red-color",
                                                                                                children: "*"
                                                                                            }),
                                                                                            "\xa0",
                                                                                            t("modal:input:members")
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_autosuggest__WEBPACK_IMPORTED_MODULE_9___default()), {
                                                                                        suggestions: users,
                                                                                        onSuggestionsFetchRequested: function(param) {
                                                                                            var value = param.value;
                                                                                            return (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .onSuggestionsFetchRequested */ .oo)(value, currentStage, setUsers, router);
                                                                                        },
                                                                                        onSuggestionsClearRequested: function() {
                                                                                            return setUsers([]);
                                                                                        },
                                                                                        getSuggestionValue: function(suggestion) {
                                                                                            return "".concat(suggestion.user_attributes.email);
                                                                                        },
                                                                                        renderSuggestion: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .renderSuggestion */ .ox,
                                                                                        renderInputComponent: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .renderAutomationModalInputComponent */ .rw,
                                                                                        shouldRenderSuggestions: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .shouldRenderSuggestions */ .KH,
                                                                                        onSuggestionSelected: function(event, param) {
                                                                                            var suggestion = param.suggestion;
                                                                                            if (suggestion.user_attributes.email.length > 0) {
                                                                                                stageEmail[index] = {
                                                                                                    value: ""
                                                                                                };
                                                                                                setStageEmail((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(stageEmail));
                                                                                                (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .onSuggestionSelection */ .wn)(formik.values.job_meeting_details_attributes[index].member_emails, suggestion.user_attributes.email, formik.values.job_meeting_details_attributes[index].member_initials, {
                                                                                                    email: suggestion.user_attributes.email,
                                                                                                    name_initials: suggestion.user_attributes.name_initials,
                                                                                                    name: suggestion.user_attributes.name
                                                                                                });
                                                                                                formik.validateForm();
                                                                                            }
                                                                                        },
                                                                                        inputProps: {
                                                                                            className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Input), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__textleft)),
                                                                                            placeholder: t("placeholder:search:type_name"),
                                                                                            styleError: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "job_meeting_details_attributes.".concat(index, ".member_emails")),
                                                                                            value: stageEmail[index].value,
                                                                                            index: index,
                                                                                            formik: formik,
                                                                                            selectedValues: formik.values.job_meeting_details_attributes[index].member_initials,
                                                                                            closeIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .Close */ .x8, {}),
                                                                                            disabled: !editable,
                                                                                            editable: editable,
                                                                                            name: "job_meeting_details_attributes.".concat(index, ".member_emails"),
                                                                                            onChange: function(value, param) {
                                                                                                var newValue = param.newValue, method = param.method;
                                                                                                stageEmail[index] = {
                                                                                                    value: newValue
                                                                                                };
                                                                                                setStageEmail((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(stageEmail));
                                                                                            },
                                                                                            stageEmail: stageEmail,
                                                                                            setStageEmail: setStageEmail,
                                                                                            onKeyDown: function(event) {
                                                                                                return (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .handleKeyDown */ .$y)(event, formik, index, stageEmail, setStageEmail);
                                                                                            }
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .CustomAutocompleteError */ .Jz, {
                                                                                        name: "job_meeting_details_attributes.".concat(index, ".member_emails"),
                                                                                        errorClass: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Error),
                                                                                        formik: formik,
                                                                                        style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "job_meeting_details_attributes.".concat(index, ".member_emails"))
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Duration), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol)),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                                        className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block__Heading */ .w2.Modal__Container__ContentSection__Block__Heading, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel)),
                                                                                        style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputText */ .oH)(formik, "job_meeting_details_attributes.".concat(index, ".duration")),
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                className: "red-color",
                                                                                                children: "*"
                                                                                            }),
                                                                                            "\xa0",
                                                                                            t("modal:input:duration"),
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                                children: [
                                                                                                    "(",
                                                                                                    t("modal:input:mins"),
                                                                                                    ")"
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .FormikControl */ .gt, {
                                                                                        className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Input), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Input)),
                                                                                        control: "input",
                                                                                        type: "text",
                                                                                        autocomplete: "off",
                                                                                        placeholder: t("placeholder:eg:15"),
                                                                                        formik: formik,
                                                                                        maxLength: 3,
                                                                                        custom_class: "FieldError",
                                                                                        name: "job_meeting_details_attributes.".concat(index, ".duration"),
                                                                                        value: formik.values.job_meeting_details_attributes[index].duration,
                                                                                        onChange: function(evt) {
                                                                                            var new_value = isNaN(evt.target.value) ? "" : parseInt(evt.target.value) == 0 ? "" : evt.target.value;
                                                                                            formik.setFieldValue("job_meeting_details_attributes.".concat(index, ".duration"), new_value);
                                                                                            var durations = [];
                                                                                            formik.values.job_meeting_details_attributes.map(function(x, itemIndex) {
                                                                                                if (!x._destroy) {
                                                                                                    if (itemIndex == index) {
                                                                                                        durations.push(new_value);
                                                                                                    } else {
                                                                                                        durations.push(parseInt(x.duration) || 0);
                                                                                                    }
                                                                                                } else {
                                                                                                    durations.push(0);
                                                                                                }
                                                                                                return x;
                                                                                            });
                                                                                            durations[index] = new_value;
                                                                                            setTotalDuration(durations.reduce(function(a, b) {
                                                                                                return (parseInt(a) || 0) + (parseInt(b) || 0);
                                                                                            }, 0));
                                                                                            var job_meeting_details_attributes = formik.values.job_meeting_details_attributes;
                                                                                        },
                                                                                        style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "job_meeting_details_attributes.".concat(index, ".duration"))
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    current_interview_type == _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.VIDEO */ .BH.VIDEO && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "mt30 ".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__FlexFlow)),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__InputField), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol), " mb0"),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                                        className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block__Heading */ .w2.Modal__Container__ContentSection__Block__Heading, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel)),
                                                                                        style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputText */ .oH)(formik, "job_meeting_details_attributes.".concat(index, ".meeting_platform_attributes.integration_id")),
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                className: "red-color",
                                                                                                children: "*"
                                                                                            }),
                                                                                            "\xa0",
                                                                                            t("modal:input:platform"),
                                                                                            " "
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .FormikControl */ .gt, {
                                                                                        className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__CustomSelect), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().width100)),
                                                                                        control: "select",
                                                                                        formik: formik,
                                                                                        placeholder: t("placeholder:select:default"),
                                                                                        options: platforms,
                                                                                        components: {
                                                                                            Option: IconOption
                                                                                        },
                                                                                        onChange: function(option) {
                                                                                            return formik.setFieldValue("job_meeting_details_attributes.".concat(index, ".meeting_platform_attributes.integration_id"), option.value);
                                                                                        },
                                                                                        default: (ref = formik.values.job_meeting_details_attributes[index].meeting_platform_attributes) === null || ref === void 0 ? void 0 : ref.integration_id,
                                                                                        name: "job_meeting_details_attributes.".concat(index, ".meeting_platform_attributes.integration_id"),
                                                                                        style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "job_meeting_details_attributes.".concat(index, ".meeting_platform_attributes.integration_id"))
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__InputField), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol), " mb0"),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                                        className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block__Heading */ .w2.Modal__Container__ContentSection__Block__Heading, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel)),
                                                                                        style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputText */ .oH)(formik, "job_meeting_details_attributes.".concat(index, ".duration")),
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                className: "red-color",
                                                                                                children: "*"
                                                                                            }),
                                                                                            "\xa0",
                                                                                            t("modal:input:duration"),
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                                children: [
                                                                                                    "(",
                                                                                                    t("modal:input:mins"),
                                                                                                    ")"
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .FormikControl */ .gt, {
                                                                                        className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Input), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Input)),
                                                                                        control: "input",
                                                                                        type: "text",
                                                                                        autocomplete: "off",
                                                                                        placeholder: "e g. 15",
                                                                                        formik: formik,
                                                                                        maxLength: 3,
                                                                                        custom_class: "FieldError",
                                                                                        name: "job_meeting_details_attributes.".concat(index, ".duration"),
                                                                                        value: formik.values.job_meeting_details_attributes[index].duration,
                                                                                        onChange: function(evt) {
                                                                                            var new_value = isNaN(evt.target.value) ? "" : parseInt(evt.target.value) == 0 ? "" : evt.target.value;
                                                                                            formik.setFieldValue("job_meeting_details_attributes.".concat(index, ".duration"), new_value);
                                                                                            var durations = [];
                                                                                            formik.values.job_meeting_details_attributes.map(function(x, itemIndex) {
                                                                                                if (!x._destroy) {
                                                                                                    if (itemIndex == index) {
                                                                                                        durations.push(new_value);
                                                                                                    } else {
                                                                                                        durations.push(parseInt(x.duration) || 0);
                                                                                                    }
                                                                                                } else {
                                                                                                    durations.push(0);
                                                                                                }
                                                                                                return x;
                                                                                            });
                                                                                            durations[index] = new_value;
                                                                                            setTotalDuration(durations.reduce(function(a, b) {
                                                                                                return (parseInt(a) || 0) + (parseInt(b) || 0);
                                                                                            }, 0));
                                                                                            var job_meeting_details_attributes = formik.values.job_meeting_details_attributes;
                                                                                        },
                                                                                        style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "job_meeting_details_attributes.".concat(index, ".duration"))
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol), " mt30"),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                                        className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block__Heading */ .w2.Modal__Container__ContentSection__Block__Heading, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel)),
                                                                                        style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputText */ .oH)(formik, "job_meeting_details_attributes.".concat(index, ".member_emails")),
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                className: "red-color",
                                                                                                children: "*"
                                                                                            }),
                                                                                            "\xa0",
                                                                                            t("modal:input:members"),
                                                                                            " "
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_autosuggest__WEBPACK_IMPORTED_MODULE_9___default()), {
                                                                                        suggestions: users,
                                                                                        onSuggestionsFetchRequested: function(param) {
                                                                                            var value = param.value;
                                                                                            return (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .onSuggestionsFetchRequested */ .oo)(value, currentStage, setUsers, router);
                                                                                        },
                                                                                        onSuggestionsClearRequested: function() {
                                                                                            return setUsers([]);
                                                                                        },
                                                                                        getSuggestionValue: function(suggestion) {
                                                                                            return "".concat(suggestion.user_attributes.email);
                                                                                        },
                                                                                        renderSuggestion: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .renderSuggestion */ .ox,
                                                                                        renderInputComponent: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .renderInputComponent */ .Qx,
                                                                                        shouldRenderSuggestions: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .shouldRenderSuggestions */ .KH,
                                                                                        onSuggestionSelected: function(event, param) {
                                                                                            var suggestion = param.suggestion;
                                                                                            if (suggestion.user_attributes.email.length > 0) {
                                                                                                stageEmail[index] = {
                                                                                                    value: ""
                                                                                                };
                                                                                                setStageEmail((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(stageEmail));
                                                                                                (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .onSuggestionSelection */ .wn)(formik.values.job_meeting_details_attributes[index].member_emails, suggestion.user_attributes.email, formik.values.job_meeting_details_attributes[index].member_initials, {
                                                                                                    email: suggestion.user_attributes.email,
                                                                                                    name_initials: suggestion.user_attributes.name_initials,
                                                                                                    name: suggestion.user_attributes.name
                                                                                                });
                                                                                                formik.validateForm();
                                                                                            }
                                                                                        },
                                                                                        inputProps: {
                                                                                            className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Input), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__textleft), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__InputFullWidth)),
                                                                                            placeholder: t("placeholder:search:type_name"),
                                                                                            value: stageEmail[index].value,
                                                                                            index: index,
                                                                                            formik: formik,
                                                                                            selectedValues: formik.values.job_meeting_details_attributes[index].member_initials,
                                                                                            closeIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .Close */ .x8, {}),
                                                                                            disabled: !editable,
                                                                                            editable: editable,
                                                                                            name: "job_meeting_details_attributes.".concat(index, ".member_emails"),
                                                                                            onChange: function(value, param) {
                                                                                                var newValue = param.newValue, method = param.method;
                                                                                                stageEmail[index] = {
                                                                                                    value: newValue
                                                                                                };
                                                                                                setStageEmail((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(stageEmail));
                                                                                            },
                                                                                            stageEmail: stageEmail,
                                                                                            setStageEmail: setStageEmail,
                                                                                            onKeyDown: function(event) {
                                                                                                return (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .handleKeyDown */ .$y)(event, formik, index, stageEmail, setStageEmail);
                                                                                            },
                                                                                            styleError: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "job_meeting_details_attributes.".concat(index, ".member_emails"))
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .CustomAutocompleteError */ .Jz, {
                                                                                        name: "job_meeting_details_attributes.".concat(index, ".member_emails"),
                                                                                        errorClass: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Error),
                                                                                        formik: formik,
                                                                                        style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "job_meeting_details_attributes.".concat(index, ".member_emails"))
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__CloseIcon)),
                                                                                children: interviewStageCount != 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                                    src: "/icons/close.png",
                                                                                    alt: "",
                                                                                    className: "mt0",
                                                                                    onClick: function() {
                                                                                        return (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .onAutomationChange */ .mV)(formik, "remove", index, currentStage, setStageEmail, setInterviewStageCount, setTotalDuration, setShowHideButton, [], []);
                                                                                    }
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    current_interview_type == _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.FACE2FACE */ .BH.FACE2FACE && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "mt0 ".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__FlexFlow)),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__BlockContainer */ .w2.Modal__Container__ContentSection__BlockContainer),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                        className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol), " mt0"),
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                                                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block__Heading */ .w2.Modal__Container__ContentSection__Block__Heading, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel)),
                                                                                                style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputText */ .oH)(formik, "default_location"),
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                        className: "red-color",
                                                                                                        children: "*"
                                                                                                    }),
                                                                                                    "\xa0",
                                                                                                    t("label:location")
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_places_autocomplete__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                                                                                                value: formik.values.default_location,
                                                                                                onChange: function(value) {
                                                                                                    formik.setFieldValue("default_location", value);
                                                                                                    formik.setFieldValue("place_id", "");
                                                                                                },
                                                                                                onSelect: function(address, placeId, suggestion) {
                                                                                                    formik.setFieldValue("default_location", address);
                                                                                                    formik.setFieldValue("place_id", placeId);
                                                                                                },
                                                                                                shouldFetchSuggestions: formik.values.default_location.length >= 3,
                                                                                                children: function(param) {
                                                                                                    var getInputProps = param.getInputProps, getSuggestionItemProps = param.getSuggestionItemProps, suggestions = param.suggestions, loading = param.loading;
                                                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                                        className: "autocomplete-root",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)({
                                                                                                                className: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Input),
                                                                                                                name: "default_location",
                                                                                                                placeholder: t("placeholder:eg:london"),
                                                                                                                style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "default_location")
                                                                                                            }, getInputProps({
                                                                                                                disabled: !editable || (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .isLocationDisabled */ .Pq)(formik, index)
                                                                                                            }))),
                                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                                                className: "autocomplete-dropdown-container",
                                                                                                                children: [
                                                                                                                    loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                                                        children: t("loading")
                                                                                                                    }),
                                                                                                                    suggestions.map(function(suggestion) {
                                                                                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)({}, getSuggestionItemProps(suggestion)), {
                                                                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                                                children: suggestion.description
                                                                                                                            }, suggestion.id)
                                                                                                                        }), suggestion.placeId);
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    });
                                                                                                }
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .CustomAutocompleteError */ .Jz, {
                                                                                                name: "default_location",
                                                                                                errorClass: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Error),
                                                                                                custom_class: "FieldError",
                                                                                                formik: formik,
                                                                                                style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "default_location"),
                                                                                                custom_error_90: "custom_error_90"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                        className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol), " mt0"),
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                                                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block__Heading */ .w2.Modal__Container__ContentSection__Block__Heading, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel)),
                                                                                                style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputText */ .oH)(formik, "job_meeting_details_attributes.".concat(index, ".duration")),
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                        className: "red-color",
                                                                                                        children: "*"
                                                                                                    }),
                                                                                                    "\xa0",
                                                                                                    t("modal:input:duration"),
                                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                                        children: [
                                                                                                            "(",
                                                                                                            t("modal:input:mins"),
                                                                                                            ")"
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                                className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Field)),
                                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .FormikControl */ .gt, {
                                                                                                    className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Input), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Input)),
                                                                                                    control: "input",
                                                                                                    type: "text",
                                                                                                    autocomplete: "off",
                                                                                                    placeholder: "e g. 15",
                                                                                                    formik: formik,
                                                                                                    maxLength: 3,
                                                                                                    custom_class: "FieldError",
                                                                                                    name: "job_meeting_details_attributes.".concat(index, ".duration"),
                                                                                                    value: formik.values.job_meeting_details_attributes[index].duration,
                                                                                                    onChange: function(evt) {
                                                                                                        var new_value = isNaN(evt.target.value) ? "" : parseInt(evt.target.value) == 0 ? "" : evt.target.value;
                                                                                                        formik.setFieldValue("job_meeting_details_attributes.".concat(index, ".duration"), new_value);
                                                                                                        var durations = [];
                                                                                                        formik.values.job_meeting_details_attributes.map(function(x, itemIndex) {
                                                                                                            if (!x._destroy) {
                                                                                                                if (itemIndex == index) {
                                                                                                                    durations.push(new_value);
                                                                                                                } else {
                                                                                                                    durations.push(parseInt(x.duration) || 0);
                                                                                                                }
                                                                                                            } else {
                                                                                                                durations.push(0);
                                                                                                            }
                                                                                                            return x;
                                                                                                        });
                                                                                                        durations[index] = new_value;
                                                                                                        setTotalDuration(durations.reduce(function(a, b) {
                                                                                                            return (parseInt(a) || 0) + (parseInt(b) || 0);
                                                                                                        }, 0));
                                                                                                        var job_meeting_details_attributes = formik.values.job_meeting_details_attributes;
                                                                                                    },
                                                                                                    style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "job_meeting_details_attributes.".concat(index, ".duration"))
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol), " mt30"),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                                        className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block__Heading */ .w2.Modal__Container__ContentSection__Block__Heading, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel)),
                                                                                        style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputText */ .oH)(formik, "job_meeting_details_attributes.".concat(index, ".member_emails")),
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                className: "red-color",
                                                                                                children: "*"
                                                                                            }),
                                                                                            "\xa0",
                                                                                            t("modal:input:members")
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_autosuggest__WEBPACK_IMPORTED_MODULE_9___default()), {
                                                                                        suggestions: users,
                                                                                        onSuggestionsFetchRequested: function(param) {
                                                                                            var value = param.value;
                                                                                            return (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .onSuggestionsFetchRequested */ .oo)(value, currentStage, setUsers, router);
                                                                                        },
                                                                                        onSuggestionsClearRequested: function() {
                                                                                            return setUsers([]);
                                                                                        },
                                                                                        getSuggestionValue: function(suggestion) {
                                                                                            return "".concat(suggestion.user_attributes.email);
                                                                                        },
                                                                                        renderSuggestion: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .renderSuggestion */ .ox,
                                                                                        renderInputComponent: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .renderAutomationModalInputComponent */ .rw,
                                                                                        shouldRenderSuggestions: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .shouldRenderSuggestions */ .KH,
                                                                                        onSuggestionSelected: function(event, param) {
                                                                                            var suggestion = param.suggestion;
                                                                                            if (suggestion.user_attributes.email.length > 0) {
                                                                                                stageEmail[index] = {
                                                                                                    value: ""
                                                                                                };
                                                                                                setStageEmail((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(stageEmail));
                                                                                                (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .onSuggestionSelection */ .wn)(formik.values.job_meeting_details_attributes[index].member_emails, suggestion.user_attributes.email, formik.values.job_meeting_details_attributes[index].member_initials, {
                                                                                                    email: suggestion.user_attributes.email,
                                                                                                    name_initials: suggestion.user_attributes.name_initials,
                                                                                                    name: suggestion.user_attributes.name
                                                                                                });
                                                                                                formik.validateForm();
                                                                                            }
                                                                                        },
                                                                                        inputProps: {
                                                                                            className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Input), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__textleft), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__InputFullWidth)),
                                                                                            placeholder: t("placeholder:search:type_name"),
                                                                                            value: stageEmail[index].value,
                                                                                            index: index,
                                                                                            formik: formik,
                                                                                            selectedValues: formik.values.job_meeting_details_attributes[index].member_initials,
                                                                                            closeIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .Close */ .x8, {}),
                                                                                            styleError: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "job_meeting_details_attributes.".concat(index, ".member_emails")),
                                                                                            disabled: !editable,
                                                                                            editable: editable,
                                                                                            name: "job_meeting_details_attributes.".concat(index, ".member_emails"),
                                                                                            onChange: function(value, param) {
                                                                                                var newValue = param.newValue, method = param.method;
                                                                                                stageEmail[index] = {
                                                                                                    value: newValue
                                                                                                };
                                                                                                setStageEmail((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(stageEmail));
                                                                                            },
                                                                                            stageEmail: stageEmail,
                                                                                            setStageEmail: setStageEmail,
                                                                                            onKeyDown: function(event) {
                                                                                                return (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .handleKeyDown */ .$y)(event, formik, index, stageEmail, setStageEmail);
                                                                                            }
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .CustomAutocompleteError */ .Jz, {
                                                                                        name: "job_meeting_details_attributes.".concat(index, ".member_emails"),
                                                                                        errorClass: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Error),
                                                                                        formik: formik,
                                                                                        style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "job_meeting_details_attributes.".concat(index, ".member_emails"))
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__CloseIcon)),
                                                                                children: interviewStageCount != 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                                    src: "/icons/close.png",
                                                                                    alt: "",
                                                                                    className: "mt0",
                                                                                    onClick: function() {
                                                                                        return (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .onAutomationChange */ .mV)(formik, "remove", index, currentStage, setStageEmail, setInterviewStageCount, setTotalDuration, setShowHideButton, [], []);
                                                                                    }
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            });
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "dnone ".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().addbtnposition), " mt25"),
                                                    children: formik.values.interview_type_id && [
                                                        _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.VIDEO */ .BH.VIDEO,
                                                        _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.FACE2FACE */ .BH.FACE2FACE, 
                                                    ].includes(current_interview_type) && showHideButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "w-auto",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                            buttonstyle: "".concat((_styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_33___default().iconTextButton), " mt0"),
                                                            type: "button",
                                                            onClick: function() {
                                                                (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .onAutomationChange */ .mV)(formik, "add", undefined, currentStage, setStageEmail, setInterviewStageCount, setTotalDuration, setShowHideButton, [], []);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(public_icons_thick_plus_svg__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {}),
                                                                t("button:add:interview")
                                                            ]
                                                        })
                                                    })
                                                }),
                                                formik.values.interview_type_id && [
                                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.PHONE */ .BH.PHONE,
                                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.VIDEO */ .BH.VIDEO,
                                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.FACE2FACE */ .BH.FACE2FACE, 
                                                ].includes(current_interview_type) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().SetupPopup__Duration), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__TotalDuration)),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                                            children: [
                                                                " ",
                                                                t("modal:input:total_duration")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            children: [
                                                                totalDuration,
                                                                " ",
                                                                t("modal:input:mins")
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        current_interview_type == _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.TECHTEST */ .BH.TECHTEST && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().SetupPopup__ContentBlock), " mt5"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Row)),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Members)),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "".concat(gridClass(current_interview_type), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel), " mb10"),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                children: t("modal:input:members")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Field)),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_autosuggest__WEBPACK_IMPORTED_MODULE_9___default()), {
                                                                    suggestions: users,
                                                                    onSuggestionsFetchRequested: function(param) {
                                                                        var value = param.value;
                                                                        return (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .onSuggestionsFetchRequested */ .oo)(value, currentStage, setUsers, router);
                                                                    },
                                                                    onSuggestionsClearRequested: function() {
                                                                        return setUsers([]);
                                                                    },
                                                                    getSuggestionValue: function(suggestion) {
                                                                        return "".concat(suggestion.user_attributes.email);
                                                                    },
                                                                    renderSuggestion: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .renderSuggestion */ .ox,
                                                                    renderInputComponent: techTestAction.renderMemberInputComponent,
                                                                    shouldRenderSuggestions: techTestAction.shouldRenderSuggestions,
                                                                    onSuggestionSelected: function(event, param) {
                                                                        var suggestion = param.suggestion;
                                                                        if (suggestion.user_attributes.email.length > 0) {
                                                                            setTechStageEmail({
                                                                                value: ""
                                                                            });
                                                                            techTestAction.onSuggestionSelection(formik.values.job_test_detail_attributes.member_emails, suggestion.user_attributes.email, formik.values.job_test_detail_attributes.member_initials, {
                                                                                email: suggestion.user_attributes.email,
                                                                                name_initials: suggestion.user_attributes.name_initials,
                                                                                name: suggestion.user_attributes.name
                                                                            });
                                                                            formik.validateForm();
                                                                        }
                                                                    },
                                                                    inputProps: {
                                                                        className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Input), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__textleft), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__InputFullWidth)),
                                                                        placeholder: t("placeholder:search:type_name"),
                                                                        value: techStageEmail.value,
                                                                        disabled: !editable,
                                                                        editable: editable,
                                                                        formik: formik,
                                                                        selectedValues: (ref7 = formik.values.job_test_detail_attributes) === null || ref7 === void 0 ? void 0 : ref7.member_initials,
                                                                        closeIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .Close */ .x8, {}),
                                                                        techTestAction: techTestAction,
                                                                        add_button: true,
                                                                        name: "job_test_detail_attributes.member_emails",
                                                                        onChange: function(value, param) {
                                                                            var newValue = param.newValue, method = param.method;
                                                                            setTechStageEmail({
                                                                                value: newValue,
                                                                                error: ""
                                                                            });
                                                                        },
                                                                        setStageEmail: setTechStageEmail,
                                                                        onKeyDown: function(event) {
                                                                            return techTestAction.handleKeyDown(event, formik, setTechStageEmail);
                                                                        }
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .CustomAutocompleteError */ .Jz, {
                                                                    name: "job_test_detail_attributes.member_emails",
                                                                    errorClass: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Error),
                                                                    formik: formik,
                                                                    style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "job_test_detail_attributes.member_emails")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        current_interview_type == _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.TECHTEST */ .BH.TECHTEST && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__BlockContainer */ .w2.Modal__Container__ContentSection__BlockContainer),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol), " mt0"),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                    className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block__Heading */ .w2.Modal__Container__ContentSection__Block__Heading, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel)),
                                                                    style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputText */ .oH)(formik, "job_test_detail_attributes.test_id"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "red-color",
                                                                            children: "*"
                                                                        }),
                                                                        "\xa0",
                                                                        t("modal:input:test_name"),
                                                                        " "
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_autosuggest__WEBPACK_IMPORTED_MODULE_9___default()), {
                                                                    suggestions: tests,
                                                                    onSuggestionsFetchRequested: function(value) {
                                                                        return techTestAction.onSuggestionsFetchRequested(value, techTestAction, formik.values.job_test_detail_attributes.test_type, false, t);
                                                                    },
                                                                    onSuggestionsClearRequested: function() {
                                                                        return setTests([]);
                                                                    },
                                                                    getSuggestionValue: techTestAction.getSuggestionValue,
                                                                    renderSuggestion: techTestAction.renderSuggestion,
                                                                    renderInputComponent: techTestAction.renderInputComponent,
                                                                    shouldRenderSuggestions: function() {
                                                                        return formik.values.job_test_detail_attributes.test_type == "Assessment" ? true : techTestAction.shouldRenderSuggestions;
                                                                    },
                                                                    onSuggestionSelected: function(event, param) {
                                                                        var suggestion = param.suggestion;
                                                                        setTechTest(suggestion.name);
                                                                        formik.setFieldValue("job_test_detail_attributes.test_id", suggestion.id);
                                                                        techTestAction.setCustomTestOptions(formik, suggestion.id.toString(), validationData, setValidationData);
                                                                    },
                                                                    inputProps: {
                                                                        className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Input), " input350"),
                                                                        placeholder: t("placeholder:eg:java_test"),
                                                                        styleError: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "job_test_detail_attributes.test_id"),
                                                                        value: techTest,
                                                                        disabled: !props.editable,
                                                                        onChange: function(value, param) {
                                                                            var newValue = param.newValue, method = param.method;
                                                                            setTechTest(newValue);
                                                                            formik.setFieldValue("job_test_detail_attributes.test_id", "");
                                                                        },
                                                                        name: "job_test_detail_attributes.test_id"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .CustomAutocompleteError */ .Jz, {
                                                                    name: "job_test_detail_attributes.test_id",
                                                                    errorClass: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Error),
                                                                    formik: formik,
                                                                    custom_class: "FieldError",
                                                                    style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "job_test_detail_attributes.test_id")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol), " mt0"),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                    className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block__Heading */ .w2.Modal__Container__ContentSection__Block__Heading, " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel)),
                                                                    style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputText */ .oH)(formik, "job_test_detail_attributes.days_to_expire"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "red-color",
                                                                            children: "*"
                                                                        }),
                                                                        "\xa0",
                                                                        t("modal:input:expires"),
                                                                        " "
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__FieldAuto), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__NoRightBorderRadius), " w50"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__NoRightBorderRadius), " Dpflexonly"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .Field */ .gN, {
                                                                                    component: addInterviewManualAction.NumberField,
                                                                                    type: "text",
                                                                                    autocomplete: "off",
                                                                                    placeholder: "e g. 5",
                                                                                    className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Input), " ").concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().Form__InputFocus), " thresholdmodl width70"),
                                                                                    formik: formik,
                                                                                    maxLength: 2,
                                                                                    name: "job_test_detail_attributes.days_to_expire",
                                                                                    format: "###",
                                                                                    style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "job_test_detail_attributes.days_to_expire"),
                                                                                    onChange: function(evt) {
                                                                                        var new_value = isNaN(evt.target.value) ? 1 : parseInt(evt.target.value) == 0 ? "" : evt.target.value;
                                                                                        formik.setFieldValue("job_test_detail_attributes.days_to_expire", new_value);
                                                                                        return new_value;
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: "".concat((_styles_components_automation_popup_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().AutomationPopup__Seconds), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__currency_symbol), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__currency_symbol__right), " ml0"),
                                                                                    style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "job_test_detail_attributes.days_to_expire"),
                                                                                    children: t("modal:input:days")
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .CustomAutocompleteError */ .Jz, {
                                                                            name: "job_test_detail_attributes.days_to_expire",
                                                                            errorClass: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Error),
                                                                            formik: formik,
                                                                            custom_class: "FieldError",
                                                                            style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "job_test_detail_attributes.days_to_expire")
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                ((ref8 = formik.values.job_test_detail_attributes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.test_id) === null || ref9 === void 0 ? void 0 : ref9.toString()) == "upload_new_test" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " mt30"),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel)),
                                                                style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputText */ .oH)(formik, "job_test_detail_attributes.assessment.name"),
                                                                children: t("modal:input:enter:assessment:name")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .FormikControl */ .gt, {
                                                            className: "assesmentlbl ".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Input), " ").concat((_styles_components_modal_add_assessment_index_module_scss__WEBPACK_IMPORTED_MODULE_35___default().Form__Input)),
                                                            control: "input",
                                                            type: "text",
                                                            errorClass: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Error),
                                                            custom_class: "form_custom_error",
                                                            formik: formik,
                                                            name: "job_test_detail_attributes.assessment.name",
                                                            style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "job_test_detail_attributes.assessment.name")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().SetupPopup__ContentBlock), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol), " mt30"),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel)),
                                                                children: t("label:assessment:link")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .FormikControl */ .gt, {
                                                            className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Input), " ").concat((_styles_components_modal_add_assessment_index_module_scss__WEBPACK_IMPORTED_MODULE_35___default().Form__Input)),
                                                            control: "input",
                                                            placeholder: t("placeholder:enter:link"),
                                                            type: "text",
                                                            formik: formik,
                                                            name: "job_test_detail_attributes.assessment.link",
                                                            errorClass: (_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__Error),
                                                            custom_class: "form_custom_error",
                                                            disabled: false,
                                                            style: (0,_imports_files_pages_clients_jobs_candidate_profile_job__WEBPACK_IMPORTED_MODULE_16__/* .InputError */ .pd)(formik, "job_test_detail_attributes.assessment.link"),
                                                            onChange: function(event) {
                                                                if (event.target.value.length == 0 && formik.values.file) {
                                                                    formik.setFieldValue("job_test_detail_attributes.assessment.file_type", "file");
                                                                } else {
                                                                    formik.setFieldValue("job_test_detail_attributes.assessment.file_type", "link");
                                                                }
                                                                formik.setFieldValue("job_test_detail_attributes.assessment.link", event.target.value);
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "".concat((_styles_components_modal_add_assessment_index_module_scss__WEBPACK_IMPORTED_MODULE_35___default().DividerOr), " ").concat((_styles_components_modal_add_assessment_index_module_scss__WEBPACK_IMPORTED_MODULE_35___default().AutomationDividerOr)),
                                                            children: t("upload:or")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "UploadAssessment ".concat((_styles_components_modal_add_assessment_index_module_scss__WEBPACK_IMPORTED_MODULE_35___default().UploadAssessment), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().SetupPopup__ContentBlock), " ").concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().mt0)),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "".concat((_styles_components_modal_add_assessment_index_module_scss__WEBPACK_IMPORTED_MODULE_35___default().LabelNote)),
                                                                    children: t("upload:supported_files")
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "".concat((_styles_components_modal_add_assessment_index_module_scss__WEBPACK_IMPORTED_MODULE_35___default().DropBox), " mt10"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__TableCol)),
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                                className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__FloatingLabel), " mb10"),
                                                                                children: t("upload:assessment")
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: "".concat((_styles_components_share_cv_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().Form__DropBoxcontainer), " ").concat((_styles_components_modal_add_assessment_index_module_scss__WEBPACK_IMPORTED_MODULE_35___default().Assessment__Form__DropBoxcontainer)),
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_recruitments_manage_assessment__WEBPACK_IMPORTED_MODULE_15__/* .AssessmentDropZone */ .Qq, {
                                                                                id: "upload_assessment",
                                                                                type: "automation",
                                                                                name: "job_test_detail_attributes.assessment.file",
                                                                                multiple: false,
                                                                                formRef: formRef,
                                                                                formik: formik,
                                                                                autofill: false,
                                                                                accept: ".pdf, .docx, .doc",
                                                                                dropAction: techTestAction,
                                                                                drop_type: "template"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: current_interview_type == _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.TECHTEST */ .BH.TECHTEST && validationData.type == "Assessment" && validationData.test_id == "upload_new_test" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ButtonSection */ .w2.Modal__Container__ButtonSection, " mt30"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_simple_tooltip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                        content: t("tooltip:test_template"),
                                                        background: "#00325A",
                                                        radius: 20,
                                                        padding: 12,
                                                        placement: "top",
                                                        fontSize: "12px",
                                                        className: "SimpleTooltip",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "SaveTooltip",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                                buttonstyle: "".concat((_styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_33___default().primarybtn), " ").concat((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .cursorNone */ .y$)(props.editable)),
                                                                type: "button",
                                                                disabled: !props.editable,
                                                                onClick: function() {
                                                                    setButtonState("save_and_continue");
                                                                    if (formik.values.job_test_detail_attributes.assessment.link.length > 0 && formik.values.job_test_detail_attributes.assessment.file || formik.values.job_test_detail_attributes.assessment.link.length == 0 && !formik.values.job_test_detail_attributes.assessment.file) {
                                                                        customToastrAction.setNormalToastr(t("errors:assessment_link_error"), "warning");
                                                                    } else {
                                                                        formik.submitForm();
                                                                    }
                                                                },
                                                                children: t("button:save_and_continue")
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                        buttonstyle: "".concat((_styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_33___default().secondarybtnborder), " ").concat((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .cursorNone */ .y$)(props.editable)),
                                                        type: "button",
                                                        disabled: !props.editable,
                                                        onClick: function() {
                                                            setButtonState("continue_without_saving");
                                                            formik.submitForm();
                                                        },
                                                        children: t("button:continue_without_saving")
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_22__/* .FormModalStyle.Modal__Container__ButtonSection */ .w2.Modal__Container__ButtonSection, " mt10"),
                                                children: [
                                                    [
                                                        _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.PHONE */ .BH.PHONE,
                                                        _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.FACE2FACE */ .BH.FACE2FACE,
                                                        _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.VIDEO */ .BH.VIDEO,
                                                        _imports_files_common_common__WEBPACK_IMPORTED_MODULE_14__/* .INTERVIEW_TYPES.VIDEOQA */ .BH.VIDEOQA, 
                                                    ].includes(current_interview_type) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                        buttonstyle: "".concat((_styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_33___default().secondarybtn), " mr0"),
                                                        type: "button",
                                                        onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)(function() {
                                                            var data, _tmp;
                                                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_29__.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        _tmp = {};
                                                                        return [
                                                                            4,
                                                                            (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_20__/* .reviewAutomationEmail */ .ds)(props.job_id || props.jobData.id, router, (_tmp.key = "move_candidates", _tmp.stage_id = currentStage.id, _tmp.list = true, _tmp.interview_type_id = formik.values.interview_type_id, _tmp))
                                                                        ];
                                                                    case 1:
                                                                        data = _state.sent();
                                                                        props.setEmailData(data);
                                                                        props.setHideModalClass(true);
                                                                        props.emailTemplateInfo.job_stage_id = currentStage.id;
                                                                        props.setEmailTemplateInfo(props.emailTemplateInfo);
                                                                        props.setReviewEmail(true);
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        }),
                                                        children: t("button:review_email")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                        buttonstyle: "".concat((_styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_33___default().primarybtn), " ").concat((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_21__/* .cursorNone */ .y$)(editable)),
                                                        disabled: isDisabled || !editable,
                                                        type: "submit",
                                                        children: t("button:save")
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            });
                        }
                    })
                ]
            })
        })
    });
}
AutomationModal.layout = src_layouts_ClientDashboard__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z;
/* harmony default export */ __webpack_exports__["default"] = (AutomationModal);


/***/ }),

/***/ 2145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CompareCandidates; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62286);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var src_layouts_ClientDashboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71234);
/* harmony import */ var _constants_components_sidebar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73257);
/* harmony import */ var _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20477);
/* harmony import */ var _imports_files_common_common_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96047);
/* harmony import */ var _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47942);
/* harmony import */ var react_simple_tooltip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54392);
/* harmony import */ var react_ellipsis_text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80272);











function CompareCandidates(props) {
    var TabletWidth = function TabletWidth(data) {
        if (data.score_hash.length < 3) {
            if (window.innerWidth <= 1200) {
                return {
                    minWidth: "700px"
                };
            }
        } else if (data.score_hash.length == 4) {
            if (window.innerWidth <= 1200) {
                return {
                    minWidth: "900px"
                };
            }
        }
        return {};
    };
    var getScoreColor = function getScoreColor(score, isLight) {
        var scoreValue = parseFloat(score);
        if (scoreValue == NaN || scoreValue == 0) return isLight ? _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.BgNaLight */ .bO.BgNaLight : _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.BgNa */ .bO.BgNa;
        else if (scoreValue <= 2) return isLight ? _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.BgRedLight */ .bO.BgRedLight : _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.BgRed */ .bO.BgRed;
        else if (scoreValue > 2 && scoreValue < 4) return isLight ? _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.BgYellowLight */ .bO.BgYellowLight : _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.BgYellow */ .bO.BgYellow;
        else if (scoreValue >= 4) return isLight ? _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.BgGreenLight */ .bO.BgGreenLight : _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.BgGreen */ .bO.BgGreen;
        else return isLight ? _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.BgNaLight */ .bO.BgNaLight : _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.BgNa */ .bO.BgNa;
    };
    var ref;
    var t = (0,_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var data = props.data;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .useState */ .eJ)(false), 2), buttonPopup = ref1[0], setButtonPopup = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .useState */ .eJ)(false), 2), showLoader = ref2[0], setShowLoader = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .useState */ .eJ)({}), 2), scorecardData = ref3[0], setScoreCardData = ref3[1];
    var commonAction = new _imports_files_common_common_js__WEBPACK_IMPORTED_MODULE_4__/* .CommonAction */ .x4();
    var customToastrAction = new _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_5__/* .CustomToastrAction */ .Y5();
    var flexBasis = data.score_hash.length <= 3 ? "flex-basis-33" : "flex-basis-20";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "DashboardPageContent ".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates */ .bO.CompareCandidates),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .motion.div */ .EA.div, {
                initial: "pageInitial",
                animate: "pageAnimate",
                exit: "pageExit",
                variants: _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .PAGE_ANIMATION_OPTIONS */ .Mf,
                transition: {
                    delay: 0.2
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .PageStyle.ClientCompany__BackSection */ .k2.ClientCompany__BackSection),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            onClick: function() {
                                return (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_5__/* .hideCompareCandidate */ .E6)();
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .ArrowLeft */ .Xd, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: t("compare_candidate:back_to_kanban")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.PageTitle */ .bO.PageTitle),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                children: t("compare_candidate:title")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__JobName */ .bO.CompareCandidates__JobName, " ").concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .PageStyle.LightBlueColor */ .k2.LightBlueColor),
                                children: data.job_title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__CandidateDetails */ .bO.CompareCandidates__CandidateDetails),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__LeftContent */ .bO.CompareCandidates__LeftContent),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__Label */ .bO.CompareCandidates__Label),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            children: t("compare_candidate:candidate")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__Reviewers */ .bO.CompareCandidates__Reviewers),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            children: t("compare_candidate:reviewers")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__Feedback */ .bO.CompareCandidates__Feedback),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            children: t("compare_candidate:feedback")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__OverallScore */ .bO.CompareCandidates__OverallScore),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            children: t("compare_candidate:overall_score")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__RightContent */ .bO.CompareCandidates__RightContent),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__CandidateName */ .bO.CompareCandidates__CandidateName),
                                        style: TabletWidth(data),
                                        children: data.score_hash.map(function(candidate, index) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "".concat(flexBasis),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
                                                        var scoredcards;
                                                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    return [
                                                                        4,
                                                                        (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_5__/* .getScorecards */ .JE)(candidate.job_application_id)
                                                                    ];
                                                                case 1:
                                                                    scoredcards = _state.sent();
                                                                    if (scoredcards) {
                                                                        setScoreCardData(scoredcards);
                                                                        setButtonPopup(true);
                                                                    } else {
                                                                        customToastrAction.setNormalToastr("".concat(t("compare_candidate:scorecard_not_available"), " ").concat(candidate.candidate_name, "."), "warning");
                                                                    }
                                                                    return [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    }),
                                                    children: [
                                                        candidate.candidate_name,
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .UpwardArrow */ .Rs, {}),
                                                        " "
                                                    ]
                                                })
                                            });
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__ReviewersCount */ .bO.CompareCandidates__ReviewersCount),
                                        style: TabletWidth(data),
                                        children: data.score_hash.map(function(candidate, index) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                                className: "".concat(flexBasis),
                                                children: [
                                                    "".concat(candidate.reviewer),
                                                    " ",
                                                    t("compare_candidate:reviewers")
                                                ]
                                            });
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__FeedbackCount */ .bO.CompareCandidates__FeedbackCount),
                                        style: TabletWidth(data),
                                        children: data.score_hash.map(function(candidate, index) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                                className: "".concat(flexBasis, " ").concat(candidate.notes > 0 ? "td-underline CursorPointer" : ""),
                                                onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
                                                    var scoredcards;
                                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                return [
                                                                    4,
                                                                    (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_5__/* .getScorecards */ .JE)(candidate.job_application_id)
                                                                ];
                                                            case 1:
                                                                scoredcards = _state.sent();
                                                                if (scoredcards) {
                                                                    setScoreCardData(scoredcards);
                                                                    setButtonPopup(true);
                                                                } else {
                                                                    customToastrAction.setNormalToastr("".concat(t("compare_candidate:scorecard_not_available"), " ").concat(candidate.candidate_name, "."), "warning");
                                                                }
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                }),
                                                children: [
                                                    "".concat(candidate.notes),
                                                    " ",
                                                    t("compare_candidate:notes")
                                                ]
                                            });
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__OverallScoreCount */ .bO.CompareCandidates__OverallScoreCount),
                                        style: TabletWidth(data),
                                        children: data.score_hash.map(function(candidate, index) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "".concat(flexBasis, " ").concat(getScoreColor(candidate.overall_score, false)),
                                                children: candidate.overall_score || "N/A"
                                            });
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    (data === null || data === void 0 ? void 0 : (ref = data.competencies) === null || ref === void 0 ? void 0 : ref.length) > 0 && !data.scorecard_private && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__w100 */ .bO.CompareCandidates__w100),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__Title */ .bO.CompareCandidates__Title),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: t("compare_candidate:competencies")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {})
                        ]
                    }),
                    !data.scorecard_private && data.competencies.map(function(competency, competency_index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__w100 */ .bO.CompareCandidates__w100),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__CandidateCompetencies */ .bO.CompareCandidates__CandidateCompetencies, " mt24"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__LeftContent */ .bO.CompareCandidates__LeftContent),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__CompetencyName */ .bO.CompareCandidates__CompetencyName),
                                                children: competency.job_competency_name.trim().length > 40 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_simple_tooltip__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                    className: "SimpleTooltip",
                                                    content: competency.job_competency_name,
                                                    background: "#00325A",
                                                    radius: 20,
                                                    padding: 10,
                                                    placement: "top",
                                                    fixed: false,
                                                    fontSize: "11px",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "Competencytooltipwidth150 tooltipwidthmb0",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                            children: competency.job_competency_name
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.LessThanForty */ .bO.LessThanForty),
                                                    children: competency.job_competency_name
                                                })
                                            }),
                                            competency.job_sub_competencies.map(function(subcompetency, subcompetency_index) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__SubCompetency */ .bO.CompareCandidates__SubCompetency),
                                                    children: subcompetency.job_sub_competency_name.trim().length > 40 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_simple_tooltip__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                        className: "SimpleTooltip",
                                                        content: subcompetency.job_sub_competency_name,
                                                        background: "#00325A",
                                                        radius: 20,
                                                        padding: 10,
                                                        placement: "top",
                                                        fixed: false,
                                                        fontSize: "11px",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "Competencytooltipwidth150 tooltipwidthmb0",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                children: subcompetency.job_sub_competency_name
                                                            })
                                                        })
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.LessThanForty */ .bO.LessThanForty),
                                                        children: subcompetency.job_sub_competency_name
                                                    })
                                                });
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__RightContent */ .bO.CompareCandidates__RightContent, " ").concat(competency.job_sub_competencies.length > 0 ? "" : _imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__CandidateCompetencyOnly */ .bO.CompareCandidates__CandidateCompetencyOnly),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__CompetencyCount */ .bO.CompareCandidates__CompetencyCount),
                                                style: TabletWidth(data),
                                                children: data.score_hash.map(function(candidate, index) {
                                                    var ref, ref1;
                                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        className: "".concat(flexBasis, " ").concat(getScoreColor((ref = candidate.score_hash.filter(function(x) {
                                                            return x.job_competency_id == competency.job_competency_id;
                                                        })[0]) === null || ref === void 0 ? void 0 : ref.score, false)),
                                                        children: ((ref1 = candidate.score_hash.filter(function(x) {
                                                            return x.job_competency_id == competency.job_competency_id;
                                                        })[0]) === null || ref1 === void 0 ? void 0 : ref1.score) || "N/A"
                                                    });
                                                })
                                            }),
                                            competency.job_sub_competencies.map(function(subcompetency, subcompetency_index) {
                                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "".concat(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .CandidateStyle.CompareCandidates__SubCompetencyCount */ .bO.CompareCandidates__SubCompetencyCount),
                                                    style: TabletWidth(data),
                                                    children: data.score_hash.map(function(candidate, index) {
                                                        var ref, ref1, ref2, ref3, ref4, ref5;
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                            className: "".concat(flexBasis, " ").concat(getScoreColor((ref2 = (ref = candidate.score_hash.filter(function(x) {
                                                                return x.job_competency_id == competency.job_competency_id;
                                                            })[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.job_sub_competencies) === null || ref1 === void 0 ? void 0 : ref1.filter(function(y) {
                                                                return y.job_sub_competency_id == subcompetency.job_sub_competency_id;
                                                            })[0]) === null || ref2 === void 0 ? void 0 : ref2.score, true)),
                                                            children: ((ref5 = (ref3 = candidate.score_hash.filter(function(x) {
                                                                return x.job_competency_id == competency.job_competency_id;
                                                            })[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.job_sub_competencies) === null || ref4 === void 0 ? void 0 : ref4.filter(function(y) {
                                                                return y.job_sub_competency_id == subcompetency.job_sub_competency_id;
                                                            })[0]) === null || ref5 === void 0 ? void 0 : ref5.score) || "N/A"
                                                        });
                                                    })
                                                });
                                            })
                                        ]
                                    })
                                ]
                            })
                        });
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_job_sharing__WEBPACK_IMPORTED_MODULE_3__/* .SingleCandidateModal */ .Rl, {
                setButtonPopup: setButtonPopup,
                buttonPopup: buttonPopup,
                data: scorecardData
            })
        ]
    });
}; // CompareCandidates.layout = ClientDashboard;
 // export default CompareCandidates;


/***/ }),

/***/ 23908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18186);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62286);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85374);
/* harmony import */ var _styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(84215);
/* harmony import */ var _styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66172);
/* harmony import */ var _components_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95662);
/* harmony import */ var react_autosuggest__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46921);
/* harmony import */ var react_autosuggest__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_autosuggest__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64335);
/* harmony import */ var src_layouts_ClientDashboard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71234);
/* harmony import */ var _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47942);
/* harmony import */ var public_icons_error_exclamation_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71843);















function CustomTechTestModal(param) {
    var setBtnPopup = param.setBtnPopup, editable = param.editable, router = param.router, from = param.from, job_id = param.job_id, params = param.params, setSelectedCards = param.setSelectedCards, setActionBar = param.setActionBar, activeTab = param.activeTab, setJobData = param.setJobData, setInitialData = param.setInitialData, setFlagForRerender = param.setFlagForRerender;
    var validations = function validations(validationData) {
        var schema = _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .Yup.object */ .sm.object({
            test_id: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .TRANSLATION */ .TA)("errors:invalid_test")),
            days_to_expire: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .TRANSLATION */ .TA)("errors:required")),
            test_type: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .Yup.string */ .sm.string(),
            assessment: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .Yup.object */ .sm.object().shape((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, validationData.type == "Assessment" && validationData.test_id.toString() == "upload_new_test" ? {
                name: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .TRANSLATION */ .TA)("errors:required")),
                file_type: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .TRANSLATION */ .TA)("errors:required")),
                link: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .Yup.string */ .sm.string().when("file_type", {
                    is: function(file_type) {
                        return file_type == "link";
                    },
                    then: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .TRANSLATION */ .TA)("errors:required")).matches(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .URL_FORMAT */ .QC, (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .TRANSLATION */ .TA)("errors:assessment_link_invalid")),
                    otherwise: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .Yup.string */ .sm.string().notRequired()
                }),
                filename: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .Yup.string */ .sm.string().when("file_type", {
                    is: function(file_type) {
                        return file_type == "file";
                    },
                    then: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .Yup.string */ .sm.string().required((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .TRANSLATION */ .TA)("errors:required")),
                    otherwise: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .Yup.string */ .sm.string().notRequired()
                }),
                filesize: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .Yup.string */ .sm.string().when("file_type", {
                    is: function(file_type) {
                        return file_type == "file";
                    },
                    then: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .Yup.string */ .sm.string().test("is-greater", (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .TRANSLATION */ .TA)("errors:max_file_size"), function(value) {
                        var currentFileSize = parseInt(value) || 0;
                        return currentFileSize < _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .MANAGE_ASSESSMENT.file_size */ .WY.file_size;
                    }),
                    otherwise: _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .Yup.string */ .sm.string().notRequired()
                })
            } : {}))
        });
        return schema;
    };
    var getSuggestionValue = function getSuggestionValue(suggestion) {
        return suggestion.code;
    };
    var renderSuggestion = function renderSuggestion(suggestion) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: suggestion.name
        });
    };
    var escapeRegexCharacters = function escapeRegexCharacters(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    };
    var shouldRenderSuggestions = function shouldRenderSuggestions(value) {
        return value.trim().length >= 3;
    };
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .useState */ .eJ)([]), 2), tests = ref[0], setTests = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .useState */ .eJ)("Upload a file"), 2), uploadFileText = ref1[0], setUploadFileText = ref1[1];
    var techTestAction = new _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .TechTestAction */ .Uy(setTests);
    var job_test_detail = {
        "test_id": "",
        "test_type": "Assessment",
        "member_initials": [],
        "member_emails": [],
        "days_to_expire": "",
        "assessment": {
            name: "",
            file_type: "link",
            link: "",
            file: "",
            filename: "",
            filesize: ""
        }
    };
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .useState */ .eJ)(""), 2), techTest = ref2[0], setTechTest = ref2[1];
    var ref3 = (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)(), t = ref3.t, i18n = ref3.i18n;
    var initialValues = job_test_detail;
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .useState */ .eJ)({
        type: "TestLibrary",
        test_id: ""
    }), 2), validationData = ref4[0], setValidationData = ref4[1];
    function getSuggestions(value) {
        return _getSuggestions.apply(this, arguments);
    }
    function _getSuggestions() {
        _getSuggestions = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(value) {
            var escapedValue, techTests;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        escapedValue = escapeRegexCharacters(value.value.trim());
                        if (escapedValue === "") {
                            return [
                                2,
                                []
                            ];
                        }
                        return [
                            4,
                            (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .getTechTestData */ .Ib)(escapedValue)
                        ];
                    case 1:
                        techTests = _state.sent();
                        return [
                            2,
                            techTests
                        ];
                }
            });
        });
        return _getSuggestions.apply(this, arguments);
    }
    function onSuggestionsFetchRequested(value) {
        return _onSuggestionsFetchRequested.apply(this, arguments);
    }
    function _onSuggestionsFetchRequested() {
        _onSuggestionsFetchRequested = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(value) {
            var techTests;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getSuggestions(value)
                        ];
                    case 1:
                        techTests = _state.sent();
                        setTests(techTests);
                        return [
                            2
                        ];
                }
            });
        });
        return _onSuggestionsFetchRequested.apply(this, arguments);
    }
    ;
    var onSuggestionsClearRequested = function() {
        setTests([]);
    };
    var renderInputComponent = function(inputProps) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            className: (_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Input),
            autoComplete: "password"
        }, inputProps));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.ModalOverlay */ .w2.ModalOverlay),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal */ .w2.Modal, " AutomationPopup AddInterview"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container */ .w2.Modal__Container),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container__Heading__Close */ .w2.Modal__Container__Heading__Close),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container__ContentSection__Heading */ .w2.Modal__Container__ContentSection__Heading),
                                    children: t("modal:tech_test:heading")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container__CloseSection */ .w2.Modal__Container__CloseSection),
                                    onClick: function() {
                                        return setBtnPopup(false);
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_1__/* .Close */ .x8, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container__ContentSection */ .w2.Modal__Container__ContentSection,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                    className: _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_1__/* .FormModalStyle.Modal__Container__ContentSection__Description */ .w2.Modal__Container__ContentSection__Description,
                                    children: t("modal:tech_test:subheading")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .Formik */ .J9, {
                                    initialValues: initialValues,
                                    validationSchema: validations(validationData),
                                    onSubmit: function() {
                                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(values) {
                                            var _tmp;
                                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _tmp = {};
                                                        return [
                                                            4,
                                                            (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_6__/* .sendCustomTechTest */ .HD)((_tmp.job_id = job_id, _tmp.values = values, _tmp.params = params, _tmp.router = router, _tmp.setBtnPopup = setBtnPopup, _tmp.setSelectedCards = setSelectedCards, _tmp.setActionBar = setActionBar, _tmp.activeTab = activeTab, _tmp.setJobData = setJobData, _tmp.from = from, _tmp.setInitialData = setInitialData, _tmp.setFlagForRerender = setFlagForRerender, _tmp))
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(values) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }(),
                                    children: function(formik) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .Form */ .l0, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "".concat((_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().SetupPopup__ContentGridTech), " cpblock ").concat((_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().mt25)),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "".concat((_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol)),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                    className: "".concat((_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabel), " mb0"),
                                                                    style: (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .InputText */ .oH)(formik, "test_id"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "red-color",
                                                                            children: "*"
                                                                        }),
                                                                        "\xa0",
                                                                        t("modal:input:select_test")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_autosuggest__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                                    suggestions: tests,
                                                                    onSuggestionsFetchRequested: function(value) {
                                                                        return techTestAction.onSuggestionsFetchRequested(value, techTestAction, formik.values.test_type, true, t);
                                                                    },
                                                                    onSuggestionsClearRequested: function() {
                                                                        return setTests([]);
                                                                    },
                                                                    getSuggestionValue: techTestAction.getSuggestionValue,
                                                                    renderSuggestion: techTestAction.renderSuggestion,
                                                                    renderInputComponent: techTestAction.renderInputComponent,
                                                                    shouldRenderSuggestions: function() {
                                                                        return formik.values.test_type == "Assessment" ? true : techTestAction.shouldRenderSuggestions;
                                                                    },
                                                                    onSuggestionSelected: function(event, param) {
                                                                        var suggestion = param.suggestion;
                                                                        setTechTest(suggestion.name);
                                                                        formik.setFieldValue("test_id", suggestion.id);
                                                                        techTestAction.setCustomTestOptions(formik, suggestion.id.toString(), validationData, setValidationData);
                                                                    },
                                                                    inputProps: {
                                                                        className: "".concat((_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Input), " input350"),
                                                                        placeholder: t("placeholder:eg:java_test"),
                                                                        value: techTest,
                                                                        style: (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .InputError */ .pd)(formik, "test_id"),
                                                                        disabled: !editable,
                                                                        onChange: function(value, param) {
                                                                            var newValue = param.newValue, method = param.method;
                                                                            setTechTest(newValue);
                                                                            formik.setFieldValue("test_id", "");
                                                                        },
                                                                        name: "test_id"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .AutocompleteError */ .PG, {
                                                                    name: "test_id",
                                                                    errorClass: (_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Error),
                                                                    formik: formik,
                                                                    style: (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .InputError */ .pd)(formik, "test_id")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "".concat((_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__TableCol)),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                    className: "Dpflex ".concat((_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__FloatingLabel)),
                                                                    style: (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .InputText */ .oH)(formik, "days_to_expire"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "red-color",
                                                                            children: "*"
                                                                        }),
                                                                        "\xa0",
                                                                        t("modal:input:expires"),
                                                                        "\xa0",
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                            children: [
                                                                                "(",
                                                                                t("modal:input:days"),
                                                                                ")"
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .FormikControl */ .gt, {
                                                                    className: "".concat((_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Input), " ").concat((_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__textleft), " ").concat((_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__InputFullWidth)),
                                                                    control: "input",
                                                                    type: "text",
                                                                    placeholder: t("placeholder:eg:5"),
                                                                    disabled: !editable,
                                                                    formik: formik,
                                                                    name: "days_to_expire",
                                                                    maxLength: 2,
                                                                    onChange: function(evt) {
                                                                        var new_value = isNaN(evt.target.value) ? 1 : parseInt(evt.target.value) == 0 ? "" : evt.target.value;
                                                                        formik.setFieldValue("days_to_expire", new_value);
                                                                        return new_value;
                                                                    },
                                                                    style: (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .InputError */ .pd)(formik, "days_to_expire")
                                                                })
                                                            ]
                                                        }),
                                                        formik.values.test_id.toString() == "upload_new_test" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "".concat((_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().SetupPopup__Assesmentsection), " asessment-form-section"),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "".concat((_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().SetupPopup__ContentBlock), " cpblock"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "".concat((_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().SetupPopup__ContentBlock)),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                                children: t("modal:tech_test:assesment_heding")
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .FormikControl */ .gt, {
                                                                                className: (_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Input),
                                                                                control: "input",
                                                                                type: "text",
                                                                                errorClass: (_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Error),
                                                                                formik: formik,
                                                                                name: "assessment.name",
                                                                                style: (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .InputError */ .pd)(formik, "assessment.name")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "".concat((_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().SetupPopup__ContentBlock)),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                                children: t("modal:input:add_file")
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                className: " WrapperRadioDpBlock customClass",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                                                className: "Dpflex WrapperRadioContainer",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                                                        type: "radio",
                                                                                                        name: "assessment.file_type",
                                                                                                        id: "option-1",
                                                                                                        value: "file",
                                                                                                        checked: formik.values.assessment.file_type == "file",
                                                                                                        onChange: function(event) {
                                                                                                            return techTestAction.onTestoptionChange(formik, event);
                                                                                                        }
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                                                        className: "ml5 WrapperRadioSpan",
                                                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                                            className: "ml5 WrapperRadioSpan",
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                                    className: "PositionRelativeRadio",
                                                                                                                    children: uploadFileText
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                                                                    disabled: formik.values.assessment.file_type == "link",
                                                                                                                    type: "file",
                                                                                                                    name: "assessment.file",
                                                                                                                    accept: ".pdf, .docx, .doc",
                                                                                                                    onChange: function(event) {
                                                                                                                        techTestAction.uploadFile(formik, event, setUploadFileText);
                                                                                                                    }
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                        children: formik.values.assessment.filename
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            formik.touched.assessment.file && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                                className: "Dpflex grid10",
                                                                                                children: formik.errors.assessment.filesize ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(public_icons_error_exclamation_svg__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
                                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                                            className: "errorcolor",
                                                                                                            children: formik.errors.assessment.filesize
                                                                                                        })
                                                                                                    ]
                                                                                                }) : formik.errors.assessment.filename ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(public_icons_error_exclamation_svg__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
                                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                                            className: "errorcolor",
                                                                                                            children: formik.errors.assessment.filename
                                                                                                        })
                                                                                                    ]
                                                                                                }) : ""
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                        className: "Dpflex",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                                                className: "Dpflex WrapperRadioContainer",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                                                        type: "radio",
                                                                                                        name: "assessment.file_type",
                                                                                                        id: "option-2",
                                                                                                        value: "link",
                                                                                                        checked: formik.values.assessment.file_type == "link",
                                                                                                        onChange: function(event) {
                                                                                                            return techTestAction.onTestoptionChange(formik, event);
                                                                                                        }
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                        className: "WrapperRadiocheckmark top15 ml0"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                        className: "ml5 WrapperRadioSpan"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .FormikControl */ .gt, {
                                                                                                className: (_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Input),
                                                                                                control: "input",
                                                                                                placeholder: t("placeholder:enter:link"),
                                                                                                type: "text",
                                                                                                formik: formik,
                                                                                                name: "assessment.link",
                                                                                                errorClass: (_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().Form__Error),
                                                                                                style: (0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .InputError */ .pd)(formik, "assessment.link")
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().SetupPopup__Footertechtest),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_styles_components_setupmodel_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().SetupPopup__SubmitSectionAutomation),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                            buttonstyle: "".concat((_styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().primarybtn), " ").concat((0,_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_4__/* .cursorNone */ .y$)(editable)),
                                                            type: "submit",
                                                            disabled: !editable,
                                                            children: t("button:send")
                                                        })
                                                    })
                                                })
                                            ]
                                        });
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}
CustomTechTestModal.layout = src_layouts_ClientDashboard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
/* harmony default export */ __webpack_exports__["default"] = (CustomTechTestModal);


/***/ }),

/***/ 91831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18186);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4012);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62286);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34817);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13245);
/* harmony import */ var react_datetime_css_react_datetime_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18202);
/* harmony import */ var react_datetime_css_react_datetime_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_datetime_css_react_datetime_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_places_autocomplete__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25538);
/* harmony import */ var react_simple_tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54392);
/* harmony import */ var _components_common_modal_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99005);
/* harmony import */ var public_icons_import_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79444);













function JobForm(props) {
    var salaryInputs = function salaryInputs(salary_choice) {
        switch(salary_choice){
            case "range":
                return [
                    "min_salary",
                    "max_salary"
                ];
            case "starting":
                return [
                    "min_salary"
                ];
            default:
                return [
                    "max_salary"
                ];
        }
    };
    var handleIsRemote = function handleIsRemote(event, formik) {
        var isChecked = event.target.checked;
        var inputName = event.target.getAttribute("name");
        if (isChecked) {
            formik.setFieldValue(inputName, isChecked);
            formik.setFieldValue("job.is_hybrid", false);
        } else {
            formik.setFieldValue(inputName, isChecked);
        }
    };
    var handleIsHybrid = function handleIsHybrid(event, formik) {
        var isChecked = event.target.checked;
        var inputName = event.target.getAttribute("name");
        if (isChecked) {
            formik.setFieldValue(inputName, true);
            formik.setFieldValue("job.is_remote", false);
        } else {
            formik.setFieldValue(inputName, isChecked);
        }
    };
    var handleSalaryHidden = function handleSalaryHidden(event, formik) {
        var isChecked = event.target.checked;
        var inputName = event.target.getAttribute("name");
        formik.setFieldValue(inputName, isChecked);
        formik.setFieldValue("job.job_salary_detail_attributes.salary_displayed", "");
    };
    var handleWithoutCV = function handleWithoutCV(event, formik) {
        var isChecked = event.target.checked;
        var inputName = event.target.getAttribute("name");
        formik.setFieldValue(inputName, isChecked);
    };
    var handleSalaryChoice = function handleSalaryChoice(option, formik, event) {
        var array = [];
        formik.setFieldValue(event.name, option.value);
        switch(option.value){
            case "range":
                array = [
                    "min_salary",
                    "max_salary"
                ];
                setMinSalaryLabel("Min Salary");
                setMaxSalaryLabel("Max Salary");
                setMinSalaryholder("Min Salary");
                setMaxSalaryholder("Max Salary");
                setSalaryInput((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(array));
                formik.setFieldValue("job.job_salary_detail_attributes.min_salary", "");
                formik.setFieldValue("job.job_salary_detail_attributes.max_salary", "");
                break;
            case "starting":
                array = [
                    "min_salary"
                ];
                setMinSalaryLabel("Salary");
                setMinSalaryholder("Salary");
                setSalaryInput((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(array));
                formik.setFieldValue("job.job_salary_detail_attributes.min_salary", "");
                formik.setFieldValue("job.job_salary_detail_attributes.max_salary", "");
                break;
            default:
                array = [
                    "max_salary"
                ];
                setMaxSalaryLabel("Salary");
                setMaxSalaryholder("Salary");
                setSalaryInput((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(array));
                formik.setFieldValue("job.job_salary_detail_attributes.min_salary", "");
                formik.setFieldValue("job.job_salary_detail_attributes.max_salary", "");
        }
    };
    var getSuggestionValue = function getSuggestionValue(suggestion) {
        return suggestion.label;
    };
    var renderSuggestion = function renderSuggestion(suggestion) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: suggestion.label
        });
    };
    var escapeRegexCharacters = function escapeRegexCharacters(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    };
    var shouldRenderSuggestions = function shouldRenderSuggestions(value) {
        return (value === null || value === void 0 ? void 0 : value.trim().length) >= 1;
    };
    var getDepartmentSuggestionValue = function getDepartmentSuggestionValue(suggestion) {
        return "".concat(suggestion);
    };
    var renderDepartmentSuggestion = function renderDepartmentSuggestion(suggestion) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: suggestion
        });
    };
    var languageList = function languageList(t) {
        return [
            {
                label: t("jobs:languages:en-US"),
                value: "English US"
            },
            {
                label: t("jobs:languages:en-UK"),
                value: "English UK"
            },
            {
                label: t("jobs:languages:sv-SE"),
                value: "Swedish"
            },
            {
                label: t("jobs:languages:nb-NO"),
                value: "Norwegian"
            },
            {
                label: t("jobs:languages:da-DK"),
                value: "Danish"
            },
            {
                label: t("jobs:languages:es-ES"),
                value: "Spanish"
            },
            {
                label: t("jobs:languages:de-DE"),
                value: "German"
            },
            {
                label: t("jobs:languages:fr-FR"),
                value: "French"
            }, 
        ];
    };
    var onContractTypeChange = function onContractTypeChange(event, formik) {
        formik.setFieldValue("job.contract_type", event.target.value);
        if (event.target.value == "contract") {
            var per_day = salaryduration.filter(function(x) {
                return x.value == "per_day";
            })[0];
            var others = salaryduration.filter(function(x) {
                return x.value != "per_day";
            });
            var values = [
                per_day
            ];
            others.map(function(x) {
                return values.push(x);
            });
            salaryduration = values;
        } else {
            var per_day1 = salaryduration.filter(function(x) {
                return x.value == "per_day";
            })[0];
            var others1 = salaryduration.filter(function(x) {
                return x.value != "per_day";
            });
            others1.push(per_day1);
            salaryduration = others1;
        }
    };
    var shouldFetchSuggestions = function shouldFetchSuggestions(formik) {
        var ref, ref1;
        return ((ref = formik.values.job.location_attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.full_address) === null || ref1 === void 0 ? void 0 : ref1.length) >= 3;
    };
    var showErrorAlert = function showErrorAlert(formik) {
        if (formik.errors.job != undefined) {
            new _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .CustomToastrAction */ .Y5().setNormalToastr((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .TRANSLATION */ .TA)("errors:complete_fields"), "warning");
        }
    };
    var ref, ref1;
    var queryClient = (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useQueryClient */ .NL)();
    var result = props.result;
    var initialValues = props.initialValues;
    var action = props.action;
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(""), 2), text = ref2[0], setText = ref2[1];
    var router = (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useRouter */ .tv)();
    var ref3 = (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)(), t = ref3.t, i18n = ref3.i18n;
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(t("jobs:details:input:min_salary")), 2), minSalaryLabel = ref4[0], setMinSalaryLabel = ref4[1];
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(t("jobs:details:input:max_salary")), 2), maxSalaryLabel = ref5[0], setMaxSalaryLabel = ref5[1];
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(t("jobs:details:input:min_salary")), 2), minSalaryHolder = ref6[0], setMinSalaryholder = ref6[1];
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(t("jobs:details:input:max_salary")), 2), maxSalaryHolder = ref7[0], setMaxSalaryholder = ref7[1];
    var ref8 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)([]), 2), users = ref8[0], setUsers = ref8[1];
    var ref9 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(false), 2), cancelPopup = ref9[0], setCancelPopup = ref9[1];
    var ref10 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(false), 2), buttonPopup = ref10[0], setButtonPopup = ref10[1];
    var editorRef = (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useRef */ .sO)(null);
    var formRef = (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useRef */ .sO)(null);
    var current_step = _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .JOB_STEPS.DETAILS */ .l.DETAILS;
    var Placeholder = function(props) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .components.Placeholder */ .wx.Placeholder, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props));
    };
    var ref11 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(""), 2), submitState = ref11[0], setSubmitState = ref11[1];
    var ref12 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)({}), 2), jobPreview = ref12[0], setJobPreivew = ref12[1];
    var fromKanban = router.query.from_kanban ? true : false;
    var ref13 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(false), 2), gotoKanban = ref13[0], setGotoKanban = ref13[1];
    var jobId = new _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .DataFromUrl */ .QJ().getJobId();
    var editable = initialValues.job.editable;
    var ref14 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(false), 2), disabledSaveButton = ref14[0], setDisabledSaveButton = ref14[1];
    var ref15 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(), 2), flagForRender = ref15[0], setFlagForRender = ref15[1];
    var ref16 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(false), 2), showLoader = ref16[0], setShowLoader = ref16[1];
    var ref17 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)({
        state: false,
        data: {
            language: "English UK",
            tone_of_voice: ""
        }
    }), 2), descriptionModal = ref17[0], setDescriptionModal = ref17[1];
    var ref18 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(false), 2), isOpen = ref18[0], setIsOpen = ref18[1];
    var dropdownRef = (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useRef */ .sO)(null);
    var ref19 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)([]), 2), departmentList = ref19[0], setDepartmentList = ref19[1];
    var ref20 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)([]), 2), jobTitleData = ref20[0], setJobTitleData = ref20[1];
    var ref21 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)({
        state: false,
        current_user_type: ""
    }), 2), privacyPolicyModal = ref21[0], setPrivacyPolicyModal = ref21[1];
    (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useEffect */ .d4)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
        var session, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .getSession */ .Gg)()
                    ];
                case 1:
                    session = _state.sent();
                    _tmp = {};
                    _tmp1 = {};
                    if (result.privacy_policy_created) {
                        if (action == "new") {
                            if (!initialValues.job.job_owner_emails.includes(result.job_owner.user_attributes.email) && (session === null || session === void 0 ? void 0 : session.role) != "Administrator") {
                                initialValues.job.job_owner_emails.push(result.job_owner.user_attributes.email);
                                initialValues.job.job_owner_initials.push((_tmp.email = result.job_owner.user_attributes.email, _tmp.photo_url = result.job_owner.user_attributes.photo_url, _tmp.name_initials = result.job_owner.user_attributes.name_initials, _tmp.name = result.job_owner.user_attributes.name, _tmp));
                            }
                            initialValues.job.approvers = {
                                emails: new Array(),
                                initials: new Array(),
                                required_approvers: ""
                            };
                        // setInitialJobOwners([...initialValues.job.job_owner_emails])
                        }
                    } else {
                        setPrivacyPolicyModal((_tmp1.state = true, _tmp1.current_user_type = session.role, _tmp1));
                    }
                    document.addEventListener("mousedown", handleClickOutside);
                    return [
                        2,
                        function() {
                            document.removeEventListener("mousedown", handleClickOutside);
                        }
                    ];
            }
        });
    }), []);
    var jobtitle = [];
    var jobindustries = (result === null || result === void 0 ? void 0 : result.industries) ? props.initialValues.job.is_old ? result === null || result === void 0 ? void 0 : result.industries.filter(function(item) {
        return [
            "previous",
            "combined"
        ].includes(item.type);
    }) : result.industries.filter(function(item) {
        return [
            "current",
            "combined"
        ].includes(item.type);
    }) : [];
    var salarychoice = (result === null || result === void 0 ? void 0 : result.salary_choices) ? result.salary_choices : [];
    var salaryduration = (result === null || result === void 0 ? void 0 : result.salary_duration) ? result.salary_duration : [];
    var currency = (result === null || result === void 0 ? void 0 : result.currencies) ? result.currencies : [];
    var seniority = (result === null || result === void 0 ? void 0 : result.seniority_levels) ? result.seniority_levels : [];
    var education = (result === null || result === void 0 ? void 0 : result.education) ? result.education : [];
    var location = (result === null || result === void 0 ? void 0 : result.location) ? result === null || result === void 0 ? void 0 : result.location : "";
    if (action == "new") {
        var ref22;
        initialValues.job.location_attributes.full_address = location;
        initialValues.job.location_attributes.place_id = "";
        initialValues.job.job_salary_detail_attributes.currency_id = (ref22 = currency[0]) === null || ref22 === void 0 ? void 0 : ref22.value;
    } else if (action == "edit") {
        var ref23;
        initialValues.job.job_title_name = ((ref23 = initialValues.job) === null || ref23 === void 0 ? void 0 : ref23.job_title) || "";
        if (!initialValues.job.location_attributes) {
            initialValues.job.location_attributes = {
                full_address: "",
                place_id: ""
            };
        }
        if (initialValues.job.contract_type == "contract") {
            var per_day = salaryduration.filter(function(x) {
                return x.value == "per_day";
            })[0];
            var others = salaryduration.filter(function(x) {
                return x.value != "per_day";
            });
            var values = [
                per_day
            ];
            others.map(function(x) {
                return values.push(x);
            });
            salaryduration = values;
        }
    }
    var ref24 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(((ref = currency.filter(function(x) {
        return x.value == initialValues.job.job_salary_detail_attributes.currency_id;
    })[0]) === null || ref === void 0 ? void 0 : ref.symbol) || ((ref1 = currency[0]) === null || ref1 === void 0 ? void 0 : ref1.symbol)), 2), currencySymbol = ref24[0], setCurrencySymbol = ref24[1];
    initialValues.job.step = current_step;
    var ref25 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(initialValues.job.job_title_name || initialValues.job.job_title || ""), 2), value = ref25[0], setJobTitle = ref25[1];
    var ref26 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)({
        option: [],
        data_fetch: false
    }), 2), jobTitleOptions = ref26[0], setJobTitleOptions = ref26[1];
    var ref27 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)({
        option: [],
        data_fetch: false
    }), 2), jobDepartmentOptions = ref27[0], setJobDepartmentOptions = ref27[1];
    var ref28 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(initialValues.job.status || "open"), 2), job_status = ref28[0], setJobStatus = ref28[1];
    var ref29 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(salaryInputs(initialValues.job.job_salary_detail_attributes.salary_choice)), 2), salaryInput = ref29[0], setSalaryInput = ref29[1];
    function getSuggestions(value) {
        return _getSuggestions.apply(this, arguments);
    }
    function _getSuggestions() {
        _getSuggestions = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(value) {
            var escapedValue, jobTitles;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        escapedValue = escapeRegexCharacters(value.trim());
                        if (escapedValue === "") {
                            return [
                                2,
                                []
                            ];
                        }
                        return [
                            4,
                            (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .getJobTitles */ .o$)(escapedValue, router)
                        ];
                    case 1:
                        jobTitles = _state.sent();
                        return [
                            2,
                            jobTitles
                        ];
                }
            });
        });
        return _getSuggestions.apply(this, arguments);
    }
    function onSuggestionsFetchRequested(_) {
        return _onSuggestionsFetchRequested.apply(this, arguments);
    }
    function _onSuggestionsFetchRequested() {
        _onSuggestionsFetchRequested = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(param) {
            var value, jobtitles, _tmp, filteredData, _tmp1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        value = param.value;
                        if (!!jobTitleOptions.data_fetch) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            getSuggestions(value)
                        ];
                    case 1:
                        jobtitles = _state.sent();
                        setJobTitleData(jobtitles);
                        _tmp = {};
                        setJobTitleOptions((_tmp.option = [], _tmp.data_fetch = true, _tmp));
                        _state.label = 2;
                    case 2:
                        filteredData = jobTitleData.filter(function(title) {
                            return title === null || title === void 0 ? void 0 : title.label.toLowerCase().includes(value.toLowerCase());
                        });
                        _tmp1 = {};
                        setJobTitleOptions((_tmp1.option = filteredData, _tmp1.data_fetch = true, _tmp1));
                        return [
                            2
                        ];
                }
            });
        });
        return _onSuggestionsFetchRequested.apply(this, arguments);
    }
    ;
    var onSuggestionsClearRequested = function() {
        setJobTitleOptions({
            option: [],
            data_fetch: jobTitleOptions.data_fetch
        });
    };
    var renderInputComponent = function(inputProps) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input */ .k2.Form__Input,
            autoComplete: "password"
        }, inputProps));
    };
    function getDepartmentSuggestions(value) {
        return _getDepartmentSuggestions.apply(this, arguments);
    }
    function _getDepartmentSuggestions() {
        _getDepartmentSuggestions = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(value) {
            var escapedValue, departments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        escapedValue = escapeRegexCharacters(value === null || value === void 0 ? void 0 : value.trim());
                        if (escapedValue === "") {
                            return [
                                2,
                                []
                            ];
                        }
                        return [
                            4,
                            (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .getDepartmentsList */ .By)(escapedValue, router)
                        ];
                    case 1:
                        departments = _state.sent();
                        return [
                            2,
                            departments
                        ];
                }
            });
        });
        return _getDepartmentSuggestions.apply(this, arguments);
    }
    function onDepartmentSuggestionsFetchRequested(_) {
        return _onDepartmentSuggestionsFetchRequested.apply(this, arguments);
    }
    function _onDepartmentSuggestionsFetchRequested() {
        _onDepartmentSuggestionsFetchRequested = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(param) {
            var value, options, _tmp, filteredData, _tmp1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        value = param.value;
                        if (!!jobDepartmentOptions.data_fetch) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            getDepartmentSuggestions(value)
                        ];
                    case 1:
                        options = _state.sent();
                        setDepartmentList(options);
                        _tmp = {};
                        setJobDepartmentOptions((_tmp.option = [], _tmp.data_fetch = true, _tmp));
                        _state.label = 2;
                    case 2:
                        filteredData = departmentList.filter(function(department) {
                            return department === null || department === void 0 ? void 0 : department.toLowerCase().includes(value.toLowerCase());
                        });
                        _tmp1 = {};
                        setJobDepartmentOptions((_tmp1.option = filteredData, _tmp1.data_fetch = true, _tmp1));
                        return [
                            2
                        ];
                }
            });
        });
        return _onDepartmentSuggestionsFetchRequested.apply(this, arguments);
    }
    ;
    var onDepartmentSuggestionsClearRequested = function() {
        setJobDepartmentOptions({
            option: [],
            data_fetch: jobDepartmentOptions.data_fetch
        });
    };
    var renderDepartmentInputComponent = function(inputProps) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input */ .k2.Form__Input,
            autoComplete: "password"
        }, inputProps));
    };
    var toggleDropdown = function() {
        setIsOpen(!isOpen);
    };
    var handleClickOutside = function(event) {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "Page NewJob ".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.NewJob */ .k2.NewJob, " job-form-section"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .BacktoAllJobs */ .tc, {
                        trigger: cancelPopup,
                        setCancelPopup: setCancelPopup,
                        setPageName: props.setPageName,
                        queryClient: queryClient,
                        formRef: formRef,
                        setSubmitState: setSubmitState,
                        save_as_draft: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.NewJob__Wrapper */ .k2.NewJob__Wrapper, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.NewJob__ContainerScroll */ .k2.NewJob__ContainerScroll, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.NewJob__ContainerHeight */ .k2.NewJob__ContainerHeight),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Formik */ .J9, {
                            initialValues: initialValues,
                            validationSchema: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .job_validation */ .aD)(submitState, job_status),
                            initialErrors: {},
                            innerRef: formRef,
                            onSubmit: function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(values, actions) {
                                    var ref, ref1, ref2, ref3, ref4, ref5, _tmp, errors;
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                values.job.job_salary_detail_attributes.min_salary = (ref2 = (ref = values.job.job_salary_detail_attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.min_salary) === null || ref1 === void 0 ? void 0 : ref1.toString()) === null || ref2 === void 0 ? void 0 : ref2.replaceAll(",", "");
                                                values.job.job_salary_detail_attributes.max_salary = (ref5 = (ref3 = values.job.job_salary_detail_attributes) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.max_salary) === null || ref4 === void 0 ? void 0 : ref4.toString()) === null || ref5 === void 0 ? void 0 : ref5.replaceAll(",", "");
                                                if (!(submitState == "draft" || submitState == "preview" && job_status != "active")) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .draftJob */ .M1)(values, router, current_step, props.setPageName, queryClient, setJobStatus, setDisabledSaveButton, formRef, submitState)
                                                ];
                                            case 1:
                                                _state.sent();
                                                _tmp = {};
                                                formRef.current.resetForm((_tmp.values = values, _tmp));
                                                return [
                                                    3,
                                                    5
                                                ];
                                            case 2:
                                                if (!(submitState == "preview")) return [
                                                    3,
                                                    3
                                                ];
                                                (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .previewJob */ .ao)(router, values.id);
                                                return [
                                                    3,
                                                    5
                                                ];
                                            case 3:
                                                return [
                                                    4,
                                                    (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .handleFormSubmit */ .xz)(values, router, t, props.setPageName, queryClient, formRef, fromKanban, gotoKanban, setDisabledSaveButton)
                                                ];
                                            case 4:
                                                errors = _state.sent();
                                                actions.setErrors(errors);
                                                _state.label = 5;
                                            case 5:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(values, actions) {
                                    return _ref.apply(this, arguments);
                                };
                            }(),
                            children: function(formik) {
                                var ref;
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
                                    className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form */ .k2.Form,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.NewJob__TopSection */ .k2.NewJob__TopSection),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.ClientCompany__BackSection */ .k2.ClientCompany__BackSection,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    onClick: function() {
                                                        if (fromKanban) {
                                                            router.push({
                                                                pathname: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.kanban_board.replace */ .RQ.client.kanban_board.replace("$job_id", jobId)
                                                            });
                                                        } else if (job_status.toLocaleLowerCase() == "open") {
                                                            setCancelPopup(true);
                                                        } else if (job_status.toLocaleLowerCase() == "draft") {
                                                            if (formik.dirty) setCancelPopup(true);
                                                            else router.push({
                                                                pathname: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.jobs.index */ .RQ.client.jobs.index,
                                                                query: {
                                                                    job_type: "active"
                                                                }
                                                            });
                                                        } else router.push({
                                                            pathname: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.jobs.index */ .RQ.client.jobs.index,
                                                            query: {
                                                                job_type: "active"
                                                            }
                                                        });
                                                    // goToNextPage('jobs', props.setPageName, queryClient, REDIRECT.client.jobs.index)
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .ArrowLeft */ .Xd, {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            children: fromKanban ? t("back:kanban") : t("back:all_jobs")
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.NewJob__ImportAction */ .k2.NewJob__ImportAction,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                                    className: " ".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.ClientCompany__Heading */ .k2.ClientCompany__Heading, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.ClientCompany__StatusAlignment */ .k2.ClientCompany__StatusAlignment, " m0"),
                                                    children: [
                                                        t("jobs:details:title_1"),
                                                        ":",
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.LightBlueColor */ .k2.LightBlueColor),
                                                            children: [
                                                                " ",
                                                                t("jobs:details:title_2"),
                                                                " "
                                                            ]
                                                        }),
                                                        (job_status == "active" || job_status == "archived") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.ClientCompany__Status */ .k2.ClientCompany__Status, " ml12"),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h5", {
                                                                className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.ClientCompany__StatusTag */ .k2.ClientCompany__StatusTag,
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .jobStatusBadge */ .OP)(job_status)
                                                                    }),
                                                                    job_status == "archived" ? t("tabs:archived") : t("tabs:active")
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .showImportPreviousJob */ .xi)(router, initialValues) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                    buttonstyle: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.secondarybtn */ .k2.secondarybtn, " buttonWithIcon"),
                                                    onClick: function() {
                                                        return setButtonPopup(true);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(public_icons_import_svg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
                                                        t("button:import:previous_job")
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mb32",
                                            children: job_status == "active" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.ClientCompany__Systemrefheding */ .k2.ClientCompany__Systemrefheding, " mr15"),
                                                children: [
                                                    t("jobs:system_ref"),
                                                    " : ",
                                                    (ref = initialValues.job) === null || ref === void 0 ? void 0 : ref.system_reference
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h4", {
                                            className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.ClientCompany__Subheading */ .k2.ClientCompany__Subheading,
                                            children: [
                                                t("jobs:details:subheading"),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form */ .k2.Form,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Table */ .k2.Form__Table,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableRow */ .k2.Form__TableRow,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oH)(formik, "job.job_title_name"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: "red-color",
                                                                                    children: "*"
                                                                                }),
                                                                                " ",
                                                                                t("jobs:details:input:job_title")
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                            control: "autosuggestInput",
                                                                            type: "text",
                                                                            errorClass: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            formik: formik,
                                                                            inputProps: {
                                                                                className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input */ .k2.Form__Input),
                                                                                formik: formik,
                                                                                name: "job.job_title_name",
                                                                                onChange: function(value, param) {
                                                                                    var newValue = param.newValue, method = param.method;
                                                                                    setJobTitle(newValue);
                                                                                    formik.setFieldValue("job.job_title_name", newValue);
                                                                                },
                                                                                placeholder: "e.g Product Designer",
                                                                                style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.job_title_name"),
                                                                                value: value,
                                                                                disabled: !editable
                                                                            },
                                                                            suggestions: jobTitleOptions.option,
                                                                            onSuggestionsFetchRequested: onSuggestionsFetchRequested,
                                                                            onSuggestionsClearRequested: onSuggestionsClearRequested,
                                                                            getSuggestionValue: getSuggestionValue,
                                                                            renderSuggestion: renderSuggestion,
                                                                            renderInputComponent: renderInputComponent,
                                                                            shouldRenderSuggestions: shouldRenderSuggestions,
                                                                            onSuggestionSelected: function(event, param) {
                                                                                var suggestion = param.suggestion;
                                                                            }
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                            control: "input",
                                                                            type: "text",
                                                                            formik: formik,
                                                                            /* placeholder     =   "Insert reference" */ name: "job.internal_reference",
                                                                            className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input */ .k2.Form__Input,
                                                                            errorClass: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.internal_reference"),
                                                                            disabled: !editable
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                            children: t("jobs:details:input:reference")
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableRow */ .k2.Form__TableRow, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.mt10 */ .k2.mt10),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: "red-color",
                                                                                    children: "*"
                                                                                }),
                                                                                " ",
                                                                                t("jobs:details:input:industry")
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__CustomSelect */ .k2.Form__CustomSelect, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.width100 */ .k2.width100),
                                                                            components: {
                                                                                Placeholder: Placeholder
                                                                            },
                                                                            control: "select",
                                                                            default: formik.values.job.industry_id,
                                                                            formik: formik,
                                                                            name: "job.industry_id",
                                                                            onChange: function(option) {
                                                                                return formik.setFieldValue("job.industry_id", option.value);
                                                                            },
                                                                            options: jobindustries,
                                                                            placeholder: t("placeholder:eg:financial"),
                                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.industry_id"),
                                                                            value: jobindustries.filter(function(option) {
                                                                                return option.value === formik.values.job.industry_id;
                                                                            }),
                                                                            disabled: !editable
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                            children: [
                                                                                " ",
                                                                                t("jobs:details:input:department")
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                            control: "autosuggestInput",
                                                                            type: "text",
                                                                            errorClass: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            formik: formik,
                                                                            inputProps: {
                                                                                className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input */ .k2.Form__Input),
                                                                                formik: formik,
                                                                                name: "job.department",
                                                                                onChange: function(value, param) {
                                                                                    var newValue = param.newValue, method = param.method;
                                                                                    // setJobTitle(newValue)
                                                                                    formik.setFieldValue("job.department", newValue);
                                                                                },
                                                                                placeholder: t("placeholder:eg:design"),
                                                                                style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.department"),
                                                                                value: formik.values.job.department || "",
                                                                                disabled: !editable
                                                                            },
                                                                            suggestions: jobDepartmentOptions.option,
                                                                            onSuggestionsFetchRequested: onDepartmentSuggestionsFetchRequested,
                                                                            onSuggestionsClearRequested: onDepartmentSuggestionsClearRequested,
                                                                            getSuggestionValue: getDepartmentSuggestionValue,
                                                                            renderSuggestion: renderDepartmentSuggestion,
                                                                            renderInputComponent: renderDepartmentInputComponent,
                                                                            shouldRenderSuggestions: shouldRenderSuggestions,
                                                                            onSuggestionSelected: function(event, param) {
                                                                                var suggestion = param.suggestion;
                                                                                console.log(suggestion);
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableRow */ .k2.Form__TableRow, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.mt10 */ .k2.mt10, " removeplaceholder"),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                        className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                className: "red-color",
                                                                                children: "*"
                                                                            }),
                                                                            " ",
                                                                            t("jobs:details:input:location"),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_simple_tooltip__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                                                className: "SimpleTooltip",
                                                                                content: t("tooltip:add_complete_address"),
                                                                                background: "#00325A",
                                                                                radius: 20,
                                                                                padding: 8,
                                                                                placement: "right",
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                                    className: "tooltipwidthinterview250 d-flex align-items-center",
                                                                                    children: [
                                                                                        "\xa0\xa0",
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Exclamation */ .P5, {})
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_places_autocomplete__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                                                        value: formik.values.job.location_attributes.full_address,
                                                                        onChange: function() {
                                                                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(value) {
                                                                                var ref, ref1, ref2;
                                                                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                                                                                    switch(_state.label){
                                                                                        case 0:
                                                                                            if (!((ref = formik.status) === null || ref === void 0 ? void 0 : (ref1 = ref.job) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.location_attributes) === null || ref2 === void 0 ? void 0 : ref2.full_address)) return [
                                                                                                3,
                                                                                                2
                                                                                            ];
                                                                                            delete formik.status.job.location_attributes.full_address;
                                                                                            delete formik.status.job.location_attributes;
                                                                                            return [
                                                                                                4,
                                                                                                formik.setStatus(formik.status)
                                                                                            ];
                                                                                        case 1:
                                                                                            _state.sent();
                                                                                            _state.label = 2;
                                                                                        case 2:
                                                                                            return [
                                                                                                4,
                                                                                                formik.setFieldValue("job.location_attributes.full_address", value)
                                                                                            ];
                                                                                        case 3:
                                                                                            _state.sent();
                                                                                            return [
                                                                                                4,
                                                                                                formik.setFieldValue("job.location_attributes.place_id", "")
                                                                                            ];
                                                                                        case 4:
                                                                                            _state.sent();
                                                                                            return [
                                                                                                2
                                                                                            ];
                                                                                    }
                                                                                });
                                                                            });
                                                                            return function(value) {
                                                                                return _ref.apply(this, arguments);
                                                                            };
                                                                        }(),
                                                                        onSelect: function(address, placeId, suggestion) {
                                                                            formik.setFieldValue("job.location_attributes.full_address", address);
                                                                            formik.setFieldValue("job.location_attributes.place_id", placeId);
                                                                        },
                                                                        shouldFetchSuggestions: shouldFetchSuggestions(formik),
                                                                        children: function(param) {
                                                                            var getInputProps = param.getInputProps, getSuggestionItemProps = param.getSuggestionItemProps, suggestions = param.suggestions, loading = param.loading;
                                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                className: "autocomplete-root",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                                                                                        className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input */ .k2.Form__Input,
                                                                                        disabled: formik.values.job.is_remote,
                                                                                        name: "job.location_attributes.full_address",
                                                                                        placeholder: t("placeholder:eg:postcode"),
                                                                                        style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.location_attributes.full_address")
                                                                                    }, getInputProps({
                                                                                        disabled: !editable
                                                                                    }))),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                        className: "autocomplete-dropdown-container",
                                                                                        children: [
                                                                                            loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                                children: [
                                                                                                    " ",
                                                                                                    t("loading"),
                                                                                                    " "
                                                                                                ]
                                                                                            }),
                                                                                            suggestions.map(function(suggestion) {
                                                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, getSuggestionItemProps(suggestion)), {
                                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                        children: suggestion.description
                                                                                                    }, suggestion.id)
                                                                                                }), suggestion.placeId);
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            });
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .AutocompleteError */ .PG, {
                                                                        name: "job.location_attributes.full_address",
                                                                        errorClass: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                        formik: formik,
                                                                        style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.location_attributes.full_address"),
                                                                        custom_error_90: "custom_error_90"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableRow */ .k2.Form__TableRow, " Dpflex justify-start"),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__CheckLabel */ .k2.Form__CheckLabel, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__LabelCheck */ .k2.Form__LabelCheck, " Mui__CustomCheckbox CheckLabelAlign mt0 wauto"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "Dpflex16",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Checkbox */ .XZ, {
                                                                                inputProps: {
                                                                                    "aria-label": "Checkbox A"
                                                                                },
                                                                                name: "job.is_remote",
                                                                                onChange: function(event) {
                                                                                    return handleIsRemote(event, formik);
                                                                                },
                                                                                style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.is_remote"),
                                                                                checked: formik.values.job.is_remote,
                                                                                disabled: !editable,
                                                                                icon: !editable ? formik.values.job.is_remote ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .SelectedDisabledCheckbox */ .t, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .DisabledCheckbox */ .g2, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .DefaultCheckbox */ .v0, {}),
                                                                                checkedIcon: !editable ? formik.values.job.is_remote ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .SelectedDisabledCheckbox */ .t, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .DisabledCheckbox */ .g2, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .CheckedCheckbox */ .bN, {})
                                                                            }),
                                                                            " ",
                                                                            t("jobs:details:input:remote")
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__CheckLabel */ .k2.Form__CheckLabel, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__LabelCheck */ .k2.Form__LabelCheck, " Mui__CustomCheckbox CheckLabelAlign mt0"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "Dpflex16",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Checkbox */ .XZ, {
                                                                                inputProps: {
                                                                                    "aria-label": "Checkbox A"
                                                                                },
                                                                                name: "job.is_hybrid",
                                                                                onChange: function(event) {
                                                                                    return handleIsHybrid(event, formik);
                                                                                },
                                                                                style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.is_hybrid"),
                                                                                checked: formik.values.job.is_hybrid,
                                                                                disabled: !editable,
                                                                                icon: !editable ? formik.values.job.is_hybrid ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .SelectedDisabledCheckbox */ .t, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .DisabledCheckbox */ .g2, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .DefaultCheckbox */ .v0, {}),
                                                                                checkedIcon: !editable ? formik.values.job.is_hybrid ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .SelectedDisabledCheckbox */ .t, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .DisabledCheckbox */ .g2, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .CheckedCheckbox */ .bN, {})
                                                                            }),
                                                                            " ",
                                                                            t("jobs:details:input:hybrid")
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableRow */ .k2.Form__TableRow, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.noDpGrid */ .k2.noDpGrid, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.mb12 */ .k2.mb12),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                        className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                className: "red-color",
                                                                                children: [
                                                                                    "*",
                                                                                    " "
                                                                                ]
                                                                            }),
                                                                            t("jobs:details:employment_type:heading")
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "wrapper",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
                                                                                type: "radio",
                                                                                name: "job.employment_type",
                                                                                id: "option-1",
                                                                                value: "full_time",
                                                                                disabled: !editable
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
                                                                                type: "radio",
                                                                                name: "job.employment_type",
                                                                                id: "option-2",
                                                                                value: "part_time",
                                                                                disabled: !editable
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
                                                                                type: "radio",
                                                                                name: "job.employment_type",
                                                                                id: "option-3",
                                                                                value: "either",
                                                                                disabled: !editable
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                                htmlFor: "option-1",
                                                                                className: "option option-1 ".concat((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .cursorNone */ .y$)(editable)),
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    children: t("jobs:details:employment_type:full_time")
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                                htmlFor: "option-2",
                                                                                className: "option option-2 ".concat((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .cursorNone */ .y$)(editable)),
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    children: t("jobs:details:employment_type:part_time")
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                                htmlFor: "option-3",
                                                                                className: "option option-3 ".concat((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .cursorNone */ .y$)(editable)),
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    children: t("jobs:details:employment_type:either")
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .AutocompleteError */ .PG, {
                                                                        name: "job.employment_type",
                                                                        errorClass: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                        formik: formik,
                                                                        style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.employment_type")
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableRow */ .k2.Form__TableRow, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.noDpGrid */ .k2.noDpGrid),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                        className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                className: "red-color",
                                                                                children: [
                                                                                    "*",
                                                                                    " "
                                                                                ]
                                                                            }),
                                                                            t("jobs:details:contract_type:heading")
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "wrapper2",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
                                                                                type: "radio",
                                                                                name: "job.contract_type",
                                                                                id: "option-4",
                                                                                value: "permanent",
                                                                                onChange: function(event) {
                                                                                    return onContractTypeChange(event, formik);
                                                                                },
                                                                                disabled: !editable
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
                                                                                type: "radio",
                                                                                name: "job.contract_type",
                                                                                id: "option-5",
                                                                                value: "contract",
                                                                                onChange: function(event) {
                                                                                    return onContractTypeChange(event, formik);
                                                                                },
                                                                                disabled: !editable
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
                                                                                type: "radio",
                                                                                name: "job.contract_type",
                                                                                id: "option-6",
                                                                                value: "temporary",
                                                                                onChange: function(event) {
                                                                                    return onContractTypeChange(event, formik);
                                                                                },
                                                                                disabled: !editable
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
                                                                                type: "radio",
                                                                                name: "job.contract_type",
                                                                                id: "option-7",
                                                                                value: "internship",
                                                                                onChange: function(event) {
                                                                                    return onContractTypeChange(event, formik);
                                                                                },
                                                                                disabled: !editable
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                                htmlFor: "option-4",
                                                                                className: "option option-4 ".concat((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .cursorNone */ .y$)(editable)),
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    children: t("jobs:details:contract_type:permanent")
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                                htmlFor: "option-5",
                                                                                className: "option option-5 ".concat((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .cursorNone */ .y$)(editable)),
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    children: t("jobs:details:contract_type:contract")
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                                htmlFor: "option-6",
                                                                                className: "option option-6 ".concat((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .cursorNone */ .y$)(editable)),
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    children: t("jobs:details:contract_type:temporary")
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                                htmlFor: "option-7",
                                                                                className: "option option-7 ".concat((0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .cursorNone */ .y$)(editable)),
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    children: t("jobs:details:contract_type:internship")
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .AutocompleteError */ .PG, {
                                                                        name: "job.contract_type",
                                                                        errorClass: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                        formik: formik,
                                                                        style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.contract_type")
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableRow */ .k2.Form__TableRow),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oH)(formik, "job.job_salary_detail_attributes.salary_choice"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: "red-color",
                                                                                    children: "*"
                                                                                }),
                                                                                "\xa0",
                                                                                t("jobs:details:input:salary_choice")
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__CustomSelect */ .k2.Form__CustomSelect, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.widthauto */ .k2.widthauto),
                                                                            components: {
                                                                                Placeholder: Placeholder
                                                                            },
                                                                            control: "select",
                                                                            default: formik.values.job.job_salary_detail_attributes.salary_choice,
                                                                            formik: formik,
                                                                            name: "job.job_salary_detail_attributes.salary_choice",
                                                                            onChange: function(option, event) {
                                                                                handleSalaryChoice(option, formik, event);
                                                                            },
                                                                            options: salarychoice,
                                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.job_salary_detail_attributes.salary_choice"),
                                                                            value: salarychoice.filter(function(option) {
                                                                                return option.value === formik.values.job.job_salary_detail_attributes.salary_choice;
                                                                            }),
                                                                            disabled: !editable
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "CurrencyDropdown ".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oH)(formik, "job.job_salary_detail_attributes.currency_id"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                    className: "red-color",
                                                                                    children: [
                                                                                        "*",
                                                                                        " "
                                                                                    ]
                                                                                }),
                                                                                t("jobs:details:input:currency")
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__CustomSelect */ .k2.Form__CustomSelect, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.widthauto */ .k2.widthauto),
                                                                            control: "select",
                                                                            default: formik.values.job.job_salary_detail_attributes.currency_id || currency[0].value,
                                                                            formik: formik,
                                                                            name: "job.job_salary_detail_attributes.currency_id",
                                                                            isCurrency: true,
                                                                            currencySymbol: currencySymbol,
                                                                            currencyClass: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__currency_symbol */ .k2.Form__currency_symbol,
                                                                            onChange: function(option) {
                                                                                setCurrencySymbol(option.symbol);
                                                                                formik.setFieldValue("job.job_salary_detail_attributes.currency_id", option.value);
                                                                            },
                                                                            options: currency,
                                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.job_salary_detail_attributes.currency_id"),
                                                                            disabled: !editable
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableRow3grid */ .k2.Form__TableRow3grid, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.mt10 */ .k2.mt10, " mb10"),
                                                            children: [
                                                                salaryInput.includes("min_salary") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oH)(formik, "job.job_salary_detail_attributes.min_salary"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                    className: "red-color",
                                                                                    children: [
                                                                                        "*",
                                                                                        " "
                                                                                    ]
                                                                                }),
                                                                                minSalaryLabel
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input_currency */ .k2.Form__Input_currency,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__currency_symbol */ .k2.Form__currency_symbol,
                                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.job_salary_detail_attributes.min_salary"),
                                                                                    disabled: !editable,
                                                                                    children: currencySymbol
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
                                                                                    component: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .NumberField */ .Ki,
                                                                                    placeholder: "e.g. 30,000",
                                                                                    type: "text",
                                                                                    name: "job.job_salary_detail_attributes.min_salary",
                                                                                    className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input */ .k2.Form__Input, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.width100 */ .k2.width100),
                                                                                    disabled: !editable,
                                                                                    formik: formik,
                                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.job_salary_detail_attributes.min_salary")
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .AutocompleteError */ .PG, {
                                                                            name: "job.job_salary_detail_attributes.min_salary",
                                                                            errorClass: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            formik: formik,
                                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.job_salary_detail_attributes.min_salary")
                                                                        })
                                                                    ]
                                                                }),
                                                                salaryInput.includes("max_salary") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oH)(formik, "job.job_salary_detail_attributes.max_salary"),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                    className: "red-color",
                                                                                    children: [
                                                                                        "*",
                                                                                        " "
                                                                                    ]
                                                                                }),
                                                                                maxSalaryLabel
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input_currency */ .k2.Form__Input_currency,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__currency_symbol */ .k2.Form__currency_symbol,
                                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.job_salary_detail_attributes.max_salary"),
                                                                                    disabled: !editable,
                                                                                    children: currencySymbol
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
                                                                                    component: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .NumberField */ .Ki,
                                                                                    type: "text",
                                                                                    placeholder: "e.g. 30,000",
                                                                                    name: "job.job_salary_detail_attributes.max_salary",
                                                                                    className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input */ .k2.Form__Input, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.width100 */ .k2.width100),
                                                                                    disabled: !editable,
                                                                                    formik: formik,
                                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.job_salary_detail_attributes.max_salary")
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .AutocompleteError */ .PG, {
                                                                            name: "job.job_salary_detail_attributes.max_salary",
                                                                            errorClass: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                            formik: formik,
                                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.job_salary_detail_attributes.max_salary")
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                    className: "red-color",
                                                                                    children: [
                                                                                        "*",
                                                                                        " "
                                                                                    ]
                                                                                }),
                                                                                t("jobs:details:input:salary_duration")
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__CustomSelect */ .k2.Form__CustomSelect, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.widthauto */ .k2.widthauto),
                                                                            control: "select",
                                                                            default: formik.values.job.job_salary_detail_attributes.salary_duration,
                                                                            formik: formik,
                                                                            name: "job.job_salary_detail_attributes.salary_duration",
                                                                            onChange: function(option) {
                                                                                return formik.setFieldValue("job.job_salary_detail_attributes.salary_duration", option.value);
                                                                            },
                                                                            options: salaryduration,
                                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.job_salary_detail_attributes.salary_duration"),
                                                                            value: salaryduration.filter(function(option) {
                                                                                return option.value === formik.values.job.job_salary_detail_attributes.salary_duration;
                                                                            }),
                                                                            disabled: !editable
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableRow */ .k2.Form__TableRow, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.mt10 */ .k2.mt10, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.noDpGrid */ .k2.noDpGrid, " mb20"),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.DpFlx */ .k2.DpFlx, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__CheckLabel */ .k2.Form__CheckLabel, " Dpflex16 Mui__CustomCheckbox"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Checkbox */ .XZ, {
                                                                            name: "job.job_salary_detail_attributes.salary_hidden",
                                                                            onChange: function(event) {
                                                                                return handleSalaryHidden(event, formik);
                                                                            },
                                                                            inputProps: {
                                                                                "aria-label": "Checkbox A"
                                                                            },
                                                                            checked: formik.values.job.job_salary_detail_attributes.salary_hidden,
                                                                            disabled: !editable,
                                                                            icon: !editable ? formik.values.job.job_salary_detail_attributes.salary_hidden ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .SelectedDisabledCheckbox */ .t, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .DisabledCheckbox */ .g2, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .DefaultCheckbox */ .v0, {}),
                                                                            checkedIcon: !editable ? formik.values.job.job_salary_detail_attributes.salary_hidden ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .SelectedDisabledCheckbox */ .t, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .DisabledCheckbox */ .g2, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .CheckedCheckbox */ .bN, {})
                                                                        }),
                                                                        " ",
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            children: t("jobs:details:input:hide_salary")
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        formik.values.job.job_salary_detail_attributes.salary_hidden && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableRow */ .k2.Form__TableRow, " mt25"),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol, " FieldError"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                        className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                        children: [
                                                                            " ",
                                                                            t("jobs:details:input:displayed_salary"),
                                                                            " * "
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                        className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input */ .k2.Form__Input,
                                                                        control: "input",
                                                                        name: "job.job_salary_detail_attributes.salary_displayed",
                                                                        placeholder: "",
                                                                        type: "text",
                                                                        formik: formik,
                                                                        style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.job_salary_detail_attributes.salary_displayed"),
                                                                        disabled: !editable
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableRow */ .k2.Form__TableRow,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oH)(formik, "job.seniority_level_id"),
                                                                            children: [
                                                                                t("jobs:details:input:seniority"),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_simple_tooltip__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                                                    className: "SimpleTooltip",
                                                                                    content: t("tooltip:select_job_role"),
                                                                                    background: "#00325A",
                                                                                    radius: 20,
                                                                                    padding: 8,
                                                                                    placement: "top",
                                                                                    fontSize: "12px",
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                                        className: "tooltipwidthinterview140 d-flex align-items-center",
                                                                                        children: [
                                                                                            "\xa0",
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Exclamation */ .P5, {})
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__CustomSelect */ .k2.Form__CustomSelect, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.widthauto */ .k2.widthauto),
                                                                            components: {
                                                                                Placeholder: Placeholder
                                                                            },
                                                                            control: "select",
                                                                            default: formik.values.job.seniority_level_id || "",
                                                                            formik: formik,
                                                                            name: "job.seniority_level_id",
                                                                            onChange: function(option) {
                                                                                return formik.setFieldValue("job.seniority_level_id", option.value);
                                                                            },
                                                                            options: seniority,
                                                                            placeholder: t("tooltip:select_job_role"),
                                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.seniority_level_id"),
                                                                            value: seniority.filter(function(option) {
                                                                                return option.value === formik.values.job.seniority_level_id;
                                                                            }),
                                                                            disabled: !editable
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oH)(formik, "job.education"),
                                                                            children: [
                                                                                " ",
                                                                                t("jobs:details:input:education"),
                                                                                " ",
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_simple_tooltip__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                                                    className: "SimpleTooltip",
                                                                                    content: t("tooltip:min_education"),
                                                                                    background: "#00325A",
                                                                                    radius: 20,
                                                                                    padding: 8,
                                                                                    placement: "top",
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                                        className: "tooltipwidthinterview200 d-flex align-items-center",
                                                                                        children: [
                                                                                            "\xa0",
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Exclamation */ .P5, {})
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__CustomSelect */ .k2.Form__CustomSelect, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.widthauto */ .k2.widthauto),
                                                                            components: {
                                                                                Placeholder: Placeholder
                                                                            },
                                                                            control: "select",
                                                                            default: formik.values.job.education || "",
                                                                            formik: formik,
                                                                            name: "job.education",
                                                                            onChange: function(option) {
                                                                                return formik.setFieldValue("job.education", option.value);
                                                                            },
                                                                            options: education,
                                                                            placeholder: t("tooltip:min_education"),
                                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.education"),
                                                                            value: education.filter(function(option) {
                                                                                return option.value === formik.values.job.education;
                                                                            }),
                                                                            disabled: !editable
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableRow */ .k2.Form__TableRow, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.mt30 */ .k2.mt30, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.noDpGrid */ .k2.noDpGrid),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "d-flex justify-content-between AlignFlexEnd",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label)
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "Generate_with_ai__button mb16",
                                                                            ref: dropdownRef,
                                                                            children: [
                                                                                result.ai_access && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                                                    buttonstyle: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.primarybtn */ .ZJ.primarybtn, " wauto mlAuto  mb0"),
                                                                                    type: "button",
                                                                                    onClick: toggleDropdown,
                                                                                    children: t("button:generate_with_ai")
                                                                                }),
                                                                                isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                    className: "Generate_with_ai__dropdown removeplaceholder",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                            className: "w100 Generate_select ".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol, " mb25"),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                                                    className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                                                    children: t("jobs:details:input:tone_of_voice")
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                                                    className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__CustomSelect */ .k2.Form__CustomSelect, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.widthauto */ .k2.widthauto),
                                                                                                    components: {
                                                                                                        Placeholder: Placeholder
                                                                                                    },
                                                                                                    control: "select",
                                                                                                    formik: formik,
                                                                                                    default: descriptionModal.data.tone_of_voice || "",
                                                                                                    name: "tone_of_voice",
                                                                                                    onChange: function(option, event) {
                                                                                                        descriptionModal.data.tone_of_voice = option.value;
                                                                                                        setDescriptionModal(descriptionModal);
                                                                                                    },
                                                                                                    options: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .toneOfVoiceList */ .xQ)(t),
                                                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "tone_of_voice")
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                            className: "w100 Generate_select ".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol, " mb30"),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                                                                    className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                                                    children: t("jobs:details:input:language")
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                                                    className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__CustomSelect */ .k2.Form__CustomSelect, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.widthauto */ .k2.widthauto),
                                                                                                    components: {
                                                                                                        Placeholder: Placeholder
                                                                                                    },
                                                                                                    control: "select",
                                                                                                    formik: formik,
                                                                                                    default: descriptionModal.data.language || "",
                                                                                                    name: "language",
                                                                                                    onChange: function(option, event) {
                                                                                                        descriptionModal.data.language = option.value;
                                                                                                        setDescriptionModal(descriptionModal);
                                                                                                    },
                                                                                                    options: languageList(t),
                                                                                                    style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "language")
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                            className: "w100 d-flex justify-content-end mt32",
                                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                                                type: "button",
                                                                                                className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.GoBtn */ .k2.GoBtn),
                                                                                                onClick: function() {
                                                                                                    (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .canGenerateDescription */ .q$)(formik, descriptionModal, setDescriptionModal, router, setShowLoader, setIsOpen);
                                                                                                },
                                                                                                children: t("button:go")
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                    className: "red-color",
                                                                                    children: [
                                                                                        "*",
                                                                                        " "
                                                                                    ]
                                                                                }),
                                                                                t("jobs:details:description")
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                            selector: "#job_description",
                                                                            apiKey: "dxe0l6rdhdta2rzyfq2io208ncq1ay4l9wc2vyre3a53sdna",
                                                                            control: "customEditor",
                                                                            formik: formik,
                                                                            onInit: function(evt, editor) {
                                                                                return editorRef.current = editor;
                                                                            },
                                                                            textareaName: "job.description",
                                                                            style: (0,_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "job.description"),
                                                                            value: formik.values.job.description,
                                                                            onEditorChange: function(value) {
                                                                                formik.setFieldValue("job.description", value);
                                                                            },
                                                                            disabled: !editable,
                                                                            init: {
                                                                                height: 250,
                                                                                menubar: false,
                                                                                resize: false,
                                                                                readOnly: !editable,
                                                                                plugins: [
                                                                                    "advlist",
                                                                                    "autolink",
                                                                                    "lists",
                                                                                    "link",
                                                                                    "image",
                                                                                    "charmap",
                                                                                    "preview",
                                                                                    "anchor",
                                                                                    "searchreplace",
                                                                                    "visualblocks",
                                                                                    "code",
                                                                                    "fullscreen",
                                                                                    "insertdatetime",
                                                                                    "media",
                                                                                    "table",
                                                                                    "help",
                                                                                    "wordcount",
                                                                                    "textcolor"
                                                                                ],
                                                                                toolbar: "undo redo | fontfamily | blocks | " + "bold italic backcolor forecolor | link | alignleft aligncenter " + "alignright alignjustify | bullist numlist outdent indent | " + "removeformat | help",
                                                                                link_target_list: false,
                                                                                content_style: "@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap'); body { font-family:Arial; font-size:14px }",
                                                                                forced_root_block: "div",
                                                                                font_family_formats: "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Poppins=poppins; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats"
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableRow */ .k2.Form__TableRow, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableRowMB */ .k2.Form__TableRowMB, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.mt30 */ .k2.mt30, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.mb0 */ .k2.mb0, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.noDpGrid */ .k2.noDpGrid),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.DpFlx */ .k2.DpFlx, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__CheckLabel */ .k2.Form__CheckLabel, " Dpflex16 Mui__CustomCheckbox"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Checkbox */ .XZ, {
                                                                            name: "job.without_cv",
                                                                            inputProps: {
                                                                                "aria-label": "Checkbox A"
                                                                            },
                                                                            checked: formik.values.job.without_cv,
                                                                            onChange: function(event) {
                                                                                return handleWithoutCV(event, formik);
                                                                            },
                                                                            disabled: !editable,
                                                                            icon: !editable ? formik.values.job.without_cv ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .SelectedDisabledCheckbox */ .t, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .DisabledCheckbox */ .g2, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .DefaultCheckbox */ .v0, {}),
                                                                            checkedIcon: !editable ? formik.values.job.without_cv ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .SelectedDisabledCheckbox */ .t, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .DisabledCheckbox */ .g2, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .CheckedCheckbox */ .bN, {})
                                                                        }),
                                                                        " ",
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "CheckLabelAlign mt0",
                                                                            children: t("jobs:details:input:without_cv")
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.NewJob__SubmitSection */ .k2.NewJob__SubmitSection, " ").concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.NewJob__Interview_buttons */ .k2.NewJob__Interview_buttons),
                                                    children: editable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                                buttonstyle: "".concat(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.nobgbutton */ .ZJ.nobgbutton, " "),
                                                                type: "button",
                                                                onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
                                                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    setSubmitState("preview")
                                                                                ];
                                                                            case 1:
                                                                                _state.sent();
                                                                                setTimeout(function() {
                                                                                    formik.submitForm();
                                                                                }, 50);
                                                                                return [
                                                                                    2
                                                                                ];
                                                                        }
                                                                    });
                                                                }),
                                                                children: t("button:preview_job")
                                                            }),
                                                            [
                                                                "open",
                                                                "draft"
                                                            ].includes(job_status.toLocaleLowerCase()) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                                buttonstyle: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.secondarybtn */ .ZJ.secondarybtn,
                                                                type: "button",
                                                                onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
                                                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    setSubmitState("draft")
                                                                                ];
                                                                            case 1:
                                                                                _state.sent();
                                                                                setTimeout(function() {
                                                                                    formik.submitForm();
                                                                                }, 50);
                                                                                return [
                                                                                    2
                                                                                ];
                                                                        }
                                                                    });
                                                                }),
                                                                children: t("button:save_as_draft")
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                                buttonstyle: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.secondarybtn */ .ZJ.secondarybtn,
                                                                type: "button",
                                                                disabled: disabledSaveButton,
                                                                onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
                                                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                setGotoKanban(true);
                                                                                return [
                                                                                    4,
                                                                                    setSubmitState("submit")
                                                                                ];
                                                                            case 1:
                                                                                _state.sent();
                                                                                setTimeout(function() {
                                                                                    formik.submitForm();
                                                                                    showErrorAlert(formik);
                                                                                }, 50);
                                                                                return [
                                                                                    2
                                                                                ];
                                                                        }
                                                                    });
                                                                }),
                                                                children: t("button:save")
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                                buttonstyle: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.primarybtn */ .ZJ.primarybtn,
                                                                type: "button",
                                                                disabled: disabledSaveButton,
                                                                onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
                                                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                setGotoKanban(false);
                                                                                return [
                                                                                    4,
                                                                                    setSubmitState("submit")
                                                                                ];
                                                                            case 1:
                                                                                _state.sent();
                                                                                setTimeout(function() {
                                                                                    formik.submitForm();
                                                                                    showErrorAlert(formik);
                                                                                }, 50);
                                                                                return [
                                                                                    2
                                                                                ];
                                                                        }
                                                                    });
                                                                }),
                                                                children: t("button:next_step")
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "#",
                                                                className: "preview-job-link dnone",
                                                                target: "_blank"
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                style: {
                                                                    visibility: "hidden"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                                buttonstyle: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .ButtonStyle.primarybtn */ .ZJ.primarybtn,
                                                                type: "button",
                                                                onClick: function() {
                                                                    var ref;
                                                                    return router.push(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.jobs.job_options.replace */ .RQ.client.jobs.job_options.replace("$job_id", (ref = initialValues.job) === null || ref === void 0 ? void 0 : ref.id));
                                                                },
                                                                children: t("button:next_step")
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .SelectJobModal */ .A9, {
                setButtonPopup: setButtonPopup,
                buttonPopup: buttonPopup,
                setShowLoader: setShowLoader
            }),
            showLoader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .Loading */ .gb, {}),
            privacyPolicyModal.state && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_modal_modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                type: "confirmation",
                ButtonWidth: true,
                message: privacyPolicyModal.current_user_type == "client_user" ? t("modal:privacy_policy_modal_message:client_user_message") : t("modal:privacy_policy_modal_message:admin_message"),
                closeModal: function() {
                    router.push({
                        pathname: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.jobs.index */ .RQ.client.jobs.index,
                        query: {
                            job_type: "Active"
                        }
                    });
                    setPrivacyPolicyModal({
                        state: false,
                        current_user_type: ""
                    });
                },
                btnAction: function() {
                    if (privacyPolicyModal.current_user_type == "client_user") {
                        router.push({
                            pathname: _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.jobs.index */ .RQ.client.jobs.index,
                            query: {
                                job_type: "Active"
                            }
                        });
                        setPrivacyPolicyModal({
                            state: false,
                            current_user_type: ""
                        });
                    } else {
                        var link = _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .REDIRECT.client.settings.data_privacy.privacy_policy */ .RQ.client.settings.data_privacy.privacy_policy;
                        var params = {
                            policy_setup: true
                        };
                        router.push({
                            pathname: link,
                            query: params
                        });
                    }
                },
                texts: {
                    button2_text: privacyPolicyModal.current_user_type == "client_user" ? t("modal:privacy_policy_modal_message:client_user_button_text") : t("modal:privacy_policy_modal_message:admin_button_text")
                }
            })
        ]
    });
}
JobForm.layout = _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_1__/* .ClientDashboard */ .LD;
/* harmony default export */ __webpack_exports__["default"] = (JobForm);


/***/ }),

/***/ 6967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ new_edit_scorecard; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(18186);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/jobs/automations.js + 3 modules
var automations = __webpack_require__(64335);
// EXTERNAL MODULE: ./src/styles/pages/clients/scorecards/_index.module.scss
var _index_module = __webpack_require__(90837);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/styles/pages/clients/edit_scorecard/_index.module.scss
var edit_scorecard_index_module = __webpack_require__(70587);
var edit_scorecard_index_module_default = /*#__PURE__*/__webpack_require__.n(edit_scorecard_index_module);
// EXTERNAL MODULE: ./public/icons/close.png
var icons_close = __webpack_require__(22700);
// EXTERNAL MODULE: ./public/icons/close.svg
var public_icons_close = __webpack_require__(85155);
// EXTERNAL MODULE: ./public/icons/arrowleft.svg
var arrowleft = __webpack_require__(65661);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
;// CONCATENATED MODULE: ./public/images/pages/scorecard/download-icon.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgDownloadIcon = function SvgDownloadIcon(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0 0h16v16H0z"
  }), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M13 12v2H3v-2H2v2a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-2h-1ZM13 7l-.705-.705-3.795 3.79V1h-1v9.085l-3.795-3.79L3 7l5 5 5-5Z",
    fill: "var(--default-text-color)"
  })));
};

/* harmony default export */ var download_icon = (SvgDownloadIcon);
// EXTERNAL MODULE: ./src/actions/common/input-error.js
var input_error = __webpack_require__(54911);
// EXTERNAL MODULE: ./src/actions/common/go-to-next-page.js
var go_to_next_page = __webpack_require__(81067);
// EXTERNAL MODULE: ./src/actions/components/sidebar.js + 1 modules
var sidebar = __webpack_require__(39826);
// EXTERNAL MODULE: ./src/actions/components/modal/add-scorecard-action.js + 2 modules
var add_scorecard_action = __webpack_require__(17523);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/scorecards.js
var scorecards = __webpack_require__(44059);
// EXTERNAL MODULE: ./src/services/pages/clients/jobs/scorecards.js
var jobs_scorecards = __webpack_require__(76275);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/constants/pages/clients/jobs/scorecards.js
var clients_jobs_scorecards = __webpack_require__(40682);
// EXTERNAL MODULE: ./src/constants/common/jobs-steps.js
var jobs_steps = __webpack_require__(46680);
// EXTERNAL MODULE: ./src/constants/components/sidebar.js
var components_sidebar = __webpack_require__(73257);
// EXTERNAL MODULE: ./src/pages/clients/jobs/back-all-jobs-modal.js
var back_all_jobs_modal = __webpack_require__(92867);
// EXTERNAL MODULE: ../../shared/node_modules/react-autosuggest/dist/index.js
var dist = __webpack_require__(46921);
// EXTERNAL MODULE: ./src/layouts/ClientDashboard.js
var ClientDashboard = __webpack_require__(71234);
// EXTERNAL MODULE: ./src/components/jobScorecardComponent/createJobAddScorecardLinkComponent.js + 1 modules
var createJobAddScorecardLinkComponent = __webpack_require__(95538);
// EXTERNAL MODULE: ./src/components/jobScorecardComponent/createJobScorecardComponent.js + 3 modules
var createJobScorecardComponent = __webpack_require__(70336);
// EXTERNAL MODULE: ./src/components/modals/scorecard-import-modal.js + 2 modules
var scorecard_import_modal = __webpack_require__(37111);
// EXTERNAL MODULE: ./src/actions/pages/clients/jobs/common.js
var jobs_common = __webpack_require__(90432);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/jobs/new-edit-scorecard.js

//--------------------StyleSheet -------------------



//--------------------StyleSheet -------------------
//-------------------Image --------------------




//-------------------Image --------------------
//-------------------Actions --------------------





//-------------------Actions --------------------



//-------------------Constant --------------------



//-------------------Constant --------------------
//-------------------Components --------------------






//-------------------Components --------------------
 // export { default as JobPreviewPage } from '@/pages/clients/dashboard/jobs/job-preview'

// EXTERNAL MODULE: ./src/actions/common/competencyName/getCompetencySubCompetencyName.js
var getCompetencySubCompetencyName = __webpack_require__(12448);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/jobs/candidate-profile-job.js + 9 modules
var candidate_profile_job = __webpack_require__(51895);
// EXTERNAL MODULE: ../../shared/node_modules/react-rating/lib/react-rating.esm.js
var react_rating_esm = __webpack_require__(82520);
// EXTERNAL MODULE: ./public/icons/info.svg
var info = __webpack_require__(35150);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/rating1.svg
var rating1 = __webpack_require__(62199);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/rating2.svg
var rating2 = __webpack_require__(60498);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/rating3.svg
var rating3 = __webpack_require__(70880);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/rating4.svg
var rating4 = __webpack_require__(42876);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/rating5.svg
var rating5 = __webpack_require__(56795);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/sub-rating1.svg
var sub_rating1 = __webpack_require__(30327);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/sub-rating2.svg
var sub_rating2 = __webpack_require__(75818);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/sub-rating3.svg
var sub_rating3 = __webpack_require__(42307);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/sub-rating4.svg
var sub_rating4 = __webpack_require__(73589);
// EXTERNAL MODULE: ./public/images/pages/scorecard/ratings/sub-rating5.svg
var sub_rating5 = __webpack_require__(48542);
;// CONCATENATED MODULE: ./src/pages/clients/dashboard/jobs/new-edit-scorecard.js













// Sub Competency Icons





function NewEditScorecard(props) {
    var getScoreColor = function getScoreColor(score, isLight) {
        var scoreValue = parseFloat(score);
        if (scoreValue == NaN) return isLight ? "LightRedBg" : "RedBg";
        else if (scoreValue <= 2) return isLight ? "LightRedBg" : "RedBg";
        else if (scoreValue > 2 && scoreValue < 4) return isLight ? "LightYellowBg" : "YellowBg";
        else if (scoreValue >= 4) return isLight ? "LightGreenBg" : "GreenBg";
        else return isLight ? "LightRedBg" : "RedBg";
    };
    var pageBreakIndex = function pageBreakIndex(index, subIndex, gIndex) {
        return "pagebreaks";
    // return (subIndex % 3 == 0) ? 'pagebreaks' : 'nopagebreak'
    // if(index == 0){
    //   return subIndex == 0 ? 'nopagebreak' : ((subIndex) % 3 == 0 ? 'pagebreaks' : '')
    // }else{
    //   return subIndex == 1 ? 'nopagebreak' : (subIndex == 2 ? '' : (subIndex+2) % 3 == 0 ? 'pagebreaks' : '')
    // }
    };
    var pageBreak = function pageBreak() {
        gIndex = gIndex + 1;
        return gIndex % 3 == 0 ? "pagebreak" : "";
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), competencies = ref[0], setCompetencies = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(""), 2), competenciesCount = ref1[0], setCompetenciesCount = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)("open"), 2), job_status = ref2[0], setJobStatus = ref2[1];
    var router = (0,common/* useRouter */.tv)();
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(true), 2), isLoading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(""), 2), initialValues = ref4[0], setInitialValues = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), cancelPopup = ref5[0], setCancelPopup = ref5[1];
    var queryClient = (0,common/* useQueryClient */.NL)();
    var current_step = common/* JOB_STEPS.SCORECARDS */.l.SCORECARDS;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(""), 2), submitState = ref6[0], setSubmitState = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)({}), 2), jobPreview = ref7[0], setJobPreivew = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), showLoader = ref8[0], setShowLoader = ref8[1];
    var sidebarAction = new sidebar/* SidebarAction */.D(queryClient, router);
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), scoreCardImport = ref9[0], setScoreCardImport = ref9[1];
    var ref10 = (0,common/* useTranslation */.$G)(), t = ref10.t, i18n = ref10.i18n;
    var jobId = new common/* DataFromUrl */.QJ().getJobId();
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), gotoKanban = ref11[0], setGotoKanban = ref11[1];
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), flagForRender = ref12[0], setFlagForRender = ref12[1];
    var fromKanban = router.query.from_kanban ? true : false;
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(true), 2), editable = ref13[0], setEditable = ref13[1];
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), disabledSaveButton = ref14[0], setDisabledSaveButton = ref14[1];
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), submitButtonDisabled = ref15[0], setSubmitButtonDisabled = ref15[1];
    var formRef = (0,common/* useRef */.sO)();
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(), 2), clientId = ref16[0], setClientId = ref16[1];
    var scorecardAction = new scorecards/* ScorecardAction */.qz(formRef, initialValues, setFlagForRender);
    var addScorecardAction = new add_scorecard_action/* AddScorecardAction */.q(router);
    var getNameFromHash = new getCompetencySubCompetencyName/* GetNameFromHash */.K();
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), isDirtyArray = ref17[0], setDirtyArray = ref17[1];
    var gIndex = 0;
    (0,common/* useEffect */.d4)(function() {
        setLoading(false);
    }, [
        props.selectScorecardIndex,
        props.flagForRender
    ]);
    if (isLoading) {
        return null;
    }
    var renderInputComponent = function(inputProps) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
            className: (_index_module_default()).Form__Input,
            autoComplete: "password"
        }, inputProps));
    };
    var radiusClass = function(competencyCount) {
        return competencyCount > 0 ? "" : (edit_scorecard_index_module_default()).Radius32;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "DashboardPageContent",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* motion.div */.EA.div, {
                initial: "pageInitial",
                animate: "pageAnimate",
                exit: "pageExit",
                variants: common/* PAGE_ANIMATION_OPTIONS */.Mf,
                transition: {
                    delay: 0.2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "Page Score ".concat((_index_module_default()).Scorecards, " job-form-section"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(back_all_jobs_modal["default"], {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((_index_module_default()).NewJob__Container, " ").concat((edit_scorecard_index_module_default()).EditContainer),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Formik */.J9, {
                                    initialValues: addScorecardAction.setFormInitialValues(props.initialData, props.selectScorecardIndex),
                                    innerRef: formRef,
                                    onSubmit: function(values) {
                                        addScorecardAction.submitForm(values, props.setShowScorecardPopup, props.setFlagForRerender, props, setSubmitButtonDisabled, candidate_profile_job/* hideAddScorecard */.$l, setShowLoader);
                                    },
                                    children: function(formik) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Form */.l0, {
                                            className: (_index_module_default()).Form,
                                            children: [
                                                !props.isPublic && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((edit_scorecard_index_module_default()).CreateScoreCard__TopSection, " noprint"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((_index_module_default()).ClientCompany__BackSection, " wauto"),
                                                            onClick: function() {
                                                                props.setSelectScorecardIndex(undefined);
                                                                setLoading(true);
                                                                (0,candidate_profile_job/* hideAddScorecard */.$l)();
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(arrowleft/* default */.Z, {}),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: t("back:candidate_profile")
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (edit_scorecard_index_module_default()).CreateScoreCard__DownloadAndSubmit,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Button */.zx, {
                                                                    buttonstyle: "".concat(common/* ButtonStyle.secondarybtnborder */.ZJ.secondarybtnborder, " buttonWithIcon ").concat((edit_scorecard_index_module_default()).DownloadBtn),
                                                                    onClick: function() {
                                                                        window.print();
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(download_icon, {}),
                                                                        t("download:pdf")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                                                    buttonstyle: "".concat(common/* ButtonStyle.primarybtn */.ZJ.primarybtn, " ml16"),
                                                                    onClick: function() {
                                                                        return formRef.current.submitForm();
                                                                    },
                                                                    children: t("button:submit")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((_index_module_default()).ClientCompany__FormSection),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((edit_scorecard_index_module_default()).ClientCompany__FormSection),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((edit_scorecard_index_module_default()).ClientCompany__LeftContent),
                                                            children: [
                                                                !props.isPublic && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                    className: " ".concat((edit_scorecard_index_module_default()).ClientCompany__SmallHeading, " ").concat((_index_module_default()).ClientCompany__StatusAlignment, " noprint"),
                                                                    children: typeof props.selectScorecardIndex != "undefined" ? t("modal:form:scorecard:edit") : t("modal:form:scorecard:new")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                                    className: " ".concat((edit_scorecard_index_module_default()).ClientCompany__Heading, " ").concat((_index_module_default()).LightBlueColor, " ").concat((_index_module_default()).ClientCompany__StatusAlignment, " mb0"),
                                                                    children: props.initialData.application.name
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                                    className: " ".concat((edit_scorecard_index_module_default()).ClientCompany__Heading, " ").concat((_index_module_default()).ClientCompany__StatusAlignment, " ").concat((edit_scorecard_index_module_default()).ClientCompany__JobTitleHeading, " mt10 mb0 printData displaynone"),
                                                                    children: props.initialData.application.job_title
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w100 mt35",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((edit_scorecard_index_module_default()).CreateScoreCard),
                                                        children: formik.values.scorecard.score_hash.map(function(competency, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat((edit_scorecard_index_module_default()).CreateScoreCard__Card),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat((edit_scorecard_index_module_default()).LightBox),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "".concat((edit_scorecard_index_module_default()).LightBox__Competency, " ").concat(radiusClass(competency.job_sub_competencies.length), " ").concat(pageBreak()),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "".concat((edit_scorecard_index_module_default()).LeftContent),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "".concat((edit_scorecard_index_module_default()).CompetencyNotes),
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                                                children: getNameFromHash.getCompetencyName(competency.job_competency_id, props.initialData.competencies)
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                children: getNameFromHash.getCompetencyNotes(competency.job_competency_id, props.initialData.competencies)
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "".concat((edit_scorecard_index_module_default()).RightContent),
                                                                                    children: [
                                                                                        competency.job_sub_competencies.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "".concat((edit_scorecard_index_module_default()).AverageScore, " noprint"),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    children: t("modal:form:scorecard:avg_score")
                                                                                                }),
                                                                                                addScorecardAction.calculateOverallScore(competency.job_sub_competencies) != 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                    className: "".concat((edit_scorecard_index_module_default()).AverageScore__Value, " ").concat(addScorecardAction.getOverallScoreColor(competency.job_sub_competencies), " "),
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                        className: "Average__Score",
                                                                                                        children: addScorecardAction.calculateOverallScore(competency.job_sub_competencies)
                                                                                                    })
                                                                                                }) : "--"
                                                                                            ]
                                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "".concat((edit_scorecard_index_module_default()).Rating, " CompetencyScorecardRating CompetencyScorecardRating_").concat(index, " noprint"),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_rating_esm/* default */.Z, {
                                                                                                    onHover: function(value) {
                                                                                                        addScorecardAction.colorHoverRatingSymbolArray(value, "CompetencyScorecardRating_".concat(index), "competency_color", formik.values.scorecard.score_hash[index].score);
                                                                                                    },
                                                                                                    onChange: function(value) {
                                                                                                        addScorecardAction.onChangeRating("scorecard.score_hash.".concat(index, ".score"), formik, value, "CompetencyScorecardRating_".concat(index), "competency_color");
                                                                                                    },
                                                                                                    emptySymbol: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(rating1/* default */.Z, {}),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(rating2/* default */.Z, {}),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(rating3/* default */.Z, {}),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(rating4/* default */.Z, {}),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(rating5/* default */.Z, {})
                                                                                                    ].map(function(rating) {
                                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                            className: "".concat((_index_module_default()).Modal__Card__Rating, " EmptyRating"),
                                                                                                            children: rating
                                                                                                        });
                                                                                                    }),
                                                                                                    fullSymbol: addScorecardAction.initalArray(formik.values.scorecard.score_hash[index].score, "competency").map(function(fillRating) {
                                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                            className: "".concat((_index_module_default()).Modal__Card__Rating, " FillRating"),
                                                                                                            children: fillRating
                                                                                                        });
                                                                                                    }),
                                                                                                    initialRating: formik.values.scorecard.score_hash[index].score
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                    className: "".concat((edit_scorecard_index_module_default()).PoorExcellentText),
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                            className: "".concat((edit_scorecard_index_module_default()).PoorExcellentText__LeftContent, " w100"),
                                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                children: t("modal:form:scorecard:poor")
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                            className: "".concat((edit_scorecard_index_module_default()).PoorExcellentText__RightContent, " w100"),
                                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                children: t("modal:form:scorecard:excellent")
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        competency.job_sub_competencies.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "".concat((edit_scorecard_index_module_default()).AverageScore, " printData displaynone"),
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                children: t("modal:form:scorecard:avg_score")
                                                                                            })
                                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "".concat((edit_scorecard_index_module_default()).Rating, " CompetencyScorecardRating CompetencyScorecardRating_").concat(index, " printData displaynone"),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_rating_esm/* default */.Z, {
                                                                                                    onHover: function(value) {
                                                                                                        addScorecardAction.colorHoverRatingSymbolArray(value, "CompetencyScorecardRating_".concat(index), "competency_color", formik.values.scorecard.score_hash[index].score);
                                                                                                    },
                                                                                                    onChange: function(value) {
                                                                                                        addScorecardAction.onChangeRating("scorecard.score_hash.".concat(index, ".score"), formik, value, "CompetencyScorecardRating_".concat(index), "competency_color");
                                                                                                    },
                                                                                                    emptySymbol: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(rating1/* default */.Z, {}),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(rating2/* default */.Z, {}),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(rating3/* default */.Z, {}),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(rating4/* default */.Z, {}),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(rating5/* default */.Z, {})
                                                                                                    ].map(function(rating) {
                                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                            className: "".concat((_index_module_default()).Modal__Card__Rating, " EmptyRating"),
                                                                                                            children: rating
                                                                                                        });
                                                                                                    }),
                                                                                                    fullSymbol: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(rating1/* default */.Z, {}),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(rating2/* default */.Z, {}),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(rating3/* default */.Z, {}),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(rating4/* default */.Z, {}),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(rating5/* default */.Z, {})
                                                                                                    ].map(function(rating) {
                                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                            className: "".concat((_index_module_default()).Modal__Card__Rating, " EmptyRating"),
                                                                                                            children: rating
                                                                                                        });
                                                                                                    }),
                                                                                                    initialRating: formik.values.scorecard.score_hash[index].score
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                    className: "".concat((edit_scorecard_index_module_default()).PoorExcellentText),
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                            className: "".concat((edit_scorecard_index_module_default()).PoorExcellentText__LeftContent, " w100"),
                                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                children: t("modal:form:scorecard:poor")
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                            className: "".concat((edit_scorecard_index_module_default()).PoorExcellentText__RightContent, " w100"),
                                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                children: t("modal:form:scorecard:excellent")
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "".concat((edit_scorecard_index_module_default()).TextEditor, " ").concat((_index_module_default()).Form__TableCol, " removeplaceholder noprint"),
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                                                control: "customtextarea",
                                                                                                type: "text",
                                                                                                formik: "",
                                                                                                className: "".concat((_index_module_default()).Form__Textarea, " ").concat((_index_module_default()).Form__Textarea),
                                                                                                name: "scorecard.score_hash.".concat(index, ".info"),
                                                                                                rows: "4",
                                                                                                placeholder: t("modal:form:scorecard:add_notes")
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "".concat((edit_scorecard_index_module_default()).TextEditor, " removeplaceholder printData displaynone"),
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                                                control: "customtextarea",
                                                                                                type: "text",
                                                                                                formik: "",
                                                                                                className: "".concat((edit_scorecard_index_module_default()).Form__Textarea, " ").concat((_index_module_default()).Form__Textarea),
                                                                                                name: "scorecard.empty",
                                                                                                rows: "4",
                                                                                                placeholder: t("modal:form:scorecard:add_notes")
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "".concat((edit_scorecard_index_module_default()).CreateScoreCard__SubCompetency, " printHeader"),
                                                                            children: competency.job_sub_competencies.map(function(subcompetency, subIndex) {
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "".concat((edit_scorecard_index_module_default()).SingleSubCompetency, " w100 ").concat(pageBreak()),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "".concat((edit_scorecard_index_module_default()).LeftContent),
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                className: "".concat((edit_scorecard_index_module_default()).SubCompetencyNotes),
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                                                        children: getNameFromHash.getSubCompetencyName(subcompetency.job_sub_competency_id, props.initialData.competencies)
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                        children: getNameFromHash.getSubCompetencyNotes(subcompetency.job_sub_competency_id, props.initialData.competencies)
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "".concat((edit_scorecard_index_module_default()).RightContent),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                    className: "".concat((edit_scorecard_index_module_default()).Rating, " CompetencyScorecardRating_").concat(index, "_SubCompetencyScorecardRating_").concat(subIndex, " noprint"),
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_rating_esm/* default */.Z, {
                                                                                                            onHover: function(value) {
                                                                                                                addScorecardAction.colorHoverRatingSymbolArray(value, "CompetencyScorecardRating_".concat(index, "_SubCompetencyScorecardRating_").concat(subIndex), "subcompetency_color", formik.values.scorecard.score_hash[index].job_sub_competencies[subIndex].score);
                                                                                                            },
                                                                                                            onChange: function(value) {
                                                                                                                addScorecardAction.onChangeRating("scorecard.score_hash.".concat(index, ".job_sub_competencies.").concat(subIndex, ".score"), formik, value, "CompetencyScorecardRating_".concat(index, "_SubCompetencyScorecardRating_").concat(subIndex), "subcompetency_color");
                                                                                                            },
                                                                                                            emptySymbol: [
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating1/* default */.Z, {}),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating2/* default */.Z, {}),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating3/* default */.Z, {}),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating4/* default */.Z, {}),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating5/* default */.Z, {})
                                                                                                            ].map(function(rating) {
                                                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                    className: "".concat((_index_module_default()).Modal__Card__Rating, " EmptyRating"),
                                                                                                                    children: rating
                                                                                                                });
                                                                                                            }),
                                                                                                            fullSymbol: addScorecardAction.initalArray(formik.values.scorecard.score_hash[index].job_sub_competencies[subIndex].score, "subcompetency").map(function(fillRating) {
                                                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                    className: "".concat((_index_module_default()).Modal__Card__Rating, " FillRating"),
                                                                                                                    children: fillRating
                                                                                                                });
                                                                                                            }),
                                                                                                            initialRating: formik.values.scorecard.score_hash[index].job_sub_competencies[subIndex].score
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                            className: "".concat((edit_scorecard_index_module_default()).PoorExcellentText),
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                    className: "".concat((edit_scorecard_index_module_default()).PoorExcellentText__LeftContent, " w100"),
                                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                        children: t("modal:form:scorecard:poor")
                                                                                                                    })
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                    className: "".concat((edit_scorecard_index_module_default()).PoorExcellentText__RightContent, " w100"),
                                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                        children: t("modal:form:scorecard:excellent")
                                                                                                                    })
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                    className: "".concat((edit_scorecard_index_module_default()).Rating, " CompetencyScorecardRating_").concat(index, "_SubCompetencyScorecardRating_").concat(subIndex, " printData displaynone"),
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_rating_esm/* default */.Z, {
                                                                                                            onHover: function(value) {
                                                                                                                addScorecardAction.colorHoverRatingSymbolArray(value, "CompetencyScorecardRating_".concat(index, "_SubCompetencyScorecardRating_").concat(subIndex), "subcompetency_color", formik.values.scorecard.score_hash[index].job_sub_competencies[subIndex].score);
                                                                                                            },
                                                                                                            onChange: function(value) {
                                                                                                                addScorecardAction.onChangeRating("scorecard.score_hash.".concat(index, ".job_sub_competencies.").concat(subIndex, ".score"), formik, value, "CompetencyScorecardRating_".concat(index, "_SubCompetencyScorecardRating_").concat(subIndex), "subcompetency_color");
                                                                                                            },
                                                                                                            emptySymbol: [
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating1/* default */.Z, {}),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating2/* default */.Z, {}),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating3/* default */.Z, {}),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating4/* default */.Z, {}),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating5/* default */.Z, {})
                                                                                                            ].map(function(rating) {
                                                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                    className: "".concat((_index_module_default()).Modal__Card__Rating, " EmptyRating"),
                                                                                                                    children: rating
                                                                                                                });
                                                                                                            }),
                                                                                                            fullSymbol: [
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating1/* default */.Z, {}),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating2/* default */.Z, {}),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating3/* default */.Z, {}),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating4/* default */.Z, {}),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_rating5/* default */.Z, {})
                                                                                                            ].map(function(rating) {
                                                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                    className: "".concat((_index_module_default()).Modal__Card__Rating, " EmptyRating"),
                                                                                                                    children: rating
                                                                                                                });
                                                                                                            }),
                                                                                                            initialRating: formik.values.scorecard.score_hash[index].job_sub_competencies[subIndex].score
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                            className: "".concat((edit_scorecard_index_module_default()).PoorExcellentText),
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                    className: "".concat((edit_scorecard_index_module_default()).PoorExcellentText__LeftContent, " w100"),
                                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                        children: t("modal:form:scorecard:poor")
                                                                                                                    })
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                    className: "".concat((edit_scorecard_index_module_default()).PoorExcellentText__RightContent, " w100"),
                                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                        children: t("modal:form:scorecard:excellent")
                                                                                                                    })
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                    className: "".concat((edit_scorecard_index_module_default()).TextEditor, " ").concat((_index_module_default()).Form__TableCol, " removeplaceholder noprint"),
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                                                        control: "customtextarea",
                                                                                                        type: "text",
                                                                                                        formik: "",
                                                                                                        className: "".concat((edit_scorecard_index_module_default()).Form__Textarea, " ").concat((_index_module_default()).Form__Textarea),
                                                                                                        name: "scorecard.score_hash.".concat(index, ".job_sub_competencies.").concat(subIndex, ".info"),
                                                                                                        rows: "4",
                                                                                                        placeholder: t("modal:form:scorecard:add_notes")
                                                                                                    })
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                    className: "".concat((edit_scorecard_index_module_default()).TextEditor, " ").concat((_index_module_default()).Form__TableCol, " removeplaceholder printData displaynone"),
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                                                                        control: "customtextarea",
                                                                                                        type: "text",
                                                                                                        formik: "",
                                                                                                        className: "".concat((edit_scorecard_index_module_default()).Form__Textarea, " ").concat((_index_module_default()).Form__Textarea),
                                                                                                        name: "scorecard.empty",
                                                                                                        rows: "4",
                                                                                                        placeholder: t("modal:form:scorecard:add_notes")
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }, "competency__".concat(index, "__subcompetency__").concat(subIndex));
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }, "competency_".concat(index));
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((_index_module_default()).Modal__Card__Editor, " ").concat((_index_module_default()).Form__TableCol, " CustomEditor mt30 noprint"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                        control: "customtextarea",
                                                        type: "text",
                                                        formik: formik,
                                                        className: "".concat((_index_module_default()).Form__Textarea, " width100 bs-none"),
                                                        rows: "7",
                                                        placeholder: t("modal:form:scorecard:questions_ask"),
                                                        name: "scorecard.overall_feedback"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((_index_module_default()).Modal__Card__Editor, " ").concat((_index_module_default()).Form__TableCol, " CustomEditor mt30 printData displaynone"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* FormikControl */.gt, {
                                                        control: "customtextarea",
                                                        type: "text",
                                                        formik: formik,
                                                        className: "".concat((_index_module_default()).Form__Textarea, " width100 bs-none"),
                                                        rows: "7",
                                                        placeholder: t("modal:form:scorecard:questions_ask"),
                                                        name: "scorecard.empty_overall_feedback"
                                                    })
                                                })
                                            ]
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((edit_scorecard_index_module_default()).CreateScoreCard__DownloadAndSubmit, " mt20 noprint"),
                                    children: [
                                        props.isPublic && /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Button */.zx, {
                                            buttonstyle: "".concat(common/* ButtonStyle.secondarybtnborder */.ZJ.secondarybtnborder, " ").concat((edit_scorecard_index_module_default()).DownloadBtn),
                                            onClick: function() {
                                                window.print();
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "mr5",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(download_icon, {})
                                                }),
                                                t("download:pdf")
                                            ]
                                        }),
                                        !props.isPublic && /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                            buttonstyle: "".concat(common/* ButtonStyle.primarybtn */.ZJ.primarybtn, " ml16 displaynone1"),
                                            onClick: function() {
                                                return formRef.current.submitForm();
                                            },
                                            children: t("button:submit")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            showLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Loading */.gb, {})
        ]
    });
}
NewEditScorecard.layout = ClientDashboard/* default */.Z;
/* harmony default export */ var new_edit_scorecard = (NewEditScorecard);


/***/ }),

/***/ 11281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SendQuestionModal": function() { return /* binding */ SendQuestionModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _components_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95662);
/* harmony import */ var _styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84215);
/* harmony import */ var _styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96047);
/* harmony import */ var _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47942);
/* harmony import */ var _imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3623);
/* harmony import */ var _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66172);











function SendQuestionModal(props) {
    var ref = (0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)(), t = ref.t, i18n = ref.i18n;
    var router = (0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .useRouter */ .tv)();
    var initialValues = props.selectedCards;
    initialValues.send_question_details = {
        expires: ""
    };
    initialValues.job_id = props.job_id;
    var validationSchema = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .Yup.object */ .sm.object().shape({
        send_question_details: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .Yup.object */ .sm.object().shape({
            expires: _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .Yup.string */ .sm.string().required((0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .TRANSLATION */ .TA)("errors:required"))
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_4__/* .FormModalStyle.ModalOverlay */ .w2.ModalOverlay),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_4__/* .FormModalStyle.Modal */ .w2.Modal),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_4__/* .FormModalStyle.Modal__Container */ .w2.Modal__Container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_4__/* .FormModalStyle.Modal__Container__Heading__Close */ .w2.Modal__Container__Heading__Close),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_4__/* .FormModalStyle.Modal__Container__ContentSection__Heading */ .w2.Modal__Container__ContentSection__Heading, " "),
                                children: [
                                    " ",
                                    t("jobs:options:screening:heading")
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_4__/* .FormModalStyle.Modal__Container__CloseSection */ .w2.Modal__Container__CloseSection),
                                onClick: function() {
                                    return props.setBtnPopup(false);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__/* .Close */ .x8, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_4__/* .FormModalStyle.Modal__Container__ContentSection */ .w2.Modal__Container__ContentSection, " "),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .Formik */ .J9, {
                            initialValues: initialValues,
                            validationSchema: validationSchema,
                            onSubmit: function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(values, actions) {
                                    var _tmp;
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _tmp = {};
                                                return [
                                                    4,
                                                    (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_3__/* .sendQuestions */ .b8)(values, props.setBtnPopup, props.from, props.setLoading, props.setJobData || props.setInitialData, (_tmp.activeTab = props.activeTab, _tmp.setSelectedCards = props.setSelectedCards, _tmp.setActionBar = props.setActionBar, _tmp))
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(values, actions) {
                                    return _ref.apply(this, arguments);
                                };
                            }(),
                            children: function(formik) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .Form */ .l0, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_4__/* .FormModalStyle.Modal__Container__ContentSection__Block */ .w2.Modal__Container__ContentSection__Block, " ").concat(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__TableCol */ .x.Form__TableCol, " "),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                    className: "".concat(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .FormStyle.Form__FloatingLabel */ .x.Form__FloatingLabel),
                                                    style: (0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .InputText */ .oH)(formik, "send_question_details.expires"),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "red-color",
                                                            children: "*"
                                                        }),
                                                        " \xa0",
                                                        t("label:expiry_days")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .FormikControl */ .gt, {
                                                    className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_4__/* .FormModalStyle.Form__Input */ .w2.Form__Input),
                                                    control: "input",
                                                    type: "text",
                                                    autocomplete: "off",
                                                    placeholder: "e g. 15",
                                                    formik: formik,
                                                    maxLength: 3,
                                                    custom_class: "FieldError",
                                                    name: "send_question_details.expires",
                                                    value: formik.values.send_question_details.expires,
                                                    onChange: function(evt) {
                                                        var new_value = isNaN(evt.target.value) ? "" : parseInt(evt.target.value) == 0 ? "" : evt.target.value;
                                                        formik.setFieldValue("send_question_details.expires", new_value);
                                                    },
                                                    style: (0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .InputError */ .pd)(formik, "send_question_details.expires")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "".concat(_imports_files_components_review_email__WEBPACK_IMPORTED_MODULE_4__/* .FormModalStyle.Modal__Container__ButtonSection */ .w2.Modal__Container__ButtonSection, " "),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                    buttonstyle: "".concat((_styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().secondarybtn)),
                                                    type: "button",
                                                    onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                                                        var data, _tmp;
                                                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    _tmp = {};
                                                                    return [
                                                                        4,
                                                                        (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_3__/* .reviewAutomationEmail */ .ds)(props.job_id, router, (_tmp.key = "send_screening_questions", _tmp.list = true, _tmp))
                                                                    ];
                                                                case 1:
                                                                    data = _state.sent();
                                                                    props.setEmailData(data);
                                                                    props.setHideModalClass(true);
                                                                    props.setEmailTemplateInfo(props.emailTemplateInfo);
                                                                    props.setReviewEmail(true);
                                                                    return [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    }),
                                                    children: t("button:review_email")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                    buttonstyle: "".concat((_styles_components_button_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().primarybtn)),
                                                    type: "submit",
                                                    children: t("button:send_questions")
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }
                        })
                    })
                ]
            })
        })
    });
}
SendQuestionModal.layout = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_2__/* .ClientDashboard */ .LD;
/* harmony default export */ __webpack_exports__["default"] = (SendQuestionModal);


/***/ }),

/***/ 59546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62286);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34817);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80952);
/* harmony import */ var _components_user_switch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28418);
/* harmony import */ var _pages_clients_dashboard_recruitments_my_interview_widget__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63523);
/* harmony import */ var _components_modals_play_video_modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18109);
/* harmony import */ var _actions_common_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1739);
/* harmony import */ var _imports_files_components_sidebar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86064);











function MyAccount(props) {
    var closeDropDown = function closeDropDown(setIsActive) {
        setTimeout(function() {
            return setIsActive(false);
        }, 50);
    };
    var handleIsChecked = function handleIsChecked(event, formik, name) {
        var isChecked = event.target.checked;
        formik.setFieldValue(name, isChecked);
    };
    (0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .clearSWRCache */ .A$)("my-account-data");
    var t = (0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(false), 2), showLoader = ref[0], setShowLoader = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(null), 2), apiError = ref1[0], setApiError = ref1[1];
    var myAccountAction = new _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .MyAccountAction */ .Pf(setApiError, setShowLoader, t);
    var errorPages = new _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .ErrorPages */ .dC();
    var editorRef = (0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .useRef */ .sO)(null);
    var router = (0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .useRouter */ .tv)();
    var sidebarAction = new _imports_files_components_sidebar__WEBPACK_IMPORTED_MODULE_6__/* .SidebarAction */ .Dv(router, t);
    var commonAction = new _actions_common_common__WEBPACK_IMPORTED_MODULE_5__/* .CommonAction */ .x();
    var step = router.query.step;
    var isQuickSetup = router.query.step && router.query.step == "my_account" ? true : false;
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(false), 2), skipModal = ref2[0], setSkipModal = ref2[1];
    var ref3 = (0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .useSWR */ .dH)("my-account-data", function() {
        return myAccountAction.getUserDetails(router);
    }, {
        revalidateOnFocus: false
    }), data = ref3.data, error = ref3.error;
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)({}), 2), initialValues = ref4[0], setInitialValues = ref4[1];
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)({}), 2), userRoles = ref5[0], setUserRoles = ref5[1];
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(true), 2), isLoading = ref6[0], setLoading = ref6[1];
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(""), 2), imageError = ref7[0], setImageError = ref7[1];
    var ref8 = (0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .useUser */ .aF)(), user = ref8.user, clearUser = ref8.clearUser, updateUser = ref8.updateUser;
    var ref9 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(props.session), 2), session = ref9[0], setSession = ref9[1];
    var ref10 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(false), 2), showVideo = ref10[0], setShowVideo = ref10[1];
    var ref11 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)([]), 2), imageUploadedData = ref11[0], setImageUploadedData = ref11[1];
    var ref12 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(false), 2), isActive = ref12[0], setIsActive = ref12[1];
    (0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .useEffect */ .d4)(function() {
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var profileData, base64Data, _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!data) return [
                            3,
                            3
                        ];
                        profileData = data === null || data === void 0 // await sidebarAction.getProfilePhotoUrl(session)
                         ? void 0 : data.user;
                        return [
                            4,
                            commonAction.convertUrlToBase64(profileData.photo_url)
                        ];
                    case 1:
                        base64Data = _state.sent();
                        _tmp = {};
                        return [
                            4,
                            updateUser((_tmp.user_image = base64Data, _tmp.user_name = profileData === null || profileData === void 0 ? void 0 : profileData.name, _tmp.user_id = session === null || session === void 0 ? void 0 : session.slug, _tmp.name_initials = profileData === null || profileData === void 0 ? void 0 : profileData.name_initials, _tmp))
                        ];
                    case 2:
                        _state.sent();
                        if (profileData.photo_url) {
                            document.querySelector(".AvatarImage").src = profileData.photo_url || _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .COMMON.DUMMY_IMAGE */ .CW.DUMMY_IMAGE;
                            sidebarAction.showImageOrInitials(true);
                        } else {
                            document.querySelector(".AvatarInitials").innerText = profileData === null || profileData === void 0 ? void 0 : profileData.name_initials;
                            sidebarAction.showImageOrInitials(false);
                        }
                        document.querySelector(".AvatarName").textContent = profileData === null || profileData === void 0 ? void 0 : profileData.name;
                        setInitialValues(data === null || data === void 0 ? void 0 : data.user);
                        setUserRoles(data.user_roles);
                        setLoading(false);
                        if (isQuickSetup) setTimeout(function() {
                            new _imports_files_components_sidebar__WEBPACK_IMPORTED_MODULE_6__/* .SidebarAction */ .Dv().subsidebarQuickSetupChangeIcon(data.sidebar_options.complete_steps, "my_account");
                        }, 750);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        data
    ]);
    if (isLoading || error || errorPages.handleErrorCodes(apiError === null || apiError === void 0 ? void 0 : apiError.status)) {
        var renderPage = error || apiError ? errorPages.renderPage((error === null || error === void 0 ? void 0 : error.status) || (apiError === null || apiError === void 0 ? void 0 : apiError.status), router) : null;
        return renderPage;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .motion.div */ .EA.div, {
        initial: "pageInitial",
        animate: "pageAnimate",
        variants: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PAGE_ANIMATION_OPTIONS */ .Mf,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "acprofile DashboardPageContent ".concat(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.accountprofile */ .k2.accountprofile, " ").concat(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.JobList */ .k2.JobList, " ").concat(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.NewJob */ .k2.NewJob),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.NewJob__Container */ .k2.NewJob__Container,
                    children: [
                        (session === null || session === void 0 ? void 0 : session.role) != "reviewer" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .QuickAdd */ .YU, {
                            session: session
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.ClientCompany__FormSection */ .k2.ClientCompany__FormSection,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "mt0 ".concat(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.ClientCompany__Heading */ .k2.ClientCompany__Heading),
                                children: t("my_account:heading")
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "CandidateListForm",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .Formik */ .J9, {
                                initialValues: initialValues,
                                validationSchema: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .MY_ACCOUNT.VALIDATION_SCHEMA */ .RX.VALIDATION_SCHEMA,
                                onSubmit: function() {
                                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(values, actions) {
                                        var parser, doc, img_array, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, encode_image, err, filter_deleted_image_urls, xmlSerializer, stringifiedContent, errors;
                                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    parser = new DOMParser();
                                                    doc = parser.parseFromString(values.email_signature, "text/html");
                                                    img_array = [];
                                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                    _state.label = 1;
                                                case 1:
                                                    _state.trys.push([
                                                        1,
                                                        6,
                                                        7,
                                                        8
                                                    ]);
                                                    _iterator = doc.getElementsByTagName("img")[Symbol.iterator]();
                                                    _state.label = 2;
                                                case 2:
                                                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                                        3,
                                                        5
                                                    ];
                                                    element = _step.value;
                                                    img_array.push(element.src);
                                                    if (!((element.src.includes("https://") || element.src.includes("http://")) && !element.src.includes("email-signature/users/".concat(session.id)))) return [
                                                        3,
                                                        4
                                                    ];
                                                    return [
                                                        4,
                                                        myAccountAction.imageToBase64(element)
                                                    ];
                                                case 3:
                                                    encode_image = _state.sent();
                                                    element.src = encode_image;
                                                    _state.label = 4;
                                                case 4:
                                                    _iteratorNormalCompletion = true;
                                                    return [
                                                        3,
                                                        2
                                                    ];
                                                case 5:
                                                    return [
                                                        3,
                                                        8
                                                    ];
                                                case 6:
                                                    err = _state.sent();
                                                    _didIteratorError = true;
                                                    _iteratorError = err;
                                                    return [
                                                        3,
                                                        8
                                                    ];
                                                case 7:
                                                    try {
                                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                            _iterator.return();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError) {
                                                            throw _iteratorError;
                                                        }
                                                    }
                                                    return [
                                                        7
                                                    ];
                                                case 8:
                                                    filter_deleted_image_urls = imageUploadedData.filter(function(a) {
                                                        return !img_array.includes(a);
                                                    });
                                                    xmlSerializer = new XMLSerializer();
                                                    stringifiedContent = xmlSerializer.serializeToString(doc);
                                                    values.email_signature = stringifiedContent;
                                                    return [
                                                        4,
                                                        myAccountAction.updateUserDetails(values, router, isQuickSetup, updateUser, initialValues.slug, setInitialValues, filter_deleted_image_urls)
                                                    ];
                                                case 9:
                                                    errors = _state.sent();
                                                    actions.setErrors(errors);
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(values, actions) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(),
                                children: function(formik) {
                                    var ref;
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
                                        className: "".concat(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form */ .k2.Form, " width100 AddCandidateForm"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Table */ .k2.Form__Table,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableRow */ .k2.Form__TableRow,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.accountprofile__ProfilePicture */ .k2.accountprofile__ProfilePicture,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    id: "User_Profile",
                                                                    src: formik.values.photo_url ? formik.values.photo_url : _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .COMMON.DUMMY_IMAGE */ .CW.DUMMY_IMAGE
                                                                }),
                                                                 false && /*#__PURE__*/ 0
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableRow */ .k2.Form__TableRow,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                    className: "".concat(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                    style: (0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oH)(formik, "role_id"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "red-color",
                                                                            children: "*"
                                                                        }),
                                                                        "\xa0",
                                                                        t("my_account:role")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                    control: "select",
                                                                    type: "text",
                                                                    /*  placeholder    =   {MY_ACCOUNT.texts.placeholder_1} */ name: "role_id",
                                                                    className: "".concat(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__CustomSelect */ .k2.Form__CustomSelect, " width398"),
                                                                    formik: formik,
                                                                    default: formik.values.role_id || "",
                                                                    errorClass: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                    style: (0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "role_id"),
                                                                    options: userRoles,
                                                                    disabled: true
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                    className: "".concat(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                    style: (0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oH)(formik, "name"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "red-color",
                                                                            children: "*"
                                                                        }),
                                                                        "\xa0",
                                                                        t("my_account:name")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                    control: "input",
                                                                    type: "text",
                                                                    /*  placeholder      =     {MY_ACCOUNT.texts.placeholder_2} */ name: "name",
                                                                    className: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input */ .k2.Form__Input,
                                                                    formik: formik,
                                                                    errorClass: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                    style: (0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "name"),
                                                                    disabled: true
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableRow */ .k2.Form__TableRow,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                    className: "".concat(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                    style: (0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oH)(formik, "email"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "red-color",
                                                                            children: "*"
                                                                        }),
                                                                        "\xa0",
                                                                        t("my_account:email")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                    control: "input",
                                                                    type: "text",
                                                                    /* placeholder    =   {MY_ACCOUNT.texts.placeholder_4} */ name: "email",
                                                                    className: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Input */ .k2.Form__Input,
                                                                    formik: formik,
                                                                    disabled: true,
                                                                    errorClass: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Error */ .k2.Form__Error,
                                                                    style: (0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "email")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableRow */ .k2.Form__TableRow,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__TableCol */ .k2.Form__TableCol,
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                className: "".concat(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__Label */ .k2.Form__Label, " ").concat(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.Form__FloatingLabel */ .k2.Form__FloatingLabel),
                                                                style: (0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oH)(formik, "email_signature"),
                                                                children: [
                                                                    " ",
                                                                    t("my_account:email_sign"),
                                                                    " "
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .FormikControl */ .gt, {
                                                                selector: "#email-signature",
                                                                apiKey: "dxe0l6rdhdta2rzyfq2io208ncq1ay4l9wc2vyre3a53sdna",
                                                                control: "customEditor",
                                                                formik: formik,
                                                                onInit: function(evt, editor) {
                                                                    return editorRef.current = editor;
                                                                },
                                                                textareaName: "email_signature",
                                                                style: (0,_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .InputError */ .pd)(formik, "email_signature"),
                                                                value: formik.values.email_signature,
                                                                onEditorChange: function(value) {
                                                                    formik.setFieldValue("email_signature", value);
                                                                },
                                                                init: {
                                                                    height: 250,
                                                                    menubar: false,
                                                                    readOnly: false,
                                                                    resize: false,
                                                                    plugins: [
                                                                        "advlist",
                                                                        "autolink",
                                                                        "lists",
                                                                        "link",
                                                                        "image",
                                                                        "charmap",
                                                                        "preview",
                                                                        "anchor",
                                                                        "searchreplace",
                                                                        "visualblocks",
                                                                        "code",
                                                                        "fullscreen",
                                                                        "insertdatetime",
                                                                        "media",
                                                                        "table",
                                                                        "help",
                                                                        "wordcount"
                                                                    ],
                                                                    toolbar: "undo redo | blocks | " + "bold italic backcolor | image | link | alignleft aligncenter " + "alignright alignjustify | bullist numlist outdent indent | " + "removeformat | help",
                                                                    images_upload_handler: function images_upload_handler(blobInfo, success, failure) {
                                                                        return new Promise(function(resolve, reject) {
                                                                            var user_id = session.id;
                                                                            var xmlRequest = new XMLHttpRequest();
                                                                            var formData = new FormData();
                                                                            xmlRequest.withCredentials = false;
                                                                            xmlRequest.open("POST", _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .API.open.UPLOAD_SIGNATURE_IMAGE */ .bl.open.UPLOAD_SIGNATURE_IMAGE);
                                                                            xmlRequest.onload = function() {
                                                                                if (xmlRequest.status == 200) {
                                                                                    var response = JSON.parse(xmlRequest.response);
                                                                                    imageUploadedData.push(response.location);
                                                                                    setImageUploadedData((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(imageUploadedData));
                                                                                    resolve(response.location);
                                                                                } else {
                                                                                    reject("HTTP Error: " + xmlRequest.status);
                                                                                }
                                                                            };
                                                                            xmlRequest.onerror = function() {
                                                                                reject("Image upload failed due to a XHR Transport error. Code: " + xmlRequest.status);
                                                                            };
                                                                            var image_base_64 = blobInfo.base64();
                                                                            var file_format = blobInfo.blob().type;
                                                                            formData.append("user_id", user_id);
                                                                            formData.append("encoded_image", image_base_64);
                                                                            formData.append("file_format", file_format);
                                                                            xmlRequest.send(formData);
                                                                        });
                                                                    },
                                                                    content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }"
                                                                }
                                                            })
                                                        ]
                                                    })
                                                }),
                                                 false && /*#__PURE__*/ 0,
                                                skipModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .SkipModal */ ["if"], {
                                                    setBtnPopup: setSkipModal,
                                                    router: router
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "space"
                                                }),
                                                !isQuickSetup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.NewJob__SubmitSection */ .k2.NewJob__SubmitSection,
                                                    children: [
                                                         false ? /*#__PURE__*/ 0 : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                            buttonstyle: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.primarybtn */ .k2.primarybtn,
                                                            type: "submit",
                                                            children: t("button:save_changes")
                                                        })
                                                    ]
                                                }),
                                                isQuickSetup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.NewJob__SubmitSection */ .k2.NewJob__SubmitSection,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                            buttonstyle: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.secondarybtnborder */ .k2.secondarybtnborder,
                                                            type: "button",
                                                            onClick: function() {
                                                                setSkipModal(true);
                                                            },
                                                            children: t("button:skip")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                            buttonstyle: _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .PageStyle.primarybtn */ .k2.primarybtn,
                                                            type: "submit",
                                                            children: t("button:next")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    });
                                }
                            })
                        })
                    ]
                }),
                showLoader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .Loading */ .gb, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .CustomCropper */ .tS, {
                    viewProfileAction: myAccountAction
                }),
                showVideo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_modals_play_video_modal__WEBPACK_IMPORTED_MODULE_4__/* .PlayVideoModal */ .a, {
                    hashKey: data.user.introduction_video_key,
                    setIntroModal: setShowVideo
                })
            ]
        })
    }, router.route);
}
MyAccount.layout = _imports_files_pages_clients_my_account__WEBPACK_IMPORTED_MODULE_1__/* .ClientDashboard */ .LD;
/* harmony default export */ __webpack_exports__["default"] = (MyAccount);


/***/ }),

/***/ 15639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ my_integration; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(34817);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common = __webpack_require__(96047);
// EXTERNAL MODULE: ./src/constants/pages/clients/manage-integration.js + 5 modules
var manage_integration = __webpack_require__(30003);
// EXTERNAL MODULE: ./public/icons/info.svg
var info = __webpack_require__(35150);
// EXTERNAL MODULE: ./src/components/button.js + 1 modules
var components_button = __webpack_require__(95662);
// EXTERNAL MODULE: ./src/services/common/send-request.js
var send_request = __webpack_require__(34964);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
;// CONCATENATED MODULE: ./src/services/pages/clients/activities/my-integrations.js







var MyIntegration = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(MyIntegration, SendRequest);
    var _super = (0,_create_super/* default */.Z)(MyIntegration);
    function MyIntegration() {
        (0,_class_call_check/* default */.Z)(this, MyIntegration);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(MyIntegration, [
        {
            key: "getIntegrationsList",
            value: function getIntegrationsList(client_auth_cookies) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    (0,common/* axios */.od)((_tmp.method = "get", _tmp.url = common/* API.client.activities.MY_INTEGRATIONS_URL */.bl.client.activities.MY_INTEGRATIONS_URL, _tmp.headers = {
                                        cookie: "Authorization=".concat(client_auth_cookies)
                                    }, _tmp))
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getIntegrationsData",
            value: function getIntegrationsData(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.activities.MY_INTEGRATIONS_DATA_URL */.bl.client.activities.MY_INTEGRATIONS_DATA_URL;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.get */.od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "connectDisconnectMyIntegrations",
            value: function connectDisconnectMyIntegrations(params, integration_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.activities.MY_INTEGRATIONS_CONNECT.replace */.bl.client.activities.MY_INTEGRATIONS_CONNECT.replace("$integration_id", integration_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common/* axios.post */.od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disconnectIntegration",
            value: function disconnectIntegration(params, integration_id) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = common/* API.client.activities.DISCONNECT_INTEGRATION.replace */.bl.client.activities.DISCONNECT_INTEGRATION.replace("$integration_id", integration_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common/* axios.delete */.od["delete"](url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return MyIntegration;
}(send_request/* SendRequest */.L);

;// CONCATENATED MODULE: ./src/actions/pages/clients/settings/my-integrations.js



function createIntegrationData(index, client_integration_id, integration_id, slug, name, description, user_enabled, is_linkable, logo, accessible, connected, redirect_url) {
    return {
        index: index,
        client_integration_id: client_integration_id,
        integration_id: integration_id,
        slug: slug,
        name: name,
        description: description,
        user_enabled: user_enabled,
        is_linkable: is_linkable,
        logo: logo,
        accessible: accessible,
        connected: connected,
        redirect_url: redirect_url
    };
}
function getIntegrationsStatus(row, t) {
    if (row.is_linkable) {
        return row.connected ? t("button:disconnect") : t("button:connect");
    }
}
function getButtonClass(row) {
    if (row.is_linkable) {
        return row.connected ? (button_index_module_default()).secondarybtnborder : (button_index_module_default()).secondarybtn;
    }
}
function connectDisconnectIntegration(event, router, row, setApiError) {
    return _connectDisconnectIntegration.apply(this, arguments);
}
function _connectDisconnectIntegration() {
    _connectDisconnectIntegration = (0,_async_to_generator/* default */.Z)(function(event, router, row, setApiError) {
        var params, _tmp, result, status_code, customToastrAction, response, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    params = (_tmp.integrate_level = "user", _tmp);
                    if (!row.connected) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        new MyIntegration().disconnectIntegration(params, row.slug)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new common/* CustomToastrAction */.Y5();
                    setApiError(result.request);
                    switch(status_code){
                        case common/* SUCCESS_REPONSE_CODE */.Us:
                            response = result.data;
                            if (response.success) {
                                row.connected = false;
                            }
                            break;
                        case common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            error = result.response.data.error;
                            if (error) {
                                customToastrAction.setNormalToastr(result.response.data.error, "warning");
                            }
                            break;
                        default:
                            (0,common/* handleOtherResponseCode */.GB)(status_code, router);
                    }
                    return [
                        2,
                        row
                    ];
                case 2:
                    row.redirect_url.length > 0 ? router.push(row.redirect_url) : console.log("Integration is not done yet.");
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _connectDisconnectIntegration.apply(this, arguments);
}
function getMyIntegrationData(router, setApiError) {
    return _getMyIntegrationData.apply(this, arguments);
}
function _getMyIntegrationData() {
    _getMyIntegrationData = (0,_async_to_generator/* default */.Z)(function(router, setApiError) {
        var ref, body, _tmp, integration_data, my_integrations, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = _tmp;
                    if (router.query.step) body.step = router.query.step;
                    return [
                        4,
                        new MyIntegration().getIntegrationsData(body)
                    ];
                case 1:
                    integration_data = _state.sent();
                    setApiError(integration_data.request);
                    my_integrations = integration_data === null || integration_data === void 0 ? void 0 : (ref = integration_data.data) === null || ref === void 0 ? void 0 : ref.my_integrations;
                    data = null;
                    if (integration_data.status == undefined || integration_data.status != 200) {
                        error = new Error("An error occurred while fetching the data.");
                        error.status = integration_data.response.status;
                        throw error;
                    } else {
                        data = {
                            props: {
                                my_integrations: my_integrations,
                                integration_data: integration_data
                            }
                        };
                        return [
                            2,
                            data
                        ];
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getMyIntegrationData.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/components/skip-modal.js
var skip_modal = __webpack_require__(53594);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ./src/imports-files/components/common-modal/common-modal.js + 2 modules
var common_modal = __webpack_require__(66172);
// EXTERNAL MODULE: ../../shared/node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(73732);
;// CONCATENATED MODULE: ./src/components/integration-popup.js






function IntegrationPopup(param) {
    var onClose = param.onClose;
    var modalRef = (0,react.useRef)(null);
    var handleClickOutside = function(event) {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            onClose();
        }
    };
    var handleClickInside = function(event) {
        event.stopPropagation();
    };
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(common_modal/* InfoModalStyle.ModalOverlay */.KD.ModalOverlay),
        onClick: handleClickOutside,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(common_modal/* InfoModalStyle.Modal */.KD.Modal),
            onClick: handleClickInside,
            ref: modalRef,
            style: {
                minHeight: "auto"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(common_modal/* InfoModalStyle.Modal__Container */.KD.Modal__Container),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(common_modal/* InfoModalStyle.Modal__Container__CloseSection */.KD.Modal__Container__CloseSection),
                        onClick: onClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_modal/* Close */.x8, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: common_modal/* InfoModalStyle.Modal__Container__ContentSection */.KD.Modal__Container__ContentSection,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "".concat(common_modal/* InfoModalStyle.Modal__Container__ContentSection__Description */.KD.Modal__Container__ContentSection__Description),
                            style: {
                                height: "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: t("modal:info:g_meet:description")
                            })
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/quick-add.js
var quick_add = __webpack_require__(35294);
// EXTERNAL MODULE: ./src/actions/pages/clients/activities/index.js
var activities = __webpack_require__(41767);
// EXTERNAL MODULE: ./src/styles/pages/admins/dashboard/clients/new/_index.module.scss
var _index_module = __webpack_require__(10994);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ./src/styles/pages/admins/dashboard/clients/integration/_index.module.scss
var integration_index_module = __webpack_require__(84370);
var integration_index_module_default = /*#__PURE__*/__webpack_require__.n(integration_index_module);
// EXTERNAL MODULE: ./src/styles/components/button/_index.module.scss
var button_index_module = __webpack_require__(84215);
var button_index_module_default = /*#__PURE__*/__webpack_require__.n(button_index_module);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/activities/my-integrations.js
// -------------------- Material Ui Table Components --------------

// -------------------- Material Ui Table Components --------------
// ----------------------------- COMMON ---------------------------------------

// ----------------------------- COMMON ---------------------------------------
// ----------------- Constants ---------------------

// ----------------- Constants ---------------------

// -----------------------------  CUSTOM COMPONENTS -----------------------------




// export {getIntegrationsStatus, turnOnOffAccessibility} from '@/actions/pages/clients/activities/client-integrations'



// -----------------------------  CUSTOM COMPONENTS -----------------------------
// -----------------------------  ACTIONS -----------------------------

// -----------------------------  ACTIONS  -----------------------------
// ---------------------------- Stylesheet -------------------------------------


 // ----------------------------- Stylesheet ------------------------------------

;// CONCATENATED MODULE: ./src/pages/clients/dashboard/my-integration.js






function MyIntegrations(props) {
    var cronofyConnectedOrNot = function cronofyConnectedOrNot(step, router) {
        var cronofy = enable_items.filter(function(x) {
            return x.slug == "cronofy";
        })[0];
        if (cronofy && cronofy.connected) {
            activitiesAction.nextOnboardingStep(step, router);
        } else {
            customToastrAction.setNormalToastr(t("integrations:my:cronofy_warning"), "warning");
        // toastr.warning('To proceed you need to connect cronofy.')
        }
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(null), 2), apiError = ref[0], setApiError = ref[1];
    var activitiesAction = new activities/* ActivitiesAction */.W(setApiError);
    var errorPages = new common/* ErrorPages */.dC();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)([]), 2), my_integrations_array = ref1[0], set_my_integrations_array = ref1[1];
    var ref2 = (0,common/* useTranslation */.$G)(), t = ref2.t, i18n = ref2.i18n;
    var router = (0,common/* useRouter */.tv)();
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(""), 2), enable_items = ref3[0], setEnableItems = ref3[1];
    var ref4 = (0,common/* useSWR */.dH)("my_integration_data", function() {
        return getMyIntegrationData(router, setApiError);
    }, {
        revalidateOnFocus: false
    }), data = ref4.data, error = ref4.error;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(true), 2), isLoading = ref5[0], setLoading = ref5[1];
    var step = router.query.step;
    var isQuickSetup = router.query.step && router.query.step == "my_integrations" ? true : false;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), skipModal = ref6[0], setSkipModal = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(props.session), 2), session = ref7[0], setSession = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,common/* useState */.eJ)(false), 2), showPopup = ref8[0], setShowPopup = ref8[1];
    var customToastrAction = new common/* CustomToastrAction */.Y5();
    var slack_document_url =  true ? "https://heartpace.com/" : 0;
    var zoom_document_url =  true ? "https://heartpace-production-public.s3.eu-north-1.amazonaws.com/$language/Zoom+Video+Interview.pdf" : 0;
    (0,common/* useEffect */.d4)(function() {
        if (data) {
            var ref, ref1;
            var integrations = data.props.my_integrations;
            var integrations_array = [];
            integrations === null || integrations === void 0 ? void 0 : integrations.map(function(x, index) {
                var file_name = x.integration.display_name.toLowerCase().replaceAll(" ", "_");
                var logo_url = "/images/pages/integration/".concat(file_name, ".png");
                integrations_array.push(createIntegrationData(index, x.id, x.integration.id, x.integration.slug, x.integration.display_name, x.integration.description, x.integration.user_enabled, x.integration.is_linkable, /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Image */.Ee, {
                    src: logo_url,
                    alt: "",
                    width: (0,common/* imageSize */.gs)(x.integration.display_name.toLowerCase().replace(/\s/g, "_")).width,
                    height: (0,common/* imageSize */.gs)(x.integration.display_name.toLowerCase().replace(/\s/g, "_")).height
                }), x.accessible, x.connected, x.integration.redirect_url));
            });
            set_my_integrations_array(integrations_array);
            setEnableItems(integrations_array);
            if (((ref = router.query) === null || ref === void 0 ? void 0 : ref.success) == "true") {
                var ref2;
                customToastrAction.setNormalToastr(t("integrations:errors:connect_success"), "success");
                // toastr.success(t('page:clients:integrations:errors:connect_success'));
                if ((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.step) {
                    router.push({
                        pathname: common/* REDIRECT.client.quick_setup_page */.RQ.client.quick_setup_page,
                        query: {
                            step: "my_integrations"
                        }
                    });
                } else {
                    window.history.replaceState(null, null, common/* REDIRECT.client.my_integrations */.RQ.client.my_integrations);
                }
                router.query = {};
            } else if (((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.success) == "false") {
                var ref3;
                // customToastrAction.setNormalToastr(t('page:clients:integrations:errors:connect_error'), 'warning');
                customToastrAction.setNormalToastr(router.query.message != null ? router.query.message : t("integrations:errors:connect_error"), "warning");
                // toastr.warning(t('page:clients:integrations:errors:connect_error'))
                if ((ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.step) {
                    router.push({
                        pathname: common/* REDIRECT.client.quick_setup_page */.RQ.client.quick_setup_page,
                        query: {
                            step: "my_integrations"
                        }
                    });
                } else {
                    window.history.replaceState(null, null, common/* REDIRECT.client.my_integrations */.RQ.client.my_integrations);
                }
                router.query = {};
            }
            if (isQuickSetup) setTimeout(function() {
                new common/* SidebarAction */.Dv().subsidebarQuickSetupChangeIcon(data.props.integration_data.data.sidebar_options.complete_steps, "my_integrations");
            }, 750);
            setLoading(false);
        }
    }, [
        data,
        set_my_integrations_array,
        setEnableItems,
        setLoading
    ]);
    if (isLoading || error || errorPages.handleErrorCodes(apiError === null || apiError === void 0 ? void 0 : apiError.status)) {
        var renderPage = error || apiError ? errorPages.renderPage((error === null || error === void 0 ? void 0 : error.status) || (apiError === null || apiError === void 0 ? void 0 : apiError.status), router) : null;
        return renderPage;
    }
    var handleOpenPopup = function() {
        setShowPopup(true);
    };
    var handleClosePopup = function() {
        setShowPopup(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "DashboardPageContent",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* motion.div */.EA.div, {
            initial: "pageInitial",
            animate: "pageAnimate",
            exit: "pageExit",
            variants: common/* PAGE_ANIMATION_OPTIONS */.Mf,
            transition: {
                delay: 0.2
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (_index_module_default()).ClientCompany__Container,
                children: [
                    (session === null || session === void 0 ? void 0 : session.role) != "reviewer" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (_index_module_default()).ClientCompany__TopSection2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (_index_module_default()).JobList__QuickAdd,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(quick_add/* default */.Z, {
                                session: session
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (_index_module_default()).ClientCompany__FormSection,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "mb0 ".concat((_index_module_default()).ClientCompany__Heading),
                                children: t("integrations:my:heading")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                className: (_index_module_default()).ClientCompany__Subheading2,
                                children: [
                                    t("integrations:my:subheading"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "mailto:support@heartpace.com",
                                        className: "td-underline",
                                        children: "support@heartpace.com "
                                    })
                                ]
                            })
                        ]
                    }),
                    enable_items.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((integration_index_module_default()).IntegrationView),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((integration_index_module_default()).IntegrationView__Title),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    children: t("integrations:my:auto_interview_scheduling")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((integration_index_module_default()).IntegrationView__Subheading),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: t("integrations:my:auto_interview_scheduling_description")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            " *",
                                            t("integrations:my:auto_interview_scheduling_note"),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: t("integrations:my:auto_interview_scheduling_note_platform")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((integration_index_module_default()).IntegrationView),
                                children: enable_items.map(function(card, index) {
                                    if (card.name == "Cronofy") {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((integration_index_module_default()).IntegrationView__BoxWidth, " w100"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((integration_index_module_default()).IntegrationView__Box),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((integration_index_module_default()).IntegrationView__BoxImage),
                                                        children: card.logo
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((integration_index_module_default()).IntegrationView__ConnectButton),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                            buttonstyle: getButtonClass(card),
                                                            onClick: function() {
                                                                var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                                                                    var result;
                                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    connectDisconnectIntegration(e, router, card, setApiError)
                                                                                ];
                                                                            case 1:
                                                                                result = _state.sent();
                                                                                if (result && !result.connected) {
                                                                                    console.log(result);
                                                                                    enable_items[card.index] = result;
                                                                                    setEnableItems((0,_to_consumable_array/* default */.Z)(enable_items));
                                                                                }
                                                                                return [
                                                                                    2
                                                                                ];
                                                                        }
                                                                    });
                                                                });
                                                                return function(e) {
                                                                    return _ref.apply(this, arguments);
                                                                };
                                                            }(),
                                                            children: getIntegrationsStatus(card, t)
                                                        })
                                                    })
                                                ]
                                            })
                                        }, index);
                                    }
                                })
                            })
                        ]
                    }) : "",
                    enable_items.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((integration_index_module_default()).IntegrationView),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((integration_index_module_default()).IntegrationView__Title),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    children: t("integrations:my:email_candidates")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((integration_index_module_default()).IntegrationView__Subheading),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("integrations:my:email_provider")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((integration_index_module_default()).IntegrationView__FlexFlow),
                                children: enable_items.map(function(card, index) {
                                    if (card.name == "Gmail" || card.name == "Microsoft") {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((integration_index_module_default()).IntegrationView__BoxWidth, " ").concat((integration_index_module_default()).IntegrationView__w100),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((integration_index_module_default()).IntegrationView__Box),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((integration_index_module_default()).IntegrationView__BoxImage),
                                                        children: card.logo
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((integration_index_module_default()).IntegrationView__ConnectButton),
                                                        children: card.name == "Gmail" && getIntegrationsStatus(card, t) == t("button:connect") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((integration_index_module_default()).IntegrationView__GoogleButton),
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                                    buttonstyle: "signingooglebtn",
                                                                    onClick: function() {
                                                                        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                                                                            var result;
                                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                                switch(_state.label){
                                                                                    case 0:
                                                                                        if (!card.is_linkable) return [
                                                                                            3,
                                                                                            2
                                                                                        ];
                                                                                        return [
                                                                                            4,
                                                                                            connectDisconnectIntegration(e, router, card, setApiError)
                                                                                        ];
                                                                                    case 1:
                                                                                        result = _state.sent();
                                                                                        if (result && !result.connected) {
                                                                                            enable_items[card.index] = result;
                                                                                            setEnableItems((0,_to_consumable_array/* default */.Z)(enable_items));
                                                                                        }
                                                                                        _state.label = 2;
                                                                                    case 2:
                                                                                        return [
                                                                                            2
                                                                                        ];
                                                                                }
                                                                            });
                                                                        });
                                                                        return function(e) {
                                                                            return _ref.apply(this, arguments);
                                                                        };
                                                                    }(),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "signingoogle buttonWithIcon",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                src: "/images/pages/integration/gicon.png",
                                                                                alt: ""
                                                                            }),
                                                                            "Sign in with Google"
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                            buttonstyle: getButtonClass(card),
                                                            onClick: function() {
                                                                var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                                                                    var result;
                                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    connectDisconnectIntegration(e, router, card, setApiError)
                                                                                ];
                                                                            case 1:
                                                                                result = _state.sent();
                                                                                if (result && !result.connected) {
                                                                                    enable_items[card.index] = result;
                                                                                    setEnableItems((0,_to_consumable_array/* default */.Z)(enable_items));
                                                                                }
                                                                                return [
                                                                                    2
                                                                                ];
                                                                        }
                                                                    });
                                                                });
                                                                return function(e) {
                                                                    return _ref.apply(this, arguments);
                                                                };
                                                            }(),
                                                            children: getIntegrationsStatus(card, t)
                                                        })
                                                    })
                                                ]
                                            })
                                        }, index);
                                    }
                                })
                            })
                        ]
                    }) : "",
                    enable_items.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((integration_index_module_default()).IntegrationView),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((integration_index_module_default()).IntegrationView__Title),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    children: t("integrations:my:video_conferencing")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((integration_index_module_default()).IntegrationView__Subheading),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("integrations:my:video_conferencing_connect")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((integration_index_module_default()).IntegrationView__FlexFlow),
                                children: [
                                    enable_items.map(function(card, index) {
                                        if (card.name == "Teams" || card.name == "Zoom") {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((integration_index_module_default()).IntegrationView__BoxWidth, " ").concat((integration_index_module_default()).IntegrationView__w100),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((integration_index_module_default()).IntegrationView__Box),
                                                    children: [
                                                        card.name == "Zoom" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((integration_index_module_default()).IntegrationView__BoxImage),
                                                            children: [
                                                                card.logo,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "".concat((integration_index_module_default()).IntegrationView__BoxImage__InfoIcon),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: zoom_document_url.replace("$language", i18n.language),
                                                                        target: "_blank",
                                                                        style: {
                                                                            color: "#00325A"
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(info/* default */.Z, {})
                                                                    })
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((integration_index_module_default()).IntegrationView__BoxImage),
                                                            children: card.logo
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((integration_index_module_default()).IntegrationView__ConnectButton),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                                buttonstyle: getButtonClass(card),
                                                                onClick: function() {
                                                                    var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                                                                        var result;
                                                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                                                            switch(_state.label){
                                                                                case 0:
                                                                                    return [
                                                                                        4,
                                                                                        connectDisconnectIntegration(e, router, card, setApiError)
                                                                                    ];
                                                                                case 1:
                                                                                    result = _state.sent();
                                                                                    if (result && !result.connected) {
                                                                                        enable_items[card.index] = result;
                                                                                        setEnableItems((0,_to_consumable_array/* default */.Z)(enable_items));
                                                                                    }
                                                                                    return [
                                                                                        2
                                                                                    ];
                                                                            }
                                                                        });
                                                                    });
                                                                    return function(e) {
                                                                        return _ref.apply(this, arguments);
                                                                    };
                                                                }(),
                                                                children: getIntegrationsStatus(card, t)
                                                            })
                                                        })
                                                    ]
                                                })
                                            }, index);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((integration_index_module_default()).IntegrationView__BoxWidth, " ").concat((integration_index_module_default()).IntegrationView__w100),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((integration_index_module_default()).IntegrationView__Box),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((integration_index_module_default()).IntegrationView__BoxImage),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/images/pages/integration/google_meet.png",
                                                        width: "127px",
                                                        alt: "Google Meet"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((integration_index_module_default()).IntegrationView__ViewMoreButton),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                        onClick: handleOpenPopup,
                                                        children: t("button:view_details")
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : "",
                    enable_items.length > 0 && false ? /*#__PURE__*/ 0 : "",
                    showPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationPopup, {
                        setShowPopup: setShowPopup,
                        onClose: handleClosePopup
                    }),
                    skipModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(skip_modal/* SkipModal */.i, {
                        setBtnPopup: setSkipModal,
                        router: router
                    }),
                    isQuickSetup && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((integration_index_module_default()).SkipFinishButton, " space"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "buttonolumngap ".concat((integration_index_module_default()).Integration__SubmitSection),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_button/* default */.Z, {
                                    buttonstyle: (button_index_module_default()).secondarybtnborder,
                                    type: "button",
                                    onClick: function() {
                                        setSkipModal(true);
                                    },
                                    children: [
                                        "   ",
                                        t("button:skip"),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_button/* default */.Z, {
                                    buttonstyle: (button_index_module_default()).primarybtn,
                                    type: "button",
                                    onClick: function() {
                                        cronofyConnectedOrNot(step, router, activitiesAction);
                                    },
                                    children: [
                                        "   ",
                                        t("button:finish"),
                                        " "
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
MyIntegrations.layout = common/* ClientDashboard */.LD;
/* harmony default export */ var my_integration = (MyIntegrations);


/***/ }),

/***/ 49712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ my_preferences; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./src/actions/common/common.js
var common = __webpack_require__(1739);
// EXTERNAL MODULE: ./src/imports-files/common/common.js + 377 modules
var common_common = __webpack_require__(96047);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(38641);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(18186);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4012);
// EXTERNAL MODULE: ../../shared/node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(30711);
;// CONCATENATED MODULE: ./src/actions/pages/clients/my-preferences.js











function handleFormSubmit(values, router, formRef, isQuickSetup, setApiError, t1) {
    return _handleFormSubmit.apply(this, arguments);
}
function _handleFormSubmit() {
    _handleFormSubmit = (0,_async_to_generator/* default */.Z)(function(values, router, formRef, isQuickSetup, setApiError, t1) {
        var body, result, status_code, customToastrAction, response, new_values, next_step, url;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    body = values;
                    return [
                        4,
                        new MyPreferences().addPreferences(body, isQuickSetup)
                    ];
                case 1:
                    result = _state.sent();
                    status_code = result.status || result.response.status;
                    customToastrAction = new common_common/* CustomToastrAction */.Y5();
                    setApiError(result.request);
                    switch(status_code){
                        case common_common/* SUCCESS_REPONSE_CODE */.Us:
                            response = result.data;
                            if (response.success) {
                                customToastrAction.setNormalToastr(response.success, "success");
                            // toastr.success(response.success)
                            }
                            new_values = reset_the_initial_values(response, INITIAL_VALUES(t1), "submit", t1);
                            formRef.current.setValues(new_values);
                            if (result.data.next_step) {
                                next_step = result.data.next_step;
                                url = "".concat(common_common/* REDIRECT.client.quick_setup */.RQ.client.quick_setup).concat(next_step);
                                next_step == "complete" ? router.push(common_common/* REDIRECT.client.activities */.RQ.client.activities) : router.push(url);
                            }
                            break;
                        case common_common/* UNPROCESSABLE_ENTITY_RESPONSE_CODE */.Mn:
                            return [
                                2,
                                result.response.data.error
                            ];
                            break;
                        default:
                            (0,common_common/* handleOtherResponseCode */.GB)(status_code, router);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _handleFormSubmit.apply(this, arguments);
}
function handelChecked(row, formik, id) {
    formik.values.users.preferences_attributes[id]._destroy = !row.target.checked;
    if (row.target.checked) {
        formik.values.users.preferences_attributes[id].start_time = "09:00";
        formik.values.users.preferences_attributes[id].end_time = "17:00";
    }
    var parent_element = row.target.closest(".MuiTableRow-root");
    var inputs = parent_element.querySelectorAll('input[type="text"]');
    var is_disable_element = parent_element.querySelector(".isDisable");
    is_disable_element.value = !row.target.checked;
    var event = new Event("input", {
        bubbles: true
    });
    is_disable_element.dispatchEvent(event);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            if (element.disabled) {
                element.disabled = false;
            } else {
                element.disabled = true;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function handleDisableValueChange(formik, fieldName) {
    return _handleDisableValueChange.apply(this, arguments);
}
function _handleDisableValueChange() {
    _handleDisableValueChange = (0,_async_to_generator/* default */.Z)(function(formik, fieldName) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        formik.setFieldValue(fieldName, !(0,common_common/* getIn */.u9)(formik.values, fieldName))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _handleDisableValueChange.apply(this, arguments);
}
function getMyPreferencesData(router, setApiError) {
    return _getMyPreferencesData.apply(this, arguments);
}
function _getMyPreferencesData() {
    _getMyPreferencesData = (0,_async_to_generator/* default */.Z)(function(router, setApiError) {
        var body, _tmp, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = (_tmp.user_type = "client", _tmp.step = router.query.step, _tmp);
                    return [
                        4,
                        new MyPreferences().getPreferences(body)
                    ];
                case 1:
                    data = _state.sent();
                    setApiError(data.request);
                    if (data.status == undefined || data.status != 200) {
                        error = new Error("An error occurred while fetching the data.");
                        error.status = data.response.status;
                        throw error;
                    } else {
                        return [
                            2,
                            data.data
                        ];
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getMyPreferencesData.apply(this, arguments);
}
function reset_the_initial_values(new_values, initial_values, action, t1) {
    var ref, ref1, ref2, ref3, ref4;
    initial_values = createInitialValues(WEEKDAYS(t1));
    var new_user_preferences = (ref = new_values.users) === null || ref === void 0 ? void 0 : ref.preferences_attributes;
    initial_values.users.preferences_attributes = initial_values.users.preferences_attributes.map(function(old_value) {
        if (new_user_preferences) {
            var value = new_user_preferences.filter(function(x) {
                return x.weekday == old_value.weekday;
            })[0];
            if (value && value.weekday == old_value.weekday) {
                old_value = value;
                old_value.isDisabled = false;
                old_value._destroy = false;
            }
        } else {
            old_value = {
                isDisabled: true,
                weekday: old_value.weekday,
                start_time: "",
                end_time: "",
                _destroy: true
            };
        }
        return old_value;
    });
    initial_values.users.client_user_attributes.buffer_before_interview = (ref1 = new_values.users.client_user_attributes) === null || ref1 === void 0 ? void 0 : ref1.buffer_before_interview;
    initial_values.users.client_user_attributes.buffer_after_interview = (ref2 = new_values.users.client_user_attributes) === null || ref2 === void 0 ? void 0 : ref2.buffer_after_interview;
    initial_values.users.client_user_attributes.timezone = (ref3 = new_values.users.client_user_attributes) === null || ref3 === void 0 ? void 0 : ref3.timezone;
    initial_values.users.client_user_attributes.date_format = (ref4 = new_values.users.client_user_attributes) === null || ref4 === void 0 ? void 0 : ref4.date_format;
    return initial_values;
}
function NumberField(param) {
    var field = param.field, className = param.className, disabled = param.disabled, format = param.format, placeholder = param.placeholder;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
        format: "##:##",
        className: className,
        name: field.name,
        disabled: disabled
    }));
}
var MyPreferencesAction = /*#__PURE__*/ function() {
    "use strict";
    function MyPreferencesAction(setTimePicker) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, MyPreferencesAction);
        (0,_define_property/* default */.Z)(this, "onSuggestionsClearRequested", function() {
            _this.setTimePicker([]);
        });
        var _this1 = this;
        (0,_define_property/* default */.Z)(this, "onSuggestionsFetchRequested", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    _this1.setTimePicker(_this1.options);
                    return [
                        2
                    ];
                });
            });
            return function(value) {
                return _ref.apply(this, arguments);
            };
        }());
        this.setTimePicker = setTimePicker;
    }
    (0,_create_class/* default */.Z)(MyPreferencesAction, [
        {
            key: "options",
            value: function options() {
                var arr = [];
                for(var i = 0; i < 24; i++){
                    if (i < 10) {
                        arr.push("0" + i + ":00");
                        arr.push("0" + i + ":30");
                    } else {
                        arr.push(i + ":00");
                        arr.push(i + ":30");
                    }
                }
                return arr;
            }
        },
        {
            key: "getSuggestionValue",
            value: function getSuggestionValue(suggestion) {
                return suggestion;
            }
        },
        {
            key: "shouldRenderSuggestions",
            value: function shouldRenderSuggestions(value) {
                return value.trim().length >= 1;
            }
        },
        {
            key: "renderSuggestion",
            value: function renderSuggestion(suggestion) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        " ",
                        suggestion
                    ]
                });
            }
        },
        {
            key: "renderInputComponent",
            value: function renderInputComponent(inputProps, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, add_selected_value, params) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_common/* Field */.gN, (0,_object_spread/* default */.Z)({
                        component: NumberField,
                        className: (_index_module_default()).Form__Input,
                        autoComplete: "password"
                    }, inputProps))
                });
            }
        },
        {
            key: "changePreferenceTime",
            value: function changePreferenceTime(formik, old_time_zone, new_time_zone) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var body, data, error, old_preferences;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                body = formik.values;
                                body.users.client_user_attributes.old_timezone = old_time_zone;
                                body.users.client_user_attributes.timezone = new_time_zone;
                                return [
                                    4,
                                    new MyPreferences().updateTimeZone(body)
                                ];
                            case 1:
                                data = _state.sent();
                                if (data.status == undefined || data.status != 200) {
                                    error = new Error("An error occurred while fetching the data.");
                                    error.status = data.response.status;
                                    throw error;
                                } else {
                                    old_preferences = formik.values.users.preferences_attributes;
                                    data.data.users.preferences_attributes.map(function(preference, index) {
                                        if (!old_preferences[index].isDisabled) {
                                            old_preferences[index].start_time = preference.start_time;
                                            old_preferences[index].end_time = preference.end_time;
                                        }
                                        return preference;
                                    });
                                    formik.setFieldValue("users.preferences_attributes", old_preferences);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "showCopyOptionIndex",
            value: function showCopyOptionIndex(formik) {
                var ref, ref1, ref2;
                var enabled_index;
                length = ((ref = formik.values) === null || ref === void 0 ? void 0 : (ref1 = ref.users) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.preferences_attributes) === null || ref2 === void 0 ? void 0 : ref2.length) || 0;
                for(var i = 0; i < length; i++){
                    var ref3, ref4;
                    if (!((ref3 = formik.values) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.users) === null || ref4 === void 0 ? void 0 : ref4.preferences_attributes[i]._destroy)) {
                        enabled_index = i;
                        break;
                    }
                }
                return enabled_index;
            }
        },
        {
            key: "copyTime",
            value: function copyTime(formik, day) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3, ref4, ref5, other_selected_days, customToastrAction, start_time, end_time, ref6, ref7, ref8;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                other_selected_days = 0;
                                customToastrAction = new common_common/* CustomToastrAction */.Y5();
                                start_time = (ref2 = (ref = formik.values) === null || ref === void 0 ? void 0 : (ref1 = ref.users) === null || ref1 === void 0 ? void 0 : ref1.preferences_attributes[day]) === null || ref2 === void 0 ? void 0 : ref2.start_time;
                                end_time = (ref5 = (ref3 = formik.values) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.users) === null || ref4 === void 0 ? void 0 : ref4.preferences_attributes[day]) === null || ref5 === void 0 ? void 0 : ref5.end_time;
                                if (!(isCorrectTime(start_time) && isCorrectTime(end_time) && isEqualTime(start_time, end_time) && isValidTime(start_time, end_time))) return [
                                    3,
                                    1
                                ];
                                (ref6 = formik.values) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.users) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.preferences_attributes) === null || ref8 === void 0 ? void 0 : ref8.map(function(item, index) {
                                    if (!item._destroy && day != index) {
                                        var ref, ref1, ref2, ref3;
                                        other_selected_days += 1;
                                        formik.setFieldValue("users.preferences_attributes[".concat(index, "].start_time"), (ref = formik.values) === null || ref === void 0 ? void 0 : (ref1 = ref.users) === null || ref1 === void 0 ? void 0 : ref1.preferences_attributes[day].start_time);
                                        formik.setFieldValue("users.preferences_attributes[".concat(index, "].end_time"), (ref2 = formik.values) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.users) === null || ref3 === void 0 ? void 0 : ref3.preferences_attributes[day].end_time);
                                    }
                                });
                                if (other_selected_days == 0) {
                                    customToastrAction.setNormalToastr(t("my_preferences:no_more_days"), "error");
                                }
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    formik.validateForm()
                                ];
                            case 2:
                                _state.sent();
                                formik.submitForm();
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return MyPreferencesAction;
}();

// EXTERNAL MODULE: ./src/imports-files/pages/admins/dashboard/clients/integration.js + 3 modules
var integration = __webpack_require__(48847);
// EXTERNAL MODULE: ./src/imports-files/pages/admins/dashboard/clients/new.js + 2 modules
var clients_new = __webpack_require__(97336);
// EXTERNAL MODULE: ../../shared/node_modules/moment/moment.js
var moment = __webpack_require__(62290);
;// CONCATENATED MODULE: ./src/constants/pages/clients/my-preferences.js


var WEEKDAYS = function(t) {
    return [
        {
            id: 0,
            day: t("my_preferences:weekdays:Monday"),
            state: true
        },
        {
            id: 1,
            day: t("my_preferences:weekdays:Tuesday"),
            state: true
        },
        {
            id: 2,
            day: t("my_preferences:weekdays:Wednesday"),
            state: true
        },
        {
            id: 3,
            day: t("my_preferences:weekdays:Thursday"),
            state: true
        },
        {
            id: 4,
            day: t("my_preferences:weekdays:Friday"),
            state: true
        },
        {
            id: 5,
            day: t("my_preferences:weekdays:Saturday"),
            state: true
        },
        {
            id: 6,
            day: t("my_preferences:weekdays:Sunday"),
            state: true
        }
    ];
};
var TIMEINTERVAL = function(t) {
    return {
        options: [
            {
                value: null,
                label: t("placeholder:select:please")
            },
            {
                value: 15,
                label: "15"
            },
            {
                value: 30,
                label: "30"
            },
            {
                value: 45,
                label: "45"
            },
            {
                value: 60,
                label: "60"
            },
            {
                value: 90,
                label: "90"
            }
        ]
    };
};
var INITIAL_VALUES = function(t) {
    return createInitialValues(WEEKDAYS(t));
};
function preferenceValidation() {
    var validation = {
        users: clients_new/* Yup.object */.sm.object({
            preferences_attributes: clients_new/* Yup.array */.sm.array().of(clients_new/* Yup.object */.sm.object({
                isDisabled: clients_new/* Yup.boolean */.sm.boolean(),
                weekday: clients_new/* Yup.string */.sm.string().required((0,clients_new/* TRANSLATION */.TA)("errors:required")),
                start_time: clients_new/* Yup.string */.sm.string().when("isDisabled", {
                    is: false,
                    then: clients_new/* Yup.string */.sm.string().required((0,clients_new/* TRANSLATION */.TA)("errors:required"))
                }).when("isDisabled", {
                    is: false,
                    then: clients_new/* Yup.string */.sm.string().test("is-correct", (0,clients_new/* TRANSLATION */.TA)("errors:invalid_start_time"), function(value) {
                        return isCorrectTime(value);
                    })
                }),
                end_time: clients_new/* Yup.string */.sm.string().when("isDisabled", {
                    is: false,
                    then: clients_new/* Yup.string */.sm.string().required((0,clients_new/* TRANSLATION */.TA)("errors:required"))
                }).when("isDisabled", {
                    is: false,
                    then: clients_new/* Yup.string */.sm.string().test("is-correct", (0,clients_new/* TRANSLATION */.TA)("errors:invalid_end_time"), function(value) {
                        return isCorrectTime(value);
                    })
                }).when("isDisabled", {
                    is: false,
                    then: clients_new/* Yup.string */.sm.string().test("is-greater", (0,clients_new/* TRANSLATION */.TA)("errors:end_time_greater_then_start_time"), function(value) {
                        var start_time = this.parent.start_time;
                        return isValidTime(start_time, value);
                    })
                }).when("isDisabled", {
                    is: false,
                    then: clients_new/* Yup.string */.sm.string().test("is-equal", (0,clients_new/* TRANSLATION */.TA)("errors:start_end_not_same"), function(value) {
                        var start_time = this.parent.start_time;
                        return isEqualTime(start_time, value);
                    })
                })
            })),
            client_user_attributes: clients_new/* Yup.object */.sm.object({
                buffer_before_interview: clients_new/* Yup.string */.sm.string().nullable(true),
                buffer_after_interview: clients_new/* Yup.string */.sm.string().nullable(true)
            })
        })
    };
    var VALIDATION_SCHEMA = clients_new/* Yup.object */.sm.object().shape(validation);
    return VALIDATION_SCHEMA;
}
function createInitialValues(WEEKDAYS) {
    var initialValues = {
        users: {
            preferences_attributes: [],
            client_user_attributes: {
                buffer_before_interview: "",
                buffer_after_interview: "",
                timezone: ""
            }
        }
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = WEEKDAYS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            initialValues.users.preferences_attributes.push({
                isDisabled: true,
                weekday: element.id,
                start_time: "",
                end_time: "",
                _destroy: true
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return initialValues;
}
function isValidTime(start_time, end_time) {
    var start_int = parseInt(start_time.replace(":", ""));
    var end_int = parseInt(end_time.replace(":", ""));
    if (start_time.includes("-") || end_time.includes("-")) return true;
    return start_int <= end_int;
}
function isEqualTime(start_time, end_time) {
    var start_int = parseInt(start_time.replace(":", ""));
    var end_int = parseInt(end_time.replace(":", ""));
    if (start_time.includes("-") || end_time.includes("-")) return true;
    return start_time != end_time;
}
function weekDayData(element) {
    var isEnableDay =  false || element.id < 5;
    return {
        isDisabled: !isEnableDay,
        weekday: element.id,
        start_time: isEnableDay ? "09:00" : "",
        end_time: isEnableDay ? "17:00" : "",
        _destroy: !isEnableDay
    };
}
function isCorrectTime(value) {
    var time = value.replace(":", "");
    return !time.includes("-");
}

// EXTERNAL MODULE: ./src/components/skip-modal.js
var skip_modal = __webpack_require__(53594);
// EXTERNAL MODULE: ./src/components/quick-add.js
var quick_add = __webpack_require__(35294);
// EXTERNAL MODULE: ./src/services/common/send-request.js
var send_request = __webpack_require__(34964);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
;// CONCATENATED MODULE: ./src/services/pages/clients/my-preferences.js







var MyPreferences = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(MyPreferences, SendRequest);
    var _super = (0,_create_super/* default */.Z)(MyPreferences);
    function MyPreferences() {
        (0,_class_call_check/* default */.Z)(this, MyPreferences);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(MyPreferences, [
        {
            key: "addPreferences",
            value: function addPreferences(params, quick_setup) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var body, _tmp, result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                body = (_tmp["user"] = params.users, _tmp);
                                if (quick_setup) body.quick_setup = quick_setup;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    common_common/* axios.post */.od.post(common_common/* API.client.my_preferences.ADD_MY_PREFERENCES_URL */.bl.client.my_preferences.ADD_MY_PREFERENCES_URL, body, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPreferences",
            value: function getPreferences(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    common_common/* axios.get */.od.get(common_common/* API.client.my_preferences.GET_MY_PREFERENCES_URL */.bl.client.my_preferences.GET_MY_PREFERENCES_URL, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateTimeZone",
            value: function updateTimeZone(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    common_common/* axios.post */.od.post(common_common/* API.client.my_preferences.UPDATE_TIME_ZONE */.bl.client.my_preferences.UPDATE_TIME_ZONE, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return MyPreferences;
}(send_request/* SendRequest */.L);

// EXTERNAL MODULE: ./src/styles/pages/clients/my-preferences/_index.module.scss
var _index_module = __webpack_require__(45895);
var _index_module_default = /*#__PURE__*/__webpack_require__.n(_index_module);
// EXTERNAL MODULE: ../../shared/node_modules/react-datetime/dist/react-datetime.cjs.js
var react_datetime_cjs = __webpack_require__(32487);
;// CONCATENATED MODULE: ./src/imports-files/pages/clients/my-preferences.js
// ----------------- Common Library -----------------

// ----------------- Common Library -----------------
// -------------------------------  ACTIONS -------------------------------------

// -------------------------------  ACTIONS -------------------------------------
//----------------- Material UI Table Components---------------

//----------------- Material UI Table Components---------------
// -----------------------------  CONSTANTS -----------------------------

// -----------------------------  CONSTANTS -----------------------------
// ----------------- COMPONENTS -----------------


// ----------------- COMPONENTS -----------------
// ----------------------------- SERVICES ---------------------------------------


// ----------------------------- SERVICES ---------------------------------------
//-----------------StyleSheets --------------------------

//-----------------StyleSheets --------------------------
//------------------ Time Picker -----------------------
 //------------------ Time Picker -----------------------

;// CONCATENATED MODULE: ./src/pages/clients/dashboard/my-preferences.js






function my_preferences_MyPreferences(props) {
    var closeDropDown = function closeDropDown(setIsActive) {
        setTimeout(function() {
            return setIsActive(false);
        }, 50);
    };
    var CustomCheckbox = function CustomCheckbox(param) {
        var field = param.field, onChange = param.onChange, checked = param.checked, icon = param.icon, checkedIcon = param.checkedIcon;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((_index_module_default()).Form__LabelCheck, " Mui__CustomCheckbox"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_common/* Checkbox */.XZ, {
                onChange: onChange,
                name: field.name,
                checked: checked,
                icon: icon || /*#__PURE__*/ (0,jsx_runtime.jsx)(common_common/* DefaultCheckbox */.v0, {}),
                checkedIcon: checkedIcon || /*#__PURE__*/ (0,jsx_runtime.jsx)(common_common/* CheckedCheckbox */.bN, {})
            })
        });
    };
    (0,common_common/* clearSWRCache */.A$)("my-preference-data");
    var ref = (0,_sliced_to_array/* default */.Z)((0,common_common/* useState */.eJ)(null), 2), apiError = ref[0], setApiError = ref[1];
    var errorPages = new common_common/* ErrorPages */.dC();
    var router = (0,common_common/* useRouter */.tv)();
    var ref1 = (0,common_common/* useTranslation */.$G)(), t = ref1.t, i18n = ref1.i18n;
    var ref2 = (0,common_common/* useSWR */.dH)("my-preference-data", function() {
        return getMyPreferencesData(router, setApiError);
    }), data = ref2.data, error = ref2.error;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,common_common/* useState */.eJ)(INITIAL_VALUES(t)), 2), initial_values = ref3[0], setInitialValue = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,common_common/* useState */.eJ)(true), 2), isLoading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,common_common/* useState */.eJ)(false), 2), pageLoaded = ref5[0], setPageLoaded = ref5[1];
    var formRef = (0,common_common/* useRef */.sO)(null);
    var queryClient = (0,common_common/* useQueryClient */.NL)();
    var step = router.query.step;
    var isQuickSetup = router.query.step && router.query.step == "my_preferences" ? true : false;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,common_common/* useState */.eJ)(false), 2), skipModal = ref6[0], setSkipModal = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,common_common/* useState */.eJ)(props.session), 2), session = ref7[0], setSession = ref7[1];
    var common_action = new common/* CommonAction */.x();
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,common_common/* useState */.eJ)([]), 2), timezonOptions = ref8[0], setTimezoneOptions = ref8[1];
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,common_common/* useState */.eJ)([]), 2), dateOptions = ref9[0], setDateOptions = ref9[1];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,common_common/* useState */.eJ)([]), 2), timePicker = ref10[0], setTimePicker = ref10[1];
    var myPreferencesAction = new MyPreferencesAction(setTimePicker);
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,common_common/* useState */.eJ)("10:12"), 2), dateEx7 = ref11[0], setDateEx7 = ref11[1];
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,common_common/* useState */.eJ)(false), 2), isActive = ref12[0], setIsActive = ref12[1];
    (0,common_common/* useEffect */.d4)(function() {
        if (data) {
            if (!pageLoaded) {
                var values = reset_the_initial_values(data, INITIAL_VALUES(t), "page", t);
                setTimezoneOptions(data.timezones);
                setInitialValue(values);
                setDateOptions(data.date_formats);
                setPageLoaded(true);
            }
            if (isQuickSetup) setTimeout(function() {
                new common_common/* SidebarAction */.Dv().subsidebarQuickSetupChangeIcon(data.sidebar_options.complete_steps, "my_preferences");
            }, 750);
            setLoading(false);
        }
    }, [
        data
    ]);
    if (isLoading || error || errorPages.handleErrorCodes(apiError === null || apiError === void 0 ? void 0 : apiError.status)) {
        var renderPage = error || apiError ? errorPages.renderPage((error === null || error === void 0 ? void 0 : error.status) || (apiError === null || apiError === void 0 ? void 0 : apiError.status), router) : null;
        return renderPage;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "Page DashboardPageContent MyPreferencesPage  ".concat((_index_module_default()).MyPreferences, " ").concat((_index_module_default()).NoMaxGrid),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_common/* motion.div */.EA.div, {
            initial: "pageInitial",
            animate: "pageAnimate",
            exit: "pageExit",
            variants: common_common/* PAGE_ANIMATION_OPTIONS */.Mf,
            transition: {
                delay: 0.2
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (_index_module_default()).MyPreferences__Container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "Dpflex JustifyEnd",
                        children: (session === null || session === void 0 ? void 0 : session.role) != "reviewer" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (_index_module_default()).TopSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(quick_add/* default */.Z, {
                                session: session
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (_index_module_default()).MyPreferences__FormSection,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "mt0 ".concat((_index_module_default()).ClientCompany__Heading),
                                children: t("my_preferences:heading")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (_index_module_default()).MyPreferences__Subheading,
                                    children: t("my_preferences:description")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_common/* Formik */.J9, {
                        initialValues: initial_values,
                        validationSchema: preferenceValidation(),
                        onSubmit: function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(values, actions) {
                                var errors;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                handleFormSubmit(values, router, formRef, isQuickSetup, setApiError, t)
                                            ];
                                        case 1:
                                            errors = _state.sent();
                                            actions.setErrors(errors);
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(values, actions) {
                                return _ref.apply(this, arguments);
                            };
                        }(),
                        innerRef: formRef,
                        children: function(formik) {
                            var ref, ref1, ref2;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(common_common/* Form */.l0, {
                                name: "users",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (_index_module_default()).Buffer,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: t("my_preferences:date_format")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("my_preferences:date_format_description")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (_index_module_default()).Buffer__BufferTimeGrid,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (_index_module_default()).Buffer__time,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_common/* FormikControl */.gt, {
                                                        className: "".concat((_index_module_default()).Form__Input),
                                                        control: "select",
                                                        errorClass: (_index_module_default()).Form__Error,
                                                        formik: formik,
                                                        name: "users.client_user_attributes.date_format",
                                                        onChange: function() {
                                                            var _ref = (0,_async_to_generator/* default */.Z)(function(option) {
                                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                                    switch(_state.label){
                                                                        case 0:
                                                                            return [
                                                                                4,
                                                                                formik.setFieldValue("users.client_user_attributes.date_format", option.value)
                                                                            ];
                                                                        case 1:
                                                                            _state.sent();
                                                                            return [
                                                                                2
                                                                            ];
                                                                    }
                                                                });
                                                            });
                                                            return function(option) {
                                                                return _ref.apply(this, arguments);
                                                            };
                                                        }(),
                                                        options: dateOptions,
                                                        style: (0,common_common/* InputError */.pd)(formik, "users.client_user_attributes.date_format"),
                                                        default: (ref = formik.values) === null || ref === void 0 ? void 0 : ref.users.client_user_attributes.date_format
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (_index_module_default()).Buffer,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: t("my_preferences:time_zone")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("my_preferences:time_zone_description")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (_index_module_default()).Buffer__BufferTimeGrid,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (_index_module_default()).Buffer__time,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_common/* FormikControl */.gt, {
                                                        className: "".concat((_index_module_default()).Form__Input),
                                                        control: "select",
                                                        errorClass: (_index_module_default()).Form__Error,
                                                        formik: formik,
                                                        name: "users.client_user_attributes.timezone",
                                                        onChange: function() {
                                                            var _ref = (0,_async_to_generator/* default */.Z)(function(option) {
                                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                                    switch(_state.label){
                                                                        case 0:
                                                                            // let old_time_zone = formik.values.users.client_user_attributes.timezone
                                                                            // await myPreferencesAction.changePreferenceTime(formik, old_time_zone, option.value)
                                                                            return [
                                                                                4,
                                                                                formik.setFieldValue("users.client_user_attributes.timezone", option.value)
                                                                            ];
                                                                        case 1:
                                                                            _state.sent();
                                                                            return [
                                                                                2
                                                                            ];
                                                                    }
                                                                });
                                                            });
                                                            return function(option) {
                                                                return _ref.apply(this, arguments);
                                                            };
                                                        }(),
                                                        options: timezonOptions,
                                                        style: (0,common_common/* InputError */.pd)(formik, "users.client_user_attributes.timezone"),
                                                        default: (ref1 = formik.values) === null || ref1 === void 0 ? void 0 : ref1.users.client_user_attributes.timezone
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (_index_module_default()).IntegrationTable,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(integration/* TableContainer */.xJ, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(integration/* Table */.iA, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(integration/* TableHead */.ss, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(integration/* TableRow */.SC, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(integration/* TableCell */.pj, {
                                                                    style: {
                                                                        width: "26.6%"
                                                                    },
                                                                    children: t("days")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(integration/* TableCell */.pj, {
                                                                    style: {
                                                                        width: "26.6%"
                                                                    },
                                                                    children: t("time:start")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(integration/* TableCell */.pj, {
                                                                    style: {
                                                                        width: "26.6%"
                                                                    },
                                                                    children: t("time:end")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(integration/* TableCell */.pj, {
                                                                    style: {
                                                                        width: "20%"
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(integration/* TableBody */.RM, {
                                                        children: WEEKDAYS(t).map(function(row, id) {
                                                            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(integration/* TableRow */.SC, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(integration/* TableCell */.pj, {
                                                                        style: {
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            gap: "16px",
                                                                            marginTop: "10px"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                className: "isDisable",
                                                                                type: "hidden",
                                                                                onInput: function() {
                                                                                    handleDisableValueChange(formik, "users.preferences_attributes[".concat(id, "].isDisabled"));
                                                                                },
                                                                                name: "users.preferences_attributes[".concat(id, "].isDisabled")
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_common/* Field */.gN, {
                                                                                component: CustomCheckbox,
                                                                                onChange: function(element) {
                                                                                    return handelChecked(element, formik, id);
                                                                                },
                                                                                name: "users.preferences_attributes[".concat(id, "].weekday"),
                                                                                checked: ((ref = formik.values.users.preferences_attributes[id]) === null || ref === void 0 ? void 0 : ref.isDisabled) != undefined ? formik.values.users.preferences_attributes[id].isDisabled ? false : true : false,
                                                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_common/* DefaultCheckbox */.v0, {}),
                                                                                checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_common/* CheckedCheckbox */.bN, {})
                                                                            }),
                                                                            row.day
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(integration/* TableCell */.pj, {
                                                                        align: "right",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_common/* FormikControl */.gt, {
                                                                            control: "timeinput",
                                                                            disabled: (ref3 = (ref1 = formik.values) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.users) === null || ref2 === void 0 ? void 0 : ref2.preferences_attributes[id]) === null || ref3 === void 0 ? void 0 : ref3.isDisabled,
                                                                            value: (ref4 = formik.values.users.preferences_attributes[id]) === null || ref4 === void 0 ? void 0 : ref4.start_time,
                                                                            fullTimeDropdown: !((ref7 = (ref5 = formik.values) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.users) === null || ref6 === void 0 ? void 0 : ref6.preferences_attributes[id]) === null || ref7 === void 0 ? void 0 : ref7.isDisabled),
                                                                            allowDelete: true,
                                                                            hour12Format: false,
                                                                            onChange: function(dateString) {
                                                                                formik.setFieldValue("users.preferences_attributes[".concat(id, "].start_time"), dateString);
                                                                            },
                                                                            inputProps: {
                                                                                style: (0,common_common/* InputError */.pd)(formik, "users.preferences_attributes[".concat(id, "].start_time"))
                                                                            },
                                                                            errorClass: (_index_module_default()).Form__Error,
                                                                            name: "users.preferences_attributes.".concat(id, ".start_time"),
                                                                            formik: formik,
                                                                            manuallyDisplayDropdown: true
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(integration/* TableCell */.pj, {
                                                                        align: "right",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_common/* FormikControl */.gt, {
                                                                            control: "timeinput",
                                                                            disabled: (ref10 = (ref8 = formik.values) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.users) === null || ref9 === void 0 ? void 0 : ref9.preferences_attributes[id]) === null || ref10 === void 0 ? void 0 : ref10.isDisabled,
                                                                            value: (ref11 = formik.values.users.preferences_attributes[id]) === null || ref11 === void 0 ? void 0 : ref11.end_time,
                                                                            fullTimeDropdown: !((ref14 = (ref12 = formik.values) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.users) === null || ref13 === void 0 ? void 0 : ref13.preferences_attributes[id]) === null || ref14 === void 0 ? void 0 : ref14.isDisabled),
                                                                            allowDelete: true,
                                                                            hour12Format: false,
                                                                            onChange: function(dateString) {
                                                                                formik.setFieldValue("users.preferences_attributes[".concat(id, "].end_time"), dateString);
                                                                            },
                                                                            inputProps: {
                                                                                style: (0,common_common/* InputError */.pd)(formik, "users.preferences_attributes[".concat(id, "].end_time"))
                                                                            },
                                                                            errorClass: (_index_module_default()).Form__Error,
                                                                            name: "users.preferences_attributes.".concat(id, ".end_time"),
                                                                            formik: formik
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(integration/* TableCell */.pj, {
                                                                        children: myPreferencesAction.showCopyOptionIndex(formik) != undefined && myPreferencesAction.showCopyOptionIndex(formik) == id && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (_index_module_default()).CopyTime,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_common/* Button */.zx, {
                                                                                onClick: function() {
                                                                                    return myPreferencesAction.copyTime(formik, id);
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_common/* CopyIcon */.TI, {}),
                                                                                    " ",
                                                                                    t("button:copy_time_to_all")
                                                                                ]
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }, id);
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (_index_module_default()).Buffer,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                children: [
                                                    t("time:buffer"),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            "(",
                                                            t("time:minutes"),
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "",
                                                children: t("time:buffer_description")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (_index_module_default()).Buffer__BufferTimeGrid,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (_index_module_default()).Buffer__time,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_common/* FormikControl */.gt, {
                                                        className: "".concat((_index_module_default()).Form__Input),
                                                        control: "select",
                                                        errorClass: (_index_module_default()).Form__Error,
                                                        formik: formik,
                                                        name: "users.client_user_attributes.buffer_before_interview",
                                                        onChange: function(option) {
                                                            formik.setFieldValue("users.client_user_attributes.buffer_before_interview", option.value);
                                                            formik.setFieldValue("users.client_user_attributes.buffer_after_interview", option.value);
                                                        },
                                                        options: TIMEINTERVAL(t).options,
                                                        style: (0,common_common/* InputError */.pd)(formik, "users.client_user_attributes.buffer_before_interview"),
                                                        default: (ref2 = formik.values) === null || ref2 === void 0 ? void 0 : ref2.users.client_user_attributes.buffer_before_interview
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (_index_module_default()).space
                                    }),
                                    !isQuickSetup && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (_index_module_default()).MyPreferences__SubmitSection,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_common/* Button */.zx, {
                                            type: "submit",
                                            buttonstyle: common_common/* ButtonStyle.primarybtn */.ZJ.primarybtn,
                                            children: t("button:save_changes")
                                        })
                                    }),
                                    skipModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(skip_modal/* SkipModal */.i, {
                                        setBtnPopup: setSkipModal,
                                        router: router
                                    }),
                                    isQuickSetup && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "buttonolumngap ".concat((_index_module_default()).MyPreferences__SubmitSectionNext),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_common/* Button */.zx, {
                                                buttonstyle: common_common/* ButtonStyle.secondarybtnborder */.ZJ.secondarybtnborder,
                                                type: "button",
                                                onClick: function() {
                                                    setSkipModal(true);
                                                },
                                                children: [
                                                    " ",
                                                    t("button:skip"),
                                                    "  "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_common/* Button */.zx, {
                                                buttonstyle: common_common/* ButtonStyle.primarybtn */.ZJ.primarybtn,
                                                type: "submit",
                                                children: [
                                                    " ",
                                                    t("button:next"),
                                                    " "
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            });
                        }
                    })
                ]
            })
        })
    });
}
my_preferences_MyPreferences.layout = common_common/* ClientDashboard */.LD;
/* harmony default export */ var my_preferences = (my_preferences_MyPreferences);


/***/ }),

/***/ 92867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ BacktoAllJobs; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _components_congrats__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1402);
/* harmony import */ var _styles_components_congrats_index_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66772);
/* harmony import */ var _styles_components_congrats_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_components_congrats_index_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95662);
/* harmony import */ var _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46780);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96047);
/* harmony import */ var _imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66172);
/* harmony import */ var _components_common_modal_modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99005);











function BacktoAllJobs(props) {
    var setCancelPopup = props.setCancelPopup;
    var router = (0,_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_3__/* .useRouter */ .tv)();
    var t = (0,_imports_files_common_common__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_congrats__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        trigger: props.trigger,
        heightClass: "confirmcontainer",
        children: [
            props.save_as_draft && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "".concat((_styles_components_congrats_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().Modalpopup__CloseCenter)),
                onClick: function() {
                    props.setCancelPopup(false);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__/* .Close */ .x8, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__/* .ConfirmationModalStyle.Modal__Container__Text */ .JD.Modal__Container__Text, " mt30"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: t("modal:confirmation:unsaved_changes")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__/* .ConfirmationModalStyle.Modal__Container__ButtonSection */ .JD.Modal__Container__ButtonSection, " ").concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__/* .ConfirmationModalStyle.Modal__ButtonWidth */ .JD.Modal__ButtonWidth),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                buttonstyle: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__/* .ConfirmationModalStyle.primarybtn */ .JD.primarybtn),
                                onClick: function() {
                                    return (0,_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_3__/* .cancelJob */ .UU)(router, setCancelPopup, props.setPageName, props.queryClient);
                                },
                                children: t("back:all_jobs")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "\xa0"
                            }),
                            props.save_as_draft ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                buttonstyle: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__/* .ConfirmationModalStyle.secondarybtn */ .JD.secondarybtn, " "),
                                onClick: function() {
                                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(event) {
                                        var ref, ref1, ref2, ref3;
                                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    event.preventDefault();
                                                    return [
                                                        4,
                                                        props.setSubmitState("draft")
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        4,
                                                        (ref = props.formRef) === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.validateForm()
                                                    ];
                                                case 2:
                                                    _state.sent();
                                                    return [
                                                        4,
                                                        (ref2 = props.formRef) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.current) === null || ref3 === void 0 ? void 0 : ref3.submitForm()
                                                    ];
                                                case 3:
                                                    _state.sent();
                                                    setCancelPopup(false);
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(event) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(),
                                children: t("button:save_as_draft")
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                buttonstyle: "".concat(_imports_files_components_common_modal_common_modal__WEBPACK_IMPORTED_MODULE_5__/* .ConfirmationModalStyle.secondarybtn */ .JD.secondarybtn, " "),
                                onClick: function() {
                                    setCancelPopup(false);
                                },
                                children: t("button:cancel")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 13142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DownloadFileFromEmail */
/* harmony import */ var _imports_files_pages_admins_dashboard_clients_edit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20504);







var DownloadFileFromEmail = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(SendRequest) {
    "use strict";
    _inherits(DownloadFileFromEmail, SendRequest);
    var _super = _create_super(DownloadFileFromEmail);
    function DownloadFileFromEmail() {
        _class_call_check(this, DownloadFileFromEmail);
        return _super.apply(this, arguments);
    }
    _create_class(DownloadFileFromEmail, [
        {
            key: "serviceDownloadFileFromEmail",
            value: function serviceDownloadFileFromEmail(params, job_application_id) {
                var _this = this;
                return _async_to_generator(function() {
                    var result, _tmp, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    axios.get(API.client.applicant.DOWNLOAD_ATTACHMENTS.replace("$job_application_id", job_application_id), (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return DownloadFileFromEmail;
}(SendRequest)));


/***/ }),

/***/ 40914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ CandidateInfoEditService; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96047);
/* harmony import */ var _services_common_send_request__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34964);








var CandidateInfoEditService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(CandidateInfoEditService, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(CandidateInfoEditService);
    function CandidateInfoEditService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, CandidateInfoEditService);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(CandidateInfoEditService, [
        {
            key: "UpdateCanidateInfo",
            value: function UpdateCanidateInfo(params, router) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var candidate_update_info, result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                candidate_update_info = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.applicant.CANDIDATE_UPDATE_INFO.replace */ .bl.client.applicant.CANDIDATE_UPDATE_INFO.replace("$applicant_id", router.query.applicant_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(candidate_update_info, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "UpdateGeneralCandidate",
            value: function UpdateGeneralCandidate(params, router) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.candidates.UPDATE_CANDIDATE.replace */ .bl.client.candidates.UPDATE_CANDIDATE.replace("$candidate_id", router.query.candidate_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.put */ .od.put(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getReferralUsers",
            value: function getReferralUsers() {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.referral_users */ .bl.referral_users;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAgencyUsers",
            value: function getAgencyUsers() {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.agency_users */ .bl.agency_users;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "LoadMoreDocuments",
            value: function LoadMoreDocuments(params, application_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.applicant.CANDIDATE_INFO.replace */ .bl.client.applicant.CANDIDATE_INFO.replace("$application_id", application_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "LoadMoreDocumentsGeneralView",
            value: function LoadMoreDocumentsGeneralView(params, candidate_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.applicant.GENERAL_PROFILE.replace */ .bl.client.applicant.GENERAL_PROFILE.replace("$candidate_id", candidate_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CandidateInfoEditService;
}(_services_common_send_request__WEBPACK_IMPORTED_MODULE_7__/* .SendRequest */ .L);


/***/ }),

/***/ 66693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ CandidateListAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96047);
/* harmony import */ var _imports_files_pages_admins_logout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63281);








var CandidateListAction = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(CandidateListAction, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(CandidateListAction);
    function CandidateListAction() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, CandidateListAction);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(CandidateListAction, [
        {
            key: "ActiveJobList",
            value: function ActiveJobList(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.candidates.ACTIVATE_JOB_LIST */ .bl.client.candidates.ACTIVATE_JOB_LIST, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "downloadCandidateResumes",
            value: function downloadCandidateResumes(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.candidates.DOWNLOAD_CANDIDATE_RESUMES */ .bl.client.candidates.DOWNLOAD_CANDIDATE_RESUMES, params, _this.setCustomHeaderFileDownloadJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deleteCandidate",
            value: function deleteCandidate(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.candidates.DELETE_CANDIDATES */ .bl.client.candidates.DELETE_CANDIDATES, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addToJobs",
            value: function addToJobs(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.candidates.ADD_TO_JOBS */ .bl.client.candidates.ADD_TO_JOBS, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CandidateListAction;
}(_imports_files_pages_admins_logout__WEBPACK_IMPORTED_MODULE_1__/* .SendRequest */ .Lt);


/***/ }),

/***/ 47896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ ReviewEmailServices; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96047);
/* harmony import */ var _imports_files_pages_admins_logout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63281);








var ReviewEmailServices = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ReviewEmailServices, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ReviewEmailServices);
    function ReviewEmailServices() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, ReviewEmailServices);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ReviewEmailServices, [
        {
            key: "createCustomEmail",
            value: // set the api for the data
            function createCustomEmail(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                    var url, result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.email_templates.CREATE_CUSTOM_EMAIL */ .bl.email_templates.CREATE_CUSTOM_EMAIL;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateEmailTemplate",
            value: function updateEmailTemplate(params, template_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                    var url, result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.email_templates.UPDATE_EMAIL_TEMPLATE.replace */ .bl.email_templates.UPDATE_EMAIL_TEMPLATE.replace("$template_id", template_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.put */ .od.put(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateSystemEmail",
            value: function updateSystemEmail(params, template_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                    var url, result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.email_templates.UPDATE_CUSTOM_TEMPLATE.replace */ .bl.email_templates.UPDATE_CUSTOM_TEMPLATE.replace("$template_id", template_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.put */ .od.put(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTagVariableList",
            value: function getTagVariableList() {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.email_templates.GET_VARIABLES */ .bl.email_templates.GET_VARIABLES;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSystemEmailTemplate",
            value: function getSystemEmailTemplate(params, template_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.email_templates.GET_EMAIL_TEMPLATE.replace */ .bl.email_templates.GET_EMAIL_TEMPLATE.replace("$template_id", template_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCustomEmailTemplate",
            value: function getCustomEmailTemplate(params, template_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.email_templates.GET_EMAIL_TEMPLATE.replace */ .bl.email_templates.GET_EMAIL_TEMPLATE.replace("$template_id", template_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "resetEmailTemplate",
            value: function resetEmailTemplate(params, template_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                    var url, result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.email_templates.RESET_EMAIL_TEMPLATE.replace */ .bl.email_templates.RESET_EMAIL_TEMPLATE.replace("$template_id", template_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.put */ .od.put(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ReviewEmailServices;
}(_imports_files_pages_admins_logout__WEBPACK_IMPORTED_MODULE_1__/* .SendRequest */ .Lt);


/***/ }),

/***/ 26013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ EditClient; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_admins_dashboard_clients_edit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20504);







var EditClient = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(EditClient, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(EditClient);
    function EditClient() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, EditClient);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(EditClient, [
        {
            key: "getClientInfo",
            value: function getClientInfo(client_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_admins_dashboard_clients_edit__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_admins_dashboard_clients_edit__WEBPACK_IMPORTED_MODULE_0__/* .API.admins.dashboard.clients.company.EDIT.replace */ .bl.admins.dashboard.clients.company.EDIT.replace("$client_id", client_id), _tmp, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return EditClient;
}(_imports_files_pages_admins_dashboard_clients_edit__WEBPACK_IMPORTED_MODULE_0__/* .SendRequest */ .Lt);


/***/ }),

/***/ 40657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ AddCandidate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43361);







var AddCandidate = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(AddCandidate, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(AddCandidate);
    function AddCandidate() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, AddCandidate);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(AddCandidate, [
        {
            key: "createCandidate",
            value: function createCandidate(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_0__/* .API.client.candidates.GET_CANDIDATE_LIST */ .bl.client.candidates.GET_CANDIDATE_LIST, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "candidateToken",
            value: function candidateToken(params, duplicateEmail) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_0__/* .API.client.candidates.GET_CANDIDATE_TOKEN.replace */ .bl.client.candidates.GET_CANDIDATE_TOKEN.replace("$client_candidate_id", duplicateEmail.client_candidate_id).replace("$job_application_id", duplicateEmail.job_application_id).replace("$job_id", duplicateEmail.job_id), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AddCandidate;
}(_imports_files_pages_candidates_add_candidate__WEBPACK_IMPORTED_MODULE_0__/* .SendRequest */ .Lt);


/***/ }),

/***/ 90317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ IntegrationConnect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_clients_activities_integration_connected__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5837);







var IntegrationConnect = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(IntegrationConnect, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(IntegrationConnect);
    function IntegrationConnect() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, IntegrationConnect);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(IntegrationConnect, [
        {
            key: "submitIntegrationCode",
            value: function submitIntegrationCode(params, slug, client_slug) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_pages_clients_activities_integration_connected__WEBPACK_IMPORTED_MODULE_0__/* .API.client.activities.SEND_INTEGRATION_CODE.replace */ .bl.client.activities.SEND_INTEGRATION_CODE.replace("$slug", slug);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_activities_integration_connected__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(url, params, _this.setCustomHeaderJSON(client_slug), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return IntegrationConnect;
}(_imports_files_pages_clients_activities_integration_connected__WEBPACK_IMPORTED_MODULE_0__/* .SendRequest */ .Lt);


/***/ }),

/***/ 56075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Kanban; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47942);







var Kanban = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Kanban, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Kanban);
    function Kanban() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, Kanban);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Kanban, [
        {
            key: "getApplicationsData",
            value: function getApplicationsData(client_auth_cookies, job_slug, params, hostName) {
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.kanban.GET_APPLICATIONS_DATA.replace */ .bl.client.kanban.GET_APPLICATIONS_DATA.replace("$job_slug", job_slug);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    (0,_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .od)((_tmp.method = "get", _tmp.url = url, _tmp.headers = {
                                        cookie: "Authorization=".concat(client_auth_cookies),
                                        SLUG: hostName
                                    }, _tmp.params = params, _tmp))
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "filterdKanbanData",
            value: function filterdKanbanData(job_slug, params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.kanban.GET_FILTERED_APPLICATIONS.replace */ .bl.client.kanban.GET_FILTERED_APPLICATIONS.replace("$job_slug", job_slug);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "closeJob",
            value: // async getAsyncVideoInterviewPlatforms(client_auth_cookies) {
            //   const url = API.client.jobs.ASYNC_VIDEO_PLATFORMS
            //   try {
            //     const result = await axios({
            //       method: 'get',
            //       url: url,
            //       headers: {cookie: `Authorization=${client_auth_cookies}`},
            //       params: {},
            //     });
            //     return result.data;
            //   } catch (error) {
            //     return error;
            //   }
            // }
            function closeJob(jobId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.CLOSE_JOB.replace */ .bl.client.jobs.CLOSE_JOB.replace("$job_id", jobId), _tmp, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "importCandidates",
            value: function importCandidates(jobId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, _tmp1, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                url = _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.kanban.IMPORT_CANDIDATES.replace */ .bl.client.kanban.IMPORT_CANDIDATES.replace("$job_id", jobId);
                                _tmp = {};
                                _tmp1 = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(url, _tmp, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON(), (_tmp1.timeout = 10 * 60 * 1000, _tmp1))
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "markActiveUnsuccessful",
            value: function markActiveUnsuccessful(jobId, params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.put */ .od.put(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.kanban.MARK_ACTIVE_UNSUCCESSFUL.replace */ .bl.client.kanban.MARK_ACTIVE_UNSUCCESSFUL.replace("$job_id", jobId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addToJob",
            value: function addToJob(jobId, params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.kanban.ADD_TO_JOB.replace */ .bl.client.kanban.ADD_TO_JOB.replace("$job_id", jobId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendTechTest",
            value: function sendTechTest(jobId, params, from, application_filter_data) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.kanban.SEND_TECH_TEST.replace */ .bl.client.kanban.SEND_TECH_TEST.replace("$job_id", jobId), (_tmp.kanban = params, _tmp.from = from, _tmp.application_filter_data = application_filter_data, _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendVideoQaInterview",
            value: function sendVideoQaInterview(jobId, params, from) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.kanban.SEND.replace */ .bl.client.kanban.SEND.replace("$job_id", jobId), (_tmp.kanban = params, _tmp.from = from, _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "moveCandidates",
            value: function moveCandidates(jobId, params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.kanban.MOVE_CANDIDATES.replace */ .bl.client.kanban.MOVE_CANDIDATES.replace("$job_id", jobId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "runAutomations",
            value: function runAutomations(jobId, params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.kanban.RUN_AUTOMATION.replace */ .bl.client.kanban.RUN_AUTOMATION.replace("$job_id", jobId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createOffer",
            value: function createOffer(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.offer.CREATE */ .bl.client.offer.CREATE, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateOffer",
            value: function updateOffer(params, offerId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.patch */ .od.patch(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.offer.UPDATE.replace */ .bl.client.offer.UPDATE.replace("$offer_id", offerId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getOfferDetail",
            value: function getOfferDetail(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = params.job_application_id ? _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.offer.NEW */ .bl.client.offer.NEW : _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.offer.EDIT.replace */ .bl.client.offer.EDIT.replace("$offer_id", params.id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "unsuccessfulReasons",
            value: function unsuccessfulReasons(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.kanban.UNSUCCESSFUL_REASONS */ .bl.client.kanban.UNSUCCESSFUL_REASONS, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "scoreCards",
            value: function scoreCards(job_application_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.kanban.GET_SCORE_CARDS.replace */ .bl.client.kanban.GET_SCORE_CARDS.replace("$job_application_id", job_application_id), (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "singleScoreCards",
            value: function singleScoreCards(job_application_id, scorecard_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.kanban.GET_SCORE_CARDS.replace */ .bl.client.kanban.GET_SCORE_CARDS.replace("$job_application_id", job_application_id), (_tmp.headers = _this.customHeaderJSON(), _tmp.params = {
                                        scorecard_id: scorecard_id
                                    }, _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "compareScoreCards",
            value: function compareScoreCards(job_id, params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.kanban.COMPARE_SCORECARDS.replace */ .bl.client.kanban.COMPARE_SCORECARDS.replace("$job_id", job_id), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "reviewAutomationEmail",
            value: function reviewAutomationEmail(job_id, params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.REVIEW_AUTOMATION_EMAIL.replace */ .bl.client.jobs.REVIEW_AUTOMATION_EMAIL.replace("$job_id", job_id), (_tmp.headers = _this.customHeaderJSON(), _tmp.params = params, _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendUnsuccessfulEmail",
            value: function sendUnsuccessfulEmail(job_id, params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.kanban.SEND_UNSUCCESSFUL_EMAIL.replace */ .bl.client.kanban.SEND_UNSUCCESSFUL_EMAIL.replace("$job_id", job_id), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendOffer",
            value: function sendOffer(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.admins.dashboard.clients.offers.SEND_OFFER.replace */ .bl.admins.dashboard.clients.offers.SEND_OFFER.replace("$offer_id", params.id), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "checkNotSent",
            value: function checkNotSent(args) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.MANUAL_NOT_SENT_DATA */ .bl.client.jobs.MANUAL_NOT_SENT_DATA, args, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendQuestions",
            value: function sendQuestions(jobId, args) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.kanban.SEND_QUESTIONS.replace */ .bl.client.kanban.SEND_QUESTIONS.replace("$job_id", jobId), args, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "syncNowHiredDataService",
            value: function syncNowHiredDataService(jobId, args) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .API.client.kanban.HIRED_SYNC_DATA.replace */ .bl.client.kanban.HIRED_SYNC_DATA.replace("$job_id", jobId), args, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Kanban;
}(_imports_files_pages_clients_candidates_kanban__WEBPACK_IMPORTED_MODULE_0__/* .SendRequest */ .Lt);


/***/ }),

/***/ 57828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CandidateGeneralProfileService; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13245);







var CandidateGeneralProfileService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(CandidateGeneralProfileService, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(CandidateGeneralProfileService);
    function CandidateGeneralProfileService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, CandidateGeneralProfileService);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(CandidateGeneralProfileService, [
        {
            key: "like_dislike",
            value: function like_dislike(params, candidate_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.candidates.LIKE_CANDIDATE.replace */ .bl.client.candidates.LIKE_CANDIDATE.replace("$candidate_id", candidate_id), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getApplicationsData",
            value: function getApplicationsData(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.applicant.CANDIDATE_INFO.replace */ .bl.client.applicant.CANDIDATE_INFO.replace("$application_id", params.applicant_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addNote",
            value: function addNote(params, candidate_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.applicant.CANDIDATE_ADD_NOTE.replace */ .bl.client.applicant.CANDIDATE_ADD_NOTE.replace("$candidate_id", candidate_id), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "shareWithNameSuggestion",
            value: function shareWithNameSuggestion(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.GET_CLIENT_USERS */ .bl.client.jobs.GET_CLIENT_USERS, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CandidateGeneralProfileService;
}(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .SendRequest */ .Lt);


/***/ }),

/***/ 43185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ findJob; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_admins_dashboard_clients_integration__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48847);







var findJob = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(findJob, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(findJob);
    function findJob() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, findJob);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(findJob, [
        {
            key: "getJobsData",
            value: function getJobsData(params) {
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    (0,_imports_files_pages_admins_dashboard_clients_integration__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .od)((_tmp.method = "get", _tmp.url = _imports_files_pages_admins_dashboard_clients_integration__WEBPACK_IMPORTED_MODULE_0__/* .API.open.GET_CAREER_PAGE_DATA */ .bl.open.GET_CAREER_PAGE_DATA, _tmp.headers = {}, _tmp.params = params, _tmp))
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getJobsDataForClientOwner",
            value: function getJobsDataForClientOwner(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_pages_admins_dashboard_clients_integration__WEBPACK_IMPORTED_MODULE_0__/* .API.client.career.PAGE_DATA */ .bl.client.career.PAGE_DATA;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_admins_dashboard_clients_integration__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setJobsImages",
            value: function setJobsImages(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_pages_admins_dashboard_clients_integration__WEBPACK_IMPORTED_MODULE_0__/* .API.admins.dashboard.clients.jobs.UPDATE_CAREER_PAGE */ .bl.admins.dashboard.clients.jobs.UPDATE_CAREER_PAGE;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_admins_dashboard_clients_integration__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(url, params, _this.setMultipartHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setJobsInfo",
            value: function setJobsInfo(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_pages_admins_dashboard_clients_integration__WEBPACK_IMPORTED_MODULE_0__/* .API.admins.dashboard.clients.jobs.UPDATE_CAREER_PAGE */ .bl.admins.dashboard.clients.jobs.UPDATE_CAREER_PAGE;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_admins_dashboard_clients_integration__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getIframeJobsData",
            value: function getIframeJobsData(params) {
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    (0,_imports_files_pages_admins_dashboard_clients_integration__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .od)((_tmp.method = "get", _tmp.url = _imports_files_pages_admins_dashboard_clients_integration__WEBPACK_IMPORTED_MODULE_0__/* .API.open.GET_IFRAME_JOBS_DATA */ .bl.open.GET_IFRAME_JOBS_DATA, _tmp.headers = {}, _tmp.params = params, _tmp))
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return findJob;
}(_imports_files_pages_admins_dashboard_clients_integration__WEBPACK_IMPORTED_MODULE_0__/* .SendRequest */ .Lt);


/***/ }),

/***/ 72389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ EmailDetailsService; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_clients_communication_email_details__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92518);







var EmailDetailsService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(EmailDetailsService, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(EmailDetailsService);
    function EmailDetailsService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, EmailDetailsService);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(EmailDetailsService, [
        {
            key: "getEmailDetailData",
            value: function getEmailDetailData(params, comms_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_pages_clients_communication_email_details__WEBPACK_IMPORTED_MODULE_0__/* .API.client.communication.GET_EMIAL_DATA.replace */ .bl.client.communication.GET_EMIAL_DATA.replace("$comms_id", comms_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_communication_email_details__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "markAsImportantAndUnimportant",
            value: function markAsImportantAndUnimportant(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_pages_clients_communication_email_details__WEBPACK_IMPORTED_MODULE_0__/* .API.client.communication.MARK_AS_IMPORTANT */ .bl.client.communication.MARK_AS_IMPORTANT;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_communication_email_details__WEBPACK_IMPORTED_MODULE_0__/* .axios.put */ .od.put(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deleteEmail",
            value: function deleteEmail(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_pages_clients_communication_email_details__WEBPACK_IMPORTED_MODULE_0__/* .API.client.communication.THREAD_DELETE */ .bl.client.communication.THREAD_DELETE;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_communication_email_details__WEBPACK_IMPORTED_MODULE_0__/* .axios["delete"] */ .od["delete"](url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return EmailDetailsService;
}(_imports_files_pages_clients_communication_email_details__WEBPACK_IMPORTED_MODULE_0__/* .SendRequest */ .Lt);


/***/ }),

/***/ 51348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ CommunicationService; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(76710);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27305);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(23679);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(26996);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ./src/imports-files/pages/clients/communication/index.js + 3 modules
var communication = __webpack_require__(25355);
;// CONCATENATED MODULE: ./public/JSON_DATA/communication_center/sent-message.js
var count = 100;
var STATIC_DATA = {
    data: {
        data: [],
        success: "Comm Details fetched successfully.",
        total: count,
        total_unread: count / 4
    }
};
create_data();
function create_data() {
    for(var i = 0; i < count; i++){
        STATIC_DATA.data.data.push({
            "id": "".concat(Math.random() * 1000),
            "description": "11:53 am Wednesday, 27 July 2022 (IST) Time in Chandigarh",
            "sender": "Static Candidate ".concat(i),
            "when": "".concat(Math.random() * 1000, " minutes ago"),
            "read": "".concat(Math.random() < 0.5),
            "href": null,
            "comm_detail_id": "".concat(Math.random() * 1000)
        });
    }
}

;// CONCATENATED MODULE: ./src/services/pages/clients/communication/index.js








var CommunicationService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_inherits/* default */.Z)(CommunicationService, SendRequest);
    var _super = (0,_create_super/* default */.Z)(CommunicationService);
    function CommunicationService() {
        (0,_class_call_check/* default */.Z)(this, CommunicationService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CommunicationService, [
        {
            key: "getCommunicationData",
            value: function getCommunicationData(params) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var url, result, _tmp, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = communication/* API.client.communication.COMMUNICATION_DATA */.bl.client.communication.COMMUNICATION_DATA;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    communication/* axios.get */.od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                // }
                })();
            }
        }
    ]);
    return CommunicationService;
}(communication/* SendRequest */.Lt);


/***/ }),

/***/ 28936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ AddTeamService; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96047);
/* harmony import */ var _services_common_send_request__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34964);








var AddTeamService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(AddTeamService, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(AddTeamService);
    function AddTeamService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, AddTeamService);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(AddTeamService, [
        {
            key: "getUserListData",
            value: function getUserListData(slug, params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.company.USER_LIST.replace */ .bl.client.company.USER_LIST.replace("$slug", slug);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateUserStatus",
            value: function updateUserStatus(client_id, params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.company.UPDATE_USER_STATUS.replace */ .bl.client.company.UPDATE_USER_STATUS.replace("$client_id", client_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.put */ .od.put(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "resendInvite",
            value: function resendInvite(client_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.company.RESENT_INVITE.replace */ .bl.client.company.RESENT_INVITE.replace("$client_id", client_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.put */ .od.put(url, _tmp, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AddTeamService;
}(_services_common_send_request__WEBPACK_IMPORTED_MODULE_7__/* .SendRequest */ .L);


/***/ }),

/***/ 49639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ Automation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64335);







var Automation = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Automation, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Automation);
    function Automation() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, Automation);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Automation, [
        {
            key: "getJobStagesList",
            value: function getJobStagesList(jobId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.JOB_STAGES_LIST.replace */ .bl.client.jobs.JOB_STAGES_LIST.replace("$job_id", jobId), (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getVideoInterviewPlatforms",
            value: function getVideoInterviewPlatforms() {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.VIDEO_PLATFORMS */ .bl.client.jobs.VIDEO_PLATFORMS, (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setThreshold",
            value: function setThreshold(params, jobId, jobStageId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .axios.patch */ .od.patch(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.UPDATE_THRESHOLD.replace */ .bl.client.jobs.UPDATE_THRESHOLD.replace("$job_id", jobId).replace("$job_stage_id", jobStageId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateAutomations",
            value: function updateAutomations(params, jobId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.UPDATE_AUTOMATIONS.replace */ .bl.client.jobs.UPDATE_AUTOMATIONS.replace("$job_id", jobId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addAutomations",
            value: function addAutomations(params, jobId, jobStageId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.ADD_AUTOMATIONS.replace */ .bl.client.jobs.ADD_AUTOMATIONS.replace("$job_id", jobId).replace("$job_stage_id", jobStageId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "jobStageData",
            value: function jobStageData(jobId, jobStageId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.JOB_STAGE_DATA.replace */ .bl.client.jobs.JOB_STAGE_DATA.replace("$job_id", jobId).replace("$job_stage_id", jobStageId), (_tmp.params = {}, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "manualJobStageData",
            value: function manualJobStageData(jobId, jobStageId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.MANUAL_JOB_STAGE_DATA */ .bl.client.jobs.MANUAL_JOB_STAGE_DATA, (_tmp.params = {
                                        job_stage_id: jobStageId
                                    }, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTechTests",
            value: function getTechTests(value) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.GET_TECH_TESTS */ .bl.client.jobs.GET_TECH_TESTS, (_tmp.params = {
                                        search_text: value,
                                        type: "TestLibrary"
                                    }, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAssessmentTests",
            value: function getAssessmentTests(value) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.GET_TECH_TESTS */ .bl.client.jobs.GET_TECH_TESTS, (_tmp.params = {
                                        search_text: value,
                                        type: "Assessment"
                                    }, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addTechTests",
            value: function addTechTests(params, jobId, jobStageId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.ADD_TECH_TESTS.replace */ .bl.client.jobs.ADD_TECH_TESTS.replace("$job_id", jobId).replace("$job_stage_id", jobStageId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Automation;
}(_imports_files_pages_clients_jobs_automations__WEBPACK_IMPORTED_MODULE_0__/* .SendRequest */ .Lt);


/***/ }),

/***/ 45533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ CandidateProfileJobService; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13245);







var CandidateProfileJobService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(CandidateProfileJobService, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(CandidateProfileJobService);
    function CandidateProfileJobService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, CandidateProfileJobService);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(CandidateProfileJobService, [
        {
            key: "like_dislike",
            value: function like_dislike(params, job_applicant_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.applicant.LIKE_CANDIDATE.replace */ .bl.client.applicant.LIKE_CANDIDATE.replace("$job_applicant_id", job_applicant_id), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getApplicationsData",
            value: function getApplicationsData(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.applicant.CANDIDATE_INFO.replace */ .bl.client.applicant.CANDIDATE_INFO.replace("$application_id", params.applicant_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getApplicationsDataWhenRestricted",
            value: function getApplicationsDataWhenRestricted(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.applicant.VIEW_APPLICATION_PROFILE */ .bl.client.applicant.VIEW_APPLICATION_PROFILE;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCandidateGeneralViewData",
            value: function getCandidateGeneralViewData(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.applicant.GENERAL_PROFILE.replace */ .bl.client.applicant.GENERAL_PROFILE.replace("$candidate_id", params.candidate_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addNote",
            value: function addNote(params, applicant_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.applicant.ADD_NOTE.replace */ .bl.client.applicant.ADD_NOTE.replace("$applicant_id", applicant_id), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "restrictedLikeDislike",
            value: function restrictedLikeDislike(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.applicant.RESTRICTED_LIKE_CANDIDATE */ .bl.client.applicant.RESTRICTED_LIKE_CANDIDATE, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "restrictedAddNote",
            value: function restrictedAddNote(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.applicant.RESTRICTED_ADD_NOTES */ .bl.client.applicant.RESTRICTED_ADD_NOTES, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "shareWithNameSuggestion",
            value: function shareWithNameSuggestion(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.GET_CLIENT_USERS */ .bl.client.jobs.GET_CLIENT_USERS, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "resendInvite",
            value: function resendInvite(meetingId, interview_type) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var params, _tmp, result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {};
                                params = (_tmp.interview_type = interview_type, _tmp);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.cronofy.RESEND_INVITE.replace */ .bl.client.cronofy.RESEND_INVITE.replace("$meeting_id", meetingId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getDetails",
            value: function getDetails(params, action) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = action == "new" ? _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.cronofy.GET_NEW_MEETING_DETAILS */ .bl.client.cronofy.GET_NEW_MEETING_DETAILS : _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.cronofy.GET_MEETING_DETAILS.replace */ .bl.client.cronofy.GET_MEETING_DETAILS.replace("$meeting_id", params.job_application_meeting_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.headers = _this.customHeaderJSON(), _tmp.params = params, _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addInterview",
            value: function addInterview(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.defaults.timeout */ .od.defaults.timeout = 5 * 60 * 1000;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.cronofy.ADD_INTERVIEW */ .bl.client.cronofy.ADD_INTERVIEW, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setupInterview",
            value: function setupInterview(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.defaults.timeout */ .od.defaults.timeout = 5 * 60 * 1000;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.cronofy.SETUP_INTERVIEW */ .bl.client.cronofy.SETUP_INTERVIEW, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "viewDetails",
            value: function viewDetails(meetingId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.cronofy.VIEW_MEETING_DETAILS.replace */ .bl.client.cronofy.VIEW_MEETING_DETAILS.replace("$meeting_id", meetingId), (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "viewRequest",
            value: function viewRequest(meetingId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.cronofy.VIEW_MEETING_REQUEST.replace */ .bl.client.cronofy.VIEW_MEETING_REQUEST.replace("$meeting_id", meetingId), (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "cancelInterview",
            value: function cancelInterview(params, meetingId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.cronofy.CANCEL_INTERVIEW_BY_CLIENT.replace */ .bl.client.cronofy.CANCEL_INTERVIEW_BY_CLIENT.replace("$meeting_id", meetingId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "rescheduleInerview",
            value: function rescheduleInerview(params, meetingId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.cronofy.RESCHEDULE_INTERVIEW.replace */ .bl.client.cronofy.RESCHEDULE_INTERVIEW.replace("$meeting_id", meetingId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getNoOfSlots",
            value: function getNoOfSlots(params, meetingId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.cronofy.AVAILABLE_SLOTS.replace */ .bl.client.cronofy.AVAILABLE_SLOTS.replace("$meeting_id", meetingId), (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "acceptSlotRequest",
            value: function acceptSlotRequest(params, meetingId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.cronofy.ACCEPT_SLOT.replace */ .bl.client.cronofy.ACCEPT_SLOT.replace("$meeting_id", meetingId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getUserByNameOrEmail",
            value: function getUserByNameOrEmail(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.GET_USERS_LIST */ .bl.client.jobs.GET_USERS_LIST, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "downloadContract",
            value: function downloadContract(contractId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.contracts.DOWNLOAD.replace */ .bl.client.contracts.DOWNLOAD.replace("$contract_id", contractId), _tmp, _this.setCustomHeaderFileDownloadJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "previewContract",
            value: function previewContract(contractId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.contracts.PREVIEW.replace */ .bl.client.contracts.PREVIEW.replace("$contract_id", contractId), (_tmp.params = {}, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return CandidateProfileJobService;
}(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .SendRequest */ .Lt);


/***/ }),

/***/ 60515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ JobCommon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46780);







var JobCommon = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(JobCommon, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(JobCommon);
    function JobCommon() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, JobCommon);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(JobCommon, [
        {
            key: "destroyJob",
            value: function destroyJob(jobId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .axios["delete"] */ .od["delete"](_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.DELETE_JOB.replace */ .bl.client.jobs.DELETE_JOB.replace("$job_id", jobId), (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "saveAsDraft",
            value: function saveAsDraft(params, jobId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.patch */ .od.patch(_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.UPDATE_JOB.replace */ .bl.client.jobs.UPDATE_JOB.replace("$job_id", jobId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "previewJob",
            value: function previewJob(client_auth_cookies, jobId, hostName) {
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    (0,_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .od)((_tmp.method = "get", _tmp.url = _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.PREVIEW_JOB.replace */ .bl.client.jobs.PREVIEW_JOB.replace("$job_id", jobId), _tmp.headers = {
                                        cookie: "Authorization=".concat(client_auth_cookies),
                                        SLUG: hostName
                                    }, _tmp.params = {}, _tmp))
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "viewJob",
            value: function viewJob(client_auth_cookies, slug) {
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    (0,_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .od)((_tmp.method = "get", _tmp.url = _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.VIEW_JOB.replace */ .bl.client.jobs.VIEW_JOB.replace("$slug", slug), _tmp.headers = {
                                        cookie: "Authorization=".concat(client_auth_cookies)
                                    }, _tmp.params = {}, _tmp))
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "closeJob",
            value: function closeJob(params, jobId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.CLOSE_JOB.replace */ .bl.client.jobs.CLOSE_JOB.replace("$job_id", jobId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "publishJob",
            value: function publishJob(jobId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.PUBLISH_JOB.replace */ .bl.client.jobs.PUBLISH_JOB.replace("$job_id", jobId), _tmp, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "duplicateJob",
            value: function duplicateJob(jobId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.DUPLICATE_JOB.replace */ .bl.client.jobs.DUPLICATE_JOB.replace("$job_id", jobId), _tmp, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "editJob",
            value: function editJob(jobId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.CHECK_EDIT.replace */ .bl.client.jobs.CHECK_EDIT.replace("$job_id", jobId), (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCandidateCv",
            value: function getCandidateCv(client_auth_cookies, cv_token) {
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    (0,_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .od)((_tmp.method = "get", _tmp.url = _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.FETCH_CANDIDATE.replace */ .bl.client.jobs.FETCH_CANDIDATE.replace("$cv_token", cv_token), _tmp.headers = {
                                        cookie: "Authorization=".concat(client_auth_cookies)
                                    }, _tmp.params = {}, _tmp))
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result.data
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getJobScorecard",
            value: function getJobScorecard(client_auth_cookies, job_slug, token) {
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    (0,_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .od)((_tmp.method = "get", _tmp.url = _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.FETCH_SCORECARD.replace */ .bl.client.jobs.FETCH_SCORECARD.replace("$job_slug", job_slug), _tmp.headers = {
                                        cookie: "Authorization=".concat(client_auth_cookies)
                                    }, _tmp.params = {
                                        token: token
                                    }, _tmp))
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "viewScreeningQuestions",
            value: function viewScreeningQuestions(client_auth_cookies, slug, token) {
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    (0,_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .od)((_tmp.method = "get", _tmp.url = _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.VIEW_SCREENING_QUESTIONS.replace */ .bl.client.jobs.VIEW_SCREENING_QUESTIONS.replace("$slug", slug), _tmp.headers = {
                                        cookie: "Authorization=".concat(client_auth_cookies)
                                    }, _tmp.params = {
                                        token: token
                                    }, _tmp))
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCvUrl",
            value: function getCvUrl(client_auth_cookies, slug, token) {
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    (0,_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .od)((_tmp.method = "get", _tmp.url = _imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.FETCH_CANDIDATE_CV.replace */ .bl.client.jobs.FETCH_CANDIDATE_CV.replace("$slug", slug), _tmp.headers = {
                                        cookie: "Authorization=".concat(client_auth_cookies)
                                    }, _tmp.params = {
                                        token: token
                                    }, _tmp))
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return JobCommon;
}(_imports_files_pages_clients_jobs_common__WEBPACK_IMPORTED_MODULE_0__/* .SendRequest */ .Lt);


/***/ }),

/***/ 85985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ EditJob; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13245);







var EditJob = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(EditJob, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(EditJob);
    function EditJob() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, EditJob);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(EditJob, [
        {
            key: "getJobInfo",
            value: function getJobInfo(jobId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.GET_JOB.replace */ .bl.client.jobs.GET_JOB.replace("$job_id", jobId), (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return EditJob;
}(_imports_files_pages_clients_jobs_new__WEBPACK_IMPORTED_MODULE_0__/* .SendRequest */ .Lt);


/***/ }),

/***/ 42465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ InterviewStage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97336);







var InterviewStage = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(InterviewStage, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(InterviewStage);
    function InterviewStage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, InterviewStage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(InterviewStage, [
        {
            key: "getInteviewStageData",
            value: function getInteviewStageData(jobId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.GET_STAGE_INTERVIEW_TYPE_DATA.replace */ .bl.client.jobs.GET_STAGE_INTERVIEW_TYPE_DATA.replace("$job_id", jobId), (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getUserByNameOrEmail",
            value: function getUserByNameOrEmail(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.GET_CLIENT_USERS */ .bl.client.jobs.GET_CLIENT_USERS, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addJobStages",
            value: function addJobStages(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var jobId, result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                jobId = new _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .DataFromUrl */ .QJ().getJobId();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.ADD_JOB_STAGES.replace */ .bl.client.jobs.ADD_JOB_STAGES.replace("$job_id", jobId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return InterviewStage;
}(_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .SendRequest */ .Lt);


/***/ }),

/***/ 23152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ JobListing; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44791);







var JobListing = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(JobListing, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(JobListing);
    function JobListing() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, JobListing);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(JobListing, [
        {
            key: "getJobListingData",
            value: function getJobListingData(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_0__/* .API.admins.dashboard.clients.jobs.GET_JOBS_LIST */ .bl.admins.dashboard.clients.jobs.GET_JOBS_LIST, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "failedJobBoardList",
            value: function failedJobBoardList(jobId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_0__/* .API.admins.dashboard.clients.jobs.FAILED_JOB_BOARDS.replace */ .bl.admins.dashboard.clients.jobs.FAILED_JOB_BOARDS.replace("$job_id", jobId), (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "retryJobsOnJobBoardService",
            value: function retryJobsOnJobBoardService(integrations_ids, jobId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_0__/* .API.admins.dashboard.clients.jobs.RETRY_JOB_BOARD.replace */ .bl.admins.dashboard.clients.jobs.RETRY_JOB_BOARD.replace("$job_id", jobId), (_tmp.integration_ids = integrations_ids, _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "dismissJobsOnJobBoardService",
            value: function dismissJobsOnJobBoardService(integrations_ids, jobId, discard_all) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_0__/* .axios["delete"] */ .od["delete"](_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_0__/* .API.admins.dashboard.clients.jobs.DISMISS_JOB_BOARD.replace */ .bl.admins.dashboard.clients.jobs.DISMISS_JOB_BOARD.replace("$job_id", jobId), (_tmp.params = {
                                        integration_ids: integrations_ids,
                                        discard_all: discard_all
                                    }, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getUserByNameOrEmail",
            value: function getUserByNameOrEmail(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.GET_AGENCY_USERS */ .bl.client.jobs.GET_AGENCY_USERS, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return JobListing;
}(_imports_files_pages_clients_jobs_job__WEBPACK_IMPORTED_MODULE_0__/* .SendRequest */ .Lt);


/***/ }),

/***/ 4185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ MergeRecordsService; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27307);
/* harmony import */ var _constants_common_urls__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47694);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96047);
/* harmony import */ var _services_common_send_request__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34964);









var MergeRecordsService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(MergeRecordsService, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(MergeRecordsService);
    function MergeRecordsService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, MergeRecordsService);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(MergeRecordsService, [
        {
            key: "getMergeCandidateData",
            value: function getMergeCandidateData(params, candidate_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_1__/* .axios.get */ .od.get(_constants_common_urls__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.GET_MERGE_CANDIDATE_DATA.replace */ .b.client.jobs.GET_MERGE_CANDIDATE_DATA.replace("$candidate_id", candidate_id), (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "rejectMergeCandidateData",
            value: function rejectMergeCandidateData(params, candidate_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_1__/* .axios.post */ .od.post(_constants_common_urls__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.REJECT_MERGE_CANDIDATE.replace */ .b.client.jobs.REJECT_MERGE_CANDIDATE.replace("$candidate_id", candidate_id), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendMergeCandidateData",
            value: function sendMergeCandidateData(params, candidate_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_1__/* .axios.post */ .od.post(_constants_common_urls__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.SEND_MERGE_CANDIDATE.replace */ .b.client.jobs.SEND_MERGE_CANDIDATE.replace("$candidate_id", candidate_id), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "acceptAgencyApplication",
            value: function acceptAgencyApplication(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_1__/* .axios.post */ .od.post(_constants_common_urls__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.ACCEPT_MERGE_APPLICATION.replace */ .b.client.jobs.ACCEPT_MERGE_APPLICATION.replace("$job_application_id", params.job_application_id), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "rejectAgencyApplication",
            value: function rejectAgencyApplication(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_1__/* .axios.post */ .od.post(_constants_common_urls__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.REJECT_MERGE_APPLICATION.replace */ .b.client.jobs.REJECT_MERGE_APPLICATION.replace("$job_application_id", params.duplicate_application_id), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return MergeRecordsService;
}(_services_common_send_request__WEBPACK_IMPORTED_MODULE_8__/* .SendRequest */ .L);


/***/ }),

/***/ 47441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ Job; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97336);







var Job = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Job, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Job);
    function Job() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, Job);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Job, [
        {
            key: "getJobData",
            value: function getJobData() {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.GET_JOB_DATA */ .bl.client.jobs.GET_JOB_DATA, (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getJobDataByJobTitle",
            value: function getJobDataByJobTitle(job_title_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.GET_JOB_BY_TITLE.replace */ .bl.client.jobs.GET_JOB_BY_TITLE.replace("$job_title_id", job_title_id), (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createJob",
            value: function createJob(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.CREATE_JOB */ .bl.client.jobs.CREATE_JOB, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateJob",
            value: function updateJob(params, jobId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.patch */ .od.patch(_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.UPDATE_JOB.replace */ .bl.client.jobs.UPDATE_JOB.replace("$job_id", jobId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getJobTitlesByName",
            value: function getJobTitlesByName(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.GET_JOB_TITLES */ .bl.client.jobs.GET_JOB_TITLES, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getDepartmentsByName",
            value: function getDepartmentsByName(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.GET_DEPARTMENTS */ .bl.client.jobs.GET_DEPARTMENTS, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "generateJobDescription",
            value: function generateJobDescription(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.GENERATE_DESCRIPTION */ .bl.client.jobs.GENERATE_DESCRIPTION, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Job;
}(_imports_files_pages_admins_dashboard_clients_new__WEBPACK_IMPORTED_MODULE_0__/* .SendRequest */ .Lt);


/***/ }),

/***/ 76275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ ScoreCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96726);







var ScoreCard = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ScoreCard, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ScoreCard);
    function ScoreCard() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, ScoreCard);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ScoreCard, [
        {
            key: "getCompetencies",
            value: // async getCompetencies(client_auth_cookies, jobId) {
            //   try {
            //     const result = await axios({
            //       method: 'get',
            //       url: API.client.jobs.GET_JOB.replace('$job_id', jobId),
            //       headers: {cookie: `Authorization=${client_auth_cookies}`},
            //       params: {},
            //     });
            //     return result.data;
            //     // const hash = {
            //     //   success: "Yes",
            //     //   id: "1",
            //     //   job_competency_names: [
            //     //     "Leadership",
            //     //     "Individuality",
            //     //     "Organisational skills"
            //     //   ]
            //     // }
            //     // return hash;
            //   } catch (error) {
            //     return error;
            //   }
            // }
            function getCompetencies(jobId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.GET_JOB.replace */ .bl.client.jobs.GET_JOB.replace("$job_id", jobId), (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCompetencyByName",
            value: function getCompetencyByName(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.GET_COMPETENCIES_LIST */ .bl.client.jobs.GET_COMPETENCIES_LIST, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addCompetencies",
            value: function addCompetencies(params, jobId) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.ADD_COMPETENCIES.replace */ .bl.client.jobs.ADD_COMPETENCIES.replace("$job_id", jobId), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ScoreCard;
}(_imports_files_pages_clients_jobs_scorecards__WEBPACK_IMPORTED_MODULE_0__/* .SendRequest */ .Lt);


/***/ }),

/***/ 68711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ MyAccountService; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14683);







var MyAccountService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(MyAccountService, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(MyAccountService);
    function MyAccountService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, MyAccountService);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(MyAccountService, [
        {
            key: "getDetails",
            value: function getDetails(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .API.client.activities.GET_USER_DETAILS */ .bl.client.activities.GET_USER_DETAILS, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateUserDetails",
            value: function updateUserDetails(params, client_slug) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .axios.put */ .od.put(_imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .API.client.activities.UPDATE_USER_DETAILS.replace */ .bl.client.activities.UPDATE_USER_DETAILS.replace("$client_slug", client_slug), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return MyAccountService;
}(_imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .SendRequest */ .Lt);


/***/ }),

/***/ 16424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ MyTeamService; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14683);







var MyTeamService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(MyTeamService, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(MyTeamService);
    function MyTeamService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, MyTeamService);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(MyTeamService, [
        {
            key: "getTeamDetails",
            value: function getTeamDetails(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .API.client.activities.GET_MY_TEAM */ .bl.client.activities.GET_MY_TEAM, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addTeamMembers",
            value: function addTeamMembers(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .API.client.activities.ADD_TEAM_MEMBERS */ .bl.client.activities.ADD_TEAM_MEMBERS, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return MyTeamService;
}(_imports_files_pages_clients_activities_index__WEBPACK_IMPORTED_MODULE_0__/* .SendRequest */ .Lt);


/***/ }),

/***/ 32784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ EmailTemplatesService; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96047);
/* harmony import */ var _services_common_send_request__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34964);








var EmailTemplatesService = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(EmailTemplatesService, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(EmailTemplatesService);
    function EmailTemplatesService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, EmailTemplatesService);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(EmailTemplatesService, [
        {
            key: "getSystemEmailTemplateData",
            value: function getSystemEmailTemplateData(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.email_templates.SYSTEM_TEMPLATE_LIST */ .bl.email_templates.SYSTEM_TEMPLATE_LIST;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCustomEmailTemplateData",
            value: function getCustomEmailTemplateData(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.email_templates.CUSTOM_TEMPLATE_LIST */ .bl.email_templates.CUSTOM_TEMPLATE_LIST;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deleteCustomEmailTemplateData",
            value: function deleteCustomEmailTemplateData(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.email_templates.DELETE_CUSTOM_TEMPLATE */ .bl.email_templates.DELETE_CUSTOM_TEMPLATE;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios["delete"] */ .od["delete"](url, (_tmp.params = params, _tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSystemPurposeList",
            value: function getSystemPurposeList() {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.email_templates.CLIENT_PURPOSE_LIST */ .bl.email_templates.CLIENT_PURPOSE_LIST;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPurposesList",
            value: function getPurposesList() {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.email_templates.CUSTOM_TEMPLATE_LIST */ .bl.email_templates.CUSTOM_TEMPLATE_LIST;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMembersList",
            value: function getMembersList() {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.email_templates.CLIENT_MEMBER_LIST */ .bl.email_templates.CLIENT_MEMBER_LIST;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(url, (_tmp.headers = _this.customHeaderJSON(), _tmp), _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "saveEmailTemplate",
            value: function saveEmailTemplate(params, job_id) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var url, result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.SAVE_EMAIL_TEMPLATE.replace */ .bl.client.jobs.SAVE_EMAIL_TEMPLATE.replace("$job_id", job_id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _imports_files_common_common__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(url, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return EmailTemplatesService;
}(_services_common_send_request__WEBPACK_IMPORTED_MODULE_7__/* .SendRequest */ .L);


/***/ }),

/***/ 83422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ JobApplication; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76710);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27305);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23679);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26996);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27307);
/* harmony import */ var _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83813);







var JobApplication = /*#__PURE__*/ function(SendRequest) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(JobApplication, SendRequest);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(JobApplication);
    function JobApplication() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, JobApplication);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(JobApplication, [
        {
            key: "applyJob",
            value: function applyJob(params, jobSlug) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.APPLY_JOB.replace */ .bl.client.jobs.APPLY_JOB.replace("$job_slug", jobSlug), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "parseCV",
            value: function parseCV(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.PARSE_CV */ .bl.client.jobs.PARSE_CV, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "confirmEmail",
            value: function confirmEmail(params) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.CONFIRM_APPLICATION */ .bl.client.jobs.CONFIRM_APPLICATION, params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "viewApplication",
            value: function viewApplication(application_id, hostName) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, _tmp, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _tmp = {};
                                return [
                                    4,
                                    _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get(_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.VIEW_APPLICATION.replace */ .bl.client.jobs.VIEW_APPLICATION.replace("$application_id", application_id), (_tmp.headers = _this.serverSideHeaderJSON(hostName), _tmp), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "submitAnswers",
            value: function submitAnswers(params, jobSlug) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                    var result, error;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .axios.post */ .od.post(_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .API.client.jobs.SUBMIT_ANSWERS.replace */ .bl.client.jobs.SUBMIT_ANSWERS.replace("$job_slug", jobSlug), params, _this.setHeaderJSON(), _this.setCrossDomainTrue(), _this.setCredentialsJSON())
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    error
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return JobApplication;
}(_imports_files_pages_career_view_job__WEBPACK_IMPORTED_MODULE_0__/* .SendRequest */ .Lt);


/***/ }),

/***/ 42000:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"AddInterview__inner":"add-interview-modal_AddInterview__inner__lt4Na","AddInterview__PaddingPopup":"add-interview-modal_AddInterview__PaddingPopup__WvTGH","AddInterview__ContentAddInterview":"add-interview-modal_AddInterview__ContentAddInterview__k7MVp","OtpBacksection":"add-interview-modal_OtpBacksection__pm_P_","Otpback":"add-interview-modal_Otpback___l4ek"};

/***/ }),

/***/ 81769:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SetupPopup__inner":"add-new-stage_SetupPopup__inner__sb4J1","SetupPopup__Content":"add-new-stage_SetupPopup__Content__hUpeD","SetupPopup__Content____Submit":"add-new-stage_SetupPopup__Content____Submit__Qwip9","OtpBacksection":"add-new-stage_OtpBacksection__wx5Y8","AddNewStage":"add-new-stage_AddNewStage__fGKwq","AddNewStage__Row":"add-new-stage_AddNewStage__Row__KFnFA","AddNewStage__LeftColumn":"add-new-stage_AddNewStage__LeftColumn__9V_A4","AddNewStage__RightColumn":"add-new-stage_AddNewStage__RightColumn__ZjqAP","AddNewStage__w100":"add-new-stage_AddNewStage__w100__x8KqV","AddNewStage__dblock":"add-new-stage_AddNewStage__dblock__yLEbX","Interview__Icons":"add-new-stage_Interview__Icons__MehXo","Interview__IconsType":"add-new-stage_Interview__IconsType__C9kVB"};

/***/ }),

/***/ 27633:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Modalpopup":"add-to-job-modal_Modalpopup__N2cTL","Modalpopup__inner":"add-to-job-modal_Modalpopup__inner__Yc8Lk","Modalpopup__Dialog":"add-to-job-modal_Modalpopup__Dialog__lWf2Z","transition":"add-to-job-modal_transition__nD3DI","Modalpopup__CloseCenter":"add-to-job-modal_Modalpopup__CloseCenter__fEZFv","Modalpopup__Content":"add-to-job-modal_Modalpopup__Content___Q2nW","Modalpopup__btn":"add-to-job-modal_Modalpopup__btn__k6L_D","mar":"add-to-job-modal_mar__rL1HI","Otpback":"add-to-job-modal_Otpback__1mBYz","Form":"add-to-job-modal_Form__DyGSA","Form__width":"add-to-job-modal_Form__width__HfGYA","Form__label":"add-to-job-modal_Form__label__muvPP","Form__textleft":"add-to-job-modal_Form__textleft__8TMiy","Form__InputFullWidth":"add-to-job-modal_Form__InputFullWidth__uQ0w6","Form__Input":"add-to-job-modal_Form__Input__FxmxS","Form__InputSection":"add-to-job-modal_Form__InputSection__poF7M","Form__ScoreCardInput":"add-to-job-modal_Form__ScoreCardInput__5Dm1n","Form__Textarea":"add-to-job-modal_Form__Textarea__4YzPY","primarybtn":"add-to-job-modal_primarybtn__Bb1Dc","secondarybtn":"add-to-job-modal_secondarybtn___rVJA","iconFilled":"add-to-job-modal_iconFilled__zbVkD","iconFilledSolid":"add-to-job-modal_iconFilledSolid__PrOko","primarybtnborder":"add-to-job-modal_primarybtnborder__Sg_bY","secondarybtnborder":"add-to-job-modal_secondarybtnborder___wSE2","tertiarybtn":"add-to-job-modal_tertiarybtn__kKiVe","graybtnborder":"add-to-job-modal_graybtnborder___P5qv","jobsrchbtn":"add-to-job-modal_jobsrchbtn__OYpKP","jobsrchbtnalign":"add-to-job-modal_jobsrchbtnalign__4bLce","nobgbutton":"add-to-job-modal_nobgbutton__Gkx2o","iconTextButton":"add-to-job-modal_iconTextButton__uhYCh","cursornone":"add-to-job-modal_cursornone__Yz7mF","nobgbuttonprimary":"add-to-job-modal_nobgbuttonprimary__pIaIC","mt15":"add-to-job-modal_mt15__X3ZuY","btn350":"add-to-job-modal_btn350__qRj0v","GrayBgBtn":"add-to-job-modal_GrayBgBtn__8gaVC","NewShareBtn":"add-to-job-modal_NewShareBtn__DJfEL","CoralBgBtn":"add-to-job-modal_CoralBgBtn__2q5kw","ModalClose":"add-to-job-modal_ModalClose__FXbb3","AddToJobModal":"add-to-job-modal_AddToJobModal__WxXhg","AddToJobModal__Inner":"add-to-job-modal_AddToJobModal__Inner__MVbQD","AddToJobModal__Head":"add-to-job-modal_AddToJobModal__Head__Yxpps","AddToJobModal__SubmitSection":"add-to-job-modal_AddToJobModal__SubmitSection__VEpIE","AddToJobModal__CustomSelect":"add-to-job-modal_AddToJobModal__CustomSelect__6M_Zy"};

/***/ }),

/***/ 72123:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"AutomationPopup":"automation-popup_AutomationPopup___BAQI","AutomationPopup__inner":"automation-popup_AutomationPopup__inner__tvEn6","AutomationPopup__Dialog":"automation-popup_AutomationPopup__Dialog__of8I0","transition":"automation-popup_transition__AK6GV","AutomationPopup__fs16":"automation-popup_AutomationPopup__fs16__o7AsE","AutomationPopup__OtpBacksection":"automation-popup_AutomationPopup__OtpBacksection__Ragz4","AutomationPopup__Otpback":"automation-popup_AutomationPopup__Otpback__HXrR8","AutomationPopup__PaddingPopup":"automation-popup_AutomationPopup__PaddingPopup__P2wMD","AutomationPopup__AutomationToggle":"automation-popup_AutomationPopup__AutomationToggle__ESDmx","AutomationPopup__ContentBlockPhone":"automation-popup_AutomationPopup__ContentBlockPhone__rwv6C","AutomationPopup__ContentFlex":"automation-popup_AutomationPopup__ContentFlex__c3Q80","AutomationPopup__JustifyContentBetween":"automation-popup_AutomationPopup__JustifyContentBetween__DSTF_","AutomationPopup__FlexFlow":"automation-popup_AutomationPopup__FlexFlow__f_A85","AutomationPopup__DeleteIcon":"automation-popup_AutomationPopup__DeleteIcon__f5vWS","AutomationPopup__Display":"automation-popup_AutomationPopup__Display__8oQTh","AutomationPopup__Field":"automation-popup_AutomationPopup__Field__XlfeE","AutomationPopup__Input":"automation-popup_AutomationPopup__Input__AfpxI","AutomationPopup__QuestionSection":"automation-popup_AutomationPopup__QuestionSection__GBvHZ","AutomationPopup__InterviewQuestion":"automation-popup_AutomationPopup__InterviewQuestion__ps01P","AutomationPopup__Question":"automation-popup_AutomationPopup__Question__2XaZa","AutomationPopup__Description":"automation-popup_AutomationPopup__Description__uZqlb","AutomationPopup__FieldAuto":"automation-popup_AutomationPopup__FieldAuto__Rd7ZW","AutomationPopup__NoRightBorderRadius":"automation-popup_AutomationPopup__NoRightBorderRadius__mvd6l","AutomationPopup__Members":"automation-popup_AutomationPopup__Members__4S7OU","AutomationPopup__Duration":"automation-popup_AutomationPopup__Duration__2YSwL","AutomationPopup__Row":"automation-popup_AutomationPopup__Row__HZkXw","AutomationPopup__Location":"automation-popup_AutomationPopup__Location__Bh1Bn","AutomationPopup__Platform":"automation-popup_AutomationPopup__Platform__nnIzN","AutomationPopup__w50":"automation-popup_AutomationPopup__w50__iCaFw","AutomationPopup__w33":"automation-popup_AutomationPopup__w33__X9TBI","AutomationPopup__CloseIcon":"automation-popup_AutomationPopup__CloseIcon__2YghO","AutomationPopup__SetupVideoQa2":"automation-popup_AutomationPopup__SetupVideoQa2__nxM18","AutomationPopup__ContentGridPhone":"automation-popup_AutomationPopup__ContentGridPhone__y5Xpc","AutomationPopup__Seconds":"automation-popup_AutomationPopup__Seconds__aubnR","AutomationPopup__SubmitSectionSave":"automation-popup_AutomationPopup__SubmitSectionSave__Pgb0F","AutomationPopup__AddQuestionButton":"automation-popup_AutomationPopup__AddQuestionButton__0KmAZ","AutomationPopup__Customisation":"automation-popup_AutomationPopup__Customisation__NHn1s","AutomationPopup__PracticeScreen":"automation-popup_AutomationPopup__PracticeScreen__25I0o","AutomationPopup__BestMatchExclamation":"automation-popup_AutomationPopup__BestMatchExclamation__YLZFs","AutomationPopup__PracticeExclamation":"automation-popup_AutomationPopup__PracticeExclamation__7QJKi","AutomationPopup__SetupVideoQa3":"automation-popup_AutomationPopup__SetupVideoQa3__LPUS6","AutomationPopup__SetupVideoQa4":"automation-popup_AutomationPopup__SetupVideoQa4__qEfzK","AutomationPopup__TotalDuration":"automation-popup_AutomationPopup__TotalDuration__LfGOp","AutomationPopup__InputField":"automation-popup_AutomationPopup__InputField__njIzD","AutomationPopup__TwoFields":"automation-popup_AutomationPopup__TwoFields__LqkEk","AutomationPopup__Time":"automation-popup_AutomationPopup__Time__wAnOT","AutomationPopup__Attempts__Number":"automation-popup_AutomationPopup__Attempts__Number__gHvAM","InterviewType__Phone":"automation-popup_InterviewType__Phone__DIdVq","InterviewType__Video":"automation-popup_InterviewType__Video__BTq_u","InterviewType__Face2Face":"automation-popup_InterviewType__Face2Face__pDGeN","InterviewType__SetupVideoQa2":"automation-popup_InterviewType__SetupVideoQa2__YyFzJ","InterviewType__Questions":"automation-popup_InterviewType__Questions__3ChIH","TagRow":"automation-popup_TagRow__qIxSB","Form__Input":"automation-popup_Form__Input__IH0Tb","Form__Textarea":"automation-popup_Form__Textarea__ZEp_O","Form__InputFocus":"automation-popup_Form__InputFocus__NRIRN","Form__CustomSelect":"automation-popup_Form__CustomSelect__IrM18","IntegrationPopup__Desc":"automation-popup_IntegrationPopup__Desc__vE0su","IntegrationPopup__inner":"automation-popup_IntegrationPopup__inner__chOPr","IntegrationPopup__PaddingPopup":"automation-popup_IntegrationPopup__PaddingPopup__aEKtl","IntegrationPopup__Content":"automation-popup_IntegrationPopup__Content__dTIS3"};

/***/ }),

/***/ 58079:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Modalpopup":"browser-notification_Modalpopup__h_j8s","Modalpopup__inner":"browser-notification_Modalpopup__inner__JE636","Modalpopup__Dialog":"browser-notification_Modalpopup__Dialog__TOTFv","transition":"browser-notification_transition__qJwvz","Modalpopup__CloseCenter":"browser-notification_Modalpopup__CloseCenter__JkOgW","Modalpopup__Content":"browser-notification_Modalpopup__Content__alGJw","Modalpopup__btn":"browser-notification_Modalpopup__btn__M_E2g","mar":"browser-notification_mar__M00dg","Otpback":"browser-notification_Otpback__pBVIc","Form":"browser-notification_Form__7LW9L","Form__width":"browser-notification_Form__width__2GBzf","Form__label":"browser-notification_Form__label__W_3Ub","Form__textleft":"browser-notification_Form__textleft__8OMLk","Form__InputFullWidth":"browser-notification_Form__InputFullWidth_____dB","Form__Input":"browser-notification_Form__Input__mZfOq","Form__InputSection":"browser-notification_Form__InputSection__IR1nH","Form__ScoreCardInput":"browser-notification_Form__ScoreCardInput__VcUuQ","Form__Textarea":"browser-notification_Form__Textarea__CFGiy","primarybtn":"browser-notification_primarybtn__XORaV","secondarybtn":"browser-notification_secondarybtn__lRBCj","iconFilled":"browser-notification_iconFilled__jo0GT","iconFilledSolid":"browser-notification_iconFilledSolid__3KPVh","primarybtnborder":"browser-notification_primarybtnborder__Se_bE","AllowBtn":"browser-notification_AllowBtn__8jwzs","secondarybtnborder":"browser-notification_secondarybtnborder__5Vgp1","ClearBtn":"browser-notification_ClearBtn___axLc","tertiarybtn":"browser-notification_tertiarybtn__BFhwX","graybtnborder":"browser-notification_graybtnborder__kLYFk","jobsrchbtn":"browser-notification_jobsrchbtn__WbGPv","jobsrchbtnalign":"browser-notification_jobsrchbtnalign__RTOLd","nobgbutton":"browser-notification_nobgbutton__ofovA","iconTextButton":"browser-notification_iconTextButton__SXK58","cursornone":"browser-notification_cursornone__V1rp_","nobgbuttonprimary":"browser-notification_nobgbuttonprimary__5xs3x","mt15":"browser-notification_mt15__TbaPL","btn350":"browser-notification_btn350__5B_fW","GrayBgBtn":"browser-notification_GrayBgBtn__ah8Mb","NewShareBtn":"browser-notification_NewShareBtn__ljxMI","CoralBgBtn":"browser-notification_CoralBgBtn__iDbnS","BrowserNotification":"browser-notification_BrowserNotification__GyY7_","BrowserNotification__content":"browser-notification_BrowserNotification__content__qdWnP","BrowserNotification__LogoImage":"browser-notification_BrowserNotification__LogoImage__Eieb2","BrowserNotification__Message":"browser-notification_BrowserNotification__Message__5W09x","BtnSection":"browser-notification_BtnSection__67l9U"};

/***/ }),

/***/ 35714:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Modalpopup":"calendar_Modalpopup__WuIkf","Modalpopup__inner":"calendar_Modalpopup__inner__rIBgx","Modalpopup__Dialog":"calendar_Modalpopup__Dialog__BbLYH","transition":"calendar_transition__3VvGx","Modalpopup__CloseCenter":"calendar_Modalpopup__CloseCenter__N6pCJ","Modalpopup__Content":"calendar_Modalpopup__Content__WR8mn","Modalpopup__btn":"calendar_Modalpopup__btn__7P3sY","mar":"calendar_mar__SNdou","Otpback":"calendar_Otpback__srETk","Form":"calendar_Form__70LZX","Form__width":"calendar_Form__width__eCDVv","Form__label":"calendar_Form__label__cOtID","Form__textleft":"calendar_Form__textleft__CTb2a","Form__InputFullWidth":"calendar_Form__InputFullWidth__mId_2","Form__Input":"calendar_Form__Input__ya2z1","Form__InputSection":"calendar_Form__InputSection__GSEsD","Form__ScoreCardInput":"calendar_Form__ScoreCardInput__kZe_V","Form__Textarea":"calendar_Form__Textarea__C6HKM","primarybtn":"calendar_primarybtn__sGFoY","secondarybtn":"calendar_secondarybtn__Uio30","iconFilled":"calendar_iconFilled__2UvS4","iconFilledSolid":"calendar_iconFilledSolid__WCp89","primarybtnborder":"calendar_primarybtnborder__8zl1N","secondarybtnborder":"calendar_secondarybtnborder__MtKbB","tertiarybtn":"calendar_tertiarybtn__4Y9se","graybtnborder":"calendar_graybtnborder__DnG2T","jobsrchbtn":"calendar_jobsrchbtn__Oqnhw","jobsrchbtnalign":"calendar_jobsrchbtnalign__rpdc3","nobgbutton":"calendar_nobgbutton__TmS9v","iconTextButton":"calendar_iconTextButton__jNnJa","cursornone":"calendar_cursornone__Yhq8a","nobgbuttonprimary":"calendar_nobgbuttonprimary__iM_j3","mt15":"calendar_mt15__Ychdg","btn350":"calendar_btn350__DtiOk","GrayBgBtn":"calendar_GrayBgBtn__aZnrs","NewShareBtn":"calendar_NewShareBtn__h9qiv","CoralBgBtn":"calendar_CoralBgBtn__ckvn8","DateFNS__Calendar":"calendar_DateFNS__Calendar__PwFne","DateFNS__Calendar__LeftIcon":"calendar_DateFNS__Calendar__LeftIcon__TeXj2","DateFNS__Calendar__RightIcon":"calendar_DateFNS__Calendar__RightIcon__qZsSH","DateFNS__Calendar__Content":"calendar_DateFNS__Calendar__Content__vFsEu","DateFNS__Calendar__MonthYear":"calendar_DateFNS__Calendar__MonthYear__9x6Pb","DateFNS__Calendar__WeekNames":"calendar_DateFNS__Calendar__WeekNames__rbkL4","DateFNS__Calendar__WeekDays":"calendar_DateFNS__Calendar__WeekDays__KEuEk","DateFNS__Calendar__Body":"calendar_DateFNS__Calendar__Body__mso61","DateFNS__Calendar__Row":"calendar_DateFNS__Calendar__Row__hEW_c","DateFNS__Calendar__DaysCells":"calendar_DateFNS__Calendar__DaysCells__j9wln","DateFNS__Calendar__Cell":"calendar_DateFNS__Calendar__Cell__JHDae","DateFNS__Calendar__Cell__Disabled":"calendar_DateFNS__Calendar__Cell__Disabled__2d5OK","DateFNS__Calendar__Cell__Selected":"calendar_DateFNS__Calendar__Cell__Selected__Sh9DG","DateFNS__Calendar__Date":"calendar_DateFNS__Calendar__Date__aYgnO","DateFNS__Calendar__Month":"calendar_DateFNS__Calendar__Month__UUEWj","CalendarMonth":"calendar_CalendarMonth__1NOwU","CalendarDate":"calendar_CalendarDate__peEcb","CalendarWeek":"calendar_CalendarWeek___MnT_","CalendarMonth__Day":"calendar_CalendarMonth__Day___aiuD","CalendarDate__Day":"calendar_CalendarDate__Day__FE8It","CalendarWeek__Day":"calendar_CalendarWeek__Day__ixy5V","CalendarMonth__LeftIcon":"calendar_CalendarMonth__LeftIcon__9xyRV","CalendarMonth__RightIcon":"calendar_CalendarMonth__RightIcon__Q2QGi","CalendarDate__LeftIcon":"calendar_CalendarDate__LeftIcon__qv0Jt","CalendarDate__RightIcon":"calendar_CalendarDate__RightIcon__EUm0i","CalendarWeek__LeftIcon":"calendar_CalendarWeek__LeftIcon__hcr4t","CalendarWeek__RightIcon":"calendar_CalendarWeek__RightIcon__jOtJ0","CalendarMonth__CenterFlex":"calendar_CalendarMonth__CenterFlex__8yVoa","CalendarDate__CenterFlex":"calendar_CalendarDate__CenterFlex__xC6Xz","CalendarWeek__CenterFlex":"calendar_CalendarWeek__CenterFlex__o_McL","CalendarMonth__Content":"calendar_CalendarMonth__Content__P10Cq","CalendarDate__Content":"calendar_CalendarDate__Content__tkFUm","CalendarWeek__Content":"calendar_CalendarWeek__Content___JUG_","CalendarMonth__Content__Body":"calendar_CalendarMonth__Content__Body__G_zRK","CalendarDate__Content__Body":"calendar_CalendarDate__Content__Body__m6nW2","CalendarWeek__Content__Body":"calendar_CalendarWeek__Content__Body__CtpgD","CalendarMonth__Content__CurrentDate":"calendar_CalendarMonth__Content__CurrentDate__V7LP8","CalendarDate__Content__CurrentDate":"calendar_CalendarDate__Content__CurrentDate__vlrYx","CalendarWeek__Content__CurrentDate":"calendar_CalendarWeek__Content__CurrentDate__hXiG5","CalendarMonth__Content__InterviewAvailable":"calendar_CalendarMonth__Content__InterviewAvailable__1WFrH","CalendarDate__Content__InterviewAvailable":"calendar_CalendarDate__Content__InterviewAvailable__v9zP3","CalendarWeek__Content__InterviewAvailable":"calendar_CalendarWeek__Content__InterviewAvailable__9XUKE","CalendarWeek__Icon":"calendar_CalendarWeek__Icon__hrjjs","CalendarWeek__Row":"calendar_CalendarWeek__Row__6U54v","CalendarWeek__Cell":"calendar_CalendarWeek__Cell__V8sUd","CalendarWeek__Cell__DayName":"calendar_CalendarWeek__Cell__DayName___TtgQ","CalendarWeek__Cell__Date":"calendar_CalendarWeek__Cell__Date__E_4D4","CalendarWeek__Cell__CurrentDay":"calendar_CalendarWeek__Cell__CurrentDay__zqwtP","CalendarWeek__Cell__Selected":"calendar_CalendarWeek__Cell__Selected__Rqfk7","CalendarMonth__CurrentMonth":"calendar_CalendarMonth__CurrentMonth__W6_55"};

/***/ }),

/***/ 42037:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Modalpopup":"candidate-bulk-action-modal_Modalpopup__XlypX","Modalpopup__inner":"candidate-bulk-action-modal_Modalpopup__inner__wzAmg","Modalpopup__Dialog":"candidate-bulk-action-modal_Modalpopup__Dialog__XFI45","transition":"candidate-bulk-action-modal_transition___z_JR","Modalpopup__CloseCenter":"candidate-bulk-action-modal_Modalpopup__CloseCenter__JEaBf","Modalpopup__Content":"candidate-bulk-action-modal_Modalpopup__Content__Xwyqy","Modalpopup__btn":"candidate-bulk-action-modal_Modalpopup__btn___u_vj","mar":"candidate-bulk-action-modal_mar__2dNHH","Otpback":"candidate-bulk-action-modal_Otpback__gXwug","Form":"candidate-bulk-action-modal_Form__IOTOY","Form__width":"candidate-bulk-action-modal_Form__width___jl2D","Form__label":"candidate-bulk-action-modal_Form__label__Cyjiq","Form__textleft":"candidate-bulk-action-modal_Form__textleft__UYsin","Form__InputFullWidth":"candidate-bulk-action-modal_Form__InputFullWidth__ZyCb_","Form__Input":"candidate-bulk-action-modal_Form__Input__ad2m0","Form__InputSection":"candidate-bulk-action-modal_Form__InputSection__8cCmv","Form__ScoreCardInput":"candidate-bulk-action-modal_Form__ScoreCardInput__rezSh","Form__Textarea":"candidate-bulk-action-modal_Form__Textarea__g6wIp","primarybtn":"candidate-bulk-action-modal_primarybtn__nTV8W","secondarybtn":"candidate-bulk-action-modal_secondarybtn__7UIPK","iconFilled":"candidate-bulk-action-modal_iconFilled__rGVYn","iconFilledSolid":"candidate-bulk-action-modal_iconFilledSolid__INwJg","primarybtnborder":"candidate-bulk-action-modal_primarybtnborder__2Ddj6","secondarybtnborder":"candidate-bulk-action-modal_secondarybtnborder__rDKoh","tertiarybtn":"candidate-bulk-action-modal_tertiarybtn___pPUk","graybtnborder":"candidate-bulk-action-modal_graybtnborder__9GqxM","jobsrchbtn":"candidate-bulk-action-modal_jobsrchbtn__Hjhz4","jobsrchbtnalign":"candidate-bulk-action-modal_jobsrchbtnalign__K_VYO","nobgbutton":"candidate-bulk-action-modal_nobgbutton__5Zz7O","iconTextButton":"candidate-bulk-action-modal_iconTextButton__6D1Xw","cursornone":"candidate-bulk-action-modal_cursornone__xh1QH","nobgbuttonprimary":"candidate-bulk-action-modal_nobgbuttonprimary__KLu4k","mt15":"candidate-bulk-action-modal_mt15__uAsv7","btn350":"candidate-bulk-action-modal_btn350__auQ7q","GrayBgBtn":"candidate-bulk-action-modal_GrayBgBtn__S0utu","NewShareBtn":"candidate-bulk-action-modal_NewShareBtn__hFZEe","CoralBgBtn":"candidate-bulk-action-modal_CoralBgBtn__K7Sn7","CandidateBulkActionSection":"candidate-bulk-action-modal_CandidateBulkActionSection__xppb8","KanbanBulkActionSection":"candidate-bulk-action-modal_KanbanBulkActionSection__Hcin5","KanbanBulkActionSection__Progress":"candidate-bulk-action-modal_KanbanBulkActionSection__Progress___v0EZ","KanbanBulkActionSection__Message":"candidate-bulk-action-modal_KanbanBulkActionSection__Message__h4zy_","Heading":"candidate-bulk-action-modal_Heading___d8cL"};

/***/ }),

/***/ 22842:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Modalpopup":"candidate-email_Modalpopup__0NC2d","Modalpopup__inner":"candidate-email_Modalpopup__inner__aB0Va","Modalpopup__Dialog":"candidate-email_Modalpopup__Dialog__iElw8","transition":"candidate-email_transition__7_8Fe","Modalpopup__CloseCenter":"candidate-email_Modalpopup__CloseCenter__InuGq","Modalpopup__Content":"candidate-email_Modalpopup__Content__HY_8D","SetupPopup__PaddingPopup":"candidate-email_SetupPopup__PaddingPopup__I3sgO","SetupPopup__ContentCustomisation":"candidate-email_SetupPopup__ContentCustomisation__UkBOo","SetupPopup__Contentwithoutpadding":"candidate-email_SetupPopup__Contentwithoutpadding__g3OH_","Modalpopup__btn":"candidate-email_Modalpopup__btn__BiDyO","mar":"candidate-email_mar__Ye7Ln","Otpback":"candidate-email_Otpback__NEuHH","Form":"candidate-email_Form__pz4F4","Form__width":"candidate-email_Form__width__NH13j","Form__label":"candidate-email_Form__label__9IYuA","Form__textleft":"candidate-email_Form__textleft__0w4hx","Form__InputFullWidth":"candidate-email_Form__InputFullWidth__dQpth","Form__Input":"candidate-email_Form__Input__47pJZ","Form__Input398":"candidate-email_Form__Input398__2r2uK","Form__InputSection":"candidate-email_Form__InputSection__E3asx","Form__ScoreCardInput":"candidate-email_Form__ScoreCardInput__3v_iO","Form__Textarea":"candidate-email_Form__Textarea__pdyBT","primarybtn":"candidate-email_primarybtn__bVuH6","GoBtn":"candidate-email_GoBtn__KMM_A","secondarybtn":"candidate-email_secondarybtn__0Aghl","iconFilled":"candidate-email_iconFilled__qnACH","iconFilledSolid":"candidate-email_iconFilledSolid__RDL5I","primarybtnborder":"candidate-email_primarybtnborder__7krIh","secondarybtnborder":"candidate-email_secondarybtnborder__I1Ckb","ClearBtn":"candidate-email_ClearBtn__OowgQ","tertiarybtn":"candidate-email_tertiarybtn__eeP_B","graybtnborder":"candidate-email_graybtnborder__mjs69","jobsrchbtn":"candidate-email_jobsrchbtn___mlhw","jobsrchbtnalign":"candidate-email_jobsrchbtnalign__XTKAh","nobgbutton":"candidate-email_nobgbutton__xY1BI","iconTextButton":"candidate-email_iconTextButton__bIhRQ","cursornone":"candidate-email_cursornone__g3jtO","nobgbuttonprimary":"candidate-email_nobgbuttonprimary__xCXn0","mt15":"candidate-email_mt15__dI_lg","btn350":"candidate-email_btn350__n07I_","GrayBgBtn":"candidate-email_GrayBgBtn__GXr2E","NewShareBtn":"candidate-email_NewShareBtn__aLByS","CoralBgBtn":"candidate-email_CoralBgBtn__Tm7uU","DropContainer":"candidate-email_DropContainer__XNqwJ","DropContainer__Inner":"candidate-email_DropContainer__Inner__basmy","CompanyProfile__Inner":"candidate-email_CompanyProfile__Inner__GDtHu","DropContainer__Message":"candidate-email_DropContainer__Message__PV14G","CompanyProfile__Message":"candidate-email_CompanyProfile__Message__KwBpG","CompanyProfile__MessageContent":"candidate-email_CompanyProfile__MessageContent__7m8oC","DropContainer__UploadIcon":"candidate-email_DropContainer__UploadIcon__sOOJP","CompanyProfile__UploadIcon":"candidate-email_CompanyProfile__UploadIcon__Qtgd_","FileDisplayContainer":"candidate-email_FileDisplayContainer__vCd6p","FileDisplayContainer__Status":"candidate-email_FileDisplayContainer__Status__x1dEt","SetupPopup__Status":"candidate-email_SetupPopup__Status__yzTku","SetupPopup__To":"candidate-email_SetupPopup__To__XnNq1","FileDisplayContainer__Type":"candidate-email_FileDisplayContainer__Type__CtHle","FileDisplayContainer__Name":"candidate-email_FileDisplayContainer__Name__iBlCR","SetupPopup__Name":"candidate-email_SetupPopup__Name___MVXg","SetupPopup__ToName":"candidate-email_SetupPopup__ToName__asOGc","FileDisplayContainer__Error":"candidate-email_FileDisplayContainer__Error__ZQYp5","FileDisplayContainer__Close":"candidate-email_FileDisplayContainer__Close__q9YjA","Browse":"candidate-email_Browse__04LPx","ClientCompany":"candidate-email_ClientCompany__ObosX","NewJob":"candidate-email_NewJob__qZ4tK","Interview":"candidate-email_Interview__OuDAv","ClientCompany__TopSection2":"candidate-email_ClientCompany__TopSection2__CG_Kj","ClientCompany__Filter":"candidate-email_ClientCompany__Filter__D09qm","ClientCompany__Input_MatchScore":"candidate-email_ClientCompany__Input_MatchScore__eyqD3","ClientCompany__Percentage_Symbol":"candidate-email_ClientCompany__Percentage_Symbol__TsbXj","ClientCompany__Filterheading":"candidate-email_ClientCompany__Filterheading__PkofT","ClientCompany__FloatButtonAdd":"candidate-email_ClientCompany__FloatButtonAdd__S2g_9","ClientCompany__FloatButtonAdd__AgencyUserIcon":"candidate-email_ClientCompany__FloatButtonAdd__AgencyUserIcon__5sTRy","ClientCompany__LastEdited":"candidate-email_ClientCompany__LastEdited__S1xRl","ClientCompany__BackSection":"candidate-email_ClientCompany__BackSection__zWCyA","AddUsers__BackSection":"candidate-email_AddUsers__BackSection__wDMWE","ClientCompany__BackSection__CloseIcon":"candidate-email_ClientCompany__BackSection__CloseIcon__6FdrC","ClientCompany__Container":"candidate-email_ClientCompany__Container___kIxa","NewJob__InterviewContainer":"candidate-email_NewJob__InterviewContainer__JdVzT","AddUsers__Container":"candidate-email_AddUsers__Container__ZPoTY","ClientCompany__FormInputSection":"candidate-email_ClientCompany__FormInputSection__sO8Nj","CompanyProfile__FormInputSection":"candidate-email_CompanyProfile__FormInputSection__mDjPz","ClientCompany__Heading":"candidate-email_ClientCompany__Heading__uUSoT","AddUsers__Heading":"candidate-email_AddUsers__Heading__OoJoy","ClientCompany__StatusAlignment":"candidate-email_ClientCompany__StatusAlignment__cfP4p","ClientCompany__Status":"candidate-email_ClientCompany__Status__AbpsS","ClientCompany__ActiveDot":"candidate-email_ClientCompany__ActiveDot__TI5Ul","ClientCompany__CloseDot":"candidate-email_ClientCompany__CloseDot__FXXKM","ClientCompany__Company":"candidate-email_ClientCompany__Company__HeWHU","AddUsers__User":"candidate-email_AddUsers__User__DfrHt","ClientCompany__Systemrefheding":"candidate-email_ClientCompany__Systemrefheding__2Sm1d","ClientCompany__Subheading":"candidate-email_ClientCompany__Subheading__Pb_Ry","CompanyProfile__Subheading":"candidate-email_CompanyProfile__Subheading__2JmJX","ClientCompany__Subheading2":"candidate-email_ClientCompany__Subheading2__xHu_R","ClientCompany__Description":"candidate-email_ClientCompany__Description__hV_EX","ClientCompany__SubmitSection":"candidate-email_ClientCompany__SubmitSection__gzQ2L","NewJob__SubmitSection":"candidate-email_NewJob__SubmitSection__Kpq7_","NewJob__SubmitSectionThreeBtn":"candidate-email_NewJob__SubmitSectionThreeBtn__7S0GO","NewJob__SubmitSectionOneBtnPlacement":"candidate-email_NewJob__SubmitSectionOneBtnPlacement__rQTyR","NewJob__ImportSection":"candidate-email_NewJob__ImportSection__szwdf","SetupPopup__SubmitSection2":"candidate-email_SetupPopup__SubmitSection2__qS7uJ","SetupPopup__SubmitSection":"candidate-email_SetupPopup__SubmitSection___4UXk","SetupPopup__SubmitSection3":"candidate-email_SetupPopup__SubmitSection3__aWtml","AddUsers__SubmitSection":"candidate-email_AddUsers__SubmitSection__K_QMc","ClientCompany__IntegrationImage":"candidate-email_ClientCompany__IntegrationImage__19Q_n","ClientCompany__QuickAdd":"candidate-email_ClientCompany__QuickAdd__1RxF9","NewJob__QuickAdd":"candidate-email_NewJob__QuickAdd__fZurN","Interview__QuickAdd":"candidate-email_Interview__QuickAdd__WSFKs","ClientCompany__BodyText":"candidate-email_ClientCompany__BodyText__ExzlS","Form__TableRow":"candidate-email_Form__TableRow__5LMAQ","Form__Label":"candidate-email_Form__Label__XO_7I","Form__FloatingLabel":"candidate-email_Form__FloatingLabel__yhPXt","Form__TableCol":"candidate-email_Form__TableCol__mvezl","Form__currency_symbol":"candidate-email_Form__currency_symbol__h9bO1","Form__CustomSelect":"candidate-email_Form__CustomSelect__aifZ6","Form__currency_symbol__right":"candidate-email_Form__currency_symbol__right__W_2iL","Form__TableCol__Disabled":"candidate-email_Form__TableCol__Disabled__7SPqL","Form__TextareaDisabled":"candidate-email_Form__TextareaDisabled__UiXLA","Form__EditorDisabled":"candidate-email_Form__EditorDisabled__1vO9C","Form__AdminCheckLabel":"candidate-email_Form__AdminCheckLabel__ZPp8T","Form__AdminCheckMargin":"candidate-email_Form__AdminCheckMargin__mcQHw","CompanyProfile__BrandingGuide":"candidate-email_CompanyProfile__BrandingGuide__woSY3","CompanyProfile__DropBoxContainer":"candidate-email_CompanyProfile__DropBoxContainer__kj5lt","CompanyProfile__Browse":"candidate-email_CompanyProfile__Browse__QjNwF","ErrorLabel":"candidate-email_ErrorLabel__G4LU5","Height80":"candidate-email_Height80__r1UEX","Browse__ButtonFlexEnd":"candidate-email_Browse__ButtonFlexEnd___wUFZ","AddAgency__Container":"candidate-email_AddAgency__Container__rFdQz","AddAgency__FormInputSection":"candidate-email_AddAgency__FormInputSection__XyGJ5","AddAgency__FormInputSection__Label":"candidate-email_AddAgency__FormInputSection__Label__sipTg","AddAgency__Form":"candidate-email_AddAgency__Form__wlAT2","LinkAsButtons":"candidate-email_LinkAsButtons__VpS8t","SearchFlex":"candidate-email_SearchFlex__qp486","Form__ErrorCustomSelect":"candidate-email_Form__ErrorCustomSelect__jc59h","Form__select_currency":"candidate-email_Form__select_currency__O_oeL","customSelect__placeholder":"candidate-email_customSelect__placeholder__wJoj8","Career":"candidate-email_Career__HhFnc","Career__Background_Edit":"candidate-email_Career__Background_Edit__p5KPQ","Career__Background_Edit_Image":"candidate-email_Career__Background_Edit_Image__SVYsv","Career__Container":"candidate-email_Career__Container__1Sz_d","Career__Inner":"candidate-email_Career__Inner__NEUN0","Career__logo":"candidate-email_Career__logo__xKnRG","Career__Content":"candidate-email_Career__Content__K4o_p","Career__ButtonSection":"candidate-email_Career__ButtonSection__jbjdW","Job":"candidate-email_Job__SX8aC","Job__Inner":"candidate-email_Job__Inner__Xwpve","Job__Container":"candidate-email_Job__Container__u0XY3","Job__Heading":"candidate-email_Job__Heading__61j4g","Job__Company":"candidate-email_Job__Company__vXXH7","Job__SearchContainer":"candidate-email_Job__SearchContainer__h8Qye","Job__SearchInput":"candidate-email_Job__SearchInput__kThpG","Job__Searchbtn":"candidate-email_Job__Searchbtn__KSKzE","Job__Input":"candidate-email_Job__Input__2bnwF","Job__SelectJob":"candidate-email_Job__SelectJob__KPZfc","Job__RemoteLabel":"candidate-email_Job__RemoteLabel__U1fNB","Job__Display":"candidate-email_Job__Display__u4_s7","Job__PostDay":"candidate-email_Job__PostDay__YMuka","Job__Title":"candidate-email_Job__Title__f4UWc","Job__Location":"candidate-email_Job__Location__w5dvv","DT":"candidate-email_DT__KCQeU","DisplayTable":"candidate-email_DisplayTable__q8ZSg","pd11":"candidate-email_pd11__P6XFs","Label":"candidate-email_Label__wLecg","inputwidth":"candidate-email_inputwidth__wAN3_","mr24":"candidate-email_mr24__5r2FQ","fullwidth":"candidate-email_fullwidth__uUUp1","padt40":"candidate-email_padt40__fqvsi","Form__TableRowflex":"candidate-email_Form__TableRowflex__q1Vbz","Form__TableColm":"candidate-email_Form__TableColm__jOw5J","Form__LabelCheck":"candidate-email_Form__LabelCheck__f_HxS","Form__Error":"candidate-email_Form__Error__f9ov_","Form__ErrorSection":"candidate-email_Form__ErrorSection__bQG9h","Form__MessagePlaceholder":"candidate-email_Form__MessagePlaceholder__dreM6","Form__Submit":"candidate-email_Form__Submit__zaVUH","Form__NormalLabel":"candidate-email_Form__NormalLabel__KiAXD","AddInterview":"candidate-email_AddInterview__M2Wo1","IntegrationPage":"candidate-email_IntegrationPage__w5hg3","Integration__BackStep":"candidate-email_Integration__BackStep__UiMIc","AddUsers__BackStep":"candidate-email_AddUsers__BackStep__a5qEY","Integration__SubmitSection":"candidate-email_Integration__SubmitSection__R0oCT","IntegrationTable":"candidate-email_IntegrationTable__lNbbL","IntegrationTable__LimitInput":"candidate-email_IntegrationTable__LimitInput__d8nTy","IntegrationTable__Type":"candidate-email_IntegrationTable__Type__hk5zr","IntegrationTable__AllJobsToggle":"candidate-email_IntegrationTable__AllJobsToggle__o22XZ","IntegrationTable__switch":"candidate-email_IntegrationTable__switch__S_Xbu","IntegrationTable__switchText":"candidate-email_IntegrationTable__switchText__TrEg_","IntegrationTable__slider":"candidate-email_IntegrationTable__slider__X242I","IntegrationTable__round":"candidate-email_IntegrationTable__round__XyxY_","IntegrationTable__Action":"candidate-email_IntegrationTable__Action__YlsEl","IntegrationView":"candidate-email_IntegrationView__kHF1b","IntegrationView__Title":"candidate-email_IntegrationView__Title__cfMA4","IntegrationView__Subheading":"candidate-email_IntegrationView__Subheading__mQB43","IntegrationView__BoxImage":"candidate-email_IntegrationView__BoxImage__psE5X","IntegrationView__Box":"candidate-email_IntegrationView__Box__4hAtw","IntegrationView__BoxImage__InfoIcon":"candidate-email_IntegrationView__BoxImage__InfoIcon__khs2D","IntegrationView__ViewMoreButton":"candidate-email_IntegrationView__ViewMoreButton__guSFO","IntegrationView__ConnectButton":"candidate-email_IntegrationView__ConnectButton___KTNH","IntegrationView__GoogleButton":"candidate-email_IntegrationView__GoogleButton__ZUMFW","IntegrationView__FlexFlow":"candidate-email_IntegrationView__FlexFlow__EXDV2","IntegrationView__BoxWidth":"candidate-email_IntegrationView__BoxWidth__1dW5V","SkipFinishButton":"candidate-email_SkipFinishButton__G29AR","AddUsers":"candidate-email_AddUsers__hYy1r","AddUsers__ButtonSection":"candidate-email_AddUsers__ButtonSection__Se4_Y","AddUsers__QuickStepHeading":"candidate-email_AddUsers__QuickStepHeading__tNVOa","AddUsers__DeleteSection":"candidate-email_AddUsers__DeleteSection__6f_Bn","Interview__DeleteSection":"candidate-email_Interview__DeleteSection__4MA9I","AddUsers__DeleteCrossHeight":"candidate-email_AddUsers__DeleteCrossHeight__GkNEd","AddUsers__Form__Input":"candidate-email_AddUsers__Form__Input__FWMUK","AddUsers__FormHeadingSection":"candidate-email_AddUsers__FormHeadingSection__fkNpF","Interview__FormHeadingSection":"candidate-email_Interview__FormHeadingSection__dh_8A","AddUsers__FormSection":"candidate-email_AddUsers__FormSection__ziyXc","NewJob__FormSection":"candidate-email_NewJob__FormSection__hlsjy","AddUsers__ButtonsActionSection":"candidate-email_AddUsers__ButtonsActionSection__RWtAJ","AddUsers__ImportUsers":"candidate-email_AddUsers__ImportUsers__XrMdT","AddUsers__NameInput":"candidate-email_AddUsers__NameInput__ZIdft","AddUsers__EmailInput":"candidate-email_AddUsers__EmailInput__t0jvg","AddUsers__RoleInput":"candidate-email_AddUsers__RoleInput__Kl4Gc","AddUsers__Subheading":"candidate-email_AddUsers__Subheading__xCEAd","AddUsers__visible":"candidate-email_AddUsers__visible__mJ9Xy","Tagrow":"candidate-email_Tagrow__zF98t","Tagrow__Tags":"candidate-email_Tagrow__Tags__fjE2r","SetupPopup__Tags":"candidate-email_SetupPopup__Tags__04rtD","Tagrow__Cancel":"candidate-email_Tagrow__Cancel__c5p9o","Tagrow__Cross":"candidate-email_Tagrow__Cross__cAyLM","SendInviteSection":"candidate-email_SendInviteSection__ec_tp","error":"candidate-email_error___pwy4","ViewJobPage__Input":"candidate-email_ViewJobPage__Input__KzITY","Form__Input2":"candidate-email_Form__Input2__vExMM","ViewJobPage__PostDay":"candidate-email_ViewJobPage__PostDay__Oev2I","ViewJobPage__Title":"candidate-email_ViewJobPage__Title__an2jX","ViewJobPage__DescriptionTitle":"candidate-email_ViewJobPage__DescriptionTitle__iFKJj","ViewJobPage__Location":"candidate-email_ViewJobPage__Location__7bHhZ","ViewJobPage__primarybtn":"candidate-email_ViewJobPage__primarybtn__W9YMB","ViewJobPage__secondarybtn":"candidate-email_ViewJobPage__secondarybtn__muGwc","ViewJobPage__secondarybtnborder":"candidate-email_ViewJobPage__secondarybtnborder__lGs0d","ViewJobPage__BackSection":"candidate-email_ViewJobPage__BackSection__iKDDz","ViewJobPage__Content":"candidate-email_ViewJobPage__Content__2kha0","ViewJobPage":"candidate-email_ViewJobPage__GVGJk","ViewJobPage__Header":"candidate-email_ViewJobPage__Header__G6yBX","ViewJobPage__Application":"candidate-email_ViewJobPage__Application__FNDcj","ViewJobPage__RecordVideo":"candidate-email_ViewJobPage__RecordVideo__ZtZtK","ViewJobPage__RecordVideoSuccessText":"candidate-email_ViewJobPage__RecordVideoSuccessText__1IYf0","ViewJobPage__subheading":"candidate-email_ViewJobPage__subheading__aTlHp","ViewJobPage__confirmation":"candidate-email_ViewJobPage__confirmation__n2ZEl","ViewJobPage__Logo":"candidate-email_ViewJobPage__Logo__zuWoM","ViewJobPage__BrandLogo":"candidate-email_ViewJobPage__BrandLogo__0O0a7","ViewJobPage__BrandLogo__Padding10":"candidate-email_ViewJobPage__BrandLogo__Padding10__yedVx","ViewJobPage__Container":"candidate-email_ViewJobPage__Container__5xGts","ViewJobPage__JobContent":"candidate-email_ViewJobPage__JobContent__5d6Q9","ViewJobPage__Sidebar":"candidate-email_ViewJobPage__Sidebar__LFGvY","ViewJobPage__Sidebar2":"candidate-email_ViewJobPage__Sidebar2__PVpTr","ViewJobPage__Description":"candidate-email_ViewJobPage__Description__SD_sP","ViewJobPage__DescriptionWidth":"candidate-email_ViewJobPage__DescriptionWidth__SWnt5","ViewJobPage__Footer":"candidate-email_ViewJobPage__Footer__D9Dn6","ViewJobPage__FooterView":"candidate-email_ViewJobPage__FooterView__PF0d5","ViewJobPage__ShareJob":"candidate-email_ViewJobPage__ShareJob__xNEJb","ViewJobPage__SubmitSection":"candidate-email_ViewJobPage__SubmitSection__NAwYd","ViewJobPage__SocialMedia":"candidate-email_ViewJobPage__SocialMedia__lYEdL","ViewJobPage__SideContent":"candidate-email_ViewJobPage__SideContent__M64jv","ViewJobPage__ApplySection":"candidate-email_ViewJobPage__ApplySection__q_7NB","FormBox__Autofill":"candidate-email_FormBox__Autofill__oRHGS","applybuttons":"candidate-email_applybuttons__YKN2C","height90":"candidate-email_height90__GjWeV","Form__Cont":"candidate-email_Form__Cont__WWIpS","Form__DropBox":"candidate-email_Form__DropBox__k7j63","Form__DropBoxcontainer":"candidate-email_Form__DropBoxcontainer__fR5wf","Form__DropBoxError":"candidate-email_Form__DropBoxError__zemdZ","Form__DropBoxicon":"candidate-email_Form__DropBoxicon__f3AqP","Form__DropBoxmessage":"candidate-email_Form__DropBoxmessage__U9Dvq","noDpGrid":"candidate-email_noDpGrid__edIuw","Terms":"candidate-email_Terms__SmGXn","TermsCondition":"candidate-email_TermsCondition__6Q6AP","TermsCondition__alignterms":"candidate-email_TermsCondition__alignterms___wh75","MenuContainer":"candidate-email_MenuContainer__5SFax","MenuContainer__Menu":"candidate-email_MenuContainer__Menu__8p5Q3","AgencyDetailPage":"candidate-email_AgencyDetailPage__AsGgZ","Congrats__ModalContent":"candidate-email_Congrats__ModalContent__bYdOe","NewJob__Container":"candidate-email_NewJob__Container__rcEvo","NewJob__TopSection":"candidate-email_NewJob__TopSection__2kYVz","Interview__TopSection":"candidate-email_Interview__TopSection__8UZTz","NewJob__HorizontalDivider":"candidate-email_NewJob__HorizontalDivider__DiJcV","NewJob__Wrapper":"candidate-email_NewJob__Wrapper__mWUVY","NewJob__ContainerPadding":"candidate-email_NewJob__ContainerPadding__sfsht","NewJob__ContainerScroll":"candidate-email_NewJob__ContainerScroll__QvOOR","NewJob__ContainerHeight":"candidate-email_NewJob__ContainerHeight__v0ZDK","NewJob__ImportAction":"candidate-email_NewJob__ImportAction__6M2Er","NewJob__Interview_buttons":"candidate-email_NewJob__Interview_buttons__6ZZc7","Form__TableRowMB":"candidate-email_Form__TableRowMB__ayusI","Form__TableRow3grid":"candidate-email_Form__TableRow3grid__UBpYj","Form__Remotegrid":"candidate-email_Form__Remotegrid__XDXRw","Form__TypeList":"candidate-email_Form__TypeList__72TP_","Form__Type":"candidate-email_Form__Type__TCEjc","Form__CheckLabel":"candidate-email_Form__CheckLabel__89lJu","PrivateSwitchBase-root-1":"candidate-email_PrivateSwitchBase-root-1__zXea8","Form__Caption":"candidate-email_Form__Caption__xgeRw","Form__Input_currency":"candidate-email_Form__Input_currency__osSIn","Form__Input_MatchScore":"candidate-email_Form__Input_MatchScore__KLV_t","Form__Percentage_Symbol":"candidate-email_Form__Percentage_Symbol__j2fen","Form__NoGridTemplate":"candidate-email_Form__NoGridTemplate__CtaoG","active":"candidate-email_active__QgG2W","mt10":"candidate-email_mt10___kDzZ","mt40":"candidate-email_mt40__ThOzk","mt30":"candidate-email_mt30__ApiVD","mt32":"candidate-email_mt32__erBIO","mb0":"candidate-email_mb0__VergQ","Dpgrid":"candidate-email_Dpgrid__c5r23","mb12":"candidate-email_mb12__V8_K0","width100":"candidate-email_width100__KMu1L","Tagrow__Prefix":"candidate-email_Tagrow__Prefix__u2IgG","PreviewJobPage":"candidate-email_PreviewJobPage__DDf2m","PreviewJob":"candidate-email_PreviewJob__ZUjTq","DpFlx":"candidate-email_DpFlx__HHxMU","Subheading":"candidate-email_Subheading__agUvV","Subheading__Description":"candidate-email_Subheading__Description__NZjRQ","Candidate__Tooltip":"candidate-email_Candidate__Tooltip__V7hjG","Candidate__Tooltip__Score":"candidate-email_Candidate__Tooltip__Score__HzfVK","Form__InputField":"candidate-email_Form__InputField__9IJtH","Candidate__Length":"candidate-email_Candidate__Length__jjyfR","Agency__PostDay":"candidate-email_Agency__PostDay__D87b7","Agency__Title":"candidate-email_Agency__Title__l6GRG","Agency__Location":"candidate-email_Agency__Location__UyzMy","Agency__DescriptionTitle":"candidate-email_Agency__DescriptionTitle__TKp_7","Agency__Description":"candidate-email_Agency__Description__tRQ4a","LightBlueColor":"candidate-email_LightBlueColor__5TAIS","Client_Page":"candidate-email_Client_Page__WP3Ew","Welcome":"candidate-email_Welcome__ihoJZ","Welcome__Inner":"candidate-email_Welcome__Inner__k_V2e","Welcome__Person":"candidate-email_Welcome__Person__GDbon","Welcome__LeftContent":"candidate-email_Welcome__LeftContent__8gGRD","Welcome__RightContent":"candidate-email_Welcome__RightContent__CZLqA","Welcome__Content":"candidate-email_Welcome__Content__LltQ1","Welcome__CreateAccount":"candidate-email_Welcome__CreateAccount__tIVTQ","Welcome__title":"candidate-email_Welcome__title__sWxe_","Welcome__FormBox":"candidate-email_Welcome__FormBox__16VXk","Form__psw":"candidate-email_Form__psw__SC1Ue","Welcome__Container":"candidate-email_Welcome__Container__UB2Ql","Success__Container":"candidate-email_Success__Container__wn24J","Success":"candidate-email_Success__J439g","Success__Inner":"candidate-email_Success__Inner__ZUhuB","InterviewContainer":"candidate-email_InterviewContainer__XHdsj","Interview__Stages":"candidate-email_Interview__Stages__7WSoi","Interview__StageHeading":"candidate-email_Interview__StageHeading__UROZK","pl10":"candidate-email_pl10__H_kVa","Interview__AddStageSection":"candidate-email_Interview__AddStageSection__j734G","Interview__Label":"candidate-email_Interview__Label__Ln53L","Interview__FormRowHeading":"candidate-email_Interview__FormRowHeading__2wxo2","dpflex":"candidate-email_dpflex__OM9vx","Interview__IconsType":"candidate-email_Interview__IconsType__MMvyZ","Interview__Icons":"candidate-email_Interview__Icons__c0fVF","Interview__Interview_buttons":"candidate-email_Interview__Interview_buttons__tkJOy","Interview__approvalButton":"candidate-email_Interview__approvalButton__f1JG8","Interview__BestMatch":"candidate-email_Interview__BestMatch__87GkZ","Interview__BestMatchExclamation":"candidate-email_Interview__BestMatchExclamation__wdgU4","DragAndDrop":"candidate-email_DragAndDrop__5wIqp","DragAndDrop__CursorHandle":"candidate-email_DragAndDrop__CursorHandle__zL2HS","Tagrow__Image":"candidate-email_Tagrow__Image__lZswj","rowbglight":"candidate-email_rowbglight__bWmgK","rowbgheight":"candidate-email_rowbgheight__aAigN","Form__w90":"candidate-email_Form__w90__YkhEr","Container":"candidate-email_Container__MVme1","Screening__StageName":"candidate-email_Screening__StageName__aoXrE","Screening__InterviewType":"candidate-email_Screening__InterviewType__NjOvV","Screening__InterviewType__Label":"candidate-email_Screening__InterviewType__Label__QB_Ab","Show_Infoicon":"candidate-email_Show_Infoicon__v72D_","Show_Infoicon_small":"candidate-email_Show_Infoicon_small__OwBae","Screening__Info":"candidate-email_Screening__Info__cCUPx","Screening__Info__IconWithText":"candidate-email_Screening__Info__IconWithText__bdwV4","InterviewType__Icon":"candidate-email_InterviewType__Icon__YKD56","InterviewType__Text":"candidate-email_InterviewType__Text__8oCne","LoginModal":"candidate-email_LoginModal__CY3TO","Logincontent":"candidate-email_Logincontent__JE2qU","Logincontent__title":"candidate-email_Logincontent__title__uhUyf","Modalbg":"candidate-email_Modalbg__ejT1l","Modalnobg":"candidate-email_Modalnobg__t6nZh","Form__Container":"candidate-email_Form__Container__zSfQf","Form__success":"candidate-email_Form__success__pB_09","Form__error":"candidate-email_Form__error__iTFIo","Form__CheckLabeltext":"candidate-email_Form__CheckLabeltext__UJ5NN","Form__TextLeft":"candidate-email_Form__TextLeft__r_uMh","Backsection":"candidate-email_Backsection__mqp40","back":"candidate-email_back__M3X0f","mlr0":"candidate-email_mlr0__m7Mlb","TwoButtons":"candidate-email_TwoButtons__IBGuX","OtpBacksection":"candidate-email_OtpBacksection___87Jv","SetupPopup":"candidate-email_SetupPopup__nHN6c","SetupPopup__inner":"candidate-email_SetupPopup__inner__xfWzv","SetupPopup__Dialog":"candidate-email_SetupPopup__Dialog__62hMI","SetupPopup__AddFile":"candidate-email_SetupPopup__AddFile__JUCWf","SetupPopup__OptionalText":"candidate-email_SetupPopup__OptionalText__vjZ3U","SetupPopup__RequestAccessBtn":"candidate-email_SetupPopup__RequestAccessBtn__yQdBb","SetupPopup__InternalSection":"candidate-email_SetupPopup__InternalSection__yvMpU","SetupPopup__ContentInnerRow":"candidate-email_SetupPopup__ContentInnerRow__4nGFL","SetupPopup__ToChips":"candidate-email_SetupPopup__ToChips__WjQ2o","SetupPopup__AttachmentContainer":"candidate-email_SetupPopup__AttachmentContainer__qg9NI","SetupPopup__ContentInnerCol":"candidate-email_SetupPopup__ContentInnerCol__FM367","SetupPopup__grid":"candidate-email_SetupPopup__grid__hKfZ2","SetupPopup__Footer":"candidate-email_SetupPopup__Footer__aVeIf","SetupPopup__FooterNew":"candidate-email_SetupPopup__FooterNew__1Euqa","SetupPopup__Footer2":"candidate-email_SetupPopup__Footer2__Zwcj_","SetupPopup__Footer3":"candidate-email_SetupPopup__Footer3__JBxa_","SetupPopup__Footerassess":"candidate-email_SetupPopup__Footerassess__xFaJd","SetupPopup__Footertechtest":"candidate-email_SetupPopup__Footertechtest__Tokh9","SetupPopup__AutommationFooter":"candidate-email_SetupPopup__AutommationFooter__N_D4o","SetupPopup__MannualFooter":"candidate-email_SetupPopup__MannualFooter__o71ay","SetupPopup__MannualInnerSection":"candidate-email_SetupPopup__MannualInnerSection__eUPTo","SetupPopup__Content":"candidate-email_SetupPopup__Content__aHhLD","SetupPopup__Content__Radiobtn":"candidate-email_SetupPopup__Content__Radiobtn__Ly08N","SetupPopup__AutomationToggle":"candidate-email_SetupPopup__AutomationToggle__X3jg8","SetupPopup__SetupVideoQa":"candidate-email_SetupPopup__SetupVideoQa__iExJk","SetupPopup__SetupVideoQa2":"candidate-email_SetupPopup__SetupVideoQa2__DAYzB","SetupPopup__SetupVideoQa3":"candidate-email_SetupPopup__SetupVideoQa3__gb8wa","SetupPopup__SetupVideoQa4":"candidate-email_SetupPopup__SetupVideoQa4__rvdz6","SetupPopup__InputQA":"candidate-email_SetupPopup__InputQA__TLhAW","SetupPopup__AddQuestion":"candidate-email_SetupPopup__AddQuestion___6N8M","SetupPopup__QuestionSection":"candidate-email_SetupPopup__QuestionSection__uSnAj","SetupPopup__PushTop":"candidate-email_SetupPopup__PushTop__78tOz","SetupPopup__Contentpading":"candidate-email_SetupPopup__Contentpading__26Fe_","SetupPopup__QuesionSectionpading":"candidate-email_SetupPopup__QuesionSectionpading___z1El","SetupPopup__Contentcenter":"candidate-email_SetupPopup__Contentcenter__RPMEZ","SetupPopup__PopDetails":"candidate-email_SetupPopup__PopDetails__zgSrs","SetupPopup__PopDetails__FS16":"candidate-email_SetupPopup__PopDetails__FS16__Gbozq","SetupPopup__Details":"candidate-email_SetupPopup__Details__uNqiL","SetupPopup__PrivacyPolicyDetails":"candidate-email_SetupPopup__PrivacyPolicyDetails__k5lXv","SetupPopup__Reason":"candidate-email_SetupPopup__Reason__mawpI","SetupPopup__ContentBlock":"candidate-email_SetupPopup__ContentBlock__tduWv","SetupPopup__Purpose":"candidate-email_SetupPopup__Purpose__SDWqO","SetupPopup__ContentGridsec":"candidate-email_SetupPopup__ContentGridsec__rSTjI","mt25":"candidate-email_mt25__YJSiY","mt20":"candidate-email_mt20___Ce23","SetupPopup__ContentGridTech":"candidate-email_SetupPopup__ContentGridTech__qD14L","SetupPopup__Assesmentsection":"candidate-email_SetupPopup__Assesmentsection__vfGW_","SetupPopup__AssesmentsectionNew":"candidate-email_SetupPopup__AssesmentsectionNew__KOPcy","SetupPopup__MannualChips":"candidate-email_SetupPopup__MannualChips__crdP8","SetupPopup__ContentGridManuaCol":"candidate-email_SetupPopup__ContentGridManuaCol__eTKYK","SetupPopup__ContentGridManual":"candidate-email_SetupPopup__ContentGridManual__NUh0z","SetupPopup__ContentBlockPhone":"candidate-email_SetupPopup__ContentBlockPhone__V4MKg","SetupPopup__ContentAddInterview":"candidate-email_SetupPopup__ContentAddInterview__m1qq9","SetupPopup__ContentGridPhone":"candidate-email_SetupPopup__ContentGridPhone__EcIlJ","SetupPopup__ContentGridStatus":"candidate-email_SetupPopup__ContentGridStatus__2b2vN","SetupPopup__GridActions":"candidate-email_SetupPopup__GridActions__eh6B2","SetupPopup__GridActionCoral":"candidate-email_SetupPopup__GridActionCoral___BSym","SetupPopup__GridActionIndigo":"candidate-email_SetupPopup__GridActionIndigo__wFrKX","SetupPopup__ContentGrid":"candidate-email_SetupPopup__ContentGrid__BpsCK","SetupPopup__SubmitSectionSave":"candidate-email_SetupPopup__SubmitSectionSave__wM1S4","SetupPopup__SubmitSectionReset":"candidate-email_SetupPopup__SubmitSectionReset__FDZGL","SetupPopup__SubmitSectionAutomation":"candidate-email_SetupPopup__SubmitSectionAutomation__58PBP","SetupPopup__Duration":"candidate-email_SetupPopup__Duration__ZrzWM","SetupPopup__DeleteIcon":"candidate-email_SetupPopup__DeleteIcon__WbcKz","SetupPopup__ContentCustomisationManualInterview":"candidate-email_SetupPopup__ContentCustomisationManualInterview__q3cSe","mt0":"candidate-email_mt0__rK8nr","mtb25":"candidate-email_mtb25___s8Wj","mb15":"candidate-email_mb15__L_G1f","mb30":"candidate-email_mb30__ZM_L5","mt9":"candidate-email_mt9__VjXwv","lineheight0":"candidate-email_lineheight0__SSWGH","PopupHeightSection":"candidate-email_PopupHeightSection__CUVV1","AssessPopupHeightSection":"candidate-email_AssessPopupHeightSection__BYdz7","Statusopupheight":"candidate-email_Statusopupheight__fdcTB","buttonIn":"candidate-email_buttonIn__V7GE7","MessagePlaceholder":"candidate-email_MessagePlaceholder__UjZI7","m0":"candidate-email_m0__XfZNg","mt18":"candidate-email_mt18__MTRwz","DPgrid":"candidate-email_DPgrid__REDwt","addbtnposition":"candidate-email_addbtnposition__EH80W","mainformdiv":"candidate-email_mainformdiv__C5ZgL","crossflex":"candidate-email_crossflex__E6Toc","crossimgheight":"candidate-email_crossimgheight__Ulewi","crossimgheight48":"candidate-email_crossimgheight48__LE8vp","SetupModalPopup":"candidate-email_SetupModalPopup__uaX9S","SetupModalPopup__Dialog":"candidate-email_SetupModalPopup__Dialog__Th_TI","SetupPopupoverlay":"candidate-email_SetupPopupoverlay__Z4ZWn","NeedHelp":"candidate-email_NeedHelp__aURG8","uploadNewTest":"candidate-email_uploadNewTest__0Vlrg","SetupPopup__ol":"candidate-email_SetupPopup__ol__zvg_5","Threshold__Content":"candidate-email_Threshold__Content__zIZSs","CandidateEmail":"candidate-email_CandidateEmail__yCY52","CandidateEmail__Heading":"candidate-email_CandidateEmail__Heading__B9mFz","PurposeContainer":"candidate-email_PurposeContainer__J00Uz","OtpBacksection2":"candidate-email_OtpBacksection2__J_bKa"};

/***/ }),

/***/ 17664:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SidePanel__AddSection":"add-section_SidePanel__AddSection__mJuDU","About":"add-section_About__srLCN","Gallery":"add-section_Gallery__8GqU1","Benefit":"add-section_Benefit__2dN40","MeetTeam":"add-section_MeetTeam__Y_vJm","About__Title":"add-section_About__Title__oNml2","Gallery__Title":"add-section_Gallery__Title__xR4OI","Benefit__Title":"add-section_Benefit__Title__0oCS3","MeetTeam__Title":"add-section_MeetTeam__Title__DFw5B","About__FirstOption":"add-section_About__FirstOption__TfQvf","About__ThirdOption":"add-section_About__ThirdOption__QWdHm","Gallery__FirstOption":"add-section_Gallery__FirstOption__XGj2y","Gallery__ThirdOption":"add-section_Gallery__ThirdOption__h_7pA","Benefit__FirstOption":"add-section_Benefit__FirstOption__HRDYT","Benefit__ThirdOption":"add-section_Benefit__ThirdOption__3Kk55","MeetTeam__FirstOption":"add-section_MeetTeam__FirstOption__pgryQ","MeetTeam__ThirdOption":"add-section_MeetTeam__ThirdOption__5br7v","About__SecondOption":"add-section_About__SecondOption__XGp1C","Gallery__SecondOption":"add-section_Gallery__SecondOption__W0SJA","Benefit__SecondOption":"add-section_Benefit__SecondOption__rNwes","MeetTeam__SecondOption":"add-section_MeetTeam__SecondOption__FSiff","About__SecondOption__Para":"add-section_About__SecondOption__Para__mX9x_","Gallery__SecondOption__Para":"add-section_Gallery__SecondOption__Para__ITeAD","Benefit__SecondOption__Para":"add-section_Benefit__SecondOption__Para__fF3EC","MeetTeam__SecondOption__Para":"add-section_MeetTeam__SecondOption__Para__7PfZc","About__SecondOption__SubTitle":"add-section_About__SecondOption__SubTitle__mepfC","Gallery__SecondOption__SubTitle":"add-section_Gallery__SecondOption__SubTitle__XUQTZ","Benefit__SecondOption__SubTitle":"add-section_Benefit__SecondOption__SubTitle__fIsWY","MeetTeam__SecondOption__SubTitle":"add-section_MeetTeam__SecondOption__SubTitle__E3mtk","About__LeftContent":"add-section_About__LeftContent__orPio","Gallery__LeftContent":"add-section_Gallery__LeftContent__C_V2u","Benefit__LeftContent":"add-section_Benefit__LeftContent__sFmXI","MeetTeam__LeftContent":"add-section_MeetTeam__LeftContent__eMvmm","About__RightContent":"add-section_About__RightContent__Kuttb","Gallery__RightContent":"add-section_Gallery__RightContent__9snTl","Benefit__RightContent":"add-section_Benefit__RightContent__DVcdf","MeetTeam__RightContent":"add-section_MeetTeam__RightContent__SGQWH","About__Content":"add-section_About__Content__jJADd","Gallery__Content":"add-section_Gallery__Content__MtleE","Benefit__Content":"add-section_Benefit__Content__A66jC","MeetTeam__Content":"add-section_MeetTeam__Content__ugpUb","About__SubTitle":"add-section_About__SubTitle__3f2ZD","Gallery__SubTitle":"add-section_Gallery__SubTitle__8_XBo","Benefit__SubTitle":"add-section_Benefit__SubTitle__uXRjV","MeetTeam__SubTitle":"add-section_MeetTeam__SubTitle__2dUDy","About__Para":"add-section_About__Para__A9QDG","Gallery__Para":"add-section_Gallery__Para__eLfFv","Benefit__Para":"add-section_Benefit__Para__Z5Pmg","MeetTeam__Para":"add-section_MeetTeam__Para__E4eOR","About__Image":"add-section_About__Image__8pf2H","Gallery__Image":"add-section_Gallery__Image__3pZCH","Benefit__Image":"add-section_Benefit__Image__IhgSH","MeetTeam__Image":"add-section_MeetTeam__Image__jPTqJ","About__AddBtn":"add-section_About__AddBtn__INVA0","Gallery__AddBtn":"add-section_Gallery__AddBtn__Sl0om","Benefit__AddBtn":"add-section_Benefit__AddBtn__WNiBq","MeetTeam__AddBtn":"add-section_MeetTeam__AddBtn__j5FPh","About__Image__EditIcon":"add-section_About__Image__EditIcon__4Z5xX","Gallery__Image__EditIcon":"add-section_Gallery__Image__EditIcon__dcKBo","Benefit__Image__EditIcon":"add-section_Benefit__Image__EditIcon__Eoj_6","MeetTeam__Image__EditIcon":"add-section_MeetTeam__Image__EditIcon__izd_8","Gallery__Preview":"add-section_Gallery__Preview__sSO51","Benefit__AddTitleText":"add-section_Benefit__AddTitleText__AS4vv","Benefit__AddDescriptionText":"add-section_Benefit__AddDescriptionText__KRAs4","Benefit__Cards":"add-section_Benefit__Cards__0goLA","Benefit__Card":"add-section_Benefit__Card__U0FZE","Benefit__Card__Icon":"add-section_Benefit__Card__Icon__gdOtF","Benefit__Card__Title":"add-section_Benefit__Card__Title__UbVRe","Benefit__Card__Text":"add-section_Benefit__Card__Text__HPdDt","Benefit__ThirdOption__Cards":"add-section_Benefit__ThirdOption__Cards__DpLs4","Benefit__ThirdOption__Card":"add-section_Benefit__ThirdOption__Card__bI6wt","MeetTeam__Cards":"add-section_MeetTeam__Cards__0OGcb","MeetTeam__Card":"add-section_MeetTeam__Card__sfumP","MeetTeam__Card__SecondOption__Card":"add-section_MeetTeam__Card__SecondOption__Card__80x9h","MeetTeam__Card__Top":"add-section_MeetTeam__Card__Top__TEQCa","MeetTeam__Card__Text":"add-section_MeetTeam__Card__Text__eGimh","MeetTeam__Card__UserDetails":"add-section_MeetTeam__Card__UserDetails___ury9","MeetTeam__Card__Icon":"add-section_MeetTeam__Card__Icon__Ryu7P","MeetTeam__Card__SocialIcon":"add-section_MeetTeam__Card__SocialIcon__1ba1i","MeetTeam__Card__TextCenter":"add-section_MeetTeam__Card__TextCenter__m1Wg_","MeetTeam__Card__Bottom":"add-section_MeetTeam__Card__Bottom__PLC48","MeetTeam__Card__Bottom__Name":"add-section_MeetTeam__Card__Bottom__Name__cVnND","MeetTeam__Card__Bottom__Designation":"add-section_MeetTeam__Card__Bottom__Designation__cTtr_","MeetTeam__SecondOption__Card":"add-section_MeetTeam__SecondOption__Card__CYYzl","MeetTeam__MarginAuto":"add-section_MeetTeam__MarginAuto__Kpxxv","ReOrder":"add-section_ReOrder__kNvd_","ReOrder__DefaultOptionCard":"add-section_ReOrder__DefaultOptionCard__2RfQY","ReOrder__AboutOptionCard":"add-section_ReOrder__AboutOptionCard__Bsh3p","ReOrder__GalleryOptionCard":"add-section_ReOrder__GalleryOptionCard__ikg3K","ReOrder__BenefitOptionCard":"add-section_ReOrder__BenefitOptionCard__SVGqw","ReOrder__MeetOurTeamOptionCard":"add-section_ReOrder__MeetOurTeamOptionCard__EjhIC","ReOrder__JobOptionCard":"add-section_ReOrder__JobOptionCard__G_oCa","ReOrder__SubTitle":"add-section_ReOrder__SubTitle__Ir1iC","ReOrder__RemoveSection":"add-section_ReOrder__RemoveSection__qsB_L"};

/***/ }),

/***/ 37648:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CustomButtons":"button-style_CustomButtons__KqVoV","CustomButtons__Title":"button-style_CustomButtons__Title__Z6QYI","CustomButtons__Fields":"button-style_CustomButtons__Fields__lzn1O","CustomButtons__Fields__LeftContent":"button-style_CustomButtons__Fields__LeftContent__7ODjC","CustomButtons__Fields__RightContent":"button-style_CustomButtons__Fields__RightContent__xMLxQ","CustomButtons__Fields__OverlayBaseContainer":"button-style_CustomButtons__Fields__OverlayBaseContainer__4XikM","CustomButtons__Fields__Label":"button-style_CustomButtons__Fields__Label__fJzUd","CustomButtons__Fields__OverlayLabelContainer":"button-style_CustomButtons__Fields__OverlayLabelContainer__L1TVP","CustomButtons__Fields__Input":"button-style_CustomButtons__Fields__Input__dglin","CustomButtons__Fields__ColorInput":"button-style_CustomButtons__Fields__ColorInput__DGaSq","CustomButtons__Fields100":"button-style_CustomButtons__Fields100__d3V7c","CareerSelect":"button-style_CareerSelect__6wD0S","CustomButtons__Input":"button-style_CustomButtons__Input__iaXlQ","CustomButtons__Add_More_Link":"button-style_CustomButtons__Add_More_Link__jqh4g","CustomButtons__Add_More_Link__Icon":"button-style_CustomButtons__Add_More_Link__Icon__wjTmV","CustomButtons__Add_More_Link__Text":"button-style_CustomButtons__Add_More_Link__Text__Julzl","CustomButtons__ButtonPreview":"button-style_CustomButtons__ButtonPreview__o4wi4","CustomButtons__RightButtonContent":"button-style_CustomButtons__RightButtonContent__2obj_","CustomButtons__VisibiltyHidden":"button-style_CustomButtons__VisibiltyHidden__ZV4g_","CustomButtons__Select":"button-style_CustomButtons__Select__2c104","customSelect__control":"button-style_customSelect__control__vsM7N","CustomButtons__CheckboxInput":"button-style_CustomButtons__CheckboxInput__6AJ44","CustomButtons__DFlex":"button-style_CustomButtons__DFlex__aw4B6","CustomColourStyle":"button-style_CustomColourStyle__JVJJi","CustomButtonStyle":"button-style_CustomButtonStyle__iHaoL","OverlayGuideDesign":"button-style_OverlayGuideDesign__MSHuc"};

/***/ }),

/***/ 83971:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Footer":"footer_Footer__sny2a","Footer__SocialIcons":"footer_Footer__SocialIcons__WuC0v","Footer__SocialIcons__EditIcon":"footer_Footer__SocialIcons__EditIcon__vMadX","Footer__SocialIconsCenter":"footer_Footer__SocialIconsCenter__emSsL","Footer__SocialIconsRight":"footer_Footer__SocialIconsRight__bnpqr","Footer__Links":"footer_Footer__Links__am9tz","Footer__LinksCenter":"footer_Footer__LinksCenter__4dSsG","Footer__Right":"footer_Footer__Right__BQnMw","Footer__Links__Li":"footer_Footer__Links__Li__pSIxO","Footer__Disclaimer":"footer_Footer__Disclaimer__QZ7i0","Footer___SocialIcons":"footer_Footer___SocialIcons__l1SRi"};

/***/ }),

/***/ 54484:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CareerHeader":"header_CareerHeader__5euPW","CareerHeader__DFlex":"header_CareerHeader__DFlex__ut4Cx","CareerHeader__BarsIcon":"header_CareerHeader__BarsIcon__jJBnH","CareerHeader__Logo":"header_CareerHeader__Logo__Vy2tE","CareerHeader__Logo__EditIcon":"header_CareerHeader__Logo__EditIcon__QmkwO","CareerHeader__Links":"header_CareerHeader__Links__k5Q_T","CareerHeader__Links__Li":"header_CareerHeader__Links__Li__r_UNg","NarrowBanner":"header_NarrowBanner__xCJTj","CareerMainHeader":"header_CareerMainHeader__kBhKG"};

/***/ }),

/***/ 43747:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Hero__BackgroundImage":"hero-section_Hero__BackgroundImage__dMTwe","Hero__SettingsIcon":"hero-section_Hero__SettingsIcon__Qg5tS","Hero__EditHeroTitle":"hero-section_Hero__EditHeroTitle__Yg1wX","Hero__EditHeroTitle__Contenteditable":"hero-section_Hero__EditHeroTitle__Contenteditable__BmiyU","Hero__PreviewHeroTitle":"hero-section_Hero__PreviewHeroTitle__QN_D4","Hero__TwoButtons":"hero-section_Hero__TwoButtons__B7_i3","Hero__LeftButton":"hero-section_Hero__LeftButton__yFPck","Hero__LeftButton__ButtonIconsHide":"hero-section_Hero__LeftButton__ButtonIconsHide__5lPTM","Hero__RightButton":"hero-section_Hero__RightButton__9tawd","Hero__RightButton__ButtonIconsHide":"hero-section_Hero__RightButton__ButtonIconsHide__tX37V","Hero__ButtonStyle":"hero-section_Hero__ButtonStyle__AHrbX","Hero__EditButton":"hero-section_Hero__EditButton__XcsHZ","Hero__EditBannerIcon":"hero-section_Hero__EditBannerIcon__LD8L5","Overlayhero":"hero-section_Overlayhero__1AcPF"};

/***/ }),

/***/ 98901:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SetupPopup__ModalCenter":"modal_SetupPopup__ModalCenter__s7pwn","SetupPopup__Content":"modal_SetupPopup__Content__tvhyn","SetupPopup__ModalContent":"modal_SetupPopup__ModalContent__2Rqpr","OtpBacksection":"modal_OtpBacksection__vdcrC","Otpback":"modal_Otpback__Jtdlz","SelectJob__Content":"modal_SelectJob__Content__yOnwB","SelectJob__Footer":"modal_SelectJob__Footer__aLMZK","SelectJob__ButtonAction":"modal_SelectJob__ButtonAction__ie0cE","ButtonCustomization__Content":"modal_ButtonCustomization__Content__2y8hR","ButtonCustomization__RadioButtons":"modal_ButtonCustomization__RadioButtons__XHevb","ButtonCustomization__Footer":"modal_ButtonCustomization__Footer__TTN_O","ButtonCustomization__Footer__ButtonAction":"modal_ButtonCustomization__Footer__ButtonAction__s5KSU","ButtonCustomization__CustomSelectWidth":"modal_ButtonCustomization__CustomSelectWidth__ID4sO"};

/***/ }),

/***/ 63417:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"HeaderLinks":"navigation-section_HeaderLinks__sWZGC","FooterLinks":"navigation-section_FooterLinks__YTiWJ","SocialLinks":"navigation-section_SocialLinks__Sq9xH","HeaderLinks__Title":"navigation-section_HeaderLinks__Title__QTpz6","FooterLinks__Title":"navigation-section_FooterLinks__Title__mqrkG","SocialLinks__Title":"navigation-section_SocialLinks__Title__jKVn_","HeaderLinks__Fields":"navigation-section_HeaderLinks__Fields__1ktL_","FooterLinks__Fields":"navigation-section_FooterLinks__Fields__Zuc2p","SocialLinks__Fields":"navigation-section_SocialLinks__Fields__v7mqH","HeaderLinks__Fields__Remove_Fields":"navigation-section_HeaderLinks__Fields__Remove_Fields__METX9","FooterLinks__Fields__Remove_Fields":"navigation-section_FooterLinks__Fields__Remove_Fields__g1ZNn","SocialLinks__Fields__Remove_Fields":"navigation-section_SocialLinks__Fields__Remove_Fields__Os7L5","HeaderLinks__Fields__LeftContent":"navigation-section_HeaderLinks__Fields__LeftContent__G_bQ8","HeaderLinks__Fields__RightContent":"navigation-section_HeaderLinks__Fields__RightContent__Ncz7Z","FooterLinks__Fields__LeftContent":"navigation-section_FooterLinks__Fields__LeftContent__Xh7Q1","FooterLinks__Fields__RightContent":"navigation-section_FooterLinks__Fields__RightContent__a6skv","SocialLinks__Fields__LeftContent":"navigation-section_SocialLinks__Fields__LeftContent__JJRgn","SocialLinks__Fields__RightContent":"navigation-section_SocialLinks__Fields__RightContent__Zq3ca","HeaderLinks__Fields__Label":"navigation-section_HeaderLinks__Fields__Label__DS_OA","FooterLinks__Fields__Label":"navigation-section_FooterLinks__Fields__Label__jjDhQ","SocialLinks__Fields__Label":"navigation-section_SocialLinks__Fields__Label__A4bdo","HeaderLinks__Fields__Input":"navigation-section_HeaderLinks__Fields__Input__K3oqQ","FooterLinks__Fields__Input":"navigation-section_FooterLinks__Fields__Input__MvZYX","SocialLinks__Fields__Input":"navigation-section_SocialLinks__Fields__Input__6Bvs8","HeaderLinks__Input":"navigation-section_HeaderLinks__Input___BTvd","FooterLinks__Input":"navigation-section_FooterLinks__Input__stz55","SocialLinks__Input":"navigation-section_SocialLinks__Input__cFY2_","HeaderLinks__Add_More_Link":"navigation-section_HeaderLinks__Add_More_Link__qfcW2","FooterLinks__Add_More_Link":"navigation-section_FooterLinks__Add_More_Link__8XL97","SocialLinks__Add_More_Link":"navigation-section_SocialLinks__Add_More_Link__3R2mQ","HeaderLinks__Add_More_Link__Icon":"navigation-section_HeaderLinks__Add_More_Link__Icon__qpQkb","FooterLinks__Add_More_Link__Icon":"navigation-section_FooterLinks__Add_More_Link__Icon__CBLCh","SocialLinks__Add_More_Link__Icon":"navigation-section_SocialLinks__Add_More_Link__Icon__Icm_G","HeaderLinks__Add_More_Link__Text":"navigation-section_HeaderLinks__Add_More_Link__Text__9yv_h","FooterLinks__Add_More_Link__Text":"navigation-section_FooterLinks__Add_More_Link__Text__vk5Fu","SocialLinks__Add_More_Link__Text":"navigation-section_SocialLinks__Add_More_Link__Text__6HXIu"};

/***/ }),

/***/ 2093:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Jobs":"open-jobs_Jobs___l6MF","Jobs__Title":"open-jobs_Jobs__Title__ZsgML","Jobs__Container":"open-jobs_Jobs__Container__Y6l_u","Jobs__JobFilter":"open-jobs_Jobs__JobFilter__5tNnW","Jobs__SearchInput":"open-jobs_Jobs__SearchInput__6rPyF","Jobs__SearchInput__InputField":"open-jobs_Jobs__SearchInput__InputField__ORATu","Jobs__SearchInput__Input":"open-jobs_Jobs__SearchInput__Input__qa7Ly","Jobs__Searchbtn":"open-jobs_Jobs__Searchbtn__mTy6K","Jobs__Select":"open-jobs_Jobs__Select__XVrBW","Jobs__CustomSelect":"open-jobs_Jobs__CustomSelect__VuBfP","Jobs__JobType":"open-jobs_Jobs__JobType__FlLqy","Jobs__Location":"open-jobs_Jobs__Location__UNucR","Jobs__Remote":"open-jobs_Jobs__Remote__a1Nbh","Jobs__SearchInputWidth":"open-jobs_Jobs__SearchInputWidth__8ap1M","Jobs__Width100":"open-jobs_Jobs__Width100__r_pau","Jobs__Listing":"open-jobs_Jobs__Listing__bDyeO","Jobs__Listing__Listing":"open-jobs_Jobs__Listing__Listing__RjZ7Q","Jobs__ListingBox":"open-jobs_Jobs__ListingBox__FNkk9","Jobs__PostDay":"open-jobs_Jobs__PostDay__PhAS3","Jobs__SubTitle":"open-jobs_Jobs__SubTitle__wDpBa","Jobs__PostedLocation":"open-jobs_Jobs__PostedLocation__GF4cR","Jobs__ContractType":"open-jobs_Jobs__ContractType__zzqYH","Jobs__ViewAllJobs":"open-jobs_Jobs__ViewAllJobs__3IWDN","Jobs__NoOpenJobs":"open-jobs_Jobs__NoOpenJobs__WUohK","Jobs__AccordionInMobile":"open-jobs_Jobs__AccordionInMobile__YelJh","Jobs__HideInMobile":"open-jobs_Jobs__HideInMobile__z_7PQ","accordion":"open-jobs_accordion__f0dSr","OpenJobs":"open-jobs_OpenJobs__taLEA","accordion__panel":"open-jobs_accordion__panel__uyQqW"};

/***/ }),

/***/ 14117:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SidePanel":"side-panel_SidePanel__TLbvb","SidePanel__Padding18":"side-panel_SidePanel__Padding18__jXkNL","SidePanel__DFlex":"side-panel_SidePanel__DFlex__rl_hH","SidePanel__CloseBtn":"side-panel_SidePanel__CloseBtn__P2hiY","SidePanel__PreviewPublishBtns":"side-panel_SidePanel__PreviewPublishBtns__mnrIS","SidePanel__PreviewPublishBtns__Publish":"side-panel_SidePanel__PreviewPublishBtns__Publish__JWkmV","SidePanel__PreviewPublishBtns__Preview":"side-panel_SidePanel__PreviewPublishBtns__Preview__S4Fyg","SidePanel__PreviewPublishBtns__Reset":"side-panel_SidePanel__PreviewPublishBtns__Reset__tzAk8","SidePanel__PublishBtn":"side-panel_SidePanel__PublishBtn__ZyNNf","SidePanel__PublishBtnText":"side-panel_SidePanel__PublishBtnText__IUZiW","SidePanel__AddSection":"side-panel_SidePanel__AddSection__N72_6","About":"side-panel_About__nIj2e","About__Title":"side-panel_About__Title__tY7Sn","About__FirstOption":"side-panel_About__FirstOption__uS_CN","About__SecondOption":"side-panel_About__SecondOption__KaYFE","About__SecondOption__Para":"side-panel_About__SecondOption__Para__rIDbm","About__SecondOption__SubTitle":"side-panel_About__SecondOption__SubTitle__BPYQ9","About__LeftContent":"side-panel_About__LeftContent__evPO4","About__RightContent":"side-panel_About__RightContent__7asfM","About__Content":"side-panel_About__Content__hW7XV","About__SubTitle":"side-panel_About__SubTitle__ZgGpw","About__Para":"side-panel_About__Para__gHjFz","About__Image":"side-panel_About__Image__zH7Mi","About__AddBtn":"side-panel_About__AddBtn__v7O8T"};

/***/ }),

/***/ 9648:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Modalpopup":"checkbox-filter-modal_Modalpopup__Rfhe1","Modalpopup__inner":"checkbox-filter-modal_Modalpopup__inner__V6xAB","Modalpopup__Dialog":"checkbox-filter-modal_Modalpopup__Dialog__SPd0j","transition":"checkbox-filter-modal_transition__6r_R0","Modalpopup__CloseCenter":"checkbox-filter-modal_Modalpopup__CloseCenter__vvAE8","Modalpopup__Content":"checkbox-filter-modal_Modalpopup__Content__0Mdyl","Modalpopup__btn":"checkbox-filter-modal_Modalpopup__btn__FR60G","mar":"checkbox-filter-modal_mar__PZkKe","Otpback":"checkbox-filter-modal_Otpback__ICLyw","Form":"checkbox-filter-modal_Form__nwUdK","Form__width":"checkbox-filter-modal_Form__width__Y_scP","Form__label":"checkbox-filter-modal_Form__label__m_rzF","Form__textleft":"checkbox-filter-modal_Form__textleft__CkHq2","Form__InputFullWidth":"checkbox-filter-modal_Form__InputFullWidth__Dwdnu","Form__Input":"checkbox-filter-modal_Form__Input__GuZR7","Form__Input398":"checkbox-filter-modal_Form__Input398__6z5bD","Form__InputSection":"checkbox-filter-modal_Form__InputSection__kZ64f","Form__ScoreCardInput":"checkbox-filter-modal_Form__ScoreCardInput__Vv5G0","Form__Textarea":"checkbox-filter-modal_Form__Textarea__0nNW_","primarybtn":"checkbox-filter-modal_primarybtn__3_mKL","GoBtn":"checkbox-filter-modal_GoBtn__7OYk6","secondarybtn":"checkbox-filter-modal_secondarybtn__48F5j","iconFilled":"checkbox-filter-modal_iconFilled__jw3pE","iconFilledSolid":"checkbox-filter-modal_iconFilledSolid__nTGUA","primarybtnborder":"checkbox-filter-modal_primarybtnborder__ixbLL","secondarybtnborder":"checkbox-filter-modal_secondarybtnborder__aNx_M","ClearBtn":"checkbox-filter-modal_ClearBtn__ZDpBK","tertiarybtn":"checkbox-filter-modal_tertiarybtn___vui9","graybtnborder":"checkbox-filter-modal_graybtnborder__XsJ9F","jobsrchbtn":"checkbox-filter-modal_jobsrchbtn__NKRCc","jobsrchbtnalign":"checkbox-filter-modal_jobsrchbtnalign__TCS3w","nobgbutton":"checkbox-filter-modal_nobgbutton__LneEX","iconTextButton":"checkbox-filter-modal_iconTextButton__jjOb1","cursornone":"checkbox-filter-modal_cursornone__1UMCv","nobgbuttonprimary":"checkbox-filter-modal_nobgbuttonprimary__y1Ygx","mt15":"checkbox-filter-modal_mt15__0UGmA","btn350":"checkbox-filter-modal_btn350__LqW_A","GrayBgBtn":"checkbox-filter-modal_GrayBgBtn__CdRas","NewShareBtn":"checkbox-filter-modal_NewShareBtn__tym7p","CoralBgBtn":"checkbox-filter-modal_CoralBgBtn__ctDSJ","DropContainer":"checkbox-filter-modal_DropContainer__2RiZc","DropContainer__Inner":"checkbox-filter-modal_DropContainer__Inner__RFBwu","CompanyProfile__Inner":"checkbox-filter-modal_CompanyProfile__Inner__MY8nc","DropContainer__Message":"checkbox-filter-modal_DropContainer__Message__YzsfA","CompanyProfile__Message":"checkbox-filter-modal_CompanyProfile__Message__WFDr2","CompanyProfile__MessageContent":"checkbox-filter-modal_CompanyProfile__MessageContent__G_KnK","DropContainer__UploadIcon":"checkbox-filter-modal_DropContainer__UploadIcon__Ce9_c","CompanyProfile__UploadIcon":"checkbox-filter-modal_CompanyProfile__UploadIcon__7dMZX","FileDisplayContainer":"checkbox-filter-modal_FileDisplayContainer__aisGw","FileDisplayContainer__Status":"checkbox-filter-modal_FileDisplayContainer__Status__vT5Iw","FileDisplayContainer__Type":"checkbox-filter-modal_FileDisplayContainer__Type__oAHAQ","FileDisplayContainer__Name":"checkbox-filter-modal_FileDisplayContainer__Name__Fe5Fb","FileDisplayContainer__Error":"checkbox-filter-modal_FileDisplayContainer__Error__L04k6","FileDisplayContainer__Close":"checkbox-filter-modal_FileDisplayContainer__Close__nXVBM","Browse":"checkbox-filter-modal_Browse__WVemr","ClientCompany":"checkbox-filter-modal_ClientCompany__F6d_i","NewJob":"checkbox-filter-modal_NewJob__1PQ_U","ClientCompany__TopSection2":"checkbox-filter-modal_ClientCompany__TopSection2__eHA6r","ClientCompany__Filter":"checkbox-filter-modal_ClientCompany__Filter__xNz8a","ClientCompany__Input_MatchScore":"checkbox-filter-modal_ClientCompany__Input_MatchScore___c_5o","ClientCompany__Percentage_Symbol":"checkbox-filter-modal_ClientCompany__Percentage_Symbol__Mu1uU","ClientCompany__Filterheading":"checkbox-filter-modal_ClientCompany__Filterheading__mCmF_","ClientCompany__FloatButtonAdd":"checkbox-filter-modal_ClientCompany__FloatButtonAdd__wKccQ","ClientCompany__FloatButtonAdd__AgencyUserIcon":"checkbox-filter-modal_ClientCompany__FloatButtonAdd__AgencyUserIcon___12_o","ClientCompany__LastEdited":"checkbox-filter-modal_ClientCompany__LastEdited__xO1pq","ClientCompany__BackSection":"checkbox-filter-modal_ClientCompany__BackSection__vgN3I","AddUsers__BackSection":"checkbox-filter-modal_AddUsers__BackSection__JdwoG","ClientCompany__BackSection__CloseIcon":"checkbox-filter-modal_ClientCompany__BackSection__CloseIcon__ol772","ClientCompany__Container":"checkbox-filter-modal_ClientCompany__Container__MA_jp","NewJob__InterviewContainer":"checkbox-filter-modal_NewJob__InterviewContainer__PmjT_","AddUsers__Container":"checkbox-filter-modal_AddUsers__Container___o2Zj","ClientCompany__FormInputSection":"checkbox-filter-modal_ClientCompany__FormInputSection__OMAh5","CompanyProfile__FormInputSection":"checkbox-filter-modal_CompanyProfile__FormInputSection__AhWZL","ClientCompany__Heading":"checkbox-filter-modal_ClientCompany__Heading__1Y_wc","AddUsers__Heading":"checkbox-filter-modal_AddUsers__Heading__2lFDo","ClientCompany__StatusAlignment":"checkbox-filter-modal_ClientCompany__StatusAlignment__R13tX","ClientCompany__Status":"checkbox-filter-modal_ClientCompany__Status__FMTqC","ClientCompany__ActiveDot":"checkbox-filter-modal_ClientCompany__ActiveDot__Ck_od","ClientCompany__CloseDot":"checkbox-filter-modal_ClientCompany__CloseDot__7quzt","ClientCompany__Company":"checkbox-filter-modal_ClientCompany__Company__B9m7A","AddUsers__User":"checkbox-filter-modal_AddUsers__User__eEwyX","ClientCompany__Systemrefheding":"checkbox-filter-modal_ClientCompany__Systemrefheding__wAObL","ClientCompany__Subheading":"checkbox-filter-modal_ClientCompany__Subheading__TcaYT","CompanyProfile__Subheading":"checkbox-filter-modal_CompanyProfile__Subheading__1Kf43","ClientCompany__Subheading2":"checkbox-filter-modal_ClientCompany__Subheading2__6GtVi","ClientCompany__Description":"checkbox-filter-modal_ClientCompany__Description__KKqKa","ClientCompany__SubmitSection":"checkbox-filter-modal_ClientCompany__SubmitSection__1aLYc","NewJob__SubmitSection":"checkbox-filter-modal_NewJob__SubmitSection__o68A4","NewJob__SubmitSectionThreeBtn":"checkbox-filter-modal_NewJob__SubmitSectionThreeBtn__B1UH7","NewJob__SubmitSectionOneBtnPlacement":"checkbox-filter-modal_NewJob__SubmitSectionOneBtnPlacement__Zy3IN","NewJob__ImportSection":"checkbox-filter-modal_NewJob__ImportSection__1G4K5","AddUsers__SubmitSection":"checkbox-filter-modal_AddUsers__SubmitSection__QUD9g","ClientCompany__IntegrationImage":"checkbox-filter-modal_ClientCompany__IntegrationImage___rJPk","ClientCompany__QuickAdd":"checkbox-filter-modal_ClientCompany__QuickAdd__gPMjn","NewJob__QuickAdd":"checkbox-filter-modal_NewJob__QuickAdd__j7Kaw","ClientCompany__BodyText":"checkbox-filter-modal_ClientCompany__BodyText__AYYQZ","Form__TableRow":"checkbox-filter-modal_Form__TableRow__QGFLr","ModalFilter__Form__TableRow":"checkbox-filter-modal_ModalFilter__Form__TableRow__sjxXE","ModalFilter__Form__TableRowBlock":"checkbox-filter-modal_ModalFilter__Form__TableRowBlock__UKcB7","Form__Label":"checkbox-filter-modal_Form__Label__btZSB","ModalFilter__Form__LabelCheck":"checkbox-filter-modal_ModalFilter__Form__LabelCheck__NBl0A","Form__FloatingLabel":"checkbox-filter-modal_Form__FloatingLabel__SQrU6","Form__TableCol":"checkbox-filter-modal_Form__TableCol__f8Kq2","ModalFilter__Form__TableCol":"checkbox-filter-modal_ModalFilter__Form__TableCol__2TULc","Form__currency_symbol":"checkbox-filter-modal_Form__currency_symbol__MQGnR","Form__CustomSelect":"checkbox-filter-modal_Form__CustomSelect__1fVSj","Form__currency_symbol__right":"checkbox-filter-modal_Form__currency_symbol__right__0hMvW","Form__TableCol__Disabled":"checkbox-filter-modal_Form__TableCol__Disabled__3BiK8","Form__TextareaDisabled":"checkbox-filter-modal_Form__TextareaDisabled__8Vfqg","Form__EditorDisabled":"checkbox-filter-modal_Form__EditorDisabled__URKM1","Form__AdminCheckLabel":"checkbox-filter-modal_Form__AdminCheckLabel__IOIp7","Form__AdminCheckMargin":"checkbox-filter-modal_Form__AdminCheckMargin__7RDQX","CompanyProfile__BrandingGuide":"checkbox-filter-modal_CompanyProfile__BrandingGuide__l_PZs","CompanyProfile__DropBoxContainer":"checkbox-filter-modal_CompanyProfile__DropBoxContainer__gNRel","CompanyProfile__Browse":"checkbox-filter-modal_CompanyProfile__Browse__9SwQZ","ErrorLabel":"checkbox-filter-modal_ErrorLabel__cLmet","Height80":"checkbox-filter-modal_Height80__kNTd_","Browse__ButtonFlexEnd":"checkbox-filter-modal_Browse__ButtonFlexEnd__g47WJ","AddAgency__Container":"checkbox-filter-modal_AddAgency__Container__Mydi7","AddAgency__FormInputSection":"checkbox-filter-modal_AddAgency__FormInputSection__qwVIt","AddAgency__FormInputSection__Label":"checkbox-filter-modal_AddAgency__FormInputSection__Label__AtDkc","AddAgency__Form":"checkbox-filter-modal_AddAgency__Form__zw3g_","LinkAsButtons":"checkbox-filter-modal_LinkAsButtons__eNRKH","SearchFlex":"checkbox-filter-modal_SearchFlex__Oh6Me","Form__ErrorCustomSelect":"checkbox-filter-modal_Form__ErrorCustomSelect__CRDkT","Form__select_currency":"checkbox-filter-modal_Form__select_currency__PgUBM","customSelect__placeholder":"checkbox-filter-modal_customSelect__placeholder__SLlCD","Career":"checkbox-filter-modal_Career__S2Ht9","Career__Background_Edit":"checkbox-filter-modal_Career__Background_Edit__fxvGh","Career__Background_Edit_Image":"checkbox-filter-modal_Career__Background_Edit_Image__1gPuJ","Career__Container":"checkbox-filter-modal_Career__Container__6Ktjj","Career__Inner":"checkbox-filter-modal_Career__Inner__l973E","Career__logo":"checkbox-filter-modal_Career__logo__92vxB","Career__Content":"checkbox-filter-modal_Career__Content__Vlhit","Career__ButtonSection":"checkbox-filter-modal_Career__ButtonSection__RCbxA","Job":"checkbox-filter-modal_Job___QHcg","Job__Inner":"checkbox-filter-modal_Job__Inner__ykKHJ","Job__Container":"checkbox-filter-modal_Job__Container__y9UBJ","Job__Heading":"checkbox-filter-modal_Job__Heading__YID_M","Job__Company":"checkbox-filter-modal_Job__Company__PnYXj","Job__SearchContainer":"checkbox-filter-modal_Job__SearchContainer__0hYcv","Job__SearchInput":"checkbox-filter-modal_Job__SearchInput__TD0Nh","Job__Searchbtn":"checkbox-filter-modal_Job__Searchbtn__NeEbO","Job__Input":"checkbox-filter-modal_Job__Input__MGZQP","Job__SelectJob":"checkbox-filter-modal_Job__SelectJob__0Hi7C","Job__RemoteLabel":"checkbox-filter-modal_Job__RemoteLabel__ADgG5","Job__Display":"checkbox-filter-modal_Job__Display__USGtJ","Job__PostDay":"checkbox-filter-modal_Job__PostDay__X_BVe","Job__Title":"checkbox-filter-modal_Job__Title__LGoQZ","Job__Location":"checkbox-filter-modal_Job__Location__rAk3j","DT":"checkbox-filter-modal_DT__d5SaR","DisplayTable":"checkbox-filter-modal_DisplayTable__ahRLt","pd11":"checkbox-filter-modal_pd11__uZh0D","Label":"checkbox-filter-modal_Label___Y340","inputwidth":"checkbox-filter-modal_inputwidth___I_KY","mr24":"checkbox-filter-modal_mr24__nD_BQ","fullwidth":"checkbox-filter-modal_fullwidth__cGkNC","padt40":"checkbox-filter-modal_padt40__bdopO","Form__TableRowflex":"checkbox-filter-modal_Form__TableRowflex__V_Upz","Form__TableColm":"checkbox-filter-modal_Form__TableColm__5btFD","Form__LabelCheck":"checkbox-filter-modal_Form__LabelCheck__umEfG","Form__Error":"checkbox-filter-modal_Form__Error__w6Cs_","Form__ErrorSection":"checkbox-filter-modal_Form__ErrorSection__yxQhJ","Form__MessagePlaceholder":"checkbox-filter-modal_Form__MessagePlaceholder__DyaCk","Form__Submit":"checkbox-filter-modal_Form__Submit__ascsM","Form__NormalLabel":"checkbox-filter-modal_Form__NormalLabel___M14q","AddInterview":"checkbox-filter-modal_AddInterview__VkQKh","IntegrationPage":"checkbox-filter-modal_IntegrationPage__3tDir","Integration__BackStep":"checkbox-filter-modal_Integration__BackStep__5wimo","AddUsers__BackStep":"checkbox-filter-modal_AddUsers__BackStep__iv1ew","Integration__SubmitSection":"checkbox-filter-modal_Integration__SubmitSection__3tK_Q","IntegrationTable":"checkbox-filter-modal_IntegrationTable__S4_I_","IntegrationTable__LimitInput":"checkbox-filter-modal_IntegrationTable__LimitInput__sumac","IntegrationTable__Type":"checkbox-filter-modal_IntegrationTable__Type__LMHt1","IntegrationTable__AllJobsToggle":"checkbox-filter-modal_IntegrationTable__AllJobsToggle__iaEL0","IntegrationTable__switch":"checkbox-filter-modal_IntegrationTable__switch__Sbe1h","IntegrationTable__switchText":"checkbox-filter-modal_IntegrationTable__switchText__bl0U5","IntegrationTable__slider":"checkbox-filter-modal_IntegrationTable__slider__tdJu3","IntegrationTable__round":"checkbox-filter-modal_IntegrationTable__round__MGpuW","IntegrationTable__Action":"checkbox-filter-modal_IntegrationTable__Action__mXfaC","IntegrationView":"checkbox-filter-modal_IntegrationView___Fp1D","IntegrationView__Title":"checkbox-filter-modal_IntegrationView__Title__7Muq7","IntegrationView__Subheading":"checkbox-filter-modal_IntegrationView__Subheading__lSW0b","IntegrationView__BoxImage":"checkbox-filter-modal_IntegrationView__BoxImage__Q10fo","IntegrationView__Box":"checkbox-filter-modal_IntegrationView__Box__g_4PU","IntegrationView__BoxImage__InfoIcon":"checkbox-filter-modal_IntegrationView__BoxImage__InfoIcon__aSIjn","IntegrationView__ViewMoreButton":"checkbox-filter-modal_IntegrationView__ViewMoreButton__eYjZR","IntegrationView__ConnectButton":"checkbox-filter-modal_IntegrationView__ConnectButton__2vP0X","IntegrationView__GoogleButton":"checkbox-filter-modal_IntegrationView__GoogleButton__CUmQS","IntegrationView__FlexFlow":"checkbox-filter-modal_IntegrationView__FlexFlow__qBkHe","IntegrationView__BoxWidth":"checkbox-filter-modal_IntegrationView__BoxWidth__MR_J9","SkipFinishButton":"checkbox-filter-modal_SkipFinishButton__YbKQb","AddUsers":"checkbox-filter-modal_AddUsers__K2Vwn","AddUsers__ButtonSection":"checkbox-filter-modal_AddUsers__ButtonSection__eLJIm","AddUsers__QuickStepHeading":"checkbox-filter-modal_AddUsers__QuickStepHeading___EJEE","AddUsers__DeleteSection":"checkbox-filter-modal_AddUsers__DeleteSection__k7diT","AddUsers__DeleteCrossHeight":"checkbox-filter-modal_AddUsers__DeleteCrossHeight__dwVej","AddUsers__Form__Input":"checkbox-filter-modal_AddUsers__Form__Input__6qaHR","AddUsers__FormHeadingSection":"checkbox-filter-modal_AddUsers__FormHeadingSection__OGJjA","AddUsers__FormSection":"checkbox-filter-modal_AddUsers__FormSection__WRj2U","NewJob__FormSection":"checkbox-filter-modal_NewJob__FormSection__4_jyU","AddUsers__ButtonsActionSection":"checkbox-filter-modal_AddUsers__ButtonsActionSection__gZgab","AddUsers__ImportUsers":"checkbox-filter-modal_AddUsers__ImportUsers__YUmE7","AddUsers__NameInput":"checkbox-filter-modal_AddUsers__NameInput__2TEO2","AddUsers__EmailInput":"checkbox-filter-modal_AddUsers__EmailInput__6Txli","AddUsers__RoleInput":"checkbox-filter-modal_AddUsers__RoleInput__bgtql","AddUsers__Subheading":"checkbox-filter-modal_AddUsers__Subheading___zw_P","AddUsers__visible":"checkbox-filter-modal_AddUsers__visible__79xB7","Tagrow":"checkbox-filter-modal_Tagrow__vftKH","Tagrow__Tags":"checkbox-filter-modal_Tagrow__Tags__vwisj","Tagrow__Cancel":"checkbox-filter-modal_Tagrow__Cancel__NlFiu","SendInviteSection":"checkbox-filter-modal_SendInviteSection__rYTx1","error":"checkbox-filter-modal_error__GJKjT","ViewJobPage__Input":"checkbox-filter-modal_ViewJobPage__Input__35ANa","Form__Input2":"checkbox-filter-modal_Form__Input2__msbbJ","ViewJobPage__PostDay":"checkbox-filter-modal_ViewJobPage__PostDay__gaJSS","ViewJobPage__Title":"checkbox-filter-modal_ViewJobPage__Title__HHh04","ViewJobPage__DescriptionTitle":"checkbox-filter-modal_ViewJobPage__DescriptionTitle__Q5jjU","ViewJobPage__Location":"checkbox-filter-modal_ViewJobPage__Location__WAIJZ","ViewJobPage__primarybtn":"checkbox-filter-modal_ViewJobPage__primarybtn__rpG3Q","ViewJobPage__secondarybtn":"checkbox-filter-modal_ViewJobPage__secondarybtn__hjQrJ","ViewJobPage__secondarybtnborder":"checkbox-filter-modal_ViewJobPage__secondarybtnborder__Tdm7m","ViewJobPage__BackSection":"checkbox-filter-modal_ViewJobPage__BackSection__4mC4F","ViewJobPage__Content":"checkbox-filter-modal_ViewJobPage__Content__Q_ZaE","ViewJobPage":"checkbox-filter-modal_ViewJobPage__6LKY7","ViewJobPage__Header":"checkbox-filter-modal_ViewJobPage__Header__B9Rko","ViewJobPage__Application":"checkbox-filter-modal_ViewJobPage__Application___5378","ViewJobPage__RecordVideo":"checkbox-filter-modal_ViewJobPage__RecordVideo__B9hPT","ViewJobPage__RecordVideoSuccessText":"checkbox-filter-modal_ViewJobPage__RecordVideoSuccessText__osVYz","ViewJobPage__subheading":"checkbox-filter-modal_ViewJobPage__subheading__gMkeY","ViewJobPage__confirmation":"checkbox-filter-modal_ViewJobPage__confirmation___RXTR","ViewJobPage__Logo":"checkbox-filter-modal_ViewJobPage__Logo__iEDbt","ViewJobPage__BrandLogo":"checkbox-filter-modal_ViewJobPage__BrandLogo__OxujK","ViewJobPage__BrandLogo__Padding10":"checkbox-filter-modal_ViewJobPage__BrandLogo__Padding10__6k_yt","ViewJobPage__Container":"checkbox-filter-modal_ViewJobPage__Container__3Ew2D","ViewJobPage__JobContent":"checkbox-filter-modal_ViewJobPage__JobContent__WMYh1","ViewJobPage__Sidebar":"checkbox-filter-modal_ViewJobPage__Sidebar__XiOB5","ViewJobPage__Sidebar2":"checkbox-filter-modal_ViewJobPage__Sidebar2__mSk6w","ViewJobPage__Description":"checkbox-filter-modal_ViewJobPage__Description__pyzNA","ViewJobPage__DescriptionWidth":"checkbox-filter-modal_ViewJobPage__DescriptionWidth___Hyil","ViewJobPage__Footer":"checkbox-filter-modal_ViewJobPage__Footer__1Q8O7","ViewJobPage__FooterView":"checkbox-filter-modal_ViewJobPage__FooterView__QCS_A","ViewJobPage__ShareJob":"checkbox-filter-modal_ViewJobPage__ShareJob__7_xTz","ViewJobPage__SubmitSection":"checkbox-filter-modal_ViewJobPage__SubmitSection__yPz2d","ViewJobPage__SocialMedia":"checkbox-filter-modal_ViewJobPage__SocialMedia__5uZ_c","ViewJobPage__SideContent":"checkbox-filter-modal_ViewJobPage__SideContent__Z0dLp","ViewJobPage__ApplySection":"checkbox-filter-modal_ViewJobPage__ApplySection__JinRI","FormBox__Autofill":"checkbox-filter-modal_FormBox__Autofill__TV8Bz","applybuttons":"checkbox-filter-modal_applybuttons__LEltH","height90":"checkbox-filter-modal_height90__Qg4D5","Form__Cont":"checkbox-filter-modal_Form__Cont__sX9WA","Form__DropBox":"checkbox-filter-modal_Form__DropBox__jkXQY","Form__DropBoxcontainer":"checkbox-filter-modal_Form__DropBoxcontainer__mLxRR","Form__DropBoxError":"checkbox-filter-modal_Form__DropBoxError__GVB1_","Form__DropBoxicon":"checkbox-filter-modal_Form__DropBoxicon__2RFhz","Form__DropBoxmessage":"checkbox-filter-modal_Form__DropBoxmessage__LUEl7","noDpGrid":"checkbox-filter-modal_noDpGrid__FhGuh","Terms":"checkbox-filter-modal_Terms__hgZx9","TermsCondition":"checkbox-filter-modal_TermsCondition__VIrUS","TermsCondition__alignterms":"checkbox-filter-modal_TermsCondition__alignterms__u7K8U","MenuContainer":"checkbox-filter-modal_MenuContainer__HHuZE","MenuContainer__Menu":"checkbox-filter-modal_MenuContainer__Menu__5tpD2","AgencyDetailPage":"checkbox-filter-modal_AgencyDetailPage__t1K7d","Congrats__ModalContent":"checkbox-filter-modal_Congrats__ModalContent__OPqkT","NewJob__Container":"checkbox-filter-modal_NewJob__Container__xfYvR","NewJob__TopSection":"checkbox-filter-modal_NewJob__TopSection__adGCW","NewJob__HorizontalDivider":"checkbox-filter-modal_NewJob__HorizontalDivider__4v9wP","NewJob__Wrapper":"checkbox-filter-modal_NewJob__Wrapper__xmEyC","NewJob__ContainerPadding":"checkbox-filter-modal_NewJob__ContainerPadding__PuvQP","NewJob__ContainerScroll":"checkbox-filter-modal_NewJob__ContainerScroll__fdvCr","NewJob__ContainerHeight":"checkbox-filter-modal_NewJob__ContainerHeight__juj6h","NewJob__ImportAction":"checkbox-filter-modal_NewJob__ImportAction__H16nP","NewJob__Interview_buttons":"checkbox-filter-modal_NewJob__Interview_buttons__h7zdg","Form__TableRowMB":"checkbox-filter-modal_Form__TableRowMB__D6o_V","Form__TableRow3grid":"checkbox-filter-modal_Form__TableRow3grid___97rt","Form__Remotegrid":"checkbox-filter-modal_Form__Remotegrid__263G0","Form__TypeList":"checkbox-filter-modal_Form__TypeList__Ja3fU","Form__Type":"checkbox-filter-modal_Form__Type__1Hh4R","Form__CheckLabel":"checkbox-filter-modal_Form__CheckLabel__826LZ","PrivateSwitchBase-root-1":"checkbox-filter-modal_PrivateSwitchBase-root-1__ZbRQq","Form__Caption":"checkbox-filter-modal_Form__Caption__OuhSu","Form__Input_currency":"checkbox-filter-modal_Form__Input_currency__ZQ0n_","Form__Input_MatchScore":"checkbox-filter-modal_Form__Input_MatchScore__m6xbG","Form__Percentage_Symbol":"checkbox-filter-modal_Form__Percentage_Symbol__lsxhd","Form__NoGridTemplate":"checkbox-filter-modal_Form__NoGridTemplate__UVC_0","active":"checkbox-filter-modal_active__mnEnT","mt10":"checkbox-filter-modal_mt10__WlIjd","mt40":"checkbox-filter-modal_mt40__Z9cCK","mt30":"checkbox-filter-modal_mt30__GyFnc","mt32":"checkbox-filter-modal_mt32__AmeO7","mb0":"checkbox-filter-modal_mb0__9pKgs","Dpgrid":"checkbox-filter-modal_Dpgrid__reYgG","mb12":"checkbox-filter-modal_mb12__Lw_8o","width100":"checkbox-filter-modal_width100__loczF","Tagrow__Prefix":"checkbox-filter-modal_Tagrow__Prefix___obhf","PreviewJobPage":"checkbox-filter-modal_PreviewJobPage__AVCLe","PreviewJob":"checkbox-filter-modal_PreviewJob__chJcz","DpFlx":"checkbox-filter-modal_DpFlx__kHNH5","Subheading":"checkbox-filter-modal_Subheading__HG0Bz","Subheading__Description":"checkbox-filter-modal_Subheading__Description__1dTa_","Candidate__Tooltip":"checkbox-filter-modal_Candidate__Tooltip__l6qMw","Candidate__Tooltip__Score":"checkbox-filter-modal_Candidate__Tooltip__Score__sPhdx","Form__InputField":"checkbox-filter-modal_Form__InputField__FtqHW","Candidate__Length":"checkbox-filter-modal_Candidate__Length__MEF__","Agency__PostDay":"checkbox-filter-modal_Agency__PostDay__C_mJh","Agency__Title":"checkbox-filter-modal_Agency__Title__ZX_tB","Agency__Location":"checkbox-filter-modal_Agency__Location__13nyt","Agency__DescriptionTitle":"checkbox-filter-modal_Agency__DescriptionTitle__BiSg_","Agency__Description":"checkbox-filter-modal_Agency__Description__SIXWt","LightBlueColor":"checkbox-filter-modal_LightBlueColor__z1QZL","ModalFilter":"checkbox-filter-modal_ModalFilter__uVrGV","ModalFilter__Inner":"checkbox-filter-modal_ModalFilter__Inner__jmYYY","ModalFilter__SubmitSection":"checkbox-filter-modal_ModalFilter__SubmitSection__xYVUD","ModalFilter__Head":"checkbox-filter-modal_ModalFilter__Head__LjwTF"};

/***/ }),

/***/ 28033:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Modalpopup":"cropper-filter_Modalpopup__OjsQU","Modalpopup__inner":"cropper-filter_Modalpopup__inner__NuNph","Modalpopup__Dialog":"cropper-filter_Modalpopup__Dialog__xFP7m","transition":"cropper-filter_transition___8PH7","Modalpopup__CloseCenter":"cropper-filter_Modalpopup__CloseCenter__yPo5k","Modalpopup__Content":"cropper-filter_Modalpopup__Content__4_JZu","Modalpopup__btn":"cropper-filter_Modalpopup__btn__Fl9xP","mar":"cropper-filter_mar__Xn2ik","Otpback":"cropper-filter_Otpback__tt9ks","Form":"cropper-filter_Form__HMu3F","Form__width":"cropper-filter_Form__width___gJrf","Form__label":"cropper-filter_Form__label__UyaBm","Form__textleft":"cropper-filter_Form__textleft__hqYTy","Form__InputFullWidth":"cropper-filter_Form__InputFullWidth__rQKD2","Form__Input":"cropper-filter_Form__Input__hrQKK","Form__Input398":"cropper-filter_Form__Input398__JKcQM","Form__InputSection":"cropper-filter_Form__InputSection__I97w9","Form__ScoreCardInput":"cropper-filter_Form__ScoreCardInput__ifeR9","Form__Textarea":"cropper-filter_Form__Textarea__iv1C_","primarybtn":"cropper-filter_primarybtn__J14mQ","GoBtn":"cropper-filter_GoBtn__GHrf6","secondarybtn":"cropper-filter_secondarybtn__GWsx9","iconFilled":"cropper-filter_iconFilled__SWTVk","iconFilledSolid":"cropper-filter_iconFilledSolid__2fnhK","primarybtnborder":"cropper-filter_primarybtnborder__2pbhA","secondarybtnborder":"cropper-filter_secondarybtnborder__pFKu8","ClearBtn":"cropper-filter_ClearBtn__E9ooD","tertiarybtn":"cropper-filter_tertiarybtn__v7aEM","graybtnborder":"cropper-filter_graybtnborder__Pjy8O","jobsrchbtn":"cropper-filter_jobsrchbtn__tzK9G","jobsrchbtnalign":"cropper-filter_jobsrchbtnalign__gfR7n","nobgbutton":"cropper-filter_nobgbutton__CQVit","iconTextButton":"cropper-filter_iconTextButton__Svpe2","cursornone":"cropper-filter_cursornone__RFGyk","nobgbuttonprimary":"cropper-filter_nobgbuttonprimary__goa4Z","mt15":"cropper-filter_mt15__91_9G","btn350":"cropper-filter_btn350__isASu","GrayBgBtn":"cropper-filter_GrayBgBtn__ZM8xB","NewShareBtn":"cropper-filter_NewShareBtn__CEwVl","CoralBgBtn":"cropper-filter_CoralBgBtn__rEeKh","DropContainer":"cropper-filter_DropContainer__q8SmV","DropContainer__Inner":"cropper-filter_DropContainer__Inner__66CNf","CompanyProfile__Inner":"cropper-filter_CompanyProfile__Inner__Pwcnv","DropContainer__Message":"cropper-filter_DropContainer__Message__6iZJQ","CompanyProfile__Message":"cropper-filter_CompanyProfile__Message__RT3bs","CompanyProfile__MessageContent":"cropper-filter_CompanyProfile__MessageContent__2BR8I","DropContainer__UploadIcon":"cropper-filter_DropContainer__UploadIcon__TshId","CompanyProfile__UploadIcon":"cropper-filter_CompanyProfile__UploadIcon__R9vb7","FileDisplayContainer":"cropper-filter_FileDisplayContainer__Z_75d","FileDisplayContainer__Status":"cropper-filter_FileDisplayContainer__Status__KHsIY","FileDisplayContainer__Type":"cropper-filter_FileDisplayContainer__Type__EuZrY","FileDisplayContainer__Name":"cropper-filter_FileDisplayContainer__Name__7Qut_","FileDisplayContainer__Error":"cropper-filter_FileDisplayContainer__Error__4Ixwk","FileDisplayContainer__Close":"cropper-filter_FileDisplayContainer__Close__yUWCq","Browse":"cropper-filter_Browse__lGPae","ClientCompany":"cropper-filter_ClientCompany__7mv2f","NewJob":"cropper-filter_NewJob__ER_6j","ClientCompany__TopSection2":"cropper-filter_ClientCompany__TopSection2__nxZR_","ClientCompany__Filter":"cropper-filter_ClientCompany__Filter__dq95b","ClientCompany__Input_MatchScore":"cropper-filter_ClientCompany__Input_MatchScore__oiMri","ClientCompany__Percentage_Symbol":"cropper-filter_ClientCompany__Percentage_Symbol__LSY9o","ClientCompany__Filterheading":"cropper-filter_ClientCompany__Filterheading__yX_D4","ClientCompany__FloatButtonAdd":"cropper-filter_ClientCompany__FloatButtonAdd__w4ZY9","ClientCompany__FloatButtonAdd__AgencyUserIcon":"cropper-filter_ClientCompany__FloatButtonAdd__AgencyUserIcon__LaFvS","ClientCompany__LastEdited":"cropper-filter_ClientCompany__LastEdited__GWUmw","ClientCompany__BackSection":"cropper-filter_ClientCompany__BackSection__sTiTi","AddUsers__BackSection":"cropper-filter_AddUsers__BackSection__RllLm","ClientCompany__BackSection__CloseIcon":"cropper-filter_ClientCompany__BackSection__CloseIcon__i0bRO","ClientCompany__Container":"cropper-filter_ClientCompany__Container__bHShy","NewJob__InterviewContainer":"cropper-filter_NewJob__InterviewContainer__KTdGm","AddUsers__Container":"cropper-filter_AddUsers__Container__6Ii1g","ClientCompany__FormInputSection":"cropper-filter_ClientCompany__FormInputSection__cQZv0","CompanyProfile__FormInputSection":"cropper-filter_CompanyProfile__FormInputSection__46l4k","ClientCompany__Heading":"cropper-filter_ClientCompany__Heading__vOdLc","AddUsers__Heading":"cropper-filter_AddUsers__Heading__zPD5K","ClientCompany__StatusAlignment":"cropper-filter_ClientCompany__StatusAlignment__eJhTZ","ClientCompany__Status":"cropper-filter_ClientCompany__Status__P_H10","ClientCompany__ActiveDot":"cropper-filter_ClientCompany__ActiveDot__ZS0Tk","ClientCompany__CloseDot":"cropper-filter_ClientCompany__CloseDot__R22YZ","ClientCompany__Company":"cropper-filter_ClientCompany__Company__YJfHE","AddUsers__User":"cropper-filter_AddUsers__User__5ntkh","ClientCompany__Systemrefheding":"cropper-filter_ClientCompany__Systemrefheding__apytm","ClientCompany__Subheading":"cropper-filter_ClientCompany__Subheading__c9fNU","CompanyProfile__Subheading":"cropper-filter_CompanyProfile__Subheading__9AKai","ClientCompany__Subheading2":"cropper-filter_ClientCompany__Subheading2__gVdh5","ClientCompany__Description":"cropper-filter_ClientCompany__Description__JCpXj","ClientCompany__SubmitSection":"cropper-filter_ClientCompany__SubmitSection__SoQKt","NewJob__SubmitSection":"cropper-filter_NewJob__SubmitSection__5pdpB","NewJob__SubmitSectionThreeBtn":"cropper-filter_NewJob__SubmitSectionThreeBtn__NEA16","NewJob__SubmitSectionOneBtnPlacement":"cropper-filter_NewJob__SubmitSectionOneBtnPlacement__2i_0D","NewJob__ImportSection":"cropper-filter_NewJob__ImportSection__CTMC9","AddUsers__SubmitSection":"cropper-filter_AddUsers__SubmitSection__0miaR","ClientCompany__IntegrationImage":"cropper-filter_ClientCompany__IntegrationImage__HYo_d","ClientCompany__QuickAdd":"cropper-filter_ClientCompany__QuickAdd__SylN2","NewJob__QuickAdd":"cropper-filter_NewJob__QuickAdd__yIcVT","ClientCompany__BodyText":"cropper-filter_ClientCompany__BodyText__LZypE","Form__TableRow":"cropper-filter_Form__TableRow__tPxt5","Form__TableRowBlock":"cropper-filter_Form__TableRowBlock__Q0ejB","Form__Label":"cropper-filter_Form__Label__sMsuZ","Form__FloatingLabel":"cropper-filter_Form__FloatingLabel__a3yLk","Form__TableCol":"cropper-filter_Form__TableCol__Pp74o","Form__TableCol2":"cropper-filter_Form__TableCol2__AWhFA","Form__currency_symbol":"cropper-filter_Form__currency_symbol__BUXK9","Form__CustomSelect":"cropper-filter_Form__CustomSelect__U38UX","Form__currency_symbol__right":"cropper-filter_Form__currency_symbol__right__s61_z","Form__TableCol__Disabled":"cropper-filter_Form__TableCol__Disabled__gmgPW","Form__TextareaDisabled":"cropper-filter_Form__TextareaDisabled__LRnXX","Form__EditorDisabled":"cropper-filter_Form__EditorDisabled__ZndW8","Form__AdminCheckLabel":"cropper-filter_Form__AdminCheckLabel__vj6H_","Form__AdminCheckMargin":"cropper-filter_Form__AdminCheckMargin__Qv_zd","CompanyProfile__BrandingGuide":"cropper-filter_CompanyProfile__BrandingGuide__7IByr","CompanyProfile__DropBoxContainer":"cropper-filter_CompanyProfile__DropBoxContainer__lhwiA","CompanyProfile__Browse":"cropper-filter_CompanyProfile__Browse__ZOHBQ","ErrorLabel":"cropper-filter_ErrorLabel__55AF9","Height80":"cropper-filter_Height80__ea1bq","Browse__ButtonFlexEnd":"cropper-filter_Browse__ButtonFlexEnd__QaAQV","AddAgency__Container":"cropper-filter_AddAgency__Container__J_BiL","AddAgency__FormInputSection":"cropper-filter_AddAgency__FormInputSection__On_s8","AddAgency__FormInputSection__Label":"cropper-filter_AddAgency__FormInputSection__Label__oiqcQ","AddAgency__Form":"cropper-filter_AddAgency__Form__pC_pV","LinkAsButtons":"cropper-filter_LinkAsButtons__pbf3f","SearchFlex":"cropper-filter_SearchFlex__eA5uN","Form__ErrorCustomSelect":"cropper-filter_Form__ErrorCustomSelect__Q0Kvv","Form__select_currency":"cropper-filter_Form__select_currency__WiZT5","customSelect__placeholder":"cropper-filter_customSelect__placeholder__RZGQ9","Career":"cropper-filter_Career__uNm3B","Career__Background_Edit":"cropper-filter_Career__Background_Edit__lZ40O","Career__Background_Edit_Image":"cropper-filter_Career__Background_Edit_Image___XXDj","Career__Container":"cropper-filter_Career__Container__QI7k3","Career__Inner":"cropper-filter_Career__Inner__2HYR4","Career__logo":"cropper-filter_Career__logo__He8oG","Career__Content":"cropper-filter_Career__Content__S76Hf","Career__ButtonSection":"cropper-filter_Career__ButtonSection__M1H8f","Job":"cropper-filter_Job__VIWf5","Job__Inner":"cropper-filter_Job__Inner__dNXTD","Job__Container":"cropper-filter_Job__Container__myGQv","Job__Heading":"cropper-filter_Job__Heading__kHfEv","Job__Company":"cropper-filter_Job__Company__UoHwE","Job__SearchContainer":"cropper-filter_Job__SearchContainer__d0MFR","Job__SearchInput":"cropper-filter_Job__SearchInput__AlIoI","Job__Searchbtn":"cropper-filter_Job__Searchbtn__kOTCy","Job__Input":"cropper-filter_Job__Input__uJpGS","Job__SelectJob":"cropper-filter_Job__SelectJob__UaU8y","Job__RemoteLabel":"cropper-filter_Job__RemoteLabel__9kUSw","Job__Display":"cropper-filter_Job__Display__zvhDG","Job__PostDay":"cropper-filter_Job__PostDay__V_1uj","Job__Title":"cropper-filter_Job__Title__NpcZM","Job__Location":"cropper-filter_Job__Location__E1GzF","DT":"cropper-filter_DT__EKcPS","DisplayTable":"cropper-filter_DisplayTable___4F1I","pd11":"cropper-filter_pd11__xPw8J","Label":"cropper-filter_Label__12cKB","inputwidth":"cropper-filter_inputwidth__aeByu","mr24":"cropper-filter_mr24__8ld9D","fullwidth":"cropper-filter_fullwidth__LGD_S","padt40":"cropper-filter_padt40__EuSgh","Form__TableRowflex":"cropper-filter_Form__TableRowflex__rk0Vn","Form__TableColm":"cropper-filter_Form__TableColm__AieK7","Form__LabelCheck":"cropper-filter_Form__LabelCheck__Fuhlo","Form__Error":"cropper-filter_Form__Error__MKgOC","Form__ErrorSection":"cropper-filter_Form__ErrorSection__HlQ5O","Form__MessagePlaceholder":"cropper-filter_Form__MessagePlaceholder__pkdzS","Form__Submit":"cropper-filter_Form__Submit__DMnPR","Form__NormalLabel":"cropper-filter_Form__NormalLabel__WRCul","AddInterview":"cropper-filter_AddInterview__JaNmE","IntegrationPage":"cropper-filter_IntegrationPage__SVrP7","Integration__BackStep":"cropper-filter_Integration__BackStep__1xNXN","AddUsers__BackStep":"cropper-filter_AddUsers__BackStep__Bl_XS","Integration__SubmitSection":"cropper-filter_Integration__SubmitSection__XkJGm","IntegrationTable":"cropper-filter_IntegrationTable___p_WU","IntegrationTable__LimitInput":"cropper-filter_IntegrationTable__LimitInput__xyCZJ","IntegrationTable__Type":"cropper-filter_IntegrationTable__Type__ku9wj","IntegrationTable__AllJobsToggle":"cropper-filter_IntegrationTable__AllJobsToggle__nTM4i","IntegrationTable__switch":"cropper-filter_IntegrationTable__switch__XKsGJ","IntegrationTable__switchText":"cropper-filter_IntegrationTable__switchText__YnuPE","IntegrationTable__slider":"cropper-filter_IntegrationTable__slider__Endzu","IntegrationTable__round":"cropper-filter_IntegrationTable__round__54348","IntegrationTable__Action":"cropper-filter_IntegrationTable__Action__euYTm","IntegrationView":"cropper-filter_IntegrationView__OUrCV","IntegrationView__Title":"cropper-filter_IntegrationView__Title__bZ6WP","IntegrationView__Subheading":"cropper-filter_IntegrationView__Subheading__7Hvbp","IntegrationView__BoxImage":"cropper-filter_IntegrationView__BoxImage__gQqsV","IntegrationView__Box":"cropper-filter_IntegrationView__Box__kUmLz","IntegrationView__BoxImage__InfoIcon":"cropper-filter_IntegrationView__BoxImage__InfoIcon___Nqwm","IntegrationView__ViewMoreButton":"cropper-filter_IntegrationView__ViewMoreButton__quHQr","IntegrationView__ConnectButton":"cropper-filter_IntegrationView__ConnectButton__Z8z31","IntegrationView__GoogleButton":"cropper-filter_IntegrationView__GoogleButton__ndMzk","IntegrationView__FlexFlow":"cropper-filter_IntegrationView__FlexFlow__yFHWK","IntegrationView__BoxWidth":"cropper-filter_IntegrationView__BoxWidth__bsUkU","SkipFinishButton":"cropper-filter_SkipFinishButton__Qr1S9","AddUsers":"cropper-filter_AddUsers__cDOLD","AddUsers__ButtonSection":"cropper-filter_AddUsers__ButtonSection__DKzrW","AddUsers__QuickStepHeading":"cropper-filter_AddUsers__QuickStepHeading__SWpoE","AddUsers__DeleteSection":"cropper-filter_AddUsers__DeleteSection__Spa8Y","AddUsers__DeleteCrossHeight":"cropper-filter_AddUsers__DeleteCrossHeight__hydnm","AddUsers__Form__Input":"cropper-filter_AddUsers__Form__Input__Jw9Kh","AddUsers__FormHeadingSection":"cropper-filter_AddUsers__FormHeadingSection__LpKKt","AddUsers__FormSection":"cropper-filter_AddUsers__FormSection__WRJ3P","NewJob__FormSection":"cropper-filter_NewJob__FormSection__Gv0Po","AddUsers__ButtonsActionSection":"cropper-filter_AddUsers__ButtonsActionSection__NRAks","AddUsers__ImportUsers":"cropper-filter_AddUsers__ImportUsers__HLxLR","AddUsers__NameInput":"cropper-filter_AddUsers__NameInput__zHCYb","AddUsers__EmailInput":"cropper-filter_AddUsers__EmailInput__NLrzh","AddUsers__RoleInput":"cropper-filter_AddUsers__RoleInput__ewstE","AddUsers__Subheading":"cropper-filter_AddUsers__Subheading___lFJJ","AddUsers__visible":"cropper-filter_AddUsers__visible__fk1dg","Tagrow":"cropper-filter_Tagrow__O0Vve","Tagrow__Tags":"cropper-filter_Tagrow__Tags__c7FOH","Tagrow__Cancel":"cropper-filter_Tagrow__Cancel__xG7By","SendInviteSection":"cropper-filter_SendInviteSection__f7jd7","error":"cropper-filter_error__dEQGr","ViewJobPage__Input":"cropper-filter_ViewJobPage__Input__PvYHL","Form__Input2":"cropper-filter_Form__Input2__vikXg","ViewJobPage__PostDay":"cropper-filter_ViewJobPage__PostDay__V1kKU","ViewJobPage__Title":"cropper-filter_ViewJobPage__Title__G07gK","ViewJobPage__DescriptionTitle":"cropper-filter_ViewJobPage__DescriptionTitle__6eVYK","ViewJobPage__Location":"cropper-filter_ViewJobPage__Location__FuJlq","ViewJobPage__primarybtn":"cropper-filter_ViewJobPage__primarybtn__J2ubG","ViewJobPage__secondarybtn":"cropper-filter_ViewJobPage__secondarybtn__4O7cP","ViewJobPage__secondarybtnborder":"cropper-filter_ViewJobPage__secondarybtnborder__wICVi","ViewJobPage__BackSection":"cropper-filter_ViewJobPage__BackSection__4GYST","ViewJobPage__Content":"cropper-filter_ViewJobPage__Content__0e_Se","ViewJobPage":"cropper-filter_ViewJobPage__aJAs0","ViewJobPage__Header":"cropper-filter_ViewJobPage__Header__gSLh_","ViewJobPage__Application":"cropper-filter_ViewJobPage__Application__5D1ni","ViewJobPage__RecordVideo":"cropper-filter_ViewJobPage__RecordVideo__LPNVK","ViewJobPage__RecordVideoSuccessText":"cropper-filter_ViewJobPage__RecordVideoSuccessText__8d8fZ","ViewJobPage__subheading":"cropper-filter_ViewJobPage__subheading__G6r6x","ViewJobPage__confirmation":"cropper-filter_ViewJobPage__confirmation__mgdt8","ViewJobPage__Logo":"cropper-filter_ViewJobPage__Logo__4dwTm","ViewJobPage__BrandLogo":"cropper-filter_ViewJobPage__BrandLogo__3HLKe","ViewJobPage__BrandLogo__Padding10":"cropper-filter_ViewJobPage__BrandLogo__Padding10__mlpvS","ViewJobPage__Container":"cropper-filter_ViewJobPage__Container__wOwkx","ViewJobPage__JobContent":"cropper-filter_ViewJobPage__JobContent__f7Tve","ViewJobPage__Sidebar":"cropper-filter_ViewJobPage__Sidebar__fG6vI","ViewJobPage__Sidebar2":"cropper-filter_ViewJobPage__Sidebar2__SdUiW","ViewJobPage__Description":"cropper-filter_ViewJobPage__Description__Hhv6t","ViewJobPage__DescriptionWidth":"cropper-filter_ViewJobPage__DescriptionWidth__8mqFG","ViewJobPage__Footer":"cropper-filter_ViewJobPage__Footer__mPQd_","ViewJobPage__FooterView":"cropper-filter_ViewJobPage__FooterView__Pqi50","ViewJobPage__ShareJob":"cropper-filter_ViewJobPage__ShareJob__SBckP","ViewJobPage__SubmitSection":"cropper-filter_ViewJobPage__SubmitSection__1Za_x","ViewJobPage__SocialMedia":"cropper-filter_ViewJobPage__SocialMedia__u5Jx0","ViewJobPage__SideContent":"cropper-filter_ViewJobPage__SideContent__MkvLN","ViewJobPage__ApplySection":"cropper-filter_ViewJobPage__ApplySection__ITTAQ","FormBox__Autofill":"cropper-filter_FormBox__Autofill__E8XCy","applybuttons":"cropper-filter_applybuttons__N8O5_","height90":"cropper-filter_height90__NKoXV","Form__Cont":"cropper-filter_Form__Cont__HzV4u","Form__DropBox":"cropper-filter_Form__DropBox__Dq71e","Form__DropBoxcontainer":"cropper-filter_Form__DropBoxcontainer__bUcy2","Form__DropBoxError":"cropper-filter_Form__DropBoxError__HiFbc","Form__DropBoxicon":"cropper-filter_Form__DropBoxicon__882zE","Form__DropBoxmessage":"cropper-filter_Form__DropBoxmessage__H8Irv","noDpGrid":"cropper-filter_noDpGrid__zu2wv","Terms":"cropper-filter_Terms__Sjjei","TermsCondition":"cropper-filter_TermsCondition___AMyG","TermsCondition__alignterms":"cropper-filter_TermsCondition__alignterms__XIQpT","MenuContainer":"cropper-filter_MenuContainer___OfQ4","MenuContainer__Menu":"cropper-filter_MenuContainer__Menu__zrAsc","AgencyDetailPage":"cropper-filter_AgencyDetailPage__RFYo9","Congrats__ModalContent":"cropper-filter_Congrats__ModalContent__hL4yS","NewJob__Container":"cropper-filter_NewJob__Container__axGaS","NewJob__TopSection":"cropper-filter_NewJob__TopSection__n9jO5","NewJob__HorizontalDivider":"cropper-filter_NewJob__HorizontalDivider__VXxQN","NewJob__Wrapper":"cropper-filter_NewJob__Wrapper__iwGbL","NewJob__ContainerPadding":"cropper-filter_NewJob__ContainerPadding__JiNWA","NewJob__ContainerScroll":"cropper-filter_NewJob__ContainerScroll__sitAa","NewJob__ContainerHeight":"cropper-filter_NewJob__ContainerHeight__iDbdk","NewJob__ImportAction":"cropper-filter_NewJob__ImportAction__JZFwk","NewJob__Interview_buttons":"cropper-filter_NewJob__Interview_buttons__9Say1","Form__TableRowMB":"cropper-filter_Form__TableRowMB__qtMnS","Form__TableRow3grid":"cropper-filter_Form__TableRow3grid__u8jWk","Form__Remotegrid":"cropper-filter_Form__Remotegrid__ZvDpM","Form__TypeList":"cropper-filter_Form__TypeList__gQ2fJ","Form__Type":"cropper-filter_Form__Type__lQ5Lc","Form__CheckLabel":"cropper-filter_Form__CheckLabel__XYsVg","PrivateSwitchBase-root-1":"cropper-filter_PrivateSwitchBase-root-1__3k7hM","Form__Caption":"cropper-filter_Form__Caption__0fg7h","Form__Input_currency":"cropper-filter_Form__Input_currency__G65_S","Form__Input_MatchScore":"cropper-filter_Form__Input_MatchScore__F6BOO","Form__Percentage_Symbol":"cropper-filter_Form__Percentage_Symbol__U_RQA","Form__NoGridTemplate":"cropper-filter_Form__NoGridTemplate__bYzZ4","active":"cropper-filter_active___Hkbt","mt10":"cropper-filter_mt10__vzUsp","mt40":"cropper-filter_mt40__rB0p_","mt30":"cropper-filter_mt30__1YJx3","mt32":"cropper-filter_mt32__uNhtz","mb0":"cropper-filter_mb0__G5epD","Dpgrid":"cropper-filter_Dpgrid__jzowx","mb12":"cropper-filter_mb12__h5R_U","width100":"cropper-filter_width100__BPzfh","Tagrow__Prefix":"cropper-filter_Tagrow__Prefix__M9wZa","PreviewJobPage":"cropper-filter_PreviewJobPage__zyEdF","PreviewJob":"cropper-filter_PreviewJob__9457U","DpFlx":"cropper-filter_DpFlx__DivX_","Subheading":"cropper-filter_Subheading__d4f7M","Subheading__Description":"cropper-filter_Subheading__Description__w7Hz9","Candidate__Tooltip":"cropper-filter_Candidate__Tooltip__ehU0b","Candidate__Tooltip__Score":"cropper-filter_Candidate__Tooltip__Score___t0Xt","Form__InputField":"cropper-filter_Form__InputField__aYvLU","Candidate__Length":"cropper-filter_Candidate__Length__ZzKS_","Agency__PostDay":"cropper-filter_Agency__PostDay__QPFXL","Agency__Title":"cropper-filter_Agency__Title__8AmHk","Agency__Location":"cropper-filter_Agency__Location__xIJ4a","Agency__DescriptionTitle":"cropper-filter_Agency__DescriptionTitle__at1b5","Agency__Description":"cropper-filter_Agency__Description__9LrrB","LightBlueColor":"cropper-filter_LightBlueColor__cv9uW","CropImage":"cropper-filter_CropImage__Qz9TL","CropImage__Actions":"cropper-filter_CropImage__Actions__2oWMI","CropImage__Inner":"cropper-filter_CropImage__Inner__8w2Pk","CropImage__Head":"cropper-filter_CropImage__Head___m1cj","CropImage__SubmitSection":"cropper-filter_CropImage__SubmitSection__wKX2_","ModalClose":"cropper-filter_ModalClose__ED38_","fontslabel":"cropper-filter_fontslabel__TjjeH","CareerLogoImage":"cropper-filter_CareerLogoImage__XA_Em","CareerHeroImage":"cropper-filter_CareerHeroImage__3al1A","CareerGalleryImage":"cropper-filter_CareerGalleryImage__l3Cmd","CareerTeamImage":"cropper-filter_CareerTeamImage__U1L9T","CareerBenefitImage":"cropper-filter_CareerBenefitImage___eVyu","CareerAboutImage":"cropper-filter_CareerAboutImage__kMLKk","CropperFilter":"cropper-filter_CropperFilter__8pKly","CropperFilter__SubmitSection":"cropper-filter_CropperFilter__SubmitSection__FAQav","CropperFilter__Inner":"cropper-filter_CropperFilter__Inner__awsgZ","CropperFilter__Head":"cropper-filter_CropperFilter__Head__O70AJ"};

/***/ }),

/***/ 72396:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CvLoader":"custom-cv-load_CvLoader__1NI4x","CvNotFoundLink":"custom-cv-load_CvNotFoundLink__BsFMz"};

/***/ }),

/***/ 44479:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Modalpopup":"cv-library_Modalpopup__7HmSs","Modalpopup__inner":"cv-library_Modalpopup__inner__4AxTM","Modalpopup__Dialog":"cv-library_Modalpopup__Dialog__fJzPD","transition":"cv-library_transition__7C2s6","Modalpopup__CloseCenter":"cv-library_Modalpopup__CloseCenter__PdPNq","Modalpopup__Content":"cv-library_Modalpopup__Content__gpjD8","Modalpopup__btn":"cv-library_Modalpopup__btn__HRjI4","mar":"cv-library_mar__ARDsp","Otpback":"cv-library_Otpback__pHA8U","Form":"cv-library_Form__BusBe","Form__width":"cv-library_Form__width__YA_RN","Form__label":"cv-library_Form__label__aU3kY","Form__textleft":"cv-library_Form__textleft__Q5Q3Q","Form__InputFullWidth":"cv-library_Form__InputFullWidth__20NbA","Form__Input":"cv-library_Form__Input__KkFAo","Form__Input398":"cv-library_Form__Input398__M0VJ6","Form__InputSection":"cv-library_Form__InputSection___djKM","Form__ScoreCardInput":"cv-library_Form__ScoreCardInput__o9QBV","Form__Textarea":"cv-library_Form__Textarea__JQD7w","primarybtn":"cv-library_primarybtn__rlmmu","GoBtn":"cv-library_GoBtn__4Hr8j","secondarybtn":"cv-library_secondarybtn__jOrx4","iconFilled":"cv-library_iconFilled__iGrYm","iconFilledSolid":"cv-library_iconFilledSolid__Q0EHh","primarybtnborder":"cv-library_primarybtnborder__CTz1X","secondarybtnborder":"cv-library_secondarybtnborder__r4Q_x","ClearBtn":"cv-library_ClearBtn__XapGz","tertiarybtn":"cv-library_tertiarybtn__ZOHGi","graybtnborder":"cv-library_graybtnborder__Xgbd8","jobsrchbtn":"cv-library_jobsrchbtn__TdqhC","jobsrchbtnalign":"cv-library_jobsrchbtnalign__HP08C","nobgbutton":"cv-library_nobgbutton__izLDB","iconTextButton":"cv-library_iconTextButton__Onn9o","cursornone":"cv-library_cursornone__gB2S8","nobgbuttonprimary":"cv-library_nobgbuttonprimary__9rOah","mt15":"cv-library_mt15__1ejcR","btn350":"cv-library_btn350__KIVUq","GrayBgBtn":"cv-library_GrayBgBtn__sdHay","NewShareBtn":"cv-library_NewShareBtn__fIJW4","CoralBgBtn":"cv-library_CoralBgBtn__GCzqE","DropContainer":"cv-library_DropContainer__xgi3a","DropContainer__Inner":"cv-library_DropContainer__Inner__iIW8J","CompanyProfile__Inner":"cv-library_CompanyProfile__Inner__qOPEG","DropContainer__Message":"cv-library_DropContainer__Message__xzqJu","CompanyProfile__Message":"cv-library_CompanyProfile__Message__eu067","CompanyProfile__MessageContent":"cv-library_CompanyProfile__MessageContent__fl4ts","DropContainer__UploadIcon":"cv-library_DropContainer__UploadIcon__yi28n","CompanyProfile__UploadIcon":"cv-library_CompanyProfile__UploadIcon__cjVgN","FileDisplayContainer":"cv-library_FileDisplayContainer__pI5z_","FileDisplayContainer__Status":"cv-library_FileDisplayContainer__Status__dCLND","FileDisplayContainer__Type":"cv-library_FileDisplayContainer__Type__GJRi1","FileDisplayContainer__Name":"cv-library_FileDisplayContainer__Name__1TZe_","FileDisplayContainer__Error":"cv-library_FileDisplayContainer__Error__ZKBpP","FileDisplayContainer__Close":"cv-library_FileDisplayContainer__Close__8hbnw","Browse":"cv-library_Browse__mFn_8","ClientCompany":"cv-library_ClientCompany__vEfbB","NewJob":"cv-library_NewJob__SJ9p_","ClientCompany__TopSection2":"cv-library_ClientCompany__TopSection2__N1Rmc","ClientCompany__Filter":"cv-library_ClientCompany__Filter__my4ji","ClientCompany__Input_MatchScore":"cv-library_ClientCompany__Input_MatchScore__4n_oy","ClientCompany__Percentage_Symbol":"cv-library_ClientCompany__Percentage_Symbol__nIP2q","ClientCompany__Filterheading":"cv-library_ClientCompany__Filterheading__S1DcY","ClientCompany__FloatButtonAdd":"cv-library_ClientCompany__FloatButtonAdd__9BLWy","ClientCompany__FloatButtonAdd__AgencyUserIcon":"cv-library_ClientCompany__FloatButtonAdd__AgencyUserIcon__hyGRY","ClientCompany__LastEdited":"cv-library_ClientCompany__LastEdited__9Tuo5","ClientCompany__BackSection":"cv-library_ClientCompany__BackSection___GlO1","AddUsers__BackSection":"cv-library_AddUsers__BackSection__mt0cX","ClientCompany__BackSection__CloseIcon":"cv-library_ClientCompany__BackSection__CloseIcon__UhvEw","ClientCompany__Container":"cv-library_ClientCompany__Container__v0MNY","NewJob__InterviewContainer":"cv-library_NewJob__InterviewContainer__gDl4h","AddUsers__Container":"cv-library_AddUsers__Container__6sorF","ClientCompany__FormInputSection":"cv-library_ClientCompany__FormInputSection__sn9Eu","CompanyProfile__FormInputSection":"cv-library_CompanyProfile__FormInputSection__BUgfX","ClientCompany__Heading":"cv-library_ClientCompany__Heading__A_wPY","AddUsers__Heading":"cv-library_AddUsers__Heading__EaVGE","ClientCompany__StatusAlignment":"cv-library_ClientCompany__StatusAlignment__iLUKZ","ClientCompany__Status":"cv-library_ClientCompany__Status__NjApN","ClientCompany__ActiveDot":"cv-library_ClientCompany__ActiveDot__JL8jF","ClientCompany__CloseDot":"cv-library_ClientCompany__CloseDot__ldJI_","ClientCompany__Company":"cv-library_ClientCompany__Company__wt4ya","AddUsers__User":"cv-library_AddUsers__User__GrsWc","ClientCompany__Systemrefheding":"cv-library_ClientCompany__Systemrefheding__3alj6","ClientCompany__Subheading":"cv-library_ClientCompany__Subheading__SM5dW","CompanyProfile__Subheading":"cv-library_CompanyProfile__Subheading__IY0Bz","ClientCompany__Subheading2":"cv-library_ClientCompany__Subheading2__aLtCL","ClientCompany__Description":"cv-library_ClientCompany__Description__3urp9","ClientCompany__SubmitSection":"cv-library_ClientCompany__SubmitSection__4UnAE","NewJob__SubmitSection":"cv-library_NewJob__SubmitSection__bGF7C","NewJob__SubmitSectionThreeBtn":"cv-library_NewJob__SubmitSectionThreeBtn__uQbp6","NewJob__SubmitSectionOneBtnPlacement":"cv-library_NewJob__SubmitSectionOneBtnPlacement__AEzed","NewJob__ImportSection":"cv-library_NewJob__ImportSection__OYVwP","AddUsers__SubmitSection":"cv-library_AddUsers__SubmitSection__krmyc","ClientCompany__IntegrationImage":"cv-library_ClientCompany__IntegrationImage__G2GyV","ClientCompany__QuickAdd":"cv-library_ClientCompany__QuickAdd__DwRQB","NewJob__QuickAdd":"cv-library_NewJob__QuickAdd__cr7yb","ClientCompany__BodyText":"cv-library_ClientCompany__BodyText__1ay8b","Form__TableRow":"cv-library_Form__TableRow__lsQpV","Form__Label":"cv-library_Form__Label__ltbgI","Form__FloatingLabel":"cv-library_Form__FloatingLabel__FiLic","Form__TableCol":"cv-library_Form__TableCol__K1nJy","Form__currency_symbol":"cv-library_Form__currency_symbol__B_wUI","Form__CustomSelect":"cv-library_Form__CustomSelect__Fa4bo","Form__currency_symbol__right":"cv-library_Form__currency_symbol__right__Ol_3k","Form__TableCol__Disabled":"cv-library_Form__TableCol__Disabled__Ml76P","Form__TextareaDisabled":"cv-library_Form__TextareaDisabled__pT_om","Form__EditorDisabled":"cv-library_Form__EditorDisabled__jY3ao","Form__AdminCheckLabel":"cv-library_Form__AdminCheckLabel__gKouG","Form__AdminCheckMargin":"cv-library_Form__AdminCheckMargin__ZP2TO","CompanyProfile__BrandingGuide":"cv-library_CompanyProfile__BrandingGuide___8lE_","CompanyProfile__DropBoxContainer":"cv-library_CompanyProfile__DropBoxContainer__8qj_P","CompanyProfile__Browse":"cv-library_CompanyProfile__Browse__3f08g","ErrorLabel":"cv-library_ErrorLabel__BnlVC","Height80":"cv-library_Height80__Gbucv","Browse__ButtonFlexEnd":"cv-library_Browse__ButtonFlexEnd__52_kw","AddAgency__Container":"cv-library_AddAgency__Container__29yQ3","AddAgency__FormInputSection":"cv-library_AddAgency__FormInputSection___mG3g","AddAgency__FormInputSection__Label":"cv-library_AddAgency__FormInputSection__Label__jA3Ne","AddAgency__Form":"cv-library_AddAgency__Form__wpw2i","LinkAsButtons":"cv-library_LinkAsButtons__JZTfP","SearchFlex":"cv-library_SearchFlex__4yiMl","Form__ErrorCustomSelect":"cv-library_Form__ErrorCustomSelect__0UBPe","Form__select_currency":"cv-library_Form__select_currency__L559I","customSelect__placeholder":"cv-library_customSelect__placeholder__XrRKa","Career":"cv-library_Career__N3Svh","Career__Background_Edit":"cv-library_Career__Background_Edit__H02rQ","Career__Background_Edit_Image":"cv-library_Career__Background_Edit_Image__DCfDp","Career__Container":"cv-library_Career__Container__aCeeG","Career__Inner":"cv-library_Career__Inner__xfL0s","Career__logo":"cv-library_Career__logo__2th3j","Career__Content":"cv-library_Career__Content__5ywkU","Career__ButtonSection":"cv-library_Career__ButtonSection__kO5WV","Job":"cv-library_Job__tT8_R","Job__Inner":"cv-library_Job__Inner__qyV0m","Job__Container":"cv-library_Job__Container__LMN1_","Job__Heading":"cv-library_Job__Heading__Q4_6B","Job__Company":"cv-library_Job__Company__bwA_D","Job__SearchContainer":"cv-library_Job__SearchContainer__VxTG4","Job__SearchInput":"cv-library_Job__SearchInput__6q4di","Job__Searchbtn":"cv-library_Job__Searchbtn__SjLdP","Job__Input":"cv-library_Job__Input__X4TGg","Job__SelectJob":"cv-library_Job__SelectJob__UWtKt","Job__RemoteLabel":"cv-library_Job__RemoteLabel__aU8Q0","Job__Display":"cv-library_Job__Display__BJ4az","Job__PostDay":"cv-library_Job__PostDay__QQBVM","Job__Title":"cv-library_Job__Title__7zJoq","Job__Location":"cv-library_Job__Location__21jua","DT":"cv-library_DT__spwOD","DisplayTable":"cv-library_DisplayTable__unprP","pd11":"cv-library_pd11__Fwfq_","Label":"cv-library_Label__69_U_","inputwidth":"cv-library_inputwidth__FOFSX","mr24":"cv-library_mr24__wxNer","fullwidth":"cv-library_fullwidth__9RwW_","padt40":"cv-library_padt40__SeacZ","Form__TableRowflex":"cv-library_Form__TableRowflex___XLJo","Form__TableColm":"cv-library_Form__TableColm__8XFxM","Form__LabelCheck":"cv-library_Form__LabelCheck___atQZ","Form__Error":"cv-library_Form__Error__vrKbG","Form__ErrorSection":"cv-library_Form__ErrorSection__xYloa","Form__MessagePlaceholder":"cv-library_Form__MessagePlaceholder__6qYVJ","Form__Submit":"cv-library_Form__Submit__ix_5w","Form__NormalLabel":"cv-library_Form__NormalLabel__oaxD4","AddInterview":"cv-library_AddInterview__8MA_o","IntegrationPage":"cv-library_IntegrationPage__e277C","Integration__BackStep":"cv-library_Integration__BackStep__yxXX_","AddUsers__BackStep":"cv-library_AddUsers__BackStep__ePUyJ","Integration__SubmitSection":"cv-library_Integration__SubmitSection__rjNR_","IntegrationTable":"cv-library_IntegrationTable__z5lG9","IntegrationTable__LimitInput":"cv-library_IntegrationTable__LimitInput__D328L","IntegrationTable__Type":"cv-library_IntegrationTable__Type__9TgMq","IntegrationTable__AllJobsToggle":"cv-library_IntegrationTable__AllJobsToggle__DQQyg","IntegrationTable__switch":"cv-library_IntegrationTable__switch__kc5R8","IntegrationTable__switchText":"cv-library_IntegrationTable__switchText__Lz6rl","IntegrationTable__slider":"cv-library_IntegrationTable__slider__vtlHl","IntegrationTable__round":"cv-library_IntegrationTable__round__mClve","IntegrationTable__Action":"cv-library_IntegrationTable__Action__NLHot","IntegrationView":"cv-library_IntegrationView__yjHhG","IntegrationView__Title":"cv-library_IntegrationView__Title__q3hh7","IntegrationView__Subheading":"cv-library_IntegrationView__Subheading__T0yNk","IntegrationView__BoxImage":"cv-library_IntegrationView__BoxImage__uoRJ6","IntegrationView__Box":"cv-library_IntegrationView__Box__Fpvxt","IntegrationView__BoxImage__InfoIcon":"cv-library_IntegrationView__BoxImage__InfoIcon__2FHmu","IntegrationView__ViewMoreButton":"cv-library_IntegrationView__ViewMoreButton__pHBbj","IntegrationView__ConnectButton":"cv-library_IntegrationView__ConnectButton__c1NqF","IntegrationView__GoogleButton":"cv-library_IntegrationView__GoogleButton__7Io0t","IntegrationView__FlexFlow":"cv-library_IntegrationView__FlexFlow__NUIdB","IntegrationView__BoxWidth":"cv-library_IntegrationView__BoxWidth__XbwxY","SkipFinishButton":"cv-library_SkipFinishButton__mm9q_","AddUsers":"cv-library_AddUsers__K_lbD","AddUsers__ButtonSection":"cv-library_AddUsers__ButtonSection__yYMv_","AddUsers__QuickStepHeading":"cv-library_AddUsers__QuickStepHeading__4zxgB","AddUsers__DeleteSection":"cv-library_AddUsers__DeleteSection__wZigP","AddUsers__DeleteCrossHeight":"cv-library_AddUsers__DeleteCrossHeight__GhZsQ","AddUsers__Form__Input":"cv-library_AddUsers__Form__Input__nscPm","AddUsers__FormHeadingSection":"cv-library_AddUsers__FormHeadingSection__L7L6t","AddUsers__FormSection":"cv-library_AddUsers__FormSection__nAhLO","NewJob__FormSection":"cv-library_NewJob__FormSection__EqhLE","AddUsers__ButtonsActionSection":"cv-library_AddUsers__ButtonsActionSection__s6fj9","AddUsers__ImportUsers":"cv-library_AddUsers__ImportUsers__mb0P7","AddUsers__NameInput":"cv-library_AddUsers__NameInput__RmvFA","AddUsers__EmailInput":"cv-library_AddUsers__EmailInput__qHdg7","AddUsers__RoleInput":"cv-library_AddUsers__RoleInput__axSXK","AddUsers__Subheading":"cv-library_AddUsers__Subheading__KcC4N","AddUsers__visible":"cv-library_AddUsers__visible__6nWk3","Tagrow":"cv-library_Tagrow__lQek2","Tagrow__Tags":"cv-library_Tagrow__Tags__KziPk","Tagrow__Cancel":"cv-library_Tagrow__Cancel__jvzjW","SendInviteSection":"cv-library_SendInviteSection__9UNWv","error":"cv-library_error__Q0K1J","ViewJobPage__Input":"cv-library_ViewJobPage__Input__bgZ3t","Form__Input2":"cv-library_Form__Input2__dOW6l","ViewJobPage__PostDay":"cv-library_ViewJobPage__PostDay__wNezy","ViewJobPage__Title":"cv-library_ViewJobPage__Title__1mGVv","ViewJobPage__DescriptionTitle":"cv-library_ViewJobPage__DescriptionTitle__fBvaV","ViewJobPage__Location":"cv-library_ViewJobPage__Location__Got7s","ViewJobPage__primarybtn":"cv-library_ViewJobPage__primarybtn__LrPqS","ViewJobPage__secondarybtn":"cv-library_ViewJobPage__secondarybtn__QvX2m","ViewJobPage__secondarybtnborder":"cv-library_ViewJobPage__secondarybtnborder__a1ci1","ViewJobPage__BackSection":"cv-library_ViewJobPage__BackSection__PhMte","ViewJobPage__Content":"cv-library_ViewJobPage__Content__dbPoq","ViewJobPage":"cv-library_ViewJobPage__XBRrk","ViewJobPage__Header":"cv-library_ViewJobPage__Header__Mdhnz","ViewJobPage__Application":"cv-library_ViewJobPage__Application__Y8JKk","ViewJobPage__RecordVideo":"cv-library_ViewJobPage__RecordVideo__35_0K","ViewJobPage__RecordVideoSuccessText":"cv-library_ViewJobPage__RecordVideoSuccessText__TyzOB","ViewJobPage__subheading":"cv-library_ViewJobPage__subheading__ACSRQ","ViewJobPage__confirmation":"cv-library_ViewJobPage__confirmation__Q43Ip","ViewJobPage__Logo":"cv-library_ViewJobPage__Logo__yl3cd","ViewJobPage__BrandLogo":"cv-library_ViewJobPage__BrandLogo__Zjmop","ViewJobPage__BrandLogo__Padding10":"cv-library_ViewJobPage__BrandLogo__Padding10__Of6S3","ViewJobPage__Container":"cv-library_ViewJobPage__Container__8h8yv","ViewJobPage__JobContent":"cv-library_ViewJobPage__JobContent__nb1ZJ","ViewJobPage__Sidebar":"cv-library_ViewJobPage__Sidebar__NyFhA","ViewJobPage__Sidebar2":"cv-library_ViewJobPage__Sidebar2__9HR4k","ViewJobPage__Description":"cv-library_ViewJobPage__Description__gvgoj","ViewJobPage__DescriptionWidth":"cv-library_ViewJobPage__DescriptionWidth__baLxz","ViewJobPage__Footer":"cv-library_ViewJobPage__Footer__O8mRX","ViewJobPage__FooterView":"cv-library_ViewJobPage__FooterView__UJDJB","ViewJobPage__ShareJob":"cv-library_ViewJobPage__ShareJob__JVCY_","ViewJobPage__SubmitSection":"cv-library_ViewJobPage__SubmitSection__s0bfX","ViewJobPage__SocialMedia":"cv-library_ViewJobPage__SocialMedia__wTes9","ViewJobPage__SideContent":"cv-library_ViewJobPage__SideContent__FMHV9","ViewJobPage__ApplySection":"cv-library_ViewJobPage__ApplySection__Daafm","FormBox__Autofill":"cv-library_FormBox__Autofill__i4PCi","applybuttons":"cv-library_applybuttons__NeZk_","height90":"cv-library_height90__8Jqvf","Form__Cont":"cv-library_Form__Cont__6Tkzs","Form__DropBox":"cv-library_Form__DropBox__YMPdv","Form__DropBoxcontainer":"cv-library_Form__DropBoxcontainer__CncP_","Form__DropBoxError":"cv-library_Form__DropBoxError__2i8IC","Form__DropBoxicon":"cv-library_Form__DropBoxicon__tJlSa","Form__DropBoxmessage":"cv-library_Form__DropBoxmessage__uTT1V","noDpGrid":"cv-library_noDpGrid__qerCj","Terms":"cv-library_Terms__yKJEC","TermsCondition":"cv-library_TermsCondition__AjnZY","TermsCondition__alignterms":"cv-library_TermsCondition__alignterms__G_hzc","MenuContainer":"cv-library_MenuContainer__QBsSz","MenuContainer__Menu":"cv-library_MenuContainer__Menu__BqbWa","AgencyDetailPage":"cv-library_AgencyDetailPage__9THG_","Congrats__ModalContent":"cv-library_Congrats__ModalContent__KjOAz","NewJob__Container":"cv-library_NewJob__Container__So6Ce","NewJob__TopSection":"cv-library_NewJob__TopSection__ggzPB","NewJob__HorizontalDivider":"cv-library_NewJob__HorizontalDivider__diDFy","NewJob__Wrapper":"cv-library_NewJob__Wrapper__mgN3E","NewJob__ContainerPadding":"cv-library_NewJob__ContainerPadding__jZ30o","NewJob__ContainerScroll":"cv-library_NewJob__ContainerScroll__ZQbON","NewJob__ContainerHeight":"cv-library_NewJob__ContainerHeight__MID34","NewJob__ImportAction":"cv-library_NewJob__ImportAction__SwDeF","NewJob__Interview_buttons":"cv-library_NewJob__Interview_buttons__T0Czm","Form__TableRowMB":"cv-library_Form__TableRowMB___Q4Pe","Form__TableRow3grid":"cv-library_Form__TableRow3grid___0mof","Form__Remotegrid":"cv-library_Form__Remotegrid__cO4Is","Form__TypeList":"cv-library_Form__TypeList__9ijHs","Form__Type":"cv-library_Form__Type__hEgpn","Form__CheckLabel":"cv-library_Form__CheckLabel__CBvXD","PrivateSwitchBase-root-1":"cv-library_PrivateSwitchBase-root-1__pIPu2","Form__Caption":"cv-library_Form__Caption__kXvv9","Form__Input_currency":"cv-library_Form__Input_currency__UDsTT","Form__Input_MatchScore":"cv-library_Form__Input_MatchScore___QKR5","Form__Percentage_Symbol":"cv-library_Form__Percentage_Symbol__adFxY","Form__NoGridTemplate":"cv-library_Form__NoGridTemplate__Gfy0v","active":"cv-library_active__jobST","mt10":"cv-library_mt10__d2unF","mt40":"cv-library_mt40__w_sXZ","mt30":"cv-library_mt30__DaXQu","mt32":"cv-library_mt32__jCZUC","mb0":"cv-library_mb0__f6CMQ","Dpgrid":"cv-library_Dpgrid__K4w9g","mb12":"cv-library_mb12__7KhRU","width100":"cv-library_width100__o728x","Tagrow__Prefix":"cv-library_Tagrow__Prefix__4H1nL","PreviewJobPage":"cv-library_PreviewJobPage__11v5_","PreviewJob":"cv-library_PreviewJob__XnTBc","DpFlx":"cv-library_DpFlx__3wieF","Subheading":"cv-library_Subheading__7Cb6A","Subheading__Description":"cv-library_Subheading__Description__fq8b0","Candidate__Tooltip":"cv-library_Candidate__Tooltip__Q9bNY","Candidate__Tooltip__Score":"cv-library_Candidate__Tooltip__Score__ll0sh","Form__InputField":"cv-library_Form__InputField__CgvSV","Candidate__Length":"cv-library_Candidate__Length__iTzJi","Agency__PostDay":"cv-library_Agency__PostDay__m6QFR","Agency__Title":"cv-library_Agency__Title__DCDCz","Agency__Location":"cv-library_Agency__Location__b7gCc","Agency__DescriptionTitle":"cv-library_Agency__DescriptionTitle__7YWT1","Agency__Description":"cv-library_Agency__Description__N_YJe","LightBlueColor":"cv-library_LightBlueColor__81S8Y","LoginModal":"cv-library_LoginModal__FRxKq","Logincontent":"cv-library_Logincontent__mhkcE","Logincontent__title":"cv-library_Logincontent__title__fHqbk","Modalbg":"cv-library_Modalbg___PLsz","Modalnobg":"cv-library_Modalnobg__JcvUz","Form__Container":"cv-library_Form__Container__BmVnX","Form__success":"cv-library_Form__success__IJyDi","Form__error":"cv-library_Form__error__GM_SC","Form__psw":"cv-library_Form__psw__5m_AJ","Form__CheckLabeltext":"cv-library_Form__CheckLabeltext__RKtMb","Form__TextLeft":"cv-library_Form__TextLeft__w1Z3F","Backsection":"cv-library_Backsection__IMJwc","back":"cv-library_back__Amo3t","mlr0":"cv-library_mlr0__EmAEE","TwoButtons":"cv-library_TwoButtons__vcxiA","OtpBacksection":"cv-library_OtpBacksection__HQU_T","CvModal":"cv-library_CvModal__dHUZQ","OtpBacksection2":"cv-library_OtpBacksection2__Z1_xf"};

/***/ }),

/***/ 19955:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Modalpopup":"delete-candidate-modal_Modalpopup__mbzTt","DeleteCandidateModal":"delete-candidate-modal_DeleteCandidateModal__iEYJ_","Modalpopup__inner":"delete-candidate-modal_Modalpopup__inner__iZOMI","DeleteCandidateModal__Inner":"delete-candidate-modal_DeleteCandidateModal__Inner__rcAfg","Modalpopup__Dialog":"delete-candidate-modal_Modalpopup__Dialog___k6MV","transition":"delete-candidate-modal_transition__qB3Rn","Modalpopup__CloseCenter":"delete-candidate-modal_Modalpopup__CloseCenter__Qp4Vv","Modalpopup__Content":"delete-candidate-modal_Modalpopup__Content__WUmEv","Modalpopup__btn":"delete-candidate-modal_Modalpopup__btn__hfIYv","mar":"delete-candidate-modal_mar__Tgkwz","Otpback":"delete-candidate-modal_Otpback__iwDjY","Form":"delete-candidate-modal_Form__5xkXa","Form__width":"delete-candidate-modal_Form__width__JCIm8","Form__label":"delete-candidate-modal_Form__label__Tth5s","Form__textleft":"delete-candidate-modal_Form__textleft__AWaAQ","Form__InputFullWidth":"delete-candidate-modal_Form__InputFullWidth__zsL28","Form__Input":"delete-candidate-modal_Form__Input__NASS4","Form__InputSection":"delete-candidate-modal_Form__InputSection__qcOAr","Form__ScoreCardInput":"delete-candidate-modal_Form__ScoreCardInput__5pbLi","Form__Textarea":"delete-candidate-modal_Form__Textarea__rfgqf","primarybtn":"delete-candidate-modal_primarybtn__Ej6ZY","secondarybtn":"delete-candidate-modal_secondarybtn__4lkfh","iconFilled":"delete-candidate-modal_iconFilled__Iagm1","iconFilledSolid":"delete-candidate-modal_iconFilledSolid__uyBw3","primarybtnborder":"delete-candidate-modal_primarybtnborder__ztUCp","secondarybtnborder":"delete-candidate-modal_secondarybtnborder__0fr04","tertiarybtn":"delete-candidate-modal_tertiarybtn__fIrZ6","graybtnborder":"delete-candidate-modal_graybtnborder__jpsZK","jobsrchbtn":"delete-candidate-modal_jobsrchbtn__7Kcsx","jobsrchbtnalign":"delete-candidate-modal_jobsrchbtnalign__vO79h","nobgbutton":"delete-candidate-modal_nobgbutton__9pgrw","iconTextButton":"delete-candidate-modal_iconTextButton__MQx3P","cursornone":"delete-candidate-modal_cursornone__FIB9n","nobgbuttonprimary":"delete-candidate-modal_nobgbuttonprimary__vvpc0","mt15":"delete-candidate-modal_mt15__Z__mD","btn350":"delete-candidate-modal_btn350__A7gfI","GrayBgBtn":"delete-candidate-modal_GrayBgBtn__cogHX","NewShareBtn":"delete-candidate-modal_NewShareBtn__BPoE0","CoralBgBtn":"delete-candidate-modal_CoralBgBtn__7PRRZ","SetupPopup__PaddingPopup":"delete-candidate-modal_SetupPopup__PaddingPopup___p1JE","SetupPopup__ContentCustomisation":"delete-candidate-modal_SetupPopup__ContentCustomisation__TvoRQ","SetupPopup__Contentwithoutpadding":"delete-candidate-modal_SetupPopup__Contentwithoutpadding__uUJ9z","Form__Input398":"delete-candidate-modal_Form__Input398__siWCe","GoBtn":"delete-candidate-modal_GoBtn___jT2C","ClearBtn":"delete-candidate-modal_ClearBtn__kk_mR","DropContainer":"delete-candidate-modal_DropContainer__C76A7","DropContainer__Inner":"delete-candidate-modal_DropContainer__Inner__9lyOY","CompanyProfile__Inner":"delete-candidate-modal_CompanyProfile__Inner__yojWW","DropContainer__Message":"delete-candidate-modal_DropContainer__Message__kPJfY","CompanyProfile__Message":"delete-candidate-modal_CompanyProfile__Message__iHM15","CompanyProfile__MessageContent":"delete-candidate-modal_CompanyProfile__MessageContent__qWj47","DropContainer__UploadIcon":"delete-candidate-modal_DropContainer__UploadIcon__8tw9x","CompanyProfile__UploadIcon":"delete-candidate-modal_CompanyProfile__UploadIcon__N4zOb","FileDisplayContainer":"delete-candidate-modal_FileDisplayContainer__Vwyot","FileDisplayContainer__Status":"delete-candidate-modal_FileDisplayContainer__Status__f3T4f","SetupPopup__Status":"delete-candidate-modal_SetupPopup__Status__ntzI_","SetupPopup__To":"delete-candidate-modal_SetupPopup__To__qUgR4","FileDisplayContainer__Type":"delete-candidate-modal_FileDisplayContainer__Type__PjX_h","FileDisplayContainer__Name":"delete-candidate-modal_FileDisplayContainer__Name__Lw_jr","SetupPopup__Name":"delete-candidate-modal_SetupPopup__Name__0qC_h","SetupPopup__ToName":"delete-candidate-modal_SetupPopup__ToName__SGOky","FileDisplayContainer__Error":"delete-candidate-modal_FileDisplayContainer__Error__pzlgD","FileDisplayContainer__Close":"delete-candidate-modal_FileDisplayContainer__Close__4bYMM","Browse":"delete-candidate-modal_Browse__LikRg","ClientCompany":"delete-candidate-modal_ClientCompany__YOof7","NewJob":"delete-candidate-modal_NewJob__PpPWE","Interview":"delete-candidate-modal_Interview__YWH2S","ClientCompany__TopSection2":"delete-candidate-modal_ClientCompany__TopSection2__EauWg","ClientCompany__Filter":"delete-candidate-modal_ClientCompany__Filter__syn2g","ClientCompany__Input_MatchScore":"delete-candidate-modal_ClientCompany__Input_MatchScore__FmT2P","ClientCompany__Percentage_Symbol":"delete-candidate-modal_ClientCompany__Percentage_Symbol___jkci","ClientCompany__Filterheading":"delete-candidate-modal_ClientCompany__Filterheading__4nP9t","ClientCompany__FloatButtonAdd":"delete-candidate-modal_ClientCompany__FloatButtonAdd__9KFlQ","ClientCompany__FloatButtonAdd__AgencyUserIcon":"delete-candidate-modal_ClientCompany__FloatButtonAdd__AgencyUserIcon__1QBB7","ClientCompany__LastEdited":"delete-candidate-modal_ClientCompany__LastEdited__Vr19t","ClientCompany__BackSection":"delete-candidate-modal_ClientCompany__BackSection__YbB2D","AddUsers__BackSection":"delete-candidate-modal_AddUsers__BackSection__zbUJ2","ClientCompany__BackSection__CloseIcon":"delete-candidate-modal_ClientCompany__BackSection__CloseIcon__VopUl","ClientCompany__Container":"delete-candidate-modal_ClientCompany__Container__jvA0e","NewJob__InterviewContainer":"delete-candidate-modal_NewJob__InterviewContainer__nDmVx","AddUsers__Container":"delete-candidate-modal_AddUsers__Container__Dixtw","ClientCompany__FormInputSection":"delete-candidate-modal_ClientCompany__FormInputSection__OordO","CompanyProfile__FormInputSection":"delete-candidate-modal_CompanyProfile__FormInputSection__i85Ws","ClientCompany__Heading":"delete-candidate-modal_ClientCompany__Heading__rdHZe","AddUsers__Heading":"delete-candidate-modal_AddUsers__Heading__gBSB1","ClientCompany__StatusAlignment":"delete-candidate-modal_ClientCompany__StatusAlignment__MTL9K","ClientCompany__Status":"delete-candidate-modal_ClientCompany__Status__WQjFe","ClientCompany__ActiveDot":"delete-candidate-modal_ClientCompany__ActiveDot__lPgdK","ClientCompany__CloseDot":"delete-candidate-modal_ClientCompany__CloseDot__pLX9H","ClientCompany__Company":"delete-candidate-modal_ClientCompany__Company__lrnWL","AddUsers__User":"delete-candidate-modal_AddUsers__User__zZ2Ep","ClientCompany__Systemrefheding":"delete-candidate-modal_ClientCompany__Systemrefheding__Hyco9","ClientCompany__Subheading":"delete-candidate-modal_ClientCompany__Subheading__LfmlY","CompanyProfile__Subheading":"delete-candidate-modal_CompanyProfile__Subheading__naRV2","ClientCompany__Subheading2":"delete-candidate-modal_ClientCompany__Subheading2__xnqaJ","ClientCompany__Description":"delete-candidate-modal_ClientCompany__Description__nquDM","ClientCompany__SubmitSection":"delete-candidate-modal_ClientCompany__SubmitSection__nJR6G","NewJob__SubmitSection":"delete-candidate-modal_NewJob__SubmitSection__tLVaC","NewJob__SubmitSectionThreeBtn":"delete-candidate-modal_NewJob__SubmitSectionThreeBtn__yuiIh","NewJob__SubmitSectionOneBtnPlacement":"delete-candidate-modal_NewJob__SubmitSectionOneBtnPlacement__zFNyE","NewJob__ImportSection":"delete-candidate-modal_NewJob__ImportSection__QHX41","SetupPopup__SubmitSection2":"delete-candidate-modal_SetupPopup__SubmitSection2__bl_Fh","SetupPopup__SubmitSection":"delete-candidate-modal_SetupPopup__SubmitSection__6tqBq","SetupPopup__SubmitSection3":"delete-candidate-modal_SetupPopup__SubmitSection3__uTlSv","AddUsers__SubmitSection":"delete-candidate-modal_AddUsers__SubmitSection___pXFl","ClientCompany__IntegrationImage":"delete-candidate-modal_ClientCompany__IntegrationImage__8EW_q","ClientCompany__QuickAdd":"delete-candidate-modal_ClientCompany__QuickAdd__SmdHY","NewJob__QuickAdd":"delete-candidate-modal_NewJob__QuickAdd__rPcgZ","Interview__QuickAdd":"delete-candidate-modal_Interview__QuickAdd__d2X2W","ClientCompany__BodyText":"delete-candidate-modal_ClientCompany__BodyText__wGJyu","Form__TableRow":"delete-candidate-modal_Form__TableRow__mArd9","Form__Label":"delete-candidate-modal_Form__Label__NxFuM","Form__FloatingLabel":"delete-candidate-modal_Form__FloatingLabel__KfSI3","Form__TableCol":"delete-candidate-modal_Form__TableCol__B_4mF","Form__currency_symbol":"delete-candidate-modal_Form__currency_symbol__UI3NH","Form__CustomSelect":"delete-candidate-modal_Form__CustomSelect__yc6B_","Form__currency_symbol__right":"delete-candidate-modal_Form__currency_symbol__right__N3KUC","Form__TableCol__Disabled":"delete-candidate-modal_Form__TableCol__Disabled__yz2bw","Form__TextareaDisabled":"delete-candidate-modal_Form__TextareaDisabled__xs3WB","Form__EditorDisabled":"delete-candidate-modal_Form__EditorDisabled__pZ7S2","Form__AdminCheckLabel":"delete-candidate-modal_Form__AdminCheckLabel__w9ot4","Form__AdminCheckMargin":"delete-candidate-modal_Form__AdminCheckMargin__Shb42","CompanyProfile__BrandingGuide":"delete-candidate-modal_CompanyProfile__BrandingGuide__Y6NUE","CompanyProfile__DropBoxContainer":"delete-candidate-modal_CompanyProfile__DropBoxContainer__wYTKS","CompanyProfile__Browse":"delete-candidate-modal_CompanyProfile__Browse__ylaWy","ErrorLabel":"delete-candidate-modal_ErrorLabel__k5Po3","Height80":"delete-candidate-modal_Height80__Jk_E_","Browse__ButtonFlexEnd":"delete-candidate-modal_Browse__ButtonFlexEnd__9kC_G","AddAgency__Container":"delete-candidate-modal_AddAgency__Container__m14cq","AddAgency__FormInputSection":"delete-candidate-modal_AddAgency__FormInputSection__hsN_P","AddAgency__FormInputSection__Label":"delete-candidate-modal_AddAgency__FormInputSection__Label____rkz","AddAgency__Form":"delete-candidate-modal_AddAgency__Form__vf_kb","LinkAsButtons":"delete-candidate-modal_LinkAsButtons__rEkhV","SearchFlex":"delete-candidate-modal_SearchFlex__6Ns0_","Form__ErrorCustomSelect":"delete-candidate-modal_Form__ErrorCustomSelect__eD2I0","Form__select_currency":"delete-candidate-modal_Form__select_currency__Q_NMR","customSelect__placeholder":"delete-candidate-modal_customSelect__placeholder__B0lUb","Career":"delete-candidate-modal_Career__hXayg","Career__Background_Edit":"delete-candidate-modal_Career__Background_Edit__alBxv","Career__Background_Edit_Image":"delete-candidate-modal_Career__Background_Edit_Image__9j8sm","Career__Container":"delete-candidate-modal_Career__Container__LUCMg","Career__Inner":"delete-candidate-modal_Career__Inner__fCO1Y","Career__logo":"delete-candidate-modal_Career__logo__og023","Career__Content":"delete-candidate-modal_Career__Content__2D414","Career__ButtonSection":"delete-candidate-modal_Career__ButtonSection__SFvbm","Job":"delete-candidate-modal_Job__mctP2","Job__Inner":"delete-candidate-modal_Job__Inner__A4iG5","Job__Container":"delete-candidate-modal_Job__Container__bKX7t","Job__Heading":"delete-candidate-modal_Job__Heading__xJC9h","Job__Company":"delete-candidate-modal_Job__Company__M1mi8","Job__SearchContainer":"delete-candidate-modal_Job__SearchContainer__Gqdie","Job__SearchInput":"delete-candidate-modal_Job__SearchInput___EBcy","Job__Searchbtn":"delete-candidate-modal_Job__Searchbtn__SUhnd","Job__Input":"delete-candidate-modal_Job__Input__Vkten","Job__SelectJob":"delete-candidate-modal_Job__SelectJob__Ku9S1","Job__RemoteLabel":"delete-candidate-modal_Job__RemoteLabel__S_yOB","Job__Display":"delete-candidate-modal_Job__Display__Z7eVj","Job__PostDay":"delete-candidate-modal_Job__PostDay__wo3Jy","Job__Title":"delete-candidate-modal_Job__Title__FkrmJ","Job__Location":"delete-candidate-modal_Job__Location__o2gka","DT":"delete-candidate-modal_DT___1Yob","DisplayTable":"delete-candidate-modal_DisplayTable__46KNQ","pd11":"delete-candidate-modal_pd11__5685_","Label":"delete-candidate-modal_Label__Z3UGj","inputwidth":"delete-candidate-modal_inputwidth__3Wu8Q","mr24":"delete-candidate-modal_mr24__N7QnV","fullwidth":"delete-candidate-modal_fullwidth__kdIVp","padt40":"delete-candidate-modal_padt40__B7rde","Form__TableRowflex":"delete-candidate-modal_Form__TableRowflex__oxtK5","Form__TableColm":"delete-candidate-modal_Form__TableColm__y_kCW","Form__LabelCheck":"delete-candidate-modal_Form__LabelCheck__Yl7AE","Form__Error":"delete-candidate-modal_Form__Error__kDg_U","Form__ErrorSection":"delete-candidate-modal_Form__ErrorSection__o4CZv","Form__MessagePlaceholder":"delete-candidate-modal_Form__MessagePlaceholder__TZys7","Form__Submit":"delete-candidate-modal_Form__Submit__o0F3S","Form__NormalLabel":"delete-candidate-modal_Form__NormalLabel__1yLUi","AddInterview":"delete-candidate-modal_AddInterview__GYqjw","IntegrationPage":"delete-candidate-modal_IntegrationPage__1zozj","Integration__BackStep":"delete-candidate-modal_Integration__BackStep___hoJr","AddUsers__BackStep":"delete-candidate-modal_AddUsers__BackStep__n1Wg6","Integration__SubmitSection":"delete-candidate-modal_Integration__SubmitSection__HyUQu","IntegrationTable":"delete-candidate-modal_IntegrationTable__ZrjOs","IntegrationTable__LimitInput":"delete-candidate-modal_IntegrationTable__LimitInput__ro1h_","IntegrationTable__Type":"delete-candidate-modal_IntegrationTable__Type__0dBZ6","IntegrationTable__AllJobsToggle":"delete-candidate-modal_IntegrationTable__AllJobsToggle__leOz2","IntegrationTable__switch":"delete-candidate-modal_IntegrationTable__switch__uR3Yx","IntegrationTable__switchText":"delete-candidate-modal_IntegrationTable__switchText__U2Ofq","IntegrationTable__slider":"delete-candidate-modal_IntegrationTable__slider__mDvge","IntegrationTable__round":"delete-candidate-modal_IntegrationTable__round__WJzlM","IntegrationTable__Action":"delete-candidate-modal_IntegrationTable__Action__Vxwoh","IntegrationView":"delete-candidate-modal_IntegrationView__lG4sB","IntegrationView__Title":"delete-candidate-modal_IntegrationView__Title__J660x","IntegrationView__Subheading":"delete-candidate-modal_IntegrationView__Subheading__DH_bp","IntegrationView__BoxImage":"delete-candidate-modal_IntegrationView__BoxImage__NZpq3","IntegrationView__Box":"delete-candidate-modal_IntegrationView__Box__fJ2Ab","IntegrationView__BoxImage__InfoIcon":"delete-candidate-modal_IntegrationView__BoxImage__InfoIcon__Hn4x6","IntegrationView__ViewMoreButton":"delete-candidate-modal_IntegrationView__ViewMoreButton__LGNgj","IntegrationView__ConnectButton":"delete-candidate-modal_IntegrationView__ConnectButton___t_gK","IntegrationView__GoogleButton":"delete-candidate-modal_IntegrationView__GoogleButton__bURuz","IntegrationView__FlexFlow":"delete-candidate-modal_IntegrationView__FlexFlow__Xp_WW","IntegrationView__BoxWidth":"delete-candidate-modal_IntegrationView__BoxWidth__alYcu","SkipFinishButton":"delete-candidate-modal_SkipFinishButton__ds89R","AddUsers":"delete-candidate-modal_AddUsers__5ce3R","AddUsers__ButtonSection":"delete-candidate-modal_AddUsers__ButtonSection__uDlgc","AddUsers__QuickStepHeading":"delete-candidate-modal_AddUsers__QuickStepHeading__vKHmA","AddUsers__DeleteSection":"delete-candidate-modal_AddUsers__DeleteSection__0APcp","Interview__DeleteSection":"delete-candidate-modal_Interview__DeleteSection__C76wF","AddUsers__DeleteCrossHeight":"delete-candidate-modal_AddUsers__DeleteCrossHeight__b_kBs","AddUsers__Form__Input":"delete-candidate-modal_AddUsers__Form__Input__xT9jc","AddUsers__FormHeadingSection":"delete-candidate-modal_AddUsers__FormHeadingSection__1mb8_","Interview__FormHeadingSection":"delete-candidate-modal_Interview__FormHeadingSection__ezDuW","AddUsers__FormSection":"delete-candidate-modal_AddUsers__FormSection__2JbT7","NewJob__FormSection":"delete-candidate-modal_NewJob__FormSection__Uwxiz","AddUsers__ButtonsActionSection":"delete-candidate-modal_AddUsers__ButtonsActionSection__LjcH6","AddUsers__ImportUsers":"delete-candidate-modal_AddUsers__ImportUsers__eXQwq","AddUsers__NameInput":"delete-candidate-modal_AddUsers__NameInput__cU58n","AddUsers__EmailInput":"delete-candidate-modal_AddUsers__EmailInput__bQjMk","AddUsers__RoleInput":"delete-candidate-modal_AddUsers__RoleInput__kzHPR","AddUsers__Subheading":"delete-candidate-modal_AddUsers__Subheading__kFdaz","AddUsers__visible":"delete-candidate-modal_AddUsers__visible__Rj5zx","Tagrow":"delete-candidate-modal_Tagrow__xzbhV","Tagrow__Tags":"delete-candidate-modal_Tagrow__Tags__1jiCP","SetupPopup__Tags":"delete-candidate-modal_SetupPopup__Tags__4ynzF","Tagrow__Cancel":"delete-candidate-modal_Tagrow__Cancel__QiYtf","Tagrow__Cross":"delete-candidate-modal_Tagrow__Cross__97Q5y","SendInviteSection":"delete-candidate-modal_SendInviteSection__AFxss","error":"delete-candidate-modal_error__zGnbk","ViewJobPage__Input":"delete-candidate-modal_ViewJobPage__Input__85k21","Form__Input2":"delete-candidate-modal_Form__Input2__Sf3EJ","ViewJobPage__PostDay":"delete-candidate-modal_ViewJobPage__PostDay__dBAL3","ViewJobPage__Title":"delete-candidate-modal_ViewJobPage__Title__9zZc1","ViewJobPage__DescriptionTitle":"delete-candidate-modal_ViewJobPage__DescriptionTitle__1E2fb","ViewJobPage__Location":"delete-candidate-modal_ViewJobPage__Location__RWz0f","ViewJobPage__primarybtn":"delete-candidate-modal_ViewJobPage__primarybtn__DkNrF","ViewJobPage__secondarybtn":"delete-candidate-modal_ViewJobPage__secondarybtn___9QSL","ViewJobPage__secondarybtnborder":"delete-candidate-modal_ViewJobPage__secondarybtnborder__Vi9d_","ViewJobPage__BackSection":"delete-candidate-modal_ViewJobPage__BackSection__yxEoH","ViewJobPage__Content":"delete-candidate-modal_ViewJobPage__Content__MjKFc","ViewJobPage":"delete-candidate-modal_ViewJobPage__y9Txq","ViewJobPage__Header":"delete-candidate-modal_ViewJobPage__Header__YSE5c","ViewJobPage__Application":"delete-candidate-modal_ViewJobPage__Application__tuC3t","ViewJobPage__RecordVideo":"delete-candidate-modal_ViewJobPage__RecordVideo__nVuJV","ViewJobPage__RecordVideoSuccessText":"delete-candidate-modal_ViewJobPage__RecordVideoSuccessText__bbtDK","ViewJobPage__subheading":"delete-candidate-modal_ViewJobPage__subheading__v_w6K","ViewJobPage__confirmation":"delete-candidate-modal_ViewJobPage__confirmation__UWGdC","ViewJobPage__Logo":"delete-candidate-modal_ViewJobPage__Logo__ANbIe","ViewJobPage__BrandLogo":"delete-candidate-modal_ViewJobPage__BrandLogo__sM8ep","ViewJobPage__BrandLogo__Padding10":"delete-candidate-modal_ViewJobPage__BrandLogo__Padding10__4Cr2S","ViewJobPage__Container":"delete-candidate-modal_ViewJobPage__Container__5i5IR","ViewJobPage__JobContent":"delete-candidate-modal_ViewJobPage__JobContent__oHR1O","ViewJobPage__Sidebar":"delete-candidate-modal_ViewJobPage__Sidebar__aCKEE","ViewJobPage__Sidebar2":"delete-candidate-modal_ViewJobPage__Sidebar2__lK7d_","ViewJobPage__Description":"delete-candidate-modal_ViewJobPage__Description__Jvv9l","ViewJobPage__DescriptionWidth":"delete-candidate-modal_ViewJobPage__DescriptionWidth__z6QOD","ViewJobPage__Footer":"delete-candidate-modal_ViewJobPage__Footer__PQoGR","ViewJobPage__FooterView":"delete-candidate-modal_ViewJobPage__FooterView__9P2Y_","ViewJobPage__ShareJob":"delete-candidate-modal_ViewJobPage__ShareJob__g3237","ViewJobPage__SubmitSection":"delete-candidate-modal_ViewJobPage__SubmitSection__yvZeE","ViewJobPage__SocialMedia":"delete-candidate-modal_ViewJobPage__SocialMedia__i22XB","ViewJobPage__SideContent":"delete-candidate-modal_ViewJobPage__SideContent__ly8i7","ViewJobPage__ApplySection":"delete-candidate-modal_ViewJobPage__ApplySection__9LpYX","FormBox__Autofill":"delete-candidate-modal_FormBox__Autofill__SJ8Cd","applybuttons":"delete-candidate-modal_applybuttons__g8WMg","height90":"delete-candidate-modal_height90__4Z07A","Form__Cont":"delete-candidate-modal_Form__Cont__E454N","Form__DropBox":"delete-candidate-modal_Form__DropBox__d1mWn","Form__DropBoxcontainer":"delete-candidate-modal_Form__DropBoxcontainer__iN8r8","Form__DropBoxError":"delete-candidate-modal_Form__DropBoxError__XzN0j","Form__DropBoxicon":"delete-candidate-modal_Form__DropBoxicon__HssY9","Form__DropBoxmessage":"delete-candidate-modal_Form__DropBoxmessage__PUeW2","noDpGrid":"delete-candidate-modal_noDpGrid___e3LY","Terms":"delete-candidate-modal_Terms__2ViPt","TermsCondition":"delete-candidate-modal_TermsCondition__0aHXU","TermsCondition__alignterms":"delete-candidate-modal_TermsCondition__alignterms__hNjmU","MenuContainer":"delete-candidate-modal_MenuContainer__tayUg","MenuContainer__Menu":"delete-candidate-modal_MenuContainer__Menu__hGs6L","AgencyDetailPage":"delete-candidate-modal_AgencyDetailPage__4X60P","Congrats__ModalContent":"delete-candidate-modal_Congrats__ModalContent__KXUIR","NewJob__Container":"delete-candidate-modal_NewJob__Container__NiZ6O","NewJob__TopSection":"delete-candidate-modal_NewJob__TopSection__j1fQb","Interview__TopSection":"delete-candidate-modal_Interview__TopSection__OZ5ld","NewJob__HorizontalDivider":"delete-candidate-modal_NewJob__HorizontalDivider__WV5Cg","NewJob__Wrapper":"delete-candidate-modal_NewJob__Wrapper__Z2I3L","NewJob__ContainerPadding":"delete-candidate-modal_NewJob__ContainerPadding__LKmyY","NewJob__ContainerScroll":"delete-candidate-modal_NewJob__ContainerScroll__JeK_l","NewJob__ContainerHeight":"delete-candidate-modal_NewJob__ContainerHeight__RcTHw","NewJob__ImportAction":"delete-candidate-modal_NewJob__ImportAction__e94_u","NewJob__Interview_buttons":"delete-candidate-modal_NewJob__Interview_buttons__UuJUE","Form__TableRowMB":"delete-candidate-modal_Form__TableRowMB__qBF6F","Form__TableRow3grid":"delete-candidate-modal_Form__TableRow3grid__M6BYO","Form__Remotegrid":"delete-candidate-modal_Form__Remotegrid__PPLoa","Form__TypeList":"delete-candidate-modal_Form__TypeList__yj62P","Form__Type":"delete-candidate-modal_Form__Type__zNEPg","Form__CheckLabel":"delete-candidate-modal_Form__CheckLabel__F4gDX","PrivateSwitchBase-root-1":"delete-candidate-modal_PrivateSwitchBase-root-1__7j167","Form__Caption":"delete-candidate-modal_Form__Caption__90Nyh","Form__Input_currency":"delete-candidate-modal_Form__Input_currency__H8PyH","Form__Input_MatchScore":"delete-candidate-modal_Form__Input_MatchScore__Ol0NX","Form__Percentage_Symbol":"delete-candidate-modal_Form__Percentage_Symbol__5gOPj","Form__NoGridTemplate":"delete-candidate-modal_Form__NoGridTemplate__StyrV","active":"delete-candidate-modal_active__oWG9R","mt10":"delete-candidate-modal_mt10__IU5CQ","mt40":"delete-candidate-modal_mt40__6Dxpy","mt30":"delete-candidate-modal_mt30__vHrzO","mt32":"delete-candidate-modal_mt32__EAizz","mb0":"delete-candidate-modal_mb0__npD3H","Dpgrid":"delete-candidate-modal_Dpgrid__DEvhq","mb12":"delete-candidate-modal_mb12__dKxwP","width100":"delete-candidate-modal_width100__2go0I","Tagrow__Prefix":"delete-candidate-modal_Tagrow__Prefix___mAIZ","PreviewJobPage":"delete-candidate-modal_PreviewJobPage__AvjsT","PreviewJob":"delete-candidate-modal_PreviewJob__t9uTD","DpFlx":"delete-candidate-modal_DpFlx__oKlbI","Subheading":"delete-candidate-modal_Subheading__bVEsw","Subheading__Description":"delete-candidate-modal_Subheading__Description__b7qDp","Candidate__Tooltip":"delete-candidate-modal_Candidate__Tooltip__rOaph","Candidate__Tooltip__Score":"delete-candidate-modal_Candidate__Tooltip__Score__ySDxX","Form__InputField":"delete-candidate-modal_Form__InputField___Pix8","Candidate__Length":"delete-candidate-modal_Candidate__Length__La_2h","Agency__PostDay":"delete-candidate-modal_Agency__PostDay__8VKh3","Agency__Title":"delete-candidate-modal_Agency__Title__XA0a4","Agency__Location":"delete-candidate-modal_Agency__Location__hcYzy","Agency__DescriptionTitle":"delete-candidate-modal_Agency__DescriptionTitle__szWF8","Agency__Description":"delete-candidate-modal_Agency__Description__IDHgo","LightBlueColor":"delete-candidate-modal_LightBlueColor__q4EdI","Client_Page":"delete-candidate-modal_Client_Page__cPlN5","Welcome":"delete-candidate-modal_Welcome__IZ_Pt","Welcome__Inner":"delete-candidate-modal_Welcome__Inner__erHmP","Welcome__Person":"delete-candidate-modal_Welcome__Person__X7kZ_","Welcome__LeftContent":"delete-candidate-modal_Welcome__LeftContent__mWXc4","Welcome__RightContent":"delete-candidate-modal_Welcome__RightContent__PuU3H","Welcome__Content":"delete-candidate-modal_Welcome__Content__HZ_Qx","Welcome__CreateAccount":"delete-candidate-modal_Welcome__CreateAccount__b39Om","Welcome__title":"delete-candidate-modal_Welcome__title__DVVk5","Welcome__FormBox":"delete-candidate-modal_Welcome__FormBox__RVy7Q","Form__psw":"delete-candidate-modal_Form__psw__fMQJp","Welcome__Container":"delete-candidate-modal_Welcome__Container__y3X0U","Success__Container":"delete-candidate-modal_Success__Container__ZVehN","Success":"delete-candidate-modal_Success__hBbDB","Success__Inner":"delete-candidate-modal_Success__Inner__JS2Jy","InterviewContainer":"delete-candidate-modal_InterviewContainer__nEIWT","Interview__Stages":"delete-candidate-modal_Interview__Stages__6QzW6","Interview__StageHeading":"delete-candidate-modal_Interview__StageHeading__fBvhb","pl10":"delete-candidate-modal_pl10__xWuTU","Interview__AddStageSection":"delete-candidate-modal_Interview__AddStageSection__fx2OA","Interview__Label":"delete-candidate-modal_Interview__Label__GSOTs","Interview__FormRowHeading":"delete-candidate-modal_Interview__FormRowHeading__Yeibi","dpflex":"delete-candidate-modal_dpflex__IMHHr","Interview__IconsType":"delete-candidate-modal_Interview__IconsType__rFq_D","Interview__Icons":"delete-candidate-modal_Interview__Icons__T03Qc","Interview__Interview_buttons":"delete-candidate-modal_Interview__Interview_buttons___iZ88","Interview__approvalButton":"delete-candidate-modal_Interview__approvalButton__rvK5o","Interview__BestMatch":"delete-candidate-modal_Interview__BestMatch__4OhyH","Interview__BestMatchExclamation":"delete-candidate-modal_Interview__BestMatchExclamation__HNxRL","DragAndDrop":"delete-candidate-modal_DragAndDrop__a748f","DragAndDrop__CursorHandle":"delete-candidate-modal_DragAndDrop__CursorHandle__2wvdR","Tagrow__Image":"delete-candidate-modal_Tagrow__Image__D3sry","rowbglight":"delete-candidate-modal_rowbglight___LUQR","rowbgheight":"delete-candidate-modal_rowbgheight__1V395","Form__w90":"delete-candidate-modal_Form__w90__K6Tg4","Container":"delete-candidate-modal_Container__wDolx","Screening__StageName":"delete-candidate-modal_Screening__StageName__ruAja","Screening__InterviewType":"delete-candidate-modal_Screening__InterviewType__Q_Qqh","Screening__InterviewType__Label":"delete-candidate-modal_Screening__InterviewType__Label__eV46b","Show_Infoicon":"delete-candidate-modal_Show_Infoicon__e3FA8","Show_Infoicon_small":"delete-candidate-modal_Show_Infoicon_small__2B2qu","Screening__Info":"delete-candidate-modal_Screening__Info__Sb5Ox","Screening__Info__IconWithText":"delete-candidate-modal_Screening__Info__IconWithText__R2ZV6","InterviewType__Icon":"delete-candidate-modal_InterviewType__Icon__i9Utd","InterviewType__Text":"delete-candidate-modal_InterviewType__Text__6sbzI","LoginModal":"delete-candidate-modal_LoginModal__Rh3Ec","Logincontent":"delete-candidate-modal_Logincontent__leqkY","Logincontent__title":"delete-candidate-modal_Logincontent__title__GGRgP","Modalbg":"delete-candidate-modal_Modalbg__m2HTQ","Modalnobg":"delete-candidate-modal_Modalnobg__eRKds","Form__Container":"delete-candidate-modal_Form__Container__YFMab","Form__success":"delete-candidate-modal_Form__success___wrWH","Form__error":"delete-candidate-modal_Form__error__KJxJA","Form__CheckLabeltext":"delete-candidate-modal_Form__CheckLabeltext__MbXqD","Form__TextLeft":"delete-candidate-modal_Form__TextLeft__bNBzz","Backsection":"delete-candidate-modal_Backsection__sRfMP","back":"delete-candidate-modal_back__MEgyi","mlr0":"delete-candidate-modal_mlr0__UqRsl","TwoButtons":"delete-candidate-modal_TwoButtons__WNVMe","OtpBacksection":"delete-candidate-modal_OtpBacksection__iub48","SetupPopup":"delete-candidate-modal_SetupPopup__B8s24","SetupPopup__inner":"delete-candidate-modal_SetupPopup__inner__tLH0V","SetupPopup__Dialog":"delete-candidate-modal_SetupPopup__Dialog__r50_x","SetupPopup__AddFile":"delete-candidate-modal_SetupPopup__AddFile__90I4o","SetupPopup__OptionalText":"delete-candidate-modal_SetupPopup__OptionalText__14OyW","SetupPopup__RequestAccessBtn":"delete-candidate-modal_SetupPopup__RequestAccessBtn__LUN8p","SetupPopup__InternalSection":"delete-candidate-modal_SetupPopup__InternalSection__qrjCm","SetupPopup__ContentInnerRow":"delete-candidate-modal_SetupPopup__ContentInnerRow__Jh9TZ","SetupPopup__ToChips":"delete-candidate-modal_SetupPopup__ToChips__8SyjD","SetupPopup__AttachmentContainer":"delete-candidate-modal_SetupPopup__AttachmentContainer__g1TG3","SetupPopup__ContentInnerCol":"delete-candidate-modal_SetupPopup__ContentInnerCol__zonEz","SetupPopup__grid":"delete-candidate-modal_SetupPopup__grid__Dtp03","SetupPopup__Footer":"delete-candidate-modal_SetupPopup__Footer__OmFlG","SetupPopup__FooterNew":"delete-candidate-modal_SetupPopup__FooterNew__qPgBU","SetupPopup__Footer2":"delete-candidate-modal_SetupPopup__Footer2__iylq5","SetupPopup__Footer3":"delete-candidate-modal_SetupPopup__Footer3__iWKqF","SetupPopup__Footerassess":"delete-candidate-modal_SetupPopup__Footerassess__M1bTH","SetupPopup__Footertechtest":"delete-candidate-modal_SetupPopup__Footertechtest__w2v0A","SetupPopup__AutommationFooter":"delete-candidate-modal_SetupPopup__AutommationFooter__Xq2ie","SetupPopup__MannualFooter":"delete-candidate-modal_SetupPopup__MannualFooter__tpDyH","SetupPopup__MannualInnerSection":"delete-candidate-modal_SetupPopup__MannualInnerSection__Hiwtn","SetupPopup__Content":"delete-candidate-modal_SetupPopup__Content__D5sr4","SetupPopup__Content__Radiobtn":"delete-candidate-modal_SetupPopup__Content__Radiobtn__fEbWg","SetupPopup__AutomationToggle":"delete-candidate-modal_SetupPopup__AutomationToggle__7PonL","SetupPopup__SetupVideoQa":"delete-candidate-modal_SetupPopup__SetupVideoQa__qPNPT","SetupPopup__SetupVideoQa2":"delete-candidate-modal_SetupPopup__SetupVideoQa2__4_Rjj","SetupPopup__SetupVideoQa3":"delete-candidate-modal_SetupPopup__SetupVideoQa3__XfpuR","SetupPopup__SetupVideoQa4":"delete-candidate-modal_SetupPopup__SetupVideoQa4__k_xLg","SetupPopup__InputQA":"delete-candidate-modal_SetupPopup__InputQA__DAtVo","SetupPopup__AddQuestion":"delete-candidate-modal_SetupPopup__AddQuestion__YsQCr","SetupPopup__QuestionSection":"delete-candidate-modal_SetupPopup__QuestionSection__7ZZEm","SetupPopup__PushTop":"delete-candidate-modal_SetupPopup__PushTop__UCd2A","SetupPopup__Contentpading":"delete-candidate-modal_SetupPopup__Contentpading___5mGq","SetupPopup__QuesionSectionpading":"delete-candidate-modal_SetupPopup__QuesionSectionpading__IxzaQ","SetupPopup__Contentcenter":"delete-candidate-modal_SetupPopup__Contentcenter__gahV0","SetupPopup__PopDetails":"delete-candidate-modal_SetupPopup__PopDetails__qqqfo","SetupPopup__PopDetails__FS16":"delete-candidate-modal_SetupPopup__PopDetails__FS16__WQr1O","SetupPopup__Details":"delete-candidate-modal_SetupPopup__Details__fTmrp","SetupPopup__PrivacyPolicyDetails":"delete-candidate-modal_SetupPopup__PrivacyPolicyDetails__TKAJu","SetupPopup__Reason":"delete-candidate-modal_SetupPopup__Reason__mwJaS","SetupPopup__ContentBlock":"delete-candidate-modal_SetupPopup__ContentBlock__WaZ52","SetupPopup__Purpose":"delete-candidate-modal_SetupPopup__Purpose__OuEEX","SetupPopup__ContentGridsec":"delete-candidate-modal_SetupPopup__ContentGridsec__5i05f","mt25":"delete-candidate-modal_mt25__dfTJN","mt20":"delete-candidate-modal_mt20__g4Vna","SetupPopup__ContentGridTech":"delete-candidate-modal_SetupPopup__ContentGridTech__oHYSr","SetupPopup__Assesmentsection":"delete-candidate-modal_SetupPopup__Assesmentsection__MX95j","SetupPopup__AssesmentsectionNew":"delete-candidate-modal_SetupPopup__AssesmentsectionNew__GHAxj","SetupPopup__MannualChips":"delete-candidate-modal_SetupPopup__MannualChips__u_qNO","SetupPopup__ContentGridManuaCol":"delete-candidate-modal_SetupPopup__ContentGridManuaCol__CzBbT","SetupPopup__ContentGridManual":"delete-candidate-modal_SetupPopup__ContentGridManual__4jq9h","SetupPopup__ContentBlockPhone":"delete-candidate-modal_SetupPopup__ContentBlockPhone__G95M6","SetupPopup__ContentAddInterview":"delete-candidate-modal_SetupPopup__ContentAddInterview__d1k0T","SetupPopup__ContentGridPhone":"delete-candidate-modal_SetupPopup__ContentGridPhone__p9WFg","SetupPopup__ContentGridStatus":"delete-candidate-modal_SetupPopup__ContentGridStatus__LNdc5","SetupPopup__GridActions":"delete-candidate-modal_SetupPopup__GridActions__8vcJq","SetupPopup__GridActionCoral":"delete-candidate-modal_SetupPopup__GridActionCoral__zWKa1","SetupPopup__GridActionIndigo":"delete-candidate-modal_SetupPopup__GridActionIndigo__gofwM","SetupPopup__ContentGrid":"delete-candidate-modal_SetupPopup__ContentGrid__ihTLT","SetupPopup__SubmitSectionSave":"delete-candidate-modal_SetupPopup__SubmitSectionSave__r3TdI","SetupPopup__SubmitSectionReset":"delete-candidate-modal_SetupPopup__SubmitSectionReset__ysrD_","SetupPopup__SubmitSectionAutomation":"delete-candidate-modal_SetupPopup__SubmitSectionAutomation__Jf3fB","SetupPopup__Duration":"delete-candidate-modal_SetupPopup__Duration__L716D","SetupPopup__DeleteIcon":"delete-candidate-modal_SetupPopup__DeleteIcon__2aTjB","SetupPopup__ContentCustomisationManualInterview":"delete-candidate-modal_SetupPopup__ContentCustomisationManualInterview__kEt08","mt0":"delete-candidate-modal_mt0__8zerD","mtb25":"delete-candidate-modal_mtb25__1ttfS","mb15":"delete-candidate-modal_mb15__SCF_h","mb30":"delete-candidate-modal_mb30__RcTuD","mt9":"delete-candidate-modal_mt9__O34vr","lineheight0":"delete-candidate-modal_lineheight0__C4ggN","PopupHeightSection":"delete-candidate-modal_PopupHeightSection__waWqH","AssessPopupHeightSection":"delete-candidate-modal_AssessPopupHeightSection__enXKw","Statusopupheight":"delete-candidate-modal_Statusopupheight__llVaK","buttonIn":"delete-candidate-modal_buttonIn__uB0b5","MessagePlaceholder":"delete-candidate-modal_MessagePlaceholder__dSACt","m0":"delete-candidate-modal_m0__icvo9","mt18":"delete-candidate-modal_mt18___TMWR","DPgrid":"delete-candidate-modal_DPgrid__EwC_3","addbtnposition":"delete-candidate-modal_addbtnposition__Evt1q","mainformdiv":"delete-candidate-modal_mainformdiv__7sMxh","crossflex":"delete-candidate-modal_crossflex__phnF0","crossimgheight":"delete-candidate-modal_crossimgheight__Lffuf","crossimgheight48":"delete-candidate-modal_crossimgheight48__kgGTL","SetupModalPopup":"delete-candidate-modal_SetupModalPopup__w6q43","SetupModalPopup__Dialog":"delete-candidate-modal_SetupModalPopup__Dialog__EvtoO","SetupPopupoverlay":"delete-candidate-modal_SetupPopupoverlay__2XtLo","NeedHelp":"delete-candidate-modal_NeedHelp__4_Ktk","uploadNewTest":"delete-candidate-modal_uploadNewTest__WL5ky","SetupPopup__ol":"delete-candidate-modal_SetupPopup__ol__q97Pc","Threshold__Content":"delete-candidate-modal_Threshold__Content__TX5zp","Sharecv":"delete-candidate-modal_Sharecv__R9Zn8","Sharecv__Heading":"delete-candidate-modal_Sharecv__Heading__B1biI","Sharecv__Docfilename":"delete-candidate-modal_Sharecv__Docfilename__YqrYS","Sharecv__Selectfile":"delete-candidate-modal_Sharecv__Selectfile__Y_YOm","Form__TextareaPlaceholder":"delete-candidate-modal_Form__TextareaPlaceholder__cGcuC","OtpBacksection2":"delete-candidate-modal_OtpBacksection2__rcDZp","DefaultCheck":"delete-candidate-modal_DefaultCheck__Nr0Jh","DefaultCheck__MarginTop25":"delete-candidate-modal_DefaultCheck__MarginTop25__JPxZl","SetupPopup__AddInterviewCustomisation":"delete-candidate-modal_SetupPopup__AddInterviewCustomisation__VmmtF","SetupPopup__ContentFlex":"delete-candidate-modal_SetupPopup__ContentFlex__pnFRH","PositionRelative":"delete-candidate-modal_PositionRelative__z_S2v","CancelInterview__inner":"delete-candidate-modal_CancelInterview__inner__vR1h_","CancelInterview__OtpBacksection":"delete-candidate-modal_CancelInterview__OtpBacksection__DBNrd","CancelInterview__popupMessage":"delete-candidate-modal_CancelInterview__popupMessage___axZG","CancelInterview__ContentBlock":"delete-candidate-modal_CancelInterview__ContentBlock__Ertaf","CancelReason__inner":"delete-candidate-modal_CancelReason__inner__52urm","AutomationPopup__inner":"delete-candidate-modal_AutomationPopup__inner__AGhtf","BulkImportPopup__inner":"delete-candidate-modal_BulkImportPopup__inner__IEa3l","AutomationPopup__OtpBacksection":"delete-candidate-modal_AutomationPopup__OtpBacksection__9Mi_O","BulkImportPopup__OtpBacksection":"delete-candidate-modal_BulkImportPopup__OtpBacksection__B6j_E","AutomationPopup__Otpback":"delete-candidate-modal_AutomationPopup__Otpback__m44nf","BulkImportPopup__Otpback":"delete-candidate-modal_BulkImportPopup__Otpback__azoME","BulkImportPopup__Main_content":"delete-candidate-modal_BulkImportPopup__Main_content__oOQzJ","BulkImportPopup__Content":"delete-candidate-modal_BulkImportPopup__Content__6zcSP","BulkImportPopup__Footer2":"delete-candidate-modal_BulkImportPopup__Footer2__JtN0i","DefaultCheckbox_MarginTop":"delete-candidate-modal_DefaultCheckbox_MarginTop__TkU7Q","CancelReason__Content":"delete-candidate-modal_CancelReason__Content__YnpBk","CancelReason__OtpBacksection2":"delete-candidate-modal_CancelReason__OtpBacksection2__SbDs1","CancelReason__ContentBlock":"delete-candidate-modal_CancelReason__ContentBlock__Dtoid","CancelInterview__Container":"delete-candidate-modal_CancelInterview__Container__00DAD","CancelInterview__SubmitSectionSave":"delete-candidate-modal_CancelInterview__SubmitSectionSave__V5WLf","DeleteCandidateModal__Container":"delete-candidate-modal_DeleteCandidateModal__Container__6r3fx","DeleteCandidateModal__Message":"delete-candidate-modal_DeleteCandidateModal__Message__CONZI","DeleteCandidateModal__ButtonSection":"delete-candidate-modal_DeleteCandidateModal__ButtonSection__ZbAoy","DeleteCandidateModal__ButtonSection2":"delete-candidate-modal_DeleteCandidateModal__ButtonSection2__ROoJ1","ModalClose":"delete-candidate-modal_ModalClose__UgOK6","CancelInterview__Content":"delete-candidate-modal_CancelInterview__Content__3BTCA"};

/***/ }),

/***/ 37307:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"dropzone_Form__9k_Dc","Form__width":"dropzone_Form__width__GfStu","Form__label":"dropzone_Form__label__VsLLX","Form__textleft":"dropzone_Form__textleft__r6WTL","Form__InputFullWidth":"dropzone_Form__InputFullWidth__yybdU","Form__Input":"dropzone_Form__Input__0d_wg","Form__InputSection":"dropzone_Form__InputSection__Ekqy1","Form__ScoreCardInput":"dropzone_Form__ScoreCardInput__fxylA","Form__Textarea":"dropzone_Form__Textarea__2p_un","primarybtn":"dropzone_primarybtn__CaPNP","secondarybtn":"dropzone_secondarybtn__shlhH","iconFilled":"dropzone_iconFilled__uR1yy","iconFilledSolid":"dropzone_iconFilledSolid__xOJbd","primarybtnborder":"dropzone_primarybtnborder__koLZi","secondarybtnborder":"dropzone_secondarybtnborder__6A_6T","tertiarybtn":"dropzone_tertiarybtn__kHfgY","graybtnborder":"dropzone_graybtnborder__xuEV9","jobsrchbtn":"dropzone_jobsrchbtn__5CFNW","jobsrchbtnalign":"dropzone_jobsrchbtnalign__ndI3o","nobgbutton":"dropzone_nobgbutton__i9zFZ","iconTextButton":"dropzone_iconTextButton__eIHo5","cursornone":"dropzone_cursornone___ZtEh","nobgbuttonprimary":"dropzone_nobgbuttonprimary__54JIz","mt15":"dropzone_mt15__19T1k","btn350":"dropzone_btn350__KhrRY","GrayBgBtn":"dropzone_GrayBgBtn__vymH9","NewShareBtn":"dropzone_NewShareBtn__Vv8U7","CoralBgBtn":"dropzone_CoralBgBtn__OYzUc","DropContainer":"dropzone_DropContainer__g4pUP","DropContainer__Inner":"dropzone_DropContainer__Inner__MNGGv","DropContainer__Message":"dropzone_DropContainer__Message__9VsQd","DropContainer__UploadIcon":"dropzone_DropContainer__UploadIcon__Gmb5J","FileDisplayContainer":"dropzone_FileDisplayContainer__FFlLt","FileDisplayContainer__Status":"dropzone_FileDisplayContainer__Status__j47VI","FileDisplayContainer__Type":"dropzone_FileDisplayContainer__Type__kK15D","FileDisplayContainer__Name":"dropzone_FileDisplayContainer__Name__MH9Uu","FileDisplayContainer__Error":"dropzone_FileDisplayContainer__Error__zNRY4","FileDisplayContainer__Close":"dropzone_FileDisplayContainer__Close__FmMw9","Browse":"dropzone_Browse___H7p1"};

/***/ }),

/***/ 2983:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Modalpopup":"input-modal_Modalpopup__pHKiK","Modalpopup__inner":"input-modal_Modalpopup__inner__LKZtF","Modalpopup__Dialog":"input-modal_Modalpopup__Dialog___prgn","transition":"input-modal_transition__I9K19","Modalpopup__CloseCenter":"input-modal_Modalpopup__CloseCenter__NGg5q","Modalpopup__Content":"input-modal_Modalpopup__Content__iEA32","Modalpopup__btn":"input-modal_Modalpopup__btn__3uAbO","mar":"input-modal_mar__q94ce","Otpback":"input-modal_Otpback__0pTQx","Form":"input-modal_Form__mDcvj","Form__width":"input-modal_Form__width__PrwvQ","Form__label":"input-modal_Form__label__0m3GS","Form__textleft":"input-modal_Form__textleft__NSlLa","Form__InputFullWidth":"input-modal_Form__InputFullWidth__Hwl0j","Form__Input":"input-modal_Form__Input__LBx2H","Form__Input398":"input-modal_Form__Input398___oLWT","Form__InputSection":"input-modal_Form__InputSection__svWfR","Form__ScoreCardInput":"input-modal_Form__ScoreCardInput__L0Pre","Form__Textarea":"input-modal_Form__Textarea__k5HfH","primarybtn":"input-modal_primarybtn__RjqEN","GoBtn":"input-modal_GoBtn__UitDP","secondarybtn":"input-modal_secondarybtn__dYduk","iconFilled":"input-modal_iconFilled__5TSFE","iconFilledSolid":"input-modal_iconFilledSolid___Dpqf","primarybtnborder":"input-modal_primarybtnborder__LmGqc","secondarybtnborder":"input-modal_secondarybtnborder__VO_tN","ClearBtn":"input-modal_ClearBtn__fnkPC","tertiarybtn":"input-modal_tertiarybtn__BI1Jy","graybtnborder":"input-modal_graybtnborder__W227f","jobsrchbtn":"input-modal_jobsrchbtn__SChwy","jobsrchbtnalign":"input-modal_jobsrchbtnalign__RRdrA","nobgbutton":"input-modal_nobgbutton__DcR7K","iconTextButton":"input-modal_iconTextButton__iWRPE","cursornone":"input-modal_cursornone__aWh8y","nobgbuttonprimary":"input-modal_nobgbuttonprimary__rSxYH","mt15":"input-modal_mt15__15T8q","btn350":"input-modal_btn350__DCUEG","GrayBgBtn":"input-modal_GrayBgBtn__FPgag","NewShareBtn":"input-modal_NewShareBtn__xi1Qb","CoralBgBtn":"input-modal_CoralBgBtn__DgkQb","DropContainer":"input-modal_DropContainer__PG3zM","DropContainer__Inner":"input-modal_DropContainer__Inner__yp_u2","CompanyProfile__Inner":"input-modal_CompanyProfile__Inner__mlzOZ","DropContainer__Message":"input-modal_DropContainer__Message__Twg2R","CompanyProfile__Message":"input-modal_CompanyProfile__Message____ix5","CompanyProfile__MessageContent":"input-modal_CompanyProfile__MessageContent__ybZL5","DropContainer__UploadIcon":"input-modal_DropContainer__UploadIcon__D4RKD","CompanyProfile__UploadIcon":"input-modal_CompanyProfile__UploadIcon__eWBTw","FileDisplayContainer":"input-modal_FileDisplayContainer__aU9uc","FileDisplayContainer__Status":"input-modal_FileDisplayContainer__Status__ySG_n","FileDisplayContainer__Type":"input-modal_FileDisplayContainer__Type__0gTiV","FileDisplayContainer__Name":"input-modal_FileDisplayContainer__Name__eIXWy","FileDisplayContainer__Error":"input-modal_FileDisplayContainer__Error__UBf5W","FileDisplayContainer__Close":"input-modal_FileDisplayContainer__Close__cuFa9","Browse":"input-modal_Browse__wVfek","ClientCompany":"input-modal_ClientCompany__XJUTD","NewJob":"input-modal_NewJob__e38rf","ClientCompany__TopSection2":"input-modal_ClientCompany__TopSection2__BjKZQ","ClientCompany__Filter":"input-modal_ClientCompany__Filter___nonq","ClientCompany__Input_MatchScore":"input-modal_ClientCompany__Input_MatchScore__9NGZm","ClientCompany__Percentage_Symbol":"input-modal_ClientCompany__Percentage_Symbol__2cDq_","ClientCompany__Filterheading":"input-modal_ClientCompany__Filterheading__9kHbi","ClientCompany__FloatButtonAdd":"input-modal_ClientCompany__FloatButtonAdd__Pdb7L","ClientCompany__FloatButtonAdd__AgencyUserIcon":"input-modal_ClientCompany__FloatButtonAdd__AgencyUserIcon__aXV2E","ClientCompany__LastEdited":"input-modal_ClientCompany__LastEdited__r_uyk","ClientCompany__BackSection":"input-modal_ClientCompany__BackSection__iJgaM","AddUsers__BackSection":"input-modal_AddUsers__BackSection__G_XiZ","ClientCompany__BackSection__CloseIcon":"input-modal_ClientCompany__BackSection__CloseIcon__v8AAw","ClientCompany__Container":"input-modal_ClientCompany__Container__wths8","NewJob__InterviewContainer":"input-modal_NewJob__InterviewContainer__91nqS","AddUsers__Container":"input-modal_AddUsers__Container___rDXQ","ClientCompany__FormInputSection":"input-modal_ClientCompany__FormInputSection__hCEwE","CompanyProfile__FormInputSection":"input-modal_CompanyProfile__FormInputSection__BBYqu","ClientCompany__Heading":"input-modal_ClientCompany__Heading__rSGVn","AddUsers__Heading":"input-modal_AddUsers__Heading___oNlJ","ClientCompany__StatusAlignment":"input-modal_ClientCompany__StatusAlignment__RQmGJ","ClientCompany__Status":"input-modal_ClientCompany__Status__W35kt","ClientCompany__ActiveDot":"input-modal_ClientCompany__ActiveDot__cSOKo","ClientCompany__CloseDot":"input-modal_ClientCompany__CloseDot__EWC4f","ClientCompany__Company":"input-modal_ClientCompany__Company__2Mzbr","AddUsers__User":"input-modal_AddUsers__User__DXYML","ClientCompany__Systemrefheding":"input-modal_ClientCompany__Systemrefheding__z6uvo","ClientCompany__Subheading":"input-modal_ClientCompany__Subheading__TYTtF","CompanyProfile__Subheading":"input-modal_CompanyProfile__Subheading__GKh__","ClientCompany__Subheading2":"input-modal_ClientCompany__Subheading2__CEohM","ClientCompany__Description":"input-modal_ClientCompany__Description__XRWPQ","ClientCompany__SubmitSection":"input-modal_ClientCompany__SubmitSection__U8wxl","NewJob__SubmitSection":"input-modal_NewJob__SubmitSection__CshqM","NewJob__SubmitSectionThreeBtn":"input-modal_NewJob__SubmitSectionThreeBtn__KxYDK","NewJob__SubmitSectionOneBtnPlacement":"input-modal_NewJob__SubmitSectionOneBtnPlacement__U3AnF","NewJob__ImportSection":"input-modal_NewJob__ImportSection__Zou1y","AddUsers__SubmitSection":"input-modal_AddUsers__SubmitSection__kYkWp","ClientCompany__IntegrationImage":"input-modal_ClientCompany__IntegrationImage__4kAEL","ClientCompany__QuickAdd":"input-modal_ClientCompany__QuickAdd__9OGDJ","NewJob__QuickAdd":"input-modal_NewJob__QuickAdd__Hoz69","ClientCompany__BodyText":"input-modal_ClientCompany__BodyText__09_11","Form__TableRow":"input-modal_Form__TableRow__4z53a","ModalInput__Form__TableRow":"input-modal_ModalInput__Form__TableRow__PJm_H","ModalInput__Form__TableRowBlock":"input-modal_ModalInput__Form__TableRowBlock__UP4Kx","Form__Label":"input-modal_Form__Label__yQ2XE","ModalInput__Form__LabelCheck":"input-modal_ModalInput__Form__LabelCheck__8tlt5","Form__FloatingLabel":"input-modal_Form__FloatingLabel__9NuCd","Form__TableCol":"input-modal_Form__TableCol__shSLF","ModalInput__Form__TableCol":"input-modal_ModalInput__Form__TableCol__Z90Dg","Form__currency_symbol":"input-modal_Form__currency_symbol__qgy9a","Form__CustomSelect":"input-modal_Form__CustomSelect___Rj6j","Form__currency_symbol__right":"input-modal_Form__currency_symbol__right__gpyz5","Form__TableCol__Disabled":"input-modal_Form__TableCol__Disabled__RK9_J","Form__TextareaDisabled":"input-modal_Form__TextareaDisabled__ZIced","Form__EditorDisabled":"input-modal_Form__EditorDisabled__A0kuJ","Form__AdminCheckLabel":"input-modal_Form__AdminCheckLabel__fv_j6","Form__AdminCheckMargin":"input-modal_Form__AdminCheckMargin__4wtBm","CompanyProfile__BrandingGuide":"input-modal_CompanyProfile__BrandingGuide___AkHh","CompanyProfile__DropBoxContainer":"input-modal_CompanyProfile__DropBoxContainer__XYV8c","CompanyProfile__Browse":"input-modal_CompanyProfile__Browse__5gWit","ErrorLabel":"input-modal_ErrorLabel__KzA_c","Height80":"input-modal_Height80__zV5Z_","Browse__ButtonFlexEnd":"input-modal_Browse__ButtonFlexEnd__RWHS1","AddAgency__Container":"input-modal_AddAgency__Container__5RlCt","AddAgency__FormInputSection":"input-modal_AddAgency__FormInputSection__B64el","AddAgency__FormInputSection__Label":"input-modal_AddAgency__FormInputSection__Label__xdhau","AddAgency__Form":"input-modal_AddAgency__Form__UC4B_","LinkAsButtons":"input-modal_LinkAsButtons__i6Zas","SearchFlex":"input-modal_SearchFlex__8bjMY","Form__ErrorCustomSelect":"input-modal_Form__ErrorCustomSelect__si3mx","Form__select_currency":"input-modal_Form__select_currency__VmeZ4","customSelect__placeholder":"input-modal_customSelect__placeholder__Kjf2B","Career":"input-modal_Career__3URP4","Career__Background_Edit":"input-modal_Career__Background_Edit__NFzcA","Career__Background_Edit_Image":"input-modal_Career__Background_Edit_Image__aDCrv","Career__Container":"input-modal_Career__Container__o9phY","Career__Inner":"input-modal_Career__Inner__UgzEQ","Career__logo":"input-modal_Career__logo__4RDO_","Career__Content":"input-modal_Career__Content__soVck","Career__ButtonSection":"input-modal_Career__ButtonSection__4OSdf","Job":"input-modal_Job__r5G7r","Job__Inner":"input-modal_Job__Inner__k2GO_","Job__Container":"input-modal_Job__Container__Kss9Y","Job__Heading":"input-modal_Job__Heading__pf_f_","Job__Company":"input-modal_Job__Company__tfHLv","Job__SearchContainer":"input-modal_Job__SearchContainer__JDW_z","Job__SearchInput":"input-modal_Job__SearchInput___AzhU","Job__Searchbtn":"input-modal_Job__Searchbtn__GGJq6","Job__Input":"input-modal_Job__Input__Al4g_","Job__SelectJob":"input-modal_Job__SelectJob__KSsmU","Job__RemoteLabel":"input-modal_Job__RemoteLabel__87Fkm","Job__Display":"input-modal_Job__Display__fzeeu","Job__PostDay":"input-modal_Job__PostDay__wDTuS","Job__Title":"input-modal_Job__Title__QLy6H","Job__Location":"input-modal_Job__Location__aoF3Z","DT":"input-modal_DT__Y1iwC","DisplayTable":"input-modal_DisplayTable__VO05a","pd11":"input-modal_pd11__OHnRQ","Label":"input-modal_Label__R86B2","inputwidth":"input-modal_inputwidth__U5_kD","mr24":"input-modal_mr24__soX7u","fullwidth":"input-modal_fullwidth__zJQ4D","padt40":"input-modal_padt40__6Cvle","Form__TableRowflex":"input-modal_Form__TableRowflex__jqgKx","Form__TableColm":"input-modal_Form__TableColm__bPaFX","Form__LabelCheck":"input-modal_Form__LabelCheck__Wrs6j","Form__Error":"input-modal_Form__Error__shRYp","Form__ErrorSection":"input-modal_Form__ErrorSection__vPxPZ","Form__MessagePlaceholder":"input-modal_Form__MessagePlaceholder__2qDJU","Form__Submit":"input-modal_Form__Submit__n7SH7","Form__NormalLabel":"input-modal_Form__NormalLabel__TvxsN","AddInterview":"input-modal_AddInterview__00mfo","IntegrationPage":"input-modal_IntegrationPage__tBeX3","Integration__BackStep":"input-modal_Integration__BackStep__ULysG","AddUsers__BackStep":"input-modal_AddUsers__BackStep__NT6g5","Integration__SubmitSection":"input-modal_Integration__SubmitSection__8GbBv","IntegrationTable":"input-modal_IntegrationTable__1QmJM","IntegrationTable__LimitInput":"input-modal_IntegrationTable__LimitInput___WBfU","IntegrationTable__Type":"input-modal_IntegrationTable__Type___DqCW","IntegrationTable__AllJobsToggle":"input-modal_IntegrationTable__AllJobsToggle___Pk0G","IntegrationTable__switch":"input-modal_IntegrationTable__switch__t83gg","IntegrationTable__switchText":"input-modal_IntegrationTable__switchText__nSz9O","IntegrationTable__slider":"input-modal_IntegrationTable__slider__Lf_RV","IntegrationTable__round":"input-modal_IntegrationTable__round__O_ZUS","IntegrationTable__Action":"input-modal_IntegrationTable__Action__OKkXC","IntegrationView":"input-modal_IntegrationView__Yf0eN","IntegrationView__Title":"input-modal_IntegrationView__Title__8Ifvi","IntegrationView__Subheading":"input-modal_IntegrationView__Subheading__ey9_9","IntegrationView__BoxImage":"input-modal_IntegrationView__BoxImage__0Up_Z","IntegrationView__Box":"input-modal_IntegrationView__Box__6wxYh","IntegrationView__BoxImage__InfoIcon":"input-modal_IntegrationView__BoxImage__InfoIcon__252vs","IntegrationView__ViewMoreButton":"input-modal_IntegrationView__ViewMoreButton__o0o6e","IntegrationView__ConnectButton":"input-modal_IntegrationView__ConnectButton__b_HK8","IntegrationView__GoogleButton":"input-modal_IntegrationView__GoogleButton__O2GsA","IntegrationView__FlexFlow":"input-modal_IntegrationView__FlexFlow__5XOjz","IntegrationView__BoxWidth":"input-modal_IntegrationView__BoxWidth__q7O4q","SkipFinishButton":"input-modal_SkipFinishButton__CSGTI","AddUsers":"input-modal_AddUsers__vo6R6","AddUsers__ButtonSection":"input-modal_AddUsers__ButtonSection__rwF5f","AddUsers__QuickStepHeading":"input-modal_AddUsers__QuickStepHeading__PbnRg","AddUsers__DeleteSection":"input-modal_AddUsers__DeleteSection__V2qJj","AddUsers__DeleteCrossHeight":"input-modal_AddUsers__DeleteCrossHeight__M2Nxs","AddUsers__Form__Input":"input-modal_AddUsers__Form__Input__hvpbd","AddUsers__FormHeadingSection":"input-modal_AddUsers__FormHeadingSection__d5Syz","AddUsers__FormSection":"input-modal_AddUsers__FormSection__l0kZO","NewJob__FormSection":"input-modal_NewJob__FormSection__9bgtt","AddUsers__ButtonsActionSection":"input-modal_AddUsers__ButtonsActionSection__buYC_","AddUsers__ImportUsers":"input-modal_AddUsers__ImportUsers__we182","AddUsers__NameInput":"input-modal_AddUsers__NameInput__cvdpp","AddUsers__EmailInput":"input-modal_AddUsers__EmailInput__WGKxJ","AddUsers__RoleInput":"input-modal_AddUsers__RoleInput__IpoiQ","AddUsers__Subheading":"input-modal_AddUsers__Subheading__35f6H","AddUsers__visible":"input-modal_AddUsers__visible__ktNge","Tagrow":"input-modal_Tagrow__7Ck3Q","Tagrow__Tags":"input-modal_Tagrow__Tags__5AUGe","Tagrow__Cancel":"input-modal_Tagrow__Cancel__fntoN","SendInviteSection":"input-modal_SendInviteSection__DtKI1","error":"input-modal_error__q5Nvz","ViewJobPage__Input":"input-modal_ViewJobPage__Input__Ijz3U","Form__Input2":"input-modal_Form__Input2__1fcmw","ViewJobPage__PostDay":"input-modal_ViewJobPage__PostDay__zw6MT","ViewJobPage__Title":"input-modal_ViewJobPage__Title__9J4dh","ViewJobPage__DescriptionTitle":"input-modal_ViewJobPage__DescriptionTitle__3vUGT","ViewJobPage__Location":"input-modal_ViewJobPage__Location__V7G1L","ViewJobPage__primarybtn":"input-modal_ViewJobPage__primarybtn__v9nG2","ViewJobPage__secondarybtn":"input-modal_ViewJobPage__secondarybtn__g6ktH","ViewJobPage__secondarybtnborder":"input-modal_ViewJobPage__secondarybtnborder__hasJO","ViewJobPage__BackSection":"input-modal_ViewJobPage__BackSection__LDcgA","ViewJobPage__Content":"input-modal_ViewJobPage__Content__1lQIs","ViewJobPage":"input-modal_ViewJobPage__DrsQQ","ViewJobPage__Header":"input-modal_ViewJobPage__Header__agnXg","ViewJobPage__Application":"input-modal_ViewJobPage__Application__sLCos","ViewJobPage__RecordVideo":"input-modal_ViewJobPage__RecordVideo__D02Wf","ViewJobPage__RecordVideoSuccessText":"input-modal_ViewJobPage__RecordVideoSuccessText__mwMzK","ViewJobPage__subheading":"input-modal_ViewJobPage__subheading__YniMt","ViewJobPage__confirmation":"input-modal_ViewJobPage__confirmation__Rgice","ViewJobPage__Logo":"input-modal_ViewJobPage__Logo__yWhOL","ViewJobPage__BrandLogo":"input-modal_ViewJobPage__BrandLogo__hHvJb","ViewJobPage__BrandLogo__Padding10":"input-modal_ViewJobPage__BrandLogo__Padding10__6c6d0","ViewJobPage__Container":"input-modal_ViewJobPage__Container__zI1A4","ViewJobPage__JobContent":"input-modal_ViewJobPage__JobContent__qgwHd","ViewJobPage__Sidebar":"input-modal_ViewJobPage__Sidebar__a4BnN","ViewJobPage__Sidebar2":"input-modal_ViewJobPage__Sidebar2__GWSnd","ViewJobPage__Description":"input-modal_ViewJobPage__Description__fq9Yt","ViewJobPage__DescriptionWidth":"input-modal_ViewJobPage__DescriptionWidth__0_8ni","ViewJobPage__Footer":"input-modal_ViewJobPage__Footer__9WIIO","ViewJobPage__FooterView":"input-modal_ViewJobPage__FooterView__cJKe8","ViewJobPage__ShareJob":"input-modal_ViewJobPage__ShareJob__wsqJb","ViewJobPage__SubmitSection":"input-modal_ViewJobPage__SubmitSection__OWTju","ViewJobPage__SocialMedia":"input-modal_ViewJobPage__SocialMedia__hHk9N","ViewJobPage__SideContent":"input-modal_ViewJobPage__SideContent__EEywh","ViewJobPage__ApplySection":"input-modal_ViewJobPage__ApplySection__VZnMG","FormBox__Autofill":"input-modal_FormBox__Autofill__9a5XA","applybuttons":"input-modal_applybuttons__l9y5R","height90":"input-modal_height90__LCi3S","Form__Cont":"input-modal_Form__Cont__lsywu","Form__DropBox":"input-modal_Form__DropBox__adr7f","Form__DropBoxcontainer":"input-modal_Form__DropBoxcontainer__cgzXz","Form__DropBoxError":"input-modal_Form__DropBoxError__GvKLN","Form__DropBoxicon":"input-modal_Form__DropBoxicon__PRLeV","Form__DropBoxmessage":"input-modal_Form__DropBoxmessage__ffk_Y","noDpGrid":"input-modal_noDpGrid__pF9Pp","Terms":"input-modal_Terms__7OVQH","TermsCondition":"input-modal_TermsCondition__U7N2I","TermsCondition__alignterms":"input-modal_TermsCondition__alignterms__U1grT","MenuContainer":"input-modal_MenuContainer__5_TJr","MenuContainer__Menu":"input-modal_MenuContainer__Menu__rOH0z","AgencyDetailPage":"input-modal_AgencyDetailPage__hKZu_","Congrats__ModalContent":"input-modal_Congrats__ModalContent__5_wcU","NewJob__Container":"input-modal_NewJob__Container__F4IzR","NewJob__TopSection":"input-modal_NewJob__TopSection__mpLp_","NewJob__HorizontalDivider":"input-modal_NewJob__HorizontalDivider__K6C_I","NewJob__Wrapper":"input-modal_NewJob__Wrapper__nY5gn","NewJob__ContainerPadding":"input-modal_NewJob__ContainerPadding__TClEu","NewJob__ContainerScroll":"input-modal_NewJob__ContainerScroll__o9b2H","NewJob__ContainerHeight":"input-modal_NewJob__ContainerHeight__zlcRa","NewJob__ImportAction":"input-modal_NewJob__ImportAction__ASLpT","NewJob__Interview_buttons":"input-modal_NewJob__Interview_buttons__pyn8A","Form__TableRowMB":"input-modal_Form__TableRowMB__4TMe_","Form__TableRow3grid":"input-modal_Form__TableRow3grid__JCKl4","Form__Remotegrid":"input-modal_Form__Remotegrid__XC_pA","Form__TypeList":"input-modal_Form__TypeList__bfrqu","Form__Type":"input-modal_Form__Type__kwP3f","Form__CheckLabel":"input-modal_Form__CheckLabel__soLG9","PrivateSwitchBase-root-1":"input-modal_PrivateSwitchBase-root-1__CumxE","Form__Caption":"input-modal_Form__Caption__OuRm1","Form__Input_currency":"input-modal_Form__Input_currency__Ubt4K","Form__Input_MatchScore":"input-modal_Form__Input_MatchScore__rS8k2","Form__Percentage_Symbol":"input-modal_Form__Percentage_Symbol__Pg2UN","Form__NoGridTemplate":"input-modal_Form__NoGridTemplate__AW7f8","active":"input-modal_active__WzfUz","mt10":"input-modal_mt10__KeOo2","mt40":"input-modal_mt40__ciMFi","mt30":"input-modal_mt30__vxfv4","mt32":"input-modal_mt32__H2iuL","mb0":"input-modal_mb0__RXv8c","Dpgrid":"input-modal_Dpgrid__6rWnQ","mb12":"input-modal_mb12__2ODzz","width100":"input-modal_width100__QxGcI","Tagrow__Prefix":"input-modal_Tagrow__Prefix__HLuCe","PreviewJobPage":"input-modal_PreviewJobPage__q8jVB","PreviewJob":"input-modal_PreviewJob__Wz_J3","DpFlx":"input-modal_DpFlx__w_xsP","Subheading":"input-modal_Subheading__TbyoJ","Subheading__Description":"input-modal_Subheading__Description___EDGT","Candidate__Tooltip":"input-modal_Candidate__Tooltip__hiXah","Candidate__Tooltip__Score":"input-modal_Candidate__Tooltip__Score__9Z9PU","Form__InputField":"input-modal_Form__InputField__ebE0Q","Candidate__Length":"input-modal_Candidate__Length__qcpm4","Agency__PostDay":"input-modal_Agency__PostDay__BEgio","Agency__Title":"input-modal_Agency__Title__7_LY6","Agency__Location":"input-modal_Agency__Location__iL_Yu","Agency__DescriptionTitle":"input-modal_Agency__DescriptionTitle__Yu8BY","Agency__Description":"input-modal_Agency__Description__EBvnY","LightBlueColor":"input-modal_LightBlueColor__8j_lU","ModalInput__Description":"input-modal_ModalInput__Description__rMip5","ModalInput__Link":"input-modal_ModalInput__Link__3xv9a","ModalInput__Head":"input-modal_ModalInput__Head__3cDzv","ModalInput__PaddingTop":"input-modal_ModalInput__PaddingTop___iSgL","ModalInput__ContentBlock":"input-modal_ModalInput__ContentBlock__pTmEa","ModalInput__ContentBlock__Description":"input-modal_ModalInput__ContentBlock__Description__pnTb4","ModalInput__ContentBlock__Tooltip":"input-modal_ModalInput__ContentBlock__Tooltip__tr4LN","ModalInput__ContentBlock__flexAlign":"input-modal_ModalInput__ContentBlock__flexAlign__RPMs6","ModalInput__Form__Radio":"input-modal_ModalInput__Form__Radio__s3YpD","ModalInput":"input-modal_ModalInput__ruLsI","ModalInput__Inner":"input-modal_ModalInput__Inner__pEY__","ModalInput__SubmitSection":"input-modal_ModalInput__SubmitSection__67zjp"};

/***/ }),

/***/ 90538:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Modalpopup":"job-filter_Modalpopup__y3EW0","Modalpopup__inner":"job-filter_Modalpopup__inner__4tKgJ","Modalpopup__Dialog":"job-filter_Modalpopup__Dialog__JXRMh","transition":"job-filter_transition__mkQuq","Modalpopup__CloseCenter":"job-filter_Modalpopup__CloseCenter__mQ1Ez","Modalpopup__Content":"job-filter_Modalpopup__Content__ltQCl","Modalpopup__btn":"job-filter_Modalpopup__btn__Rk08y","mar":"job-filter_mar__tzccW","Otpback":"job-filter_Otpback__bo9SV","Form":"job-filter_Form__Lg_ra","Form__width":"job-filter_Form__width__laqlw","Form__label":"job-filter_Form__label__0wjcH","Form__textleft":"job-filter_Form__textleft__1P6Th","Form__InputFullWidth":"job-filter_Form__InputFullWidth__bBKmM","Form__Input":"job-filter_Form__Input__O_KHk","Form__Input398":"job-filter_Form__Input398__UoEVN","Form__InputSection":"job-filter_Form__InputSection__Ub5yT","Form__ScoreCardInput":"job-filter_Form__ScoreCardInput__RYPPF","Form__Textarea":"job-filter_Form__Textarea__AcFnu","primarybtn":"job-filter_primarybtn__1que6","GoBtn":"job-filter_GoBtn__XQ3o7","secondarybtn":"job-filter_secondarybtn__58WQB","iconFilled":"job-filter_iconFilled__EYIk6","iconFilledSolid":"job-filter_iconFilledSolid__A0Xtw","primarybtnborder":"job-filter_primarybtnborder__5J82m","secondarybtnborder":"job-filter_secondarybtnborder__I_yzD","ClearBtn":"job-filter_ClearBtn__WU_9l","tertiarybtn":"job-filter_tertiarybtn__s0b0C","graybtnborder":"job-filter_graybtnborder__IsTuq","jobsrchbtn":"job-filter_jobsrchbtn__14_3p","jobsrchbtnalign":"job-filter_jobsrchbtnalign__N5C0P","nobgbutton":"job-filter_nobgbutton__AgICx","iconTextButton":"job-filter_iconTextButton__qyhx9","cursornone":"job-filter_cursornone__4pBvv","nobgbuttonprimary":"job-filter_nobgbuttonprimary__dthcG","mt15":"job-filter_mt15__URvf1","btn350":"job-filter_btn350__8_Qre","GrayBgBtn":"job-filter_GrayBgBtn__oSVK_","NewShareBtn":"job-filter_NewShareBtn__MAHgw","CoralBgBtn":"job-filter_CoralBgBtn__SDsVG","DropContainer":"job-filter_DropContainer__sU_9B","DropContainer__Inner":"job-filter_DropContainer__Inner__115zf","CompanyProfile__Inner":"job-filter_CompanyProfile__Inner__twNMr","DropContainer__Message":"job-filter_DropContainer__Message__MvhZr","CompanyProfile__Message":"job-filter_CompanyProfile__Message__XFan9","CompanyProfile__MessageContent":"job-filter_CompanyProfile__MessageContent__KdAt7","DropContainer__UploadIcon":"job-filter_DropContainer__UploadIcon__7DsgX","CompanyProfile__UploadIcon":"job-filter_CompanyProfile__UploadIcon__QOpct","FileDisplayContainer":"job-filter_FileDisplayContainer__r1Ust","FileDisplayContainer__Status":"job-filter_FileDisplayContainer__Status__0547m","FileDisplayContainer__Type":"job-filter_FileDisplayContainer__Type__TnCv0","FileDisplayContainer__Name":"job-filter_FileDisplayContainer__Name__MD94q","FileDisplayContainer__Error":"job-filter_FileDisplayContainer__Error__TDwrM","FileDisplayContainer__Close":"job-filter_FileDisplayContainer__Close__tzDM2","Browse":"job-filter_Browse____aD_","ClientCompany":"job-filter_ClientCompany__w8lvq","NewJob":"job-filter_NewJob___v7IB","ClientCompany__TopSection2":"job-filter_ClientCompany__TopSection2__7ulej","ClientCompany__Filter":"job-filter_ClientCompany__Filter__ZhEhm","ClientCompany__Input_MatchScore":"job-filter_ClientCompany__Input_MatchScore__2XYp2","ClientCompany__Percentage_Symbol":"job-filter_ClientCompany__Percentage_Symbol__JTdW2","ClientCompany__Filterheading":"job-filter_ClientCompany__Filterheading__eExBs","ClientCompany__FloatButtonAdd":"job-filter_ClientCompany__FloatButtonAdd__9U5vG","ClientCompany__FloatButtonAdd__AgencyUserIcon":"job-filter_ClientCompany__FloatButtonAdd__AgencyUserIcon__EWgRX","ClientCompany__LastEdited":"job-filter_ClientCompany__LastEdited__j2rNY","ClientCompany__BackSection":"job-filter_ClientCompany__BackSection__Beffl","AddUsers__BackSection":"job-filter_AddUsers__BackSection__09N0z","ClientCompany__BackSection__CloseIcon":"job-filter_ClientCompany__BackSection__CloseIcon__koyYF","ClientCompany__Container":"job-filter_ClientCompany__Container__dLFFD","NewJob__InterviewContainer":"job-filter_NewJob__InterviewContainer__JBIdb","AddUsers__Container":"job-filter_AddUsers__Container__Qgi6I","ClientCompany__FormInputSection":"job-filter_ClientCompany__FormInputSection__mO0kE","CompanyProfile__FormInputSection":"job-filter_CompanyProfile__FormInputSection__lblm4","ClientCompany__Heading":"job-filter_ClientCompany__Heading__XldwX","AddUsers__Heading":"job-filter_AddUsers__Heading__BQVBH","ClientCompany__StatusAlignment":"job-filter_ClientCompany__StatusAlignment___CNYl","ClientCompany__Status":"job-filter_ClientCompany__Status__fPPM0","ClientCompany__ActiveDot":"job-filter_ClientCompany__ActiveDot__6posI","ClientCompany__CloseDot":"job-filter_ClientCompany__CloseDot__cIdHf","ClientCompany__Company":"job-filter_ClientCompany__Company__GP5jg","AddUsers__User":"job-filter_AddUsers__User__FL1zX","ClientCompany__Systemrefheding":"job-filter_ClientCompany__Systemrefheding__zvfVA","ClientCompany__Subheading":"job-filter_ClientCompany__Subheading__UVwP6","CompanyProfile__Subheading":"job-filter_CompanyProfile__Subheading__fFIco","ClientCompany__Subheading2":"job-filter_ClientCompany__Subheading2__uXawS","ClientCompany__Description":"job-filter_ClientCompany__Description__eC49g","ClientCompany__SubmitSection":"job-filter_ClientCompany__SubmitSection__I_agf","NewJob__SubmitSection":"job-filter_NewJob__SubmitSection__CAKvW","NewJob__SubmitSectionThreeBtn":"job-filter_NewJob__SubmitSectionThreeBtn__FPdLD","NewJob__SubmitSectionOneBtnPlacement":"job-filter_NewJob__SubmitSectionOneBtnPlacement__U8QQu","NewJob__ImportSection":"job-filter_NewJob__ImportSection__bKW_Q","AddUsers__SubmitSection":"job-filter_AddUsers__SubmitSection__zN9s4","ClientCompany__IntegrationImage":"job-filter_ClientCompany__IntegrationImage__lDipv","ClientCompany__QuickAdd":"job-filter_ClientCompany__QuickAdd__BNNDn","NewJob__QuickAdd":"job-filter_NewJob__QuickAdd__tD4UN","ClientCompany__BodyText":"job-filter_ClientCompany__BodyText__9PnuB","Form__TableRow":"job-filter_Form__TableRow__MTGrF","Form__TableRowBlock":"job-filter_Form__TableRowBlock__XSCTC","Form__Label":"job-filter_Form__Label__CnWir","Form__LabelCheck":"job-filter_Form__LabelCheck__H6S0v","Form__FloatingLabel":"job-filter_Form__FloatingLabel__N_2Cm","Form__TableCol":"job-filter_Form__TableCol__q7fRp","Form__TableCol2":"job-filter_Form__TableCol2__Kyfhi","Form__TableColNormal":"job-filter_Form__TableColNormal__z4Hd4","Form__currency_symbol":"job-filter_Form__currency_symbol__GMxZp","Form__CustomSelect":"job-filter_Form__CustomSelect__n4lSH","Form__currency_symbol__right":"job-filter_Form__currency_symbol__right__XAcyQ","Form__TableCol__Disabled":"job-filter_Form__TableCol__Disabled__BdTvK","Form__TextareaDisabled":"job-filter_Form__TextareaDisabled__A73Tz","Form__EditorDisabled":"job-filter_Form__EditorDisabled__GqzCc","Form__AdminCheckLabel":"job-filter_Form__AdminCheckLabel__pbO7o","Form__AdminCheckMargin":"job-filter_Form__AdminCheckMargin__uVOsX","CompanyProfile__BrandingGuide":"job-filter_CompanyProfile__BrandingGuide__c1NZn","CompanyProfile__DropBoxContainer":"job-filter_CompanyProfile__DropBoxContainer__nnt_x","CompanyProfile__Browse":"job-filter_CompanyProfile__Browse__uDuv4","ErrorLabel":"job-filter_ErrorLabel__xzyJs","Height80":"job-filter_Height80__W8rH_","Browse__ButtonFlexEnd":"job-filter_Browse__ButtonFlexEnd__Xmf49","AddAgency__Container":"job-filter_AddAgency__Container__ITSx6","AddAgency__FormInputSection":"job-filter_AddAgency__FormInputSection__67J_W","AddAgency__FormInputSection__Label":"job-filter_AddAgency__FormInputSection__Label__mlx0G","AddAgency__Form":"job-filter_AddAgency__Form__8Ls_e","LinkAsButtons":"job-filter_LinkAsButtons__Th5yT","SearchFlex":"job-filter_SearchFlex__LgOjU","Form__ErrorCustomSelect":"job-filter_Form__ErrorCustomSelect__8lsA0","Form__select_currency":"job-filter_Form__select_currency__fvtIC","customSelect__placeholder":"job-filter_customSelect__placeholder__2DgkH","Career":"job-filter_Career__td3lU","Career__Background_Edit":"job-filter_Career__Background_Edit__VLP5N","Career__Background_Edit_Image":"job-filter_Career__Background_Edit_Image__K3sQf","Career__Container":"job-filter_Career__Container__MQSSG","Career__Inner":"job-filter_Career__Inner__uUW02","Career__logo":"job-filter_Career__logo__1CCGJ","Career__Content":"job-filter_Career__Content__BA3R6","Career__ButtonSection":"job-filter_Career__ButtonSection__gbGZg","Job":"job-filter_Job__6v_Ou","Job__Inner":"job-filter_Job__Inner__M6Fes","Job__Container":"job-filter_Job__Container__8Kdbr","Job__Heading":"job-filter_Job__Heading__SQD15","Job__Company":"job-filter_Job__Company__8p9nC","Job__SearchContainer":"job-filter_Job__SearchContainer__QZe1o","Job__SearchInput":"job-filter_Job__SearchInput__wcQcI","Job__Searchbtn":"job-filter_Job__Searchbtn__0Lm_t","Job__Input":"job-filter_Job__Input__5dbR1","Job__SelectJob":"job-filter_Job__SelectJob__G_3_g","Job__RemoteLabel":"job-filter_Job__RemoteLabel___mEai","Job__Display":"job-filter_Job__Display__umg_J","Job__PostDay":"job-filter_Job__PostDay__3CCN4","Job__Title":"job-filter_Job__Title__j3IMV","Job__Location":"job-filter_Job__Location__MTjGW","DT":"job-filter_DT__tEvR3","DisplayTable":"job-filter_DisplayTable__zSt5C","pd11":"job-filter_pd11__W_kiB","Label":"job-filter_Label__NUite","inputwidth":"job-filter_inputwidth__oufab","mr24":"job-filter_mr24__UXYtA","fullwidth":"job-filter_fullwidth__WLMTT","padt40":"job-filter_padt40__iVvRG","Form__TableRowflex":"job-filter_Form__TableRowflex__y19gh","Form__TableColm":"job-filter_Form__TableColm__AtYrz","Form__Error":"job-filter_Form__Error__OmRT1","Form__ErrorSection":"job-filter_Form__ErrorSection__tyERt","Form__MessagePlaceholder":"job-filter_Form__MessagePlaceholder__mvKlo","Form__Submit":"job-filter_Form__Submit___zTfa","Form__NormalLabel":"job-filter_Form__NormalLabel__x_Mfy","AddInterview":"job-filter_AddInterview___qz8s","IntegrationPage":"job-filter_IntegrationPage__k_1Lt","Integration__BackStep":"job-filter_Integration__BackStep__p2U4Y","AddUsers__BackStep":"job-filter_AddUsers__BackStep__kUhuE","Integration__SubmitSection":"job-filter_Integration__SubmitSection__avP1v","IntegrationTable":"job-filter_IntegrationTable__VlJok","IntegrationTable__LimitInput":"job-filter_IntegrationTable__LimitInput__HyImV","IntegrationTable__Type":"job-filter_IntegrationTable__Type__b__N5","IntegrationTable__AllJobsToggle":"job-filter_IntegrationTable__AllJobsToggle__LxOY6","IntegrationTable__switch":"job-filter_IntegrationTable__switch___3JyX","IntegrationTable__switchText":"job-filter_IntegrationTable__switchText__YKHFB","IntegrationTable__slider":"job-filter_IntegrationTable__slider__TbyrG","IntegrationTable__round":"job-filter_IntegrationTable__round__g2Nk6","IntegrationTable__Action":"job-filter_IntegrationTable__Action__QpzSM","IntegrationView":"job-filter_IntegrationView__A2wep","IntegrationView__Title":"job-filter_IntegrationView__Title__r1KkV","IntegrationView__Subheading":"job-filter_IntegrationView__Subheading__HEleg","IntegrationView__BoxImage":"job-filter_IntegrationView__BoxImage__m6J2c","IntegrationView__Box":"job-filter_IntegrationView__Box__9VP6_","IntegrationView__BoxImage__InfoIcon":"job-filter_IntegrationView__BoxImage__InfoIcon__z0pk_","IntegrationView__ViewMoreButton":"job-filter_IntegrationView__ViewMoreButton__TWrs5","IntegrationView__ConnectButton":"job-filter_IntegrationView__ConnectButton__YR4Y_","IntegrationView__GoogleButton":"job-filter_IntegrationView__GoogleButton__XL6oB","IntegrationView__FlexFlow":"job-filter_IntegrationView__FlexFlow__6ofml","IntegrationView__BoxWidth":"job-filter_IntegrationView__BoxWidth__bWFwy","SkipFinishButton":"job-filter_SkipFinishButton__qGmoH","AddUsers":"job-filter_AddUsers__oBPiA","AddUsers__ButtonSection":"job-filter_AddUsers__ButtonSection__qP0jj","AddUsers__QuickStepHeading":"job-filter_AddUsers__QuickStepHeading__bIEGq","AddUsers__DeleteSection":"job-filter_AddUsers__DeleteSection__84vOk","AddUsers__DeleteCrossHeight":"job-filter_AddUsers__DeleteCrossHeight__aOAxB","AddUsers__Form__Input":"job-filter_AddUsers__Form__Input__CFGMp","AddUsers__FormHeadingSection":"job-filter_AddUsers__FormHeadingSection__p_3sX","AddUsers__FormSection":"job-filter_AddUsers__FormSection__bhDjg","NewJob__FormSection":"job-filter_NewJob__FormSection__2cdff","AddUsers__ButtonsActionSection":"job-filter_AddUsers__ButtonsActionSection___1nXu","AddUsers__ImportUsers":"job-filter_AddUsers__ImportUsers__02UT3","AddUsers__NameInput":"job-filter_AddUsers__NameInput__Aslqn","AddUsers__EmailInput":"job-filter_AddUsers__EmailInput__MmwBd","AddUsers__RoleInput":"job-filter_AddUsers__RoleInput__R5t2h","AddUsers__Subheading":"job-filter_AddUsers__Subheading__1tqga","AddUsers__visible":"job-filter_AddUsers__visible__RMBrr","Tagrow":"job-filter_Tagrow__DCWSU","Tagrow__Tags":"job-filter_Tagrow__Tags__iVcIe","Tagrow__Cancel":"job-filter_Tagrow__Cancel__TLlId","SendInviteSection":"job-filter_SendInviteSection__EVAuK","error":"job-filter_error__PSBGU","ViewJobPage__Input":"job-filter_ViewJobPage__Input__EfAnZ","Form__Input2":"job-filter_Form__Input2__Irr7m","ViewJobPage__PostDay":"job-filter_ViewJobPage__PostDay__J9lsS","ViewJobPage__Title":"job-filter_ViewJobPage__Title__ugpS5","ViewJobPage__DescriptionTitle":"job-filter_ViewJobPage__DescriptionTitle__rvjZe","ViewJobPage__Location":"job-filter_ViewJobPage__Location__V_GuU","ViewJobPage__primarybtn":"job-filter_ViewJobPage__primarybtn__ddHBP","ViewJobPage__secondarybtn":"job-filter_ViewJobPage__secondarybtn__WxOie","ViewJobPage__secondarybtnborder":"job-filter_ViewJobPage__secondarybtnborder__pXK0I","ViewJobPage__BackSection":"job-filter_ViewJobPage__BackSection__NnYBq","ViewJobPage__Content":"job-filter_ViewJobPage__Content__r6Di7","ViewJobPage":"job-filter_ViewJobPage__jIqVy","ViewJobPage__Header":"job-filter_ViewJobPage__Header__mbOvV","ViewJobPage__Application":"job-filter_ViewJobPage__Application__RnkSV","ViewJobPage__RecordVideo":"job-filter_ViewJobPage__RecordVideo__ciDdD","ViewJobPage__RecordVideoSuccessText":"job-filter_ViewJobPage__RecordVideoSuccessText__LimSr","ViewJobPage__subheading":"job-filter_ViewJobPage__subheading__i3vM4","ViewJobPage__confirmation":"job-filter_ViewJobPage__confirmation__9gS17","ViewJobPage__Logo":"job-filter_ViewJobPage__Logo__9BEoR","ViewJobPage__BrandLogo":"job-filter_ViewJobPage__BrandLogo__Gmmzv","ViewJobPage__BrandLogo__Padding10":"job-filter_ViewJobPage__BrandLogo__Padding10__UqRFn","ViewJobPage__Container":"job-filter_ViewJobPage__Container__8muK2","ViewJobPage__JobContent":"job-filter_ViewJobPage__JobContent___5kg5","ViewJobPage__Sidebar":"job-filter_ViewJobPage__Sidebar__VMT20","ViewJobPage__Sidebar2":"job-filter_ViewJobPage__Sidebar2__u3yVj","ViewJobPage__Description":"job-filter_ViewJobPage__Description__rbEQ7","ViewJobPage__DescriptionWidth":"job-filter_ViewJobPage__DescriptionWidth__zdcyl","ViewJobPage__Footer":"job-filter_ViewJobPage__Footer__uozmV","ViewJobPage__FooterView":"job-filter_ViewJobPage__FooterView__JA400","ViewJobPage__ShareJob":"job-filter_ViewJobPage__ShareJob__nnlFE","ViewJobPage__SubmitSection":"job-filter_ViewJobPage__SubmitSection__OcoUj","ViewJobPage__SocialMedia":"job-filter_ViewJobPage__SocialMedia__TVag5","ViewJobPage__SideContent":"job-filter_ViewJobPage__SideContent__vNxPv","ViewJobPage__ApplySection":"job-filter_ViewJobPage__ApplySection__RBbXi","FormBox__Autofill":"job-filter_FormBox__Autofill__j8t7N","applybuttons":"job-filter_applybuttons__mSF7z","height90":"job-filter_height90__b1ar3","Form__Cont":"job-filter_Form__Cont__oLco5","Form__DropBox":"job-filter_Form__DropBox__eUOAK","Form__DropBoxcontainer":"job-filter_Form__DropBoxcontainer__Mw8l7","Form__DropBoxError":"job-filter_Form__DropBoxError__iXXi3","Form__DropBoxicon":"job-filter_Form__DropBoxicon__N9t1k","Form__DropBoxmessage":"job-filter_Form__DropBoxmessage__IFRJ0","noDpGrid":"job-filter_noDpGrid__zESWU","Terms":"job-filter_Terms__h1_aJ","TermsCondition":"job-filter_TermsCondition__I41ve","TermsCondition__alignterms":"job-filter_TermsCondition__alignterms__usHID","MenuContainer":"job-filter_MenuContainer__MPXW5","MenuContainer__Menu":"job-filter_MenuContainer__Menu__0MmZK","AgencyDetailPage":"job-filter_AgencyDetailPage__UgkY6","Congrats__ModalContent":"job-filter_Congrats__ModalContent__06CTZ","NewJob__Container":"job-filter_NewJob__Container__dUTXq","NewJob__TopSection":"job-filter_NewJob__TopSection__NZhYA","NewJob__HorizontalDivider":"job-filter_NewJob__HorizontalDivider__85oc2","NewJob__Wrapper":"job-filter_NewJob__Wrapper__7yZ8t","NewJob__ContainerPadding":"job-filter_NewJob__ContainerPadding__rx2GC","NewJob__ContainerScroll":"job-filter_NewJob__ContainerScroll__SpMqc","NewJob__ContainerHeight":"job-filter_NewJob__ContainerHeight__JtCgc","NewJob__ImportAction":"job-filter_NewJob__ImportAction__gvApb","NewJob__Interview_buttons":"job-filter_NewJob__Interview_buttons__rZ165","Form__TableRowMB":"job-filter_Form__TableRowMB__EEv7_","Form__TableRow3grid":"job-filter_Form__TableRow3grid__xHvEU","Form__Remotegrid":"job-filter_Form__Remotegrid__Xf7EH","Form__TypeList":"job-filter_Form__TypeList__AxT5R","Form__Type":"job-filter_Form__Type__tAkOx","Form__CheckLabel":"job-filter_Form__CheckLabel___xRN9","PrivateSwitchBase-root-1":"job-filter_PrivateSwitchBase-root-1__91U_M","Form__Caption":"job-filter_Form__Caption__5WLQ3","Form__Input_currency":"job-filter_Form__Input_currency__CUX3t","Form__Input_MatchScore":"job-filter_Form__Input_MatchScore__tk3Pa","Form__Percentage_Symbol":"job-filter_Form__Percentage_Symbol__GOSEZ","Form__NoGridTemplate":"job-filter_Form__NoGridTemplate__AbIRc","active":"job-filter_active__HY9zb","mt10":"job-filter_mt10__9EvIq","mt40":"job-filter_mt40__DHTdT","mt30":"job-filter_mt30__KZ3n9","mt32":"job-filter_mt32__T1DoP","mb0":"job-filter_mb0__lBC5C","Dpgrid":"job-filter_Dpgrid__yoSPH","mb12":"job-filter_mb12__w_6wE","width100":"job-filter_width100__CysDw","Tagrow__Prefix":"job-filter_Tagrow__Prefix__nB_4I","PreviewJobPage":"job-filter_PreviewJobPage__7QlPX","PreviewJob":"job-filter_PreviewJob__BgCWD","DpFlx":"job-filter_DpFlx__qd0fl","Subheading":"job-filter_Subheading__vPg55","Subheading__Description":"job-filter_Subheading__Description__g6rNm","Candidate__Tooltip":"job-filter_Candidate__Tooltip__PLdEE","Candidate__Tooltip__Score":"job-filter_Candidate__Tooltip__Score__29k_Q","Form__InputField":"job-filter_Form__InputField__LlS3x","Candidate__Length":"job-filter_Candidate__Length__pOhJj","Agency__PostDay":"job-filter_Agency__PostDay__H4Nlx","Agency__Title":"job-filter_Agency__Title__Y58ty","Agency__Location":"job-filter_Agency__Location__ZfKlT","Agency__DescriptionTitle":"job-filter_Agency__DescriptionTitle__Vfamr","Agency__Description":"job-filter_Agency__Description__nQLVy","LightBlueColor":"job-filter_LightBlueColor__wX9F0","JobFilter":"job-filter_JobFilter__Y6rzr","JobFilter__Inner":"job-filter_JobFilter__Inner__UyWBi","JobFilter__Head":"job-filter_JobFilter__Head__yrSY8","JobFilter__SubmitSection":"job-filter_JobFilter__SubmitSection__RZrQo","JobFilter__EmailFilterBottom":"job-filter_JobFilter__EmailFilterBottom___2KOe","CropImage":"job-filter_CropImage__4Zc4i","CropImage__Actions":"job-filter_CropImage__Actions__lqWJz","CropImage__Inner":"job-filter_CropImage__Inner__iUTUS","CropImage__Head":"job-filter_CropImage__Head__mizUz","CropImage__SubmitSection":"job-filter_CropImage__SubmitSection__3k9Hx","ModalClose":"job-filter_ModalClose__N_8tg","Form__gap16":"job-filter_Form__gap16__q4p_I","fontslabel":"job-filter_fontslabel__a9VK_"};

/***/ }),

/***/ 95150:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Modalpopup":"job-live_Modalpopup__RZ_k_","Modalpopup__inner":"job-live_Modalpopup__inner__S8rzG","JobLive__inner":"job-live_JobLive__inner__Lr3dQ","JobLive__inneroffer":"job-live_JobLive__inneroffer__yhhLA","JobLive__inneroffersent":"job-live_JobLive__inneroffersent__DMPXx","Modalpopup__Dialog":"job-live_Modalpopup__Dialog__5zXRb","transition":"job-live_transition__3RjBa","Modalpopup__CloseCenter":"job-live_Modalpopup__CloseCenter__ClV11","Modalpopup__Content":"job-live_Modalpopup__Content__AtOtc","JobLive__Content":"job-live_JobLive__Content__qCv2w","Modalpopup__btn":"job-live_Modalpopup__btn__rQ8PS","JobLive__btn":"job-live_JobLive__btn__tN4_w","mar":"job-live_mar__4LWQ6","Otpback":"job-live_Otpback__AgUVh","Form":"job-live_Form__8YIi0","Form__width":"job-live_Form__width__ztrGf","Form__label":"job-live_Form__label__ivyNY","Form__textleft":"job-live_Form__textleft__838WN","Form__InputFullWidth":"job-live_Form__InputFullWidth__3guIy","Form__Input":"job-live_Form__Input__oDXCN","Form__Input398":"job-live_Form__Input398__2SN5J","Form__InputSection":"job-live_Form__InputSection__f5UDh","Form__ScoreCardInput":"job-live_Form__ScoreCardInput__UnFzv","Form__Textarea":"job-live_Form__Textarea__ba4LX","primarybtn":"job-live_primarybtn__ib3q3","secondarybtn":"job-live_secondarybtn__4kCJo","iconFilled":"job-live_iconFilled__2eLQy","iconFilledSolid":"job-live_iconFilledSolid__LjIlj","primarybtnborder":"job-live_primarybtnborder__1SwkP","secondarybtnborder":"job-live_secondarybtnborder__z2kM5","tertiarybtn":"job-live_tertiarybtn__t3xWO","graybtnborder":"job-live_graybtnborder__e83UF","jobsrchbtn":"job-live_jobsrchbtn__wngQr","jobsrchbtnalign":"job-live_jobsrchbtnalign__3ypUu","nobgbutton":"job-live_nobgbutton__pCIKO","iconTextButton":"job-live_iconTextButton__UDngg","cursornone":"job-live_cursornone__tOoHU","nobgbuttonprimary":"job-live_nobgbuttonprimary__NpoUy","mt15":"job-live_mt15__RgaOt","btn350":"job-live_btn350__T16Ij","GrayBgBtn":"job-live_GrayBgBtn__KvKCc","NewShareBtn":"job-live_NewShareBtn__SL9tT","CoralBgBtn":"job-live_CoralBgBtn__NszNi","DropContainer":"job-live_DropContainer__ZdcjZ","DropContainer__Inner":"job-live_DropContainer__Inner__1qYpO","CompanyProfile__Inner":"job-live_CompanyProfile__Inner__1qerp","DropContainer__Message":"job-live_DropContainer__Message__RzWCD","CompanyProfile__Message":"job-live_CompanyProfile__Message__xjUVn","CompanyProfile__MessageContent":"job-live_CompanyProfile__MessageContent__RE6sw","DropContainer__UploadIcon":"job-live_DropContainer__UploadIcon__6Ig37","CompanyProfile__UploadIcon":"job-live_CompanyProfile__UploadIcon__dMm3g","FileDisplayContainer":"job-live_FileDisplayContainer__b4p5N","FileDisplayContainer__Status":"job-live_FileDisplayContainer__Status__qm1X4","FileDisplayContainer__Type":"job-live_FileDisplayContainer__Type__MV6aF","FileDisplayContainer__Name":"job-live_FileDisplayContainer__Name__vjNVO","FileDisplayContainer__Error":"job-live_FileDisplayContainer__Error__aB_0e","FileDisplayContainer__Close":"job-live_FileDisplayContainer__Close__NdJLM","Browse":"job-live_Browse__AoH76","ClientCompany":"job-live_ClientCompany__lrt_L","ClientCompany__TopSection2":"job-live_ClientCompany__TopSection2__PwFbF","ClientCompany__Filter":"job-live_ClientCompany__Filter__zoTxA","ClientCompany__Input_MatchScore":"job-live_ClientCompany__Input_MatchScore__C_JQr","ClientCompany__Percentage_Symbol":"job-live_ClientCompany__Percentage_Symbol__m17cn","ClientCompany__Filterheading":"job-live_ClientCompany__Filterheading__HQjpS","ClientCompany__FloatButtonAdd":"job-live_ClientCompany__FloatButtonAdd__REb2S","ClientCompany__FloatButtonAdd__AgencyUserIcon":"job-live_ClientCompany__FloatButtonAdd__AgencyUserIcon___mhe1","ClientCompany__LastEdited":"job-live_ClientCompany__LastEdited__xn287","ClientCompany__BackSection":"job-live_ClientCompany__BackSection__9uzFO","JobLive__BackSection":"job-live_JobLive__BackSection__8r4I4","ClientCompany__BackSection__CloseIcon":"job-live_ClientCompany__BackSection__CloseIcon__MzQGb","ClientCompany__Container":"job-live_ClientCompany__Container__HV_Vm","ClientCompany__FormInputSection":"job-live_ClientCompany__FormInputSection__pBLO5","CompanyProfile__FormInputSection":"job-live_CompanyProfile__FormInputSection__WDk3W","ClientCompany__Heading":"job-live_ClientCompany__Heading__LVNfi","ClientCompany__StatusAlignment":"job-live_ClientCompany__StatusAlignment__hU0Qf","ClientCompany__Status":"job-live_ClientCompany__Status__XOCSx","ClientCompany__ActiveDot":"job-live_ClientCompany__ActiveDot__unq_x","ClientCompany__CloseDot":"job-live_ClientCompany__CloseDot__RXuPr","ClientCompany__Company":"job-live_ClientCompany__Company__OAKBd","ClientCompany__Systemrefheding":"job-live_ClientCompany__Systemrefheding__IRTYT","ClientCompany__Subheading":"job-live_ClientCompany__Subheading__r2JNB","CompanyProfile__Subheading":"job-live_CompanyProfile__Subheading__MD4gP","ClientCompany__Subheading2":"job-live_ClientCompany__Subheading2__WrdrO","ClientCompany__Description":"job-live_ClientCompany__Description__qXZby","ClientCompany__SubmitSection":"job-live_ClientCompany__SubmitSection__wi2rX","ClientCompany__IntegrationImage":"job-live_ClientCompany__IntegrationImage__NQ3M0","ClientCompany__QuickAdd":"job-live_ClientCompany__QuickAdd__QJeb_","ClientCompany__BodyText":"job-live_ClientCompany__BodyText__ud6v0","Form__TableRow":"job-live_Form__TableRow__c3jAS","Form__Label":"job-live_Form__Label__oBHcV","Form__FloatingLabel":"job-live_Form__FloatingLabel__7jH1w","Form__TableCol":"job-live_Form__TableCol__5hi5A","Form__currency_symbol":"job-live_Form__currency_symbol__HADtk","Form__CustomSelect":"job-live_Form__CustomSelect__44rdL","Form__currency_symbol__right":"job-live_Form__currency_symbol__right__icFWv","Form__TableCol__Disabled":"job-live_Form__TableCol__Disabled__FMbb5","Form__TextareaDisabled":"job-live_Form__TextareaDisabled__1EuXW","Form__EditorDisabled":"job-live_Form__EditorDisabled__yh9WA","Form__AdminCheckLabel":"job-live_Form__AdminCheckLabel__MhTDy","Form__AdminCheckMargin":"job-live_Form__AdminCheckMargin__pYCMP","CompanyProfile__BrandingGuide":"job-live_CompanyProfile__BrandingGuide__8HSS2","CompanyProfile__DropBoxContainer":"job-live_CompanyProfile__DropBoxContainer__b9A9a","CompanyProfile__Browse":"job-live_CompanyProfile__Browse__kp5kU","ErrorLabel":"job-live_ErrorLabel___LePB","Height80":"job-live_Height80__w7oYN","Browse__ButtonFlexEnd":"job-live_Browse__ButtonFlexEnd__wGlf7","AddAgency__Container":"job-live_AddAgency__Container__fLenK","AddAgency__FormInputSection":"job-live_AddAgency__FormInputSection__dnYrm","AddAgency__FormInputSection__Label":"job-live_AddAgency__FormInputSection__Label__Rp6r5","AddAgency__Form":"job-live_AddAgency__Form__iaiT4","LinkAsButtons":"job-live_LinkAsButtons__hhSno","SearchFlex":"job-live_SearchFlex__OQ1oW","JobLive__Content__mw90":"job-live_JobLive__Content__mw90__5ALdo","JobLive__Confetti":"job-live_JobLive__Confetti__dl3e4","JobLive__SocialMedia":"job-live_JobLive__SocialMedia__bx6_e","JobLive__Url":"job-live_JobLive__Url__6bfYm","JobLive__copyBtn":"job-live_JobLive__copyBtn__URfgx"};

/***/ }),

/***/ 55264:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"AddAssessment__inner":"add-assessment_AddAssessment__inner__7e7r7","AddAssessment__Content":"add-assessment_AddAssessment__Content__xAoc5","AddAssessment__ContentBlock":"add-assessment_AddAssessment__ContentBlock__h85_s","AddAssessment__SlotsAvailablity":"add-assessment_AddAssessment__SlotsAvailablity__DZiY2","AddAssessment__Footer":"add-assessment_AddAssessment__Footer__UkuH6","AddAssessment__SubHeading":"add-assessment_AddAssessment__SubHeading__bPQiO","OtpBacksection2":"add-assessment_OtpBacksection2__ju3Q0","Form__Input":"add-assessment_Form__Input__vwFlU","DividerOr":"add-assessment_DividerOr__AAqjh","AutomationDividerOr":"add-assessment_AutomationDividerOr__Fl77i","DropBox":"add-assessment_DropBox__mffdP","Form__DropBoxcontainer":"add-assessment_Form__DropBoxcontainer__Php6c","LabelNote":"add-assessment_LabelNote__OLmJr"};

/***/ }),

/***/ 61790:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Modal":"single-candidate-modal_Modal__MSsis","Modal__inner":"single-candidate-modal_Modal__inner__OyKMV","Modal__Dialog":"single-candidate-modal_Modal__Dialog__3g7n4","transition":"single-candidate-modal_transition__b6Hjj","Modal__Dialog__Centered":"single-candidate-modal_Modal__Dialog__Centered__qsPBw","Modal__Content":"single-candidate-modal_Modal__Content__y5z_a","Modal__Header":"single-candidate-modal_Modal__Header__3ofsC","Modal__Header__Close":"single-candidate-modal_Modal__Header__Close__TEp_r","Modal__Body":"single-candidate-modal_Modal__Body__s7NUQ","Modal__Body__SubHeading":"single-candidate-modal_Modal__Body__SubHeading__jPPjb","Modal__Body__MainHeading":"single-candidate-modal_Modal__Body__MainHeading__f8iuD","Modal__Body__HeadingPlusScore":"single-candidate-modal_Modal__Body__HeadingPlusScore__DUqbg","Modal__Body__OverallScore":"single-candidate-modal_Modal__Body__OverallScore___krPy","Modal__Body__OverallScoreValue":"single-candidate-modal_Modal__Body__OverallScoreValue__CcuAd","Modal__Footer":"single-candidate-modal_Modal__Footer__V1Mhy","Modal__FadeIn":"single-candidate-modal_Modal__FadeIn__Dvwyf","fadeIn":"single-candidate-modal_fadeIn__wSPit","Tagrow":"single-candidate-modal_Tagrow__qcm3O","Tagrow__Tags":"single-candidate-modal_Tagrow__Tags__hEhDl","Tagrow__Cancel":"single-candidate-modal_Tagrow__Cancel__r8fd0","Tagrow__Prefix":"single-candidate-modal_Tagrow__Prefix__NaWvp"};

/***/ }),

/***/ 93210:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"RejectModal__inner":"reject-modal_RejectModal__inner__nQAxt","RejectModal__Content":"reject-modal_RejectModal__Content___ZPqe","RejectModal__ContentBlock":"reject-modal_RejectModal__ContentBlock__zF9k_","RejectModal__SubmitSectionSave":"reject-modal_RejectModal__SubmitSectionSave__Um_9n","OtpBacksection2":"reject-modal_OtpBacksection2__vVmbF","Otpback":"reject-modal_Otpback__eEtX4"};

/***/ }),

/***/ 92626:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Modalpopup":"request-for-more_Modalpopup__9VEhk","Modalpopup__inner":"request-for-more_Modalpopup__inner__xQdHG","Modalpopup__Dialog":"request-for-more_Modalpopup__Dialog__bzxGh","transition":"request-for-more_transition__pAPeq","Modalpopup__CloseCenter":"request-for-more_Modalpopup__CloseCenter__E4GX_","Modalpopup__Content":"request-for-more_Modalpopup__Content__oUGmV","SetupPopup__PaddingPopup":"request-for-more_SetupPopup__PaddingPopup__hwJEG","SetupPopup__ContentCustomisation":"request-for-more_SetupPopup__ContentCustomisation__Un9Sd","SetupPopup__Contentwithoutpadding":"request-for-more_SetupPopup__Contentwithoutpadding__A2I_2","Modalpopup__btn":"request-for-more_Modalpopup__btn__5bkcU","mar":"request-for-more_mar__DVDDv","Otpback":"request-for-more_Otpback__2yCC3","Form":"request-for-more_Form__jNedH","Form__width":"request-for-more_Form__width__u4DYy","Form__label":"request-for-more_Form__label__dX0hJ","Form__textleft":"request-for-more_Form__textleft__VhXZh","Form__InputFullWidth":"request-for-more_Form__InputFullWidth__7Ua5l","Form__Input":"request-for-more_Form__Input__P3Ixh","Form__Input398":"request-for-more_Form__Input398__7Ni0z","Form__InputSection":"request-for-more_Form__InputSection__YkyKX","Form__ScoreCardInput":"request-for-more_Form__ScoreCardInput__lbcAa","Form__Textarea":"request-for-more_Form__Textarea__1_R4j","primarybtn":"request-for-more_primarybtn__UEBs2","GoBtn":"request-for-more_GoBtn__lbepG","secondarybtn":"request-for-more_secondarybtn__6I__O","iconFilled":"request-for-more_iconFilled__hDXec","iconFilledSolid":"request-for-more_iconFilledSolid__Ylh0_","primarybtnborder":"request-for-more_primarybtnborder__KXwWY","secondarybtnborder":"request-for-more_secondarybtnborder__fmOH3","ClearBtn":"request-for-more_ClearBtn__Jmrls","tertiarybtn":"request-for-more_tertiarybtn__IxcJ1","graybtnborder":"request-for-more_graybtnborder__BW1Rp","jobsrchbtn":"request-for-more_jobsrchbtn__T2yLR","jobsrchbtnalign":"request-for-more_jobsrchbtnalign__JJ4zy","nobgbutton":"request-for-more_nobgbutton__VDNPL","iconTextButton":"request-for-more_iconTextButton__mUJUw","cursornone":"request-for-more_cursornone__5aGIb","nobgbuttonprimary":"request-for-more_nobgbuttonprimary__oVikj","mt15":"request-for-more_mt15__VISso","btn350":"request-for-more_btn350__2Xsn4","GrayBgBtn":"request-for-more_GrayBgBtn__SzOhP","NewShareBtn":"request-for-more_NewShareBtn__cGiNg","CoralBgBtn":"request-for-more_CoralBgBtn__agVfA","DropContainer":"request-for-more_DropContainer__CGZ2m","DropContainer__Inner":"request-for-more_DropContainer__Inner__aH836","CompanyProfile__Inner":"request-for-more_CompanyProfile__Inner__Qcccq","DropContainer__Message":"request-for-more_DropContainer__Message__bk3mU","CompanyProfile__Message":"request-for-more_CompanyProfile__Message__MVIXt","CompanyProfile__MessageContent":"request-for-more_CompanyProfile__MessageContent__4R7Uz","DropContainer__UploadIcon":"request-for-more_DropContainer__UploadIcon__4xlz6","CompanyProfile__UploadIcon":"request-for-more_CompanyProfile__UploadIcon__Uq5Kv","FileDisplayContainer":"request-for-more_FileDisplayContainer__CrwTb","FileDisplayContainer__Status":"request-for-more_FileDisplayContainer__Status__Fi4x7","SetupPopup__Status":"request-for-more_SetupPopup__Status__Wy3ET","SetupPopup__To":"request-for-more_SetupPopup__To__70JGY","FileDisplayContainer__Type":"request-for-more_FileDisplayContainer__Type__VAkOS","FileDisplayContainer__Name":"request-for-more_FileDisplayContainer__Name__OTceV","SetupPopup__Name":"request-for-more_SetupPopup__Name__A1b5K","SetupPopup__ToName":"request-for-more_SetupPopup__ToName__UUoey","FileDisplayContainer__Error":"request-for-more_FileDisplayContainer__Error__EKCv4","FileDisplayContainer__Close":"request-for-more_FileDisplayContainer__Close__F0B0G","Browse":"request-for-more_Browse__98RGg","ClientCompany":"request-for-more_ClientCompany__2_t__","NewJob":"request-for-more_NewJob__toeXl","Interview":"request-for-more_Interview__afoVw","ClientCompany__TopSection2":"request-for-more_ClientCompany__TopSection2__41Zuu","ClientCompany__Filter":"request-for-more_ClientCompany__Filter__JNb_l","ClientCompany__Input_MatchScore":"request-for-more_ClientCompany__Input_MatchScore__mfI6a","ClientCompany__Percentage_Symbol":"request-for-more_ClientCompany__Percentage_Symbol__pa5cU","ClientCompany__Filterheading":"request-for-more_ClientCompany__Filterheading__mpnpi","ClientCompany__FloatButtonAdd":"request-for-more_ClientCompany__FloatButtonAdd__Rtngt","ClientCompany__FloatButtonAdd__AgencyUserIcon":"request-for-more_ClientCompany__FloatButtonAdd__AgencyUserIcon__bqZmy","ClientCompany__LastEdited":"request-for-more_ClientCompany__LastEdited__dUY6W","ClientCompany__BackSection":"request-for-more_ClientCompany__BackSection__L_RAU","AddUsers__BackSection":"request-for-more_AddUsers__BackSection__S2BEO","ClientCompany__BackSection__CloseIcon":"request-for-more_ClientCompany__BackSection__CloseIcon__tyTCf","ClientCompany__Container":"request-for-more_ClientCompany__Container__WxVsq","NewJob__InterviewContainer":"request-for-more_NewJob__InterviewContainer__V_znC","AddUsers__Container":"request-for-more_AddUsers__Container__hsxW_","ClientCompany__FormInputSection":"request-for-more_ClientCompany__FormInputSection__y1_zh","CompanyProfile__FormInputSection":"request-for-more_CompanyProfile__FormInputSection__cKGbM","ClientCompany__Heading":"request-for-more_ClientCompany__Heading__SwS8g","AddUsers__Heading":"request-for-more_AddUsers__Heading__nCj1s","ClientCompany__StatusAlignment":"request-for-more_ClientCompany__StatusAlignment__u0REE","ClientCompany__Status":"request-for-more_ClientCompany__Status__rgKeT","ClientCompany__ActiveDot":"request-for-more_ClientCompany__ActiveDot__e3vtt","ClientCompany__CloseDot":"request-for-more_ClientCompany__CloseDot__ojS3T","ClientCompany__Company":"request-for-more_ClientCompany__Company__oDC6g","AddUsers__User":"request-for-more_AddUsers__User__js4JV","ClientCompany__Systemrefheding":"request-for-more_ClientCompany__Systemrefheding__nvaaC","ClientCompany__Subheading":"request-for-more_ClientCompany__Subheading__K1R5n","CompanyProfile__Subheading":"request-for-more_CompanyProfile__Subheading__rOBjZ","ClientCompany__Subheading2":"request-for-more_ClientCompany__Subheading2__T1IL2","ClientCompany__Description":"request-for-more_ClientCompany__Description__9hkvD","ClientCompany__SubmitSection":"request-for-more_ClientCompany__SubmitSection__1HWFW","NewJob__SubmitSection":"request-for-more_NewJob__SubmitSection__CME4q","NewJob__SubmitSectionThreeBtn":"request-for-more_NewJob__SubmitSectionThreeBtn___pcY2","NewJob__SubmitSectionOneBtnPlacement":"request-for-more_NewJob__SubmitSectionOneBtnPlacement__NyIjt","NewJob__ImportSection":"request-for-more_NewJob__ImportSection__fRn1c","SetupPopup__SubmitSection2":"request-for-more_SetupPopup__SubmitSection2__zxjuh","SetupPopup__SubmitSection":"request-for-more_SetupPopup__SubmitSection__Yy9DM","SetupPopup__SubmitSection3":"request-for-more_SetupPopup__SubmitSection3__N74cj","AddUsers__SubmitSection":"request-for-more_AddUsers__SubmitSection__psJWC","ClientCompany__IntegrationImage":"request-for-more_ClientCompany__IntegrationImage__Z2qaG","ClientCompany__QuickAdd":"request-for-more_ClientCompany__QuickAdd__KfSMx","NewJob__QuickAdd":"request-for-more_NewJob__QuickAdd__Q0WV8","Interview__QuickAdd":"request-for-more_Interview__QuickAdd__E8tjZ","ClientCompany__BodyText":"request-for-more_ClientCompany__BodyText__s5ede","Form__TableRow":"request-for-more_Form__TableRow__p4AX1","Form__Label":"request-for-more_Form__Label___Shjr","Form__FloatingLabel":"request-for-more_Form__FloatingLabel__OraD2","Form__TableCol":"request-for-more_Form__TableCol__Sadj3","Form__currency_symbol":"request-for-more_Form__currency_symbol__XlLqe","Form__CustomSelect":"request-for-more_Form__CustomSelect__6FJX8","Form__currency_symbol__right":"request-for-more_Form__currency_symbol__right__nMhur","Form__TableCol__Disabled":"request-for-more_Form__TableCol__Disabled__DXy4u","Form__TextareaDisabled":"request-for-more_Form__TextareaDisabled__dNwRl","Form__EditorDisabled":"request-for-more_Form__EditorDisabled__mUxMU","Form__AdminCheckLabel":"request-for-more_Form__AdminCheckLabel__uJWh9","Form__AdminCheckMargin":"request-for-more_Form__AdminCheckMargin__U6Yun","CompanyProfile__BrandingGuide":"request-for-more_CompanyProfile__BrandingGuide__mtczz","CompanyProfile__DropBoxContainer":"request-for-more_CompanyProfile__DropBoxContainer__L2BNk","CompanyProfile__Browse":"request-for-more_CompanyProfile__Browse__FxfRy","ErrorLabel":"request-for-more_ErrorLabel__5mujw","Height80":"request-for-more_Height80__BJZTJ","Browse__ButtonFlexEnd":"request-for-more_Browse__ButtonFlexEnd__nENaG","AddAgency__Container":"request-for-more_AddAgency__Container__gNJUs","AddAgency__FormInputSection":"request-for-more_AddAgency__FormInputSection__509Ho","AddAgency__FormInputSection__Label":"request-for-more_AddAgency__FormInputSection__Label__uVh11","AddAgency__Form":"request-for-more_AddAgency__Form__vM7FS","LinkAsButtons":"request-for-more_LinkAsButtons__gXujC","SearchFlex":"request-for-more_SearchFlex__LF__l","Form__ErrorCustomSelect":"request-for-more_Form__ErrorCustomSelect__IzFJD","Form__select_currency":"request-for-more_Form__select_currency__MLhyu","customSelect__placeholder":"request-for-more_customSelect__placeholder__OldTz","Career":"request-for-more_Career__8lA89","Career__Background_Edit":"request-for-more_Career__Background_Edit__fpfr7","Career__Background_Edit_Image":"request-for-more_Career__Background_Edit_Image__tz8D2","Career__Container":"request-for-more_Career__Container__QcIuE","Career__Inner":"request-for-more_Career__Inner__zxcuW","Career__logo":"request-for-more_Career__logo__nrP5_","Career__Content":"request-for-more_Career__Content__wed_7","Career__ButtonSection":"request-for-more_Career__ButtonSection__WgVWU","Job":"request-for-more_Job__WuGQR","Job__Inner":"request-for-more_Job__Inner__sWGX0","Job__Container":"request-for-more_Job__Container__0Az3g","Job__Heading":"request-for-more_Job__Heading__HzDaL","Job__Company":"request-for-more_Job__Company__bNrop","Job__SearchContainer":"request-for-more_Job__SearchContainer__v_LbE","Job__SearchInput":"request-for-more_Job__SearchInput__5LuXi","Job__Searchbtn":"request-for-more_Job__Searchbtn___kWvs","Job__Input":"request-for-more_Job__Input__TPLqk","Job__SelectJob":"request-for-more_Job__SelectJob__X1t5v","Job__RemoteLabel":"request-for-more_Job__RemoteLabel__zTc7A","Job__Display":"request-for-more_Job__Display__1DbcV","Job__PostDay":"request-for-more_Job__PostDay__K_6Ib","Job__Title":"request-for-more_Job__Title__caLOn","Job__Location":"request-for-more_Job__Location__eYMQM","DT":"request-for-more_DT__bMHlJ","DisplayTable":"request-for-more_DisplayTable__H8VMH","pd11":"request-for-more_pd11__zNdC7","Label":"request-for-more_Label__p0pHp","inputwidth":"request-for-more_inputwidth__s0Yil","mr24":"request-for-more_mr24__YroNN","fullwidth":"request-for-more_fullwidth__BruoC","padt40":"request-for-more_padt40__Sd6UF","Form__TableRowflex":"request-for-more_Form__TableRowflex__gezdY","Form__TableColm":"request-for-more_Form__TableColm__G_f46","Form__LabelCheck":"request-for-more_Form__LabelCheck__Gp6Mo","Form__Error":"request-for-more_Form__Error__UceuP","Form__ErrorSection":"request-for-more_Form__ErrorSection__ocegx","Form__MessagePlaceholder":"request-for-more_Form__MessagePlaceholder__JRzpa","Form__Submit":"request-for-more_Form__Submit__NQeDx","Form__NormalLabel":"request-for-more_Form__NormalLabel___qKNB","AddInterview":"request-for-more_AddInterview__NATt9","IntegrationPage":"request-for-more_IntegrationPage__W2g3m","Integration__BackStep":"request-for-more_Integration__BackStep__gnTf1","AddUsers__BackStep":"request-for-more_AddUsers__BackStep__vCB4C","Integration__SubmitSection":"request-for-more_Integration__SubmitSection__gvWF0","IntegrationTable":"request-for-more_IntegrationTable__JB71F","IntegrationTable__LimitInput":"request-for-more_IntegrationTable__LimitInput__pHUbd","IntegrationTable__Type":"request-for-more_IntegrationTable__Type__R_VzF","IntegrationTable__AllJobsToggle":"request-for-more_IntegrationTable__AllJobsToggle__EuHo2","IntegrationTable__switch":"request-for-more_IntegrationTable__switch__t7E3I","IntegrationTable__switchText":"request-for-more_IntegrationTable__switchText__7kqsQ","IntegrationTable__slider":"request-for-more_IntegrationTable__slider__3boJD","IntegrationTable__round":"request-for-more_IntegrationTable__round__J2aT9","IntegrationTable__Action":"request-for-more_IntegrationTable__Action__AMAfi","IntegrationView":"request-for-more_IntegrationView__b3QD0","IntegrationView__Title":"request-for-more_IntegrationView__Title__ciiU0","IntegrationView__Subheading":"request-for-more_IntegrationView__Subheading__m_vKe","IntegrationView__BoxImage":"request-for-more_IntegrationView__BoxImage__2QZiI","IntegrationView__Box":"request-for-more_IntegrationView__Box__gIhsw","IntegrationView__BoxImage__InfoIcon":"request-for-more_IntegrationView__BoxImage__InfoIcon__xDoc5","IntegrationView__ViewMoreButton":"request-for-more_IntegrationView__ViewMoreButton__y4mUX","IntegrationView__ConnectButton":"request-for-more_IntegrationView__ConnectButton__lOZN_","IntegrationView__GoogleButton":"request-for-more_IntegrationView__GoogleButton__WfZLB","IntegrationView__FlexFlow":"request-for-more_IntegrationView__FlexFlow__BzbC5","IntegrationView__BoxWidth":"request-for-more_IntegrationView__BoxWidth__bkiOg","SkipFinishButton":"request-for-more_SkipFinishButton__4KXAE","AddUsers":"request-for-more_AddUsers__CDsnb","AddUsers__ButtonSection":"request-for-more_AddUsers__ButtonSection__KsZ4S","AddUsers__QuickStepHeading":"request-for-more_AddUsers__QuickStepHeading__zBDHc","AddUsers__DeleteSection":"request-for-more_AddUsers__DeleteSection__DdGtt","Interview__DeleteSection":"request-for-more_Interview__DeleteSection___1H76","AddUsers__DeleteCrossHeight":"request-for-more_AddUsers__DeleteCrossHeight__Unvwp","AddUsers__Form__Input":"request-for-more_AddUsers__Form__Input__wW1T7","AddUsers__FormHeadingSection":"request-for-more_AddUsers__FormHeadingSection__M_VGm","Interview__FormHeadingSection":"request-for-more_Interview__FormHeadingSection__3hT2e","AddUsers__FormSection":"request-for-more_AddUsers__FormSection__n8_P1","NewJob__FormSection":"request-for-more_NewJob__FormSection__i4luV","AddUsers__ButtonsActionSection":"request-for-more_AddUsers__ButtonsActionSection__l7ccZ","AddUsers__ImportUsers":"request-for-more_AddUsers__ImportUsers__aA661","AddUsers__NameInput":"request-for-more_AddUsers__NameInput__5GFIV","AddUsers__EmailInput":"request-for-more_AddUsers__EmailInput__ra8fK","AddUsers__RoleInput":"request-for-more_AddUsers__RoleInput__7F_pl","AddUsers__Subheading":"request-for-more_AddUsers__Subheading__ju1y_","AddUsers__visible":"request-for-more_AddUsers__visible__JUxMP","Tagrow":"request-for-more_Tagrow__GqEg0","Tagrow__Tags":"request-for-more_Tagrow__Tags__J2ZY_","SetupPopup__Tags":"request-for-more_SetupPopup__Tags__3ZPjS","Tagrow__Cancel":"request-for-more_Tagrow__Cancel__rTiTb","Tagrow__Cross":"request-for-more_Tagrow__Cross__nNaPh","SendInviteSection":"request-for-more_SendInviteSection__JtBdg","error":"request-for-more_error__MpZLt","ViewJobPage__Input":"request-for-more_ViewJobPage__Input___2xBx","Form__Input2":"request-for-more_Form__Input2__uBv_E","ViewJobPage__PostDay":"request-for-more_ViewJobPage__PostDay__kby05","ViewJobPage__Title":"request-for-more_ViewJobPage__Title__b9o13","ViewJobPage__DescriptionTitle":"request-for-more_ViewJobPage__DescriptionTitle__YvdjL","ViewJobPage__Location":"request-for-more_ViewJobPage__Location__bIHkA","ViewJobPage__primarybtn":"request-for-more_ViewJobPage__primarybtn__4QFMe","ViewJobPage__secondarybtn":"request-for-more_ViewJobPage__secondarybtn__e_dnc","ViewJobPage__secondarybtnborder":"request-for-more_ViewJobPage__secondarybtnborder__dLwpI","ViewJobPage__BackSection":"request-for-more_ViewJobPage__BackSection__C_33m","ViewJobPage__Content":"request-for-more_ViewJobPage__Content__Jn_jh","ViewJobPage":"request-for-more_ViewJobPage__ohrKI","ViewJobPage__Header":"request-for-more_ViewJobPage__Header__EVSjE","ViewJobPage__Application":"request-for-more_ViewJobPage__Application__NgJ14","ViewJobPage__RecordVideo":"request-for-more_ViewJobPage__RecordVideo__kf5hF","ViewJobPage__RecordVideoSuccessText":"request-for-more_ViewJobPage__RecordVideoSuccessText__Qbs_s","ViewJobPage__subheading":"request-for-more_ViewJobPage__subheading__RJ_B6","ViewJobPage__confirmation":"request-for-more_ViewJobPage__confirmation__3Cx4a","ViewJobPage__Logo":"request-for-more_ViewJobPage__Logo__1QSfT","ViewJobPage__BrandLogo":"request-for-more_ViewJobPage__BrandLogo__DfCD_","ViewJobPage__BrandLogo__Padding10":"request-for-more_ViewJobPage__BrandLogo__Padding10__H_Zrh","ViewJobPage__Container":"request-for-more_ViewJobPage__Container__qYlab","ViewJobPage__JobContent":"request-for-more_ViewJobPage__JobContent__HcNbh","ViewJobPage__Sidebar":"request-for-more_ViewJobPage__Sidebar__jduN_","ViewJobPage__Sidebar2":"request-for-more_ViewJobPage__Sidebar2__4nNpv","ViewJobPage__Description":"request-for-more_ViewJobPage__Description__7NWvI","ViewJobPage__DescriptionWidth":"request-for-more_ViewJobPage__DescriptionWidth___V_iG","ViewJobPage__Footer":"request-for-more_ViewJobPage__Footer__JaSNS","ViewJobPage__FooterView":"request-for-more_ViewJobPage__FooterView__ZmlFh","ViewJobPage__ShareJob":"request-for-more_ViewJobPage__ShareJob__D39Uc","ViewJobPage__SubmitSection":"request-for-more_ViewJobPage__SubmitSection___GL6V","ViewJobPage__SocialMedia":"request-for-more_ViewJobPage__SocialMedia__GKLR_","ViewJobPage__SideContent":"request-for-more_ViewJobPage__SideContent__brrl3","ViewJobPage__ApplySection":"request-for-more_ViewJobPage__ApplySection__5uTDS","FormBox__Autofill":"request-for-more_FormBox__Autofill__ySpYp","applybuttons":"request-for-more_applybuttons__J9UwS","height90":"request-for-more_height90__gHgoc","Form__Cont":"request-for-more_Form__Cont__FQx_C","Form__DropBox":"request-for-more_Form__DropBox__f2EI2","Form__DropBoxcontainer":"request-for-more_Form__DropBoxcontainer__HCZ__","Form__DropBoxError":"request-for-more_Form__DropBoxError__iK3DG","Form__DropBoxicon":"request-for-more_Form__DropBoxicon__epiMp","Form__DropBoxmessage":"request-for-more_Form__DropBoxmessage__RXw1L","noDpGrid":"request-for-more_noDpGrid__lj3u1","Terms":"request-for-more_Terms__rRUhn","TermsCondition":"request-for-more_TermsCondition__XtTn5","TermsCondition__alignterms":"request-for-more_TermsCondition__alignterms__waJ9e","MenuContainer":"request-for-more_MenuContainer__Z_ncJ","MenuContainer__Menu":"request-for-more_MenuContainer__Menu__EKU5d","AgencyDetailPage":"request-for-more_AgencyDetailPage__tJcws","Congrats__ModalContent":"request-for-more_Congrats__ModalContent__1QxFA","NewJob__Container":"request-for-more_NewJob__Container__VZW6k","NewJob__TopSection":"request-for-more_NewJob__TopSection__AcYZW","Interview__TopSection":"request-for-more_Interview__TopSection__CU6Ox","NewJob__HorizontalDivider":"request-for-more_NewJob__HorizontalDivider__BO1Q7","NewJob__Wrapper":"request-for-more_NewJob__Wrapper__mSJih","NewJob__ContainerPadding":"request-for-more_NewJob__ContainerPadding__VC8yM","NewJob__ContainerScroll":"request-for-more_NewJob__ContainerScroll__W29Sx","NewJob__ContainerHeight":"request-for-more_NewJob__ContainerHeight__ErWrL","NewJob__ImportAction":"request-for-more_NewJob__ImportAction__NZVVS","NewJob__Interview_buttons":"request-for-more_NewJob__Interview_buttons__TznJI","Form__TableRowMB":"request-for-more_Form__TableRowMB__ir5A9","Form__TableRow3grid":"request-for-more_Form__TableRow3grid__xeGl3","Form__Remotegrid":"request-for-more_Form__Remotegrid__fNlSl","Form__TypeList":"request-for-more_Form__TypeList__GXcos","Form__Type":"request-for-more_Form__Type__r_PFl","Form__CheckLabel":"request-for-more_Form__CheckLabel__kCZiv","PrivateSwitchBase-root-1":"request-for-more_PrivateSwitchBase-root-1__ECjLt","Form__Caption":"request-for-more_Form__Caption__ZzQpZ","Form__Input_currency":"request-for-more_Form__Input_currency__jamkr","Form__Input_MatchScore":"request-for-more_Form__Input_MatchScore__yBkXV","Form__Percentage_Symbol":"request-for-more_Form__Percentage_Symbol__2kb1O","Form__NoGridTemplate":"request-for-more_Form__NoGridTemplate__C7r_3","active":"request-for-more_active__bYKRo","mt10":"request-for-more_mt10__hCL5j","mt40":"request-for-more_mt40__7DKmj","mt30":"request-for-more_mt30__bPpL5","mt32":"request-for-more_mt32__SWF_e","mb0":"request-for-more_mb0__ivAYd","Dpgrid":"request-for-more_Dpgrid__GgmaB","mb12":"request-for-more_mb12__o9Odz","width100":"request-for-more_width100__USlWU","Tagrow__Prefix":"request-for-more_Tagrow__Prefix__FELQh","PreviewJobPage":"request-for-more_PreviewJobPage__Nv_QF","PreviewJob":"request-for-more_PreviewJob__9Wc_q","DpFlx":"request-for-more_DpFlx__1tRiI","Subheading":"request-for-more_Subheading__eh39y","Subheading__Description":"request-for-more_Subheading__Description__TKPhv","Candidate__Tooltip":"request-for-more_Candidate__Tooltip__8SBWZ","Candidate__Tooltip__Score":"request-for-more_Candidate__Tooltip__Score__hvHYA","Form__InputField":"request-for-more_Form__InputField__OSV0W","Candidate__Length":"request-for-more_Candidate__Length__JXNIM","Agency__PostDay":"request-for-more_Agency__PostDay__IZ4Ly","Agency__Title":"request-for-more_Agency__Title__X0Z3M","Agency__Location":"request-for-more_Agency__Location__DDnh1","Agency__DescriptionTitle":"request-for-more_Agency__DescriptionTitle__R_iI3","Agency__Description":"request-for-more_Agency__Description__BaplH","LightBlueColor":"request-for-more_LightBlueColor__Y9_uG","Client_Page":"request-for-more_Client_Page__ecwAN","Welcome":"request-for-more_Welcome__LyjPM","Welcome__Inner":"request-for-more_Welcome__Inner__DrLUt","Welcome__Person":"request-for-more_Welcome__Person__kus9B","Welcome__LeftContent":"request-for-more_Welcome__LeftContent__JBSCb","Welcome__RightContent":"request-for-more_Welcome__RightContent__cCUCo","Welcome__Content":"request-for-more_Welcome__Content__s1Dz1","Welcome__CreateAccount":"request-for-more_Welcome__CreateAccount__Odu1l","Welcome__title":"request-for-more_Welcome__title__SqrHl","Welcome__FormBox":"request-for-more_Welcome__FormBox___RyNS","Form__psw":"request-for-more_Form__psw__FJxTd","Welcome__Container":"request-for-more_Welcome__Container__Vkl8l","Success__Container":"request-for-more_Success__Container__MqQc3","Success":"request-for-more_Success__nknR_","Success__Inner":"request-for-more_Success__Inner__XsHjG","InterviewContainer":"request-for-more_InterviewContainer__YN_Ux","Interview__Stages":"request-for-more_Interview__Stages__oNA2J","Interview__StageHeading":"request-for-more_Interview__StageHeading__v5Buj","pl10":"request-for-more_pl10__W2l4k","Interview__AddStageSection":"request-for-more_Interview__AddStageSection__BVZus","Interview__Label":"request-for-more_Interview__Label__peAKK","Interview__FormRowHeading":"request-for-more_Interview__FormRowHeading__NTE_g","dpflex":"request-for-more_dpflex__4ynb3","Interview__IconsType":"request-for-more_Interview__IconsType__XO3yq","Interview__Icons":"request-for-more_Interview__Icons___Qcg4","Interview__Interview_buttons":"request-for-more_Interview__Interview_buttons__5S4NH","Interview__approvalButton":"request-for-more_Interview__approvalButton____cfy","Interview__BestMatch":"request-for-more_Interview__BestMatch__P_Vpk","Interview__BestMatchExclamation":"request-for-more_Interview__BestMatchExclamation__9fZ_h","DragAndDrop":"request-for-more_DragAndDrop__1OU3X","DragAndDrop__CursorHandle":"request-for-more_DragAndDrop__CursorHandle__7gRc2","Tagrow__Image":"request-for-more_Tagrow__Image__QG_4U","rowbglight":"request-for-more_rowbglight__YwwwI","rowbgheight":"request-for-more_rowbgheight__D16bk","Form__w90":"request-for-more_Form__w90__Q7PYp","Container":"request-for-more_Container__9SBab","Screening__StageName":"request-for-more_Screening__StageName__9_bA0","Screening__InterviewType":"request-for-more_Screening__InterviewType__ZiWqH","Screening__InterviewType__Label":"request-for-more_Screening__InterviewType__Label__6XMvE","Show_Infoicon":"request-for-more_Show_Infoicon__V85Gu","Show_Infoicon_small":"request-for-more_Show_Infoicon_small__LrsEH","Screening__Info":"request-for-more_Screening__Info__W8GFH","Screening__Info__IconWithText":"request-for-more_Screening__Info__IconWithText__BjJU6","InterviewType__Icon":"request-for-more_InterviewType__Icon__RCNLv","InterviewType__Text":"request-for-more_InterviewType__Text__T3YYH","LoginModal":"request-for-more_LoginModal__hYbU2","Logincontent":"request-for-more_Logincontent__R_0od","Logincontent__title":"request-for-more_Logincontent__title__YiSop","Modalbg":"request-for-more_Modalbg__n3ABP","Modalnobg":"request-for-more_Modalnobg__8myPO","Form__Container":"request-for-more_Form__Container__UnfvA","Form__success":"request-for-more_Form__success__QzVi6","Form__error":"request-for-more_Form__error__NNZra","Form__CheckLabeltext":"request-for-more_Form__CheckLabeltext__0GOVI","Form__TextLeft":"request-for-more_Form__TextLeft__2xvEN","Backsection":"request-for-more_Backsection__TMvQI","back":"request-for-more_back__0MgMX","mlr0":"request-for-more_mlr0__ZS8aS","TwoButtons":"request-for-more_TwoButtons__LeFIL","OtpBacksection":"request-for-more_OtpBacksection__Cp2Z8","SetupPopup":"request-for-more_SetupPopup___chQB","SetupPopup__inner":"request-for-more_SetupPopup__inner__RCT80","SetupPopup__Dialog":"request-for-more_SetupPopup__Dialog__gLCuT","SetupPopup__AddFile":"request-for-more_SetupPopup__AddFile__WrfOp","SetupPopup__OptionalText":"request-for-more_SetupPopup__OptionalText__SKR9t","SetupPopup__RequestAccessBtn":"request-for-more_SetupPopup__RequestAccessBtn____kIS","SetupPopup__InternalSection":"request-for-more_SetupPopup__InternalSection__s4udp","SetupPopup__ContentInnerRow":"request-for-more_SetupPopup__ContentInnerRow__KFulE","SetupPopup__ToChips":"request-for-more_SetupPopup__ToChips__0o9Dt","SetupPopup__AttachmentContainer":"request-for-more_SetupPopup__AttachmentContainer__AA3BR","SetupPopup__ContentInnerCol":"request-for-more_SetupPopup__ContentInnerCol__z4V_5","SetupPopup__grid":"request-for-more_SetupPopup__grid__zUm2i","SetupPopup__Footer":"request-for-more_SetupPopup__Footer__jbmgB","SetupPopup__FooterNew":"request-for-more_SetupPopup__FooterNew__jyg_3","SetupPopup__Footer2":"request-for-more_SetupPopup__Footer2__s_ui_","SetupPopup__Footer3":"request-for-more_SetupPopup__Footer3__Y959s","SetupPopup__Footerassess":"request-for-more_SetupPopup__Footerassess__9XgzX","SetupPopup__Footertechtest":"request-for-more_SetupPopup__Footertechtest__m8Dmb","SetupPopup__AutommationFooter":"request-for-more_SetupPopup__AutommationFooter__EojWc","SetupPopup__MannualFooter":"request-for-more_SetupPopup__MannualFooter__dxyF3","SetupPopup__MannualInnerSection":"request-for-more_SetupPopup__MannualInnerSection__iVXSe","SetupPopup__Content":"request-for-more_SetupPopup__Content__CYuBU","SetupPopup__Content__Radiobtn":"request-for-more_SetupPopup__Content__Radiobtn__OAgIY","SetupPopup__AutomationToggle":"request-for-more_SetupPopup__AutomationToggle__RCuSl","SetupPopup__SetupVideoQa":"request-for-more_SetupPopup__SetupVideoQa__VXWc5","SetupPopup__SetupVideoQa2":"request-for-more_SetupPopup__SetupVideoQa2__GQQAq","SetupPopup__SetupVideoQa3":"request-for-more_SetupPopup__SetupVideoQa3__lH__T","SetupPopup__SetupVideoQa4":"request-for-more_SetupPopup__SetupVideoQa4__S5qZB","SetupPopup__InputQA":"request-for-more_SetupPopup__InputQA__UjkYD","SetupPopup__AddQuestion":"request-for-more_SetupPopup__AddQuestion__Sku1y","SetupPopup__QuestionSection":"request-for-more_SetupPopup__QuestionSection__nNpdA","SetupPopup__PushTop":"request-for-more_SetupPopup__PushTop__MKyA7","SetupPopup__Contentpading":"request-for-more_SetupPopup__Contentpading__j84xX","SetupPopup__QuesionSectionpading":"request-for-more_SetupPopup__QuesionSectionpading__tRaWr","SetupPopup__Contentcenter":"request-for-more_SetupPopup__Contentcenter__duNeP","SetupPopup__PopDetails":"request-for-more_SetupPopup__PopDetails__6BHCx","SetupPopup__PopDetails__FS16":"request-for-more_SetupPopup__PopDetails__FS16__CMSor","SetupPopup__Details":"request-for-more_SetupPopup__Details__fjANj","SetupPopup__PrivacyPolicyDetails":"request-for-more_SetupPopup__PrivacyPolicyDetails__8ldvy","SetupPopup__Reason":"request-for-more_SetupPopup__Reason__TKY2x","SetupPopup__ContentBlock":"request-for-more_SetupPopup__ContentBlock__vLd_X","SetupPopup__Purpose":"request-for-more_SetupPopup__Purpose__Ez4pp","SetupPopup__ContentGridsec":"request-for-more_SetupPopup__ContentGridsec__jfSXH","mt25":"request-for-more_mt25__Va__w","mt20":"request-for-more_mt20__4fT9k","SetupPopup__ContentGridTech":"request-for-more_SetupPopup__ContentGridTech__r9OO0","SetupPopup__Assesmentsection":"request-for-more_SetupPopup__Assesmentsection__mEAWf","SetupPopup__AssesmentsectionNew":"request-for-more_SetupPopup__AssesmentsectionNew__7BtxI","SetupPopup__MannualChips":"request-for-more_SetupPopup__MannualChips__WcYRG","SetupPopup__ContentGridManuaCol":"request-for-more_SetupPopup__ContentGridManuaCol__kZeQy","SetupPopup__ContentGridManual":"request-for-more_SetupPopup__ContentGridManual__7A1p_","SetupPopup__ContentBlockPhone":"request-for-more_SetupPopup__ContentBlockPhone__STbPI","SetupPopup__ContentAddInterview":"request-for-more_SetupPopup__ContentAddInterview__t_R2g","SetupPopup__ContentGridPhone":"request-for-more_SetupPopup__ContentGridPhone__f35b3","SetupPopup__ContentGridStatus":"request-for-more_SetupPopup__ContentGridStatus__4STeS","SetupPopup__GridActions":"request-for-more_SetupPopup__GridActions__P4fpl","SetupPopup__GridActionCoral":"request-for-more_SetupPopup__GridActionCoral__HFpbD","SetupPopup__GridActionIndigo":"request-for-more_SetupPopup__GridActionIndigo__qOG7E","SetupPopup__ContentGrid":"request-for-more_SetupPopup__ContentGrid__Cv9fp","SetupPopup__SubmitSectionSave":"request-for-more_SetupPopup__SubmitSectionSave__hVBeU","SetupPopup__SubmitSectionReset":"request-for-more_SetupPopup__SubmitSectionReset__BfAVr","SetupPopup__SubmitSectionAutomation":"request-for-more_SetupPopup__SubmitSectionAutomation__ZWRMM","SetupPopup__Duration":"request-for-more_SetupPopup__Duration__1JrwP","SetupPopup__DeleteIcon":"request-for-more_SetupPopup__DeleteIcon__Lx6Q1","SetupPopup__ContentCustomisationManualInterview":"request-for-more_SetupPopup__ContentCustomisationManualInterview__Hh5E7","mt0":"request-for-more_mt0__vYMn7","mtb25":"request-for-more_mtb25__pBbam","mb15":"request-for-more_mb15__C4MxJ","mb30":"request-for-more_mb30__4YeN_","mt9":"request-for-more_mt9__Bb_bw","lineheight0":"request-for-more_lineheight0__ryxwm","PopupHeightSection":"request-for-more_PopupHeightSection__DLUuZ","AssessPopupHeightSection":"request-for-more_AssessPopupHeightSection__GHd_G","Statusopupheight":"request-for-more_Statusopupheight__0wLKf","buttonIn":"request-for-more_buttonIn__HOhim","MessagePlaceholder":"request-for-more_MessagePlaceholder__U6pfh","m0":"request-for-more_m0__i2TwW","mt18":"request-for-more_mt18__3WamC","DPgrid":"request-for-more_DPgrid__WZSDn","addbtnposition":"request-for-more_addbtnposition__X8P30","mainformdiv":"request-for-more_mainformdiv__EPN8X","crossflex":"request-for-more_crossflex__Fx_Wj","crossimgheight":"request-for-more_crossimgheight__5WMg1","crossimgheight48":"request-for-more_crossimgheight48__tQqu_","SetupModalPopup":"request-for-more_SetupModalPopup__Bt2kv","SetupModalPopup__Dialog":"request-for-more_SetupModalPopup__Dialog__rW_2z","SetupPopupoverlay":"request-for-more_SetupPopupoverlay__XAHnS","NeedHelp":"request-for-more_NeedHelp__YJzNp","uploadNewTest":"request-for-more_uploadNewTest__fx1Eq","SetupPopup__ol":"request-for-more_SetupPopup__ol__HfQB7","Threshold__Content":"request-for-more_Threshold__Content__AAokW","Sharecv":"request-for-more_Sharecv__kaHcp","Sharecv__Heading":"request-for-more_Sharecv__Heading__TQXaz","Sharecv__Docfilename":"request-for-more_Sharecv__Docfilename__ZiPmT","Sharecv__Selectfile":"request-for-more_Sharecv__Selectfile__fmEUX","Form__TextareaPlaceholder":"request-for-more_Form__TextareaPlaceholder__rWZ2_","OtpBacksection2":"request-for-more_OtpBacksection2__IkgY7","DefaultCheck":"request-for-more_DefaultCheck__HQ8YE","DefaultCheck__MarginTop25":"request-for-more_DefaultCheck__MarginTop25__CSi0W","SetupPopup__AddInterviewCustomisation":"request-for-more_SetupPopup__AddInterviewCustomisation__MzAyR","SetupPopup__ContentFlex":"request-for-more_SetupPopup__ContentFlex__9dkgZ","PositionRelative":"request-for-more_PositionRelative__UWPjV","CancelInterview__inner":"request-for-more_CancelInterview__inner__Viwpm","CancelInterview__OtpBacksection":"request-for-more_CancelInterview__OtpBacksection__wat30","CancelInterview__popupMessage":"request-for-more_CancelInterview__popupMessage__eagqc","CancelInterview__ContentBlock":"request-for-more_CancelInterview__ContentBlock__fqYG7","CancelReason__inner":"request-for-more_CancelReason__inner__7eo5q","AutomationPopup__inner":"request-for-more_AutomationPopup__inner__IzrGn","BulkImportPopup__inner":"request-for-more_BulkImportPopup__inner__5OIvt","AutomationPopup__OtpBacksection":"request-for-more_AutomationPopup__OtpBacksection__LPow9","BulkImportPopup__OtpBacksection":"request-for-more_BulkImportPopup__OtpBacksection__8rSlG","AutomationPopup__Otpback":"request-for-more_AutomationPopup__Otpback__h0dO7","BulkImportPopup__Otpback":"request-for-more_BulkImportPopup__Otpback__DKAF3","BulkImportPopup__Main_content":"request-for-more_BulkImportPopup__Main_content___a4Xa","BulkImportPopup__Content":"request-for-more_BulkImportPopup__Content__h__lz","BulkImportPopup__Footer2":"request-for-more_BulkImportPopup__Footer2__h0l6k","DefaultCheckbox_MarginTop":"request-for-more_DefaultCheckbox_MarginTop__fCQwm","CancelReason__Content":"request-for-more_CancelReason__Content__0cMDF","CancelReason__OtpBacksection2":"request-for-more_CancelReason__OtpBacksection2__Rso6W","CancelReason__ContentBlock":"request-for-more_CancelReason__ContentBlock__bl53A","CancelInterview__Container":"request-for-more_CancelInterview__Container__OVPfF","CancelInterview__SubmitSectionSave":"request-for-more_CancelInterview__SubmitSectionSave__f7TDN","RequestDetails":"request-for-more_RequestDetails__hlToI","RequestDetails__gridauto":"request-for-more_RequestDetails__gridauto__9iNAy","RequestDetails__ContentBlock":"request-for-more_RequestDetails__ContentBlock__YGnI0","RequestDetails__SlotsAvailablity":"request-for-more_RequestDetails__SlotsAvailablity__dTG6n","RequestDetails__AvailableSlotsBg":"request-for-more_RequestDetails__AvailableSlotsBg__ifF1t","RequestDetails__NoAvailableSlotsBg":"request-for-more_RequestDetails__NoAvailableSlotsBg__tO3S_","tabledataheight":"request-for-more_tabledataheight__31Cbz","Content":"request-for-more_Content__2zScE","Contentdata":"request-for-more_Contentdata__IrnbD","ListItem":"request-for-more_ListItem___F3N_","Contentdata1":"request-for-more_Contentdata1__XydHi","Preferred_Date_Time":"request-for-more_Preferred_Date_Time__mPGoQ","Preferred_Date_Time__LeftColumn":"request-for-more_Preferred_Date_Time__LeftColumn__RTZYU","Preferred_Date_Time__RightColumn":"request-for-more_Preferred_Date_Time__RightColumn__YzPdw","Timebg":"request-for-more_Timebg__IOgz7","react-time-input-picker-wrapper":"request-for-more_react-time-input-picker-wrapper__mzg7Y","react-time-input-picker":"request-for-more_react-time-input-picker__1VLV6","Preferred_Date":"request-for-more_Preferred_Date__skTM_","SetupPopup__ContentPopup":"request-for-more_SetupPopup__ContentPopup__wvhf6","Threshold__innerWidth":"request-for-more_Threshold__innerWidth__TnXTY","Threshold__OtpBacksection2":"request-for-more_Threshold__OtpBacksection2__T80pH","Threshold__Otpback":"request-for-more_Threshold__Otpback__x8c6F","Threshold__SubmitSectionAutomation":"request-for-more_Threshold__SubmitSectionAutomation__tASta","ReshecheduleRequest__inner":"request-for-more_ReshecheduleRequest__inner__4_6NF","ReshecheduleRequest__OtpBacksection":"request-for-more_ReshecheduleRequest__OtpBacksection__19EHM","ReshecheduleRequest__Container":"request-for-more_ReshecheduleRequest__Container__lnvdf","Information__OtpBacksection2":"request-for-more_Information__OtpBacksection2__DkpUI","ReshecheduleRequest__SubmitSectionSave":"request-for-more_ReshecheduleRequest__SubmitSectionSave__kEtxw"};

/***/ }),

/***/ 24207:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"RescheduleRequest__inner":"reschedule-request-modal_RescheduleRequest__inner__TOAmk","RescheduleRequest__Content":"reschedule-request-modal_RescheduleRequest__Content__gbEJ8","RescheduleRequest__ContentBlock":"reschedule-request-modal_RescheduleRequest__ContentBlock__XLc__","RescheduleRequest__SlotsAvailablity":"reschedule-request-modal_RescheduleRequest__SlotsAvailablity__G_TMM","RescheduleRequest__Footer":"reschedule-request-modal_RescheduleRequest__Footer__xP4o4","OtpBacksection2":"reschedule-request-modal_OtpBacksection2__MdJB9","JobCustomDateTime":"reschedule-request-modal_JobCustomDateTime__lC2n7","RescheduleRequest__JobCustomDateTime":"reschedule-request-modal_RescheduleRequest__JobCustomDateTime__zbzv5","RescheduleRequest__primarybtn":"reschedule-request-modal_RescheduleRequest__primarybtn__BfpRa"};

/***/ }),

/***/ 2365:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Modalpopup":"select-job-modal_Modalpopup__PNRTO","Modalpopup__inner":"select-job-modal_Modalpopup__inner__TubW_","Modalpopup__Dialog":"select-job-modal_Modalpopup__Dialog__gfAtV","transition":"select-job-modal_transition__HYPkl","Modalpopup__CloseCenter":"select-job-modal_Modalpopup__CloseCenter__4IDF6","Modalpopup__Content":"select-job-modal_Modalpopup__Content__Ua7X1","SetupPopup__PaddingPopup":"select-job-modal_SetupPopup__PaddingPopup__dEWNc","SetupPopup__ContentCustomisation":"select-job-modal_SetupPopup__ContentCustomisation__tIr2a","SetupPopup__Contentwithoutpadding":"select-job-modal_SetupPopup__Contentwithoutpadding__em7eQ","Modalpopup__btn":"select-job-modal_Modalpopup__btn__ckRow","mar":"select-job-modal_mar__PAQHB","Otpback":"select-job-modal_Otpback__QqbPg","Form":"select-job-modal_Form__gAqsV","Form__width":"select-job-modal_Form__width__j6665","Form__label":"select-job-modal_Form__label__7J5YZ","Form__textleft":"select-job-modal_Form__textleft__I0ExG","Form__InputFullWidth":"select-job-modal_Form__InputFullWidth__f_DG7","Form__Input":"select-job-modal_Form__Input__8_R1f","Form__InputSection":"select-job-modal_Form__InputSection__opd_2","Form__ScoreCardInput":"select-job-modal_Form__ScoreCardInput__QLhAl","Form__Textarea":"select-job-modal_Form__Textarea__0U8nD","primarybtn":"select-job-modal_primarybtn__7P_wN","secondarybtn":"select-job-modal_secondarybtn__7ziUl","iconFilled":"select-job-modal_iconFilled__vfNYH","iconFilledSolid":"select-job-modal_iconFilledSolid__P3qEk","primarybtnborder":"select-job-modal_primarybtnborder__62sEF","secondarybtnborder":"select-job-modal_secondarybtnborder__kmnb8","tertiarybtn":"select-job-modal_tertiarybtn__CUMTv","graybtnborder":"select-job-modal_graybtnborder__mU827","jobsrchbtn":"select-job-modal_jobsrchbtn__sm7z8","jobsrchbtnalign":"select-job-modal_jobsrchbtnalign__As0sN","nobgbutton":"select-job-modal_nobgbutton__TKktb","iconTextButton":"select-job-modal_iconTextButton__dxBRv","cursornone":"select-job-modal_cursornone__p__oW","nobgbuttonprimary":"select-job-modal_nobgbuttonprimary__XB5Jv","mt15":"select-job-modal_mt15__BpQhh","btn350":"select-job-modal_btn350__EmVse","GrayBgBtn":"select-job-modal_GrayBgBtn__HK012","NewShareBtn":"select-job-modal_NewShareBtn__FdQFe","CoralBgBtn":"select-job-modal_CoralBgBtn__92Dc9","Form__Input398":"select-job-modal_Form__Input398__dVx8p","GoBtn":"select-job-modal_GoBtn__jhrSz","ClearBtn":"select-job-modal_ClearBtn__qFXlS","DropContainer":"select-job-modal_DropContainer__X66X1","DropContainer__Inner":"select-job-modal_DropContainer__Inner__70qgj","CompanyProfile__Inner":"select-job-modal_CompanyProfile__Inner__C1I_I","DropContainer__Message":"select-job-modal_DropContainer__Message__cFU3w","CompanyProfile__Message":"select-job-modal_CompanyProfile__Message__MVdGf","CompanyProfile__MessageContent":"select-job-modal_CompanyProfile__MessageContent__F32vb","DropContainer__UploadIcon":"select-job-modal_DropContainer__UploadIcon__N_edc","CompanyProfile__UploadIcon":"select-job-modal_CompanyProfile__UploadIcon__rHHHn","FileDisplayContainer":"select-job-modal_FileDisplayContainer__ZLxzp","FileDisplayContainer__Status":"select-job-modal_FileDisplayContainer__Status__xNAsW","SetupPopup__Status":"select-job-modal_SetupPopup__Status__ICkRa","SetupPopup__To":"select-job-modal_SetupPopup__To__5qMdJ","FileDisplayContainer__Type":"select-job-modal_FileDisplayContainer__Type__x34i4","FileDisplayContainer__Name":"select-job-modal_FileDisplayContainer__Name__454Wv","SetupPopup__Name":"select-job-modal_SetupPopup__Name__d7paC","SetupPopup__ToName":"select-job-modal_SetupPopup__ToName__vU7EK","FileDisplayContainer__Error":"select-job-modal_FileDisplayContainer__Error__04hiS","FileDisplayContainer__Close":"select-job-modal_FileDisplayContainer__Close__yXVFT","Browse":"select-job-modal_Browse__k85lv","ClientCompany":"select-job-modal_ClientCompany__h6hAr","NewJob":"select-job-modal_NewJob__SOXLS","Interview":"select-job-modal_Interview__UqLIt","ClientCompany__TopSection2":"select-job-modal_ClientCompany__TopSection2__6H8rY","ClientCompany__Filter":"select-job-modal_ClientCompany__Filter__DLGkI","ClientCompany__Input_MatchScore":"select-job-modal_ClientCompany__Input_MatchScore__As3aW","ClientCompany__Percentage_Symbol":"select-job-modal_ClientCompany__Percentage_Symbol__LIgK_","ClientCompany__Filterheading":"select-job-modal_ClientCompany__Filterheading__66AkC","ClientCompany__FloatButtonAdd":"select-job-modal_ClientCompany__FloatButtonAdd__x4uEP","ClientCompany__FloatButtonAdd__AgencyUserIcon":"select-job-modal_ClientCompany__FloatButtonAdd__AgencyUserIcon__jEa6k","ClientCompany__LastEdited":"select-job-modal_ClientCompany__LastEdited__6sp_1","ClientCompany__BackSection":"select-job-modal_ClientCompany__BackSection__VTLGU","AddUsers__BackSection":"select-job-modal_AddUsers__BackSection__DLPWh","ClientCompany__BackSection__CloseIcon":"select-job-modal_ClientCompany__BackSection__CloseIcon___RQxq","ClientCompany__Container":"select-job-modal_ClientCompany__Container__0wpO3","NewJob__InterviewContainer":"select-job-modal_NewJob__InterviewContainer__7c9Ej","AddUsers__Container":"select-job-modal_AddUsers__Container__camCQ","ClientCompany__FormInputSection":"select-job-modal_ClientCompany__FormInputSection__4isa6","CompanyProfile__FormInputSection":"select-job-modal_CompanyProfile__FormInputSection__RIxah","ClientCompany__Heading":"select-job-modal_ClientCompany__Heading__xpwFM","AddUsers__Heading":"select-job-modal_AddUsers__Heading__nvdbz","ClientCompany__StatusAlignment":"select-job-modal_ClientCompany__StatusAlignment__8L2Ss","ClientCompany__Status":"select-job-modal_ClientCompany__Status__C5zjb","ClientCompany__ActiveDot":"select-job-modal_ClientCompany__ActiveDot__D3_XB","ClientCompany__CloseDot":"select-job-modal_ClientCompany__CloseDot__OREc3","ClientCompany__Company":"select-job-modal_ClientCompany__Company__GTfpt","AddUsers__User":"select-job-modal_AddUsers__User__jXw86","ClientCompany__Systemrefheding":"select-job-modal_ClientCompany__Systemrefheding__RTrJ_","ClientCompany__Subheading":"select-job-modal_ClientCompany__Subheading__Fr_Q4","CompanyProfile__Subheading":"select-job-modal_CompanyProfile__Subheading__hE9N8","ClientCompany__Subheading2":"select-job-modal_ClientCompany__Subheading2__hQG1y","ClientCompany__Description":"select-job-modal_ClientCompany__Description__GysVj","ClientCompany__SubmitSection":"select-job-modal_ClientCompany__SubmitSection__Xp_6b","NewJob__SubmitSection":"select-job-modal_NewJob__SubmitSection__JknTr","NewJob__SubmitSectionThreeBtn":"select-job-modal_NewJob__SubmitSectionThreeBtn__KAKbA","NewJob__SubmitSectionOneBtnPlacement":"select-job-modal_NewJob__SubmitSectionOneBtnPlacement__nevlK","NewJob__ImportSection":"select-job-modal_NewJob__ImportSection__b0Tn5","SetupPopup__SubmitSection2":"select-job-modal_SetupPopup__SubmitSection2__1gxnv","SetupPopup__SubmitSection":"select-job-modal_SetupPopup__SubmitSection__83TxH","SetupPopup__SubmitSection3":"select-job-modal_SetupPopup__SubmitSection3__hfGLC","AddUsers__SubmitSection":"select-job-modal_AddUsers__SubmitSection__3vyi_","ClientCompany__IntegrationImage":"select-job-modal_ClientCompany__IntegrationImage__OzkjD","ClientCompany__QuickAdd":"select-job-modal_ClientCompany__QuickAdd__QfDPW","NewJob__QuickAdd":"select-job-modal_NewJob__QuickAdd__hwEGw","Interview__QuickAdd":"select-job-modal_Interview__QuickAdd__Vh6oA","ClientCompany__BodyText":"select-job-modal_ClientCompany__BodyText__JmEex","Form__TableRow":"select-job-modal_Form__TableRow__86HEo","Form__Label":"select-job-modal_Form__Label__DW_KC","Form__FloatingLabel":"select-job-modal_Form__FloatingLabel__wmPnZ","Form__TableCol":"select-job-modal_Form__TableCol__WBhvn","Form__currency_symbol":"select-job-modal_Form__currency_symbol__iTmrR","Form__CustomSelect":"select-job-modal_Form__CustomSelect__t_s5h","Form__currency_symbol__right":"select-job-modal_Form__currency_symbol__right__0B_qh","Form__TableCol__Disabled":"select-job-modal_Form__TableCol__Disabled__dAPnd","Form__TextareaDisabled":"select-job-modal_Form__TextareaDisabled__sZR9f","Form__EditorDisabled":"select-job-modal_Form__EditorDisabled__sXIgn","Form__AdminCheckLabel":"select-job-modal_Form__AdminCheckLabel__4gyJM","Form__AdminCheckMargin":"select-job-modal_Form__AdminCheckMargin__hZbz3","CompanyProfile__BrandingGuide":"select-job-modal_CompanyProfile__BrandingGuide__2E1_J","CompanyProfile__DropBoxContainer":"select-job-modal_CompanyProfile__DropBoxContainer__Jh_VY","CompanyProfile__Browse":"select-job-modal_CompanyProfile__Browse__haCyw","ErrorLabel":"select-job-modal_ErrorLabel__SoZX5","Height80":"select-job-modal_Height80__JH0ri","Browse__ButtonFlexEnd":"select-job-modal_Browse__ButtonFlexEnd__9EOaD","AddAgency__Container":"select-job-modal_AddAgency__Container__I5Eqs","AddAgency__FormInputSection":"select-job-modal_AddAgency__FormInputSection__6NpJR","AddAgency__FormInputSection__Label":"select-job-modal_AddAgency__FormInputSection__Label__9F6JU","AddAgency__Form":"select-job-modal_AddAgency__Form__ZukMS","LinkAsButtons":"select-job-modal_LinkAsButtons__SnVJ5","SearchFlex":"select-job-modal_SearchFlex__LNUIU","Form__ErrorCustomSelect":"select-job-modal_Form__ErrorCustomSelect__bRDUk","Form__select_currency":"select-job-modal_Form__select_currency__FnKFr","customSelect__placeholder":"select-job-modal_customSelect__placeholder__q_oF1","Career":"select-job-modal_Career__LN56P","Career__Background_Edit":"select-job-modal_Career__Background_Edit__UNlCB","Career__Background_Edit_Image":"select-job-modal_Career__Background_Edit_Image__Dt24l","Career__Container":"select-job-modal_Career__Container__Iso0w","Career__Inner":"select-job-modal_Career__Inner__sSz0S","Career__logo":"select-job-modal_Career__logo__IFb0n","Career__Content":"select-job-modal_Career__Content__78_lZ","Career__ButtonSection":"select-job-modal_Career__ButtonSection__lnCRb","Job":"select-job-modal_Job__hfcOB","Job__Inner":"select-job-modal_Job__Inner__U0IT5","Job__Container":"select-job-modal_Job__Container__gnPqt","Job__Heading":"select-job-modal_Job__Heading__m5kJw","Job__Company":"select-job-modal_Job__Company__upnEs","Job__SearchContainer":"select-job-modal_Job__SearchContainer__7t0sR","Job__SearchInput":"select-job-modal_Job__SearchInput__H9J_1","Job__Searchbtn":"select-job-modal_Job__Searchbtn__agFaq","Job__Input":"select-job-modal_Job__Input__LicJz","Job__SelectJob":"select-job-modal_Job__SelectJob__cJZs5","Job__RemoteLabel":"select-job-modal_Job__RemoteLabel__LxR2C","Job__Display":"select-job-modal_Job__Display__hXMIm","Job__PostDay":"select-job-modal_Job__PostDay__3KXCi","Job__Title":"select-job-modal_Job__Title__kkyno","Job__Location":"select-job-modal_Job__Location__6_MQw","DT":"select-job-modal_DT__bHgXb","DisplayTable":"select-job-modal_DisplayTable__NKPng","pd11":"select-job-modal_pd11__88aAM","Label":"select-job-modal_Label__Qd6kL","inputwidth":"select-job-modal_inputwidth__5NRdI","mr24":"select-job-modal_mr24__BJZl_","fullwidth":"select-job-modal_fullwidth__bQYnt","padt40":"select-job-modal_padt40__eorx7","Form__TableRowflex":"select-job-modal_Form__TableRowflex__0tdaJ","Form__TableColm":"select-job-modal_Form__TableColm__nKrqa","Form__LabelCheck":"select-job-modal_Form__LabelCheck__6YY_9","Form__Error":"select-job-modal_Form__Error__yQ6Nk","Form__ErrorSection":"select-job-modal_Form__ErrorSection__5Gskj","Form__MessagePlaceholder":"select-job-modal_Form__MessagePlaceholder__UMlCQ","Form__Submit":"select-job-modal_Form__Submit__Dg0Jz","Form__NormalLabel":"select-job-modal_Form__NormalLabel__SU4aA","AddInterview":"select-job-modal_AddInterview__77DTH","IntegrationPage":"select-job-modal_IntegrationPage__bPSbn","Integration__BackStep":"select-job-modal_Integration__BackStep__QI5NH","AddUsers__BackStep":"select-job-modal_AddUsers__BackStep__Rs2h8","Integration__SubmitSection":"select-job-modal_Integration__SubmitSection__Rz4sn","IntegrationTable":"select-job-modal_IntegrationTable__yx12v","IntegrationTable__LimitInput":"select-job-modal_IntegrationTable__LimitInput__OM6Y5","IntegrationTable__Type":"select-job-modal_IntegrationTable__Type__Gi295","IntegrationTable__AllJobsToggle":"select-job-modal_IntegrationTable__AllJobsToggle__lwd_0","IntegrationTable__switch":"select-job-modal_IntegrationTable__switch__7vcqe","IntegrationTable__switchText":"select-job-modal_IntegrationTable__switchText__NPYDK","IntegrationTable__slider":"select-job-modal_IntegrationTable__slider__27rO_","IntegrationTable__round":"select-job-modal_IntegrationTable__round__4A7Ya","IntegrationTable__Action":"select-job-modal_IntegrationTable__Action__SOUTJ","IntegrationView":"select-job-modal_IntegrationView__ILnQj","IntegrationView__Title":"select-job-modal_IntegrationView__Title__WFqTu","IntegrationView__Subheading":"select-job-modal_IntegrationView__Subheading__Z6jVD","IntegrationView__BoxImage":"select-job-modal_IntegrationView__BoxImage__88B2c","IntegrationView__Box":"select-job-modal_IntegrationView__Box__KnmvT","IntegrationView__BoxImage__InfoIcon":"select-job-modal_IntegrationView__BoxImage__InfoIcon__wwEMp","IntegrationView__ViewMoreButton":"select-job-modal_IntegrationView__ViewMoreButton__L4SXF","IntegrationView__ConnectButton":"select-job-modal_IntegrationView__ConnectButton__tqwA3","IntegrationView__GoogleButton":"select-job-modal_IntegrationView__GoogleButton__ZfqPS","IntegrationView__FlexFlow":"select-job-modal_IntegrationView__FlexFlow__dVac6","IntegrationView__BoxWidth":"select-job-modal_IntegrationView__BoxWidth__BrKJg","SkipFinishButton":"select-job-modal_SkipFinishButton__T6H_K","AddUsers":"select-job-modal_AddUsers__WE2RT","AddUsers__ButtonSection":"select-job-modal_AddUsers__ButtonSection__XyTQM","AddUsers__QuickStepHeading":"select-job-modal_AddUsers__QuickStepHeading__sncMy","AddUsers__DeleteSection":"select-job-modal_AddUsers__DeleteSection__0PdbJ","Interview__DeleteSection":"select-job-modal_Interview__DeleteSection__nlsji","AddUsers__DeleteCrossHeight":"select-job-modal_AddUsers__DeleteCrossHeight__lKBVl","AddUsers__Form__Input":"select-job-modal_AddUsers__Form__Input__Xm5IC","AddUsers__FormHeadingSection":"select-job-modal_AddUsers__FormHeadingSection__XMIbO","Interview__FormHeadingSection":"select-job-modal_Interview__FormHeadingSection___eDrR","AddUsers__FormSection":"select-job-modal_AddUsers__FormSection__8n0yj","NewJob__FormSection":"select-job-modal_NewJob__FormSection__j3h10","AddUsers__ButtonsActionSection":"select-job-modal_AddUsers__ButtonsActionSection__o47SN","AddUsers__ImportUsers":"select-job-modal_AddUsers__ImportUsers__Cc0ra","AddUsers__NameInput":"select-job-modal_AddUsers__NameInput__6FtzT","AddUsers__EmailInput":"select-job-modal_AddUsers__EmailInput___ylUv","AddUsers__RoleInput":"select-job-modal_AddUsers__RoleInput__HABR4","AddUsers__Subheading":"select-job-modal_AddUsers__Subheading__3nJl7","AddUsers__visible":"select-job-modal_AddUsers__visible__aysLQ","Tagrow":"select-job-modal_Tagrow__rC_NQ","Tagrow__Tags":"select-job-modal_Tagrow__Tags__Ft9Oz","SetupPopup__Tags":"select-job-modal_SetupPopup__Tags__Qtqu3","Tagrow__Cancel":"select-job-modal_Tagrow__Cancel__gX2yX","Tagrow__Cross":"select-job-modal_Tagrow__Cross__Kb4qT","SendInviteSection":"select-job-modal_SendInviteSection__DvcV5","error":"select-job-modal_error__IgGkL","ViewJobPage__Input":"select-job-modal_ViewJobPage__Input__v1j7_","Form__Input2":"select-job-modal_Form__Input2__4y9Sv","ViewJobPage__PostDay":"select-job-modal_ViewJobPage__PostDay__UwSBh","ViewJobPage__Title":"select-job-modal_ViewJobPage__Title__fewJi","ViewJobPage__DescriptionTitle":"select-job-modal_ViewJobPage__DescriptionTitle__dzeCL","ViewJobPage__Location":"select-job-modal_ViewJobPage__Location__jsVqm","ViewJobPage__primarybtn":"select-job-modal_ViewJobPage__primarybtn__E_1gL","ViewJobPage__secondarybtn":"select-job-modal_ViewJobPage__secondarybtn__lxlCf","ViewJobPage__secondarybtnborder":"select-job-modal_ViewJobPage__secondarybtnborder__mtwwb","ViewJobPage__BackSection":"select-job-modal_ViewJobPage__BackSection__6JhrW","ViewJobPage__Content":"select-job-modal_ViewJobPage__Content__1vnip","ViewJobPage":"select-job-modal_ViewJobPage__3cJIU","ViewJobPage__Header":"select-job-modal_ViewJobPage__Header__wjQZK","ViewJobPage__Application":"select-job-modal_ViewJobPage__Application__psClI","ViewJobPage__RecordVideo":"select-job-modal_ViewJobPage__RecordVideo__7TSoI","ViewJobPage__RecordVideoSuccessText":"select-job-modal_ViewJobPage__RecordVideoSuccessText__iJALL","ViewJobPage__subheading":"select-job-modal_ViewJobPage__subheading__2TwVg","ViewJobPage__confirmation":"select-job-modal_ViewJobPage__confirmation__0ggUz","ViewJobPage__Logo":"select-job-modal_ViewJobPage__Logo__i_SQp","ViewJobPage__BrandLogo":"select-job-modal_ViewJobPage__BrandLogo__BJO8X","ViewJobPage__BrandLogo__Padding10":"select-job-modal_ViewJobPage__BrandLogo__Padding10__jEek5","ViewJobPage__Container":"select-job-modal_ViewJobPage__Container__KRrOc","ViewJobPage__JobContent":"select-job-modal_ViewJobPage__JobContent__r2JAx","ViewJobPage__Sidebar":"select-job-modal_ViewJobPage__Sidebar__f4F8p","ViewJobPage__Sidebar2":"select-job-modal_ViewJobPage__Sidebar2__pS0GV","ViewJobPage__Description":"select-job-modal_ViewJobPage__Description__uu2F9","ViewJobPage__DescriptionWidth":"select-job-modal_ViewJobPage__DescriptionWidth__uKIRG","ViewJobPage__Footer":"select-job-modal_ViewJobPage__Footer__cnDSA","ViewJobPage__FooterView":"select-job-modal_ViewJobPage__FooterView__S_TqY","ViewJobPage__ShareJob":"select-job-modal_ViewJobPage__ShareJob__2IXDi","ViewJobPage__SubmitSection":"select-job-modal_ViewJobPage__SubmitSection__UPKwf","ViewJobPage__SocialMedia":"select-job-modal_ViewJobPage__SocialMedia__bTOdE","ViewJobPage__SideContent":"select-job-modal_ViewJobPage__SideContent__okpWP","ViewJobPage__ApplySection":"select-job-modal_ViewJobPage__ApplySection__Cb_PC","FormBox__Autofill":"select-job-modal_FormBox__Autofill__yOdso","applybuttons":"select-job-modal_applybuttons__yxLRg","height90":"select-job-modal_height90__LOigA","Form__Cont":"select-job-modal_Form__Cont__1nxY6","Form__DropBox":"select-job-modal_Form__DropBox__93qos","Form__DropBoxcontainer":"select-job-modal_Form__DropBoxcontainer__dt__o","Form__DropBoxError":"select-job-modal_Form__DropBoxError__Jph2J","Form__DropBoxicon":"select-job-modal_Form__DropBoxicon__M81CJ","Form__DropBoxmessage":"select-job-modal_Form__DropBoxmessage__CfJfZ","noDpGrid":"select-job-modal_noDpGrid__mVoYL","Terms":"select-job-modal_Terms__Py69d","TermsCondition":"select-job-modal_TermsCondition___ktEt","TermsCondition__alignterms":"select-job-modal_TermsCondition__alignterms__Q6Yef","MenuContainer":"select-job-modal_MenuContainer__GHaTe","MenuContainer__Menu":"select-job-modal_MenuContainer__Menu__mAHNN","AgencyDetailPage":"select-job-modal_AgencyDetailPage__RQcIF","Congrats__ModalContent":"select-job-modal_Congrats__ModalContent__dAqZF","NewJob__Container":"select-job-modal_NewJob__Container__i_ZHS","NewJob__TopSection":"select-job-modal_NewJob__TopSection__1VC0L","Interview__TopSection":"select-job-modal_Interview__TopSection__m__gL","NewJob__HorizontalDivider":"select-job-modal_NewJob__HorizontalDivider__QrgC_","NewJob__Wrapper":"select-job-modal_NewJob__Wrapper__VqjxH","NewJob__ContainerPadding":"select-job-modal_NewJob__ContainerPadding__Adn6m","NewJob__ContainerScroll":"select-job-modal_NewJob__ContainerScroll__BteU_","NewJob__ContainerHeight":"select-job-modal_NewJob__ContainerHeight__FEMf6","NewJob__ImportAction":"select-job-modal_NewJob__ImportAction__V1XPt","NewJob__Interview_buttons":"select-job-modal_NewJob__Interview_buttons__WM_UF","Form__TableRowMB":"select-job-modal_Form__TableRowMB__aoSCV","Form__TableRow3grid":"select-job-modal_Form__TableRow3grid__3biTX","Form__Remotegrid":"select-job-modal_Form__Remotegrid__ex_8e","Form__TypeList":"select-job-modal_Form__TypeList__hkfKl","Form__Type":"select-job-modal_Form__Type__R6RgN","Form__CheckLabel":"select-job-modal_Form__CheckLabel__TwMPW","PrivateSwitchBase-root-1":"select-job-modal_PrivateSwitchBase-root-1__fD6MD","Form__Caption":"select-job-modal_Form__Caption__QFRkV","Form__Input_currency":"select-job-modal_Form__Input_currency__37ptZ","Form__Input_MatchScore":"select-job-modal_Form__Input_MatchScore__BmQ82","Form__Percentage_Symbol":"select-job-modal_Form__Percentage_Symbol__RfkHN","Form__NoGridTemplate":"select-job-modal_Form__NoGridTemplate__pHTvS","active":"select-job-modal_active__ZQ8gH","mt10":"select-job-modal_mt10__NfqlR","mt40":"select-job-modal_mt40__SiEDS","mt30":"select-job-modal_mt30__ylNqa","mt32":"select-job-modal_mt32__PDI_I","mb0":"select-job-modal_mb0__Cl0ql","Dpgrid":"select-job-modal_Dpgrid___QUmp","mb12":"select-job-modal_mb12__6fquN","width100":"select-job-modal_width100__LsTj8","Tagrow__Prefix":"select-job-modal_Tagrow__Prefix__fff6z","PreviewJobPage":"select-job-modal_PreviewJobPage__dk_Ky","PreviewJob":"select-job-modal_PreviewJob__JNSHc","DpFlx":"select-job-modal_DpFlx__yPlg2","Subheading":"select-job-modal_Subheading__xX_Uz","Subheading__Description":"select-job-modal_Subheading__Description__4z5bj","Candidate__Tooltip":"select-job-modal_Candidate__Tooltip__q3wYy","Candidate__Tooltip__Score":"select-job-modal_Candidate__Tooltip__Score__uTlDL","Form__InputField":"select-job-modal_Form__InputField__KZVvZ","Candidate__Length":"select-job-modal_Candidate__Length__y3Rz_","Agency__PostDay":"select-job-modal_Agency__PostDay__2wPX7","Agency__Title":"select-job-modal_Agency__Title__pbNDV","Agency__Location":"select-job-modal_Agency__Location__5X7PW","Agency__DescriptionTitle":"select-job-modal_Agency__DescriptionTitle__4BkGB","Agency__Description":"select-job-modal_Agency__Description__ecTNK","LightBlueColor":"select-job-modal_LightBlueColor__FSRR_","Client_Page":"select-job-modal_Client_Page__jwV37","Welcome":"select-job-modal_Welcome__g9GKw","Welcome__Inner":"select-job-modal_Welcome__Inner__vzGyj","Welcome__Person":"select-job-modal_Welcome__Person__qxAVR","Welcome__LeftContent":"select-job-modal_Welcome__LeftContent__wP2r5","Welcome__RightContent":"select-job-modal_Welcome__RightContent__syGKQ","Welcome__Content":"select-job-modal_Welcome__Content__OHhmL","Welcome__CreateAccount":"select-job-modal_Welcome__CreateAccount__PYIa_","Welcome__title":"select-job-modal_Welcome__title__BpZRE","Welcome__FormBox":"select-job-modal_Welcome__FormBox__MhvXS","Form__psw":"select-job-modal_Form__psw__oQocB","Welcome__Container":"select-job-modal_Welcome__Container__QHyJm","Success__Container":"select-job-modal_Success__Container___zjAS","Success":"select-job-modal_Success__e7PSW","Success__Inner":"select-job-modal_Success__Inner__BvRMd","InterviewContainer":"select-job-modal_InterviewContainer__a6SAz","Interview__Stages":"select-job-modal_Interview__Stages__mWauL","Interview__StageHeading":"select-job-modal_Interview__StageHeading__kGxdE","pl10":"select-job-modal_pl10__ITGNv","Interview__AddStageSection":"select-job-modal_Interview__AddStageSection__4oHfb","Interview__Label":"select-job-modal_Interview__Label__fIL9U","Interview__FormRowHeading":"select-job-modal_Interview__FormRowHeading__IOSPE","dpflex":"select-job-modal_dpflex__yCLAt","Interview__IconsType":"select-job-modal_Interview__IconsType__D7Icj","Interview__Icons":"select-job-modal_Interview__Icons__swMvC","Interview__Interview_buttons":"select-job-modal_Interview__Interview_buttons__CMMhq","Interview__approvalButton":"select-job-modal_Interview__approvalButton__daEVk","Interview__BestMatch":"select-job-modal_Interview__BestMatch__fF_bw","Interview__BestMatchExclamation":"select-job-modal_Interview__BestMatchExclamation__uEw3i","DragAndDrop":"select-job-modal_DragAndDrop__CbuGA","DragAndDrop__CursorHandle":"select-job-modal_DragAndDrop__CursorHandle__4TOuV","Tagrow__Image":"select-job-modal_Tagrow__Image__bR5RX","rowbglight":"select-job-modal_rowbglight__azEAY","rowbgheight":"select-job-modal_rowbgheight__olvV4","Form__w90":"select-job-modal_Form__w90__K99yF","Container":"select-job-modal_Container__l9a0C","Screening__StageName":"select-job-modal_Screening__StageName___Qo2d","Screening__InterviewType":"select-job-modal_Screening__InterviewType__yjoQv","Screening__InterviewType__Label":"select-job-modal_Screening__InterviewType__Label___u8tz","Show_Infoicon":"select-job-modal_Show_Infoicon__ITnOI","Show_Infoicon_small":"select-job-modal_Show_Infoicon_small__iFcdY","Screening__Info":"select-job-modal_Screening__Info__zdIUI","Screening__Info__IconWithText":"select-job-modal_Screening__Info__IconWithText__Q7uxE","InterviewType__Icon":"select-job-modal_InterviewType__Icon__4dEDX","InterviewType__Text":"select-job-modal_InterviewType__Text__F9rk7","LoginModal":"select-job-modal_LoginModal__t25rX","Logincontent":"select-job-modal_Logincontent__bTt1T","Logincontent__title":"select-job-modal_Logincontent__title__YoK1q","Modalbg":"select-job-modal_Modalbg__jlkyF","Modalnobg":"select-job-modal_Modalnobg__oK3n_","Form__Container":"select-job-modal_Form__Container__ghY8r","Form__success":"select-job-modal_Form__success__lPBvG","Form__error":"select-job-modal_Form__error__rPBZi","Form__CheckLabeltext":"select-job-modal_Form__CheckLabeltext__tbbMP","Form__TextLeft":"select-job-modal_Form__TextLeft__Rcwij","Backsection":"select-job-modal_Backsection__YexsL","back":"select-job-modal_back__cPwUs","mlr0":"select-job-modal_mlr0__spyqb","TwoButtons":"select-job-modal_TwoButtons__PSDOS","OtpBacksection":"select-job-modal_OtpBacksection__igTiI","SetupPopup":"select-job-modal_SetupPopup__9cGtE","SetupPopup__inner":"select-job-modal_SetupPopup__inner__ee21K","SetupPopup__Dialog":"select-job-modal_SetupPopup__Dialog__0a_3h","SetupPopup__AddFile":"select-job-modal_SetupPopup__AddFile__xl4oo","SetupPopup__OptionalText":"select-job-modal_SetupPopup__OptionalText__TXLan","SetupPopup__RequestAccessBtn":"select-job-modal_SetupPopup__RequestAccessBtn__FeIIY","SetupPopup__InternalSection":"select-job-modal_SetupPopup__InternalSection__pL_AN","SetupPopup__ContentInnerRow":"select-job-modal_SetupPopup__ContentInnerRow__DDqEI","SetupPopup__ToChips":"select-job-modal_SetupPopup__ToChips__ujVO2","SetupPopup__AttachmentContainer":"select-job-modal_SetupPopup__AttachmentContainer__cz07w","SetupPopup__ContentInnerCol":"select-job-modal_SetupPopup__ContentInnerCol__WUONM","SetupPopup__grid":"select-job-modal_SetupPopup__grid__yPvvy","SetupPopup__Footer":"select-job-modal_SetupPopup__Footer__yfk0L","SetupPopup__FooterNew":"select-job-modal_SetupPopup__FooterNew__K0d4i","SetupPopup__Footer2":"select-job-modal_SetupPopup__Footer2__RRz7V","SetupPopup__Footer3":"select-job-modal_SetupPopup__Footer3__iYLDW","SetupPopup__Footerassess":"select-job-modal_SetupPopup__Footerassess__zj4BV","SetupPopup__Footertechtest":"select-job-modal_SetupPopup__Footertechtest__P5g_h","SetupPopup__AutommationFooter":"select-job-modal_SetupPopup__AutommationFooter__lz_MP","SetupPopup__MannualFooter":"select-job-modal_SetupPopup__MannualFooter__2wa_h","SetupPopup__MannualInnerSection":"select-job-modal_SetupPopup__MannualInnerSection__CL4_P","SetupPopup__Content":"select-job-modal_SetupPopup__Content__LeuEU","SelectJob__Content":"select-job-modal_SelectJob__Content__nq2Wl","SetupPopup__Content__Radiobtn":"select-job-modal_SetupPopup__Content__Radiobtn__kE8KB","SetupPopup__AutomationToggle":"select-job-modal_SetupPopup__AutomationToggle__3mhJx","SetupPopup__SetupVideoQa":"select-job-modal_SetupPopup__SetupVideoQa__yxmSK","SetupPopup__SetupVideoQa2":"select-job-modal_SetupPopup__SetupVideoQa2__lLJOW","SetupPopup__SetupVideoQa3":"select-job-modal_SetupPopup__SetupVideoQa3__fvLLS","SetupPopup__SetupVideoQa4":"select-job-modal_SetupPopup__SetupVideoQa4__43Usc","SetupPopup__InputQA":"select-job-modal_SetupPopup__InputQA__rAING","SetupPopup__AddQuestion":"select-job-modal_SetupPopup__AddQuestion__M4gDB","SetupPopup__QuestionSection":"select-job-modal_SetupPopup__QuestionSection__nCLjw","SetupPopup__PushTop":"select-job-modal_SetupPopup__PushTop__kTPIw","SetupPopup__Contentpading":"select-job-modal_SetupPopup__Contentpading__h2atF","SetupPopup__QuesionSectionpading":"select-job-modal_SetupPopup__QuesionSectionpading__cLJ0o","SetupPopup__Contentcenter":"select-job-modal_SetupPopup__Contentcenter__zAKtB","SetupPopup__PopDetails":"select-job-modal_SetupPopup__PopDetails__IWuOs","SetupPopup__PopDetails__FS16":"select-job-modal_SetupPopup__PopDetails__FS16__WFddF","SetupPopup__Details":"select-job-modal_SetupPopup__Details__VSLaz","SetupPopup__PrivacyPolicyDetails":"select-job-modal_SetupPopup__PrivacyPolicyDetails__D9MHS","SetupPopup__Reason":"select-job-modal_SetupPopup__Reason__0tAcL","SetupPopup__ContentBlock":"select-job-modal_SetupPopup__ContentBlock__eiB89","SetupPopup__Purpose":"select-job-modal_SetupPopup__Purpose__E8WIQ","SetupPopup__ContentGridsec":"select-job-modal_SetupPopup__ContentGridsec__zOgLJ","mt25":"select-job-modal_mt25__Y6EJK","mt20":"select-job-modal_mt20__DDuhc","SetupPopup__ContentGridTech":"select-job-modal_SetupPopup__ContentGridTech__FCiZz","SetupPopup__Assesmentsection":"select-job-modal_SetupPopup__Assesmentsection__Enm6x","SetupPopup__AssesmentsectionNew":"select-job-modal_SetupPopup__AssesmentsectionNew__npNx7","SetupPopup__MannualChips":"select-job-modal_SetupPopup__MannualChips__rim1K","SetupPopup__ContentGridManuaCol":"select-job-modal_SetupPopup__ContentGridManuaCol__0fJmt","SetupPopup__ContentGridManual":"select-job-modal_SetupPopup__ContentGridManual__8h7vk","SetupPopup__ContentBlockPhone":"select-job-modal_SetupPopup__ContentBlockPhone__AoRoF","SetupPopup__ContentAddInterview":"select-job-modal_SetupPopup__ContentAddInterview__M9D_k","SetupPopup__ContentGridPhone":"select-job-modal_SetupPopup__ContentGridPhone__DddSy","SetupPopup__ContentGridStatus":"select-job-modal_SetupPopup__ContentGridStatus__CYcS3","SetupPopup__GridActions":"select-job-modal_SetupPopup__GridActions__i_tJl","SetupPopup__GridActionCoral":"select-job-modal_SetupPopup__GridActionCoral__Kr01U","SetupPopup__GridActionIndigo":"select-job-modal_SetupPopup__GridActionIndigo__Nc9RA","SetupPopup__ContentGrid":"select-job-modal_SetupPopup__ContentGrid__tn2Zd","SetupPopup__SubmitSectionSave":"select-job-modal_SetupPopup__SubmitSectionSave__4AFG6","SetupPopup__SubmitSectionReset":"select-job-modal_SetupPopup__SubmitSectionReset__cyWGj","SetupPopup__SubmitSectionAutomation":"select-job-modal_SetupPopup__SubmitSectionAutomation__mD2lm","SetupPopup__Duration":"select-job-modal_SetupPopup__Duration__HBjzn","SetupPopup__DeleteIcon":"select-job-modal_SetupPopup__DeleteIcon__64OSP","SetupPopup__ContentCustomisationManualInterview":"select-job-modal_SetupPopup__ContentCustomisationManualInterview__XTIUM","mt0":"select-job-modal_mt0__fcxZ_","mtb25":"select-job-modal_mtb25__nQSji","mb15":"select-job-modal_mb15__Jaqgy","mb30":"select-job-modal_mb30__QnURT","mt9":"select-job-modal_mt9__TkXYG","lineheight0":"select-job-modal_lineheight0__sBOav","PopupHeightSection":"select-job-modal_PopupHeightSection___U2iB","AssessPopupHeightSection":"select-job-modal_AssessPopupHeightSection__HhD_z","Statusopupheight":"select-job-modal_Statusopupheight__1Z2JO","buttonIn":"select-job-modal_buttonIn__Lv5OV","MessagePlaceholder":"select-job-modal_MessagePlaceholder__LV0eD","m0":"select-job-modal_m0__UMXX1","mt18":"select-job-modal_mt18__x_crR","DPgrid":"select-job-modal_DPgrid__3_Bhp","addbtnposition":"select-job-modal_addbtnposition__pZ8ey","mainformdiv":"select-job-modal_mainformdiv__zScT9","crossflex":"select-job-modal_crossflex__ExWRG","crossimgheight":"select-job-modal_crossimgheight__pyC0z","crossimgheight48":"select-job-modal_crossimgheight48__egGyf","SetupModalPopup":"select-job-modal_SetupModalPopup__iybeR","SetupModalPopup__Dialog":"select-job-modal_SetupModalPopup__Dialog__Dzf6q","SetupPopupoverlay":"select-job-modal_SetupPopupoverlay__NlVm2","NeedHelp":"select-job-modal_NeedHelp__nltU2","uploadNewTest":"select-job-modal_uploadNewTest__OOOIt","SetupPopup__ol":"select-job-modal_SetupPopup__ol__YwJ3u","Threshold__Content":"select-job-modal_Threshold__Content__JF0eV","SelectJob__CustomSelectWidth":"select-job-modal_SelectJob__CustomSelectWidth__EWPMv","SelectJob__DisplayFlex":"select-job-modal_SelectJob__DisplayFlex__9Cs2L","SelectJob__Label":"select-job-modal_SelectJob__Label__8v7b6","SelectJob__ButtonAction":"select-job-modal_SelectJob__ButtonAction__dKRWQ","SelectJob__Footer":"select-job-modal_SelectJob__Footer__MMMWJ"};

/***/ }),

/***/ 85374:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Modalpopup":"setupmodel_Modalpopup__zqvxl","Modalpopup__inner":"setupmodel_Modalpopup__inner__7VBdu","Modalpopup__Dialog":"setupmodel_Modalpopup__Dialog__52ivJ","transition":"setupmodel_transition__9CZ4G","Modalpopup__CloseCenter":"setupmodel_Modalpopup__CloseCenter__VrYB7","Modalpopup__Content":"setupmodel_Modalpopup__Content__iZ8Xs","SetupPopup__PaddingPopup":"setupmodel_SetupPopup__PaddingPopup__OmE0r","SetupPopup__ContentCustomisation":"setupmodel_SetupPopup__ContentCustomisation__YNZw1","SetupPopup__Contentwithoutpadding":"setupmodel_SetupPopup__Contentwithoutpadding__6I3w4","Modalpopup__btn":"setupmodel_Modalpopup__btn__OUNl1","mar":"setupmodel_mar__ehBrs","Otpback":"setupmodel_Otpback__Apu1G","Form":"setupmodel_Form__id3VY","Form__width":"setupmodel_Form__width__xeWc8","Form__label":"setupmodel_Form__label__2_RM5","Form__textleft":"setupmodel_Form__textleft__oMFMd","Form__InputFullWidth":"setupmodel_Form__InputFullWidth__joTcN","Form__Input":"setupmodel_Form__Input__wAu3x","Form__Input398":"setupmodel_Form__Input398__aDwZX","Form__InputSection":"setupmodel_Form__InputSection__0B09X","Form__ScoreCardInput":"setupmodel_Form__ScoreCardInput__GDBV3","Form__Textarea":"setupmodel_Form__Textarea__rk0yO","primarybtn":"setupmodel_primarybtn__VaZbc","GoBtn":"setupmodel_GoBtn__RBGk3","secondarybtn":"setupmodel_secondarybtn__aqcTk","iconFilled":"setupmodel_iconFilled__StHd3","iconFilledSolid":"setupmodel_iconFilledSolid__h5I_1","primarybtnborder":"setupmodel_primarybtnborder__xeAzf","secondarybtnborder":"setupmodel_secondarybtnborder__xtGP4","ClearBtn":"setupmodel_ClearBtn__1cnIY","tertiarybtn":"setupmodel_tertiarybtn__wFB5j","graybtnborder":"setupmodel_graybtnborder__lS_ss","jobsrchbtn":"setupmodel_jobsrchbtn__CQs0e","jobsrchbtnalign":"setupmodel_jobsrchbtnalign__CjKSh","nobgbutton":"setupmodel_nobgbutton__zp3K6","iconTextButton":"setupmodel_iconTextButton__l3i5O","cursornone":"setupmodel_cursornone__TwdT9","nobgbuttonprimary":"setupmodel_nobgbuttonprimary__2Lg8Y","mt15":"setupmodel_mt15__HRjKf","btn350":"setupmodel_btn350__DMU8e","GrayBgBtn":"setupmodel_GrayBgBtn__9b4mB","NewShareBtn":"setupmodel_NewShareBtn__yFbMg","CoralBgBtn":"setupmodel_CoralBgBtn__YpJYr","DropContainer":"setupmodel_DropContainer__hi2R7","DropContainer__Inner":"setupmodel_DropContainer__Inner__asFrD","CompanyProfile__Inner":"setupmodel_CompanyProfile__Inner__3CjKb","DropContainer__Message":"setupmodel_DropContainer__Message___iNJT","CompanyProfile__Message":"setupmodel_CompanyProfile__Message__CobNG","CompanyProfile__MessageContent":"setupmodel_CompanyProfile__MessageContent__4bZuF","DropContainer__UploadIcon":"setupmodel_DropContainer__UploadIcon__FDxFw","CompanyProfile__UploadIcon":"setupmodel_CompanyProfile__UploadIcon__tSYOx","FileDisplayContainer":"setupmodel_FileDisplayContainer__qDese","FileDisplayContainer__Status":"setupmodel_FileDisplayContainer__Status__n76ml","SetupPopup__Status":"setupmodel_SetupPopup__Status__QCQuC","SetupPopup__To":"setupmodel_SetupPopup__To__ejafM","FileDisplayContainer__Type":"setupmodel_FileDisplayContainer__Type__Quew0","FileDisplayContainer__Name":"setupmodel_FileDisplayContainer__Name__0E_fr","SetupPopup__Name":"setupmodel_SetupPopup__Name__CMopd","SetupPopup__ToName":"setupmodel_SetupPopup__ToName__auLwW","FileDisplayContainer__Error":"setupmodel_FileDisplayContainer__Error__f6OD0","FileDisplayContainer__Close":"setupmodel_FileDisplayContainer__Close__jywlN","Browse":"setupmodel_Browse__9cGwG","ClientCompany":"setupmodel_ClientCompany__HAzwZ","NewJob":"setupmodel_NewJob__NEg1P","Interview":"setupmodel_Interview__q4t_t","ClientCompany__TopSection2":"setupmodel_ClientCompany__TopSection2__gdCe0","ClientCompany__Filter":"setupmodel_ClientCompany__Filter__Fuk2V","ClientCompany__Input_MatchScore":"setupmodel_ClientCompany__Input_MatchScore__emF_R","ClientCompany__Percentage_Symbol":"setupmodel_ClientCompany__Percentage_Symbol__uxYaK","ClientCompany__Filterheading":"setupmodel_ClientCompany__Filterheading__rsD_k","ClientCompany__FloatButtonAdd":"setupmodel_ClientCompany__FloatButtonAdd__Nf9PV","ClientCompany__FloatButtonAdd__AgencyUserIcon":"setupmodel_ClientCompany__FloatButtonAdd__AgencyUserIcon__rGiZ4","ClientCompany__LastEdited":"setupmodel_ClientCompany__LastEdited__HTrzq","ClientCompany__BackSection":"setupmodel_ClientCompany__BackSection__NXQ_C","AddUsers__BackSection":"setupmodel_AddUsers__BackSection__q4pqA","ClientCompany__BackSection__CloseIcon":"setupmodel_ClientCompany__BackSection__CloseIcon__sDSKX","ClientCompany__Container":"setupmodel_ClientCompany__Container__6P6BE","NewJob__InterviewContainer":"setupmodel_NewJob__InterviewContainer___cSh0","AddUsers__Container":"setupmodel_AddUsers__Container__vSHXj","ClientCompany__FormInputSection":"setupmodel_ClientCompany__FormInputSection__XWQGi","CompanyProfile__FormInputSection":"setupmodel_CompanyProfile__FormInputSection__CmMWx","ClientCompany__Heading":"setupmodel_ClientCompany__Heading__iQEdq","AddUsers__Heading":"setupmodel_AddUsers__Heading__i5THp","ClientCompany__StatusAlignment":"setupmodel_ClientCompany__StatusAlignment__p3Ubi","ClientCompany__Status":"setupmodel_ClientCompany__Status__nFm9w","ClientCompany__ActiveDot":"setupmodel_ClientCompany__ActiveDot__IvSMl","ClientCompany__CloseDot":"setupmodel_ClientCompany__CloseDot__8muyY","ClientCompany__Company":"setupmodel_ClientCompany__Company__xANXC","AddUsers__User":"setupmodel_AddUsers__User__0y_c1","ClientCompany__Systemrefheding":"setupmodel_ClientCompany__Systemrefheding__GaoZg","ClientCompany__Subheading":"setupmodel_ClientCompany__Subheading__IRZ98","CompanyProfile__Subheading":"setupmodel_CompanyProfile__Subheading__3YE59","ClientCompany__Subheading2":"setupmodel_ClientCompany__Subheading2__U_lJO","ClientCompany__Description":"setupmodel_ClientCompany__Description__Lw2Uc","ClientCompany__SubmitSection":"setupmodel_ClientCompany__SubmitSection__VbAS2","NewJob__SubmitSection":"setupmodel_NewJob__SubmitSection__7q9Cq","SetupPopup__SubmitSection2":"setupmodel_SetupPopup__SubmitSection2__eRsUj","SetupPopup__SubmitSection":"setupmodel_SetupPopup__SubmitSection__x2Wpp","SetupPopup__SubmitSection3":"setupmodel_SetupPopup__SubmitSection3__cPtuw","NewJob__SubmitSectionThreeBtn":"setupmodel_NewJob__SubmitSectionThreeBtn__zm9f3","NewJob__SubmitSectionOneBtnPlacement":"setupmodel_NewJob__SubmitSectionOneBtnPlacement__jWxMB","NewJob__ImportSection":"setupmodel_NewJob__ImportSection__3CZNJ","AddUsers__SubmitSection":"setupmodel_AddUsers__SubmitSection__pyD1A","ClientCompany__IntegrationImage":"setupmodel_ClientCompany__IntegrationImage__IbiEC","ClientCompany__QuickAdd":"setupmodel_ClientCompany__QuickAdd__rma0x","NewJob__QuickAdd":"setupmodel_NewJob__QuickAdd__hHOcr","Interview__QuickAdd":"setupmodel_Interview__QuickAdd__KQ0Kf","ClientCompany__BodyText":"setupmodel_ClientCompany__BodyText__LG5UT","Form__TableRow":"setupmodel_Form__TableRow__3PLvv","Form__Label":"setupmodel_Form__Label__u0h74","Form__FloatingLabel":"setupmodel_Form__FloatingLabel__V2C_z","Form__TableCol":"setupmodel_Form__TableCol__ut6HZ","Form__currency_symbol":"setupmodel_Form__currency_symbol__vYEIP","Form__CustomSelect":"setupmodel_Form__CustomSelect__0SJl4","Form__currency_symbol__right":"setupmodel_Form__currency_symbol__right__WvrHp","Form__TableCol__Disabled":"setupmodel_Form__TableCol__Disabled__BXRCC","Form__TextareaDisabled":"setupmodel_Form__TextareaDisabled__OxI0h","Form__EditorDisabled":"setupmodel_Form__EditorDisabled__S_bfV","Form__AdminCheckLabel":"setupmodel_Form__AdminCheckLabel__6aoyQ","Form__AdminCheckMargin":"setupmodel_Form__AdminCheckMargin__JCLEK","CompanyProfile__BrandingGuide":"setupmodel_CompanyProfile__BrandingGuide__3OoaT","CompanyProfile__DropBoxContainer":"setupmodel_CompanyProfile__DropBoxContainer__Ngce3","CompanyProfile__Browse":"setupmodel_CompanyProfile__Browse__AlOGa","ErrorLabel":"setupmodel_ErrorLabel___wgOm","Height80":"setupmodel_Height80__yZ37B","Browse__ButtonFlexEnd":"setupmodel_Browse__ButtonFlexEnd__ca5Kd","AddAgency__Container":"setupmodel_AddAgency__Container___4DvA","AddAgency__FormInputSection":"setupmodel_AddAgency__FormInputSection__647GH","AddAgency__FormInputSection__Label":"setupmodel_AddAgency__FormInputSection__Label__CKhnN","AddAgency__Form":"setupmodel_AddAgency__Form__FgoOL","LinkAsButtons":"setupmodel_LinkAsButtons__mxXOZ","SearchFlex":"setupmodel_SearchFlex__jWLuh","Form__ErrorCustomSelect":"setupmodel_Form__ErrorCustomSelect__56cjR","Form__select_currency":"setupmodel_Form__select_currency__Cz0GC","customSelect__placeholder":"setupmodel_customSelect__placeholder__ZkqHM","Career":"setupmodel_Career__AvMAv","Career__Background_Edit":"setupmodel_Career__Background_Edit__49cNf","Career__Background_Edit_Image":"setupmodel_Career__Background_Edit_Image__pcGDl","Career__Container":"setupmodel_Career__Container__W1sw4","Career__Inner":"setupmodel_Career__Inner__ipB2_","Career__logo":"setupmodel_Career__logo__DTkkj","Career__Content":"setupmodel_Career__Content__s8skP","Career__ButtonSection":"setupmodel_Career__ButtonSection__QEOsO","Job":"setupmodel_Job__D8Mtj","Job__Inner":"setupmodel_Job__Inner__8f7vV","Job__Container":"setupmodel_Job__Container__PfQHh","Job__Heading":"setupmodel_Job__Heading__bUoSY","Job__Company":"setupmodel_Job__Company__gWl1A","Job__SearchContainer":"setupmodel_Job__SearchContainer__E7DD7","Job__SearchInput":"setupmodel_Job__SearchInput__TeuKD","Job__Searchbtn":"setupmodel_Job__Searchbtn__mi7Ql","Job__Input":"setupmodel_Job__Input__k59rS","Job__SelectJob":"setupmodel_Job__SelectJob__ywFI0","Job__RemoteLabel":"setupmodel_Job__RemoteLabel__vX6hS","Job__Display":"setupmodel_Job__Display__wAosI","Job__PostDay":"setupmodel_Job__PostDay__vzll5","Job__Title":"setupmodel_Job__Title__4UwjM","Job__Location":"setupmodel_Job__Location__ZMijF","DT":"setupmodel_DT__ondK1","DisplayTable":"setupmodel_DisplayTable__m3S5k","pd11":"setupmodel_pd11__sAvtA","Label":"setupmodel_Label__MXnXj","inputwidth":"setupmodel_inputwidth__Bv1Ck","mr24":"setupmodel_mr24__qC5jJ","fullwidth":"setupmodel_fullwidth__on5KZ","padt40":"setupmodel_padt40__fGv96","Form__TableRowflex":"setupmodel_Form__TableRowflex__ibep5","Form__TableColm":"setupmodel_Form__TableColm__M3_Us","Form__LabelCheck":"setupmodel_Form__LabelCheck__1Fkdu","Form__Error":"setupmodel_Form__Error__iflAL","Form__ErrorSection":"setupmodel_Form__ErrorSection__2XAhG","Form__MessagePlaceholder":"setupmodel_Form__MessagePlaceholder__rIGH0","Form__Submit":"setupmodel_Form__Submit__4WghA","Form__NormalLabel":"setupmodel_Form__NormalLabel__9__Fb","AddInterview":"setupmodel_AddInterview__oGZEL","IntegrationPage":"setupmodel_IntegrationPage__ucZrh","Integration__BackStep":"setupmodel_Integration__BackStep__9VE1b","AddUsers__BackStep":"setupmodel_AddUsers__BackStep__JOXby","Integration__SubmitSection":"setupmodel_Integration__SubmitSection__NQ2zB","IntegrationTable":"setupmodel_IntegrationTable__X0VHm","IntegrationTable__LimitInput":"setupmodel_IntegrationTable__LimitInput__8qDYS","IntegrationTable__Type":"setupmodel_IntegrationTable__Type__x8SpZ","IntegrationTable__AllJobsToggle":"setupmodel_IntegrationTable__AllJobsToggle__gLv2D","IntegrationTable__switch":"setupmodel_IntegrationTable__switch__vcdqH","IntegrationTable__switchText":"setupmodel_IntegrationTable__switchText__9xLMF","IntegrationTable__slider":"setupmodel_IntegrationTable__slider__lqBgh","IntegrationTable__round":"setupmodel_IntegrationTable__round__z4gmk","IntegrationTable__Action":"setupmodel_IntegrationTable__Action__ovRuv","IntegrationView":"setupmodel_IntegrationView__85pnV","IntegrationView__Title":"setupmodel_IntegrationView__Title__dSAFG","IntegrationView__Subheading":"setupmodel_IntegrationView__Subheading__Jj2pU","IntegrationView__BoxImage":"setupmodel_IntegrationView__BoxImage__mQW6A","IntegrationView__Box":"setupmodel_IntegrationView__Box__qzJH4","IntegrationView__BoxImage__InfoIcon":"setupmodel_IntegrationView__BoxImage__InfoIcon__DpMfd","IntegrationView__ViewMoreButton":"setupmodel_IntegrationView__ViewMoreButton__vcu_G","IntegrationView__ConnectButton":"setupmodel_IntegrationView__ConnectButton__r7pVb","IntegrationView__GoogleButton":"setupmodel_IntegrationView__GoogleButton__rw_21","IntegrationView__FlexFlow":"setupmodel_IntegrationView__FlexFlow__0kV7H","IntegrationView__BoxWidth":"setupmodel_IntegrationView__BoxWidth__RC8Ve","SkipFinishButton":"setupmodel_SkipFinishButton__i0iEp","AddUsers":"setupmodel_AddUsers__jhIga","AddUsers__ButtonSection":"setupmodel_AddUsers__ButtonSection__9ZOQy","AddUsers__QuickStepHeading":"setupmodel_AddUsers__QuickStepHeading__9NYb7","AddUsers__DeleteSection":"setupmodel_AddUsers__DeleteSection__KbWCV","Interview__DeleteSection":"setupmodel_Interview__DeleteSection__u_aXK","AddUsers__DeleteCrossHeight":"setupmodel_AddUsers__DeleteCrossHeight__qBv0a","AddUsers__Form__Input":"setupmodel_AddUsers__Form__Input__woBjM","AddUsers__FormHeadingSection":"setupmodel_AddUsers__FormHeadingSection__SMWEg","Interview__FormHeadingSection":"setupmodel_Interview__FormHeadingSection__oq2Zw","AddUsers__FormSection":"setupmodel_AddUsers__FormSection__YJMHV","NewJob__FormSection":"setupmodel_NewJob__FormSection__HK_82","AddUsers__ButtonsActionSection":"setupmodel_AddUsers__ButtonsActionSection__hqop_","AddUsers__ImportUsers":"setupmodel_AddUsers__ImportUsers__aHK3T","AddUsers__NameInput":"setupmodel_AddUsers__NameInput__ZX8qp","AddUsers__EmailInput":"setupmodel_AddUsers__EmailInput__5UFya","AddUsers__RoleInput":"setupmodel_AddUsers__RoleInput__OCpYg","AddUsers__Subheading":"setupmodel_AddUsers__Subheading__y_yUE","AddUsers__visible":"setupmodel_AddUsers__visible__UbWcR","Tagrow":"setupmodel_Tagrow__ZICg6","Tagrow__Tags":"setupmodel_Tagrow__Tags__kW6X0","SetupPopup__Tags":"setupmodel_SetupPopup__Tags__fv5l_","Tagrow__Cancel":"setupmodel_Tagrow__Cancel__H29TO","Tagrow__Cross":"setupmodel_Tagrow__Cross__1lFoL","SendInviteSection":"setupmodel_SendInviteSection__quj8q","error":"setupmodel_error__aY6nK","ViewJobPage__Input":"setupmodel_ViewJobPage__Input__vPD31","Form__Input2":"setupmodel_Form__Input2___fbPm","ViewJobPage__PostDay":"setupmodel_ViewJobPage__PostDay__nvIxF","ViewJobPage__Title":"setupmodel_ViewJobPage__Title__qpyHR","ViewJobPage__DescriptionTitle":"setupmodel_ViewJobPage__DescriptionTitle__ZhqhN","ViewJobPage__Location":"setupmodel_ViewJobPage__Location__cbVrq","ViewJobPage__primarybtn":"setupmodel_ViewJobPage__primarybtn__ZiEzV","ViewJobPage__secondarybtn":"setupmodel_ViewJobPage__secondarybtn__tZ9c2","ViewJobPage__secondarybtnborder":"setupmodel_ViewJobPage__secondarybtnborder__4UmRy","ViewJobPage__BackSection":"setupmodel_ViewJobPage__BackSection__wK0gQ","ViewJobPage__Content":"setupmodel_ViewJobPage__Content__1VMnP","ViewJobPage":"setupmodel_ViewJobPage__wNkLf","ViewJobPage__Header":"setupmodel_ViewJobPage__Header__etWcj","ViewJobPage__Application":"setupmodel_ViewJobPage__Application__Vghsz","ViewJobPage__RecordVideo":"setupmodel_ViewJobPage__RecordVideo__MiZG3","ViewJobPage__RecordVideoSuccessText":"setupmodel_ViewJobPage__RecordVideoSuccessText__EYgJS","ViewJobPage__subheading":"setupmodel_ViewJobPage__subheading__jZKSe","ViewJobPage__confirmation":"setupmodel_ViewJobPage__confirmation__Xjkw9","ViewJobPage__Logo":"setupmodel_ViewJobPage__Logo__YRE7m","ViewJobPage__BrandLogo":"setupmodel_ViewJobPage__BrandLogo__2vE5J","ViewJobPage__BrandLogo__Padding10":"setupmodel_ViewJobPage__BrandLogo__Padding10__YBKoK","ViewJobPage__Container":"setupmodel_ViewJobPage__Container__gh4hf","ViewJobPage__JobContent":"setupmodel_ViewJobPage__JobContent__j_Ldv","ViewJobPage__Sidebar":"setupmodel_ViewJobPage__Sidebar__DNVEV","ViewJobPage__Sidebar2":"setupmodel_ViewJobPage__Sidebar2__H_trY","ViewJobPage__Description":"setupmodel_ViewJobPage__Description__Jj9Op","ViewJobPage__DescriptionWidth":"setupmodel_ViewJobPage__DescriptionWidth__QwNuE","ViewJobPage__Footer":"setupmodel_ViewJobPage__Footer__I8gqU","ViewJobPage__FooterView":"setupmodel_ViewJobPage__FooterView__j4z29","ViewJobPage__ShareJob":"setupmodel_ViewJobPage__ShareJob__IHoft","ViewJobPage__SubmitSection":"setupmodel_ViewJobPage__SubmitSection__XCSzE","ViewJobPage__SocialMedia":"setupmodel_ViewJobPage__SocialMedia___aMHC","ViewJobPage__SideContent":"setupmodel_ViewJobPage__SideContent__9GgX7","ViewJobPage__ApplySection":"setupmodel_ViewJobPage__ApplySection__DAbJr","FormBox__Autofill":"setupmodel_FormBox__Autofill__L5Ri9","applybuttons":"setupmodel_applybuttons__td4_D","height90":"setupmodel_height90__1oGOu","Form__Cont":"setupmodel_Form__Cont__9Od9n","Form__DropBox":"setupmodel_Form__DropBox__GkhpM","Form__DropBoxcontainer":"setupmodel_Form__DropBoxcontainer__D25_J","Form__DropBoxError":"setupmodel_Form__DropBoxError__6CA58","Form__DropBoxicon":"setupmodel_Form__DropBoxicon__nyddx","Form__DropBoxmessage":"setupmodel_Form__DropBoxmessage__QfGpq","noDpGrid":"setupmodel_noDpGrid__rS_WF","Terms":"setupmodel_Terms__RTHOC","TermsCondition":"setupmodel_TermsCondition__K5cmJ","TermsCondition__alignterms":"setupmodel_TermsCondition__alignterms__xWWoU","MenuContainer":"setupmodel_MenuContainer__RBpMi","MenuContainer__Menu":"setupmodel_MenuContainer__Menu__rvY5o","AgencyDetailPage":"setupmodel_AgencyDetailPage__RZlFS","Congrats__ModalContent":"setupmodel_Congrats__ModalContent__pCnVj","NewJob__Container":"setupmodel_NewJob__Container__FRYRt","NewJob__TopSection":"setupmodel_NewJob__TopSection__61YvP","Interview__TopSection":"setupmodel_Interview__TopSection__zGcmw","NewJob__HorizontalDivider":"setupmodel_NewJob__HorizontalDivider__wA8vE","NewJob__Wrapper":"setupmodel_NewJob__Wrapper__WU0Tv","NewJob__ContainerPadding":"setupmodel_NewJob__ContainerPadding__9iIvF","NewJob__ContainerScroll":"setupmodel_NewJob__ContainerScroll__7Mo6g","NewJob__ContainerHeight":"setupmodel_NewJob__ContainerHeight__Av_vp","NewJob__ImportAction":"setupmodel_NewJob__ImportAction__xH1Da","NewJob__Interview_buttons":"setupmodel_NewJob__Interview_buttons__QmoSI","Form__TableRowMB":"setupmodel_Form__TableRowMB__Lcw_I","Form__TableRow3grid":"setupmodel_Form__TableRow3grid__buTb3","Form__Remotegrid":"setupmodel_Form__Remotegrid__cg1DE","Form__TypeList":"setupmodel_Form__TypeList__eaXJb","Form__Type":"setupmodel_Form__Type__ainyC","Form__CheckLabel":"setupmodel_Form__CheckLabel__woyna","PrivateSwitchBase-root-1":"setupmodel_PrivateSwitchBase-root-1__KTpYm","Form__Caption":"setupmodel_Form__Caption__NRur9","Form__Input_currency":"setupmodel_Form__Input_currency__DHbVv","Form__Input_MatchScore":"setupmodel_Form__Input_MatchScore__4EBad","Form__Percentage_Symbol":"setupmodel_Form__Percentage_Symbol__tOMkh","Form__NoGridTemplate":"setupmodel_Form__NoGridTemplate___BUlY","active":"setupmodel_active__zRVcU","mt10":"setupmodel_mt10__tcNhW","mt40":"setupmodel_mt40__1jswf","mt30":"setupmodel_mt30__d3wNc","mt32":"setupmodel_mt32___V8vY","mb0":"setupmodel_mb0__iyVDs","Dpgrid":"setupmodel_Dpgrid__vOk6s","mb12":"setupmodel_mb12__X0QZT","width100":"setupmodel_width100__89tUE","Tagrow__Prefix":"setupmodel_Tagrow__Prefix__5xosN","PreviewJobPage":"setupmodel_PreviewJobPage__F6U_F","PreviewJob":"setupmodel_PreviewJob__1N_xu","DpFlx":"setupmodel_DpFlx__lrWmA","Subheading":"setupmodel_Subheading__yFSmb","Subheading__Description":"setupmodel_Subheading__Description__3OszB","Candidate__Tooltip":"setupmodel_Candidate__Tooltip__oYPxl","Candidate__Tooltip__Score":"setupmodel_Candidate__Tooltip__Score__4HBqD","Form__InputField":"setupmodel_Form__InputField__AtsR_","Candidate__Length":"setupmodel_Candidate__Length__94_67","Agency__PostDay":"setupmodel_Agency__PostDay__2cxpU","Agency__Title":"setupmodel_Agency__Title__bhD8p","Agency__Location":"setupmodel_Agency__Location__FJtAh","Agency__DescriptionTitle":"setupmodel_Agency__DescriptionTitle__Evf8w","Agency__Description":"setupmodel_Agency__Description__DPvjv","LightBlueColor":"setupmodel_LightBlueColor__zD5pk","Client_Page":"setupmodel_Client_Page__FjeY3","Welcome":"setupmodel_Welcome__Ha4y6","Welcome__Inner":"setupmodel_Welcome__Inner__9db_S","Welcome__Person":"setupmodel_Welcome__Person__b_plC","Welcome__LeftContent":"setupmodel_Welcome__LeftContent__yztZq","Welcome__RightContent":"setupmodel_Welcome__RightContent__8rSbx","Welcome__Content":"setupmodel_Welcome__Content__jz2Et","Welcome__CreateAccount":"setupmodel_Welcome__CreateAccount__ASs_Q","Welcome__title":"setupmodel_Welcome__title__hSC6d","Welcome__FormBox":"setupmodel_Welcome__FormBox__Ci8Xz","Form__psw":"setupmodel_Form__psw__yW9l7","Welcome__Container":"setupmodel_Welcome__Container__rwupM","Success__Container":"setupmodel_Success__Container__cCREU","Success":"setupmodel_Success__s2lWr","Success__Inner":"setupmodel_Success__Inner__aISPD","InterviewContainer":"setupmodel_InterviewContainer__t5Pyn","Interview__Stages":"setupmodel_Interview__Stages__ZDMrC","Interview__StageHeading":"setupmodel_Interview__StageHeading__zoP1K","pl10":"setupmodel_pl10__i1gQ9","Interview__AddStageSection":"setupmodel_Interview__AddStageSection__fKS26","Interview__Label":"setupmodel_Interview__Label__LuYrH","Interview__FormRowHeading":"setupmodel_Interview__FormRowHeading__OrQ5v","dpflex":"setupmodel_dpflex__H6QCj","Interview__IconsType":"setupmodel_Interview__IconsType__bFRtI","Interview__Icons":"setupmodel_Interview__Icons__04Are","Interview__Interview_buttons":"setupmodel_Interview__Interview_buttons__Uautj","Interview__approvalButton":"setupmodel_Interview__approvalButton__C7CBx","Interview__BestMatch":"setupmodel_Interview__BestMatch__30W4M","Interview__BestMatchExclamation":"setupmodel_Interview__BestMatchExclamation__kF0hZ","DragAndDrop":"setupmodel_DragAndDrop__r1_NG","DragAndDrop__CursorHandle":"setupmodel_DragAndDrop__CursorHandle__aALJg","Tagrow__Image":"setupmodel_Tagrow__Image__0FR6z","rowbglight":"setupmodel_rowbglight__CERK2","rowbgheight":"setupmodel_rowbgheight__R49Z1","Form__w90":"setupmodel_Form__w90__7b8Lb","Container":"setupmodel_Container__NLkq1","Screening__StageName":"setupmodel_Screening__StageName__jGT5J","Screening__InterviewType":"setupmodel_Screening__InterviewType__MboPK","Screening__InterviewType__Label":"setupmodel_Screening__InterviewType__Label__TxKiQ","Show_Infoicon":"setupmodel_Show_Infoicon__OEczS","Show_Infoicon_small":"setupmodel_Show_Infoicon_small__2OV0_","Screening__Info":"setupmodel_Screening__Info__TAmFy","Screening__Info__IconWithText":"setupmodel_Screening__Info__IconWithText__BpOCx","InterviewType__Icon":"setupmodel_InterviewType__Icon__Hn9j8","InterviewType__Text":"setupmodel_InterviewType__Text__qHEK8","LoginModal":"setupmodel_LoginModal__ZnVUF","Logincontent":"setupmodel_Logincontent__AwWer","Logincontent__title":"setupmodel_Logincontent__title__m_PfN","Modalbg":"setupmodel_Modalbg__7GbAd","Modalnobg":"setupmodel_Modalnobg__1cXGV","Form__Container":"setupmodel_Form__Container__cE4Bb","Form__success":"setupmodel_Form__success__ttN1X","Form__error":"setupmodel_Form__error__uvq6s","Form__CheckLabeltext":"setupmodel_Form__CheckLabeltext__oN6AE","Form__TextLeft":"setupmodel_Form__TextLeft__0WGHe","Backsection":"setupmodel_Backsection__sbJP7","back":"setupmodel_back__iH2Pn","mlr0":"setupmodel_mlr0__agQ07","TwoButtons":"setupmodel_TwoButtons___uFcz","OtpBacksection":"setupmodel_OtpBacksection__gAIBI","SetupPopup":"setupmodel_SetupPopup__p0g3v","SetupPopup__inner":"setupmodel_SetupPopup__inner__PKw59","SetupPopup__Dialog":"setupmodel_SetupPopup__Dialog__o5UFB","SetupPopup__AddFile":"setupmodel_SetupPopup__AddFile__WkxUE","SetupPopup__OptionalText":"setupmodel_SetupPopup__OptionalText__4aiL5","SetupPopup__RequestAccessBtn":"setupmodel_SetupPopup__RequestAccessBtn__2YLnZ","SetupPopup__InternalSection":"setupmodel_SetupPopup__InternalSection__p0oIV","SetupPopup__ContentInnerRow":"setupmodel_SetupPopup__ContentInnerRow__9He60","SetupPopup__ToChips":"setupmodel_SetupPopup__ToChips__Nld4N","SetupPopup__AttachmentContainer":"setupmodel_SetupPopup__AttachmentContainer__ant4K","SetupPopup__ContentInnerCol":"setupmodel_SetupPopup__ContentInnerCol__Janps","SetupPopup__grid":"setupmodel_SetupPopup__grid__9Xkkh","SetupPopup__Footer":"setupmodel_SetupPopup__Footer__vmIKG","SetupPopup__FooterNew":"setupmodel_SetupPopup__FooterNew__OE_uB","SetupPopup__Footer2":"setupmodel_SetupPopup__Footer2__yEUbo","SetupPopup__Footer3":"setupmodel_SetupPopup__Footer3___oPnx","SetupPopup__Footerassess":"setupmodel_SetupPopup__Footerassess__TyTvr","SetupPopup__Footertechtest":"setupmodel_SetupPopup__Footertechtest__jtMKp","SetupPopup__AutommationFooter":"setupmodel_SetupPopup__AutommationFooter__KCcZq","SetupPopup__MannualFooter":"setupmodel_SetupPopup__MannualFooter__oKBeD","SetupPopup__MannualInnerSection":"setupmodel_SetupPopup__MannualInnerSection__YFSjC","SetupPopup__Content":"setupmodel_SetupPopup__Content__dyLlR","SetupPopup__Content__Radiobtn":"setupmodel_SetupPopup__Content__Radiobtn__IkaU7","SetupPopup__AutomationToggle":"setupmodel_SetupPopup__AutomationToggle__i34dj","SetupPopup__SetupVideoQa":"setupmodel_SetupPopup__SetupVideoQa__0K7wl","SetupPopup__SetupVideoQa2":"setupmodel_SetupPopup__SetupVideoQa2__Duipr","SetupPopup__SetupVideoQa3":"setupmodel_SetupPopup__SetupVideoQa3__22KGB","SetupPopup__SetupVideoQa4":"setupmodel_SetupPopup__SetupVideoQa4__2Q2Dj","SetupPopup__InputQA":"setupmodel_SetupPopup__InputQA__w_si0","SetupPopup__AddQuestion":"setupmodel_SetupPopup__AddQuestion__AH4H6","SetupPopup__QuestionSection":"setupmodel_SetupPopup__QuestionSection__U3lcV","SetupPopup__PushTop":"setupmodel_SetupPopup__PushTop__T_CwT","SetupPopup__Contentpading":"setupmodel_SetupPopup__Contentpading__ty8JS","SetupPopup__QuesionSectionpading":"setupmodel_SetupPopup__QuesionSectionpading__BdUH0","SetupPopup__Contentcenter":"setupmodel_SetupPopup__Contentcenter__4_B8D","SetupPopup__PopDetails":"setupmodel_SetupPopup__PopDetails__Kk89j","SetupPopup__PopDetails__FS16":"setupmodel_SetupPopup__PopDetails__FS16__JDD7N","SetupPopup__Details":"setupmodel_SetupPopup__Details__6LTBk","SetupPopup__PrivacyPolicyDetails":"setupmodel_SetupPopup__PrivacyPolicyDetails__XmOF_","SetupPopup__Reason":"setupmodel_SetupPopup__Reason__7gjQj","SetupPopup__ContentBlock":"setupmodel_SetupPopup__ContentBlock__sjXTf","SetupPopup__Purpose":"setupmodel_SetupPopup__Purpose__N0W60","SetupPopup__ContentGridsec":"setupmodel_SetupPopup__ContentGridsec__BIUF7","mt25":"setupmodel_mt25__CimTV","mt20":"setupmodel_mt20__7AzXv","SetupPopup__ContentGridTech":"setupmodel_SetupPopup__ContentGridTech__k70MX","SetupPopup__Assesmentsection":"setupmodel_SetupPopup__Assesmentsection__l01_b","SetupPopup__AssesmentsectionNew":"setupmodel_SetupPopup__AssesmentsectionNew__b7Qzi","SetupPopup__MannualChips":"setupmodel_SetupPopup__MannualChips__OW4ED","SetupPopup__ContentGridManuaCol":"setupmodel_SetupPopup__ContentGridManuaCol___d8Su","SetupPopup__ContentGridManual":"setupmodel_SetupPopup__ContentGridManual__kUHT1","SetupPopup__ContentBlockPhone":"setupmodel_SetupPopup__ContentBlockPhone__3ymcg","SetupPopup__ContentAddInterview":"setupmodel_SetupPopup__ContentAddInterview__q_FeL","SetupPopup__ContentGridPhone":"setupmodel_SetupPopup__ContentGridPhone__jdnAZ","SetupPopup__ContentGridStatus":"setupmodel_SetupPopup__ContentGridStatus__MT3n8","SetupPopup__GridActions":"setupmodel_SetupPopup__GridActions__TxGiJ","SetupPopup__GridActionCoral":"setupmodel_SetupPopup__GridActionCoral__vtQd4","SetupPopup__GridActionIndigo":"setupmodel_SetupPopup__GridActionIndigo__kd4P_","SetupPopup__ContentGrid":"setupmodel_SetupPopup__ContentGrid__ppCDb","SetupPopup__SubmitSectionSave":"setupmodel_SetupPopup__SubmitSectionSave__Ac2Sc","SetupPopup__SubmitSectionReset":"setupmodel_SetupPopup__SubmitSectionReset__yLZV6","SetupPopup__SubmitSectionAutomation":"setupmodel_SetupPopup__SubmitSectionAutomation__JJSxK","SetupPopup__Duration":"setupmodel_SetupPopup__Duration__nLxkx","SetupPopup__DeleteIcon":"setupmodel_SetupPopup__DeleteIcon__ol3l0","SetupPopup__ContentCustomisationManualInterview":"setupmodel_SetupPopup__ContentCustomisationManualInterview__RF_tK","mt0":"setupmodel_mt0__KA4ea","mtb25":"setupmodel_mtb25__fq40T","mb15":"setupmodel_mb15__RdHjB","mb30":"setupmodel_mb30__4oCml","mt9":"setupmodel_mt9__wCzaB","lineheight0":"setupmodel_lineheight0__bAGIZ","PopupHeightSection":"setupmodel_PopupHeightSection__hVCSg","AssessPopupHeightSection":"setupmodel_AssessPopupHeightSection__OFhlR","Statusopupheight":"setupmodel_Statusopupheight__crGjr","buttonIn":"setupmodel_buttonIn__oyNtN","MessagePlaceholder":"setupmodel_MessagePlaceholder__SmUOi","m0":"setupmodel_m0__1Mz42","mt18":"setupmodel_mt18__GluKT","DPgrid":"setupmodel_DPgrid__kGkb_","addbtnposition":"setupmodel_addbtnposition__Y_hDE","mainformdiv":"setupmodel_mainformdiv__4BWPt","crossflex":"setupmodel_crossflex__C43tX","crossimgheight":"setupmodel_crossimgheight__JwsxL","crossimgheight48":"setupmodel_crossimgheight48__4cUSh","SetupModalPopup":"setupmodel_SetupModalPopup__gsk_x","SetupModalPopup__Dialog":"setupmodel_SetupModalPopup__Dialog__3H39z","SetupPopupoverlay":"setupmodel_SetupPopupoverlay__e_5cw","NeedHelp":"setupmodel_NeedHelp__u5rQD","uploadNewTest":"setupmodel_uploadNewTest__XH__S","SetupPopup__ol":"setupmodel_SetupPopup__ol__c6qxG","Threshold__Content":"setupmodel_Threshold__Content__xGI5m","SetupPopup__ContentGridPhone__Content":"setupmodel_SetupPopup__ContentGridPhone__Content___4WlW","Popupheight":"setupmodel_Popupheight__h8Vm1"};

/***/ }),

/***/ 6966:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"uploadNewTest":"tech-test_uploadNewTest__cZgSI"};

/***/ }),

/***/ 56143:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ThirdPartyLogo":"third-party-logo_ThirdPartyLogo__32nwW","ThirdPartyLogo__RectangularLogo":"third-party-logo_ThirdPartyLogo__RectangularLogo__0qqn1","ThirdPartyLogo__SquareLogo":"third-party-logo_ThirdPartyLogo__SquareLogo__ZuGEX","ThirdPartyLogo__PoweredByCandidly":"third-party-logo_ThirdPartyLogo__PoweredByCandidly__3G_JR"};

/***/ }),

/***/ 84370:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"integration_Form__aqwuD","Form__width":"integration_Form__width__2EYEl","Form__label":"integration_Form__label__IxKX6","Form__textleft":"integration_Form__textleft__NdSvh","Form__InputFullWidth":"integration_Form__InputFullWidth__tEcqY","Form__Input":"integration_Form__Input__UB9JD","Form__InputSection":"integration_Form__InputSection__DLKmv","Form__ScoreCardInput":"integration_Form__ScoreCardInput__MM0a3","Form__Textarea":"integration_Form__Textarea__wQ6TP","IntegrationPage":"integration_IntegrationPage__2RE7A","Integration__BackStep":"integration_Integration__BackStep__M7efG","Integration__SubmitSection":"integration_Integration__SubmitSection__PIo6W","IntegrationTable":"integration_IntegrationTable__FAm66","IntegrationTable__LimitInput":"integration_IntegrationTable__LimitInput__eJeHq","IntegrationTable__Type":"integration_IntegrationTable__Type___ZsM5","IntegrationTable__AllJobsToggle":"integration_IntegrationTable__AllJobsToggle__HYKaX","IntegrationTable__switch":"integration_IntegrationTable__switch__DNLnQ","IntegrationTable__switchText":"integration_IntegrationTable__switchText__URFKa","IntegrationTable__slider":"integration_IntegrationTable__slider__sa0bt","IntegrationTable__round":"integration_IntegrationTable__round___FQSA","IntegrationTable__Action":"integration_IntegrationTable__Action__qY9IW","IntegrationView":"integration_IntegrationView__Y4yMF","IntegrationView__Title":"integration_IntegrationView__Title__gzm3Z","IntegrationView__Subheading":"integration_IntegrationView__Subheading__TJtlA","IntegrationView__BoxImage":"integration_IntegrationView__BoxImage__dPk5p","IntegrationView__Box":"integration_IntegrationView__Box___Yu5m","IntegrationView__BoxImage__InfoIcon":"integration_IntegrationView__BoxImage__InfoIcon__TSuWr","IntegrationView__ViewMoreButton":"integration_IntegrationView__ViewMoreButton__RqyQ2","IntegrationView__ConnectButton":"integration_IntegrationView__ConnectButton__TERhC","IntegrationView__GoogleButton":"integration_IntegrationView__GoogleButton__nxcEI","IntegrationView__FlexFlow":"integration_IntegrationView__FlexFlow__jvjhz","IntegrationView__BoxWidth":"integration_IntegrationView__BoxWidth__k8Ze_","SkipFinishButton":"integration_SkipFinishButton__ad4Go","IntegrationView__w100":"integration_IntegrationView__w100__j9jxF"};

/***/ }),

/***/ 70525:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"DragAndDrop":"customize-career-page_DragAndDrop__4KqYe","DragAndDrop__CursorHandle":"customize-career-page_DragAndDrop__CursorHandle__IxFjp","About__RemoveSection":"customize-career-page_About__RemoveSection__sy8LN","About":"customize-career-page_About__sHSLl","Gallery":"customize-career-page_Gallery__lNaJi","Benefit":"customize-career-page_Benefit__NUel7","MeetTeam":"customize-career-page_MeetTeam__5yhv0","About__Container":"customize-career-page_About__Container__qY0Q2","Gallery__Container":"customize-career-page_Gallery__Container__i3ztf","Benefit__Container":"customize-career-page_Benefit__Container___lQ6P","MeetTeam__Container":"customize-career-page_MeetTeam__Container__tbLWN","About__Title":"customize-career-page_About__Title__xzb2Q","Gallery__Title":"customize-career-page_Gallery__Title___8V7R","Benefit__Title":"customize-career-page_Benefit__Title__LwLUm","MeetTeam__Title":"customize-career-page_MeetTeam__Title__Pr7Ok","About__FirstOption":"customize-career-page_About__FirstOption__UP0GB","Gallery__FirstOption":"customize-career-page_Gallery__FirstOption__VwR1n","Benefit__FirstOption":"customize-career-page_Benefit__FirstOption__nULXI","MeetTeam__FirstOption":"customize-career-page_MeetTeam__FirstOption__sMXJD","About__SecondOption":"customize-career-page_About__SecondOption__iL2uW","Gallery__SecondOption":"customize-career-page_Gallery__SecondOption__NMY8q","Benefit__SecondOption":"customize-career-page_Benefit__SecondOption__w10kO","MeetTeam__SecondOption":"customize-career-page_MeetTeam__SecondOption__GEuqP","About__SecondOption__Para":"customize-career-page_About__SecondOption__Para__IgZwV","Gallery__SecondOption__Para":"customize-career-page_Gallery__SecondOption__Para__y65uV","Benefit__SecondOption__Para":"customize-career-page_Benefit__SecondOption__Para__ihgQF","MeetTeam__SecondOption__Para":"customize-career-page_MeetTeam__SecondOption__Para__02DSl","About__SecondOption__SubTitle":"customize-career-page_About__SecondOption__SubTitle__e2FyP","Gallery__SecondOption__SubTitle":"customize-career-page_Gallery__SecondOption__SubTitle__KqidH","Benefit__SecondOption__SubTitle":"customize-career-page_Benefit__SecondOption__SubTitle__7PrC_","MeetTeam__SecondOption__SubTitle":"customize-career-page_MeetTeam__SecondOption__SubTitle__ebatB","About__LeftContent":"customize-career-page_About__LeftContent__jo2vv","Gallery__LeftContent":"customize-career-page_Gallery__LeftContent__RJq6_","Benefit__LeftContent":"customize-career-page_Benefit__LeftContent__7C008","MeetTeam__LeftContent":"customize-career-page_MeetTeam__LeftContent__tOTz6","About__RightContent":"customize-career-page_About__RightContent__WSZ4k","Gallery__RightContent":"customize-career-page_Gallery__RightContent__j2g8m","Benefit__RightContent":"customize-career-page_Benefit__RightContent__txG7o","MeetTeam__RightContent":"customize-career-page_MeetTeam__RightContent___uVGK","About__Content":"customize-career-page_About__Content__EZt_9","Gallery__Content":"customize-career-page_Gallery__Content__S4h5i","Benefit__Content":"customize-career-page_Benefit__Content__N64CM","MeetTeam__Content":"customize-career-page_MeetTeam__Content__s5f0Z","About__SubTitle":"customize-career-page_About__SubTitle___PYfo","Gallery__SubTitle":"customize-career-page_Gallery__SubTitle__jEjS4","Benefit__SubTitle":"customize-career-page_Benefit__SubTitle__QcetV","MeetTeam__SubTitle":"customize-career-page_MeetTeam__SubTitle__G4z1_","About__Para":"customize-career-page_About__Para__y5gPM","Gallery__Para":"customize-career-page_Gallery__Para__3H4aL","Benefit__Para":"customize-career-page_Benefit__Para__z8nzX","MeetTeam__Para":"customize-career-page_MeetTeam__Para__sZTDa","About__Image":"customize-career-page_About__Image__2r_f2","Gallery__Image":"customize-career-page_Gallery__Image__Sk156","Benefit__Image":"customize-career-page_Benefit__Image__dpAca","MeetTeam__Image":"customize-career-page_MeetTeam__Image__sdEaV","About__Image__EditIcon":"customize-career-page_About__Image__EditIcon__wlbHa","Gallery__Image__EditIcon":"customize-career-page_Gallery__Image__EditIcon__zqnjh","Benefit__Image__EditIcon":"customize-career-page_Benefit__Image__EditIcon__qZaFk","MeetTeam__Image__EditIcon":"customize-career-page_MeetTeam__Image__EditIcon__KlSAl","About__ContentEditable":"customize-career-page_About__ContentEditable__tl6fQ","Gallery__ContentEditable":"customize-career-page_Gallery__ContentEditable__yfInB","Benefit__ContentEditable":"customize-career-page_Benefit__ContentEditable__bUSRU","MeetTeam__ContentEditable":"customize-career-page_MeetTeam__ContentEditable__xrH8I","Gallery__RemoveSection":"customize-career-page_Gallery__RemoveSection__Pvqzn","Benefit__RemoveSection":"customize-career-page_Benefit__RemoveSection__degVp","MeetTeam__RemoveSection":"customize-career-page_MeetTeam__RemoveSection__mD2CH","About__ContentPreview":"customize-career-page_About__ContentPreview__tDK25","Gallery__ContentPreview":"customize-career-page_Gallery__ContentPreview__H_8ro","Benefit__ContentPreview":"customize-career-page_Benefit__ContentPreview__yI_j6","MeetTeam__ContentPreview":"customize-career-page_MeetTeam__ContentPreview__FZSPu","About__CursorHandle":"customize-career-page_About__CursorHandle__VgZsd","Gallery__CursorHandle":"customize-career-page_Gallery__CursorHandle__ieCHq","Benefit__CursorHandle":"customize-career-page_Benefit__CursorHandle__mEGim","MeetTeam__CursorHandle":"customize-career-page_MeetTeam__CursorHandle__Kppc7","About__NoBorder":"customize-career-page_About__NoBorder__gfQSE","Gallery__AddNewMember":"customize-career-page_Gallery__AddNewMember__TbbKt","Gallery__SixCardLayout":"customize-career-page_Gallery__SixCardLayout__clWce","Gallery__ThreeCardLayout":"customize-career-page_Gallery__ThreeCardLayout__yBgw_","Gallery__FourCardLayout":"customize-career-page_Gallery__FourCardLayout__WbTIO","Gallery__EditImage":"customize-career-page_Gallery__EditImage__Xb8Is","Gallery__PreviewContainer":"customize-career-page_Gallery__PreviewContainer__wwD2x","Gallery__MySwiper":"customize-career-page_Gallery__MySwiper__nXcHq","Gallery__EditView":"customize-career-page_Gallery__EditView__P4y5m","Gallery__Preview":"customize-career-page_Gallery__Preview__K6MmO","Gallery__Preview__ShowInMobile":"customize-career-page_Gallery__Preview__ShowInMobile__pwUP8","Gallery__UploadImage":"customize-career-page_Gallery__UploadImage__g7H5k","Gallery__EditImage__EditIcon":"customize-career-page_Gallery__EditImage__EditIcon__0TNQA","Gallery__EditImage__UploadIcon":"customize-career-page_Gallery__EditImage__UploadIcon__NKZ69","Gallery__EditImage__CloseEyeIcon":"customize-career-page_Gallery__EditImage__CloseEyeIcon__MYvlS","Gallery__EditImage__UploadImage":"customize-career-page_Gallery__EditImage__UploadImage__WoXk4","Benefit__PreviewContainer":"customize-career-page_Benefit__PreviewContainer__l0FIt","Benefit__AddTitleText":"customize-career-page_Benefit__AddTitleText__JuFgY","Benefit__AddDescriptionText":"customize-career-page_Benefit__AddDescriptionText__CK8PE","Benefit__SixCardLayout":"customize-career-page_Benefit__SixCardLayout__Pz9su","Benefit__ThreeCardLayout":"customize-career-page_Benefit__ThreeCardLayout__de2NL","Benefit__Card":"customize-career-page_Benefit__Card__p_FLo","Benefit__FourCardLayout":"customize-career-page_Benefit__FourCardLayout__ofXAG","Benefit__Card__Title":"customize-career-page_Benefit__Card__Title__GVy7p","Benefit__Card__Text":"customize-career-page_Benefit__Card__Text__2bgZS","Benefit__ThirdOption":"customize-career-page_Benefit__ThirdOption__zdYuM","Benefit__Cards":"customize-career-page_Benefit__Cards__D3EYY","Benefit__Card__EditIcon":"customize-career-page_Benefit__Card__EditIcon__ejWRm","Benefit__Card__Icon":"customize-career-page_Benefit__Card__Icon__9RMxf","Benefit__Card__Delete":"customize-career-page_Benefit__Card__Delete__LygxV","Benefit__Card__Hover":"customize-career-page_Benefit__Card__Hover__hTOCK","Benefit__ThirdOption__Cards":"customize-career-page_Benefit__ThirdOption__Cards__U2_iu","Benefit__ThirdOption__Card":"customize-career-page_Benefit__ThirdOption__Card__0umqa","MeetTeam__MarginBottom4":"customize-career-page_MeetTeam__MarginBottom4__WQ13r","MeetTeam__TextCenter":"customize-career-page_MeetTeam__TextCenter__2NH2z","MeetTeam__AddNameText":"customize-career-page_MeetTeam__AddNameText__w3nSB","MeetTeam__AddDesignationText":"customize-career-page_MeetTeam__AddDesignationText__s7th1","MeetTeam__AddDescriptionText":"customize-career-page_MeetTeam__AddDescriptionText__Vcl9g","MeetTeam__Cards__Display":"customize-career-page_MeetTeam__Cards__Display__Rp3Ov","MeetTeam__Cards__FirstOptionDisplay":"customize-career-page_MeetTeam__Cards__FirstOptionDisplay__yAv_q","MeetTeam__PreviewContainer":"customize-career-page_MeetTeam__PreviewContainer__Pa4_U","MeetTeam__Preview":"customize-career-page_MeetTeam__Preview__vDPJP","MeetTeam__SixCardLayout":"customize-career-page_MeetTeam__SixCardLayout__DcZ8d","MeetTeam__Card":"customize-career-page_MeetTeam__Card__OXC5C","MeetTeam__ThreeCardLayout":"customize-career-page_MeetTeam__ThreeCardLayout__L4Ps_","MeetTeam__FourCardLayout":"customize-career-page_MeetTeam__FourCardLayout__jvsny","MeetTeam__Subtitle":"customize-career-page_MeetTeam__Subtitle__2s7_S","MeetTeam__Card__Title":"customize-career-page_MeetTeam__Card__Title__PqnjL","MeetTeam__Card__Text":"customize-career-page_MeetTeam__Card__Text__MFy2T","MeetTeam__Cards":"customize-career-page_MeetTeam__Cards__WvgSz","MeetTeam__Card__Designation__NoMargin":"customize-career-page_MeetTeam__Card__Designation__NoMargin__QCN3H","MeetTeam__Card__Name":"customize-career-page_MeetTeam__Card__Name__YqH9C","MeetTeam__Card__NameCenter":"customize-career-page_MeetTeam__Card__NameCenter__3ddpf","MeetTeam__Card__Delete":"customize-career-page_MeetTeam__Card__Delete__MPbte","MeetTeam__Card__Left":"customize-career-page_MeetTeam__Card__Left__0IDo6","MeetTeam__Card__Designation":"customize-career-page_MeetTeam__Card__Designation__SjJz9","MeetTeam__Card__Designation__Center":"customize-career-page_MeetTeam__Card__Designation__Center__CDmMH","MeetTeam__Card__Right":"customize-career-page_MeetTeam__Card__Right__sadiF","MeetTeam__Card__Center":"customize-career-page_MeetTeam__Card__Center__uvUkC","MeetTeam__Card__UserDetails":"customize-career-page_MeetTeam__Card__UserDetails__p9a5s","MeetTeam__Card__Icon":"customize-career-page_MeetTeam__Card__Icon__9aHPE","MeetTeam__Card__Icon240":"customize-career-page_MeetTeam__Card__Icon240__g_7B_","MeetTeam__Card__Hover":"customize-career-page_MeetTeam__Card__Hover__wop7H","MeetTeam__SecondOption__Card":"customize-career-page_MeetTeam__SecondOption__Card__Ahlnj","MeetTeam__SecondOption__SocialIcon":"customize-career-page_MeetTeam__SecondOption__SocialIcon__MM4J_","MeetTeam__MarginAuto":"customize-career-page_MeetTeam__MarginAuto__ts65w","MeetTeam__Width100":"customize-career-page_MeetTeam__Width100__Xek9z","MeetTeam__AddNewMember":"customize-career-page_MeetTeam__AddNewMember__MQoaL","MeetTeam__AddNewMember__Icon":"customize-career-page_MeetTeam__AddNewMember__Icon__nJPIP","MeetTeam__NoMarginBottom":"customize-career-page_MeetTeam__NoMarginBottom__EYOLj","Main":"customize-career-page_Main__yjYQs","MeetTeam__Preview__ShowInMobile":"customize-career-page_MeetTeam__Preview__ShowInMobile__EbA0I","Benefit__Preview__ShowInMobile":"customize-career-page_Benefit__Preview__ShowInMobile__rqWE5","MeetTeam__MySwiper":"customize-career-page_MeetTeam__MySwiper__6T3Wr","MeetTeam__Delete":"customize-career-page_MeetTeam__Delete__FdX9w","MeetTeam__FirstOption__Card":"customize-career-page_MeetTeam__FirstOption__Card__gqNs9","MeetTeam__Card__SocialIcon":"customize-career-page_MeetTeam__Card__SocialIcon__YuhKe","About__PreviewContainer":"customize-career-page_About__PreviewContainer__KocPv","MeetTeam__Preview__DisplayNoneXS":"customize-career-page_MeetTeam__Preview__DisplayNoneXS__wJO_Z","MeetTeam__Preview__HideInMobile":"customize-career-page_MeetTeam__Preview__HideInMobile__hmhhP","Gallery__Preview__HideInMobile":"customize-career-page_Gallery__Preview__HideInMobile__qA_5B","Benefit__Preview__HideInMobile":"customize-career-page_Benefit__Preview__HideInMobile__d7RRl"};

/***/ }),

/***/ 94968:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form__CustomSelect":"new-view-job_Form__CustomSelect__9Wcbs","Form__ErrorCustomSelect":"new-view-job_Form__ErrorCustomSelect__KxTRu","Form__currency_symbol":"new-view-job_Form__currency_symbol__qqjGp","Form__select_currency":"new-view-job_Form__select_currency__i2twS","customSelect__placeholder":"new-view-job_customSelect__placeholder__JtJjq","Form":"new-view-job_Form__TkPp6","Form__width":"new-view-job_Form__width__zj8sF","Form__label":"new-view-job_Form__label__u2Ljv","Form__textleft":"new-view-job_Form__textleft__9YyGM","Form__InputFullWidth":"new-view-job_Form__InputFullWidth__AKtsO","Form__Input":"new-view-job_Form__Input__VJAPm","Form__Input398":"new-view-job_Form__Input398__pLtOq","Form__InputSection":"new-view-job_Form__InputSection__fBhxJ","Form__ScoreCardInput":"new-view-job_Form__ScoreCardInput__uycYD","Form__Textarea":"new-view-job_Form__Textarea__gTqK_","Career":"new-view-job_Career__2Qzih","Career__Background_Edit":"new-view-job_Career__Background_Edit___Tf9J","Career__Background_Edit_Image":"new-view-job_Career__Background_Edit_Image__3ZEhm","Career__Container":"new-view-job_Career__Container__f9uL4","Career__Inner":"new-view-job_Career__Inner__mc9DE","Career__logo":"new-view-job_Career__logo__4nWvK","Career__Content":"new-view-job_Career__Content__sjwmr","Career__ButtonSection":"new-view-job_Career__ButtonSection__mlyOs","Job":"new-view-job_Job__4M6Fq","Job__Inner":"new-view-job_Job__Inner__qWAgE","Job__Container":"new-view-job_Job__Container__zAnZA","Job__Heading":"new-view-job_Job__Heading__08bUK","Job__Company":"new-view-job_Job__Company___qCgC","Job__SearchContainer":"new-view-job_Job__SearchContainer__jY_aY","Job__SearchInput":"new-view-job_Job__SearchInput__Dokob","Job__Searchbtn":"new-view-job_Job__Searchbtn__OWGwA","Job__Input":"new-view-job_Job__Input__rLqoP","Job__SelectJob":"new-view-job_Job__SelectJob__lSxLk","Job__RemoteLabel":"new-view-job_Job__RemoteLabel__A8GSR","Job__Display":"new-view-job_Job__Display__D9M5s","Job__PostDay":"new-view-job_Job__PostDay__l5c_P","Job__Title":"new-view-job_Job__Title__gDBmO","Job__Location":"new-view-job_Job__Location__xQWGI","DT":"new-view-job_DT__m_9ZS","DisplayTable":"new-view-job_DisplayTable___bnNO","pd11":"new-view-job_pd11__Vpydx","Label":"new-view-job_Label___Htil","inputwidth":"new-view-job_inputwidth__iiqVN","mr24":"new-view-job_mr24__bMnr_","fullwidth":"new-view-job_fullwidth__yao6X","padt40":"new-view-job_padt40__AgvoZ","Form__TableRow":"new-view-job_Form__TableRow__6i7pL","Form__TableRowflex":"new-view-job_Form__TableRowflex__Ubicz","Form__TableColm":"new-view-job_Form__TableColm__lRZlK","Form__Label":"new-view-job_Form__Label__T4VXQ","Form__LabelCheck":"new-view-job_Form__LabelCheck__90k_j","Form__Error":"new-view-job_Form__Error__muoLo","Form__ErrorSection":"new-view-job_Form__ErrorSection__Rh9rX","Form__MessagePlaceholder":"new-view-job_Form__MessagePlaceholder__BlYxW","Form__Submit":"new-view-job_Form__Submit__5Yow0","Form__FloatingLabel":"new-view-job_Form__FloatingLabel__BMXRs","Form__NormalLabel":"new-view-job_Form__NormalLabel__8r_H1","Form__TableCol":"new-view-job_Form__TableCol__G9pZ9","Form__currency_symbol__right":"new-view-job_Form__currency_symbol__right__Yhr6_","AddInterview":"new-view-job_AddInterview__gCI9u","primarybtn":"new-view-job_primarybtn__4nsng","secondarybtn":"new-view-job_secondarybtn__r0GaM","iconFilled":"new-view-job_iconFilled__5svqa","iconFilledSolid":"new-view-job_iconFilledSolid__AHURI","primarybtnborder":"new-view-job_primarybtnborder__ZvrTV","secondarybtnborder":"new-view-job_secondarybtnborder__sE2i5","tertiarybtn":"new-view-job_tertiarybtn__F9j7g","graybtnborder":"new-view-job_graybtnborder___bx_6","jobsrchbtn":"new-view-job_jobsrchbtn__M0voy","jobsrchbtnalign":"new-view-job_jobsrchbtnalign__rabOs","nobgbutton":"new-view-job_nobgbutton__yqQB7","iconTextButton":"new-view-job_iconTextButton__YE6f3","cursornone":"new-view-job_cursornone__VCNsk","nobgbuttonprimary":"new-view-job_nobgbuttonprimary__XVJ7R","mt15":"new-view-job_mt15__kN_EL","btn350":"new-view-job_btn350__dIVJJ","GrayBgBtn":"new-view-job_GrayBgBtn__9tj42","NewShareBtn":"new-view-job_NewShareBtn__BOMD9","CoralBgBtn":"new-view-job_CoralBgBtn__uY5KL","DropContainer":"new-view-job_DropContainer__kN9Qb","DropContainer__Inner":"new-view-job_DropContainer__Inner__7N8eV","CompanyProfile__Inner":"new-view-job_CompanyProfile__Inner__PESXy","DropContainer__Message":"new-view-job_DropContainer__Message__Xdsq2","CompanyProfile__Message":"new-view-job_CompanyProfile__Message__XZ0Ku","CompanyProfile__MessageContent":"new-view-job_CompanyProfile__MessageContent__Uy8yt","DropContainer__UploadIcon":"new-view-job_DropContainer__UploadIcon__pNyGv","CompanyProfile__UploadIcon":"new-view-job_CompanyProfile__UploadIcon__d_Ni0","FileDisplayContainer":"new-view-job_FileDisplayContainer__ZBcnE","FileDisplayContainer__Status":"new-view-job_FileDisplayContainer__Status__Oy08D","FileDisplayContainer__Type":"new-view-job_FileDisplayContainer__Type__py2e2","FileDisplayContainer__Name":"new-view-job_FileDisplayContainer__Name__SxSMM","FileDisplayContainer__Error":"new-view-job_FileDisplayContainer__Error__NRG3j","FileDisplayContainer__Close":"new-view-job_FileDisplayContainer__Close__AOQm8","Browse":"new-view-job_Browse__6FXL2","ClientCompany":"new-view-job_ClientCompany__KYp4t","ClientCompany__TopSection2":"new-view-job_ClientCompany__TopSection2__c16e2","ClientCompany__Filter":"new-view-job_ClientCompany__Filter__QC_ry","ClientCompany__Input_MatchScore":"new-view-job_ClientCompany__Input_MatchScore__ZWJX6","ClientCompany__Percentage_Symbol":"new-view-job_ClientCompany__Percentage_Symbol__lWenE","ClientCompany__Filterheading":"new-view-job_ClientCompany__Filterheading__fFRx_","ClientCompany__FloatButtonAdd":"new-view-job_ClientCompany__FloatButtonAdd__xYm9t","ClientCompany__FloatButtonAdd__AgencyUserIcon":"new-view-job_ClientCompany__FloatButtonAdd__AgencyUserIcon__J6jQw","ClientCompany__LastEdited":"new-view-job_ClientCompany__LastEdited__TytuL","ClientCompany__BackSection":"new-view-job_ClientCompany__BackSection__u8SiT","ClientCompany__BackSection__CloseIcon":"new-view-job_ClientCompany__BackSection__CloseIcon__sOOTg","ClientCompany__Container":"new-view-job_ClientCompany__Container__Ypnw9","ClientCompany__FormInputSection":"new-view-job_ClientCompany__FormInputSection__E4JkK","CompanyProfile__FormInputSection":"new-view-job_CompanyProfile__FormInputSection__3MW_G","ClientCompany__Heading":"new-view-job_ClientCompany__Heading__hD_iD","ClientCompany__StatusAlignment":"new-view-job_ClientCompany__StatusAlignment__adati","ClientCompany__Status":"new-view-job_ClientCompany__Status__32xeu","ClientCompany__ActiveDot":"new-view-job_ClientCompany__ActiveDot__C3yMx","ClientCompany__CloseDot":"new-view-job_ClientCompany__CloseDot__XnAQQ","ClientCompany__Company":"new-view-job_ClientCompany__Company__3prZh","ClientCompany__Systemrefheding":"new-view-job_ClientCompany__Systemrefheding___8nRs","ClientCompany__Subheading":"new-view-job_ClientCompany__Subheading__1qxri","CompanyProfile__Subheading":"new-view-job_CompanyProfile__Subheading__z16cM","ClientCompany__Subheading2":"new-view-job_ClientCompany__Subheading2__rkC6F","ClientCompany__Description":"new-view-job_ClientCompany__Description__WFJ6e","ClientCompany__SubmitSection":"new-view-job_ClientCompany__SubmitSection__pEYEI","ClientCompany__IntegrationImage":"new-view-job_ClientCompany__IntegrationImage__zzZhy","ClientCompany__QuickAdd":"new-view-job_ClientCompany__QuickAdd__QsaKB","ClientCompany__BodyText":"new-view-job_ClientCompany__BodyText__9x3ly","Form__TableCol__Disabled":"new-view-job_Form__TableCol__Disabled__OAHGw","Form__TextareaDisabled":"new-view-job_Form__TextareaDisabled__Z_1VL","Form__EditorDisabled":"new-view-job_Form__EditorDisabled__ijpst","Form__AdminCheckLabel":"new-view-job_Form__AdminCheckLabel__d_2K0","Form__AdminCheckMargin":"new-view-job_Form__AdminCheckMargin__pmHSw","CompanyProfile__BrandingGuide":"new-view-job_CompanyProfile__BrandingGuide__SVz36","CompanyProfile__DropBoxContainer":"new-view-job_CompanyProfile__DropBoxContainer__CQz8X","CompanyProfile__Browse":"new-view-job_CompanyProfile__Browse__kCDQD","ErrorLabel":"new-view-job_ErrorLabel__29CaZ","Height80":"new-view-job_Height80__e1C4Z","Browse__ButtonFlexEnd":"new-view-job_Browse__ButtonFlexEnd__Pu5tu","AddAgency__Container":"new-view-job_AddAgency__Container__NMbhe","AddAgency__FormInputSection":"new-view-job_AddAgency__FormInputSection__KzK61","AddAgency__FormInputSection__Label":"new-view-job_AddAgency__FormInputSection__Label__qqCAK","AddAgency__Form":"new-view-job_AddAgency__Form__CrrtZ","LinkAsButtons":"new-view-job_LinkAsButtons__oIMGx","SearchFlex":"new-view-job_SearchFlex__RH6hh","Modalpopup":"new-view-job_Modalpopup__Q_z2W","Modalpopup__inner":"new-view-job_Modalpopup__inner__3hdl4","Modalpopup__Dialog":"new-view-job_Modalpopup__Dialog__gYq1_","transition":"new-view-job_transition__Rcvpk","Modalpopup__CloseCenter":"new-view-job_Modalpopup__CloseCenter__R9YGt","Modalpopup__Content":"new-view-job_Modalpopup__Content__A1LBG","Modalpopup__btn":"new-view-job_Modalpopup__btn__e9LoV","mar":"new-view-job_mar__5c1Lx","Otpback":"new-view-job_Otpback___c8Om","ViewJob":"new-view-job_ViewJob__wQ654","ViewJob__Header":"new-view-job_ViewJob__Header__90FWh","ViewJob__SubHeader":"new-view-job_ViewJob__SubHeader__YWGdN","ViewJob__SubHeader__Text":"new-view-job_ViewJob__SubHeader__Text__18G8l","ViewJob__InnerContent":"new-view-job_ViewJob__InnerContent__n4SY2","ViewJob__LeftContent":"new-view-job_ViewJob__LeftContent__X_v7h","ViewJob__RightContent":"new-view-job_ViewJob__RightContent__jy_Vh","ViewJob__BlueBox":"new-view-job_ViewJob__BlueBox__8_3pH","ViewJob__BlueBox__Icon":"new-view-job_ViewJob__BlueBox__Icon__XSnfz","ViewJob__BlueBox__ShareJob":"new-view-job_ViewJob__BlueBox__ShareJob__EcXIO","ViewJob__BlueBox__HideInDesktop":"new-view-job_ViewJob__BlueBox__HideInDesktop__usRvY","ViewJob__SocialIcons":"new-view-job_ViewJob__SocialIcons___KMs3","ViewJob__SocialIcon":"new-view-job_ViewJob__SocialIcon__UW_us","ViewJob__SocialDisabled":"new-view-job_ViewJob__SocialDisabled__6Zcg9","ViewJob__MainHeading":"new-view-job_ViewJob__MainHeading__lLns8","ViewJob__MainText":"new-view-job_ViewJob__MainText__uSA6k","ViewJob__ApplyButton":"new-view-job_ViewJob__ApplyButton__7RdSf","ViewJob__UploadCV":"new-view-job_ViewJob__UploadCV__hcszj","ViewJob__UploadCV__LeftContent":"new-view-job_ViewJob__UploadCV__LeftContent__XyagA","ViewJob__UploadCV__RightContent":"new-view-job_ViewJob__UploadCV__RightContent__jP03q","ViewJob__UploadCV__Img":"new-view-job_ViewJob__UploadCV__Img__WeuO1","ViewJob__UploadCV__Text":"new-view-job_ViewJob__UploadCV__Text__SJxFc","ViewJob__UploadCV__UploadButton":"new-view-job_ViewJob__UploadCV__UploadButton__erbik","ViewJob__TextUppercase":"new-view-job_ViewJob__TextUppercase__16Utr","ViewJob__Description":"new-view-job_ViewJob__Description__NPVFv","ViewJob__TextLowercase":"new-view-job_ViewJob__TextLowercase__S4QFm","ViewJob__FooterView":"new-view-job_ViewJob__FooterView__SUIog","ApplyForm":"new-view-job_ApplyForm__oQ2N2","ApplyForm__Heading":"new-view-job_ApplyForm__Heading__cSFFc","ApplyForm__MainForm":"new-view-job_ApplyForm__MainForm__Kg2cO","ApplyForm__Field":"new-view-job_ApplyForm__Field__EsxPu","ApplyForm__Field__Label":"new-view-job_ApplyForm__Field__Label__3fdWW","ApplyForm__Mandatory":"new-view-job_ApplyForm__Mandatory__vRFKI","ApplyForm__MarginLeft65":"new-view-job_ApplyForm__MarginLeft65__EVLZR","ApplyForm__Field100":"new-view-job_ApplyForm__Field100__9h5dg","ApplyForm__UploadCV":"new-view-job_ApplyForm__UploadCV__ueCpq","ApplyForm__UploadButton":"new-view-job_ApplyForm__UploadButton__BIrsP","ApplyForm__DragandDropFile":"new-view-job_ApplyForm__DragandDropFile__cqE6C","ApplyForm__Agreement":"new-view-job_ApplyForm__Agreement__sbzES","ApplyForm__Agreement__LeftContent":"new-view-job_ApplyForm__Agreement__LeftContent___AqBX","ApplyForm__Agreement__RightContent":"new-view-job_ApplyForm__Agreement__RightContent__UsE6Z","ApplyForm__PrivacyPolicy":"new-view-job_ApplyForm__PrivacyPolicy__g4cwd","ApplyForm__SubmitButton":"new-view-job_ApplyForm__SubmitButton__CtnYr","ApplyForm__DropBoxError":"new-view-job_ApplyForm__DropBoxError__T5vuy","ApplyJob__Header":"new-view-job_ApplyJob__Header__ezDYO","PreviewJobPage":"new-view-job_PreviewJobPage__lPTgy","Form__CheckLabel":"new-view-job_Form__CheckLabel__5M4uW","Congrats__ModalContent":"new-view-job_Congrats__ModalContent__fzMMn","ViewJob__Text":"new-view-job_ViewJob__Text__Eqdf1","ViewJob__InnerContentPaddingMobile":"new-view-job_ViewJob__InnerContentPaddingMobile__bXMyF","ViewJob__BlueBox__HideInMobile":"new-view-job_ViewJob__BlueBox__HideInMobile__Ytfoc","ViewJob__BlueBox__ShowInMobile":"new-view-job_ViewJob__BlueBox__ShowInMobile__zPrgT","ViewJob__NewShareBtn":"new-view-job_ViewJob__NewShareBtn__jf5AB","ApplyForm__UploadCV__LeftContent":"new-view-job_ApplyForm__UploadCV__LeftContent__hEOSp","ViewJobPage__Content":"new-view-job_ViewJobPage__Content__KwUyD"};

/***/ }),

/***/ 25436:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form__CustomSelect":"view-job_Form__CustomSelect__AX2lN","Form__ErrorCustomSelect":"view-job_Form__ErrorCustomSelect__AAqiu","Form__currency_symbol":"view-job_Form__currency_symbol__qIcwX","Form__select_currency":"view-job_Form__select_currency__QKLeC","customSelect__placeholder":"view-job_customSelect__placeholder__WCNQe","Form":"view-job_Form__0Ooux","Form__width":"view-job_Form__width__Ad5_o","Form__label":"view-job_Form__label__Qi7p8","Form__textleft":"view-job_Form__textleft__WGc4O","Form__InputFullWidth":"view-job_Form__InputFullWidth__ZlmW6","Form__Input":"view-job_Form__Input__o8der","ViewJobPage__Input":"view-job_ViewJobPage__Input__Da6Qb","Form__Input2":"view-job_Form__Input2__6r1cl","Form__Input398":"view-job_Form__Input398__5ZEcG","Form__InputSection":"view-job_Form__InputSection__pG7NB","Form__ScoreCardInput":"view-job_Form__ScoreCardInput__ROK4D","Form__Textarea":"view-job_Form__Textarea__1yMKx","Career":"view-job_Career__gXhxO","Career__Background_Edit":"view-job_Career__Background_Edit__DLGtZ","Career__Background_Edit_Image":"view-job_Career__Background_Edit_Image__ii_f6","Career__Container":"view-job_Career__Container__VJte9","Career__Inner":"view-job_Career__Inner__h7HdM","Career__logo":"view-job_Career__logo__ZGQKF","Career__Content":"view-job_Career__Content__yhDpN","Career__ButtonSection":"view-job_Career__ButtonSection__U2GFg","Job":"view-job_Job__OWCSa","Job__Inner":"view-job_Job__Inner__x9j6h","Job__Container":"view-job_Job__Container__I8W3_","Job__Heading":"view-job_Job__Heading__JvRyX","Job__Company":"view-job_Job__Company__E7r9U","Job__SearchContainer":"view-job_Job__SearchContainer__rqXwG","Job__SearchInput":"view-job_Job__SearchInput__15Z7H","Job__Searchbtn":"view-job_Job__Searchbtn__miz2v","Job__Input":"view-job_Job__Input__2F0y7","Job__SelectJob":"view-job_Job__SelectJob__sS2L0","Job__RemoteLabel":"view-job_Job__RemoteLabel__aDbml","Job__Display":"view-job_Job__Display__uHAC_","Job__PostDay":"view-job_Job__PostDay__07g_P","ViewJobPage__PostDay":"view-job_ViewJobPage__PostDay__2Yps9","Job__Title":"view-job_Job__Title__Bd2QU","ViewJobPage__Title":"view-job_ViewJobPage__Title__LqtJD","ViewJobPage__DescriptionTitle":"view-job_ViewJobPage__DescriptionTitle__UUD3Y","Job__Location":"view-job_Job__Location__L_IRp","ViewJobPage__Location":"view-job_ViewJobPage__Location__3g9rB","DT":"view-job_DT__ACUP5","DisplayTable":"view-job_DisplayTable__H00cK","pd11":"view-job_pd11__d51Mr","Label":"view-job_Label___R8cO","inputwidth":"view-job_inputwidth__4dmCg","mr24":"view-job_mr24__qXsJA","fullwidth":"view-job_fullwidth__t2_VD","padt40":"view-job_padt40__OnBYA","Form__TableRow":"view-job_Form__TableRow__hXqvq","Form__TableRowflex":"view-job_Form__TableRowflex__ppdRi","Form__TableColm":"view-job_Form__TableColm__18AYW","Form__Label":"view-job_Form__Label__l1oid","primarybtn":"view-job_primarybtn__1rr31","ViewJobPage__primarybtn":"view-job_ViewJobPage__primarybtn__n_aYv","secondarybtn":"view-job_secondarybtn__wljrf","ViewJobPage__secondarybtn":"view-job_ViewJobPage__secondarybtn___PiKf","iconFilled":"view-job_iconFilled__I84cP","iconFilledSolid":"view-job_iconFilledSolid__4UHSA","primarybtnborder":"view-job_primarybtnborder__zMXFB","secondarybtnborder":"view-job_secondarybtnborder__3n8h8","ViewJobPage__secondarybtnborder":"view-job_ViewJobPage__secondarybtnborder__6CQf8","tertiarybtn":"view-job_tertiarybtn__jMGB8","graybtnborder":"view-job_graybtnborder__9yMVJ","jobsrchbtn":"view-job_jobsrchbtn__2yoJI","jobsrchbtnalign":"view-job_jobsrchbtnalign____vsX","nobgbutton":"view-job_nobgbutton__h55Sv","iconTextButton":"view-job_iconTextButton__nOkRR","cursornone":"view-job_cursornone__uQA16","nobgbuttonprimary":"view-job_nobgbuttonprimary__Y74xA","mt15":"view-job_mt15__DSEqh","btn350":"view-job_btn350__keTK1","GrayBgBtn":"view-job_GrayBgBtn__QhPcp","NewShareBtn":"view-job_NewShareBtn__C7U7r","CoralBgBtn":"view-job_CoralBgBtn__nbwWu","DropContainer":"view-job_DropContainer__ryN7P","DropContainer__Inner":"view-job_DropContainer__Inner__MKpm_","CompanyProfile__Inner":"view-job_CompanyProfile__Inner___UtdI","DropContainer__Message":"view-job_DropContainer__Message__JA4Bx","CompanyProfile__Message":"view-job_CompanyProfile__Message__Mp3tK","CompanyProfile__MessageContent":"view-job_CompanyProfile__MessageContent__WXzqa","DropContainer__UploadIcon":"view-job_DropContainer__UploadIcon__LVZmf","CompanyProfile__UploadIcon":"view-job_CompanyProfile__UploadIcon__qtY19","FileDisplayContainer":"view-job_FileDisplayContainer__neUD2","FileDisplayContainer__Status":"view-job_FileDisplayContainer__Status__JUl_1","FileDisplayContainer__Type":"view-job_FileDisplayContainer__Type__Sx5XL","FileDisplayContainer__Name":"view-job_FileDisplayContainer__Name__uZX7O","FileDisplayContainer__Error":"view-job_FileDisplayContainer__Error___YLjR","FileDisplayContainer__Close":"view-job_FileDisplayContainer__Close__OJnCV","Browse":"view-job_Browse__3mVPB","ClientCompany":"view-job_ClientCompany__GV_hH","ClientCompany__TopSection2":"view-job_ClientCompany__TopSection2___Z_M_","ClientCompany__Filter":"view-job_ClientCompany__Filter__DIirR","ClientCompany__Input_MatchScore":"view-job_ClientCompany__Input_MatchScore__Xxlky","ClientCompany__Percentage_Symbol":"view-job_ClientCompany__Percentage_Symbol__m2Fr7","ClientCompany__Filterheading":"view-job_ClientCompany__Filterheading__KZSda","ClientCompany__FloatButtonAdd":"view-job_ClientCompany__FloatButtonAdd__J8vT2","ClientCompany__FloatButtonAdd__AgencyUserIcon":"view-job_ClientCompany__FloatButtonAdd__AgencyUserIcon__jTOXx","ClientCompany__LastEdited":"view-job_ClientCompany__LastEdited__20LNE","ClientCompany__BackSection":"view-job_ClientCompany__BackSection__I8NN0","ViewJobPage__BackSection":"view-job_ViewJobPage__BackSection__3_UzA","ClientCompany__BackSection__CloseIcon":"view-job_ClientCompany__BackSection__CloseIcon__vU9q_","ClientCompany__Container":"view-job_ClientCompany__Container__4LKHV","ClientCompany__FormInputSection":"view-job_ClientCompany__FormInputSection__E_NVN","CompanyProfile__FormInputSection":"view-job_CompanyProfile__FormInputSection__nDrvK","ClientCompany__Heading":"view-job_ClientCompany__Heading__8Aq1T","ClientCompany__StatusAlignment":"view-job_ClientCompany__StatusAlignment__YuAG7","ClientCompany__Status":"view-job_ClientCompany__Status__D3Cvu","ClientCompany__ActiveDot":"view-job_ClientCompany__ActiveDot__SlZgG","ClientCompany__CloseDot":"view-job_ClientCompany__CloseDot__yr54u","ClientCompany__Company":"view-job_ClientCompany__Company__RFlv4","ClientCompany__Systemrefheding":"view-job_ClientCompany__Systemrefheding__DaDsb","ClientCompany__Subheading":"view-job_ClientCompany__Subheading__0W87d","CompanyProfile__Subheading":"view-job_CompanyProfile__Subheading__h35a2","ClientCompany__Subheading2":"view-job_ClientCompany__Subheading2__9Vefn","ClientCompany__Description":"view-job_ClientCompany__Description__2Bstq","ClientCompany__SubmitSection":"view-job_ClientCompany__SubmitSection__X_VYO","ClientCompany__IntegrationImage":"view-job_ClientCompany__IntegrationImage__u7WCq","ClientCompany__QuickAdd":"view-job_ClientCompany__QuickAdd__3CSJl","ClientCompany__BodyText":"view-job_ClientCompany__BodyText__Ywdqr","Form__FloatingLabel":"view-job_Form__FloatingLabel__51mBz","Form__TableCol":"view-job_Form__TableCol__IwlPh","Form__currency_symbol__right":"view-job_Form__currency_symbol__right__4FVFI","Form__TableCol__Disabled":"view-job_Form__TableCol__Disabled__uZcSs","Form__TextareaDisabled":"view-job_Form__TextareaDisabled__5CZ_x","Form__EditorDisabled":"view-job_Form__EditorDisabled__rSxCu","Form__AdminCheckLabel":"view-job_Form__AdminCheckLabel__y3mmp","Form__AdminCheckMargin":"view-job_Form__AdminCheckMargin__N5zvl","CompanyProfile__BrandingGuide":"view-job_CompanyProfile__BrandingGuide__xNYxY","CompanyProfile__DropBoxContainer":"view-job_CompanyProfile__DropBoxContainer__jlmqv","CompanyProfile__Browse":"view-job_CompanyProfile__Browse__RD3u9","ErrorLabel":"view-job_ErrorLabel__jtzIv","Height80":"view-job_Height80__Fub25","Browse__ButtonFlexEnd":"view-job_Browse__ButtonFlexEnd__CEGap","AddAgency__Container":"view-job_AddAgency__Container__IA2on","AddAgency__FormInputSection":"view-job_AddAgency__FormInputSection__ASVJ_","AddAgency__FormInputSection__Label":"view-job_AddAgency__FormInputSection__Label__r3Tdj","AddAgency__Form":"view-job_AddAgency__Form__zRdTd","LinkAsButtons":"view-job_LinkAsButtons__0R42U","SearchFlex":"view-job_SearchFlex__v7lLX","Modalpopup":"view-job_Modalpopup___qNaw","Modalpopup__inner":"view-job_Modalpopup__inner__eiww1","Modalpopup__Dialog":"view-job_Modalpopup__Dialog__GXSRO","transition":"view-job_transition__jgLKF","Modalpopup__CloseCenter":"view-job_Modalpopup__CloseCenter__UJfGg","Modalpopup__Content":"view-job_Modalpopup__Content__yV1hM","ViewJobPage__Content":"view-job_ViewJobPage__Content__s8lyl","Modalpopup__btn":"view-job_Modalpopup__btn__Q7EpR","mar":"view-job_mar__3g4SL","Otpback":"view-job_Otpback__6FabM","ViewJobPage":"view-job_ViewJobPage__Af5a1","ViewJobPage__Header":"view-job_ViewJobPage__Header__KRQO_","ViewJobPage__Application":"view-job_ViewJobPage__Application__WAg0P","ViewJobPage__RecordVideo":"view-job_ViewJobPage__RecordVideo__DpYu4","ViewJobPage__RecordVideoSuccessText":"view-job_ViewJobPage__RecordVideoSuccessText__l1is2","ViewJobPage__subheading":"view-job_ViewJobPage__subheading__O7Hak","ViewJobPage__confirmation":"view-job_ViewJobPage__confirmation__swO6V","ViewJobPage__Logo":"view-job_ViewJobPage__Logo__LJdkn","ViewJobPage__BrandLogo":"view-job_ViewJobPage__BrandLogo__ZWc4e","ViewJobPage__BrandLogo__Padding10":"view-job_ViewJobPage__BrandLogo__Padding10__J578A","ViewJobPage__Container":"view-job_ViewJobPage__Container__gY0LV","ViewJobPage__JobContent":"view-job_ViewJobPage__JobContent__GSo9F","ViewJobPage__Sidebar":"view-job_ViewJobPage__Sidebar__EXWE1","ViewJobPage__Sidebar2":"view-job_ViewJobPage__Sidebar2___LChe","ViewJobPage__Description":"view-job_ViewJobPage__Description__BYP_t","ViewJobPage__DescriptionWidth":"view-job_ViewJobPage__DescriptionWidth__WVRWK","ViewJobPage__Footer":"view-job_ViewJobPage__Footer__f6uVX","ViewJobPage__FooterView":"view-job_ViewJobPage__FooterView__SUJqt","ViewJobPage__ShareJob":"view-job_ViewJobPage__ShareJob__Npjfn","ViewJobPage__SubmitSection":"view-job_ViewJobPage__SubmitSection__m4JDw","ViewJobPage__SocialMedia":"view-job_ViewJobPage__SocialMedia__kLyQO","ViewJobPage__SideContent":"view-job_ViewJobPage__SideContent__N63Yp","ViewJobPage__ApplySection":"view-job_ViewJobPage__ApplySection__07JpI","FormBox__Autofill":"view-job_FormBox__Autofill__Nj7kV","applybuttons":"view-job_applybuttons__s047H","height90":"view-job_height90__PvpXg","Form__Cont":"view-job_Form__Cont__J5wyP","Form__DropBox":"view-job_Form__DropBox__hQhLy","Form__DropBoxcontainer":"view-job_Form__DropBoxcontainer__WaGE4","Form__DropBoxError":"view-job_Form__DropBoxError__kogul","Form__DropBoxicon":"view-job_Form__DropBoxicon__cFAfE","Form__DropBoxmessage":"view-job_Form__DropBoxmessage__5cFCf","noDpGrid":"view-job_noDpGrid__x1S1P","Terms":"view-job_Terms__DgZLd","TermsCondition":"view-job_TermsCondition__CElRo","TermsCondition__alignterms":"view-job_TermsCondition__alignterms__sKt_1","MenuContainer":"view-job_MenuContainer__ohqC9","MenuContainer__Menu":"view-job_MenuContainer__Menu__B_Wnv","AgencyDetailPage":"view-job_AgencyDetailPage__IogZP","Congrats__ModalContent":"view-job_Congrats__ModalContent__jjcqK"};

/***/ }),

/***/ 68685:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"automation_Form__LeObL","Form__width":"automation_Form__width__1iZiK","Form__label":"automation_Form__label__Lt2Fv","Form__textleft":"automation_Form__textleft__gLZY7","Form__InputFullWidth":"automation_Form__InputFullWidth__M2Nbs","Form__Input":"automation_Form__Input__WGz9r","Form__Input398":"automation_Form__Input398__MNH6F","Form__InputSection":"automation_Form__InputSection__TN7VN","Form__ScoreCardInput":"automation_Form__ScoreCardInput__U0ZeC","Form__Textarea":"automation_Form__Textarea__jIEbw","primarybtn":"automation_primarybtn__4xdSa","GoBtn":"automation_GoBtn__ltIEK","secondarybtn":"automation_secondarybtn__mOXF_","iconFilled":"automation_iconFilled__2m6k1","iconFilledSolid":"automation_iconFilledSolid__QtsaK","primarybtnborder":"automation_primarybtnborder__u0lY2","secondarybtnborder":"automation_secondarybtnborder__KBK3t","ClearBtn":"automation_ClearBtn__AU3mu","tertiarybtn":"automation_tertiarybtn__RTAaf","graybtnborder":"automation_graybtnborder__PgF8K","jobsrchbtn":"automation_jobsrchbtn__D_ugR","jobsrchbtnalign":"automation_jobsrchbtnalign__4NU8D","nobgbutton":"automation_nobgbutton__eQGsL","iconTextButton":"automation_iconTextButton__jlXgA","cursornone":"automation_cursornone__Qpmft","nobgbuttonprimary":"automation_nobgbuttonprimary__kkPb3","mt15":"automation_mt15__twoIV","btn350":"automation_btn350__s15S2","GrayBgBtn":"automation_GrayBgBtn__Loe2x","NewShareBtn":"automation_NewShareBtn__y7W6I","CoralBgBtn":"automation_CoralBgBtn__3W_sA","DropContainer":"automation_DropContainer__Eae2O","DropContainer__Inner":"automation_DropContainer__Inner__yPOEg","CompanyProfile__Inner":"automation_CompanyProfile__Inner__uusXs","DropContainer__Message":"automation_DropContainer__Message__eDFad","CompanyProfile__Message":"automation_CompanyProfile__Message__JTXlz","CompanyProfile__MessageContent":"automation_CompanyProfile__MessageContent__5eSr8","DropContainer__UploadIcon":"automation_DropContainer__UploadIcon__NwJQr","CompanyProfile__UploadIcon":"automation_CompanyProfile__UploadIcon__J158O","FileDisplayContainer":"automation_FileDisplayContainer__6Q_qP","FileDisplayContainer__Status":"automation_FileDisplayContainer__Status__Mhhah","SetupPopup__Status":"automation_SetupPopup__Status__tLNPh","SetupPopup__To":"automation_SetupPopup__To__RPhWF","FileDisplayContainer__Type":"automation_FileDisplayContainer__Type__prNJQ","FileDisplayContainer__Name":"automation_FileDisplayContainer__Name__w0QLy","SetupPopup__Name":"automation_SetupPopup__Name__NeEGd","SetupPopup__ToName":"automation_SetupPopup__ToName__9SWU8","FileDisplayContainer__Error":"automation_FileDisplayContainer__Error__zavpz","FileDisplayContainer__Close":"automation_FileDisplayContainer__Close__ZZSQI","Browse":"automation_Browse__Uu3Ke","ClientCompany":"automation_ClientCompany__AnQGm","NewJob":"automation_NewJob__aIJp_","Automation":"automation_Automation__NlBG9","Interview":"automation_Interview__68j_1","ClientCompany__TopSection2":"automation_ClientCompany__TopSection2__66HU_","ClientCompany__Filter":"automation_ClientCompany__Filter__nQ99E","ClientCompany__Input_MatchScore":"automation_ClientCompany__Input_MatchScore__UiZNu","ClientCompany__Percentage_Symbol":"automation_ClientCompany__Percentage_Symbol__BFuFT","ClientCompany__Filterheading":"automation_ClientCompany__Filterheading__RZPKi","ClientCompany__FloatButtonAdd":"automation_ClientCompany__FloatButtonAdd__zycLc","ClientCompany__FloatButtonAdd__AgencyUserIcon":"automation_ClientCompany__FloatButtonAdd__AgencyUserIcon__8lHpU","ClientCompany__LastEdited":"automation_ClientCompany__LastEdited__il0RT","ClientCompany__BackSection":"automation_ClientCompany__BackSection__9HXlJ","AddUsers__BackSection":"automation_AddUsers__BackSection__55olC","ClientCompany__BackSection__CloseIcon":"automation_ClientCompany__BackSection__CloseIcon__btJqs","ClientCompany__Container":"automation_ClientCompany__Container__gOjFk","NewJob__InterviewContainer":"automation_NewJob__InterviewContainer__EylkF","AddUsers__Container":"automation_AddUsers__Container__CWBFQ","ClientCompany__FormInputSection":"automation_ClientCompany__FormInputSection__BZi_k","CompanyProfile__FormInputSection":"automation_CompanyProfile__FormInputSection__SG_n0","ClientCompany__Heading":"automation_ClientCompany__Heading__ryfx6","AddUsers__Heading":"automation_AddUsers__Heading__Q1m7r","ClientCompany__StatusAlignment":"automation_ClientCompany__StatusAlignment__tgEpK","ClientCompany__Status":"automation_ClientCompany__Status___q2Gn","ClientCompany__ActiveDot":"automation_ClientCompany__ActiveDot__P7U_I","ClientCompany__CloseDot":"automation_ClientCompany__CloseDot__V6hE5","ClientCompany__Company":"automation_ClientCompany__Company__yLxCA","AddUsers__User":"automation_AddUsers__User__TTDhy","ClientCompany__Systemrefheding":"automation_ClientCompany__Systemrefheding__ZGVzI","ClientCompany__Subheading":"automation_ClientCompany__Subheading__GCgrZ","Automation__Subheading":"automation_Automation__Subheading__gMYcp","CompanyProfile__Subheading":"automation_CompanyProfile__Subheading__sWoa3","ClientCompany__Subheading2":"automation_ClientCompany__Subheading2__LckX_","ClientCompany__Description":"automation_ClientCompany__Description__gZbrH","ClientCompany__SubmitSection":"automation_ClientCompany__SubmitSection__MtTMa","NewJob__SubmitSection":"automation_NewJob__SubmitSection__ZC7Gb","NewJob__SubmitSectionThreeBtn":"automation_NewJob__SubmitSectionThreeBtn__XFDWq","NewJob__SubmitSectionOneBtnPlacement":"automation_NewJob__SubmitSectionOneBtnPlacement__gi93u","NewJob__ImportSection":"automation_NewJob__ImportSection__S5UpZ","SetupPopup__SubmitSection2":"automation_SetupPopup__SubmitSection2__lvvsU","SetupPopup__SubmitSection":"automation_SetupPopup__SubmitSection__TA6Rh","SetupPopup__SubmitSection3":"automation_SetupPopup__SubmitSection3__l6hzn","AddUsers__SubmitSection":"automation_AddUsers__SubmitSection__6e2f0","ClientCompany__IntegrationImage":"automation_ClientCompany__IntegrationImage__01ks8","ClientCompany__QuickAdd":"automation_ClientCompany__QuickAdd__XyILc","NewJob__QuickAdd":"automation_NewJob__QuickAdd__Re0qA","Interview__QuickAdd":"automation_Interview__QuickAdd__MJFvU","ClientCompany__BodyText":"automation_ClientCompany__BodyText__u3u6i","Form__TableRow":"automation_Form__TableRow__wP27J","Form__Label":"automation_Form__Label__uH0jf","Form__FloatingLabel":"automation_Form__FloatingLabel__D9OAC","Form__TableCol":"automation_Form__TableCol__oXdo3","Form__currency_symbol":"automation_Form__currency_symbol__6cSnT","Form__CustomSelect":"automation_Form__CustomSelect__nlD_u","Form__currency_symbol__right":"automation_Form__currency_symbol__right__nl6Ik","Form__TableCol__Disabled":"automation_Form__TableCol__Disabled___8cJo","Form__TextareaDisabled":"automation_Form__TextareaDisabled__QUlZM","Form__EditorDisabled":"automation_Form__EditorDisabled__un9Cw","Form__AdminCheckLabel":"automation_Form__AdminCheckLabel__LK7ut","Form__AdminCheckMargin":"automation_Form__AdminCheckMargin__wOoYl","CompanyProfile__BrandingGuide":"automation_CompanyProfile__BrandingGuide__quu7U","CompanyProfile__DropBoxContainer":"automation_CompanyProfile__DropBoxContainer__VaDk0","CompanyProfile__Browse":"automation_CompanyProfile__Browse__WrB77","ErrorLabel":"automation_ErrorLabel__Buas_","Height80":"automation_Height80__iN7fO","Browse__ButtonFlexEnd":"automation_Browse__ButtonFlexEnd__kjyDb","AddAgency__Container":"automation_AddAgency__Container__F826Z","AddAgency__FormInputSection":"automation_AddAgency__FormInputSection__5vPHU","AddAgency__FormInputSection__Label":"automation_AddAgency__FormInputSection__Label__UCes4","AddAgency__Form":"automation_AddAgency__Form__KVNC6","LinkAsButtons":"automation_LinkAsButtons__iu4QV","SearchFlex":"automation_SearchFlex__yxtou","Form__ErrorCustomSelect":"automation_Form__ErrorCustomSelect__Kl09V","Form__select_currency":"automation_Form__select_currency__qrltG","customSelect__placeholder":"automation_customSelect__placeholder__hAeMh","Career":"automation_Career__2kEgr","Career__Background_Edit":"automation_Career__Background_Edit__E6wmg","Career__Background_Edit_Image":"automation_Career__Background_Edit_Image___1TNs","Career__Container":"automation_Career__Container__FM6UQ","Career__Inner":"automation_Career__Inner__hIRjc","Career__logo":"automation_Career__logo__f9nxj","Career__Content":"automation_Career__Content__JDk0i","Career__ButtonSection":"automation_Career__ButtonSection__EnYWn","Job":"automation_Job__muoHt","Job__Inner":"automation_Job__Inner__deG1G","Job__Container":"automation_Job__Container__KjpEZ","Job__Heading":"automation_Job__Heading__lHToH","Job__Company":"automation_Job__Company__4GJZg","Job__SearchContainer":"automation_Job__SearchContainer__e9_nu","Job__SearchInput":"automation_Job__SearchInput__ZbP99","Job__Searchbtn":"automation_Job__Searchbtn__Ema46","Job__Input":"automation_Job__Input__CblJu","Job__SelectJob":"automation_Job__SelectJob__FSqyU","Job__RemoteLabel":"automation_Job__RemoteLabel__fBZQJ","Job__Display":"automation_Job__Display__5YOBt","Job__PostDay":"automation_Job__PostDay__s_5CE","Job__Title":"automation_Job__Title__CQJBL","Job__Location":"automation_Job__Location__4zaDU","DT":"automation_DT__fwMY6","DisplayTable":"automation_DisplayTable__We4mb","pd11":"automation_pd11__A_4eq","Label":"automation_Label__DXgKN","inputwidth":"automation_inputwidth__2YUIk","mr24":"automation_mr24__9ZtH3","fullwidth":"automation_fullwidth__1Jc3u","padt40":"automation_padt40__8QhRO","Form__TableRowflex":"automation_Form__TableRowflex__NAQ9E","Form__TableColm":"automation_Form__TableColm__hGou_","Form__LabelCheck":"automation_Form__LabelCheck__dIXN4","Form__Error":"automation_Form__Error__ONqsv","Form__ErrorSection":"automation_Form__ErrorSection__ntUIR","Form__MessagePlaceholder":"automation_Form__MessagePlaceholder__kjcku","Form__Submit":"automation_Form__Submit__a_BVA","Form__NormalLabel":"automation_Form__NormalLabel__w3ute","AddInterview":"automation_AddInterview__LLAf2","IntegrationPage":"automation_IntegrationPage__VEIwg","Integration__BackStep":"automation_Integration__BackStep__Uza4Y","AddUsers__BackStep":"automation_AddUsers__BackStep__6zrqn","Integration__SubmitSection":"automation_Integration__SubmitSection__Hg8HV","IntegrationTable":"automation_IntegrationTable__prUaF","IntegrationTable__LimitInput":"automation_IntegrationTable__LimitInput__Z50GS","IntegrationTable__Type":"automation_IntegrationTable__Type__B86GH","IntegrationTable__AllJobsToggle":"automation_IntegrationTable__AllJobsToggle__fpjYa","IntegrationTable__switch":"automation_IntegrationTable__switch__LdMlP","IntegrationTable__switchText":"automation_IntegrationTable__switchText__op3Hk","IntegrationTable__slider":"automation_IntegrationTable__slider__iehjR","IntegrationTable__round":"automation_IntegrationTable__round__XBi4O","IntegrationTable__Action":"automation_IntegrationTable__Action__cIucd","IntegrationView":"automation_IntegrationView__iyJcc","IntegrationView__Title":"automation_IntegrationView__Title__rrV9U","IntegrationView__Subheading":"automation_IntegrationView__Subheading__8_SiO","IntegrationView__BoxImage":"automation_IntegrationView__BoxImage__nRxh4","IntegrationView__Box":"automation_IntegrationView__Box__PYZio","IntegrationView__BoxImage__InfoIcon":"automation_IntegrationView__BoxImage__InfoIcon__Khh7r","IntegrationView__ViewMoreButton":"automation_IntegrationView__ViewMoreButton__DOVL_","IntegrationView__ConnectButton":"automation_IntegrationView__ConnectButton__0AtzE","IntegrationView__GoogleButton":"automation_IntegrationView__GoogleButton__VNXt9","IntegrationView__FlexFlow":"automation_IntegrationView__FlexFlow__aBEyB","IntegrationView__BoxWidth":"automation_IntegrationView__BoxWidth__rfWrd","SkipFinishButton":"automation_SkipFinishButton__iOrRe","AddUsers":"automation_AddUsers__vwLyS","AddUsers__ButtonSection":"automation_AddUsers__ButtonSection__xv7vY","AddUsers__QuickStepHeading":"automation_AddUsers__QuickStepHeading__TcBXt","AddUsers__DeleteSection":"automation_AddUsers__DeleteSection__zxH5X","Interview__DeleteSection":"automation_Interview__DeleteSection__AeKEQ","AddUsers__DeleteCrossHeight":"automation_AddUsers__DeleteCrossHeight__ldiYf","AddUsers__Form__Input":"automation_AddUsers__Form__Input__flWwU","AddUsers__FormHeadingSection":"automation_AddUsers__FormHeadingSection__7F_HZ","Interview__FormHeadingSection":"automation_Interview__FormHeadingSection__lq38t","Automation__FormHeadingSection":"automation_Automation__FormHeadingSection__5w0x7","AddUsers__FormSection":"automation_AddUsers__FormSection__eEYMv","NewJob__FormSection":"automation_NewJob__FormSection__bA_pR","AddUsers__ButtonsActionSection":"automation_AddUsers__ButtonsActionSection__LYvgr","AddUsers__ImportUsers":"automation_AddUsers__ImportUsers__afg6p","AddUsers__NameInput":"automation_AddUsers__NameInput__jeDSo","AddUsers__EmailInput":"automation_AddUsers__EmailInput__qZSeF","AddUsers__RoleInput":"automation_AddUsers__RoleInput__Hh5EJ","AddUsers__Subheading":"automation_AddUsers__Subheading___ErF_","AddUsers__visible":"automation_AddUsers__visible__745DO","Tagrow":"automation_Tagrow__lcbqZ","Tagrow__Tags":"automation_Tagrow__Tags__nvf4d","SetupPopup__Tags":"automation_SetupPopup__Tags__hl7cg","Tagrow__Cancel":"automation_Tagrow__Cancel__FrpdK","Tagrow__Cross":"automation_Tagrow__Cross__rH01X","SendInviteSection":"automation_SendInviteSection__cZqaf","error":"automation_error__4mC9E","ViewJobPage__Input":"automation_ViewJobPage__Input__17foL","Form__Input2":"automation_Form__Input2__R1WdZ","ViewJobPage__PostDay":"automation_ViewJobPage__PostDay__Qi08h","ViewJobPage__Title":"automation_ViewJobPage__Title__J4fAW","ViewJobPage__DescriptionTitle":"automation_ViewJobPage__DescriptionTitle__rwysY","ViewJobPage__Location":"automation_ViewJobPage__Location__NvjlZ","ViewJobPage__primarybtn":"automation_ViewJobPage__primarybtn__TzCSn","ViewJobPage__secondarybtn":"automation_ViewJobPage__secondarybtn__91oKO","ViewJobPage__secondarybtnborder":"automation_ViewJobPage__secondarybtnborder__NpOXq","ViewJobPage__BackSection":"automation_ViewJobPage__BackSection__tcFY9","Modalpopup":"automation_Modalpopup__5Z2ZV","Modalpopup__inner":"automation_Modalpopup__inner__3wmgC","Modalpopup__Dialog":"automation_Modalpopup__Dialog___Ucx6","transition":"automation_transition__ym6rw","Modalpopup__CloseCenter":"automation_Modalpopup__CloseCenter__NSRr9","Modalpopup__Content":"automation_Modalpopup__Content__3PkZE","SetupPopup__PaddingPopup":"automation_SetupPopup__PaddingPopup__ZGGeE","SetupPopup__ContentCustomisation":"automation_SetupPopup__ContentCustomisation__fcES8","SetupPopup__Contentwithoutpadding":"automation_SetupPopup__Contentwithoutpadding__vJK6q","ViewJobPage__Content":"automation_ViewJobPage__Content__j6BDX","Modalpopup__btn":"automation_Modalpopup__btn__hEDTp","mar":"automation_mar__bEvvQ","Otpback":"automation_Otpback__HTP5u","ViewJobPage":"automation_ViewJobPage__ElVOB","ViewJobPage__Header":"automation_ViewJobPage__Header__XrAbf","ViewJobPage__Application":"automation_ViewJobPage__Application__QNLCw","ViewJobPage__RecordVideo":"automation_ViewJobPage__RecordVideo__RF6Pt","ViewJobPage__RecordVideoSuccessText":"automation_ViewJobPage__RecordVideoSuccessText__V_UD7","ViewJobPage__subheading":"automation_ViewJobPage__subheading__1kbIV","ViewJobPage__confirmation":"automation_ViewJobPage__confirmation__Son7U","ViewJobPage__Logo":"automation_ViewJobPage__Logo__GF1p3","ViewJobPage__BrandLogo":"automation_ViewJobPage__BrandLogo__8rE6v","ViewJobPage__BrandLogo__Padding10":"automation_ViewJobPage__BrandLogo__Padding10__iLVC3","ViewJobPage__Container":"automation_ViewJobPage__Container__5DwKG","ViewJobPage__JobContent":"automation_ViewJobPage__JobContent__T7ELf","ViewJobPage__Sidebar":"automation_ViewJobPage__Sidebar__yr8VW","ViewJobPage__Sidebar2":"automation_ViewJobPage__Sidebar2__SMnx5","ViewJobPage__Description":"automation_ViewJobPage__Description__P5KZx","ViewJobPage__DescriptionWidth":"automation_ViewJobPage__DescriptionWidth__TWskY","ViewJobPage__Footer":"automation_ViewJobPage__Footer__2BHQr","ViewJobPage__FooterView":"automation_ViewJobPage__FooterView__laqy7","ViewJobPage__ShareJob":"automation_ViewJobPage__ShareJob__vKOKU","ViewJobPage__SubmitSection":"automation_ViewJobPage__SubmitSection__2jwAv","ViewJobPage__SocialMedia":"automation_ViewJobPage__SocialMedia__NfW3X","ViewJobPage__SideContent":"automation_ViewJobPage__SideContent__w4dgq","ViewJobPage__ApplySection":"automation_ViewJobPage__ApplySection__vEgEM","FormBox__Autofill":"automation_FormBox__Autofill__ftobt","applybuttons":"automation_applybuttons__6gcMW","height90":"automation_height90__QFSb4","Form__Cont":"automation_Form__Cont__86FEm","Form__DropBox":"automation_Form__DropBox___Qm5L","Form__DropBoxcontainer":"automation_Form__DropBoxcontainer__3Towm","Form__DropBoxError":"automation_Form__DropBoxError__Nf2EY","Form__DropBoxicon":"automation_Form__DropBoxicon__kFlIl","Form__DropBoxmessage":"automation_Form__DropBoxmessage__XLqrd","noDpGrid":"automation_noDpGrid__smvc_","Terms":"automation_Terms__MiCE6","TermsCondition":"automation_TermsCondition__NN9Kh","TermsCondition__alignterms":"automation_TermsCondition__alignterms__T_oUR","MenuContainer":"automation_MenuContainer__ikzNv","MenuContainer__Menu":"automation_MenuContainer__Menu__Vgm71","AgencyDetailPage":"automation_AgencyDetailPage___CUBV","Congrats__ModalContent":"automation_Congrats__ModalContent__ZAl_B","NewJob__Container":"automation_NewJob__Container__EIEfM","NewJob__TopSection":"automation_NewJob__TopSection__BdBR8","Automation__TopSection":"automation_Automation__TopSection__cPISa","Interview__TopSection":"automation_Interview__TopSection__QffL1","NewJob__HorizontalDivider":"automation_NewJob__HorizontalDivider___V0yi","NewJob__Wrapper":"automation_NewJob__Wrapper__9STyq","NewJob__ContainerPadding":"automation_NewJob__ContainerPadding__66_gF","NewJob__ContainerScroll":"automation_NewJob__ContainerScroll__wP5hN","NewJob__ContainerHeight":"automation_NewJob__ContainerHeight__qHu6k","NewJob__ImportAction":"automation_NewJob__ImportAction__nglNL","NewJob__Interview_buttons":"automation_NewJob__Interview_buttons__kIa2o","Form__TableRowMB":"automation_Form__TableRowMB__Z6SMY","Form__TableRow3grid":"automation_Form__TableRow3grid___Whbm","Form__Remotegrid":"automation_Form__Remotegrid__2OVUF","Form__TypeList":"automation_Form__TypeList__hQJrc","Form__Type":"automation_Form__Type__Wh9Ap","Form__CheckLabel":"automation_Form__CheckLabel__ANc3y","PrivateSwitchBase-root-1":"automation_PrivateSwitchBase-root-1__LHPTA","Form__Caption":"automation_Form__Caption__nMzPP","Form__Input_currency":"automation_Form__Input_currency__fQ08S","Form__Input_MatchScore":"automation_Form__Input_MatchScore__P_un3","Form__Percentage_Symbol":"automation_Form__Percentage_Symbol__cbaoq","Form__NoGridTemplate":"automation_Form__NoGridTemplate__TjVjp","active":"automation_active__g_AaJ","mt10":"automation_mt10__jwde_","mt40":"automation_mt40___MlDl","mt30":"automation_mt30__tpZyH","mt32":"automation_mt32__Y4hly","mb0":"automation_mb0__8_s8s","Dpgrid":"automation_Dpgrid__XbAiZ","mb12":"automation_mb12__XHhxb","width100":"automation_width100__kLzMQ","Tagrow__Prefix":"automation_Tagrow__Prefix__ipEWQ","PreviewJobPage":"automation_PreviewJobPage__mfoPf","PreviewJob":"automation_PreviewJob__tyr_u","DpFlx":"automation_DpFlx__rrxci","Subheading":"automation_Subheading__IWT1M","Subheading__Description":"automation_Subheading__Description__Jzfz3","Candidate__Tooltip":"automation_Candidate__Tooltip__udR4c","Candidate__Tooltip__Score":"automation_Candidate__Tooltip__Score___biby","Form__InputField":"automation_Form__InputField__t_L7d","Candidate__Length":"automation_Candidate__Length__4VAOG","Agency__PostDay":"automation_Agency__PostDay__0kBpK","Agency__Title":"automation_Agency__Title__r0RrV","Agency__Location":"automation_Agency__Location__6qnqt","Agency__DescriptionTitle":"automation_Agency__DescriptionTitle__xTo3h","Agency__Description":"automation_Agency__Description__7Y6fZ","LightBlueColor":"automation_LightBlueColor__xUokg","Client_Page":"automation_Client_Page__dGxg5","Welcome":"automation_Welcome__0zav0","Welcome__Inner":"automation_Welcome__Inner__Pzrvu","Welcome__Person":"automation_Welcome__Person__4U0AV","Welcome__LeftContent":"automation_Welcome__LeftContent__ZBbN_","Welcome__RightContent":"automation_Welcome__RightContent__5VJTT","Welcome__Content":"automation_Welcome__Content__bZPNY","Welcome__CreateAccount":"automation_Welcome__CreateAccount__QqCSJ","Welcome__title":"automation_Welcome__title__QORci","Welcome__FormBox":"automation_Welcome__FormBox__ia_x1","Form__psw":"automation_Form__psw__vOcOS","Welcome__Container":"automation_Welcome__Container__EBu9Q","Success__Container":"automation_Success__Container__jFfOJ","Success":"automation_Success__Um6Ps","Success__Inner":"automation_Success__Inner__8OkDw","InterviewContainer":"automation_InterviewContainer__Zaq52","Interview__Stages":"automation_Interview__Stages__EIFIC","Interview__StageHeading":"automation_Interview__StageHeading__5RKsI","pl10":"automation_pl10__bUfHJ","Interview__AddStageSection":"automation_Interview__AddStageSection___MRPk","Interview__Label":"automation_Interview__Label__7s_RS","Interview__FormRowHeading":"automation_Interview__FormRowHeading__sC4gJ","Automation__FormRowHeading":"automation_Automation__FormRowHeading__jy5ez","dpflex":"automation_dpflex__uOxnU","Interview__IconsType":"automation_Interview__IconsType__AVw_j","Automation__IconsType":"automation_Automation__IconsType__qKN3b","Interview__Icons":"automation_Interview__Icons__E4SSl","Automation__Icons":"automation_Automation__Icons__ZUceg","Interview__Interview_buttons":"automation_Interview__Interview_buttons__NvYTQ","Interview__approvalButton":"automation_Interview__approvalButton__Z_ggj","Interview__BestMatch":"automation_Interview__BestMatch__yPQG4","Interview__BestMatchExclamation":"automation_Interview__BestMatchExclamation__FuWz_","DragAndDrop":"automation_DragAndDrop__F_cvh","DragAndDrop__CursorHandle":"automation_DragAndDrop__CursorHandle__nze34","Tagrow__Image":"automation_Tagrow__Image__zsfjq","rowbglight":"automation_rowbglight__rGgp_","rowbgheight":"automation_rowbgheight__nOuQF","Form__w90":"automation_Form__w90___5g_d","Container":"automation_Container__y9x7d","Screening__StageName":"automation_Screening__StageName__42Xt9","Screening__InterviewType":"automation_Screening__InterviewType__vkB3Z","Screening__InterviewType__Label":"automation_Screening__InterviewType__Label__oCus5","Show_Infoicon":"automation_Show_Infoicon__HcZsY","Show_Infoicon_small":"automation_Show_Infoicon_small__DGJQL","Screening__Info":"automation_Screening__Info__FgRhi","Screening__Info__IconWithText":"automation_Screening__Info__IconWithText__LzD6e","InterviewType__Icon":"automation_InterviewType__Icon__OFoNv","InterviewType__Text":"automation_InterviewType__Text__tK8xk","LoginModal":"automation_LoginModal__ByEpm","Logincontent":"automation_Logincontent__Mdwm8","Logincontent__title":"automation_Logincontent__title__VM6_m","Modalbg":"automation_Modalbg__onSKO","Modalnobg":"automation_Modalnobg__Af_ml","Form__Container":"automation_Form__Container__dIUmo","Form__success":"automation_Form__success__FMxxy","Form__error":"automation_Form__error__VVDz6","Form__CheckLabeltext":"automation_Form__CheckLabeltext__tujuP","Form__TextLeft":"automation_Form__TextLeft__emElL","Backsection":"automation_Backsection__PJ307","back":"automation_back__6ZxRt","mlr0":"automation_mlr0__Rm_E8","TwoButtons":"automation_TwoButtons__NUEaM","OtpBacksection":"automation_OtpBacksection__ZYum9","SetupPopup":"automation_SetupPopup__S6C8_","SetupPopup__inner":"automation_SetupPopup__inner__XWBbb","SetupPopup__Dialog":"automation_SetupPopup__Dialog___747i","SetupPopup__AddFile":"automation_SetupPopup__AddFile__uaUVf","SetupPopup__OptionalText":"automation_SetupPopup__OptionalText__71Gn_","SetupPopup__RequestAccessBtn":"automation_SetupPopup__RequestAccessBtn__jUelG","SetupPopup__InternalSection":"automation_SetupPopup__InternalSection__8VhJe","SetupPopup__ContentInnerRow":"automation_SetupPopup__ContentInnerRow___UYei","SetupPopup__ToChips":"automation_SetupPopup__ToChips__SOJS0","SetupPopup__AttachmentContainer":"automation_SetupPopup__AttachmentContainer__1Iuxh","SetupPopup__ContentInnerCol":"automation_SetupPopup__ContentInnerCol__NoxRz","SetupPopup__grid":"automation_SetupPopup__grid__sWYCo","SetupPopup__Footer":"automation_SetupPopup__Footer__S2FoK","SetupPopup__FooterNew":"automation_SetupPopup__FooterNew__59Dze","SetupPopup__Footer2":"automation_SetupPopup__Footer2__byNfs","SetupPopup__Footer3":"automation_SetupPopup__Footer3__Q_xmy","SetupPopup__Footerassess":"automation_SetupPopup__Footerassess__qLCj6","SetupPopup__Footertechtest":"automation_SetupPopup__Footertechtest__ctTSH","SetupPopup__AutommationFooter":"automation_SetupPopup__AutommationFooter__seub5","SetupPopup__MannualFooter":"automation_SetupPopup__MannualFooter__CJ_A1","SetupPopup__MannualInnerSection":"automation_SetupPopup__MannualInnerSection__keh6p","SetupPopup__Content":"automation_SetupPopup__Content__xcyix","SetupPopup__Content__Radiobtn":"automation_SetupPopup__Content__Radiobtn__qy0US","SetupPopup__AutomationToggle":"automation_SetupPopup__AutomationToggle__TCUbz","SetupPopup__SetupVideoQa":"automation_SetupPopup__SetupVideoQa__S4d3f","SetupPopup__SetupVideoQa2":"automation_SetupPopup__SetupVideoQa2__8QvLD","SetupPopup__SetupVideoQa3":"automation_SetupPopup__SetupVideoQa3__bQ14T","SetupPopup__SetupVideoQa4":"automation_SetupPopup__SetupVideoQa4__cHd4P","SetupPopup__InputQA":"automation_SetupPopup__InputQA__i1hxN","SetupPopup__AddQuestion":"automation_SetupPopup__AddQuestion__p8XyX","SetupPopup__QuestionSection":"automation_SetupPopup__QuestionSection__q07YR","SetupPopup__PushTop":"automation_SetupPopup__PushTop__PGqJP","SetupPopup__Contentpading":"automation_SetupPopup__Contentpading__whJVm","SetupPopup__QuesionSectionpading":"automation_SetupPopup__QuesionSectionpading___sHdP","SetupPopup__Contentcenter":"automation_SetupPopup__Contentcenter__oZbEp","SetupPopup__PopDetails":"automation_SetupPopup__PopDetails__wGBpQ","SetupPopup__PopDetails__FS16":"automation_SetupPopup__PopDetails__FS16__DtZ4m","SetupPopup__Details":"automation_SetupPopup__Details__CuW5P","SetupPopup__PrivacyPolicyDetails":"automation_SetupPopup__PrivacyPolicyDetails__XSt0i","SetupPopup__Reason":"automation_SetupPopup__Reason__i0tz2","SetupPopup__ContentBlock":"automation_SetupPopup__ContentBlock__kpXu2","SetupPopup__Purpose":"automation_SetupPopup__Purpose__h7uDy","SetupPopup__ContentGridsec":"automation_SetupPopup__ContentGridsec__Af5kg","mt25":"automation_mt25__43UNs","mt20":"automation_mt20__yV8AO","SetupPopup__ContentGridTech":"automation_SetupPopup__ContentGridTech__eMoci","SetupPopup__Assesmentsection":"automation_SetupPopup__Assesmentsection__w1Qkq","SetupPopup__AssesmentsectionNew":"automation_SetupPopup__AssesmentsectionNew__fHiMV","SetupPopup__MannualChips":"automation_SetupPopup__MannualChips__8tRHU","SetupPopup__ContentGridManuaCol":"automation_SetupPopup__ContentGridManuaCol__ajd9x","SetupPopup__ContentGridManual":"automation_SetupPopup__ContentGridManual__CTg3m","SetupPopup__ContentBlockPhone":"automation_SetupPopup__ContentBlockPhone__Fiv2G","SetupPopup__ContentAddInterview":"automation_SetupPopup__ContentAddInterview__c_5Bs","SetupPopup__ContentGridPhone":"automation_SetupPopup__ContentGridPhone__rTp7i","SetupPopup__ContentGridStatus":"automation_SetupPopup__ContentGridStatus__FJTHr","SetupPopup__GridActions":"automation_SetupPopup__GridActions__VwrYl","SetupPopup__GridActionCoral":"automation_SetupPopup__GridActionCoral__pvx6j","SetupPopup__GridActionIndigo":"automation_SetupPopup__GridActionIndigo__2gjJs","SetupPopup__ContentGrid":"automation_SetupPopup__ContentGrid__tfDoH","SetupPopup__SubmitSectionSave":"automation_SetupPopup__SubmitSectionSave__4Ayc1","SetupPopup__SubmitSectionReset":"automation_SetupPopup__SubmitSectionReset__BGeKY","SetupPopup__SubmitSectionAutomation":"automation_SetupPopup__SubmitSectionAutomation__1k7mj","SetupPopup__Duration":"automation_SetupPopup__Duration__a5XXL","SetupPopup__DeleteIcon":"automation_SetupPopup__DeleteIcon__ZqgI9","SetupPopup__ContentCustomisationManualInterview":"automation_SetupPopup__ContentCustomisationManualInterview__8zW8U","mt0":"automation_mt0__NeRE4","mtb25":"automation_mtb25__GuqCs","mb15":"automation_mb15__KPliw","mb30":"automation_mb30__4PpOg","mt9":"automation_mt9__a9tik","lineheight0":"automation_lineheight0__opqOd","PopupHeightSection":"automation_PopupHeightSection__880BN","AssessPopupHeightSection":"automation_AssessPopupHeightSection__a59A5","Statusopupheight":"automation_Statusopupheight__KLYOv","buttonIn":"automation_buttonIn__C6LCG","MessagePlaceholder":"automation_MessagePlaceholder__fSoYX","m0":"automation_m0__CzZ1b","mt18":"automation_mt18__p0pMg","DPgrid":"automation_DPgrid__ATT8g","addbtnposition":"automation_addbtnposition__lKw5d","mainformdiv":"automation_mainformdiv__K9ZND","crossflex":"automation_crossflex__f46Fs","crossimgheight":"automation_crossimgheight__mQH1U","crossimgheight48":"automation_crossimgheight48__wUMlr","SetupModalPopup":"automation_SetupModalPopup__TsYck","SetupModalPopup__Dialog":"automation_SetupModalPopup__Dialog__RoXjY","SetupPopupoverlay":"automation_SetupPopupoverlay__6uy16","NeedHelp":"automation_NeedHelp__84Dk4","uploadNewTest":"automation_uploadNewTest__n9uTz","SetupPopup__ol":"automation_SetupPopup__ol__Kid_f","Threshold__Content":"automation_Threshold__Content__vT88T","Automation__HorizontalDivider":"automation_Automation__HorizontalDivider__QY7mH","Automation__IconsType__BgFilled":"automation_Automation__IconsType__BgFilled__5Cq4i","Automation__AutomationBox":"automation_Automation__AutomationBox__V_rxj","Automation__Interview":"automation_Automation__Interview___VCvJ","Selectimg":"automation_Selectimg__jv9_m","Form__InputSetup":"automation_Form__InputSetup__rOh2S","Accordian":"automation_Accordian___hpHa","Accordian__Item":"automation_Accordian__Item__Ik7pu","Accordian__Button":"automation_Accordian__Button__QrOo0","Accordian__Panel":"automation_Accordian__Panel__Eqtj_","StageCard":"automation_StageCard__Xh1qa","StageCard__Panel":"automation_StageCard__Panel__yEwk_","StageCard__Heading":"automation_StageCard__Heading__WOfaE","StageCard__LeftContent":"automation_StageCard__LeftContent__7MK9S","StageCard__RightContent":"automation_StageCard__RightContent__gzv7T","StageCard__Details":"automation_StageCard__Details__n5xy_","StageCard__PlusMinusBtn":"automation_StageCard__PlusMinusBtn__iKjnu","StageCard__PlusMinusBtn__MinusBtn":"automation_StageCard__PlusMinusBtn__MinusBtn__h9Tzv","StageCard__PlusMinusBtn__PlusBtn":"automation_StageCard__PlusMinusBtn__PlusBtn__xckPv","SetupPopup__ContentGridPhone__Content":"automation_SetupPopup__ContentGridPhone__Content__flvgW","Popupheight":"automation_Popupheight__vo__8","automation":"automation_automation__2lx15"};

/***/ }),

/***/ 91122:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"customize-career_Form__xBmrG","Form__width":"customize-career_Form__width__nPGgJ","Form__label":"customize-career_Form__label__xIjSd","Form__textleft":"customize-career_Form__textleft__x3F1X","Form__InputFullWidth":"customize-career_Form__InputFullWidth__nVtWH","Form__Input":"customize-career_Form__Input__FX_Uj","Form__InputSection":"customize-career_Form__InputSection__OjC3B","Form__ScoreCardInput":"customize-career_Form__ScoreCardInput__OF1tp","Form__Textarea":"customize-career_Form__Textarea__sq3_Q","Form__CustomSelect":"customize-career_Form__CustomSelect__oQ9fu","Form__ErrorCustomSelect":"customize-career_Form__ErrorCustomSelect__FBNii","Form__currency_symbol":"customize-career_Form__currency_symbol__fJUYt","Form__select_currency":"customize-career_Form__select_currency__zA_OO","customSelect__placeholder":"customize-career_customSelect__placeholder__oo2WR","CustomizeCareer":"customize-career_CustomizeCareer__3wKsX","CustomizeCareer__Background_Edit":"customize-career_CustomizeCareer__Background_Edit___rLX5","CustomizeCareer__Container":"customize-career_CustomizeCareer__Container__CbYu2","CustomizeCareer__Heading":"customize-career_CustomizeCareer__Heading__FjlAo","CustomizeCareer__Inner":"customize-career_CustomizeCareer__Inner__W_K5j","CustomizeCareer__logo":"customize-career_CustomizeCareer__logo__RVCKM","CustomizeCareer__Content":"customize-career_CustomizeCareer__Content__uwBDh","CustomizeCareer__ButtonSection":"customize-career_CustomizeCareer__ButtonSection__3RcO_","CustomizeCareer__Subheading":"customize-career_CustomizeCareer__Subheading__nTmyw","Job":"customize-career_Job__cu_ZP","Job__Inner":"customize-career_Job__Inner__T3GdK","Job__Heading":"customize-career_Job__Heading__zPi4m","Job__Company":"customize-career_Job__Company__yznue","Job__SearchContainer":"customize-career_Job__SearchContainer__JXQ4G","Job__SearchInput":"customize-career_Job__SearchInput__pycYx","Job__Searchbtn":"customize-career_Job__Searchbtn__rpycb","Job__Input":"customize-career_Job__Input__D9Qfd","Job__SelectJob":"customize-career_Job__SelectJob__VADvY","Job__RemoteLabel":"customize-career_Job__RemoteLabel__wyQ_M","Job__Display":"customize-career_Job__Display__HuyLz","Job__PostDay":"customize-career_Job__PostDay__XU6Qu","Job__Title":"customize-career_Job__Title__prU2h","Job__Location":"customize-career_Job__Location__uHRik","DT":"customize-career_DT__qdol4","DisplayTable":"customize-career_DisplayTable__uztcL","pd11":"customize-career_pd11__Md7OW","Label":"customize-career_Label__1X_D8","inputwidth":"customize-career_inputwidth__hhMK2","mr24":"customize-career_mr24__5y1qo","fullwidth":"customize-career_fullwidth__om6NG","padt40":"customize-career_padt40__KEAo1","Form__TableRow":"customize-career_Form__TableRow__6o_j0","Form__TableRowflex":"customize-career_Form__TableRowflex__RPtkD","Form__TableColm":"customize-career_Form__TableColm__E6UCA","Form__Label":"customize-career_Form__Label__7stKM","CareerFooter":"customize-career_CareerFooter__VnwTh","CareerFooterWithButton":"customize-career_CareerFooterWithButton__lTZx7"};

/***/ }),

/***/ 3002:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CompareCandidates":"compare_candidates_CompareCandidates__fLjYm","CompareCandidates__w100":"compare_candidates_CompareCandidates__w100__5Zw0m","CompareCandidates__JobName":"compare_candidates_CompareCandidates__JobName__jQuS4","CompareCandidates__CandidateDetails":"compare_candidates_CompareCandidates__CandidateDetails__e71yZ","CompareCandidates__CandidateCompetencies":"compare_candidates_CompareCandidates__CandidateCompetencies__xjBla","CompareCandidates__LeftContent":"compare_candidates_CompareCandidates__LeftContent__PJ7os","CompareCandidates__Label":"compare_candidates_CompareCandidates__Label___M3Zq","CompareCandidates__CompetencyName":"compare_candidates_CompareCandidates__CompetencyName__ft7C3","CompareCandidates__Reviewers":"compare_candidates_CompareCandidates__Reviewers__yQqth","CompareCandidates__Feedback":"compare_candidates_CompareCandidates__Feedback__f9C6X","CompareCandidates__OverallScore":"compare_candidates_CompareCandidates__OverallScore__c6_Nx","CompareCandidates__SubCompetency":"compare_candidates_CompareCandidates__SubCompetency__VnQXc","CompareCandidates__RightContent":"compare_candidates_CompareCandidates__RightContent__W3D98","CompareCandidates__CandidateName":"compare_candidates_CompareCandidates__CandidateName__tIcpD","CompareCandidates__ReviewersCount":"compare_candidates_CompareCandidates__ReviewersCount__tVYu5","CompareCandidates__FeedbackCount":"compare_candidates_CompareCandidates__FeedbackCount__RZRiK","CompareCandidates__OverallScoreCount":"compare_candidates_CompareCandidates__OverallScoreCount__kBkHK","CompareCandidates__CompetencyCount":"compare_candidates_CompareCandidates__CompetencyCount__g4snk","CompareCandidates__SubCompetencyCount":"compare_candidates_CompareCandidates__SubCompetencyCount__A8BWZ","CompareCandidates__Title":"compare_candidates_CompareCandidates__Title__sqp4M","CompareCandidates__CandidateCompetencyOnly":"compare_candidates_CompareCandidates__CandidateCompetencyOnly__qFnLY","BacktoKanban":"compare_candidates_BacktoKanban__MXH0V","PageTitle":"compare_candidates_PageTitle__EBaIP","LessThanForty":"compare_candidates_LessThanForty__J25lS","BgGreen":"compare_candidates_BgGreen__tZI2G","BgYellow":"compare_candidates_BgYellow__aGpWF","BgRed":"compare_candidates_BgRed__14XMz","BgGreenLight":"compare_candidates_BgGreenLight__iYwcJ","BgYellowLight":"compare_candidates_BgYellowLight__ijgEW","BgRedLight":"compare_candidates_BgRedLight__itLUC","BgNa":"compare_candidates_BgNa__SoCWY","BgNaLight":"compare_candidates_BgNaLight__HmDVy"};

/***/ }),

/***/ 70587:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"edit_scorecard_Form__h6y2H","Form__width":"edit_scorecard_Form__width__9llnt","Form__label":"edit_scorecard_Form__label__Dz1qu","Form__textleft":"edit_scorecard_Form__textleft__FqOd4","Form__InputFullWidth":"edit_scorecard_Form__InputFullWidth__BS6ni","Form__Input":"edit_scorecard_Form__Input__QkyUV","Form__InputSection":"edit_scorecard_Form__InputSection__78wXa","Form__ScoreCardInput":"edit_scorecard_Form__ScoreCardInput__wZby4","Form__Textarea":"edit_scorecard_Form__Textarea__5SDRH","Tagrow":"edit_scorecard_Tagrow__K6xz_","Tagrow__Tags":"edit_scorecard_Tagrow__Tags__Pfaic","Tagrow__Cancel":"edit_scorecard_Tagrow__Cancel__FDVNM","Tagrow__Prefix":"edit_scorecard_Tagrow__Prefix__bcKFY","AutoSuggestInputContainer":"edit_scorecard_AutoSuggestInputContainer__LQKru","CreateScoreCard":"edit_scorecard_CreateScoreCard__2QBsI","CreateScoreCard__Card":"edit_scorecard_CreateScoreCard__Card__HxaMy","CreateScoreCard__Close":"edit_scorecard_CreateScoreCard__Close__6qwRf","w100":"edit_scorecard_w100__hOXiC","mw420":"edit_scorecard_mw420__bVxFD","CreateScoreCard__DownloadAndSubmit":"edit_scorecard_CreateScoreCard__DownloadAndSubmit__tHDYz","CreateScoreCard__TopSection":"edit_scorecard_CreateScoreCard__TopSection__q9cXT","CreateScoreCard__Subheading":"edit_scorecard_CreateScoreCard__Subheading__2mRkP","CreateScoreCard__Desc":"edit_scorecard_CreateScoreCard__Desc___qNXw","CreateScoreCard__Competency":"edit_scorecard_CreateScoreCard__Competency__3jKye","CreateScoreCard__SubCompetency":"edit_scorecard_CreateScoreCard__SubCompetency__fUPwV","LightBox":"edit_scorecard_LightBox__rnSUL","LightBox__Competency":"edit_scorecard_LightBox__Competency__jIBAb","LightBox__CompetencyLink":"edit_scorecard_LightBox__CompetencyLink__FoFTx","LightBox__OnlyCompetency":"edit_scorecard_LightBox__OnlyCompetency____vI_","LightBox__SubCompetency":"edit_scorecard_LightBox__SubCompetency__nMUTP","LeftSide":"edit_scorecard_LeftSide__Plm3P","RightSide":"edit_scorecard_RightSide__sHgK4","Dpflex":"edit_scorecard_Dpflex__xmHTm","CompetencyContainer":"edit_scorecard_CompetencyContainer__R9T5O","Anchor__Add":"edit_scorecard_Anchor__Add__UWm0Y","SubCompetency":"edit_scorecard_SubCompetency__8HwW7","CloseIcon_Width":"edit_scorecard_CloseIcon_Width___cnB1","Button":"edit_scorecard_Button__B0Iv1","Editor":"edit_scorecard_Editor__H09JK","AddScoreLink":"edit_scorecard_AddScoreLink__Ev0F2","addLink":"edit_scorecard_addLink__20dtP","CustomCheckLabel":"edit_scorecard_CustomCheckLabel__s85P7","Tagrow__TagsHeight":"edit_scorecard_Tagrow__TagsHeight__XtAr8","Tagrow__CancelSmall":"edit_scorecard_Tagrow__CancelSmall__If_Tp","ScorecardInputError":"edit_scorecard_ScorecardInputError__gZ_nE","ClientCompany__FormSection":"edit_scorecard_ClientCompany__FormSection__OXjKu","ClientCompany__LeftContent":"edit_scorecard_ClientCompany__LeftContent__jIpFd","ClientCompany__RightContent":"edit_scorecard_ClientCompany__RightContent__mDLJj","ClientCompany__Heading":"edit_scorecard_ClientCompany__Heading__PKDfQ","ClientCompany__JobTitleHeading":"edit_scorecard_ClientCompany__JobTitleHeading__G5DUU","ClientCompany__SmallHeading":"edit_scorecard_ClientCompany__SmallHeading__TNvAZ","importbtn":"edit_scorecard_importbtn__J7ciK","SearchIcon":"edit_scorecard_SearchIcon__dIhc_","AddNotes":"edit_scorecard_AddNotes__RVzQq","DownloadBtn":"edit_scorecard_DownloadBtn__LDALJ","AverageScore__Value":"edit_scorecard_AverageScore__Value__IySs9","LeftContent":"edit_scorecard_LeftContent__WBDwX","RightContent":"edit_scorecard_RightContent__oj1MN","AverageScore":"edit_scorecard_AverageScore___yPAF","CompetencyNotes":"edit_scorecard_CompetencyNotes__a0qan","TextEditor":"edit_scorecard_TextEditor__NLrKt","MessagePlaceholder":"edit_scorecard_MessagePlaceholder__DLDOo","SubCompetencyNotes":"edit_scorecard_SubCompetencyNotes__LM5VX","SingleSubCompetency":"edit_scorecard_SingleSubCompetency__iYAQb","Radius32":"edit_scorecard_Radius32___FWyf","PoorExcellentText":"edit_scorecard_PoorExcellentText__WODYB","PoorExcellentText__LeftContent":"edit_scorecard_PoorExcellentText__LeftContent__E5EFk","PoorExcellentText__RightContent":"edit_scorecard_PoorExcellentText__RightContent__L5A0U","Rating":"edit_scorecard_Rating__yK6Z_","EditContainer":"edit_scorecard_EditContainer__6hDvj"};

/***/ }),

/***/ 2273:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"email-chain_Form__mlhS7","Form__width":"email-chain_Form__width__z9P_b","Form__label":"email-chain_Form__label__oRDXt","Form__textleft":"email-chain_Form__textleft__8EkDr","Form__InputFullWidth":"email-chain_Form__InputFullWidth__gnrus","Form__Input":"email-chain_Form__Input__tc_Go","Form__Input398":"email-chain_Form__Input398__CQHSY","Form__InputSection":"email-chain_Form__InputSection__snfaR","Form__ScoreCardInput":"email-chain_Form__ScoreCardInput__FI29J","Form__Textarea":"email-chain_Form__Textarea__je5Bf","primarybtn":"email-chain_primarybtn___TUG8","JobList__EditModalEditButton":"email-chain_JobList__EditModalEditButton__C6nL6","GoBtn":"email-chain_GoBtn__qZy2t","secondarybtn":"email-chain_secondarybtn__TVZRt","JobList__EditModalCancelButton":"email-chain_JobList__EditModalCancelButton__Y5Uv4","iconFilled":"email-chain_iconFilled__snL9l","iconFilledSolid":"email-chain_iconFilledSolid__0mcm_","primarybtnborder":"email-chain_primarybtnborder__wKBeH","secondarybtnborder":"email-chain_secondarybtnborder__06eK7","ClearBtn":"email-chain_ClearBtn__opByo","tertiarybtn":"email-chain_tertiarybtn__MOd9d","graybtnborder":"email-chain_graybtnborder__Zrn0q","jobsrchbtn":"email-chain_jobsrchbtn__twP1V","jobsrchbtnalign":"email-chain_jobsrchbtnalign__KDlmD","nobgbutton":"email-chain_nobgbutton__aLyNU","iconTextButton":"email-chain_iconTextButton__5XvT3","cursornone":"email-chain_cursornone__o2RNH","nobgbuttonprimary":"email-chain_nobgbuttonprimary__GeuPu","mt15":"email-chain_mt15__kMRD2","btn350":"email-chain_btn350___aDj8","GrayBgBtn":"email-chain_GrayBgBtn__AYy5x","NewShareBtn":"email-chain_NewShareBtn__tGnW3","CoralBgBtn":"email-chain_CoralBgBtn__oAyR_","DropContainer":"email-chain_DropContainer__zl_Uv","DropContainer__Inner":"email-chain_DropContainer__Inner___SwFf","CompanyProfile__Inner":"email-chain_CompanyProfile__Inner__3ID2h","DropContainer__Message":"email-chain_DropContainer__Message__96gFP","CompanyProfile__Message":"email-chain_CompanyProfile__Message__NccYX","CompanyProfile__MessageContent":"email-chain_CompanyProfile__MessageContent__HA3kC","DropContainer__UploadIcon":"email-chain_DropContainer__UploadIcon__DzzST","CompanyProfile__UploadIcon":"email-chain_CompanyProfile__UploadIcon__AsiRi","FileDisplayContainer":"email-chain_FileDisplayContainer__O4fEL","FileDisplayContainer__Status":"email-chain_FileDisplayContainer__Status__xGHxM","SetupPopup__Status":"email-chain_SetupPopup__Status__Afy_X","SetupPopup__To":"email-chain_SetupPopup__To__M_wcG","FileDisplayContainer__Type":"email-chain_FileDisplayContainer__Type__8cpIz","FileDisplayContainer__Name":"email-chain_FileDisplayContainer__Name__udjZD","SetupPopup__Name":"email-chain_SetupPopup__Name__4Qg_e","SetupPopup__ToName":"email-chain_SetupPopup__ToName__FwVJ5","FileDisplayContainer__Error":"email-chain_FileDisplayContainer__Error__13nsf","FileDisplayContainer__Close":"email-chain_FileDisplayContainer__Close__xHDLG","Browse":"email-chain_Browse__wVfy4","ClientCompany":"email-chain_ClientCompany__TvETZ","NewJob":"email-chain_NewJob__OEEIj","Interview":"email-chain_Interview__ReqKI","ClientCompany__TopSection2":"email-chain_ClientCompany__TopSection2__TqbV1","ClientCompany__Filter":"email-chain_ClientCompany__Filter__G1rgc","ClientCompany__Input_MatchScore":"email-chain_ClientCompany__Input_MatchScore__rNWmv","ClientCompany__Percentage_Symbol":"email-chain_ClientCompany__Percentage_Symbol__VWUrY","ClientCompany__Filterheading":"email-chain_ClientCompany__Filterheading__CKwbV","ClientCompany__FloatButtonAdd":"email-chain_ClientCompany__FloatButtonAdd__yPQlJ","ClientCompany__FloatButtonAdd__AgencyUserIcon":"email-chain_ClientCompany__FloatButtonAdd__AgencyUserIcon__BXsHV","ClientCompany__LastEdited":"email-chain_ClientCompany__LastEdited__cQliq","ClientCompany__BackSection":"email-chain_ClientCompany__BackSection__R2XoL","AddUsers__BackSection":"email-chain_AddUsers__BackSection__7csV5","ClientCompany__BackSection__CloseIcon":"email-chain_ClientCompany__BackSection__CloseIcon__QQdRa","ClientCompany__Container":"email-chain_ClientCompany__Container__wPbnV","NewJob__InterviewContainer":"email-chain_NewJob__InterviewContainer__FNpKn","AddUsers__Container":"email-chain_AddUsers__Container__fQX0k","ClientCompany__FormInputSection":"email-chain_ClientCompany__FormInputSection__zj854","CompanyProfile__FormInputSection":"email-chain_CompanyProfile__FormInputSection__mjGv7","ClientCompany__Heading":"email-chain_ClientCompany__Heading__CpChH","Offer__Heading":"email-chain_Offer__Heading__MR50D","AddUsers__Heading":"email-chain_AddUsers__Heading__IntPv","ClientCompany__StatusAlignment":"email-chain_ClientCompany__StatusAlignment__bvbHC","ClientCompany__Status":"email-chain_ClientCompany__Status__bqu4W","ClientCompany__ActiveDot":"email-chain_ClientCompany__ActiveDot__Gj28w","ClientCompany__CloseDot":"email-chain_ClientCompany__CloseDot__ZGu1X","ClientCompany__Company":"email-chain_ClientCompany__Company__2mdNa","AddUsers__User":"email-chain_AddUsers__User__QwXME","ClientCompany__Systemrefheding":"email-chain_ClientCompany__Systemrefheding__oz_ET","ClientCompany__Subheading":"email-chain_ClientCompany__Subheading__K9O_1","CompanyProfile__Subheading":"email-chain_CompanyProfile__Subheading__GtP1E","ClientCompany__Subheading2":"email-chain_ClientCompany__Subheading2__APQvQ","ClientCompany__Description":"email-chain_ClientCompany__Description__Di8Rs","ClientCompany__SubmitSection":"email-chain_ClientCompany__SubmitSection__qvvup","NewJob__SubmitSection":"email-chain_NewJob__SubmitSection__WaerP","NewJob__SubmitSectionThreeBtn":"email-chain_NewJob__SubmitSectionThreeBtn__iymGl","NewJob__SubmitSectionOneBtnPlacement":"email-chain_NewJob__SubmitSectionOneBtnPlacement__WL32r","NewJob__ImportSection":"email-chain_NewJob__ImportSection__H0Poh","SetupPopup__SubmitSection2":"email-chain_SetupPopup__SubmitSection2__CRbSe","SetupPopup__SubmitSection":"email-chain_SetupPopup__SubmitSection__4eiJW","SetupPopup__SubmitSection3":"email-chain_SetupPopup__SubmitSection3__yDzsh","AddUsers__SubmitSection":"email-chain_AddUsers__SubmitSection__LeUMw","ClientCompany__IntegrationImage":"email-chain_ClientCompany__IntegrationImage__1txDb","ClientCompany__QuickAdd":"email-chain_ClientCompany__QuickAdd__Kvx4E","NewJob__QuickAdd":"email-chain_NewJob__QuickAdd__hp6Ns","JobList__QuickAdd":"email-chain_JobList__QuickAdd__1ZiwT","Interview__QuickAdd":"email-chain_Interview__QuickAdd__zyGdQ","ClientCompany__BodyText":"email-chain_ClientCompany__BodyText__8uBFb","Form__TableRow":"email-chain_Form__TableRow___8bAe","Form__TableRowTowGrid":"email-chain_Form__TableRowTowGrid__936cp","Form__TableRowSingle":"email-chain_Form__TableRowSingle__gZNxM","Form__Label":"email-chain_Form__Label__CW7ud","Form__Data":"email-chain_Form__Data__x3RjS","Form__DataSingleRow":"email-chain_Form__DataSingleRow__STgwm","Form__FloatingLabel":"email-chain_Form__FloatingLabel__kNoCG","Form__TableCol":"email-chain_Form__TableCol__i8L0F","Form__currency_symbol":"email-chain_Form__currency_symbol__JbvpC","Form__CustomSelect":"email-chain_Form__CustomSelect__W9VUP","Form__currency_symbol__right":"email-chain_Form__currency_symbol__right__AfS_3","Form__TableCol__Disabled":"email-chain_Form__TableCol__Disabled__MJQFf","Form__TextareaDisabled":"email-chain_Form__TextareaDisabled__sBrOR","Form__EditorDisabled":"email-chain_Form__EditorDisabled__Qj9Bu","Form__AdminCheckLabel":"email-chain_Form__AdminCheckLabel__nmJfm","Form__AdminCheckMargin":"email-chain_Form__AdminCheckMargin__MaX3Z","CompanyProfile__BrandingGuide":"email-chain_CompanyProfile__BrandingGuide__dfgBi","CompanyProfile__DropBoxContainer":"email-chain_CompanyProfile__DropBoxContainer__p4ppV","CompanyProfile__Browse":"email-chain_CompanyProfile__Browse__wcldt","ErrorLabel":"email-chain_ErrorLabel__G6_e_","Height80":"email-chain_Height80__cAIsB","Browse__ButtonFlexEnd":"email-chain_Browse__ButtonFlexEnd__OqdiX","AddAgency__Container":"email-chain_AddAgency__Container__NQqsu","AddAgency__FormInputSection":"email-chain_AddAgency__FormInputSection___v8xT","AddAgency__FormInputSection__Label":"email-chain_AddAgency__FormInputSection__Label__LVwVm","AddAgency__Form":"email-chain_AddAgency__Form___39N8","LinkAsButtons":"email-chain_LinkAsButtons__sjWVr","SearchFlex":"email-chain_SearchFlex__pZQOr","Form__ErrorCustomSelect":"email-chain_Form__ErrorCustomSelect__LBvYc","Form__select_currency":"email-chain_Form__select_currency__CWm_e","customSelect__placeholder":"email-chain_customSelect__placeholder__t8Yf3","Career":"email-chain_Career__q321I","Career__Background_Edit":"email-chain_Career__Background_Edit__1LFVv","Career__Background_Edit_Image":"email-chain_Career__Background_Edit_Image__M4dNz","Career__Container":"email-chain_Career__Container__W5dGD","Career__Inner":"email-chain_Career__Inner___QUHe","Career__logo":"email-chain_Career__logo__ulixz","Career__Content":"email-chain_Career__Content__vDtCP","Career__ButtonSection":"email-chain_Career__ButtonSection__t5Me8","Job":"email-chain_Job__83xOk","Job__Inner":"email-chain_Job__Inner__TO_e0","Job__Container":"email-chain_Job__Container__a1HXe","Job__Heading":"email-chain_Job__Heading__TS0sR","Job__Company":"email-chain_Job__Company__gRos4","Job__SearchContainer":"email-chain_Job__SearchContainer__AaX3Y","Job__SearchInput":"email-chain_Job__SearchInput___CXAu","Job__Searchbtn":"email-chain_Job__Searchbtn__lBvAd","Job__Input":"email-chain_Job__Input__1EfJZ","Job__SelectJob":"email-chain_Job__SelectJob__Cktak","Job__RemoteLabel":"email-chain_Job__RemoteLabel__ZqdFT","Job__Display":"email-chain_Job__Display__yI3M8","Job__PostDay":"email-chain_Job__PostDay__anA6p","Job__Title":"email-chain_Job__Title__QN_dn","Job__Location":"email-chain_Job__Location__48KZ4","DT":"email-chain_DT__V_Rva","DisplayTable":"email-chain_DisplayTable__iRewd","pd11":"email-chain_pd11__y4zx1","Label":"email-chain_Label__c9sfj","inputwidth":"email-chain_inputwidth___gX8z","mr24":"email-chain_mr24__kaBl1","fullwidth":"email-chain_fullwidth__5aDzg","padt40":"email-chain_padt40__kCZcC","Form__TableRowflex":"email-chain_Form__TableRowflex__85J2P","Form__TableColm":"email-chain_Form__TableColm__5YXlg","Form__LabelCheck":"email-chain_Form__LabelCheck__wAQvO","Form__Error":"email-chain_Form__Error__W4aY1","Form__ErrorSection":"email-chain_Form__ErrorSection___jeYK","Form__MessagePlaceholder":"email-chain_Form__MessagePlaceholder__aqSpD","Form__Submit":"email-chain_Form__Submit__JDOgM","Form__NormalLabel":"email-chain_Form__NormalLabel__HumIb","AddInterview":"email-chain_AddInterview__vF_g7","IntegrationPage":"email-chain_IntegrationPage__lF4Nh","Integration__BackStep":"email-chain_Integration__BackStep__APYh5","AddUsers__BackStep":"email-chain_AddUsers__BackStep__0nfTw","Integration__SubmitSection":"email-chain_Integration__SubmitSection__cUV_T","IntegrationTable":"email-chain_IntegrationTable__KumUz","IntegrationTable__LimitInput":"email-chain_IntegrationTable__LimitInput__4PmYv","IntegrationTable__Type":"email-chain_IntegrationTable__Type__1vnA4","IntegrationTable__AllJobsToggle":"email-chain_IntegrationTable__AllJobsToggle__On4aB","IntegrationTable__switch":"email-chain_IntegrationTable__switch__ganNy","IntegrationTable__switchText":"email-chain_IntegrationTable__switchText__C_dKA","IntegrationTable__slider":"email-chain_IntegrationTable__slider__uzNTb","IntegrationTable__round":"email-chain_IntegrationTable__round__pQeCl","IntegrationTable__Action":"email-chain_IntegrationTable__Action___vsk4","IntegrationView":"email-chain_IntegrationView__k4oDn","IntegrationView__Title":"email-chain_IntegrationView__Title__W1EAe","IntegrationView__Subheading":"email-chain_IntegrationView__Subheading__uyxmX","IntegrationView__BoxImage":"email-chain_IntegrationView__BoxImage__TNOB8","IntegrationView__Box":"email-chain_IntegrationView__Box__AN_Jo","IntegrationView__BoxImage__InfoIcon":"email-chain_IntegrationView__BoxImage__InfoIcon__HRXOR","IntegrationView__ViewMoreButton":"email-chain_IntegrationView__ViewMoreButton__SOXfM","IntegrationView__ConnectButton":"email-chain_IntegrationView__ConnectButton__jZHUs","IntegrationView__GoogleButton":"email-chain_IntegrationView__GoogleButton__GQ5kD","IntegrationView__FlexFlow":"email-chain_IntegrationView__FlexFlow__jZda1","IntegrationView__BoxWidth":"email-chain_IntegrationView__BoxWidth__x0p8g","SkipFinishButton":"email-chain_SkipFinishButton__vte0U","AddUsers":"email-chain_AddUsers__LJ0Ha","AddUsers__ButtonSection":"email-chain_AddUsers__ButtonSection__7_EAM","AddUsers__QuickStepHeading":"email-chain_AddUsers__QuickStepHeading__T2d6o","AddUsers__DeleteSection":"email-chain_AddUsers__DeleteSection__aNv_n","Interview__DeleteSection":"email-chain_Interview__DeleteSection__NNVAy","AddUsers__DeleteCrossHeight":"email-chain_AddUsers__DeleteCrossHeight__t9AJ3","AddUsers__Form__Input":"email-chain_AddUsers__Form__Input__7uYcY","AddUsers__FormHeadingSection":"email-chain_AddUsers__FormHeadingSection__SEJ5q","Interview__FormHeadingSection":"email-chain_Interview__FormHeadingSection__0nnmH","AddUsers__FormSection":"email-chain_AddUsers__FormSection__mITWf","NewJob__FormSection":"email-chain_NewJob__FormSection__3VmkT","AddUsers__ButtonsActionSection":"email-chain_AddUsers__ButtonsActionSection__qd5og","AddUsers__ImportUsers":"email-chain_AddUsers__ImportUsers__O1oBh","AddUsers__NameInput":"email-chain_AddUsers__NameInput__ZGT6O","AddUsers__EmailInput":"email-chain_AddUsers__EmailInput__zJth3","AddUsers__RoleInput":"email-chain_AddUsers__RoleInput__tqUCw","AddUsers__Subheading":"email-chain_AddUsers__Subheading__RO1od","AddUsers__visible":"email-chain_AddUsers__visible__9FeqT","Tagrow":"email-chain_Tagrow__YB23R","Tagrow__Tags":"email-chain_Tagrow__Tags__R2sJm","SetupPopup__Tags":"email-chain_SetupPopup__Tags__2ej7a","Tagrow__Cancel":"email-chain_Tagrow__Cancel__MzOc_","Tagrow__Cross":"email-chain_Tagrow__Cross__wgxHH","SendInviteSection":"email-chain_SendInviteSection__qIH__","error":"email-chain_error__I4qAI","ViewJobPage__Input":"email-chain_ViewJobPage__Input__PdqiK","Form__Input2":"email-chain_Form__Input2__xAdtZ","ViewJobPage__PostDay":"email-chain_ViewJobPage__PostDay__PMAH9","ViewJobPage__Title":"email-chain_ViewJobPage__Title___hGDy","ViewJobPage__DescriptionTitle":"email-chain_ViewJobPage__DescriptionTitle__CpNMy","ViewJobPage__Location":"email-chain_ViewJobPage__Location__eDrYw","ViewJobPage__primarybtn":"email-chain_ViewJobPage__primarybtn__3Y_PS","ViewJobPage__secondarybtn":"email-chain_ViewJobPage__secondarybtn__65opR","ViewJobPage__secondarybtnborder":"email-chain_ViewJobPage__secondarybtnborder__zbNfc","ViewJobPage__BackSection":"email-chain_ViewJobPage__BackSection__amu5_","Modalpopup":"email-chain_Modalpopup__7CKss","Modalpopup__inner":"email-chain_Modalpopup__inner__7brQV","Modalpopup__Dialog":"email-chain_Modalpopup__Dialog__qXehw","transition":"email-chain_transition__LBY0z","Modalpopup__CloseCenter":"email-chain_Modalpopup__CloseCenter__GldRI","Modalpopup__Content":"email-chain_Modalpopup__Content__EQf6t","SetupPopup__PaddingPopup":"email-chain_SetupPopup__PaddingPopup__pze8e","SetupPopup__ContentCustomisation":"email-chain_SetupPopup__ContentCustomisation__ZMsd2","SetupPopup__Contentwithoutpadding":"email-chain_SetupPopup__Contentwithoutpadding__7Q3XF","ViewJobPage__Content":"email-chain_ViewJobPage__Content__6GORl","Modalpopup__btn":"email-chain_Modalpopup__btn___tj3Q","mar":"email-chain_mar__Z4A_A","Otpback":"email-chain_Otpback__VtJ5K","ViewJobPage":"email-chain_ViewJobPage__r3VrT","ViewJobPage__Header":"email-chain_ViewJobPage__Header___8ogc","ViewJobPage__Application":"email-chain_ViewJobPage__Application__DwNyR","ViewJobPage__RecordVideo":"email-chain_ViewJobPage__RecordVideo__5lkQn","ViewJobPage__RecordVideoSuccessText":"email-chain_ViewJobPage__RecordVideoSuccessText__C6mpP","ViewJobPage__subheading":"email-chain_ViewJobPage__subheading__xIl0c","ViewJobPage__confirmation":"email-chain_ViewJobPage__confirmation__eb4SL","ViewJobPage__Logo":"email-chain_ViewJobPage__Logo__RREYx","ViewJobPage__BrandLogo":"email-chain_ViewJobPage__BrandLogo__1mbDk","ViewJobPage__BrandLogo__Padding10":"email-chain_ViewJobPage__BrandLogo__Padding10__yyACf","ViewJobPage__Container":"email-chain_ViewJobPage__Container__8XDez","ViewJobPage__JobContent":"email-chain_ViewJobPage__JobContent__P9nfp","ViewJobPage__Sidebar":"email-chain_ViewJobPage__Sidebar__8yQvD","ViewJobPage__Sidebar2":"email-chain_ViewJobPage__Sidebar2__v6wJb","ViewJobPage__Description":"email-chain_ViewJobPage__Description__7z__d","ViewJobPage__DescriptionWidth":"email-chain_ViewJobPage__DescriptionWidth__SAdfJ","ViewJobPage__Footer":"email-chain_ViewJobPage__Footer__6RqDo","ViewJobPage__FooterView":"email-chain_ViewJobPage__FooterView__5gztu","ViewJobPage__ShareJob":"email-chain_ViewJobPage__ShareJob__ud8pU","ViewJobPage__SubmitSection":"email-chain_ViewJobPage__SubmitSection__nh92_","ViewJobPage__SocialMedia":"email-chain_ViewJobPage__SocialMedia__yuPoN","ViewJobPage__SideContent":"email-chain_ViewJobPage__SideContent__7OSfV","ViewJobPage__ApplySection":"email-chain_ViewJobPage__ApplySection__ETle0","FormBox__Autofill":"email-chain_FormBox__Autofill__U8YxX","applybuttons":"email-chain_applybuttons__NlOV4","height90":"email-chain_height90__CIWqr","Form__Cont":"email-chain_Form__Cont__NBM06","Form__DropBox":"email-chain_Form__DropBox__saHWo","Form__DropBoxcontainer":"email-chain_Form__DropBoxcontainer__kxT7R","Form__DropBoxError":"email-chain_Form__DropBoxError__tV_U5","Form__DropBoxicon":"email-chain_Form__DropBoxicon___eaCZ","Form__DropBoxmessage":"email-chain_Form__DropBoxmessage__5lFXO","noDpGrid":"email-chain_noDpGrid__oN_00","Terms":"email-chain_Terms__31hmf","TermsCondition":"email-chain_TermsCondition__YFYW3","TermsCondition__alignterms":"email-chain_TermsCondition__alignterms__vuHX9","MenuContainer":"email-chain_MenuContainer__L9Bdz","MenuContainer__Menu":"email-chain_MenuContainer__Menu__6ryUn","AgencyDetailPage":"email-chain_AgencyDetailPage__51Hsx","Congrats__ModalContent":"email-chain_Congrats__ModalContent__c9BoS","JobList__SearchBox":"email-chain_JobList__SearchBox__qI5SH","NewJob__Container":"email-chain_NewJob__Container__1vET4","NewJob__TopSection":"email-chain_NewJob__TopSection__Cx1Kz","JobList__TopSection":"email-chain_JobList__TopSection___KFOY","Interview__TopSection":"email-chain_Interview__TopSection__P8TsW","NewJob__HorizontalDivider":"email-chain_NewJob__HorizontalDivider__WSNqE","NewJob__Wrapper":"email-chain_NewJob__Wrapper__YZ5rC","NewJob__ContainerPadding":"email-chain_NewJob__ContainerPadding__4786O","NewJob__ContainerScroll":"email-chain_NewJob__ContainerScroll__AV5hZ","NewJob__ContainerHeight":"email-chain_NewJob__ContainerHeight__L0WK2","NewJob__ImportAction":"email-chain_NewJob__ImportAction__0Wzex","NewJob__Interview_buttons":"email-chain_NewJob__Interview_buttons__YPjQB","Form__TableRowMB":"email-chain_Form__TableRowMB__yg4Im","Form__TableRow3grid":"email-chain_Form__TableRow3grid__hZ1_C","Form__Remotegrid":"email-chain_Form__Remotegrid__ld_Z7","Form__TypeList":"email-chain_Form__TypeList__Pf3Rq","Form__Type":"email-chain_Form__Type__ARmuk","Form__CheckLabel":"email-chain_Form__CheckLabel__JU32p","PrivateSwitchBase-root-1":"email-chain_PrivateSwitchBase-root-1__Aeygg","Form__Caption":"email-chain_Form__Caption__bxTXF","Form__Input_currency":"email-chain_Form__Input_currency__fOfTC","Form__Input_MatchScore":"email-chain_Form__Input_MatchScore__vkw09","Form__Percentage_Symbol":"email-chain_Form__Percentage_Symbol__3joa4","Form__NoGridTemplate":"email-chain_Form__NoGridTemplate__sVyt1","active":"email-chain_active__et7Wg","mt10":"email-chain_mt10__xzRFs","mt40":"email-chain_mt40__VVCqz","mt30":"email-chain_mt30__ER0M2","mt32":"email-chain_mt32__kO1p8","mb0":"email-chain_mb0__u6nl_","Dpgrid":"email-chain_Dpgrid__x_UYS","mb12":"email-chain_mb12__zKuoT","width100":"email-chain_width100__5ZIUQ","Tagrow__Prefix":"email-chain_Tagrow__Prefix__M_gil","PreviewJobPage":"email-chain_PreviewJobPage__b53qB","PreviewJob":"email-chain_PreviewJob__Ql_1Z","DpFlx":"email-chain_DpFlx__HN7Lp","Subheading":"email-chain_Subheading__ZQq7C","Subheading__Description":"email-chain_Subheading__Description__uiC7s","Candidate__Tooltip":"email-chain_Candidate__Tooltip__Ov4NZ","Candidate__Tooltip__Score":"email-chain_Candidate__Tooltip__Score__bnrof","Form__InputField":"email-chain_Form__InputField__gogVF","Candidate__Length":"email-chain_Candidate__Length__0KwUC","Agency__PostDay":"email-chain_Agency__PostDay__hPGx0","Agency__Title":"email-chain_Agency__Title__I_aDS","Agency__Location":"email-chain_Agency__Location__QGxS2","Agency__DescriptionTitle":"email-chain_Agency__DescriptionTitle__lts6q","Agency__Description":"email-chain_Agency__Description__XZolZ","LightBlueColor":"email-chain_LightBlueColor__l__z9","Client_Page":"email-chain_Client_Page__DcLWU","Welcome":"email-chain_Welcome__7z_pc","Welcome__Inner":"email-chain_Welcome__Inner__DOnZH","Welcome__Person":"email-chain_Welcome__Person__VVUqf","Welcome__LeftContent":"email-chain_Welcome__LeftContent__jCgWY","Welcome__RightContent":"email-chain_Welcome__RightContent__pJibY","Welcome__Content":"email-chain_Welcome__Content__uKyVc","Welcome__CreateAccount":"email-chain_Welcome__CreateAccount__YU6_M","Welcome__title":"email-chain_Welcome__title__JH3pG","Welcome__FormBox":"email-chain_Welcome__FormBox__bPI9d","AgencyDetailForm":"email-chain_AgencyDetailForm__1YOIS","Form__psw":"email-chain_Form__psw__fI_I0","Welcome__Container":"email-chain_Welcome__Container__74zpA","Success__Container":"email-chain_Success__Container__NEy_u","Success":"email-chain_Success__96J62","Success__Inner":"email-chain_Success__Inner__elHaQ","InterviewContainer":"email-chain_InterviewContainer__6sYIA","Interview__Stages":"email-chain_Interview__Stages__JXFki","Interview__StageHeading":"email-chain_Interview__StageHeading__Smps8","pl10":"email-chain_pl10__8yqRQ","Interview__AddStageSection":"email-chain_Interview__AddStageSection__ItXHs","Interview__Label":"email-chain_Interview__Label__Nj5T_","Interview__FormRowHeading":"email-chain_Interview__FormRowHeading__ygoqD","dpflex":"email-chain_dpflex__UWbXo","Interview__IconsType":"email-chain_Interview__IconsType__qbPFm","Interview__Icons":"email-chain_Interview__Icons__w66_Q","Interview__Interview_buttons":"email-chain_Interview__Interview_buttons__HWkPA","Interview__approvalButton":"email-chain_Interview__approvalButton__lg0A7","Interview__BestMatch":"email-chain_Interview__BestMatch__LUtdG","Interview__BestMatchExclamation":"email-chain_Interview__BestMatchExclamation__F5jzg","DragAndDrop":"email-chain_DragAndDrop__p7lch","DragAndDrop__CursorHandle":"email-chain_DragAndDrop__CursorHandle__z_2j9","Tagrow__Image":"email-chain_Tagrow__Image__w77Kl","rowbglight":"email-chain_rowbglight__OUUIZ","rowbgheight":"email-chain_rowbgheight__MwquD","Form__w90":"email-chain_Form__w90__gLyWc","Container":"email-chain_Container___k_Uj","Screening__StageName":"email-chain_Screening__StageName__RNELx","Screening__InterviewType":"email-chain_Screening__InterviewType__x8fC1","Screening__InterviewType__Label":"email-chain_Screening__InterviewType__Label__hNJPv","Show_Infoicon":"email-chain_Show_Infoicon__iqcGq","Show_Infoicon_small":"email-chain_Show_Infoicon_small__msjEy","Screening__Info":"email-chain_Screening__Info__ZeddB","Screening__Info__IconWithText":"email-chain_Screening__Info__IconWithText__h4MMb","InterviewType__Icon":"email-chain_InterviewType__Icon__BHbGc","InterviewType__Text":"email-chain_InterviewType__Text__0ZN81","LoginModal":"email-chain_LoginModal__dKTLM","Logincontent":"email-chain_Logincontent__msYkP","Logincontent__title":"email-chain_Logincontent__title__320uT","Modalbg":"email-chain_Modalbg__sUxI6","Modalnobg":"email-chain_Modalnobg__gK8FF","Form__Container":"email-chain_Form__Container__Hj_9j","Form__success":"email-chain_Form__success__wV7HZ","Form__error":"email-chain_Form__error__NfV5s","Form__CheckLabeltext":"email-chain_Form__CheckLabeltext__SV_Ns","Form__TextLeft":"email-chain_Form__TextLeft__GxUBM","Backsection":"email-chain_Backsection__ojapK","back":"email-chain_back__LVynZ","mlr0":"email-chain_mlr0__pdLWE","TwoButtons":"email-chain_TwoButtons__pbd8b","OtpBacksection":"email-chain_OtpBacksection__KjI12","SetupPopup":"email-chain_SetupPopup__pNbmQ","JobList__EditModal":"email-chain_JobList__EditModal__BLNBs","SetupPopup__inner":"email-chain_SetupPopup__inner__uQdfA","SetupPopup__Dialog":"email-chain_SetupPopup__Dialog__e3HTZ","SetupPopup__AddFile":"email-chain_SetupPopup__AddFile__gCVMs","SetupPopup__OptionalText":"email-chain_SetupPopup__OptionalText__fGFq0","SetupPopup__RequestAccessBtn":"email-chain_SetupPopup__RequestAccessBtn__ffNcY","SetupPopup__InternalSection":"email-chain_SetupPopup__InternalSection__Z2c54","SetupPopup__ContentInnerRow":"email-chain_SetupPopup__ContentInnerRow__2KfEp","SetupPopup__ToChips":"email-chain_SetupPopup__ToChips__uIzvA","SetupPopup__AttachmentContainer":"email-chain_SetupPopup__AttachmentContainer__drqnJ","SetupPopup__ContentInnerCol":"email-chain_SetupPopup__ContentInnerCol__gq6z5","SetupPopup__grid":"email-chain_SetupPopup__grid__Qfeya","SetupPopup__Footer":"email-chain_SetupPopup__Footer__7UKMQ","SetupPopup__FooterNew":"email-chain_SetupPopup__FooterNew__11ktP","SetupPopup__Footer2":"email-chain_SetupPopup__Footer2__pLM1W","SetupPopup__Footer3":"email-chain_SetupPopup__Footer3__5LLws","SetupPopup__Footerassess":"email-chain_SetupPopup__Footerassess__Wnbd5","SetupPopup__Footertechtest":"email-chain_SetupPopup__Footertechtest__HESHC","SetupPopup__AutommationFooter":"email-chain_SetupPopup__AutommationFooter__h5Tc6","SetupPopup__MannualFooter":"email-chain_SetupPopup__MannualFooter__y3dOK","SetupPopup__MannualInnerSection":"email-chain_SetupPopup__MannualInnerSection__wmtVQ","SetupPopup__Content":"email-chain_SetupPopup__Content__MbO4D","SetupPopup__Content__Radiobtn":"email-chain_SetupPopup__Content__Radiobtn__qHqmx","SetupPopup__AutomationToggle":"email-chain_SetupPopup__AutomationToggle__l1ddM","SetupPopup__SetupVideoQa":"email-chain_SetupPopup__SetupVideoQa__RJ2Hl","SetupPopup__SetupVideoQa2":"email-chain_SetupPopup__SetupVideoQa2__nYUnE","SetupPopup__SetupVideoQa3":"email-chain_SetupPopup__SetupVideoQa3__UZ1Gk","SetupPopup__SetupVideoQa4":"email-chain_SetupPopup__SetupVideoQa4__eDIZX","SetupPopup__InputQA":"email-chain_SetupPopup__InputQA__aqUQ_","SetupPopup__AddQuestion":"email-chain_SetupPopup__AddQuestion__AWtb5","SetupPopup__QuestionSection":"email-chain_SetupPopup__QuestionSection__HFlLM","SetupPopup__PushTop":"email-chain_SetupPopup__PushTop__2n8_5","SetupPopup__Contentpading":"email-chain_SetupPopup__Contentpading__a_As9","SetupPopup__QuesionSectionpading":"email-chain_SetupPopup__QuesionSectionpading__cQ_nf","SetupPopup__Contentcenter":"email-chain_SetupPopup__Contentcenter__xuhce","SetupPopup__PopDetails":"email-chain_SetupPopup__PopDetails__YH2lH","SetupPopup__PopDetails__FS16":"email-chain_SetupPopup__PopDetails__FS16__M4pIp","SetupPopup__Details":"email-chain_SetupPopup__Details__gFEjn","SetupPopup__PrivacyPolicyDetails":"email-chain_SetupPopup__PrivacyPolicyDetails__D1UMv","SetupPopup__Reason":"email-chain_SetupPopup__Reason__T307B","SetupPopup__ContentBlock":"email-chain_SetupPopup__ContentBlock__v7g6R","SetupPopup__Purpose":"email-chain_SetupPopup__Purpose__Hk2eD","SetupPopup__ContentGridsec":"email-chain_SetupPopup__ContentGridsec__TmwQY","mt25":"email-chain_mt25__qpnJZ","mt20":"email-chain_mt20__WMzMo","SetupPopup__ContentGridTech":"email-chain_SetupPopup__ContentGridTech__481wh","SetupPopup__Assesmentsection":"email-chain_SetupPopup__Assesmentsection__m_5U6","SetupPopup__AssesmentsectionNew":"email-chain_SetupPopup__AssesmentsectionNew__0Nxnl","SetupPopup__MannualChips":"email-chain_SetupPopup__MannualChips__uWjux","SetupPopup__ContentGridManuaCol":"email-chain_SetupPopup__ContentGridManuaCol__PBE4b","SetupPopup__ContentGridManual":"email-chain_SetupPopup__ContentGridManual__S9YmL","SetupPopup__ContentBlockPhone":"email-chain_SetupPopup__ContentBlockPhone__Zepc2","SetupPopup__ContentAddInterview":"email-chain_SetupPopup__ContentAddInterview__M5Wiu","SetupPopup__ContentGridPhone":"email-chain_SetupPopup__ContentGridPhone__GSRbS","SetupPopup__ContentGridStatus":"email-chain_SetupPopup__ContentGridStatus__bpdK_","SetupPopup__GridActions":"email-chain_SetupPopup__GridActions__NO7F_","SetupPopup__GridActionCoral":"email-chain_SetupPopup__GridActionCoral__cdH6_","SetupPopup__GridActionIndigo":"email-chain_SetupPopup__GridActionIndigo__UI6tv","SetupPopup__ContentGrid":"email-chain_SetupPopup__ContentGrid__O5xGc","SetupPopup__SubmitSectionSave":"email-chain_SetupPopup__SubmitSectionSave__CtNkF","SetupPopup__SubmitSectionReset":"email-chain_SetupPopup__SubmitSectionReset__EoT3I","SetupPopup__SubmitSectionAutomation":"email-chain_SetupPopup__SubmitSectionAutomation__md2UQ","SetupPopup__Duration":"email-chain_SetupPopup__Duration__HDOsJ","SetupPopup__DeleteIcon":"email-chain_SetupPopup__DeleteIcon__cWFvP","SetupPopup__ContentCustomisationManualInterview":"email-chain_SetupPopup__ContentCustomisationManualInterview__oVkCf","mt0":"email-chain_mt0__NgCwF","mtb25":"email-chain_mtb25__h3t1z","mb15":"email-chain_mb15__4feEH","mb30":"email-chain_mb30__PDCqA","mt9":"email-chain_mt9__6couP","lineheight0":"email-chain_lineheight0__2f3V4","PopupHeightSection":"email-chain_PopupHeightSection__y_7QH","AssessPopupHeightSection":"email-chain_AssessPopupHeightSection__cvOVs","Statusopupheight":"email-chain_Statusopupheight__Jm5ZO","buttonIn":"email-chain_buttonIn__QtwPW","MessagePlaceholder":"email-chain_MessagePlaceholder__6GR5l","m0":"email-chain_m0__jX1qc","mt18":"email-chain_mt18___XZX5","DPgrid":"email-chain_DPgrid__sQq5E","addbtnposition":"email-chain_addbtnposition__O1hEm","mainformdiv":"email-chain_mainformdiv__U1dh9","crossflex":"email-chain_crossflex__vPZQH","crossimgheight":"email-chain_crossimgheight__3o8vN","crossimgheight48":"email-chain_crossimgheight48__SbPZb","SetupModalPopup":"email-chain_SetupModalPopup__iSawN","SetupModalPopup__Dialog":"email-chain_SetupModalPopup__Dialog__Lx9u_","SetupPopupoverlay":"email-chain_SetupPopupoverlay__pZ_or","NeedHelp":"email-chain_NeedHelp__mdOFr","uploadNewTest":"email-chain_uploadNewTest__GEqmg","SetupPopup__ol":"email-chain_SetupPopup__ol__xTfUD","Threshold__Content":"email-chain_Threshold__Content__hCan_","SetupPopup__ContentGridPhone__Content":"email-chain_SetupPopup__ContentGridPhone__Content__iWgxJ","JobList__EditModalInner":"email-chain_JobList__EditModalInner__rj3Kg","Popupheight":"email-chain_Popupheight__y8AKN","CandidateBulkActionSection":"email-chain_CandidateBulkActionSection__hPjUt","KanbanBulkActionSection":"email-chain_KanbanBulkActionSection__GR_p_","KanbanBulkActionSection__Progress":"email-chain_KanbanBulkActionSection__Progress__ryJyq","KanbanBulkActionSection__Message":"email-chain_KanbanBulkActionSection__Message__jGe8E","Heading":"email-chain_Heading__oMaRb","Offer__Container":"email-chain_Offer__Container__xjI_v","Offer__DetailsSection":"email-chain_Offer__DetailsSection__GIWTV","Offer__NoMarginTop":"email-chain_Offer__NoMarginTop__iWwH4","Offer__Mt20":"email-chain_Offer__Mt20__lBpr0","Form__OfferSubmit":"email-chain_Form__OfferSubmit__tqPXx","Error":"email-chain_Error__uPSLf","SignContract":"email-chain_SignContract__AdBdU","SignContract__Container":"email-chain_SignContract__Container__jXqiY","SignContract__Button":"email-chain_SignContract__Button__GBUvJ","SignContract__Header":"email-chain_SignContract__Header__4pf5V","SignContract__Page":"email-chain_SignContract__Page__qd_eV","SignContract__Logo":"email-chain_SignContract__Logo__aPiFx","SignContract__Main":"email-chain_SignContract__Main__6YKiV","OfferDetail__Container":"email-chain_OfferDetail__Container__eRYF1","JobOfferDetails":"email-chain_JobOfferDetails__biRoY","JobOfferDetails__Section":"email-chain_JobOfferDetails__Section__c6VAW","JobOfferDetails__Row":"email-chain_JobOfferDetails__Row__QKcz7","JobOfferDetails__LeftCol":"email-chain_JobOfferDetails__LeftCol__DTXSh","JobOfferDetails__RightCol":"email-chain_JobOfferDetails__RightCol__mtsDL","JobOfferDetails__Label":"email-chain_JobOfferDetails__Label__mfWKS","JobOfferDetails__Data":"email-chain_JobOfferDetails__Data__gfhsi","JobOfferDetails__W100":"email-chain_JobOfferDetails__W100__m_1Sj","JobOfferDetails__MR20":"email-chain_JobOfferDetails__MR20__EQout","Offer":"email-chain_Offer__VIGRf","OfferDetail":"email-chain_OfferDetail__GMkWI","ProgressLineSection":"email-chain_ProgressLineSection__MieyG","ProgressLineSection__Container":"email-chain_ProgressLineSection__Container__V1Aiw","ProgressLineSection__AcionSection":"email-chain_ProgressLineSection__AcionSection__p2MXT","ProgressLineSection__ActionButtons":"email-chain_ProgressLineSection__ActionButtons__nal6V","ProgressLineSection__Heading":"email-chain_ProgressLineSection__Heading__2BA4v","TopHeaderSection":"email-chain_TopHeaderSection__HjjCi","TopHeaderSection__SpaceBetween":"email-chain_TopHeaderSection__SpaceBetween__gZs67","AgencyHeading":"email-chain_AgencyHeading___2ZsQ","StatsSection":"email-chain_StatsSection__z5_Gw","StatsSection__List":"email-chain_StatsSection__List__jvvlF","StatsSection__NewList":"email-chain_StatsSection__NewList__LOlYD","StatsSection__ListStatus":"email-chain_StatsSection__ListStatus__8X3Os","StatsSection__NewListStatus":"email-chain_StatsSection__NewListStatus__pm2JG","StatsSection__Statslist":"email-chain_StatsSection__Statslist__6TZXk","StatsSection__StatsAnchor":"email-chain_StatsSection__StatsAnchor__PwTlk","StatsSection__StatsContent":"email-chain_StatsSection__StatsContent__yz7D2","StatsSection__StatsContentWidth":"email-chain_StatsSection__StatsContentWidth__aoDAE","StatsSection__StatsNumber":"email-chain_StatsSection__StatsNumber__dyCTO","StatsSection__StatsNumberWidth":"email-chain_StatsSection__StatsNumberWidth__BnXh5","StatsSection__Health":"email-chain_StatsSection__Health__JBtIM","StatsSection__IndigoBg":"email-chain_StatsSection__IndigoBg__mY1uD","StatsSection__CorelBg":"email-chain_StatsSection__CorelBg__tmRaK","StatsSection__GreenBg":"email-chain_StatsSection__GreenBg__Dj3tA","StatsSection__RoseBg":"email-chain_StatsSection__RoseBg__G2X7d","StatsSection__CorelDarkBg":"email-chain_StatsSection__CorelDarkBg__hE_V6","StatsSection__StatBgOne":"email-chain_StatsSection__StatBgOne__hMidg","StatsSection__StatBgOne__NoBorder":"email-chain_StatsSection__StatBgOne__NoBorder__XB7Y5","StatsSection__StatBgTwo":"email-chain_StatsSection__StatBgTwo__pOHxf","StatsSection__StatBgThree":"email-chain_StatsSection__StatBgThree__lOLqy","StatsSection__StatBgFour":"email-chain_StatsSection__StatBgFour__UA2nq","NotificationSection":"email-chain_NotificationSection__SV3w_","NotificationSection__InterviewListNoHover":"email-chain_NotificationSection__InterviewListNoHover__Ru_En","NotificationSection__AlertActivity":"email-chain_NotificationSection__AlertActivity__ewOVU","NotificationSection__Alert":"email-chain_NotificationSection__Alert__uFFOq","NotificationSection__List":"email-chain_NotificationSection__List__DbPYP","NotificationSection__AlertContainer":"email-chain_NotificationSection__AlertContainer__s7WA0","NotificationSection__CommunicationContainer":"email-chain_NotificationSection__CommunicationContainer___Nzwn","NotificationSection__AlertActivityContainer":"email-chain_NotificationSection__AlertActivityContainer__PEaEk","NotificationSection__Schedulingmain":"email-chain_NotificationSection__Schedulingmain__guBwh","NotificationSection__More":"email-chain_NotificationSection__More__OSuuh","NotificationSection__Alertslist":"email-chain_NotificationSection__Alertslist__Oi63O","NotificationSection__Alertsmessage":"email-chain_NotificationSection__Alertsmessage__NTq8S","NotificationSection__AlertsTilte":"email-chain_NotificationSection__AlertsTilte__0VEX7","NotificationSection__AlertHeading":"email-chain_NotificationSection__AlertHeading__bAN78","NotificationSection__CalendarHeading":"email-chain_NotificationSection__CalendarHeading__1sopE","NotificationSection__Dismiss":"email-chain_NotificationSection__Dismiss__3fNS8","NotificationSection__Communications":"email-chain_NotificationSection__Communications__Y_5N1","NotificationSection__ProfileCircle":"email-chain_NotificationSection__ProfileCircle__fGrXH","NotificationSection__SchedulingTiming":"email-chain_NotificationSection__SchedulingTiming__zIMxj","NotificationSection__TimimgsSection":"email-chain_NotificationSection__TimimgsSection__VvzsG","NotificationSection__WeekTiming":"email-chain_NotificationSection__WeekTiming__j7G66","NotificationSection__Scheduling":"email-chain_NotificationSection__Scheduling__Zy410","NotificationSection__Pagination":"email-chain_NotificationSection__Pagination__QkLwQ","NotificationSection__PaginationButton":"email-chain_NotificationSection__PaginationButton__QAsnD","NotificationSection__InterviewListSvg":"email-chain_NotificationSection__InterviewListSvg__o91CM","NotificationSection__InterviewListStage":"email-chain_NotificationSection__InterviewListStage__lSpRE","NotificationSection__InterviewList":"email-chain_NotificationSection__InterviewList__MgtTV","NotificationSection__Interviewtitle":"email-chain_NotificationSection__Interviewtitle__SmIAP","NotificationSection__InterviewerProfile":"email-chain_NotificationSection__InterviewerProfile__Rz7Nz","NotificationSection__InterviewerDate":"email-chain_NotificationSection__InterviewerDate__fK9Nk","NotificationSection__Greybox":"email-chain_NotificationSection__Greybox__2DPC0","NotificationSection__Tabs":"email-chain_NotificationSection__Tabs__l90j0","React__tabs":"email-chain_React__tabs__2M6sw","React__tabs__today":"email-chain_React__tabs__today__Q2xXD","React__tabs__head":"email-chain_React__tabs__head__HrwyQ","React__tabs__tabpanel":"email-chain_React__tabs__tabpanel__FYt_X","React__tabs__tablist":"email-chain_React__tabs__tablist__ZSmdq","React__tabs__tablist__tab":"email-chain_React__tabs__tablist__tab__mfWY0","React__tabs__interviewtype":"email-chain_React__tabs__interviewtype__K4bt1","React__tabs__MyInterview":"email-chain_React__tabs__MyInterview__daNzF","React__tabs__TeamInterview":"email-chain_React__tabs__TeamInterview__MQWKE","NamePrefix":"email-chain_NamePrefix__c2uIp","CandidatePrefix":"email-chain_CandidatePrefix__H7mDQ","TopSection":"email-chain_TopSection__5FPDC","CalendarSelectedDate":"email-chain_CalendarSelectedDate__x2OJT","TitleFlex":"email-chain_TitleFlex__XNw_k","JobList__Accordian":"email-chain_JobList__Accordian__ELNB1","JobList__AccordianContent":"email-chain_JobList__AccordianContent__IX3Cm","JobList__SearchSection":"email-chain_JobList__SearchSection__52gSz","EmailTemplates__SearchSection":"email-chain_EmailTemplates__SearchSection__cvIFN","JobList__FilterMarginBottom":"email-chain_JobList__FilterMarginBottom__q95PE","JobList__SearchFilter":"email-chain_JobList__SearchFilter__GLjVr","JobList__AppliedSearchFilter":"email-chain_JobList__AppliedSearchFilter__iwE8V","JobList__SearchFilterFullWidth":"email-chain_JobList__SearchFilterFullWidth__kkctR","JobList__AddJobSection":"email-chain_JobList__AddJobSection__RzvAq","JobList__Status":"email-chain_JobList__Status__M7D5E","JobList__EditModalContainer":"email-chain_JobList__EditModalContainer__hcmLQ","JobList__EditModalMessage":"email-chain_JobList__EditModalMessage__QZn_m","JobList__EditModalButtonSection":"email-chain_JobList__EditModalButtonSection__4gMoW","JobList__CheckLabel":"email-chain_JobList__CheckLabel__gC_6O","JobList__Checkbox":"email-chain_JobList__Checkbox__qBXnT","JobList__JobBoard":"email-chain_JobList__JobBoard__7NliV","JobList__Reasons":"email-chain_JobList__Reasons__NA9Zr","KanbanSearch__Dots":"email-chain_KanbanSearch__Dots__cKLd1","AgencyDetailForm__Label":"email-chain_AgencyDetailForm__Label__od5UO","AgencyDetailForm__Data":"email-chain_AgencyDetailForm__Data__352UH","AgencyDetailForm__Actionsection":"email-chain_AgencyDetailForm__Actionsection__HBaXI","AgencyDetailForm__FormInputSection":"email-chain_AgencyDetailForm__FormInputSection__3QueS","ApprovalContract":"email-chain_ApprovalContract__7Iz3j","ApprovalContractButtons":"email-chain_ApprovalContractButtons__RWzbQ","EmailTemplates__AddJobSection":"email-chain_EmailTemplates__AddJobSection__VjOEO","EmailTemplates__AddJobSection2":"email-chain_EmailTemplates__AddJobSection2__b5K0p","EmailTemplates__InviteUser":"email-chain_EmailTemplates__InviteUser__D7Oz_","EmailTemplates__AddJobSectionheight":"email-chain_EmailTemplates__AddJobSectionheight__ybEbv","EmailTemplates__SearchFlex":"email-chain_EmailTemplates__SearchFlex__Z2q2_","EmailTemplates__NotifyFlex":"email-chain_EmailTemplates__NotifyFlex__tt3mu","EmailChain__EmailHead":"email-chain_EmailChain__EmailHead__CYxP_","EmailChain__EmailHeadContent":"email-chain_EmailChain__EmailHeadContent__weNz1","EmailChain__EmailHeadActions":"email-chain_EmailChain__EmailHeadActions__poO0D","EmailChain__EmailDoc":"email-chain_EmailChain__EmailDoc__7yRNR","EmailChain__EmailAttachment":"email-chain_EmailChain__EmailAttachment__d62PC"};

/***/ }),

/***/ 89817:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"interview-stages_Form__CkXYk","Form__width":"interview-stages_Form__width__tz1Gb","Form__label":"interview-stages_Form__label__zlx8L","Form__textleft":"interview-stages_Form__textleft__AZX0d","Form__InputFullWidth":"interview-stages_Form__InputFullWidth___Secl","Form__Input":"interview-stages_Form__Input__dpyOb","Form__Input398":"interview-stages_Form__Input398__GorXs","Form__InputSection":"interview-stages_Form__InputSection___d2DB","Form__ScoreCardInput":"interview-stages_Form__ScoreCardInput__S4qvr","Form__Textarea":"interview-stages_Form__Textarea__0h3w6","primarybtn":"interview-stages_primarybtn__tga1W","GoBtn":"interview-stages_GoBtn__Cgi6d","secondarybtn":"interview-stages_secondarybtn__9oNln","iconFilled":"interview-stages_iconFilled__D8J2U","iconFilledSolid":"interview-stages_iconFilledSolid__85PgG","primarybtnborder":"interview-stages_primarybtnborder__y8fvY","secondarybtnborder":"interview-stages_secondarybtnborder__JKiNc","ClearBtn":"interview-stages_ClearBtn__omKm3","tertiarybtn":"interview-stages_tertiarybtn__QVdAu","graybtnborder":"interview-stages_graybtnborder__5sg4V","jobsrchbtn":"interview-stages_jobsrchbtn__nHr4t","jobsrchbtnalign":"interview-stages_jobsrchbtnalign__WxxM9","nobgbutton":"interview-stages_nobgbutton__aZl_s","iconTextButton":"interview-stages_iconTextButton__rzTbm","cursornone":"interview-stages_cursornone__Ubdzv","nobgbuttonprimary":"interview-stages_nobgbuttonprimary__VWYaX","mt15":"interview-stages_mt15__4RgJY","btn350":"interview-stages_btn350__GvAGs","GrayBgBtn":"interview-stages_GrayBgBtn__Xxrj4","NewShareBtn":"interview-stages_NewShareBtn__yS39O","CoralBgBtn":"interview-stages_CoralBgBtn__G1UE6","DropContainer":"interview-stages_DropContainer__V_7n0","DropContainer__Inner":"interview-stages_DropContainer__Inner__1R_es","CompanyProfile__Inner":"interview-stages_CompanyProfile__Inner__XxvBY","DropContainer__Message":"interview-stages_DropContainer__Message__VodEV","CompanyProfile__Message":"interview-stages_CompanyProfile__Message__FB09H","CompanyProfile__MessageContent":"interview-stages_CompanyProfile__MessageContent__UCCM0","DropContainer__UploadIcon":"interview-stages_DropContainer__UploadIcon__CFATC","CompanyProfile__UploadIcon":"interview-stages_CompanyProfile__UploadIcon__7aHk8","FileDisplayContainer":"interview-stages_FileDisplayContainer__d5iFl","FileDisplayContainer__Status":"interview-stages_FileDisplayContainer__Status__kKUHN","FileDisplayContainer__Type":"interview-stages_FileDisplayContainer__Type__pdv7z","FileDisplayContainer__Name":"interview-stages_FileDisplayContainer__Name__yWeuk","FileDisplayContainer__Error":"interview-stages_FileDisplayContainer__Error__rPzui","FileDisplayContainer__Close":"interview-stages_FileDisplayContainer__Close__ZB6Xt","Browse":"interview-stages_Browse__lhwAT","ClientCompany":"interview-stages_ClientCompany__bj4tq","NewJob":"interview-stages_NewJob__7Q5xA","Interview":"interview-stages_Interview__9ji6J","ClientCompany__TopSection2":"interview-stages_ClientCompany__TopSection2__S0jMY","ClientCompany__Filter":"interview-stages_ClientCompany__Filter__0IV3t","ClientCompany__Input_MatchScore":"interview-stages_ClientCompany__Input_MatchScore__zRgzX","ClientCompany__Percentage_Symbol":"interview-stages_ClientCompany__Percentage_Symbol__FxZqa","ClientCompany__Filterheading":"interview-stages_ClientCompany__Filterheading__wdapG","ClientCompany__FloatButtonAdd":"interview-stages_ClientCompany__FloatButtonAdd__Gu2at","ClientCompany__FloatButtonAdd__AgencyUserIcon":"interview-stages_ClientCompany__FloatButtonAdd__AgencyUserIcon__Rsx0V","ClientCompany__LastEdited":"interview-stages_ClientCompany__LastEdited__EkJIG","ClientCompany__BackSection":"interview-stages_ClientCompany__BackSection__dLWVO","AddUsers__BackSection":"interview-stages_AddUsers__BackSection__h1HU4","ClientCompany__BackSection__CloseIcon":"interview-stages_ClientCompany__BackSection__CloseIcon__2m4_N","ClientCompany__Container":"interview-stages_ClientCompany__Container__E3Zvw","NewJob__InterviewContainer":"interview-stages_NewJob__InterviewContainer__JS85F","AddUsers__Container":"interview-stages_AddUsers__Container__Sm8xu","ClientCompany__FormInputSection":"interview-stages_ClientCompany__FormInputSection__QnFyG","CompanyProfile__FormInputSection":"interview-stages_CompanyProfile__FormInputSection__gdrJn","ClientCompany__Heading":"interview-stages_ClientCompany__Heading__ipxSZ","AddUsers__Heading":"interview-stages_AddUsers__Heading__ZKZ7K","ClientCompany__StatusAlignment":"interview-stages_ClientCompany__StatusAlignment__oHs7_","ClientCompany__Status":"interview-stages_ClientCompany__Status__C_IOc","ClientCompany__ActiveDot":"interview-stages_ClientCompany__ActiveDot__NfM_t","ClientCompany__CloseDot":"interview-stages_ClientCompany__CloseDot__bNXMS","ClientCompany__Company":"interview-stages_ClientCompany__Company__5jyr9","AddUsers__User":"interview-stages_AddUsers__User__2AvD1","ClientCompany__Systemrefheding":"interview-stages_ClientCompany__Systemrefheding__sUnMY","ClientCompany__Subheading":"interview-stages_ClientCompany__Subheading__jY4Uv","CompanyProfile__Subheading":"interview-stages_CompanyProfile__Subheading__5ihSn","ClientCompany__Subheading2":"interview-stages_ClientCompany__Subheading2__KLhvT","ClientCompany__Description":"interview-stages_ClientCompany__Description__KsEf9","ClientCompany__SubmitSection":"interview-stages_ClientCompany__SubmitSection__F494u","NewJob__SubmitSection":"interview-stages_NewJob__SubmitSection__EXWL5","NewJob__SubmitSectionThreeBtn":"interview-stages_NewJob__SubmitSectionThreeBtn__xRJFA","NewJob__SubmitSectionOneBtnPlacement":"interview-stages_NewJob__SubmitSectionOneBtnPlacement__E91It","NewJob__ImportSection":"interview-stages_NewJob__ImportSection__MJqK1","AddUsers__SubmitSection":"interview-stages_AddUsers__SubmitSection___2hch","ClientCompany__IntegrationImage":"interview-stages_ClientCompany__IntegrationImage__prGcn","ClientCompany__QuickAdd":"interview-stages_ClientCompany__QuickAdd__Hw4lc","NewJob__QuickAdd":"interview-stages_NewJob__QuickAdd__j6miH","Interview__QuickAdd":"interview-stages_Interview__QuickAdd__vJT6E","ClientCompany__BodyText":"interview-stages_ClientCompany__BodyText__Cw6b_","Form__TableRow":"interview-stages_Form__TableRow__8F_OD","Form__Label":"interview-stages_Form__Label__T2FZ9","Form__FloatingLabel":"interview-stages_Form__FloatingLabel__yzFuh","Form__TableCol":"interview-stages_Form__TableCol__cywhy","Form__currency_symbol":"interview-stages_Form__currency_symbol__fxJG2","Form__CustomSelect":"interview-stages_Form__CustomSelect__a7IVJ","Form__currency_symbol__right":"interview-stages_Form__currency_symbol__right__uQxa7","Form__TableCol__Disabled":"interview-stages_Form__TableCol__Disabled__v7H0v","Form__TextareaDisabled":"interview-stages_Form__TextareaDisabled__YesRU","Form__EditorDisabled":"interview-stages_Form__EditorDisabled__JZf4W","Form__AdminCheckLabel":"interview-stages_Form__AdminCheckLabel__CLbCp","Form__AdminCheckMargin":"interview-stages_Form__AdminCheckMargin__AuZDj","CompanyProfile__BrandingGuide":"interview-stages_CompanyProfile__BrandingGuide__9EI5n","CompanyProfile__DropBoxContainer":"interview-stages_CompanyProfile__DropBoxContainer__Q3Wfs","CompanyProfile__Browse":"interview-stages_CompanyProfile__Browse__7Fs4X","ErrorLabel":"interview-stages_ErrorLabel__a8Yi_","Height80":"interview-stages_Height80__NAN_g","Browse__ButtonFlexEnd":"interview-stages_Browse__ButtonFlexEnd__qv1w9","AddAgency__Container":"interview-stages_AddAgency__Container__gjvqn","AddAgency__FormInputSection":"interview-stages_AddAgency__FormInputSection__49S44","AddAgency__FormInputSection__Label":"interview-stages_AddAgency__FormInputSection__Label__otxdo","AddAgency__Form":"interview-stages_AddAgency__Form__z_Nat","LinkAsButtons":"interview-stages_LinkAsButtons__Wbe6o","SearchFlex":"interview-stages_SearchFlex__r8EDW","Form__ErrorCustomSelect":"interview-stages_Form__ErrorCustomSelect__chbcM","Form__select_currency":"interview-stages_Form__select_currency__Ukml1","customSelect__placeholder":"interview-stages_customSelect__placeholder__UtR6w","Career":"interview-stages_Career__F_aSk","Career__Background_Edit":"interview-stages_Career__Background_Edit__OOigD","Career__Background_Edit_Image":"interview-stages_Career__Background_Edit_Image__ISnbA","Career__Container":"interview-stages_Career__Container__MOk0a","Career__Inner":"interview-stages_Career__Inner__Kwcib","Career__logo":"interview-stages_Career__logo__sR7p9","Career__Content":"interview-stages_Career__Content__rrJUX","Career__ButtonSection":"interview-stages_Career__ButtonSection__zo4zq","Job":"interview-stages_Job__eMHf7","Job__Inner":"interview-stages_Job__Inner__JTECj","Job__Container":"interview-stages_Job__Container__SZz7A","Job__Heading":"interview-stages_Job__Heading__iwbPu","Job__Company":"interview-stages_Job__Company__aDt6Z","Job__SearchContainer":"interview-stages_Job__SearchContainer__oIPJX","Job__SearchInput":"interview-stages_Job__SearchInput__qePTx","Job__Searchbtn":"interview-stages_Job__Searchbtn__JI93s","Job__Input":"interview-stages_Job__Input__8pS0H","Job__SelectJob":"interview-stages_Job__SelectJob__v_kaF","Job__RemoteLabel":"interview-stages_Job__RemoteLabel__OQEnZ","Job__Display":"interview-stages_Job__Display__49M3M","Job__PostDay":"interview-stages_Job__PostDay__K2hc8","Job__Title":"interview-stages_Job__Title__3ikYI","Job__Location":"interview-stages_Job__Location__WFUD_","DT":"interview-stages_DT__TEeWS","DisplayTable":"interview-stages_DisplayTable__df8zL","pd11":"interview-stages_pd11__Pvy_G","Label":"interview-stages_Label__12b_w","inputwidth":"interview-stages_inputwidth__bnVEJ","mr24":"interview-stages_mr24__UtIsS","fullwidth":"interview-stages_fullwidth__ucDXU","padt40":"interview-stages_padt40__RI3kq","Form__TableRowflex":"interview-stages_Form__TableRowflex__83OjJ","Form__TableColm":"interview-stages_Form__TableColm__Llstf","Form__LabelCheck":"interview-stages_Form__LabelCheck__HwK4U","Form__Error":"interview-stages_Form__Error__6vSCi","Form__ErrorSection":"interview-stages_Form__ErrorSection__d0lCj","Form__MessagePlaceholder":"interview-stages_Form__MessagePlaceholder__k8P7K","Form__Submit":"interview-stages_Form__Submit__9gW4I","Form__NormalLabel":"interview-stages_Form__NormalLabel__j6GnV","AddInterview":"interview-stages_AddInterview__3kUoG","IntegrationPage":"interview-stages_IntegrationPage__btcj_","Integration__BackStep":"interview-stages_Integration__BackStep__wRDD9","AddUsers__BackStep":"interview-stages_AddUsers__BackStep__v1E7l","Integration__SubmitSection":"interview-stages_Integration__SubmitSection__qqjC7","IntegrationTable":"interview-stages_IntegrationTable__F_CKH","IntegrationTable__LimitInput":"interview-stages_IntegrationTable__LimitInput__kSE1w","IntegrationTable__Type":"interview-stages_IntegrationTable__Type__w6mGT","IntegrationTable__AllJobsToggle":"interview-stages_IntegrationTable__AllJobsToggle__IXWOD","IntegrationTable__switch":"interview-stages_IntegrationTable__switch__8SvcH","IntegrationTable__switchText":"interview-stages_IntegrationTable__switchText__QTQt3","IntegrationTable__slider":"interview-stages_IntegrationTable__slider__68sgl","IntegrationTable__round":"interview-stages_IntegrationTable__round__nAu4e","IntegrationTable__Action":"interview-stages_IntegrationTable__Action__YSLBL","IntegrationView":"interview-stages_IntegrationView__NK2ab","IntegrationView__Title":"interview-stages_IntegrationView__Title__NTUmE","IntegrationView__Subheading":"interview-stages_IntegrationView__Subheading__hynVi","IntegrationView__BoxImage":"interview-stages_IntegrationView__BoxImage__ta1PN","IntegrationView__Box":"interview-stages_IntegrationView__Box__ymT44","IntegrationView__BoxImage__InfoIcon":"interview-stages_IntegrationView__BoxImage__InfoIcon__usMBT","IntegrationView__ViewMoreButton":"interview-stages_IntegrationView__ViewMoreButton__TaefX","IntegrationView__ConnectButton":"interview-stages_IntegrationView__ConnectButton__kxd9Z","IntegrationView__GoogleButton":"interview-stages_IntegrationView__GoogleButton__nqO66","IntegrationView__FlexFlow":"interview-stages_IntegrationView__FlexFlow__QTnrE","IntegrationView__BoxWidth":"interview-stages_IntegrationView__BoxWidth__FXalM","SkipFinishButton":"interview-stages_SkipFinishButton__p1pG6","AddUsers":"interview-stages_AddUsers__X_qqa","AddUsers__ButtonSection":"interview-stages_AddUsers__ButtonSection__C0A7r","AddUsers__QuickStepHeading":"interview-stages_AddUsers__QuickStepHeading__tg7vm","AddUsers__DeleteSection":"interview-stages_AddUsers__DeleteSection__4B115","Interview__DeleteSection":"interview-stages_Interview__DeleteSection__AxGZZ","AddUsers__DeleteCrossHeight":"interview-stages_AddUsers__DeleteCrossHeight__VpgzF","AddUsers__Form__Input":"interview-stages_AddUsers__Form__Input__wc_3F","AddUsers__FormHeadingSection":"interview-stages_AddUsers__FormHeadingSection__d3zvD","Interview__FormHeadingSection":"interview-stages_Interview__FormHeadingSection__h64r8","AddUsers__FormSection":"interview-stages_AddUsers__FormSection__y_GPy","NewJob__FormSection":"interview-stages_NewJob__FormSection__aN5E3","AddUsers__ButtonsActionSection":"interview-stages_AddUsers__ButtonsActionSection__QNVZ8","AddUsers__ImportUsers":"interview-stages_AddUsers__ImportUsers__sPW0b","AddUsers__NameInput":"interview-stages_AddUsers__NameInput__CDm69","AddUsers__EmailInput":"interview-stages_AddUsers__EmailInput__DPeIC","AddUsers__RoleInput":"interview-stages_AddUsers__RoleInput__c_cZ2","AddUsers__Subheading":"interview-stages_AddUsers__Subheading___c8JL","AddUsers__visible":"interview-stages_AddUsers__visible__Mb1A6","Tagrow":"interview-stages_Tagrow__FfzdH","Tagrow__Tags":"interview-stages_Tagrow__Tags__0Et72","Tagrow__Cancel":"interview-stages_Tagrow__Cancel__Hv0RV","Tagrow__Cross":"interview-stages_Tagrow__Cross__b9tH_","SendInviteSection":"interview-stages_SendInviteSection__gYQiM","error":"interview-stages_error___9gz9","ViewJobPage__Input":"interview-stages_ViewJobPage__Input__5x4zl","Form__Input2":"interview-stages_Form__Input2__tv8xi","ViewJobPage__PostDay":"interview-stages_ViewJobPage__PostDay__0ptig","ViewJobPage__Title":"interview-stages_ViewJobPage__Title__tLN_e","ViewJobPage__DescriptionTitle":"interview-stages_ViewJobPage__DescriptionTitle__7YNcq","ViewJobPage__Location":"interview-stages_ViewJobPage__Location__VRsGf","ViewJobPage__primarybtn":"interview-stages_ViewJobPage__primarybtn__6ZPxy","ViewJobPage__secondarybtn":"interview-stages_ViewJobPage__secondarybtn__d01FF","ViewJobPage__secondarybtnborder":"interview-stages_ViewJobPage__secondarybtnborder__hQ1tg","ViewJobPage__BackSection":"interview-stages_ViewJobPage__BackSection__290Nv","Modalpopup":"interview-stages_Modalpopup__j1Rt_","Modalpopup__inner":"interview-stages_Modalpopup__inner__x_5bS","Modalpopup__Dialog":"interview-stages_Modalpopup__Dialog___a5Ke","transition":"interview-stages_transition__AREXw","Modalpopup__CloseCenter":"interview-stages_Modalpopup__CloseCenter__S7YCO","Modalpopup__Content":"interview-stages_Modalpopup__Content__z8fGs","ViewJobPage__Content":"interview-stages_ViewJobPage__Content__ElYrS","Modalpopup__btn":"interview-stages_Modalpopup__btn__O_zi7","mar":"interview-stages_mar__TwaSX","Otpback":"interview-stages_Otpback__Bku4y","ViewJobPage":"interview-stages_ViewJobPage__5L4ig","ViewJobPage__Header":"interview-stages_ViewJobPage__Header__4qj3N","ViewJobPage__Application":"interview-stages_ViewJobPage__Application__ieods","ViewJobPage__RecordVideo":"interview-stages_ViewJobPage__RecordVideo__L1vNL","ViewJobPage__RecordVideoSuccessText":"interview-stages_ViewJobPage__RecordVideoSuccessText__HSC2w","ViewJobPage__subheading":"interview-stages_ViewJobPage__subheading__j_TIW","ViewJobPage__confirmation":"interview-stages_ViewJobPage__confirmation__nMtBe","ViewJobPage__Logo":"interview-stages_ViewJobPage__Logo__FQ7wU","ViewJobPage__BrandLogo":"interview-stages_ViewJobPage__BrandLogo__MOt_Z","ViewJobPage__BrandLogo__Padding10":"interview-stages_ViewJobPage__BrandLogo__Padding10__M9ggl","ViewJobPage__Container":"interview-stages_ViewJobPage__Container__nR4iX","ViewJobPage__JobContent":"interview-stages_ViewJobPage__JobContent__89Vsk","ViewJobPage__Sidebar":"interview-stages_ViewJobPage__Sidebar__tYeFb","ViewJobPage__Sidebar2":"interview-stages_ViewJobPage__Sidebar2__4dyhE","ViewJobPage__Description":"interview-stages_ViewJobPage__Description__t_FlH","ViewJobPage__DescriptionWidth":"interview-stages_ViewJobPage__DescriptionWidth__y0_fu","ViewJobPage__Footer":"interview-stages_ViewJobPage__Footer__uP6tg","ViewJobPage__FooterView":"interview-stages_ViewJobPage__FooterView__I2lNI","ViewJobPage__ShareJob":"interview-stages_ViewJobPage__ShareJob__YHVll","ViewJobPage__SubmitSection":"interview-stages_ViewJobPage__SubmitSection__kj5Pq","ViewJobPage__SocialMedia":"interview-stages_ViewJobPage__SocialMedia__hCzF5","ViewJobPage__SideContent":"interview-stages_ViewJobPage__SideContent__wJu4A","ViewJobPage__ApplySection":"interview-stages_ViewJobPage__ApplySection__17uEg","FormBox__Autofill":"interview-stages_FormBox__Autofill__mP6JX","applybuttons":"interview-stages_applybuttons__of14K","height90":"interview-stages_height90__YmrNb","Form__Cont":"interview-stages_Form__Cont__hO8bO","Form__DropBox":"interview-stages_Form__DropBox__3at2m","Form__DropBoxcontainer":"interview-stages_Form__DropBoxcontainer__AwRLX","Form__DropBoxError":"interview-stages_Form__DropBoxError__8GmuL","Form__DropBoxicon":"interview-stages_Form__DropBoxicon__0PdUB","Form__DropBoxmessage":"interview-stages_Form__DropBoxmessage__UHodz","noDpGrid":"interview-stages_noDpGrid__6S5KH","Terms":"interview-stages_Terms__EfqV5","TermsCondition":"interview-stages_TermsCondition__ApDXB","TermsCondition__alignterms":"interview-stages_TermsCondition__alignterms__4_k3i","MenuContainer":"interview-stages_MenuContainer__rh5ch","MenuContainer__Menu":"interview-stages_MenuContainer__Menu__B8Tnz","AgencyDetailPage":"interview-stages_AgencyDetailPage__lFWsU","Congrats__ModalContent":"interview-stages_Congrats__ModalContent__N2rLU","NewJob__Container":"interview-stages_NewJob__Container___cXLL","NewJob__TopSection":"interview-stages_NewJob__TopSection__bu1F_","Interview__TopSection":"interview-stages_Interview__TopSection__1ZRWe","NewJob__HorizontalDivider":"interview-stages_NewJob__HorizontalDivider__gTneq","NewJob__Wrapper":"interview-stages_NewJob__Wrapper__U9Jvc","NewJob__ContainerPadding":"interview-stages_NewJob__ContainerPadding__S1mTs","NewJob__ContainerScroll":"interview-stages_NewJob__ContainerScroll__JELPP","NewJob__ContainerHeight":"interview-stages_NewJob__ContainerHeight____RjZ","NewJob__ImportAction":"interview-stages_NewJob__ImportAction__GqFmv","NewJob__Interview_buttons":"interview-stages_NewJob__Interview_buttons__cFmi3","Form__TableRowMB":"interview-stages_Form__TableRowMB__tOzZl","Form__TableRow3grid":"interview-stages_Form__TableRow3grid__XW69G","Form__Remotegrid":"interview-stages_Form__Remotegrid__Mge1f","Form__TypeList":"interview-stages_Form__TypeList__iPI5t","Form__Type":"interview-stages_Form__Type__URbv0","Form__CheckLabel":"interview-stages_Form__CheckLabel__5NrzB","PrivateSwitchBase-root-1":"interview-stages_PrivateSwitchBase-root-1___1DuM","Form__Caption":"interview-stages_Form__Caption__FGp0f","Form__Input_currency":"interview-stages_Form__Input_currency__BTefi","Form__Input_MatchScore":"interview-stages_Form__Input_MatchScore__Bl_SU","Form__Percentage_Symbol":"interview-stages_Form__Percentage_Symbol__7lX58","Form__NoGridTemplate":"interview-stages_Form__NoGridTemplate__kCjeS","active":"interview-stages_active__XYuvX","mt10":"interview-stages_mt10__9CiNN","mt40":"interview-stages_mt40__aNMNz","mt30":"interview-stages_mt30__VbWp6","mt32":"interview-stages_mt32__vDHt1","mb0":"interview-stages_mb0__Qbut8","Dpgrid":"interview-stages_Dpgrid__qX_cx","mb12":"interview-stages_mb12__drrxA","width100":"interview-stages_width100__qsob1","Tagrow__Prefix":"interview-stages_Tagrow__Prefix__P61G_","PreviewJobPage":"interview-stages_PreviewJobPage__X4_bl","PreviewJob":"interview-stages_PreviewJob__13eHR","DpFlx":"interview-stages_DpFlx__NE4IZ","Subheading":"interview-stages_Subheading__OXKJw","Subheading__Description":"interview-stages_Subheading__Description__bzdQ_","Candidate__Tooltip":"interview-stages_Candidate__Tooltip__KV0Tr","Candidate__Tooltip__Score":"interview-stages_Candidate__Tooltip__Score__Q6NZ3","Form__InputField":"interview-stages_Form__InputField__4GYg_","Candidate__Length":"interview-stages_Candidate__Length__P8Pxx","Agency__PostDay":"interview-stages_Agency__PostDay__zxYzW","Agency__Title":"interview-stages_Agency__Title__aEeU4","Agency__Location":"interview-stages_Agency__Location__7nJUN","Agency__DescriptionTitle":"interview-stages_Agency__DescriptionTitle__8O_Gq","Agency__Description":"interview-stages_Agency__Description__RdtN3","LightBlueColor":"interview-stages_LightBlueColor__zjU7L","Client_Page":"interview-stages_Client_Page__sCTnD","Welcome":"interview-stages_Welcome__hwlWM","Welcome__Inner":"interview-stages_Welcome__Inner__PlcmI","Welcome__Person":"interview-stages_Welcome__Person__KlZVn","Welcome__LeftContent":"interview-stages_Welcome__LeftContent__LLRzM","Welcome__RightContent":"interview-stages_Welcome__RightContent__CpxJi","Welcome__Content":"interview-stages_Welcome__Content__k4y4L","Welcome__CreateAccount":"interview-stages_Welcome__CreateAccount__vCujj","Welcome__title":"interview-stages_Welcome__title__KL3yn","Welcome__FormBox":"interview-stages_Welcome__FormBox__vucyS","Form__psw":"interview-stages_Form__psw__L3lBw","Welcome__Container":"interview-stages_Welcome__Container__bBfKG","Success__Container":"interview-stages_Success__Container__TCeGk","Success":"interview-stages_Success__BZhIg","Success__Inner":"interview-stages_Success__Inner__vWTH6","InterviewContainer":"interview-stages_InterviewContainer__iv_wN","Interview__Stages":"interview-stages_Interview__Stages___0DiQ","Interview__StageHeading":"interview-stages_Interview__StageHeading__ZXHmE","pl10":"interview-stages_pl10__U0OUX","Interview__AddStageSection":"interview-stages_Interview__AddStageSection__L8C7q","Interview__Label":"interview-stages_Interview__Label__VMBHv","Interview__FormRowHeading":"interview-stages_Interview__FormRowHeading__lDz0F","dpflex":"interview-stages_dpflex__fvkyI","Interview__IconsType":"interview-stages_Interview__IconsType__1XiFw","Interview__Icons":"interview-stages_Interview__Icons__kcLc5","Interview__Interview_buttons":"interview-stages_Interview__Interview_buttons__SiP0z","Interview__approvalButton":"interview-stages_Interview__approvalButton__cjcDx","Interview__BestMatch":"interview-stages_Interview__BestMatch__GL1dY","Interview__BestMatchExclamation":"interview-stages_Interview__BestMatchExclamation__QsFwT","DragAndDrop":"interview-stages_DragAndDrop__fjto4","DragAndDrop__CursorHandle":"interview-stages_DragAndDrop__CursorHandle__tkhLx","Tagrow__Image":"interview-stages_Tagrow__Image__EUfbn","rowbglight":"interview-stages_rowbglight__EO7aE","rowbgheight":"interview-stages_rowbgheight__jRlqE","Form__w90":"interview-stages_Form__w90__yskcC","Container":"interview-stages_Container__dwsVV","Screening__StageName":"interview-stages_Screening__StageName__4CLUm","Screening__InterviewType":"interview-stages_Screening__InterviewType__xXJXk","Screening__InterviewType__Label":"interview-stages_Screening__InterviewType__Label__6SiDT","Show_Infoicon":"interview-stages_Show_Infoicon__siuTG","Show_Infoicon_small":"interview-stages_Show_Infoicon_small__FUgsC","Screening__Info":"interview-stages_Screening__Info__nUNS7","Screening__Info__IconWithText":"interview-stages_Screening__Info__IconWithText__C43vx","InterviewType__Icon":"interview-stages_InterviewType__Icon__tP2ih","InterviewType__Text":"interview-stages_InterviewType__Text__kaGcf"};

/***/ }),

/***/ 98071:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Tagrow":"invite-admin_Tagrow__gxDT0","Tagrow__Tags":"invite-admin_Tagrow__Tags__zdnEo","Tagrow__Cancel":"invite-admin_Tagrow__Cancel__b11ew","SendInviteSection":"invite-admin_SendInviteSection__9f2fW","error":"invite-admin_error__65sYk"};

/***/ }),

/***/ 67019:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"job-options_Form__upoOI","Form__width":"job-options_Form__width__cKtzY","Form__label":"job-options_Form__label__zVgbB","Form__textleft":"job-options_Form__textleft__QHzI0","Form__InputFullWidth":"job-options_Form__InputFullWidth__eZ1QV","Form__Input":"job-options_Form__Input__3TvA6","ScreeningQuestions__BoxInput":"job-options_ScreeningQuestions__BoxInput__b3Z_V","Form__InputSection":"job-options_Form__InputSection__Fe0gQ","Form__ScoreCardInput":"job-options_Form__ScoreCardInput__ggASd","Form__Textarea":"job-options_Form__Textarea__22K56","Form__CustomSelect":"job-options_Form__CustomSelect__pZbTj","Form__ErrorCustomSelect":"job-options_Form__ErrorCustomSelect__FaEMK","Form__currency_symbol":"job-options_Form__currency_symbol__V4jx6","Form__select_currency":"job-options_Form__select_currency__YPBZt","customSelect__placeholder":"job-options_customSelect__placeholder__paY0U","primarybtn":"job-options_primarybtn__6nRxP","secondarybtn":"job-options_secondarybtn__VF3Pw","iconFilled":"job-options_iconFilled__hOE06","iconFilledSolid":"job-options_iconFilledSolid__c_Uoz","primarybtnborder":"job-options_primarybtnborder__pK1uk","secondarybtnborder":"job-options_secondarybtnborder__33tv4","tertiarybtn":"job-options_tertiarybtn__uWvws","graybtnborder":"job-options_graybtnborder__JnbQR","jobsrchbtn":"job-options_jobsrchbtn__8X9AG","jobsrchbtnalign":"job-options_jobsrchbtnalign__bwZ2E","nobgbutton":"job-options_nobgbutton__1cf81","iconTextButton":"job-options_iconTextButton__pgZlI","cursornone":"job-options_cursornone__aC6tx","nobgbuttonprimary":"job-options_nobgbuttonprimary__O0Zwd","mt15":"job-options_mt15__R5t0h","btn350":"job-options_btn350__5VBB6","GrayBgBtn":"job-options_GrayBgBtn__bkrx_","NewShareBtn":"job-options_NewShareBtn__dG6nc","CoralBgBtn":"job-options_CoralBgBtn__CoDzi","JobOptions":"job-options_JobOptions__k_zWJ","JobOptions__Container":"job-options_JobOptions__Container__9e1vq","JobOptions__ContainerScroll":"job-options_JobOptions__ContainerScroll__xEI_J","JobOptions__ContainerHeight":"job-options_JobOptions__ContainerHeight__xCBpt","ScreeningQuestions":"job-options_ScreeningQuestions__W730n","ScreeningQuestions__Subheading":"job-options_ScreeningQuestions__Subheading__tpPMP","ScreeningQuestions__Description":"job-options_ScreeningQuestions__Description__9Lo77","ScreeningQuestions__Box":"job-options_ScreeningQuestions__Box__F3oDe","ScreeningQuestions__BoxForm":"job-options_ScreeningQuestions__BoxForm__oL2Om","ScreeningQuestions__BoxLabels":"job-options_ScreeningQuestions__BoxLabels__oEdBC","ScreeningQuestions__Remove":"job-options_ScreeningQuestions__Remove__4D65m","ScreeningQuestions__BoxLabel":"job-options_ScreeningQuestions__BoxLabel__LAbNU","ScreeningQuestions__BoxChoiceButton":"job-options_ScreeningQuestions__BoxChoiceButton__Zxc_L","ScreeningQuestions__BoxSelect":"job-options_ScreeningQuestions__BoxSelect__IfqnT","ScreeningQuestions__ToggleSwitch":"job-options_ScreeningQuestions__ToggleSwitch__lvu4X","ScreeningQuestions__Switch":"job-options_ScreeningQuestions__Switch__9L_VS","ScreeningQuestions__Slider":"job-options_ScreeningQuestions__Slider__E0Fy7","Form__TableRow":"job-options_Form__TableRow__e5522","Form__TableCol":"job-options_Form__TableCol__B_9de"};

/***/ }),

/***/ 25385:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"job-sharing_Form__wX2ZA","Form__width":"job-sharing_Form__width__uoBzo","Form__label":"job-sharing_Form__label__P22Wc","Form__textleft":"job-sharing_Form__textleft__7pgyK","Form__InputFullWidth":"job-sharing_Form__InputFullWidth__ugMuU","Form__Input":"job-sharing_Form__Input__V06f_","Form__Input398":"job-sharing_Form__Input398__BhDmo","Form__InputSection":"job-sharing_Form__InputSection__Ed6fi","Form__ScoreCardInput":"job-sharing_Form__ScoreCardInput__XKdsI","Form__Textarea":"job-sharing_Form__Textarea__Hbpxu","primarybtn":"job-sharing_primarybtn__spSPZ","GoBtn":"job-sharing_GoBtn__1FJN_","secondarybtn":"job-sharing_secondarybtn__STiNV","iconFilled":"job-sharing_iconFilled__SaLJ4","iconFilledSolid":"job-sharing_iconFilledSolid__b_Yum","primarybtnborder":"job-sharing_primarybtnborder__giUBp","secondarybtnborder":"job-sharing_secondarybtnborder__E5_bn","ClearBtn":"job-sharing_ClearBtn__OrSr4","tertiarybtn":"job-sharing_tertiarybtn__iw96N","graybtnborder":"job-sharing_graybtnborder__MZRSP","jobsrchbtn":"job-sharing_jobsrchbtn__arY8T","jobsrchbtnalign":"job-sharing_jobsrchbtnalign___JanA","nobgbutton":"job-sharing_nobgbutton__KT6Pm","iconTextButton":"job-sharing_iconTextButton__UuZX8","cursornone":"job-sharing_cursornone__foSPC","nobgbuttonprimary":"job-sharing_nobgbuttonprimary__UUPXv","mt15":"job-sharing_mt15__VRD6_","btn350":"job-sharing_btn350__hBon4","GrayBgBtn":"job-sharing_GrayBgBtn__VG6os","NewShareBtn":"job-sharing_NewShareBtn__wlq1j","CoralBgBtn":"job-sharing_CoralBgBtn__kLQzw","DropContainer":"job-sharing_DropContainer__Ssbo6","DropContainer__Inner":"job-sharing_DropContainer__Inner__C2gVg","CompanyProfile__Inner":"job-sharing_CompanyProfile__Inner__M9EKU","DropContainer__Message":"job-sharing_DropContainer__Message__b6ePN","CompanyProfile__Message":"job-sharing_CompanyProfile__Message__aWlIR","CompanyProfile__MessageContent":"job-sharing_CompanyProfile__MessageContent___Oi7D","DropContainer__UploadIcon":"job-sharing_DropContainer__UploadIcon___Ow2I","CompanyProfile__UploadIcon":"job-sharing_CompanyProfile__UploadIcon__s7_Qp","FileDisplayContainer":"job-sharing_FileDisplayContainer__jRp9_","FileDisplayContainer__Status":"job-sharing_FileDisplayContainer__Status__exO6T","FileDisplayContainer__Type":"job-sharing_FileDisplayContainer__Type__P82oF","FileDisplayContainer__Name":"job-sharing_FileDisplayContainer__Name__yRG24","FileDisplayContainer__Error":"job-sharing_FileDisplayContainer__Error__tnmXa","FileDisplayContainer__Close":"job-sharing_FileDisplayContainer__Close__6_Yjo","Browse":"job-sharing_Browse__pDmrN","ClientCompany":"job-sharing_ClientCompany___Sp1b","NewJob":"job-sharing_NewJob__RxfJF","Interview":"job-sharing_Interview__HFwWu","ClientCompany__TopSection2":"job-sharing_ClientCompany__TopSection2__pk7TM","ClientCompany__Filter":"job-sharing_ClientCompany__Filter__yRLac","ClientCompany__Input_MatchScore":"job-sharing_ClientCompany__Input_MatchScore__GbYMN","ClientCompany__Percentage_Symbol":"job-sharing_ClientCompany__Percentage_Symbol__K7Z5t","ClientCompany__Filterheading":"job-sharing_ClientCompany__Filterheading__gmg8r","ClientCompany__FloatButtonAdd":"job-sharing_ClientCompany__FloatButtonAdd__BtAds","ClientCompany__FloatButtonAdd__AgencyUserIcon":"job-sharing_ClientCompany__FloatButtonAdd__AgencyUserIcon__RCaje","ClientCompany__LastEdited":"job-sharing_ClientCompany__LastEdited__9NoOT","ClientCompany__BackSection":"job-sharing_ClientCompany__BackSection__i64LY","AddUsers__BackSection":"job-sharing_AddUsers__BackSection__LPOFz","ClientCompany__BackSection__CloseIcon":"job-sharing_ClientCompany__BackSection__CloseIcon__7J5V8","ClientCompany__Container":"job-sharing_ClientCompany__Container__cl0Ip","NewJob__InterviewContainer":"job-sharing_NewJob__InterviewContainer____fi8","AddUsers__Container":"job-sharing_AddUsers__Container__Oq318","ClientCompany__FormInputSection":"job-sharing_ClientCompany__FormInputSection__NWwdk","CompanyProfile__FormInputSection":"job-sharing_CompanyProfile__FormInputSection__bIq39","ClientCompany__Heading":"job-sharing_ClientCompany__Heading__SUnZE","AddUsers__Heading":"job-sharing_AddUsers__Heading__9pLD4","ClientCompany__StatusAlignment":"job-sharing_ClientCompany__StatusAlignment__0GyCk","ClientCompany__Status":"job-sharing_ClientCompany__Status__BeGzU","ClientCompany__ActiveDot":"job-sharing_ClientCompany__ActiveDot__PTltD","ClientCompany__CloseDot":"job-sharing_ClientCompany__CloseDot__YnMEy","ClientCompany__Company":"job-sharing_ClientCompany__Company__WRt0D","AddUsers__User":"job-sharing_AddUsers__User__8DqvG","ClientCompany__Systemrefheding":"job-sharing_ClientCompany__Systemrefheding__Vm1fr","ClientCompany__Subheading":"job-sharing_ClientCompany__Subheading__GTg0a","CompanyProfile__Subheading":"job-sharing_CompanyProfile__Subheading__HLM4V","ClientCompany__Subheading2":"job-sharing_ClientCompany__Subheading2__wOmA6","ClientCompany__Description":"job-sharing_ClientCompany__Description__sV_Cd","ClientCompany__SubmitSection":"job-sharing_ClientCompany__SubmitSection__vm_MN","NewJob__SubmitSection":"job-sharing_NewJob__SubmitSection__SOX1_","NewJob__SubmitSectionThreeBtn":"job-sharing_NewJob__SubmitSectionThreeBtn__84270","NewJob__SubmitSectionOneBtnPlacement":"job-sharing_NewJob__SubmitSectionOneBtnPlacement__s1xeB","NewJob__ImportSection":"job-sharing_NewJob__ImportSection__5bc8u","AddUsers__SubmitSection":"job-sharing_AddUsers__SubmitSection__PKc8y","ClientCompany__IntegrationImage":"job-sharing_ClientCompany__IntegrationImage___cUPQ","ClientCompany__QuickAdd":"job-sharing_ClientCompany__QuickAdd__rPxxM","NewJob__QuickAdd":"job-sharing_NewJob__QuickAdd__U8HOC","Interview__QuickAdd":"job-sharing_Interview__QuickAdd__4x_o6","ClientCompany__BodyText":"job-sharing_ClientCompany__BodyText__6HWqy","Form__TableRow":"job-sharing_Form__TableRow__9V52r","Form__Label":"job-sharing_Form__Label__h8h2E","Sharing__Label":"job-sharing_Sharing__Label__1EXlP","Form__FloatingLabel":"job-sharing_Form__FloatingLabel___pg7a","Form__TableCol":"job-sharing_Form__TableCol__IaZq3","Form__currency_symbol":"job-sharing_Form__currency_symbol__0CegA","Form__CustomSelect":"job-sharing_Form__CustomSelect__SHLwS","Form__currency_symbol__right":"job-sharing_Form__currency_symbol__right__zEVRX","Form__TableCol__Disabled":"job-sharing_Form__TableCol__Disabled__huvSB","Form__TextareaDisabled":"job-sharing_Form__TextareaDisabled__KYpBU","Form__EditorDisabled":"job-sharing_Form__EditorDisabled__4o1Vi","Form__AdminCheckLabel":"job-sharing_Form__AdminCheckLabel__xNORo","Form__AdminCheckMargin":"job-sharing_Form__AdminCheckMargin__NO9rW","CompanyProfile__BrandingGuide":"job-sharing_CompanyProfile__BrandingGuide__nGmi5","CompanyProfile__DropBoxContainer":"job-sharing_CompanyProfile__DropBoxContainer__Pe81B","CompanyProfile__Browse":"job-sharing_CompanyProfile__Browse__xAgrU","ErrorLabel":"job-sharing_ErrorLabel__cnhqB","Height80":"job-sharing_Height80__mK_2Y","Browse__ButtonFlexEnd":"job-sharing_Browse__ButtonFlexEnd__iMRf3","AddAgency__Container":"job-sharing_AddAgency__Container__EEYVU","AddAgency__FormInputSection":"job-sharing_AddAgency__FormInputSection__iALYJ","AddAgency__FormInputSection__Label":"job-sharing_AddAgency__FormInputSection__Label__zz835","AddAgency__Form":"job-sharing_AddAgency__Form__4_RPu","LinkAsButtons":"job-sharing_LinkAsButtons__fWMx7","SearchFlex":"job-sharing_SearchFlex__6RcJD","IntegrationPage":"job-sharing_IntegrationPage__4xHQh","Integration__BackStep":"job-sharing_Integration__BackStep__cqb9k","AddUsers__BackStep":"job-sharing_AddUsers__BackStep__ma4e_","Integration__SubmitSection":"job-sharing_Integration__SubmitSection__qRU5d","IntegrationTable":"job-sharing_IntegrationTable__5T0MS","IntegrationTable__LimitInput":"job-sharing_IntegrationTable__LimitInput__IqBSD","IntegrationTable__Type":"job-sharing_IntegrationTable__Type___G4tk","IntegrationTable__AllJobsToggle":"job-sharing_IntegrationTable__AllJobsToggle__oDxjX","IntegrationTable__switch":"job-sharing_IntegrationTable__switch__TR76e","IntegrationTable__switchText":"job-sharing_IntegrationTable__switchText__7iP0C","IntegrationTable__slider":"job-sharing_IntegrationTable__slider__Y04oZ","IntegrationTable__round":"job-sharing_IntegrationTable__round__k_B7u","IntegrationTable__Action":"job-sharing_IntegrationTable__Action__8t6mZ","IntegrationView":"job-sharing_IntegrationView__jGSiy","IntegrationView__Title":"job-sharing_IntegrationView__Title__J1LIW","IntegrationView__Subheading":"job-sharing_IntegrationView__Subheading__iGxau","IntegrationView__BoxImage":"job-sharing_IntegrationView__BoxImage__jWu6y","IntegrationView__Box":"job-sharing_IntegrationView__Box__5DbpG","IntegrationView__BoxImage__InfoIcon":"job-sharing_IntegrationView__BoxImage__InfoIcon__IbKoD","IntegrationView__ViewMoreButton":"job-sharing_IntegrationView__ViewMoreButton__1X7sZ","IntegrationView__ConnectButton":"job-sharing_IntegrationView__ConnectButton__kLZAy","IntegrationView__GoogleButton":"job-sharing_IntegrationView__GoogleButton__kss38","IntegrationView__FlexFlow":"job-sharing_IntegrationView__FlexFlow__ZNgJw","IntegrationView__BoxWidth":"job-sharing_IntegrationView__BoxWidth__qslB9","SkipFinishButton":"job-sharing_SkipFinishButton__OOKpc","Form__LabelCheck":"job-sharing_Form__LabelCheck__Qhby_","Form__Error":"job-sharing_Form__Error__JQkdC","Form__ErrorSection":"job-sharing_Form__ErrorSection__63tqs","Form__MessagePlaceholder":"job-sharing_Form__MessagePlaceholder__g9n3_","Form__Submit":"job-sharing_Form__Submit__Ov3VG","Form__NormalLabel":"job-sharing_Form__NormalLabel__zCy8n","AddInterview":"job-sharing_AddInterview__6ujqp","Form__ErrorCustomSelect":"job-sharing_Form__ErrorCustomSelect__nCYDl","Form__select_currency":"job-sharing_Form__select_currency__sR1CH","customSelect__placeholder":"job-sharing_customSelect__placeholder__kzm3Q","Career":"job-sharing_Career__PpoDl","Career__Background_Edit":"job-sharing_Career__Background_Edit__1Uhte","Career__Background_Edit_Image":"job-sharing_Career__Background_Edit_Image__DbY2B","Career__Container":"job-sharing_Career__Container__1L1Ic","Career__Inner":"job-sharing_Career__Inner__LGg6d","Career__logo":"job-sharing_Career__logo__D_hmF","Career__Content":"job-sharing_Career__Content__5DKid","Career__ButtonSection":"job-sharing_Career__ButtonSection__l3Szp","Job":"job-sharing_Job__6Smgh","Job__Inner":"job-sharing_Job__Inner__AKUrt","Job__Container":"job-sharing_Job__Container__jPr9A","Job__Heading":"job-sharing_Job__Heading__8xy_x","Job__Company":"job-sharing_Job__Company__WVhK4","Job__SearchContainer":"job-sharing_Job__SearchContainer__qzbii","Job__SearchInput":"job-sharing_Job__SearchInput__pCyao","Job__Searchbtn":"job-sharing_Job__Searchbtn__UtACs","Job__Input":"job-sharing_Job__Input__iL_fv","Job__SelectJob":"job-sharing_Job__SelectJob__6EQIA","Job__RemoteLabel":"job-sharing_Job__RemoteLabel__SSFIY","Job__Display":"job-sharing_Job__Display__p_pEA","Job__PostDay":"job-sharing_Job__PostDay__qjeBX","Job__Title":"job-sharing_Job__Title__ykcbq","Job__Location":"job-sharing_Job__Location__i_YHH","DT":"job-sharing_DT__kEewr","DisplayTable":"job-sharing_DisplayTable___FjEG","pd11":"job-sharing_pd11__twrqN","Label":"job-sharing_Label__U50Yo","inputwidth":"job-sharing_inputwidth__yCbie","mr24":"job-sharing_mr24__1_FJp","fullwidth":"job-sharing_fullwidth__Fr82W","padt40":"job-sharing_padt40__Au6IC","Form__TableRowflex":"job-sharing_Form__TableRowflex__6RcvH","Form__TableColm":"job-sharing_Form__TableColm__XT0Yx","AddUsers":"job-sharing_AddUsers__2XkOk","AddUsers__ButtonSection":"job-sharing_AddUsers__ButtonSection__Ph4jw","AddUsers__QuickStepHeading":"job-sharing_AddUsers__QuickStepHeading__kDEF5","AddUsers__DeleteSection":"job-sharing_AddUsers__DeleteSection__j1ktL","Interview__DeleteSection":"job-sharing_Interview__DeleteSection__p0L1C","AddUsers__DeleteCrossHeight":"job-sharing_AddUsers__DeleteCrossHeight__Y7rdO","AddUsers__Form__Input":"job-sharing_AddUsers__Form__Input__W_tCr","AddUsers__FormHeadingSection":"job-sharing_AddUsers__FormHeadingSection__Dhor3","Interview__FormHeadingSection":"job-sharing_Interview__FormHeadingSection__awakR","AddUsers__FormSection":"job-sharing_AddUsers__FormSection__9g87_","NewJob__FormSection":"job-sharing_NewJob__FormSection___zQWm","AddUsers__ButtonsActionSection":"job-sharing_AddUsers__ButtonsActionSection__0kjt7","AddUsers__ImportUsers":"job-sharing_AddUsers__ImportUsers__WA0l7","AddUsers__NameInput":"job-sharing_AddUsers__NameInput__J0X84","AddUsers__EmailInput":"job-sharing_AddUsers__EmailInput__J1u1w","AddUsers__RoleInput":"job-sharing_AddUsers__RoleInput__867Ti","AddUsers__Subheading":"job-sharing_AddUsers__Subheading__mbs_s","AddUsers__visible":"job-sharing_AddUsers__visible__y_FfO","Tagrow":"job-sharing_Tagrow__3nFmK","Tagrow__Tags":"job-sharing_Tagrow__Tags__jYhOD","Tagrow__Cancel":"job-sharing_Tagrow__Cancel__hcpQj","Tagrow__Cross":"job-sharing_Tagrow__Cross__zGrJ1","SendInviteSection":"job-sharing_SendInviteSection__Nm50b","error":"job-sharing_error__BiAPT","ViewJobPage__Input":"job-sharing_ViewJobPage__Input__R7TGd","Form__Input2":"job-sharing_Form__Input2__oPbbF","ViewJobPage__PostDay":"job-sharing_ViewJobPage__PostDay__dAbwO","ViewJobPage__Title":"job-sharing_ViewJobPage__Title__coChY","ViewJobPage__DescriptionTitle":"job-sharing_ViewJobPage__DescriptionTitle__nZwQB","ViewJobPage__Location":"job-sharing_ViewJobPage__Location__N9Osr","ViewJobPage__primarybtn":"job-sharing_ViewJobPage__primarybtn__t_H8A","ViewJobPage__secondarybtn":"job-sharing_ViewJobPage__secondarybtn__GAfRP","ViewJobPage__secondarybtnborder":"job-sharing_ViewJobPage__secondarybtnborder__D2KUR","ViewJobPage__BackSection":"job-sharing_ViewJobPage__BackSection__synAX","Modalpopup":"job-sharing_Modalpopup__J54BT","Modalpopup__inner":"job-sharing_Modalpopup__inner__N6fsn","Modalpopup__Dialog":"job-sharing_Modalpopup__Dialog__bYZqX","transition":"job-sharing_transition__uLWaj","Modalpopup__CloseCenter":"job-sharing_Modalpopup__CloseCenter__4S4D7","Modalpopup__Content":"job-sharing_Modalpopup__Content__By0F4","ViewJobPage__Content":"job-sharing_ViewJobPage__Content__FQE7V","Modalpopup__btn":"job-sharing_Modalpopup__btn__2Xw00","mar":"job-sharing_mar__oYTBu","Otpback":"job-sharing_Otpback__htj_3","ViewJobPage":"job-sharing_ViewJobPage__Rs9gh","ViewJobPage__Header":"job-sharing_ViewJobPage__Header__ijJoY","ViewJobPage__Application":"job-sharing_ViewJobPage__Application__czeMW","ViewJobPage__RecordVideo":"job-sharing_ViewJobPage__RecordVideo__0SWuP","ViewJobPage__RecordVideoSuccessText":"job-sharing_ViewJobPage__RecordVideoSuccessText__4XLDg","ViewJobPage__subheading":"job-sharing_ViewJobPage__subheading__Ih3Cc","ViewJobPage__confirmation":"job-sharing_ViewJobPage__confirmation__MuD29","ViewJobPage__Logo":"job-sharing_ViewJobPage__Logo__KfIEb","ViewJobPage__BrandLogo":"job-sharing_ViewJobPage__BrandLogo__vV0T0","ViewJobPage__BrandLogo__Padding10":"job-sharing_ViewJobPage__BrandLogo__Padding10__9wjz6","ViewJobPage__Container":"job-sharing_ViewJobPage__Container__D4k3e","ViewJobPage__JobContent":"job-sharing_ViewJobPage__JobContent__UzYmt","ViewJobPage__Sidebar":"job-sharing_ViewJobPage__Sidebar__RNYy5","ViewJobPage__Sidebar2":"job-sharing_ViewJobPage__Sidebar2__3n6jh","ViewJobPage__Description":"job-sharing_ViewJobPage__Description__kwcw0","ViewJobPage__DescriptionWidth":"job-sharing_ViewJobPage__DescriptionWidth__muPDx","ViewJobPage__Footer":"job-sharing_ViewJobPage__Footer__ZUKeX","ViewJobPage__FooterView":"job-sharing_ViewJobPage__FooterView___OORA","ViewJobPage__ShareJob":"job-sharing_ViewJobPage__ShareJob__xOQnS","ViewJobPage__SubmitSection":"job-sharing_ViewJobPage__SubmitSection__RwpTP","ViewJobPage__SocialMedia":"job-sharing_ViewJobPage__SocialMedia__4xXhf","ViewJobPage__SideContent":"job-sharing_ViewJobPage__SideContent__7Lc6I","ViewJobPage__ApplySection":"job-sharing_ViewJobPage__ApplySection___JoTC","FormBox__Autofill":"job-sharing_FormBox__Autofill__9isIU","applybuttons":"job-sharing_applybuttons__FeTgR","height90":"job-sharing_height90__YG0Hb","Form__Cont":"job-sharing_Form__Cont__67pCX","Form__DropBox":"job-sharing_Form__DropBox__m_9CZ","Form__DropBoxcontainer":"job-sharing_Form__DropBoxcontainer___nMMA","Form__DropBoxError":"job-sharing_Form__DropBoxError__5QREf","Form__DropBoxicon":"job-sharing_Form__DropBoxicon__F_mCB","Form__DropBoxmessage":"job-sharing_Form__DropBoxmessage__lQxq_","noDpGrid":"job-sharing_noDpGrid__bq6FJ","Terms":"job-sharing_Terms__frWgV","TermsCondition":"job-sharing_TermsCondition__PMZ_r","TermsCondition__alignterms":"job-sharing_TermsCondition__alignterms__klqkC","MenuContainer":"job-sharing_MenuContainer__6U_JW","MenuContainer__Menu":"job-sharing_MenuContainer__Menu__Pp22j","AgencyDetailPage":"job-sharing_AgencyDetailPage__LPuTl","Congrats__ModalContent":"job-sharing_Congrats__ModalContent__DAGr1","NewJob__Container":"job-sharing_NewJob__Container__DqMtY","NewJob__TopSection":"job-sharing_NewJob__TopSection__2Dxtn","Interview__TopSection":"job-sharing_Interview__TopSection__zImex","NewJob__HorizontalDivider":"job-sharing_NewJob__HorizontalDivider__v0tw6","NewJob__Wrapper":"job-sharing_NewJob__Wrapper__SuRc1","NewJob__ContainerPadding":"job-sharing_NewJob__ContainerPadding__Qg5T0","NewJob__ContainerScroll":"job-sharing_NewJob__ContainerScroll__F0GBh","NewJob__ContainerHeight":"job-sharing_NewJob__ContainerHeight__2F69h","NewJob__ImportAction":"job-sharing_NewJob__ImportAction__UWxbb","NewJob__Interview_buttons":"job-sharing_NewJob__Interview_buttons__yfXqF","Form__TableRowMB":"job-sharing_Form__TableRowMB__sQuCB","Form__TableRow3grid":"job-sharing_Form__TableRow3grid__LMLMi","Form__Remotegrid":"job-sharing_Form__Remotegrid__My_vL","Form__TypeList":"job-sharing_Form__TypeList__My44K","Form__Type":"job-sharing_Form__Type__zUpr8","Form__CheckLabel":"job-sharing_Form__CheckLabel__kIA_s","PrivateSwitchBase-root-1":"job-sharing_PrivateSwitchBase-root-1__CMOOs","Form__Caption":"job-sharing_Form__Caption__pGMxk","Form__Input_currency":"job-sharing_Form__Input_currency__uRMKc","Form__Input_MatchScore":"job-sharing_Form__Input_MatchScore__j_X1r","Form__Percentage_Symbol":"job-sharing_Form__Percentage_Symbol__LdnCR","Form__NoGridTemplate":"job-sharing_Form__NoGridTemplate__HXChu","active":"job-sharing_active__YN01b","mt10":"job-sharing_mt10__08QRr","mt40":"job-sharing_mt40__HZwG_","mt30":"job-sharing_mt30__DGhXs","mt32":"job-sharing_mt32__bRDIR","mb0":"job-sharing_mb0__r_3rO","Dpgrid":"job-sharing_Dpgrid__0CLVo","mb12":"job-sharing_mb12__RKrj_","width100":"job-sharing_width100__qZXt1","Tagrow__Prefix":"job-sharing_Tagrow__Prefix__A9frh","PreviewJobPage":"job-sharing_PreviewJobPage__5vXhJ","PreviewJob":"job-sharing_PreviewJob__yGXm_","DpFlx":"job-sharing_DpFlx__bM8N3","Subheading":"job-sharing_Subheading__mleu6","Subheading__Description":"job-sharing_Subheading__Description__cMeYN","Candidate__Tooltip":"job-sharing_Candidate__Tooltip__M_IHo","Candidate__Tooltip__Score":"job-sharing_Candidate__Tooltip__Score__Sy94_","Form__InputField":"job-sharing_Form__InputField__CllRB","Candidate__Length":"job-sharing_Candidate__Length__9FJpO","Agency__PostDay":"job-sharing_Agency__PostDay__Ddktk","Agency__Title":"job-sharing_Agency__Title__Aj3v4","Agency__Location":"job-sharing_Agency__Location__oErTY","Agency__DescriptionTitle":"job-sharing_Agency__DescriptionTitle__4BoMc","Agency__Description":"job-sharing_Agency__Description__SGbMy","LightBlueColor":"job-sharing_LightBlueColor__c7o_9","Client_Page":"job-sharing_Client_Page__WAhqp","Welcome":"job-sharing_Welcome__sLpGg","Welcome__Inner":"job-sharing_Welcome__Inner__tpMIq","Welcome__Person":"job-sharing_Welcome__Person__S6Oli","Welcome__LeftContent":"job-sharing_Welcome__LeftContent__dH8BX","Welcome__RightContent":"job-sharing_Welcome__RightContent__H0bjI","Welcome__Content":"job-sharing_Welcome__Content__7i9gT","Welcome__CreateAccount":"job-sharing_Welcome__CreateAccount__gbf1g","Welcome__title":"job-sharing_Welcome__title__851dJ","Welcome__FormBox":"job-sharing_Welcome__FormBox__Vh60j","Form__psw":"job-sharing_Form__psw__LX07K","Welcome__Container":"job-sharing_Welcome__Container__KNdzX","Success__Container":"job-sharing_Success__Container__3Kh3x","Success":"job-sharing_Success__qFvz3","Success__Inner":"job-sharing_Success__Inner__DJcll","InterviewContainer":"job-sharing_InterviewContainer__zPVwF","Interview__Stages":"job-sharing_Interview__Stages__bcznQ","Interview__StageHeading":"job-sharing_Interview__StageHeading__kRHJV","pl10":"job-sharing_pl10__ZxlwA","Interview__AddStageSection":"job-sharing_Interview__AddStageSection__vXd59","Interview__Label":"job-sharing_Interview__Label__ixg1I","Interview__FormRowHeading":"job-sharing_Interview__FormRowHeading__4SwO6","dpflex":"job-sharing_dpflex__vPM0i","Interview__IconsType":"job-sharing_Interview__IconsType__Tbvk2","Sharing__IconsType":"job-sharing_Sharing__IconsType__bt0T3","Interview__Icons":"job-sharing_Interview__Icons__DZSBI","Interview__Interview_buttons":"job-sharing_Interview__Interview_buttons__wlg2k","Interview__approvalButton":"job-sharing_Interview__approvalButton__jwxhP","Interview__BestMatch":"job-sharing_Interview__BestMatch__5KPvf","Interview__BestMatchExclamation":"job-sharing_Interview__BestMatchExclamation__g_x6D","DragAndDrop":"job-sharing_DragAndDrop__6o7k8","DragAndDrop__CursorHandle":"job-sharing_DragAndDrop__CursorHandle__g5dOj","Tagrow__Image":"job-sharing_Tagrow__Image__LEUz1","rowbglight":"job-sharing_rowbglight__Rrnaz","rowbgheight":"job-sharing_rowbgheight__Mlw_B","Form__w90":"job-sharing_Form__w90__ScUA8","Container":"job-sharing_Container__HenZ9","Screening__StageName":"job-sharing_Screening__StageName__ctVvo","Screening__InterviewType":"job-sharing_Screening__InterviewType__710Zy","Screening__InterviewType__Label":"job-sharing_Screening__InterviewType__Label__qkV3Q","Show_Infoicon":"job-sharing_Show_Infoicon__Zkhfp","Show_Infoicon_small":"job-sharing_Show_Infoicon_small__LdkMo","Screening__Info":"job-sharing_Screening__Info__6NqZi","Screening__Info__IconWithText":"job-sharing_Screening__Info__IconWithText__3cqT4","InterviewType__Icon":"job-sharing_InterviewType__Icon__VfgJB","InterviewType__Text":"job-sharing_InterviewType__Text__eOxPK","Sharing":"job-sharing_Sharing__W1FeA","Sharing__HorizontalDivider":"job-sharing_Sharing__HorizontalDivider__Y99T3","Sharing__SocialIcons":"job-sharing_Sharing__SocialIcons__R5xxv","Sharing__Box":"job-sharing_Sharing__Box__y8LCQ","BorderActive":"job-sharing_BorderActive__vpcuY","BorderDisable":"job-sharing_BorderDisable__SD0Tb","FreePaidJobsDisplay":"job-sharing_FreePaidJobsDisplay__IZqsQ"};

/***/ }),

/***/ 45895:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"my-preferences_Form__mKOIO","Form__width":"my-preferences_Form__width__w3VPZ","Form__label":"my-preferences_Form__label__f3KkH","Form__textleft":"my-preferences_Form__textleft__rmAe4","Form__InputFullWidth":"my-preferences_Form__InputFullWidth__4KtIL","Form__Input":"my-preferences_Form__Input__sR6cy","Form__Input398":"my-preferences_Form__Input398__ypfNu","Form__InputSection":"my-preferences_Form__InputSection__uolKi","Form__ScoreCardInput":"my-preferences_Form__ScoreCardInput__AT1wE","Form__Textarea":"my-preferences_Form__Textarea__I9x1_","Form__Label":"my-preferences_Form__Label__Xy03o","Form__Data":"my-preferences_Form__Data__bTWju","Form__DataSingleRow":"my-preferences_Form__DataSingleRow__6m_Ur","Form__LabelCheck":"my-preferences_Form__LabelCheck__ErRpD","Form__Error":"my-preferences_Form__Error__qCYzD","Form__ErrorSection":"my-preferences_Form__ErrorSection__IcRX7","Form__MessagePlaceholder":"my-preferences_Form__MessagePlaceholder__1P_r2","Form__Submit":"my-preferences_Form__Submit__LD6kv","Form__FloatingLabel":"my-preferences_Form__FloatingLabel__8_1Yo","Form__NormalLabel":"my-preferences_Form__NormalLabel__VSQBe","Form__TableCol":"my-preferences_Form__TableCol__tYP_9","Form__currency_symbol":"my-preferences_Form__currency_symbol__5qv_m","Form__CustomSelect":"my-preferences_Form__CustomSelect__kPEAs","Form__currency_symbol__right":"my-preferences_Form__currency_symbol__right__m0mbV","AddInterview":"my-preferences_AddInterview__1GvfG","IntegrationTable":"my-preferences_IntegrationTable__pzg64","IntegrationTable__LimitInput":"my-preferences_IntegrationTable__LimitInput__CawNE","IntegrationTable__Type":"my-preferences_IntegrationTable__Type__PALi1","IntegrationTable__switch":"my-preferences_IntegrationTable__switch___JflH","IntegrationTable__slider":"my-preferences_IntegrationTable__slider__sH4It","IntegrationTable__round":"my-preferences_IntegrationTable__round__Lepc1","Form__ErrorCustomSelect":"my-preferences_Form__ErrorCustomSelect__xPs7k","Form__select_currency":"my-preferences_Form__select_currency__Z4lYn","customSelect__placeholder":"my-preferences_customSelect__placeholder__B8M_H","primarybtn":"my-preferences_primarybtn__i9Sls","JobList__EditModalEditButton":"my-preferences_JobList__EditModalEditButton__NwYgW","GoBtn":"my-preferences_GoBtn__bl0df","secondarybtn":"my-preferences_secondarybtn__TYaA7","JobList__EditModalCancelButton":"my-preferences_JobList__EditModalCancelButton__E7Wkp","iconFilled":"my-preferences_iconFilled__pbRNW","iconFilledSolid":"my-preferences_iconFilledSolid__2SXyk","primarybtnborder":"my-preferences_primarybtnborder__AjqUw","secondarybtnborder":"my-preferences_secondarybtnborder__v7i7D","ClearBtn":"my-preferences_ClearBtn__cvDlz","tertiarybtn":"my-preferences_tertiarybtn__tBv8d","graybtnborder":"my-preferences_graybtnborder__cBUFq","jobsrchbtn":"my-preferences_jobsrchbtn__XhUCZ","jobsrchbtnalign":"my-preferences_jobsrchbtnalign__QziPO","nobgbutton":"my-preferences_nobgbutton__cC2r9","iconTextButton":"my-preferences_iconTextButton__LAoPp","cursornone":"my-preferences_cursornone__w46Jz","nobgbuttonprimary":"my-preferences_nobgbuttonprimary__I_55Q","mt15":"my-preferences_mt15__hE3vD","btn350":"my-preferences_btn350__JQVS1","GrayBgBtn":"my-preferences_GrayBgBtn__3Q4E_","NewShareBtn":"my-preferences_NewShareBtn__87tTe","CoralBgBtn":"my-preferences_CoralBgBtn__Yb2V9","DropContainer":"my-preferences_DropContainer__0dkx9","DropContainer__Inner":"my-preferences_DropContainer__Inner__cKWiN","CompanyProfile__Inner":"my-preferences_CompanyProfile__Inner__DSr0c","DropContainer__Message":"my-preferences_DropContainer__Message__NR3fC","CompanyProfile__Message":"my-preferences_CompanyProfile__Message__tCno3","CompanyProfile__MessageContent":"my-preferences_CompanyProfile__MessageContent__VNOCb","DropContainer__UploadIcon":"my-preferences_DropContainer__UploadIcon__uhFGU","CompanyProfile__UploadIcon":"my-preferences_CompanyProfile__UploadIcon__hvbon","FileDisplayContainer":"my-preferences_FileDisplayContainer__LZuIT","FileDisplayContainer__Status":"my-preferences_FileDisplayContainer__Status__8sG0T","SetupPopup__Status":"my-preferences_SetupPopup__Status__kZlA2","SetupPopup__To":"my-preferences_SetupPopup__To__x4YE1","FileDisplayContainer__Type":"my-preferences_FileDisplayContainer__Type__BApTx","FileDisplayContainer__Name":"my-preferences_FileDisplayContainer__Name__rC_8N","SetupPopup__Name":"my-preferences_SetupPopup__Name__qHYll","SetupPopup__ToName":"my-preferences_SetupPopup__ToName__3o60R","FileDisplayContainer__Error":"my-preferences_FileDisplayContainer__Error__hd9fn","FileDisplayContainer__Close":"my-preferences_FileDisplayContainer__Close__ohHp9","Browse":"my-preferences_Browse__Z1tQr","ClientCompany":"my-preferences_ClientCompany__cjqC8","NewJob":"my-preferences_NewJob__ckz7z","Interview":"my-preferences_Interview__b077m","ClientCompany__TopSection2":"my-preferences_ClientCompany__TopSection2__5cokv","ClientCompany__Filter":"my-preferences_ClientCompany__Filter__17Qpi","ClientCompany__Input_MatchScore":"my-preferences_ClientCompany__Input_MatchScore__RQg8y","ClientCompany__Percentage_Symbol":"my-preferences_ClientCompany__Percentage_Symbol__R51Ln","ClientCompany__Filterheading":"my-preferences_ClientCompany__Filterheading__1qHrU","ClientCompany__FloatButtonAdd":"my-preferences_ClientCompany__FloatButtonAdd__Gtphv","ClientCompany__FloatButtonAdd__AgencyUserIcon":"my-preferences_ClientCompany__FloatButtonAdd__AgencyUserIcon__h3VX3","ClientCompany__LastEdited":"my-preferences_ClientCompany__LastEdited__GPo_j","ClientCompany__BackSection":"my-preferences_ClientCompany__BackSection__hPWFv","AddUsers__BackSection":"my-preferences_AddUsers__BackSection__M0L2a","ClientCompany__BackSection__CloseIcon":"my-preferences_ClientCompany__BackSection__CloseIcon__2lNy2","ClientCompany__Container":"my-preferences_ClientCompany__Container__WmmF0","NewJob__InterviewContainer":"my-preferences_NewJob__InterviewContainer__Rtfhz","AddUsers__Container":"my-preferences_AddUsers__Container__RuYTK","ClientCompany__FormInputSection":"my-preferences_ClientCompany__FormInputSection__jYdbL","CompanyProfile__FormInputSection":"my-preferences_CompanyProfile__FormInputSection__alD02","ClientCompany__Heading":"my-preferences_ClientCompany__Heading__prz0k","Offer__Heading":"my-preferences_Offer__Heading__g0iYA","AddUsers__Heading":"my-preferences_AddUsers__Heading__Y1Xcw","ClientCompany__StatusAlignment":"my-preferences_ClientCompany__StatusAlignment__W76Yx","ClientCompany__Status":"my-preferences_ClientCompany__Status__952Vn","ClientCompany__ActiveDot":"my-preferences_ClientCompany__ActiveDot__yGzyq","ClientCompany__CloseDot":"my-preferences_ClientCompany__CloseDot__XIiX6","ClientCompany__Company":"my-preferences_ClientCompany__Company__gN6of","AddUsers__User":"my-preferences_AddUsers__User__1Iwhc","ClientCompany__Systemrefheding":"my-preferences_ClientCompany__Systemrefheding__6MoCz","ClientCompany__Subheading":"my-preferences_ClientCompany__Subheading__Eq47d","CompanyProfile__Subheading":"my-preferences_CompanyProfile__Subheading__G2rhz","ClientCompany__Subheading2":"my-preferences_ClientCompany__Subheading2___MXof","ClientCompany__Description":"my-preferences_ClientCompany__Description__SFt9F","ClientCompany__SubmitSection":"my-preferences_ClientCompany__SubmitSection__XImML","NewJob__SubmitSection":"my-preferences_NewJob__SubmitSection__EO6bd","NewJob__SubmitSectionThreeBtn":"my-preferences_NewJob__SubmitSectionThreeBtn__8adII","NewJob__SubmitSectionOneBtnPlacement":"my-preferences_NewJob__SubmitSectionOneBtnPlacement__wAd_e","NewJob__ImportSection":"my-preferences_NewJob__ImportSection__73rnG","SetupPopup__SubmitSection2":"my-preferences_SetupPopup__SubmitSection2__UZa3h","SetupPopup__SubmitSection":"my-preferences_SetupPopup__SubmitSection__kRLQJ","SetupPopup__SubmitSection3":"my-preferences_SetupPopup__SubmitSection3__JYQLf","AddUsers__SubmitSection":"my-preferences_AddUsers__SubmitSection___d__0","ClientCompany__IntegrationImage":"my-preferences_ClientCompany__IntegrationImage__Oa00t","ClientCompany__QuickAdd":"my-preferences_ClientCompany__QuickAdd__NDUT5","NewJob__QuickAdd":"my-preferences_NewJob__QuickAdd__x8ab3","JobList__QuickAdd":"my-preferences_JobList__QuickAdd__BEVuF","Interview__QuickAdd":"my-preferences_Interview__QuickAdd__i1cpO","ClientCompany__BodyText":"my-preferences_ClientCompany__BodyText__ruMdv","Form__TableRow":"my-preferences_Form__TableRow__uXE5E","Form__TableRowTowGrid":"my-preferences_Form__TableRowTowGrid__kl__6","Form__TableRowSingle":"my-preferences_Form__TableRowSingle__yvMOU","Form__TableCol__Disabled":"my-preferences_Form__TableCol__Disabled__ZluVm","Form__TextareaDisabled":"my-preferences_Form__TextareaDisabled__vMakD","Form__EditorDisabled":"my-preferences_Form__EditorDisabled__nmbDK","Form__AdminCheckLabel":"my-preferences_Form__AdminCheckLabel__9mMKg","Form__AdminCheckMargin":"my-preferences_Form__AdminCheckMargin__1eGdB","CompanyProfile__BrandingGuide":"my-preferences_CompanyProfile__BrandingGuide__C2a1j","CompanyProfile__DropBoxContainer":"my-preferences_CompanyProfile__DropBoxContainer__w2v6R","CompanyProfile__Browse":"my-preferences_CompanyProfile__Browse__BnUGt","ErrorLabel":"my-preferences_ErrorLabel__PWAIC","Height80":"my-preferences_Height80__7wEVD","Browse__ButtonFlexEnd":"my-preferences_Browse__ButtonFlexEnd__DAkcv","AddAgency__Container":"my-preferences_AddAgency__Container__2ILuj","AddAgency__FormInputSection":"my-preferences_AddAgency__FormInputSection__myPcN","AddAgency__FormInputSection__Label":"my-preferences_AddAgency__FormInputSection__Label__Lghn7","AddAgency__Form":"my-preferences_AddAgency__Form__td2Ft","LinkAsButtons":"my-preferences_LinkAsButtons__bKKdT","SearchFlex":"my-preferences_SearchFlex__yiFc8","Career":"my-preferences_Career___G5Un","Career__Background_Edit":"my-preferences_Career__Background_Edit__yskle","Career__Background_Edit_Image":"my-preferences_Career__Background_Edit_Image__yhhf9","Career__Container":"my-preferences_Career__Container__br7Pg","Career__Inner":"my-preferences_Career__Inner__OxbDs","Career__logo":"my-preferences_Career__logo__1PfEb","Career__Content":"my-preferences_Career__Content__UUyfl","Career__ButtonSection":"my-preferences_Career__ButtonSection__GxTlg","Job":"my-preferences_Job__Eg4A0","Job__Inner":"my-preferences_Job__Inner__g9MZ8","Job__Container":"my-preferences_Job__Container__V7qtM","Job__Heading":"my-preferences_Job__Heading__8Nz8v","Job__Company":"my-preferences_Job__Company__BIrHj","Job__SearchContainer":"my-preferences_Job__SearchContainer__aNfRd","Job__SearchInput":"my-preferences_Job__SearchInput__OLUyu","Job__Searchbtn":"my-preferences_Job__Searchbtn__FSH9i","Job__Input":"my-preferences_Job__Input__iwK2B","Job__SelectJob":"my-preferences_Job__SelectJob__G0Pky","Job__RemoteLabel":"my-preferences_Job__RemoteLabel__nlWiQ","Job__Display":"my-preferences_Job__Display__UPE4m","Job__PostDay":"my-preferences_Job__PostDay__P_y_b","Job__Title":"my-preferences_Job__Title__uGyAt","Job__Location":"my-preferences_Job__Location__f0kjH","DT":"my-preferences_DT__9JXAa","DisplayTable":"my-preferences_DisplayTable__zxStz","pd11":"my-preferences_pd11__y4DCl","Label":"my-preferences_Label__SgzSP","inputwidth":"my-preferences_inputwidth__azsZX","mr24":"my-preferences_mr24__xMSLa","fullwidth":"my-preferences_fullwidth__9rO3r","padt40":"my-preferences_padt40__z2_3p","Form__TableRowflex":"my-preferences_Form__TableRowflex__MWlSz","Form__TableColm":"my-preferences_Form__TableColm__kmU8W","IntegrationPage":"my-preferences_IntegrationPage__v2x2_","Integration__BackStep":"my-preferences_Integration__BackStep__Z6JhE","AddUsers__BackStep":"my-preferences_AddUsers__BackStep__GZyW2","Integration__SubmitSection":"my-preferences_Integration__SubmitSection__PDX6W","IntegrationTable__AllJobsToggle":"my-preferences_IntegrationTable__AllJobsToggle__FhLtY","IntegrationTable__switchText":"my-preferences_IntegrationTable__switchText__98JNe","IntegrationTable__Action":"my-preferences_IntegrationTable__Action__P0vCo","IntegrationView":"my-preferences_IntegrationView__2xO83","IntegrationView__Title":"my-preferences_IntegrationView__Title___Rlfn","IntegrationView__Subheading":"my-preferences_IntegrationView__Subheading__nRgYt","IntegrationView__BoxImage":"my-preferences_IntegrationView__BoxImage__1xmyO","IntegrationView__Box":"my-preferences_IntegrationView__Box__ffcb2","IntegrationView__BoxImage__InfoIcon":"my-preferences_IntegrationView__BoxImage__InfoIcon__QYLoO","IntegrationView__ViewMoreButton":"my-preferences_IntegrationView__ViewMoreButton__hZBmc","IntegrationView__ConnectButton":"my-preferences_IntegrationView__ConnectButton__socE0","IntegrationView__GoogleButton":"my-preferences_IntegrationView__GoogleButton__D9zUY","IntegrationView__FlexFlow":"my-preferences_IntegrationView__FlexFlow__8UcaZ","IntegrationView__BoxWidth":"my-preferences_IntegrationView__BoxWidth__eHPFS","SkipFinishButton":"my-preferences_SkipFinishButton__JeXII","AddUsers":"my-preferences_AddUsers__fA7Re","AddUsers__ButtonSection":"my-preferences_AddUsers__ButtonSection__l_mLA","AddUsers__QuickStepHeading":"my-preferences_AddUsers__QuickStepHeading__o_ikN","AddUsers__DeleteSection":"my-preferences_AddUsers__DeleteSection__m0fOc","Interview__DeleteSection":"my-preferences_Interview__DeleteSection__fYhpi","AddUsers__DeleteCrossHeight":"my-preferences_AddUsers__DeleteCrossHeight__ZoL1i","AddUsers__Form__Input":"my-preferences_AddUsers__Form__Input__qF_Az","AddUsers__FormHeadingSection":"my-preferences_AddUsers__FormHeadingSection__R5CJl","Interview__FormHeadingSection":"my-preferences_Interview__FormHeadingSection__f2Nbk","AddUsers__FormSection":"my-preferences_AddUsers__FormSection__Plk79","NewJob__FormSection":"my-preferences_NewJob__FormSection__RqDfU","AddUsers__ButtonsActionSection":"my-preferences_AddUsers__ButtonsActionSection__c13pb","AddUsers__ImportUsers":"my-preferences_AddUsers__ImportUsers__vwn_F","AddUsers__NameInput":"my-preferences_AddUsers__NameInput__XuxLx","AddUsers__EmailInput":"my-preferences_AddUsers__EmailInput__ukR9J","AddUsers__RoleInput":"my-preferences_AddUsers__RoleInput__K82Yt","AddUsers__Subheading":"my-preferences_AddUsers__Subheading__qKCjK","AddUsers__visible":"my-preferences_AddUsers__visible__HZ2iV","Tagrow":"my-preferences_Tagrow__5uY6O","Tagrow__Tags":"my-preferences_Tagrow__Tags__SuPQ4","SetupPopup__Tags":"my-preferences_SetupPopup__Tags__qpgPP","Tagrow__Cancel":"my-preferences_Tagrow__Cancel__UurfY","Tagrow__Cross":"my-preferences_Tagrow__Cross__VR20F","SendInviteSection":"my-preferences_SendInviteSection__t7TTE","error":"my-preferences_error__oiRUx","ViewJobPage__Input":"my-preferences_ViewJobPage__Input__yRNf0","Form__Input2":"my-preferences_Form__Input2__FdfZk","ViewJobPage__PostDay":"my-preferences_ViewJobPage__PostDay___8PrN","ViewJobPage__Title":"my-preferences_ViewJobPage__Title__p_Ka4","ViewJobPage__DescriptionTitle":"my-preferences_ViewJobPage__DescriptionTitle__F6tAF","ViewJobPage__Location":"my-preferences_ViewJobPage__Location__VFiMO","ViewJobPage__primarybtn":"my-preferences_ViewJobPage__primarybtn__FV2_6","ViewJobPage__secondarybtn":"my-preferences_ViewJobPage__secondarybtn__X7m80","ViewJobPage__secondarybtnborder":"my-preferences_ViewJobPage__secondarybtnborder__2yVLm","ViewJobPage__BackSection":"my-preferences_ViewJobPage__BackSection__wRPse","Modalpopup":"my-preferences_Modalpopup__UBdW4","Modalpopup__inner":"my-preferences_Modalpopup__inner__FTzVq","Modalpopup__Dialog":"my-preferences_Modalpopup__Dialog__BLx1P","transition":"my-preferences_transition__FHVRS","Modalpopup__CloseCenter":"my-preferences_Modalpopup__CloseCenter__GgdYM","Modalpopup__Content":"my-preferences_Modalpopup__Content__t_pYD","SetupPopup__PaddingPopup":"my-preferences_SetupPopup__PaddingPopup__Guz7u","SetupPopup__ContentCustomisation":"my-preferences_SetupPopup__ContentCustomisation__V8FR_","SetupPopup__Contentwithoutpadding":"my-preferences_SetupPopup__Contentwithoutpadding__BuN3w","ViewJobPage__Content":"my-preferences_ViewJobPage__Content__gkPpf","Modalpopup__btn":"my-preferences_Modalpopup__btn__5H8NK","mar":"my-preferences_mar__TzFiF","Otpback":"my-preferences_Otpback__m56MD","ViewJobPage":"my-preferences_ViewJobPage__iWXqU","ViewJobPage__Header":"my-preferences_ViewJobPage__Header__6MAYG","ViewJobPage__Application":"my-preferences_ViewJobPage__Application__aroP9","ViewJobPage__RecordVideo":"my-preferences_ViewJobPage__RecordVideo__gFHwV","ViewJobPage__RecordVideoSuccessText":"my-preferences_ViewJobPage__RecordVideoSuccessText__MIIIQ","ViewJobPage__subheading":"my-preferences_ViewJobPage__subheading__x8bUX","ViewJobPage__confirmation":"my-preferences_ViewJobPage__confirmation__JqE4K","ViewJobPage__Logo":"my-preferences_ViewJobPage__Logo__4xfC6","ViewJobPage__BrandLogo":"my-preferences_ViewJobPage__BrandLogo__KSS1K","ViewJobPage__BrandLogo__Padding10":"my-preferences_ViewJobPage__BrandLogo__Padding10__AG89N","ViewJobPage__Container":"my-preferences_ViewJobPage__Container__CQqsF","ViewJobPage__JobContent":"my-preferences_ViewJobPage__JobContent__ceMOu","ViewJobPage__Sidebar":"my-preferences_ViewJobPage__Sidebar__jGM0n","ViewJobPage__Sidebar2":"my-preferences_ViewJobPage__Sidebar2__6L9HD","ViewJobPage__Description":"my-preferences_ViewJobPage__Description__kzmjc","ViewJobPage__DescriptionWidth":"my-preferences_ViewJobPage__DescriptionWidth__KfIww","ViewJobPage__Footer":"my-preferences_ViewJobPage__Footer___PL_W","ViewJobPage__FooterView":"my-preferences_ViewJobPage__FooterView__607Vd","ViewJobPage__ShareJob":"my-preferences_ViewJobPage__ShareJob__3HSRO","ViewJobPage__SubmitSection":"my-preferences_ViewJobPage__SubmitSection__kn0KK","ViewJobPage__SocialMedia":"my-preferences_ViewJobPage__SocialMedia__uK86A","ViewJobPage__SideContent":"my-preferences_ViewJobPage__SideContent__9lPzg","ViewJobPage__ApplySection":"my-preferences_ViewJobPage__ApplySection__x0upE","FormBox__Autofill":"my-preferences_FormBox__Autofill__qrekS","applybuttons":"my-preferences_applybuttons__0l36Z","height90":"my-preferences_height90__C_dyQ","Form__Cont":"my-preferences_Form__Cont__NRgJG","Form__DropBox":"my-preferences_Form__DropBox__qU4mF","Form__DropBoxcontainer":"my-preferences_Form__DropBoxcontainer__Xm6e_","Form__DropBoxError":"my-preferences_Form__DropBoxError__TLZvE","Form__DropBoxicon":"my-preferences_Form__DropBoxicon__sh6iA","Form__DropBoxmessage":"my-preferences_Form__DropBoxmessage__uNv_9","noDpGrid":"my-preferences_noDpGrid__D0Ccj","Terms":"my-preferences_Terms__1Eepd","TermsCondition":"my-preferences_TermsCondition__70Fn_","TermsCondition__alignterms":"my-preferences_TermsCondition__alignterms__1VVQ5","MenuContainer":"my-preferences_MenuContainer__SBBOb","MenuContainer__Menu":"my-preferences_MenuContainer__Menu__BaSFx","AgencyDetailPage":"my-preferences_AgencyDetailPage__K6cPc","Congrats__ModalContent":"my-preferences_Congrats__ModalContent__lwtai","JobList__SearchBox":"my-preferences_JobList__SearchBox__fSeeS","NewJob__Container":"my-preferences_NewJob__Container__bL71w","NewJob__TopSection":"my-preferences_NewJob__TopSection__ODOFu","JobList__TopSection":"my-preferences_JobList__TopSection__hpBai","Interview__TopSection":"my-preferences_Interview__TopSection__SAV_e","NewJob__HorizontalDivider":"my-preferences_NewJob__HorizontalDivider__bAgoX","NewJob__Wrapper":"my-preferences_NewJob__Wrapper__uZW1A","NewJob__ContainerPadding":"my-preferences_NewJob__ContainerPadding__eteEe","NewJob__ContainerScroll":"my-preferences_NewJob__ContainerScroll__Q3YMo","NewJob__ContainerHeight":"my-preferences_NewJob__ContainerHeight__jgs79","NewJob__ImportAction":"my-preferences_NewJob__ImportAction__H7dm4","NewJob__Interview_buttons":"my-preferences_NewJob__Interview_buttons__QMPqy","Form__TableRowMB":"my-preferences_Form__TableRowMB___PxYV","Form__TableRow3grid":"my-preferences_Form__TableRow3grid__Enx1N","Form__Remotegrid":"my-preferences_Form__Remotegrid__95AD7","Form__TypeList":"my-preferences_Form__TypeList__HA5QE","Form__Type":"my-preferences_Form__Type__gsMVN","Form__CheckLabel":"my-preferences_Form__CheckLabel__FORqe","PrivateSwitchBase-root-1":"my-preferences_PrivateSwitchBase-root-1__Ujxdh","Form__Caption":"my-preferences_Form__Caption__Bc1Uo","Form__Input_currency":"my-preferences_Form__Input_currency__bGl4x","Form__Input_MatchScore":"my-preferences_Form__Input_MatchScore__iqNbF","Form__Percentage_Symbol":"my-preferences_Form__Percentage_Symbol__lxtPB","Form__NoGridTemplate":"my-preferences_Form__NoGridTemplate__Wdx6J","active":"my-preferences_active__Ohc42","mt10":"my-preferences_mt10__KLJQ6","mt40":"my-preferences_mt40__JaGm9","mt30":"my-preferences_mt30__mN9P_","mt32":"my-preferences_mt32__xq_U3","mb0":"my-preferences_mb0__w3NTX","Dpgrid":"my-preferences_Dpgrid__0ZVGJ","mb12":"my-preferences_mb12__nYsDH","width100":"my-preferences_width100__4nLv5","Tagrow__Prefix":"my-preferences_Tagrow__Prefix__lqMgG","PreviewJobPage":"my-preferences_PreviewJobPage__wKDJG","PreviewJob":"my-preferences_PreviewJob__3w03d","DpFlx":"my-preferences_DpFlx__GCUIj","Subheading":"my-preferences_Subheading__ymrcn","Subheading__Description":"my-preferences_Subheading__Description__tcPuW","Candidate__Tooltip":"my-preferences_Candidate__Tooltip__iUnhl","Candidate__Tooltip__Score":"my-preferences_Candidate__Tooltip__Score__LC92U","Form__InputField":"my-preferences_Form__InputField__42vfz","Candidate__Length":"my-preferences_Candidate__Length__faBuW","Agency__PostDay":"my-preferences_Agency__PostDay__jRmt8","Agency__Title":"my-preferences_Agency__Title__lMQrW","Agency__Location":"my-preferences_Agency__Location__CDgUI","Agency__DescriptionTitle":"my-preferences_Agency__DescriptionTitle__NkyAU","Agency__Description":"my-preferences_Agency__Description___4u0y","LightBlueColor":"my-preferences_LightBlueColor__NgdHz","AgencyDetailForm":"my-preferences_AgencyDetailForm__qJg3q","Client_Page":"my-preferences_Client_Page__gGWrK","Welcome":"my-preferences_Welcome__r3FbJ","Welcome__Inner":"my-preferences_Welcome__Inner__FG31w","Welcome__Person":"my-preferences_Welcome__Person__MoS3K","Welcome__LeftContent":"my-preferences_Welcome__LeftContent__2DULM","Welcome__RightContent":"my-preferences_Welcome__RightContent__AjMA1","Welcome__Content":"my-preferences_Welcome__Content__o_0eR","Welcome__CreateAccount":"my-preferences_Welcome__CreateAccount__n_WbG","Welcome__title":"my-preferences_Welcome__title__mUgPj","Welcome__FormBox":"my-preferences_Welcome__FormBox__3i9wd","Form__psw":"my-preferences_Form__psw__ZJY_0","Welcome__Container":"my-preferences_Welcome__Container__gYqSu","Success__Container":"my-preferences_Success__Container__ACiDP","Success":"my-preferences_Success__nLSvp","Success__Inner":"my-preferences_Success__Inner__LdCKk","InterviewContainer":"my-preferences_InterviewContainer__UTtUj","Interview__Stages":"my-preferences_Interview__Stages__MIiIh","Interview__StageHeading":"my-preferences_Interview__StageHeading__8u3xJ","pl10":"my-preferences_pl10__62_1L","Interview__AddStageSection":"my-preferences_Interview__AddStageSection__1nwIf","Interview__Label":"my-preferences_Interview__Label__y6V_I","Interview__FormRowHeading":"my-preferences_Interview__FormRowHeading__wmOGP","dpflex":"my-preferences_dpflex__5wmBB","Interview__IconsType":"my-preferences_Interview__IconsType__G1WPO","Interview__Icons":"my-preferences_Interview__Icons__bXEW2","Interview__Interview_buttons":"my-preferences_Interview__Interview_buttons__KUhWr","Interview__approvalButton":"my-preferences_Interview__approvalButton__xBN5V","Interview__BestMatch":"my-preferences_Interview__BestMatch___zzNr","Interview__BestMatchExclamation":"my-preferences_Interview__BestMatchExclamation__GEkcx","DragAndDrop":"my-preferences_DragAndDrop__y_QkT","DragAndDrop__CursorHandle":"my-preferences_DragAndDrop__CursorHandle__6RYSj","Tagrow__Image":"my-preferences_Tagrow__Image__D3soi","rowbglight":"my-preferences_rowbglight__6svS5","rowbgheight":"my-preferences_rowbgheight__ay3Lt","Form__w90":"my-preferences_Form__w90__3IPP0","Container":"my-preferences_Container__EtcXm","Screening__StageName":"my-preferences_Screening__StageName__1ii_O","Screening__InterviewType":"my-preferences_Screening__InterviewType__DtSUz","Screening__InterviewType__Label":"my-preferences_Screening__InterviewType__Label___tIyY","Show_Infoicon":"my-preferences_Show_Infoicon__1ipNm","Show_Infoicon_small":"my-preferences_Show_Infoicon_small__yJd0s","Screening__Info":"my-preferences_Screening__Info__abmp5","Screening__Info__IconWithText":"my-preferences_Screening__Info__IconWithText__kaSfH","InterviewType__Icon":"my-preferences_InterviewType__Icon__Sq5nN","InterviewType__Text":"my-preferences_InterviewType__Text__yXHgk","LoginModal":"my-preferences_LoginModal__NA_xc","Logincontent":"my-preferences_Logincontent__fPlEX","Logincontent__title":"my-preferences_Logincontent__title__ucMbL","Modalbg":"my-preferences_Modalbg__JHokX","Modalnobg":"my-preferences_Modalnobg__cgGwr","Form__Container":"my-preferences_Form__Container__7SmNH","Form__success":"my-preferences_Form__success__i0Jws","Form__error":"my-preferences_Form__error__zdM3o","Form__CheckLabeltext":"my-preferences_Form__CheckLabeltext__4YmYz","Form__TextLeft":"my-preferences_Form__TextLeft__XIOE_","Backsection":"my-preferences_Backsection___2M29","back":"my-preferences_back__lMBha","mlr0":"my-preferences_mlr0__RScUm","TwoButtons":"my-preferences_TwoButtons__rkhSG","OtpBacksection":"my-preferences_OtpBacksection__rDUHG","SetupPopup":"my-preferences_SetupPopup__nqESt","JobList__EditModal":"my-preferences_JobList__EditModal__kZN6k","SetupPopup__inner":"my-preferences_SetupPopup__inner__aOyg4","SetupPopup__Dialog":"my-preferences_SetupPopup__Dialog__nGWPY","SetupPopup__AddFile":"my-preferences_SetupPopup__AddFile__n_YEP","SetupPopup__OptionalText":"my-preferences_SetupPopup__OptionalText__Xa_cL","SetupPopup__RequestAccessBtn":"my-preferences_SetupPopup__RequestAccessBtn__3GiDv","SetupPopup__InternalSection":"my-preferences_SetupPopup__InternalSection__z5AYv","SetupPopup__ContentInnerRow":"my-preferences_SetupPopup__ContentInnerRow__jtIG_","SetupPopup__ToChips":"my-preferences_SetupPopup__ToChips__LYlCu","SetupPopup__AttachmentContainer":"my-preferences_SetupPopup__AttachmentContainer__D4Erl","SetupPopup__ContentInnerCol":"my-preferences_SetupPopup__ContentInnerCol__qCPHn","SetupPopup__grid":"my-preferences_SetupPopup__grid__iXk14","SetupPopup__Footer":"my-preferences_SetupPopup__Footer__LuPYI","SetupPopup__FooterNew":"my-preferences_SetupPopup__FooterNew__nEASQ","SetupPopup__Footer2":"my-preferences_SetupPopup__Footer2__NJNNJ","SetupPopup__Footer3":"my-preferences_SetupPopup__Footer3__qAHON","SetupPopup__Footerassess":"my-preferences_SetupPopup__Footerassess__upB9S","SetupPopup__Footertechtest":"my-preferences_SetupPopup__Footertechtest__lbH6X","SetupPopup__AutommationFooter":"my-preferences_SetupPopup__AutommationFooter__tGMSu","SetupPopup__MannualFooter":"my-preferences_SetupPopup__MannualFooter__aii_v","SetupPopup__MannualInnerSection":"my-preferences_SetupPopup__MannualInnerSection__cL9VC","SetupPopup__Content":"my-preferences_SetupPopup__Content__WtaqF","SetupPopup__Content__Radiobtn":"my-preferences_SetupPopup__Content__Radiobtn__3O7JJ","SetupPopup__AutomationToggle":"my-preferences_SetupPopup__AutomationToggle__y9sTu","SetupPopup__SetupVideoQa":"my-preferences_SetupPopup__SetupVideoQa__m9krF","SetupPopup__SetupVideoQa2":"my-preferences_SetupPopup__SetupVideoQa2__24zlB","SetupPopup__SetupVideoQa3":"my-preferences_SetupPopup__SetupVideoQa3__mY9Jk","SetupPopup__SetupVideoQa4":"my-preferences_SetupPopup__SetupVideoQa4__QK2gn","SetupPopup__InputQA":"my-preferences_SetupPopup__InputQA__nCm5r","SetupPopup__AddQuestion":"my-preferences_SetupPopup__AddQuestion__ONulF","SetupPopup__QuestionSection":"my-preferences_SetupPopup__QuestionSection__NfyOi","SetupPopup__PushTop":"my-preferences_SetupPopup__PushTop__X2UG1","SetupPopup__Contentpading":"my-preferences_SetupPopup__Contentpading__SkYa9","SetupPopup__QuesionSectionpading":"my-preferences_SetupPopup__QuesionSectionpading__bgNz7","SetupPopup__Contentcenter":"my-preferences_SetupPopup__Contentcenter__zvw7e","SetupPopup__PopDetails":"my-preferences_SetupPopup__PopDetails__2z9vx","SetupPopup__PopDetails__FS16":"my-preferences_SetupPopup__PopDetails__FS16___5_eV","SetupPopup__Details":"my-preferences_SetupPopup__Details__Gl12H","SetupPopup__PrivacyPolicyDetails":"my-preferences_SetupPopup__PrivacyPolicyDetails__GUxZm","SetupPopup__Reason":"my-preferences_SetupPopup__Reason__YVuI1","SetupPopup__ContentBlock":"my-preferences_SetupPopup__ContentBlock__1l4O2","SetupPopup__Purpose":"my-preferences_SetupPopup__Purpose__ZwR5i","SetupPopup__ContentGridsec":"my-preferences_SetupPopup__ContentGridsec__FeDx5","mt25":"my-preferences_mt25__BCDr9","mt20":"my-preferences_mt20__sJALZ","SetupPopup__ContentGridTech":"my-preferences_SetupPopup__ContentGridTech__si5YZ","SetupPopup__Assesmentsection":"my-preferences_SetupPopup__Assesmentsection__H9vwl","SetupPopup__AssesmentsectionNew":"my-preferences_SetupPopup__AssesmentsectionNew__2_80h","SetupPopup__MannualChips":"my-preferences_SetupPopup__MannualChips__P_CQO","SetupPopup__ContentGridManuaCol":"my-preferences_SetupPopup__ContentGridManuaCol__ZHYmm","SetupPopup__ContentGridManual":"my-preferences_SetupPopup__ContentGridManual__TYwg4","SetupPopup__ContentBlockPhone":"my-preferences_SetupPopup__ContentBlockPhone__A0hJT","SetupPopup__ContentAddInterview":"my-preferences_SetupPopup__ContentAddInterview__p_TLW","SetupPopup__ContentGridPhone":"my-preferences_SetupPopup__ContentGridPhone__yz1WU","SetupPopup__ContentGridStatus":"my-preferences_SetupPopup__ContentGridStatus__Jq73x","SetupPopup__GridActions":"my-preferences_SetupPopup__GridActions__sn9Ew","SetupPopup__GridActionCoral":"my-preferences_SetupPopup__GridActionCoral__nclLf","SetupPopup__GridActionIndigo":"my-preferences_SetupPopup__GridActionIndigo__LGNzI","SetupPopup__ContentGrid":"my-preferences_SetupPopup__ContentGrid__Kv2y_","SetupPopup__SubmitSectionSave":"my-preferences_SetupPopup__SubmitSectionSave__QvYwG","SetupPopup__SubmitSectionReset":"my-preferences_SetupPopup__SubmitSectionReset__ag5WL","SetupPopup__SubmitSectionAutomation":"my-preferences_SetupPopup__SubmitSectionAutomation___83U5","SetupPopup__Duration":"my-preferences_SetupPopup__Duration__WlTAv","SetupPopup__DeleteIcon":"my-preferences_SetupPopup__DeleteIcon__XlL_z","SetupPopup__ContentCustomisationManualInterview":"my-preferences_SetupPopup__ContentCustomisationManualInterview__yF2z9","mt0":"my-preferences_mt0__y_FiL","mtb25":"my-preferences_mtb25__Yjr14","mb15":"my-preferences_mb15__WlIFL","mb30":"my-preferences_mb30__kSWC0","mt9":"my-preferences_mt9__FM4FG","lineheight0":"my-preferences_lineheight0__oa4XJ","PopupHeightSection":"my-preferences_PopupHeightSection__jFfuL","AssessPopupHeightSection":"my-preferences_AssessPopupHeightSection__N5fnD","Statusopupheight":"my-preferences_Statusopupheight__jYBXR","buttonIn":"my-preferences_buttonIn__LUgoQ","MessagePlaceholder":"my-preferences_MessagePlaceholder__PXhlU","m0":"my-preferences_m0__r2CzE","mt18":"my-preferences_mt18__G_aNw","DPgrid":"my-preferences_DPgrid__2JVSu","addbtnposition":"my-preferences_addbtnposition__TBRh1","mainformdiv":"my-preferences_mainformdiv__eeIHe","crossflex":"my-preferences_crossflex__oDnS6","crossimgheight":"my-preferences_crossimgheight__SIWv6","crossimgheight48":"my-preferences_crossimgheight48__iYiq6","SetupModalPopup":"my-preferences_SetupModalPopup__ZYJeA","SetupModalPopup__Dialog":"my-preferences_SetupModalPopup__Dialog__ce1gx","SetupPopupoverlay":"my-preferences_SetupPopupoverlay__iNp3h","NeedHelp":"my-preferences_NeedHelp__qQdei","uploadNewTest":"my-preferences_uploadNewTest__5twAP","SetupPopup__ol":"my-preferences_SetupPopup__ol__QA2U_","Threshold__Content":"my-preferences_Threshold__Content__kMERP","SetupPopup__ContentGridPhone__Content":"my-preferences_SetupPopup__ContentGridPhone__Content__EnZXR","JobList__EditModalInner":"my-preferences_JobList__EditModalInner__LP7Iw","Popupheight":"my-preferences_Popupheight__04H5a","CandidateBulkActionSection":"my-preferences_CandidateBulkActionSection__vof2m","KanbanBulkActionSection":"my-preferences_KanbanBulkActionSection__DMusS","KanbanBulkActionSection__Progress":"my-preferences_KanbanBulkActionSection__Progress__OXmSh","KanbanBulkActionSection__Message":"my-preferences_KanbanBulkActionSection__Message__M11Ku","Heading":"my-preferences_Heading___M8qm","Offer__Container":"my-preferences_Offer__Container__m6ldF","Offer__DetailsSection":"my-preferences_Offer__DetailsSection__jupVl","Offer__NoMarginTop":"my-preferences_Offer__NoMarginTop__BBOn4","Offer__Mt20":"my-preferences_Offer__Mt20__zwR2z","Form__OfferSubmit":"my-preferences_Form__OfferSubmit__ZcYep","Error":"my-preferences_Error__RDzsc","SignContract":"my-preferences_SignContract__bgRYD","SignContract__Container":"my-preferences_SignContract__Container__VFfRm","SignContract__Button":"my-preferences_SignContract__Button__FKnmM","SignContract__Header":"my-preferences_SignContract__Header__1ZLpY","SignContract__Page":"my-preferences_SignContract__Page__VpMGu","SignContract__Logo":"my-preferences_SignContract__Logo__a0T04","SignContract__Main":"my-preferences_SignContract__Main__zHuvt","OfferDetail__Container":"my-preferences_OfferDetail__Container__1UN9e","JobOfferDetails":"my-preferences_JobOfferDetails__jhvif","JobOfferDetails__Section":"my-preferences_JobOfferDetails__Section__XkIUW","JobOfferDetails__Row":"my-preferences_JobOfferDetails__Row__I3j5w","JobOfferDetails__LeftCol":"my-preferences_JobOfferDetails__LeftCol__uzg8J","JobOfferDetails__RightCol":"my-preferences_JobOfferDetails__RightCol__vx97s","JobOfferDetails__Label":"my-preferences_JobOfferDetails__Label__rmk04","JobOfferDetails__Data":"my-preferences_JobOfferDetails__Data__XaOD2","JobOfferDetails__W100":"my-preferences_JobOfferDetails__W100__m_Zf8","JobOfferDetails__MR20":"my-preferences_JobOfferDetails__MR20__4PBIv","Offer":"my-preferences_Offer__LQH8l","OfferDetail":"my-preferences_OfferDetail__kWWYm","ProgressLineSection":"my-preferences_ProgressLineSection__2Xov_","ProgressLineSection__Container":"my-preferences_ProgressLineSection__Container__fNIa0","ProgressLineSection__AcionSection":"my-preferences_ProgressLineSection__AcionSection__ALIZM","ProgressLineSection__ActionButtons":"my-preferences_ProgressLineSection__ActionButtons__Xmq74","ProgressLineSection__Heading":"my-preferences_ProgressLineSection__Heading__BVMsO","TopHeaderSection":"my-preferences_TopHeaderSection__L2hlZ","TopHeaderSection__SpaceBetween":"my-preferences_TopHeaderSection__SpaceBetween__1dZ_T","AgencyHeading":"my-preferences_AgencyHeading__22hSG","StatsSection":"my-preferences_StatsSection__RNTej","StatsSection__List":"my-preferences_StatsSection__List__Vfv1Q","StatsSection__NewList":"my-preferences_StatsSection__NewList__ox_cV","StatsSection__ListStatus":"my-preferences_StatsSection__ListStatus__BYSlR","StatsSection__NewListStatus":"my-preferences_StatsSection__NewListStatus__5Y1sB","StatsSection__Statslist":"my-preferences_StatsSection__Statslist__R8ySo","StatsSection__StatsAnchor":"my-preferences_StatsSection__StatsAnchor__hJtak","StatsSection__StatsContent":"my-preferences_StatsSection__StatsContent__8mG70","StatsSection__StatsContentWidth":"my-preferences_StatsSection__StatsContentWidth__zdLfW","StatsSection__StatsNumber":"my-preferences_StatsSection__StatsNumber__PWgP5","StatsSection__StatsNumberWidth":"my-preferences_StatsSection__StatsNumberWidth__M1jlc","StatsSection__Health":"my-preferences_StatsSection__Health__JB8N8","StatsSection__IndigoBg":"my-preferences_StatsSection__IndigoBg__3t71l","StatsSection__CorelBg":"my-preferences_StatsSection__CorelBg__ncMKm","StatsSection__GreenBg":"my-preferences_StatsSection__GreenBg__lQAA8","StatsSection__RoseBg":"my-preferences_StatsSection__RoseBg__Vlc_5","StatsSection__CorelDarkBg":"my-preferences_StatsSection__CorelDarkBg__diK_8","StatsSection__StatBgOne":"my-preferences_StatsSection__StatBgOne__vGuyQ","StatsSection__StatBgOne__NoBorder":"my-preferences_StatsSection__StatBgOne__NoBorder__5AJSE","StatsSection__StatBgTwo":"my-preferences_StatsSection__StatBgTwo__0UgSZ","StatsSection__StatBgThree":"my-preferences_StatsSection__StatBgThree__IgblJ","StatsSection__StatBgFour":"my-preferences_StatsSection__StatBgFour__RkF_0","NotificationSection":"my-preferences_NotificationSection__LKyYd","NotificationSection__InterviewListNoHover":"my-preferences_NotificationSection__InterviewListNoHover__xTPH0","NotificationSection__AlertActivity":"my-preferences_NotificationSection__AlertActivity__zWS8y","NotificationSection__Alert":"my-preferences_NotificationSection__Alert__MUBb1","NotificationSection__List":"my-preferences_NotificationSection__List__1yDbt","NotificationSection__AlertContainer":"my-preferences_NotificationSection__AlertContainer__gSpFW","NotificationSection__CommunicationContainer":"my-preferences_NotificationSection__CommunicationContainer__PjI1K","NotificationSection__AlertActivityContainer":"my-preferences_NotificationSection__AlertActivityContainer__Es3kL","NotificationSection__Schedulingmain":"my-preferences_NotificationSection__Schedulingmain__aJLwE","NotificationSection__More":"my-preferences_NotificationSection__More__tfsc5","NotificationSection__Alertslist":"my-preferences_NotificationSection__Alertslist__360b5","NotificationSection__Alertsmessage":"my-preferences_NotificationSection__Alertsmessage__Ssy14","NotificationSection__AlertsTilte":"my-preferences_NotificationSection__AlertsTilte__cgarF","NotificationSection__AlertHeading":"my-preferences_NotificationSection__AlertHeading__INUx5","NotificationSection__CalendarHeading":"my-preferences_NotificationSection__CalendarHeading__lRYzU","NotificationSection__Dismiss":"my-preferences_NotificationSection__Dismiss__0SSzI","NotificationSection__Communications":"my-preferences_NotificationSection__Communications__fT3ED","NotificationSection__ProfileCircle":"my-preferences_NotificationSection__ProfileCircle__gsCLs","NotificationSection__SchedulingTiming":"my-preferences_NotificationSection__SchedulingTiming__JnNPy","NotificationSection__TimimgsSection":"my-preferences_NotificationSection__TimimgsSection__88Bi_","NotificationSection__WeekTiming":"my-preferences_NotificationSection__WeekTiming__q5uOM","NotificationSection__Scheduling":"my-preferences_NotificationSection__Scheduling__31wk7","NotificationSection__Pagination":"my-preferences_NotificationSection__Pagination__b_pqJ","NotificationSection__PaginationButton":"my-preferences_NotificationSection__PaginationButton__whJQJ","NotificationSection__InterviewListSvg":"my-preferences_NotificationSection__InterviewListSvg___CjTm","NotificationSection__InterviewListStage":"my-preferences_NotificationSection__InterviewListStage__1HHT9","NotificationSection__InterviewList":"my-preferences_NotificationSection__InterviewList__FmhXa","NotificationSection__Interviewtitle":"my-preferences_NotificationSection__Interviewtitle__t2o8A","NotificationSection__InterviewerProfile":"my-preferences_NotificationSection__InterviewerProfile__Zv_A6","NotificationSection__InterviewerDate":"my-preferences_NotificationSection__InterviewerDate__su3XR","NotificationSection__Greybox":"my-preferences_NotificationSection__Greybox__b8KQ1","NotificationSection__Tabs":"my-preferences_NotificationSection__Tabs__U_5W0","React__tabs":"my-preferences_React__tabs__OEuMy","React__tabs__today":"my-preferences_React__tabs__today__3680_","React__tabs__head":"my-preferences_React__tabs__head__SjWjv","React__tabs__tabpanel":"my-preferences_React__tabs__tabpanel__U6SH7","React__tabs__tablist":"my-preferences_React__tabs__tablist__2vkfy","React__tabs__tablist__tab":"my-preferences_React__tabs__tablist__tab__e_WVA","React__tabs__interviewtype":"my-preferences_React__tabs__interviewtype__u9ZHc","React__tabs__MyInterview":"my-preferences_React__tabs__MyInterview__yAVnd","React__tabs__TeamInterview":"my-preferences_React__tabs__TeamInterview__u2597","NamePrefix":"my-preferences_NamePrefix__byJ5R","CandidatePrefix":"my-preferences_CandidatePrefix__rDshj","TopSection":"my-preferences_TopSection__H8LID","CalendarSelectedDate":"my-preferences_CalendarSelectedDate__g03If","TitleFlex":"my-preferences_TitleFlex__b3XQG","JobList__Accordian":"my-preferences_JobList__Accordian__OiYDq","JobList__AccordianContent":"my-preferences_JobList__AccordianContent__pMJc_","JobList__SearchSection":"my-preferences_JobList__SearchSection__T7Cym","JobList__FilterMarginBottom":"my-preferences_JobList__FilterMarginBottom__Z2bP9","JobList__SearchFilter":"my-preferences_JobList__SearchFilter__u8fSb","JobList__AppliedSearchFilter":"my-preferences_JobList__AppliedSearchFilter__D9BWe","JobList__SearchFilterFullWidth":"my-preferences_JobList__SearchFilterFullWidth__yZvKB","JobList__AddJobSection":"my-preferences_JobList__AddJobSection__ib_vb","JobList__Status":"my-preferences_JobList__Status__3e82d","JobList__EditModalContainer":"my-preferences_JobList__EditModalContainer__8eAIs","JobList__EditModalMessage":"my-preferences_JobList__EditModalMessage__KNkPF","JobList__EditModalButtonSection":"my-preferences_JobList__EditModalButtonSection__U7xpO","JobList__CheckLabel":"my-preferences_JobList__CheckLabel__Pgxpk","JobList__Checkbox":"my-preferences_JobList__Checkbox__R2AXC","JobList__JobBoard":"my-preferences_JobList__JobBoard__EiH0X","JobList__Reasons":"my-preferences_JobList__Reasons__3g5FD","KanbanSearch__Dots":"my-preferences_KanbanSearch__Dots__pNjUq","AgencyDetailForm__Label":"my-preferences_AgencyDetailForm__Label__TVr7e","AgencyDetailForm__Data":"my-preferences_AgencyDetailForm__Data__OfD9j","AgencyDetailForm__Actionsection":"my-preferences_AgencyDetailForm__Actionsection__tFPct","AgencyDetailForm__FormInputSection":"my-preferences_AgencyDetailForm__FormInputSection__w3kEb","ApprovalContract":"my-preferences_ApprovalContract__liHj4","ApprovalContractButtons":"my-preferences_ApprovalContractButtons__v7CHF","MyPreferences":"my-preferences_MyPreferences__bu1b2","MyPreferences__BackSection":"my-preferences_MyPreferences__BackSection__2IzUj","MyPreferences__TopSection":"my-preferences_MyPreferences__TopSection__oRiLa","MyPreferences__Container":"my-preferences_MyPreferences__Container__kqQFI","MyPreferences__FormInputSection":"my-preferences_MyPreferences__FormInputSection__etmI1","MyPreferences__Heading":"my-preferences_MyPreferences__Heading__CyzZ_","MyPreferences__Company":"my-preferences_MyPreferences__Company__uIAid","MyPreferences__Subheading":"my-preferences_MyPreferences__Subheading__xDPR6","MyPreferences__Subheading_1":"my-preferences_MyPreferences__Subheading_1__4Cnc_","MyPreferences__SubmitSection":"my-preferences_MyPreferences__SubmitSection__YUYY2","MyPreferences__SubmitSectionNext":"my-preferences_MyPreferences__SubmitSectionNext__M9W7H","MyPreferences__IntegrationImage":"my-preferences_MyPreferences__IntegrationImage__K3KJ7","MyPreferences__QuickAdd":"my-preferences_MyPreferences__QuickAdd__ATYwj","Buffer":"my-preferences_Buffer__sKzbZ","Buffer__BufferTimeGrid":"my-preferences_Buffer__BufferTimeGrid__aK_Aa","dateInput":"my-preferences_dateInput__HZoRw","Buffer__time":"my-preferences_Buffer__time__JD3M0","space":"my-preferences_space__J26ah","NoMaxGrid":"my-preferences_NoMaxGrid__DFIpK","CopyTime":"my-preferences_CopyTime__Ia2eb"};

/***/ }),

/***/ 35057:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"new-job_Form__FFV22","Form__width":"new-job_Form__width__aKcCo","Form__label":"new-job_Form__label__EzqL_","Form__textleft":"new-job_Form__textleft__wklV6","Form__InputFullWidth":"new-job_Form__InputFullWidth__n32mu","Form__Input":"new-job_Form__Input__sC3_b","Form__Input398":"new-job_Form__Input398__F88SX","Form__InputSection":"new-job_Form__InputSection__Yii8N","Form__ScoreCardInput":"new-job_Form__ScoreCardInput__9Q2YW","Form__Textarea":"new-job_Form__Textarea__m8gqs","primarybtn":"new-job_primarybtn__b0LtP","GoBtn":"new-job_GoBtn___BOJl","secondarybtn":"new-job_secondarybtn__Jnijg","iconFilled":"new-job_iconFilled__cxPt9","iconFilledSolid":"new-job_iconFilledSolid__8Otpr","primarybtnborder":"new-job_primarybtnborder__spEfI","secondarybtnborder":"new-job_secondarybtnborder__Cbo0Q","ClearBtn":"new-job_ClearBtn__yXedg","tertiarybtn":"new-job_tertiarybtn__ULyjW","graybtnborder":"new-job_graybtnborder__u0b4i","jobsrchbtn":"new-job_jobsrchbtn__UGJTU","jobsrchbtnalign":"new-job_jobsrchbtnalign__W55GO","nobgbutton":"new-job_nobgbutton__xdWrM","iconTextButton":"new-job_iconTextButton__e8gup","cursornone":"new-job_cursornone__iYO8p","nobgbuttonprimary":"new-job_nobgbuttonprimary__Ijcey","mt15":"new-job_mt15__qGv13","btn350":"new-job_btn350__XrrOf","GrayBgBtn":"new-job_GrayBgBtn__mW3U6","NewShareBtn":"new-job_NewShareBtn__0aS_1","CoralBgBtn":"new-job_CoralBgBtn__wi8vp","DropContainer":"new-job_DropContainer__xmqyD","DropContainer__Inner":"new-job_DropContainer__Inner__8GnXU","CompanyProfile__Inner":"new-job_CompanyProfile__Inner__PjjN8","DropContainer__Message":"new-job_DropContainer__Message__Ygq4b","CompanyProfile__Message":"new-job_CompanyProfile__Message__X_gPJ","CompanyProfile__MessageContent":"new-job_CompanyProfile__MessageContent__7AWaf","DropContainer__UploadIcon":"new-job_DropContainer__UploadIcon___5zdf","CompanyProfile__UploadIcon":"new-job_CompanyProfile__UploadIcon__Ba5tC","FileDisplayContainer":"new-job_FileDisplayContainer__mYM9p","FileDisplayContainer__Status":"new-job_FileDisplayContainer__Status__ps_VO","FileDisplayContainer__Type":"new-job_FileDisplayContainer__Type__U53IW","FileDisplayContainer__Name":"new-job_FileDisplayContainer__Name__lSlQy","FileDisplayContainer__Error":"new-job_FileDisplayContainer__Error__j7Dft","FileDisplayContainer__Close":"new-job_FileDisplayContainer__Close__khYOC","Browse":"new-job_Browse__zBeQj","ClientCompany":"new-job_ClientCompany__Ve_9C","NewJob":"new-job_NewJob__1CZ1_","ClientCompany__TopSection2":"new-job_ClientCompany__TopSection2__qK7T_","ClientCompany__Filter":"new-job_ClientCompany__Filter__Exz2Q","ClientCompany__Input_MatchScore":"new-job_ClientCompany__Input_MatchScore__KpEDV","ClientCompany__Percentage_Symbol":"new-job_ClientCompany__Percentage_Symbol__Vk5n7","ClientCompany__Filterheading":"new-job_ClientCompany__Filterheading__9JX4C","ClientCompany__FloatButtonAdd":"new-job_ClientCompany__FloatButtonAdd__h6nu3","ClientCompany__FloatButtonAdd__AgencyUserIcon":"new-job_ClientCompany__FloatButtonAdd__AgencyUserIcon__3EdoU","ClientCompany__LastEdited":"new-job_ClientCompany__LastEdited__hxl8S","ClientCompany__BackSection":"new-job_ClientCompany__BackSection__zR3o9","AddUsers__BackSection":"new-job_AddUsers__BackSection__j9VPe","ClientCompany__BackSection__CloseIcon":"new-job_ClientCompany__BackSection__CloseIcon__pu8h2","ClientCompany__Container":"new-job_ClientCompany__Container__wC40P","NewJob__InterviewContainer":"new-job_NewJob__InterviewContainer__hPMaf","AddUsers__Container":"new-job_AddUsers__Container__cxdSg","ClientCompany__FormInputSection":"new-job_ClientCompany__FormInputSection__tFM3d","CompanyProfile__FormInputSection":"new-job_CompanyProfile__FormInputSection__9CeAs","ClientCompany__Heading":"new-job_ClientCompany__Heading__TOAPp","AddUsers__Heading":"new-job_AddUsers__Heading__bnGFT","ClientCompany__StatusAlignment":"new-job_ClientCompany__StatusAlignment__XvsYR","ClientCompany__Status":"new-job_ClientCompany__Status___cZoM","ClientCompany__ActiveDot":"new-job_ClientCompany__ActiveDot__8RM96","ClientCompany__CloseDot":"new-job_ClientCompany__CloseDot__JAznO","ClientCompany__Company":"new-job_ClientCompany__Company__jtytL","AddUsers__User":"new-job_AddUsers__User__SWiEB","ClientCompany__Systemrefheding":"new-job_ClientCompany__Systemrefheding__0lKKI","ClientCompany__Subheading":"new-job_ClientCompany__Subheading__tFOiB","Subheading":"new-job_Subheading__ey5VK","CompanyProfile__Subheading":"new-job_CompanyProfile__Subheading__fGSjU","ClientCompany__Subheading2":"new-job_ClientCompany__Subheading2__MSewx","ClientCompany__Description":"new-job_ClientCompany__Description__2taGM","ClientCompany__SubmitSection":"new-job_ClientCompany__SubmitSection__6RN3N","NewJob__SubmitSection":"new-job_NewJob__SubmitSection__rrQHv","NewJob__SubmitSectionThreeBtn":"new-job_NewJob__SubmitSectionThreeBtn__psEvG","NewJob__SubmitSectionOneBtnPlacement":"new-job_NewJob__SubmitSectionOneBtnPlacement__O_kuv","NewJob__ImportSection":"new-job_NewJob__ImportSection__Sv5zg","AddUsers__SubmitSection":"new-job_AddUsers__SubmitSection__SGynC","ClientCompany__IntegrationImage":"new-job_ClientCompany__IntegrationImage__f_WCF","ClientCompany__QuickAdd":"new-job_ClientCompany__QuickAdd__TB_sA","NewJob__QuickAdd":"new-job_NewJob__QuickAdd__66alQ","ClientCompany__BodyText":"new-job_ClientCompany__BodyText__oduBa","Form__TableRow":"new-job_Form__TableRow__xqgoX","Form__Label":"new-job_Form__Label__hpavc","Form__FloatingLabel":"new-job_Form__FloatingLabel__ED_L_","Form__TableCol":"new-job_Form__TableCol__sBI86","Form__currency_symbol":"new-job_Form__currency_symbol__LmG3D","Form__CustomSelect":"new-job_Form__CustomSelect__tAPHT","Form__currency_symbol__right":"new-job_Form__currency_symbol__right__ogWnz","Form__TableCol__Disabled":"new-job_Form__TableCol__Disabled__KnWEk","Form__TextareaDisabled":"new-job_Form__TextareaDisabled__DrHM7","Form__EditorDisabled":"new-job_Form__EditorDisabled__GirGF","Form__AdminCheckLabel":"new-job_Form__AdminCheckLabel__ZMaON","Form__AdminCheckMargin":"new-job_Form__AdminCheckMargin__CCX0I","CompanyProfile__BrandingGuide":"new-job_CompanyProfile__BrandingGuide__w4NzH","CompanyProfile__DropBoxContainer":"new-job_CompanyProfile__DropBoxContainer__UVuf0","CompanyProfile__Browse":"new-job_CompanyProfile__Browse__6Gj3S","ErrorLabel":"new-job_ErrorLabel__BsMFl","Height80":"new-job_Height80__ca_SS","Browse__ButtonFlexEnd":"new-job_Browse__ButtonFlexEnd__Ww_HM","AddAgency__Container":"new-job_AddAgency__Container__AkT2I","AddAgency__FormInputSection":"new-job_AddAgency__FormInputSection__qpIcP","AddAgency__FormInputSection__Label":"new-job_AddAgency__FormInputSection__Label__TeTlr","AddAgency__Form":"new-job_AddAgency__Form__c8rop","LinkAsButtons":"new-job_LinkAsButtons__2HtFT","SearchFlex":"new-job_SearchFlex___Lla8","Form__ErrorCustomSelect":"new-job_Form__ErrorCustomSelect__W4b8M","Form__select_currency":"new-job_Form__select_currency__kd5ab","customSelect__placeholder":"new-job_customSelect__placeholder___4C93","Career":"new-job_Career__w4Ask","Career__Background_Edit":"new-job_Career__Background_Edit__yjJ3A","Career__Background_Edit_Image":"new-job_Career__Background_Edit_Image__4OiIS","Career__Container":"new-job_Career__Container__q5cT7","Career__Inner":"new-job_Career__Inner__Hs_Ha","Career__logo":"new-job_Career__logo__B5k_i","Career__Content":"new-job_Career__Content__jUs8_","Career__ButtonSection":"new-job_Career__ButtonSection__DkCWw","Job":"new-job_Job__PsJiI","Job__Inner":"new-job_Job__Inner__Eq8ks","Job__Container":"new-job_Job__Container__xza5Q","Job__Heading":"new-job_Job__Heading__3u6AV","Job__Company":"new-job_Job__Company__mwmDv","Job__SearchContainer":"new-job_Job__SearchContainer__ufCM4","Job__SearchInput":"new-job_Job__SearchInput__R0t4h","Job__Searchbtn":"new-job_Job__Searchbtn__JYvdy","Job__Input":"new-job_Job__Input___Rwty","Job__SelectJob":"new-job_Job__SelectJob__sH9Vw","Job__RemoteLabel":"new-job_Job__RemoteLabel___OlNA","Job__Display":"new-job_Job__Display__marF7","Job__PostDay":"new-job_Job__PostDay__MCXli","Job__Title":"new-job_Job__Title__f7l2U","Job__Location":"new-job_Job__Location__qw0rE","DT":"new-job_DT__5Lbyj","DisplayTable":"new-job_DisplayTable__1xysu","pd11":"new-job_pd11__x8bm3","Label":"new-job_Label__FiCQq","inputwidth":"new-job_inputwidth__K3nH_","mr24":"new-job_mr24__aOlSr","fullwidth":"new-job_fullwidth__bTgb2","padt40":"new-job_padt40__SfjNs","Form__TableRowflex":"new-job_Form__TableRowflex__ZTOuQ","Form__TableColm":"new-job_Form__TableColm___BxlG","Form__LabelCheck":"new-job_Form__LabelCheck__0tUnc","Form__Error":"new-job_Form__Error__WEjZO","Form__ErrorSection":"new-job_Form__ErrorSection__emHGV","Form__MessagePlaceholder":"new-job_Form__MessagePlaceholder__H6sA1","Form__Submit":"new-job_Form__Submit__LIFJK","Form__NormalLabel":"new-job_Form__NormalLabel__m_Cda","AddInterview":"new-job_AddInterview__6kk6Z","IntegrationPage":"new-job_IntegrationPage__b4bO1","Integration__BackStep":"new-job_Integration__BackStep__m5ob_","AddUsers__BackStep":"new-job_AddUsers__BackStep__lRCOY","Integration__SubmitSection":"new-job_Integration__SubmitSection__tju9c","IntegrationTable":"new-job_IntegrationTable___QsU3","IntegrationTable__LimitInput":"new-job_IntegrationTable__LimitInput__tKyRI","IntegrationTable__Type":"new-job_IntegrationTable__Type__9bfku","IntegrationTable__AllJobsToggle":"new-job_IntegrationTable__AllJobsToggle__Ru_J6","IntegrationTable__switch":"new-job_IntegrationTable__switch__NSOvL","IntegrationTable__switchText":"new-job_IntegrationTable__switchText__KNPim","IntegrationTable__slider":"new-job_IntegrationTable__slider__UVrGW","IntegrationTable__round":"new-job_IntegrationTable__round__BtzBw","IntegrationTable__Action":"new-job_IntegrationTable__Action__hjayz","IntegrationView":"new-job_IntegrationView__3uBas","IntegrationView__Title":"new-job_IntegrationView__Title__LmyK0","IntegrationView__Subheading":"new-job_IntegrationView__Subheading__VZ9ro","IntegrationView__BoxImage":"new-job_IntegrationView__BoxImage__T_oXp","IntegrationView__Box":"new-job_IntegrationView__Box__XyNVy","IntegrationView__BoxImage__InfoIcon":"new-job_IntegrationView__BoxImage__InfoIcon__QNu4x","IntegrationView__ViewMoreButton":"new-job_IntegrationView__ViewMoreButton__zJ7dY","IntegrationView__ConnectButton":"new-job_IntegrationView__ConnectButton__y1ZK_","IntegrationView__GoogleButton":"new-job_IntegrationView__GoogleButton__MoaER","IntegrationView__FlexFlow":"new-job_IntegrationView__FlexFlow__Urk3C","IntegrationView__BoxWidth":"new-job_IntegrationView__BoxWidth__KZ2xg","SkipFinishButton":"new-job_SkipFinishButton__P9KPk","AddUsers":"new-job_AddUsers__pf6_1","AddUsers__ButtonSection":"new-job_AddUsers__ButtonSection__RopHo","AddUsers__QuickStepHeading":"new-job_AddUsers__QuickStepHeading__80VZL","AddUsers__DeleteSection":"new-job_AddUsers__DeleteSection__rdgVd","AddUsers__DeleteCrossHeight":"new-job_AddUsers__DeleteCrossHeight__zmG1l","AddUsers__Form__Input":"new-job_AddUsers__Form__Input__zcw2_","AddUsers__FormHeadingSection":"new-job_AddUsers__FormHeadingSection__BgDbc","AddUsers__FormSection":"new-job_AddUsers__FormSection__QPQZB","NewJob__FormSection":"new-job_NewJob__FormSection__b_eBR","AddUsers__ButtonsActionSection":"new-job_AddUsers__ButtonsActionSection__5fR8x","AddUsers__ImportUsers":"new-job_AddUsers__ImportUsers__W8Jp9","AddUsers__NameInput":"new-job_AddUsers__NameInput__d55wO","AddUsers__EmailInput":"new-job_AddUsers__EmailInput__WyByN","AddUsers__RoleInput":"new-job_AddUsers__RoleInput__EcaKa","AddUsers__Subheading":"new-job_AddUsers__Subheading__VhhoC","AddUsers__visible":"new-job_AddUsers__visible__1LLbR","Tagrow":"new-job_Tagrow__egReq","Tagrow__Tags":"new-job_Tagrow__Tags__m0zyK","Tagrow__Cancel":"new-job_Tagrow__Cancel__zxdUd","SendInviteSection":"new-job_SendInviteSection__PPA7o","error":"new-job_error__p_hfr","ViewJobPage__Input":"new-job_ViewJobPage__Input__ndHCF","Form__Input2":"new-job_Form__Input2__M_LDl","ViewJobPage__PostDay":"new-job_ViewJobPage__PostDay__D9uRw","ViewJobPage__Title":"new-job_ViewJobPage__Title__6UhVh","ViewJobPage__DescriptionTitle":"new-job_ViewJobPage__DescriptionTitle__B4wMI","ViewJobPage__Location":"new-job_ViewJobPage__Location__xzJVM","ViewJobPage__primarybtn":"new-job_ViewJobPage__primarybtn__m8A5C","ViewJobPage__secondarybtn":"new-job_ViewJobPage__secondarybtn__HidEu","ViewJobPage__secondarybtnborder":"new-job_ViewJobPage__secondarybtnborder__l8Fo8","ViewJobPage__BackSection":"new-job_ViewJobPage__BackSection__Rdj7u","Modalpopup":"new-job_Modalpopup__DOvvr","Modalpopup__inner":"new-job_Modalpopup__inner__nIjbM","Modalpopup__Dialog":"new-job_Modalpopup__Dialog__qp_Gh","transition":"new-job_transition__yyGBP","Modalpopup__CloseCenter":"new-job_Modalpopup__CloseCenter__5ugho","Modalpopup__Content":"new-job_Modalpopup__Content__z_xKU","ViewJobPage__Content":"new-job_ViewJobPage__Content__mP1D2","Modalpopup__btn":"new-job_Modalpopup__btn__5a_bF","mar":"new-job_mar__voLql","Otpback":"new-job_Otpback__20mUe","ViewJobPage":"new-job_ViewJobPage__e4SvE","ViewJobPage__Header":"new-job_ViewJobPage__Header__5T9vv","ViewJobPage__Application":"new-job_ViewJobPage__Application__XqKZL","ViewJobPage__RecordVideo":"new-job_ViewJobPage__RecordVideo__VPecS","ViewJobPage__RecordVideoSuccessText":"new-job_ViewJobPage__RecordVideoSuccessText__L5kZ1","ViewJobPage__subheading":"new-job_ViewJobPage__subheading__BB1BL","ViewJobPage__confirmation":"new-job_ViewJobPage__confirmation__82kuf","ViewJobPage__Logo":"new-job_ViewJobPage__Logo__XC7Fm","ViewJobPage__BrandLogo":"new-job_ViewJobPage__BrandLogo__YIBnL","ViewJobPage__BrandLogo__Padding10":"new-job_ViewJobPage__BrandLogo__Padding10__ObirR","ViewJobPage__Container":"new-job_ViewJobPage__Container__F_1DI","ViewJobPage__JobContent":"new-job_ViewJobPage__JobContent__TvFNx","ViewJobPage__Sidebar":"new-job_ViewJobPage__Sidebar__p4cKO","ViewJobPage__Sidebar2":"new-job_ViewJobPage__Sidebar2__G3Iy1","ViewJobPage__Description":"new-job_ViewJobPage__Description__n7_AQ","ViewJobPage__DescriptionWidth":"new-job_ViewJobPage__DescriptionWidth__WFHD_","ViewJobPage__Footer":"new-job_ViewJobPage__Footer__ZUsyI","ViewJobPage__FooterView":"new-job_ViewJobPage__FooterView__j3_4i","ViewJobPage__ShareJob":"new-job_ViewJobPage__ShareJob__XsxUd","ViewJobPage__SubmitSection":"new-job_ViewJobPage__SubmitSection__Y6PJE","ViewJobPage__SocialMedia":"new-job_ViewJobPage__SocialMedia__Oka32","ViewJobPage__SideContent":"new-job_ViewJobPage__SideContent__uJ1Ui","ViewJobPage__ApplySection":"new-job_ViewJobPage__ApplySection__xYLad","FormBox__Autofill":"new-job_FormBox__Autofill__Atjyo","applybuttons":"new-job_applybuttons__U_rel","height90":"new-job_height90__sR2ao","Form__Cont":"new-job_Form__Cont__ie1SC","Form__DropBox":"new-job_Form__DropBox__F5SNZ","Form__DropBoxcontainer":"new-job_Form__DropBoxcontainer___hCK5","Form__DropBoxError":"new-job_Form__DropBoxError__y8hY_","Form__DropBoxicon":"new-job_Form__DropBoxicon__z4bQ_","Form__DropBoxmessage":"new-job_Form__DropBoxmessage__KGJ3v","noDpGrid":"new-job_noDpGrid__Swm2r","Terms":"new-job_Terms__Tz2qy","TermsCondition":"new-job_TermsCondition__Ox0V_","TermsCondition__alignterms":"new-job_TermsCondition__alignterms__xY9GG","MenuContainer":"new-job_MenuContainer__9ewZL","MenuContainer__Menu":"new-job_MenuContainer__Menu__6NAsz","AgencyDetailPage":"new-job_AgencyDetailPage__v_K8p","Congrats__ModalContent":"new-job_Congrats__ModalContent__cUQs5","NewJob__Container":"new-job_NewJob__Container__7o7j4","NewJob__TopSection":"new-job_NewJob__TopSection__4wMgw","NewJob__HorizontalDivider":"new-job_NewJob__HorizontalDivider__9cS1Z","NewJob__Wrapper":"new-job_NewJob__Wrapper__GA3Xu","NewJob__ContainerPadding":"new-job_NewJob__ContainerPadding__9_YFC","NewJob__ContainerScroll":"new-job_NewJob__ContainerScroll__ZVWWt","NewJob__ContainerHeight":"new-job_NewJob__ContainerHeight__wdt2Y","NewJob__ImportAction":"new-job_NewJob__ImportAction__OM2eF","NewJob__Interview_buttons":"new-job_NewJob__Interview_buttons__3NFTR","Form__TableRowMB":"new-job_Form__TableRowMB__sYgEN","Form__TableRow3grid":"new-job_Form__TableRow3grid__CUNQM","Form__Remotegrid":"new-job_Form__Remotegrid__lv_Rr","Form__TypeList":"new-job_Form__TypeList__cARy3","Form__Type":"new-job_Form__Type__TbkDx","Form__CheckLabel":"new-job_Form__CheckLabel__YCcU3","PrivateSwitchBase-root-1":"new-job_PrivateSwitchBase-root-1__ndHB_","Form__Caption":"new-job_Form__Caption___TywS","Form__Input_currency":"new-job_Form__Input_currency__LLu8_","Form__Input_MatchScore":"new-job_Form__Input_MatchScore__V0Ra5","Form__Percentage_Symbol":"new-job_Form__Percentage_Symbol__0L88m","Form__NoGridTemplate":"new-job_Form__NoGridTemplate__lcXjX","active":"new-job_active__5fhO2","mt10":"new-job_mt10__EtOq2","mt40":"new-job_mt40__yxmZl","mt30":"new-job_mt30__HwL4T","mt32":"new-job_mt32__ITtA2","mb0":"new-job_mb0__pPOjb","Dpgrid":"new-job_Dpgrid__mg6SE","mb12":"new-job_mb12__0LFDh","width100":"new-job_width100__NFUyT","Tagrow__Prefix":"new-job_Tagrow__Prefix__Zm480","PreviewJobPage":"new-job_PreviewJobPage__vmlsM","PreviewJob":"new-job_PreviewJob__FJJM9","DpFlx":"new-job_DpFlx__XK1qW","Subheading__Description":"new-job_Subheading__Description__IhLia","Candidate__Tooltip":"new-job_Candidate__Tooltip__rAEI1","Candidate__Tooltip__Score":"new-job_Candidate__Tooltip__Score__LF8AR","Form__InputField":"new-job_Form__InputField__pulRk","Candidate__Length":"new-job_Candidate__Length__E2AER","Agency__PostDay":"new-job_Agency__PostDay__TEtK7","Agency__Title":"new-job_Agency__Title__bl9Gj","Agency__Location":"new-job_Agency__Location__QAhLt","Agency__DescriptionTitle":"new-job_Agency__DescriptionTitle__m06KM","Agency__Description":"new-job_Agency__Description__JP7vi","LightBlueColor":"new-job_LightBlueColor__VESB0"};

/***/ }),

/***/ 9765:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"scorecards-component_Form__oK56X","Form__width":"scorecards-component_Form__width__jAkXk","Form__label":"scorecards-component_Form__label__tpo4N","Form__textleft":"scorecards-component_Form__textleft__Qn8Dd","Form__InputFullWidth":"scorecards-component_Form__InputFullWidth__oXEej","Form__Input":"scorecards-component_Form__Input__1f1mc","LightBox__Competency":"scorecards-component_LightBox__Competency__Ww2jC","LightBox__SubCompetency":"scorecards-component_LightBox__SubCompetency__VRula","AddNotes":"scorecards-component_AddNotes__hrHtt","Form__InputSection":"scorecards-component_Form__InputSection__1FBXB","Form__ScoreCardInput":"scorecards-component_Form__ScoreCardInput__ly4TT","Form__Textarea":"scorecards-component_Form__Textarea__Lde1W","Tagrow":"scorecards-component_Tagrow__Y91q9","Tagrow__Tags":"scorecards-component_Tagrow__Tags__vkUBm","Tagrow__Cancel":"scorecards-component_Tagrow__Cancel__wmqzi","Tagrow__Prefix":"scorecards-component_Tagrow__Prefix__apgTN","Form__Input398":"scorecards-component_Form__Input398__PFC_E","primarybtn":"scorecards-component_primarybtn__xjNmF","secondarybtn":"scorecards-component_secondarybtn__Il4Wq","iconFilled":"scorecards-component_iconFilled__5mMeB","iconFilledSolid":"scorecards-component_iconFilledSolid__7RAsQ","primarybtnborder":"scorecards-component_primarybtnborder__ZMxcL","secondarybtnborder":"scorecards-component_secondarybtnborder__XuVFd","tertiarybtn":"scorecards-component_tertiarybtn___XACL","graybtnborder":"scorecards-component_graybtnborder__iMJm_","jobsrchbtn":"scorecards-component_jobsrchbtn__Km6w9","jobsrchbtnalign":"scorecards-component_jobsrchbtnalign__YK__q","nobgbutton":"scorecards-component_nobgbutton__06nJD","iconTextButton":"scorecards-component_iconTextButton__sf5bs","cursornone":"scorecards-component_cursornone__MRQm9","nobgbuttonprimary":"scorecards-component_nobgbuttonprimary__zSmIZ","mt15":"scorecards-component_mt15__hQrff","btn350":"scorecards-component_btn350__6OMi3","GrayBgBtn":"scorecards-component_GrayBgBtn__QXEQk","NewShareBtn":"scorecards-component_NewShareBtn__yvpuQ","CoralBgBtn":"scorecards-component_CoralBgBtn__gGgCT","DropContainer":"scorecards-component_DropContainer__Dm1di","DropContainer__Inner":"scorecards-component_DropContainer__Inner__yXakP","CompanyProfile__Inner":"scorecards-component_CompanyProfile__Inner__Yyva1","DropContainer__Message":"scorecards-component_DropContainer__Message__mIlpG","CompanyProfile__Message":"scorecards-component_CompanyProfile__Message__W6M3d","CompanyProfile__MessageContent":"scorecards-component_CompanyProfile__MessageContent__XmllE","DropContainer__UploadIcon":"scorecards-component_DropContainer__UploadIcon__7tmcM","CompanyProfile__UploadIcon":"scorecards-component_CompanyProfile__UploadIcon__we7gC","FileDisplayContainer":"scorecards-component_FileDisplayContainer__xjBuI","FileDisplayContainer__Status":"scorecards-component_FileDisplayContainer__Status__Yaa6q","FileDisplayContainer__Type":"scorecards-component_FileDisplayContainer__Type__bFFa8","FileDisplayContainer__Name":"scorecards-component_FileDisplayContainer__Name__5oAzs","FileDisplayContainer__Error":"scorecards-component_FileDisplayContainer__Error__3_bUU","FileDisplayContainer__Close":"scorecards-component_FileDisplayContainer__Close__Fjkik","Browse":"scorecards-component_Browse__yqOCu","ClientCompany":"scorecards-component_ClientCompany__SyP4C","ClientCompany__TopSection2":"scorecards-component_ClientCompany__TopSection2__o24PH","ClientCompany__Filter":"scorecards-component_ClientCompany__Filter__Guvvg","ClientCompany__Input_MatchScore":"scorecards-component_ClientCompany__Input_MatchScore__ASB_F","ClientCompany__Percentage_Symbol":"scorecards-component_ClientCompany__Percentage_Symbol__uUvS2","ClientCompany__Filterheading":"scorecards-component_ClientCompany__Filterheading__eqoyP","ClientCompany__FloatButtonAdd":"scorecards-component_ClientCompany__FloatButtonAdd__a7cds","ClientCompany__FloatButtonAdd__AgencyUserIcon":"scorecards-component_ClientCompany__FloatButtonAdd__AgencyUserIcon__ngr43","ClientCompany__LastEdited":"scorecards-component_ClientCompany__LastEdited__oiYq_","ClientCompany__BackSection":"scorecards-component_ClientCompany__BackSection__aos_2","ClientCompany__BackSection__CloseIcon":"scorecards-component_ClientCompany__BackSection__CloseIcon__Lhlsd","ClientCompany__Container":"scorecards-component_ClientCompany__Container__9J38c","ClientCompany__FormInputSection":"scorecards-component_ClientCompany__FormInputSection__lERPD","CompanyProfile__FormInputSection":"scorecards-component_CompanyProfile__FormInputSection__baKGk","ClientCompany__Heading":"scorecards-component_ClientCompany__Heading__9PYkY","ClientCompany__StatusAlignment":"scorecards-component_ClientCompany__StatusAlignment__NMi_a","ClientCompany__Status":"scorecards-component_ClientCompany__Status__oKhiC","ClientCompany__ActiveDot":"scorecards-component_ClientCompany__ActiveDot__YhpWP","ClientCompany__CloseDot":"scorecards-component_ClientCompany__CloseDot__z_Mgx","ClientCompany__Company":"scorecards-component_ClientCompany__Company__zIlCr","ClientCompany__Systemrefheding":"scorecards-component_ClientCompany__Systemrefheding__1LpGM","ClientCompany__Subheading":"scorecards-component_ClientCompany__Subheading__Dmmt0","CompanyProfile__Subheading":"scorecards-component_CompanyProfile__Subheading__i7ZXa","ClientCompany__Subheading2":"scorecards-component_ClientCompany__Subheading2__t5Qgp","ClientCompany__Description":"scorecards-component_ClientCompany__Description__DB8_E","ClientCompany__SubmitSection":"scorecards-component_ClientCompany__SubmitSection___oojw","ClientCompany__IntegrationImage":"scorecards-component_ClientCompany__IntegrationImage__7JBC_","ClientCompany__QuickAdd":"scorecards-component_ClientCompany__QuickAdd__fZQXS","ClientCompany__BodyText":"scorecards-component_ClientCompany__BodyText__yq3Ai","Form__TableRow":"scorecards-component_Form__TableRow__f83tI","Form__Label":"scorecards-component_Form__Label__rBkAW","Form__FloatingLabel":"scorecards-component_Form__FloatingLabel__6tisU","Form__TableCol":"scorecards-component_Form__TableCol__e3g0D","Form__currency_symbol":"scorecards-component_Form__currency_symbol__4yr4n","Form__CustomSelect":"scorecards-component_Form__CustomSelect__8z652","Form__currency_symbol__right":"scorecards-component_Form__currency_symbol__right__n4lEd","Form__TableCol__Disabled":"scorecards-component_Form__TableCol__Disabled__Jcb47","Form__TextareaDisabled":"scorecards-component_Form__TextareaDisabled__QRoDr","Form__EditorDisabled":"scorecards-component_Form__EditorDisabled__Ky8OP","Form__AdminCheckLabel":"scorecards-component_Form__AdminCheckLabel__VM_bt","Form__AdminCheckMargin":"scorecards-component_Form__AdminCheckMargin__lFAwU","CompanyProfile__BrandingGuide":"scorecards-component_CompanyProfile__BrandingGuide__WRtqQ","CompanyProfile__DropBoxContainer":"scorecards-component_CompanyProfile__DropBoxContainer__VtbEt","CompanyProfile__Browse":"scorecards-component_CompanyProfile__Browse__chDv8","ErrorLabel":"scorecards-component_ErrorLabel__eDt9_","Height80":"scorecards-component_Height80__5zlCt","Browse__ButtonFlexEnd":"scorecards-component_Browse__ButtonFlexEnd__NrdEn","AddAgency__Container":"scorecards-component_AddAgency__Container__swUTd","AddAgency__FormInputSection":"scorecards-component_AddAgency__FormInputSection__8G6uv","AddAgency__FormInputSection__Label":"scorecards-component_AddAgency__FormInputSection__Label__XNSfX","AddAgency__Form":"scorecards-component_AddAgency__Form__MFaCE","LinkAsButtons":"scorecards-component_LinkAsButtons__HpZBY","SearchFlex":"scorecards-component_SearchFlex__R0Xxa","AutoSuggestInputContainer":"scorecards-component_AutoSuggestInputContainer__xD3Bw","CreateScoreCard":"scorecards-component_CreateScoreCard__DorN5","CreateScoreCard__Card":"scorecards-component_CreateScoreCard__Card__l1MS_","CreateScoreCard__Close":"scorecards-component_CreateScoreCard__Close__ITUNZ","w100":"scorecards-component_w100__y0kAb","mw420":"scorecards-component_mw420__Rt5kr","CreateScoreCard__SaveDraftButton":"scorecards-component_CreateScoreCard__SaveDraftButton__uitBj","CreateScoreCard__TopSection":"scorecards-component_CreateScoreCard__TopSection__XU0fk","CreateScoreCard__Subheading":"scorecards-component_CreateScoreCard__Subheading__xIFXB","CreateScoreCard__Desc":"scorecards-component_CreateScoreCard__Desc__AmCEj","CreateScoreCard__Competency":"scorecards-component_CreateScoreCard__Competency__Zw_YH","CreateScoreCard__SubCompetency":"scorecards-component_CreateScoreCard__SubCompetency___UwaP","Anchor__Add":"scorecards-component_Anchor__Add__HVCcY","LightBox":"scorecards-component_LightBox__5UNUP","LightBox__CompetencyLink":"scorecards-component_LightBox__CompetencyLink___3jQs","LightBox__OnlyCompetency":"scorecards-component_LightBox__OnlyCompetency__eBZa7","LeftSide":"scorecards-component_LeftSide__pXmx3","RightSide":"scorecards-component_RightSide__exqHt","Dpflex":"scorecards-component_Dpflex__w9kFb","CompetencyContainer":"scorecards-component_CompetencyContainer__dP7cl","AddCompetencyBtn":"scorecards-component_AddCompetencyBtn__hzz4O","SubCompetency":"scorecards-component_SubCompetency__GrC_8","CloseIcon_Width":"scorecards-component_CloseIcon_Width__0PEex","Button":"scorecards-component_Button__QGZyy","Editor":"scorecards-component_Editor__bWpR1","AddScoreLink":"scorecards-component_AddScoreLink__goxjC","addLink":"scorecards-component_addLink__N4KoD","CustomCheckLabel":"scorecards-component_CustomCheckLabel__d7qL2","Tagrow__TagsHeight":"scorecards-component_Tagrow__TagsHeight__YFU5D","Tagrow__CancelSmall":"scorecards-component_Tagrow__CancelSmall__EBqda","ScorecardInputError":"scorecards-component_ScorecardInputError__5zFoo","ClientCompany__FormSection":"scorecards-component_ClientCompany__FormSection__eCBks","ClientCompany__LeftContent":"scorecards-component_ClientCompany__LeftContent__2ab1a","ClientCompany__RightContent":"scorecards-component_ClientCompany__RightContent__JKOx2","ClientCompany__SmallHeading":"scorecards-component_ClientCompany__SmallHeading__mJL_h","importbtn":"scorecards-component_importbtn__9v6Z0","SearchIcon":"scorecards-component_SearchIcon__hYGIM","LabelTitle":"scorecards-component_LabelTitle__kniOQ","Form__Remotegrid":"scorecards-component_Form__Remotegrid__kNruw","Form__TableRow3grid":"scorecards-component_Form__TableRow3grid__Kqapt","NewJob__QuickAdd":"scorecards-component_NewJob__QuickAdd__P9_U9","NewJob__TopSection":"scorecards-component_NewJob__TopSection__F7KNK","NewJob__Interview_buttons":"scorecards-component_NewJob__Interview_buttons__2M6du","NewJob__ImportAction":"scorecards-component_NewJob__ImportAction__Ivohp","Scorecards__CompetencySection":"scorecards-component_Scorecards__CompetencySection__JCegW","NewJob":"scorecards-component_NewJob__Bw5J8","NewJob__Container":"scorecards-component_NewJob__Container__M3n8E","NewJob__SubmitSection":"scorecards-component_NewJob__SubmitSection__dYyF5","mt40":"scorecards-component_mt40__kcK9y","Scorecards":"scorecards-component_Scorecards__w5BW8","Scorecards__CustomSelect":"scorecards-component_Scorecards__CustomSelect__n8I9X","css-yk16xz-control":"scorecards-component_css-yk16xz-control__otp2V","Scorecards__AddStageSection":"scorecards-component_Scorecards__AddStageSection__2rRK_"};

/***/ }),

/***/ 90837:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"scorecards_Form__MvHOt","Form__width":"scorecards_Form__width__RViVb","Form__label":"scorecards_Form__label__kUCQ4","Form__textleft":"scorecards_Form__textleft__5_ggZ","Form__InputFullWidth":"scorecards_Form__InputFullWidth__xoRWP","Form__Input":"scorecards_Form__Input__VJh6E","Form__Input398":"scorecards_Form__Input398__b9Wor","Form__InputSection":"scorecards_Form__InputSection__rGnWT","Form__ScoreCardInput":"scorecards_Form__ScoreCardInput__N_WTt","Form__Textarea":"scorecards_Form__Textarea__wHqb_","primarybtn":"scorecards_primarybtn___3AGt","GoBtn":"scorecards_GoBtn__gQtDj","secondarybtn":"scorecards_secondarybtn__PTRLA","iconFilled":"scorecards_iconFilled__1VmTO","iconFilledSolid":"scorecards_iconFilledSolid___srfB","primarybtnborder":"scorecards_primarybtnborder__7wRpy","secondarybtnborder":"scorecards_secondarybtnborder__SaR1M","ClearBtn":"scorecards_ClearBtn___rdbU","tertiarybtn":"scorecards_tertiarybtn__M_7z_","graybtnborder":"scorecards_graybtnborder__0ALkk","jobsrchbtn":"scorecards_jobsrchbtn__IGudH","jobsrchbtnalign":"scorecards_jobsrchbtnalign__Cf8nd","nobgbutton":"scorecards_nobgbutton__X8ell","iconTextButton":"scorecards_iconTextButton__cFL6g","cursornone":"scorecards_cursornone__UMA5X","nobgbuttonprimary":"scorecards_nobgbuttonprimary__20bBn","mt15":"scorecards_mt15__f1ETw","btn350":"scorecards_btn350___WcFT","GrayBgBtn":"scorecards_GrayBgBtn__PN0lI","NewShareBtn":"scorecards_NewShareBtn__rbjEG","CoralBgBtn":"scorecards_CoralBgBtn__9wO4i","DropContainer":"scorecards_DropContainer__kN8lI","DropContainer__Inner":"scorecards_DropContainer__Inner__wmGk9","CompanyProfile__Inner":"scorecards_CompanyProfile__Inner__pO_yA","DropContainer__Message":"scorecards_DropContainer__Message__Yu0Tw","CompanyProfile__Message":"scorecards_CompanyProfile__Message__WntIK","CompanyProfile__MessageContent":"scorecards_CompanyProfile__MessageContent___FY_j","DropContainer__UploadIcon":"scorecards_DropContainer__UploadIcon__HgUnx","CompanyProfile__UploadIcon":"scorecards_CompanyProfile__UploadIcon___tDLh","FileDisplayContainer":"scorecards_FileDisplayContainer__bxA0V","FileDisplayContainer__Status":"scorecards_FileDisplayContainer__Status__0p8Xp","FileDisplayContainer__Type":"scorecards_FileDisplayContainer__Type__we62L","FileDisplayContainer__Name":"scorecards_FileDisplayContainer__Name__OouZc","FileDisplayContainer__Error":"scorecards_FileDisplayContainer__Error__YM_iX","FileDisplayContainer__Close":"scorecards_FileDisplayContainer__Close__p_M3e","Browse":"scorecards_Browse__Yu2uq","ClientCompany":"scorecards_ClientCompany__UwT_w","NewJob":"scorecards_NewJob__vuidj","Interview":"scorecards_Interview__v6yRH","ClientCompany__TopSection2":"scorecards_ClientCompany__TopSection2__5_68H","ClientCompany__Filter":"scorecards_ClientCompany__Filter__XsdmY","ClientCompany__Input_MatchScore":"scorecards_ClientCompany__Input_MatchScore____U7W","ClientCompany__Percentage_Symbol":"scorecards_ClientCompany__Percentage_Symbol__atCw6","ClientCompany__Filterheading":"scorecards_ClientCompany__Filterheading__xJLTj","ClientCompany__FloatButtonAdd":"scorecards_ClientCompany__FloatButtonAdd__qVUB5","ClientCompany__FloatButtonAdd__AgencyUserIcon":"scorecards_ClientCompany__FloatButtonAdd__AgencyUserIcon__01liC","ClientCompany__LastEdited":"scorecards_ClientCompany__LastEdited__SKPWX","ClientCompany__BackSection":"scorecards_ClientCompany__BackSection__bIjt_","AddUsers__BackSection":"scorecards_AddUsers__BackSection__LKM9y","ClientCompany__BackSection__CloseIcon":"scorecards_ClientCompany__BackSection__CloseIcon__yDvCD","ClientCompany__Container":"scorecards_ClientCompany__Container__6i1Aa","NewJob__InterviewContainer":"scorecards_NewJob__InterviewContainer__Jag2v","AddUsers__Container":"scorecards_AddUsers__Container__rUFzh","ClientCompany__FormInputSection":"scorecards_ClientCompany__FormInputSection__W5Io9","CompanyProfile__FormInputSection":"scorecards_CompanyProfile__FormInputSection__ZDyOe","ClientCompany__Heading":"scorecards_ClientCompany__Heading__dfMDC","AddUsers__Heading":"scorecards_AddUsers__Heading__MLd4b","ClientCompany__StatusAlignment":"scorecards_ClientCompany__StatusAlignment___HNYa","ClientCompany__Status":"scorecards_ClientCompany__Status__pv8da","ClientCompany__ActiveDot":"scorecards_ClientCompany__ActiveDot__0fgtV","ClientCompany__CloseDot":"scorecards_ClientCompany__CloseDot__uqieZ","ClientCompany__Company":"scorecards_ClientCompany__Company__FMxVw","AddUsers__User":"scorecards_AddUsers__User__Poe7L","ClientCompany__Systemrefheding":"scorecards_ClientCompany__Systemrefheding__nTkAi","ClientCompany__Subheading":"scorecards_ClientCompany__Subheading__RVj2P","Scorecards__Subheading":"scorecards_Scorecards__Subheading__dkWjB","CompanyProfile__Subheading":"scorecards_CompanyProfile__Subheading__3aMm1","ClientCompany__Subheading2":"scorecards_ClientCompany__Subheading2__G0sdy","ClientCompany__Description":"scorecards_ClientCompany__Description__GXKIf","ClientCompany__SubmitSection":"scorecards_ClientCompany__SubmitSection__nN_1Y","NewJob__SubmitSection":"scorecards_NewJob__SubmitSection__d7A8q","NewJob__SubmitSectionThreeBtn":"scorecards_NewJob__SubmitSectionThreeBtn__YbOPb","NewJob__SubmitSectionOneBtnPlacement":"scorecards_NewJob__SubmitSectionOneBtnPlacement__9Ba_E","NewJob__ImportSection":"scorecards_NewJob__ImportSection__hn8YG","AddUsers__SubmitSection":"scorecards_AddUsers__SubmitSection__tQtQi","ClientCompany__IntegrationImage":"scorecards_ClientCompany__IntegrationImage__Rgkno","ClientCompany__QuickAdd":"scorecards_ClientCompany__QuickAdd__Dm4nZ","NewJob__QuickAdd":"scorecards_NewJob__QuickAdd__D9LWp","Interview__QuickAdd":"scorecards_Interview__QuickAdd__I_uGw","ClientCompany__BodyText":"scorecards_ClientCompany__BodyText__kL1Jy","Form__TableRow":"scorecards_Form__TableRow__6dDz6","Form__Label":"scorecards_Form__Label__Jp69a","Form__FloatingLabel":"scorecards_Form__FloatingLabel__UuLNf","Form__TableCol":"scorecards_Form__TableCol__OIIe_","Form__currency_symbol":"scorecards_Form__currency_symbol__nZLQl","Form__CustomSelect":"scorecards_Form__CustomSelect__t5MK5","Form__currency_symbol__right":"scorecards_Form__currency_symbol__right__b0zoR","Form__TableCol__Disabled":"scorecards_Form__TableCol__Disabled__WFlG_","Form__TextareaDisabled":"scorecards_Form__TextareaDisabled__CJvA3","Form__EditorDisabled":"scorecards_Form__EditorDisabled__eFiLx","Form__AdminCheckLabel":"scorecards_Form__AdminCheckLabel__I0EeT","Form__AdminCheckMargin":"scorecards_Form__AdminCheckMargin__qWJ7V","CompanyProfile__BrandingGuide":"scorecards_CompanyProfile__BrandingGuide__hmjdr","CompanyProfile__DropBoxContainer":"scorecards_CompanyProfile__DropBoxContainer__3zJdD","CompanyProfile__Browse":"scorecards_CompanyProfile__Browse__emm3L","ErrorLabel":"scorecards_ErrorLabel__Bfdbo","Height80":"scorecards_Height80__xAsvn","Browse__ButtonFlexEnd":"scorecards_Browse__ButtonFlexEnd__H84Sk","AddAgency__Container":"scorecards_AddAgency__Container__saHCY","AddAgency__FormInputSection":"scorecards_AddAgency__FormInputSection__Me0Dh","AddAgency__FormInputSection__Label":"scorecards_AddAgency__FormInputSection__Label__WIJd1","AddAgency__Form":"scorecards_AddAgency__Form__TTfn7","LinkAsButtons":"scorecards_LinkAsButtons__DRT_v","SearchFlex":"scorecards_SearchFlex__QFu1S","Form__ErrorCustomSelect":"scorecards_Form__ErrorCustomSelect__wdd06","Form__select_currency":"scorecards_Form__select_currency__5xdhM","customSelect__placeholder":"scorecards_customSelect__placeholder__IZMjX","Career":"scorecards_Career___xNI_","Career__Background_Edit":"scorecards_Career__Background_Edit__HzIA3","Career__Background_Edit_Image":"scorecards_Career__Background_Edit_Image__eyth0","Career__Container":"scorecards_Career__Container__bGuqZ","Career__Inner":"scorecards_Career__Inner__C8NnB","Career__logo":"scorecards_Career__logo__8dOji","Career__Content":"scorecards_Career__Content__47GlK","Career__ButtonSection":"scorecards_Career__ButtonSection__OhULe","Job":"scorecards_Job__oOwIY","Job__Inner":"scorecards_Job__Inner__iAv4V","Job__Container":"scorecards_Job__Container__OiyGU","Job__Heading":"scorecards_Job__Heading__UjMdV","Job__Company":"scorecards_Job__Company__QeId8","Job__SearchContainer":"scorecards_Job__SearchContainer__h9EGT","Job__SearchInput":"scorecards_Job__SearchInput__Hi9JG","Job__Searchbtn":"scorecards_Job__Searchbtn__ldpaB","Job__Input":"scorecards_Job__Input__qRsYa","Job__SelectJob":"scorecards_Job__SelectJob__1zowx","Job__RemoteLabel":"scorecards_Job__RemoteLabel__jmWI1","Job__Display":"scorecards_Job__Display__oYf0E","Job__PostDay":"scorecards_Job__PostDay__Mko5P","Job__Title":"scorecards_Job__Title__fvllD","Job__Location":"scorecards_Job__Location__NSTxB","DT":"scorecards_DT__rSFWZ","DisplayTable":"scorecards_DisplayTable__1WsEH","pd11":"scorecards_pd11__wJqmT","Label":"scorecards_Label__e96ME","inputwidth":"scorecards_inputwidth__Cf1IO","mr24":"scorecards_mr24__2oWRl","fullwidth":"scorecards_fullwidth__8PtnA","padt40":"scorecards_padt40__oijSF","Form__TableRowflex":"scorecards_Form__TableRowflex__iTcS2","Form__TableColm":"scorecards_Form__TableColm__0joUR","Form__LabelCheck":"scorecards_Form__LabelCheck__RCZp6","Form__Error":"scorecards_Form__Error__RQQE7","Form__ErrorSection":"scorecards_Form__ErrorSection__WStf6","Form__MessagePlaceholder":"scorecards_Form__MessagePlaceholder__QiASn","Form__Submit":"scorecards_Form__Submit__a5Jp_","Form__NormalLabel":"scorecards_Form__NormalLabel__ixFsw","AddInterview":"scorecards_AddInterview__PxwGw","IntegrationPage":"scorecards_IntegrationPage__mJw96","Integration__BackStep":"scorecards_Integration__BackStep__ItoCc","AddUsers__BackStep":"scorecards_AddUsers__BackStep__VSAte","Integration__SubmitSection":"scorecards_Integration__SubmitSection__mrQgi","IntegrationTable":"scorecards_IntegrationTable__CBITy","IntegrationTable__LimitInput":"scorecards_IntegrationTable__LimitInput__YZfPC","IntegrationTable__Type":"scorecards_IntegrationTable__Type__Daswf","IntegrationTable__AllJobsToggle":"scorecards_IntegrationTable__AllJobsToggle__9mO7W","IntegrationTable__switch":"scorecards_IntegrationTable__switch__ZYP5k","IntegrationTable__switchText":"scorecards_IntegrationTable__switchText__9yURw","IntegrationTable__slider":"scorecards_IntegrationTable__slider__T37Kl","IntegrationTable__round":"scorecards_IntegrationTable__round__LmYur","IntegrationTable__Action":"scorecards_IntegrationTable__Action__7qFKD","IntegrationView":"scorecards_IntegrationView__4fhmK","IntegrationView__Title":"scorecards_IntegrationView__Title__srb04","IntegrationView__Subheading":"scorecards_IntegrationView__Subheading__1muCP","IntegrationView__BoxImage":"scorecards_IntegrationView__BoxImage__aRRQK","IntegrationView__Box":"scorecards_IntegrationView__Box__UFFwB","IntegrationView__BoxImage__InfoIcon":"scorecards_IntegrationView__BoxImage__InfoIcon__T9_LH","IntegrationView__ViewMoreButton":"scorecards_IntegrationView__ViewMoreButton__8iX0S","IntegrationView__ConnectButton":"scorecards_IntegrationView__ConnectButton__v74Q4","IntegrationView__GoogleButton":"scorecards_IntegrationView__GoogleButton__kzoRZ","IntegrationView__FlexFlow":"scorecards_IntegrationView__FlexFlow__XNW3A","IntegrationView__BoxWidth":"scorecards_IntegrationView__BoxWidth__eHdOM","SkipFinishButton":"scorecards_SkipFinishButton__4h3N_","AddUsers":"scorecards_AddUsers__vteJJ","AddUsers__ButtonSection":"scorecards_AddUsers__ButtonSection__lpS1f","AddUsers__QuickStepHeading":"scorecards_AddUsers__QuickStepHeading__cN4ld","AddUsers__DeleteSection":"scorecards_AddUsers__DeleteSection__UgFLA","Interview__DeleteSection":"scorecards_Interview__DeleteSection__3qdhk","AddUsers__DeleteCrossHeight":"scorecards_AddUsers__DeleteCrossHeight___Ks90","AddUsers__Form__Input":"scorecards_AddUsers__Form__Input__8Yf5i","AddUsers__FormHeadingSection":"scorecards_AddUsers__FormHeadingSection__96t1j","Interview__FormHeadingSection":"scorecards_Interview__FormHeadingSection__56Bh7","AddUsers__FormSection":"scorecards_AddUsers__FormSection__p9Ry3","NewJob__FormSection":"scorecards_NewJob__FormSection__IsbZa","AddUsers__ButtonsActionSection":"scorecards_AddUsers__ButtonsActionSection__AKr8M","AddUsers__ImportUsers":"scorecards_AddUsers__ImportUsers__MVHqN","AddUsers__NameInput":"scorecards_AddUsers__NameInput__oPC5j","AddUsers__EmailInput":"scorecards_AddUsers__EmailInput__5v2Da","AddUsers__RoleInput":"scorecards_AddUsers__RoleInput__a5qjd","AddUsers__Subheading":"scorecards_AddUsers__Subheading__n6NfM","AddUsers__visible":"scorecards_AddUsers__visible__XrfL4","Tagrow":"scorecards_Tagrow__5_BVy","Tagrow__Tags":"scorecards_Tagrow__Tags___qHI8","Tagrow__Cancel":"scorecards_Tagrow__Cancel__jL4bw","Tagrow__Cross":"scorecards_Tagrow__Cross__V5FGg","SendInviteSection":"scorecards_SendInviteSection__pm7Le","error":"scorecards_error__J4x_S","ViewJobPage__Input":"scorecards_ViewJobPage__Input__FGBFX","Form__Input2":"scorecards_Form__Input2__YkCG9","ViewJobPage__PostDay":"scorecards_ViewJobPage__PostDay__EN6ko","ViewJobPage__Title":"scorecards_ViewJobPage__Title__4JYe9","ViewJobPage__DescriptionTitle":"scorecards_ViewJobPage__DescriptionTitle__dx4Az","ViewJobPage__Location":"scorecards_ViewJobPage__Location__pksWO","ViewJobPage__primarybtn":"scorecards_ViewJobPage__primarybtn__G2ih_","ViewJobPage__secondarybtn":"scorecards_ViewJobPage__secondarybtn__68E1E","ViewJobPage__secondarybtnborder":"scorecards_ViewJobPage__secondarybtnborder__GnXjf","ViewJobPage__BackSection":"scorecards_ViewJobPage__BackSection__sU1Zu","Modalpopup":"scorecards_Modalpopup__CB4OS","Modalpopup__inner":"scorecards_Modalpopup__inner__aYOkl","Modalpopup__Dialog":"scorecards_Modalpopup__Dialog__7yiW9","transition":"scorecards_transition__mmsPu","Modalpopup__CloseCenter":"scorecards_Modalpopup__CloseCenter__OR4CB","Modalpopup__Content":"scorecards_Modalpopup__Content__jThMp","ViewJobPage__Content":"scorecards_ViewJobPage__Content__zaoDc","Modalpopup__btn":"scorecards_Modalpopup__btn__Clon7","mar":"scorecards_mar__BaCSf","Otpback":"scorecards_Otpback__KE4wO","ViewJobPage":"scorecards_ViewJobPage__oz_zM","ViewJobPage__Header":"scorecards_ViewJobPage__Header__Q9zK1","ViewJobPage__Application":"scorecards_ViewJobPage__Application__jWK7A","ViewJobPage__RecordVideo":"scorecards_ViewJobPage__RecordVideo__aHEGo","ViewJobPage__RecordVideoSuccessText":"scorecards_ViewJobPage__RecordVideoSuccessText__a0C5C","ViewJobPage__subheading":"scorecards_ViewJobPage__subheading__HvXAe","ViewJobPage__confirmation":"scorecards_ViewJobPage__confirmation__B2TCW","ViewJobPage__Logo":"scorecards_ViewJobPage__Logo__E7iO5","ViewJobPage__BrandLogo":"scorecards_ViewJobPage__BrandLogo__qALWc","ViewJobPage__BrandLogo__Padding10":"scorecards_ViewJobPage__BrandLogo__Padding10__fSpY_","ViewJobPage__Container":"scorecards_ViewJobPage__Container__Xv_AX","ViewJobPage__JobContent":"scorecards_ViewJobPage__JobContent__D8T8m","ViewJobPage__Sidebar":"scorecards_ViewJobPage__Sidebar__2lfqF","ViewJobPage__Sidebar2":"scorecards_ViewJobPage__Sidebar2__n6w6l","ViewJobPage__Description":"scorecards_ViewJobPage__Description__Okk8d","ViewJobPage__DescriptionWidth":"scorecards_ViewJobPage__DescriptionWidth__aUwrf","ViewJobPage__Footer":"scorecards_ViewJobPage__Footer__gw0Bq","ViewJobPage__FooterView":"scorecards_ViewJobPage__FooterView__l2Hrf","ViewJobPage__ShareJob":"scorecards_ViewJobPage__ShareJob__wJ_vf","ViewJobPage__SubmitSection":"scorecards_ViewJobPage__SubmitSection__UECz0","ViewJobPage__SocialMedia":"scorecards_ViewJobPage__SocialMedia__KbLUR","ViewJobPage__SideContent":"scorecards_ViewJobPage__SideContent__y9QA1","ViewJobPage__ApplySection":"scorecards_ViewJobPage__ApplySection__5_2_T","FormBox__Autofill":"scorecards_FormBox__Autofill__2MXsJ","applybuttons":"scorecards_applybuttons__HSx03","height90":"scorecards_height90__MPj8W","Form__Cont":"scorecards_Form__Cont__oT_8U","Form__DropBox":"scorecards_Form__DropBox__BGJpG","Form__DropBoxcontainer":"scorecards_Form__DropBoxcontainer__NoQGN","Form__DropBoxError":"scorecards_Form__DropBoxError__4Mels","Form__DropBoxicon":"scorecards_Form__DropBoxicon__Z4i0V","Form__DropBoxmessage":"scorecards_Form__DropBoxmessage__335tV","noDpGrid":"scorecards_noDpGrid__E9AMg","Terms":"scorecards_Terms__Ihc8I","TermsCondition":"scorecards_TermsCondition__ZPX8v","TermsCondition__alignterms":"scorecards_TermsCondition__alignterms__Udmeg","MenuContainer":"scorecards_MenuContainer__blPbM","MenuContainer__Menu":"scorecards_MenuContainer__Menu__QCQYs","AgencyDetailPage":"scorecards_AgencyDetailPage__g1Gsj","Congrats__ModalContent":"scorecards_Congrats__ModalContent__wheZp","NewJob__Container":"scorecards_NewJob__Container__KufMb","NewJob__TopSection":"scorecards_NewJob__TopSection__XI8q2","Interview__TopSection":"scorecards_Interview__TopSection__d37BV","NewJob__HorizontalDivider":"scorecards_NewJob__HorizontalDivider__1aU_k","NewJob__Wrapper":"scorecards_NewJob__Wrapper__1ZQeY","NewJob__ContainerPadding":"scorecards_NewJob__ContainerPadding__Z_9_j","NewJob__ContainerScroll":"scorecards_NewJob__ContainerScroll__WYWWS","NewJob__ContainerHeight":"scorecards_NewJob__ContainerHeight__sTmjq","NewJob__ImportAction":"scorecards_NewJob__ImportAction__P4OEO","NewJob__Interview_buttons":"scorecards_NewJob__Interview_buttons__JjKj_","Form__TableRowMB":"scorecards_Form__TableRowMB__Q8pzq","Form__TableRow3grid":"scorecards_Form__TableRow3grid__sParQ","Form__Remotegrid":"scorecards_Form__Remotegrid__vaRDD","Form__TypeList":"scorecards_Form__TypeList__n_NYs","Form__Type":"scorecards_Form__Type__ManCC","Form__CheckLabel":"scorecards_Form__CheckLabel__kzxqw","PrivateSwitchBase-root-1":"scorecards_PrivateSwitchBase-root-1__q__pD","Form__Caption":"scorecards_Form__Caption__wqrhd","Form__Input_currency":"scorecards_Form__Input_currency__A4pZJ","Form__Input_MatchScore":"scorecards_Form__Input_MatchScore__LBbMZ","Form__Percentage_Symbol":"scorecards_Form__Percentage_Symbol__heZXG","Form__NoGridTemplate":"scorecards_Form__NoGridTemplate__Xc3qd","active":"scorecards_active__dw6Za","mt10":"scorecards_mt10__cIafs","mt40":"scorecards_mt40__kqSdb","mt30":"scorecards_mt30__roBz7","mt32":"scorecards_mt32__AfeTm","mb0":"scorecards_mb0__QhLk8","Dpgrid":"scorecards_Dpgrid__yBWXU","mb12":"scorecards_mb12__pe_7U","width100":"scorecards_width100__CJmBq","Tagrow__Prefix":"scorecards_Tagrow__Prefix__sYzp5","PreviewJobPage":"scorecards_PreviewJobPage__bY6B8","PreviewJob":"scorecards_PreviewJob__gYiwK","DpFlx":"scorecards_DpFlx__5JFdc","Subheading":"scorecards_Subheading__B668i","Subheading__Description":"scorecards_Subheading__Description__GWM4g","Candidate__Tooltip":"scorecards_Candidate__Tooltip__gH743","Candidate__Tooltip__Score":"scorecards_Candidate__Tooltip__Score__Z1Hfa","Form__InputField":"scorecards_Form__InputField__G6wD7","Candidate__Length":"scorecards_Candidate__Length__rqvkI","Agency__PostDay":"scorecards_Agency__PostDay__bJuJh","Agency__Title":"scorecards_Agency__Title__AePFH","Agency__Location":"scorecards_Agency__Location__TlQY5","Agency__DescriptionTitle":"scorecards_Agency__DescriptionTitle__E5b02","Agency__Description":"scorecards_Agency__Description__bDz76","LightBlueColor":"scorecards_LightBlueColor__L8bMX","Client_Page":"scorecards_Client_Page__YmZ1O","Welcome":"scorecards_Welcome__51YXO","Welcome__Inner":"scorecards_Welcome__Inner__c_b_l","Welcome__Person":"scorecards_Welcome__Person__QuXZq","Welcome__LeftContent":"scorecards_Welcome__LeftContent__gpGCX","Welcome__RightContent":"scorecards_Welcome__RightContent__dj7VA","Welcome__Content":"scorecards_Welcome__Content__slbsy","Welcome__CreateAccount":"scorecards_Welcome__CreateAccount__aQRC2","Welcome__title":"scorecards_Welcome__title__GBdzu","Welcome__FormBox":"scorecards_Welcome__FormBox__L0p3O","Form__psw":"scorecards_Form__psw___7WM_","Welcome__Container":"scorecards_Welcome__Container__JIHS8","Success__Container":"scorecards_Success__Container__FuYCT","Success":"scorecards_Success__PuTWw","Success__Inner":"scorecards_Success__Inner__xG3up","InterviewContainer":"scorecards_InterviewContainer__i5Ihz","Interview__Stages":"scorecards_Interview__Stages__GZlEd","Interview__StageHeading":"scorecards_Interview__StageHeading__sMxwu","pl10":"scorecards_pl10__e4PA7","Interview__AddStageSection":"scorecards_Interview__AddStageSection__O7LW8","Scorecards__AddStageSection":"scorecards_Scorecards__AddStageSection__UXdrp","Interview__Label":"scorecards_Interview__Label__Zn_1S","Interview__FormRowHeading":"scorecards_Interview__FormRowHeading__b91_J","dpflex":"scorecards_dpflex__cWdZN","Interview__IconsType":"scorecards_Interview__IconsType__sM6pn","Interview__Icons":"scorecards_Interview__Icons__ztzNj","Interview__Interview_buttons":"scorecards_Interview__Interview_buttons__JJaLm","Interview__approvalButton":"scorecards_Interview__approvalButton__ErM_o","Interview__BestMatch":"scorecards_Interview__BestMatch__vhNqI","Interview__BestMatchExclamation":"scorecards_Interview__BestMatchExclamation__Cygwi","DragAndDrop":"scorecards_DragAndDrop__ybrqJ","DragAndDrop__CursorHandle":"scorecards_DragAndDrop__CursorHandle__CjkB4","Tagrow__Image":"scorecards_Tagrow__Image__Lq6Ur","rowbglight":"scorecards_rowbglight__4T1A5","rowbgheight":"scorecards_rowbgheight__I_aNL","Form__w90":"scorecards_Form__w90__QTcWv","Container":"scorecards_Container__tecZO","Screening__StageName":"scorecards_Screening__StageName__lpelR","Screening__InterviewType":"scorecards_Screening__InterviewType__NuLjS","Screening__InterviewType__Label":"scorecards_Screening__InterviewType__Label__Lhs_8","Show_Infoicon":"scorecards_Show_Infoicon__GZMrm","Show_Infoicon_small":"scorecards_Show_Infoicon_small__g204Z","Screening__Info":"scorecards_Screening__Info__EdNV1","Screening__Info__IconWithText":"scorecards_Screening__Info__IconWithText__9WUge","InterviewType__Icon":"scorecards_InterviewType__Icon__gbH62","InterviewType__Text":"scorecards_InterviewType__Text__QDBZE","Scorecards__Des":"scorecards_Scorecards__Des__M4MHl","Scorecards__CompetencySection":"scorecards_Scorecards__CompetencySection__lNrCD","Score":"scorecards_Score__44_36","Job__SelectJob__dflex":"scorecards_Job__SelectJob__dflex__eTEXp","WrapperRadiocheckmark":"scorecards_WrapperRadiocheckmark__x1ZsU","CustomWrapperRadio":"scorecards_CustomWrapperRadio__oim3U","CustomWrapperRadio__ml225":"scorecards_CustomWrapperRadio__ml225__e_D0f","Scorecards":"scorecards_Scorecards__WRalz","Scorecards__CustomSelect":"scorecards_Scorecards__CustomSelect__E2CS_","css-yk16xz-control":"scorecards_css-yk16xz-control__BO81p"};

/***/ }),

/***/ 47327:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"success_Form__7fTE_","Form__width":"success_Form__width__vs51B","Form__label":"success_Form__label__NHZcy","Form__textleft":"success_Form__textleft__Kv8XX","Form__InputFullWidth":"success_Form__InputFullWidth__CpMO2","Form__Input":"success_Form__Input__u7KST","Form__InputSection":"success_Form__InputSection__2B7EG","Form__ScoreCardInput":"success_Form__ScoreCardInput__M5vv8","Form__Textarea":"success_Form__Textarea__trBo7","Client_Page":"success_Client_Page__woRU9","Form__Label":"success_Form__Label__AMkmj","Form__LabelCheck":"success_Form__LabelCheck__euNgv","Form__Error":"success_Form__Error__MRuM2","Form__ErrorSection":"success_Form__ErrorSection__JCrvR","Form__MessagePlaceholder":"success_Form__MessagePlaceholder__w98aX","Form__Submit":"success_Form__Submit__01JLu","Form__FloatingLabel":"success_Form__FloatingLabel__YI_Fs","Form__NormalLabel":"success_Form__NormalLabel__3LVXF","Form__TableCol":"success_Form__TableCol__tz2Qk","Form__currency_symbol":"success_Form__currency_symbol__UQkyD","Form__CustomSelect":"success_Form__CustomSelect__aGoEg","Form__currency_symbol__right":"success_Form__currency_symbol__right__qiL2q","AddInterview":"success_AddInterview__mySei","Welcome":"success_Welcome__28p6V","Welcome__Inner":"success_Welcome__Inner__Xlcuj","Welcome__Person":"success_Welcome__Person__Mtd71","Welcome__LeftContent":"success_Welcome__LeftContent__akxP8","Welcome__RightContent":"success_Welcome__RightContent__xryCW","Welcome__Content":"success_Welcome__Content__wo1K_","Welcome__CreateAccount":"success_Welcome__CreateAccount__hamtC","Welcome__title":"success_Welcome__title__2jm4s","Welcome__FormBox":"success_Welcome__FormBox__8ih2C","Form__psw":"success_Form__psw__CI4BA","Welcome__Container":"success_Welcome__Container__tVTFz","Success__Container":"success_Success__Container__LaSfG","Success":"success_Success__WBKJ0","Success__Inner":"success_Success__Inner__a8Urg"};

/***/ }),

/***/ 51841:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"add-offer_Form__6BPBi","Form__width":"add-offer_Form__width__XG_7O","Form__label":"add-offer_Form__label__C6Vin","Form__textleft":"add-offer_Form__textleft__ALW01","Form__InputFullWidth":"add-offer_Form__InputFullWidth__JuZHG","Form__Input":"add-offer_Form__Input___nvZW","Form__Input398":"add-offer_Form__Input398__E57iZ","Form__InputSection":"add-offer_Form__InputSection___8xEP","Form__ScoreCardInput":"add-offer_Form__ScoreCardInput__s4IFb","Form__Textarea":"add-offer_Form__Textarea__PtTI6","Form__CustomSelect":"add-offer_Form__CustomSelect__Bb0QM","Form__ErrorCustomSelect":"add-offer_Form__ErrorCustomSelect__KAqho","Form__currency_symbol":"add-offer_Form__currency_symbol__MukT6","Form__select_currency":"add-offer_Form__select_currency__a6Z0t","customSelect__placeholder":"add-offer_customSelect__placeholder__MUt7K","primarybtn":"add-offer_primarybtn__8MdzN","JobList__EditModalEditButton":"add-offer_JobList__EditModalEditButton__0RaFp","GoBtn":"add-offer_GoBtn__zemnC","secondarybtn":"add-offer_secondarybtn__wfBoQ","JobList__EditModalCancelButton":"add-offer_JobList__EditModalCancelButton__wLoM_","iconFilled":"add-offer_iconFilled__rHtya","iconFilledSolid":"add-offer_iconFilledSolid__xBisJ","primarybtnborder":"add-offer_primarybtnborder__cN1cG","secondarybtnborder":"add-offer_secondarybtnborder__Vpguw","ClearBtn":"add-offer_ClearBtn__MQvLK","tertiarybtn":"add-offer_tertiarybtn__vN8yE","graybtnborder":"add-offer_graybtnborder__KTph9","jobsrchbtn":"add-offer_jobsrchbtn__CWutt","jobsrchbtnalign":"add-offer_jobsrchbtnalign__Vu3Ir","nobgbutton":"add-offer_nobgbutton__o6tGM","iconTextButton":"add-offer_iconTextButton__6sR1l","cursornone":"add-offer_cursornone__LYckE","nobgbuttonprimary":"add-offer_nobgbuttonprimary__A3AK7","mt15":"add-offer_mt15__IatTw","btn350":"add-offer_btn350__JFMzG","GrayBgBtn":"add-offer_GrayBgBtn__eSQaz","NewShareBtn":"add-offer_NewShareBtn__lpJ7B","CoralBgBtn":"add-offer_CoralBgBtn__C4OKi","DropContainer":"add-offer_DropContainer__fgXJ5","DropContainer__Inner":"add-offer_DropContainer__Inner__XyHKs","CompanyProfile__Inner":"add-offer_CompanyProfile__Inner__b5zEm","DropContainer__Message":"add-offer_DropContainer__Message__DbazZ","CompanyProfile__Message":"add-offer_CompanyProfile__Message__Ls2pv","CompanyProfile__MessageContent":"add-offer_CompanyProfile__MessageContent__7NhVa","DropContainer__UploadIcon":"add-offer_DropContainer__UploadIcon__41sWA","CompanyProfile__UploadIcon":"add-offer_CompanyProfile__UploadIcon__B7NhE","FileDisplayContainer":"add-offer_FileDisplayContainer__DaQKM","FileDisplayContainer__Status":"add-offer_FileDisplayContainer__Status__KARAf","SetupPopup__Status":"add-offer_SetupPopup__Status__TzbHo","SetupPopup__To":"add-offer_SetupPopup__To__i9I1z","FileDisplayContainer__Type":"add-offer_FileDisplayContainer__Type__8vhj_","FileDisplayContainer__Name":"add-offer_FileDisplayContainer__Name__elDQM","SetupPopup__Name":"add-offer_SetupPopup__Name__rcdKb","SetupPopup__ToName":"add-offer_SetupPopup__ToName__nXazr","FileDisplayContainer__Error":"add-offer_FileDisplayContainer__Error__STUZr","FileDisplayContainer__Close":"add-offer_FileDisplayContainer__Close__AgET_","Browse":"add-offer_Browse__r0YSI","ClientCompany":"add-offer_ClientCompany__WK_YK","NewJob":"add-offer_NewJob__OKoTv","Interview":"add-offer_Interview__Zt9QX","ClientCompany__TopSection2":"add-offer_ClientCompany__TopSection2__jkPdy","ClientCompany__Filter":"add-offer_ClientCompany__Filter__omEIF","ClientCompany__Input_MatchScore":"add-offer_ClientCompany__Input_MatchScore__velLV","ClientCompany__Percentage_Symbol":"add-offer_ClientCompany__Percentage_Symbol__U1zyt","ClientCompany__Filterheading":"add-offer_ClientCompany__Filterheading__5a6dw","ClientCompany__FloatButtonAdd":"add-offer_ClientCompany__FloatButtonAdd__Ah95q","ClientCompany__FloatButtonAdd__AgencyUserIcon":"add-offer_ClientCompany__FloatButtonAdd__AgencyUserIcon__wHZco","ClientCompany__LastEdited":"add-offer_ClientCompany__LastEdited__2SyEH","ClientCompany__BackSection":"add-offer_ClientCompany__BackSection__k1SnI","AddUsers__BackSection":"add-offer_AddUsers__BackSection__eccuK","ClientCompany__BackSection__CloseIcon":"add-offer_ClientCompany__BackSection__CloseIcon__v9Y0i","ClientCompany__Container":"add-offer_ClientCompany__Container__Kd86N","NewJob__InterviewContainer":"add-offer_NewJob__InterviewContainer__ZXUEa","AddUsers__Container":"add-offer_AddUsers__Container__a4g9e","ClientCompany__FormInputSection":"add-offer_ClientCompany__FormInputSection__Q137J","CompanyProfile__FormInputSection":"add-offer_CompanyProfile__FormInputSection__Ktst2","ClientCompany__Heading":"add-offer_ClientCompany__Heading__rSoMb","Offer__Heading":"add-offer_Offer__Heading__KosOS","AddUsers__Heading":"add-offer_AddUsers__Heading__BuekZ","ClientCompany__StatusAlignment":"add-offer_ClientCompany__StatusAlignment__dQvIg","ClientCompany__Status":"add-offer_ClientCompany__Status__yhFwb","ClientCompany__ActiveDot":"add-offer_ClientCompany__ActiveDot__Wk3J1","ClientCompany__CloseDot":"add-offer_ClientCompany__CloseDot__RtIl_","ClientCompany__Company":"add-offer_ClientCompany__Company__2DxqQ","AddUsers__User":"add-offer_AddUsers__User__eYv3j","ClientCompany__Systemrefheding":"add-offer_ClientCompany__Systemrefheding__roU5d","ClientCompany__Subheading":"add-offer_ClientCompany__Subheading____LrB","CompanyProfile__Subheading":"add-offer_CompanyProfile__Subheading__bNfGj","ClientCompany__Subheading2":"add-offer_ClientCompany__Subheading2__FF5V_","ClientCompany__Description":"add-offer_ClientCompany__Description__jN6Gf","ClientCompany__SubmitSection":"add-offer_ClientCompany__SubmitSection__fdae2","NewJob__SubmitSection":"add-offer_NewJob__SubmitSection__r1vD3","NewJob__SubmitSectionThreeBtn":"add-offer_NewJob__SubmitSectionThreeBtn__L04te","NewJob__SubmitSectionOneBtnPlacement":"add-offer_NewJob__SubmitSectionOneBtnPlacement__hBFjg","NewJob__ImportSection":"add-offer_NewJob__ImportSection__4xMMk","SetupPopup__SubmitSection2":"add-offer_SetupPopup__SubmitSection2__FxE_y","SetupPopup__SubmitSection":"add-offer_SetupPopup__SubmitSection__pmrzG","SetupPopup__SubmitSection3":"add-offer_SetupPopup__SubmitSection3__seTJZ","AddUsers__SubmitSection":"add-offer_AddUsers__SubmitSection__0rSZh","ClientCompany__IntegrationImage":"add-offer_ClientCompany__IntegrationImage__9_9Kj","ClientCompany__QuickAdd":"add-offer_ClientCompany__QuickAdd__4fNHI","NewJob__QuickAdd":"add-offer_NewJob__QuickAdd__zq_4m","JobList__QuickAdd":"add-offer_JobList__QuickAdd__t_M9f","Interview__QuickAdd":"add-offer_Interview__QuickAdd___GnCM","ClientCompany__BodyText":"add-offer_ClientCompany__BodyText__OwjUY","Form__TableRow":"add-offer_Form__TableRow__B4Lo6","Form__TableRowTowGrid":"add-offer_Form__TableRowTowGrid__kKDFE","Form__TableRowSingle":"add-offer_Form__TableRowSingle__EKy6W","Form__Label":"add-offer_Form__Label__p2yKt","Form__Data":"add-offer_Form__Data__PAFij","Form__DataSingleRow":"add-offer_Form__DataSingleRow__N1pQi","Form__FloatingLabel":"add-offer_Form__FloatingLabel__1g7d7","Form__TableCol":"add-offer_Form__TableCol__JBU88","Form__currency_symbol__right":"add-offer_Form__currency_symbol__right__sbZ_p","Form__TableCol__Disabled":"add-offer_Form__TableCol__Disabled__c9cYO","Form__TextareaDisabled":"add-offer_Form__TextareaDisabled__AF9_U","Form__EditorDisabled":"add-offer_Form__EditorDisabled__DwjLN","Form__AdminCheckLabel":"add-offer_Form__AdminCheckLabel____MIr","Form__AdminCheckMargin":"add-offer_Form__AdminCheckMargin__WWrBu","CompanyProfile__BrandingGuide":"add-offer_CompanyProfile__BrandingGuide__E2BrW","CompanyProfile__DropBoxContainer":"add-offer_CompanyProfile__DropBoxContainer__A7Nj7","CompanyProfile__Browse":"add-offer_CompanyProfile__Browse__eGfT0","ErrorLabel":"add-offer_ErrorLabel__nL_bK","Height80":"add-offer_Height80___LhRu","Browse__ButtonFlexEnd":"add-offer_Browse__ButtonFlexEnd__RSbRx","AddAgency__Container":"add-offer_AddAgency__Container__X_tUg","AddAgency__FormInputSection":"add-offer_AddAgency__FormInputSection__XD6zL","AddAgency__FormInputSection__Label":"add-offer_AddAgency__FormInputSection__Label__IZqQH","AddAgency__Form":"add-offer_AddAgency__Form__8YDDh","LinkAsButtons":"add-offer_LinkAsButtons__5jUPV","SearchFlex":"add-offer_SearchFlex__YrK7W","Career":"add-offer_Career__hdlCc","Career__Background_Edit":"add-offer_Career__Background_Edit__1Yvop","Career__Background_Edit_Image":"add-offer_Career__Background_Edit_Image__QGLzl","Career__Container":"add-offer_Career__Container__4INSe","Career__Inner":"add-offer_Career__Inner__a_zfK","Career__logo":"add-offer_Career__logo__T5ukW","Career__Content":"add-offer_Career__Content__8cgg6","Career__ButtonSection":"add-offer_Career__ButtonSection__yarAR","Job":"add-offer_Job__gbxss","Job__Inner":"add-offer_Job__Inner__DGWos","Job__Container":"add-offer_Job__Container__ovBwD","Job__Heading":"add-offer_Job__Heading__s28Dy","Job__Company":"add-offer_Job__Company__jv_ka","Job__SearchContainer":"add-offer_Job__SearchContainer__zetUD","Job__SearchInput":"add-offer_Job__SearchInput__Hbkyd","Job__Searchbtn":"add-offer_Job__Searchbtn__AQqG8","Job__Input":"add-offer_Job__Input__Vm6KF","Job__SelectJob":"add-offer_Job__SelectJob__RHNnu","Job__RemoteLabel":"add-offer_Job__RemoteLabel__rl_PW","Job__Display":"add-offer_Job__Display__c3BkZ","Job__PostDay":"add-offer_Job__PostDay__4mqLh","Job__Title":"add-offer_Job__Title__veEnh","Job__Location":"add-offer_Job__Location__oZ3YB","DT":"add-offer_DT__ICkvH","DisplayTable":"add-offer_DisplayTable__ara3Z","pd11":"add-offer_pd11__70aO3","Label":"add-offer_Label__VbT7n","inputwidth":"add-offer_inputwidth__bMwqf","mr24":"add-offer_mr24__J0mIy","fullwidth":"add-offer_fullwidth__LvaLV","padt40":"add-offer_padt40__LqrPf","Form__TableRowflex":"add-offer_Form__TableRowflex__Ot0gT","Form__TableColm":"add-offer_Form__TableColm__nOhsb","Form__LabelCheck":"add-offer_Form__LabelCheck__8Vau6","Form__Error":"add-offer_Form__Error__Fki_X","Form__ErrorSection":"add-offer_Form__ErrorSection__ZtRO3","Form__MessagePlaceholder":"add-offer_Form__MessagePlaceholder__FmYdt","Form__Submit":"add-offer_Form__Submit__l9Jr8","Form__NormalLabel":"add-offer_Form__NormalLabel__eczsw","AddInterview":"add-offer_AddInterview__wfKIq","IntegrationPage":"add-offer_IntegrationPage___Eh_3","Integration__BackStep":"add-offer_Integration__BackStep__wXIFv","AddUsers__BackStep":"add-offer_AddUsers__BackStep__GDEat","Integration__SubmitSection":"add-offer_Integration__SubmitSection__BMbCe","IntegrationTable":"add-offer_IntegrationTable__H6BVS","IntegrationTable__LimitInput":"add-offer_IntegrationTable__LimitInput__wYlf9","IntegrationTable__Type":"add-offer_IntegrationTable__Type__ncMoE","IntegrationTable__AllJobsToggle":"add-offer_IntegrationTable__AllJobsToggle__W9nKw","IntegrationTable__switch":"add-offer_IntegrationTable__switch__NHe9e","IntegrationTable__switchText":"add-offer_IntegrationTable__switchText__JDhkA","IntegrationTable__slider":"add-offer_IntegrationTable__slider__iPLDX","IntegrationTable__round":"add-offer_IntegrationTable__round__CbzgC","IntegrationTable__Action":"add-offer_IntegrationTable__Action__g7vkE","IntegrationView":"add-offer_IntegrationView__qM_R6","IntegrationView__Title":"add-offer_IntegrationView__Title__T6CbR","IntegrationView__Subheading":"add-offer_IntegrationView__Subheading__xJs3i","IntegrationView__BoxImage":"add-offer_IntegrationView__BoxImage__aVHRU","IntegrationView__Box":"add-offer_IntegrationView__Box__q2xQd","IntegrationView__BoxImage__InfoIcon":"add-offer_IntegrationView__BoxImage__InfoIcon__4JOqT","IntegrationView__ViewMoreButton":"add-offer_IntegrationView__ViewMoreButton__A1fee","IntegrationView__ConnectButton":"add-offer_IntegrationView__ConnectButton__5z6mR","IntegrationView__GoogleButton":"add-offer_IntegrationView__GoogleButton__LX_Ku","IntegrationView__FlexFlow":"add-offer_IntegrationView__FlexFlow__c727_","IntegrationView__BoxWidth":"add-offer_IntegrationView__BoxWidth__2lued","SkipFinishButton":"add-offer_SkipFinishButton__iTLnW","AddUsers":"add-offer_AddUsers__iIivs","AddUsers__ButtonSection":"add-offer_AddUsers__ButtonSection___0zEX","AddUsers__QuickStepHeading":"add-offer_AddUsers__QuickStepHeading__k0Z4m","AddUsers__DeleteSection":"add-offer_AddUsers__DeleteSection__W99h0","Interview__DeleteSection":"add-offer_Interview__DeleteSection__hCn2i","AddUsers__DeleteCrossHeight":"add-offer_AddUsers__DeleteCrossHeight__WgiiX","AddUsers__Form__Input":"add-offer_AddUsers__Form__Input__hEAkg","AddUsers__FormHeadingSection":"add-offer_AddUsers__FormHeadingSection__QoExE","Interview__FormHeadingSection":"add-offer_Interview__FormHeadingSection__aJ3rQ","AddUsers__FormSection":"add-offer_AddUsers__FormSection__8lQzn","NewJob__FormSection":"add-offer_NewJob__FormSection__Jhgwi","AddUsers__ButtonsActionSection":"add-offer_AddUsers__ButtonsActionSection__mdS0o","AddUsers__ImportUsers":"add-offer_AddUsers__ImportUsers__vqc56","AddUsers__NameInput":"add-offer_AddUsers__NameInput__HE9vh","AddUsers__EmailInput":"add-offer_AddUsers__EmailInput__4U_2u","AddUsers__RoleInput":"add-offer_AddUsers__RoleInput__xoDpV","AddUsers__Subheading":"add-offer_AddUsers__Subheading__fThxF","AddUsers__visible":"add-offer_AddUsers__visible__8_PhX","Tagrow":"add-offer_Tagrow__fvxbO","Tagrow__Tags":"add-offer_Tagrow__Tags__VeAap","SetupPopup__Tags":"add-offer_SetupPopup__Tags___l_md","Tagrow__Cancel":"add-offer_Tagrow__Cancel__Bh_DP","Tagrow__Cross":"add-offer_Tagrow__Cross__2TgNQ","SendInviteSection":"add-offer_SendInviteSection__QTmh4","error":"add-offer_error__2HMC3","ViewJobPage__Input":"add-offer_ViewJobPage__Input__n87ga","Form__Input2":"add-offer_Form__Input2__Y7_hC","ViewJobPage__PostDay":"add-offer_ViewJobPage__PostDay__yiXQp","ViewJobPage__Title":"add-offer_ViewJobPage__Title__gF7cx","ViewJobPage__DescriptionTitle":"add-offer_ViewJobPage__DescriptionTitle__cD_xs","ViewJobPage__Location":"add-offer_ViewJobPage__Location__rskFf","ViewJobPage__primarybtn":"add-offer_ViewJobPage__primarybtn__9_r5E","ViewJobPage__secondarybtn":"add-offer_ViewJobPage__secondarybtn__TPiKH","ViewJobPage__secondarybtnborder":"add-offer_ViewJobPage__secondarybtnborder__9pezK","ViewJobPage__BackSection":"add-offer_ViewJobPage__BackSection__DvHvx","Modalpopup":"add-offer_Modalpopup__hp1Ow","Modalpopup__inner":"add-offer_Modalpopup__inner__rK3Mb","Modalpopup__Dialog":"add-offer_Modalpopup__Dialog__0poT_","transition":"add-offer_transition__s4V7m","Modalpopup__CloseCenter":"add-offer_Modalpopup__CloseCenter__Ijdor","Modalpopup__Content":"add-offer_Modalpopup__Content__8eCiD","SetupPopup__PaddingPopup":"add-offer_SetupPopup__PaddingPopup__BjeYN","SetupPopup__ContentCustomisation":"add-offer_SetupPopup__ContentCustomisation__UDVh7","SetupPopup__Contentwithoutpadding":"add-offer_SetupPopup__Contentwithoutpadding__yRIZh","ViewJobPage__Content":"add-offer_ViewJobPage__Content__nkOXc","Modalpopup__btn":"add-offer_Modalpopup__btn__659ai","mar":"add-offer_mar__ZAr57","Otpback":"add-offer_Otpback__GrQnR","ViewJobPage":"add-offer_ViewJobPage__78oy_","ViewJobPage__Header":"add-offer_ViewJobPage__Header__rb3cg","ViewJobPage__Application":"add-offer_ViewJobPage__Application__2rvee","ViewJobPage__RecordVideo":"add-offer_ViewJobPage__RecordVideo__9kI7_","ViewJobPage__RecordVideoSuccessText":"add-offer_ViewJobPage__RecordVideoSuccessText__lKjhX","ViewJobPage__subheading":"add-offer_ViewJobPage__subheading__Q_8e4","ViewJobPage__confirmation":"add-offer_ViewJobPage__confirmation__Jx3xL","ViewJobPage__Logo":"add-offer_ViewJobPage__Logo__iZGLA","ViewJobPage__BrandLogo":"add-offer_ViewJobPage__BrandLogo__EdI3w","ViewJobPage__BrandLogo__Padding10":"add-offer_ViewJobPage__BrandLogo__Padding10__YxWlg","ViewJobPage__Container":"add-offer_ViewJobPage__Container__WyCxJ","ViewJobPage__JobContent":"add-offer_ViewJobPage__JobContent__TpGPn","ViewJobPage__Sidebar":"add-offer_ViewJobPage__Sidebar__OydAv","ViewJobPage__Sidebar2":"add-offer_ViewJobPage__Sidebar2__gM5pK","ViewJobPage__Description":"add-offer_ViewJobPage__Description__BBBkL","ViewJobPage__DescriptionWidth":"add-offer_ViewJobPage__DescriptionWidth__9ije_","ViewJobPage__Footer":"add-offer_ViewJobPage__Footer__pAUSw","ViewJobPage__FooterView":"add-offer_ViewJobPage__FooterView__S5_sf","ViewJobPage__ShareJob":"add-offer_ViewJobPage__ShareJob__VMNL3","ViewJobPage__SubmitSection":"add-offer_ViewJobPage__SubmitSection__UbM1E","ViewJobPage__SocialMedia":"add-offer_ViewJobPage__SocialMedia__7L_3f","ViewJobPage__SideContent":"add-offer_ViewJobPage__SideContent__GRaPr","ViewJobPage__ApplySection":"add-offer_ViewJobPage__ApplySection__S34A5","FormBox__Autofill":"add-offer_FormBox__Autofill__wD5dl","applybuttons":"add-offer_applybuttons__ae5cU","height90":"add-offer_height90__dhB9N","Form__Cont":"add-offer_Form__Cont__hpYxo","Form__DropBox":"add-offer_Form__DropBox__1s6Tf","Form__DropBoxcontainer":"add-offer_Form__DropBoxcontainer__Wo8Lw","Form__DropBoxError":"add-offer_Form__DropBoxError__C_Ybg","Form__DropBoxicon":"add-offer_Form__DropBoxicon__lzNWX","Form__DropBoxmessage":"add-offer_Form__DropBoxmessage__xqOpy","noDpGrid":"add-offer_noDpGrid__vZw1E","Terms":"add-offer_Terms__aglKw","TermsCondition":"add-offer_TermsCondition__8kfUK","TermsCondition__alignterms":"add-offer_TermsCondition__alignterms__xSaW3","MenuContainer":"add-offer_MenuContainer__2PKVz","MenuContainer__Menu":"add-offer_MenuContainer__Menu__SZGPo","AgencyDetailPage":"add-offer_AgencyDetailPage__NRb3B","Congrats__ModalContent":"add-offer_Congrats__ModalContent__SH1Vu","JobList__SearchBox":"add-offer_JobList__SearchBox__BDDLI","NewJob__Container":"add-offer_NewJob__Container__MSrl7","NewJob__TopSection":"add-offer_NewJob__TopSection__wQgSN","JobList__TopSection":"add-offer_JobList__TopSection__SAAGA","Interview__TopSection":"add-offer_Interview__TopSection__XTEi_","NewJob__HorizontalDivider":"add-offer_NewJob__HorizontalDivider__zvYPC","NewJob__Wrapper":"add-offer_NewJob__Wrapper__AKh4k","NewJob__ContainerPadding":"add-offer_NewJob__ContainerPadding__fp5PG","NewJob__ContainerScroll":"add-offer_NewJob__ContainerScroll__ogv9I","NewJob__ContainerHeight":"add-offer_NewJob__ContainerHeight___0HDj","NewJob__ImportAction":"add-offer_NewJob__ImportAction__pbRzR","NewJob__Interview_buttons":"add-offer_NewJob__Interview_buttons__5ZTRv","Form__TableRowMB":"add-offer_Form__TableRowMB__XNyMd","Form__TableRow3grid":"add-offer_Form__TableRow3grid__Tr0xy","Form__Remotegrid":"add-offer_Form__Remotegrid__HmqX2","Form__TypeList":"add-offer_Form__TypeList__wAbun","Form__Type":"add-offer_Form__Type__ShfRP","Form__CheckLabel":"add-offer_Form__CheckLabel__OU7Uj","PrivateSwitchBase-root-1":"add-offer_PrivateSwitchBase-root-1__14CGv","Form__Caption":"add-offer_Form__Caption__B6Qxf","Form__Input_currency":"add-offer_Form__Input_currency__IJphe","Form__Input_MatchScore":"add-offer_Form__Input_MatchScore__uozdT","Form__Percentage_Symbol":"add-offer_Form__Percentage_Symbol__1zE30","Form__NoGridTemplate":"add-offer_Form__NoGridTemplate__yjrE_","active":"add-offer_active__Q58U1","mt10":"add-offer_mt10__hXLd7","mt40":"add-offer_mt40__4jnXE","mt30":"add-offer_mt30__PkBv7","mt32":"add-offer_mt32__zPWx6","mb0":"add-offer_mb0__2Nvna","Dpgrid":"add-offer_Dpgrid__RQAT5","mb12":"add-offer_mb12__mi8MX","width100":"add-offer_width100___wDqw","Tagrow__Prefix":"add-offer_Tagrow__Prefix__7a1LX","PreviewJobPage":"add-offer_PreviewJobPage__D3_7j","PreviewJob":"add-offer_PreviewJob__OLda6","DpFlx":"add-offer_DpFlx__cxApg","Subheading":"add-offer_Subheading__kv_fm","Subheading__Description":"add-offer_Subheading__Description__0GAcr","Candidate__Tooltip":"add-offer_Candidate__Tooltip__3QIjp","Candidate__Tooltip__Score":"add-offer_Candidate__Tooltip__Score__NoSl4","Form__InputField":"add-offer_Form__InputField__QYkyU","Candidate__Length":"add-offer_Candidate__Length__ETmDF","Agency__PostDay":"add-offer_Agency__PostDay__cN1eE","Agency__Title":"add-offer_Agency__Title__6H0Xy","Agency__Location":"add-offer_Agency__Location__tM4aL","Agency__DescriptionTitle":"add-offer_Agency__DescriptionTitle__ICANp","Agency__Description":"add-offer_Agency__Description__eRUN5","LightBlueColor":"add-offer_LightBlueColor__z439f","AgencyDetailForm":"add-offer_AgencyDetailForm__sOwHx","Client_Page":"add-offer_Client_Page__NtEw0","Welcome":"add-offer_Welcome__AeyGN","Welcome__Inner":"add-offer_Welcome__Inner__xKgB0","Welcome__Person":"add-offer_Welcome__Person__cTrAc","Welcome__LeftContent":"add-offer_Welcome__LeftContent__RnQ2_","Welcome__RightContent":"add-offer_Welcome__RightContent__kzE26","Welcome__Content":"add-offer_Welcome__Content__R4szQ","Welcome__CreateAccount":"add-offer_Welcome__CreateAccount__skH58","Welcome__title":"add-offer_Welcome__title__JCxPm","Welcome__FormBox":"add-offer_Welcome__FormBox__5kiyS","Form__psw":"add-offer_Form__psw__mQtyZ","Welcome__Container":"add-offer_Welcome__Container__5PqGd","Success__Container":"add-offer_Success__Container__xt14R","Success":"add-offer_Success__hWPV7","Success__Inner":"add-offer_Success__Inner__9QNhH","InterviewContainer":"add-offer_InterviewContainer__IINMT","Interview__Stages":"add-offer_Interview__Stages__83wXN","Interview__StageHeading":"add-offer_Interview__StageHeading__l_QvQ","pl10":"add-offer_pl10__Xdzs9","Interview__AddStageSection":"add-offer_Interview__AddStageSection__PniCG","Interview__Label":"add-offer_Interview__Label__B8rUm","Interview__FormRowHeading":"add-offer_Interview__FormRowHeading__bLVlk","dpflex":"add-offer_dpflex__qTCwJ","Interview__IconsType":"add-offer_Interview__IconsType__Iewwp","Interview__Icons":"add-offer_Interview__Icons__3_di9","Interview__Interview_buttons":"add-offer_Interview__Interview_buttons___KtAR","Interview__approvalButton":"add-offer_Interview__approvalButton__uNjbL","Interview__BestMatch":"add-offer_Interview__BestMatch___j4Jm","Interview__BestMatchExclamation":"add-offer_Interview__BestMatchExclamation__0blKG","DragAndDrop":"add-offer_DragAndDrop__nY0Ka","DragAndDrop__CursorHandle":"add-offer_DragAndDrop__CursorHandle__R3IYN","Tagrow__Image":"add-offer_Tagrow__Image__gwcAu","rowbglight":"add-offer_rowbglight__qZI0O","rowbgheight":"add-offer_rowbgheight__JtLMW","Form__w90":"add-offer_Form__w90__RJiwZ","Container":"add-offer_Container__4Ul5j","Screening__StageName":"add-offer_Screening__StageName__3m54k","Screening__InterviewType":"add-offer_Screening__InterviewType__zT1WI","Screening__InterviewType__Label":"add-offer_Screening__InterviewType__Label__ksRS_","Show_Infoicon":"add-offer_Show_Infoicon__WXmLX","Show_Infoicon_small":"add-offer_Show_Infoicon_small__hsKce","Screening__Info":"add-offer_Screening__Info__O_V_1","Screening__Info__IconWithText":"add-offer_Screening__Info__IconWithText__dqlUG","InterviewType__Icon":"add-offer_InterviewType__Icon__UhWKl","InterviewType__Text":"add-offer_InterviewType__Text__DlESW","LoginModal":"add-offer_LoginModal__WHuNI","Logincontent":"add-offer_Logincontent__vf2sf","Logincontent__title":"add-offer_Logincontent__title____zKH","Modalbg":"add-offer_Modalbg__K_dOl","Modalnobg":"add-offer_Modalnobg__CaV2o","Form__Container":"add-offer_Form__Container__JhBkL","Form__success":"add-offer_Form__success__mc5Yf","Form__error":"add-offer_Form__error__sj9Xe","Form__CheckLabeltext":"add-offer_Form__CheckLabeltext__s8f1S","Form__TextLeft":"add-offer_Form__TextLeft__4P0yn","Backsection":"add-offer_Backsection__ds619","back":"add-offer_back__Htzoj","mlr0":"add-offer_mlr0__pvnLT","TwoButtons":"add-offer_TwoButtons__CX_Dp","OtpBacksection":"add-offer_OtpBacksection__KcZV_","SetupPopup":"add-offer_SetupPopup__67icZ","JobList__EditModal":"add-offer_JobList__EditModal__LuWW8","SetupPopup__inner":"add-offer_SetupPopup__inner__4UohF","SetupPopup__Dialog":"add-offer_SetupPopup__Dialog__Yrs01","SetupPopup__AddFile":"add-offer_SetupPopup__AddFile__xd14p","SetupPopup__OptionalText":"add-offer_SetupPopup__OptionalText__3ZI0Y","SetupPopup__RequestAccessBtn":"add-offer_SetupPopup__RequestAccessBtn__5_cOM","SetupPopup__InternalSection":"add-offer_SetupPopup__InternalSection__QH17l","SetupPopup__ContentInnerRow":"add-offer_SetupPopup__ContentInnerRow__yC8ZR","SetupPopup__ToChips":"add-offer_SetupPopup__ToChips__IjMzV","SetupPopup__AttachmentContainer":"add-offer_SetupPopup__AttachmentContainer__xu6bv","SetupPopup__ContentInnerCol":"add-offer_SetupPopup__ContentInnerCol__dt9Ei","SetupPopup__grid":"add-offer_SetupPopup__grid__lKmIO","SetupPopup__Footer":"add-offer_SetupPopup__Footer__B_zv0","SetupPopup__FooterNew":"add-offer_SetupPopup__FooterNew__LQ2ZE","SetupPopup__Footer2":"add-offer_SetupPopup__Footer2__9qsuB","SetupPopup__Footer3":"add-offer_SetupPopup__Footer3__NrPct","SetupPopup__Footerassess":"add-offer_SetupPopup__Footerassess__Cmf4z","SetupPopup__Footertechtest":"add-offer_SetupPopup__Footertechtest__oYU20","SetupPopup__AutommationFooter":"add-offer_SetupPopup__AutommationFooter__pQ_NY","SetupPopup__MannualFooter":"add-offer_SetupPopup__MannualFooter__GVJox","SetupPopup__MannualInnerSection":"add-offer_SetupPopup__MannualInnerSection__Pv6EW","SetupPopup__Content":"add-offer_SetupPopup__Content__7xeRW","SetupPopup__Content__Radiobtn":"add-offer_SetupPopup__Content__Radiobtn__k96Lg","SetupPopup__AutomationToggle":"add-offer_SetupPopup__AutomationToggle__2SsiO","SetupPopup__SetupVideoQa":"add-offer_SetupPopup__SetupVideoQa__RIkfB","SetupPopup__SetupVideoQa2":"add-offer_SetupPopup__SetupVideoQa2__F82v1","SetupPopup__SetupVideoQa3":"add-offer_SetupPopup__SetupVideoQa3__71seL","SetupPopup__SetupVideoQa4":"add-offer_SetupPopup__SetupVideoQa4__1SLzG","SetupPopup__InputQA":"add-offer_SetupPopup__InputQA__E2kwC","SetupPopup__AddQuestion":"add-offer_SetupPopup__AddQuestion__UMEzi","SetupPopup__QuestionSection":"add-offer_SetupPopup__QuestionSection__cjpA_","SetupPopup__PushTop":"add-offer_SetupPopup__PushTop__9yuny","SetupPopup__Contentpading":"add-offer_SetupPopup__Contentpading__uwBUF","SetupPopup__QuesionSectionpading":"add-offer_SetupPopup__QuesionSectionpading__rwY_t","SetupPopup__Contentcenter":"add-offer_SetupPopup__Contentcenter__oF3AV","SetupPopup__PopDetails":"add-offer_SetupPopup__PopDetails__dgQ1W","SetupPopup__PopDetails__FS16":"add-offer_SetupPopup__PopDetails__FS16__wUv4_","SetupPopup__Details":"add-offer_SetupPopup__Details__W49JW","SetupPopup__PrivacyPolicyDetails":"add-offer_SetupPopup__PrivacyPolicyDetails__pH6vq","SetupPopup__Reason":"add-offer_SetupPopup__Reason__Huc0a","SetupPopup__ContentBlock":"add-offer_SetupPopup__ContentBlock__0J_Xr","SetupPopup__Purpose":"add-offer_SetupPopup__Purpose__1TDQb","SetupPopup__ContentGridsec":"add-offer_SetupPopup__ContentGridsec__Y_zr2","mt25":"add-offer_mt25__cRzc3","mt20":"add-offer_mt20__brROt","SetupPopup__ContentGridTech":"add-offer_SetupPopup__ContentGridTech__qVmYE","SetupPopup__Assesmentsection":"add-offer_SetupPopup__Assesmentsection__rd876","SetupPopup__AssesmentsectionNew":"add-offer_SetupPopup__AssesmentsectionNew__GTzPA","SetupPopup__MannualChips":"add-offer_SetupPopup__MannualChips__h_nsB","SetupPopup__ContentGridManuaCol":"add-offer_SetupPopup__ContentGridManuaCol__lqYj7","SetupPopup__ContentGridManual":"add-offer_SetupPopup__ContentGridManual__UMPQ1","SetupPopup__ContentBlockPhone":"add-offer_SetupPopup__ContentBlockPhone__dOkKv","SetupPopup__ContentAddInterview":"add-offer_SetupPopup__ContentAddInterview__0d4de","SetupPopup__ContentGridPhone":"add-offer_SetupPopup__ContentGridPhone__sH_JL","SetupPopup__ContentGridStatus":"add-offer_SetupPopup__ContentGridStatus__H5JLS","SetupPopup__GridActions":"add-offer_SetupPopup__GridActions__rryNF","SetupPopup__GridActionCoral":"add-offer_SetupPopup__GridActionCoral__CKv83","SetupPopup__GridActionIndigo":"add-offer_SetupPopup__GridActionIndigo__u8eQQ","SetupPopup__ContentGrid":"add-offer_SetupPopup__ContentGrid___zQ_e","SetupPopup__SubmitSectionSave":"add-offer_SetupPopup__SubmitSectionSave__CoLo5","SetupPopup__SubmitSectionReset":"add-offer_SetupPopup__SubmitSectionReset__uSeC8","SetupPopup__SubmitSectionAutomation":"add-offer_SetupPopup__SubmitSectionAutomation__p6nt7","SetupPopup__Duration":"add-offer_SetupPopup__Duration__8UgSQ","SetupPopup__DeleteIcon":"add-offer_SetupPopup__DeleteIcon__SO4gY","SetupPopup__ContentCustomisationManualInterview":"add-offer_SetupPopup__ContentCustomisationManualInterview__h3dGI","mt0":"add-offer_mt0__0D4e7","mtb25":"add-offer_mtb25__afkl9","mb15":"add-offer_mb15__MM3_q","mb30":"add-offer_mb30__5dvAH","mt9":"add-offer_mt9__0SbG_","lineheight0":"add-offer_lineheight0__OLuf7","PopupHeightSection":"add-offer_PopupHeightSection__8asyV","AssessPopupHeightSection":"add-offer_AssessPopupHeightSection__owghV","Statusopupheight":"add-offer_Statusopupheight__eMIic","buttonIn":"add-offer_buttonIn__h_d06","MessagePlaceholder":"add-offer_MessagePlaceholder__jk4Xx","m0":"add-offer_m0__pEbqM","mt18":"add-offer_mt18__ILmw_","DPgrid":"add-offer_DPgrid__V82FJ","addbtnposition":"add-offer_addbtnposition__c_xn0","mainformdiv":"add-offer_mainformdiv__T2ar7","crossflex":"add-offer_crossflex__fnUTj","crossimgheight":"add-offer_crossimgheight__BkqXZ","crossimgheight48":"add-offer_crossimgheight48__2991u","SetupModalPopup":"add-offer_SetupModalPopup__jhy6n","SetupModalPopup__Dialog":"add-offer_SetupModalPopup__Dialog__5uycP","SetupPopupoverlay":"add-offer_SetupPopupoverlay__Akuhz","NeedHelp":"add-offer_NeedHelp__eQrsI","uploadNewTest":"add-offer_uploadNewTest__mhJhC","SetupPopup__ol":"add-offer_SetupPopup__ol__mEGV0","Threshold__Content":"add-offer_Threshold__Content__6gVLk","SetupPopup__ContentGridPhone__Content":"add-offer_SetupPopup__ContentGridPhone__Content__h6sTg","JobList__EditModalInner":"add-offer_JobList__EditModalInner__y7RdK","Popupheight":"add-offer_Popupheight__2Y2bf","CandidateBulkActionSection":"add-offer_CandidateBulkActionSection__BameX","KanbanBulkActionSection":"add-offer_KanbanBulkActionSection__3PhLM","KanbanBulkActionSection__Progress":"add-offer_KanbanBulkActionSection__Progress__pJiOy","KanbanBulkActionSection__Message":"add-offer_KanbanBulkActionSection__Message__z351B","Heading":"add-offer_Heading__QQEnF","Offer__Container":"add-offer_Offer__Container__JlBxG","Offer__DetailsSection":"add-offer_Offer__DetailsSection__9Ssr0","Offer__NoMarginTop":"add-offer_Offer__NoMarginTop__QqnRM","Offer__Mt20":"add-offer_Offer__Mt20__b7_K9","Form__OfferSubmit":"add-offer_Form__OfferSubmit__plX02","Error":"add-offer_Error___JudQ","SignContract":"add-offer_SignContract__AbbO8","SignContract__Container":"add-offer_SignContract__Container__vqt5G","SignContract__Button":"add-offer_SignContract__Button__xUi_c","SignContract__Header":"add-offer_SignContract__Header__GxfQK","SignContract__Page":"add-offer_SignContract__Page__MURL0","SignContract__Logo":"add-offer_SignContract__Logo__pizgf","SignContract__Main":"add-offer_SignContract__Main__nUPyH","OfferDetail__Container":"add-offer_OfferDetail__Container__ybTza","JobOfferDetails":"add-offer_JobOfferDetails__yOQ2B","JobOfferDetails__Section":"add-offer_JobOfferDetails__Section__M1B1g","JobOfferDetails__Row":"add-offer_JobOfferDetails__Row__ehvSd","JobOfferDetails__LeftCol":"add-offer_JobOfferDetails__LeftCol__KxAd_","JobOfferDetails__RightCol":"add-offer_JobOfferDetails__RightCol__MXIQJ","JobOfferDetails__Label":"add-offer_JobOfferDetails__Label__UKBB8","JobOfferDetails__Data":"add-offer_JobOfferDetails__Data__PGhXh","JobOfferDetails__W100":"add-offer_JobOfferDetails__W100__2_cfq","JobOfferDetails__MR20":"add-offer_JobOfferDetails__MR20__FFT_6","Offer":"add-offer_Offer__geXFE","OfferDetail":"add-offer_OfferDetail__HmA9T","ProgressLineSection":"add-offer_ProgressLineSection__a4BU1","ProgressLineSection__Container":"add-offer_ProgressLineSection__Container__83OKI","ProgressLineSection__AcionSection":"add-offer_ProgressLineSection__AcionSection__pYMZc","ProgressLineSection__ActionButtons":"add-offer_ProgressLineSection__ActionButtons__k4Dox","ProgressLineSection__Heading":"add-offer_ProgressLineSection__Heading__0qLfg","TopHeaderSection":"add-offer_TopHeaderSection__GGIka","TopHeaderSection__SpaceBetween":"add-offer_TopHeaderSection__SpaceBetween__NkIIb","AgencyHeading":"add-offer_AgencyHeading__gPBaK","StatsSection":"add-offer_StatsSection__F7AZQ","StatsSection__List":"add-offer_StatsSection__List__De0ZJ","StatsSection__NewList":"add-offer_StatsSection__NewList__kjV2S","StatsSection__ListStatus":"add-offer_StatsSection__ListStatus__Lf9zw","StatsSection__NewListStatus":"add-offer_StatsSection__NewListStatus__Bn9Mw","StatsSection__Statslist":"add-offer_StatsSection__Statslist__HD1dR","StatsSection__StatsAnchor":"add-offer_StatsSection__StatsAnchor__2gsqw","StatsSection__StatsContent":"add-offer_StatsSection__StatsContent__Ucpye","StatsSection__StatsContentWidth":"add-offer_StatsSection__StatsContentWidth__gnuf1","StatsSection__StatsNumber":"add-offer_StatsSection__StatsNumber__XKA9p","StatsSection__StatsNumberWidth":"add-offer_StatsSection__StatsNumberWidth__LU3Eq","StatsSection__Health":"add-offer_StatsSection__Health__P6CRk","StatsSection__IndigoBg":"add-offer_StatsSection__IndigoBg__oaPJQ","StatsSection__CorelBg":"add-offer_StatsSection__CorelBg__4zcSK","StatsSection__GreenBg":"add-offer_StatsSection__GreenBg__Kog1p","StatsSection__RoseBg":"add-offer_StatsSection__RoseBg__0FvYG","StatsSection__CorelDarkBg":"add-offer_StatsSection__CorelDarkBg__m0W1s","StatsSection__StatBgOne":"add-offer_StatsSection__StatBgOne__3MUGD","StatsSection__StatBgOne__NoBorder":"add-offer_StatsSection__StatBgOne__NoBorder__SMkLd","StatsSection__StatBgTwo":"add-offer_StatsSection__StatBgTwo__LiiYS","StatsSection__StatBgThree":"add-offer_StatsSection__StatBgThree__YG9Hf","StatsSection__StatBgFour":"add-offer_StatsSection__StatBgFour__tjae1","NotificationSection":"add-offer_NotificationSection__KdOam","NotificationSection__InterviewListNoHover":"add-offer_NotificationSection__InterviewListNoHover__7buCh","NotificationSection__AlertActivity":"add-offer_NotificationSection__AlertActivity__Bis57","NotificationSection__Alert":"add-offer_NotificationSection__Alert__kpqpx","NotificationSection__List":"add-offer_NotificationSection__List__Ioj0f","NotificationSection__AlertContainer":"add-offer_NotificationSection__AlertContainer__8vq3A","NotificationSection__CommunicationContainer":"add-offer_NotificationSection__CommunicationContainer__70oQz","NotificationSection__AlertActivityContainer":"add-offer_NotificationSection__AlertActivityContainer__UiOIE","NotificationSection__Schedulingmain":"add-offer_NotificationSection__Schedulingmain__yfMWM","NotificationSection__More":"add-offer_NotificationSection__More__wXf_J","NotificationSection__Alertslist":"add-offer_NotificationSection__Alertslist__87Au7","NotificationSection__Alertsmessage":"add-offer_NotificationSection__Alertsmessage__gxOcx","NotificationSection__AlertsTilte":"add-offer_NotificationSection__AlertsTilte__IzEov","NotificationSection__AlertHeading":"add-offer_NotificationSection__AlertHeading__XWJk1","NotificationSection__CalendarHeading":"add-offer_NotificationSection__CalendarHeading__HnkEB","NotificationSection__Dismiss":"add-offer_NotificationSection__Dismiss__W0JL0","NotificationSection__Communications":"add-offer_NotificationSection__Communications__CHeMP","NotificationSection__ProfileCircle":"add-offer_NotificationSection__ProfileCircle__wc_XM","NotificationSection__SchedulingTiming":"add-offer_NotificationSection__SchedulingTiming__n1MaM","NotificationSection__TimimgsSection":"add-offer_NotificationSection__TimimgsSection__Rb8aC","NotificationSection__WeekTiming":"add-offer_NotificationSection__WeekTiming__RaZRo","NotificationSection__Scheduling":"add-offer_NotificationSection__Scheduling__5Re6Q","NotificationSection__Pagination":"add-offer_NotificationSection__Pagination__e8hdh","NotificationSection__PaginationButton":"add-offer_NotificationSection__PaginationButton__6_pB2","NotificationSection__InterviewListSvg":"add-offer_NotificationSection__InterviewListSvg__6eIi9","NotificationSection__InterviewListStage":"add-offer_NotificationSection__InterviewListStage__mpYPk","NotificationSection__InterviewList":"add-offer_NotificationSection__InterviewList__y5U_F","NotificationSection__Interviewtitle":"add-offer_NotificationSection__Interviewtitle__KyiFp","NotificationSection__InterviewerProfile":"add-offer_NotificationSection__InterviewerProfile__hIwJ6","NotificationSection__InterviewerDate":"add-offer_NotificationSection__InterviewerDate__txXLv","NotificationSection__Greybox":"add-offer_NotificationSection__Greybox__wbYRj","NotificationSection__Tabs":"add-offer_NotificationSection__Tabs__FlRXL","React__tabs":"add-offer_React__tabs__hGT5N","React__tabs__today":"add-offer_React__tabs__today__TDpc3","React__tabs__head":"add-offer_React__tabs__head__kOQhX","React__tabs__tabpanel":"add-offer_React__tabs__tabpanel__sa2kJ","React__tabs__tablist":"add-offer_React__tabs__tablist__FzYol","React__tabs__tablist__tab":"add-offer_React__tabs__tablist__tab__ZUM8M","React__tabs__interviewtype":"add-offer_React__tabs__interviewtype__H8OOB","React__tabs__MyInterview":"add-offer_React__tabs__MyInterview__QXnA9","React__tabs__TeamInterview":"add-offer_React__tabs__TeamInterview__Zea9x","NamePrefix":"add-offer_NamePrefix__1_9II","CandidatePrefix":"add-offer_CandidatePrefix__C6oRq","TopSection":"add-offer_TopSection__Ffzli","CalendarSelectedDate":"add-offer_CalendarSelectedDate__9C_qU","TitleFlex":"add-offer_TitleFlex__6JqBe","JobList__Accordian":"add-offer_JobList__Accordian__8jwBc","JobList__AccordianContent":"add-offer_JobList__AccordianContent__x76eQ","JobList__SearchSection":"add-offer_JobList__SearchSection__GoZIm","JobList__FilterMarginBottom":"add-offer_JobList__FilterMarginBottom__K1MO6","JobList__SearchFilter":"add-offer_JobList__SearchFilter___XTvB","JobList__AppliedSearchFilter":"add-offer_JobList__AppliedSearchFilter___Zz4r","JobList__SearchFilterFullWidth":"add-offer_JobList__SearchFilterFullWidth__cFoEL","JobList__AddJobSection":"add-offer_JobList__AddJobSection__zkWpt","JobList__Status":"add-offer_JobList__Status__2e9Ek","JobList__EditModalContainer":"add-offer_JobList__EditModalContainer___dgLX","JobList__EditModalMessage":"add-offer_JobList__EditModalMessage___etBH","JobList__EditModalButtonSection":"add-offer_JobList__EditModalButtonSection__vnW9L","JobList__CheckLabel":"add-offer_JobList__CheckLabel__VlmrS","JobList__Checkbox":"add-offer_JobList__Checkbox__kDbi0","JobList__JobBoard":"add-offer_JobList__JobBoard__xgQ3n","JobList__Reasons":"add-offer_JobList__Reasons__kn2bN","KanbanSearch__Dots":"add-offer_KanbanSearch__Dots__cDXF5","AgencyDetailForm__Label":"add-offer_AgencyDetailForm__Label__qT2ol","AgencyDetailForm__Data":"add-offer_AgencyDetailForm__Data__IA_o7","AgencyDetailForm__Actionsection":"add-offer_AgencyDetailForm__Actionsection__DS7nJ","AgencyDetailForm__FormInputSection":"add-offer_AgencyDetailForm__FormInputSection__dOtCd","ApprovalContract":"add-offer_ApprovalContract__jDfPb","ApprovalContractButtons":"add-offer_ApprovalContractButtons__BiHxx","AddOffer__Details":"add-offer_AddOffer__Details__eIuXa","ButtonAlign":"add-offer_ButtonAlign__wppsI","TwoButtonAlign":"add-offer_TwoButtonAlign__QYcLM","Form__TableRowFourGrid":"add-offer_Form__TableRowFourGrid__hchgv","Form__TableRowThreeGrid":"add-offer_Form__TableRowThreeGrid__1pjGQ","Form__TableRowTwoGrid":"add-offer_Form__TableRowTwoGrid__VZCBm","Form__TableRowNoGrid":"add-offer_Form__TableRowNoGrid___ngT4"};

/***/ }),

/***/ 63393:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"candidate-profile-job_Form__jnrus","Form__width":"candidate-profile-job_Form__width__Cefsy","Form__label":"candidate-profile-job_Form__label__pJ_pj","Form__textleft":"candidate-profile-job_Form__textleft__TjhCH","Form__InputFullWidth":"candidate-profile-job_Form__InputFullWidth__VHwGA","Form__Input":"candidate-profile-job_Form__Input__qJqdd","Form__Input398":"candidate-profile-job_Form__Input398__kOwnB","Form__InputSection":"candidate-profile-job_Form__InputSection__sp0rP","Form__ScoreCardInput":"candidate-profile-job_Form__ScoreCardInput__eZk6D","Form__Textarea":"candidate-profile-job_Form__Textarea__Jo6LL","Form__CustomSelect":"candidate-profile-job_Form__CustomSelect__dBMEg","Form__ErrorCustomSelect":"candidate-profile-job_Form__ErrorCustomSelect__gFT17","Form__currency_symbol":"candidate-profile-job_Form__currency_symbol__PqeTm","Form__select_currency":"candidate-profile-job_Form__select_currency__ErUhg","customSelect__placeholder":"candidate-profile-job_customSelect__placeholder__kFufW","primarybtn":"candidate-profile-job_primarybtn__vYPrN","JobList__EditModalEditButton":"candidate-profile-job_JobList__EditModalEditButton__1L85g","GoBtn":"candidate-profile-job_GoBtn__tO2KC","secondarybtn":"candidate-profile-job_secondarybtn__SDcq1","JobList__EditModalCancelButton":"candidate-profile-job_JobList__EditModalCancelButton__aRM53","iconFilled":"candidate-profile-job_iconFilled__G9ABM","iconFilledSolid":"candidate-profile-job_iconFilledSolid__8bD69","primarybtnborder":"candidate-profile-job_primarybtnborder__XEYq3","secondarybtnborder":"candidate-profile-job_secondarybtnborder__O28du","ClearBtn":"candidate-profile-job_ClearBtn__BG_hf","tertiarybtn":"candidate-profile-job_tertiarybtn__Zp0bN","graybtnborder":"candidate-profile-job_graybtnborder___7T8r","jobsrchbtn":"candidate-profile-job_jobsrchbtn__sjFfz","jobsrchbtnalign":"candidate-profile-job_jobsrchbtnalign__dIsFb","nobgbutton":"candidate-profile-job_nobgbutton__6oOdA","iconTextButton":"candidate-profile-job_iconTextButton__FQ_H3","cursornone":"candidate-profile-job_cursornone__P6mlv","nobgbuttonprimary":"candidate-profile-job_nobgbuttonprimary__MRmql","mt15":"candidate-profile-job_mt15___zNmn","btn350":"candidate-profile-job_btn350__l2ize","GrayBgBtn":"candidate-profile-job_GrayBgBtn__f0f_y","NewShareBtn":"candidate-profile-job_NewShareBtn__iLv8_","CoralBgBtn":"candidate-profile-job_CoralBgBtn__ZETFo","DropContainer":"candidate-profile-job_DropContainer__iDfvC","DropContainer__Inner":"candidate-profile-job_DropContainer__Inner__vcnXX","CompanyProfile__Inner":"candidate-profile-job_CompanyProfile__Inner__9doMc","DropContainer__Message":"candidate-profile-job_DropContainer__Message__g9B9C","CompanyProfile__Message":"candidate-profile-job_CompanyProfile__Message__XgKrN","CompanyProfile__MessageContent":"candidate-profile-job_CompanyProfile__MessageContent__9a_X5","DropContainer__UploadIcon":"candidate-profile-job_DropContainer__UploadIcon__eT9eV","CompanyProfile__UploadIcon":"candidate-profile-job_CompanyProfile__UploadIcon__yqtAS","FileDisplayContainer":"candidate-profile-job_FileDisplayContainer__jxZy5","FileDisplayContainer__Status":"candidate-profile-job_FileDisplayContainer__Status__T82o9","SetupPopup__Status":"candidate-profile-job_SetupPopup__Status__5lkGt","SetupPopup__To":"candidate-profile-job_SetupPopup__To__YkMEl","FileDisplayContainer__Type":"candidate-profile-job_FileDisplayContainer__Type__nMKE6","FileDisplayContainer__Name":"candidate-profile-job_FileDisplayContainer__Name__Sabgq","SetupPopup__Name":"candidate-profile-job_SetupPopup__Name__b_TR_","SetupPopup__ToName":"candidate-profile-job_SetupPopup__ToName__BOZok","FileDisplayContainer__Error":"candidate-profile-job_FileDisplayContainer__Error__lZA1a","FileDisplayContainer__Close":"candidate-profile-job_FileDisplayContainer__Close__y0bl7","Browse":"candidate-profile-job_Browse__Gcv2p","ClientCompany":"candidate-profile-job_ClientCompany__kcYYy","NewJob":"candidate-profile-job_NewJob__xTeIA","Interview":"candidate-profile-job_Interview__XwVo9","ClientCompany__TopSection2":"candidate-profile-job_ClientCompany__TopSection2__qYm4T","ClientCompany__Filter":"candidate-profile-job_ClientCompany__Filter__hiaLk","ClientCompany__Input_MatchScore":"candidate-profile-job_ClientCompany__Input_MatchScore__txFSS","ClientCompany__Percentage_Symbol":"candidate-profile-job_ClientCompany__Percentage_Symbol__dXaH_","ClientCompany__Filterheading":"candidate-profile-job_ClientCompany__Filterheading__IGp2K","ClientCompany__FloatButtonAdd":"candidate-profile-job_ClientCompany__FloatButtonAdd__eFuOL","ClientCompany__FloatButtonAdd__AgencyUserIcon":"candidate-profile-job_ClientCompany__FloatButtonAdd__AgencyUserIcon__CCHuO","ClientCompany__LastEdited":"candidate-profile-job_ClientCompany__LastEdited__jgCzK","ClientCompany__BackSection":"candidate-profile-job_ClientCompany__BackSection__ZTjVv","AddUsers__BackSection":"candidate-profile-job_AddUsers__BackSection__UEeHF","ClientCompany__BackSection__CloseIcon":"candidate-profile-job_ClientCompany__BackSection__CloseIcon__qljUY","ClientCompany__Container":"candidate-profile-job_ClientCompany__Container__Zg187","NewJob__InterviewContainer":"candidate-profile-job_NewJob__InterviewContainer__f2IcY","AddUsers__Container":"candidate-profile-job_AddUsers__Container__Rd7oe","ClientCompany__FormInputSection":"candidate-profile-job_ClientCompany__FormInputSection__s0lCE","Profile__FormInputSection":"candidate-profile-job_Profile__FormInputSection__FQ94Z","CompanyProfile__FormInputSection":"candidate-profile-job_CompanyProfile__FormInputSection__DDBQR","ClientCompany__Heading":"candidate-profile-job_ClientCompany__Heading__H_E_e","Offer__Heading":"candidate-profile-job_Offer__Heading__Qs7no","AddUsers__Heading":"candidate-profile-job_AddUsers__Heading__6rYtj","ClientCompany__StatusAlignment":"candidate-profile-job_ClientCompany__StatusAlignment__6GPPZ","ClientCompany__Status":"candidate-profile-job_ClientCompany__Status__ZOJU8","ClientCompany__ActiveDot":"candidate-profile-job_ClientCompany__ActiveDot__VeitZ","ClientCompany__CloseDot":"candidate-profile-job_ClientCompany__CloseDot__h0h_G","ClientCompany__Company":"candidate-profile-job_ClientCompany__Company___bqs9","AddUsers__User":"candidate-profile-job_AddUsers__User__x1AFE","ClientCompany__Systemrefheding":"candidate-profile-job_ClientCompany__Systemrefheding__Xk7S4","ClientCompany__Subheading":"candidate-profile-job_ClientCompany__Subheading__I_Bq5","CompanyProfile__Subheading":"candidate-profile-job_CompanyProfile__Subheading__2XVBA","ClientCompany__Subheading2":"candidate-profile-job_ClientCompany__Subheading2__BktuW","ClientCompany__Description":"candidate-profile-job_ClientCompany__Description__sxwf1","ClientCompany__SubmitSection":"candidate-profile-job_ClientCompany__SubmitSection__q89gV","NewJob__SubmitSection":"candidate-profile-job_NewJob__SubmitSection__Ef39J","NewJob__SubmitSectionThreeBtn":"candidate-profile-job_NewJob__SubmitSectionThreeBtn__V34l1","NewJob__SubmitSectionOneBtnPlacement":"candidate-profile-job_NewJob__SubmitSectionOneBtnPlacement__TGv0a","NewJob__ImportSection":"candidate-profile-job_NewJob__ImportSection__wpue3","SetupPopup__SubmitSection2":"candidate-profile-job_SetupPopup__SubmitSection2__jBl1I","SetupPopup__SubmitSection":"candidate-profile-job_SetupPopup__SubmitSection__rBAMc","SetupPopup__SubmitSection3":"candidate-profile-job_SetupPopup__SubmitSection3__f8Pqh","AddUsers__SubmitSection":"candidate-profile-job_AddUsers__SubmitSection__SzVCj","ClientCompany__IntegrationImage":"candidate-profile-job_ClientCompany__IntegrationImage__ABVgT","ClientCompany__QuickAdd":"candidate-profile-job_ClientCompany__QuickAdd__ZHLBG","NewJob__QuickAdd":"candidate-profile-job_NewJob__QuickAdd__k7MAN","JobList__QuickAdd":"candidate-profile-job_JobList__QuickAdd__0Fs_e","Interview__QuickAdd":"candidate-profile-job_Interview__QuickAdd__8BpVs","ClientCompany__BodyText":"candidate-profile-job_ClientCompany__BodyText__svMfz","Form__TableRow":"candidate-profile-job_Form__TableRow__CXQj1","Form__TableRowTowGrid":"candidate-profile-job_Form__TableRowTowGrid__z9m3J","Form__TableRowSingle":"candidate-profile-job_Form__TableRowSingle__flx7x","Form__Label":"candidate-profile-job_Form__Label___BtxO","Form__Data":"candidate-profile-job_Form__Data__C3Y1T","Form__DataSingleRow":"candidate-profile-job_Form__DataSingleRow__sCcBz","Form__FloatingLabel":"candidate-profile-job_Form__FloatingLabel__3sVwk","Form__TableCol":"candidate-profile-job_Form__TableCol___ubdM","Form__currency_symbol__right":"candidate-profile-job_Form__currency_symbol__right__twsGG","Form__TableCol__Disabled":"candidate-profile-job_Form__TableCol__Disabled__1d_cK","Form__TextareaDisabled":"candidate-profile-job_Form__TextareaDisabled__l_JVo","Form__EditorDisabled":"candidate-profile-job_Form__EditorDisabled__15gMo","Form__AdminCheckLabel":"candidate-profile-job_Form__AdminCheckLabel__UOEhv","Form__AdminCheckMargin":"candidate-profile-job_Form__AdminCheckMargin___E2dX","CompanyProfile__BrandingGuide":"candidate-profile-job_CompanyProfile__BrandingGuide__MOoKu","CompanyProfile__DropBoxContainer":"candidate-profile-job_CompanyProfile__DropBoxContainer__ZSxjS","CompanyProfile__Browse":"candidate-profile-job_CompanyProfile__Browse__EnT0g","ErrorLabel":"candidate-profile-job_ErrorLabel__kJMHU","Height80":"candidate-profile-job_Height80__m95Ei","Browse__ButtonFlexEnd":"candidate-profile-job_Browse__ButtonFlexEnd__SzrSO","AddAgency__Container":"candidate-profile-job_AddAgency__Container__roxqb","AddAgency__FormInputSection":"candidate-profile-job_AddAgency__FormInputSection__WTKdo","AddAgency__FormInputSection__Label":"candidate-profile-job_AddAgency__FormInputSection__Label___NG4S","AddAgency__Form":"candidate-profile-job_AddAgency__Form__ScidG","LinkAsButtons":"candidate-profile-job_LinkAsButtons__3kKF7","SearchFlex":"candidate-profile-job_SearchFlex__s_N1F","Career":"candidate-profile-job_Career__V7Dc8","Career__Background_Edit":"candidate-profile-job_Career__Background_Edit__d7gQO","Career__Background_Edit_Image":"candidate-profile-job_Career__Background_Edit_Image__Nmg3_","Career__Container":"candidate-profile-job_Career__Container__g6Rqz","Career__Inner":"candidate-profile-job_Career__Inner__Xqm_f","Career__logo":"candidate-profile-job_Career__logo__EozA6","Career__Content":"candidate-profile-job_Career__Content__T4uk7","Career__ButtonSection":"candidate-profile-job_Career__ButtonSection__bgHdu","Job":"candidate-profile-job_Job__4dqZF","Job__Inner":"candidate-profile-job_Job__Inner__5iKAm","Job__Container":"candidate-profile-job_Job__Container__i3eOY","Job__Heading":"candidate-profile-job_Job__Heading__gH5Sg","Job__Company":"candidate-profile-job_Job__Company__lPAqd","Job__SearchContainer":"candidate-profile-job_Job__SearchContainer__0s8z_","Job__SearchInput":"candidate-profile-job_Job__SearchInput__g_G_B","Job__Searchbtn":"candidate-profile-job_Job__Searchbtn__Vz05R","Job__Input":"candidate-profile-job_Job__Input__5mHrn","Job__SelectJob":"candidate-profile-job_Job__SelectJob__FJt9U","Job__RemoteLabel":"candidate-profile-job_Job__RemoteLabel__ckGn_","Job__Display":"candidate-profile-job_Job__Display__weHVB","Job__PostDay":"candidate-profile-job_Job__PostDay__cL7GF","Job__Title":"candidate-profile-job_Job__Title__munxZ","Job__Location":"candidate-profile-job_Job__Location__jrord","DT":"candidate-profile-job_DT__4viIn","DisplayTable":"candidate-profile-job_DisplayTable__IaJti","pd11":"candidate-profile-job_pd11__J6adW","Label":"candidate-profile-job_Label__ZlALp","inputwidth":"candidate-profile-job_inputwidth__4VoI9","mr24":"candidate-profile-job_mr24__LRSc1","fullwidth":"candidate-profile-job_fullwidth__evOsX","padt40":"candidate-profile-job_padt40__mtJJ5","Form__TableRowflex":"candidate-profile-job_Form__TableRowflex__guP6s","Form__TableColm":"candidate-profile-job_Form__TableColm___F1te","Form__LabelCheck":"candidate-profile-job_Form__LabelCheck__1xi3n","Form__Error":"candidate-profile-job_Form__Error__PDOwY","Form__ErrorSection":"candidate-profile-job_Form__ErrorSection__nwsAb","Form__MessagePlaceholder":"candidate-profile-job_Form__MessagePlaceholder__1UNMv","Form__Submit":"candidate-profile-job_Form__Submit__hg6Vq","Form__NormalLabel":"candidate-profile-job_Form__NormalLabel__ulWwb","AddInterview":"candidate-profile-job_AddInterview__x_yY_","IntegrationPage":"candidate-profile-job_IntegrationPage__8Mq7O","Integration__BackStep":"candidate-profile-job_Integration__BackStep__v3Qf9","AddUsers__BackStep":"candidate-profile-job_AddUsers__BackStep__melqP","Integration__SubmitSection":"candidate-profile-job_Integration__SubmitSection__i1_zL","IntegrationTable":"candidate-profile-job_IntegrationTable__lwZmY","IntegrationTable__LimitInput":"candidate-profile-job_IntegrationTable__LimitInput__9qtzh","IntegrationTable__Type":"candidate-profile-job_IntegrationTable__Type__jJZFW","IntegrationTable__AllJobsToggle":"candidate-profile-job_IntegrationTable__AllJobsToggle__Cln5m","IntegrationTable__switch":"candidate-profile-job_IntegrationTable__switch__lUiKX","IntegrationTable__switchText":"candidate-profile-job_IntegrationTable__switchText__CmHk_","IntegrationTable__slider":"candidate-profile-job_IntegrationTable__slider__5QhDY","IntegrationTable__round":"candidate-profile-job_IntegrationTable__round__g8hH3","IntegrationTable__Action":"candidate-profile-job_IntegrationTable__Action__VN6Di","IntegrationView":"candidate-profile-job_IntegrationView__8AfTW","IntegrationView__Title":"candidate-profile-job_IntegrationView__Title__QkxU4","IntegrationView__Subheading":"candidate-profile-job_IntegrationView__Subheading__0drBx","IntegrationView__BoxImage":"candidate-profile-job_IntegrationView__BoxImage__4tpWb","IntegrationView__Box":"candidate-profile-job_IntegrationView__Box__7IunN","IntegrationView__BoxImage__InfoIcon":"candidate-profile-job_IntegrationView__BoxImage__InfoIcon__3b4d2","IntegrationView__ViewMoreButton":"candidate-profile-job_IntegrationView__ViewMoreButton__VUnj3","IntegrationView__ConnectButton":"candidate-profile-job_IntegrationView__ConnectButton__8mnai","IntegrationView__GoogleButton":"candidate-profile-job_IntegrationView__GoogleButton__y_q2q","IntegrationView__FlexFlow":"candidate-profile-job_IntegrationView__FlexFlow__FNSm0","IntegrationView__BoxWidth":"candidate-profile-job_IntegrationView__BoxWidth__jbh6D","SkipFinishButton":"candidate-profile-job_SkipFinishButton__rKRlJ","AddUsers":"candidate-profile-job_AddUsers__3kEMT","AddUsers__ButtonSection":"candidate-profile-job_AddUsers__ButtonSection__UlTPt","AddUsers__QuickStepHeading":"candidate-profile-job_AddUsers__QuickStepHeading__UWA15","AddUsers__DeleteSection":"candidate-profile-job_AddUsers__DeleteSection___w6I2","Interview__DeleteSection":"candidate-profile-job_Interview__DeleteSection__v0Gdd","AddUsers__DeleteCrossHeight":"candidate-profile-job_AddUsers__DeleteCrossHeight__Vogwp","AddUsers__Form__Input":"candidate-profile-job_AddUsers__Form__Input__1e752","AddUsers__FormHeadingSection":"candidate-profile-job_AddUsers__FormHeadingSection__Se9lX","Interview__FormHeadingSection":"candidate-profile-job_Interview__FormHeadingSection__FeI_3","AddUsers__FormSection":"candidate-profile-job_AddUsers__FormSection__0HyAO","NewJob__FormSection":"candidate-profile-job_NewJob__FormSection__qGczq","AddUsers__ButtonsActionSection":"candidate-profile-job_AddUsers__ButtonsActionSection__F9H1L","AddUsers__ImportUsers":"candidate-profile-job_AddUsers__ImportUsers__6lZ1E","AddUsers__NameInput":"candidate-profile-job_AddUsers__NameInput__8llDf","AddUsers__EmailInput":"candidate-profile-job_AddUsers__EmailInput__1NH5g","AddUsers__RoleInput":"candidate-profile-job_AddUsers__RoleInput__teU_i","AddUsers__Subheading":"candidate-profile-job_AddUsers__Subheading__6kcXl","AddUsers__visible":"candidate-profile-job_AddUsers__visible__flDmZ","Tagrow":"candidate-profile-job_Tagrow__O2jN0","Tagrow__Tags":"candidate-profile-job_Tagrow__Tags__IBLBs","ProfileTabs__Private":"candidate-profile-job_ProfileTabs__Private__sO9Dl","Email__EmailTitle":"candidate-profile-job_Email__EmailTitle__LwR6r","SetupPopup__Tags":"candidate-profile-job_SetupPopup__Tags__QG3Nt","Tagrow__Cancel":"candidate-profile-job_Tagrow__Cancel__5YH64","Tagrow__Cross":"candidate-profile-job_Tagrow__Cross__ZCXxy","SendInviteSection":"candidate-profile-job_SendInviteSection__mDuL_","error":"candidate-profile-job_error__YN59z","ViewJobPage__Input":"candidate-profile-job_ViewJobPage__Input__qF6DT","Form__Input2":"candidate-profile-job_Form__Input2__gTzB_","ViewJobPage__PostDay":"candidate-profile-job_ViewJobPage__PostDay__ngGaG","ViewJobPage__Title":"candidate-profile-job_ViewJobPage__Title__460cQ","ViewJobPage__DescriptionTitle":"candidate-profile-job_ViewJobPage__DescriptionTitle__fEkfc","ViewJobPage__Location":"candidate-profile-job_ViewJobPage__Location__Zh9DU","ViewJobPage__primarybtn":"candidate-profile-job_ViewJobPage__primarybtn__KICS8","ViewJobPage__secondarybtn":"candidate-profile-job_ViewJobPage__secondarybtn__0w0Wh","ViewJobPage__secondarybtnborder":"candidate-profile-job_ViewJobPage__secondarybtnborder__DuCG2","ViewJobPage__BackSection":"candidate-profile-job_ViewJobPage__BackSection__pFpIf","Modalpopup":"candidate-profile-job_Modalpopup__RJRO6","Modalpopup__inner":"candidate-profile-job_Modalpopup__inner__HbSXM","Modalpopup__Dialog":"candidate-profile-job_Modalpopup__Dialog___uEvW","transition":"candidate-profile-job_transition__Lwwek","Modalpopup__CloseCenter":"candidate-profile-job_Modalpopup__CloseCenter__TfaM3","Modalpopup__Content":"candidate-profile-job_Modalpopup__Content__qyKHM","SetupPopup__PaddingPopup":"candidate-profile-job_SetupPopup__PaddingPopup__iHabX","SetupPopup__ContentCustomisation":"candidate-profile-job_SetupPopup__ContentCustomisation__7IT46","SetupPopup__Contentwithoutpadding":"candidate-profile-job_SetupPopup__Contentwithoutpadding__nca_I","ViewJobPage__Content":"candidate-profile-job_ViewJobPage__Content__ZT950","Modalpopup__btn":"candidate-profile-job_Modalpopup__btn__JnEOB","mar":"candidate-profile-job_mar__Ots3j","Otpback":"candidate-profile-job_Otpback__1boU2","ViewJobPage":"candidate-profile-job_ViewJobPage__M3Kn4","ViewJobPage__Header":"candidate-profile-job_ViewJobPage__Header__ujOI_","ViewJobPage__Application":"candidate-profile-job_ViewJobPage__Application__faiGK","ViewJobPage__RecordVideo":"candidate-profile-job_ViewJobPage__RecordVideo__98cQw","ViewJobPage__RecordVideoSuccessText":"candidate-profile-job_ViewJobPage__RecordVideoSuccessText__6JV6o","ViewJobPage__subheading":"candidate-profile-job_ViewJobPage__subheading__CA2cJ","ViewJobPage__confirmation":"candidate-profile-job_ViewJobPage__confirmation__6A1Sw","ViewJobPage__Logo":"candidate-profile-job_ViewJobPage__Logo__WKBbu","ViewJobPage__BrandLogo":"candidate-profile-job_ViewJobPage__BrandLogo___lgVO","ViewJobPage__BrandLogo__Padding10":"candidate-profile-job_ViewJobPage__BrandLogo__Padding10__v0Irx","ViewJobPage__Container":"candidate-profile-job_ViewJobPage__Container__ARXW8","ViewJobPage__JobContent":"candidate-profile-job_ViewJobPage__JobContent__tSiwq","ViewJobPage__Sidebar":"candidate-profile-job_ViewJobPage__Sidebar__qbObT","ViewJobPage__Sidebar2":"candidate-profile-job_ViewJobPage__Sidebar2__XAMF_","ViewJobPage__Description":"candidate-profile-job_ViewJobPage__Description__ykxhQ","ViewJobPage__DescriptionWidth":"candidate-profile-job_ViewJobPage__DescriptionWidth__cVQ_v","ViewJobPage__Footer":"candidate-profile-job_ViewJobPage__Footer__P8VIf","ViewJobPage__FooterView":"candidate-profile-job_ViewJobPage__FooterView__IPdND","ViewJobPage__ShareJob":"candidate-profile-job_ViewJobPage__ShareJob__p3zBt","ViewJobPage__SubmitSection":"candidate-profile-job_ViewJobPage__SubmitSection__aZ1WG","ViewJobPage__SocialMedia":"candidate-profile-job_ViewJobPage__SocialMedia__9timO","ViewJobPage__SideContent":"candidate-profile-job_ViewJobPage__SideContent__yZr_E","ViewJobPage__ApplySection":"candidate-profile-job_ViewJobPage__ApplySection__9khWi","FormBox__Autofill":"candidate-profile-job_FormBox__Autofill__LLDme","applybuttons":"candidate-profile-job_applybuttons__kVTnH","height90":"candidate-profile-job_height90__eyBCp","Form__Cont":"candidate-profile-job_Form__Cont___Jf6L","Form__DropBox":"candidate-profile-job_Form__DropBox__S2RR7","Form__DropBoxcontainer":"candidate-profile-job_Form__DropBoxcontainer__2sy91","Form__DropBoxError":"candidate-profile-job_Form__DropBoxError__8vfrq","Form__DropBoxicon":"candidate-profile-job_Form__DropBoxicon__QoXG_","Form__DropBoxmessage":"candidate-profile-job_Form__DropBoxmessage__RGw0h","noDpGrid":"candidate-profile-job_noDpGrid__UVRQk","Terms":"candidate-profile-job_Terms__dVN1C","TermsCondition":"candidate-profile-job_TermsCondition__m5MJz","TermsCondition__alignterms":"candidate-profile-job_TermsCondition__alignterms__KGwM_","MenuContainer":"candidate-profile-job_MenuContainer__IFDEo","MenuContainer__Menu":"candidate-profile-job_MenuContainer__Menu__DckfP","AgencyDetailPage":"candidate-profile-job_AgencyDetailPage__Z4StV","Congrats__ModalContent":"candidate-profile-job_Congrats__ModalContent__Oil_M","JobList__SearchBox":"candidate-profile-job_JobList__SearchBox__J880q","NewJob__Container":"candidate-profile-job_NewJob__Container__hVf77","NewJob__TopSection":"candidate-profile-job_NewJob__TopSection__kDy3E","JobList__TopSection":"candidate-profile-job_JobList__TopSection__YzdrL","Interview__TopSection":"candidate-profile-job_Interview__TopSection__Cg8sQ","NewJob__HorizontalDivider":"candidate-profile-job_NewJob__HorizontalDivider__f1fcP","NewJob__Wrapper":"candidate-profile-job_NewJob__Wrapper__80Vxz","NewJob__ContainerPadding":"candidate-profile-job_NewJob__ContainerPadding__K1Sji","NewJob__ContainerScroll":"candidate-profile-job_NewJob__ContainerScroll__rxanj","NewJob__ContainerHeight":"candidate-profile-job_NewJob__ContainerHeight__Ig7WI","NewJob__ImportAction":"candidate-profile-job_NewJob__ImportAction__yJZOP","NewJob__Interview_buttons":"candidate-profile-job_NewJob__Interview_buttons__wuKka","Form__TableRowMB":"candidate-profile-job_Form__TableRowMB__jGTr2","Form__TableRow3grid":"candidate-profile-job_Form__TableRow3grid__PBu8y","Form__Remotegrid":"candidate-profile-job_Form__Remotegrid__EieCi","Form__TypeList":"candidate-profile-job_Form__TypeList__g750S","Form__Type":"candidate-profile-job_Form__Type__P6VjU","Form__CheckLabel":"candidate-profile-job_Form__CheckLabel__tHoIf","PrivateSwitchBase-root-1":"candidate-profile-job_PrivateSwitchBase-root-1__F4RxH","Form__Caption":"candidate-profile-job_Form__Caption__kNY6G","Form__Input_currency":"candidate-profile-job_Form__Input_currency__vHpfa","Form__Input_MatchScore":"candidate-profile-job_Form__Input_MatchScore__thWGx","Form__Percentage_Symbol":"candidate-profile-job_Form__Percentage_Symbol__CQDpi","Form__NoGridTemplate":"candidate-profile-job_Form__NoGridTemplate__c_H8r","active":"candidate-profile-job_active__2w2Wf","mt10":"candidate-profile-job_mt10__Aq1DM","mt40":"candidate-profile-job_mt40___JcQH","mt30":"candidate-profile-job_mt30__IIBhy","mt32":"candidate-profile-job_mt32__EDbPs","mb0":"candidate-profile-job_mb0___CWGR","Dpgrid":"candidate-profile-job_Dpgrid__wAgMY","mb12":"candidate-profile-job_mb12__mBXWE","width100":"candidate-profile-job_width100__Ju_pZ","Tagrow__Prefix":"candidate-profile-job_Tagrow__Prefix__HD1jl","PreviewJobPage":"candidate-profile-job_PreviewJobPage__r0kBW","PreviewJob":"candidate-profile-job_PreviewJob__Qm2ut","DpFlx":"candidate-profile-job_DpFlx__pg7vw","Subheading":"candidate-profile-job_Subheading__hjI3H","Subheading__Description":"candidate-profile-job_Subheading__Description__Zs0cQ","Candidate__Tooltip":"candidate-profile-job_Candidate__Tooltip__DTxb4","Candidate__Tooltip__Score":"candidate-profile-job_Candidate__Tooltip__Score__NslQe","Form__InputField":"candidate-profile-job_Form__InputField__bFCyF","Candidate__Length":"candidate-profile-job_Candidate__Length__riA3b","Agency__PostDay":"candidate-profile-job_Agency__PostDay___NNFB","Agency__Title":"candidate-profile-job_Agency__Title__EOFLV","Agency__Location":"candidate-profile-job_Agency__Location__BzCO3","Agency__DescriptionTitle":"candidate-profile-job_Agency__DescriptionTitle__EtmmW","Agency__Description":"candidate-profile-job_Agency__Description__JG22m","LightBlueColor":"candidate-profile-job_LightBlueColor__GyxnP","AgencyDetailForm":"candidate-profile-job_AgencyDetailForm__u5l3k","Client_Page":"candidate-profile-job_Client_Page__nd5hX","Welcome":"candidate-profile-job_Welcome__IaD1_","Welcome__Inner":"candidate-profile-job_Welcome__Inner__LxNU9","Welcome__Person":"candidate-profile-job_Welcome__Person__dUuax","Welcome__LeftContent":"candidate-profile-job_Welcome__LeftContent__md3lj","Welcome__RightContent":"candidate-profile-job_Welcome__RightContent__W4i8d","Welcome__Content":"candidate-profile-job_Welcome__Content__qA4bt","Welcome__CreateAccount":"candidate-profile-job_Welcome__CreateAccount__y26_Q","Welcome__title":"candidate-profile-job_Welcome__title__u12Ic","Welcome__FormBox":"candidate-profile-job_Welcome__FormBox__ksh8e","Form__psw":"candidate-profile-job_Form__psw__aJmDC","Welcome__Container":"candidate-profile-job_Welcome__Container__JpIgX","Success__Container":"candidate-profile-job_Success__Container__RpRyf","Success":"candidate-profile-job_Success__S32jj","Success__Inner":"candidate-profile-job_Success__Inner__bq_lt","InterviewContainer":"candidate-profile-job_InterviewContainer__zz0tG","Interview__Stages":"candidate-profile-job_Interview__Stages__w_Ltc","Interview__StageHeading":"candidate-profile-job_Interview__StageHeading__mU6xh","pl10":"candidate-profile-job_pl10__7n6__","Interview__AddStageSection":"candidate-profile-job_Interview__AddStageSection__7BEm5","Interview__Label":"candidate-profile-job_Interview__Label__T2xVm","Interview__FormRowHeading":"candidate-profile-job_Interview__FormRowHeading__By7HB","dpflex":"candidate-profile-job_dpflex__zgmJy","Interview__IconsType":"candidate-profile-job_Interview__IconsType__hGPoH","Interview__Icons":"candidate-profile-job_Interview__Icons__v8ohS","Interview__Interview_buttons":"candidate-profile-job_Interview__Interview_buttons__OiAOf","Interview__approvalButton":"candidate-profile-job_Interview__approvalButton__oZmew","Interview__BestMatch":"candidate-profile-job_Interview__BestMatch__q4Wj5","Interview__BestMatchExclamation":"candidate-profile-job_Interview__BestMatchExclamation__I4pIx","DragAndDrop":"candidate-profile-job_DragAndDrop__gYmBN","DragAndDrop__CursorHandle":"candidate-profile-job_DragAndDrop__CursorHandle__Dwxl3","Tagrow__Image":"candidate-profile-job_Tagrow__Image__SrPMU","rowbglight":"candidate-profile-job_rowbglight__D22Ab","rowbgheight":"candidate-profile-job_rowbgheight__Omxj2","Form__w90":"candidate-profile-job_Form__w90__Yzjr3","Container":"candidate-profile-job_Container__n6oGV","Screening__StageName":"candidate-profile-job_Screening__StageName__mY938","Screening__InterviewType":"candidate-profile-job_Screening__InterviewType__Bfd3M","Screening__InterviewType__Label":"candidate-profile-job_Screening__InterviewType__Label__LF9GJ","Show_Infoicon":"candidate-profile-job_Show_Infoicon__USdaq","Show_Infoicon_small":"candidate-profile-job_Show_Infoicon_small__R7x4m","Screening__Info":"candidate-profile-job_Screening__Info__N50El","Screening__Info__IconWithText":"candidate-profile-job_Screening__Info__IconWithText__45_Yw","InterviewType__Icon":"candidate-profile-job_InterviewType__Icon__uw4VI","InterviewType__Text":"candidate-profile-job_InterviewType__Text__vzTOR","LoginModal":"candidate-profile-job_LoginModal__y_jsj","Logincontent":"candidate-profile-job_Logincontent__UpdQI","Logincontent__title":"candidate-profile-job_Logincontent__title__xldAl","Modalbg":"candidate-profile-job_Modalbg___LvdZ","Modalnobg":"candidate-profile-job_Modalnobg__akWjF","Form__Container":"candidate-profile-job_Form__Container__PQATv","Form__success":"candidate-profile-job_Form__success___a8qt","Form__error":"candidate-profile-job_Form__error__7YkGa","Form__CheckLabeltext":"candidate-profile-job_Form__CheckLabeltext__7zhiJ","Form__TextLeft":"candidate-profile-job_Form__TextLeft__gYnxQ","Backsection":"candidate-profile-job_Backsection__R1i0o","back":"candidate-profile-job_back__vx6N9","mlr0":"candidate-profile-job_mlr0__TJu47","TwoButtons":"candidate-profile-job_TwoButtons__pNOvc","OtpBacksection":"candidate-profile-job_OtpBacksection__A6ZQC","SetupPopup":"candidate-profile-job_SetupPopup__b6HKn","JobList__EditModal":"candidate-profile-job_JobList__EditModal__MXgK_","SetupPopup__inner":"candidate-profile-job_SetupPopup__inner__hy_RY","SetupPopup__Dialog":"candidate-profile-job_SetupPopup__Dialog__XSe7I","SetupPopup__AddFile":"candidate-profile-job_SetupPopup__AddFile__EK1x2","SetupPopup__OptionalText":"candidate-profile-job_SetupPopup__OptionalText__Aum1_","SetupPopup__RequestAccessBtn":"candidate-profile-job_SetupPopup__RequestAccessBtn__CsHMv","SetupPopup__InternalSection":"candidate-profile-job_SetupPopup__InternalSection__1lIKt","SetupPopup__ContentInnerRow":"candidate-profile-job_SetupPopup__ContentInnerRow__W0CEU","SetupPopup__ToChips":"candidate-profile-job_SetupPopup__ToChips__UMWjF","SetupPopup__AttachmentContainer":"candidate-profile-job_SetupPopup__AttachmentContainer__KjnmC","SetupPopup__ContentInnerCol":"candidate-profile-job_SetupPopup__ContentInnerCol__X88gd","SetupPopup__grid":"candidate-profile-job_SetupPopup__grid__UZzKv","SetupPopup__Footer":"candidate-profile-job_SetupPopup__Footer__s_tXF","SetupPopup__FooterNew":"candidate-profile-job_SetupPopup__FooterNew__DQdwg","SetupPopup__Footer2":"candidate-profile-job_SetupPopup__Footer2__lGgCr","SetupPopup__Footer3":"candidate-profile-job_SetupPopup__Footer3__LUDBD","SetupPopup__Footerassess":"candidate-profile-job_SetupPopup__Footerassess__KpMmW","SetupPopup__Footertechtest":"candidate-profile-job_SetupPopup__Footertechtest__yOhco","SetupPopup__AutommationFooter":"candidate-profile-job_SetupPopup__AutommationFooter__HaHEN","SetupPopup__MannualFooter":"candidate-profile-job_SetupPopup__MannualFooter__dMQfv","SetupPopup__MannualInnerSection":"candidate-profile-job_SetupPopup__MannualInnerSection__TEexh","SetupPopup__Content":"candidate-profile-job_SetupPopup__Content__0i4Lv","SetupPopup__Content__Radiobtn":"candidate-profile-job_SetupPopup__Content__Radiobtn__UwHCZ","SetupPopup__AutomationToggle":"candidate-profile-job_SetupPopup__AutomationToggle__qyidX","SetupPopup__SetupVideoQa":"candidate-profile-job_SetupPopup__SetupVideoQa__pZBir","SetupPopup__SetupVideoQa2":"candidate-profile-job_SetupPopup__SetupVideoQa2__O7u2x","SetupPopup__SetupVideoQa3":"candidate-profile-job_SetupPopup__SetupVideoQa3__9d2j4","SetupPopup__SetupVideoQa4":"candidate-profile-job_SetupPopup__SetupVideoQa4__kqLIH","SetupPopup__InputQA":"candidate-profile-job_SetupPopup__InputQA__54IzA","SetupPopup__AddQuestion":"candidate-profile-job_SetupPopup__AddQuestion__jPGvF","SetupPopup__QuestionSection":"candidate-profile-job_SetupPopup__QuestionSection___rsb9","SetupPopup__PushTop":"candidate-profile-job_SetupPopup__PushTop__UbudR","SetupPopup__Contentpading":"candidate-profile-job_SetupPopup__Contentpading__WJ3lC","SetupPopup__QuesionSectionpading":"candidate-profile-job_SetupPopup__QuesionSectionpading__lCCnP","SetupPopup__Contentcenter":"candidate-profile-job_SetupPopup__Contentcenter__UrLia","SetupPopup__PopDetails":"candidate-profile-job_SetupPopup__PopDetails__nVnaz","SetupPopup__PopDetails__FS16":"candidate-profile-job_SetupPopup__PopDetails__FS16__5LIdt","SetupPopup__Details":"candidate-profile-job_SetupPopup__Details__VGCr3","SetupPopup__PrivacyPolicyDetails":"candidate-profile-job_SetupPopup__PrivacyPolicyDetails__HEn2u","SetupPopup__Reason":"candidate-profile-job_SetupPopup__Reason__36uva","SetupPopup__ContentBlock":"candidate-profile-job_SetupPopup__ContentBlock__V2bOp","SetupPopup__Purpose":"candidate-profile-job_SetupPopup__Purpose__BBv0c","SetupPopup__ContentGridsec":"candidate-profile-job_SetupPopup__ContentGridsec__1dukO","mt25":"candidate-profile-job_mt25__v___L","mt20":"candidate-profile-job_mt20__AlgeE","SetupPopup__ContentGridTech":"candidate-profile-job_SetupPopup__ContentGridTech__Dr2tT","SetupPopup__Assesmentsection":"candidate-profile-job_SetupPopup__Assesmentsection__s0eqV","SetupPopup__AssesmentsectionNew":"candidate-profile-job_SetupPopup__AssesmentsectionNew__tDegB","SetupPopup__MannualChips":"candidate-profile-job_SetupPopup__MannualChips__VEjEZ","SetupPopup__ContentGridManuaCol":"candidate-profile-job_SetupPopup__ContentGridManuaCol__NqWqo","SetupPopup__ContentGridManual":"candidate-profile-job_SetupPopup__ContentGridManual__M1_dQ","SetupPopup__ContentBlockPhone":"candidate-profile-job_SetupPopup__ContentBlockPhone__Rnuim","SetupPopup__ContentAddInterview":"candidate-profile-job_SetupPopup__ContentAddInterview__2GNB9","SetupPopup__ContentGridPhone":"candidate-profile-job_SetupPopup__ContentGridPhone__oed7Z","SetupPopup__ContentGridStatus":"candidate-profile-job_SetupPopup__ContentGridStatus__P1aIJ","SetupPopup__GridActions":"candidate-profile-job_SetupPopup__GridActions__NXb0U","SetupPopup__GridActionCoral":"candidate-profile-job_SetupPopup__GridActionCoral__nZcol","SetupPopup__GridActionIndigo":"candidate-profile-job_SetupPopup__GridActionIndigo__BrLbt","SetupPopup__ContentGrid":"candidate-profile-job_SetupPopup__ContentGrid__QGm00","SetupPopup__SubmitSectionSave":"candidate-profile-job_SetupPopup__SubmitSectionSave__9qHIS","SetupPopup__SubmitSectionReset":"candidate-profile-job_SetupPopup__SubmitSectionReset__Urffd","SetupPopup__SubmitSectionAutomation":"candidate-profile-job_SetupPopup__SubmitSectionAutomation__qVS14","SetupPopup__Duration":"candidate-profile-job_SetupPopup__Duration__Hk7_F","SetupPopup__DeleteIcon":"candidate-profile-job_SetupPopup__DeleteIcon__wELrC","SetupPopup__ContentCustomisationManualInterview":"candidate-profile-job_SetupPopup__ContentCustomisationManualInterview__5Egt7","mt0":"candidate-profile-job_mt0__pTEqx","mtb25":"candidate-profile-job_mtb25__ntaDJ","mb15":"candidate-profile-job_mb15__MkoZi","mb30":"candidate-profile-job_mb30__z41Xr","mt9":"candidate-profile-job_mt9__4NBgM","lineheight0":"candidate-profile-job_lineheight0__lEK13","PopupHeightSection":"candidate-profile-job_PopupHeightSection__ACqPz","AssessPopupHeightSection":"candidate-profile-job_AssessPopupHeightSection__QJkcX","Statusopupheight":"candidate-profile-job_Statusopupheight__CSVXh","buttonIn":"candidate-profile-job_buttonIn__6KVAC","MessagePlaceholder":"candidate-profile-job_MessagePlaceholder__y0fO_","m0":"candidate-profile-job_m0__y9fXK","mt18":"candidate-profile-job_mt18__NjF24","DPgrid":"candidate-profile-job_DPgrid__0OlaU","addbtnposition":"candidate-profile-job_addbtnposition__96HwZ","mainformdiv":"candidate-profile-job_mainformdiv__hwz3n","crossflex":"candidate-profile-job_crossflex__faISZ","crossimgheight":"candidate-profile-job_crossimgheight__LKwOW","crossimgheight48":"candidate-profile-job_crossimgheight48__75LbE","SetupModalPopup":"candidate-profile-job_SetupModalPopup__XtyCX","SetupModalPopup__Dialog":"candidate-profile-job_SetupModalPopup__Dialog__XttmU","SetupPopupoverlay":"candidate-profile-job_SetupPopupoverlay__eZP6J","NeedHelp":"candidate-profile-job_NeedHelp__7xcDZ","uploadNewTest":"candidate-profile-job_uploadNewTest__FVOc4","SetupPopup__ol":"candidate-profile-job_SetupPopup__ol__ZrtyD","Threshold__Content":"candidate-profile-job_Threshold__Content__Crt_A","SetupPopup__ContentGridPhone__Content":"candidate-profile-job_SetupPopup__ContentGridPhone__Content__imEPX","JobList__EditModalInner":"candidate-profile-job_JobList__EditModalInner__z_o1k","Popupheight":"candidate-profile-job_Popupheight__81owR","CandidateBulkActionSection":"candidate-profile-job_CandidateBulkActionSection__zVZh9","KanbanBulkActionSection":"candidate-profile-job_KanbanBulkActionSection__AmYmE","KanbanBulkActionSection__Progress":"candidate-profile-job_KanbanBulkActionSection__Progress__ewO3x","KanbanBulkActionSection__Message":"candidate-profile-job_KanbanBulkActionSection__Message__21_wf","Heading":"candidate-profile-job_Heading__ChiVK","Offer__Container":"candidate-profile-job_Offer__Container__FZFjl","Offer__DetailsSection":"candidate-profile-job_Offer__DetailsSection__3D4AY","Offer__NoMarginTop":"candidate-profile-job_Offer__NoMarginTop__lvsz3","Offer__Mt20":"candidate-profile-job_Offer__Mt20__0tWyN","Form__OfferSubmit":"candidate-profile-job_Form__OfferSubmit___SdIX","Error":"candidate-profile-job_Error__EKFJX","SignContract":"candidate-profile-job_SignContract__kG_t1","SignContract__Container":"candidate-profile-job_SignContract__Container__uMXZL","SignContract__Button":"candidate-profile-job_SignContract__Button__bLw_7","SignContract__Header":"candidate-profile-job_SignContract__Header__FShIq","SignContract__Page":"candidate-profile-job_SignContract__Page__BQmaq","SignContract__Logo":"candidate-profile-job_SignContract__Logo___jAQ4","SignContract__Main":"candidate-profile-job_SignContract__Main__Jq4uO","OfferDetail__Container":"candidate-profile-job_OfferDetail__Container__QW3vn","JobOfferDetails":"candidate-profile-job_JobOfferDetails__8RJl0","JobOfferDetails__Section":"candidate-profile-job_JobOfferDetails__Section__eHfjv","JobOfferDetails__Row":"candidate-profile-job_JobOfferDetails__Row__sVn63","JobOfferDetails__LeftCol":"candidate-profile-job_JobOfferDetails__LeftCol__Xl8R1","JobOfferDetails__RightCol":"candidate-profile-job_JobOfferDetails__RightCol__LrS4O","JobOfferDetails__Label":"candidate-profile-job_JobOfferDetails__Label__mboJg","JobOfferDetails__Data":"candidate-profile-job_JobOfferDetails__Data__eZcTS","JobOfferDetails__W100":"candidate-profile-job_JobOfferDetails__W100__r1Zsh","JobOfferDetails__MR20":"candidate-profile-job_JobOfferDetails__MR20__oCOZU","Offer":"candidate-profile-job_Offer__36w1b","OfferDetail":"candidate-profile-job_OfferDetail__Oxcu8","ProgressLineSection":"candidate-profile-job_ProgressLineSection__WULMz","ProgressLineSection__Container":"candidate-profile-job_ProgressLineSection__Container__aUjl6","ProgressLineSection__AcionSection":"candidate-profile-job_ProgressLineSection__AcionSection__dlR9n","ProgressLineSection__ActionButtons":"candidate-profile-job_ProgressLineSection__ActionButtons__O0xLt","ProgressLineSection__Heading":"candidate-profile-job_ProgressLineSection__Heading__e1lzX","TopHeaderSection":"candidate-profile-job_TopHeaderSection__oPCaj","TopHeaderSection__SpaceBetween":"candidate-profile-job_TopHeaderSection__SpaceBetween__Rpzko","AgencyHeading":"candidate-profile-job_AgencyHeading__KVtG0","StatsSection":"candidate-profile-job_StatsSection__Q6v_E","StatsSection__List":"candidate-profile-job_StatsSection__List__EzH_p","StatsSection__NewList":"candidate-profile-job_StatsSection__NewList__FZWSN","StatsSection__ListStatus":"candidate-profile-job_StatsSection__ListStatus__gzZWv","StatsSection__NewListStatus":"candidate-profile-job_StatsSection__NewListStatus__JneQF","StatsSection__Statslist":"candidate-profile-job_StatsSection__Statslist__UYIb5","StatsSection__StatsAnchor":"candidate-profile-job_StatsSection__StatsAnchor__jED6b","StatsSection__StatsContent":"candidate-profile-job_StatsSection__StatsContent__mCj_s","StatsSection__StatsContentWidth":"candidate-profile-job_StatsSection__StatsContentWidth__WSYKn","StatsSection__StatsNumber":"candidate-profile-job_StatsSection__StatsNumber__5AR8v","StatsSection__StatsNumberWidth":"candidate-profile-job_StatsSection__StatsNumberWidth__NTjs2","StatsSection__Health":"candidate-profile-job_StatsSection__Health__jwfG_","StatsSection__IndigoBg":"candidate-profile-job_StatsSection__IndigoBg__ZUDb4","StatsSection__CorelBg":"candidate-profile-job_StatsSection__CorelBg__oXvH7","StatsSection__GreenBg":"candidate-profile-job_StatsSection__GreenBg__6_o6j","StatsSection__RoseBg":"candidate-profile-job_StatsSection__RoseBg__RPsHQ","StatsSection__CorelDarkBg":"candidate-profile-job_StatsSection__CorelDarkBg__hCaZS","StatsSection__StatBgOne":"candidate-profile-job_StatsSection__StatBgOne__8yySq","StatsSection__StatBgOne__NoBorder":"candidate-profile-job_StatsSection__StatBgOne__NoBorder__uUzPk","StatsSection__StatBgTwo":"candidate-profile-job_StatsSection__StatBgTwo__38pPR","StatsSection__StatBgThree":"candidate-profile-job_StatsSection__StatBgThree__ItssK","StatsSection__StatBgFour":"candidate-profile-job_StatsSection__StatBgFour__1tOWG","NotificationSection":"candidate-profile-job_NotificationSection__2V83R","NotificationSection__InterviewListNoHover":"candidate-profile-job_NotificationSection__InterviewListNoHover__Eq6As","NotificationSection__AlertActivity":"candidate-profile-job_NotificationSection__AlertActivity__okIlO","NotificationSection__Alert":"candidate-profile-job_NotificationSection__Alert__oI5Id","NotificationSection__List":"candidate-profile-job_NotificationSection__List__zq4_0","NotificationSection__AlertContainer":"candidate-profile-job_NotificationSection__AlertContainer__DsFhQ","NotificationSection__CommunicationContainer":"candidate-profile-job_NotificationSection__CommunicationContainer__vtWYZ","NotificationSection__AlertActivityContainer":"candidate-profile-job_NotificationSection__AlertActivityContainer__EDSWj","NotificationSection__Schedulingmain":"candidate-profile-job_NotificationSection__Schedulingmain__Msq8g","NotificationSection__More":"candidate-profile-job_NotificationSection__More__X6uqb","NotificationSection__Alertslist":"candidate-profile-job_NotificationSection__Alertslist__PZPMJ","NotificationSection__Alertsmessage":"candidate-profile-job_NotificationSection__Alertsmessage__5N5aK","NotificationSection__AlertsTilte":"candidate-profile-job_NotificationSection__AlertsTilte__T0LS0","NotificationSection__AlertHeading":"candidate-profile-job_NotificationSection__AlertHeading__QlwAG","NotificationSection__CalendarHeading":"candidate-profile-job_NotificationSection__CalendarHeading__H8yd_","NotificationSection__Dismiss":"candidate-profile-job_NotificationSection__Dismiss__f8WfS","NotificationSection__Communications":"candidate-profile-job_NotificationSection__Communications__2mUmV","NotificationSection__ProfileCircle":"candidate-profile-job_NotificationSection__ProfileCircle__Jdm7n","NotificationSection__SchedulingTiming":"candidate-profile-job_NotificationSection__SchedulingTiming__StMFc","NotificationSection__TimimgsSection":"candidate-profile-job_NotificationSection__TimimgsSection__MLP6V","NotificationSection__WeekTiming":"candidate-profile-job_NotificationSection__WeekTiming__kbRa2","NotificationSection__Scheduling":"candidate-profile-job_NotificationSection__Scheduling__8islV","NotificationSection__Pagination":"candidate-profile-job_NotificationSection__Pagination___4V6d","NotificationSection__PaginationButton":"candidate-profile-job_NotificationSection__PaginationButton__scgP6","NotificationSection__InterviewListSvg":"candidate-profile-job_NotificationSection__InterviewListSvg__5Ytzs","NotificationSection__InterviewListStage":"candidate-profile-job_NotificationSection__InterviewListStage__acIRa","NotificationSection__InterviewList":"candidate-profile-job_NotificationSection__InterviewList__u7yFu","NotificationSection__Interviewtitle":"candidate-profile-job_NotificationSection__Interviewtitle__TQBLM","NotificationSection__InterviewerProfile":"candidate-profile-job_NotificationSection__InterviewerProfile__Q_QB2","NotificationSection__InterviewerDate":"candidate-profile-job_NotificationSection__InterviewerDate__irGmA","NotificationSection__Greybox":"candidate-profile-job_NotificationSection__Greybox__Cs6p2","NotificationSection__Tabs":"candidate-profile-job_NotificationSection__Tabs__C4v6N","React__tabs":"candidate-profile-job_React__tabs__97_n1","React__tabs__today":"candidate-profile-job_React__tabs__today__FRpv7","React__tabs__head":"candidate-profile-job_React__tabs__head__TMOz_","React__tabs__tabpanel":"candidate-profile-job_React__tabs__tabpanel__KpJYS","React__tabs__tablist":"candidate-profile-job_React__tabs__tablist__eOZyT","React__tabs__tablist__tab":"candidate-profile-job_React__tabs__tablist__tab__vXsqQ","React__tabs__interviewtype":"candidate-profile-job_React__tabs__interviewtype__vEvxf","React__tabs__MyInterview":"candidate-profile-job_React__tabs__MyInterview__xIcFJ","React__tabs__TeamInterview":"candidate-profile-job_React__tabs__TeamInterview__5Mr1z","NamePrefix":"candidate-profile-job_NamePrefix__cv_7r","CandidatePrefix":"candidate-profile-job_CandidatePrefix__fE5ht","TopSection":"candidate-profile-job_TopSection___2ed2","CalendarSelectedDate":"candidate-profile-job_CalendarSelectedDate__3mxuQ","TitleFlex":"candidate-profile-job_TitleFlex__CwqE_","JobList__Accordian":"candidate-profile-job_JobList__Accordian__CUyhk","JobList__AccordianContent":"candidate-profile-job_JobList__AccordianContent__Kux3f","JobList__SearchSection":"candidate-profile-job_JobList__SearchSection__usemH","JobList__FilterMarginBottom":"candidate-profile-job_JobList__FilterMarginBottom__oB3ZP","JobList__SearchFilter":"candidate-profile-job_JobList__SearchFilter__XTdqL","JobList__AppliedSearchFilter":"candidate-profile-job_JobList__AppliedSearchFilter__LqgXe","JobList__SearchFilterFullWidth":"candidate-profile-job_JobList__SearchFilterFullWidth__F6mK4","JobList__AddJobSection":"candidate-profile-job_JobList__AddJobSection__bAmFn","JobList__Status":"candidate-profile-job_JobList__Status__qrUFs","JobList__EditModalContainer":"candidate-profile-job_JobList__EditModalContainer__K7ctz","JobList__EditModalMessage":"candidate-profile-job_JobList__EditModalMessage__AwQMc","JobList__EditModalButtonSection":"candidate-profile-job_JobList__EditModalButtonSection__OtjKk","JobList__CheckLabel":"candidate-profile-job_JobList__CheckLabel__bLO8x","JobList__Checkbox":"candidate-profile-job_JobList__Checkbox__gIeLN","JobList__JobBoard":"candidate-profile-job_JobList__JobBoard__tNXaZ","JobList__Reasons":"candidate-profile-job_JobList__Reasons__7vuoA","KanbanSearch__Dots":"candidate-profile-job_KanbanSearch__Dots__7a3ji","AgencyDetailForm__Label":"candidate-profile-job_AgencyDetailForm__Label__tvgWv","AgencyDetailForm__Data":"candidate-profile-job_AgencyDetailForm__Data__RrB33","AgencyDetailForm__Actionsection":"candidate-profile-job_AgencyDetailForm__Actionsection___RDnU","AgencyDetailForm__FormInputSection":"candidate-profile-job_AgencyDetailForm__FormInputSection__bTSIP","ApprovalContract":"candidate-profile-job_ApprovalContract__7ZMp6","ApprovalContractButtons":"candidate-profile-job_ApprovalContractButtons__IzEnL","Form__TableRowBlock":"candidate-profile-job_Form__TableRowBlock__cOqT6","Form__TableCol2":"candidate-profile-job_Form__TableCol2__DTa0F","Form__TableColNormal":"candidate-profile-job_Form__TableColNormal__h1ef0","JobFilter":"candidate-profile-job_JobFilter__hnpNv","JobFilter__Inner":"candidate-profile-job_JobFilter__Inner__zD4Af","JobFilter__Head":"candidate-profile-job_JobFilter__Head__6ma16","JobFilter__SubmitSection":"candidate-profile-job_JobFilter__SubmitSection__l9aXb","JobFilter__EmailFilterBottom":"candidate-profile-job_JobFilter__EmailFilterBottom___6rA2","CropImage":"candidate-profile-job_CropImage__W_qWJ","CropImage__Actions":"candidate-profile-job_CropImage__Actions__bUzYR","CropImage__Inner":"candidate-profile-job_CropImage__Inner__hRVv2","CropImage__Head":"candidate-profile-job_CropImage__Head__c2iKG","CropImage__SubmitSection":"candidate-profile-job_CropImage__SubmitSection__sPyYq","ModalClose":"candidate-profile-job_ModalClose__nydE_","Form__gap16":"candidate-profile-job_Form__gap16__uH4_m","fontslabel":"candidate-profile-job_fontslabel__uV5vE","HideButton":"candidate-profile-job_HideButton__8ufBN","ExpandButton":"candidate-profile-job_ExpandButton__nreYn","InfoContainer":"candidate-profile-job_InfoContainer__GC4XI","HeadingSection":"candidate-profile-job_HeadingSection__iXVOz","AssessHeadingSection":"candidate-profile-job_AssessHeadingSection__4naUL","HeadingInfoSection":"candidate-profile-job_HeadingInfoSection__UGmiK","CloseSection":"candidate-profile-job_CloseSection__49yOR","CloseSectionbuton":"candidate-profile-job_CloseSectionbuton__Mir_k","Profile":"candidate-profile-job_Profile__xQBsw","Profile__PaddingRight":"candidate-profile-job_Profile__PaddingRight__PlRCW","Profile__FormButtonSection":"candidate-profile-job_Profile__FormButtonSection__DrIfs","Profile__EditSection":"candidate-profile-job_Profile__EditSection__JkE4e","Profile__Link":"candidate-profile-job_Profile__Link__XPWaZ","Profile__LeftSection":"candidate-profile-job_Profile__LeftSection__cB5ja","Profile__EditFormSection":"candidate-profile-job_Profile__EditFormSection__rhp4I","Profile__LeftTopSection":"candidate-profile-job_Profile__LeftTopSection__stSG3","Profile__RightSection":"candidate-profile-job_Profile__RightSection__waphS","Profile__TopSectionName":"candidate-profile-job_Profile__TopSectionName__nPBj0","Profile__LikeSection":"candidate-profile-job_Profile__LikeSection__U1lh8","Profile__Details":"candidate-profile-job_Profile__Details__VwHbP","Profile__ScoreIconsSection":"candidate-profile-job_Profile__ScoreIconsSection__imzLc","Profile__Name":"candidate-profile-job_Profile__Name__NVICi","Profile__NameContainer":"candidate-profile-job_Profile__NameContainer__OHKhv","Profile__Steps":"candidate-profile-job_Profile__Steps__jV8CT","Profile__Score":"candidate-profile-job_Profile__Score__S7U1c","Profile__Dextra":"candidate-profile-job_Profile__Dextra__U5Y_9","Profile__NextPrev":"candidate-profile-job_Profile__NextPrev__ssFh5","Profile__Status":"candidate-profile-job_Profile__Status__1IAj0","Profile__MultipleStatus":"candidate-profile-job_Profile__MultipleStatus__stzOc","Profile__MakeExclamation":"candidate-profile-job_Profile__MakeExclamation__KOPG_","Profile__DetailsSection":"candidate-profile-job_Profile__DetailsSection___rJRo","Profile__DetailsSectionEmail":"candidate-profile-job_Profile__DetailsSectionEmail__EvDza","Profile__DetailSectionRow":"candidate-profile-job_Profile__DetailSectionRow__VMXic","Profile__DetailSectionoutercol":"candidate-profile-job_Profile__DetailSectionoutercol__ZHsql","Profile__DetailSectionRowGrid":"candidate-profile-job_Profile__DetailSectionRowGrid__jCcpv","Profile__DetailSectionRowcol":"candidate-profile-job_Profile__DetailSectionRowcol__Rt_1K","Profile__DetailSectionRowTwoGrid":"candidate-profile-job_Profile__DetailSectionRowTwoGrid__99R42","Profile__DetailSectionCol":"candidate-profile-job_Profile__DetailSectionCol__Ch48X","Profile__DetailSectionCol__LeftColumn":"candidate-profile-job_Profile__DetailSectionCol__LeftColumn__3dxP8","Profile__DetailSectionCol__RightColumn":"candidate-profile-job_Profile__DetailSectionCol__RightColumn__mFgpi","Profile__DetailSectionColWordBrk":"candidate-profile-job_Profile__DetailSectionColWordBrk__gdihr","Profile__TooltiptextPostion":"candidate-profile-job_Profile__TooltiptextPostion__SQGdr","Profile__ActionSection":"candidate-profile-job_Profile__ActionSection__S_Plx","Profile__TabsSection":"candidate-profile-job_Profile__TabsSection__Xh82z","Profile__TabsSection__Btn":"candidate-profile-job_Profile__TabsSection__Btn__Z_FMy","Profile__MakePrivateExclamation":"candidate-profile-job_Profile__MakePrivateExclamation__q2WyL","DpFlex":"candidate-profile-job_DpFlex___wzCe","ProfileTabs__ContentDetails":"candidate-profile-job_ProfileTabs__ContentDetails__s_rty","ProfileTabs__Author":"candidate-profile-job_ProfileTabs__Author__bfH4Q","ProfileTabs__Time":"candidate-profile-job_ProfileTabs__Time__rK2Ek","ProfileTabs__TagsContainer":"candidate-profile-job_ProfileTabs__TagsContainer__tM9Lr","ProfileTabs__Content":"candidate-profile-job_ProfileTabs__Content__STc0x","ProfileTabs__PostedDay":"candidate-profile-job_ProfileTabs__PostedDay__JtbH2","ProfileTabs__Application":"candidate-profile-job_ProfileTabs__Application__rHTjA","ProfileTabs__VideoApplicatonLink":"candidate-profile-job_ProfileTabs__VideoApplicatonLink__YNOGy","ProfileTabs__ApplicationRow":"candidate-profile-job_ProfileTabs__ApplicationRow__IgmuA","ProfileTabs__ApplicationCol2":"candidate-profile-job_ProfileTabs__ApplicationCol2__ZN3zd","ProfileTabs__ApplicationCol":"candidate-profile-job_ProfileTabs__ApplicationCol__ZqSz5","ProfileTabs__NoteTabNameSection":"candidate-profile-job_ProfileTabs__NoteTabNameSection__8lWCC","widthcontainer":"candidate-profile-job_widthcontainer__ly1wG","Email":"candidate-profile-job_Email__PhRRc","Email__Link":"candidate-profile-job_Email__Link__o_HvB","Email__Attachment":"candidate-profile-job_Email__Attachment__IyZR3","Email__Receiver":"candidate-profile-job_Email__Receiver__Doihn","Email__Top":"candidate-profile-job_Email__Top__rq8Sm","Email__SenderName":"candidate-profile-job_Email__SenderName__uOLk1","Email__EmailTime":"candidate-profile-job_Email__EmailTime__6ni8_","Email__EmailInfo":"candidate-profile-job_Email__EmailInfo__L5Re8","Email__To":"candidate-profile-job_Email__To__YHJRM","Email__Subject":"candidate-profile-job_Email__Subject__Ur_Jm","Email__Body":"candidate-profile-job_Email__Body___DvXu","Email__Content":"candidate-profile-job_Email__Content__E28SO","Email__Doc":"candidate-profile-job_Email__Doc__pXZ8K","Email__RecieverName":"candidate-profile-job_Email__RecieverName__3tw0G","Email__Reply":"candidate-profile-job_Email__Reply__dBeyf","Email__ReplyIcon":"candidate-profile-job_Email__ReplyIcon__7Br3k","Scorecards__Sectionone":"candidate-profile-job_Scorecards__Sectionone__JCfWb","Scorecards__ButtonSection":"candidate-profile-job_Scorecards__ButtonSection__RmVfL","Scorecards__DetailsBox":"candidate-profile-job_Scorecards__DetailsBox__nacMC","Scorecards__Action":"candidate-profile-job_Scorecards__Action__NPbbS","Scorecards__OverallScore":"candidate-profile-job_Scorecards__OverallScore__Y0sdM","Scorecards__DetailsBoxRow":"candidate-profile-job_Scorecards__DetailsBoxRow___mBM4","Scorecards__NameDetails":"candidate-profile-job_Scorecards__NameDetails__IZ3Rl","Scorecards__ScoreDetails":"candidate-profile-job_Scorecards__ScoreDetails__krBH4","Scorecards__Scorecard":"candidate-profile-job_Scorecards__Scorecard___k7vm","Scorecards__FeedbackForm":"candidate-profile-job_Scorecards__FeedbackForm__kXWvO","Scorecards__Questions":"candidate-profile-job_Scorecards__Questions__rfoAs","Scorecards__Ratings":"candidate-profile-job_Scorecards__Ratings__lbbQT","Scorecards__EditSpace":"candidate-profile-job_Scorecards__EditSpace__kuhfO","Offer__Label":"candidate-profile-job_Offer__Label__d50M5","Offer__ContentDetails":"candidate-profile-job_Offer__ContentDetails__ZLpFr","Offer__OfferLneBreak":"candidate-profile-job_Offer__OfferLneBreak__Rtzmn","Offer__Modify":"candidate-profile-job_Offer__Modify__U2cb4","Offer__Modify__Buttons":"candidate-profile-job_Offer__Modify__Buttons__f0jw_","Offer__Decline":"candidate-profile-job_Offer__Decline__FFe1o","CreateOfferContract":"candidate-profile-job_CreateOfferContract__9qaIi","CreateOfferContract__Buttons":"candidate-profile-job_CreateOfferContract__Buttons__sR7FA","CreateOfferContract__MainDetails":"candidate-profile-job_CreateOfferContract__MainDetails__gSstH","DraftOfferBtn":"candidate-profile-job_DraftOfferBtn__uBIuq","ProfileTabs__ApplicationForm":"candidate-profile-job_ProfileTabs__ApplicationForm___eesa","ProfileTabs__OfferApplicationRow":"candidate-profile-job_ProfileTabs__OfferApplicationRow__4XHwF","ProfileTabs__PostedDayWhiteLine":"candidate-profile-job_ProfileTabs__PostedDayWhiteLine__WwSuE","InfoDocs":"candidate-profile-job_InfoDocs__8ltl6","InfoDocs__ActionSection":"candidate-profile-job_InfoDocs__ActionSection__bp_hr","InfoDocs__ResumeSection":"candidate-profile-job_InfoDocs__ResumeSection__Rjdf5","InfoDocs__DocumentSection":"candidate-profile-job_InfoDocs__DocumentSection__WGpnq","InfoDocs__ResumeItem":"candidate-profile-job_InfoDocs__ResumeItem__w1KZq","InfoDocs__DocumentItem":"candidate-profile-job_InfoDocs__DocumentItem__hZlWn","InfoDocs__DefaultTag":"candidate-profile-job_InfoDocs__DefaultTag__pWUn7","InfoDocs__AddLink":"candidate-profile-job_InfoDocs__AddLink__7L6qA","InfoDocs__AddDocuments":"candidate-profile-job_InfoDocs__AddDocuments__6rtVR","InfoDocs__inner":"candidate-profile-job_InfoDocs__inner__JsHz0","InfoDocs__Row":"candidate-profile-job_InfoDocs__Row__IKtrL","InfoDocs__Row2":"candidate-profile-job_InfoDocs__Row2__QY2gc","InfoDocs__Edit":"candidate-profile-job_InfoDocs__Edit__0TTrp","InfoDocs__Col":"candidate-profile-job_InfoDocs__Col__g609K","InfoDocs__borderbootm":"candidate-profile-job_InfoDocs__borderbootm__tQLNx","InfoDocs__DocList":"candidate-profile-job_InfoDocs__DocList__2WVGx","InfoDocs__ErrorClass":"candidate-profile-job_InfoDocs__ErrorClass__z3brK","InfoDocs__InputContainer":"candidate-profile-job_InfoDocs__InputContainer__mngM0","InfoDocs__Save":"candidate-profile-job_InfoDocs__Save__NlqP_","InfoDocs__Cancel":"candidate-profile-job_InfoDocs__Cancel__N1V6c","PrevApp":"candidate-profile-job_PrevApp__N5jq4","bgtransparents":"candidate-profile-job_bgtransparents__GMQP3","JobCompetencyInput":"candidate-profile-job_JobCompetencyInput__wgJfS","AddCv_Division":"candidate-profile-job_AddCv_Division__F6a2M","AddCv_Button":"candidate-profile-job_AddCv_Button__ySPK8","TechTestBox":"candidate-profile-job_TechTestBox__58tRL","TechTestBox__Status":"candidate-profile-job_TechTestBox__Status__V4Z_D","TechTestBox__DetailSection":"candidate-profile-job_TechTestBox__DetailSection__wav0M","TechTestBox__Details":"candidate-profile-job_TechTestBox__Details__kfNxV","TechTestBox__Title":"candidate-profile-job_TechTestBox__Title__qV0vf","TechTestBox__Content":"candidate-profile-job_TechTestBox__Content__DLXGP","TechTestBox__ScoreBlue":"candidate-profile-job_TechTestBox__ScoreBlue__LQ0MB","TechTestBox__ScoreRed":"candidate-profile-job_TechTestBox__ScoreRed__yPsqE","TechTestBox__ResendSection":"candidate-profile-job_TechTestBox__ResendSection__Tm1Uw","TechTestBox__AssessmentStatus":"candidate-profile-job_TechTestBox__AssessmentStatus__xPpDV","TechTestBox__AssessmentExpand":"candidate-profile-job_TechTestBox__AssessmentExpand__LdQSq","TechTestBox__ScoreSection":"candidate-profile-job_TechTestBox__ScoreSection__pYRcp","TechTestBox__AssessmentContentLabels":"candidate-profile-job_TechTestBox__AssessmentContentLabels__rz75P","TechTestBox__Solutiongrid":"candidate-profile-job_TechTestBox__Solutiongrid__Lg_zr","TechTestBox__AssessmentContentLabels2":"candidate-profile-job_TechTestBox__AssessmentContentLabels2__MsPvT","TechTestBox__AssessmentContentScore":"candidate-profile-job_TechTestBox__AssessmentContentScore__3OIL8","TechTestBox__ProblemFile":"candidate-profile-job_TechTestBox__ProblemFile__MR5Xr","TechTestBox__ml10":"candidate-profile-job_TechTestBox__ml10__ZPOzR","TechTestBox__SolutionFile":"candidate-profile-job_TechTestBox__SolutionFile__LWg41","TechTestBox__ProblemLink":"candidate-profile-job_TechTestBox__ProblemLink___eNME","TechTestBox__AssessmentActions":"candidate-profile-job_TechTestBox__AssessmentActions__RJE_u","TechTestBox__HeadingInfoSection":"candidate-profile-job_TechTestBox__HeadingInfoSection__S8IGQ","TechTestBox__w100":"candidate-profile-job_TechTestBox__w100__fs__E","VideoQATab":"candidate-profile-job_VideoQATab__rn1kE","RightAlign":"candidate-profile-job_RightAlign__Dgimc","RightAlign__VideoQA":"candidate-profile-job_RightAlign__VideoQA__rOj6U","CardBox__BestMatchScore":"candidate-profile-job_CardBox__BestMatchScore__c_Mdv","CardBox__BestMatchScore__Icon":"candidate-profile-job_CardBox__BestMatchScore__Icon__b5vxm","CardBox__BestMatchScore__Data":"candidate-profile-job_CardBox__BestMatchScore__Data__yKXul","CardBox__ScoreSection":"candidate-profile-job_CardBox__ScoreSection__3NrE1","SmallBox":"candidate-profile-job_SmallBox__J5CzP","ScoreBoxHeading":"candidate-profile-job_ScoreBoxHeading__1EarN","ScoreBox__Jobs":"candidate-profile-job_ScoreBox__Jobs___5wLS","ScoreBox__Skills":"candidate-profile-job_ScoreBox__Skills__oLH1t","ScoreBox__Jobs_Title":"candidate-profile-job_ScoreBox__Jobs_Title__YqFYx","ScoreBox__Skills_Title":"candidate-profile-job_ScoreBox__Skills_Title__WvCo3","ScoreBox__Jobs_Name":"candidate-profile-job_ScoreBox__Jobs_Name__hhM4N","ScoreBox__Skills_Name":"candidate-profile-job_ScoreBox__Skills_Name__crNrq","ScoreBox__Jobs_Width100":"candidate-profile-job_ScoreBox__Jobs_Width100__GIBYI","ScoreBox__Skills_Width100":"candidate-profile-job_ScoreBox__Skills_Width100__o5arb","ScoreBox__Jobs_Score":"candidate-profile-job_ScoreBox__Jobs_Score__LLeh1","ScoreBox__Skills_Score":"candidate-profile-job_ScoreBox__Skills_Score__iprsY","ScoreBox__SkillDetails":"candidate-profile-job_ScoreBox__SkillDetails__qCR9z","ScoreBox__SkillDetail":"candidate-profile-job_ScoreBox__SkillDetail__N4C01","ScreeningDetails":"candidate-profile-job_ScreeningDetails__HpGy1","ScreeningDate":"candidate-profile-job_ScreeningDate__DVB97","ScreeningQuestion":"candidate-profile-job_ScreeningQuestion__t10xG","ScreeningQuestion__Heading":"candidate-profile-job_ScreeningQuestion__Heading__mYq_O","ScreeningQuestion__Answer":"candidate-profile-job_ScreeningQuestion__Answer__xdjmd","AgencyBadgeAlignment":"candidate-profile-job_AgencyBadgeAlignment__V8Ayq","StrokeWhite":"candidate-profile-job_StrokeWhite__ni41E","Profile__FormContainer":"candidate-profile-job_Profile__FormContainer__6BEbM","Profile__PostedDay":"candidate-profile-job_Profile__PostedDay__ld6w1","ProfileViewContainer":"candidate-profile-job_ProfileViewContainer__B8S5t","Profile__FlexColumn__Sm":"candidate-profile-job_Profile__FlexColumn__Sm__uC4q7","Profile__Source":"candidate-profile-job_Profile__Source__ssGit","Profile__50":"candidate-profile-job_Profile__50__2CY86","Profile__FormRow":"candidate-profile-job_Profile__FormRow__OQpgj","DpFlexStart":"candidate-profile-job_DpFlexStart__sSKf5","edit-link":"candidate-profile-job_edit-link__T81RO","Profile__FlexColumn__Md":"candidate-profile-job_Profile__FlexColumn__Md__Bb8xT"};

/***/ }),

/***/ 87079:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"candidates_Form__np99M","Form__width":"candidates_Form__width__yBZWJ","Form__label":"candidates_Form__label__JWLN6","Form__textleft":"candidates_Form__textleft__BzYH6","Form__InputFullWidth":"candidates_Form__InputFullWidth__erI3N","Form__Input":"candidates_Form__Input__aDEJp","Form__Input398":"candidates_Form__Input398__FQD_a","Form__InputSection":"candidates_Form__InputSection__oKiIv","Form__ScoreCardInput":"candidates_Form__ScoreCardInput__Rt_wk","Form__Textarea":"candidates_Form__Textarea__FbB93","Form__CustomSelect":"candidates_Form__CustomSelect__4Q_H3","Form__ErrorCustomSelect":"candidates_Form__ErrorCustomSelect__PJULd","Form__currency_symbol":"candidates_Form__currency_symbol__BaKHL","Form__select_currency":"candidates_Form__select_currency__7P8Zg","customSelect__placeholder":"candidates_customSelect__placeholder__XU_iQ","primarybtn":"candidates_primarybtn__1nNSw","JobList__EditModalEditButton":"candidates_JobList__EditModalEditButton__W4SlQ","GoBtn":"candidates_GoBtn__9Iqpk","secondarybtn":"candidates_secondarybtn__1XHp6","JobList__EditModalCancelButton":"candidates_JobList__EditModalCancelButton__dUq7_","iconFilled":"candidates_iconFilled__9PwKo","iconFilledSolid":"candidates_iconFilledSolid__8SE5l","primarybtnborder":"candidates_primarybtnborder__RRl0U","secondarybtnborder":"candidates_secondarybtnborder__6MHdV","ClearBtn":"candidates_ClearBtn__2lxGO","tertiarybtn":"candidates_tertiarybtn__hRizz","graybtnborder":"candidates_graybtnborder__mgU69","jobsrchbtn":"candidates_jobsrchbtn__CVF_s","jobsrchbtnalign":"candidates_jobsrchbtnalign__6a7DZ","nobgbutton":"candidates_nobgbutton__I0QRr","iconTextButton":"candidates_iconTextButton__vmpp9","cursornone":"candidates_cursornone__3Iphc","nobgbuttonprimary":"candidates_nobgbuttonprimary__2kg3O","mt15":"candidates_mt15__lGDuM","btn350":"candidates_btn350__JwgiY","GrayBgBtn":"candidates_GrayBgBtn__cP2xh","NewShareBtn":"candidates_NewShareBtn__tfK8i","CoralBgBtn":"candidates_CoralBgBtn__fN2M9","DropContainer":"candidates_DropContainer__mqSV5","DropContainer__Inner":"candidates_DropContainer__Inner__LmWRi","CompanyProfile__Inner":"candidates_CompanyProfile__Inner__VSOk2","DropContainer__Message":"candidates_DropContainer__Message__04veL","CompanyProfile__Message":"candidates_CompanyProfile__Message__k_m7V","CompanyProfile__MessageContent":"candidates_CompanyProfile__MessageContent___Geos","DropContainer__UploadIcon":"candidates_DropContainer__UploadIcon__yiXVv","CompanyProfile__UploadIcon":"candidates_CompanyProfile__UploadIcon__alzvc","FileDisplayContainer":"candidates_FileDisplayContainer__fMOBa","FileDisplayContainer__Status":"candidates_FileDisplayContainer__Status__3ieFF","SetupPopup__Status":"candidates_SetupPopup__Status__HuMDJ","SetupPopup__To":"candidates_SetupPopup__To__c8THP","FileDisplayContainer__Type":"candidates_FileDisplayContainer__Type__VW3SZ","FileDisplayContainer__Name":"candidates_FileDisplayContainer__Name__NqWB9","SetupPopup__Name":"candidates_SetupPopup__Name__4aamM","SetupPopup__ToName":"candidates_SetupPopup__ToName__h_8_b","FileDisplayContainer__Error":"candidates_FileDisplayContainer__Error__M7Yq_","FileDisplayContainer__Close":"candidates_FileDisplayContainer__Close__rtl1h","Browse":"candidates_Browse__BJe9J","ClientCompany":"candidates_ClientCompany__g73Yt","NewJob":"candidates_NewJob__7QADn","Interview":"candidates_Interview__EFBL2","ClientCompany__TopSection2":"candidates_ClientCompany__TopSection2__8nq1Q","ClientCompany__Filter":"candidates_ClientCompany__Filter__Y_R78","ClientCompany__Input_MatchScore":"candidates_ClientCompany__Input_MatchScore__Zp3V4","ClientCompany__Percentage_Symbol":"candidates_ClientCompany__Percentage_Symbol__iXHYP","ClientCompany__Filterheading":"candidates_ClientCompany__Filterheading__sPdy5","ClientCompany__FloatButtonAdd":"candidates_ClientCompany__FloatButtonAdd__OL9AP","ClientCompany__FloatButtonAdd__AgencyUserIcon":"candidates_ClientCompany__FloatButtonAdd__AgencyUserIcon__5cvID","ClientCompany__LastEdited":"candidates_ClientCompany__LastEdited__5GAON","ClientCompany__BackSection":"candidates_ClientCompany__BackSection__niduu","AddUsers__BackSection":"candidates_AddUsers__BackSection__nQ0EZ","ClientCompany__BackSection__CloseIcon":"candidates_ClientCompany__BackSection__CloseIcon__utf90","ClientCompany__Container":"candidates_ClientCompany__Container__XTgxU","NewJob__InterviewContainer":"candidates_NewJob__InterviewContainer__Igl1D","AddUsers__Container":"candidates_AddUsers__Container__FBSgN","ClientCompany__FormInputSection":"candidates_ClientCompany__FormInputSection__Ymnc3","CompanyProfile__FormInputSection":"candidates_CompanyProfile__FormInputSection__Fy_a1","ClientCompany__Heading":"candidates_ClientCompany__Heading__nL_dj","Offer__Heading":"candidates_Offer__Heading__3A4Eo","AddUsers__Heading":"candidates_AddUsers__Heading__HMT_O","ClientCompany__StatusAlignment":"candidates_ClientCompany__StatusAlignment__Sf6Ne","ClientCompany__Status":"candidates_ClientCompany__Status__TShMb","ClientCompany__ActiveDot":"candidates_ClientCompany__ActiveDot__hEwWK","ClientCompany__CloseDot":"candidates_ClientCompany__CloseDot__jbNi2","ClientCompany__Company":"candidates_ClientCompany__Company__GHpoD","AddUsers__User":"candidates_AddUsers__User__7MiOZ","ClientCompany__Systemrefheding":"candidates_ClientCompany__Systemrefheding__s1DuF","ClientCompany__Subheading":"candidates_ClientCompany__Subheading__fL6Kf","CompanyProfile__Subheading":"candidates_CompanyProfile__Subheading__Ra15H","ClientCompany__Subheading2":"candidates_ClientCompany__Subheading2__UDMvT","ClientCompany__Description":"candidates_ClientCompany__Description__un3Id","ClientCompany__SubmitSection":"candidates_ClientCompany__SubmitSection__mYvqQ","NewJob__SubmitSection":"candidates_NewJob__SubmitSection__Jzi5Z","NewJob__SubmitSectionThreeBtn":"candidates_NewJob__SubmitSectionThreeBtn__z4TUO","NewJob__SubmitSectionOneBtnPlacement":"candidates_NewJob__SubmitSectionOneBtnPlacement__ar_MY","NewJob__ImportSection":"candidates_NewJob__ImportSection___LYKU","SetupPopup__SubmitSection2":"candidates_SetupPopup__SubmitSection2__R976I","SetupPopup__SubmitSection":"candidates_SetupPopup__SubmitSection__78miE","SetupPopup__SubmitSection3":"candidates_SetupPopup__SubmitSection3__pjeMK","AddUsers__SubmitSection":"candidates_AddUsers__SubmitSection__z7mq_","ClientCompany__IntegrationImage":"candidates_ClientCompany__IntegrationImage__aY2y4","ClientCompany__QuickAdd":"candidates_ClientCompany__QuickAdd__xzYf7","NewJob__QuickAdd":"candidates_NewJob__QuickAdd__z4_iJ","JobList__QuickAdd":"candidates_JobList__QuickAdd__FEFht","Interview__QuickAdd":"candidates_Interview__QuickAdd__vrq9j","ClientCompany__BodyText":"candidates_ClientCompany__BodyText__oQ8C3","Form__TableRow":"candidates_Form__TableRow__cc31S","Form__TableRowTowGrid":"candidates_Form__TableRowTowGrid__Hftyo","Form__TableRowSingle":"candidates_Form__TableRowSingle__xonIx","Form__Label":"candidates_Form__Label__7Le7z","Form__Data":"candidates_Form__Data__Ccx5q","Form__DataSingleRow":"candidates_Form__DataSingleRow__K4o9J","Form__FloatingLabel":"candidates_Form__FloatingLabel__k7f_Z","Form__TableCol":"candidates_Form__TableCol__gvrts","Form__currency_symbol__right":"candidates_Form__currency_symbol__right__VEAjT","Form__TableCol__Disabled":"candidates_Form__TableCol__Disabled__w9akY","Form__TextareaDisabled":"candidates_Form__TextareaDisabled__3EZYj","Form__EditorDisabled":"candidates_Form__EditorDisabled__XP5x0","Form__AdminCheckLabel":"candidates_Form__AdminCheckLabel__nDkh7","Form__AdminCheckMargin":"candidates_Form__AdminCheckMargin__IozXd","CompanyProfile__BrandingGuide":"candidates_CompanyProfile__BrandingGuide__pKCA9","CompanyProfile__DropBoxContainer":"candidates_CompanyProfile__DropBoxContainer__N9sGE","CompanyProfile__Browse":"candidates_CompanyProfile__Browse__5XNQX","ErrorLabel":"candidates_ErrorLabel__i7wMg","Height80":"candidates_Height80__LoM6q","Browse__ButtonFlexEnd":"candidates_Browse__ButtonFlexEnd__ccSRb","AddAgency__Container":"candidates_AddAgency__Container__Gn_SB","AddAgency__FormInputSection":"candidates_AddAgency__FormInputSection___9dvC","AddAgency__FormInputSection__Label":"candidates_AddAgency__FormInputSection__Label__PxtFj","AddAgency__Form":"candidates_AddAgency__Form__E7QLI","LinkAsButtons":"candidates_LinkAsButtons__OVHI8","SearchFlex":"candidates_SearchFlex___UR40","Career":"candidates_Career__LS8ve","Career__Background_Edit":"candidates_Career__Background_Edit__vHvbO","Career__Background_Edit_Image":"candidates_Career__Background_Edit_Image__hV1yD","Career__Container":"candidates_Career__Container__cEFw4","Career__Inner":"candidates_Career__Inner__YovUQ","Career__logo":"candidates_Career__logo__7M6DX","Career__Content":"candidates_Career__Content__JrcxG","Career__ButtonSection":"candidates_Career__ButtonSection__4XSB9","Job":"candidates_Job__gFbGW","Job__Inner":"candidates_Job__Inner___xDPf","Job__Container":"candidates_Job__Container__2mPgW","Job__Heading":"candidates_Job__Heading__NEG_3","Job__Company":"candidates_Job__Company__Vunq8","Job__SearchContainer":"candidates_Job__SearchContainer__haKqa","CandidatesList__SearchContainer":"candidates_CandidatesList__SearchContainer__xHKnF","Job__SearchInput":"candidates_Job__SearchInput__l8TNM","CandidatesList__SearchInput":"candidates_CandidatesList__SearchInput__8ap5S","Job__Searchbtn":"candidates_Job__Searchbtn__1J1m0","CandidatesList__Searchbtn":"candidates_CandidatesList__Searchbtn__31Na6","Job__Input":"candidates_Job__Input__0ygEX","CandidatesList__Input":"candidates_CandidatesList__Input__zGepN","Job__SelectJob":"candidates_Job__SelectJob__XiAhe","Job__RemoteLabel":"candidates_Job__RemoteLabel__HiWRp","Job__Display":"candidates_Job__Display__cbH_Z","Job__PostDay":"candidates_Job__PostDay__Nras3","Job__Title":"candidates_Job__Title___TKZY","Job__Location":"candidates_Job__Location__uLSas","DT":"candidates_DT__Qjb_u","DisplayTable":"candidates_DisplayTable__4Qn5K","pd11":"candidates_pd11__CgG2F","Label":"candidates_Label__8iA9P","inputwidth":"candidates_inputwidth__2MdnA","mr24":"candidates_mr24__CKUgs","fullwidth":"candidates_fullwidth__9Xzm2","padt40":"candidates_padt40__nTmIs","Form__TableRowflex":"candidates_Form__TableRowflex__mV0eN","Form__TableColm":"candidates_Form__TableColm__knNss","Form__LabelCheck":"candidates_Form__LabelCheck__t5Nbj","Form__Error":"candidates_Form__Error__fam5l","Form__ErrorSection":"candidates_Form__ErrorSection__ebfym","Form__MessagePlaceholder":"candidates_Form__MessagePlaceholder__ShDwY","Form__Submit":"candidates_Form__Submit__850sV","Form__NormalLabel":"candidates_Form__NormalLabel__t7_6w","AddInterview":"candidates_AddInterview__f35Hk","IntegrationPage":"candidates_IntegrationPage__f4DA9","Integration__BackStep":"candidates_Integration__BackStep__3sm1k","AddUsers__BackStep":"candidates_AddUsers__BackStep__hZnea","Integration__SubmitSection":"candidates_Integration__SubmitSection___ffLP","IntegrationTable":"candidates_IntegrationTable__Yb6HV","IntegrationTable__LimitInput":"candidates_IntegrationTable__LimitInput__t2pOW","IntegrationTable__Type":"candidates_IntegrationTable__Type__8brDq","IntegrationTable__AllJobsToggle":"candidates_IntegrationTable__AllJobsToggle__Ykn0a","IntegrationTable__switch":"candidates_IntegrationTable__switch__0pERr","IntegrationTable__switchText":"candidates_IntegrationTable__switchText__AG1VZ","IntegrationTable__slider":"candidates_IntegrationTable__slider__PZBG8","IntegrationTable__round":"candidates_IntegrationTable__round__CUVNe","IntegrationTable__Action":"candidates_IntegrationTable__Action__LEVHG","IntegrationView":"candidates_IntegrationView__CsRsQ","IntegrationView__Title":"candidates_IntegrationView__Title__YdGh5","IntegrationView__Subheading":"candidates_IntegrationView__Subheading__nMFOi","IntegrationView__BoxImage":"candidates_IntegrationView__BoxImage__QF6SU","IntegrationView__Box":"candidates_IntegrationView__Box__IgjBX","IntegrationView__BoxImage__InfoIcon":"candidates_IntegrationView__BoxImage__InfoIcon__3Qsb3","IntegrationView__ViewMoreButton":"candidates_IntegrationView__ViewMoreButton__dBbl_","IntegrationView__ConnectButton":"candidates_IntegrationView__ConnectButton__UOBZI","IntegrationView__GoogleButton":"candidates_IntegrationView__GoogleButton__apeJi","IntegrationView__FlexFlow":"candidates_IntegrationView__FlexFlow__2omkG","IntegrationView__BoxWidth":"candidates_IntegrationView__BoxWidth__t8Cls","SkipFinishButton":"candidates_SkipFinishButton__PVTNK","AddUsers":"candidates_AddUsers__4Ut0Y","AddUsers__ButtonSection":"candidates_AddUsers__ButtonSection__rr5nL","AddUsers__QuickStepHeading":"candidates_AddUsers__QuickStepHeading__iCLu9","AddUsers__DeleteSection":"candidates_AddUsers__DeleteSection__BwQVt","Interview__DeleteSection":"candidates_Interview__DeleteSection__KRZro","AddUsers__DeleteCrossHeight":"candidates_AddUsers__DeleteCrossHeight__z8Mp6","AddUsers__Form__Input":"candidates_AddUsers__Form__Input__o05fR","AddUsers__FormHeadingSection":"candidates_AddUsers__FormHeadingSection__JdAl4","Interview__FormHeadingSection":"candidates_Interview__FormHeadingSection__NbF29","AddUsers__FormSection":"candidates_AddUsers__FormSection__bEhGw","NewJob__FormSection":"candidates_NewJob__FormSection__WreAL","AddUsers__ButtonsActionSection":"candidates_AddUsers__ButtonsActionSection__Lbhfi","AddUsers__ImportUsers":"candidates_AddUsers__ImportUsers__c_5ty","AddUsers__NameInput":"candidates_AddUsers__NameInput__YkifB","AddUsers__EmailInput":"candidates_AddUsers__EmailInput__ftWnI","AddUsers__RoleInput":"candidates_AddUsers__RoleInput__2T8sn","AddUsers__Subheading":"candidates_AddUsers__Subheading__fzmlP","AddUsers__visible":"candidates_AddUsers__visible__fPMEt","Tagrow":"candidates_Tagrow__fo_r4","Tagrow__Tags":"candidates_Tagrow__Tags__hi5Uu","SetupPopup__Tags":"candidates_SetupPopup__Tags__zQtKd","Tagrow__Cancel":"candidates_Tagrow__Cancel__kiGgj","Tagrow__Cross":"candidates_Tagrow__Cross__cN1Fs","SendInviteSection":"candidates_SendInviteSection__pU43w","error":"candidates_error___TKMI","ViewJobPage__Input":"candidates_ViewJobPage__Input__fj9Jm","Form__Input2":"candidates_Form__Input2__YoHrQ","ViewJobPage__PostDay":"candidates_ViewJobPage__PostDay__5dkE7","ViewJobPage__Title":"candidates_ViewJobPage__Title__ctHIS","ViewJobPage__DescriptionTitle":"candidates_ViewJobPage__DescriptionTitle__pHr7E","ViewJobPage__Location":"candidates_ViewJobPage__Location__XR98I","ViewJobPage__primarybtn":"candidates_ViewJobPage__primarybtn__hucAZ","ViewJobPage__secondarybtn":"candidates_ViewJobPage__secondarybtn__P_Cg6","ViewJobPage__secondarybtnborder":"candidates_ViewJobPage__secondarybtnborder__8wwys","ViewJobPage__BackSection":"candidates_ViewJobPage__BackSection__ZPmId","Modalpopup":"candidates_Modalpopup__2NTJU","Modalpopup__inner":"candidates_Modalpopup__inner__XeSO4","Modalpopup__Dialog":"candidates_Modalpopup__Dialog__4bbGj","transition":"candidates_transition__V9jzC","Modalpopup__CloseCenter":"candidates_Modalpopup__CloseCenter__ORWEw","Modalpopup__Content":"candidates_Modalpopup__Content__3zkkg","SetupPopup__PaddingPopup":"candidates_SetupPopup__PaddingPopup__Md27z","SetupPopup__ContentCustomisation":"candidates_SetupPopup__ContentCustomisation__QAOoe","SetupPopup__Contentwithoutpadding":"candidates_SetupPopup__Contentwithoutpadding__OrFXV","ViewJobPage__Content":"candidates_ViewJobPage__Content__orww5","Modalpopup__btn":"candidates_Modalpopup__btn__VWlZO","mar":"candidates_mar__YAxG2","Otpback":"candidates_Otpback__WDwRv","ViewJobPage":"candidates_ViewJobPage__ASBZY","ViewJobPage__Header":"candidates_ViewJobPage__Header__cTVsl","ViewJobPage__Application":"candidates_ViewJobPage__Application__KpqV_","ViewJobPage__RecordVideo":"candidates_ViewJobPage__RecordVideo__d4Rnz","ViewJobPage__RecordVideoSuccessText":"candidates_ViewJobPage__RecordVideoSuccessText__1UM2Z","ViewJobPage__subheading":"candidates_ViewJobPage__subheading__usfb0","ViewJobPage__confirmation":"candidates_ViewJobPage__confirmation__y8Wu_","ViewJobPage__Logo":"candidates_ViewJobPage__Logo__Gk9DO","ViewJobPage__BrandLogo":"candidates_ViewJobPage__BrandLogo__bzlHq","ViewJobPage__BrandLogo__Padding10":"candidates_ViewJobPage__BrandLogo__Padding10__eVgTt","ViewJobPage__Container":"candidates_ViewJobPage__Container__nC0he","ViewJobPage__JobContent":"candidates_ViewJobPage__JobContent__IYSC9","ViewJobPage__Sidebar":"candidates_ViewJobPage__Sidebar__U42Wg","ViewJobPage__Sidebar2":"candidates_ViewJobPage__Sidebar2__ev_Bx","ViewJobPage__Description":"candidates_ViewJobPage__Description__pZUpU","ViewJobPage__DescriptionWidth":"candidates_ViewJobPage__DescriptionWidth__Uz94l","ViewJobPage__Footer":"candidates_ViewJobPage__Footer__Ws3xM","ViewJobPage__FooterView":"candidates_ViewJobPage__FooterView__gRlYD","ViewJobPage__ShareJob":"candidates_ViewJobPage__ShareJob__wV9tp","ViewJobPage__SubmitSection":"candidates_ViewJobPage__SubmitSection__R5oPr","ViewJobPage__SocialMedia":"candidates_ViewJobPage__SocialMedia__YwH0d","ViewJobPage__SideContent":"candidates_ViewJobPage__SideContent__MOoTO","ViewJobPage__ApplySection":"candidates_ViewJobPage__ApplySection__EFyzW","FormBox__Autofill":"candidates_FormBox__Autofill__TSlga","applybuttons":"candidates_applybuttons___Ad4u","height90":"candidates_height90__u8HUE","Form__Cont":"candidates_Form__Cont__zUutC","Form__DropBox":"candidates_Form__DropBox__flx2Q","Form__DropBoxcontainer":"candidates_Form__DropBoxcontainer__C49TA","Form__DropBoxError":"candidates_Form__DropBoxError__lSM5f","Form__DropBoxicon":"candidates_Form__DropBoxicon__4lgLr","Form__DropBoxmessage":"candidates_Form__DropBoxmessage__wpfhj","noDpGrid":"candidates_noDpGrid__1Y0rz","Terms":"candidates_Terms__gBkUs","TermsCondition":"candidates_TermsCondition__WQ_4l","TermsCondition__alignterms":"candidates_TermsCondition__alignterms__OzZ9u","MenuContainer":"candidates_MenuContainer__2NEfe","MenuContainer__Menu":"candidates_MenuContainer__Menu__lqSd5","AgencyDetailPage":"candidates_AgencyDetailPage__hX3ag","Congrats__ModalContent":"candidates_Congrats__ModalContent__gV1nD","JobList__SearchBox":"candidates_JobList__SearchBox__4gPsx","NewJob__Container":"candidates_NewJob__Container__fm7my","NewJob__TopSection":"candidates_NewJob__TopSection__vvTuc","JobList__TopSection":"candidates_JobList__TopSection__z8I6q","Interview__TopSection":"candidates_Interview__TopSection__mjwFH","NewJob__HorizontalDivider":"candidates_NewJob__HorizontalDivider__MdicI","NewJob__Wrapper":"candidates_NewJob__Wrapper__Vuvnb","NewJob__ContainerPadding":"candidates_NewJob__ContainerPadding__U_EnD","NewJob__ContainerScroll":"candidates_NewJob__ContainerScroll__Q33WU","NewJob__ContainerHeight":"candidates_NewJob__ContainerHeight__qN0VA","NewJob__ImportAction":"candidates_NewJob__ImportAction__sPkMp","NewJob__Interview_buttons":"candidates_NewJob__Interview_buttons__8zfd6","Form__TableRowMB":"candidates_Form__TableRowMB__VnRyw","Form__TableRow3grid":"candidates_Form__TableRow3grid__dH3hw","Form__Remotegrid":"candidates_Form__Remotegrid__7p4fL","Form__TypeList":"candidates_Form__TypeList__SdGQs","Form__Type":"candidates_Form__Type__CqifD","Form__CheckLabel":"candidates_Form__CheckLabel__cTKWS","PrivateSwitchBase-root-1":"candidates_PrivateSwitchBase-root-1__FzRlO","Form__Caption":"candidates_Form__Caption__Zlom7","Form__Input_currency":"candidates_Form__Input_currency__SaOAo","Form__Input_MatchScore":"candidates_Form__Input_MatchScore__RGZVF","Form__Percentage_Symbol":"candidates_Form__Percentage_Symbol__ZHHxl","Form__NoGridTemplate":"candidates_Form__NoGridTemplate__vl_OK","active":"candidates_active__gkvy1","mt10":"candidates_mt10___QuFc","mt40":"candidates_mt40__bi_7G","mt30":"candidates_mt30__i7agv","mt32":"candidates_mt32__vmXmI","mb0":"candidates_mb0__wAAPB","Dpgrid":"candidates_Dpgrid__u0D5k","mb12":"candidates_mb12__WTuaU","width100":"candidates_width100__dvcFb","Tagrow__Prefix":"candidates_Tagrow__Prefix__FAJRV","PreviewJobPage":"candidates_PreviewJobPage__W1ivW","PreviewJob":"candidates_PreviewJob__yhoa3","DpFlx":"candidates_DpFlx__yHzh2","Subheading":"candidates_Subheading__qIU7b","Subheading__Description":"candidates_Subheading__Description__dHuFj","Candidate__Tooltip":"candidates_Candidate__Tooltip___OTIN","Candidate__Tooltip__Score":"candidates_Candidate__Tooltip__Score__Uwij6","Form__InputField":"candidates_Form__InputField__cfeCV","Candidate__Length":"candidates_Candidate__Length__fwdDU","Agency__PostDay":"candidates_Agency__PostDay__s9LuI","Agency__Title":"candidates_Agency__Title__FgOEZ","Agency__Location":"candidates_Agency__Location__H44BC","Agency__DescriptionTitle":"candidates_Agency__DescriptionTitle__fCjc2","Agency__Description":"candidates_Agency__Description__z1YVK","LightBlueColor":"candidates_LightBlueColor__TUK6P","AgencyDetailForm":"candidates_AgencyDetailForm__pbL7y","Client_Page":"candidates_Client_Page__lt_X9","Welcome":"candidates_Welcome__4ZIpP","Welcome__Inner":"candidates_Welcome__Inner__9g9CL","Welcome__Person":"candidates_Welcome__Person__SURQW","Welcome__LeftContent":"candidates_Welcome__LeftContent__kkXlw","Welcome__RightContent":"candidates_Welcome__RightContent__YVMnJ","Welcome__Content":"candidates_Welcome__Content__eEFFo","Welcome__CreateAccount":"candidates_Welcome__CreateAccount__Ha_KI","Welcome__title":"candidates_Welcome__title__T470r","Welcome__FormBox":"candidates_Welcome__FormBox__hrXL6","Form__psw":"candidates_Form__psw__OtmRK","Welcome__Container":"candidates_Welcome__Container__RcQwb","Success__Container":"candidates_Success__Container__J6hzk","Success":"candidates_Success__wy_8S","Success__Inner":"candidates_Success__Inner__7gamo","InterviewContainer":"candidates_InterviewContainer__pSrYz","Interview__Stages":"candidates_Interview__Stages___Gp8I","Interview__StageHeading":"candidates_Interview__StageHeading__kFdRs","pl10":"candidates_pl10__TnW9u","Interview__AddStageSection":"candidates_Interview__AddStageSection__PGGFl","Interview__Label":"candidates_Interview__Label____OS7","Interview__FormRowHeading":"candidates_Interview__FormRowHeading__sTsV8","dpflex":"candidates_dpflex__xtkyQ","Interview__IconsType":"candidates_Interview__IconsType__7hgBs","Interview__Icons":"candidates_Interview__Icons__vSKBP","Interview__Interview_buttons":"candidates_Interview__Interview_buttons__ocrAH","Interview__approvalButton":"candidates_Interview__approvalButton__avYNb","Interview__BestMatch":"candidates_Interview__BestMatch__1AL_y","Interview__BestMatchExclamation":"candidates_Interview__BestMatchExclamation__5JUQo","DragAndDrop":"candidates_DragAndDrop__fl_oL","DragAndDrop__CursorHandle":"candidates_DragAndDrop__CursorHandle__Y_U1W","Tagrow__Image":"candidates_Tagrow__Image__Kyvk8","rowbglight":"candidates_rowbglight__Bu1o2","rowbgheight":"candidates_rowbgheight__y68nI","Form__w90":"candidates_Form__w90__6M_XJ","Container":"candidates_Container__kDbxg","Screening__StageName":"candidates_Screening__StageName__tJMbt","Screening__InterviewType":"candidates_Screening__InterviewType__X2IJ5","Screening__InterviewType__Label":"candidates_Screening__InterviewType__Label__t6LC4","Show_Infoicon":"candidates_Show_Infoicon__1JJKc","Show_Infoicon_small":"candidates_Show_Infoicon_small__B5atC","Screening__Info":"candidates_Screening__Info__PuUvP","Screening__Info__IconWithText":"candidates_Screening__Info__IconWithText__NNCVU","InterviewType__Icon":"candidates_InterviewType__Icon__F6Fms","InterviewType__Text":"candidates_InterviewType__Text__sKqM1","LoginModal":"candidates_LoginModal__AY08H","Logincontent":"candidates_Logincontent__LcS0m","Logincontent__title":"candidates_Logincontent__title___jJMr","Modalbg":"candidates_Modalbg__QysnM","Modalnobg":"candidates_Modalnobg__FCRRC","Form__Container":"candidates_Form__Container__Lnqep","Form__success":"candidates_Form__success__v0ywE","Form__error":"candidates_Form__error__txg99","Form__CheckLabeltext":"candidates_Form__CheckLabeltext__Jc51L","Form__TextLeft":"candidates_Form__TextLeft__FJjMC","Backsection":"candidates_Backsection__o5t24","back":"candidates_back__JFxsA","mlr0":"candidates_mlr0__O1k8q","TwoButtons":"candidates_TwoButtons__dRJeV","OtpBacksection":"candidates_OtpBacksection__Gi5ma","SetupPopup":"candidates_SetupPopup__0nPAJ","JobList__EditModal":"candidates_JobList__EditModal__t1x__","SetupPopup__inner":"candidates_SetupPopup__inner__vzbT2","SetupPopup__Dialog":"candidates_SetupPopup__Dialog__yb9QO","SetupPopup__AddFile":"candidates_SetupPopup__AddFile__xsff7","SetupPopup__OptionalText":"candidates_SetupPopup__OptionalText__BQzQg","SetupPopup__RequestAccessBtn":"candidates_SetupPopup__RequestAccessBtn__3SGHh","SetupPopup__InternalSection":"candidates_SetupPopup__InternalSection__iJiRZ","SetupPopup__ContentInnerRow":"candidates_SetupPopup__ContentInnerRow__wgGlw","SetupPopup__ToChips":"candidates_SetupPopup__ToChips__0p4ub","SetupPopup__AttachmentContainer":"candidates_SetupPopup__AttachmentContainer__oAMuc","SetupPopup__ContentInnerCol":"candidates_SetupPopup__ContentInnerCol__JPtiy","SetupPopup__grid":"candidates_SetupPopup__grid__VncC_","SetupPopup__Footer":"candidates_SetupPopup__Footer__3FWAT","SetupPopup__FooterNew":"candidates_SetupPopup__FooterNew__8ZxOw","SetupPopup__Footer2":"candidates_SetupPopup__Footer2__zoX4S","SetupPopup__Footer3":"candidates_SetupPopup__Footer3__d_qLN","SetupPopup__Footerassess":"candidates_SetupPopup__Footerassess__Qb3Z9","SetupPopup__Footertechtest":"candidates_SetupPopup__Footertechtest__Kks4a","SetupPopup__AutommationFooter":"candidates_SetupPopup__AutommationFooter__JRM0w","SetupPopup__MannualFooter":"candidates_SetupPopup__MannualFooter__iaZ_v","SetupPopup__MannualInnerSection":"candidates_SetupPopup__MannualInnerSection__F8xYW","SetupPopup__Content":"candidates_SetupPopup__Content___FgMB","SetupPopup__Content__Radiobtn":"candidates_SetupPopup__Content__Radiobtn__ZyF0r","SetupPopup__AutomationToggle":"candidates_SetupPopup__AutomationToggle__N_CPk","SetupPopup__SetupVideoQa":"candidates_SetupPopup__SetupVideoQa__gJ_rx","SetupPopup__SetupVideoQa2":"candidates_SetupPopup__SetupVideoQa2__wLWM4","SetupPopup__SetupVideoQa3":"candidates_SetupPopup__SetupVideoQa3__0H5gw","SetupPopup__SetupVideoQa4":"candidates_SetupPopup__SetupVideoQa4__ud8w7","SetupPopup__InputQA":"candidates_SetupPopup__InputQA__GOvmV","SetupPopup__AddQuestion":"candidates_SetupPopup__AddQuestion__buEbx","SetupPopup__QuestionSection":"candidates_SetupPopup__QuestionSection__IEthW","SetupPopup__PushTop":"candidates_SetupPopup__PushTop__wak3C","SetupPopup__Contentpading":"candidates_SetupPopup__Contentpading__Ca4U1","SetupPopup__QuesionSectionpading":"candidates_SetupPopup__QuesionSectionpading__5VE_R","SetupPopup__Contentcenter":"candidates_SetupPopup__Contentcenter__vsJMV","SetupPopup__PopDetails":"candidates_SetupPopup__PopDetails__569tZ","SetupPopup__PopDetails__FS16":"candidates_SetupPopup__PopDetails__FS16__5kzzn","SetupPopup__Details":"candidates_SetupPopup__Details__yhrd8","SetupPopup__PrivacyPolicyDetails":"candidates_SetupPopup__PrivacyPolicyDetails__P_LKn","SetupPopup__Reason":"candidates_SetupPopup__Reason__e8IUT","SetupPopup__ContentBlock":"candidates_SetupPopup__ContentBlock__Rl4rh","SetupPopup__Purpose":"candidates_SetupPopup__Purpose__z0b62","SetupPopup__ContentGridsec":"candidates_SetupPopup__ContentGridsec__eueXX","mt25":"candidates_mt25__FefsF","mt20":"candidates_mt20__biAxQ","SetupPopup__ContentGridTech":"candidates_SetupPopup__ContentGridTech___TlQM","SetupPopup__Assesmentsection":"candidates_SetupPopup__Assesmentsection__VvnHY","SetupPopup__AssesmentsectionNew":"candidates_SetupPopup__AssesmentsectionNew__KFw3P","SetupPopup__MannualChips":"candidates_SetupPopup__MannualChips__wFniF","SetupPopup__ContentGridManuaCol":"candidates_SetupPopup__ContentGridManuaCol__VTWGa","SetupPopup__ContentGridManual":"candidates_SetupPopup__ContentGridManual__ejDSl","SetupPopup__ContentBlockPhone":"candidates_SetupPopup__ContentBlockPhone__BQvNF","SetupPopup__ContentAddInterview":"candidates_SetupPopup__ContentAddInterview__F2Cwo","SetupPopup__ContentGridPhone":"candidates_SetupPopup__ContentGridPhone__DAISz","SetupPopup__ContentGridStatus":"candidates_SetupPopup__ContentGridStatus__cbtF_","SetupPopup__GridActions":"candidates_SetupPopup__GridActions__Fo3Fp","SetupPopup__GridActionCoral":"candidates_SetupPopup__GridActionCoral__Tm4eU","SetupPopup__GridActionIndigo":"candidates_SetupPopup__GridActionIndigo__uzUlp","SetupPopup__ContentGrid":"candidates_SetupPopup__ContentGrid__wv9sA","SetupPopup__SubmitSectionSave":"candidates_SetupPopup__SubmitSectionSave__ckoDa","SetupPopup__SubmitSectionReset":"candidates_SetupPopup__SubmitSectionReset__ulOmM","SetupPopup__SubmitSectionAutomation":"candidates_SetupPopup__SubmitSectionAutomation__zZkyA","SetupPopup__Duration":"candidates_SetupPopup__Duration__fh4t_","SetupPopup__DeleteIcon":"candidates_SetupPopup__DeleteIcon__9zNzy","SetupPopup__ContentCustomisationManualInterview":"candidates_SetupPopup__ContentCustomisationManualInterview__2hjV1","mt0":"candidates_mt0__tVkYK","mtb25":"candidates_mtb25__5vJQ0","mb15":"candidates_mb15__hjHmq","mb30":"candidates_mb30__yytnF","mt9":"candidates_mt9__tbTO_","lineheight0":"candidates_lineheight0__teYC5","PopupHeightSection":"candidates_PopupHeightSection__FUI5A","AssessPopupHeightSection":"candidates_AssessPopupHeightSection__BW9a0","Statusopupheight":"candidates_Statusopupheight__Ek0Yh","buttonIn":"candidates_buttonIn__3650c","MessagePlaceholder":"candidates_MessagePlaceholder__HRXbN","m0":"candidates_m0__06FJX","mt18":"candidates_mt18__Oj90j","DPgrid":"candidates_DPgrid__XhQn_","addbtnposition":"candidates_addbtnposition__2YJeZ","mainformdiv":"candidates_mainformdiv__lRPZK","crossflex":"candidates_crossflex__M4Kyu","crossimgheight":"candidates_crossimgheight__bRUO_","crossimgheight48":"candidates_crossimgheight48__RZVow","SetupModalPopup":"candidates_SetupModalPopup__u_unW","SetupModalPopup__Dialog":"candidates_SetupModalPopup__Dialog__8T4RD","SetupPopupoverlay":"candidates_SetupPopupoverlay__4o_jX","NeedHelp":"candidates_NeedHelp___LKJ2","uploadNewTest":"candidates_uploadNewTest__eZHQe","SetupPopup__ol":"candidates_SetupPopup__ol__9OvAX","Threshold__Content":"candidates_Threshold__Content__mJMgZ","SetupPopup__ContentGridPhone__Content":"candidates_SetupPopup__ContentGridPhone__Content__cf5Qx","JobList__EditModalInner":"candidates_JobList__EditModalInner__d5ObW","Popupheight":"candidates_Popupheight__arj_B","CandidateBulkActionSection":"candidates_CandidateBulkActionSection__ywV6d","KanbanBulkActionSection":"candidates_KanbanBulkActionSection__AYcaI","KanbanBulkActionSection__Progress":"candidates_KanbanBulkActionSection__Progress__mikga","KanbanBulkActionSection__Message":"candidates_KanbanBulkActionSection__Message__7vwZx","Heading":"candidates_Heading__hmoZ9","Offer__Container":"candidates_Offer__Container__CK4Ju","Offer__DetailsSection":"candidates_Offer__DetailsSection__R_x28","Offer__NoMarginTop":"candidates_Offer__NoMarginTop__nxqSB","Offer__Mt20":"candidates_Offer__Mt20__mCEVz","Form__OfferSubmit":"candidates_Form__OfferSubmit___SeGk","Error":"candidates_Error__X8p6D","SignContract":"candidates_SignContract__cQrIt","SignContract__Container":"candidates_SignContract__Container__AsSCK","SignContract__Button":"candidates_SignContract__Button__iq1MH","SignContract__Header":"candidates_SignContract__Header___inqO","SignContract__Page":"candidates_SignContract__Page__lNlMR","SignContract__Logo":"candidates_SignContract__Logo__727W3","SignContract__Main":"candidates_SignContract__Main__AekSa","OfferDetail__Container":"candidates_OfferDetail__Container__GITi2","JobOfferDetails":"candidates_JobOfferDetails__nKRNb","JobOfferDetails__Section":"candidates_JobOfferDetails__Section__tdsba","JobOfferDetails__Row":"candidates_JobOfferDetails__Row__JYfaZ","JobOfferDetails__LeftCol":"candidates_JobOfferDetails__LeftCol__od7cI","JobOfferDetails__RightCol":"candidates_JobOfferDetails__RightCol__ocxFu","JobOfferDetails__Label":"candidates_JobOfferDetails__Label__u_pwr","JobOfferDetails__Data":"candidates_JobOfferDetails__Data__v_Xvf","JobOfferDetails__W100":"candidates_JobOfferDetails__W100__pxXj_","JobOfferDetails__MR20":"candidates_JobOfferDetails__MR20__aBBXP","Offer":"candidates_Offer__JTi8b","OfferDetail":"candidates_OfferDetail__UGF4m","ProgressLineSection":"candidates_ProgressLineSection__n6_bW","ProgressLineSection__Container":"candidates_ProgressLineSection__Container__ZEP_q","ProgressLineSection__AcionSection":"candidates_ProgressLineSection__AcionSection__Lw2jz","ProgressLineSection__ActionButtons":"candidates_ProgressLineSection__ActionButtons__ag2FX","ProgressLineSection__Heading":"candidates_ProgressLineSection__Heading__CJrfV","TopHeaderSection":"candidates_TopHeaderSection__j8Fx5","TopHeaderSection__SpaceBetween":"candidates_TopHeaderSection__SpaceBetween__9wb24","AgencyHeading":"candidates_AgencyHeading__zITh_","StatsSection":"candidates_StatsSection__siD45","StatsSection__List":"candidates_StatsSection__List__EoZch","StatsSection__NewList":"candidates_StatsSection__NewList__Bk0EK","StatsSection__ListStatus":"candidates_StatsSection__ListStatus__GiLXy","StatsSection__NewListStatus":"candidates_StatsSection__NewListStatus___a3Oa","StatsSection__Statslist":"candidates_StatsSection__Statslist__fJB5P","StatsSection__StatsAnchor":"candidates_StatsSection__StatsAnchor__A0gXA","StatsSection__StatsContent":"candidates_StatsSection__StatsContent__14rdX","StatsSection__StatsContentWidth":"candidates_StatsSection__StatsContentWidth__jD0v4","StatsSection__StatsNumber":"candidates_StatsSection__StatsNumber__xrNL0","StatsSection__StatsNumberWidth":"candidates_StatsSection__StatsNumberWidth__103q8","StatsSection__Health":"candidates_StatsSection__Health__seoDs","StatsSection__IndigoBg":"candidates_StatsSection__IndigoBg__o8_pl","StatsSection__CorelBg":"candidates_StatsSection__CorelBg__OrWNF","StatsSection__GreenBg":"candidates_StatsSection__GreenBg__jIwNq","StatsSection__RoseBg":"candidates_StatsSection__RoseBg__qIa8c","StatsSection__CorelDarkBg":"candidates_StatsSection__CorelDarkBg__BZqHo","StatsSection__StatBgOne":"candidates_StatsSection__StatBgOne__IRbgX","StatsSection__StatBgOne__NoBorder":"candidates_StatsSection__StatBgOne__NoBorder__GF8XM","StatsSection__StatBgTwo":"candidates_StatsSection__StatBgTwo__cqfwB","StatsSection__StatBgThree":"candidates_StatsSection__StatBgThree__Qs8qj","StatsSection__StatBgFour":"candidates_StatsSection__StatBgFour__wrfXm","NotificationSection":"candidates_NotificationSection__jUdXL","NotificationSection__InterviewListNoHover":"candidates_NotificationSection__InterviewListNoHover__kqXO7","NotificationSection__AlertActivity":"candidates_NotificationSection__AlertActivity___zDcE","NotificationSection__Alert":"candidates_NotificationSection__Alert__b6eIy","NotificationSection__List":"candidates_NotificationSection__List__rhSk4","NotificationSection__AlertContainer":"candidates_NotificationSection__AlertContainer__gJk_4","NotificationSection__CommunicationContainer":"candidates_NotificationSection__CommunicationContainer__TJX7c","NotificationSection__AlertActivityContainer":"candidates_NotificationSection__AlertActivityContainer___uGP3","NotificationSection__Schedulingmain":"candidates_NotificationSection__Schedulingmain__gBnCE","NotificationSection__More":"candidates_NotificationSection__More__njceU","NotificationSection__Alertslist":"candidates_NotificationSection__Alertslist__jzdDE","NotificationSection__Alertsmessage":"candidates_NotificationSection__Alertsmessage__hK2ag","NotificationSection__AlertsTilte":"candidates_NotificationSection__AlertsTilte__uAW8B","NotificationSection__AlertHeading":"candidates_NotificationSection__AlertHeading__35RFf","NotificationSection__CalendarHeading":"candidates_NotificationSection__CalendarHeading__BsVxh","NotificationSection__Dismiss":"candidates_NotificationSection__Dismiss__Yfq6u","NotificationSection__Communications":"candidates_NotificationSection__Communications__WYQ07","NotificationSection__ProfileCircle":"candidates_NotificationSection__ProfileCircle__iM_G_","NotificationSection__SchedulingTiming":"candidates_NotificationSection__SchedulingTiming__Wtpmg","NotificationSection__TimimgsSection":"candidates_NotificationSection__TimimgsSection__hoOkl","NotificationSection__WeekTiming":"candidates_NotificationSection__WeekTiming__4gpsg","NotificationSection__Scheduling":"candidates_NotificationSection__Scheduling__VFc_I","NotificationSection__Pagination":"candidates_NotificationSection__Pagination__DIcvK","NotificationSection__PaginationButton":"candidates_NotificationSection__PaginationButton__dKrTW","NotificationSection__InterviewListSvg":"candidates_NotificationSection__InterviewListSvg__eBO5s","NotificationSection__InterviewListStage":"candidates_NotificationSection__InterviewListStage__f7rt4","NotificationSection__InterviewList":"candidates_NotificationSection__InterviewList__bd_pS","NotificationSection__Interviewtitle":"candidates_NotificationSection__Interviewtitle__IFwEb","NotificationSection__InterviewerProfile":"candidates_NotificationSection__InterviewerProfile__oa1KI","NotificationSection__InterviewerDate":"candidates_NotificationSection__InterviewerDate___ClJW","NotificationSection__Greybox":"candidates_NotificationSection__Greybox__PVSPQ","NotificationSection__Tabs":"candidates_NotificationSection__Tabs__xb9ZU","React__tabs":"candidates_React__tabs__2XOM2","React__tabs__today":"candidates_React__tabs__today__cYVW7","React__tabs__head":"candidates_React__tabs__head__M49nD","React__tabs__tabpanel":"candidates_React__tabs__tabpanel__SSwLb","React__tabs__tablist":"candidates_React__tabs__tablist__vEOxP","React__tabs__tablist__tab":"candidates_React__tabs__tablist__tab__nd_No","React__tabs__interviewtype":"candidates_React__tabs__interviewtype__EJYHl","React__tabs__MyInterview":"candidates_React__tabs__MyInterview__gEvco","React__tabs__TeamInterview":"candidates_React__tabs__TeamInterview__cMTD2","NamePrefix":"candidates_NamePrefix__1MA8j","CandidatePrefix":"candidates_CandidatePrefix__nsKRw","TopSection":"candidates_TopSection__34_Y5","CalendarSelectedDate":"candidates_CalendarSelectedDate__8LEfa","TitleFlex":"candidates_TitleFlex__8hwMT","JobList__Accordian":"candidates_JobList__Accordian__N0hAI","JobList__AccordianContent":"candidates_JobList__AccordianContent__47eVv","JobList__SearchSection":"candidates_JobList__SearchSection__8CidV","CandidatesList__SearchSection":"candidates_CandidatesList__SearchSection__N4m4v","JobList__FilterMarginBottom":"candidates_JobList__FilterMarginBottom__ui0UG","JobList__SearchFilter":"candidates_JobList__SearchFilter__Pddtd","CandidatesList__SearchFilter":"candidates_CandidatesList__SearchFilter__FlzPE","JobList__AppliedSearchFilter":"candidates_JobList__AppliedSearchFilter__gN9HA","JobList__SearchFilterFullWidth":"candidates_JobList__SearchFilterFullWidth__Ox8Sm","JobList__AddJobSection":"candidates_JobList__AddJobSection__4AWeu","CandidatesList__AddJobSection":"candidates_CandidatesList__AddJobSection__GPLcc","JobList__Status":"candidates_JobList__Status__leFeG","JobList__EditModalContainer":"candidates_JobList__EditModalContainer__ZyVKB","JobList__EditModalMessage":"candidates_JobList__EditModalMessage__4Gjb8","JobList__EditModalButtonSection":"candidates_JobList__EditModalButtonSection__aVSrx","JobList__CheckLabel":"candidates_JobList__CheckLabel__sMhcs","JobList__Checkbox":"candidates_JobList__Checkbox__FLwX0","JobList__JobBoard":"candidates_JobList__JobBoard__Ew87U","JobList__Reasons":"candidates_JobList__Reasons__5ASWB","KanbanSearch__Dots":"candidates_KanbanSearch__Dots__19IoS","AgencyDetailForm__Label":"candidates_AgencyDetailForm__Label__ATXS8","AgencyDetailForm__Data":"candidates_AgencyDetailForm__Data__ei5Gp","AgencyDetailForm__Actionsection":"candidates_AgencyDetailForm__Actionsection__9gz4Y","AgencyDetailForm__FormInputSection":"candidates_AgencyDetailForm__FormInputSection__ZfQiT","ApprovalContract":"candidates_ApprovalContract__06FIU","ApprovalContractButtons":"candidates_ApprovalContractButtons__3NFtS","Form__TableRowBlock":"candidates_Form__TableRowBlock___UeEl","Form__TableCol2":"candidates_Form__TableCol2__U0e_y","Form__TableColNormal":"candidates_Form__TableColNormal__T9YA6","JobFilter":"candidates_JobFilter__gce1M","JobFilter__Inner":"candidates_JobFilter__Inner__Vot4P","JobFilter__Head":"candidates_JobFilter__Head__Rf0nj","JobFilter__SubmitSection":"candidates_JobFilter__SubmitSection__Qzo_l","JobFilter__EmailFilterBottom":"candidates_JobFilter__EmailFilterBottom__SceaV","CropImage":"candidates_CropImage__jNgOX","CropImage__Actions":"candidates_CropImage__Actions__TJNO0","CropImage__Inner":"candidates_CropImage__Inner__M_ipp","CropImage__Head":"candidates_CropImage__Head__1oQQD","CropImage__SubmitSection":"candidates_CropImage__SubmitSection__mFS5h","ModalClose":"candidates_ModalClose__bnDVh","Form__gap16":"candidates_Form__gap16__5XWG3","fontslabel":"candidates_fontslabel__emNWN","CandidatesList__AgencyFilterSection":"candidates_CandidatesList__AgencyFilterSection__SYlj2","CandidatesList__widthfilter":"candidates_CandidatesList__widthfilter__tRlqB","CandidatesList__SearchSectionCandidates":"candidates_CandidatesList__SearchSectionCandidates__7umYY","CandidatesList__AddCandidatesSection":"candidates_CandidatesList__AddCandidatesSection__Byh9d","DF":"candidates_DF__v3pVF","dpend":"candidates_dpend__Cbtyb","AddCandidatesForm":"candidates_AddCandidatesForm__jEcA_","CandidatesListpage":"candidates_CandidatesListpage__ceOlP"};

/***/ }),

/***/ 54858:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"profile_Form__BYbDU","Form__width":"profile_Form__width__bEVkj","Form__label":"profile_Form__label__GJrt0","Form__textleft":"profile_Form__textleft__7Bugm","Form__InputFullWidth":"profile_Form__InputFullWidth__3h8J4","Form__Input":"profile_Form__Input__lFXnN","Form__Input398":"profile_Form__Input398__hxT85","Form__InputSection":"profile_Form__InputSection__NBIdb","Form__ScoreCardInput":"profile_Form__ScoreCardInput__uE9kQ","Form__Textarea":"profile_Form__Textarea__rjEaV","fa":"profile_fa__RT8fN","fas":"profile_fas__fk_3Z","far":"profile_far__s4wq6","fal":"profile_fal__1yewK","fad":"profile_fad__jcN3S","fab":"profile_fab__lB9Ag","fa-lg":"profile_fa-lg__u3bZl","fa-xs":"profile_fa-xs__HYfsK","fa-sm":"profile_fa-sm__fJiMD","fa-1x":"profile_fa-1x__QWw49","fa-2x":"profile_fa-2x__aXZwX","fa-3x":"profile_fa-3x__PoLFs","fa-4x":"profile_fa-4x__5y6Ia","fa-5x":"profile_fa-5x__Km4Bk","fa-6x":"profile_fa-6x__nbg40","fa-7x":"profile_fa-7x__6kr02","fa-8x":"profile_fa-8x__j6UBY","fa-9x":"profile_fa-9x__BMNsE","fa-10x":"profile_fa-10x__Io9PE","fa-fw":"profile_fa-fw__Ia_Mr","fa-ul":"profile_fa-ul__PvBDS","fa-li":"profile_fa-li__4SbZW","fa-border":"profile_fa-border__GIVhP","fa-pull-left":"profile_fa-pull-left__5ZLBZ","fa-pull-right":"profile_fa-pull-right__JsHNT","fa-spin":"profile_fa-spin__eEqRw","fa-pulse":"profile_fa-pulse__wL68d","fa-rotate-90":"profile_fa-rotate-90__f_tuf","fa-rotate-180":"profile_fa-rotate-180__57fNe","fa-rotate-270":"profile_fa-rotate-270__w4r_C","fa-flip-horizontal":"profile_fa-flip-horizontal__blPHS","fa-flip-vertical":"profile_fa-flip-vertical__pPTxR","fa-flip-both":"profile_fa-flip-both__v0fDl","fa-stack":"profile_fa-stack__e_8Ke","fa-stack-1x":"profile_fa-stack-1x__tbzO_","fa-stack-2x":"profile_fa-stack-2x__nidb7","fa-inverse":"profile_fa-inverse__dFTDw","fa-500px":"profile_fa-500px___jaO_","fa-accessible-icon":"profile_fa-accessible-icon__2qDAC","fa-accusoft":"profile_fa-accusoft__5iz8Q","fa-acquisitions-incorporated":"profile_fa-acquisitions-incorporated__mOAyU","fa-ad":"profile_fa-ad__RYg8R","fa-address-book":"profile_fa-address-book__09PgD","fa-address-card":"profile_fa-address-card__hCcMy","fa-adjust":"profile_fa-adjust__lL7J5","fa-adn":"profile_fa-adn__jObw3","fa-adversal":"profile_fa-adversal__0ijTQ","fa-affiliatetheme":"profile_fa-affiliatetheme__in5CA","fa-air-freshener":"profile_fa-air-freshener__R3U14","fa-airbnb":"profile_fa-airbnb__dfSRD","fa-algolia":"profile_fa-algolia__GlCqg","fa-align-center":"profile_fa-align-center__TAzoR","fa-align-justify":"profile_fa-align-justify__upmof","fa-align-left":"profile_fa-align-left__Mr7j0","fa-align-right":"profile_fa-align-right__uQM6T","fa-alipay":"profile_fa-alipay__RhfYM","fa-allergies":"profile_fa-allergies__4ATjk","fa-amazon":"profile_fa-amazon__5tpve","fa-amazon-pay":"profile_fa-amazon-pay__1l5nY","fa-ambulance":"profile_fa-ambulance__F7mwN","fa-american-sign-language-interpreting":"profile_fa-american-sign-language-interpreting__nbU_1","fa-amilia":"profile_fa-amilia__7f6e_","fa-anchor":"profile_fa-anchor__56SVX","fa-android":"profile_fa-android__XQuyI","fa-angellist":"profile_fa-angellist__RjuRm","fa-angle-double-down":"profile_fa-angle-double-down__DLt2T","fa-angle-double-left":"profile_fa-angle-double-left__73q7_","fa-angle-double-right":"profile_fa-angle-double-right__dbBBx","fa-angle-double-up":"profile_fa-angle-double-up__TzNfG","fa-angle-down":"profile_fa-angle-down__SYsKz","fa-angle-left":"profile_fa-angle-left__e6a_I","fa-angle-right":"profile_fa-angle-right__6o_6Q","fa-angle-up":"profile_fa-angle-up__mtDwx","fa-angry":"profile_fa-angry__iAhbi","fa-angrycreative":"profile_fa-angrycreative__7J6qi","fa-angular":"profile_fa-angular__ItOny","fa-ankh":"profile_fa-ankh__Pw64W","fa-app-store":"profile_fa-app-store__azIco","fa-app-store-ios":"profile_fa-app-store-ios__NGBoE","fa-apper":"profile_fa-apper__tRyId","fa-apple":"profile_fa-apple__5QwOI","fa-apple-alt":"profile_fa-apple-alt__cIdWs","fa-apple-pay":"profile_fa-apple-pay__NEYGx","fa-archive":"profile_fa-archive__adkN5","fa-archway":"profile_fa-archway__O6znz","fa-arrow-alt-circle-down":"profile_fa-arrow-alt-circle-down__eF7QS","fa-arrow-alt-circle-left":"profile_fa-arrow-alt-circle-left__67rle","fa-arrow-alt-circle-right":"profile_fa-arrow-alt-circle-right__yeAtK","fa-arrow-alt-circle-up":"profile_fa-arrow-alt-circle-up__9_DpL","fa-arrow-circle-down":"profile_fa-arrow-circle-down__dW0dJ","fa-arrow-circle-left":"profile_fa-arrow-circle-left__QW3Bp","fa-arrow-circle-right":"profile_fa-arrow-circle-right__mZDYK","fa-arrow-circle-up":"profile_fa-arrow-circle-up__YTsGQ","fa-arrow-down":"profile_fa-arrow-down__d_SIw","fa-arrow-left":"profile_fa-arrow-left__kEHfW","fa-arrow-right":"profile_fa-arrow-right__L6_r9","fa-arrow-up":"profile_fa-arrow-up__DfllW","fa-arrows-alt":"profile_fa-arrows-alt__ddwUs","fa-arrows-alt-h":"profile_fa-arrows-alt-h__f0Gyi","fa-arrows-alt-v":"profile_fa-arrows-alt-v___VgcI","fa-artstation":"profile_fa-artstation__ALWBu","fa-assistive-listening-systems":"profile_fa-assistive-listening-systems__4soP8","fa-asterisk":"profile_fa-asterisk__6u_LZ","fa-asymmetrik":"profile_fa-asymmetrik__sFPpO","fa-at":"profile_fa-at__fwfM6","fa-atlas":"profile_fa-atlas__7N6jl","fa-atlassian":"profile_fa-atlassian__XI8XZ","fa-atom":"profile_fa-atom__pVEti","fa-audible":"profile_fa-audible__dS17z","fa-audio-description":"profile_fa-audio-description__ZbV47","fa-autoprefixer":"profile_fa-autoprefixer__M6KJO","fa-avianex":"profile_fa-avianex__T2LpR","fa-aviato":"profile_fa-aviato__rvS_3","fa-award":"profile_fa-award__XqZ_g","fa-aws":"profile_fa-aws__SMifG","fa-baby":"profile_fa-baby__d3aff","fa-baby-carriage":"profile_fa-baby-carriage__Luytq","fa-backspace":"profile_fa-backspace__ILJHG","fa-backward":"profile_fa-backward__y4IG9","fa-bacon":"profile_fa-bacon__OEfOR","fa-bacteria":"profile_fa-bacteria__i9MQP","fa-bacterium":"profile_fa-bacterium__L2Unb","fa-bahai":"profile_fa-bahai__s9pBh","fa-balance-scale":"profile_fa-balance-scale__OcyXQ","fa-balance-scale-left":"profile_fa-balance-scale-left__aPJEq","fa-balance-scale-right":"profile_fa-balance-scale-right__WlZGC","fa-ban":"profile_fa-ban__cYwXj","fa-band-aid":"profile_fa-band-aid__Wj9w0","fa-bandcamp":"profile_fa-bandcamp__nWsy6","fa-barcode":"profile_fa-barcode__dW8_U","fa-bars":"profile_fa-bars__D11MQ","fa-baseball-ball":"profile_fa-baseball-ball__USp0U","fa-basketball-ball":"profile_fa-basketball-ball__7dgU1","fa-bath":"profile_fa-bath__hxceL","fa-battery-empty":"profile_fa-battery-empty__ybKZf","fa-battery-full":"profile_fa-battery-full__wAutw","fa-battery-half":"profile_fa-battery-half__yG2_U","fa-battery-quarter":"profile_fa-battery-quarter__rUszx","fa-battery-three-quarters":"profile_fa-battery-three-quarters__uKKI8","fa-battle-net":"profile_fa-battle-net__51Wo6","fa-bed":"profile_fa-bed__haB0i","fa-beer":"profile_fa-beer__ijU6D","fa-behance":"profile_fa-behance__SvM40","fa-behance-square":"profile_fa-behance-square__nmD9j","fa-bell":"profile_fa-bell__4MRjb","fa-bell-slash":"profile_fa-bell-slash__dr2dD","fa-bezier-curve":"profile_fa-bezier-curve__LsLCS","fa-bible":"profile_fa-bible__W9FDZ","fa-bicycle":"profile_fa-bicycle___Yd_f","fa-biking":"profile_fa-biking__Bod4N","fa-bimobject":"profile_fa-bimobject__zWdMH","fa-binoculars":"profile_fa-binoculars__jeCGR","fa-biohazard":"profile_fa-biohazard__aTYwj","fa-birthday-cake":"profile_fa-birthday-cake__zme8u","fa-bitbucket":"profile_fa-bitbucket__sAncL","fa-bitcoin":"profile_fa-bitcoin__vyWBP","fa-bity":"profile_fa-bity__kpY_B","fa-black-tie":"profile_fa-black-tie__rb8qU","fa-blackberry":"profile_fa-blackberry__vc63r","fa-blender":"profile_fa-blender__OHWEV","fa-blender-phone":"profile_fa-blender-phone__uztMN","fa-blind":"profile_fa-blind__oxOv8","fa-blog":"profile_fa-blog__CmdKs","fa-blogger":"profile_fa-blogger__3VUzv","fa-blogger-b":"profile_fa-blogger-b__dcPoF","fa-bluetooth":"profile_fa-bluetooth__bHPwD","fa-bluetooth-b":"profile_fa-bluetooth-b__Yikxk","fa-bold":"profile_fa-bold__OiK16","fa-bolt":"profile_fa-bolt__2kKtG","fa-bomb":"profile_fa-bomb__vhYKI","fa-bone":"profile_fa-bone__KbOlT","fa-bong":"profile_fa-bong___cY9u","fa-book":"profile_fa-book__qU0rj","fa-book-dead":"profile_fa-book-dead__gTU3n","fa-book-medical":"profile_fa-book-medical__VJzLW","fa-book-open":"profile_fa-book-open__SK38X","fa-book-reader":"profile_fa-book-reader__uXG3h","fa-bookmark":"profile_fa-bookmark__Nb7Z8","fa-bootstrap":"profile_fa-bootstrap__AnmUk","fa-border-all":"profile_fa-border-all__pmELW","fa-border-none":"profile_fa-border-none__alAIN","fa-border-style":"profile_fa-border-style__dKBPV","fa-bowling-ball":"profile_fa-bowling-ball__iGsh9","fa-box":"profile_fa-box__17Y5M","fa-box-open":"profile_fa-box-open__VPIgT","fa-box-tissue":"profile_fa-box-tissue__h7D0S","fa-boxes":"profile_fa-boxes__hoVUI","fa-braille":"profile_fa-braille__OYLvv","fa-brain":"profile_fa-brain__1n3Pn","fa-bread-slice":"profile_fa-bread-slice__Ik01F","fa-briefcase":"profile_fa-briefcase__MsCoA","fa-briefcase-medical":"profile_fa-briefcase-medical__rCpdY","fa-broadcast-tower":"profile_fa-broadcast-tower__PD2Ej","fa-broom":"profile_fa-broom__18dOa","fa-brush":"profile_fa-brush__JfDiL","fa-btc":"profile_fa-btc__Gqnnu","fa-buffer":"profile_fa-buffer___cz2h","fa-bug":"profile_fa-bug__i26Jv","fa-building":"profile_fa-building__S9y79","fa-bullhorn":"profile_fa-bullhorn__Zw91o","fa-bullseye":"profile_fa-bullseye__L7nIU","fa-burn":"profile_fa-burn__KFHtE","fa-buromobelexperte":"profile_fa-buromobelexperte__jyt63","fa-bus":"profile_fa-bus__wrDq5","fa-bus-alt":"profile_fa-bus-alt__qpNqU","fa-business-time":"profile_fa-business-time__pxb8G","fa-buy-n-large":"profile_fa-buy-n-large__MCBUp","fa-buysellads":"profile_fa-buysellads__7Eib4","fa-calculator":"profile_fa-calculator__Xz6hZ","fa-calendar":"profile_fa-calendar__h8_SD","fa-calendar-alt":"profile_fa-calendar-alt__4nAWb","fa-calendar-check":"profile_fa-calendar-check__WUp3n","fa-calendar-day":"profile_fa-calendar-day__IO44E","fa-calendar-minus":"profile_fa-calendar-minus__mcviw","fa-calendar-plus":"profile_fa-calendar-plus__CMW0Z","fa-calendar-times":"profile_fa-calendar-times__PU2nz","fa-calendar-week":"profile_fa-calendar-week__8OmRB","fa-camera":"profile_fa-camera__K1fgr","fa-camera-retro":"profile_fa-camera-retro__zJsCW","fa-campground":"profile_fa-campground__imAJi","fa-canadian-maple-leaf":"profile_fa-canadian-maple-leaf__zYSb9","fa-candy-cane":"profile_fa-candy-cane__Rc8U0","fa-cannabis":"profile_fa-cannabis__s7vOn","fa-capsules":"profile_fa-capsules__UP7Ou","fa-car":"profile_fa-car__kVMZR","fa-car-alt":"profile_fa-car-alt__cALo_","fa-car-battery":"profile_fa-car-battery__VH2ba","fa-car-crash":"profile_fa-car-crash__Lkuuc","fa-car-side":"profile_fa-car-side__7l475","fa-caravan":"profile_fa-caravan__LOpNW","fa-caret-down":"profile_fa-caret-down__3oJ_D","fa-caret-left":"profile_fa-caret-left__B3e54","fa-caret-right":"profile_fa-caret-right__jxjEb","fa-caret-square-down":"profile_fa-caret-square-down__2RTqr","fa-caret-square-left":"profile_fa-caret-square-left__9H69S","fa-caret-square-right":"profile_fa-caret-square-right__n5SXy","fa-caret-square-up":"profile_fa-caret-square-up__FMsWt","fa-caret-up":"profile_fa-caret-up__WIbpb","fa-carrot":"profile_fa-carrot__pwTtR","fa-cart-arrow-down":"profile_fa-cart-arrow-down__2u6Bk","fa-cart-plus":"profile_fa-cart-plus__nlFwT","fa-cash-register":"profile_fa-cash-register__Phrs6","fa-cat":"profile_fa-cat__5lQwt","fa-cc-amazon-pay":"profile_fa-cc-amazon-pay__7PcLj","fa-cc-amex":"profile_fa-cc-amex__zsMdZ","fa-cc-apple-pay":"profile_fa-cc-apple-pay__76ODt","fa-cc-diners-club":"profile_fa-cc-diners-club__aznni","fa-cc-discover":"profile_fa-cc-discover__fGxrN","fa-cc-jcb":"profile_fa-cc-jcb__qII2L","fa-cc-mastercard":"profile_fa-cc-mastercard__VDVrX","fa-cc-paypal":"profile_fa-cc-paypal__3gHpZ","fa-cc-stripe":"profile_fa-cc-stripe__15_ru","fa-cc-visa":"profile_fa-cc-visa__MT7Rc","fa-centercode":"profile_fa-centercode__vpt8d","fa-centos":"profile_fa-centos__DUAuS","fa-certificate":"profile_fa-certificate__pz5rF","fa-chair":"profile_fa-chair__K4kmt","fa-chalkboard":"profile_fa-chalkboard__epzpG","fa-chalkboard-teacher":"profile_fa-chalkboard-teacher__gTZb9","fa-charging-station":"profile_fa-charging-station__aJXJk","fa-chart-area":"profile_fa-chart-area__CJ1BU","fa-chart-bar":"profile_fa-chart-bar__5GH16","fa-chart-line":"profile_fa-chart-line__HTadq","fa-chart-pie":"profile_fa-chart-pie__hq7ch","fa-check":"profile_fa-check__1MDKY","fa-check-circle":"profile_fa-check-circle__wamCC","fa-check-double":"profile_fa-check-double__wZaJr","fa-check-square":"profile_fa-check-square__zGcC6","fa-cheese":"profile_fa-cheese__Y2qmP","fa-chess":"profile_fa-chess__fDznJ","fa-chess-bishop":"profile_fa-chess-bishop__KSGJD","fa-chess-board":"profile_fa-chess-board__5Yum6","fa-chess-king":"profile_fa-chess-king__djFH_","fa-chess-knight":"profile_fa-chess-knight__DTcrf","fa-chess-pawn":"profile_fa-chess-pawn__0ll_L","fa-chess-queen":"profile_fa-chess-queen__vl1si","fa-chess-rook":"profile_fa-chess-rook__6GGk_","fa-chevron-circle-down":"profile_fa-chevron-circle-down__KTgOY","fa-chevron-circle-left":"profile_fa-chevron-circle-left__Kl7O7","fa-chevron-circle-right":"profile_fa-chevron-circle-right__5hrJu","fa-chevron-circle-up":"profile_fa-chevron-circle-up__pWjrX","fa-chevron-down":"profile_fa-chevron-down__roor8","fa-chevron-left":"profile_fa-chevron-left__LU715","fa-chevron-right":"profile_fa-chevron-right___zb3h","fa-chevron-up":"profile_fa-chevron-up__oqi1o","fa-child":"profile_fa-child__P2yHj","fa-chrome":"profile_fa-chrome__s1Usq","fa-chromecast":"profile_fa-chromecast__DKq2f","fa-church":"profile_fa-church__9HoUW","fa-circle":"profile_fa-circle__wmNn4","fa-circle-notch":"profile_fa-circle-notch__eja0i","fa-city":"profile_fa-city__D898S","fa-clinic-medical":"profile_fa-clinic-medical__eWXHl","fa-clipboard":"profile_fa-clipboard__VuVQz","fa-clipboard-check":"profile_fa-clipboard-check__niQRd","fa-clipboard-list":"profile_fa-clipboard-list__YyZaD","fa-clock":"profile_fa-clock__EumeO","fa-clone":"profile_fa-clone__BoewH","fa-closed-captioning":"profile_fa-closed-captioning__4gw8B","fa-cloud":"profile_fa-cloud__09mYL","fa-cloud-download-alt":"profile_fa-cloud-download-alt__ZZMti","fa-cloud-meatball":"profile_fa-cloud-meatball__NsSfG","fa-cloud-moon":"profile_fa-cloud-moon__iZd29","fa-cloud-moon-rain":"profile_fa-cloud-moon-rain__CCjIg","fa-cloud-rain":"profile_fa-cloud-rain__9py1U","fa-cloud-showers-heavy":"profile_fa-cloud-showers-heavy__0YhpV","fa-cloud-sun":"profile_fa-cloud-sun__E5BPG","fa-cloud-sun-rain":"profile_fa-cloud-sun-rain__cfV4u","fa-cloud-upload-alt":"profile_fa-cloud-upload-alt__HSO90","fa-cloudflare":"profile_fa-cloudflare__5CZts","fa-cloudscale":"profile_fa-cloudscale__xXfSl","fa-cloudsmith":"profile_fa-cloudsmith__R_L7M","fa-cloudversify":"profile_fa-cloudversify___OrxD","fa-cocktail":"profile_fa-cocktail__FS5FN","fa-code":"profile_fa-code__VrL13","fa-code-branch":"profile_fa-code-branch__dbNmm","fa-codepen":"profile_fa-codepen__PqbRh","fa-codiepie":"profile_fa-codiepie__K_5Fw","fa-coffee":"profile_fa-coffee__mF7_T","fa-cog":"profile_fa-cog__Jrtu_","fa-cogs":"profile_fa-cogs__Yu4Q6","fa-coins":"profile_fa-coins__6rffi","fa-columns":"profile_fa-columns__lfWef","fa-comment":"profile_fa-comment__6iMd_","fa-comment-alt":"profile_fa-comment-alt__i2Wu2","fa-comment-dollar":"profile_fa-comment-dollar__RckWH","fa-comment-dots":"profile_fa-comment-dots__WJhWG","fa-comment-medical":"profile_fa-comment-medical__NDLJv","fa-comment-slash":"profile_fa-comment-slash__mpjTo","fa-comments":"profile_fa-comments__dIz6H","fa-comments-dollar":"profile_fa-comments-dollar__fHQAt","fa-compact-disc":"profile_fa-compact-disc__jkRLW","fa-compass":"profile_fa-compass__tG8ET","fa-compress":"profile_fa-compress__5NeO0","fa-compress-alt":"profile_fa-compress-alt__NpPCU","fa-compress-arrows-alt":"profile_fa-compress-arrows-alt__RQLPP","fa-concierge-bell":"profile_fa-concierge-bell__uW_zX","fa-confluence":"profile_fa-confluence__fgnis","fa-connectdevelop":"profile_fa-connectdevelop__qnuDk","fa-contao":"profile_fa-contao__YJQDw","fa-cookie":"profile_fa-cookie__0Z3EO","fa-cookie-bite":"profile_fa-cookie-bite__BnMRr","fa-copy":"profile_fa-copy__Csvlo","fa-copyright":"profile_fa-copyright__zrq7_","fa-cotton-bureau":"profile_fa-cotton-bureau__Amn2R","fa-couch":"profile_fa-couch__Nq8pt","fa-cpanel":"profile_fa-cpanel__JJeds","fa-creative-commons":"profile_fa-creative-commons__lPud_","fa-creative-commons-by":"profile_fa-creative-commons-by___GzHk","fa-creative-commons-nc":"profile_fa-creative-commons-nc__ZOWEI","fa-creative-commons-nc-eu":"profile_fa-creative-commons-nc-eu__sOCUF","fa-creative-commons-nc-jp":"profile_fa-creative-commons-nc-jp__rPTan","fa-creative-commons-nd":"profile_fa-creative-commons-nd__loJph","fa-creative-commons-pd":"profile_fa-creative-commons-pd__CkKLY","fa-creative-commons-pd-alt":"profile_fa-creative-commons-pd-alt___iQ4e","fa-creative-commons-remix":"profile_fa-creative-commons-remix__x_EMf","fa-creative-commons-sa":"profile_fa-creative-commons-sa__PTMjd","fa-creative-commons-sampling":"profile_fa-creative-commons-sampling___3Tri","fa-creative-commons-sampling-plus":"profile_fa-creative-commons-sampling-plus__x1yVw","fa-creative-commons-share":"profile_fa-creative-commons-share__DsL1L","fa-creative-commons-zero":"profile_fa-creative-commons-zero__8ZBoQ","fa-credit-card":"profile_fa-credit-card__Rg_yA","fa-critical-role":"profile_fa-critical-role__YevqY","fa-crop":"profile_fa-crop__5zrou","fa-crop-alt":"profile_fa-crop-alt__7aUjK","fa-cross":"profile_fa-cross__swFVm","fa-crosshairs":"profile_fa-crosshairs__eAuTt","fa-crow":"profile_fa-crow__O1Wl5","fa-crown":"profile_fa-crown__0npYv","fa-crutch":"profile_fa-crutch__RR77p","fa-css3":"profile_fa-css3__vt1mX","fa-css3-alt":"profile_fa-css3-alt__3v0yO","fa-cube":"profile_fa-cube__UvgaD","fa-cubes":"profile_fa-cubes__n6JrC","fa-cut":"profile_fa-cut__SI2pC","fa-cuttlefish":"profile_fa-cuttlefish__epN2v","fa-d-and-d":"profile_fa-d-and-d__QP_ss","fa-d-and-d-beyond":"profile_fa-d-and-d-beyond__YvpWX","fa-dailymotion":"profile_fa-dailymotion__1ruIQ","fa-dashcube":"profile_fa-dashcube__SlgHo","fa-database":"profile_fa-database__cEQHp","fa-deaf":"profile_fa-deaf__elWlu","fa-deezer":"profile_fa-deezer__E1REf","fa-delicious":"profile_fa-delicious__FBp3z","fa-democrat":"profile_fa-democrat__uTXgt","fa-deploydog":"profile_fa-deploydog__4C7Jf","fa-deskpro":"profile_fa-deskpro___eB_0","fa-desktop":"profile_fa-desktop__iWnsg","fa-dev":"profile_fa-dev___79Wg","fa-deviantart":"profile_fa-deviantart__oRVZW","fa-dharmachakra":"profile_fa-dharmachakra__hprf1","fa-dhl":"profile_fa-dhl__rspCA","fa-diagnoses":"profile_fa-diagnoses__hig5Y","fa-diaspora":"profile_fa-diaspora__nieW4","fa-dice":"profile_fa-dice__muBhG","fa-dice-d20":"profile_fa-dice-d20__k13_I","fa-dice-d6":"profile_fa-dice-d6__4Mr1O","fa-dice-five":"profile_fa-dice-five__Y6osC","fa-dice-four":"profile_fa-dice-four__Jd7Gp","fa-dice-one":"profile_fa-dice-one__J8d5m","fa-dice-six":"profile_fa-dice-six__bTJTw","fa-dice-three":"profile_fa-dice-three__w2RRN","fa-dice-two":"profile_fa-dice-two__k7QfF","fa-digg":"profile_fa-digg__4xnyu","fa-digital-ocean":"profile_fa-digital-ocean__PcsaK","fa-digital-tachograph":"profile_fa-digital-tachograph__6_RpB","fa-directions":"profile_fa-directions__65sb9","fa-discord":"profile_fa-discord__paBkc","fa-discourse":"profile_fa-discourse__6Usmp","fa-disease":"profile_fa-disease__8QolN","fa-divide":"profile_fa-divide__gX1BY","fa-dizzy":"profile_fa-dizzy__wWJ0Y","fa-dna":"profile_fa-dna__Au0BD","fa-dochub":"profile_fa-dochub__4ttj9","fa-docker":"profile_fa-docker__vnW1I","fa-dog":"profile_fa-dog__M7XJl","fa-dollar-sign":"profile_fa-dollar-sign__FqD7N","fa-dolly":"profile_fa-dolly__Y7UM0","fa-dolly-flatbed":"profile_fa-dolly-flatbed__85uxN","fa-donate":"profile_fa-donate__LVpgr","fa-door-closed":"profile_fa-door-closed___DGLs","fa-door-open":"profile_fa-door-open__I66c3","fa-dot-circle":"profile_fa-dot-circle__e0km5","fa-dove":"profile_fa-dove__iC_k5","fa-download":"profile_fa-download__y5tFB","fa-draft2digital":"profile_fa-draft2digital__8Gbcj","fa-drafting-compass":"profile_fa-drafting-compass__fKw32","fa-dragon":"profile_fa-dragon__Dg1ST","fa-draw-polygon":"profile_fa-draw-polygon__DvwYs","fa-dribbble":"profile_fa-dribbble__Zo3wj","fa-dribbble-square":"profile_fa-dribbble-square__3NQ_X","fa-dropbox":"profile_fa-dropbox__RQqBp","fa-drum":"profile_fa-drum__ztn37","fa-drum-steelpan":"profile_fa-drum-steelpan__fpbdO","fa-drumstick-bite":"profile_fa-drumstick-bite__fwEEk","fa-drupal":"profile_fa-drupal__LbiR5","fa-dumbbell":"profile_fa-dumbbell__QPK8X","fa-dumpster":"profile_fa-dumpster__xPC3q","fa-dumpster-fire":"profile_fa-dumpster-fire__N8chR","fa-dungeon":"profile_fa-dungeon__toJxu","fa-dyalog":"profile_fa-dyalog__1yq8I","fa-earlybirds":"profile_fa-earlybirds__iQxwz","fa-ebay":"profile_fa-ebay__2ZWKn","fa-edge":"profile_fa-edge__Hu3aN","fa-edge-legacy":"profile_fa-edge-legacy__mgFO2","fa-edit":"profile_fa-edit__bfZEm","fa-egg":"profile_fa-egg__FZiUf","fa-eject":"profile_fa-eject__vCYtu","fa-elementor":"profile_fa-elementor__i6j19","fa-ellipsis-h":"profile_fa-ellipsis-h__TeDKH","fa-ellipsis-v":"profile_fa-ellipsis-v__cyd0Q","fa-ello":"profile_fa-ello__P2rlv","fa-ember":"profile_fa-ember__T__fq","fa-empire":"profile_fa-empire__r50V3","fa-envelope":"profile_fa-envelope__2l2PB","fa-envelope-open":"profile_fa-envelope-open__hf8Vv","fa-envelope-open-text":"profile_fa-envelope-open-text__ce0WQ","fa-envelope-square":"profile_fa-envelope-square__vbop4","fa-envira":"profile_fa-envira__zTZol","fa-equals":"profile_fa-equals__7cqgy","fa-eraser":"profile_fa-eraser__IK5xN","fa-erlang":"profile_fa-erlang__Oligv","fa-ethereum":"profile_fa-ethereum__Kzkz8","fa-ethernet":"profile_fa-ethernet____TDK","fa-etsy":"profile_fa-etsy__TVJrr","fa-euro-sign":"profile_fa-euro-sign__HK_HQ","fa-evernote":"profile_fa-evernote__gDyde","fa-exchange-alt":"profile_fa-exchange-alt__OLJm9","fa-exclamation":"profile_fa-exclamation__bNqbE","fa-exclamation-circle":"profile_fa-exclamation-circle__tFkqe","fa-exclamation-triangle":"profile_fa-exclamation-triangle__5Nh4S","fa-expand":"profile_fa-expand__0tpvZ","fa-expand-alt":"profile_fa-expand-alt__DplQg","fa-expand-arrows-alt":"profile_fa-expand-arrows-alt__BUxUH","fa-expeditedssl":"profile_fa-expeditedssl__jxvWi","fa-external-link-alt":"profile_fa-external-link-alt__g30s7","fa-external-link-square-alt":"profile_fa-external-link-square-alt___AyBO","fa-eye":"profile_fa-eye__TnH2V","fa-eye-dropper":"profile_fa-eye-dropper__moIaU","fa-eye-slash":"profile_fa-eye-slash__MA65i","fa-facebook":"profile_fa-facebook__QZZOz","fa-facebook-f":"profile_fa-facebook-f__ZHScT","fa-facebook-messenger":"profile_fa-facebook-messenger__4PfMT","fa-facebook-square":"profile_fa-facebook-square__dzODy","fa-fan":"profile_fa-fan__L8rv0","fa-fantasy-flight-games":"profile_fa-fantasy-flight-games__4Oa_L","fa-fast-backward":"profile_fa-fast-backward__3CW_f","fa-fast-forward":"profile_fa-fast-forward__deJe4","fa-faucet":"profile_fa-faucet__QdSSk","fa-fax":"profile_fa-fax__j0myT","fa-feather":"profile_fa-feather__6Aplk","fa-feather-alt":"profile_fa-feather-alt__cVMJh","fa-fedex":"profile_fa-fedex__NTsvr","fa-fedora":"profile_fa-fedora__IP36m","fa-female":"profile_fa-female__E2YQT","fa-fighter-jet":"profile_fa-fighter-jet__iph_p","fa-figma":"profile_fa-figma__vLaI7","fa-file":"profile_fa-file__nekol","fa-file-alt":"profile_fa-file-alt__J0BbR","fa-file-archive":"profile_fa-file-archive__SSTqR","fa-file-audio":"profile_fa-file-audio__P0k9f","fa-file-code":"profile_fa-file-code__6QGNV","fa-file-contract":"profile_fa-file-contract__SSQ_L","fa-file-csv":"profile_fa-file-csv__HcW7a","fa-file-download":"profile_fa-file-download__8KYAd","fa-file-excel":"profile_fa-file-excel__6p0Ak","fa-file-export":"profile_fa-file-export__pmp_i","fa-file-image":"profile_fa-file-image__speo6","fa-file-import":"profile_fa-file-import__6ra2h","fa-file-invoice":"profile_fa-file-invoice__26A1d","fa-file-invoice-dollar":"profile_fa-file-invoice-dollar__B68RH","fa-file-medical":"profile_fa-file-medical__FMRBt","fa-file-medical-alt":"profile_fa-file-medical-alt__OrCdv","fa-file-pdf":"profile_fa-file-pdf__wdKg6","fa-file-powerpoint":"profile_fa-file-powerpoint__q361Q","fa-file-prescription":"profile_fa-file-prescription__uFiC6","fa-file-signature":"profile_fa-file-signature__uzSl3","fa-file-upload":"profile_fa-file-upload__sRXuv","fa-file-video":"profile_fa-file-video__V9Dzm","fa-file-word":"profile_fa-file-word__c2enI","fa-fill":"profile_fa-fill__ij29n","fa-fill-drip":"profile_fa-fill-drip__G9E5_","fa-film":"profile_fa-film__wtZr7","fa-filter":"profile_fa-filter__7K3Hg","fa-fingerprint":"profile_fa-fingerprint__UQ1t0","fa-fire":"profile_fa-fire__Fld7g","fa-fire-alt":"profile_fa-fire-alt__6Zax5","fa-fire-extinguisher":"profile_fa-fire-extinguisher__4m5wq","fa-firefox":"profile_fa-firefox__nWBac","fa-firefox-browser":"profile_fa-firefox-browser__sChKM","fa-first-aid":"profile_fa-first-aid__x5Trs","fa-first-order":"profile_fa-first-order__kJjFS","fa-first-order-alt":"profile_fa-first-order-alt__OimUv","fa-firstdraft":"profile_fa-firstdraft__7PSpB","fa-fish":"profile_fa-fish__9kL5l","fa-fist-raised":"profile_fa-fist-raised__IrfI8","fa-flag":"profile_fa-flag__u4jh1","fa-flag-checkered":"profile_fa-flag-checkered__u6zKq","fa-flag-usa":"profile_fa-flag-usa__8ZVC5","fa-flask":"profile_fa-flask__ACcj1","fa-flickr":"profile_fa-flickr__WRM6j","fa-flipboard":"profile_fa-flipboard__7SUGE","fa-flushed":"profile_fa-flushed__XNqtE","fa-fly":"profile_fa-fly__7MsPi","fa-folder":"profile_fa-folder__x9yPj","fa-folder-minus":"profile_fa-folder-minus__MrgZS","fa-folder-open":"profile_fa-folder-open__zsvXz","fa-folder-plus":"profile_fa-folder-plus__yqp__","fa-font":"profile_fa-font__ydmX0","fa-font-awesome":"profile_fa-font-awesome__ZzWY3","fa-font-awesome-alt":"profile_fa-font-awesome-alt__fcwxU","fa-font-awesome-flag":"profile_fa-font-awesome-flag__UDBbz","fa-font-awesome-logo-full":"profile_fa-font-awesome-logo-full__HdkGq","fa-fonticons":"profile_fa-fonticons__dHZFB","fa-fonticons-fi":"profile_fa-fonticons-fi__I877_","fa-football-ball":"profile_fa-football-ball__SYfRa","fa-fort-awesome":"profile_fa-fort-awesome__nN4yp","fa-fort-awesome-alt":"profile_fa-fort-awesome-alt__suKoK","fa-forumbee":"profile_fa-forumbee__PqKqk","fa-forward":"profile_fa-forward__kOqwX","fa-foursquare":"profile_fa-foursquare__pjLhG","fa-free-code-camp":"profile_fa-free-code-camp__PIBxA","fa-freebsd":"profile_fa-freebsd__cVxm8","fa-frog":"profile_fa-frog__RZRjE","fa-frown":"profile_fa-frown__Ol_av","fa-frown-open":"profile_fa-frown-open__tA5Wh","fa-fulcrum":"profile_fa-fulcrum__nkDt0","fa-funnel-dollar":"profile_fa-funnel-dollar__j5umG","fa-futbol":"profile_fa-futbol__4uSUV","fa-galactic-republic":"profile_fa-galactic-republic__GstUs","fa-galactic-senate":"profile_fa-galactic-senate__HJoJT","fa-gamepad":"profile_fa-gamepad__PcwAx","fa-gas-pump":"profile_fa-gas-pump__Prlyl","fa-gavel":"profile_fa-gavel__v19Lk","fa-gem":"profile_fa-gem__2VeYb","fa-genderless":"profile_fa-genderless__mngu9","fa-get-pocket":"profile_fa-get-pocket__xsvB5","fa-gg":"profile_fa-gg__HTFKs","fa-gg-circle":"profile_fa-gg-circle__C4Yu6","fa-ghost":"profile_fa-ghost__iiMfR","fa-gift":"profile_fa-gift__lTdmh","fa-gifts":"profile_fa-gifts__WyXmI","fa-git":"profile_fa-git__NcjnR","fa-git-alt":"profile_fa-git-alt___3_CD","fa-git-square":"profile_fa-git-square__Gn6OQ","fa-github":"profile_fa-github__mYGX6","fa-github-alt":"profile_fa-github-alt__DnhSJ","fa-github-square":"profile_fa-github-square__Ksy98","fa-gitkraken":"profile_fa-gitkraken__qZflS","fa-gitlab":"profile_fa-gitlab__rsxhz","fa-gitter":"profile_fa-gitter__qR2rb","fa-glass-cheers":"profile_fa-glass-cheers__hi23r","fa-glass-martini":"profile_fa-glass-martini__VmcfG","fa-glass-martini-alt":"profile_fa-glass-martini-alt__HekS_","fa-glass-whiskey":"profile_fa-glass-whiskey__aJZlV","fa-glasses":"profile_fa-glasses__kO4oj","fa-glide":"profile_fa-glide__41QaG","fa-glide-g":"profile_fa-glide-g__zC3kL","fa-globe":"profile_fa-globe__lulpf","fa-globe-africa":"profile_fa-globe-africa__Tz3Sv","fa-globe-americas":"profile_fa-globe-americas__qAJNd","fa-globe-asia":"profile_fa-globe-asia__zwYxL","fa-globe-europe":"profile_fa-globe-europe__X4q9W","fa-gofore":"profile_fa-gofore__gcw6I","fa-golf-ball":"profile_fa-golf-ball__ySqRr","fa-goodreads":"profile_fa-goodreads__s3taF","fa-goodreads-g":"profile_fa-goodreads-g__DJnnK","fa-google":"profile_fa-google__QOXXS","fa-google-drive":"profile_fa-google-drive__1sx4_","fa-google-pay":"profile_fa-google-pay__5I_dW","fa-google-play":"profile_fa-google-play__eoh4i","fa-google-plus":"profile_fa-google-plus__zyeCw","fa-google-plus-g":"profile_fa-google-plus-g__LYrbg","fa-google-plus-square":"profile_fa-google-plus-square__dnCjJ","fa-google-wallet":"profile_fa-google-wallet__tVh2x","fa-gopuram":"profile_fa-gopuram__KV4hj","fa-graduation-cap":"profile_fa-graduation-cap__TLsgc","fa-gratipay":"profile_fa-gratipay__Druj9","fa-grav":"profile_fa-grav__fln2r","fa-greater-than":"profile_fa-greater-than__g3AI8","fa-greater-than-equal":"profile_fa-greater-than-equal__vIxFm","fa-grimace":"profile_fa-grimace__owzYE","fa-grin":"profile_fa-grin__Fr1E5","fa-grin-alt":"profile_fa-grin-alt__515l5","fa-grin-beam":"profile_fa-grin-beam__GIV0f","fa-grin-beam-sweat":"profile_fa-grin-beam-sweat__S9tnc","fa-grin-hearts":"profile_fa-grin-hearts__cSDHO","fa-grin-squint":"profile_fa-grin-squint__xEEq0","fa-grin-squint-tears":"profile_fa-grin-squint-tears__WzNf2","fa-grin-stars":"profile_fa-grin-stars__EhvEb","fa-grin-tears":"profile_fa-grin-tears__HEJXH","fa-grin-tongue":"profile_fa-grin-tongue__d8hV2","fa-grin-tongue-squint":"profile_fa-grin-tongue-squint__uflLE","fa-grin-tongue-wink":"profile_fa-grin-tongue-wink__8c9hE","fa-grin-wink":"profile_fa-grin-wink__YfQhP","fa-grip-horizontal":"profile_fa-grip-horizontal__NvX1N","fa-grip-lines":"profile_fa-grip-lines__5M4CO","fa-grip-lines-vertical":"profile_fa-grip-lines-vertical__pSyDs","fa-grip-vertical":"profile_fa-grip-vertical__xixMe","fa-gripfire":"profile_fa-gripfire__w9sfk","fa-grunt":"profile_fa-grunt__FIAm1","fa-guilded":"profile_fa-guilded__0PSvC","fa-guitar":"profile_fa-guitar__ExQrB","fa-gulp":"profile_fa-gulp__ARZSM","fa-h-square":"profile_fa-h-square__YynK9","fa-hacker-news":"profile_fa-hacker-news__extWN","fa-hacker-news-square":"profile_fa-hacker-news-square__v0eQb","fa-hackerrank":"profile_fa-hackerrank__DEsKg","fa-hamburger":"profile_fa-hamburger__UKWLM","fa-hammer":"profile_fa-hammer__AwDsd","fa-hamsa":"profile_fa-hamsa__lTwf2","fa-hand-holding":"profile_fa-hand-holding__qomT8","fa-hand-holding-heart":"profile_fa-hand-holding-heart__hsY1P","fa-hand-holding-medical":"profile_fa-hand-holding-medical__nuDCm","fa-hand-holding-usd":"profile_fa-hand-holding-usd___AFIU","fa-hand-holding-water":"profile_fa-hand-holding-water__w7pzL","fa-hand-lizard":"profile_fa-hand-lizard__QTSAs","fa-hand-middle-finger":"profile_fa-hand-middle-finger__flVdp","fa-hand-paper":"profile_fa-hand-paper___5ViI","fa-hand-peace":"profile_fa-hand-peace__sKsmZ","fa-hand-point-down":"profile_fa-hand-point-down__htomA","fa-hand-point-left":"profile_fa-hand-point-left__vaBWc","fa-hand-point-right":"profile_fa-hand-point-right__idPQt","fa-hand-point-up":"profile_fa-hand-point-up__xstSI","fa-hand-pointer":"profile_fa-hand-pointer__MHfNt","fa-hand-rock":"profile_fa-hand-rock__04f0F","fa-hand-scissors":"profile_fa-hand-scissors__nH46h","fa-hand-sparkles":"profile_fa-hand-sparkles__AMpNw","fa-hand-spock":"profile_fa-hand-spock__u55x3","fa-hands":"profile_fa-hands__NI3Py","fa-hands-helping":"profile_fa-hands-helping__TduYI","fa-hands-wash":"profile_fa-hands-wash__sNDbX","fa-handshake":"profile_fa-handshake__0S4zP","fa-handshake-alt-slash":"profile_fa-handshake-alt-slash__xs02f","fa-handshake-slash":"profile_fa-handshake-slash__3Axha","fa-hanukiah":"profile_fa-hanukiah__tJaIm","fa-hard-hat":"profile_fa-hard-hat__6aM7S","fa-hashtag":"profile_fa-hashtag__x7OLC","fa-hat-cowboy":"profile_fa-hat-cowboy__B9FCm","fa-hat-cowboy-side":"profile_fa-hat-cowboy-side__gqJBE","fa-hat-wizard":"profile_fa-hat-wizard__RjrVj","fa-hdd":"profile_fa-hdd__Lt6kI","fa-head-side-cough":"profile_fa-head-side-cough__HFUyv","fa-head-side-cough-slash":"profile_fa-head-side-cough-slash__EjmaS","fa-head-side-mask":"profile_fa-head-side-mask__KkpKp","fa-head-side-virus":"profile_fa-head-side-virus__Pa9ng","fa-heading":"profile_fa-heading__5kOCm","fa-headphones":"profile_fa-headphones__DlB2x","fa-headphones-alt":"profile_fa-headphones-alt__ZhMR4","fa-headset":"profile_fa-headset__c5FSp","fa-heart":"profile_fa-heart__Wk8GW","fa-heart-broken":"profile_fa-heart-broken__MaAax","fa-heartbeat":"profile_fa-heartbeat__i3zKn","fa-helicopter":"profile_fa-helicopter__7Mx8t","fa-highlighter":"profile_fa-highlighter__n9pFq","fa-hiking":"profile_fa-hiking__4l8B_","fa-hippo":"profile_fa-hippo__MI5oj","fa-hips":"profile_fa-hips__A_wSN","fa-hire-a-helper":"profile_fa-hire-a-helper__VcNGO","fa-history":"profile_fa-history__Ehfbx","fa-hive":"profile_fa-hive__qQI_d","fa-hockey-puck":"profile_fa-hockey-puck__Vttdo","fa-holly-berry":"profile_fa-holly-berry__Ca3dF","fa-home":"profile_fa-home__7IWBA","fa-hooli":"profile_fa-hooli__yqzZr","fa-hornbill":"profile_fa-hornbill__NK5M3","fa-horse":"profile_fa-horse__JD5vp","fa-horse-head":"profile_fa-horse-head__lIgRu","fa-hospital":"profile_fa-hospital__MyTHk","fa-hospital-alt":"profile_fa-hospital-alt__F8ulf","fa-hospital-symbol":"profile_fa-hospital-symbol__fpC0L","fa-hospital-user":"profile_fa-hospital-user__drATx","fa-hot-tub":"profile_fa-hot-tub__3NmoS","fa-hotdog":"profile_fa-hotdog__xzU6x","fa-hotel":"profile_fa-hotel__Xmcqs","fa-hotjar":"profile_fa-hotjar__4WAg_","fa-hourglass":"profile_fa-hourglass__3ykt8","fa-hourglass-end":"profile_fa-hourglass-end__HMAbu","fa-hourglass-half":"profile_fa-hourglass-half__AuFky","fa-hourglass-start":"profile_fa-hourglass-start__8lET3","fa-house-damage":"profile_fa-house-damage__mtVtC","fa-house-user":"profile_fa-house-user__Uot9w","fa-houzz":"profile_fa-houzz__t04pl","fa-hryvnia":"profile_fa-hryvnia__7k10d","fa-html5":"profile_fa-html5__pxQJg","fa-hubspot":"profile_fa-hubspot__3dW49","fa-i-cursor":"profile_fa-i-cursor__qDIFG","fa-ice-cream":"profile_fa-ice-cream__Nfx1i","fa-icicles":"profile_fa-icicles__oWum5","fa-icons":"profile_fa-icons__Is52a","fa-id-badge":"profile_fa-id-badge__DgtGD","fa-id-card":"profile_fa-id-card__ovZPV","fa-id-card-alt":"profile_fa-id-card-alt__np_RY","fa-ideal":"profile_fa-ideal__KYBQY","fa-igloo":"profile_fa-igloo__RfUWy","fa-image":"profile_fa-image__EAIy9","fa-images":"profile_fa-images__Vi__O","fa-imdb":"profile_fa-imdb__yAe3Z","fa-inbox":"profile_fa-inbox__vVMkU","fa-indent":"profile_fa-indent__gth0_","fa-industry":"profile_fa-industry__IexQt","fa-infinity":"profile_fa-infinity__ssvXo","fa-info":"profile_fa-info__sxMl2","fa-info-circle":"profile_fa-info-circle__VERId","fa-innosoft":"profile_fa-innosoft__BhmuV","fa-instagram":"profile_fa-instagram__HjIwk","fa-instagram-square":"profile_fa-instagram-square__nJ1IU","fa-instalod":"profile_fa-instalod__SPrwZ","fa-intercom":"profile_fa-intercom__ra6nK","fa-internet-explorer":"profile_fa-internet-explorer__Qdazz","fa-invision":"profile_fa-invision__FrVsF","fa-ioxhost":"profile_fa-ioxhost__FkpHH","fa-italic":"profile_fa-italic__wcqHX","fa-itch-io":"profile_fa-itch-io__J0Mzy","fa-itunes":"profile_fa-itunes__wvtJO","fa-itunes-note":"profile_fa-itunes-note__nlz_X","fa-java":"profile_fa-java__QOf99","fa-jedi":"profile_fa-jedi__liu9l","fa-jedi-order":"profile_fa-jedi-order__195fZ","fa-jenkins":"profile_fa-jenkins__zRJl8","fa-jira":"profile_fa-jira__hIstN","fa-joget":"profile_fa-joget__iKFXA","fa-joint":"profile_fa-joint__R47hx","fa-joomla":"profile_fa-joomla__5oXNp","fa-journal-whills":"profile_fa-journal-whills__gx6qk","fa-js":"profile_fa-js__VoC7X","fa-js-square":"profile_fa-js-square__8PNFO","fa-jsfiddle":"profile_fa-jsfiddle__6U5Kj","fa-kaaba":"profile_fa-kaaba__TST4L","fa-kaggle":"profile_fa-kaggle__cHRio","fa-key":"profile_fa-key__v63uF","fa-keybase":"profile_fa-keybase__PKRdI","fa-keyboard":"profile_fa-keyboard__ffJRa","fa-keycdn":"profile_fa-keycdn__WLeHn","fa-khanda":"profile_fa-khanda__2vSlI","fa-kickstarter":"profile_fa-kickstarter__zKE6C","fa-kickstarter-k":"profile_fa-kickstarter-k__VFFFV","fa-kiss":"profile_fa-kiss__3dQ8Y","fa-kiss-beam":"profile_fa-kiss-beam__pXJTt","fa-kiss-wink-heart":"profile_fa-kiss-wink-heart__Rov_O","fa-kiwi-bird":"profile_fa-kiwi-bird__4I6Zd","fa-korvue":"profile_fa-korvue__d2UxU","fa-landmark":"profile_fa-landmark__W8L8h","fa-language":"profile_fa-language__naL67","fa-laptop":"profile_fa-laptop__8iwFz","fa-laptop-code":"profile_fa-laptop-code__1fIQ9","fa-laptop-house":"profile_fa-laptop-house__hXMtF","fa-laptop-medical":"profile_fa-laptop-medical__Ljkqy","fa-laravel":"profile_fa-laravel__9RD0Q","fa-lastfm":"profile_fa-lastfm__mG1mG","fa-lastfm-square":"profile_fa-lastfm-square__UgLcY","fa-laugh":"profile_fa-laugh__LEu0n","fa-laugh-beam":"profile_fa-laugh-beam__vjTxE","fa-laugh-squint":"profile_fa-laugh-squint__Yt_4i","fa-laugh-wink":"profile_fa-laugh-wink__hZ1_A","fa-layer-group":"profile_fa-layer-group__3TAef","fa-leaf":"profile_fa-leaf__0uNvU","fa-leanpub":"profile_fa-leanpub__nBhgm","fa-lemon":"profile_fa-lemon__yqWhb","fa-less":"profile_fa-less__gLhXJ","fa-less-than":"profile_fa-less-than___Lhrz","fa-less-than-equal":"profile_fa-less-than-equal__op2hH","fa-level-down-alt":"profile_fa-level-down-alt__6d3n5","fa-level-up-alt":"profile_fa-level-up-alt__RCI7R","fa-life-ring":"profile_fa-life-ring__8RvxW","fa-lightbulb":"profile_fa-lightbulb__bjXAC","fa-line":"profile_fa-line__tQGF4","fa-link":"profile_fa-link__lgJ8v","fa-linkedin":"profile_fa-linkedin__3sGUZ","fa-linkedin-in":"profile_fa-linkedin-in__pC8MA","fa-linode":"profile_fa-linode__xyxM_","fa-linux":"profile_fa-linux__z79K5","fa-lira-sign":"profile_fa-lira-sign__9mg0V","fa-list":"profile_fa-list__Et4Xe","fa-list-alt":"profile_fa-list-alt__OQs9A","fa-list-ol":"profile_fa-list-ol__zfLvK","fa-list-ul":"profile_fa-list-ul___hM1a","fa-location-arrow":"profile_fa-location-arrow__R9wMP","fa-lock":"profile_fa-lock__07i7n","fa-lock-open":"profile_fa-lock-open__ko3nJ","fa-long-arrow-alt-down":"profile_fa-long-arrow-alt-down__IQFEx","fa-long-arrow-alt-left":"profile_fa-long-arrow-alt-left___GO4z","fa-long-arrow-alt-right":"profile_fa-long-arrow-alt-right__x7BqL","fa-long-arrow-alt-up":"profile_fa-long-arrow-alt-up__JOen7","fa-low-vision":"profile_fa-low-vision__ktCI4","fa-luggage-cart":"profile_fa-luggage-cart__FMri4","fa-lungs":"profile_fa-lungs__hLyww","fa-lungs-virus":"profile_fa-lungs-virus__eT48J","fa-lyft":"profile_fa-lyft__nz8GU","fa-magento":"profile_fa-magento__wXYqp","fa-magic":"profile_fa-magic__fr_Mf","fa-magnet":"profile_fa-magnet__OJuWx","fa-mail-bulk":"profile_fa-mail-bulk__aIyKa","fa-mailchimp":"profile_fa-mailchimp__CPYbQ","fa-male":"profile_fa-male__Qhwua","fa-mandalorian":"profile_fa-mandalorian__iQvTx","fa-map":"profile_fa-map__BGGUM","fa-map-marked":"profile_fa-map-marked__yODcH","fa-map-marked-alt":"profile_fa-map-marked-alt__Bmoxm","fa-map-marker":"profile_fa-map-marker__bEVzq","fa-map-marker-alt":"profile_fa-map-marker-alt__NxIm7","fa-map-pin":"profile_fa-map-pin__cQqWz","fa-map-signs":"profile_fa-map-signs__ZYmNr","fa-markdown":"profile_fa-markdown__GvX83","fa-marker":"profile_fa-marker__K_rwP","fa-mars":"profile_fa-mars__yQdV3","fa-mars-double":"profile_fa-mars-double__CfXiU","fa-mars-stroke":"profile_fa-mars-stroke__O8JOn","fa-mars-stroke-h":"profile_fa-mars-stroke-h__xqNym","fa-mars-stroke-v":"profile_fa-mars-stroke-v__l_T09","fa-mask":"profile_fa-mask__K1u9e","fa-mastodon":"profile_fa-mastodon__nPuWR","fa-maxcdn":"profile_fa-maxcdn__3BKri","fa-mdb":"profile_fa-mdb__WbQOV","fa-medal":"profile_fa-medal__ER_uA","fa-medapps":"profile_fa-medapps__eK4_u","fa-medium":"profile_fa-medium__Ekg0f","fa-medium-m":"profile_fa-medium-m__5_nn5","fa-medkit":"profile_fa-medkit__0WIeD","fa-medrt":"profile_fa-medrt__xWRUr","fa-meetup":"profile_fa-meetup__vSP7l","fa-megaport":"profile_fa-megaport__a4ecw","fa-meh":"profile_fa-meh__DP46v","fa-meh-blank":"profile_fa-meh-blank__VGlmd","fa-meh-rolling-eyes":"profile_fa-meh-rolling-eyes__rvnto","fa-memory":"profile_fa-memory__imSmW","fa-mendeley":"profile_fa-mendeley__ffqPE","fa-menorah":"profile_fa-menorah__CsonG","fa-mercury":"profile_fa-mercury__epvab","fa-meteor":"profile_fa-meteor__cQzQX","fa-microblog":"profile_fa-microblog__2nEgB","fa-microchip":"profile_fa-microchip__nUMdB","fa-microphone":"profile_fa-microphone__Z16uN","fa-microphone-alt":"profile_fa-microphone-alt__vqa7u","fa-microphone-alt-slash":"profile_fa-microphone-alt-slash__hmuin","fa-microphone-slash":"profile_fa-microphone-slash__E93Er","fa-microscope":"profile_fa-microscope__sEnUM","fa-microsoft":"profile_fa-microsoft__ywYrb","fa-minus":"profile_fa-minus__JuBlA","fa-minus-circle":"profile_fa-minus-circle__UuiRV","fa-minus-square":"profile_fa-minus-square__Xyfkg","fa-mitten":"profile_fa-mitten__DHqLE","fa-mix":"profile_fa-mix__QsCw7","fa-mixcloud":"profile_fa-mixcloud__uVfu0","fa-mixer":"profile_fa-mixer__YzaNs","fa-mizuni":"profile_fa-mizuni__pqSaP","fa-mobile":"profile_fa-mobile__Kao1Y","fa-mobile-alt":"profile_fa-mobile-alt__lTN7w","fa-modx":"profile_fa-modx__DV0SA","fa-monero":"profile_fa-monero__53djv","fa-money-bill":"profile_fa-money-bill__r8Zpq","fa-money-bill-alt":"profile_fa-money-bill-alt__piuye","fa-money-bill-wave":"profile_fa-money-bill-wave__0O1hG","fa-money-bill-wave-alt":"profile_fa-money-bill-wave-alt__xwgei","fa-money-check":"profile_fa-money-check__QmXO0","fa-money-check-alt":"profile_fa-money-check-alt__dJvth","fa-monument":"profile_fa-monument__jvp9i","fa-moon":"profile_fa-moon__4UdJf","fa-mortar-pestle":"profile_fa-mortar-pestle__9_n6O","fa-mosque":"profile_fa-mosque__puhum","fa-motorcycle":"profile_fa-motorcycle__MhHSI","fa-mountain":"profile_fa-mountain__Dtd3g","fa-mouse":"profile_fa-mouse__KG5gr","fa-mouse-pointer":"profile_fa-mouse-pointer__Al_4x","fa-mug-hot":"profile_fa-mug-hot__GSseO","fa-music":"profile_fa-music__0FOUi","fa-napster":"profile_fa-napster__yRI0K","fa-neos":"profile_fa-neos__u_IUe","fa-network-wired":"profile_fa-network-wired__6ThGP","fa-neuter":"profile_fa-neuter__2gIW5","fa-newspaper":"profile_fa-newspaper__r_KkH","fa-nimblr":"profile_fa-nimblr__j5310","fa-node":"profile_fa-node__UHTNK","fa-node-js":"profile_fa-node-js__BqgfO","fa-not-equal":"profile_fa-not-equal__uwgd9","fa-notes-medical":"profile_fa-notes-medical__FX9Qi","fa-npm":"profile_fa-npm__VBYTs","fa-ns8":"profile_fa-ns8__nV5Rm","fa-nutritionix":"profile_fa-nutritionix__RqfMj","fa-object-group":"profile_fa-object-group__Xl8_M","fa-object-ungroup":"profile_fa-object-ungroup__xqump","fa-octopus-deploy":"profile_fa-octopus-deploy__fkhtp","fa-odnoklassniki":"profile_fa-odnoklassniki__9f6mJ","fa-odnoklassniki-square":"profile_fa-odnoklassniki-square__A5i_F","fa-oil-can":"profile_fa-oil-can__FF9iX","fa-old-republic":"profile_fa-old-republic__SZw74","fa-om":"profile_fa-om__3NBe1","fa-opencart":"profile_fa-opencart__BM_zt","fa-openid":"profile_fa-openid__fkLxl","fa-opera":"profile_fa-opera__rZbVv","fa-optin-monster":"profile_fa-optin-monster__wyqCe","fa-orcid":"profile_fa-orcid__ZlKyB","fa-osi":"profile_fa-osi__St4yl","fa-otter":"profile_fa-otter__qNR5I","fa-outdent":"profile_fa-outdent__NqcF0","fa-page4":"profile_fa-page4__fIdFi","fa-pagelines":"profile_fa-pagelines__Uf_ok","fa-pager":"profile_fa-pager__7We5p","fa-paint-brush":"profile_fa-paint-brush__9cetx","fa-paint-roller":"profile_fa-paint-roller__ICJM1","fa-palette":"profile_fa-palette__4_mRg","fa-palfed":"profile_fa-palfed__EFcQe","fa-pallet":"profile_fa-pallet__Hdpms","fa-paper-plane":"profile_fa-paper-plane__emImi","fa-paperclip":"profile_fa-paperclip__10fVc","fa-parachute-box":"profile_fa-parachute-box__RXJdk","fa-paragraph":"profile_fa-paragraph__HlGoY","fa-parking":"profile_fa-parking__p3QMT","fa-passport":"profile_fa-passport__HDi5q","fa-pastafarianism":"profile_fa-pastafarianism__pKIQ_","fa-paste":"profile_fa-paste__avKIv","fa-patreon":"profile_fa-patreon__4CqL6","fa-pause":"profile_fa-pause__wCoLZ","fa-pause-circle":"profile_fa-pause-circle__IiGtm","fa-paw":"profile_fa-paw__NQJQg","fa-paypal":"profile_fa-paypal__xYSdx","fa-peace":"profile_fa-peace__ZPuIK","fa-pen":"profile_fa-pen__o6g9_","fa-pen-alt":"profile_fa-pen-alt__UDIXR","fa-pen-fancy":"profile_fa-pen-fancy___Zpg3","fa-pen-nib":"profile_fa-pen-nib__YAh3P","fa-pen-square":"profile_fa-pen-square__a2xQ7","fa-pencil-alt":"profile_fa-pencil-alt__3VCey","fa-pencil-ruler":"profile_fa-pencil-ruler__JyDsb","fa-penny-arcade":"profile_fa-penny-arcade__j10YB","fa-people-arrows":"profile_fa-people-arrows__8Qp0w","fa-people-carry":"profile_fa-people-carry__dzlMh","fa-pepper-hot":"profile_fa-pepper-hot__F9Hwh","fa-perbyte":"profile_fa-perbyte__vVrbU","fa-percent":"profile_fa-percent__MgW4K","fa-percentage":"profile_fa-percentage__HxEqk","fa-periscope":"profile_fa-periscope__ZADD1","fa-person-booth":"profile_fa-person-booth__D_KTq","fa-phabricator":"profile_fa-phabricator__8L_du","fa-phoenix-framework":"profile_fa-phoenix-framework__ROVPS","fa-phoenix-squadron":"profile_fa-phoenix-squadron__uhMxE","fa-phone":"profile_fa-phone__Vkmfo","fa-phone-alt":"profile_fa-phone-alt__TQUc7","fa-phone-slash":"profile_fa-phone-slash__H9NFL","fa-phone-square":"profile_fa-phone-square__Vmf3s","fa-phone-square-alt":"profile_fa-phone-square-alt__3KUcZ","fa-phone-volume":"profile_fa-phone-volume__KKzmX","fa-photo-video":"profile_fa-photo-video__fvP9A","fa-php":"profile_fa-php__71eEE","fa-pied-piper":"profile_fa-pied-piper__SXTWO","fa-pied-piper-alt":"profile_fa-pied-piper-alt__e7Dpr","fa-pied-piper-hat":"profile_fa-pied-piper-hat__atYGh","fa-pied-piper-pp":"profile_fa-pied-piper-pp__WgYOB","fa-pied-piper-square":"profile_fa-pied-piper-square__wL080","fa-piggy-bank":"profile_fa-piggy-bank__IOVY_","fa-pills":"profile_fa-pills__PQE8r","fa-pinterest":"profile_fa-pinterest__ML7qo","fa-pinterest-p":"profile_fa-pinterest-p__z8Koq","fa-pinterest-square":"profile_fa-pinterest-square__n_R_6","fa-pizza-slice":"profile_fa-pizza-slice__6_KlG","fa-place-of-worship":"profile_fa-place-of-worship__l2y2M","fa-plane":"profile_fa-plane__Yd9jr","fa-plane-arrival":"profile_fa-plane-arrival__jbne7","fa-plane-departure":"profile_fa-plane-departure__YETv3","fa-plane-slash":"profile_fa-plane-slash__rzVfk","fa-play":"profile_fa-play__Owfrh","fa-play-circle":"profile_fa-play-circle__iLxmK","fa-playstation":"profile_fa-playstation__ps5gF","fa-plug":"profile_fa-plug__2RHEU","fa-plus":"profile_fa-plus__Ww5B3","fa-plus-circle":"profile_fa-plus-circle___5DeP","fa-plus-square":"profile_fa-plus-square__3_tkf","fa-podcast":"profile_fa-podcast__J8Kpw","fa-poll":"profile_fa-poll__FjU03","fa-poll-h":"profile_fa-poll-h__N5pxQ","fa-poo":"profile_fa-poo__Nprfp","fa-poo-storm":"profile_fa-poo-storm__1BI6b","fa-poop":"profile_fa-poop__NkM2I","fa-portrait":"profile_fa-portrait__DGahD","fa-pound-sign":"profile_fa-pound-sign__o3Qg9","fa-power-off":"profile_fa-power-off__VQrp_","fa-pray":"profile_fa-pray__AGypf","fa-praying-hands":"profile_fa-praying-hands__FVnr3","fa-prescription":"profile_fa-prescription__OKNJe","fa-prescription-bottle":"profile_fa-prescription-bottle__YWGtu","fa-prescription-bottle-alt":"profile_fa-prescription-bottle-alt__rR_qb","fa-print":"profile_fa-print__m8dkU","fa-procedures":"profile_fa-procedures__piWPs","fa-product-hunt":"profile_fa-product-hunt___MdR8","fa-project-diagram":"profile_fa-project-diagram___N3xM","fa-pump-medical":"profile_fa-pump-medical__trAbC","fa-pump-soap":"profile_fa-pump-soap__Rtcua","fa-pushed":"profile_fa-pushed__I_NYk","fa-puzzle-piece":"profile_fa-puzzle-piece__03jQf","fa-python":"profile_fa-python__qpc8i","fa-qq":"profile_fa-qq__e_Q7v","fa-qrcode":"profile_fa-qrcode__VAp7X","fa-question":"profile_fa-question__pnsVC","fa-question-circle":"profile_fa-question-circle__AUls_","fa-quidditch":"profile_fa-quidditch__UxrtL","fa-quinscape":"profile_fa-quinscape__hSguI","fa-quora":"profile_fa-quora__lFSXA","fa-quote-left":"profile_fa-quote-left__IsDdG","fa-quote-right":"profile_fa-quote-right__SojL6","fa-quran":"profile_fa-quran__nt1UN","fa-r-project":"profile_fa-r-project__l6C1b","fa-radiation":"profile_fa-radiation__6bF5b","fa-radiation-alt":"profile_fa-radiation-alt__wIJYe","fa-rainbow":"profile_fa-rainbow__Wyr2g","fa-random":"profile_fa-random__GlnO5","fa-raspberry-pi":"profile_fa-raspberry-pi__9zyXg","fa-ravelry":"profile_fa-ravelry__xkJNA","fa-react":"profile_fa-react__c0FPG","fa-reacteurope":"profile_fa-reacteurope__CA1_V","fa-readme":"profile_fa-readme__dXKZ2","fa-rebel":"profile_fa-rebel__KwRps","fa-receipt":"profile_fa-receipt__mXDcd","fa-record-vinyl":"profile_fa-record-vinyl__lPJ2L","fa-recycle":"profile_fa-recycle__6_VVf","fa-red-river":"profile_fa-red-river__ETvKQ","fa-reddit":"profile_fa-reddit__jtpcy","fa-reddit-alien":"profile_fa-reddit-alien__4g_zZ","fa-reddit-square":"profile_fa-reddit-square__Lz66Q","fa-redhat":"profile_fa-redhat__o867i","fa-redo":"profile_fa-redo__ZIvMp","fa-redo-alt":"profile_fa-redo-alt__Lcesb","fa-registered":"profile_fa-registered__VKSsq","fa-remove-format":"profile_fa-remove-format__vm1q3","fa-renren":"profile_fa-renren__Otq_P","fa-reply":"profile_fa-reply__S25X_","fa-reply-all":"profile_fa-reply-all__KNIZ1","fa-replyd":"profile_fa-replyd__9nwmd","fa-republican":"profile_fa-republican__Ewl9B","fa-researchgate":"profile_fa-researchgate__95_Ap","fa-resolving":"profile_fa-resolving__JVq8h","fa-restroom":"profile_fa-restroom__ZpP3w","fa-retweet":"profile_fa-retweet__dTW07","fa-rev":"profile_fa-rev__qqHHk","fa-ribbon":"profile_fa-ribbon__BWE2v","fa-ring":"profile_fa-ring__EVo9V","fa-road":"profile_fa-road__DDtuQ","fa-robot":"profile_fa-robot__EVOYq","fa-rocket":"profile_fa-rocket__8_oD0","fa-rocketchat":"profile_fa-rocketchat__EITaC","fa-rockrms":"profile_fa-rockrms__vQz1t","fa-route":"profile_fa-route__hrQw3","fa-rss":"profile_fa-rss__vR5mw","fa-rss-square":"profile_fa-rss-square__MiiSC","fa-ruble-sign":"profile_fa-ruble-sign___pfkd","fa-ruler":"profile_fa-ruler__rUoiv","fa-ruler-combined":"profile_fa-ruler-combined__y_FIN","fa-ruler-horizontal":"profile_fa-ruler-horizontal__n0cBc","fa-ruler-vertical":"profile_fa-ruler-vertical__EBDTp","fa-running":"profile_fa-running__cUFHo","fa-rupee-sign":"profile_fa-rupee-sign__gzbwV","fa-rust":"profile_fa-rust__Xz5S8","fa-sad-cry":"profile_fa-sad-cry__PDbGh","fa-sad-tear":"profile_fa-sad-tear__KBS08","fa-safari":"profile_fa-safari__Mhqks","fa-salesforce":"profile_fa-salesforce___DTZI","fa-sass":"profile_fa-sass__JaOQw","fa-satellite":"profile_fa-satellite__dVagH","fa-satellite-dish":"profile_fa-satellite-dish__J_e4B","fa-save":"profile_fa-save__PotfC","fa-schlix":"profile_fa-schlix__t1mqx","fa-school":"profile_fa-school__0S6rB","fa-screwdriver":"profile_fa-screwdriver___HDQr","fa-scribd":"profile_fa-scribd___S_yj","fa-scroll":"profile_fa-scroll__Nmjwc","fa-sd-card":"profile_fa-sd-card__wS6uH","fa-search":"profile_fa-search__i7A5k","fa-search-dollar":"profile_fa-search-dollar__zQaeV","fa-search-location":"profile_fa-search-location__wqVEf","fa-search-minus":"profile_fa-search-minus__1axU0","fa-search-plus":"profile_fa-search-plus__Vnb8K","fa-searchengin":"profile_fa-searchengin__95TxK","fa-seedling":"profile_fa-seedling__HqZT5","fa-sellcast":"profile_fa-sellcast__N1QGK","fa-sellsy":"profile_fa-sellsy__UQ1lO","fa-server":"profile_fa-server__OrBbI","fa-servicestack":"profile_fa-servicestack__Lb_yy","fa-shapes":"profile_fa-shapes___9iqO","fa-share":"profile_fa-share__fk7dB","fa-share-alt":"profile_fa-share-alt__NAEWB","fa-share-alt-square":"profile_fa-share-alt-square__BkEMa","fa-share-square":"profile_fa-share-square__bKJhu","fa-shekel-sign":"profile_fa-shekel-sign__PJCMS","fa-shield-alt":"profile_fa-shield-alt__DjvQx","fa-shield-virus":"profile_fa-shield-virus__xmxoY","fa-ship":"profile_fa-ship__qMkQA","fa-shipping-fast":"profile_fa-shipping-fast__K_FGV","fa-shirtsinbulk":"profile_fa-shirtsinbulk__iYVzR","fa-shoe-prints":"profile_fa-shoe-prints__ji5xp","fa-shopify":"profile_fa-shopify__XDJIg","fa-shopping-bag":"profile_fa-shopping-bag__ddMDG","fa-shopping-basket":"profile_fa-shopping-basket__U0yCr","fa-shopping-cart":"profile_fa-shopping-cart__RYq0k","fa-shopware":"profile_fa-shopware__FJNyZ","fa-shower":"profile_fa-shower__exCGF","fa-shuttle-van":"profile_fa-shuttle-van__3Qh98","fa-sign":"profile_fa-sign__jK__T","fa-sign-in-alt":"profile_fa-sign-in-alt__AQcjL","fa-sign-language":"profile_fa-sign-language__VfQGE","fa-sign-out-alt":"profile_fa-sign-out-alt__h6HSE","fa-signal":"profile_fa-signal__I7Wcc","fa-signature":"profile_fa-signature__QGNgD","fa-sim-card":"profile_fa-sim-card__vCF1Z","fa-simplybuilt":"profile_fa-simplybuilt__FWZHz","fa-sink":"profile_fa-sink__hxRod","fa-sistrix":"profile_fa-sistrix__7zqfR","fa-sitemap":"profile_fa-sitemap__ibpZE","fa-sith":"profile_fa-sith__Ovu8D","fa-skating":"profile_fa-skating__b8_PN","fa-sketch":"profile_fa-sketch___KsFX","fa-skiing":"profile_fa-skiing__2yJfS","fa-skiing-nordic":"profile_fa-skiing-nordic__2KCfa","fa-skull":"profile_fa-skull__f6V9L","fa-skull-crossbones":"profile_fa-skull-crossbones__Lssvl","fa-skyatlas":"profile_fa-skyatlas__BmUO_","fa-skype":"profile_fa-skype__GGXz8","fa-slack":"profile_fa-slack__esTei","fa-slack-hash":"profile_fa-slack-hash__gfZ9D","fa-slash":"profile_fa-slash__3AEAY","fa-sleigh":"profile_fa-sleigh__4Lc6O","fa-sliders-h":"profile_fa-sliders-h__OYSbr","fa-slideshare":"profile_fa-slideshare__8clQu","fa-smile":"profile_fa-smile__W2loi","fa-smile-beam":"profile_fa-smile-beam__UfaYi","fa-smile-wink":"profile_fa-smile-wink__plcxm","fa-smog":"profile_fa-smog__z1Weu","fa-smoking":"profile_fa-smoking__x08gy","fa-smoking-ban":"profile_fa-smoking-ban__Yvu9t","fa-sms":"profile_fa-sms__gAHYT","fa-snapchat":"profile_fa-snapchat__WWtvT","fa-snapchat-ghost":"profile_fa-snapchat-ghost__TiIkH","fa-snapchat-square":"profile_fa-snapchat-square__OfctK","fa-snowboarding":"profile_fa-snowboarding__KwRli","fa-snowflake":"profile_fa-snowflake__VlEV_","fa-snowman":"profile_fa-snowman__Frgjw","fa-snowplow":"profile_fa-snowplow__MAeT_","fa-soap":"profile_fa-soap__PXH_S","fa-socks":"profile_fa-socks__bxZVp","fa-solar-panel":"profile_fa-solar-panel__D_72x","fa-sort":"profile_fa-sort__Awk3J","fa-sort-alpha-down":"profile_fa-sort-alpha-down__xTcox","fa-sort-alpha-down-alt":"profile_fa-sort-alpha-down-alt__I9Cqd","fa-sort-alpha-up":"profile_fa-sort-alpha-up___XErE","fa-sort-alpha-up-alt":"profile_fa-sort-alpha-up-alt__sxXoe","fa-sort-amount-down":"profile_fa-sort-amount-down__MdNRY","fa-sort-amount-down-alt":"profile_fa-sort-amount-down-alt__x9ou4","fa-sort-amount-up":"profile_fa-sort-amount-up__eMs1g","fa-sort-amount-up-alt":"profile_fa-sort-amount-up-alt__x2lGz","fa-sort-down":"profile_fa-sort-down__zjEQL","fa-sort-numeric-down":"profile_fa-sort-numeric-down__VUAUb","fa-sort-numeric-down-alt":"profile_fa-sort-numeric-down-alt__sQp9c","fa-sort-numeric-up":"profile_fa-sort-numeric-up__t1yrz","fa-sort-numeric-up-alt":"profile_fa-sort-numeric-up-alt__hVXmz","fa-sort-up":"profile_fa-sort-up__rkJ7V","fa-soundcloud":"profile_fa-soundcloud__wCPt3","fa-sourcetree":"profile_fa-sourcetree__BWBZO","fa-spa":"profile_fa-spa__6_bz3","fa-space-shuttle":"profile_fa-space-shuttle__QpbEY","fa-speakap":"profile_fa-speakap__iQsne","fa-speaker-deck":"profile_fa-speaker-deck__cRRNG","fa-spell-check":"profile_fa-spell-check__w1sU1","fa-spider":"profile_fa-spider__aeYHF","fa-spinner":"profile_fa-spinner__ij_Sm","fa-splotch":"profile_fa-splotch__TpAqb","fa-spotify":"profile_fa-spotify__PFoxG","fa-spray-can":"profile_fa-spray-can__8SFVn","fa-square":"profile_fa-square__P8xpx","fa-square-full":"profile_fa-square-full__GxELP","fa-square-root-alt":"profile_fa-square-root-alt__R5uxT","fa-squarespace":"profile_fa-squarespace__5fV9o","fa-stack-exchange":"profile_fa-stack-exchange__Fv4V7","fa-stack-overflow":"profile_fa-stack-overflow__Qyrk7","fa-stackpath":"profile_fa-stackpath__wRrAY","fa-stamp":"profile_fa-stamp__i0zE7","fa-star":"profile_fa-star__ytAya","fa-star-and-crescent":"profile_fa-star-and-crescent__Le7L4","fa-star-half":"profile_fa-star-half__h0hvM","fa-star-half-alt":"profile_fa-star-half-alt____INn","fa-star-of-david":"profile_fa-star-of-david__CDYAW","fa-star-of-life":"profile_fa-star-of-life___SLwB","fa-staylinked":"profile_fa-staylinked__m8iJ6","fa-steam":"profile_fa-steam__LDQqT","fa-steam-square":"profile_fa-steam-square__NTTtz","fa-steam-symbol":"profile_fa-steam-symbol__r_NlP","fa-step-backward":"profile_fa-step-backward__MsEvo","fa-step-forward":"profile_fa-step-forward__3fhCL","fa-stethoscope":"profile_fa-stethoscope__LVoFz","fa-sticker-mule":"profile_fa-sticker-mule__t7mYt","fa-sticky-note":"profile_fa-sticky-note__8IMov","fa-stop":"profile_fa-stop__cn8tc","fa-stop-circle":"profile_fa-stop-circle__9CPge","fa-stopwatch":"profile_fa-stopwatch__VrfN1","fa-stopwatch-20":"profile_fa-stopwatch-20__7HzLW","fa-store":"profile_fa-store__m3Fhj","fa-store-alt":"profile_fa-store-alt__Z8pFa","fa-store-alt-slash":"profile_fa-store-alt-slash___ObsZ","fa-store-slash":"profile_fa-store-slash__Zrjbw","fa-strava":"profile_fa-strava__8QPjM","fa-stream":"profile_fa-stream__Y2F9B","fa-street-view":"profile_fa-street-view__sYf2z","fa-strikethrough":"profile_fa-strikethrough__Kj_Zt","fa-stripe":"profile_fa-stripe__jzd2z","fa-stripe-s":"profile_fa-stripe-s__t7_Z5","fa-stroopwafel":"profile_fa-stroopwafel__1oF_H","fa-studiovinari":"profile_fa-studiovinari__Lg6Fg","fa-stumbleupon":"profile_fa-stumbleupon__7H5vv","fa-stumbleupon-circle":"profile_fa-stumbleupon-circle__0I05t","fa-subscript":"profile_fa-subscript__rrfkC","fa-subway":"profile_fa-subway__pOCh4","fa-suitcase":"profile_fa-suitcase__laLym","fa-suitcase-rolling":"profile_fa-suitcase-rolling__O0Vap","fa-sun":"profile_fa-sun__rrSp6","fa-superpowers":"profile_fa-superpowers__S_NNS","fa-superscript":"profile_fa-superscript__Vtrna","fa-supple":"profile_fa-supple__08lPn","fa-surprise":"profile_fa-surprise__CqOkC","fa-suse":"profile_fa-suse__tK9ME","fa-swatchbook":"profile_fa-swatchbook__bD34s","fa-swift":"profile_fa-swift__yDCnR","fa-swimmer":"profile_fa-swimmer__Vk20I","fa-swimming-pool":"profile_fa-swimming-pool__gbbJz","fa-symfony":"profile_fa-symfony__CHNtK","fa-synagogue":"profile_fa-synagogue__NEn7i","fa-sync":"profile_fa-sync__qR6lr","fa-sync-alt":"profile_fa-sync-alt__YY2H7","fa-syringe":"profile_fa-syringe__aEChZ","fa-table":"profile_fa-table__GSres","fa-table-tennis":"profile_fa-table-tennis__wB2ht","fa-tablet":"profile_fa-tablet__ovetY","fa-tablet-alt":"profile_fa-tablet-alt__lgoL_","fa-tablets":"profile_fa-tablets__afd8b","fa-tachometer-alt":"profile_fa-tachometer-alt__TO3fB","fa-tag":"profile_fa-tag__jpE9U","fa-tags":"profile_fa-tags___0Bgy","fa-tape":"profile_fa-tape__ZQBpB","fa-tasks":"profile_fa-tasks__FC8a5","fa-taxi":"profile_fa-taxi__2Y1yR","fa-teamspeak":"profile_fa-teamspeak__KQAse","fa-teeth":"profile_fa-teeth__vZF2Y","fa-teeth-open":"profile_fa-teeth-open__klx3_","fa-telegram":"profile_fa-telegram__g0XiO","fa-telegram-plane":"profile_fa-telegram-plane__rfm9A","fa-temperature-high":"profile_fa-temperature-high__1UkwZ","fa-temperature-low":"profile_fa-temperature-low__QZmIw","fa-tencent-weibo":"profile_fa-tencent-weibo__I9FRt","fa-tenge":"profile_fa-tenge__IBrwh","fa-terminal":"profile_fa-terminal__5DsZ3","fa-text-height":"profile_fa-text-height__zNhQ4","fa-text-width":"profile_fa-text-width__cl2Bh","fa-th":"profile_fa-th__Af4tF","fa-th-large":"profile_fa-th-large__vYITZ","fa-th-list":"profile_fa-th-list__aZNJO","fa-the-red-yeti":"profile_fa-the-red-yeti__3gQTt","fa-theater-masks":"profile_fa-theater-masks__F6HGv","fa-themeco":"profile_fa-themeco__OjQaB","fa-themeisle":"profile_fa-themeisle__eKPVw","fa-thermometer":"profile_fa-thermometer__3J4eu","fa-thermometer-empty":"profile_fa-thermometer-empty__KSFOs","fa-thermometer-full":"profile_fa-thermometer-full__yqvxK","fa-thermometer-half":"profile_fa-thermometer-half__Z6Ewh","fa-thermometer-quarter":"profile_fa-thermometer-quarter__Lv6xH","fa-thermometer-three-quarters":"profile_fa-thermometer-three-quarters__JTLoS","fa-think-peaks":"profile_fa-think-peaks__16u9G","fa-thumbs-down":"profile_fa-thumbs-down__TFdPh","fa-thumbs-up":"profile_fa-thumbs-up__RcAlQ","fa-thumbtack":"profile_fa-thumbtack__s61zU","fa-ticket-alt":"profile_fa-ticket-alt__Qjse8","fa-tiktok":"profile_fa-tiktok__oUUFM","fa-times":"profile_fa-times__tPVcX","fa-times-circle":"profile_fa-times-circle__2CGs3","fa-tint":"profile_fa-tint__pcT1h","fa-tint-slash":"profile_fa-tint-slash__CFr_Q","fa-tired":"profile_fa-tired__b_CeZ","fa-toggle-off":"profile_fa-toggle-off__9LHNn","fa-toggle-on":"profile_fa-toggle-on__RYi2b","fa-toilet":"profile_fa-toilet__iMJKy","fa-toilet-paper":"profile_fa-toilet-paper__k9e3W","fa-toilet-paper-slash":"profile_fa-toilet-paper-slash__XVfAd","fa-toolbox":"profile_fa-toolbox__ooQgy","fa-tools":"profile_fa-tools__XkyHW","fa-tooth":"profile_fa-tooth__lSx71","fa-torah":"profile_fa-torah__49XW0","fa-torii-gate":"profile_fa-torii-gate__DTpct","fa-tractor":"profile_fa-tractor__wRyQc","fa-trade-federation":"profile_fa-trade-federation__ZnAw9","fa-trademark":"profile_fa-trademark__okVrQ","fa-traffic-light":"profile_fa-traffic-light__b7TOS","fa-trailer":"profile_fa-trailer__S5ZoD","fa-train":"profile_fa-train__fN4OV","fa-tram":"profile_fa-tram__ZrV4Z","fa-transgender":"profile_fa-transgender__dOjEW","fa-transgender-alt":"profile_fa-transgender-alt__RWMqP","fa-trash":"profile_fa-trash__JUneq","fa-trash-alt":"profile_fa-trash-alt__bVHdn","fa-trash-restore":"profile_fa-trash-restore__jj7dJ","fa-trash-restore-alt":"profile_fa-trash-restore-alt__BhKgV","fa-tree":"profile_fa-tree__IKyoP","fa-trello":"profile_fa-trello__Sf7ae","fa-tripadvisor":"profile_fa-tripadvisor__pM8C2","fa-trophy":"profile_fa-trophy__fIzB0","fa-truck":"profile_fa-truck__QjVaj","fa-truck-loading":"profile_fa-truck-loading__KYbl_","fa-truck-monster":"profile_fa-truck-monster__NLrfS","fa-truck-moving":"profile_fa-truck-moving__s4TXo","fa-truck-pickup":"profile_fa-truck-pickup__comMq","fa-tshirt":"profile_fa-tshirt__gmXVI","fa-tty":"profile_fa-tty__d1l5a","fa-tumblr":"profile_fa-tumblr__DZKPn","fa-tumblr-square":"profile_fa-tumblr-square__HsZJ3","fa-tv":"profile_fa-tv__cyj7_","fa-twitch":"profile_fa-twitch__wjuH_","fa-twitter":"profile_fa-twitter__bMGzM","fa-twitter-square":"profile_fa-twitter-square__04biM","fa-typo3":"profile_fa-typo3__5mPvg","fa-uber":"profile_fa-uber___vwKG","fa-ubuntu":"profile_fa-ubuntu__Yomit","fa-uikit":"profile_fa-uikit__hJZLO","fa-umbraco":"profile_fa-umbraco__kx9Q1","fa-umbrella":"profile_fa-umbrella__qYl76","fa-umbrella-beach":"profile_fa-umbrella-beach__BdMVP","fa-uncharted":"profile_fa-uncharted__Te2H6","fa-underline":"profile_fa-underline__ye3Tm","fa-undo":"profile_fa-undo__50I_i","fa-undo-alt":"profile_fa-undo-alt__6dEeU","fa-uniregistry":"profile_fa-uniregistry__lE66F","fa-unity":"profile_fa-unity__JMZ2n","fa-universal-access":"profile_fa-universal-access__9C_xp","fa-university":"profile_fa-university__ztqJS","fa-unlink":"profile_fa-unlink__Btwa2","fa-unlock":"profile_fa-unlock__kHNkH","fa-unlock-alt":"profile_fa-unlock-alt__pbpd2","fa-unsplash":"profile_fa-unsplash__FOcrL","fa-untappd":"profile_fa-untappd__5fa5v","fa-upload":"profile_fa-upload__g7kyb","fa-ups":"profile_fa-ups__19RWJ","fa-usb":"profile_fa-usb__GJXVX","fa-user":"profile_fa-user__awQ7b","fa-user-alt":"profile_fa-user-alt__R8XSd","fa-user-alt-slash":"profile_fa-user-alt-slash__vj3kA","fa-user-astronaut":"profile_fa-user-astronaut__W8L0K","fa-user-check":"profile_fa-user-check__mvzmm","fa-user-circle":"profile_fa-user-circle__zyywK","fa-user-clock":"profile_fa-user-clock__zWvUD","fa-user-cog":"profile_fa-user-cog__T0cCO","fa-user-edit":"profile_fa-user-edit__IpG6A","fa-user-friends":"profile_fa-user-friends__XAGuS","fa-user-graduate":"profile_fa-user-graduate__Odw_S","fa-user-injured":"profile_fa-user-injured__ujFkV","fa-user-lock":"profile_fa-user-lock__R1JgK","fa-user-md":"profile_fa-user-md__R7TOE","fa-user-minus":"profile_fa-user-minus__m5Yc3","fa-user-ninja":"profile_fa-user-ninja__a6_JU","fa-user-nurse":"profile_fa-user-nurse__xNZ_J","fa-user-plus":"profile_fa-user-plus__GSPTO","fa-user-secret":"profile_fa-user-secret__oBdp7","fa-user-shield":"profile_fa-user-shield__iqzWz","fa-user-slash":"profile_fa-user-slash__ELjTp","fa-user-tag":"profile_fa-user-tag___ZMIk","fa-user-tie":"profile_fa-user-tie__QsoJo","fa-user-times":"profile_fa-user-times__Gd0Ye","fa-users":"profile_fa-users__nG5u4","fa-users-cog":"profile_fa-users-cog__v3Tzu","fa-users-slash":"profile_fa-users-slash__cjn_T","fa-usps":"profile_fa-usps__Q1woE","fa-ussunnah":"profile_fa-ussunnah__TvHJd","fa-utensil-spoon":"profile_fa-utensil-spoon__2bLxq","fa-utensils":"profile_fa-utensils__1F0oK","fa-vaadin":"profile_fa-vaadin__wgSOz","fa-vector-square":"profile_fa-vector-square__kbPMi","fa-venus":"profile_fa-venus__lh1jO","fa-venus-double":"profile_fa-venus-double__IG7gZ","fa-venus-mars":"profile_fa-venus-mars__nKXAg","fa-vest":"profile_fa-vest__a2Bph","fa-vest-patches":"profile_fa-vest-patches__u4MeV","fa-viacoin":"profile_fa-viacoin__OAyBP","fa-viadeo":"profile_fa-viadeo____FDN","fa-viadeo-square":"profile_fa-viadeo-square___ZJJP","fa-vial":"profile_fa-vial__ACMbv","fa-vials":"profile_fa-vials__wUx2x","fa-viber":"profile_fa-viber__ljBtX","fa-video":"profile_fa-video__4D6Ir","fa-video-slash":"profile_fa-video-slash__UrPhF","fa-vihara":"profile_fa-vihara__Yn6Ue","fa-vimeo":"profile_fa-vimeo__mzNFB","fa-vimeo-square":"profile_fa-vimeo-square__PA_CX","fa-vimeo-v":"profile_fa-vimeo-v__vk0jV","fa-vine":"profile_fa-vine__GOH_X","fa-virus":"profile_fa-virus__4svIC","fa-virus-slash":"profile_fa-virus-slash__Tn3VO","fa-viruses":"profile_fa-viruses__1CtWr","fa-vk":"profile_fa-vk__XIPQS","fa-vnv":"profile_fa-vnv__BsMGT","fa-voicemail":"profile_fa-voicemail__tLRFu","fa-volleyball-ball":"profile_fa-volleyball-ball__MsCXw","fa-volume-down":"profile_fa-volume-down__Uq8TL","fa-volume-mute":"profile_fa-volume-mute__1qqfJ","fa-volume-off":"profile_fa-volume-off__jGMJZ","fa-volume-up":"profile_fa-volume-up__Lr1sn","fa-vote-yea":"profile_fa-vote-yea__y_mcf","fa-vr-cardboard":"profile_fa-vr-cardboard__EaVwT","fa-vuejs":"profile_fa-vuejs__LlmkR","fa-walking":"profile_fa-walking__CaSUx","fa-wallet":"profile_fa-wallet__zuiGE","fa-warehouse":"profile_fa-warehouse___H91y","fa-watchman-monitoring":"profile_fa-watchman-monitoring__wd0m8","fa-water":"profile_fa-water__0EhKx","fa-wave-square":"profile_fa-wave-square__QYZGn","fa-waze":"profile_fa-waze__I2eVc","fa-weebly":"profile_fa-weebly__DLt4T","fa-weibo":"profile_fa-weibo__LqDcH","fa-weight":"profile_fa-weight__FwDre","fa-weight-hanging":"profile_fa-weight-hanging__69Sox","fa-weixin":"profile_fa-weixin__OnUjP","fa-whatsapp":"profile_fa-whatsapp__9ptev","fa-whatsapp-square":"profile_fa-whatsapp-square__0RBMI","fa-wheelchair":"profile_fa-wheelchair__5o2p7","fa-whmcs":"profile_fa-whmcs__Flziy","fa-wifi":"profile_fa-wifi__D4Wsj","fa-wikipedia-w":"profile_fa-wikipedia-w__zCY0N","fa-wind":"profile_fa-wind__Lf3uy","fa-window-close":"profile_fa-window-close__5Tz9F","fa-window-maximize":"profile_fa-window-maximize__z_Kiv","fa-window-minimize":"profile_fa-window-minimize__tuziV","fa-window-restore":"profile_fa-window-restore__3LHsb","fa-windows":"profile_fa-windows__hFKhz","fa-wine-bottle":"profile_fa-wine-bottle__DRZvH","fa-wine-glass":"profile_fa-wine-glass__i1L9y","fa-wine-glass-alt":"profile_fa-wine-glass-alt__ERRVk","fa-wix":"profile_fa-wix__pUEsj","fa-wizards-of-the-coast":"profile_fa-wizards-of-the-coast__Z_j4k","fa-wodu":"profile_fa-wodu__1l774","fa-wolf-pack-battalion":"profile_fa-wolf-pack-battalion__8Kagp","fa-won-sign":"profile_fa-won-sign__bGo7O","fa-wordpress":"profile_fa-wordpress__Oos02","fa-wordpress-simple":"profile_fa-wordpress-simple__DMV6v","fa-wpbeginner":"profile_fa-wpbeginner__CoYLg","fa-wpexplorer":"profile_fa-wpexplorer__NPmrE","fa-wpforms":"profile_fa-wpforms__RlAfh","fa-wpressr":"profile_fa-wpressr__ENzVK","fa-wrench":"profile_fa-wrench__ToNpI","fa-x-ray":"profile_fa-x-ray__ZR5Jw","fa-xbox":"profile_fa-xbox__Zijd8","fa-xing":"profile_fa-xing__Ygurm","fa-xing-square":"profile_fa-xing-square__kPf4D","fa-y-combinator":"profile_fa-y-combinator__ZTdhc","fa-yahoo":"profile_fa-yahoo__GZHuR","fa-yammer":"profile_fa-yammer__EDKMD","fa-yandex":"profile_fa-yandex__Qp_rM","fa-yandex-international":"profile_fa-yandex-international__ZPcSL","fa-yarn":"profile_fa-yarn__x_ZPZ","fa-yelp":"profile_fa-yelp__hpk13","fa-yen-sign":"profile_fa-yen-sign__VkfEM","fa-yin-yang":"profile_fa-yin-yang__VF6b2","fa-yoast":"profile_fa-yoast__843Ds","fa-youtube":"profile_fa-youtube__oNThV","fa-youtube-square":"profile_fa-youtube-square__d9elw","fa-zhihu":"profile_fa-zhihu__3mTWX","sr-only":"profile_sr-only__DQt1a","sr-only-focusable":"profile_sr-only-focusable__LAGYB","Form__CustomSelect":"profile_Form__CustomSelect__wnb1k","Form__ErrorCustomSelect":"profile_Form__ErrorCustomSelect__IPQ4a","Form__currency_symbol":"profile_Form__currency_symbol__xKgbI","Form__select_currency":"profile_Form__select_currency__7HJGa","customSelect__placeholder":"profile_customSelect__placeholder__X0862","primarybtn":"profile_primarybtn__mg_wW","JobList__EditModalEditButton":"profile_JobList__EditModalEditButton__uFMYu","GoBtn":"profile_GoBtn__fxs_t","secondarybtn":"profile_secondarybtn__C0SOt","JobList__EditModalCancelButton":"profile_JobList__EditModalCancelButton__VySIR","iconFilled":"profile_iconFilled__l_FuX","iconFilledSolid":"profile_iconFilledSolid__rciWw","primarybtnborder":"profile_primarybtnborder__GCZSr","secondarybtnborder":"profile_secondarybtnborder__CwViW","ClearBtn":"profile_ClearBtn__k7N6h","tertiarybtn":"profile_tertiarybtn__EC9Rx","graybtnborder":"profile_graybtnborder__SN4vT","jobsrchbtn":"profile_jobsrchbtn__H8qCF","jobsrchbtnalign":"profile_jobsrchbtnalign__Ylp_b","nobgbutton":"profile_nobgbutton__ygI2S","iconTextButton":"profile_iconTextButton__HQMr8","cursornone":"profile_cursornone__y6t5r","nobgbuttonprimary":"profile_nobgbuttonprimary__zvtXH","mt15":"profile_mt15__JEjXP","btn350":"profile_btn350__NEJKG","GrayBgBtn":"profile_GrayBgBtn__gYTqI","NewShareBtn":"profile_NewShareBtn__7s3N2","CoralBgBtn":"profile_CoralBgBtn__Tf1KU","DropContainer":"profile_DropContainer__7p7nY","DropContainer__Inner":"profile_DropContainer__Inner__xIsIA","CompanyProfile__Inner":"profile_CompanyProfile__Inner__19gss","DropContainer__Message":"profile_DropContainer__Message____spL","CompanyProfile__Message":"profile_CompanyProfile__Message__nqG12","CompanyProfile__MessageContent":"profile_CompanyProfile__MessageContent__qekAb","DropContainer__UploadIcon":"profile_DropContainer__UploadIcon__G1XV8","CompanyProfile__UploadIcon":"profile_CompanyProfile__UploadIcon__Mrthb","FileDisplayContainer":"profile_FileDisplayContainer___EbXg","FileDisplayContainer__Status":"profile_FileDisplayContainer__Status__xvpq_","SetupPopup__Status":"profile_SetupPopup__Status__owGWR","SetupPopup__To":"profile_SetupPopup__To__5ff1y","FileDisplayContainer__Type":"profile_FileDisplayContainer__Type__pNdj_","FileDisplayContainer__Name":"profile_FileDisplayContainer__Name____tra","SetupPopup__Name":"profile_SetupPopup__Name__WeseI","SetupPopup__ToName":"profile_SetupPopup__ToName__QC66Y","FileDisplayContainer__Error":"profile_FileDisplayContainer__Error__nWb2C","FileDisplayContainer__Close":"profile_FileDisplayContainer__Close__wdYxa","Browse":"profile_Browse__ybWmc","ClientCompany":"profile_ClientCompany__YjDx3","NewJob":"profile_NewJob__uCpZQ","Interview":"profile_Interview__2JJOC","ClientCompany__TopSection2":"profile_ClientCompany__TopSection2___XMmJ","ClientCompany__Filter":"profile_ClientCompany__Filter__PjQA8","ClientCompany__Input_MatchScore":"profile_ClientCompany__Input_MatchScore__N_pWP","ClientCompany__Percentage_Symbol":"profile_ClientCompany__Percentage_Symbol__O3ocK","ClientCompany__Filterheading":"profile_ClientCompany__Filterheading__9IbDM","ClientCompany__FloatButtonAdd":"profile_ClientCompany__FloatButtonAdd__cF2tI","ClientCompany__FloatButtonAdd__AgencyUserIcon":"profile_ClientCompany__FloatButtonAdd__AgencyUserIcon__cCHZk","ClientCompany__LastEdited":"profile_ClientCompany__LastEdited__eyZYr","ClientCompany__BackSection":"profile_ClientCompany__BackSection__wSANU","AddUsers__BackSection":"profile_AddUsers__BackSection__ThjH8","ClientCompany__BackSection__CloseIcon":"profile_ClientCompany__BackSection__CloseIcon__wF_lL","ClientCompany__Container":"profile_ClientCompany__Container__iLBEh","NewJob__InterviewContainer":"profile_NewJob__InterviewContainer__KtAat","AddUsers__Container":"profile_AddUsers__Container__HvqoM","ClientCompany__FormInputSection":"profile_ClientCompany__FormInputSection__FKH3j","CompanyProfile__FormInputSection":"profile_CompanyProfile__FormInputSection__8NaC4","ClientCompany__Heading":"profile_ClientCompany__Heading__SDkuR","Offer__Heading":"profile_Offer__Heading__gKoIF","AddUsers__Heading":"profile_AddUsers__Heading__fPIia","ClientCompany__StatusAlignment":"profile_ClientCompany__StatusAlignment__g3HkT","ClientCompany__Status":"profile_ClientCompany__Status__VTiC8","ClientCompany__ActiveDot":"profile_ClientCompany__ActiveDot__YXh7a","ClientCompany__CloseDot":"profile_ClientCompany__CloseDot__GaD9m","ClientCompany__Company":"profile_ClientCompany__Company__L_PNd","AddUsers__User":"profile_AddUsers__User__TqIzR","ClientCompany__Systemrefheding":"profile_ClientCompany__Systemrefheding__tU3sz","ClientCompany__Subheading":"profile_ClientCompany__Subheading__L0brI","CompanyProfile__Subheading":"profile_CompanyProfile__Subheading__kcHZP","ClientCompany__Subheading2":"profile_ClientCompany__Subheading2__yXNSz","ClientCompany__Description":"profile_ClientCompany__Description___UpMK","ClientCompany__SubmitSection":"profile_ClientCompany__SubmitSection__DOi6i","NewJob__SubmitSection":"profile_NewJob__SubmitSection__u7Mpo","NewJob__SubmitSectionThreeBtn":"profile_NewJob__SubmitSectionThreeBtn__F0IlO","NewJob__SubmitSectionOneBtnPlacement":"profile_NewJob__SubmitSectionOneBtnPlacement__Zwl9Z","NewJob__ImportSection":"profile_NewJob__ImportSection__kBlOX","SetupPopup__SubmitSection2":"profile_SetupPopup__SubmitSection2__MckjZ","SetupPopup__SubmitSection":"profile_SetupPopup__SubmitSection__Ka9a6","SetupPopup__SubmitSection3":"profile_SetupPopup__SubmitSection3__bp_gF","AddUsers__SubmitSection":"profile_AddUsers__SubmitSection__ItFvZ","ClientCompany__IntegrationImage":"profile_ClientCompany__IntegrationImage__nnzlb","ClientCompany__QuickAdd":"profile_ClientCompany__QuickAdd__1BnEB","NewJob__QuickAdd":"profile_NewJob__QuickAdd__NhOxX","JobList__QuickAdd":"profile_JobList__QuickAdd__Galhh","Interview__QuickAdd":"profile_Interview__QuickAdd__ylNVI","ClientCompany__BodyText":"profile_ClientCompany__BodyText__NaX2f","Form__TableRow":"profile_Form__TableRow__tcNhs","Form__TableRowTwo":"profile_Form__TableRowTwo__eTRSI","Form__TableRowTowGrid":"profile_Form__TableRowTowGrid__K_KrI","Form__TableRowSingle":"profile_Form__TableRowSingle___I1Mf","Form__Label":"profile_Form__Label__MgXZ5","Form__Data":"profile_Form__Data__3RKtj","Form__DataSingleRow":"profile_Form__DataSingleRow__MBQX6","Form__FloatingLabel":"profile_Form__FloatingLabel__gGs3h","Form__TableCol":"profile_Form__TableCol__32I_j","Form__currency_symbol__right":"profile_Form__currency_symbol__right__Lmoy3","Form__TableCol__Disabled":"profile_Form__TableCol__Disabled__Ie1NR","Form__TextareaDisabled":"profile_Form__TextareaDisabled__Gb8Wm","Form__EditorDisabled":"profile_Form__EditorDisabled__YBHAD","Form__AdminCheckLabel":"profile_Form__AdminCheckLabel__lS1bQ","Form__AdminCheckMargin":"profile_Form__AdminCheckMargin__R_u1N","CompanyProfile__BrandingGuide":"profile_CompanyProfile__BrandingGuide__NH_Q0","CompanyProfile__DropBoxContainer":"profile_CompanyProfile__DropBoxContainer__btk_3","CompanyProfile__Browse":"profile_CompanyProfile__Browse__cpV_D","ErrorLabel":"profile_ErrorLabel__8A_3e","Height80":"profile_Height80__1rNam","Browse__ButtonFlexEnd":"profile_Browse__ButtonFlexEnd__joBLQ","AddAgency__Container":"profile_AddAgency__Container__bZ5_V","AddAgency__FormInputSection":"profile_AddAgency__FormInputSection__CJhnO","AddAgency__FormInputSection__Label":"profile_AddAgency__FormInputSection__Label__npF3F","AddAgency__Form":"profile_AddAgency__Form__26LVb","LinkAsButtons":"profile_LinkAsButtons__IY2zb","SearchFlex":"profile_SearchFlex__t3Iru","Career":"profile_Career__3PaJ3","Career__Background_Edit":"profile_Career__Background_Edit__indgg","Career__Background_Edit_Image":"profile_Career__Background_Edit_Image__58Cvs","Career__Container":"profile_Career__Container__dFEjL","Career__Inner":"profile_Career__Inner__GDSwa","Career__logo":"profile_Career__logo__ooJXG","Career__Content":"profile_Career__Content__vFHax","Career__ButtonSection":"profile_Career__ButtonSection__WzgRN","Job":"profile_Job__y2LIZ","Job__Inner":"profile_Job__Inner___f0Ch","Job__Container":"profile_Job__Container__q6NHU","Job__Heading":"profile_Job__Heading__wjRz_","Job__Company":"profile_Job__Company__uMZpv","Job__SearchContainer":"profile_Job__SearchContainer__2HdtV","CandidatesList__SearchContainer":"profile_CandidatesList__SearchContainer__MFIla","Job__SearchInput":"profile_Job__SearchInput__5JFuR","CandidatesList__SearchInput":"profile_CandidatesList__SearchInput__wsRUo","Job__Searchbtn":"profile_Job__Searchbtn__vCjll","CandidatesList__Searchbtn":"profile_CandidatesList__Searchbtn__PNgbs","Job__Input":"profile_Job__Input__u8s95","CandidatesList__Input":"profile_CandidatesList__Input__hmJm_","Job__SelectJob":"profile_Job__SelectJob__vx2te","Job__RemoteLabel":"profile_Job__RemoteLabel__BQyC9","Job__Display":"profile_Job__Display__dCret","Job__PostDay":"profile_Job__PostDay__4eluW","Job__Title":"profile_Job__Title__OPg_N","Job__Location":"profile_Job__Location__Vq7c9","DT":"profile_DT__f0UW1","DisplayTable":"profile_DisplayTable__dmJHW","pd11":"profile_pd11__pVzcu","Label":"profile_Label__WxhNb","inputwidth":"profile_inputwidth__nKMGA","mr24":"profile_mr24__G63MC","fullwidth":"profile_fullwidth__sKTt6","padt40":"profile_padt40__ljZTu","Form__TableRowflex":"profile_Form__TableRowflex__sqlAv","Form__TableColm":"profile_Form__TableColm__NeJfX","Form__LabelCheck":"profile_Form__LabelCheck___MgQZ","Form__Error":"profile_Form__Error__RUdUX","Form__ErrorSection":"profile_Form__ErrorSection__rFLZw","Form__MessagePlaceholder":"profile_Form__MessagePlaceholder__yNmQD","Form__Submit":"profile_Form__Submit__EN_GR","Form__NormalLabel":"profile_Form__NormalLabel__9Rn7c","AddInterview":"profile_AddInterview__S2lze","IntegrationPage":"profile_IntegrationPage__Oqh2f","Integration__BackStep":"profile_Integration__BackStep__lT_y9","AddUsers__BackStep":"profile_AddUsers__BackStep__fs45i","Integration__SubmitSection":"profile_Integration__SubmitSection__cIm9V","IntegrationTable":"profile_IntegrationTable__k1PIY","IntegrationTable__LimitInput":"profile_IntegrationTable__LimitInput__hc_CX","IntegrationTable__Type":"profile_IntegrationTable__Type__jw2bC","IntegrationTable__AllJobsToggle":"profile_IntegrationTable__AllJobsToggle__oRxZC","IntegrationTable__switch":"profile_IntegrationTable__switch__HnwyB","IntegrationTable__switchText":"profile_IntegrationTable__switchText__zJPRy","IntegrationTable__slider":"profile_IntegrationTable__slider___a9wy","IntegrationTable__round":"profile_IntegrationTable__round__xLOM2","IntegrationTable__Action":"profile_IntegrationTable__Action__5_1mC","IntegrationView":"profile_IntegrationView__a_9SR","IntegrationView__Title":"profile_IntegrationView__Title___wtd5","IntegrationView__Subheading":"profile_IntegrationView__Subheading__HASHr","IntegrationView__BoxImage":"profile_IntegrationView__BoxImage__auLSK","IntegrationView__Box":"profile_IntegrationView__Box__qIqXa","IntegrationView__BoxImage__InfoIcon":"profile_IntegrationView__BoxImage__InfoIcon___mkzc","IntegrationView__ViewMoreButton":"profile_IntegrationView__ViewMoreButton__eju2h","IntegrationView__ConnectButton":"profile_IntegrationView__ConnectButton__Aomtg","IntegrationView__GoogleButton":"profile_IntegrationView__GoogleButton__37Gbh","IntegrationView__FlexFlow":"profile_IntegrationView__FlexFlow__RNY_M","IntegrationView__BoxWidth":"profile_IntegrationView__BoxWidth__MbkcT","SkipFinishButton":"profile_SkipFinishButton__Wyqcj","AddUsers":"profile_AddUsers__YHQaY","AddUsers__ButtonSection":"profile_AddUsers__ButtonSection__P0wpO","AddUsers__QuickStepHeading":"profile_AddUsers__QuickStepHeading__5DhT7","AddUsers__DeleteSection":"profile_AddUsers__DeleteSection__m5J_T","Interview__DeleteSection":"profile_Interview__DeleteSection__xETfr","AddUsers__DeleteCrossHeight":"profile_AddUsers__DeleteCrossHeight__eh8o8","AddUsers__Form__Input":"profile_AddUsers__Form__Input__3aLxA","AddUsers__FormHeadingSection":"profile_AddUsers__FormHeadingSection__lO1eV","Interview__FormHeadingSection":"profile_Interview__FormHeadingSection__jK54X","AddUsers__FormSection":"profile_AddUsers__FormSection__XDsTS","NewJob__FormSection":"profile_NewJob__FormSection__FT11a","AddUsers__ButtonsActionSection":"profile_AddUsers__ButtonsActionSection__3ykiA","AddUsers__ImportUsers":"profile_AddUsers__ImportUsers__GINDr","AddUsers__NameInput":"profile_AddUsers__NameInput__MZEgf","AddUsers__EmailInput":"profile_AddUsers__EmailInput__uPinX","AddUsers__RoleInput":"profile_AddUsers__RoleInput__Fhjqm","AddUsers__Subheading":"profile_AddUsers__Subheading__H5H9H","AddUsers__visible":"profile_AddUsers__visible__8sWwQ","Tagrow":"profile_Tagrow__QGTCB","Tagrow__Tags":"profile_Tagrow__Tags___2cKp","SetupPopup__Tags":"profile_SetupPopup__Tags__CGx38","Tagrow__Cancel":"profile_Tagrow__Cancel__NKtNv","Tagrow__Cross":"profile_Tagrow__Cross__NXwqQ","SendInviteSection":"profile_SendInviteSection__zHUQN","error":"profile_error__MrXXa","ViewJobPage__Input":"profile_ViewJobPage__Input__JzU9_","Form__Input2":"profile_Form__Input2__xJgOL","ViewJobPage__PostDay":"profile_ViewJobPage__PostDay__tLVix","ViewJobPage__Title":"profile_ViewJobPage__Title__3N5Q9","ViewJobPage__DescriptionTitle":"profile_ViewJobPage__DescriptionTitle__BFZzp","ViewJobPage__Location":"profile_ViewJobPage__Location__VrlNH","ViewJobPage__primarybtn":"profile_ViewJobPage__primarybtn__84_2u","ViewJobPage__secondarybtn":"profile_ViewJobPage__secondarybtn__p_9VE","ViewJobPage__secondarybtnborder":"profile_ViewJobPage__secondarybtnborder__zEySd","ViewJobPage__BackSection":"profile_ViewJobPage__BackSection__uDTsO","Modalpopup":"profile_Modalpopup__Xvo1f","Modalpopup__inner":"profile_Modalpopup__inner__R11w7","Modalpopup__Dialog":"profile_Modalpopup__Dialog__RfrAd","transition":"profile_transition__GqMcH","Modalpopup__CloseCenter":"profile_Modalpopup__CloseCenter__tO7u6","Modalpopup__Content":"profile_Modalpopup__Content__dL2DA","SetupPopup__PaddingPopup":"profile_SetupPopup__PaddingPopup__V2qCK","SetupPopup__ContentCustomisation":"profile_SetupPopup__ContentCustomisation__7lgef","SetupPopup__Contentwithoutpadding":"profile_SetupPopup__Contentwithoutpadding__USUCz","ViewJobPage__Content":"profile_ViewJobPage__Content__OPmYY","Modalpopup__btn":"profile_Modalpopup__btn__ms9Sv","mar":"profile_mar__3WPwl","Otpback":"profile_Otpback__9V1xW","ViewJobPage":"profile_ViewJobPage__2HfqX","ViewJobPage__Header":"profile_ViewJobPage__Header__vuT2a","ViewJobPage__Application":"profile_ViewJobPage__Application__FRGMq","ViewJobPage__RecordVideo":"profile_ViewJobPage__RecordVideo__3jmUZ","ViewJobPage__RecordVideoSuccessText":"profile_ViewJobPage__RecordVideoSuccessText__OQtXf","ViewJobPage__subheading":"profile_ViewJobPage__subheading__Mkwyt","ViewJobPage__confirmation":"profile_ViewJobPage__confirmation__QJUso","ViewJobPage__Logo":"profile_ViewJobPage__Logo__aaT8t","ViewJobPage__BrandLogo":"profile_ViewJobPage__BrandLogo__9MATK","ViewJobPage__BrandLogo__Padding10":"profile_ViewJobPage__BrandLogo__Padding10__3Vulp","ViewJobPage__Container":"profile_ViewJobPage__Container__EYBPF","ViewJobPage__JobContent":"profile_ViewJobPage__JobContent__bblgw","ViewJobPage__Sidebar":"profile_ViewJobPage__Sidebar__TElHt","ViewJobPage__Sidebar2":"profile_ViewJobPage__Sidebar2__Jwvyp","ViewJobPage__Description":"profile_ViewJobPage__Description__7sidW","ViewJobPage__DescriptionWidth":"profile_ViewJobPage__DescriptionWidth___JDlk","ViewJobPage__Footer":"profile_ViewJobPage__Footer__gWhkm","ViewJobPage__FooterView":"profile_ViewJobPage__FooterView__7YHdK","ViewJobPage__ShareJob":"profile_ViewJobPage__ShareJob__E1Kmt","ViewJobPage__SubmitSection":"profile_ViewJobPage__SubmitSection__oRDNr","ViewJobPage__SocialMedia":"profile_ViewJobPage__SocialMedia___ubHy","ViewJobPage__SideContent":"profile_ViewJobPage__SideContent__LFEEH","ViewJobPage__ApplySection":"profile_ViewJobPage__ApplySection__f5dLu","FormBox__Autofill":"profile_FormBox__Autofill__xtNWn","applybuttons":"profile_applybuttons__Bi0iX","height90":"profile_height90__HYAfR","Form__Cont":"profile_Form__Cont__Sqxd8","Form__DropBox":"profile_Form__DropBox__PZ3dC","Form__DropBoxcontainer":"profile_Form__DropBoxcontainer__BxAcy","Form__DropBoxError":"profile_Form__DropBoxError__Fjjbp","Form__DropBoxicon":"profile_Form__DropBoxicon__Z1_fK","Form__DropBoxmessage":"profile_Form__DropBoxmessage__7o0JD","noDpGrid":"profile_noDpGrid__6hqQ_","Terms":"profile_Terms__lt7oT","TermsCondition":"profile_TermsCondition__bdNEt","TermsCondition__alignterms":"profile_TermsCondition__alignterms__XAd56","MenuContainer":"profile_MenuContainer__8E3uJ","MenuContainer__Menu":"profile_MenuContainer__Menu__WM3nN","AgencyDetailPage":"profile_AgencyDetailPage__0DizI","Congrats__ModalContent":"profile_Congrats__ModalContent__9I3Aa","JobList__SearchBox":"profile_JobList__SearchBox__2aUuK","NewJob__Container":"profile_NewJob__Container__H9teJ","NewJob__TopSection":"profile_NewJob__TopSection__buxmc","JobList__TopSection":"profile_JobList__TopSection__dMH3l","Interview__TopSection":"profile_Interview__TopSection___GzMC","NewJob__HorizontalDivider":"profile_NewJob__HorizontalDivider__PExwZ","NewJob__Wrapper":"profile_NewJob__Wrapper__T2L0D","NewJob__ContainerPadding":"profile_NewJob__ContainerPadding__Qyasr","NewJob__ContainerScroll":"profile_NewJob__ContainerScroll__wG_oX","NewJob__ContainerHeight":"profile_NewJob__ContainerHeight__mr7L9","NewJob__ImportAction":"profile_NewJob__ImportAction__d4jgA","NewJob__Interview_buttons":"profile_NewJob__Interview_buttons__GXrKo","Form__TableRowMB":"profile_Form__TableRowMB__MhWqe","Form__TableRow3grid":"profile_Form__TableRow3grid__Pyzmt","Form__Remotegrid":"profile_Form__Remotegrid__GtXjY","Form__TypeList":"profile_Form__TypeList__I1Vre","Form__Type":"profile_Form__Type__VyzZH","Form__CheckLabel":"profile_Form__CheckLabel__FBqdA","PrivateSwitchBase-root-1":"profile_PrivateSwitchBase-root-1__YGWHA","Form__Caption":"profile_Form__Caption__uPFSp","Form__Input_currency":"profile_Form__Input_currency__Oixtb","Form__Input_MatchScore":"profile_Form__Input_MatchScore__DpMPz","Form__Percentage_Symbol":"profile_Form__Percentage_Symbol__FIwEf","Form__NoGridTemplate":"profile_Form__NoGridTemplate__WE325","active":"profile_active__olsLh","mt10":"profile_mt10__NIsdw","mt40":"profile_mt40__r_20Z","mt30":"profile_mt30__EUyCw","mt32":"profile_mt32__9TSKc","mb0":"profile_mb0__kpHvv","Dpgrid":"profile_Dpgrid__b25_r","mb12":"profile_mb12__N0V7W","width100":"profile_width100__x4ScS","Tagrow__Prefix":"profile_Tagrow__Prefix__r0HiH","PreviewJobPage":"profile_PreviewJobPage__H86Um","PreviewJob":"profile_PreviewJob__pceLr","DpFlx":"profile_DpFlx__QeB30","Subheading":"profile_Subheading__sZF_Q","Subheading__Description":"profile_Subheading__Description__yk1nZ","Candidate__Tooltip":"profile_Candidate__Tooltip__Z7BST","Candidate__Tooltip__Score":"profile_Candidate__Tooltip__Score__r2FJe","Form__InputField":"profile_Form__InputField__s9fvR","Candidate__Length":"profile_Candidate__Length__Db1U_","Agency__PostDay":"profile_Agency__PostDay__Y_zB_","Agency__Title":"profile_Agency__Title__iBiVJ","Agency__Location":"profile_Agency__Location__f21Py","Agency__DescriptionTitle":"profile_Agency__DescriptionTitle__T04cd","Agency__Description":"profile_Agency__Description__DpOTW","LightBlueColor":"profile_LightBlueColor__H2AEg","AgencyDetailForm":"profile_AgencyDetailForm__MKAck","Client_Page":"profile_Client_Page___BN1A","Welcome":"profile_Welcome__2b_PQ","Welcome__Inner":"profile_Welcome__Inner__KXRjz","Welcome__Person":"profile_Welcome__Person__rzBnY","Welcome__LeftContent":"profile_Welcome__LeftContent__45X7U","Welcome__RightContent":"profile_Welcome__RightContent__SMUOZ","Welcome__Content":"profile_Welcome__Content__z_mCh","Welcome__CreateAccount":"profile_Welcome__CreateAccount__UdgXD","Welcome__title":"profile_Welcome__title__8L6CA","Welcome__FormBox":"profile_Welcome__FormBox__PCP1T","Form__psw":"profile_Form__psw__A096h","Welcome__Container":"profile_Welcome__Container__wLFbv","Success__Container":"profile_Success__Container__2Az7y","Success":"profile_Success__qcvjy","Success__Inner":"profile_Success__Inner__0kMVh","InterviewContainer":"profile_InterviewContainer__LBsrK","Interview__Stages":"profile_Interview__Stages___Dxml","Interview__StageHeading":"profile_Interview__StageHeading__VnBU8","pl10":"profile_pl10__Arr6g","Interview__AddStageSection":"profile_Interview__AddStageSection__euTlK","Interview__Label":"profile_Interview__Label__nbSU9","Interview__FormRowHeading":"profile_Interview__FormRowHeading__qQZ2m","dpflex":"profile_dpflex__bsSbN","Interview__IconsType":"profile_Interview__IconsType__tVkfu","Interview__Icons":"profile_Interview__Icons__sbJEK","Interview__Interview_buttons":"profile_Interview__Interview_buttons__tiJxU","Interview__approvalButton":"profile_Interview__approvalButton__rMxb3","Interview__BestMatch":"profile_Interview__BestMatch__Jv4m4","Interview__BestMatchExclamation":"profile_Interview__BestMatchExclamation__zNPV6","DragAndDrop":"profile_DragAndDrop__NeGqH","DragAndDrop__CursorHandle":"profile_DragAndDrop__CursorHandle__8pOXP","Tagrow__Image":"profile_Tagrow__Image__M72xs","rowbglight":"profile_rowbglight___xVxY","rowbgheight":"profile_rowbgheight__Q4B26","Form__w90":"profile_Form__w90__To0Ln","Container":"profile_Container__kWXZU","Screening__StageName":"profile_Screening__StageName__PZdfV","Screening__InterviewType":"profile_Screening__InterviewType__VnW_k","Screening__InterviewType__Label":"profile_Screening__InterviewType__Label__Z58o_","Show_Infoicon":"profile_Show_Infoicon__QbM8Y","Show_Infoicon_small":"profile_Show_Infoicon_small__1o0qR","Screening__Info":"profile_Screening__Info__w8g_m","Screening__Info__IconWithText":"profile_Screening__Info__IconWithText__6Dk1G","InterviewType__Icon":"profile_InterviewType__Icon___Rs9y","InterviewType__Text":"profile_InterviewType__Text__Q4zUB","LoginModal":"profile_LoginModal__nqitA","Logincontent":"profile_Logincontent__616B9","Logincontent__title":"profile_Logincontent__title__zQLqs","Modalbg":"profile_Modalbg__nOr0z","Modalnobg":"profile_Modalnobg__g3BLi","Form__Container":"profile_Form__Container__5oGoi","Form__success":"profile_Form__success__D2kYI","Form__error":"profile_Form__error__datzB","Form__CheckLabeltext":"profile_Form__CheckLabeltext__pyQKq","Form__TextLeft":"profile_Form__TextLeft__L79SR","Backsection":"profile_Backsection___FCnJ","back":"profile_back__JoyzA","mlr0":"profile_mlr0__C1vMR","TwoButtons":"profile_TwoButtons__VKyFF","OtpBacksection":"profile_OtpBacksection__T7PCl","SetupPopup":"profile_SetupPopup__JCKW2","JobList__EditModal":"profile_JobList__EditModal__3ct8h","SetupPopup__inner":"profile_SetupPopup__inner__r6WVx","SetupPopup__Dialog":"profile_SetupPopup__Dialog__RUKkv","SetupPopup__AddFile":"profile_SetupPopup__AddFile__yTxVZ","SetupPopup__OptionalText":"profile_SetupPopup__OptionalText__anA_1","SetupPopup__RequestAccessBtn":"profile_SetupPopup__RequestAccessBtn__fTzNK","SetupPopup__InternalSection":"profile_SetupPopup__InternalSection__d2S0y","SetupPopup__ContentInnerRow":"profile_SetupPopup__ContentInnerRow__TrT9e","SetupPopup__ToChips":"profile_SetupPopup__ToChips__MED01","SetupPopup__AttachmentContainer":"profile_SetupPopup__AttachmentContainer__DnpE3","SetupPopup__ContentInnerCol":"profile_SetupPopup__ContentInnerCol__QovrY","SetupPopup__grid":"profile_SetupPopup__grid__GJ7dy","SetupPopup__Footer":"profile_SetupPopup__Footer__WfjaZ","SetupPopup__FooterNew":"profile_SetupPopup__FooterNew__WOSYL","SetupPopup__Footer2":"profile_SetupPopup__Footer2__GipBK","SetupPopup__Footer3":"profile_SetupPopup__Footer3__fnT41","SetupPopup__Footerassess":"profile_SetupPopup__Footerassess__bE4GK","SetupPopup__Footertechtest":"profile_SetupPopup__Footertechtest__I8R9f","SetupPopup__AutommationFooter":"profile_SetupPopup__AutommationFooter__u_5Oc","SetupPopup__MannualFooter":"profile_SetupPopup__MannualFooter__dYBOx","SetupPopup__MannualInnerSection":"profile_SetupPopup__MannualInnerSection__YT_BI","SetupPopup__Content":"profile_SetupPopup__Content__bzIfw","SetupPopup__Content__Radiobtn":"profile_SetupPopup__Content__Radiobtn__h9A2n","SetupPopup__AutomationToggle":"profile_SetupPopup__AutomationToggle__KOjyQ","SetupPopup__SetupVideoQa":"profile_SetupPopup__SetupVideoQa__wSP1k","SetupPopup__SetupVideoQa2":"profile_SetupPopup__SetupVideoQa2__R_BAR","SetupPopup__SetupVideoQa3":"profile_SetupPopup__SetupVideoQa3__hNXeO","SetupPopup__SetupVideoQa4":"profile_SetupPopup__SetupVideoQa4__rKxuG","SetupPopup__InputQA":"profile_SetupPopup__InputQA__6FW7p","SetupPopup__AddQuestion":"profile_SetupPopup__AddQuestion__cGJ79","SetupPopup__QuestionSection":"profile_SetupPopup__QuestionSection__Gj9OX","SetupPopup__PushTop":"profile_SetupPopup__PushTop__1vP5T","SetupPopup__Contentpading":"profile_SetupPopup__Contentpading__9j1Fo","SetupPopup__QuesionSectionpading":"profile_SetupPopup__QuesionSectionpading__wP_zI","SetupPopup__Contentcenter":"profile_SetupPopup__Contentcenter__wKprZ","SetupPopup__PopDetails":"profile_SetupPopup__PopDetails__HF3oJ","SetupPopup__PopDetails__FS16":"profile_SetupPopup__PopDetails__FS16__7NgWA","SetupPopup__Details":"profile_SetupPopup__Details__q17K8","SetupPopup__PrivacyPolicyDetails":"profile_SetupPopup__PrivacyPolicyDetails__xYi6R","SetupPopup__Reason":"profile_SetupPopup__Reason__5JfwO","SetupPopup__ContentBlock":"profile_SetupPopup__ContentBlock__HdTsf","SetupPopup__Purpose":"profile_SetupPopup__Purpose__JaOaL","SetupPopup__ContentGridsec":"profile_SetupPopup__ContentGridsec___8dPH","mt25":"profile_mt25__po0Cp","mt20":"profile_mt20__ubIVW","SetupPopup__ContentGridTech":"profile_SetupPopup__ContentGridTech__Jxdd5","SetupPopup__Assesmentsection":"profile_SetupPopup__Assesmentsection__DOKsF","SetupPopup__AssesmentsectionNew":"profile_SetupPopup__AssesmentsectionNew__FGFIW","SetupPopup__MannualChips":"profile_SetupPopup__MannualChips__n4_gO","SetupPopup__ContentGridManuaCol":"profile_SetupPopup__ContentGridManuaCol__pcfTQ","SetupPopup__ContentGridManual":"profile_SetupPopup__ContentGridManual__0QPJ3","SetupPopup__ContentBlockPhone":"profile_SetupPopup__ContentBlockPhone__3hbp5","SetupPopup__ContentAddInterview":"profile_SetupPopup__ContentAddInterview__syuAd","SetupPopup__ContentGridPhone":"profile_SetupPopup__ContentGridPhone__XT_Re","SetupPopup__ContentGridStatus":"profile_SetupPopup__ContentGridStatus__Lsykm","SetupPopup__GridActions":"profile_SetupPopup__GridActions__ovDFE","SetupPopup__GridActionCoral":"profile_SetupPopup__GridActionCoral__uDIdJ","SetupPopup__GridActionIndigo":"profile_SetupPopup__GridActionIndigo__8ejJT","SetupPopup__ContentGrid":"profile_SetupPopup__ContentGrid__QRveJ","SetupPopup__SubmitSectionSave":"profile_SetupPopup__SubmitSectionSave__ck24U","SetupPopup__SubmitSectionReset":"profile_SetupPopup__SubmitSectionReset__SOFfm","SetupPopup__SubmitSectionAutomation":"profile_SetupPopup__SubmitSectionAutomation__i6oOf","SetupPopup__Duration":"profile_SetupPopup__Duration__KCGok","SetupPopup__DeleteIcon":"profile_SetupPopup__DeleteIcon__LxKL0","SetupPopup__ContentCustomisationManualInterview":"profile_SetupPopup__ContentCustomisationManualInterview__e09P6","mt0":"profile_mt0__vkJm_","mtb25":"profile_mtb25__dy4gE","mb15":"profile_mb15__6kdAy","mb30":"profile_mb30__geKDy","mt9":"profile_mt9__2Wx87","lineheight0":"profile_lineheight0__rxZ2s","PopupHeightSection":"profile_PopupHeightSection__wJo7D","AssessPopupHeightSection":"profile_AssessPopupHeightSection__u9SI2","Statusopupheight":"profile_Statusopupheight__XuJ65","buttonIn":"profile_buttonIn__l2Il6","MessagePlaceholder":"profile_MessagePlaceholder__yAUyW","m0":"profile_m0__gY_el","mt18":"profile_mt18__iPy5F","DPgrid":"profile_DPgrid__D1RSf","addbtnposition":"profile_addbtnposition__h3rg_","mainformdiv":"profile_mainformdiv___zrSW","crossflex":"profile_crossflex__NFgJ6","crossimgheight":"profile_crossimgheight__NxrSw","crossimgheight48":"profile_crossimgheight48__tJUwS","SetupModalPopup":"profile_SetupModalPopup__Kx0rB","SetupModalPopup__Dialog":"profile_SetupModalPopup__Dialog__Th3IC","SetupPopupoverlay":"profile_SetupPopupoverlay__sM3RU","NeedHelp":"profile_NeedHelp__BH9X0","uploadNewTest":"profile_uploadNewTest__ADWGT","SetupPopup__ol":"profile_SetupPopup__ol__iGFMa","Threshold__Content":"profile_Threshold__Content__Gv_36","SetupPopup__ContentGridPhone__Content":"profile_SetupPopup__ContentGridPhone__Content__ccmdT","JobList__EditModalInner":"profile_JobList__EditModalInner__bYCiH","Popupheight":"profile_Popupheight__rhMXe","CandidateBulkActionSection":"profile_CandidateBulkActionSection__EIX51","KanbanBulkActionSection":"profile_KanbanBulkActionSection__dxuT0","KanbanBulkActionSection__Progress":"profile_KanbanBulkActionSection__Progress__c_EJN","KanbanBulkActionSection__Message":"profile_KanbanBulkActionSection__Message__fsbvf","Heading":"profile_Heading__UFIhv","Offer__Container":"profile_Offer__Container__q8IVx","Offer__DetailsSection":"profile_Offer__DetailsSection__0CXJh","Offer__NoMarginTop":"profile_Offer__NoMarginTop__74rrj","Offer__Mt20":"profile_Offer__Mt20__wWJPQ","Form__OfferSubmit":"profile_Form__OfferSubmit__6CWAp","Error":"profile_Error__TdFim","SignContract":"profile_SignContract__oRYnK","SignContract__Container":"profile_SignContract__Container__KE6eh","SignContract__Button":"profile_SignContract__Button__RQfr1","SignContract__Header":"profile_SignContract__Header__M_cg8","SignContract__Page":"profile_SignContract__Page__lDDdp","SignContract__Logo":"profile_SignContract__Logo__Rq_kO","SignContract__Main":"profile_SignContract__Main__OfMuQ","OfferDetail__Container":"profile_OfferDetail__Container__o72Vn","JobOfferDetails":"profile_JobOfferDetails__7Znok","JobOfferDetails__Section":"profile_JobOfferDetails__Section__cJG98","JobOfferDetails__Row":"profile_JobOfferDetails__Row__jas_S","JobOfferDetails__LeftCol":"profile_JobOfferDetails__LeftCol__w16n1","JobOfferDetails__RightCol":"profile_JobOfferDetails__RightCol__5WGSw","JobOfferDetails__Label":"profile_JobOfferDetails__Label__RgB6M","JobOfferDetails__Data":"profile_JobOfferDetails__Data__KB1fb","JobOfferDetails__W100":"profile_JobOfferDetails__W100__zNePx","JobOfferDetails__MR20":"profile_JobOfferDetails__MR20__kodMe","Offer":"profile_Offer__krGsG","OfferDetail":"profile_OfferDetail__CME5I","ProgressLineSection":"profile_ProgressLineSection__xtaOW","ProgressLineSection__Container":"profile_ProgressLineSection__Container__NSVHn","ProgressLineSection__AcionSection":"profile_ProgressLineSection__AcionSection__LnbhE","ProgressLineSection__ActionButtons":"profile_ProgressLineSection__ActionButtons__cSe_K","ProgressLineSection__Heading":"profile_ProgressLineSection__Heading__y_Z_o","TopHeaderSection":"profile_TopHeaderSection__PIisV","TopHeaderSection__SpaceBetween":"profile_TopHeaderSection__SpaceBetween__crJCh","AgencyHeading":"profile_AgencyHeading__CW989","StatsSection":"profile_StatsSection__nqeZr","StatsSection__List":"profile_StatsSection__List__vIZd7","StatsSection__NewList":"profile_StatsSection__NewList__43_1A","StatsSection__ListStatus":"profile_StatsSection__ListStatus__LRUU1","StatsSection__NewListStatus":"profile_StatsSection__NewListStatus__o1gnD","StatsSection__Statslist":"profile_StatsSection__Statslist__MHfhq","StatsSection__StatsAnchor":"profile_StatsSection__StatsAnchor__7e8wb","StatsSection__StatsContent":"profile_StatsSection__StatsContent__K0DaM","StatsSection__StatsContentWidth":"profile_StatsSection__StatsContentWidth__BDlf2","StatsSection__StatsNumber":"profile_StatsSection__StatsNumber__HvZyW","StatsSection__StatsNumberWidth":"profile_StatsSection__StatsNumberWidth__hGmqh","StatsSection__Health":"profile_StatsSection__Health__QuPxo","StatsSection__IndigoBg":"profile_StatsSection__IndigoBg__7N6jt","StatsSection__CorelBg":"profile_StatsSection__CorelBg__6NsPm","StatsSection__GreenBg":"profile_StatsSection__GreenBg__iBYWh","StatsSection__RoseBg":"profile_StatsSection__RoseBg__8_mKh","StatsSection__CorelDarkBg":"profile_StatsSection__CorelDarkBg__cAZJm","StatsSection__StatBgOne":"profile_StatsSection__StatBgOne__p4usn","StatsSection__StatBgOne__NoBorder":"profile_StatsSection__StatBgOne__NoBorder__wNeoV","StatsSection__StatBgTwo":"profile_StatsSection__StatBgTwo__aZ1sC","StatsSection__StatBgThree":"profile_StatsSection__StatBgThree___El7r","StatsSection__StatBgFour":"profile_StatsSection__StatBgFour__9BbxZ","NotificationSection":"profile_NotificationSection__ZsiQN","NotificationSection__InterviewListNoHover":"profile_NotificationSection__InterviewListNoHover__t1Fpk","NotificationSection__AlertActivity":"profile_NotificationSection__AlertActivity__fXira","NotificationSection__Alert":"profile_NotificationSection__Alert__WZhHE","NotificationSection__List":"profile_NotificationSection__List__5SG1B","NotificationSection__AlertContainer":"profile_NotificationSection__AlertContainer___vN2Q","NotificationSection__CommunicationContainer":"profile_NotificationSection__CommunicationContainer__yynCj","NotificationSection__AlertActivityContainer":"profile_NotificationSection__AlertActivityContainer__F_UJH","NotificationSection__Schedulingmain":"profile_NotificationSection__Schedulingmain__TEc5V","NotificationSection__More":"profile_NotificationSection__More__v_nBv","NotificationSection__Alertslist":"profile_NotificationSection__Alertslist__uGZY1","NotificationSection__Alertsmessage":"profile_NotificationSection__Alertsmessage__f2dqe","NotificationSection__AlertsTilte":"profile_NotificationSection__AlertsTilte__gQQC9","NotificationSection__AlertHeading":"profile_NotificationSection__AlertHeading__7LSs1","NotificationSection__CalendarHeading":"profile_NotificationSection__CalendarHeading__WWd_0","NotificationSection__Dismiss":"profile_NotificationSection__Dismiss__akXrG","NotificationSection__Communications":"profile_NotificationSection__Communications__9Ra2U","NotificationSection__ProfileCircle":"profile_NotificationSection__ProfileCircle__UyWMK","NotificationSection__SchedulingTiming":"profile_NotificationSection__SchedulingTiming__1qBxV","NotificationSection__TimimgsSection":"profile_NotificationSection__TimimgsSection__o9163","NotificationSection__WeekTiming":"profile_NotificationSection__WeekTiming__5wJ54","NotificationSection__Scheduling":"profile_NotificationSection__Scheduling__BHI4l","NotificationSection__Pagination":"profile_NotificationSection__Pagination__tEuBd","NotificationSection__PaginationButton":"profile_NotificationSection__PaginationButton__nS6Bo","NotificationSection__InterviewListSvg":"profile_NotificationSection__InterviewListSvg__7QB1I","NotificationSection__InterviewListStage":"profile_NotificationSection__InterviewListStage__UEWf4","NotificationSection__InterviewList":"profile_NotificationSection__InterviewList__r9auf","NotificationSection__Interviewtitle":"profile_NotificationSection__Interviewtitle__DcYlF","NotificationSection__InterviewerProfile":"profile_NotificationSection__InterviewerProfile__AFC6P","NotificationSection__InterviewerDate":"profile_NotificationSection__InterviewerDate__AWiO_","NotificationSection__Greybox":"profile_NotificationSection__Greybox__zKuEj","NotificationSection__Tabs":"profile_NotificationSection__Tabs__Nq3IG","React__tabs":"profile_React__tabs__dGdI_","React__tabs__today":"profile_React__tabs__today__y22im","React__tabs__head":"profile_React__tabs__head__PF1dV","React__tabs__tabpanel":"profile_React__tabs__tabpanel__rSCJ8","React__tabs__tablist":"profile_React__tabs__tablist__VxTyq","React__tabs__tablist__tab":"profile_React__tabs__tablist__tab__839s2","React__tabs__interviewtype":"profile_React__tabs__interviewtype__RJ7zz","React__tabs__MyInterview":"profile_React__tabs__MyInterview__Hv3jD","React__tabs__TeamInterview":"profile_React__tabs__TeamInterview__DhoV3","NamePrefix":"profile_NamePrefix__J9p_E","CandidatePrefix":"profile_CandidatePrefix__IdZ53","TopSection":"profile_TopSection__cXjYN","CalendarSelectedDate":"profile_CalendarSelectedDate__O0xXg","TitleFlex":"profile_TitleFlex__O0WRy","JobList__Accordian":"profile_JobList__Accordian__m_87J","JobList__AccordianContent":"profile_JobList__AccordianContent__IfMd_","JobList__SearchSection":"profile_JobList__SearchSection__y4tQc","CandidatesList__SearchSection":"profile_CandidatesList__SearchSection__fXnAs","JobList__FilterMarginBottom":"profile_JobList__FilterMarginBottom__Etja1","JobList__SearchFilter":"profile_JobList__SearchFilter___pzQn","JobList__AppliedSearchFilter":"profile_JobList__AppliedSearchFilter__mtl7I","JobList__SearchFilterFullWidth":"profile_JobList__SearchFilterFullWidth__5Rj2v","JobList__AddJobSection":"profile_JobList__AddJobSection__KecZA","CandidatesList__AddJobSection":"profile_CandidatesList__AddJobSection__VQ20r","JobList__Status":"profile_JobList__Status__X3EJ_","JobList__EditModalContainer":"profile_JobList__EditModalContainer__dInAt","JobList__EditModalMessage":"profile_JobList__EditModalMessage__scvTJ","JobList__EditModalButtonSection":"profile_JobList__EditModalButtonSection__Uv1k3","JobList__CheckLabel":"profile_JobList__CheckLabel__kByei","JobList__Checkbox":"profile_JobList__Checkbox__qu9L5","JobList__JobBoard":"profile_JobList__JobBoard__7RmY8","JobList__Reasons":"profile_JobList__Reasons__A_Jxt","KanbanSearch__Dots":"profile_KanbanSearch__Dots__hr_AS","AgencyDetailForm__Label":"profile_AgencyDetailForm__Label__1vti4","AgencyDetailForm__Data":"profile_AgencyDetailForm__Data__Mw02p","AgencyDetailForm__Actionsection":"profile_AgencyDetailForm__Actionsection__wDAKu","AgencyDetailForm__FormInputSection":"profile_AgencyDetailForm__FormInputSection___1_9P","ApprovalContract":"profile_ApprovalContract__hT8qT","ApprovalContractButtons":"profile_ApprovalContractButtons__upoI5","Form__TableRowBlock":"profile_Form__TableRowBlock__KmNbl","Form__TableCol2":"profile_Form__TableCol2__SjHzC","Form__TableColNormal":"profile_Form__TableColNormal__r5lbg","JobFilter":"profile_JobFilter__uRsXr","JobFilter__Inner":"profile_JobFilter__Inner__XysS6","JobFilter__Head":"profile_JobFilter__Head__CkEee","JobFilter__SubmitSection":"profile_JobFilter__SubmitSection__FPp__","JobFilter__EmailFilterBottom":"profile_JobFilter__EmailFilterBottom___xNfw","CropImage":"profile_CropImage__g6b9V","CropImage__Actions":"profile_CropImage__Actions__6qqSK","CropImage__Inner":"profile_CropImage__Inner__YeJrr","CropImage__Head":"profile_CropImage__Head__m5Qk_","CropImage__SubmitSection":"profile_CropImage__SubmitSection__hbEz1","ModalClose":"profile_ModalClose__My0w_","Form__gap16":"profile_Form__gap16__YDQVT","fontslabel":"profile_fontslabel__Jmxdb","CandidatesList__AgencyFilterSection":"profile_CandidatesList__AgencyFilterSection__JXSJ7","CandidatesList__widthfilter":"profile_CandidatesList__widthfilter__2fUDT","CandidatesList__SearchFilter":"profile_CandidatesList__SearchFilter__X8JW4","CandidatesList__SearchSectionCandidates":"profile_CandidatesList__SearchSectionCandidates__frd6O","CandidatesList__AddCandidatesSection":"profile_CandidatesList__AddCandidatesSection__ej8NJ","DF":"profile_DF__l04fx","dpend":"profile_dpend__71FHj","accountprofile__ProfilePicture":"profile_accountprofile__ProfilePicture__N3w8w","accountprofile":"profile_accountprofile__ljHPJ","Form__BiographyLabel":"profile_Form__BiographyLabel__ungTV","Form__TableRowTwoGrd":"profile_Form__TableRowTwoGrd__ibClb","VideoBiographyContainer":"profile_VideoBiographyContainer__N_n3G","VideoBiographyText":"profile_VideoBiographyText__veNp_","VideoBiographyButton":"profile_VideoBiographyButton__meHM0","AddCandidatesForm":"profile_AddCandidatesForm__8NX18"};

/***/ }),

/***/ 31144:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Form":"kanban_Form__JIKUl","Form__width":"kanban_Form__width__0Hu5_","Form__label":"kanban_Form__label__66Z9f","Form__textleft":"kanban_Form__textleft__iz_qW","Form__InputFullWidth":"kanban_Form__InputFullWidth__ZGu7D","Form__Input":"kanban_Form__Input__nmxPZ","Form__Input398":"kanban_Form__Input398__I97q8","Form__InputSection":"kanban_Form__InputSection__IUafL","Form__ScoreCardInput":"kanban_Form__ScoreCardInput__yt68r","Form__Textarea":"kanban_Form__Textarea__7oEyj","primarybtn":"kanban_primarybtn__d6qwb","JobList__EditModalEditButton":"kanban_JobList__EditModalEditButton__X_PEV","GoBtn":"kanban_GoBtn__wakYM","secondarybtn":"kanban_secondarybtn__qTQbA","JobList__EditModalCancelButton":"kanban_JobList__EditModalCancelButton__X2Eif","iconFilled":"kanban_iconFilled__LCEPb","iconFilledSolid":"kanban_iconFilledSolid__sXWbE","primarybtnborder":"kanban_primarybtnborder__wuOTp","secondarybtnborder":"kanban_secondarybtnborder__i8Gew","ClearBtn":"kanban_ClearBtn__Lnzsm","tertiarybtn":"kanban_tertiarybtn__x5XfI","graybtnborder":"kanban_graybtnborder__Zyhhn","jobsrchbtn":"kanban_jobsrchbtn__3oK1Y","jobsrchbtnalign":"kanban_jobsrchbtnalign__8NuRJ","nobgbutton":"kanban_nobgbutton___SqRe","iconTextButton":"kanban_iconTextButton__JCo1R","cursornone":"kanban_cursornone__crNlt","nobgbuttonprimary":"kanban_nobgbuttonprimary__ZP778","mt15":"kanban_mt15__rGm8M","btn350":"kanban_btn350__fR0eS","GrayBgBtn":"kanban_GrayBgBtn__wgBdj","NewShareBtn":"kanban_NewShareBtn__u30NW","CoralBgBtn":"kanban_CoralBgBtn__Cma3I","DropContainer":"kanban_DropContainer__N7_XS","DropContainer__Inner":"kanban_DropContainer__Inner__B3TBN","CompanyProfile__Inner":"kanban_CompanyProfile__Inner__EYjp4","DropContainer__Message":"kanban_DropContainer__Message__Zeohu","CompanyProfile__Message":"kanban_CompanyProfile__Message__ix5ZD","CompanyProfile__MessageContent":"kanban_CompanyProfile__MessageContent__sUPOM","DropContainer__UploadIcon":"kanban_DropContainer__UploadIcon__cjaj2","CompanyProfile__UploadIcon":"kanban_CompanyProfile__UploadIcon__kmrso","FileDisplayContainer":"kanban_FileDisplayContainer__AjWoL","FileDisplayContainer__Status":"kanban_FileDisplayContainer__Status__sU5jN","SetupPopup__Status":"kanban_SetupPopup__Status__GPaua","SetupPopup__To":"kanban_SetupPopup__To__A80mj","FileDisplayContainer__Type":"kanban_FileDisplayContainer__Type__IvtzF","FileDisplayContainer__Name":"kanban_FileDisplayContainer__Name__osb5K","SetupPopup__Name":"kanban_SetupPopup__Name__ftxkn","SetupPopup__ToName":"kanban_SetupPopup__ToName__AUZXe","FileDisplayContainer__Error":"kanban_FileDisplayContainer__Error__La_5i","FileDisplayContainer__Close":"kanban_FileDisplayContainer__Close__qFw7l","Browse":"kanban_Browse__mITWm","ClientCompany":"kanban_ClientCompany__SIZRH","NewJob":"kanban_NewJob__VyB_c","Interview":"kanban_Interview__RQFHP","ClientCompany__TopSection2":"kanban_ClientCompany__TopSection2__xx0Np","ClientCompany__Filter":"kanban_ClientCompany__Filter__XVLJ1","ClientCompany__Input_MatchScore":"kanban_ClientCompany__Input_MatchScore__v2vDj","ClientCompany__Percentage_Symbol":"kanban_ClientCompany__Percentage_Symbol__P9HA0","ClientCompany__Filterheading":"kanban_ClientCompany__Filterheading__UDelv","ClientCompany__FloatButtonAdd":"kanban_ClientCompany__FloatButtonAdd__tEca8","ClientCompany__FloatButtonAdd__AgencyUserIcon":"kanban_ClientCompany__FloatButtonAdd__AgencyUserIcon__CwBDZ","ClientCompany__LastEdited":"kanban_ClientCompany__LastEdited__1Kb5v","ClientCompany__BackSection":"kanban_ClientCompany__BackSection__mZyoF","AddUsers__BackSection":"kanban_AddUsers__BackSection__B3QrO","ClientCompany__BackSection__CloseIcon":"kanban_ClientCompany__BackSection__CloseIcon__irSJU","ClientCompany__Container":"kanban_ClientCompany__Container__N4szg","NewJob__InterviewContainer":"kanban_NewJob__InterviewContainer__Jo6or","AddUsers__Container":"kanban_AddUsers__Container__RmUre","ClientCompany__FormInputSection":"kanban_ClientCompany__FormInputSection__dxcFf","CompanyProfile__FormInputSection":"kanban_CompanyProfile__FormInputSection__pKKZU","ClientCompany__Heading":"kanban_ClientCompany__Heading___x8tr","Offer__Heading":"kanban_Offer__Heading__WNEUr","AddUsers__Heading":"kanban_AddUsers__Heading__O_Xov","ClientCompany__StatusAlignment":"kanban_ClientCompany__StatusAlignment__pYn8_","ClientCompany__Status":"kanban_ClientCompany__Status__2ebCA","ClientCompany__ActiveDot":"kanban_ClientCompany__ActiveDot__1qWg3","ClientCompany__CloseDot":"kanban_ClientCompany__CloseDot__rB5P7","ClientCompany__Company":"kanban_ClientCompany__Company__YPaph","AddUsers__User":"kanban_AddUsers__User__rLOte","ClientCompany__Systemrefheding":"kanban_ClientCompany__Systemrefheding__XA8Iy","ClientCompany__Subheading":"kanban_ClientCompany__Subheading__DU5E1","CompanyProfile__Subheading":"kanban_CompanyProfile__Subheading__vNAsd","ClientCompany__Subheading2":"kanban_ClientCompany__Subheading2__tUEi7","ClientCompany__Description":"kanban_ClientCompany__Description__Xnlsl","ClientCompany__SubmitSection":"kanban_ClientCompany__SubmitSection__9kQiv","NewJob__SubmitSection":"kanban_NewJob__SubmitSection__YdOgl","NewJob__SubmitSectionThreeBtn":"kanban_NewJob__SubmitSectionThreeBtn__2UDqM","NewJob__SubmitSectionOneBtnPlacement":"kanban_NewJob__SubmitSectionOneBtnPlacement__hKQEd","NewJob__ImportSection":"kanban_NewJob__ImportSection__8aSeF","SetupPopup__SubmitSection2":"kanban_SetupPopup__SubmitSection2__npm_c","SetupPopup__SubmitSection":"kanban_SetupPopup__SubmitSection__4oKs3","SetupPopup__SubmitSection3":"kanban_SetupPopup__SubmitSection3__78jEd","AddUsers__SubmitSection":"kanban_AddUsers__SubmitSection__Ysk0Y","ClientCompany__IntegrationImage":"kanban_ClientCompany__IntegrationImage__NvUCX","ClientCompany__QuickAdd":"kanban_ClientCompany__QuickAdd__HeOO7","NewJob__QuickAdd":"kanban_NewJob__QuickAdd__bJm4Y","JobList__QuickAdd":"kanban_JobList__QuickAdd__3HrwH","Interview__QuickAdd":"kanban_Interview__QuickAdd___Maet","ClientCompany__BodyText":"kanban_ClientCompany__BodyText__4V3Qq","Form__TableRow":"kanban_Form__TableRow__cVpdJ","Form__TableRowTowGrid":"kanban_Form__TableRowTowGrid__n1sKL","Form__TableRowSingle":"kanban_Form__TableRowSingle__EhFL1","Form__Label":"kanban_Form__Label__fBtiz","Form__Data":"kanban_Form__Data__vAwWO","Form__DataSingleRow":"kanban_Form__DataSingleRow__CcgNn","Form__FloatingLabel":"kanban_Form__FloatingLabel__XNcb5","Form__TableCol":"kanban_Form__TableCol__0G4aj","Form__currency_symbol":"kanban_Form__currency_symbol__J83dd","Form__CustomSelect":"kanban_Form__CustomSelect__hD6Oy","Form__currency_symbol__right":"kanban_Form__currency_symbol__right__NYFB1","Form__TableCol__Disabled":"kanban_Form__TableCol__Disabled__DrvrA","Form__TextareaDisabled":"kanban_Form__TextareaDisabled__hd8ZJ","Form__EditorDisabled":"kanban_Form__EditorDisabled__md3gz","Form__AdminCheckLabel":"kanban_Form__AdminCheckLabel__I3jBQ","Form__AdminCheckMargin":"kanban_Form__AdminCheckMargin__tF2PW","CompanyProfile__BrandingGuide":"kanban_CompanyProfile__BrandingGuide__cB_MQ","CompanyProfile__DropBoxContainer":"kanban_CompanyProfile__DropBoxContainer__4459g","CompanyProfile__Browse":"kanban_CompanyProfile__Browse__fLLQk","ErrorLabel":"kanban_ErrorLabel__pzlZU","Height80":"kanban_Height80___7iXS","Browse__ButtonFlexEnd":"kanban_Browse__ButtonFlexEnd__XIsCT","AddAgency__Container":"kanban_AddAgency__Container__9x5O_","AddAgency__FormInputSection":"kanban_AddAgency__FormInputSection__2AqA2","AddAgency__FormInputSection__Label":"kanban_AddAgency__FormInputSection__Label__Eb1AX","AddAgency__Form":"kanban_AddAgency__Form__JNy1j","LinkAsButtons":"kanban_LinkAsButtons__JiuTV","SearchFlex":"kanban_SearchFlex__PqiF1","Form__ErrorCustomSelect":"kanban_Form__ErrorCustomSelect__uF5zd","Form__select_currency":"kanban_Form__select_currency__qXPOc","customSelect__placeholder":"kanban_customSelect__placeholder__H38Y2","Career":"kanban_Career__Df4q9","Career__Background_Edit":"kanban_Career__Background_Edit__4HNYt","Career__Background_Edit_Image":"kanban_Career__Background_Edit_Image__JmlUK","Career__Container":"kanban_Career__Container__E2tZ_","Career__Inner":"kanban_Career__Inner__hRGvg","Career__logo":"kanban_Career__logo__A0MoQ","Career__Content":"kanban_Career__Content__9K1ae","Career__ButtonSection":"kanban_Career__ButtonSection__WkeBx","Job":"kanban_Job__9nhRm","Job__Inner":"kanban_Job__Inner__6oYaw","Job__Container":"kanban_Job__Container__Lm1Nr","Job__Heading":"kanban_Job__Heading__9JAz9","Job__Company":"kanban_Job__Company__M1Kzd","Job__SearchContainer":"kanban_Job__SearchContainer__Eocqp","Job__SearchInput":"kanban_Job__SearchInput__l7IuT","Job__Searchbtn":"kanban_Job__Searchbtn__5fcOR","Job__Input":"kanban_Job__Input__Ws0qD","Job__SelectJob":"kanban_Job__SelectJob__RRV5Q","Job__RemoteLabel":"kanban_Job__RemoteLabel__JnaJ3","Job__Display":"kanban_Job__Display__RMSy3","Job__PostDay":"kanban_Job__PostDay__DdT_U","Job__Title":"kanban_Job__Title__Gtd9H","Job__Location":"kanban_Job__Location__ttxlZ","DT":"kanban_DT__2vahQ","DisplayTable":"kanban_DisplayTable___oInb","pd11":"kanban_pd11__MwBWP","Label":"kanban_Label__xioHX","inputwidth":"kanban_inputwidth__R1F5W","mr24":"kanban_mr24__IUoI7","fullwidth":"kanban_fullwidth__9vIAd","padt40":"kanban_padt40__v4Ayb","Form__TableRowflex":"kanban_Form__TableRowflex__F4bBF","Form__TableColm":"kanban_Form__TableColm__wFbI5","Form__LabelCheck":"kanban_Form__LabelCheck__ohT09","Form__Error":"kanban_Form__Error__Jz3HQ","Form__ErrorSection":"kanban_Form__ErrorSection__Fq7pj","Form__MessagePlaceholder":"kanban_Form__MessagePlaceholder__pjjga","Form__Submit":"kanban_Form__Submit__8KTsD","Form__NormalLabel":"kanban_Form__NormalLabel__Zc13D","AddInterview":"kanban_AddInterview__GApRB","IntegrationPage":"kanban_IntegrationPage__5mmfQ","Integration__BackStep":"kanban_Integration__BackStep__SGixB","AddUsers__BackStep":"kanban_AddUsers__BackStep__U4CtM","Integration__SubmitSection":"kanban_Integration__SubmitSection__q4Wma","IntegrationTable":"kanban_IntegrationTable__1H_Rv","IntegrationTable__LimitInput":"kanban_IntegrationTable__LimitInput__WflRj","IntegrationTable__Type":"kanban_IntegrationTable__Type__JpgNs","IntegrationTable__AllJobsToggle":"kanban_IntegrationTable__AllJobsToggle__MSeLf","IntegrationTable__switch":"kanban_IntegrationTable__switch__bFqkc","IntegrationTable__switchText":"kanban_IntegrationTable__switchText__hiw8M","IntegrationTable__slider":"kanban_IntegrationTable__slider__A17ue","IntegrationTable__round":"kanban_IntegrationTable__round__pz5w6","IntegrationTable__Action":"kanban_IntegrationTable__Action__bBCy3","IntegrationView":"kanban_IntegrationView__zTaIp","IntegrationView__Title":"kanban_IntegrationView__Title__ZSd1p","IntegrationView__Subheading":"kanban_IntegrationView__Subheading__7abf2","IntegrationView__BoxImage":"kanban_IntegrationView__BoxImage__WEnfB","IntegrationView__Box":"kanban_IntegrationView__Box__mrX5J","IntegrationView__BoxImage__InfoIcon":"kanban_IntegrationView__BoxImage__InfoIcon__Rz__w","IntegrationView__ViewMoreButton":"kanban_IntegrationView__ViewMoreButton__iDlxJ","IntegrationView__ConnectButton":"kanban_IntegrationView__ConnectButton__U2RQ2","IntegrationView__GoogleButton":"kanban_IntegrationView__GoogleButton__rklWm","IntegrationView__FlexFlow":"kanban_IntegrationView__FlexFlow__T_h_M","IntegrationView__BoxWidth":"kanban_IntegrationView__BoxWidth__W9XEl","SkipFinishButton":"kanban_SkipFinishButton__jme6J","AddUsers":"kanban_AddUsers__21Odj","AddUsers__ButtonSection":"kanban_AddUsers__ButtonSection__4_w7s","AddUsers__QuickStepHeading":"kanban_AddUsers__QuickStepHeading__T_xlx","AddUsers__DeleteSection":"kanban_AddUsers__DeleteSection__6dIT4","Interview__DeleteSection":"kanban_Interview__DeleteSection__SMfNv","AddUsers__DeleteCrossHeight":"kanban_AddUsers__DeleteCrossHeight__9wMNm","AddUsers__Form__Input":"kanban_AddUsers__Form__Input__IbLO5","AddUsers__FormHeadingSection":"kanban_AddUsers__FormHeadingSection__IPA_S","Interview__FormHeadingSection":"kanban_Interview__FormHeadingSection__njvhl","AddUsers__FormSection":"kanban_AddUsers__FormSection__t816I","NewJob__FormSection":"kanban_NewJob__FormSection__3s3Ef","AddUsers__ButtonsActionSection":"kanban_AddUsers__ButtonsActionSection__pmJWU","AddUsers__ImportUsers":"kanban_AddUsers__ImportUsers__UeW34","AddUsers__NameInput":"kanban_AddUsers__NameInput__FFKJo","AddUsers__EmailInput":"kanban_AddUsers__EmailInput__VZZsx","AddUsers__RoleInput":"kanban_AddUsers__RoleInput__FErFi","AddUsers__Subheading":"kanban_AddUsers__Subheading__tRE8d","AddUsers__visible":"kanban_AddUsers__visible__klMen","Tagrow":"kanban_Tagrow__orBXc","Tagrow__Tags":"kanban_Tagrow__Tags__QfBTF","SetupPopup__Tags":"kanban_SetupPopup__Tags__vH0jM","Tagrow__Cancel":"kanban_Tagrow__Cancel__JBtjo","Tagrow__Cross":"kanban_Tagrow__Cross__XztJh","SendInviteSection":"kanban_SendInviteSection__vREUZ","error":"kanban_error__EwlXP","ViewJobPage__Input":"kanban_ViewJobPage__Input__5H6Gp","Form__Input2":"kanban_Form__Input2__GMvmf","ViewJobPage__PostDay":"kanban_ViewJobPage__PostDay__TVHv6","ViewJobPage__Title":"kanban_ViewJobPage__Title__0LSFE","ViewJobPage__DescriptionTitle":"kanban_ViewJobPage__DescriptionTitle__DBkj9","ViewJobPage__Location":"kanban_ViewJobPage__Location__QCWge","ViewJobPage__primarybtn":"kanban_ViewJobPage__primarybtn__vJUgM","ViewJobPage__secondarybtn":"kanban_ViewJobPage__secondarybtn__tosmH","ViewJobPage__secondarybtnborder":"kanban_ViewJobPage__secondarybtnborder__gppat","ViewJobPage__BackSection":"kanban_ViewJobPage__BackSection__XpR8g","Modalpopup":"kanban_Modalpopup__BVaO9","Modalpopup__inner":"kanban_Modalpopup__inner__cvKwz","Modalpopup__Dialog":"kanban_Modalpopup__Dialog__wecRh","transition":"kanban_transition__BMFTe","Modalpopup__CloseCenter":"kanban_Modalpopup__CloseCenter__6MUbc","Modalpopup__Content":"kanban_Modalpopup__Content__IoEHh","SetupPopup__PaddingPopup":"kanban_SetupPopup__PaddingPopup__r80wB","SetupPopup__ContentCustomisation":"kanban_SetupPopup__ContentCustomisation__y0V_s","SetupPopup__Contentwithoutpadding":"kanban_SetupPopup__Contentwithoutpadding__o5vqA","ViewJobPage__Content":"kanban_ViewJobPage__Content__xQzdI","Modalpopup__btn":"kanban_Modalpopup__btn__mFzuI","mar":"kanban_mar__NKqnB","Otpback":"kanban_Otpback__5WqT4","ViewJobPage":"kanban_ViewJobPage__LwyTK","ViewJobPage__Header":"kanban_ViewJobPage__Header__Ag7S1","ViewJobPage__Application":"kanban_ViewJobPage__Application__IFUhk","ViewJobPage__RecordVideo":"kanban_ViewJobPage__RecordVideo__hIWk9","ViewJobPage__RecordVideoSuccessText":"kanban_ViewJobPage__RecordVideoSuccessText__uGxDp","ViewJobPage__subheading":"kanban_ViewJobPage__subheading__eZ3uo","ViewJobPage__confirmation":"kanban_ViewJobPage__confirmation__s_dDz","ViewJobPage__Logo":"kanban_ViewJobPage__Logo__TVtgw","ViewJobPage__BrandLogo":"kanban_ViewJobPage__BrandLogo__1YXbh","ViewJobPage__BrandLogo__Padding10":"kanban_ViewJobPage__BrandLogo__Padding10__uXpQe","ViewJobPage__Container":"kanban_ViewJobPage__Container__vPN05","ViewJobPage__JobContent":"kanban_ViewJobPage__JobContent__sPX4y","ViewJobPage__Sidebar":"kanban_ViewJobPage__Sidebar__oCjZr","ViewJobPage__Sidebar2":"kanban_ViewJobPage__Sidebar2__YwGsD","ViewJobPage__Description":"kanban_ViewJobPage__Description__0EG8A","ViewJobPage__DescriptionWidth":"kanban_ViewJobPage__DescriptionWidth__SbSQZ","ViewJobPage__Footer":"kanban_ViewJobPage__Footer__pY56W","ViewJobPage__FooterView":"kanban_ViewJobPage__FooterView__8_8gu","ViewJobPage__ShareJob":"kanban_ViewJobPage__ShareJob__PRwGD","ViewJobPage__SubmitSection":"kanban_ViewJobPage__SubmitSection__PZOVA","ViewJobPage__SocialMedia":"kanban_ViewJobPage__SocialMedia__PoHfN","ViewJobPage__SideContent":"kanban_ViewJobPage__SideContent__CT_8M","ViewJobPage__ApplySection":"kanban_ViewJobPage__ApplySection__vMWOs","FormBox__Autofill":"kanban_FormBox__Autofill__RnfHy","applybuttons":"kanban_applybuttons___Qre9","height90":"kanban_height90__kQWi_","Form__Cont":"kanban_Form__Cont__G77pV","Form__DropBox":"kanban_Form__DropBox__b_aVD","Form__DropBoxcontainer":"kanban_Form__DropBoxcontainer__Cghyn","Form__DropBoxError":"kanban_Form__DropBoxError__MNs8F","Form__DropBoxicon":"kanban_Form__DropBoxicon__O4FbO","Form__DropBoxmessage":"kanban_Form__DropBoxmessage__m34vX","noDpGrid":"kanban_noDpGrid__oA7uT","Terms":"kanban_Terms__DMHBq","TermsCondition":"kanban_TermsCondition__zquwq","TermsCondition__alignterms":"kanban_TermsCondition__alignterms__9AOTI","MenuContainer":"kanban_MenuContainer__HcGfL","MenuContainer__Menu":"kanban_MenuContainer__Menu__uw0p7","AgencyDetailPage":"kanban_AgencyDetailPage__FuGk4","Congrats__ModalContent":"kanban_Congrats__ModalContent__Wauiv","JobList__SearchBox":"kanban_JobList__SearchBox__LplUh","KanbanSearch__SearchBox":"kanban_KanbanSearch__SearchBox__b0PZj","NewJob__Container":"kanban_NewJob__Container__dTNt2","NewJob__TopSection":"kanban_NewJob__TopSection__MrsbS","JobList__TopSection":"kanban_JobList__TopSection__IV8Z_","Interview__TopSection":"kanban_Interview__TopSection__OBoQj","NewJob__HorizontalDivider":"kanban_NewJob__HorizontalDivider__UiLbm","NewJob__Wrapper":"kanban_NewJob__Wrapper__sLOGh","NewJob__ContainerPadding":"kanban_NewJob__ContainerPadding__p5epK","NewJob__ContainerScroll":"kanban_NewJob__ContainerScroll__q5g9g","NewJob__ContainerHeight":"kanban_NewJob__ContainerHeight__RKJG5","NewJob__ImportAction":"kanban_NewJob__ImportAction__HGQMw","NewJob__Interview_buttons":"kanban_NewJob__Interview_buttons__gHp5_","Form__TableRowMB":"kanban_Form__TableRowMB__fbtab","Form__TableRow3grid":"kanban_Form__TableRow3grid__jw8YH","Form__Remotegrid":"kanban_Form__Remotegrid__xkmjr","Form__TypeList":"kanban_Form__TypeList__mnQqq","Form__Type":"kanban_Form__Type__2vnks","Form__CheckLabel":"kanban_Form__CheckLabel__NtHLH","PrivateSwitchBase-root-1":"kanban_PrivateSwitchBase-root-1__q6hqV","Form__Caption":"kanban_Form__Caption__4jCjx","Form__Input_currency":"kanban_Form__Input_currency__h0SnG","Form__Input_MatchScore":"kanban_Form__Input_MatchScore__sxjPA","Form__Percentage_Symbol":"kanban_Form__Percentage_Symbol__9zpCK","Form__NoGridTemplate":"kanban_Form__NoGridTemplate__Ujsru","active":"kanban_active__IBpKc","mt10":"kanban_mt10__bUrUK","mt40":"kanban_mt40__UwHTW","mt30":"kanban_mt30__uaJaq","mt32":"kanban_mt32__5Xu9t","mb0":"kanban_mb0__PWj7n","Dpgrid":"kanban_Dpgrid__xQw3D","mb12":"kanban_mb12__sIf1j","width100":"kanban_width100__uQ6jI","Tagrow__Prefix":"kanban_Tagrow__Prefix__POhwb","PreviewJobPage":"kanban_PreviewJobPage__7Ym5n","PreviewJob":"kanban_PreviewJob__RoAXS","DpFlx":"kanban_DpFlx__hJJUV","Subheading":"kanban_Subheading__GVLZp","Subheading__Description":"kanban_Subheading__Description__34Za9","Candidate__Tooltip":"kanban_Candidate__Tooltip__qlf7u","Candidate__Tooltip__Score":"kanban_Candidate__Tooltip__Score__jvHTj","Form__InputField":"kanban_Form__InputField__nVfNV","Candidate__Length":"kanban_Candidate__Length__dxgOn","Agency__PostDay":"kanban_Agency__PostDay__ODbLI","Agency__Title":"kanban_Agency__Title__LFWUK","Agency__Location":"kanban_Agency__Location__oHXrl","Agency__DescriptionTitle":"kanban_Agency__DescriptionTitle__4yjsQ","Agency__Description":"kanban_Agency__Description__hOPXB","LightBlueColor":"kanban_LightBlueColor__Bk2nP","AgencyDetailForm":"kanban_AgencyDetailForm__aSsvi","Client_Page":"kanban_Client_Page__Qi0Ri","Welcome":"kanban_Welcome__Kdu1c","Welcome__Inner":"kanban_Welcome__Inner__hjXRM","Welcome__Person":"kanban_Welcome__Person__xnhpE","Welcome__LeftContent":"kanban_Welcome__LeftContent__WSOjy","Welcome__RightContent":"kanban_Welcome__RightContent__jvrVG","Welcome__Content":"kanban_Welcome__Content__QkArU","Welcome__CreateAccount":"kanban_Welcome__CreateAccount__VmZwA","Welcome__title":"kanban_Welcome__title__CLJA3","Welcome__FormBox":"kanban_Welcome__FormBox__F9P8q","Form__psw":"kanban_Form__psw__gJPLx","Welcome__Container":"kanban_Welcome__Container__yeSsn","Success__Container":"kanban_Success__Container__pU2ma","Success":"kanban_Success__CojOj","Success__Inner":"kanban_Success__Inner__APOkq","InterviewContainer":"kanban_InterviewContainer__OSpL8","Interview__Stages":"kanban_Interview__Stages__qzVsr","Interview__StageHeading":"kanban_Interview__StageHeading__HaDUY","pl10":"kanban_pl10__72PMV","Interview__AddStageSection":"kanban_Interview__AddStageSection__5_f1W","Interview__Label":"kanban_Interview__Label__8NNqH","Interview__FormRowHeading":"kanban_Interview__FormRowHeading__QZvPp","dpflex":"kanban_dpflex__eGjLn","Interview__IconsType":"kanban_Interview__IconsType__q7fzB","Interview__Icons":"kanban_Interview__Icons__i2v0l","Interview__Interview_buttons":"kanban_Interview__Interview_buttons__I3jpf","Interview__approvalButton":"kanban_Interview__approvalButton__52IPd","Interview__BestMatch":"kanban_Interview__BestMatch__Y3i6n","Interview__BestMatchExclamation":"kanban_Interview__BestMatchExclamation__hewd3","DragAndDrop":"kanban_DragAndDrop__sFdbw","DragAndDrop__CursorHandle":"kanban_DragAndDrop__CursorHandle__byJDb","Tagrow__Image":"kanban_Tagrow__Image__Y8i_G","rowbglight":"kanban_rowbglight__owgxf","rowbgheight":"kanban_rowbgheight__PaotP","Form__w90":"kanban_Form__w90__WkcE_","Container":"kanban_Container__j1Hek","Screening__StageName":"kanban_Screening__StageName__7vKVX","Screening__InterviewType":"kanban_Screening__InterviewType__DB481","Screening__InterviewType__Label":"kanban_Screening__InterviewType__Label__2y3E1","Show_Infoicon":"kanban_Show_Infoicon__1CxiQ","Show_Infoicon_small":"kanban_Show_Infoicon_small__xbe_6","Screening__Info":"kanban_Screening__Info__qH5Yg","Screening__Info__IconWithText":"kanban_Screening__Info__IconWithText__jNEma","InterviewType__Icon":"kanban_InterviewType__Icon__Mwt4Z","InterviewType__Text":"kanban_InterviewType__Text___Mehb","LoginModal":"kanban_LoginModal__Th5sT","Logincontent":"kanban_Logincontent__MZA0f","Logincontent__title":"kanban_Logincontent__title__FUb_o","Modalbg":"kanban_Modalbg__CHTvP","Modalnobg":"kanban_Modalnobg__NQ5TD","Form__Container":"kanban_Form__Container__yFWOi","Form__success":"kanban_Form__success__WFPZM","Form__error":"kanban_Form__error__hRmQk","Form__CheckLabeltext":"kanban_Form__CheckLabeltext__lq4eA","Form__TextLeft":"kanban_Form__TextLeft__NO48D","Backsection":"kanban_Backsection__dLopz","back":"kanban_back__8E85e","mlr0":"kanban_mlr0__pExJH","TwoButtons":"kanban_TwoButtons__0r5HM","OtpBacksection":"kanban_OtpBacksection__oNfz9","SetupPopup":"kanban_SetupPopup__U_nCr","JobList__EditModal":"kanban_JobList__EditModal__jYL68","SetupPopup__inner":"kanban_SetupPopup__inner__0B51R","SetupPopup__Dialog":"kanban_SetupPopup__Dialog__Iz_V_","SetupPopup__AddFile":"kanban_SetupPopup__AddFile__W_XGs","SetupPopup__OptionalText":"kanban_SetupPopup__OptionalText__cGevo","SetupPopup__RequestAccessBtn":"kanban_SetupPopup__RequestAccessBtn__k_LuZ","SetupPopup__InternalSection":"kanban_SetupPopup__InternalSection__2qKEf","SetupPopup__ContentInnerRow":"kanban_SetupPopup__ContentInnerRow__YAYHy","SetupPopup__ToChips":"kanban_SetupPopup__ToChips__yX_UY","SetupPopup__AttachmentContainer":"kanban_SetupPopup__AttachmentContainer__bAlfL","SetupPopup__ContentInnerCol":"kanban_SetupPopup__ContentInnerCol__UvBf8","SetupPopup__grid":"kanban_SetupPopup__grid__6Bfi0","SetupPopup__Footer":"kanban_SetupPopup__Footer__ZHzZi","SetupPopup__FooterNew":"kanban_SetupPopup__FooterNew__jgXFv","SetupPopup__Footer2":"kanban_SetupPopup__Footer2__LEBgm","SetupPopup__Footer3":"kanban_SetupPopup__Footer3__twYv4","SetupPopup__Footerassess":"kanban_SetupPopup__Footerassess__SV_AJ","SetupPopup__Footertechtest":"kanban_SetupPopup__Footertechtest__GAMPA","SetupPopup__AutommationFooter":"kanban_SetupPopup__AutommationFooter__DqP9x","SetupPopup__MannualFooter":"kanban_SetupPopup__MannualFooter__xgL25","SetupPopup__MannualInnerSection":"kanban_SetupPopup__MannualInnerSection__SsxC_","SetupPopup__Content":"kanban_SetupPopup__Content__lttDx","SetupPopup__Content__Radiobtn":"kanban_SetupPopup__Content__Radiobtn__OVqvM","SetupPopup__AutomationToggle":"kanban_SetupPopup__AutomationToggle__279iO","SetupPopup__SetupVideoQa":"kanban_SetupPopup__SetupVideoQa__ZT5XX","SetupPopup__SetupVideoQa2":"kanban_SetupPopup__SetupVideoQa2__2zF2M","SetupPopup__SetupVideoQa3":"kanban_SetupPopup__SetupVideoQa3__NARcJ","SetupPopup__SetupVideoQa4":"kanban_SetupPopup__SetupVideoQa4__rKBkf","SetupPopup__InputQA":"kanban_SetupPopup__InputQA__JMuX4","SetupPopup__AddQuestion":"kanban_SetupPopup__AddQuestion__ZwTlo","SetupPopup__QuestionSection":"kanban_SetupPopup__QuestionSection__xYvtw","SetupPopup__PushTop":"kanban_SetupPopup__PushTop__M4qkX","SetupPopup__Contentpading":"kanban_SetupPopup__Contentpading__DqGFW","SetupPopup__QuesionSectionpading":"kanban_SetupPopup__QuesionSectionpading__Y89f_","SetupPopup__Contentcenter":"kanban_SetupPopup__Contentcenter__EKcdn","SetupPopup__PopDetails":"kanban_SetupPopup__PopDetails__32Ulc","SetupPopup__PopDetails__FS16":"kanban_SetupPopup__PopDetails__FS16__kRW5R","SetupPopup__Details":"kanban_SetupPopup__Details__mcnkM","SetupPopup__PrivacyPolicyDetails":"kanban_SetupPopup__PrivacyPolicyDetails___cKHn","SetupPopup__Reason":"kanban_SetupPopup__Reason__lJ020","SetupPopup__ContentBlock":"kanban_SetupPopup__ContentBlock__OSS7U","SetupPopup__Purpose":"kanban_SetupPopup__Purpose__QSgIz","SetupPopup__ContentGridsec":"kanban_SetupPopup__ContentGridsec__P0RGt","mt25":"kanban_mt25__7cOzc","mt20":"kanban_mt20__zUJ1T","SetupPopup__ContentGridTech":"kanban_SetupPopup__ContentGridTech__qhhT1","SetupPopup__Assesmentsection":"kanban_SetupPopup__Assesmentsection__chR3N","SetupPopup__AssesmentsectionNew":"kanban_SetupPopup__AssesmentsectionNew__0T_B8","SetupPopup__MannualChips":"kanban_SetupPopup__MannualChips__2wWyH","SetupPopup__ContentGridManuaCol":"kanban_SetupPopup__ContentGridManuaCol__Vbdmr","SetupPopup__ContentGridManual":"kanban_SetupPopup__ContentGridManual__PJmtP","SetupPopup__ContentBlockPhone":"kanban_SetupPopup__ContentBlockPhone___O_2V","SetupPopup__ContentAddInterview":"kanban_SetupPopup__ContentAddInterview__NG591","SetupPopup__ContentGridPhone":"kanban_SetupPopup__ContentGridPhone__byxf5","SetupPopup__ContentGridStatus":"kanban_SetupPopup__ContentGridStatus__ZqpPa","SetupPopup__GridActions":"kanban_SetupPopup__GridActions___aKcF","SetupPopup__GridActionCoral":"kanban_SetupPopup__GridActionCoral__J_wgg","SetupPopup__GridActionIndigo":"kanban_SetupPopup__GridActionIndigo__IF_mh","SetupPopup__ContentGrid":"kanban_SetupPopup__ContentGrid__Coh_q","SetupPopup__SubmitSectionSave":"kanban_SetupPopup__SubmitSectionSave__bEXEP","SetupPopup__SubmitSectionReset":"kanban_SetupPopup__SubmitSectionReset__gKuzx","SetupPopup__SubmitSectionAutomation":"kanban_SetupPopup__SubmitSectionAutomation__tr2En","SetupPopup__Duration":"kanban_SetupPopup__Duration__ckxBG","SetupPopup__DeleteIcon":"kanban_SetupPopup__DeleteIcon___Gn7l","SetupPopup__ContentCustomisationManualInterview":"kanban_SetupPopup__ContentCustomisationManualInterview__e5tc4","mt0":"kanban_mt0__8myIB","mtb25":"kanban_mtb25__4Wugw","mb15":"kanban_mb15__6QDPx","mb30":"kanban_mb30__U_H_p","mt9":"kanban_mt9__awZ38","lineheight0":"kanban_lineheight0__ToMGR","PopupHeightSection":"kanban_PopupHeightSection__ekNRL","AssessPopupHeightSection":"kanban_AssessPopupHeightSection__6_Fya","Statusopupheight":"kanban_Statusopupheight__Fm5J4","buttonIn":"kanban_buttonIn___IDCh","MessagePlaceholder":"kanban_MessagePlaceholder___cifA","m0":"kanban_m0__mDGR9","mt18":"kanban_mt18__GYn3y","DPgrid":"kanban_DPgrid___ZqC7","addbtnposition":"kanban_addbtnposition___e7F_","mainformdiv":"kanban_mainformdiv__FCSje","crossflex":"kanban_crossflex__oI_NW","crossimgheight":"kanban_crossimgheight__siIoQ","crossimgheight48":"kanban_crossimgheight48__ZdUgb","SetupModalPopup":"kanban_SetupModalPopup__saf_a","SetupModalPopup__Dialog":"kanban_SetupModalPopup__Dialog__d_dUM","SetupPopupoverlay":"kanban_SetupPopupoverlay__CkHlt","NeedHelp":"kanban_NeedHelp__5apMf","uploadNewTest":"kanban_uploadNewTest___KMQW","SetupPopup__ol":"kanban_SetupPopup__ol__wwhMt","Threshold__Content":"kanban_Threshold__Content__AT5BN","SetupPopup__ContentGridPhone__Content":"kanban_SetupPopup__ContentGridPhone__Content__MSiNI","JobList__EditModalInner":"kanban_JobList__EditModalInner__K2tja","Popupheight":"kanban_Popupheight__sqqHk","CandidateBulkActionSection":"kanban_CandidateBulkActionSection__kouW0","KanbanBulkActionSection":"kanban_KanbanBulkActionSection__mjlh_","KanbanBulkActionSection__Progress":"kanban_KanbanBulkActionSection__Progress__M79q0","KanbanBulkActionSection__Message":"kanban_KanbanBulkActionSection__Message__SBNxx","Heading":"kanban_Heading__jOnw_","Offer__Container":"kanban_Offer__Container__YqARU","Offer__DetailsSection":"kanban_Offer__DetailsSection__IBq4J","Offer__NoMarginTop":"kanban_Offer__NoMarginTop__bgkN1","Offer__Mt20":"kanban_Offer__Mt20__5AEeo","Form__OfferSubmit":"kanban_Form__OfferSubmit__60NNd","Error":"kanban_Error__33TM8","SignContract":"kanban_SignContract__XeLlq","SignContract__Container":"kanban_SignContract__Container__V4kki","SignContract__Button":"kanban_SignContract__Button__0erhA","SignContract__Header":"kanban_SignContract__Header__jUesm","SignContract__Page":"kanban_SignContract__Page__Mv36X","SignContract__Logo":"kanban_SignContract__Logo__Vzj6Z","SignContract__Main":"kanban_SignContract__Main__q7ch7","OfferDetail__Container":"kanban_OfferDetail__Container__Dkmdv","JobOfferDetails":"kanban_JobOfferDetails__jrP6B","JobOfferDetails__Section":"kanban_JobOfferDetails__Section__zy0tK","JobOfferDetails__Row":"kanban_JobOfferDetails__Row__AQ1Jo","JobOfferDetails__LeftCol":"kanban_JobOfferDetails__LeftCol__n7dyL","JobOfferDetails__RightCol":"kanban_JobOfferDetails__RightCol__F2z1V","JobOfferDetails__Label":"kanban_JobOfferDetails__Label__zyCmC","JobOfferDetails__Data":"kanban_JobOfferDetails__Data__JhrtH","JobOfferDetails__W100":"kanban_JobOfferDetails__W100___hKR_","JobOfferDetails__MR20":"kanban_JobOfferDetails__MR20__960qf","Offer":"kanban_Offer__lCLLu","OfferDetail":"kanban_OfferDetail__ybJEX","ProgressLineSection":"kanban_ProgressLineSection__mndZZ","ProgressLineSection__Container":"kanban_ProgressLineSection__Container__SsHAE","ProgressLineSection__AcionSection":"kanban_ProgressLineSection__AcionSection__a4eMD","ProgressLineSection__ActionButtons":"kanban_ProgressLineSection__ActionButtons__AygH8","ProgressLineSection__Heading":"kanban_ProgressLineSection__Heading__k4Dj0","TopHeaderSection":"kanban_TopHeaderSection__bGaWQ","TopHeaderSection__SpaceBetween":"kanban_TopHeaderSection__SpaceBetween__EFIbO","AgencyHeading":"kanban_AgencyHeading__FyEm4","StatsSection":"kanban_StatsSection__r88Gs","StatsSection__List":"kanban_StatsSection__List__rbpS2","StatsSection__NewList":"kanban_StatsSection__NewList__PB8_R","StatsSection__ListStatus":"kanban_StatsSection__ListStatus__0dX8d","StatsSection__NewListStatus":"kanban_StatsSection__NewListStatus__dVMMM","StatsSection__Statslist":"kanban_StatsSection__Statslist__Gs15e","StatsSection__StatsAnchor":"kanban_StatsSection__StatsAnchor__RfqM8","StatsSection__StatsContent":"kanban_StatsSection__StatsContent__1UBE_","StatsSection__StatsContentWidth":"kanban_StatsSection__StatsContentWidth__dwfaJ","StatsSection__StatsNumber":"kanban_StatsSection__StatsNumber__ySnGy","StatsSection__StatsNumberWidth":"kanban_StatsSection__StatsNumberWidth__P_LQT","StatsSection__Health":"kanban_StatsSection__Health__LXppD","StatsSection__IndigoBg":"kanban_StatsSection__IndigoBg__xK2s8","StatsSection__CorelBg":"kanban_StatsSection__CorelBg__LdqNp","StatsSection__GreenBg":"kanban_StatsSection__GreenBg__RRk51","StatsSection__RoseBg":"kanban_StatsSection__RoseBg__D7N9b","StatsSection__CorelDarkBg":"kanban_StatsSection__CorelDarkBg__CjkKx","StatsSection__StatBgOne":"kanban_StatsSection__StatBgOne__L0wft","StatsSection__StatBgOne__NoBorder":"kanban_StatsSection__StatBgOne__NoBorder__jfYF5","StatsSection__StatBgTwo":"kanban_StatsSection__StatBgTwo__FcOii","StatsSection__StatBgThree":"kanban_StatsSection__StatBgThree__R55CN","StatsSection__StatBgFour":"kanban_StatsSection__StatBgFour__gqf4_","NotificationSection":"kanban_NotificationSection___7rFj","NotificationSection__InterviewListNoHover":"kanban_NotificationSection__InterviewListNoHover___Pk9m","NotificationSection__AlertActivity":"kanban_NotificationSection__AlertActivity__Oc1jr","NotificationSection__Alert":"kanban_NotificationSection__Alert__ZhbMc","NotificationSection__List":"kanban_NotificationSection__List__Fg4rX","NotificationSection__AlertContainer":"kanban_NotificationSection__AlertContainer__LH1oU","NotificationSection__CommunicationContainer":"kanban_NotificationSection__CommunicationContainer__BNiim","NotificationSection__AlertActivityContainer":"kanban_NotificationSection__AlertActivityContainer__eh31f","NotificationSection__Schedulingmain":"kanban_NotificationSection__Schedulingmain__3_Mqs","NotificationSection__More":"kanban_NotificationSection__More__4cHs8","NotificationSection__Alertslist":"kanban_NotificationSection__Alertslist__i7GkH","NotificationSection__Alertsmessage":"kanban_NotificationSection__Alertsmessage__7IB4e","NotificationSection__AlertsTilte":"kanban_NotificationSection__AlertsTilte__4WWls","NotificationSection__AlertHeading":"kanban_NotificationSection__AlertHeading__KA_CB","NotificationSection__CalendarHeading":"kanban_NotificationSection__CalendarHeading__UGJqQ","NotificationSection__Dismiss":"kanban_NotificationSection__Dismiss__hH5dL","NotificationSection__Communications":"kanban_NotificationSection__Communications__qLyhA","NotificationSection__ProfileCircle":"kanban_NotificationSection__ProfileCircle__y8er3","NotificationSection__SchedulingTiming":"kanban_NotificationSection__SchedulingTiming__ptNxF","NotificationSection__TimimgsSection":"kanban_NotificationSection__TimimgsSection__xj_st","NotificationSection__WeekTiming":"kanban_NotificationSection__WeekTiming__B_0PI","NotificationSection__Scheduling":"kanban_NotificationSection__Scheduling__e09vb","NotificationSection__Pagination":"kanban_NotificationSection__Pagination__Cx4XU","NotificationSection__PaginationButton":"kanban_NotificationSection__PaginationButton__SZrJs","NotificationSection__InterviewListSvg":"kanban_NotificationSection__InterviewListSvg___OvtB","NotificationSection__InterviewListStage":"kanban_NotificationSection__InterviewListStage__ojOan","NotificationSection__InterviewList":"kanban_NotificationSection__InterviewList__hxDtp","NotificationSection__Interviewtitle":"kanban_NotificationSection__Interviewtitle__oV8Lc","NotificationSection__InterviewerProfile":"kanban_NotificationSection__InterviewerProfile__Zcaoy","NotificationSection__InterviewerDate":"kanban_NotificationSection__InterviewerDate__E4iy4","NotificationSection__Greybox":"kanban_NotificationSection__Greybox__qT_dG","NotificationSection__Tabs":"kanban_NotificationSection__Tabs__T9iE_","React__tabs":"kanban_React__tabs__jM_XO","React__tabs__today":"kanban_React__tabs__today__wURL2","React__tabs__head":"kanban_React__tabs__head__7sK1K","React__tabs__tabpanel":"kanban_React__tabs__tabpanel__SqSGX","React__tabs__tablist":"kanban_React__tabs__tablist__eFSoz","React__tabs__tablist__tab":"kanban_React__tabs__tablist__tab__eTG_v","React__tabs__interviewtype":"kanban_React__tabs__interviewtype__Mg5cC","React__tabs__MyInterview":"kanban_React__tabs__MyInterview__iTC6S","React__tabs__TeamInterview":"kanban_React__tabs__TeamInterview__o6EcH","NamePrefix":"kanban_NamePrefix__nkic5","CandidatePrefix":"kanban_CandidatePrefix__TYrtk","TopSection":"kanban_TopSection__eryJI","CalendarSelectedDate":"kanban_CalendarSelectedDate__IqebR","TitleFlex":"kanban_TitleFlex__2ioty","JobList__Accordian":"kanban_JobList__Accordian__6nzlk","JobList__AccordianContent":"kanban_JobList__AccordianContent__hCNh2","JobList__SearchSection":"kanban_JobList__SearchSection__ga_A7","KanbanSearch__SearchSection":"kanban_KanbanSearch__SearchSection__t_YcV","JobList__FilterMarginBottom":"kanban_JobList__FilterMarginBottom__Rs_5o","JobList__SearchFilter":"kanban_JobList__SearchFilter__39svG","JobList__AppliedSearchFilter":"kanban_JobList__AppliedSearchFilter__bCGWR","JobList__SearchFilterFullWidth":"kanban_JobList__SearchFilterFullWidth__iAsH_","JobList__AddJobSection":"kanban_JobList__AddJobSection__fkoy_","JobList__Status":"kanban_JobList__Status__BjvW8","JobList__EditModalContainer":"kanban_JobList__EditModalContainer__kd6b5","JobList__EditModalMessage":"kanban_JobList__EditModalMessage__fjOm0","JobList__EditModalButtonSection":"kanban_JobList__EditModalButtonSection__GrvII","JobList__CheckLabel":"kanban_JobList__CheckLabel__Ev1Xf","JobList__Checkbox":"kanban_JobList__Checkbox__jbSfe","JobList__JobBoard":"kanban_JobList__JobBoard__lpeDM","JobList__Reasons":"kanban_JobList__Reasons__QtrzJ","KanbanSearch__Dots":"kanban_KanbanSearch__Dots__RNA9t","AgencyDetailForm__Label":"kanban_AgencyDetailForm__Label__L7NSs","AgencyDetailForm__Data":"kanban_AgencyDetailForm__Data__m0IYR","AgencyDetailForm__Actionsection":"kanban_AgencyDetailForm__Actionsection__QDDMb","AgencyDetailForm__FormInputSection":"kanban_AgencyDetailForm__FormInputSection__5dlMD","ApprovalContract":"kanban_ApprovalContract__EdMeQ","ApprovalContractButtons":"kanban_ApprovalContractButtons__gReK8","CardBox":"kanban_CardBox__7d0lO","CardBox__Status":"kanban_CardBox__Status__hwuSI","CardBox__Status2":"kanban_CardBox__Status2__VavFe","CardBox__CompanyImage":"kanban_CardBox__CompanyImage__fb74x","CardBox__CheckContainer":"kanban_CardBox__CheckContainer__bz_zq","CardBox__CheckMark":"kanban_CardBox__CheckMark__8QaPj","CardBox__CheckMark__Alignment":"kanban_CardBox__CheckMark__Alignment__GtkvT","CardBox__NameWithoutWarning":"kanban_CardBox__NameWithoutWarning__8bE2W","CardBox__Name":"kanban_CardBox__Name__cQvqh","CardBox__WarningIcon":"kanban_CardBox__WarningIcon__sP_KX","CardBox__Label":"kanban_CardBox__Label__f__I_","CardBox__ScoreSection":"kanban_CardBox__ScoreSection__XLr_t","CardBox__ScoreBlue":"kanban_CardBox__ScoreBlue__QUDs_","CardBox__ScoreRed":"kanban_CardBox__ScoreRed__f2v4i","CardBox__ScoreSectionCursor":"kanban_CardBox__ScoreSectionCursor__XBFSp","CardBox__DetailSection":"kanban_CardBox__DetailSection__m_k7S","CardBox__Details":"kanban_CardBox__Details__L_4mk","CardBox__Alignment":"kanban_CardBox__Alignment__rtLSY","CardBoxHeight":"kanban_CardBoxHeight__Zm4Ja","LaneHeader":"kanban_LaneHeader__ZbSVF","LaneHeader__Heading":"kanban_LaneHeader__Heading__1Z4eK","LaneHeader__Heading__Vertical":"kanban_LaneHeader__Heading__Vertical__CGuqa","Kanban__UserIcon":"kanban_Kanban__UserIcon__l6_CB","LaneHeader__ActiveAcutomation":"kanban_LaneHeader__ActiveAcutomation__0t81k","LaneHeader__Check":"kanban_LaneHeader__Check__mRHTH","LaneHeader__Link":"kanban_LaneHeader__Link___6mIC","LaneHeader__Alignment":"kanban_LaneHeader__Alignment__uHmGd","kanbantbsearch":"kanban_kanbantbsearch__iOw_t","NamePrefix__Circle":"kanban_NamePrefix__Circle__6Vdju","NameImage":"kanban_NameImage__i_fYo","BestMatch":"kanban_BestMatch__smbZW","AddNames":"kanban_AddNames__t1kMw","AddNames__Savebutton":"kanban_AddNames__Savebutton__BBVvD","AddNames__StageName":"kanban_AddNames__StageName__oUFww","AddNames__MemberName":"kanban_AddNames__MemberName__Ztr6G","AddNames__Close":"kanban_AddNames__Close__6vOqw","AddNames__Head":"kanban_AddNames__Head__oUG6Y","Sourced__Content":"kanban_Sourced__Content__xAXEN","SourceTab":"kanban_SourceTab__nBI_7","Kanban__Flex":"kanban_Kanban__Flex__d7FMg","SortingDropdown":"kanban_SortingDropdown__QGWBj","NewJob__BacktoJobs":"kanban_NewJob__BacktoJobs__7OO4I","Kanban__BlindHiringIcon":"kanban_Kanban__BlindHiringIcon__WKnRk","Kanban__StatusAlignment":"kanban_Kanban__StatusAlignment__3Jp6E","Kanbantop":"kanban_Kanbantop__oBaJg","KanbantopAuto":"kanban_KanbantopAuto__8AZ0Y","KanbanBoardTabs":"kanban_KanbanBoardTabs__5rwpP","KanbanBoardTabsWidth":"kanban_KanbanBoardTabsWidth__YywJS","CardBox__BestMatchScore":"kanban_CardBox__BestMatchScore___LkS9","CardBox__BestMatchScore__Icon":"kanban_CardBox__BestMatchScore__Icon__WgCiN","CardBox__BestMatchScore__Data":"kanban_CardBox__BestMatchScore__Data__S_hA0","CardBox__TechIcon":"kanban_CardBox__TechIcon__jvpJi","SmallBox":"kanban_SmallBox__Mqblk","ScoreBoxHeading":"kanban_ScoreBoxHeading__aDiKj","ScoreBox__Jobs":"kanban_ScoreBox__Jobs__k7_W_","ScoreBox__Skills":"kanban_ScoreBox__Skills__IgQuL","ScoreBox__Jobs_Title":"kanban_ScoreBox__Jobs_Title__U3tRb","ScoreBox__Skills_Title":"kanban_ScoreBox__Skills_Title__skgX5","ScoreBox__Jobs_Name":"kanban_ScoreBox__Jobs_Name__aV7_o","ScoreBox__Skills_Name":"kanban_ScoreBox__Skills_Name__fmiD_","ScoreBox__Jobs_Score":"kanban_ScoreBox__Jobs_Score__tppGD","ScoreBox__Skills_Score":"kanban_ScoreBox__Skills_Score__64FBG","ScoreBox__SkillDetails":"kanban_ScoreBox__SkillDetails__Hvqss","ScoreBox__SkillDetail":"kanban_ScoreBox__SkillDetail__3CZt9"};

/***/ }),

/***/ 21181:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 2544:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 25935:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 59028:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 10902:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 71550:
/***/ (function() {

/* (ignored) */

/***/ })

}]);